import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  bigint: { input: any; output: any; }
  bytea: { input: any; output: any; }
  citext: { input: any; output: any; }
  date: { input: any; output: any; }
  float8: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timestamp: { input: any; output: any; }
  timestamptz: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** AI configuration settings per company */
export type AiConfig_ = {
  __typename?: 'AIConfig';
  /** An object relationship */
  company: Company_;
  companyId: Scalars['uuid']['output'];
  preferredLanguage: Scalars['String']['output'];
  toneOfVoice?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "AIConfig" */
export type AiConfig_Aggregate_ = {
  __typename?: 'AIConfig_aggregate';
  aggregate?: Maybe<AiConfig_Aggregate_Fields_>;
  nodes: Array<AiConfig_>;
};

/** aggregate fields of "AIConfig" */
export type AiConfig_Aggregate_Fields_ = {
  __typename?: 'AIConfig_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AiConfig_Max_Fields_>;
  min?: Maybe<AiConfig_Min_Fields_>;
};


/** aggregate fields of "AIConfig" */
export type AiConfig_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<AiConfig_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "AIConfig". All fields are combined with a logical 'AND'. */
export type AiConfig_Bool_Exp_ = {
  _and?: InputMaybe<Array<AiConfig_Bool_Exp_>>;
  _not?: InputMaybe<AiConfig_Bool_Exp_>;
  _or?: InputMaybe<Array<AiConfig_Bool_Exp_>>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  preferredLanguage?: InputMaybe<String_Comparison_Exp_>;
  toneOfVoice?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "AIConfig" */
export enum AiConfig_Constraint_ {
  /** unique or primary key constraint on columns "companyId" */
  AiConfigPkey_ = 'AIConfig_pkey'
}

/** input type for inserting data into table "AIConfig" */
export type AiConfig_Insert_Input_ = {
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  toneOfVoice?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AiConfig_Max_Fields_ = {
  __typename?: 'AIConfig_max_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  toneOfVoice?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AiConfig_Min_Fields_ = {
  __typename?: 'AIConfig_min_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  toneOfVoice?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "AIConfig" */
export type AiConfig_Mutation_Response_ = {
  __typename?: 'AIConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AiConfig_>;
};

/** input type for inserting object relation for remote table "AIConfig" */
export type AiConfig_Obj_Rel_Insert_Input_ = {
  data: AiConfig_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<AiConfig_On_Conflict_>;
};

/** on_conflict condition type for table "AIConfig" */
export type AiConfig_On_Conflict_ = {
  constraint: AiConfig_Constraint_;
  update_columns?: Array<AiConfig_Update_Column_>;
  where?: InputMaybe<AiConfig_Bool_Exp_>;
};

/** Ordering options when selecting data from "AIConfig". */
export type AiConfig_Order_By_ = {
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  preferredLanguage?: InputMaybe<Order_By_>;
  toneOfVoice?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: AIConfig */
export type AiConfig_Pk_Columns_Input_ = {
  companyId: Scalars['uuid']['input'];
};

/** select columns of table "AIConfig" */
export enum AiConfig_Select_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  PreferredLanguage_ = 'preferredLanguage',
  /** column name */
  ToneOfVoice_ = 'toneOfVoice'
}

/** input type for updating data in table "AIConfig" */
export type AiConfig_Set_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  toneOfVoice?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "AIConfig" */
export type AiConfig_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: AiConfig_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type AiConfig_Stream_Cursor_Value_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  toneOfVoice?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "AIConfig" */
export enum AiConfig_Update_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  PreferredLanguage_ = 'preferredLanguage',
  /** column name */
  ToneOfVoice_ = 'toneOfVoice'
}

export type AiConfig_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AiConfig_Set_Input_>;
  /** filter the rows which have to be updated */
  where: AiConfig_Bool_Exp_;
};

/** columns and relationships of "esrs.ActionQuestion" */
export type ActionQuestion_ = {
  __typename?: 'ActionQuestion';
  /** An object relationship */
  choiceSet?: Maybe<ChoiceSet_>;
  choiceSetRef?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  firstLevel?: Maybe<Scalars['String']['output']>;
  globalOrder?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  group?: Maybe<ActionQuestionGroup_>;
  groupRef?: Maybe<Scalars['String']['output']>;
  isAR: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  questionType: QuestionType_Enum_;
  reference: Scalars['String']['output'];
  secondLevel?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  standard: EsrsStandard_;
  standardRef: Scalars['String']['output'];
  title: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** columns and relationships of "esrs.ActionQuestionGroup" */
export type ActionQuestionGroup_ = {
  __typename?: 'ActionQuestionGroup';
  /** An array relationship */
  actionQuestions: Array<ActionQuestion_>;
  /** An aggregate relationship */
  actionQuestions_aggregate: ActionQuestion_Aggregate_;
  reference: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


/** columns and relationships of "esrs.ActionQuestionGroup" */
export type ActionQuestionGroupActionQuestionsArgs_ = {
  distinct_on?: InputMaybe<Array<ActionQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestion_Order_By_>>;
  where?: InputMaybe<ActionQuestion_Bool_Exp_>;
};


/** columns and relationships of "esrs.ActionQuestionGroup" */
export type ActionQuestionGroupActionQuestions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActionQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestion_Order_By_>>;
  where?: InputMaybe<ActionQuestion_Bool_Exp_>;
};

/** aggregated selection of "esrs.ActionQuestionGroup" */
export type ActionQuestionGroup_Aggregate_ = {
  __typename?: 'ActionQuestionGroup_aggregate';
  aggregate?: Maybe<ActionQuestionGroup_Aggregate_Fields_>;
  nodes: Array<ActionQuestionGroup_>;
};

/** aggregate fields of "esrs.ActionQuestionGroup" */
export type ActionQuestionGroup_Aggregate_Fields_ = {
  __typename?: 'ActionQuestionGroup_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ActionQuestionGroup_Max_Fields_>;
  min?: Maybe<ActionQuestionGroup_Min_Fields_>;
};


/** aggregate fields of "esrs.ActionQuestionGroup" */
export type ActionQuestionGroup_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<ActionQuestionGroup_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "esrs.ActionQuestionGroup". All fields are combined with a logical 'AND'. */
export type ActionQuestionGroup_Bool_Exp_ = {
  _and?: InputMaybe<Array<ActionQuestionGroup_Bool_Exp_>>;
  _not?: InputMaybe<ActionQuestionGroup_Bool_Exp_>;
  _or?: InputMaybe<Array<ActionQuestionGroup_Bool_Exp_>>;
  actionQuestions?: InputMaybe<ActionQuestion_Bool_Exp_>;
  actionQuestions_aggregate?: InputMaybe<ActionQuestion_Aggregate_Bool_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.ActionQuestionGroup" */
export enum ActionQuestionGroup_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  ActionQuestionGroupPkey_ = 'ActionQuestionGroup_pkey'
}

/** input type for inserting data into table "esrs.ActionQuestionGroup" */
export type ActionQuestionGroup_Insert_Input_ = {
  actionQuestions?: InputMaybe<ActionQuestion_Arr_Rel_Insert_Input_>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ActionQuestionGroup_Max_Fields_ = {
  __typename?: 'ActionQuestionGroup_max_fields';
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ActionQuestionGroup_Min_Fields_ = {
  __typename?: 'ActionQuestionGroup_min_fields';
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "esrs.ActionQuestionGroup" */
export type ActionQuestionGroup_Mutation_Response_ = {
  __typename?: 'ActionQuestionGroup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ActionQuestionGroup_>;
};

/** input type for inserting object relation for remote table "esrs.ActionQuestionGroup" */
export type ActionQuestionGroup_Obj_Rel_Insert_Input_ = {
  data: ActionQuestionGroup_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<ActionQuestionGroup_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.ActionQuestionGroup" */
export type ActionQuestionGroup_On_Conflict_ = {
  constraint: ActionQuestionGroup_Constraint_;
  update_columns?: Array<ActionQuestionGroup_Update_Column_>;
  where?: InputMaybe<ActionQuestionGroup_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.ActionQuestionGroup". */
export type ActionQuestionGroup_Order_By_ = {
  actionQuestions_aggregate?: InputMaybe<ActionQuestion_Aggregate_Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.ActionQuestionGroup */
export type ActionQuestionGroup_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.ActionQuestionGroup" */
export enum ActionQuestionGroup_Select_Column_ {
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

/** input type for updating data in table "esrs.ActionQuestionGroup" */
export type ActionQuestionGroup_Set_Input_ = {
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ActionQuestionGroup" */
export type ActionQuestionGroup_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: ActionQuestionGroup_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type ActionQuestionGroup_Stream_Cursor_Value_Input_ = {
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.ActionQuestionGroup" */
export enum ActionQuestionGroup_Update_Column_ {
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

export type ActionQuestionGroup_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActionQuestionGroup_Set_Input_>;
  /** filter the rows which have to be updated */
  where: ActionQuestionGroup_Bool_Exp_;
};

/** aggregated selection of "esrs.ActionQuestion" */
export type ActionQuestion_Aggregate_ = {
  __typename?: 'ActionQuestion_aggregate';
  aggregate?: Maybe<ActionQuestion_Aggregate_Fields_>;
  nodes: Array<ActionQuestion_>;
};

export type ActionQuestion_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<ActionQuestion_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<ActionQuestion_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<ActionQuestion_Aggregate_Bool_Exp_Count_>;
};

export type ActionQuestion_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: ActionQuestion_Select_Column_ActionQuestion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ActionQuestion_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type ActionQuestion_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: ActionQuestion_Select_Column_ActionQuestion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ActionQuestion_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type ActionQuestion_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<ActionQuestion_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ActionQuestion_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.ActionQuestion" */
export type ActionQuestion_Aggregate_Fields_ = {
  __typename?: 'ActionQuestion_aggregate_fields';
  avg?: Maybe<ActionQuestion_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<ActionQuestion_Max_Fields_>;
  min?: Maybe<ActionQuestion_Min_Fields_>;
  stddev?: Maybe<ActionQuestion_Stddev_Fields_>;
  stddev_pop?: Maybe<ActionQuestion_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<ActionQuestion_Stddev_Samp_Fields_>;
  sum?: Maybe<ActionQuestion_Sum_Fields_>;
  var_pop?: Maybe<ActionQuestion_Var_Pop_Fields_>;
  var_samp?: Maybe<ActionQuestion_Var_Samp_Fields_>;
  variance?: Maybe<ActionQuestion_Variance_Fields_>;
};


/** aggregate fields of "esrs.ActionQuestion" */
export type ActionQuestion_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<ActionQuestion_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.ActionQuestion" */
export type ActionQuestion_Aggregate_Order_By_ = {
  avg?: InputMaybe<ActionQuestion_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<ActionQuestion_Max_Order_By_>;
  min?: InputMaybe<ActionQuestion_Min_Order_By_>;
  stddev?: InputMaybe<ActionQuestion_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<ActionQuestion_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<ActionQuestion_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<ActionQuestion_Sum_Order_By_>;
  var_pop?: InputMaybe<ActionQuestion_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<ActionQuestion_Var_Samp_Order_By_>;
  variance?: InputMaybe<ActionQuestion_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.ActionQuestion" */
export type ActionQuestion_Arr_Rel_Insert_Input_ = {
  data: Array<ActionQuestion_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<ActionQuestion_On_Conflict_>;
};

/** aggregate avg on columns */
export type ActionQuestion_Avg_Fields_ = {
  __typename?: 'ActionQuestion_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.ActionQuestion" */
export type ActionQuestion_Avg_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.ActionQuestion". All fields are combined with a logical 'AND'. */
export type ActionQuestion_Bool_Exp_ = {
  _and?: InputMaybe<Array<ActionQuestion_Bool_Exp_>>;
  _not?: InputMaybe<ActionQuestion_Bool_Exp_>;
  _or?: InputMaybe<Array<ActionQuestion_Bool_Exp_>>;
  choiceSet?: InputMaybe<ChoiceSet_Bool_Exp_>;
  choiceSetRef?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  description?: InputMaybe<String_Comparison_Exp_>;
  firstLevel?: InputMaybe<String_Comparison_Exp_>;
  globalOrder?: InputMaybe<String_Comparison_Exp_>;
  group?: InputMaybe<ActionQuestionGroup_Bool_Exp_>;
  groupRef?: InputMaybe<String_Comparison_Exp_>;
  isAR?: InputMaybe<Boolean_Comparison_Exp_>;
  order?: InputMaybe<Int_Comparison_Exp_>;
  questionType?: InputMaybe<QuestionType_Enum_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  secondLevel?: InputMaybe<String_Comparison_Exp_>;
  standard?: InputMaybe<EsrsStandard_Bool_Exp_>;
  standardRef?: InputMaybe<String_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
  unit?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.ActionQuestion" */
export enum ActionQuestion_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  ActionQuestionPkey_ = 'ActionQuestion_pkey'
}

/** input type for incrementing numeric columns in table "esrs.ActionQuestion" */
export type ActionQuestion_Inc_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.ActionQuestion" */
export type ActionQuestion_Insert_Input_ = {
  choiceSet?: InputMaybe<ChoiceSet_Obj_Rel_Insert_Input_>;
  choiceSetRef?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  firstLevel?: InputMaybe<Scalars['String']['input']>;
  globalOrder?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<ActionQuestionGroup_Obj_Rel_Insert_Input_>;
  groupRef?: InputMaybe<Scalars['String']['input']>;
  isAR?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  questionType?: InputMaybe<QuestionType_Enum_>;
  reference?: InputMaybe<Scalars['String']['input']>;
  secondLevel?: InputMaybe<Scalars['String']['input']>;
  standard?: InputMaybe<EsrsStandard_Obj_Rel_Insert_Input_>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ActionQuestion_Max_Fields_ = {
  __typename?: 'ActionQuestion_max_fields';
  choiceSetRef?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  firstLevel?: Maybe<Scalars['String']['output']>;
  globalOrder?: Maybe<Scalars['String']['output']>;
  groupRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  secondLevel?: Maybe<Scalars['String']['output']>;
  standardRef?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.ActionQuestion" */
export type ActionQuestion_Max_Order_By_ = {
  choiceSetRef?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  firstLevel?: InputMaybe<Order_By_>;
  globalOrder?: InputMaybe<Order_By_>;
  groupRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  secondLevel?: InputMaybe<Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  unit?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type ActionQuestion_Min_Fields_ = {
  __typename?: 'ActionQuestion_min_fields';
  choiceSetRef?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  firstLevel?: Maybe<Scalars['String']['output']>;
  globalOrder?: Maybe<Scalars['String']['output']>;
  groupRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  secondLevel?: Maybe<Scalars['String']['output']>;
  standardRef?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.ActionQuestion" */
export type ActionQuestion_Min_Order_By_ = {
  choiceSetRef?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  firstLevel?: InputMaybe<Order_By_>;
  globalOrder?: InputMaybe<Order_By_>;
  groupRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  secondLevel?: InputMaybe<Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  unit?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.ActionQuestion" */
export type ActionQuestion_Mutation_Response_ = {
  __typename?: 'ActionQuestion_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ActionQuestion_>;
};

/** on_conflict condition type for table "esrs.ActionQuestion" */
export type ActionQuestion_On_Conflict_ = {
  constraint: ActionQuestion_Constraint_;
  update_columns?: Array<ActionQuestion_Update_Column_>;
  where?: InputMaybe<ActionQuestion_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.ActionQuestion". */
export type ActionQuestion_Order_By_ = {
  choiceSet?: InputMaybe<ChoiceSet_Order_By_>;
  choiceSetRef?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  firstLevel?: InputMaybe<Order_By_>;
  globalOrder?: InputMaybe<Order_By_>;
  group?: InputMaybe<ActionQuestionGroup_Order_By_>;
  groupRef?: InputMaybe<Order_By_>;
  isAR?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  questionType?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  secondLevel?: InputMaybe<Order_By_>;
  standard?: InputMaybe<EsrsStandard_Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  unit?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.ActionQuestion */
export type ActionQuestion_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.ActionQuestion" */
export enum ActionQuestion_Select_Column_ {
  /** column name */
  ChoiceSetRef_ = 'choiceSetRef',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  FirstLevel_ = 'firstLevel',
  /** column name */
  GlobalOrder_ = 'globalOrder',
  /** column name */
  GroupRef_ = 'groupRef',
  /** column name */
  IsAr_ = 'isAR',
  /** column name */
  Order_ = 'order',
  /** column name */
  QuestionType_ = 'questionType',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  SecondLevel_ = 'secondLevel',
  /** column name */
  StandardRef_ = 'standardRef',
  /** column name */
  Title_ = 'title',
  /** column name */
  Unit_ = 'unit',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "ActionQuestion_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.ActionQuestion" */
export enum ActionQuestion_Select_Column_ActionQuestion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsAr_ = 'isAR'
}

/** select "ActionQuestion_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.ActionQuestion" */
export enum ActionQuestion_Select_Column_ActionQuestion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsAr_ = 'isAR'
}

/** input type for updating data in table "esrs.ActionQuestion" */
export type ActionQuestion_Set_Input_ = {
  choiceSetRef?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  firstLevel?: InputMaybe<Scalars['String']['input']>;
  globalOrder?: InputMaybe<Scalars['String']['input']>;
  groupRef?: InputMaybe<Scalars['String']['input']>;
  isAR?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  questionType?: InputMaybe<QuestionType_Enum_>;
  reference?: InputMaybe<Scalars['String']['input']>;
  secondLevel?: InputMaybe<Scalars['String']['input']>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type ActionQuestion_Stddev_Fields_ = {
  __typename?: 'ActionQuestion_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.ActionQuestion" */
export type ActionQuestion_Stddev_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type ActionQuestion_Stddev_Pop_Fields_ = {
  __typename?: 'ActionQuestion_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.ActionQuestion" */
export type ActionQuestion_Stddev_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type ActionQuestion_Stddev_Samp_Fields_ = {
  __typename?: 'ActionQuestion_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.ActionQuestion" */
export type ActionQuestion_Stddev_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "ActionQuestion" */
export type ActionQuestion_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: ActionQuestion_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type ActionQuestion_Stream_Cursor_Value_Input_ = {
  choiceSetRef?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  firstLevel?: InputMaybe<Scalars['String']['input']>;
  globalOrder?: InputMaybe<Scalars['String']['input']>;
  groupRef?: InputMaybe<Scalars['String']['input']>;
  isAR?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  questionType?: InputMaybe<QuestionType_Enum_>;
  reference?: InputMaybe<Scalars['String']['input']>;
  secondLevel?: InputMaybe<Scalars['String']['input']>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type ActionQuestion_Sum_Fields_ = {
  __typename?: 'ActionQuestion_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.ActionQuestion" */
export type ActionQuestion_Sum_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.ActionQuestion" */
export enum ActionQuestion_Update_Column_ {
  /** column name */
  ChoiceSetRef_ = 'choiceSetRef',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  FirstLevel_ = 'firstLevel',
  /** column name */
  GlobalOrder_ = 'globalOrder',
  /** column name */
  GroupRef_ = 'groupRef',
  /** column name */
  IsAr_ = 'isAR',
  /** column name */
  Order_ = 'order',
  /** column name */
  QuestionType_ = 'questionType',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  SecondLevel_ = 'secondLevel',
  /** column name */
  StandardRef_ = 'standardRef',
  /** column name */
  Title_ = 'title',
  /** column name */
  Unit_ = 'unit',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type ActionQuestion_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ActionQuestion_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActionQuestion_Set_Input_>;
  /** filter the rows which have to be updated */
  where: ActionQuestion_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type ActionQuestion_Var_Pop_Fields_ = {
  __typename?: 'ActionQuestion_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.ActionQuestion" */
export type ActionQuestion_Var_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type ActionQuestion_Var_Samp_Fields_ = {
  __typename?: 'ActionQuestion_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.ActionQuestion" */
export type ActionQuestion_Var_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type ActionQuestion_Variance_Fields_ = {
  __typename?: 'ActionQuestion_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.ActionQuestion" */
export type ActionQuestion_Variance_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** columns and relationships of "Activity" */
export type Activity_ = {
  __typename?: 'Activity';
  /** An array relationship */
  activityNaceCodes: Array<ActivityNaceCode_>;
  /** An aggregate relationship */
  activityNaceCodes_aggregate: ActivityNaceCode_Aggregate_;
  /** An array relationship */
  activityQuestionSets: Array<ActivityQuestionSet_>;
  /** An aggregate relationship */
  activityQuestionSets_aggregate: ActivityQuestionSet_Aggregate_;
  /** An array relationship */
  activityReports: Array<ActivityReport_>;
  /** An aggregate relationship */
  activityReports_aggregate: ActivityReport_Aggregate_;
  additionalGuidance?: Maybe<Scalars['String']['output']>;
  celsiaComment?: Maybe<Scalars['String']['output']>;
  currentQuestionSetVersion?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  currentVersion?: Maybe<ActivityVersion_>;
  description: Scalars['String']['output'];
  descriptionSource?: Maybe<Scalars['String']['output']>;
  guidanceSource?: Maybe<Scalars['String']['output']>;
  isHidden: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  sector: Sector_;
  sectorRef: Scalars['String']['output'];
  /** Deprecated: This field has been moved to ActivityVersion */
  tagExpression: Scalars['String']['output'];
  /** An array relationship */
  versions: Array<ActivityVersion_>;
  /** An aggregate relationship */
  versions_aggregate: ActivityVersion_Aggregate_;
};


/** columns and relationships of "Activity" */
export type ActivityActivityNaceCodesArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityNaceCode_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityNaceCode_Order_By_>>;
  where?: InputMaybe<ActivityNaceCode_Bool_Exp_>;
};


/** columns and relationships of "Activity" */
export type ActivityActivityNaceCodes_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityNaceCode_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityNaceCode_Order_By_>>;
  where?: InputMaybe<ActivityNaceCode_Bool_Exp_>;
};


/** columns and relationships of "Activity" */
export type ActivityActivityQuestionSetsArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityQuestionSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityQuestionSet_Order_By_>>;
  where?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
};


/** columns and relationships of "Activity" */
export type ActivityActivityQuestionSets_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityQuestionSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityQuestionSet_Order_By_>>;
  where?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
};


/** columns and relationships of "Activity" */
export type ActivityActivityReportsArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityReport_Order_By_>>;
  where?: InputMaybe<ActivityReport_Bool_Exp_>;
};


/** columns and relationships of "Activity" */
export type ActivityActivityReports_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityReport_Order_By_>>;
  where?: InputMaybe<ActivityReport_Bool_Exp_>;
};


/** columns and relationships of "Activity" */
export type ActivityVersionsArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityVersion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityVersion_Order_By_>>;
  where?: InputMaybe<ActivityVersion_Bool_Exp_>;
};


/** columns and relationships of "Activity" */
export type ActivityVersions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityVersion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityVersion_Order_By_>>;
  where?: InputMaybe<ActivityVersion_Bool_Exp_>;
};

/** columns and relationships of "ActivityNaceCode" */
export type ActivityNaceCode_ = {
  __typename?: 'ActivityNaceCode';
  /** An object relationship */
  activity: Activity_;
  activityRef: Scalars['String']['output'];
  code: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
};

/** aggregated selection of "ActivityNaceCode" */
export type ActivityNaceCode_Aggregate_ = {
  __typename?: 'ActivityNaceCode_aggregate';
  aggregate?: Maybe<ActivityNaceCode_Aggregate_Fields_>;
  nodes: Array<ActivityNaceCode_>;
};

export type ActivityNaceCode_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<ActivityNaceCode_Aggregate_Bool_Exp_Count_>;
};

export type ActivityNaceCode_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<ActivityNaceCode_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ActivityNaceCode_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "ActivityNaceCode" */
export type ActivityNaceCode_Aggregate_Fields_ = {
  __typename?: 'ActivityNaceCode_aggregate_fields';
  avg?: Maybe<ActivityNaceCode_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<ActivityNaceCode_Max_Fields_>;
  min?: Maybe<ActivityNaceCode_Min_Fields_>;
  stddev?: Maybe<ActivityNaceCode_Stddev_Fields_>;
  stddev_pop?: Maybe<ActivityNaceCode_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<ActivityNaceCode_Stddev_Samp_Fields_>;
  sum?: Maybe<ActivityNaceCode_Sum_Fields_>;
  var_pop?: Maybe<ActivityNaceCode_Var_Pop_Fields_>;
  var_samp?: Maybe<ActivityNaceCode_Var_Samp_Fields_>;
  variance?: Maybe<ActivityNaceCode_Variance_Fields_>;
};


/** aggregate fields of "ActivityNaceCode" */
export type ActivityNaceCode_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<ActivityNaceCode_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ActivityNaceCode" */
export type ActivityNaceCode_Aggregate_Order_By_ = {
  avg?: InputMaybe<ActivityNaceCode_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<ActivityNaceCode_Max_Order_By_>;
  min?: InputMaybe<ActivityNaceCode_Min_Order_By_>;
  stddev?: InputMaybe<ActivityNaceCode_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<ActivityNaceCode_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<ActivityNaceCode_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<ActivityNaceCode_Sum_Order_By_>;
  var_pop?: InputMaybe<ActivityNaceCode_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<ActivityNaceCode_Var_Samp_Order_By_>;
  variance?: InputMaybe<ActivityNaceCode_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "ActivityNaceCode" */
export type ActivityNaceCode_Arr_Rel_Insert_Input_ = {
  data: Array<ActivityNaceCode_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<ActivityNaceCode_On_Conflict_>;
};

/** aggregate avg on columns */
export type ActivityNaceCode_Avg_Fields_ = {
  __typename?: 'ActivityNaceCode_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "ActivityNaceCode" */
export type ActivityNaceCode_Avg_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "ActivityNaceCode". All fields are combined with a logical 'AND'. */
export type ActivityNaceCode_Bool_Exp_ = {
  _and?: InputMaybe<Array<ActivityNaceCode_Bool_Exp_>>;
  _not?: InputMaybe<ActivityNaceCode_Bool_Exp_>;
  _or?: InputMaybe<Array<ActivityNaceCode_Bool_Exp_>>;
  activity?: InputMaybe<Activity_Bool_Exp_>;
  activityRef?: InputMaybe<String_Comparison_Exp_>;
  code?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Bigint_Comparison_Exp_>;
};

/** unique or primary key constraints on table "ActivityNaceCode" */
export enum ActivityNaceCode_Constraint_ {
  /** unique or primary key constraint on columns "code", "activityRef" */
  NaceCodesActivityRefCode_7039065dUniq_ = 'naceCodes_activityRef_code_7039065d_uniq',
  /** unique or primary key constraint on columns "id" */
  NaceCodesPkey_ = 'naceCodes_pkey'
}

/** input type for incrementing numeric columns in table "ActivityNaceCode" */
export type ActivityNaceCode_Inc_Input_ = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "ActivityNaceCode" */
export type ActivityNaceCode_Insert_Input_ = {
  activity?: InputMaybe<Activity_Obj_Rel_Insert_Input_>;
  activityRef?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate max on columns */
export type ActivityNaceCode_Max_Fields_ = {
  __typename?: 'ActivityNaceCode_max_fields';
  activityRef?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by max() on columns of table "ActivityNaceCode" */
export type ActivityNaceCode_Max_Order_By_ = {
  activityRef?: InputMaybe<Order_By_>;
  code?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type ActivityNaceCode_Min_Fields_ = {
  __typename?: 'ActivityNaceCode_min_fields';
  activityRef?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by min() on columns of table "ActivityNaceCode" */
export type ActivityNaceCode_Min_Order_By_ = {
  activityRef?: InputMaybe<Order_By_>;
  code?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "ActivityNaceCode" */
export type ActivityNaceCode_Mutation_Response_ = {
  __typename?: 'ActivityNaceCode_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ActivityNaceCode_>;
};

/** on_conflict condition type for table "ActivityNaceCode" */
export type ActivityNaceCode_On_Conflict_ = {
  constraint: ActivityNaceCode_Constraint_;
  update_columns?: Array<ActivityNaceCode_Update_Column_>;
  where?: InputMaybe<ActivityNaceCode_Bool_Exp_>;
};

/** Ordering options when selecting data from "ActivityNaceCode". */
export type ActivityNaceCode_Order_By_ = {
  activity?: InputMaybe<Activity_Order_By_>;
  activityRef?: InputMaybe<Order_By_>;
  code?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: ActivityNaceCode */
export type ActivityNaceCode_Pk_Columns_Input_ = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "ActivityNaceCode" */
export enum ActivityNaceCode_Select_Column_ {
  /** column name */
  ActivityRef_ = 'activityRef',
  /** column name */
  Code_ = 'code',
  /** column name */
  Id_ = 'id'
}

/** input type for updating data in table "ActivityNaceCode" */
export type ActivityNaceCode_Set_Input_ = {
  activityRef?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate stddev on columns */
export type ActivityNaceCode_Stddev_Fields_ = {
  __typename?: 'ActivityNaceCode_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "ActivityNaceCode" */
export type ActivityNaceCode_Stddev_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type ActivityNaceCode_Stddev_Pop_Fields_ = {
  __typename?: 'ActivityNaceCode_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "ActivityNaceCode" */
export type ActivityNaceCode_Stddev_Pop_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type ActivityNaceCode_Stddev_Samp_Fields_ = {
  __typename?: 'ActivityNaceCode_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "ActivityNaceCode" */
export type ActivityNaceCode_Stddev_Samp_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "ActivityNaceCode" */
export type ActivityNaceCode_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: ActivityNaceCode_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type ActivityNaceCode_Stream_Cursor_Value_Input_ = {
  activityRef?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** aggregate sum on columns */
export type ActivityNaceCode_Sum_Fields_ = {
  __typename?: 'ActivityNaceCode_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "ActivityNaceCode" */
export type ActivityNaceCode_Sum_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** update columns of table "ActivityNaceCode" */
export enum ActivityNaceCode_Update_Column_ {
  /** column name */
  ActivityRef_ = 'activityRef',
  /** column name */
  Code_ = 'code',
  /** column name */
  Id_ = 'id'
}

export type ActivityNaceCode_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ActivityNaceCode_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActivityNaceCode_Set_Input_>;
  /** filter the rows which have to be updated */
  where: ActivityNaceCode_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type ActivityNaceCode_Var_Pop_Fields_ = {
  __typename?: 'ActivityNaceCode_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "ActivityNaceCode" */
export type ActivityNaceCode_Var_Pop_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type ActivityNaceCode_Var_Samp_Fields_ = {
  __typename?: 'ActivityNaceCode_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "ActivityNaceCode" */
export type ActivityNaceCode_Var_Samp_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type ActivityNaceCode_Variance_Fields_ = {
  __typename?: 'ActivityNaceCode_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "ActivityNaceCode" */
export type ActivityNaceCode_Variance_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** columns and relationships of "ActivityQuestionSet" */
export type ActivityQuestionSet_ = {
  __typename?: 'ActivityQuestionSet';
  /** An object relationship */
  activity: Activity_;
  activityRef: Scalars['String']['output'];
  /** An object relationship */
  activityVersion: ActivityVersion_;
  id: Scalars['bigint']['output'];
  /** An object relationship */
  questionSet: QuestionSet_;
  questionSetRef: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

/** aggregated selection of "ActivityQuestionSet" */
export type ActivityQuestionSet_Aggregate_ = {
  __typename?: 'ActivityQuestionSet_aggregate';
  aggregate?: Maybe<ActivityQuestionSet_Aggregate_Fields_>;
  nodes: Array<ActivityQuestionSet_>;
};

export type ActivityQuestionSet_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<ActivityQuestionSet_Aggregate_Bool_Exp_Count_>;
};

export type ActivityQuestionSet_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<ActivityQuestionSet_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "ActivityQuestionSet" */
export type ActivityQuestionSet_Aggregate_Fields_ = {
  __typename?: 'ActivityQuestionSet_aggregate_fields';
  avg?: Maybe<ActivityQuestionSet_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<ActivityQuestionSet_Max_Fields_>;
  min?: Maybe<ActivityQuestionSet_Min_Fields_>;
  stddev?: Maybe<ActivityQuestionSet_Stddev_Fields_>;
  stddev_pop?: Maybe<ActivityQuestionSet_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<ActivityQuestionSet_Stddev_Samp_Fields_>;
  sum?: Maybe<ActivityQuestionSet_Sum_Fields_>;
  var_pop?: Maybe<ActivityQuestionSet_Var_Pop_Fields_>;
  var_samp?: Maybe<ActivityQuestionSet_Var_Samp_Fields_>;
  variance?: Maybe<ActivityQuestionSet_Variance_Fields_>;
};


/** aggregate fields of "ActivityQuestionSet" */
export type ActivityQuestionSet_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<ActivityQuestionSet_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ActivityQuestionSet" */
export type ActivityQuestionSet_Aggregate_Order_By_ = {
  avg?: InputMaybe<ActivityQuestionSet_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<ActivityQuestionSet_Max_Order_By_>;
  min?: InputMaybe<ActivityQuestionSet_Min_Order_By_>;
  stddev?: InputMaybe<ActivityQuestionSet_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<ActivityQuestionSet_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<ActivityQuestionSet_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<ActivityQuestionSet_Sum_Order_By_>;
  var_pop?: InputMaybe<ActivityQuestionSet_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<ActivityQuestionSet_Var_Samp_Order_By_>;
  variance?: InputMaybe<ActivityQuestionSet_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "ActivityQuestionSet" */
export type ActivityQuestionSet_Arr_Rel_Insert_Input_ = {
  data: Array<ActivityQuestionSet_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<ActivityQuestionSet_On_Conflict_>;
};

/** aggregate avg on columns */
export type ActivityQuestionSet_Avg_Fields_ = {
  __typename?: 'ActivityQuestionSet_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "ActivityQuestionSet" */
export type ActivityQuestionSet_Avg_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  version?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "ActivityQuestionSet". All fields are combined with a logical 'AND'. */
export type ActivityQuestionSet_Bool_Exp_ = {
  _and?: InputMaybe<Array<ActivityQuestionSet_Bool_Exp_>>;
  _not?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
  _or?: InputMaybe<Array<ActivityQuestionSet_Bool_Exp_>>;
  activity?: InputMaybe<Activity_Bool_Exp_>;
  activityRef?: InputMaybe<String_Comparison_Exp_>;
  activityVersion?: InputMaybe<ActivityVersion_Bool_Exp_>;
  id?: InputMaybe<Bigint_Comparison_Exp_>;
  questionSet?: InputMaybe<QuestionSet_Bool_Exp_>;
  questionSetRef?: InputMaybe<String_Comparison_Exp_>;
  version?: InputMaybe<Int_Comparison_Exp_>;
};

/** unique or primary key constraints on table "ActivityQuestionSet" */
export enum ActivityQuestionSet_Constraint_ {
  /** unique or primary key constraint on columns "activityRef", "questionSetRef", "version" */
  ActivityQuestionSetQuestionSetRefActivityRefVersionKey_ = 'ActivityQuestionSet_questionSetRef_activityRef_version_key',
  /** unique or primary key constraint on columns "activityRef", "questionSetRef", "version" */
  ActivityQuestionSetsPkey_ = 'activityQuestionSets_pkey'
}

/** input type for incrementing numeric columns in table "ActivityQuestionSet" */
export type ActivityQuestionSet_Inc_Input_ = {
  id?: InputMaybe<Scalars['bigint']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "ActivityQuestionSet" */
export type ActivityQuestionSet_Insert_Input_ = {
  activity?: InputMaybe<Activity_Obj_Rel_Insert_Input_>;
  activityRef?: InputMaybe<Scalars['String']['input']>;
  activityVersion?: InputMaybe<ActivityVersion_Obj_Rel_Insert_Input_>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  questionSet?: InputMaybe<QuestionSet_Obj_Rel_Insert_Input_>;
  questionSetRef?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type ActivityQuestionSet_Max_Fields_ = {
  __typename?: 'ActivityQuestionSet_max_fields';
  activityRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  questionSetRef?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "ActivityQuestionSet" */
export type ActivityQuestionSet_Max_Order_By_ = {
  activityRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  questionSetRef?: InputMaybe<Order_By_>;
  version?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type ActivityQuestionSet_Min_Fields_ = {
  __typename?: 'ActivityQuestionSet_min_fields';
  activityRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  questionSetRef?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "ActivityQuestionSet" */
export type ActivityQuestionSet_Min_Order_By_ = {
  activityRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  questionSetRef?: InputMaybe<Order_By_>;
  version?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "ActivityQuestionSet" */
export type ActivityQuestionSet_Mutation_Response_ = {
  __typename?: 'ActivityQuestionSet_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ActivityQuestionSet_>;
};

/** on_conflict condition type for table "ActivityQuestionSet" */
export type ActivityQuestionSet_On_Conflict_ = {
  constraint: ActivityQuestionSet_Constraint_;
  update_columns?: Array<ActivityQuestionSet_Update_Column_>;
  where?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
};

/** Ordering options when selecting data from "ActivityQuestionSet". */
export type ActivityQuestionSet_Order_By_ = {
  activity?: InputMaybe<Activity_Order_By_>;
  activityRef?: InputMaybe<Order_By_>;
  activityVersion?: InputMaybe<ActivityVersion_Order_By_>;
  id?: InputMaybe<Order_By_>;
  questionSet?: InputMaybe<QuestionSet_Order_By_>;
  questionSetRef?: InputMaybe<Order_By_>;
  version?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: ActivityQuestionSet */
export type ActivityQuestionSet_Pk_Columns_Input_ = {
  activityRef: Scalars['String']['input'];
  questionSetRef: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};

/** select columns of table "ActivityQuestionSet" */
export enum ActivityQuestionSet_Select_Column_ {
  /** column name */
  ActivityRef_ = 'activityRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  QuestionSetRef_ = 'questionSetRef',
  /** column name */
  Version_ = 'version'
}

/** input type for updating data in table "ActivityQuestionSet" */
export type ActivityQuestionSet_Set_Input_ = {
  activityRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  questionSetRef?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type ActivityQuestionSet_Stddev_Fields_ = {
  __typename?: 'ActivityQuestionSet_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "ActivityQuestionSet" */
export type ActivityQuestionSet_Stddev_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  version?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type ActivityQuestionSet_Stddev_Pop_Fields_ = {
  __typename?: 'ActivityQuestionSet_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "ActivityQuestionSet" */
export type ActivityQuestionSet_Stddev_Pop_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  version?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type ActivityQuestionSet_Stddev_Samp_Fields_ = {
  __typename?: 'ActivityQuestionSet_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "ActivityQuestionSet" */
export type ActivityQuestionSet_Stddev_Samp_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  version?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "ActivityQuestionSet" */
export type ActivityQuestionSet_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: ActivityQuestionSet_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type ActivityQuestionSet_Stream_Cursor_Value_Input_ = {
  activityRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  questionSetRef?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type ActivityQuestionSet_Sum_Fields_ = {
  __typename?: 'ActivityQuestionSet_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "ActivityQuestionSet" */
export type ActivityQuestionSet_Sum_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  version?: InputMaybe<Order_By_>;
};

/** update columns of table "ActivityQuestionSet" */
export enum ActivityQuestionSet_Update_Column_ {
  /** column name */
  ActivityRef_ = 'activityRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  QuestionSetRef_ = 'questionSetRef',
  /** column name */
  Version_ = 'version'
}

export type ActivityQuestionSet_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ActivityQuestionSet_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActivityQuestionSet_Set_Input_>;
  /** filter the rows which have to be updated */
  where: ActivityQuestionSet_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type ActivityQuestionSet_Var_Pop_Fields_ = {
  __typename?: 'ActivityQuestionSet_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "ActivityQuestionSet" */
export type ActivityQuestionSet_Var_Pop_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  version?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type ActivityQuestionSet_Var_Samp_Fields_ = {
  __typename?: 'ActivityQuestionSet_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "ActivityQuestionSet" */
export type ActivityQuestionSet_Var_Samp_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  version?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type ActivityQuestionSet_Variance_Fields_ = {
  __typename?: 'ActivityQuestionSet_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "ActivityQuestionSet" */
export type ActivityQuestionSet_Variance_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  version?: InputMaybe<Order_By_>;
};

/** columns and relationships of "ActivityReport" */
export type ActivityReport_ = {
  __typename?: 'ActivityReport';
  /** An object relationship */
  activity: Activity_;
  activityRef: Scalars['String']['output'];
  /** An object relationship */
  activityVersion: ActivityVersion_;
  activityVersionConfig?: Maybe<Scalars['jsonb']['output']>;
  activityVersionNumber: Scalars['Int']['output'];
  /** An array relationship */
  answers: Array<Answer_>;
  /** An aggregate relationship */
  answers_aggregate: Answer_Aggregate_;
  /** An object relationship */
  attachmentBox?: Maybe<AttachmentBox_>;
  /** An object relationship */
  bAssessment: BusinessUnitAssessment_;
  bAssessmentId: Scalars['uuid']['output'];
  /** An object relationship */
  cachedResult?: Maybe<CachedResult_>;
  cachedResultId?: Maybe<Scalars['uuid']['output']>;
  completedAt?: Maybe<Scalars['timestamptz']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  financials?: Maybe<Financials_>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  noteHistory?: Maybe<NoteHistory_>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "ActivityReport" */
export type ActivityReportActivityVersionConfigArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "ActivityReport" */
export type ActivityReportAnswersArgs_ = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By_>>;
  where?: InputMaybe<Answer_Bool_Exp_>;
};


/** columns and relationships of "ActivityReport" */
export type ActivityReportAnswers_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By_>>;
  where?: InputMaybe<Answer_Bool_Exp_>;
};

/** aggregated selection of "ActivityReport" */
export type ActivityReport_Aggregate_ = {
  __typename?: 'ActivityReport_aggregate';
  aggregate?: Maybe<ActivityReport_Aggregate_Fields_>;
  nodes: Array<ActivityReport_>;
};

export type ActivityReport_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<ActivityReport_Aggregate_Bool_Exp_Count_>;
};

export type ActivityReport_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<ActivityReport_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ActivityReport_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "ActivityReport" */
export type ActivityReport_Aggregate_Fields_ = {
  __typename?: 'ActivityReport_aggregate_fields';
  avg?: Maybe<ActivityReport_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<ActivityReport_Max_Fields_>;
  min?: Maybe<ActivityReport_Min_Fields_>;
  stddev?: Maybe<ActivityReport_Stddev_Fields_>;
  stddev_pop?: Maybe<ActivityReport_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<ActivityReport_Stddev_Samp_Fields_>;
  sum?: Maybe<ActivityReport_Sum_Fields_>;
  var_pop?: Maybe<ActivityReport_Var_Pop_Fields_>;
  var_samp?: Maybe<ActivityReport_Var_Samp_Fields_>;
  variance?: Maybe<ActivityReport_Variance_Fields_>;
};


/** aggregate fields of "ActivityReport" */
export type ActivityReport_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<ActivityReport_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ActivityReport" */
export type ActivityReport_Aggregate_Order_By_ = {
  avg?: InputMaybe<ActivityReport_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<ActivityReport_Max_Order_By_>;
  min?: InputMaybe<ActivityReport_Min_Order_By_>;
  stddev?: InputMaybe<ActivityReport_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<ActivityReport_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<ActivityReport_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<ActivityReport_Sum_Order_By_>;
  var_pop?: InputMaybe<ActivityReport_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<ActivityReport_Var_Samp_Order_By_>;
  variance?: InputMaybe<ActivityReport_Variance_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ActivityReport_Append_Input_ = {
  activityVersionConfig?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "ActivityReport" */
export type ActivityReport_Arr_Rel_Insert_Input_ = {
  data: Array<ActivityReport_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<ActivityReport_On_Conflict_>;
};

/** aggregate avg on columns */
export type ActivityReport_Avg_Fields_ = {
  __typename?: 'ActivityReport_avg_fields';
  activityVersionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "ActivityReport" */
export type ActivityReport_Avg_Order_By_ = {
  activityVersionNumber?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "ActivityReport". All fields are combined with a logical 'AND'. */
export type ActivityReport_Bool_Exp_ = {
  _and?: InputMaybe<Array<ActivityReport_Bool_Exp_>>;
  _not?: InputMaybe<ActivityReport_Bool_Exp_>;
  _or?: InputMaybe<Array<ActivityReport_Bool_Exp_>>;
  activity?: InputMaybe<Activity_Bool_Exp_>;
  activityRef?: InputMaybe<String_Comparison_Exp_>;
  activityVersion?: InputMaybe<ActivityVersion_Bool_Exp_>;
  activityVersionConfig?: InputMaybe<Jsonb_Comparison_Exp_>;
  activityVersionNumber?: InputMaybe<Int_Comparison_Exp_>;
  answers?: InputMaybe<Answer_Bool_Exp_>;
  answers_aggregate?: InputMaybe<Answer_Aggregate_Bool_Exp_>;
  attachmentBox?: InputMaybe<AttachmentBox_Bool_Exp_>;
  bAssessment?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
  bAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  cachedResult?: InputMaybe<CachedResult_Bool_Exp_>;
  cachedResultId?: InputMaybe<Uuid_Comparison_Exp_>;
  completedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  financials?: InputMaybe<Financials_Bool_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  noteHistory?: InputMaybe<NoteHistory_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "ActivityReport" */
export enum ActivityReport_Constraint_ {
  /** unique or primary key constraint on columns "bAssessmentId", "activityRef" */
  ActivityReportBAssessmentIdActivityRef_614b7372Uniq_ = 'ActivityReport_bAssessmentId_activityRef_614b7372_uniq',
  /** unique or primary key constraint on columns "id" */
  ActivityReportPkey_ = 'activityReport_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ActivityReport_Delete_At_Path_Input_ = {
  activityVersionConfig?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ActivityReport_Delete_Elem_Input_ = {
  activityVersionConfig?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ActivityReport_Delete_Key_Input_ = {
  activityVersionConfig?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "ActivityReport" */
export type ActivityReport_Inc_Input_ = {
  activityVersionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "ActivityReport" */
export type ActivityReport_Insert_Input_ = {
  activity?: InputMaybe<Activity_Obj_Rel_Insert_Input_>;
  activityRef?: InputMaybe<Scalars['String']['input']>;
  activityVersion?: InputMaybe<ActivityVersion_Obj_Rel_Insert_Input_>;
  activityVersionConfig?: InputMaybe<Scalars['jsonb']['input']>;
  activityVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  answers?: InputMaybe<Answer_Arr_Rel_Insert_Input_>;
  attachmentBox?: InputMaybe<AttachmentBox_Obj_Rel_Insert_Input_>;
  bAssessment?: InputMaybe<BusinessUnitAssessment_Obj_Rel_Insert_Input_>;
  bAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  cachedResult?: InputMaybe<CachedResult_Obj_Rel_Insert_Input_>;
  cachedResultId?: InputMaybe<Scalars['uuid']['input']>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  financials?: InputMaybe<Financials_Obj_Rel_Insert_Input_>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  noteHistory?: InputMaybe<NoteHistory_Obj_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ActivityReport_Max_Fields_ = {
  __typename?: 'ActivityReport_max_fields';
  activityRef?: Maybe<Scalars['String']['output']>;
  activityVersionNumber?: Maybe<Scalars['Int']['output']>;
  bAssessmentId?: Maybe<Scalars['uuid']['output']>;
  cachedResultId?: Maybe<Scalars['uuid']['output']>;
  completedAt?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "ActivityReport" */
export type ActivityReport_Max_Order_By_ = {
  activityRef?: InputMaybe<Order_By_>;
  activityVersionNumber?: InputMaybe<Order_By_>;
  bAssessmentId?: InputMaybe<Order_By_>;
  cachedResultId?: InputMaybe<Order_By_>;
  completedAt?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type ActivityReport_Min_Fields_ = {
  __typename?: 'ActivityReport_min_fields';
  activityRef?: Maybe<Scalars['String']['output']>;
  activityVersionNumber?: Maybe<Scalars['Int']['output']>;
  bAssessmentId?: Maybe<Scalars['uuid']['output']>;
  cachedResultId?: Maybe<Scalars['uuid']['output']>;
  completedAt?: Maybe<Scalars['timestamptz']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "ActivityReport" */
export type ActivityReport_Min_Order_By_ = {
  activityRef?: InputMaybe<Order_By_>;
  activityVersionNumber?: InputMaybe<Order_By_>;
  bAssessmentId?: InputMaybe<Order_By_>;
  cachedResultId?: InputMaybe<Order_By_>;
  completedAt?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "ActivityReport" */
export type ActivityReport_Mutation_Response_ = {
  __typename?: 'ActivityReport_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ActivityReport_>;
};

/** input type for inserting object relation for remote table "ActivityReport" */
export type ActivityReport_Obj_Rel_Insert_Input_ = {
  data: ActivityReport_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<ActivityReport_On_Conflict_>;
};

/** on_conflict condition type for table "ActivityReport" */
export type ActivityReport_On_Conflict_ = {
  constraint: ActivityReport_Constraint_;
  update_columns?: Array<ActivityReport_Update_Column_>;
  where?: InputMaybe<ActivityReport_Bool_Exp_>;
};

/** Ordering options when selecting data from "ActivityReport". */
export type ActivityReport_Order_By_ = {
  activity?: InputMaybe<Activity_Order_By_>;
  activityRef?: InputMaybe<Order_By_>;
  activityVersion?: InputMaybe<ActivityVersion_Order_By_>;
  activityVersionConfig?: InputMaybe<Order_By_>;
  activityVersionNumber?: InputMaybe<Order_By_>;
  answers_aggregate?: InputMaybe<Answer_Aggregate_Order_By_>;
  attachmentBox?: InputMaybe<AttachmentBox_Order_By_>;
  bAssessment?: InputMaybe<BusinessUnitAssessment_Order_By_>;
  bAssessmentId?: InputMaybe<Order_By_>;
  cachedResult?: InputMaybe<CachedResult_Order_By_>;
  cachedResultId?: InputMaybe<Order_By_>;
  completedAt?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  financials?: InputMaybe<Financials_Order_By_>;
  id?: InputMaybe<Order_By_>;
  noteHistory?: InputMaybe<NoteHistory_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: ActivityReport */
export type ActivityReport_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ActivityReport_Prepend_Input_ = {
  activityVersionConfig?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "ActivityReport" */
export enum ActivityReport_Select_Column_ {
  /** column name */
  ActivityRef_ = 'activityRef',
  /** column name */
  ActivityVersionConfig_ = 'activityVersionConfig',
  /** column name */
  ActivityVersionNumber_ = 'activityVersionNumber',
  /** column name */
  BAssessmentId_ = 'bAssessmentId',
  /** column name */
  CachedResultId_ = 'cachedResultId',
  /** column name */
  CompletedAt_ = 'completedAt',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "ActivityReport" */
export type ActivityReport_Set_Input_ = {
  activityRef?: InputMaybe<Scalars['String']['input']>;
  activityVersionConfig?: InputMaybe<Scalars['jsonb']['input']>;
  activityVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  bAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  cachedResultId?: InputMaybe<Scalars['uuid']['input']>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type ActivityReport_Stddev_Fields_ = {
  __typename?: 'ActivityReport_stddev_fields';
  activityVersionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "ActivityReport" */
export type ActivityReport_Stddev_Order_By_ = {
  activityVersionNumber?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type ActivityReport_Stddev_Pop_Fields_ = {
  __typename?: 'ActivityReport_stddev_pop_fields';
  activityVersionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "ActivityReport" */
export type ActivityReport_Stddev_Pop_Order_By_ = {
  activityVersionNumber?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type ActivityReport_Stddev_Samp_Fields_ = {
  __typename?: 'ActivityReport_stddev_samp_fields';
  activityVersionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "ActivityReport" */
export type ActivityReport_Stddev_Samp_Order_By_ = {
  activityVersionNumber?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "ActivityReport" */
export type ActivityReport_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: ActivityReport_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type ActivityReport_Stream_Cursor_Value_Input_ = {
  activityRef?: InputMaybe<Scalars['String']['input']>;
  activityVersionConfig?: InputMaybe<Scalars['jsonb']['input']>;
  activityVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  bAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  cachedResultId?: InputMaybe<Scalars['uuid']['input']>;
  completedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type ActivityReport_Sum_Fields_ = {
  __typename?: 'ActivityReport_sum_fields';
  activityVersionNumber?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "ActivityReport" */
export type ActivityReport_Sum_Order_By_ = {
  activityVersionNumber?: InputMaybe<Order_By_>;
};

/** update columns of table "ActivityReport" */
export enum ActivityReport_Update_Column_ {
  /** column name */
  ActivityRef_ = 'activityRef',
  /** column name */
  ActivityVersionConfig_ = 'activityVersionConfig',
  /** column name */
  ActivityVersionNumber_ = 'activityVersionNumber',
  /** column name */
  BAssessmentId_ = 'bAssessmentId',
  /** column name */
  CachedResultId_ = 'cachedResultId',
  /** column name */
  CompletedAt_ = 'completedAt',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type ActivityReport_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ActivityReport_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ActivityReport_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ActivityReport_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ActivityReport_Delete_Key_Input_>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ActivityReport_Inc_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ActivityReport_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActivityReport_Set_Input_>;
  /** filter the rows which have to be updated */
  where: ActivityReport_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type ActivityReport_Var_Pop_Fields_ = {
  __typename?: 'ActivityReport_var_pop_fields';
  activityVersionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "ActivityReport" */
export type ActivityReport_Var_Pop_Order_By_ = {
  activityVersionNumber?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type ActivityReport_Var_Samp_Fields_ = {
  __typename?: 'ActivityReport_var_samp_fields';
  activityVersionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "ActivityReport" */
export type ActivityReport_Var_Samp_Order_By_ = {
  activityVersionNumber?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type ActivityReport_Variance_Fields_ = {
  __typename?: 'ActivityReport_variance_fields';
  activityVersionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "ActivityReport" */
export type ActivityReport_Variance_Order_By_ = {
  activityVersionNumber?: InputMaybe<Order_By_>;
};

/** List of each version of the group of question sets an activity has */
export type ActivityVersion_ = {
  __typename?: 'ActivityVersion';
  /** An object relationship */
  activity: Activity_;
  /** An array relationship */
  activityQuestionSets: Array<ActivityQuestionSet_>;
  /** An aggregate relationship */
  activityQuestionSets_aggregate: ActivityQuestionSet_Aggregate_;
  activityRef: Scalars['String']['output'];
  changeDescription: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  tagExpression: Scalars['String']['output'];
  tagObjective?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  validFrom: Scalars['date']['output'];
  versionNumber: Scalars['Int']['output'];
};


/** List of each version of the group of question sets an activity has */
export type ActivityVersionActivityQuestionSetsArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityQuestionSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityQuestionSet_Order_By_>>;
  where?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
};


/** List of each version of the group of question sets an activity has */
export type ActivityVersionActivityQuestionSets_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityQuestionSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityQuestionSet_Order_By_>>;
  where?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
};

/** aggregated selection of "ActivityVersion" */
export type ActivityVersion_Aggregate_ = {
  __typename?: 'ActivityVersion_aggregate';
  aggregate?: Maybe<ActivityVersion_Aggregate_Fields_>;
  nodes: Array<ActivityVersion_>;
};

export type ActivityVersion_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<ActivityVersion_Aggregate_Bool_Exp_Count_>;
};

export type ActivityVersion_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<ActivityVersion_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ActivityVersion_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "ActivityVersion" */
export type ActivityVersion_Aggregate_Fields_ = {
  __typename?: 'ActivityVersion_aggregate_fields';
  avg?: Maybe<ActivityVersion_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<ActivityVersion_Max_Fields_>;
  min?: Maybe<ActivityVersion_Min_Fields_>;
  stddev?: Maybe<ActivityVersion_Stddev_Fields_>;
  stddev_pop?: Maybe<ActivityVersion_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<ActivityVersion_Stddev_Samp_Fields_>;
  sum?: Maybe<ActivityVersion_Sum_Fields_>;
  var_pop?: Maybe<ActivityVersion_Var_Pop_Fields_>;
  var_samp?: Maybe<ActivityVersion_Var_Samp_Fields_>;
  variance?: Maybe<ActivityVersion_Variance_Fields_>;
};


/** aggregate fields of "ActivityVersion" */
export type ActivityVersion_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<ActivityVersion_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ActivityVersion" */
export type ActivityVersion_Aggregate_Order_By_ = {
  avg?: InputMaybe<ActivityVersion_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<ActivityVersion_Max_Order_By_>;
  min?: InputMaybe<ActivityVersion_Min_Order_By_>;
  stddev?: InputMaybe<ActivityVersion_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<ActivityVersion_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<ActivityVersion_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<ActivityVersion_Sum_Order_By_>;
  var_pop?: InputMaybe<ActivityVersion_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<ActivityVersion_Var_Samp_Order_By_>;
  variance?: InputMaybe<ActivityVersion_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "ActivityVersion" */
export type ActivityVersion_Arr_Rel_Insert_Input_ = {
  data: Array<ActivityVersion_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<ActivityVersion_On_Conflict_>;
};

/** aggregate avg on columns */
export type ActivityVersion_Avg_Fields_ = {
  __typename?: 'ActivityVersion_avg_fields';
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "ActivityVersion" */
export type ActivityVersion_Avg_Order_By_ = {
  versionNumber?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "ActivityVersion". All fields are combined with a logical 'AND'. */
export type ActivityVersion_Bool_Exp_ = {
  _and?: InputMaybe<Array<ActivityVersion_Bool_Exp_>>;
  _not?: InputMaybe<ActivityVersion_Bool_Exp_>;
  _or?: InputMaybe<Array<ActivityVersion_Bool_Exp_>>;
  activity?: InputMaybe<Activity_Bool_Exp_>;
  activityQuestionSets?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
  activityQuestionSets_aggregate?: InputMaybe<ActivityQuestionSet_Aggregate_Bool_Exp_>;
  activityRef?: InputMaybe<String_Comparison_Exp_>;
  changeDescription?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  tagExpression?: InputMaybe<String_Comparison_Exp_>;
  tagObjective?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  validFrom?: InputMaybe<Date_Comparison_Exp_>;
  versionNumber?: InputMaybe<Int_Comparison_Exp_>;
};

/** unique or primary key constraints on table "ActivityVersion" */
export enum ActivityVersion_Constraint_ {
  /** unique or primary key constraint on columns "activityRef", "versionNumber" */
  ActivityVersionPkey_ = 'ActivityVersion_pkey'
}

/** input type for incrementing numeric columns in table "ActivityVersion" */
export type ActivityVersion_Inc_Input_ = {
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "ActivityVersion" */
export type ActivityVersion_Insert_Input_ = {
  activity?: InputMaybe<Activity_Obj_Rel_Insert_Input_>;
  activityQuestionSets?: InputMaybe<ActivityQuestionSet_Arr_Rel_Insert_Input_>;
  activityRef?: InputMaybe<Scalars['String']['input']>;
  changeDescription?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  tagExpression?: InputMaybe<Scalars['String']['input']>;
  tagObjective?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  validFrom?: InputMaybe<Scalars['date']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type ActivityVersion_Max_Fields_ = {
  __typename?: 'ActivityVersion_max_fields';
  activityRef?: Maybe<Scalars['String']['output']>;
  changeDescription?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  tagExpression?: Maybe<Scalars['String']['output']>;
  tagObjective?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  validFrom?: Maybe<Scalars['date']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "ActivityVersion" */
export type ActivityVersion_Max_Order_By_ = {
  activityRef?: InputMaybe<Order_By_>;
  changeDescription?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  tagExpression?: InputMaybe<Order_By_>;
  tagObjective?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  validFrom?: InputMaybe<Order_By_>;
  versionNumber?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type ActivityVersion_Min_Fields_ = {
  __typename?: 'ActivityVersion_min_fields';
  activityRef?: Maybe<Scalars['String']['output']>;
  changeDescription?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  tagExpression?: Maybe<Scalars['String']['output']>;
  tagObjective?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  validFrom?: Maybe<Scalars['date']['output']>;
  versionNumber?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "ActivityVersion" */
export type ActivityVersion_Min_Order_By_ = {
  activityRef?: InputMaybe<Order_By_>;
  changeDescription?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  tagExpression?: InputMaybe<Order_By_>;
  tagObjective?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  validFrom?: InputMaybe<Order_By_>;
  versionNumber?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "ActivityVersion" */
export type ActivityVersion_Mutation_Response_ = {
  __typename?: 'ActivityVersion_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ActivityVersion_>;
};

/** input type for inserting object relation for remote table "ActivityVersion" */
export type ActivityVersion_Obj_Rel_Insert_Input_ = {
  data: ActivityVersion_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<ActivityVersion_On_Conflict_>;
};

/** on_conflict condition type for table "ActivityVersion" */
export type ActivityVersion_On_Conflict_ = {
  constraint: ActivityVersion_Constraint_;
  update_columns?: Array<ActivityVersion_Update_Column_>;
  where?: InputMaybe<ActivityVersion_Bool_Exp_>;
};

/** Ordering options when selecting data from "ActivityVersion". */
export type ActivityVersion_Order_By_ = {
  activity?: InputMaybe<Activity_Order_By_>;
  activityQuestionSets_aggregate?: InputMaybe<ActivityQuestionSet_Aggregate_Order_By_>;
  activityRef?: InputMaybe<Order_By_>;
  changeDescription?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  tagExpression?: InputMaybe<Order_By_>;
  tagObjective?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  validFrom?: InputMaybe<Order_By_>;
  versionNumber?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: ActivityVersion */
export type ActivityVersion_Pk_Columns_Input_ = {
  activityRef: Scalars['String']['input'];
  versionNumber: Scalars['Int']['input'];
};

/** select columns of table "ActivityVersion" */
export enum ActivityVersion_Select_Column_ {
  /** column name */
  ActivityRef_ = 'activityRef',
  /** column name */
  ChangeDescription_ = 'changeDescription',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  TagExpression_ = 'tagExpression',
  /** column name */
  TagObjective_ = 'tagObjective',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  ValidFrom_ = 'validFrom',
  /** column name */
  VersionNumber_ = 'versionNumber'
}

/** input type for updating data in table "ActivityVersion" */
export type ActivityVersion_Set_Input_ = {
  activityRef?: InputMaybe<Scalars['String']['input']>;
  changeDescription?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  tagExpression?: InputMaybe<Scalars['String']['input']>;
  tagObjective?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  validFrom?: InputMaybe<Scalars['date']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type ActivityVersion_Stddev_Fields_ = {
  __typename?: 'ActivityVersion_stddev_fields';
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "ActivityVersion" */
export type ActivityVersion_Stddev_Order_By_ = {
  versionNumber?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type ActivityVersion_Stddev_Pop_Fields_ = {
  __typename?: 'ActivityVersion_stddev_pop_fields';
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "ActivityVersion" */
export type ActivityVersion_Stddev_Pop_Order_By_ = {
  versionNumber?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type ActivityVersion_Stddev_Samp_Fields_ = {
  __typename?: 'ActivityVersion_stddev_samp_fields';
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "ActivityVersion" */
export type ActivityVersion_Stddev_Samp_Order_By_ = {
  versionNumber?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "ActivityVersion" */
export type ActivityVersion_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: ActivityVersion_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type ActivityVersion_Stream_Cursor_Value_Input_ = {
  activityRef?: InputMaybe<Scalars['String']['input']>;
  changeDescription?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  tagExpression?: InputMaybe<Scalars['String']['input']>;
  tagObjective?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  validFrom?: InputMaybe<Scalars['date']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type ActivityVersion_Sum_Fields_ = {
  __typename?: 'ActivityVersion_sum_fields';
  versionNumber?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "ActivityVersion" */
export type ActivityVersion_Sum_Order_By_ = {
  versionNumber?: InputMaybe<Order_By_>;
};

/** update columns of table "ActivityVersion" */
export enum ActivityVersion_Update_Column_ {
  /** column name */
  ActivityRef_ = 'activityRef',
  /** column name */
  ChangeDescription_ = 'changeDescription',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  TagExpression_ = 'tagExpression',
  /** column name */
  TagObjective_ = 'tagObjective',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  ValidFrom_ = 'validFrom',
  /** column name */
  VersionNumber_ = 'versionNumber'
}

export type ActivityVersion_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ActivityVersion_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ActivityVersion_Set_Input_>;
  /** filter the rows which have to be updated */
  where: ActivityVersion_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type ActivityVersion_Var_Pop_Fields_ = {
  __typename?: 'ActivityVersion_var_pop_fields';
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "ActivityVersion" */
export type ActivityVersion_Var_Pop_Order_By_ = {
  versionNumber?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type ActivityVersion_Var_Samp_Fields_ = {
  __typename?: 'ActivityVersion_var_samp_fields';
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "ActivityVersion" */
export type ActivityVersion_Var_Samp_Order_By_ = {
  versionNumber?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type ActivityVersion_Variance_Fields_ = {
  __typename?: 'ActivityVersion_variance_fields';
  versionNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "ActivityVersion" */
export type ActivityVersion_Variance_Order_By_ = {
  versionNumber?: InputMaybe<Order_By_>;
};

/** aggregated selection of "Activity" */
export type Activity_Aggregate_ = {
  __typename?: 'Activity_aggregate';
  aggregate?: Maybe<Activity_Aggregate_Fields_>;
  nodes: Array<Activity_>;
};

export type Activity_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Activity_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Activity_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Activity_Aggregate_Bool_Exp_Count_>;
};

export type Activity_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Activity_Select_Column_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Activity_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Activity_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Activity_Select_Column_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Activity_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Activity_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Activity_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Activity_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "Activity" */
export type Activity_Aggregate_Fields_ = {
  __typename?: 'Activity_aggregate_fields';
  avg?: Maybe<Activity_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<Activity_Max_Fields_>;
  min?: Maybe<Activity_Min_Fields_>;
  stddev?: Maybe<Activity_Stddev_Fields_>;
  stddev_pop?: Maybe<Activity_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<Activity_Stddev_Samp_Fields_>;
  sum?: Maybe<Activity_Sum_Fields_>;
  var_pop?: Maybe<Activity_Var_Pop_Fields_>;
  var_samp?: Maybe<Activity_Var_Samp_Fields_>;
  variance?: Maybe<Activity_Variance_Fields_>;
};


/** aggregate fields of "Activity" */
export type Activity_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Activity_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Activity" */
export type Activity_Aggregate_Order_By_ = {
  avg?: InputMaybe<Activity_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Activity_Max_Order_By_>;
  min?: InputMaybe<Activity_Min_Order_By_>;
  stddev?: InputMaybe<Activity_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<Activity_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<Activity_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<Activity_Sum_Order_By_>;
  var_pop?: InputMaybe<Activity_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<Activity_Var_Samp_Order_By_>;
  variance?: InputMaybe<Activity_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "Activity" */
export type Activity_Arr_Rel_Insert_Input_ = {
  data: Array<Activity_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Activity_On_Conflict_>;
};

/** aggregate avg on columns */
export type Activity_Avg_Fields_ = {
  __typename?: 'Activity_avg_fields';
  currentQuestionSetVersion?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "Activity" */
export type Activity_Avg_Order_By_ = {
  currentQuestionSetVersion?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "Activity". All fields are combined with a logical 'AND'. */
export type Activity_Bool_Exp_ = {
  _and?: InputMaybe<Array<Activity_Bool_Exp_>>;
  _not?: InputMaybe<Activity_Bool_Exp_>;
  _or?: InputMaybe<Array<Activity_Bool_Exp_>>;
  activityNaceCodes?: InputMaybe<ActivityNaceCode_Bool_Exp_>;
  activityNaceCodes_aggregate?: InputMaybe<ActivityNaceCode_Aggregate_Bool_Exp_>;
  activityQuestionSets?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
  activityQuestionSets_aggregate?: InputMaybe<ActivityQuestionSet_Aggregate_Bool_Exp_>;
  activityReports?: InputMaybe<ActivityReport_Bool_Exp_>;
  activityReports_aggregate?: InputMaybe<ActivityReport_Aggregate_Bool_Exp_>;
  additionalGuidance?: InputMaybe<String_Comparison_Exp_>;
  celsiaComment?: InputMaybe<String_Comparison_Exp_>;
  currentQuestionSetVersion?: InputMaybe<Int_Comparison_Exp_>;
  currentVersion?: InputMaybe<ActivityVersion_Bool_Exp_>;
  description?: InputMaybe<String_Comparison_Exp_>;
  descriptionSource?: InputMaybe<String_Comparison_Exp_>;
  guidanceSource?: InputMaybe<String_Comparison_Exp_>;
  isHidden?: InputMaybe<Boolean_Comparison_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  referenceNumber?: InputMaybe<String_Comparison_Exp_>;
  sector?: InputMaybe<Sector_Bool_Exp_>;
  sectorRef?: InputMaybe<String_Comparison_Exp_>;
  tagExpression?: InputMaybe<String_Comparison_Exp_>;
  versions?: InputMaybe<ActivityVersion_Bool_Exp_>;
  versions_aggregate?: InputMaybe<ActivityVersion_Aggregate_Bool_Exp_>;
};

/** unique or primary key constraints on table "Activity" */
export enum Activity_Constraint_ {
  /** unique or primary key constraint on columns "name" */
  ActivityNameKey_ = 'activity_name_key',
  /** unique or primary key constraint on columns "reference" */
  ActivityPkey_ = 'activity_pkey'
}

/** input type for incrementing numeric columns in table "Activity" */
export type Activity_Inc_Input_ = {
  currentQuestionSetVersion?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "Activity" */
export type Activity_Insert_Input_ = {
  activityNaceCodes?: InputMaybe<ActivityNaceCode_Arr_Rel_Insert_Input_>;
  activityQuestionSets?: InputMaybe<ActivityQuestionSet_Arr_Rel_Insert_Input_>;
  activityReports?: InputMaybe<ActivityReport_Arr_Rel_Insert_Input_>;
  additionalGuidance?: InputMaybe<Scalars['String']['input']>;
  celsiaComment?: InputMaybe<Scalars['String']['input']>;
  currentQuestionSetVersion?: InputMaybe<Scalars['Int']['input']>;
  currentVersion?: InputMaybe<ActivityVersion_Obj_Rel_Insert_Input_>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionSource?: InputMaybe<Scalars['String']['input']>;
  guidanceSource?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  sector?: InputMaybe<Sector_Obj_Rel_Insert_Input_>;
  sectorRef?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: This field has been moved to ActivityVersion */
  tagExpression?: InputMaybe<Scalars['String']['input']>;
  versions?: InputMaybe<ActivityVersion_Arr_Rel_Insert_Input_>;
};

/** aggregate max on columns */
export type Activity_Max_Fields_ = {
  __typename?: 'Activity_max_fields';
  additionalGuidance?: Maybe<Scalars['String']['output']>;
  celsiaComment?: Maybe<Scalars['String']['output']>;
  currentQuestionSetVersion?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionSource?: Maybe<Scalars['String']['output']>;
  guidanceSource?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  sectorRef?: Maybe<Scalars['String']['output']>;
  /** Deprecated: This field has been moved to ActivityVersion */
  tagExpression?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "Activity" */
export type Activity_Max_Order_By_ = {
  additionalGuidance?: InputMaybe<Order_By_>;
  celsiaComment?: InputMaybe<Order_By_>;
  currentQuestionSetVersion?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  descriptionSource?: InputMaybe<Order_By_>;
  guidanceSource?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  referenceNumber?: InputMaybe<Order_By_>;
  sectorRef?: InputMaybe<Order_By_>;
  /** Deprecated: This field has been moved to ActivityVersion */
  tagExpression?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Activity_Min_Fields_ = {
  __typename?: 'Activity_min_fields';
  additionalGuidance?: Maybe<Scalars['String']['output']>;
  celsiaComment?: Maybe<Scalars['String']['output']>;
  currentQuestionSetVersion?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionSource?: Maybe<Scalars['String']['output']>;
  guidanceSource?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  sectorRef?: Maybe<Scalars['String']['output']>;
  /** Deprecated: This field has been moved to ActivityVersion */
  tagExpression?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "Activity" */
export type Activity_Min_Order_By_ = {
  additionalGuidance?: InputMaybe<Order_By_>;
  celsiaComment?: InputMaybe<Order_By_>;
  currentQuestionSetVersion?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  descriptionSource?: InputMaybe<Order_By_>;
  guidanceSource?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  referenceNumber?: InputMaybe<Order_By_>;
  sectorRef?: InputMaybe<Order_By_>;
  /** Deprecated: This field has been moved to ActivityVersion */
  tagExpression?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "Activity" */
export type Activity_Mutation_Response_ = {
  __typename?: 'Activity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Activity_>;
};

/** input type for inserting object relation for remote table "Activity" */
export type Activity_Obj_Rel_Insert_Input_ = {
  data: Activity_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Activity_On_Conflict_>;
};

/** on_conflict condition type for table "Activity" */
export type Activity_On_Conflict_ = {
  constraint: Activity_Constraint_;
  update_columns?: Array<Activity_Update_Column_>;
  where?: InputMaybe<Activity_Bool_Exp_>;
};

/** Ordering options when selecting data from "Activity". */
export type Activity_Order_By_ = {
  activityNaceCodes_aggregate?: InputMaybe<ActivityNaceCode_Aggregate_Order_By_>;
  activityQuestionSets_aggregate?: InputMaybe<ActivityQuestionSet_Aggregate_Order_By_>;
  activityReports_aggregate?: InputMaybe<ActivityReport_Aggregate_Order_By_>;
  additionalGuidance?: InputMaybe<Order_By_>;
  celsiaComment?: InputMaybe<Order_By_>;
  currentQuestionSetVersion?: InputMaybe<Order_By_>;
  currentVersion?: InputMaybe<ActivityVersion_Order_By_>;
  description?: InputMaybe<Order_By_>;
  descriptionSource?: InputMaybe<Order_By_>;
  guidanceSource?: InputMaybe<Order_By_>;
  isHidden?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  referenceNumber?: InputMaybe<Order_By_>;
  sector?: InputMaybe<Sector_Order_By_>;
  sectorRef?: InputMaybe<Order_By_>;
  tagExpression?: InputMaybe<Order_By_>;
  versions_aggregate?: InputMaybe<ActivityVersion_Aggregate_Order_By_>;
};

/** primary key columns input for table: Activity */
export type Activity_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "Activity" */
export enum Activity_Select_Column_ {
  /** column name */
  AdditionalGuidance_ = 'additionalGuidance',
  /** column name */
  CelsiaComment_ = 'celsiaComment',
  /** column name */
  CurrentQuestionSetVersion_ = 'currentQuestionSetVersion',
  /** column name */
  Description_ = 'description',
  /** column name */
  DescriptionSource_ = 'descriptionSource',
  /** column name */
  GuidanceSource_ = 'guidanceSource',
  /** column name */
  IsHidden_ = 'isHidden',
  /** column name */
  Name_ = 'name',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  ReferenceNumber_ = 'referenceNumber',
  /** column name */
  SectorRef_ = 'sectorRef',
  /** column name */
  TagExpression_ = 'tagExpression'
}

/** select "Activity_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Activity" */
export enum Activity_Select_Column_Activity_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsHidden_ = 'isHidden'
}

/** select "Activity_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Activity" */
export enum Activity_Select_Column_Activity_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsHidden_ = 'isHidden'
}

/** input type for updating data in table "Activity" */
export type Activity_Set_Input_ = {
  additionalGuidance?: InputMaybe<Scalars['String']['input']>;
  celsiaComment?: InputMaybe<Scalars['String']['input']>;
  currentQuestionSetVersion?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionSource?: InputMaybe<Scalars['String']['input']>;
  guidanceSource?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  sectorRef?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: This field has been moved to ActivityVersion */
  tagExpression?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Activity_Stddev_Fields_ = {
  __typename?: 'Activity_stddev_fields';
  currentQuestionSetVersion?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "Activity" */
export type Activity_Stddev_Order_By_ = {
  currentQuestionSetVersion?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type Activity_Stddev_Pop_Fields_ = {
  __typename?: 'Activity_stddev_pop_fields';
  currentQuestionSetVersion?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "Activity" */
export type Activity_Stddev_Pop_Order_By_ = {
  currentQuestionSetVersion?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type Activity_Stddev_Samp_Fields_ = {
  __typename?: 'Activity_stddev_samp_fields';
  currentQuestionSetVersion?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "Activity" */
export type Activity_Stddev_Samp_Order_By_ = {
  currentQuestionSetVersion?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "Activity" */
export type Activity_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Activity_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Activity_Stream_Cursor_Value_Input_ = {
  additionalGuidance?: InputMaybe<Scalars['String']['input']>;
  celsiaComment?: InputMaybe<Scalars['String']['input']>;
  currentQuestionSetVersion?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionSource?: InputMaybe<Scalars['String']['input']>;
  guidanceSource?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  sectorRef?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated: This field has been moved to ActivityVersion */
  tagExpression?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Activity_Sum_Fields_ = {
  __typename?: 'Activity_sum_fields';
  currentQuestionSetVersion?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "Activity" */
export type Activity_Sum_Order_By_ = {
  currentQuestionSetVersion?: InputMaybe<Order_By_>;
};

/** update columns of table "Activity" */
export enum Activity_Update_Column_ {
  /** column name */
  AdditionalGuidance_ = 'additionalGuidance',
  /** column name */
  CelsiaComment_ = 'celsiaComment',
  /** column name */
  CurrentQuestionSetVersion_ = 'currentQuestionSetVersion',
  /** column name */
  Description_ = 'description',
  /** column name */
  DescriptionSource_ = 'descriptionSource',
  /** column name */
  GuidanceSource_ = 'guidanceSource',
  /** column name */
  IsHidden_ = 'isHidden',
  /** column name */
  Name_ = 'name',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  ReferenceNumber_ = 'referenceNumber',
  /** column name */
  SectorRef_ = 'sectorRef',
  /** column name */
  TagExpression_ = 'tagExpression'
}

export type Activity_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Activity_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Activity_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Activity_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type Activity_Var_Pop_Fields_ = {
  __typename?: 'Activity_var_pop_fields';
  currentQuestionSetVersion?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "Activity" */
export type Activity_Var_Pop_Order_By_ = {
  currentQuestionSetVersion?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type Activity_Var_Samp_Fields_ = {
  __typename?: 'Activity_var_samp_fields';
  currentQuestionSetVersion?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "Activity" */
export type Activity_Var_Samp_Order_By_ = {
  currentQuestionSetVersion?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type Activity_Variance_Fields_ = {
  __typename?: 'Activity_variance_fields';
  currentQuestionSetVersion?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "Activity" */
export type Activity_Variance_Order_By_ = {
  currentQuestionSetVersion?: InputMaybe<Order_By_>;
};

/** Additional type categories for metrics and disclosure requirements so that users know which metrics they have to report on, and which are voluntary, as well as which metrics their investors might require them to report on. */
export type AdditionalType_ = {
  __typename?: 'AdditionalType';
  description?: Maybe<Scalars['String']['output']>;
  learnMore?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "esrs.AdditionalType" */
export type AdditionalType_Aggregate_ = {
  __typename?: 'AdditionalType_aggregate';
  aggregate?: Maybe<AdditionalType_Aggregate_Fields_>;
  nodes: Array<AdditionalType_>;
};

/** aggregate fields of "esrs.AdditionalType" */
export type AdditionalType_Aggregate_Fields_ = {
  __typename?: 'AdditionalType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AdditionalType_Max_Fields_>;
  min?: Maybe<AdditionalType_Min_Fields_>;
};


/** aggregate fields of "esrs.AdditionalType" */
export type AdditionalType_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<AdditionalType_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "esrs.AdditionalType". All fields are combined with a logical 'AND'. */
export type AdditionalType_Bool_Exp_ = {
  _and?: InputMaybe<Array<AdditionalType_Bool_Exp_>>;
  _not?: InputMaybe<AdditionalType_Bool_Exp_>;
  _or?: InputMaybe<Array<AdditionalType_Bool_Exp_>>;
  description?: InputMaybe<String_Comparison_Exp_>;
  learnMore?: InputMaybe<String_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.AdditionalType" */
export enum AdditionalType_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  AdditionalTypePkey_ = 'AdditionalType_pkey'
}

/** input type for inserting data into table "esrs.AdditionalType" */
export type AdditionalType_Insert_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  learnMore?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AdditionalType_Max_Fields_ = {
  __typename?: 'AdditionalType_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  learnMore?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AdditionalType_Min_Fields_ = {
  __typename?: 'AdditionalType_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  learnMore?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "esrs.AdditionalType" */
export type AdditionalType_Mutation_Response_ = {
  __typename?: 'AdditionalType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AdditionalType_>;
};

/** input type for inserting object relation for remote table "esrs.AdditionalType" */
export type AdditionalType_Obj_Rel_Insert_Input_ = {
  data: AdditionalType_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<AdditionalType_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.AdditionalType" */
export type AdditionalType_On_Conflict_ = {
  constraint: AdditionalType_Constraint_;
  update_columns?: Array<AdditionalType_Update_Column_>;
  where?: InputMaybe<AdditionalType_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.AdditionalType". */
export type AdditionalType_Order_By_ = {
  description?: InputMaybe<Order_By_>;
  learnMore?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.AdditionalType */
export type AdditionalType_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.AdditionalType" */
export enum AdditionalType_Select_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  LearnMore_ = 'learnMore',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

/** input type for updating data in table "esrs.AdditionalType" */
export type AdditionalType_Set_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  learnMore?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "AdditionalType" */
export type AdditionalType_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: AdditionalType_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type AdditionalType_Stream_Cursor_Value_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  learnMore?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.AdditionalType" */
export enum AdditionalType_Update_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  LearnMore_ = 'learnMore',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

export type AdditionalType_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AdditionalType_Set_Input_>;
  /** filter the rows which have to be updated */
  where: AdditionalType_Bool_Exp_;
};

/** columns and relationships of "Answer" */
export type Answer_ = {
  __typename?: 'Answer';
  /** An object relationship */
  activityReport?: Maybe<ActivityReport_>;
  /** An object relationship */
  answerCompany?: Maybe<AnswerCompany_>;
  /** An object relationship */
  answeredBy: Users_;
  answeredById: Scalars['uuid']['output'];
  /** An object relationship */
  attachmentBox?: Maybe<AttachmentBox_>;
  createdAt: Scalars['timestamptz']['output'];
  data?: Maybe<Scalars['jsonb']['output']>;
  flagged?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  noteHistory?: Maybe<NoteHistory_>;
  /** An object relationship */
  question: Question_;
  questionId: Scalars['uuid']['output'];
  reportId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  thread?: Maybe<Thread_>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "Answer" */
export type AnswerDataArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "AnswerCompany" */
export type AnswerCompany_ = {
  __typename?: 'AnswerCompany';
  answerId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  company?: Maybe<Company_>;
  companyId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregated selection of "AnswerCompany" */
export type AnswerCompany_Aggregate_ = {
  __typename?: 'AnswerCompany_aggregate';
  aggregate?: Maybe<AnswerCompany_Aggregate_Fields_>;
  nodes: Array<AnswerCompany_>;
};

/** aggregate fields of "AnswerCompany" */
export type AnswerCompany_Aggregate_Fields_ = {
  __typename?: 'AnswerCompany_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AnswerCompany_Max_Fields_>;
  min?: Maybe<AnswerCompany_Min_Fields_>;
};


/** aggregate fields of "AnswerCompany" */
export type AnswerCompany_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<AnswerCompany_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "AnswerCompany". All fields are combined with a logical 'AND'. */
export type AnswerCompany_Bool_Exp_ = {
  _and?: InputMaybe<Array<AnswerCompany_Bool_Exp_>>;
  _not?: InputMaybe<AnswerCompany_Bool_Exp_>;
  _or?: InputMaybe<Array<AnswerCompany_Bool_Exp_>>;
  answerId?: InputMaybe<Uuid_Comparison_Exp_>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
};

/** input type for inserting data into table "AnswerCompany" */
export type AnswerCompany_Insert_Input_ = {
  answerId?: InputMaybe<Scalars['uuid']['input']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AnswerCompany_Max_Fields_ = {
  __typename?: 'AnswerCompany_max_fields';
  answerId?: Maybe<Scalars['uuid']['output']>;
  companyId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type AnswerCompany_Min_Fields_ = {
  __typename?: 'AnswerCompany_min_fields';
  answerId?: Maybe<Scalars['uuid']['output']>;
  companyId?: Maybe<Scalars['uuid']['output']>;
};

/** input type for inserting object relation for remote table "AnswerCompany" */
export type AnswerCompany_Obj_Rel_Insert_Input_ = {
  data: AnswerCompany_Insert_Input_;
};

/** Ordering options when selecting data from "AnswerCompany". */
export type AnswerCompany_Order_By_ = {
  answerId?: InputMaybe<Order_By_>;
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
};

/** select columns of table "AnswerCompany" */
export enum AnswerCompany_Select_Column_ {
  /** column name */
  AnswerId_ = 'answerId',
  /** column name */
  CompanyId_ = 'companyId'
}

/** Streaming cursor of the table "AnswerCompany" */
export type AnswerCompany_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: AnswerCompany_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type AnswerCompany_Stream_Cursor_Value_Input_ = {
  answerId?: InputMaybe<Scalars['uuid']['input']>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregated selection of "Answer" */
export type Answer_Aggregate_ = {
  __typename?: 'Answer_aggregate';
  aggregate?: Maybe<Answer_Aggregate_Fields_>;
  nodes: Array<Answer_>;
};

export type Answer_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Answer_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Answer_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Answer_Aggregate_Bool_Exp_Count_>;
};

export type Answer_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Answer_Select_Column_Answer_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Answer_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Answer_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Answer_Select_Column_Answer_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Answer_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Answer_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Answer_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Answer_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "Answer" */
export type Answer_Aggregate_Fields_ = {
  __typename?: 'Answer_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Answer_Max_Fields_>;
  min?: Maybe<Answer_Min_Fields_>;
};


/** aggregate fields of "Answer" */
export type Answer_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Answer_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Answer" */
export type Answer_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Answer_Max_Order_By_>;
  min?: InputMaybe<Answer_Min_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Answer_Append_Input_ = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "Answer" */
export type Answer_Arr_Rel_Insert_Input_ = {
  data: Array<Answer_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Answer_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "Answer". All fields are combined with a logical 'AND'. */
export type Answer_Bool_Exp_ = {
  _and?: InputMaybe<Array<Answer_Bool_Exp_>>;
  _not?: InputMaybe<Answer_Bool_Exp_>;
  _or?: InputMaybe<Array<Answer_Bool_Exp_>>;
  activityReport?: InputMaybe<ActivityReport_Bool_Exp_>;
  answerCompany?: InputMaybe<AnswerCompany_Bool_Exp_>;
  answeredBy?: InputMaybe<Users_Bool_Exp_>;
  answeredById?: InputMaybe<Uuid_Comparison_Exp_>;
  attachmentBox?: InputMaybe<AttachmentBox_Bool_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  data?: InputMaybe<Jsonb_Comparison_Exp_>;
  flagged?: InputMaybe<Boolean_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  noteHistory?: InputMaybe<NoteHistory_Bool_Exp_>;
  question?: InputMaybe<Question_Bool_Exp_>;
  questionId?: InputMaybe<Uuid_Comparison_Exp_>;
  reportId?: InputMaybe<Uuid_Comparison_Exp_>;
  thread?: InputMaybe<Thread_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Answer" */
export enum Answer_Constraint_ {
  /** unique or primary key constraint on columns "reportId", "questionId" */
  AnswerQuestionIdReportId_22331f7fUniq_ = 'Answer_questionId_reportId_22331f7f_uniq',
  /** unique or primary key constraint on columns "id" */
  AnswerPkey_ = 'answer_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Answer_Delete_At_Path_Input_ = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Answer_Delete_Elem_Input_ = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Answer_Delete_Key_Input_ = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "Answer" */
export type Answer_Insert_Input_ = {
  activityReport?: InputMaybe<ActivityReport_Obj_Rel_Insert_Input_>;
  answerCompany?: InputMaybe<AnswerCompany_Obj_Rel_Insert_Input_>;
  answeredBy?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  answeredById?: InputMaybe<Scalars['uuid']['input']>;
  attachmentBox?: InputMaybe<AttachmentBox_Obj_Rel_Insert_Input_>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  noteHistory?: InputMaybe<NoteHistory_Obj_Rel_Insert_Input_>;
  question?: InputMaybe<Question_Obj_Rel_Insert_Input_>;
  questionId?: InputMaybe<Scalars['uuid']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  thread?: InputMaybe<Thread_Obj_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Answer_Max_Fields_ = {
  __typename?: 'Answer_max_fields';
  answeredById?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  questionId?: Maybe<Scalars['uuid']['output']>;
  reportId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "Answer" */
export type Answer_Max_Order_By_ = {
  answeredById?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  questionId?: InputMaybe<Order_By_>;
  reportId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Answer_Min_Fields_ = {
  __typename?: 'Answer_min_fields';
  answeredById?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  questionId?: Maybe<Scalars['uuid']['output']>;
  reportId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "Answer" */
export type Answer_Min_Order_By_ = {
  answeredById?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  questionId?: InputMaybe<Order_By_>;
  reportId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "Answer" */
export type Answer_Mutation_Response_ = {
  __typename?: 'Answer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Answer_>;
};

/** input type for inserting object relation for remote table "Answer" */
export type Answer_Obj_Rel_Insert_Input_ = {
  data: Answer_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Answer_On_Conflict_>;
};

/** on_conflict condition type for table "Answer" */
export type Answer_On_Conflict_ = {
  constraint: Answer_Constraint_;
  update_columns?: Array<Answer_Update_Column_>;
  where?: InputMaybe<Answer_Bool_Exp_>;
};

/** Ordering options when selecting data from "Answer". */
export type Answer_Order_By_ = {
  activityReport?: InputMaybe<ActivityReport_Order_By_>;
  answerCompany?: InputMaybe<AnswerCompany_Order_By_>;
  answeredBy?: InputMaybe<Users_Order_By_>;
  answeredById?: InputMaybe<Order_By_>;
  attachmentBox?: InputMaybe<AttachmentBox_Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  data?: InputMaybe<Order_By_>;
  flagged?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  noteHistory?: InputMaybe<NoteHistory_Order_By_>;
  question?: InputMaybe<Question_Order_By_>;
  questionId?: InputMaybe<Order_By_>;
  reportId?: InputMaybe<Order_By_>;
  thread?: InputMaybe<Thread_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Answer */
export type Answer_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Answer_Prepend_Input_ = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "Answer" */
export enum Answer_Select_Column_ {
  /** column name */
  AnsweredById_ = 'answeredById',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Data_ = 'data',
  /** column name */
  Flagged_ = 'flagged',
  /** column name */
  Id_ = 'id',
  /** column name */
  QuestionId_ = 'questionId',
  /** column name */
  ReportId_ = 'reportId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "Answer_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Answer" */
export enum Answer_Select_Column_Answer_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  Flagged_ = 'flagged'
}

/** select "Answer_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Answer" */
export enum Answer_Select_Column_Answer_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  Flagged_ = 'flagged'
}

/** input type for updating data in table "Answer" */
export type Answer_Set_Input_ = {
  answeredById?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  questionId?: InputMaybe<Scalars['uuid']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "Answer" */
export type Answer_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Answer_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Answer_Stream_Cursor_Value_Input_ = {
  answeredById?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  questionId?: InputMaybe<Scalars['uuid']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "Answer" */
export enum Answer_Update_Column_ {
  /** column name */
  AnsweredById_ = 'answeredById',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Data_ = 'data',
  /** column name */
  Flagged_ = 'flagged',
  /** column name */
  Id_ = 'id',
  /** column name */
  QuestionId_ = 'questionId',
  /** column name */
  ReportId_ = 'reportId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Answer_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Answer_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Answer_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Answer_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Answer_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Answer_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Answer_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Answer_Bool_Exp_;
};

/** columns and relationships of "AppConfig" */
export type AppConfig_ = {
  __typename?: 'AppConfig';
  id: Scalars['Boolean']['output'];
  identifier: Scalars['String']['output'];
  mergeInProgress: Scalars['Boolean']['output'];
  updated_at: Scalars['timestamptz']['output'];
};

/** aggregated selection of "AppConfig" */
export type AppConfig_Aggregate_ = {
  __typename?: 'AppConfig_aggregate';
  aggregate?: Maybe<AppConfig_Aggregate_Fields_>;
  nodes: Array<AppConfig_>;
};

/** aggregate fields of "AppConfig" */
export type AppConfig_Aggregate_Fields_ = {
  __typename?: 'AppConfig_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AppConfig_Max_Fields_>;
  min?: Maybe<AppConfig_Min_Fields_>;
};


/** aggregate fields of "AppConfig" */
export type AppConfig_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<AppConfig_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "AppConfig". All fields are combined with a logical 'AND'. */
export type AppConfig_Bool_Exp_ = {
  _and?: InputMaybe<Array<AppConfig_Bool_Exp_>>;
  _not?: InputMaybe<AppConfig_Bool_Exp_>;
  _or?: InputMaybe<Array<AppConfig_Bool_Exp_>>;
  id?: InputMaybe<Boolean_Comparison_Exp_>;
  identifier?: InputMaybe<String_Comparison_Exp_>;
  mergeInProgress?: InputMaybe<Boolean_Comparison_Exp_>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "AppConfig" */
export enum AppConfig_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  AppConfigPkey_ = 'AppConfig_pkey'
}

/** input type for inserting data into table "AppConfig" */
export type AppConfig_Insert_Input_ = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  mergeInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type AppConfig_Max_Fields_ = {
  __typename?: 'AppConfig_max_fields';
  identifier?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type AppConfig_Min_Fields_ = {
  __typename?: 'AppConfig_min_fields';
  identifier?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "AppConfig" */
export type AppConfig_Mutation_Response_ = {
  __typename?: 'AppConfig_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AppConfig_>;
};

/** on_conflict condition type for table "AppConfig" */
export type AppConfig_On_Conflict_ = {
  constraint: AppConfig_Constraint_;
  update_columns?: Array<AppConfig_Update_Column_>;
  where?: InputMaybe<AppConfig_Bool_Exp_>;
};

/** Ordering options when selecting data from "AppConfig". */
export type AppConfig_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  identifier?: InputMaybe<Order_By_>;
  mergeInProgress?: InputMaybe<Order_By_>;
  updated_at?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: AppConfig */
export type AppConfig_Pk_Columns_Input_ = {
  id: Scalars['Boolean']['input'];
};

/** select columns of table "AppConfig" */
export enum AppConfig_Select_Column_ {
  /** column name */
  Id_ = 'id',
  /** column name */
  Identifier_ = 'identifier',
  /** column name */
  MergeInProgress_ = 'mergeInProgress',
  /** column name */
  UpdatedAt_ = 'updated_at'
}

/** input type for updating data in table "AppConfig" */
export type AppConfig_Set_Input_ = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  mergeInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "AppConfig" */
export type AppConfig_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: AppConfig_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type AppConfig_Stream_Cursor_Value_Input_ = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  identifier?: InputMaybe<Scalars['String']['input']>;
  mergeInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "AppConfig" */
export enum AppConfig_Update_Column_ {
  /** column name */
  Id_ = 'id',
  /** column name */
  Identifier_ = 'identifier',
  /** column name */
  MergeInProgress_ = 'mergeInProgress',
  /** column name */
  UpdatedAt_ = 'updated_at'
}

export type AppConfig_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AppConfig_Set_Input_>;
  /** filter the rows which have to be updated */
  where: AppConfig_Bool_Exp_;
};

/** columns and relationships of "Article" */
export type Article_ = {
  __typename?: 'Article';
  body: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isHidden: Scalars['Boolean']['output'];
  order: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  tags: Array<Tag_Articles_>;
  /** An aggregate relationship */
  tags_aggregate: Tag_Articles_Aggregate_;
  title: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "Article" */
export type ArticleTagsArgs_ = {
  distinct_on?: InputMaybe<Array<Tag_Articles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Articles_Order_By_>>;
  where?: InputMaybe<Tag_Articles_Bool_Exp_>;
};


/** columns and relationships of "Article" */
export type ArticleTags_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Tag_Articles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Articles_Order_By_>>;
  where?: InputMaybe<Tag_Articles_Bool_Exp_>;
};

/** aggregated selection of "Article" */
export type Article_Aggregate_ = {
  __typename?: 'Article_aggregate';
  aggregate?: Maybe<Article_Aggregate_Fields_>;
  nodes: Array<Article_>;
};

/** aggregate fields of "Article" */
export type Article_Aggregate_Fields_ = {
  __typename?: 'Article_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Article_Max_Fields_>;
  min?: Maybe<Article_Min_Fields_>;
};


/** aggregate fields of "Article" */
export type Article_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Article_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "Article". All fields are combined with a logical 'AND'. */
export type Article_Bool_Exp_ = {
  _and?: InputMaybe<Array<Article_Bool_Exp_>>;
  _not?: InputMaybe<Article_Bool_Exp_>;
  _or?: InputMaybe<Array<Article_Bool_Exp_>>;
  body?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isHidden?: InputMaybe<Boolean_Comparison_Exp_>;
  order?: InputMaybe<String_Comparison_Exp_>;
  slug?: InputMaybe<String_Comparison_Exp_>;
  tags?: InputMaybe<Tag_Articles_Bool_Exp_>;
  tags_aggregate?: InputMaybe<Tag_Articles_Aggregate_Bool_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Article" */
export enum Article_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  ArticlePkey_ = 'Article_pkey',
  /** unique or primary key constraint on columns "slug" */
  ArticleSlugKey_ = 'Article_slug_key'
}

/** input type for inserting data into table "Article" */
export type Article_Insert_Input_ = {
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Tag_Articles_Arr_Rel_Insert_Input_>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Article_Max_Fields_ = {
  __typename?: 'Article_max_fields';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Article_Min_Fields_ = {
  __typename?: 'Article_min_fields';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "Article" */
export type Article_Mutation_Response_ = {
  __typename?: 'Article_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Article_>;
};

/** input type for inserting object relation for remote table "Article" */
export type Article_Obj_Rel_Insert_Input_ = {
  data: Article_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Article_On_Conflict_>;
};

/** on_conflict condition type for table "Article" */
export type Article_On_Conflict_ = {
  constraint: Article_Constraint_;
  update_columns?: Array<Article_Update_Column_>;
  where?: InputMaybe<Article_Bool_Exp_>;
};

/** Ordering options when selecting data from "Article". */
export type Article_Order_By_ = {
  body?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isHidden?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  slug?: InputMaybe<Order_By_>;
  tags_aggregate?: InputMaybe<Tag_Articles_Aggregate_Order_By_>;
  title?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Article */
export type Article_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "Article" */
export enum Article_Select_Column_ {
  /** column name */
  Body_ = 'body',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsHidden_ = 'isHidden',
  /** column name */
  Order_ = 'order',
  /** column name */
  Slug_ = 'slug',
  /** column name */
  Title_ = 'title',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "Article" */
export type Article_Set_Input_ = {
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "Article" */
export type Article_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Article_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Article_Stream_Cursor_Value_Input_ = {
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "Article" */
export enum Article_Update_Column_ {
  /** column name */
  Body_ = 'body',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsHidden_ = 'isHidden',
  /** column name */
  Order_ = 'order',
  /** column name */
  Slug_ = 'slug',
  /** column name */
  Title_ = 'title',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Article_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Article_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Article_Bool_Exp_;
};

/** columns and relationships of "Attachment" */
export type Attachment_ = {
  __typename?: 'Attachment';
  /** An object relationship */
  attachmentBox: AttachmentBox_;
  attachmentBoxId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  file: DocumentationFile_;
  fileId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** columns and relationships of "AttachmentBox" */
export type AttachmentBox_ = {
  __typename?: 'AttachmentBox';
  /** An object relationship */
  action?: Maybe<Esrs_Actions_>;
  actionId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  activityReport?: Maybe<ActivityReport_>;
  activityReportId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  answer?: Maybe<Answer_>;
  answerId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  attachments: Array<Attachment_>;
  /** An aggregate relationship */
  attachments_aggregate: Attachment_Aggregate_;
  createdAt: Scalars['timestamptz']['output'];
  deprecatedMetricAnswerId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  disclosureRequirementAttachment?: Maybe<Esrs_DisclosureRequirementAttachment_>;
  disclosureRequirementAttachmentId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  financials?: Maybe<Financials_>;
  financialsId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  materialStandard?: Maybe<Esrs_MaterialStandard_>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  metricAnswer?: Maybe<Esrs_Answer_>;
  metricAnswerId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  nonMaterialFinancials?: Maybe<NonMaterialFinancials_>;
  /** An object relationship */
  paiAnswer?: Maybe<PaiAnswers_>;
  paiAnswerId?: Maybe<Scalars['uuid']['output']>;
  policiesId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  policy?: Maybe<Esrs_Policy_>;
  /** An object relationship */
  target?: Maybe<Esrs_Target_>;
  targetId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  totalComparisonFinancials?: Maybe<TotalComparisonFinancials_>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "AttachmentBox" */
export type AttachmentBoxAttachmentsArgs_ = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attachment_Order_By_>>;
  where?: InputMaybe<Attachment_Bool_Exp_>;
};


/** columns and relationships of "AttachmentBox" */
export type AttachmentBoxAttachments_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attachment_Order_By_>>;
  where?: InputMaybe<Attachment_Bool_Exp_>;
};

/** aggregated selection of "AttachmentBox" */
export type AttachmentBox_Aggregate_ = {
  __typename?: 'AttachmentBox_aggregate';
  aggregate?: Maybe<AttachmentBox_Aggregate_Fields_>;
  nodes: Array<AttachmentBox_>;
};

/** aggregate fields of "AttachmentBox" */
export type AttachmentBox_Aggregate_Fields_ = {
  __typename?: 'AttachmentBox_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AttachmentBox_Max_Fields_>;
  min?: Maybe<AttachmentBox_Min_Fields_>;
};


/** aggregate fields of "AttachmentBox" */
export type AttachmentBox_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<AttachmentBox_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "AttachmentBox". All fields are combined with a logical 'AND'. */
export type AttachmentBox_Bool_Exp_ = {
  _and?: InputMaybe<Array<AttachmentBox_Bool_Exp_>>;
  _not?: InputMaybe<AttachmentBox_Bool_Exp_>;
  _or?: InputMaybe<Array<AttachmentBox_Bool_Exp_>>;
  action?: InputMaybe<Esrs_Actions_Bool_Exp_>;
  actionId?: InputMaybe<Uuid_Comparison_Exp_>;
  activityReport?: InputMaybe<ActivityReport_Bool_Exp_>;
  activityReportId?: InputMaybe<Uuid_Comparison_Exp_>;
  answer?: InputMaybe<Answer_Bool_Exp_>;
  answerId?: InputMaybe<Uuid_Comparison_Exp_>;
  attachments?: InputMaybe<Attachment_Bool_Exp_>;
  attachments_aggregate?: InputMaybe<Attachment_Aggregate_Bool_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  deprecatedMetricAnswerId?: InputMaybe<Uuid_Comparison_Exp_>;
  disclosureRequirementAttachment?: InputMaybe<Esrs_DisclosureRequirementAttachment_Bool_Exp_>;
  disclosureRequirementAttachmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  financials?: InputMaybe<Financials_Bool_Exp_>;
  financialsId?: InputMaybe<Uuid_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  materialStandardId?: InputMaybe<Uuid_Comparison_Exp_>;
  metricAnswer?: InputMaybe<Esrs_Answer_Bool_Exp_>;
  metricAnswerId?: InputMaybe<Uuid_Comparison_Exp_>;
  nonMaterialFinancials?: InputMaybe<NonMaterialFinancials_Bool_Exp_>;
  paiAnswer?: InputMaybe<PaiAnswers_Bool_Exp_>;
  paiAnswerId?: InputMaybe<Uuid_Comparison_Exp_>;
  policiesId?: InputMaybe<Uuid_Comparison_Exp_>;
  policy?: InputMaybe<Esrs_Policy_Bool_Exp_>;
  target?: InputMaybe<Esrs_Target_Bool_Exp_>;
  targetId?: InputMaybe<Uuid_Comparison_Exp_>;
  totalComparisonFinancials?: InputMaybe<TotalComparisonFinancials_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "AttachmentBox" */
export enum AttachmentBox_Constraint_ {
  /** unique or primary key constraint on columns "actionId" */
  AttachmentBoxActionIdKey_ = 'AttachmentBox_actionId_key',
  /** unique or primary key constraint on columns "activityReportId" */
  AttachmentBoxActivityReportIdKey_ = 'AttachmentBox_activityReportId_key',
  /** unique or primary key constraint on columns "answerId" */
  AttachmentBoxAnswerIdKey_ = 'AttachmentBox_answerId_key',
  /** unique or primary key constraint on columns "disclosureRequirementAttachmentId" */
  AttachmentBoxDisclosureRequirementAttachmentIdKey_ = 'AttachmentBox_disclosureRequirementAttachmentId_key',
  /** unique or primary key constraint on columns "financialsId" */
  AttachmentBoxFinancialsIdKey_ = 'AttachmentBox_financialsId_key',
  /** unique or primary key constraint on columns "materialStandardId" */
  AttachmentBoxMaterialityAssessmentIdKey_ = 'AttachmentBox_materialityAssessmentId_key',
  /** unique or primary key constraint on columns "metricAnswerId" */
  AttachmentBoxMetricAnswerIdKey1_ = 'AttachmentBox_metricAnswerId_key1',
  /** unique or primary key constraint on columns "paiAnswerId" */
  AttachmentBoxPaiAnswerIdKey_ = 'AttachmentBox_paiAnswerId_key',
  /** unique or primary key constraint on columns "id" */
  AttachmentBoxPkey_ = 'AttachmentBox_pkey',
  /** unique or primary key constraint on columns "policiesId" */
  AttachmentBoxPoliciesIdKey_ = 'AttachmentBox_policiesId_key',
  /** unique or primary key constraint on columns "targetId" */
  AttachmentBoxTargetIdKey_ = 'AttachmentBox_targetId_key'
}

/** input type for inserting data into table "AttachmentBox" */
export type AttachmentBox_Insert_Input_ = {
  action?: InputMaybe<Esrs_Actions_Obj_Rel_Insert_Input_>;
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  activityReport?: InputMaybe<ActivityReport_Obj_Rel_Insert_Input_>;
  activityReportId?: InputMaybe<Scalars['uuid']['input']>;
  answer?: InputMaybe<Answer_Obj_Rel_Insert_Input_>;
  answerId?: InputMaybe<Scalars['uuid']['input']>;
  attachments?: InputMaybe<Attachment_Arr_Rel_Insert_Input_>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecatedMetricAnswerId?: InputMaybe<Scalars['uuid']['input']>;
  disclosureRequirementAttachment?: InputMaybe<Esrs_DisclosureRequirementAttachment_Obj_Rel_Insert_Input_>;
  disclosureRequirementAttachmentId?: InputMaybe<Scalars['uuid']['input']>;
  financials?: InputMaybe<Financials_Obj_Rel_Insert_Input_>;
  financialsId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Obj_Rel_Insert_Input_>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  metricAnswer?: InputMaybe<Esrs_Answer_Obj_Rel_Insert_Input_>;
  metricAnswerId?: InputMaybe<Scalars['uuid']['input']>;
  nonMaterialFinancials?: InputMaybe<NonMaterialFinancials_Obj_Rel_Insert_Input_>;
  paiAnswer?: InputMaybe<PaiAnswers_Obj_Rel_Insert_Input_>;
  paiAnswerId?: InputMaybe<Scalars['uuid']['input']>;
  policiesId?: InputMaybe<Scalars['uuid']['input']>;
  policy?: InputMaybe<Esrs_Policy_Obj_Rel_Insert_Input_>;
  target?: InputMaybe<Esrs_Target_Obj_Rel_Insert_Input_>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  totalComparisonFinancials?: InputMaybe<TotalComparisonFinancials_Obj_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type AttachmentBox_Max_Fields_ = {
  __typename?: 'AttachmentBox_max_fields';
  actionId?: Maybe<Scalars['uuid']['output']>;
  activityReportId?: Maybe<Scalars['uuid']['output']>;
  answerId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deprecatedMetricAnswerId?: Maybe<Scalars['uuid']['output']>;
  disclosureRequirementAttachmentId?: Maybe<Scalars['uuid']['output']>;
  financialsId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  metricAnswerId?: Maybe<Scalars['uuid']['output']>;
  paiAnswerId?: Maybe<Scalars['uuid']['output']>;
  policiesId?: Maybe<Scalars['uuid']['output']>;
  targetId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type AttachmentBox_Min_Fields_ = {
  __typename?: 'AttachmentBox_min_fields';
  actionId?: Maybe<Scalars['uuid']['output']>;
  activityReportId?: Maybe<Scalars['uuid']['output']>;
  answerId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deprecatedMetricAnswerId?: Maybe<Scalars['uuid']['output']>;
  disclosureRequirementAttachmentId?: Maybe<Scalars['uuid']['output']>;
  financialsId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  metricAnswerId?: Maybe<Scalars['uuid']['output']>;
  paiAnswerId?: Maybe<Scalars['uuid']['output']>;
  policiesId?: Maybe<Scalars['uuid']['output']>;
  targetId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "AttachmentBox" */
export type AttachmentBox_Mutation_Response_ = {
  __typename?: 'AttachmentBox_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AttachmentBox_>;
};

/** input type for inserting object relation for remote table "AttachmentBox" */
export type AttachmentBox_Obj_Rel_Insert_Input_ = {
  data: AttachmentBox_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<AttachmentBox_On_Conflict_>;
};

/** on_conflict condition type for table "AttachmentBox" */
export type AttachmentBox_On_Conflict_ = {
  constraint: AttachmentBox_Constraint_;
  update_columns?: Array<AttachmentBox_Update_Column_>;
  where?: InputMaybe<AttachmentBox_Bool_Exp_>;
};

/** Ordering options when selecting data from "AttachmentBox". */
export type AttachmentBox_Order_By_ = {
  action?: InputMaybe<Esrs_Actions_Order_By_>;
  actionId?: InputMaybe<Order_By_>;
  activityReport?: InputMaybe<ActivityReport_Order_By_>;
  activityReportId?: InputMaybe<Order_By_>;
  answer?: InputMaybe<Answer_Order_By_>;
  answerId?: InputMaybe<Order_By_>;
  attachments_aggregate?: InputMaybe<Attachment_Aggregate_Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deprecatedMetricAnswerId?: InputMaybe<Order_By_>;
  disclosureRequirementAttachment?: InputMaybe<Esrs_DisclosureRequirementAttachment_Order_By_>;
  disclosureRequirementAttachmentId?: InputMaybe<Order_By_>;
  financials?: InputMaybe<Financials_Order_By_>;
  financialsId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Order_By_>;
  materialStandardId?: InputMaybe<Order_By_>;
  metricAnswer?: InputMaybe<Esrs_Answer_Order_By_>;
  metricAnswerId?: InputMaybe<Order_By_>;
  nonMaterialFinancials?: InputMaybe<NonMaterialFinancials_Order_By_>;
  paiAnswer?: InputMaybe<PaiAnswers_Order_By_>;
  paiAnswerId?: InputMaybe<Order_By_>;
  policiesId?: InputMaybe<Order_By_>;
  policy?: InputMaybe<Esrs_Policy_Order_By_>;
  target?: InputMaybe<Esrs_Target_Order_By_>;
  targetId?: InputMaybe<Order_By_>;
  totalComparisonFinancials?: InputMaybe<TotalComparisonFinancials_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: AttachmentBox */
export type AttachmentBox_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "AttachmentBox" */
export enum AttachmentBox_Select_Column_ {
  /** column name */
  ActionId_ = 'actionId',
  /** column name */
  ActivityReportId_ = 'activityReportId',
  /** column name */
  AnswerId_ = 'answerId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeprecatedMetricAnswerId_ = 'deprecatedMetricAnswerId',
  /** column name */
  DisclosureRequirementAttachmentId_ = 'disclosureRequirementAttachmentId',
  /** column name */
  FinancialsId_ = 'financialsId',
  /** column name */
  Id_ = 'id',
  /** column name */
  MaterialStandardId_ = 'materialStandardId',
  /** column name */
  MetricAnswerId_ = 'metricAnswerId',
  /** column name */
  PaiAnswerId_ = 'paiAnswerId',
  /** column name */
  PoliciesId_ = 'policiesId',
  /** column name */
  TargetId_ = 'targetId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "AttachmentBox" */
export type AttachmentBox_Set_Input_ = {
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  activityReportId?: InputMaybe<Scalars['uuid']['input']>;
  answerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecatedMetricAnswerId?: InputMaybe<Scalars['uuid']['input']>;
  disclosureRequirementAttachmentId?: InputMaybe<Scalars['uuid']['input']>;
  financialsId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  metricAnswerId?: InputMaybe<Scalars['uuid']['input']>;
  paiAnswerId?: InputMaybe<Scalars['uuid']['input']>;
  policiesId?: InputMaybe<Scalars['uuid']['input']>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "AttachmentBox" */
export type AttachmentBox_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: AttachmentBox_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type AttachmentBox_Stream_Cursor_Value_Input_ = {
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  activityReportId?: InputMaybe<Scalars['uuid']['input']>;
  answerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecatedMetricAnswerId?: InputMaybe<Scalars['uuid']['input']>;
  disclosureRequirementAttachmentId?: InputMaybe<Scalars['uuid']['input']>;
  financialsId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  metricAnswerId?: InputMaybe<Scalars['uuid']['input']>;
  paiAnswerId?: InputMaybe<Scalars['uuid']['input']>;
  policiesId?: InputMaybe<Scalars['uuid']['input']>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "AttachmentBox" */
export enum AttachmentBox_Update_Column_ {
  /** column name */
  ActionId_ = 'actionId',
  /** column name */
  ActivityReportId_ = 'activityReportId',
  /** column name */
  AnswerId_ = 'answerId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeprecatedMetricAnswerId_ = 'deprecatedMetricAnswerId',
  /** column name */
  DisclosureRequirementAttachmentId_ = 'disclosureRequirementAttachmentId',
  /** column name */
  FinancialsId_ = 'financialsId',
  /** column name */
  Id_ = 'id',
  /** column name */
  MaterialStandardId_ = 'materialStandardId',
  /** column name */
  MetricAnswerId_ = 'metricAnswerId',
  /** column name */
  PaiAnswerId_ = 'paiAnswerId',
  /** column name */
  PoliciesId_ = 'policiesId',
  /** column name */
  TargetId_ = 'targetId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type AttachmentBox_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AttachmentBox_Set_Input_>;
  /** filter the rows which have to be updated */
  where: AttachmentBox_Bool_Exp_;
};

/** aggregated selection of "Attachment" */
export type Attachment_Aggregate_ = {
  __typename?: 'Attachment_aggregate';
  aggregate?: Maybe<Attachment_Aggregate_Fields_>;
  nodes: Array<Attachment_>;
};

export type Attachment_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Attachment_Aggregate_Bool_Exp_Count_>;
};

export type Attachment_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Attachment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Attachment_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "Attachment" */
export type Attachment_Aggregate_Fields_ = {
  __typename?: 'Attachment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Attachment_Max_Fields_>;
  min?: Maybe<Attachment_Min_Fields_>;
};


/** aggregate fields of "Attachment" */
export type Attachment_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Attachment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Attachment" */
export type Attachment_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Attachment_Max_Order_By_>;
  min?: InputMaybe<Attachment_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "Attachment" */
export type Attachment_Arr_Rel_Insert_Input_ = {
  data: Array<Attachment_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Attachment_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "Attachment". All fields are combined with a logical 'AND'. */
export type Attachment_Bool_Exp_ = {
  _and?: InputMaybe<Array<Attachment_Bool_Exp_>>;
  _not?: InputMaybe<Attachment_Bool_Exp_>;
  _or?: InputMaybe<Array<Attachment_Bool_Exp_>>;
  attachmentBox?: InputMaybe<AttachmentBox_Bool_Exp_>;
  attachmentBoxId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  file?: InputMaybe<DocumentationFile_Bool_Exp_>;
  fileId?: InputMaybe<Uuid_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Attachment" */
export enum Attachment_Constraint_ {
  /** unique or primary key constraint on columns "attachmentBoxId", "fileId" */
  AttachmentAttachmentBoxIdFileIdKey_ = 'Attachment_attachmentBoxId_fileId_key',
  /** unique or primary key constraint on columns "id" */
  AttachmentPkey_ = 'Attachment_pkey'
}

/** input type for inserting data into table "Attachment" */
export type Attachment_Insert_Input_ = {
  attachmentBox?: InputMaybe<AttachmentBox_Obj_Rel_Insert_Input_>;
  attachmentBoxId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<DocumentationFile_Obj_Rel_Insert_Input_>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Attachment_Max_Fields_ = {
  __typename?: 'Attachment_max_fields';
  attachmentBoxId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "Attachment" */
export type Attachment_Max_Order_By_ = {
  attachmentBoxId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  fileId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Attachment_Min_Fields_ = {
  __typename?: 'Attachment_min_fields';
  attachmentBoxId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "Attachment" */
export type Attachment_Min_Order_By_ = {
  attachmentBoxId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  fileId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "Attachment" */
export type Attachment_Mutation_Response_ = {
  __typename?: 'Attachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Attachment_>;
};

/** on_conflict condition type for table "Attachment" */
export type Attachment_On_Conflict_ = {
  constraint: Attachment_Constraint_;
  update_columns?: Array<Attachment_Update_Column_>;
  where?: InputMaybe<Attachment_Bool_Exp_>;
};

/** Ordering options when selecting data from "Attachment". */
export type Attachment_Order_By_ = {
  attachmentBox?: InputMaybe<AttachmentBox_Order_By_>;
  attachmentBoxId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  file?: InputMaybe<DocumentationFile_Order_By_>;
  fileId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Attachment */
export type Attachment_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "Attachment" */
export enum Attachment_Select_Column_ {
  /** column name */
  AttachmentBoxId_ = 'attachmentBoxId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  FileId_ = 'fileId',
  /** column name */
  Id_ = 'id',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "Attachment" */
export type Attachment_Set_Input_ = {
  attachmentBoxId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "Attachment" */
export type Attachment_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Attachment_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Attachment_Stream_Cursor_Value_Input_ = {
  attachmentBoxId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "Attachment" */
export enum Attachment_Update_Column_ {
  /** column name */
  AttachmentBoxId_ = 'attachmentBoxId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  FileId_ = 'fileId',
  /** column name */
  Id_ = 'id',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Attachment_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Attachment_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Attachment_Bool_Exp_;
};

/** Each row represents an insert/update/delete on any of the tracked tables */
export type AuditLogEntry_ = {
  __typename?: 'AuditLogEntry';
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  invocationId: Scalars['uuid']['output'];
  newData?: Maybe<Scalars['jsonb']['output']>;
  oldData?: Maybe<Scalars['jsonb']['output']>;
  operation: Scalars['String']['output'];
  schema: Scalars['String']['output'];
  table: Scalars['String']['output'];
  timestamp: Scalars['timestamptz']['output'];
  triggerType: TriggerTypes_Enum_;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user?: Maybe<Users_>;
  /** If NULL it means it was created by the system */
  userId?: Maybe<Scalars['uuid']['output']>;
  userRole: Scalars['String']['output'];
};


/** Each row represents an insert/update/delete on any of the tracked tables */
export type AuditLogEntryNewDataArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Each row represents an insert/update/delete on any of the tracked tables */
export type AuditLogEntryOldDataArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "AuditLogEntry" */
export type AuditLogEntry_Aggregate_ = {
  __typename?: 'AuditLogEntry_aggregate';
  aggregate?: Maybe<AuditLogEntry_Aggregate_Fields_>;
  nodes: Array<AuditLogEntry_>;
};

/** aggregate fields of "AuditLogEntry" */
export type AuditLogEntry_Aggregate_Fields_ = {
  __typename?: 'AuditLogEntry_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuditLogEntry_Max_Fields_>;
  min?: Maybe<AuditLogEntry_Min_Fields_>;
};


/** aggregate fields of "AuditLogEntry" */
export type AuditLogEntry_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<AuditLogEntry_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuditLogEntry_Append_Input_ = {
  newData?: InputMaybe<Scalars['jsonb']['input']>;
  oldData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "AuditLogEntry". All fields are combined with a logical 'AND'. */
export type AuditLogEntry_Bool_Exp_ = {
  _and?: InputMaybe<Array<AuditLogEntry_Bool_Exp_>>;
  _not?: InputMaybe<AuditLogEntry_Bool_Exp_>;
  _or?: InputMaybe<Array<AuditLogEntry_Bool_Exp_>>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  invocationId?: InputMaybe<Uuid_Comparison_Exp_>;
  newData?: InputMaybe<Jsonb_Comparison_Exp_>;
  oldData?: InputMaybe<Jsonb_Comparison_Exp_>;
  operation?: InputMaybe<String_Comparison_Exp_>;
  schema?: InputMaybe<String_Comparison_Exp_>;
  table?: InputMaybe<String_Comparison_Exp_>;
  timestamp?: InputMaybe<Timestamptz_Comparison_Exp_>;
  triggerType?: InputMaybe<TriggerTypes_Enum_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  user?: InputMaybe<Users_Bool_Exp_>;
  userId?: InputMaybe<Uuid_Comparison_Exp_>;
  userRole?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "AuditLogEntry" */
export enum AuditLogEntry_Constraint_ {
  /** unique or primary key constraint on columns "invocationId" */
  AuditLogEntryPkey_ = 'AuditLogEntry_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuditLogEntry_Delete_At_Path_Input_ = {
  newData?: InputMaybe<Array<Scalars['String']['input']>>;
  oldData?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuditLogEntry_Delete_Elem_Input_ = {
  newData?: InputMaybe<Scalars['Int']['input']>;
  oldData?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuditLogEntry_Delete_Key_Input_ = {
  newData?: InputMaybe<Scalars['String']['input']>;
  oldData?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "AuditLogEntry" */
export type AuditLogEntry_Insert_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  invocationId?: InputMaybe<Scalars['uuid']['input']>;
  newData?: InputMaybe<Scalars['jsonb']['input']>;
  oldData?: InputMaybe<Scalars['jsonb']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  triggerType?: InputMaybe<TriggerTypes_Enum_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  /** If NULL it means it was created by the system */
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userRole?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AuditLogEntry_Max_Fields_ = {
  __typename?: 'AuditLogEntry_max_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  invocationId?: Maybe<Scalars['uuid']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** If NULL it means it was created by the system */
  userId?: Maybe<Scalars['uuid']['output']>;
  userRole?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuditLogEntry_Min_Fields_ = {
  __typename?: 'AuditLogEntry_min_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  invocationId?: Maybe<Scalars['uuid']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  schema?: Maybe<Scalars['String']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['timestamptz']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** If NULL it means it was created by the system */
  userId?: Maybe<Scalars['uuid']['output']>;
  userRole?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "AuditLogEntry" */
export type AuditLogEntry_Mutation_Response_ = {
  __typename?: 'AuditLogEntry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuditLogEntry_>;
};

/** on_conflict condition type for table "AuditLogEntry" */
export type AuditLogEntry_On_Conflict_ = {
  constraint: AuditLogEntry_Constraint_;
  update_columns?: Array<AuditLogEntry_Update_Column_>;
  where?: InputMaybe<AuditLogEntry_Bool_Exp_>;
};

/** Ordering options when selecting data from "AuditLogEntry". */
export type AuditLogEntry_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  invocationId?: InputMaybe<Order_By_>;
  newData?: InputMaybe<Order_By_>;
  oldData?: InputMaybe<Order_By_>;
  operation?: InputMaybe<Order_By_>;
  schema?: InputMaybe<Order_By_>;
  table?: InputMaybe<Order_By_>;
  timestamp?: InputMaybe<Order_By_>;
  triggerType?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  user?: InputMaybe<Users_Order_By_>;
  userId?: InputMaybe<Order_By_>;
  userRole?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: AuditLogEntry */
export type AuditLogEntry_Pk_Columns_Input_ = {
  invocationId: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuditLogEntry_Prepend_Input_ = {
  newData?: InputMaybe<Scalars['jsonb']['input']>;
  oldData?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "AuditLogEntry" */
export enum AuditLogEntry_Select_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  InvocationId_ = 'invocationId',
  /** column name */
  NewData_ = 'newData',
  /** column name */
  OldData_ = 'oldData',
  /** column name */
  Operation_ = 'operation',
  /** column name */
  Schema_ = 'schema',
  /** column name */
  Table_ = 'table',
  /** column name */
  Timestamp_ = 'timestamp',
  /** column name */
  TriggerType_ = 'triggerType',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UserId_ = 'userId',
  /** column name */
  UserRole_ = 'userRole'
}

/** input type for updating data in table "AuditLogEntry" */
export type AuditLogEntry_Set_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  invocationId?: InputMaybe<Scalars['uuid']['input']>;
  newData?: InputMaybe<Scalars['jsonb']['input']>;
  oldData?: InputMaybe<Scalars['jsonb']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  triggerType?: InputMaybe<TriggerTypes_Enum_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** If NULL it means it was created by the system */
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userRole?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "AuditLogEntry" */
export type AuditLogEntry_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: AuditLogEntry_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type AuditLogEntry_Stream_Cursor_Value_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  invocationId?: InputMaybe<Scalars['uuid']['input']>;
  newData?: InputMaybe<Scalars['jsonb']['input']>;
  oldData?: InputMaybe<Scalars['jsonb']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  schema?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['timestamptz']['input']>;
  triggerType?: InputMaybe<TriggerTypes_Enum_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** If NULL it means it was created by the system */
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userRole?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "AuditLogEntry" */
export enum AuditLogEntry_Update_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  InvocationId_ = 'invocationId',
  /** column name */
  NewData_ = 'newData',
  /** column name */
  OldData_ = 'oldData',
  /** column name */
  Operation_ = 'operation',
  /** column name */
  Schema_ = 'schema',
  /** column name */
  Table_ = 'table',
  /** column name */
  Timestamp_ = 'timestamp',
  /** column name */
  TriggerType_ = 'triggerType',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UserId_ = 'userId',
  /** column name */
  UserRole_ = 'userRole'
}

export type AuditLogEntry_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuditLogEntry_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuditLogEntry_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuditLogEntry_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuditLogEntry_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuditLogEntry_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuditLogEntry_Set_Input_>;
  /** filter the rows which have to be updated */
  where: AuditLogEntry_Bool_Exp_;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp_ = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** columns and relationships of "BusinessUnit" */
export type BusinessUnit_ = {
  __typename?: 'BusinessUnit';
  /** An array relationship */
  bAssessments: Array<BusinessUnitAssessment_>;
  /** An aggregate relationship */
  bAssessments_aggregate: BusinessUnitAssessment_Aggregate_;
  /** An object relationship */
  company: Company_;
  companyId: Scalars['uuid']['output'];
  /** An object relationship */
  contactPerson: Users_;
  contactPersonId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duplicatedFromId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  labels: Scalars['jsonb']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "BusinessUnit" */
export type BusinessUnitBAssessmentsArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnitAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnitAssessment_Order_By_>>;
  where?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
};


/** columns and relationships of "BusinessUnit" */
export type BusinessUnitBAssessments_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnitAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnitAssessment_Order_By_>>;
  where?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
};


/** columns and relationships of "BusinessUnit" */
export type BusinessUnitLabelsArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "BusinessUnitAssessment" */
export type BusinessUnitAssessment_ = {
  __typename?: 'BusinessUnitAssessment';
  /** An array relationship */
  activityReports: Array<ActivityReport_>;
  /** An aggregate relationship */
  activityReports_aggregate: ActivityReport_Aggregate_;
  /** An object relationship */
  businessUnit?: Maybe<BusinessUnit_>;
  /** An object relationship */
  businessUnitAssessmentDuplicate?: Maybe<BusinessUnitAssessment_>;
  businessUnitId?: Maybe<Scalars['uuid']['output']>;
  businessUnitIdNotNull: Scalars['uuid']['output'];
  /** An object relationship */
  cAssessment: CompanyAssessment_;
  cAssessmentId: Scalars['uuid']['output'];
  /** An object relationship */
  cachedResult?: Maybe<CachedResult_>;
  cachedResultId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  duplicatedFrom?: Maybe<Scalars['uuid']['output']>;
  hasGeneralAssessment: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  orderIndex?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  reportingGroup?: Maybe<ReportingGroup_>;
  reportingGroupId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "BusinessUnitAssessment" */
export type BusinessUnitAssessmentActivityReportsArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityReport_Order_By_>>;
  where?: InputMaybe<ActivityReport_Bool_Exp_>;
};


/** columns and relationships of "BusinessUnitAssessment" */
export type BusinessUnitAssessmentActivityReports_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityReport_Order_By_>>;
  where?: InputMaybe<ActivityReport_Bool_Exp_>;
};

/** aggregated selection of "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Aggregate_ = {
  __typename?: 'BusinessUnitAssessment_aggregate';
  aggregate?: Maybe<BusinessUnitAssessment_Aggregate_Fields_>;
  nodes: Array<BusinessUnitAssessment_>;
};

export type BusinessUnitAssessment_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<BusinessUnitAssessment_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<BusinessUnitAssessment_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<BusinessUnitAssessment_Aggregate_Bool_Exp_Count_>;
};

export type BusinessUnitAssessment_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: BusinessUnitAssessment_Select_Column_BusinessUnitAssessment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type BusinessUnitAssessment_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: BusinessUnitAssessment_Select_Column_BusinessUnitAssessment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type BusinessUnitAssessment_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<BusinessUnitAssessment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Aggregate_Fields_ = {
  __typename?: 'BusinessUnitAssessment_aggregate_fields';
  avg?: Maybe<BusinessUnitAssessment_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessUnitAssessment_Max_Fields_>;
  min?: Maybe<BusinessUnitAssessment_Min_Fields_>;
  stddev?: Maybe<BusinessUnitAssessment_Stddev_Fields_>;
  stddev_pop?: Maybe<BusinessUnitAssessment_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<BusinessUnitAssessment_Stddev_Samp_Fields_>;
  sum?: Maybe<BusinessUnitAssessment_Sum_Fields_>;
  var_pop?: Maybe<BusinessUnitAssessment_Var_Pop_Fields_>;
  var_samp?: Maybe<BusinessUnitAssessment_Var_Samp_Fields_>;
  variance?: Maybe<BusinessUnitAssessment_Variance_Fields_>;
};


/** aggregate fields of "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<BusinessUnitAssessment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Aggregate_Order_By_ = {
  avg?: InputMaybe<BusinessUnitAssessment_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<BusinessUnitAssessment_Max_Order_By_>;
  min?: InputMaybe<BusinessUnitAssessment_Min_Order_By_>;
  stddev?: InputMaybe<BusinessUnitAssessment_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<BusinessUnitAssessment_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<BusinessUnitAssessment_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<BusinessUnitAssessment_Sum_Order_By_>;
  var_pop?: InputMaybe<BusinessUnitAssessment_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<BusinessUnitAssessment_Var_Samp_Order_By_>;
  variance?: InputMaybe<BusinessUnitAssessment_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Arr_Rel_Insert_Input_ = {
  data: Array<BusinessUnitAssessment_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<BusinessUnitAssessment_On_Conflict_>;
};

/** aggregate avg on columns */
export type BusinessUnitAssessment_Avg_Fields_ = {
  __typename?: 'BusinessUnitAssessment_avg_fields';
  orderIndex?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Avg_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "BusinessUnitAssessment". All fields are combined with a logical 'AND'. */
export type BusinessUnitAssessment_Bool_Exp_ = {
  _and?: InputMaybe<Array<BusinessUnitAssessment_Bool_Exp_>>;
  _not?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
  _or?: InputMaybe<Array<BusinessUnitAssessment_Bool_Exp_>>;
  activityReports?: InputMaybe<ActivityReport_Bool_Exp_>;
  activityReports_aggregate?: InputMaybe<ActivityReport_Aggregate_Bool_Exp_>;
  businessUnit?: InputMaybe<BusinessUnit_Bool_Exp_>;
  businessUnitAssessmentDuplicate?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
  businessUnitId?: InputMaybe<Uuid_Comparison_Exp_>;
  businessUnitIdNotNull?: InputMaybe<Uuid_Comparison_Exp_>;
  cAssessment?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  cAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  cachedResult?: InputMaybe<CachedResult_Bool_Exp_>;
  cachedResultId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  duplicatedFrom?: InputMaybe<Uuid_Comparison_Exp_>;
  hasGeneralAssessment?: InputMaybe<Boolean_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  orderIndex?: InputMaybe<Numeric_Comparison_Exp_>;
  reportingGroup?: InputMaybe<ReportingGroup_Bool_Exp_>;
  reportingGroupId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "BusinessUnitAssessment" */
export enum BusinessUnitAssessment_Constraint_ {
  /** unique or primary key constraint on columns "cAssessmentId", "businessUnitIdNotNull" */
  BusinessUnitAssessmentCAssessmentIdBusinessUnitIdN_8db61b88U_ = 'BusinessUnitAssessment_cAssessmentId_businessUnitIdN_8db61b88_u',
  /** unique or primary key constraint on columns "id" */
  BusinessUnitAssessmentPkey_ = 'BusinessUnitAssessment_pkey'
}

/** input type for incrementing numeric columns in table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Inc_Input_ = {
  orderIndex?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Insert_Input_ = {
  activityReports?: InputMaybe<ActivityReport_Arr_Rel_Insert_Input_>;
  businessUnit?: InputMaybe<BusinessUnit_Obj_Rel_Insert_Input_>;
  businessUnitAssessmentDuplicate?: InputMaybe<BusinessUnitAssessment_Obj_Rel_Insert_Input_>;
  businessUnitId?: InputMaybe<Scalars['uuid']['input']>;
  businessUnitIdNotNull?: InputMaybe<Scalars['uuid']['input']>;
  cAssessment?: InputMaybe<CompanyAssessment_Obj_Rel_Insert_Input_>;
  cAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  cachedResult?: InputMaybe<CachedResult_Obj_Rel_Insert_Input_>;
  cachedResultId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  duplicatedFrom?: InputMaybe<Scalars['uuid']['input']>;
  hasGeneralAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  orderIndex?: InputMaybe<Scalars['numeric']['input']>;
  reportingGroup?: InputMaybe<ReportingGroup_Obj_Rel_Insert_Input_>;
  reportingGroupId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type BusinessUnitAssessment_Max_Fields_ = {
  __typename?: 'BusinessUnitAssessment_max_fields';
  businessUnitId?: Maybe<Scalars['uuid']['output']>;
  businessUnitIdNotNull?: Maybe<Scalars['uuid']['output']>;
  cAssessmentId?: Maybe<Scalars['uuid']['output']>;
  cachedResultId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  duplicatedFrom?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  orderIndex?: Maybe<Scalars['numeric']['output']>;
  reportingGroupId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Max_Order_By_ = {
  businessUnitId?: InputMaybe<Order_By_>;
  businessUnitIdNotNull?: InputMaybe<Order_By_>;
  cAssessmentId?: InputMaybe<Order_By_>;
  cachedResultId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  duplicatedFrom?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  orderIndex?: InputMaybe<Order_By_>;
  reportingGroupId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type BusinessUnitAssessment_Min_Fields_ = {
  __typename?: 'BusinessUnitAssessment_min_fields';
  businessUnitId?: Maybe<Scalars['uuid']['output']>;
  businessUnitIdNotNull?: Maybe<Scalars['uuid']['output']>;
  cAssessmentId?: Maybe<Scalars['uuid']['output']>;
  cachedResultId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  duplicatedFrom?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  orderIndex?: Maybe<Scalars['numeric']['output']>;
  reportingGroupId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Min_Order_By_ = {
  businessUnitId?: InputMaybe<Order_By_>;
  businessUnitIdNotNull?: InputMaybe<Order_By_>;
  cAssessmentId?: InputMaybe<Order_By_>;
  cachedResultId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  duplicatedFrom?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  orderIndex?: InputMaybe<Order_By_>;
  reportingGroupId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Mutation_Response_ = {
  __typename?: 'BusinessUnitAssessment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessUnitAssessment_>;
};

/** input type for inserting object relation for remote table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Obj_Rel_Insert_Input_ = {
  data: BusinessUnitAssessment_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<BusinessUnitAssessment_On_Conflict_>;
};

/** on_conflict condition type for table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_On_Conflict_ = {
  constraint: BusinessUnitAssessment_Constraint_;
  update_columns?: Array<BusinessUnitAssessment_Update_Column_>;
  where?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
};

/** Ordering options when selecting data from "BusinessUnitAssessment". */
export type BusinessUnitAssessment_Order_By_ = {
  activityReports_aggregate?: InputMaybe<ActivityReport_Aggregate_Order_By_>;
  businessUnit?: InputMaybe<BusinessUnit_Order_By_>;
  businessUnitAssessmentDuplicate?: InputMaybe<BusinessUnitAssessment_Order_By_>;
  businessUnitId?: InputMaybe<Order_By_>;
  businessUnitIdNotNull?: InputMaybe<Order_By_>;
  cAssessment?: InputMaybe<CompanyAssessment_Order_By_>;
  cAssessmentId?: InputMaybe<Order_By_>;
  cachedResult?: InputMaybe<CachedResult_Order_By_>;
  cachedResultId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  duplicatedFrom?: InputMaybe<Order_By_>;
  hasGeneralAssessment?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  orderIndex?: InputMaybe<Order_By_>;
  reportingGroup?: InputMaybe<ReportingGroup_Order_By_>;
  reportingGroupId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: BusinessUnitAssessment */
export type BusinessUnitAssessment_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "BusinessUnitAssessment" */
export enum BusinessUnitAssessment_Select_Column_ {
  /** column name */
  BusinessUnitId_ = 'businessUnitId',
  /** column name */
  BusinessUnitIdNotNull_ = 'businessUnitIdNotNull',
  /** column name */
  CAssessmentId_ = 'cAssessmentId',
  /** column name */
  CachedResultId_ = 'cachedResultId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  DuplicatedFrom_ = 'duplicatedFrom',
  /** column name */
  HasGeneralAssessment_ = 'hasGeneralAssessment',
  /** column name */
  Id_ = 'id',
  /** column name */
  OrderIndex_ = 'orderIndex',
  /** column name */
  ReportingGroupId_ = 'reportingGroupId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "BusinessUnitAssessment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "BusinessUnitAssessment" */
export enum BusinessUnitAssessment_Select_Column_BusinessUnitAssessment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  HasGeneralAssessment_ = 'hasGeneralAssessment'
}

/** select "BusinessUnitAssessment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "BusinessUnitAssessment" */
export enum BusinessUnitAssessment_Select_Column_BusinessUnitAssessment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  HasGeneralAssessment_ = 'hasGeneralAssessment'
}

/** input type for updating data in table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Set_Input_ = {
  businessUnitId?: InputMaybe<Scalars['uuid']['input']>;
  businessUnitIdNotNull?: InputMaybe<Scalars['uuid']['input']>;
  cAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  cachedResultId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  duplicatedFrom?: InputMaybe<Scalars['uuid']['input']>;
  hasGeneralAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  orderIndex?: InputMaybe<Scalars['numeric']['input']>;
  reportingGroupId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type BusinessUnitAssessment_Stddev_Fields_ = {
  __typename?: 'BusinessUnitAssessment_stddev_fields';
  orderIndex?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Stddev_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type BusinessUnitAssessment_Stddev_Pop_Fields_ = {
  __typename?: 'BusinessUnitAssessment_stddev_pop_fields';
  orderIndex?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Stddev_Pop_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type BusinessUnitAssessment_Stddev_Samp_Fields_ = {
  __typename?: 'BusinessUnitAssessment_stddev_samp_fields';
  orderIndex?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Stddev_Samp_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: BusinessUnitAssessment_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessUnitAssessment_Stream_Cursor_Value_Input_ = {
  businessUnitId?: InputMaybe<Scalars['uuid']['input']>;
  businessUnitIdNotNull?: InputMaybe<Scalars['uuid']['input']>;
  cAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  cachedResultId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  duplicatedFrom?: InputMaybe<Scalars['uuid']['input']>;
  hasGeneralAssessment?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  orderIndex?: InputMaybe<Scalars['numeric']['input']>;
  reportingGroupId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type BusinessUnitAssessment_Sum_Fields_ = {
  __typename?: 'BusinessUnitAssessment_sum_fields';
  orderIndex?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Sum_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

/** update columns of table "BusinessUnitAssessment" */
export enum BusinessUnitAssessment_Update_Column_ {
  /** column name */
  BusinessUnitId_ = 'businessUnitId',
  /** column name */
  BusinessUnitIdNotNull_ = 'businessUnitIdNotNull',
  /** column name */
  CAssessmentId_ = 'cAssessmentId',
  /** column name */
  CachedResultId_ = 'cachedResultId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  DuplicatedFrom_ = 'duplicatedFrom',
  /** column name */
  HasGeneralAssessment_ = 'hasGeneralAssessment',
  /** column name */
  Id_ = 'id',
  /** column name */
  OrderIndex_ = 'orderIndex',
  /** column name */
  ReportingGroupId_ = 'reportingGroupId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type BusinessUnitAssessment_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<BusinessUnitAssessment_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessUnitAssessment_Set_Input_>;
  /** filter the rows which have to be updated */
  where: BusinessUnitAssessment_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type BusinessUnitAssessment_Var_Pop_Fields_ = {
  __typename?: 'BusinessUnitAssessment_var_pop_fields';
  orderIndex?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Var_Pop_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type BusinessUnitAssessment_Var_Samp_Fields_ = {
  __typename?: 'BusinessUnitAssessment_var_samp_fields';
  orderIndex?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Var_Samp_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type BusinessUnitAssessment_Variance_Fields_ = {
  __typename?: 'BusinessUnitAssessment_variance_fields';
  orderIndex?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "BusinessUnitAssessment" */
export type BusinessUnitAssessment_Variance_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

/** aggregated selection of "BusinessUnit" */
export type BusinessUnit_Aggregate_ = {
  __typename?: 'BusinessUnit_aggregate';
  aggregate?: Maybe<BusinessUnit_Aggregate_Fields_>;
  nodes: Array<BusinessUnit_>;
};

export type BusinessUnit_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<BusinessUnit_Aggregate_Bool_Exp_Count_>;
};

export type BusinessUnit_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<BusinessUnit_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BusinessUnit_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "BusinessUnit" */
export type BusinessUnit_Aggregate_Fields_ = {
  __typename?: 'BusinessUnit_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<BusinessUnit_Max_Fields_>;
  min?: Maybe<BusinessUnit_Min_Fields_>;
};


/** aggregate fields of "BusinessUnit" */
export type BusinessUnit_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<BusinessUnit_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "BusinessUnit" */
export type BusinessUnit_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<BusinessUnit_Max_Order_By_>;
  min?: InputMaybe<BusinessUnit_Min_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BusinessUnit_Append_Input_ = {
  labels?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "BusinessUnit" */
export type BusinessUnit_Arr_Rel_Insert_Input_ = {
  data: Array<BusinessUnit_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<BusinessUnit_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "BusinessUnit". All fields are combined with a logical 'AND'. */
export type BusinessUnit_Bool_Exp_ = {
  _and?: InputMaybe<Array<BusinessUnit_Bool_Exp_>>;
  _not?: InputMaybe<BusinessUnit_Bool_Exp_>;
  _or?: InputMaybe<Array<BusinessUnit_Bool_Exp_>>;
  bAssessments?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
  bAssessments_aggregate?: InputMaybe<BusinessUnitAssessment_Aggregate_Bool_Exp_>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  contactPerson?: InputMaybe<Users_Bool_Exp_>;
  contactPersonId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  description?: InputMaybe<String_Comparison_Exp_>;
  duplicatedFromId?: InputMaybe<Uuid_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  labels?: InputMaybe<Jsonb_Comparison_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "BusinessUnit" */
export enum BusinessUnit_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  BusinessUnitPkey_ = 'businessUnit_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BusinessUnit_Delete_At_Path_Input_ = {
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BusinessUnit_Delete_Elem_Input_ = {
  labels?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BusinessUnit_Delete_Key_Input_ = {
  labels?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "BusinessUnit" */
export type BusinessUnit_Insert_Input_ = {
  bAssessments?: InputMaybe<BusinessUnitAssessment_Arr_Rel_Insert_Input_>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  contactPerson?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  contactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duplicatedFromId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labels?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type BusinessUnit_Max_Fields_ = {
  __typename?: 'BusinessUnit_max_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  contactPersonId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duplicatedFromId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "BusinessUnit" */
export type BusinessUnit_Max_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  contactPersonId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  duplicatedFromId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type BusinessUnit_Min_Fields_ = {
  __typename?: 'BusinessUnit_min_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  contactPersonId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duplicatedFromId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "BusinessUnit" */
export type BusinessUnit_Min_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  contactPersonId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  duplicatedFromId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "BusinessUnit" */
export type BusinessUnit_Mutation_Response_ = {
  __typename?: 'BusinessUnit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BusinessUnit_>;
};

/** input type for inserting object relation for remote table "BusinessUnit" */
export type BusinessUnit_Obj_Rel_Insert_Input_ = {
  data: BusinessUnit_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<BusinessUnit_On_Conflict_>;
};

/** on_conflict condition type for table "BusinessUnit" */
export type BusinessUnit_On_Conflict_ = {
  constraint: BusinessUnit_Constraint_;
  update_columns?: Array<BusinessUnit_Update_Column_>;
  where?: InputMaybe<BusinessUnit_Bool_Exp_>;
};

/** Ordering options when selecting data from "BusinessUnit". */
export type BusinessUnit_Order_By_ = {
  bAssessments_aggregate?: InputMaybe<BusinessUnitAssessment_Aggregate_Order_By_>;
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  contactPerson?: InputMaybe<Users_Order_By_>;
  contactPersonId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  duplicatedFromId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  labels?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: BusinessUnit */
export type BusinessUnit_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BusinessUnit_Prepend_Input_ = {
  labels?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "BusinessUnit" */
export enum BusinessUnit_Select_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  ContactPersonId_ = 'contactPersonId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  DuplicatedFromId_ = 'duplicatedFromId',
  /** column name */
  Id_ = 'id',
  /** column name */
  Labels_ = 'labels',
  /** column name */
  Name_ = 'name',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "BusinessUnit" */
export type BusinessUnit_Set_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  contactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duplicatedFromId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labels?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "BusinessUnit" */
export type BusinessUnit_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: BusinessUnit_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type BusinessUnit_Stream_Cursor_Value_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  contactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duplicatedFromId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  labels?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "BusinessUnit" */
export enum BusinessUnit_Update_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  ContactPersonId_ = 'contactPersonId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  DuplicatedFromId_ = 'duplicatedFromId',
  /** column name */
  Id_ = 'id',
  /** column name */
  Labels_ = 'labels',
  /** column name */
  Name_ = 'name',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type BusinessUnit_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BusinessUnit_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<BusinessUnit_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<BusinessUnit_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<BusinessUnit_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BusinessUnit_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BusinessUnit_Set_Input_>;
  /** filter the rows which have to be updated */
  where: BusinessUnit_Bool_Exp_;
};

/** Calculated and cached result for assessments. */
export type CachedResult_ = {
  __typename?: 'CachedResult';
  /** An object relationship */
  Company?: Maybe<Company_>;
  /** An object relationship */
  activity?: Maybe<Activity_>;
  activityRef?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  activityReports: Array<ActivityReport_>;
  /** An aggregate relationship */
  activityReports_aggregate: ActivityReport_Aggregate_;
  activityTag?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  activityVersion?: Maybe<ActivityVersion_>;
  activityVersionNumber?: Maybe<Scalars['Int']['output']>;
  /** An array relationship */
  bAssessments: Array<BusinessUnitAssessment_>;
  /** An aggregate relationship */
  bAssessments_aggregate: BusinessUnitAssessment_Aggregate_;
  /** An array relationship */
  cAssessments: Array<CompanyAssessment_>;
  /** An aggregate relationship */
  cAssessments_aggregate: CompanyAssessment_Aggregate_;
  companyId?: Maybe<Scalars['uuid']['output']>;
  financials: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  isAligned?: Maybe<Scalars['Boolean']['output']>;
  isCompleted: Scalars['Boolean']['output'];
  isDirty?: Maybe<Scalars['Boolean']['output']>;
  objectivesState: Scalars['jsonb']['output'];
  progress: Scalars['jsonb']['output'];
  score: Scalars['jsonb']['output'];
  status?: Maybe<Scalars['String']['output']>;
};


/** Calculated and cached result for assessments. */
export type CachedResultActivityReportsArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityReport_Order_By_>>;
  where?: InputMaybe<ActivityReport_Bool_Exp_>;
};


/** Calculated and cached result for assessments. */
export type CachedResultActivityReports_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityReport_Order_By_>>;
  where?: InputMaybe<ActivityReport_Bool_Exp_>;
};


/** Calculated and cached result for assessments. */
export type CachedResultBAssessmentsArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnitAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnitAssessment_Order_By_>>;
  where?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
};


/** Calculated and cached result for assessments. */
export type CachedResultBAssessments_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnitAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnitAssessment_Order_By_>>;
  where?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
};


/** Calculated and cached result for assessments. */
export type CachedResultCAssessmentsArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessment_Order_By_>>;
  where?: InputMaybe<CompanyAssessment_Bool_Exp_>;
};


/** Calculated and cached result for assessments. */
export type CachedResultCAssessments_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessment_Order_By_>>;
  where?: InputMaybe<CompanyAssessment_Bool_Exp_>;
};


/** Calculated and cached result for assessments. */
export type CachedResultFinancialsArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Calculated and cached result for assessments. */
export type CachedResultObjectivesStateArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Calculated and cached result for assessments. */
export type CachedResultProgressArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Calculated and cached result for assessments. */
export type CachedResultScoreArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "CachedResult" */
export type CachedResult_Aggregate_ = {
  __typename?: 'CachedResult_aggregate';
  aggregate?: Maybe<CachedResult_Aggregate_Fields_>;
  nodes: Array<CachedResult_>;
};

/** aggregate fields of "CachedResult" */
export type CachedResult_Aggregate_Fields_ = {
  __typename?: 'CachedResult_aggregate_fields';
  avg?: Maybe<CachedResult_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<CachedResult_Max_Fields_>;
  min?: Maybe<CachedResult_Min_Fields_>;
  stddev?: Maybe<CachedResult_Stddev_Fields_>;
  stddev_pop?: Maybe<CachedResult_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<CachedResult_Stddev_Samp_Fields_>;
  sum?: Maybe<CachedResult_Sum_Fields_>;
  var_pop?: Maybe<CachedResult_Var_Pop_Fields_>;
  var_samp?: Maybe<CachedResult_Var_Samp_Fields_>;
  variance?: Maybe<CachedResult_Variance_Fields_>;
};


/** aggregate fields of "CachedResult" */
export type CachedResult_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<CachedResult_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CachedResult_Append_Input_ = {
  financials?: InputMaybe<Scalars['jsonb']['input']>;
  objectivesState?: InputMaybe<Scalars['jsonb']['input']>;
  progress?: InputMaybe<Scalars['jsonb']['input']>;
  score?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type CachedResult_Avg_Fields_ = {
  __typename?: 'CachedResult_avg_fields';
  activityVersionNumber?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "CachedResult". All fields are combined with a logical 'AND'. */
export type CachedResult_Bool_Exp_ = {
  Company?: InputMaybe<Company_Bool_Exp_>;
  _and?: InputMaybe<Array<CachedResult_Bool_Exp_>>;
  _not?: InputMaybe<CachedResult_Bool_Exp_>;
  _or?: InputMaybe<Array<CachedResult_Bool_Exp_>>;
  activity?: InputMaybe<Activity_Bool_Exp_>;
  activityRef?: InputMaybe<String_Comparison_Exp_>;
  activityReports?: InputMaybe<ActivityReport_Bool_Exp_>;
  activityReports_aggregate?: InputMaybe<ActivityReport_Aggregate_Bool_Exp_>;
  activityTag?: InputMaybe<String_Comparison_Exp_>;
  activityVersion?: InputMaybe<ActivityVersion_Bool_Exp_>;
  activityVersionNumber?: InputMaybe<Int_Comparison_Exp_>;
  bAssessments?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
  bAssessments_aggregate?: InputMaybe<BusinessUnitAssessment_Aggregate_Bool_Exp_>;
  cAssessments?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  cAssessments_aggregate?: InputMaybe<CompanyAssessment_Aggregate_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  financials?: InputMaybe<Jsonb_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isAligned?: InputMaybe<Boolean_Comparison_Exp_>;
  isCompleted?: InputMaybe<Boolean_Comparison_Exp_>;
  isDirty?: InputMaybe<Boolean_Comparison_Exp_>;
  objectivesState?: InputMaybe<Jsonb_Comparison_Exp_>;
  progress?: InputMaybe<Jsonb_Comparison_Exp_>;
  score?: InputMaybe<Jsonb_Comparison_Exp_>;
  status?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "CachedResult" */
export enum CachedResult_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  CachedResultPkey_ = 'CachedResult_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CachedResult_Delete_At_Path_Input_ = {
  financials?: InputMaybe<Array<Scalars['String']['input']>>;
  objectivesState?: InputMaybe<Array<Scalars['String']['input']>>;
  progress?: InputMaybe<Array<Scalars['String']['input']>>;
  score?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CachedResult_Delete_Elem_Input_ = {
  financials?: InputMaybe<Scalars['Int']['input']>;
  objectivesState?: InputMaybe<Scalars['Int']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CachedResult_Delete_Key_Input_ = {
  financials?: InputMaybe<Scalars['String']['input']>;
  objectivesState?: InputMaybe<Scalars['String']['input']>;
  progress?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "CachedResult" */
export type CachedResult_Inc_Input_ = {
  activityVersionNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "CachedResult" */
export type CachedResult_Insert_Input_ = {
  Company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  activity?: InputMaybe<Activity_Obj_Rel_Insert_Input_>;
  activityRef?: InputMaybe<Scalars['String']['input']>;
  activityReports?: InputMaybe<ActivityReport_Arr_Rel_Insert_Input_>;
  activityTag?: InputMaybe<Scalars['String']['input']>;
  activityVersion?: InputMaybe<ActivityVersion_Obj_Rel_Insert_Input_>;
  activityVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  bAssessments?: InputMaybe<BusinessUnitAssessment_Arr_Rel_Insert_Input_>;
  cAssessments?: InputMaybe<CompanyAssessment_Arr_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  financials?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAligned?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isDirty?: InputMaybe<Scalars['Boolean']['input']>;
  objectivesState?: InputMaybe<Scalars['jsonb']['input']>;
  progress?: InputMaybe<Scalars['jsonb']['input']>;
  score?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CachedResult_Max_Fields_ = {
  __typename?: 'CachedResult_max_fields';
  activityRef?: Maybe<Scalars['String']['output']>;
  activityTag?: Maybe<Scalars['String']['output']>;
  activityVersionNumber?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CachedResult_Min_Fields_ = {
  __typename?: 'CachedResult_min_fields';
  activityRef?: Maybe<Scalars['String']['output']>;
  activityTag?: Maybe<Scalars['String']['output']>;
  activityVersionNumber?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "CachedResult" */
export type CachedResult_Mutation_Response_ = {
  __typename?: 'CachedResult_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CachedResult_>;
};

/** input type for inserting object relation for remote table "CachedResult" */
export type CachedResult_Obj_Rel_Insert_Input_ = {
  data: CachedResult_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<CachedResult_On_Conflict_>;
};

/** on_conflict condition type for table "CachedResult" */
export type CachedResult_On_Conflict_ = {
  constraint: CachedResult_Constraint_;
  update_columns?: Array<CachedResult_Update_Column_>;
  where?: InputMaybe<CachedResult_Bool_Exp_>;
};

/** Ordering options when selecting data from "CachedResult". */
export type CachedResult_Order_By_ = {
  Company?: InputMaybe<Company_Order_By_>;
  activity?: InputMaybe<Activity_Order_By_>;
  activityRef?: InputMaybe<Order_By_>;
  activityReports_aggregate?: InputMaybe<ActivityReport_Aggregate_Order_By_>;
  activityTag?: InputMaybe<Order_By_>;
  activityVersion?: InputMaybe<ActivityVersion_Order_By_>;
  activityVersionNumber?: InputMaybe<Order_By_>;
  bAssessments_aggregate?: InputMaybe<BusinessUnitAssessment_Aggregate_Order_By_>;
  cAssessments_aggregate?: InputMaybe<CompanyAssessment_Aggregate_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  financials?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isAligned?: InputMaybe<Order_By_>;
  isCompleted?: InputMaybe<Order_By_>;
  isDirty?: InputMaybe<Order_By_>;
  objectivesState?: InputMaybe<Order_By_>;
  progress?: InputMaybe<Order_By_>;
  score?: InputMaybe<Order_By_>;
  status?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: CachedResult */
export type CachedResult_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CachedResult_Prepend_Input_ = {
  financials?: InputMaybe<Scalars['jsonb']['input']>;
  objectivesState?: InputMaybe<Scalars['jsonb']['input']>;
  progress?: InputMaybe<Scalars['jsonb']['input']>;
  score?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "CachedResult" */
export enum CachedResult_Select_Column_ {
  /** column name */
  ActivityRef_ = 'activityRef',
  /** column name */
  ActivityTag_ = 'activityTag',
  /** column name */
  ActivityVersionNumber_ = 'activityVersionNumber',
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  Financials_ = 'financials',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsAligned_ = 'isAligned',
  /** column name */
  IsCompleted_ = 'isCompleted',
  /** column name */
  IsDirty_ = 'isDirty',
  /** column name */
  ObjectivesState_ = 'objectivesState',
  /** column name */
  Progress_ = 'progress',
  /** column name */
  Score_ = 'score',
  /** column name */
  Status_ = 'status'
}

/** input type for updating data in table "CachedResult" */
export type CachedResult_Set_Input_ = {
  activityRef?: InputMaybe<Scalars['String']['input']>;
  activityTag?: InputMaybe<Scalars['String']['input']>;
  activityVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  financials?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAligned?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isDirty?: InputMaybe<Scalars['Boolean']['input']>;
  objectivesState?: InputMaybe<Scalars['jsonb']['input']>;
  progress?: InputMaybe<Scalars['jsonb']['input']>;
  score?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type CachedResult_Stddev_Fields_ = {
  __typename?: 'CachedResult_stddev_fields';
  activityVersionNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type CachedResult_Stddev_Pop_Fields_ = {
  __typename?: 'CachedResult_stddev_pop_fields';
  activityVersionNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type CachedResult_Stddev_Samp_Fields_ = {
  __typename?: 'CachedResult_stddev_samp_fields';
  activityVersionNumber?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "CachedResult" */
export type CachedResult_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: CachedResult_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type CachedResult_Stream_Cursor_Value_Input_ = {
  activityRef?: InputMaybe<Scalars['String']['input']>;
  activityTag?: InputMaybe<Scalars['String']['input']>;
  activityVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  financials?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAligned?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isDirty?: InputMaybe<Scalars['Boolean']['input']>;
  objectivesState?: InputMaybe<Scalars['jsonb']['input']>;
  progress?: InputMaybe<Scalars['jsonb']['input']>;
  score?: InputMaybe<Scalars['jsonb']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type CachedResult_Sum_Fields_ = {
  __typename?: 'CachedResult_sum_fields';
  activityVersionNumber?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "CachedResult" */
export enum CachedResult_Update_Column_ {
  /** column name */
  ActivityRef_ = 'activityRef',
  /** column name */
  ActivityTag_ = 'activityTag',
  /** column name */
  ActivityVersionNumber_ = 'activityVersionNumber',
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  Financials_ = 'financials',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsAligned_ = 'isAligned',
  /** column name */
  IsCompleted_ = 'isCompleted',
  /** column name */
  IsDirty_ = 'isDirty',
  /** column name */
  ObjectivesState_ = 'objectivesState',
  /** column name */
  Progress_ = 'progress',
  /** column name */
  Score_ = 'score',
  /** column name */
  Status_ = 'status'
}

export type CachedResult_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CachedResult_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CachedResult_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CachedResult_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CachedResult_Delete_Key_Input_>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CachedResult_Inc_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CachedResult_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CachedResult_Set_Input_>;
  /** filter the rows which have to be updated */
  where: CachedResult_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type CachedResult_Var_Pop_Fields_ = {
  __typename?: 'CachedResult_var_pop_fields';
  activityVersionNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type CachedResult_Var_Samp_Fields_ = {
  __typename?: 'CachedResult_var_samp_fields';
  activityVersionNumber?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type CachedResult_Variance_Fields_ = {
  __typename?: 'CachedResult_variance_fields';
  activityVersionNumber?: Maybe<Scalars['Float']['output']>;
};

export type Capex_ = {
  __typename?: 'Capex';
  aligned?: Maybe<Scalars['Float']['output']>;
  eligible?: Maybe<Scalars['Float']['output']>;
  enabling?: Maybe<Scalars['Float']['output']>;
  inProgress?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  transitional?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "esrs.ChoiceSet" */
export type ChoiceSet_ = {
  __typename?: 'ChoiceSet';
  /** An array relationship */
  actionQuestions: Array<ActionQuestion_>;
  /** An aggregate relationship */
  actionQuestions_aggregate: ActionQuestion_Aggregate_;
  /** An array relationship */
  choices: Array<EsrsChoice_>;
  /** An aggregate relationship */
  choices_aggregate: EsrsChoice_Aggregate_;
  /** An array relationship */
  metrics: Array<EsrsMetric_>;
  /** An aggregate relationship */
  metrics_aggregate: EsrsMetric_Aggregate_;
  /** An array relationship */
  targetQuestions: Array<TargetQuestion_>;
  /** An aggregate relationship */
  targetQuestions_aggregate: TargetQuestion_Aggregate_;
  title: Scalars['String']['output'];
};


/** columns and relationships of "esrs.ChoiceSet" */
export type ChoiceSetActionQuestionsArgs_ = {
  distinct_on?: InputMaybe<Array<ActionQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestion_Order_By_>>;
  where?: InputMaybe<ActionQuestion_Bool_Exp_>;
};


/** columns and relationships of "esrs.ChoiceSet" */
export type ChoiceSetActionQuestions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActionQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestion_Order_By_>>;
  where?: InputMaybe<ActionQuestion_Bool_Exp_>;
};


/** columns and relationships of "esrs.ChoiceSet" */
export type ChoiceSetChoicesArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsChoice_Order_By_>>;
  where?: InputMaybe<EsrsChoice_Bool_Exp_>;
};


/** columns and relationships of "esrs.ChoiceSet" */
export type ChoiceSetChoices_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsChoice_Order_By_>>;
  where?: InputMaybe<EsrsChoice_Bool_Exp_>;
};


/** columns and relationships of "esrs.ChoiceSet" */
export type ChoiceSetMetricsArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetric_Order_By_>>;
  where?: InputMaybe<EsrsMetric_Bool_Exp_>;
};


/** columns and relationships of "esrs.ChoiceSet" */
export type ChoiceSetMetrics_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetric_Order_By_>>;
  where?: InputMaybe<EsrsMetric_Bool_Exp_>;
};


/** columns and relationships of "esrs.ChoiceSet" */
export type ChoiceSetTargetQuestionsArgs_ = {
  distinct_on?: InputMaybe<Array<TargetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestion_Order_By_>>;
  where?: InputMaybe<TargetQuestion_Bool_Exp_>;
};


/** columns and relationships of "esrs.ChoiceSet" */
export type ChoiceSetTargetQuestions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TargetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestion_Order_By_>>;
  where?: InputMaybe<TargetQuestion_Bool_Exp_>;
};

/** aggregated selection of "esrs.ChoiceSet" */
export type ChoiceSet_Aggregate_ = {
  __typename?: 'ChoiceSet_aggregate';
  aggregate?: Maybe<ChoiceSet_Aggregate_Fields_>;
  nodes: Array<ChoiceSet_>;
};

/** aggregate fields of "esrs.ChoiceSet" */
export type ChoiceSet_Aggregate_Fields_ = {
  __typename?: 'ChoiceSet_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ChoiceSet_Max_Fields_>;
  min?: Maybe<ChoiceSet_Min_Fields_>;
};


/** aggregate fields of "esrs.ChoiceSet" */
export type ChoiceSet_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<ChoiceSet_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "esrs.ChoiceSet". All fields are combined with a logical 'AND'. */
export type ChoiceSet_Bool_Exp_ = {
  _and?: InputMaybe<Array<ChoiceSet_Bool_Exp_>>;
  _not?: InputMaybe<ChoiceSet_Bool_Exp_>;
  _or?: InputMaybe<Array<ChoiceSet_Bool_Exp_>>;
  actionQuestions?: InputMaybe<ActionQuestion_Bool_Exp_>;
  actionQuestions_aggregate?: InputMaybe<ActionQuestion_Aggregate_Bool_Exp_>;
  choices?: InputMaybe<EsrsChoice_Bool_Exp_>;
  choices_aggregate?: InputMaybe<EsrsChoice_Aggregate_Bool_Exp_>;
  metrics?: InputMaybe<EsrsMetric_Bool_Exp_>;
  metrics_aggregate?: InputMaybe<EsrsMetric_Aggregate_Bool_Exp_>;
  targetQuestions?: InputMaybe<TargetQuestion_Bool_Exp_>;
  targetQuestions_aggregate?: InputMaybe<TargetQuestion_Aggregate_Bool_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.ChoiceSet" */
export enum ChoiceSet_Constraint_ {
  /** unique or primary key constraint on columns "title" */
  ChoiceSetPkey_ = 'ChoiceSet_pkey'
}

/** input type for inserting data into table "esrs.ChoiceSet" */
export type ChoiceSet_Insert_Input_ = {
  actionQuestions?: InputMaybe<ActionQuestion_Arr_Rel_Insert_Input_>;
  choices?: InputMaybe<EsrsChoice_Arr_Rel_Insert_Input_>;
  metrics?: InputMaybe<EsrsMetric_Arr_Rel_Insert_Input_>;
  targetQuestions?: InputMaybe<TargetQuestion_Arr_Rel_Insert_Input_>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type ChoiceSet_Max_Fields_ = {
  __typename?: 'ChoiceSet_max_fields';
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type ChoiceSet_Min_Fields_ = {
  __typename?: 'ChoiceSet_min_fields';
  title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "esrs.ChoiceSet" */
export type ChoiceSet_Mutation_Response_ = {
  __typename?: 'ChoiceSet_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ChoiceSet_>;
};

/** input type for inserting object relation for remote table "esrs.ChoiceSet" */
export type ChoiceSet_Obj_Rel_Insert_Input_ = {
  data: ChoiceSet_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<ChoiceSet_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.ChoiceSet" */
export type ChoiceSet_On_Conflict_ = {
  constraint: ChoiceSet_Constraint_;
  update_columns?: Array<ChoiceSet_Update_Column_>;
  where?: InputMaybe<ChoiceSet_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.ChoiceSet". */
export type ChoiceSet_Order_By_ = {
  actionQuestions_aggregate?: InputMaybe<ActionQuestion_Aggregate_Order_By_>;
  choices_aggregate?: InputMaybe<EsrsChoice_Aggregate_Order_By_>;
  metrics_aggregate?: InputMaybe<EsrsMetric_Aggregate_Order_By_>;
  targetQuestions_aggregate?: InputMaybe<TargetQuestion_Aggregate_Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.ChoiceSet */
export type ChoiceSet_Pk_Columns_Input_ = {
  title: Scalars['String']['input'];
};

/** select columns of table "esrs.ChoiceSet" */
export enum ChoiceSet_Select_Column_ {
  /** column name */
  Title_ = 'title'
}

/** input type for updating data in table "esrs.ChoiceSet" */
export type ChoiceSet_Set_Input_ = {
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "ChoiceSet" */
export type ChoiceSet_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: ChoiceSet_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type ChoiceSet_Stream_Cursor_Value_Input_ = {
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.ChoiceSet" */
export enum ChoiceSet_Update_Column_ {
  /** column name */
  Title_ = 'title'
}

export type ChoiceSet_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChoiceSet_Set_Input_>;
  /** filter the rows which have to be updated */
  where: ChoiceSet_Bool_Exp_;
};

/** columns and relationships of "Comment" */
export type Comment_ = {
  __typename?: 'Comment';
  /** An object relationship */
  author: Users_;
  authorId: Scalars['uuid']['output'];
  /** An object relationship */
  comment?: Maybe<Comment_>;
  createdAt: Scalars['timestamptz']['output'];
  data: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  duplicatedFrom?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  notifications: Array<UserNotification_>;
  /** An aggregate relationship */
  notifications_aggregate: UserNotification_Aggregate_;
  /** An object relationship */
  thread: Thread_;
  threadId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "Comment" */
export type CommentNotificationsArgs_ = {
  distinct_on?: InputMaybe<Array<UserNotification_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserNotification_Order_By_>>;
  where?: InputMaybe<UserNotification_Bool_Exp_>;
};


/** columns and relationships of "Comment" */
export type CommentNotifications_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<UserNotification_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserNotification_Order_By_>>;
  where?: InputMaybe<UserNotification_Bool_Exp_>;
};

/** aggregated selection of "Comment" */
export type Comment_Aggregate_ = {
  __typename?: 'Comment_aggregate';
  aggregate?: Maybe<Comment_Aggregate_Fields_>;
  nodes: Array<Comment_>;
};

export type Comment_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Comment_Aggregate_Bool_Exp_Count_>;
};

export type Comment_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Comment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Comment_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "Comment" */
export type Comment_Aggregate_Fields_ = {
  __typename?: 'Comment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Comment_Max_Fields_>;
  min?: Maybe<Comment_Min_Fields_>;
};


/** aggregate fields of "Comment" */
export type Comment_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Comment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Comment" */
export type Comment_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Comment_Max_Order_By_>;
  min?: InputMaybe<Comment_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "Comment" */
export type Comment_Arr_Rel_Insert_Input_ = {
  data: Array<Comment_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Comment_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "Comment". All fields are combined with a logical 'AND'. */
export type Comment_Bool_Exp_ = {
  _and?: InputMaybe<Array<Comment_Bool_Exp_>>;
  _not?: InputMaybe<Comment_Bool_Exp_>;
  _or?: InputMaybe<Array<Comment_Bool_Exp_>>;
  author?: InputMaybe<Users_Bool_Exp_>;
  authorId?: InputMaybe<Uuid_Comparison_Exp_>;
  comment?: InputMaybe<Comment_Bool_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  data?: InputMaybe<String_Comparison_Exp_>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  duplicatedFrom?: InputMaybe<Uuid_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  notifications?: InputMaybe<UserNotification_Bool_Exp_>;
  notifications_aggregate?: InputMaybe<UserNotification_Aggregate_Bool_Exp_>;
  thread?: InputMaybe<Thread_Bool_Exp_>;
  threadId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Comment" */
export enum Comment_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  CommentPkey_ = 'Comment_pkey'
}

/** input type for inserting data into table "Comment" */
export type Comment_Insert_Input_ = {
  author?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  comment?: InputMaybe<Comment_Obj_Rel_Insert_Input_>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  duplicatedFrom?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  notifications?: InputMaybe<UserNotification_Arr_Rel_Insert_Input_>;
  thread?: InputMaybe<Thread_Obj_Rel_Insert_Input_>;
  threadId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Comment_Max_Fields_ = {
  __typename?: 'Comment_max_fields';
  authorId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  duplicatedFrom?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  threadId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "Comment" */
export type Comment_Max_Order_By_ = {
  authorId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  data?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  duplicatedFrom?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  threadId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Comment_Min_Fields_ = {
  __typename?: 'Comment_min_fields';
  authorId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  duplicatedFrom?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  threadId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "Comment" */
export type Comment_Min_Order_By_ = {
  authorId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  data?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  duplicatedFrom?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  threadId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "Comment" */
export type Comment_Mutation_Response_ = {
  __typename?: 'Comment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Comment_>;
};

/** input type for inserting object relation for remote table "Comment" */
export type Comment_Obj_Rel_Insert_Input_ = {
  data: Comment_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Comment_On_Conflict_>;
};

/** on_conflict condition type for table "Comment" */
export type Comment_On_Conflict_ = {
  constraint: Comment_Constraint_;
  update_columns?: Array<Comment_Update_Column_>;
  where?: InputMaybe<Comment_Bool_Exp_>;
};

/** Ordering options when selecting data from "Comment". */
export type Comment_Order_By_ = {
  author?: InputMaybe<Users_Order_By_>;
  authorId?: InputMaybe<Order_By_>;
  comment?: InputMaybe<Comment_Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  data?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  duplicatedFrom?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  notifications_aggregate?: InputMaybe<UserNotification_Aggregate_Order_By_>;
  thread?: InputMaybe<Thread_Order_By_>;
  threadId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Comment */
export type Comment_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "Comment" */
export enum Comment_Select_Column_ {
  /** column name */
  AuthorId_ = 'authorId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Data_ = 'data',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  DuplicatedFrom_ = 'duplicatedFrom',
  /** column name */
  Id_ = 'id',
  /** column name */
  ThreadId_ = 'threadId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "Comment" */
export type Comment_Set_Input_ = {
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  duplicatedFrom?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  threadId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "Comment" */
export type Comment_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Comment_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Comment_Stream_Cursor_Value_Input_ = {
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  duplicatedFrom?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  threadId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "Comment" */
export enum Comment_Update_Column_ {
  /** column name */
  AuthorId_ = 'authorId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Data_ = 'data',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  DuplicatedFrom_ = 'duplicatedFrom',
  /** column name */
  Id_ = 'id',
  /** column name */
  ThreadId_ = 'threadId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Comment_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Comment_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Comment_Bool_Exp_;
};

/** columns and relationships of "Company" */
export type Company_ = {
  __typename?: 'Company';
  /** An array relationship */
  additionalCommunitySpaces: Array<SharedSpace_>;
  /** An aggregate relationship */
  additionalCommunitySpaces_aggregate: SharedSpace_Aggregate_;
  /** An object relationship */
  aiConfig?: Maybe<AiConfig_>;
  /** An array relationship */
  businessUnits: Array<BusinessUnit_>;
  /** An aggregate relationship */
  businessUnits_aggregate: BusinessUnit_Aggregate_;
  /** An array relationship */
  cAssessmentAggregates: Array<CompanyAssessmentAggregate_>;
  /** An aggregate relationship */
  cAssessmentAggregates_aggregate: CompanyAssessmentAggregate_Aggregate_;
  /** An array relationship */
  cAssessments: Array<CompanyAssessment_>;
  /** An aggregate relationship */
  cAssessments_aggregate: CompanyAssessment_Aggregate_;
  canDownloadEsrsReport: Scalars['Boolean']['output'];
  canDownloadTaxonomyReport: Scalars['Boolean']['output'];
  cancelledAt?: Maybe<Scalars['date']['output']>;
  compassId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  createdById?: Maybe<Scalars['uuid']['output']>;
  currency: Scalars['String']['output'];
  /** An array relationship */
  esrsAssessments: Array<EsrsAssessment_>;
  /** An aggregate relationship */
  esrsAssessments_aggregate: EsrsAssessment_Aggregate_;
  /** An array relationship */
  files: Array<DocumentationFile_>;
  /** An aggregate relationship */
  files_aggregate: DocumentationFile_Aggregate_;
  /** An array relationship */
  groupAssessments: Array<GroupAssessment_>;
  /** An aggregate relationship */
  groupAssessments_aggregate: GroupAssessment_Aggregate_;
  hasAiAccess: Scalars['Boolean']['output'];
  hasBulkUploadAccess?: Maybe<Scalars['Boolean']['output']>;
  hasCommunityAccess: Scalars['Boolean']['output'];
  hasCustomQuestionsAccess: Scalars['Boolean']['output'];
  hasESRSAccess: Scalars['Boolean']['output'];
  hasESRSOilAndGasAccess: Scalars['Boolean']['output'];
  hasEntitySpecificAccess: Scalars['Boolean']['output'];
  hasIFRSAccess?: Maybe<Scalars['Boolean']['output']>;
  hasPaiAccess: Scalars['Boolean']['output'];
  hasSASBAccess: Scalars['Boolean']['output'];
  hasTCFDAccess: Scalars['Boolean']['output'];
  hasTaxonomyAccess: Scalars['Boolean']['output'];
  hasVSMEAccess: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  identityProviderConfiguration?: Maybe<CompanyIdentityProvider_>;
  /** An array relationship */
  invitations: Array<CompanyInvitation_>;
  /** An aggregate relationship */
  invitations_aggregate: CompanyInvitation_Aggregate_;
  isDemo: Scalars['Boolean']['output'];
  isGroupOwner: Scalars['Boolean']['output'];
  isPortfolioOwner: Scalars['Boolean']['output'];
  /** Indicates if this company is actually real, and not a demo or test. If isReal is true, the company should be used in statistics, and when making decisions related to migrations, activities and so on. */
  isReal: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** An array relationship */
  paiReports: Array<PaiCompanyReport_>;
  /** An aggregate relationship */
  paiReports_aggregate: PaiCompanyReport_Aggregate_;
  /** An array relationship */
  portfolioCompanies: Array<PortfolioCompany_>;
  /** An aggregate relationship */
  portfolioCompanies_aggregate: PortfolioCompany_Aggregate_;
  /** An array relationship */
  portfolios: Array<Portfolio_>;
  /** An aggregate relationship */
  portfolios_aggregate: Portfolio_Aggregate_;
  settings: Scalars['jsonb']['output'];
  /** An array relationship */
  subsidiaries: Array<Subsidiary_>;
  /** An aggregate relationship */
  subsidiaries_aggregate: Subsidiary_Aggregate_;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<CompanyUser_>;
  /** An aggregate relationship */
  users_aggregate: CompanyUser_Aggregate_;
};


/** columns and relationships of "Company" */
export type CompanyAdditionalCommunitySpacesArgs_ = {
  distinct_on?: InputMaybe<Array<SharedSpace_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SharedSpace_Order_By_>>;
  where?: InputMaybe<SharedSpace_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyAdditionalCommunitySpaces_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<SharedSpace_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SharedSpace_Order_By_>>;
  where?: InputMaybe<SharedSpace_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyBusinessUnitsArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnit_Order_By_>>;
  where?: InputMaybe<BusinessUnit_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyBusinessUnits_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnit_Order_By_>>;
  where?: InputMaybe<BusinessUnit_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyCAssessmentAggregatesArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessmentAggregate_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessmentAggregate_Order_By_>>;
  where?: InputMaybe<CompanyAssessmentAggregate_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyCAssessmentAggregates_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessmentAggregate_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessmentAggregate_Order_By_>>;
  where?: InputMaybe<CompanyAssessmentAggregate_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyCAssessmentsArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessment_Order_By_>>;
  where?: InputMaybe<CompanyAssessment_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyCAssessments_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessment_Order_By_>>;
  where?: InputMaybe<CompanyAssessment_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyEsrsAssessmentsArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsAssessment_Order_By_>>;
  where?: InputMaybe<EsrsAssessment_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyEsrsAssessments_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsAssessment_Order_By_>>;
  where?: InputMaybe<EsrsAssessment_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyFilesArgs_ = {
  distinct_on?: InputMaybe<Array<DocumentationFile_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DocumentationFile_Order_By_>>;
  where?: InputMaybe<DocumentationFile_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyFiles_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DocumentationFile_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DocumentationFile_Order_By_>>;
  where?: InputMaybe<DocumentationFile_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyGroupAssessmentsArgs_ = {
  distinct_on?: InputMaybe<Array<GroupAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GroupAssessment_Order_By_>>;
  where?: InputMaybe<GroupAssessment_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyGroupAssessments_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<GroupAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GroupAssessment_Order_By_>>;
  where?: InputMaybe<GroupAssessment_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyInvitationsArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyInvitation_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyInvitation_Order_By_>>;
  where?: InputMaybe<CompanyInvitation_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyInvitations_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyInvitation_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyInvitation_Order_By_>>;
  where?: InputMaybe<CompanyInvitation_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyPaiReportsArgs_ = {
  distinct_on?: InputMaybe<Array<PaiCompanyReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiCompanyReport_Order_By_>>;
  where?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyPaiReports_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiCompanyReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiCompanyReport_Order_By_>>;
  where?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyPortfolioCompaniesArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyPortfolioCompanies_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyPortfoliosArgs_ = {
  distinct_on?: InputMaybe<Array<Portfolio_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Order_By_>>;
  where?: InputMaybe<Portfolio_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyPortfolios_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Portfolio_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Order_By_>>;
  where?: InputMaybe<Portfolio_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanySettingsArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "Company" */
export type CompanySubsidiariesArgs_ = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By_>>;
  where?: InputMaybe<Subsidiary_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanySubsidiaries_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By_>>;
  where?: InputMaybe<Subsidiary_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyUsersArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyUser_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyUser_Order_By_>>;
  where?: InputMaybe<CompanyUser_Bool_Exp_>;
};


/** columns and relationships of "Company" */
export type CompanyUsers_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyUser_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyUser_Order_By_>>;
  where?: InputMaybe<CompanyUser_Bool_Exp_>;
};

/** columns and relationships of "CompanyAssessment" */
export type CompanyAssessment_ = {
  __typename?: 'CompanyAssessment';
  /** An object relationship */
  aggregate: CompanyAssessmentAggregate_;
  aggregateId: Scalars['uuid']['output'];
  /** An array relationship */
  bAssesssments: Array<BusinessUnitAssessment_>;
  /** An aggregate relationship */
  bAssesssments_aggregate: BusinessUnitAssessment_Aggregate_;
  /** An object relationship */
  cachedResult?: Maybe<CachedResult_>;
  cachedResultId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  company: Company_;
  /** An object relationship */
  companyAssessmentDuplicate?: Maybe<CompanyAssessment_>;
  companyId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  duplicatedFrom?: Maybe<Scalars['uuid']['output']>;
  endDate: Scalars['date']['output'];
  /** An object relationship */
  groupAssessment?: Maybe<GroupAssessment_>;
  /** An array relationship */
  groupsWithAccess: Array<Subsidiary_>;
  /** An aggregate relationship */
  groupsWithAccess_aggregate: Subsidiary_Aggregate_;
  id: Scalars['uuid']['output'];
  isLocked: Scalars['Boolean']['output'];
  /** An object relationship */
  nonMaterialFinancials?: Maybe<NonMaterialFinancials_>;
  oldStartDate?: Maybe<Scalars['date']['output']>;
  /** An array relationship */
  portfoliosWithAccess: Array<PortfolioCompany_>;
  /** An aggregate relationship */
  portfoliosWithAccess_aggregate: PortfolioCompany_Aggregate_;
  /** An array relationship */
  reportingGroups: Array<ReportingGroup_>;
  /** An aggregate relationship */
  reportingGroups_aggregate: ReportingGroup_Aggregate_;
  startDate: Scalars['date']['output'];
  /** An object relationship */
  totalComparisonFinancials?: Maybe<TotalComparisonFinancials_>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "CompanyAssessment" */
export type CompanyAssessmentBAssesssmentsArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnitAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnitAssessment_Order_By_>>;
  where?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
};


/** columns and relationships of "CompanyAssessment" */
export type CompanyAssessmentBAssesssments_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnitAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnitAssessment_Order_By_>>;
  where?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
};


/** columns and relationships of "CompanyAssessment" */
export type CompanyAssessmentGroupsWithAccessArgs_ = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By_>>;
  where?: InputMaybe<Subsidiary_Bool_Exp_>;
};


/** columns and relationships of "CompanyAssessment" */
export type CompanyAssessmentGroupsWithAccess_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By_>>;
  where?: InputMaybe<Subsidiary_Bool_Exp_>;
};


/** columns and relationships of "CompanyAssessment" */
export type CompanyAssessmentPortfoliosWithAccessArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "CompanyAssessment" */
export type CompanyAssessmentPortfoliosWithAccess_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "CompanyAssessment" */
export type CompanyAssessmentReportingGroupsArgs_ = {
  distinct_on?: InputMaybe<Array<ReportingGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportingGroup_Order_By_>>;
  where?: InputMaybe<ReportingGroup_Bool_Exp_>;
};


/** columns and relationships of "CompanyAssessment" */
export type CompanyAssessmentReportingGroups_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ReportingGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportingGroup_Order_By_>>;
  where?: InputMaybe<ReportingGroup_Bool_Exp_>;
};

/** columns and relationships of "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregate_ = {
  __typename?: 'CompanyAssessmentAggregate';
  /** An array relationship */
  cAssessments: Array<CompanyAssessment_>;
  /** An aggregate relationship */
  cAssessments_aggregate: CompanyAssessment_Aggregate_;
  /** An object relationship */
  company: Company_;
  companyId: Scalars['uuid']['output'];
  /** An object relationship */
  contactPerson?: Maybe<Users_>;
  contactPersonId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  interval: Scalars['String']['output'];
  /** Indicates if this assessment is actually real, and not a demo or test. If isReal is true, the assessment should be used in statistics, and when making decisions related to migrations, activities and so on. */
  isReal: Scalars['Boolean']['output'];
  oldStartDate?: Maybe<Scalars['date']['output']>;
  startDate: Scalars['date']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregateCAssessmentsArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessment_Order_By_>>;
  where?: InputMaybe<CompanyAssessment_Bool_Exp_>;
};


/** columns and relationships of "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregateCAssessments_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessment_Order_By_>>;
  where?: InputMaybe<CompanyAssessment_Bool_Exp_>;
};

/** aggregated selection of "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregate_Aggregate_ = {
  __typename?: 'CompanyAssessmentAggregate_aggregate';
  aggregate?: Maybe<CompanyAssessmentAggregate_Aggregate_Fields_>;
  nodes: Array<CompanyAssessmentAggregate_>;
};

export type CompanyAssessmentAggregate_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<CompanyAssessmentAggregate_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<CompanyAssessmentAggregate_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<CompanyAssessmentAggregate_Aggregate_Bool_Exp_Count_>;
};

export type CompanyAssessmentAggregate_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: CompanyAssessmentAggregate_Select_Column_CompanyAssessmentAggregate_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CompanyAssessmentAggregate_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type CompanyAssessmentAggregate_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: CompanyAssessmentAggregate_Select_Column_CompanyAssessmentAggregate_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CompanyAssessmentAggregate_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type CompanyAssessmentAggregate_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<CompanyAssessmentAggregate_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CompanyAssessmentAggregate_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregate_Aggregate_Fields_ = {
  __typename?: 'CompanyAssessmentAggregate_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<CompanyAssessmentAggregate_Max_Fields_>;
  min?: Maybe<CompanyAssessmentAggregate_Min_Fields_>;
};


/** aggregate fields of "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregate_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<CompanyAssessmentAggregate_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregate_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<CompanyAssessmentAggregate_Max_Order_By_>;
  min?: InputMaybe<CompanyAssessmentAggregate_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregate_Arr_Rel_Insert_Input_ = {
  data: Array<CompanyAssessmentAggregate_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<CompanyAssessmentAggregate_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "CompanyAssessmentAggregate". All fields are combined with a logical 'AND'. */
export type CompanyAssessmentAggregate_Bool_Exp_ = {
  _and?: InputMaybe<Array<CompanyAssessmentAggregate_Bool_Exp_>>;
  _not?: InputMaybe<CompanyAssessmentAggregate_Bool_Exp_>;
  _or?: InputMaybe<Array<CompanyAssessmentAggregate_Bool_Exp_>>;
  cAssessments?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  cAssessments_aggregate?: InputMaybe<CompanyAssessment_Aggregate_Bool_Exp_>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  contactPerson?: InputMaybe<Users_Bool_Exp_>;
  contactPersonId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  interval?: InputMaybe<String_Comparison_Exp_>;
  isReal?: InputMaybe<Boolean_Comparison_Exp_>;
  oldStartDate?: InputMaybe<Date_Comparison_Exp_>;
  startDate?: InputMaybe<Date_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "CompanyAssessmentAggregate" */
export enum CompanyAssessmentAggregate_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  CompanyAssessmentAggregatePkey_ = 'CompanyAssessmentAggregate_pkey'
}

/** input type for inserting data into table "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregate_Insert_Input_ = {
  cAssessments?: InputMaybe<CompanyAssessment_Arr_Rel_Insert_Input_>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  contactPerson?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  contactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if this assessment is actually real, and not a demo or test. If isReal is true, the assessment should be used in statistics, and when making decisions related to migrations, activities and so on. */
  isReal?: InputMaybe<Scalars['Boolean']['input']>;
  oldStartDate?: InputMaybe<Scalars['date']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type CompanyAssessmentAggregate_Max_Fields_ = {
  __typename?: 'CompanyAssessmentAggregate_max_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  contactPersonId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  oldStartDate?: Maybe<Scalars['date']['output']>;
  startDate?: Maybe<Scalars['date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregate_Max_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  contactPersonId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  interval?: InputMaybe<Order_By_>;
  oldStartDate?: InputMaybe<Order_By_>;
  startDate?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type CompanyAssessmentAggregate_Min_Fields_ = {
  __typename?: 'CompanyAssessmentAggregate_min_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  contactPersonId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  oldStartDate?: Maybe<Scalars['date']['output']>;
  startDate?: Maybe<Scalars['date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregate_Min_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  contactPersonId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  interval?: InputMaybe<Order_By_>;
  oldStartDate?: InputMaybe<Order_By_>;
  startDate?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregate_Mutation_Response_ = {
  __typename?: 'CompanyAssessmentAggregate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyAssessmentAggregate_>;
};

/** input type for inserting object relation for remote table "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregate_Obj_Rel_Insert_Input_ = {
  data: CompanyAssessmentAggregate_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<CompanyAssessmentAggregate_On_Conflict_>;
};

/** on_conflict condition type for table "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregate_On_Conflict_ = {
  constraint: CompanyAssessmentAggregate_Constraint_;
  update_columns?: Array<CompanyAssessmentAggregate_Update_Column_>;
  where?: InputMaybe<CompanyAssessmentAggregate_Bool_Exp_>;
};

/** Ordering options when selecting data from "CompanyAssessmentAggregate". */
export type CompanyAssessmentAggregate_Order_By_ = {
  cAssessments_aggregate?: InputMaybe<CompanyAssessment_Aggregate_Order_By_>;
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  contactPerson?: InputMaybe<Users_Order_By_>;
  contactPersonId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  interval?: InputMaybe<Order_By_>;
  isReal?: InputMaybe<Order_By_>;
  oldStartDate?: InputMaybe<Order_By_>;
  startDate?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: CompanyAssessmentAggregate */
export type CompanyAssessmentAggregate_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "CompanyAssessmentAggregate" */
export enum CompanyAssessmentAggregate_Select_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  ContactPersonId_ = 'contactPersonId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Interval_ = 'interval',
  /** column name */
  IsReal_ = 'isReal',
  /** column name */
  OldStartDate_ = 'oldStartDate',
  /** column name */
  StartDate_ = 'startDate',
  /** column name */
  Title_ = 'title',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "CompanyAssessmentAggregate_aggregate_bool_exp_bool_and_arguments_columns" columns of table "CompanyAssessmentAggregate" */
export enum CompanyAssessmentAggregate_Select_Column_CompanyAssessmentAggregate_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsReal_ = 'isReal'
}

/** select "CompanyAssessmentAggregate_aggregate_bool_exp_bool_or_arguments_columns" columns of table "CompanyAssessmentAggregate" */
export enum CompanyAssessmentAggregate_Select_Column_CompanyAssessmentAggregate_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsReal_ = 'isReal'
}

/** input type for updating data in table "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregate_Set_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  contactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if this assessment is actually real, and not a demo or test. If isReal is true, the assessment should be used in statistics, and when making decisions related to migrations, activities and so on. */
  isReal?: InputMaybe<Scalars['Boolean']['input']>;
  oldStartDate?: InputMaybe<Scalars['date']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "CompanyAssessmentAggregate" */
export type CompanyAssessmentAggregate_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: CompanyAssessmentAggregate_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyAssessmentAggregate_Stream_Cursor_Value_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  contactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if this assessment is actually real, and not a demo or test. If isReal is true, the assessment should be used in statistics, and when making decisions related to migrations, activities and so on. */
  isReal?: InputMaybe<Scalars['Boolean']['input']>;
  oldStartDate?: InputMaybe<Scalars['date']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "CompanyAssessmentAggregate" */
export enum CompanyAssessmentAggregate_Update_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  ContactPersonId_ = 'contactPersonId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Interval_ = 'interval',
  /** column name */
  IsReal_ = 'isReal',
  /** column name */
  OldStartDate_ = 'oldStartDate',
  /** column name */
  StartDate_ = 'startDate',
  /** column name */
  Title_ = 'title',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type CompanyAssessmentAggregate_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyAssessmentAggregate_Set_Input_>;
  /** filter the rows which have to be updated */
  where: CompanyAssessmentAggregate_Bool_Exp_;
};

/** aggregated selection of "CompanyAssessment" */
export type CompanyAssessment_Aggregate_ = {
  __typename?: 'CompanyAssessment_aggregate';
  aggregate?: Maybe<CompanyAssessment_Aggregate_Fields_>;
  nodes: Array<CompanyAssessment_>;
};

export type CompanyAssessment_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<CompanyAssessment_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<CompanyAssessment_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<CompanyAssessment_Aggregate_Bool_Exp_Count_>;
};

export type CompanyAssessment_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: CompanyAssessment_Select_Column_CompanyAssessment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type CompanyAssessment_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: CompanyAssessment_Select_Column_CompanyAssessment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type CompanyAssessment_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<CompanyAssessment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "CompanyAssessment" */
export type CompanyAssessment_Aggregate_Fields_ = {
  __typename?: 'CompanyAssessment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<CompanyAssessment_Max_Fields_>;
  min?: Maybe<CompanyAssessment_Min_Fields_>;
};


/** aggregate fields of "CompanyAssessment" */
export type CompanyAssessment_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<CompanyAssessment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "CompanyAssessment" */
export type CompanyAssessment_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<CompanyAssessment_Max_Order_By_>;
  min?: InputMaybe<CompanyAssessment_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "CompanyAssessment" */
export type CompanyAssessment_Arr_Rel_Insert_Input_ = {
  data: Array<CompanyAssessment_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<CompanyAssessment_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "CompanyAssessment". All fields are combined with a logical 'AND'. */
export type CompanyAssessment_Bool_Exp_ = {
  _and?: InputMaybe<Array<CompanyAssessment_Bool_Exp_>>;
  _not?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  _or?: InputMaybe<Array<CompanyAssessment_Bool_Exp_>>;
  aggregate?: InputMaybe<CompanyAssessmentAggregate_Bool_Exp_>;
  aggregateId?: InputMaybe<Uuid_Comparison_Exp_>;
  bAssesssments?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
  bAssesssments_aggregate?: InputMaybe<BusinessUnitAssessment_Aggregate_Bool_Exp_>;
  cachedResult?: InputMaybe<CachedResult_Bool_Exp_>;
  cachedResultId?: InputMaybe<Uuid_Comparison_Exp_>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyAssessmentDuplicate?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  duplicatedFrom?: InputMaybe<Uuid_Comparison_Exp_>;
  endDate?: InputMaybe<Date_Comparison_Exp_>;
  groupAssessment?: InputMaybe<GroupAssessment_Bool_Exp_>;
  groupsWithAccess?: InputMaybe<Subsidiary_Bool_Exp_>;
  groupsWithAccess_aggregate?: InputMaybe<Subsidiary_Aggregate_Bool_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isLocked?: InputMaybe<Boolean_Comparison_Exp_>;
  nonMaterialFinancials?: InputMaybe<NonMaterialFinancials_Bool_Exp_>;
  oldStartDate?: InputMaybe<Date_Comparison_Exp_>;
  portfoliosWithAccess?: InputMaybe<PortfolioCompany_Bool_Exp_>;
  portfoliosWithAccess_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Bool_Exp_>;
  reportingGroups?: InputMaybe<ReportingGroup_Bool_Exp_>;
  reportingGroups_aggregate?: InputMaybe<ReportingGroup_Aggregate_Bool_Exp_>;
  startDate?: InputMaybe<Date_Comparison_Exp_>;
  totalComparisonFinancials?: InputMaybe<TotalComparisonFinancials_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "CompanyAssessment" */
export enum CompanyAssessment_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  CompanyAssessmentPkey_ = 'companyAssessment_pkey'
}

/** input type for inserting data into table "CompanyAssessment" */
export type CompanyAssessment_Insert_Input_ = {
  aggregate?: InputMaybe<CompanyAssessmentAggregate_Obj_Rel_Insert_Input_>;
  aggregateId?: InputMaybe<Scalars['uuid']['input']>;
  bAssesssments?: InputMaybe<BusinessUnitAssessment_Arr_Rel_Insert_Input_>;
  cachedResult?: InputMaybe<CachedResult_Obj_Rel_Insert_Input_>;
  cachedResultId?: InputMaybe<Scalars['uuid']['input']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyAssessmentDuplicate?: InputMaybe<CompanyAssessment_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  duplicatedFrom?: InputMaybe<Scalars['uuid']['input']>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  groupAssessment?: InputMaybe<GroupAssessment_Obj_Rel_Insert_Input_>;
  groupsWithAccess?: InputMaybe<Subsidiary_Arr_Rel_Insert_Input_>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  nonMaterialFinancials?: InputMaybe<NonMaterialFinancials_Obj_Rel_Insert_Input_>;
  oldStartDate?: InputMaybe<Scalars['date']['input']>;
  portfoliosWithAccess?: InputMaybe<PortfolioCompany_Arr_Rel_Insert_Input_>;
  reportingGroups?: InputMaybe<ReportingGroup_Arr_Rel_Insert_Input_>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  totalComparisonFinancials?: InputMaybe<TotalComparisonFinancials_Obj_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type CompanyAssessment_Max_Fields_ = {
  __typename?: 'CompanyAssessment_max_fields';
  aggregateId?: Maybe<Scalars['uuid']['output']>;
  cachedResultId?: Maybe<Scalars['uuid']['output']>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  duplicatedFrom?: Maybe<Scalars['uuid']['output']>;
  endDate?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  oldStartDate?: Maybe<Scalars['date']['output']>;
  startDate?: Maybe<Scalars['date']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "CompanyAssessment" */
export type CompanyAssessment_Max_Order_By_ = {
  aggregateId?: InputMaybe<Order_By_>;
  cachedResultId?: InputMaybe<Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  duplicatedFrom?: InputMaybe<Order_By_>;
  endDate?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  oldStartDate?: InputMaybe<Order_By_>;
  startDate?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type CompanyAssessment_Min_Fields_ = {
  __typename?: 'CompanyAssessment_min_fields';
  aggregateId?: Maybe<Scalars['uuid']['output']>;
  cachedResultId?: Maybe<Scalars['uuid']['output']>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  duplicatedFrom?: Maybe<Scalars['uuid']['output']>;
  endDate?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  oldStartDate?: Maybe<Scalars['date']['output']>;
  startDate?: Maybe<Scalars['date']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "CompanyAssessment" */
export type CompanyAssessment_Min_Order_By_ = {
  aggregateId?: InputMaybe<Order_By_>;
  cachedResultId?: InputMaybe<Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  duplicatedFrom?: InputMaybe<Order_By_>;
  endDate?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  oldStartDate?: InputMaybe<Order_By_>;
  startDate?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "CompanyAssessment" */
export type CompanyAssessment_Mutation_Response_ = {
  __typename?: 'CompanyAssessment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyAssessment_>;
};

/** input type for inserting object relation for remote table "CompanyAssessment" */
export type CompanyAssessment_Obj_Rel_Insert_Input_ = {
  data: CompanyAssessment_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<CompanyAssessment_On_Conflict_>;
};

/** on_conflict condition type for table "CompanyAssessment" */
export type CompanyAssessment_On_Conflict_ = {
  constraint: CompanyAssessment_Constraint_;
  update_columns?: Array<CompanyAssessment_Update_Column_>;
  where?: InputMaybe<CompanyAssessment_Bool_Exp_>;
};

/** Ordering options when selecting data from "CompanyAssessment". */
export type CompanyAssessment_Order_By_ = {
  aggregate?: InputMaybe<CompanyAssessmentAggregate_Order_By_>;
  aggregateId?: InputMaybe<Order_By_>;
  bAssesssments_aggregate?: InputMaybe<BusinessUnitAssessment_Aggregate_Order_By_>;
  cachedResult?: InputMaybe<CachedResult_Order_By_>;
  cachedResultId?: InputMaybe<Order_By_>;
  company?: InputMaybe<Company_Order_By_>;
  companyAssessmentDuplicate?: InputMaybe<CompanyAssessment_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  duplicatedFrom?: InputMaybe<Order_By_>;
  endDate?: InputMaybe<Order_By_>;
  groupAssessment?: InputMaybe<GroupAssessment_Order_By_>;
  groupsWithAccess_aggregate?: InputMaybe<Subsidiary_Aggregate_Order_By_>;
  id?: InputMaybe<Order_By_>;
  isLocked?: InputMaybe<Order_By_>;
  nonMaterialFinancials?: InputMaybe<NonMaterialFinancials_Order_By_>;
  oldStartDate?: InputMaybe<Order_By_>;
  portfoliosWithAccess_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Order_By_>;
  reportingGroups_aggregate?: InputMaybe<ReportingGroup_Aggregate_Order_By_>;
  startDate?: InputMaybe<Order_By_>;
  totalComparisonFinancials?: InputMaybe<TotalComparisonFinancials_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: CompanyAssessment */
export type CompanyAssessment_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "CompanyAssessment" */
export enum CompanyAssessment_Select_Column_ {
  /** column name */
  AggregateId_ = 'aggregateId',
  /** column name */
  CachedResultId_ = 'cachedResultId',
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  DuplicatedFrom_ = 'duplicatedFrom',
  /** column name */
  EndDate_ = 'endDate',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsLocked_ = 'isLocked',
  /** column name */
  OldStartDate_ = 'oldStartDate',
  /** column name */
  StartDate_ = 'startDate',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "CompanyAssessment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "CompanyAssessment" */
export enum CompanyAssessment_Select_Column_CompanyAssessment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsLocked_ = 'isLocked'
}

/** select "CompanyAssessment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "CompanyAssessment" */
export enum CompanyAssessment_Select_Column_CompanyAssessment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsLocked_ = 'isLocked'
}

/** input type for updating data in table "CompanyAssessment" */
export type CompanyAssessment_Set_Input_ = {
  aggregateId?: InputMaybe<Scalars['uuid']['input']>;
  cachedResultId?: InputMaybe<Scalars['uuid']['input']>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  duplicatedFrom?: InputMaybe<Scalars['uuid']['input']>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  oldStartDate?: InputMaybe<Scalars['date']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "CompanyAssessment" */
export type CompanyAssessment_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: CompanyAssessment_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyAssessment_Stream_Cursor_Value_Input_ = {
  aggregateId?: InputMaybe<Scalars['uuid']['input']>;
  cachedResultId?: InputMaybe<Scalars['uuid']['input']>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  duplicatedFrom?: InputMaybe<Scalars['uuid']['input']>;
  endDate?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  oldStartDate?: InputMaybe<Scalars['date']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "CompanyAssessment" */
export enum CompanyAssessment_Update_Column_ {
  /** column name */
  AggregateId_ = 'aggregateId',
  /** column name */
  CachedResultId_ = 'cachedResultId',
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  DuplicatedFrom_ = 'duplicatedFrom',
  /** column name */
  EndDate_ = 'endDate',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsLocked_ = 'isLocked',
  /** column name */
  OldStartDate_ = 'oldStartDate',
  /** column name */
  StartDate_ = 'startDate',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type CompanyAssessment_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyAssessment_Set_Input_>;
  /** filter the rows which have to be updated */
  where: CompanyAssessment_Bool_Exp_;
};

/** columns and relationships of "CompanyIdentityProvider" */
export type CompanyIdentityProvider_ = {
  __typename?: 'CompanyIdentityProvider';
  allowOtherLoginMethods: Scalars['Boolean']['output'];
  /** An object relationship */
  company: Company_;
  companyId: Scalars['uuid']['output'];
  /** An object relationship */
  identityProvider: IdentityProvider_;
  identityProviderOrgName: Scalars['String']['output'];
  requireInvitation: Scalars['Boolean']['output'];
};

/** aggregated selection of "CompanyIdentityProvider" */
export type CompanyIdentityProvider_Aggregate_ = {
  __typename?: 'CompanyIdentityProvider_aggregate';
  aggregate?: Maybe<CompanyIdentityProvider_Aggregate_Fields_>;
  nodes: Array<CompanyIdentityProvider_>;
};

export type CompanyIdentityProvider_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<CompanyIdentityProvider_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<CompanyIdentityProvider_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<CompanyIdentityProvider_Aggregate_Bool_Exp_Count_>;
};

export type CompanyIdentityProvider_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: CompanyIdentityProvider_Select_Column_CompanyIdentityProvider_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CompanyIdentityProvider_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type CompanyIdentityProvider_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: CompanyIdentityProvider_Select_Column_CompanyIdentityProvider_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CompanyIdentityProvider_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type CompanyIdentityProvider_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<CompanyIdentityProvider_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CompanyIdentityProvider_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "CompanyIdentityProvider" */
export type CompanyIdentityProvider_Aggregate_Fields_ = {
  __typename?: 'CompanyIdentityProvider_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<CompanyIdentityProvider_Max_Fields_>;
  min?: Maybe<CompanyIdentityProvider_Min_Fields_>;
};


/** aggregate fields of "CompanyIdentityProvider" */
export type CompanyIdentityProvider_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<CompanyIdentityProvider_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "CompanyIdentityProvider" */
export type CompanyIdentityProvider_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<CompanyIdentityProvider_Max_Order_By_>;
  min?: InputMaybe<CompanyIdentityProvider_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "CompanyIdentityProvider" */
export type CompanyIdentityProvider_Arr_Rel_Insert_Input_ = {
  data: Array<CompanyIdentityProvider_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<CompanyIdentityProvider_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "CompanyIdentityProvider". All fields are combined with a logical 'AND'. */
export type CompanyIdentityProvider_Bool_Exp_ = {
  _and?: InputMaybe<Array<CompanyIdentityProvider_Bool_Exp_>>;
  _not?: InputMaybe<CompanyIdentityProvider_Bool_Exp_>;
  _or?: InputMaybe<Array<CompanyIdentityProvider_Bool_Exp_>>;
  allowOtherLoginMethods?: InputMaybe<Boolean_Comparison_Exp_>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  identityProvider?: InputMaybe<IdentityProvider_Bool_Exp_>;
  identityProviderOrgName?: InputMaybe<String_Comparison_Exp_>;
  requireInvitation?: InputMaybe<Boolean_Comparison_Exp_>;
};

/** unique or primary key constraints on table "CompanyIdentityProvider" */
export enum CompanyIdentityProvider_Constraint_ {
  /** unique or primary key constraint on columns "companyId" */
  CompanyIdentityProviderPkey_ = 'CompanyIdentityProvider_pkey'
}

/** input type for inserting data into table "CompanyIdentityProvider" */
export type CompanyIdentityProvider_Insert_Input_ = {
  allowOtherLoginMethods?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  identityProvider?: InputMaybe<IdentityProvider_Obj_Rel_Insert_Input_>;
  identityProviderOrgName?: InputMaybe<Scalars['String']['input']>;
  requireInvitation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type CompanyIdentityProvider_Max_Fields_ = {
  __typename?: 'CompanyIdentityProvider_max_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  identityProviderOrgName?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "CompanyIdentityProvider" */
export type CompanyIdentityProvider_Max_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  identityProviderOrgName?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type CompanyIdentityProvider_Min_Fields_ = {
  __typename?: 'CompanyIdentityProvider_min_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  identityProviderOrgName?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "CompanyIdentityProvider" */
export type CompanyIdentityProvider_Min_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  identityProviderOrgName?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "CompanyIdentityProvider" */
export type CompanyIdentityProvider_Mutation_Response_ = {
  __typename?: 'CompanyIdentityProvider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyIdentityProvider_>;
};

/** input type for inserting object relation for remote table "CompanyIdentityProvider" */
export type CompanyIdentityProvider_Obj_Rel_Insert_Input_ = {
  data: CompanyIdentityProvider_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<CompanyIdentityProvider_On_Conflict_>;
};

/** on_conflict condition type for table "CompanyIdentityProvider" */
export type CompanyIdentityProvider_On_Conflict_ = {
  constraint: CompanyIdentityProvider_Constraint_;
  update_columns?: Array<CompanyIdentityProvider_Update_Column_>;
  where?: InputMaybe<CompanyIdentityProvider_Bool_Exp_>;
};

/** Ordering options when selecting data from "CompanyIdentityProvider". */
export type CompanyIdentityProvider_Order_By_ = {
  allowOtherLoginMethods?: InputMaybe<Order_By_>;
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  identityProvider?: InputMaybe<IdentityProvider_Order_By_>;
  identityProviderOrgName?: InputMaybe<Order_By_>;
  requireInvitation?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: CompanyIdentityProvider */
export type CompanyIdentityProvider_Pk_Columns_Input_ = {
  companyId: Scalars['uuid']['input'];
};

/** select columns of table "CompanyIdentityProvider" */
export enum CompanyIdentityProvider_Select_Column_ {
  /** column name */
  AllowOtherLoginMethods_ = 'allowOtherLoginMethods',
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  IdentityProviderOrgName_ = 'identityProviderOrgName',
  /** column name */
  RequireInvitation_ = 'requireInvitation'
}

/** select "CompanyIdentityProvider_aggregate_bool_exp_bool_and_arguments_columns" columns of table "CompanyIdentityProvider" */
export enum CompanyIdentityProvider_Select_Column_CompanyIdentityProvider_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  AllowOtherLoginMethods_ = 'allowOtherLoginMethods',
  /** column name */
  RequireInvitation_ = 'requireInvitation'
}

/** select "CompanyIdentityProvider_aggregate_bool_exp_bool_or_arguments_columns" columns of table "CompanyIdentityProvider" */
export enum CompanyIdentityProvider_Select_Column_CompanyIdentityProvider_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  AllowOtherLoginMethods_ = 'allowOtherLoginMethods',
  /** column name */
  RequireInvitation_ = 'requireInvitation'
}

/** input type for updating data in table "CompanyIdentityProvider" */
export type CompanyIdentityProvider_Set_Input_ = {
  allowOtherLoginMethods?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  identityProviderOrgName?: InputMaybe<Scalars['String']['input']>;
  requireInvitation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "CompanyIdentityProvider" */
export type CompanyIdentityProvider_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: CompanyIdentityProvider_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyIdentityProvider_Stream_Cursor_Value_Input_ = {
  allowOtherLoginMethods?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  identityProviderOrgName?: InputMaybe<Scalars['String']['input']>;
  requireInvitation?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "CompanyIdentityProvider" */
export enum CompanyIdentityProvider_Update_Column_ {
  /** column name */
  AllowOtherLoginMethods_ = 'allowOtherLoginMethods',
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  IdentityProviderOrgName_ = 'identityProviderOrgName',
  /** column name */
  RequireInvitation_ = 'requireInvitation'
}

export type CompanyIdentityProvider_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyIdentityProvider_Set_Input_>;
  /** filter the rows which have to be updated */
  where: CompanyIdentityProvider_Bool_Exp_;
};

/** columns and relationships of "CompanyInvitation" */
export type CompanyInvitation_ = {
  __typename?: 'CompanyInvitation';
  /** An object relationship */
  company: Company_;
  companyId: Scalars['uuid']['output'];
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  createdBy?: Maybe<Users_>;
  /** The user id who made the invitation, if null it means it was created before 7/11/23 or by a script */
  createdById?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  inviteToChildCompanies?: Maybe<Scalars['Boolean']['output']>;
  /** Which role the user while get once the invite is accepted */
  role: UserRole_Enum_;
  shouldAddToSubs?: Maybe<Scalars['Boolean']['output']>;
  status: Scalars['String']['output'];
  triggerInviteEmail: Scalars['Boolean']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<Users_>;
  userEmail: Scalars['citext']['output'];
};

/** aggregated selection of "CompanyInvitation" */
export type CompanyInvitation_Aggregate_ = {
  __typename?: 'CompanyInvitation_aggregate';
  aggregate?: Maybe<CompanyInvitation_Aggregate_Fields_>;
  nodes: Array<CompanyInvitation_>;
};

export type CompanyInvitation_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<CompanyInvitation_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<CompanyInvitation_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<CompanyInvitation_Aggregate_Bool_Exp_Count_>;
};

export type CompanyInvitation_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: CompanyInvitation_Select_Column_CompanyInvitation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CompanyInvitation_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type CompanyInvitation_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: CompanyInvitation_Select_Column_CompanyInvitation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CompanyInvitation_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type CompanyInvitation_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<CompanyInvitation_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CompanyInvitation_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "CompanyInvitation" */
export type CompanyInvitation_Aggregate_Fields_ = {
  __typename?: 'CompanyInvitation_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<CompanyInvitation_Max_Fields_>;
  min?: Maybe<CompanyInvitation_Min_Fields_>;
};


/** aggregate fields of "CompanyInvitation" */
export type CompanyInvitation_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<CompanyInvitation_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "CompanyInvitation" */
export type CompanyInvitation_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<CompanyInvitation_Max_Order_By_>;
  min?: InputMaybe<CompanyInvitation_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "CompanyInvitation" */
export type CompanyInvitation_Arr_Rel_Insert_Input_ = {
  data: Array<CompanyInvitation_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<CompanyInvitation_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "CompanyInvitation". All fields are combined with a logical 'AND'. */
export type CompanyInvitation_Bool_Exp_ = {
  _and?: InputMaybe<Array<CompanyInvitation_Bool_Exp_>>;
  _not?: InputMaybe<CompanyInvitation_Bool_Exp_>;
  _or?: InputMaybe<Array<CompanyInvitation_Bool_Exp_>>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  createdBy?: InputMaybe<Users_Bool_Exp_>;
  createdById?: InputMaybe<Uuid_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  inviteToChildCompanies?: InputMaybe<Boolean_Comparison_Exp_>;
  role?: InputMaybe<UserRole_Enum_Comparison_Exp_>;
  shouldAddToSubs?: InputMaybe<Boolean_Comparison_Exp_>;
  status?: InputMaybe<String_Comparison_Exp_>;
  triggerInviteEmail?: InputMaybe<Boolean_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  user?: InputMaybe<Users_Bool_Exp_>;
  userEmail?: InputMaybe<Citext_Comparison_Exp_>;
};

/** unique or primary key constraints on table "CompanyInvitation" */
export enum CompanyInvitation_Constraint_ {
  /** unique or primary key constraint on columns "userEmail", "companyId" */
  CompanyInvitationCompanyIdUserEmail_68f64bffUniq_ = 'CompanyInvitation_companyId_userEmail_68f64bff_uniq',
  /** unique or primary key constraint on columns "id" */
  CompanyInvitationPkey_ = 'CompanyInvitation_pkey'
}

/** input type for inserting data into table "CompanyInvitation" */
export type CompanyInvitation_Insert_Input_ = {
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdBy?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  /** The user id who made the invitation, if null it means it was created before 7/11/23 or by a script */
  createdById?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inviteToChildCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  /** Which role the user while get once the invite is accepted */
  role?: InputMaybe<UserRole_Enum_>;
  shouldAddToSubs?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  triggerInviteEmail?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  userEmail?: InputMaybe<Scalars['citext']['input']>;
};

/** aggregate max on columns */
export type CompanyInvitation_Max_Fields_ = {
  __typename?: 'CompanyInvitation_max_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** The user id who made the invitation, if null it means it was created before 7/11/23 or by a script */
  createdById?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userEmail?: Maybe<Scalars['citext']['output']>;
};

/** order by max() on columns of table "CompanyInvitation" */
export type CompanyInvitation_Max_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  /** The user id who made the invitation, if null it means it was created before 7/11/23 or by a script */
  createdById?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  status?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  userEmail?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type CompanyInvitation_Min_Fields_ = {
  __typename?: 'CompanyInvitation_min_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** The user id who made the invitation, if null it means it was created before 7/11/23 or by a script */
  createdById?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userEmail?: Maybe<Scalars['citext']['output']>;
};

/** order by min() on columns of table "CompanyInvitation" */
export type CompanyInvitation_Min_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  /** The user id who made the invitation, if null it means it was created before 7/11/23 or by a script */
  createdById?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  status?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  userEmail?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "CompanyInvitation" */
export type CompanyInvitation_Mutation_Response_ = {
  __typename?: 'CompanyInvitation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyInvitation_>;
};

/** on_conflict condition type for table "CompanyInvitation" */
export type CompanyInvitation_On_Conflict_ = {
  constraint: CompanyInvitation_Constraint_;
  update_columns?: Array<CompanyInvitation_Update_Column_>;
  where?: InputMaybe<CompanyInvitation_Bool_Exp_>;
};

/** Ordering options when selecting data from "CompanyInvitation". */
export type CompanyInvitation_Order_By_ = {
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  createdBy?: InputMaybe<Users_Order_By_>;
  createdById?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  inviteToChildCompanies?: InputMaybe<Order_By_>;
  role?: InputMaybe<Order_By_>;
  shouldAddToSubs?: InputMaybe<Order_By_>;
  status?: InputMaybe<Order_By_>;
  triggerInviteEmail?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  user?: InputMaybe<Users_Order_By_>;
  userEmail?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: CompanyInvitation */
export type CompanyInvitation_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "CompanyInvitation" */
export enum CompanyInvitation_Select_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  CreatedById_ = 'createdById',
  /** column name */
  Id_ = 'id',
  /** column name */
  InviteToChildCompanies_ = 'inviteToChildCompanies',
  /** column name */
  Role_ = 'role',
  /** column name */
  ShouldAddToSubs_ = 'shouldAddToSubs',
  /** column name */
  Status_ = 'status',
  /** column name */
  TriggerInviteEmail_ = 'triggerInviteEmail',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UserEmail_ = 'userEmail'
}

/** select "CompanyInvitation_aggregate_bool_exp_bool_and_arguments_columns" columns of table "CompanyInvitation" */
export enum CompanyInvitation_Select_Column_CompanyInvitation_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  InviteToChildCompanies_ = 'inviteToChildCompanies',
  /** column name */
  ShouldAddToSubs_ = 'shouldAddToSubs',
  /** column name */
  TriggerInviteEmail_ = 'triggerInviteEmail'
}

/** select "CompanyInvitation_aggregate_bool_exp_bool_or_arguments_columns" columns of table "CompanyInvitation" */
export enum CompanyInvitation_Select_Column_CompanyInvitation_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  InviteToChildCompanies_ = 'inviteToChildCompanies',
  /** column name */
  ShouldAddToSubs_ = 'shouldAddToSubs',
  /** column name */
  TriggerInviteEmail_ = 'triggerInviteEmail'
}

/** input type for updating data in table "CompanyInvitation" */
export type CompanyInvitation_Set_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The user id who made the invitation, if null it means it was created before 7/11/23 or by a script */
  createdById?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inviteToChildCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  /** Which role the user while get once the invite is accepted */
  role?: InputMaybe<UserRole_Enum_>;
  shouldAddToSubs?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  triggerInviteEmail?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userEmail?: InputMaybe<Scalars['citext']['input']>;
};

/** Streaming cursor of the table "CompanyInvitation" */
export type CompanyInvitation_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: CompanyInvitation_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyInvitation_Stream_Cursor_Value_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** The user id who made the invitation, if null it means it was created before 7/11/23 or by a script */
  createdById?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  inviteToChildCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  /** Which role the user while get once the invite is accepted */
  role?: InputMaybe<UserRole_Enum_>;
  shouldAddToSubs?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  triggerInviteEmail?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userEmail?: InputMaybe<Scalars['citext']['input']>;
};

/** update columns of table "CompanyInvitation" */
export enum CompanyInvitation_Update_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  CreatedById_ = 'createdById',
  /** column name */
  Id_ = 'id',
  /** column name */
  InviteToChildCompanies_ = 'inviteToChildCompanies',
  /** column name */
  Role_ = 'role',
  /** column name */
  ShouldAddToSubs_ = 'shouldAddToSubs',
  /** column name */
  Status_ = 'status',
  /** column name */
  TriggerInviteEmail_ = 'triggerInviteEmail',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UserEmail_ = 'userEmail'
}

export type CompanyInvitation_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyInvitation_Set_Input_>;
  /** filter the rows which have to be updated */
  where: CompanyInvitation_Bool_Exp_;
};

/** columns and relationships of "CompanyUser" */
export type CompanyUser_ = {
  __typename?: 'CompanyUser';
  /** An object relationship */
  company: Company_;
  companyId: Scalars['uuid']['output'];
  id: Scalars['bigint']['output'];
  role: UserRole_Enum_;
  /** An object relationship */
  user: Users_;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "CompanyUser" */
export type CompanyUser_Aggregate_ = {
  __typename?: 'CompanyUser_aggregate';
  aggregate?: Maybe<CompanyUser_Aggregate_Fields_>;
  nodes: Array<CompanyUser_>;
};

export type CompanyUser_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<CompanyUser_Aggregate_Bool_Exp_Count_>;
};

export type CompanyUser_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<CompanyUser_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CompanyUser_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "CompanyUser" */
export type CompanyUser_Aggregate_Fields_ = {
  __typename?: 'CompanyUser_aggregate_fields';
  avg?: Maybe<CompanyUser_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<CompanyUser_Max_Fields_>;
  min?: Maybe<CompanyUser_Min_Fields_>;
  stddev?: Maybe<CompanyUser_Stddev_Fields_>;
  stddev_pop?: Maybe<CompanyUser_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<CompanyUser_Stddev_Samp_Fields_>;
  sum?: Maybe<CompanyUser_Sum_Fields_>;
  var_pop?: Maybe<CompanyUser_Var_Pop_Fields_>;
  var_samp?: Maybe<CompanyUser_Var_Samp_Fields_>;
  variance?: Maybe<CompanyUser_Variance_Fields_>;
};


/** aggregate fields of "CompanyUser" */
export type CompanyUser_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<CompanyUser_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "CompanyUser" */
export type CompanyUser_Aggregate_Order_By_ = {
  avg?: InputMaybe<CompanyUser_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<CompanyUser_Max_Order_By_>;
  min?: InputMaybe<CompanyUser_Min_Order_By_>;
  stddev?: InputMaybe<CompanyUser_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<CompanyUser_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<CompanyUser_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<CompanyUser_Sum_Order_By_>;
  var_pop?: InputMaybe<CompanyUser_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<CompanyUser_Var_Samp_Order_By_>;
  variance?: InputMaybe<CompanyUser_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "CompanyUser" */
export type CompanyUser_Arr_Rel_Insert_Input_ = {
  data: Array<CompanyUser_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<CompanyUser_On_Conflict_>;
};

/** aggregate avg on columns */
export type CompanyUser_Avg_Fields_ = {
  __typename?: 'CompanyUser_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "CompanyUser" */
export type CompanyUser_Avg_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "CompanyUser". All fields are combined with a logical 'AND'. */
export type CompanyUser_Bool_Exp_ = {
  _and?: InputMaybe<Array<CompanyUser_Bool_Exp_>>;
  _not?: InputMaybe<CompanyUser_Bool_Exp_>;
  _or?: InputMaybe<Array<CompanyUser_Bool_Exp_>>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  id?: InputMaybe<Bigint_Comparison_Exp_>;
  role?: InputMaybe<UserRole_Enum_Comparison_Exp_>;
  user?: InputMaybe<Users_Bool_Exp_>;
  userId?: InputMaybe<Uuid_Comparison_Exp_>;
};

/** unique or primary key constraints on table "CompanyUser" */
export enum CompanyUser_Constraint_ {
  /** unique or primary key constraint on columns "userId", "companyId" */
  CompanyUserCompanyIdUserId_10e185baUniq_ = 'CompanyUser_companyId_userId_10e185ba_uniq',
  /** unique or primary key constraint on columns "userId", "companyId" */
  CompanyUserPkey_ = 'companyUser_pkey'
}

/** input type for incrementing numeric columns in table "CompanyUser" */
export type CompanyUser_Inc_Input_ = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "CompanyUser" */
export type CompanyUser_Insert_Input_ = {
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  role?: InputMaybe<UserRole_Enum_>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type CompanyUser_Max_Fields_ = {
  __typename?: 'CompanyUser_max_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "CompanyUser" */
export type CompanyUser_Max_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type CompanyUser_Min_Fields_ = {
  __typename?: 'CompanyUser_min_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "CompanyUser" */
export type CompanyUser_Min_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "CompanyUser" */
export type CompanyUser_Mutation_Response_ = {
  __typename?: 'CompanyUser_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CompanyUser_>;
};

/** on_conflict condition type for table "CompanyUser" */
export type CompanyUser_On_Conflict_ = {
  constraint: CompanyUser_Constraint_;
  update_columns?: Array<CompanyUser_Update_Column_>;
  where?: InputMaybe<CompanyUser_Bool_Exp_>;
};

/** Ordering options when selecting data from "CompanyUser". */
export type CompanyUser_Order_By_ = {
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  role?: InputMaybe<Order_By_>;
  user?: InputMaybe<Users_Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: CompanyUser */
export type CompanyUser_Pk_Columns_Input_ = {
  companyId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};

/** select columns of table "CompanyUser" */
export enum CompanyUser_Select_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  Id_ = 'id',
  /** column name */
  Role_ = 'role',
  /** column name */
  UserId_ = 'userId'
}

/** input type for updating data in table "CompanyUser" */
export type CompanyUser_Set_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  role?: InputMaybe<UserRole_Enum_>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type CompanyUser_Stddev_Fields_ = {
  __typename?: 'CompanyUser_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "CompanyUser" */
export type CompanyUser_Stddev_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type CompanyUser_Stddev_Pop_Fields_ = {
  __typename?: 'CompanyUser_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "CompanyUser" */
export type CompanyUser_Stddev_Pop_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type CompanyUser_Stddev_Samp_Fields_ = {
  __typename?: 'CompanyUser_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "CompanyUser" */
export type CompanyUser_Stddev_Samp_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "CompanyUser" */
export type CompanyUser_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: CompanyUser_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type CompanyUser_Stream_Cursor_Value_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  role?: InputMaybe<UserRole_Enum_>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type CompanyUser_Sum_Fields_ = {
  __typename?: 'CompanyUser_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "CompanyUser" */
export type CompanyUser_Sum_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** update columns of table "CompanyUser" */
export enum CompanyUser_Update_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  Id_ = 'id',
  /** column name */
  Role_ = 'role',
  /** column name */
  UserId_ = 'userId'
}

export type CompanyUser_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CompanyUser_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompanyUser_Set_Input_>;
  /** filter the rows which have to be updated */
  where: CompanyUser_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type CompanyUser_Var_Pop_Fields_ = {
  __typename?: 'CompanyUser_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "CompanyUser" */
export type CompanyUser_Var_Pop_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type CompanyUser_Var_Samp_Fields_ = {
  __typename?: 'CompanyUser_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "CompanyUser" */
export type CompanyUser_Var_Samp_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type CompanyUser_Variance_Fields_ = {
  __typename?: 'CompanyUser_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "CompanyUser" */
export type CompanyUser_Variance_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregated selection of "Company" */
export type Company_Aggregate_ = {
  __typename?: 'Company_aggregate';
  aggregate?: Maybe<Company_Aggregate_Fields_>;
  nodes: Array<Company_>;
};

/** aggregate fields of "Company" */
export type Company_Aggregate_Fields_ = {
  __typename?: 'Company_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Company_Max_Fields_>;
  min?: Maybe<Company_Min_Fields_>;
};


/** aggregate fields of "Company" */
export type Company_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Company_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Company_Append_Input_ = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "Company". All fields are combined with a logical 'AND'. */
export type Company_Bool_Exp_ = {
  _and?: InputMaybe<Array<Company_Bool_Exp_>>;
  _not?: InputMaybe<Company_Bool_Exp_>;
  _or?: InputMaybe<Array<Company_Bool_Exp_>>;
  additionalCommunitySpaces?: InputMaybe<SharedSpace_Bool_Exp_>;
  additionalCommunitySpaces_aggregate?: InputMaybe<SharedSpace_Aggregate_Bool_Exp_>;
  aiConfig?: InputMaybe<AiConfig_Bool_Exp_>;
  businessUnits?: InputMaybe<BusinessUnit_Bool_Exp_>;
  businessUnits_aggregate?: InputMaybe<BusinessUnit_Aggregate_Bool_Exp_>;
  cAssessmentAggregates?: InputMaybe<CompanyAssessmentAggregate_Bool_Exp_>;
  cAssessmentAggregates_aggregate?: InputMaybe<CompanyAssessmentAggregate_Aggregate_Bool_Exp_>;
  cAssessments?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  cAssessments_aggregate?: InputMaybe<CompanyAssessment_Aggregate_Bool_Exp_>;
  canDownloadEsrsReport?: InputMaybe<Boolean_Comparison_Exp_>;
  canDownloadTaxonomyReport?: InputMaybe<Boolean_Comparison_Exp_>;
  cancelledAt?: InputMaybe<Date_Comparison_Exp_>;
  compassId?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  createdById?: InputMaybe<Uuid_Comparison_Exp_>;
  currency?: InputMaybe<String_Comparison_Exp_>;
  esrsAssessments?: InputMaybe<EsrsAssessment_Bool_Exp_>;
  esrsAssessments_aggregate?: InputMaybe<EsrsAssessment_Aggregate_Bool_Exp_>;
  files?: InputMaybe<DocumentationFile_Bool_Exp_>;
  files_aggregate?: InputMaybe<DocumentationFile_Aggregate_Bool_Exp_>;
  groupAssessments?: InputMaybe<GroupAssessment_Bool_Exp_>;
  groupAssessments_aggregate?: InputMaybe<GroupAssessment_Aggregate_Bool_Exp_>;
  hasAiAccess?: InputMaybe<Boolean_Comparison_Exp_>;
  hasBulkUploadAccess?: InputMaybe<Boolean_Comparison_Exp_>;
  hasCommunityAccess?: InputMaybe<Boolean_Comparison_Exp_>;
  hasCustomQuestionsAccess?: InputMaybe<Boolean_Comparison_Exp_>;
  hasESRSAccess?: InputMaybe<Boolean_Comparison_Exp_>;
  hasESRSOilAndGasAccess?: InputMaybe<Boolean_Comparison_Exp_>;
  hasEntitySpecificAccess?: InputMaybe<Boolean_Comparison_Exp_>;
  hasIFRSAccess?: InputMaybe<Boolean_Comparison_Exp_>;
  hasPaiAccess?: InputMaybe<Boolean_Comparison_Exp_>;
  hasSASBAccess?: InputMaybe<Boolean_Comparison_Exp_>;
  hasTCFDAccess?: InputMaybe<Boolean_Comparison_Exp_>;
  hasTaxonomyAccess?: InputMaybe<Boolean_Comparison_Exp_>;
  hasVSMEAccess?: InputMaybe<Boolean_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  identityProviderConfiguration?: InputMaybe<CompanyIdentityProvider_Bool_Exp_>;
  invitations?: InputMaybe<CompanyInvitation_Bool_Exp_>;
  invitations_aggregate?: InputMaybe<CompanyInvitation_Aggregate_Bool_Exp_>;
  isDemo?: InputMaybe<Boolean_Comparison_Exp_>;
  isGroupOwner?: InputMaybe<Boolean_Comparison_Exp_>;
  isPortfolioOwner?: InputMaybe<Boolean_Comparison_Exp_>;
  isReal?: InputMaybe<Boolean_Comparison_Exp_>;
  logoUrl?: InputMaybe<String_Comparison_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  paiReports?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
  paiReports_aggregate?: InputMaybe<PaiCompanyReport_Aggregate_Bool_Exp_>;
  portfolioCompanies?: InputMaybe<PortfolioCompany_Bool_Exp_>;
  portfolioCompanies_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Bool_Exp_>;
  portfolios?: InputMaybe<Portfolio_Bool_Exp_>;
  portfolios_aggregate?: InputMaybe<Portfolio_Aggregate_Bool_Exp_>;
  settings?: InputMaybe<Jsonb_Comparison_Exp_>;
  subsidiaries?: InputMaybe<Subsidiary_Bool_Exp_>;
  subsidiaries_aggregate?: InputMaybe<Subsidiary_Aggregate_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  users?: InputMaybe<CompanyUser_Bool_Exp_>;
  users_aggregate?: InputMaybe<CompanyUser_Aggregate_Bool_Exp_>;
};

/** unique or primary key constraints on table "Company" */
export enum Company_Constraint_ {
  /** unique or primary key constraint on columns "compassId" */
  CompanyCompassIdKey_ = 'Company_compassId_key',
  /** unique or primary key constraint on columns "id" */
  CompanyPkey_ = 'company_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Company_Delete_At_Path_Input_ = {
  settings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Company_Delete_Elem_Input_ = {
  settings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Company_Delete_Key_Input_ = {
  settings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "Company" */
export type Company_Insert_Input_ = {
  additionalCommunitySpaces?: InputMaybe<SharedSpace_Arr_Rel_Insert_Input_>;
  aiConfig?: InputMaybe<AiConfig_Obj_Rel_Insert_Input_>;
  businessUnits?: InputMaybe<BusinessUnit_Arr_Rel_Insert_Input_>;
  cAssessmentAggregates?: InputMaybe<CompanyAssessmentAggregate_Arr_Rel_Insert_Input_>;
  cAssessments?: InputMaybe<CompanyAssessment_Arr_Rel_Insert_Input_>;
  canDownloadEsrsReport?: InputMaybe<Scalars['Boolean']['input']>;
  canDownloadTaxonomyReport?: InputMaybe<Scalars['Boolean']['input']>;
  cancelledAt?: InputMaybe<Scalars['date']['input']>;
  compassId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdById?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  esrsAssessments?: InputMaybe<EsrsAssessment_Arr_Rel_Insert_Input_>;
  files?: InputMaybe<DocumentationFile_Arr_Rel_Insert_Input_>;
  groupAssessments?: InputMaybe<GroupAssessment_Arr_Rel_Insert_Input_>;
  hasAiAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasBulkUploadAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasCommunityAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomQuestionsAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasESRSAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasESRSOilAndGasAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntitySpecificAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasIFRSAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaiAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasSASBAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasTCFDAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaxonomyAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasVSMEAccess?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  identityProviderConfiguration?: InputMaybe<CompanyIdentityProvider_Obj_Rel_Insert_Input_>;
  invitations?: InputMaybe<CompanyInvitation_Arr_Rel_Insert_Input_>;
  isDemo?: InputMaybe<Scalars['Boolean']['input']>;
  isGroupOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isPortfolioOwner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if this company is actually real, and not a demo or test. If isReal is true, the company should be used in statistics, and when making decisions related to migrations, activities and so on. */
  isReal?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paiReports?: InputMaybe<PaiCompanyReport_Arr_Rel_Insert_Input_>;
  portfolioCompanies?: InputMaybe<PortfolioCompany_Arr_Rel_Insert_Input_>;
  portfolios?: InputMaybe<Portfolio_Arr_Rel_Insert_Input_>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  subsidiaries?: InputMaybe<Subsidiary_Arr_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  users?: InputMaybe<CompanyUser_Arr_Rel_Insert_Input_>;
};

/** aggregate max on columns */
export type Company_Max_Fields_ = {
  __typename?: 'Company_max_fields';
  cancelledAt?: Maybe<Scalars['date']['output']>;
  compassId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdById?: Maybe<Scalars['uuid']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Company_Min_Fields_ = {
  __typename?: 'Company_min_fields';
  cancelledAt?: Maybe<Scalars['date']['output']>;
  compassId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  createdById?: Maybe<Scalars['uuid']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "Company" */
export type Company_Mutation_Response_ = {
  __typename?: 'Company_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Company_>;
};

/** input type for inserting object relation for remote table "Company" */
export type Company_Obj_Rel_Insert_Input_ = {
  data: Company_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Company_On_Conflict_>;
};

/** on_conflict condition type for table "Company" */
export type Company_On_Conflict_ = {
  constraint: Company_Constraint_;
  update_columns?: Array<Company_Update_Column_>;
  where?: InputMaybe<Company_Bool_Exp_>;
};

/** Ordering options when selecting data from "Company". */
export type Company_Order_By_ = {
  additionalCommunitySpaces_aggregate?: InputMaybe<SharedSpace_Aggregate_Order_By_>;
  aiConfig?: InputMaybe<AiConfig_Order_By_>;
  businessUnits_aggregate?: InputMaybe<BusinessUnit_Aggregate_Order_By_>;
  cAssessmentAggregates_aggregate?: InputMaybe<CompanyAssessmentAggregate_Aggregate_Order_By_>;
  cAssessments_aggregate?: InputMaybe<CompanyAssessment_Aggregate_Order_By_>;
  canDownloadEsrsReport?: InputMaybe<Order_By_>;
  canDownloadTaxonomyReport?: InputMaybe<Order_By_>;
  cancelledAt?: InputMaybe<Order_By_>;
  compassId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  createdById?: InputMaybe<Order_By_>;
  currency?: InputMaybe<Order_By_>;
  esrsAssessments_aggregate?: InputMaybe<EsrsAssessment_Aggregate_Order_By_>;
  files_aggregate?: InputMaybe<DocumentationFile_Aggregate_Order_By_>;
  groupAssessments_aggregate?: InputMaybe<GroupAssessment_Aggregate_Order_By_>;
  hasAiAccess?: InputMaybe<Order_By_>;
  hasBulkUploadAccess?: InputMaybe<Order_By_>;
  hasCommunityAccess?: InputMaybe<Order_By_>;
  hasCustomQuestionsAccess?: InputMaybe<Order_By_>;
  hasESRSAccess?: InputMaybe<Order_By_>;
  hasESRSOilAndGasAccess?: InputMaybe<Order_By_>;
  hasEntitySpecificAccess?: InputMaybe<Order_By_>;
  hasIFRSAccess?: InputMaybe<Order_By_>;
  hasPaiAccess?: InputMaybe<Order_By_>;
  hasSASBAccess?: InputMaybe<Order_By_>;
  hasTCFDAccess?: InputMaybe<Order_By_>;
  hasTaxonomyAccess?: InputMaybe<Order_By_>;
  hasVSMEAccess?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  identityProviderConfiguration?: InputMaybe<CompanyIdentityProvider_Order_By_>;
  invitations_aggregate?: InputMaybe<CompanyInvitation_Aggregate_Order_By_>;
  isDemo?: InputMaybe<Order_By_>;
  isGroupOwner?: InputMaybe<Order_By_>;
  isPortfolioOwner?: InputMaybe<Order_By_>;
  isReal?: InputMaybe<Order_By_>;
  logoUrl?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  paiReports_aggregate?: InputMaybe<PaiCompanyReport_Aggregate_Order_By_>;
  portfolioCompanies_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Order_By_>;
  portfolios_aggregate?: InputMaybe<Portfolio_Aggregate_Order_By_>;
  settings?: InputMaybe<Order_By_>;
  subsidiaries_aggregate?: InputMaybe<Subsidiary_Aggregate_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  users_aggregate?: InputMaybe<CompanyUser_Aggregate_Order_By_>;
};

/** primary key columns input for table: Company */
export type Company_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Company_Prepend_Input_ = {
  settings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "Company" */
export enum Company_Select_Column_ {
  /** column name */
  CanDownloadEsrsReport_ = 'canDownloadEsrsReport',
  /** column name */
  CanDownloadTaxonomyReport_ = 'canDownloadTaxonomyReport',
  /** column name */
  CancelledAt_ = 'cancelledAt',
  /** column name */
  CompassId_ = 'compassId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  CreatedById_ = 'createdById',
  /** column name */
  Currency_ = 'currency',
  /** column name */
  HasAiAccess_ = 'hasAiAccess',
  /** column name */
  HasBulkUploadAccess_ = 'hasBulkUploadAccess',
  /** column name */
  HasCommunityAccess_ = 'hasCommunityAccess',
  /** column name */
  HasCustomQuestionsAccess_ = 'hasCustomQuestionsAccess',
  /** column name */
  HasEsrsAccess_ = 'hasESRSAccess',
  /** column name */
  HasEsrsOilAndGasAccess_ = 'hasESRSOilAndGasAccess',
  /** column name */
  HasEntitySpecificAccess_ = 'hasEntitySpecificAccess',
  /** column name */
  HasIfrsAccess_ = 'hasIFRSAccess',
  /** column name */
  HasPaiAccess_ = 'hasPaiAccess',
  /** column name */
  HasSasbAccess_ = 'hasSASBAccess',
  /** column name */
  HasTcfdAccess_ = 'hasTCFDAccess',
  /** column name */
  HasTaxonomyAccess_ = 'hasTaxonomyAccess',
  /** column name */
  HasVsmeAccess_ = 'hasVSMEAccess',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsDemo_ = 'isDemo',
  /** column name */
  IsGroupOwner_ = 'isGroupOwner',
  /** column name */
  IsPortfolioOwner_ = 'isPortfolioOwner',
  /** column name */
  IsReal_ = 'isReal',
  /** column name */
  LogoUrl_ = 'logoUrl',
  /** column name */
  Name_ = 'name',
  /** column name */
  Settings_ = 'settings',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "Company" */
export type Company_Set_Input_ = {
  canDownloadEsrsReport?: InputMaybe<Scalars['Boolean']['input']>;
  canDownloadTaxonomyReport?: InputMaybe<Scalars['Boolean']['input']>;
  cancelledAt?: InputMaybe<Scalars['date']['input']>;
  compassId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdById?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  hasAiAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasBulkUploadAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasCommunityAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomQuestionsAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasESRSAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasESRSOilAndGasAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntitySpecificAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasIFRSAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaiAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasSASBAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasTCFDAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaxonomyAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasVSMEAccess?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDemo?: InputMaybe<Scalars['Boolean']['input']>;
  isGroupOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isPortfolioOwner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if this company is actually real, and not a demo or test. If isReal is true, the company should be used in statistics, and when making decisions related to migrations, activities and so on. */
  isReal?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "Company" */
export type Company_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Company_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Company_Stream_Cursor_Value_Input_ = {
  canDownloadEsrsReport?: InputMaybe<Scalars['Boolean']['input']>;
  canDownloadTaxonomyReport?: InputMaybe<Scalars['Boolean']['input']>;
  cancelledAt?: InputMaybe<Scalars['date']['input']>;
  compassId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  createdById?: InputMaybe<Scalars['uuid']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  hasAiAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasBulkUploadAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasCommunityAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasCustomQuestionsAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasESRSAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasESRSOilAndGasAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasEntitySpecificAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasIFRSAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaiAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasSASBAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasTCFDAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasTaxonomyAccess?: InputMaybe<Scalars['Boolean']['input']>;
  hasVSMEAccess?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDemo?: InputMaybe<Scalars['Boolean']['input']>;
  isGroupOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isPortfolioOwner?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if this company is actually real, and not a demo or test. If isReal is true, the company should be used in statistics, and when making decisions related to migrations, activities and so on. */
  isReal?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "Company" */
export enum Company_Update_Column_ {
  /** column name */
  CanDownloadEsrsReport_ = 'canDownloadEsrsReport',
  /** column name */
  CanDownloadTaxonomyReport_ = 'canDownloadTaxonomyReport',
  /** column name */
  CancelledAt_ = 'cancelledAt',
  /** column name */
  CompassId_ = 'compassId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  CreatedById_ = 'createdById',
  /** column name */
  Currency_ = 'currency',
  /** column name */
  HasAiAccess_ = 'hasAiAccess',
  /** column name */
  HasBulkUploadAccess_ = 'hasBulkUploadAccess',
  /** column name */
  HasCommunityAccess_ = 'hasCommunityAccess',
  /** column name */
  HasCustomQuestionsAccess_ = 'hasCustomQuestionsAccess',
  /** column name */
  HasEsrsAccess_ = 'hasESRSAccess',
  /** column name */
  HasEsrsOilAndGasAccess_ = 'hasESRSOilAndGasAccess',
  /** column name */
  HasEntitySpecificAccess_ = 'hasEntitySpecificAccess',
  /** column name */
  HasIfrsAccess_ = 'hasIFRSAccess',
  /** column name */
  HasPaiAccess_ = 'hasPaiAccess',
  /** column name */
  HasSasbAccess_ = 'hasSASBAccess',
  /** column name */
  HasTcfdAccess_ = 'hasTCFDAccess',
  /** column name */
  HasTaxonomyAccess_ = 'hasTaxonomyAccess',
  /** column name */
  HasVsmeAccess_ = 'hasVSMEAccess',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsDemo_ = 'isDemo',
  /** column name */
  IsGroupOwner_ = 'isGroupOwner',
  /** column name */
  IsPortfolioOwner_ = 'isPortfolioOwner',
  /** column name */
  IsReal_ = 'isReal',
  /** column name */
  LogoUrl_ = 'logoUrl',
  /** column name */
  Name_ = 'name',
  /** column name */
  Settings_ = 'settings',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Company_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Company_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Company_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Company_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Company_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Company_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Company_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Company_Bool_Exp_;
};

/** Store personal access tokens for logging into compass */
export type CompassPat_ = {
  __typename?: 'CompassPAT';
  createdAt: Scalars['timestamptz']['output'];
  expiresAt: Scalars['timestamptz']['output'];
  personalAccessToken: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users_;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "CompassPAT" */
export type CompassPat_Aggregate_ = {
  __typename?: 'CompassPAT_aggregate';
  aggregate?: Maybe<CompassPat_Aggregate_Fields_>;
  nodes: Array<CompassPat_>;
};

/** aggregate fields of "CompassPAT" */
export type CompassPat_Aggregate_Fields_ = {
  __typename?: 'CompassPAT_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<CompassPat_Max_Fields_>;
  min?: Maybe<CompassPat_Min_Fields_>;
};


/** aggregate fields of "CompassPAT" */
export type CompassPat_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<CompassPat_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "CompassPAT". All fields are combined with a logical 'AND'. */
export type CompassPat_Bool_Exp_ = {
  _and?: InputMaybe<Array<CompassPat_Bool_Exp_>>;
  _not?: InputMaybe<CompassPat_Bool_Exp_>;
  _or?: InputMaybe<Array<CompassPat_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  personalAccessToken?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  user?: InputMaybe<Users_Bool_Exp_>;
  userId?: InputMaybe<Uuid_Comparison_Exp_>;
};

/** unique or primary key constraints on table "CompassPAT" */
export enum CompassPat_Constraint_ {
  /** unique or primary key constraint on columns "personalAccessToken" */
  CompassPatPersonalAccessTokenKey_ = 'CompassPAT_personalAccessToken_key',
  /** unique or primary key constraint on columns "userId" */
  CompassPatPkey_ = 'CompassPAT_pkey'
}

/** input type for inserting data into table "CompassPAT" */
export type CompassPat_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  personalAccessToken?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type CompassPat_Max_Fields_ = {
  __typename?: 'CompassPAT_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  personalAccessToken?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type CompassPat_Min_Fields_ = {
  __typename?: 'CompassPAT_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  personalAccessToken?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "CompassPAT" */
export type CompassPat_Mutation_Response_ = {
  __typename?: 'CompassPAT_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CompassPat_>;
};

/** input type for inserting object relation for remote table "CompassPAT" */
export type CompassPat_Obj_Rel_Insert_Input_ = {
  data: CompassPat_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<CompassPat_On_Conflict_>;
};

/** on_conflict condition type for table "CompassPAT" */
export type CompassPat_On_Conflict_ = {
  constraint: CompassPat_Constraint_;
  update_columns?: Array<CompassPat_Update_Column_>;
  where?: InputMaybe<CompassPat_Bool_Exp_>;
};

/** Ordering options when selecting data from "CompassPAT". */
export type CompassPat_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  expiresAt?: InputMaybe<Order_By_>;
  personalAccessToken?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  user?: InputMaybe<Users_Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: CompassPAT */
export type CompassPat_Pk_Columns_Input_ = {
  userId: Scalars['uuid']['input'];
};

/** select columns of table "CompassPAT" */
export enum CompassPat_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  ExpiresAt_ = 'expiresAt',
  /** column name */
  PersonalAccessToken_ = 'personalAccessToken',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UserId_ = 'userId'
}

/** input type for updating data in table "CompassPAT" */
export type CompassPat_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  personalAccessToken?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "CompassPAT" */
export type CompassPat_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: CompassPat_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type CompassPat_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  personalAccessToken?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "CompassPAT" */
export enum CompassPat_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  ExpiresAt_ = 'expiresAt',
  /** column name */
  PersonalAccessToken_ = 'personalAccessToken',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UserId_ = 'userId'
}

export type CompassPat_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompassPat_Set_Input_>;
  /** filter the rows which have to be updated */
  where: CompassPat_Bool_Exp_;
};

/** columns and relationships of "esrs.DRToMFDisclosureRequirement" */
export type DrToMfDisclosureRequirement_ = {
  __typename?: 'DRToMFDisclosureRequirement';
  /** An object relationship */
  disclosureRequirement: DisclosureRequirement_;
  disclosureRequirementRef: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  mfDisclosureRequirement: MfDisclosureRequirement_;
  mfDisclosureRequirementRef: Scalars['String']['output'];
};

/** aggregated selection of "esrs.DRToMFDisclosureRequirement" */
export type DrToMfDisclosureRequirement_Aggregate_ = {
  __typename?: 'DRToMFDisclosureRequirement_aggregate';
  aggregate?: Maybe<DrToMfDisclosureRequirement_Aggregate_Fields_>;
  nodes: Array<DrToMfDisclosureRequirement_>;
};

export type DrToMfDisclosureRequirement_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<DrToMfDisclosureRequirement_Aggregate_Bool_Exp_Count_>;
};

export type DrToMfDisclosureRequirement_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<DrToMfDisclosureRequirement_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DrToMfDisclosureRequirement_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.DRToMFDisclosureRequirement" */
export type DrToMfDisclosureRequirement_Aggregate_Fields_ = {
  __typename?: 'DRToMFDisclosureRequirement_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<DrToMfDisclosureRequirement_Max_Fields_>;
  min?: Maybe<DrToMfDisclosureRequirement_Min_Fields_>;
};


/** aggregate fields of "esrs.DRToMFDisclosureRequirement" */
export type DrToMfDisclosureRequirement_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<DrToMfDisclosureRequirement_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.DRToMFDisclosureRequirement" */
export type DrToMfDisclosureRequirement_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<DrToMfDisclosureRequirement_Max_Order_By_>;
  min?: InputMaybe<DrToMfDisclosureRequirement_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.DRToMFDisclosureRequirement" */
export type DrToMfDisclosureRequirement_Arr_Rel_Insert_Input_ = {
  data: Array<DrToMfDisclosureRequirement_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<DrToMfDisclosureRequirement_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.DRToMFDisclosureRequirement". All fields are combined with a logical 'AND'. */
export type DrToMfDisclosureRequirement_Bool_Exp_ = {
  _and?: InputMaybe<Array<DrToMfDisclosureRequirement_Bool_Exp_>>;
  _not?: InputMaybe<DrToMfDisclosureRequirement_Bool_Exp_>;
  _or?: InputMaybe<Array<DrToMfDisclosureRequirement_Bool_Exp_>>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  disclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  mfDisclosureRequirement?: InputMaybe<MfDisclosureRequirement_Bool_Exp_>;
  mfDisclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.DRToMFDisclosureRequirement" */
export enum DrToMfDisclosureRequirement_Constraint_ {
  /** unique or primary key constraint on columns "disclosureRequirementRef", "mfDisclosureRequirementRef" */
  DrToMfDisclosureRequirementDisclosureRequirementRefMfDiscKey_ = 'DRToMFDisclosureRequirement_disclosureRequirementRef_mfDisc_key',
  /** unique or primary key constraint on columns "id" */
  DrToMfDisclosureRequirementPkey_ = 'DRToMFDisclosureRequirement_pkey'
}

/** input type for inserting data into table "esrs.DRToMFDisclosureRequirement" */
export type DrToMfDisclosureRequirement_Insert_Input_ = {
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Obj_Rel_Insert_Input_>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mfDisclosureRequirement?: InputMaybe<MfDisclosureRequirement_Obj_Rel_Insert_Input_>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type DrToMfDisclosureRequirement_Max_Fields_ = {
  __typename?: 'DRToMFDisclosureRequirement_max_fields';
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.DRToMFDisclosureRequirement" */
export type DrToMfDisclosureRequirement_Max_Order_By_ = {
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type DrToMfDisclosureRequirement_Min_Fields_ = {
  __typename?: 'DRToMFDisclosureRequirement_min_fields';
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.DRToMFDisclosureRequirement" */
export type DrToMfDisclosureRequirement_Min_Order_By_ = {
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.DRToMFDisclosureRequirement" */
export type DrToMfDisclosureRequirement_Mutation_Response_ = {
  __typename?: 'DRToMFDisclosureRequirement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DrToMfDisclosureRequirement_>;
};

/** on_conflict condition type for table "esrs.DRToMFDisclosureRequirement" */
export type DrToMfDisclosureRequirement_On_Conflict_ = {
  constraint: DrToMfDisclosureRequirement_Constraint_;
  update_columns?: Array<DrToMfDisclosureRequirement_Update_Column_>;
  where?: InputMaybe<DrToMfDisclosureRequirement_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.DRToMFDisclosureRequirement". */
export type DrToMfDisclosureRequirement_Order_By_ = {
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  mfDisclosureRequirement?: InputMaybe<MfDisclosureRequirement_Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.DRToMFDisclosureRequirement */
export type DrToMfDisclosureRequirement_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.DRToMFDisclosureRequirement" */
export enum DrToMfDisclosureRequirement_Select_Column_ {
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  MfDisclosureRequirementRef_ = 'mfDisclosureRequirementRef'
}

/** input type for updating data in table "esrs.DRToMFDisclosureRequirement" */
export type DrToMfDisclosureRequirement_Set_Input_ = {
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "DRToMFDisclosureRequirement" */
export type DrToMfDisclosureRequirement_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: DrToMfDisclosureRequirement_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type DrToMfDisclosureRequirement_Stream_Cursor_Value_Input_ = {
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.DRToMFDisclosureRequirement" */
export enum DrToMfDisclosureRequirement_Update_Column_ {
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  MfDisclosureRequirementRef_ = 'mfDisclosureRequirementRef'
}

export type DrToMfDisclosureRequirement_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DrToMfDisclosureRequirement_Set_Input_>;
  /** filter the rows which have to be updated */
  where: DrToMfDisclosureRequirement_Bool_Exp_;
};

/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement group has by its own, many disclosure requirements related to it. If the type is metric, the requirement has then many metrics related to it. */
export type DisclosureRequirement_ = {
  __typename?: 'DisclosureRequirement';
  /** An array relationship */
  actions: Array<Esrs_Actions_>;
  /** An aggregate relationship */
  actions_aggregate: Esrs_Actions_Aggregate_;
  /** An array relationship */
  additionalTypes: Array<DisclosureRequirementAdditionalType_>;
  /** An aggregate relationship */
  additionalTypes_aggregate: DisclosureRequirementAdditionalType_Aggregate_;
  description?: Maybe<Scalars['String']['output']>;
  /** A shortcut to get frameworkRef */
  frameworkRef?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  group: DisclosureRequirementGroup_;
  /** disclosure requirement group reference related to each one */
  groupRef: Scalars['String']['output'];
  isMandatory: Scalars['Boolean']['output'];
  /** An array relationship */
  metrics: Array<EsrsMetric_>;
  /** An aggregate relationship */
  metrics_aggregate: EsrsMetric_Aggregate_;
  /** An array relationship */
  mfDisclosureRequirements: Array<DrToMfDisclosureRequirement_>;
  /** An aggregate relationship */
  mfDisclosureRequirements_aggregate: DrToMfDisclosureRequirement_Aggregate_;
  order: Scalars['Int']['output'];
  /** An array relationship */
  policies: Array<Esrs_Policy_>;
  /** An aggregate relationship */
  policies_aggregate: Esrs_Policy_Aggregate_;
  /** unique reference for each disclosure requirement */
  reference: Scalars['String']['output'];
  shortTitle?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  targets: Array<Esrs_Target_>;
  /** An aggregate relationship */
  targets_aggregate: Esrs_Target_Aggregate_;
  title: Scalars['String']['output'];
  /** type of the disclosure requirement (policy, metric, action, target) */
  type: Scalars['String']['output'];
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement group has by its own, many disclosure requirements related to it. If the type is metric, the requirement has then many metrics related to it. */
export type DisclosureRequirementActionsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Actions_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Actions_Order_By_>>;
  where?: InputMaybe<Esrs_Actions_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement group has by its own, many disclosure requirements related to it. If the type is metric, the requirement has then many metrics related to it. */
export type DisclosureRequirementActions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Actions_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Actions_Order_By_>>;
  where?: InputMaybe<Esrs_Actions_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement group has by its own, many disclosure requirements related to it. If the type is metric, the requirement has then many metrics related to it. */
export type DisclosureRequirementAdditionalTypesArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementAdditionalType_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementAdditionalType_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement group has by its own, many disclosure requirements related to it. If the type is metric, the requirement has then many metrics related to it. */
export type DisclosureRequirementAdditionalTypes_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementAdditionalType_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementAdditionalType_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement group has by its own, many disclosure requirements related to it. If the type is metric, the requirement has then many metrics related to it. */
export type DisclosureRequirementMetricsArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetric_Order_By_>>;
  where?: InputMaybe<EsrsMetric_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement group has by its own, many disclosure requirements related to it. If the type is metric, the requirement has then many metrics related to it. */
export type DisclosureRequirementMetrics_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetric_Order_By_>>;
  where?: InputMaybe<EsrsMetric_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement group has by its own, many disclosure requirements related to it. If the type is metric, the requirement has then many metrics related to it. */
export type DisclosureRequirementMfDisclosureRequirementsArgs_ = {
  distinct_on?: InputMaybe<Array<DrToMfDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DrToMfDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<DrToMfDisclosureRequirement_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement group has by its own, many disclosure requirements related to it. If the type is metric, the requirement has then many metrics related to it. */
export type DisclosureRequirementMfDisclosureRequirements_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DrToMfDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DrToMfDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<DrToMfDisclosureRequirement_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement group has by its own, many disclosure requirements related to it. If the type is metric, the requirement has then many metrics related to it. */
export type DisclosureRequirementPoliciesArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Policy_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Policy_Order_By_>>;
  where?: InputMaybe<Esrs_Policy_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement group has by its own, many disclosure requirements related to it. If the type is metric, the requirement has then many metrics related to it. */
export type DisclosureRequirementPolicies_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Policy_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Policy_Order_By_>>;
  where?: InputMaybe<Esrs_Policy_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement group has by its own, many disclosure requirements related to it. If the type is metric, the requirement has then many metrics related to it. */
export type DisclosureRequirementTargetsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Target_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Target_Order_By_>>;
  where?: InputMaybe<Esrs_Target_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement group has by its own, many disclosure requirements related to it. If the type is metric, the requirement has then many metrics related to it. */
export type DisclosureRequirementTargets_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Target_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Target_Order_By_>>;
  where?: InputMaybe<Esrs_Target_Bool_Exp_>;
};

/** columns and relationships of "esrs.DisclosureRequirementAdditionalType" */
export type DisclosureRequirementAdditionalType_ = {
  __typename?: 'DisclosureRequirementAdditionalType';
  /** An object relationship */
  additionalType: AdditionalType_;
  additionalTypeRef: Scalars['String']['output'];
  /** An object relationship */
  disclosureRequirement: DisclosureRequirement_;
  disclosureRequirementRef: Scalars['String']['output'];
};

/** aggregated selection of "esrs.DisclosureRequirementAdditionalType" */
export type DisclosureRequirementAdditionalType_Aggregate_ = {
  __typename?: 'DisclosureRequirementAdditionalType_aggregate';
  aggregate?: Maybe<DisclosureRequirementAdditionalType_Aggregate_Fields_>;
  nodes: Array<DisclosureRequirementAdditionalType_>;
};

export type DisclosureRequirementAdditionalType_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<DisclosureRequirementAdditionalType_Aggregate_Bool_Exp_Count_>;
};

export type DisclosureRequirementAdditionalType_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<DisclosureRequirementAdditionalType_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DisclosureRequirementAdditionalType_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.DisclosureRequirementAdditionalType" */
export type DisclosureRequirementAdditionalType_Aggregate_Fields_ = {
  __typename?: 'DisclosureRequirementAdditionalType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<DisclosureRequirementAdditionalType_Max_Fields_>;
  min?: Maybe<DisclosureRequirementAdditionalType_Min_Fields_>;
};


/** aggregate fields of "esrs.DisclosureRequirementAdditionalType" */
export type DisclosureRequirementAdditionalType_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<DisclosureRequirementAdditionalType_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.DisclosureRequirementAdditionalType" */
export type DisclosureRequirementAdditionalType_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<DisclosureRequirementAdditionalType_Max_Order_By_>;
  min?: InputMaybe<DisclosureRequirementAdditionalType_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.DisclosureRequirementAdditionalType" */
export type DisclosureRequirementAdditionalType_Arr_Rel_Insert_Input_ = {
  data: Array<DisclosureRequirementAdditionalType_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<DisclosureRequirementAdditionalType_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.DisclosureRequirementAdditionalType". All fields are combined with a logical 'AND'. */
export type DisclosureRequirementAdditionalType_Bool_Exp_ = {
  _and?: InputMaybe<Array<DisclosureRequirementAdditionalType_Bool_Exp_>>;
  _not?: InputMaybe<DisclosureRequirementAdditionalType_Bool_Exp_>;
  _or?: InputMaybe<Array<DisclosureRequirementAdditionalType_Bool_Exp_>>;
  additionalType?: InputMaybe<AdditionalType_Bool_Exp_>;
  additionalTypeRef?: InputMaybe<String_Comparison_Exp_>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  disclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.DisclosureRequirementAdditionalType" */
export enum DisclosureRequirementAdditionalType_Constraint_ {
  /** unique or primary key constraint on columns "disclosureRequirementRef", "additionalTypeRef" */
  DisclosureRequirementAdditionalTypeDisclosureRequirementRefAd_ = 'DisclosureRequirementAdditionalType_disclosureRequirementRef_ad',
  /** unique or primary key constraint on columns "disclosureRequirementRef", "additionalTypeRef" */
  DisclosureRequirementAdditionalTypePkey_ = 'DisclosureRequirementAdditionalType_pkey'
}

/** input type for inserting data into table "esrs.DisclosureRequirementAdditionalType" */
export type DisclosureRequirementAdditionalType_Insert_Input_ = {
  additionalType?: InputMaybe<AdditionalType_Obj_Rel_Insert_Input_>;
  additionalTypeRef?: InputMaybe<Scalars['String']['input']>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Obj_Rel_Insert_Input_>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type DisclosureRequirementAdditionalType_Max_Fields_ = {
  __typename?: 'DisclosureRequirementAdditionalType_max_fields';
  additionalTypeRef?: Maybe<Scalars['String']['output']>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.DisclosureRequirementAdditionalType" */
export type DisclosureRequirementAdditionalType_Max_Order_By_ = {
  additionalTypeRef?: InputMaybe<Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type DisclosureRequirementAdditionalType_Min_Fields_ = {
  __typename?: 'DisclosureRequirementAdditionalType_min_fields';
  additionalTypeRef?: Maybe<Scalars['String']['output']>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.DisclosureRequirementAdditionalType" */
export type DisclosureRequirementAdditionalType_Min_Order_By_ = {
  additionalTypeRef?: InputMaybe<Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.DisclosureRequirementAdditionalType" */
export type DisclosureRequirementAdditionalType_Mutation_Response_ = {
  __typename?: 'DisclosureRequirementAdditionalType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DisclosureRequirementAdditionalType_>;
};

/** on_conflict condition type for table "esrs.DisclosureRequirementAdditionalType" */
export type DisclosureRequirementAdditionalType_On_Conflict_ = {
  constraint: DisclosureRequirementAdditionalType_Constraint_;
  update_columns?: Array<DisclosureRequirementAdditionalType_Update_Column_>;
  where?: InputMaybe<DisclosureRequirementAdditionalType_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.DisclosureRequirementAdditionalType". */
export type DisclosureRequirementAdditionalType_Order_By_ = {
  additionalType?: InputMaybe<AdditionalType_Order_By_>;
  additionalTypeRef?: InputMaybe<Order_By_>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.DisclosureRequirementAdditionalType */
export type DisclosureRequirementAdditionalType_Pk_Columns_Input_ = {
  additionalTypeRef: Scalars['String']['input'];
  disclosureRequirementRef: Scalars['String']['input'];
};

/** select columns of table "esrs.DisclosureRequirementAdditionalType" */
export enum DisclosureRequirementAdditionalType_Select_Column_ {
  /** column name */
  AdditionalTypeRef_ = 'additionalTypeRef',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef'
}

/** input type for updating data in table "esrs.DisclosureRequirementAdditionalType" */
export type DisclosureRequirementAdditionalType_Set_Input_ = {
  additionalTypeRef?: InputMaybe<Scalars['String']['input']>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "DisclosureRequirementAdditionalType" */
export type DisclosureRequirementAdditionalType_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: DisclosureRequirementAdditionalType_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type DisclosureRequirementAdditionalType_Stream_Cursor_Value_Input_ = {
  additionalTypeRef?: InputMaybe<Scalars['String']['input']>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.DisclosureRequirementAdditionalType" */
export enum DisclosureRequirementAdditionalType_Update_Column_ {
  /** column name */
  AdditionalTypeRef_ = 'additionalTypeRef',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef'
}

export type DisclosureRequirementAdditionalType_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DisclosureRequirementAdditionalType_Set_Input_>;
  /** filter the rows which have to be updated */
  where: DisclosureRequirementAdditionalType_Bool_Exp_;
};

/** (admin panel): These follow a 1 to many relationship. Each standard has by its own, many disclosure requirement groups related to it. And each group has many disclosure requirements related to it.  */
export type DisclosureRequirementGroup_ = {
  __typename?: 'DisclosureRequirementGroup';
  order: Scalars['Int']['output'];
  /** naming convention: combination between standardRefTitle-DisclosureRequirementGroupTitle */
  reference: Scalars['String']['output'];
  /** An array relationship */
  requirements: Array<DisclosureRequirement_>;
  /** An aggregate relationship */
  requirements_aggregate: DisclosureRequirement_Aggregate_;
  /** An object relationship */
  standard: EsrsStandard_;
  /** Its the standard reference for each group, foreign key */
  standardRef: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


/** (admin panel): These follow a 1 to many relationship. Each standard has by its own, many disclosure requirement groups related to it. And each group has many disclosure requirements related to it.  */
export type DisclosureRequirementGroupRequirementsArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirement_Order_By_>>;
  where?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each standard has by its own, many disclosure requirement groups related to it. And each group has many disclosure requirements related to it.  */
export type DisclosureRequirementGroupRequirements_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirement_Order_By_>>;
  where?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
};

/** aggregated selection of "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Aggregate_ = {
  __typename?: 'DisclosureRequirementGroup_aggregate';
  aggregate?: Maybe<DisclosureRequirementGroup_Aggregate_Fields_>;
  nodes: Array<DisclosureRequirementGroup_>;
};

export type DisclosureRequirementGroup_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<DisclosureRequirementGroup_Aggregate_Bool_Exp_Count_>;
};

export type DisclosureRequirementGroup_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<DisclosureRequirementGroup_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DisclosureRequirementGroup_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Aggregate_Fields_ = {
  __typename?: 'DisclosureRequirementGroup_aggregate_fields';
  avg?: Maybe<DisclosureRequirementGroup_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<DisclosureRequirementGroup_Max_Fields_>;
  min?: Maybe<DisclosureRequirementGroup_Min_Fields_>;
  stddev?: Maybe<DisclosureRequirementGroup_Stddev_Fields_>;
  stddev_pop?: Maybe<DisclosureRequirementGroup_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<DisclosureRequirementGroup_Stddev_Samp_Fields_>;
  sum?: Maybe<DisclosureRequirementGroup_Sum_Fields_>;
  var_pop?: Maybe<DisclosureRequirementGroup_Var_Pop_Fields_>;
  var_samp?: Maybe<DisclosureRequirementGroup_Var_Samp_Fields_>;
  variance?: Maybe<DisclosureRequirementGroup_Variance_Fields_>;
};


/** aggregate fields of "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<DisclosureRequirementGroup_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Aggregate_Order_By_ = {
  avg?: InputMaybe<DisclosureRequirementGroup_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<DisclosureRequirementGroup_Max_Order_By_>;
  min?: InputMaybe<DisclosureRequirementGroup_Min_Order_By_>;
  stddev?: InputMaybe<DisclosureRequirementGroup_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<DisclosureRequirementGroup_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<DisclosureRequirementGroup_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<DisclosureRequirementGroup_Sum_Order_By_>;
  var_pop?: InputMaybe<DisclosureRequirementGroup_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<DisclosureRequirementGroup_Var_Samp_Order_By_>;
  variance?: InputMaybe<DisclosureRequirementGroup_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Arr_Rel_Insert_Input_ = {
  data: Array<DisclosureRequirementGroup_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<DisclosureRequirementGroup_On_Conflict_>;
};

/** aggregate avg on columns */
export type DisclosureRequirementGroup_Avg_Fields_ = {
  __typename?: 'DisclosureRequirementGroup_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Avg_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.DisclosureRequirementGroup". All fields are combined with a logical 'AND'. */
export type DisclosureRequirementGroup_Bool_Exp_ = {
  _and?: InputMaybe<Array<DisclosureRequirementGroup_Bool_Exp_>>;
  _not?: InputMaybe<DisclosureRequirementGroup_Bool_Exp_>;
  _or?: InputMaybe<Array<DisclosureRequirementGroup_Bool_Exp_>>;
  order?: InputMaybe<Int_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  requirements?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  requirements_aggregate?: InputMaybe<DisclosureRequirement_Aggregate_Bool_Exp_>;
  standard?: InputMaybe<EsrsStandard_Bool_Exp_>;
  standardRef?: InputMaybe<String_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.DisclosureRequirementGroup" */
export enum DisclosureRequirementGroup_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  DisclosureRequirementGroupPkey_ = 'DisclosureRequirementGroup_pkey'
}

/** input type for incrementing numeric columns in table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Inc_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Insert_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
  /** naming convention: combination between standardRefTitle-DisclosureRequirementGroupTitle */
  reference?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<DisclosureRequirement_Arr_Rel_Insert_Input_>;
  standard?: InputMaybe<EsrsStandard_Obj_Rel_Insert_Input_>;
  /** Its the standard reference for each group, foreign key */
  standardRef?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type DisclosureRequirementGroup_Max_Fields_ = {
  __typename?: 'DisclosureRequirementGroup_max_fields';
  order?: Maybe<Scalars['Int']['output']>;
  /** naming convention: combination between standardRefTitle-DisclosureRequirementGroupTitle */
  reference?: Maybe<Scalars['String']['output']>;
  /** Its the standard reference for each group, foreign key */
  standardRef?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Max_Order_By_ = {
  order?: InputMaybe<Order_By_>;
  /** naming convention: combination between standardRefTitle-DisclosureRequirementGroupTitle */
  reference?: InputMaybe<Order_By_>;
  /** Its the standard reference for each group, foreign key */
  standardRef?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type DisclosureRequirementGroup_Min_Fields_ = {
  __typename?: 'DisclosureRequirementGroup_min_fields';
  order?: Maybe<Scalars['Int']['output']>;
  /** naming convention: combination between standardRefTitle-DisclosureRequirementGroupTitle */
  reference?: Maybe<Scalars['String']['output']>;
  /** Its the standard reference for each group, foreign key */
  standardRef?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Min_Order_By_ = {
  order?: InputMaybe<Order_By_>;
  /** naming convention: combination between standardRefTitle-DisclosureRequirementGroupTitle */
  reference?: InputMaybe<Order_By_>;
  /** Its the standard reference for each group, foreign key */
  standardRef?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Mutation_Response_ = {
  __typename?: 'DisclosureRequirementGroup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DisclosureRequirementGroup_>;
};

/** input type for inserting object relation for remote table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Obj_Rel_Insert_Input_ = {
  data: DisclosureRequirementGroup_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<DisclosureRequirementGroup_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_On_Conflict_ = {
  constraint: DisclosureRequirementGroup_Constraint_;
  update_columns?: Array<DisclosureRequirementGroup_Update_Column_>;
  where?: InputMaybe<DisclosureRequirementGroup_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.DisclosureRequirementGroup". */
export type DisclosureRequirementGroup_Order_By_ = {
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  requirements_aggregate?: InputMaybe<DisclosureRequirement_Aggregate_Order_By_>;
  standard?: InputMaybe<EsrsStandard_Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.DisclosureRequirementGroup */
export type DisclosureRequirementGroup_Pk_Columns_Input_ = {
  /** naming convention: combination between standardRefTitle-DisclosureRequirementGroupTitle */
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.DisclosureRequirementGroup" */
export enum DisclosureRequirementGroup_Select_Column_ {
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  StandardRef_ = 'standardRef',
  /** column name */
  Title_ = 'title'
}

/** input type for updating data in table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Set_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
  /** naming convention: combination between standardRefTitle-DisclosureRequirementGroupTitle */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Its the standard reference for each group, foreign key */
  standardRef?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type DisclosureRequirementGroup_Stddev_Fields_ = {
  __typename?: 'DisclosureRequirementGroup_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Stddev_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type DisclosureRequirementGroup_Stddev_Pop_Fields_ = {
  __typename?: 'DisclosureRequirementGroup_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Stddev_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type DisclosureRequirementGroup_Stddev_Samp_Fields_ = {
  __typename?: 'DisclosureRequirementGroup_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Stddev_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: DisclosureRequirementGroup_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type DisclosureRequirementGroup_Stream_Cursor_Value_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
  /** naming convention: combination between standardRefTitle-DisclosureRequirementGroupTitle */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Its the standard reference for each group, foreign key */
  standardRef?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type DisclosureRequirementGroup_Sum_Fields_ = {
  __typename?: 'DisclosureRequirementGroup_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Sum_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.DisclosureRequirementGroup" */
export enum DisclosureRequirementGroup_Update_Column_ {
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  StandardRef_ = 'standardRef',
  /** column name */
  Title_ = 'title'
}

export type DisclosureRequirementGroup_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DisclosureRequirementGroup_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DisclosureRequirementGroup_Set_Input_>;
  /** filter the rows which have to be updated */
  where: DisclosureRequirementGroup_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type DisclosureRequirementGroup_Var_Pop_Fields_ = {
  __typename?: 'DisclosureRequirementGroup_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Var_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type DisclosureRequirementGroup_Var_Samp_Fields_ = {
  __typename?: 'DisclosureRequirementGroup_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Var_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type DisclosureRequirementGroup_Variance_Fields_ = {
  __typename?: 'DisclosureRequirementGroup_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.DisclosureRequirementGroup" */
export type DisclosureRequirementGroup_Variance_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** columns and relationships of "esrs.DisclosureRequirementOwner" */
export type DisclosureRequirementOwner_ = {
  __typename?: 'DisclosureRequirementOwner';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  disclosureRequirement?: Maybe<DisclosureRequirement_>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  materialStandard: Esrs_MaterialStandard_;
  materialStandardId: Scalars['uuid']['output'];
  /** An object relationship */
  mfDisclosureRequirement?: Maybe<MfDisclosureRequirement_>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  owner: Users_;
  ownerId: Scalars['uuid']['output'];
  /** An object relationship */
  reportingUnit: Esrs_ReportingUnit_;
  reportingUnitId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "esrs.DisclosureRequirementOwner" */
export type DisclosureRequirementOwner_Aggregate_ = {
  __typename?: 'DisclosureRequirementOwner_aggregate';
  aggregate?: Maybe<DisclosureRequirementOwner_Aggregate_Fields_>;
  nodes: Array<DisclosureRequirementOwner_>;
};

/** aggregate fields of "esrs.DisclosureRequirementOwner" */
export type DisclosureRequirementOwner_Aggregate_Fields_ = {
  __typename?: 'DisclosureRequirementOwner_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<DisclosureRequirementOwner_Max_Fields_>;
  min?: Maybe<DisclosureRequirementOwner_Min_Fields_>;
};


/** aggregate fields of "esrs.DisclosureRequirementOwner" */
export type DisclosureRequirementOwner_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<DisclosureRequirementOwner_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "esrs.DisclosureRequirementOwner". All fields are combined with a logical 'AND'. */
export type DisclosureRequirementOwner_Bool_Exp_ = {
  _and?: InputMaybe<Array<DisclosureRequirementOwner_Bool_Exp_>>;
  _not?: InputMaybe<DisclosureRequirementOwner_Bool_Exp_>;
  _or?: InputMaybe<Array<DisclosureRequirementOwner_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  disclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  materialStandardId?: InputMaybe<Uuid_Comparison_Exp_>;
  mfDisclosureRequirement?: InputMaybe<MfDisclosureRequirement_Bool_Exp_>;
  mfDisclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
  owner?: InputMaybe<Users_Bool_Exp_>;
  ownerId?: InputMaybe<Uuid_Comparison_Exp_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
  reportingUnitId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.DisclosureRequirementOwner" */
export enum DisclosureRequirementOwner_Constraint_ {
  /** unique or primary key constraint on columns "disclosureRequirementRef", "materialStandardId", "reportingUnitId" */
  DisclosureRequirementOwnerMaterialStandardIdDisclosureReqKey_ = 'DisclosureRequirementOwner_materialStandardId_disclosureReq_key',
  /** unique or primary key constraint on columns "materialStandardId", "reportingUnitId", "mfDisclosureRequirementRef" */
  DisclosureRequirementOwnerMaterialStandardIdMfDisclosureRKey_ = 'DisclosureRequirementOwner_materialStandardId_mfDisclosureR_key',
  /** unique or primary key constraint on columns "id" */
  DisclosureRequirementOwnerPkey_ = 'DisclosureRequirementOwner_pkey'
}

/** input type for inserting data into table "esrs.DisclosureRequirementOwner" */
export type DisclosureRequirementOwner_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Obj_Rel_Insert_Input_>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Obj_Rel_Insert_Input_>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  mfDisclosureRequirement?: InputMaybe<MfDisclosureRequirement_Obj_Rel_Insert_Input_>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Obj_Rel_Insert_Input_>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type DisclosureRequirementOwner_Max_Fields_ = {
  __typename?: 'DisclosureRequirementOwner_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type DisclosureRequirementOwner_Min_Fields_ = {
  __typename?: 'DisclosureRequirementOwner_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "esrs.DisclosureRequirementOwner" */
export type DisclosureRequirementOwner_Mutation_Response_ = {
  __typename?: 'DisclosureRequirementOwner_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DisclosureRequirementOwner_>;
};

/** on_conflict condition type for table "esrs.DisclosureRequirementOwner" */
export type DisclosureRequirementOwner_On_Conflict_ = {
  constraint: DisclosureRequirementOwner_Constraint_;
  update_columns?: Array<DisclosureRequirementOwner_Update_Column_>;
  where?: InputMaybe<DisclosureRequirementOwner_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.DisclosureRequirementOwner". */
export type DisclosureRequirementOwner_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Order_By_>;
  materialStandardId?: InputMaybe<Order_By_>;
  mfDisclosureRequirement?: InputMaybe<MfDisclosureRequirement_Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
  owner?: InputMaybe<Users_Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.DisclosureRequirementOwner */
export type DisclosureRequirementOwner_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.DisclosureRequirementOwner" */
export enum DisclosureRequirementOwner_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  MaterialStandardId_ = 'materialStandardId',
  /** column name */
  MfDisclosureRequirementRef_ = 'mfDisclosureRequirementRef',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  ReportingUnitId_ = 'reportingUnitId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "esrs.DisclosureRequirementOwner" */
export type DisclosureRequirementOwner_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "DisclosureRequirementOwner" */
export type DisclosureRequirementOwner_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: DisclosureRequirementOwner_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type DisclosureRequirementOwner_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.DisclosureRequirementOwner" */
export enum DisclosureRequirementOwner_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  MaterialStandardId_ = 'materialStandardId',
  /** column name */
  MfDisclosureRequirementRef_ = 'mfDisclosureRequirementRef',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  ReportingUnitId_ = 'reportingUnitId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type DisclosureRequirementOwner_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DisclosureRequirementOwner_Set_Input_>;
  /** filter the rows which have to be updated */
  where: DisclosureRequirementOwner_Bool_Exp_;
};

/** columns and relationships of "esrs.DisclosureRequirementStatus" */
export type DisclosureRequirementStatus_ = {
  __typename?: 'DisclosureRequirementStatus';
  /** An object relationship */
  disclosureRequirement?: Maybe<DisclosureRequirement_>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isConfigured: Scalars['Boolean']['output'];
  /** An object relationship */
  materialStandard: Esrs_MaterialStandard_;
  materialStandardId: Scalars['uuid']['output'];
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "esrs.DisclosureRequirementStatus" */
export type DisclosureRequirementStatus_Aggregate_ = {
  __typename?: 'DisclosureRequirementStatus_aggregate';
  aggregate?: Maybe<DisclosureRequirementStatus_Aggregate_Fields_>;
  nodes: Array<DisclosureRequirementStatus_>;
};

export type DisclosureRequirementStatus_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<DisclosureRequirementStatus_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<DisclosureRequirementStatus_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<DisclosureRequirementStatus_Aggregate_Bool_Exp_Count_>;
};

export type DisclosureRequirementStatus_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: DisclosureRequirementStatus_Select_Column_DisclosureRequirementStatus_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DisclosureRequirementStatus_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type DisclosureRequirementStatus_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: DisclosureRequirementStatus_Select_Column_DisclosureRequirementStatus_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DisclosureRequirementStatus_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type DisclosureRequirementStatus_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<DisclosureRequirementStatus_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DisclosureRequirementStatus_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.DisclosureRequirementStatus" */
export type DisclosureRequirementStatus_Aggregate_Fields_ = {
  __typename?: 'DisclosureRequirementStatus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<DisclosureRequirementStatus_Max_Fields_>;
  min?: Maybe<DisclosureRequirementStatus_Min_Fields_>;
};


/** aggregate fields of "esrs.DisclosureRequirementStatus" */
export type DisclosureRequirementStatus_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<DisclosureRequirementStatus_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.DisclosureRequirementStatus" */
export type DisclosureRequirementStatus_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<DisclosureRequirementStatus_Max_Order_By_>;
  min?: InputMaybe<DisclosureRequirementStatus_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.DisclosureRequirementStatus" */
export type DisclosureRequirementStatus_Arr_Rel_Insert_Input_ = {
  data: Array<DisclosureRequirementStatus_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<DisclosureRequirementStatus_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.DisclosureRequirementStatus". All fields are combined with a logical 'AND'. */
export type DisclosureRequirementStatus_Bool_Exp_ = {
  _and?: InputMaybe<Array<DisclosureRequirementStatus_Bool_Exp_>>;
  _not?: InputMaybe<DisclosureRequirementStatus_Bool_Exp_>;
  _or?: InputMaybe<Array<DisclosureRequirementStatus_Bool_Exp_>>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  disclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isConfigured?: InputMaybe<Boolean_Comparison_Exp_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  materialStandardId?: InputMaybe<Uuid_Comparison_Exp_>;
  mfDisclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.DisclosureRequirementStatus" */
export enum DisclosureRequirementStatus_Constraint_ {
  /** unique or primary key constraint on columns "disclosureRequirementRef", "materialStandardId" */
  DisclosureRequirementStatusMaterialStandardIdDisclosureRequir_ = 'DisclosureRequirementStatus_materialStandardId_disclosureRequir',
  /** unique or primary key constraint on columns "materialStandardId", "mfDisclosureRequirementRef" */
  DisclosureRequirementStatusMaterialStandardIdMfDisclosureRequ_ = 'DisclosureRequirementStatus_materialStandardId_mfDisclosureRequ',
  /** unique or primary key constraint on columns "id" */
  DisclosureRequirementStatusPkey_ = 'DisclosureRequirementStatus_pkey'
}

/** input type for inserting data into table "esrs.DisclosureRequirementStatus" */
export type DisclosureRequirementStatus_Insert_Input_ = {
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Obj_Rel_Insert_Input_>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Obj_Rel_Insert_Input_>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type DisclosureRequirementStatus_Max_Fields_ = {
  __typename?: 'DisclosureRequirementStatus_max_fields';
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.DisclosureRequirementStatus" */
export type DisclosureRequirementStatus_Max_Order_By_ = {
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialStandardId?: InputMaybe<Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type DisclosureRequirementStatus_Min_Fields_ = {
  __typename?: 'DisclosureRequirementStatus_min_fields';
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.DisclosureRequirementStatus" */
export type DisclosureRequirementStatus_Min_Order_By_ = {
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialStandardId?: InputMaybe<Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.DisclosureRequirementStatus" */
export type DisclosureRequirementStatus_Mutation_Response_ = {
  __typename?: 'DisclosureRequirementStatus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DisclosureRequirementStatus_>;
};

/** on_conflict condition type for table "esrs.DisclosureRequirementStatus" */
export type DisclosureRequirementStatus_On_Conflict_ = {
  constraint: DisclosureRequirementStatus_Constraint_;
  update_columns?: Array<DisclosureRequirementStatus_Update_Column_>;
  where?: InputMaybe<DisclosureRequirementStatus_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.DisclosureRequirementStatus". */
export type DisclosureRequirementStatus_Order_By_ = {
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isConfigured?: InputMaybe<Order_By_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Order_By_>;
  materialStandardId?: InputMaybe<Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.DisclosureRequirementStatus */
export type DisclosureRequirementStatus_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.DisclosureRequirementStatus" */
export enum DisclosureRequirementStatus_Select_Column_ {
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsConfigured_ = 'isConfigured',
  /** column name */
  MaterialStandardId_ = 'materialStandardId',
  /** column name */
  MfDisclosureRequirementRef_ = 'mfDisclosureRequirementRef'
}

/** select "DisclosureRequirementStatus_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.DisclosureRequirementStatus" */
export enum DisclosureRequirementStatus_Select_Column_DisclosureRequirementStatus_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsConfigured_ = 'isConfigured'
}

/** select "DisclosureRequirementStatus_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.DisclosureRequirementStatus" */
export enum DisclosureRequirementStatus_Select_Column_DisclosureRequirementStatus_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsConfigured_ = 'isConfigured'
}

/** input type for updating data in table "esrs.DisclosureRequirementStatus" */
export type DisclosureRequirementStatus_Set_Input_ = {
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "DisclosureRequirementStatus" */
export type DisclosureRequirementStatus_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: DisclosureRequirementStatus_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type DisclosureRequirementStatus_Stream_Cursor_Value_Input_ = {
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.DisclosureRequirementStatus" */
export enum DisclosureRequirementStatus_Update_Column_ {
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsConfigured_ = 'isConfigured',
  /** column name */
  MaterialStandardId_ = 'materialStandardId',
  /** column name */
  MfDisclosureRequirementRef_ = 'mfDisclosureRequirementRef'
}

export type DisclosureRequirementStatus_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DisclosureRequirementStatus_Set_Input_>;
  /** filter the rows which have to be updated */
  where: DisclosureRequirementStatus_Bool_Exp_;
};

/** aggregated selection of "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Aggregate_ = {
  __typename?: 'DisclosureRequirement_aggregate';
  aggregate?: Maybe<DisclosureRequirement_Aggregate_Fields_>;
  nodes: Array<DisclosureRequirement_>;
};

export type DisclosureRequirement_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<DisclosureRequirement_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<DisclosureRequirement_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<DisclosureRequirement_Aggregate_Bool_Exp_Count_>;
};

export type DisclosureRequirement_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: DisclosureRequirement_Select_Column_DisclosureRequirement_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type DisclosureRequirement_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: DisclosureRequirement_Select_Column_DisclosureRequirement_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type DisclosureRequirement_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<DisclosureRequirement_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Aggregate_Fields_ = {
  __typename?: 'DisclosureRequirement_aggregate_fields';
  avg?: Maybe<DisclosureRequirement_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<DisclosureRequirement_Max_Fields_>;
  min?: Maybe<DisclosureRequirement_Min_Fields_>;
  stddev?: Maybe<DisclosureRequirement_Stddev_Fields_>;
  stddev_pop?: Maybe<DisclosureRequirement_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<DisclosureRequirement_Stddev_Samp_Fields_>;
  sum?: Maybe<DisclosureRequirement_Sum_Fields_>;
  var_pop?: Maybe<DisclosureRequirement_Var_Pop_Fields_>;
  var_samp?: Maybe<DisclosureRequirement_Var_Samp_Fields_>;
  variance?: Maybe<DisclosureRequirement_Variance_Fields_>;
};


/** aggregate fields of "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<DisclosureRequirement_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Aggregate_Order_By_ = {
  avg?: InputMaybe<DisclosureRequirement_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<DisclosureRequirement_Max_Order_By_>;
  min?: InputMaybe<DisclosureRequirement_Min_Order_By_>;
  stddev?: InputMaybe<DisclosureRequirement_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<DisclosureRequirement_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<DisclosureRequirement_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<DisclosureRequirement_Sum_Order_By_>;
  var_pop?: InputMaybe<DisclosureRequirement_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<DisclosureRequirement_Var_Samp_Order_By_>;
  variance?: InputMaybe<DisclosureRequirement_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Arr_Rel_Insert_Input_ = {
  data: Array<DisclosureRequirement_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<DisclosureRequirement_On_Conflict_>;
};

/** aggregate avg on columns */
export type DisclosureRequirement_Avg_Fields_ = {
  __typename?: 'DisclosureRequirement_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Avg_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.DisclosureRequirement". All fields are combined with a logical 'AND'. */
export type DisclosureRequirement_Bool_Exp_ = {
  _and?: InputMaybe<Array<DisclosureRequirement_Bool_Exp_>>;
  _not?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  _or?: InputMaybe<Array<DisclosureRequirement_Bool_Exp_>>;
  actions?: InputMaybe<Esrs_Actions_Bool_Exp_>;
  actions_aggregate?: InputMaybe<Esrs_Actions_Aggregate_Bool_Exp_>;
  additionalTypes?: InputMaybe<DisclosureRequirementAdditionalType_Bool_Exp_>;
  additionalTypes_aggregate?: InputMaybe<DisclosureRequirementAdditionalType_Aggregate_Bool_Exp_>;
  description?: InputMaybe<String_Comparison_Exp_>;
  frameworkRef?: InputMaybe<String_Comparison_Exp_>;
  group?: InputMaybe<DisclosureRequirementGroup_Bool_Exp_>;
  groupRef?: InputMaybe<String_Comparison_Exp_>;
  isMandatory?: InputMaybe<Boolean_Comparison_Exp_>;
  metrics?: InputMaybe<EsrsMetric_Bool_Exp_>;
  metrics_aggregate?: InputMaybe<EsrsMetric_Aggregate_Bool_Exp_>;
  mfDisclosureRequirements?: InputMaybe<DrToMfDisclosureRequirement_Bool_Exp_>;
  mfDisclosureRequirements_aggregate?: InputMaybe<DrToMfDisclosureRequirement_Aggregate_Bool_Exp_>;
  order?: InputMaybe<Int_Comparison_Exp_>;
  policies?: InputMaybe<Esrs_Policy_Bool_Exp_>;
  policies_aggregate?: InputMaybe<Esrs_Policy_Aggregate_Bool_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  shortTitle?: InputMaybe<String_Comparison_Exp_>;
  targets?: InputMaybe<Esrs_Target_Bool_Exp_>;
  targets_aggregate?: InputMaybe<Esrs_Target_Aggregate_Bool_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
  type?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.DisclosureRequirement" */
export enum DisclosureRequirement_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  DisclosureRequirementPkey_ = 'DisclosureRequirement_pkey'
}

/** input type for incrementing numeric columns in table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Inc_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Insert_Input_ = {
  actions?: InputMaybe<Esrs_Actions_Arr_Rel_Insert_Input_>;
  additionalTypes?: InputMaybe<DisclosureRequirementAdditionalType_Arr_Rel_Insert_Input_>;
  description?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<DisclosureRequirementGroup_Obj_Rel_Insert_Input_>;
  /** disclosure requirement group reference related to each one */
  groupRef?: InputMaybe<Scalars['String']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  metrics?: InputMaybe<EsrsMetric_Arr_Rel_Insert_Input_>;
  mfDisclosureRequirements?: InputMaybe<DrToMfDisclosureRequirement_Arr_Rel_Insert_Input_>;
  order?: InputMaybe<Scalars['Int']['input']>;
  policies?: InputMaybe<Esrs_Policy_Arr_Rel_Insert_Input_>;
  /** unique reference for each disclosure requirement */
  reference?: InputMaybe<Scalars['String']['input']>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  targets?: InputMaybe<Esrs_Target_Arr_Rel_Insert_Input_>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** type of the disclosure requirement (policy, metric, action, target) */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type DisclosureRequirement_Max_Fields_ = {
  __typename?: 'DisclosureRequirement_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  /** A shortcut to get frameworkRef */
  frameworkRef?: Maybe<Scalars['String']['output']>;
  /** disclosure requirement group reference related to each one */
  groupRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  /** unique reference for each disclosure requirement */
  reference?: Maybe<Scalars['String']['output']>;
  shortTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** type of the disclosure requirement (policy, metric, action, target) */
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Max_Order_By_ = {
  description?: InputMaybe<Order_By_>;
  /** disclosure requirement group reference related to each one */
  groupRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  /** unique reference for each disclosure requirement */
  reference?: InputMaybe<Order_By_>;
  shortTitle?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  /** type of the disclosure requirement (policy, metric, action, target) */
  type?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type DisclosureRequirement_Min_Fields_ = {
  __typename?: 'DisclosureRequirement_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  /** A shortcut to get frameworkRef */
  frameworkRef?: Maybe<Scalars['String']['output']>;
  /** disclosure requirement group reference related to each one */
  groupRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  /** unique reference for each disclosure requirement */
  reference?: Maybe<Scalars['String']['output']>;
  shortTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  /** type of the disclosure requirement (policy, metric, action, target) */
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Min_Order_By_ = {
  description?: InputMaybe<Order_By_>;
  /** disclosure requirement group reference related to each one */
  groupRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  /** unique reference for each disclosure requirement */
  reference?: InputMaybe<Order_By_>;
  shortTitle?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  /** type of the disclosure requirement (policy, metric, action, target) */
  type?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Mutation_Response_ = {
  __typename?: 'DisclosureRequirement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DisclosureRequirement_>;
};

/** input type for inserting object relation for remote table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Obj_Rel_Insert_Input_ = {
  data: DisclosureRequirement_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<DisclosureRequirement_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_On_Conflict_ = {
  constraint: DisclosureRequirement_Constraint_;
  update_columns?: Array<DisclosureRequirement_Update_Column_>;
  where?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.DisclosureRequirement". */
export type DisclosureRequirement_Order_By_ = {
  actions_aggregate?: InputMaybe<Esrs_Actions_Aggregate_Order_By_>;
  additionalTypes_aggregate?: InputMaybe<DisclosureRequirementAdditionalType_Aggregate_Order_By_>;
  description?: InputMaybe<Order_By_>;
  frameworkRef?: InputMaybe<Order_By_>;
  group?: InputMaybe<DisclosureRequirementGroup_Order_By_>;
  groupRef?: InputMaybe<Order_By_>;
  isMandatory?: InputMaybe<Order_By_>;
  metrics_aggregate?: InputMaybe<EsrsMetric_Aggregate_Order_By_>;
  mfDisclosureRequirements_aggregate?: InputMaybe<DrToMfDisclosureRequirement_Aggregate_Order_By_>;
  order?: InputMaybe<Order_By_>;
  policies_aggregate?: InputMaybe<Esrs_Policy_Aggregate_Order_By_>;
  reference?: InputMaybe<Order_By_>;
  shortTitle?: InputMaybe<Order_By_>;
  targets_aggregate?: InputMaybe<Esrs_Target_Aggregate_Order_By_>;
  title?: InputMaybe<Order_By_>;
  type?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.DisclosureRequirement */
export type DisclosureRequirement_Pk_Columns_Input_ = {
  /** unique reference for each disclosure requirement */
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.DisclosureRequirement" */
export enum DisclosureRequirement_Select_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  GroupRef_ = 'groupRef',
  /** column name */
  IsMandatory_ = 'isMandatory',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  ShortTitle_ = 'shortTitle',
  /** column name */
  Title_ = 'title',
  /** column name */
  Type_ = 'type'
}

/** select "DisclosureRequirement_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.DisclosureRequirement" */
export enum DisclosureRequirement_Select_Column_DisclosureRequirement_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsMandatory_ = 'isMandatory'
}

/** select "DisclosureRequirement_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.DisclosureRequirement" */
export enum DisclosureRequirement_Select_Column_DisclosureRequirement_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsMandatory_ = 'isMandatory'
}

/** input type for updating data in table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Set_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** disclosure requirement group reference related to each one */
  groupRef?: InputMaybe<Scalars['String']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  /** unique reference for each disclosure requirement */
  reference?: InputMaybe<Scalars['String']['input']>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** type of the disclosure requirement (policy, metric, action, target) */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type DisclosureRequirement_Stddev_Fields_ = {
  __typename?: 'DisclosureRequirement_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Stddev_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type DisclosureRequirement_Stddev_Pop_Fields_ = {
  __typename?: 'DisclosureRequirement_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Stddev_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type DisclosureRequirement_Stddev_Samp_Fields_ = {
  __typename?: 'DisclosureRequirement_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Stddev_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "DisclosureRequirement" */
export type DisclosureRequirement_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: DisclosureRequirement_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type DisclosureRequirement_Stream_Cursor_Value_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  /** disclosure requirement group reference related to each one */
  groupRef?: InputMaybe<Scalars['String']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  /** unique reference for each disclosure requirement */
  reference?: InputMaybe<Scalars['String']['input']>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  /** type of the disclosure requirement (policy, metric, action, target) */
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type DisclosureRequirement_Sum_Fields_ = {
  __typename?: 'DisclosureRequirement_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Sum_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.DisclosureRequirement" */
export enum DisclosureRequirement_Update_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  GroupRef_ = 'groupRef',
  /** column name */
  IsMandatory_ = 'isMandatory',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  ShortTitle_ = 'shortTitle',
  /** column name */
  Title_ = 'title',
  /** column name */
  Type_ = 'type'
}

export type DisclosureRequirement_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DisclosureRequirement_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DisclosureRequirement_Set_Input_>;
  /** filter the rows which have to be updated */
  where: DisclosureRequirement_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type DisclosureRequirement_Var_Pop_Fields_ = {
  __typename?: 'DisclosureRequirement_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Var_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type DisclosureRequirement_Var_Samp_Fields_ = {
  __typename?: 'DisclosureRequirement_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Var_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type DisclosureRequirement_Variance_Fields_ = {
  __typename?: 'DisclosureRequirement_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.DisclosureRequirement" */
export type DisclosureRequirement_Variance_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** columns and relationships of "DocumentInsight" */
export type DocumentInsight_ = {
  __typename?: 'DocumentInsight';
  /** An object relationship */
  extractionJob: ExtractionJob_;
  id: Scalars['uuid']['output'];
  insight?: Maybe<Scalars['jsonb']['output']>;
  jobId: Scalars['uuid']['output'];
  /** An array relationship */
  paiInsight: Array<PaiMetricInsight_>;
  /** An aggregate relationship */
  paiInsight_aggregate: PaiMetricInsight_Aggregate_;
};


/** columns and relationships of "DocumentInsight" */
export type DocumentInsightInsightArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "DocumentInsight" */
export type DocumentInsightPaiInsightArgs_ = {
  distinct_on?: InputMaybe<Array<PaiMetricInsight_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiMetricInsight_Order_By_>>;
  where?: InputMaybe<PaiMetricInsight_Bool_Exp_>;
};


/** columns and relationships of "DocumentInsight" */
export type DocumentInsightPaiInsight_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiMetricInsight_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiMetricInsight_Order_By_>>;
  where?: InputMaybe<PaiMetricInsight_Bool_Exp_>;
};

/** aggregated selection of "DocumentInsight" */
export type DocumentInsight_Aggregate_ = {
  __typename?: 'DocumentInsight_aggregate';
  aggregate?: Maybe<DocumentInsight_Aggregate_Fields_>;
  nodes: Array<DocumentInsight_>;
};

export type DocumentInsight_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<DocumentInsight_Aggregate_Bool_Exp_Count_>;
};

export type DocumentInsight_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<DocumentInsight_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DocumentInsight_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "DocumentInsight" */
export type DocumentInsight_Aggregate_Fields_ = {
  __typename?: 'DocumentInsight_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<DocumentInsight_Max_Fields_>;
  min?: Maybe<DocumentInsight_Min_Fields_>;
};


/** aggregate fields of "DocumentInsight" */
export type DocumentInsight_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<DocumentInsight_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "DocumentInsight" */
export type DocumentInsight_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<DocumentInsight_Max_Order_By_>;
  min?: InputMaybe<DocumentInsight_Min_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DocumentInsight_Append_Input_ = {
  insight?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "DocumentInsight" */
export type DocumentInsight_Arr_Rel_Insert_Input_ = {
  data: Array<DocumentInsight_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<DocumentInsight_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "DocumentInsight". All fields are combined with a logical 'AND'. */
export type DocumentInsight_Bool_Exp_ = {
  _and?: InputMaybe<Array<DocumentInsight_Bool_Exp_>>;
  _not?: InputMaybe<DocumentInsight_Bool_Exp_>;
  _or?: InputMaybe<Array<DocumentInsight_Bool_Exp_>>;
  extractionJob?: InputMaybe<ExtractionJob_Bool_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  insight?: InputMaybe<Jsonb_Comparison_Exp_>;
  jobId?: InputMaybe<Uuid_Comparison_Exp_>;
  paiInsight?: InputMaybe<PaiMetricInsight_Bool_Exp_>;
  paiInsight_aggregate?: InputMaybe<PaiMetricInsight_Aggregate_Bool_Exp_>;
};

/** unique or primary key constraints on table "DocumentInsight" */
export enum DocumentInsight_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  DocumentInsightPkey_ = 'DocumentInsight_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DocumentInsight_Delete_At_Path_Input_ = {
  insight?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DocumentInsight_Delete_Elem_Input_ = {
  insight?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DocumentInsight_Delete_Key_Input_ = {
  insight?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "DocumentInsight" */
export type DocumentInsight_Insert_Input_ = {
  extractionJob?: InputMaybe<ExtractionJob_Obj_Rel_Insert_Input_>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  insight?: InputMaybe<Scalars['jsonb']['input']>;
  jobId?: InputMaybe<Scalars['uuid']['input']>;
  paiInsight?: InputMaybe<PaiMetricInsight_Arr_Rel_Insert_Input_>;
};

/** aggregate max on columns */
export type DocumentInsight_Max_Fields_ = {
  __typename?: 'DocumentInsight_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  jobId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "DocumentInsight" */
export type DocumentInsight_Max_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  jobId?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type DocumentInsight_Min_Fields_ = {
  __typename?: 'DocumentInsight_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  jobId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "DocumentInsight" */
export type DocumentInsight_Min_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  jobId?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "DocumentInsight" */
export type DocumentInsight_Mutation_Response_ = {
  __typename?: 'DocumentInsight_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DocumentInsight_>;
};

/** input type for inserting object relation for remote table "DocumentInsight" */
export type DocumentInsight_Obj_Rel_Insert_Input_ = {
  data: DocumentInsight_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<DocumentInsight_On_Conflict_>;
};

/** on_conflict condition type for table "DocumentInsight" */
export type DocumentInsight_On_Conflict_ = {
  constraint: DocumentInsight_Constraint_;
  update_columns?: Array<DocumentInsight_Update_Column_>;
  where?: InputMaybe<DocumentInsight_Bool_Exp_>;
};

/** Ordering options when selecting data from "DocumentInsight". */
export type DocumentInsight_Order_By_ = {
  extractionJob?: InputMaybe<ExtractionJob_Order_By_>;
  id?: InputMaybe<Order_By_>;
  insight?: InputMaybe<Order_By_>;
  jobId?: InputMaybe<Order_By_>;
  paiInsight_aggregate?: InputMaybe<PaiMetricInsight_Aggregate_Order_By_>;
};

/** primary key columns input for table: DocumentInsight */
export type DocumentInsight_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DocumentInsight_Prepend_Input_ = {
  insight?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "DocumentInsight" */
export enum DocumentInsight_Select_Column_ {
  /** column name */
  Id_ = 'id',
  /** column name */
  Insight_ = 'insight',
  /** column name */
  JobId_ = 'jobId'
}

/** input type for updating data in table "DocumentInsight" */
export type DocumentInsight_Set_Input_ = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  insight?: InputMaybe<Scalars['jsonb']['input']>;
  jobId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "DocumentInsight" */
export type DocumentInsight_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: DocumentInsight_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type DocumentInsight_Stream_Cursor_Value_Input_ = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  insight?: InputMaybe<Scalars['jsonb']['input']>;
  jobId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "DocumentInsight" */
export enum DocumentInsight_Update_Column_ {
  /** column name */
  Id_ = 'id',
  /** column name */
  Insight_ = 'insight',
  /** column name */
  JobId_ = 'jobId'
}

export type DocumentInsight_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DocumentInsight_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DocumentInsight_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DocumentInsight_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DocumentInsight_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DocumentInsight_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DocumentInsight_Set_Input_>;
  /** filter the rows which have to be updated */
  where: DocumentInsight_Bool_Exp_;
};

/** columns and relationships of "DocumentationFile" */
export type DocumentationFile_ = {
  __typename?: 'DocumentationFile';
  /** An object relationship */
  company: Company_;
  companyId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  creationDate?: Maybe<Scalars['date']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  embeddings?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  lastUpdatedBy?: Maybe<Users_>;
  lastUpdatedById: Scalars['uuid']['output'];
  source: Scalars['String']['output'];
  /** An object relationship */
  storageFile?: Maybe<Files_>;
  storageFileId?: Maybe<Scalars['uuid']['output']>;
  tags: Scalars['jsonb']['output'];
  title: Scalars['String']['output'];
  token?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "DocumentationFile" */
export type DocumentationFileEmbeddingsArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "DocumentationFile" */
export type DocumentationFileTagsArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "DocumentationFile" */
export type DocumentationFile_Aggregate_ = {
  __typename?: 'DocumentationFile_aggregate';
  aggregate?: Maybe<DocumentationFile_Aggregate_Fields_>;
  nodes: Array<DocumentationFile_>;
};

export type DocumentationFile_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<DocumentationFile_Aggregate_Bool_Exp_Count_>;
};

export type DocumentationFile_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<DocumentationFile_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DocumentationFile_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "DocumentationFile" */
export type DocumentationFile_Aggregate_Fields_ = {
  __typename?: 'DocumentationFile_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<DocumentationFile_Max_Fields_>;
  min?: Maybe<DocumentationFile_Min_Fields_>;
};


/** aggregate fields of "DocumentationFile" */
export type DocumentationFile_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<DocumentationFile_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "DocumentationFile" */
export type DocumentationFile_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<DocumentationFile_Max_Order_By_>;
  min?: InputMaybe<DocumentationFile_Min_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DocumentationFile_Append_Input_ = {
  embeddings?: InputMaybe<Scalars['jsonb']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "DocumentationFile" */
export type DocumentationFile_Arr_Rel_Insert_Input_ = {
  data: Array<DocumentationFile_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<DocumentationFile_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "DocumentationFile". All fields are combined with a logical 'AND'. */
export type DocumentationFile_Bool_Exp_ = {
  _and?: InputMaybe<Array<DocumentationFile_Bool_Exp_>>;
  _not?: InputMaybe<DocumentationFile_Bool_Exp_>;
  _or?: InputMaybe<Array<DocumentationFile_Bool_Exp_>>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  creationDate?: InputMaybe<Date_Comparison_Exp_>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  description?: InputMaybe<String_Comparison_Exp_>;
  embeddings?: InputMaybe<Jsonb_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  lastUpdatedBy?: InputMaybe<Users_Bool_Exp_>;
  lastUpdatedById?: InputMaybe<Uuid_Comparison_Exp_>;
  source?: InputMaybe<String_Comparison_Exp_>;
  storageFile?: InputMaybe<Files_Bool_Exp_>;
  storageFileId?: InputMaybe<Uuid_Comparison_Exp_>;
  tags?: InputMaybe<Jsonb_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
  token?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  url?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "DocumentationFile" */
export enum DocumentationFile_Constraint_ {
  /** unique or primary key constraint on columns "storageFileId" */
  DocumentationFileStorageFileIdKey_ = 'DocumentationFile_storageFileId_key',
  /** unique or primary key constraint on columns "id" */
  FilePkey_ = 'File_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DocumentationFile_Delete_At_Path_Input_ = {
  embeddings?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DocumentationFile_Delete_Elem_Input_ = {
  embeddings?: InputMaybe<Scalars['Int']['input']>;
  tags?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DocumentationFile_Delete_Key_Input_ = {
  embeddings?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "DocumentationFile" */
export type DocumentationFile_Insert_Input_ = {
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  creationDate?: InputMaybe<Scalars['date']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embeddings?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastUpdatedBy?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  lastUpdatedById?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  storageFile?: InputMaybe<Files_Obj_Rel_Insert_Input_>;
  storageFileId?: InputMaybe<Scalars['uuid']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type DocumentationFile_Max_Fields_ = {
  __typename?: 'DocumentationFile_max_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  creationDate?: Maybe<Scalars['date']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastUpdatedById?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  storageFileId?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "DocumentationFile" */
export type DocumentationFile_Max_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  creationDate?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  lastUpdatedById?: InputMaybe<Order_By_>;
  source?: InputMaybe<Order_By_>;
  storageFileId?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  token?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  url?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type DocumentationFile_Min_Fields_ = {
  __typename?: 'DocumentationFile_min_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  creationDate?: Maybe<Scalars['date']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastUpdatedById?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  storageFileId?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "DocumentationFile" */
export type DocumentationFile_Min_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  creationDate?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  lastUpdatedById?: InputMaybe<Order_By_>;
  source?: InputMaybe<Order_By_>;
  storageFileId?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  token?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  url?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "DocumentationFile" */
export type DocumentationFile_Mutation_Response_ = {
  __typename?: 'DocumentationFile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DocumentationFile_>;
};

/** input type for inserting object relation for remote table "DocumentationFile" */
export type DocumentationFile_Obj_Rel_Insert_Input_ = {
  data: DocumentationFile_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<DocumentationFile_On_Conflict_>;
};

/** on_conflict condition type for table "DocumentationFile" */
export type DocumentationFile_On_Conflict_ = {
  constraint: DocumentationFile_Constraint_;
  update_columns?: Array<DocumentationFile_Update_Column_>;
  where?: InputMaybe<DocumentationFile_Bool_Exp_>;
};

/** Ordering options when selecting data from "DocumentationFile". */
export type DocumentationFile_Order_By_ = {
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  creationDate?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  embeddings?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  lastUpdatedBy?: InputMaybe<Users_Order_By_>;
  lastUpdatedById?: InputMaybe<Order_By_>;
  source?: InputMaybe<Order_By_>;
  storageFile?: InputMaybe<Files_Order_By_>;
  storageFileId?: InputMaybe<Order_By_>;
  tags?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  token?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  url?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: DocumentationFile */
export type DocumentationFile_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DocumentationFile_Prepend_Input_ = {
  embeddings?: InputMaybe<Scalars['jsonb']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "DocumentationFile" */
export enum DocumentationFile_Select_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  CreationDate_ = 'creationDate',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  Embeddings_ = 'embeddings',
  /** column name */
  Id_ = 'id',
  /** column name */
  LastUpdatedById_ = 'lastUpdatedById',
  /** column name */
  Source_ = 'source',
  /** column name */
  StorageFileId_ = 'storageFileId',
  /** column name */
  Tags_ = 'tags',
  /** column name */
  Title_ = 'title',
  /** column name */
  Token_ = 'token',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Url_ = 'url'
}

/** input type for updating data in table "DocumentationFile" */
export type DocumentationFile_Set_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  creationDate?: InputMaybe<Scalars['date']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embeddings?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastUpdatedById?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  storageFileId?: InputMaybe<Scalars['uuid']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "DocumentationFile" */
export type DocumentationFile_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: DocumentationFile_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type DocumentationFile_Stream_Cursor_Value_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  creationDate?: InputMaybe<Scalars['date']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embeddings?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lastUpdatedById?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  storageFileId?: InputMaybe<Scalars['uuid']['input']>;
  tags?: InputMaybe<Scalars['jsonb']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "DocumentationFile" */
export enum DocumentationFile_Update_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  CreationDate_ = 'creationDate',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  Embeddings_ = 'embeddings',
  /** column name */
  Id_ = 'id',
  /** column name */
  LastUpdatedById_ = 'lastUpdatedById',
  /** column name */
  Source_ = 'source',
  /** column name */
  StorageFileId_ = 'storageFileId',
  /** column name */
  Tags_ = 'tags',
  /** column name */
  Title_ = 'title',
  /** column name */
  Token_ = 'token',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Url_ = 'url'
}

export type DocumentationFile_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DocumentationFile_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DocumentationFile_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DocumentationFile_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DocumentationFile_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DocumentationFile_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DocumentationFile_Set_Input_>;
  /** filter the rows which have to be updated */
  where: DocumentationFile_Bool_Exp_;
};

export type EmailItem_ = {
  companyId: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

/** (user input data): The esrs assessment created for a specific reporting year. Can both be for a group and normal company. */
export type EsrsAssessment_ = {
  __typename?: 'EsrsAssessment';
  collectOnly?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  company: Company_;
  /** can be a group or normal company */
  companyId: Scalars['uuid']['output'];
  /** demanded by the EU, affects which disclosure requirements are mandatory */
  companySize?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  currency: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  esrsAssessmentCompanyIntegrations: Array<Esrs_EsrsAssessmentCompanyIntegration_>;
  /** An aggregate relationship */
  esrsAssessmentCompanyIntegrations_aggregate: Esrs_EsrsAssessmentCompanyIntegration_Aggregate_;
  /** An object relationship */
  framework?: Maybe<Framework_>;
  frameworkRef?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** A computed field, executes function "esrs.EsrsAssessment_latestDatapointUpdate" */
  latestDatapointUpdate?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "esrs.EsrsAssessment_latestMaterialMetricUpdate" */
  latestMaterialMetricUpdate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  materialStandards: Array<Esrs_MaterialStandard_>;
  /** An aggregate relationship */
  materialStandards_aggregate: Esrs_MaterialStandard_Aggregate_;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  onboardingStep?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  parentAssessment?: Maybe<EsrsAssessment_>;
  /** if its not null, the company is a part of a larger group (has a parent) */
  parentAssessmentId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  projectLeader?: Maybe<Users_>;
  projectLeaderId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  reportingUnits: Array<Esrs_ReportingUnit_>;
  /** An aggregate relationship */
  reportingUnits_aggregate: Esrs_ReportingUnit_Aggregate_;
  /** Each company can only have 1 assessment per year */
  reportingYear: Scalars['Int']['output'];
  /** An array relationship */
  subsidiaryAssessments: Array<EsrsAssessment_>;
  /** An aggregate relationship */
  subsidiaryAssessments_aggregate: EsrsAssessment_Aggregate_;
  updatedAt: Scalars['timestamptz']['output'];
};


/** (user input data): The esrs assessment created for a specific reporting year. Can both be for a group and normal company. */
export type EsrsAssessmentEsrsAssessmentCompanyIntegrationsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>;
};


/** (user input data): The esrs assessment created for a specific reporting year. Can both be for a group and normal company. */
export type EsrsAssessmentEsrsAssessmentCompanyIntegrations_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>;
};


/** (user input data): The esrs assessment created for a specific reporting year. Can both be for a group and normal company. */
export type EsrsAssessmentMaterialStandardsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialStandard_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
};


/** (user input data): The esrs assessment created for a specific reporting year. Can both be for a group and normal company. */
export type EsrsAssessmentMaterialStandards_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialStandard_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
};


/** (user input data): The esrs assessment created for a specific reporting year. Can both be for a group and normal company. */
export type EsrsAssessmentMetadataArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** (user input data): The esrs assessment created for a specific reporting year. Can both be for a group and normal company. */
export type EsrsAssessmentReportingUnitsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ReportingUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ReportingUnit_Order_By_>>;
  where?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
};


/** (user input data): The esrs assessment created for a specific reporting year. Can both be for a group and normal company. */
export type EsrsAssessmentReportingUnits_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ReportingUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ReportingUnit_Order_By_>>;
  where?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
};


/** (user input data): The esrs assessment created for a specific reporting year. Can both be for a group and normal company. */
export type EsrsAssessmentSubsidiaryAssessmentsArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsAssessment_Order_By_>>;
  where?: InputMaybe<EsrsAssessment_Bool_Exp_>;
};


/** (user input data): The esrs assessment created for a specific reporting year. Can both be for a group and normal company. */
export type EsrsAssessmentSubsidiaryAssessments_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsAssessment_Order_By_>>;
  where?: InputMaybe<EsrsAssessment_Bool_Exp_>;
};

/** aggregated selection of "esrs.EsrsAssessment" */
export type EsrsAssessment_Aggregate_ = {
  __typename?: 'EsrsAssessment_aggregate';
  aggregate?: Maybe<EsrsAssessment_Aggregate_Fields_>;
  nodes: Array<EsrsAssessment_>;
};

export type EsrsAssessment_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<EsrsAssessment_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<EsrsAssessment_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<EsrsAssessment_Aggregate_Bool_Exp_Count_>;
};

export type EsrsAssessment_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: EsrsAssessment_Select_Column_EsrsAssessment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EsrsAssessment_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type EsrsAssessment_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: EsrsAssessment_Select_Column_EsrsAssessment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EsrsAssessment_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type EsrsAssessment_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<EsrsAssessment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EsrsAssessment_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.EsrsAssessment" */
export type EsrsAssessment_Aggregate_Fields_ = {
  __typename?: 'EsrsAssessment_aggregate_fields';
  avg?: Maybe<EsrsAssessment_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<EsrsAssessment_Max_Fields_>;
  min?: Maybe<EsrsAssessment_Min_Fields_>;
  stddev?: Maybe<EsrsAssessment_Stddev_Fields_>;
  stddev_pop?: Maybe<EsrsAssessment_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<EsrsAssessment_Stddev_Samp_Fields_>;
  sum?: Maybe<EsrsAssessment_Sum_Fields_>;
  var_pop?: Maybe<EsrsAssessment_Var_Pop_Fields_>;
  var_samp?: Maybe<EsrsAssessment_Var_Samp_Fields_>;
  variance?: Maybe<EsrsAssessment_Variance_Fields_>;
};


/** aggregate fields of "esrs.EsrsAssessment" */
export type EsrsAssessment_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<EsrsAssessment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.EsrsAssessment" */
export type EsrsAssessment_Aggregate_Order_By_ = {
  avg?: InputMaybe<EsrsAssessment_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<EsrsAssessment_Max_Order_By_>;
  min?: InputMaybe<EsrsAssessment_Min_Order_By_>;
  stddev?: InputMaybe<EsrsAssessment_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<EsrsAssessment_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<EsrsAssessment_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<EsrsAssessment_Sum_Order_By_>;
  var_pop?: InputMaybe<EsrsAssessment_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<EsrsAssessment_Var_Samp_Order_By_>;
  variance?: InputMaybe<EsrsAssessment_Variance_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EsrsAssessment_Append_Input_ = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "esrs.EsrsAssessment" */
export type EsrsAssessment_Arr_Rel_Insert_Input_ = {
  data: Array<EsrsAssessment_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<EsrsAssessment_On_Conflict_>;
};

/** aggregate avg on columns */
export type EsrsAssessment_Avg_Fields_ = {
  __typename?: 'EsrsAssessment_avg_fields';
  onboardingStep?: Maybe<Scalars['Float']['output']>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.EsrsAssessment" */
export type EsrsAssessment_Avg_Order_By_ = {
  onboardingStep?: InputMaybe<Order_By_>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.EsrsAssessment". All fields are combined with a logical 'AND'. */
export type EsrsAssessment_Bool_Exp_ = {
  _and?: InputMaybe<Array<EsrsAssessment_Bool_Exp_>>;
  _not?: InputMaybe<EsrsAssessment_Bool_Exp_>;
  _or?: InputMaybe<Array<EsrsAssessment_Bool_Exp_>>;
  collectOnly?: InputMaybe<Boolean_Comparison_Exp_>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  companySize?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  currency?: InputMaybe<String_Comparison_Exp_>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  esrsAssessmentCompanyIntegrations?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>;
  esrsAssessmentCompanyIntegrations_aggregate?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Aggregate_Bool_Exp_>;
  framework?: InputMaybe<Framework_Bool_Exp_>;
  frameworkRef?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  latestDatapointUpdate?: InputMaybe<Timestamptz_Comparison_Exp_>;
  latestMaterialMetricUpdate?: InputMaybe<Timestamptz_Comparison_Exp_>;
  materialStandards?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  materialStandards_aggregate?: InputMaybe<Esrs_MaterialStandard_Aggregate_Bool_Exp_>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp_>;
  onboardingStep?: InputMaybe<Int_Comparison_Exp_>;
  parentAssessment?: InputMaybe<EsrsAssessment_Bool_Exp_>;
  parentAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  projectLeader?: InputMaybe<Users_Bool_Exp_>;
  projectLeaderId?: InputMaybe<Uuid_Comparison_Exp_>;
  reportingUnits?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
  reportingUnits_aggregate?: InputMaybe<Esrs_ReportingUnit_Aggregate_Bool_Exp_>;
  reportingYear?: InputMaybe<Int_Comparison_Exp_>;
  subsidiaryAssessments?: InputMaybe<EsrsAssessment_Bool_Exp_>;
  subsidiaryAssessments_aggregate?: InputMaybe<EsrsAssessment_Aggregate_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.EsrsAssessment" */
export enum EsrsAssessment_Constraint_ {
  /** unique or primary key constraint on columns "reportingYear", "deletedAt", "companyId" */
  EsrsAssessmentCompanyIdReportingYearDeletedAtKey_ = 'EsrsAssessment_companyId_reportingYear_deletedAt_key',
  /** unique or primary key constraint on columns "id" */
  EsrsAssessmentPkey_ = 'EsrsAssessment_pkey',
  /** unique or primary key constraint on columns "reportingYear", "companyId" */
  MaxOneUndeletedEsrsAssessmentPerYear_ = 'max_one_undeleted_esrs_assessment_per_year'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EsrsAssessment_Delete_At_Path_Input_ = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EsrsAssessment_Delete_Elem_Input_ = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EsrsAssessment_Delete_Key_Input_ = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "esrs.EsrsAssessment" */
export type EsrsAssessment_Inc_Input_ = {
  onboardingStep?: InputMaybe<Scalars['Int']['input']>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.EsrsAssessment" */
export type EsrsAssessment_Insert_Input_ = {
  collectOnly?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  /** can be a group or normal company */
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  /** demanded by the EU, affects which disclosure requirements are mandatory */
  companySize?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  esrsAssessmentCompanyIntegrations?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Arr_Rel_Insert_Input_>;
  framework?: InputMaybe<Framework_Obj_Rel_Insert_Input_>;
  frameworkRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandards?: InputMaybe<Esrs_MaterialStandard_Arr_Rel_Insert_Input_>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  onboardingStep?: InputMaybe<Scalars['Int']['input']>;
  parentAssessment?: InputMaybe<EsrsAssessment_Obj_Rel_Insert_Input_>;
  /** if its not null, the company is a part of a larger group (has a parent) */
  parentAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  projectLeader?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  projectLeaderId?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnits?: InputMaybe<Esrs_ReportingUnit_Arr_Rel_Insert_Input_>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: InputMaybe<Scalars['Int']['input']>;
  subsidiaryAssessments?: InputMaybe<EsrsAssessment_Arr_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type EsrsAssessment_Max_Fields_ = {
  __typename?: 'EsrsAssessment_max_fields';
  /** can be a group or normal company */
  companyId?: Maybe<Scalars['uuid']['output']>;
  /** demanded by the EU, affects which disclosure requirements are mandatory */
  companySize?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  frameworkRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "esrs.EsrsAssessment_latestDatapointUpdate" */
  latestDatapointUpdate?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "esrs.EsrsAssessment_latestMaterialMetricUpdate" */
  latestMaterialMetricUpdate?: Maybe<Scalars['timestamptz']['output']>;
  onboardingStep?: Maybe<Scalars['Int']['output']>;
  /** if its not null, the company is a part of a larger group (has a parent) */
  parentAssessmentId?: Maybe<Scalars['uuid']['output']>;
  projectLeaderId?: Maybe<Scalars['uuid']['output']>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.EsrsAssessment" */
export type EsrsAssessment_Max_Order_By_ = {
  /** can be a group or normal company */
  companyId?: InputMaybe<Order_By_>;
  /** demanded by the EU, affects which disclosure requirements are mandatory */
  companySize?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  currency?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  frameworkRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  onboardingStep?: InputMaybe<Order_By_>;
  /** if its not null, the company is a part of a larger group (has a parent) */
  parentAssessmentId?: InputMaybe<Order_By_>;
  projectLeaderId?: InputMaybe<Order_By_>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type EsrsAssessment_Min_Fields_ = {
  __typename?: 'EsrsAssessment_min_fields';
  /** can be a group or normal company */
  companyId?: Maybe<Scalars['uuid']['output']>;
  /** demanded by the EU, affects which disclosure requirements are mandatory */
  companySize?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  frameworkRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** A computed field, executes function "esrs.EsrsAssessment_latestDatapointUpdate" */
  latestDatapointUpdate?: Maybe<Scalars['timestamptz']['output']>;
  /** A computed field, executes function "esrs.EsrsAssessment_latestMaterialMetricUpdate" */
  latestMaterialMetricUpdate?: Maybe<Scalars['timestamptz']['output']>;
  onboardingStep?: Maybe<Scalars['Int']['output']>;
  /** if its not null, the company is a part of a larger group (has a parent) */
  parentAssessmentId?: Maybe<Scalars['uuid']['output']>;
  projectLeaderId?: Maybe<Scalars['uuid']['output']>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.EsrsAssessment" */
export type EsrsAssessment_Min_Order_By_ = {
  /** can be a group or normal company */
  companyId?: InputMaybe<Order_By_>;
  /** demanded by the EU, affects which disclosure requirements are mandatory */
  companySize?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  currency?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  frameworkRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  onboardingStep?: InputMaybe<Order_By_>;
  /** if its not null, the company is a part of a larger group (has a parent) */
  parentAssessmentId?: InputMaybe<Order_By_>;
  projectLeaderId?: InputMaybe<Order_By_>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.EsrsAssessment" */
export type EsrsAssessment_Mutation_Response_ = {
  __typename?: 'EsrsAssessment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EsrsAssessment_>;
};

/** input type for inserting object relation for remote table "esrs.EsrsAssessment" */
export type EsrsAssessment_Obj_Rel_Insert_Input_ = {
  data: EsrsAssessment_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<EsrsAssessment_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.EsrsAssessment" */
export type EsrsAssessment_On_Conflict_ = {
  constraint: EsrsAssessment_Constraint_;
  update_columns?: Array<EsrsAssessment_Update_Column_>;
  where?: InputMaybe<EsrsAssessment_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.EsrsAssessment". */
export type EsrsAssessment_Order_By_ = {
  collectOnly?: InputMaybe<Order_By_>;
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  companySize?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  currency?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  esrsAssessmentCompanyIntegrations_aggregate?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Aggregate_Order_By_>;
  framework?: InputMaybe<Framework_Order_By_>;
  frameworkRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  latestDatapointUpdate?: InputMaybe<Order_By_>;
  latestMaterialMetricUpdate?: InputMaybe<Order_By_>;
  materialStandards_aggregate?: InputMaybe<Esrs_MaterialStandard_Aggregate_Order_By_>;
  metadata?: InputMaybe<Order_By_>;
  onboardingStep?: InputMaybe<Order_By_>;
  parentAssessment?: InputMaybe<EsrsAssessment_Order_By_>;
  parentAssessmentId?: InputMaybe<Order_By_>;
  projectLeader?: InputMaybe<Users_Order_By_>;
  projectLeaderId?: InputMaybe<Order_By_>;
  reportingUnits_aggregate?: InputMaybe<Esrs_ReportingUnit_Aggregate_Order_By_>;
  reportingYear?: InputMaybe<Order_By_>;
  subsidiaryAssessments_aggregate?: InputMaybe<EsrsAssessment_Aggregate_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.EsrsAssessment */
export type EsrsAssessment_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EsrsAssessment_Prepend_Input_ = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "esrs.EsrsAssessment" */
export enum EsrsAssessment_Select_Column_ {
  /** column name */
  CollectOnly_ = 'collectOnly',
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CompanySize_ = 'companySize',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Currency_ = 'currency',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  FrameworkRef_ = 'frameworkRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  Metadata_ = 'metadata',
  /** column name */
  OnboardingStep_ = 'onboardingStep',
  /** column name */
  ParentAssessmentId_ = 'parentAssessmentId',
  /** column name */
  ProjectLeaderId_ = 'projectLeaderId',
  /** column name */
  ReportingYear_ = 'reportingYear',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "EsrsAssessment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.EsrsAssessment" */
export enum EsrsAssessment_Select_Column_EsrsAssessment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  CollectOnly_ = 'collectOnly'
}

/** select "EsrsAssessment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.EsrsAssessment" */
export enum EsrsAssessment_Select_Column_EsrsAssessment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  CollectOnly_ = 'collectOnly'
}

/** input type for updating data in table "esrs.EsrsAssessment" */
export type EsrsAssessment_Set_Input_ = {
  collectOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** can be a group or normal company */
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  /** demanded by the EU, affects which disclosure requirements are mandatory */
  companySize?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  frameworkRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  onboardingStep?: InputMaybe<Scalars['Int']['input']>;
  /** if its not null, the company is a part of a larger group (has a parent) */
  parentAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  projectLeaderId?: InputMaybe<Scalars['uuid']['input']>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type EsrsAssessment_Stddev_Fields_ = {
  __typename?: 'EsrsAssessment_stddev_fields';
  onboardingStep?: Maybe<Scalars['Float']['output']>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.EsrsAssessment" */
export type EsrsAssessment_Stddev_Order_By_ = {
  onboardingStep?: InputMaybe<Order_By_>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type EsrsAssessment_Stddev_Pop_Fields_ = {
  __typename?: 'EsrsAssessment_stddev_pop_fields';
  onboardingStep?: Maybe<Scalars['Float']['output']>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.EsrsAssessment" */
export type EsrsAssessment_Stddev_Pop_Order_By_ = {
  onboardingStep?: InputMaybe<Order_By_>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type EsrsAssessment_Stddev_Samp_Fields_ = {
  __typename?: 'EsrsAssessment_stddev_samp_fields';
  onboardingStep?: Maybe<Scalars['Float']['output']>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.EsrsAssessment" */
export type EsrsAssessment_Stddev_Samp_Order_By_ = {
  onboardingStep?: InputMaybe<Order_By_>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "EsrsAssessment" */
export type EsrsAssessment_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: EsrsAssessment_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type EsrsAssessment_Stream_Cursor_Value_Input_ = {
  collectOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** can be a group or normal company */
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  /** demanded by the EU, affects which disclosure requirements are mandatory */
  companySize?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  frameworkRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  onboardingStep?: InputMaybe<Scalars['Int']['input']>;
  /** if its not null, the company is a part of a larger group (has a parent) */
  parentAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  projectLeaderId?: InputMaybe<Scalars['uuid']['input']>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type EsrsAssessment_Sum_Fields_ = {
  __typename?: 'EsrsAssessment_sum_fields';
  onboardingStep?: Maybe<Scalars['Int']['output']>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.EsrsAssessment" */
export type EsrsAssessment_Sum_Order_By_ = {
  onboardingStep?: InputMaybe<Order_By_>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.EsrsAssessment" */
export enum EsrsAssessment_Update_Column_ {
  /** column name */
  CollectOnly_ = 'collectOnly',
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CompanySize_ = 'companySize',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Currency_ = 'currency',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  FrameworkRef_ = 'frameworkRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  Metadata_ = 'metadata',
  /** column name */
  OnboardingStep_ = 'onboardingStep',
  /** column name */
  ParentAssessmentId_ = 'parentAssessmentId',
  /** column name */
  ProjectLeaderId_ = 'projectLeaderId',
  /** column name */
  ReportingYear_ = 'reportingYear',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type EsrsAssessment_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EsrsAssessment_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EsrsAssessment_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EsrsAssessment_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EsrsAssessment_Delete_Key_Input_>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EsrsAssessment_Inc_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EsrsAssessment_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EsrsAssessment_Set_Input_>;
  /** filter the rows which have to be updated */
  where: EsrsAssessment_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type EsrsAssessment_Var_Pop_Fields_ = {
  __typename?: 'EsrsAssessment_var_pop_fields';
  onboardingStep?: Maybe<Scalars['Float']['output']>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.EsrsAssessment" */
export type EsrsAssessment_Var_Pop_Order_By_ = {
  onboardingStep?: InputMaybe<Order_By_>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type EsrsAssessment_Var_Samp_Fields_ = {
  __typename?: 'EsrsAssessment_var_samp_fields';
  onboardingStep?: Maybe<Scalars['Float']['output']>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.EsrsAssessment" */
export type EsrsAssessment_Var_Samp_Order_By_ = {
  onboardingStep?: InputMaybe<Order_By_>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type EsrsAssessment_Variance_Fields_ = {
  __typename?: 'EsrsAssessment_variance_fields';
  onboardingStep?: Maybe<Scalars['Float']['output']>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.EsrsAssessment" */
export type EsrsAssessment_Variance_Order_By_ = {
  onboardingStep?: InputMaybe<Order_By_>;
  /** Each company can only have 1 assessment per year */
  reportingYear?: InputMaybe<Order_By_>;
};

/** (admin panel): There's 4 main ESRS Categories: environment, social, governance & general - Each category has its own set of standards (EsrsStandard table)  */
export type EsrsCategory_ = {
  __typename?: 'EsrsCategory';
  isSpecial: Scalars['Boolean']['output'];
  /** Unique reference for each category, used as a foreign key in the EsrsStandard */
  reference: Scalars['String']['output'];
  /** An array relationship */
  standards: Array<EsrsStandard_>;
  /** An aggregate relationship */
  standards_aggregate: EsrsStandard_Aggregate_;
  title: Scalars['String']['output'];
};


/** (admin panel): There's 4 main ESRS Categories: environment, social, governance & general - Each category has its own set of standards (EsrsStandard table)  */
export type EsrsCategoryStandardsArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandard_Order_By_>>;
  where?: InputMaybe<EsrsStandard_Bool_Exp_>;
};


/** (admin panel): There's 4 main ESRS Categories: environment, social, governance & general - Each category has its own set of standards (EsrsStandard table)  */
export type EsrsCategoryStandards_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandard_Order_By_>>;
  where?: InputMaybe<EsrsStandard_Bool_Exp_>;
};

/** aggregated selection of "esrs.EsrsCategory" */
export type EsrsCategory_Aggregate_ = {
  __typename?: 'EsrsCategory_aggregate';
  aggregate?: Maybe<EsrsCategory_Aggregate_Fields_>;
  nodes: Array<EsrsCategory_>;
};

/** aggregate fields of "esrs.EsrsCategory" */
export type EsrsCategory_Aggregate_Fields_ = {
  __typename?: 'EsrsCategory_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<EsrsCategory_Max_Fields_>;
  min?: Maybe<EsrsCategory_Min_Fields_>;
};


/** aggregate fields of "esrs.EsrsCategory" */
export type EsrsCategory_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<EsrsCategory_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "esrs.EsrsCategory". All fields are combined with a logical 'AND'. */
export type EsrsCategory_Bool_Exp_ = {
  _and?: InputMaybe<Array<EsrsCategory_Bool_Exp_>>;
  _not?: InputMaybe<EsrsCategory_Bool_Exp_>;
  _or?: InputMaybe<Array<EsrsCategory_Bool_Exp_>>;
  isSpecial?: InputMaybe<Boolean_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  standards?: InputMaybe<EsrsStandard_Bool_Exp_>;
  standards_aggregate?: InputMaybe<EsrsStandard_Aggregate_Bool_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.EsrsCategory" */
export enum EsrsCategory_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  EsrsCategoryPkey_ = 'EsrsCategory_pkey'
}

/** input type for inserting data into table "esrs.EsrsCategory" */
export type EsrsCategory_Insert_Input_ = {
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique reference for each category, used as a foreign key in the EsrsStandard */
  reference?: InputMaybe<Scalars['String']['input']>;
  standards?: InputMaybe<EsrsStandard_Arr_Rel_Insert_Input_>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EsrsCategory_Max_Fields_ = {
  __typename?: 'EsrsCategory_max_fields';
  /** Unique reference for each category, used as a foreign key in the EsrsStandard */
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type EsrsCategory_Min_Fields_ = {
  __typename?: 'EsrsCategory_min_fields';
  /** Unique reference for each category, used as a foreign key in the EsrsStandard */
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "esrs.EsrsCategory" */
export type EsrsCategory_Mutation_Response_ = {
  __typename?: 'EsrsCategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EsrsCategory_>;
};

/** input type for inserting object relation for remote table "esrs.EsrsCategory" */
export type EsrsCategory_Obj_Rel_Insert_Input_ = {
  data: EsrsCategory_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<EsrsCategory_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.EsrsCategory" */
export type EsrsCategory_On_Conflict_ = {
  constraint: EsrsCategory_Constraint_;
  update_columns?: Array<EsrsCategory_Update_Column_>;
  where?: InputMaybe<EsrsCategory_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.EsrsCategory". */
export type EsrsCategory_Order_By_ = {
  isSpecial?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  standards_aggregate?: InputMaybe<EsrsStandard_Aggregate_Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.EsrsCategory */
export type EsrsCategory_Pk_Columns_Input_ = {
  /** Unique reference for each category, used as a foreign key in the EsrsStandard */
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.EsrsCategory" */
export enum EsrsCategory_Select_Column_ {
  /** column name */
  IsSpecial_ = 'isSpecial',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

/** input type for updating data in table "esrs.EsrsCategory" */
export type EsrsCategory_Set_Input_ = {
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique reference for each category, used as a foreign key in the EsrsStandard */
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "EsrsCategory" */
export type EsrsCategory_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: EsrsCategory_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type EsrsCategory_Stream_Cursor_Value_Input_ = {
  isSpecial?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unique reference for each category, used as a foreign key in the EsrsStandard */
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.EsrsCategory" */
export enum EsrsCategory_Update_Column_ {
  /** column name */
  IsSpecial_ = 'isSpecial',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

export type EsrsCategory_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EsrsCategory_Set_Input_>;
  /** filter the rows which have to be updated */
  where: EsrsCategory_Bool_Exp_;
};

/** columns and relationships of "esrs.EsrsChoice" */
export type EsrsChoice_ = {
  __typename?: 'EsrsChoice';
  /** An object relationship */
  choiceSet?: Maybe<ChoiceSet_>;
  choiceSetRef?: Maybe<Scalars['String']['output']>;
  order: Scalars['numeric']['output'];
  reference: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** aggregated selection of "esrs.EsrsChoice" */
export type EsrsChoice_Aggregate_ = {
  __typename?: 'EsrsChoice_aggregate';
  aggregate?: Maybe<EsrsChoice_Aggregate_Fields_>;
  nodes: Array<EsrsChoice_>;
};

export type EsrsChoice_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<EsrsChoice_Aggregate_Bool_Exp_Count_>;
};

export type EsrsChoice_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<EsrsChoice_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EsrsChoice_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.EsrsChoice" */
export type EsrsChoice_Aggregate_Fields_ = {
  __typename?: 'EsrsChoice_aggregate_fields';
  avg?: Maybe<EsrsChoice_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<EsrsChoice_Max_Fields_>;
  min?: Maybe<EsrsChoice_Min_Fields_>;
  stddev?: Maybe<EsrsChoice_Stddev_Fields_>;
  stddev_pop?: Maybe<EsrsChoice_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<EsrsChoice_Stddev_Samp_Fields_>;
  sum?: Maybe<EsrsChoice_Sum_Fields_>;
  var_pop?: Maybe<EsrsChoice_Var_Pop_Fields_>;
  var_samp?: Maybe<EsrsChoice_Var_Samp_Fields_>;
  variance?: Maybe<EsrsChoice_Variance_Fields_>;
};


/** aggregate fields of "esrs.EsrsChoice" */
export type EsrsChoice_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<EsrsChoice_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.EsrsChoice" */
export type EsrsChoice_Aggregate_Order_By_ = {
  avg?: InputMaybe<EsrsChoice_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<EsrsChoice_Max_Order_By_>;
  min?: InputMaybe<EsrsChoice_Min_Order_By_>;
  stddev?: InputMaybe<EsrsChoice_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<EsrsChoice_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<EsrsChoice_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<EsrsChoice_Sum_Order_By_>;
  var_pop?: InputMaybe<EsrsChoice_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<EsrsChoice_Var_Samp_Order_By_>;
  variance?: InputMaybe<EsrsChoice_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.EsrsChoice" */
export type EsrsChoice_Arr_Rel_Insert_Input_ = {
  data: Array<EsrsChoice_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<EsrsChoice_On_Conflict_>;
};

/** aggregate avg on columns */
export type EsrsChoice_Avg_Fields_ = {
  __typename?: 'EsrsChoice_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.EsrsChoice" */
export type EsrsChoice_Avg_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.EsrsChoice". All fields are combined with a logical 'AND'. */
export type EsrsChoice_Bool_Exp_ = {
  _and?: InputMaybe<Array<EsrsChoice_Bool_Exp_>>;
  _not?: InputMaybe<EsrsChoice_Bool_Exp_>;
  _or?: InputMaybe<Array<EsrsChoice_Bool_Exp_>>;
  choiceSet?: InputMaybe<ChoiceSet_Bool_Exp_>;
  choiceSetRef?: InputMaybe<String_Comparison_Exp_>;
  order?: InputMaybe<Numeric_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.EsrsChoice" */
export enum EsrsChoice_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  EsrsChoicePkey_ = 'EsrsChoice_pkey'
}

/** input type for incrementing numeric columns in table "esrs.EsrsChoice" */
export type EsrsChoice_Inc_Input_ = {
  order?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "esrs.EsrsChoice" */
export type EsrsChoice_Insert_Input_ = {
  choiceSet?: InputMaybe<ChoiceSet_Obj_Rel_Insert_Input_>;
  choiceSetRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['numeric']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EsrsChoice_Max_Fields_ = {
  __typename?: 'EsrsChoice_max_fields';
  choiceSetRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['numeric']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.EsrsChoice" */
export type EsrsChoice_Max_Order_By_ = {
  choiceSetRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type EsrsChoice_Min_Fields_ = {
  __typename?: 'EsrsChoice_min_fields';
  choiceSetRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['numeric']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.EsrsChoice" */
export type EsrsChoice_Min_Order_By_ = {
  choiceSetRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.EsrsChoice" */
export type EsrsChoice_Mutation_Response_ = {
  __typename?: 'EsrsChoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EsrsChoice_>;
};

/** input type for inserting object relation for remote table "esrs.EsrsChoice" */
export type EsrsChoice_Obj_Rel_Insert_Input_ = {
  data: EsrsChoice_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<EsrsChoice_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.EsrsChoice" */
export type EsrsChoice_On_Conflict_ = {
  constraint: EsrsChoice_Constraint_;
  update_columns?: Array<EsrsChoice_Update_Column_>;
  where?: InputMaybe<EsrsChoice_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.EsrsChoice". */
export type EsrsChoice_Order_By_ = {
  choiceSet?: InputMaybe<ChoiceSet_Order_By_>;
  choiceSetRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.EsrsChoice */
export type EsrsChoice_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.EsrsChoice" */
export enum EsrsChoice_Select_Column_ {
  /** column name */
  ChoiceSetRef_ = 'choiceSetRef',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

/** input type for updating data in table "esrs.EsrsChoice" */
export type EsrsChoice_Set_Input_ = {
  choiceSetRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['numeric']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type EsrsChoice_Stddev_Fields_ = {
  __typename?: 'EsrsChoice_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.EsrsChoice" */
export type EsrsChoice_Stddev_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type EsrsChoice_Stddev_Pop_Fields_ = {
  __typename?: 'EsrsChoice_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.EsrsChoice" */
export type EsrsChoice_Stddev_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type EsrsChoice_Stddev_Samp_Fields_ = {
  __typename?: 'EsrsChoice_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.EsrsChoice" */
export type EsrsChoice_Stddev_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "EsrsChoice" */
export type EsrsChoice_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: EsrsChoice_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type EsrsChoice_Stream_Cursor_Value_Input_ = {
  choiceSetRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['numeric']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type EsrsChoice_Sum_Fields_ = {
  __typename?: 'EsrsChoice_sum_fields';
  order?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "esrs.EsrsChoice" */
export type EsrsChoice_Sum_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.EsrsChoice" */
export enum EsrsChoice_Update_Column_ {
  /** column name */
  ChoiceSetRef_ = 'choiceSetRef',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

export type EsrsChoice_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EsrsChoice_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EsrsChoice_Set_Input_>;
  /** filter the rows which have to be updated */
  where: EsrsChoice_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type EsrsChoice_Var_Pop_Fields_ = {
  __typename?: 'EsrsChoice_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.EsrsChoice" */
export type EsrsChoice_Var_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type EsrsChoice_Var_Samp_Fields_ = {
  __typename?: 'EsrsChoice_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.EsrsChoice" */
export type EsrsChoice_Var_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type EsrsChoice_Variance_Fields_ = {
  __typename?: 'EsrsChoice_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.EsrsChoice" */
export type EsrsChoice_Variance_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetric_ = {
  __typename?: 'EsrsMetric';
  abbreviation?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  additionalTypes: Array<EsrsMetricAdditionalType_>;
  /** An aggregate relationship */
  additionalTypes_aggregate: EsrsMetricAdditionalType_Aggregate_;
  /** An array relationship */
  answers: Array<Esrs_Answer_>;
  /** An aggregate relationship */
  answers_aggregate: Esrs_Answer_Aggregate_;
  /** to do */
  calculation?: Maybe<Scalars['String']['output']>;
  canBeUsedForTarget: Scalars['Boolean']['output'];
  /** An array relationship */
  childrenMetrics: Array<MetricDependency_>;
  /** A computed field, executes function "esrs.get_children_count" */
  childrenMetricsCount?: Maybe<Scalars['Int']['output']>;
  /** An aggregate relationship */
  childrenMetrics_aggregate: MetricDependency_Aggregate_;
  /** An object relationship */
  choiceSet?: Maybe<ChoiceSet_>;
  choiceSetRef?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  disclosureRequirementRef: Scalars['String']['output'];
  firstLevel?: Maybe<Scalars['String']['output']>;
  globalOrder?: Maybe<Scalars['String']['output']>;
  hasAssociation: Scalars['Boolean']['output'];
  /** An object relationship */
  hierarchyStatus?: Maybe<Esrs_EsrsMetricHierarchyStatus_>;
  isAR: Scalars['Boolean']['output'];
  isAssessable: Scalars['Boolean']['output'];
  isGroup: Scalars['Boolean']['output'];
  /** An array relationship */
  materialMetrics: Array<Esrs_MaterialMetric_>;
  /** An aggregate relationship */
  materialMetrics_aggregate: Esrs_MaterialMetric_Aggregate_;
  /** defines what kind of input it should be (text, number..) */
  metricType?: Maybe<QuestionType_Enum_>;
  /** An array relationship */
  mfDisclosureRequirements: Array<MfDisclosureRequirementItem_>;
  /** An aggregate relationship */
  mfDisclosureRequirements_aggregate: MfDisclosureRequirementItem_Aggregate_;
  notAggregatable: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  /** An array relationship */
  parentMetrics: Array<MetricDependency_>;
  /** An aggregate relationship */
  parentMetrics_aggregate: MetricDependency_Aggregate_;
  reference: Scalars['String']['output'];
  /** An array relationship */
  relatedDRs: Array<Esrs_MetricRelatedDisclosureRequirement_>;
  /** An aggregate relationship */
  relatedDRs_aggregate: Esrs_MetricRelatedDisclosureRequirement_Aggregate_;
  /** An object relationship */
  requirement: DisclosureRequirement_;
  secondLevel?: Maybe<Scalars['String']['output']>;
  shortTitle?: Maybe<Scalars['String']['output']>;
  showAsPercentage?: Maybe<Scalars['Boolean']['output']>;
  showPercentageWithTag: Scalars['Boolean']['output'];
  /** An array relationship */
  tags: Array<MetricTag_>;
  /** An aggregate relationship */
  tags_aggregate: MetricTag_Aggregate_;
  title: Scalars['String']['output'];
  /** An object relationship */
  type?: Maybe<QuestionType_>;
  unitOfMeasurement?: Maybe<Scalars['String']['output']>;
  unlockCondition?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  view_childrenMetrics: Array<Esrs_MetricDependencyClosure_>;
  /** An aggregate relationship */
  view_childrenMetrics_aggregate: Esrs_MetricDependencyClosure_Aggregate_;
  /** An array relationship */
  view_parentMetrics: Array<Esrs_MetricDependencyClosure_>;
  /** An aggregate relationship */
  view_parentMetrics_aggregate: Esrs_MetricDependencyClosure_Aggregate_;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricAdditionalTypesArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsMetricAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetricAdditionalType_Order_By_>>;
  where?: InputMaybe<EsrsMetricAdditionalType_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricAdditionalTypes_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsMetricAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetricAdditionalType_Order_By_>>;
  where?: InputMaybe<EsrsMetricAdditionalType_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricAnswersArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Answer_Order_By_>>;
  where?: InputMaybe<Esrs_Answer_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricAnswers_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Answer_Order_By_>>;
  where?: InputMaybe<Esrs_Answer_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricChildrenMetricsArgs_ = {
  distinct_on?: InputMaybe<Array<MetricDependency_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricDependency_Order_By_>>;
  where?: InputMaybe<MetricDependency_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricChildrenMetrics_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MetricDependency_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricDependency_Order_By_>>;
  where?: InputMaybe<MetricDependency_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricMaterialMetricsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetric_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricMaterialMetrics_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetric_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricMfDisclosureRequirementsArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirementItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementItem_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirementItem_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricMfDisclosureRequirements_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirementItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementItem_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirementItem_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricParentMetricsArgs_ = {
  distinct_on?: InputMaybe<Array<MetricDependency_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricDependency_Order_By_>>;
  where?: InputMaybe<MetricDependency_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricParentMetrics_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MetricDependency_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricDependency_Order_By_>>;
  where?: InputMaybe<MetricDependency_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricRelatedDRsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricRelatedDRs_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricTagsArgs_ = {
  distinct_on?: InputMaybe<Array<MetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricTag_Order_By_>>;
  where?: InputMaybe<MetricTag_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricTags_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricTag_Order_By_>>;
  where?: InputMaybe<MetricTag_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricView_ChildrenMetricsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MetricDependencyClosure_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MetricDependencyClosure_Order_By_>>;
  where?: InputMaybe<Esrs_MetricDependencyClosure_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricView_ChildrenMetrics_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MetricDependencyClosure_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MetricDependencyClosure_Order_By_>>;
  where?: InputMaybe<Esrs_MetricDependencyClosure_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricView_ParentMetricsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MetricDependencyClosure_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MetricDependencyClosure_Order_By_>>;
  where?: InputMaybe<Esrs_MetricDependencyClosure_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship. Each disclosure requirement has by its own, many metrics related to it (if its type is metric). Some metrics can also be dependent on each others. */
export type EsrsMetricView_ParentMetrics_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MetricDependencyClosure_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MetricDependencyClosure_Order_By_>>;
  where?: InputMaybe<Esrs_MetricDependencyClosure_Bool_Exp_>;
};

/** columns and relationships of "esrs.EsrsMetricAdditionalType" */
export type EsrsMetricAdditionalType_ = {
  __typename?: 'EsrsMetricAdditionalType';
  /** An object relationship */
  additionalType: AdditionalType_;
  additionalTypeRef: Scalars['String']['output'];
  /** An object relationship */
  metric: EsrsMetric_;
  metricRef: Scalars['String']['output'];
};

/** aggregated selection of "esrs.EsrsMetricAdditionalType" */
export type EsrsMetricAdditionalType_Aggregate_ = {
  __typename?: 'EsrsMetricAdditionalType_aggregate';
  aggregate?: Maybe<EsrsMetricAdditionalType_Aggregate_Fields_>;
  nodes: Array<EsrsMetricAdditionalType_>;
};

export type EsrsMetricAdditionalType_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<EsrsMetricAdditionalType_Aggregate_Bool_Exp_Count_>;
};

export type EsrsMetricAdditionalType_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<EsrsMetricAdditionalType_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EsrsMetricAdditionalType_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.EsrsMetricAdditionalType" */
export type EsrsMetricAdditionalType_Aggregate_Fields_ = {
  __typename?: 'EsrsMetricAdditionalType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<EsrsMetricAdditionalType_Max_Fields_>;
  min?: Maybe<EsrsMetricAdditionalType_Min_Fields_>;
};


/** aggregate fields of "esrs.EsrsMetricAdditionalType" */
export type EsrsMetricAdditionalType_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<EsrsMetricAdditionalType_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.EsrsMetricAdditionalType" */
export type EsrsMetricAdditionalType_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<EsrsMetricAdditionalType_Max_Order_By_>;
  min?: InputMaybe<EsrsMetricAdditionalType_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.EsrsMetricAdditionalType" */
export type EsrsMetricAdditionalType_Arr_Rel_Insert_Input_ = {
  data: Array<EsrsMetricAdditionalType_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<EsrsMetricAdditionalType_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.EsrsMetricAdditionalType". All fields are combined with a logical 'AND'. */
export type EsrsMetricAdditionalType_Bool_Exp_ = {
  _and?: InputMaybe<Array<EsrsMetricAdditionalType_Bool_Exp_>>;
  _not?: InputMaybe<EsrsMetricAdditionalType_Bool_Exp_>;
  _or?: InputMaybe<Array<EsrsMetricAdditionalType_Bool_Exp_>>;
  additionalType?: InputMaybe<AdditionalType_Bool_Exp_>;
  additionalTypeRef?: InputMaybe<String_Comparison_Exp_>;
  metric?: InputMaybe<EsrsMetric_Bool_Exp_>;
  metricRef?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.EsrsMetricAdditionalType" */
export enum EsrsMetricAdditionalType_Constraint_ {
  /** unique or primary key constraint on columns "additionalTypeRef", "metricRef" */
  EsrsMetricAdditionalTypeMetricRefAdditionalTypeNameKey_ = 'EsrsMetricAdditionalType_metricRef_additionalTypeName_key',
  /** unique or primary key constraint on columns "additionalTypeRef", "metricRef" */
  EsrsMetricAdditionalTypePkey_ = 'EsrsMetricAdditionalType_pkey'
}

/** input type for inserting data into table "esrs.EsrsMetricAdditionalType" */
export type EsrsMetricAdditionalType_Insert_Input_ = {
  additionalType?: InputMaybe<AdditionalType_Obj_Rel_Insert_Input_>;
  additionalTypeRef?: InputMaybe<Scalars['String']['input']>;
  metric?: InputMaybe<EsrsMetric_Obj_Rel_Insert_Input_>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EsrsMetricAdditionalType_Max_Fields_ = {
  __typename?: 'EsrsMetricAdditionalType_max_fields';
  additionalTypeRef?: Maybe<Scalars['String']['output']>;
  metricRef?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.EsrsMetricAdditionalType" */
export type EsrsMetricAdditionalType_Max_Order_By_ = {
  additionalTypeRef?: InputMaybe<Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type EsrsMetricAdditionalType_Min_Fields_ = {
  __typename?: 'EsrsMetricAdditionalType_min_fields';
  additionalTypeRef?: Maybe<Scalars['String']['output']>;
  metricRef?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.EsrsMetricAdditionalType" */
export type EsrsMetricAdditionalType_Min_Order_By_ = {
  additionalTypeRef?: InputMaybe<Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.EsrsMetricAdditionalType" */
export type EsrsMetricAdditionalType_Mutation_Response_ = {
  __typename?: 'EsrsMetricAdditionalType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EsrsMetricAdditionalType_>;
};

/** on_conflict condition type for table "esrs.EsrsMetricAdditionalType" */
export type EsrsMetricAdditionalType_On_Conflict_ = {
  constraint: EsrsMetricAdditionalType_Constraint_;
  update_columns?: Array<EsrsMetricAdditionalType_Update_Column_>;
  where?: InputMaybe<EsrsMetricAdditionalType_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.EsrsMetricAdditionalType". */
export type EsrsMetricAdditionalType_Order_By_ = {
  additionalType?: InputMaybe<AdditionalType_Order_By_>;
  additionalTypeRef?: InputMaybe<Order_By_>;
  metric?: InputMaybe<EsrsMetric_Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.EsrsMetricAdditionalType */
export type EsrsMetricAdditionalType_Pk_Columns_Input_ = {
  additionalTypeRef: Scalars['String']['input'];
  metricRef: Scalars['String']['input'];
};

/** select columns of table "esrs.EsrsMetricAdditionalType" */
export enum EsrsMetricAdditionalType_Select_Column_ {
  /** column name */
  AdditionalTypeRef_ = 'additionalTypeRef',
  /** column name */
  MetricRef_ = 'metricRef'
}

/** input type for updating data in table "esrs.EsrsMetricAdditionalType" */
export type EsrsMetricAdditionalType_Set_Input_ = {
  additionalTypeRef?: InputMaybe<Scalars['String']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "EsrsMetricAdditionalType" */
export type EsrsMetricAdditionalType_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: EsrsMetricAdditionalType_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type EsrsMetricAdditionalType_Stream_Cursor_Value_Input_ = {
  additionalTypeRef?: InputMaybe<Scalars['String']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.EsrsMetricAdditionalType" */
export enum EsrsMetricAdditionalType_Update_Column_ {
  /** column name */
  AdditionalTypeRef_ = 'additionalTypeRef',
  /** column name */
  MetricRef_ = 'metricRef'
}

export type EsrsMetricAdditionalType_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EsrsMetricAdditionalType_Set_Input_>;
  /** filter the rows which have to be updated */
  where: EsrsMetricAdditionalType_Bool_Exp_;
};

/** aggregated selection of "esrs.EsrsMetric" */
export type EsrsMetric_Aggregate_ = {
  __typename?: 'EsrsMetric_aggregate';
  aggregate?: Maybe<EsrsMetric_Aggregate_Fields_>;
  nodes: Array<EsrsMetric_>;
};

export type EsrsMetric_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<EsrsMetric_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<EsrsMetric_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<EsrsMetric_Aggregate_Bool_Exp_Count_>;
};

export type EsrsMetric_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: EsrsMetric_Select_Column_EsrsMetric_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EsrsMetric_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type EsrsMetric_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: EsrsMetric_Select_Column_EsrsMetric_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EsrsMetric_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type EsrsMetric_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<EsrsMetric_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EsrsMetric_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.EsrsMetric" */
export type EsrsMetric_Aggregate_Fields_ = {
  __typename?: 'EsrsMetric_aggregate_fields';
  avg?: Maybe<EsrsMetric_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<EsrsMetric_Max_Fields_>;
  min?: Maybe<EsrsMetric_Min_Fields_>;
  stddev?: Maybe<EsrsMetric_Stddev_Fields_>;
  stddev_pop?: Maybe<EsrsMetric_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<EsrsMetric_Stddev_Samp_Fields_>;
  sum?: Maybe<EsrsMetric_Sum_Fields_>;
  var_pop?: Maybe<EsrsMetric_Var_Pop_Fields_>;
  var_samp?: Maybe<EsrsMetric_Var_Samp_Fields_>;
  variance?: Maybe<EsrsMetric_Variance_Fields_>;
};


/** aggregate fields of "esrs.EsrsMetric" */
export type EsrsMetric_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<EsrsMetric_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.EsrsMetric" */
export type EsrsMetric_Aggregate_Order_By_ = {
  avg?: InputMaybe<EsrsMetric_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<EsrsMetric_Max_Order_By_>;
  min?: InputMaybe<EsrsMetric_Min_Order_By_>;
  stddev?: InputMaybe<EsrsMetric_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<EsrsMetric_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<EsrsMetric_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<EsrsMetric_Sum_Order_By_>;
  var_pop?: InputMaybe<EsrsMetric_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<EsrsMetric_Var_Samp_Order_By_>;
  variance?: InputMaybe<EsrsMetric_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.EsrsMetric" */
export type EsrsMetric_Arr_Rel_Insert_Input_ = {
  data: Array<EsrsMetric_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<EsrsMetric_On_Conflict_>;
};

/** aggregate avg on columns */
export type EsrsMetric_Avg_Fields_ = {
  __typename?: 'EsrsMetric_avg_fields';
  /** A computed field, executes function "esrs.get_children_count" */
  childrenMetricsCount?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.EsrsMetric" */
export type EsrsMetric_Avg_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.EsrsMetric". All fields are combined with a logical 'AND'. */
export type EsrsMetric_Bool_Exp_ = {
  _and?: InputMaybe<Array<EsrsMetric_Bool_Exp_>>;
  _not?: InputMaybe<EsrsMetric_Bool_Exp_>;
  _or?: InputMaybe<Array<EsrsMetric_Bool_Exp_>>;
  abbreviation?: InputMaybe<String_Comparison_Exp_>;
  additionalTypes?: InputMaybe<EsrsMetricAdditionalType_Bool_Exp_>;
  additionalTypes_aggregate?: InputMaybe<EsrsMetricAdditionalType_Aggregate_Bool_Exp_>;
  answers?: InputMaybe<Esrs_Answer_Bool_Exp_>;
  answers_aggregate?: InputMaybe<Esrs_Answer_Aggregate_Bool_Exp_>;
  calculation?: InputMaybe<String_Comparison_Exp_>;
  canBeUsedForTarget?: InputMaybe<Boolean_Comparison_Exp_>;
  childrenMetrics?: InputMaybe<MetricDependency_Bool_Exp_>;
  childrenMetricsCount?: InputMaybe<Int_Comparison_Exp_>;
  childrenMetrics_aggregate?: InputMaybe<MetricDependency_Aggregate_Bool_Exp_>;
  choiceSet?: InputMaybe<ChoiceSet_Bool_Exp_>;
  choiceSetRef?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  description?: InputMaybe<String_Comparison_Exp_>;
  disclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
  firstLevel?: InputMaybe<String_Comparison_Exp_>;
  globalOrder?: InputMaybe<String_Comparison_Exp_>;
  hasAssociation?: InputMaybe<Boolean_Comparison_Exp_>;
  hierarchyStatus?: InputMaybe<Esrs_EsrsMetricHierarchyStatus_Bool_Exp_>;
  isAR?: InputMaybe<Boolean_Comparison_Exp_>;
  isAssessable?: InputMaybe<Boolean_Comparison_Exp_>;
  isGroup?: InputMaybe<Boolean_Comparison_Exp_>;
  materialMetrics?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
  materialMetrics_aggregate?: InputMaybe<Esrs_MaterialMetric_Aggregate_Bool_Exp_>;
  metricType?: InputMaybe<QuestionType_Enum_Comparison_Exp_>;
  mfDisclosureRequirements?: InputMaybe<MfDisclosureRequirementItem_Bool_Exp_>;
  mfDisclosureRequirements_aggregate?: InputMaybe<MfDisclosureRequirementItem_Aggregate_Bool_Exp_>;
  notAggregatable?: InputMaybe<Boolean_Comparison_Exp_>;
  order?: InputMaybe<Int_Comparison_Exp_>;
  parentMetrics?: InputMaybe<MetricDependency_Bool_Exp_>;
  parentMetrics_aggregate?: InputMaybe<MetricDependency_Aggregate_Bool_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  relatedDRs?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Bool_Exp_>;
  relatedDRs_aggregate?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Aggregate_Bool_Exp_>;
  requirement?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  secondLevel?: InputMaybe<String_Comparison_Exp_>;
  shortTitle?: InputMaybe<String_Comparison_Exp_>;
  showAsPercentage?: InputMaybe<Boolean_Comparison_Exp_>;
  showPercentageWithTag?: InputMaybe<Boolean_Comparison_Exp_>;
  tags?: InputMaybe<MetricTag_Bool_Exp_>;
  tags_aggregate?: InputMaybe<MetricTag_Aggregate_Bool_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
  type?: InputMaybe<QuestionType_Bool_Exp_>;
  unitOfMeasurement?: InputMaybe<String_Comparison_Exp_>;
  unlockCondition?: InputMaybe<Boolean_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  view_childrenMetrics?: InputMaybe<Esrs_MetricDependencyClosure_Bool_Exp_>;
  view_childrenMetrics_aggregate?: InputMaybe<Esrs_MetricDependencyClosure_Aggregate_Bool_Exp_>;
  view_parentMetrics?: InputMaybe<Esrs_MetricDependencyClosure_Bool_Exp_>;
  view_parentMetrics_aggregate?: InputMaybe<Esrs_MetricDependencyClosure_Aggregate_Bool_Exp_>;
};

/** unique or primary key constraints on table "esrs.EsrsMetric" */
export enum EsrsMetric_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  EsrsMetricPkey_ = 'EsrsMetric_pkey'
}

/** input type for incrementing numeric columns in table "esrs.EsrsMetric" */
export type EsrsMetric_Inc_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.EsrsMetric" */
export type EsrsMetric_Insert_Input_ = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  additionalTypes?: InputMaybe<EsrsMetricAdditionalType_Arr_Rel_Insert_Input_>;
  answers?: InputMaybe<Esrs_Answer_Arr_Rel_Insert_Input_>;
  /** to do */
  calculation?: InputMaybe<Scalars['String']['input']>;
  canBeUsedForTarget?: InputMaybe<Scalars['Boolean']['input']>;
  childrenMetrics?: InputMaybe<MetricDependency_Arr_Rel_Insert_Input_>;
  choiceSet?: InputMaybe<ChoiceSet_Obj_Rel_Insert_Input_>;
  choiceSetRef?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  firstLevel?: InputMaybe<Scalars['String']['input']>;
  globalOrder?: InputMaybe<Scalars['String']['input']>;
  hasAssociation?: InputMaybe<Scalars['Boolean']['input']>;
  hierarchyStatus?: InputMaybe<Esrs_EsrsMetricHierarchyStatus_Obj_Rel_Insert_Input_>;
  isAR?: InputMaybe<Scalars['Boolean']['input']>;
  isAssessable?: InputMaybe<Scalars['Boolean']['input']>;
  isGroup?: InputMaybe<Scalars['Boolean']['input']>;
  materialMetrics?: InputMaybe<Esrs_MaterialMetric_Arr_Rel_Insert_Input_>;
  /** defines what kind of input it should be (text, number..) */
  metricType?: InputMaybe<QuestionType_Enum_>;
  mfDisclosureRequirements?: InputMaybe<MfDisclosureRequirementItem_Arr_Rel_Insert_Input_>;
  notAggregatable?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentMetrics?: InputMaybe<MetricDependency_Arr_Rel_Insert_Input_>;
  reference?: InputMaybe<Scalars['String']['input']>;
  relatedDRs?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Arr_Rel_Insert_Input_>;
  requirement?: InputMaybe<DisclosureRequirement_Obj_Rel_Insert_Input_>;
  secondLevel?: InputMaybe<Scalars['String']['input']>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  showAsPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  showPercentageWithTag?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<MetricTag_Arr_Rel_Insert_Input_>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<QuestionType_Obj_Rel_Insert_Input_>;
  unitOfMeasurement?: InputMaybe<Scalars['String']['input']>;
  unlockCondition?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  view_childrenMetrics?: InputMaybe<Esrs_MetricDependencyClosure_Arr_Rel_Insert_Input_>;
  view_parentMetrics?: InputMaybe<Esrs_MetricDependencyClosure_Arr_Rel_Insert_Input_>;
};

/** aggregate max on columns */
export type EsrsMetric_Max_Fields_ = {
  __typename?: 'EsrsMetric_max_fields';
  abbreviation?: Maybe<Scalars['String']['output']>;
  /** to do */
  calculation?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "esrs.get_children_count" */
  childrenMetricsCount?: Maybe<Scalars['Int']['output']>;
  choiceSetRef?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  firstLevel?: Maybe<Scalars['String']['output']>;
  globalOrder?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  secondLevel?: Maybe<Scalars['String']['output']>;
  shortTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unitOfMeasurement?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.EsrsMetric" */
export type EsrsMetric_Max_Order_By_ = {
  abbreviation?: InputMaybe<Order_By_>;
  /** to do */
  calculation?: InputMaybe<Order_By_>;
  choiceSetRef?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  firstLevel?: InputMaybe<Order_By_>;
  globalOrder?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  secondLevel?: InputMaybe<Order_By_>;
  shortTitle?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  unitOfMeasurement?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type EsrsMetric_Min_Fields_ = {
  __typename?: 'EsrsMetric_min_fields';
  abbreviation?: Maybe<Scalars['String']['output']>;
  /** to do */
  calculation?: Maybe<Scalars['String']['output']>;
  /** A computed field, executes function "esrs.get_children_count" */
  childrenMetricsCount?: Maybe<Scalars['Int']['output']>;
  choiceSetRef?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  firstLevel?: Maybe<Scalars['String']['output']>;
  globalOrder?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  secondLevel?: Maybe<Scalars['String']['output']>;
  shortTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unitOfMeasurement?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.EsrsMetric" */
export type EsrsMetric_Min_Order_By_ = {
  abbreviation?: InputMaybe<Order_By_>;
  /** to do */
  calculation?: InputMaybe<Order_By_>;
  choiceSetRef?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  firstLevel?: InputMaybe<Order_By_>;
  globalOrder?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  secondLevel?: InputMaybe<Order_By_>;
  shortTitle?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  unitOfMeasurement?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.EsrsMetric" */
export type EsrsMetric_Mutation_Response_ = {
  __typename?: 'EsrsMetric_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EsrsMetric_>;
};

/** input type for inserting object relation for remote table "esrs.EsrsMetric" */
export type EsrsMetric_Obj_Rel_Insert_Input_ = {
  data: EsrsMetric_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<EsrsMetric_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.EsrsMetric" */
export type EsrsMetric_On_Conflict_ = {
  constraint: EsrsMetric_Constraint_;
  update_columns?: Array<EsrsMetric_Update_Column_>;
  where?: InputMaybe<EsrsMetric_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.EsrsMetric". */
export type EsrsMetric_Order_By_ = {
  abbreviation?: InputMaybe<Order_By_>;
  additionalTypes_aggregate?: InputMaybe<EsrsMetricAdditionalType_Aggregate_Order_By_>;
  answers_aggregate?: InputMaybe<Esrs_Answer_Aggregate_Order_By_>;
  calculation?: InputMaybe<Order_By_>;
  canBeUsedForTarget?: InputMaybe<Order_By_>;
  childrenMetricsCount?: InputMaybe<Order_By_>;
  childrenMetrics_aggregate?: InputMaybe<MetricDependency_Aggregate_Order_By_>;
  choiceSet?: InputMaybe<ChoiceSet_Order_By_>;
  choiceSetRef?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  firstLevel?: InputMaybe<Order_By_>;
  globalOrder?: InputMaybe<Order_By_>;
  hasAssociation?: InputMaybe<Order_By_>;
  hierarchyStatus?: InputMaybe<Esrs_EsrsMetricHierarchyStatus_Order_By_>;
  isAR?: InputMaybe<Order_By_>;
  isAssessable?: InputMaybe<Order_By_>;
  isGroup?: InputMaybe<Order_By_>;
  materialMetrics_aggregate?: InputMaybe<Esrs_MaterialMetric_Aggregate_Order_By_>;
  metricType?: InputMaybe<Order_By_>;
  mfDisclosureRequirements_aggregate?: InputMaybe<MfDisclosureRequirementItem_Aggregate_Order_By_>;
  notAggregatable?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  parentMetrics_aggregate?: InputMaybe<MetricDependency_Aggregate_Order_By_>;
  reference?: InputMaybe<Order_By_>;
  relatedDRs_aggregate?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Aggregate_Order_By_>;
  requirement?: InputMaybe<DisclosureRequirement_Order_By_>;
  secondLevel?: InputMaybe<Order_By_>;
  shortTitle?: InputMaybe<Order_By_>;
  showAsPercentage?: InputMaybe<Order_By_>;
  showPercentageWithTag?: InputMaybe<Order_By_>;
  tags_aggregate?: InputMaybe<MetricTag_Aggregate_Order_By_>;
  title?: InputMaybe<Order_By_>;
  type?: InputMaybe<QuestionType_Order_By_>;
  unitOfMeasurement?: InputMaybe<Order_By_>;
  unlockCondition?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  view_childrenMetrics_aggregate?: InputMaybe<Esrs_MetricDependencyClosure_Aggregate_Order_By_>;
  view_parentMetrics_aggregate?: InputMaybe<Esrs_MetricDependencyClosure_Aggregate_Order_By_>;
};

/** primary key columns input for table: esrs.EsrsMetric */
export type EsrsMetric_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.EsrsMetric" */
export enum EsrsMetric_Select_Column_ {
  /** column name */
  Abbreviation_ = 'abbreviation',
  /** column name */
  Calculation_ = 'calculation',
  /** column name */
  CanBeUsedForTarget_ = 'canBeUsedForTarget',
  /** column name */
  ChoiceSetRef_ = 'choiceSetRef',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  FirstLevel_ = 'firstLevel',
  /** column name */
  GlobalOrder_ = 'globalOrder',
  /** column name */
  HasAssociation_ = 'hasAssociation',
  /** column name */
  IsAr_ = 'isAR',
  /** column name */
  IsAssessable_ = 'isAssessable',
  /** column name */
  IsGroup_ = 'isGroup',
  /** column name */
  MetricType_ = 'metricType',
  /** column name */
  NotAggregatable_ = 'notAggregatable',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  SecondLevel_ = 'secondLevel',
  /** column name */
  ShortTitle_ = 'shortTitle',
  /** column name */
  ShowAsPercentage_ = 'showAsPercentage',
  /** column name */
  ShowPercentageWithTag_ = 'showPercentageWithTag',
  /** column name */
  Title_ = 'title',
  /** column name */
  UnitOfMeasurement_ = 'unitOfMeasurement',
  /** column name */
  UnlockCondition_ = 'unlockCondition',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "EsrsMetric_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.EsrsMetric" */
export enum EsrsMetric_Select_Column_EsrsMetric_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  CanBeUsedForTarget_ = 'canBeUsedForTarget',
  /** column name */
  HasAssociation_ = 'hasAssociation',
  /** column name */
  IsAr_ = 'isAR',
  /** column name */
  IsAssessable_ = 'isAssessable',
  /** column name */
  IsGroup_ = 'isGroup',
  /** column name */
  NotAggregatable_ = 'notAggregatable',
  /** column name */
  ShowAsPercentage_ = 'showAsPercentage',
  /** column name */
  ShowPercentageWithTag_ = 'showPercentageWithTag',
  /** column name */
  UnlockCondition_ = 'unlockCondition'
}

/** select "EsrsMetric_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.EsrsMetric" */
export enum EsrsMetric_Select_Column_EsrsMetric_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  CanBeUsedForTarget_ = 'canBeUsedForTarget',
  /** column name */
  HasAssociation_ = 'hasAssociation',
  /** column name */
  IsAr_ = 'isAR',
  /** column name */
  IsAssessable_ = 'isAssessable',
  /** column name */
  IsGroup_ = 'isGroup',
  /** column name */
  NotAggregatable_ = 'notAggregatable',
  /** column name */
  ShowAsPercentage_ = 'showAsPercentage',
  /** column name */
  ShowPercentageWithTag_ = 'showPercentageWithTag',
  /** column name */
  UnlockCondition_ = 'unlockCondition'
}

/** input type for updating data in table "esrs.EsrsMetric" */
export type EsrsMetric_Set_Input_ = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  /** to do */
  calculation?: InputMaybe<Scalars['String']['input']>;
  canBeUsedForTarget?: InputMaybe<Scalars['Boolean']['input']>;
  choiceSetRef?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  firstLevel?: InputMaybe<Scalars['String']['input']>;
  globalOrder?: InputMaybe<Scalars['String']['input']>;
  hasAssociation?: InputMaybe<Scalars['Boolean']['input']>;
  isAR?: InputMaybe<Scalars['Boolean']['input']>;
  isAssessable?: InputMaybe<Scalars['Boolean']['input']>;
  isGroup?: InputMaybe<Scalars['Boolean']['input']>;
  /** defines what kind of input it should be (text, number..) */
  metricType?: InputMaybe<QuestionType_Enum_>;
  notAggregatable?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  secondLevel?: InputMaybe<Scalars['String']['input']>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  showAsPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  showPercentageWithTag?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasurement?: InputMaybe<Scalars['String']['input']>;
  unlockCondition?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type EsrsMetric_Stddev_Fields_ = {
  __typename?: 'EsrsMetric_stddev_fields';
  /** A computed field, executes function "esrs.get_children_count" */
  childrenMetricsCount?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.EsrsMetric" */
export type EsrsMetric_Stddev_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type EsrsMetric_Stddev_Pop_Fields_ = {
  __typename?: 'EsrsMetric_stddev_pop_fields';
  /** A computed field, executes function "esrs.get_children_count" */
  childrenMetricsCount?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.EsrsMetric" */
export type EsrsMetric_Stddev_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type EsrsMetric_Stddev_Samp_Fields_ = {
  __typename?: 'EsrsMetric_stddev_samp_fields';
  /** A computed field, executes function "esrs.get_children_count" */
  childrenMetricsCount?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.EsrsMetric" */
export type EsrsMetric_Stddev_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "EsrsMetric" */
export type EsrsMetric_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: EsrsMetric_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type EsrsMetric_Stream_Cursor_Value_Input_ = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  /** to do */
  calculation?: InputMaybe<Scalars['String']['input']>;
  canBeUsedForTarget?: InputMaybe<Scalars['Boolean']['input']>;
  choiceSetRef?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  firstLevel?: InputMaybe<Scalars['String']['input']>;
  globalOrder?: InputMaybe<Scalars['String']['input']>;
  hasAssociation?: InputMaybe<Scalars['Boolean']['input']>;
  isAR?: InputMaybe<Scalars['Boolean']['input']>;
  isAssessable?: InputMaybe<Scalars['Boolean']['input']>;
  isGroup?: InputMaybe<Scalars['Boolean']['input']>;
  /** defines what kind of input it should be (text, number..) */
  metricType?: InputMaybe<QuestionType_Enum_>;
  notAggregatable?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  secondLevel?: InputMaybe<Scalars['String']['input']>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  showAsPercentage?: InputMaybe<Scalars['Boolean']['input']>;
  showPercentageWithTag?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unitOfMeasurement?: InputMaybe<Scalars['String']['input']>;
  unlockCondition?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type EsrsMetric_Sum_Fields_ = {
  __typename?: 'EsrsMetric_sum_fields';
  /** A computed field, executes function "esrs.get_children_count" */
  childrenMetricsCount?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.EsrsMetric" */
export type EsrsMetric_Sum_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.EsrsMetric" */
export enum EsrsMetric_Update_Column_ {
  /** column name */
  Abbreviation_ = 'abbreviation',
  /** column name */
  Calculation_ = 'calculation',
  /** column name */
  CanBeUsedForTarget_ = 'canBeUsedForTarget',
  /** column name */
  ChoiceSetRef_ = 'choiceSetRef',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  FirstLevel_ = 'firstLevel',
  /** column name */
  GlobalOrder_ = 'globalOrder',
  /** column name */
  HasAssociation_ = 'hasAssociation',
  /** column name */
  IsAr_ = 'isAR',
  /** column name */
  IsAssessable_ = 'isAssessable',
  /** column name */
  IsGroup_ = 'isGroup',
  /** column name */
  MetricType_ = 'metricType',
  /** column name */
  NotAggregatable_ = 'notAggregatable',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  SecondLevel_ = 'secondLevel',
  /** column name */
  ShortTitle_ = 'shortTitle',
  /** column name */
  ShowAsPercentage_ = 'showAsPercentage',
  /** column name */
  ShowPercentageWithTag_ = 'showPercentageWithTag',
  /** column name */
  Title_ = 'title',
  /** column name */
  UnitOfMeasurement_ = 'unitOfMeasurement',
  /** column name */
  UnlockCondition_ = 'unlockCondition',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type EsrsMetric_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EsrsMetric_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EsrsMetric_Set_Input_>;
  /** filter the rows which have to be updated */
  where: EsrsMetric_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type EsrsMetric_Var_Pop_Fields_ = {
  __typename?: 'EsrsMetric_var_pop_fields';
  /** A computed field, executes function "esrs.get_children_count" */
  childrenMetricsCount?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.EsrsMetric" */
export type EsrsMetric_Var_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type EsrsMetric_Var_Samp_Fields_ = {
  __typename?: 'EsrsMetric_var_samp_fields';
  /** A computed field, executes function "esrs.get_children_count" */
  childrenMetricsCount?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.EsrsMetric" */
export type EsrsMetric_Var_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type EsrsMetric_Variance_Fields_ = {
  __typename?: 'EsrsMetric_variance_fields';
  /** A computed field, executes function "esrs.get_children_count" */
  childrenMetricsCount?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.EsrsMetric" */
export type EsrsMetric_Variance_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** (admin panel): These follow a 1 to many relationship, each standard can only be present in one category, and the categories can have multiple standards directly related to it. Each standard has by its own, many disclosure requirement groups related to it.  */
export type EsrsStandard_ = {
  __typename?: 'EsrsStandard';
  /** An array relationship */
  actionQuestions: Array<ActionQuestion_>;
  /** An aggregate relationship */
  actionQuestions_aggregate: ActionQuestion_Aggregate_;
  /** An array relationship */
  additionalTypes: Array<EsrsStandardAdditionalType_>;
  /** An aggregate relationship */
  additionalTypes_aggregate: EsrsStandardAdditionalType_Aggregate_;
  /** This is the checklist sent to GPT-3, please make this as concise as possible */
  aiPolicyChecklist?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  category: EsrsCategory_;
  /** Its the category for each standard, foreign key */
  categoryRef: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  disclosureRequirementGroups: Array<DisclosureRequirementGroup_>;
  /** An aggregate relationship */
  disclosureRequirementGroups_aggregate: DisclosureRequirementGroup_Aggregate_;
  /** This is the checklist shown to users in the app */
  formattedPolicyChecklist?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  framework?: Maybe<Framework_>;
  frameworkRef?: Maybe<Scalars['String']['output']>;
  /** the EU defines each standard as topical or not - this affects how it's displayed in the tool */
  isTopical: Scalars['Boolean']['output'];
  /** An array relationship */
  materialStandards: Array<Esrs_MaterialStandard_>;
  /** An aggregate relationship */
  materialStandards_aggregate: Esrs_MaterialStandard_Aggregate_;
  /** fake standard reference to real mfStandard */
  mfStandardRef?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  mfStandards: Array<MfStandardItem_>;
  /** An aggregate relationship */
  mfStandards_aggregate: MfStandardItem_Aggregate_;
  order: Scalars['Int']['output'];
  /** Each standard has a unique reference, used as primary key */
  reference: Scalars['String']['output'];
  /** An object relationship */
  specificMFStandard?: Maybe<MfStandard_>;
  /** An array relationship */
  targetQuestions: Array<TargetQuestion_>;
  /** An aggregate relationship */
  targetQuestions_aggregate: TargetQuestion_Aggregate_;
  title: Scalars['String']['output'];
};


/** (admin panel): These follow a 1 to many relationship, each standard can only be present in one category, and the categories can have multiple standards directly related to it. Each standard has by its own, many disclosure requirement groups related to it.  */
export type EsrsStandardActionQuestionsArgs_ = {
  distinct_on?: InputMaybe<Array<ActionQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestion_Order_By_>>;
  where?: InputMaybe<ActionQuestion_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship, each standard can only be present in one category, and the categories can have multiple standards directly related to it. Each standard has by its own, many disclosure requirement groups related to it.  */
export type EsrsStandardActionQuestions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActionQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestion_Order_By_>>;
  where?: InputMaybe<ActionQuestion_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship, each standard can only be present in one category, and the categories can have multiple standards directly related to it. Each standard has by its own, many disclosure requirement groups related to it.  */
export type EsrsStandardAdditionalTypesArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsStandardAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandardAdditionalType_Order_By_>>;
  where?: InputMaybe<EsrsStandardAdditionalType_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship, each standard can only be present in one category, and the categories can have multiple standards directly related to it. Each standard has by its own, many disclosure requirement groups related to it.  */
export type EsrsStandardAdditionalTypes_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsStandardAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandardAdditionalType_Order_By_>>;
  where?: InputMaybe<EsrsStandardAdditionalType_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship, each standard can only be present in one category, and the categories can have multiple standards directly related to it. Each standard has by its own, many disclosure requirement groups related to it.  */
export type EsrsStandardDisclosureRequirementGroupsArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementGroup_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementGroup_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship, each standard can only be present in one category, and the categories can have multiple standards directly related to it. Each standard has by its own, many disclosure requirement groups related to it.  */
export type EsrsStandardDisclosureRequirementGroups_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementGroup_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementGroup_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship, each standard can only be present in one category, and the categories can have multiple standards directly related to it. Each standard has by its own, many disclosure requirement groups related to it.  */
export type EsrsStandardMaterialStandardsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialStandard_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship, each standard can only be present in one category, and the categories can have multiple standards directly related to it. Each standard has by its own, many disclosure requirement groups related to it.  */
export type EsrsStandardMaterialStandards_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialStandard_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship, each standard can only be present in one category, and the categories can have multiple standards directly related to it. Each standard has by its own, many disclosure requirement groups related to it.  */
export type EsrsStandardMfStandardsArgs_ = {
  distinct_on?: InputMaybe<Array<MfStandardItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandardItem_Order_By_>>;
  where?: InputMaybe<MfStandardItem_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship, each standard can only be present in one category, and the categories can have multiple standards directly related to it. Each standard has by its own, many disclosure requirement groups related to it.  */
export type EsrsStandardMfStandards_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfStandardItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandardItem_Order_By_>>;
  where?: InputMaybe<MfStandardItem_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship, each standard can only be present in one category, and the categories can have multiple standards directly related to it. Each standard has by its own, many disclosure requirement groups related to it.  */
export type EsrsStandardTargetQuestionsArgs_ = {
  distinct_on?: InputMaybe<Array<TargetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestion_Order_By_>>;
  where?: InputMaybe<TargetQuestion_Bool_Exp_>;
};


/** (admin panel): These follow a 1 to many relationship, each standard can only be present in one category, and the categories can have multiple standards directly related to it. Each standard has by its own, many disclosure requirement groups related to it.  */
export type EsrsStandardTargetQuestions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TargetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestion_Order_By_>>;
  where?: InputMaybe<TargetQuestion_Bool_Exp_>;
};

/** columns and relationships of "esrs.EsrsStandardAdditionalType" */
export type EsrsStandardAdditionalType_ = {
  __typename?: 'EsrsStandardAdditionalType';
  /** An object relationship */
  additionalType: AdditionalType_;
  additionalTypeRef: Scalars['String']['output'];
  /** An object relationship */
  standard: EsrsStandard_;
  standardRef: Scalars['String']['output'];
};

/** aggregated selection of "esrs.EsrsStandardAdditionalType" */
export type EsrsStandardAdditionalType_Aggregate_ = {
  __typename?: 'EsrsStandardAdditionalType_aggregate';
  aggregate?: Maybe<EsrsStandardAdditionalType_Aggregate_Fields_>;
  nodes: Array<EsrsStandardAdditionalType_>;
};

export type EsrsStandardAdditionalType_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<EsrsStandardAdditionalType_Aggregate_Bool_Exp_Count_>;
};

export type EsrsStandardAdditionalType_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<EsrsStandardAdditionalType_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EsrsStandardAdditionalType_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.EsrsStandardAdditionalType" */
export type EsrsStandardAdditionalType_Aggregate_Fields_ = {
  __typename?: 'EsrsStandardAdditionalType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<EsrsStandardAdditionalType_Max_Fields_>;
  min?: Maybe<EsrsStandardAdditionalType_Min_Fields_>;
};


/** aggregate fields of "esrs.EsrsStandardAdditionalType" */
export type EsrsStandardAdditionalType_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<EsrsStandardAdditionalType_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.EsrsStandardAdditionalType" */
export type EsrsStandardAdditionalType_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<EsrsStandardAdditionalType_Max_Order_By_>;
  min?: InputMaybe<EsrsStandardAdditionalType_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.EsrsStandardAdditionalType" */
export type EsrsStandardAdditionalType_Arr_Rel_Insert_Input_ = {
  data: Array<EsrsStandardAdditionalType_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<EsrsStandardAdditionalType_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.EsrsStandardAdditionalType". All fields are combined with a logical 'AND'. */
export type EsrsStandardAdditionalType_Bool_Exp_ = {
  _and?: InputMaybe<Array<EsrsStandardAdditionalType_Bool_Exp_>>;
  _not?: InputMaybe<EsrsStandardAdditionalType_Bool_Exp_>;
  _or?: InputMaybe<Array<EsrsStandardAdditionalType_Bool_Exp_>>;
  additionalType?: InputMaybe<AdditionalType_Bool_Exp_>;
  additionalTypeRef?: InputMaybe<String_Comparison_Exp_>;
  standard?: InputMaybe<EsrsStandard_Bool_Exp_>;
  standardRef?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.EsrsStandardAdditionalType" */
export enum EsrsStandardAdditionalType_Constraint_ {
  /** unique or primary key constraint on columns "additionalTypeRef", "standardRef" */
  EsrsStandardAdditionalTypePkey_ = 'EsrsStandardAdditionalType_pkey',
  /** unique or primary key constraint on columns "additionalTypeRef", "standardRef" */
  EsrsStandardAdditionalTypeStandardRefAdditionalTypeRefKey_ = 'EsrsStandardAdditionalType_standardRef_additionalTypeRef_key'
}

/** input type for inserting data into table "esrs.EsrsStandardAdditionalType" */
export type EsrsStandardAdditionalType_Insert_Input_ = {
  additionalType?: InputMaybe<AdditionalType_Obj_Rel_Insert_Input_>;
  additionalTypeRef?: InputMaybe<Scalars['String']['input']>;
  standard?: InputMaybe<EsrsStandard_Obj_Rel_Insert_Input_>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EsrsStandardAdditionalType_Max_Fields_ = {
  __typename?: 'EsrsStandardAdditionalType_max_fields';
  additionalTypeRef?: Maybe<Scalars['String']['output']>;
  standardRef?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.EsrsStandardAdditionalType" */
export type EsrsStandardAdditionalType_Max_Order_By_ = {
  additionalTypeRef?: InputMaybe<Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type EsrsStandardAdditionalType_Min_Fields_ = {
  __typename?: 'EsrsStandardAdditionalType_min_fields';
  additionalTypeRef?: Maybe<Scalars['String']['output']>;
  standardRef?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.EsrsStandardAdditionalType" */
export type EsrsStandardAdditionalType_Min_Order_By_ = {
  additionalTypeRef?: InputMaybe<Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.EsrsStandardAdditionalType" */
export type EsrsStandardAdditionalType_Mutation_Response_ = {
  __typename?: 'EsrsStandardAdditionalType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EsrsStandardAdditionalType_>;
};

/** on_conflict condition type for table "esrs.EsrsStandardAdditionalType" */
export type EsrsStandardAdditionalType_On_Conflict_ = {
  constraint: EsrsStandardAdditionalType_Constraint_;
  update_columns?: Array<EsrsStandardAdditionalType_Update_Column_>;
  where?: InputMaybe<EsrsStandardAdditionalType_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.EsrsStandardAdditionalType". */
export type EsrsStandardAdditionalType_Order_By_ = {
  additionalType?: InputMaybe<AdditionalType_Order_By_>;
  additionalTypeRef?: InputMaybe<Order_By_>;
  standard?: InputMaybe<EsrsStandard_Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.EsrsStandardAdditionalType */
export type EsrsStandardAdditionalType_Pk_Columns_Input_ = {
  additionalTypeRef: Scalars['String']['input'];
  standardRef: Scalars['String']['input'];
};

/** select columns of table "esrs.EsrsStandardAdditionalType" */
export enum EsrsStandardAdditionalType_Select_Column_ {
  /** column name */
  AdditionalTypeRef_ = 'additionalTypeRef',
  /** column name */
  StandardRef_ = 'standardRef'
}

/** input type for updating data in table "esrs.EsrsStandardAdditionalType" */
export type EsrsStandardAdditionalType_Set_Input_ = {
  additionalTypeRef?: InputMaybe<Scalars['String']['input']>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "EsrsStandardAdditionalType" */
export type EsrsStandardAdditionalType_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: EsrsStandardAdditionalType_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type EsrsStandardAdditionalType_Stream_Cursor_Value_Input_ = {
  additionalTypeRef?: InputMaybe<Scalars['String']['input']>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.EsrsStandardAdditionalType" */
export enum EsrsStandardAdditionalType_Update_Column_ {
  /** column name */
  AdditionalTypeRef_ = 'additionalTypeRef',
  /** column name */
  StandardRef_ = 'standardRef'
}

export type EsrsStandardAdditionalType_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EsrsStandardAdditionalType_Set_Input_>;
  /** filter the rows which have to be updated */
  where: EsrsStandardAdditionalType_Bool_Exp_;
};

/** aggregated selection of "esrs.EsrsStandard" */
export type EsrsStandard_Aggregate_ = {
  __typename?: 'EsrsStandard_aggregate';
  aggregate?: Maybe<EsrsStandard_Aggregate_Fields_>;
  nodes: Array<EsrsStandard_>;
};

export type EsrsStandard_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<EsrsStandard_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<EsrsStandard_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<EsrsStandard_Aggregate_Bool_Exp_Count_>;
};

export type EsrsStandard_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: EsrsStandard_Select_Column_EsrsStandard_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EsrsStandard_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type EsrsStandard_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: EsrsStandard_Select_Column_EsrsStandard_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EsrsStandard_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type EsrsStandard_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<EsrsStandard_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EsrsStandard_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.EsrsStandard" */
export type EsrsStandard_Aggregate_Fields_ = {
  __typename?: 'EsrsStandard_aggregate_fields';
  avg?: Maybe<EsrsStandard_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<EsrsStandard_Max_Fields_>;
  min?: Maybe<EsrsStandard_Min_Fields_>;
  stddev?: Maybe<EsrsStandard_Stddev_Fields_>;
  stddev_pop?: Maybe<EsrsStandard_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<EsrsStandard_Stddev_Samp_Fields_>;
  sum?: Maybe<EsrsStandard_Sum_Fields_>;
  var_pop?: Maybe<EsrsStandard_Var_Pop_Fields_>;
  var_samp?: Maybe<EsrsStandard_Var_Samp_Fields_>;
  variance?: Maybe<EsrsStandard_Variance_Fields_>;
};


/** aggregate fields of "esrs.EsrsStandard" */
export type EsrsStandard_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<EsrsStandard_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.EsrsStandard" */
export type EsrsStandard_Aggregate_Order_By_ = {
  avg?: InputMaybe<EsrsStandard_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<EsrsStandard_Max_Order_By_>;
  min?: InputMaybe<EsrsStandard_Min_Order_By_>;
  stddev?: InputMaybe<EsrsStandard_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<EsrsStandard_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<EsrsStandard_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<EsrsStandard_Sum_Order_By_>;
  var_pop?: InputMaybe<EsrsStandard_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<EsrsStandard_Var_Samp_Order_By_>;
  variance?: InputMaybe<EsrsStandard_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.EsrsStandard" */
export type EsrsStandard_Arr_Rel_Insert_Input_ = {
  data: Array<EsrsStandard_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<EsrsStandard_On_Conflict_>;
};

/** aggregate avg on columns */
export type EsrsStandard_Avg_Fields_ = {
  __typename?: 'EsrsStandard_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.EsrsStandard" */
export type EsrsStandard_Avg_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.EsrsStandard". All fields are combined with a logical 'AND'. */
export type EsrsStandard_Bool_Exp_ = {
  _and?: InputMaybe<Array<EsrsStandard_Bool_Exp_>>;
  _not?: InputMaybe<EsrsStandard_Bool_Exp_>;
  _or?: InputMaybe<Array<EsrsStandard_Bool_Exp_>>;
  actionQuestions?: InputMaybe<ActionQuestion_Bool_Exp_>;
  actionQuestions_aggregate?: InputMaybe<ActionQuestion_Aggregate_Bool_Exp_>;
  additionalTypes?: InputMaybe<EsrsStandardAdditionalType_Bool_Exp_>;
  additionalTypes_aggregate?: InputMaybe<EsrsStandardAdditionalType_Aggregate_Bool_Exp_>;
  aiPolicyChecklist?: InputMaybe<String_Comparison_Exp_>;
  category?: InputMaybe<EsrsCategory_Bool_Exp_>;
  categoryRef?: InputMaybe<String_Comparison_Exp_>;
  description?: InputMaybe<String_Comparison_Exp_>;
  disclosureRequirementGroups?: InputMaybe<DisclosureRequirementGroup_Bool_Exp_>;
  disclosureRequirementGroups_aggregate?: InputMaybe<DisclosureRequirementGroup_Aggregate_Bool_Exp_>;
  formattedPolicyChecklist?: InputMaybe<String_Comparison_Exp_>;
  framework?: InputMaybe<Framework_Bool_Exp_>;
  frameworkRef?: InputMaybe<String_Comparison_Exp_>;
  isTopical?: InputMaybe<Boolean_Comparison_Exp_>;
  materialStandards?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  materialStandards_aggregate?: InputMaybe<Esrs_MaterialStandard_Aggregate_Bool_Exp_>;
  mfStandardRef?: InputMaybe<String_Comparison_Exp_>;
  mfStandards?: InputMaybe<MfStandardItem_Bool_Exp_>;
  mfStandards_aggregate?: InputMaybe<MfStandardItem_Aggregate_Bool_Exp_>;
  order?: InputMaybe<Int_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  specificMFStandard?: InputMaybe<MfStandard_Bool_Exp_>;
  targetQuestions?: InputMaybe<TargetQuestion_Bool_Exp_>;
  targetQuestions_aggregate?: InputMaybe<TargetQuestion_Aggregate_Bool_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.EsrsStandard" */
export enum EsrsStandard_Constraint_ {
  /** unique or primary key constraint on columns "mfStandardRef" */
  EsrsStandardMfStandardRefKey_ = 'EsrsStandard_mfStandardRef_key',
  /** unique or primary key constraint on columns "reference" */
  EsrsStandardPkey_ = 'EsrsStandard_pkey',
  /** unique or primary key constraint on columns "reference" */
  EsrsStandardReferenceKey_ = 'EsrsStandard_reference_key'
}

/** input type for incrementing numeric columns in table "esrs.EsrsStandard" */
export type EsrsStandard_Inc_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.EsrsStandard" */
export type EsrsStandard_Insert_Input_ = {
  actionQuestions?: InputMaybe<ActionQuestion_Arr_Rel_Insert_Input_>;
  additionalTypes?: InputMaybe<EsrsStandardAdditionalType_Arr_Rel_Insert_Input_>;
  /** This is the checklist sent to GPT-3, please make this as concise as possible */
  aiPolicyChecklist?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<EsrsCategory_Obj_Rel_Insert_Input_>;
  /** Its the category for each standard, foreign key */
  categoryRef?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disclosureRequirementGroups?: InputMaybe<DisclosureRequirementGroup_Arr_Rel_Insert_Input_>;
  /** This is the checklist shown to users in the app */
  formattedPolicyChecklist?: InputMaybe<Scalars['String']['input']>;
  framework?: InputMaybe<Framework_Obj_Rel_Insert_Input_>;
  frameworkRef?: InputMaybe<Scalars['String']['input']>;
  /** the EU defines each standard as topical or not - this affects how it's displayed in the tool */
  isTopical?: InputMaybe<Scalars['Boolean']['input']>;
  materialStandards?: InputMaybe<Esrs_MaterialStandard_Arr_Rel_Insert_Input_>;
  /** fake standard reference to real mfStandard */
  mfStandardRef?: InputMaybe<Scalars['String']['input']>;
  mfStandards?: InputMaybe<MfStandardItem_Arr_Rel_Insert_Input_>;
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Each standard has a unique reference, used as primary key */
  reference?: InputMaybe<Scalars['String']['input']>;
  specificMFStandard?: InputMaybe<MfStandard_Obj_Rel_Insert_Input_>;
  targetQuestions?: InputMaybe<TargetQuestion_Arr_Rel_Insert_Input_>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type EsrsStandard_Max_Fields_ = {
  __typename?: 'EsrsStandard_max_fields';
  /** This is the checklist sent to GPT-3, please make this as concise as possible */
  aiPolicyChecklist?: Maybe<Scalars['String']['output']>;
  /** Its the category for each standard, foreign key */
  categoryRef?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** This is the checklist shown to users in the app */
  formattedPolicyChecklist?: Maybe<Scalars['String']['output']>;
  frameworkRef?: Maybe<Scalars['String']['output']>;
  /** fake standard reference to real mfStandard */
  mfStandardRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  /** Each standard has a unique reference, used as primary key */
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.EsrsStandard" */
export type EsrsStandard_Max_Order_By_ = {
  /** This is the checklist sent to GPT-3, please make this as concise as possible */
  aiPolicyChecklist?: InputMaybe<Order_By_>;
  /** Its the category for each standard, foreign key */
  categoryRef?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  /** This is the checklist shown to users in the app */
  formattedPolicyChecklist?: InputMaybe<Order_By_>;
  frameworkRef?: InputMaybe<Order_By_>;
  /** fake standard reference to real mfStandard */
  mfStandardRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  /** Each standard has a unique reference, used as primary key */
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type EsrsStandard_Min_Fields_ = {
  __typename?: 'EsrsStandard_min_fields';
  /** This is the checklist sent to GPT-3, please make this as concise as possible */
  aiPolicyChecklist?: Maybe<Scalars['String']['output']>;
  /** Its the category for each standard, foreign key */
  categoryRef?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** This is the checklist shown to users in the app */
  formattedPolicyChecklist?: Maybe<Scalars['String']['output']>;
  frameworkRef?: Maybe<Scalars['String']['output']>;
  /** fake standard reference to real mfStandard */
  mfStandardRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  /** Each standard has a unique reference, used as primary key */
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.EsrsStandard" */
export type EsrsStandard_Min_Order_By_ = {
  /** This is the checklist sent to GPT-3, please make this as concise as possible */
  aiPolicyChecklist?: InputMaybe<Order_By_>;
  /** Its the category for each standard, foreign key */
  categoryRef?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  /** This is the checklist shown to users in the app */
  formattedPolicyChecklist?: InputMaybe<Order_By_>;
  frameworkRef?: InputMaybe<Order_By_>;
  /** fake standard reference to real mfStandard */
  mfStandardRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  /** Each standard has a unique reference, used as primary key */
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.EsrsStandard" */
export type EsrsStandard_Mutation_Response_ = {
  __typename?: 'EsrsStandard_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EsrsStandard_>;
};

/** input type for inserting object relation for remote table "esrs.EsrsStandard" */
export type EsrsStandard_Obj_Rel_Insert_Input_ = {
  data: EsrsStandard_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<EsrsStandard_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.EsrsStandard" */
export type EsrsStandard_On_Conflict_ = {
  constraint: EsrsStandard_Constraint_;
  update_columns?: Array<EsrsStandard_Update_Column_>;
  where?: InputMaybe<EsrsStandard_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.EsrsStandard". */
export type EsrsStandard_Order_By_ = {
  actionQuestions_aggregate?: InputMaybe<ActionQuestion_Aggregate_Order_By_>;
  additionalTypes_aggregate?: InputMaybe<EsrsStandardAdditionalType_Aggregate_Order_By_>;
  aiPolicyChecklist?: InputMaybe<Order_By_>;
  category?: InputMaybe<EsrsCategory_Order_By_>;
  categoryRef?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  disclosureRequirementGroups_aggregate?: InputMaybe<DisclosureRequirementGroup_Aggregate_Order_By_>;
  formattedPolicyChecklist?: InputMaybe<Order_By_>;
  framework?: InputMaybe<Framework_Order_By_>;
  frameworkRef?: InputMaybe<Order_By_>;
  isTopical?: InputMaybe<Order_By_>;
  materialStandards_aggregate?: InputMaybe<Esrs_MaterialStandard_Aggregate_Order_By_>;
  mfStandardRef?: InputMaybe<Order_By_>;
  mfStandards_aggregate?: InputMaybe<MfStandardItem_Aggregate_Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  specificMFStandard?: InputMaybe<MfStandard_Order_By_>;
  targetQuestions_aggregate?: InputMaybe<TargetQuestion_Aggregate_Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.EsrsStandard */
export type EsrsStandard_Pk_Columns_Input_ = {
  /** Each standard has a unique reference, used as primary key */
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.EsrsStandard" */
export enum EsrsStandard_Select_Column_ {
  /** column name */
  AiPolicyChecklist_ = 'aiPolicyChecklist',
  /** column name */
  CategoryRef_ = 'categoryRef',
  /** column name */
  Description_ = 'description',
  /** column name */
  FormattedPolicyChecklist_ = 'formattedPolicyChecklist',
  /** column name */
  FrameworkRef_ = 'frameworkRef',
  /** column name */
  IsTopical_ = 'isTopical',
  /** column name */
  MfStandardRef_ = 'mfStandardRef',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

/** select "EsrsStandard_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.EsrsStandard" */
export enum EsrsStandard_Select_Column_EsrsStandard_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsTopical_ = 'isTopical'
}

/** select "EsrsStandard_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.EsrsStandard" */
export enum EsrsStandard_Select_Column_EsrsStandard_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsTopical_ = 'isTopical'
}

/** input type for updating data in table "esrs.EsrsStandard" */
export type EsrsStandard_Set_Input_ = {
  /** This is the checklist sent to GPT-3, please make this as concise as possible */
  aiPolicyChecklist?: InputMaybe<Scalars['String']['input']>;
  /** Its the category for each standard, foreign key */
  categoryRef?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** This is the checklist shown to users in the app */
  formattedPolicyChecklist?: InputMaybe<Scalars['String']['input']>;
  frameworkRef?: InputMaybe<Scalars['String']['input']>;
  /** the EU defines each standard as topical or not - this affects how it's displayed in the tool */
  isTopical?: InputMaybe<Scalars['Boolean']['input']>;
  /** fake standard reference to real mfStandard */
  mfStandardRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Each standard has a unique reference, used as primary key */
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type EsrsStandard_Stddev_Fields_ = {
  __typename?: 'EsrsStandard_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.EsrsStandard" */
export type EsrsStandard_Stddev_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type EsrsStandard_Stddev_Pop_Fields_ = {
  __typename?: 'EsrsStandard_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.EsrsStandard" */
export type EsrsStandard_Stddev_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type EsrsStandard_Stddev_Samp_Fields_ = {
  __typename?: 'EsrsStandard_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.EsrsStandard" */
export type EsrsStandard_Stddev_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "EsrsStandard" */
export type EsrsStandard_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: EsrsStandard_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type EsrsStandard_Stream_Cursor_Value_Input_ = {
  /** This is the checklist sent to GPT-3, please make this as concise as possible */
  aiPolicyChecklist?: InputMaybe<Scalars['String']['input']>;
  /** Its the category for each standard, foreign key */
  categoryRef?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** This is the checklist shown to users in the app */
  formattedPolicyChecklist?: InputMaybe<Scalars['String']['input']>;
  frameworkRef?: InputMaybe<Scalars['String']['input']>;
  /** the EU defines each standard as topical or not - this affects how it's displayed in the tool */
  isTopical?: InputMaybe<Scalars['Boolean']['input']>;
  /** fake standard reference to real mfStandard */
  mfStandardRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Each standard has a unique reference, used as primary key */
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type EsrsStandard_Sum_Fields_ = {
  __typename?: 'EsrsStandard_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.EsrsStandard" */
export type EsrsStandard_Sum_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.EsrsStandard" */
export enum EsrsStandard_Update_Column_ {
  /** column name */
  AiPolicyChecklist_ = 'aiPolicyChecklist',
  /** column name */
  CategoryRef_ = 'categoryRef',
  /** column name */
  Description_ = 'description',
  /** column name */
  FormattedPolicyChecklist_ = 'formattedPolicyChecklist',
  /** column name */
  FrameworkRef_ = 'frameworkRef',
  /** column name */
  IsTopical_ = 'isTopical',
  /** column name */
  MfStandardRef_ = 'mfStandardRef',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

export type EsrsStandard_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EsrsStandard_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EsrsStandard_Set_Input_>;
  /** filter the rows which have to be updated */
  where: EsrsStandard_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type EsrsStandard_Var_Pop_Fields_ = {
  __typename?: 'EsrsStandard_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.EsrsStandard" */
export type EsrsStandard_Var_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type EsrsStandard_Var_Samp_Fields_ = {
  __typename?: 'EsrsStandard_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.EsrsStandard" */
export type EsrsStandard_Var_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type EsrsStandard_Variance_Fields_ = {
  __typename?: 'EsrsStandard_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.EsrsStandard" */
export type EsrsStandard_Variance_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** columns and relationships of "EstimateCompany_deprecated" */
export type EstimateCompany_Deprecated_ = {
  __typename?: 'EstimateCompany_deprecated';
  /** An array relationship */
  PortfolioCompanies: Array<PortfolioCompany_>;
  /** An aggregate relationship */
  PortfolioCompanies_aggregate: PortfolioCompany_Aggregate_;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  industries: Scalars['jsonb']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['jsonb']['output'];
  name: Scalars['String']['output'];
  scoreType: Scalars['String']['output'];
  scores: Scalars['jsonb']['output'];
  uniqueId: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "EstimateCompany_deprecated" */
export type EstimateCompany_DeprecatedPortfolioCompaniesArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "EstimateCompany_deprecated" */
export type EstimateCompany_DeprecatedPortfolioCompanies_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "EstimateCompany_deprecated" */
export type EstimateCompany_DeprecatedIndustriesArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "EstimateCompany_deprecated" */
export type EstimateCompany_DeprecatedMetadataArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "EstimateCompany_deprecated" */
export type EstimateCompany_DeprecatedScoresArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "EstimateCompany_deprecated" */
export type EstimateCompany_Deprecated_Aggregate_ = {
  __typename?: 'EstimateCompany_deprecated_aggregate';
  aggregate?: Maybe<EstimateCompany_Deprecated_Aggregate_Fields_>;
  nodes: Array<EstimateCompany_Deprecated_>;
};

/** aggregate fields of "EstimateCompany_deprecated" */
export type EstimateCompany_Deprecated_Aggregate_Fields_ = {
  __typename?: 'EstimateCompany_deprecated_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<EstimateCompany_Deprecated_Max_Fields_>;
  min?: Maybe<EstimateCompany_Deprecated_Min_Fields_>;
};


/** aggregate fields of "EstimateCompany_deprecated" */
export type EstimateCompany_Deprecated_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<EstimateCompany_Deprecated_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EstimateCompany_Deprecated_Append_Input_ = {
  industries?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  scores?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "EstimateCompany_deprecated". All fields are combined with a logical 'AND'. */
export type EstimateCompany_Deprecated_Bool_Exp_ = {
  PortfolioCompanies?: InputMaybe<PortfolioCompany_Bool_Exp_>;
  PortfolioCompanies_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Bool_Exp_>;
  _and?: InputMaybe<Array<EstimateCompany_Deprecated_Bool_Exp_>>;
  _not?: InputMaybe<EstimateCompany_Deprecated_Bool_Exp_>;
  _or?: InputMaybe<Array<EstimateCompany_Deprecated_Bool_Exp_>>;
  country?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  industries?: InputMaybe<Jsonb_Comparison_Exp_>;
  logoUrl?: InputMaybe<String_Comparison_Exp_>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  scoreType?: InputMaybe<String_Comparison_Exp_>;
  scores?: InputMaybe<Jsonb_Comparison_Exp_>;
  uniqueId?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "EstimateCompany_deprecated" */
export enum EstimateCompany_Deprecated_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  EstimateCompanyPkey_ = 'EstimateCompany_pkey',
  /** unique or primary key constraint on columns "uniqueId" */
  EstimateCompanyUniqueIdKey_ = 'EstimateCompany_uniqueId_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EstimateCompany_Deprecated_Delete_At_Path_Input_ = {
  industries?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  scores?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EstimateCompany_Deprecated_Delete_Elem_Input_ = {
  industries?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Int']['input']>;
  scores?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EstimateCompany_Deprecated_Delete_Key_Input_ = {
  industries?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  scores?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "EstimateCompany_deprecated" */
export type EstimateCompany_Deprecated_Insert_Input_ = {
  PortfolioCompanies?: InputMaybe<PortfolioCompany_Arr_Rel_Insert_Input_>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  industries?: InputMaybe<Scalars['jsonb']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  scores?: InputMaybe<Scalars['jsonb']['input']>;
  uniqueId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type EstimateCompany_Deprecated_Max_Fields_ = {
  __typename?: 'EstimateCompany_deprecated_max_fields';
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scoreType?: Maybe<Scalars['String']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type EstimateCompany_Deprecated_Min_Fields_ = {
  __typename?: 'EstimateCompany_deprecated_min_fields';
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  scoreType?: Maybe<Scalars['String']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "EstimateCompany_deprecated" */
export type EstimateCompany_Deprecated_Mutation_Response_ = {
  __typename?: 'EstimateCompany_deprecated_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EstimateCompany_Deprecated_>;
};

/** input type for inserting object relation for remote table "EstimateCompany_deprecated" */
export type EstimateCompany_Deprecated_Obj_Rel_Insert_Input_ = {
  data: EstimateCompany_Deprecated_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<EstimateCompany_Deprecated_On_Conflict_>;
};

/** on_conflict condition type for table "EstimateCompany_deprecated" */
export type EstimateCompany_Deprecated_On_Conflict_ = {
  constraint: EstimateCompany_Deprecated_Constraint_;
  update_columns?: Array<EstimateCompany_Deprecated_Update_Column_>;
  where?: InputMaybe<EstimateCompany_Deprecated_Bool_Exp_>;
};

/** Ordering options when selecting data from "EstimateCompany_deprecated". */
export type EstimateCompany_Deprecated_Order_By_ = {
  PortfolioCompanies_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Order_By_>;
  country?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  industries?: InputMaybe<Order_By_>;
  logoUrl?: InputMaybe<Order_By_>;
  metadata?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  scoreType?: InputMaybe<Order_By_>;
  scores?: InputMaybe<Order_By_>;
  uniqueId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: EstimateCompany_deprecated */
export type EstimateCompany_Deprecated_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EstimateCompany_Deprecated_Prepend_Input_ = {
  industries?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  scores?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "EstimateCompany_deprecated" */
export enum EstimateCompany_Deprecated_Select_Column_ {
  /** column name */
  Country_ = 'country',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Industries_ = 'industries',
  /** column name */
  LogoUrl_ = 'logoUrl',
  /** column name */
  Metadata_ = 'metadata',
  /** column name */
  Name_ = 'name',
  /** column name */
  ScoreType_ = 'scoreType',
  /** column name */
  Scores_ = 'scores',
  /** column name */
  UniqueId_ = 'uniqueId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "EstimateCompany_deprecated" */
export type EstimateCompany_Deprecated_Set_Input_ = {
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  industries?: InputMaybe<Scalars['jsonb']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  scores?: InputMaybe<Scalars['jsonb']['input']>;
  uniqueId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "EstimateCompany_deprecated" */
export type EstimateCompany_Deprecated_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: EstimateCompany_Deprecated_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type EstimateCompany_Deprecated_Stream_Cursor_Value_Input_ = {
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  industries?: InputMaybe<Scalars['jsonb']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  scores?: InputMaybe<Scalars['jsonb']['input']>;
  uniqueId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "EstimateCompany_deprecated" */
export enum EstimateCompany_Deprecated_Update_Column_ {
  /** column name */
  Country_ = 'country',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Industries_ = 'industries',
  /** column name */
  LogoUrl_ = 'logoUrl',
  /** column name */
  Metadata_ = 'metadata',
  /** column name */
  Name_ = 'name',
  /** column name */
  ScoreType_ = 'scoreType',
  /** column name */
  Scores_ = 'scores',
  /** column name */
  UniqueId_ = 'uniqueId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type EstimateCompany_Deprecated_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EstimateCompany_Deprecated_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<EstimateCompany_Deprecated_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<EstimateCompany_Deprecated_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<EstimateCompany_Deprecated_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EstimateCompany_Deprecated_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EstimateCompany_Deprecated_Set_Input_>;
  /** filter the rows which have to be updated */
  where: EstimateCompany_Deprecated_Bool_Exp_;
};

/** columns and relationships of "ExtractionJob" */
export type ExtractionJob_ = {
  __typename?: 'ExtractionJob';
  /** An object relationship */
  documentationFile: DocumentationFile_;
  documentationFileId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  insights: Array<DocumentInsight_>;
  /** An aggregate relationship */
  insights_aggregate: DocumentInsight_Aggregate_;
  progress: Scalars['Int']['output'];
  results?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "ExtractionJob" */
export type ExtractionJobInsightsArgs_ = {
  distinct_on?: InputMaybe<Array<DocumentInsight_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DocumentInsight_Order_By_>>;
  where?: InputMaybe<DocumentInsight_Bool_Exp_>;
};


/** columns and relationships of "ExtractionJob" */
export type ExtractionJobInsights_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DocumentInsight_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DocumentInsight_Order_By_>>;
  where?: InputMaybe<DocumentInsight_Bool_Exp_>;
};


/** columns and relationships of "ExtractionJob" */
export type ExtractionJobResultsArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "ExtractionJob" */
export type ExtractionJob_Aggregate_ = {
  __typename?: 'ExtractionJob_aggregate';
  aggregate?: Maybe<ExtractionJob_Aggregate_Fields_>;
  nodes: Array<ExtractionJob_>;
};

/** aggregate fields of "ExtractionJob" */
export type ExtractionJob_Aggregate_Fields_ = {
  __typename?: 'ExtractionJob_aggregate_fields';
  avg?: Maybe<ExtractionJob_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<ExtractionJob_Max_Fields_>;
  min?: Maybe<ExtractionJob_Min_Fields_>;
  stddev?: Maybe<ExtractionJob_Stddev_Fields_>;
  stddev_pop?: Maybe<ExtractionJob_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<ExtractionJob_Stddev_Samp_Fields_>;
  sum?: Maybe<ExtractionJob_Sum_Fields_>;
  var_pop?: Maybe<ExtractionJob_Var_Pop_Fields_>;
  var_samp?: Maybe<ExtractionJob_Var_Samp_Fields_>;
  variance?: Maybe<ExtractionJob_Variance_Fields_>;
};


/** aggregate fields of "ExtractionJob" */
export type ExtractionJob_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<ExtractionJob_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ExtractionJob_Append_Input_ = {
  results?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type ExtractionJob_Avg_Fields_ = {
  __typename?: 'ExtractionJob_avg_fields';
  progress?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "ExtractionJob". All fields are combined with a logical 'AND'. */
export type ExtractionJob_Bool_Exp_ = {
  _and?: InputMaybe<Array<ExtractionJob_Bool_Exp_>>;
  _not?: InputMaybe<ExtractionJob_Bool_Exp_>;
  _or?: InputMaybe<Array<ExtractionJob_Bool_Exp_>>;
  documentationFile?: InputMaybe<DocumentationFile_Bool_Exp_>;
  documentationFileId?: InputMaybe<Uuid_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  insights?: InputMaybe<DocumentInsight_Bool_Exp_>;
  insights_aggregate?: InputMaybe<DocumentInsight_Aggregate_Bool_Exp_>;
  progress?: InputMaybe<Int_Comparison_Exp_>;
  results?: InputMaybe<Jsonb_Comparison_Exp_>;
};

/** unique or primary key constraints on table "ExtractionJob" */
export enum ExtractionJob_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  ExtractionJobPkey_ = 'ExtractionJob_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ExtractionJob_Delete_At_Path_Input_ = {
  results?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ExtractionJob_Delete_Elem_Input_ = {
  results?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ExtractionJob_Delete_Key_Input_ = {
  results?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "ExtractionJob" */
export type ExtractionJob_Inc_Input_ = {
  progress?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "ExtractionJob" */
export type ExtractionJob_Insert_Input_ = {
  documentationFile?: InputMaybe<DocumentationFile_Obj_Rel_Insert_Input_>;
  documentationFileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  insights?: InputMaybe<DocumentInsight_Arr_Rel_Insert_Input_>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  results?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type ExtractionJob_Max_Fields_ = {
  __typename?: 'ExtractionJob_max_fields';
  documentationFileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type ExtractionJob_Min_Fields_ = {
  __typename?: 'ExtractionJob_min_fields';
  documentationFileId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "ExtractionJob" */
export type ExtractionJob_Mutation_Response_ = {
  __typename?: 'ExtractionJob_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ExtractionJob_>;
};

/** input type for inserting object relation for remote table "ExtractionJob" */
export type ExtractionJob_Obj_Rel_Insert_Input_ = {
  data: ExtractionJob_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<ExtractionJob_On_Conflict_>;
};

/** on_conflict condition type for table "ExtractionJob" */
export type ExtractionJob_On_Conflict_ = {
  constraint: ExtractionJob_Constraint_;
  update_columns?: Array<ExtractionJob_Update_Column_>;
  where?: InputMaybe<ExtractionJob_Bool_Exp_>;
};

/** Ordering options when selecting data from "ExtractionJob". */
export type ExtractionJob_Order_By_ = {
  documentationFile?: InputMaybe<DocumentationFile_Order_By_>;
  documentationFileId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  insights_aggregate?: InputMaybe<DocumentInsight_Aggregate_Order_By_>;
  progress?: InputMaybe<Order_By_>;
  results?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: ExtractionJob */
export type ExtractionJob_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ExtractionJob_Prepend_Input_ = {
  results?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "ExtractionJob" */
export enum ExtractionJob_Select_Column_ {
  /** column name */
  DocumentationFileId_ = 'documentationFileId',
  /** column name */
  Id_ = 'id',
  /** column name */
  Progress_ = 'progress',
  /** column name */
  Results_ = 'results'
}

/** input type for updating data in table "ExtractionJob" */
export type ExtractionJob_Set_Input_ = {
  documentationFileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  results?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type ExtractionJob_Stddev_Fields_ = {
  __typename?: 'ExtractionJob_stddev_fields';
  progress?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type ExtractionJob_Stddev_Pop_Fields_ = {
  __typename?: 'ExtractionJob_stddev_pop_fields';
  progress?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type ExtractionJob_Stddev_Samp_Fields_ = {
  __typename?: 'ExtractionJob_stddev_samp_fields';
  progress?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "ExtractionJob" */
export type ExtractionJob_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: ExtractionJob_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type ExtractionJob_Stream_Cursor_Value_Input_ = {
  documentationFileId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  results?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type ExtractionJob_Sum_Fields_ = {
  __typename?: 'ExtractionJob_sum_fields';
  progress?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "ExtractionJob" */
export enum ExtractionJob_Update_Column_ {
  /** column name */
  DocumentationFileId_ = 'documentationFileId',
  /** column name */
  Id_ = 'id',
  /** column name */
  Progress_ = 'progress',
  /** column name */
  Results_ = 'results'
}

export type ExtractionJob_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ExtractionJob_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<ExtractionJob_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<ExtractionJob_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<ExtractionJob_Delete_Key_Input_>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ExtractionJob_Inc_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ExtractionJob_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ExtractionJob_Set_Input_>;
  /** filter the rows which have to be updated */
  where: ExtractionJob_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type ExtractionJob_Var_Pop_Fields_ = {
  __typename?: 'ExtractionJob_var_pop_fields';
  progress?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type ExtractionJob_Var_Samp_Fields_ = {
  __typename?: 'ExtractionJob_var_samp_fields';
  progress?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ExtractionJob_Variance_Fields_ = {
  __typename?: 'ExtractionJob_variance_fields';
  progress?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "Financials" */
export type Financials_ = {
  __typename?: 'Financials';
  /** An object relationship */
  activityReport?: Maybe<ActivityReport_>;
  adaptationCapex: Scalars['float8']['output'];
  adaptationOpex: Scalars['float8']['output'];
  /** An object relationship */
  attachmentBox?: Maybe<AttachmentBox_>;
  /** The company assessment where these financials represents the total financials as reported */
  cAssessmentId?: Maybe<Scalars['uuid']['output']>;
  capex: Scalars['float8']['output'];
  /** An object relationship */
  companyAssessment?: Maybe<CompanyAssessment_>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isEstimate: Scalars['Boolean']['output'];
  /** Needed for taxonomy update where financials can be marked as non material */
  isMaterial: Scalars['Boolean']['output'];
  /** An object relationship */
  noteHistory?: Maybe<NoteHistory_>;
  opex: Scalars['float8']['output'];
  reportId?: Maybe<Scalars['uuid']['output']>;
  revenue: Scalars['float8']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "Financials" */
export type Financials_Aggregate_ = {
  __typename?: 'Financials_aggregate';
  aggregate?: Maybe<Financials_Aggregate_Fields_>;
  nodes: Array<Financials_>;
};

/** aggregate fields of "Financials" */
export type Financials_Aggregate_Fields_ = {
  __typename?: 'Financials_aggregate_fields';
  avg?: Maybe<Financials_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<Financials_Max_Fields_>;
  min?: Maybe<Financials_Min_Fields_>;
  stddev?: Maybe<Financials_Stddev_Fields_>;
  stddev_pop?: Maybe<Financials_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<Financials_Stddev_Samp_Fields_>;
  sum?: Maybe<Financials_Sum_Fields_>;
  var_pop?: Maybe<Financials_Var_Pop_Fields_>;
  var_samp?: Maybe<Financials_Var_Samp_Fields_>;
  variance?: Maybe<Financials_Variance_Fields_>;
};


/** aggregate fields of "Financials" */
export type Financials_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Financials_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Financials_Avg_Fields_ = {
  __typename?: 'Financials_avg_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "Financials". All fields are combined with a logical 'AND'. */
export type Financials_Bool_Exp_ = {
  _and?: InputMaybe<Array<Financials_Bool_Exp_>>;
  _not?: InputMaybe<Financials_Bool_Exp_>;
  _or?: InputMaybe<Array<Financials_Bool_Exp_>>;
  activityReport?: InputMaybe<ActivityReport_Bool_Exp_>;
  adaptationCapex?: InputMaybe<Float8_Comparison_Exp_>;
  adaptationOpex?: InputMaybe<Float8_Comparison_Exp_>;
  attachmentBox?: InputMaybe<AttachmentBox_Bool_Exp_>;
  cAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  capex?: InputMaybe<Float8_Comparison_Exp_>;
  companyAssessment?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isEstimate?: InputMaybe<Boolean_Comparison_Exp_>;
  isMaterial?: InputMaybe<Boolean_Comparison_Exp_>;
  noteHistory?: InputMaybe<NoteHistory_Bool_Exp_>;
  opex?: InputMaybe<Float8_Comparison_Exp_>;
  reportId?: InputMaybe<Uuid_Comparison_Exp_>;
  revenue?: InputMaybe<Float8_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Financials" */
export enum Financials_Constraint_ {
  /** unique or primary key constraint on columns "isMaterial", "cAssessmentId" */
  FinancialsCAssessmentIdIsMaterialKey_ = 'Financials_cAssessmentId_isMaterial_key',
  /** unique or primary key constraint on columns "reportId" */
  FinancialsReportId_801651ecUniq_ = 'Financials_reportId_801651ec_uniq',
  /** unique or primary key constraint on columns "id" */
  FinancialsPkey_ = 'financials_pkey'
}

/** input type for incrementing numeric columns in table "Financials" */
export type Financials_Inc_Input_ = {
  adaptationCapex?: InputMaybe<Scalars['float8']['input']>;
  adaptationOpex?: InputMaybe<Scalars['float8']['input']>;
  capex?: InputMaybe<Scalars['float8']['input']>;
  opex?: InputMaybe<Scalars['float8']['input']>;
  revenue?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "Financials" */
export type Financials_Insert_Input_ = {
  activityReport?: InputMaybe<ActivityReport_Obj_Rel_Insert_Input_>;
  adaptationCapex?: InputMaybe<Scalars['float8']['input']>;
  adaptationOpex?: InputMaybe<Scalars['float8']['input']>;
  attachmentBox?: InputMaybe<AttachmentBox_Obj_Rel_Insert_Input_>;
  /** The company assessment where these financials represents the total financials as reported */
  cAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  capex?: InputMaybe<Scalars['float8']['input']>;
  companyAssessment?: InputMaybe<CompanyAssessment_Obj_Rel_Insert_Input_>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Needed for taxonomy update where financials can be marked as non material */
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  noteHistory?: InputMaybe<NoteHistory_Obj_Rel_Insert_Input_>;
  opex?: InputMaybe<Scalars['float8']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  revenue?: InputMaybe<Scalars['float8']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Financials_Max_Fields_ = {
  __typename?: 'Financials_max_fields';
  adaptationCapex?: Maybe<Scalars['float8']['output']>;
  adaptationOpex?: Maybe<Scalars['float8']['output']>;
  /** The company assessment where these financials represents the total financials as reported */
  cAssessmentId?: Maybe<Scalars['uuid']['output']>;
  capex?: Maybe<Scalars['float8']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  opex?: Maybe<Scalars['float8']['output']>;
  reportId?: Maybe<Scalars['uuid']['output']>;
  revenue?: Maybe<Scalars['float8']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Financials_Min_Fields_ = {
  __typename?: 'Financials_min_fields';
  adaptationCapex?: Maybe<Scalars['float8']['output']>;
  adaptationOpex?: Maybe<Scalars['float8']['output']>;
  /** The company assessment where these financials represents the total financials as reported */
  cAssessmentId?: Maybe<Scalars['uuid']['output']>;
  capex?: Maybe<Scalars['float8']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  opex?: Maybe<Scalars['float8']['output']>;
  reportId?: Maybe<Scalars['uuid']['output']>;
  revenue?: Maybe<Scalars['float8']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "Financials" */
export type Financials_Mutation_Response_ = {
  __typename?: 'Financials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Financials_>;
};

/** input type for inserting object relation for remote table "Financials" */
export type Financials_Obj_Rel_Insert_Input_ = {
  data: Financials_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Financials_On_Conflict_>;
};

/** on_conflict condition type for table "Financials" */
export type Financials_On_Conflict_ = {
  constraint: Financials_Constraint_;
  update_columns?: Array<Financials_Update_Column_>;
  where?: InputMaybe<Financials_Bool_Exp_>;
};

/** Ordering options when selecting data from "Financials". */
export type Financials_Order_By_ = {
  activityReport?: InputMaybe<ActivityReport_Order_By_>;
  adaptationCapex?: InputMaybe<Order_By_>;
  adaptationOpex?: InputMaybe<Order_By_>;
  attachmentBox?: InputMaybe<AttachmentBox_Order_By_>;
  cAssessmentId?: InputMaybe<Order_By_>;
  capex?: InputMaybe<Order_By_>;
  companyAssessment?: InputMaybe<CompanyAssessment_Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isEstimate?: InputMaybe<Order_By_>;
  isMaterial?: InputMaybe<Order_By_>;
  noteHistory?: InputMaybe<NoteHistory_Order_By_>;
  opex?: InputMaybe<Order_By_>;
  reportId?: InputMaybe<Order_By_>;
  revenue?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Financials */
export type Financials_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "Financials" */
export enum Financials_Select_Column_ {
  /** column name */
  AdaptationCapex_ = 'adaptationCapex',
  /** column name */
  AdaptationOpex_ = 'adaptationOpex',
  /** column name */
  CAssessmentId_ = 'cAssessmentId',
  /** column name */
  Capex_ = 'capex',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsEstimate_ = 'isEstimate',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  Opex_ = 'opex',
  /** column name */
  ReportId_ = 'reportId',
  /** column name */
  Revenue_ = 'revenue',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "Financials" */
export type Financials_Set_Input_ = {
  adaptationCapex?: InputMaybe<Scalars['float8']['input']>;
  adaptationOpex?: InputMaybe<Scalars['float8']['input']>;
  /** The company assessment where these financials represents the total financials as reported */
  cAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  capex?: InputMaybe<Scalars['float8']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Needed for taxonomy update where financials can be marked as non material */
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  opex?: InputMaybe<Scalars['float8']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  revenue?: InputMaybe<Scalars['float8']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Financials_Stddev_Fields_ = {
  __typename?: 'Financials_stddev_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Financials_Stddev_Pop_Fields_ = {
  __typename?: 'Financials_stddev_pop_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Financials_Stddev_Samp_Fields_ = {
  __typename?: 'Financials_stddev_samp_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "Financials" */
export type Financials_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Financials_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Financials_Stream_Cursor_Value_Input_ = {
  adaptationCapex?: InputMaybe<Scalars['float8']['input']>;
  adaptationOpex?: InputMaybe<Scalars['float8']['input']>;
  /** The company assessment where these financials represents the total financials as reported */
  cAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  capex?: InputMaybe<Scalars['float8']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Needed for taxonomy update where financials can be marked as non material */
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  opex?: InputMaybe<Scalars['float8']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  revenue?: InputMaybe<Scalars['float8']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Financials_Sum_Fields_ = {
  __typename?: 'Financials_sum_fields';
  adaptationCapex?: Maybe<Scalars['float8']['output']>;
  adaptationOpex?: Maybe<Scalars['float8']['output']>;
  capex?: Maybe<Scalars['float8']['output']>;
  opex?: Maybe<Scalars['float8']['output']>;
  revenue?: Maybe<Scalars['float8']['output']>;
};

/** update columns of table "Financials" */
export enum Financials_Update_Column_ {
  /** column name */
  AdaptationCapex_ = 'adaptationCapex',
  /** column name */
  AdaptationOpex_ = 'adaptationOpex',
  /** column name */
  CAssessmentId_ = 'cAssessmentId',
  /** column name */
  Capex_ = 'capex',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsEstimate_ = 'isEstimate',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  Opex_ = 'opex',
  /** column name */
  ReportId_ = 'reportId',
  /** column name */
  Revenue_ = 'revenue',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Financials_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Financials_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Financials_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Financials_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type Financials_Var_Pop_Fields_ = {
  __typename?: 'Financials_var_pop_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Financials_Var_Samp_Fields_ = {
  __typename?: 'Financials_var_samp_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Financials_Variance_Fields_ = {
  __typename?: 'Financials_variance_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "esrs.Framework" */
export type Framework_ = {
  __typename?: 'Framework';
  /** An array relationship */
  assessments: Array<EsrsAssessment_>;
  /** An aggregate relationship */
  assessments_aggregate: EsrsAssessment_Aggregate_;
  name: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  /** An array relationship */
  standards: Array<EsrsStandard_>;
  /** An aggregate relationship */
  standards_aggregate: EsrsStandard_Aggregate_;
};


/** columns and relationships of "esrs.Framework" */
export type FrameworkAssessmentsArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsAssessment_Order_By_>>;
  where?: InputMaybe<EsrsAssessment_Bool_Exp_>;
};


/** columns and relationships of "esrs.Framework" */
export type FrameworkAssessments_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsAssessment_Order_By_>>;
  where?: InputMaybe<EsrsAssessment_Bool_Exp_>;
};


/** columns and relationships of "esrs.Framework" */
export type FrameworkStandardsArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandard_Order_By_>>;
  where?: InputMaybe<EsrsStandard_Bool_Exp_>;
};


/** columns and relationships of "esrs.Framework" */
export type FrameworkStandards_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandard_Order_By_>>;
  where?: InputMaybe<EsrsStandard_Bool_Exp_>;
};

/** aggregated selection of "esrs.Framework" */
export type Framework_Aggregate_ = {
  __typename?: 'Framework_aggregate';
  aggregate?: Maybe<Framework_Aggregate_Fields_>;
  nodes: Array<Framework_>;
};

/** aggregate fields of "esrs.Framework" */
export type Framework_Aggregate_Fields_ = {
  __typename?: 'Framework_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Framework_Max_Fields_>;
  min?: Maybe<Framework_Min_Fields_>;
};


/** aggregate fields of "esrs.Framework" */
export type Framework_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Framework_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "esrs.Framework". All fields are combined with a logical 'AND'. */
export type Framework_Bool_Exp_ = {
  _and?: InputMaybe<Array<Framework_Bool_Exp_>>;
  _not?: InputMaybe<Framework_Bool_Exp_>;
  _or?: InputMaybe<Array<Framework_Bool_Exp_>>;
  assessments?: InputMaybe<EsrsAssessment_Bool_Exp_>;
  assessments_aggregate?: InputMaybe<EsrsAssessment_Aggregate_Bool_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  standards?: InputMaybe<EsrsStandard_Bool_Exp_>;
  standards_aggregate?: InputMaybe<EsrsStandard_Aggregate_Bool_Exp_>;
};

/** unique or primary key constraints on table "esrs.Framework" */
export enum Framework_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  FrameworkPkey_ = 'Framework_pkey',
  /** unique or primary key constraint on columns "reference" */
  FrameworkReferenceKey_ = 'Framework_reference_key'
}

/** input type for inserting data into table "esrs.Framework" */
export type Framework_Insert_Input_ = {
  assessments?: InputMaybe<EsrsAssessment_Arr_Rel_Insert_Input_>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  standards?: InputMaybe<EsrsStandard_Arr_Rel_Insert_Input_>;
};

/** aggregate max on columns */
export type Framework_Max_Fields_ = {
  __typename?: 'Framework_max_fields';
  name?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Framework_Min_Fields_ = {
  __typename?: 'Framework_min_fields';
  name?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "esrs.Framework" */
export type Framework_Mutation_Response_ = {
  __typename?: 'Framework_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Framework_>;
};

/** input type for inserting object relation for remote table "esrs.Framework" */
export type Framework_Obj_Rel_Insert_Input_ = {
  data: Framework_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Framework_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.Framework" */
export type Framework_On_Conflict_ = {
  constraint: Framework_Constraint_;
  update_columns?: Array<Framework_Update_Column_>;
  where?: InputMaybe<Framework_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.Framework". */
export type Framework_Order_By_ = {
  assessments_aggregate?: InputMaybe<EsrsAssessment_Aggregate_Order_By_>;
  name?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  standards_aggregate?: InputMaybe<EsrsStandard_Aggregate_Order_By_>;
};

/** primary key columns input for table: esrs.Framework */
export type Framework_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.Framework" */
export enum Framework_Select_Column_ {
  /** column name */
  Name_ = 'name',
  /** column name */
  Reference_ = 'reference'
}

/** input type for updating data in table "esrs.Framework" */
export type Framework_Set_Input_ = {
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "Framework" */
export type Framework_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Framework_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Framework_Stream_Cursor_Value_Input_ = {
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.Framework" */
export enum Framework_Update_Column_ {
  /** column name */
  Name_ = 'name',
  /** column name */
  Reference_ = 'reference'
}

export type Framework_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Framework_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Framework_Bool_Exp_;
};

/** columns and relationships of "GroupAssessment" */
export type GroupAssessment_ = {
  __typename?: 'GroupAssessment';
  /** An object relationship */
  company?: Maybe<Company_>;
  companyId: Scalars['uuid']['output'];
  /** An object relationship */
  consolidatedCompanyAssessment?: Maybe<CompanyAssessment_>;
  consolidatedCompanyAssessmentId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  consolidatedCsv?: Maybe<DocumentationFile_>;
  consolidatedCsvId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  period: Scalars['date']['output'];
  /** An array relationship */
  subsidiaries: Array<Subsidiary_>;
  /** An aggregate relationship */
  subsidiaries_aggregate: Subsidiary_Aggregate_;
  updatedAt: Scalars['timestamptz']['output'];
  uploadedAt?: Maybe<Scalars['date']['output']>;
};


/** columns and relationships of "GroupAssessment" */
export type GroupAssessmentSubsidiariesArgs_ = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By_>>;
  where?: InputMaybe<Subsidiary_Bool_Exp_>;
};


/** columns and relationships of "GroupAssessment" */
export type GroupAssessmentSubsidiaries_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By_>>;
  where?: InputMaybe<Subsidiary_Bool_Exp_>;
};

/** aggregated selection of "GroupAssessment" */
export type GroupAssessment_Aggregate_ = {
  __typename?: 'GroupAssessment_aggregate';
  aggregate?: Maybe<GroupAssessment_Aggregate_Fields_>;
  nodes: Array<GroupAssessment_>;
};

export type GroupAssessment_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<GroupAssessment_Aggregate_Bool_Exp_Count_>;
};

export type GroupAssessment_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<GroupAssessment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<GroupAssessment_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "GroupAssessment" */
export type GroupAssessment_Aggregate_Fields_ = {
  __typename?: 'GroupAssessment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<GroupAssessment_Max_Fields_>;
  min?: Maybe<GroupAssessment_Min_Fields_>;
};


/** aggregate fields of "GroupAssessment" */
export type GroupAssessment_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<GroupAssessment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "GroupAssessment" */
export type GroupAssessment_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<GroupAssessment_Max_Order_By_>;
  min?: InputMaybe<GroupAssessment_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "GroupAssessment" */
export type GroupAssessment_Arr_Rel_Insert_Input_ = {
  data: Array<GroupAssessment_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<GroupAssessment_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "GroupAssessment". All fields are combined with a logical 'AND'. */
export type GroupAssessment_Bool_Exp_ = {
  _and?: InputMaybe<Array<GroupAssessment_Bool_Exp_>>;
  _not?: InputMaybe<GroupAssessment_Bool_Exp_>;
  _or?: InputMaybe<Array<GroupAssessment_Bool_Exp_>>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  consolidatedCompanyAssessment?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  consolidatedCompanyAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  consolidatedCsv?: InputMaybe<DocumentationFile_Bool_Exp_>;
  consolidatedCsvId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  period?: InputMaybe<Date_Comparison_Exp_>;
  subsidiaries?: InputMaybe<Subsidiary_Bool_Exp_>;
  subsidiaries_aggregate?: InputMaybe<Subsidiary_Aggregate_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  uploadedAt?: InputMaybe<Date_Comparison_Exp_>;
};

/** unique or primary key constraints on table "GroupAssessment" */
export enum GroupAssessment_Constraint_ {
  /** unique or primary key constraint on columns "consolidatedCompanyAssessmentId" */
  GroupAssessmentConsolidatedCompanyAssessmentIdKey_ = 'GroupAssessment_consolidatedCompanyAssessmentId_key',
  /** unique or primary key constraint on columns "id" */
  GroupAssessmentPkey_ = 'GroupAssessment_pkey'
}

/** input type for inserting data into table "GroupAssessment" */
export type GroupAssessment_Insert_Input_ = {
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  consolidatedCompanyAssessment?: InputMaybe<CompanyAssessment_Obj_Rel_Insert_Input_>;
  consolidatedCompanyAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  consolidatedCsv?: InputMaybe<DocumentationFile_Obj_Rel_Insert_Input_>;
  consolidatedCsvId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['date']['input']>;
  subsidiaries?: InputMaybe<Subsidiary_Arr_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedAt?: InputMaybe<Scalars['date']['input']>;
};

/** aggregate max on columns */
export type GroupAssessment_Max_Fields_ = {
  __typename?: 'GroupAssessment_max_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  consolidatedCompanyAssessmentId?: Maybe<Scalars['uuid']['output']>;
  consolidatedCsvId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['date']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedAt?: Maybe<Scalars['date']['output']>;
};

/** order by max() on columns of table "GroupAssessment" */
export type GroupAssessment_Max_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  consolidatedCompanyAssessmentId?: InputMaybe<Order_By_>;
  consolidatedCsvId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  period?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  uploadedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type GroupAssessment_Min_Fields_ = {
  __typename?: 'GroupAssessment_min_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  consolidatedCompanyAssessmentId?: Maybe<Scalars['uuid']['output']>;
  consolidatedCsvId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['date']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedAt?: Maybe<Scalars['date']['output']>;
};

/** order by min() on columns of table "GroupAssessment" */
export type GroupAssessment_Min_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  consolidatedCompanyAssessmentId?: InputMaybe<Order_By_>;
  consolidatedCsvId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  period?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  uploadedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "GroupAssessment" */
export type GroupAssessment_Mutation_Response_ = {
  __typename?: 'GroupAssessment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<GroupAssessment_>;
};

/** input type for inserting object relation for remote table "GroupAssessment" */
export type GroupAssessment_Obj_Rel_Insert_Input_ = {
  data: GroupAssessment_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<GroupAssessment_On_Conflict_>;
};

/** on_conflict condition type for table "GroupAssessment" */
export type GroupAssessment_On_Conflict_ = {
  constraint: GroupAssessment_Constraint_;
  update_columns?: Array<GroupAssessment_Update_Column_>;
  where?: InputMaybe<GroupAssessment_Bool_Exp_>;
};

/** Ordering options when selecting data from "GroupAssessment". */
export type GroupAssessment_Order_By_ = {
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  consolidatedCompanyAssessment?: InputMaybe<CompanyAssessment_Order_By_>;
  consolidatedCompanyAssessmentId?: InputMaybe<Order_By_>;
  consolidatedCsv?: InputMaybe<DocumentationFile_Order_By_>;
  consolidatedCsvId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  period?: InputMaybe<Order_By_>;
  subsidiaries_aggregate?: InputMaybe<Subsidiary_Aggregate_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  uploadedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: GroupAssessment */
export type GroupAssessment_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "GroupAssessment" */
export enum GroupAssessment_Select_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  ConsolidatedCompanyAssessmentId_ = 'consolidatedCompanyAssessmentId',
  /** column name */
  ConsolidatedCsvId_ = 'consolidatedCsvId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Name_ = 'name',
  /** column name */
  Period_ = 'period',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UploadedAt_ = 'uploadedAt'
}

/** input type for updating data in table "GroupAssessment" */
export type GroupAssessment_Set_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  consolidatedCompanyAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  consolidatedCsvId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['date']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedAt?: InputMaybe<Scalars['date']['input']>;
};

/** Streaming cursor of the table "GroupAssessment" */
export type GroupAssessment_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: GroupAssessment_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type GroupAssessment_Stream_Cursor_Value_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  consolidatedCompanyAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  consolidatedCsvId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['date']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedAt?: InputMaybe<Scalars['date']['input']>;
};

/** update columns of table "GroupAssessment" */
export enum GroupAssessment_Update_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  ConsolidatedCompanyAssessmentId_ = 'consolidatedCompanyAssessmentId',
  /** column name */
  ConsolidatedCsvId_ = 'consolidatedCsvId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Name_ = 'name',
  /** column name */
  Period_ = 'period',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UploadedAt_ = 'uploadedAt'
}

export type GroupAssessment_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<GroupAssessment_Set_Input_>;
  /** filter the rows which have to be updated */
  where: GroupAssessment_Bool_Exp_;
};

/** columns and relationships of "IdentityProvider" */
export type IdentityProvider_ = {
  __typename?: 'IdentityProvider';
  /** An array relationship */
  configurations: Array<CompanyIdentityProvider_>;
  /** An aggregate relationship */
  configurations_aggregate: CompanyIdentityProvider_Aggregate_;
  createdAt: Scalars['timestamptz']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['timestamptz']['output'];
  workosOrgId: Scalars['String']['output'];
};


/** columns and relationships of "IdentityProvider" */
export type IdentityProviderConfigurationsArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyIdentityProvider_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyIdentityProvider_Order_By_>>;
  where?: InputMaybe<CompanyIdentityProvider_Bool_Exp_>;
};


/** columns and relationships of "IdentityProvider" */
export type IdentityProviderConfigurations_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyIdentityProvider_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyIdentityProvider_Order_By_>>;
  where?: InputMaybe<CompanyIdentityProvider_Bool_Exp_>;
};

/** aggregated selection of "IdentityProvider" */
export type IdentityProvider_Aggregate_ = {
  __typename?: 'IdentityProvider_aggregate';
  aggregate?: Maybe<IdentityProvider_Aggregate_Fields_>;
  nodes: Array<IdentityProvider_>;
};

/** aggregate fields of "IdentityProvider" */
export type IdentityProvider_Aggregate_Fields_ = {
  __typename?: 'IdentityProvider_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<IdentityProvider_Max_Fields_>;
  min?: Maybe<IdentityProvider_Min_Fields_>;
};


/** aggregate fields of "IdentityProvider" */
export type IdentityProvider_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<IdentityProvider_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "IdentityProvider". All fields are combined with a logical 'AND'. */
export type IdentityProvider_Bool_Exp_ = {
  _and?: InputMaybe<Array<IdentityProvider_Bool_Exp_>>;
  _not?: InputMaybe<IdentityProvider_Bool_Exp_>;
  _or?: InputMaybe<Array<IdentityProvider_Bool_Exp_>>;
  configurations?: InputMaybe<CompanyIdentityProvider_Bool_Exp_>;
  configurations_aggregate?: InputMaybe<CompanyIdentityProvider_Aggregate_Bool_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp_>;
  workosOrgId?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "IdentityProvider" */
export enum IdentityProvider_Constraint_ {
  /** unique or primary key constraint on columns "name" */
  IdentityProviderNameKey_ = 'IdentityProvider_name_key',
  /** unique or primary key constraint on columns "name" */
  IdentityProviderPkey_ = 'IdentityProvider_pkey'
}

/** input type for inserting data into table "IdentityProvider" */
export type IdentityProvider_Insert_Input_ = {
  configurations?: InputMaybe<CompanyIdentityProvider_Arr_Rel_Insert_Input_>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  workosOrgId?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type IdentityProvider_Max_Fields_ = {
  __typename?: 'IdentityProvider_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  workosOrgId?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type IdentityProvider_Min_Fields_ = {
  __typename?: 'IdentityProvider_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  workosOrgId?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "IdentityProvider" */
export type IdentityProvider_Mutation_Response_ = {
  __typename?: 'IdentityProvider_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<IdentityProvider_>;
};

/** input type for inserting object relation for remote table "IdentityProvider" */
export type IdentityProvider_Obj_Rel_Insert_Input_ = {
  data: IdentityProvider_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<IdentityProvider_On_Conflict_>;
};

/** on_conflict condition type for table "IdentityProvider" */
export type IdentityProvider_On_Conflict_ = {
  constraint: IdentityProvider_Constraint_;
  update_columns?: Array<IdentityProvider_Update_Column_>;
  where?: InputMaybe<IdentityProvider_Bool_Exp_>;
};

/** Ordering options when selecting data from "IdentityProvider". */
export type IdentityProvider_Order_By_ = {
  configurations_aggregate?: InputMaybe<CompanyIdentityProvider_Aggregate_Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  updated_at?: InputMaybe<Order_By_>;
  workosOrgId?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: IdentityProvider */
export type IdentityProvider_Pk_Columns_Input_ = {
  name: Scalars['String']['input'];
};

/** select columns of table "IdentityProvider" */
export enum IdentityProvider_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Name_ = 'name',
  /** column name */
  UpdatedAt_ = 'updated_at',
  /** column name */
  WorkosOrgId_ = 'workosOrgId'
}

/** input type for updating data in table "IdentityProvider" */
export type IdentityProvider_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  workosOrgId?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "IdentityProvider" */
export type IdentityProvider_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: IdentityProvider_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type IdentityProvider_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  workosOrgId?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "IdentityProvider" */
export enum IdentityProvider_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Name_ = 'name',
  /** column name */
  UpdatedAt_ = 'updated_at',
  /** column name */
  WorkosOrgId_ = 'workosOrgId'
}

export type IdentityProvider_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IdentityProvider_Set_Input_>;
  /** filter the rows which have to be updated */
  where: IdentityProvider_Bool_Exp_;
};

/** columns and relationships of "IndicatorToInvestorMetric" */
export type IndicatorToInvestorMetric_ = {
  __typename?: 'IndicatorToInvestorMetric';
  /** An object relationship */
  indicator: PaiTableIndicator_;
  indicatorRef: Scalars['String']['output'];
  /** An object relationship */
  investorMetric: InvestorMetric_;
  investorMetricRef: Scalars['String']['output'];
};

/** aggregated selection of "IndicatorToInvestorMetric" */
export type IndicatorToInvestorMetric_Aggregate_ = {
  __typename?: 'IndicatorToInvestorMetric_aggregate';
  aggregate?: Maybe<IndicatorToInvestorMetric_Aggregate_Fields_>;
  nodes: Array<IndicatorToInvestorMetric_>;
};

export type IndicatorToInvestorMetric_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<IndicatorToInvestorMetric_Aggregate_Bool_Exp_Count_>;
};

export type IndicatorToInvestorMetric_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<IndicatorToInvestorMetric_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<IndicatorToInvestorMetric_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "IndicatorToInvestorMetric" */
export type IndicatorToInvestorMetric_Aggregate_Fields_ = {
  __typename?: 'IndicatorToInvestorMetric_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<IndicatorToInvestorMetric_Max_Fields_>;
  min?: Maybe<IndicatorToInvestorMetric_Min_Fields_>;
};


/** aggregate fields of "IndicatorToInvestorMetric" */
export type IndicatorToInvestorMetric_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<IndicatorToInvestorMetric_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "IndicatorToInvestorMetric" */
export type IndicatorToInvestorMetric_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<IndicatorToInvestorMetric_Max_Order_By_>;
  min?: InputMaybe<IndicatorToInvestorMetric_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "IndicatorToInvestorMetric" */
export type IndicatorToInvestorMetric_Arr_Rel_Insert_Input_ = {
  data: Array<IndicatorToInvestorMetric_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<IndicatorToInvestorMetric_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "IndicatorToInvestorMetric". All fields are combined with a logical 'AND'. */
export type IndicatorToInvestorMetric_Bool_Exp_ = {
  _and?: InputMaybe<Array<IndicatorToInvestorMetric_Bool_Exp_>>;
  _not?: InputMaybe<IndicatorToInvestorMetric_Bool_Exp_>;
  _or?: InputMaybe<Array<IndicatorToInvestorMetric_Bool_Exp_>>;
  indicator?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
  indicatorRef?: InputMaybe<String_Comparison_Exp_>;
  investorMetric?: InputMaybe<InvestorMetric_Bool_Exp_>;
  investorMetricRef?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "IndicatorToInvestorMetric" */
export enum IndicatorToInvestorMetric_Constraint_ {
  /** unique or primary key constraint on columns "indicatorRef", "investorMetricRef" */
  IndicatorToInvestorMetricPkey_ = 'IndicatorToInvestorMetric_pkey'
}

/** input type for inserting data into table "IndicatorToInvestorMetric" */
export type IndicatorToInvestorMetric_Insert_Input_ = {
  indicator?: InputMaybe<PaiTableIndicator_Obj_Rel_Insert_Input_>;
  indicatorRef?: InputMaybe<Scalars['String']['input']>;
  investorMetric?: InputMaybe<InvestorMetric_Obj_Rel_Insert_Input_>;
  investorMetricRef?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type IndicatorToInvestorMetric_Max_Fields_ = {
  __typename?: 'IndicatorToInvestorMetric_max_fields';
  indicatorRef?: Maybe<Scalars['String']['output']>;
  investorMetricRef?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "IndicatorToInvestorMetric" */
export type IndicatorToInvestorMetric_Max_Order_By_ = {
  indicatorRef?: InputMaybe<Order_By_>;
  investorMetricRef?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type IndicatorToInvestorMetric_Min_Fields_ = {
  __typename?: 'IndicatorToInvestorMetric_min_fields';
  indicatorRef?: Maybe<Scalars['String']['output']>;
  investorMetricRef?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "IndicatorToInvestorMetric" */
export type IndicatorToInvestorMetric_Min_Order_By_ = {
  indicatorRef?: InputMaybe<Order_By_>;
  investorMetricRef?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "IndicatorToInvestorMetric" */
export type IndicatorToInvestorMetric_Mutation_Response_ = {
  __typename?: 'IndicatorToInvestorMetric_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<IndicatorToInvestorMetric_>;
};

/** on_conflict condition type for table "IndicatorToInvestorMetric" */
export type IndicatorToInvestorMetric_On_Conflict_ = {
  constraint: IndicatorToInvestorMetric_Constraint_;
  update_columns?: Array<IndicatorToInvestorMetric_Update_Column_>;
  where?: InputMaybe<IndicatorToInvestorMetric_Bool_Exp_>;
};

/** Ordering options when selecting data from "IndicatorToInvestorMetric". */
export type IndicatorToInvestorMetric_Order_By_ = {
  indicator?: InputMaybe<PaiTableIndicator_Order_By_>;
  indicatorRef?: InputMaybe<Order_By_>;
  investorMetric?: InputMaybe<InvestorMetric_Order_By_>;
  investorMetricRef?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: IndicatorToInvestorMetric */
export type IndicatorToInvestorMetric_Pk_Columns_Input_ = {
  indicatorRef: Scalars['String']['input'];
  investorMetricRef: Scalars['String']['input'];
};

/** select columns of table "IndicatorToInvestorMetric" */
export enum IndicatorToInvestorMetric_Select_Column_ {
  /** column name */
  IndicatorRef_ = 'indicatorRef',
  /** column name */
  InvestorMetricRef_ = 'investorMetricRef'
}

/** input type for updating data in table "IndicatorToInvestorMetric" */
export type IndicatorToInvestorMetric_Set_Input_ = {
  indicatorRef?: InputMaybe<Scalars['String']['input']>;
  investorMetricRef?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "IndicatorToInvestorMetric" */
export type IndicatorToInvestorMetric_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: IndicatorToInvestorMetric_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type IndicatorToInvestorMetric_Stream_Cursor_Value_Input_ = {
  indicatorRef?: InputMaybe<Scalars['String']['input']>;
  investorMetricRef?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "IndicatorToInvestorMetric" */
export enum IndicatorToInvestorMetric_Update_Column_ {
  /** column name */
  IndicatorRef_ = 'indicatorRef',
  /** column name */
  InvestorMetricRef_ = 'investorMetricRef'
}

export type IndicatorToInvestorMetric_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IndicatorToInvestorMetric_Set_Input_>;
  /** filter the rows which have to be updated */
  where: IndicatorToInvestorMetric_Bool_Exp_;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp_ = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Investee metrics (for portfolio companies) for investor metrics that come from indicators of a  */
export type InvesteeMetric_ = {
  __typename?: 'InvesteeMetric';
  /** An object relationship */
  QuestionType: QuestionType_;
  additionalResources?: Maybe<Scalars['String']['output']>;
  dependencies?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  embeddings?: Maybe<Scalars['jsonb']['output']>;
  /** An array relationship */
  investorMetrics: Array<InvestorToInvesteeMetric_>;
  /** An aggregate relationship */
  investorMetrics_aggregate: InvestorToInvesteeMetric_Aggregate_;
  methodology?: Maybe<Scalars['String']['output']>;
  order: Scalars['Int']['output'];
  reference: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: QuestionType_Enum_;
  unit?: Maybe<Scalars['String']['output']>;
};


/** Investee metrics (for portfolio companies) for investor metrics that come from indicators of a  */
export type InvesteeMetricEmbeddingsArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** Investee metrics (for portfolio companies) for investor metrics that come from indicators of a  */
export type InvesteeMetricInvestorMetricsArgs_ = {
  distinct_on?: InputMaybe<Array<InvestorToInvesteeMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestorToInvesteeMetric_Order_By_>>;
  where?: InputMaybe<InvestorToInvesteeMetric_Bool_Exp_>;
};


/** Investee metrics (for portfolio companies) for investor metrics that come from indicators of a  */
export type InvesteeMetricInvestorMetrics_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<InvestorToInvesteeMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestorToInvesteeMetric_Order_By_>>;
  where?: InputMaybe<InvestorToInvesteeMetric_Bool_Exp_>;
};

/** aggregated selection of "InvesteeMetric" */
export type InvesteeMetric_Aggregate_ = {
  __typename?: 'InvesteeMetric_aggregate';
  aggregate?: Maybe<InvesteeMetric_Aggregate_Fields_>;
  nodes: Array<InvesteeMetric_>;
};

/** aggregate fields of "InvesteeMetric" */
export type InvesteeMetric_Aggregate_Fields_ = {
  __typename?: 'InvesteeMetric_aggregate_fields';
  avg?: Maybe<InvesteeMetric_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<InvesteeMetric_Max_Fields_>;
  min?: Maybe<InvesteeMetric_Min_Fields_>;
  stddev?: Maybe<InvesteeMetric_Stddev_Fields_>;
  stddev_pop?: Maybe<InvesteeMetric_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<InvesteeMetric_Stddev_Samp_Fields_>;
  sum?: Maybe<InvesteeMetric_Sum_Fields_>;
  var_pop?: Maybe<InvesteeMetric_Var_Pop_Fields_>;
  var_samp?: Maybe<InvesteeMetric_Var_Samp_Fields_>;
  variance?: Maybe<InvesteeMetric_Variance_Fields_>;
};


/** aggregate fields of "InvesteeMetric" */
export type InvesteeMetric_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<InvesteeMetric_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type InvesteeMetric_Append_Input_ = {
  embeddings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type InvesteeMetric_Avg_Fields_ = {
  __typename?: 'InvesteeMetric_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "InvesteeMetric". All fields are combined with a logical 'AND'. */
export type InvesteeMetric_Bool_Exp_ = {
  QuestionType?: InputMaybe<QuestionType_Bool_Exp_>;
  _and?: InputMaybe<Array<InvesteeMetric_Bool_Exp_>>;
  _not?: InputMaybe<InvesteeMetric_Bool_Exp_>;
  _or?: InputMaybe<Array<InvesteeMetric_Bool_Exp_>>;
  additionalResources?: InputMaybe<String_Comparison_Exp_>;
  dependencies?: InputMaybe<String_Comparison_Exp_>;
  description?: InputMaybe<String_Comparison_Exp_>;
  embeddings?: InputMaybe<Jsonb_Comparison_Exp_>;
  investorMetrics?: InputMaybe<InvestorToInvesteeMetric_Bool_Exp_>;
  investorMetrics_aggregate?: InputMaybe<InvestorToInvesteeMetric_Aggregate_Bool_Exp_>;
  methodology?: InputMaybe<String_Comparison_Exp_>;
  order?: InputMaybe<Int_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
  type?: InputMaybe<QuestionType_Enum_Comparison_Exp_>;
  unit?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "InvesteeMetric" */
export enum InvesteeMetric_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  InvesteeMetricPkey_ = 'InvesteeMetric_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type InvesteeMetric_Delete_At_Path_Input_ = {
  embeddings?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type InvesteeMetric_Delete_Elem_Input_ = {
  embeddings?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type InvesteeMetric_Delete_Key_Input_ = {
  embeddings?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "InvesteeMetric" */
export type InvesteeMetric_Inc_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "InvesteeMetric" */
export type InvesteeMetric_Insert_Input_ = {
  QuestionType?: InputMaybe<QuestionType_Obj_Rel_Insert_Input_>;
  additionalResources?: InputMaybe<Scalars['String']['input']>;
  dependencies?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embeddings?: InputMaybe<Scalars['jsonb']['input']>;
  investorMetrics?: InputMaybe<InvestorToInvesteeMetric_Arr_Rel_Insert_Input_>;
  methodology?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<QuestionType_Enum_>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type InvesteeMetric_Max_Fields_ = {
  __typename?: 'InvesteeMetric_max_fields';
  additionalResources?: Maybe<Scalars['String']['output']>;
  dependencies?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  methodology?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type InvesteeMetric_Min_Fields_ = {
  __typename?: 'InvesteeMetric_min_fields';
  additionalResources?: Maybe<Scalars['String']['output']>;
  dependencies?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  methodology?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "InvesteeMetric" */
export type InvesteeMetric_Mutation_Response_ = {
  __typename?: 'InvesteeMetric_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<InvesteeMetric_>;
};

/** input type for inserting object relation for remote table "InvesteeMetric" */
export type InvesteeMetric_Obj_Rel_Insert_Input_ = {
  data: InvesteeMetric_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<InvesteeMetric_On_Conflict_>;
};

/** on_conflict condition type for table "InvesteeMetric" */
export type InvesteeMetric_On_Conflict_ = {
  constraint: InvesteeMetric_Constraint_;
  update_columns?: Array<InvesteeMetric_Update_Column_>;
  where?: InputMaybe<InvesteeMetric_Bool_Exp_>;
};

/** Ordering options when selecting data from "InvesteeMetric". */
export type InvesteeMetric_Order_By_ = {
  QuestionType?: InputMaybe<QuestionType_Order_By_>;
  additionalResources?: InputMaybe<Order_By_>;
  dependencies?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  embeddings?: InputMaybe<Order_By_>;
  investorMetrics_aggregate?: InputMaybe<InvestorToInvesteeMetric_Aggregate_Order_By_>;
  methodology?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  type?: InputMaybe<Order_By_>;
  unit?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: InvesteeMetric */
export type InvesteeMetric_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type InvesteeMetric_Prepend_Input_ = {
  embeddings?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "InvesteeMetric" */
export enum InvesteeMetric_Select_Column_ {
  /** column name */
  AdditionalResources_ = 'additionalResources',
  /** column name */
  Dependencies_ = 'dependencies',
  /** column name */
  Description_ = 'description',
  /** column name */
  Embeddings_ = 'embeddings',
  /** column name */
  Methodology_ = 'methodology',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title',
  /** column name */
  Type_ = 'type',
  /** column name */
  Unit_ = 'unit'
}

/** input type for updating data in table "InvesteeMetric" */
export type InvesteeMetric_Set_Input_ = {
  additionalResources?: InputMaybe<Scalars['String']['input']>;
  dependencies?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embeddings?: InputMaybe<Scalars['jsonb']['input']>;
  methodology?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<QuestionType_Enum_>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type InvesteeMetric_Stddev_Fields_ = {
  __typename?: 'InvesteeMetric_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type InvesteeMetric_Stddev_Pop_Fields_ = {
  __typename?: 'InvesteeMetric_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type InvesteeMetric_Stddev_Samp_Fields_ = {
  __typename?: 'InvesteeMetric_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "InvesteeMetric" */
export type InvesteeMetric_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: InvesteeMetric_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type InvesteeMetric_Stream_Cursor_Value_Input_ = {
  additionalResources?: InputMaybe<Scalars['String']['input']>;
  dependencies?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embeddings?: InputMaybe<Scalars['jsonb']['input']>;
  methodology?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<QuestionType_Enum_>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type InvesteeMetric_Sum_Fields_ = {
  __typename?: 'InvesteeMetric_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "InvesteeMetric" */
export enum InvesteeMetric_Update_Column_ {
  /** column name */
  AdditionalResources_ = 'additionalResources',
  /** column name */
  Dependencies_ = 'dependencies',
  /** column name */
  Description_ = 'description',
  /** column name */
  Embeddings_ = 'embeddings',
  /** column name */
  Methodology_ = 'methodology',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title',
  /** column name */
  Type_ = 'type',
  /** column name */
  Unit_ = 'unit'
}

export type InvesteeMetric_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<InvesteeMetric_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<InvesteeMetric_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<InvesteeMetric_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<InvesteeMetric_Delete_Key_Input_>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<InvesteeMetric_Inc_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<InvesteeMetric_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvesteeMetric_Set_Input_>;
  /** filter the rows which have to be updated */
  where: InvesteeMetric_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type InvesteeMetric_Var_Pop_Fields_ = {
  __typename?: 'InvesteeMetric_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type InvesteeMetric_Var_Samp_Fields_ = {
  __typename?: 'InvesteeMetric_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type InvesteeMetric_Variance_Fields_ = {
  __typename?: 'InvesteeMetric_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** This table shows the type of the portfolio's additional non-eligible investments, wether it's cash or sovereign  */
export type InvestmentCategory_ = {
  __typename?: 'InvestmentCategory';
  value: Scalars['String']['output'];
};

/** aggregated selection of "InvestmentCategory" */
export type InvestmentCategory_Aggregate_ = {
  __typename?: 'InvestmentCategory_aggregate';
  aggregate?: Maybe<InvestmentCategory_Aggregate_Fields_>;
  nodes: Array<InvestmentCategory_>;
};

/** aggregate fields of "InvestmentCategory" */
export type InvestmentCategory_Aggregate_Fields_ = {
  __typename?: 'InvestmentCategory_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<InvestmentCategory_Max_Fields_>;
  min?: Maybe<InvestmentCategory_Min_Fields_>;
};


/** aggregate fields of "InvestmentCategory" */
export type InvestmentCategory_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<InvestmentCategory_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "InvestmentCategory". All fields are combined with a logical 'AND'. */
export type InvestmentCategory_Bool_Exp_ = {
  _and?: InputMaybe<Array<InvestmentCategory_Bool_Exp_>>;
  _not?: InputMaybe<InvestmentCategory_Bool_Exp_>;
  _or?: InputMaybe<Array<InvestmentCategory_Bool_Exp_>>;
  value?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "InvestmentCategory" */
export enum InvestmentCategory_Constraint_ {
  /** unique or primary key constraint on columns "value" */
  InvestmentCategoryPkey_ = 'InvestmentCategory_pkey'
}

export enum InvestmentCategory_Enum_ {
  Cash_ = 'CASH',
  Sovereign_ = 'SOVEREIGN'
}

/** Boolean expression to compare columns of type "InvestmentCategory_enum". All fields are combined with logical 'AND'. */
export type InvestmentCategory_Enum_Comparison_Exp_ = {
  _eq?: InputMaybe<InvestmentCategory_Enum_>;
  _in?: InputMaybe<Array<InvestmentCategory_Enum_>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<InvestmentCategory_Enum_>;
  _nin?: InputMaybe<Array<InvestmentCategory_Enum_>>;
};

/** input type for inserting data into table "InvestmentCategory" */
export type InvestmentCategory_Insert_Input_ = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type InvestmentCategory_Max_Fields_ = {
  __typename?: 'InvestmentCategory_max_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type InvestmentCategory_Min_Fields_ = {
  __typename?: 'InvestmentCategory_min_fields';
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "InvestmentCategory" */
export type InvestmentCategory_Mutation_Response_ = {
  __typename?: 'InvestmentCategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<InvestmentCategory_>;
};

/** on_conflict condition type for table "InvestmentCategory" */
export type InvestmentCategory_On_Conflict_ = {
  constraint: InvestmentCategory_Constraint_;
  update_columns?: Array<InvestmentCategory_Update_Column_>;
  where?: InputMaybe<InvestmentCategory_Bool_Exp_>;
};

/** Ordering options when selecting data from "InvestmentCategory". */
export type InvestmentCategory_Order_By_ = {
  value?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: InvestmentCategory */
export type InvestmentCategory_Pk_Columns_Input_ = {
  value: Scalars['String']['input'];
};

/** select columns of table "InvestmentCategory" */
export enum InvestmentCategory_Select_Column_ {
  /** column name */
  Value_ = 'value'
}

/** input type for updating data in table "InvestmentCategory" */
export type InvestmentCategory_Set_Input_ = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "InvestmentCategory" */
export type InvestmentCategory_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: InvestmentCategory_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type InvestmentCategory_Stream_Cursor_Value_Input_ = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "InvestmentCategory" */
export enum InvestmentCategory_Update_Column_ {
  /** column name */
  Value_ = 'value'
}

export type InvestmentCategory_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvestmentCategory_Set_Input_>;
  /** filter the rows which have to be updated */
  where: InvestmentCategory_Bool_Exp_;
};

/** Investor metric linked to some PAI indicator in a category in one of the PAI tables. */
export type InvestorMetric_ = {
  __typename?: 'InvestorMetric';
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  indicators: Array<IndicatorToInvestorMetric_>;
  /** An aggregate relationship */
  indicators_aggregate: IndicatorToInvestorMetric_Aggregate_;
  /** An array relationship */
  investeeMetrics: Array<InvestorToInvesteeMetric_>;
  /** An aggregate relationship */
  investeeMetrics_aggregate: InvestorToInvesteeMetric_Aggregate_;
  isAggregatable?: Maybe<Scalars['Boolean']['output']>;
  methodology?: Maybe<Scalars['String']['output']>;
  old_indicatorReference?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  title: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};


/** Investor metric linked to some PAI indicator in a category in one of the PAI tables. */
export type InvestorMetricIndicatorsArgs_ = {
  distinct_on?: InputMaybe<Array<IndicatorToInvestorMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorToInvestorMetric_Order_By_>>;
  where?: InputMaybe<IndicatorToInvestorMetric_Bool_Exp_>;
};


/** Investor metric linked to some PAI indicator in a category in one of the PAI tables. */
export type InvestorMetricIndicators_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<IndicatorToInvestorMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorToInvestorMetric_Order_By_>>;
  where?: InputMaybe<IndicatorToInvestorMetric_Bool_Exp_>;
};


/** Investor metric linked to some PAI indicator in a category in one of the PAI tables. */
export type InvestorMetricInvesteeMetricsArgs_ = {
  distinct_on?: InputMaybe<Array<InvestorToInvesteeMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestorToInvesteeMetric_Order_By_>>;
  where?: InputMaybe<InvestorToInvesteeMetric_Bool_Exp_>;
};


/** Investor metric linked to some PAI indicator in a category in one of the PAI tables. */
export type InvestorMetricInvesteeMetrics_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<InvestorToInvesteeMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestorToInvesteeMetric_Order_By_>>;
  where?: InputMaybe<InvestorToInvesteeMetric_Bool_Exp_>;
};

/** aggregated selection of "InvestorMetric" */
export type InvestorMetric_Aggregate_ = {
  __typename?: 'InvestorMetric_aggregate';
  aggregate?: Maybe<InvestorMetric_Aggregate_Fields_>;
  nodes: Array<InvestorMetric_>;
};

/** aggregate fields of "InvestorMetric" */
export type InvestorMetric_Aggregate_Fields_ = {
  __typename?: 'InvestorMetric_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<InvestorMetric_Max_Fields_>;
  min?: Maybe<InvestorMetric_Min_Fields_>;
};


/** aggregate fields of "InvestorMetric" */
export type InvestorMetric_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<InvestorMetric_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "InvestorMetric". All fields are combined with a logical 'AND'. */
export type InvestorMetric_Bool_Exp_ = {
  _and?: InputMaybe<Array<InvestorMetric_Bool_Exp_>>;
  _not?: InputMaybe<InvestorMetric_Bool_Exp_>;
  _or?: InputMaybe<Array<InvestorMetric_Bool_Exp_>>;
  description?: InputMaybe<String_Comparison_Exp_>;
  indicators?: InputMaybe<IndicatorToInvestorMetric_Bool_Exp_>;
  indicators_aggregate?: InputMaybe<IndicatorToInvestorMetric_Aggregate_Bool_Exp_>;
  investeeMetrics?: InputMaybe<InvestorToInvesteeMetric_Bool_Exp_>;
  investeeMetrics_aggregate?: InputMaybe<InvestorToInvesteeMetric_Aggregate_Bool_Exp_>;
  isAggregatable?: InputMaybe<Boolean_Comparison_Exp_>;
  methodology?: InputMaybe<String_Comparison_Exp_>;
  old_indicatorReference?: InputMaybe<String_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
  unit?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "InvestorMetric" */
export enum InvestorMetric_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  InvestorMetricPkey_ = 'InvestorMetric_pkey'
}

/** input type for inserting data into table "InvestorMetric" */
export type InvestorMetric_Insert_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  indicators?: InputMaybe<IndicatorToInvestorMetric_Arr_Rel_Insert_Input_>;
  investeeMetrics?: InputMaybe<InvestorToInvesteeMetric_Arr_Rel_Insert_Input_>;
  isAggregatable?: InputMaybe<Scalars['Boolean']['input']>;
  methodology?: InputMaybe<Scalars['String']['input']>;
  old_indicatorReference?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type InvestorMetric_Max_Fields_ = {
  __typename?: 'InvestorMetric_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  methodology?: Maybe<Scalars['String']['output']>;
  old_indicatorReference?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type InvestorMetric_Min_Fields_ = {
  __typename?: 'InvestorMetric_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  methodology?: Maybe<Scalars['String']['output']>;
  old_indicatorReference?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "InvestorMetric" */
export type InvestorMetric_Mutation_Response_ = {
  __typename?: 'InvestorMetric_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<InvestorMetric_>;
};

/** input type for inserting object relation for remote table "InvestorMetric" */
export type InvestorMetric_Obj_Rel_Insert_Input_ = {
  data: InvestorMetric_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<InvestorMetric_On_Conflict_>;
};

/** on_conflict condition type for table "InvestorMetric" */
export type InvestorMetric_On_Conflict_ = {
  constraint: InvestorMetric_Constraint_;
  update_columns?: Array<InvestorMetric_Update_Column_>;
  where?: InputMaybe<InvestorMetric_Bool_Exp_>;
};

/** Ordering options when selecting data from "InvestorMetric". */
export type InvestorMetric_Order_By_ = {
  description?: InputMaybe<Order_By_>;
  indicators_aggregate?: InputMaybe<IndicatorToInvestorMetric_Aggregate_Order_By_>;
  investeeMetrics_aggregate?: InputMaybe<InvestorToInvesteeMetric_Aggregate_Order_By_>;
  isAggregatable?: InputMaybe<Order_By_>;
  methodology?: InputMaybe<Order_By_>;
  old_indicatorReference?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  unit?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: InvestorMetric */
export type InvestorMetric_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "InvestorMetric" */
export enum InvestorMetric_Select_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  IsAggregatable_ = 'isAggregatable',
  /** column name */
  Methodology_ = 'methodology',
  /** column name */
  OldIndicatorReference_ = 'old_indicatorReference',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title',
  /** column name */
  Unit_ = 'unit'
}

/** input type for updating data in table "InvestorMetric" */
export type InvestorMetric_Set_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  isAggregatable?: InputMaybe<Scalars['Boolean']['input']>;
  methodology?: InputMaybe<Scalars['String']['input']>;
  old_indicatorReference?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "InvestorMetric" */
export type InvestorMetric_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: InvestorMetric_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type InvestorMetric_Stream_Cursor_Value_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  isAggregatable?: InputMaybe<Scalars['Boolean']['input']>;
  methodology?: InputMaybe<Scalars['String']['input']>;
  old_indicatorReference?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "InvestorMetric" */
export enum InvestorMetric_Update_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  IsAggregatable_ = 'isAggregatable',
  /** column name */
  Methodology_ = 'methodology',
  /** column name */
  OldIndicatorReference_ = 'old_indicatorReference',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title',
  /** column name */
  Unit_ = 'unit'
}

export type InvestorMetric_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvestorMetric_Set_Input_>;
  /** filter the rows which have to be updated */
  where: InvestorMetric_Bool_Exp_;
};

/** Tracking which investee metric is needed for a investor metric (Many to many) */
export type InvestorToInvesteeMetric_ = {
  __typename?: 'InvestorToInvesteeMetric';
  /** An object relationship */
  investeeMetric: InvesteeMetric_;
  investeeMetricReference: Scalars['String']['output'];
  /** An object relationship */
  investorMetric: InvestorMetric_;
  investorMetricReference: Scalars['String']['output'];
};

/** aggregated selection of "InvestorToInvesteeMetric" */
export type InvestorToInvesteeMetric_Aggregate_ = {
  __typename?: 'InvestorToInvesteeMetric_aggregate';
  aggregate?: Maybe<InvestorToInvesteeMetric_Aggregate_Fields_>;
  nodes: Array<InvestorToInvesteeMetric_>;
};

export type InvestorToInvesteeMetric_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<InvestorToInvesteeMetric_Aggregate_Bool_Exp_Count_>;
};

export type InvestorToInvesteeMetric_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<InvestorToInvesteeMetric_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<InvestorToInvesteeMetric_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "InvestorToInvesteeMetric" */
export type InvestorToInvesteeMetric_Aggregate_Fields_ = {
  __typename?: 'InvestorToInvesteeMetric_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<InvestorToInvesteeMetric_Max_Fields_>;
  min?: Maybe<InvestorToInvesteeMetric_Min_Fields_>;
};


/** aggregate fields of "InvestorToInvesteeMetric" */
export type InvestorToInvesteeMetric_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<InvestorToInvesteeMetric_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "InvestorToInvesteeMetric" */
export type InvestorToInvesteeMetric_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<InvestorToInvesteeMetric_Max_Order_By_>;
  min?: InputMaybe<InvestorToInvesteeMetric_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "InvestorToInvesteeMetric" */
export type InvestorToInvesteeMetric_Arr_Rel_Insert_Input_ = {
  data: Array<InvestorToInvesteeMetric_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<InvestorToInvesteeMetric_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "InvestorToInvesteeMetric". All fields are combined with a logical 'AND'. */
export type InvestorToInvesteeMetric_Bool_Exp_ = {
  _and?: InputMaybe<Array<InvestorToInvesteeMetric_Bool_Exp_>>;
  _not?: InputMaybe<InvestorToInvesteeMetric_Bool_Exp_>;
  _or?: InputMaybe<Array<InvestorToInvesteeMetric_Bool_Exp_>>;
  investeeMetric?: InputMaybe<InvesteeMetric_Bool_Exp_>;
  investeeMetricReference?: InputMaybe<String_Comparison_Exp_>;
  investorMetric?: InputMaybe<InvestorMetric_Bool_Exp_>;
  investorMetricReference?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "InvestorToInvesteeMetric" */
export enum InvestorToInvesteeMetric_Constraint_ {
  /** unique or primary key constraint on columns "investorMetricReference", "investeeMetricReference" */
  InvestorToInvesteeMetricPkey_ = 'InvestorToInvesteeMetric_pkey'
}

/** input type for inserting data into table "InvestorToInvesteeMetric" */
export type InvestorToInvesteeMetric_Insert_Input_ = {
  investeeMetric?: InputMaybe<InvesteeMetric_Obj_Rel_Insert_Input_>;
  investeeMetricReference?: InputMaybe<Scalars['String']['input']>;
  investorMetric?: InputMaybe<InvestorMetric_Obj_Rel_Insert_Input_>;
  investorMetricReference?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type InvestorToInvesteeMetric_Max_Fields_ = {
  __typename?: 'InvestorToInvesteeMetric_max_fields';
  investeeMetricReference?: Maybe<Scalars['String']['output']>;
  investorMetricReference?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "InvestorToInvesteeMetric" */
export type InvestorToInvesteeMetric_Max_Order_By_ = {
  investeeMetricReference?: InputMaybe<Order_By_>;
  investorMetricReference?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type InvestorToInvesteeMetric_Min_Fields_ = {
  __typename?: 'InvestorToInvesteeMetric_min_fields';
  investeeMetricReference?: Maybe<Scalars['String']['output']>;
  investorMetricReference?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "InvestorToInvesteeMetric" */
export type InvestorToInvesteeMetric_Min_Order_By_ = {
  investeeMetricReference?: InputMaybe<Order_By_>;
  investorMetricReference?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "InvestorToInvesteeMetric" */
export type InvestorToInvesteeMetric_Mutation_Response_ = {
  __typename?: 'InvestorToInvesteeMetric_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<InvestorToInvesteeMetric_>;
};

/** on_conflict condition type for table "InvestorToInvesteeMetric" */
export type InvestorToInvesteeMetric_On_Conflict_ = {
  constraint: InvestorToInvesteeMetric_Constraint_;
  update_columns?: Array<InvestorToInvesteeMetric_Update_Column_>;
  where?: InputMaybe<InvestorToInvesteeMetric_Bool_Exp_>;
};

/** Ordering options when selecting data from "InvestorToInvesteeMetric". */
export type InvestorToInvesteeMetric_Order_By_ = {
  investeeMetric?: InputMaybe<InvesteeMetric_Order_By_>;
  investeeMetricReference?: InputMaybe<Order_By_>;
  investorMetric?: InputMaybe<InvestorMetric_Order_By_>;
  investorMetricReference?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: InvestorToInvesteeMetric */
export type InvestorToInvesteeMetric_Pk_Columns_Input_ = {
  investeeMetricReference: Scalars['String']['input'];
  investorMetricReference: Scalars['String']['input'];
};

/** select columns of table "InvestorToInvesteeMetric" */
export enum InvestorToInvesteeMetric_Select_Column_ {
  /** column name */
  InvesteeMetricReference_ = 'investeeMetricReference',
  /** column name */
  InvestorMetricReference_ = 'investorMetricReference'
}

/** input type for updating data in table "InvestorToInvesteeMetric" */
export type InvestorToInvesteeMetric_Set_Input_ = {
  investeeMetricReference?: InputMaybe<Scalars['String']['input']>;
  investorMetricReference?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "InvestorToInvesteeMetric" */
export type InvestorToInvesteeMetric_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: InvestorToInvesteeMetric_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type InvestorToInvesteeMetric_Stream_Cursor_Value_Input_ = {
  investeeMetricReference?: InputMaybe<Scalars['String']['input']>;
  investorMetricReference?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "InvestorToInvesteeMetric" */
export enum InvestorToInvesteeMetric_Update_Column_ {
  /** column name */
  InvesteeMetricReference_ = 'investeeMetricReference',
  /** column name */
  InvestorMetricReference_ = 'investorMetricReference'
}

export type InvestorToInvesteeMetric_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<InvestorToInvesteeMetric_Set_Input_>;
  /** filter the rows which have to be updated */
  where: InvestorToInvesteeMetric_Bool_Exp_;
};

export type InvitationOutput_ = {
  __typename?: 'InvitationOutput';
  companyId: Scalars['uuid']['output'];
  companyLogoUrl?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  inviteToChildCompanies: Scalars['Boolean']['output'];
  status: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
  userExists: Scalars['Boolean']['output'];
};

export type InvitationQuery_ = {
  id: Scalars['uuid']['input'];
};

/** columns and relationships of "esrs.MFCategory" */
export type MfCategory_ = {
  __typename?: 'MFCategory';
  /** An array relationship */
  mfStandards: Array<MfStandard_>;
  /** An aggregate relationship */
  mfStandards_aggregate: MfStandard_Aggregate_;
  order: Scalars['Int']['output'];
  reference: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


/** columns and relationships of "esrs.MFCategory" */
export type MfCategoryMfStandardsArgs_ = {
  distinct_on?: InputMaybe<Array<MfStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandard_Order_By_>>;
  where?: InputMaybe<MfStandard_Bool_Exp_>;
};


/** columns and relationships of "esrs.MFCategory" */
export type MfCategoryMfStandards_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandard_Order_By_>>;
  where?: InputMaybe<MfStandard_Bool_Exp_>;
};

/** aggregated selection of "esrs.MFCategory" */
export type MfCategory_Aggregate_ = {
  __typename?: 'MFCategory_aggregate';
  aggregate?: Maybe<MfCategory_Aggregate_Fields_>;
  nodes: Array<MfCategory_>;
};

/** aggregate fields of "esrs.MFCategory" */
export type MfCategory_Aggregate_Fields_ = {
  __typename?: 'MFCategory_aggregate_fields';
  avg?: Maybe<MfCategory_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<MfCategory_Max_Fields_>;
  min?: Maybe<MfCategory_Min_Fields_>;
  stddev?: Maybe<MfCategory_Stddev_Fields_>;
  stddev_pop?: Maybe<MfCategory_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<MfCategory_Stddev_Samp_Fields_>;
  sum?: Maybe<MfCategory_Sum_Fields_>;
  var_pop?: Maybe<MfCategory_Var_Pop_Fields_>;
  var_samp?: Maybe<MfCategory_Var_Samp_Fields_>;
  variance?: Maybe<MfCategory_Variance_Fields_>;
};


/** aggregate fields of "esrs.MFCategory" */
export type MfCategory_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<MfCategory_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type MfCategory_Avg_Fields_ = {
  __typename?: 'MFCategory_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "esrs.MFCategory". All fields are combined with a logical 'AND'. */
export type MfCategory_Bool_Exp_ = {
  _and?: InputMaybe<Array<MfCategory_Bool_Exp_>>;
  _not?: InputMaybe<MfCategory_Bool_Exp_>;
  _or?: InputMaybe<Array<MfCategory_Bool_Exp_>>;
  mfStandards?: InputMaybe<MfStandard_Bool_Exp_>;
  mfStandards_aggregate?: InputMaybe<MfStandard_Aggregate_Bool_Exp_>;
  order?: InputMaybe<Int_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.MFCategory" */
export enum MfCategory_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  MfCategoryPkey_ = 'MFCategory_pkey'
}

/** input type for incrementing numeric columns in table "esrs.MFCategory" */
export type MfCategory_Inc_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.MFCategory" */
export type MfCategory_Insert_Input_ = {
  mfStandards?: InputMaybe<MfStandard_Arr_Rel_Insert_Input_>;
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MfCategory_Max_Fields_ = {
  __typename?: 'MFCategory_max_fields';
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type MfCategory_Min_Fields_ = {
  __typename?: 'MFCategory_min_fields';
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "esrs.MFCategory" */
export type MfCategory_Mutation_Response_ = {
  __typename?: 'MFCategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MfCategory_>;
};

/** input type for inserting object relation for remote table "esrs.MFCategory" */
export type MfCategory_Obj_Rel_Insert_Input_ = {
  data: MfCategory_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<MfCategory_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.MFCategory" */
export type MfCategory_On_Conflict_ = {
  constraint: MfCategory_Constraint_;
  update_columns?: Array<MfCategory_Update_Column_>;
  where?: InputMaybe<MfCategory_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.MFCategory". */
export type MfCategory_Order_By_ = {
  mfStandards_aggregate?: InputMaybe<MfStandard_Aggregate_Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.MFCategory */
export type MfCategory_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.MFCategory" */
export enum MfCategory_Select_Column_ {
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

/** input type for updating data in table "esrs.MFCategory" */
export type MfCategory_Set_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type MfCategory_Stddev_Fields_ = {
  __typename?: 'MFCategory_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type MfCategory_Stddev_Pop_Fields_ = {
  __typename?: 'MFCategory_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type MfCategory_Stddev_Samp_Fields_ = {
  __typename?: 'MFCategory_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "MFCategory" */
export type MfCategory_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: MfCategory_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type MfCategory_Stream_Cursor_Value_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type MfCategory_Sum_Fields_ = {
  __typename?: 'MFCategory_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "esrs.MFCategory" */
export enum MfCategory_Update_Column_ {
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

export type MfCategory_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MfCategory_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MfCategory_Set_Input_>;
  /** filter the rows which have to be updated */
  where: MfCategory_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type MfCategory_Var_Pop_Fields_ = {
  __typename?: 'MFCategory_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type MfCategory_Var_Samp_Fields_ = {
  __typename?: 'MFCategory_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type MfCategory_Variance_Fields_ = {
  __typename?: 'MFCategory_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_ = {
  __typename?: 'MFDisclosureRequirement';
  /** An array relationship */
  actions: Array<Esrs_Actions_>;
  /** An aggregate relationship */
  actions_aggregate: Esrs_Actions_Aggregate_;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  drToMFDisclosureRequirements: Array<DrToMfDisclosureRequirement_>;
  /** An aggregate relationship */
  drToMFDisclosureRequirements_aggregate: DrToMfDisclosureRequirement_Aggregate_;
  /** An object relationship */
  mfDisclosureRequirementGroup: MfDisclosureRequirementGroup_;
  mfDisclosureRequirementGroupRef: Scalars['String']['output'];
  /** An array relationship */
  mfDisclosureRequirementItems: Array<MfDisclosureRequirementItem_>;
  /** An aggregate relationship */
  mfDisclosureRequirementItems_aggregate: MfDisclosureRequirementItem_Aggregate_;
  order: Scalars['Int']['output'];
  /** An array relationship */
  policies: Array<Esrs_Policy_>;
  /** An aggregate relationship */
  policies_aggregate: Esrs_Policy_Aggregate_;
  reference: Scalars['String']['output'];
  /** An array relationship */
  targets: Array<Esrs_Target_>;
  /** An aggregate relationship */
  targets_aggregate: Esrs_Target_Aggregate_;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};


/** columns and relationships of "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirementActionsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Actions_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Actions_Order_By_>>;
  where?: InputMaybe<Esrs_Actions_Bool_Exp_>;
};


/** columns and relationships of "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirementActions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Actions_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Actions_Order_By_>>;
  where?: InputMaybe<Esrs_Actions_Bool_Exp_>;
};


/** columns and relationships of "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirementDrToMfDisclosureRequirementsArgs_ = {
  distinct_on?: InputMaybe<Array<DrToMfDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DrToMfDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<DrToMfDisclosureRequirement_Bool_Exp_>;
};


/** columns and relationships of "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirementDrToMfDisclosureRequirements_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DrToMfDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DrToMfDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<DrToMfDisclosureRequirement_Bool_Exp_>;
};


/** columns and relationships of "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirementMfDisclosureRequirementItemsArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirementItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementItem_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirementItem_Bool_Exp_>;
};


/** columns and relationships of "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirementMfDisclosureRequirementItems_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirementItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementItem_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirementItem_Bool_Exp_>;
};


/** columns and relationships of "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirementPoliciesArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Policy_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Policy_Order_By_>>;
  where?: InputMaybe<Esrs_Policy_Bool_Exp_>;
};


/** columns and relationships of "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirementPolicies_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Policy_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Policy_Order_By_>>;
  where?: InputMaybe<Esrs_Policy_Bool_Exp_>;
};


/** columns and relationships of "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirementTargetsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Target_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Target_Order_By_>>;
  where?: InputMaybe<Esrs_Target_Bool_Exp_>;
};


/** columns and relationships of "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirementTargets_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Target_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Target_Order_By_>>;
  where?: InputMaybe<Esrs_Target_Bool_Exp_>;
};

/** columns and relationships of "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_ = {
  __typename?: 'MFDisclosureRequirementGroup';
  /** An array relationship */
  mfDisclosureRequirements: Array<MfDisclosureRequirement_>;
  /** An aggregate relationship */
  mfDisclosureRequirements_aggregate: MfDisclosureRequirement_Aggregate_;
  /** An object relationship */
  mfStandard: MfStandard_;
  mfStandardRef: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  reference: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


/** columns and relationships of "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroupMfDisclosureRequirementsArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirement_Bool_Exp_>;
};


/** columns and relationships of "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroupMfDisclosureRequirements_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirement_Bool_Exp_>;
};

/** aggregated selection of "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Aggregate_ = {
  __typename?: 'MFDisclosureRequirementGroup_aggregate';
  aggregate?: Maybe<MfDisclosureRequirementGroup_Aggregate_Fields_>;
  nodes: Array<MfDisclosureRequirementGroup_>;
};

export type MfDisclosureRequirementGroup_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<MfDisclosureRequirementGroup_Aggregate_Bool_Exp_Count_>;
};

export type MfDisclosureRequirementGroup_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<MfDisclosureRequirementGroup_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MfDisclosureRequirementGroup_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Aggregate_Fields_ = {
  __typename?: 'MFDisclosureRequirementGroup_aggregate_fields';
  avg?: Maybe<MfDisclosureRequirementGroup_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<MfDisclosureRequirementGroup_Max_Fields_>;
  min?: Maybe<MfDisclosureRequirementGroup_Min_Fields_>;
  stddev?: Maybe<MfDisclosureRequirementGroup_Stddev_Fields_>;
  stddev_pop?: Maybe<MfDisclosureRequirementGroup_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<MfDisclosureRequirementGroup_Stddev_Samp_Fields_>;
  sum?: Maybe<MfDisclosureRequirementGroup_Sum_Fields_>;
  var_pop?: Maybe<MfDisclosureRequirementGroup_Var_Pop_Fields_>;
  var_samp?: Maybe<MfDisclosureRequirementGroup_Var_Samp_Fields_>;
  variance?: Maybe<MfDisclosureRequirementGroup_Variance_Fields_>;
};


/** aggregate fields of "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<MfDisclosureRequirementGroup_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Aggregate_Order_By_ = {
  avg?: InputMaybe<MfDisclosureRequirementGroup_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<MfDisclosureRequirementGroup_Max_Order_By_>;
  min?: InputMaybe<MfDisclosureRequirementGroup_Min_Order_By_>;
  stddev?: InputMaybe<MfDisclosureRequirementGroup_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<MfDisclosureRequirementGroup_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<MfDisclosureRequirementGroup_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<MfDisclosureRequirementGroup_Sum_Order_By_>;
  var_pop?: InputMaybe<MfDisclosureRequirementGroup_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<MfDisclosureRequirementGroup_Var_Samp_Order_By_>;
  variance?: InputMaybe<MfDisclosureRequirementGroup_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Arr_Rel_Insert_Input_ = {
  data: Array<MfDisclosureRequirementGroup_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<MfDisclosureRequirementGroup_On_Conflict_>;
};

/** aggregate avg on columns */
export type MfDisclosureRequirementGroup_Avg_Fields_ = {
  __typename?: 'MFDisclosureRequirementGroup_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Avg_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.MFDisclosureRequirementGroup". All fields are combined with a logical 'AND'. */
export type MfDisclosureRequirementGroup_Bool_Exp_ = {
  _and?: InputMaybe<Array<MfDisclosureRequirementGroup_Bool_Exp_>>;
  _not?: InputMaybe<MfDisclosureRequirementGroup_Bool_Exp_>;
  _or?: InputMaybe<Array<MfDisclosureRequirementGroup_Bool_Exp_>>;
  mfDisclosureRequirements?: InputMaybe<MfDisclosureRequirement_Bool_Exp_>;
  mfDisclosureRequirements_aggregate?: InputMaybe<MfDisclosureRequirement_Aggregate_Bool_Exp_>;
  mfStandard?: InputMaybe<MfStandard_Bool_Exp_>;
  mfStandardRef?: InputMaybe<String_Comparison_Exp_>;
  order?: InputMaybe<Int_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.MFDisclosureRequirementGroup" */
export enum MfDisclosureRequirementGroup_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  MfDisclosureRequirementGroupPkey_ = 'MFDisclosureRequirementGroup_pkey'
}

/** input type for incrementing numeric columns in table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Inc_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Insert_Input_ = {
  mfDisclosureRequirements?: InputMaybe<MfDisclosureRequirement_Arr_Rel_Insert_Input_>;
  mfStandard?: InputMaybe<MfStandard_Obj_Rel_Insert_Input_>;
  mfStandardRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MfDisclosureRequirementGroup_Max_Fields_ = {
  __typename?: 'MFDisclosureRequirementGroup_max_fields';
  mfStandardRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Max_Order_By_ = {
  mfStandardRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type MfDisclosureRequirementGroup_Min_Fields_ = {
  __typename?: 'MFDisclosureRequirementGroup_min_fields';
  mfStandardRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Min_Order_By_ = {
  mfStandardRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Mutation_Response_ = {
  __typename?: 'MFDisclosureRequirementGroup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MfDisclosureRequirementGroup_>;
};

/** input type for inserting object relation for remote table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Obj_Rel_Insert_Input_ = {
  data: MfDisclosureRequirementGroup_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<MfDisclosureRequirementGroup_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_On_Conflict_ = {
  constraint: MfDisclosureRequirementGroup_Constraint_;
  update_columns?: Array<MfDisclosureRequirementGroup_Update_Column_>;
  where?: InputMaybe<MfDisclosureRequirementGroup_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.MFDisclosureRequirementGroup". */
export type MfDisclosureRequirementGroup_Order_By_ = {
  mfDisclosureRequirements_aggregate?: InputMaybe<MfDisclosureRequirement_Aggregate_Order_By_>;
  mfStandard?: InputMaybe<MfStandard_Order_By_>;
  mfStandardRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.MFDisclosureRequirementGroup */
export type MfDisclosureRequirementGroup_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.MFDisclosureRequirementGroup" */
export enum MfDisclosureRequirementGroup_Select_Column_ {
  /** column name */
  MfStandardRef_ = 'mfStandardRef',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

/** input type for updating data in table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Set_Input_ = {
  mfStandardRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type MfDisclosureRequirementGroup_Stddev_Fields_ = {
  __typename?: 'MFDisclosureRequirementGroup_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Stddev_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type MfDisclosureRequirementGroup_Stddev_Pop_Fields_ = {
  __typename?: 'MFDisclosureRequirementGroup_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Stddev_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type MfDisclosureRequirementGroup_Stddev_Samp_Fields_ = {
  __typename?: 'MFDisclosureRequirementGroup_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Stddev_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: MfDisclosureRequirementGroup_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type MfDisclosureRequirementGroup_Stream_Cursor_Value_Input_ = {
  mfStandardRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type MfDisclosureRequirementGroup_Sum_Fields_ = {
  __typename?: 'MFDisclosureRequirementGroup_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Sum_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.MFDisclosureRequirementGroup" */
export enum MfDisclosureRequirementGroup_Update_Column_ {
  /** column name */
  MfStandardRef_ = 'mfStandardRef',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

export type MfDisclosureRequirementGroup_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MfDisclosureRequirementGroup_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MfDisclosureRequirementGroup_Set_Input_>;
  /** filter the rows which have to be updated */
  where: MfDisclosureRequirementGroup_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type MfDisclosureRequirementGroup_Var_Pop_Fields_ = {
  __typename?: 'MFDisclosureRequirementGroup_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Var_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type MfDisclosureRequirementGroup_Var_Samp_Fields_ = {
  __typename?: 'MFDisclosureRequirementGroup_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Var_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type MfDisclosureRequirementGroup_Variance_Fields_ = {
  __typename?: 'MFDisclosureRequirementGroup_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.MFDisclosureRequirementGroup" */
export type MfDisclosureRequirementGroup_Variance_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** columns and relationships of "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_ = {
  __typename?: 'MFDisclosureRequirementItem';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  metric: EsrsMetric_;
  metricRef: Scalars['String']['output'];
  /** An object relationship */
  mfDisclosureRequirement: MfDisclosureRequirement_;
  mfDisclosureRequirementRef: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

/** aggregated selection of "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Aggregate_ = {
  __typename?: 'MFDisclosureRequirementItem_aggregate';
  aggregate?: Maybe<MfDisclosureRequirementItem_Aggregate_Fields_>;
  nodes: Array<MfDisclosureRequirementItem_>;
};

export type MfDisclosureRequirementItem_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<MfDisclosureRequirementItem_Aggregate_Bool_Exp_Count_>;
};

export type MfDisclosureRequirementItem_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<MfDisclosureRequirementItem_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MfDisclosureRequirementItem_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Aggregate_Fields_ = {
  __typename?: 'MFDisclosureRequirementItem_aggregate_fields';
  avg?: Maybe<MfDisclosureRequirementItem_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<MfDisclosureRequirementItem_Max_Fields_>;
  min?: Maybe<MfDisclosureRequirementItem_Min_Fields_>;
  stddev?: Maybe<MfDisclosureRequirementItem_Stddev_Fields_>;
  stddev_pop?: Maybe<MfDisclosureRequirementItem_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<MfDisclosureRequirementItem_Stddev_Samp_Fields_>;
  sum?: Maybe<MfDisclosureRequirementItem_Sum_Fields_>;
  var_pop?: Maybe<MfDisclosureRequirementItem_Var_Pop_Fields_>;
  var_samp?: Maybe<MfDisclosureRequirementItem_Var_Samp_Fields_>;
  variance?: Maybe<MfDisclosureRequirementItem_Variance_Fields_>;
};


/** aggregate fields of "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<MfDisclosureRequirementItem_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Aggregate_Order_By_ = {
  avg?: InputMaybe<MfDisclosureRequirementItem_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<MfDisclosureRequirementItem_Max_Order_By_>;
  min?: InputMaybe<MfDisclosureRequirementItem_Min_Order_By_>;
  stddev?: InputMaybe<MfDisclosureRequirementItem_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<MfDisclosureRequirementItem_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<MfDisclosureRequirementItem_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<MfDisclosureRequirementItem_Sum_Order_By_>;
  var_pop?: InputMaybe<MfDisclosureRequirementItem_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<MfDisclosureRequirementItem_Var_Samp_Order_By_>;
  variance?: InputMaybe<MfDisclosureRequirementItem_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Arr_Rel_Insert_Input_ = {
  data: Array<MfDisclosureRequirementItem_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<MfDisclosureRequirementItem_On_Conflict_>;
};

/** aggregate avg on columns */
export type MfDisclosureRequirementItem_Avg_Fields_ = {
  __typename?: 'MFDisclosureRequirementItem_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Avg_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.MFDisclosureRequirementItem". All fields are combined with a logical 'AND'. */
export type MfDisclosureRequirementItem_Bool_Exp_ = {
  _and?: InputMaybe<Array<MfDisclosureRequirementItem_Bool_Exp_>>;
  _not?: InputMaybe<MfDisclosureRequirementItem_Bool_Exp_>;
  _or?: InputMaybe<Array<MfDisclosureRequirementItem_Bool_Exp_>>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  metric?: InputMaybe<EsrsMetric_Bool_Exp_>;
  metricRef?: InputMaybe<String_Comparison_Exp_>;
  mfDisclosureRequirement?: InputMaybe<MfDisclosureRequirement_Bool_Exp_>;
  mfDisclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
  order?: InputMaybe<Int_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.MFDisclosureRequirementItem" */
export enum MfDisclosureRequirementItem_Constraint_ {
  /** unique or primary key constraint on columns "metricRef", "mfDisclosureRequirementRef" */
  MfDisclosureRequirementItemMfDisclosureRequirementRefMetrKey_ = 'MFDisclosureRequirementItem_mfDisclosureRequirementRef_metr_key',
  /** unique or primary key constraint on columns "id" */
  MfDisclosureRequirementItemPkey_ = 'MFDisclosureRequirementItem_pkey'
}

/** input type for incrementing numeric columns in table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Inc_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Insert_Input_ = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  metric?: InputMaybe<EsrsMetric_Obj_Rel_Insert_Input_>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  mfDisclosureRequirement?: InputMaybe<MfDisclosureRequirement_Obj_Rel_Insert_Input_>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type MfDisclosureRequirementItem_Max_Fields_ = {
  __typename?: 'MFDisclosureRequirementItem_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  metricRef?: Maybe<Scalars['String']['output']>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Max_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type MfDisclosureRequirementItem_Min_Fields_ = {
  __typename?: 'MFDisclosureRequirementItem_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  metricRef?: Maybe<Scalars['String']['output']>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Min_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Mutation_Response_ = {
  __typename?: 'MFDisclosureRequirementItem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MfDisclosureRequirementItem_>;
};

/** on_conflict condition type for table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_On_Conflict_ = {
  constraint: MfDisclosureRequirementItem_Constraint_;
  update_columns?: Array<MfDisclosureRequirementItem_Update_Column_>;
  where?: InputMaybe<MfDisclosureRequirementItem_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.MFDisclosureRequirementItem". */
export type MfDisclosureRequirementItem_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  metric?: InputMaybe<EsrsMetric_Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
  mfDisclosureRequirement?: InputMaybe<MfDisclosureRequirement_Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.MFDisclosureRequirementItem */
export type MfDisclosureRequirementItem_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.MFDisclosureRequirementItem" */
export enum MfDisclosureRequirementItem_Select_Column_ {
  /** column name */
  Id_ = 'id',
  /** column name */
  MetricRef_ = 'metricRef',
  /** column name */
  MfDisclosureRequirementRef_ = 'mfDisclosureRequirementRef',
  /** column name */
  Order_ = 'order'
}

/** input type for updating data in table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Set_Input_ = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type MfDisclosureRequirementItem_Stddev_Fields_ = {
  __typename?: 'MFDisclosureRequirementItem_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Stddev_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type MfDisclosureRequirementItem_Stddev_Pop_Fields_ = {
  __typename?: 'MFDisclosureRequirementItem_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Stddev_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type MfDisclosureRequirementItem_Stddev_Samp_Fields_ = {
  __typename?: 'MFDisclosureRequirementItem_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Stddev_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: MfDisclosureRequirementItem_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type MfDisclosureRequirementItem_Stream_Cursor_Value_Input_ = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type MfDisclosureRequirementItem_Sum_Fields_ = {
  __typename?: 'MFDisclosureRequirementItem_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Sum_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.MFDisclosureRequirementItem" */
export enum MfDisclosureRequirementItem_Update_Column_ {
  /** column name */
  Id_ = 'id',
  /** column name */
  MetricRef_ = 'metricRef',
  /** column name */
  MfDisclosureRequirementRef_ = 'mfDisclosureRequirementRef',
  /** column name */
  Order_ = 'order'
}

export type MfDisclosureRequirementItem_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MfDisclosureRequirementItem_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MfDisclosureRequirementItem_Set_Input_>;
  /** filter the rows which have to be updated */
  where: MfDisclosureRequirementItem_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type MfDisclosureRequirementItem_Var_Pop_Fields_ = {
  __typename?: 'MFDisclosureRequirementItem_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Var_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type MfDisclosureRequirementItem_Var_Samp_Fields_ = {
  __typename?: 'MFDisclosureRequirementItem_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Var_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type MfDisclosureRequirementItem_Variance_Fields_ = {
  __typename?: 'MFDisclosureRequirementItem_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.MFDisclosureRequirementItem" */
export type MfDisclosureRequirementItem_Variance_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregated selection of "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Aggregate_ = {
  __typename?: 'MFDisclosureRequirement_aggregate';
  aggregate?: Maybe<MfDisclosureRequirement_Aggregate_Fields_>;
  nodes: Array<MfDisclosureRequirement_>;
};

export type MfDisclosureRequirement_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<MfDisclosureRequirement_Aggregate_Bool_Exp_Count_>;
};

export type MfDisclosureRequirement_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<MfDisclosureRequirement_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MfDisclosureRequirement_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Aggregate_Fields_ = {
  __typename?: 'MFDisclosureRequirement_aggregate_fields';
  avg?: Maybe<MfDisclosureRequirement_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<MfDisclosureRequirement_Max_Fields_>;
  min?: Maybe<MfDisclosureRequirement_Min_Fields_>;
  stddev?: Maybe<MfDisclosureRequirement_Stddev_Fields_>;
  stddev_pop?: Maybe<MfDisclosureRequirement_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<MfDisclosureRequirement_Stddev_Samp_Fields_>;
  sum?: Maybe<MfDisclosureRequirement_Sum_Fields_>;
  var_pop?: Maybe<MfDisclosureRequirement_Var_Pop_Fields_>;
  var_samp?: Maybe<MfDisclosureRequirement_Var_Samp_Fields_>;
  variance?: Maybe<MfDisclosureRequirement_Variance_Fields_>;
};


/** aggregate fields of "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<MfDisclosureRequirement_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Aggregate_Order_By_ = {
  avg?: InputMaybe<MfDisclosureRequirement_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<MfDisclosureRequirement_Max_Order_By_>;
  min?: InputMaybe<MfDisclosureRequirement_Min_Order_By_>;
  stddev?: InputMaybe<MfDisclosureRequirement_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<MfDisclosureRequirement_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<MfDisclosureRequirement_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<MfDisclosureRequirement_Sum_Order_By_>;
  var_pop?: InputMaybe<MfDisclosureRequirement_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<MfDisclosureRequirement_Var_Samp_Order_By_>;
  variance?: InputMaybe<MfDisclosureRequirement_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Arr_Rel_Insert_Input_ = {
  data: Array<MfDisclosureRequirement_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<MfDisclosureRequirement_On_Conflict_>;
};

/** aggregate avg on columns */
export type MfDisclosureRequirement_Avg_Fields_ = {
  __typename?: 'MFDisclosureRequirement_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Avg_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.MFDisclosureRequirement". All fields are combined with a logical 'AND'. */
export type MfDisclosureRequirement_Bool_Exp_ = {
  _and?: InputMaybe<Array<MfDisclosureRequirement_Bool_Exp_>>;
  _not?: InputMaybe<MfDisclosureRequirement_Bool_Exp_>;
  _or?: InputMaybe<Array<MfDisclosureRequirement_Bool_Exp_>>;
  actions?: InputMaybe<Esrs_Actions_Bool_Exp_>;
  actions_aggregate?: InputMaybe<Esrs_Actions_Aggregate_Bool_Exp_>;
  description?: InputMaybe<String_Comparison_Exp_>;
  drToMFDisclosureRequirements?: InputMaybe<DrToMfDisclosureRequirement_Bool_Exp_>;
  drToMFDisclosureRequirements_aggregate?: InputMaybe<DrToMfDisclosureRequirement_Aggregate_Bool_Exp_>;
  mfDisclosureRequirementGroup?: InputMaybe<MfDisclosureRequirementGroup_Bool_Exp_>;
  mfDisclosureRequirementGroupRef?: InputMaybe<String_Comparison_Exp_>;
  mfDisclosureRequirementItems?: InputMaybe<MfDisclosureRequirementItem_Bool_Exp_>;
  mfDisclosureRequirementItems_aggregate?: InputMaybe<MfDisclosureRequirementItem_Aggregate_Bool_Exp_>;
  order?: InputMaybe<Int_Comparison_Exp_>;
  policies?: InputMaybe<Esrs_Policy_Bool_Exp_>;
  policies_aggregate?: InputMaybe<Esrs_Policy_Aggregate_Bool_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  targets?: InputMaybe<Esrs_Target_Bool_Exp_>;
  targets_aggregate?: InputMaybe<Esrs_Target_Aggregate_Bool_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
  type?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.MFDisclosureRequirement" */
export enum MfDisclosureRequirement_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  MfDisclosureRequirementPkey_ = 'MFDisclosureRequirement_pkey'
}

/** input type for incrementing numeric columns in table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Inc_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Insert_Input_ = {
  actions?: InputMaybe<Esrs_Actions_Arr_Rel_Insert_Input_>;
  description?: InputMaybe<Scalars['String']['input']>;
  drToMFDisclosureRequirements?: InputMaybe<DrToMfDisclosureRequirement_Arr_Rel_Insert_Input_>;
  mfDisclosureRequirementGroup?: InputMaybe<MfDisclosureRequirementGroup_Obj_Rel_Insert_Input_>;
  mfDisclosureRequirementGroupRef?: InputMaybe<Scalars['String']['input']>;
  mfDisclosureRequirementItems?: InputMaybe<MfDisclosureRequirementItem_Arr_Rel_Insert_Input_>;
  order?: InputMaybe<Scalars['Int']['input']>;
  policies?: InputMaybe<Esrs_Policy_Arr_Rel_Insert_Input_>;
  reference?: InputMaybe<Scalars['String']['input']>;
  targets?: InputMaybe<Esrs_Target_Arr_Rel_Insert_Input_>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MfDisclosureRequirement_Max_Fields_ = {
  __typename?: 'MFDisclosureRequirement_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  mfDisclosureRequirementGroupRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Max_Order_By_ = {
  description?: InputMaybe<Order_By_>;
  mfDisclosureRequirementGroupRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  type?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type MfDisclosureRequirement_Min_Fields_ = {
  __typename?: 'MFDisclosureRequirement_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  mfDisclosureRequirementGroupRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Min_Order_By_ = {
  description?: InputMaybe<Order_By_>;
  mfDisclosureRequirementGroupRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  type?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Mutation_Response_ = {
  __typename?: 'MFDisclosureRequirement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MfDisclosureRequirement_>;
};

/** input type for inserting object relation for remote table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Obj_Rel_Insert_Input_ = {
  data: MfDisclosureRequirement_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<MfDisclosureRequirement_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_On_Conflict_ = {
  constraint: MfDisclosureRequirement_Constraint_;
  update_columns?: Array<MfDisclosureRequirement_Update_Column_>;
  where?: InputMaybe<MfDisclosureRequirement_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.MFDisclosureRequirement". */
export type MfDisclosureRequirement_Order_By_ = {
  actions_aggregate?: InputMaybe<Esrs_Actions_Aggregate_Order_By_>;
  description?: InputMaybe<Order_By_>;
  drToMFDisclosureRequirements_aggregate?: InputMaybe<DrToMfDisclosureRequirement_Aggregate_Order_By_>;
  mfDisclosureRequirementGroup?: InputMaybe<MfDisclosureRequirementGroup_Order_By_>;
  mfDisclosureRequirementGroupRef?: InputMaybe<Order_By_>;
  mfDisclosureRequirementItems_aggregate?: InputMaybe<MfDisclosureRequirementItem_Aggregate_Order_By_>;
  order?: InputMaybe<Order_By_>;
  policies_aggregate?: InputMaybe<Esrs_Policy_Aggregate_Order_By_>;
  reference?: InputMaybe<Order_By_>;
  targets_aggregate?: InputMaybe<Esrs_Target_Aggregate_Order_By_>;
  title?: InputMaybe<Order_By_>;
  type?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.MFDisclosureRequirement */
export type MfDisclosureRequirement_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.MFDisclosureRequirement" */
export enum MfDisclosureRequirement_Select_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  MfDisclosureRequirementGroupRef_ = 'mfDisclosureRequirementGroupRef',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title',
  /** column name */
  Type_ = 'type'
}

/** input type for updating data in table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Set_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  mfDisclosureRequirementGroupRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type MfDisclosureRequirement_Stddev_Fields_ = {
  __typename?: 'MFDisclosureRequirement_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Stddev_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type MfDisclosureRequirement_Stddev_Pop_Fields_ = {
  __typename?: 'MFDisclosureRequirement_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Stddev_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type MfDisclosureRequirement_Stddev_Samp_Fields_ = {
  __typename?: 'MFDisclosureRequirement_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Stddev_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "MFDisclosureRequirement" */
export type MfDisclosureRequirement_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: MfDisclosureRequirement_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type MfDisclosureRequirement_Stream_Cursor_Value_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  mfDisclosureRequirementGroupRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type MfDisclosureRequirement_Sum_Fields_ = {
  __typename?: 'MFDisclosureRequirement_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Sum_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.MFDisclosureRequirement" */
export enum MfDisclosureRequirement_Update_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  MfDisclosureRequirementGroupRef_ = 'mfDisclosureRequirementGroupRef',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title',
  /** column name */
  Type_ = 'type'
}

export type MfDisclosureRequirement_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MfDisclosureRequirement_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MfDisclosureRequirement_Set_Input_>;
  /** filter the rows which have to be updated */
  where: MfDisclosureRequirement_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type MfDisclosureRequirement_Var_Pop_Fields_ = {
  __typename?: 'MFDisclosureRequirement_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Var_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type MfDisclosureRequirement_Var_Samp_Fields_ = {
  __typename?: 'MFDisclosureRequirement_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Var_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type MfDisclosureRequirement_Variance_Fields_ = {
  __typename?: 'MFDisclosureRequirement_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.MFDisclosureRequirement" */
export type MfDisclosureRequirement_Variance_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** columns and relationships of "esrs.MFStandard" */
export type MfStandard_ = {
  __typename?: 'MFStandard';
  description?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  fakeStandard?: Maybe<EsrsStandard_>;
  /** An object relationship */
  mfCategory: MfCategory_;
  mfCategoryRef: Scalars['String']['output'];
  /** An array relationship */
  mfDisclosureRequirementGroups: Array<MfDisclosureRequirementGroup_>;
  /** An aggregate relationship */
  mfDisclosureRequirementGroups_aggregate: MfDisclosureRequirementGroup_Aggregate_;
  /** An array relationship */
  mfStandardItems: Array<MfStandardItem_>;
  /** An aggregate relationship */
  mfStandardItems_aggregate: MfStandardItem_Aggregate_;
  order: Scalars['Int']['output'];
  reference: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


/** columns and relationships of "esrs.MFStandard" */
export type MfStandardMfDisclosureRequirementGroupsArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirementGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementGroup_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirementGroup_Bool_Exp_>;
};


/** columns and relationships of "esrs.MFStandard" */
export type MfStandardMfDisclosureRequirementGroups_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirementGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementGroup_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirementGroup_Bool_Exp_>;
};


/** columns and relationships of "esrs.MFStandard" */
export type MfStandardMfStandardItemsArgs_ = {
  distinct_on?: InputMaybe<Array<MfStandardItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandardItem_Order_By_>>;
  where?: InputMaybe<MfStandardItem_Bool_Exp_>;
};


/** columns and relationships of "esrs.MFStandard" */
export type MfStandardMfStandardItems_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfStandardItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandardItem_Order_By_>>;
  where?: InputMaybe<MfStandardItem_Bool_Exp_>;
};

/** columns and relationships of "esrs.MFStandardItem" */
export type MfStandardItem_ = {
  __typename?: 'MFStandardItem';
  id: Scalars['uuid']['output'];
  /** An object relationship */
  mfStandard: MfStandard_;
  mfStandardRef: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** An object relationship */
  standard: EsrsStandard_;
  standardRef: Scalars['String']['output'];
};

/** aggregated selection of "esrs.MFStandardItem" */
export type MfStandardItem_Aggregate_ = {
  __typename?: 'MFStandardItem_aggregate';
  aggregate?: Maybe<MfStandardItem_Aggregate_Fields_>;
  nodes: Array<MfStandardItem_>;
};

export type MfStandardItem_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<MfStandardItem_Aggregate_Bool_Exp_Count_>;
};

export type MfStandardItem_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<MfStandardItem_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MfStandardItem_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.MFStandardItem" */
export type MfStandardItem_Aggregate_Fields_ = {
  __typename?: 'MFStandardItem_aggregate_fields';
  avg?: Maybe<MfStandardItem_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<MfStandardItem_Max_Fields_>;
  min?: Maybe<MfStandardItem_Min_Fields_>;
  stddev?: Maybe<MfStandardItem_Stddev_Fields_>;
  stddev_pop?: Maybe<MfStandardItem_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<MfStandardItem_Stddev_Samp_Fields_>;
  sum?: Maybe<MfStandardItem_Sum_Fields_>;
  var_pop?: Maybe<MfStandardItem_Var_Pop_Fields_>;
  var_samp?: Maybe<MfStandardItem_Var_Samp_Fields_>;
  variance?: Maybe<MfStandardItem_Variance_Fields_>;
};


/** aggregate fields of "esrs.MFStandardItem" */
export type MfStandardItem_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<MfStandardItem_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.MFStandardItem" */
export type MfStandardItem_Aggregate_Order_By_ = {
  avg?: InputMaybe<MfStandardItem_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<MfStandardItem_Max_Order_By_>;
  min?: InputMaybe<MfStandardItem_Min_Order_By_>;
  stddev?: InputMaybe<MfStandardItem_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<MfStandardItem_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<MfStandardItem_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<MfStandardItem_Sum_Order_By_>;
  var_pop?: InputMaybe<MfStandardItem_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<MfStandardItem_Var_Samp_Order_By_>;
  variance?: InputMaybe<MfStandardItem_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.MFStandardItem" */
export type MfStandardItem_Arr_Rel_Insert_Input_ = {
  data: Array<MfStandardItem_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<MfStandardItem_On_Conflict_>;
};

/** aggregate avg on columns */
export type MfStandardItem_Avg_Fields_ = {
  __typename?: 'MFStandardItem_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.MFStandardItem" */
export type MfStandardItem_Avg_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.MFStandardItem". All fields are combined with a logical 'AND'. */
export type MfStandardItem_Bool_Exp_ = {
  _and?: InputMaybe<Array<MfStandardItem_Bool_Exp_>>;
  _not?: InputMaybe<MfStandardItem_Bool_Exp_>;
  _or?: InputMaybe<Array<MfStandardItem_Bool_Exp_>>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  mfStandard?: InputMaybe<MfStandard_Bool_Exp_>;
  mfStandardRef?: InputMaybe<String_Comparison_Exp_>;
  order?: InputMaybe<Int_Comparison_Exp_>;
  standard?: InputMaybe<EsrsStandard_Bool_Exp_>;
  standardRef?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.MFStandardItem" */
export enum MfStandardItem_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  MfStandardItemPkey_ = 'MFStandardItem_pkey',
  /** unique or primary key constraint on columns "mfStandardRef", "standardRef" */
  MfStandardItemStandardRefMfStandardRefKey_ = 'MFStandardItem_standardRef_mfStandardRef_key'
}

/** input type for incrementing numeric columns in table "esrs.MFStandardItem" */
export type MfStandardItem_Inc_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.MFStandardItem" */
export type MfStandardItem_Insert_Input_ = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  mfStandard?: InputMaybe<MfStandard_Obj_Rel_Insert_Input_>;
  mfStandardRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  standard?: InputMaybe<EsrsStandard_Obj_Rel_Insert_Input_>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MfStandardItem_Max_Fields_ = {
  __typename?: 'MFStandardItem_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  mfStandardRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  standardRef?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.MFStandardItem" */
export type MfStandardItem_Max_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  mfStandardRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type MfStandardItem_Min_Fields_ = {
  __typename?: 'MFStandardItem_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  mfStandardRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  standardRef?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.MFStandardItem" */
export type MfStandardItem_Min_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  mfStandardRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.MFStandardItem" */
export type MfStandardItem_Mutation_Response_ = {
  __typename?: 'MFStandardItem_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MfStandardItem_>;
};

/** on_conflict condition type for table "esrs.MFStandardItem" */
export type MfStandardItem_On_Conflict_ = {
  constraint: MfStandardItem_Constraint_;
  update_columns?: Array<MfStandardItem_Update_Column_>;
  where?: InputMaybe<MfStandardItem_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.MFStandardItem". */
export type MfStandardItem_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  mfStandard?: InputMaybe<MfStandard_Order_By_>;
  mfStandardRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  standard?: InputMaybe<EsrsStandard_Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.MFStandardItem */
export type MfStandardItem_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.MFStandardItem" */
export enum MfStandardItem_Select_Column_ {
  /** column name */
  Id_ = 'id',
  /** column name */
  MfStandardRef_ = 'mfStandardRef',
  /** column name */
  Order_ = 'order',
  /** column name */
  StandardRef_ = 'standardRef'
}

/** input type for updating data in table "esrs.MFStandardItem" */
export type MfStandardItem_Set_Input_ = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  mfStandardRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type MfStandardItem_Stddev_Fields_ = {
  __typename?: 'MFStandardItem_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.MFStandardItem" */
export type MfStandardItem_Stddev_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type MfStandardItem_Stddev_Pop_Fields_ = {
  __typename?: 'MFStandardItem_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.MFStandardItem" */
export type MfStandardItem_Stddev_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type MfStandardItem_Stddev_Samp_Fields_ = {
  __typename?: 'MFStandardItem_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.MFStandardItem" */
export type MfStandardItem_Stddev_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "MFStandardItem" */
export type MfStandardItem_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: MfStandardItem_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type MfStandardItem_Stream_Cursor_Value_Input_ = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  mfStandardRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type MfStandardItem_Sum_Fields_ = {
  __typename?: 'MFStandardItem_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.MFStandardItem" */
export type MfStandardItem_Sum_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.MFStandardItem" */
export enum MfStandardItem_Update_Column_ {
  /** column name */
  Id_ = 'id',
  /** column name */
  MfStandardRef_ = 'mfStandardRef',
  /** column name */
  Order_ = 'order',
  /** column name */
  StandardRef_ = 'standardRef'
}

export type MfStandardItem_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MfStandardItem_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MfStandardItem_Set_Input_>;
  /** filter the rows which have to be updated */
  where: MfStandardItem_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type MfStandardItem_Var_Pop_Fields_ = {
  __typename?: 'MFStandardItem_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.MFStandardItem" */
export type MfStandardItem_Var_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type MfStandardItem_Var_Samp_Fields_ = {
  __typename?: 'MFStandardItem_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.MFStandardItem" */
export type MfStandardItem_Var_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type MfStandardItem_Variance_Fields_ = {
  __typename?: 'MFStandardItem_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.MFStandardItem" */
export type MfStandardItem_Variance_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregated selection of "esrs.MFStandard" */
export type MfStandard_Aggregate_ = {
  __typename?: 'MFStandard_aggregate';
  aggregate?: Maybe<MfStandard_Aggregate_Fields_>;
  nodes: Array<MfStandard_>;
};

export type MfStandard_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<MfStandard_Aggregate_Bool_Exp_Count_>;
};

export type MfStandard_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<MfStandard_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MfStandard_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.MFStandard" */
export type MfStandard_Aggregate_Fields_ = {
  __typename?: 'MFStandard_aggregate_fields';
  avg?: Maybe<MfStandard_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<MfStandard_Max_Fields_>;
  min?: Maybe<MfStandard_Min_Fields_>;
  stddev?: Maybe<MfStandard_Stddev_Fields_>;
  stddev_pop?: Maybe<MfStandard_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<MfStandard_Stddev_Samp_Fields_>;
  sum?: Maybe<MfStandard_Sum_Fields_>;
  var_pop?: Maybe<MfStandard_Var_Pop_Fields_>;
  var_samp?: Maybe<MfStandard_Var_Samp_Fields_>;
  variance?: Maybe<MfStandard_Variance_Fields_>;
};


/** aggregate fields of "esrs.MFStandard" */
export type MfStandard_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<MfStandard_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.MFStandard" */
export type MfStandard_Aggregate_Order_By_ = {
  avg?: InputMaybe<MfStandard_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<MfStandard_Max_Order_By_>;
  min?: InputMaybe<MfStandard_Min_Order_By_>;
  stddev?: InputMaybe<MfStandard_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<MfStandard_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<MfStandard_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<MfStandard_Sum_Order_By_>;
  var_pop?: InputMaybe<MfStandard_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<MfStandard_Var_Samp_Order_By_>;
  variance?: InputMaybe<MfStandard_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.MFStandard" */
export type MfStandard_Arr_Rel_Insert_Input_ = {
  data: Array<MfStandard_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<MfStandard_On_Conflict_>;
};

/** aggregate avg on columns */
export type MfStandard_Avg_Fields_ = {
  __typename?: 'MFStandard_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.MFStandard" */
export type MfStandard_Avg_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.MFStandard". All fields are combined with a logical 'AND'. */
export type MfStandard_Bool_Exp_ = {
  _and?: InputMaybe<Array<MfStandard_Bool_Exp_>>;
  _not?: InputMaybe<MfStandard_Bool_Exp_>;
  _or?: InputMaybe<Array<MfStandard_Bool_Exp_>>;
  description?: InputMaybe<String_Comparison_Exp_>;
  fakeStandard?: InputMaybe<EsrsStandard_Bool_Exp_>;
  mfCategory?: InputMaybe<MfCategory_Bool_Exp_>;
  mfCategoryRef?: InputMaybe<String_Comparison_Exp_>;
  mfDisclosureRequirementGroups?: InputMaybe<MfDisclosureRequirementGroup_Bool_Exp_>;
  mfDisclosureRequirementGroups_aggregate?: InputMaybe<MfDisclosureRequirementGroup_Aggregate_Bool_Exp_>;
  mfStandardItems?: InputMaybe<MfStandardItem_Bool_Exp_>;
  mfStandardItems_aggregate?: InputMaybe<MfStandardItem_Aggregate_Bool_Exp_>;
  order?: InputMaybe<Int_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.MFStandard" */
export enum MfStandard_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  MfStandardPkey_ = 'MFStandard_pkey'
}

/** input type for incrementing numeric columns in table "esrs.MFStandard" */
export type MfStandard_Inc_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.MFStandard" */
export type MfStandard_Insert_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  fakeStandard?: InputMaybe<EsrsStandard_Obj_Rel_Insert_Input_>;
  mfCategory?: InputMaybe<MfCategory_Obj_Rel_Insert_Input_>;
  mfCategoryRef?: InputMaybe<Scalars['String']['input']>;
  mfDisclosureRequirementGroups?: InputMaybe<MfDisclosureRequirementGroup_Arr_Rel_Insert_Input_>;
  mfStandardItems?: InputMaybe<MfStandardItem_Arr_Rel_Insert_Input_>;
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MfStandard_Max_Fields_ = {
  __typename?: 'MFStandard_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  mfCategoryRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.MFStandard" */
export type MfStandard_Max_Order_By_ = {
  description?: InputMaybe<Order_By_>;
  mfCategoryRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type MfStandard_Min_Fields_ = {
  __typename?: 'MFStandard_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  mfCategoryRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.MFStandard" */
export type MfStandard_Min_Order_By_ = {
  description?: InputMaybe<Order_By_>;
  mfCategoryRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.MFStandard" */
export type MfStandard_Mutation_Response_ = {
  __typename?: 'MFStandard_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MfStandard_>;
};

/** input type for inserting object relation for remote table "esrs.MFStandard" */
export type MfStandard_Obj_Rel_Insert_Input_ = {
  data: MfStandard_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<MfStandard_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.MFStandard" */
export type MfStandard_On_Conflict_ = {
  constraint: MfStandard_Constraint_;
  update_columns?: Array<MfStandard_Update_Column_>;
  where?: InputMaybe<MfStandard_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.MFStandard". */
export type MfStandard_Order_By_ = {
  description?: InputMaybe<Order_By_>;
  fakeStandard?: InputMaybe<EsrsStandard_Order_By_>;
  mfCategory?: InputMaybe<MfCategory_Order_By_>;
  mfCategoryRef?: InputMaybe<Order_By_>;
  mfDisclosureRequirementGroups_aggregate?: InputMaybe<MfDisclosureRequirementGroup_Aggregate_Order_By_>;
  mfStandardItems_aggregate?: InputMaybe<MfStandardItem_Aggregate_Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.MFStandard */
export type MfStandard_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.MFStandard" */
export enum MfStandard_Select_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  MfCategoryRef_ = 'mfCategoryRef',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

/** input type for updating data in table "esrs.MFStandard" */
export type MfStandard_Set_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  mfCategoryRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type MfStandard_Stddev_Fields_ = {
  __typename?: 'MFStandard_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.MFStandard" */
export type MfStandard_Stddev_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type MfStandard_Stddev_Pop_Fields_ = {
  __typename?: 'MFStandard_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.MFStandard" */
export type MfStandard_Stddev_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type MfStandard_Stddev_Samp_Fields_ = {
  __typename?: 'MFStandard_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.MFStandard" */
export type MfStandard_Stddev_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "MFStandard" */
export type MfStandard_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: MfStandard_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type MfStandard_Stream_Cursor_Value_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  mfCategoryRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type MfStandard_Sum_Fields_ = {
  __typename?: 'MFStandard_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.MFStandard" */
export type MfStandard_Sum_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.MFStandard" */
export enum MfStandard_Update_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  MfCategoryRef_ = 'mfCategoryRef',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

export type MfStandard_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MfStandard_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MfStandard_Set_Input_>;
  /** filter the rows which have to be updated */
  where: MfStandard_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type MfStandard_Var_Pop_Fields_ = {
  __typename?: 'MFStandard_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.MFStandard" */
export type MfStandard_Var_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type MfStandard_Var_Samp_Fields_ = {
  __typename?: 'MFStandard_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.MFStandard" */
export type MfStandard_Var_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type MfStandard_Variance_Fields_ = {
  __typename?: 'MFStandard_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.MFStandard" */
export type MfStandard_Variance_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** columns and relationships of "esrs.MaterialStandardOwner" */
export type MaterialStandardOwner_ = {
  __typename?: 'MaterialStandardOwner';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  materialStandard: Esrs_MaterialStandard_;
  materialStandardId: Scalars['uuid']['output'];
  /** An object relationship */
  owner: Users_;
  ownerId: Scalars['uuid']['output'];
  /** An object relationship */
  reportingUnit: Esrs_ReportingUnit_;
  reportingUnitId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "esrs.MaterialStandardOwner" */
export type MaterialStandardOwner_Aggregate_ = {
  __typename?: 'MaterialStandardOwner_aggregate';
  aggregate?: Maybe<MaterialStandardOwner_Aggregate_Fields_>;
  nodes: Array<MaterialStandardOwner_>;
};

export type MaterialStandardOwner_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<MaterialStandardOwner_Aggregate_Bool_Exp_Count_>;
};

export type MaterialStandardOwner_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<MaterialStandardOwner_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MaterialStandardOwner_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.MaterialStandardOwner" */
export type MaterialStandardOwner_Aggregate_Fields_ = {
  __typename?: 'MaterialStandardOwner_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<MaterialStandardOwner_Max_Fields_>;
  min?: Maybe<MaterialStandardOwner_Min_Fields_>;
};


/** aggregate fields of "esrs.MaterialStandardOwner" */
export type MaterialStandardOwner_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<MaterialStandardOwner_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.MaterialStandardOwner" */
export type MaterialStandardOwner_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<MaterialStandardOwner_Max_Order_By_>;
  min?: InputMaybe<MaterialStandardOwner_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.MaterialStandardOwner" */
export type MaterialStandardOwner_Arr_Rel_Insert_Input_ = {
  data: Array<MaterialStandardOwner_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<MaterialStandardOwner_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.MaterialStandardOwner". All fields are combined with a logical 'AND'. */
export type MaterialStandardOwner_Bool_Exp_ = {
  _and?: InputMaybe<Array<MaterialStandardOwner_Bool_Exp_>>;
  _not?: InputMaybe<MaterialStandardOwner_Bool_Exp_>;
  _or?: InputMaybe<Array<MaterialStandardOwner_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  materialStandardId?: InputMaybe<Uuid_Comparison_Exp_>;
  owner?: InputMaybe<Users_Bool_Exp_>;
  ownerId?: InputMaybe<Uuid_Comparison_Exp_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
  reportingUnitId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.MaterialStandardOwner" */
export enum MaterialStandardOwner_Constraint_ {
  /** unique or primary key constraint on columns "materialStandardId", "reportingUnitId" */
  MaterialStandardOwnerMaterialStandardIdReportingUnitIdKey_ = 'MaterialStandardOwner_materialStandardId_reportingUnitId_key',
  /** unique or primary key constraint on columns "id" */
  MaterialStandardOwnerPkey_ = 'MaterialStandardOwner_pkey'
}

/** input type for inserting data into table "esrs.MaterialStandardOwner" */
export type MaterialStandardOwner_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Obj_Rel_Insert_Input_>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  owner?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Obj_Rel_Insert_Input_>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type MaterialStandardOwner_Max_Fields_ = {
  __typename?: 'MaterialStandardOwner_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.MaterialStandardOwner" */
export type MaterialStandardOwner_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialStandardId?: InputMaybe<Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type MaterialStandardOwner_Min_Fields_ = {
  __typename?: 'MaterialStandardOwner_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.MaterialStandardOwner" */
export type MaterialStandardOwner_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialStandardId?: InputMaybe<Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.MaterialStandardOwner" */
export type MaterialStandardOwner_Mutation_Response_ = {
  __typename?: 'MaterialStandardOwner_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MaterialStandardOwner_>;
};

/** on_conflict condition type for table "esrs.MaterialStandardOwner" */
export type MaterialStandardOwner_On_Conflict_ = {
  constraint: MaterialStandardOwner_Constraint_;
  update_columns?: Array<MaterialStandardOwner_Update_Column_>;
  where?: InputMaybe<MaterialStandardOwner_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.MaterialStandardOwner". */
export type MaterialStandardOwner_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Order_By_>;
  materialStandardId?: InputMaybe<Order_By_>;
  owner?: InputMaybe<Users_Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.MaterialStandardOwner */
export type MaterialStandardOwner_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.MaterialStandardOwner" */
export enum MaterialStandardOwner_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  MaterialStandardId_ = 'materialStandardId',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  ReportingUnitId_ = 'reportingUnitId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "esrs.MaterialStandardOwner" */
export type MaterialStandardOwner_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "MaterialStandardOwner" */
export type MaterialStandardOwner_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: MaterialStandardOwner_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type MaterialStandardOwner_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.MaterialStandardOwner" */
export enum MaterialStandardOwner_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  MaterialStandardId_ = 'materialStandardId',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  ReportingUnitId_ = 'reportingUnitId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type MaterialStandardOwner_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MaterialStandardOwner_Set_Input_>;
  /** filter the rows which have to be updated */
  where: MaterialStandardOwner_Bool_Exp_;
};

/** (admin panel): Some metrics are related to each others, this is a relationship table  */
export type MetricDependency_ = {
  __typename?: 'MetricDependency';
  /** An object relationship */
  childMetric?: Maybe<EsrsMetric_>;
  childMetricRef: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  /** An object relationship */
  parentMetric: EsrsMetric_;
  parentMetricRef: Scalars['String']['output'];
};

/** aggregated selection of "esrs.MetricDependency" */
export type MetricDependency_Aggregate_ = {
  __typename?: 'MetricDependency_aggregate';
  aggregate?: Maybe<MetricDependency_Aggregate_Fields_>;
  nodes: Array<MetricDependency_>;
};

export type MetricDependency_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<MetricDependency_Aggregate_Bool_Exp_Count_>;
};

export type MetricDependency_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<MetricDependency_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MetricDependency_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.MetricDependency" */
export type MetricDependency_Aggregate_Fields_ = {
  __typename?: 'MetricDependency_aggregate_fields';
  avg?: Maybe<MetricDependency_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<MetricDependency_Max_Fields_>;
  min?: Maybe<MetricDependency_Min_Fields_>;
  stddev?: Maybe<MetricDependency_Stddev_Fields_>;
  stddev_pop?: Maybe<MetricDependency_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<MetricDependency_Stddev_Samp_Fields_>;
  sum?: Maybe<MetricDependency_Sum_Fields_>;
  var_pop?: Maybe<MetricDependency_Var_Pop_Fields_>;
  var_samp?: Maybe<MetricDependency_Var_Samp_Fields_>;
  variance?: Maybe<MetricDependency_Variance_Fields_>;
};


/** aggregate fields of "esrs.MetricDependency" */
export type MetricDependency_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<MetricDependency_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.MetricDependency" */
export type MetricDependency_Aggregate_Order_By_ = {
  avg?: InputMaybe<MetricDependency_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<MetricDependency_Max_Order_By_>;
  min?: InputMaybe<MetricDependency_Min_Order_By_>;
  stddev?: InputMaybe<MetricDependency_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<MetricDependency_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<MetricDependency_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<MetricDependency_Sum_Order_By_>;
  var_pop?: InputMaybe<MetricDependency_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<MetricDependency_Var_Samp_Order_By_>;
  variance?: InputMaybe<MetricDependency_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.MetricDependency" */
export type MetricDependency_Arr_Rel_Insert_Input_ = {
  data: Array<MetricDependency_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<MetricDependency_On_Conflict_>;
};

/** aggregate avg on columns */
export type MetricDependency_Avg_Fields_ = {
  __typename?: 'MetricDependency_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.MetricDependency" */
export type MetricDependency_Avg_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.MetricDependency". All fields are combined with a logical 'AND'. */
export type MetricDependency_Bool_Exp_ = {
  _and?: InputMaybe<Array<MetricDependency_Bool_Exp_>>;
  _not?: InputMaybe<MetricDependency_Bool_Exp_>;
  _or?: InputMaybe<Array<MetricDependency_Bool_Exp_>>;
  childMetric?: InputMaybe<EsrsMetric_Bool_Exp_>;
  childMetricRef?: InputMaybe<String_Comparison_Exp_>;
  order?: InputMaybe<Int_Comparison_Exp_>;
  parentMetric?: InputMaybe<EsrsMetric_Bool_Exp_>;
  parentMetricRef?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.MetricDependency" */
export enum MetricDependency_Constraint_ {
  /** unique or primary key constraint on columns "childMetricRef", "parentMetricRef" */
  MetricDependencyPkey_ = 'MetricDependency_pkey'
}

/** input type for incrementing numeric columns in table "esrs.MetricDependency" */
export type MetricDependency_Inc_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.MetricDependency" */
export type MetricDependency_Insert_Input_ = {
  childMetric?: InputMaybe<EsrsMetric_Obj_Rel_Insert_Input_>;
  childMetricRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentMetric?: InputMaybe<EsrsMetric_Obj_Rel_Insert_Input_>;
  parentMetricRef?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MetricDependency_Max_Fields_ = {
  __typename?: 'MetricDependency_max_fields';
  childMetricRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentMetricRef?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.MetricDependency" */
export type MetricDependency_Max_Order_By_ = {
  childMetricRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  parentMetricRef?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type MetricDependency_Min_Fields_ = {
  __typename?: 'MetricDependency_min_fields';
  childMetricRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  parentMetricRef?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.MetricDependency" */
export type MetricDependency_Min_Order_By_ = {
  childMetricRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  parentMetricRef?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.MetricDependency" */
export type MetricDependency_Mutation_Response_ = {
  __typename?: 'MetricDependency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MetricDependency_>;
};

/** on_conflict condition type for table "esrs.MetricDependency" */
export type MetricDependency_On_Conflict_ = {
  constraint: MetricDependency_Constraint_;
  update_columns?: Array<MetricDependency_Update_Column_>;
  where?: InputMaybe<MetricDependency_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.MetricDependency". */
export type MetricDependency_Order_By_ = {
  childMetric?: InputMaybe<EsrsMetric_Order_By_>;
  childMetricRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  parentMetric?: InputMaybe<EsrsMetric_Order_By_>;
  parentMetricRef?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.MetricDependency */
export type MetricDependency_Pk_Columns_Input_ = {
  childMetricRef: Scalars['String']['input'];
  parentMetricRef: Scalars['String']['input'];
};

/** select columns of table "esrs.MetricDependency" */
export enum MetricDependency_Select_Column_ {
  /** column name */
  ChildMetricRef_ = 'childMetricRef',
  /** column name */
  Order_ = 'order',
  /** column name */
  ParentMetricRef_ = 'parentMetricRef'
}

/** input type for updating data in table "esrs.MetricDependency" */
export type MetricDependency_Set_Input_ = {
  childMetricRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentMetricRef?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type MetricDependency_Stddev_Fields_ = {
  __typename?: 'MetricDependency_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.MetricDependency" */
export type MetricDependency_Stddev_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type MetricDependency_Stddev_Pop_Fields_ = {
  __typename?: 'MetricDependency_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.MetricDependency" */
export type MetricDependency_Stddev_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type MetricDependency_Stddev_Samp_Fields_ = {
  __typename?: 'MetricDependency_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.MetricDependency" */
export type MetricDependency_Stddev_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "MetricDependency" */
export type MetricDependency_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: MetricDependency_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type MetricDependency_Stream_Cursor_Value_Input_ = {
  childMetricRef?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  parentMetricRef?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type MetricDependency_Sum_Fields_ = {
  __typename?: 'MetricDependency_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.MetricDependency" */
export type MetricDependency_Sum_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.MetricDependency" */
export enum MetricDependency_Update_Column_ {
  /** column name */
  ChildMetricRef_ = 'childMetricRef',
  /** column name */
  Order_ = 'order',
  /** column name */
  ParentMetricRef_ = 'parentMetricRef'
}

export type MetricDependency_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MetricDependency_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MetricDependency_Set_Input_>;
  /** filter the rows which have to be updated */
  where: MetricDependency_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type MetricDependency_Var_Pop_Fields_ = {
  __typename?: 'MetricDependency_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.MetricDependency" */
export type MetricDependency_Var_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type MetricDependency_Var_Samp_Fields_ = {
  __typename?: 'MetricDependency_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.MetricDependency" */
export type MetricDependency_Var_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type MetricDependency_Variance_Fields_ = {
  __typename?: 'MetricDependency_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.MetricDependency" */
export type MetricDependency_Variance_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** columns and relationships of "esrs.MetricTag" */
export type MetricTag_ = {
  __typename?: 'MetricTag';
  isOptional: Scalars['Boolean']['output'];
  /** An object relationship */
  metric: EsrsMetric_;
  metricRef: Scalars['String']['output'];
  /** An object relationship */
  tagType: TagType_;
  type: Scalars['String']['output'];
};

/** aggregated selection of "esrs.MetricTag" */
export type MetricTag_Aggregate_ = {
  __typename?: 'MetricTag_aggregate';
  aggregate?: Maybe<MetricTag_Aggregate_Fields_>;
  nodes: Array<MetricTag_>;
};

export type MetricTag_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<MetricTag_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<MetricTag_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<MetricTag_Aggregate_Bool_Exp_Count_>;
};

export type MetricTag_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: MetricTag_Select_Column_MetricTag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MetricTag_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type MetricTag_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: MetricTag_Select_Column_MetricTag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MetricTag_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type MetricTag_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<MetricTag_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<MetricTag_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.MetricTag" */
export type MetricTag_Aggregate_Fields_ = {
  __typename?: 'MetricTag_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<MetricTag_Max_Fields_>;
  min?: Maybe<MetricTag_Min_Fields_>;
};


/** aggregate fields of "esrs.MetricTag" */
export type MetricTag_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<MetricTag_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.MetricTag" */
export type MetricTag_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<MetricTag_Max_Order_By_>;
  min?: InputMaybe<MetricTag_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.MetricTag" */
export type MetricTag_Arr_Rel_Insert_Input_ = {
  data: Array<MetricTag_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<MetricTag_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.MetricTag". All fields are combined with a logical 'AND'. */
export type MetricTag_Bool_Exp_ = {
  _and?: InputMaybe<Array<MetricTag_Bool_Exp_>>;
  _not?: InputMaybe<MetricTag_Bool_Exp_>;
  _or?: InputMaybe<Array<MetricTag_Bool_Exp_>>;
  isOptional?: InputMaybe<Boolean_Comparison_Exp_>;
  metric?: InputMaybe<EsrsMetric_Bool_Exp_>;
  metricRef?: InputMaybe<String_Comparison_Exp_>;
  tagType?: InputMaybe<TagType_Bool_Exp_>;
  type?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.MetricTag" */
export enum MetricTag_Constraint_ {
  /** unique or primary key constraint on columns "type", "metricRef" */
  MetricTagPkey_ = 'MetricTag_pkey'
}

/** input type for inserting data into table "esrs.MetricTag" */
export type MetricTag_Insert_Input_ = {
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  metric?: InputMaybe<EsrsMetric_Obj_Rel_Insert_Input_>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  tagType?: InputMaybe<TagType_Obj_Rel_Insert_Input_>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type MetricTag_Max_Fields_ = {
  __typename?: 'MetricTag_max_fields';
  metricRef?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.MetricTag" */
export type MetricTag_Max_Order_By_ = {
  metricRef?: InputMaybe<Order_By_>;
  type?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type MetricTag_Min_Fields_ = {
  __typename?: 'MetricTag_min_fields';
  metricRef?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.MetricTag" */
export type MetricTag_Min_Order_By_ = {
  metricRef?: InputMaybe<Order_By_>;
  type?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.MetricTag" */
export type MetricTag_Mutation_Response_ = {
  __typename?: 'MetricTag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<MetricTag_>;
};

/** on_conflict condition type for table "esrs.MetricTag" */
export type MetricTag_On_Conflict_ = {
  constraint: MetricTag_Constraint_;
  update_columns?: Array<MetricTag_Update_Column_>;
  where?: InputMaybe<MetricTag_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.MetricTag". */
export type MetricTag_Order_By_ = {
  isOptional?: InputMaybe<Order_By_>;
  metric?: InputMaybe<EsrsMetric_Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
  tagType?: InputMaybe<TagType_Order_By_>;
  type?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.MetricTag */
export type MetricTag_Pk_Columns_Input_ = {
  metricRef: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

/** select columns of table "esrs.MetricTag" */
export enum MetricTag_Select_Column_ {
  /** column name */
  IsOptional_ = 'isOptional',
  /** column name */
  MetricRef_ = 'metricRef',
  /** column name */
  Type_ = 'type'
}

/** select "MetricTag_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.MetricTag" */
export enum MetricTag_Select_Column_MetricTag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsOptional_ = 'isOptional'
}

/** select "MetricTag_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.MetricTag" */
export enum MetricTag_Select_Column_MetricTag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsOptional_ = 'isOptional'
}

/** input type for updating data in table "esrs.MetricTag" */
export type MetricTag_Set_Input_ = {
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "MetricTag" */
export type MetricTag_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: MetricTag_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type MetricTag_Stream_Cursor_Value_Input_ = {
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.MetricTag" */
export enum MetricTag_Update_Column_ {
  /** column name */
  IsOptional_ = 'isOptional',
  /** column name */
  MetricRef_ = 'metricRef',
  /** column name */
  Type_ = 'type'
}

export type MetricTag_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MetricTag_Set_Input_>;
  /** filter the rows which have to be updated */
  where: MetricTag_Bool_Exp_;
};

/** columns and relationships of "NonMaterialFinancials" */
export type NonMaterialFinancials_ = {
  __typename?: 'NonMaterialFinancials';
  adaptationCapex?: Maybe<Scalars['float8']['output']>;
  adaptationOpex?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  attachmentBox?: Maybe<AttachmentBox_>;
  cAssessmentId?: Maybe<Scalars['uuid']['output']>;
  capex?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  companyAssessment?: Maybe<CompanyAssessment_>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  isEstimate?: Maybe<Scalars['Boolean']['output']>;
  isMaterial?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  noteHistory?: Maybe<NoteHistory_>;
  opex?: Maybe<Scalars['float8']['output']>;
  reportId?: Maybe<Scalars['uuid']['output']>;
  revenue?: Maybe<Scalars['float8']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "NonMaterialFinancials" */
export type NonMaterialFinancials_Aggregate_ = {
  __typename?: 'NonMaterialFinancials_aggregate';
  aggregate?: Maybe<NonMaterialFinancials_Aggregate_Fields_>;
  nodes: Array<NonMaterialFinancials_>;
};

/** aggregate fields of "NonMaterialFinancials" */
export type NonMaterialFinancials_Aggregate_Fields_ = {
  __typename?: 'NonMaterialFinancials_aggregate_fields';
  avg?: Maybe<NonMaterialFinancials_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<NonMaterialFinancials_Max_Fields_>;
  min?: Maybe<NonMaterialFinancials_Min_Fields_>;
  stddev?: Maybe<NonMaterialFinancials_Stddev_Fields_>;
  stddev_pop?: Maybe<NonMaterialFinancials_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<NonMaterialFinancials_Stddev_Samp_Fields_>;
  sum?: Maybe<NonMaterialFinancials_Sum_Fields_>;
  var_pop?: Maybe<NonMaterialFinancials_Var_Pop_Fields_>;
  var_samp?: Maybe<NonMaterialFinancials_Var_Samp_Fields_>;
  variance?: Maybe<NonMaterialFinancials_Variance_Fields_>;
};


/** aggregate fields of "NonMaterialFinancials" */
export type NonMaterialFinancials_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<NonMaterialFinancials_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type NonMaterialFinancials_Avg_Fields_ = {
  __typename?: 'NonMaterialFinancials_avg_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "NonMaterialFinancials". All fields are combined with a logical 'AND'. */
export type NonMaterialFinancials_Bool_Exp_ = {
  _and?: InputMaybe<Array<NonMaterialFinancials_Bool_Exp_>>;
  _not?: InputMaybe<NonMaterialFinancials_Bool_Exp_>;
  _or?: InputMaybe<Array<NonMaterialFinancials_Bool_Exp_>>;
  adaptationCapex?: InputMaybe<Float8_Comparison_Exp_>;
  adaptationOpex?: InputMaybe<Float8_Comparison_Exp_>;
  attachmentBox?: InputMaybe<AttachmentBox_Bool_Exp_>;
  cAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  capex?: InputMaybe<Float8_Comparison_Exp_>;
  companyAssessment?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isEstimate?: InputMaybe<Boolean_Comparison_Exp_>;
  isMaterial?: InputMaybe<Boolean_Comparison_Exp_>;
  noteHistory?: InputMaybe<NoteHistory_Bool_Exp_>;
  opex?: InputMaybe<Float8_Comparison_Exp_>;
  reportId?: InputMaybe<Uuid_Comparison_Exp_>;
  revenue?: InputMaybe<Float8_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** input type for incrementing numeric columns in table "NonMaterialFinancials" */
export type NonMaterialFinancials_Inc_Input_ = {
  adaptationCapex?: InputMaybe<Scalars['float8']['input']>;
  adaptationOpex?: InputMaybe<Scalars['float8']['input']>;
  capex?: InputMaybe<Scalars['float8']['input']>;
  opex?: InputMaybe<Scalars['float8']['input']>;
  revenue?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "NonMaterialFinancials" */
export type NonMaterialFinancials_Insert_Input_ = {
  adaptationCapex?: InputMaybe<Scalars['float8']['input']>;
  adaptationOpex?: InputMaybe<Scalars['float8']['input']>;
  attachmentBox?: InputMaybe<AttachmentBox_Obj_Rel_Insert_Input_>;
  cAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  capex?: InputMaybe<Scalars['float8']['input']>;
  companyAssessment?: InputMaybe<CompanyAssessment_Obj_Rel_Insert_Input_>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  noteHistory?: InputMaybe<NoteHistory_Obj_Rel_Insert_Input_>;
  opex?: InputMaybe<Scalars['float8']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  revenue?: InputMaybe<Scalars['float8']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type NonMaterialFinancials_Max_Fields_ = {
  __typename?: 'NonMaterialFinancials_max_fields';
  adaptationCapex?: Maybe<Scalars['float8']['output']>;
  adaptationOpex?: Maybe<Scalars['float8']['output']>;
  cAssessmentId?: Maybe<Scalars['uuid']['output']>;
  capex?: Maybe<Scalars['float8']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  opex?: Maybe<Scalars['float8']['output']>;
  reportId?: Maybe<Scalars['uuid']['output']>;
  revenue?: Maybe<Scalars['float8']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type NonMaterialFinancials_Min_Fields_ = {
  __typename?: 'NonMaterialFinancials_min_fields';
  adaptationCapex?: Maybe<Scalars['float8']['output']>;
  adaptationOpex?: Maybe<Scalars['float8']['output']>;
  cAssessmentId?: Maybe<Scalars['uuid']['output']>;
  capex?: Maybe<Scalars['float8']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  opex?: Maybe<Scalars['float8']['output']>;
  reportId?: Maybe<Scalars['uuid']['output']>;
  revenue?: Maybe<Scalars['float8']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "NonMaterialFinancials" */
export type NonMaterialFinancials_Mutation_Response_ = {
  __typename?: 'NonMaterialFinancials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<NonMaterialFinancials_>;
};

/** input type for inserting object relation for remote table "NonMaterialFinancials" */
export type NonMaterialFinancials_Obj_Rel_Insert_Input_ = {
  data: NonMaterialFinancials_Insert_Input_;
};

/** Ordering options when selecting data from "NonMaterialFinancials". */
export type NonMaterialFinancials_Order_By_ = {
  adaptationCapex?: InputMaybe<Order_By_>;
  adaptationOpex?: InputMaybe<Order_By_>;
  attachmentBox?: InputMaybe<AttachmentBox_Order_By_>;
  cAssessmentId?: InputMaybe<Order_By_>;
  capex?: InputMaybe<Order_By_>;
  companyAssessment?: InputMaybe<CompanyAssessment_Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isEstimate?: InputMaybe<Order_By_>;
  isMaterial?: InputMaybe<Order_By_>;
  noteHistory?: InputMaybe<NoteHistory_Order_By_>;
  opex?: InputMaybe<Order_By_>;
  reportId?: InputMaybe<Order_By_>;
  revenue?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** select columns of table "NonMaterialFinancials" */
export enum NonMaterialFinancials_Select_Column_ {
  /** column name */
  AdaptationCapex_ = 'adaptationCapex',
  /** column name */
  AdaptationOpex_ = 'adaptationOpex',
  /** column name */
  CAssessmentId_ = 'cAssessmentId',
  /** column name */
  Capex_ = 'capex',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsEstimate_ = 'isEstimate',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  Opex_ = 'opex',
  /** column name */
  ReportId_ = 'reportId',
  /** column name */
  Revenue_ = 'revenue',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "NonMaterialFinancials" */
export type NonMaterialFinancials_Set_Input_ = {
  adaptationCapex?: InputMaybe<Scalars['float8']['input']>;
  adaptationOpex?: InputMaybe<Scalars['float8']['input']>;
  cAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  capex?: InputMaybe<Scalars['float8']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  opex?: InputMaybe<Scalars['float8']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  revenue?: InputMaybe<Scalars['float8']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type NonMaterialFinancials_Stddev_Fields_ = {
  __typename?: 'NonMaterialFinancials_stddev_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type NonMaterialFinancials_Stddev_Pop_Fields_ = {
  __typename?: 'NonMaterialFinancials_stddev_pop_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type NonMaterialFinancials_Stddev_Samp_Fields_ = {
  __typename?: 'NonMaterialFinancials_stddev_samp_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "NonMaterialFinancials" */
export type NonMaterialFinancials_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: NonMaterialFinancials_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type NonMaterialFinancials_Stream_Cursor_Value_Input_ = {
  adaptationCapex?: InputMaybe<Scalars['float8']['input']>;
  adaptationOpex?: InputMaybe<Scalars['float8']['input']>;
  cAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  capex?: InputMaybe<Scalars['float8']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  opex?: InputMaybe<Scalars['float8']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  revenue?: InputMaybe<Scalars['float8']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type NonMaterialFinancials_Sum_Fields_ = {
  __typename?: 'NonMaterialFinancials_sum_fields';
  adaptationCapex?: Maybe<Scalars['float8']['output']>;
  adaptationOpex?: Maybe<Scalars['float8']['output']>;
  capex?: Maybe<Scalars['float8']['output']>;
  opex?: Maybe<Scalars['float8']['output']>;
  revenue?: Maybe<Scalars['float8']['output']>;
};

export type NonMaterialFinancials_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NonMaterialFinancials_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NonMaterialFinancials_Set_Input_>;
  /** filter the rows which have to be updated */
  where: NonMaterialFinancials_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type NonMaterialFinancials_Var_Pop_Fields_ = {
  __typename?: 'NonMaterialFinancials_var_pop_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type NonMaterialFinancials_Var_Samp_Fields_ = {
  __typename?: 'NonMaterialFinancials_var_samp_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type NonMaterialFinancials_Variance_Fields_ = {
  __typename?: 'NonMaterialFinancials_variance_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "Note" */
export type Note_ = {
  __typename?: 'Note';
  /** An object relationship */
  author: Users_;
  authorId: Scalars['uuid']['output'];
  body?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isAIGenerated: Scalars['Boolean']['output'];
  /** An object relationship */
  noteHistory: NoteHistory_;
  noteHistoryId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** columns and relationships of "NoteHistory" */
export type NoteHistory_ = {
  __typename?: 'NoteHistory';
  /** An object relationship */
  action?: Maybe<Esrs_Actions_>;
  actionId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  activityReport?: Maybe<ActivityReport_>;
  activityReportId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  answer?: Maybe<Answer_>;
  answerId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  financials?: Maybe<Financials_>;
  financialsId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  materialStandard?: Maybe<Esrs_MaterialStandard_>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  metricAnswer?: Maybe<Esrs_Answer_>;
  metricAnswerId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  nonMaterialFinancials?: Maybe<NonMaterialFinancials_>;
  /** An array relationship */
  notes: Array<Note_>;
  /** An aggregate relationship */
  notes_aggregate: Note_Aggregate_;
  /** An object relationship */
  paiAnswer?: Maybe<PaiAnswers_>;
  paiAnswerId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  policy?: Maybe<Esrs_Policy_>;
  policyId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  target?: Maybe<Esrs_Target_>;
  targetId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  totalComparisonFinancials?: Maybe<TotalComparisonFinancials_>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "NoteHistory" */
export type NoteHistoryNotesArgs_ = {
  distinct_on?: InputMaybe<Array<Note_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By_>>;
  where?: InputMaybe<Note_Bool_Exp_>;
};


/** columns and relationships of "NoteHistory" */
export type NoteHistoryNotes_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Note_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By_>>;
  where?: InputMaybe<Note_Bool_Exp_>;
};

/** aggregated selection of "NoteHistory" */
export type NoteHistory_Aggregate_ = {
  __typename?: 'NoteHistory_aggregate';
  aggregate?: Maybe<NoteHistory_Aggregate_Fields_>;
  nodes: Array<NoteHistory_>;
};

/** aggregate fields of "NoteHistory" */
export type NoteHistory_Aggregate_Fields_ = {
  __typename?: 'NoteHistory_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<NoteHistory_Max_Fields_>;
  min?: Maybe<NoteHistory_Min_Fields_>;
};


/** aggregate fields of "NoteHistory" */
export type NoteHistory_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<NoteHistory_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "NoteHistory". All fields are combined with a logical 'AND'. */
export type NoteHistory_Bool_Exp_ = {
  _and?: InputMaybe<Array<NoteHistory_Bool_Exp_>>;
  _not?: InputMaybe<NoteHistory_Bool_Exp_>;
  _or?: InputMaybe<Array<NoteHistory_Bool_Exp_>>;
  action?: InputMaybe<Esrs_Actions_Bool_Exp_>;
  actionId?: InputMaybe<Uuid_Comparison_Exp_>;
  activityReport?: InputMaybe<ActivityReport_Bool_Exp_>;
  activityReportId?: InputMaybe<Uuid_Comparison_Exp_>;
  answer?: InputMaybe<Answer_Bool_Exp_>;
  answerId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  financials?: InputMaybe<Financials_Bool_Exp_>;
  financialsId?: InputMaybe<Uuid_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  materialStandardId?: InputMaybe<Uuid_Comparison_Exp_>;
  metricAnswer?: InputMaybe<Esrs_Answer_Bool_Exp_>;
  metricAnswerId?: InputMaybe<Uuid_Comparison_Exp_>;
  nonMaterialFinancials?: InputMaybe<NonMaterialFinancials_Bool_Exp_>;
  notes?: InputMaybe<Note_Bool_Exp_>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Bool_Exp_>;
  paiAnswer?: InputMaybe<PaiAnswers_Bool_Exp_>;
  paiAnswerId?: InputMaybe<Uuid_Comparison_Exp_>;
  policy?: InputMaybe<Esrs_Policy_Bool_Exp_>;
  policyId?: InputMaybe<Uuid_Comparison_Exp_>;
  target?: InputMaybe<Esrs_Target_Bool_Exp_>;
  targetId?: InputMaybe<Uuid_Comparison_Exp_>;
  totalComparisonFinancials?: InputMaybe<TotalComparisonFinancials_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "NoteHistory" */
export enum NoteHistory_Constraint_ {
  /** unique or primary key constraint on columns "actionId" */
  NoteHistoryActionIdKey_ = 'NoteHistory_actionId_key',
  /** unique or primary key constraint on columns "activityReportId" */
  NoteHistoryActivityReportIdKey_ = 'NoteHistory_activityReportId_key',
  /** unique or primary key constraint on columns "answerId" */
  NoteHistoryAnswerIdKey_ = 'NoteHistory_answerId_key',
  /** unique or primary key constraint on columns "financialsId" */
  NoteHistoryFinancialsIdKey_ = 'NoteHistory_financialsId_key',
  /** unique or primary key constraint on columns "id", "answerId", "activityReportId" */
  NoteHistoryIdActivityReportIdAnswerIdKey_ = 'NoteHistory_id_activityReportId_answerId_key',
  /** unique or primary key constraint on columns "materialStandardId" */
  NoteHistoryMaterialityAssessmentIdKey_ = 'NoteHistory_materialityAssessmentId_key',
  /** unique or primary key constraint on columns "metricAnswerId" */
  NoteHistoryMetricAnswerIdKey_ = 'NoteHistory_metricAnswerId_key',
  /** unique or primary key constraint on columns "paiAnswerId" */
  NoteHistoryPaiAnswerIdKey_ = 'NoteHistory_paiAnswerId_key',
  /** unique or primary key constraint on columns "id" */
  NoteHistoryPkey_ = 'NoteHistory_pkey',
  /** unique or primary key constraint on columns "policyId" */
  NoteHistoryPolicyIdKey_ = 'NoteHistory_policyId_key',
  /** unique or primary key constraint on columns "targetId" */
  NoteHistoryTargetIdKey_ = 'NoteHistory_targetId_key'
}

/** input type for inserting data into table "NoteHistory" */
export type NoteHistory_Insert_Input_ = {
  action?: InputMaybe<Esrs_Actions_Obj_Rel_Insert_Input_>;
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  activityReport?: InputMaybe<ActivityReport_Obj_Rel_Insert_Input_>;
  activityReportId?: InputMaybe<Scalars['uuid']['input']>;
  answer?: InputMaybe<Answer_Obj_Rel_Insert_Input_>;
  answerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  financials?: InputMaybe<Financials_Obj_Rel_Insert_Input_>;
  financialsId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Obj_Rel_Insert_Input_>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  metricAnswer?: InputMaybe<Esrs_Answer_Obj_Rel_Insert_Input_>;
  metricAnswerId?: InputMaybe<Scalars['uuid']['input']>;
  nonMaterialFinancials?: InputMaybe<NonMaterialFinancials_Obj_Rel_Insert_Input_>;
  notes?: InputMaybe<Note_Arr_Rel_Insert_Input_>;
  paiAnswer?: InputMaybe<PaiAnswers_Obj_Rel_Insert_Input_>;
  paiAnswerId?: InputMaybe<Scalars['uuid']['input']>;
  policy?: InputMaybe<Esrs_Policy_Obj_Rel_Insert_Input_>;
  policyId?: InputMaybe<Scalars['uuid']['input']>;
  target?: InputMaybe<Esrs_Target_Obj_Rel_Insert_Input_>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  totalComparisonFinancials?: InputMaybe<TotalComparisonFinancials_Obj_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type NoteHistory_Max_Fields_ = {
  __typename?: 'NoteHistory_max_fields';
  actionId?: Maybe<Scalars['uuid']['output']>;
  activityReportId?: Maybe<Scalars['uuid']['output']>;
  answerId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  financialsId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  metricAnswerId?: Maybe<Scalars['uuid']['output']>;
  paiAnswerId?: Maybe<Scalars['uuid']['output']>;
  policyId?: Maybe<Scalars['uuid']['output']>;
  targetId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type NoteHistory_Min_Fields_ = {
  __typename?: 'NoteHistory_min_fields';
  actionId?: Maybe<Scalars['uuid']['output']>;
  activityReportId?: Maybe<Scalars['uuid']['output']>;
  answerId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  financialsId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  metricAnswerId?: Maybe<Scalars['uuid']['output']>;
  paiAnswerId?: Maybe<Scalars['uuid']['output']>;
  policyId?: Maybe<Scalars['uuid']['output']>;
  targetId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "NoteHistory" */
export type NoteHistory_Mutation_Response_ = {
  __typename?: 'NoteHistory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<NoteHistory_>;
};

/** input type for inserting object relation for remote table "NoteHistory" */
export type NoteHistory_Obj_Rel_Insert_Input_ = {
  data: NoteHistory_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<NoteHistory_On_Conflict_>;
};

/** on_conflict condition type for table "NoteHistory" */
export type NoteHistory_On_Conflict_ = {
  constraint: NoteHistory_Constraint_;
  update_columns?: Array<NoteHistory_Update_Column_>;
  where?: InputMaybe<NoteHistory_Bool_Exp_>;
};

/** Ordering options when selecting data from "NoteHistory". */
export type NoteHistory_Order_By_ = {
  action?: InputMaybe<Esrs_Actions_Order_By_>;
  actionId?: InputMaybe<Order_By_>;
  activityReport?: InputMaybe<ActivityReport_Order_By_>;
  activityReportId?: InputMaybe<Order_By_>;
  answer?: InputMaybe<Answer_Order_By_>;
  answerId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  financials?: InputMaybe<Financials_Order_By_>;
  financialsId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Order_By_>;
  materialStandardId?: InputMaybe<Order_By_>;
  metricAnswer?: InputMaybe<Esrs_Answer_Order_By_>;
  metricAnswerId?: InputMaybe<Order_By_>;
  nonMaterialFinancials?: InputMaybe<NonMaterialFinancials_Order_By_>;
  notes_aggregate?: InputMaybe<Note_Aggregate_Order_By_>;
  paiAnswer?: InputMaybe<PaiAnswers_Order_By_>;
  paiAnswerId?: InputMaybe<Order_By_>;
  policy?: InputMaybe<Esrs_Policy_Order_By_>;
  policyId?: InputMaybe<Order_By_>;
  target?: InputMaybe<Esrs_Target_Order_By_>;
  targetId?: InputMaybe<Order_By_>;
  totalComparisonFinancials?: InputMaybe<TotalComparisonFinancials_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: NoteHistory */
export type NoteHistory_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "NoteHistory" */
export enum NoteHistory_Select_Column_ {
  /** column name */
  ActionId_ = 'actionId',
  /** column name */
  ActivityReportId_ = 'activityReportId',
  /** column name */
  AnswerId_ = 'answerId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  FinancialsId_ = 'financialsId',
  /** column name */
  Id_ = 'id',
  /** column name */
  MaterialStandardId_ = 'materialStandardId',
  /** column name */
  MetricAnswerId_ = 'metricAnswerId',
  /** column name */
  PaiAnswerId_ = 'paiAnswerId',
  /** column name */
  PolicyId_ = 'policyId',
  /** column name */
  TargetId_ = 'targetId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "NoteHistory" */
export type NoteHistory_Set_Input_ = {
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  activityReportId?: InputMaybe<Scalars['uuid']['input']>;
  answerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  financialsId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  metricAnswerId?: InputMaybe<Scalars['uuid']['input']>;
  paiAnswerId?: InputMaybe<Scalars['uuid']['input']>;
  policyId?: InputMaybe<Scalars['uuid']['input']>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "NoteHistory" */
export type NoteHistory_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: NoteHistory_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type NoteHistory_Stream_Cursor_Value_Input_ = {
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  activityReportId?: InputMaybe<Scalars['uuid']['input']>;
  answerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  financialsId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  metricAnswerId?: InputMaybe<Scalars['uuid']['input']>;
  paiAnswerId?: InputMaybe<Scalars['uuid']['input']>;
  policyId?: InputMaybe<Scalars['uuid']['input']>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "NoteHistory" */
export enum NoteHistory_Update_Column_ {
  /** column name */
  ActionId_ = 'actionId',
  /** column name */
  ActivityReportId_ = 'activityReportId',
  /** column name */
  AnswerId_ = 'answerId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  FinancialsId_ = 'financialsId',
  /** column name */
  Id_ = 'id',
  /** column name */
  MaterialStandardId_ = 'materialStandardId',
  /** column name */
  MetricAnswerId_ = 'metricAnswerId',
  /** column name */
  PaiAnswerId_ = 'paiAnswerId',
  /** column name */
  PolicyId_ = 'policyId',
  /** column name */
  TargetId_ = 'targetId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type NoteHistory_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NoteHistory_Set_Input_>;
  /** filter the rows which have to be updated */
  where: NoteHistory_Bool_Exp_;
};

/** aggregated selection of "Note" */
export type Note_Aggregate_ = {
  __typename?: 'Note_aggregate';
  aggregate?: Maybe<Note_Aggregate_Fields_>;
  nodes: Array<Note_>;
};

export type Note_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Note_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Note_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Note_Aggregate_Bool_Exp_Count_>;
};

export type Note_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Note_Select_Column_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Note_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Note_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Note_Select_Column_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Note_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Note_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Note_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Note_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "Note" */
export type Note_Aggregate_Fields_ = {
  __typename?: 'Note_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Note_Max_Fields_>;
  min?: Maybe<Note_Min_Fields_>;
};


/** aggregate fields of "Note" */
export type Note_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Note_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Note" */
export type Note_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Note_Max_Order_By_>;
  min?: InputMaybe<Note_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "Note" */
export type Note_Arr_Rel_Insert_Input_ = {
  data: Array<Note_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Note_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "Note". All fields are combined with a logical 'AND'. */
export type Note_Bool_Exp_ = {
  _and?: InputMaybe<Array<Note_Bool_Exp_>>;
  _not?: InputMaybe<Note_Bool_Exp_>;
  _or?: InputMaybe<Array<Note_Bool_Exp_>>;
  author?: InputMaybe<Users_Bool_Exp_>;
  authorId?: InputMaybe<Uuid_Comparison_Exp_>;
  body?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isAIGenerated?: InputMaybe<Boolean_Comparison_Exp_>;
  noteHistory?: InputMaybe<NoteHistory_Bool_Exp_>;
  noteHistoryId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Note" */
export enum Note_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  NotePkey_ = 'Note_pkey'
}

/** input type for inserting data into table "Note" */
export type Note_Insert_Input_ = {
  author?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAIGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  noteHistory?: InputMaybe<NoteHistory_Obj_Rel_Insert_Input_>;
  noteHistoryId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Note_Max_Fields_ = {
  __typename?: 'Note_max_fields';
  authorId?: Maybe<Scalars['uuid']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  noteHistoryId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "Note" */
export type Note_Max_Order_By_ = {
  authorId?: InputMaybe<Order_By_>;
  body?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  noteHistoryId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Note_Min_Fields_ = {
  __typename?: 'Note_min_fields';
  authorId?: Maybe<Scalars['uuid']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  noteHistoryId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "Note" */
export type Note_Min_Order_By_ = {
  authorId?: InputMaybe<Order_By_>;
  body?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  noteHistoryId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "Note" */
export type Note_Mutation_Response_ = {
  __typename?: 'Note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Note_>;
};

/** on_conflict condition type for table "Note" */
export type Note_On_Conflict_ = {
  constraint: Note_Constraint_;
  update_columns?: Array<Note_Update_Column_>;
  where?: InputMaybe<Note_Bool_Exp_>;
};

/** Ordering options when selecting data from "Note". */
export type Note_Order_By_ = {
  author?: InputMaybe<Users_Order_By_>;
  authorId?: InputMaybe<Order_By_>;
  body?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isAIGenerated?: InputMaybe<Order_By_>;
  noteHistory?: InputMaybe<NoteHistory_Order_By_>;
  noteHistoryId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Note */
export type Note_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "Note" */
export enum Note_Select_Column_ {
  /** column name */
  AuthorId_ = 'authorId',
  /** column name */
  Body_ = 'body',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsAiGenerated_ = 'isAIGenerated',
  /** column name */
  NoteHistoryId_ = 'noteHistoryId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "Note_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Note" */
export enum Note_Select_Column_Note_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsAiGenerated_ = 'isAIGenerated'
}

/** select "Note_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Note" */
export enum Note_Select_Column_Note_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsAiGenerated_ = 'isAIGenerated'
}

/** input type for updating data in table "Note" */
export type Note_Set_Input_ = {
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAIGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  noteHistoryId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "Note" */
export type Note_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Note_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Note_Stream_Cursor_Value_Input_ = {
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAIGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  noteHistoryId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "Note" */
export enum Note_Update_Column_ {
  /** column name */
  AuthorId_ = 'authorId',
  /** column name */
  Body_ = 'body',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsAiGenerated_ = 'isAIGenerated',
  /** column name */
  NoteHistoryId_ = 'noteHistoryId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Note_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Note_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Note_Bool_Exp_;
};

export type NudgeGroupCompaniesInput_ = {
  customMessage: Scalars['String']['input'];
  portfolioOwner: Scalars['String']['input'];
};

export type NudgeGroupCompaniesOutput_ = {
  __typename?: 'NudgeGroupCompaniesOutput';
  emailsSent: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
};

export type NudgePortfolioCompaniesInput_ = {
  customMessage: Scalars['String']['input'];
  portfolioId: Scalars['String']['input'];
  portfolioOwner: Scalars['String']['input'];
};

export type NudgePortfolioCompaniesOutput_ = {
  __typename?: 'NudgePortfolioCompaniesOutput';
  emailsSent: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "Objective" */
export type Objective_ = {
  __typename?: 'Objective';
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  /** An array relationship */
  questions: Array<Question_>;
  /** An aggregate relationship */
  questions_aggregate: Question_Aggregate_;
  title: Scalars['String']['output'];
};


/** columns and relationships of "Objective" */
export type ObjectiveQuestionsArgs_ = {
  distinct_on?: InputMaybe<Array<Question_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Order_By_>>;
  where?: InputMaybe<Question_Bool_Exp_>;
};


/** columns and relationships of "Objective" */
export type ObjectiveQuestions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Question_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Order_By_>>;
  where?: InputMaybe<Question_Bool_Exp_>;
};

/** aggregated selection of "Objective" */
export type Objective_Aggregate_ = {
  __typename?: 'Objective_aggregate';
  aggregate?: Maybe<Objective_Aggregate_Fields_>;
  nodes: Array<Objective_>;
};

/** aggregate fields of "Objective" */
export type Objective_Aggregate_Fields_ = {
  __typename?: 'Objective_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Objective_Max_Fields_>;
  min?: Maybe<Objective_Min_Fields_>;
};


/** aggregate fields of "Objective" */
export type Objective_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Objective_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "Objective". All fields are combined with a logical 'AND'. */
export type Objective_Bool_Exp_ = {
  _and?: InputMaybe<Array<Objective_Bool_Exp_>>;
  _not?: InputMaybe<Objective_Bool_Exp_>;
  _or?: InputMaybe<Array<Objective_Bool_Exp_>>;
  description?: InputMaybe<String_Comparison_Exp_>;
  key?: InputMaybe<String_Comparison_Exp_>;
  questions?: InputMaybe<Question_Bool_Exp_>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Bool_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Objective" */
export enum Objective_Constraint_ {
  /** unique or primary key constraint on columns "key" */
  SectionPkey_ = 'section_pkey',
  /** unique or primary key constraint on columns "title" */
  SectionTitleKey_ = 'section_title_key'
}

/** input type for inserting data into table "Objective" */
export type Objective_Insert_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Question_Arr_Rel_Insert_Input_>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Objective_Max_Fields_ = {
  __typename?: 'Objective_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Objective_Min_Fields_ = {
  __typename?: 'Objective_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "Objective" */
export type Objective_Mutation_Response_ = {
  __typename?: 'Objective_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Objective_>;
};

/** input type for inserting object relation for remote table "Objective" */
export type Objective_Obj_Rel_Insert_Input_ = {
  data: Objective_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Objective_On_Conflict_>;
};

/** on_conflict condition type for table "Objective" */
export type Objective_On_Conflict_ = {
  constraint: Objective_Constraint_;
  update_columns?: Array<Objective_Update_Column_>;
  where?: InputMaybe<Objective_Bool_Exp_>;
};

/** Ordering options when selecting data from "Objective". */
export type Objective_Order_By_ = {
  description?: InputMaybe<Order_By_>;
  key?: InputMaybe<Order_By_>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Objective */
export type Objective_Pk_Columns_Input_ = {
  key: Scalars['String']['input'];
};

/** select columns of table "Objective" */
export enum Objective_Select_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  Key_ = 'key',
  /** column name */
  Title_ = 'title'
}

/** input type for updating data in table "Objective" */
export type Objective_Set_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "Objective" */
export type Objective_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Objective_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Objective_Stream_Cursor_Value_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "Objective" */
export enum Objective_Update_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  Key_ = 'key',
  /** column name */
  Title_ = 'title'
}

export type Objective_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Objective_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Objective_Bool_Exp_;
};

export type Opex_ = {
  __typename?: 'Opex';
  aligned?: Maybe<Scalars['Float']['output']>;
  eligible?: Maybe<Scalars['Float']['output']>;
  enabling?: Maybe<Scalars['Float']['output']>;
  inProgress?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  transitional?: Maybe<Scalars['Float']['output']>;
};

/** Answers for PAI  */
export type PaiAnswers_ = {
  __typename?: 'PaiAnswers';
  /** An object relationship */
  answeredBy?: Maybe<Users_>;
  answeredById?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  attachmentBox?: Maybe<AttachmentBox_>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  investeeMetricReference: Scalars['String']['output'];
  /** An object relationship */
  metric: InvesteeMetric_;
  /** An object relationship */
  noteHistory?: Maybe<NoteHistory_>;
  /** An object relationship */
  paiCompanyReport: PaiCompanyReport_;
  paiCompanyReportId: Scalars['uuid']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "PaiAnswers" */
export type PaiAnswers_Aggregate_ = {
  __typename?: 'PaiAnswers_aggregate';
  aggregate?: Maybe<PaiAnswers_Aggregate_Fields_>;
  nodes: Array<PaiAnswers_>;
};

export type PaiAnswers_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<PaiAnswers_Aggregate_Bool_Exp_Count_>;
};

export type PaiAnswers_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<PaiAnswers_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PaiAnswers_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "PaiAnswers" */
export type PaiAnswers_Aggregate_Fields_ = {
  __typename?: 'PaiAnswers_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PaiAnswers_Max_Fields_>;
  min?: Maybe<PaiAnswers_Min_Fields_>;
};


/** aggregate fields of "PaiAnswers" */
export type PaiAnswers_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<PaiAnswers_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "PaiAnswers" */
export type PaiAnswers_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<PaiAnswers_Max_Order_By_>;
  min?: InputMaybe<PaiAnswers_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "PaiAnswers" */
export type PaiAnswers_Arr_Rel_Insert_Input_ = {
  data: Array<PaiAnswers_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<PaiAnswers_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "PaiAnswers". All fields are combined with a logical 'AND'. */
export type PaiAnswers_Bool_Exp_ = {
  _and?: InputMaybe<Array<PaiAnswers_Bool_Exp_>>;
  _not?: InputMaybe<PaiAnswers_Bool_Exp_>;
  _or?: InputMaybe<Array<PaiAnswers_Bool_Exp_>>;
  answeredBy?: InputMaybe<Users_Bool_Exp_>;
  answeredById?: InputMaybe<Uuid_Comparison_Exp_>;
  attachmentBox?: InputMaybe<AttachmentBox_Bool_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  data?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  investeeMetricReference?: InputMaybe<String_Comparison_Exp_>;
  metric?: InputMaybe<InvesteeMetric_Bool_Exp_>;
  noteHistory?: InputMaybe<NoteHistory_Bool_Exp_>;
  paiCompanyReport?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
  paiCompanyReportId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "PaiAnswers" */
export enum PaiAnswers_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  PaiAnswersPkey_ = 'PaiAnswers_pkey'
}

/** input type for inserting data into table "PaiAnswers" */
export type PaiAnswers_Insert_Input_ = {
  answeredBy?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  answeredById?: InputMaybe<Scalars['uuid']['input']>;
  attachmentBox?: InputMaybe<AttachmentBox_Obj_Rel_Insert_Input_>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  investeeMetricReference?: InputMaybe<Scalars['String']['input']>;
  metric?: InputMaybe<InvesteeMetric_Obj_Rel_Insert_Input_>;
  noteHistory?: InputMaybe<NoteHistory_Obj_Rel_Insert_Input_>;
  paiCompanyReport?: InputMaybe<PaiCompanyReport_Obj_Rel_Insert_Input_>;
  paiCompanyReportId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PaiAnswers_Max_Fields_ = {
  __typename?: 'PaiAnswers_max_fields';
  answeredById?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  investeeMetricReference?: Maybe<Scalars['String']['output']>;
  paiCompanyReportId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "PaiAnswers" */
export type PaiAnswers_Max_Order_By_ = {
  answeredById?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  data?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  investeeMetricReference?: InputMaybe<Order_By_>;
  paiCompanyReportId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type PaiAnswers_Min_Fields_ = {
  __typename?: 'PaiAnswers_min_fields';
  answeredById?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  data?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  investeeMetricReference?: Maybe<Scalars['String']['output']>;
  paiCompanyReportId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "PaiAnswers" */
export type PaiAnswers_Min_Order_By_ = {
  answeredById?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  data?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  investeeMetricReference?: InputMaybe<Order_By_>;
  paiCompanyReportId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "PaiAnswers" */
export type PaiAnswers_Mutation_Response_ = {
  __typename?: 'PaiAnswers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PaiAnswers_>;
};

/** input type for inserting object relation for remote table "PaiAnswers" */
export type PaiAnswers_Obj_Rel_Insert_Input_ = {
  data: PaiAnswers_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<PaiAnswers_On_Conflict_>;
};

/** on_conflict condition type for table "PaiAnswers" */
export type PaiAnswers_On_Conflict_ = {
  constraint: PaiAnswers_Constraint_;
  update_columns?: Array<PaiAnswers_Update_Column_>;
  where?: InputMaybe<PaiAnswers_Bool_Exp_>;
};

/** Ordering options when selecting data from "PaiAnswers". */
export type PaiAnswers_Order_By_ = {
  answeredBy?: InputMaybe<Users_Order_By_>;
  answeredById?: InputMaybe<Order_By_>;
  attachmentBox?: InputMaybe<AttachmentBox_Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  data?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  investeeMetricReference?: InputMaybe<Order_By_>;
  metric?: InputMaybe<InvesteeMetric_Order_By_>;
  noteHistory?: InputMaybe<NoteHistory_Order_By_>;
  paiCompanyReport?: InputMaybe<PaiCompanyReport_Order_By_>;
  paiCompanyReportId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: PaiAnswers */
export type PaiAnswers_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "PaiAnswers" */
export enum PaiAnswers_Select_Column_ {
  /** column name */
  AnsweredById_ = 'answeredById',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Data_ = 'data',
  /** column name */
  Id_ = 'id',
  /** column name */
  InvesteeMetricReference_ = 'investeeMetricReference',
  /** column name */
  PaiCompanyReportId_ = 'paiCompanyReportId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "PaiAnswers" */
export type PaiAnswers_Set_Input_ = {
  answeredById?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  investeeMetricReference?: InputMaybe<Scalars['String']['input']>;
  paiCompanyReportId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "PaiAnswers" */
export type PaiAnswers_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: PaiAnswers_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type PaiAnswers_Stream_Cursor_Value_Input_ = {
  answeredById?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  investeeMetricReference?: InputMaybe<Scalars['String']['input']>;
  paiCompanyReportId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "PaiAnswers" */
export enum PaiAnswers_Update_Column_ {
  /** column name */
  AnsweredById_ = 'answeredById',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Data_ = 'data',
  /** column name */
  Id_ = 'id',
  /** column name */
  InvesteeMetricReference_ = 'investeeMetricReference',
  /** column name */
  PaiCompanyReportId_ = 'paiCompanyReportId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type PaiAnswers_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaiAnswers_Set_Input_>;
  /** filter the rows which have to be updated */
  where: PaiAnswers_Bool_Exp_;
};

/** Categories in PAI tables (ex: Greenhouse gas emissions) */
export type PaiCategory_ = {
  __typename?: 'PaiCategory';
  /** An array relationship */
  indicators: Array<PaiTableIndicator_>;
  /** An aggregate relationship */
  indicators_aggregate: PaiTableIndicator_Aggregate_;
  reference: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  table: PaiTable_;
  tableReference: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


/** Categories in PAI tables (ex: Greenhouse gas emissions) */
export type PaiCategoryIndicatorsArgs_ = {
  distinct_on?: InputMaybe<Array<PaiTableIndicator_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiTableIndicator_Order_By_>>;
  where?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
};


/** Categories in PAI tables (ex: Greenhouse gas emissions) */
export type PaiCategoryIndicators_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiTableIndicator_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiTableIndicator_Order_By_>>;
  where?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
};

/** aggregated selection of "PaiCategory" */
export type PaiCategory_Aggregate_ = {
  __typename?: 'PaiCategory_aggregate';
  aggregate?: Maybe<PaiCategory_Aggregate_Fields_>;
  nodes: Array<PaiCategory_>;
};

export type PaiCategory_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<PaiCategory_Aggregate_Bool_Exp_Count_>;
};

export type PaiCategory_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<PaiCategory_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PaiCategory_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "PaiCategory" */
export type PaiCategory_Aggregate_Fields_ = {
  __typename?: 'PaiCategory_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PaiCategory_Max_Fields_>;
  min?: Maybe<PaiCategory_Min_Fields_>;
};


/** aggregate fields of "PaiCategory" */
export type PaiCategory_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<PaiCategory_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "PaiCategory" */
export type PaiCategory_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<PaiCategory_Max_Order_By_>;
  min?: InputMaybe<PaiCategory_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "PaiCategory" */
export type PaiCategory_Arr_Rel_Insert_Input_ = {
  data: Array<PaiCategory_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<PaiCategory_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "PaiCategory". All fields are combined with a logical 'AND'. */
export type PaiCategory_Bool_Exp_ = {
  _and?: InputMaybe<Array<PaiCategory_Bool_Exp_>>;
  _not?: InputMaybe<PaiCategory_Bool_Exp_>;
  _or?: InputMaybe<Array<PaiCategory_Bool_Exp_>>;
  indicators?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
  indicators_aggregate?: InputMaybe<PaiTableIndicator_Aggregate_Bool_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  subtitle?: InputMaybe<String_Comparison_Exp_>;
  table?: InputMaybe<PaiTable_Bool_Exp_>;
  tableReference?: InputMaybe<String_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "PaiCategory" */
export enum PaiCategory_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  PaiCategoryPkey_ = 'PaiCategory_pkey'
}

/** input type for inserting data into table "PaiCategory" */
export type PaiCategory_Insert_Input_ = {
  indicators?: InputMaybe<PaiTableIndicator_Arr_Rel_Insert_Input_>;
  reference?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  table?: InputMaybe<PaiTable_Obj_Rel_Insert_Input_>;
  tableReference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type PaiCategory_Max_Fields_ = {
  __typename?: 'PaiCategory_max_fields';
  reference?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tableReference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "PaiCategory" */
export type PaiCategory_Max_Order_By_ = {
  reference?: InputMaybe<Order_By_>;
  subtitle?: InputMaybe<Order_By_>;
  tableReference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type PaiCategory_Min_Fields_ = {
  __typename?: 'PaiCategory_min_fields';
  reference?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  tableReference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "PaiCategory" */
export type PaiCategory_Min_Order_By_ = {
  reference?: InputMaybe<Order_By_>;
  subtitle?: InputMaybe<Order_By_>;
  tableReference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "PaiCategory" */
export type PaiCategory_Mutation_Response_ = {
  __typename?: 'PaiCategory_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PaiCategory_>;
};

/** input type for inserting object relation for remote table "PaiCategory" */
export type PaiCategory_Obj_Rel_Insert_Input_ = {
  data: PaiCategory_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<PaiCategory_On_Conflict_>;
};

/** on_conflict condition type for table "PaiCategory" */
export type PaiCategory_On_Conflict_ = {
  constraint: PaiCategory_Constraint_;
  update_columns?: Array<PaiCategory_Update_Column_>;
  where?: InputMaybe<PaiCategory_Bool_Exp_>;
};

/** Ordering options when selecting data from "PaiCategory". */
export type PaiCategory_Order_By_ = {
  indicators_aggregate?: InputMaybe<PaiTableIndicator_Aggregate_Order_By_>;
  reference?: InputMaybe<Order_By_>;
  subtitle?: InputMaybe<Order_By_>;
  table?: InputMaybe<PaiTable_Order_By_>;
  tableReference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: PaiCategory */
export type PaiCategory_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "PaiCategory" */
export enum PaiCategory_Select_Column_ {
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Subtitle_ = 'subtitle',
  /** column name */
  TableReference_ = 'tableReference',
  /** column name */
  Title_ = 'title'
}

/** input type for updating data in table "PaiCategory" */
export type PaiCategory_Set_Input_ = {
  reference?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tableReference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "PaiCategory" */
export type PaiCategory_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: PaiCategory_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type PaiCategory_Stream_Cursor_Value_Input_ = {
  reference?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  tableReference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "PaiCategory" */
export enum PaiCategory_Update_Column_ {
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Subtitle_ = 'subtitle',
  /** column name */
  TableReference_ = 'tableReference',
  /** column name */
  Title_ = 'title'
}

export type PaiCategory_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaiCategory_Set_Input_>;
  /** filter the rows which have to be updated */
  where: PaiCategory_Bool_Exp_;
};

/** columns and relationships of "PaiCompanyReport" */
export type PaiCompanyReport_ = {
  __typename?: 'PaiCompanyReport';
  /** An array relationship */
  answers: Array<PaiAnswers_>;
  /** An aggregate relationship */
  answers_aggregate: PaiAnswers_Aggregate_;
  /** An object relationship */
  company?: Maybe<Company_>;
  companyId: Scalars['uuid']['output'];
  contactPersonId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  insights: Array<PaiMetricInsight_>;
  /** An aggregate relationship */
  insights_aggregate: PaiMetricInsight_Aggregate_;
  period: Scalars['String']['output'];
  /** An array relationship */
  portfoliosWithAccessToQ1: Array<PortfolioCompany_>;
  /** An aggregate relationship */
  portfoliosWithAccessToQ1_aggregate: PortfolioCompany_Aggregate_;
  /** An array relationship */
  portfoliosWithAccessToQ2: Array<PortfolioCompany_>;
  /** An aggregate relationship */
  portfoliosWithAccessToQ2_aggregate: PortfolioCompany_Aggregate_;
  /** An array relationship */
  portfoliosWithAccessToQ3: Array<PortfolioCompany_>;
  /** An aggregate relationship */
  portfoliosWithAccessToQ3_aggregate: PortfolioCompany_Aggregate_;
  /** An array relationship */
  portfoliosWithAccessToQ4: Array<PortfolioCompany_>;
  /** An aggregate relationship */
  portfoliosWithAccessToQ4_aggregate: PortfolioCompany_Aggregate_;
  /** An array relationship */
  portfoliosWithAccessToYear: Array<PortfolioCompany_>;
  /** An aggregate relationship */
  portfoliosWithAccessToYear_aggregate: PortfolioCompany_Aggregate_;
  /** Deprecated. Use the "year" and "period" columns instead. */
  reportingPeriod?: Maybe<Scalars['date']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  user?: Maybe<Users_>;
  year?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "PaiCompanyReport" */
export type PaiCompanyReportAnswersArgs_ = {
  distinct_on?: InputMaybe<Array<PaiAnswers_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiAnswers_Order_By_>>;
  where?: InputMaybe<PaiAnswers_Bool_Exp_>;
};


/** columns and relationships of "PaiCompanyReport" */
export type PaiCompanyReportAnswers_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiAnswers_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiAnswers_Order_By_>>;
  where?: InputMaybe<PaiAnswers_Bool_Exp_>;
};


/** columns and relationships of "PaiCompanyReport" */
export type PaiCompanyReportInsightsArgs_ = {
  distinct_on?: InputMaybe<Array<PaiMetricInsight_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiMetricInsight_Order_By_>>;
  where?: InputMaybe<PaiMetricInsight_Bool_Exp_>;
};


/** columns and relationships of "PaiCompanyReport" */
export type PaiCompanyReportInsights_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiMetricInsight_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiMetricInsight_Order_By_>>;
  where?: InputMaybe<PaiMetricInsight_Bool_Exp_>;
};


/** columns and relationships of "PaiCompanyReport" */
export type PaiCompanyReportPortfoliosWithAccessToQ1Args_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "PaiCompanyReport" */
export type PaiCompanyReportPortfoliosWithAccessToQ1_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "PaiCompanyReport" */
export type PaiCompanyReportPortfoliosWithAccessToQ2Args_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "PaiCompanyReport" */
export type PaiCompanyReportPortfoliosWithAccessToQ2_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "PaiCompanyReport" */
export type PaiCompanyReportPortfoliosWithAccessToQ3Args_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "PaiCompanyReport" */
export type PaiCompanyReportPortfoliosWithAccessToQ3_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "PaiCompanyReport" */
export type PaiCompanyReportPortfoliosWithAccessToQ4Args_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "PaiCompanyReport" */
export type PaiCompanyReportPortfoliosWithAccessToQ4_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "PaiCompanyReport" */
export type PaiCompanyReportPortfoliosWithAccessToYearArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "PaiCompanyReport" */
export type PaiCompanyReportPortfoliosWithAccessToYear_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};

/** aggregated selection of "PaiCompanyReport" */
export type PaiCompanyReport_Aggregate_ = {
  __typename?: 'PaiCompanyReport_aggregate';
  aggregate?: Maybe<PaiCompanyReport_Aggregate_Fields_>;
  nodes: Array<PaiCompanyReport_>;
};

export type PaiCompanyReport_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<PaiCompanyReport_Aggregate_Bool_Exp_Count_>;
};

export type PaiCompanyReport_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<PaiCompanyReport_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "PaiCompanyReport" */
export type PaiCompanyReport_Aggregate_Fields_ = {
  __typename?: 'PaiCompanyReport_aggregate_fields';
  avg?: Maybe<PaiCompanyReport_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<PaiCompanyReport_Max_Fields_>;
  min?: Maybe<PaiCompanyReport_Min_Fields_>;
  stddev?: Maybe<PaiCompanyReport_Stddev_Fields_>;
  stddev_pop?: Maybe<PaiCompanyReport_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<PaiCompanyReport_Stddev_Samp_Fields_>;
  sum?: Maybe<PaiCompanyReport_Sum_Fields_>;
  var_pop?: Maybe<PaiCompanyReport_Var_Pop_Fields_>;
  var_samp?: Maybe<PaiCompanyReport_Var_Samp_Fields_>;
  variance?: Maybe<PaiCompanyReport_Variance_Fields_>;
};


/** aggregate fields of "PaiCompanyReport" */
export type PaiCompanyReport_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<PaiCompanyReport_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "PaiCompanyReport" */
export type PaiCompanyReport_Aggregate_Order_By_ = {
  avg?: InputMaybe<PaiCompanyReport_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<PaiCompanyReport_Max_Order_By_>;
  min?: InputMaybe<PaiCompanyReport_Min_Order_By_>;
  stddev?: InputMaybe<PaiCompanyReport_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<PaiCompanyReport_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<PaiCompanyReport_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<PaiCompanyReport_Sum_Order_By_>;
  var_pop?: InputMaybe<PaiCompanyReport_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<PaiCompanyReport_Var_Samp_Order_By_>;
  variance?: InputMaybe<PaiCompanyReport_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "PaiCompanyReport" */
export type PaiCompanyReport_Arr_Rel_Insert_Input_ = {
  data: Array<PaiCompanyReport_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<PaiCompanyReport_On_Conflict_>;
};

/** aggregate avg on columns */
export type PaiCompanyReport_Avg_Fields_ = {
  __typename?: 'PaiCompanyReport_avg_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "PaiCompanyReport" */
export type PaiCompanyReport_Avg_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "PaiCompanyReport". All fields are combined with a logical 'AND'. */
export type PaiCompanyReport_Bool_Exp_ = {
  _and?: InputMaybe<Array<PaiCompanyReport_Bool_Exp_>>;
  _not?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
  _or?: InputMaybe<Array<PaiCompanyReport_Bool_Exp_>>;
  answers?: InputMaybe<PaiAnswers_Bool_Exp_>;
  answers_aggregate?: InputMaybe<PaiAnswers_Aggregate_Bool_Exp_>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  contactPersonId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  insights?: InputMaybe<PaiMetricInsight_Bool_Exp_>;
  insights_aggregate?: InputMaybe<PaiMetricInsight_Aggregate_Bool_Exp_>;
  period?: InputMaybe<String_Comparison_Exp_>;
  portfoliosWithAccessToQ1?: InputMaybe<PortfolioCompany_Bool_Exp_>;
  portfoliosWithAccessToQ1_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Bool_Exp_>;
  portfoliosWithAccessToQ2?: InputMaybe<PortfolioCompany_Bool_Exp_>;
  portfoliosWithAccessToQ2_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Bool_Exp_>;
  portfoliosWithAccessToQ3?: InputMaybe<PortfolioCompany_Bool_Exp_>;
  portfoliosWithAccessToQ3_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Bool_Exp_>;
  portfoliosWithAccessToQ4?: InputMaybe<PortfolioCompany_Bool_Exp_>;
  portfoliosWithAccessToQ4_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Bool_Exp_>;
  portfoliosWithAccessToYear?: InputMaybe<PortfolioCompany_Bool_Exp_>;
  portfoliosWithAccessToYear_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Bool_Exp_>;
  reportingPeriod?: InputMaybe<Date_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  user?: InputMaybe<Users_Bool_Exp_>;
  year?: InputMaybe<Int_Comparison_Exp_>;
};

/** unique or primary key constraints on table "PaiCompanyReport" */
export enum PaiCompanyReport_Constraint_ {
  /** unique or primary key constraint on columns "period", "year", "companyId" */
  PaiCompanyReportCompanyIdYearPeriodKey_ = 'PaiCompanyReport_companyId_year_period_key',
  /** unique or primary key constraint on columns "id" */
  PaiCompanyReportPkey_ = 'PaiCompanyReport_pkey'
}

/** input type for incrementing numeric columns in table "PaiCompanyReport" */
export type PaiCompanyReport_Inc_Input_ = {
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "PaiCompanyReport" */
export type PaiCompanyReport_Insert_Input_ = {
  answers?: InputMaybe<PaiAnswers_Arr_Rel_Insert_Input_>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  contactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  insights?: InputMaybe<PaiMetricInsight_Arr_Rel_Insert_Input_>;
  period?: InputMaybe<Scalars['String']['input']>;
  portfoliosWithAccessToQ1?: InputMaybe<PortfolioCompany_Arr_Rel_Insert_Input_>;
  portfoliosWithAccessToQ2?: InputMaybe<PortfolioCompany_Arr_Rel_Insert_Input_>;
  portfoliosWithAccessToQ3?: InputMaybe<PortfolioCompany_Arr_Rel_Insert_Input_>;
  portfoliosWithAccessToQ4?: InputMaybe<PortfolioCompany_Arr_Rel_Insert_Input_>;
  portfoliosWithAccessToYear?: InputMaybe<PortfolioCompany_Arr_Rel_Insert_Input_>;
  /** Deprecated. Use the "year" and "period" columns instead. */
  reportingPeriod?: InputMaybe<Scalars['date']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type PaiCompanyReport_Max_Fields_ = {
  __typename?: 'PaiCompanyReport_max_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  contactPersonId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  /** Deprecated. Use the "year" and "period" columns instead. */
  reportingPeriod?: Maybe<Scalars['date']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "PaiCompanyReport" */
export type PaiCompanyReport_Max_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  contactPersonId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  period?: InputMaybe<Order_By_>;
  /** Deprecated. Use the "year" and "period" columns instead. */
  reportingPeriod?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type PaiCompanyReport_Min_Fields_ = {
  __typename?: 'PaiCompanyReport_min_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  contactPersonId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  /** Deprecated. Use the "year" and "period" columns instead. */
  reportingPeriod?: Maybe<Scalars['date']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "PaiCompanyReport" */
export type PaiCompanyReport_Min_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  contactPersonId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  period?: InputMaybe<Order_By_>;
  /** Deprecated. Use the "year" and "period" columns instead. */
  reportingPeriod?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "PaiCompanyReport" */
export type PaiCompanyReport_Mutation_Response_ = {
  __typename?: 'PaiCompanyReport_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PaiCompanyReport_>;
};

/** input type for inserting object relation for remote table "PaiCompanyReport" */
export type PaiCompanyReport_Obj_Rel_Insert_Input_ = {
  data: PaiCompanyReport_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<PaiCompanyReport_On_Conflict_>;
};

/** on_conflict condition type for table "PaiCompanyReport" */
export type PaiCompanyReport_On_Conflict_ = {
  constraint: PaiCompanyReport_Constraint_;
  update_columns?: Array<PaiCompanyReport_Update_Column_>;
  where?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
};

/** Ordering options when selecting data from "PaiCompanyReport". */
export type PaiCompanyReport_Order_By_ = {
  answers_aggregate?: InputMaybe<PaiAnswers_Aggregate_Order_By_>;
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  contactPersonId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  insights_aggregate?: InputMaybe<PaiMetricInsight_Aggregate_Order_By_>;
  period?: InputMaybe<Order_By_>;
  portfoliosWithAccessToQ1_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Order_By_>;
  portfoliosWithAccessToQ2_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Order_By_>;
  portfoliosWithAccessToQ3_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Order_By_>;
  portfoliosWithAccessToQ4_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Order_By_>;
  portfoliosWithAccessToYear_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Order_By_>;
  reportingPeriod?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  user?: InputMaybe<Users_Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: PaiCompanyReport */
export type PaiCompanyReport_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "PaiCompanyReport" */
export enum PaiCompanyReport_Select_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  ContactPersonId_ = 'contactPersonId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Period_ = 'period',
  /** column name */
  ReportingPeriod_ = 'reportingPeriod',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Year_ = 'year'
}

/** input type for updating data in table "PaiCompanyReport" */
export type PaiCompanyReport_Set_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  contactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated. Use the "year" and "period" columns instead. */
  reportingPeriod?: InputMaybe<Scalars['date']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type PaiCompanyReport_Stddev_Fields_ = {
  __typename?: 'PaiCompanyReport_stddev_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "PaiCompanyReport" */
export type PaiCompanyReport_Stddev_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type PaiCompanyReport_Stddev_Pop_Fields_ = {
  __typename?: 'PaiCompanyReport_stddev_pop_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "PaiCompanyReport" */
export type PaiCompanyReport_Stddev_Pop_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type PaiCompanyReport_Stddev_Samp_Fields_ = {
  __typename?: 'PaiCompanyReport_stddev_samp_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "PaiCompanyReport" */
export type PaiCompanyReport_Stddev_Samp_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "PaiCompanyReport" */
export type PaiCompanyReport_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: PaiCompanyReport_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type PaiCompanyReport_Stream_Cursor_Value_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  contactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated. Use the "year" and "period" columns instead. */
  reportingPeriod?: InputMaybe<Scalars['date']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type PaiCompanyReport_Sum_Fields_ = {
  __typename?: 'PaiCompanyReport_sum_fields';
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "PaiCompanyReport" */
export type PaiCompanyReport_Sum_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** update columns of table "PaiCompanyReport" */
export enum PaiCompanyReport_Update_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  ContactPersonId_ = 'contactPersonId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Period_ = 'period',
  /** column name */
  ReportingPeriod_ = 'reportingPeriod',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Year_ = 'year'
}

export type PaiCompanyReport_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PaiCompanyReport_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaiCompanyReport_Set_Input_>;
  /** filter the rows which have to be updated */
  where: PaiCompanyReport_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type PaiCompanyReport_Var_Pop_Fields_ = {
  __typename?: 'PaiCompanyReport_var_pop_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "PaiCompanyReport" */
export type PaiCompanyReport_Var_Pop_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type PaiCompanyReport_Var_Samp_Fields_ = {
  __typename?: 'PaiCompanyReport_var_samp_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "PaiCompanyReport" */
export type PaiCompanyReport_Var_Samp_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type PaiCompanyReport_Variance_Fields_ = {
  __typename?: 'PaiCompanyReport_variance_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "PaiCompanyReport" */
export type PaiCompanyReport_Variance_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** columns and relationships of "PaiMetricInsight" */
export type PaiMetricInsight_ = {
  __typename?: 'PaiMetricInsight';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  insight: DocumentInsight_;
  insightId: Scalars['uuid']['output'];
  /** An object relationship */
  investeeMetric: InvesteeMetric_;
  investeeMetricRef: Scalars['String']['output'];
  /** An object relationship */
  paiCompanyReport: PaiCompanyReport_;
  reportId: Scalars['uuid']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "PaiMetricInsight" */
export type PaiMetricInsight_Aggregate_ = {
  __typename?: 'PaiMetricInsight_aggregate';
  aggregate?: Maybe<PaiMetricInsight_Aggregate_Fields_>;
  nodes: Array<PaiMetricInsight_>;
};

export type PaiMetricInsight_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<PaiMetricInsight_Aggregate_Bool_Exp_Count_>;
};

export type PaiMetricInsight_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<PaiMetricInsight_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PaiMetricInsight_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "PaiMetricInsight" */
export type PaiMetricInsight_Aggregate_Fields_ = {
  __typename?: 'PaiMetricInsight_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PaiMetricInsight_Max_Fields_>;
  min?: Maybe<PaiMetricInsight_Min_Fields_>;
};


/** aggregate fields of "PaiMetricInsight" */
export type PaiMetricInsight_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<PaiMetricInsight_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "PaiMetricInsight" */
export type PaiMetricInsight_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<PaiMetricInsight_Max_Order_By_>;
  min?: InputMaybe<PaiMetricInsight_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "PaiMetricInsight" */
export type PaiMetricInsight_Arr_Rel_Insert_Input_ = {
  data: Array<PaiMetricInsight_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<PaiMetricInsight_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "PaiMetricInsight". All fields are combined with a logical 'AND'. */
export type PaiMetricInsight_Bool_Exp_ = {
  _and?: InputMaybe<Array<PaiMetricInsight_Bool_Exp_>>;
  _not?: InputMaybe<PaiMetricInsight_Bool_Exp_>;
  _or?: InputMaybe<Array<PaiMetricInsight_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  insight?: InputMaybe<DocumentInsight_Bool_Exp_>;
  insightId?: InputMaybe<Uuid_Comparison_Exp_>;
  investeeMetric?: InputMaybe<InvesteeMetric_Bool_Exp_>;
  investeeMetricRef?: InputMaybe<String_Comparison_Exp_>;
  paiCompanyReport?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
  reportId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "PaiMetricInsight" */
export enum PaiMetricInsight_Constraint_ {
  /** unique or primary key constraint on columns "investeeMetricRef", "reportId", "insightId" */
  PaiMetricInsightPkey_ = 'PAIMetricInsight_pkey'
}

/** input type for inserting data into table "PaiMetricInsight" */
export type PaiMetricInsight_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  insight?: InputMaybe<DocumentInsight_Obj_Rel_Insert_Input_>;
  insightId?: InputMaybe<Scalars['uuid']['input']>;
  investeeMetric?: InputMaybe<InvesteeMetric_Obj_Rel_Insert_Input_>;
  investeeMetricRef?: InputMaybe<Scalars['String']['input']>;
  paiCompanyReport?: InputMaybe<PaiCompanyReport_Obj_Rel_Insert_Input_>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PaiMetricInsight_Max_Fields_ = {
  __typename?: 'PaiMetricInsight_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  insightId?: Maybe<Scalars['uuid']['output']>;
  investeeMetricRef?: Maybe<Scalars['String']['output']>;
  reportId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "PaiMetricInsight" */
export type PaiMetricInsight_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  insightId?: InputMaybe<Order_By_>;
  investeeMetricRef?: InputMaybe<Order_By_>;
  reportId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type PaiMetricInsight_Min_Fields_ = {
  __typename?: 'PaiMetricInsight_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  insightId?: Maybe<Scalars['uuid']['output']>;
  investeeMetricRef?: Maybe<Scalars['String']['output']>;
  reportId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "PaiMetricInsight" */
export type PaiMetricInsight_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  insightId?: InputMaybe<Order_By_>;
  investeeMetricRef?: InputMaybe<Order_By_>;
  reportId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "PaiMetricInsight" */
export type PaiMetricInsight_Mutation_Response_ = {
  __typename?: 'PaiMetricInsight_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PaiMetricInsight_>;
};

/** on_conflict condition type for table "PaiMetricInsight" */
export type PaiMetricInsight_On_Conflict_ = {
  constraint: PaiMetricInsight_Constraint_;
  update_columns?: Array<PaiMetricInsight_Update_Column_>;
  where?: InputMaybe<PaiMetricInsight_Bool_Exp_>;
};

/** Ordering options when selecting data from "PaiMetricInsight". */
export type PaiMetricInsight_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  insight?: InputMaybe<DocumentInsight_Order_By_>;
  insightId?: InputMaybe<Order_By_>;
  investeeMetric?: InputMaybe<InvesteeMetric_Order_By_>;
  investeeMetricRef?: InputMaybe<Order_By_>;
  paiCompanyReport?: InputMaybe<PaiCompanyReport_Order_By_>;
  reportId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: PaiMetricInsight */
export type PaiMetricInsight_Pk_Columns_Input_ = {
  insightId: Scalars['uuid']['input'];
  investeeMetricRef: Scalars['String']['input'];
  reportId: Scalars['uuid']['input'];
};

/** select columns of table "PaiMetricInsight" */
export enum PaiMetricInsight_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  InsightId_ = 'insightId',
  /** column name */
  InvesteeMetricRef_ = 'investeeMetricRef',
  /** column name */
  ReportId_ = 'reportId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "PaiMetricInsight" */
export type PaiMetricInsight_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  insightId?: InputMaybe<Scalars['uuid']['input']>;
  investeeMetricRef?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "PaiMetricInsight" */
export type PaiMetricInsight_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: PaiMetricInsight_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type PaiMetricInsight_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  insightId?: InputMaybe<Scalars['uuid']['input']>;
  investeeMetricRef?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "PaiMetricInsight" */
export enum PaiMetricInsight_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  InsightId_ = 'insightId',
  /** column name */
  InvesteeMetricRef_ = 'investeeMetricRef',
  /** column name */
  ReportId_ = 'reportId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type PaiMetricInsight_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaiMetricInsight_Set_Input_>;
  /** filter the rows which have to be updated */
  where: PaiMetricInsight_Bool_Exp_;
};

/** PAI report for a portfolio */
export type PaiPortfolioReport_ = {
  __typename?: 'PaiPortfolioReport';
  /** An object relationship */
  contactPerson?: Maybe<Users_>;
  contactPersonId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** Deprecated. Use the "dueDates" field to indicate the due dates per quarter instead. */
  dueDate?: Maybe<Scalars['date']['output']>;
  dueDates?: Maybe<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  portfolio: Portfolio_;
  portfolioId: Scalars['uuid']['output'];
  quarter: QuarterEnum_Enum_;
  /** Deprecated. Use the "year" column instead. */
  reportingPeriod?: Maybe<Scalars['date']['output']>;
  /** An array relationship */
  selectedIndicators: Array<PaiReportIndicator_>;
  /** An aggregate relationship */
  selectedIndicators_aggregate: PaiReportIndicator_Aggregate_;
  sendOutDates?: Maybe<Scalars['jsonb']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};


/** PAI report for a portfolio */
export type PaiPortfolioReportDueDatesArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** PAI report for a portfolio */
export type PaiPortfolioReportSelectedIndicatorsArgs_ = {
  distinct_on?: InputMaybe<Array<PaiReportIndicator_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiReportIndicator_Order_By_>>;
  where?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
};


/** PAI report for a portfolio */
export type PaiPortfolioReportSelectedIndicators_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiReportIndicator_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiReportIndicator_Order_By_>>;
  where?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
};


/** PAI report for a portfolio */
export type PaiPortfolioReportSendOutDatesArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "PaiPortfolioReport" */
export type PaiPortfolioReport_Aggregate_ = {
  __typename?: 'PaiPortfolioReport_aggregate';
  aggregate?: Maybe<PaiPortfolioReport_Aggregate_Fields_>;
  nodes: Array<PaiPortfolioReport_>;
};

export type PaiPortfolioReport_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<PaiPortfolioReport_Aggregate_Bool_Exp_Count_>;
};

export type PaiPortfolioReport_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<PaiPortfolioReport_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PaiPortfolioReport_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "PaiPortfolioReport" */
export type PaiPortfolioReport_Aggregate_Fields_ = {
  __typename?: 'PaiPortfolioReport_aggregate_fields';
  avg?: Maybe<PaiPortfolioReport_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<PaiPortfolioReport_Max_Fields_>;
  min?: Maybe<PaiPortfolioReport_Min_Fields_>;
  stddev?: Maybe<PaiPortfolioReport_Stddev_Fields_>;
  stddev_pop?: Maybe<PaiPortfolioReport_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<PaiPortfolioReport_Stddev_Samp_Fields_>;
  sum?: Maybe<PaiPortfolioReport_Sum_Fields_>;
  var_pop?: Maybe<PaiPortfolioReport_Var_Pop_Fields_>;
  var_samp?: Maybe<PaiPortfolioReport_Var_Samp_Fields_>;
  variance?: Maybe<PaiPortfolioReport_Variance_Fields_>;
};


/** aggregate fields of "PaiPortfolioReport" */
export type PaiPortfolioReport_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<PaiPortfolioReport_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "PaiPortfolioReport" */
export type PaiPortfolioReport_Aggregate_Order_By_ = {
  avg?: InputMaybe<PaiPortfolioReport_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<PaiPortfolioReport_Max_Order_By_>;
  min?: InputMaybe<PaiPortfolioReport_Min_Order_By_>;
  stddev?: InputMaybe<PaiPortfolioReport_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<PaiPortfolioReport_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<PaiPortfolioReport_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<PaiPortfolioReport_Sum_Order_By_>;
  var_pop?: InputMaybe<PaiPortfolioReport_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<PaiPortfolioReport_Var_Samp_Order_By_>;
  variance?: InputMaybe<PaiPortfolioReport_Variance_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PaiPortfolioReport_Append_Input_ = {
  dueDates?: InputMaybe<Scalars['jsonb']['input']>;
  sendOutDates?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "PaiPortfolioReport" */
export type PaiPortfolioReport_Arr_Rel_Insert_Input_ = {
  data: Array<PaiPortfolioReport_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<PaiPortfolioReport_On_Conflict_>;
};

/** aggregate avg on columns */
export type PaiPortfolioReport_Avg_Fields_ = {
  __typename?: 'PaiPortfolioReport_avg_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "PaiPortfolioReport" */
export type PaiPortfolioReport_Avg_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "PaiPortfolioReport". All fields are combined with a logical 'AND'. */
export type PaiPortfolioReport_Bool_Exp_ = {
  _and?: InputMaybe<Array<PaiPortfolioReport_Bool_Exp_>>;
  _not?: InputMaybe<PaiPortfolioReport_Bool_Exp_>;
  _or?: InputMaybe<Array<PaiPortfolioReport_Bool_Exp_>>;
  contactPerson?: InputMaybe<Users_Bool_Exp_>;
  contactPersonId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  dueDate?: InputMaybe<Date_Comparison_Exp_>;
  dueDates?: InputMaybe<Jsonb_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  portfolio?: InputMaybe<Portfolio_Bool_Exp_>;
  portfolioId?: InputMaybe<Uuid_Comparison_Exp_>;
  quarter?: InputMaybe<QuarterEnum_Enum_Comparison_Exp_>;
  reportingPeriod?: InputMaybe<Date_Comparison_Exp_>;
  selectedIndicators?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
  selectedIndicators_aggregate?: InputMaybe<PaiReportIndicator_Aggregate_Bool_Exp_>;
  sendOutDates?: InputMaybe<Jsonb_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  year?: InputMaybe<Int_Comparison_Exp_>;
};

/** unique or primary key constraints on table "PaiPortfolioReport" */
export enum PaiPortfolioReport_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  PaiPortfolioReportPkey_ = 'PaiPortfolioReport_pkey',
  /** unique or primary key constraint on columns "portfolioId", "reportingPeriod" */
  PaiPortfolioReportPortfolioIdReportingPeriodKey_ = 'PaiPortfolioReport_portfolioId_reportingPeriod_key',
  /** unique or primary key constraint on columns "portfolioId", "quarter", "year" */
  PaiPortfolioReportPortfolioIdYearQuarterKey_ = 'PaiPortfolioReport_portfolioId_year_quarter_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PaiPortfolioReport_Delete_At_Path_Input_ = {
  dueDates?: InputMaybe<Array<Scalars['String']['input']>>;
  sendOutDates?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PaiPortfolioReport_Delete_Elem_Input_ = {
  dueDates?: InputMaybe<Scalars['Int']['input']>;
  sendOutDates?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PaiPortfolioReport_Delete_Key_Input_ = {
  dueDates?: InputMaybe<Scalars['String']['input']>;
  sendOutDates?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "PaiPortfolioReport" */
export type PaiPortfolioReport_Inc_Input_ = {
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "PaiPortfolioReport" */
export type PaiPortfolioReport_Insert_Input_ = {
  contactPerson?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  contactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Deprecated. Use the "dueDates" field to indicate the due dates per quarter instead. */
  dueDate?: InputMaybe<Scalars['date']['input']>;
  dueDates?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolio?: InputMaybe<Portfolio_Obj_Rel_Insert_Input_>;
  portfolioId?: InputMaybe<Scalars['uuid']['input']>;
  quarter?: InputMaybe<QuarterEnum_Enum_>;
  /** Deprecated. Use the "year" column instead. */
  reportingPeriod?: InputMaybe<Scalars['date']['input']>;
  selectedIndicators?: InputMaybe<PaiReportIndicator_Arr_Rel_Insert_Input_>;
  sendOutDates?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type PaiPortfolioReport_Max_Fields_ = {
  __typename?: 'PaiPortfolioReport_max_fields';
  contactPersonId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** Deprecated. Use the "dueDates" field to indicate the due dates per quarter instead. */
  dueDate?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  portfolioId?: Maybe<Scalars['uuid']['output']>;
  /** Deprecated. Use the "year" column instead. */
  reportingPeriod?: Maybe<Scalars['date']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "PaiPortfolioReport" */
export type PaiPortfolioReport_Max_Order_By_ = {
  contactPersonId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  /** Deprecated. Use the "dueDates" field to indicate the due dates per quarter instead. */
  dueDate?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  portfolioId?: InputMaybe<Order_By_>;
  /** Deprecated. Use the "year" column instead. */
  reportingPeriod?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type PaiPortfolioReport_Min_Fields_ = {
  __typename?: 'PaiPortfolioReport_min_fields';
  contactPersonId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** Deprecated. Use the "dueDates" field to indicate the due dates per quarter instead. */
  dueDate?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  portfolioId?: Maybe<Scalars['uuid']['output']>;
  /** Deprecated. Use the "year" column instead. */
  reportingPeriod?: Maybe<Scalars['date']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "PaiPortfolioReport" */
export type PaiPortfolioReport_Min_Order_By_ = {
  contactPersonId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  /** Deprecated. Use the "dueDates" field to indicate the due dates per quarter instead. */
  dueDate?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  portfolioId?: InputMaybe<Order_By_>;
  /** Deprecated. Use the "year" column instead. */
  reportingPeriod?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "PaiPortfolioReport" */
export type PaiPortfolioReport_Mutation_Response_ = {
  __typename?: 'PaiPortfolioReport_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PaiPortfolioReport_>;
};

/** input type for inserting object relation for remote table "PaiPortfolioReport" */
export type PaiPortfolioReport_Obj_Rel_Insert_Input_ = {
  data: PaiPortfolioReport_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<PaiPortfolioReport_On_Conflict_>;
};

/** on_conflict condition type for table "PaiPortfolioReport" */
export type PaiPortfolioReport_On_Conflict_ = {
  constraint: PaiPortfolioReport_Constraint_;
  update_columns?: Array<PaiPortfolioReport_Update_Column_>;
  where?: InputMaybe<PaiPortfolioReport_Bool_Exp_>;
};

/** Ordering options when selecting data from "PaiPortfolioReport". */
export type PaiPortfolioReport_Order_By_ = {
  contactPerson?: InputMaybe<Users_Order_By_>;
  contactPersonId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  dueDate?: InputMaybe<Order_By_>;
  dueDates?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  portfolio?: InputMaybe<Portfolio_Order_By_>;
  portfolioId?: InputMaybe<Order_By_>;
  quarter?: InputMaybe<Order_By_>;
  reportingPeriod?: InputMaybe<Order_By_>;
  selectedIndicators_aggregate?: InputMaybe<PaiReportIndicator_Aggregate_Order_By_>;
  sendOutDates?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: PaiPortfolioReport */
export type PaiPortfolioReport_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PaiPortfolioReport_Prepend_Input_ = {
  dueDates?: InputMaybe<Scalars['jsonb']['input']>;
  sendOutDates?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "PaiPortfolioReport" */
export enum PaiPortfolioReport_Select_Column_ {
  /** column name */
  ContactPersonId_ = 'contactPersonId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DueDate_ = 'dueDate',
  /** column name */
  DueDates_ = 'dueDates',
  /** column name */
  Id_ = 'id',
  /** column name */
  PortfolioId_ = 'portfolioId',
  /** column name */
  Quarter_ = 'quarter',
  /** column name */
  ReportingPeriod_ = 'reportingPeriod',
  /** column name */
  SendOutDates_ = 'sendOutDates',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Year_ = 'year'
}

/** input type for updating data in table "PaiPortfolioReport" */
export type PaiPortfolioReport_Set_Input_ = {
  contactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Deprecated. Use the "dueDates" field to indicate the due dates per quarter instead. */
  dueDate?: InputMaybe<Scalars['date']['input']>;
  dueDates?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolioId?: InputMaybe<Scalars['uuid']['input']>;
  quarter?: InputMaybe<QuarterEnum_Enum_>;
  /** Deprecated. Use the "year" column instead. */
  reportingPeriod?: InputMaybe<Scalars['date']['input']>;
  sendOutDates?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type PaiPortfolioReport_Stddev_Fields_ = {
  __typename?: 'PaiPortfolioReport_stddev_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "PaiPortfolioReport" */
export type PaiPortfolioReport_Stddev_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type PaiPortfolioReport_Stddev_Pop_Fields_ = {
  __typename?: 'PaiPortfolioReport_stddev_pop_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "PaiPortfolioReport" */
export type PaiPortfolioReport_Stddev_Pop_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type PaiPortfolioReport_Stddev_Samp_Fields_ = {
  __typename?: 'PaiPortfolioReport_stddev_samp_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "PaiPortfolioReport" */
export type PaiPortfolioReport_Stddev_Samp_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "PaiPortfolioReport" */
export type PaiPortfolioReport_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: PaiPortfolioReport_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type PaiPortfolioReport_Stream_Cursor_Value_Input_ = {
  contactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Deprecated. Use the "dueDates" field to indicate the due dates per quarter instead. */
  dueDate?: InputMaybe<Scalars['date']['input']>;
  dueDates?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolioId?: InputMaybe<Scalars['uuid']['input']>;
  quarter?: InputMaybe<QuarterEnum_Enum_>;
  /** Deprecated. Use the "year" column instead. */
  reportingPeriod?: InputMaybe<Scalars['date']['input']>;
  sendOutDates?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type PaiPortfolioReport_Sum_Fields_ = {
  __typename?: 'PaiPortfolioReport_sum_fields';
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "PaiPortfolioReport" */
export type PaiPortfolioReport_Sum_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** update columns of table "PaiPortfolioReport" */
export enum PaiPortfolioReport_Update_Column_ {
  /** column name */
  ContactPersonId_ = 'contactPersonId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DueDate_ = 'dueDate',
  /** column name */
  DueDates_ = 'dueDates',
  /** column name */
  Id_ = 'id',
  /** column name */
  PortfolioId_ = 'portfolioId',
  /** column name */
  Quarter_ = 'quarter',
  /** column name */
  ReportingPeriod_ = 'reportingPeriod',
  /** column name */
  SendOutDates_ = 'sendOutDates',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Year_ = 'year'
}

export type PaiPortfolioReport_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PaiPortfolioReport_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PaiPortfolioReport_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PaiPortfolioReport_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PaiPortfolioReport_Delete_Key_Input_>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PaiPortfolioReport_Inc_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PaiPortfolioReport_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaiPortfolioReport_Set_Input_>;
  /** filter the rows which have to be updated */
  where: PaiPortfolioReport_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type PaiPortfolioReport_Var_Pop_Fields_ = {
  __typename?: 'PaiPortfolioReport_var_pop_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "PaiPortfolioReport" */
export type PaiPortfolioReport_Var_Pop_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type PaiPortfolioReport_Var_Samp_Fields_ = {
  __typename?: 'PaiPortfolioReport_var_samp_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "PaiPortfolioReport" */
export type PaiPortfolioReport_Var_Samp_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type PaiPortfolioReport_Variance_Fields_ = {
  __typename?: 'PaiPortfolioReport_variance_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "PaiPortfolioReport" */
export type PaiPortfolioReport_Variance_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** columns and relationships of "PaiReportIndicator" */
export type PaiReportIndicator_ = {
  __typename?: 'PaiReportIndicator';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  indicator: PaiTableIndicator_;
  isForAllCompanies: Scalars['Boolean']['output'];
  isNew: Scalars['Boolean']['output'];
  /** An object relationship */
  paiPortfolioReport: PaiPortfolioReport_;
  paiPortfolioReportId: Scalars['uuid']['output'];
  /** An array relationship */
  paiReportIndicatorPortfolioCompanies: Array<PaiReportIndicatorPortfolioCompany_>;
  /** An aggregate relationship */
  paiReportIndicatorPortfolioCompanies_aggregate: PaiReportIndicatorPortfolioCompany_Aggregate_;
  paiTableIndicatorReference: Scalars['String']['output'];
  periods?: Maybe<Scalars['jsonb']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "PaiReportIndicator" */
export type PaiReportIndicatorPaiReportIndicatorPortfolioCompaniesArgs_ = {
  distinct_on?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Order_By_>>;
  where?: InputMaybe<PaiReportIndicatorPortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "PaiReportIndicator" */
export type PaiReportIndicatorPaiReportIndicatorPortfolioCompanies_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Order_By_>>;
  where?: InputMaybe<PaiReportIndicatorPortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "PaiReportIndicator" */
export type PaiReportIndicatorPeriodsArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "PaiReportIndicatorPortfolioCompany" */
export type PaiReportIndicatorPortfolioCompany_ = {
  __typename?: 'PaiReportIndicatorPortfolioCompany';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  paiReportIndicator?: Maybe<PaiReportIndicator_>;
  paiReportIndicatorId: Scalars['uuid']['output'];
  /** An object relationship */
  portfolioCompany?: Maybe<PortfolioCompany_>;
  portfolioCompanyId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "PaiReportIndicatorPortfolioCompany" */
export type PaiReportIndicatorPortfolioCompany_Aggregate_ = {
  __typename?: 'PaiReportIndicatorPortfolioCompany_aggregate';
  aggregate?: Maybe<PaiReportIndicatorPortfolioCompany_Aggregate_Fields_>;
  nodes: Array<PaiReportIndicatorPortfolioCompany_>;
};

export type PaiReportIndicatorPortfolioCompany_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<PaiReportIndicatorPortfolioCompany_Aggregate_Bool_Exp_Count_>;
};

export type PaiReportIndicatorPortfolioCompany_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PaiReportIndicatorPortfolioCompany_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "PaiReportIndicatorPortfolioCompany" */
export type PaiReportIndicatorPortfolioCompany_Aggregate_Fields_ = {
  __typename?: 'PaiReportIndicatorPortfolioCompany_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PaiReportIndicatorPortfolioCompany_Max_Fields_>;
  min?: Maybe<PaiReportIndicatorPortfolioCompany_Min_Fields_>;
};


/** aggregate fields of "PaiReportIndicatorPortfolioCompany" */
export type PaiReportIndicatorPortfolioCompany_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "PaiReportIndicatorPortfolioCompany" */
export type PaiReportIndicatorPortfolioCompany_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<PaiReportIndicatorPortfolioCompany_Max_Order_By_>;
  min?: InputMaybe<PaiReportIndicatorPortfolioCompany_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "PaiReportIndicatorPortfolioCompany" */
export type PaiReportIndicatorPortfolioCompany_Arr_Rel_Insert_Input_ = {
  data: Array<PaiReportIndicatorPortfolioCompany_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<PaiReportIndicatorPortfolioCompany_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "PaiReportIndicatorPortfolioCompany". All fields are combined with a logical 'AND'. */
export type PaiReportIndicatorPortfolioCompany_Bool_Exp_ = {
  _and?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Bool_Exp_>>;
  _not?: InputMaybe<PaiReportIndicatorPortfolioCompany_Bool_Exp_>;
  _or?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  paiReportIndicator?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
  paiReportIndicatorId?: InputMaybe<Uuid_Comparison_Exp_>;
  portfolioCompany?: InputMaybe<PortfolioCompany_Bool_Exp_>;
  portfolioCompanyId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "PaiReportIndicatorPortfolioCompany" */
export enum PaiReportIndicatorPortfolioCompany_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  PaiReportIndicatorPortfolioCompanyIdKey_ = 'PaiReportIndicatorPortfolioCompany_id_key',
  /** unique or primary key constraint on columns "id" */
  PaiReportIndicatorPortfolioCompanyPkey_ = 'PaiReportIndicatorPortfolioCompany_pkey',
  /** unique or primary key constraint on columns "paiReportIndicatorId", "portfolioCompanyId" */
  PaiReportIndicatorPortfolioCompanyPortfolioCompanyIdPaiReport_ = 'PaiReportIndicatorPortfolioCompany_portfolioCompanyId_paiReport'
}

/** input type for inserting data into table "PaiReportIndicatorPortfolioCompany" */
export type PaiReportIndicatorPortfolioCompany_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  paiReportIndicator?: InputMaybe<PaiReportIndicator_Obj_Rel_Insert_Input_>;
  paiReportIndicatorId?: InputMaybe<Scalars['uuid']['input']>;
  portfolioCompany?: InputMaybe<PortfolioCompany_Obj_Rel_Insert_Input_>;
  portfolioCompanyId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PaiReportIndicatorPortfolioCompany_Max_Fields_ = {
  __typename?: 'PaiReportIndicatorPortfolioCompany_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  paiReportIndicatorId?: Maybe<Scalars['uuid']['output']>;
  portfolioCompanyId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "PaiReportIndicatorPortfolioCompany" */
export type PaiReportIndicatorPortfolioCompany_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  paiReportIndicatorId?: InputMaybe<Order_By_>;
  portfolioCompanyId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type PaiReportIndicatorPortfolioCompany_Min_Fields_ = {
  __typename?: 'PaiReportIndicatorPortfolioCompany_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  paiReportIndicatorId?: Maybe<Scalars['uuid']['output']>;
  portfolioCompanyId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "PaiReportIndicatorPortfolioCompany" */
export type PaiReportIndicatorPortfolioCompany_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  paiReportIndicatorId?: InputMaybe<Order_By_>;
  portfolioCompanyId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "PaiReportIndicatorPortfolioCompany" */
export type PaiReportIndicatorPortfolioCompany_Mutation_Response_ = {
  __typename?: 'PaiReportIndicatorPortfolioCompany_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PaiReportIndicatorPortfolioCompany_>;
};

/** on_conflict condition type for table "PaiReportIndicatorPortfolioCompany" */
export type PaiReportIndicatorPortfolioCompany_On_Conflict_ = {
  constraint: PaiReportIndicatorPortfolioCompany_Constraint_;
  update_columns?: Array<PaiReportIndicatorPortfolioCompany_Update_Column_>;
  where?: InputMaybe<PaiReportIndicatorPortfolioCompany_Bool_Exp_>;
};

/** Ordering options when selecting data from "PaiReportIndicatorPortfolioCompany". */
export type PaiReportIndicatorPortfolioCompany_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  paiReportIndicator?: InputMaybe<PaiReportIndicator_Order_By_>;
  paiReportIndicatorId?: InputMaybe<Order_By_>;
  portfolioCompany?: InputMaybe<PortfolioCompany_Order_By_>;
  portfolioCompanyId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: PaiReportIndicatorPortfolioCompany */
export type PaiReportIndicatorPortfolioCompany_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "PaiReportIndicatorPortfolioCompany" */
export enum PaiReportIndicatorPortfolioCompany_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  PaiReportIndicatorId_ = 'paiReportIndicatorId',
  /** column name */
  PortfolioCompanyId_ = 'portfolioCompanyId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "PaiReportIndicatorPortfolioCompany" */
export type PaiReportIndicatorPortfolioCompany_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  paiReportIndicatorId?: InputMaybe<Scalars['uuid']['input']>;
  portfolioCompanyId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "PaiReportIndicatorPortfolioCompany" */
export type PaiReportIndicatorPortfolioCompany_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: PaiReportIndicatorPortfolioCompany_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type PaiReportIndicatorPortfolioCompany_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  paiReportIndicatorId?: InputMaybe<Scalars['uuid']['input']>;
  portfolioCompanyId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "PaiReportIndicatorPortfolioCompany" */
export enum PaiReportIndicatorPortfolioCompany_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  PaiReportIndicatorId_ = 'paiReportIndicatorId',
  /** column name */
  PortfolioCompanyId_ = 'portfolioCompanyId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type PaiReportIndicatorPortfolioCompany_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaiReportIndicatorPortfolioCompany_Set_Input_>;
  /** filter the rows which have to be updated */
  where: PaiReportIndicatorPortfolioCompany_Bool_Exp_;
};

/** aggregated selection of "PaiReportIndicator" */
export type PaiReportIndicator_Aggregate_ = {
  __typename?: 'PaiReportIndicator_aggregate';
  aggregate?: Maybe<PaiReportIndicator_Aggregate_Fields_>;
  nodes: Array<PaiReportIndicator_>;
};

export type PaiReportIndicator_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<PaiReportIndicator_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<PaiReportIndicator_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<PaiReportIndicator_Aggregate_Bool_Exp_Count_>;
};

export type PaiReportIndicator_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: PaiReportIndicator_Select_Column_PaiReportIndicator_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type PaiReportIndicator_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: PaiReportIndicator_Select_Column_PaiReportIndicator_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type PaiReportIndicator_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<PaiReportIndicator_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "PaiReportIndicator" */
export type PaiReportIndicator_Aggregate_Fields_ = {
  __typename?: 'PaiReportIndicator_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PaiReportIndicator_Max_Fields_>;
  min?: Maybe<PaiReportIndicator_Min_Fields_>;
};


/** aggregate fields of "PaiReportIndicator" */
export type PaiReportIndicator_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<PaiReportIndicator_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "PaiReportIndicator" */
export type PaiReportIndicator_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<PaiReportIndicator_Max_Order_By_>;
  min?: InputMaybe<PaiReportIndicator_Min_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PaiReportIndicator_Append_Input_ = {
  periods?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "PaiReportIndicator" */
export type PaiReportIndicator_Arr_Rel_Insert_Input_ = {
  data: Array<PaiReportIndicator_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<PaiReportIndicator_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "PaiReportIndicator". All fields are combined with a logical 'AND'. */
export type PaiReportIndicator_Bool_Exp_ = {
  _and?: InputMaybe<Array<PaiReportIndicator_Bool_Exp_>>;
  _not?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
  _or?: InputMaybe<Array<PaiReportIndicator_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  indicator?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
  isForAllCompanies?: InputMaybe<Boolean_Comparison_Exp_>;
  isNew?: InputMaybe<Boolean_Comparison_Exp_>;
  paiPortfolioReport?: InputMaybe<PaiPortfolioReport_Bool_Exp_>;
  paiPortfolioReportId?: InputMaybe<Uuid_Comparison_Exp_>;
  paiReportIndicatorPortfolioCompanies?: InputMaybe<PaiReportIndicatorPortfolioCompany_Bool_Exp_>;
  paiReportIndicatorPortfolioCompanies_aggregate?: InputMaybe<PaiReportIndicatorPortfolioCompany_Aggregate_Bool_Exp_>;
  paiTableIndicatorReference?: InputMaybe<String_Comparison_Exp_>;
  periods?: InputMaybe<Jsonb_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "PaiReportIndicator" */
export enum PaiReportIndicator_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  PaiReportIndicatorIdKey_ = 'PaiReportIndicator_id_key',
  /** unique or primary key constraint on columns "paiPortfolioReportId", "paiTableIndicatorReference" */
  PaiReportIndicatorPaiPortfolioReportIdPaiTableIndicatorRefere_ = 'PaiReportIndicator_paiPortfolioReportId_paiTableIndicatorRefere',
  /** unique or primary key constraint on columns "id" */
  PaiReportIndicatorPkey_ = 'PaiReportIndicator_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PaiReportIndicator_Delete_At_Path_Input_ = {
  periods?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PaiReportIndicator_Delete_Elem_Input_ = {
  periods?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PaiReportIndicator_Delete_Key_Input_ = {
  periods?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "PaiReportIndicator" */
export type PaiReportIndicator_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  indicator?: InputMaybe<PaiTableIndicator_Obj_Rel_Insert_Input_>;
  isForAllCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  paiPortfolioReport?: InputMaybe<PaiPortfolioReport_Obj_Rel_Insert_Input_>;
  paiPortfolioReportId?: InputMaybe<Scalars['uuid']['input']>;
  paiReportIndicatorPortfolioCompanies?: InputMaybe<PaiReportIndicatorPortfolioCompany_Arr_Rel_Insert_Input_>;
  paiTableIndicatorReference?: InputMaybe<Scalars['String']['input']>;
  periods?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PaiReportIndicator_Max_Fields_ = {
  __typename?: 'PaiReportIndicator_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  paiPortfolioReportId?: Maybe<Scalars['uuid']['output']>;
  paiTableIndicatorReference?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "PaiReportIndicator" */
export type PaiReportIndicator_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  paiPortfolioReportId?: InputMaybe<Order_By_>;
  paiTableIndicatorReference?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type PaiReportIndicator_Min_Fields_ = {
  __typename?: 'PaiReportIndicator_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  paiPortfolioReportId?: Maybe<Scalars['uuid']['output']>;
  paiTableIndicatorReference?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "PaiReportIndicator" */
export type PaiReportIndicator_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  paiPortfolioReportId?: InputMaybe<Order_By_>;
  paiTableIndicatorReference?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "PaiReportIndicator" */
export type PaiReportIndicator_Mutation_Response_ = {
  __typename?: 'PaiReportIndicator_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PaiReportIndicator_>;
};

/** input type for inserting object relation for remote table "PaiReportIndicator" */
export type PaiReportIndicator_Obj_Rel_Insert_Input_ = {
  data: PaiReportIndicator_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<PaiReportIndicator_On_Conflict_>;
};

/** on_conflict condition type for table "PaiReportIndicator" */
export type PaiReportIndicator_On_Conflict_ = {
  constraint: PaiReportIndicator_Constraint_;
  update_columns?: Array<PaiReportIndicator_Update_Column_>;
  where?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
};

/** Ordering options when selecting data from "PaiReportIndicator". */
export type PaiReportIndicator_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  indicator?: InputMaybe<PaiTableIndicator_Order_By_>;
  isForAllCompanies?: InputMaybe<Order_By_>;
  isNew?: InputMaybe<Order_By_>;
  paiPortfolioReport?: InputMaybe<PaiPortfolioReport_Order_By_>;
  paiPortfolioReportId?: InputMaybe<Order_By_>;
  paiReportIndicatorPortfolioCompanies_aggregate?: InputMaybe<PaiReportIndicatorPortfolioCompany_Aggregate_Order_By_>;
  paiTableIndicatorReference?: InputMaybe<Order_By_>;
  periods?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: PaiReportIndicator */
export type PaiReportIndicator_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PaiReportIndicator_Prepend_Input_ = {
  periods?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "PaiReportIndicator" */
export enum PaiReportIndicator_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsForAllCompanies_ = 'isForAllCompanies',
  /** column name */
  IsNew_ = 'isNew',
  /** column name */
  PaiPortfolioReportId_ = 'paiPortfolioReportId',
  /** column name */
  PaiTableIndicatorReference_ = 'paiTableIndicatorReference',
  /** column name */
  Periods_ = 'periods',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "PaiReportIndicator_aggregate_bool_exp_bool_and_arguments_columns" columns of table "PaiReportIndicator" */
export enum PaiReportIndicator_Select_Column_PaiReportIndicator_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsForAllCompanies_ = 'isForAllCompanies',
  /** column name */
  IsNew_ = 'isNew'
}

/** select "PaiReportIndicator_aggregate_bool_exp_bool_or_arguments_columns" columns of table "PaiReportIndicator" */
export enum PaiReportIndicator_Select_Column_PaiReportIndicator_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsForAllCompanies_ = 'isForAllCompanies',
  /** column name */
  IsNew_ = 'isNew'
}

/** input type for updating data in table "PaiReportIndicator" */
export type PaiReportIndicator_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isForAllCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  paiPortfolioReportId?: InputMaybe<Scalars['uuid']['input']>;
  paiTableIndicatorReference?: InputMaybe<Scalars['String']['input']>;
  periods?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "PaiReportIndicator" */
export type PaiReportIndicator_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: PaiReportIndicator_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type PaiReportIndicator_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isForAllCompanies?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  paiPortfolioReportId?: InputMaybe<Scalars['uuid']['input']>;
  paiTableIndicatorReference?: InputMaybe<Scalars['String']['input']>;
  periods?: InputMaybe<Scalars['jsonb']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "PaiReportIndicator" */
export enum PaiReportIndicator_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsForAllCompanies_ = 'isForAllCompanies',
  /** column name */
  IsNew_ = 'isNew',
  /** column name */
  PaiPortfolioReportId_ = 'paiPortfolioReportId',
  /** column name */
  PaiTableIndicatorReference_ = 'paiTableIndicatorReference',
  /** column name */
  Periods_ = 'periods',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type PaiReportIndicator_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PaiReportIndicator_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PaiReportIndicator_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PaiReportIndicator_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PaiReportIndicator_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PaiReportIndicator_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaiReportIndicator_Set_Input_>;
  /** filter the rows which have to be updated */
  where: PaiReportIndicator_Bool_Exp_;
};

/** PAI tables (ask Jade) */
export type PaiTable_ = {
  __typename?: 'PaiTable';
  /** An array relationship */
  categories: Array<PaiCategory_>;
  /** An aggregate relationship */
  categories_aggregate: PaiCategory_Aggregate_;
  isCustom: Scalars['Boolean']['output'];
  isMandatory: Scalars['Boolean']['output'];
  reference: Scalars['String']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


/** PAI tables (ask Jade) */
export type PaiTableCategoriesArgs_ = {
  distinct_on?: InputMaybe<Array<PaiCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiCategory_Order_By_>>;
  where?: InputMaybe<PaiCategory_Bool_Exp_>;
};


/** PAI tables (ask Jade) */
export type PaiTableCategories_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiCategory_Order_By_>>;
  where?: InputMaybe<PaiCategory_Bool_Exp_>;
};

/** Indicator in PAI table category (ex: GHG emissions) */
export type PaiTableIndicator_ = {
  __typename?: 'PaiTableIndicator';
  /** An object relationship */
  category: PaiCategory_;
  categoryReference: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  investorMetrics: Array<IndicatorToInvestorMetric_>;
  /** An aggregate relationship */
  investorMetrics_aggregate: IndicatorToInvestorMetric_Aggregate_;
  isHidden: Scalars['Boolean']['output'];
  order?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  /** An array relationship */
  reports: Array<PaiReportIndicator_>;
  /** An aggregate relationship */
  reports_aggregate: PaiReportIndicator_Aggregate_;
  title: Scalars['String']['output'];
};


/** Indicator in PAI table category (ex: GHG emissions) */
export type PaiTableIndicatorInvestorMetricsArgs_ = {
  distinct_on?: InputMaybe<Array<IndicatorToInvestorMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorToInvestorMetric_Order_By_>>;
  where?: InputMaybe<IndicatorToInvestorMetric_Bool_Exp_>;
};


/** Indicator in PAI table category (ex: GHG emissions) */
export type PaiTableIndicatorInvestorMetrics_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<IndicatorToInvestorMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorToInvestorMetric_Order_By_>>;
  where?: InputMaybe<IndicatorToInvestorMetric_Bool_Exp_>;
};


/** Indicator in PAI table category (ex: GHG emissions) */
export type PaiTableIndicatorReportsArgs_ = {
  distinct_on?: InputMaybe<Array<PaiReportIndicator_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiReportIndicator_Order_By_>>;
  where?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
};


/** Indicator in PAI table category (ex: GHG emissions) */
export type PaiTableIndicatorReports_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiReportIndicator_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiReportIndicator_Order_By_>>;
  where?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
};

/** aggregated selection of "PaiTableIndicator" */
export type PaiTableIndicator_Aggregate_ = {
  __typename?: 'PaiTableIndicator_aggregate';
  aggregate?: Maybe<PaiTableIndicator_Aggregate_Fields_>;
  nodes: Array<PaiTableIndicator_>;
};

export type PaiTableIndicator_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<PaiTableIndicator_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<PaiTableIndicator_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<PaiTableIndicator_Aggregate_Bool_Exp_Count_>;
};

export type PaiTableIndicator_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: PaiTableIndicator_Select_Column_PaiTableIndicator_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type PaiTableIndicator_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: PaiTableIndicator_Select_Column_PaiTableIndicator_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type PaiTableIndicator_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<PaiTableIndicator_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "PaiTableIndicator" */
export type PaiTableIndicator_Aggregate_Fields_ = {
  __typename?: 'PaiTableIndicator_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PaiTableIndicator_Max_Fields_>;
  min?: Maybe<PaiTableIndicator_Min_Fields_>;
};


/** aggregate fields of "PaiTableIndicator" */
export type PaiTableIndicator_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<PaiTableIndicator_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "PaiTableIndicator" */
export type PaiTableIndicator_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<PaiTableIndicator_Max_Order_By_>;
  min?: InputMaybe<PaiTableIndicator_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "PaiTableIndicator" */
export type PaiTableIndicator_Arr_Rel_Insert_Input_ = {
  data: Array<PaiTableIndicator_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<PaiTableIndicator_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "PaiTableIndicator". All fields are combined with a logical 'AND'. */
export type PaiTableIndicator_Bool_Exp_ = {
  _and?: InputMaybe<Array<PaiTableIndicator_Bool_Exp_>>;
  _not?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
  _or?: InputMaybe<Array<PaiTableIndicator_Bool_Exp_>>;
  category?: InputMaybe<PaiCategory_Bool_Exp_>;
  categoryReference?: InputMaybe<String_Comparison_Exp_>;
  description?: InputMaybe<String_Comparison_Exp_>;
  investorMetrics?: InputMaybe<IndicatorToInvestorMetric_Bool_Exp_>;
  investorMetrics_aggregate?: InputMaybe<IndicatorToInvestorMetric_Aggregate_Bool_Exp_>;
  isHidden?: InputMaybe<Boolean_Comparison_Exp_>;
  order?: InputMaybe<String_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  reports?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
  reports_aggregate?: InputMaybe<PaiReportIndicator_Aggregate_Bool_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "PaiTableIndicator" */
export enum PaiTableIndicator_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  PaiTableIndicatorPkey_ = 'PaiTableIndicator_pkey'
}

/** input type for inserting data into table "PaiTableIndicator" */
export type PaiTableIndicator_Insert_Input_ = {
  category?: InputMaybe<PaiCategory_Obj_Rel_Insert_Input_>;
  categoryReference?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  investorMetrics?: InputMaybe<IndicatorToInvestorMetric_Arr_Rel_Insert_Input_>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  reports?: InputMaybe<PaiReportIndicator_Arr_Rel_Insert_Input_>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type PaiTableIndicator_Max_Fields_ = {
  __typename?: 'PaiTableIndicator_max_fields';
  categoryReference?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "PaiTableIndicator" */
export type PaiTableIndicator_Max_Order_By_ = {
  categoryReference?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type PaiTableIndicator_Min_Fields_ = {
  __typename?: 'PaiTableIndicator_min_fields';
  categoryReference?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "PaiTableIndicator" */
export type PaiTableIndicator_Min_Order_By_ = {
  categoryReference?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "PaiTableIndicator" */
export type PaiTableIndicator_Mutation_Response_ = {
  __typename?: 'PaiTableIndicator_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PaiTableIndicator_>;
};

/** input type for inserting object relation for remote table "PaiTableIndicator" */
export type PaiTableIndicator_Obj_Rel_Insert_Input_ = {
  data: PaiTableIndicator_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<PaiTableIndicator_On_Conflict_>;
};

/** on_conflict condition type for table "PaiTableIndicator" */
export type PaiTableIndicator_On_Conflict_ = {
  constraint: PaiTableIndicator_Constraint_;
  update_columns?: Array<PaiTableIndicator_Update_Column_>;
  where?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
};

/** Ordering options when selecting data from "PaiTableIndicator". */
export type PaiTableIndicator_Order_By_ = {
  category?: InputMaybe<PaiCategory_Order_By_>;
  categoryReference?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  investorMetrics_aggregate?: InputMaybe<IndicatorToInvestorMetric_Aggregate_Order_By_>;
  isHidden?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  reports_aggregate?: InputMaybe<PaiReportIndicator_Aggregate_Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: PaiTableIndicator */
export type PaiTableIndicator_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "PaiTableIndicator" */
export enum PaiTableIndicator_Select_Column_ {
  /** column name */
  CategoryReference_ = 'categoryReference',
  /** column name */
  Description_ = 'description',
  /** column name */
  IsHidden_ = 'isHidden',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

/** select "PaiTableIndicator_aggregate_bool_exp_bool_and_arguments_columns" columns of table "PaiTableIndicator" */
export enum PaiTableIndicator_Select_Column_PaiTableIndicator_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsHidden_ = 'isHidden'
}

/** select "PaiTableIndicator_aggregate_bool_exp_bool_or_arguments_columns" columns of table "PaiTableIndicator" */
export enum PaiTableIndicator_Select_Column_PaiTableIndicator_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsHidden_ = 'isHidden'
}

/** input type for updating data in table "PaiTableIndicator" */
export type PaiTableIndicator_Set_Input_ = {
  categoryReference?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "PaiTableIndicator" */
export type PaiTableIndicator_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: PaiTableIndicator_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type PaiTableIndicator_Stream_Cursor_Value_Input_ = {
  categoryReference?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "PaiTableIndicator" */
export enum PaiTableIndicator_Update_Column_ {
  /** column name */
  CategoryReference_ = 'categoryReference',
  /** column name */
  Description_ = 'description',
  /** column name */
  IsHidden_ = 'isHidden',
  /** column name */
  Order_ = 'order',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

export type PaiTableIndicator_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaiTableIndicator_Set_Input_>;
  /** filter the rows which have to be updated */
  where: PaiTableIndicator_Bool_Exp_;
};

/** aggregated selection of "PaiTable" */
export type PaiTable_Aggregate_ = {
  __typename?: 'PaiTable_aggregate';
  aggregate?: Maybe<PaiTable_Aggregate_Fields_>;
  nodes: Array<PaiTable_>;
};

/** aggregate fields of "PaiTable" */
export type PaiTable_Aggregate_Fields_ = {
  __typename?: 'PaiTable_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<PaiTable_Max_Fields_>;
  min?: Maybe<PaiTable_Min_Fields_>;
};


/** aggregate fields of "PaiTable" */
export type PaiTable_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<PaiTable_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "PaiTable". All fields are combined with a logical 'AND'. */
export type PaiTable_Bool_Exp_ = {
  _and?: InputMaybe<Array<PaiTable_Bool_Exp_>>;
  _not?: InputMaybe<PaiTable_Bool_Exp_>;
  _or?: InputMaybe<Array<PaiTable_Bool_Exp_>>;
  categories?: InputMaybe<PaiCategory_Bool_Exp_>;
  categories_aggregate?: InputMaybe<PaiCategory_Aggregate_Bool_Exp_>;
  isCustom?: InputMaybe<Boolean_Comparison_Exp_>;
  isMandatory?: InputMaybe<Boolean_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  subtitle?: InputMaybe<String_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "PaiTable" */
export enum PaiTable_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  PaiTablePkey_ = 'PaiTable_pkey'
}

/** input type for inserting data into table "PaiTable" */
export type PaiTable_Insert_Input_ = {
  categories?: InputMaybe<PaiCategory_Arr_Rel_Insert_Input_>;
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type PaiTable_Max_Fields_ = {
  __typename?: 'PaiTable_max_fields';
  reference?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type PaiTable_Min_Fields_ = {
  __typename?: 'PaiTable_min_fields';
  reference?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "PaiTable" */
export type PaiTable_Mutation_Response_ = {
  __typename?: 'PaiTable_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PaiTable_>;
};

/** input type for inserting object relation for remote table "PaiTable" */
export type PaiTable_Obj_Rel_Insert_Input_ = {
  data: PaiTable_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<PaiTable_On_Conflict_>;
};

/** on_conflict condition type for table "PaiTable" */
export type PaiTable_On_Conflict_ = {
  constraint: PaiTable_Constraint_;
  update_columns?: Array<PaiTable_Update_Column_>;
  where?: InputMaybe<PaiTable_Bool_Exp_>;
};

/** Ordering options when selecting data from "PaiTable". */
export type PaiTable_Order_By_ = {
  categories_aggregate?: InputMaybe<PaiCategory_Aggregate_Order_By_>;
  isCustom?: InputMaybe<Order_By_>;
  isMandatory?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  subtitle?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: PaiTable */
export type PaiTable_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "PaiTable" */
export enum PaiTable_Select_Column_ {
  /** column name */
  IsCustom_ = 'isCustom',
  /** column name */
  IsMandatory_ = 'isMandatory',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Subtitle_ = 'subtitle',
  /** column name */
  Title_ = 'title'
}

/** input type for updating data in table "PaiTable" */
export type PaiTable_Set_Input_ = {
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "PaiTable" */
export type PaiTable_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: PaiTable_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type PaiTable_Stream_Cursor_Value_Input_ = {
  isCustom?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "PaiTable" */
export enum PaiTable_Update_Column_ {
  /** column name */
  IsCustom_ = 'isCustom',
  /** column name */
  IsMandatory_ = 'isMandatory',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Subtitle_ = 'subtitle',
  /** column name */
  Title_ = 'title'
}

export type PaiTable_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PaiTable_Set_Input_>;
  /** filter the rows which have to be updated */
  where: PaiTable_Bool_Exp_;
};

/** columns and relationships of "Portfolio" */
export type Portfolio_ = {
  __typename?: 'Portfolio';
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  ownerCompany: Company_;
  ownerCompanyId: Scalars['uuid']['output'];
  /** An array relationship */
  paiReports: Array<PaiPortfolioReport_>;
  /** An aggregate relationship */
  paiReports_aggregate: PaiPortfolioReport_Aggregate_;
  /** An array relationship */
  portfolioCompanies: Array<PortfolioCompany_>;
  /** An aggregate relationship */
  portfolioCompanies_aggregate: PortfolioCompany_Aggregate_;
  /** An array relationship */
  portfolioNonEligibleFinancials: Array<PortfolioNonEligibleFinancials_>;
  /** An aggregate relationship */
  portfolioNonEligibleFinancials_aggregate: PortfolioNonEligibleFinancials_Aggregate_;
  /** An array relationship */
  taxonomyReports: Array<TaxonomyPortfolioReport_>;
  /** An aggregate relationship */
  taxonomyReports_aggregate: TaxonomyPortfolioReport_Aggregate_;
  totalAmount: Scalars['numeric']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "Portfolio" */
export type PortfolioPaiReportsArgs_ = {
  distinct_on?: InputMaybe<Array<PaiPortfolioReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiPortfolioReport_Order_By_>>;
  where?: InputMaybe<PaiPortfolioReport_Bool_Exp_>;
};


/** columns and relationships of "Portfolio" */
export type PortfolioPaiReports_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiPortfolioReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiPortfolioReport_Order_By_>>;
  where?: InputMaybe<PaiPortfolioReport_Bool_Exp_>;
};


/** columns and relationships of "Portfolio" */
export type PortfolioPortfolioCompaniesArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "Portfolio" */
export type PortfolioPortfolioCompanies_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


/** columns and relationships of "Portfolio" */
export type PortfolioPortfolioNonEligibleFinancialsArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioNonEligibleFinancials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioNonEligibleFinancials_Order_By_>>;
  where?: InputMaybe<PortfolioNonEligibleFinancials_Bool_Exp_>;
};


/** columns and relationships of "Portfolio" */
export type PortfolioPortfolioNonEligibleFinancials_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioNonEligibleFinancials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioNonEligibleFinancials_Order_By_>>;
  where?: InputMaybe<PortfolioNonEligibleFinancials_Bool_Exp_>;
};


/** columns and relationships of "Portfolio" */
export type PortfolioTaxonomyReportsArgs_ = {
  distinct_on?: InputMaybe<Array<TaxonomyPortfolioReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaxonomyPortfolioReport_Order_By_>>;
  where?: InputMaybe<TaxonomyPortfolioReport_Bool_Exp_>;
};


/** columns and relationships of "Portfolio" */
export type PortfolioTaxonomyReports_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TaxonomyPortfolioReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaxonomyPortfolioReport_Order_By_>>;
  where?: InputMaybe<TaxonomyPortfolioReport_Bool_Exp_>;
};

export type PortfolioAgreggateInput_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  reportPeriod?: InputMaybe<ReportPeriod_>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type PortfolioCompanies_ = {
  __typename?: 'PortfolioCompanies';
  amount?: Maybe<Scalars['Int']['output']>;
  company?: Maybe<ShortCompany_>;
  id?: Maybe<Scalars['String']['output']>;
  marketValue?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  progress?: Maybe<Progress_>;
  score?: Maybe<Scores_>;
  substantialContributionProportion?: Maybe<SubstantialContributionProportion_>;
};

/** columns and relationships of "PortfolioCompany" */
export type PortfolioCompany_ = {
  __typename?: 'PortfolioCompany';
  /** An object relationship */
  cachedResult?: Maybe<CachedResult_>;
  cachedResultId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  company?: Maybe<Company_>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  contactPersonEmail?: Maybe<Scalars['String']['output']>;
  contactPersonName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount: Scalars['numeric']['output'];
  eligibilityStatus: Scalars['String']['output'];
  /** An object relationship */
  estimateCompany?: Maybe<EstimateCompany_Deprecated_>;
  estimateCompanyId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  marketValue?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  paiCompanyReport?: Maybe<PaiCompanyReport_>;
  /** An object relationship */
  paiCompanyReportQ1?: Maybe<PaiCompanyReport_>;
  /** An object relationship */
  paiCompanyReportQ2?: Maybe<PaiCompanyReport_>;
  /** An object relationship */
  paiCompanyReportQ3?: Maybe<PaiCompanyReport_>;
  /** An object relationship */
  paiCompanyReportQ4?: Maybe<PaiCompanyReport_>;
  /** An object relationship */
  portfolio: Portfolio_;
  portfolioId: Scalars['uuid']['output'];
  quarter: QuarterEnum_Enum_;
  scores?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  sharedAssessment?: Maybe<CompanyAssessment_>;
  sharedCompanyAssessmentId?: Maybe<Scalars['uuid']['output']>;
  sharedPaiCompanyReportId?: Maybe<Scalars['uuid']['output']>;
  sharedPaiCompanyReportQ1Id?: Maybe<Scalars['uuid']['output']>;
  sharedPaiCompanyReportQ2Id?: Maybe<Scalars['uuid']['output']>;
  sharedPaiCompanyReportQ3Id?: Maybe<Scalars['uuid']['output']>;
  sharedPaiCompanyReportQ4Id?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  taxonomyContactPerson?: Maybe<Users_>;
  taxonomyContactPersonId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  valueOfInvestments?: Maybe<Scalars['jsonb']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};


/** columns and relationships of "PortfolioCompany" */
export type PortfolioCompanyScoresArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "PortfolioCompany" */
export type PortfolioCompanyValueOfInvestmentsArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "PortfolioCompany" */
export type PortfolioCompany_Aggregate_ = {
  __typename?: 'PortfolioCompany_aggregate';
  aggregate?: Maybe<PortfolioCompany_Aggregate_Fields_>;
  nodes: Array<PortfolioCompany_>;
};

export type PortfolioCompany_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<PortfolioCompany_Aggregate_Bool_Exp_Count_>;
};

export type PortfolioCompany_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PortfolioCompany_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "PortfolioCompany" */
export type PortfolioCompany_Aggregate_Fields_ = {
  __typename?: 'PortfolioCompany_aggregate_fields';
  avg?: Maybe<PortfolioCompany_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<PortfolioCompany_Max_Fields_>;
  min?: Maybe<PortfolioCompany_Min_Fields_>;
  stddev?: Maybe<PortfolioCompany_Stddev_Fields_>;
  stddev_pop?: Maybe<PortfolioCompany_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<PortfolioCompany_Stddev_Samp_Fields_>;
  sum?: Maybe<PortfolioCompany_Sum_Fields_>;
  var_pop?: Maybe<PortfolioCompany_Var_Pop_Fields_>;
  var_samp?: Maybe<PortfolioCompany_Var_Samp_Fields_>;
  variance?: Maybe<PortfolioCompany_Variance_Fields_>;
};


/** aggregate fields of "PortfolioCompany" */
export type PortfolioCompany_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "PortfolioCompany" */
export type PortfolioCompany_Aggregate_Order_By_ = {
  avg?: InputMaybe<PortfolioCompany_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<PortfolioCompany_Max_Order_By_>;
  min?: InputMaybe<PortfolioCompany_Min_Order_By_>;
  stddev?: InputMaybe<PortfolioCompany_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<PortfolioCompany_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<PortfolioCompany_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<PortfolioCompany_Sum_Order_By_>;
  var_pop?: InputMaybe<PortfolioCompany_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<PortfolioCompany_Var_Samp_Order_By_>;
  variance?: InputMaybe<PortfolioCompany_Variance_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PortfolioCompany_Append_Input_ = {
  scores?: InputMaybe<Scalars['jsonb']['input']>;
  valueOfInvestments?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "PortfolioCompany" */
export type PortfolioCompany_Arr_Rel_Insert_Input_ = {
  data: Array<PortfolioCompany_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<PortfolioCompany_On_Conflict_>;
};

/** aggregate avg on columns */
export type PortfolioCompany_Avg_Fields_ = {
  __typename?: 'PortfolioCompany_avg_fields';
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: Maybe<Scalars['Float']['output']>;
  marketValue?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "PortfolioCompany" */
export type PortfolioCompany_Avg_Order_By_ = {
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: InputMaybe<Order_By_>;
  marketValue?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "PortfolioCompany". All fields are combined with a logical 'AND'. */
export type PortfolioCompany_Bool_Exp_ = {
  _and?: InputMaybe<Array<PortfolioCompany_Bool_Exp_>>;
  _not?: InputMaybe<PortfolioCompany_Bool_Exp_>;
  _or?: InputMaybe<Array<PortfolioCompany_Bool_Exp_>>;
  cachedResult?: InputMaybe<CachedResult_Bool_Exp_>;
  cachedResultId?: InputMaybe<Uuid_Comparison_Exp_>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  contactPersonEmail?: InputMaybe<String_Comparison_Exp_>;
  contactPersonName?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  deprecatedAmount?: InputMaybe<Numeric_Comparison_Exp_>;
  eligibilityStatus?: InputMaybe<String_Comparison_Exp_>;
  estimateCompany?: InputMaybe<EstimateCompany_Deprecated_Bool_Exp_>;
  estimateCompanyId?: InputMaybe<Uuid_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  marketValue?: InputMaybe<Numeric_Comparison_Exp_>;
  paiCompanyReport?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
  paiCompanyReportQ1?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
  paiCompanyReportQ2?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
  paiCompanyReportQ3?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
  paiCompanyReportQ4?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
  portfolio?: InputMaybe<Portfolio_Bool_Exp_>;
  portfolioId?: InputMaybe<Uuid_Comparison_Exp_>;
  quarter?: InputMaybe<QuarterEnum_Enum_Comparison_Exp_>;
  scores?: InputMaybe<Jsonb_Comparison_Exp_>;
  sharedAssessment?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  sharedCompanyAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  sharedPaiCompanyReportId?: InputMaybe<Uuid_Comparison_Exp_>;
  sharedPaiCompanyReportQ1Id?: InputMaybe<Uuid_Comparison_Exp_>;
  sharedPaiCompanyReportQ2Id?: InputMaybe<Uuid_Comparison_Exp_>;
  sharedPaiCompanyReportQ3Id?: InputMaybe<Uuid_Comparison_Exp_>;
  sharedPaiCompanyReportQ4Id?: InputMaybe<Uuid_Comparison_Exp_>;
  taxonomyContactPerson?: InputMaybe<Users_Bool_Exp_>;
  taxonomyContactPersonId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  valueOfInvestments?: InputMaybe<Jsonb_Comparison_Exp_>;
  year?: InputMaybe<Int_Comparison_Exp_>;
};

/** unique or primary key constraints on table "PortfolioCompany" */
export enum PortfolioCompany_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  PortfolioCompanyPkey_ = 'PortfolioCompany_pkey',
  /** unique or primary key constraint on columns "portfolioId", "quarter", "year", "companyId" */
  PortfolioCompanyPortfolioIdCompanyIdYearQuarterKey_ = 'PortfolioCompany_portfolioId_companyId_year_quarter_key',
  /** unique or primary key constraint on columns "estimateCompanyId", "portfolioId" */
  PortfolioCompanyPortfolioIdEstimateCompanyIdFd25d65dUniq_ = 'PortfolioCompany_portfolioId_estimateCompanyId_fd25d65d_uniq'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PortfolioCompany_Delete_At_Path_Input_ = {
  scores?: InputMaybe<Array<Scalars['String']['input']>>;
  valueOfInvestments?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PortfolioCompany_Delete_Elem_Input_ = {
  scores?: InputMaybe<Scalars['Int']['input']>;
  valueOfInvestments?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PortfolioCompany_Delete_Key_Input_ = {
  scores?: InputMaybe<Scalars['String']['input']>;
  valueOfInvestments?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "PortfolioCompany" */
export type PortfolioCompany_Inc_Input_ = {
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: InputMaybe<Scalars['numeric']['input']>;
  marketValue?: InputMaybe<Scalars['numeric']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "PortfolioCompany" */
export type PortfolioCompany_Insert_Input_ = {
  cachedResult?: InputMaybe<CachedResult_Obj_Rel_Insert_Input_>;
  cachedResultId?: InputMaybe<Scalars['uuid']['input']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: InputMaybe<Scalars['numeric']['input']>;
  eligibilityStatus?: InputMaybe<Scalars['String']['input']>;
  estimateCompany?: InputMaybe<EstimateCompany_Deprecated_Obj_Rel_Insert_Input_>;
  estimateCompanyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  marketValue?: InputMaybe<Scalars['numeric']['input']>;
  paiCompanyReport?: InputMaybe<PaiCompanyReport_Obj_Rel_Insert_Input_>;
  paiCompanyReportQ1?: InputMaybe<PaiCompanyReport_Obj_Rel_Insert_Input_>;
  paiCompanyReportQ2?: InputMaybe<PaiCompanyReport_Obj_Rel_Insert_Input_>;
  paiCompanyReportQ3?: InputMaybe<PaiCompanyReport_Obj_Rel_Insert_Input_>;
  paiCompanyReportQ4?: InputMaybe<PaiCompanyReport_Obj_Rel_Insert_Input_>;
  portfolio?: InputMaybe<Portfolio_Obj_Rel_Insert_Input_>;
  portfolioId?: InputMaybe<Scalars['uuid']['input']>;
  quarter?: InputMaybe<QuarterEnum_Enum_>;
  scores?: InputMaybe<Scalars['jsonb']['input']>;
  sharedAssessment?: InputMaybe<CompanyAssessment_Obj_Rel_Insert_Input_>;
  sharedCompanyAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  sharedPaiCompanyReportId?: InputMaybe<Scalars['uuid']['input']>;
  sharedPaiCompanyReportQ1Id?: InputMaybe<Scalars['uuid']['input']>;
  sharedPaiCompanyReportQ2Id?: InputMaybe<Scalars['uuid']['input']>;
  sharedPaiCompanyReportQ3Id?: InputMaybe<Scalars['uuid']['input']>;
  sharedPaiCompanyReportQ4Id?: InputMaybe<Scalars['uuid']['input']>;
  taxonomyContactPerson?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  taxonomyContactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  valueOfInvestments?: InputMaybe<Scalars['jsonb']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type PortfolioCompany_Max_Fields_ = {
  __typename?: 'PortfolioCompany_max_fields';
  cachedResultId?: Maybe<Scalars['uuid']['output']>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  contactPersonEmail?: Maybe<Scalars['String']['output']>;
  contactPersonName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: Maybe<Scalars['numeric']['output']>;
  eligibilityStatus?: Maybe<Scalars['String']['output']>;
  estimateCompanyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  marketValue?: Maybe<Scalars['numeric']['output']>;
  portfolioId?: Maybe<Scalars['uuid']['output']>;
  sharedCompanyAssessmentId?: Maybe<Scalars['uuid']['output']>;
  sharedPaiCompanyReportId?: Maybe<Scalars['uuid']['output']>;
  sharedPaiCompanyReportQ1Id?: Maybe<Scalars['uuid']['output']>;
  sharedPaiCompanyReportQ2Id?: Maybe<Scalars['uuid']['output']>;
  sharedPaiCompanyReportQ3Id?: Maybe<Scalars['uuid']['output']>;
  sharedPaiCompanyReportQ4Id?: Maybe<Scalars['uuid']['output']>;
  taxonomyContactPersonId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "PortfolioCompany" */
export type PortfolioCompany_Max_Order_By_ = {
  cachedResultId?: InputMaybe<Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  contactPersonEmail?: InputMaybe<Order_By_>;
  contactPersonName?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: InputMaybe<Order_By_>;
  eligibilityStatus?: InputMaybe<Order_By_>;
  estimateCompanyId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  marketValue?: InputMaybe<Order_By_>;
  portfolioId?: InputMaybe<Order_By_>;
  sharedCompanyAssessmentId?: InputMaybe<Order_By_>;
  sharedPaiCompanyReportId?: InputMaybe<Order_By_>;
  sharedPaiCompanyReportQ1Id?: InputMaybe<Order_By_>;
  sharedPaiCompanyReportQ2Id?: InputMaybe<Order_By_>;
  sharedPaiCompanyReportQ3Id?: InputMaybe<Order_By_>;
  sharedPaiCompanyReportQ4Id?: InputMaybe<Order_By_>;
  taxonomyContactPersonId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type PortfolioCompany_Min_Fields_ = {
  __typename?: 'PortfolioCompany_min_fields';
  cachedResultId?: Maybe<Scalars['uuid']['output']>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  contactPersonEmail?: Maybe<Scalars['String']['output']>;
  contactPersonName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: Maybe<Scalars['numeric']['output']>;
  eligibilityStatus?: Maybe<Scalars['String']['output']>;
  estimateCompanyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  marketValue?: Maybe<Scalars['numeric']['output']>;
  portfolioId?: Maybe<Scalars['uuid']['output']>;
  sharedCompanyAssessmentId?: Maybe<Scalars['uuid']['output']>;
  sharedPaiCompanyReportId?: Maybe<Scalars['uuid']['output']>;
  sharedPaiCompanyReportQ1Id?: Maybe<Scalars['uuid']['output']>;
  sharedPaiCompanyReportQ2Id?: Maybe<Scalars['uuid']['output']>;
  sharedPaiCompanyReportQ3Id?: Maybe<Scalars['uuid']['output']>;
  sharedPaiCompanyReportQ4Id?: Maybe<Scalars['uuid']['output']>;
  taxonomyContactPersonId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "PortfolioCompany" */
export type PortfolioCompany_Min_Order_By_ = {
  cachedResultId?: InputMaybe<Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  contactPersonEmail?: InputMaybe<Order_By_>;
  contactPersonName?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: InputMaybe<Order_By_>;
  eligibilityStatus?: InputMaybe<Order_By_>;
  estimateCompanyId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  marketValue?: InputMaybe<Order_By_>;
  portfolioId?: InputMaybe<Order_By_>;
  sharedCompanyAssessmentId?: InputMaybe<Order_By_>;
  sharedPaiCompanyReportId?: InputMaybe<Order_By_>;
  sharedPaiCompanyReportQ1Id?: InputMaybe<Order_By_>;
  sharedPaiCompanyReportQ2Id?: InputMaybe<Order_By_>;
  sharedPaiCompanyReportQ3Id?: InputMaybe<Order_By_>;
  sharedPaiCompanyReportQ4Id?: InputMaybe<Order_By_>;
  taxonomyContactPersonId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "PortfolioCompany" */
export type PortfolioCompany_Mutation_Response_ = {
  __typename?: 'PortfolioCompany_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PortfolioCompany_>;
};

/** input type for inserting object relation for remote table "PortfolioCompany" */
export type PortfolioCompany_Obj_Rel_Insert_Input_ = {
  data: PortfolioCompany_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<PortfolioCompany_On_Conflict_>;
};

/** on_conflict condition type for table "PortfolioCompany" */
export type PortfolioCompany_On_Conflict_ = {
  constraint: PortfolioCompany_Constraint_;
  update_columns?: Array<PortfolioCompany_Update_Column_>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};

/** Ordering options when selecting data from "PortfolioCompany". */
export type PortfolioCompany_Order_By_ = {
  cachedResult?: InputMaybe<CachedResult_Order_By_>;
  cachedResultId?: InputMaybe<Order_By_>;
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  contactPersonEmail?: InputMaybe<Order_By_>;
  contactPersonName?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deprecatedAmount?: InputMaybe<Order_By_>;
  eligibilityStatus?: InputMaybe<Order_By_>;
  estimateCompany?: InputMaybe<EstimateCompany_Deprecated_Order_By_>;
  estimateCompanyId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  marketValue?: InputMaybe<Order_By_>;
  paiCompanyReport?: InputMaybe<PaiCompanyReport_Order_By_>;
  paiCompanyReportQ1?: InputMaybe<PaiCompanyReport_Order_By_>;
  paiCompanyReportQ2?: InputMaybe<PaiCompanyReport_Order_By_>;
  paiCompanyReportQ3?: InputMaybe<PaiCompanyReport_Order_By_>;
  paiCompanyReportQ4?: InputMaybe<PaiCompanyReport_Order_By_>;
  portfolio?: InputMaybe<Portfolio_Order_By_>;
  portfolioId?: InputMaybe<Order_By_>;
  quarter?: InputMaybe<Order_By_>;
  scores?: InputMaybe<Order_By_>;
  sharedAssessment?: InputMaybe<CompanyAssessment_Order_By_>;
  sharedCompanyAssessmentId?: InputMaybe<Order_By_>;
  sharedPaiCompanyReportId?: InputMaybe<Order_By_>;
  sharedPaiCompanyReportQ1Id?: InputMaybe<Order_By_>;
  sharedPaiCompanyReportQ2Id?: InputMaybe<Order_By_>;
  sharedPaiCompanyReportQ3Id?: InputMaybe<Order_By_>;
  sharedPaiCompanyReportQ4Id?: InputMaybe<Order_By_>;
  taxonomyContactPerson?: InputMaybe<Users_Order_By_>;
  taxonomyContactPersonId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  valueOfInvestments?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: PortfolioCompany */
export type PortfolioCompany_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PortfolioCompany_Prepend_Input_ = {
  scores?: InputMaybe<Scalars['jsonb']['input']>;
  valueOfInvestments?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "PortfolioCompany" */
export enum PortfolioCompany_Select_Column_ {
  /** column name */
  CachedResultId_ = 'cachedResultId',
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  ContactPersonEmail_ = 'contactPersonEmail',
  /** column name */
  ContactPersonName_ = 'contactPersonName',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeprecatedAmount_ = 'deprecatedAmount',
  /** column name */
  EligibilityStatus_ = 'eligibilityStatus',
  /** column name */
  EstimateCompanyId_ = 'estimateCompanyId',
  /** column name */
  Id_ = 'id',
  /** column name */
  MarketValue_ = 'marketValue',
  /** column name */
  PortfolioId_ = 'portfolioId',
  /** column name */
  Quarter_ = 'quarter',
  /** column name */
  Scores_ = 'scores',
  /** column name */
  SharedCompanyAssessmentId_ = 'sharedCompanyAssessmentId',
  /** column name */
  SharedPaiCompanyReportId_ = 'sharedPaiCompanyReportId',
  /** column name */
  SharedPaiCompanyReportQ1Id_ = 'sharedPaiCompanyReportQ1Id',
  /** column name */
  SharedPaiCompanyReportQ2Id_ = 'sharedPaiCompanyReportQ2Id',
  /** column name */
  SharedPaiCompanyReportQ3Id_ = 'sharedPaiCompanyReportQ3Id',
  /** column name */
  SharedPaiCompanyReportQ4Id_ = 'sharedPaiCompanyReportQ4Id',
  /** column name */
  TaxonomyContactPersonId_ = 'taxonomyContactPersonId',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  ValueOfInvestments_ = 'valueOfInvestments',
  /** column name */
  Year_ = 'year'
}

/** input type for updating data in table "PortfolioCompany" */
export type PortfolioCompany_Set_Input_ = {
  cachedResultId?: InputMaybe<Scalars['uuid']['input']>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: InputMaybe<Scalars['numeric']['input']>;
  eligibilityStatus?: InputMaybe<Scalars['String']['input']>;
  estimateCompanyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  marketValue?: InputMaybe<Scalars['numeric']['input']>;
  portfolioId?: InputMaybe<Scalars['uuid']['input']>;
  quarter?: InputMaybe<QuarterEnum_Enum_>;
  scores?: InputMaybe<Scalars['jsonb']['input']>;
  sharedCompanyAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  sharedPaiCompanyReportId?: InputMaybe<Scalars['uuid']['input']>;
  sharedPaiCompanyReportQ1Id?: InputMaybe<Scalars['uuid']['input']>;
  sharedPaiCompanyReportQ2Id?: InputMaybe<Scalars['uuid']['input']>;
  sharedPaiCompanyReportQ3Id?: InputMaybe<Scalars['uuid']['input']>;
  sharedPaiCompanyReportQ4Id?: InputMaybe<Scalars['uuid']['input']>;
  taxonomyContactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  valueOfInvestments?: InputMaybe<Scalars['jsonb']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type PortfolioCompany_Stddev_Fields_ = {
  __typename?: 'PortfolioCompany_stddev_fields';
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: Maybe<Scalars['Float']['output']>;
  marketValue?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "PortfolioCompany" */
export type PortfolioCompany_Stddev_Order_By_ = {
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: InputMaybe<Order_By_>;
  marketValue?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type PortfolioCompany_Stddev_Pop_Fields_ = {
  __typename?: 'PortfolioCompany_stddev_pop_fields';
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: Maybe<Scalars['Float']['output']>;
  marketValue?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "PortfolioCompany" */
export type PortfolioCompany_Stddev_Pop_Order_By_ = {
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: InputMaybe<Order_By_>;
  marketValue?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type PortfolioCompany_Stddev_Samp_Fields_ = {
  __typename?: 'PortfolioCompany_stddev_samp_fields';
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: Maybe<Scalars['Float']['output']>;
  marketValue?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "PortfolioCompany" */
export type PortfolioCompany_Stddev_Samp_Order_By_ = {
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: InputMaybe<Order_By_>;
  marketValue?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "PortfolioCompany" */
export type PortfolioCompany_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: PortfolioCompany_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type PortfolioCompany_Stream_Cursor_Value_Input_ = {
  cachedResultId?: InputMaybe<Scalars['uuid']['input']>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: InputMaybe<Scalars['numeric']['input']>;
  eligibilityStatus?: InputMaybe<Scalars['String']['input']>;
  estimateCompanyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  marketValue?: InputMaybe<Scalars['numeric']['input']>;
  portfolioId?: InputMaybe<Scalars['uuid']['input']>;
  quarter?: InputMaybe<QuarterEnum_Enum_>;
  scores?: InputMaybe<Scalars['jsonb']['input']>;
  sharedCompanyAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  sharedPaiCompanyReportId?: InputMaybe<Scalars['uuid']['input']>;
  sharedPaiCompanyReportQ1Id?: InputMaybe<Scalars['uuid']['input']>;
  sharedPaiCompanyReportQ2Id?: InputMaybe<Scalars['uuid']['input']>;
  sharedPaiCompanyReportQ3Id?: InputMaybe<Scalars['uuid']['input']>;
  sharedPaiCompanyReportQ4Id?: InputMaybe<Scalars['uuid']['input']>;
  taxonomyContactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  valueOfInvestments?: InputMaybe<Scalars['jsonb']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type PortfolioCompany_Sum_Fields_ = {
  __typename?: 'PortfolioCompany_sum_fields';
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: Maybe<Scalars['numeric']['output']>;
  marketValue?: Maybe<Scalars['numeric']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "PortfolioCompany" */
export type PortfolioCompany_Sum_Order_By_ = {
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: InputMaybe<Order_By_>;
  marketValue?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** update columns of table "PortfolioCompany" */
export enum PortfolioCompany_Update_Column_ {
  /** column name */
  CachedResultId_ = 'cachedResultId',
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  ContactPersonEmail_ = 'contactPersonEmail',
  /** column name */
  ContactPersonName_ = 'contactPersonName',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeprecatedAmount_ = 'deprecatedAmount',
  /** column name */
  EligibilityStatus_ = 'eligibilityStatus',
  /** column name */
  EstimateCompanyId_ = 'estimateCompanyId',
  /** column name */
  Id_ = 'id',
  /** column name */
  MarketValue_ = 'marketValue',
  /** column name */
  PortfolioId_ = 'portfolioId',
  /** column name */
  Quarter_ = 'quarter',
  /** column name */
  Scores_ = 'scores',
  /** column name */
  SharedCompanyAssessmentId_ = 'sharedCompanyAssessmentId',
  /** column name */
  SharedPaiCompanyReportId_ = 'sharedPaiCompanyReportId',
  /** column name */
  SharedPaiCompanyReportQ1Id_ = 'sharedPaiCompanyReportQ1Id',
  /** column name */
  SharedPaiCompanyReportQ2Id_ = 'sharedPaiCompanyReportQ2Id',
  /** column name */
  SharedPaiCompanyReportQ3Id_ = 'sharedPaiCompanyReportQ3Id',
  /** column name */
  SharedPaiCompanyReportQ4Id_ = 'sharedPaiCompanyReportQ4Id',
  /** column name */
  TaxonomyContactPersonId_ = 'taxonomyContactPersonId',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  ValueOfInvestments_ = 'valueOfInvestments',
  /** column name */
  Year_ = 'year'
}

export type PortfolioCompany_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PortfolioCompany_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PortfolioCompany_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PortfolioCompany_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PortfolioCompany_Delete_Key_Input_>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PortfolioCompany_Inc_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PortfolioCompany_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PortfolioCompany_Set_Input_>;
  /** filter the rows which have to be updated */
  where: PortfolioCompany_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type PortfolioCompany_Var_Pop_Fields_ = {
  __typename?: 'PortfolioCompany_var_pop_fields';
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: Maybe<Scalars['Float']['output']>;
  marketValue?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "PortfolioCompany" */
export type PortfolioCompany_Var_Pop_Order_By_ = {
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: InputMaybe<Order_By_>;
  marketValue?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type PortfolioCompany_Var_Samp_Fields_ = {
  __typename?: 'PortfolioCompany_var_samp_fields';
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: Maybe<Scalars['Float']['output']>;
  marketValue?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "PortfolioCompany" */
export type PortfolioCompany_Var_Samp_Order_By_ = {
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: InputMaybe<Order_By_>;
  marketValue?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type PortfolioCompany_Variance_Fields_ = {
  __typename?: 'PortfolioCompany_variance_fields';
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: Maybe<Scalars['Float']['output']>;
  marketValue?: Maybe<Scalars['Float']['output']>;
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "PortfolioCompany" */
export type PortfolioCompany_Variance_Order_By_ = {
  /** Deprecated. Use the "valueOfInvestments" column to insert the value of investment per quarter instead. */
  deprecatedAmount?: InputMaybe<Order_By_>;
  marketValue?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** This table is storing the additional cash and sovereigns values (behaving like non-eligible financials) to portfolios. */
export type PortfolioNonEligibleFinancials_ = {
  __typename?: 'PortfolioNonEligibleFinancials';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isSelected: Scalars['Boolean']['output'];
  /** An object relationship */
  portfolio?: Maybe<Portfolio_>;
  portfolioId: Scalars['uuid']['output'];
  quarter: QuarterEnum_Enum_;
  type: InvestmentCategory_Enum_;
  updatedAt: Scalars['timestamptz']['output'];
  value?: Maybe<Scalars['jsonb']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};


/** This table is storing the additional cash and sovereigns values (behaving like non-eligible financials) to portfolios. */
export type PortfolioNonEligibleFinancialsValueArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Aggregate_ = {
  __typename?: 'PortfolioNonEligibleFinancials_aggregate';
  aggregate?: Maybe<PortfolioNonEligibleFinancials_Aggregate_Fields_>;
  nodes: Array<PortfolioNonEligibleFinancials_>;
};

export type PortfolioNonEligibleFinancials_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<PortfolioNonEligibleFinancials_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<PortfolioNonEligibleFinancials_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<PortfolioNonEligibleFinancials_Aggregate_Bool_Exp_Count_>;
};

export type PortfolioNonEligibleFinancials_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: PortfolioNonEligibleFinancials_Select_Column_PortfolioNonEligibleFinancials_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PortfolioNonEligibleFinancials_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type PortfolioNonEligibleFinancials_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: PortfolioNonEligibleFinancials_Select_Column_PortfolioNonEligibleFinancials_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PortfolioNonEligibleFinancials_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type PortfolioNonEligibleFinancials_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<PortfolioNonEligibleFinancials_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PortfolioNonEligibleFinancials_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Aggregate_Fields_ = {
  __typename?: 'PortfolioNonEligibleFinancials_aggregate_fields';
  avg?: Maybe<PortfolioNonEligibleFinancials_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<PortfolioNonEligibleFinancials_Max_Fields_>;
  min?: Maybe<PortfolioNonEligibleFinancials_Min_Fields_>;
  stddev?: Maybe<PortfolioNonEligibleFinancials_Stddev_Fields_>;
  stddev_pop?: Maybe<PortfolioNonEligibleFinancials_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<PortfolioNonEligibleFinancials_Stddev_Samp_Fields_>;
  sum?: Maybe<PortfolioNonEligibleFinancials_Sum_Fields_>;
  var_pop?: Maybe<PortfolioNonEligibleFinancials_Var_Pop_Fields_>;
  var_samp?: Maybe<PortfolioNonEligibleFinancials_Var_Samp_Fields_>;
  variance?: Maybe<PortfolioNonEligibleFinancials_Variance_Fields_>;
};


/** aggregate fields of "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<PortfolioNonEligibleFinancials_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Aggregate_Order_By_ = {
  avg?: InputMaybe<PortfolioNonEligibleFinancials_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<PortfolioNonEligibleFinancials_Max_Order_By_>;
  min?: InputMaybe<PortfolioNonEligibleFinancials_Min_Order_By_>;
  stddev?: InputMaybe<PortfolioNonEligibleFinancials_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<PortfolioNonEligibleFinancials_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<PortfolioNonEligibleFinancials_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<PortfolioNonEligibleFinancials_Sum_Order_By_>;
  var_pop?: InputMaybe<PortfolioNonEligibleFinancials_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<PortfolioNonEligibleFinancials_Var_Samp_Order_By_>;
  variance?: InputMaybe<PortfolioNonEligibleFinancials_Variance_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PortfolioNonEligibleFinancials_Append_Input_ = {
  value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Arr_Rel_Insert_Input_ = {
  data: Array<PortfolioNonEligibleFinancials_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<PortfolioNonEligibleFinancials_On_Conflict_>;
};

/** aggregate avg on columns */
export type PortfolioNonEligibleFinancials_Avg_Fields_ = {
  __typename?: 'PortfolioNonEligibleFinancials_avg_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Avg_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "PortfolioNonEligibleFinancials". All fields are combined with a logical 'AND'. */
export type PortfolioNonEligibleFinancials_Bool_Exp_ = {
  _and?: InputMaybe<Array<PortfolioNonEligibleFinancials_Bool_Exp_>>;
  _not?: InputMaybe<PortfolioNonEligibleFinancials_Bool_Exp_>;
  _or?: InputMaybe<Array<PortfolioNonEligibleFinancials_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isSelected?: InputMaybe<Boolean_Comparison_Exp_>;
  portfolio?: InputMaybe<Portfolio_Bool_Exp_>;
  portfolioId?: InputMaybe<Uuid_Comparison_Exp_>;
  quarter?: InputMaybe<QuarterEnum_Enum_Comparison_Exp_>;
  type?: InputMaybe<InvestmentCategory_Enum_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  value?: InputMaybe<Jsonb_Comparison_Exp_>;
  year?: InputMaybe<Int_Comparison_Exp_>;
};

/** unique or primary key constraints on table "PortfolioNonEligibleFinancials" */
export enum PortfolioNonEligibleFinancials_Constraint_ {
  /** unique or primary key constraint on columns "type", "portfolioId", "quarter", "year" */
  PortfolioNonEligibleFinancialPortfolioIdYearTypeQuarterKey_ = 'PortfolioNonEligibleFinancial_portfolioId_year_type_quarter_key',
  /** unique or primary key constraint on columns "id" */
  PortfolioNonEligibleFinancialsPkey_ = 'PortfolioNonEligibleFinancials_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PortfolioNonEligibleFinancials_Delete_At_Path_Input_ = {
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PortfolioNonEligibleFinancials_Delete_Elem_Input_ = {
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PortfolioNonEligibleFinancials_Delete_Key_Input_ = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Inc_Input_ = {
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  portfolio?: InputMaybe<Portfolio_Obj_Rel_Insert_Input_>;
  portfolioId?: InputMaybe<Scalars['uuid']['input']>;
  quarter?: InputMaybe<QuarterEnum_Enum_>;
  type?: InputMaybe<InvestmentCategory_Enum_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['jsonb']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type PortfolioNonEligibleFinancials_Max_Fields_ = {
  __typename?: 'PortfolioNonEligibleFinancials_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  portfolioId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  portfolioId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type PortfolioNonEligibleFinancials_Min_Fields_ = {
  __typename?: 'PortfolioNonEligibleFinancials_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  portfolioId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  portfolioId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Mutation_Response_ = {
  __typename?: 'PortfolioNonEligibleFinancials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PortfolioNonEligibleFinancials_>;
};

/** on_conflict condition type for table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_On_Conflict_ = {
  constraint: PortfolioNonEligibleFinancials_Constraint_;
  update_columns?: Array<PortfolioNonEligibleFinancials_Update_Column_>;
  where?: InputMaybe<PortfolioNonEligibleFinancials_Bool_Exp_>;
};

/** Ordering options when selecting data from "PortfolioNonEligibleFinancials". */
export type PortfolioNonEligibleFinancials_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isSelected?: InputMaybe<Order_By_>;
  portfolio?: InputMaybe<Portfolio_Order_By_>;
  portfolioId?: InputMaybe<Order_By_>;
  quarter?: InputMaybe<Order_By_>;
  type?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: PortfolioNonEligibleFinancials */
export type PortfolioNonEligibleFinancials_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PortfolioNonEligibleFinancials_Prepend_Input_ = {
  value?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "PortfolioNonEligibleFinancials" */
export enum PortfolioNonEligibleFinancials_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsSelected_ = 'isSelected',
  /** column name */
  PortfolioId_ = 'portfolioId',
  /** column name */
  Quarter_ = 'quarter',
  /** column name */
  Type_ = 'type',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Value_ = 'value',
  /** column name */
  Year_ = 'year'
}

/** select "PortfolioNonEligibleFinancials_aggregate_bool_exp_bool_and_arguments_columns" columns of table "PortfolioNonEligibleFinancials" */
export enum PortfolioNonEligibleFinancials_Select_Column_PortfolioNonEligibleFinancials_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsSelected_ = 'isSelected'
}

/** select "PortfolioNonEligibleFinancials_aggregate_bool_exp_bool_or_arguments_columns" columns of table "PortfolioNonEligibleFinancials" */
export enum PortfolioNonEligibleFinancials_Select_Column_PortfolioNonEligibleFinancials_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsSelected_ = 'isSelected'
}

/** input type for updating data in table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  portfolioId?: InputMaybe<Scalars['uuid']['input']>;
  quarter?: InputMaybe<QuarterEnum_Enum_>;
  type?: InputMaybe<InvestmentCategory_Enum_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['jsonb']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type PortfolioNonEligibleFinancials_Stddev_Fields_ = {
  __typename?: 'PortfolioNonEligibleFinancials_stddev_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Stddev_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type PortfolioNonEligibleFinancials_Stddev_Pop_Fields_ = {
  __typename?: 'PortfolioNonEligibleFinancials_stddev_pop_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Stddev_Pop_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type PortfolioNonEligibleFinancials_Stddev_Samp_Fields_ = {
  __typename?: 'PortfolioNonEligibleFinancials_stddev_samp_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Stddev_Samp_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: PortfolioNonEligibleFinancials_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type PortfolioNonEligibleFinancials_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isSelected?: InputMaybe<Scalars['Boolean']['input']>;
  portfolioId?: InputMaybe<Scalars['uuid']['input']>;
  quarter?: InputMaybe<QuarterEnum_Enum_>;
  type?: InputMaybe<InvestmentCategory_Enum_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['jsonb']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type PortfolioNonEligibleFinancials_Sum_Fields_ = {
  __typename?: 'PortfolioNonEligibleFinancials_sum_fields';
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Sum_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** update columns of table "PortfolioNonEligibleFinancials" */
export enum PortfolioNonEligibleFinancials_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsSelected_ = 'isSelected',
  /** column name */
  PortfolioId_ = 'portfolioId',
  /** column name */
  Quarter_ = 'quarter',
  /** column name */
  Type_ = 'type',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Value_ = 'value',
  /** column name */
  Year_ = 'year'
}

export type PortfolioNonEligibleFinancials_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PortfolioNonEligibleFinancials_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PortfolioNonEligibleFinancials_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PortfolioNonEligibleFinancials_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PortfolioNonEligibleFinancials_Delete_Key_Input_>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PortfolioNonEligibleFinancials_Inc_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PortfolioNonEligibleFinancials_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PortfolioNonEligibleFinancials_Set_Input_>;
  /** filter the rows which have to be updated */
  where: PortfolioNonEligibleFinancials_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type PortfolioNonEligibleFinancials_Var_Pop_Fields_ = {
  __typename?: 'PortfolioNonEligibleFinancials_var_pop_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Var_Pop_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type PortfolioNonEligibleFinancials_Var_Samp_Fields_ = {
  __typename?: 'PortfolioNonEligibleFinancials_var_samp_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Var_Samp_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type PortfolioNonEligibleFinancials_Variance_Fields_ = {
  __typename?: 'PortfolioNonEligibleFinancials_variance_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "PortfolioNonEligibleFinancials" */
export type PortfolioNonEligibleFinancials_Variance_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

export type PortfolioProgress_ = {
  __typename?: 'PortfolioProgress';
  financials?: Maybe<Scalars['Int']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  screening?: Maybe<Scalars['Float']['output']>;
};

export type PortfolioScore_ = {
  __typename?: 'PortfolioScore';
  capex?: Maybe<Capex_>;
  opex?: Maybe<Opex_>;
  revenue?: Maybe<Revenue_>;
};

/** aggregated selection of "Portfolio" */
export type Portfolio_Aggregate_ = {
  __typename?: 'Portfolio_aggregate';
  aggregate?: Maybe<Portfolio_Aggregate_Fields_>;
  nodes: Array<Portfolio_>;
};

export type Portfolio_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Portfolio_Aggregate_Bool_Exp_Count_>;
};

export type Portfolio_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Portfolio_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Portfolio_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "Portfolio" */
export type Portfolio_Aggregate_Fields_ = {
  __typename?: 'Portfolio_aggregate_fields';
  avg?: Maybe<Portfolio_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<Portfolio_Max_Fields_>;
  min?: Maybe<Portfolio_Min_Fields_>;
  stddev?: Maybe<Portfolio_Stddev_Fields_>;
  stddev_pop?: Maybe<Portfolio_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<Portfolio_Stddev_Samp_Fields_>;
  sum?: Maybe<Portfolio_Sum_Fields_>;
  var_pop?: Maybe<Portfolio_Var_Pop_Fields_>;
  var_samp?: Maybe<Portfolio_Var_Samp_Fields_>;
  variance?: Maybe<Portfolio_Variance_Fields_>;
};


/** aggregate fields of "Portfolio" */
export type Portfolio_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Portfolio_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Portfolio" */
export type Portfolio_Aggregate_Order_By_ = {
  avg?: InputMaybe<Portfolio_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Portfolio_Max_Order_By_>;
  min?: InputMaybe<Portfolio_Min_Order_By_>;
  stddev?: InputMaybe<Portfolio_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<Portfolio_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<Portfolio_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<Portfolio_Sum_Order_By_>;
  var_pop?: InputMaybe<Portfolio_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<Portfolio_Var_Samp_Order_By_>;
  variance?: InputMaybe<Portfolio_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "Portfolio" */
export type Portfolio_Arr_Rel_Insert_Input_ = {
  data: Array<Portfolio_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Portfolio_On_Conflict_>;
};

/** aggregate avg on columns */
export type Portfolio_Avg_Fields_ = {
  __typename?: 'Portfolio_avg_fields';
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "Portfolio" */
export type Portfolio_Avg_Order_By_ = {
  totalAmount?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "Portfolio". All fields are combined with a logical 'AND'. */
export type Portfolio_Bool_Exp_ = {
  _and?: InputMaybe<Array<Portfolio_Bool_Exp_>>;
  _not?: InputMaybe<Portfolio_Bool_Exp_>;
  _or?: InputMaybe<Array<Portfolio_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  description?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  ownerCompany?: InputMaybe<Company_Bool_Exp_>;
  ownerCompanyId?: InputMaybe<Uuid_Comparison_Exp_>;
  paiReports?: InputMaybe<PaiPortfolioReport_Bool_Exp_>;
  paiReports_aggregate?: InputMaybe<PaiPortfolioReport_Aggregate_Bool_Exp_>;
  portfolioCompanies?: InputMaybe<PortfolioCompany_Bool_Exp_>;
  portfolioCompanies_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Bool_Exp_>;
  portfolioNonEligibleFinancials?: InputMaybe<PortfolioNonEligibleFinancials_Bool_Exp_>;
  portfolioNonEligibleFinancials_aggregate?: InputMaybe<PortfolioNonEligibleFinancials_Aggregate_Bool_Exp_>;
  taxonomyReports?: InputMaybe<TaxonomyPortfolioReport_Bool_Exp_>;
  taxonomyReports_aggregate?: InputMaybe<TaxonomyPortfolioReport_Aggregate_Bool_Exp_>;
  totalAmount?: InputMaybe<Numeric_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Portfolio" */
export enum Portfolio_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  PortfolioPkey_ = 'Portfolio_pkey'
}

/** input type for incrementing numeric columns in table "Portfolio" */
export type Portfolio_Inc_Input_ = {
  totalAmount?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "Portfolio" */
export type Portfolio_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerCompany?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  ownerCompanyId?: InputMaybe<Scalars['uuid']['input']>;
  paiReports?: InputMaybe<PaiPortfolioReport_Arr_Rel_Insert_Input_>;
  portfolioCompanies?: InputMaybe<PortfolioCompany_Arr_Rel_Insert_Input_>;
  portfolioNonEligibleFinancials?: InputMaybe<PortfolioNonEligibleFinancials_Arr_Rel_Insert_Input_>;
  taxonomyReports?: InputMaybe<TaxonomyPortfolioReport_Arr_Rel_Insert_Input_>;
  totalAmount?: InputMaybe<Scalars['numeric']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Portfolio_Max_Fields_ = {
  __typename?: 'Portfolio_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerCompanyId?: Maybe<Scalars['uuid']['output']>;
  totalAmount?: Maybe<Scalars['numeric']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "Portfolio" */
export type Portfolio_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  ownerCompanyId?: InputMaybe<Order_By_>;
  totalAmount?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Portfolio_Min_Fields_ = {
  __typename?: 'Portfolio_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerCompanyId?: Maybe<Scalars['uuid']['output']>;
  totalAmount?: Maybe<Scalars['numeric']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "Portfolio" */
export type Portfolio_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  ownerCompanyId?: InputMaybe<Order_By_>;
  totalAmount?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "Portfolio" */
export type Portfolio_Mutation_Response_ = {
  __typename?: 'Portfolio_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Portfolio_>;
};

/** input type for inserting object relation for remote table "Portfolio" */
export type Portfolio_Obj_Rel_Insert_Input_ = {
  data: Portfolio_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Portfolio_On_Conflict_>;
};

/** on_conflict condition type for table "Portfolio" */
export type Portfolio_On_Conflict_ = {
  constraint: Portfolio_Constraint_;
  update_columns?: Array<Portfolio_Update_Column_>;
  where?: InputMaybe<Portfolio_Bool_Exp_>;
};

/** Ordering options when selecting data from "Portfolio". */
export type Portfolio_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  ownerCompany?: InputMaybe<Company_Order_By_>;
  ownerCompanyId?: InputMaybe<Order_By_>;
  paiReports_aggregate?: InputMaybe<PaiPortfolioReport_Aggregate_Order_By_>;
  portfolioCompanies_aggregate?: InputMaybe<PortfolioCompany_Aggregate_Order_By_>;
  portfolioNonEligibleFinancials_aggregate?: InputMaybe<PortfolioNonEligibleFinancials_Aggregate_Order_By_>;
  taxonomyReports_aggregate?: InputMaybe<TaxonomyPortfolioReport_Aggregate_Order_By_>;
  totalAmount?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Portfolio */
export type Portfolio_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "Portfolio" */
export enum Portfolio_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  Id_ = 'id',
  /** column name */
  Name_ = 'name',
  /** column name */
  OwnerCompanyId_ = 'ownerCompanyId',
  /** column name */
  TotalAmount_ = 'totalAmount',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "Portfolio" */
export type Portfolio_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerCompanyId?: InputMaybe<Scalars['uuid']['input']>;
  totalAmount?: InputMaybe<Scalars['numeric']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Portfolio_Stddev_Fields_ = {
  __typename?: 'Portfolio_stddev_fields';
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "Portfolio" */
export type Portfolio_Stddev_Order_By_ = {
  totalAmount?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type Portfolio_Stddev_Pop_Fields_ = {
  __typename?: 'Portfolio_stddev_pop_fields';
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "Portfolio" */
export type Portfolio_Stddev_Pop_Order_By_ = {
  totalAmount?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type Portfolio_Stddev_Samp_Fields_ = {
  __typename?: 'Portfolio_stddev_samp_fields';
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "Portfolio" */
export type Portfolio_Stddev_Samp_Order_By_ = {
  totalAmount?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "Portfolio" */
export type Portfolio_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Portfolio_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Portfolio_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerCompanyId?: InputMaybe<Scalars['uuid']['input']>;
  totalAmount?: InputMaybe<Scalars['numeric']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Portfolio_Sum_Fields_ = {
  __typename?: 'Portfolio_sum_fields';
  totalAmount?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "Portfolio" */
export type Portfolio_Sum_Order_By_ = {
  totalAmount?: InputMaybe<Order_By_>;
};

/** update columns of table "Portfolio" */
export enum Portfolio_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  Id_ = 'id',
  /** column name */
  Name_ = 'name',
  /** column name */
  OwnerCompanyId_ = 'ownerCompanyId',
  /** column name */
  TotalAmount_ = 'totalAmount',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Portfolio_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Portfolio_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Portfolio_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Portfolio_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type Portfolio_Var_Pop_Fields_ = {
  __typename?: 'Portfolio_var_pop_fields';
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "Portfolio" */
export type Portfolio_Var_Pop_Order_By_ = {
  totalAmount?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type Portfolio_Var_Samp_Fields_ = {
  __typename?: 'Portfolio_var_samp_fields';
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "Portfolio" */
export type Portfolio_Var_Samp_Order_By_ = {
  totalAmount?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type Portfolio_Variance_Fields_ = {
  __typename?: 'Portfolio_variance_fields';
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "Portfolio" */
export type Portfolio_Variance_Order_By_ = {
  totalAmount?: InputMaybe<Order_By_>;
};

export type Portfolios_ = {
  __typename?: 'Portfolios';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  portfolioCompanies?: Maybe<Array<Maybe<PortfolioCompanies_>>>;
  portfolioProgress?: Maybe<PortfolioProgress_>;
  portfolioScore?: Maybe<PortfolioScore_>;
  portfolioSubstantialContributionProportion?: Maybe<SubstantialContributionProportion_>;
  portfolioTotal?: Maybe<Scalars['Int']['output']>;
  totalAmount?: Maybe<Scalars['Int']['output']>;
};

export type Progress_ = {
  __typename?: 'Progress';
  financials?: Maybe<Scalars['Int']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  screening?: Maybe<Scalars['Float']['output']>;
};

export type Proportion_ = {
  __typename?: 'Proportion';
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "QuarterEnum" */
export type QuarterEnum_ = {
  __typename?: 'QuarterEnum';
  quarter: Scalars['String']['output'];
};

/** aggregated selection of "QuarterEnum" */
export type QuarterEnum_Aggregate_ = {
  __typename?: 'QuarterEnum_aggregate';
  aggregate?: Maybe<QuarterEnum_Aggregate_Fields_>;
  nodes: Array<QuarterEnum_>;
};

/** aggregate fields of "QuarterEnum" */
export type QuarterEnum_Aggregate_Fields_ = {
  __typename?: 'QuarterEnum_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<QuarterEnum_Max_Fields_>;
  min?: Maybe<QuarterEnum_Min_Fields_>;
};


/** aggregate fields of "QuarterEnum" */
export type QuarterEnum_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<QuarterEnum_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "QuarterEnum". All fields are combined with a logical 'AND'. */
export type QuarterEnum_Bool_Exp_ = {
  _and?: InputMaybe<Array<QuarterEnum_Bool_Exp_>>;
  _not?: InputMaybe<QuarterEnum_Bool_Exp_>;
  _or?: InputMaybe<Array<QuarterEnum_Bool_Exp_>>;
  quarter?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "QuarterEnum" */
export enum QuarterEnum_Constraint_ {
  /** unique or primary key constraint on columns "quarter" */
  QuarterEnumPkey_ = 'QuarterEnum_pkey'
}

export enum QuarterEnum_Enum_ {
  Q1_ = 'Q1',
  Q2_ = 'Q2',
  Q3_ = 'Q3',
  Q4_ = 'Q4'
}

/** Boolean expression to compare columns of type "QuarterEnum_enum". All fields are combined with logical 'AND'. */
export type QuarterEnum_Enum_Comparison_Exp_ = {
  _eq?: InputMaybe<QuarterEnum_Enum_>;
  _in?: InputMaybe<Array<QuarterEnum_Enum_>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<QuarterEnum_Enum_>;
  _nin?: InputMaybe<Array<QuarterEnum_Enum_>>;
};

/** input type for inserting data into table "QuarterEnum" */
export type QuarterEnum_Insert_Input_ = {
  quarter?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type QuarterEnum_Max_Fields_ = {
  __typename?: 'QuarterEnum_max_fields';
  quarter?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type QuarterEnum_Min_Fields_ = {
  __typename?: 'QuarterEnum_min_fields';
  quarter?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "QuarterEnum" */
export type QuarterEnum_Mutation_Response_ = {
  __typename?: 'QuarterEnum_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<QuarterEnum_>;
};

/** on_conflict condition type for table "QuarterEnum" */
export type QuarterEnum_On_Conflict_ = {
  constraint: QuarterEnum_Constraint_;
  update_columns?: Array<QuarterEnum_Update_Column_>;
  where?: InputMaybe<QuarterEnum_Bool_Exp_>;
};

/** Ordering options when selecting data from "QuarterEnum". */
export type QuarterEnum_Order_By_ = {
  quarter?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: QuarterEnum */
export type QuarterEnum_Pk_Columns_Input_ = {
  quarter: Scalars['String']['input'];
};

/** select columns of table "QuarterEnum" */
export enum QuarterEnum_Select_Column_ {
  /** column name */
  Quarter_ = 'quarter'
}

/** input type for updating data in table "QuarterEnum" */
export type QuarterEnum_Set_Input_ = {
  quarter?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "QuarterEnum" */
export type QuarterEnum_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: QuarterEnum_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type QuarterEnum_Stream_Cursor_Value_Input_ = {
  quarter?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "QuarterEnum" */
export enum QuarterEnum_Update_Column_ {
  /** column name */
  Quarter_ = 'quarter'
}

export type QuarterEnum_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QuarterEnum_Set_Input_>;
  /** filter the rows which have to be updated */
  where: QuarterEnum_Bool_Exp_;
};

/** columns and relationships of "Question" */
export type Question_ = {
  __typename?: 'Question';
  /** An array relationship */
  Answers: Array<Answer_>;
  /** An aggregate relationship */
  Answers_aggregate: Answer_Aggregate_;
  /** An object relationship */
  QuestionType: QuestionType_;
  aboutDocumentation?: Maybe<Scalars['String']['output']>;
  alignmentErrorMessage?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  choices: Array<QuestionChoice_>;
  /** An aggregate relationship */
  choices_aggregate: QuestionChoice_Aggregate_;
  createdAt: Scalars['timestamptz']['output'];
  dependencyDescription?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentationRequired: Scalars['Boolean']['output'];
  extendedDescription?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isAligned?: Maybe<Scalars['String']['output']>;
  isEditable?: Maybe<Scalars['String']['output']>;
  isRequired?: Maybe<Scalars['String']['output']>;
  isVisible?: Maybe<Scalars['String']['output']>;
  learnMoreArticleSlug?: Maybe<Scalars['String']['output']>;
  level: QuestionLevel_Enum_;
  levelExpression?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  newerRevisions: Array<QuestionRevision_>;
  /** An aggregate relationship */
  newerRevisions_aggregate: QuestionRevision_Aggregate_;
  /** An object relationship */
  objective: Objective_;
  objectiveKey: Scalars['String']['output'];
  /** An array relationship */
  olderRevisions: Array<QuestionRevision_>;
  /** An aggregate relationship */
  olderRevisions_aggregate: QuestionRevision_Aggregate_;
  orderIndex: Scalars['String']['output'];
  other?: Maybe<Scalars['jsonb']['output']>;
  /** Deprecated, use QuestionSetQuestion relationship instead */
  questionSetRef?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  questionSets: Array<QuestionSetQuestion_>;
  /** An aggregate relationship */
  questionSets_aggregate: QuestionSetQuestion_Aggregate_;
  relevantDirectives?: Maybe<Scalars['String']['output']>;
  resourceLink?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: QuestionType_Enum_;
  uniqueId: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  version: Scalars['String']['output'];
};


/** columns and relationships of "Question" */
export type QuestionAnswersArgs_ = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By_>>;
  where?: InputMaybe<Answer_Bool_Exp_>;
};


/** columns and relationships of "Question" */
export type QuestionAnswers_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By_>>;
  where?: InputMaybe<Answer_Bool_Exp_>;
};


/** columns and relationships of "Question" */
export type QuestionChoicesArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionChoice_Order_By_>>;
  where?: InputMaybe<QuestionChoice_Bool_Exp_>;
};


/** columns and relationships of "Question" */
export type QuestionChoices_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionChoice_Order_By_>>;
  where?: InputMaybe<QuestionChoice_Bool_Exp_>;
};


/** columns and relationships of "Question" */
export type QuestionNewerRevisionsArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionRevision_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionRevision_Order_By_>>;
  where?: InputMaybe<QuestionRevision_Bool_Exp_>;
};


/** columns and relationships of "Question" */
export type QuestionNewerRevisions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionRevision_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionRevision_Order_By_>>;
  where?: InputMaybe<QuestionRevision_Bool_Exp_>;
};


/** columns and relationships of "Question" */
export type QuestionOlderRevisionsArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionRevision_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionRevision_Order_By_>>;
  where?: InputMaybe<QuestionRevision_Bool_Exp_>;
};


/** columns and relationships of "Question" */
export type QuestionOlderRevisions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionRevision_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionRevision_Order_By_>>;
  where?: InputMaybe<QuestionRevision_Bool_Exp_>;
};


/** columns and relationships of "Question" */
export type QuestionOtherArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "Question" */
export type QuestionQuestionSetsArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionSetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionSetQuestion_Order_By_>>;
  where?: InputMaybe<QuestionSetQuestion_Bool_Exp_>;
};


/** columns and relationships of "Question" */
export type QuestionQuestionSets_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionSetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionSetQuestion_Order_By_>>;
  where?: InputMaybe<QuestionSetQuestion_Bool_Exp_>;
};

/** columns and relationships of "QuestionChoice" */
export type QuestionChoice_ = {
  __typename?: 'QuestionChoice';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['bigint']['output'];
  order: Scalars['String']['output'];
  /** An object relationship */
  question: Question_;
  question_id: Scalars['uuid']['output'];
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  value: Scalars['String']['output'];
};

/** aggregated selection of "QuestionChoice" */
export type QuestionChoice_Aggregate_ = {
  __typename?: 'QuestionChoice_aggregate';
  aggregate?: Maybe<QuestionChoice_Aggregate_Fields_>;
  nodes: Array<QuestionChoice_>;
};

export type QuestionChoice_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<QuestionChoice_Aggregate_Bool_Exp_Count_>;
};

export type QuestionChoice_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<QuestionChoice_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<QuestionChoice_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "QuestionChoice" */
export type QuestionChoice_Aggregate_Fields_ = {
  __typename?: 'QuestionChoice_aggregate_fields';
  avg?: Maybe<QuestionChoice_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<QuestionChoice_Max_Fields_>;
  min?: Maybe<QuestionChoice_Min_Fields_>;
  stddev?: Maybe<QuestionChoice_Stddev_Fields_>;
  stddev_pop?: Maybe<QuestionChoice_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<QuestionChoice_Stddev_Samp_Fields_>;
  sum?: Maybe<QuestionChoice_Sum_Fields_>;
  var_pop?: Maybe<QuestionChoice_Var_Pop_Fields_>;
  var_samp?: Maybe<QuestionChoice_Var_Samp_Fields_>;
  variance?: Maybe<QuestionChoice_Variance_Fields_>;
};


/** aggregate fields of "QuestionChoice" */
export type QuestionChoice_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<QuestionChoice_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "QuestionChoice" */
export type QuestionChoice_Aggregate_Order_By_ = {
  avg?: InputMaybe<QuestionChoice_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<QuestionChoice_Max_Order_By_>;
  min?: InputMaybe<QuestionChoice_Min_Order_By_>;
  stddev?: InputMaybe<QuestionChoice_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<QuestionChoice_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<QuestionChoice_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<QuestionChoice_Sum_Order_By_>;
  var_pop?: InputMaybe<QuestionChoice_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<QuestionChoice_Var_Samp_Order_By_>;
  variance?: InputMaybe<QuestionChoice_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "QuestionChoice" */
export type QuestionChoice_Arr_Rel_Insert_Input_ = {
  data: Array<QuestionChoice_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<QuestionChoice_On_Conflict_>;
};

/** aggregate avg on columns */
export type QuestionChoice_Avg_Fields_ = {
  __typename?: 'QuestionChoice_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "QuestionChoice" */
export type QuestionChoice_Avg_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "QuestionChoice". All fields are combined with a logical 'AND'. */
export type QuestionChoice_Bool_Exp_ = {
  _and?: InputMaybe<Array<QuestionChoice_Bool_Exp_>>;
  _not?: InputMaybe<QuestionChoice_Bool_Exp_>;
  _or?: InputMaybe<Array<QuestionChoice_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  displayName?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Bigint_Comparison_Exp_>;
  order?: InputMaybe<String_Comparison_Exp_>;
  question?: InputMaybe<Question_Bool_Exp_>;
  question_id?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  value?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "QuestionChoice" */
export enum QuestionChoice_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  CelsiaAppQuestionchoicePkey_ = 'celsia_app_questionchoice_pkey'
}

/** input type for incrementing numeric columns in table "QuestionChoice" */
export type QuestionChoice_Inc_Input_ = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "QuestionChoice" */
export type QuestionChoice_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  question?: InputMaybe<Question_Obj_Rel_Insert_Input_>;
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type QuestionChoice_Max_Fields_ = {
  __typename?: 'QuestionChoice_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  question_id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "QuestionChoice" */
export type QuestionChoice_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  displayName?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  question_id?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type QuestionChoice_Min_Fields_ = {
  __typename?: 'QuestionChoice_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  question_id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "QuestionChoice" */
export type QuestionChoice_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  displayName?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  question_id?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "QuestionChoice" */
export type QuestionChoice_Mutation_Response_ = {
  __typename?: 'QuestionChoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<QuestionChoice_>;
};

/** on_conflict condition type for table "QuestionChoice" */
export type QuestionChoice_On_Conflict_ = {
  constraint: QuestionChoice_Constraint_;
  update_columns?: Array<QuestionChoice_Update_Column_>;
  where?: InputMaybe<QuestionChoice_Bool_Exp_>;
};

/** Ordering options when selecting data from "QuestionChoice". */
export type QuestionChoice_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  displayName?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  question?: InputMaybe<Question_Order_By_>;
  question_id?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: QuestionChoice */
export type QuestionChoice_Pk_Columns_Input_ = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "QuestionChoice" */
export enum QuestionChoice_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DisplayName_ = 'displayName',
  /** column name */
  Id_ = 'id',
  /** column name */
  Order_ = 'order',
  /** column name */
  QuestionId_ = 'question_id',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Value_ = 'value'
}

/** input type for updating data in table "QuestionChoice" */
export type QuestionChoice_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type QuestionChoice_Stddev_Fields_ = {
  __typename?: 'QuestionChoice_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "QuestionChoice" */
export type QuestionChoice_Stddev_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type QuestionChoice_Stddev_Pop_Fields_ = {
  __typename?: 'QuestionChoice_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "QuestionChoice" */
export type QuestionChoice_Stddev_Pop_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type QuestionChoice_Stddev_Samp_Fields_ = {
  __typename?: 'QuestionChoice_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "QuestionChoice" */
export type QuestionChoice_Stddev_Samp_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "QuestionChoice" */
export type QuestionChoice_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: QuestionChoice_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type QuestionChoice_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  question_id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type QuestionChoice_Sum_Fields_ = {
  __typename?: 'QuestionChoice_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "QuestionChoice" */
export type QuestionChoice_Sum_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** update columns of table "QuestionChoice" */
export enum QuestionChoice_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DisplayName_ = 'displayName',
  /** column name */
  Id_ = 'id',
  /** column name */
  Order_ = 'order',
  /** column name */
  QuestionId_ = 'question_id',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Value_ = 'value'
}

export type QuestionChoice_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<QuestionChoice_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QuestionChoice_Set_Input_>;
  /** filter the rows which have to be updated */
  where: QuestionChoice_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type QuestionChoice_Var_Pop_Fields_ = {
  __typename?: 'QuestionChoice_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "QuestionChoice" */
export type QuestionChoice_Var_Pop_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type QuestionChoice_Var_Samp_Fields_ = {
  __typename?: 'QuestionChoice_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "QuestionChoice" */
export type QuestionChoice_Var_Samp_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type QuestionChoice_Variance_Fields_ = {
  __typename?: 'QuestionChoice_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "QuestionChoice" */
export type QuestionChoice_Variance_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** columns and relationships of "QuestionLevel" */
export type QuestionLevel_ = {
  __typename?: 'QuestionLevel';
  level: Scalars['String']['output'];
  /** An array relationship */
  questions: Array<Question_>;
  /** An aggregate relationship */
  questions_aggregate: Question_Aggregate_;
};


/** columns and relationships of "QuestionLevel" */
export type QuestionLevelQuestionsArgs_ = {
  distinct_on?: InputMaybe<Array<Question_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Order_By_>>;
  where?: InputMaybe<Question_Bool_Exp_>;
};


/** columns and relationships of "QuestionLevel" */
export type QuestionLevelQuestions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Question_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Order_By_>>;
  where?: InputMaybe<Question_Bool_Exp_>;
};

/** aggregated selection of "QuestionLevel" */
export type QuestionLevel_Aggregate_ = {
  __typename?: 'QuestionLevel_aggregate';
  aggregate?: Maybe<QuestionLevel_Aggregate_Fields_>;
  nodes: Array<QuestionLevel_>;
};

/** aggregate fields of "QuestionLevel" */
export type QuestionLevel_Aggregate_Fields_ = {
  __typename?: 'QuestionLevel_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<QuestionLevel_Max_Fields_>;
  min?: Maybe<QuestionLevel_Min_Fields_>;
};


/** aggregate fields of "QuestionLevel" */
export type QuestionLevel_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<QuestionLevel_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "QuestionLevel". All fields are combined with a logical 'AND'. */
export type QuestionLevel_Bool_Exp_ = {
  _and?: InputMaybe<Array<QuestionLevel_Bool_Exp_>>;
  _not?: InputMaybe<QuestionLevel_Bool_Exp_>;
  _or?: InputMaybe<Array<QuestionLevel_Bool_Exp_>>;
  level?: InputMaybe<String_Comparison_Exp_>;
  questions?: InputMaybe<Question_Bool_Exp_>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Bool_Exp_>;
};

/** unique or primary key constraints on table "QuestionLevel" */
export enum QuestionLevel_Constraint_ {
  /** unique or primary key constraint on columns "level" */
  QuestionLevelPkey_ = 'questionLevel_pkey'
}

export enum QuestionLevel_Enum_ {
  DoNoSignificantHarm_ = 'DO_NO_SIGNIFICANT_HARM',
  General_ = 'GENERAL',
  SocialSafeguards_ = 'SOCIAL_SAFEGUARDS',
  SubstantialContribution_ = 'SUBSTANTIAL_CONTRIBUTION'
}

/** Boolean expression to compare columns of type "QuestionLevel_enum". All fields are combined with logical 'AND'. */
export type QuestionLevel_Enum_Comparison_Exp_ = {
  _eq?: InputMaybe<QuestionLevel_Enum_>;
  _in?: InputMaybe<Array<QuestionLevel_Enum_>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<QuestionLevel_Enum_>;
  _nin?: InputMaybe<Array<QuestionLevel_Enum_>>;
};

/** input type for inserting data into table "QuestionLevel" */
export type QuestionLevel_Insert_Input_ = {
  level?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Question_Arr_Rel_Insert_Input_>;
};

/** aggregate max on columns */
export type QuestionLevel_Max_Fields_ = {
  __typename?: 'QuestionLevel_max_fields';
  level?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type QuestionLevel_Min_Fields_ = {
  __typename?: 'QuestionLevel_min_fields';
  level?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "QuestionLevel" */
export type QuestionLevel_Mutation_Response_ = {
  __typename?: 'QuestionLevel_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<QuestionLevel_>;
};

/** on_conflict condition type for table "QuestionLevel" */
export type QuestionLevel_On_Conflict_ = {
  constraint: QuestionLevel_Constraint_;
  update_columns?: Array<QuestionLevel_Update_Column_>;
  where?: InputMaybe<QuestionLevel_Bool_Exp_>;
};

/** Ordering options when selecting data from "QuestionLevel". */
export type QuestionLevel_Order_By_ = {
  level?: InputMaybe<Order_By_>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Order_By_>;
};

/** primary key columns input for table: QuestionLevel */
export type QuestionLevel_Pk_Columns_Input_ = {
  level: Scalars['String']['input'];
};

/** select columns of table "QuestionLevel" */
export enum QuestionLevel_Select_Column_ {
  /** column name */
  Level_ = 'level'
}

/** input type for updating data in table "QuestionLevel" */
export type QuestionLevel_Set_Input_ = {
  level?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "QuestionLevel" */
export type QuestionLevel_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: QuestionLevel_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type QuestionLevel_Stream_Cursor_Value_Input_ = {
  level?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "QuestionLevel" */
export enum QuestionLevel_Update_Column_ {
  /** column name */
  Level_ = 'level'
}

export type QuestionLevel_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QuestionLevel_Set_Input_>;
  /** filter the rows which have to be updated */
  where: QuestionLevel_Bool_Exp_;
};

/** Many to many relationship between new and old versions of questions */
export type QuestionRevision_ = {
  __typename?: 'QuestionRevision';
  createdAt: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  /** An object relationship */
  newQuestion: Question_;
  newQuestionId: Scalars['uuid']['output'];
  /** An object relationship */
  oldQuestion: Question_;
  oldQuestionId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "QuestionRevision" */
export type QuestionRevision_Aggregate_ = {
  __typename?: 'QuestionRevision_aggregate';
  aggregate?: Maybe<QuestionRevision_Aggregate_Fields_>;
  nodes: Array<QuestionRevision_>;
};

export type QuestionRevision_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<QuestionRevision_Aggregate_Bool_Exp_Count_>;
};

export type QuestionRevision_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<QuestionRevision_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<QuestionRevision_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "QuestionRevision" */
export type QuestionRevision_Aggregate_Fields_ = {
  __typename?: 'QuestionRevision_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<QuestionRevision_Max_Fields_>;
  min?: Maybe<QuestionRevision_Min_Fields_>;
};


/** aggregate fields of "QuestionRevision" */
export type QuestionRevision_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<QuestionRevision_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "QuestionRevision" */
export type QuestionRevision_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<QuestionRevision_Max_Order_By_>;
  min?: InputMaybe<QuestionRevision_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "QuestionRevision" */
export type QuestionRevision_Arr_Rel_Insert_Input_ = {
  data: Array<QuestionRevision_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<QuestionRevision_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "QuestionRevision". All fields are combined with a logical 'AND'. */
export type QuestionRevision_Bool_Exp_ = {
  _and?: InputMaybe<Array<QuestionRevision_Bool_Exp_>>;
  _not?: InputMaybe<QuestionRevision_Bool_Exp_>;
  _or?: InputMaybe<Array<QuestionRevision_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  description?: InputMaybe<String_Comparison_Exp_>;
  newQuestion?: InputMaybe<Question_Bool_Exp_>;
  newQuestionId?: InputMaybe<Uuid_Comparison_Exp_>;
  oldQuestion?: InputMaybe<Question_Bool_Exp_>;
  oldQuestionId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "QuestionRevision" */
export enum QuestionRevision_Constraint_ {
  /** unique or primary key constraint on columns "newQuestionId", "oldQuestionId" */
  QuestionRevisionPkey_ = 'QuestionRevision_pkey'
}

/** input type for inserting data into table "QuestionRevision" */
export type QuestionRevision_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  newQuestion?: InputMaybe<Question_Obj_Rel_Insert_Input_>;
  newQuestionId?: InputMaybe<Scalars['uuid']['input']>;
  oldQuestion?: InputMaybe<Question_Obj_Rel_Insert_Input_>;
  oldQuestionId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type QuestionRevision_Max_Fields_ = {
  __typename?: 'QuestionRevision_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  newQuestionId?: Maybe<Scalars['uuid']['output']>;
  oldQuestionId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "QuestionRevision" */
export type QuestionRevision_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  newQuestionId?: InputMaybe<Order_By_>;
  oldQuestionId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type QuestionRevision_Min_Fields_ = {
  __typename?: 'QuestionRevision_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  newQuestionId?: Maybe<Scalars['uuid']['output']>;
  oldQuestionId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "QuestionRevision" */
export type QuestionRevision_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  newQuestionId?: InputMaybe<Order_By_>;
  oldQuestionId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "QuestionRevision" */
export type QuestionRevision_Mutation_Response_ = {
  __typename?: 'QuestionRevision_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<QuestionRevision_>;
};

/** on_conflict condition type for table "QuestionRevision" */
export type QuestionRevision_On_Conflict_ = {
  constraint: QuestionRevision_Constraint_;
  update_columns?: Array<QuestionRevision_Update_Column_>;
  where?: InputMaybe<QuestionRevision_Bool_Exp_>;
};

/** Ordering options when selecting data from "QuestionRevision". */
export type QuestionRevision_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  newQuestion?: InputMaybe<Question_Order_By_>;
  newQuestionId?: InputMaybe<Order_By_>;
  oldQuestion?: InputMaybe<Question_Order_By_>;
  oldQuestionId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: QuestionRevision */
export type QuestionRevision_Pk_Columns_Input_ = {
  newQuestionId: Scalars['uuid']['input'];
  oldQuestionId: Scalars['uuid']['input'];
};

/** select columns of table "QuestionRevision" */
export enum QuestionRevision_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  NewQuestionId_ = 'newQuestionId',
  /** column name */
  OldQuestionId_ = 'oldQuestionId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "QuestionRevision" */
export type QuestionRevision_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  newQuestionId?: InputMaybe<Scalars['uuid']['input']>;
  oldQuestionId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "QuestionRevision" */
export type QuestionRevision_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: QuestionRevision_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type QuestionRevision_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  newQuestionId?: InputMaybe<Scalars['uuid']['input']>;
  oldQuestionId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "QuestionRevision" */
export enum QuestionRevision_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  NewQuestionId_ = 'newQuestionId',
  /** column name */
  OldQuestionId_ = 'oldQuestionId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type QuestionRevision_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QuestionRevision_Set_Input_>;
  /** filter the rows which have to be updated */
  where: QuestionRevision_Bool_Exp_;
};

/** columns and relationships of "QuestionSet" */
export type QuestionSet_ = {
  __typename?: 'QuestionSet';
  /** An array relationship */
  activityQuestionSets: Array<ActivityQuestionSet_>;
  /** An aggregate relationship */
  activityQuestionSets_aggregate: ActivityQuestionSet_Aggregate_;
  /** Deprecated */
  newestVersion?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  questions: Array<QuestionSetQuestion_>;
  /** An array relationship */
  questionsDeprecated: Array<Question_>;
  /** An aggregate relationship */
  questionsDeprecated_aggregate: Question_Aggregate_;
  /** An aggregate relationship */
  questions_aggregate: QuestionSetQuestion_Aggregate_;
  reference: Scalars['String']['output'];
};


/** columns and relationships of "QuestionSet" */
export type QuestionSetActivityQuestionSetsArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityQuestionSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityQuestionSet_Order_By_>>;
  where?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
};


/** columns and relationships of "QuestionSet" */
export type QuestionSetActivityQuestionSets_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityQuestionSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityQuestionSet_Order_By_>>;
  where?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
};


/** columns and relationships of "QuestionSet" */
export type QuestionSetQuestionsArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionSetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionSetQuestion_Order_By_>>;
  where?: InputMaybe<QuestionSetQuestion_Bool_Exp_>;
};


/** columns and relationships of "QuestionSet" */
export type QuestionSetQuestionsDeprecatedArgs_ = {
  distinct_on?: InputMaybe<Array<Question_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Order_By_>>;
  where?: InputMaybe<Question_Bool_Exp_>;
};


/** columns and relationships of "QuestionSet" */
export type QuestionSetQuestionsDeprecated_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Question_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Order_By_>>;
  where?: InputMaybe<Question_Bool_Exp_>;
};


/** columns and relationships of "QuestionSet" */
export type QuestionSetQuestions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionSetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionSetQuestion_Order_By_>>;
  where?: InputMaybe<QuestionSetQuestion_Bool_Exp_>;
};

/** Relationship between Questions and the QuestionSet(s) they are in */
export type QuestionSetQuestion_ = {
  __typename?: 'QuestionSetQuestion';
  /** An object relationship */
  question: Question_;
  questionId: Scalars['uuid']['output'];
  /** An object relationship */
  questionSet: QuestionSet_;
  questionSetRef: Scalars['String']['output'];
};

/** aggregated selection of "QuestionSetQuestion" */
export type QuestionSetQuestion_Aggregate_ = {
  __typename?: 'QuestionSetQuestion_aggregate';
  aggregate?: Maybe<QuestionSetQuestion_Aggregate_Fields_>;
  nodes: Array<QuestionSetQuestion_>;
};

export type QuestionSetQuestion_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<QuestionSetQuestion_Aggregate_Bool_Exp_Count_>;
};

export type QuestionSetQuestion_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<QuestionSetQuestion_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<QuestionSetQuestion_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "QuestionSetQuestion" */
export type QuestionSetQuestion_Aggregate_Fields_ = {
  __typename?: 'QuestionSetQuestion_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<QuestionSetQuestion_Max_Fields_>;
  min?: Maybe<QuestionSetQuestion_Min_Fields_>;
};


/** aggregate fields of "QuestionSetQuestion" */
export type QuestionSetQuestion_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<QuestionSetQuestion_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "QuestionSetQuestion" */
export type QuestionSetQuestion_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<QuestionSetQuestion_Max_Order_By_>;
  min?: InputMaybe<QuestionSetQuestion_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "QuestionSetQuestion" */
export type QuestionSetQuestion_Arr_Rel_Insert_Input_ = {
  data: Array<QuestionSetQuestion_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<QuestionSetQuestion_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "QuestionSetQuestion". All fields are combined with a logical 'AND'. */
export type QuestionSetQuestion_Bool_Exp_ = {
  _and?: InputMaybe<Array<QuestionSetQuestion_Bool_Exp_>>;
  _not?: InputMaybe<QuestionSetQuestion_Bool_Exp_>;
  _or?: InputMaybe<Array<QuestionSetQuestion_Bool_Exp_>>;
  question?: InputMaybe<Question_Bool_Exp_>;
  questionId?: InputMaybe<Uuid_Comparison_Exp_>;
  questionSet?: InputMaybe<QuestionSet_Bool_Exp_>;
  questionSetRef?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "QuestionSetQuestion" */
export enum QuestionSetQuestion_Constraint_ {
  /** unique or primary key constraint on columns "questionSetRef", "questionId" */
  QuestionSetQuestionPkey_ = 'QuestionSetQuestion_pkey'
}

/** input type for inserting data into table "QuestionSetQuestion" */
export type QuestionSetQuestion_Insert_Input_ = {
  question?: InputMaybe<Question_Obj_Rel_Insert_Input_>;
  questionId?: InputMaybe<Scalars['uuid']['input']>;
  questionSet?: InputMaybe<QuestionSet_Obj_Rel_Insert_Input_>;
  questionSetRef?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type QuestionSetQuestion_Max_Fields_ = {
  __typename?: 'QuestionSetQuestion_max_fields';
  questionId?: Maybe<Scalars['uuid']['output']>;
  questionSetRef?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "QuestionSetQuestion" */
export type QuestionSetQuestion_Max_Order_By_ = {
  questionId?: InputMaybe<Order_By_>;
  questionSetRef?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type QuestionSetQuestion_Min_Fields_ = {
  __typename?: 'QuestionSetQuestion_min_fields';
  questionId?: Maybe<Scalars['uuid']['output']>;
  questionSetRef?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "QuestionSetQuestion" */
export type QuestionSetQuestion_Min_Order_By_ = {
  questionId?: InputMaybe<Order_By_>;
  questionSetRef?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "QuestionSetQuestion" */
export type QuestionSetQuestion_Mutation_Response_ = {
  __typename?: 'QuestionSetQuestion_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<QuestionSetQuestion_>;
};

/** on_conflict condition type for table "QuestionSetQuestion" */
export type QuestionSetQuestion_On_Conflict_ = {
  constraint: QuestionSetQuestion_Constraint_;
  update_columns?: Array<QuestionSetQuestion_Update_Column_>;
  where?: InputMaybe<QuestionSetQuestion_Bool_Exp_>;
};

/** Ordering options when selecting data from "QuestionSetQuestion". */
export type QuestionSetQuestion_Order_By_ = {
  question?: InputMaybe<Question_Order_By_>;
  questionId?: InputMaybe<Order_By_>;
  questionSet?: InputMaybe<QuestionSet_Order_By_>;
  questionSetRef?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: QuestionSetQuestion */
export type QuestionSetQuestion_Pk_Columns_Input_ = {
  questionId: Scalars['uuid']['input'];
  questionSetRef: Scalars['String']['input'];
};

/** select columns of table "QuestionSetQuestion" */
export enum QuestionSetQuestion_Select_Column_ {
  /** column name */
  QuestionId_ = 'questionId',
  /** column name */
  QuestionSetRef_ = 'questionSetRef'
}

/** input type for updating data in table "QuestionSetQuestion" */
export type QuestionSetQuestion_Set_Input_ = {
  questionId?: InputMaybe<Scalars['uuid']['input']>;
  questionSetRef?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "QuestionSetQuestion" */
export type QuestionSetQuestion_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: QuestionSetQuestion_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type QuestionSetQuestion_Stream_Cursor_Value_Input_ = {
  questionId?: InputMaybe<Scalars['uuid']['input']>;
  questionSetRef?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "QuestionSetQuestion" */
export enum QuestionSetQuestion_Update_Column_ {
  /** column name */
  QuestionId_ = 'questionId',
  /** column name */
  QuestionSetRef_ = 'questionSetRef'
}

export type QuestionSetQuestion_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QuestionSetQuestion_Set_Input_>;
  /** filter the rows which have to be updated */
  where: QuestionSetQuestion_Bool_Exp_;
};

/** aggregated selection of "QuestionSet" */
export type QuestionSet_Aggregate_ = {
  __typename?: 'QuestionSet_aggregate';
  aggregate?: Maybe<QuestionSet_Aggregate_Fields_>;
  nodes: Array<QuestionSet_>;
};

/** aggregate fields of "QuestionSet" */
export type QuestionSet_Aggregate_Fields_ = {
  __typename?: 'QuestionSet_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<QuestionSet_Max_Fields_>;
  min?: Maybe<QuestionSet_Min_Fields_>;
};


/** aggregate fields of "QuestionSet" */
export type QuestionSet_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<QuestionSet_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "QuestionSet". All fields are combined with a logical 'AND'. */
export type QuestionSet_Bool_Exp_ = {
  _and?: InputMaybe<Array<QuestionSet_Bool_Exp_>>;
  _not?: InputMaybe<QuestionSet_Bool_Exp_>;
  _or?: InputMaybe<Array<QuestionSet_Bool_Exp_>>;
  activityQuestionSets?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
  activityQuestionSets_aggregate?: InputMaybe<ActivityQuestionSet_Aggregate_Bool_Exp_>;
  newestVersion?: InputMaybe<String_Comparison_Exp_>;
  questions?: InputMaybe<QuestionSetQuestion_Bool_Exp_>;
  questionsDeprecated?: InputMaybe<Question_Bool_Exp_>;
  questionsDeprecated_aggregate?: InputMaybe<Question_Aggregate_Bool_Exp_>;
  questions_aggregate?: InputMaybe<QuestionSetQuestion_Aggregate_Bool_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "QuestionSet" */
export enum QuestionSet_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  QuestionSetPkey_ = 'questionSet_pkey',
  /** unique or primary key constraint on columns "newestVersion", "reference" */
  QuestionSetReferenceNewestVersionE562c137Uniq_ = 'questionSet_reference_newestVersion_e562c137_uniq'
}

/** input type for inserting data into table "QuestionSet" */
export type QuestionSet_Insert_Input_ = {
  activityQuestionSets?: InputMaybe<ActivityQuestionSet_Arr_Rel_Insert_Input_>;
  /** Deprecated */
  newestVersion?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<QuestionSetQuestion_Arr_Rel_Insert_Input_>;
  questionsDeprecated?: InputMaybe<Question_Arr_Rel_Insert_Input_>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type QuestionSet_Max_Fields_ = {
  __typename?: 'QuestionSet_max_fields';
  /** Deprecated */
  newestVersion?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type QuestionSet_Min_Fields_ = {
  __typename?: 'QuestionSet_min_fields';
  /** Deprecated */
  newestVersion?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "QuestionSet" */
export type QuestionSet_Mutation_Response_ = {
  __typename?: 'QuestionSet_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<QuestionSet_>;
};

/** input type for inserting object relation for remote table "QuestionSet" */
export type QuestionSet_Obj_Rel_Insert_Input_ = {
  data: QuestionSet_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<QuestionSet_On_Conflict_>;
};

/** on_conflict condition type for table "QuestionSet" */
export type QuestionSet_On_Conflict_ = {
  constraint: QuestionSet_Constraint_;
  update_columns?: Array<QuestionSet_Update_Column_>;
  where?: InputMaybe<QuestionSet_Bool_Exp_>;
};

/** Ordering options when selecting data from "QuestionSet". */
export type QuestionSet_Order_By_ = {
  activityQuestionSets_aggregate?: InputMaybe<ActivityQuestionSet_Aggregate_Order_By_>;
  newestVersion?: InputMaybe<Order_By_>;
  questionsDeprecated_aggregate?: InputMaybe<Question_Aggregate_Order_By_>;
  questions_aggregate?: InputMaybe<QuestionSetQuestion_Aggregate_Order_By_>;
  reference?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: QuestionSet */
export type QuestionSet_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "QuestionSet" */
export enum QuestionSet_Select_Column_ {
  /** column name */
  NewestVersion_ = 'newestVersion',
  /** column name */
  Reference_ = 'reference'
}

/** input type for updating data in table "QuestionSet" */
export type QuestionSet_Set_Input_ = {
  /** Deprecated */
  newestVersion?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "QuestionSet" */
export type QuestionSet_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: QuestionSet_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type QuestionSet_Stream_Cursor_Value_Input_ = {
  /** Deprecated */
  newestVersion?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "QuestionSet" */
export enum QuestionSet_Update_Column_ {
  /** column name */
  NewestVersion_ = 'newestVersion',
  /** column name */
  Reference_ = 'reference'
}

export type QuestionSet_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QuestionSet_Set_Input_>;
  /** filter the rows which have to be updated */
  where: QuestionSet_Bool_Exp_;
};

/** columns and relationships of "QuestionType" */
export type QuestionType_ = {
  __typename?: 'QuestionType';
  /** An array relationship */
  questions: Array<Question_>;
  /** An aggregate relationship */
  questions_aggregate: Question_Aggregate_;
  type: Scalars['String']['output'];
};


/** columns and relationships of "QuestionType" */
export type QuestionTypeQuestionsArgs_ = {
  distinct_on?: InputMaybe<Array<Question_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Order_By_>>;
  where?: InputMaybe<Question_Bool_Exp_>;
};


/** columns and relationships of "QuestionType" */
export type QuestionTypeQuestions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Question_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Order_By_>>;
  where?: InputMaybe<Question_Bool_Exp_>;
};

/** aggregated selection of "QuestionType" */
export type QuestionType_Aggregate_ = {
  __typename?: 'QuestionType_aggregate';
  aggregate?: Maybe<QuestionType_Aggregate_Fields_>;
  nodes: Array<QuestionType_>;
};

/** aggregate fields of "QuestionType" */
export type QuestionType_Aggregate_Fields_ = {
  __typename?: 'QuestionType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<QuestionType_Max_Fields_>;
  min?: Maybe<QuestionType_Min_Fields_>;
};


/** aggregate fields of "QuestionType" */
export type QuestionType_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<QuestionType_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "QuestionType". All fields are combined with a logical 'AND'. */
export type QuestionType_Bool_Exp_ = {
  _and?: InputMaybe<Array<QuestionType_Bool_Exp_>>;
  _not?: InputMaybe<QuestionType_Bool_Exp_>;
  _or?: InputMaybe<Array<QuestionType_Bool_Exp_>>;
  questions?: InputMaybe<Question_Bool_Exp_>;
  questions_aggregate?: InputMaybe<Question_Aggregate_Bool_Exp_>;
  type?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "QuestionType" */
export enum QuestionType_Constraint_ {
  /** unique or primary key constraint on columns "type" */
  AnswerTypePkey_ = 'answerType_pkey'
}

export enum QuestionType_Enum_ {
  Decimal_ = 'DECIMAL',
  Integer_ = 'INTEGER',
  LongText_ = 'LONG_TEXT',
  MultipleChoice_ = 'MULTIPLE_CHOICE',
  MultipleCriteria_ = 'MULTIPLE_CRITERIA',
  Other_ = 'OTHER',
  ShortText_ = 'SHORT_TEXT',
  SingleChoice_ = 'SINGLE_CHOICE',
  SingleChoiceDropdown_ = 'SINGLE_CHOICE_DROPDOWN',
  YesNo_ = 'YES_NO',
  YesNoNa_ = 'YES_NO_NA',
  YesNoNaUnknown_ = 'YES_NO_NA_UNKNOWN'
}

/** Boolean expression to compare columns of type "QuestionType_enum". All fields are combined with logical 'AND'. */
export type QuestionType_Enum_Comparison_Exp_ = {
  _eq?: InputMaybe<QuestionType_Enum_>;
  _in?: InputMaybe<Array<QuestionType_Enum_>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<QuestionType_Enum_>;
  _nin?: InputMaybe<Array<QuestionType_Enum_>>;
};

/** input type for inserting data into table "QuestionType" */
export type QuestionType_Insert_Input_ = {
  questions?: InputMaybe<Question_Arr_Rel_Insert_Input_>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type QuestionType_Max_Fields_ = {
  __typename?: 'QuestionType_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type QuestionType_Min_Fields_ = {
  __typename?: 'QuestionType_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "QuestionType" */
export type QuestionType_Mutation_Response_ = {
  __typename?: 'QuestionType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<QuestionType_>;
};

/** input type for inserting object relation for remote table "QuestionType" */
export type QuestionType_Obj_Rel_Insert_Input_ = {
  data: QuestionType_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<QuestionType_On_Conflict_>;
};

/** on_conflict condition type for table "QuestionType" */
export type QuestionType_On_Conflict_ = {
  constraint: QuestionType_Constraint_;
  update_columns?: Array<QuestionType_Update_Column_>;
  where?: InputMaybe<QuestionType_Bool_Exp_>;
};

/** Ordering options when selecting data from "QuestionType". */
export type QuestionType_Order_By_ = {
  questions_aggregate?: InputMaybe<Question_Aggregate_Order_By_>;
  type?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: QuestionType */
export type QuestionType_Pk_Columns_Input_ = {
  type: Scalars['String']['input'];
};

/** select columns of table "QuestionType" */
export enum QuestionType_Select_Column_ {
  /** column name */
  Type_ = 'type'
}

/** input type for updating data in table "QuestionType" */
export type QuestionType_Set_Input_ = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "QuestionType" */
export type QuestionType_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: QuestionType_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type QuestionType_Stream_Cursor_Value_Input_ = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "QuestionType" */
export enum QuestionType_Update_Column_ {
  /** column name */
  Type_ = 'type'
}

export type QuestionType_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<QuestionType_Set_Input_>;
  /** filter the rows which have to be updated */
  where: QuestionType_Bool_Exp_;
};

/** aggregated selection of "Question" */
export type Question_Aggregate_ = {
  __typename?: 'Question_aggregate';
  aggregate?: Maybe<Question_Aggregate_Fields_>;
  nodes: Array<Question_>;
};

export type Question_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Question_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Question_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Question_Aggregate_Bool_Exp_Count_>;
};

export type Question_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Question_Select_Column_Question_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Question_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Question_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Question_Select_Column_Question_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Question_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Question_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Question_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Question_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "Question" */
export type Question_Aggregate_Fields_ = {
  __typename?: 'Question_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Question_Max_Fields_>;
  min?: Maybe<Question_Min_Fields_>;
};


/** aggregate fields of "Question" */
export type Question_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Question_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Question" */
export type Question_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Question_Max_Order_By_>;
  min?: InputMaybe<Question_Min_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Question_Append_Input_ = {
  other?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "Question" */
export type Question_Arr_Rel_Insert_Input_ = {
  data: Array<Question_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Question_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "Question". All fields are combined with a logical 'AND'. */
export type Question_Bool_Exp_ = {
  Answers?: InputMaybe<Answer_Bool_Exp_>;
  Answers_aggregate?: InputMaybe<Answer_Aggregate_Bool_Exp_>;
  QuestionType?: InputMaybe<QuestionType_Bool_Exp_>;
  _and?: InputMaybe<Array<Question_Bool_Exp_>>;
  _not?: InputMaybe<Question_Bool_Exp_>;
  _or?: InputMaybe<Array<Question_Bool_Exp_>>;
  aboutDocumentation?: InputMaybe<String_Comparison_Exp_>;
  alignmentErrorMessage?: InputMaybe<String_Comparison_Exp_>;
  choices?: InputMaybe<QuestionChoice_Bool_Exp_>;
  choices_aggregate?: InputMaybe<QuestionChoice_Aggregate_Bool_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  dependencyDescription?: InputMaybe<String_Comparison_Exp_>;
  description?: InputMaybe<String_Comparison_Exp_>;
  documentationRequired?: InputMaybe<Boolean_Comparison_Exp_>;
  extendedDescription?: InputMaybe<String_Comparison_Exp_>;
  group?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isAligned?: InputMaybe<String_Comparison_Exp_>;
  isEditable?: InputMaybe<String_Comparison_Exp_>;
  isRequired?: InputMaybe<String_Comparison_Exp_>;
  isVisible?: InputMaybe<String_Comparison_Exp_>;
  learnMoreArticleSlug?: InputMaybe<String_Comparison_Exp_>;
  level?: InputMaybe<QuestionLevel_Enum_Comparison_Exp_>;
  levelExpression?: InputMaybe<String_Comparison_Exp_>;
  newerRevisions?: InputMaybe<QuestionRevision_Bool_Exp_>;
  newerRevisions_aggregate?: InputMaybe<QuestionRevision_Aggregate_Bool_Exp_>;
  objective?: InputMaybe<Objective_Bool_Exp_>;
  objectiveKey?: InputMaybe<String_Comparison_Exp_>;
  olderRevisions?: InputMaybe<QuestionRevision_Bool_Exp_>;
  olderRevisions_aggregate?: InputMaybe<QuestionRevision_Aggregate_Bool_Exp_>;
  orderIndex?: InputMaybe<String_Comparison_Exp_>;
  other?: InputMaybe<Jsonb_Comparison_Exp_>;
  questionSetRef?: InputMaybe<String_Comparison_Exp_>;
  questionSets?: InputMaybe<QuestionSetQuestion_Bool_Exp_>;
  questionSets_aggregate?: InputMaybe<QuestionSetQuestion_Aggregate_Bool_Exp_>;
  relevantDirectives?: InputMaybe<String_Comparison_Exp_>;
  resourceLink?: InputMaybe<String_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
  type?: InputMaybe<QuestionType_Enum_Comparison_Exp_>;
  uniqueId?: InputMaybe<String_Comparison_Exp_>;
  unit?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  version?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Question" */
export enum Question_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  QuestionPkey_ = 'question_pkey',
  /** unique or primary key constraint on columns "uniqueId", "questionSetRef", "version" */
  QuestionUniqueIdQuestionSetRef_50e55a4dUniq_ = 'question_uniqueId_questionSetRef__50e55a4d_uniq',
  /** unique or primary key constraint on columns "uniqueId", "version" */
  QuestionUniqueIdQuestionSetVersion_7d15110dUniq_ = 'question_uniqueId_questionSetVersion_7d15110d_uniq'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Question_Delete_At_Path_Input_ = {
  other?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Question_Delete_Elem_Input_ = {
  other?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Question_Delete_Key_Input_ = {
  other?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "Question" */
export type Question_Insert_Input_ = {
  Answers?: InputMaybe<Answer_Arr_Rel_Insert_Input_>;
  QuestionType?: InputMaybe<QuestionType_Obj_Rel_Insert_Input_>;
  aboutDocumentation?: InputMaybe<Scalars['String']['input']>;
  alignmentErrorMessage?: InputMaybe<Scalars['String']['input']>;
  choices?: InputMaybe<QuestionChoice_Arr_Rel_Insert_Input_>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dependencyDescription?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  extendedDescription?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAligned?: InputMaybe<Scalars['String']['input']>;
  isEditable?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['String']['input']>;
  isVisible?: InputMaybe<Scalars['String']['input']>;
  learnMoreArticleSlug?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<QuestionLevel_Enum_>;
  levelExpression?: InputMaybe<Scalars['String']['input']>;
  newerRevisions?: InputMaybe<QuestionRevision_Arr_Rel_Insert_Input_>;
  objective?: InputMaybe<Objective_Obj_Rel_Insert_Input_>;
  objectiveKey?: InputMaybe<Scalars['String']['input']>;
  olderRevisions?: InputMaybe<QuestionRevision_Arr_Rel_Insert_Input_>;
  orderIndex?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<Scalars['jsonb']['input']>;
  /** Deprecated, use QuestionSetQuestion relationship instead */
  questionSetRef?: InputMaybe<Scalars['String']['input']>;
  questionSets?: InputMaybe<QuestionSetQuestion_Arr_Rel_Insert_Input_>;
  relevantDirectives?: InputMaybe<Scalars['String']['input']>;
  resourceLink?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<QuestionType_Enum_>;
  uniqueId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Question_Max_Fields_ = {
  __typename?: 'Question_max_fields';
  aboutDocumentation?: Maybe<Scalars['String']['output']>;
  alignmentErrorMessage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dependencyDescription?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extendedDescription?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  isAligned?: Maybe<Scalars['String']['output']>;
  isEditable?: Maybe<Scalars['String']['output']>;
  isRequired?: Maybe<Scalars['String']['output']>;
  isVisible?: Maybe<Scalars['String']['output']>;
  learnMoreArticleSlug?: Maybe<Scalars['String']['output']>;
  levelExpression?: Maybe<Scalars['String']['output']>;
  objectiveKey?: Maybe<Scalars['String']['output']>;
  orderIndex?: Maybe<Scalars['String']['output']>;
  /** Deprecated, use QuestionSetQuestion relationship instead */
  questionSetRef?: Maybe<Scalars['String']['output']>;
  relevantDirectives?: Maybe<Scalars['String']['output']>;
  resourceLink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "Question" */
export type Question_Max_Order_By_ = {
  aboutDocumentation?: InputMaybe<Order_By_>;
  alignmentErrorMessage?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  dependencyDescription?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  extendedDescription?: InputMaybe<Order_By_>;
  group?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isAligned?: InputMaybe<Order_By_>;
  isEditable?: InputMaybe<Order_By_>;
  isRequired?: InputMaybe<Order_By_>;
  isVisible?: InputMaybe<Order_By_>;
  learnMoreArticleSlug?: InputMaybe<Order_By_>;
  levelExpression?: InputMaybe<Order_By_>;
  objectiveKey?: InputMaybe<Order_By_>;
  orderIndex?: InputMaybe<Order_By_>;
  /** Deprecated, use QuestionSetQuestion relationship instead */
  questionSetRef?: InputMaybe<Order_By_>;
  relevantDirectives?: InputMaybe<Order_By_>;
  resourceLink?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  uniqueId?: InputMaybe<Order_By_>;
  unit?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  version?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Question_Min_Fields_ = {
  __typename?: 'Question_min_fields';
  aboutDocumentation?: Maybe<Scalars['String']['output']>;
  alignmentErrorMessage?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dependencyDescription?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extendedDescription?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  isAligned?: Maybe<Scalars['String']['output']>;
  isEditable?: Maybe<Scalars['String']['output']>;
  isRequired?: Maybe<Scalars['String']['output']>;
  isVisible?: Maybe<Scalars['String']['output']>;
  learnMoreArticleSlug?: Maybe<Scalars['String']['output']>;
  levelExpression?: Maybe<Scalars['String']['output']>;
  objectiveKey?: Maybe<Scalars['String']['output']>;
  orderIndex?: Maybe<Scalars['String']['output']>;
  /** Deprecated, use QuestionSetQuestion relationship instead */
  questionSetRef?: Maybe<Scalars['String']['output']>;
  relevantDirectives?: Maybe<Scalars['String']['output']>;
  resourceLink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "Question" */
export type Question_Min_Order_By_ = {
  aboutDocumentation?: InputMaybe<Order_By_>;
  alignmentErrorMessage?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  dependencyDescription?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  extendedDescription?: InputMaybe<Order_By_>;
  group?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isAligned?: InputMaybe<Order_By_>;
  isEditable?: InputMaybe<Order_By_>;
  isRequired?: InputMaybe<Order_By_>;
  isVisible?: InputMaybe<Order_By_>;
  learnMoreArticleSlug?: InputMaybe<Order_By_>;
  levelExpression?: InputMaybe<Order_By_>;
  objectiveKey?: InputMaybe<Order_By_>;
  orderIndex?: InputMaybe<Order_By_>;
  /** Deprecated, use QuestionSetQuestion relationship instead */
  questionSetRef?: InputMaybe<Order_By_>;
  relevantDirectives?: InputMaybe<Order_By_>;
  resourceLink?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  uniqueId?: InputMaybe<Order_By_>;
  unit?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  version?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "Question" */
export type Question_Mutation_Response_ = {
  __typename?: 'Question_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Question_>;
};

/** input type for inserting object relation for remote table "Question" */
export type Question_Obj_Rel_Insert_Input_ = {
  data: Question_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Question_On_Conflict_>;
};

/** on_conflict condition type for table "Question" */
export type Question_On_Conflict_ = {
  constraint: Question_Constraint_;
  update_columns?: Array<Question_Update_Column_>;
  where?: InputMaybe<Question_Bool_Exp_>;
};

/** Ordering options when selecting data from "Question". */
export type Question_Order_By_ = {
  Answers_aggregate?: InputMaybe<Answer_Aggregate_Order_By_>;
  QuestionType?: InputMaybe<QuestionType_Order_By_>;
  aboutDocumentation?: InputMaybe<Order_By_>;
  alignmentErrorMessage?: InputMaybe<Order_By_>;
  choices_aggregate?: InputMaybe<QuestionChoice_Aggregate_Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  dependencyDescription?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  documentationRequired?: InputMaybe<Order_By_>;
  extendedDescription?: InputMaybe<Order_By_>;
  group?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isAligned?: InputMaybe<Order_By_>;
  isEditable?: InputMaybe<Order_By_>;
  isRequired?: InputMaybe<Order_By_>;
  isVisible?: InputMaybe<Order_By_>;
  learnMoreArticleSlug?: InputMaybe<Order_By_>;
  level?: InputMaybe<Order_By_>;
  levelExpression?: InputMaybe<Order_By_>;
  newerRevisions_aggregate?: InputMaybe<QuestionRevision_Aggregate_Order_By_>;
  objective?: InputMaybe<Objective_Order_By_>;
  objectiveKey?: InputMaybe<Order_By_>;
  olderRevisions_aggregate?: InputMaybe<QuestionRevision_Aggregate_Order_By_>;
  orderIndex?: InputMaybe<Order_By_>;
  other?: InputMaybe<Order_By_>;
  questionSetRef?: InputMaybe<Order_By_>;
  questionSets_aggregate?: InputMaybe<QuestionSetQuestion_Aggregate_Order_By_>;
  relevantDirectives?: InputMaybe<Order_By_>;
  resourceLink?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  type?: InputMaybe<Order_By_>;
  uniqueId?: InputMaybe<Order_By_>;
  unit?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  version?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Question */
export type Question_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Question_Prepend_Input_ = {
  other?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "Question" */
export enum Question_Select_Column_ {
  /** column name */
  AboutDocumentation_ = 'aboutDocumentation',
  /** column name */
  AlignmentErrorMessage_ = 'alignmentErrorMessage',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DependencyDescription_ = 'dependencyDescription',
  /** column name */
  Description_ = 'description',
  /** column name */
  DocumentationRequired_ = 'documentationRequired',
  /** column name */
  ExtendedDescription_ = 'extendedDescription',
  /** column name */
  Group_ = 'group',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsAligned_ = 'isAligned',
  /** column name */
  IsEditable_ = 'isEditable',
  /** column name */
  IsRequired_ = 'isRequired',
  /** column name */
  IsVisible_ = 'isVisible',
  /** column name */
  LearnMoreArticleSlug_ = 'learnMoreArticleSlug',
  /** column name */
  Level_ = 'level',
  /** column name */
  LevelExpression_ = 'levelExpression',
  /** column name */
  ObjectiveKey_ = 'objectiveKey',
  /** column name */
  OrderIndex_ = 'orderIndex',
  /** column name */
  Other_ = 'other',
  /** column name */
  QuestionSetRef_ = 'questionSetRef',
  /** column name */
  RelevantDirectives_ = 'relevantDirectives',
  /** column name */
  ResourceLink_ = 'resourceLink',
  /** column name */
  Title_ = 'title',
  /** column name */
  Type_ = 'type',
  /** column name */
  UniqueId_ = 'uniqueId',
  /** column name */
  Unit_ = 'unit',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Version_ = 'version'
}

/** select "Question_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Question" */
export enum Question_Select_Column_Question_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  DocumentationRequired_ = 'documentationRequired'
}

/** select "Question_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Question" */
export enum Question_Select_Column_Question_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  DocumentationRequired_ = 'documentationRequired'
}

/** input type for updating data in table "Question" */
export type Question_Set_Input_ = {
  aboutDocumentation?: InputMaybe<Scalars['String']['input']>;
  alignmentErrorMessage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dependencyDescription?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  extendedDescription?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAligned?: InputMaybe<Scalars['String']['input']>;
  isEditable?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['String']['input']>;
  isVisible?: InputMaybe<Scalars['String']['input']>;
  learnMoreArticleSlug?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<QuestionLevel_Enum_>;
  levelExpression?: InputMaybe<Scalars['String']['input']>;
  objectiveKey?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<Scalars['jsonb']['input']>;
  /** Deprecated, use QuestionSetQuestion relationship instead */
  questionSetRef?: InputMaybe<Scalars['String']['input']>;
  relevantDirectives?: InputMaybe<Scalars['String']['input']>;
  resourceLink?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<QuestionType_Enum_>;
  uniqueId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "Question" */
export type Question_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Question_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Question_Stream_Cursor_Value_Input_ = {
  aboutDocumentation?: InputMaybe<Scalars['String']['input']>;
  alignmentErrorMessage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dependencyDescription?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  extendedDescription?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAligned?: InputMaybe<Scalars['String']['input']>;
  isEditable?: InputMaybe<Scalars['String']['input']>;
  isRequired?: InputMaybe<Scalars['String']['input']>;
  isVisible?: InputMaybe<Scalars['String']['input']>;
  learnMoreArticleSlug?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<QuestionLevel_Enum_>;
  levelExpression?: InputMaybe<Scalars['String']['input']>;
  objectiveKey?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['String']['input']>;
  other?: InputMaybe<Scalars['jsonb']['input']>;
  /** Deprecated, use QuestionSetQuestion relationship instead */
  questionSetRef?: InputMaybe<Scalars['String']['input']>;
  relevantDirectives?: InputMaybe<Scalars['String']['input']>;
  resourceLink?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<QuestionType_Enum_>;
  uniqueId?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "Question" */
export enum Question_Update_Column_ {
  /** column name */
  AboutDocumentation_ = 'aboutDocumentation',
  /** column name */
  AlignmentErrorMessage_ = 'alignmentErrorMessage',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DependencyDescription_ = 'dependencyDescription',
  /** column name */
  Description_ = 'description',
  /** column name */
  DocumentationRequired_ = 'documentationRequired',
  /** column name */
  ExtendedDescription_ = 'extendedDescription',
  /** column name */
  Group_ = 'group',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsAligned_ = 'isAligned',
  /** column name */
  IsEditable_ = 'isEditable',
  /** column name */
  IsRequired_ = 'isRequired',
  /** column name */
  IsVisible_ = 'isVisible',
  /** column name */
  LearnMoreArticleSlug_ = 'learnMoreArticleSlug',
  /** column name */
  Level_ = 'level',
  /** column name */
  LevelExpression_ = 'levelExpression',
  /** column name */
  ObjectiveKey_ = 'objectiveKey',
  /** column name */
  OrderIndex_ = 'orderIndex',
  /** column name */
  Other_ = 'other',
  /** column name */
  QuestionSetRef_ = 'questionSetRef',
  /** column name */
  RelevantDirectives_ = 'relevantDirectives',
  /** column name */
  ResourceLink_ = 'resourceLink',
  /** column name */
  Title_ = 'title',
  /** column name */
  Type_ = 'type',
  /** column name */
  UniqueId_ = 'uniqueId',
  /** column name */
  Unit_ = 'unit',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Version_ = 'version'
}

export type Question_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Question_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Question_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Question_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Question_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Question_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Question_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Question_Bool_Exp_;
};

export enum ReportPeriod_ {
  Q1_ = 'q1',
  Q2_ = 'q2',
  Q3_ = 'q3',
  Q4_ = 'q4',
  Year_ = 'year'
}

/** columns and relationships of "ReportingGroup" */
export type ReportingGroup_ = {
  __typename?: 'ReportingGroup';
  /** An array relationship */
  businessUnits: Array<BusinessUnitAssessment_>;
  /** An aggregate relationship */
  businessUnits_aggregate: BusinessUnitAssessment_Aggregate_;
  /** An object relationship */
  cAssessment: CompanyAssessment_;
  companyAssessmentId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  orderIndex: Scalars['numeric']['output'];
  /** An object relationship */
  owner?: Maybe<Users_>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  parent?: Maybe<ReportingGroup_>;
  parentId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  reportingSubGroups: Array<ReportingGroup_>;
  /** An aggregate relationship */
  reportingSubGroups_aggregate: ReportingGroup_Aggregate_;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "ReportingGroup" */
export type ReportingGroupBusinessUnitsArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnitAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnitAssessment_Order_By_>>;
  where?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
};


/** columns and relationships of "ReportingGroup" */
export type ReportingGroupBusinessUnits_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnitAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnitAssessment_Order_By_>>;
  where?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
};


/** columns and relationships of "ReportingGroup" */
export type ReportingGroupReportingSubGroupsArgs_ = {
  distinct_on?: InputMaybe<Array<ReportingGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportingGroup_Order_By_>>;
  where?: InputMaybe<ReportingGroup_Bool_Exp_>;
};


/** columns and relationships of "ReportingGroup" */
export type ReportingGroupReportingSubGroups_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ReportingGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportingGroup_Order_By_>>;
  where?: InputMaybe<ReportingGroup_Bool_Exp_>;
};

/** aggregated selection of "ReportingGroup" */
export type ReportingGroup_Aggregate_ = {
  __typename?: 'ReportingGroup_aggregate';
  aggregate?: Maybe<ReportingGroup_Aggregate_Fields_>;
  nodes: Array<ReportingGroup_>;
};

export type ReportingGroup_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<ReportingGroup_Aggregate_Bool_Exp_Count_>;
};

export type ReportingGroup_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<ReportingGroup_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ReportingGroup_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "ReportingGroup" */
export type ReportingGroup_Aggregate_Fields_ = {
  __typename?: 'ReportingGroup_aggregate_fields';
  avg?: Maybe<ReportingGroup_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<ReportingGroup_Max_Fields_>;
  min?: Maybe<ReportingGroup_Min_Fields_>;
  stddev?: Maybe<ReportingGroup_Stddev_Fields_>;
  stddev_pop?: Maybe<ReportingGroup_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<ReportingGroup_Stddev_Samp_Fields_>;
  sum?: Maybe<ReportingGroup_Sum_Fields_>;
  var_pop?: Maybe<ReportingGroup_Var_Pop_Fields_>;
  var_samp?: Maybe<ReportingGroup_Var_Samp_Fields_>;
  variance?: Maybe<ReportingGroup_Variance_Fields_>;
};


/** aggregate fields of "ReportingGroup" */
export type ReportingGroup_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<ReportingGroup_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ReportingGroup" */
export type ReportingGroup_Aggregate_Order_By_ = {
  avg?: InputMaybe<ReportingGroup_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<ReportingGroup_Max_Order_By_>;
  min?: InputMaybe<ReportingGroup_Min_Order_By_>;
  stddev?: InputMaybe<ReportingGroup_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<ReportingGroup_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<ReportingGroup_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<ReportingGroup_Sum_Order_By_>;
  var_pop?: InputMaybe<ReportingGroup_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<ReportingGroup_Var_Samp_Order_By_>;
  variance?: InputMaybe<ReportingGroup_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "ReportingGroup" */
export type ReportingGroup_Arr_Rel_Insert_Input_ = {
  data: Array<ReportingGroup_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<ReportingGroup_On_Conflict_>;
};

/** aggregate avg on columns */
export type ReportingGroup_Avg_Fields_ = {
  __typename?: 'ReportingGroup_avg_fields';
  orderIndex?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "ReportingGroup" */
export type ReportingGroup_Avg_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "ReportingGroup". All fields are combined with a logical 'AND'. */
export type ReportingGroup_Bool_Exp_ = {
  _and?: InputMaybe<Array<ReportingGroup_Bool_Exp_>>;
  _not?: InputMaybe<ReportingGroup_Bool_Exp_>;
  _or?: InputMaybe<Array<ReportingGroup_Bool_Exp_>>;
  businessUnits?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
  businessUnits_aggregate?: InputMaybe<BusinessUnitAssessment_Aggregate_Bool_Exp_>;
  cAssessment?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  companyAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  orderIndex?: InputMaybe<Numeric_Comparison_Exp_>;
  owner?: InputMaybe<Users_Bool_Exp_>;
  ownerId?: InputMaybe<Uuid_Comparison_Exp_>;
  parent?: InputMaybe<ReportingGroup_Bool_Exp_>;
  parentId?: InputMaybe<Uuid_Comparison_Exp_>;
  reportingSubGroups?: InputMaybe<ReportingGroup_Bool_Exp_>;
  reportingSubGroups_aggregate?: InputMaybe<ReportingGroup_Aggregate_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "ReportingGroup" */
export enum ReportingGroup_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  ReportingGroupPkey_ = 'ReportingGroup_pkey'
}

/** input type for incrementing numeric columns in table "ReportingGroup" */
export type ReportingGroup_Inc_Input_ = {
  orderIndex?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "ReportingGroup" */
export type ReportingGroup_Insert_Input_ = {
  businessUnits?: InputMaybe<BusinessUnitAssessment_Arr_Rel_Insert_Input_>;
  cAssessment?: InputMaybe<CompanyAssessment_Obj_Rel_Insert_Input_>;
  companyAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['numeric']['input']>;
  owner?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  parent?: InputMaybe<ReportingGroup_Obj_Rel_Insert_Input_>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  reportingSubGroups?: InputMaybe<ReportingGroup_Arr_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ReportingGroup_Max_Fields_ = {
  __typename?: 'ReportingGroup_max_fields';
  companyAssessmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderIndex?: Maybe<Scalars['numeric']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  parentId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "ReportingGroup" */
export type ReportingGroup_Max_Order_By_ = {
  companyAssessmentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  orderIndex?: InputMaybe<Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  parentId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type ReportingGroup_Min_Fields_ = {
  __typename?: 'ReportingGroup_min_fields';
  companyAssessmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orderIndex?: Maybe<Scalars['numeric']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  parentId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "ReportingGroup" */
export type ReportingGroup_Min_Order_By_ = {
  companyAssessmentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  orderIndex?: InputMaybe<Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  parentId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "ReportingGroup" */
export type ReportingGroup_Mutation_Response_ = {
  __typename?: 'ReportingGroup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ReportingGroup_>;
};

/** input type for inserting object relation for remote table "ReportingGroup" */
export type ReportingGroup_Obj_Rel_Insert_Input_ = {
  data: ReportingGroup_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<ReportingGroup_On_Conflict_>;
};

/** on_conflict condition type for table "ReportingGroup" */
export type ReportingGroup_On_Conflict_ = {
  constraint: ReportingGroup_Constraint_;
  update_columns?: Array<ReportingGroup_Update_Column_>;
  where?: InputMaybe<ReportingGroup_Bool_Exp_>;
};

/** Ordering options when selecting data from "ReportingGroup". */
export type ReportingGroup_Order_By_ = {
  businessUnits_aggregate?: InputMaybe<BusinessUnitAssessment_Aggregate_Order_By_>;
  cAssessment?: InputMaybe<CompanyAssessment_Order_By_>;
  companyAssessmentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  orderIndex?: InputMaybe<Order_By_>;
  owner?: InputMaybe<Users_Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  parent?: InputMaybe<ReportingGroup_Order_By_>;
  parentId?: InputMaybe<Order_By_>;
  reportingSubGroups_aggregate?: InputMaybe<ReportingGroup_Aggregate_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: ReportingGroup */
export type ReportingGroup_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ReportingGroup" */
export enum ReportingGroup_Select_Column_ {
  /** column name */
  CompanyAssessmentId_ = 'companyAssessmentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Name_ = 'name',
  /** column name */
  OrderIndex_ = 'orderIndex',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  ParentId_ = 'parentId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "ReportingGroup" */
export type ReportingGroup_Set_Input_ = {
  companyAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['numeric']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type ReportingGroup_Stddev_Fields_ = {
  __typename?: 'ReportingGroup_stddev_fields';
  orderIndex?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "ReportingGroup" */
export type ReportingGroup_Stddev_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type ReportingGroup_Stddev_Pop_Fields_ = {
  __typename?: 'ReportingGroup_stddev_pop_fields';
  orderIndex?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "ReportingGroup" */
export type ReportingGroup_Stddev_Pop_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type ReportingGroup_Stddev_Samp_Fields_ = {
  __typename?: 'ReportingGroup_stddev_samp_fields';
  orderIndex?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "ReportingGroup" */
export type ReportingGroup_Stddev_Samp_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "ReportingGroup" */
export type ReportingGroup_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: ReportingGroup_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type ReportingGroup_Stream_Cursor_Value_Input_ = {
  companyAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderIndex?: InputMaybe<Scalars['numeric']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  parentId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type ReportingGroup_Sum_Fields_ = {
  __typename?: 'ReportingGroup_sum_fields';
  orderIndex?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "ReportingGroup" */
export type ReportingGroup_Sum_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

/** update columns of table "ReportingGroup" */
export enum ReportingGroup_Update_Column_ {
  /** column name */
  CompanyAssessmentId_ = 'companyAssessmentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Name_ = 'name',
  /** column name */
  OrderIndex_ = 'orderIndex',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  ParentId_ = 'parentId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type ReportingGroup_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ReportingGroup_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReportingGroup_Set_Input_>;
  /** filter the rows which have to be updated */
  where: ReportingGroup_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type ReportingGroup_Var_Pop_Fields_ = {
  __typename?: 'ReportingGroup_var_pop_fields';
  orderIndex?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "ReportingGroup" */
export type ReportingGroup_Var_Pop_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type ReportingGroup_Var_Samp_Fields_ = {
  __typename?: 'ReportingGroup_var_samp_fields';
  orderIndex?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "ReportingGroup" */
export type ReportingGroup_Var_Samp_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type ReportingGroup_Variance_Fields_ = {
  __typename?: 'ReportingGroup_variance_fields';
  orderIndex?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "ReportingGroup" */
export type ReportingGroup_Variance_Order_By_ = {
  orderIndex?: InputMaybe<Order_By_>;
};

export type RequestQuoteInput_ = {
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  taxonomyKnowledge: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
};

export type RequestQuoteOutput_ = {
  __typename?: 'RequestQuoteOutput';
  message: Scalars['String']['output'];
};

export type Revenue_ = {
  __typename?: 'Revenue';
  aligned?: Maybe<Scalars['Float']['output']>;
  eligible?: Maybe<Scalars['Float']['output']>;
  enabling?: Maybe<Scalars['Float']['output']>;
  inProgress?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  transitional?: Maybe<Scalars['Float']['output']>;
};

export type SampleOutput_ = {
  __typename?: 'SampleOutput';
  portfolios?: Maybe<Array<Maybe<Portfolios_>>>;
};

export type Scores_ = {
  __typename?: 'Scores';
  capex?: Maybe<Capex_>;
  opex?: Maybe<Opex_>;
  revenue?: Maybe<Revenue_>;
};

/** columns and relationships of "Sector" */
export type Sector_ = {
  __typename?: 'Sector';
  /** An array relationship */
  activities: Array<Activity_>;
  /** An aggregate relationship */
  activities_aggregate: Activity_Aggregate_;
  name: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  referenceNumber?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "Sector" */
export type SectorActivitiesArgs_ = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By_>>;
  where?: InputMaybe<Activity_Bool_Exp_>;
};


/** columns and relationships of "Sector" */
export type SectorActivities_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By_>>;
  where?: InputMaybe<Activity_Bool_Exp_>;
};

/** aggregated selection of "Sector" */
export type Sector_Aggregate_ = {
  __typename?: 'Sector_aggregate';
  aggregate?: Maybe<Sector_Aggregate_Fields_>;
  nodes: Array<Sector_>;
};

/** aggregate fields of "Sector" */
export type Sector_Aggregate_Fields_ = {
  __typename?: 'Sector_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Sector_Max_Fields_>;
  min?: Maybe<Sector_Min_Fields_>;
};


/** aggregate fields of "Sector" */
export type Sector_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Sector_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "Sector". All fields are combined with a logical 'AND'. */
export type Sector_Bool_Exp_ = {
  _and?: InputMaybe<Array<Sector_Bool_Exp_>>;
  _not?: InputMaybe<Sector_Bool_Exp_>;
  _or?: InputMaybe<Array<Sector_Bool_Exp_>>;
  activities?: InputMaybe<Activity_Bool_Exp_>;
  activities_aggregate?: InputMaybe<Activity_Aggregate_Bool_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  referenceNumber?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Sector" */
export enum Sector_Constraint_ {
  /** unique or primary key constraint on columns "name" */
  SectorNameKey_ = 'sector_name_key',
  /** unique or primary key constraint on columns "reference" */
  SectorPkey_ = 'sector_pkey'
}

/** input type for inserting data into table "Sector" */
export type Sector_Insert_Input_ = {
  activities?: InputMaybe<Activity_Arr_Rel_Insert_Input_>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Sector_Max_Fields_ = {
  __typename?: 'Sector_max_fields';
  name?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Sector_Min_Fields_ = {
  __typename?: 'Sector_min_fields';
  name?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "Sector" */
export type Sector_Mutation_Response_ = {
  __typename?: 'Sector_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Sector_>;
};

/** input type for inserting object relation for remote table "Sector" */
export type Sector_Obj_Rel_Insert_Input_ = {
  data: Sector_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Sector_On_Conflict_>;
};

/** on_conflict condition type for table "Sector" */
export type Sector_On_Conflict_ = {
  constraint: Sector_Constraint_;
  update_columns?: Array<Sector_Update_Column_>;
  where?: InputMaybe<Sector_Bool_Exp_>;
};

/** Ordering options when selecting data from "Sector". */
export type Sector_Order_By_ = {
  activities_aggregate?: InputMaybe<Activity_Aggregate_Order_By_>;
  name?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  referenceNumber?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Sector */
export type Sector_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "Sector" */
export enum Sector_Select_Column_ {
  /** column name */
  Name_ = 'name',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  ReferenceNumber_ = 'referenceNumber'
}

/** input type for updating data in table "Sector" */
export type Sector_Set_Input_ = {
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "Sector" */
export type Sector_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Sector_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Sector_Stream_Cursor_Value_Input_ = {
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "Sector" */
export enum Sector_Update_Column_ {
  /** column name */
  Name_ = 'name',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  ReferenceNumber_ = 'referenceNumber'
}

export type Sector_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Sector_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Sector_Bool_Exp_;
};

/** Spaces in the ESG portal that has been shared with other companies */
export type SharedSpace_ = {
  __typename?: 'SharedSpace';
  /** An object relationship */
  company: Company_;
  companyId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  space: Space_;
  spaceId: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "SharedSpace" */
export type SharedSpace_Aggregate_ = {
  __typename?: 'SharedSpace_aggregate';
  aggregate?: Maybe<SharedSpace_Aggregate_Fields_>;
  nodes: Array<SharedSpace_>;
};

export type SharedSpace_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<SharedSpace_Aggregate_Bool_Exp_Count_>;
};

export type SharedSpace_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<SharedSpace_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SharedSpace_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "SharedSpace" */
export type SharedSpace_Aggregate_Fields_ = {
  __typename?: 'SharedSpace_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<SharedSpace_Max_Fields_>;
  min?: Maybe<SharedSpace_Min_Fields_>;
};


/** aggregate fields of "SharedSpace" */
export type SharedSpace_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<SharedSpace_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "SharedSpace" */
export type SharedSpace_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<SharedSpace_Max_Order_By_>;
  min?: InputMaybe<SharedSpace_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "SharedSpace" */
export type SharedSpace_Arr_Rel_Insert_Input_ = {
  data: Array<SharedSpace_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<SharedSpace_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "SharedSpace". All fields are combined with a logical 'AND'. */
export type SharedSpace_Bool_Exp_ = {
  _and?: InputMaybe<Array<SharedSpace_Bool_Exp_>>;
  _not?: InputMaybe<SharedSpace_Bool_Exp_>;
  _or?: InputMaybe<Array<SharedSpace_Bool_Exp_>>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  space?: InputMaybe<Space_Bool_Exp_>;
  spaceId?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "SharedSpace" */
export enum SharedSpace_Constraint_ {
  /** unique or primary key constraint on columns "companyId", "spaceId" */
  SharedSpacePkey_ = 'SharedSpace_pkey'
}

/** input type for inserting data into table "SharedSpace" */
export type SharedSpace_Insert_Input_ = {
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  space?: InputMaybe<Space_Obj_Rel_Insert_Input_>;
  spaceId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type SharedSpace_Max_Fields_ = {
  __typename?: 'SharedSpace_max_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  spaceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "SharedSpace" */
export type SharedSpace_Max_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  spaceId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type SharedSpace_Min_Fields_ = {
  __typename?: 'SharedSpace_min_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  spaceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "SharedSpace" */
export type SharedSpace_Min_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  spaceId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "SharedSpace" */
export type SharedSpace_Mutation_Response_ = {
  __typename?: 'SharedSpace_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<SharedSpace_>;
};

/** on_conflict condition type for table "SharedSpace" */
export type SharedSpace_On_Conflict_ = {
  constraint: SharedSpace_Constraint_;
  update_columns?: Array<SharedSpace_Update_Column_>;
  where?: InputMaybe<SharedSpace_Bool_Exp_>;
};

/** Ordering options when selecting data from "SharedSpace". */
export type SharedSpace_Order_By_ = {
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  space?: InputMaybe<Space_Order_By_>;
  spaceId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: SharedSpace */
export type SharedSpace_Pk_Columns_Input_ = {
  companyId: Scalars['uuid']['input'];
  spaceId: Scalars['String']['input'];
};

/** select columns of table "SharedSpace" */
export enum SharedSpace_Select_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  SpaceId_ = 'spaceId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "SharedSpace" */
export type SharedSpace_Set_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  spaceId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "SharedSpace" */
export type SharedSpace_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: SharedSpace_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type SharedSpace_Stream_Cursor_Value_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  spaceId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "SharedSpace" */
export enum SharedSpace_Update_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  SpaceId_ = 'spaceId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type SharedSpace_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SharedSpace_Set_Input_>;
  /** filter the rows which have to be updated */
  where: SharedSpace_Bool_Exp_;
};

export type ShortCompany_ = {
  __typename?: 'ShortCompany';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Spaces in the community (ESG portal) used in combination with SharedSpaces to give companies access to other companies spaces */
export type Space_ = {
  __typename?: 'Space';
  createdAt: Scalars['timestamptz']['output'];
  /** This correlates to the space slug in Bettermode, the unique string used to navigate to a space. It is not the same as Bettermode's internal space id. */
  id: Scalars['String']['output'];
  /** NOT SYNCED this should only be used for convenience when working in the admin panel */
  name: Scalars['String']['output'];
  /** An array relationship */
  sharedWith: Array<SharedSpace_>;
  /** An aggregate relationship */
  sharedWith_aggregate: SharedSpace_Aggregate_;
  updatedAt: Scalars['timestamptz']['output'];
};


/** Spaces in the community (ESG portal) used in combination with SharedSpaces to give companies access to other companies spaces */
export type SpaceSharedWithArgs_ = {
  distinct_on?: InputMaybe<Array<SharedSpace_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SharedSpace_Order_By_>>;
  where?: InputMaybe<SharedSpace_Bool_Exp_>;
};


/** Spaces in the community (ESG portal) used in combination with SharedSpaces to give companies access to other companies spaces */
export type SpaceSharedWith_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<SharedSpace_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SharedSpace_Order_By_>>;
  where?: InputMaybe<SharedSpace_Bool_Exp_>;
};

/** aggregated selection of "Space" */
export type Space_Aggregate_ = {
  __typename?: 'Space_aggregate';
  aggregate?: Maybe<Space_Aggregate_Fields_>;
  nodes: Array<Space_>;
};

/** aggregate fields of "Space" */
export type Space_Aggregate_Fields_ = {
  __typename?: 'Space_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Space_Max_Fields_>;
  min?: Maybe<Space_Min_Fields_>;
};


/** aggregate fields of "Space" */
export type Space_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Space_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "Space". All fields are combined with a logical 'AND'. */
export type Space_Bool_Exp_ = {
  _and?: InputMaybe<Array<Space_Bool_Exp_>>;
  _not?: InputMaybe<Space_Bool_Exp_>;
  _or?: InputMaybe<Array<Space_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<String_Comparison_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  sharedWith?: InputMaybe<SharedSpace_Bool_Exp_>;
  sharedWith_aggregate?: InputMaybe<SharedSpace_Aggregate_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Space" */
export enum Space_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  SpacePkey_ = 'Space_pkey'
}

/** input type for inserting data into table "Space" */
export type Space_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** This correlates to the space slug in Bettermode, the unique string used to navigate to a space. It is not the same as Bettermode's internal space id. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** NOT SYNCED this should only be used for convenience when working in the admin panel */
  name?: InputMaybe<Scalars['String']['input']>;
  sharedWith?: InputMaybe<SharedSpace_Arr_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Space_Max_Fields_ = {
  __typename?: 'Space_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** This correlates to the space slug in Bettermode, the unique string used to navigate to a space. It is not the same as Bettermode's internal space id. */
  id?: Maybe<Scalars['String']['output']>;
  /** NOT SYNCED this should only be used for convenience when working in the admin panel */
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Space_Min_Fields_ = {
  __typename?: 'Space_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** This correlates to the space slug in Bettermode, the unique string used to navigate to a space. It is not the same as Bettermode's internal space id. */
  id?: Maybe<Scalars['String']['output']>;
  /** NOT SYNCED this should only be used for convenience when working in the admin panel */
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "Space" */
export type Space_Mutation_Response_ = {
  __typename?: 'Space_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Space_>;
};

/** input type for inserting object relation for remote table "Space" */
export type Space_Obj_Rel_Insert_Input_ = {
  data: Space_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Space_On_Conflict_>;
};

/** on_conflict condition type for table "Space" */
export type Space_On_Conflict_ = {
  constraint: Space_Constraint_;
  update_columns?: Array<Space_Update_Column_>;
  where?: InputMaybe<Space_Bool_Exp_>;
};

/** Ordering options when selecting data from "Space". */
export type Space_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  sharedWith_aggregate?: InputMaybe<SharedSpace_Aggregate_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Space */
export type Space_Pk_Columns_Input_ = {
  /** This correlates to the space slug in Bettermode, the unique string used to navigate to a space. It is not the same as Bettermode's internal space id. */
  id: Scalars['String']['input'];
};

/** select columns of table "Space" */
export enum Space_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Name_ = 'name',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "Space" */
export type Space_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** This correlates to the space slug in Bettermode, the unique string used to navigate to a space. It is not the same as Bettermode's internal space id. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** NOT SYNCED this should only be used for convenience when working in the admin panel */
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "Space" */
export type Space_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Space_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Space_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** This correlates to the space slug in Bettermode, the unique string used to navigate to a space. It is not the same as Bettermode's internal space id. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** NOT SYNCED this should only be used for convenience when working in the admin panel */
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "Space" */
export enum Space_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Name_ = 'name',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Space_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Space_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Space_Bool_Exp_;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp_ = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "Subsidiary" */
export type Subsidiary_ = {
  __typename?: 'Subsidiary';
  /** An object relationship */
  company?: Maybe<Company_>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  contactPersonEmail?: Maybe<Scalars['String']['output']>;
  contactPersonName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  ownerGroupAssessment: GroupAssessment_;
  ownerGroupAssessmentId: Scalars['uuid']['output'];
  /** An object relationship */
  sharedCompanyAssessment?: Maybe<CompanyAssessment_>;
  sharedCompanyAssessmentId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  totalFinancials?: Maybe<Financials_>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "Subsidiary" */
export type Subsidiary_Aggregate_ = {
  __typename?: 'Subsidiary_aggregate';
  aggregate?: Maybe<Subsidiary_Aggregate_Fields_>;
  nodes: Array<Subsidiary_>;
};

export type Subsidiary_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Subsidiary_Aggregate_Bool_Exp_Count_>;
};

export type Subsidiary_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Subsidiary_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Subsidiary_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "Subsidiary" */
export type Subsidiary_Aggregate_Fields_ = {
  __typename?: 'Subsidiary_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Subsidiary_Max_Fields_>;
  min?: Maybe<Subsidiary_Min_Fields_>;
};


/** aggregate fields of "Subsidiary" */
export type Subsidiary_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Subsidiary_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Subsidiary" */
export type Subsidiary_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Subsidiary_Max_Order_By_>;
  min?: InputMaybe<Subsidiary_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "Subsidiary" */
export type Subsidiary_Arr_Rel_Insert_Input_ = {
  data: Array<Subsidiary_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Subsidiary_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "Subsidiary". All fields are combined with a logical 'AND'. */
export type Subsidiary_Bool_Exp_ = {
  _and?: InputMaybe<Array<Subsidiary_Bool_Exp_>>;
  _not?: InputMaybe<Subsidiary_Bool_Exp_>;
  _or?: InputMaybe<Array<Subsidiary_Bool_Exp_>>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  contactPersonEmail?: InputMaybe<String_Comparison_Exp_>;
  contactPersonName?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  ownerGroupAssessment?: InputMaybe<GroupAssessment_Bool_Exp_>;
  ownerGroupAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  sharedCompanyAssessment?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  sharedCompanyAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  totalFinancials?: InputMaybe<Financials_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Subsidiary" */
export enum Subsidiary_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  SubsidiaryPkey_ = 'Subsidiary_pkey',
  /** unique or primary key constraint on columns "ownerGroupAssessmentId", "companyId" */
  MaxOneUndeletedSubsidiary_ = 'max_one_undeleted_subsidiary'
}

/** input type for inserting data into table "Subsidiary" */
export type Subsidiary_Insert_Input_ = {
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ownerGroupAssessment?: InputMaybe<GroupAssessment_Obj_Rel_Insert_Input_>;
  ownerGroupAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  sharedCompanyAssessment?: InputMaybe<CompanyAssessment_Obj_Rel_Insert_Input_>;
  sharedCompanyAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  totalFinancials?: InputMaybe<Financials_Obj_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Subsidiary_Max_Fields_ = {
  __typename?: 'Subsidiary_max_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  contactPersonEmail?: Maybe<Scalars['String']['output']>;
  contactPersonName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ownerGroupAssessmentId?: Maybe<Scalars['uuid']['output']>;
  sharedCompanyAssessmentId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "Subsidiary" */
export type Subsidiary_Max_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  contactPersonEmail?: InputMaybe<Order_By_>;
  contactPersonName?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  ownerGroupAssessmentId?: InputMaybe<Order_By_>;
  sharedCompanyAssessmentId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Subsidiary_Min_Fields_ = {
  __typename?: 'Subsidiary_min_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  contactPersonEmail?: Maybe<Scalars['String']['output']>;
  contactPersonName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ownerGroupAssessmentId?: Maybe<Scalars['uuid']['output']>;
  sharedCompanyAssessmentId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "Subsidiary" */
export type Subsidiary_Min_Order_By_ = {
  companyId?: InputMaybe<Order_By_>;
  contactPersonEmail?: InputMaybe<Order_By_>;
  contactPersonName?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  ownerGroupAssessmentId?: InputMaybe<Order_By_>;
  sharedCompanyAssessmentId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "Subsidiary" */
export type Subsidiary_Mutation_Response_ = {
  __typename?: 'Subsidiary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Subsidiary_>;
};

/** on_conflict condition type for table "Subsidiary" */
export type Subsidiary_On_Conflict_ = {
  constraint: Subsidiary_Constraint_;
  update_columns?: Array<Subsidiary_Update_Column_>;
  where?: InputMaybe<Subsidiary_Bool_Exp_>;
};

/** Ordering options when selecting data from "Subsidiary". */
export type Subsidiary_Order_By_ = {
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  contactPersonEmail?: InputMaybe<Order_By_>;
  contactPersonName?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  ownerGroupAssessment?: InputMaybe<GroupAssessment_Order_By_>;
  ownerGroupAssessmentId?: InputMaybe<Order_By_>;
  sharedCompanyAssessment?: InputMaybe<CompanyAssessment_Order_By_>;
  sharedCompanyAssessmentId?: InputMaybe<Order_By_>;
  totalFinancials?: InputMaybe<Financials_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Subsidiary */
export type Subsidiary_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "Subsidiary" */
export enum Subsidiary_Select_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  ContactPersonEmail_ = 'contactPersonEmail',
  /** column name */
  ContactPersonName_ = 'contactPersonName',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  OwnerGroupAssessmentId_ = 'ownerGroupAssessmentId',
  /** column name */
  SharedCompanyAssessmentId_ = 'sharedCompanyAssessmentId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "Subsidiary" */
export type Subsidiary_Set_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ownerGroupAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  sharedCompanyAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "Subsidiary" */
export type Subsidiary_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Subsidiary_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Subsidiary_Stream_Cursor_Value_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  contactPersonEmail?: InputMaybe<Scalars['String']['input']>;
  contactPersonName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ownerGroupAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  sharedCompanyAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "Subsidiary" */
export enum Subsidiary_Update_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  ContactPersonEmail_ = 'contactPersonEmail',
  /** column name */
  ContactPersonName_ = 'contactPersonName',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  OwnerGroupAssessmentId_ = 'ownerGroupAssessmentId',
  /** column name */
  SharedCompanyAssessmentId_ = 'sharedCompanyAssessmentId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Subsidiary_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subsidiary_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Subsidiary_Bool_Exp_;
};

export type SubstantialContributionProportion_ = {
  __typename?: 'SubstantialContributionProportion';
  adaptation?: Maybe<Proportion_>;
  biodiversity?: Maybe<Proportion_>;
  circular?: Maybe<Proportion_>;
  mitigation?: Maybe<Proportion_>;
  pollution?: Maybe<Proportion_>;
  water?: Maybe<Proportion_>;
};

/** columns and relationships of "Tag" */
export type Tag_ = {
  __typename?: 'Tag';
  /** An array relationship */
  Tag_articles: Array<Tag_Articles_>;
  /** An aggregate relationship */
  Tag_articles_aggregate: Tag_Articles_Aggregate_;
  description: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  tagGroup?: Maybe<TagGroup_>;
  tagGroupId?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "Tag" */
export type TagTag_ArticlesArgs_ = {
  distinct_on?: InputMaybe<Array<Tag_Articles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Articles_Order_By_>>;
  where?: InputMaybe<Tag_Articles_Bool_Exp_>;
};


/** columns and relationships of "Tag" */
export type TagTag_Articles_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Tag_Articles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Articles_Order_By_>>;
  where?: InputMaybe<Tag_Articles_Bool_Exp_>;
};

/** columns and relationships of "TagGroup" */
export type TagGroup_ = {
  __typename?: 'TagGroup';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  tags: Array<Tag_>;
  /** An aggregate relationship */
  tags_aggregate: Tag_Aggregate_;
};


/** columns and relationships of "TagGroup" */
export type TagGroupTagsArgs_ = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By_>>;
  where?: InputMaybe<Tag_Bool_Exp_>;
};


/** columns and relationships of "TagGroup" */
export type TagGroupTags_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By_>>;
  where?: InputMaybe<Tag_Bool_Exp_>;
};

/** aggregated selection of "TagGroup" */
export type TagGroup_Aggregate_ = {
  __typename?: 'TagGroup_aggregate';
  aggregate?: Maybe<TagGroup_Aggregate_Fields_>;
  nodes: Array<TagGroup_>;
};

/** aggregate fields of "TagGroup" */
export type TagGroup_Aggregate_Fields_ = {
  __typename?: 'TagGroup_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<TagGroup_Max_Fields_>;
  min?: Maybe<TagGroup_Min_Fields_>;
};


/** aggregate fields of "TagGroup" */
export type TagGroup_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<TagGroup_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "TagGroup". All fields are combined with a logical 'AND'. */
export type TagGroup_Bool_Exp_ = {
  _and?: InputMaybe<Array<TagGroup_Bool_Exp_>>;
  _not?: InputMaybe<TagGroup_Bool_Exp_>;
  _or?: InputMaybe<Array<TagGroup_Bool_Exp_>>;
  description?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  tags?: InputMaybe<Tag_Bool_Exp_>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Bool_Exp_>;
};

/** unique or primary key constraints on table "TagGroup" */
export enum TagGroup_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  TagGroupPkey_ = 'TagGroup_pkey'
}

/** input type for inserting data into table "TagGroup" */
export type TagGroup_Insert_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Tag_Arr_Rel_Insert_Input_>;
};

/** aggregate max on columns */
export type TagGroup_Max_Fields_ = {
  __typename?: 'TagGroup_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TagGroup_Min_Fields_ = {
  __typename?: 'TagGroup_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "TagGroup" */
export type TagGroup_Mutation_Response_ = {
  __typename?: 'TagGroup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TagGroup_>;
};

/** input type for inserting object relation for remote table "TagGroup" */
export type TagGroup_Obj_Rel_Insert_Input_ = {
  data: TagGroup_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<TagGroup_On_Conflict_>;
};

/** on_conflict condition type for table "TagGroup" */
export type TagGroup_On_Conflict_ = {
  constraint: TagGroup_Constraint_;
  update_columns?: Array<TagGroup_Update_Column_>;
  where?: InputMaybe<TagGroup_Bool_Exp_>;
};

/** Ordering options when selecting data from "TagGroup". */
export type TagGroup_Order_By_ = {
  description?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  tags_aggregate?: InputMaybe<Tag_Aggregate_Order_By_>;
};

/** primary key columns input for table: TagGroup */
export type TagGroup_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "TagGroup" */
export enum TagGroup_Select_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  Id_ = 'id',
  /** column name */
  Name_ = 'name'
}

/** input type for updating data in table "TagGroup" */
export type TagGroup_Set_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "TagGroup" */
export type TagGroup_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: TagGroup_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type TagGroup_Stream_Cursor_Value_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "TagGroup" */
export enum TagGroup_Update_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  Id_ = 'id',
  /** column name */
  Name_ = 'name'
}

export type TagGroup_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TagGroup_Set_Input_>;
  /** filter the rows which have to be updated */
  where: TagGroup_Bool_Exp_;
};

/** columns and relationships of "esrs.TagType" */
export type TagType_ = {
  __typename?: 'TagType';
  alwaysAll: Scalars['Boolean']['output'];
  /** An array relationship */
  materialMetricTags: Array<Esrs_MaterialMetricTag_>;
  /** An aggregate relationship */
  materialMetricTags_aggregate: Esrs_MaterialMetricTag_Aggregate_;
  /** An array relationship */
  metricTags: Array<MetricTag_>;
  /** An aggregate relationship */
  metricTags_aggregate: MetricTag_Aggregate_;
  /** An array relationship */
  tagValues: Array<TagValue_>;
  /** An aggregate relationship */
  tagValues_aggregate: TagValue_Aggregate_;
  type: Scalars['String']['output'];
};


/** columns and relationships of "esrs.TagType" */
export type TagTypeMaterialMetricTagsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetricTag_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
};


/** columns and relationships of "esrs.TagType" */
export type TagTypeMaterialMetricTags_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetricTag_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
};


/** columns and relationships of "esrs.TagType" */
export type TagTypeMetricTagsArgs_ = {
  distinct_on?: InputMaybe<Array<MetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricTag_Order_By_>>;
  where?: InputMaybe<MetricTag_Bool_Exp_>;
};


/** columns and relationships of "esrs.TagType" */
export type TagTypeMetricTags_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricTag_Order_By_>>;
  where?: InputMaybe<MetricTag_Bool_Exp_>;
};


/** columns and relationships of "esrs.TagType" */
export type TagTypeTagValuesArgs_ = {
  distinct_on?: InputMaybe<Array<TagValue_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagValue_Order_By_>>;
  where?: InputMaybe<TagValue_Bool_Exp_>;
};


/** columns and relationships of "esrs.TagType" */
export type TagTypeTagValues_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TagValue_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagValue_Order_By_>>;
  where?: InputMaybe<TagValue_Bool_Exp_>;
};

/** aggregated selection of "esrs.TagType" */
export type TagType_Aggregate_ = {
  __typename?: 'TagType_aggregate';
  aggregate?: Maybe<TagType_Aggregate_Fields_>;
  nodes: Array<TagType_>;
};

/** aggregate fields of "esrs.TagType" */
export type TagType_Aggregate_Fields_ = {
  __typename?: 'TagType_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<TagType_Max_Fields_>;
  min?: Maybe<TagType_Min_Fields_>;
};


/** aggregate fields of "esrs.TagType" */
export type TagType_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<TagType_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "esrs.TagType". All fields are combined with a logical 'AND'. */
export type TagType_Bool_Exp_ = {
  _and?: InputMaybe<Array<TagType_Bool_Exp_>>;
  _not?: InputMaybe<TagType_Bool_Exp_>;
  _or?: InputMaybe<Array<TagType_Bool_Exp_>>;
  alwaysAll?: InputMaybe<Boolean_Comparison_Exp_>;
  materialMetricTags?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
  materialMetricTags_aggregate?: InputMaybe<Esrs_MaterialMetricTag_Aggregate_Bool_Exp_>;
  metricTags?: InputMaybe<MetricTag_Bool_Exp_>;
  metricTags_aggregate?: InputMaybe<MetricTag_Aggregate_Bool_Exp_>;
  tagValues?: InputMaybe<TagValue_Bool_Exp_>;
  tagValues_aggregate?: InputMaybe<TagValue_Aggregate_Bool_Exp_>;
  type?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.TagType" */
export enum TagType_Constraint_ {
  /** unique or primary key constraint on columns "type" */
  TagTypePkey_ = 'TagType_pkey'
}

/** input type for inserting data into table "esrs.TagType" */
export type TagType_Insert_Input_ = {
  alwaysAll?: InputMaybe<Scalars['Boolean']['input']>;
  materialMetricTags?: InputMaybe<Esrs_MaterialMetricTag_Arr_Rel_Insert_Input_>;
  metricTags?: InputMaybe<MetricTag_Arr_Rel_Insert_Input_>;
  tagValues?: InputMaybe<TagValue_Arr_Rel_Insert_Input_>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TagType_Max_Fields_ = {
  __typename?: 'TagType_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TagType_Min_Fields_ = {
  __typename?: 'TagType_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "esrs.TagType" */
export type TagType_Mutation_Response_ = {
  __typename?: 'TagType_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TagType_>;
};

/** input type for inserting object relation for remote table "esrs.TagType" */
export type TagType_Obj_Rel_Insert_Input_ = {
  data: TagType_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<TagType_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.TagType" */
export type TagType_On_Conflict_ = {
  constraint: TagType_Constraint_;
  update_columns?: Array<TagType_Update_Column_>;
  where?: InputMaybe<TagType_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.TagType". */
export type TagType_Order_By_ = {
  alwaysAll?: InputMaybe<Order_By_>;
  materialMetricTags_aggregate?: InputMaybe<Esrs_MaterialMetricTag_Aggregate_Order_By_>;
  metricTags_aggregate?: InputMaybe<MetricTag_Aggregate_Order_By_>;
  tagValues_aggregate?: InputMaybe<TagValue_Aggregate_Order_By_>;
  type?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.TagType */
export type TagType_Pk_Columns_Input_ = {
  type: Scalars['String']['input'];
};

/** select columns of table "esrs.TagType" */
export enum TagType_Select_Column_ {
  /** column name */
  AlwaysAll_ = 'alwaysAll',
  /** column name */
  Type_ = 'type'
}

/** input type for updating data in table "esrs.TagType" */
export type TagType_Set_Input_ = {
  alwaysAll?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "TagType" */
export type TagType_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: TagType_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type TagType_Stream_Cursor_Value_Input_ = {
  alwaysAll?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.TagType" */
export enum TagType_Update_Column_ {
  /** column name */
  AlwaysAll_ = 'alwaysAll',
  /** column name */
  Type_ = 'type'
}

export type TagType_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TagType_Set_Input_>;
  /** filter the rows which have to be updated */
  where: TagType_Bool_Exp_;
};

/** columns and relationships of "esrs.TagValue" */
export type TagValue_ = {
  __typename?: 'TagValue';
  order: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** aggregated selection of "esrs.TagValue" */
export type TagValue_Aggregate_ = {
  __typename?: 'TagValue_aggregate';
  aggregate?: Maybe<TagValue_Aggregate_Fields_>;
  nodes: Array<TagValue_>;
};

export type TagValue_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<TagValue_Aggregate_Bool_Exp_Count_>;
};

export type TagValue_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<TagValue_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TagValue_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.TagValue" */
export type TagValue_Aggregate_Fields_ = {
  __typename?: 'TagValue_aggregate_fields';
  avg?: Maybe<TagValue_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<TagValue_Max_Fields_>;
  min?: Maybe<TagValue_Min_Fields_>;
  stddev?: Maybe<TagValue_Stddev_Fields_>;
  stddev_pop?: Maybe<TagValue_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<TagValue_Stddev_Samp_Fields_>;
  sum?: Maybe<TagValue_Sum_Fields_>;
  var_pop?: Maybe<TagValue_Var_Pop_Fields_>;
  var_samp?: Maybe<TagValue_Var_Samp_Fields_>;
  variance?: Maybe<TagValue_Variance_Fields_>;
};


/** aggregate fields of "esrs.TagValue" */
export type TagValue_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<TagValue_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.TagValue" */
export type TagValue_Aggregate_Order_By_ = {
  avg?: InputMaybe<TagValue_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<TagValue_Max_Order_By_>;
  min?: InputMaybe<TagValue_Min_Order_By_>;
  stddev?: InputMaybe<TagValue_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<TagValue_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<TagValue_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<TagValue_Sum_Order_By_>;
  var_pop?: InputMaybe<TagValue_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<TagValue_Var_Samp_Order_By_>;
  variance?: InputMaybe<TagValue_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.TagValue" */
export type TagValue_Arr_Rel_Insert_Input_ = {
  data: Array<TagValue_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<TagValue_On_Conflict_>;
};

/** aggregate avg on columns */
export type TagValue_Avg_Fields_ = {
  __typename?: 'TagValue_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.TagValue" */
export type TagValue_Avg_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.TagValue". All fields are combined with a logical 'AND'. */
export type TagValue_Bool_Exp_ = {
  _and?: InputMaybe<Array<TagValue_Bool_Exp_>>;
  _not?: InputMaybe<TagValue_Bool_Exp_>;
  _or?: InputMaybe<Array<TagValue_Bool_Exp_>>;
  order?: InputMaybe<Int_Comparison_Exp_>;
  type?: InputMaybe<String_Comparison_Exp_>;
  value?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.TagValue" */
export enum TagValue_Constraint_ {
  /** unique or primary key constraint on columns "type", "value" */
  TagValuePkey_ = 'TagValue_pkey'
}

/** input type for incrementing numeric columns in table "esrs.TagValue" */
export type TagValue_Inc_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.TagValue" */
export type TagValue_Insert_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TagValue_Max_Fields_ = {
  __typename?: 'TagValue_max_fields';
  order?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.TagValue" */
export type TagValue_Max_Order_By_ = {
  order?: InputMaybe<Order_By_>;
  type?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type TagValue_Min_Fields_ = {
  __typename?: 'TagValue_min_fields';
  order?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.TagValue" */
export type TagValue_Min_Order_By_ = {
  order?: InputMaybe<Order_By_>;
  type?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.TagValue" */
export type TagValue_Mutation_Response_ = {
  __typename?: 'TagValue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TagValue_>;
};

/** input type for inserting object relation for remote table "esrs.TagValue" */
export type TagValue_Obj_Rel_Insert_Input_ = {
  data: TagValue_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<TagValue_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.TagValue" */
export type TagValue_On_Conflict_ = {
  constraint: TagValue_Constraint_;
  update_columns?: Array<TagValue_Update_Column_>;
  where?: InputMaybe<TagValue_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.TagValue". */
export type TagValue_Order_By_ = {
  order?: InputMaybe<Order_By_>;
  type?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.TagValue */
export type TagValue_Pk_Columns_Input_ = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** select columns of table "esrs.TagValue" */
export enum TagValue_Select_Column_ {
  /** column name */
  Order_ = 'order',
  /** column name */
  Type_ = 'type',
  /** column name */
  Value_ = 'value'
}

/** input type for updating data in table "esrs.TagValue" */
export type TagValue_Set_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type TagValue_Stddev_Fields_ = {
  __typename?: 'TagValue_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.TagValue" */
export type TagValue_Stddev_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type TagValue_Stddev_Pop_Fields_ = {
  __typename?: 'TagValue_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.TagValue" */
export type TagValue_Stddev_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type TagValue_Stddev_Samp_Fields_ = {
  __typename?: 'TagValue_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.TagValue" */
export type TagValue_Stddev_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "TagValue" */
export type TagValue_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: TagValue_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type TagValue_Stream_Cursor_Value_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type TagValue_Sum_Fields_ = {
  __typename?: 'TagValue_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.TagValue" */
export type TagValue_Sum_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.TagValue" */
export enum TagValue_Update_Column_ {
  /** column name */
  Order_ = 'order',
  /** column name */
  Type_ = 'type',
  /** column name */
  Value_ = 'value'
}

export type TagValue_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TagValue_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TagValue_Set_Input_>;
  /** filter the rows which have to be updated */
  where: TagValue_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type TagValue_Var_Pop_Fields_ = {
  __typename?: 'TagValue_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.TagValue" */
export type TagValue_Var_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type TagValue_Var_Samp_Fields_ = {
  __typename?: 'TagValue_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.TagValue" */
export type TagValue_Var_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type TagValue_Variance_Fields_ = {
  __typename?: 'TagValue_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.TagValue" */
export type TagValue_Variance_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregated selection of "Tag" */
export type Tag_Aggregate_ = {
  __typename?: 'Tag_aggregate';
  aggregate?: Maybe<Tag_Aggregate_Fields_>;
  nodes: Array<Tag_>;
};

export type Tag_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Tag_Aggregate_Bool_Exp_Count_>;
};

export type Tag_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Tag_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tag_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "Tag" */
export type Tag_Aggregate_Fields_ = {
  __typename?: 'Tag_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Tag_Max_Fields_>;
  min?: Maybe<Tag_Min_Fields_>;
};


/** aggregate fields of "Tag" */
export type Tag_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Tag_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Tag" */
export type Tag_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Tag_Max_Order_By_>;
  min?: InputMaybe<Tag_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "Tag" */
export type Tag_Arr_Rel_Insert_Input_ = {
  data: Array<Tag_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_On_Conflict_>;
};

/** columns and relationships of "Tag_articles" */
export type Tag_Articles_ = {
  __typename?: 'Tag_articles';
  /** An object relationship */
  Article: Article_;
  /** An object relationship */
  Tag: Tag_;
  article_id: Scalars['uuid']['output'];
  id: Scalars['bigint']['output'];
  tag_id: Scalars['uuid']['output'];
};

/** aggregated selection of "Tag_articles" */
export type Tag_Articles_Aggregate_ = {
  __typename?: 'Tag_articles_aggregate';
  aggregate?: Maybe<Tag_Articles_Aggregate_Fields_>;
  nodes: Array<Tag_Articles_>;
};

export type Tag_Articles_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Tag_Articles_Aggregate_Bool_Exp_Count_>;
};

export type Tag_Articles_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Tag_Articles_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Tag_Articles_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "Tag_articles" */
export type Tag_Articles_Aggregate_Fields_ = {
  __typename?: 'Tag_articles_aggregate_fields';
  avg?: Maybe<Tag_Articles_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<Tag_Articles_Max_Fields_>;
  min?: Maybe<Tag_Articles_Min_Fields_>;
  stddev?: Maybe<Tag_Articles_Stddev_Fields_>;
  stddev_pop?: Maybe<Tag_Articles_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<Tag_Articles_Stddev_Samp_Fields_>;
  sum?: Maybe<Tag_Articles_Sum_Fields_>;
  var_pop?: Maybe<Tag_Articles_Var_Pop_Fields_>;
  var_samp?: Maybe<Tag_Articles_Var_Samp_Fields_>;
  variance?: Maybe<Tag_Articles_Variance_Fields_>;
};


/** aggregate fields of "Tag_articles" */
export type Tag_Articles_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Tag_Articles_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "Tag_articles" */
export type Tag_Articles_Aggregate_Order_By_ = {
  avg?: InputMaybe<Tag_Articles_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Tag_Articles_Max_Order_By_>;
  min?: InputMaybe<Tag_Articles_Min_Order_By_>;
  stddev?: InputMaybe<Tag_Articles_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<Tag_Articles_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<Tag_Articles_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<Tag_Articles_Sum_Order_By_>;
  var_pop?: InputMaybe<Tag_Articles_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<Tag_Articles_Var_Samp_Order_By_>;
  variance?: InputMaybe<Tag_Articles_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "Tag_articles" */
export type Tag_Articles_Arr_Rel_Insert_Input_ = {
  data: Array<Tag_Articles_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_Articles_On_Conflict_>;
};

/** aggregate avg on columns */
export type Tag_Articles_Avg_Fields_ = {
  __typename?: 'Tag_articles_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "Tag_articles" */
export type Tag_Articles_Avg_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "Tag_articles". All fields are combined with a logical 'AND'. */
export type Tag_Articles_Bool_Exp_ = {
  Article?: InputMaybe<Article_Bool_Exp_>;
  Tag?: InputMaybe<Tag_Bool_Exp_>;
  _and?: InputMaybe<Array<Tag_Articles_Bool_Exp_>>;
  _not?: InputMaybe<Tag_Articles_Bool_Exp_>;
  _or?: InputMaybe<Array<Tag_Articles_Bool_Exp_>>;
  article_id?: InputMaybe<Uuid_Comparison_Exp_>;
  id?: InputMaybe<Bigint_Comparison_Exp_>;
  tag_id?: InputMaybe<Uuid_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Tag_articles" */
export enum Tag_Articles_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  TagArticlesPkey_ = 'Tag_articles_pkey',
  /** unique or primary key constraint on columns "tag_id", "article_id" */
  TagArticlesTagIdArticleId_13fc8a18Uniq_ = 'Tag_articles_tag_id_article_id_13fc8a18_uniq'
}

/** input type for incrementing numeric columns in table "Tag_articles" */
export type Tag_Articles_Inc_Input_ = {
  id?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "Tag_articles" */
export type Tag_Articles_Insert_Input_ = {
  Article?: InputMaybe<Article_Obj_Rel_Insert_Input_>;
  Tag?: InputMaybe<Tag_Obj_Rel_Insert_Input_>;
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Tag_Articles_Max_Fields_ = {
  __typename?: 'Tag_articles_max_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  tag_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "Tag_articles" */
export type Tag_Articles_Max_Order_By_ = {
  article_id?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  tag_id?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Tag_Articles_Min_Fields_ = {
  __typename?: 'Tag_articles_min_fields';
  article_id?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['bigint']['output']>;
  tag_id?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "Tag_articles" */
export type Tag_Articles_Min_Order_By_ = {
  article_id?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  tag_id?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "Tag_articles" */
export type Tag_Articles_Mutation_Response_ = {
  __typename?: 'Tag_articles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag_Articles_>;
};

/** on_conflict condition type for table "Tag_articles" */
export type Tag_Articles_On_Conflict_ = {
  constraint: Tag_Articles_Constraint_;
  update_columns?: Array<Tag_Articles_Update_Column_>;
  where?: InputMaybe<Tag_Articles_Bool_Exp_>;
};

/** Ordering options when selecting data from "Tag_articles". */
export type Tag_Articles_Order_By_ = {
  Article?: InputMaybe<Article_Order_By_>;
  Tag?: InputMaybe<Tag_Order_By_>;
  article_id?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  tag_id?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Tag_articles */
export type Tag_Articles_Pk_Columns_Input_ = {
  id: Scalars['bigint']['input'];
};

/** select columns of table "Tag_articles" */
export enum Tag_Articles_Select_Column_ {
  /** column name */
  ArticleId_ = 'article_id',
  /** column name */
  Id_ = 'id',
  /** column name */
  TagId_ = 'tag_id'
}

/** input type for updating data in table "Tag_articles" */
export type Tag_Articles_Set_Input_ = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Tag_Articles_Stddev_Fields_ = {
  __typename?: 'Tag_articles_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "Tag_articles" */
export type Tag_Articles_Stddev_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type Tag_Articles_Stddev_Pop_Fields_ = {
  __typename?: 'Tag_articles_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "Tag_articles" */
export type Tag_Articles_Stddev_Pop_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type Tag_Articles_Stddev_Samp_Fields_ = {
  __typename?: 'Tag_articles_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "Tag_articles" */
export type Tag_Articles_Stddev_Samp_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "Tag_articles" */
export type Tag_Articles_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Tag_Articles_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Articles_Stream_Cursor_Value_Input_ = {
  article_id?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['bigint']['input']>;
  tag_id?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Tag_Articles_Sum_Fields_ = {
  __typename?: 'Tag_articles_sum_fields';
  id?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "Tag_articles" */
export type Tag_Articles_Sum_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** update columns of table "Tag_articles" */
export enum Tag_Articles_Update_Column_ {
  /** column name */
  ArticleId_ = 'article_id',
  /** column name */
  Id_ = 'id',
  /** column name */
  TagId_ = 'tag_id'
}

export type Tag_Articles_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tag_Articles_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tag_Articles_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Tag_Articles_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type Tag_Articles_Var_Pop_Fields_ = {
  __typename?: 'Tag_articles_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "Tag_articles" */
export type Tag_Articles_Var_Pop_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type Tag_Articles_Var_Samp_Fields_ = {
  __typename?: 'Tag_articles_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "Tag_articles" */
export type Tag_Articles_Var_Samp_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type Tag_Articles_Variance_Fields_ = {
  __typename?: 'Tag_articles_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "Tag_articles" */
export type Tag_Articles_Variance_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "Tag". All fields are combined with a logical 'AND'. */
export type Tag_Bool_Exp_ = {
  Tag_articles?: InputMaybe<Tag_Articles_Bool_Exp_>;
  Tag_articles_aggregate?: InputMaybe<Tag_Articles_Aggregate_Bool_Exp_>;
  _and?: InputMaybe<Array<Tag_Bool_Exp_>>;
  _not?: InputMaybe<Tag_Bool_Exp_>;
  _or?: InputMaybe<Array<Tag_Bool_Exp_>>;
  description?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  tagGroup?: InputMaybe<TagGroup_Bool_Exp_>;
  tagGroupId?: InputMaybe<Uuid_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Tag" */
export enum Tag_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  TagPkey_ = 'Tag_pkey'
}

/** input type for inserting data into table "Tag" */
export type Tag_Insert_Input_ = {
  Tag_articles?: InputMaybe<Tag_Articles_Arr_Rel_Insert_Input_>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagGroup?: InputMaybe<TagGroup_Obj_Rel_Insert_Input_>;
  tagGroupId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Tag_Max_Fields_ = {
  __typename?: 'Tag_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tagGroupId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "Tag" */
export type Tag_Max_Order_By_ = {
  description?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  tagGroupId?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Tag_Min_Fields_ = {
  __typename?: 'Tag_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tagGroupId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "Tag" */
export type Tag_Min_Order_By_ = {
  description?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  tagGroupId?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "Tag" */
export type Tag_Mutation_Response_ = {
  __typename?: 'Tag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tag_>;
};

/** input type for inserting object relation for remote table "Tag" */
export type Tag_Obj_Rel_Insert_Input_ = {
  data: Tag_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Tag_On_Conflict_>;
};

/** on_conflict condition type for table "Tag" */
export type Tag_On_Conflict_ = {
  constraint: Tag_Constraint_;
  update_columns?: Array<Tag_Update_Column_>;
  where?: InputMaybe<Tag_Bool_Exp_>;
};

/** Ordering options when selecting data from "Tag". */
export type Tag_Order_By_ = {
  Tag_articles_aggregate?: InputMaybe<Tag_Articles_Aggregate_Order_By_>;
  description?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  tagGroup?: InputMaybe<TagGroup_Order_By_>;
  tagGroupId?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Tag */
export type Tag_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "Tag" */
export enum Tag_Select_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  Id_ = 'id',
  /** column name */
  Name_ = 'name',
  /** column name */
  TagGroupId_ = 'tagGroupId'
}

/** input type for updating data in table "Tag" */
export type Tag_Set_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagGroupId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "Tag" */
export type Tag_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Tag_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Tag_Stream_Cursor_Value_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tagGroupId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "Tag" */
export enum Tag_Update_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  Id_ = 'id',
  /** column name */
  Name_ = 'name',
  /** column name */
  TagGroupId_ = 'tagGroupId'
}

export type Tag_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tag_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Tag_Bool_Exp_;
};

/** columns and relationships of "esrs.TargetQuestion" */
export type TargetQuestion_ = {
  __typename?: 'TargetQuestion';
  /** An object relationship */
  choiceSet?: Maybe<ChoiceSet_>;
  choiceSetRef?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  firstLevel?: Maybe<Scalars['String']['output']>;
  globalOrder?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  group?: Maybe<TargetQuestionGroup_>;
  groupRef?: Maybe<Scalars['String']['output']>;
  isAR: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  questionType: QuestionType_Enum_;
  reference: Scalars['String']['output'];
  secondLevel?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  standard: EsrsStandard_;
  standardRef: Scalars['String']['output'];
  title: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** columns and relationships of "esrs.TargetQuestionGroup" */
export type TargetQuestionGroup_ = {
  __typename?: 'TargetQuestionGroup';
  reference: Scalars['String']['output'];
  /** An array relationship */
  targetQuestions: Array<TargetQuestion_>;
  /** An aggregate relationship */
  targetQuestions_aggregate: TargetQuestion_Aggregate_;
  title: Scalars['String']['output'];
};


/** columns and relationships of "esrs.TargetQuestionGroup" */
export type TargetQuestionGroupTargetQuestionsArgs_ = {
  distinct_on?: InputMaybe<Array<TargetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestion_Order_By_>>;
  where?: InputMaybe<TargetQuestion_Bool_Exp_>;
};


/** columns and relationships of "esrs.TargetQuestionGroup" */
export type TargetQuestionGroupTargetQuestions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TargetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestion_Order_By_>>;
  where?: InputMaybe<TargetQuestion_Bool_Exp_>;
};

/** aggregated selection of "esrs.TargetQuestionGroup" */
export type TargetQuestionGroup_Aggregate_ = {
  __typename?: 'TargetQuestionGroup_aggregate';
  aggregate?: Maybe<TargetQuestionGroup_Aggregate_Fields_>;
  nodes: Array<TargetQuestionGroup_>;
};

/** aggregate fields of "esrs.TargetQuestionGroup" */
export type TargetQuestionGroup_Aggregate_Fields_ = {
  __typename?: 'TargetQuestionGroup_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<TargetQuestionGroup_Max_Fields_>;
  min?: Maybe<TargetQuestionGroup_Min_Fields_>;
};


/** aggregate fields of "esrs.TargetQuestionGroup" */
export type TargetQuestionGroup_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<TargetQuestionGroup_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "esrs.TargetQuestionGroup". All fields are combined with a logical 'AND'. */
export type TargetQuestionGroup_Bool_Exp_ = {
  _and?: InputMaybe<Array<TargetQuestionGroup_Bool_Exp_>>;
  _not?: InputMaybe<TargetQuestionGroup_Bool_Exp_>;
  _or?: InputMaybe<Array<TargetQuestionGroup_Bool_Exp_>>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  targetQuestions?: InputMaybe<TargetQuestion_Bool_Exp_>;
  targetQuestions_aggregate?: InputMaybe<TargetQuestion_Aggregate_Bool_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.TargetQuestionGroup" */
export enum TargetQuestionGroup_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  TargetQuestionGroupPkey_ = 'TargetQuestionGroup_pkey'
}

/** input type for inserting data into table "esrs.TargetQuestionGroup" */
export type TargetQuestionGroup_Insert_Input_ = {
  reference?: InputMaybe<Scalars['String']['input']>;
  targetQuestions?: InputMaybe<TargetQuestion_Arr_Rel_Insert_Input_>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TargetQuestionGroup_Max_Fields_ = {
  __typename?: 'TargetQuestionGroup_max_fields';
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TargetQuestionGroup_Min_Fields_ = {
  __typename?: 'TargetQuestionGroup_min_fields';
  reference?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "esrs.TargetQuestionGroup" */
export type TargetQuestionGroup_Mutation_Response_ = {
  __typename?: 'TargetQuestionGroup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TargetQuestionGroup_>;
};

/** input type for inserting object relation for remote table "esrs.TargetQuestionGroup" */
export type TargetQuestionGroup_Obj_Rel_Insert_Input_ = {
  data: TargetQuestionGroup_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<TargetQuestionGroup_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.TargetQuestionGroup" */
export type TargetQuestionGroup_On_Conflict_ = {
  constraint: TargetQuestionGroup_Constraint_;
  update_columns?: Array<TargetQuestionGroup_Update_Column_>;
  where?: InputMaybe<TargetQuestionGroup_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.TargetQuestionGroup". */
export type TargetQuestionGroup_Order_By_ = {
  reference?: InputMaybe<Order_By_>;
  targetQuestions_aggregate?: InputMaybe<TargetQuestion_Aggregate_Order_By_>;
  title?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.TargetQuestionGroup */
export type TargetQuestionGroup_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.TargetQuestionGroup" */
export enum TargetQuestionGroup_Select_Column_ {
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

/** input type for updating data in table "esrs.TargetQuestionGroup" */
export type TargetQuestionGroup_Set_Input_ = {
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "TargetQuestionGroup" */
export type TargetQuestionGroup_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: TargetQuestionGroup_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type TargetQuestionGroup_Stream_Cursor_Value_Input_ = {
  reference?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.TargetQuestionGroup" */
export enum TargetQuestionGroup_Update_Column_ {
  /** column name */
  Reference_ = 'reference',
  /** column name */
  Title_ = 'title'
}

export type TargetQuestionGroup_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TargetQuestionGroup_Set_Input_>;
  /** filter the rows which have to be updated */
  where: TargetQuestionGroup_Bool_Exp_;
};

/** aggregated selection of "esrs.TargetQuestion" */
export type TargetQuestion_Aggregate_ = {
  __typename?: 'TargetQuestion_aggregate';
  aggregate?: Maybe<TargetQuestion_Aggregate_Fields_>;
  nodes: Array<TargetQuestion_>;
};

export type TargetQuestion_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<TargetQuestion_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<TargetQuestion_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<TargetQuestion_Aggregate_Bool_Exp_Count_>;
};

export type TargetQuestion_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: TargetQuestion_Select_Column_TargetQuestion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TargetQuestion_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type TargetQuestion_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: TargetQuestion_Select_Column_TargetQuestion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TargetQuestion_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type TargetQuestion_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<TargetQuestion_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TargetQuestion_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.TargetQuestion" */
export type TargetQuestion_Aggregate_Fields_ = {
  __typename?: 'TargetQuestion_aggregate_fields';
  avg?: Maybe<TargetQuestion_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<TargetQuestion_Max_Fields_>;
  min?: Maybe<TargetQuestion_Min_Fields_>;
  stddev?: Maybe<TargetQuestion_Stddev_Fields_>;
  stddev_pop?: Maybe<TargetQuestion_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<TargetQuestion_Stddev_Samp_Fields_>;
  sum?: Maybe<TargetQuestion_Sum_Fields_>;
  var_pop?: Maybe<TargetQuestion_Var_Pop_Fields_>;
  var_samp?: Maybe<TargetQuestion_Var_Samp_Fields_>;
  variance?: Maybe<TargetQuestion_Variance_Fields_>;
};


/** aggregate fields of "esrs.TargetQuestion" */
export type TargetQuestion_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<TargetQuestion_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.TargetQuestion" */
export type TargetQuestion_Aggregate_Order_By_ = {
  avg?: InputMaybe<TargetQuestion_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<TargetQuestion_Max_Order_By_>;
  min?: InputMaybe<TargetQuestion_Min_Order_By_>;
  stddev?: InputMaybe<TargetQuestion_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<TargetQuestion_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<TargetQuestion_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<TargetQuestion_Sum_Order_By_>;
  var_pop?: InputMaybe<TargetQuestion_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<TargetQuestion_Var_Samp_Order_By_>;
  variance?: InputMaybe<TargetQuestion_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.TargetQuestion" */
export type TargetQuestion_Arr_Rel_Insert_Input_ = {
  data: Array<TargetQuestion_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<TargetQuestion_On_Conflict_>;
};

/** aggregate avg on columns */
export type TargetQuestion_Avg_Fields_ = {
  __typename?: 'TargetQuestion_avg_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.TargetQuestion" */
export type TargetQuestion_Avg_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.TargetQuestion". All fields are combined with a logical 'AND'. */
export type TargetQuestion_Bool_Exp_ = {
  _and?: InputMaybe<Array<TargetQuestion_Bool_Exp_>>;
  _not?: InputMaybe<TargetQuestion_Bool_Exp_>;
  _or?: InputMaybe<Array<TargetQuestion_Bool_Exp_>>;
  choiceSet?: InputMaybe<ChoiceSet_Bool_Exp_>;
  choiceSetRef?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  description?: InputMaybe<String_Comparison_Exp_>;
  firstLevel?: InputMaybe<String_Comparison_Exp_>;
  globalOrder?: InputMaybe<String_Comparison_Exp_>;
  group?: InputMaybe<TargetQuestionGroup_Bool_Exp_>;
  groupRef?: InputMaybe<String_Comparison_Exp_>;
  isAR?: InputMaybe<Boolean_Comparison_Exp_>;
  order?: InputMaybe<Int_Comparison_Exp_>;
  questionType?: InputMaybe<QuestionType_Enum_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
  secondLevel?: InputMaybe<String_Comparison_Exp_>;
  standard?: InputMaybe<EsrsStandard_Bool_Exp_>;
  standardRef?: InputMaybe<String_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
  unit?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.TargetQuestion" */
export enum TargetQuestion_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  TargetQuestionsPkey_ = 'TargetQuestions_pkey'
}

/** input type for incrementing numeric columns in table "esrs.TargetQuestion" */
export type TargetQuestion_Inc_Input_ = {
  order?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.TargetQuestion" */
export type TargetQuestion_Insert_Input_ = {
  choiceSet?: InputMaybe<ChoiceSet_Obj_Rel_Insert_Input_>;
  choiceSetRef?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  firstLevel?: InputMaybe<Scalars['String']['input']>;
  globalOrder?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<TargetQuestionGroup_Obj_Rel_Insert_Input_>;
  groupRef?: InputMaybe<Scalars['String']['input']>;
  isAR?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  questionType?: InputMaybe<QuestionType_Enum_>;
  reference?: InputMaybe<Scalars['String']['input']>;
  secondLevel?: InputMaybe<Scalars['String']['input']>;
  standard?: InputMaybe<EsrsStandard_Obj_Rel_Insert_Input_>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type TargetQuestion_Max_Fields_ = {
  __typename?: 'TargetQuestion_max_fields';
  choiceSetRef?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  firstLevel?: Maybe<Scalars['String']['output']>;
  globalOrder?: Maybe<Scalars['String']['output']>;
  groupRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  secondLevel?: Maybe<Scalars['String']['output']>;
  standardRef?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.TargetQuestion" */
export type TargetQuestion_Max_Order_By_ = {
  choiceSetRef?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  firstLevel?: InputMaybe<Order_By_>;
  globalOrder?: InputMaybe<Order_By_>;
  groupRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  secondLevel?: InputMaybe<Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  unit?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type TargetQuestion_Min_Fields_ = {
  __typename?: 'TargetQuestion_min_fields';
  choiceSetRef?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  firstLevel?: Maybe<Scalars['String']['output']>;
  globalOrder?: Maybe<Scalars['String']['output']>;
  groupRef?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  secondLevel?: Maybe<Scalars['String']['output']>;
  standardRef?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.TargetQuestion" */
export type TargetQuestion_Min_Order_By_ = {
  choiceSetRef?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  firstLevel?: InputMaybe<Order_By_>;
  globalOrder?: InputMaybe<Order_By_>;
  groupRef?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  secondLevel?: InputMaybe<Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  unit?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.TargetQuestion" */
export type TargetQuestion_Mutation_Response_ = {
  __typename?: 'TargetQuestion_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TargetQuestion_>;
};

/** on_conflict condition type for table "esrs.TargetQuestion" */
export type TargetQuestion_On_Conflict_ = {
  constraint: TargetQuestion_Constraint_;
  update_columns?: Array<TargetQuestion_Update_Column_>;
  where?: InputMaybe<TargetQuestion_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.TargetQuestion". */
export type TargetQuestion_Order_By_ = {
  choiceSet?: InputMaybe<ChoiceSet_Order_By_>;
  choiceSetRef?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  firstLevel?: InputMaybe<Order_By_>;
  globalOrder?: InputMaybe<Order_By_>;
  group?: InputMaybe<TargetQuestionGroup_Order_By_>;
  groupRef?: InputMaybe<Order_By_>;
  isAR?: InputMaybe<Order_By_>;
  order?: InputMaybe<Order_By_>;
  questionType?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
  secondLevel?: InputMaybe<Order_By_>;
  standard?: InputMaybe<EsrsStandard_Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  unit?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.TargetQuestion */
export type TargetQuestion_Pk_Columns_Input_ = {
  reference: Scalars['String']['input'];
};

/** select columns of table "esrs.TargetQuestion" */
export enum TargetQuestion_Select_Column_ {
  /** column name */
  ChoiceSetRef_ = 'choiceSetRef',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  FirstLevel_ = 'firstLevel',
  /** column name */
  GlobalOrder_ = 'globalOrder',
  /** column name */
  GroupRef_ = 'groupRef',
  /** column name */
  IsAr_ = 'isAR',
  /** column name */
  Order_ = 'order',
  /** column name */
  QuestionType_ = 'questionType',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  SecondLevel_ = 'secondLevel',
  /** column name */
  StandardRef_ = 'standardRef',
  /** column name */
  Title_ = 'title',
  /** column name */
  Unit_ = 'unit',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "TargetQuestion_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.TargetQuestion" */
export enum TargetQuestion_Select_Column_TargetQuestion_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsAr_ = 'isAR'
}

/** select "TargetQuestion_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.TargetQuestion" */
export enum TargetQuestion_Select_Column_TargetQuestion_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsAr_ = 'isAR'
}

/** input type for updating data in table "esrs.TargetQuestion" */
export type TargetQuestion_Set_Input_ = {
  choiceSetRef?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  firstLevel?: InputMaybe<Scalars['String']['input']>;
  globalOrder?: InputMaybe<Scalars['String']['input']>;
  groupRef?: InputMaybe<Scalars['String']['input']>;
  isAR?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  questionType?: InputMaybe<QuestionType_Enum_>;
  reference?: InputMaybe<Scalars['String']['input']>;
  secondLevel?: InputMaybe<Scalars['String']['input']>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type TargetQuestion_Stddev_Fields_ = {
  __typename?: 'TargetQuestion_stddev_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.TargetQuestion" */
export type TargetQuestion_Stddev_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type TargetQuestion_Stddev_Pop_Fields_ = {
  __typename?: 'TargetQuestion_stddev_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.TargetQuestion" */
export type TargetQuestion_Stddev_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type TargetQuestion_Stddev_Samp_Fields_ = {
  __typename?: 'TargetQuestion_stddev_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.TargetQuestion" */
export type TargetQuestion_Stddev_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "TargetQuestion" */
export type TargetQuestion_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: TargetQuestion_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type TargetQuestion_Stream_Cursor_Value_Input_ = {
  choiceSetRef?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  firstLevel?: InputMaybe<Scalars['String']['input']>;
  globalOrder?: InputMaybe<Scalars['String']['input']>;
  groupRef?: InputMaybe<Scalars['String']['input']>;
  isAR?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  questionType?: InputMaybe<QuestionType_Enum_>;
  reference?: InputMaybe<Scalars['String']['input']>;
  secondLevel?: InputMaybe<Scalars['String']['input']>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type TargetQuestion_Sum_Fields_ = {
  __typename?: 'TargetQuestion_sum_fields';
  order?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.TargetQuestion" */
export type TargetQuestion_Sum_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.TargetQuestion" */
export enum TargetQuestion_Update_Column_ {
  /** column name */
  ChoiceSetRef_ = 'choiceSetRef',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  FirstLevel_ = 'firstLevel',
  /** column name */
  GlobalOrder_ = 'globalOrder',
  /** column name */
  GroupRef_ = 'groupRef',
  /** column name */
  IsAr_ = 'isAR',
  /** column name */
  Order_ = 'order',
  /** column name */
  QuestionType_ = 'questionType',
  /** column name */
  Reference_ = 'reference',
  /** column name */
  SecondLevel_ = 'secondLevel',
  /** column name */
  StandardRef_ = 'standardRef',
  /** column name */
  Title_ = 'title',
  /** column name */
  Unit_ = 'unit',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type TargetQuestion_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TargetQuestion_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TargetQuestion_Set_Input_>;
  /** filter the rows which have to be updated */
  where: TargetQuestion_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type TargetQuestion_Var_Pop_Fields_ = {
  __typename?: 'TargetQuestion_var_pop_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.TargetQuestion" */
export type TargetQuestion_Var_Pop_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type TargetQuestion_Var_Samp_Fields_ = {
  __typename?: 'TargetQuestion_var_samp_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.TargetQuestion" */
export type TargetQuestion_Var_Samp_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type TargetQuestion_Variance_Fields_ = {
  __typename?: 'TargetQuestion_variance_fields';
  order?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.TargetQuestion" */
export type TargetQuestion_Variance_Order_By_ = {
  order?: InputMaybe<Order_By_>;
};

/** columns and relationships of "Task" */
export type Task_ = {
  __typename?: 'Task';
  /** A computed field, executes function "Task_assessmentId" */
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  company: Company_;
  companyId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  datapointMdrm?: Maybe<Esrs_DatapointMdrm_>;
  /** An array relationship */
  datapoints: Array<Esrs_Datapoint_>;
  /** An aggregate relationship */
  datapoints_aggregate: Esrs_Datapoint_Aggregate_;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  dueDate?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  owner: Users_;
  ownerId: Scalars['uuid']['output'];
  status: TaskStatusEnum_Enum_;
  table: Scalars['String']['output'];
  taskReference?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "Task" */
export type TaskDatapointsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Datapoint_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Datapoint_Order_By_>>;
  where?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
};


/** columns and relationships of "Task" */
export type TaskDatapoints_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Datapoint_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Datapoint_Order_By_>>;
  where?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
};

/** columns and relationships of "TaskStatusEnum" */
export type TaskStatusEnum_ = {
  __typename?: 'TaskStatusEnum';
  status: Scalars['String']['output'];
};

/** aggregated selection of "TaskStatusEnum" */
export type TaskStatusEnum_Aggregate_ = {
  __typename?: 'TaskStatusEnum_aggregate';
  aggregate?: Maybe<TaskStatusEnum_Aggregate_Fields_>;
  nodes: Array<TaskStatusEnum_>;
};

/** aggregate fields of "TaskStatusEnum" */
export type TaskStatusEnum_Aggregate_Fields_ = {
  __typename?: 'TaskStatusEnum_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<TaskStatusEnum_Max_Fields_>;
  min?: Maybe<TaskStatusEnum_Min_Fields_>;
};


/** aggregate fields of "TaskStatusEnum" */
export type TaskStatusEnum_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<TaskStatusEnum_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "TaskStatusEnum". All fields are combined with a logical 'AND'. */
export type TaskStatusEnum_Bool_Exp_ = {
  _and?: InputMaybe<Array<TaskStatusEnum_Bool_Exp_>>;
  _not?: InputMaybe<TaskStatusEnum_Bool_Exp_>;
  _or?: InputMaybe<Array<TaskStatusEnum_Bool_Exp_>>;
  status?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "TaskStatusEnum" */
export enum TaskStatusEnum_Constraint_ {
  /** unique or primary key constraint on columns "status" */
  TaskStatusEnumPkey_ = 'TaskStatusEnum_pkey'
}

export enum TaskStatusEnum_Enum_ {
  Completed_ = 'COMPLETED',
  InProgress_ = 'IN_PROGRESS',
  NotStarted_ = 'NOT_STARTED'
}

/** Boolean expression to compare columns of type "TaskStatusEnum_enum". All fields are combined with logical 'AND'. */
export type TaskStatusEnum_Enum_Comparison_Exp_ = {
  _eq?: InputMaybe<TaskStatusEnum_Enum_>;
  _in?: InputMaybe<Array<TaskStatusEnum_Enum_>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TaskStatusEnum_Enum_>;
  _nin?: InputMaybe<Array<TaskStatusEnum_Enum_>>;
};

/** input type for inserting data into table "TaskStatusEnum" */
export type TaskStatusEnum_Insert_Input_ = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TaskStatusEnum_Max_Fields_ = {
  __typename?: 'TaskStatusEnum_max_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TaskStatusEnum_Min_Fields_ = {
  __typename?: 'TaskStatusEnum_min_fields';
  status?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "TaskStatusEnum" */
export type TaskStatusEnum_Mutation_Response_ = {
  __typename?: 'TaskStatusEnum_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TaskStatusEnum_>;
};

/** on_conflict condition type for table "TaskStatusEnum" */
export type TaskStatusEnum_On_Conflict_ = {
  constraint: TaskStatusEnum_Constraint_;
  update_columns?: Array<TaskStatusEnum_Update_Column_>;
  where?: InputMaybe<TaskStatusEnum_Bool_Exp_>;
};

/** Ordering options when selecting data from "TaskStatusEnum". */
export type TaskStatusEnum_Order_By_ = {
  status?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: TaskStatusEnum */
export type TaskStatusEnum_Pk_Columns_Input_ = {
  status: Scalars['String']['input'];
};

/** select columns of table "TaskStatusEnum" */
export enum TaskStatusEnum_Select_Column_ {
  /** column name */
  Status_ = 'status'
}

/** input type for updating data in table "TaskStatusEnum" */
export type TaskStatusEnum_Set_Input_ = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "TaskStatusEnum" */
export type TaskStatusEnum_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: TaskStatusEnum_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type TaskStatusEnum_Stream_Cursor_Value_Input_ = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "TaskStatusEnum" */
export enum TaskStatusEnum_Update_Column_ {
  /** column name */
  Status_ = 'status'
}

export type TaskStatusEnum_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TaskStatusEnum_Set_Input_>;
  /** filter the rows which have to be updated */
  where: TaskStatusEnum_Bool_Exp_;
};

/** aggregated selection of "Task" */
export type Task_Aggregate_ = {
  __typename?: 'Task_aggregate';
  aggregate?: Maybe<Task_Aggregate_Fields_>;
  nodes: Array<Task_>;
};

/** aggregate fields of "Task" */
export type Task_Aggregate_Fields_ = {
  __typename?: 'Task_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Task_Max_Fields_>;
  min?: Maybe<Task_Min_Fields_>;
};


/** aggregate fields of "Task" */
export type Task_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Task_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "Task". All fields are combined with a logical 'AND'. */
export type Task_Bool_Exp_ = {
  _and?: InputMaybe<Array<Task_Bool_Exp_>>;
  _not?: InputMaybe<Task_Bool_Exp_>;
  _or?: InputMaybe<Array<Task_Bool_Exp_>>;
  assessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  datapointMdrm?: InputMaybe<Esrs_DatapointMdrm_Bool_Exp_>;
  datapoints?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
  datapoints_aggregate?: InputMaybe<Esrs_Datapoint_Aggregate_Bool_Exp_>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  dueDate?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  owner?: InputMaybe<Users_Bool_Exp_>;
  ownerId?: InputMaybe<Uuid_Comparison_Exp_>;
  status?: InputMaybe<TaskStatusEnum_Enum_Comparison_Exp_>;
  table?: InputMaybe<String_Comparison_Exp_>;
  taskReference?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Task" */
export enum Task_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  TaskPkey_ = 'Task_pkey',
  /** unique or primary key constraint on columns "table", "taskReference" */
  TaskTableTaskReferenceKey_ = 'Task_table_taskReference_key'
}

/** input type for inserting data into table "Task" */
export type Task_Insert_Input_ = {
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  datapointMdrm?: InputMaybe<Esrs_DatapointMdrm_Obj_Rel_Insert_Input_>;
  datapoints?: InputMaybe<Esrs_Datapoint_Arr_Rel_Insert_Input_>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dueDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  owner?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<TaskStatusEnum_Enum_>;
  table?: InputMaybe<Scalars['String']['input']>;
  taskReference?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Task_Max_Fields_ = {
  __typename?: 'Task_max_fields';
  /** A computed field, executes function "Task_assessmentId" */
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  dueDate?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  taskReference?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Task_Min_Fields_ = {
  __typename?: 'Task_min_fields';
  /** A computed field, executes function "Task_assessmentId" */
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  dueDate?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  table?: Maybe<Scalars['String']['output']>;
  taskReference?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "Task" */
export type Task_Mutation_Response_ = {
  __typename?: 'Task_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Task_>;
};

/** input type for inserting object relation for remote table "Task" */
export type Task_Obj_Rel_Insert_Input_ = {
  data: Task_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Task_On_Conflict_>;
};

/** on_conflict condition type for table "Task" */
export type Task_On_Conflict_ = {
  constraint: Task_Constraint_;
  update_columns?: Array<Task_Update_Column_>;
  where?: InputMaybe<Task_Bool_Exp_>;
};

/** Ordering options when selecting data from "Task". */
export type Task_Order_By_ = {
  assessmentId?: InputMaybe<Order_By_>;
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  datapointMdrm?: InputMaybe<Esrs_DatapointMdrm_Order_By_>;
  datapoints_aggregate?: InputMaybe<Esrs_Datapoint_Aggregate_Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  dueDate?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  owner?: InputMaybe<Users_Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  status?: InputMaybe<Order_By_>;
  table?: InputMaybe<Order_By_>;
  taskReference?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Task */
export type Task_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "Task" */
export enum Task_Select_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  DueDate_ = 'dueDate',
  /** column name */
  Id_ = 'id',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  Status_ = 'status',
  /** column name */
  Table_ = 'table',
  /** column name */
  TaskReference_ = 'taskReference',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "Task" */
export type Task_Set_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dueDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<TaskStatusEnum_Enum_>;
  table?: InputMaybe<Scalars['String']['input']>;
  taskReference?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "Task" */
export type Task_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Task_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Task_Stream_Cursor_Value_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dueDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  status?: InputMaybe<TaskStatusEnum_Enum_>;
  table?: InputMaybe<Scalars['String']['input']>;
  taskReference?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "Task" */
export enum Task_Update_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  DueDate_ = 'dueDate',
  /** column name */
  Id_ = 'id',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  Status_ = 'status',
  /** column name */
  Table_ = 'table',
  /** column name */
  TaskReference_ = 'taskReference',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Task_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Task_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Task_Bool_Exp_;
};

/** columns and relationships of "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_ = {
  __typename?: 'TaxonomyPortfolioReport';
  /** An object relationship */
  contactPerson?: Maybe<Users_>;
  contactPersonId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  dueDate?: Maybe<Scalars['date']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  portfolio?: Maybe<Portfolio_>;
  portfolioId: Scalars['uuid']['output'];
  quarter: QuarterEnum_Enum_;
  sendOutDate?: Maybe<Scalars['date']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  year: Scalars['Int']['output'];
};

/** aggregated selection of "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Aggregate_ = {
  __typename?: 'TaxonomyPortfolioReport_aggregate';
  aggregate?: Maybe<TaxonomyPortfolioReport_Aggregate_Fields_>;
  nodes: Array<TaxonomyPortfolioReport_>;
};

export type TaxonomyPortfolioReport_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<TaxonomyPortfolioReport_Aggregate_Bool_Exp_Count_>;
};

export type TaxonomyPortfolioReport_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<TaxonomyPortfolioReport_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TaxonomyPortfolioReport_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Aggregate_Fields_ = {
  __typename?: 'TaxonomyPortfolioReport_aggregate_fields';
  avg?: Maybe<TaxonomyPortfolioReport_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<TaxonomyPortfolioReport_Max_Fields_>;
  min?: Maybe<TaxonomyPortfolioReport_Min_Fields_>;
  stddev?: Maybe<TaxonomyPortfolioReport_Stddev_Fields_>;
  stddev_pop?: Maybe<TaxonomyPortfolioReport_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<TaxonomyPortfolioReport_Stddev_Samp_Fields_>;
  sum?: Maybe<TaxonomyPortfolioReport_Sum_Fields_>;
  var_pop?: Maybe<TaxonomyPortfolioReport_Var_Pop_Fields_>;
  var_samp?: Maybe<TaxonomyPortfolioReport_Var_Samp_Fields_>;
  variance?: Maybe<TaxonomyPortfolioReport_Variance_Fields_>;
};


/** aggregate fields of "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<TaxonomyPortfolioReport_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Aggregate_Order_By_ = {
  avg?: InputMaybe<TaxonomyPortfolioReport_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<TaxonomyPortfolioReport_Max_Order_By_>;
  min?: InputMaybe<TaxonomyPortfolioReport_Min_Order_By_>;
  stddev?: InputMaybe<TaxonomyPortfolioReport_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<TaxonomyPortfolioReport_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<TaxonomyPortfolioReport_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<TaxonomyPortfolioReport_Sum_Order_By_>;
  var_pop?: InputMaybe<TaxonomyPortfolioReport_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<TaxonomyPortfolioReport_Var_Samp_Order_By_>;
  variance?: InputMaybe<TaxonomyPortfolioReport_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Arr_Rel_Insert_Input_ = {
  data: Array<TaxonomyPortfolioReport_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<TaxonomyPortfolioReport_On_Conflict_>;
};

/** aggregate avg on columns */
export type TaxonomyPortfolioReport_Avg_Fields_ = {
  __typename?: 'TaxonomyPortfolioReport_avg_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Avg_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "TaxonomyPortfolioReport". All fields are combined with a logical 'AND'. */
export type TaxonomyPortfolioReport_Bool_Exp_ = {
  _and?: InputMaybe<Array<TaxonomyPortfolioReport_Bool_Exp_>>;
  _not?: InputMaybe<TaxonomyPortfolioReport_Bool_Exp_>;
  _or?: InputMaybe<Array<TaxonomyPortfolioReport_Bool_Exp_>>;
  contactPerson?: InputMaybe<Users_Bool_Exp_>;
  contactPersonId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  dueDate?: InputMaybe<Date_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  portfolio?: InputMaybe<Portfolio_Bool_Exp_>;
  portfolioId?: InputMaybe<Uuid_Comparison_Exp_>;
  quarter?: InputMaybe<QuarterEnum_Enum_Comparison_Exp_>;
  sendOutDate?: InputMaybe<Date_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  year?: InputMaybe<Int_Comparison_Exp_>;
};

/** unique or primary key constraints on table "TaxonomyPortfolioReport" */
export enum TaxonomyPortfolioReport_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  TaxonomyPortfolioReportPkey_ = 'TaxonomyPortfolioReport_pkey',
  /** unique or primary key constraint on columns "portfolioId", "quarter", "year" */
  TaxonomyPortfolioReportYearPortfolioIdQuarterKey_ = 'TaxonomyPortfolioReport_year_portfolioId_quarter_key'
}

/** input type for incrementing numeric columns in table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Inc_Input_ = {
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Insert_Input_ = {
  contactPerson?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  contactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dueDate?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolio?: InputMaybe<Portfolio_Obj_Rel_Insert_Input_>;
  portfolioId?: InputMaybe<Scalars['uuid']['input']>;
  quarter?: InputMaybe<QuarterEnum_Enum_>;
  sendOutDate?: InputMaybe<Scalars['date']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type TaxonomyPortfolioReport_Max_Fields_ = {
  __typename?: 'TaxonomyPortfolioReport_max_fields';
  contactPersonId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dueDate?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  portfolioId?: Maybe<Scalars['uuid']['output']>;
  sendOutDate?: Maybe<Scalars['date']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Max_Order_By_ = {
  contactPersonId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  dueDate?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  portfolioId?: InputMaybe<Order_By_>;
  sendOutDate?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type TaxonomyPortfolioReport_Min_Fields_ = {
  __typename?: 'TaxonomyPortfolioReport_min_fields';
  contactPersonId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dueDate?: Maybe<Scalars['date']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  portfolioId?: Maybe<Scalars['uuid']['output']>;
  sendOutDate?: Maybe<Scalars['date']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Min_Order_By_ = {
  contactPersonId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  dueDate?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  portfolioId?: InputMaybe<Order_By_>;
  sendOutDate?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Mutation_Response_ = {
  __typename?: 'TaxonomyPortfolioReport_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TaxonomyPortfolioReport_>;
};

/** on_conflict condition type for table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_On_Conflict_ = {
  constraint: TaxonomyPortfolioReport_Constraint_;
  update_columns?: Array<TaxonomyPortfolioReport_Update_Column_>;
  where?: InputMaybe<TaxonomyPortfolioReport_Bool_Exp_>;
};

/** Ordering options when selecting data from "TaxonomyPortfolioReport". */
export type TaxonomyPortfolioReport_Order_By_ = {
  contactPerson?: InputMaybe<Users_Order_By_>;
  contactPersonId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  dueDate?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  portfolio?: InputMaybe<Portfolio_Order_By_>;
  portfolioId?: InputMaybe<Order_By_>;
  quarter?: InputMaybe<Order_By_>;
  sendOutDate?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: TaxonomyPortfolioReport */
export type TaxonomyPortfolioReport_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "TaxonomyPortfolioReport" */
export enum TaxonomyPortfolioReport_Select_Column_ {
  /** column name */
  ContactPersonId_ = 'contactPersonId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DueDate_ = 'dueDate',
  /** column name */
  Id_ = 'id',
  /** column name */
  PortfolioId_ = 'portfolioId',
  /** column name */
  Quarter_ = 'quarter',
  /** column name */
  SendOutDate_ = 'sendOutDate',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Year_ = 'year'
}

/** input type for updating data in table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Set_Input_ = {
  contactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dueDate?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolioId?: InputMaybe<Scalars['uuid']['input']>;
  quarter?: InputMaybe<QuarterEnum_Enum_>;
  sendOutDate?: InputMaybe<Scalars['date']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type TaxonomyPortfolioReport_Stddev_Fields_ = {
  __typename?: 'TaxonomyPortfolioReport_stddev_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Stddev_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type TaxonomyPortfolioReport_Stddev_Pop_Fields_ = {
  __typename?: 'TaxonomyPortfolioReport_stddev_pop_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Stddev_Pop_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type TaxonomyPortfolioReport_Stddev_Samp_Fields_ = {
  __typename?: 'TaxonomyPortfolioReport_stddev_samp_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Stddev_Samp_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: TaxonomyPortfolioReport_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type TaxonomyPortfolioReport_Stream_Cursor_Value_Input_ = {
  contactPersonId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dueDate?: InputMaybe<Scalars['date']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  portfolioId?: InputMaybe<Scalars['uuid']['input']>;
  quarter?: InputMaybe<QuarterEnum_Enum_>;
  sendOutDate?: InputMaybe<Scalars['date']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type TaxonomyPortfolioReport_Sum_Fields_ = {
  __typename?: 'TaxonomyPortfolioReport_sum_fields';
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Sum_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** update columns of table "TaxonomyPortfolioReport" */
export enum TaxonomyPortfolioReport_Update_Column_ {
  /** column name */
  ContactPersonId_ = 'contactPersonId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DueDate_ = 'dueDate',
  /** column name */
  Id_ = 'id',
  /** column name */
  PortfolioId_ = 'portfolioId',
  /** column name */
  Quarter_ = 'quarter',
  /** column name */
  SendOutDate_ = 'sendOutDate',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Year_ = 'year'
}

export type TaxonomyPortfolioReport_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TaxonomyPortfolioReport_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TaxonomyPortfolioReport_Set_Input_>;
  /** filter the rows which have to be updated */
  where: TaxonomyPortfolioReport_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type TaxonomyPortfolioReport_Var_Pop_Fields_ = {
  __typename?: 'TaxonomyPortfolioReport_var_pop_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Var_Pop_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type TaxonomyPortfolioReport_Var_Samp_Fields_ = {
  __typename?: 'TaxonomyPortfolioReport_var_samp_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Var_Samp_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type TaxonomyPortfolioReport_Variance_Fields_ = {
  __typename?: 'TaxonomyPortfolioReport_variance_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "TaxonomyPortfolioReport" */
export type TaxonomyPortfolioReport_Variance_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** columns and relationships of "Thread" */
export type Thread_ = {
  __typename?: 'Thread';
  /** An object relationship */
  answer?: Maybe<Answer_>;
  answerId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  comments: Array<Comment_>;
  /** An aggregate relationship */
  comments_aggregate: Comment_Aggregate_;
  /** An object relationship */
  company: Company_;
  companyId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  esrsDatapoint?: Maybe<Esrs_Datapoint_>;
  esrsDatapointId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  esrsDatapointMdrm?: Maybe<Esrs_DatapointMdrm_>;
  esrsDatapointMdrmId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  subscribers: Array<ThreadSubscriber_>;
  /** An aggregate relationship */
  subscribers_aggregate: ThreadSubscriber_Aggregate_;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "Thread" */
export type ThreadCommentsArgs_ = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comment_Order_By_>>;
  where?: InputMaybe<Comment_Bool_Exp_>;
};


/** columns and relationships of "Thread" */
export type ThreadComments_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comment_Order_By_>>;
  where?: InputMaybe<Comment_Bool_Exp_>;
};


/** columns and relationships of "Thread" */
export type ThreadSubscribersArgs_ = {
  distinct_on?: InputMaybe<Array<ThreadSubscriber_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ThreadSubscriber_Order_By_>>;
  where?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
};


/** columns and relationships of "Thread" */
export type ThreadSubscribers_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ThreadSubscriber_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ThreadSubscriber_Order_By_>>;
  where?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
};

/** columns and relationships of "ThreadSubscriber" */
export type ThreadSubscriber_ = {
  __typename?: 'ThreadSubscriber';
  id: Scalars['uuid']['output'];
  isSubscribed: Scalars['Boolean']['output'];
  /** An object relationship */
  thread: Thread_;
  threadId: Scalars['uuid']['output'];
  /** An object relationship */
  user: Users_;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "ThreadSubscriber" */
export type ThreadSubscriber_Aggregate_ = {
  __typename?: 'ThreadSubscriber_aggregate';
  aggregate?: Maybe<ThreadSubscriber_Aggregate_Fields_>;
  nodes: Array<ThreadSubscriber_>;
};

export type ThreadSubscriber_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<ThreadSubscriber_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<ThreadSubscriber_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<ThreadSubscriber_Aggregate_Bool_Exp_Count_>;
};

export type ThreadSubscriber_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: ThreadSubscriber_Select_Column_ThreadSubscriber_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type ThreadSubscriber_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: ThreadSubscriber_Select_Column_ThreadSubscriber_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type ThreadSubscriber_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<ThreadSubscriber_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "ThreadSubscriber" */
export type ThreadSubscriber_Aggregate_Fields_ = {
  __typename?: 'ThreadSubscriber_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<ThreadSubscriber_Max_Fields_>;
  min?: Maybe<ThreadSubscriber_Min_Fields_>;
};


/** aggregate fields of "ThreadSubscriber" */
export type ThreadSubscriber_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<ThreadSubscriber_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "ThreadSubscriber" */
export type ThreadSubscriber_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<ThreadSubscriber_Max_Order_By_>;
  min?: InputMaybe<ThreadSubscriber_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "ThreadSubscriber" */
export type ThreadSubscriber_Arr_Rel_Insert_Input_ = {
  data: Array<ThreadSubscriber_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<ThreadSubscriber_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "ThreadSubscriber". All fields are combined with a logical 'AND'. */
export type ThreadSubscriber_Bool_Exp_ = {
  _and?: InputMaybe<Array<ThreadSubscriber_Bool_Exp_>>;
  _not?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
  _or?: InputMaybe<Array<ThreadSubscriber_Bool_Exp_>>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isSubscribed?: InputMaybe<Boolean_Comparison_Exp_>;
  thread?: InputMaybe<Thread_Bool_Exp_>;
  threadId?: InputMaybe<Uuid_Comparison_Exp_>;
  user?: InputMaybe<Users_Bool_Exp_>;
  userId?: InputMaybe<Uuid_Comparison_Exp_>;
};

/** unique or primary key constraints on table "ThreadSubscriber" */
export enum ThreadSubscriber_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  ThreadSubscriberPkey_ = 'ThreadSubscriber_pkey',
  /** unique or primary key constraint on columns "userId", "threadId" */
  ThreadSubscriberThreadIdUserIdC1ed612aUniq_ = 'ThreadSubscriber_threadId_userId_c1ed612a_uniq'
}

/** input type for inserting data into table "ThreadSubscriber" */
export type ThreadSubscriber_Insert_Input_ = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  isSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  thread?: InputMaybe<Thread_Obj_Rel_Insert_Input_>;
  threadId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ThreadSubscriber_Max_Fields_ = {
  __typename?: 'ThreadSubscriber_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  threadId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "ThreadSubscriber" */
export type ThreadSubscriber_Max_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  threadId?: InputMaybe<Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type ThreadSubscriber_Min_Fields_ = {
  __typename?: 'ThreadSubscriber_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
  threadId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "ThreadSubscriber" */
export type ThreadSubscriber_Min_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  threadId?: InputMaybe<Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "ThreadSubscriber" */
export type ThreadSubscriber_Mutation_Response_ = {
  __typename?: 'ThreadSubscriber_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ThreadSubscriber_>;
};

/** on_conflict condition type for table "ThreadSubscriber" */
export type ThreadSubscriber_On_Conflict_ = {
  constraint: ThreadSubscriber_Constraint_;
  update_columns?: Array<ThreadSubscriber_Update_Column_>;
  where?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
};

/** Ordering options when selecting data from "ThreadSubscriber". */
export type ThreadSubscriber_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  isSubscribed?: InputMaybe<Order_By_>;
  thread?: InputMaybe<Thread_Order_By_>;
  threadId?: InputMaybe<Order_By_>;
  user?: InputMaybe<Users_Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: ThreadSubscriber */
export type ThreadSubscriber_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "ThreadSubscriber" */
export enum ThreadSubscriber_Select_Column_ {
  /** column name */
  Id_ = 'id',
  /** column name */
  IsSubscribed_ = 'isSubscribed',
  /** column name */
  ThreadId_ = 'threadId',
  /** column name */
  UserId_ = 'userId'
}

/** select "ThreadSubscriber_aggregate_bool_exp_bool_and_arguments_columns" columns of table "ThreadSubscriber" */
export enum ThreadSubscriber_Select_Column_ThreadSubscriber_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsSubscribed_ = 'isSubscribed'
}

/** select "ThreadSubscriber_aggregate_bool_exp_bool_or_arguments_columns" columns of table "ThreadSubscriber" */
export enum ThreadSubscriber_Select_Column_ThreadSubscriber_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsSubscribed_ = 'isSubscribed'
}

/** input type for updating data in table "ThreadSubscriber" */
export type ThreadSubscriber_Set_Input_ = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  isSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  threadId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "ThreadSubscriber" */
export type ThreadSubscriber_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: ThreadSubscriber_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type ThreadSubscriber_Stream_Cursor_Value_Input_ = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  isSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
  threadId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "ThreadSubscriber" */
export enum ThreadSubscriber_Update_Column_ {
  /** column name */
  Id_ = 'id',
  /** column name */
  IsSubscribed_ = 'isSubscribed',
  /** column name */
  ThreadId_ = 'threadId',
  /** column name */
  UserId_ = 'userId'
}

export type ThreadSubscriber_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ThreadSubscriber_Set_Input_>;
  /** filter the rows which have to be updated */
  where: ThreadSubscriber_Bool_Exp_;
};

/** aggregated selection of "Thread" */
export type Thread_Aggregate_ = {
  __typename?: 'Thread_aggregate';
  aggregate?: Maybe<Thread_Aggregate_Fields_>;
  nodes: Array<Thread_>;
};

/** aggregate fields of "Thread" */
export type Thread_Aggregate_Fields_ = {
  __typename?: 'Thread_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Thread_Max_Fields_>;
  min?: Maybe<Thread_Min_Fields_>;
};


/** aggregate fields of "Thread" */
export type Thread_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Thread_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "Thread". All fields are combined with a logical 'AND'. */
export type Thread_Bool_Exp_ = {
  _and?: InputMaybe<Array<Thread_Bool_Exp_>>;
  _not?: InputMaybe<Thread_Bool_Exp_>;
  _or?: InputMaybe<Array<Thread_Bool_Exp_>>;
  answer?: InputMaybe<Answer_Bool_Exp_>;
  answerId?: InputMaybe<Uuid_Comparison_Exp_>;
  comments?: InputMaybe<Comment_Bool_Exp_>;
  comments_aggregate?: InputMaybe<Comment_Aggregate_Bool_Exp_>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  esrsDatapoint?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
  esrsDatapointId?: InputMaybe<Uuid_Comparison_Exp_>;
  esrsDatapointMdrm?: InputMaybe<Esrs_DatapointMdrm_Bool_Exp_>;
  esrsDatapointMdrmId?: InputMaybe<Uuid_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  subscribers?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
  subscribers_aggregate?: InputMaybe<ThreadSubscriber_Aggregate_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "Thread" */
export enum Thread_Constraint_ {
  /** unique or primary key constraint on columns "answerId" */
  ThreadAnswerIdKey_ = 'Thread_answerId_key',
  /** unique or primary key constraint on columns "esrsDatapointId" */
  ThreadEsrsDatapointIdKey_ = 'Thread_esrsDatapointId_key',
  /** unique or primary key constraint on columns "esrsDatapointMdrmId" */
  ThreadEsrsDatapointMdrmIdKey_ = 'Thread_esrsDatapointMdrmId_key',
  /** unique or primary key constraint on columns "id" */
  ThreadPkey_ = 'Thread_pkey'
}

/** input type for inserting data into table "Thread" */
export type Thread_Insert_Input_ = {
  answer?: InputMaybe<Answer_Obj_Rel_Insert_Input_>;
  answerId?: InputMaybe<Scalars['uuid']['input']>;
  comments?: InputMaybe<Comment_Arr_Rel_Insert_Input_>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  esrsDatapoint?: InputMaybe<Esrs_Datapoint_Obj_Rel_Insert_Input_>;
  esrsDatapointId?: InputMaybe<Scalars['uuid']['input']>;
  esrsDatapointMdrm?: InputMaybe<Esrs_DatapointMdrm_Obj_Rel_Insert_Input_>;
  esrsDatapointMdrmId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  subscribers?: InputMaybe<ThreadSubscriber_Arr_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Thread_Max_Fields_ = {
  __typename?: 'Thread_max_fields';
  answerId?: Maybe<Scalars['uuid']['output']>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  esrsDatapointId?: Maybe<Scalars['uuid']['output']>;
  esrsDatapointMdrmId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Thread_Min_Fields_ = {
  __typename?: 'Thread_min_fields';
  answerId?: Maybe<Scalars['uuid']['output']>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  esrsDatapointId?: Maybe<Scalars['uuid']['output']>;
  esrsDatapointMdrmId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "Thread" */
export type Thread_Mutation_Response_ = {
  __typename?: 'Thread_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Thread_>;
};

/** input type for inserting object relation for remote table "Thread" */
export type Thread_Obj_Rel_Insert_Input_ = {
  data: Thread_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Thread_On_Conflict_>;
};

/** on_conflict condition type for table "Thread" */
export type Thread_On_Conflict_ = {
  constraint: Thread_Constraint_;
  update_columns?: Array<Thread_Update_Column_>;
  where?: InputMaybe<Thread_Bool_Exp_>;
};

/** Ordering options when selecting data from "Thread". */
export type Thread_Order_By_ = {
  answer?: InputMaybe<Answer_Order_By_>;
  answerId?: InputMaybe<Order_By_>;
  comments_aggregate?: InputMaybe<Comment_Aggregate_Order_By_>;
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  esrsDatapoint?: InputMaybe<Esrs_Datapoint_Order_By_>;
  esrsDatapointId?: InputMaybe<Order_By_>;
  esrsDatapointMdrm?: InputMaybe<Esrs_DatapointMdrm_Order_By_>;
  esrsDatapointMdrmId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  subscribers_aggregate?: InputMaybe<ThreadSubscriber_Aggregate_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: Thread */
export type Thread_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "Thread" */
export enum Thread_Select_Column_ {
  /** column name */
  AnswerId_ = 'answerId',
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  EsrsDatapointId_ = 'esrsDatapointId',
  /** column name */
  EsrsDatapointMdrmId_ = 'esrsDatapointMdrmId',
  /** column name */
  Id_ = 'id',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "Thread" */
export type Thread_Set_Input_ = {
  answerId?: InputMaybe<Scalars['uuid']['input']>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  esrsDatapointId?: InputMaybe<Scalars['uuid']['input']>;
  esrsDatapointMdrmId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "Thread" */
export type Thread_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Thread_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Thread_Stream_Cursor_Value_Input_ = {
  answerId?: InputMaybe<Scalars['uuid']['input']>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  esrsDatapointId?: InputMaybe<Scalars['uuid']['input']>;
  esrsDatapointMdrmId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "Thread" */
export enum Thread_Update_Column_ {
  /** column name */
  AnswerId_ = 'answerId',
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  EsrsDatapointId_ = 'esrsDatapointId',
  /** column name */
  EsrsDatapointMdrmId_ = 'esrsDatapointMdrmId',
  /** column name */
  Id_ = 'id',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Thread_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Thread_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Thread_Bool_Exp_;
};

/** columns and relationships of "TotalComparisonFinancials" */
export type TotalComparisonFinancials_ = {
  __typename?: 'TotalComparisonFinancials';
  adaptationCapex?: Maybe<Scalars['float8']['output']>;
  adaptationOpex?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  attachmentBox?: Maybe<AttachmentBox_>;
  cAssessmentId?: Maybe<Scalars['uuid']['output']>;
  capex?: Maybe<Scalars['float8']['output']>;
  /** An object relationship */
  companyAssessment?: Maybe<CompanyAssessment_>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  isEstimate?: Maybe<Scalars['Boolean']['output']>;
  isMaterial?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  noteHistory?: Maybe<NoteHistory_>;
  opex?: Maybe<Scalars['float8']['output']>;
  reportId?: Maybe<Scalars['uuid']['output']>;
  revenue?: Maybe<Scalars['float8']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "TotalComparisonFinancials" */
export type TotalComparisonFinancials_Aggregate_ = {
  __typename?: 'TotalComparisonFinancials_aggregate';
  aggregate?: Maybe<TotalComparisonFinancials_Aggregate_Fields_>;
  nodes: Array<TotalComparisonFinancials_>;
};

/** aggregate fields of "TotalComparisonFinancials" */
export type TotalComparisonFinancials_Aggregate_Fields_ = {
  __typename?: 'TotalComparisonFinancials_aggregate_fields';
  avg?: Maybe<TotalComparisonFinancials_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<TotalComparisonFinancials_Max_Fields_>;
  min?: Maybe<TotalComparisonFinancials_Min_Fields_>;
  stddev?: Maybe<TotalComparisonFinancials_Stddev_Fields_>;
  stddev_pop?: Maybe<TotalComparisonFinancials_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<TotalComparisonFinancials_Stddev_Samp_Fields_>;
  sum?: Maybe<TotalComparisonFinancials_Sum_Fields_>;
  var_pop?: Maybe<TotalComparisonFinancials_Var_Pop_Fields_>;
  var_samp?: Maybe<TotalComparisonFinancials_Var_Samp_Fields_>;
  variance?: Maybe<TotalComparisonFinancials_Variance_Fields_>;
};


/** aggregate fields of "TotalComparisonFinancials" */
export type TotalComparisonFinancials_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<TotalComparisonFinancials_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type TotalComparisonFinancials_Avg_Fields_ = {
  __typename?: 'TotalComparisonFinancials_avg_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "TotalComparisonFinancials". All fields are combined with a logical 'AND'. */
export type TotalComparisonFinancials_Bool_Exp_ = {
  _and?: InputMaybe<Array<TotalComparisonFinancials_Bool_Exp_>>;
  _not?: InputMaybe<TotalComparisonFinancials_Bool_Exp_>;
  _or?: InputMaybe<Array<TotalComparisonFinancials_Bool_Exp_>>;
  adaptationCapex?: InputMaybe<Float8_Comparison_Exp_>;
  adaptationOpex?: InputMaybe<Float8_Comparison_Exp_>;
  attachmentBox?: InputMaybe<AttachmentBox_Bool_Exp_>;
  cAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  capex?: InputMaybe<Float8_Comparison_Exp_>;
  companyAssessment?: InputMaybe<CompanyAssessment_Bool_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isEstimate?: InputMaybe<Boolean_Comparison_Exp_>;
  isMaterial?: InputMaybe<Boolean_Comparison_Exp_>;
  noteHistory?: InputMaybe<NoteHistory_Bool_Exp_>;
  opex?: InputMaybe<Float8_Comparison_Exp_>;
  reportId?: InputMaybe<Uuid_Comparison_Exp_>;
  revenue?: InputMaybe<Float8_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** input type for incrementing numeric columns in table "TotalComparisonFinancials" */
export type TotalComparisonFinancials_Inc_Input_ = {
  adaptationCapex?: InputMaybe<Scalars['float8']['input']>;
  adaptationOpex?: InputMaybe<Scalars['float8']['input']>;
  capex?: InputMaybe<Scalars['float8']['input']>;
  opex?: InputMaybe<Scalars['float8']['input']>;
  revenue?: InputMaybe<Scalars['float8']['input']>;
};

/** input type for inserting data into table "TotalComparisonFinancials" */
export type TotalComparisonFinancials_Insert_Input_ = {
  adaptationCapex?: InputMaybe<Scalars['float8']['input']>;
  adaptationOpex?: InputMaybe<Scalars['float8']['input']>;
  attachmentBox?: InputMaybe<AttachmentBox_Obj_Rel_Insert_Input_>;
  cAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  capex?: InputMaybe<Scalars['float8']['input']>;
  companyAssessment?: InputMaybe<CompanyAssessment_Obj_Rel_Insert_Input_>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  noteHistory?: InputMaybe<NoteHistory_Obj_Rel_Insert_Input_>;
  opex?: InputMaybe<Scalars['float8']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  revenue?: InputMaybe<Scalars['float8']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type TotalComparisonFinancials_Max_Fields_ = {
  __typename?: 'TotalComparisonFinancials_max_fields';
  adaptationCapex?: Maybe<Scalars['float8']['output']>;
  adaptationOpex?: Maybe<Scalars['float8']['output']>;
  cAssessmentId?: Maybe<Scalars['uuid']['output']>;
  capex?: Maybe<Scalars['float8']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  opex?: Maybe<Scalars['float8']['output']>;
  reportId?: Maybe<Scalars['uuid']['output']>;
  revenue?: Maybe<Scalars['float8']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type TotalComparisonFinancials_Min_Fields_ = {
  __typename?: 'TotalComparisonFinancials_min_fields';
  adaptationCapex?: Maybe<Scalars['float8']['output']>;
  adaptationOpex?: Maybe<Scalars['float8']['output']>;
  cAssessmentId?: Maybe<Scalars['uuid']['output']>;
  capex?: Maybe<Scalars['float8']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  opex?: Maybe<Scalars['float8']['output']>;
  reportId?: Maybe<Scalars['uuid']['output']>;
  revenue?: Maybe<Scalars['float8']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "TotalComparisonFinancials" */
export type TotalComparisonFinancials_Mutation_Response_ = {
  __typename?: 'TotalComparisonFinancials_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TotalComparisonFinancials_>;
};

/** input type for inserting object relation for remote table "TotalComparisonFinancials" */
export type TotalComparisonFinancials_Obj_Rel_Insert_Input_ = {
  data: TotalComparisonFinancials_Insert_Input_;
};

/** Ordering options when selecting data from "TotalComparisonFinancials". */
export type TotalComparisonFinancials_Order_By_ = {
  adaptationCapex?: InputMaybe<Order_By_>;
  adaptationOpex?: InputMaybe<Order_By_>;
  attachmentBox?: InputMaybe<AttachmentBox_Order_By_>;
  cAssessmentId?: InputMaybe<Order_By_>;
  capex?: InputMaybe<Order_By_>;
  companyAssessment?: InputMaybe<CompanyAssessment_Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isEstimate?: InputMaybe<Order_By_>;
  isMaterial?: InputMaybe<Order_By_>;
  noteHistory?: InputMaybe<NoteHistory_Order_By_>;
  opex?: InputMaybe<Order_By_>;
  reportId?: InputMaybe<Order_By_>;
  revenue?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** select columns of table "TotalComparisonFinancials" */
export enum TotalComparisonFinancials_Select_Column_ {
  /** column name */
  AdaptationCapex_ = 'adaptationCapex',
  /** column name */
  AdaptationOpex_ = 'adaptationOpex',
  /** column name */
  CAssessmentId_ = 'cAssessmentId',
  /** column name */
  Capex_ = 'capex',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsEstimate_ = 'isEstimate',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  Opex_ = 'opex',
  /** column name */
  ReportId_ = 'reportId',
  /** column name */
  Revenue_ = 'revenue',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "TotalComparisonFinancials" */
export type TotalComparisonFinancials_Set_Input_ = {
  adaptationCapex?: InputMaybe<Scalars['float8']['input']>;
  adaptationOpex?: InputMaybe<Scalars['float8']['input']>;
  cAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  capex?: InputMaybe<Scalars['float8']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  opex?: InputMaybe<Scalars['float8']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  revenue?: InputMaybe<Scalars['float8']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type TotalComparisonFinancials_Stddev_Fields_ = {
  __typename?: 'TotalComparisonFinancials_stddev_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type TotalComparisonFinancials_Stddev_Pop_Fields_ = {
  __typename?: 'TotalComparisonFinancials_stddev_pop_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type TotalComparisonFinancials_Stddev_Samp_Fields_ = {
  __typename?: 'TotalComparisonFinancials_stddev_samp_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "TotalComparisonFinancials" */
export type TotalComparisonFinancials_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: TotalComparisonFinancials_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type TotalComparisonFinancials_Stream_Cursor_Value_Input_ = {
  adaptationCapex?: InputMaybe<Scalars['float8']['input']>;
  adaptationOpex?: InputMaybe<Scalars['float8']['input']>;
  cAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  capex?: InputMaybe<Scalars['float8']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isEstimate?: InputMaybe<Scalars['Boolean']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  opex?: InputMaybe<Scalars['float8']['input']>;
  reportId?: InputMaybe<Scalars['uuid']['input']>;
  revenue?: InputMaybe<Scalars['float8']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type TotalComparisonFinancials_Sum_Fields_ = {
  __typename?: 'TotalComparisonFinancials_sum_fields';
  adaptationCapex?: Maybe<Scalars['float8']['output']>;
  adaptationOpex?: Maybe<Scalars['float8']['output']>;
  capex?: Maybe<Scalars['float8']['output']>;
  opex?: Maybe<Scalars['float8']['output']>;
  revenue?: Maybe<Scalars['float8']['output']>;
};

export type TotalComparisonFinancials_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TotalComparisonFinancials_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TotalComparisonFinancials_Set_Input_>;
  /** filter the rows which have to be updated */
  where: TotalComparisonFinancials_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type TotalComparisonFinancials_Var_Pop_Fields_ = {
  __typename?: 'TotalComparisonFinancials_var_pop_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type TotalComparisonFinancials_Var_Samp_Fields_ = {
  __typename?: 'TotalComparisonFinancials_var_samp_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type TotalComparisonFinancials_Variance_Fields_ = {
  __typename?: 'TotalComparisonFinancials_variance_fields';
  adaptationCapex?: Maybe<Scalars['Float']['output']>;
  adaptationOpex?: Maybe<Scalars['Float']['output']>;
  capex?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  revenue?: Maybe<Scalars['Float']['output']>;
};

/** This specifies wether the trigger type for the audit logs comes from a hasura event or from a cloud function */
export type TriggerTypes_ = {
  __typename?: 'TriggerTypes';
  type: Scalars['String']['output'];
};

/** aggregated selection of "TriggerTypes" */
export type TriggerTypes_Aggregate_ = {
  __typename?: 'TriggerTypes_aggregate';
  aggregate?: Maybe<TriggerTypes_Aggregate_Fields_>;
  nodes: Array<TriggerTypes_>;
};

/** aggregate fields of "TriggerTypes" */
export type TriggerTypes_Aggregate_Fields_ = {
  __typename?: 'TriggerTypes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<TriggerTypes_Max_Fields_>;
  min?: Maybe<TriggerTypes_Min_Fields_>;
};


/** aggregate fields of "TriggerTypes" */
export type TriggerTypes_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<TriggerTypes_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "TriggerTypes". All fields are combined with a logical 'AND'. */
export type TriggerTypes_Bool_Exp_ = {
  _and?: InputMaybe<Array<TriggerTypes_Bool_Exp_>>;
  _not?: InputMaybe<TriggerTypes_Bool_Exp_>;
  _or?: InputMaybe<Array<TriggerTypes_Bool_Exp_>>;
  type?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "TriggerTypes" */
export enum TriggerTypes_Constraint_ {
  /** unique or primary key constraint on columns "type" */
  TriggerTypesPkey_ = 'TriggerTypes_pkey'
}

export enum TriggerTypes_Enum_ {
  Action_ = 'ACTION',
  Event_ = 'EVENT'
}

/** Boolean expression to compare columns of type "TriggerTypes_enum". All fields are combined with logical 'AND'. */
export type TriggerTypes_Enum_Comparison_Exp_ = {
  _eq?: InputMaybe<TriggerTypes_Enum_>;
  _in?: InputMaybe<Array<TriggerTypes_Enum_>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<TriggerTypes_Enum_>;
  _nin?: InputMaybe<Array<TriggerTypes_Enum_>>;
};

/** input type for inserting data into table "TriggerTypes" */
export type TriggerTypes_Insert_Input_ = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TriggerTypes_Max_Fields_ = {
  __typename?: 'TriggerTypes_max_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type TriggerTypes_Min_Fields_ = {
  __typename?: 'TriggerTypes_min_fields';
  type?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "TriggerTypes" */
export type TriggerTypes_Mutation_Response_ = {
  __typename?: 'TriggerTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TriggerTypes_>;
};

/** on_conflict condition type for table "TriggerTypes" */
export type TriggerTypes_On_Conflict_ = {
  constraint: TriggerTypes_Constraint_;
  update_columns?: Array<TriggerTypes_Update_Column_>;
  where?: InputMaybe<TriggerTypes_Bool_Exp_>;
};

/** Ordering options when selecting data from "TriggerTypes". */
export type TriggerTypes_Order_By_ = {
  type?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: TriggerTypes */
export type TriggerTypes_Pk_Columns_Input_ = {
  type: Scalars['String']['input'];
};

/** select columns of table "TriggerTypes" */
export enum TriggerTypes_Select_Column_ {
  /** column name */
  Type_ = 'type'
}

/** input type for updating data in table "TriggerTypes" */
export type TriggerTypes_Set_Input_ = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "TriggerTypes" */
export type TriggerTypes_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: TriggerTypes_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type TriggerTypes_Stream_Cursor_Value_Input_ = {
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "TriggerTypes" */
export enum TriggerTypes_Update_Column_ {
  /** column name */
  Type_ = 'type'
}

export type TriggerTypes_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TriggerTypes_Set_Input_>;
  /** filter the rows which have to be updated */
  where: TriggerTypes_Bool_Exp_;
};

export type UpdateFinancialsInput_ = {
  activityReportId: Scalars['uuid']['input'];
  adaptationCapex?: InputMaybe<Scalars['float8']['input']>;
  adaptationOpex?: InputMaybe<Scalars['float8']['input']>;
  capex?: InputMaybe<Scalars['float8']['input']>;
  opex?: InputMaybe<Scalars['float8']['input']>;
  revenue?: InputMaybe<Scalars['float8']['input']>;
};

export type UpdateFinancialsOutput_ = {
  __typename?: 'UpdateFinancialsOutput';
  id: Scalars['String']['output'];
};

/** columns and relationships of "UserNotification" */
export type UserNotification_ = {
  __typename?: 'UserNotification';
  /** An object relationship */
  comment: Comment_;
  commentId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  emailSentAt?: Maybe<Scalars['timestamp']['output']>;
  id: Scalars['uuid']['output'];
  isRead: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users_;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "UserNotification" */
export type UserNotification_Aggregate_ = {
  __typename?: 'UserNotification_aggregate';
  aggregate?: Maybe<UserNotification_Aggregate_Fields_>;
  nodes: Array<UserNotification_>;
};

export type UserNotification_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<UserNotification_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<UserNotification_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<UserNotification_Aggregate_Bool_Exp_Count_>;
};

export type UserNotification_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: UserNotification_Select_Column_UserNotification_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserNotification_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type UserNotification_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: UserNotification_Select_Column_UserNotification_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserNotification_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type UserNotification_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<UserNotification_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserNotification_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "UserNotification" */
export type UserNotification_Aggregate_Fields_ = {
  __typename?: 'UserNotification_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<UserNotification_Max_Fields_>;
  min?: Maybe<UserNotification_Min_Fields_>;
};


/** aggregate fields of "UserNotification" */
export type UserNotification_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<UserNotification_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "UserNotification" */
export type UserNotification_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<UserNotification_Max_Order_By_>;
  min?: InputMaybe<UserNotification_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "UserNotification" */
export type UserNotification_Arr_Rel_Insert_Input_ = {
  data: Array<UserNotification_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<UserNotification_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "UserNotification". All fields are combined with a logical 'AND'. */
export type UserNotification_Bool_Exp_ = {
  _and?: InputMaybe<Array<UserNotification_Bool_Exp_>>;
  _not?: InputMaybe<UserNotification_Bool_Exp_>;
  _or?: InputMaybe<Array<UserNotification_Bool_Exp_>>;
  comment?: InputMaybe<Comment_Bool_Exp_>;
  commentId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  emailSentAt?: InputMaybe<Timestamp_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isRead?: InputMaybe<Boolean_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  user?: InputMaybe<Users_Bool_Exp_>;
  userId?: InputMaybe<Uuid_Comparison_Exp_>;
};

/** unique or primary key constraints on table "UserNotification" */
export enum UserNotification_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  UserNotificationPkey_ = 'UserNotification_pkey'
}

/** input type for inserting data into table "UserNotification" */
export type UserNotification_Insert_Input_ = {
  comment?: InputMaybe<Comment_Obj_Rel_Insert_Input_>;
  commentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  emailSentAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type UserNotification_Max_Fields_ = {
  __typename?: 'UserNotification_max_fields';
  commentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  emailSentAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "UserNotification" */
export type UserNotification_Max_Order_By_ = {
  commentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  emailSentAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type UserNotification_Min_Fields_ = {
  __typename?: 'UserNotification_min_fields';
  commentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  emailSentAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "UserNotification" */
export type UserNotification_Min_Order_By_ = {
  commentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  emailSentAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "UserNotification" */
export type UserNotification_Mutation_Response_ = {
  __typename?: 'UserNotification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserNotification_>;
};

/** on_conflict condition type for table "UserNotification" */
export type UserNotification_On_Conflict_ = {
  constraint: UserNotification_Constraint_;
  update_columns?: Array<UserNotification_Update_Column_>;
  where?: InputMaybe<UserNotification_Bool_Exp_>;
};

/** Ordering options when selecting data from "UserNotification". */
export type UserNotification_Order_By_ = {
  comment?: InputMaybe<Comment_Order_By_>;
  commentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  emailSentAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isRead?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  user?: InputMaybe<Users_Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: UserNotification */
export type UserNotification_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "UserNotification" */
export enum UserNotification_Select_Column_ {
  /** column name */
  CommentId_ = 'commentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  EmailSentAt_ = 'emailSentAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsRead_ = 'isRead',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UserId_ = 'userId'
}

/** select "UserNotification_aggregate_bool_exp_bool_and_arguments_columns" columns of table "UserNotification" */
export enum UserNotification_Select_Column_UserNotification_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsRead_ = 'isRead'
}

/** select "UserNotification_aggregate_bool_exp_bool_or_arguments_columns" columns of table "UserNotification" */
export enum UserNotification_Select_Column_UserNotification_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsRead_ = 'isRead'
}

/** input type for updating data in table "UserNotification" */
export type UserNotification_Set_Input_ = {
  commentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  emailSentAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "UserNotification" */
export type UserNotification_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: UserNotification_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type UserNotification_Stream_Cursor_Value_Input_ = {
  commentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  emailSentAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "UserNotification" */
export enum UserNotification_Update_Column_ {
  /** column name */
  CommentId_ = 'commentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  EmailSentAt_ = 'emailSentAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsRead_ = 'isRead',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UserId_ = 'userId'
}

export type UserNotification_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserNotification_Set_Input_>;
  /** filter the rows which have to be updated */
  where: UserNotification_Bool_Exp_;
};

/** columns and relationships of "UserRole" */
export type UserRole_ = {
  __typename?: 'UserRole';
  description: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

/** aggregated selection of "UserRole" */
export type UserRole_Aggregate_ = {
  __typename?: 'UserRole_aggregate';
  aggregate?: Maybe<UserRole_Aggregate_Fields_>;
  nodes: Array<UserRole_>;
};

/** aggregate fields of "UserRole" */
export type UserRole_Aggregate_Fields_ = {
  __typename?: 'UserRole_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<UserRole_Max_Fields_>;
  min?: Maybe<UserRole_Min_Fields_>;
};


/** aggregate fields of "UserRole" */
export type UserRole_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<UserRole_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "UserRole". All fields are combined with a logical 'AND'. */
export type UserRole_Bool_Exp_ = {
  _and?: InputMaybe<Array<UserRole_Bool_Exp_>>;
  _not?: InputMaybe<UserRole_Bool_Exp_>;
  _or?: InputMaybe<Array<UserRole_Bool_Exp_>>;
  description?: InputMaybe<String_Comparison_Exp_>;
  role?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "UserRole" */
export enum UserRole_Constraint_ {
  /** unique or primary key constraint on columns "role" */
  UserRolesPkey_ = 'userRoles_pkey'
}

export enum UserRole_Enum_ {
  /** Administrator rights to a company. Can manage users and their roles in the company. */
  Admin_ = 'ADMIN',
  /** Can view reports. Including financials and answers to question, and can edit the audit status. */
  Auditor_ = 'AUDITOR',
  /** Can create and edit reports, including financials and answers to questions. */
  Editor_ = 'EDITOR'
}

/** Boolean expression to compare columns of type "UserRole_enum". All fields are combined with logical 'AND'. */
export type UserRole_Enum_Comparison_Exp_ = {
  _eq?: InputMaybe<UserRole_Enum_>;
  _in?: InputMaybe<Array<UserRole_Enum_>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<UserRole_Enum_>;
  _nin?: InputMaybe<Array<UserRole_Enum_>>;
};

/** input type for inserting data into table "UserRole" */
export type UserRole_Insert_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type UserRole_Max_Fields_ = {
  __typename?: 'UserRole_max_fields';
  description?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type UserRole_Min_Fields_ = {
  __typename?: 'UserRole_min_fields';
  description?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "UserRole" */
export type UserRole_Mutation_Response_ = {
  __typename?: 'UserRole_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserRole_>;
};

/** on_conflict condition type for table "UserRole" */
export type UserRole_On_Conflict_ = {
  constraint: UserRole_Constraint_;
  update_columns?: Array<UserRole_Update_Column_>;
  where?: InputMaybe<UserRole_Bool_Exp_>;
};

/** Ordering options when selecting data from "UserRole". */
export type UserRole_Order_By_ = {
  description?: InputMaybe<Order_By_>;
  role?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: UserRole */
export type UserRole_Pk_Columns_Input_ = {
  role: Scalars['String']['input'];
};

/** select columns of table "UserRole" */
export enum UserRole_Select_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  Role_ = 'role'
}

/** input type for updating data in table "UserRole" */
export type UserRole_Set_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "UserRole" */
export type UserRole_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: UserRole_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type UserRole_Stream_Cursor_Value_Input_ = {
  description?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "UserRole" */
export enum UserRole_Update_Column_ {
  /** column name */
  Description_ = 'description',
  /** column name */
  Role_ = 'role'
}

export type UserRole_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserRole_Set_Input_>;
  /** filter the rows which have to be updated */
  where: UserRole_Bool_Exp_;
};

/** Additional info about the currently logged in users. This is coming from the user and can not be trusted 100%, but can be useful to manage sessions etc. */
export type UserSessionMetadata_ = {
  __typename?: 'UserSessionMetadata';
  browser?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  /** Set to the same as refreshTokenId, however, this one will not be nulled if the refreshToken is deleted. */
  id: Scalars['uuid']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  operatingSystem?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  refreshToken?: Maybe<AuthRefreshTokens_>;
  refreshTokenId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "UserSessionMetadata" */
export type UserSessionMetadata_Aggregate_ = {
  __typename?: 'UserSessionMetadata_aggregate';
  aggregate?: Maybe<UserSessionMetadata_Aggregate_Fields_>;
  nodes: Array<UserSessionMetadata_>;
};

/** aggregate fields of "UserSessionMetadata" */
export type UserSessionMetadata_Aggregate_Fields_ = {
  __typename?: 'UserSessionMetadata_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<UserSessionMetadata_Max_Fields_>;
  min?: Maybe<UserSessionMetadata_Min_Fields_>;
};


/** aggregate fields of "UserSessionMetadata" */
export type UserSessionMetadata_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<UserSessionMetadata_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "UserSessionMetadata". All fields are combined with a logical 'AND'. */
export type UserSessionMetadata_Bool_Exp_ = {
  _and?: InputMaybe<Array<UserSessionMetadata_Bool_Exp_>>;
  _not?: InputMaybe<UserSessionMetadata_Bool_Exp_>;
  _or?: InputMaybe<Array<UserSessionMetadata_Bool_Exp_>>;
  browser?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  deletedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  device?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  ipAddress?: InputMaybe<String_Comparison_Exp_>;
  operatingSystem?: InputMaybe<String_Comparison_Exp_>;
  refreshToken?: InputMaybe<AuthRefreshTokens_Bool_Exp_>;
  refreshTokenId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  userId?: InputMaybe<Uuid_Comparison_Exp_>;
};

/** unique or primary key constraints on table "UserSessionMetadata" */
export enum UserSessionMetadata_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  UserSessionMetadataPkey_ = 'UserSessionMetadata_pkey',
  /** unique or primary key constraint on columns "refreshTokenId" */
  UserSessionMetadataRefreshTokenIdKey_ = 'UserSessionMetadata_refreshTokenId_key'
}

/** input type for inserting data into table "UserSessionMetadata" */
export type UserSessionMetadata_Insert_Input_ = {
  browser?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  device?: InputMaybe<Scalars['String']['input']>;
  /** Set to the same as refreshTokenId, however, this one will not be nulled if the refreshToken is deleted. */
  id?: InputMaybe<Scalars['uuid']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  operatingSystem?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<AuthRefreshTokens_Obj_Rel_Insert_Input_>;
  refreshTokenId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type UserSessionMetadata_Max_Fields_ = {
  __typename?: 'UserSessionMetadata_max_fields';
  browser?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  /** Set to the same as refreshTokenId, however, this one will not be nulled if the refreshToken is deleted. */
  id?: Maybe<Scalars['uuid']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  operatingSystem?: Maybe<Scalars['String']['output']>;
  refreshTokenId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type UserSessionMetadata_Min_Fields_ = {
  __typename?: 'UserSessionMetadata_min_fields';
  browser?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deletedAt?: Maybe<Scalars['timestamptz']['output']>;
  device?: Maybe<Scalars['String']['output']>;
  /** Set to the same as refreshTokenId, however, this one will not be nulled if the refreshToken is deleted. */
  id?: Maybe<Scalars['uuid']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  operatingSystem?: Maybe<Scalars['String']['output']>;
  refreshTokenId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "UserSessionMetadata" */
export type UserSessionMetadata_Mutation_Response_ = {
  __typename?: 'UserSessionMetadata_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserSessionMetadata_>;
};

/** on_conflict condition type for table "UserSessionMetadata" */
export type UserSessionMetadata_On_Conflict_ = {
  constraint: UserSessionMetadata_Constraint_;
  update_columns?: Array<UserSessionMetadata_Update_Column_>;
  where?: InputMaybe<UserSessionMetadata_Bool_Exp_>;
};

/** Ordering options when selecting data from "UserSessionMetadata". */
export type UserSessionMetadata_Order_By_ = {
  browser?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deletedAt?: InputMaybe<Order_By_>;
  device?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  ipAddress?: InputMaybe<Order_By_>;
  operatingSystem?: InputMaybe<Order_By_>;
  refreshToken?: InputMaybe<AuthRefreshTokens_Order_By_>;
  refreshTokenId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: UserSessionMetadata */
export type UserSessionMetadata_Pk_Columns_Input_ = {
  /** Set to the same as refreshTokenId, however, this one will not be nulled if the refreshToken is deleted. */
  id: Scalars['uuid']['input'];
};

/** select columns of table "UserSessionMetadata" */
export enum UserSessionMetadata_Select_Column_ {
  /** column name */
  Browser_ = 'browser',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Device_ = 'device',
  /** column name */
  Id_ = 'id',
  /** column name */
  IpAddress_ = 'ipAddress',
  /** column name */
  OperatingSystem_ = 'operatingSystem',
  /** column name */
  RefreshTokenId_ = 'refreshTokenId',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UserId_ = 'userId'
}

/** input type for updating data in table "UserSessionMetadata" */
export type UserSessionMetadata_Set_Input_ = {
  browser?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  device?: InputMaybe<Scalars['String']['input']>;
  /** Set to the same as refreshTokenId, however, this one will not be nulled if the refreshToken is deleted. */
  id?: InputMaybe<Scalars['uuid']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  operatingSystem?: InputMaybe<Scalars['String']['input']>;
  refreshTokenId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "UserSessionMetadata" */
export type UserSessionMetadata_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: UserSessionMetadata_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type UserSessionMetadata_Stream_Cursor_Value_Input_ = {
  browser?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  device?: InputMaybe<Scalars['String']['input']>;
  /** Set to the same as refreshTokenId, however, this one will not be nulled if the refreshToken is deleted. */
  id?: InputMaybe<Scalars['uuid']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  operatingSystem?: InputMaybe<Scalars['String']['input']>;
  refreshTokenId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "UserSessionMetadata" */
export enum UserSessionMetadata_Update_Column_ {
  /** column name */
  Browser_ = 'browser',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeletedAt_ = 'deletedAt',
  /** column name */
  Device_ = 'device',
  /** column name */
  Id_ = 'id',
  /** column name */
  IpAddress_ = 'ipAddress',
  /** column name */
  OperatingSystem_ = 'operatingSystem',
  /** column name */
  RefreshTokenId_ = 'refreshTokenId',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UserId_ = 'userId'
}

export type UserSessionMetadata_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserSessionMetadata_Set_Input_>;
  /** filter the rows which have to be updated */
  where: UserSessionMetadata_Bool_Exp_;
};

/** This table is used only to test websocket connection, and should be deleted once the test is completed. */
export type WebsocketTest_ = {
  __typename?: 'WebsocketTest';
  id: Scalars['Int']['output'];
};

/** aggregated selection of "WebsocketTest" */
export type WebsocketTest_Aggregate_ = {
  __typename?: 'WebsocketTest_aggregate';
  aggregate?: Maybe<WebsocketTest_Aggregate_Fields_>;
  nodes: Array<WebsocketTest_>;
};

/** aggregate fields of "WebsocketTest" */
export type WebsocketTest_Aggregate_Fields_ = {
  __typename?: 'WebsocketTest_aggregate_fields';
  avg?: Maybe<WebsocketTest_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<WebsocketTest_Max_Fields_>;
  min?: Maybe<WebsocketTest_Min_Fields_>;
  stddev?: Maybe<WebsocketTest_Stddev_Fields_>;
  stddev_pop?: Maybe<WebsocketTest_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<WebsocketTest_Stddev_Samp_Fields_>;
  sum?: Maybe<WebsocketTest_Sum_Fields_>;
  var_pop?: Maybe<WebsocketTest_Var_Pop_Fields_>;
  var_samp?: Maybe<WebsocketTest_Var_Samp_Fields_>;
  variance?: Maybe<WebsocketTest_Variance_Fields_>;
};


/** aggregate fields of "WebsocketTest" */
export type WebsocketTest_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<WebsocketTest_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type WebsocketTest_Avg_Fields_ = {
  __typename?: 'WebsocketTest_avg_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "WebsocketTest". All fields are combined with a logical 'AND'. */
export type WebsocketTest_Bool_Exp_ = {
  _and?: InputMaybe<Array<WebsocketTest_Bool_Exp_>>;
  _not?: InputMaybe<WebsocketTest_Bool_Exp_>;
  _or?: InputMaybe<Array<WebsocketTest_Bool_Exp_>>;
  id?: InputMaybe<Int_Comparison_Exp_>;
};

/** unique or primary key constraints on table "WebsocketTest" */
export enum WebsocketTest_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  WebsocketTestPkey_ = 'WebsocketTest_pkey'
}

/** input type for incrementing numeric columns in table "WebsocketTest" */
export type WebsocketTest_Inc_Input_ = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "WebsocketTest" */
export type WebsocketTest_Insert_Input_ = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type WebsocketTest_Max_Fields_ = {
  __typename?: 'WebsocketTest_max_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type WebsocketTest_Min_Fields_ = {
  __typename?: 'WebsocketTest_min_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "WebsocketTest" */
export type WebsocketTest_Mutation_Response_ = {
  __typename?: 'WebsocketTest_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<WebsocketTest_>;
};

/** on_conflict condition type for table "WebsocketTest" */
export type WebsocketTest_On_Conflict_ = {
  constraint: WebsocketTest_Constraint_;
  update_columns?: Array<WebsocketTest_Update_Column_>;
  where?: InputMaybe<WebsocketTest_Bool_Exp_>;
};

/** Ordering options when selecting data from "WebsocketTest". */
export type WebsocketTest_Order_By_ = {
  id?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: WebsocketTest */
export type WebsocketTest_Pk_Columns_Input_ = {
  id: Scalars['Int']['input'];
};

/** select columns of table "WebsocketTest" */
export enum WebsocketTest_Select_Column_ {
  /** column name */
  Id_ = 'id'
}

/** input type for updating data in table "WebsocketTest" */
export type WebsocketTest_Set_Input_ = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type WebsocketTest_Stddev_Fields_ = {
  __typename?: 'WebsocketTest_stddev_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type WebsocketTest_Stddev_Pop_Fields_ = {
  __typename?: 'WebsocketTest_stddev_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type WebsocketTest_Stddev_Samp_Fields_ = {
  __typename?: 'WebsocketTest_stddev_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "WebsocketTest" */
export type WebsocketTest_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: WebsocketTest_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type WebsocketTest_Stream_Cursor_Value_Input_ = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type WebsocketTest_Sum_Fields_ = {
  __typename?: 'WebsocketTest_sum_fields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "WebsocketTest" */
export enum WebsocketTest_Update_Column_ {
  /** column name */
  Id_ = 'id'
}

export type WebsocketTest_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<WebsocketTest_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<WebsocketTest_Set_Input_>;
  /** filter the rows which have to be updated */
  where: WebsocketTest_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type WebsocketTest_Var_Pop_Fields_ = {
  __typename?: 'WebsocketTest_var_pop_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type WebsocketTest_Var_Samp_Fields_ = {
  __typename?: 'WebsocketTest_var_samp_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type WebsocketTest_Variance_Fields_ = {
  __typename?: 'WebsocketTest_variance_fields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequests_ = {
  __typename?: 'authProviderRequests';
  id: Scalars['uuid']['output'];
  options?: Maybe<Scalars['jsonb']['output']>;
};


/** Oauth requests, inserted before redirecting to the provider's site. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviderRequestsOptionsArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_ = {
  __typename?: 'authProviderRequests_aggregate';
  aggregate?: Maybe<AuthProviderRequests_Aggregate_Fields_>;
  nodes: Array<AuthProviderRequests_>;
};

/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_Fields_ = {
  __typename?: 'authProviderRequests_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthProviderRequests_Max_Fields_>;
  min?: Maybe<AuthProviderRequests_Min_Fields_>;
};


/** aggregate fields of "auth.provider_requests" */
export type AuthProviderRequests_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<AuthProviderRequests_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Append_Input_ = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "auth.provider_requests". All fields are combined with a logical 'AND'. */
export type AuthProviderRequests_Bool_Exp_ = {
  _and?: InputMaybe<Array<AuthProviderRequests_Bool_Exp_>>;
  _not?: InputMaybe<AuthProviderRequests_Bool_Exp_>;
  _or?: InputMaybe<Array<AuthProviderRequests_Bool_Exp_>>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  options?: InputMaybe<Jsonb_Comparison_Exp_>;
};

/** unique or primary key constraints on table "auth.provider_requests" */
export enum AuthProviderRequests_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  ProviderRequestsPkey_ = 'provider_requests_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthProviderRequests_Delete_At_Path_Input_ = {
  options?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthProviderRequests_Delete_Elem_Input_ = {
  options?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthProviderRequests_Delete_Key_Input_ = {
  options?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.provider_requests" */
export type AuthProviderRequests_Insert_Input_ = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type AuthProviderRequests_Max_Fields_ = {
  __typename?: 'authProviderRequests_max_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type AuthProviderRequests_Min_Fields_ = {
  __typename?: 'authProviderRequests_min_fields';
  id?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "auth.provider_requests" */
export type AuthProviderRequests_Mutation_Response_ = {
  __typename?: 'authProviderRequests_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviderRequests_>;
};

/** on_conflict condition type for table "auth.provider_requests" */
export type AuthProviderRequests_On_Conflict_ = {
  constraint: AuthProviderRequests_Constraint_;
  update_columns?: Array<AuthProviderRequests_Update_Column_>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp_>;
};

/** Ordering options when selecting data from "auth.provider_requests". */
export type AuthProviderRequests_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  options?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: auth.provider_requests */
export type AuthProviderRequests_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthProviderRequests_Prepend_Input_ = {
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Select_Column_ {
  /** column name */
  Id_ = 'id',
  /** column name */
  Options_ = 'options'
}

/** input type for updating data in table "auth.provider_requests" */
export type AuthProviderRequests_Set_Input_ = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "authProviderRequests" */
export type AuthProviderRequests_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: AuthProviderRequests_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type AuthProviderRequests_Stream_Cursor_Value_Input_ = {
  id?: InputMaybe<Scalars['uuid']['input']>;
  options?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "auth.provider_requests" */
export enum AuthProviderRequests_Update_Column_ {
  /** column name */
  Id_ = 'id',
  /** column name */
  Options_ = 'options'
}

export type AuthProviderRequests_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthProviderRequests_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthProviderRequests_Set_Input_>;
  /** filter the rows which have to be updated */
  where: AuthProviderRequests_Bool_Exp_;
};

/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProviders_ = {
  __typename?: 'authProviders';
  id: Scalars['String']['output'];
  /** An array relationship */
  userProviders: Array<AuthUserProviders_>;
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate_;
};


/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProvidersArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By_>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp_>;
};


/** List of available Oauth providers. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthProvidersUserProviders_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By_>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp_>;
};

/** aggregated selection of "auth.providers" */
export type AuthProviders_Aggregate_ = {
  __typename?: 'authProviders_aggregate';
  aggregate?: Maybe<AuthProviders_Aggregate_Fields_>;
  nodes: Array<AuthProviders_>;
};

/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_Fields_ = {
  __typename?: 'authProviders_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthProviders_Max_Fields_>;
  min?: Maybe<AuthProviders_Min_Fields_>;
};


/** aggregate fields of "auth.providers" */
export type AuthProviders_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<AuthProviders_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.providers". All fields are combined with a logical 'AND'. */
export type AuthProviders_Bool_Exp_ = {
  _and?: InputMaybe<Array<AuthProviders_Bool_Exp_>>;
  _not?: InputMaybe<AuthProviders_Bool_Exp_>;
  _or?: InputMaybe<Array<AuthProviders_Bool_Exp_>>;
  id?: InputMaybe<String_Comparison_Exp_>;
  userProviders?: InputMaybe<AuthUserProviders_Bool_Exp_>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp_>;
};

/** unique or primary key constraints on table "auth.providers" */
export enum AuthProviders_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  ProvidersPkey_ = 'providers_pkey'
}

/** input type for inserting data into table "auth.providers" */
export type AuthProviders_Insert_Input_ = {
  id?: InputMaybe<Scalars['String']['input']>;
  userProviders?: InputMaybe<AuthUserProviders_Arr_Rel_Insert_Input_>;
};

/** aggregate max on columns */
export type AuthProviders_Max_Fields_ = {
  __typename?: 'authProviders_max_fields';
  id?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthProviders_Min_Fields_ = {
  __typename?: 'authProviders_min_fields';
  id?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.providers" */
export type AuthProviders_Mutation_Response_ = {
  __typename?: 'authProviders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthProviders_>;
};

/** input type for inserting object relation for remote table "auth.providers" */
export type AuthProviders_Obj_Rel_Insert_Input_ = {
  data: AuthProviders_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthProviders_On_Conflict_>;
};

/** on_conflict condition type for table "auth.providers" */
export type AuthProviders_On_Conflict_ = {
  constraint: AuthProviders_Constraint_;
  update_columns?: Array<AuthProviders_Update_Column_>;
  where?: InputMaybe<AuthProviders_Bool_Exp_>;
};

/** Ordering options when selecting data from "auth.providers". */
export type AuthProviders_Order_By_ = {
  id?: InputMaybe<Order_By_>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Order_By_>;
};

/** primary key columns input for table: auth.providers */
export type AuthProviders_Pk_Columns_Input_ = {
  id: Scalars['String']['input'];
};

/** select columns of table "auth.providers" */
export enum AuthProviders_Select_Column_ {
  /** column name */
  Id_ = 'id'
}

/** input type for updating data in table "auth.providers" */
export type AuthProviders_Set_Input_ = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authProviders" */
export type AuthProviders_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: AuthProviders_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type AuthProviders_Stream_Cursor_Value_Input_ = {
  id?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.providers" */
export enum AuthProviders_Update_Column_ {
  /** column name */
  Id_ = 'id'
}

export type AuthProviders_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthProviders_Set_Input_>;
  /** filter the rows which have to be updated */
  where: AuthProviders_Bool_Exp_;
};

/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_ = {
  __typename?: 'authRefreshTokenTypes';
  comment?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens_>;
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthRefreshTokens_Aggregate_;
  value: Scalars['String']['output'];
};


/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypesRefreshTokensArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By_>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp_>;
};


/** columns and relationships of "auth.refresh_token_types" */
export type AuthRefreshTokenTypesRefreshTokens_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By_>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp_>;
};

/** aggregated selection of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate_ = {
  __typename?: 'authRefreshTokenTypes_aggregate';
  aggregate?: Maybe<AuthRefreshTokenTypes_Aggregate_Fields_>;
  nodes: Array<AuthRefreshTokenTypes_>;
};

/** aggregate fields of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate_Fields_ = {
  __typename?: 'authRefreshTokenTypes_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthRefreshTokenTypes_Max_Fields_>;
  min?: Maybe<AuthRefreshTokenTypes_Min_Fields_>;
};


/** aggregate fields of "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.refresh_token_types". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokenTypes_Bool_Exp_ = {
  _and?: InputMaybe<Array<AuthRefreshTokenTypes_Bool_Exp_>>;
  _not?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp_>;
  _or?: InputMaybe<Array<AuthRefreshTokenTypes_Bool_Exp_>>;
  comment?: InputMaybe<String_Comparison_Exp_>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Bool_Exp_>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp_>;
  value?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Constraint_ {
  /** unique or primary key constraint on columns "value" */
  RefreshTokenTypesPkey_ = 'refresh_token_types_pkey'
}

export enum AuthRefreshTokenTypes_Enum_ {
  /** Personal access token */
  Pat_ = 'pat',
  /** Regular refresh token */
  Regular_ = 'regular'
}

/** Boolean expression to compare columns of type "authRefreshTokenTypes_enum". All fields are combined with logical 'AND'. */
export type AuthRefreshTokenTypes_Enum_Comparison_Exp_ = {
  _eq?: InputMaybe<AuthRefreshTokenTypes_Enum_>;
  _in?: InputMaybe<Array<AuthRefreshTokenTypes_Enum_>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<AuthRefreshTokenTypes_Enum_>;
  _nin?: InputMaybe<Array<AuthRefreshTokenTypes_Enum_>>;
};

/** input type for inserting data into table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Insert_Input_ = {
  comment?: InputMaybe<Scalars['String']['input']>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Arr_Rel_Insert_Input_>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AuthRefreshTokenTypes_Max_Fields_ = {
  __typename?: 'authRefreshTokenTypes_max_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthRefreshTokenTypes_Min_Fields_ = {
  __typename?: 'authRefreshTokenTypes_min_fields';
  comment?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Mutation_Response_ = {
  __typename?: 'authRefreshTokenTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokenTypes_>;
};

/** on_conflict condition type for table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_On_Conflict_ = {
  constraint: AuthRefreshTokenTypes_Constraint_;
  update_columns?: Array<AuthRefreshTokenTypes_Update_Column_>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp_>;
};

/** Ordering options when selecting data from "auth.refresh_token_types". */
export type AuthRefreshTokenTypes_Order_By_ = {
  comment?: InputMaybe<Order_By_>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: auth.refresh_token_types */
export type AuthRefreshTokenTypes_Pk_Columns_Input_ = {
  value: Scalars['String']['input'];
};

/** select columns of table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Select_Column_ {
  /** column name */
  Comment_ = 'comment',
  /** column name */
  Value_ = 'value'
}

/** input type for updating data in table "auth.refresh_token_types" */
export type AuthRefreshTokenTypes_Set_Input_ = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authRefreshTokenTypes" */
export type AuthRefreshTokenTypes_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokenTypes_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokenTypes_Stream_Cursor_Value_Input_ = {
  comment?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.refresh_token_types" */
export enum AuthRefreshTokenTypes_Update_Column_ {
  /** column name */
  Comment_ = 'comment',
  /** column name */
  Value_ = 'value'
}

export type AuthRefreshTokenTypes_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input_>;
  /** filter the rows which have to be updated */
  where: AuthRefreshTokenTypes_Bool_Exp_;
};

/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokens_ = {
  __typename?: 'authRefreshTokens';
  createdAt: Scalars['timestamptz']['output'];
  expiresAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  type: AuthRefreshTokenTypes_Enum_;
  /** An object relationship */
  user: Users_;
  userId: Scalars['uuid']['output'];
};


/** User refresh tokens. Hasura auth uses them to rotate new access tokens as long as the refresh token is not expired. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRefreshTokensMetadataArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_ = {
  __typename?: 'authRefreshTokens_aggregate';
  aggregate?: Maybe<AuthRefreshTokens_Aggregate_Fields_>;
  nodes: Array<AuthRefreshTokens_>;
};

export type AuthRefreshTokens_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp_Count_>;
};

export type AuthRefreshTokens_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<AuthRefreshTokens_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthRefreshTokens_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Fields_ = {
  __typename?: 'authRefreshTokens_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthRefreshTokens_Max_Fields_>;
  min?: Maybe<AuthRefreshTokens_Min_Fields_>;
};


/** aggregate fields of "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<AuthRefreshTokens_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<AuthRefreshTokens_Max_Order_By_>;
  min?: InputMaybe<AuthRefreshTokens_Min_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthRefreshTokens_Append_Input_ = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "auth.refresh_tokens" */
export type AuthRefreshTokens_Arr_Rel_Insert_Input_ = {
  data: Array<AuthRefreshTokens_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "auth.refresh_tokens". All fields are combined with a logical 'AND'. */
export type AuthRefreshTokens_Bool_Exp_ = {
  _and?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp_>>;
  _not?: InputMaybe<AuthRefreshTokens_Bool_Exp_>;
  _or?: InputMaybe<Array<AuthRefreshTokens_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  expiresAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp_>;
  refreshTokenHash?: InputMaybe<String_Comparison_Exp_>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum_Comparison_Exp_>;
  user?: InputMaybe<Users_Bool_Exp_>;
  userId?: InputMaybe<Uuid_Comparison_Exp_>;
};

/** unique or primary key constraints on table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  RefreshTokensPkey_ = 'refresh_tokens_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthRefreshTokens_Delete_At_Path_Input_ = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthRefreshTokens_Delete_Elem_Input_ = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthRefreshTokens_Delete_Key_Input_ = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.refresh_tokens" */
export type AuthRefreshTokens_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum_>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthRefreshTokens_Max_Fields_ = {
  __typename?: 'authRefreshTokens_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  expiresAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  refreshTokenHash?: InputMaybe<Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type AuthRefreshTokens_Min_Fields_ = {
  __typename?: 'authRefreshTokens_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  expiresAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  refreshTokenHash?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.refresh_tokens" */
export type AuthRefreshTokens_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  expiresAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  refreshTokenHash?: InputMaybe<Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "auth.refresh_tokens" */
export type AuthRefreshTokens_Mutation_Response_ = {
  __typename?: 'authRefreshTokens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRefreshTokens_>;
};

/** input type for inserting object relation for remote table "auth.refresh_tokens" */
export type AuthRefreshTokens_Obj_Rel_Insert_Input_ = {
  data: AuthRefreshTokens_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict_>;
};

/** on_conflict condition type for table "auth.refresh_tokens" */
export type AuthRefreshTokens_On_Conflict_ = {
  constraint: AuthRefreshTokens_Constraint_;
  update_columns?: Array<AuthRefreshTokens_Update_Column_>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp_>;
};

/** Ordering options when selecting data from "auth.refresh_tokens". */
export type AuthRefreshTokens_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  expiresAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  metadata?: InputMaybe<Order_By_>;
  refreshTokenHash?: InputMaybe<Order_By_>;
  type?: InputMaybe<Order_By_>;
  user?: InputMaybe<Users_Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: auth.refresh_tokens */
export type AuthRefreshTokens_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthRefreshTokens_Prepend_Input_ = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  ExpiresAt_ = 'expiresAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Metadata_ = 'metadata',
  /** column name */
  RefreshTokenHash_ = 'refreshTokenHash',
  /** column name */
  Type_ = 'type',
  /** column name */
  UserId_ = 'userId'
}

/** input type for updating data in table "auth.refresh_tokens" */
export type AuthRefreshTokens_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum_>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "authRefreshTokens" */
export type AuthRefreshTokens_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: AuthRefreshTokens_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRefreshTokens_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  expiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  refreshTokenHash?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<AuthRefreshTokenTypes_Enum_>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.refresh_tokens" */
export enum AuthRefreshTokens_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  ExpiresAt_ = 'expiresAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Metadata_ = 'metadata',
  /** column name */
  RefreshTokenHash_ = 'refreshTokenHash',
  /** column name */
  Type_ = 'type',
  /** column name */
  UserId_ = 'userId'
}

export type AuthRefreshTokens_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthRefreshTokens_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRefreshTokens_Set_Input_>;
  /** filter the rows which have to be updated */
  where: AuthRefreshTokens_Bool_Exp_;
};

/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRoles_ = {
  __typename?: 'authRoles';
  role: Scalars['String']['output'];
  /** An array relationship */
  userRoles: Array<AuthUserRoles_>;
  /** An aggregate relationship */
  userRoles_aggregate: AuthUserRoles_Aggregate_;
  /** An array relationship */
  usersByDefaultRole: Array<Users_>;
  /** An aggregate relationship */
  usersByDefaultRole_aggregate: Users_Aggregate_;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRolesArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By_>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp_>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUserRoles_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By_>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp_>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRoleArgs_ = {
  distinct_on?: InputMaybe<Array<Users_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By_>>;
  where?: InputMaybe<Users_Bool_Exp_>;
};


/** Persistent Hasura roles for users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthRolesUsersByDefaultRole_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Users_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By_>>;
  where?: InputMaybe<Users_Bool_Exp_>;
};

/** aggregated selection of "auth.roles" */
export type AuthRoles_Aggregate_ = {
  __typename?: 'authRoles_aggregate';
  aggregate?: Maybe<AuthRoles_Aggregate_Fields_>;
  nodes: Array<AuthRoles_>;
};

/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_Fields_ = {
  __typename?: 'authRoles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthRoles_Max_Fields_>;
  min?: Maybe<AuthRoles_Min_Fields_>;
};


/** aggregate fields of "auth.roles" */
export type AuthRoles_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<AuthRoles_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "auth.roles". All fields are combined with a logical 'AND'. */
export type AuthRoles_Bool_Exp_ = {
  _and?: InputMaybe<Array<AuthRoles_Bool_Exp_>>;
  _not?: InputMaybe<AuthRoles_Bool_Exp_>;
  _or?: InputMaybe<Array<AuthRoles_Bool_Exp_>>;
  role?: InputMaybe<String_Comparison_Exp_>;
  userRoles?: InputMaybe<AuthUserRoles_Bool_Exp_>;
  userRoles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp_>;
  usersByDefaultRole?: InputMaybe<Users_Bool_Exp_>;
  usersByDefaultRole_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp_>;
};

/** unique or primary key constraints on table "auth.roles" */
export enum AuthRoles_Constraint_ {
  /** unique or primary key constraint on columns "role" */
  RolesPkey_ = 'roles_pkey'
}

/** input type for inserting data into table "auth.roles" */
export type AuthRoles_Insert_Input_ = {
  role?: InputMaybe<Scalars['String']['input']>;
  userRoles?: InputMaybe<AuthUserRoles_Arr_Rel_Insert_Input_>;
  usersByDefaultRole?: InputMaybe<Users_Arr_Rel_Insert_Input_>;
};

/** aggregate max on columns */
export type AuthRoles_Max_Fields_ = {
  __typename?: 'authRoles_max_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AuthRoles_Min_Fields_ = {
  __typename?: 'authRoles_min_fields';
  role?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "auth.roles" */
export type AuthRoles_Mutation_Response_ = {
  __typename?: 'authRoles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthRoles_>;
};

/** input type for inserting object relation for remote table "auth.roles" */
export type AuthRoles_Obj_Rel_Insert_Input_ = {
  data: AuthRoles_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthRoles_On_Conflict_>;
};

/** on_conflict condition type for table "auth.roles" */
export type AuthRoles_On_Conflict_ = {
  constraint: AuthRoles_Constraint_;
  update_columns?: Array<AuthRoles_Update_Column_>;
  where?: InputMaybe<AuthRoles_Bool_Exp_>;
};

/** Ordering options when selecting data from "auth.roles". */
export type AuthRoles_Order_By_ = {
  role?: InputMaybe<Order_By_>;
  userRoles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Order_By_>;
  usersByDefaultRole_aggregate?: InputMaybe<Users_Aggregate_Order_By_>;
};

/** primary key columns input for table: auth.roles */
export type AuthRoles_Pk_Columns_Input_ = {
  role: Scalars['String']['input'];
};

/** select columns of table "auth.roles" */
export enum AuthRoles_Select_Column_ {
  /** column name */
  Role_ = 'role'
}

/** input type for updating data in table "auth.roles" */
export type AuthRoles_Set_Input_ = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "authRoles" */
export type AuthRoles_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: AuthRoles_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type AuthRoles_Stream_Cursor_Value_Input_ = {
  role?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "auth.roles" */
export enum AuthRoles_Update_Column_ {
  /** column name */
  Role_ = 'role'
}

export type AuthRoles_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthRoles_Set_Input_>;
  /** filter the rows which have to be updated */
  where: AuthRoles_Bool_Exp_;
};

/** Active providers for a given user. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserProviders_ = {
  __typename?: 'authUserProviders';
  accessToken: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  provider: AuthProviders_;
  providerId: Scalars['String']['output'];
  providerUserId: Scalars['String']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users_;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.user_providers" */
export type AuthUserProviders_Aggregate_ = {
  __typename?: 'authUserProviders_aggregate';
  aggregate?: Maybe<AuthUserProviders_Aggregate_Fields_>;
  nodes: Array<AuthUserProviders_>;
};

export type AuthUserProviders_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp_Count_>;
};

export type AuthUserProviders_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<AuthUserProviders_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthUserProviders_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_Fields_ = {
  __typename?: 'authUserProviders_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthUserProviders_Max_Fields_>;
  min?: Maybe<AuthUserProviders_Min_Fields_>;
};


/** aggregate fields of "auth.user_providers" */
export type AuthUserProviders_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<AuthUserProviders_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_providers" */
export type AuthUserProviders_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<AuthUserProviders_Max_Order_By_>;
  min?: InputMaybe<AuthUserProviders_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "auth.user_providers" */
export type AuthUserProviders_Arr_Rel_Insert_Input_ = {
  data: Array<AuthUserProviders_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "auth.user_providers". All fields are combined with a logical 'AND'. */
export type AuthUserProviders_Bool_Exp_ = {
  _and?: InputMaybe<Array<AuthUserProviders_Bool_Exp_>>;
  _not?: InputMaybe<AuthUserProviders_Bool_Exp_>;
  _or?: InputMaybe<Array<AuthUserProviders_Bool_Exp_>>;
  accessToken?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  provider?: InputMaybe<AuthProviders_Bool_Exp_>;
  providerId?: InputMaybe<String_Comparison_Exp_>;
  providerUserId?: InputMaybe<String_Comparison_Exp_>;
  refreshToken?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  user?: InputMaybe<Users_Bool_Exp_>;
  userId?: InputMaybe<Uuid_Comparison_Exp_>;
};

/** unique or primary key constraints on table "auth.user_providers" */
export enum AuthUserProviders_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  UserProvidersPkey_ = 'user_providers_pkey',
  /** unique or primary key constraint on columns "provider_user_id", "provider_id" */
  UserProvidersProviderIdProviderUserIdKey_ = 'user_providers_provider_id_provider_user_id_key'
}

/** input type for inserting data into table "auth.user_providers" */
export type AuthUserProviders_Insert_Input_ = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  provider?: InputMaybe<AuthProviders_Obj_Rel_Insert_Input_>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthUserProviders_Max_Fields_ = {
  __typename?: 'authUserProviders_max_fields';
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerUserId?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.user_providers" */
export type AuthUserProviders_Max_Order_By_ = {
  accessToken?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  providerId?: InputMaybe<Order_By_>;
  providerUserId?: InputMaybe<Order_By_>;
  refreshToken?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type AuthUserProviders_Min_Fields_ = {
  __typename?: 'authUserProviders_min_fields';
  accessToken?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerUserId?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.user_providers" */
export type AuthUserProviders_Min_Order_By_ = {
  accessToken?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  providerId?: InputMaybe<Order_By_>;
  providerUserId?: InputMaybe<Order_By_>;
  refreshToken?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "auth.user_providers" */
export type AuthUserProviders_Mutation_Response_ = {
  __typename?: 'authUserProviders_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserProviders_>;
};

/** on_conflict condition type for table "auth.user_providers" */
export type AuthUserProviders_On_Conflict_ = {
  constraint: AuthUserProviders_Constraint_;
  update_columns?: Array<AuthUserProviders_Update_Column_>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp_>;
};

/** Ordering options when selecting data from "auth.user_providers". */
export type AuthUserProviders_Order_By_ = {
  accessToken?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  provider?: InputMaybe<AuthProviders_Order_By_>;
  providerId?: InputMaybe<Order_By_>;
  providerUserId?: InputMaybe<Order_By_>;
  refreshToken?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  user?: InputMaybe<Users_Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: auth.user_providers */
export type AuthUserProviders_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.user_providers" */
export enum AuthUserProviders_Select_Column_ {
  /** column name */
  AccessToken_ = 'accessToken',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  ProviderId_ = 'providerId',
  /** column name */
  ProviderUserId_ = 'providerUserId',
  /** column name */
  RefreshToken_ = 'refreshToken',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UserId_ = 'userId'
}

/** input type for updating data in table "auth.user_providers" */
export type AuthUserProviders_Set_Input_ = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "authUserProviders" */
export type AuthUserProviders_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: AuthUserProviders_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserProviders_Stream_Cursor_Value_Input_ = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUserId?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.user_providers" */
export enum AuthUserProviders_Update_Column_ {
  /** column name */
  AccessToken_ = 'accessToken',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  ProviderId_ = 'providerId',
  /** column name */
  ProviderUserId_ = 'providerUserId',
  /** column name */
  RefreshToken_ = 'refreshToken',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UserId_ = 'userId'
}

export type AuthUserProviders_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserProviders_Set_Input_>;
  /** filter the rows which have to be updated */
  where: AuthUserProviders_Bool_Exp_;
};

/** Roles of users. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserRoles_ = {
  __typename?: 'authUserRoles';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  role: Scalars['String']['output'];
  /** An object relationship */
  roleByRole: AuthRoles_;
  /** An object relationship */
  user: Users_;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.user_roles" */
export type AuthUserRoles_Aggregate_ = {
  __typename?: 'authUserRoles_aggregate';
  aggregate?: Maybe<AuthUserRoles_Aggregate_Fields_>;
  nodes: Array<AuthUserRoles_>;
};

export type AuthUserRoles_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp_Count_>;
};

export type AuthUserRoles_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<AuthUserRoles_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthUserRoles_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_Fields_ = {
  __typename?: 'authUserRoles_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<AuthUserRoles_Max_Fields_>;
  min?: Maybe<AuthUserRoles_Min_Fields_>;
};


/** aggregate fields of "auth.user_roles" */
export type AuthUserRoles_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<AuthUserRoles_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_roles" */
export type AuthUserRoles_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<AuthUserRoles_Max_Order_By_>;
  min?: InputMaybe<AuthUserRoles_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "auth.user_roles" */
export type AuthUserRoles_Arr_Rel_Insert_Input_ = {
  data: Array<AuthUserRoles_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "auth.user_roles". All fields are combined with a logical 'AND'. */
export type AuthUserRoles_Bool_Exp_ = {
  _and?: InputMaybe<Array<AuthUserRoles_Bool_Exp_>>;
  _not?: InputMaybe<AuthUserRoles_Bool_Exp_>;
  _or?: InputMaybe<Array<AuthUserRoles_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  role?: InputMaybe<String_Comparison_Exp_>;
  roleByRole?: InputMaybe<AuthRoles_Bool_Exp_>;
  user?: InputMaybe<Users_Bool_Exp_>;
  userId?: InputMaybe<Uuid_Comparison_Exp_>;
};

/** unique or primary key constraints on table "auth.user_roles" */
export enum AuthUserRoles_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  UserRolesPkey_ = 'user_roles_pkey',
  /** unique or primary key constraint on columns "user_id", "role" */
  UserRolesUserIdRoleKey_ = 'user_roles_user_id_role_key'
}

/** input type for inserting data into table "auth.user_roles" */
export type AuthUserRoles_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roleByRole?: InputMaybe<AuthRoles_Obj_Rel_Insert_Input_>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthUserRoles_Max_Fields_ = {
  __typename?: 'authUserRoles_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.user_roles" */
export type AuthUserRoles_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  role?: InputMaybe<Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type AuthUserRoles_Min_Fields_ = {
  __typename?: 'authUserRoles_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.user_roles" */
export type AuthUserRoles_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  role?: InputMaybe<Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "auth.user_roles" */
export type AuthUserRoles_Mutation_Response_ = {
  __typename?: 'authUserRoles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserRoles_>;
};

/** on_conflict condition type for table "auth.user_roles" */
export type AuthUserRoles_On_Conflict_ = {
  constraint: AuthUserRoles_Constraint_;
  update_columns?: Array<AuthUserRoles_Update_Column_>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp_>;
};

/** Ordering options when selecting data from "auth.user_roles". */
export type AuthUserRoles_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  role?: InputMaybe<Order_By_>;
  roleByRole?: InputMaybe<AuthRoles_Order_By_>;
  user?: InputMaybe<Users_Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: auth.user_roles */
export type AuthUserRoles_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.user_roles" */
export enum AuthUserRoles_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Role_ = 'role',
  /** column name */
  UserId_ = 'userId'
}

/** input type for updating data in table "auth.user_roles" */
export type AuthUserRoles_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "authUserRoles" */
export type AuthUserRoles_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: AuthUserRoles_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserRoles_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "auth.user_roles" */
export enum AuthUserRoles_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  Role_ = 'role',
  /** column name */
  UserId_ = 'userId'
}

export type AuthUserRoles_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserRoles_Set_Input_>;
  /** filter the rows which have to be updated */
  where: AuthUserRoles_Bool_Exp_;
};

/** User webauthn security keys. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type AuthUserSecurityKeys_ = {
  __typename?: 'authUserSecurityKeys';
  counter: Scalars['bigint']['output'];
  credentialId: Scalars['String']['output'];
  credentialPublicKey?: Maybe<Scalars['bytea']['output']>;
  id: Scalars['uuid']['output'];
  nickname?: Maybe<Scalars['String']['output']>;
  transports: Scalars['String']['output'];
  /** An object relationship */
  user: Users_;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_ = {
  __typename?: 'authUserSecurityKeys_aggregate';
  aggregate?: Maybe<AuthUserSecurityKeys_Aggregate_Fields_>;
  nodes: Array<AuthUserSecurityKeys_>;
};

export type AuthUserSecurityKeys_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<AuthUserSecurityKeys_Aggregate_Bool_Exp_Count_>;
};

export type AuthUserSecurityKeys_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<AuthUserSecurityKeys_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Fields_ = {
  __typename?: 'authUserSecurityKeys_aggregate_fields';
  avg?: Maybe<AuthUserSecurityKeys_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<AuthUserSecurityKeys_Max_Fields_>;
  min?: Maybe<AuthUserSecurityKeys_Min_Fields_>;
  stddev?: Maybe<AuthUserSecurityKeys_Stddev_Fields_>;
  stddev_pop?: Maybe<AuthUserSecurityKeys_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<AuthUserSecurityKeys_Stddev_Samp_Fields_>;
  sum?: Maybe<AuthUserSecurityKeys_Sum_Fields_>;
  var_pop?: Maybe<AuthUserSecurityKeys_Var_Pop_Fields_>;
  var_samp?: Maybe<AuthUserSecurityKeys_Var_Samp_Fields_>;
  variance?: Maybe<AuthUserSecurityKeys_Variance_Fields_>;
};


/** aggregate fields of "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Aggregate_Order_By_ = {
  avg?: InputMaybe<AuthUserSecurityKeys_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<AuthUserSecurityKeys_Max_Order_By_>;
  min?: InputMaybe<AuthUserSecurityKeys_Min_Order_By_>;
  stddev?: InputMaybe<AuthUserSecurityKeys_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<AuthUserSecurityKeys_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<AuthUserSecurityKeys_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<AuthUserSecurityKeys_Sum_Order_By_>;
  var_pop?: InputMaybe<AuthUserSecurityKeys_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<AuthUserSecurityKeys_Var_Samp_Order_By_>;
  variance?: InputMaybe<AuthUserSecurityKeys_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Arr_Rel_Insert_Input_ = {
  data: Array<AuthUserSecurityKeys_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict_>;
};

/** aggregate avg on columns */
export type AuthUserSecurityKeys_Avg_Fields_ = {
  __typename?: 'authUserSecurityKeys_avg_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Avg_Order_By_ = {
  counter?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "auth.user_security_keys". All fields are combined with a logical 'AND'. */
export type AuthUserSecurityKeys_Bool_Exp_ = {
  _and?: InputMaybe<Array<AuthUserSecurityKeys_Bool_Exp_>>;
  _not?: InputMaybe<AuthUserSecurityKeys_Bool_Exp_>;
  _or?: InputMaybe<Array<AuthUserSecurityKeys_Bool_Exp_>>;
  counter?: InputMaybe<Bigint_Comparison_Exp_>;
  credentialId?: InputMaybe<String_Comparison_Exp_>;
  credentialPublicKey?: InputMaybe<Bytea_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  nickname?: InputMaybe<String_Comparison_Exp_>;
  transports?: InputMaybe<String_Comparison_Exp_>;
  user?: InputMaybe<Users_Bool_Exp_>;
  userId?: InputMaybe<Uuid_Comparison_Exp_>;
};

/** unique or primary key constraints on table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Constraint_ {
  /** unique or primary key constraint on columns "credential_id" */
  UserSecurityKeyCredentialIdKey_ = 'user_security_key_credential_id_key',
  /** unique or primary key constraint on columns "id" */
  UserSecurityKeysPkey_ = 'user_security_keys_pkey'
}

/** input type for incrementing numeric columns in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Inc_Input_ = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
};

/** input type for inserting data into table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Insert_Input_ = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type AuthUserSecurityKeys_Max_Fields_ = {
  __typename?: 'authUserSecurityKeys_max_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
  credentialId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  transports?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Max_Order_By_ = {
  counter?: InputMaybe<Order_By_>;
  credentialId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  nickname?: InputMaybe<Order_By_>;
  transports?: InputMaybe<Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type AuthUserSecurityKeys_Min_Fields_ = {
  __typename?: 'authUserSecurityKeys_min_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
  credentialId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  transports?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Min_Order_By_ = {
  counter?: InputMaybe<Order_By_>;
  credentialId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  nickname?: InputMaybe<Order_By_>;
  transports?: InputMaybe<Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Mutation_Response_ = {
  __typename?: 'authUserSecurityKeys_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthUserSecurityKeys_>;
};

/** on_conflict condition type for table "auth.user_security_keys" */
export type AuthUserSecurityKeys_On_Conflict_ = {
  constraint: AuthUserSecurityKeys_Constraint_;
  update_columns?: Array<AuthUserSecurityKeys_Update_Column_>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp_>;
};

/** Ordering options when selecting data from "auth.user_security_keys". */
export type AuthUserSecurityKeys_Order_By_ = {
  counter?: InputMaybe<Order_By_>;
  credentialId?: InputMaybe<Order_By_>;
  credentialPublicKey?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  nickname?: InputMaybe<Order_By_>;
  transports?: InputMaybe<Order_By_>;
  user?: InputMaybe<Users_Order_By_>;
  userId?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: auth.user_security_keys */
export type AuthUserSecurityKeys_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Select_Column_ {
  /** column name */
  Counter_ = 'counter',
  /** column name */
  CredentialId_ = 'credentialId',
  /** column name */
  CredentialPublicKey_ = 'credentialPublicKey',
  /** column name */
  Id_ = 'id',
  /** column name */
  Nickname_ = 'nickname',
  /** column name */
  Transports_ = 'transports',
  /** column name */
  UserId_ = 'userId'
}

/** input type for updating data in table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Set_Input_ = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type AuthUserSecurityKeys_Stddev_Fields_ = {
  __typename?: 'authUserSecurityKeys_stddev_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Order_By_ = {
  counter?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type AuthUserSecurityKeys_Stddev_Pop_Fields_ = {
  __typename?: 'authUserSecurityKeys_stddev_pop_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Pop_Order_By_ = {
  counter?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type AuthUserSecurityKeys_Stddev_Samp_Fields_ = {
  __typename?: 'authUserSecurityKeys_stddev_samp_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Stddev_Samp_Order_By_ = {
  counter?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "authUserSecurityKeys" */
export type AuthUserSecurityKeys_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: AuthUserSecurityKeys_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type AuthUserSecurityKeys_Stream_Cursor_Value_Input_ = {
  counter?: InputMaybe<Scalars['bigint']['input']>;
  credentialId?: InputMaybe<Scalars['String']['input']>;
  credentialPublicKey?: InputMaybe<Scalars['bytea']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  transports?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type AuthUserSecurityKeys_Sum_Fields_ = {
  __typename?: 'authUserSecurityKeys_sum_fields';
  counter?: Maybe<Scalars['bigint']['output']>;
};

/** order by sum() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Sum_Order_By_ = {
  counter?: InputMaybe<Order_By_>;
};

/** update columns of table "auth.user_security_keys" */
export enum AuthUserSecurityKeys_Update_Column_ {
  /** column name */
  Counter_ = 'counter',
  /** column name */
  CredentialId_ = 'credentialId',
  /** column name */
  CredentialPublicKey_ = 'credentialPublicKey',
  /** column name */
  Id_ = 'id',
  /** column name */
  Nickname_ = 'nickname',
  /** column name */
  Transports_ = 'transports',
  /** column name */
  UserId_ = 'userId'
}

export type AuthUserSecurityKeys_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input_>;
  /** filter the rows which have to be updated */
  where: AuthUserSecurityKeys_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type AuthUserSecurityKeys_Var_Pop_Fields_ = {
  __typename?: 'authUserSecurityKeys_var_pop_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Pop_Order_By_ = {
  counter?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type AuthUserSecurityKeys_Var_Samp_Fields_ = {
  __typename?: 'authUserSecurityKeys_var_samp_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Var_Samp_Order_By_ = {
  counter?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type AuthUserSecurityKeys_Variance_Fields_ = {
  __typename?: 'authUserSecurityKeys_variance_fields';
  counter?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "auth.user_security_keys" */
export type AuthUserSecurityKeys_Variance_Order_By_ = {
  counter?: InputMaybe<Order_By_>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp_ = {
  _eq?: InputMaybe<Scalars['bigint']['input']>;
  _gt?: InputMaybe<Scalars['bigint']['input']>;
  _gte?: InputMaybe<Scalars['bigint']['input']>;
  _in?: InputMaybe<Array<Scalars['bigint']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bigint']['input']>;
  _lte?: InputMaybe<Scalars['bigint']['input']>;
  _neq?: InputMaybe<Scalars['bigint']['input']>;
  _nin?: InputMaybe<Array<Scalars['bigint']['input']>>;
};

/** columns and relationships of "storage.buckets" */
export type Buckets_ = {
  __typename?: 'buckets';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  downloadExpiration: Scalars['Int']['output'];
  /** An array relationship */
  files: Array<Files_>;
  /** An aggregate relationship */
  files_aggregate: Files_Aggregate_;
  id: Scalars['String']['output'];
  maxUploadFileSize: Scalars['Int']['output'];
  minUploadFileSize: Scalars['Int']['output'];
  presignedUrlsEnabled: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "storage.buckets" */
export type BucketsFilesArgs_ = {
  distinct_on?: InputMaybe<Array<Files_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By_>>;
  where?: InputMaybe<Files_Bool_Exp_>;
};


/** columns and relationships of "storage.buckets" */
export type BucketsFiles_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Files_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By_>>;
  where?: InputMaybe<Files_Bool_Exp_>;
};

/** aggregated selection of "storage.buckets" */
export type Buckets_Aggregate_ = {
  __typename?: 'buckets_aggregate';
  aggregate?: Maybe<Buckets_Aggregate_Fields_>;
  nodes: Array<Buckets_>;
};

/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_Fields_ = {
  __typename?: 'buckets_aggregate_fields';
  avg?: Maybe<Buckets_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<Buckets_Max_Fields_>;
  min?: Maybe<Buckets_Min_Fields_>;
  stddev?: Maybe<Buckets_Stddev_Fields_>;
  stddev_pop?: Maybe<Buckets_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<Buckets_Stddev_Samp_Fields_>;
  sum?: Maybe<Buckets_Sum_Fields_>;
  var_pop?: Maybe<Buckets_Var_Pop_Fields_>;
  var_samp?: Maybe<Buckets_Var_Samp_Fields_>;
  variance?: Maybe<Buckets_Variance_Fields_>;
};


/** aggregate fields of "storage.buckets" */
export type Buckets_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Buckets_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Buckets_Avg_Fields_ = {
  __typename?: 'buckets_avg_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "storage.buckets". All fields are combined with a logical 'AND'. */
export type Buckets_Bool_Exp_ = {
  _and?: InputMaybe<Array<Buckets_Bool_Exp_>>;
  _not?: InputMaybe<Buckets_Bool_Exp_>;
  _or?: InputMaybe<Array<Buckets_Bool_Exp_>>;
  cacheControl?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  downloadExpiration?: InputMaybe<Int_Comparison_Exp_>;
  files?: InputMaybe<Files_Bool_Exp_>;
  files_aggregate?: InputMaybe<Files_Aggregate_Bool_Exp_>;
  id?: InputMaybe<String_Comparison_Exp_>;
  maxUploadFileSize?: InputMaybe<Int_Comparison_Exp_>;
  minUploadFileSize?: InputMaybe<Int_Comparison_Exp_>;
  presignedUrlsEnabled?: InputMaybe<Boolean_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "storage.buckets" */
export enum Buckets_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  BucketsPkey_ = 'buckets_pkey'
}

/** input type for incrementing numeric columns in table "storage.buckets" */
export type Buckets_Inc_Input_ = {
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storage.buckets" */
export type Buckets_Insert_Input_ = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  files?: InputMaybe<Files_Arr_Rel_Insert_Input_>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Buckets_Max_Fields_ = {
  __typename?: 'buckets_max_fields';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Buckets_Min_Fields_ = {
  __typename?: 'buckets_min_fields';
  cacheControl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "storage.buckets" */
export type Buckets_Mutation_Response_ = {
  __typename?: 'buckets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Buckets_>;
};

/** input type for inserting object relation for remote table "storage.buckets" */
export type Buckets_Obj_Rel_Insert_Input_ = {
  data: Buckets_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Buckets_On_Conflict_>;
};

/** on_conflict condition type for table "storage.buckets" */
export type Buckets_On_Conflict_ = {
  constraint: Buckets_Constraint_;
  update_columns?: Array<Buckets_Update_Column_>;
  where?: InputMaybe<Buckets_Bool_Exp_>;
};

/** Ordering options when selecting data from "storage.buckets". */
export type Buckets_Order_By_ = {
  cacheControl?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  downloadExpiration?: InputMaybe<Order_By_>;
  files_aggregate?: InputMaybe<Files_Aggregate_Order_By_>;
  id?: InputMaybe<Order_By_>;
  maxUploadFileSize?: InputMaybe<Order_By_>;
  minUploadFileSize?: InputMaybe<Order_By_>;
  presignedUrlsEnabled?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: storage.buckets */
export type Buckets_Pk_Columns_Input_ = {
  id: Scalars['String']['input'];
};

/** select columns of table "storage.buckets" */
export enum Buckets_Select_Column_ {
  /** column name */
  CacheControl_ = 'cacheControl',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DownloadExpiration_ = 'downloadExpiration',
  /** column name */
  Id_ = 'id',
  /** column name */
  MaxUploadFileSize_ = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize_ = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled_ = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "storage.buckets" */
export type Buckets_Set_Input_ = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Buckets_Stddev_Fields_ = {
  __typename?: 'buckets_stddev_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Buckets_Stddev_Pop_Fields_ = {
  __typename?: 'buckets_stddev_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Buckets_Stddev_Samp_Fields_ = {
  __typename?: 'buckets_stddev_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "buckets" */
export type Buckets_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Buckets_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Buckets_Stream_Cursor_Value_Input_ = {
  cacheControl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  downloadExpiration?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  minUploadFileSize?: InputMaybe<Scalars['Int']['input']>;
  presignedUrlsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Buckets_Sum_Fields_ = {
  __typename?: 'buckets_sum_fields';
  downloadExpiration?: Maybe<Scalars['Int']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Int']['output']>;
  minUploadFileSize?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "storage.buckets" */
export enum Buckets_Update_Column_ {
  /** column name */
  CacheControl_ = 'cacheControl',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DownloadExpiration_ = 'downloadExpiration',
  /** column name */
  Id_ = 'id',
  /** column name */
  MaxUploadFileSize_ = 'maxUploadFileSize',
  /** column name */
  MinUploadFileSize_ = 'minUploadFileSize',
  /** column name */
  PresignedUrlsEnabled_ = 'presignedUrlsEnabled',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Buckets_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Buckets_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Buckets_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Buckets_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type Buckets_Var_Pop_Fields_ = {
  __typename?: 'buckets_var_pop_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Buckets_Var_Samp_Fields_ = {
  __typename?: 'buckets_var_samp_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Buckets_Variance_Fields_ = {
  __typename?: 'buckets_variance_fields';
  downloadExpiration?: Maybe<Scalars['Float']['output']>;
  maxUploadFileSize?: Maybe<Scalars['Float']['output']>;
  minUploadFileSize?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to compare columns of type "bytea". All fields are combined with logical 'AND'. */
export type Bytea_Comparison_Exp_ = {
  _eq?: InputMaybe<Scalars['bytea']['input']>;
  _gt?: InputMaybe<Scalars['bytea']['input']>;
  _gte?: InputMaybe<Scalars['bytea']['input']>;
  _in?: InputMaybe<Array<Scalars['bytea']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['bytea']['input']>;
  _lte?: InputMaybe<Scalars['bytea']['input']>;
  _neq?: InputMaybe<Scalars['bytea']['input']>;
  _nin?: InputMaybe<Array<Scalars['bytea']['input']>>;
};

/** Boolean expression to compare columns of type "citext". All fields are combined with logical 'AND'. */
export type Citext_Comparison_Exp_ = {
  _eq?: InputMaybe<Scalars['citext']['input']>;
  _gt?: InputMaybe<Scalars['citext']['input']>;
  _gte?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['citext']['input']>;
  _in?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['citext']['input']>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['citext']['input']>;
  _lt?: InputMaybe<Scalars['citext']['input']>;
  _lte?: InputMaybe<Scalars['citext']['input']>;
  _neq?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['citext']['input']>;
  _nin?: InputMaybe<Array<Scalars['citext']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['citext']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['citext']['input']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering_ {
  /** ascending ordering of the cursor */
  Asc_ = 'ASC',
  /** descending ordering of the cursor */
  Desc_ = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp_ = {
  _eq?: InputMaybe<Scalars['date']['input']>;
  _gt?: InputMaybe<Scalars['date']['input']>;
  _gte?: InputMaybe<Scalars['date']['input']>;
  _in?: InputMaybe<Array<Scalars['date']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['date']['input']>;
  _lte?: InputMaybe<Scalars['date']['input']>;
  _neq?: InputMaybe<Scalars['date']['input']>;
  _nin?: InputMaybe<Array<Scalars['date']['input']>>;
};

/** columns and relationships of "esrs.ActionReportingUnit" */
export type Esrs_ActionReportingUnit_ = {
  __typename?: 'esrs_ActionReportingUnit';
  /** An object relationship */
  action: Esrs_Actions_;
  actionId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  reportingUnit: Esrs_ReportingUnit_;
  reportingUnitId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "esrs.ActionReportingUnit" */
export type Esrs_ActionReportingUnit_Aggregate_ = {
  __typename?: 'esrs_ActionReportingUnit_aggregate';
  aggregate?: Maybe<Esrs_ActionReportingUnit_Aggregate_Fields_>;
  nodes: Array<Esrs_ActionReportingUnit_>;
};

export type Esrs_ActionReportingUnit_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Esrs_ActionReportingUnit_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_ActionReportingUnit_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_ActionReportingUnit_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_ActionReportingUnit_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.ActionReportingUnit" */
export type Esrs_ActionReportingUnit_Aggregate_Fields_ = {
  __typename?: 'esrs_ActionReportingUnit_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_ActionReportingUnit_Max_Fields_>;
  min?: Maybe<Esrs_ActionReportingUnit_Min_Fields_>;
};


/** aggregate fields of "esrs.ActionReportingUnit" */
export type Esrs_ActionReportingUnit_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_ActionReportingUnit_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.ActionReportingUnit" */
export type Esrs_ActionReportingUnit_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_ActionReportingUnit_Max_Order_By_>;
  min?: InputMaybe<Esrs_ActionReportingUnit_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.ActionReportingUnit" */
export type Esrs_ActionReportingUnit_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_ActionReportingUnit_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_ActionReportingUnit_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.ActionReportingUnit". All fields are combined with a logical 'AND'. */
export type Esrs_ActionReportingUnit_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_ActionReportingUnit_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_ActionReportingUnit_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_ActionReportingUnit_Bool_Exp_>>;
  action?: InputMaybe<Esrs_Actions_Bool_Exp_>;
  actionId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
  reportingUnitId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.ActionReportingUnit" */
export enum Esrs_ActionReportingUnit_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  ActionReportingUnitPkey_ = 'ActionReportingUnit_pkey'
}

/** input type for inserting data into table "esrs.ActionReportingUnit" */
export type Esrs_ActionReportingUnit_Insert_Input_ = {
  action?: InputMaybe<Esrs_Actions_Obj_Rel_Insert_Input_>;
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Obj_Rel_Insert_Input_>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_ActionReportingUnit_Max_Fields_ = {
  __typename?: 'esrs_ActionReportingUnit_max_fields';
  actionId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.ActionReportingUnit" */
export type Esrs_ActionReportingUnit_Max_Order_By_ = {
  actionId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_ActionReportingUnit_Min_Fields_ = {
  __typename?: 'esrs_ActionReportingUnit_min_fields';
  actionId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.ActionReportingUnit" */
export type Esrs_ActionReportingUnit_Min_Order_By_ = {
  actionId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.ActionReportingUnit" */
export type Esrs_ActionReportingUnit_Mutation_Response_ = {
  __typename?: 'esrs_ActionReportingUnit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_ActionReportingUnit_>;
};

/** on_conflict condition type for table "esrs.ActionReportingUnit" */
export type Esrs_ActionReportingUnit_On_Conflict_ = {
  constraint: Esrs_ActionReportingUnit_Constraint_;
  update_columns?: Array<Esrs_ActionReportingUnit_Update_Column_>;
  where?: InputMaybe<Esrs_ActionReportingUnit_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.ActionReportingUnit". */
export type Esrs_ActionReportingUnit_Order_By_ = {
  action?: InputMaybe<Esrs_Actions_Order_By_>;
  actionId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.ActionReportingUnit */
export type Esrs_ActionReportingUnit_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.ActionReportingUnit" */
export enum Esrs_ActionReportingUnit_Select_Column_ {
  /** column name */
  ActionId_ = 'actionId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  ReportingUnitId_ = 'reportingUnitId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "esrs.ActionReportingUnit" */
export type Esrs_ActionReportingUnit_Set_Input_ = {
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_ActionReportingUnit" */
export type Esrs_ActionReportingUnit_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_ActionReportingUnit_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_ActionReportingUnit_Stream_Cursor_Value_Input_ = {
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.ActionReportingUnit" */
export enum Esrs_ActionReportingUnit_Update_Column_ {
  /** column name */
  ActionId_ = 'actionId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  ReportingUnitId_ = 'reportingUnitId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_ActionReportingUnit_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_ActionReportingUnit_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_ActionReportingUnit_Bool_Exp_;
};

/** columns and relationships of "esrs.ActionSubsidiary" */
export type Esrs_ActionSubsidiary_ = {
  __typename?: 'esrs_ActionSubsidiary';
  /** An object relationship */
  action: Esrs_Actions_;
  actionId: Scalars['uuid']['output'];
  created_at: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  subsidiaryAssessment: EsrsAssessment_;
  subsidiaryAssessmentId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamp']['output'];
};

/** aggregated selection of "esrs.ActionSubsidiary" */
export type Esrs_ActionSubsidiary_Aggregate_ = {
  __typename?: 'esrs_ActionSubsidiary_aggregate';
  aggregate?: Maybe<Esrs_ActionSubsidiary_Aggregate_Fields_>;
  nodes: Array<Esrs_ActionSubsidiary_>;
};

export type Esrs_ActionSubsidiary_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Esrs_ActionSubsidiary_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_ActionSubsidiary_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_ActionSubsidiary_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_ActionSubsidiary_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.ActionSubsidiary" */
export type Esrs_ActionSubsidiary_Aggregate_Fields_ = {
  __typename?: 'esrs_ActionSubsidiary_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_ActionSubsidiary_Max_Fields_>;
  min?: Maybe<Esrs_ActionSubsidiary_Min_Fields_>;
};


/** aggregate fields of "esrs.ActionSubsidiary" */
export type Esrs_ActionSubsidiary_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_ActionSubsidiary_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.ActionSubsidiary" */
export type Esrs_ActionSubsidiary_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_ActionSubsidiary_Max_Order_By_>;
  min?: InputMaybe<Esrs_ActionSubsidiary_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.ActionSubsidiary" */
export type Esrs_ActionSubsidiary_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_ActionSubsidiary_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_ActionSubsidiary_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.ActionSubsidiary". All fields are combined with a logical 'AND'. */
export type Esrs_ActionSubsidiary_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_ActionSubsidiary_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_ActionSubsidiary_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_ActionSubsidiary_Bool_Exp_>>;
  action?: InputMaybe<Esrs_Actions_Bool_Exp_>;
  actionId?: InputMaybe<Uuid_Comparison_Exp_>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  subsidiaryAssessment?: InputMaybe<EsrsAssessment_Bool_Exp_>;
  subsidiaryAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.ActionSubsidiary" */
export enum Esrs_ActionSubsidiary_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  ActionSubsidiaryPkey_ = 'ActionSubsidiary_pkey'
}

/** input type for inserting data into table "esrs.ActionSubsidiary" */
export type Esrs_ActionSubsidiary_Insert_Input_ = {
  action?: InputMaybe<Esrs_Actions_Obj_Rel_Insert_Input_>;
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiaryAssessment?: InputMaybe<EsrsAssessment_Obj_Rel_Insert_Input_>;
  subsidiaryAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Esrs_ActionSubsidiary_Max_Fields_ = {
  __typename?: 'esrs_ActionSubsidiary_max_fields';
  actionId?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  subsidiaryAssessmentId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "esrs.ActionSubsidiary" */
export type Esrs_ActionSubsidiary_Max_Order_By_ = {
  actionId?: InputMaybe<Order_By_>;
  created_at?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  subsidiaryAssessmentId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_ActionSubsidiary_Min_Fields_ = {
  __typename?: 'esrs_ActionSubsidiary_min_fields';
  actionId?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  subsidiaryAssessmentId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "esrs.ActionSubsidiary" */
export type Esrs_ActionSubsidiary_Min_Order_By_ = {
  actionId?: InputMaybe<Order_By_>;
  created_at?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  subsidiaryAssessmentId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.ActionSubsidiary" */
export type Esrs_ActionSubsidiary_Mutation_Response_ = {
  __typename?: 'esrs_ActionSubsidiary_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_ActionSubsidiary_>;
};

/** on_conflict condition type for table "esrs.ActionSubsidiary" */
export type Esrs_ActionSubsidiary_On_Conflict_ = {
  constraint: Esrs_ActionSubsidiary_Constraint_;
  update_columns?: Array<Esrs_ActionSubsidiary_Update_Column_>;
  where?: InputMaybe<Esrs_ActionSubsidiary_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.ActionSubsidiary". */
export type Esrs_ActionSubsidiary_Order_By_ = {
  action?: InputMaybe<Esrs_Actions_Order_By_>;
  actionId?: InputMaybe<Order_By_>;
  created_at?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  subsidiaryAssessment?: InputMaybe<EsrsAssessment_Order_By_>;
  subsidiaryAssessmentId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.ActionSubsidiary */
export type Esrs_ActionSubsidiary_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.ActionSubsidiary" */
export enum Esrs_ActionSubsidiary_Select_Column_ {
  /** column name */
  ActionId_ = 'actionId',
  /** column name */
  CreatedAt_ = 'created_at',
  /** column name */
  Id_ = 'id',
  /** column name */
  SubsidiaryAssessmentId_ = 'subsidiaryAssessmentId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "esrs.ActionSubsidiary" */
export type Esrs_ActionSubsidiary_Set_Input_ = {
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiaryAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "esrs_ActionSubsidiary" */
export type Esrs_ActionSubsidiary_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_ActionSubsidiary_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_ActionSubsidiary_Stream_Cursor_Value_Input_ = {
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  subsidiaryAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "esrs.ActionSubsidiary" */
export enum Esrs_ActionSubsidiary_Update_Column_ {
  /** column name */
  ActionId_ = 'actionId',
  /** column name */
  CreatedAt_ = 'created_at',
  /** column name */
  Id_ = 'id',
  /** column name */
  SubsidiaryAssessmentId_ = 'subsidiaryAssessmentId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_ActionSubsidiary_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_ActionSubsidiary_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_ActionSubsidiary_Bool_Exp_;
};

/** (user input data): Actions and Targets have a many to many relationship, so each target can be connected to many actions and vis versa */
export type Esrs_ActionTarget_ = {
  __typename?: 'esrs_ActionTarget';
  /** An object relationship */
  action: Esrs_Actions_;
  actionId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  estimate?: Maybe<Scalars['numeric']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  target: Esrs_Target_;
  targetId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "esrs.ActionTarget" */
export type Esrs_ActionTarget_Aggregate_ = {
  __typename?: 'esrs_ActionTarget_aggregate';
  aggregate?: Maybe<Esrs_ActionTarget_Aggregate_Fields_>;
  nodes: Array<Esrs_ActionTarget_>;
};

export type Esrs_ActionTarget_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Esrs_ActionTarget_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_ActionTarget_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_ActionTarget_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_ActionTarget_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.ActionTarget" */
export type Esrs_ActionTarget_Aggregate_Fields_ = {
  __typename?: 'esrs_ActionTarget_aggregate_fields';
  avg?: Maybe<Esrs_ActionTarget_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_ActionTarget_Max_Fields_>;
  min?: Maybe<Esrs_ActionTarget_Min_Fields_>;
  stddev?: Maybe<Esrs_ActionTarget_Stddev_Fields_>;
  stddev_pop?: Maybe<Esrs_ActionTarget_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<Esrs_ActionTarget_Stddev_Samp_Fields_>;
  sum?: Maybe<Esrs_ActionTarget_Sum_Fields_>;
  var_pop?: Maybe<Esrs_ActionTarget_Var_Pop_Fields_>;
  var_samp?: Maybe<Esrs_ActionTarget_Var_Samp_Fields_>;
  variance?: Maybe<Esrs_ActionTarget_Variance_Fields_>;
};


/** aggregate fields of "esrs.ActionTarget" */
export type Esrs_ActionTarget_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_ActionTarget_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Aggregate_Order_By_ = {
  avg?: InputMaybe<Esrs_ActionTarget_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_ActionTarget_Max_Order_By_>;
  min?: InputMaybe<Esrs_ActionTarget_Min_Order_By_>;
  stddev?: InputMaybe<Esrs_ActionTarget_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<Esrs_ActionTarget_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<Esrs_ActionTarget_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<Esrs_ActionTarget_Sum_Order_By_>;
  var_pop?: InputMaybe<Esrs_ActionTarget_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<Esrs_ActionTarget_Var_Samp_Order_By_>;
  variance?: InputMaybe<Esrs_ActionTarget_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_ActionTarget_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_ActionTarget_On_Conflict_>;
};

/** aggregate avg on columns */
export type Esrs_ActionTarget_Avg_Fields_ = {
  __typename?: 'esrs_ActionTarget_avg_fields';
  estimate?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Avg_Order_By_ = {
  estimate?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.ActionTarget". All fields are combined with a logical 'AND'. */
export type Esrs_ActionTarget_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_ActionTarget_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_ActionTarget_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_ActionTarget_Bool_Exp_>>;
  action?: InputMaybe<Esrs_Actions_Bool_Exp_>;
  actionId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  estimate?: InputMaybe<Numeric_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  target?: InputMaybe<Esrs_Target_Bool_Exp_>;
  targetId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.ActionTarget" */
export enum Esrs_ActionTarget_Constraint_ {
  /** unique or primary key constraint on columns "targetId", "actionId" */
  ActionTargetActionIdTargetIdKey_ = 'ActionTarget_actionId_targetId_key',
  /** unique or primary key constraint on columns "id" */
  ActionTargetPkey_ = 'ActionTarget_pkey'
}

/** input type for incrementing numeric columns in table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Inc_Input_ = {
  estimate?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Insert_Input_ = {
  action?: InputMaybe<Esrs_Actions_Obj_Rel_Insert_Input_>;
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  estimate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  target?: InputMaybe<Esrs_Target_Obj_Rel_Insert_Input_>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_ActionTarget_Max_Fields_ = {
  __typename?: 'esrs_ActionTarget_max_fields';
  actionId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  estimate?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  targetId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Max_Order_By_ = {
  actionId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  estimate?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  targetId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_ActionTarget_Min_Fields_ = {
  __typename?: 'esrs_ActionTarget_min_fields';
  actionId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  estimate?: Maybe<Scalars['numeric']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  targetId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Min_Order_By_ = {
  actionId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  estimate?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  targetId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Mutation_Response_ = {
  __typename?: 'esrs_ActionTarget_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_ActionTarget_>;
};

/** on_conflict condition type for table "esrs.ActionTarget" */
export type Esrs_ActionTarget_On_Conflict_ = {
  constraint: Esrs_ActionTarget_Constraint_;
  update_columns?: Array<Esrs_ActionTarget_Update_Column_>;
  where?: InputMaybe<Esrs_ActionTarget_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.ActionTarget". */
export type Esrs_ActionTarget_Order_By_ = {
  action?: InputMaybe<Esrs_Actions_Order_By_>;
  actionId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  estimate?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  target?: InputMaybe<Esrs_Target_Order_By_>;
  targetId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.ActionTarget */
export type Esrs_ActionTarget_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.ActionTarget" */
export enum Esrs_ActionTarget_Select_Column_ {
  /** column name */
  ActionId_ = 'actionId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Estimate_ = 'estimate',
  /** column name */
  Id_ = 'id',
  /** column name */
  TargetId_ = 'targetId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Set_Input_ = {
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  estimate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Esrs_ActionTarget_Stddev_Fields_ = {
  __typename?: 'esrs_ActionTarget_stddev_fields';
  estimate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Stddev_Order_By_ = {
  estimate?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type Esrs_ActionTarget_Stddev_Pop_Fields_ = {
  __typename?: 'esrs_ActionTarget_stddev_pop_fields';
  estimate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Stddev_Pop_Order_By_ = {
  estimate?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type Esrs_ActionTarget_Stddev_Samp_Fields_ = {
  __typename?: 'esrs_ActionTarget_stddev_samp_fields';
  estimate?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Stddev_Samp_Order_By_ = {
  estimate?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "esrs_ActionTarget" */
export type Esrs_ActionTarget_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_ActionTarget_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_ActionTarget_Stream_Cursor_Value_Input_ = {
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  estimate?: InputMaybe<Scalars['numeric']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Esrs_ActionTarget_Sum_Fields_ = {
  __typename?: 'esrs_ActionTarget_sum_fields';
  estimate?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Sum_Order_By_ = {
  estimate?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.ActionTarget" */
export enum Esrs_ActionTarget_Update_Column_ {
  /** column name */
  ActionId_ = 'actionId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Estimate_ = 'estimate',
  /** column name */
  Id_ = 'id',
  /** column name */
  TargetId_ = 'targetId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_ActionTarget_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Esrs_ActionTarget_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_ActionTarget_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_ActionTarget_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type Esrs_ActionTarget_Var_Pop_Fields_ = {
  __typename?: 'esrs_ActionTarget_var_pop_fields';
  estimate?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Var_Pop_Order_By_ = {
  estimate?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type Esrs_ActionTarget_Var_Samp_Fields_ = {
  __typename?: 'esrs_ActionTarget_var_samp_fields';
  estimate?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Var_Samp_Order_By_ = {
  estimate?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type Esrs_ActionTarget_Variance_Fields_ = {
  __typename?: 'esrs_ActionTarget_variance_fields';
  estimate?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.ActionTarget" */
export type Esrs_ActionTarget_Variance_Order_By_ = {
  estimate?: InputMaybe<Order_By_>;
};

/** (user input data): When setting up targets relating to each specific metric, there's specific actions to be done in order to achieve the targets. These actions will have specific start dates and deadlines.  */
export type Esrs_Actions_ = {
  __typename?: 'esrs_Actions';
  /** An array relationship */
  actionReportingUnits: Array<Esrs_ActionReportingUnit_>;
  /** An aggregate relationship */
  actionReportingUnits_aggregate: Esrs_ActionReportingUnit_Aggregate_;
  /** An array relationship */
  actionSubsidiaries: Array<Esrs_ActionSubsidiary_>;
  /** An aggregate relationship */
  actionSubsidiaries_aggregate: Esrs_ActionSubsidiary_Aggregate_;
  /** An array relationship */
  actionTargets: Array<Esrs_ActionTarget_>;
  /** An aggregate relationship */
  actionTargets_aggregate: Esrs_ActionTarget_Aggregate_;
  answers?: Maybe<Scalars['jsonb']['output']>;
  /** the esrs assessments linking then to esrs business units */
  assessmentId: Scalars['uuid']['output'];
  /** An object relationship */
  attachmentBox?: Maybe<AttachmentBox_>;
  capex?: Maybe<Scalars['numeric']['output']>;
  capexLongTerm?: Maybe<Scalars['numeric']['output']>;
  capexMediumTerm?: Maybe<Scalars['numeric']['output']>;
  capexShortTerm?: Maybe<Scalars['numeric']['output']>;
  coverage?: Maybe<Scalars['String']['output']>;
  coverageExplanation?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deadline: Scalars['date']['output'];
  /** An object relationship */
  disclosureRequirement: DisclosureRequirement_;
  /** specifies which disclosure requirement/standard the action is related to */
  disclosureRequirementRef: Scalars['String']['output'];
  expectedOutcome?: Maybe<Scalars['String']['output']>;
  hasPreconditions?: Maybe<Scalars['Boolean']['output']>;
  hasPreconditionsExplanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  investmentsAndResources?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  materialStandard: Esrs_MaterialStandard_;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  noteHistory?: Maybe<NoteHistory_>;
  noteReference?: Maybe<Scalars['String']['output']>;
  opex?: Maybe<Scalars['numeric']['output']>;
  opexLongTerm?: Maybe<Scalars['numeric']['output']>;
  opexMediumTerm?: Maybe<Scalars['numeric']['output']>;
  opexShortTerm?: Maybe<Scalars['numeric']['output']>;
  /** An object relationship */
  owner?: Maybe<Users_>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  progressInfo?: Maybe<Scalars['String']['output']>;
  provisionOfRemedy?: Maybe<Scalars['Boolean']['output']>;
  provisionOfRemedyExplanation?: Maybe<Scalars['String']['output']>;
  relatedIRO?: Maybe<Scalars['String']['output']>;
  relatedPolicy?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scopeValueChain?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['date']['output'];
  statusOfKeyAction?: Maybe<Scalars['String']['output']>;
  statusOfKeyActionExplanation?: Maybe<Scalars['String']['output']>;
  sustainabilityMatter?: Maybe<Scalars['String']['output']>;
  sustainabilityMatterExplanation?: Maybe<Scalars['String']['output']>;
  timeHorizon?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** (user input data): When setting up targets relating to each specific metric, there's specific actions to be done in order to achieve the targets. These actions will have specific start dates and deadlines.  */
export type Esrs_ActionsActionReportingUnitsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionReportingUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionReportingUnit_Order_By_>>;
  where?: InputMaybe<Esrs_ActionReportingUnit_Bool_Exp_>;
};


/** (user input data): When setting up targets relating to each specific metric, there's specific actions to be done in order to achieve the targets. These actions will have specific start dates and deadlines.  */
export type Esrs_ActionsActionReportingUnits_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionReportingUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionReportingUnit_Order_By_>>;
  where?: InputMaybe<Esrs_ActionReportingUnit_Bool_Exp_>;
};


/** (user input data): When setting up targets relating to each specific metric, there's specific actions to be done in order to achieve the targets. These actions will have specific start dates and deadlines.  */
export type Esrs_ActionsActionSubsidiariesArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionSubsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionSubsidiary_Order_By_>>;
  where?: InputMaybe<Esrs_ActionSubsidiary_Bool_Exp_>;
};


/** (user input data): When setting up targets relating to each specific metric, there's specific actions to be done in order to achieve the targets. These actions will have specific start dates and deadlines.  */
export type Esrs_ActionsActionSubsidiaries_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionSubsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionSubsidiary_Order_By_>>;
  where?: InputMaybe<Esrs_ActionSubsidiary_Bool_Exp_>;
};


/** (user input data): When setting up targets relating to each specific metric, there's specific actions to be done in order to achieve the targets. These actions will have specific start dates and deadlines.  */
export type Esrs_ActionsActionTargetsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionTarget_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionTarget_Order_By_>>;
  where?: InputMaybe<Esrs_ActionTarget_Bool_Exp_>;
};


/** (user input data): When setting up targets relating to each specific metric, there's specific actions to be done in order to achieve the targets. These actions will have specific start dates and deadlines.  */
export type Esrs_ActionsActionTargets_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionTarget_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionTarget_Order_By_>>;
  where?: InputMaybe<Esrs_ActionTarget_Bool_Exp_>;
};


/** (user input data): When setting up targets relating to each specific metric, there's specific actions to be done in order to achieve the targets. These actions will have specific start dates and deadlines.  */
export type Esrs_ActionsAnswersArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "esrs.Actions" */
export type Esrs_Actions_Aggregate_ = {
  __typename?: 'esrs_Actions_aggregate';
  aggregate?: Maybe<Esrs_Actions_Aggregate_Fields_>;
  nodes: Array<Esrs_Actions_>;
};

export type Esrs_Actions_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Esrs_Actions_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Esrs_Actions_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Esrs_Actions_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_Actions_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Esrs_Actions_Select_Column_Esrs_Actions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Actions_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_Actions_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Esrs_Actions_Select_Column_Esrs_Actions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Actions_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_Actions_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_Actions_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Actions_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.Actions" */
export type Esrs_Actions_Aggregate_Fields_ = {
  __typename?: 'esrs_Actions_aggregate_fields';
  avg?: Maybe<Esrs_Actions_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_Actions_Max_Fields_>;
  min?: Maybe<Esrs_Actions_Min_Fields_>;
  stddev?: Maybe<Esrs_Actions_Stddev_Fields_>;
  stddev_pop?: Maybe<Esrs_Actions_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<Esrs_Actions_Stddev_Samp_Fields_>;
  sum?: Maybe<Esrs_Actions_Sum_Fields_>;
  var_pop?: Maybe<Esrs_Actions_Var_Pop_Fields_>;
  var_samp?: Maybe<Esrs_Actions_Var_Samp_Fields_>;
  variance?: Maybe<Esrs_Actions_Variance_Fields_>;
};


/** aggregate fields of "esrs.Actions" */
export type Esrs_Actions_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_Actions_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.Actions" */
export type Esrs_Actions_Aggregate_Order_By_ = {
  avg?: InputMaybe<Esrs_Actions_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_Actions_Max_Order_By_>;
  min?: InputMaybe<Esrs_Actions_Min_Order_By_>;
  stddev?: InputMaybe<Esrs_Actions_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<Esrs_Actions_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<Esrs_Actions_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<Esrs_Actions_Sum_Order_By_>;
  var_pop?: InputMaybe<Esrs_Actions_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<Esrs_Actions_Var_Samp_Order_By_>;
  variance?: InputMaybe<Esrs_Actions_Variance_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Esrs_Actions_Append_Input_ = {
  answers?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "esrs.Actions" */
export type Esrs_Actions_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_Actions_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_Actions_On_Conflict_>;
};

/** aggregate avg on columns */
export type Esrs_Actions_Avg_Fields_ = {
  __typename?: 'esrs_Actions_avg_fields';
  capex?: Maybe<Scalars['Float']['output']>;
  capexLongTerm?: Maybe<Scalars['Float']['output']>;
  capexMediumTerm?: Maybe<Scalars['Float']['output']>;
  capexShortTerm?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  opexLongTerm?: Maybe<Scalars['Float']['output']>;
  opexMediumTerm?: Maybe<Scalars['Float']['output']>;
  opexShortTerm?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.Actions" */
export type Esrs_Actions_Avg_Order_By_ = {
  capex?: InputMaybe<Order_By_>;
  capexLongTerm?: InputMaybe<Order_By_>;
  capexMediumTerm?: InputMaybe<Order_By_>;
  capexShortTerm?: InputMaybe<Order_By_>;
  opex?: InputMaybe<Order_By_>;
  opexLongTerm?: InputMaybe<Order_By_>;
  opexMediumTerm?: InputMaybe<Order_By_>;
  opexShortTerm?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.Actions". All fields are combined with a logical 'AND'. */
export type Esrs_Actions_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_Actions_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_Actions_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_Actions_Bool_Exp_>>;
  actionReportingUnits?: InputMaybe<Esrs_ActionReportingUnit_Bool_Exp_>;
  actionReportingUnits_aggregate?: InputMaybe<Esrs_ActionReportingUnit_Aggregate_Bool_Exp_>;
  actionSubsidiaries?: InputMaybe<Esrs_ActionSubsidiary_Bool_Exp_>;
  actionSubsidiaries_aggregate?: InputMaybe<Esrs_ActionSubsidiary_Aggregate_Bool_Exp_>;
  actionTargets?: InputMaybe<Esrs_ActionTarget_Bool_Exp_>;
  actionTargets_aggregate?: InputMaybe<Esrs_ActionTarget_Aggregate_Bool_Exp_>;
  answers?: InputMaybe<Jsonb_Comparison_Exp_>;
  assessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  attachmentBox?: InputMaybe<AttachmentBox_Bool_Exp_>;
  capex?: InputMaybe<Numeric_Comparison_Exp_>;
  capexLongTerm?: InputMaybe<Numeric_Comparison_Exp_>;
  capexMediumTerm?: InputMaybe<Numeric_Comparison_Exp_>;
  capexShortTerm?: InputMaybe<Numeric_Comparison_Exp_>;
  coverage?: InputMaybe<String_Comparison_Exp_>;
  coverageExplanation?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  deadline?: InputMaybe<Date_Comparison_Exp_>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  disclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
  expectedOutcome?: InputMaybe<String_Comparison_Exp_>;
  hasPreconditions?: InputMaybe<Boolean_Comparison_Exp_>;
  hasPreconditionsExplanation?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  investmentsAndResources?: InputMaybe<String_Comparison_Exp_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  mfDisclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
  noteHistory?: InputMaybe<NoteHistory_Bool_Exp_>;
  noteReference?: InputMaybe<String_Comparison_Exp_>;
  opex?: InputMaybe<Numeric_Comparison_Exp_>;
  opexLongTerm?: InputMaybe<Numeric_Comparison_Exp_>;
  opexMediumTerm?: InputMaybe<Numeric_Comparison_Exp_>;
  opexShortTerm?: InputMaybe<Numeric_Comparison_Exp_>;
  owner?: InputMaybe<Users_Bool_Exp_>;
  ownerId?: InputMaybe<Uuid_Comparison_Exp_>;
  progressInfo?: InputMaybe<String_Comparison_Exp_>;
  provisionOfRemedy?: InputMaybe<Boolean_Comparison_Exp_>;
  provisionOfRemedyExplanation?: InputMaybe<String_Comparison_Exp_>;
  relatedIRO?: InputMaybe<String_Comparison_Exp_>;
  relatedPolicy?: InputMaybe<String_Comparison_Exp_>;
  scope?: InputMaybe<String_Comparison_Exp_>;
  scopeValueChain?: InputMaybe<String_Comparison_Exp_>;
  startDate?: InputMaybe<Date_Comparison_Exp_>;
  statusOfKeyAction?: InputMaybe<String_Comparison_Exp_>;
  statusOfKeyActionExplanation?: InputMaybe<String_Comparison_Exp_>;
  sustainabilityMatter?: InputMaybe<String_Comparison_Exp_>;
  sustainabilityMatterExplanation?: InputMaybe<String_Comparison_Exp_>;
  timeHorizon?: InputMaybe<String_Comparison_Exp_>;
  title?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.Actions" */
export enum Esrs_Actions_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  ActionsPkey_ = 'Actions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Esrs_Actions_Delete_At_Path_Input_ = {
  answers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Esrs_Actions_Delete_Elem_Input_ = {
  answers?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Esrs_Actions_Delete_Key_Input_ = {
  answers?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "esrs.Actions" */
export type Esrs_Actions_Inc_Input_ = {
  capex?: InputMaybe<Scalars['numeric']['input']>;
  capexLongTerm?: InputMaybe<Scalars['numeric']['input']>;
  capexMediumTerm?: InputMaybe<Scalars['numeric']['input']>;
  capexShortTerm?: InputMaybe<Scalars['numeric']['input']>;
  opex?: InputMaybe<Scalars['numeric']['input']>;
  opexLongTerm?: InputMaybe<Scalars['numeric']['input']>;
  opexMediumTerm?: InputMaybe<Scalars['numeric']['input']>;
  opexShortTerm?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "esrs.Actions" */
export type Esrs_Actions_Insert_Input_ = {
  actionReportingUnits?: InputMaybe<Esrs_ActionReportingUnit_Arr_Rel_Insert_Input_>;
  actionSubsidiaries?: InputMaybe<Esrs_ActionSubsidiary_Arr_Rel_Insert_Input_>;
  actionTargets?: InputMaybe<Esrs_ActionTarget_Arr_Rel_Insert_Input_>;
  answers?: InputMaybe<Scalars['jsonb']['input']>;
  /** the esrs assessments linking then to esrs business units */
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  attachmentBox?: InputMaybe<AttachmentBox_Obj_Rel_Insert_Input_>;
  capex?: InputMaybe<Scalars['numeric']['input']>;
  capexLongTerm?: InputMaybe<Scalars['numeric']['input']>;
  capexMediumTerm?: InputMaybe<Scalars['numeric']['input']>;
  capexShortTerm?: InputMaybe<Scalars['numeric']['input']>;
  coverage?: InputMaybe<Scalars['String']['input']>;
  coverageExplanation?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deadline?: InputMaybe<Scalars['date']['input']>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Obj_Rel_Insert_Input_>;
  /** specifies which disclosure requirement/standard the action is related to */
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  expectedOutcome?: InputMaybe<Scalars['String']['input']>;
  hasPreconditions?: InputMaybe<Scalars['Boolean']['input']>;
  hasPreconditionsExplanation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  investmentsAndResources?: InputMaybe<Scalars['String']['input']>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Obj_Rel_Insert_Input_>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  noteHistory?: InputMaybe<NoteHistory_Obj_Rel_Insert_Input_>;
  noteReference?: InputMaybe<Scalars['String']['input']>;
  opex?: InputMaybe<Scalars['numeric']['input']>;
  opexLongTerm?: InputMaybe<Scalars['numeric']['input']>;
  opexMediumTerm?: InputMaybe<Scalars['numeric']['input']>;
  opexShortTerm?: InputMaybe<Scalars['numeric']['input']>;
  owner?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  progressInfo?: InputMaybe<Scalars['String']['input']>;
  provisionOfRemedy?: InputMaybe<Scalars['Boolean']['input']>;
  provisionOfRemedyExplanation?: InputMaybe<Scalars['String']['input']>;
  relatedIRO?: InputMaybe<Scalars['String']['input']>;
  relatedPolicy?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scopeValueChain?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  statusOfKeyAction?: InputMaybe<Scalars['String']['input']>;
  statusOfKeyActionExplanation?: InputMaybe<Scalars['String']['input']>;
  sustainabilityMatter?: InputMaybe<Scalars['String']['input']>;
  sustainabilityMatterExplanation?: InputMaybe<Scalars['String']['input']>;
  timeHorizon?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_Actions_Max_Fields_ = {
  __typename?: 'esrs_Actions_max_fields';
  /** the esrs assessments linking then to esrs business units */
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  capex?: Maybe<Scalars['numeric']['output']>;
  capexLongTerm?: Maybe<Scalars['numeric']['output']>;
  capexMediumTerm?: Maybe<Scalars['numeric']['output']>;
  capexShortTerm?: Maybe<Scalars['numeric']['output']>;
  coverage?: Maybe<Scalars['String']['output']>;
  coverageExplanation?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deadline?: Maybe<Scalars['date']['output']>;
  /** specifies which disclosure requirement/standard the action is related to */
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  expectedOutcome?: Maybe<Scalars['String']['output']>;
  hasPreconditionsExplanation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  investmentsAndResources?: Maybe<Scalars['String']['output']>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  noteReference?: Maybe<Scalars['String']['output']>;
  opex?: Maybe<Scalars['numeric']['output']>;
  opexLongTerm?: Maybe<Scalars['numeric']['output']>;
  opexMediumTerm?: Maybe<Scalars['numeric']['output']>;
  opexShortTerm?: Maybe<Scalars['numeric']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  progressInfo?: Maybe<Scalars['String']['output']>;
  provisionOfRemedyExplanation?: Maybe<Scalars['String']['output']>;
  relatedIRO?: Maybe<Scalars['String']['output']>;
  relatedPolicy?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scopeValueChain?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['date']['output']>;
  statusOfKeyAction?: Maybe<Scalars['String']['output']>;
  statusOfKeyActionExplanation?: Maybe<Scalars['String']['output']>;
  sustainabilityMatter?: Maybe<Scalars['String']['output']>;
  sustainabilityMatterExplanation?: Maybe<Scalars['String']['output']>;
  timeHorizon?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.Actions" */
export type Esrs_Actions_Max_Order_By_ = {
  /** the esrs assessments linking then to esrs business units */
  assessmentId?: InputMaybe<Order_By_>;
  capex?: InputMaybe<Order_By_>;
  capexLongTerm?: InputMaybe<Order_By_>;
  capexMediumTerm?: InputMaybe<Order_By_>;
  capexShortTerm?: InputMaybe<Order_By_>;
  coverage?: InputMaybe<Order_By_>;
  coverageExplanation?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deadline?: InputMaybe<Order_By_>;
  /** specifies which disclosure requirement/standard the action is related to */
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  expectedOutcome?: InputMaybe<Order_By_>;
  hasPreconditionsExplanation?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  investmentsAndResources?: InputMaybe<Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
  noteReference?: InputMaybe<Order_By_>;
  opex?: InputMaybe<Order_By_>;
  opexLongTerm?: InputMaybe<Order_By_>;
  opexMediumTerm?: InputMaybe<Order_By_>;
  opexShortTerm?: InputMaybe<Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  progressInfo?: InputMaybe<Order_By_>;
  provisionOfRemedyExplanation?: InputMaybe<Order_By_>;
  relatedIRO?: InputMaybe<Order_By_>;
  relatedPolicy?: InputMaybe<Order_By_>;
  scope?: InputMaybe<Order_By_>;
  scopeValueChain?: InputMaybe<Order_By_>;
  startDate?: InputMaybe<Order_By_>;
  statusOfKeyAction?: InputMaybe<Order_By_>;
  statusOfKeyActionExplanation?: InputMaybe<Order_By_>;
  sustainabilityMatter?: InputMaybe<Order_By_>;
  sustainabilityMatterExplanation?: InputMaybe<Order_By_>;
  timeHorizon?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_Actions_Min_Fields_ = {
  __typename?: 'esrs_Actions_min_fields';
  /** the esrs assessments linking then to esrs business units */
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  capex?: Maybe<Scalars['numeric']['output']>;
  capexLongTerm?: Maybe<Scalars['numeric']['output']>;
  capexMediumTerm?: Maybe<Scalars['numeric']['output']>;
  capexShortTerm?: Maybe<Scalars['numeric']['output']>;
  coverage?: Maybe<Scalars['String']['output']>;
  coverageExplanation?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deadline?: Maybe<Scalars['date']['output']>;
  /** specifies which disclosure requirement/standard the action is related to */
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  expectedOutcome?: Maybe<Scalars['String']['output']>;
  hasPreconditionsExplanation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  investmentsAndResources?: Maybe<Scalars['String']['output']>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  noteReference?: Maybe<Scalars['String']['output']>;
  opex?: Maybe<Scalars['numeric']['output']>;
  opexLongTerm?: Maybe<Scalars['numeric']['output']>;
  opexMediumTerm?: Maybe<Scalars['numeric']['output']>;
  opexShortTerm?: Maybe<Scalars['numeric']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  progressInfo?: Maybe<Scalars['String']['output']>;
  provisionOfRemedyExplanation?: Maybe<Scalars['String']['output']>;
  relatedIRO?: Maybe<Scalars['String']['output']>;
  relatedPolicy?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  scopeValueChain?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['date']['output']>;
  statusOfKeyAction?: Maybe<Scalars['String']['output']>;
  statusOfKeyActionExplanation?: Maybe<Scalars['String']['output']>;
  sustainabilityMatter?: Maybe<Scalars['String']['output']>;
  sustainabilityMatterExplanation?: Maybe<Scalars['String']['output']>;
  timeHorizon?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.Actions" */
export type Esrs_Actions_Min_Order_By_ = {
  /** the esrs assessments linking then to esrs business units */
  assessmentId?: InputMaybe<Order_By_>;
  capex?: InputMaybe<Order_By_>;
  capexLongTerm?: InputMaybe<Order_By_>;
  capexMediumTerm?: InputMaybe<Order_By_>;
  capexShortTerm?: InputMaybe<Order_By_>;
  coverage?: InputMaybe<Order_By_>;
  coverageExplanation?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deadline?: InputMaybe<Order_By_>;
  /** specifies which disclosure requirement/standard the action is related to */
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  expectedOutcome?: InputMaybe<Order_By_>;
  hasPreconditionsExplanation?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  investmentsAndResources?: InputMaybe<Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
  noteReference?: InputMaybe<Order_By_>;
  opex?: InputMaybe<Order_By_>;
  opexLongTerm?: InputMaybe<Order_By_>;
  opexMediumTerm?: InputMaybe<Order_By_>;
  opexShortTerm?: InputMaybe<Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  progressInfo?: InputMaybe<Order_By_>;
  provisionOfRemedyExplanation?: InputMaybe<Order_By_>;
  relatedIRO?: InputMaybe<Order_By_>;
  relatedPolicy?: InputMaybe<Order_By_>;
  scope?: InputMaybe<Order_By_>;
  scopeValueChain?: InputMaybe<Order_By_>;
  startDate?: InputMaybe<Order_By_>;
  statusOfKeyAction?: InputMaybe<Order_By_>;
  statusOfKeyActionExplanation?: InputMaybe<Order_By_>;
  sustainabilityMatter?: InputMaybe<Order_By_>;
  sustainabilityMatterExplanation?: InputMaybe<Order_By_>;
  timeHorizon?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.Actions" */
export type Esrs_Actions_Mutation_Response_ = {
  __typename?: 'esrs_Actions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_Actions_>;
};

/** input type for inserting object relation for remote table "esrs.Actions" */
export type Esrs_Actions_Obj_Rel_Insert_Input_ = {
  data: Esrs_Actions_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_Actions_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.Actions" */
export type Esrs_Actions_On_Conflict_ = {
  constraint: Esrs_Actions_Constraint_;
  update_columns?: Array<Esrs_Actions_Update_Column_>;
  where?: InputMaybe<Esrs_Actions_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.Actions". */
export type Esrs_Actions_Order_By_ = {
  actionReportingUnits_aggregate?: InputMaybe<Esrs_ActionReportingUnit_Aggregate_Order_By_>;
  actionSubsidiaries_aggregate?: InputMaybe<Esrs_ActionSubsidiary_Aggregate_Order_By_>;
  actionTargets_aggregate?: InputMaybe<Esrs_ActionTarget_Aggregate_Order_By_>;
  answers?: InputMaybe<Order_By_>;
  assessmentId?: InputMaybe<Order_By_>;
  attachmentBox?: InputMaybe<AttachmentBox_Order_By_>;
  capex?: InputMaybe<Order_By_>;
  capexLongTerm?: InputMaybe<Order_By_>;
  capexMediumTerm?: InputMaybe<Order_By_>;
  capexShortTerm?: InputMaybe<Order_By_>;
  coverage?: InputMaybe<Order_By_>;
  coverageExplanation?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deadline?: InputMaybe<Order_By_>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  expectedOutcome?: InputMaybe<Order_By_>;
  hasPreconditions?: InputMaybe<Order_By_>;
  hasPreconditionsExplanation?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  investmentsAndResources?: InputMaybe<Order_By_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
  noteHistory?: InputMaybe<NoteHistory_Order_By_>;
  noteReference?: InputMaybe<Order_By_>;
  opex?: InputMaybe<Order_By_>;
  opexLongTerm?: InputMaybe<Order_By_>;
  opexMediumTerm?: InputMaybe<Order_By_>;
  opexShortTerm?: InputMaybe<Order_By_>;
  owner?: InputMaybe<Users_Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  progressInfo?: InputMaybe<Order_By_>;
  provisionOfRemedy?: InputMaybe<Order_By_>;
  provisionOfRemedyExplanation?: InputMaybe<Order_By_>;
  relatedIRO?: InputMaybe<Order_By_>;
  relatedPolicy?: InputMaybe<Order_By_>;
  scope?: InputMaybe<Order_By_>;
  scopeValueChain?: InputMaybe<Order_By_>;
  startDate?: InputMaybe<Order_By_>;
  statusOfKeyAction?: InputMaybe<Order_By_>;
  statusOfKeyActionExplanation?: InputMaybe<Order_By_>;
  sustainabilityMatter?: InputMaybe<Order_By_>;
  sustainabilityMatterExplanation?: InputMaybe<Order_By_>;
  timeHorizon?: InputMaybe<Order_By_>;
  title?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.Actions */
export type Esrs_Actions_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Esrs_Actions_Prepend_Input_ = {
  answers?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "esrs.Actions" */
export enum Esrs_Actions_Select_Column_ {
  /** column name */
  Answers_ = 'answers',
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  Capex_ = 'capex',
  /** column name */
  CapexLongTerm_ = 'capexLongTerm',
  /** column name */
  CapexMediumTerm_ = 'capexMediumTerm',
  /** column name */
  CapexShortTerm_ = 'capexShortTerm',
  /** column name */
  Coverage_ = 'coverage',
  /** column name */
  CoverageExplanation_ = 'coverageExplanation',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Deadline_ = 'deadline',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  ExpectedOutcome_ = 'expectedOutcome',
  /** column name */
  HasPreconditions_ = 'hasPreconditions',
  /** column name */
  HasPreconditionsExplanation_ = 'hasPreconditionsExplanation',
  /** column name */
  Id_ = 'id',
  /** column name */
  InvestmentsAndResources_ = 'investmentsAndResources',
  /** column name */
  MfDisclosureRequirementRef_ = 'mfDisclosureRequirementRef',
  /** column name */
  NoteReference_ = 'noteReference',
  /** column name */
  Opex_ = 'opex',
  /** column name */
  OpexLongTerm_ = 'opexLongTerm',
  /** column name */
  OpexMediumTerm_ = 'opexMediumTerm',
  /** column name */
  OpexShortTerm_ = 'opexShortTerm',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  ProgressInfo_ = 'progressInfo',
  /** column name */
  ProvisionOfRemedy_ = 'provisionOfRemedy',
  /** column name */
  ProvisionOfRemedyExplanation_ = 'provisionOfRemedyExplanation',
  /** column name */
  RelatedIro_ = 'relatedIRO',
  /** column name */
  RelatedPolicy_ = 'relatedPolicy',
  /** column name */
  Scope_ = 'scope',
  /** column name */
  ScopeValueChain_ = 'scopeValueChain',
  /** column name */
  StartDate_ = 'startDate',
  /** column name */
  StatusOfKeyAction_ = 'statusOfKeyAction',
  /** column name */
  StatusOfKeyActionExplanation_ = 'statusOfKeyActionExplanation',
  /** column name */
  SustainabilityMatter_ = 'sustainabilityMatter',
  /** column name */
  SustainabilityMatterExplanation_ = 'sustainabilityMatterExplanation',
  /** column name */
  TimeHorizon_ = 'timeHorizon',
  /** column name */
  Title_ = 'title',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "esrs_Actions_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.Actions" */
export enum Esrs_Actions_Select_Column_Esrs_Actions_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  HasPreconditions_ = 'hasPreconditions',
  /** column name */
  ProvisionOfRemedy_ = 'provisionOfRemedy'
}

/** select "esrs_Actions_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.Actions" */
export enum Esrs_Actions_Select_Column_Esrs_Actions_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  HasPreconditions_ = 'hasPreconditions',
  /** column name */
  ProvisionOfRemedy_ = 'provisionOfRemedy'
}

/** input type for updating data in table "esrs.Actions" */
export type Esrs_Actions_Set_Input_ = {
  answers?: InputMaybe<Scalars['jsonb']['input']>;
  /** the esrs assessments linking then to esrs business units */
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  capex?: InputMaybe<Scalars['numeric']['input']>;
  capexLongTerm?: InputMaybe<Scalars['numeric']['input']>;
  capexMediumTerm?: InputMaybe<Scalars['numeric']['input']>;
  capexShortTerm?: InputMaybe<Scalars['numeric']['input']>;
  coverage?: InputMaybe<Scalars['String']['input']>;
  coverageExplanation?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deadline?: InputMaybe<Scalars['date']['input']>;
  /** specifies which disclosure requirement/standard the action is related to */
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  expectedOutcome?: InputMaybe<Scalars['String']['input']>;
  hasPreconditions?: InputMaybe<Scalars['Boolean']['input']>;
  hasPreconditionsExplanation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  investmentsAndResources?: InputMaybe<Scalars['String']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  noteReference?: InputMaybe<Scalars['String']['input']>;
  opex?: InputMaybe<Scalars['numeric']['input']>;
  opexLongTerm?: InputMaybe<Scalars['numeric']['input']>;
  opexMediumTerm?: InputMaybe<Scalars['numeric']['input']>;
  opexShortTerm?: InputMaybe<Scalars['numeric']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  progressInfo?: InputMaybe<Scalars['String']['input']>;
  provisionOfRemedy?: InputMaybe<Scalars['Boolean']['input']>;
  provisionOfRemedyExplanation?: InputMaybe<Scalars['String']['input']>;
  relatedIRO?: InputMaybe<Scalars['String']['input']>;
  relatedPolicy?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scopeValueChain?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  statusOfKeyAction?: InputMaybe<Scalars['String']['input']>;
  statusOfKeyActionExplanation?: InputMaybe<Scalars['String']['input']>;
  sustainabilityMatter?: InputMaybe<Scalars['String']['input']>;
  sustainabilityMatterExplanation?: InputMaybe<Scalars['String']['input']>;
  timeHorizon?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type Esrs_Actions_Stddev_Fields_ = {
  __typename?: 'esrs_Actions_stddev_fields';
  capex?: Maybe<Scalars['Float']['output']>;
  capexLongTerm?: Maybe<Scalars['Float']['output']>;
  capexMediumTerm?: Maybe<Scalars['Float']['output']>;
  capexShortTerm?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  opexLongTerm?: Maybe<Scalars['Float']['output']>;
  opexMediumTerm?: Maybe<Scalars['Float']['output']>;
  opexShortTerm?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.Actions" */
export type Esrs_Actions_Stddev_Order_By_ = {
  capex?: InputMaybe<Order_By_>;
  capexLongTerm?: InputMaybe<Order_By_>;
  capexMediumTerm?: InputMaybe<Order_By_>;
  capexShortTerm?: InputMaybe<Order_By_>;
  opex?: InputMaybe<Order_By_>;
  opexLongTerm?: InputMaybe<Order_By_>;
  opexMediumTerm?: InputMaybe<Order_By_>;
  opexShortTerm?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type Esrs_Actions_Stddev_Pop_Fields_ = {
  __typename?: 'esrs_Actions_stddev_pop_fields';
  capex?: Maybe<Scalars['Float']['output']>;
  capexLongTerm?: Maybe<Scalars['Float']['output']>;
  capexMediumTerm?: Maybe<Scalars['Float']['output']>;
  capexShortTerm?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  opexLongTerm?: Maybe<Scalars['Float']['output']>;
  opexMediumTerm?: Maybe<Scalars['Float']['output']>;
  opexShortTerm?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.Actions" */
export type Esrs_Actions_Stddev_Pop_Order_By_ = {
  capex?: InputMaybe<Order_By_>;
  capexLongTerm?: InputMaybe<Order_By_>;
  capexMediumTerm?: InputMaybe<Order_By_>;
  capexShortTerm?: InputMaybe<Order_By_>;
  opex?: InputMaybe<Order_By_>;
  opexLongTerm?: InputMaybe<Order_By_>;
  opexMediumTerm?: InputMaybe<Order_By_>;
  opexShortTerm?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type Esrs_Actions_Stddev_Samp_Fields_ = {
  __typename?: 'esrs_Actions_stddev_samp_fields';
  capex?: Maybe<Scalars['Float']['output']>;
  capexLongTerm?: Maybe<Scalars['Float']['output']>;
  capexMediumTerm?: Maybe<Scalars['Float']['output']>;
  capexShortTerm?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  opexLongTerm?: Maybe<Scalars['Float']['output']>;
  opexMediumTerm?: Maybe<Scalars['Float']['output']>;
  opexShortTerm?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.Actions" */
export type Esrs_Actions_Stddev_Samp_Order_By_ = {
  capex?: InputMaybe<Order_By_>;
  capexLongTerm?: InputMaybe<Order_By_>;
  capexMediumTerm?: InputMaybe<Order_By_>;
  capexShortTerm?: InputMaybe<Order_By_>;
  opex?: InputMaybe<Order_By_>;
  opexLongTerm?: InputMaybe<Order_By_>;
  opexMediumTerm?: InputMaybe<Order_By_>;
  opexShortTerm?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "esrs_Actions" */
export type Esrs_Actions_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_Actions_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_Actions_Stream_Cursor_Value_Input_ = {
  answers?: InputMaybe<Scalars['jsonb']['input']>;
  /** the esrs assessments linking then to esrs business units */
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  capex?: InputMaybe<Scalars['numeric']['input']>;
  capexLongTerm?: InputMaybe<Scalars['numeric']['input']>;
  capexMediumTerm?: InputMaybe<Scalars['numeric']['input']>;
  capexShortTerm?: InputMaybe<Scalars['numeric']['input']>;
  coverage?: InputMaybe<Scalars['String']['input']>;
  coverageExplanation?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deadline?: InputMaybe<Scalars['date']['input']>;
  /** specifies which disclosure requirement/standard the action is related to */
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  expectedOutcome?: InputMaybe<Scalars['String']['input']>;
  hasPreconditions?: InputMaybe<Scalars['Boolean']['input']>;
  hasPreconditionsExplanation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  investmentsAndResources?: InputMaybe<Scalars['String']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  noteReference?: InputMaybe<Scalars['String']['input']>;
  opex?: InputMaybe<Scalars['numeric']['input']>;
  opexLongTerm?: InputMaybe<Scalars['numeric']['input']>;
  opexMediumTerm?: InputMaybe<Scalars['numeric']['input']>;
  opexShortTerm?: InputMaybe<Scalars['numeric']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  progressInfo?: InputMaybe<Scalars['String']['input']>;
  provisionOfRemedy?: InputMaybe<Scalars['Boolean']['input']>;
  provisionOfRemedyExplanation?: InputMaybe<Scalars['String']['input']>;
  relatedIRO?: InputMaybe<Scalars['String']['input']>;
  relatedPolicy?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scopeValueChain?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['date']['input']>;
  statusOfKeyAction?: InputMaybe<Scalars['String']['input']>;
  statusOfKeyActionExplanation?: InputMaybe<Scalars['String']['input']>;
  sustainabilityMatter?: InputMaybe<Scalars['String']['input']>;
  sustainabilityMatterExplanation?: InputMaybe<Scalars['String']['input']>;
  timeHorizon?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type Esrs_Actions_Sum_Fields_ = {
  __typename?: 'esrs_Actions_sum_fields';
  capex?: Maybe<Scalars['numeric']['output']>;
  capexLongTerm?: Maybe<Scalars['numeric']['output']>;
  capexMediumTerm?: Maybe<Scalars['numeric']['output']>;
  capexShortTerm?: Maybe<Scalars['numeric']['output']>;
  opex?: Maybe<Scalars['numeric']['output']>;
  opexLongTerm?: Maybe<Scalars['numeric']['output']>;
  opexMediumTerm?: Maybe<Scalars['numeric']['output']>;
  opexShortTerm?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "esrs.Actions" */
export type Esrs_Actions_Sum_Order_By_ = {
  capex?: InputMaybe<Order_By_>;
  capexLongTerm?: InputMaybe<Order_By_>;
  capexMediumTerm?: InputMaybe<Order_By_>;
  capexShortTerm?: InputMaybe<Order_By_>;
  opex?: InputMaybe<Order_By_>;
  opexLongTerm?: InputMaybe<Order_By_>;
  opexMediumTerm?: InputMaybe<Order_By_>;
  opexShortTerm?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.Actions" */
export enum Esrs_Actions_Update_Column_ {
  /** column name */
  Answers_ = 'answers',
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  Capex_ = 'capex',
  /** column name */
  CapexLongTerm_ = 'capexLongTerm',
  /** column name */
  CapexMediumTerm_ = 'capexMediumTerm',
  /** column name */
  CapexShortTerm_ = 'capexShortTerm',
  /** column name */
  Coverage_ = 'coverage',
  /** column name */
  CoverageExplanation_ = 'coverageExplanation',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Deadline_ = 'deadline',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  ExpectedOutcome_ = 'expectedOutcome',
  /** column name */
  HasPreconditions_ = 'hasPreconditions',
  /** column name */
  HasPreconditionsExplanation_ = 'hasPreconditionsExplanation',
  /** column name */
  Id_ = 'id',
  /** column name */
  InvestmentsAndResources_ = 'investmentsAndResources',
  /** column name */
  MfDisclosureRequirementRef_ = 'mfDisclosureRequirementRef',
  /** column name */
  NoteReference_ = 'noteReference',
  /** column name */
  Opex_ = 'opex',
  /** column name */
  OpexLongTerm_ = 'opexLongTerm',
  /** column name */
  OpexMediumTerm_ = 'opexMediumTerm',
  /** column name */
  OpexShortTerm_ = 'opexShortTerm',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  ProgressInfo_ = 'progressInfo',
  /** column name */
  ProvisionOfRemedy_ = 'provisionOfRemedy',
  /** column name */
  ProvisionOfRemedyExplanation_ = 'provisionOfRemedyExplanation',
  /** column name */
  RelatedIro_ = 'relatedIRO',
  /** column name */
  RelatedPolicy_ = 'relatedPolicy',
  /** column name */
  Scope_ = 'scope',
  /** column name */
  ScopeValueChain_ = 'scopeValueChain',
  /** column name */
  StartDate_ = 'startDate',
  /** column name */
  StatusOfKeyAction_ = 'statusOfKeyAction',
  /** column name */
  StatusOfKeyActionExplanation_ = 'statusOfKeyActionExplanation',
  /** column name */
  SustainabilityMatter_ = 'sustainabilityMatter',
  /** column name */
  SustainabilityMatterExplanation_ = 'sustainabilityMatterExplanation',
  /** column name */
  TimeHorizon_ = 'timeHorizon',
  /** column name */
  Title_ = 'title',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_Actions_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Esrs_Actions_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Esrs_Actions_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Esrs_Actions_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Esrs_Actions_Delete_Key_Input_>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Esrs_Actions_Inc_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Esrs_Actions_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_Actions_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_Actions_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type Esrs_Actions_Var_Pop_Fields_ = {
  __typename?: 'esrs_Actions_var_pop_fields';
  capex?: Maybe<Scalars['Float']['output']>;
  capexLongTerm?: Maybe<Scalars['Float']['output']>;
  capexMediumTerm?: Maybe<Scalars['Float']['output']>;
  capexShortTerm?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  opexLongTerm?: Maybe<Scalars['Float']['output']>;
  opexMediumTerm?: Maybe<Scalars['Float']['output']>;
  opexShortTerm?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.Actions" */
export type Esrs_Actions_Var_Pop_Order_By_ = {
  capex?: InputMaybe<Order_By_>;
  capexLongTerm?: InputMaybe<Order_By_>;
  capexMediumTerm?: InputMaybe<Order_By_>;
  capexShortTerm?: InputMaybe<Order_By_>;
  opex?: InputMaybe<Order_By_>;
  opexLongTerm?: InputMaybe<Order_By_>;
  opexMediumTerm?: InputMaybe<Order_By_>;
  opexShortTerm?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type Esrs_Actions_Var_Samp_Fields_ = {
  __typename?: 'esrs_Actions_var_samp_fields';
  capex?: Maybe<Scalars['Float']['output']>;
  capexLongTerm?: Maybe<Scalars['Float']['output']>;
  capexMediumTerm?: Maybe<Scalars['Float']['output']>;
  capexShortTerm?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  opexLongTerm?: Maybe<Scalars['Float']['output']>;
  opexMediumTerm?: Maybe<Scalars['Float']['output']>;
  opexShortTerm?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.Actions" */
export type Esrs_Actions_Var_Samp_Order_By_ = {
  capex?: InputMaybe<Order_By_>;
  capexLongTerm?: InputMaybe<Order_By_>;
  capexMediumTerm?: InputMaybe<Order_By_>;
  capexShortTerm?: InputMaybe<Order_By_>;
  opex?: InputMaybe<Order_By_>;
  opexLongTerm?: InputMaybe<Order_By_>;
  opexMediumTerm?: InputMaybe<Order_By_>;
  opexShortTerm?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type Esrs_Actions_Variance_Fields_ = {
  __typename?: 'esrs_Actions_variance_fields';
  capex?: Maybe<Scalars['Float']['output']>;
  capexLongTerm?: Maybe<Scalars['Float']['output']>;
  capexMediumTerm?: Maybe<Scalars['Float']['output']>;
  capexShortTerm?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Float']['output']>;
  opexLongTerm?: Maybe<Scalars['Float']['output']>;
  opexMediumTerm?: Maybe<Scalars['Float']['output']>;
  opexShortTerm?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.Actions" */
export type Esrs_Actions_Variance_Order_By_ = {
  capex?: InputMaybe<Order_By_>;
  capexLongTerm?: InputMaybe<Order_By_>;
  capexMediumTerm?: InputMaybe<Order_By_>;
  capexShortTerm?: InputMaybe<Order_By_>;
  opex?: InputMaybe<Order_By_>;
  opexLongTerm?: InputMaybe<Order_By_>;
  opexMediumTerm?: InputMaybe<Order_By_>;
  opexShortTerm?: InputMaybe<Order_By_>;
};

/** columns and relationships of "esrs.Answer" */
export type Esrs_Answer_ = {
  __typename?: 'esrs_Answer';
  assessmentId: Scalars['uuid']['output'];
  /** An object relationship */
  attachmentBox?: Maybe<AttachmentBox_>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  datapoints: Array<Esrs_Datapoint_>;
  /** An aggregate relationship */
  datapoints_aggregate: Esrs_Datapoint_Aggregate_;
  /** An object relationship */
  esrsAssessment: EsrsAssessment_;
  hasOptedOut: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  metric: EsrsMetric_;
  metricRef: Scalars['String']['output'];
  /** An object relationship */
  noteHistory?: Maybe<NoteHistory_>;
  /** An object relationship */
  optOutAuthor?: Maybe<Users_>;
  optOutAuthorId?: Maybe<Scalars['uuid']['output']>;
  optOutReason?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  reportingUnit: Esrs_ReportingUnit_;
  reportingUnitId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "esrs.Answer" */
export type Esrs_AnswerDatapointsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Datapoint_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Datapoint_Order_By_>>;
  where?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
};


/** columns and relationships of "esrs.Answer" */
export type Esrs_AnswerDatapoints_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Datapoint_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Datapoint_Order_By_>>;
  where?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
};

/** aggregated selection of "esrs.Answer" */
export type Esrs_Answer_Aggregate_ = {
  __typename?: 'esrs_Answer_aggregate';
  aggregate?: Maybe<Esrs_Answer_Aggregate_Fields_>;
  nodes: Array<Esrs_Answer_>;
};

export type Esrs_Answer_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Esrs_Answer_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Esrs_Answer_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Esrs_Answer_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_Answer_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Esrs_Answer_Select_Column_Esrs_Answer_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Answer_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_Answer_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Esrs_Answer_Select_Column_Esrs_Answer_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Answer_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_Answer_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_Answer_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Answer_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.Answer" */
export type Esrs_Answer_Aggregate_Fields_ = {
  __typename?: 'esrs_Answer_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_Answer_Max_Fields_>;
  min?: Maybe<Esrs_Answer_Min_Fields_>;
};


/** aggregate fields of "esrs.Answer" */
export type Esrs_Answer_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_Answer_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.Answer" */
export type Esrs_Answer_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_Answer_Max_Order_By_>;
  min?: InputMaybe<Esrs_Answer_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.Answer" */
export type Esrs_Answer_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_Answer_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_Answer_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.Answer". All fields are combined with a logical 'AND'. */
export type Esrs_Answer_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_Answer_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_Answer_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_Answer_Bool_Exp_>>;
  assessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  attachmentBox?: InputMaybe<AttachmentBox_Bool_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  datapoints?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
  datapoints_aggregate?: InputMaybe<Esrs_Datapoint_Aggregate_Bool_Exp_>;
  esrsAssessment?: InputMaybe<EsrsAssessment_Bool_Exp_>;
  hasOptedOut?: InputMaybe<Boolean_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  metric?: InputMaybe<EsrsMetric_Bool_Exp_>;
  metricRef?: InputMaybe<String_Comparison_Exp_>;
  noteHistory?: InputMaybe<NoteHistory_Bool_Exp_>;
  optOutAuthor?: InputMaybe<Users_Bool_Exp_>;
  optOutAuthorId?: InputMaybe<Uuid_Comparison_Exp_>;
  optOutReason?: InputMaybe<String_Comparison_Exp_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
  reportingUnitId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.Answer" */
export enum Esrs_Answer_Constraint_ {
  /** unique or primary key constraint on columns "assessmentId", "metricRef", "reportingUnitId" */
  AnswerMetricRefAssessmentIdReportingUnitIdKey_ = 'Answer_metricRef_assessmentId_reportingUnitId_key',
  /** unique or primary key constraint on columns "id" */
  AnswerPkey_ = 'Answer_pkey'
}

/** input type for inserting data into table "esrs.Answer" */
export type Esrs_Answer_Insert_Input_ = {
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  attachmentBox?: InputMaybe<AttachmentBox_Obj_Rel_Insert_Input_>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  datapoints?: InputMaybe<Esrs_Datapoint_Arr_Rel_Insert_Input_>;
  esrsAssessment?: InputMaybe<EsrsAssessment_Obj_Rel_Insert_Input_>;
  hasOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metric?: InputMaybe<EsrsMetric_Obj_Rel_Insert_Input_>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  noteHistory?: InputMaybe<NoteHistory_Obj_Rel_Insert_Input_>;
  optOutAuthor?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  optOutAuthorId?: InputMaybe<Scalars['uuid']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Obj_Rel_Insert_Input_>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_Answer_Max_Fields_ = {
  __typename?: 'esrs_Answer_max_fields';
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  metricRef?: Maybe<Scalars['String']['output']>;
  optOutAuthorId?: Maybe<Scalars['uuid']['output']>;
  optOutReason?: Maybe<Scalars['String']['output']>;
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.Answer" */
export type Esrs_Answer_Max_Order_By_ = {
  assessmentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
  optOutAuthorId?: InputMaybe<Order_By_>;
  optOutReason?: InputMaybe<Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_Answer_Min_Fields_ = {
  __typename?: 'esrs_Answer_min_fields';
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  metricRef?: Maybe<Scalars['String']['output']>;
  optOutAuthorId?: Maybe<Scalars['uuid']['output']>;
  optOutReason?: Maybe<Scalars['String']['output']>;
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.Answer" */
export type Esrs_Answer_Min_Order_By_ = {
  assessmentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
  optOutAuthorId?: InputMaybe<Order_By_>;
  optOutReason?: InputMaybe<Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.Answer" */
export type Esrs_Answer_Mutation_Response_ = {
  __typename?: 'esrs_Answer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_Answer_>;
};

/** input type for inserting object relation for remote table "esrs.Answer" */
export type Esrs_Answer_Obj_Rel_Insert_Input_ = {
  data: Esrs_Answer_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_Answer_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.Answer" */
export type Esrs_Answer_On_Conflict_ = {
  constraint: Esrs_Answer_Constraint_;
  update_columns?: Array<Esrs_Answer_Update_Column_>;
  where?: InputMaybe<Esrs_Answer_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.Answer". */
export type Esrs_Answer_Order_By_ = {
  assessmentId?: InputMaybe<Order_By_>;
  attachmentBox?: InputMaybe<AttachmentBox_Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  datapoints_aggregate?: InputMaybe<Esrs_Datapoint_Aggregate_Order_By_>;
  esrsAssessment?: InputMaybe<EsrsAssessment_Order_By_>;
  hasOptedOut?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  metric?: InputMaybe<EsrsMetric_Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
  noteHistory?: InputMaybe<NoteHistory_Order_By_>;
  optOutAuthor?: InputMaybe<Users_Order_By_>;
  optOutAuthorId?: InputMaybe<Order_By_>;
  optOutReason?: InputMaybe<Order_By_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.Answer */
export type Esrs_Answer_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.Answer" */
export enum Esrs_Answer_Select_Column_ {
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  HasOptedOut_ = 'hasOptedOut',
  /** column name */
  Id_ = 'id',
  /** column name */
  MetricRef_ = 'metricRef',
  /** column name */
  OptOutAuthorId_ = 'optOutAuthorId',
  /** column name */
  OptOutReason_ = 'optOutReason',
  /** column name */
  ReportingUnitId_ = 'reportingUnitId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "esrs_Answer_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.Answer" */
export enum Esrs_Answer_Select_Column_Esrs_Answer_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  HasOptedOut_ = 'hasOptedOut'
}

/** select "esrs_Answer_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.Answer" */
export enum Esrs_Answer_Select_Column_Esrs_Answer_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  HasOptedOut_ = 'hasOptedOut'
}

/** input type for updating data in table "esrs.Answer" */
export type Esrs_Answer_Set_Input_ = {
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  hasOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  optOutAuthorId?: InputMaybe<Scalars['uuid']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_Answer" */
export type Esrs_Answer_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_Answer_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_Answer_Stream_Cursor_Value_Input_ = {
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  hasOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  optOutAuthorId?: InputMaybe<Scalars['uuid']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.Answer" */
export enum Esrs_Answer_Update_Column_ {
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  HasOptedOut_ = 'hasOptedOut',
  /** column name */
  Id_ = 'id',
  /** column name */
  MetricRef_ = 'metricRef',
  /** column name */
  OptOutAuthorId_ = 'optOutAuthorId',
  /** column name */
  OptOutReason_ = 'optOutReason',
  /** column name */
  ReportingUnitId_ = 'reportingUnitId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_Answer_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_Answer_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_Answer_Bool_Exp_;
};

/** columns and relationships of "esrs.AssessmentCurrencyConversion" */
export type Esrs_AssessmentCurrencyConversion_ = {
  __typename?: 'esrs_AssessmentCurrencyConversion';
  assessmentId: Scalars['uuid']['output'];
  /** An object relationship */
  esrsAssessment?: Maybe<EsrsAssessment_>;
  from: Scalars['String']['output'];
  rate?: Maybe<Scalars['numeric']['output']>;
  to: Scalars['String']['output'];
};

/** aggregated selection of "esrs.AssessmentCurrencyConversion" */
export type Esrs_AssessmentCurrencyConversion_Aggregate_ = {
  __typename?: 'esrs_AssessmentCurrencyConversion_aggregate';
  aggregate?: Maybe<Esrs_AssessmentCurrencyConversion_Aggregate_Fields_>;
  nodes: Array<Esrs_AssessmentCurrencyConversion_>;
};

/** aggregate fields of "esrs.AssessmentCurrencyConversion" */
export type Esrs_AssessmentCurrencyConversion_Aggregate_Fields_ = {
  __typename?: 'esrs_AssessmentCurrencyConversion_aggregate_fields';
  avg?: Maybe<Esrs_AssessmentCurrencyConversion_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_AssessmentCurrencyConversion_Max_Fields_>;
  min?: Maybe<Esrs_AssessmentCurrencyConversion_Min_Fields_>;
  stddev?: Maybe<Esrs_AssessmentCurrencyConversion_Stddev_Fields_>;
  stddev_pop?: Maybe<Esrs_AssessmentCurrencyConversion_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<Esrs_AssessmentCurrencyConversion_Stddev_Samp_Fields_>;
  sum?: Maybe<Esrs_AssessmentCurrencyConversion_Sum_Fields_>;
  var_pop?: Maybe<Esrs_AssessmentCurrencyConversion_Var_Pop_Fields_>;
  var_samp?: Maybe<Esrs_AssessmentCurrencyConversion_Var_Samp_Fields_>;
  variance?: Maybe<Esrs_AssessmentCurrencyConversion_Variance_Fields_>;
};


/** aggregate fields of "esrs.AssessmentCurrencyConversion" */
export type Esrs_AssessmentCurrencyConversion_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_AssessmentCurrencyConversion_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type Esrs_AssessmentCurrencyConversion_Avg_Fields_ = {
  __typename?: 'esrs_AssessmentCurrencyConversion_avg_fields';
  rate?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "esrs.AssessmentCurrencyConversion". All fields are combined with a logical 'AND'. */
export type Esrs_AssessmentCurrencyConversion_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_AssessmentCurrencyConversion_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_AssessmentCurrencyConversion_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_AssessmentCurrencyConversion_Bool_Exp_>>;
  assessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  esrsAssessment?: InputMaybe<EsrsAssessment_Bool_Exp_>;
  from?: InputMaybe<String_Comparison_Exp_>;
  rate?: InputMaybe<Numeric_Comparison_Exp_>;
  to?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.AssessmentCurrencyConversion" */
export enum Esrs_AssessmentCurrencyConversion_Constraint_ {
  /** unique or primary key constraint on columns "assessmentId", "to", "from" */
  AssessmentCurrencyConversionPkey_ = 'AssessmentCurrencyConversion_pkey'
}

/** input type for incrementing numeric columns in table "esrs.AssessmentCurrencyConversion" */
export type Esrs_AssessmentCurrencyConversion_Inc_Input_ = {
  rate?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "esrs.AssessmentCurrencyConversion" */
export type Esrs_AssessmentCurrencyConversion_Insert_Input_ = {
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  esrsAssessment?: InputMaybe<EsrsAssessment_Obj_Rel_Insert_Input_>;
  from?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Esrs_AssessmentCurrencyConversion_Max_Fields_ = {
  __typename?: 'esrs_AssessmentCurrencyConversion_max_fields';
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['numeric']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Esrs_AssessmentCurrencyConversion_Min_Fields_ = {
  __typename?: 'esrs_AssessmentCurrencyConversion_min_fields';
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  rate?: Maybe<Scalars['numeric']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "esrs.AssessmentCurrencyConversion" */
export type Esrs_AssessmentCurrencyConversion_Mutation_Response_ = {
  __typename?: 'esrs_AssessmentCurrencyConversion_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_AssessmentCurrencyConversion_>;
};

/** on_conflict condition type for table "esrs.AssessmentCurrencyConversion" */
export type Esrs_AssessmentCurrencyConversion_On_Conflict_ = {
  constraint: Esrs_AssessmentCurrencyConversion_Constraint_;
  update_columns?: Array<Esrs_AssessmentCurrencyConversion_Update_Column_>;
  where?: InputMaybe<Esrs_AssessmentCurrencyConversion_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.AssessmentCurrencyConversion". */
export type Esrs_AssessmentCurrencyConversion_Order_By_ = {
  assessmentId?: InputMaybe<Order_By_>;
  esrsAssessment?: InputMaybe<EsrsAssessment_Order_By_>;
  from?: InputMaybe<Order_By_>;
  rate?: InputMaybe<Order_By_>;
  to?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.AssessmentCurrencyConversion */
export type Esrs_AssessmentCurrencyConversion_Pk_Columns_Input_ = {
  assessmentId: Scalars['uuid']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

/** select columns of table "esrs.AssessmentCurrencyConversion" */
export enum Esrs_AssessmentCurrencyConversion_Select_Column_ {
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  From_ = 'from',
  /** column name */
  Rate_ = 'rate',
  /** column name */
  To_ = 'to'
}

/** input type for updating data in table "esrs.AssessmentCurrencyConversion" */
export type Esrs_AssessmentCurrencyConversion_Set_Input_ = {
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Esrs_AssessmentCurrencyConversion_Stddev_Fields_ = {
  __typename?: 'esrs_AssessmentCurrencyConversion_stddev_fields';
  rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_pop on columns */
export type Esrs_AssessmentCurrencyConversion_Stddev_Pop_Fields_ = {
  __typename?: 'esrs_AssessmentCurrencyConversion_stddev_pop_fields';
  rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddev_samp on columns */
export type Esrs_AssessmentCurrencyConversion_Stddev_Samp_Fields_ = {
  __typename?: 'esrs_AssessmentCurrencyConversion_stddev_samp_fields';
  rate?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "esrs_AssessmentCurrencyConversion" */
export type Esrs_AssessmentCurrencyConversion_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_AssessmentCurrencyConversion_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_AssessmentCurrencyConversion_Stream_Cursor_Value_Input_ = {
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['numeric']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Esrs_AssessmentCurrencyConversion_Sum_Fields_ = {
  __typename?: 'esrs_AssessmentCurrencyConversion_sum_fields';
  rate?: Maybe<Scalars['numeric']['output']>;
};

/** update columns of table "esrs.AssessmentCurrencyConversion" */
export enum Esrs_AssessmentCurrencyConversion_Update_Column_ {
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  From_ = 'from',
  /** column name */
  Rate_ = 'rate',
  /** column name */
  To_ = 'to'
}

export type Esrs_AssessmentCurrencyConversion_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Esrs_AssessmentCurrencyConversion_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_AssessmentCurrencyConversion_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_AssessmentCurrencyConversion_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type Esrs_AssessmentCurrencyConversion_Var_Pop_Fields_ = {
  __typename?: 'esrs_AssessmentCurrencyConversion_var_pop_fields';
  rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate var_samp on columns */
export type Esrs_AssessmentCurrencyConversion_Var_Samp_Fields_ = {
  __typename?: 'esrs_AssessmentCurrencyConversion_var_samp_fields';
  rate?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type Esrs_AssessmentCurrencyConversion_Variance_Fields_ = {
  __typename?: 'esrs_AssessmentCurrencyConversion_variance_fields';
  rate?: Maybe<Scalars['Float']['output']>;
};

/** (user input data): These are the results that the targets are aiming for in different periods.  */
export type Esrs_Baseline_ = {
  __typename?: 'esrs_Baseline';
  /** when's your starting point */
  baseYear?: Maybe<Scalars['date']['output']>;
  /** the value you have at the starting point */
  baseline?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isFlagged: Scalars['Boolean']['output'];
  /** An object relationship */
  reportingUnit?: Maybe<Esrs_ReportingUnit_>;
  /** business unit esrs assessment id */
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  target: Esrs_Target_;
  targetId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "esrs.Baseline" */
export type Esrs_Baseline_Aggregate_ = {
  __typename?: 'esrs_Baseline_aggregate';
  aggregate?: Maybe<Esrs_Baseline_Aggregate_Fields_>;
  nodes: Array<Esrs_Baseline_>;
};

export type Esrs_Baseline_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Esrs_Baseline_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Esrs_Baseline_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Esrs_Baseline_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_Baseline_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Esrs_Baseline_Select_Column_Esrs_Baseline_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Baseline_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_Baseline_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Esrs_Baseline_Select_Column_Esrs_Baseline_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Baseline_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_Baseline_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_Baseline_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Baseline_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.Baseline" */
export type Esrs_Baseline_Aggregate_Fields_ = {
  __typename?: 'esrs_Baseline_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_Baseline_Max_Fields_>;
  min?: Maybe<Esrs_Baseline_Min_Fields_>;
};


/** aggregate fields of "esrs.Baseline" */
export type Esrs_Baseline_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_Baseline_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.Baseline" */
export type Esrs_Baseline_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_Baseline_Max_Order_By_>;
  min?: InputMaybe<Esrs_Baseline_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.Baseline" */
export type Esrs_Baseline_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_Baseline_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_Baseline_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.Baseline". All fields are combined with a logical 'AND'. */
export type Esrs_Baseline_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_Baseline_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_Baseline_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_Baseline_Bool_Exp_>>;
  baseYear?: InputMaybe<Date_Comparison_Exp_>;
  baseline?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isFlagged?: InputMaybe<Boolean_Comparison_Exp_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
  reportingUnitId?: InputMaybe<Uuid_Comparison_Exp_>;
  target?: InputMaybe<Esrs_Target_Bool_Exp_>;
  targetId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.Baseline" */
export enum Esrs_Baseline_Constraint_ {
  /** unique or primary key constraint on columns "targetId", "reportingUnitId" */
  KeyResultBusinessUnitAssessmentIdTargetIdKey_ = 'KeyResult_businessUnitAssessmentId_targetId_key',
  /** unique or primary key constraint on columns "id" */
  KeyResultPkey_ = 'KeyResult_pkey'
}

/** input type for inserting data into table "esrs.Baseline" */
export type Esrs_Baseline_Insert_Input_ = {
  /** when's your starting point */
  baseYear?: InputMaybe<Scalars['date']['input']>;
  /** the value you have at the starting point */
  baseline?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isFlagged?: InputMaybe<Scalars['Boolean']['input']>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Obj_Rel_Insert_Input_>;
  /** business unit esrs assessment id */
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  target?: InputMaybe<Esrs_Target_Obj_Rel_Insert_Input_>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_Baseline_Max_Fields_ = {
  __typename?: 'esrs_Baseline_max_fields';
  /** when's your starting point */
  baseYear?: Maybe<Scalars['date']['output']>;
  /** the value you have at the starting point */
  baseline?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** business unit esrs assessment id */
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  targetId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.Baseline" */
export type Esrs_Baseline_Max_Order_By_ = {
  /** when's your starting point */
  baseYear?: InputMaybe<Order_By_>;
  /** the value you have at the starting point */
  baseline?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  /** business unit esrs assessment id */
  reportingUnitId?: InputMaybe<Order_By_>;
  targetId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_Baseline_Min_Fields_ = {
  __typename?: 'esrs_Baseline_min_fields';
  /** when's your starting point */
  baseYear?: Maybe<Scalars['date']['output']>;
  /** the value you have at the starting point */
  baseline?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** business unit esrs assessment id */
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  targetId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.Baseline" */
export type Esrs_Baseline_Min_Order_By_ = {
  /** when's your starting point */
  baseYear?: InputMaybe<Order_By_>;
  /** the value you have at the starting point */
  baseline?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  /** business unit esrs assessment id */
  reportingUnitId?: InputMaybe<Order_By_>;
  targetId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.Baseline" */
export type Esrs_Baseline_Mutation_Response_ = {
  __typename?: 'esrs_Baseline_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_Baseline_>;
};

/** on_conflict condition type for table "esrs.Baseline" */
export type Esrs_Baseline_On_Conflict_ = {
  constraint: Esrs_Baseline_Constraint_;
  update_columns?: Array<Esrs_Baseline_Update_Column_>;
  where?: InputMaybe<Esrs_Baseline_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.Baseline". */
export type Esrs_Baseline_Order_By_ = {
  baseYear?: InputMaybe<Order_By_>;
  baseline?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isFlagged?: InputMaybe<Order_By_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  target?: InputMaybe<Esrs_Target_Order_By_>;
  targetId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.Baseline */
export type Esrs_Baseline_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.Baseline" */
export enum Esrs_Baseline_Select_Column_ {
  /** column name */
  BaseYear_ = 'baseYear',
  /** column name */
  Baseline_ = 'baseline',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsFlagged_ = 'isFlagged',
  /** column name */
  ReportingUnitId_ = 'reportingUnitId',
  /** column name */
  TargetId_ = 'targetId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "esrs_Baseline_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.Baseline" */
export enum Esrs_Baseline_Select_Column_Esrs_Baseline_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsFlagged_ = 'isFlagged'
}

/** select "esrs_Baseline_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.Baseline" */
export enum Esrs_Baseline_Select_Column_Esrs_Baseline_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsFlagged_ = 'isFlagged'
}

/** input type for updating data in table "esrs.Baseline" */
export type Esrs_Baseline_Set_Input_ = {
  /** when's your starting point */
  baseYear?: InputMaybe<Scalars['date']['input']>;
  /** the value you have at the starting point */
  baseline?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isFlagged?: InputMaybe<Scalars['Boolean']['input']>;
  /** business unit esrs assessment id */
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_Baseline" */
export type Esrs_Baseline_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_Baseline_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_Baseline_Stream_Cursor_Value_Input_ = {
  /** when's your starting point */
  baseYear?: InputMaybe<Scalars['date']['input']>;
  /** the value you have at the starting point */
  baseline?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isFlagged?: InputMaybe<Scalars['Boolean']['input']>;
  /** business unit esrs assessment id */
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.Baseline" */
export enum Esrs_Baseline_Update_Column_ {
  /** column name */
  BaseYear_ = 'baseYear',
  /** column name */
  Baseline_ = 'baseline',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsFlagged_ = 'isFlagged',
  /** column name */
  ReportingUnitId_ = 'reportingUnitId',
  /** column name */
  TargetId_ = 'targetId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_Baseline_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_Baseline_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_Baseline_Bool_Exp_;
};

/** columns and relationships of "esrs.CompanyIntegration" */
export type Esrs_CompanyIntegration_ = {
  __typename?: 'esrs_CompanyIntegration';
  apiKey?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  company: Company_;
  companyId: Scalars['uuid']['output'];
  /** An array relationship */
  esrsAssessmentCompanyIntegration: Array<Esrs_EsrsAssessmentCompanyIntegration_>;
  /** An aggregate relationship */
  esrsAssessmentCompanyIntegration_aggregate: Esrs_EsrsAssessmentCompanyIntegration_Aggregate_;
  id: Scalars['uuid']['output'];
  integrationSystemName: Scalars['String']['output'];
  isDisaggregated?: Maybe<Scalars['Boolean']['output']>;
};


/** columns and relationships of "esrs.CompanyIntegration" */
export type Esrs_CompanyIntegrationEsrsAssessmentCompanyIntegrationArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>;
};


/** columns and relationships of "esrs.CompanyIntegration" */
export type Esrs_CompanyIntegrationEsrsAssessmentCompanyIntegration_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>;
};

/** aggregated selection of "esrs.CompanyIntegration" */
export type Esrs_CompanyIntegration_Aggregate_ = {
  __typename?: 'esrs_CompanyIntegration_aggregate';
  aggregate?: Maybe<Esrs_CompanyIntegration_Aggregate_Fields_>;
  nodes: Array<Esrs_CompanyIntegration_>;
};

/** aggregate fields of "esrs.CompanyIntegration" */
export type Esrs_CompanyIntegration_Aggregate_Fields_ = {
  __typename?: 'esrs_CompanyIntegration_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_CompanyIntegration_Max_Fields_>;
  min?: Maybe<Esrs_CompanyIntegration_Min_Fields_>;
};


/** aggregate fields of "esrs.CompanyIntegration" */
export type Esrs_CompanyIntegration_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_CompanyIntegration_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "esrs.CompanyIntegration". All fields are combined with a logical 'AND'. */
export type Esrs_CompanyIntegration_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_CompanyIntegration_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_CompanyIntegration_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_CompanyIntegration_Bool_Exp_>>;
  apiKey?: InputMaybe<String_Comparison_Exp_>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  esrsAssessmentCompanyIntegration?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>;
  esrsAssessmentCompanyIntegration_aggregate?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Aggregate_Bool_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  integrationSystemName?: InputMaybe<String_Comparison_Exp_>;
  isDisaggregated?: InputMaybe<Boolean_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.CompanyIntegration" */
export enum Esrs_CompanyIntegration_Constraint_ {
  /** unique or primary key constraint on columns "apiKey", "integrationSystemName", "companyId" */
  CompanyIntegrationCompanyIdIntegrationSystemNameApiKeyKey_ = 'CompanyIntegration_companyId_integrationSystemName_apiKey_key',
  /** unique or primary key constraint on columns "id" */
  CompanyIntegrationPkey_ = 'CompanyIntegration_pkey'
}

/** input type for inserting data into table "esrs.CompanyIntegration" */
export type Esrs_CompanyIntegration_Insert_Input_ = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  esrsAssessmentCompanyIntegration?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Arr_Rel_Insert_Input_>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  integrationSystemName?: InputMaybe<Scalars['String']['input']>;
  isDisaggregated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate max on columns */
export type Esrs_CompanyIntegration_Max_Fields_ = {
  __typename?: 'esrs_CompanyIntegration_max_fields';
  apiKey?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  integrationSystemName?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Esrs_CompanyIntegration_Min_Fields_ = {
  __typename?: 'esrs_CompanyIntegration_min_fields';
  apiKey?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  integrationSystemName?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "esrs.CompanyIntegration" */
export type Esrs_CompanyIntegration_Mutation_Response_ = {
  __typename?: 'esrs_CompanyIntegration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_CompanyIntegration_>;
};

/** input type for inserting object relation for remote table "esrs.CompanyIntegration" */
export type Esrs_CompanyIntegration_Obj_Rel_Insert_Input_ = {
  data: Esrs_CompanyIntegration_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_CompanyIntegration_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.CompanyIntegration" */
export type Esrs_CompanyIntegration_On_Conflict_ = {
  constraint: Esrs_CompanyIntegration_Constraint_;
  update_columns?: Array<Esrs_CompanyIntegration_Update_Column_>;
  where?: InputMaybe<Esrs_CompanyIntegration_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.CompanyIntegration". */
export type Esrs_CompanyIntegration_Order_By_ = {
  apiKey?: InputMaybe<Order_By_>;
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  esrsAssessmentCompanyIntegration_aggregate?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Aggregate_Order_By_>;
  id?: InputMaybe<Order_By_>;
  integrationSystemName?: InputMaybe<Order_By_>;
  isDisaggregated?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.CompanyIntegration */
export type Esrs_CompanyIntegration_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.CompanyIntegration" */
export enum Esrs_CompanyIntegration_Select_Column_ {
  /** column name */
  ApiKey_ = 'apiKey',
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  Id_ = 'id',
  /** column name */
  IntegrationSystemName_ = 'integrationSystemName',
  /** column name */
  IsDisaggregated_ = 'isDisaggregated'
}

/** input type for updating data in table "esrs.CompanyIntegration" */
export type Esrs_CompanyIntegration_Set_Input_ = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  integrationSystemName?: InputMaybe<Scalars['String']['input']>;
  isDisaggregated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Streaming cursor of the table "esrs_CompanyIntegration" */
export type Esrs_CompanyIntegration_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_CompanyIntegration_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_CompanyIntegration_Stream_Cursor_Value_Input_ = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  integrationSystemName?: InputMaybe<Scalars['String']['input']>;
  isDisaggregated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** update columns of table "esrs.CompanyIntegration" */
export enum Esrs_CompanyIntegration_Update_Column_ {
  /** column name */
  ApiKey_ = 'apiKey',
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  Id_ = 'id',
  /** column name */
  IntegrationSystemName_ = 'integrationSystemName',
  /** column name */
  IsDisaggregated_ = 'isDisaggregated'
}

export type Esrs_CompanyIntegration_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_CompanyIntegration_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_CompanyIntegration_Bool_Exp_;
};

/** columns and relationships of "esrs.Datapoint" */
export type Esrs_Datapoint_ = {
  __typename?: 'esrs_Datapoint';
  /** An object relationship */
  answer: Esrs_Answer_;
  answerId: Scalars['uuid']['output'];
  /** An object relationship */
  author?: Maybe<Users_>;
  authorId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  datapointChoices: Array<Esrs_DatapointChoice_>;
  /** An aggregate relationship */
  datapointChoices_aggregate: Esrs_DatapointChoice_Aggregate_;
  /** An array relationship */
  datapointMdrms: Array<Esrs_DatapointMdrm_>;
  /** An aggregate relationship */
  datapointMdrms_aggregate: Esrs_DatapointMdrm_Aggregate_;
  /** An array relationship */
  datapointTags: Array<Esrs_DatapointTag_>;
  /** An aggregate relationship */
  datapointTags_aggregate: Esrs_DatapointTag_Aggregate_;
  factValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isMdrmDisclosed?: Maybe<Scalars['Boolean']['output']>;
  lastEdited?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  mdrmAnswers: Array<Esrs_Deprecated_EsrsMdrm_>;
  /** An aggregate relationship */
  mdrmAnswers_aggregate: Esrs_Deprecated_EsrsMdrm_Aggregate_;
  mdrmElsewhereDisclosure?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  owner?: Maybe<Users_>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  tagCombination?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  task?: Maybe<Task_>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  thread?: Maybe<Thread_>;
  timeframe: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  value?: Maybe<Scalars['String']['output']>;
};


/** columns and relationships of "esrs.Datapoint" */
export type Esrs_DatapointDatapointChoicesArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointChoice_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointChoice_Bool_Exp_>;
};


/** columns and relationships of "esrs.Datapoint" */
export type Esrs_DatapointDatapointChoices_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointChoice_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointChoice_Bool_Exp_>;
};


/** columns and relationships of "esrs.Datapoint" */
export type Esrs_DatapointDatapointMdrmsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointMdrm_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointMdrm_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointMdrm_Bool_Exp_>;
};


/** columns and relationships of "esrs.Datapoint" */
export type Esrs_DatapointDatapointMdrms_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointMdrm_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointMdrm_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointMdrm_Bool_Exp_>;
};


/** columns and relationships of "esrs.Datapoint" */
export type Esrs_DatapointDatapointTagsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointTag_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointTag_Bool_Exp_>;
};


/** columns and relationships of "esrs.Datapoint" */
export type Esrs_DatapointDatapointTags_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointTag_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointTag_Bool_Exp_>;
};


/** columns and relationships of "esrs.Datapoint" */
export type Esrs_DatapointMdrmAnswersArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Bool_Exp_>;
};


/** columns and relationships of "esrs.Datapoint" */
export type Esrs_DatapointMdrmAnswers_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Bool_Exp_>;
};


/** columns and relationships of "esrs.Datapoint" */
export type Esrs_DatapointMetadataArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "esrs.DatapointChoice" */
export type Esrs_DatapointChoice_ = {
  __typename?: 'esrs_DatapointChoice';
  /** An object relationship */
  choice: EsrsChoice_;
  choiceRef: Scalars['String']['output'];
  /** An object relationship */
  datapoint: Esrs_Datapoint_;
  datapointId: Scalars['uuid']['output'];
};

/** aggregated selection of "esrs.DatapointChoice" */
export type Esrs_DatapointChoice_Aggregate_ = {
  __typename?: 'esrs_DatapointChoice_aggregate';
  aggregate?: Maybe<Esrs_DatapointChoice_Aggregate_Fields_>;
  nodes: Array<Esrs_DatapointChoice_>;
};

export type Esrs_DatapointChoice_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Esrs_DatapointChoice_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_DatapointChoice_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_DatapointChoice_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_DatapointChoice_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.DatapointChoice" */
export type Esrs_DatapointChoice_Aggregate_Fields_ = {
  __typename?: 'esrs_DatapointChoice_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_DatapointChoice_Max_Fields_>;
  min?: Maybe<Esrs_DatapointChoice_Min_Fields_>;
};


/** aggregate fields of "esrs.DatapointChoice" */
export type Esrs_DatapointChoice_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_DatapointChoice_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.DatapointChoice" */
export type Esrs_DatapointChoice_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_DatapointChoice_Max_Order_By_>;
  min?: InputMaybe<Esrs_DatapointChoice_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.DatapointChoice" */
export type Esrs_DatapointChoice_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_DatapointChoice_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_DatapointChoice_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.DatapointChoice". All fields are combined with a logical 'AND'. */
export type Esrs_DatapointChoice_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_DatapointChoice_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_DatapointChoice_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_DatapointChoice_Bool_Exp_>>;
  choice?: InputMaybe<EsrsChoice_Bool_Exp_>;
  choiceRef?: InputMaybe<String_Comparison_Exp_>;
  datapoint?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
  datapointId?: InputMaybe<Uuid_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.DatapointChoice" */
export enum Esrs_DatapointChoice_Constraint_ {
  /** unique or primary key constraint on columns "choiceRef", "datapointId" */
  DatapointChoiceDatapointIdChoiceRefKey_ = 'DatapointChoice_datapointId_choiceRef_key',
  /** unique or primary key constraint on columns "choiceRef", "datapointId" */
  DatapointChoicePkey_ = 'DatapointChoice_pkey'
}

/** input type for inserting data into table "esrs.DatapointChoice" */
export type Esrs_DatapointChoice_Insert_Input_ = {
  choice?: InputMaybe<EsrsChoice_Obj_Rel_Insert_Input_>;
  choiceRef?: InputMaybe<Scalars['String']['input']>;
  datapoint?: InputMaybe<Esrs_Datapoint_Obj_Rel_Insert_Input_>;
  datapointId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Esrs_DatapointChoice_Max_Fields_ = {
  __typename?: 'esrs_DatapointChoice_max_fields';
  choiceRef?: Maybe<Scalars['String']['output']>;
  datapointId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "esrs.DatapointChoice" */
export type Esrs_DatapointChoice_Max_Order_By_ = {
  choiceRef?: InputMaybe<Order_By_>;
  datapointId?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_DatapointChoice_Min_Fields_ = {
  __typename?: 'esrs_DatapointChoice_min_fields';
  choiceRef?: Maybe<Scalars['String']['output']>;
  datapointId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "esrs.DatapointChoice" */
export type Esrs_DatapointChoice_Min_Order_By_ = {
  choiceRef?: InputMaybe<Order_By_>;
  datapointId?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.DatapointChoice" */
export type Esrs_DatapointChoice_Mutation_Response_ = {
  __typename?: 'esrs_DatapointChoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_DatapointChoice_>;
};

/** on_conflict condition type for table "esrs.DatapointChoice" */
export type Esrs_DatapointChoice_On_Conflict_ = {
  constraint: Esrs_DatapointChoice_Constraint_;
  update_columns?: Array<Esrs_DatapointChoice_Update_Column_>;
  where?: InputMaybe<Esrs_DatapointChoice_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.DatapointChoice". */
export type Esrs_DatapointChoice_Order_By_ = {
  choice?: InputMaybe<EsrsChoice_Order_By_>;
  choiceRef?: InputMaybe<Order_By_>;
  datapoint?: InputMaybe<Esrs_Datapoint_Order_By_>;
  datapointId?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.DatapointChoice */
export type Esrs_DatapointChoice_Pk_Columns_Input_ = {
  choiceRef: Scalars['String']['input'];
  datapointId: Scalars['uuid']['input'];
};

/** select columns of table "esrs.DatapointChoice" */
export enum Esrs_DatapointChoice_Select_Column_ {
  /** column name */
  ChoiceRef_ = 'choiceRef',
  /** column name */
  DatapointId_ = 'datapointId'
}

/** input type for updating data in table "esrs.DatapointChoice" */
export type Esrs_DatapointChoice_Set_Input_ = {
  choiceRef?: InputMaybe<Scalars['String']['input']>;
  datapointId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "esrs_DatapointChoice" */
export type Esrs_DatapointChoice_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_DatapointChoice_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_DatapointChoice_Stream_Cursor_Value_Input_ = {
  choiceRef?: InputMaybe<Scalars['String']['input']>;
  datapointId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "esrs.DatapointChoice" */
export enum Esrs_DatapointChoice_Update_Column_ {
  /** column name */
  ChoiceRef_ = 'choiceRef',
  /** column name */
  DatapointId_ = 'datapointId'
}

export type Esrs_DatapointChoice_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_DatapointChoice_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_DatapointChoice_Bool_Exp_;
};

/** columns and relationships of "esrs.DatapointMdrm" */
export type Esrs_DatapointMdrm_ = {
  __typename?: 'esrs_DatapointMdrm';
  /** An object relationship */
  author?: Maybe<Users_>;
  authorId?: Maybe<Scalars['uuid']['output']>;
  created_at: Scalars['timestamptz']['output'];
  /** An object relationship */
  datapoint: Esrs_Datapoint_;
  datapointId: Scalars['uuid']['output'];
  hasOptedOut: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  mdrmRef: Scalars['String']['output'];
  /** An object relationship */
  owner?: Maybe<Users_>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  task?: Maybe<Task_>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  thread?: Maybe<Thread_>;
  updated_at: Scalars['timestamptz']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "esrs.DatapointMdrm" */
export type Esrs_DatapointMdrm_Aggregate_ = {
  __typename?: 'esrs_DatapointMdrm_aggregate';
  aggregate?: Maybe<Esrs_DatapointMdrm_Aggregate_Fields_>;
  nodes: Array<Esrs_DatapointMdrm_>;
};

export type Esrs_DatapointMdrm_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Esrs_DatapointMdrm_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Esrs_DatapointMdrm_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Esrs_DatapointMdrm_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_DatapointMdrm_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Esrs_DatapointMdrm_Select_Column_Esrs_DatapointMdrm_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_DatapointMdrm_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_DatapointMdrm_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Esrs_DatapointMdrm_Select_Column_Esrs_DatapointMdrm_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_DatapointMdrm_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_DatapointMdrm_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_DatapointMdrm_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_DatapointMdrm_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.DatapointMdrm" */
export type Esrs_DatapointMdrm_Aggregate_Fields_ = {
  __typename?: 'esrs_DatapointMdrm_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_DatapointMdrm_Max_Fields_>;
  min?: Maybe<Esrs_DatapointMdrm_Min_Fields_>;
};


/** aggregate fields of "esrs.DatapointMdrm" */
export type Esrs_DatapointMdrm_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_DatapointMdrm_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.DatapointMdrm" */
export type Esrs_DatapointMdrm_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_DatapointMdrm_Max_Order_By_>;
  min?: InputMaybe<Esrs_DatapointMdrm_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.DatapointMdrm" */
export type Esrs_DatapointMdrm_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_DatapointMdrm_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_DatapointMdrm_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.DatapointMdrm". All fields are combined with a logical 'AND'. */
export type Esrs_DatapointMdrm_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_DatapointMdrm_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_DatapointMdrm_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_DatapointMdrm_Bool_Exp_>>;
  author?: InputMaybe<Users_Bool_Exp_>;
  authorId?: InputMaybe<Uuid_Comparison_Exp_>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp_>;
  datapoint?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
  datapointId?: InputMaybe<Uuid_Comparison_Exp_>;
  hasOptedOut?: InputMaybe<Boolean_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  mdrmRef?: InputMaybe<String_Comparison_Exp_>;
  owner?: InputMaybe<Users_Bool_Exp_>;
  ownerId?: InputMaybe<Uuid_Comparison_Exp_>;
  task?: InputMaybe<Task_Bool_Exp_>;
  taskId?: InputMaybe<Uuid_Comparison_Exp_>;
  thread?: InputMaybe<Thread_Bool_Exp_>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp_>;
  value?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.DatapointMdrm" */
export enum Esrs_DatapointMdrm_Constraint_ {
  /** unique or primary key constraint on columns "mdrmRef", "datapointId" */
  DatapointMdrmDatapointIdMdrmRefKey_ = 'DatapointMdrm_datapointId_mdrmRef_key',
  /** unique or primary key constraint on columns "id" */
  DatapointMdrmIdKey_ = 'DatapointMdrm_id_key',
  /** unique or primary key constraint on columns "id" */
  DatapointMdrmPkey_ = 'DatapointMdrm_pkey'
}

/** input type for inserting data into table "esrs.DatapointMdrm" */
export type Esrs_DatapointMdrm_Insert_Input_ = {
  author?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  datapoint?: InputMaybe<Esrs_Datapoint_Obj_Rel_Insert_Input_>;
  datapointId?: InputMaybe<Scalars['uuid']['input']>;
  hasOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mdrmRef?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  task?: InputMaybe<Task_Obj_Rel_Insert_Input_>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  thread?: InputMaybe<Thread_Obj_Rel_Insert_Input_>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Esrs_DatapointMdrm_Max_Fields_ = {
  __typename?: 'esrs_DatapointMdrm_max_fields';
  authorId?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  datapointId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mdrmRef?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.DatapointMdrm" */
export type Esrs_DatapointMdrm_Max_Order_By_ = {
  authorId?: InputMaybe<Order_By_>;
  created_at?: InputMaybe<Order_By_>;
  datapointId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  mdrmRef?: InputMaybe<Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  taskId?: InputMaybe<Order_By_>;
  updated_at?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_DatapointMdrm_Min_Fields_ = {
  __typename?: 'esrs_DatapointMdrm_min_fields';
  authorId?: Maybe<Scalars['uuid']['output']>;
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  datapointId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mdrmRef?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.DatapointMdrm" */
export type Esrs_DatapointMdrm_Min_Order_By_ = {
  authorId?: InputMaybe<Order_By_>;
  created_at?: InputMaybe<Order_By_>;
  datapointId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  mdrmRef?: InputMaybe<Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  taskId?: InputMaybe<Order_By_>;
  updated_at?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.DatapointMdrm" */
export type Esrs_DatapointMdrm_Mutation_Response_ = {
  __typename?: 'esrs_DatapointMdrm_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_DatapointMdrm_>;
};

/** input type for inserting object relation for remote table "esrs.DatapointMdrm" */
export type Esrs_DatapointMdrm_Obj_Rel_Insert_Input_ = {
  data: Esrs_DatapointMdrm_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_DatapointMdrm_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.DatapointMdrm" */
export type Esrs_DatapointMdrm_On_Conflict_ = {
  constraint: Esrs_DatapointMdrm_Constraint_;
  update_columns?: Array<Esrs_DatapointMdrm_Update_Column_>;
  where?: InputMaybe<Esrs_DatapointMdrm_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.DatapointMdrm". */
export type Esrs_DatapointMdrm_Order_By_ = {
  author?: InputMaybe<Users_Order_By_>;
  authorId?: InputMaybe<Order_By_>;
  created_at?: InputMaybe<Order_By_>;
  datapoint?: InputMaybe<Esrs_Datapoint_Order_By_>;
  datapointId?: InputMaybe<Order_By_>;
  hasOptedOut?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  mdrmRef?: InputMaybe<Order_By_>;
  owner?: InputMaybe<Users_Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  task?: InputMaybe<Task_Order_By_>;
  taskId?: InputMaybe<Order_By_>;
  thread?: InputMaybe<Thread_Order_By_>;
  updated_at?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.DatapointMdrm */
export type Esrs_DatapointMdrm_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.DatapointMdrm" */
export enum Esrs_DatapointMdrm_Select_Column_ {
  /** column name */
  AuthorId_ = 'authorId',
  /** column name */
  CreatedAt_ = 'created_at',
  /** column name */
  DatapointId_ = 'datapointId',
  /** column name */
  HasOptedOut_ = 'hasOptedOut',
  /** column name */
  Id_ = 'id',
  /** column name */
  MdrmRef_ = 'mdrmRef',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  TaskId_ = 'taskId',
  /** column name */
  UpdatedAt_ = 'updated_at',
  /** column name */
  Value_ = 'value'
}

/** select "esrs_DatapointMdrm_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.DatapointMdrm" */
export enum Esrs_DatapointMdrm_Select_Column_Esrs_DatapointMdrm_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  HasOptedOut_ = 'hasOptedOut'
}

/** select "esrs_DatapointMdrm_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.DatapointMdrm" */
export enum Esrs_DatapointMdrm_Select_Column_Esrs_DatapointMdrm_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  HasOptedOut_ = 'hasOptedOut'
}

/** input type for updating data in table "esrs.DatapointMdrm" */
export type Esrs_DatapointMdrm_Set_Input_ = {
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  datapointId?: InputMaybe<Scalars['uuid']['input']>;
  hasOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mdrmRef?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "esrs_DatapointMdrm" */
export type Esrs_DatapointMdrm_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_DatapointMdrm_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_DatapointMdrm_Stream_Cursor_Value_Input_ = {
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  datapointId?: InputMaybe<Scalars['uuid']['input']>;
  hasOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mdrmRef?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.DatapointMdrm" */
export enum Esrs_DatapointMdrm_Update_Column_ {
  /** column name */
  AuthorId_ = 'authorId',
  /** column name */
  CreatedAt_ = 'created_at',
  /** column name */
  DatapointId_ = 'datapointId',
  /** column name */
  HasOptedOut_ = 'hasOptedOut',
  /** column name */
  Id_ = 'id',
  /** column name */
  MdrmRef_ = 'mdrmRef',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  TaskId_ = 'taskId',
  /** column name */
  UpdatedAt_ = 'updated_at',
  /** column name */
  Value_ = 'value'
}

export type Esrs_DatapointMdrm_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_DatapointMdrm_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_DatapointMdrm_Bool_Exp_;
};

/** columns and relationships of "esrs.DatapointTag" */
export type Esrs_DatapointTag_ = {
  __typename?: 'esrs_DatapointTag';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  datapoint: Esrs_Datapoint_;
  datapointId: Scalars['uuid']['output'];
  /** An object relationship */
  datapointTagValue: TagValue_;
  id: Scalars['uuid']['output'];
  tagType: Scalars['String']['output'];
  tagValue: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "esrs.DatapointTag" */
export type Esrs_DatapointTag_Aggregate_ = {
  __typename?: 'esrs_DatapointTag_aggregate';
  aggregate?: Maybe<Esrs_DatapointTag_Aggregate_Fields_>;
  nodes: Array<Esrs_DatapointTag_>;
};

export type Esrs_DatapointTag_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Esrs_DatapointTag_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_DatapointTag_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_DatapointTag_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_DatapointTag_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.DatapointTag" */
export type Esrs_DatapointTag_Aggregate_Fields_ = {
  __typename?: 'esrs_DatapointTag_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_DatapointTag_Max_Fields_>;
  min?: Maybe<Esrs_DatapointTag_Min_Fields_>;
};


/** aggregate fields of "esrs.DatapointTag" */
export type Esrs_DatapointTag_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_DatapointTag_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.DatapointTag" */
export type Esrs_DatapointTag_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_DatapointTag_Max_Order_By_>;
  min?: InputMaybe<Esrs_DatapointTag_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.DatapointTag" */
export type Esrs_DatapointTag_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_DatapointTag_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_DatapointTag_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.DatapointTag". All fields are combined with a logical 'AND'. */
export type Esrs_DatapointTag_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_DatapointTag_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_DatapointTag_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_DatapointTag_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  datapoint?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
  datapointId?: InputMaybe<Uuid_Comparison_Exp_>;
  datapointTagValue?: InputMaybe<TagValue_Bool_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  tagType?: InputMaybe<String_Comparison_Exp_>;
  tagValue?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.DatapointTag" */
export enum Esrs_DatapointTag_Constraint_ {
  /** unique or primary key constraint on columns "tagValue", "tagType", "datapointId" */
  DatapointTagDatapointIdTagValueTagTypeKey_ = 'DatapointTag_datapointId_tagValue_tagType_key',
  /** unique or primary key constraint on columns "id" */
  DatapointTagPkey_ = 'DatapointTag_pkey'
}

/** input type for inserting data into table "esrs.DatapointTag" */
export type Esrs_DatapointTag_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  datapoint?: InputMaybe<Esrs_Datapoint_Obj_Rel_Insert_Input_>;
  datapointId?: InputMaybe<Scalars['uuid']['input']>;
  datapointTagValue?: InputMaybe<TagValue_Obj_Rel_Insert_Input_>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tagValue?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_DatapointTag_Max_Fields_ = {
  __typename?: 'esrs_DatapointTag_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  datapointId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tagType?: Maybe<Scalars['String']['output']>;
  tagValue?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.DatapointTag" */
export type Esrs_DatapointTag_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  datapointId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  tagType?: InputMaybe<Order_By_>;
  tagValue?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_DatapointTag_Min_Fields_ = {
  __typename?: 'esrs_DatapointTag_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  datapointId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tagType?: Maybe<Scalars['String']['output']>;
  tagValue?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.DatapointTag" */
export type Esrs_DatapointTag_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  datapointId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  tagType?: InputMaybe<Order_By_>;
  tagValue?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.DatapointTag" */
export type Esrs_DatapointTag_Mutation_Response_ = {
  __typename?: 'esrs_DatapointTag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_DatapointTag_>;
};

/** on_conflict condition type for table "esrs.DatapointTag" */
export type Esrs_DatapointTag_On_Conflict_ = {
  constraint: Esrs_DatapointTag_Constraint_;
  update_columns?: Array<Esrs_DatapointTag_Update_Column_>;
  where?: InputMaybe<Esrs_DatapointTag_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.DatapointTag". */
export type Esrs_DatapointTag_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  datapoint?: InputMaybe<Esrs_Datapoint_Order_By_>;
  datapointId?: InputMaybe<Order_By_>;
  datapointTagValue?: InputMaybe<TagValue_Order_By_>;
  id?: InputMaybe<Order_By_>;
  tagType?: InputMaybe<Order_By_>;
  tagValue?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.DatapointTag */
export type Esrs_DatapointTag_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.DatapointTag" */
export enum Esrs_DatapointTag_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DatapointId_ = 'datapointId',
  /** column name */
  Id_ = 'id',
  /** column name */
  TagType_ = 'tagType',
  /** column name */
  TagValue_ = 'tagValue',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "esrs.DatapointTag" */
export type Esrs_DatapointTag_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  datapointId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tagValue?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_DatapointTag" */
export type Esrs_DatapointTag_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_DatapointTag_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_DatapointTag_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  datapointId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tagValue?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.DatapointTag" */
export enum Esrs_DatapointTag_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DatapointId_ = 'datapointId',
  /** column name */
  Id_ = 'id',
  /** column name */
  TagType_ = 'tagType',
  /** column name */
  TagValue_ = 'tagValue',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_DatapointTag_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_DatapointTag_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_DatapointTag_Bool_Exp_;
};

/** aggregated selection of "esrs.Datapoint" */
export type Esrs_Datapoint_Aggregate_ = {
  __typename?: 'esrs_Datapoint_aggregate';
  aggregate?: Maybe<Esrs_Datapoint_Aggregate_Fields_>;
  nodes: Array<Esrs_Datapoint_>;
};

export type Esrs_Datapoint_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Esrs_Datapoint_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Esrs_Datapoint_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Esrs_Datapoint_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_Datapoint_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Esrs_Datapoint_Select_Column_Esrs_Datapoint_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_Datapoint_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Esrs_Datapoint_Select_Column_Esrs_Datapoint_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_Datapoint_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_Datapoint_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.Datapoint" */
export type Esrs_Datapoint_Aggregate_Fields_ = {
  __typename?: 'esrs_Datapoint_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_Datapoint_Max_Fields_>;
  min?: Maybe<Esrs_Datapoint_Min_Fields_>;
};


/** aggregate fields of "esrs.Datapoint" */
export type Esrs_Datapoint_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_Datapoint_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.Datapoint" */
export type Esrs_Datapoint_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_Datapoint_Max_Order_By_>;
  min?: InputMaybe<Esrs_Datapoint_Min_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Esrs_Datapoint_Append_Input_ = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "esrs.Datapoint" */
export type Esrs_Datapoint_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_Datapoint_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_Datapoint_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.Datapoint". All fields are combined with a logical 'AND'. */
export type Esrs_Datapoint_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_Datapoint_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_Datapoint_Bool_Exp_>>;
  answer?: InputMaybe<Esrs_Answer_Bool_Exp_>;
  answerId?: InputMaybe<Uuid_Comparison_Exp_>;
  author?: InputMaybe<Users_Bool_Exp_>;
  authorId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  datapointChoices?: InputMaybe<Esrs_DatapointChoice_Bool_Exp_>;
  datapointChoices_aggregate?: InputMaybe<Esrs_DatapointChoice_Aggregate_Bool_Exp_>;
  datapointMdrms?: InputMaybe<Esrs_DatapointMdrm_Bool_Exp_>;
  datapointMdrms_aggregate?: InputMaybe<Esrs_DatapointMdrm_Aggregate_Bool_Exp_>;
  datapointTags?: InputMaybe<Esrs_DatapointTag_Bool_Exp_>;
  datapointTags_aggregate?: InputMaybe<Esrs_DatapointTag_Aggregate_Bool_Exp_>;
  factValue?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isMdrmDisclosed?: InputMaybe<Boolean_Comparison_Exp_>;
  lastEdited?: InputMaybe<Timestamptz_Comparison_Exp_>;
  mdrmAnswers?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Bool_Exp_>;
  mdrmAnswers_aggregate?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Aggregate_Bool_Exp_>;
  mdrmElsewhereDisclosure?: InputMaybe<String_Comparison_Exp_>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp_>;
  owner?: InputMaybe<Users_Bool_Exp_>;
  ownerId?: InputMaybe<Uuid_Comparison_Exp_>;
  source?: InputMaybe<String_Comparison_Exp_>;
  tagCombination?: InputMaybe<String_Comparison_Exp_>;
  task?: InputMaybe<Task_Bool_Exp_>;
  taskId?: InputMaybe<Uuid_Comparison_Exp_>;
  thread?: InputMaybe<Thread_Bool_Exp_>;
  timeframe?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  value?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.Datapoint" */
export enum Esrs_Datapoint_Constraint_ {
  /** unique or primary key constraint on columns "timeframe", "answerId", "tagCombination" */
  DatapointAnswerIdTimeframeTagCombinationKey_ = 'Datapoint_answerId_timeframe_tagCombination_key',
  /** unique or primary key constraint on columns "id" */
  DatapointPkey_ = 'Datapoint_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Esrs_Datapoint_Delete_At_Path_Input_ = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Esrs_Datapoint_Delete_Elem_Input_ = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Esrs_Datapoint_Delete_Key_Input_ = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "esrs.Datapoint" */
export type Esrs_Datapoint_Insert_Input_ = {
  answer?: InputMaybe<Esrs_Answer_Obj_Rel_Insert_Input_>;
  answerId?: InputMaybe<Scalars['uuid']['input']>;
  author?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  datapointChoices?: InputMaybe<Esrs_DatapointChoice_Arr_Rel_Insert_Input_>;
  datapointMdrms?: InputMaybe<Esrs_DatapointMdrm_Arr_Rel_Insert_Input_>;
  datapointTags?: InputMaybe<Esrs_DatapointTag_Arr_Rel_Insert_Input_>;
  factValue?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isMdrmDisclosed?: InputMaybe<Scalars['Boolean']['input']>;
  lastEdited?: InputMaybe<Scalars['timestamptz']['input']>;
  mdrmAnswers?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Arr_Rel_Insert_Input_>;
  mdrmElsewhereDisclosure?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  owner?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tagCombination?: InputMaybe<Scalars['String']['input']>;
  task?: InputMaybe<Task_Obj_Rel_Insert_Input_>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  thread?: InputMaybe<Thread_Obj_Rel_Insert_Input_>;
  timeframe?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Esrs_Datapoint_Max_Fields_ = {
  __typename?: 'esrs_Datapoint_max_fields';
  answerId?: Maybe<Scalars['uuid']['output']>;
  authorId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  factValue?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastEdited?: Maybe<Scalars['timestamptz']['output']>;
  mdrmElsewhereDisclosure?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  tagCombination?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  timeframe?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.Datapoint" */
export type Esrs_Datapoint_Max_Order_By_ = {
  answerId?: InputMaybe<Order_By_>;
  authorId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  factValue?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  lastEdited?: InputMaybe<Order_By_>;
  mdrmElsewhereDisclosure?: InputMaybe<Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  source?: InputMaybe<Order_By_>;
  tagCombination?: InputMaybe<Order_By_>;
  taskId?: InputMaybe<Order_By_>;
  timeframe?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_Datapoint_Min_Fields_ = {
  __typename?: 'esrs_Datapoint_min_fields';
  answerId?: Maybe<Scalars['uuid']['output']>;
  authorId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  factValue?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastEdited?: Maybe<Scalars['timestamptz']['output']>;
  mdrmElsewhereDisclosure?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  tagCombination?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  timeframe?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.Datapoint" */
export type Esrs_Datapoint_Min_Order_By_ = {
  answerId?: InputMaybe<Order_By_>;
  authorId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  factValue?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  lastEdited?: InputMaybe<Order_By_>;
  mdrmElsewhereDisclosure?: InputMaybe<Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  source?: InputMaybe<Order_By_>;
  tagCombination?: InputMaybe<Order_By_>;
  taskId?: InputMaybe<Order_By_>;
  timeframe?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.Datapoint" */
export type Esrs_Datapoint_Mutation_Response_ = {
  __typename?: 'esrs_Datapoint_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_Datapoint_>;
};

/** input type for inserting object relation for remote table "esrs.Datapoint" */
export type Esrs_Datapoint_Obj_Rel_Insert_Input_ = {
  data: Esrs_Datapoint_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_Datapoint_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.Datapoint" */
export type Esrs_Datapoint_On_Conflict_ = {
  constraint: Esrs_Datapoint_Constraint_;
  update_columns?: Array<Esrs_Datapoint_Update_Column_>;
  where?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.Datapoint". */
export type Esrs_Datapoint_Order_By_ = {
  answer?: InputMaybe<Esrs_Answer_Order_By_>;
  answerId?: InputMaybe<Order_By_>;
  author?: InputMaybe<Users_Order_By_>;
  authorId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  datapointChoices_aggregate?: InputMaybe<Esrs_DatapointChoice_Aggregate_Order_By_>;
  datapointMdrms_aggregate?: InputMaybe<Esrs_DatapointMdrm_Aggregate_Order_By_>;
  datapointTags_aggregate?: InputMaybe<Esrs_DatapointTag_Aggregate_Order_By_>;
  factValue?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isMdrmDisclosed?: InputMaybe<Order_By_>;
  lastEdited?: InputMaybe<Order_By_>;
  mdrmAnswers_aggregate?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Aggregate_Order_By_>;
  mdrmElsewhereDisclosure?: InputMaybe<Order_By_>;
  metadata?: InputMaybe<Order_By_>;
  owner?: InputMaybe<Users_Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  source?: InputMaybe<Order_By_>;
  tagCombination?: InputMaybe<Order_By_>;
  task?: InputMaybe<Task_Order_By_>;
  taskId?: InputMaybe<Order_By_>;
  thread?: InputMaybe<Thread_Order_By_>;
  timeframe?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.Datapoint */
export type Esrs_Datapoint_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Esrs_Datapoint_Prepend_Input_ = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "esrs.Datapoint" */
export enum Esrs_Datapoint_Select_Column_ {
  /** column name */
  AnswerId_ = 'answerId',
  /** column name */
  AuthorId_ = 'authorId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  FactValue_ = 'factValue',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsMdrmDisclosed_ = 'isMdrmDisclosed',
  /** column name */
  LastEdited_ = 'lastEdited',
  /** column name */
  MdrmElsewhereDisclosure_ = 'mdrmElsewhereDisclosure',
  /** column name */
  Metadata_ = 'metadata',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  Source_ = 'source',
  /** column name */
  TagCombination_ = 'tagCombination',
  /** column name */
  TaskId_ = 'taskId',
  /** column name */
  Timeframe_ = 'timeframe',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Value_ = 'value'
}

/** select "esrs_Datapoint_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.Datapoint" */
export enum Esrs_Datapoint_Select_Column_Esrs_Datapoint_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsMdrmDisclosed_ = 'isMdrmDisclosed'
}

/** select "esrs_Datapoint_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.Datapoint" */
export enum Esrs_Datapoint_Select_Column_Esrs_Datapoint_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsMdrmDisclosed_ = 'isMdrmDisclosed'
}

/** input type for updating data in table "esrs.Datapoint" */
export type Esrs_Datapoint_Set_Input_ = {
  answerId?: InputMaybe<Scalars['uuid']['input']>;
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  factValue?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isMdrmDisclosed?: InputMaybe<Scalars['Boolean']['input']>;
  lastEdited?: InputMaybe<Scalars['timestamptz']['input']>;
  mdrmElsewhereDisclosure?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tagCombination?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  timeframe?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "esrs_Datapoint" */
export type Esrs_Datapoint_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_Datapoint_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_Datapoint_Stream_Cursor_Value_Input_ = {
  answerId?: InputMaybe<Scalars['uuid']['input']>;
  authorId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  factValue?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isMdrmDisclosed?: InputMaybe<Scalars['Boolean']['input']>;
  lastEdited?: InputMaybe<Scalars['timestamptz']['input']>;
  mdrmElsewhereDisclosure?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  tagCombination?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  timeframe?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.Datapoint" */
export enum Esrs_Datapoint_Update_Column_ {
  /** column name */
  AnswerId_ = 'answerId',
  /** column name */
  AuthorId_ = 'authorId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  FactValue_ = 'factValue',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsMdrmDisclosed_ = 'isMdrmDisclosed',
  /** column name */
  LastEdited_ = 'lastEdited',
  /** column name */
  MdrmElsewhereDisclosure_ = 'mdrmElsewhereDisclosure',
  /** column name */
  Metadata_ = 'metadata',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  Source_ = 'source',
  /** column name */
  TagCombination_ = 'tagCombination',
  /** column name */
  TaskId_ = 'taskId',
  /** column name */
  Timeframe_ = 'timeframe',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Value_ = 'value'
}

export type Esrs_Datapoint_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Esrs_Datapoint_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Esrs_Datapoint_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Esrs_Datapoint_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Esrs_Datapoint_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Esrs_Datapoint_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_Datapoint_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_Datapoint_Bool_Exp_;
};

/** (user input data): This table is for linking business units to the actions, each action can have many ESRS business units related to it. It's a many to many relationship. */
export type Esrs_Deprecated_ActionBusinessUnit_ = {
  __typename?: 'esrs_Deprecated_ActionBusinessUnit';
  actionId: Scalars['uuid']['output'];
  /** BusinessUnitEsrsAssessment id */
  businessUnitId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "esrs.Deprecated_ActionBusinessUnit" */
export type Esrs_Deprecated_ActionBusinessUnit_Aggregate_ = {
  __typename?: 'esrs_Deprecated_ActionBusinessUnit_aggregate';
  aggregate?: Maybe<Esrs_Deprecated_ActionBusinessUnit_Aggregate_Fields_>;
  nodes: Array<Esrs_Deprecated_ActionBusinessUnit_>;
};

/** aggregate fields of "esrs.Deprecated_ActionBusinessUnit" */
export type Esrs_Deprecated_ActionBusinessUnit_Aggregate_Fields_ = {
  __typename?: 'esrs_Deprecated_ActionBusinessUnit_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_Deprecated_ActionBusinessUnit_Max_Fields_>;
  min?: Maybe<Esrs_Deprecated_ActionBusinessUnit_Min_Fields_>;
};


/** aggregate fields of "esrs.Deprecated_ActionBusinessUnit" */
export type Esrs_Deprecated_ActionBusinessUnit_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_Deprecated_ActionBusinessUnit_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "esrs.Deprecated_ActionBusinessUnit". All fields are combined with a logical 'AND'. */
export type Esrs_Deprecated_ActionBusinessUnit_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_Deprecated_ActionBusinessUnit_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_Deprecated_ActionBusinessUnit_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_Deprecated_ActionBusinessUnit_Bool_Exp_>>;
  actionId?: InputMaybe<Uuid_Comparison_Exp_>;
  businessUnitId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.Deprecated_ActionBusinessUnit" */
export enum Esrs_Deprecated_ActionBusinessUnit_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  ActionBusinessUnitPkey_ = 'ActionBusinessUnit_pkey'
}

/** input type for inserting data into table "esrs.Deprecated_ActionBusinessUnit" */
export type Esrs_Deprecated_ActionBusinessUnit_Insert_Input_ = {
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  /** BusinessUnitEsrsAssessment id */
  businessUnitId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_Deprecated_ActionBusinessUnit_Max_Fields_ = {
  __typename?: 'esrs_Deprecated_ActionBusinessUnit_max_fields';
  actionId?: Maybe<Scalars['uuid']['output']>;
  /** BusinessUnitEsrsAssessment id */
  businessUnitId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Esrs_Deprecated_ActionBusinessUnit_Min_Fields_ = {
  __typename?: 'esrs_Deprecated_ActionBusinessUnit_min_fields';
  actionId?: Maybe<Scalars['uuid']['output']>;
  /** BusinessUnitEsrsAssessment id */
  businessUnitId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "esrs.Deprecated_ActionBusinessUnit" */
export type Esrs_Deprecated_ActionBusinessUnit_Mutation_Response_ = {
  __typename?: 'esrs_Deprecated_ActionBusinessUnit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_Deprecated_ActionBusinessUnit_>;
};

/** on_conflict condition type for table "esrs.Deprecated_ActionBusinessUnit" */
export type Esrs_Deprecated_ActionBusinessUnit_On_Conflict_ = {
  constraint: Esrs_Deprecated_ActionBusinessUnit_Constraint_;
  update_columns?: Array<Esrs_Deprecated_ActionBusinessUnit_Update_Column_>;
  where?: InputMaybe<Esrs_Deprecated_ActionBusinessUnit_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.Deprecated_ActionBusinessUnit". */
export type Esrs_Deprecated_ActionBusinessUnit_Order_By_ = {
  actionId?: InputMaybe<Order_By_>;
  businessUnitId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.Deprecated_ActionBusinessUnit */
export type Esrs_Deprecated_ActionBusinessUnit_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.Deprecated_ActionBusinessUnit" */
export enum Esrs_Deprecated_ActionBusinessUnit_Select_Column_ {
  /** column name */
  ActionId_ = 'actionId',
  /** column name */
  BusinessUnitId_ = 'businessUnitId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "esrs.Deprecated_ActionBusinessUnit" */
export type Esrs_Deprecated_ActionBusinessUnit_Set_Input_ = {
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  /** BusinessUnitEsrsAssessment id */
  businessUnitId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_Deprecated_ActionBusinessUnit" */
export type Esrs_Deprecated_ActionBusinessUnit_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_Deprecated_ActionBusinessUnit_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_Deprecated_ActionBusinessUnit_Stream_Cursor_Value_Input_ = {
  actionId?: InputMaybe<Scalars['uuid']['input']>;
  /** BusinessUnitEsrsAssessment id */
  businessUnitId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.Deprecated_ActionBusinessUnit" */
export enum Esrs_Deprecated_ActionBusinessUnit_Update_Column_ {
  /** column name */
  ActionId_ = 'actionId',
  /** column name */
  BusinessUnitId_ = 'businessUnitId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_Deprecated_ActionBusinessUnit_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_Deprecated_ActionBusinessUnit_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_Deprecated_ActionBusinessUnit_Bool_Exp_;
};

/** (user input data): The assessments for the business units reporting on ESRS  */
export type Esrs_Deprecated_BusinessUnitEsrsAssessment_ = {
  __typename?: 'esrs_Deprecated_BusinessUnitEsrsAssessment';
  /** if this is null, this is a company/general level business unit */
  businessUnitId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamp']['output'];
  id: Scalars['uuid']['output'];
  /** id of the company's esrs assessment where this business unit is present */
  parentAssessmentId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamp']['output'];
};

/** aggregated selection of "esrs.Deprecated_BusinessUnitEsrsAssessment" */
export type Esrs_Deprecated_BusinessUnitEsrsAssessment_Aggregate_ = {
  __typename?: 'esrs_Deprecated_BusinessUnitEsrsAssessment_aggregate';
  aggregate?: Maybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Aggregate_Fields_>;
  nodes: Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_>;
};

/** aggregate fields of "esrs.Deprecated_BusinessUnitEsrsAssessment" */
export type Esrs_Deprecated_BusinessUnitEsrsAssessment_Aggregate_Fields_ = {
  __typename?: 'esrs_Deprecated_BusinessUnitEsrsAssessment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Max_Fields_>;
  min?: Maybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Min_Fields_>;
};


/** aggregate fields of "esrs.Deprecated_BusinessUnitEsrsAssessment" */
export type Esrs_Deprecated_BusinessUnitEsrsAssessment_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "esrs.Deprecated_BusinessUnitEsrsAssessment". All fields are combined with a logical 'AND'. */
export type Esrs_Deprecated_BusinessUnitEsrsAssessment_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_Bool_Exp_>>;
  businessUnitId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  parentAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.Deprecated_BusinessUnitEsrsAssessment" */
export enum Esrs_Deprecated_BusinessUnitEsrsAssessment_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  BusinessUnitEsrsAssessmentPkey_ = 'BusinessUnitEsrsAssessment_pkey'
}

/** input type for inserting data into table "esrs.Deprecated_BusinessUnitEsrsAssessment" */
export type Esrs_Deprecated_BusinessUnitEsrsAssessment_Insert_Input_ = {
  /** if this is null, this is a company/general level business unit */
  businessUnitId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** id of the company's esrs assessment where this business unit is present */
  parentAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Esrs_Deprecated_BusinessUnitEsrsAssessment_Max_Fields_ = {
  __typename?: 'esrs_Deprecated_BusinessUnitEsrsAssessment_max_fields';
  /** if this is null, this is a company/general level business unit */
  businessUnitId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** id of the company's esrs assessment where this business unit is present */
  parentAssessmentId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregate min on columns */
export type Esrs_Deprecated_BusinessUnitEsrsAssessment_Min_Fields_ = {
  __typename?: 'esrs_Deprecated_BusinessUnitEsrsAssessment_min_fields';
  /** if this is null, this is a company/general level business unit */
  businessUnitId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** id of the company's esrs assessment where this business unit is present */
  parentAssessmentId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** response of any mutation on the table "esrs.Deprecated_BusinessUnitEsrsAssessment" */
export type Esrs_Deprecated_BusinessUnitEsrsAssessment_Mutation_Response_ = {
  __typename?: 'esrs_Deprecated_BusinessUnitEsrsAssessment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_>;
};

/** on_conflict condition type for table "esrs.Deprecated_BusinessUnitEsrsAssessment" */
export type Esrs_Deprecated_BusinessUnitEsrsAssessment_On_Conflict_ = {
  constraint: Esrs_Deprecated_BusinessUnitEsrsAssessment_Constraint_;
  update_columns?: Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_Update_Column_>;
  where?: InputMaybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.Deprecated_BusinessUnitEsrsAssessment". */
export type Esrs_Deprecated_BusinessUnitEsrsAssessment_Order_By_ = {
  businessUnitId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  parentAssessmentId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.Deprecated_BusinessUnitEsrsAssessment */
export type Esrs_Deprecated_BusinessUnitEsrsAssessment_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.Deprecated_BusinessUnitEsrsAssessment" */
export enum Esrs_Deprecated_BusinessUnitEsrsAssessment_Select_Column_ {
  /** column name */
  BusinessUnitId_ = 'businessUnitId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  ParentAssessmentId_ = 'parentAssessmentId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "esrs.Deprecated_BusinessUnitEsrsAssessment" */
export type Esrs_Deprecated_BusinessUnitEsrsAssessment_Set_Input_ = {
  /** if this is null, this is a company/general level business unit */
  businessUnitId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** id of the company's esrs assessment where this business unit is present */
  parentAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "esrs_Deprecated_BusinessUnitEsrsAssessment" */
export type Esrs_Deprecated_BusinessUnitEsrsAssessment_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_Deprecated_BusinessUnitEsrsAssessment_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_Deprecated_BusinessUnitEsrsAssessment_Stream_Cursor_Value_Input_ = {
  /** if this is null, this is a company/general level business unit */
  businessUnitId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** id of the company's esrs assessment where this business unit is present */
  parentAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "esrs.Deprecated_BusinessUnitEsrsAssessment" */
export enum Esrs_Deprecated_BusinessUnitEsrsAssessment_Update_Column_ {
  /** column name */
  BusinessUnitId_ = 'businessUnitId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  ParentAssessmentId_ = 'parentAssessmentId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_Deprecated_BusinessUnitEsrsAssessment_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_Deprecated_BusinessUnitEsrsAssessment_Bool_Exp_;
};

/** (user input data): Every standard has a company materiality assessment, it states wether the standard is material or not. It's linked to policies, targets & actions, and to material metrics . In addition, subsidiaries will be affected by the materiality assessment of their parents. */
export type Esrs_Deprecated_CompanyMaterialityAssessment_ = {
  __typename?: 'esrs_Deprecated_CompanyMaterialityAssessment';
  /** to know to which assessment and time period its related to */
  assessmentId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** deprecated */
  isForAll: Scalars['Boolean']['output'];
  /** States if the standard is material or not, if material it'll allow reporting on actions/targets/policies */
  isMaterial?: Maybe<Scalars['Boolean']['output']>;
  /** the reference of each standard it's related to */
  standardRef: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "esrs.Deprecated_CompanyMaterialityAssessment" */
export type Esrs_Deprecated_CompanyMaterialityAssessment_Aggregate_ = {
  __typename?: 'esrs_Deprecated_CompanyMaterialityAssessment_aggregate';
  aggregate?: Maybe<Esrs_Deprecated_CompanyMaterialityAssessment_Aggregate_Fields_>;
  nodes: Array<Esrs_Deprecated_CompanyMaterialityAssessment_>;
};

/** aggregate fields of "esrs.Deprecated_CompanyMaterialityAssessment" */
export type Esrs_Deprecated_CompanyMaterialityAssessment_Aggregate_Fields_ = {
  __typename?: 'esrs_Deprecated_CompanyMaterialityAssessment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_Deprecated_CompanyMaterialityAssessment_Max_Fields_>;
  min?: Maybe<Esrs_Deprecated_CompanyMaterialityAssessment_Min_Fields_>;
};


/** aggregate fields of "esrs.Deprecated_CompanyMaterialityAssessment" */
export type Esrs_Deprecated_CompanyMaterialityAssessment_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_Deprecated_CompanyMaterialityAssessment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "esrs.Deprecated_CompanyMaterialityAssessment". All fields are combined with a logical 'AND'. */
export type Esrs_Deprecated_CompanyMaterialityAssessment_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_Deprecated_CompanyMaterialityAssessment_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_Deprecated_CompanyMaterialityAssessment_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_Deprecated_CompanyMaterialityAssessment_Bool_Exp_>>;
  assessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isForAll?: InputMaybe<Boolean_Comparison_Exp_>;
  isMaterial?: InputMaybe<Boolean_Comparison_Exp_>;
  standardRef?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.Deprecated_CompanyMaterialityAssessment" */
export enum Esrs_Deprecated_CompanyMaterialityAssessment_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  MaterialityAssessmentPkey_ = 'MaterialityAssessment_pkey'
}

/** input type for inserting data into table "esrs.Deprecated_CompanyMaterialityAssessment" */
export type Esrs_Deprecated_CompanyMaterialityAssessment_Insert_Input_ = {
  /** to know to which assessment and time period its related to */
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** deprecated */
  isForAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** States if the standard is material or not, if material it'll allow reporting on actions/targets/policies */
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  /** the reference of each standard it's related to */
  standardRef?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_Deprecated_CompanyMaterialityAssessment_Max_Fields_ = {
  __typename?: 'esrs_Deprecated_CompanyMaterialityAssessment_max_fields';
  /** to know to which assessment and time period its related to */
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** the reference of each standard it's related to */
  standardRef?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Esrs_Deprecated_CompanyMaterialityAssessment_Min_Fields_ = {
  __typename?: 'esrs_Deprecated_CompanyMaterialityAssessment_min_fields';
  /** to know to which assessment and time period its related to */
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  /** the reference of each standard it's related to */
  standardRef?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "esrs.Deprecated_CompanyMaterialityAssessment" */
export type Esrs_Deprecated_CompanyMaterialityAssessment_Mutation_Response_ = {
  __typename?: 'esrs_Deprecated_CompanyMaterialityAssessment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_Deprecated_CompanyMaterialityAssessment_>;
};

/** on_conflict condition type for table "esrs.Deprecated_CompanyMaterialityAssessment" */
export type Esrs_Deprecated_CompanyMaterialityAssessment_On_Conflict_ = {
  constraint: Esrs_Deprecated_CompanyMaterialityAssessment_Constraint_;
  update_columns?: Array<Esrs_Deprecated_CompanyMaterialityAssessment_Update_Column_>;
  where?: InputMaybe<Esrs_Deprecated_CompanyMaterialityAssessment_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.Deprecated_CompanyMaterialityAssessment". */
export type Esrs_Deprecated_CompanyMaterialityAssessment_Order_By_ = {
  assessmentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isForAll?: InputMaybe<Order_By_>;
  isMaterial?: InputMaybe<Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.Deprecated_CompanyMaterialityAssessment */
export type Esrs_Deprecated_CompanyMaterialityAssessment_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.Deprecated_CompanyMaterialityAssessment" */
export enum Esrs_Deprecated_CompanyMaterialityAssessment_Select_Column_ {
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsForAll_ = 'isForAll',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  StandardRef_ = 'standardRef',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "esrs.Deprecated_CompanyMaterialityAssessment" */
export type Esrs_Deprecated_CompanyMaterialityAssessment_Set_Input_ = {
  /** to know to which assessment and time period its related to */
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** deprecated */
  isForAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** States if the standard is material or not, if material it'll allow reporting on actions/targets/policies */
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  /** the reference of each standard it's related to */
  standardRef?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_Deprecated_CompanyMaterialityAssessment" */
export type Esrs_Deprecated_CompanyMaterialityAssessment_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_Deprecated_CompanyMaterialityAssessment_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_Deprecated_CompanyMaterialityAssessment_Stream_Cursor_Value_Input_ = {
  /** to know to which assessment and time period its related to */
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  /** deprecated */
  isForAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** States if the standard is material or not, if material it'll allow reporting on actions/targets/policies */
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  /** the reference of each standard it's related to */
  standardRef?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.Deprecated_CompanyMaterialityAssessment" */
export enum Esrs_Deprecated_CompanyMaterialityAssessment_Update_Column_ {
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsForAll_ = 'isForAll',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  StandardRef_ = 'standardRef',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_Deprecated_CompanyMaterialityAssessment_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_Deprecated_CompanyMaterialityAssessment_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_Deprecated_CompanyMaterialityAssessment_Bool_Exp_;
};

/** MDR-M answers for metric datapoints */
export type Esrs_Deprecated_EsrsMdrm_ = {
  __typename?: 'esrs_Deprecated_EsrsMDRM';
  answeredByUserId: Scalars['uuid']['output'];
  /** An object relationship */
  datapoint: Esrs_Datapoint_;
  datapointId: Scalars['uuid']['output'];
  elsewhereDisclosure?: Maybe<Scalars['String']['output']>;
  entitySpecific?: Maybe<Scalars['String']['output']>;
  methodology?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  metric: EsrsMetric_;
  metricRef: Scalars['String']['output'];
  metricUsed?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  user: Users_;
  validation?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "esrs.Deprecated_EsrsMDRM" */
export type Esrs_Deprecated_EsrsMdrm_Aggregate_ = {
  __typename?: 'esrs_Deprecated_EsrsMDRM_aggregate';
  aggregate?: Maybe<Esrs_Deprecated_EsrsMdrm_Aggregate_Fields_>;
  nodes: Array<Esrs_Deprecated_EsrsMdrm_>;
};

export type Esrs_Deprecated_EsrsMdrm_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_Deprecated_EsrsMdrm_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.Deprecated_EsrsMDRM" */
export type Esrs_Deprecated_EsrsMdrm_Aggregate_Fields_ = {
  __typename?: 'esrs_Deprecated_EsrsMDRM_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_Deprecated_EsrsMdrm_Max_Fields_>;
  min?: Maybe<Esrs_Deprecated_EsrsMdrm_Min_Fields_>;
};


/** aggregate fields of "esrs.Deprecated_EsrsMDRM" */
export type Esrs_Deprecated_EsrsMdrm_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.Deprecated_EsrsMDRM" */
export type Esrs_Deprecated_EsrsMdrm_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Max_Order_By_>;
  min?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.Deprecated_EsrsMDRM" */
export type Esrs_Deprecated_EsrsMdrm_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_Deprecated_EsrsMdrm_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_Deprecated_EsrsMdrm_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.Deprecated_EsrsMDRM". All fields are combined with a logical 'AND'. */
export type Esrs_Deprecated_EsrsMdrm_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Bool_Exp_>>;
  answeredByUserId?: InputMaybe<Uuid_Comparison_Exp_>;
  datapoint?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
  datapointId?: InputMaybe<Uuid_Comparison_Exp_>;
  elsewhereDisclosure?: InputMaybe<String_Comparison_Exp_>;
  entitySpecific?: InputMaybe<String_Comparison_Exp_>;
  methodology?: InputMaybe<String_Comparison_Exp_>;
  metric?: InputMaybe<EsrsMetric_Bool_Exp_>;
  metricRef?: InputMaybe<String_Comparison_Exp_>;
  metricUsed?: InputMaybe<String_Comparison_Exp_>;
  user?: InputMaybe<Users_Bool_Exp_>;
  validation?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.Deprecated_EsrsMDRM" */
export enum Esrs_Deprecated_EsrsMdrm_Constraint_ {
  /** unique or primary key constraint on columns "metricRef", "datapointId" */
  EsrsMdrmPkey_ = 'ESRS_MDRM_pkey'
}

/** input type for inserting data into table "esrs.Deprecated_EsrsMDRM" */
export type Esrs_Deprecated_EsrsMdrm_Insert_Input_ = {
  answeredByUserId?: InputMaybe<Scalars['uuid']['input']>;
  datapoint?: InputMaybe<Esrs_Datapoint_Obj_Rel_Insert_Input_>;
  datapointId?: InputMaybe<Scalars['uuid']['input']>;
  elsewhereDisclosure?: InputMaybe<Scalars['String']['input']>;
  entitySpecific?: InputMaybe<Scalars['String']['input']>;
  methodology?: InputMaybe<Scalars['String']['input']>;
  metric?: InputMaybe<EsrsMetric_Obj_Rel_Insert_Input_>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  metricUsed?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  validation?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Esrs_Deprecated_EsrsMdrm_Max_Fields_ = {
  __typename?: 'esrs_Deprecated_EsrsMDRM_max_fields';
  answeredByUserId?: Maybe<Scalars['uuid']['output']>;
  datapointId?: Maybe<Scalars['uuid']['output']>;
  elsewhereDisclosure?: Maybe<Scalars['String']['output']>;
  entitySpecific?: Maybe<Scalars['String']['output']>;
  methodology?: Maybe<Scalars['String']['output']>;
  metricRef?: Maybe<Scalars['String']['output']>;
  metricUsed?: Maybe<Scalars['String']['output']>;
  validation?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.Deprecated_EsrsMDRM" */
export type Esrs_Deprecated_EsrsMdrm_Max_Order_By_ = {
  answeredByUserId?: InputMaybe<Order_By_>;
  datapointId?: InputMaybe<Order_By_>;
  elsewhereDisclosure?: InputMaybe<Order_By_>;
  entitySpecific?: InputMaybe<Order_By_>;
  methodology?: InputMaybe<Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
  metricUsed?: InputMaybe<Order_By_>;
  validation?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_Deprecated_EsrsMdrm_Min_Fields_ = {
  __typename?: 'esrs_Deprecated_EsrsMDRM_min_fields';
  answeredByUserId?: Maybe<Scalars['uuid']['output']>;
  datapointId?: Maybe<Scalars['uuid']['output']>;
  elsewhereDisclosure?: Maybe<Scalars['String']['output']>;
  entitySpecific?: Maybe<Scalars['String']['output']>;
  methodology?: Maybe<Scalars['String']['output']>;
  metricRef?: Maybe<Scalars['String']['output']>;
  metricUsed?: Maybe<Scalars['String']['output']>;
  validation?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.Deprecated_EsrsMDRM" */
export type Esrs_Deprecated_EsrsMdrm_Min_Order_By_ = {
  answeredByUserId?: InputMaybe<Order_By_>;
  datapointId?: InputMaybe<Order_By_>;
  elsewhereDisclosure?: InputMaybe<Order_By_>;
  entitySpecific?: InputMaybe<Order_By_>;
  methodology?: InputMaybe<Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
  metricUsed?: InputMaybe<Order_By_>;
  validation?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.Deprecated_EsrsMDRM" */
export type Esrs_Deprecated_EsrsMdrm_Mutation_Response_ = {
  __typename?: 'esrs_Deprecated_EsrsMDRM_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_Deprecated_EsrsMdrm_>;
};

/** on_conflict condition type for table "esrs.Deprecated_EsrsMDRM" */
export type Esrs_Deprecated_EsrsMdrm_On_Conflict_ = {
  constraint: Esrs_Deprecated_EsrsMdrm_Constraint_;
  update_columns?: Array<Esrs_Deprecated_EsrsMdrm_Update_Column_>;
  where?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.Deprecated_EsrsMDRM". */
export type Esrs_Deprecated_EsrsMdrm_Order_By_ = {
  answeredByUserId?: InputMaybe<Order_By_>;
  datapoint?: InputMaybe<Esrs_Datapoint_Order_By_>;
  datapointId?: InputMaybe<Order_By_>;
  elsewhereDisclosure?: InputMaybe<Order_By_>;
  entitySpecific?: InputMaybe<Order_By_>;
  methodology?: InputMaybe<Order_By_>;
  metric?: InputMaybe<EsrsMetric_Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
  metricUsed?: InputMaybe<Order_By_>;
  user?: InputMaybe<Users_Order_By_>;
  validation?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.Deprecated_EsrsMDRM */
export type Esrs_Deprecated_EsrsMdrm_Pk_Columns_Input_ = {
  datapointId: Scalars['uuid']['input'];
  metricRef: Scalars['String']['input'];
};

/** select columns of table "esrs.Deprecated_EsrsMDRM" */
export enum Esrs_Deprecated_EsrsMdrm_Select_Column_ {
  /** column name */
  AnsweredByUserId_ = 'answeredByUserId',
  /** column name */
  DatapointId_ = 'datapointId',
  /** column name */
  ElsewhereDisclosure_ = 'elsewhereDisclosure',
  /** column name */
  EntitySpecific_ = 'entitySpecific',
  /** column name */
  Methodology_ = 'methodology',
  /** column name */
  MetricRef_ = 'metricRef',
  /** column name */
  MetricUsed_ = 'metricUsed',
  /** column name */
  Validation_ = 'validation'
}

/** input type for updating data in table "esrs.Deprecated_EsrsMDRM" */
export type Esrs_Deprecated_EsrsMdrm_Set_Input_ = {
  answeredByUserId?: InputMaybe<Scalars['uuid']['input']>;
  datapointId?: InputMaybe<Scalars['uuid']['input']>;
  elsewhereDisclosure?: InputMaybe<Scalars['String']['input']>;
  entitySpecific?: InputMaybe<Scalars['String']['input']>;
  methodology?: InputMaybe<Scalars['String']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  metricUsed?: InputMaybe<Scalars['String']['input']>;
  validation?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "esrs_Deprecated_EsrsMDRM" */
export type Esrs_Deprecated_EsrsMdrm_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_Deprecated_EsrsMdrm_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_Deprecated_EsrsMdrm_Stream_Cursor_Value_Input_ = {
  answeredByUserId?: InputMaybe<Scalars['uuid']['input']>;
  datapointId?: InputMaybe<Scalars['uuid']['input']>;
  elsewhereDisclosure?: InputMaybe<Scalars['String']['input']>;
  entitySpecific?: InputMaybe<Scalars['String']['input']>;
  methodology?: InputMaybe<Scalars['String']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  metricUsed?: InputMaybe<Scalars['String']['input']>;
  validation?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.Deprecated_EsrsMDRM" */
export enum Esrs_Deprecated_EsrsMdrm_Update_Column_ {
  /** column name */
  AnsweredByUserId_ = 'answeredByUserId',
  /** column name */
  DatapointId_ = 'datapointId',
  /** column name */
  ElsewhereDisclosure_ = 'elsewhereDisclosure',
  /** column name */
  EntitySpecific_ = 'entitySpecific',
  /** column name */
  Methodology_ = 'methodology',
  /** column name */
  MetricRef_ = 'metricRef',
  /** column name */
  MetricUsed_ = 'metricUsed',
  /** column name */
  Validation_ = 'validation'
}

export type Esrs_Deprecated_EsrsMdrm_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_Deprecated_EsrsMdrm_Bool_Exp_;
};

/** columns and relationships of "esrs.Deprecated_MaterialDisclosureRequirement" */
export type Esrs_Deprecated_MaterialDisclosureRequirement_ = {
  __typename?: 'esrs_Deprecated_MaterialDisclosureRequirement';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  disclosureRequirement: DisclosureRequirement_;
  disclosureRequirementRef: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  isDataGatheringOnly: Scalars['Boolean']['output'];
  isMaterial?: Maybe<Scalars['Boolean']['output']>;
  /** An object relationship */
  materialStandard: Esrs_MaterialStandard_;
  /** An object relationship */
  standard: EsrsStandard_;
  standardAssessmentId: Scalars['uuid']['output'];
  standardRef: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "esrs.Deprecated_MaterialDisclosureRequirement" */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_ = {
  __typename?: 'esrs_Deprecated_MaterialDisclosureRequirement_aggregate';
  aggregate?: Maybe<Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Fields_>;
  nodes: Array<Esrs_Deprecated_MaterialDisclosureRequirement_>;
};

export type Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Esrs_Deprecated_MaterialDisclosureRequirement_Select_Column_Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Esrs_Deprecated_MaterialDisclosureRequirement_Select_Column_Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.Deprecated_MaterialDisclosureRequirement" */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Fields_ = {
  __typename?: 'esrs_Deprecated_MaterialDisclosureRequirement_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_Deprecated_MaterialDisclosureRequirement_Max_Fields_>;
  min?: Maybe<Esrs_Deprecated_MaterialDisclosureRequirement_Min_Fields_>;
};


/** aggregate fields of "esrs.Deprecated_MaterialDisclosureRequirement" */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.Deprecated_MaterialDisclosureRequirement" */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Max_Order_By_>;
  min?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.Deprecated_MaterialDisclosureRequirement" */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_Deprecated_MaterialDisclosureRequirement_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.Deprecated_MaterialDisclosureRequirement". All fields are combined with a logical 'AND'. */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  disclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isDataGatheringOnly?: InputMaybe<Boolean_Comparison_Exp_>;
  isMaterial?: InputMaybe<Boolean_Comparison_Exp_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  standard?: InputMaybe<EsrsStandard_Bool_Exp_>;
  standardAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  standardRef?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.Deprecated_MaterialDisclosureRequirement" */
export enum Esrs_Deprecated_MaterialDisclosureRequirement_Constraint_ {
  /** unique or primary key constraint on columns "disclosureRequirementRef", "standardAssessmentId", "standardRef" */
  MaterialDisclosureRequirementCompanyMaterialityAssessmentIKey_ = 'MaterialDisclosureRequirement_companyMaterialityAssessmentI_key',
  /** unique or primary key constraint on columns "id" */
  MaterialDisclosureRequirementPkey_ = 'MaterialDisclosureRequirement_pkey'
}

/** input type for inserting data into table "esrs.Deprecated_MaterialDisclosureRequirement" */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Obj_Rel_Insert_Input_>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDataGatheringOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Obj_Rel_Insert_Input_>;
  standard?: InputMaybe<EsrsStandard_Obj_Rel_Insert_Input_>;
  standardAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Max_Fields_ = {
  __typename?: 'esrs_Deprecated_MaterialDisclosureRequirement_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  standardAssessmentId?: Maybe<Scalars['uuid']['output']>;
  standardRef?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.Deprecated_MaterialDisclosureRequirement" */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  standardAssessmentId?: InputMaybe<Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Min_Fields_ = {
  __typename?: 'esrs_Deprecated_MaterialDisclosureRequirement_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  standardAssessmentId?: Maybe<Scalars['uuid']['output']>;
  standardRef?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.Deprecated_MaterialDisclosureRequirement" */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  standardAssessmentId?: InputMaybe<Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.Deprecated_MaterialDisclosureRequirement" */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Mutation_Response_ = {
  __typename?: 'esrs_Deprecated_MaterialDisclosureRequirement_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_Deprecated_MaterialDisclosureRequirement_>;
};

/** on_conflict condition type for table "esrs.Deprecated_MaterialDisclosureRequirement" */
export type Esrs_Deprecated_MaterialDisclosureRequirement_On_Conflict_ = {
  constraint: Esrs_Deprecated_MaterialDisclosureRequirement_Constraint_;
  update_columns?: Array<Esrs_Deprecated_MaterialDisclosureRequirement_Update_Column_>;
  where?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.Deprecated_MaterialDisclosureRequirement". */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isDataGatheringOnly?: InputMaybe<Order_By_>;
  isMaterial?: InputMaybe<Order_By_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Order_By_>;
  standard?: InputMaybe<EsrsStandard_Order_By_>;
  standardAssessmentId?: InputMaybe<Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.Deprecated_MaterialDisclosureRequirement */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.Deprecated_MaterialDisclosureRequirement" */
export enum Esrs_Deprecated_MaterialDisclosureRequirement_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsDataGatheringOnly_ = 'isDataGatheringOnly',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  StandardAssessmentId_ = 'standardAssessmentId',
  /** column name */
  StandardRef_ = 'standardRef',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "esrs_Deprecated_MaterialDisclosureRequirement_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.Deprecated_MaterialDisclosureRequirement" */
export enum Esrs_Deprecated_MaterialDisclosureRequirement_Select_Column_Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsDataGatheringOnly_ = 'isDataGatheringOnly',
  /** column name */
  IsMaterial_ = 'isMaterial'
}

/** select "esrs_Deprecated_MaterialDisclosureRequirement_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.Deprecated_MaterialDisclosureRequirement" */
export enum Esrs_Deprecated_MaterialDisclosureRequirement_Select_Column_Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsDataGatheringOnly_ = 'isDataGatheringOnly',
  /** column name */
  IsMaterial_ = 'isMaterial'
}

/** input type for updating data in table "esrs.Deprecated_MaterialDisclosureRequirement" */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDataGatheringOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  standardAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_Deprecated_MaterialDisclosureRequirement" */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_Deprecated_MaterialDisclosureRequirement_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_Deprecated_MaterialDisclosureRequirement_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDataGatheringOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  standardAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.Deprecated_MaterialDisclosureRequirement" */
export enum Esrs_Deprecated_MaterialDisclosureRequirement_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsDataGatheringOnly_ = 'isDataGatheringOnly',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  StandardAssessmentId_ = 'standardAssessmentId',
  /** column name */
  StandardRef_ = 'standardRef',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_Deprecated_MaterialDisclosureRequirement_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_;
};

/** (user input data): This gathers all the answers for the chosen metrics  */
export type Esrs_Deprecated_MetricAnswer_ = {
  __typename?: 'esrs_Deprecated_MetricAnswer';
  /** the id of the user that answered */
  answeredById: Scalars['uuid']['output'];
  businessUnitAssessmentId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** the actual input answer */
  data?: Maybe<Scalars['jsonb']['output']>;
  hasOptedOut: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  metricRef: Scalars['String']['output'];
  optOutReason?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
};


/** (user input data): This gathers all the answers for the chosen metrics  */
export type Esrs_Deprecated_MetricAnswerDataArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "esrs.Deprecated_MetricAnswer" */
export type Esrs_Deprecated_MetricAnswer_Aggregate_ = {
  __typename?: 'esrs_Deprecated_MetricAnswer_aggregate';
  aggregate?: Maybe<Esrs_Deprecated_MetricAnswer_Aggregate_Fields_>;
  nodes: Array<Esrs_Deprecated_MetricAnswer_>;
};

/** aggregate fields of "esrs.Deprecated_MetricAnswer" */
export type Esrs_Deprecated_MetricAnswer_Aggregate_Fields_ = {
  __typename?: 'esrs_Deprecated_MetricAnswer_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_Deprecated_MetricAnswer_Max_Fields_>;
  min?: Maybe<Esrs_Deprecated_MetricAnswer_Min_Fields_>;
};


/** aggregate fields of "esrs.Deprecated_MetricAnswer" */
export type Esrs_Deprecated_MetricAnswer_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_Deprecated_MetricAnswer_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Esrs_Deprecated_MetricAnswer_Append_Input_ = {
  /** the actual input answer */
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "esrs.Deprecated_MetricAnswer". All fields are combined with a logical 'AND'. */
export type Esrs_Deprecated_MetricAnswer_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_Deprecated_MetricAnswer_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_Deprecated_MetricAnswer_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_Deprecated_MetricAnswer_Bool_Exp_>>;
  answeredById?: InputMaybe<Uuid_Comparison_Exp_>;
  businessUnitAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  data?: InputMaybe<Jsonb_Comparison_Exp_>;
  hasOptedOut?: InputMaybe<Boolean_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  metricRef?: InputMaybe<String_Comparison_Exp_>;
  optOutReason?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.Deprecated_MetricAnswer" */
export enum Esrs_Deprecated_MetricAnswer_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  MetricAnswerPkey_ = 'MetricAnswer_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Esrs_Deprecated_MetricAnswer_Delete_At_Path_Input_ = {
  /** the actual input answer */
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Esrs_Deprecated_MetricAnswer_Delete_Elem_Input_ = {
  /** the actual input answer */
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Esrs_Deprecated_MetricAnswer_Delete_Key_Input_ = {
  /** the actual input answer */
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "esrs.Deprecated_MetricAnswer" */
export type Esrs_Deprecated_MetricAnswer_Insert_Input_ = {
  /** the id of the user that answered */
  answeredById?: InputMaybe<Scalars['uuid']['input']>;
  businessUnitAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** the actual input answer */
  data?: InputMaybe<Scalars['jsonb']['input']>;
  hasOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_Deprecated_MetricAnswer_Max_Fields_ = {
  __typename?: 'esrs_Deprecated_MetricAnswer_max_fields';
  /** the id of the user that answered */
  answeredById?: Maybe<Scalars['uuid']['output']>;
  businessUnitAssessmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  metricRef?: Maybe<Scalars['String']['output']>;
  optOutReason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Esrs_Deprecated_MetricAnswer_Min_Fields_ = {
  __typename?: 'esrs_Deprecated_MetricAnswer_min_fields';
  /** the id of the user that answered */
  answeredById?: Maybe<Scalars['uuid']['output']>;
  businessUnitAssessmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  metricRef?: Maybe<Scalars['String']['output']>;
  optOutReason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "esrs.Deprecated_MetricAnswer" */
export type Esrs_Deprecated_MetricAnswer_Mutation_Response_ = {
  __typename?: 'esrs_Deprecated_MetricAnswer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_Deprecated_MetricAnswer_>;
};

/** on_conflict condition type for table "esrs.Deprecated_MetricAnswer" */
export type Esrs_Deprecated_MetricAnswer_On_Conflict_ = {
  constraint: Esrs_Deprecated_MetricAnswer_Constraint_;
  update_columns?: Array<Esrs_Deprecated_MetricAnswer_Update_Column_>;
  where?: InputMaybe<Esrs_Deprecated_MetricAnswer_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.Deprecated_MetricAnswer". */
export type Esrs_Deprecated_MetricAnswer_Order_By_ = {
  answeredById?: InputMaybe<Order_By_>;
  businessUnitAssessmentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  data?: InputMaybe<Order_By_>;
  hasOptedOut?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
  optOutReason?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.Deprecated_MetricAnswer */
export type Esrs_Deprecated_MetricAnswer_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Esrs_Deprecated_MetricAnswer_Prepend_Input_ = {
  /** the actual input answer */
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "esrs.Deprecated_MetricAnswer" */
export enum Esrs_Deprecated_MetricAnswer_Select_Column_ {
  /** column name */
  AnsweredById_ = 'answeredById',
  /** column name */
  BusinessUnitAssessmentId_ = 'businessUnitAssessmentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Data_ = 'data',
  /** column name */
  HasOptedOut_ = 'hasOptedOut',
  /** column name */
  Id_ = 'id',
  /** column name */
  MetricRef_ = 'metricRef',
  /** column name */
  OptOutReason_ = 'optOutReason',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "esrs.Deprecated_MetricAnswer" */
export type Esrs_Deprecated_MetricAnswer_Set_Input_ = {
  /** the id of the user that answered */
  answeredById?: InputMaybe<Scalars['uuid']['input']>;
  businessUnitAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** the actual input answer */
  data?: InputMaybe<Scalars['jsonb']['input']>;
  hasOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_Deprecated_MetricAnswer" */
export type Esrs_Deprecated_MetricAnswer_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_Deprecated_MetricAnswer_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_Deprecated_MetricAnswer_Stream_Cursor_Value_Input_ = {
  /** the id of the user that answered */
  answeredById?: InputMaybe<Scalars['uuid']['input']>;
  businessUnitAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  /** the actual input answer */
  data?: InputMaybe<Scalars['jsonb']['input']>;
  hasOptedOut?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  optOutReason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.Deprecated_MetricAnswer" */
export enum Esrs_Deprecated_MetricAnswer_Update_Column_ {
  /** column name */
  AnsweredById_ = 'answeredById',
  /** column name */
  BusinessUnitAssessmentId_ = 'businessUnitAssessmentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Data_ = 'data',
  /** column name */
  HasOptedOut_ = 'hasOptedOut',
  /** column name */
  Id_ = 'id',
  /** column name */
  MetricRef_ = 'metricRef',
  /** column name */
  OptOutReason_ = 'optOutReason',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_Deprecated_MetricAnswer_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Esrs_Deprecated_MetricAnswer_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Esrs_Deprecated_MetricAnswer_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Esrs_Deprecated_MetricAnswer_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Esrs_Deprecated_MetricAnswer_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Esrs_Deprecated_MetricAnswer_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_Deprecated_MetricAnswer_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_Deprecated_MetricAnswer_Bool_Exp_;
};

/** Attachments for disclosure requirements, per reporting units, and per materialStandard */
export type Esrs_DisclosureRequirementAttachment_ = {
  __typename?: 'esrs_DisclosureRequirementAttachment';
  /** An object relationship */
  attachmentBox?: Maybe<AttachmentBox_>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  /** An object relationship */
  disclosureRequirement: DisclosureRequirement_;
  disclosureRequirementRef: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  materialStandard: Esrs_MaterialStandard_;
  materialStandardId: Scalars['uuid']['output'];
  /** An object relationship */
  reportingUnit: Esrs_ReportingUnit_;
  reportingUnitId: Scalars['uuid']['output'];
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** aggregated selection of "esrs.DisclosureRequirementAttachment" */
export type Esrs_DisclosureRequirementAttachment_Aggregate_ = {
  __typename?: 'esrs_DisclosureRequirementAttachment_aggregate';
  aggregate?: Maybe<Esrs_DisclosureRequirementAttachment_Aggregate_Fields_>;
  nodes: Array<Esrs_DisclosureRequirementAttachment_>;
};

export type Esrs_DisclosureRequirementAttachment_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Esrs_DisclosureRequirementAttachment_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_DisclosureRequirementAttachment_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_DisclosureRequirementAttachment_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.DisclosureRequirementAttachment" */
export type Esrs_DisclosureRequirementAttachment_Aggregate_Fields_ = {
  __typename?: 'esrs_DisclosureRequirementAttachment_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_DisclosureRequirementAttachment_Max_Fields_>;
  min?: Maybe<Esrs_DisclosureRequirementAttachment_Min_Fields_>;
};


/** aggregate fields of "esrs.DisclosureRequirementAttachment" */
export type Esrs_DisclosureRequirementAttachment_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.DisclosureRequirementAttachment" */
export type Esrs_DisclosureRequirementAttachment_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_DisclosureRequirementAttachment_Max_Order_By_>;
  min?: InputMaybe<Esrs_DisclosureRequirementAttachment_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.DisclosureRequirementAttachment" */
export type Esrs_DisclosureRequirementAttachment_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_DisclosureRequirementAttachment_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_DisclosureRequirementAttachment_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.DisclosureRequirementAttachment". All fields are combined with a logical 'AND'. */
export type Esrs_DisclosureRequirementAttachment_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_DisclosureRequirementAttachment_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Bool_Exp_>>;
  attachmentBox?: InputMaybe<AttachmentBox_Bool_Exp_>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp_>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  disclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  materialStandardId?: InputMaybe<Uuid_Comparison_Exp_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
  reportingUnitId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.DisclosureRequirementAttachment" */
export enum Esrs_DisclosureRequirementAttachment_Constraint_ {
  /** unique or primary key constraint on columns "disclosureRequirementRef", "materialStandardId", "reportingUnitId" */
  DisclosureRequirementAttachmentMaterialStandardIdReportingUni_ = 'DisclosureRequirementAttachment_materialStandardId_reportingUni',
  /** unique or primary key constraint on columns "id" */
  DisclosureRequirementAttachmentPkey_ = 'DisclosureRequirementAttachment_pkey'
}

/** input type for inserting data into table "esrs.DisclosureRequirementAttachment" */
export type Esrs_DisclosureRequirementAttachment_Insert_Input_ = {
  attachmentBox?: InputMaybe<AttachmentBox_Obj_Rel_Insert_Input_>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Obj_Rel_Insert_Input_>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Obj_Rel_Insert_Input_>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Obj_Rel_Insert_Input_>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** aggregate max on columns */
export type Esrs_DisclosureRequirementAttachment_Max_Fields_ = {
  __typename?: 'esrs_DisclosureRequirementAttachment_max_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by max() on columns of table "esrs.DisclosureRequirementAttachment" */
export type Esrs_DisclosureRequirementAttachment_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialStandardId?: InputMaybe<Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_DisclosureRequirementAttachment_Min_Fields_ = {
  __typename?: 'esrs_DisclosureRequirementAttachment_min_fields';
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
};

/** order by min() on columns of table "esrs.DisclosureRequirementAttachment" */
export type Esrs_DisclosureRequirementAttachment_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialStandardId?: InputMaybe<Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.DisclosureRequirementAttachment" */
export type Esrs_DisclosureRequirementAttachment_Mutation_Response_ = {
  __typename?: 'esrs_DisclosureRequirementAttachment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_DisclosureRequirementAttachment_>;
};

/** input type for inserting object relation for remote table "esrs.DisclosureRequirementAttachment" */
export type Esrs_DisclosureRequirementAttachment_Obj_Rel_Insert_Input_ = {
  data: Esrs_DisclosureRequirementAttachment_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_DisclosureRequirementAttachment_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.DisclosureRequirementAttachment" */
export type Esrs_DisclosureRequirementAttachment_On_Conflict_ = {
  constraint: Esrs_DisclosureRequirementAttachment_Constraint_;
  update_columns?: Array<Esrs_DisclosureRequirementAttachment_Update_Column_>;
  where?: InputMaybe<Esrs_DisclosureRequirementAttachment_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.DisclosureRequirementAttachment". */
export type Esrs_DisclosureRequirementAttachment_Order_By_ = {
  attachmentBox?: InputMaybe<AttachmentBox_Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Order_By_>;
  materialStandardId?: InputMaybe<Order_By_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.DisclosureRequirementAttachment */
export type Esrs_DisclosureRequirementAttachment_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.DisclosureRequirementAttachment" */
export enum Esrs_DisclosureRequirementAttachment_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  MaterialStandardId_ = 'materialStandardId',
  /** column name */
  ReportingUnitId_ = 'reportingUnitId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "esrs.DisclosureRequirementAttachment" */
export type Esrs_DisclosureRequirementAttachment_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** Streaming cursor of the table "esrs_DisclosureRequirementAttachment" */
export type Esrs_DisclosureRequirementAttachment_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_DisclosureRequirementAttachment_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_DisclosureRequirementAttachment_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
};

/** update columns of table "esrs.DisclosureRequirementAttachment" */
export enum Esrs_DisclosureRequirementAttachment_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  MaterialStandardId_ = 'materialStandardId',
  /** column name */
  ReportingUnitId_ = 'reportingUnitId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_DisclosureRequirementAttachment_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_DisclosureRequirementAttachment_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_DisclosureRequirementAttachment_Bool_Exp_;
};

/** columns and relationships of "esrs.EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegration_ = {
  __typename?: 'esrs_EsrsAssessmentCompanyIntegration';
  /** An object relationship */
  companyIntegration: Esrs_CompanyIntegration_;
  companyIntegrationId: Scalars['uuid']['output'];
  /** An object relationship */
  esrsAssessment: EsrsAssessment_;
  /** An array relationship */
  esrsAssessmentCompanyIntegrationRUs: Array<Esrs_EsrsAssessmentCompanyIntegrationRu_>;
  /** An aggregate relationship */
  esrsAssessmentCompanyIntegrationRUs_aggregate: Esrs_EsrsAssessmentCompanyIntegrationRu_Aggregate_;
  esrsAssessmentId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  syncedAt?: Maybe<Scalars['timestamptz']['output']>;
};


/** columns and relationships of "esrs.EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegrationEsrsAssessmentCompanyIntegrationRUsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_>;
};


/** columns and relationships of "esrs.EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegrationEsrsAssessmentCompanyIntegrationRUs_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_>;
};

/** columns and relationships of "esrs.EsrsAssessmentCompanyIntegrationRU" */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_ = {
  __typename?: 'esrs_EsrsAssessmentCompanyIntegrationRU';
  apiKey?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  esrsAssessmentCompanyIntegration: Esrs_EsrsAssessmentCompanyIntegration_;
  esrsAssessmentCompanyIntegrationId: Scalars['uuid']['output'];
  esrsReportingUnitId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  reportingUnit: Esrs_ReportingUnit_;
  syncedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregated selection of "esrs.EsrsAssessmentCompanyIntegrationRU" */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Aggregate_ = {
  __typename?: 'esrs_EsrsAssessmentCompanyIntegrationRU_aggregate';
  aggregate?: Maybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Aggregate_Fields_>;
  nodes: Array<Esrs_EsrsAssessmentCompanyIntegrationRu_>;
};

export type Esrs_EsrsAssessmentCompanyIntegrationRu_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_EsrsAssessmentCompanyIntegrationRu_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.EsrsAssessmentCompanyIntegrationRU" */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Aggregate_Fields_ = {
  __typename?: 'esrs_EsrsAssessmentCompanyIntegrationRU_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Max_Fields_>;
  min?: Maybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Min_Fields_>;
};


/** aggregate fields of "esrs.EsrsAssessmentCompanyIntegrationRU" */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.EsrsAssessmentCompanyIntegrationRU" */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Max_Order_By_>;
  min?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.EsrsAssessmentCompanyIntegrationRU" */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.EsrsAssessmentCompanyIntegrationRU". All fields are combined with a logical 'AND'. */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_>>;
  apiKey?: InputMaybe<String_Comparison_Exp_>;
  esrsAssessmentCompanyIntegration?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>;
  esrsAssessmentCompanyIntegrationId?: InputMaybe<Uuid_Comparison_Exp_>;
  esrsReportingUnitId?: InputMaybe<Uuid_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
  syncedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.EsrsAssessmentCompanyIntegrationRU" */
export enum Esrs_EsrsAssessmentCompanyIntegrationRu_Constraint_ {
  /** unique or primary key constraint on columns "esrsAssessmentCompanyIntegrationId", "esrsReportingUnitId" */
  EsrsAssessmentCompanyIntegrationRuEsrsReportingUnitIdEsrsAsse_ = 'EsrsAssessmentCompanyIntegrationRU_esrsReportingUnitId_esrsAsse',
  /** unique or primary key constraint on columns "id" */
  EsrsAssessmentCompanyIntegrationRuPkey_ = 'EsrsAssessmentCompanyIntegrationRU_pkey'
}

/** input type for inserting data into table "esrs.EsrsAssessmentCompanyIntegrationRU" */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Insert_Input_ = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  esrsAssessmentCompanyIntegration?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Obj_Rel_Insert_Input_>;
  esrsAssessmentCompanyIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  esrsReportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Obj_Rel_Insert_Input_>;
  syncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Max_Fields_ = {
  __typename?: 'esrs_EsrsAssessmentCompanyIntegrationRU_max_fields';
  apiKey?: Maybe<Scalars['String']['output']>;
  esrsAssessmentCompanyIntegrationId?: Maybe<Scalars['uuid']['output']>;
  esrsReportingUnitId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  syncedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.EsrsAssessmentCompanyIntegrationRU" */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Max_Order_By_ = {
  apiKey?: InputMaybe<Order_By_>;
  esrsAssessmentCompanyIntegrationId?: InputMaybe<Order_By_>;
  esrsReportingUnitId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  syncedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Min_Fields_ = {
  __typename?: 'esrs_EsrsAssessmentCompanyIntegrationRU_min_fields';
  apiKey?: Maybe<Scalars['String']['output']>;
  esrsAssessmentCompanyIntegrationId?: Maybe<Scalars['uuid']['output']>;
  esrsReportingUnitId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  syncedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.EsrsAssessmentCompanyIntegrationRU" */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Min_Order_By_ = {
  apiKey?: InputMaybe<Order_By_>;
  esrsAssessmentCompanyIntegrationId?: InputMaybe<Order_By_>;
  esrsReportingUnitId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  syncedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.EsrsAssessmentCompanyIntegrationRU" */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Mutation_Response_ = {
  __typename?: 'esrs_EsrsAssessmentCompanyIntegrationRU_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_EsrsAssessmentCompanyIntegrationRu_>;
};

/** on_conflict condition type for table "esrs.EsrsAssessmentCompanyIntegrationRU" */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_On_Conflict_ = {
  constraint: Esrs_EsrsAssessmentCompanyIntegrationRu_Constraint_;
  update_columns?: Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Update_Column_>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.EsrsAssessmentCompanyIntegrationRU". */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Order_By_ = {
  apiKey?: InputMaybe<Order_By_>;
  esrsAssessmentCompanyIntegration?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Order_By_>;
  esrsAssessmentCompanyIntegrationId?: InputMaybe<Order_By_>;
  esrsReportingUnitId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Order_By_>;
  syncedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.EsrsAssessmentCompanyIntegrationRU */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.EsrsAssessmentCompanyIntegrationRU" */
export enum Esrs_EsrsAssessmentCompanyIntegrationRu_Select_Column_ {
  /** column name */
  ApiKey_ = 'apiKey',
  /** column name */
  EsrsAssessmentCompanyIntegrationId_ = 'esrsAssessmentCompanyIntegrationId',
  /** column name */
  EsrsReportingUnitId_ = 'esrsReportingUnitId',
  /** column name */
  Id_ = 'id',
  /** column name */
  SyncedAt_ = 'syncedAt'
}

/** input type for updating data in table "esrs.EsrsAssessmentCompanyIntegrationRU" */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Set_Input_ = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  esrsAssessmentCompanyIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  esrsReportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_EsrsAssessmentCompanyIntegrationRU" */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_EsrsAssessmentCompanyIntegrationRu_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_EsrsAssessmentCompanyIntegrationRu_Stream_Cursor_Value_Input_ = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  esrsAssessmentCompanyIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  esrsReportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.EsrsAssessmentCompanyIntegrationRU" */
export enum Esrs_EsrsAssessmentCompanyIntegrationRu_Update_Column_ {
  /** column name */
  ApiKey_ = 'apiKey',
  /** column name */
  EsrsAssessmentCompanyIntegrationId_ = 'esrsAssessmentCompanyIntegrationId',
  /** column name */
  EsrsReportingUnitId_ = 'esrsReportingUnitId',
  /** column name */
  Id_ = 'id',
  /** column name */
  SyncedAt_ = 'syncedAt'
}

export type Esrs_EsrsAssessmentCompanyIntegrationRu_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_;
};

/** aggregated selection of "esrs.EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegration_Aggregate_ = {
  __typename?: 'esrs_EsrsAssessmentCompanyIntegration_aggregate';
  aggregate?: Maybe<Esrs_EsrsAssessmentCompanyIntegration_Aggregate_Fields_>;
  nodes: Array<Esrs_EsrsAssessmentCompanyIntegration_>;
};

export type Esrs_EsrsAssessmentCompanyIntegration_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_EsrsAssessmentCompanyIntegration_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegration_Aggregate_Fields_ = {
  __typename?: 'esrs_EsrsAssessmentCompanyIntegration_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_EsrsAssessmentCompanyIntegration_Max_Fields_>;
  min?: Maybe<Esrs_EsrsAssessmentCompanyIntegration_Min_Fields_>;
};


/** aggregate fields of "esrs.EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegration_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegration_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Max_Order_By_>;
  min?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegration_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_EsrsAssessmentCompanyIntegration_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.EsrsAssessmentCompanyIntegration". All fields are combined with a logical 'AND'. */
export type Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>>;
  companyIntegration?: InputMaybe<Esrs_CompanyIntegration_Bool_Exp_>;
  companyIntegrationId?: InputMaybe<Uuid_Comparison_Exp_>;
  esrsAssessment?: InputMaybe<EsrsAssessment_Bool_Exp_>;
  esrsAssessmentCompanyIntegrationRUs?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_>;
  esrsAssessmentCompanyIntegrationRUs_aggregate?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Aggregate_Bool_Exp_>;
  esrsAssessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  syncedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.EsrsAssessmentCompanyIntegration" */
export enum Esrs_EsrsAssessmentCompanyIntegration_Constraint_ {
  /** unique or primary key constraint on columns "esrsAssessmentId", "companyIntegrationId" */
  EsrsAssessmentCompanyIntegrationEsrsAssessmentIdCompanyIntegr_ = 'EsrsAssessmentCompanyIntegration_esrsAssessmentId_companyIntegr',
  /** unique or primary key constraint on columns "id" */
  EsrsAssessmentCompanyIntegrationPkey_ = 'EsrsAssessmentCompanyIntegration_pkey'
}

/** input type for inserting data into table "esrs.EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegration_Insert_Input_ = {
  companyIntegration?: InputMaybe<Esrs_CompanyIntegration_Obj_Rel_Insert_Input_>;
  companyIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  esrsAssessment?: InputMaybe<EsrsAssessment_Obj_Rel_Insert_Input_>;
  esrsAssessmentCompanyIntegrationRUs?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Arr_Rel_Insert_Input_>;
  esrsAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_EsrsAssessmentCompanyIntegration_Max_Fields_ = {
  __typename?: 'esrs_EsrsAssessmentCompanyIntegration_max_fields';
  companyIntegrationId?: Maybe<Scalars['uuid']['output']>;
  esrsAssessmentId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  syncedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegration_Max_Order_By_ = {
  companyIntegrationId?: InputMaybe<Order_By_>;
  esrsAssessmentId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  syncedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_EsrsAssessmentCompanyIntegration_Min_Fields_ = {
  __typename?: 'esrs_EsrsAssessmentCompanyIntegration_min_fields';
  companyIntegrationId?: Maybe<Scalars['uuid']['output']>;
  esrsAssessmentId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  syncedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegration_Min_Order_By_ = {
  companyIntegrationId?: InputMaybe<Order_By_>;
  esrsAssessmentId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  syncedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegration_Mutation_Response_ = {
  __typename?: 'esrs_EsrsAssessmentCompanyIntegration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_EsrsAssessmentCompanyIntegration_>;
};

/** input type for inserting object relation for remote table "esrs.EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegration_Obj_Rel_Insert_Input_ = {
  data: Esrs_EsrsAssessmentCompanyIntegration_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegration_On_Conflict_ = {
  constraint: Esrs_EsrsAssessmentCompanyIntegration_Constraint_;
  update_columns?: Array<Esrs_EsrsAssessmentCompanyIntegration_Update_Column_>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.EsrsAssessmentCompanyIntegration". */
export type Esrs_EsrsAssessmentCompanyIntegration_Order_By_ = {
  companyIntegration?: InputMaybe<Esrs_CompanyIntegration_Order_By_>;
  companyIntegrationId?: InputMaybe<Order_By_>;
  esrsAssessment?: InputMaybe<EsrsAssessment_Order_By_>;
  esrsAssessmentCompanyIntegrationRUs_aggregate?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Aggregate_Order_By_>;
  esrsAssessmentId?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  syncedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.EsrsAssessmentCompanyIntegration */
export type Esrs_EsrsAssessmentCompanyIntegration_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.EsrsAssessmentCompanyIntegration" */
export enum Esrs_EsrsAssessmentCompanyIntegration_Select_Column_ {
  /** column name */
  CompanyIntegrationId_ = 'companyIntegrationId',
  /** column name */
  EsrsAssessmentId_ = 'esrsAssessmentId',
  /** column name */
  Id_ = 'id',
  /** column name */
  SyncedAt_ = 'syncedAt'
}

/** input type for updating data in table "esrs.EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegration_Set_Input_ = {
  companyIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  esrsAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_EsrsAssessmentCompanyIntegration" */
export type Esrs_EsrsAssessmentCompanyIntegration_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_EsrsAssessmentCompanyIntegration_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_EsrsAssessmentCompanyIntegration_Stream_Cursor_Value_Input_ = {
  companyIntegrationId?: InputMaybe<Scalars['uuid']['input']>;
  esrsAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  syncedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.EsrsAssessmentCompanyIntegration" */
export enum Esrs_EsrsAssessmentCompanyIntegration_Update_Column_ {
  /** column name */
  CompanyIntegrationId_ = 'companyIntegrationId',
  /** column name */
  EsrsAssessmentId_ = 'esrsAssessmentId',
  /** column name */
  Id_ = 'id',
  /** column name */
  SyncedAt_ = 'syncedAt'
}

export type Esrs_EsrsAssessmentCompanyIntegration_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_;
};

/** columns and relationships of "esrs.EsrsMetricHierarchyStatus" */
export type Esrs_EsrsMetricHierarchyStatus_ = {
  __typename?: 'esrs_EsrsMetricHierarchyStatus';
  isLeaf?: Maybe<Scalars['Boolean']['output']>;
  isTopLevel?: Maybe<Scalars['Boolean']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "esrs.EsrsMetricHierarchyStatus" */
export type Esrs_EsrsMetricHierarchyStatus_Aggregate_ = {
  __typename?: 'esrs_EsrsMetricHierarchyStatus_aggregate';
  aggregate?: Maybe<Esrs_EsrsMetricHierarchyStatus_Aggregate_Fields_>;
  nodes: Array<Esrs_EsrsMetricHierarchyStatus_>;
};

/** aggregate fields of "esrs.EsrsMetricHierarchyStatus" */
export type Esrs_EsrsMetricHierarchyStatus_Aggregate_Fields_ = {
  __typename?: 'esrs_EsrsMetricHierarchyStatus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_EsrsMetricHierarchyStatus_Max_Fields_>;
  min?: Maybe<Esrs_EsrsMetricHierarchyStatus_Min_Fields_>;
};


/** aggregate fields of "esrs.EsrsMetricHierarchyStatus" */
export type Esrs_EsrsMetricHierarchyStatus_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_EsrsMetricHierarchyStatus_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "esrs.EsrsMetricHierarchyStatus". All fields are combined with a logical 'AND'. */
export type Esrs_EsrsMetricHierarchyStatus_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_EsrsMetricHierarchyStatus_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_EsrsMetricHierarchyStatus_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_EsrsMetricHierarchyStatus_Bool_Exp_>>;
  isLeaf?: InputMaybe<Boolean_Comparison_Exp_>;
  isTopLevel?: InputMaybe<Boolean_Comparison_Exp_>;
  reference?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.EsrsMetricHierarchyStatus" */
export enum Esrs_EsrsMetricHierarchyStatus_Constraint_ {
  /** unique or primary key constraint on columns "reference" */
  EsrsEsrsmetrichierarchystatusRefIdx_ = 'esrs_esrsmetrichierarchystatus_ref_idx'
}

/** input type for inserting data into table "esrs.EsrsMetricHierarchyStatus" */
export type Esrs_EsrsMetricHierarchyStatus_Insert_Input_ = {
  isLeaf?: InputMaybe<Scalars['Boolean']['input']>;
  isTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Esrs_EsrsMetricHierarchyStatus_Max_Fields_ = {
  __typename?: 'esrs_EsrsMetricHierarchyStatus_max_fields';
  reference?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Esrs_EsrsMetricHierarchyStatus_Min_Fields_ = {
  __typename?: 'esrs_EsrsMetricHierarchyStatus_min_fields';
  reference?: Maybe<Scalars['String']['output']>;
};

/** input type for inserting object relation for remote table "esrs.EsrsMetricHierarchyStatus" */
export type Esrs_EsrsMetricHierarchyStatus_Obj_Rel_Insert_Input_ = {
  data: Esrs_EsrsMetricHierarchyStatus_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_EsrsMetricHierarchyStatus_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.EsrsMetricHierarchyStatus" */
export type Esrs_EsrsMetricHierarchyStatus_On_Conflict_ = {
  constraint: Esrs_EsrsMetricHierarchyStatus_Constraint_;
  update_columns?: Array<Esrs_EsrsMetricHierarchyStatus_Update_Column_>;
  where?: InputMaybe<Esrs_EsrsMetricHierarchyStatus_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.EsrsMetricHierarchyStatus". */
export type Esrs_EsrsMetricHierarchyStatus_Order_By_ = {
  isLeaf?: InputMaybe<Order_By_>;
  isTopLevel?: InputMaybe<Order_By_>;
  reference?: InputMaybe<Order_By_>;
};

/** select columns of table "esrs.EsrsMetricHierarchyStatus" */
export enum Esrs_EsrsMetricHierarchyStatus_Select_Column_ {
  /** column name */
  IsLeaf_ = 'isLeaf',
  /** column name */
  IsTopLevel_ = 'isTopLevel',
  /** column name */
  Reference_ = 'reference'
}

/** Streaming cursor of the table "esrs_EsrsMetricHierarchyStatus" */
export type Esrs_EsrsMetricHierarchyStatus_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_EsrsMetricHierarchyStatus_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_EsrsMetricHierarchyStatus_Stream_Cursor_Value_Input_ = {
  isLeaf?: InputMaybe<Scalars['Boolean']['input']>;
  isTopLevel?: InputMaybe<Scalars['Boolean']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "esrs.EsrsMetricHierarchyStatus" */
export enum Esrs_EsrsMetricHierarchyStatus_Update_Column_ {
  /** column name */
  IsLeaf_ = 'isLeaf',
  /** column name */
  IsTopLevel_ = 'isTopLevel',
  /** column name */
  Reference_ = 'reference'
}

/** (user input data): This defines the group of metric that have been defined as material for a company  */
export type Esrs_MaterialMetric_ = {
  __typename?: 'esrs_MaterialMetric';
  /** An array relationship */
  childrenMetrics: Array<MetricDependency_>;
  /** An aggregate relationship */
  childrenMetrics_aggregate: MetricDependency_Aggregate_;
  createdAt: Scalars['timestamptz']['output'];
  dataCollection?: Maybe<Scalars['String']['output']>;
  deprecated_isCopiedFromParent: Scalars['Boolean']['output'];
  frequency: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  isDataGatheringOnly: Scalars['Boolean']['output'];
  isHidden: Scalars['Boolean']['output'];
  isMaterial?: Maybe<Scalars['Boolean']['output']>;
  isPhasedIn: Scalars['Boolean']['output'];
  /** An array relationship */
  materialMetricTags: Array<Esrs_MaterialMetricTag_>;
  /** An aggregate relationship */
  materialMetricTags_aggregate: Esrs_MaterialMetricTag_Aggregate_;
  /** An object relationship */
  materialStandard: Esrs_MaterialStandard_;
  materialStandardId: Scalars['uuid']['output'];
  /** This field is optional, for extra data? */
  metadata?: Maybe<Scalars['jsonb']['output']>;
  /** An object relationship */
  metric: EsrsMetric_;
  metricRef: Scalars['String']['output'];
  /** An array relationship */
  parentMetrics: Array<MetricDependency_>;
  /** An aggregate relationship */
  parentMetrics_aggregate: MetricDependency_Aggregate_;
  updatedAt: Scalars['timestamptz']['output'];
};


/** (user input data): This defines the group of metric that have been defined as material for a company  */
export type Esrs_MaterialMetricChildrenMetricsArgs_ = {
  distinct_on?: InputMaybe<Array<MetricDependency_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricDependency_Order_By_>>;
  where?: InputMaybe<MetricDependency_Bool_Exp_>;
};


/** (user input data): This defines the group of metric that have been defined as material for a company  */
export type Esrs_MaterialMetricChildrenMetrics_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MetricDependency_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricDependency_Order_By_>>;
  where?: InputMaybe<MetricDependency_Bool_Exp_>;
};


/** (user input data): This defines the group of metric that have been defined as material for a company  */
export type Esrs_MaterialMetricMaterialMetricTagsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetricTag_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
};


/** (user input data): This defines the group of metric that have been defined as material for a company  */
export type Esrs_MaterialMetricMaterialMetricTags_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetricTag_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
};


/** (user input data): This defines the group of metric that have been defined as material for a company  */
export type Esrs_MaterialMetricMetadataArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** (user input data): This defines the group of metric that have been defined as material for a company  */
export type Esrs_MaterialMetricParentMetricsArgs_ = {
  distinct_on?: InputMaybe<Array<MetricDependency_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricDependency_Order_By_>>;
  where?: InputMaybe<MetricDependency_Bool_Exp_>;
};


/** (user input data): This defines the group of metric that have been defined as material for a company  */
export type Esrs_MaterialMetricParentMetrics_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MetricDependency_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricDependency_Order_By_>>;
  where?: InputMaybe<MetricDependency_Bool_Exp_>;
};

/** columns and relationships of "esrs.MaterialMetricTag" */
export type Esrs_MaterialMetricTag_ = {
  __typename?: 'esrs_MaterialMetricTag';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isOptional: Scalars['Boolean']['output'];
  /** An object relationship */
  materialMetric: Esrs_MaterialMetric_;
  materialMetricId: Scalars['uuid']['output'];
  /** An array relationship */
  materialTagValues: Array<Esrs_MaterialTagValue_>;
  /** An aggregate relationship */
  materialTagValues_aggregate: Esrs_MaterialTagValue_Aggregate_;
  /** An object relationship */
  metricTagType: TagType_;
  tagType: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "esrs.MaterialMetricTag" */
export type Esrs_MaterialMetricTagMaterialTagValuesArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialTagValue_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialTagValue_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialTagValue_Bool_Exp_>;
};


/** columns and relationships of "esrs.MaterialMetricTag" */
export type Esrs_MaterialMetricTagMaterialTagValues_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialTagValue_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialTagValue_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialTagValue_Bool_Exp_>;
};

/** aggregated selection of "esrs.MaterialMetricTag" */
export type Esrs_MaterialMetricTag_Aggregate_ = {
  __typename?: 'esrs_MaterialMetricTag_aggregate';
  aggregate?: Maybe<Esrs_MaterialMetricTag_Aggregate_Fields_>;
  nodes: Array<Esrs_MaterialMetricTag_>;
};

export type Esrs_MaterialMetricTag_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Esrs_MaterialMetricTag_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Esrs_MaterialMetricTag_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Esrs_MaterialMetricTag_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_MaterialMetricTag_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Esrs_MaterialMetricTag_Select_Column_Esrs_MaterialMetricTag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_MaterialMetricTag_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Esrs_MaterialMetricTag_Select_Column_Esrs_MaterialMetricTag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_MaterialMetricTag_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_MaterialMetricTag_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.MaterialMetricTag" */
export type Esrs_MaterialMetricTag_Aggregate_Fields_ = {
  __typename?: 'esrs_MaterialMetricTag_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_MaterialMetricTag_Max_Fields_>;
  min?: Maybe<Esrs_MaterialMetricTag_Min_Fields_>;
};


/** aggregate fields of "esrs.MaterialMetricTag" */
export type Esrs_MaterialMetricTag_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_MaterialMetricTag_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.MaterialMetricTag" */
export type Esrs_MaterialMetricTag_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_MaterialMetricTag_Max_Order_By_>;
  min?: InputMaybe<Esrs_MaterialMetricTag_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.MaterialMetricTag" */
export type Esrs_MaterialMetricTag_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_MaterialMetricTag_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_MaterialMetricTag_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.MaterialMetricTag". All fields are combined with a logical 'AND'. */
export type Esrs_MaterialMetricTag_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_MaterialMetricTag_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_MaterialMetricTag_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isOptional?: InputMaybe<Boolean_Comparison_Exp_>;
  materialMetric?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
  materialMetricId?: InputMaybe<Uuid_Comparison_Exp_>;
  materialTagValues?: InputMaybe<Esrs_MaterialTagValue_Bool_Exp_>;
  materialTagValues_aggregate?: InputMaybe<Esrs_MaterialTagValue_Aggregate_Bool_Exp_>;
  metricTagType?: InputMaybe<TagType_Bool_Exp_>;
  tagType?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.MaterialMetricTag" */
export enum Esrs_MaterialMetricTag_Constraint_ {
  /** unique or primary key constraint on columns "materialMetricId", "tagType" */
  MaterialMetricTagMaterialMetricIdTagTypeKey_ = 'MaterialMetricTag_materialMetricId_tagType_key',
  /** unique or primary key constraint on columns "id" */
  MaterialMetricTagPkey_ = 'MaterialMetricTag_pkey'
}

/** input type for inserting data into table "esrs.MaterialMetricTag" */
export type Esrs_MaterialMetricTag_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  materialMetric?: InputMaybe<Esrs_MaterialMetric_Obj_Rel_Insert_Input_>;
  materialMetricId?: InputMaybe<Scalars['uuid']['input']>;
  materialTagValues?: InputMaybe<Esrs_MaterialTagValue_Arr_Rel_Insert_Input_>;
  metricTagType?: InputMaybe<TagType_Obj_Rel_Insert_Input_>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_MaterialMetricTag_Max_Fields_ = {
  __typename?: 'esrs_MaterialMetricTag_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialMetricId?: Maybe<Scalars['uuid']['output']>;
  tagType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.MaterialMetricTag" */
export type Esrs_MaterialMetricTag_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialMetricId?: InputMaybe<Order_By_>;
  tagType?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_MaterialMetricTag_Min_Fields_ = {
  __typename?: 'esrs_MaterialMetricTag_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialMetricId?: Maybe<Scalars['uuid']['output']>;
  tagType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.MaterialMetricTag" */
export type Esrs_MaterialMetricTag_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialMetricId?: InputMaybe<Order_By_>;
  tagType?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.MaterialMetricTag" */
export type Esrs_MaterialMetricTag_Mutation_Response_ = {
  __typename?: 'esrs_MaterialMetricTag_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_MaterialMetricTag_>;
};

/** input type for inserting object relation for remote table "esrs.MaterialMetricTag" */
export type Esrs_MaterialMetricTag_Obj_Rel_Insert_Input_ = {
  data: Esrs_MaterialMetricTag_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_MaterialMetricTag_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.MaterialMetricTag" */
export type Esrs_MaterialMetricTag_On_Conflict_ = {
  constraint: Esrs_MaterialMetricTag_Constraint_;
  update_columns?: Array<Esrs_MaterialMetricTag_Update_Column_>;
  where?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.MaterialMetricTag". */
export type Esrs_MaterialMetricTag_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isOptional?: InputMaybe<Order_By_>;
  materialMetric?: InputMaybe<Esrs_MaterialMetric_Order_By_>;
  materialMetricId?: InputMaybe<Order_By_>;
  materialTagValues_aggregate?: InputMaybe<Esrs_MaterialTagValue_Aggregate_Order_By_>;
  metricTagType?: InputMaybe<TagType_Order_By_>;
  tagType?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.MaterialMetricTag */
export type Esrs_MaterialMetricTag_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.MaterialMetricTag" */
export enum Esrs_MaterialMetricTag_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsOptional_ = 'isOptional',
  /** column name */
  MaterialMetricId_ = 'materialMetricId',
  /** column name */
  TagType_ = 'tagType',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "esrs_MaterialMetricTag_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.MaterialMetricTag" */
export enum Esrs_MaterialMetricTag_Select_Column_Esrs_MaterialMetricTag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsOptional_ = 'isOptional'
}

/** select "esrs_MaterialMetricTag_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.MaterialMetricTag" */
export enum Esrs_MaterialMetricTag_Select_Column_Esrs_MaterialMetricTag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsOptional_ = 'isOptional'
}

/** input type for updating data in table "esrs.MaterialMetricTag" */
export type Esrs_MaterialMetricTag_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  materialMetricId?: InputMaybe<Scalars['uuid']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_MaterialMetricTag" */
export type Esrs_MaterialMetricTag_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_MaterialMetricTag_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_MaterialMetricTag_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isOptional?: InputMaybe<Scalars['Boolean']['input']>;
  materialMetricId?: InputMaybe<Scalars['uuid']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.MaterialMetricTag" */
export enum Esrs_MaterialMetricTag_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsOptional_ = 'isOptional',
  /** column name */
  MaterialMetricId_ = 'materialMetricId',
  /** column name */
  TagType_ = 'tagType',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_MaterialMetricTag_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_MaterialMetricTag_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_MaterialMetricTag_Bool_Exp_;
};

/** aggregated selection of "esrs.MaterialMetric" */
export type Esrs_MaterialMetric_Aggregate_ = {
  __typename?: 'esrs_MaterialMetric_aggregate';
  aggregate?: Maybe<Esrs_MaterialMetric_Aggregate_Fields_>;
  nodes: Array<Esrs_MaterialMetric_>;
};

export type Esrs_MaterialMetric_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Esrs_MaterialMetric_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Esrs_MaterialMetric_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Esrs_MaterialMetric_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_MaterialMetric_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Esrs_MaterialMetric_Select_Column_Esrs_MaterialMetric_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_MaterialMetric_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Esrs_MaterialMetric_Select_Column_Esrs_MaterialMetric_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_MaterialMetric_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_MaterialMetric_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.MaterialMetric" */
export type Esrs_MaterialMetric_Aggregate_Fields_ = {
  __typename?: 'esrs_MaterialMetric_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_MaterialMetric_Max_Fields_>;
  min?: Maybe<Esrs_MaterialMetric_Min_Fields_>;
};


/** aggregate fields of "esrs.MaterialMetric" */
export type Esrs_MaterialMetric_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_MaterialMetric_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.MaterialMetric" */
export type Esrs_MaterialMetric_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_MaterialMetric_Max_Order_By_>;
  min?: InputMaybe<Esrs_MaterialMetric_Min_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Esrs_MaterialMetric_Append_Input_ = {
  /** This field is optional, for extra data? */
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "esrs.MaterialMetric" */
export type Esrs_MaterialMetric_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_MaterialMetric_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_MaterialMetric_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.MaterialMetric". All fields are combined with a logical 'AND'. */
export type Esrs_MaterialMetric_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_MaterialMetric_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_MaterialMetric_Bool_Exp_>>;
  childrenMetrics?: InputMaybe<MetricDependency_Bool_Exp_>;
  childrenMetrics_aggregate?: InputMaybe<MetricDependency_Aggregate_Bool_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  dataCollection?: InputMaybe<String_Comparison_Exp_>;
  deprecated_isCopiedFromParent?: InputMaybe<Boolean_Comparison_Exp_>;
  frequency?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isDataGatheringOnly?: InputMaybe<Boolean_Comparison_Exp_>;
  isHidden?: InputMaybe<Boolean_Comparison_Exp_>;
  isMaterial?: InputMaybe<Boolean_Comparison_Exp_>;
  isPhasedIn?: InputMaybe<Boolean_Comparison_Exp_>;
  materialMetricTags?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
  materialMetricTags_aggregate?: InputMaybe<Esrs_MaterialMetricTag_Aggregate_Bool_Exp_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  materialStandardId?: InputMaybe<Uuid_Comparison_Exp_>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp_>;
  metric?: InputMaybe<EsrsMetric_Bool_Exp_>;
  metricRef?: InputMaybe<String_Comparison_Exp_>;
  parentMetrics?: InputMaybe<MetricDependency_Bool_Exp_>;
  parentMetrics_aggregate?: InputMaybe<MetricDependency_Aggregate_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.MaterialMetric" */
export enum Esrs_MaterialMetric_Constraint_ {
  /** unique or primary key constraint on columns "materialStandardId", "metricRef" */
  MaterialMetricMaterialStandardIdMetricRefKey_ = 'MaterialMetric_materialStandardId_metricRef_key',
  /** unique or primary key constraint on columns "id" */
  MaterialMetricPkey_ = 'MaterialMetric_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Esrs_MaterialMetric_Delete_At_Path_Input_ = {
  /** This field is optional, for extra data? */
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Esrs_MaterialMetric_Delete_Elem_Input_ = {
  /** This field is optional, for extra data? */
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Esrs_MaterialMetric_Delete_Key_Input_ = {
  /** This field is optional, for extra data? */
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "esrs.MaterialMetric" */
export type Esrs_MaterialMetric_Insert_Input_ = {
  childrenMetrics?: InputMaybe<MetricDependency_Arr_Rel_Insert_Input_>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataCollection?: InputMaybe<Scalars['String']['input']>;
  deprecated_isCopiedFromParent?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDataGatheringOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  isPhasedIn?: InputMaybe<Scalars['Boolean']['input']>;
  materialMetricTags?: InputMaybe<Esrs_MaterialMetricTag_Arr_Rel_Insert_Input_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Obj_Rel_Insert_Input_>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  /** This field is optional, for extra data? */
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  metric?: InputMaybe<EsrsMetric_Obj_Rel_Insert_Input_>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  parentMetrics?: InputMaybe<MetricDependency_Arr_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_MaterialMetric_Max_Fields_ = {
  __typename?: 'esrs_MaterialMetric_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataCollection?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  metricRef?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.MaterialMetric" */
export type Esrs_MaterialMetric_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  dataCollection?: InputMaybe<Order_By_>;
  frequency?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialStandardId?: InputMaybe<Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_MaterialMetric_Min_Fields_ = {
  __typename?: 'esrs_MaterialMetric_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataCollection?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialStandardId?: Maybe<Scalars['uuid']['output']>;
  metricRef?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.MaterialMetric" */
export type Esrs_MaterialMetric_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  dataCollection?: InputMaybe<Order_By_>;
  frequency?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialStandardId?: InputMaybe<Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.MaterialMetric" */
export type Esrs_MaterialMetric_Mutation_Response_ = {
  __typename?: 'esrs_MaterialMetric_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_MaterialMetric_>;
};

/** input type for inserting object relation for remote table "esrs.MaterialMetric" */
export type Esrs_MaterialMetric_Obj_Rel_Insert_Input_ = {
  data: Esrs_MaterialMetric_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_MaterialMetric_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.MaterialMetric" */
export type Esrs_MaterialMetric_On_Conflict_ = {
  constraint: Esrs_MaterialMetric_Constraint_;
  update_columns?: Array<Esrs_MaterialMetric_Update_Column_>;
  where?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.MaterialMetric". */
export type Esrs_MaterialMetric_Order_By_ = {
  childrenMetrics_aggregate?: InputMaybe<MetricDependency_Aggregate_Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  dataCollection?: InputMaybe<Order_By_>;
  deprecated_isCopiedFromParent?: InputMaybe<Order_By_>;
  frequency?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isDataGatheringOnly?: InputMaybe<Order_By_>;
  isHidden?: InputMaybe<Order_By_>;
  isMaterial?: InputMaybe<Order_By_>;
  isPhasedIn?: InputMaybe<Order_By_>;
  materialMetricTags_aggregate?: InputMaybe<Esrs_MaterialMetricTag_Aggregate_Order_By_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Order_By_>;
  materialStandardId?: InputMaybe<Order_By_>;
  metadata?: InputMaybe<Order_By_>;
  metric?: InputMaybe<EsrsMetric_Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
  parentMetrics_aggregate?: InputMaybe<MetricDependency_Aggregate_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.MaterialMetric */
export type Esrs_MaterialMetric_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Esrs_MaterialMetric_Prepend_Input_ = {
  /** This field is optional, for extra data? */
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "esrs.MaterialMetric" */
export enum Esrs_MaterialMetric_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DataCollection_ = 'dataCollection',
  /** column name */
  DeprecatedIsCopiedFromParent_ = 'deprecated_isCopiedFromParent',
  /** column name */
  Frequency_ = 'frequency',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsDataGatheringOnly_ = 'isDataGatheringOnly',
  /** column name */
  IsHidden_ = 'isHidden',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  IsPhasedIn_ = 'isPhasedIn',
  /** column name */
  MaterialStandardId_ = 'materialStandardId',
  /** column name */
  Metadata_ = 'metadata',
  /** column name */
  MetricRef_ = 'metricRef',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "esrs_MaterialMetric_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.MaterialMetric" */
export enum Esrs_MaterialMetric_Select_Column_Esrs_MaterialMetric_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  DeprecatedIsCopiedFromParent_ = 'deprecated_isCopiedFromParent',
  /** column name */
  IsDataGatheringOnly_ = 'isDataGatheringOnly',
  /** column name */
  IsHidden_ = 'isHidden',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  IsPhasedIn_ = 'isPhasedIn'
}

/** select "esrs_MaterialMetric_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.MaterialMetric" */
export enum Esrs_MaterialMetric_Select_Column_Esrs_MaterialMetric_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  DeprecatedIsCopiedFromParent_ = 'deprecated_isCopiedFromParent',
  /** column name */
  IsDataGatheringOnly_ = 'isDataGatheringOnly',
  /** column name */
  IsHidden_ = 'isHidden',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  IsPhasedIn_ = 'isPhasedIn'
}

/** input type for updating data in table "esrs.MaterialMetric" */
export type Esrs_MaterialMetric_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataCollection?: InputMaybe<Scalars['String']['input']>;
  deprecated_isCopiedFromParent?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDataGatheringOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  isPhasedIn?: InputMaybe<Scalars['Boolean']['input']>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  /** This field is optional, for extra data? */
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_MaterialMetric" */
export type Esrs_MaterialMetric_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_MaterialMetric_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_MaterialMetric_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataCollection?: InputMaybe<Scalars['String']['input']>;
  deprecated_isCopiedFromParent?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDataGatheringOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  isPhasedIn?: InputMaybe<Scalars['Boolean']['input']>;
  materialStandardId?: InputMaybe<Scalars['uuid']['input']>;
  /** This field is optional, for extra data? */
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.MaterialMetric" */
export enum Esrs_MaterialMetric_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DataCollection_ = 'dataCollection',
  /** column name */
  DeprecatedIsCopiedFromParent_ = 'deprecated_isCopiedFromParent',
  /** column name */
  Frequency_ = 'frequency',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsDataGatheringOnly_ = 'isDataGatheringOnly',
  /** column name */
  IsHidden_ = 'isHidden',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  IsPhasedIn_ = 'isPhasedIn',
  /** column name */
  MaterialStandardId_ = 'materialStandardId',
  /** column name */
  Metadata_ = 'metadata',
  /** column name */
  MetricRef_ = 'metricRef',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_MaterialMetric_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Esrs_MaterialMetric_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Esrs_MaterialMetric_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Esrs_MaterialMetric_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Esrs_MaterialMetric_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Esrs_MaterialMetric_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_MaterialMetric_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_MaterialMetric_Bool_Exp_;
};

/** columns and relationships of "esrs.MaterialStandard" */
export type Esrs_MaterialStandard_ = {
  __typename?: 'esrs_MaterialStandard';
  /** An array relationship */
  actions: Array<Esrs_Actions_>;
  /** An aggregate relationship */
  actions_aggregate: Esrs_Actions_Aggregate_;
  assessmentId: Scalars['uuid']['output'];
  /** An object relationship */
  attachmentBox?: Maybe<AttachmentBox_>;
  createdAt: Scalars['timestamptz']['output'];
  deprecated_isCopiedFromParent: Scalars['Boolean']['output'];
  /** An array relationship */
  deprecated_materialDisclosureRequirements: Array<Esrs_Deprecated_MaterialDisclosureRequirement_>;
  /** An aggregate relationship */
  deprecated_materialDisclosureRequirements_aggregate: Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_;
  /** An array relationship */
  disclosureRequirementStatuses: Array<DisclosureRequirementStatus_>;
  /** An aggregate relationship */
  disclosureRequirementStatuses_aggregate: DisclosureRequirementStatus_Aggregate_;
  /** An object relationship */
  esrsAssessment: EsrsAssessment_;
  id: Scalars['uuid']['output'];
  isDataCollected: Scalars['Boolean']['output'];
  isDataGatheringOnly: Scalars['Boolean']['output'];
  isMaterial?: Maybe<Scalars['Boolean']['output']>;
  isPhasedIn: Scalars['Boolean']['output'];
  /** An array relationship */
  materialMetrics: Array<Esrs_MaterialMetric_>;
  /** An aggregate relationship */
  materialMetrics_aggregate: Esrs_MaterialMetric_Aggregate_;
  /** An array relationship */
  materialStandardOwners: Array<MaterialStandardOwner_>;
  /** An aggregate relationship */
  materialStandardOwners_aggregate: MaterialStandardOwner_Aggregate_;
  /** An object relationship */
  noteHistory?: Maybe<NoteHistory_>;
  /** An array relationship */
  policies: Array<Esrs_Policy_>;
  /** An aggregate relationship */
  policies_aggregate: Esrs_Policy_Aggregate_;
  /** An object relationship */
  standard: EsrsStandard_;
  standardRef: Scalars['String']['output'];
  /** An array relationship */
  targets: Array<Esrs_Target_>;
  /** An aggregate relationship */
  targets_aggregate: Esrs_Target_Aggregate_;
  /** An object relationship */
  task?: Maybe<Task_>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  updateSubsidiaries: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "esrs.MaterialStandard" */
export type Esrs_MaterialStandardActionsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Actions_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Actions_Order_By_>>;
  where?: InputMaybe<Esrs_Actions_Bool_Exp_>;
};


/** columns and relationships of "esrs.MaterialStandard" */
export type Esrs_MaterialStandardActions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Actions_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Actions_Order_By_>>;
  where?: InputMaybe<Esrs_Actions_Bool_Exp_>;
};


/** columns and relationships of "esrs.MaterialStandard" */
export type Esrs_MaterialStandardDeprecated_MaterialDisclosureRequirementsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_>;
};


/** columns and relationships of "esrs.MaterialStandard" */
export type Esrs_MaterialStandardDeprecated_MaterialDisclosureRequirements_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_>;
};


/** columns and relationships of "esrs.MaterialStandard" */
export type Esrs_MaterialStandardDisclosureRequirementStatusesArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementStatus_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementStatus_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementStatus_Bool_Exp_>;
};


/** columns and relationships of "esrs.MaterialStandard" */
export type Esrs_MaterialStandardDisclosureRequirementStatuses_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementStatus_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementStatus_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementStatus_Bool_Exp_>;
};


/** columns and relationships of "esrs.MaterialStandard" */
export type Esrs_MaterialStandardMaterialMetricsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetric_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
};


/** columns and relationships of "esrs.MaterialStandard" */
export type Esrs_MaterialStandardMaterialMetrics_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetric_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
};


/** columns and relationships of "esrs.MaterialStandard" */
export type Esrs_MaterialStandardMaterialStandardOwnersArgs_ = {
  distinct_on?: InputMaybe<Array<MaterialStandardOwner_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialStandardOwner_Order_By_>>;
  where?: InputMaybe<MaterialStandardOwner_Bool_Exp_>;
};


/** columns and relationships of "esrs.MaterialStandard" */
export type Esrs_MaterialStandardMaterialStandardOwners_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MaterialStandardOwner_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialStandardOwner_Order_By_>>;
  where?: InputMaybe<MaterialStandardOwner_Bool_Exp_>;
};


/** columns and relationships of "esrs.MaterialStandard" */
export type Esrs_MaterialStandardPoliciesArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Policy_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Policy_Order_By_>>;
  where?: InputMaybe<Esrs_Policy_Bool_Exp_>;
};


/** columns and relationships of "esrs.MaterialStandard" */
export type Esrs_MaterialStandardPolicies_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Policy_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Policy_Order_By_>>;
  where?: InputMaybe<Esrs_Policy_Bool_Exp_>;
};


/** columns and relationships of "esrs.MaterialStandard" */
export type Esrs_MaterialStandardTargetsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Target_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Target_Order_By_>>;
  where?: InputMaybe<Esrs_Target_Bool_Exp_>;
};


/** columns and relationships of "esrs.MaterialStandard" */
export type Esrs_MaterialStandardTargets_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Target_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Target_Order_By_>>;
  where?: InputMaybe<Esrs_Target_Bool_Exp_>;
};

/** aggregated selection of "esrs.MaterialStandard" */
export type Esrs_MaterialStandard_Aggregate_ = {
  __typename?: 'esrs_MaterialStandard_aggregate';
  aggregate?: Maybe<Esrs_MaterialStandard_Aggregate_Fields_>;
  nodes: Array<Esrs_MaterialStandard_>;
};

export type Esrs_MaterialStandard_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Esrs_MaterialStandard_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Esrs_MaterialStandard_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Esrs_MaterialStandard_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_MaterialStandard_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Esrs_MaterialStandard_Select_Column_Esrs_MaterialStandard_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_MaterialStandard_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Esrs_MaterialStandard_Select_Column_Esrs_MaterialStandard_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_MaterialStandard_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_MaterialStandard_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.MaterialStandard" */
export type Esrs_MaterialStandard_Aggregate_Fields_ = {
  __typename?: 'esrs_MaterialStandard_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_MaterialStandard_Max_Fields_>;
  min?: Maybe<Esrs_MaterialStandard_Min_Fields_>;
};


/** aggregate fields of "esrs.MaterialStandard" */
export type Esrs_MaterialStandard_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_MaterialStandard_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.MaterialStandard" */
export type Esrs_MaterialStandard_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_MaterialStandard_Max_Order_By_>;
  min?: InputMaybe<Esrs_MaterialStandard_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.MaterialStandard" */
export type Esrs_MaterialStandard_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_MaterialStandard_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_MaterialStandard_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.MaterialStandard". All fields are combined with a logical 'AND'. */
export type Esrs_MaterialStandard_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_MaterialStandard_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_MaterialStandard_Bool_Exp_>>;
  actions?: InputMaybe<Esrs_Actions_Bool_Exp_>;
  actions_aggregate?: InputMaybe<Esrs_Actions_Aggregate_Bool_Exp_>;
  assessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  attachmentBox?: InputMaybe<AttachmentBox_Bool_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  deprecated_isCopiedFromParent?: InputMaybe<Boolean_Comparison_Exp_>;
  deprecated_materialDisclosureRequirements?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_>;
  deprecated_materialDisclosureRequirements_aggregate?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Bool_Exp_>;
  disclosureRequirementStatuses?: InputMaybe<DisclosureRequirementStatus_Bool_Exp_>;
  disclosureRequirementStatuses_aggregate?: InputMaybe<DisclosureRequirementStatus_Aggregate_Bool_Exp_>;
  esrsAssessment?: InputMaybe<EsrsAssessment_Bool_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isDataCollected?: InputMaybe<Boolean_Comparison_Exp_>;
  isDataGatheringOnly?: InputMaybe<Boolean_Comparison_Exp_>;
  isMaterial?: InputMaybe<Boolean_Comparison_Exp_>;
  isPhasedIn?: InputMaybe<Boolean_Comparison_Exp_>;
  materialMetrics?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
  materialMetrics_aggregate?: InputMaybe<Esrs_MaterialMetric_Aggregate_Bool_Exp_>;
  materialStandardOwners?: InputMaybe<MaterialStandardOwner_Bool_Exp_>;
  materialStandardOwners_aggregate?: InputMaybe<MaterialStandardOwner_Aggregate_Bool_Exp_>;
  noteHistory?: InputMaybe<NoteHistory_Bool_Exp_>;
  policies?: InputMaybe<Esrs_Policy_Bool_Exp_>;
  policies_aggregate?: InputMaybe<Esrs_Policy_Aggregate_Bool_Exp_>;
  standard?: InputMaybe<EsrsStandard_Bool_Exp_>;
  standardRef?: InputMaybe<String_Comparison_Exp_>;
  targets?: InputMaybe<Esrs_Target_Bool_Exp_>;
  targets_aggregate?: InputMaybe<Esrs_Target_Aggregate_Bool_Exp_>;
  task?: InputMaybe<Task_Bool_Exp_>;
  taskId?: InputMaybe<Uuid_Comparison_Exp_>;
  updateSubsidiaries?: InputMaybe<Boolean_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.MaterialStandard" */
export enum Esrs_MaterialStandard_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  MaterialStandardPkey_ = 'MaterialStandard_pkey',
  /** unique or primary key constraint on columns "assessmentId", "standardRef" */
  MaterialStandardStandardRefAssessmentIdKey_ = 'MaterialStandard_standardRef_assessmentId_key'
}

/** input type for inserting data into table "esrs.MaterialStandard" */
export type Esrs_MaterialStandard_Insert_Input_ = {
  actions?: InputMaybe<Esrs_Actions_Arr_Rel_Insert_Input_>;
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  attachmentBox?: InputMaybe<AttachmentBox_Obj_Rel_Insert_Input_>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecated_isCopiedFromParent?: InputMaybe<Scalars['Boolean']['input']>;
  deprecated_materialDisclosureRequirements?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Arr_Rel_Insert_Input_>;
  disclosureRequirementStatuses?: InputMaybe<DisclosureRequirementStatus_Arr_Rel_Insert_Input_>;
  esrsAssessment?: InputMaybe<EsrsAssessment_Obj_Rel_Insert_Input_>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDataCollected?: InputMaybe<Scalars['Boolean']['input']>;
  isDataGatheringOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  isPhasedIn?: InputMaybe<Scalars['Boolean']['input']>;
  materialMetrics?: InputMaybe<Esrs_MaterialMetric_Arr_Rel_Insert_Input_>;
  materialStandardOwners?: InputMaybe<MaterialStandardOwner_Arr_Rel_Insert_Input_>;
  noteHistory?: InputMaybe<NoteHistory_Obj_Rel_Insert_Input_>;
  policies?: InputMaybe<Esrs_Policy_Arr_Rel_Insert_Input_>;
  standard?: InputMaybe<EsrsStandard_Obj_Rel_Insert_Input_>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
  targets?: InputMaybe<Esrs_Target_Arr_Rel_Insert_Input_>;
  task?: InputMaybe<Task_Obj_Rel_Insert_Input_>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  updateSubsidiaries?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_MaterialStandard_Max_Fields_ = {
  __typename?: 'esrs_MaterialStandard_max_fields';
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  standardRef?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.MaterialStandard" */
export type Esrs_MaterialStandard_Max_Order_By_ = {
  assessmentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
  taskId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_MaterialStandard_Min_Fields_ = {
  __typename?: 'esrs_MaterialStandard_min_fields';
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  standardRef?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.MaterialStandard" */
export type Esrs_MaterialStandard_Min_Order_By_ = {
  assessmentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
  taskId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.MaterialStandard" */
export type Esrs_MaterialStandard_Mutation_Response_ = {
  __typename?: 'esrs_MaterialStandard_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_MaterialStandard_>;
};

/** input type for inserting object relation for remote table "esrs.MaterialStandard" */
export type Esrs_MaterialStandard_Obj_Rel_Insert_Input_ = {
  data: Esrs_MaterialStandard_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_MaterialStandard_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.MaterialStandard" */
export type Esrs_MaterialStandard_On_Conflict_ = {
  constraint: Esrs_MaterialStandard_Constraint_;
  update_columns?: Array<Esrs_MaterialStandard_Update_Column_>;
  where?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.MaterialStandard". */
export type Esrs_MaterialStandard_Order_By_ = {
  actions_aggregate?: InputMaybe<Esrs_Actions_Aggregate_Order_By_>;
  assessmentId?: InputMaybe<Order_By_>;
  attachmentBox?: InputMaybe<AttachmentBox_Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  deprecated_isCopiedFromParent?: InputMaybe<Order_By_>;
  deprecated_materialDisclosureRequirements_aggregate?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_Order_By_>;
  disclosureRequirementStatuses_aggregate?: InputMaybe<DisclosureRequirementStatus_Aggregate_Order_By_>;
  esrsAssessment?: InputMaybe<EsrsAssessment_Order_By_>;
  id?: InputMaybe<Order_By_>;
  isDataCollected?: InputMaybe<Order_By_>;
  isDataGatheringOnly?: InputMaybe<Order_By_>;
  isMaterial?: InputMaybe<Order_By_>;
  isPhasedIn?: InputMaybe<Order_By_>;
  materialMetrics_aggregate?: InputMaybe<Esrs_MaterialMetric_Aggregate_Order_By_>;
  materialStandardOwners_aggregate?: InputMaybe<MaterialStandardOwner_Aggregate_Order_By_>;
  noteHistory?: InputMaybe<NoteHistory_Order_By_>;
  policies_aggregate?: InputMaybe<Esrs_Policy_Aggregate_Order_By_>;
  standard?: InputMaybe<EsrsStandard_Order_By_>;
  standardRef?: InputMaybe<Order_By_>;
  targets_aggregate?: InputMaybe<Esrs_Target_Aggregate_Order_By_>;
  task?: InputMaybe<Task_Order_By_>;
  taskId?: InputMaybe<Order_By_>;
  updateSubsidiaries?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.MaterialStandard */
export type Esrs_MaterialStandard_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.MaterialStandard" */
export enum Esrs_MaterialStandard_Select_Column_ {
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeprecatedIsCopiedFromParent_ = 'deprecated_isCopiedFromParent',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsDataCollected_ = 'isDataCollected',
  /** column name */
  IsDataGatheringOnly_ = 'isDataGatheringOnly',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  IsPhasedIn_ = 'isPhasedIn',
  /** column name */
  StandardRef_ = 'standardRef',
  /** column name */
  TaskId_ = 'taskId',
  /** column name */
  UpdateSubsidiaries_ = 'updateSubsidiaries',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "esrs_MaterialStandard_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.MaterialStandard" */
export enum Esrs_MaterialStandard_Select_Column_Esrs_MaterialStandard_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  DeprecatedIsCopiedFromParent_ = 'deprecated_isCopiedFromParent',
  /** column name */
  IsDataCollected_ = 'isDataCollected',
  /** column name */
  IsDataGatheringOnly_ = 'isDataGatheringOnly',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  IsPhasedIn_ = 'isPhasedIn',
  /** column name */
  UpdateSubsidiaries_ = 'updateSubsidiaries'
}

/** select "esrs_MaterialStandard_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.MaterialStandard" */
export enum Esrs_MaterialStandard_Select_Column_Esrs_MaterialStandard_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  DeprecatedIsCopiedFromParent_ = 'deprecated_isCopiedFromParent',
  /** column name */
  IsDataCollected_ = 'isDataCollected',
  /** column name */
  IsDataGatheringOnly_ = 'isDataGatheringOnly',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  IsPhasedIn_ = 'isPhasedIn',
  /** column name */
  UpdateSubsidiaries_ = 'updateSubsidiaries'
}

/** input type for updating data in table "esrs.MaterialStandard" */
export type Esrs_MaterialStandard_Set_Input_ = {
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecated_isCopiedFromParent?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDataCollected?: InputMaybe<Scalars['Boolean']['input']>;
  isDataGatheringOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  isPhasedIn?: InputMaybe<Scalars['Boolean']['input']>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  updateSubsidiaries?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_MaterialStandard" */
export type Esrs_MaterialStandard_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_MaterialStandard_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_MaterialStandard_Stream_Cursor_Value_Input_ = {
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deprecated_isCopiedFromParent?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isDataCollected?: InputMaybe<Scalars['Boolean']['input']>;
  isDataGatheringOnly?: InputMaybe<Scalars['Boolean']['input']>;
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
  isPhasedIn?: InputMaybe<Scalars['Boolean']['input']>;
  standardRef?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['uuid']['input']>;
  updateSubsidiaries?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.MaterialStandard" */
export enum Esrs_MaterialStandard_Update_Column_ {
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DeprecatedIsCopiedFromParent_ = 'deprecated_isCopiedFromParent',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsDataCollected_ = 'isDataCollected',
  /** column name */
  IsDataGatheringOnly_ = 'isDataGatheringOnly',
  /** column name */
  IsMaterial_ = 'isMaterial',
  /** column name */
  IsPhasedIn_ = 'isPhasedIn',
  /** column name */
  StandardRef_ = 'standardRef',
  /** column name */
  TaskId_ = 'taskId',
  /** column name */
  UpdateSubsidiaries_ = 'updateSubsidiaries',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_MaterialStandard_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_MaterialStandard_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_MaterialStandard_Bool_Exp_;
};

/** Tag values for MaterialMetricTypes */
export type Esrs_MaterialTagValue_ = {
  __typename?: 'esrs_MaterialTagValue';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  materialMetricTag: Esrs_MaterialMetricTag_;
  materialMetricTagId: Scalars['uuid']['output'];
  /** An object relationship */
  tag?: Maybe<TagValue_>;
  tagType: Scalars['String']['output'];
  tagValue: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "esrs.MaterialTagValue" */
export type Esrs_MaterialTagValue_Aggregate_ = {
  __typename?: 'esrs_MaterialTagValue_aggregate';
  aggregate?: Maybe<Esrs_MaterialTagValue_Aggregate_Fields_>;
  nodes: Array<Esrs_MaterialTagValue_>;
};

export type Esrs_MaterialTagValue_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Esrs_MaterialTagValue_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_MaterialTagValue_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_MaterialTagValue_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_MaterialTagValue_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.MaterialTagValue" */
export type Esrs_MaterialTagValue_Aggregate_Fields_ = {
  __typename?: 'esrs_MaterialTagValue_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_MaterialTagValue_Max_Fields_>;
  min?: Maybe<Esrs_MaterialTagValue_Min_Fields_>;
};


/** aggregate fields of "esrs.MaterialTagValue" */
export type Esrs_MaterialTagValue_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_MaterialTagValue_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.MaterialTagValue" */
export type Esrs_MaterialTagValue_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_MaterialTagValue_Max_Order_By_>;
  min?: InputMaybe<Esrs_MaterialTagValue_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.MaterialTagValue" */
export type Esrs_MaterialTagValue_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_MaterialTagValue_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_MaterialTagValue_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.MaterialTagValue". All fields are combined with a logical 'AND'. */
export type Esrs_MaterialTagValue_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_MaterialTagValue_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_MaterialTagValue_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_MaterialTagValue_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  materialMetricTag?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
  materialMetricTagId?: InputMaybe<Uuid_Comparison_Exp_>;
  tag?: InputMaybe<TagValue_Bool_Exp_>;
  tagType?: InputMaybe<String_Comparison_Exp_>;
  tagValue?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.MaterialTagValue" */
export enum Esrs_MaterialTagValue_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  MaterialTagValueIdKey_ = 'MaterialTagValue_id_key',
  /** unique or primary key constraint on columns "tagValue", "tagType", "materialMetricTagId" */
  MaterialTagValueMaterialMetricTagIdTagValueTagTypeKey_ = 'MaterialTagValue_materialMetricTagId_tagValue_tagType_key',
  /** unique or primary key constraint on columns "id" */
  MaterialTagValuePkey_ = 'MaterialTagValue_pkey'
}

/** input type for inserting data into table "esrs.MaterialTagValue" */
export type Esrs_MaterialTagValue_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialMetricTag?: InputMaybe<Esrs_MaterialMetricTag_Obj_Rel_Insert_Input_>;
  materialMetricTagId?: InputMaybe<Scalars['uuid']['input']>;
  tag?: InputMaybe<TagValue_Obj_Rel_Insert_Input_>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tagValue?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_MaterialTagValue_Max_Fields_ = {
  __typename?: 'esrs_MaterialTagValue_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialMetricTagId?: Maybe<Scalars['uuid']['output']>;
  tagType?: Maybe<Scalars['String']['output']>;
  tagValue?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.MaterialTagValue" */
export type Esrs_MaterialTagValue_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialMetricTagId?: InputMaybe<Order_By_>;
  tagType?: InputMaybe<Order_By_>;
  tagValue?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_MaterialTagValue_Min_Fields_ = {
  __typename?: 'esrs_MaterialTagValue_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  materialMetricTagId?: Maybe<Scalars['uuid']['output']>;
  tagType?: Maybe<Scalars['String']['output']>;
  tagValue?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.MaterialTagValue" */
export type Esrs_MaterialTagValue_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialMetricTagId?: InputMaybe<Order_By_>;
  tagType?: InputMaybe<Order_By_>;
  tagValue?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.MaterialTagValue" */
export type Esrs_MaterialTagValue_Mutation_Response_ = {
  __typename?: 'esrs_MaterialTagValue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_MaterialTagValue_>;
};

/** on_conflict condition type for table "esrs.MaterialTagValue" */
export type Esrs_MaterialTagValue_On_Conflict_ = {
  constraint: Esrs_MaterialTagValue_Constraint_;
  update_columns?: Array<Esrs_MaterialTagValue_Update_Column_>;
  where?: InputMaybe<Esrs_MaterialTagValue_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.MaterialTagValue". */
export type Esrs_MaterialTagValue_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialMetricTag?: InputMaybe<Esrs_MaterialMetricTag_Order_By_>;
  materialMetricTagId?: InputMaybe<Order_By_>;
  tag?: InputMaybe<TagValue_Order_By_>;
  tagType?: InputMaybe<Order_By_>;
  tagValue?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.MaterialTagValue */
export type Esrs_MaterialTagValue_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.MaterialTagValue" */
export enum Esrs_MaterialTagValue_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  MaterialMetricTagId_ = 'materialMetricTagId',
  /** column name */
  TagType_ = 'tagType',
  /** column name */
  TagValue_ = 'tagValue',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "esrs.MaterialTagValue" */
export type Esrs_MaterialTagValue_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialMetricTagId?: InputMaybe<Scalars['uuid']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tagValue?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_MaterialTagValue" */
export type Esrs_MaterialTagValue_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_MaterialTagValue_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_MaterialTagValue_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialMetricTagId?: InputMaybe<Scalars['uuid']['input']>;
  tagType?: InputMaybe<Scalars['String']['input']>;
  tagValue?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.MaterialTagValue" */
export enum Esrs_MaterialTagValue_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  MaterialMetricTagId_ = 'materialMetricTagId',
  /** column name */
  TagType_ = 'tagType',
  /** column name */
  TagValue_ = 'tagValue',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_MaterialTagValue_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_MaterialTagValue_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_MaterialTagValue_Bool_Exp_;
};

/** columns and relationships of "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_ = {
  __typename?: 'esrs_MetricDependencyClosure';
  childMetricRef?: Maybe<Scalars['String']['output']>;
  depth?: Maybe<Scalars['Int']['output']>;
  parentMetricRef?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  view_childMetric?: Maybe<EsrsMetric_>;
  /** An object relationship */
  view_parentMetric?: Maybe<EsrsMetric_>;
};

/** aggregated selection of "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Aggregate_ = {
  __typename?: 'esrs_MetricDependencyClosure_aggregate';
  aggregate?: Maybe<Esrs_MetricDependencyClosure_Aggregate_Fields_>;
  nodes: Array<Esrs_MetricDependencyClosure_>;
};

export type Esrs_MetricDependencyClosure_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Esrs_MetricDependencyClosure_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_MetricDependencyClosure_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_MetricDependencyClosure_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_MetricDependencyClosure_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Aggregate_Fields_ = {
  __typename?: 'esrs_MetricDependencyClosure_aggregate_fields';
  avg?: Maybe<Esrs_MetricDependencyClosure_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_MetricDependencyClosure_Max_Fields_>;
  min?: Maybe<Esrs_MetricDependencyClosure_Min_Fields_>;
  stddev?: Maybe<Esrs_MetricDependencyClosure_Stddev_Fields_>;
  stddev_pop?: Maybe<Esrs_MetricDependencyClosure_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<Esrs_MetricDependencyClosure_Stddev_Samp_Fields_>;
  sum?: Maybe<Esrs_MetricDependencyClosure_Sum_Fields_>;
  var_pop?: Maybe<Esrs_MetricDependencyClosure_Var_Pop_Fields_>;
  var_samp?: Maybe<Esrs_MetricDependencyClosure_Var_Samp_Fields_>;
  variance?: Maybe<Esrs_MetricDependencyClosure_Variance_Fields_>;
};


/** aggregate fields of "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_MetricDependencyClosure_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Aggregate_Order_By_ = {
  avg?: InputMaybe<Esrs_MetricDependencyClosure_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_MetricDependencyClosure_Max_Order_By_>;
  min?: InputMaybe<Esrs_MetricDependencyClosure_Min_Order_By_>;
  stddev?: InputMaybe<Esrs_MetricDependencyClosure_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<Esrs_MetricDependencyClosure_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<Esrs_MetricDependencyClosure_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<Esrs_MetricDependencyClosure_Sum_Order_By_>;
  var_pop?: InputMaybe<Esrs_MetricDependencyClosure_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<Esrs_MetricDependencyClosure_Var_Samp_Order_By_>;
  variance?: InputMaybe<Esrs_MetricDependencyClosure_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_MetricDependencyClosure_Insert_Input_>;
};

/** aggregate avg on columns */
export type Esrs_MetricDependencyClosure_Avg_Fields_ = {
  __typename?: 'esrs_MetricDependencyClosure_avg_fields';
  depth?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Avg_Order_By_ = {
  depth?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.MetricDependencyClosure". All fields are combined with a logical 'AND'. */
export type Esrs_MetricDependencyClosure_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_MetricDependencyClosure_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_MetricDependencyClosure_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_MetricDependencyClosure_Bool_Exp_>>;
  childMetricRef?: InputMaybe<String_Comparison_Exp_>;
  depth?: InputMaybe<Int_Comparison_Exp_>;
  parentMetricRef?: InputMaybe<String_Comparison_Exp_>;
  view_childMetric?: InputMaybe<EsrsMetric_Bool_Exp_>;
  view_parentMetric?: InputMaybe<EsrsMetric_Bool_Exp_>;
};

/** input type for inserting data into table "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Insert_Input_ = {
  childMetricRef?: InputMaybe<Scalars['String']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  parentMetricRef?: InputMaybe<Scalars['String']['input']>;
  view_childMetric?: InputMaybe<EsrsMetric_Obj_Rel_Insert_Input_>;
  view_parentMetric?: InputMaybe<EsrsMetric_Obj_Rel_Insert_Input_>;
};

/** aggregate max on columns */
export type Esrs_MetricDependencyClosure_Max_Fields_ = {
  __typename?: 'esrs_MetricDependencyClosure_max_fields';
  childMetricRef?: Maybe<Scalars['String']['output']>;
  depth?: Maybe<Scalars['Int']['output']>;
  parentMetricRef?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Max_Order_By_ = {
  childMetricRef?: InputMaybe<Order_By_>;
  depth?: InputMaybe<Order_By_>;
  parentMetricRef?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_MetricDependencyClosure_Min_Fields_ = {
  __typename?: 'esrs_MetricDependencyClosure_min_fields';
  childMetricRef?: Maybe<Scalars['String']['output']>;
  depth?: Maybe<Scalars['Int']['output']>;
  parentMetricRef?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Min_Order_By_ = {
  childMetricRef?: InputMaybe<Order_By_>;
  depth?: InputMaybe<Order_By_>;
  parentMetricRef?: InputMaybe<Order_By_>;
};

/** Ordering options when selecting data from "esrs.MetricDependencyClosure". */
export type Esrs_MetricDependencyClosure_Order_By_ = {
  childMetricRef?: InputMaybe<Order_By_>;
  depth?: InputMaybe<Order_By_>;
  parentMetricRef?: InputMaybe<Order_By_>;
  view_childMetric?: InputMaybe<EsrsMetric_Order_By_>;
  view_parentMetric?: InputMaybe<EsrsMetric_Order_By_>;
};

/** select columns of table "esrs.MetricDependencyClosure" */
export enum Esrs_MetricDependencyClosure_Select_Column_ {
  /** column name */
  ChildMetricRef_ = 'childMetricRef',
  /** column name */
  Depth_ = 'depth',
  /** column name */
  ParentMetricRef_ = 'parentMetricRef'
}

/** aggregate stddev on columns */
export type Esrs_MetricDependencyClosure_Stddev_Fields_ = {
  __typename?: 'esrs_MetricDependencyClosure_stddev_fields';
  depth?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Stddev_Order_By_ = {
  depth?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type Esrs_MetricDependencyClosure_Stddev_Pop_Fields_ = {
  __typename?: 'esrs_MetricDependencyClosure_stddev_pop_fields';
  depth?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Stddev_Pop_Order_By_ = {
  depth?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type Esrs_MetricDependencyClosure_Stddev_Samp_Fields_ = {
  __typename?: 'esrs_MetricDependencyClosure_stddev_samp_fields';
  depth?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Stddev_Samp_Order_By_ = {
  depth?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "esrs_MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_MetricDependencyClosure_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_MetricDependencyClosure_Stream_Cursor_Value_Input_ = {
  childMetricRef?: InputMaybe<Scalars['String']['input']>;
  depth?: InputMaybe<Scalars['Int']['input']>;
  parentMetricRef?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Esrs_MetricDependencyClosure_Sum_Fields_ = {
  __typename?: 'esrs_MetricDependencyClosure_sum_fields';
  depth?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Sum_Order_By_ = {
  depth?: InputMaybe<Order_By_>;
};

/** aggregate var_pop on columns */
export type Esrs_MetricDependencyClosure_Var_Pop_Fields_ = {
  __typename?: 'esrs_MetricDependencyClosure_var_pop_fields';
  depth?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Var_Pop_Order_By_ = {
  depth?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type Esrs_MetricDependencyClosure_Var_Samp_Fields_ = {
  __typename?: 'esrs_MetricDependencyClosure_var_samp_fields';
  depth?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Var_Samp_Order_By_ = {
  depth?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type Esrs_MetricDependencyClosure_Variance_Fields_ = {
  __typename?: 'esrs_MetricDependencyClosure_variance_fields';
  depth?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.MetricDependencyClosure" */
export type Esrs_MetricDependencyClosure_Variance_Order_By_ = {
  depth?: InputMaybe<Order_By_>;
};

/** columns and relationships of "esrs.MetricRelatedDisclosureRequirement" */
export type Esrs_MetricRelatedDisclosureRequirement_ = {
  __typename?: 'esrs_MetricRelatedDisclosureRequirement';
  /** An object relationship */
  disclosureRequirement?: Maybe<DisclosureRequirement_>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  frameworkRef?: Maybe<Scalars['String']['output']>;
  metricRef?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "esrs.MetricRelatedDisclosureRequirement" */
export type Esrs_MetricRelatedDisclosureRequirement_Aggregate_ = {
  __typename?: 'esrs_MetricRelatedDisclosureRequirement_aggregate';
  aggregate?: Maybe<Esrs_MetricRelatedDisclosureRequirement_Aggregate_Fields_>;
  nodes: Array<Esrs_MetricRelatedDisclosureRequirement_>;
};

export type Esrs_MetricRelatedDisclosureRequirement_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_MetricRelatedDisclosureRequirement_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.MetricRelatedDisclosureRequirement" */
export type Esrs_MetricRelatedDisclosureRequirement_Aggregate_Fields_ = {
  __typename?: 'esrs_MetricRelatedDisclosureRequirement_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_MetricRelatedDisclosureRequirement_Max_Fields_>;
  min?: Maybe<Esrs_MetricRelatedDisclosureRequirement_Min_Fields_>;
};


/** aggregate fields of "esrs.MetricRelatedDisclosureRequirement" */
export type Esrs_MetricRelatedDisclosureRequirement_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.MetricRelatedDisclosureRequirement" */
export type Esrs_MetricRelatedDisclosureRequirement_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Max_Order_By_>;
  min?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.MetricRelatedDisclosureRequirement" */
export type Esrs_MetricRelatedDisclosureRequirement_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_MetricRelatedDisclosureRequirement_Insert_Input_>;
};

/** Boolean expression to filter rows from the table "esrs.MetricRelatedDisclosureRequirement". All fields are combined with a logical 'AND'. */
export type Esrs_MetricRelatedDisclosureRequirement_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Bool_Exp_>>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  disclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
  frameworkRef?: InputMaybe<String_Comparison_Exp_>;
  metricRef?: InputMaybe<String_Comparison_Exp_>;
};

/** input type for inserting data into table "esrs.MetricRelatedDisclosureRequirement" */
export type Esrs_MetricRelatedDisclosureRequirement_Insert_Input_ = {
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Obj_Rel_Insert_Input_>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  frameworkRef?: InputMaybe<Scalars['String']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Esrs_MetricRelatedDisclosureRequirement_Max_Fields_ = {
  __typename?: 'esrs_MetricRelatedDisclosureRequirement_max_fields';
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  frameworkRef?: Maybe<Scalars['String']['output']>;
  metricRef?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.MetricRelatedDisclosureRequirement" */
export type Esrs_MetricRelatedDisclosureRequirement_Max_Order_By_ = {
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  frameworkRef?: InputMaybe<Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_MetricRelatedDisclosureRequirement_Min_Fields_ = {
  __typename?: 'esrs_MetricRelatedDisclosureRequirement_min_fields';
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  frameworkRef?: Maybe<Scalars['String']['output']>;
  metricRef?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.MetricRelatedDisclosureRequirement" */
export type Esrs_MetricRelatedDisclosureRequirement_Min_Order_By_ = {
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  frameworkRef?: InputMaybe<Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
};

/** Ordering options when selecting data from "esrs.MetricRelatedDisclosureRequirement". */
export type Esrs_MetricRelatedDisclosureRequirement_Order_By_ = {
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  frameworkRef?: InputMaybe<Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
};

/** select columns of table "esrs.MetricRelatedDisclosureRequirement" */
export enum Esrs_MetricRelatedDisclosureRequirement_Select_Column_ {
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  FrameworkRef_ = 'frameworkRef',
  /** column name */
  MetricRef_ = 'metricRef'
}

/** Streaming cursor of the table "esrs_MetricRelatedDisclosureRequirement" */
export type Esrs_MetricRelatedDisclosureRequirement_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_MetricRelatedDisclosureRequirement_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_MetricRelatedDisclosureRequirement_Stream_Cursor_Value_Input_ = {
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  frameworkRef?: InputMaybe<Scalars['String']['input']>;
  metricRef?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "esrs.Milestone" */
export type Esrs_Milestone_ = {
  __typename?: 'esrs_Milestone';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  isRelative: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  /** An array relationship */
  milestoneResults: Array<Esrs_MilestoneResult_>;
  /** An aggregate relationship */
  milestoneResults_aggregate: Esrs_MilestoneResult_Aggregate_;
  /** An object relationship */
  target: Esrs_Target_;
  targetId: Scalars['uuid']['output'];
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  year: Scalars['Int']['output'];
};


/** columns and relationships of "esrs.Milestone" */
export type Esrs_MilestoneMilestoneResultsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MilestoneResult_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MilestoneResult_Order_By_>>;
  where?: InputMaybe<Esrs_MilestoneResult_Bool_Exp_>;
};


/** columns and relationships of "esrs.Milestone" */
export type Esrs_MilestoneMilestoneResults_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MilestoneResult_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MilestoneResult_Order_By_>>;
  where?: InputMaybe<Esrs_MilestoneResult_Bool_Exp_>;
};

/** columns and relationships of "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_ = {
  __typename?: 'esrs_MilestoneResult';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  milestone: Esrs_Milestone_;
  milestoneId: Scalars['uuid']['output'];
  /** An object relationship */
  reportingUnit?: Maybe<Esrs_ReportingUnit_>;
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  value?: Maybe<Scalars['numeric']['output']>;
};

/** aggregated selection of "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Aggregate_ = {
  __typename?: 'esrs_MilestoneResult_aggregate';
  aggregate?: Maybe<Esrs_MilestoneResult_Aggregate_Fields_>;
  nodes: Array<Esrs_MilestoneResult_>;
};

export type Esrs_MilestoneResult_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Esrs_MilestoneResult_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_MilestoneResult_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_MilestoneResult_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_MilestoneResult_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Aggregate_Fields_ = {
  __typename?: 'esrs_MilestoneResult_aggregate_fields';
  avg?: Maybe<Esrs_MilestoneResult_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_MilestoneResult_Max_Fields_>;
  min?: Maybe<Esrs_MilestoneResult_Min_Fields_>;
  stddev?: Maybe<Esrs_MilestoneResult_Stddev_Fields_>;
  stddev_pop?: Maybe<Esrs_MilestoneResult_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<Esrs_MilestoneResult_Stddev_Samp_Fields_>;
  sum?: Maybe<Esrs_MilestoneResult_Sum_Fields_>;
  var_pop?: Maybe<Esrs_MilestoneResult_Var_Pop_Fields_>;
  var_samp?: Maybe<Esrs_MilestoneResult_Var_Samp_Fields_>;
  variance?: Maybe<Esrs_MilestoneResult_Variance_Fields_>;
};


/** aggregate fields of "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_MilestoneResult_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Aggregate_Order_By_ = {
  avg?: InputMaybe<Esrs_MilestoneResult_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_MilestoneResult_Max_Order_By_>;
  min?: InputMaybe<Esrs_MilestoneResult_Min_Order_By_>;
  stddev?: InputMaybe<Esrs_MilestoneResult_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<Esrs_MilestoneResult_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<Esrs_MilestoneResult_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<Esrs_MilestoneResult_Sum_Order_By_>;
  var_pop?: InputMaybe<Esrs_MilestoneResult_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<Esrs_MilestoneResult_Var_Samp_Order_By_>;
  variance?: InputMaybe<Esrs_MilestoneResult_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_MilestoneResult_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_MilestoneResult_On_Conflict_>;
};

/** aggregate avg on columns */
export type Esrs_MilestoneResult_Avg_Fields_ = {
  __typename?: 'esrs_MilestoneResult_avg_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Avg_Order_By_ = {
  value?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.MilestoneResult". All fields are combined with a logical 'AND'. */
export type Esrs_MilestoneResult_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_MilestoneResult_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_MilestoneResult_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_MilestoneResult_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  milestone?: InputMaybe<Esrs_Milestone_Bool_Exp_>;
  milestoneId?: InputMaybe<Uuid_Comparison_Exp_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
  reportingUnitId?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  value?: InputMaybe<Numeric_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.MilestoneResult" */
export enum Esrs_MilestoneResult_Constraint_ {
  /** unique or primary key constraint on columns "milestoneId", "reportingUnitId" */
  MilestoneResultMilestoneIdBusinessUnitAssessmentIdKey_ = 'MilestoneResult_milestoneId_businessUnitAssessmentId_key',
  /** unique or primary key constraint on columns "id" */
  MilestoneResultPkey_ = 'MilestoneResult_pkey'
}

/** input type for incrementing numeric columns in table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Inc_Input_ = {
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  milestone?: InputMaybe<Esrs_Milestone_Obj_Rel_Insert_Input_>;
  milestoneId?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Obj_Rel_Insert_Input_>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate max on columns */
export type Esrs_MilestoneResult_Max_Fields_ = {
  __typename?: 'esrs_MilestoneResult_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  milestoneId?: Maybe<Scalars['uuid']['output']>;
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by max() on columns of table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Max_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  milestoneId?: InputMaybe<Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_MilestoneResult_Min_Fields_ = {
  __typename?: 'esrs_MilestoneResult_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  milestoneId?: Maybe<Scalars['uuid']['output']>;
  reportingUnitId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by min() on columns of table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Min_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  milestoneId?: InputMaybe<Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Mutation_Response_ = {
  __typename?: 'esrs_MilestoneResult_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_MilestoneResult_>;
};

/** on_conflict condition type for table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_On_Conflict_ = {
  constraint: Esrs_MilestoneResult_Constraint_;
  update_columns?: Array<Esrs_MilestoneResult_Update_Column_>;
  where?: InputMaybe<Esrs_MilestoneResult_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.MilestoneResult". */
export type Esrs_MilestoneResult_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  milestone?: InputMaybe<Esrs_Milestone_Order_By_>;
  milestoneId?: InputMaybe<Order_By_>;
  reportingUnit?: InputMaybe<Esrs_ReportingUnit_Order_By_>;
  reportingUnitId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  value?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.MilestoneResult */
export type Esrs_MilestoneResult_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.MilestoneResult" */
export enum Esrs_MilestoneResult_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  MilestoneId_ = 'milestoneId',
  /** column name */
  ReportingUnitId_ = 'reportingUnitId',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Value_ = 'value'
}

/** input type for updating data in table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  milestoneId?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate stddev on columns */
export type Esrs_MilestoneResult_Stddev_Fields_ = {
  __typename?: 'esrs_MilestoneResult_stddev_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Stddev_Order_By_ = {
  value?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type Esrs_MilestoneResult_Stddev_Pop_Fields_ = {
  __typename?: 'esrs_MilestoneResult_stddev_pop_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Stddev_Pop_Order_By_ = {
  value?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type Esrs_MilestoneResult_Stddev_Samp_Fields_ = {
  __typename?: 'esrs_MilestoneResult_stddev_samp_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Stddev_Samp_Order_By_ = {
  value?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "esrs_MilestoneResult" */
export type Esrs_MilestoneResult_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_MilestoneResult_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_MilestoneResult_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  milestoneId?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnitId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  value?: InputMaybe<Scalars['numeric']['input']>;
};

/** aggregate sum on columns */
export type Esrs_MilestoneResult_Sum_Fields_ = {
  __typename?: 'esrs_MilestoneResult_sum_fields';
  value?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Sum_Order_By_ = {
  value?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.MilestoneResult" */
export enum Esrs_MilestoneResult_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  MilestoneId_ = 'milestoneId',
  /** column name */
  ReportingUnitId_ = 'reportingUnitId',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  Value_ = 'value'
}

export type Esrs_MilestoneResult_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Esrs_MilestoneResult_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_MilestoneResult_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_MilestoneResult_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type Esrs_MilestoneResult_Var_Pop_Fields_ = {
  __typename?: 'esrs_MilestoneResult_var_pop_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Var_Pop_Order_By_ = {
  value?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type Esrs_MilestoneResult_Var_Samp_Fields_ = {
  __typename?: 'esrs_MilestoneResult_var_samp_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Var_Samp_Order_By_ = {
  value?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type Esrs_MilestoneResult_Variance_Fields_ = {
  __typename?: 'esrs_MilestoneResult_variance_fields';
  value?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.MilestoneResult" */
export type Esrs_MilestoneResult_Variance_Order_By_ = {
  value?: InputMaybe<Order_By_>;
};

/** aggregated selection of "esrs.Milestone" */
export type Esrs_Milestone_Aggregate_ = {
  __typename?: 'esrs_Milestone_aggregate';
  aggregate?: Maybe<Esrs_Milestone_Aggregate_Fields_>;
  nodes: Array<Esrs_Milestone_>;
};

export type Esrs_Milestone_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Esrs_Milestone_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Esrs_Milestone_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Esrs_Milestone_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_Milestone_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Esrs_Milestone_Select_Column_Esrs_Milestone_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Milestone_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_Milestone_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Esrs_Milestone_Select_Column_Esrs_Milestone_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Milestone_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_Milestone_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_Milestone_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Milestone_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.Milestone" */
export type Esrs_Milestone_Aggregate_Fields_ = {
  __typename?: 'esrs_Milestone_aggregate_fields';
  avg?: Maybe<Esrs_Milestone_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_Milestone_Max_Fields_>;
  min?: Maybe<Esrs_Milestone_Min_Fields_>;
  stddev?: Maybe<Esrs_Milestone_Stddev_Fields_>;
  stddev_pop?: Maybe<Esrs_Milestone_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<Esrs_Milestone_Stddev_Samp_Fields_>;
  sum?: Maybe<Esrs_Milestone_Sum_Fields_>;
  var_pop?: Maybe<Esrs_Milestone_Var_Pop_Fields_>;
  var_samp?: Maybe<Esrs_Milestone_Var_Samp_Fields_>;
  variance?: Maybe<Esrs_Milestone_Variance_Fields_>;
};


/** aggregate fields of "esrs.Milestone" */
export type Esrs_Milestone_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_Milestone_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.Milestone" */
export type Esrs_Milestone_Aggregate_Order_By_ = {
  avg?: InputMaybe<Esrs_Milestone_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_Milestone_Max_Order_By_>;
  min?: InputMaybe<Esrs_Milestone_Min_Order_By_>;
  stddev?: InputMaybe<Esrs_Milestone_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<Esrs_Milestone_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<Esrs_Milestone_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<Esrs_Milestone_Sum_Order_By_>;
  var_pop?: InputMaybe<Esrs_Milestone_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<Esrs_Milestone_Var_Samp_Order_By_>;
  variance?: InputMaybe<Esrs_Milestone_Variance_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.Milestone" */
export type Esrs_Milestone_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_Milestone_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_Milestone_On_Conflict_>;
};

/** aggregate avg on columns */
export type Esrs_Milestone_Avg_Fields_ = {
  __typename?: 'esrs_Milestone_avg_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.Milestone" */
export type Esrs_Milestone_Avg_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.Milestone". All fields are combined with a logical 'AND'. */
export type Esrs_Milestone_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_Milestone_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_Milestone_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_Milestone_Bool_Exp_>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isRelative?: InputMaybe<Boolean_Comparison_Exp_>;
  isRequired?: InputMaybe<Boolean_Comparison_Exp_>;
  milestoneResults?: InputMaybe<Esrs_MilestoneResult_Bool_Exp_>;
  milestoneResults_aggregate?: InputMaybe<Esrs_MilestoneResult_Aggregate_Bool_Exp_>;
  target?: InputMaybe<Esrs_Target_Bool_Exp_>;
  targetId?: InputMaybe<Uuid_Comparison_Exp_>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp_>;
  year?: InputMaybe<Int_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.Milestone" */
export enum Esrs_Milestone_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  MilestoneIdKey_ = 'Milestone_id_key',
  /** unique or primary key constraint on columns "id" */
  MilestonePkey_ = 'Milestone_pkey',
  /** unique or primary key constraint on columns "targetId", "year" */
  MilestoneYearTargetIdKey_ = 'Milestone_year_targetId_key'
}

/** input type for incrementing numeric columns in table "esrs.Milestone" */
export type Esrs_Milestone_Inc_Input_ = {
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "esrs.Milestone" */
export type Esrs_Milestone_Insert_Input_ = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isRelative?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  milestoneResults?: InputMaybe<Esrs_MilestoneResult_Arr_Rel_Insert_Input_>;
  target?: InputMaybe<Esrs_Target_Obj_Rel_Insert_Input_>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type Esrs_Milestone_Max_Fields_ = {
  __typename?: 'esrs_Milestone_max_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  targetId?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "esrs.Milestone" */
export type Esrs_Milestone_Max_Order_By_ = {
  created_at?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  targetId?: InputMaybe<Order_By_>;
  updated_at?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_Milestone_Min_Fields_ = {
  __typename?: 'esrs_Milestone_min_fields';
  created_at?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  targetId?: Maybe<Scalars['uuid']['output']>;
  updated_at?: Maybe<Scalars['timestamptz']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "esrs.Milestone" */
export type Esrs_Milestone_Min_Order_By_ = {
  created_at?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  targetId?: InputMaybe<Order_By_>;
  updated_at?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.Milestone" */
export type Esrs_Milestone_Mutation_Response_ = {
  __typename?: 'esrs_Milestone_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_Milestone_>;
};

/** input type for inserting object relation for remote table "esrs.Milestone" */
export type Esrs_Milestone_Obj_Rel_Insert_Input_ = {
  data: Esrs_Milestone_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_Milestone_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.Milestone" */
export type Esrs_Milestone_On_Conflict_ = {
  constraint: Esrs_Milestone_Constraint_;
  update_columns?: Array<Esrs_Milestone_Update_Column_>;
  where?: InputMaybe<Esrs_Milestone_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.Milestone". */
export type Esrs_Milestone_Order_By_ = {
  created_at?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isRelative?: InputMaybe<Order_By_>;
  isRequired?: InputMaybe<Order_By_>;
  milestoneResults_aggregate?: InputMaybe<Esrs_MilestoneResult_Aggregate_Order_By_>;
  target?: InputMaybe<Esrs_Target_Order_By_>;
  targetId?: InputMaybe<Order_By_>;
  updated_at?: InputMaybe<Order_By_>;
  year?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.Milestone */
export type Esrs_Milestone_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.Milestone" */
export enum Esrs_Milestone_Select_Column_ {
  /** column name */
  CreatedAt_ = 'created_at',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsRelative_ = 'isRelative',
  /** column name */
  IsRequired_ = 'isRequired',
  /** column name */
  TargetId_ = 'targetId',
  /** column name */
  UpdatedAt_ = 'updated_at',
  /** column name */
  Year_ = 'year'
}

/** select "esrs_Milestone_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.Milestone" */
export enum Esrs_Milestone_Select_Column_Esrs_Milestone_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsRelative_ = 'isRelative',
  /** column name */
  IsRequired_ = 'isRequired'
}

/** select "esrs_Milestone_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.Milestone" */
export enum Esrs_Milestone_Select_Column_Esrs_Milestone_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsRelative_ = 'isRelative',
  /** column name */
  IsRequired_ = 'isRequired'
}

/** input type for updating data in table "esrs.Milestone" */
export type Esrs_Milestone_Set_Input_ = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isRelative?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type Esrs_Milestone_Stddev_Fields_ = {
  __typename?: 'esrs_Milestone_stddev_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.Milestone" */
export type Esrs_Milestone_Stddev_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type Esrs_Milestone_Stddev_Pop_Fields_ = {
  __typename?: 'esrs_Milestone_stddev_pop_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.Milestone" */
export type Esrs_Milestone_Stddev_Pop_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type Esrs_Milestone_Stddev_Samp_Fields_ = {
  __typename?: 'esrs_Milestone_stddev_samp_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.Milestone" */
export type Esrs_Milestone_Stddev_Samp_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "esrs_Milestone" */
export type Esrs_Milestone_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_Milestone_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_Milestone_Stream_Cursor_Value_Input_ = {
  created_at?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isRelative?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  updated_at?: InputMaybe<Scalars['timestamptz']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type Esrs_Milestone_Sum_Fields_ = {
  __typename?: 'esrs_Milestone_sum_fields';
  year?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "esrs.Milestone" */
export type Esrs_Milestone_Sum_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.Milestone" */
export enum Esrs_Milestone_Update_Column_ {
  /** column name */
  CreatedAt_ = 'created_at',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsRelative_ = 'isRelative',
  /** column name */
  IsRequired_ = 'isRequired',
  /** column name */
  TargetId_ = 'targetId',
  /** column name */
  UpdatedAt_ = 'updated_at',
  /** column name */
  Year_ = 'year'
}

export type Esrs_Milestone_Updates_ = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Esrs_Milestone_Inc_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_Milestone_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_Milestone_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type Esrs_Milestone_Var_Pop_Fields_ = {
  __typename?: 'esrs_Milestone_var_pop_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.Milestone" */
export type Esrs_Milestone_Var_Pop_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type Esrs_Milestone_Var_Samp_Fields_ = {
  __typename?: 'esrs_Milestone_var_samp_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.Milestone" */
export type Esrs_Milestone_Var_Samp_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type Esrs_Milestone_Variance_Fields_ = {
  __typename?: 'esrs_Milestone_variance_fields';
  year?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.Milestone" */
export type Esrs_Milestone_Variance_Order_By_ = {
  year?: InputMaybe<Order_By_>;
};

/** (user input data): User data policies that will link to a specific disclosure requirement, for a specific assessment. It has a summary and documents attached to it (attachmentBox & noteHistory) */
export type Esrs_Policy_ = {
  __typename?: 'esrs_Policy';
  /** companyMaterialityAssessment id */
  assessmentId: Scalars['uuid']['output'];
  /** An object relationship */
  attachmentBox?: Maybe<AttachmentBox_>;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  disclosureRequirement: DisclosureRequirement_;
  disclosureRequirementRef: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  materialStandard: Esrs_MaterialStandard_;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  noteHistory?: Maybe<NoteHistory_>;
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "esrs.Policy" */
export type Esrs_Policy_Aggregate_ = {
  __typename?: 'esrs_Policy_aggregate';
  aggregate?: Maybe<Esrs_Policy_Aggregate_Fields_>;
  nodes: Array<Esrs_Policy_>;
};

export type Esrs_Policy_Aggregate_Bool_Exp_ = {
  count?: InputMaybe<Esrs_Policy_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_Policy_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_Policy_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Policy_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.Policy" */
export type Esrs_Policy_Aggregate_Fields_ = {
  __typename?: 'esrs_Policy_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_Policy_Max_Fields_>;
  min?: Maybe<Esrs_Policy_Min_Fields_>;
};


/** aggregate fields of "esrs.Policy" */
export type Esrs_Policy_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_Policy_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.Policy" */
export type Esrs_Policy_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_Policy_Max_Order_By_>;
  min?: InputMaybe<Esrs_Policy_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.Policy" */
export type Esrs_Policy_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_Policy_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_Policy_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.Policy". All fields are combined with a logical 'AND'. */
export type Esrs_Policy_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_Policy_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_Policy_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_Policy_Bool_Exp_>>;
  assessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  attachmentBox?: InputMaybe<AttachmentBox_Bool_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  disclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  mfDisclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
  noteHistory?: InputMaybe<NoteHistory_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.Policy" */
export enum Esrs_Policy_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  PoliciesPkey_ = 'Policies_pkey',
  /** unique or primary key constraint on columns "disclosureRequirementRef", "assessmentId" */
  PolicyAssessmentIdDisclosureRequirementRefKey_ = 'Policy_assessmentId_disclosureRequirementRef_key'
}

/** input type for inserting data into table "esrs.Policy" */
export type Esrs_Policy_Insert_Input_ = {
  /** companyMaterialityAssessment id */
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  attachmentBox?: InputMaybe<AttachmentBox_Obj_Rel_Insert_Input_>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Obj_Rel_Insert_Input_>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Obj_Rel_Insert_Input_>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  noteHistory?: InputMaybe<NoteHistory_Obj_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_Policy_Max_Fields_ = {
  __typename?: 'esrs_Policy_max_fields';
  /** companyMaterialityAssessment id */
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.Policy" */
export type Esrs_Policy_Max_Order_By_ = {
  /** companyMaterialityAssessment id */
  assessmentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_Policy_Min_Fields_ = {
  __typename?: 'esrs_Policy_min_fields';
  /** companyMaterialityAssessment id */
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.Policy" */
export type Esrs_Policy_Min_Order_By_ = {
  /** companyMaterialityAssessment id */
  assessmentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.Policy" */
export type Esrs_Policy_Mutation_Response_ = {
  __typename?: 'esrs_Policy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_Policy_>;
};

/** input type for inserting object relation for remote table "esrs.Policy" */
export type Esrs_Policy_Obj_Rel_Insert_Input_ = {
  data: Esrs_Policy_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_Policy_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.Policy" */
export type Esrs_Policy_On_Conflict_ = {
  constraint: Esrs_Policy_Constraint_;
  update_columns?: Array<Esrs_Policy_Update_Column_>;
  where?: InputMaybe<Esrs_Policy_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.Policy". */
export type Esrs_Policy_Order_By_ = {
  assessmentId?: InputMaybe<Order_By_>;
  attachmentBox?: InputMaybe<AttachmentBox_Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
  noteHistory?: InputMaybe<NoteHistory_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.Policy */
export type Esrs_Policy_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.Policy" */
export enum Esrs_Policy_Select_Column_ {
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  MfDisclosureRequirementRef_ = 'mfDisclosureRequirementRef',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "esrs.Policy" */
export type Esrs_Policy_Set_Input_ = {
  /** companyMaterialityAssessment id */
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_Policy" */
export type Esrs_Policy_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_Policy_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_Policy_Stream_Cursor_Value_Input_ = {
  /** companyMaterialityAssessment id */
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.Policy" */
export enum Esrs_Policy_Update_Column_ {
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  MfDisclosureRequirementRef_ = 'mfDisclosureRequirementRef',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_Policy_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_Policy_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_Policy_Bool_Exp_;
};

/** columns and relationships of "esrs.ReportingUnit" */
export type Esrs_ReportingUnit_ = {
  __typename?: 'esrs_ReportingUnit';
  /** An array relationship */
  answers: Array<Esrs_Answer_>;
  /** An aggregate relationship */
  answers_aggregate: Esrs_Answer_Aggregate_;
  assessmentId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  disclosureRequirementAttachments: Array<Esrs_DisclosureRequirementAttachment_>;
  /** An aggregate relationship */
  disclosureRequirementAttachments_aggregate: Esrs_DisclosureRequirementAttachment_Aggregate_;
  /** An object relationship */
  esrsAssessment: EsrsAssessment_;
  id: Scalars['uuid']['output'];
  isCompanyLevel: Scalars['Boolean']['output'];
  lineageId: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  projectLeader?: Maybe<Users_>;
  projectLeaderId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  reportingUnitLineage: Esrs_ReportingUnitLineage_;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "esrs.ReportingUnit" */
export type Esrs_ReportingUnitAnswersArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Answer_Order_By_>>;
  where?: InputMaybe<Esrs_Answer_Bool_Exp_>;
};


/** columns and relationships of "esrs.ReportingUnit" */
export type Esrs_ReportingUnitAnswers_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Answer_Order_By_>>;
  where?: InputMaybe<Esrs_Answer_Bool_Exp_>;
};


/** columns and relationships of "esrs.ReportingUnit" */
export type Esrs_ReportingUnitDisclosureRequirementAttachmentsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Order_By_>>;
  where?: InputMaybe<Esrs_DisclosureRequirementAttachment_Bool_Exp_>;
};


/** columns and relationships of "esrs.ReportingUnit" */
export type Esrs_ReportingUnitDisclosureRequirementAttachments_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Order_By_>>;
  where?: InputMaybe<Esrs_DisclosureRequirementAttachment_Bool_Exp_>;
};

/** columns and relationships of "esrs.ReportingUnitLineage" */
export type Esrs_ReportingUnitLineage_ = {
  __typename?: 'esrs_ReportingUnitLineage';
  /** An object relationship */
  company: Company_;
  companyId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  isCompanyLevel: Scalars['Boolean']['output'];
  /** An array relationship */
  reportingUnits: Array<Esrs_ReportingUnit_>;
  /** An aggregate relationship */
  reportingUnits_aggregate: Esrs_ReportingUnit_Aggregate_;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "esrs.ReportingUnitLineage" */
export type Esrs_ReportingUnitLineageReportingUnitsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ReportingUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ReportingUnit_Order_By_>>;
  where?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
};


/** columns and relationships of "esrs.ReportingUnitLineage" */
export type Esrs_ReportingUnitLineageReportingUnits_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ReportingUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ReportingUnit_Order_By_>>;
  where?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
};

/** aggregated selection of "esrs.ReportingUnitLineage" */
export type Esrs_ReportingUnitLineage_Aggregate_ = {
  __typename?: 'esrs_ReportingUnitLineage_aggregate';
  aggregate?: Maybe<Esrs_ReportingUnitLineage_Aggregate_Fields_>;
  nodes: Array<Esrs_ReportingUnitLineage_>;
};

/** aggregate fields of "esrs.ReportingUnitLineage" */
export type Esrs_ReportingUnitLineage_Aggregate_Fields_ = {
  __typename?: 'esrs_ReportingUnitLineage_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_ReportingUnitLineage_Max_Fields_>;
  min?: Maybe<Esrs_ReportingUnitLineage_Min_Fields_>;
};


/** aggregate fields of "esrs.ReportingUnitLineage" */
export type Esrs_ReportingUnitLineage_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_ReportingUnitLineage_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "esrs.ReportingUnitLineage". All fields are combined with a logical 'AND'. */
export type Esrs_ReportingUnitLineage_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_ReportingUnitLineage_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_ReportingUnitLineage_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_ReportingUnitLineage_Bool_Exp_>>;
  company?: InputMaybe<Company_Bool_Exp_>;
  companyId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isCompanyLevel?: InputMaybe<Boolean_Comparison_Exp_>;
  reportingUnits?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
  reportingUnits_aggregate?: InputMaybe<Esrs_ReportingUnit_Aggregate_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.ReportingUnitLineage" */
export enum Esrs_ReportingUnitLineage_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  ReportingUnitLineagePkey_ = 'ReportingUnitLineage_pkey'
}

/** input type for inserting data into table "esrs.ReportingUnitLineage" */
export type Esrs_ReportingUnitLineage_Insert_Input_ = {
  company?: InputMaybe<Company_Obj_Rel_Insert_Input_>;
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isCompanyLevel?: InputMaybe<Scalars['Boolean']['input']>;
  reportingUnits?: InputMaybe<Esrs_ReportingUnit_Arr_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_ReportingUnitLineage_Max_Fields_ = {
  __typename?: 'esrs_ReportingUnitLineage_max_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type Esrs_ReportingUnitLineage_Min_Fields_ = {
  __typename?: 'esrs_ReportingUnitLineage_min_fields';
  companyId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "esrs.ReportingUnitLineage" */
export type Esrs_ReportingUnitLineage_Mutation_Response_ = {
  __typename?: 'esrs_ReportingUnitLineage_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_ReportingUnitLineage_>;
};

/** input type for inserting object relation for remote table "esrs.ReportingUnitLineage" */
export type Esrs_ReportingUnitLineage_Obj_Rel_Insert_Input_ = {
  data: Esrs_ReportingUnitLineage_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_ReportingUnitLineage_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.ReportingUnitLineage" */
export type Esrs_ReportingUnitLineage_On_Conflict_ = {
  constraint: Esrs_ReportingUnitLineage_Constraint_;
  update_columns?: Array<Esrs_ReportingUnitLineage_Update_Column_>;
  where?: InputMaybe<Esrs_ReportingUnitLineage_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.ReportingUnitLineage". */
export type Esrs_ReportingUnitLineage_Order_By_ = {
  company?: InputMaybe<Company_Order_By_>;
  companyId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isCompanyLevel?: InputMaybe<Order_By_>;
  reportingUnits_aggregate?: InputMaybe<Esrs_ReportingUnit_Aggregate_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.ReportingUnitLineage */
export type Esrs_ReportingUnitLineage_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.ReportingUnitLineage" */
export enum Esrs_ReportingUnitLineage_Select_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsCompanyLevel_ = 'isCompanyLevel',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** input type for updating data in table "esrs.ReportingUnitLineage" */
export type Esrs_ReportingUnitLineage_Set_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isCompanyLevel?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_ReportingUnitLineage" */
export type Esrs_ReportingUnitLineage_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_ReportingUnitLineage_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_ReportingUnitLineage_Stream_Cursor_Value_Input_ = {
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isCompanyLevel?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.ReportingUnitLineage" */
export enum Esrs_ReportingUnitLineage_Update_Column_ {
  /** column name */
  CompanyId_ = 'companyId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsCompanyLevel_ = 'isCompanyLevel',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_ReportingUnitLineage_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_ReportingUnitLineage_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_ReportingUnitLineage_Bool_Exp_;
};

/** aggregated selection of "esrs.ReportingUnit" */
export type Esrs_ReportingUnit_Aggregate_ = {
  __typename?: 'esrs_ReportingUnit_aggregate';
  aggregate?: Maybe<Esrs_ReportingUnit_Aggregate_Fields_>;
  nodes: Array<Esrs_ReportingUnit_>;
};

export type Esrs_ReportingUnit_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Esrs_ReportingUnit_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Esrs_ReportingUnit_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Esrs_ReportingUnit_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_ReportingUnit_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Esrs_ReportingUnit_Select_Column_Esrs_ReportingUnit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_ReportingUnit_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Esrs_ReportingUnit_Select_Column_Esrs_ReportingUnit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_ReportingUnit_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_ReportingUnit_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.ReportingUnit" */
export type Esrs_ReportingUnit_Aggregate_Fields_ = {
  __typename?: 'esrs_ReportingUnit_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_ReportingUnit_Max_Fields_>;
  min?: Maybe<Esrs_ReportingUnit_Min_Fields_>;
};


/** aggregate fields of "esrs.ReportingUnit" */
export type Esrs_ReportingUnit_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_ReportingUnit_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.ReportingUnit" */
export type Esrs_ReportingUnit_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_ReportingUnit_Max_Order_By_>;
  min?: InputMaybe<Esrs_ReportingUnit_Min_Order_By_>;
};

/** input type for inserting array relation for remote table "esrs.ReportingUnit" */
export type Esrs_ReportingUnit_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_ReportingUnit_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_ReportingUnit_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "esrs.ReportingUnit". All fields are combined with a logical 'AND'. */
export type Esrs_ReportingUnit_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_ReportingUnit_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_ReportingUnit_Bool_Exp_>>;
  answers?: InputMaybe<Esrs_Answer_Bool_Exp_>;
  answers_aggregate?: InputMaybe<Esrs_Answer_Aggregate_Bool_Exp_>;
  assessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  disclosureRequirementAttachments?: InputMaybe<Esrs_DisclosureRequirementAttachment_Bool_Exp_>;
  disclosureRequirementAttachments_aggregate?: InputMaybe<Esrs_DisclosureRequirementAttachment_Aggregate_Bool_Exp_>;
  esrsAssessment?: InputMaybe<EsrsAssessment_Bool_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isCompanyLevel?: InputMaybe<Boolean_Comparison_Exp_>;
  lineageId?: InputMaybe<Uuid_Comparison_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  projectLeader?: InputMaybe<Users_Bool_Exp_>;
  projectLeaderId?: InputMaybe<Uuid_Comparison_Exp_>;
  reportingUnitLineage?: InputMaybe<Esrs_ReportingUnitLineage_Bool_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.ReportingUnit" */
export enum Esrs_ReportingUnit_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  ReportingUnitPkey_ = 'ReportingUnit_pkey'
}

/** input type for inserting data into table "esrs.ReportingUnit" */
export type Esrs_ReportingUnit_Insert_Input_ = {
  answers?: InputMaybe<Esrs_Answer_Arr_Rel_Insert_Input_>;
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  disclosureRequirementAttachments?: InputMaybe<Esrs_DisclosureRequirementAttachment_Arr_Rel_Insert_Input_>;
  esrsAssessment?: InputMaybe<EsrsAssessment_Obj_Rel_Insert_Input_>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isCompanyLevel?: InputMaybe<Scalars['Boolean']['input']>;
  lineageId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectLeader?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  projectLeaderId?: InputMaybe<Scalars['uuid']['input']>;
  reportingUnitLineage?: InputMaybe<Esrs_ReportingUnitLineage_Obj_Rel_Insert_Input_>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type Esrs_ReportingUnit_Max_Fields_ = {
  __typename?: 'esrs_ReportingUnit_max_fields';
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lineageId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectLeaderId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "esrs.ReportingUnit" */
export type Esrs_ReportingUnit_Max_Order_By_ = {
  assessmentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  lineageId?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  projectLeaderId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_ReportingUnit_Min_Fields_ = {
  __typename?: 'esrs_ReportingUnit_min_fields';
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lineageId?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  projectLeaderId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "esrs.ReportingUnit" */
export type Esrs_ReportingUnit_Min_Order_By_ = {
  assessmentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  lineageId?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  projectLeaderId?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.ReportingUnit" */
export type Esrs_ReportingUnit_Mutation_Response_ = {
  __typename?: 'esrs_ReportingUnit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_ReportingUnit_>;
};

/** input type for inserting object relation for remote table "esrs.ReportingUnit" */
export type Esrs_ReportingUnit_Obj_Rel_Insert_Input_ = {
  data: Esrs_ReportingUnit_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_ReportingUnit_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.ReportingUnit" */
export type Esrs_ReportingUnit_On_Conflict_ = {
  constraint: Esrs_ReportingUnit_Constraint_;
  update_columns?: Array<Esrs_ReportingUnit_Update_Column_>;
  where?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.ReportingUnit". */
export type Esrs_ReportingUnit_Order_By_ = {
  answers_aggregate?: InputMaybe<Esrs_Answer_Aggregate_Order_By_>;
  assessmentId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  disclosureRequirementAttachments_aggregate?: InputMaybe<Esrs_DisclosureRequirementAttachment_Aggregate_Order_By_>;
  esrsAssessment?: InputMaybe<EsrsAssessment_Order_By_>;
  id?: InputMaybe<Order_By_>;
  isCompanyLevel?: InputMaybe<Order_By_>;
  lineageId?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  projectLeader?: InputMaybe<Users_Order_By_>;
  projectLeaderId?: InputMaybe<Order_By_>;
  reportingUnitLineage?: InputMaybe<Esrs_ReportingUnitLineage_Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.ReportingUnit */
export type Esrs_ReportingUnit_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "esrs.ReportingUnit" */
export enum Esrs_ReportingUnit_Select_Column_ {
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsCompanyLevel_ = 'isCompanyLevel',
  /** column name */
  LineageId_ = 'lineageId',
  /** column name */
  Name_ = 'name',
  /** column name */
  ProjectLeaderId_ = 'projectLeaderId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "esrs_ReportingUnit_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.ReportingUnit" */
export enum Esrs_ReportingUnit_Select_Column_Esrs_ReportingUnit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsCompanyLevel_ = 'isCompanyLevel'
}

/** select "esrs_ReportingUnit_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.ReportingUnit" */
export enum Esrs_ReportingUnit_Select_Column_Esrs_ReportingUnit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsCompanyLevel_ = 'isCompanyLevel'
}

/** input type for updating data in table "esrs.ReportingUnit" */
export type Esrs_ReportingUnit_Set_Input_ = {
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isCompanyLevel?: InputMaybe<Scalars['Boolean']['input']>;
  lineageId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectLeaderId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "esrs_ReportingUnit" */
export type Esrs_ReportingUnit_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_ReportingUnit_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_ReportingUnit_Stream_Cursor_Value_Input_ = {
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isCompanyLevel?: InputMaybe<Scalars['Boolean']['input']>;
  lineageId?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectLeaderId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "esrs.ReportingUnit" */
export enum Esrs_ReportingUnit_Update_Column_ {
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsCompanyLevel_ = 'isCompanyLevel',
  /** column name */
  LineageId_ = 'lineageId',
  /** column name */
  Name_ = 'name',
  /** column name */
  ProjectLeaderId_ = 'projectLeaderId',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Esrs_ReportingUnit_Updates_ = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_ReportingUnit_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_ReportingUnit_Bool_Exp_;
};

/** (user input data): These are targets set to solve a problem, based on the metrics. Can be linked to actions that will help reach these targets.  */
export type Esrs_Target_ = {
  __typename?: 'esrs_Target';
  /** An array relationship */
  actionTargets: Array<Esrs_ActionTarget_>;
  /** An aggregate relationship */
  actionTargets_aggregate: Esrs_ActionTarget_Aggregate_;
  answers?: Maybe<Scalars['jsonb']['output']>;
  /** CompanyMaterialityAssessment id */
  assessmentId: Scalars['uuid']['output'];
  /** An object relationship */
  attachmentBox?: Maybe<AttachmentBox_>;
  coverage?: Maybe<Scalars['String']['output']>;
  coverageExplanation?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** specifies whether the goal is to increase, decrease, etc.. */
  direction?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  disclosureRequirement: DisclosureRequirement_;
  disclosureRequirementRef: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  isBottomUp: Scalars['Boolean']['output'];
  isEvidenceScientific?: Maybe<Scalars['Boolean']['output']>;
  isEvidenceScientificExplanation?: Maybe<Scalars['String']['output']>;
  isProgressAligned?: Maybe<Scalars['Boolean']['output']>;
  isProgressAlignedExplanation?: Maybe<Scalars['String']['output']>;
  /** refers to a unit; if relative: %, if absolute: t */
  isRelative: Scalars['Boolean']['output'];
  isRequired: Scalars['Boolean']['output'];
  /** An array relationship */
  keyResults: Array<Esrs_Baseline_>;
  /** An aggregate relationship */
  keyResults_aggregate: Esrs_Baseline_Aggregate_;
  /** An object relationship */
  materialStandard: Esrs_MaterialStandard_;
  methodologies?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  metric?: Maybe<EsrsMetric_>;
  /** the metric that we want to improve */
  metricRef?: Maybe<Scalars['String']['output']>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  milestones: Array<Esrs_Milestone_>;
  /** An aggregate relationship */
  milestones_aggregate: Esrs_Milestone_Aggregate_;
  name: Scalars['String']['output'];
  /** An object relationship */
  noteHistory?: Maybe<NoteHistory_>;
  /** An object relationship */
  owner?: Maybe<Users_>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  parentTarget?: Maybe<Esrs_Target_>;
  /** under development - linking subsidiaries targets to their group company targets (id of the target in the group company level) */
  parentTargetId?: Maybe<Scalars['uuid']['output']>;
  performanceNumber?: Maybe<Scalars['numeric']['output']>;
  performanceText?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  periodExplanation?: Maybe<Scalars['String']['output']>;
  relatedIRO?: Maybe<Scalars['String']['output']>;
  relatedPolicy?: Maybe<Scalars['String']['output']>;
  relationshipToPolicy?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  subsidiariesTargets: Array<Esrs_Target_>;
  /** An aggregate relationship */
  subsidiariesTargets_aggregate: Esrs_Target_Aggregate_;
  sustainabilityMatter?: Maybe<Scalars['String']['output']>;
  sustainabilityMatterExplanation?: Maybe<Scalars['String']['output']>;
  targetChangeDescription?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  withStakeholders?: Maybe<Scalars['Boolean']['output']>;
  withStakeholdersDescription?: Maybe<Scalars['String']['output']>;
  withStakeholdersExplanation?: Maybe<Scalars['String']['output']>;
};


/** (user input data): These are targets set to solve a problem, based on the metrics. Can be linked to actions that will help reach these targets.  */
export type Esrs_TargetActionTargetsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionTarget_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionTarget_Order_By_>>;
  where?: InputMaybe<Esrs_ActionTarget_Bool_Exp_>;
};


/** (user input data): These are targets set to solve a problem, based on the metrics. Can be linked to actions that will help reach these targets.  */
export type Esrs_TargetActionTargets_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionTarget_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionTarget_Order_By_>>;
  where?: InputMaybe<Esrs_ActionTarget_Bool_Exp_>;
};


/** (user input data): These are targets set to solve a problem, based on the metrics. Can be linked to actions that will help reach these targets.  */
export type Esrs_TargetAnswersArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** (user input data): These are targets set to solve a problem, based on the metrics. Can be linked to actions that will help reach these targets.  */
export type Esrs_TargetKeyResultsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Baseline_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Baseline_Order_By_>>;
  where?: InputMaybe<Esrs_Baseline_Bool_Exp_>;
};


/** (user input data): These are targets set to solve a problem, based on the metrics. Can be linked to actions that will help reach these targets.  */
export type Esrs_TargetKeyResults_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Baseline_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Baseline_Order_By_>>;
  where?: InputMaybe<Esrs_Baseline_Bool_Exp_>;
};


/** (user input data): These are targets set to solve a problem, based on the metrics. Can be linked to actions that will help reach these targets.  */
export type Esrs_TargetMilestonesArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Milestone_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Milestone_Order_By_>>;
  where?: InputMaybe<Esrs_Milestone_Bool_Exp_>;
};


/** (user input data): These are targets set to solve a problem, based on the metrics. Can be linked to actions that will help reach these targets.  */
export type Esrs_TargetMilestones_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Milestone_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Milestone_Order_By_>>;
  where?: InputMaybe<Esrs_Milestone_Bool_Exp_>;
};


/** (user input data): These are targets set to solve a problem, based on the metrics. Can be linked to actions that will help reach these targets.  */
export type Esrs_TargetSubsidiariesTargetsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Target_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Target_Order_By_>>;
  where?: InputMaybe<Esrs_Target_Bool_Exp_>;
};


/** (user input data): These are targets set to solve a problem, based on the metrics. Can be linked to actions that will help reach these targets.  */
export type Esrs_TargetSubsidiariesTargets_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Target_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Target_Order_By_>>;
  where?: InputMaybe<Esrs_Target_Bool_Exp_>;
};

/** aggregated selection of "esrs.Target" */
export type Esrs_Target_Aggregate_ = {
  __typename?: 'esrs_Target_aggregate';
  aggregate?: Maybe<Esrs_Target_Aggregate_Fields_>;
  nodes: Array<Esrs_Target_>;
};

export type Esrs_Target_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Esrs_Target_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Esrs_Target_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Esrs_Target_Aggregate_Bool_Exp_Count_>;
};

export type Esrs_Target_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Esrs_Target_Select_Column_Esrs_Target_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Target_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_Target_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Esrs_Target_Select_Column_Esrs_Target_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Target_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Esrs_Target_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Esrs_Target_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Esrs_Target_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "esrs.Target" */
export type Esrs_Target_Aggregate_Fields_ = {
  __typename?: 'esrs_Target_aggregate_fields';
  avg?: Maybe<Esrs_Target_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<Esrs_Target_Max_Fields_>;
  min?: Maybe<Esrs_Target_Min_Fields_>;
  stddev?: Maybe<Esrs_Target_Stddev_Fields_>;
  stddev_pop?: Maybe<Esrs_Target_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<Esrs_Target_Stddev_Samp_Fields_>;
  sum?: Maybe<Esrs_Target_Sum_Fields_>;
  var_pop?: Maybe<Esrs_Target_Var_Pop_Fields_>;
  var_samp?: Maybe<Esrs_Target_Var_Samp_Fields_>;
  variance?: Maybe<Esrs_Target_Variance_Fields_>;
};


/** aggregate fields of "esrs.Target" */
export type Esrs_Target_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Esrs_Target_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "esrs.Target" */
export type Esrs_Target_Aggregate_Order_By_ = {
  avg?: InputMaybe<Esrs_Target_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Esrs_Target_Max_Order_By_>;
  min?: InputMaybe<Esrs_Target_Min_Order_By_>;
  stddev?: InputMaybe<Esrs_Target_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<Esrs_Target_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<Esrs_Target_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<Esrs_Target_Sum_Order_By_>;
  var_pop?: InputMaybe<Esrs_Target_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<Esrs_Target_Var_Samp_Order_By_>;
  variance?: InputMaybe<Esrs_Target_Variance_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Esrs_Target_Append_Input_ = {
  answers?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "esrs.Target" */
export type Esrs_Target_Arr_Rel_Insert_Input_ = {
  data: Array<Esrs_Target_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_Target_On_Conflict_>;
};

/** aggregate avg on columns */
export type Esrs_Target_Avg_Fields_ = {
  __typename?: 'esrs_Target_avg_fields';
  performanceNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "esrs.Target" */
export type Esrs_Target_Avg_Order_By_ = {
  performanceNumber?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "esrs.Target". All fields are combined with a logical 'AND'. */
export type Esrs_Target_Bool_Exp_ = {
  _and?: InputMaybe<Array<Esrs_Target_Bool_Exp_>>;
  _not?: InputMaybe<Esrs_Target_Bool_Exp_>;
  _or?: InputMaybe<Array<Esrs_Target_Bool_Exp_>>;
  actionTargets?: InputMaybe<Esrs_ActionTarget_Bool_Exp_>;
  actionTargets_aggregate?: InputMaybe<Esrs_ActionTarget_Aggregate_Bool_Exp_>;
  answers?: InputMaybe<Jsonb_Comparison_Exp_>;
  assessmentId?: InputMaybe<Uuid_Comparison_Exp_>;
  attachmentBox?: InputMaybe<AttachmentBox_Bool_Exp_>;
  coverage?: InputMaybe<String_Comparison_Exp_>;
  coverageExplanation?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  description?: InputMaybe<String_Comparison_Exp_>;
  direction?: InputMaybe<String_Comparison_Exp_>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
  disclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isBottomUp?: InputMaybe<Boolean_Comparison_Exp_>;
  isEvidenceScientific?: InputMaybe<Boolean_Comparison_Exp_>;
  isEvidenceScientificExplanation?: InputMaybe<String_Comparison_Exp_>;
  isProgressAligned?: InputMaybe<Boolean_Comparison_Exp_>;
  isProgressAlignedExplanation?: InputMaybe<String_Comparison_Exp_>;
  isRelative?: InputMaybe<Boolean_Comparison_Exp_>;
  isRequired?: InputMaybe<Boolean_Comparison_Exp_>;
  keyResults?: InputMaybe<Esrs_Baseline_Bool_Exp_>;
  keyResults_aggregate?: InputMaybe<Esrs_Baseline_Aggregate_Bool_Exp_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
  methodologies?: InputMaybe<String_Comparison_Exp_>;
  metric?: InputMaybe<EsrsMetric_Bool_Exp_>;
  metricRef?: InputMaybe<String_Comparison_Exp_>;
  mfDisclosureRequirementRef?: InputMaybe<String_Comparison_Exp_>;
  milestones?: InputMaybe<Esrs_Milestone_Bool_Exp_>;
  milestones_aggregate?: InputMaybe<Esrs_Milestone_Aggregate_Bool_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  noteHistory?: InputMaybe<NoteHistory_Bool_Exp_>;
  owner?: InputMaybe<Users_Bool_Exp_>;
  ownerId?: InputMaybe<Uuid_Comparison_Exp_>;
  parentTarget?: InputMaybe<Esrs_Target_Bool_Exp_>;
  parentTargetId?: InputMaybe<Uuid_Comparison_Exp_>;
  performanceNumber?: InputMaybe<Numeric_Comparison_Exp_>;
  performanceText?: InputMaybe<String_Comparison_Exp_>;
  period?: InputMaybe<String_Comparison_Exp_>;
  periodExplanation?: InputMaybe<String_Comparison_Exp_>;
  relatedIRO?: InputMaybe<String_Comparison_Exp_>;
  relatedPolicy?: InputMaybe<String_Comparison_Exp_>;
  relationshipToPolicy?: InputMaybe<String_Comparison_Exp_>;
  scope?: InputMaybe<String_Comparison_Exp_>;
  subsidiariesTargets?: InputMaybe<Esrs_Target_Bool_Exp_>;
  subsidiariesTargets_aggregate?: InputMaybe<Esrs_Target_Aggregate_Bool_Exp_>;
  sustainabilityMatter?: InputMaybe<String_Comparison_Exp_>;
  sustainabilityMatterExplanation?: InputMaybe<String_Comparison_Exp_>;
  targetChangeDescription?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  withStakeholders?: InputMaybe<Boolean_Comparison_Exp_>;
  withStakeholdersDescription?: InputMaybe<String_Comparison_Exp_>;
  withStakeholdersExplanation?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "esrs.Target" */
export enum Esrs_Target_Constraint_ {
  /** unique or primary key constraint on columns "assessmentId", "metricRef" */
  TargetAssessmentIdMetricRefKey_ = 'Target_assessmentId_metricRef_key',
  /** unique or primary key constraint on columns "id" */
  TargetPkey_ = 'Target_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Esrs_Target_Delete_At_Path_Input_ = {
  answers?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Esrs_Target_Delete_Elem_Input_ = {
  answers?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Esrs_Target_Delete_Key_Input_ = {
  answers?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "esrs.Target" */
export type Esrs_Target_Inc_Input_ = {
  performanceNumber?: InputMaybe<Scalars['numeric']['input']>;
};

/** input type for inserting data into table "esrs.Target" */
export type Esrs_Target_Insert_Input_ = {
  actionTargets?: InputMaybe<Esrs_ActionTarget_Arr_Rel_Insert_Input_>;
  answers?: InputMaybe<Scalars['jsonb']['input']>;
  /** CompanyMaterialityAssessment id */
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  attachmentBox?: InputMaybe<AttachmentBox_Obj_Rel_Insert_Input_>;
  coverage?: InputMaybe<Scalars['String']['input']>;
  coverageExplanation?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** specifies whether the goal is to increase, decrease, etc.. */
  direction?: InputMaybe<Scalars['String']['input']>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Obj_Rel_Insert_Input_>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isBottomUp?: InputMaybe<Scalars['Boolean']['input']>;
  isEvidenceScientific?: InputMaybe<Scalars['Boolean']['input']>;
  isEvidenceScientificExplanation?: InputMaybe<Scalars['String']['input']>;
  isProgressAligned?: InputMaybe<Scalars['Boolean']['input']>;
  isProgressAlignedExplanation?: InputMaybe<Scalars['String']['input']>;
  /** refers to a unit; if relative: %, if absolute: t */
  isRelative?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  keyResults?: InputMaybe<Esrs_Baseline_Arr_Rel_Insert_Input_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Obj_Rel_Insert_Input_>;
  methodologies?: InputMaybe<Scalars['String']['input']>;
  metric?: InputMaybe<EsrsMetric_Obj_Rel_Insert_Input_>;
  /** the metric that we want to improve */
  metricRef?: InputMaybe<Scalars['String']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  milestones?: InputMaybe<Esrs_Milestone_Arr_Rel_Insert_Input_>;
  name?: InputMaybe<Scalars['String']['input']>;
  noteHistory?: InputMaybe<NoteHistory_Obj_Rel_Insert_Input_>;
  owner?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  parentTarget?: InputMaybe<Esrs_Target_Obj_Rel_Insert_Input_>;
  /** under development - linking subsidiaries targets to their group company targets (id of the target in the group company level) */
  parentTargetId?: InputMaybe<Scalars['uuid']['input']>;
  performanceNumber?: InputMaybe<Scalars['numeric']['input']>;
  performanceText?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  periodExplanation?: InputMaybe<Scalars['String']['input']>;
  relatedIRO?: InputMaybe<Scalars['String']['input']>;
  relatedPolicy?: InputMaybe<Scalars['String']['input']>;
  relationshipToPolicy?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  subsidiariesTargets?: InputMaybe<Esrs_Target_Arr_Rel_Insert_Input_>;
  sustainabilityMatter?: InputMaybe<Scalars['String']['input']>;
  sustainabilityMatterExplanation?: InputMaybe<Scalars['String']['input']>;
  targetChangeDescription?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  withStakeholders?: InputMaybe<Scalars['Boolean']['input']>;
  withStakeholdersDescription?: InputMaybe<Scalars['String']['input']>;
  withStakeholdersExplanation?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Esrs_Target_Max_Fields_ = {
  __typename?: 'esrs_Target_max_fields';
  /** CompanyMaterialityAssessment id */
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  coverage?: Maybe<Scalars['String']['output']>;
  coverageExplanation?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** specifies whether the goal is to increase, decrease, etc.. */
  direction?: Maybe<Scalars['String']['output']>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  isEvidenceScientificExplanation?: Maybe<Scalars['String']['output']>;
  isProgressAlignedExplanation?: Maybe<Scalars['String']['output']>;
  methodologies?: Maybe<Scalars['String']['output']>;
  /** the metric that we want to improve */
  metricRef?: Maybe<Scalars['String']['output']>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  /** under development - linking subsidiaries targets to their group company targets (id of the target in the group company level) */
  parentTargetId?: Maybe<Scalars['uuid']['output']>;
  performanceNumber?: Maybe<Scalars['numeric']['output']>;
  performanceText?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  periodExplanation?: Maybe<Scalars['String']['output']>;
  relatedIRO?: Maybe<Scalars['String']['output']>;
  relatedPolicy?: Maybe<Scalars['String']['output']>;
  relationshipToPolicy?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  sustainabilityMatter?: Maybe<Scalars['String']['output']>;
  sustainabilityMatterExplanation?: Maybe<Scalars['String']['output']>;
  targetChangeDescription?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  withStakeholdersDescription?: Maybe<Scalars['String']['output']>;
  withStakeholdersExplanation?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "esrs.Target" */
export type Esrs_Target_Max_Order_By_ = {
  /** CompanyMaterialityAssessment id */
  assessmentId?: InputMaybe<Order_By_>;
  coverage?: InputMaybe<Order_By_>;
  coverageExplanation?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  /** specifies whether the goal is to increase, decrease, etc.. */
  direction?: InputMaybe<Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isEvidenceScientificExplanation?: InputMaybe<Order_By_>;
  isProgressAlignedExplanation?: InputMaybe<Order_By_>;
  methodologies?: InputMaybe<Order_By_>;
  /** the metric that we want to improve */
  metricRef?: InputMaybe<Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  /** under development - linking subsidiaries targets to their group company targets (id of the target in the group company level) */
  parentTargetId?: InputMaybe<Order_By_>;
  performanceNumber?: InputMaybe<Order_By_>;
  performanceText?: InputMaybe<Order_By_>;
  period?: InputMaybe<Order_By_>;
  periodExplanation?: InputMaybe<Order_By_>;
  relatedIRO?: InputMaybe<Order_By_>;
  relatedPolicy?: InputMaybe<Order_By_>;
  relationshipToPolicy?: InputMaybe<Order_By_>;
  scope?: InputMaybe<Order_By_>;
  sustainabilityMatter?: InputMaybe<Order_By_>;
  sustainabilityMatterExplanation?: InputMaybe<Order_By_>;
  targetChangeDescription?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  withStakeholdersDescription?: InputMaybe<Order_By_>;
  withStakeholdersExplanation?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Esrs_Target_Min_Fields_ = {
  __typename?: 'esrs_Target_min_fields';
  /** CompanyMaterialityAssessment id */
  assessmentId?: Maybe<Scalars['uuid']['output']>;
  coverage?: Maybe<Scalars['String']['output']>;
  coverageExplanation?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** specifies whether the goal is to increase, decrease, etc.. */
  direction?: Maybe<Scalars['String']['output']>;
  disclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  isEvidenceScientificExplanation?: Maybe<Scalars['String']['output']>;
  isProgressAlignedExplanation?: Maybe<Scalars['String']['output']>;
  methodologies?: Maybe<Scalars['String']['output']>;
  /** the metric that we want to improve */
  metricRef?: Maybe<Scalars['String']['output']>;
  mfDisclosureRequirementRef?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['uuid']['output']>;
  /** under development - linking subsidiaries targets to their group company targets (id of the target in the group company level) */
  parentTargetId?: Maybe<Scalars['uuid']['output']>;
  performanceNumber?: Maybe<Scalars['numeric']['output']>;
  performanceText?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  periodExplanation?: Maybe<Scalars['String']['output']>;
  relatedIRO?: Maybe<Scalars['String']['output']>;
  relatedPolicy?: Maybe<Scalars['String']['output']>;
  relationshipToPolicy?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
  sustainabilityMatter?: Maybe<Scalars['String']['output']>;
  sustainabilityMatterExplanation?: Maybe<Scalars['String']['output']>;
  targetChangeDescription?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  withStakeholdersDescription?: Maybe<Scalars['String']['output']>;
  withStakeholdersExplanation?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "esrs.Target" */
export type Esrs_Target_Min_Order_By_ = {
  /** CompanyMaterialityAssessment id */
  assessmentId?: InputMaybe<Order_By_>;
  coverage?: InputMaybe<Order_By_>;
  coverageExplanation?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  /** specifies whether the goal is to increase, decrease, etc.. */
  direction?: InputMaybe<Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isEvidenceScientificExplanation?: InputMaybe<Order_By_>;
  isProgressAlignedExplanation?: InputMaybe<Order_By_>;
  methodologies?: InputMaybe<Order_By_>;
  /** the metric that we want to improve */
  metricRef?: InputMaybe<Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  /** under development - linking subsidiaries targets to their group company targets (id of the target in the group company level) */
  parentTargetId?: InputMaybe<Order_By_>;
  performanceNumber?: InputMaybe<Order_By_>;
  performanceText?: InputMaybe<Order_By_>;
  period?: InputMaybe<Order_By_>;
  periodExplanation?: InputMaybe<Order_By_>;
  relatedIRO?: InputMaybe<Order_By_>;
  relatedPolicy?: InputMaybe<Order_By_>;
  relationshipToPolicy?: InputMaybe<Order_By_>;
  scope?: InputMaybe<Order_By_>;
  sustainabilityMatter?: InputMaybe<Order_By_>;
  sustainabilityMatterExplanation?: InputMaybe<Order_By_>;
  targetChangeDescription?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  withStakeholdersDescription?: InputMaybe<Order_By_>;
  withStakeholdersExplanation?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "esrs.Target" */
export type Esrs_Target_Mutation_Response_ = {
  __typename?: 'esrs_Target_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Esrs_Target_>;
};

/** input type for inserting object relation for remote table "esrs.Target" */
export type Esrs_Target_Obj_Rel_Insert_Input_ = {
  data: Esrs_Target_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Esrs_Target_On_Conflict_>;
};

/** on_conflict condition type for table "esrs.Target" */
export type Esrs_Target_On_Conflict_ = {
  constraint: Esrs_Target_Constraint_;
  update_columns?: Array<Esrs_Target_Update_Column_>;
  where?: InputMaybe<Esrs_Target_Bool_Exp_>;
};

/** Ordering options when selecting data from "esrs.Target". */
export type Esrs_Target_Order_By_ = {
  actionTargets_aggregate?: InputMaybe<Esrs_ActionTarget_Aggregate_Order_By_>;
  answers?: InputMaybe<Order_By_>;
  assessmentId?: InputMaybe<Order_By_>;
  attachmentBox?: InputMaybe<AttachmentBox_Order_By_>;
  coverage?: InputMaybe<Order_By_>;
  coverageExplanation?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  description?: InputMaybe<Order_By_>;
  direction?: InputMaybe<Order_By_>;
  disclosureRequirement?: InputMaybe<DisclosureRequirement_Order_By_>;
  disclosureRequirementRef?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isBottomUp?: InputMaybe<Order_By_>;
  isEvidenceScientific?: InputMaybe<Order_By_>;
  isEvidenceScientificExplanation?: InputMaybe<Order_By_>;
  isProgressAligned?: InputMaybe<Order_By_>;
  isProgressAlignedExplanation?: InputMaybe<Order_By_>;
  isRelative?: InputMaybe<Order_By_>;
  isRequired?: InputMaybe<Order_By_>;
  keyResults_aggregate?: InputMaybe<Esrs_Baseline_Aggregate_Order_By_>;
  materialStandard?: InputMaybe<Esrs_MaterialStandard_Order_By_>;
  methodologies?: InputMaybe<Order_By_>;
  metric?: InputMaybe<EsrsMetric_Order_By_>;
  metricRef?: InputMaybe<Order_By_>;
  mfDisclosureRequirementRef?: InputMaybe<Order_By_>;
  milestones_aggregate?: InputMaybe<Esrs_Milestone_Aggregate_Order_By_>;
  name?: InputMaybe<Order_By_>;
  noteHistory?: InputMaybe<NoteHistory_Order_By_>;
  owner?: InputMaybe<Users_Order_By_>;
  ownerId?: InputMaybe<Order_By_>;
  parentTarget?: InputMaybe<Esrs_Target_Order_By_>;
  parentTargetId?: InputMaybe<Order_By_>;
  performanceNumber?: InputMaybe<Order_By_>;
  performanceText?: InputMaybe<Order_By_>;
  period?: InputMaybe<Order_By_>;
  periodExplanation?: InputMaybe<Order_By_>;
  relatedIRO?: InputMaybe<Order_By_>;
  relatedPolicy?: InputMaybe<Order_By_>;
  relationshipToPolicy?: InputMaybe<Order_By_>;
  scope?: InputMaybe<Order_By_>;
  subsidiariesTargets_aggregate?: InputMaybe<Esrs_Target_Aggregate_Order_By_>;
  sustainabilityMatter?: InputMaybe<Order_By_>;
  sustainabilityMatterExplanation?: InputMaybe<Order_By_>;
  targetChangeDescription?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  withStakeholders?: InputMaybe<Order_By_>;
  withStakeholdersDescription?: InputMaybe<Order_By_>;
  withStakeholdersExplanation?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: esrs.Target */
export type Esrs_Target_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Esrs_Target_Prepend_Input_ = {
  answers?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "esrs.Target" */
export enum Esrs_Target_Select_Column_ {
  /** column name */
  Answers_ = 'answers',
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  Coverage_ = 'coverage',
  /** column name */
  CoverageExplanation_ = 'coverageExplanation',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  Direction_ = 'direction',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsBottomUp_ = 'isBottomUp',
  /** column name */
  IsEvidenceScientific_ = 'isEvidenceScientific',
  /** column name */
  IsEvidenceScientificExplanation_ = 'isEvidenceScientificExplanation',
  /** column name */
  IsProgressAligned_ = 'isProgressAligned',
  /** column name */
  IsProgressAlignedExplanation_ = 'isProgressAlignedExplanation',
  /** column name */
  IsRelative_ = 'isRelative',
  /** column name */
  IsRequired_ = 'isRequired',
  /** column name */
  Methodologies_ = 'methodologies',
  /** column name */
  MetricRef_ = 'metricRef',
  /** column name */
  MfDisclosureRequirementRef_ = 'mfDisclosureRequirementRef',
  /** column name */
  Name_ = 'name',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  ParentTargetId_ = 'parentTargetId',
  /** column name */
  PerformanceNumber_ = 'performanceNumber',
  /** column name */
  PerformanceText_ = 'performanceText',
  /** column name */
  Period_ = 'period',
  /** column name */
  PeriodExplanation_ = 'periodExplanation',
  /** column name */
  RelatedIro_ = 'relatedIRO',
  /** column name */
  RelatedPolicy_ = 'relatedPolicy',
  /** column name */
  RelationshipToPolicy_ = 'relationshipToPolicy',
  /** column name */
  Scope_ = 'scope',
  /** column name */
  SustainabilityMatter_ = 'sustainabilityMatter',
  /** column name */
  SustainabilityMatterExplanation_ = 'sustainabilityMatterExplanation',
  /** column name */
  TargetChangeDescription_ = 'targetChangeDescription',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  WithStakeholders_ = 'withStakeholders',
  /** column name */
  WithStakeholdersDescription_ = 'withStakeholdersDescription',
  /** column name */
  WithStakeholdersExplanation_ = 'withStakeholdersExplanation'
}

/** select "esrs_Target_aggregate_bool_exp_bool_and_arguments_columns" columns of table "esrs.Target" */
export enum Esrs_Target_Select_Column_Esrs_Target_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsBottomUp_ = 'isBottomUp',
  /** column name */
  IsEvidenceScientific_ = 'isEvidenceScientific',
  /** column name */
  IsProgressAligned_ = 'isProgressAligned',
  /** column name */
  IsRelative_ = 'isRelative',
  /** column name */
  IsRequired_ = 'isRequired',
  /** column name */
  WithStakeholders_ = 'withStakeholders'
}

/** select "esrs_Target_aggregate_bool_exp_bool_or_arguments_columns" columns of table "esrs.Target" */
export enum Esrs_Target_Select_Column_Esrs_Target_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsBottomUp_ = 'isBottomUp',
  /** column name */
  IsEvidenceScientific_ = 'isEvidenceScientific',
  /** column name */
  IsProgressAligned_ = 'isProgressAligned',
  /** column name */
  IsRelative_ = 'isRelative',
  /** column name */
  IsRequired_ = 'isRequired',
  /** column name */
  WithStakeholders_ = 'withStakeholders'
}

/** input type for updating data in table "esrs.Target" */
export type Esrs_Target_Set_Input_ = {
  answers?: InputMaybe<Scalars['jsonb']['input']>;
  /** CompanyMaterialityAssessment id */
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  coverage?: InputMaybe<Scalars['String']['input']>;
  coverageExplanation?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** specifies whether the goal is to increase, decrease, etc.. */
  direction?: InputMaybe<Scalars['String']['input']>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isBottomUp?: InputMaybe<Scalars['Boolean']['input']>;
  isEvidenceScientific?: InputMaybe<Scalars['Boolean']['input']>;
  isEvidenceScientificExplanation?: InputMaybe<Scalars['String']['input']>;
  isProgressAligned?: InputMaybe<Scalars['Boolean']['input']>;
  isProgressAlignedExplanation?: InputMaybe<Scalars['String']['input']>;
  /** refers to a unit; if relative: %, if absolute: t */
  isRelative?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  methodologies?: InputMaybe<Scalars['String']['input']>;
  /** the metric that we want to improve */
  metricRef?: InputMaybe<Scalars['String']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  /** under development - linking subsidiaries targets to their group company targets (id of the target in the group company level) */
  parentTargetId?: InputMaybe<Scalars['uuid']['input']>;
  performanceNumber?: InputMaybe<Scalars['numeric']['input']>;
  performanceText?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  periodExplanation?: InputMaybe<Scalars['String']['input']>;
  relatedIRO?: InputMaybe<Scalars['String']['input']>;
  relatedPolicy?: InputMaybe<Scalars['String']['input']>;
  relationshipToPolicy?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  sustainabilityMatter?: InputMaybe<Scalars['String']['input']>;
  sustainabilityMatterExplanation?: InputMaybe<Scalars['String']['input']>;
  targetChangeDescription?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  withStakeholders?: InputMaybe<Scalars['Boolean']['input']>;
  withStakeholdersDescription?: InputMaybe<Scalars['String']['input']>;
  withStakeholdersExplanation?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type Esrs_Target_Stddev_Fields_ = {
  __typename?: 'esrs_Target_stddev_fields';
  performanceNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "esrs.Target" */
export type Esrs_Target_Stddev_Order_By_ = {
  performanceNumber?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type Esrs_Target_Stddev_Pop_Fields_ = {
  __typename?: 'esrs_Target_stddev_pop_fields';
  performanceNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "esrs.Target" */
export type Esrs_Target_Stddev_Pop_Order_By_ = {
  performanceNumber?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type Esrs_Target_Stddev_Samp_Fields_ = {
  __typename?: 'esrs_Target_stddev_samp_fields';
  performanceNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "esrs.Target" */
export type Esrs_Target_Stddev_Samp_Order_By_ = {
  performanceNumber?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "esrs_Target" */
export type Esrs_Target_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Esrs_Target_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Esrs_Target_Stream_Cursor_Value_Input_ = {
  answers?: InputMaybe<Scalars['jsonb']['input']>;
  /** CompanyMaterialityAssessment id */
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  coverage?: InputMaybe<Scalars['String']['input']>;
  coverageExplanation?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** specifies whether the goal is to increase, decrease, etc.. */
  direction?: InputMaybe<Scalars['String']['input']>;
  disclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isBottomUp?: InputMaybe<Scalars['Boolean']['input']>;
  isEvidenceScientific?: InputMaybe<Scalars['Boolean']['input']>;
  isEvidenceScientificExplanation?: InputMaybe<Scalars['String']['input']>;
  isProgressAligned?: InputMaybe<Scalars['Boolean']['input']>;
  isProgressAlignedExplanation?: InputMaybe<Scalars['String']['input']>;
  /** refers to a unit; if relative: %, if absolute: t */
  isRelative?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  methodologies?: InputMaybe<Scalars['String']['input']>;
  /** the metric that we want to improve */
  metricRef?: InputMaybe<Scalars['String']['input']>;
  mfDisclosureRequirementRef?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['uuid']['input']>;
  /** under development - linking subsidiaries targets to their group company targets (id of the target in the group company level) */
  parentTargetId?: InputMaybe<Scalars['uuid']['input']>;
  performanceNumber?: InputMaybe<Scalars['numeric']['input']>;
  performanceText?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  periodExplanation?: InputMaybe<Scalars['String']['input']>;
  relatedIRO?: InputMaybe<Scalars['String']['input']>;
  relatedPolicy?: InputMaybe<Scalars['String']['input']>;
  relationshipToPolicy?: InputMaybe<Scalars['String']['input']>;
  scope?: InputMaybe<Scalars['String']['input']>;
  sustainabilityMatter?: InputMaybe<Scalars['String']['input']>;
  sustainabilityMatterExplanation?: InputMaybe<Scalars['String']['input']>;
  targetChangeDescription?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  withStakeholders?: InputMaybe<Scalars['Boolean']['input']>;
  withStakeholdersDescription?: InputMaybe<Scalars['String']['input']>;
  withStakeholdersExplanation?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type Esrs_Target_Sum_Fields_ = {
  __typename?: 'esrs_Target_sum_fields';
  performanceNumber?: Maybe<Scalars['numeric']['output']>;
};

/** order by sum() on columns of table "esrs.Target" */
export type Esrs_Target_Sum_Order_By_ = {
  performanceNumber?: InputMaybe<Order_By_>;
};

/** update columns of table "esrs.Target" */
export enum Esrs_Target_Update_Column_ {
  /** column name */
  Answers_ = 'answers',
  /** column name */
  AssessmentId_ = 'assessmentId',
  /** column name */
  Coverage_ = 'coverage',
  /** column name */
  CoverageExplanation_ = 'coverageExplanation',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Description_ = 'description',
  /** column name */
  Direction_ = 'direction',
  /** column name */
  DisclosureRequirementRef_ = 'disclosureRequirementRef',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsBottomUp_ = 'isBottomUp',
  /** column name */
  IsEvidenceScientific_ = 'isEvidenceScientific',
  /** column name */
  IsEvidenceScientificExplanation_ = 'isEvidenceScientificExplanation',
  /** column name */
  IsProgressAligned_ = 'isProgressAligned',
  /** column name */
  IsProgressAlignedExplanation_ = 'isProgressAlignedExplanation',
  /** column name */
  IsRelative_ = 'isRelative',
  /** column name */
  IsRequired_ = 'isRequired',
  /** column name */
  Methodologies_ = 'methodologies',
  /** column name */
  MetricRef_ = 'metricRef',
  /** column name */
  MfDisclosureRequirementRef_ = 'mfDisclosureRequirementRef',
  /** column name */
  Name_ = 'name',
  /** column name */
  OwnerId_ = 'ownerId',
  /** column name */
  ParentTargetId_ = 'parentTargetId',
  /** column name */
  PerformanceNumber_ = 'performanceNumber',
  /** column name */
  PerformanceText_ = 'performanceText',
  /** column name */
  Period_ = 'period',
  /** column name */
  PeriodExplanation_ = 'periodExplanation',
  /** column name */
  RelatedIro_ = 'relatedIRO',
  /** column name */
  RelatedPolicy_ = 'relatedPolicy',
  /** column name */
  RelationshipToPolicy_ = 'relationshipToPolicy',
  /** column name */
  Scope_ = 'scope',
  /** column name */
  SustainabilityMatter_ = 'sustainabilityMatter',
  /** column name */
  SustainabilityMatterExplanation_ = 'sustainabilityMatterExplanation',
  /** column name */
  TargetChangeDescription_ = 'targetChangeDescription',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  WithStakeholders_ = 'withStakeholders',
  /** column name */
  WithStakeholdersDescription_ = 'withStakeholdersDescription',
  /** column name */
  WithStakeholdersExplanation_ = 'withStakeholdersExplanation'
}

export type Esrs_Target_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Esrs_Target_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Esrs_Target_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Esrs_Target_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Esrs_Target_Delete_Key_Input_>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Esrs_Target_Inc_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Esrs_Target_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Esrs_Target_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Esrs_Target_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type Esrs_Target_Var_Pop_Fields_ = {
  __typename?: 'esrs_Target_var_pop_fields';
  performanceNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "esrs.Target" */
export type Esrs_Target_Var_Pop_Order_By_ = {
  performanceNumber?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type Esrs_Target_Var_Samp_Fields_ = {
  __typename?: 'esrs_Target_var_samp_fields';
  performanceNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "esrs.Target" */
export type Esrs_Target_Var_Samp_Order_By_ = {
  performanceNumber?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type Esrs_Target_Variance_Fields_ = {
  __typename?: 'esrs_Target_variance_fields';
  performanceNumber?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "esrs.Target" */
export type Esrs_Target_Variance_Order_By_ = {
  performanceNumber?: InputMaybe<Order_By_>;
};

/** columns and relationships of "storage.files" */
export type Files_ = {
  __typename?: 'files';
  /** An object relationship */
  bucket: Buckets_;
  bucketId: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  documentationFile?: Maybe<DocumentationFile_>;
  etag?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  isUploaded?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['jsonb']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  uploadedBy?: Maybe<Users_>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};


/** columns and relationships of "storage.files" */
export type FilesMetadataArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storage.files" */
export type Files_Aggregate_ = {
  __typename?: 'files_aggregate';
  aggregate?: Maybe<Files_Aggregate_Fields_>;
  nodes: Array<Files_>;
};

export type Files_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Files_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Files_Aggregate_Bool_Exp_Count_>;
};

export type Files_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Files_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Files_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Files_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Files_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "storage.files" */
export type Files_Aggregate_Fields_ = {
  __typename?: 'files_aggregate_fields';
  avg?: Maybe<Files_Avg_Fields_>;
  count: Scalars['Int']['output'];
  max?: Maybe<Files_Max_Fields_>;
  min?: Maybe<Files_Min_Fields_>;
  stddev?: Maybe<Files_Stddev_Fields_>;
  stddev_pop?: Maybe<Files_Stddev_Pop_Fields_>;
  stddev_samp?: Maybe<Files_Stddev_Samp_Fields_>;
  sum?: Maybe<Files_Sum_Fields_>;
  var_pop?: Maybe<Files_Var_Pop_Fields_>;
  var_samp?: Maybe<Files_Var_Samp_Fields_>;
  variance?: Maybe<Files_Variance_Fields_>;
};


/** aggregate fields of "storage.files" */
export type Files_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Files_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "storage.files" */
export type Files_Aggregate_Order_By_ = {
  avg?: InputMaybe<Files_Avg_Order_By_>;
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Files_Max_Order_By_>;
  min?: InputMaybe<Files_Min_Order_By_>;
  stddev?: InputMaybe<Files_Stddev_Order_By_>;
  stddev_pop?: InputMaybe<Files_Stddev_Pop_Order_By_>;
  stddev_samp?: InputMaybe<Files_Stddev_Samp_Order_By_>;
  sum?: InputMaybe<Files_Sum_Order_By_>;
  var_pop?: InputMaybe<Files_Var_Pop_Order_By_>;
  var_samp?: InputMaybe<Files_Var_Samp_Order_By_>;
  variance?: InputMaybe<Files_Variance_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Files_Append_Input_ = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "storage.files" */
export type Files_Arr_Rel_Insert_Input_ = {
  data: Array<Files_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict_>;
};

/** aggregate avg on columns */
export type Files_Avg_Fields_ = {
  __typename?: 'files_avg_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "storage.files" */
export type Files_Avg_Order_By_ = {
  size?: InputMaybe<Order_By_>;
};

/** Boolean expression to filter rows from the table "storage.files". All fields are combined with a logical 'AND'. */
export type Files_Bool_Exp_ = {
  _and?: InputMaybe<Array<Files_Bool_Exp_>>;
  _not?: InputMaybe<Files_Bool_Exp_>;
  _or?: InputMaybe<Array<Files_Bool_Exp_>>;
  bucket?: InputMaybe<Buckets_Bool_Exp_>;
  bucketId?: InputMaybe<String_Comparison_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  documentationFile?: InputMaybe<DocumentationFile_Bool_Exp_>;
  etag?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  isUploaded?: InputMaybe<Boolean_Comparison_Exp_>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp_>;
  mimeType?: InputMaybe<String_Comparison_Exp_>;
  name?: InputMaybe<String_Comparison_Exp_>;
  size?: InputMaybe<Int_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  uploadedBy?: InputMaybe<Users_Bool_Exp_>;
  uploadedByUserId?: InputMaybe<Uuid_Comparison_Exp_>;
};

/** unique or primary key constraints on table "storage.files" */
export enum Files_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  FilesPkey_ = 'files_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Files_Delete_At_Path_Input_ = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Files_Delete_Elem_Input_ = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Files_Delete_Key_Input_ = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "storage.files" */
export type Files_Inc_Input_ = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "storage.files" */
export type Files_Insert_Input_ = {
  bucket?: InputMaybe<Buckets_Obj_Rel_Insert_Input_>;
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  documentationFile?: InputMaybe<DocumentationFile_Obj_Rel_Insert_Input_>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedBy?: InputMaybe<Users_Obj_Rel_Insert_Input_>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type Files_Max_Fields_ = {
  __typename?: 'files_max_fields';
  bucketId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "storage.files" */
export type Files_Max_Order_By_ = {
  bucketId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  etag?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  mimeType?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  size?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  uploadedByUserId?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Files_Min_Fields_ = {
  __typename?: 'files_min_fields';
  bucketId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  etag?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  uploadedByUserId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "storage.files" */
export type Files_Min_Order_By_ = {
  bucketId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  etag?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  mimeType?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  size?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  uploadedByUserId?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "storage.files" */
export type Files_Mutation_Response_ = {
  __typename?: 'files_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Files_>;
};

/** input type for inserting object relation for remote table "storage.files" */
export type Files_Obj_Rel_Insert_Input_ = {
  data: Files_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Files_On_Conflict_>;
};

/** on_conflict condition type for table "storage.files" */
export type Files_On_Conflict_ = {
  constraint: Files_Constraint_;
  update_columns?: Array<Files_Update_Column_>;
  where?: InputMaybe<Files_Bool_Exp_>;
};

/** Ordering options when selecting data from "storage.files". */
export type Files_Order_By_ = {
  bucket?: InputMaybe<Buckets_Order_By_>;
  bucketId?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  documentationFile?: InputMaybe<DocumentationFile_Order_By_>;
  etag?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  isUploaded?: InputMaybe<Order_By_>;
  metadata?: InputMaybe<Order_By_>;
  mimeType?: InputMaybe<Order_By_>;
  name?: InputMaybe<Order_By_>;
  size?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  uploadedBy?: InputMaybe<Users_Order_By_>;
  uploadedByUserId?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: storage.files */
export type Files_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Files_Prepend_Input_ = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.files" */
export enum Files_Select_Column_ {
  /** column name */
  BucketId_ = 'bucketId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Etag_ = 'etag',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsUploaded_ = 'isUploaded',
  /** column name */
  Metadata_ = 'metadata',
  /** column name */
  MimeType_ = 'mimeType',
  /** column name */
  Name_ = 'name',
  /** column name */
  Size_ = 'size',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UploadedByUserId_ = 'uploadedByUserId'
}

/** select "files_aggregate_bool_exp_bool_and_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  IsUploaded_ = 'isUploaded'
}

/** select "files_aggregate_bool_exp_bool_or_arguments_columns" columns of table "storage.files" */
export enum Files_Select_Column_Files_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  IsUploaded_ = 'isUploaded'
}

/** input type for updating data in table "storage.files" */
export type Files_Set_Input_ = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type Files_Stddev_Fields_ = {
  __typename?: 'files_stddev_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "storage.files" */
export type Files_Stddev_Order_By_ = {
  size?: InputMaybe<Order_By_>;
};

/** aggregate stddev_pop on columns */
export type Files_Stddev_Pop_Fields_ = {
  __typename?: 'files_stddev_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_pop() on columns of table "storage.files" */
export type Files_Stddev_Pop_Order_By_ = {
  size?: InputMaybe<Order_By_>;
};

/** aggregate stddev_samp on columns */
export type Files_Stddev_Samp_Fields_ = {
  __typename?: 'files_stddev_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev_samp() on columns of table "storage.files" */
export type Files_Stddev_Samp_Order_By_ = {
  size?: InputMaybe<Order_By_>;
};

/** Streaming cursor of the table "files" */
export type Files_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Files_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Files_Stream_Cursor_Value_Input_ = {
  bucketId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  etag?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isUploaded?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  uploadedByUserId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type Files_Sum_Fields_ = {
  __typename?: 'files_sum_fields';
  size?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "storage.files" */
export type Files_Sum_Order_By_ = {
  size?: InputMaybe<Order_By_>;
};

/** update columns of table "storage.files" */
export enum Files_Update_Column_ {
  /** column name */
  BucketId_ = 'bucketId',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  Etag_ = 'etag',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsUploaded_ = 'isUploaded',
  /** column name */
  Metadata_ = 'metadata',
  /** column name */
  MimeType_ = 'mimeType',
  /** column name */
  Name_ = 'name',
  /** column name */
  Size_ = 'size',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UploadedByUserId_ = 'uploadedByUserId'
}

export type Files_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Files_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Files_Delete_Key_Input_>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Files_Inc_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Files_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Files_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Files_Bool_Exp_;
};

/** aggregate var_pop on columns */
export type Files_Var_Pop_Fields_ = {
  __typename?: 'files_var_pop_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_pop() on columns of table "storage.files" */
export type Files_Var_Pop_Order_By_ = {
  size?: InputMaybe<Order_By_>;
};

/** aggregate var_samp on columns */
export type Files_Var_Samp_Fields_ = {
  __typename?: 'files_var_samp_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by var_samp() on columns of table "storage.files" */
export type Files_Var_Samp_Order_By_ = {
  size?: InputMaybe<Order_By_>;
};

/** aggregate variance on columns */
export type Files_Variance_Fields_ = {
  __typename?: 'files_variance_fields';
  size?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "storage.files" */
export type Files_Variance_Order_By_ = {
  size?: InputMaybe<Order_By_>;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp_ = {
  _eq?: InputMaybe<Scalars['float8']['input']>;
  _gt?: InputMaybe<Scalars['float8']['input']>;
  _gte?: InputMaybe<Scalars['float8']['input']>;
  _in?: InputMaybe<Array<Scalars['float8']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['float8']['input']>;
  _lte?: InputMaybe<Scalars['float8']['input']>;
  _neq?: InputMaybe<Scalars['float8']['input']>;
  _nin?: InputMaybe<Array<Scalars['float8']['input']>>;
};

export type Jsonb_Cast_Exp_ = {
  String?: InputMaybe<String_Comparison_Exp_>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp_ = {
  _cast?: InputMaybe<Jsonb_Cast_Exp_>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

/** mutation root */
export type Mutation_Root_ = {
  __typename?: 'mutation_root';
  /** delete single row from the table: "auth.providers" */
  deleteAuthProvider?: Maybe<AuthProviders_>;
  /** delete single row from the table: "auth.provider_requests" */
  deleteAuthProviderRequest?: Maybe<AuthProviderRequests_>;
  /** delete data from the table: "auth.provider_requests" */
  deleteAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response_>;
  /** delete data from the table: "auth.providers" */
  deleteAuthProviders?: Maybe<AuthProviders_Mutation_Response_>;
  /** delete single row from the table: "auth.refresh_tokens" */
  deleteAuthRefreshToken?: Maybe<AuthRefreshTokens_>;
  /** delete single row from the table: "auth.refresh_token_types" */
  deleteAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes_>;
  /** delete data from the table: "auth.refresh_token_types" */
  deleteAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response_>;
  /** delete data from the table: "auth.refresh_tokens" */
  deleteAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response_>;
  /** delete single row from the table: "auth.roles" */
  deleteAuthRole?: Maybe<AuthRoles_>;
  /** delete data from the table: "auth.roles" */
  deleteAuthRoles?: Maybe<AuthRoles_Mutation_Response_>;
  /** delete single row from the table: "auth.user_providers" */
  deleteAuthUserProvider?: Maybe<AuthUserProviders_>;
  /** delete data from the table: "auth.user_providers" */
  deleteAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response_>;
  /** delete single row from the table: "auth.user_roles" */
  deleteAuthUserRole?: Maybe<AuthUserRoles_>;
  /** delete data from the table: "auth.user_roles" */
  deleteAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response_>;
  /** delete single row from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys_>;
  /** delete data from the table: "auth.user_security_keys" */
  deleteAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response_>;
  /** delete single row from the table: "storage.buckets" */
  deleteBucket?: Maybe<Buckets_>;
  /** delete data from the table: "storage.buckets" */
  deleteBuckets?: Maybe<Buckets_Mutation_Response_>;
  /** delete single row from the table: "storage.files" */
  deleteFile?: Maybe<Files_>;
  /** delete data from the table: "storage.files" */
  deleteFiles?: Maybe<Files_Mutation_Response_>;
  /** delete single row from the table: "auth.users" */
  deleteUser?: Maybe<Users_>;
  /** delete data from the table: "auth.users" */
  deleteUsers?: Maybe<Users_Mutation_Response_>;
  /** delete single row from the table: "storage.virus" */
  deleteVirus?: Maybe<Virus_>;
  /** delete data from the table: "storage.virus" */
  deleteViruses?: Maybe<Virus_Mutation_Response_>;
  /** delete data from the table: "AIConfig" */
  delete_AIConfig?: Maybe<AiConfig_Mutation_Response_>;
  /** delete single row from the table: "AIConfig" */
  delete_AIConfig_by_pk?: Maybe<AiConfig_>;
  /** delete data from the table: "esrs.ActionQuestion" */
  delete_ActionQuestion?: Maybe<ActionQuestion_Mutation_Response_>;
  /** delete data from the table: "esrs.ActionQuestionGroup" */
  delete_ActionQuestionGroup?: Maybe<ActionQuestionGroup_Mutation_Response_>;
  /** delete single row from the table: "esrs.ActionQuestionGroup" */
  delete_ActionQuestionGroup_by_pk?: Maybe<ActionQuestionGroup_>;
  /** delete single row from the table: "esrs.ActionQuestion" */
  delete_ActionQuestion_by_pk?: Maybe<ActionQuestion_>;
  /** delete data from the table: "Activity" */
  delete_Activity?: Maybe<Activity_Mutation_Response_>;
  /** delete data from the table: "ActivityNaceCode" */
  delete_ActivityNaceCode?: Maybe<ActivityNaceCode_Mutation_Response_>;
  /** delete single row from the table: "ActivityNaceCode" */
  delete_ActivityNaceCode_by_pk?: Maybe<ActivityNaceCode_>;
  /** delete data from the table: "ActivityQuestionSet" */
  delete_ActivityQuestionSet?: Maybe<ActivityQuestionSet_Mutation_Response_>;
  /** delete single row from the table: "ActivityQuestionSet" */
  delete_ActivityQuestionSet_by_pk?: Maybe<ActivityQuestionSet_>;
  /** delete data from the table: "ActivityReport" */
  delete_ActivityReport?: Maybe<ActivityReport_Mutation_Response_>;
  /** delete single row from the table: "ActivityReport" */
  delete_ActivityReport_by_pk?: Maybe<ActivityReport_>;
  /** delete data from the table: "ActivityVersion" */
  delete_ActivityVersion?: Maybe<ActivityVersion_Mutation_Response_>;
  /** delete single row from the table: "ActivityVersion" */
  delete_ActivityVersion_by_pk?: Maybe<ActivityVersion_>;
  /** delete single row from the table: "Activity" */
  delete_Activity_by_pk?: Maybe<Activity_>;
  /** delete data from the table: "esrs.AdditionalType" */
  delete_AdditionalType?: Maybe<AdditionalType_Mutation_Response_>;
  /** delete single row from the table: "esrs.AdditionalType" */
  delete_AdditionalType_by_pk?: Maybe<AdditionalType_>;
  /** delete data from the table: "Answer" */
  delete_Answer?: Maybe<Answer_Mutation_Response_>;
  /** delete single row from the table: "Answer" */
  delete_Answer_by_pk?: Maybe<Answer_>;
  /** delete data from the table: "AppConfig" */
  delete_AppConfig?: Maybe<AppConfig_Mutation_Response_>;
  /** delete single row from the table: "AppConfig" */
  delete_AppConfig_by_pk?: Maybe<AppConfig_>;
  /** delete data from the table: "Article" */
  delete_Article?: Maybe<Article_Mutation_Response_>;
  /** delete single row from the table: "Article" */
  delete_Article_by_pk?: Maybe<Article_>;
  /** delete data from the table: "Attachment" */
  delete_Attachment?: Maybe<Attachment_Mutation_Response_>;
  /** delete data from the table: "AttachmentBox" */
  delete_AttachmentBox?: Maybe<AttachmentBox_Mutation_Response_>;
  /** delete single row from the table: "AttachmentBox" */
  delete_AttachmentBox_by_pk?: Maybe<AttachmentBox_>;
  /** delete single row from the table: "Attachment" */
  delete_Attachment_by_pk?: Maybe<Attachment_>;
  /** delete data from the table: "AuditLogEntry" */
  delete_AuditLogEntry?: Maybe<AuditLogEntry_Mutation_Response_>;
  /** delete single row from the table: "AuditLogEntry" */
  delete_AuditLogEntry_by_pk?: Maybe<AuditLogEntry_>;
  /** delete data from the table: "BusinessUnit" */
  delete_BusinessUnit?: Maybe<BusinessUnit_Mutation_Response_>;
  /** delete data from the table: "BusinessUnitAssessment" */
  delete_BusinessUnitAssessment?: Maybe<BusinessUnitAssessment_Mutation_Response_>;
  /** delete single row from the table: "BusinessUnitAssessment" */
  delete_BusinessUnitAssessment_by_pk?: Maybe<BusinessUnitAssessment_>;
  /** delete single row from the table: "BusinessUnit" */
  delete_BusinessUnit_by_pk?: Maybe<BusinessUnit_>;
  /** delete data from the table: "CachedResult" */
  delete_CachedResult?: Maybe<CachedResult_Mutation_Response_>;
  /** delete single row from the table: "CachedResult" */
  delete_CachedResult_by_pk?: Maybe<CachedResult_>;
  /** delete data from the table: "esrs.ChoiceSet" */
  delete_ChoiceSet?: Maybe<ChoiceSet_Mutation_Response_>;
  /** delete single row from the table: "esrs.ChoiceSet" */
  delete_ChoiceSet_by_pk?: Maybe<ChoiceSet_>;
  /** delete data from the table: "Comment" */
  delete_Comment?: Maybe<Comment_Mutation_Response_>;
  /** delete single row from the table: "Comment" */
  delete_Comment_by_pk?: Maybe<Comment_>;
  /** delete data from the table: "Company" */
  delete_Company?: Maybe<Company_Mutation_Response_>;
  /** delete data from the table: "CompanyAssessment" */
  delete_CompanyAssessment?: Maybe<CompanyAssessment_Mutation_Response_>;
  /** delete data from the table: "CompanyAssessmentAggregate" */
  delete_CompanyAssessmentAggregate?: Maybe<CompanyAssessmentAggregate_Mutation_Response_>;
  /** delete single row from the table: "CompanyAssessmentAggregate" */
  delete_CompanyAssessmentAggregate_by_pk?: Maybe<CompanyAssessmentAggregate_>;
  /** delete single row from the table: "CompanyAssessment" */
  delete_CompanyAssessment_by_pk?: Maybe<CompanyAssessment_>;
  /** delete data from the table: "CompanyIdentityProvider" */
  delete_CompanyIdentityProvider?: Maybe<CompanyIdentityProvider_Mutation_Response_>;
  /** delete single row from the table: "CompanyIdentityProvider" */
  delete_CompanyIdentityProvider_by_pk?: Maybe<CompanyIdentityProvider_>;
  /** delete data from the table: "CompanyInvitation" */
  delete_CompanyInvitation?: Maybe<CompanyInvitation_Mutation_Response_>;
  /** delete single row from the table: "CompanyInvitation" */
  delete_CompanyInvitation_by_pk?: Maybe<CompanyInvitation_>;
  /** delete data from the table: "CompanyUser" */
  delete_CompanyUser?: Maybe<CompanyUser_Mutation_Response_>;
  /** delete single row from the table: "CompanyUser" */
  delete_CompanyUser_by_pk?: Maybe<CompanyUser_>;
  /** delete single row from the table: "Company" */
  delete_Company_by_pk?: Maybe<Company_>;
  /** delete data from the table: "CompassPAT" */
  delete_CompassPAT?: Maybe<CompassPat_Mutation_Response_>;
  /** delete single row from the table: "CompassPAT" */
  delete_CompassPAT_by_pk?: Maybe<CompassPat_>;
  /** delete data from the table: "esrs.DRToMFDisclosureRequirement" */
  delete_DRToMFDisclosureRequirement?: Maybe<DrToMfDisclosureRequirement_Mutation_Response_>;
  /** delete single row from the table: "esrs.DRToMFDisclosureRequirement" */
  delete_DRToMFDisclosureRequirement_by_pk?: Maybe<DrToMfDisclosureRequirement_>;
  /** delete data from the table: "esrs.DisclosureRequirement" */
  delete_DisclosureRequirement?: Maybe<DisclosureRequirement_Mutation_Response_>;
  /** delete data from the table: "esrs.DisclosureRequirementAdditionalType" */
  delete_DisclosureRequirementAdditionalType?: Maybe<DisclosureRequirementAdditionalType_Mutation_Response_>;
  /** delete single row from the table: "esrs.DisclosureRequirementAdditionalType" */
  delete_DisclosureRequirementAdditionalType_by_pk?: Maybe<DisclosureRequirementAdditionalType_>;
  /** delete data from the table: "esrs.DisclosureRequirementGroup" */
  delete_DisclosureRequirementGroup?: Maybe<DisclosureRequirementGroup_Mutation_Response_>;
  /** delete single row from the table: "esrs.DisclosureRequirementGroup" */
  delete_DisclosureRequirementGroup_by_pk?: Maybe<DisclosureRequirementGroup_>;
  /** delete data from the table: "esrs.DisclosureRequirementOwner" */
  delete_DisclosureRequirementOwner?: Maybe<DisclosureRequirementOwner_Mutation_Response_>;
  /** delete single row from the table: "esrs.DisclosureRequirementOwner" */
  delete_DisclosureRequirementOwner_by_pk?: Maybe<DisclosureRequirementOwner_>;
  /** delete data from the table: "esrs.DisclosureRequirementStatus" */
  delete_DisclosureRequirementStatus?: Maybe<DisclosureRequirementStatus_Mutation_Response_>;
  /** delete single row from the table: "esrs.DisclosureRequirementStatus" */
  delete_DisclosureRequirementStatus_by_pk?: Maybe<DisclosureRequirementStatus_>;
  /** delete single row from the table: "esrs.DisclosureRequirement" */
  delete_DisclosureRequirement_by_pk?: Maybe<DisclosureRequirement_>;
  /** delete data from the table: "DocumentInsight" */
  delete_DocumentInsight?: Maybe<DocumentInsight_Mutation_Response_>;
  /** delete single row from the table: "DocumentInsight" */
  delete_DocumentInsight_by_pk?: Maybe<DocumentInsight_>;
  /** delete data from the table: "DocumentationFile" */
  delete_DocumentationFile?: Maybe<DocumentationFile_Mutation_Response_>;
  /** delete single row from the table: "DocumentationFile" */
  delete_DocumentationFile_by_pk?: Maybe<DocumentationFile_>;
  /** delete data from the table: "esrs.EsrsAssessment" */
  delete_EsrsAssessment?: Maybe<EsrsAssessment_Mutation_Response_>;
  /** delete single row from the table: "esrs.EsrsAssessment" */
  delete_EsrsAssessment_by_pk?: Maybe<EsrsAssessment_>;
  /** delete data from the table: "esrs.EsrsCategory" */
  delete_EsrsCategory?: Maybe<EsrsCategory_Mutation_Response_>;
  /** delete single row from the table: "esrs.EsrsCategory" */
  delete_EsrsCategory_by_pk?: Maybe<EsrsCategory_>;
  /** delete data from the table: "esrs.EsrsChoice" */
  delete_EsrsChoice?: Maybe<EsrsChoice_Mutation_Response_>;
  /** delete single row from the table: "esrs.EsrsChoice" */
  delete_EsrsChoice_by_pk?: Maybe<EsrsChoice_>;
  /** delete data from the table: "esrs.EsrsMetric" */
  delete_EsrsMetric?: Maybe<EsrsMetric_Mutation_Response_>;
  /** delete data from the table: "esrs.EsrsMetricAdditionalType" */
  delete_EsrsMetricAdditionalType?: Maybe<EsrsMetricAdditionalType_Mutation_Response_>;
  /** delete single row from the table: "esrs.EsrsMetricAdditionalType" */
  delete_EsrsMetricAdditionalType_by_pk?: Maybe<EsrsMetricAdditionalType_>;
  /** delete single row from the table: "esrs.EsrsMetric" */
  delete_EsrsMetric_by_pk?: Maybe<EsrsMetric_>;
  /** delete data from the table: "esrs.EsrsStandard" */
  delete_EsrsStandard?: Maybe<EsrsStandard_Mutation_Response_>;
  /** delete data from the table: "esrs.EsrsStandardAdditionalType" */
  delete_EsrsStandardAdditionalType?: Maybe<EsrsStandardAdditionalType_Mutation_Response_>;
  /** delete single row from the table: "esrs.EsrsStandardAdditionalType" */
  delete_EsrsStandardAdditionalType_by_pk?: Maybe<EsrsStandardAdditionalType_>;
  /** delete single row from the table: "esrs.EsrsStandard" */
  delete_EsrsStandard_by_pk?: Maybe<EsrsStandard_>;
  /** delete data from the table: "EstimateCompany_deprecated" */
  delete_EstimateCompany_deprecated?: Maybe<EstimateCompany_Deprecated_Mutation_Response_>;
  /** delete single row from the table: "EstimateCompany_deprecated" */
  delete_EstimateCompany_deprecated_by_pk?: Maybe<EstimateCompany_Deprecated_>;
  /** delete data from the table: "ExtractionJob" */
  delete_ExtractionJob?: Maybe<ExtractionJob_Mutation_Response_>;
  /** delete single row from the table: "ExtractionJob" */
  delete_ExtractionJob_by_pk?: Maybe<ExtractionJob_>;
  /** delete data from the table: "Financials" */
  delete_Financials?: Maybe<Financials_Mutation_Response_>;
  /** delete single row from the table: "Financials" */
  delete_Financials_by_pk?: Maybe<Financials_>;
  /** delete data from the table: "esrs.Framework" */
  delete_Framework?: Maybe<Framework_Mutation_Response_>;
  /** delete single row from the table: "esrs.Framework" */
  delete_Framework_by_pk?: Maybe<Framework_>;
  /** delete data from the table: "GroupAssessment" */
  delete_GroupAssessment?: Maybe<GroupAssessment_Mutation_Response_>;
  /** delete single row from the table: "GroupAssessment" */
  delete_GroupAssessment_by_pk?: Maybe<GroupAssessment_>;
  /** delete data from the table: "IdentityProvider" */
  delete_IdentityProvider?: Maybe<IdentityProvider_Mutation_Response_>;
  /** delete single row from the table: "IdentityProvider" */
  delete_IdentityProvider_by_pk?: Maybe<IdentityProvider_>;
  /** delete data from the table: "IndicatorToInvestorMetric" */
  delete_IndicatorToInvestorMetric?: Maybe<IndicatorToInvestorMetric_Mutation_Response_>;
  /** delete single row from the table: "IndicatorToInvestorMetric" */
  delete_IndicatorToInvestorMetric_by_pk?: Maybe<IndicatorToInvestorMetric_>;
  /** delete data from the table: "InvesteeMetric" */
  delete_InvesteeMetric?: Maybe<InvesteeMetric_Mutation_Response_>;
  /** delete single row from the table: "InvesteeMetric" */
  delete_InvesteeMetric_by_pk?: Maybe<InvesteeMetric_>;
  /** delete data from the table: "InvestmentCategory" */
  delete_InvestmentCategory?: Maybe<InvestmentCategory_Mutation_Response_>;
  /** delete single row from the table: "InvestmentCategory" */
  delete_InvestmentCategory_by_pk?: Maybe<InvestmentCategory_>;
  /** delete data from the table: "InvestorMetric" */
  delete_InvestorMetric?: Maybe<InvestorMetric_Mutation_Response_>;
  /** delete single row from the table: "InvestorMetric" */
  delete_InvestorMetric_by_pk?: Maybe<InvestorMetric_>;
  /** delete data from the table: "InvestorToInvesteeMetric" */
  delete_InvestorToInvesteeMetric?: Maybe<InvestorToInvesteeMetric_Mutation_Response_>;
  /** delete single row from the table: "InvestorToInvesteeMetric" */
  delete_InvestorToInvesteeMetric_by_pk?: Maybe<InvestorToInvesteeMetric_>;
  /** delete data from the table: "esrs.MFCategory" */
  delete_MFCategory?: Maybe<MfCategory_Mutation_Response_>;
  /** delete single row from the table: "esrs.MFCategory" */
  delete_MFCategory_by_pk?: Maybe<MfCategory_>;
  /** delete data from the table: "esrs.MFDisclosureRequirement" */
  delete_MFDisclosureRequirement?: Maybe<MfDisclosureRequirement_Mutation_Response_>;
  /** delete data from the table: "esrs.MFDisclosureRequirementGroup" */
  delete_MFDisclosureRequirementGroup?: Maybe<MfDisclosureRequirementGroup_Mutation_Response_>;
  /** delete single row from the table: "esrs.MFDisclosureRequirementGroup" */
  delete_MFDisclosureRequirementGroup_by_pk?: Maybe<MfDisclosureRequirementGroup_>;
  /** delete data from the table: "esrs.MFDisclosureRequirementItem" */
  delete_MFDisclosureRequirementItem?: Maybe<MfDisclosureRequirementItem_Mutation_Response_>;
  /** delete single row from the table: "esrs.MFDisclosureRequirementItem" */
  delete_MFDisclosureRequirementItem_by_pk?: Maybe<MfDisclosureRequirementItem_>;
  /** delete single row from the table: "esrs.MFDisclosureRequirement" */
  delete_MFDisclosureRequirement_by_pk?: Maybe<MfDisclosureRequirement_>;
  /** delete data from the table: "esrs.MFStandard" */
  delete_MFStandard?: Maybe<MfStandard_Mutation_Response_>;
  /** delete data from the table: "esrs.MFStandardItem" */
  delete_MFStandardItem?: Maybe<MfStandardItem_Mutation_Response_>;
  /** delete single row from the table: "esrs.MFStandardItem" */
  delete_MFStandardItem_by_pk?: Maybe<MfStandardItem_>;
  /** delete single row from the table: "esrs.MFStandard" */
  delete_MFStandard_by_pk?: Maybe<MfStandard_>;
  /** delete data from the table: "esrs.MaterialStandardOwner" */
  delete_MaterialStandardOwner?: Maybe<MaterialStandardOwner_Mutation_Response_>;
  /** delete single row from the table: "esrs.MaterialStandardOwner" */
  delete_MaterialStandardOwner_by_pk?: Maybe<MaterialStandardOwner_>;
  /** delete data from the table: "esrs.MetricDependency" */
  delete_MetricDependency?: Maybe<MetricDependency_Mutation_Response_>;
  /** delete single row from the table: "esrs.MetricDependency" */
  delete_MetricDependency_by_pk?: Maybe<MetricDependency_>;
  /** delete data from the table: "esrs.MetricTag" */
  delete_MetricTag?: Maybe<MetricTag_Mutation_Response_>;
  /** delete single row from the table: "esrs.MetricTag" */
  delete_MetricTag_by_pk?: Maybe<MetricTag_>;
  /** delete data from the table: "NonMaterialFinancials" */
  delete_NonMaterialFinancials?: Maybe<NonMaterialFinancials_Mutation_Response_>;
  /** delete data from the table: "Note" */
  delete_Note?: Maybe<Note_Mutation_Response_>;
  /** delete data from the table: "NoteHistory" */
  delete_NoteHistory?: Maybe<NoteHistory_Mutation_Response_>;
  /** delete single row from the table: "NoteHistory" */
  delete_NoteHistory_by_pk?: Maybe<NoteHistory_>;
  /** delete single row from the table: "Note" */
  delete_Note_by_pk?: Maybe<Note_>;
  /** delete data from the table: "Objective" */
  delete_Objective?: Maybe<Objective_Mutation_Response_>;
  /** delete single row from the table: "Objective" */
  delete_Objective_by_pk?: Maybe<Objective_>;
  /** delete data from the table: "PaiAnswers" */
  delete_PaiAnswers?: Maybe<PaiAnswers_Mutation_Response_>;
  /** delete single row from the table: "PaiAnswers" */
  delete_PaiAnswers_by_pk?: Maybe<PaiAnswers_>;
  /** delete data from the table: "PaiCategory" */
  delete_PaiCategory?: Maybe<PaiCategory_Mutation_Response_>;
  /** delete single row from the table: "PaiCategory" */
  delete_PaiCategory_by_pk?: Maybe<PaiCategory_>;
  /** delete data from the table: "PaiCompanyReport" */
  delete_PaiCompanyReport?: Maybe<PaiCompanyReport_Mutation_Response_>;
  /** delete single row from the table: "PaiCompanyReport" */
  delete_PaiCompanyReport_by_pk?: Maybe<PaiCompanyReport_>;
  /** delete data from the table: "PaiMetricInsight" */
  delete_PaiMetricInsight?: Maybe<PaiMetricInsight_Mutation_Response_>;
  /** delete single row from the table: "PaiMetricInsight" */
  delete_PaiMetricInsight_by_pk?: Maybe<PaiMetricInsight_>;
  /** delete data from the table: "PaiPortfolioReport" */
  delete_PaiPortfolioReport?: Maybe<PaiPortfolioReport_Mutation_Response_>;
  /** delete single row from the table: "PaiPortfolioReport" */
  delete_PaiPortfolioReport_by_pk?: Maybe<PaiPortfolioReport_>;
  /** delete data from the table: "PaiReportIndicator" */
  delete_PaiReportIndicator?: Maybe<PaiReportIndicator_Mutation_Response_>;
  /** delete data from the table: "PaiReportIndicatorPortfolioCompany" */
  delete_PaiReportIndicatorPortfolioCompany?: Maybe<PaiReportIndicatorPortfolioCompany_Mutation_Response_>;
  /** delete single row from the table: "PaiReportIndicatorPortfolioCompany" */
  delete_PaiReportIndicatorPortfolioCompany_by_pk?: Maybe<PaiReportIndicatorPortfolioCompany_>;
  /** delete single row from the table: "PaiReportIndicator" */
  delete_PaiReportIndicator_by_pk?: Maybe<PaiReportIndicator_>;
  /** delete data from the table: "PaiTable" */
  delete_PaiTable?: Maybe<PaiTable_Mutation_Response_>;
  /** delete data from the table: "PaiTableIndicator" */
  delete_PaiTableIndicator?: Maybe<PaiTableIndicator_Mutation_Response_>;
  /** delete single row from the table: "PaiTableIndicator" */
  delete_PaiTableIndicator_by_pk?: Maybe<PaiTableIndicator_>;
  /** delete single row from the table: "PaiTable" */
  delete_PaiTable_by_pk?: Maybe<PaiTable_>;
  /** delete data from the table: "Portfolio" */
  delete_Portfolio?: Maybe<Portfolio_Mutation_Response_>;
  /** delete data from the table: "PortfolioCompany" */
  delete_PortfolioCompany?: Maybe<PortfolioCompany_Mutation_Response_>;
  /** delete single row from the table: "PortfolioCompany" */
  delete_PortfolioCompany_by_pk?: Maybe<PortfolioCompany_>;
  /** delete data from the table: "PortfolioNonEligibleFinancials" */
  delete_PortfolioNonEligibleFinancials?: Maybe<PortfolioNonEligibleFinancials_Mutation_Response_>;
  /** delete single row from the table: "PortfolioNonEligibleFinancials" */
  delete_PortfolioNonEligibleFinancials_by_pk?: Maybe<PortfolioNonEligibleFinancials_>;
  /** delete single row from the table: "Portfolio" */
  delete_Portfolio_by_pk?: Maybe<Portfolio_>;
  /** delete data from the table: "QuarterEnum" */
  delete_QuarterEnum?: Maybe<QuarterEnum_Mutation_Response_>;
  /** delete single row from the table: "QuarterEnum" */
  delete_QuarterEnum_by_pk?: Maybe<QuarterEnum_>;
  /** delete data from the table: "Question" */
  delete_Question?: Maybe<Question_Mutation_Response_>;
  /** delete data from the table: "QuestionChoice" */
  delete_QuestionChoice?: Maybe<QuestionChoice_Mutation_Response_>;
  /** delete single row from the table: "QuestionChoice" */
  delete_QuestionChoice_by_pk?: Maybe<QuestionChoice_>;
  /** delete data from the table: "QuestionLevel" */
  delete_QuestionLevel?: Maybe<QuestionLevel_Mutation_Response_>;
  /** delete single row from the table: "QuestionLevel" */
  delete_QuestionLevel_by_pk?: Maybe<QuestionLevel_>;
  /** delete data from the table: "QuestionRevision" */
  delete_QuestionRevision?: Maybe<QuestionRevision_Mutation_Response_>;
  /** delete single row from the table: "QuestionRevision" */
  delete_QuestionRevision_by_pk?: Maybe<QuestionRevision_>;
  /** delete data from the table: "QuestionSet" */
  delete_QuestionSet?: Maybe<QuestionSet_Mutation_Response_>;
  /** delete data from the table: "QuestionSetQuestion" */
  delete_QuestionSetQuestion?: Maybe<QuestionSetQuestion_Mutation_Response_>;
  /** delete single row from the table: "QuestionSetQuestion" */
  delete_QuestionSetQuestion_by_pk?: Maybe<QuestionSetQuestion_>;
  /** delete single row from the table: "QuestionSet" */
  delete_QuestionSet_by_pk?: Maybe<QuestionSet_>;
  /** delete data from the table: "QuestionType" */
  delete_QuestionType?: Maybe<QuestionType_Mutation_Response_>;
  /** delete single row from the table: "QuestionType" */
  delete_QuestionType_by_pk?: Maybe<QuestionType_>;
  /** delete single row from the table: "Question" */
  delete_Question_by_pk?: Maybe<Question_>;
  /** delete data from the table: "ReportingGroup" */
  delete_ReportingGroup?: Maybe<ReportingGroup_Mutation_Response_>;
  /** delete single row from the table: "ReportingGroup" */
  delete_ReportingGroup_by_pk?: Maybe<ReportingGroup_>;
  /** delete data from the table: "Sector" */
  delete_Sector?: Maybe<Sector_Mutation_Response_>;
  /** delete single row from the table: "Sector" */
  delete_Sector_by_pk?: Maybe<Sector_>;
  /** delete data from the table: "SharedSpace" */
  delete_SharedSpace?: Maybe<SharedSpace_Mutation_Response_>;
  /** delete single row from the table: "SharedSpace" */
  delete_SharedSpace_by_pk?: Maybe<SharedSpace_>;
  /** delete data from the table: "Space" */
  delete_Space?: Maybe<Space_Mutation_Response_>;
  /** delete single row from the table: "Space" */
  delete_Space_by_pk?: Maybe<Space_>;
  /** delete data from the table: "Subsidiary" */
  delete_Subsidiary?: Maybe<Subsidiary_Mutation_Response_>;
  /** delete single row from the table: "Subsidiary" */
  delete_Subsidiary_by_pk?: Maybe<Subsidiary_>;
  /** delete data from the table: "Tag" */
  delete_Tag?: Maybe<Tag_Mutation_Response_>;
  /** delete data from the table: "TagGroup" */
  delete_TagGroup?: Maybe<TagGroup_Mutation_Response_>;
  /** delete single row from the table: "TagGroup" */
  delete_TagGroup_by_pk?: Maybe<TagGroup_>;
  /** delete data from the table: "esrs.TagType" */
  delete_TagType?: Maybe<TagType_Mutation_Response_>;
  /** delete single row from the table: "esrs.TagType" */
  delete_TagType_by_pk?: Maybe<TagType_>;
  /** delete data from the table: "esrs.TagValue" */
  delete_TagValue?: Maybe<TagValue_Mutation_Response_>;
  /** delete single row from the table: "esrs.TagValue" */
  delete_TagValue_by_pk?: Maybe<TagValue_>;
  /** delete data from the table: "Tag_articles" */
  delete_Tag_articles?: Maybe<Tag_Articles_Mutation_Response_>;
  /** delete single row from the table: "Tag_articles" */
  delete_Tag_articles_by_pk?: Maybe<Tag_Articles_>;
  /** delete single row from the table: "Tag" */
  delete_Tag_by_pk?: Maybe<Tag_>;
  /** delete data from the table: "esrs.TargetQuestion" */
  delete_TargetQuestion?: Maybe<TargetQuestion_Mutation_Response_>;
  /** delete data from the table: "esrs.TargetQuestionGroup" */
  delete_TargetQuestionGroup?: Maybe<TargetQuestionGroup_Mutation_Response_>;
  /** delete single row from the table: "esrs.TargetQuestionGroup" */
  delete_TargetQuestionGroup_by_pk?: Maybe<TargetQuestionGroup_>;
  /** delete single row from the table: "esrs.TargetQuestion" */
  delete_TargetQuestion_by_pk?: Maybe<TargetQuestion_>;
  /** delete data from the table: "Task" */
  delete_Task?: Maybe<Task_Mutation_Response_>;
  /** delete data from the table: "TaskStatusEnum" */
  delete_TaskStatusEnum?: Maybe<TaskStatusEnum_Mutation_Response_>;
  /** delete single row from the table: "TaskStatusEnum" */
  delete_TaskStatusEnum_by_pk?: Maybe<TaskStatusEnum_>;
  /** delete single row from the table: "Task" */
  delete_Task_by_pk?: Maybe<Task_>;
  /** delete data from the table: "TaxonomyPortfolioReport" */
  delete_TaxonomyPortfolioReport?: Maybe<TaxonomyPortfolioReport_Mutation_Response_>;
  /** delete single row from the table: "TaxonomyPortfolioReport" */
  delete_TaxonomyPortfolioReport_by_pk?: Maybe<TaxonomyPortfolioReport_>;
  /** delete data from the table: "Thread" */
  delete_Thread?: Maybe<Thread_Mutation_Response_>;
  /** delete data from the table: "ThreadSubscriber" */
  delete_ThreadSubscriber?: Maybe<ThreadSubscriber_Mutation_Response_>;
  /** delete single row from the table: "ThreadSubscriber" */
  delete_ThreadSubscriber_by_pk?: Maybe<ThreadSubscriber_>;
  /** delete single row from the table: "Thread" */
  delete_Thread_by_pk?: Maybe<Thread_>;
  /** delete data from the table: "TotalComparisonFinancials" */
  delete_TotalComparisonFinancials?: Maybe<TotalComparisonFinancials_Mutation_Response_>;
  /** delete data from the table: "TriggerTypes" */
  delete_TriggerTypes?: Maybe<TriggerTypes_Mutation_Response_>;
  /** delete single row from the table: "TriggerTypes" */
  delete_TriggerTypes_by_pk?: Maybe<TriggerTypes_>;
  /** delete data from the table: "UserNotification" */
  delete_UserNotification?: Maybe<UserNotification_Mutation_Response_>;
  /** delete single row from the table: "UserNotification" */
  delete_UserNotification_by_pk?: Maybe<UserNotification_>;
  /** delete data from the table: "UserRole" */
  delete_UserRole?: Maybe<UserRole_Mutation_Response_>;
  /** delete single row from the table: "UserRole" */
  delete_UserRole_by_pk?: Maybe<UserRole_>;
  /** delete data from the table: "UserSessionMetadata" */
  delete_UserSessionMetadata?: Maybe<UserSessionMetadata_Mutation_Response_>;
  /** delete single row from the table: "UserSessionMetadata" */
  delete_UserSessionMetadata_by_pk?: Maybe<UserSessionMetadata_>;
  /** delete data from the table: "WebsocketTest" */
  delete_WebsocketTest?: Maybe<WebsocketTest_Mutation_Response_>;
  /** delete single row from the table: "WebsocketTest" */
  delete_WebsocketTest_by_pk?: Maybe<WebsocketTest_>;
  /** delete data from the table: "esrs.ActionReportingUnit" */
  delete_esrs_ActionReportingUnit?: Maybe<Esrs_ActionReportingUnit_Mutation_Response_>;
  /** delete single row from the table: "esrs.ActionReportingUnit" */
  delete_esrs_ActionReportingUnit_by_pk?: Maybe<Esrs_ActionReportingUnit_>;
  /** delete data from the table: "esrs.ActionSubsidiary" */
  delete_esrs_ActionSubsidiary?: Maybe<Esrs_ActionSubsidiary_Mutation_Response_>;
  /** delete single row from the table: "esrs.ActionSubsidiary" */
  delete_esrs_ActionSubsidiary_by_pk?: Maybe<Esrs_ActionSubsidiary_>;
  /** delete data from the table: "esrs.ActionTarget" */
  delete_esrs_ActionTarget?: Maybe<Esrs_ActionTarget_Mutation_Response_>;
  /** delete single row from the table: "esrs.ActionTarget" */
  delete_esrs_ActionTarget_by_pk?: Maybe<Esrs_ActionTarget_>;
  /** delete data from the table: "esrs.Actions" */
  delete_esrs_Actions?: Maybe<Esrs_Actions_Mutation_Response_>;
  /** delete single row from the table: "esrs.Actions" */
  delete_esrs_Actions_by_pk?: Maybe<Esrs_Actions_>;
  /** delete data from the table: "esrs.Answer" */
  delete_esrs_Answer?: Maybe<Esrs_Answer_Mutation_Response_>;
  /** delete single row from the table: "esrs.Answer" */
  delete_esrs_Answer_by_pk?: Maybe<Esrs_Answer_>;
  /** delete data from the table: "esrs.AssessmentCurrencyConversion" */
  delete_esrs_AssessmentCurrencyConversion?: Maybe<Esrs_AssessmentCurrencyConversion_Mutation_Response_>;
  /** delete single row from the table: "esrs.AssessmentCurrencyConversion" */
  delete_esrs_AssessmentCurrencyConversion_by_pk?: Maybe<Esrs_AssessmentCurrencyConversion_>;
  /** delete data from the table: "esrs.Baseline" */
  delete_esrs_Baseline?: Maybe<Esrs_Baseline_Mutation_Response_>;
  /** delete single row from the table: "esrs.Baseline" */
  delete_esrs_Baseline_by_pk?: Maybe<Esrs_Baseline_>;
  /** delete data from the table: "esrs.CompanyIntegration" */
  delete_esrs_CompanyIntegration?: Maybe<Esrs_CompanyIntegration_Mutation_Response_>;
  /** delete single row from the table: "esrs.CompanyIntegration" */
  delete_esrs_CompanyIntegration_by_pk?: Maybe<Esrs_CompanyIntegration_>;
  /** delete data from the table: "esrs.Datapoint" */
  delete_esrs_Datapoint?: Maybe<Esrs_Datapoint_Mutation_Response_>;
  /** delete data from the table: "esrs.DatapointChoice" */
  delete_esrs_DatapointChoice?: Maybe<Esrs_DatapointChoice_Mutation_Response_>;
  /** delete single row from the table: "esrs.DatapointChoice" */
  delete_esrs_DatapointChoice_by_pk?: Maybe<Esrs_DatapointChoice_>;
  /** delete data from the table: "esrs.DatapointMdrm" */
  delete_esrs_DatapointMdrm?: Maybe<Esrs_DatapointMdrm_Mutation_Response_>;
  /** delete single row from the table: "esrs.DatapointMdrm" */
  delete_esrs_DatapointMdrm_by_pk?: Maybe<Esrs_DatapointMdrm_>;
  /** delete data from the table: "esrs.DatapointTag" */
  delete_esrs_DatapointTag?: Maybe<Esrs_DatapointTag_Mutation_Response_>;
  /** delete single row from the table: "esrs.DatapointTag" */
  delete_esrs_DatapointTag_by_pk?: Maybe<Esrs_DatapointTag_>;
  /** delete single row from the table: "esrs.Datapoint" */
  delete_esrs_Datapoint_by_pk?: Maybe<Esrs_Datapoint_>;
  /** delete data from the table: "esrs.Deprecated_ActionBusinessUnit" */
  delete_esrs_Deprecated_ActionBusinessUnit?: Maybe<Esrs_Deprecated_ActionBusinessUnit_Mutation_Response_>;
  /** delete single row from the table: "esrs.Deprecated_ActionBusinessUnit" */
  delete_esrs_Deprecated_ActionBusinessUnit_by_pk?: Maybe<Esrs_Deprecated_ActionBusinessUnit_>;
  /** delete data from the table: "esrs.Deprecated_BusinessUnitEsrsAssessment" */
  delete_esrs_Deprecated_BusinessUnitEsrsAssessment?: Maybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Mutation_Response_>;
  /** delete single row from the table: "esrs.Deprecated_BusinessUnitEsrsAssessment" */
  delete_esrs_Deprecated_BusinessUnitEsrsAssessment_by_pk?: Maybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_>;
  /** delete data from the table: "esrs.Deprecated_CompanyMaterialityAssessment" */
  delete_esrs_Deprecated_CompanyMaterialityAssessment?: Maybe<Esrs_Deprecated_CompanyMaterialityAssessment_Mutation_Response_>;
  /** delete single row from the table: "esrs.Deprecated_CompanyMaterialityAssessment" */
  delete_esrs_Deprecated_CompanyMaterialityAssessment_by_pk?: Maybe<Esrs_Deprecated_CompanyMaterialityAssessment_>;
  /** delete data from the table: "esrs.Deprecated_EsrsMDRM" */
  delete_esrs_Deprecated_EsrsMDRM?: Maybe<Esrs_Deprecated_EsrsMdrm_Mutation_Response_>;
  /** delete single row from the table: "esrs.Deprecated_EsrsMDRM" */
  delete_esrs_Deprecated_EsrsMDRM_by_pk?: Maybe<Esrs_Deprecated_EsrsMdrm_>;
  /** delete data from the table: "esrs.Deprecated_MaterialDisclosureRequirement" */
  delete_esrs_Deprecated_MaterialDisclosureRequirement?: Maybe<Esrs_Deprecated_MaterialDisclosureRequirement_Mutation_Response_>;
  /** delete single row from the table: "esrs.Deprecated_MaterialDisclosureRequirement" */
  delete_esrs_Deprecated_MaterialDisclosureRequirement_by_pk?: Maybe<Esrs_Deprecated_MaterialDisclosureRequirement_>;
  /** delete data from the table: "esrs.Deprecated_MetricAnswer" */
  delete_esrs_Deprecated_MetricAnswer?: Maybe<Esrs_Deprecated_MetricAnswer_Mutation_Response_>;
  /** delete single row from the table: "esrs.Deprecated_MetricAnswer" */
  delete_esrs_Deprecated_MetricAnswer_by_pk?: Maybe<Esrs_Deprecated_MetricAnswer_>;
  /** delete data from the table: "esrs.DisclosureRequirementAttachment" */
  delete_esrs_DisclosureRequirementAttachment?: Maybe<Esrs_DisclosureRequirementAttachment_Mutation_Response_>;
  /** delete single row from the table: "esrs.DisclosureRequirementAttachment" */
  delete_esrs_DisclosureRequirementAttachment_by_pk?: Maybe<Esrs_DisclosureRequirementAttachment_>;
  /** delete data from the table: "esrs.EsrsAssessmentCompanyIntegration" */
  delete_esrs_EsrsAssessmentCompanyIntegration?: Maybe<Esrs_EsrsAssessmentCompanyIntegration_Mutation_Response_>;
  /** delete data from the table: "esrs.EsrsAssessmentCompanyIntegrationRU" */
  delete_esrs_EsrsAssessmentCompanyIntegrationRU?: Maybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Mutation_Response_>;
  /** delete single row from the table: "esrs.EsrsAssessmentCompanyIntegrationRU" */
  delete_esrs_EsrsAssessmentCompanyIntegrationRU_by_pk?: Maybe<Esrs_EsrsAssessmentCompanyIntegrationRu_>;
  /** delete single row from the table: "esrs.EsrsAssessmentCompanyIntegration" */
  delete_esrs_EsrsAssessmentCompanyIntegration_by_pk?: Maybe<Esrs_EsrsAssessmentCompanyIntegration_>;
  /** delete data from the table: "esrs.MaterialMetric" */
  delete_esrs_MaterialMetric?: Maybe<Esrs_MaterialMetric_Mutation_Response_>;
  /** delete data from the table: "esrs.MaterialMetricTag" */
  delete_esrs_MaterialMetricTag?: Maybe<Esrs_MaterialMetricTag_Mutation_Response_>;
  /** delete single row from the table: "esrs.MaterialMetricTag" */
  delete_esrs_MaterialMetricTag_by_pk?: Maybe<Esrs_MaterialMetricTag_>;
  /** delete single row from the table: "esrs.MaterialMetric" */
  delete_esrs_MaterialMetric_by_pk?: Maybe<Esrs_MaterialMetric_>;
  /** delete data from the table: "esrs.MaterialStandard" */
  delete_esrs_MaterialStandard?: Maybe<Esrs_MaterialStandard_Mutation_Response_>;
  /** delete single row from the table: "esrs.MaterialStandard" */
  delete_esrs_MaterialStandard_by_pk?: Maybe<Esrs_MaterialStandard_>;
  /** delete data from the table: "esrs.MaterialTagValue" */
  delete_esrs_MaterialTagValue?: Maybe<Esrs_MaterialTagValue_Mutation_Response_>;
  /** delete single row from the table: "esrs.MaterialTagValue" */
  delete_esrs_MaterialTagValue_by_pk?: Maybe<Esrs_MaterialTagValue_>;
  /** delete data from the table: "esrs.Milestone" */
  delete_esrs_Milestone?: Maybe<Esrs_Milestone_Mutation_Response_>;
  /** delete data from the table: "esrs.MilestoneResult" */
  delete_esrs_MilestoneResult?: Maybe<Esrs_MilestoneResult_Mutation_Response_>;
  /** delete single row from the table: "esrs.MilestoneResult" */
  delete_esrs_MilestoneResult_by_pk?: Maybe<Esrs_MilestoneResult_>;
  /** delete single row from the table: "esrs.Milestone" */
  delete_esrs_Milestone_by_pk?: Maybe<Esrs_Milestone_>;
  /** delete data from the table: "esrs.Policy" */
  delete_esrs_Policy?: Maybe<Esrs_Policy_Mutation_Response_>;
  /** delete single row from the table: "esrs.Policy" */
  delete_esrs_Policy_by_pk?: Maybe<Esrs_Policy_>;
  /** delete data from the table: "esrs.ReportingUnit" */
  delete_esrs_ReportingUnit?: Maybe<Esrs_ReportingUnit_Mutation_Response_>;
  /** delete data from the table: "esrs.ReportingUnitLineage" */
  delete_esrs_ReportingUnitLineage?: Maybe<Esrs_ReportingUnitLineage_Mutation_Response_>;
  /** delete single row from the table: "esrs.ReportingUnitLineage" */
  delete_esrs_ReportingUnitLineage_by_pk?: Maybe<Esrs_ReportingUnitLineage_>;
  /** delete single row from the table: "esrs.ReportingUnit" */
  delete_esrs_ReportingUnit_by_pk?: Maybe<Esrs_ReportingUnit_>;
  /** delete data from the table: "esrs.Target" */
  delete_esrs_Target?: Maybe<Esrs_Target_Mutation_Response_>;
  /** delete single row from the table: "esrs.Target" */
  delete_esrs_Target_by_pk?: Maybe<Esrs_Target_>;
  /** insert a single row into the table: "auth.providers" */
  insertAuthProvider?: Maybe<AuthProviders_>;
  /** insert a single row into the table: "auth.provider_requests" */
  insertAuthProviderRequest?: Maybe<AuthProviderRequests_>;
  /** insert data into the table: "auth.provider_requests" */
  insertAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response_>;
  /** insert data into the table: "auth.providers" */
  insertAuthProviders?: Maybe<AuthProviders_Mutation_Response_>;
  /** insert a single row into the table: "auth.refresh_tokens" */
  insertAuthRefreshToken?: Maybe<AuthRefreshTokens_>;
  /** insert a single row into the table: "auth.refresh_token_types" */
  insertAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes_>;
  /** insert data into the table: "auth.refresh_token_types" */
  insertAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response_>;
  /** insert data into the table: "auth.refresh_tokens" */
  insertAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response_>;
  /** insert a single row into the table: "auth.roles" */
  insertAuthRole?: Maybe<AuthRoles_>;
  /** insert data into the table: "auth.roles" */
  insertAuthRoles?: Maybe<AuthRoles_Mutation_Response_>;
  /** insert a single row into the table: "auth.user_providers" */
  insertAuthUserProvider?: Maybe<AuthUserProviders_>;
  /** insert data into the table: "auth.user_providers" */
  insertAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response_>;
  /** insert a single row into the table: "auth.user_roles" */
  insertAuthUserRole?: Maybe<AuthUserRoles_>;
  /** insert data into the table: "auth.user_roles" */
  insertAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response_>;
  /** insert a single row into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys_>;
  /** insert data into the table: "auth.user_security_keys" */
  insertAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response_>;
  /** insert a single row into the table: "storage.buckets" */
  insertBucket?: Maybe<Buckets_>;
  /** insert data into the table: "storage.buckets" */
  insertBuckets?: Maybe<Buckets_Mutation_Response_>;
  /** insert a single row into the table: "storage.files" */
  insertFile?: Maybe<Files_>;
  /** insert data into the table: "storage.files" */
  insertFiles?: Maybe<Files_Mutation_Response_>;
  /** insert a single row into the table: "auth.users" */
  insertUser?: Maybe<Users_>;
  /** insert data into the table: "auth.users" */
  insertUsers?: Maybe<Users_Mutation_Response_>;
  /** insert a single row into the table: "storage.virus" */
  insertVirus?: Maybe<Virus_>;
  /** insert data into the table: "storage.virus" */
  insertViruses?: Maybe<Virus_Mutation_Response_>;
  /** insert data into the table: "AIConfig" */
  insert_AIConfig?: Maybe<AiConfig_Mutation_Response_>;
  /** insert a single row into the table: "AIConfig" */
  insert_AIConfig_one?: Maybe<AiConfig_>;
  /** insert data into the table: "esrs.ActionQuestion" */
  insert_ActionQuestion?: Maybe<ActionQuestion_Mutation_Response_>;
  /** insert data into the table: "esrs.ActionQuestionGroup" */
  insert_ActionQuestionGroup?: Maybe<ActionQuestionGroup_Mutation_Response_>;
  /** insert a single row into the table: "esrs.ActionQuestionGroup" */
  insert_ActionQuestionGroup_one?: Maybe<ActionQuestionGroup_>;
  /** insert a single row into the table: "esrs.ActionQuestion" */
  insert_ActionQuestion_one?: Maybe<ActionQuestion_>;
  /** insert data into the table: "Activity" */
  insert_Activity?: Maybe<Activity_Mutation_Response_>;
  /** insert data into the table: "ActivityNaceCode" */
  insert_ActivityNaceCode?: Maybe<ActivityNaceCode_Mutation_Response_>;
  /** insert a single row into the table: "ActivityNaceCode" */
  insert_ActivityNaceCode_one?: Maybe<ActivityNaceCode_>;
  /** insert data into the table: "ActivityQuestionSet" */
  insert_ActivityQuestionSet?: Maybe<ActivityQuestionSet_Mutation_Response_>;
  /** insert a single row into the table: "ActivityQuestionSet" */
  insert_ActivityQuestionSet_one?: Maybe<ActivityQuestionSet_>;
  /** insert data into the table: "ActivityReport" */
  insert_ActivityReport?: Maybe<ActivityReport_Mutation_Response_>;
  /** insert a single row into the table: "ActivityReport" */
  insert_ActivityReport_one?: Maybe<ActivityReport_>;
  /** insert data into the table: "ActivityVersion" */
  insert_ActivityVersion?: Maybe<ActivityVersion_Mutation_Response_>;
  /** insert a single row into the table: "ActivityVersion" */
  insert_ActivityVersion_one?: Maybe<ActivityVersion_>;
  /** insert a single row into the table: "Activity" */
  insert_Activity_one?: Maybe<Activity_>;
  /** insert data into the table: "esrs.AdditionalType" */
  insert_AdditionalType?: Maybe<AdditionalType_Mutation_Response_>;
  /** insert a single row into the table: "esrs.AdditionalType" */
  insert_AdditionalType_one?: Maybe<AdditionalType_>;
  /** insert data into the table: "Answer" */
  insert_Answer?: Maybe<Answer_Mutation_Response_>;
  /** insert a single row into the table: "Answer" */
  insert_Answer_one?: Maybe<Answer_>;
  /** insert data into the table: "AppConfig" */
  insert_AppConfig?: Maybe<AppConfig_Mutation_Response_>;
  /** insert a single row into the table: "AppConfig" */
  insert_AppConfig_one?: Maybe<AppConfig_>;
  /** insert data into the table: "Article" */
  insert_Article?: Maybe<Article_Mutation_Response_>;
  /** insert a single row into the table: "Article" */
  insert_Article_one?: Maybe<Article_>;
  /** insert data into the table: "Attachment" */
  insert_Attachment?: Maybe<Attachment_Mutation_Response_>;
  /** insert data into the table: "AttachmentBox" */
  insert_AttachmentBox?: Maybe<AttachmentBox_Mutation_Response_>;
  /** insert a single row into the table: "AttachmentBox" */
  insert_AttachmentBox_one?: Maybe<AttachmentBox_>;
  /** insert a single row into the table: "Attachment" */
  insert_Attachment_one?: Maybe<Attachment_>;
  /** insert data into the table: "AuditLogEntry" */
  insert_AuditLogEntry?: Maybe<AuditLogEntry_Mutation_Response_>;
  /** insert a single row into the table: "AuditLogEntry" */
  insert_AuditLogEntry_one?: Maybe<AuditLogEntry_>;
  /** insert data into the table: "BusinessUnit" */
  insert_BusinessUnit?: Maybe<BusinessUnit_Mutation_Response_>;
  /** insert data into the table: "BusinessUnitAssessment" */
  insert_BusinessUnitAssessment?: Maybe<BusinessUnitAssessment_Mutation_Response_>;
  /** insert a single row into the table: "BusinessUnitAssessment" */
  insert_BusinessUnitAssessment_one?: Maybe<BusinessUnitAssessment_>;
  /** insert a single row into the table: "BusinessUnit" */
  insert_BusinessUnit_one?: Maybe<BusinessUnit_>;
  /** insert data into the table: "CachedResult" */
  insert_CachedResult?: Maybe<CachedResult_Mutation_Response_>;
  /** insert a single row into the table: "CachedResult" */
  insert_CachedResult_one?: Maybe<CachedResult_>;
  /** insert data into the table: "esrs.ChoiceSet" */
  insert_ChoiceSet?: Maybe<ChoiceSet_Mutation_Response_>;
  /** insert a single row into the table: "esrs.ChoiceSet" */
  insert_ChoiceSet_one?: Maybe<ChoiceSet_>;
  /** insert data into the table: "Comment" */
  insert_Comment?: Maybe<Comment_Mutation_Response_>;
  /** insert a single row into the table: "Comment" */
  insert_Comment_one?: Maybe<Comment_>;
  /** insert data into the table: "Company" */
  insert_Company?: Maybe<Company_Mutation_Response_>;
  /** insert data into the table: "CompanyAssessment" */
  insert_CompanyAssessment?: Maybe<CompanyAssessment_Mutation_Response_>;
  /** insert data into the table: "CompanyAssessmentAggregate" */
  insert_CompanyAssessmentAggregate?: Maybe<CompanyAssessmentAggregate_Mutation_Response_>;
  /** insert a single row into the table: "CompanyAssessmentAggregate" */
  insert_CompanyAssessmentAggregate_one?: Maybe<CompanyAssessmentAggregate_>;
  /** insert a single row into the table: "CompanyAssessment" */
  insert_CompanyAssessment_one?: Maybe<CompanyAssessment_>;
  /** insert data into the table: "CompanyIdentityProvider" */
  insert_CompanyIdentityProvider?: Maybe<CompanyIdentityProvider_Mutation_Response_>;
  /** insert a single row into the table: "CompanyIdentityProvider" */
  insert_CompanyIdentityProvider_one?: Maybe<CompanyIdentityProvider_>;
  /** insert data into the table: "CompanyInvitation" */
  insert_CompanyInvitation?: Maybe<CompanyInvitation_Mutation_Response_>;
  /** insert a single row into the table: "CompanyInvitation" */
  insert_CompanyInvitation_one?: Maybe<CompanyInvitation_>;
  /** insert data into the table: "CompanyUser" */
  insert_CompanyUser?: Maybe<CompanyUser_Mutation_Response_>;
  /** insert a single row into the table: "CompanyUser" */
  insert_CompanyUser_one?: Maybe<CompanyUser_>;
  /** insert a single row into the table: "Company" */
  insert_Company_one?: Maybe<Company_>;
  /** insert data into the table: "CompassPAT" */
  insert_CompassPAT?: Maybe<CompassPat_Mutation_Response_>;
  /** insert a single row into the table: "CompassPAT" */
  insert_CompassPAT_one?: Maybe<CompassPat_>;
  /** insert data into the table: "esrs.DRToMFDisclosureRequirement" */
  insert_DRToMFDisclosureRequirement?: Maybe<DrToMfDisclosureRequirement_Mutation_Response_>;
  /** insert a single row into the table: "esrs.DRToMFDisclosureRequirement" */
  insert_DRToMFDisclosureRequirement_one?: Maybe<DrToMfDisclosureRequirement_>;
  /** insert data into the table: "esrs.DisclosureRequirement" */
  insert_DisclosureRequirement?: Maybe<DisclosureRequirement_Mutation_Response_>;
  /** insert data into the table: "esrs.DisclosureRequirementAdditionalType" */
  insert_DisclosureRequirementAdditionalType?: Maybe<DisclosureRequirementAdditionalType_Mutation_Response_>;
  /** insert a single row into the table: "esrs.DisclosureRequirementAdditionalType" */
  insert_DisclosureRequirementAdditionalType_one?: Maybe<DisclosureRequirementAdditionalType_>;
  /** insert data into the table: "esrs.DisclosureRequirementGroup" */
  insert_DisclosureRequirementGroup?: Maybe<DisclosureRequirementGroup_Mutation_Response_>;
  /** insert a single row into the table: "esrs.DisclosureRequirementGroup" */
  insert_DisclosureRequirementGroup_one?: Maybe<DisclosureRequirementGroup_>;
  /** insert data into the table: "esrs.DisclosureRequirementOwner" */
  insert_DisclosureRequirementOwner?: Maybe<DisclosureRequirementOwner_Mutation_Response_>;
  /** insert a single row into the table: "esrs.DisclosureRequirementOwner" */
  insert_DisclosureRequirementOwner_one?: Maybe<DisclosureRequirementOwner_>;
  /** insert data into the table: "esrs.DisclosureRequirementStatus" */
  insert_DisclosureRequirementStatus?: Maybe<DisclosureRequirementStatus_Mutation_Response_>;
  /** insert a single row into the table: "esrs.DisclosureRequirementStatus" */
  insert_DisclosureRequirementStatus_one?: Maybe<DisclosureRequirementStatus_>;
  /** insert a single row into the table: "esrs.DisclosureRequirement" */
  insert_DisclosureRequirement_one?: Maybe<DisclosureRequirement_>;
  /** insert data into the table: "DocumentInsight" */
  insert_DocumentInsight?: Maybe<DocumentInsight_Mutation_Response_>;
  /** insert a single row into the table: "DocumentInsight" */
  insert_DocumentInsight_one?: Maybe<DocumentInsight_>;
  /** insert data into the table: "DocumentationFile" */
  insert_DocumentationFile?: Maybe<DocumentationFile_Mutation_Response_>;
  /** insert a single row into the table: "DocumentationFile" */
  insert_DocumentationFile_one?: Maybe<DocumentationFile_>;
  /** insert data into the table: "esrs.EsrsAssessment" */
  insert_EsrsAssessment?: Maybe<EsrsAssessment_Mutation_Response_>;
  /** insert a single row into the table: "esrs.EsrsAssessment" */
  insert_EsrsAssessment_one?: Maybe<EsrsAssessment_>;
  /** insert data into the table: "esrs.EsrsCategory" */
  insert_EsrsCategory?: Maybe<EsrsCategory_Mutation_Response_>;
  /** insert a single row into the table: "esrs.EsrsCategory" */
  insert_EsrsCategory_one?: Maybe<EsrsCategory_>;
  /** insert data into the table: "esrs.EsrsChoice" */
  insert_EsrsChoice?: Maybe<EsrsChoice_Mutation_Response_>;
  /** insert a single row into the table: "esrs.EsrsChoice" */
  insert_EsrsChoice_one?: Maybe<EsrsChoice_>;
  /** insert data into the table: "esrs.EsrsMetric" */
  insert_EsrsMetric?: Maybe<EsrsMetric_Mutation_Response_>;
  /** insert data into the table: "esrs.EsrsMetricAdditionalType" */
  insert_EsrsMetricAdditionalType?: Maybe<EsrsMetricAdditionalType_Mutation_Response_>;
  /** insert a single row into the table: "esrs.EsrsMetricAdditionalType" */
  insert_EsrsMetricAdditionalType_one?: Maybe<EsrsMetricAdditionalType_>;
  /** insert a single row into the table: "esrs.EsrsMetric" */
  insert_EsrsMetric_one?: Maybe<EsrsMetric_>;
  /** insert data into the table: "esrs.EsrsStandard" */
  insert_EsrsStandard?: Maybe<EsrsStandard_Mutation_Response_>;
  /** insert data into the table: "esrs.EsrsStandardAdditionalType" */
  insert_EsrsStandardAdditionalType?: Maybe<EsrsStandardAdditionalType_Mutation_Response_>;
  /** insert a single row into the table: "esrs.EsrsStandardAdditionalType" */
  insert_EsrsStandardAdditionalType_one?: Maybe<EsrsStandardAdditionalType_>;
  /** insert a single row into the table: "esrs.EsrsStandard" */
  insert_EsrsStandard_one?: Maybe<EsrsStandard_>;
  /** insert data into the table: "EstimateCompany_deprecated" */
  insert_EstimateCompany_deprecated?: Maybe<EstimateCompany_Deprecated_Mutation_Response_>;
  /** insert a single row into the table: "EstimateCompany_deprecated" */
  insert_EstimateCompany_deprecated_one?: Maybe<EstimateCompany_Deprecated_>;
  /** insert data into the table: "ExtractionJob" */
  insert_ExtractionJob?: Maybe<ExtractionJob_Mutation_Response_>;
  /** insert a single row into the table: "ExtractionJob" */
  insert_ExtractionJob_one?: Maybe<ExtractionJob_>;
  /** insert data into the table: "Financials" */
  insert_Financials?: Maybe<Financials_Mutation_Response_>;
  /** insert a single row into the table: "Financials" */
  insert_Financials_one?: Maybe<Financials_>;
  /** insert data into the table: "esrs.Framework" */
  insert_Framework?: Maybe<Framework_Mutation_Response_>;
  /** insert a single row into the table: "esrs.Framework" */
  insert_Framework_one?: Maybe<Framework_>;
  /** insert data into the table: "GroupAssessment" */
  insert_GroupAssessment?: Maybe<GroupAssessment_Mutation_Response_>;
  /** insert a single row into the table: "GroupAssessment" */
  insert_GroupAssessment_one?: Maybe<GroupAssessment_>;
  /** insert data into the table: "IdentityProvider" */
  insert_IdentityProvider?: Maybe<IdentityProvider_Mutation_Response_>;
  /** insert a single row into the table: "IdentityProvider" */
  insert_IdentityProvider_one?: Maybe<IdentityProvider_>;
  /** insert data into the table: "IndicatorToInvestorMetric" */
  insert_IndicatorToInvestorMetric?: Maybe<IndicatorToInvestorMetric_Mutation_Response_>;
  /** insert a single row into the table: "IndicatorToInvestorMetric" */
  insert_IndicatorToInvestorMetric_one?: Maybe<IndicatorToInvestorMetric_>;
  /** insert data into the table: "InvesteeMetric" */
  insert_InvesteeMetric?: Maybe<InvesteeMetric_Mutation_Response_>;
  /** insert a single row into the table: "InvesteeMetric" */
  insert_InvesteeMetric_one?: Maybe<InvesteeMetric_>;
  /** insert data into the table: "InvestmentCategory" */
  insert_InvestmentCategory?: Maybe<InvestmentCategory_Mutation_Response_>;
  /** insert a single row into the table: "InvestmentCategory" */
  insert_InvestmentCategory_one?: Maybe<InvestmentCategory_>;
  /** insert data into the table: "InvestorMetric" */
  insert_InvestorMetric?: Maybe<InvestorMetric_Mutation_Response_>;
  /** insert a single row into the table: "InvestorMetric" */
  insert_InvestorMetric_one?: Maybe<InvestorMetric_>;
  /** insert data into the table: "InvestorToInvesteeMetric" */
  insert_InvestorToInvesteeMetric?: Maybe<InvestorToInvesteeMetric_Mutation_Response_>;
  /** insert a single row into the table: "InvestorToInvesteeMetric" */
  insert_InvestorToInvesteeMetric_one?: Maybe<InvestorToInvesteeMetric_>;
  /** insert data into the table: "esrs.MFCategory" */
  insert_MFCategory?: Maybe<MfCategory_Mutation_Response_>;
  /** insert a single row into the table: "esrs.MFCategory" */
  insert_MFCategory_one?: Maybe<MfCategory_>;
  /** insert data into the table: "esrs.MFDisclosureRequirement" */
  insert_MFDisclosureRequirement?: Maybe<MfDisclosureRequirement_Mutation_Response_>;
  /** insert data into the table: "esrs.MFDisclosureRequirementGroup" */
  insert_MFDisclosureRequirementGroup?: Maybe<MfDisclosureRequirementGroup_Mutation_Response_>;
  /** insert a single row into the table: "esrs.MFDisclosureRequirementGroup" */
  insert_MFDisclosureRequirementGroup_one?: Maybe<MfDisclosureRequirementGroup_>;
  /** insert data into the table: "esrs.MFDisclosureRequirementItem" */
  insert_MFDisclosureRequirementItem?: Maybe<MfDisclosureRequirementItem_Mutation_Response_>;
  /** insert a single row into the table: "esrs.MFDisclosureRequirementItem" */
  insert_MFDisclosureRequirementItem_one?: Maybe<MfDisclosureRequirementItem_>;
  /** insert a single row into the table: "esrs.MFDisclosureRequirement" */
  insert_MFDisclosureRequirement_one?: Maybe<MfDisclosureRequirement_>;
  /** insert data into the table: "esrs.MFStandard" */
  insert_MFStandard?: Maybe<MfStandard_Mutation_Response_>;
  /** insert data into the table: "esrs.MFStandardItem" */
  insert_MFStandardItem?: Maybe<MfStandardItem_Mutation_Response_>;
  /** insert a single row into the table: "esrs.MFStandardItem" */
  insert_MFStandardItem_one?: Maybe<MfStandardItem_>;
  /** insert a single row into the table: "esrs.MFStandard" */
  insert_MFStandard_one?: Maybe<MfStandard_>;
  /** insert data into the table: "esrs.MaterialStandardOwner" */
  insert_MaterialStandardOwner?: Maybe<MaterialStandardOwner_Mutation_Response_>;
  /** insert a single row into the table: "esrs.MaterialStandardOwner" */
  insert_MaterialStandardOwner_one?: Maybe<MaterialStandardOwner_>;
  /** insert data into the table: "esrs.MetricDependency" */
  insert_MetricDependency?: Maybe<MetricDependency_Mutation_Response_>;
  /** insert a single row into the table: "esrs.MetricDependency" */
  insert_MetricDependency_one?: Maybe<MetricDependency_>;
  /** insert data into the table: "esrs.MetricTag" */
  insert_MetricTag?: Maybe<MetricTag_Mutation_Response_>;
  /** insert a single row into the table: "esrs.MetricTag" */
  insert_MetricTag_one?: Maybe<MetricTag_>;
  /** insert data into the table: "NonMaterialFinancials" */
  insert_NonMaterialFinancials?: Maybe<NonMaterialFinancials_Mutation_Response_>;
  /** insert a single row into the table: "NonMaterialFinancials" */
  insert_NonMaterialFinancials_one?: Maybe<NonMaterialFinancials_>;
  /** insert data into the table: "Note" */
  insert_Note?: Maybe<Note_Mutation_Response_>;
  /** insert data into the table: "NoteHistory" */
  insert_NoteHistory?: Maybe<NoteHistory_Mutation_Response_>;
  /** insert a single row into the table: "NoteHistory" */
  insert_NoteHistory_one?: Maybe<NoteHistory_>;
  /** insert a single row into the table: "Note" */
  insert_Note_one?: Maybe<Note_>;
  /** insert data into the table: "Objective" */
  insert_Objective?: Maybe<Objective_Mutation_Response_>;
  /** insert a single row into the table: "Objective" */
  insert_Objective_one?: Maybe<Objective_>;
  /** insert data into the table: "PaiAnswers" */
  insert_PaiAnswers?: Maybe<PaiAnswers_Mutation_Response_>;
  /** insert a single row into the table: "PaiAnswers" */
  insert_PaiAnswers_one?: Maybe<PaiAnswers_>;
  /** insert data into the table: "PaiCategory" */
  insert_PaiCategory?: Maybe<PaiCategory_Mutation_Response_>;
  /** insert a single row into the table: "PaiCategory" */
  insert_PaiCategory_one?: Maybe<PaiCategory_>;
  /** insert data into the table: "PaiCompanyReport" */
  insert_PaiCompanyReport?: Maybe<PaiCompanyReport_Mutation_Response_>;
  /** insert a single row into the table: "PaiCompanyReport" */
  insert_PaiCompanyReport_one?: Maybe<PaiCompanyReport_>;
  /** insert data into the table: "PaiMetricInsight" */
  insert_PaiMetricInsight?: Maybe<PaiMetricInsight_Mutation_Response_>;
  /** insert a single row into the table: "PaiMetricInsight" */
  insert_PaiMetricInsight_one?: Maybe<PaiMetricInsight_>;
  /** insert data into the table: "PaiPortfolioReport" */
  insert_PaiPortfolioReport?: Maybe<PaiPortfolioReport_Mutation_Response_>;
  /** insert a single row into the table: "PaiPortfolioReport" */
  insert_PaiPortfolioReport_one?: Maybe<PaiPortfolioReport_>;
  /** insert data into the table: "PaiReportIndicator" */
  insert_PaiReportIndicator?: Maybe<PaiReportIndicator_Mutation_Response_>;
  /** insert data into the table: "PaiReportIndicatorPortfolioCompany" */
  insert_PaiReportIndicatorPortfolioCompany?: Maybe<PaiReportIndicatorPortfolioCompany_Mutation_Response_>;
  /** insert a single row into the table: "PaiReportIndicatorPortfolioCompany" */
  insert_PaiReportIndicatorPortfolioCompany_one?: Maybe<PaiReportIndicatorPortfolioCompany_>;
  /** insert a single row into the table: "PaiReportIndicator" */
  insert_PaiReportIndicator_one?: Maybe<PaiReportIndicator_>;
  /** insert data into the table: "PaiTable" */
  insert_PaiTable?: Maybe<PaiTable_Mutation_Response_>;
  /** insert data into the table: "PaiTableIndicator" */
  insert_PaiTableIndicator?: Maybe<PaiTableIndicator_Mutation_Response_>;
  /** insert a single row into the table: "PaiTableIndicator" */
  insert_PaiTableIndicator_one?: Maybe<PaiTableIndicator_>;
  /** insert a single row into the table: "PaiTable" */
  insert_PaiTable_one?: Maybe<PaiTable_>;
  /** insert data into the table: "Portfolio" */
  insert_Portfolio?: Maybe<Portfolio_Mutation_Response_>;
  /** insert data into the table: "PortfolioCompany" */
  insert_PortfolioCompany?: Maybe<PortfolioCompany_Mutation_Response_>;
  /** insert a single row into the table: "PortfolioCompany" */
  insert_PortfolioCompany_one?: Maybe<PortfolioCompany_>;
  /** insert data into the table: "PortfolioNonEligibleFinancials" */
  insert_PortfolioNonEligibleFinancials?: Maybe<PortfolioNonEligibleFinancials_Mutation_Response_>;
  /** insert a single row into the table: "PortfolioNonEligibleFinancials" */
  insert_PortfolioNonEligibleFinancials_one?: Maybe<PortfolioNonEligibleFinancials_>;
  /** insert a single row into the table: "Portfolio" */
  insert_Portfolio_one?: Maybe<Portfolio_>;
  /** insert data into the table: "QuarterEnum" */
  insert_QuarterEnum?: Maybe<QuarterEnum_Mutation_Response_>;
  /** insert a single row into the table: "QuarterEnum" */
  insert_QuarterEnum_one?: Maybe<QuarterEnum_>;
  /** insert data into the table: "Question" */
  insert_Question?: Maybe<Question_Mutation_Response_>;
  /** insert data into the table: "QuestionChoice" */
  insert_QuestionChoice?: Maybe<QuestionChoice_Mutation_Response_>;
  /** insert a single row into the table: "QuestionChoice" */
  insert_QuestionChoice_one?: Maybe<QuestionChoice_>;
  /** insert data into the table: "QuestionLevel" */
  insert_QuestionLevel?: Maybe<QuestionLevel_Mutation_Response_>;
  /** insert a single row into the table: "QuestionLevel" */
  insert_QuestionLevel_one?: Maybe<QuestionLevel_>;
  /** insert data into the table: "QuestionRevision" */
  insert_QuestionRevision?: Maybe<QuestionRevision_Mutation_Response_>;
  /** insert a single row into the table: "QuestionRevision" */
  insert_QuestionRevision_one?: Maybe<QuestionRevision_>;
  /** insert data into the table: "QuestionSet" */
  insert_QuestionSet?: Maybe<QuestionSet_Mutation_Response_>;
  /** insert data into the table: "QuestionSetQuestion" */
  insert_QuestionSetQuestion?: Maybe<QuestionSetQuestion_Mutation_Response_>;
  /** insert a single row into the table: "QuestionSetQuestion" */
  insert_QuestionSetQuestion_one?: Maybe<QuestionSetQuestion_>;
  /** insert a single row into the table: "QuestionSet" */
  insert_QuestionSet_one?: Maybe<QuestionSet_>;
  /** insert data into the table: "QuestionType" */
  insert_QuestionType?: Maybe<QuestionType_Mutation_Response_>;
  /** insert a single row into the table: "QuestionType" */
  insert_QuestionType_one?: Maybe<QuestionType_>;
  /** insert a single row into the table: "Question" */
  insert_Question_one?: Maybe<Question_>;
  /** insert data into the table: "ReportingGroup" */
  insert_ReportingGroup?: Maybe<ReportingGroup_Mutation_Response_>;
  /** insert a single row into the table: "ReportingGroup" */
  insert_ReportingGroup_one?: Maybe<ReportingGroup_>;
  /** insert data into the table: "Sector" */
  insert_Sector?: Maybe<Sector_Mutation_Response_>;
  /** insert a single row into the table: "Sector" */
  insert_Sector_one?: Maybe<Sector_>;
  /** insert data into the table: "SharedSpace" */
  insert_SharedSpace?: Maybe<SharedSpace_Mutation_Response_>;
  /** insert a single row into the table: "SharedSpace" */
  insert_SharedSpace_one?: Maybe<SharedSpace_>;
  /** insert data into the table: "Space" */
  insert_Space?: Maybe<Space_Mutation_Response_>;
  /** insert a single row into the table: "Space" */
  insert_Space_one?: Maybe<Space_>;
  /** insert data into the table: "Subsidiary" */
  insert_Subsidiary?: Maybe<Subsidiary_Mutation_Response_>;
  /** insert a single row into the table: "Subsidiary" */
  insert_Subsidiary_one?: Maybe<Subsidiary_>;
  /** insert data into the table: "Tag" */
  insert_Tag?: Maybe<Tag_Mutation_Response_>;
  /** insert data into the table: "TagGroup" */
  insert_TagGroup?: Maybe<TagGroup_Mutation_Response_>;
  /** insert a single row into the table: "TagGroup" */
  insert_TagGroup_one?: Maybe<TagGroup_>;
  /** insert data into the table: "esrs.TagType" */
  insert_TagType?: Maybe<TagType_Mutation_Response_>;
  /** insert a single row into the table: "esrs.TagType" */
  insert_TagType_one?: Maybe<TagType_>;
  /** insert data into the table: "esrs.TagValue" */
  insert_TagValue?: Maybe<TagValue_Mutation_Response_>;
  /** insert a single row into the table: "esrs.TagValue" */
  insert_TagValue_one?: Maybe<TagValue_>;
  /** insert data into the table: "Tag_articles" */
  insert_Tag_articles?: Maybe<Tag_Articles_Mutation_Response_>;
  /** insert a single row into the table: "Tag_articles" */
  insert_Tag_articles_one?: Maybe<Tag_Articles_>;
  /** insert a single row into the table: "Tag" */
  insert_Tag_one?: Maybe<Tag_>;
  /** insert data into the table: "esrs.TargetQuestion" */
  insert_TargetQuestion?: Maybe<TargetQuestion_Mutation_Response_>;
  /** insert data into the table: "esrs.TargetQuestionGroup" */
  insert_TargetQuestionGroup?: Maybe<TargetQuestionGroup_Mutation_Response_>;
  /** insert a single row into the table: "esrs.TargetQuestionGroup" */
  insert_TargetQuestionGroup_one?: Maybe<TargetQuestionGroup_>;
  /** insert a single row into the table: "esrs.TargetQuestion" */
  insert_TargetQuestion_one?: Maybe<TargetQuestion_>;
  /** insert data into the table: "Task" */
  insert_Task?: Maybe<Task_Mutation_Response_>;
  /** insert data into the table: "TaskStatusEnum" */
  insert_TaskStatusEnum?: Maybe<TaskStatusEnum_Mutation_Response_>;
  /** insert a single row into the table: "TaskStatusEnum" */
  insert_TaskStatusEnum_one?: Maybe<TaskStatusEnum_>;
  /** insert a single row into the table: "Task" */
  insert_Task_one?: Maybe<Task_>;
  /** insert data into the table: "TaxonomyPortfolioReport" */
  insert_TaxonomyPortfolioReport?: Maybe<TaxonomyPortfolioReport_Mutation_Response_>;
  /** insert a single row into the table: "TaxonomyPortfolioReport" */
  insert_TaxonomyPortfolioReport_one?: Maybe<TaxonomyPortfolioReport_>;
  /** insert data into the table: "Thread" */
  insert_Thread?: Maybe<Thread_Mutation_Response_>;
  /** insert data into the table: "ThreadSubscriber" */
  insert_ThreadSubscriber?: Maybe<ThreadSubscriber_Mutation_Response_>;
  /** insert a single row into the table: "ThreadSubscriber" */
  insert_ThreadSubscriber_one?: Maybe<ThreadSubscriber_>;
  /** insert a single row into the table: "Thread" */
  insert_Thread_one?: Maybe<Thread_>;
  /** insert data into the table: "TotalComparisonFinancials" */
  insert_TotalComparisonFinancials?: Maybe<TotalComparisonFinancials_Mutation_Response_>;
  /** insert a single row into the table: "TotalComparisonFinancials" */
  insert_TotalComparisonFinancials_one?: Maybe<TotalComparisonFinancials_>;
  /** insert data into the table: "TriggerTypes" */
  insert_TriggerTypes?: Maybe<TriggerTypes_Mutation_Response_>;
  /** insert a single row into the table: "TriggerTypes" */
  insert_TriggerTypes_one?: Maybe<TriggerTypes_>;
  /** insert data into the table: "UserNotification" */
  insert_UserNotification?: Maybe<UserNotification_Mutation_Response_>;
  /** insert a single row into the table: "UserNotification" */
  insert_UserNotification_one?: Maybe<UserNotification_>;
  /** insert data into the table: "UserRole" */
  insert_UserRole?: Maybe<UserRole_Mutation_Response_>;
  /** insert a single row into the table: "UserRole" */
  insert_UserRole_one?: Maybe<UserRole_>;
  /** insert data into the table: "UserSessionMetadata" */
  insert_UserSessionMetadata?: Maybe<UserSessionMetadata_Mutation_Response_>;
  /** insert a single row into the table: "UserSessionMetadata" */
  insert_UserSessionMetadata_one?: Maybe<UserSessionMetadata_>;
  /** insert data into the table: "WebsocketTest" */
  insert_WebsocketTest?: Maybe<WebsocketTest_Mutation_Response_>;
  /** insert a single row into the table: "WebsocketTest" */
  insert_WebsocketTest_one?: Maybe<WebsocketTest_>;
  /** insert data into the table: "esrs.ActionReportingUnit" */
  insert_esrs_ActionReportingUnit?: Maybe<Esrs_ActionReportingUnit_Mutation_Response_>;
  /** insert a single row into the table: "esrs.ActionReportingUnit" */
  insert_esrs_ActionReportingUnit_one?: Maybe<Esrs_ActionReportingUnit_>;
  /** insert data into the table: "esrs.ActionSubsidiary" */
  insert_esrs_ActionSubsidiary?: Maybe<Esrs_ActionSubsidiary_Mutation_Response_>;
  /** insert a single row into the table: "esrs.ActionSubsidiary" */
  insert_esrs_ActionSubsidiary_one?: Maybe<Esrs_ActionSubsidiary_>;
  /** insert data into the table: "esrs.ActionTarget" */
  insert_esrs_ActionTarget?: Maybe<Esrs_ActionTarget_Mutation_Response_>;
  /** insert a single row into the table: "esrs.ActionTarget" */
  insert_esrs_ActionTarget_one?: Maybe<Esrs_ActionTarget_>;
  /** insert data into the table: "esrs.Actions" */
  insert_esrs_Actions?: Maybe<Esrs_Actions_Mutation_Response_>;
  /** insert a single row into the table: "esrs.Actions" */
  insert_esrs_Actions_one?: Maybe<Esrs_Actions_>;
  /** insert data into the table: "esrs.Answer" */
  insert_esrs_Answer?: Maybe<Esrs_Answer_Mutation_Response_>;
  /** insert a single row into the table: "esrs.Answer" */
  insert_esrs_Answer_one?: Maybe<Esrs_Answer_>;
  /** insert data into the table: "esrs.AssessmentCurrencyConversion" */
  insert_esrs_AssessmentCurrencyConversion?: Maybe<Esrs_AssessmentCurrencyConversion_Mutation_Response_>;
  /** insert a single row into the table: "esrs.AssessmentCurrencyConversion" */
  insert_esrs_AssessmentCurrencyConversion_one?: Maybe<Esrs_AssessmentCurrencyConversion_>;
  /** insert data into the table: "esrs.Baseline" */
  insert_esrs_Baseline?: Maybe<Esrs_Baseline_Mutation_Response_>;
  /** insert a single row into the table: "esrs.Baseline" */
  insert_esrs_Baseline_one?: Maybe<Esrs_Baseline_>;
  /** insert data into the table: "esrs.CompanyIntegration" */
  insert_esrs_CompanyIntegration?: Maybe<Esrs_CompanyIntegration_Mutation_Response_>;
  /** insert a single row into the table: "esrs.CompanyIntegration" */
  insert_esrs_CompanyIntegration_one?: Maybe<Esrs_CompanyIntegration_>;
  /** insert data into the table: "esrs.Datapoint" */
  insert_esrs_Datapoint?: Maybe<Esrs_Datapoint_Mutation_Response_>;
  /** insert data into the table: "esrs.DatapointChoice" */
  insert_esrs_DatapointChoice?: Maybe<Esrs_DatapointChoice_Mutation_Response_>;
  /** insert a single row into the table: "esrs.DatapointChoice" */
  insert_esrs_DatapointChoice_one?: Maybe<Esrs_DatapointChoice_>;
  /** insert data into the table: "esrs.DatapointMdrm" */
  insert_esrs_DatapointMdrm?: Maybe<Esrs_DatapointMdrm_Mutation_Response_>;
  /** insert a single row into the table: "esrs.DatapointMdrm" */
  insert_esrs_DatapointMdrm_one?: Maybe<Esrs_DatapointMdrm_>;
  /** insert data into the table: "esrs.DatapointTag" */
  insert_esrs_DatapointTag?: Maybe<Esrs_DatapointTag_Mutation_Response_>;
  /** insert a single row into the table: "esrs.DatapointTag" */
  insert_esrs_DatapointTag_one?: Maybe<Esrs_DatapointTag_>;
  /** insert a single row into the table: "esrs.Datapoint" */
  insert_esrs_Datapoint_one?: Maybe<Esrs_Datapoint_>;
  /** insert data into the table: "esrs.Deprecated_ActionBusinessUnit" */
  insert_esrs_Deprecated_ActionBusinessUnit?: Maybe<Esrs_Deprecated_ActionBusinessUnit_Mutation_Response_>;
  /** insert a single row into the table: "esrs.Deprecated_ActionBusinessUnit" */
  insert_esrs_Deprecated_ActionBusinessUnit_one?: Maybe<Esrs_Deprecated_ActionBusinessUnit_>;
  /** insert data into the table: "esrs.Deprecated_BusinessUnitEsrsAssessment" */
  insert_esrs_Deprecated_BusinessUnitEsrsAssessment?: Maybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Mutation_Response_>;
  /** insert a single row into the table: "esrs.Deprecated_BusinessUnitEsrsAssessment" */
  insert_esrs_Deprecated_BusinessUnitEsrsAssessment_one?: Maybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_>;
  /** insert data into the table: "esrs.Deprecated_CompanyMaterialityAssessment" */
  insert_esrs_Deprecated_CompanyMaterialityAssessment?: Maybe<Esrs_Deprecated_CompanyMaterialityAssessment_Mutation_Response_>;
  /** insert a single row into the table: "esrs.Deprecated_CompanyMaterialityAssessment" */
  insert_esrs_Deprecated_CompanyMaterialityAssessment_one?: Maybe<Esrs_Deprecated_CompanyMaterialityAssessment_>;
  /** insert data into the table: "esrs.Deprecated_EsrsMDRM" */
  insert_esrs_Deprecated_EsrsMDRM?: Maybe<Esrs_Deprecated_EsrsMdrm_Mutation_Response_>;
  /** insert a single row into the table: "esrs.Deprecated_EsrsMDRM" */
  insert_esrs_Deprecated_EsrsMDRM_one?: Maybe<Esrs_Deprecated_EsrsMdrm_>;
  /** insert data into the table: "esrs.Deprecated_MaterialDisclosureRequirement" */
  insert_esrs_Deprecated_MaterialDisclosureRequirement?: Maybe<Esrs_Deprecated_MaterialDisclosureRequirement_Mutation_Response_>;
  /** insert a single row into the table: "esrs.Deprecated_MaterialDisclosureRequirement" */
  insert_esrs_Deprecated_MaterialDisclosureRequirement_one?: Maybe<Esrs_Deprecated_MaterialDisclosureRequirement_>;
  /** insert data into the table: "esrs.Deprecated_MetricAnswer" */
  insert_esrs_Deprecated_MetricAnswer?: Maybe<Esrs_Deprecated_MetricAnswer_Mutation_Response_>;
  /** insert a single row into the table: "esrs.Deprecated_MetricAnswer" */
  insert_esrs_Deprecated_MetricAnswer_one?: Maybe<Esrs_Deprecated_MetricAnswer_>;
  /** insert data into the table: "esrs.DisclosureRequirementAttachment" */
  insert_esrs_DisclosureRequirementAttachment?: Maybe<Esrs_DisclosureRequirementAttachment_Mutation_Response_>;
  /** insert a single row into the table: "esrs.DisclosureRequirementAttachment" */
  insert_esrs_DisclosureRequirementAttachment_one?: Maybe<Esrs_DisclosureRequirementAttachment_>;
  /** insert data into the table: "esrs.EsrsAssessmentCompanyIntegration" */
  insert_esrs_EsrsAssessmentCompanyIntegration?: Maybe<Esrs_EsrsAssessmentCompanyIntegration_Mutation_Response_>;
  /** insert data into the table: "esrs.EsrsAssessmentCompanyIntegrationRU" */
  insert_esrs_EsrsAssessmentCompanyIntegrationRU?: Maybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Mutation_Response_>;
  /** insert a single row into the table: "esrs.EsrsAssessmentCompanyIntegrationRU" */
  insert_esrs_EsrsAssessmentCompanyIntegrationRU_one?: Maybe<Esrs_EsrsAssessmentCompanyIntegrationRu_>;
  /** insert a single row into the table: "esrs.EsrsAssessmentCompanyIntegration" */
  insert_esrs_EsrsAssessmentCompanyIntegration_one?: Maybe<Esrs_EsrsAssessmentCompanyIntegration_>;
  /** insert data into the table: "esrs.MaterialMetric" */
  insert_esrs_MaterialMetric?: Maybe<Esrs_MaterialMetric_Mutation_Response_>;
  /** insert data into the table: "esrs.MaterialMetricTag" */
  insert_esrs_MaterialMetricTag?: Maybe<Esrs_MaterialMetricTag_Mutation_Response_>;
  /** insert a single row into the table: "esrs.MaterialMetricTag" */
  insert_esrs_MaterialMetricTag_one?: Maybe<Esrs_MaterialMetricTag_>;
  /** insert a single row into the table: "esrs.MaterialMetric" */
  insert_esrs_MaterialMetric_one?: Maybe<Esrs_MaterialMetric_>;
  /** insert data into the table: "esrs.MaterialStandard" */
  insert_esrs_MaterialStandard?: Maybe<Esrs_MaterialStandard_Mutation_Response_>;
  /** insert a single row into the table: "esrs.MaterialStandard" */
  insert_esrs_MaterialStandard_one?: Maybe<Esrs_MaterialStandard_>;
  /** insert data into the table: "esrs.MaterialTagValue" */
  insert_esrs_MaterialTagValue?: Maybe<Esrs_MaterialTagValue_Mutation_Response_>;
  /** insert a single row into the table: "esrs.MaterialTagValue" */
  insert_esrs_MaterialTagValue_one?: Maybe<Esrs_MaterialTagValue_>;
  /** insert data into the table: "esrs.Milestone" */
  insert_esrs_Milestone?: Maybe<Esrs_Milestone_Mutation_Response_>;
  /** insert data into the table: "esrs.MilestoneResult" */
  insert_esrs_MilestoneResult?: Maybe<Esrs_MilestoneResult_Mutation_Response_>;
  /** insert a single row into the table: "esrs.MilestoneResult" */
  insert_esrs_MilestoneResult_one?: Maybe<Esrs_MilestoneResult_>;
  /** insert a single row into the table: "esrs.Milestone" */
  insert_esrs_Milestone_one?: Maybe<Esrs_Milestone_>;
  /** insert data into the table: "esrs.Policy" */
  insert_esrs_Policy?: Maybe<Esrs_Policy_Mutation_Response_>;
  /** insert a single row into the table: "esrs.Policy" */
  insert_esrs_Policy_one?: Maybe<Esrs_Policy_>;
  /** insert data into the table: "esrs.ReportingUnit" */
  insert_esrs_ReportingUnit?: Maybe<Esrs_ReportingUnit_Mutation_Response_>;
  /** insert data into the table: "esrs.ReportingUnitLineage" */
  insert_esrs_ReportingUnitLineage?: Maybe<Esrs_ReportingUnitLineage_Mutation_Response_>;
  /** insert a single row into the table: "esrs.ReportingUnitLineage" */
  insert_esrs_ReportingUnitLineage_one?: Maybe<Esrs_ReportingUnitLineage_>;
  /** insert a single row into the table: "esrs.ReportingUnit" */
  insert_esrs_ReportingUnit_one?: Maybe<Esrs_ReportingUnit_>;
  /** insert data into the table: "esrs.Target" */
  insert_esrs_Target?: Maybe<Esrs_Target_Mutation_Response_>;
  /** insert a single row into the table: "esrs.Target" */
  insert_esrs_Target_one?: Maybe<Esrs_Target_>;
  nudgeGroupCompanies?: Maybe<NudgeGroupCompaniesOutput_>;
  nudgePortfolioCompanies?: Maybe<NudgePortfolioCompaniesOutput_>;
  requestQuote?: Maybe<RequestQuoteOutput_>;
  /** updateActivityFinancials */
  updateActivityFinancials?: Maybe<UpdateFinancialsOutput_>;
  /** update single row of the table: "auth.providers" */
  updateAuthProvider?: Maybe<AuthProviders_>;
  /** update single row of the table: "auth.provider_requests" */
  updateAuthProviderRequest?: Maybe<AuthProviderRequests_>;
  /** update data of the table: "auth.provider_requests" */
  updateAuthProviderRequests?: Maybe<AuthProviderRequests_Mutation_Response_>;
  /** update data of the table: "auth.providers" */
  updateAuthProviders?: Maybe<AuthProviders_Mutation_Response_>;
  /** update single row of the table: "auth.refresh_tokens" */
  updateAuthRefreshToken?: Maybe<AuthRefreshTokens_>;
  /** update single row of the table: "auth.refresh_token_types" */
  updateAuthRefreshTokenType?: Maybe<AuthRefreshTokenTypes_>;
  /** update data of the table: "auth.refresh_token_types" */
  updateAuthRefreshTokenTypes?: Maybe<AuthRefreshTokenTypes_Mutation_Response_>;
  /** update data of the table: "auth.refresh_tokens" */
  updateAuthRefreshTokens?: Maybe<AuthRefreshTokens_Mutation_Response_>;
  /** update single row of the table: "auth.roles" */
  updateAuthRole?: Maybe<AuthRoles_>;
  /** update data of the table: "auth.roles" */
  updateAuthRoles?: Maybe<AuthRoles_Mutation_Response_>;
  /** update single row of the table: "auth.user_providers" */
  updateAuthUserProvider?: Maybe<AuthUserProviders_>;
  /** update data of the table: "auth.user_providers" */
  updateAuthUserProviders?: Maybe<AuthUserProviders_Mutation_Response_>;
  /** update single row of the table: "auth.user_roles" */
  updateAuthUserRole?: Maybe<AuthUserRoles_>;
  /** update data of the table: "auth.user_roles" */
  updateAuthUserRoles?: Maybe<AuthUserRoles_Mutation_Response_>;
  /** update single row of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKey?: Maybe<AuthUserSecurityKeys_>;
  /** update data of the table: "auth.user_security_keys" */
  updateAuthUserSecurityKeys?: Maybe<AuthUserSecurityKeys_Mutation_Response_>;
  /** update single row of the table: "storage.buckets" */
  updateBucket?: Maybe<Buckets_>;
  /** update data of the table: "storage.buckets" */
  updateBuckets?: Maybe<Buckets_Mutation_Response_>;
  /** update single row of the table: "storage.files" */
  updateFile?: Maybe<Files_>;
  /** update data of the table: "storage.files" */
  updateFiles?: Maybe<Files_Mutation_Response_>;
  /** update single row of the table: "auth.users" */
  updateUser?: Maybe<Users_>;
  /** update data of the table: "auth.users" */
  updateUsers?: Maybe<Users_Mutation_Response_>;
  /** update single row of the table: "storage.virus" */
  updateVirus?: Maybe<Virus_>;
  /** update data of the table: "storage.virus" */
  updateViruses?: Maybe<Virus_Mutation_Response_>;
  /** update data of the table: "AIConfig" */
  update_AIConfig?: Maybe<AiConfig_Mutation_Response_>;
  /** update single row of the table: "AIConfig" */
  update_AIConfig_by_pk?: Maybe<AiConfig_>;
  /** update multiples rows of table: "AIConfig" */
  update_AIConfig_many?: Maybe<Array<Maybe<AiConfig_Mutation_Response_>>>;
  /** update data of the table: "esrs.ActionQuestion" */
  update_ActionQuestion?: Maybe<ActionQuestion_Mutation_Response_>;
  /** update data of the table: "esrs.ActionQuestionGroup" */
  update_ActionQuestionGroup?: Maybe<ActionQuestionGroup_Mutation_Response_>;
  /** update single row of the table: "esrs.ActionQuestionGroup" */
  update_ActionQuestionGroup_by_pk?: Maybe<ActionQuestionGroup_>;
  /** update multiples rows of table: "esrs.ActionQuestionGroup" */
  update_ActionQuestionGroup_many?: Maybe<Array<Maybe<ActionQuestionGroup_Mutation_Response_>>>;
  /** update single row of the table: "esrs.ActionQuestion" */
  update_ActionQuestion_by_pk?: Maybe<ActionQuestion_>;
  /** update multiples rows of table: "esrs.ActionQuestion" */
  update_ActionQuestion_many?: Maybe<Array<Maybe<ActionQuestion_Mutation_Response_>>>;
  /** update data of the table: "Activity" */
  update_Activity?: Maybe<Activity_Mutation_Response_>;
  /** update data of the table: "ActivityNaceCode" */
  update_ActivityNaceCode?: Maybe<ActivityNaceCode_Mutation_Response_>;
  /** update single row of the table: "ActivityNaceCode" */
  update_ActivityNaceCode_by_pk?: Maybe<ActivityNaceCode_>;
  /** update multiples rows of table: "ActivityNaceCode" */
  update_ActivityNaceCode_many?: Maybe<Array<Maybe<ActivityNaceCode_Mutation_Response_>>>;
  /** update data of the table: "ActivityQuestionSet" */
  update_ActivityQuestionSet?: Maybe<ActivityQuestionSet_Mutation_Response_>;
  /** update single row of the table: "ActivityQuestionSet" */
  update_ActivityQuestionSet_by_pk?: Maybe<ActivityQuestionSet_>;
  /** update multiples rows of table: "ActivityQuestionSet" */
  update_ActivityQuestionSet_many?: Maybe<Array<Maybe<ActivityQuestionSet_Mutation_Response_>>>;
  /** update data of the table: "ActivityReport" */
  update_ActivityReport?: Maybe<ActivityReport_Mutation_Response_>;
  /** update single row of the table: "ActivityReport" */
  update_ActivityReport_by_pk?: Maybe<ActivityReport_>;
  /** update multiples rows of table: "ActivityReport" */
  update_ActivityReport_many?: Maybe<Array<Maybe<ActivityReport_Mutation_Response_>>>;
  /** update data of the table: "ActivityVersion" */
  update_ActivityVersion?: Maybe<ActivityVersion_Mutation_Response_>;
  /** update single row of the table: "ActivityVersion" */
  update_ActivityVersion_by_pk?: Maybe<ActivityVersion_>;
  /** update multiples rows of table: "ActivityVersion" */
  update_ActivityVersion_many?: Maybe<Array<Maybe<ActivityVersion_Mutation_Response_>>>;
  /** update single row of the table: "Activity" */
  update_Activity_by_pk?: Maybe<Activity_>;
  /** update multiples rows of table: "Activity" */
  update_Activity_many?: Maybe<Array<Maybe<Activity_Mutation_Response_>>>;
  /** update data of the table: "esrs.AdditionalType" */
  update_AdditionalType?: Maybe<AdditionalType_Mutation_Response_>;
  /** update single row of the table: "esrs.AdditionalType" */
  update_AdditionalType_by_pk?: Maybe<AdditionalType_>;
  /** update multiples rows of table: "esrs.AdditionalType" */
  update_AdditionalType_many?: Maybe<Array<Maybe<AdditionalType_Mutation_Response_>>>;
  /** update data of the table: "Answer" */
  update_Answer?: Maybe<Answer_Mutation_Response_>;
  /** update single row of the table: "Answer" */
  update_Answer_by_pk?: Maybe<Answer_>;
  /** update multiples rows of table: "Answer" */
  update_Answer_many?: Maybe<Array<Maybe<Answer_Mutation_Response_>>>;
  /** update data of the table: "AppConfig" */
  update_AppConfig?: Maybe<AppConfig_Mutation_Response_>;
  /** update single row of the table: "AppConfig" */
  update_AppConfig_by_pk?: Maybe<AppConfig_>;
  /** update multiples rows of table: "AppConfig" */
  update_AppConfig_many?: Maybe<Array<Maybe<AppConfig_Mutation_Response_>>>;
  /** update data of the table: "Article" */
  update_Article?: Maybe<Article_Mutation_Response_>;
  /** update single row of the table: "Article" */
  update_Article_by_pk?: Maybe<Article_>;
  /** update multiples rows of table: "Article" */
  update_Article_many?: Maybe<Array<Maybe<Article_Mutation_Response_>>>;
  /** update data of the table: "Attachment" */
  update_Attachment?: Maybe<Attachment_Mutation_Response_>;
  /** update data of the table: "AttachmentBox" */
  update_AttachmentBox?: Maybe<AttachmentBox_Mutation_Response_>;
  /** update single row of the table: "AttachmentBox" */
  update_AttachmentBox_by_pk?: Maybe<AttachmentBox_>;
  /** update multiples rows of table: "AttachmentBox" */
  update_AttachmentBox_many?: Maybe<Array<Maybe<AttachmentBox_Mutation_Response_>>>;
  /** update single row of the table: "Attachment" */
  update_Attachment_by_pk?: Maybe<Attachment_>;
  /** update multiples rows of table: "Attachment" */
  update_Attachment_many?: Maybe<Array<Maybe<Attachment_Mutation_Response_>>>;
  /** update data of the table: "AuditLogEntry" */
  update_AuditLogEntry?: Maybe<AuditLogEntry_Mutation_Response_>;
  /** update single row of the table: "AuditLogEntry" */
  update_AuditLogEntry_by_pk?: Maybe<AuditLogEntry_>;
  /** update multiples rows of table: "AuditLogEntry" */
  update_AuditLogEntry_many?: Maybe<Array<Maybe<AuditLogEntry_Mutation_Response_>>>;
  /** update data of the table: "BusinessUnit" */
  update_BusinessUnit?: Maybe<BusinessUnit_Mutation_Response_>;
  /** update data of the table: "BusinessUnitAssessment" */
  update_BusinessUnitAssessment?: Maybe<BusinessUnitAssessment_Mutation_Response_>;
  /** update single row of the table: "BusinessUnitAssessment" */
  update_BusinessUnitAssessment_by_pk?: Maybe<BusinessUnitAssessment_>;
  /** update multiples rows of table: "BusinessUnitAssessment" */
  update_BusinessUnitAssessment_many?: Maybe<Array<Maybe<BusinessUnitAssessment_Mutation_Response_>>>;
  /** update single row of the table: "BusinessUnit" */
  update_BusinessUnit_by_pk?: Maybe<BusinessUnit_>;
  /** update multiples rows of table: "BusinessUnit" */
  update_BusinessUnit_many?: Maybe<Array<Maybe<BusinessUnit_Mutation_Response_>>>;
  /** update data of the table: "CachedResult" */
  update_CachedResult?: Maybe<CachedResult_Mutation_Response_>;
  /** update single row of the table: "CachedResult" */
  update_CachedResult_by_pk?: Maybe<CachedResult_>;
  /** update multiples rows of table: "CachedResult" */
  update_CachedResult_many?: Maybe<Array<Maybe<CachedResult_Mutation_Response_>>>;
  /** update data of the table: "esrs.ChoiceSet" */
  update_ChoiceSet?: Maybe<ChoiceSet_Mutation_Response_>;
  /** update single row of the table: "esrs.ChoiceSet" */
  update_ChoiceSet_by_pk?: Maybe<ChoiceSet_>;
  /** update multiples rows of table: "esrs.ChoiceSet" */
  update_ChoiceSet_many?: Maybe<Array<Maybe<ChoiceSet_Mutation_Response_>>>;
  /** update data of the table: "Comment" */
  update_Comment?: Maybe<Comment_Mutation_Response_>;
  /** update single row of the table: "Comment" */
  update_Comment_by_pk?: Maybe<Comment_>;
  /** update multiples rows of table: "Comment" */
  update_Comment_many?: Maybe<Array<Maybe<Comment_Mutation_Response_>>>;
  /** update data of the table: "Company" */
  update_Company?: Maybe<Company_Mutation_Response_>;
  /** update data of the table: "CompanyAssessment" */
  update_CompanyAssessment?: Maybe<CompanyAssessment_Mutation_Response_>;
  /** update data of the table: "CompanyAssessmentAggregate" */
  update_CompanyAssessmentAggregate?: Maybe<CompanyAssessmentAggregate_Mutation_Response_>;
  /** update single row of the table: "CompanyAssessmentAggregate" */
  update_CompanyAssessmentAggregate_by_pk?: Maybe<CompanyAssessmentAggregate_>;
  /** update multiples rows of table: "CompanyAssessmentAggregate" */
  update_CompanyAssessmentAggregate_many?: Maybe<Array<Maybe<CompanyAssessmentAggregate_Mutation_Response_>>>;
  /** update single row of the table: "CompanyAssessment" */
  update_CompanyAssessment_by_pk?: Maybe<CompanyAssessment_>;
  /** update multiples rows of table: "CompanyAssessment" */
  update_CompanyAssessment_many?: Maybe<Array<Maybe<CompanyAssessment_Mutation_Response_>>>;
  /** update data of the table: "CompanyIdentityProvider" */
  update_CompanyIdentityProvider?: Maybe<CompanyIdentityProvider_Mutation_Response_>;
  /** update single row of the table: "CompanyIdentityProvider" */
  update_CompanyIdentityProvider_by_pk?: Maybe<CompanyIdentityProvider_>;
  /** update multiples rows of table: "CompanyIdentityProvider" */
  update_CompanyIdentityProvider_many?: Maybe<Array<Maybe<CompanyIdentityProvider_Mutation_Response_>>>;
  /** update data of the table: "CompanyInvitation" */
  update_CompanyInvitation?: Maybe<CompanyInvitation_Mutation_Response_>;
  /** update single row of the table: "CompanyInvitation" */
  update_CompanyInvitation_by_pk?: Maybe<CompanyInvitation_>;
  /** update multiples rows of table: "CompanyInvitation" */
  update_CompanyInvitation_many?: Maybe<Array<Maybe<CompanyInvitation_Mutation_Response_>>>;
  /** update data of the table: "CompanyUser" */
  update_CompanyUser?: Maybe<CompanyUser_Mutation_Response_>;
  /** update single row of the table: "CompanyUser" */
  update_CompanyUser_by_pk?: Maybe<CompanyUser_>;
  /** update multiples rows of table: "CompanyUser" */
  update_CompanyUser_many?: Maybe<Array<Maybe<CompanyUser_Mutation_Response_>>>;
  /** update single row of the table: "Company" */
  update_Company_by_pk?: Maybe<Company_>;
  /** update multiples rows of table: "Company" */
  update_Company_many?: Maybe<Array<Maybe<Company_Mutation_Response_>>>;
  /** update data of the table: "CompassPAT" */
  update_CompassPAT?: Maybe<CompassPat_Mutation_Response_>;
  /** update single row of the table: "CompassPAT" */
  update_CompassPAT_by_pk?: Maybe<CompassPat_>;
  /** update multiples rows of table: "CompassPAT" */
  update_CompassPAT_many?: Maybe<Array<Maybe<CompassPat_Mutation_Response_>>>;
  /** update data of the table: "esrs.DRToMFDisclosureRequirement" */
  update_DRToMFDisclosureRequirement?: Maybe<DrToMfDisclosureRequirement_Mutation_Response_>;
  /** update single row of the table: "esrs.DRToMFDisclosureRequirement" */
  update_DRToMFDisclosureRequirement_by_pk?: Maybe<DrToMfDisclosureRequirement_>;
  /** update multiples rows of table: "esrs.DRToMFDisclosureRequirement" */
  update_DRToMFDisclosureRequirement_many?: Maybe<Array<Maybe<DrToMfDisclosureRequirement_Mutation_Response_>>>;
  /** update data of the table: "esrs.DisclosureRequirement" */
  update_DisclosureRequirement?: Maybe<DisclosureRequirement_Mutation_Response_>;
  /** update data of the table: "esrs.DisclosureRequirementAdditionalType" */
  update_DisclosureRequirementAdditionalType?: Maybe<DisclosureRequirementAdditionalType_Mutation_Response_>;
  /** update single row of the table: "esrs.DisclosureRequirementAdditionalType" */
  update_DisclosureRequirementAdditionalType_by_pk?: Maybe<DisclosureRequirementAdditionalType_>;
  /** update multiples rows of table: "esrs.DisclosureRequirementAdditionalType" */
  update_DisclosureRequirementAdditionalType_many?: Maybe<Array<Maybe<DisclosureRequirementAdditionalType_Mutation_Response_>>>;
  /** update data of the table: "esrs.DisclosureRequirementGroup" */
  update_DisclosureRequirementGroup?: Maybe<DisclosureRequirementGroup_Mutation_Response_>;
  /** update single row of the table: "esrs.DisclosureRequirementGroup" */
  update_DisclosureRequirementGroup_by_pk?: Maybe<DisclosureRequirementGroup_>;
  /** update multiples rows of table: "esrs.DisclosureRequirementGroup" */
  update_DisclosureRequirementGroup_many?: Maybe<Array<Maybe<DisclosureRequirementGroup_Mutation_Response_>>>;
  /** update data of the table: "esrs.DisclosureRequirementOwner" */
  update_DisclosureRequirementOwner?: Maybe<DisclosureRequirementOwner_Mutation_Response_>;
  /** update single row of the table: "esrs.DisclosureRequirementOwner" */
  update_DisclosureRequirementOwner_by_pk?: Maybe<DisclosureRequirementOwner_>;
  /** update multiples rows of table: "esrs.DisclosureRequirementOwner" */
  update_DisclosureRequirementOwner_many?: Maybe<Array<Maybe<DisclosureRequirementOwner_Mutation_Response_>>>;
  /** update data of the table: "esrs.DisclosureRequirementStatus" */
  update_DisclosureRequirementStatus?: Maybe<DisclosureRequirementStatus_Mutation_Response_>;
  /** update single row of the table: "esrs.DisclosureRequirementStatus" */
  update_DisclosureRequirementStatus_by_pk?: Maybe<DisclosureRequirementStatus_>;
  /** update multiples rows of table: "esrs.DisclosureRequirementStatus" */
  update_DisclosureRequirementStatus_many?: Maybe<Array<Maybe<DisclosureRequirementStatus_Mutation_Response_>>>;
  /** update single row of the table: "esrs.DisclosureRequirement" */
  update_DisclosureRequirement_by_pk?: Maybe<DisclosureRequirement_>;
  /** update multiples rows of table: "esrs.DisclosureRequirement" */
  update_DisclosureRequirement_many?: Maybe<Array<Maybe<DisclosureRequirement_Mutation_Response_>>>;
  /** update data of the table: "DocumentInsight" */
  update_DocumentInsight?: Maybe<DocumentInsight_Mutation_Response_>;
  /** update single row of the table: "DocumentInsight" */
  update_DocumentInsight_by_pk?: Maybe<DocumentInsight_>;
  /** update multiples rows of table: "DocumentInsight" */
  update_DocumentInsight_many?: Maybe<Array<Maybe<DocumentInsight_Mutation_Response_>>>;
  /** update data of the table: "DocumentationFile" */
  update_DocumentationFile?: Maybe<DocumentationFile_Mutation_Response_>;
  /** update single row of the table: "DocumentationFile" */
  update_DocumentationFile_by_pk?: Maybe<DocumentationFile_>;
  /** update multiples rows of table: "DocumentationFile" */
  update_DocumentationFile_many?: Maybe<Array<Maybe<DocumentationFile_Mutation_Response_>>>;
  /** update data of the table: "esrs.EsrsAssessment" */
  update_EsrsAssessment?: Maybe<EsrsAssessment_Mutation_Response_>;
  /** update single row of the table: "esrs.EsrsAssessment" */
  update_EsrsAssessment_by_pk?: Maybe<EsrsAssessment_>;
  /** update multiples rows of table: "esrs.EsrsAssessment" */
  update_EsrsAssessment_many?: Maybe<Array<Maybe<EsrsAssessment_Mutation_Response_>>>;
  /** update data of the table: "esrs.EsrsCategory" */
  update_EsrsCategory?: Maybe<EsrsCategory_Mutation_Response_>;
  /** update single row of the table: "esrs.EsrsCategory" */
  update_EsrsCategory_by_pk?: Maybe<EsrsCategory_>;
  /** update multiples rows of table: "esrs.EsrsCategory" */
  update_EsrsCategory_many?: Maybe<Array<Maybe<EsrsCategory_Mutation_Response_>>>;
  /** update data of the table: "esrs.EsrsChoice" */
  update_EsrsChoice?: Maybe<EsrsChoice_Mutation_Response_>;
  /** update single row of the table: "esrs.EsrsChoice" */
  update_EsrsChoice_by_pk?: Maybe<EsrsChoice_>;
  /** update multiples rows of table: "esrs.EsrsChoice" */
  update_EsrsChoice_many?: Maybe<Array<Maybe<EsrsChoice_Mutation_Response_>>>;
  /** update data of the table: "esrs.EsrsMetric" */
  update_EsrsMetric?: Maybe<EsrsMetric_Mutation_Response_>;
  /** update data of the table: "esrs.EsrsMetricAdditionalType" */
  update_EsrsMetricAdditionalType?: Maybe<EsrsMetricAdditionalType_Mutation_Response_>;
  /** update single row of the table: "esrs.EsrsMetricAdditionalType" */
  update_EsrsMetricAdditionalType_by_pk?: Maybe<EsrsMetricAdditionalType_>;
  /** update multiples rows of table: "esrs.EsrsMetricAdditionalType" */
  update_EsrsMetricAdditionalType_many?: Maybe<Array<Maybe<EsrsMetricAdditionalType_Mutation_Response_>>>;
  /** update single row of the table: "esrs.EsrsMetric" */
  update_EsrsMetric_by_pk?: Maybe<EsrsMetric_>;
  /** update multiples rows of table: "esrs.EsrsMetric" */
  update_EsrsMetric_many?: Maybe<Array<Maybe<EsrsMetric_Mutation_Response_>>>;
  /** update data of the table: "esrs.EsrsStandard" */
  update_EsrsStandard?: Maybe<EsrsStandard_Mutation_Response_>;
  /** update data of the table: "esrs.EsrsStandardAdditionalType" */
  update_EsrsStandardAdditionalType?: Maybe<EsrsStandardAdditionalType_Mutation_Response_>;
  /** update single row of the table: "esrs.EsrsStandardAdditionalType" */
  update_EsrsStandardAdditionalType_by_pk?: Maybe<EsrsStandardAdditionalType_>;
  /** update multiples rows of table: "esrs.EsrsStandardAdditionalType" */
  update_EsrsStandardAdditionalType_many?: Maybe<Array<Maybe<EsrsStandardAdditionalType_Mutation_Response_>>>;
  /** update single row of the table: "esrs.EsrsStandard" */
  update_EsrsStandard_by_pk?: Maybe<EsrsStandard_>;
  /** update multiples rows of table: "esrs.EsrsStandard" */
  update_EsrsStandard_many?: Maybe<Array<Maybe<EsrsStandard_Mutation_Response_>>>;
  /** update data of the table: "EstimateCompany_deprecated" */
  update_EstimateCompany_deprecated?: Maybe<EstimateCompany_Deprecated_Mutation_Response_>;
  /** update single row of the table: "EstimateCompany_deprecated" */
  update_EstimateCompany_deprecated_by_pk?: Maybe<EstimateCompany_Deprecated_>;
  /** update multiples rows of table: "EstimateCompany_deprecated" */
  update_EstimateCompany_deprecated_many?: Maybe<Array<Maybe<EstimateCompany_Deprecated_Mutation_Response_>>>;
  /** update data of the table: "ExtractionJob" */
  update_ExtractionJob?: Maybe<ExtractionJob_Mutation_Response_>;
  /** update single row of the table: "ExtractionJob" */
  update_ExtractionJob_by_pk?: Maybe<ExtractionJob_>;
  /** update multiples rows of table: "ExtractionJob" */
  update_ExtractionJob_many?: Maybe<Array<Maybe<ExtractionJob_Mutation_Response_>>>;
  /** update data of the table: "Financials" */
  update_Financials?: Maybe<Financials_Mutation_Response_>;
  /** update single row of the table: "Financials" */
  update_Financials_by_pk?: Maybe<Financials_>;
  /** update multiples rows of table: "Financials" */
  update_Financials_many?: Maybe<Array<Maybe<Financials_Mutation_Response_>>>;
  /** update data of the table: "esrs.Framework" */
  update_Framework?: Maybe<Framework_Mutation_Response_>;
  /** update single row of the table: "esrs.Framework" */
  update_Framework_by_pk?: Maybe<Framework_>;
  /** update multiples rows of table: "esrs.Framework" */
  update_Framework_many?: Maybe<Array<Maybe<Framework_Mutation_Response_>>>;
  /** update data of the table: "GroupAssessment" */
  update_GroupAssessment?: Maybe<GroupAssessment_Mutation_Response_>;
  /** update single row of the table: "GroupAssessment" */
  update_GroupAssessment_by_pk?: Maybe<GroupAssessment_>;
  /** update multiples rows of table: "GroupAssessment" */
  update_GroupAssessment_many?: Maybe<Array<Maybe<GroupAssessment_Mutation_Response_>>>;
  /** update data of the table: "IdentityProvider" */
  update_IdentityProvider?: Maybe<IdentityProvider_Mutation_Response_>;
  /** update single row of the table: "IdentityProvider" */
  update_IdentityProvider_by_pk?: Maybe<IdentityProvider_>;
  /** update multiples rows of table: "IdentityProvider" */
  update_IdentityProvider_many?: Maybe<Array<Maybe<IdentityProvider_Mutation_Response_>>>;
  /** update data of the table: "IndicatorToInvestorMetric" */
  update_IndicatorToInvestorMetric?: Maybe<IndicatorToInvestorMetric_Mutation_Response_>;
  /** update single row of the table: "IndicatorToInvestorMetric" */
  update_IndicatorToInvestorMetric_by_pk?: Maybe<IndicatorToInvestorMetric_>;
  /** update multiples rows of table: "IndicatorToInvestorMetric" */
  update_IndicatorToInvestorMetric_many?: Maybe<Array<Maybe<IndicatorToInvestorMetric_Mutation_Response_>>>;
  /** update data of the table: "InvesteeMetric" */
  update_InvesteeMetric?: Maybe<InvesteeMetric_Mutation_Response_>;
  /** update single row of the table: "InvesteeMetric" */
  update_InvesteeMetric_by_pk?: Maybe<InvesteeMetric_>;
  /** update multiples rows of table: "InvesteeMetric" */
  update_InvesteeMetric_many?: Maybe<Array<Maybe<InvesteeMetric_Mutation_Response_>>>;
  /** update data of the table: "InvestmentCategory" */
  update_InvestmentCategory?: Maybe<InvestmentCategory_Mutation_Response_>;
  /** update single row of the table: "InvestmentCategory" */
  update_InvestmentCategory_by_pk?: Maybe<InvestmentCategory_>;
  /** update multiples rows of table: "InvestmentCategory" */
  update_InvestmentCategory_many?: Maybe<Array<Maybe<InvestmentCategory_Mutation_Response_>>>;
  /** update data of the table: "InvestorMetric" */
  update_InvestorMetric?: Maybe<InvestorMetric_Mutation_Response_>;
  /** update single row of the table: "InvestorMetric" */
  update_InvestorMetric_by_pk?: Maybe<InvestorMetric_>;
  /** update multiples rows of table: "InvestorMetric" */
  update_InvestorMetric_many?: Maybe<Array<Maybe<InvestorMetric_Mutation_Response_>>>;
  /** update data of the table: "InvestorToInvesteeMetric" */
  update_InvestorToInvesteeMetric?: Maybe<InvestorToInvesteeMetric_Mutation_Response_>;
  /** update single row of the table: "InvestorToInvesteeMetric" */
  update_InvestorToInvesteeMetric_by_pk?: Maybe<InvestorToInvesteeMetric_>;
  /** update multiples rows of table: "InvestorToInvesteeMetric" */
  update_InvestorToInvesteeMetric_many?: Maybe<Array<Maybe<InvestorToInvesteeMetric_Mutation_Response_>>>;
  /** update data of the table: "esrs.MFCategory" */
  update_MFCategory?: Maybe<MfCategory_Mutation_Response_>;
  /** update single row of the table: "esrs.MFCategory" */
  update_MFCategory_by_pk?: Maybe<MfCategory_>;
  /** update multiples rows of table: "esrs.MFCategory" */
  update_MFCategory_many?: Maybe<Array<Maybe<MfCategory_Mutation_Response_>>>;
  /** update data of the table: "esrs.MFDisclosureRequirement" */
  update_MFDisclosureRequirement?: Maybe<MfDisclosureRequirement_Mutation_Response_>;
  /** update data of the table: "esrs.MFDisclosureRequirementGroup" */
  update_MFDisclosureRequirementGroup?: Maybe<MfDisclosureRequirementGroup_Mutation_Response_>;
  /** update single row of the table: "esrs.MFDisclosureRequirementGroup" */
  update_MFDisclosureRequirementGroup_by_pk?: Maybe<MfDisclosureRequirementGroup_>;
  /** update multiples rows of table: "esrs.MFDisclosureRequirementGroup" */
  update_MFDisclosureRequirementGroup_many?: Maybe<Array<Maybe<MfDisclosureRequirementGroup_Mutation_Response_>>>;
  /** update data of the table: "esrs.MFDisclosureRequirementItem" */
  update_MFDisclosureRequirementItem?: Maybe<MfDisclosureRequirementItem_Mutation_Response_>;
  /** update single row of the table: "esrs.MFDisclosureRequirementItem" */
  update_MFDisclosureRequirementItem_by_pk?: Maybe<MfDisclosureRequirementItem_>;
  /** update multiples rows of table: "esrs.MFDisclosureRequirementItem" */
  update_MFDisclosureRequirementItem_many?: Maybe<Array<Maybe<MfDisclosureRequirementItem_Mutation_Response_>>>;
  /** update single row of the table: "esrs.MFDisclosureRequirement" */
  update_MFDisclosureRequirement_by_pk?: Maybe<MfDisclosureRequirement_>;
  /** update multiples rows of table: "esrs.MFDisclosureRequirement" */
  update_MFDisclosureRequirement_many?: Maybe<Array<Maybe<MfDisclosureRequirement_Mutation_Response_>>>;
  /** update data of the table: "esrs.MFStandard" */
  update_MFStandard?: Maybe<MfStandard_Mutation_Response_>;
  /** update data of the table: "esrs.MFStandardItem" */
  update_MFStandardItem?: Maybe<MfStandardItem_Mutation_Response_>;
  /** update single row of the table: "esrs.MFStandardItem" */
  update_MFStandardItem_by_pk?: Maybe<MfStandardItem_>;
  /** update multiples rows of table: "esrs.MFStandardItem" */
  update_MFStandardItem_many?: Maybe<Array<Maybe<MfStandardItem_Mutation_Response_>>>;
  /** update single row of the table: "esrs.MFStandard" */
  update_MFStandard_by_pk?: Maybe<MfStandard_>;
  /** update multiples rows of table: "esrs.MFStandard" */
  update_MFStandard_many?: Maybe<Array<Maybe<MfStandard_Mutation_Response_>>>;
  /** update data of the table: "esrs.MaterialStandardOwner" */
  update_MaterialStandardOwner?: Maybe<MaterialStandardOwner_Mutation_Response_>;
  /** update single row of the table: "esrs.MaterialStandardOwner" */
  update_MaterialStandardOwner_by_pk?: Maybe<MaterialStandardOwner_>;
  /** update multiples rows of table: "esrs.MaterialStandardOwner" */
  update_MaterialStandardOwner_many?: Maybe<Array<Maybe<MaterialStandardOwner_Mutation_Response_>>>;
  /** update data of the table: "esrs.MetricDependency" */
  update_MetricDependency?: Maybe<MetricDependency_Mutation_Response_>;
  /** update single row of the table: "esrs.MetricDependency" */
  update_MetricDependency_by_pk?: Maybe<MetricDependency_>;
  /** update multiples rows of table: "esrs.MetricDependency" */
  update_MetricDependency_many?: Maybe<Array<Maybe<MetricDependency_Mutation_Response_>>>;
  /** update data of the table: "esrs.MetricTag" */
  update_MetricTag?: Maybe<MetricTag_Mutation_Response_>;
  /** update single row of the table: "esrs.MetricTag" */
  update_MetricTag_by_pk?: Maybe<MetricTag_>;
  /** update multiples rows of table: "esrs.MetricTag" */
  update_MetricTag_many?: Maybe<Array<Maybe<MetricTag_Mutation_Response_>>>;
  /** update data of the table: "NonMaterialFinancials" */
  update_NonMaterialFinancials?: Maybe<NonMaterialFinancials_Mutation_Response_>;
  /** update multiples rows of table: "NonMaterialFinancials" */
  update_NonMaterialFinancials_many?: Maybe<Array<Maybe<NonMaterialFinancials_Mutation_Response_>>>;
  /** update data of the table: "Note" */
  update_Note?: Maybe<Note_Mutation_Response_>;
  /** update data of the table: "NoteHistory" */
  update_NoteHistory?: Maybe<NoteHistory_Mutation_Response_>;
  /** update single row of the table: "NoteHistory" */
  update_NoteHistory_by_pk?: Maybe<NoteHistory_>;
  /** update multiples rows of table: "NoteHistory" */
  update_NoteHistory_many?: Maybe<Array<Maybe<NoteHistory_Mutation_Response_>>>;
  /** update single row of the table: "Note" */
  update_Note_by_pk?: Maybe<Note_>;
  /** update multiples rows of table: "Note" */
  update_Note_many?: Maybe<Array<Maybe<Note_Mutation_Response_>>>;
  /** update data of the table: "Objective" */
  update_Objective?: Maybe<Objective_Mutation_Response_>;
  /** update single row of the table: "Objective" */
  update_Objective_by_pk?: Maybe<Objective_>;
  /** update multiples rows of table: "Objective" */
  update_Objective_many?: Maybe<Array<Maybe<Objective_Mutation_Response_>>>;
  /** update data of the table: "PaiAnswers" */
  update_PaiAnswers?: Maybe<PaiAnswers_Mutation_Response_>;
  /** update single row of the table: "PaiAnswers" */
  update_PaiAnswers_by_pk?: Maybe<PaiAnswers_>;
  /** update multiples rows of table: "PaiAnswers" */
  update_PaiAnswers_many?: Maybe<Array<Maybe<PaiAnswers_Mutation_Response_>>>;
  /** update data of the table: "PaiCategory" */
  update_PaiCategory?: Maybe<PaiCategory_Mutation_Response_>;
  /** update single row of the table: "PaiCategory" */
  update_PaiCategory_by_pk?: Maybe<PaiCategory_>;
  /** update multiples rows of table: "PaiCategory" */
  update_PaiCategory_many?: Maybe<Array<Maybe<PaiCategory_Mutation_Response_>>>;
  /** update data of the table: "PaiCompanyReport" */
  update_PaiCompanyReport?: Maybe<PaiCompanyReport_Mutation_Response_>;
  /** update single row of the table: "PaiCompanyReport" */
  update_PaiCompanyReport_by_pk?: Maybe<PaiCompanyReport_>;
  /** update multiples rows of table: "PaiCompanyReport" */
  update_PaiCompanyReport_many?: Maybe<Array<Maybe<PaiCompanyReport_Mutation_Response_>>>;
  /** update data of the table: "PaiMetricInsight" */
  update_PaiMetricInsight?: Maybe<PaiMetricInsight_Mutation_Response_>;
  /** update single row of the table: "PaiMetricInsight" */
  update_PaiMetricInsight_by_pk?: Maybe<PaiMetricInsight_>;
  /** update multiples rows of table: "PaiMetricInsight" */
  update_PaiMetricInsight_many?: Maybe<Array<Maybe<PaiMetricInsight_Mutation_Response_>>>;
  /** update data of the table: "PaiPortfolioReport" */
  update_PaiPortfolioReport?: Maybe<PaiPortfolioReport_Mutation_Response_>;
  /** update single row of the table: "PaiPortfolioReport" */
  update_PaiPortfolioReport_by_pk?: Maybe<PaiPortfolioReport_>;
  /** update multiples rows of table: "PaiPortfolioReport" */
  update_PaiPortfolioReport_many?: Maybe<Array<Maybe<PaiPortfolioReport_Mutation_Response_>>>;
  /** update data of the table: "PaiReportIndicator" */
  update_PaiReportIndicator?: Maybe<PaiReportIndicator_Mutation_Response_>;
  /** update data of the table: "PaiReportIndicatorPortfolioCompany" */
  update_PaiReportIndicatorPortfolioCompany?: Maybe<PaiReportIndicatorPortfolioCompany_Mutation_Response_>;
  /** update single row of the table: "PaiReportIndicatorPortfolioCompany" */
  update_PaiReportIndicatorPortfolioCompany_by_pk?: Maybe<PaiReportIndicatorPortfolioCompany_>;
  /** update multiples rows of table: "PaiReportIndicatorPortfolioCompany" */
  update_PaiReportIndicatorPortfolioCompany_many?: Maybe<Array<Maybe<PaiReportIndicatorPortfolioCompany_Mutation_Response_>>>;
  /** update single row of the table: "PaiReportIndicator" */
  update_PaiReportIndicator_by_pk?: Maybe<PaiReportIndicator_>;
  /** update multiples rows of table: "PaiReportIndicator" */
  update_PaiReportIndicator_many?: Maybe<Array<Maybe<PaiReportIndicator_Mutation_Response_>>>;
  /** update data of the table: "PaiTable" */
  update_PaiTable?: Maybe<PaiTable_Mutation_Response_>;
  /** update data of the table: "PaiTableIndicator" */
  update_PaiTableIndicator?: Maybe<PaiTableIndicator_Mutation_Response_>;
  /** update single row of the table: "PaiTableIndicator" */
  update_PaiTableIndicator_by_pk?: Maybe<PaiTableIndicator_>;
  /** update multiples rows of table: "PaiTableIndicator" */
  update_PaiTableIndicator_many?: Maybe<Array<Maybe<PaiTableIndicator_Mutation_Response_>>>;
  /** update single row of the table: "PaiTable" */
  update_PaiTable_by_pk?: Maybe<PaiTable_>;
  /** update multiples rows of table: "PaiTable" */
  update_PaiTable_many?: Maybe<Array<Maybe<PaiTable_Mutation_Response_>>>;
  /** update data of the table: "Portfolio" */
  update_Portfolio?: Maybe<Portfolio_Mutation_Response_>;
  /** update data of the table: "PortfolioCompany" */
  update_PortfolioCompany?: Maybe<PortfolioCompany_Mutation_Response_>;
  /** update single row of the table: "PortfolioCompany" */
  update_PortfolioCompany_by_pk?: Maybe<PortfolioCompany_>;
  /** update multiples rows of table: "PortfolioCompany" */
  update_PortfolioCompany_many?: Maybe<Array<Maybe<PortfolioCompany_Mutation_Response_>>>;
  /** update data of the table: "PortfolioNonEligibleFinancials" */
  update_PortfolioNonEligibleFinancials?: Maybe<PortfolioNonEligibleFinancials_Mutation_Response_>;
  /** update single row of the table: "PortfolioNonEligibleFinancials" */
  update_PortfolioNonEligibleFinancials_by_pk?: Maybe<PortfolioNonEligibleFinancials_>;
  /** update multiples rows of table: "PortfolioNonEligibleFinancials" */
  update_PortfolioNonEligibleFinancials_many?: Maybe<Array<Maybe<PortfolioNonEligibleFinancials_Mutation_Response_>>>;
  /** update single row of the table: "Portfolio" */
  update_Portfolio_by_pk?: Maybe<Portfolio_>;
  /** update multiples rows of table: "Portfolio" */
  update_Portfolio_many?: Maybe<Array<Maybe<Portfolio_Mutation_Response_>>>;
  /** update data of the table: "QuarterEnum" */
  update_QuarterEnum?: Maybe<QuarterEnum_Mutation_Response_>;
  /** update single row of the table: "QuarterEnum" */
  update_QuarterEnum_by_pk?: Maybe<QuarterEnum_>;
  /** update multiples rows of table: "QuarterEnum" */
  update_QuarterEnum_many?: Maybe<Array<Maybe<QuarterEnum_Mutation_Response_>>>;
  /** update data of the table: "Question" */
  update_Question?: Maybe<Question_Mutation_Response_>;
  /** update data of the table: "QuestionChoice" */
  update_QuestionChoice?: Maybe<QuestionChoice_Mutation_Response_>;
  /** update single row of the table: "QuestionChoice" */
  update_QuestionChoice_by_pk?: Maybe<QuestionChoice_>;
  /** update multiples rows of table: "QuestionChoice" */
  update_QuestionChoice_many?: Maybe<Array<Maybe<QuestionChoice_Mutation_Response_>>>;
  /** update data of the table: "QuestionLevel" */
  update_QuestionLevel?: Maybe<QuestionLevel_Mutation_Response_>;
  /** update single row of the table: "QuestionLevel" */
  update_QuestionLevel_by_pk?: Maybe<QuestionLevel_>;
  /** update multiples rows of table: "QuestionLevel" */
  update_QuestionLevel_many?: Maybe<Array<Maybe<QuestionLevel_Mutation_Response_>>>;
  /** update data of the table: "QuestionRevision" */
  update_QuestionRevision?: Maybe<QuestionRevision_Mutation_Response_>;
  /** update single row of the table: "QuestionRevision" */
  update_QuestionRevision_by_pk?: Maybe<QuestionRevision_>;
  /** update multiples rows of table: "QuestionRevision" */
  update_QuestionRevision_many?: Maybe<Array<Maybe<QuestionRevision_Mutation_Response_>>>;
  /** update data of the table: "QuestionSet" */
  update_QuestionSet?: Maybe<QuestionSet_Mutation_Response_>;
  /** update data of the table: "QuestionSetQuestion" */
  update_QuestionSetQuestion?: Maybe<QuestionSetQuestion_Mutation_Response_>;
  /** update single row of the table: "QuestionSetQuestion" */
  update_QuestionSetQuestion_by_pk?: Maybe<QuestionSetQuestion_>;
  /** update multiples rows of table: "QuestionSetQuestion" */
  update_QuestionSetQuestion_many?: Maybe<Array<Maybe<QuestionSetQuestion_Mutation_Response_>>>;
  /** update single row of the table: "QuestionSet" */
  update_QuestionSet_by_pk?: Maybe<QuestionSet_>;
  /** update multiples rows of table: "QuestionSet" */
  update_QuestionSet_many?: Maybe<Array<Maybe<QuestionSet_Mutation_Response_>>>;
  /** update data of the table: "QuestionType" */
  update_QuestionType?: Maybe<QuestionType_Mutation_Response_>;
  /** update single row of the table: "QuestionType" */
  update_QuestionType_by_pk?: Maybe<QuestionType_>;
  /** update multiples rows of table: "QuestionType" */
  update_QuestionType_many?: Maybe<Array<Maybe<QuestionType_Mutation_Response_>>>;
  /** update single row of the table: "Question" */
  update_Question_by_pk?: Maybe<Question_>;
  /** update multiples rows of table: "Question" */
  update_Question_many?: Maybe<Array<Maybe<Question_Mutation_Response_>>>;
  /** update data of the table: "ReportingGroup" */
  update_ReportingGroup?: Maybe<ReportingGroup_Mutation_Response_>;
  /** update single row of the table: "ReportingGroup" */
  update_ReportingGroup_by_pk?: Maybe<ReportingGroup_>;
  /** update multiples rows of table: "ReportingGroup" */
  update_ReportingGroup_many?: Maybe<Array<Maybe<ReportingGroup_Mutation_Response_>>>;
  /** update data of the table: "Sector" */
  update_Sector?: Maybe<Sector_Mutation_Response_>;
  /** update single row of the table: "Sector" */
  update_Sector_by_pk?: Maybe<Sector_>;
  /** update multiples rows of table: "Sector" */
  update_Sector_many?: Maybe<Array<Maybe<Sector_Mutation_Response_>>>;
  /** update data of the table: "SharedSpace" */
  update_SharedSpace?: Maybe<SharedSpace_Mutation_Response_>;
  /** update single row of the table: "SharedSpace" */
  update_SharedSpace_by_pk?: Maybe<SharedSpace_>;
  /** update multiples rows of table: "SharedSpace" */
  update_SharedSpace_many?: Maybe<Array<Maybe<SharedSpace_Mutation_Response_>>>;
  /** update data of the table: "Space" */
  update_Space?: Maybe<Space_Mutation_Response_>;
  /** update single row of the table: "Space" */
  update_Space_by_pk?: Maybe<Space_>;
  /** update multiples rows of table: "Space" */
  update_Space_many?: Maybe<Array<Maybe<Space_Mutation_Response_>>>;
  /** update data of the table: "Subsidiary" */
  update_Subsidiary?: Maybe<Subsidiary_Mutation_Response_>;
  /** update single row of the table: "Subsidiary" */
  update_Subsidiary_by_pk?: Maybe<Subsidiary_>;
  /** update multiples rows of table: "Subsidiary" */
  update_Subsidiary_many?: Maybe<Array<Maybe<Subsidiary_Mutation_Response_>>>;
  /** update data of the table: "Tag" */
  update_Tag?: Maybe<Tag_Mutation_Response_>;
  /** update data of the table: "TagGroup" */
  update_TagGroup?: Maybe<TagGroup_Mutation_Response_>;
  /** update single row of the table: "TagGroup" */
  update_TagGroup_by_pk?: Maybe<TagGroup_>;
  /** update multiples rows of table: "TagGroup" */
  update_TagGroup_many?: Maybe<Array<Maybe<TagGroup_Mutation_Response_>>>;
  /** update data of the table: "esrs.TagType" */
  update_TagType?: Maybe<TagType_Mutation_Response_>;
  /** update single row of the table: "esrs.TagType" */
  update_TagType_by_pk?: Maybe<TagType_>;
  /** update multiples rows of table: "esrs.TagType" */
  update_TagType_many?: Maybe<Array<Maybe<TagType_Mutation_Response_>>>;
  /** update data of the table: "esrs.TagValue" */
  update_TagValue?: Maybe<TagValue_Mutation_Response_>;
  /** update single row of the table: "esrs.TagValue" */
  update_TagValue_by_pk?: Maybe<TagValue_>;
  /** update multiples rows of table: "esrs.TagValue" */
  update_TagValue_many?: Maybe<Array<Maybe<TagValue_Mutation_Response_>>>;
  /** update data of the table: "Tag_articles" */
  update_Tag_articles?: Maybe<Tag_Articles_Mutation_Response_>;
  /** update single row of the table: "Tag_articles" */
  update_Tag_articles_by_pk?: Maybe<Tag_Articles_>;
  /** update multiples rows of table: "Tag_articles" */
  update_Tag_articles_many?: Maybe<Array<Maybe<Tag_Articles_Mutation_Response_>>>;
  /** update single row of the table: "Tag" */
  update_Tag_by_pk?: Maybe<Tag_>;
  /** update multiples rows of table: "Tag" */
  update_Tag_many?: Maybe<Array<Maybe<Tag_Mutation_Response_>>>;
  /** update data of the table: "esrs.TargetQuestion" */
  update_TargetQuestion?: Maybe<TargetQuestion_Mutation_Response_>;
  /** update data of the table: "esrs.TargetQuestionGroup" */
  update_TargetQuestionGroup?: Maybe<TargetQuestionGroup_Mutation_Response_>;
  /** update single row of the table: "esrs.TargetQuestionGroup" */
  update_TargetQuestionGroup_by_pk?: Maybe<TargetQuestionGroup_>;
  /** update multiples rows of table: "esrs.TargetQuestionGroup" */
  update_TargetQuestionGroup_many?: Maybe<Array<Maybe<TargetQuestionGroup_Mutation_Response_>>>;
  /** update single row of the table: "esrs.TargetQuestion" */
  update_TargetQuestion_by_pk?: Maybe<TargetQuestion_>;
  /** update multiples rows of table: "esrs.TargetQuestion" */
  update_TargetQuestion_many?: Maybe<Array<Maybe<TargetQuestion_Mutation_Response_>>>;
  /** update data of the table: "Task" */
  update_Task?: Maybe<Task_Mutation_Response_>;
  /** update data of the table: "TaskStatusEnum" */
  update_TaskStatusEnum?: Maybe<TaskStatusEnum_Mutation_Response_>;
  /** update single row of the table: "TaskStatusEnum" */
  update_TaskStatusEnum_by_pk?: Maybe<TaskStatusEnum_>;
  /** update multiples rows of table: "TaskStatusEnum" */
  update_TaskStatusEnum_many?: Maybe<Array<Maybe<TaskStatusEnum_Mutation_Response_>>>;
  /** update single row of the table: "Task" */
  update_Task_by_pk?: Maybe<Task_>;
  /** update multiples rows of table: "Task" */
  update_Task_many?: Maybe<Array<Maybe<Task_Mutation_Response_>>>;
  /** update data of the table: "TaxonomyPortfolioReport" */
  update_TaxonomyPortfolioReport?: Maybe<TaxonomyPortfolioReport_Mutation_Response_>;
  /** update single row of the table: "TaxonomyPortfolioReport" */
  update_TaxonomyPortfolioReport_by_pk?: Maybe<TaxonomyPortfolioReport_>;
  /** update multiples rows of table: "TaxonomyPortfolioReport" */
  update_TaxonomyPortfolioReport_many?: Maybe<Array<Maybe<TaxonomyPortfolioReport_Mutation_Response_>>>;
  /** update data of the table: "Thread" */
  update_Thread?: Maybe<Thread_Mutation_Response_>;
  /** update data of the table: "ThreadSubscriber" */
  update_ThreadSubscriber?: Maybe<ThreadSubscriber_Mutation_Response_>;
  /** update single row of the table: "ThreadSubscriber" */
  update_ThreadSubscriber_by_pk?: Maybe<ThreadSubscriber_>;
  /** update multiples rows of table: "ThreadSubscriber" */
  update_ThreadSubscriber_many?: Maybe<Array<Maybe<ThreadSubscriber_Mutation_Response_>>>;
  /** update single row of the table: "Thread" */
  update_Thread_by_pk?: Maybe<Thread_>;
  /** update multiples rows of table: "Thread" */
  update_Thread_many?: Maybe<Array<Maybe<Thread_Mutation_Response_>>>;
  /** update data of the table: "TotalComparisonFinancials" */
  update_TotalComparisonFinancials?: Maybe<TotalComparisonFinancials_Mutation_Response_>;
  /** update multiples rows of table: "TotalComparisonFinancials" */
  update_TotalComparisonFinancials_many?: Maybe<Array<Maybe<TotalComparisonFinancials_Mutation_Response_>>>;
  /** update data of the table: "TriggerTypes" */
  update_TriggerTypes?: Maybe<TriggerTypes_Mutation_Response_>;
  /** update single row of the table: "TriggerTypes" */
  update_TriggerTypes_by_pk?: Maybe<TriggerTypes_>;
  /** update multiples rows of table: "TriggerTypes" */
  update_TriggerTypes_many?: Maybe<Array<Maybe<TriggerTypes_Mutation_Response_>>>;
  /** update data of the table: "UserNotification" */
  update_UserNotification?: Maybe<UserNotification_Mutation_Response_>;
  /** update single row of the table: "UserNotification" */
  update_UserNotification_by_pk?: Maybe<UserNotification_>;
  /** update multiples rows of table: "UserNotification" */
  update_UserNotification_many?: Maybe<Array<Maybe<UserNotification_Mutation_Response_>>>;
  /** update data of the table: "UserRole" */
  update_UserRole?: Maybe<UserRole_Mutation_Response_>;
  /** update single row of the table: "UserRole" */
  update_UserRole_by_pk?: Maybe<UserRole_>;
  /** update multiples rows of table: "UserRole" */
  update_UserRole_many?: Maybe<Array<Maybe<UserRole_Mutation_Response_>>>;
  /** update data of the table: "UserSessionMetadata" */
  update_UserSessionMetadata?: Maybe<UserSessionMetadata_Mutation_Response_>;
  /** update single row of the table: "UserSessionMetadata" */
  update_UserSessionMetadata_by_pk?: Maybe<UserSessionMetadata_>;
  /** update multiples rows of table: "UserSessionMetadata" */
  update_UserSessionMetadata_many?: Maybe<Array<Maybe<UserSessionMetadata_Mutation_Response_>>>;
  /** update data of the table: "WebsocketTest" */
  update_WebsocketTest?: Maybe<WebsocketTest_Mutation_Response_>;
  /** update single row of the table: "WebsocketTest" */
  update_WebsocketTest_by_pk?: Maybe<WebsocketTest_>;
  /** update multiples rows of table: "WebsocketTest" */
  update_WebsocketTest_many?: Maybe<Array<Maybe<WebsocketTest_Mutation_Response_>>>;
  /** update multiples rows of table: "auth.provider_requests" */
  update_authProviderRequests_many?: Maybe<Array<Maybe<AuthProviderRequests_Mutation_Response_>>>;
  /** update multiples rows of table: "auth.providers" */
  update_authProviders_many?: Maybe<Array<Maybe<AuthProviders_Mutation_Response_>>>;
  /** update multiples rows of table: "auth.refresh_token_types" */
  update_authRefreshTokenTypes_many?: Maybe<Array<Maybe<AuthRefreshTokenTypes_Mutation_Response_>>>;
  /** update multiples rows of table: "auth.refresh_tokens" */
  update_authRefreshTokens_many?: Maybe<Array<Maybe<AuthRefreshTokens_Mutation_Response_>>>;
  /** update multiples rows of table: "auth.roles" */
  update_authRoles_many?: Maybe<Array<Maybe<AuthRoles_Mutation_Response_>>>;
  /** update multiples rows of table: "auth.user_providers" */
  update_authUserProviders_many?: Maybe<Array<Maybe<AuthUserProviders_Mutation_Response_>>>;
  /** update multiples rows of table: "auth.user_roles" */
  update_authUserRoles_many?: Maybe<Array<Maybe<AuthUserRoles_Mutation_Response_>>>;
  /** update multiples rows of table: "auth.user_security_keys" */
  update_authUserSecurityKeys_many?: Maybe<Array<Maybe<AuthUserSecurityKeys_Mutation_Response_>>>;
  /** update multiples rows of table: "storage.buckets" */
  update_buckets_many?: Maybe<Array<Maybe<Buckets_Mutation_Response_>>>;
  /** update data of the table: "esrs.ActionReportingUnit" */
  update_esrs_ActionReportingUnit?: Maybe<Esrs_ActionReportingUnit_Mutation_Response_>;
  /** update single row of the table: "esrs.ActionReportingUnit" */
  update_esrs_ActionReportingUnit_by_pk?: Maybe<Esrs_ActionReportingUnit_>;
  /** update multiples rows of table: "esrs.ActionReportingUnit" */
  update_esrs_ActionReportingUnit_many?: Maybe<Array<Maybe<Esrs_ActionReportingUnit_Mutation_Response_>>>;
  /** update data of the table: "esrs.ActionSubsidiary" */
  update_esrs_ActionSubsidiary?: Maybe<Esrs_ActionSubsidiary_Mutation_Response_>;
  /** update single row of the table: "esrs.ActionSubsidiary" */
  update_esrs_ActionSubsidiary_by_pk?: Maybe<Esrs_ActionSubsidiary_>;
  /** update multiples rows of table: "esrs.ActionSubsidiary" */
  update_esrs_ActionSubsidiary_many?: Maybe<Array<Maybe<Esrs_ActionSubsidiary_Mutation_Response_>>>;
  /** update data of the table: "esrs.ActionTarget" */
  update_esrs_ActionTarget?: Maybe<Esrs_ActionTarget_Mutation_Response_>;
  /** update single row of the table: "esrs.ActionTarget" */
  update_esrs_ActionTarget_by_pk?: Maybe<Esrs_ActionTarget_>;
  /** update multiples rows of table: "esrs.ActionTarget" */
  update_esrs_ActionTarget_many?: Maybe<Array<Maybe<Esrs_ActionTarget_Mutation_Response_>>>;
  /** update data of the table: "esrs.Actions" */
  update_esrs_Actions?: Maybe<Esrs_Actions_Mutation_Response_>;
  /** update single row of the table: "esrs.Actions" */
  update_esrs_Actions_by_pk?: Maybe<Esrs_Actions_>;
  /** update multiples rows of table: "esrs.Actions" */
  update_esrs_Actions_many?: Maybe<Array<Maybe<Esrs_Actions_Mutation_Response_>>>;
  /** update data of the table: "esrs.Answer" */
  update_esrs_Answer?: Maybe<Esrs_Answer_Mutation_Response_>;
  /** update single row of the table: "esrs.Answer" */
  update_esrs_Answer_by_pk?: Maybe<Esrs_Answer_>;
  /** update multiples rows of table: "esrs.Answer" */
  update_esrs_Answer_many?: Maybe<Array<Maybe<Esrs_Answer_Mutation_Response_>>>;
  /** update data of the table: "esrs.AssessmentCurrencyConversion" */
  update_esrs_AssessmentCurrencyConversion?: Maybe<Esrs_AssessmentCurrencyConversion_Mutation_Response_>;
  /** update single row of the table: "esrs.AssessmentCurrencyConversion" */
  update_esrs_AssessmentCurrencyConversion_by_pk?: Maybe<Esrs_AssessmentCurrencyConversion_>;
  /** update multiples rows of table: "esrs.AssessmentCurrencyConversion" */
  update_esrs_AssessmentCurrencyConversion_many?: Maybe<Array<Maybe<Esrs_AssessmentCurrencyConversion_Mutation_Response_>>>;
  /** update data of the table: "esrs.Baseline" */
  update_esrs_Baseline?: Maybe<Esrs_Baseline_Mutation_Response_>;
  /** update single row of the table: "esrs.Baseline" */
  update_esrs_Baseline_by_pk?: Maybe<Esrs_Baseline_>;
  /** update multiples rows of table: "esrs.Baseline" */
  update_esrs_Baseline_many?: Maybe<Array<Maybe<Esrs_Baseline_Mutation_Response_>>>;
  /** update data of the table: "esrs.CompanyIntegration" */
  update_esrs_CompanyIntegration?: Maybe<Esrs_CompanyIntegration_Mutation_Response_>;
  /** update single row of the table: "esrs.CompanyIntegration" */
  update_esrs_CompanyIntegration_by_pk?: Maybe<Esrs_CompanyIntegration_>;
  /** update multiples rows of table: "esrs.CompanyIntegration" */
  update_esrs_CompanyIntegration_many?: Maybe<Array<Maybe<Esrs_CompanyIntegration_Mutation_Response_>>>;
  /** update data of the table: "esrs.Datapoint" */
  update_esrs_Datapoint?: Maybe<Esrs_Datapoint_Mutation_Response_>;
  /** update data of the table: "esrs.DatapointChoice" */
  update_esrs_DatapointChoice?: Maybe<Esrs_DatapointChoice_Mutation_Response_>;
  /** update single row of the table: "esrs.DatapointChoice" */
  update_esrs_DatapointChoice_by_pk?: Maybe<Esrs_DatapointChoice_>;
  /** update multiples rows of table: "esrs.DatapointChoice" */
  update_esrs_DatapointChoice_many?: Maybe<Array<Maybe<Esrs_DatapointChoice_Mutation_Response_>>>;
  /** update data of the table: "esrs.DatapointMdrm" */
  update_esrs_DatapointMdrm?: Maybe<Esrs_DatapointMdrm_Mutation_Response_>;
  /** update single row of the table: "esrs.DatapointMdrm" */
  update_esrs_DatapointMdrm_by_pk?: Maybe<Esrs_DatapointMdrm_>;
  /** update multiples rows of table: "esrs.DatapointMdrm" */
  update_esrs_DatapointMdrm_many?: Maybe<Array<Maybe<Esrs_DatapointMdrm_Mutation_Response_>>>;
  /** update data of the table: "esrs.DatapointTag" */
  update_esrs_DatapointTag?: Maybe<Esrs_DatapointTag_Mutation_Response_>;
  /** update single row of the table: "esrs.DatapointTag" */
  update_esrs_DatapointTag_by_pk?: Maybe<Esrs_DatapointTag_>;
  /** update multiples rows of table: "esrs.DatapointTag" */
  update_esrs_DatapointTag_many?: Maybe<Array<Maybe<Esrs_DatapointTag_Mutation_Response_>>>;
  /** update single row of the table: "esrs.Datapoint" */
  update_esrs_Datapoint_by_pk?: Maybe<Esrs_Datapoint_>;
  /** update multiples rows of table: "esrs.Datapoint" */
  update_esrs_Datapoint_many?: Maybe<Array<Maybe<Esrs_Datapoint_Mutation_Response_>>>;
  /** update data of the table: "esrs.Deprecated_ActionBusinessUnit" */
  update_esrs_Deprecated_ActionBusinessUnit?: Maybe<Esrs_Deprecated_ActionBusinessUnit_Mutation_Response_>;
  /** update single row of the table: "esrs.Deprecated_ActionBusinessUnit" */
  update_esrs_Deprecated_ActionBusinessUnit_by_pk?: Maybe<Esrs_Deprecated_ActionBusinessUnit_>;
  /** update multiples rows of table: "esrs.Deprecated_ActionBusinessUnit" */
  update_esrs_Deprecated_ActionBusinessUnit_many?: Maybe<Array<Maybe<Esrs_Deprecated_ActionBusinessUnit_Mutation_Response_>>>;
  /** update data of the table: "esrs.Deprecated_BusinessUnitEsrsAssessment" */
  update_esrs_Deprecated_BusinessUnitEsrsAssessment?: Maybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Mutation_Response_>;
  /** update single row of the table: "esrs.Deprecated_BusinessUnitEsrsAssessment" */
  update_esrs_Deprecated_BusinessUnitEsrsAssessment_by_pk?: Maybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_>;
  /** update multiples rows of table: "esrs.Deprecated_BusinessUnitEsrsAssessment" */
  update_esrs_Deprecated_BusinessUnitEsrsAssessment_many?: Maybe<Array<Maybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Mutation_Response_>>>;
  /** update data of the table: "esrs.Deprecated_CompanyMaterialityAssessment" */
  update_esrs_Deprecated_CompanyMaterialityAssessment?: Maybe<Esrs_Deprecated_CompanyMaterialityAssessment_Mutation_Response_>;
  /** update single row of the table: "esrs.Deprecated_CompanyMaterialityAssessment" */
  update_esrs_Deprecated_CompanyMaterialityAssessment_by_pk?: Maybe<Esrs_Deprecated_CompanyMaterialityAssessment_>;
  /** update multiples rows of table: "esrs.Deprecated_CompanyMaterialityAssessment" */
  update_esrs_Deprecated_CompanyMaterialityAssessment_many?: Maybe<Array<Maybe<Esrs_Deprecated_CompanyMaterialityAssessment_Mutation_Response_>>>;
  /** update data of the table: "esrs.Deprecated_EsrsMDRM" */
  update_esrs_Deprecated_EsrsMDRM?: Maybe<Esrs_Deprecated_EsrsMdrm_Mutation_Response_>;
  /** update single row of the table: "esrs.Deprecated_EsrsMDRM" */
  update_esrs_Deprecated_EsrsMDRM_by_pk?: Maybe<Esrs_Deprecated_EsrsMdrm_>;
  /** update multiples rows of table: "esrs.Deprecated_EsrsMDRM" */
  update_esrs_Deprecated_EsrsMDRM_many?: Maybe<Array<Maybe<Esrs_Deprecated_EsrsMdrm_Mutation_Response_>>>;
  /** update data of the table: "esrs.Deprecated_MaterialDisclosureRequirement" */
  update_esrs_Deprecated_MaterialDisclosureRequirement?: Maybe<Esrs_Deprecated_MaterialDisclosureRequirement_Mutation_Response_>;
  /** update single row of the table: "esrs.Deprecated_MaterialDisclosureRequirement" */
  update_esrs_Deprecated_MaterialDisclosureRequirement_by_pk?: Maybe<Esrs_Deprecated_MaterialDisclosureRequirement_>;
  /** update multiples rows of table: "esrs.Deprecated_MaterialDisclosureRequirement" */
  update_esrs_Deprecated_MaterialDisclosureRequirement_many?: Maybe<Array<Maybe<Esrs_Deprecated_MaterialDisclosureRequirement_Mutation_Response_>>>;
  /** update data of the table: "esrs.Deprecated_MetricAnswer" */
  update_esrs_Deprecated_MetricAnswer?: Maybe<Esrs_Deprecated_MetricAnswer_Mutation_Response_>;
  /** update single row of the table: "esrs.Deprecated_MetricAnswer" */
  update_esrs_Deprecated_MetricAnswer_by_pk?: Maybe<Esrs_Deprecated_MetricAnswer_>;
  /** update multiples rows of table: "esrs.Deprecated_MetricAnswer" */
  update_esrs_Deprecated_MetricAnswer_many?: Maybe<Array<Maybe<Esrs_Deprecated_MetricAnswer_Mutation_Response_>>>;
  /** update data of the table: "esrs.DisclosureRequirementAttachment" */
  update_esrs_DisclosureRequirementAttachment?: Maybe<Esrs_DisclosureRequirementAttachment_Mutation_Response_>;
  /** update single row of the table: "esrs.DisclosureRequirementAttachment" */
  update_esrs_DisclosureRequirementAttachment_by_pk?: Maybe<Esrs_DisclosureRequirementAttachment_>;
  /** update multiples rows of table: "esrs.DisclosureRequirementAttachment" */
  update_esrs_DisclosureRequirementAttachment_many?: Maybe<Array<Maybe<Esrs_DisclosureRequirementAttachment_Mutation_Response_>>>;
  /** update data of the table: "esrs.EsrsAssessmentCompanyIntegration" */
  update_esrs_EsrsAssessmentCompanyIntegration?: Maybe<Esrs_EsrsAssessmentCompanyIntegration_Mutation_Response_>;
  /** update data of the table: "esrs.EsrsAssessmentCompanyIntegrationRU" */
  update_esrs_EsrsAssessmentCompanyIntegrationRU?: Maybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Mutation_Response_>;
  /** update single row of the table: "esrs.EsrsAssessmentCompanyIntegrationRU" */
  update_esrs_EsrsAssessmentCompanyIntegrationRU_by_pk?: Maybe<Esrs_EsrsAssessmentCompanyIntegrationRu_>;
  /** update multiples rows of table: "esrs.EsrsAssessmentCompanyIntegrationRU" */
  update_esrs_EsrsAssessmentCompanyIntegrationRU_many?: Maybe<Array<Maybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Mutation_Response_>>>;
  /** update single row of the table: "esrs.EsrsAssessmentCompanyIntegration" */
  update_esrs_EsrsAssessmentCompanyIntegration_by_pk?: Maybe<Esrs_EsrsAssessmentCompanyIntegration_>;
  /** update multiples rows of table: "esrs.EsrsAssessmentCompanyIntegration" */
  update_esrs_EsrsAssessmentCompanyIntegration_many?: Maybe<Array<Maybe<Esrs_EsrsAssessmentCompanyIntegration_Mutation_Response_>>>;
  /** update data of the table: "esrs.MaterialMetric" */
  update_esrs_MaterialMetric?: Maybe<Esrs_MaterialMetric_Mutation_Response_>;
  /** update data of the table: "esrs.MaterialMetricTag" */
  update_esrs_MaterialMetricTag?: Maybe<Esrs_MaterialMetricTag_Mutation_Response_>;
  /** update single row of the table: "esrs.MaterialMetricTag" */
  update_esrs_MaterialMetricTag_by_pk?: Maybe<Esrs_MaterialMetricTag_>;
  /** update multiples rows of table: "esrs.MaterialMetricTag" */
  update_esrs_MaterialMetricTag_many?: Maybe<Array<Maybe<Esrs_MaterialMetricTag_Mutation_Response_>>>;
  /** update single row of the table: "esrs.MaterialMetric" */
  update_esrs_MaterialMetric_by_pk?: Maybe<Esrs_MaterialMetric_>;
  /** update multiples rows of table: "esrs.MaterialMetric" */
  update_esrs_MaterialMetric_many?: Maybe<Array<Maybe<Esrs_MaterialMetric_Mutation_Response_>>>;
  /** update data of the table: "esrs.MaterialStandard" */
  update_esrs_MaterialStandard?: Maybe<Esrs_MaterialStandard_Mutation_Response_>;
  /** update single row of the table: "esrs.MaterialStandard" */
  update_esrs_MaterialStandard_by_pk?: Maybe<Esrs_MaterialStandard_>;
  /** update multiples rows of table: "esrs.MaterialStandard" */
  update_esrs_MaterialStandard_many?: Maybe<Array<Maybe<Esrs_MaterialStandard_Mutation_Response_>>>;
  /** update data of the table: "esrs.MaterialTagValue" */
  update_esrs_MaterialTagValue?: Maybe<Esrs_MaterialTagValue_Mutation_Response_>;
  /** update single row of the table: "esrs.MaterialTagValue" */
  update_esrs_MaterialTagValue_by_pk?: Maybe<Esrs_MaterialTagValue_>;
  /** update multiples rows of table: "esrs.MaterialTagValue" */
  update_esrs_MaterialTagValue_many?: Maybe<Array<Maybe<Esrs_MaterialTagValue_Mutation_Response_>>>;
  /** update data of the table: "esrs.Milestone" */
  update_esrs_Milestone?: Maybe<Esrs_Milestone_Mutation_Response_>;
  /** update data of the table: "esrs.MilestoneResult" */
  update_esrs_MilestoneResult?: Maybe<Esrs_MilestoneResult_Mutation_Response_>;
  /** update single row of the table: "esrs.MilestoneResult" */
  update_esrs_MilestoneResult_by_pk?: Maybe<Esrs_MilestoneResult_>;
  /** update multiples rows of table: "esrs.MilestoneResult" */
  update_esrs_MilestoneResult_many?: Maybe<Array<Maybe<Esrs_MilestoneResult_Mutation_Response_>>>;
  /** update single row of the table: "esrs.Milestone" */
  update_esrs_Milestone_by_pk?: Maybe<Esrs_Milestone_>;
  /** update multiples rows of table: "esrs.Milestone" */
  update_esrs_Milestone_many?: Maybe<Array<Maybe<Esrs_Milestone_Mutation_Response_>>>;
  /** update data of the table: "esrs.Policy" */
  update_esrs_Policy?: Maybe<Esrs_Policy_Mutation_Response_>;
  /** update single row of the table: "esrs.Policy" */
  update_esrs_Policy_by_pk?: Maybe<Esrs_Policy_>;
  /** update multiples rows of table: "esrs.Policy" */
  update_esrs_Policy_many?: Maybe<Array<Maybe<Esrs_Policy_Mutation_Response_>>>;
  /** update data of the table: "esrs.ReportingUnit" */
  update_esrs_ReportingUnit?: Maybe<Esrs_ReportingUnit_Mutation_Response_>;
  /** update data of the table: "esrs.ReportingUnitLineage" */
  update_esrs_ReportingUnitLineage?: Maybe<Esrs_ReportingUnitLineage_Mutation_Response_>;
  /** update single row of the table: "esrs.ReportingUnitLineage" */
  update_esrs_ReportingUnitLineage_by_pk?: Maybe<Esrs_ReportingUnitLineage_>;
  /** update multiples rows of table: "esrs.ReportingUnitLineage" */
  update_esrs_ReportingUnitLineage_many?: Maybe<Array<Maybe<Esrs_ReportingUnitLineage_Mutation_Response_>>>;
  /** update single row of the table: "esrs.ReportingUnit" */
  update_esrs_ReportingUnit_by_pk?: Maybe<Esrs_ReportingUnit_>;
  /** update multiples rows of table: "esrs.ReportingUnit" */
  update_esrs_ReportingUnit_many?: Maybe<Array<Maybe<Esrs_ReportingUnit_Mutation_Response_>>>;
  /** update data of the table: "esrs.Target" */
  update_esrs_Target?: Maybe<Esrs_Target_Mutation_Response_>;
  /** update single row of the table: "esrs.Target" */
  update_esrs_Target_by_pk?: Maybe<Esrs_Target_>;
  /** update multiples rows of table: "esrs.Target" */
  update_esrs_Target_many?: Maybe<Array<Maybe<Esrs_Target_Mutation_Response_>>>;
  /** update multiples rows of table: "storage.files" */
  update_files_many?: Maybe<Array<Maybe<Files_Mutation_Response_>>>;
  /** update multiples rows of table: "auth.users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response_>>>;
  /** update multiples rows of table: "storage.virus" */
  update_virus_many?: Maybe<Array<Maybe<Virus_Mutation_Response_>>>;
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderArgs_ = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthProviderRequestsArgs_ = {
  where: AuthProviderRequests_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDeleteAuthProvidersArgs_ = {
  where: AuthProviders_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenTypeArgs_ = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokenTypesArgs_ = {
  where: AuthRefreshTokenTypes_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDeleteAuthRefreshTokensArgs_ = {
  where: AuthRefreshTokens_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDeleteAuthRoleArgs_ = {
  role: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthRolesArgs_ = {
  where: AuthRoles_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserProviderArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserProvidersArgs_ = {
  where: AuthUserProviders_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserRoleArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserRolesArgs_ = {
  where: AuthUserRoles_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeyArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteAuthUserSecurityKeysArgs_ = {
  where: AuthUserSecurityKeys_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDeleteBucketArgs_ = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBucketsArgs_ = {
  where: Buckets_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDeleteFileArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteFilesArgs_ = {
  where: Files_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDeleteUserArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUsersArgs_ = {
  where: Users_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDeleteVirusArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteVirusesArgs_ = {
  where: Virus_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_AiConfigArgs_ = {
  where: AiConfig_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_AiConfig_By_PkArgs_ = {
  companyId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ActionQuestionArgs_ = {
  where: ActionQuestion_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_ActionQuestionGroupArgs_ = {
  where: ActionQuestionGroup_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_ActionQuestionGroup_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ActionQuestion_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ActivityArgs_ = {
  where: Activity_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_ActivityNaceCodeArgs_ = {
  where: ActivityNaceCode_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_ActivityNaceCode_By_PkArgs_ = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ActivityQuestionSetArgs_ = {
  where: ActivityQuestionSet_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_ActivityQuestionSet_By_PkArgs_ = {
  activityRef: Scalars['String']['input'];
  questionSetRef: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ActivityReportArgs_ = {
  where: ActivityReport_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_ActivityReport_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ActivityVersionArgs_ = {
  where: ActivityVersion_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_ActivityVersion_By_PkArgs_ = {
  activityRef: Scalars['String']['input'];
  versionNumber: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Activity_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AdditionalTypeArgs_ = {
  where: AdditionalType_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_AdditionalType_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AnswerArgs_ = {
  where: Answer_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Answer_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AppConfigArgs_ = {
  where: AppConfig_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_AppConfig_By_PkArgs_ = {
  id: Scalars['Boolean']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ArticleArgs_ = {
  where: Article_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Article_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AttachmentArgs_ = {
  where: Attachment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_AttachmentBoxArgs_ = {
  where: AttachmentBox_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_AttachmentBox_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Attachment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_AuditLogEntryArgs_ = {
  where: AuditLogEntry_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_AuditLogEntry_By_PkArgs_ = {
  invocationId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BusinessUnitArgs_ = {
  where: BusinessUnit_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_BusinessUnitAssessmentArgs_ = {
  where: BusinessUnitAssessment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_BusinessUnitAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_BusinessUnit_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CachedResultArgs_ = {
  where: CachedResult_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_CachedResult_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ChoiceSetArgs_ = {
  where: ChoiceSet_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_ChoiceSet_By_PkArgs_ = {
  title: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CommentArgs_ = {
  where: Comment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Comment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CompanyArgs_ = {
  where: Company_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_CompanyAssessmentArgs_ = {
  where: CompanyAssessment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_CompanyAssessmentAggregateArgs_ = {
  where: CompanyAssessmentAggregate_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_CompanyAssessmentAggregate_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CompanyAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CompanyIdentityProviderArgs_ = {
  where: CompanyIdentityProvider_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_CompanyIdentityProvider_By_PkArgs_ = {
  companyId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CompanyInvitationArgs_ = {
  where: CompanyInvitation_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_CompanyInvitation_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CompanyUserArgs_ = {
  where: CompanyUser_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_CompanyUser_By_PkArgs_ = {
  companyId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Company_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_CompassPatArgs_ = {
  where: CompassPat_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_CompassPat_By_PkArgs_ = {
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DrToMfDisclosureRequirementArgs_ = {
  where: DrToMfDisclosureRequirement_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_DrToMfDisclosureRequirement_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DisclosureRequirementArgs_ = {
  where: DisclosureRequirement_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_DisclosureRequirementAdditionalTypeArgs_ = {
  where: DisclosureRequirementAdditionalType_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_DisclosureRequirementAdditionalType_By_PkArgs_ = {
  additionalTypeRef: Scalars['String']['input'];
  disclosureRequirementRef: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DisclosureRequirementGroupArgs_ = {
  where: DisclosureRequirementGroup_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_DisclosureRequirementGroup_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DisclosureRequirementOwnerArgs_ = {
  where: DisclosureRequirementOwner_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_DisclosureRequirementOwner_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DisclosureRequirementStatusArgs_ = {
  where: DisclosureRequirementStatus_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_DisclosureRequirementStatus_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DisclosureRequirement_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DocumentInsightArgs_ = {
  where: DocumentInsight_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_DocumentInsight_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_DocumentationFileArgs_ = {
  where: DocumentationFile_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_DocumentationFile_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EsrsAssessmentArgs_ = {
  where: EsrsAssessment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_EsrsAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EsrsCategoryArgs_ = {
  where: EsrsCategory_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_EsrsCategory_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EsrsChoiceArgs_ = {
  where: EsrsChoice_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_EsrsChoice_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EsrsMetricArgs_ = {
  where: EsrsMetric_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_EsrsMetricAdditionalTypeArgs_ = {
  where: EsrsMetricAdditionalType_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_EsrsMetricAdditionalType_By_PkArgs_ = {
  additionalTypeRef: Scalars['String']['input'];
  metricRef: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EsrsMetric_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EsrsStandardArgs_ = {
  where: EsrsStandard_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_EsrsStandardAdditionalTypeArgs_ = {
  where: EsrsStandardAdditionalType_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_EsrsStandardAdditionalType_By_PkArgs_ = {
  additionalTypeRef: Scalars['String']['input'];
  standardRef: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EsrsStandard_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_EstimateCompany_DeprecatedArgs_ = {
  where: EstimateCompany_Deprecated_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_EstimateCompany_Deprecated_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ExtractionJobArgs_ = {
  where: ExtractionJob_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_ExtractionJob_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FinancialsArgs_ = {
  where: Financials_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Financials_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_FrameworkArgs_ = {
  where: Framework_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Framework_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_GroupAssessmentArgs_ = {
  where: GroupAssessment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_GroupAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_IdentityProviderArgs_ = {
  where: IdentityProvider_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_IdentityProvider_By_PkArgs_ = {
  name: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_IndicatorToInvestorMetricArgs_ = {
  where: IndicatorToInvestorMetric_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_IndicatorToInvestorMetric_By_PkArgs_ = {
  indicatorRef: Scalars['String']['input'];
  investorMetricRef: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_InvesteeMetricArgs_ = {
  where: InvesteeMetric_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_InvesteeMetric_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_InvestmentCategoryArgs_ = {
  where: InvestmentCategory_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_InvestmentCategory_By_PkArgs_ = {
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_InvestorMetricArgs_ = {
  where: InvestorMetric_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_InvestorMetric_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_InvestorToInvesteeMetricArgs_ = {
  where: InvestorToInvesteeMetric_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_InvestorToInvesteeMetric_By_PkArgs_ = {
  investeeMetricReference: Scalars['String']['input'];
  investorMetricReference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MfCategoryArgs_ = {
  where: MfCategory_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_MfCategory_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MfDisclosureRequirementArgs_ = {
  where: MfDisclosureRequirement_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_MfDisclosureRequirementGroupArgs_ = {
  where: MfDisclosureRequirementGroup_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_MfDisclosureRequirementGroup_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MfDisclosureRequirementItemArgs_ = {
  where: MfDisclosureRequirementItem_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_MfDisclosureRequirementItem_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MfDisclosureRequirement_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MfStandardArgs_ = {
  where: MfStandard_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_MfStandardItemArgs_ = {
  where: MfStandardItem_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_MfStandardItem_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MfStandard_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MaterialStandardOwnerArgs_ = {
  where: MaterialStandardOwner_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_MaterialStandardOwner_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MetricDependencyArgs_ = {
  where: MetricDependency_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_MetricDependency_By_PkArgs_ = {
  childMetricRef: Scalars['String']['input'];
  parentMetricRef: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_MetricTagArgs_ = {
  where: MetricTag_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_MetricTag_By_PkArgs_ = {
  metricRef: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_NonMaterialFinancialsArgs_ = {
  where: NonMaterialFinancials_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_NoteArgs_ = {
  where: Note_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_NoteHistoryArgs_ = {
  where: NoteHistory_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_NoteHistory_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Note_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ObjectiveArgs_ = {
  where: Objective_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Objective_By_PkArgs_ = {
  key: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PaiAnswersArgs_ = {
  where: PaiAnswers_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_PaiAnswers_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PaiCategoryArgs_ = {
  where: PaiCategory_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_PaiCategory_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PaiCompanyReportArgs_ = {
  where: PaiCompanyReport_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_PaiCompanyReport_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PaiMetricInsightArgs_ = {
  where: PaiMetricInsight_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_PaiMetricInsight_By_PkArgs_ = {
  insightId: Scalars['uuid']['input'];
  investeeMetricRef: Scalars['String']['input'];
  reportId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PaiPortfolioReportArgs_ = {
  where: PaiPortfolioReport_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_PaiPortfolioReport_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PaiReportIndicatorArgs_ = {
  where: PaiReportIndicator_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_PaiReportIndicatorPortfolioCompanyArgs_ = {
  where: PaiReportIndicatorPortfolioCompany_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_PaiReportIndicatorPortfolioCompany_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PaiReportIndicator_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PaiTableArgs_ = {
  where: PaiTable_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_PaiTableIndicatorArgs_ = {
  where: PaiTableIndicator_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_PaiTableIndicator_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PaiTable_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PortfolioArgs_ = {
  where: Portfolio_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_PortfolioCompanyArgs_ = {
  where: PortfolioCompany_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_PortfolioCompany_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_PortfolioNonEligibleFinancialsArgs_ = {
  where: PortfolioNonEligibleFinancials_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_PortfolioNonEligibleFinancials_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Portfolio_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_QuarterEnumArgs_ = {
  where: QuarterEnum_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_QuarterEnum_By_PkArgs_ = {
  quarter: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_QuestionArgs_ = {
  where: Question_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_QuestionChoiceArgs_ = {
  where: QuestionChoice_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_QuestionChoice_By_PkArgs_ = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_QuestionLevelArgs_ = {
  where: QuestionLevel_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_QuestionLevel_By_PkArgs_ = {
  level: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_QuestionRevisionArgs_ = {
  where: QuestionRevision_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_QuestionRevision_By_PkArgs_ = {
  newQuestionId: Scalars['uuid']['input'];
  oldQuestionId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_QuestionSetArgs_ = {
  where: QuestionSet_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_QuestionSetQuestionArgs_ = {
  where: QuestionSetQuestion_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_QuestionSetQuestion_By_PkArgs_ = {
  questionId: Scalars['uuid']['input'];
  questionSetRef: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_QuestionSet_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_QuestionTypeArgs_ = {
  where: QuestionType_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_QuestionType_By_PkArgs_ = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Question_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ReportingGroupArgs_ = {
  where: ReportingGroup_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_ReportingGroup_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SectorArgs_ = {
  where: Sector_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Sector_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SharedSpaceArgs_ = {
  where: SharedSpace_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_SharedSpace_By_PkArgs_ = {
  companyId: Scalars['uuid']['input'];
  spaceId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SpaceArgs_ = {
  where: Space_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Space_By_PkArgs_ = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_SubsidiaryArgs_ = {
  where: Subsidiary_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Subsidiary_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TagArgs_ = {
  where: Tag_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_TagGroupArgs_ = {
  where: TagGroup_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_TagGroup_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TagTypeArgs_ = {
  where: TagType_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_TagType_By_PkArgs_ = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TagValueArgs_ = {
  where: TagValue_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_TagValue_By_PkArgs_ = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tag_ArticlesArgs_ = {
  where: Tag_Articles_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Tag_Articles_By_PkArgs_ = {
  id: Scalars['bigint']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Tag_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TargetQuestionArgs_ = {
  where: TargetQuestion_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_TargetQuestionGroupArgs_ = {
  where: TargetQuestionGroup_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_TargetQuestionGroup_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TargetQuestion_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TaskArgs_ = {
  where: Task_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_TaskStatusEnumArgs_ = {
  where: TaskStatusEnum_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_TaskStatusEnum_By_PkArgs_ = {
  status: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Task_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TaxonomyPortfolioReportArgs_ = {
  where: TaxonomyPortfolioReport_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_TaxonomyPortfolioReport_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_ThreadArgs_ = {
  where: Thread_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_ThreadSubscriberArgs_ = {
  where: ThreadSubscriber_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_ThreadSubscriber_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Thread_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_TotalComparisonFinancialsArgs_ = {
  where: TotalComparisonFinancials_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_TriggerTypesArgs_ = {
  where: TriggerTypes_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_TriggerTypes_By_PkArgs_ = {
  type: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserNotificationArgs_ = {
  where: UserNotification_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_UserNotification_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserRoleArgs_ = {
  where: UserRole_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_UserRole_By_PkArgs_ = {
  role: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_UserSessionMetadataArgs_ = {
  where: UserSessionMetadata_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_UserSessionMetadata_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_WebsocketTestArgs_ = {
  where: WebsocketTest_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_WebsocketTest_By_PkArgs_ = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_ActionReportingUnitArgs_ = {
  where: Esrs_ActionReportingUnit_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_ActionReportingUnit_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_ActionSubsidiaryArgs_ = {
  where: Esrs_ActionSubsidiary_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_ActionSubsidiary_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_ActionTargetArgs_ = {
  where: Esrs_ActionTarget_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_ActionTarget_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_ActionsArgs_ = {
  where: Esrs_Actions_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Actions_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_AnswerArgs_ = {
  where: Esrs_Answer_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Answer_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_AssessmentCurrencyConversionArgs_ = {
  where: Esrs_AssessmentCurrencyConversion_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_AssessmentCurrencyConversion_By_PkArgs_ = {
  assessmentId: Scalars['uuid']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_BaselineArgs_ = {
  where: Esrs_Baseline_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Baseline_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_CompanyIntegrationArgs_ = {
  where: Esrs_CompanyIntegration_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_CompanyIntegration_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_DatapointArgs_ = {
  where: Esrs_Datapoint_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_DatapointChoiceArgs_ = {
  where: Esrs_DatapointChoice_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_DatapointChoice_By_PkArgs_ = {
  choiceRef: Scalars['String']['input'];
  datapointId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_DatapointMdrmArgs_ = {
  where: Esrs_DatapointMdrm_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_DatapointMdrm_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_DatapointTagArgs_ = {
  where: Esrs_DatapointTag_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_DatapointTag_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Datapoint_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Deprecated_ActionBusinessUnitArgs_ = {
  where: Esrs_Deprecated_ActionBusinessUnit_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Deprecated_ActionBusinessUnit_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Deprecated_BusinessUnitEsrsAssessmentArgs_ = {
  where: Esrs_Deprecated_BusinessUnitEsrsAssessment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Deprecated_BusinessUnitEsrsAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Deprecated_CompanyMaterialityAssessmentArgs_ = {
  where: Esrs_Deprecated_CompanyMaterialityAssessment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Deprecated_CompanyMaterialityAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Deprecated_EsrsMdrmArgs_ = {
  where: Esrs_Deprecated_EsrsMdrm_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Deprecated_EsrsMdrm_By_PkArgs_ = {
  datapointId: Scalars['uuid']['input'];
  metricRef: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Deprecated_MaterialDisclosureRequirementArgs_ = {
  where: Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Deprecated_MaterialDisclosureRequirement_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Deprecated_MetricAnswerArgs_ = {
  where: Esrs_Deprecated_MetricAnswer_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Deprecated_MetricAnswer_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_DisclosureRequirementAttachmentArgs_ = {
  where: Esrs_DisclosureRequirementAttachment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_DisclosureRequirementAttachment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_EsrsAssessmentCompanyIntegrationArgs_ = {
  where: Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_EsrsAssessmentCompanyIntegrationRuArgs_ = {
  where: Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_EsrsAssessmentCompanyIntegrationRu_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_EsrsAssessmentCompanyIntegration_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_MaterialMetricArgs_ = {
  where: Esrs_MaterialMetric_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_MaterialMetricTagArgs_ = {
  where: Esrs_MaterialMetricTag_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_MaterialMetricTag_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_MaterialMetric_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_MaterialStandardArgs_ = {
  where: Esrs_MaterialStandard_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_MaterialStandard_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_MaterialTagValueArgs_ = {
  where: Esrs_MaterialTagValue_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_MaterialTagValue_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_MilestoneArgs_ = {
  where: Esrs_Milestone_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_MilestoneResultArgs_ = {
  where: Esrs_MilestoneResult_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_MilestoneResult_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Milestone_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_PolicyArgs_ = {
  where: Esrs_Policy_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Policy_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_ReportingUnitArgs_ = {
  where: Esrs_ReportingUnit_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_ReportingUnitLineageArgs_ = {
  where: Esrs_ReportingUnitLineage_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_ReportingUnitLineage_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_ReportingUnit_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDelete_Esrs_TargetArgs_ = {
  where: Esrs_Target_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootDelete_Esrs_Target_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsertAuthProviderArgs_ = {
  object: AuthProviders_Insert_Input_;
  on_conflict?: InputMaybe<AuthProviders_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderRequestArgs_ = {
  object: AuthProviderRequests_Insert_Input_;
  on_conflict?: InputMaybe<AuthProviderRequests_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertAuthProviderRequestsArgs_ = {
  objects: Array<AuthProviderRequests_Insert_Input_>;
  on_conflict?: InputMaybe<AuthProviderRequests_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertAuthProvidersArgs_ = {
  objects: Array<AuthProviders_Insert_Input_>;
  on_conflict?: InputMaybe<AuthProviders_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenArgs_ = {
  object: AuthRefreshTokens_Insert_Input_;
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenTypeArgs_ = {
  object: AuthRefreshTokenTypes_Insert_Input_;
  on_conflict?: InputMaybe<AuthRefreshTokenTypes_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokenTypesArgs_ = {
  objects: Array<AuthRefreshTokenTypes_Insert_Input_>;
  on_conflict?: InputMaybe<AuthRefreshTokenTypes_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertAuthRefreshTokensArgs_ = {
  objects: Array<AuthRefreshTokens_Insert_Input_>;
  on_conflict?: InputMaybe<AuthRefreshTokens_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertAuthRoleArgs_ = {
  object: AuthRoles_Insert_Input_;
  on_conflict?: InputMaybe<AuthRoles_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertAuthRolesArgs_ = {
  objects: Array<AuthRoles_Insert_Input_>;
  on_conflict?: InputMaybe<AuthRoles_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserProviderArgs_ = {
  object: AuthUserProviders_Insert_Input_;
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserProvidersArgs_ = {
  objects: Array<AuthUserProviders_Insert_Input_>;
  on_conflict?: InputMaybe<AuthUserProviders_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserRoleArgs_ = {
  object: AuthUserRoles_Insert_Input_;
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserRolesArgs_ = {
  objects: Array<AuthUserRoles_Insert_Input_>;
  on_conflict?: InputMaybe<AuthUserRoles_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeyArgs_ = {
  object: AuthUserSecurityKeys_Insert_Input_;
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertAuthUserSecurityKeysArgs_ = {
  objects: Array<AuthUserSecurityKeys_Insert_Input_>;
  on_conflict?: InputMaybe<AuthUserSecurityKeys_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertBucketArgs_ = {
  object: Buckets_Insert_Input_;
  on_conflict?: InputMaybe<Buckets_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertBucketsArgs_ = {
  objects: Array<Buckets_Insert_Input_>;
  on_conflict?: InputMaybe<Buckets_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertFileArgs_ = {
  object: Files_Insert_Input_;
  on_conflict?: InputMaybe<Files_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertFilesArgs_ = {
  objects: Array<Files_Insert_Input_>;
  on_conflict?: InputMaybe<Files_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertUserArgs_ = {
  object: Users_Insert_Input_;
  on_conflict?: InputMaybe<Users_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertUsersArgs_ = {
  objects: Array<Users_Insert_Input_>;
  on_conflict?: InputMaybe<Users_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertVirusArgs_ = {
  object: Virus_Insert_Input_;
  on_conflict?: InputMaybe<Virus_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsertVirusesArgs_ = {
  objects: Array<Virus_Insert_Input_>;
  on_conflict?: InputMaybe<Virus_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_AiConfigArgs_ = {
  objects: Array<AiConfig_Insert_Input_>;
  on_conflict?: InputMaybe<AiConfig_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_AiConfig_OneArgs_ = {
  object: AiConfig_Insert_Input_;
  on_conflict?: InputMaybe<AiConfig_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ActionQuestionArgs_ = {
  objects: Array<ActionQuestion_Insert_Input_>;
  on_conflict?: InputMaybe<ActionQuestion_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ActionQuestionGroupArgs_ = {
  objects: Array<ActionQuestionGroup_Insert_Input_>;
  on_conflict?: InputMaybe<ActionQuestionGroup_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ActionQuestionGroup_OneArgs_ = {
  object: ActionQuestionGroup_Insert_Input_;
  on_conflict?: InputMaybe<ActionQuestionGroup_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ActionQuestion_OneArgs_ = {
  object: ActionQuestion_Insert_Input_;
  on_conflict?: InputMaybe<ActionQuestion_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ActivityArgs_ = {
  objects: Array<Activity_Insert_Input_>;
  on_conflict?: InputMaybe<Activity_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ActivityNaceCodeArgs_ = {
  objects: Array<ActivityNaceCode_Insert_Input_>;
  on_conflict?: InputMaybe<ActivityNaceCode_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ActivityNaceCode_OneArgs_ = {
  object: ActivityNaceCode_Insert_Input_;
  on_conflict?: InputMaybe<ActivityNaceCode_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ActivityQuestionSetArgs_ = {
  objects: Array<ActivityQuestionSet_Insert_Input_>;
  on_conflict?: InputMaybe<ActivityQuestionSet_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ActivityQuestionSet_OneArgs_ = {
  object: ActivityQuestionSet_Insert_Input_;
  on_conflict?: InputMaybe<ActivityQuestionSet_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ActivityReportArgs_ = {
  objects: Array<ActivityReport_Insert_Input_>;
  on_conflict?: InputMaybe<ActivityReport_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ActivityReport_OneArgs_ = {
  object: ActivityReport_Insert_Input_;
  on_conflict?: InputMaybe<ActivityReport_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ActivityVersionArgs_ = {
  objects: Array<ActivityVersion_Insert_Input_>;
  on_conflict?: InputMaybe<ActivityVersion_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ActivityVersion_OneArgs_ = {
  object: ActivityVersion_Insert_Input_;
  on_conflict?: InputMaybe<ActivityVersion_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Activity_OneArgs_ = {
  object: Activity_Insert_Input_;
  on_conflict?: InputMaybe<Activity_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_AdditionalTypeArgs_ = {
  objects: Array<AdditionalType_Insert_Input_>;
  on_conflict?: InputMaybe<AdditionalType_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_AdditionalType_OneArgs_ = {
  object: AdditionalType_Insert_Input_;
  on_conflict?: InputMaybe<AdditionalType_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_AnswerArgs_ = {
  objects: Array<Answer_Insert_Input_>;
  on_conflict?: InputMaybe<Answer_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Answer_OneArgs_ = {
  object: Answer_Insert_Input_;
  on_conflict?: InputMaybe<Answer_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_AppConfigArgs_ = {
  objects: Array<AppConfig_Insert_Input_>;
  on_conflict?: InputMaybe<AppConfig_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_AppConfig_OneArgs_ = {
  object: AppConfig_Insert_Input_;
  on_conflict?: InputMaybe<AppConfig_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ArticleArgs_ = {
  objects: Array<Article_Insert_Input_>;
  on_conflict?: InputMaybe<Article_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Article_OneArgs_ = {
  object: Article_Insert_Input_;
  on_conflict?: InputMaybe<Article_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_AttachmentArgs_ = {
  objects: Array<Attachment_Insert_Input_>;
  on_conflict?: InputMaybe<Attachment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_AttachmentBoxArgs_ = {
  objects: Array<AttachmentBox_Insert_Input_>;
  on_conflict?: InputMaybe<AttachmentBox_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_AttachmentBox_OneArgs_ = {
  object: AttachmentBox_Insert_Input_;
  on_conflict?: InputMaybe<AttachmentBox_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Attachment_OneArgs_ = {
  object: Attachment_Insert_Input_;
  on_conflict?: InputMaybe<Attachment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_AuditLogEntryArgs_ = {
  objects: Array<AuditLogEntry_Insert_Input_>;
  on_conflict?: InputMaybe<AuditLogEntry_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_AuditLogEntry_OneArgs_ = {
  object: AuditLogEntry_Insert_Input_;
  on_conflict?: InputMaybe<AuditLogEntry_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_BusinessUnitArgs_ = {
  objects: Array<BusinessUnit_Insert_Input_>;
  on_conflict?: InputMaybe<BusinessUnit_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_BusinessUnitAssessmentArgs_ = {
  objects: Array<BusinessUnitAssessment_Insert_Input_>;
  on_conflict?: InputMaybe<BusinessUnitAssessment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_BusinessUnitAssessment_OneArgs_ = {
  object: BusinessUnitAssessment_Insert_Input_;
  on_conflict?: InputMaybe<BusinessUnitAssessment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_BusinessUnit_OneArgs_ = {
  object: BusinessUnit_Insert_Input_;
  on_conflict?: InputMaybe<BusinessUnit_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CachedResultArgs_ = {
  objects: Array<CachedResult_Insert_Input_>;
  on_conflict?: InputMaybe<CachedResult_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CachedResult_OneArgs_ = {
  object: CachedResult_Insert_Input_;
  on_conflict?: InputMaybe<CachedResult_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ChoiceSetArgs_ = {
  objects: Array<ChoiceSet_Insert_Input_>;
  on_conflict?: InputMaybe<ChoiceSet_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ChoiceSet_OneArgs_ = {
  object: ChoiceSet_Insert_Input_;
  on_conflict?: InputMaybe<ChoiceSet_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CommentArgs_ = {
  objects: Array<Comment_Insert_Input_>;
  on_conflict?: InputMaybe<Comment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Comment_OneArgs_ = {
  object: Comment_Insert_Input_;
  on_conflict?: InputMaybe<Comment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyArgs_ = {
  objects: Array<Company_Insert_Input_>;
  on_conflict?: InputMaybe<Company_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyAssessmentArgs_ = {
  objects: Array<CompanyAssessment_Insert_Input_>;
  on_conflict?: InputMaybe<CompanyAssessment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyAssessmentAggregateArgs_ = {
  objects: Array<CompanyAssessmentAggregate_Insert_Input_>;
  on_conflict?: InputMaybe<CompanyAssessmentAggregate_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyAssessmentAggregate_OneArgs_ = {
  object: CompanyAssessmentAggregate_Insert_Input_;
  on_conflict?: InputMaybe<CompanyAssessmentAggregate_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyAssessment_OneArgs_ = {
  object: CompanyAssessment_Insert_Input_;
  on_conflict?: InputMaybe<CompanyAssessment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyIdentityProviderArgs_ = {
  objects: Array<CompanyIdentityProvider_Insert_Input_>;
  on_conflict?: InputMaybe<CompanyIdentityProvider_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyIdentityProvider_OneArgs_ = {
  object: CompanyIdentityProvider_Insert_Input_;
  on_conflict?: InputMaybe<CompanyIdentityProvider_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyInvitationArgs_ = {
  objects: Array<CompanyInvitation_Insert_Input_>;
  on_conflict?: InputMaybe<CompanyInvitation_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyInvitation_OneArgs_ = {
  object: CompanyInvitation_Insert_Input_;
  on_conflict?: InputMaybe<CompanyInvitation_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyUserArgs_ = {
  objects: Array<CompanyUser_Insert_Input_>;
  on_conflict?: InputMaybe<CompanyUser_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CompanyUser_OneArgs_ = {
  object: CompanyUser_Insert_Input_;
  on_conflict?: InputMaybe<CompanyUser_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Company_OneArgs_ = {
  object: Company_Insert_Input_;
  on_conflict?: InputMaybe<Company_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CompassPatArgs_ = {
  objects: Array<CompassPat_Insert_Input_>;
  on_conflict?: InputMaybe<CompassPat_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_CompassPat_OneArgs_ = {
  object: CompassPat_Insert_Input_;
  on_conflict?: InputMaybe<CompassPat_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DrToMfDisclosureRequirementArgs_ = {
  objects: Array<DrToMfDisclosureRequirement_Insert_Input_>;
  on_conflict?: InputMaybe<DrToMfDisclosureRequirement_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DrToMfDisclosureRequirement_OneArgs_ = {
  object: DrToMfDisclosureRequirement_Insert_Input_;
  on_conflict?: InputMaybe<DrToMfDisclosureRequirement_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DisclosureRequirementArgs_ = {
  objects: Array<DisclosureRequirement_Insert_Input_>;
  on_conflict?: InputMaybe<DisclosureRequirement_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DisclosureRequirementAdditionalTypeArgs_ = {
  objects: Array<DisclosureRequirementAdditionalType_Insert_Input_>;
  on_conflict?: InputMaybe<DisclosureRequirementAdditionalType_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DisclosureRequirementAdditionalType_OneArgs_ = {
  object: DisclosureRequirementAdditionalType_Insert_Input_;
  on_conflict?: InputMaybe<DisclosureRequirementAdditionalType_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DisclosureRequirementGroupArgs_ = {
  objects: Array<DisclosureRequirementGroup_Insert_Input_>;
  on_conflict?: InputMaybe<DisclosureRequirementGroup_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DisclosureRequirementGroup_OneArgs_ = {
  object: DisclosureRequirementGroup_Insert_Input_;
  on_conflict?: InputMaybe<DisclosureRequirementGroup_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DisclosureRequirementOwnerArgs_ = {
  objects: Array<DisclosureRequirementOwner_Insert_Input_>;
  on_conflict?: InputMaybe<DisclosureRequirementOwner_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DisclosureRequirementOwner_OneArgs_ = {
  object: DisclosureRequirementOwner_Insert_Input_;
  on_conflict?: InputMaybe<DisclosureRequirementOwner_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DisclosureRequirementStatusArgs_ = {
  objects: Array<DisclosureRequirementStatus_Insert_Input_>;
  on_conflict?: InputMaybe<DisclosureRequirementStatus_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DisclosureRequirementStatus_OneArgs_ = {
  object: DisclosureRequirementStatus_Insert_Input_;
  on_conflict?: InputMaybe<DisclosureRequirementStatus_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DisclosureRequirement_OneArgs_ = {
  object: DisclosureRequirement_Insert_Input_;
  on_conflict?: InputMaybe<DisclosureRequirement_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DocumentInsightArgs_ = {
  objects: Array<DocumentInsight_Insert_Input_>;
  on_conflict?: InputMaybe<DocumentInsight_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DocumentInsight_OneArgs_ = {
  object: DocumentInsight_Insert_Input_;
  on_conflict?: InputMaybe<DocumentInsight_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DocumentationFileArgs_ = {
  objects: Array<DocumentationFile_Insert_Input_>;
  on_conflict?: InputMaybe<DocumentationFile_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_DocumentationFile_OneArgs_ = {
  object: DocumentationFile_Insert_Input_;
  on_conflict?: InputMaybe<DocumentationFile_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EsrsAssessmentArgs_ = {
  objects: Array<EsrsAssessment_Insert_Input_>;
  on_conflict?: InputMaybe<EsrsAssessment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EsrsAssessment_OneArgs_ = {
  object: EsrsAssessment_Insert_Input_;
  on_conflict?: InputMaybe<EsrsAssessment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EsrsCategoryArgs_ = {
  objects: Array<EsrsCategory_Insert_Input_>;
  on_conflict?: InputMaybe<EsrsCategory_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EsrsCategory_OneArgs_ = {
  object: EsrsCategory_Insert_Input_;
  on_conflict?: InputMaybe<EsrsCategory_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EsrsChoiceArgs_ = {
  objects: Array<EsrsChoice_Insert_Input_>;
  on_conflict?: InputMaybe<EsrsChoice_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EsrsChoice_OneArgs_ = {
  object: EsrsChoice_Insert_Input_;
  on_conflict?: InputMaybe<EsrsChoice_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EsrsMetricArgs_ = {
  objects: Array<EsrsMetric_Insert_Input_>;
  on_conflict?: InputMaybe<EsrsMetric_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EsrsMetricAdditionalTypeArgs_ = {
  objects: Array<EsrsMetricAdditionalType_Insert_Input_>;
  on_conflict?: InputMaybe<EsrsMetricAdditionalType_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EsrsMetricAdditionalType_OneArgs_ = {
  object: EsrsMetricAdditionalType_Insert_Input_;
  on_conflict?: InputMaybe<EsrsMetricAdditionalType_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EsrsMetric_OneArgs_ = {
  object: EsrsMetric_Insert_Input_;
  on_conflict?: InputMaybe<EsrsMetric_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EsrsStandardArgs_ = {
  objects: Array<EsrsStandard_Insert_Input_>;
  on_conflict?: InputMaybe<EsrsStandard_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EsrsStandardAdditionalTypeArgs_ = {
  objects: Array<EsrsStandardAdditionalType_Insert_Input_>;
  on_conflict?: InputMaybe<EsrsStandardAdditionalType_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EsrsStandardAdditionalType_OneArgs_ = {
  object: EsrsStandardAdditionalType_Insert_Input_;
  on_conflict?: InputMaybe<EsrsStandardAdditionalType_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EsrsStandard_OneArgs_ = {
  object: EsrsStandard_Insert_Input_;
  on_conflict?: InputMaybe<EsrsStandard_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EstimateCompany_DeprecatedArgs_ = {
  objects: Array<EstimateCompany_Deprecated_Insert_Input_>;
  on_conflict?: InputMaybe<EstimateCompany_Deprecated_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_EstimateCompany_Deprecated_OneArgs_ = {
  object: EstimateCompany_Deprecated_Insert_Input_;
  on_conflict?: InputMaybe<EstimateCompany_Deprecated_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ExtractionJobArgs_ = {
  objects: Array<ExtractionJob_Insert_Input_>;
  on_conflict?: InputMaybe<ExtractionJob_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ExtractionJob_OneArgs_ = {
  object: ExtractionJob_Insert_Input_;
  on_conflict?: InputMaybe<ExtractionJob_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_FinancialsArgs_ = {
  objects: Array<Financials_Insert_Input_>;
  on_conflict?: InputMaybe<Financials_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Financials_OneArgs_ = {
  object: Financials_Insert_Input_;
  on_conflict?: InputMaybe<Financials_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_FrameworkArgs_ = {
  objects: Array<Framework_Insert_Input_>;
  on_conflict?: InputMaybe<Framework_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Framework_OneArgs_ = {
  object: Framework_Insert_Input_;
  on_conflict?: InputMaybe<Framework_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_GroupAssessmentArgs_ = {
  objects: Array<GroupAssessment_Insert_Input_>;
  on_conflict?: InputMaybe<GroupAssessment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_GroupAssessment_OneArgs_ = {
  object: GroupAssessment_Insert_Input_;
  on_conflict?: InputMaybe<GroupAssessment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_IdentityProviderArgs_ = {
  objects: Array<IdentityProvider_Insert_Input_>;
  on_conflict?: InputMaybe<IdentityProvider_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_IdentityProvider_OneArgs_ = {
  object: IdentityProvider_Insert_Input_;
  on_conflict?: InputMaybe<IdentityProvider_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_IndicatorToInvestorMetricArgs_ = {
  objects: Array<IndicatorToInvestorMetric_Insert_Input_>;
  on_conflict?: InputMaybe<IndicatorToInvestorMetric_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_IndicatorToInvestorMetric_OneArgs_ = {
  object: IndicatorToInvestorMetric_Insert_Input_;
  on_conflict?: InputMaybe<IndicatorToInvestorMetric_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_InvesteeMetricArgs_ = {
  objects: Array<InvesteeMetric_Insert_Input_>;
  on_conflict?: InputMaybe<InvesteeMetric_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_InvesteeMetric_OneArgs_ = {
  object: InvesteeMetric_Insert_Input_;
  on_conflict?: InputMaybe<InvesteeMetric_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_InvestmentCategoryArgs_ = {
  objects: Array<InvestmentCategory_Insert_Input_>;
  on_conflict?: InputMaybe<InvestmentCategory_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_InvestmentCategory_OneArgs_ = {
  object: InvestmentCategory_Insert_Input_;
  on_conflict?: InputMaybe<InvestmentCategory_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_InvestorMetricArgs_ = {
  objects: Array<InvestorMetric_Insert_Input_>;
  on_conflict?: InputMaybe<InvestorMetric_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_InvestorMetric_OneArgs_ = {
  object: InvestorMetric_Insert_Input_;
  on_conflict?: InputMaybe<InvestorMetric_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_InvestorToInvesteeMetricArgs_ = {
  objects: Array<InvestorToInvesteeMetric_Insert_Input_>;
  on_conflict?: InputMaybe<InvestorToInvesteeMetric_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_InvestorToInvesteeMetric_OneArgs_ = {
  object: InvestorToInvesteeMetric_Insert_Input_;
  on_conflict?: InputMaybe<InvestorToInvesteeMetric_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MfCategoryArgs_ = {
  objects: Array<MfCategory_Insert_Input_>;
  on_conflict?: InputMaybe<MfCategory_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MfCategory_OneArgs_ = {
  object: MfCategory_Insert_Input_;
  on_conflict?: InputMaybe<MfCategory_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MfDisclosureRequirementArgs_ = {
  objects: Array<MfDisclosureRequirement_Insert_Input_>;
  on_conflict?: InputMaybe<MfDisclosureRequirement_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MfDisclosureRequirementGroupArgs_ = {
  objects: Array<MfDisclosureRequirementGroup_Insert_Input_>;
  on_conflict?: InputMaybe<MfDisclosureRequirementGroup_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MfDisclosureRequirementGroup_OneArgs_ = {
  object: MfDisclosureRequirementGroup_Insert_Input_;
  on_conflict?: InputMaybe<MfDisclosureRequirementGroup_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MfDisclosureRequirementItemArgs_ = {
  objects: Array<MfDisclosureRequirementItem_Insert_Input_>;
  on_conflict?: InputMaybe<MfDisclosureRequirementItem_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MfDisclosureRequirementItem_OneArgs_ = {
  object: MfDisclosureRequirementItem_Insert_Input_;
  on_conflict?: InputMaybe<MfDisclosureRequirementItem_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MfDisclosureRequirement_OneArgs_ = {
  object: MfDisclosureRequirement_Insert_Input_;
  on_conflict?: InputMaybe<MfDisclosureRequirement_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MfStandardArgs_ = {
  objects: Array<MfStandard_Insert_Input_>;
  on_conflict?: InputMaybe<MfStandard_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MfStandardItemArgs_ = {
  objects: Array<MfStandardItem_Insert_Input_>;
  on_conflict?: InputMaybe<MfStandardItem_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MfStandardItem_OneArgs_ = {
  object: MfStandardItem_Insert_Input_;
  on_conflict?: InputMaybe<MfStandardItem_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MfStandard_OneArgs_ = {
  object: MfStandard_Insert_Input_;
  on_conflict?: InputMaybe<MfStandard_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialStandardOwnerArgs_ = {
  objects: Array<MaterialStandardOwner_Insert_Input_>;
  on_conflict?: InputMaybe<MaterialStandardOwner_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MaterialStandardOwner_OneArgs_ = {
  object: MaterialStandardOwner_Insert_Input_;
  on_conflict?: InputMaybe<MaterialStandardOwner_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MetricDependencyArgs_ = {
  objects: Array<MetricDependency_Insert_Input_>;
  on_conflict?: InputMaybe<MetricDependency_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MetricDependency_OneArgs_ = {
  object: MetricDependency_Insert_Input_;
  on_conflict?: InputMaybe<MetricDependency_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MetricTagArgs_ = {
  objects: Array<MetricTag_Insert_Input_>;
  on_conflict?: InputMaybe<MetricTag_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_MetricTag_OneArgs_ = {
  object: MetricTag_Insert_Input_;
  on_conflict?: InputMaybe<MetricTag_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_NonMaterialFinancialsArgs_ = {
  objects: Array<NonMaterialFinancials_Insert_Input_>;
};


/** mutation root */
export type Mutation_RootInsert_NonMaterialFinancials_OneArgs_ = {
  object: NonMaterialFinancials_Insert_Input_;
};


/** mutation root */
export type Mutation_RootInsert_NoteArgs_ = {
  objects: Array<Note_Insert_Input_>;
  on_conflict?: InputMaybe<Note_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_NoteHistoryArgs_ = {
  objects: Array<NoteHistory_Insert_Input_>;
  on_conflict?: InputMaybe<NoteHistory_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_NoteHistory_OneArgs_ = {
  object: NoteHistory_Insert_Input_;
  on_conflict?: InputMaybe<NoteHistory_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Note_OneArgs_ = {
  object: Note_Insert_Input_;
  on_conflict?: InputMaybe<Note_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ObjectiveArgs_ = {
  objects: Array<Objective_Insert_Input_>;
  on_conflict?: InputMaybe<Objective_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Objective_OneArgs_ = {
  object: Objective_Insert_Input_;
  on_conflict?: InputMaybe<Objective_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiAnswersArgs_ = {
  objects: Array<PaiAnswers_Insert_Input_>;
  on_conflict?: InputMaybe<PaiAnswers_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiAnswers_OneArgs_ = {
  object: PaiAnswers_Insert_Input_;
  on_conflict?: InputMaybe<PaiAnswers_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiCategoryArgs_ = {
  objects: Array<PaiCategory_Insert_Input_>;
  on_conflict?: InputMaybe<PaiCategory_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiCategory_OneArgs_ = {
  object: PaiCategory_Insert_Input_;
  on_conflict?: InputMaybe<PaiCategory_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiCompanyReportArgs_ = {
  objects: Array<PaiCompanyReport_Insert_Input_>;
  on_conflict?: InputMaybe<PaiCompanyReport_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiCompanyReport_OneArgs_ = {
  object: PaiCompanyReport_Insert_Input_;
  on_conflict?: InputMaybe<PaiCompanyReport_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiMetricInsightArgs_ = {
  objects: Array<PaiMetricInsight_Insert_Input_>;
  on_conflict?: InputMaybe<PaiMetricInsight_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiMetricInsight_OneArgs_ = {
  object: PaiMetricInsight_Insert_Input_;
  on_conflict?: InputMaybe<PaiMetricInsight_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiPortfolioReportArgs_ = {
  objects: Array<PaiPortfolioReport_Insert_Input_>;
  on_conflict?: InputMaybe<PaiPortfolioReport_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiPortfolioReport_OneArgs_ = {
  object: PaiPortfolioReport_Insert_Input_;
  on_conflict?: InputMaybe<PaiPortfolioReport_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiReportIndicatorArgs_ = {
  objects: Array<PaiReportIndicator_Insert_Input_>;
  on_conflict?: InputMaybe<PaiReportIndicator_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiReportIndicatorPortfolioCompanyArgs_ = {
  objects: Array<PaiReportIndicatorPortfolioCompany_Insert_Input_>;
  on_conflict?: InputMaybe<PaiReportIndicatorPortfolioCompany_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiReportIndicatorPortfolioCompany_OneArgs_ = {
  object: PaiReportIndicatorPortfolioCompany_Insert_Input_;
  on_conflict?: InputMaybe<PaiReportIndicatorPortfolioCompany_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiReportIndicator_OneArgs_ = {
  object: PaiReportIndicator_Insert_Input_;
  on_conflict?: InputMaybe<PaiReportIndicator_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiTableArgs_ = {
  objects: Array<PaiTable_Insert_Input_>;
  on_conflict?: InputMaybe<PaiTable_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiTableIndicatorArgs_ = {
  objects: Array<PaiTableIndicator_Insert_Input_>;
  on_conflict?: InputMaybe<PaiTableIndicator_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiTableIndicator_OneArgs_ = {
  object: PaiTableIndicator_Insert_Input_;
  on_conflict?: InputMaybe<PaiTableIndicator_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PaiTable_OneArgs_ = {
  object: PaiTable_Insert_Input_;
  on_conflict?: InputMaybe<PaiTable_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PortfolioArgs_ = {
  objects: Array<Portfolio_Insert_Input_>;
  on_conflict?: InputMaybe<Portfolio_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PortfolioCompanyArgs_ = {
  objects: Array<PortfolioCompany_Insert_Input_>;
  on_conflict?: InputMaybe<PortfolioCompany_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PortfolioCompany_OneArgs_ = {
  object: PortfolioCompany_Insert_Input_;
  on_conflict?: InputMaybe<PortfolioCompany_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PortfolioNonEligibleFinancialsArgs_ = {
  objects: Array<PortfolioNonEligibleFinancials_Insert_Input_>;
  on_conflict?: InputMaybe<PortfolioNonEligibleFinancials_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_PortfolioNonEligibleFinancials_OneArgs_ = {
  object: PortfolioNonEligibleFinancials_Insert_Input_;
  on_conflict?: InputMaybe<PortfolioNonEligibleFinancials_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Portfolio_OneArgs_ = {
  object: Portfolio_Insert_Input_;
  on_conflict?: InputMaybe<Portfolio_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_QuarterEnumArgs_ = {
  objects: Array<QuarterEnum_Insert_Input_>;
  on_conflict?: InputMaybe<QuarterEnum_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_QuarterEnum_OneArgs_ = {
  object: QuarterEnum_Insert_Input_;
  on_conflict?: InputMaybe<QuarterEnum_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionArgs_ = {
  objects: Array<Question_Insert_Input_>;
  on_conflict?: InputMaybe<Question_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionChoiceArgs_ = {
  objects: Array<QuestionChoice_Insert_Input_>;
  on_conflict?: InputMaybe<QuestionChoice_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionChoice_OneArgs_ = {
  object: QuestionChoice_Insert_Input_;
  on_conflict?: InputMaybe<QuestionChoice_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionLevelArgs_ = {
  objects: Array<QuestionLevel_Insert_Input_>;
  on_conflict?: InputMaybe<QuestionLevel_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionLevel_OneArgs_ = {
  object: QuestionLevel_Insert_Input_;
  on_conflict?: InputMaybe<QuestionLevel_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionRevisionArgs_ = {
  objects: Array<QuestionRevision_Insert_Input_>;
  on_conflict?: InputMaybe<QuestionRevision_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionRevision_OneArgs_ = {
  object: QuestionRevision_Insert_Input_;
  on_conflict?: InputMaybe<QuestionRevision_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionSetArgs_ = {
  objects: Array<QuestionSet_Insert_Input_>;
  on_conflict?: InputMaybe<QuestionSet_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionSetQuestionArgs_ = {
  objects: Array<QuestionSetQuestion_Insert_Input_>;
  on_conflict?: InputMaybe<QuestionSetQuestion_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionSetQuestion_OneArgs_ = {
  object: QuestionSetQuestion_Insert_Input_;
  on_conflict?: InputMaybe<QuestionSetQuestion_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionSet_OneArgs_ = {
  object: QuestionSet_Insert_Input_;
  on_conflict?: InputMaybe<QuestionSet_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionTypeArgs_ = {
  objects: Array<QuestionType_Insert_Input_>;
  on_conflict?: InputMaybe<QuestionType_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_QuestionType_OneArgs_ = {
  object: QuestionType_Insert_Input_;
  on_conflict?: InputMaybe<QuestionType_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Question_OneArgs_ = {
  object: Question_Insert_Input_;
  on_conflict?: InputMaybe<Question_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ReportingGroupArgs_ = {
  objects: Array<ReportingGroup_Insert_Input_>;
  on_conflict?: InputMaybe<ReportingGroup_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ReportingGroup_OneArgs_ = {
  object: ReportingGroup_Insert_Input_;
  on_conflict?: InputMaybe<ReportingGroup_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_SectorArgs_ = {
  objects: Array<Sector_Insert_Input_>;
  on_conflict?: InputMaybe<Sector_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Sector_OneArgs_ = {
  object: Sector_Insert_Input_;
  on_conflict?: InputMaybe<Sector_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_SharedSpaceArgs_ = {
  objects: Array<SharedSpace_Insert_Input_>;
  on_conflict?: InputMaybe<SharedSpace_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_SharedSpace_OneArgs_ = {
  object: SharedSpace_Insert_Input_;
  on_conflict?: InputMaybe<SharedSpace_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_SpaceArgs_ = {
  objects: Array<Space_Insert_Input_>;
  on_conflict?: InputMaybe<Space_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Space_OneArgs_ = {
  object: Space_Insert_Input_;
  on_conflict?: InputMaybe<Space_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_SubsidiaryArgs_ = {
  objects: Array<Subsidiary_Insert_Input_>;
  on_conflict?: InputMaybe<Subsidiary_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Subsidiary_OneArgs_ = {
  object: Subsidiary_Insert_Input_;
  on_conflict?: InputMaybe<Subsidiary_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TagArgs_ = {
  objects: Array<Tag_Insert_Input_>;
  on_conflict?: InputMaybe<Tag_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TagGroupArgs_ = {
  objects: Array<TagGroup_Insert_Input_>;
  on_conflict?: InputMaybe<TagGroup_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TagGroup_OneArgs_ = {
  object: TagGroup_Insert_Input_;
  on_conflict?: InputMaybe<TagGroup_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TagTypeArgs_ = {
  objects: Array<TagType_Insert_Input_>;
  on_conflict?: InputMaybe<TagType_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TagType_OneArgs_ = {
  object: TagType_Insert_Input_;
  on_conflict?: InputMaybe<TagType_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TagValueArgs_ = {
  objects: Array<TagValue_Insert_Input_>;
  on_conflict?: InputMaybe<TagValue_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TagValue_OneArgs_ = {
  object: TagValue_Insert_Input_;
  on_conflict?: InputMaybe<TagValue_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_ArticlesArgs_ = {
  objects: Array<Tag_Articles_Insert_Input_>;
  on_conflict?: InputMaybe<Tag_Articles_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_Articles_OneArgs_ = {
  object: Tag_Articles_Insert_Input_;
  on_conflict?: InputMaybe<Tag_Articles_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Tag_OneArgs_ = {
  object: Tag_Insert_Input_;
  on_conflict?: InputMaybe<Tag_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TargetQuestionArgs_ = {
  objects: Array<TargetQuestion_Insert_Input_>;
  on_conflict?: InputMaybe<TargetQuestion_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TargetQuestionGroupArgs_ = {
  objects: Array<TargetQuestionGroup_Insert_Input_>;
  on_conflict?: InputMaybe<TargetQuestionGroup_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TargetQuestionGroup_OneArgs_ = {
  object: TargetQuestionGroup_Insert_Input_;
  on_conflict?: InputMaybe<TargetQuestionGroup_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TargetQuestion_OneArgs_ = {
  object: TargetQuestion_Insert_Input_;
  on_conflict?: InputMaybe<TargetQuestion_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TaskArgs_ = {
  objects: Array<Task_Insert_Input_>;
  on_conflict?: InputMaybe<Task_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TaskStatusEnumArgs_ = {
  objects: Array<TaskStatusEnum_Insert_Input_>;
  on_conflict?: InputMaybe<TaskStatusEnum_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TaskStatusEnum_OneArgs_ = {
  object: TaskStatusEnum_Insert_Input_;
  on_conflict?: InputMaybe<TaskStatusEnum_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Task_OneArgs_ = {
  object: Task_Insert_Input_;
  on_conflict?: InputMaybe<Task_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TaxonomyPortfolioReportArgs_ = {
  objects: Array<TaxonomyPortfolioReport_Insert_Input_>;
  on_conflict?: InputMaybe<TaxonomyPortfolioReport_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TaxonomyPortfolioReport_OneArgs_ = {
  object: TaxonomyPortfolioReport_Insert_Input_;
  on_conflict?: InputMaybe<TaxonomyPortfolioReport_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ThreadArgs_ = {
  objects: Array<Thread_Insert_Input_>;
  on_conflict?: InputMaybe<Thread_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ThreadSubscriberArgs_ = {
  objects: Array<ThreadSubscriber_Insert_Input_>;
  on_conflict?: InputMaybe<ThreadSubscriber_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_ThreadSubscriber_OneArgs_ = {
  object: ThreadSubscriber_Insert_Input_;
  on_conflict?: InputMaybe<ThreadSubscriber_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Thread_OneArgs_ = {
  object: Thread_Insert_Input_;
  on_conflict?: InputMaybe<Thread_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TotalComparisonFinancialsArgs_ = {
  objects: Array<TotalComparisonFinancials_Insert_Input_>;
};


/** mutation root */
export type Mutation_RootInsert_TotalComparisonFinancials_OneArgs_ = {
  object: TotalComparisonFinancials_Insert_Input_;
};


/** mutation root */
export type Mutation_RootInsert_TriggerTypesArgs_ = {
  objects: Array<TriggerTypes_Insert_Input_>;
  on_conflict?: InputMaybe<TriggerTypes_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_TriggerTypes_OneArgs_ = {
  object: TriggerTypes_Insert_Input_;
  on_conflict?: InputMaybe<TriggerTypes_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_UserNotificationArgs_ = {
  objects: Array<UserNotification_Insert_Input_>;
  on_conflict?: InputMaybe<UserNotification_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_UserNotification_OneArgs_ = {
  object: UserNotification_Insert_Input_;
  on_conflict?: InputMaybe<UserNotification_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_UserRoleArgs_ = {
  objects: Array<UserRole_Insert_Input_>;
  on_conflict?: InputMaybe<UserRole_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_UserRole_OneArgs_ = {
  object: UserRole_Insert_Input_;
  on_conflict?: InputMaybe<UserRole_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_UserSessionMetadataArgs_ = {
  objects: Array<UserSessionMetadata_Insert_Input_>;
  on_conflict?: InputMaybe<UserSessionMetadata_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_UserSessionMetadata_OneArgs_ = {
  object: UserSessionMetadata_Insert_Input_;
  on_conflict?: InputMaybe<UserSessionMetadata_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_WebsocketTestArgs_ = {
  objects: Array<WebsocketTest_Insert_Input_>;
  on_conflict?: InputMaybe<WebsocketTest_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_WebsocketTest_OneArgs_ = {
  object: WebsocketTest_Insert_Input_;
  on_conflict?: InputMaybe<WebsocketTest_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_ActionReportingUnitArgs_ = {
  objects: Array<Esrs_ActionReportingUnit_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_ActionReportingUnit_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_ActionReportingUnit_OneArgs_ = {
  object: Esrs_ActionReportingUnit_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_ActionReportingUnit_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_ActionSubsidiaryArgs_ = {
  objects: Array<Esrs_ActionSubsidiary_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_ActionSubsidiary_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_ActionSubsidiary_OneArgs_ = {
  object: Esrs_ActionSubsidiary_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_ActionSubsidiary_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_ActionTargetArgs_ = {
  objects: Array<Esrs_ActionTarget_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_ActionTarget_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_ActionTarget_OneArgs_ = {
  object: Esrs_ActionTarget_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_ActionTarget_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_ActionsArgs_ = {
  objects: Array<Esrs_Actions_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_Actions_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Actions_OneArgs_ = {
  object: Esrs_Actions_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_Actions_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_AnswerArgs_ = {
  objects: Array<Esrs_Answer_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_Answer_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Answer_OneArgs_ = {
  object: Esrs_Answer_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_Answer_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_AssessmentCurrencyConversionArgs_ = {
  objects: Array<Esrs_AssessmentCurrencyConversion_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_AssessmentCurrencyConversion_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_AssessmentCurrencyConversion_OneArgs_ = {
  object: Esrs_AssessmentCurrencyConversion_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_AssessmentCurrencyConversion_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_BaselineArgs_ = {
  objects: Array<Esrs_Baseline_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_Baseline_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Baseline_OneArgs_ = {
  object: Esrs_Baseline_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_Baseline_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_CompanyIntegrationArgs_ = {
  objects: Array<Esrs_CompanyIntegration_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_CompanyIntegration_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_CompanyIntegration_OneArgs_ = {
  object: Esrs_CompanyIntegration_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_CompanyIntegration_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_DatapointArgs_ = {
  objects: Array<Esrs_Datapoint_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_Datapoint_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_DatapointChoiceArgs_ = {
  objects: Array<Esrs_DatapointChoice_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_DatapointChoice_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_DatapointChoice_OneArgs_ = {
  object: Esrs_DatapointChoice_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_DatapointChoice_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_DatapointMdrmArgs_ = {
  objects: Array<Esrs_DatapointMdrm_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_DatapointMdrm_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_DatapointMdrm_OneArgs_ = {
  object: Esrs_DatapointMdrm_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_DatapointMdrm_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_DatapointTagArgs_ = {
  objects: Array<Esrs_DatapointTag_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_DatapointTag_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_DatapointTag_OneArgs_ = {
  object: Esrs_DatapointTag_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_DatapointTag_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Datapoint_OneArgs_ = {
  object: Esrs_Datapoint_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_Datapoint_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Deprecated_ActionBusinessUnitArgs_ = {
  objects: Array<Esrs_Deprecated_ActionBusinessUnit_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_Deprecated_ActionBusinessUnit_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Deprecated_ActionBusinessUnit_OneArgs_ = {
  object: Esrs_Deprecated_ActionBusinessUnit_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_Deprecated_ActionBusinessUnit_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Deprecated_BusinessUnitEsrsAssessmentArgs_ = {
  objects: Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Deprecated_BusinessUnitEsrsAssessment_OneArgs_ = {
  object: Esrs_Deprecated_BusinessUnitEsrsAssessment_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Deprecated_CompanyMaterialityAssessmentArgs_ = {
  objects: Array<Esrs_Deprecated_CompanyMaterialityAssessment_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_Deprecated_CompanyMaterialityAssessment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Deprecated_CompanyMaterialityAssessment_OneArgs_ = {
  object: Esrs_Deprecated_CompanyMaterialityAssessment_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_Deprecated_CompanyMaterialityAssessment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Deprecated_EsrsMdrmArgs_ = {
  objects: Array<Esrs_Deprecated_EsrsMdrm_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_Deprecated_EsrsMdrm_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Deprecated_EsrsMdrm_OneArgs_ = {
  object: Esrs_Deprecated_EsrsMdrm_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_Deprecated_EsrsMdrm_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Deprecated_MaterialDisclosureRequirementArgs_ = {
  objects: Array<Esrs_Deprecated_MaterialDisclosureRequirement_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Deprecated_MaterialDisclosureRequirement_OneArgs_ = {
  object: Esrs_Deprecated_MaterialDisclosureRequirement_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Deprecated_MetricAnswerArgs_ = {
  objects: Array<Esrs_Deprecated_MetricAnswer_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_Deprecated_MetricAnswer_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Deprecated_MetricAnswer_OneArgs_ = {
  object: Esrs_Deprecated_MetricAnswer_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_Deprecated_MetricAnswer_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_DisclosureRequirementAttachmentArgs_ = {
  objects: Array<Esrs_DisclosureRequirementAttachment_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_DisclosureRequirementAttachment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_DisclosureRequirementAttachment_OneArgs_ = {
  object: Esrs_DisclosureRequirementAttachment_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_DisclosureRequirementAttachment_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_EsrsAssessmentCompanyIntegrationArgs_ = {
  objects: Array<Esrs_EsrsAssessmentCompanyIntegration_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_EsrsAssessmentCompanyIntegrationRuArgs_ = {
  objects: Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_EsrsAssessmentCompanyIntegrationRu_OneArgs_ = {
  object: Esrs_EsrsAssessmentCompanyIntegrationRu_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_EsrsAssessmentCompanyIntegration_OneArgs_ = {
  object: Esrs_EsrsAssessmentCompanyIntegration_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_MaterialMetricArgs_ = {
  objects: Array<Esrs_MaterialMetric_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_MaterialMetric_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_MaterialMetricTagArgs_ = {
  objects: Array<Esrs_MaterialMetricTag_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_MaterialMetricTag_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_MaterialMetricTag_OneArgs_ = {
  object: Esrs_MaterialMetricTag_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_MaterialMetricTag_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_MaterialMetric_OneArgs_ = {
  object: Esrs_MaterialMetric_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_MaterialMetric_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_MaterialStandardArgs_ = {
  objects: Array<Esrs_MaterialStandard_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_MaterialStandard_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_MaterialStandard_OneArgs_ = {
  object: Esrs_MaterialStandard_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_MaterialStandard_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_MaterialTagValueArgs_ = {
  objects: Array<Esrs_MaterialTagValue_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_MaterialTagValue_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_MaterialTagValue_OneArgs_ = {
  object: Esrs_MaterialTagValue_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_MaterialTagValue_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_MilestoneArgs_ = {
  objects: Array<Esrs_Milestone_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_Milestone_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_MilestoneResultArgs_ = {
  objects: Array<Esrs_MilestoneResult_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_MilestoneResult_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_MilestoneResult_OneArgs_ = {
  object: Esrs_MilestoneResult_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_MilestoneResult_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Milestone_OneArgs_ = {
  object: Esrs_Milestone_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_Milestone_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_PolicyArgs_ = {
  objects: Array<Esrs_Policy_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_Policy_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Policy_OneArgs_ = {
  object: Esrs_Policy_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_Policy_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_ReportingUnitArgs_ = {
  objects: Array<Esrs_ReportingUnit_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_ReportingUnit_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_ReportingUnitLineageArgs_ = {
  objects: Array<Esrs_ReportingUnitLineage_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_ReportingUnitLineage_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_ReportingUnitLineage_OneArgs_ = {
  object: Esrs_ReportingUnitLineage_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_ReportingUnitLineage_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_ReportingUnit_OneArgs_ = {
  object: Esrs_ReportingUnit_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_ReportingUnit_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_TargetArgs_ = {
  objects: Array<Esrs_Target_Insert_Input_>;
  on_conflict?: InputMaybe<Esrs_Target_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootInsert_Esrs_Target_OneArgs_ = {
  object: Esrs_Target_Insert_Input_;
  on_conflict?: InputMaybe<Esrs_Target_On_Conflict_>;
};


/** mutation root */
export type Mutation_RootNudgeGroupCompaniesArgs_ = {
  data: NudgeGroupCompaniesInput_;
  recipients: Array<EmailItem_>;
};


/** mutation root */
export type Mutation_RootNudgePortfolioCompaniesArgs_ = {
  data: NudgePortfolioCompaniesInput_;
  recipients: Array<EmailItem_>;
};


/** mutation root */
export type Mutation_RootRequestQuoteArgs_ = {
  data: RequestQuoteInput_;
};


/** mutation root */
export type Mutation_RootUpdateActivityFinancialsArgs_ = {
  input?: InputMaybe<UpdateFinancialsInput_>;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderArgs_ = {
  _set?: InputMaybe<AuthProviders_Set_Input_>;
  pk_columns: AuthProviders_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestArgs_ = {
  _append?: InputMaybe<AuthProviderRequests_Append_Input_>;
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input_>;
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input_>;
  _set?: InputMaybe<AuthProviderRequests_Set_Input_>;
  pk_columns: AuthProviderRequests_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdateAuthProviderRequestsArgs_ = {
  _append?: InputMaybe<AuthProviderRequests_Append_Input_>;
  _delete_at_path?: InputMaybe<AuthProviderRequests_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<AuthProviderRequests_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<AuthProviderRequests_Delete_Key_Input_>;
  _prepend?: InputMaybe<AuthProviderRequests_Prepend_Input_>;
  _set?: InputMaybe<AuthProviderRequests_Set_Input_>;
  where: AuthProviderRequests_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdateAuthProvidersArgs_ = {
  _set?: InputMaybe<AuthProviders_Set_Input_>;
  where: AuthProviders_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenArgs_ = {
  _append?: InputMaybe<AuthRefreshTokens_Append_Input_>;
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input_>;
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input_>;
  _set?: InputMaybe<AuthRefreshTokens_Set_Input_>;
  pk_columns: AuthRefreshTokens_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenTypeArgs_ = {
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input_>;
  pk_columns: AuthRefreshTokenTypes_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokenTypesArgs_ = {
  _set?: InputMaybe<AuthRefreshTokenTypes_Set_Input_>;
  where: AuthRefreshTokenTypes_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdateAuthRefreshTokensArgs_ = {
  _append?: InputMaybe<AuthRefreshTokens_Append_Input_>;
  _delete_at_path?: InputMaybe<AuthRefreshTokens_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<AuthRefreshTokens_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<AuthRefreshTokens_Delete_Key_Input_>;
  _prepend?: InputMaybe<AuthRefreshTokens_Prepend_Input_>;
  _set?: InputMaybe<AuthRefreshTokens_Set_Input_>;
  where: AuthRefreshTokens_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdateAuthRoleArgs_ = {
  _set?: InputMaybe<AuthRoles_Set_Input_>;
  pk_columns: AuthRoles_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdateAuthRolesArgs_ = {
  _set?: InputMaybe<AuthRoles_Set_Input_>;
  where: AuthRoles_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserProviderArgs_ = {
  _set?: InputMaybe<AuthUserProviders_Set_Input_>;
  pk_columns: AuthUserProviders_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserProvidersArgs_ = {
  _set?: InputMaybe<AuthUserProviders_Set_Input_>;
  where: AuthUserProviders_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserRoleArgs_ = {
  _set?: InputMaybe<AuthUserRoles_Set_Input_>;
  pk_columns: AuthUserRoles_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserRolesArgs_ = {
  _set?: InputMaybe<AuthUserRoles_Set_Input_>;
  where: AuthUserRoles_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeyArgs_ = {
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input_>;
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input_>;
  pk_columns: AuthUserSecurityKeys_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdateAuthUserSecurityKeysArgs_ = {
  _inc?: InputMaybe<AuthUserSecurityKeys_Inc_Input_>;
  _set?: InputMaybe<AuthUserSecurityKeys_Set_Input_>;
  where: AuthUserSecurityKeys_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdateBucketArgs_ = {
  _inc?: InputMaybe<Buckets_Inc_Input_>;
  _set?: InputMaybe<Buckets_Set_Input_>;
  pk_columns: Buckets_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdateBucketsArgs_ = {
  _inc?: InputMaybe<Buckets_Inc_Input_>;
  _set?: InputMaybe<Buckets_Set_Input_>;
  where: Buckets_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdateFileArgs_ = {
  _append?: InputMaybe<Files_Append_Input_>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input_>;
  _inc?: InputMaybe<Files_Inc_Input_>;
  _prepend?: InputMaybe<Files_Prepend_Input_>;
  _set?: InputMaybe<Files_Set_Input_>;
  pk_columns: Files_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdateFilesArgs_ = {
  _append?: InputMaybe<Files_Append_Input_>;
  _delete_at_path?: InputMaybe<Files_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Files_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Files_Delete_Key_Input_>;
  _inc?: InputMaybe<Files_Inc_Input_>;
  _prepend?: InputMaybe<Files_Prepend_Input_>;
  _set?: InputMaybe<Files_Set_Input_>;
  where: Files_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdateUserArgs_ = {
  _append?: InputMaybe<Users_Append_Input_>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input_>;
  _prepend?: InputMaybe<Users_Prepend_Input_>;
  _set?: InputMaybe<Users_Set_Input_>;
  pk_columns: Users_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdateUsersArgs_ = {
  _append?: InputMaybe<Users_Append_Input_>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input_>;
  _prepend?: InputMaybe<Users_Prepend_Input_>;
  _set?: InputMaybe<Users_Set_Input_>;
  where: Users_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdateVirusArgs_ = {
  _append?: InputMaybe<Virus_Append_Input_>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input_>;
  _prepend?: InputMaybe<Virus_Prepend_Input_>;
  _set?: InputMaybe<Virus_Set_Input_>;
  pk_columns: Virus_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdateVirusesArgs_ = {
  _append?: InputMaybe<Virus_Append_Input_>;
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Virus_Delete_Key_Input_>;
  _prepend?: InputMaybe<Virus_Prepend_Input_>;
  _set?: InputMaybe<Virus_Set_Input_>;
  where: Virus_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_AiConfigArgs_ = {
  _set?: InputMaybe<AiConfig_Set_Input_>;
  where: AiConfig_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_AiConfig_By_PkArgs_ = {
  _set?: InputMaybe<AiConfig_Set_Input_>;
  pk_columns: AiConfig_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_AiConfig_ManyArgs_ = {
  updates: Array<AiConfig_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_ActionQuestionArgs_ = {
  _inc?: InputMaybe<ActionQuestion_Inc_Input_>;
  _set?: InputMaybe<ActionQuestion_Set_Input_>;
  where: ActionQuestion_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_ActionQuestionGroupArgs_ = {
  _set?: InputMaybe<ActionQuestionGroup_Set_Input_>;
  where: ActionQuestionGroup_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_ActionQuestionGroup_By_PkArgs_ = {
  _set?: InputMaybe<ActionQuestionGroup_Set_Input_>;
  pk_columns: ActionQuestionGroup_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_ActionQuestionGroup_ManyArgs_ = {
  updates: Array<ActionQuestionGroup_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_ActionQuestion_By_PkArgs_ = {
  _inc?: InputMaybe<ActionQuestion_Inc_Input_>;
  _set?: InputMaybe<ActionQuestion_Set_Input_>;
  pk_columns: ActionQuestion_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_ActionQuestion_ManyArgs_ = {
  updates: Array<ActionQuestion_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_ActivityArgs_ = {
  _inc?: InputMaybe<Activity_Inc_Input_>;
  _set?: InputMaybe<Activity_Set_Input_>;
  where: Activity_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_ActivityNaceCodeArgs_ = {
  _inc?: InputMaybe<ActivityNaceCode_Inc_Input_>;
  _set?: InputMaybe<ActivityNaceCode_Set_Input_>;
  where: ActivityNaceCode_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_ActivityNaceCode_By_PkArgs_ = {
  _inc?: InputMaybe<ActivityNaceCode_Inc_Input_>;
  _set?: InputMaybe<ActivityNaceCode_Set_Input_>;
  pk_columns: ActivityNaceCode_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_ActivityNaceCode_ManyArgs_ = {
  updates: Array<ActivityNaceCode_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_ActivityQuestionSetArgs_ = {
  _inc?: InputMaybe<ActivityQuestionSet_Inc_Input_>;
  _set?: InputMaybe<ActivityQuestionSet_Set_Input_>;
  where: ActivityQuestionSet_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_ActivityQuestionSet_By_PkArgs_ = {
  _inc?: InputMaybe<ActivityQuestionSet_Inc_Input_>;
  _set?: InputMaybe<ActivityQuestionSet_Set_Input_>;
  pk_columns: ActivityQuestionSet_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_ActivityQuestionSet_ManyArgs_ = {
  updates: Array<ActivityQuestionSet_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_ActivityReportArgs_ = {
  _append?: InputMaybe<ActivityReport_Append_Input_>;
  _delete_at_path?: InputMaybe<ActivityReport_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<ActivityReport_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<ActivityReport_Delete_Key_Input_>;
  _inc?: InputMaybe<ActivityReport_Inc_Input_>;
  _prepend?: InputMaybe<ActivityReport_Prepend_Input_>;
  _set?: InputMaybe<ActivityReport_Set_Input_>;
  where: ActivityReport_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_ActivityReport_By_PkArgs_ = {
  _append?: InputMaybe<ActivityReport_Append_Input_>;
  _delete_at_path?: InputMaybe<ActivityReport_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<ActivityReport_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<ActivityReport_Delete_Key_Input_>;
  _inc?: InputMaybe<ActivityReport_Inc_Input_>;
  _prepend?: InputMaybe<ActivityReport_Prepend_Input_>;
  _set?: InputMaybe<ActivityReport_Set_Input_>;
  pk_columns: ActivityReport_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_ActivityReport_ManyArgs_ = {
  updates: Array<ActivityReport_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_ActivityVersionArgs_ = {
  _inc?: InputMaybe<ActivityVersion_Inc_Input_>;
  _set?: InputMaybe<ActivityVersion_Set_Input_>;
  where: ActivityVersion_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_ActivityVersion_By_PkArgs_ = {
  _inc?: InputMaybe<ActivityVersion_Inc_Input_>;
  _set?: InputMaybe<ActivityVersion_Set_Input_>;
  pk_columns: ActivityVersion_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_ActivityVersion_ManyArgs_ = {
  updates: Array<ActivityVersion_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_By_PkArgs_ = {
  _inc?: InputMaybe<Activity_Inc_Input_>;
  _set?: InputMaybe<Activity_Set_Input_>;
  pk_columns: Activity_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Activity_ManyArgs_ = {
  updates: Array<Activity_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_AdditionalTypeArgs_ = {
  _set?: InputMaybe<AdditionalType_Set_Input_>;
  where: AdditionalType_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_AdditionalType_By_PkArgs_ = {
  _set?: InputMaybe<AdditionalType_Set_Input_>;
  pk_columns: AdditionalType_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_AdditionalType_ManyArgs_ = {
  updates: Array<AdditionalType_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_AnswerArgs_ = {
  _append?: InputMaybe<Answer_Append_Input_>;
  _delete_at_path?: InputMaybe<Answer_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Answer_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Answer_Delete_Key_Input_>;
  _prepend?: InputMaybe<Answer_Prepend_Input_>;
  _set?: InputMaybe<Answer_Set_Input_>;
  where: Answer_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Answer_By_PkArgs_ = {
  _append?: InputMaybe<Answer_Append_Input_>;
  _delete_at_path?: InputMaybe<Answer_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Answer_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Answer_Delete_Key_Input_>;
  _prepend?: InputMaybe<Answer_Prepend_Input_>;
  _set?: InputMaybe<Answer_Set_Input_>;
  pk_columns: Answer_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Answer_ManyArgs_ = {
  updates: Array<Answer_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_AppConfigArgs_ = {
  _set?: InputMaybe<AppConfig_Set_Input_>;
  where: AppConfig_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_AppConfig_By_PkArgs_ = {
  _set?: InputMaybe<AppConfig_Set_Input_>;
  pk_columns: AppConfig_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_AppConfig_ManyArgs_ = {
  updates: Array<AppConfig_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_ArticleArgs_ = {
  _set?: InputMaybe<Article_Set_Input_>;
  where: Article_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Article_By_PkArgs_ = {
  _set?: InputMaybe<Article_Set_Input_>;
  pk_columns: Article_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Article_ManyArgs_ = {
  updates: Array<Article_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_AttachmentArgs_ = {
  _set?: InputMaybe<Attachment_Set_Input_>;
  where: Attachment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_AttachmentBoxArgs_ = {
  _set?: InputMaybe<AttachmentBox_Set_Input_>;
  where: AttachmentBox_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_AttachmentBox_By_PkArgs_ = {
  _set?: InputMaybe<AttachmentBox_Set_Input_>;
  pk_columns: AttachmentBox_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_AttachmentBox_ManyArgs_ = {
  updates: Array<AttachmentBox_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Attachment_By_PkArgs_ = {
  _set?: InputMaybe<Attachment_Set_Input_>;
  pk_columns: Attachment_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Attachment_ManyArgs_ = {
  updates: Array<Attachment_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_AuditLogEntryArgs_ = {
  _append?: InputMaybe<AuditLogEntry_Append_Input_>;
  _delete_at_path?: InputMaybe<AuditLogEntry_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<AuditLogEntry_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<AuditLogEntry_Delete_Key_Input_>;
  _prepend?: InputMaybe<AuditLogEntry_Prepend_Input_>;
  _set?: InputMaybe<AuditLogEntry_Set_Input_>;
  where: AuditLogEntry_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_AuditLogEntry_By_PkArgs_ = {
  _append?: InputMaybe<AuditLogEntry_Append_Input_>;
  _delete_at_path?: InputMaybe<AuditLogEntry_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<AuditLogEntry_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<AuditLogEntry_Delete_Key_Input_>;
  _prepend?: InputMaybe<AuditLogEntry_Prepend_Input_>;
  _set?: InputMaybe<AuditLogEntry_Set_Input_>;
  pk_columns: AuditLogEntry_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_AuditLogEntry_ManyArgs_ = {
  updates: Array<AuditLogEntry_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_BusinessUnitArgs_ = {
  _append?: InputMaybe<BusinessUnit_Append_Input_>;
  _delete_at_path?: InputMaybe<BusinessUnit_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<BusinessUnit_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<BusinessUnit_Delete_Key_Input_>;
  _prepend?: InputMaybe<BusinessUnit_Prepend_Input_>;
  _set?: InputMaybe<BusinessUnit_Set_Input_>;
  where: BusinessUnit_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_BusinessUnitAssessmentArgs_ = {
  _inc?: InputMaybe<BusinessUnitAssessment_Inc_Input_>;
  _set?: InputMaybe<BusinessUnitAssessment_Set_Input_>;
  where: BusinessUnitAssessment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_BusinessUnitAssessment_By_PkArgs_ = {
  _inc?: InputMaybe<BusinessUnitAssessment_Inc_Input_>;
  _set?: InputMaybe<BusinessUnitAssessment_Set_Input_>;
  pk_columns: BusinessUnitAssessment_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_BusinessUnitAssessment_ManyArgs_ = {
  updates: Array<BusinessUnitAssessment_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_BusinessUnit_By_PkArgs_ = {
  _append?: InputMaybe<BusinessUnit_Append_Input_>;
  _delete_at_path?: InputMaybe<BusinessUnit_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<BusinessUnit_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<BusinessUnit_Delete_Key_Input_>;
  _prepend?: InputMaybe<BusinessUnit_Prepend_Input_>;
  _set?: InputMaybe<BusinessUnit_Set_Input_>;
  pk_columns: BusinessUnit_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_BusinessUnit_ManyArgs_ = {
  updates: Array<BusinessUnit_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_CachedResultArgs_ = {
  _append?: InputMaybe<CachedResult_Append_Input_>;
  _delete_at_path?: InputMaybe<CachedResult_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<CachedResult_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<CachedResult_Delete_Key_Input_>;
  _inc?: InputMaybe<CachedResult_Inc_Input_>;
  _prepend?: InputMaybe<CachedResult_Prepend_Input_>;
  _set?: InputMaybe<CachedResult_Set_Input_>;
  where: CachedResult_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_CachedResult_By_PkArgs_ = {
  _append?: InputMaybe<CachedResult_Append_Input_>;
  _delete_at_path?: InputMaybe<CachedResult_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<CachedResult_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<CachedResult_Delete_Key_Input_>;
  _inc?: InputMaybe<CachedResult_Inc_Input_>;
  _prepend?: InputMaybe<CachedResult_Prepend_Input_>;
  _set?: InputMaybe<CachedResult_Set_Input_>;
  pk_columns: CachedResult_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_CachedResult_ManyArgs_ = {
  updates: Array<CachedResult_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_ChoiceSetArgs_ = {
  _set?: InputMaybe<ChoiceSet_Set_Input_>;
  where: ChoiceSet_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_ChoiceSet_By_PkArgs_ = {
  _set?: InputMaybe<ChoiceSet_Set_Input_>;
  pk_columns: ChoiceSet_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_ChoiceSet_ManyArgs_ = {
  updates: Array<ChoiceSet_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_CommentArgs_ = {
  _set?: InputMaybe<Comment_Set_Input_>;
  where: Comment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Comment_By_PkArgs_ = {
  _set?: InputMaybe<Comment_Set_Input_>;
  pk_columns: Comment_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Comment_ManyArgs_ = {
  updates: Array<Comment_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyArgs_ = {
  _append?: InputMaybe<Company_Append_Input_>;
  _delete_at_path?: InputMaybe<Company_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Company_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Company_Delete_Key_Input_>;
  _prepend?: InputMaybe<Company_Prepend_Input_>;
  _set?: InputMaybe<Company_Set_Input_>;
  where: Company_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyAssessmentArgs_ = {
  _set?: InputMaybe<CompanyAssessment_Set_Input_>;
  where: CompanyAssessment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyAssessmentAggregateArgs_ = {
  _set?: InputMaybe<CompanyAssessmentAggregate_Set_Input_>;
  where: CompanyAssessmentAggregate_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyAssessmentAggregate_By_PkArgs_ = {
  _set?: InputMaybe<CompanyAssessmentAggregate_Set_Input_>;
  pk_columns: CompanyAssessmentAggregate_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyAssessmentAggregate_ManyArgs_ = {
  updates: Array<CompanyAssessmentAggregate_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyAssessment_By_PkArgs_ = {
  _set?: InputMaybe<CompanyAssessment_Set_Input_>;
  pk_columns: CompanyAssessment_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyAssessment_ManyArgs_ = {
  updates: Array<CompanyAssessment_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyIdentityProviderArgs_ = {
  _set?: InputMaybe<CompanyIdentityProvider_Set_Input_>;
  where: CompanyIdentityProvider_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyIdentityProvider_By_PkArgs_ = {
  _set?: InputMaybe<CompanyIdentityProvider_Set_Input_>;
  pk_columns: CompanyIdentityProvider_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyIdentityProvider_ManyArgs_ = {
  updates: Array<CompanyIdentityProvider_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyInvitationArgs_ = {
  _set?: InputMaybe<CompanyInvitation_Set_Input_>;
  where: CompanyInvitation_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyInvitation_By_PkArgs_ = {
  _set?: InputMaybe<CompanyInvitation_Set_Input_>;
  pk_columns: CompanyInvitation_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyInvitation_ManyArgs_ = {
  updates: Array<CompanyInvitation_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyUserArgs_ = {
  _inc?: InputMaybe<CompanyUser_Inc_Input_>;
  _set?: InputMaybe<CompanyUser_Set_Input_>;
  where: CompanyUser_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyUser_By_PkArgs_ = {
  _inc?: InputMaybe<CompanyUser_Inc_Input_>;
  _set?: InputMaybe<CompanyUser_Set_Input_>;
  pk_columns: CompanyUser_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_CompanyUser_ManyArgs_ = {
  updates: Array<CompanyUser_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Company_By_PkArgs_ = {
  _append?: InputMaybe<Company_Append_Input_>;
  _delete_at_path?: InputMaybe<Company_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Company_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Company_Delete_Key_Input_>;
  _prepend?: InputMaybe<Company_Prepend_Input_>;
  _set?: InputMaybe<Company_Set_Input_>;
  pk_columns: Company_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Company_ManyArgs_ = {
  updates: Array<Company_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_CompassPatArgs_ = {
  _set?: InputMaybe<CompassPat_Set_Input_>;
  where: CompassPat_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_CompassPat_By_PkArgs_ = {
  _set?: InputMaybe<CompassPat_Set_Input_>;
  pk_columns: CompassPat_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_CompassPat_ManyArgs_ = {
  updates: Array<CompassPat_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_DrToMfDisclosureRequirementArgs_ = {
  _set?: InputMaybe<DrToMfDisclosureRequirement_Set_Input_>;
  where: DrToMfDisclosureRequirement_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_DrToMfDisclosureRequirement_By_PkArgs_ = {
  _set?: InputMaybe<DrToMfDisclosureRequirement_Set_Input_>;
  pk_columns: DrToMfDisclosureRequirement_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_DrToMfDisclosureRequirement_ManyArgs_ = {
  updates: Array<DrToMfDisclosureRequirement_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_DisclosureRequirementArgs_ = {
  _inc?: InputMaybe<DisclosureRequirement_Inc_Input_>;
  _set?: InputMaybe<DisclosureRequirement_Set_Input_>;
  where: DisclosureRequirement_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_DisclosureRequirementAdditionalTypeArgs_ = {
  _set?: InputMaybe<DisclosureRequirementAdditionalType_Set_Input_>;
  where: DisclosureRequirementAdditionalType_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_DisclosureRequirementAdditionalType_By_PkArgs_ = {
  _set?: InputMaybe<DisclosureRequirementAdditionalType_Set_Input_>;
  pk_columns: DisclosureRequirementAdditionalType_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_DisclosureRequirementAdditionalType_ManyArgs_ = {
  updates: Array<DisclosureRequirementAdditionalType_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_DisclosureRequirementGroupArgs_ = {
  _inc?: InputMaybe<DisclosureRequirementGroup_Inc_Input_>;
  _set?: InputMaybe<DisclosureRequirementGroup_Set_Input_>;
  where: DisclosureRequirementGroup_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_DisclosureRequirementGroup_By_PkArgs_ = {
  _inc?: InputMaybe<DisclosureRequirementGroup_Inc_Input_>;
  _set?: InputMaybe<DisclosureRequirementGroup_Set_Input_>;
  pk_columns: DisclosureRequirementGroup_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_DisclosureRequirementGroup_ManyArgs_ = {
  updates: Array<DisclosureRequirementGroup_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_DisclosureRequirementOwnerArgs_ = {
  _set?: InputMaybe<DisclosureRequirementOwner_Set_Input_>;
  where: DisclosureRequirementOwner_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_DisclosureRequirementOwner_By_PkArgs_ = {
  _set?: InputMaybe<DisclosureRequirementOwner_Set_Input_>;
  pk_columns: DisclosureRequirementOwner_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_DisclosureRequirementOwner_ManyArgs_ = {
  updates: Array<DisclosureRequirementOwner_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_DisclosureRequirementStatusArgs_ = {
  _set?: InputMaybe<DisclosureRequirementStatus_Set_Input_>;
  where: DisclosureRequirementStatus_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_DisclosureRequirementStatus_By_PkArgs_ = {
  _set?: InputMaybe<DisclosureRequirementStatus_Set_Input_>;
  pk_columns: DisclosureRequirementStatus_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_DisclosureRequirementStatus_ManyArgs_ = {
  updates: Array<DisclosureRequirementStatus_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_DisclosureRequirement_By_PkArgs_ = {
  _inc?: InputMaybe<DisclosureRequirement_Inc_Input_>;
  _set?: InputMaybe<DisclosureRequirement_Set_Input_>;
  pk_columns: DisclosureRequirement_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_DisclosureRequirement_ManyArgs_ = {
  updates: Array<DisclosureRequirement_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentInsightArgs_ = {
  _append?: InputMaybe<DocumentInsight_Append_Input_>;
  _delete_at_path?: InputMaybe<DocumentInsight_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<DocumentInsight_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<DocumentInsight_Delete_Key_Input_>;
  _prepend?: InputMaybe<DocumentInsight_Prepend_Input_>;
  _set?: InputMaybe<DocumentInsight_Set_Input_>;
  where: DocumentInsight_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentInsight_By_PkArgs_ = {
  _append?: InputMaybe<DocumentInsight_Append_Input_>;
  _delete_at_path?: InputMaybe<DocumentInsight_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<DocumentInsight_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<DocumentInsight_Delete_Key_Input_>;
  _prepend?: InputMaybe<DocumentInsight_Prepend_Input_>;
  _set?: InputMaybe<DocumentInsight_Set_Input_>;
  pk_columns: DocumentInsight_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentInsight_ManyArgs_ = {
  updates: Array<DocumentInsight_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentationFileArgs_ = {
  _append?: InputMaybe<DocumentationFile_Append_Input_>;
  _delete_at_path?: InputMaybe<DocumentationFile_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<DocumentationFile_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<DocumentationFile_Delete_Key_Input_>;
  _prepend?: InputMaybe<DocumentationFile_Prepend_Input_>;
  _set?: InputMaybe<DocumentationFile_Set_Input_>;
  where: DocumentationFile_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentationFile_By_PkArgs_ = {
  _append?: InputMaybe<DocumentationFile_Append_Input_>;
  _delete_at_path?: InputMaybe<DocumentationFile_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<DocumentationFile_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<DocumentationFile_Delete_Key_Input_>;
  _prepend?: InputMaybe<DocumentationFile_Prepend_Input_>;
  _set?: InputMaybe<DocumentationFile_Set_Input_>;
  pk_columns: DocumentationFile_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_DocumentationFile_ManyArgs_ = {
  updates: Array<DocumentationFile_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsAssessmentArgs_ = {
  _append?: InputMaybe<EsrsAssessment_Append_Input_>;
  _delete_at_path?: InputMaybe<EsrsAssessment_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<EsrsAssessment_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<EsrsAssessment_Delete_Key_Input_>;
  _inc?: InputMaybe<EsrsAssessment_Inc_Input_>;
  _prepend?: InputMaybe<EsrsAssessment_Prepend_Input_>;
  _set?: InputMaybe<EsrsAssessment_Set_Input_>;
  where: EsrsAssessment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsAssessment_By_PkArgs_ = {
  _append?: InputMaybe<EsrsAssessment_Append_Input_>;
  _delete_at_path?: InputMaybe<EsrsAssessment_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<EsrsAssessment_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<EsrsAssessment_Delete_Key_Input_>;
  _inc?: InputMaybe<EsrsAssessment_Inc_Input_>;
  _prepend?: InputMaybe<EsrsAssessment_Prepend_Input_>;
  _set?: InputMaybe<EsrsAssessment_Set_Input_>;
  pk_columns: EsrsAssessment_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsAssessment_ManyArgs_ = {
  updates: Array<EsrsAssessment_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsCategoryArgs_ = {
  _set?: InputMaybe<EsrsCategory_Set_Input_>;
  where: EsrsCategory_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsCategory_By_PkArgs_ = {
  _set?: InputMaybe<EsrsCategory_Set_Input_>;
  pk_columns: EsrsCategory_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsCategory_ManyArgs_ = {
  updates: Array<EsrsCategory_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsChoiceArgs_ = {
  _inc?: InputMaybe<EsrsChoice_Inc_Input_>;
  _set?: InputMaybe<EsrsChoice_Set_Input_>;
  where: EsrsChoice_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsChoice_By_PkArgs_ = {
  _inc?: InputMaybe<EsrsChoice_Inc_Input_>;
  _set?: InputMaybe<EsrsChoice_Set_Input_>;
  pk_columns: EsrsChoice_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsChoice_ManyArgs_ = {
  updates: Array<EsrsChoice_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsMetricArgs_ = {
  _inc?: InputMaybe<EsrsMetric_Inc_Input_>;
  _set?: InputMaybe<EsrsMetric_Set_Input_>;
  where: EsrsMetric_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsMetricAdditionalTypeArgs_ = {
  _set?: InputMaybe<EsrsMetricAdditionalType_Set_Input_>;
  where: EsrsMetricAdditionalType_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsMetricAdditionalType_By_PkArgs_ = {
  _set?: InputMaybe<EsrsMetricAdditionalType_Set_Input_>;
  pk_columns: EsrsMetricAdditionalType_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsMetricAdditionalType_ManyArgs_ = {
  updates: Array<EsrsMetricAdditionalType_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsMetric_By_PkArgs_ = {
  _inc?: InputMaybe<EsrsMetric_Inc_Input_>;
  _set?: InputMaybe<EsrsMetric_Set_Input_>;
  pk_columns: EsrsMetric_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsMetric_ManyArgs_ = {
  updates: Array<EsrsMetric_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsStandardArgs_ = {
  _inc?: InputMaybe<EsrsStandard_Inc_Input_>;
  _set?: InputMaybe<EsrsStandard_Set_Input_>;
  where: EsrsStandard_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsStandardAdditionalTypeArgs_ = {
  _set?: InputMaybe<EsrsStandardAdditionalType_Set_Input_>;
  where: EsrsStandardAdditionalType_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsStandardAdditionalType_By_PkArgs_ = {
  _set?: InputMaybe<EsrsStandardAdditionalType_Set_Input_>;
  pk_columns: EsrsStandardAdditionalType_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsStandardAdditionalType_ManyArgs_ = {
  updates: Array<EsrsStandardAdditionalType_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsStandard_By_PkArgs_ = {
  _inc?: InputMaybe<EsrsStandard_Inc_Input_>;
  _set?: InputMaybe<EsrsStandard_Set_Input_>;
  pk_columns: EsrsStandard_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_EsrsStandard_ManyArgs_ = {
  updates: Array<EsrsStandard_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_EstimateCompany_DeprecatedArgs_ = {
  _append?: InputMaybe<EstimateCompany_Deprecated_Append_Input_>;
  _delete_at_path?: InputMaybe<EstimateCompany_Deprecated_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<EstimateCompany_Deprecated_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<EstimateCompany_Deprecated_Delete_Key_Input_>;
  _prepend?: InputMaybe<EstimateCompany_Deprecated_Prepend_Input_>;
  _set?: InputMaybe<EstimateCompany_Deprecated_Set_Input_>;
  where: EstimateCompany_Deprecated_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_EstimateCompany_Deprecated_By_PkArgs_ = {
  _append?: InputMaybe<EstimateCompany_Deprecated_Append_Input_>;
  _delete_at_path?: InputMaybe<EstimateCompany_Deprecated_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<EstimateCompany_Deprecated_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<EstimateCompany_Deprecated_Delete_Key_Input_>;
  _prepend?: InputMaybe<EstimateCompany_Deprecated_Prepend_Input_>;
  _set?: InputMaybe<EstimateCompany_Deprecated_Set_Input_>;
  pk_columns: EstimateCompany_Deprecated_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_EstimateCompany_Deprecated_ManyArgs_ = {
  updates: Array<EstimateCompany_Deprecated_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_ExtractionJobArgs_ = {
  _append?: InputMaybe<ExtractionJob_Append_Input_>;
  _delete_at_path?: InputMaybe<ExtractionJob_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<ExtractionJob_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<ExtractionJob_Delete_Key_Input_>;
  _inc?: InputMaybe<ExtractionJob_Inc_Input_>;
  _prepend?: InputMaybe<ExtractionJob_Prepend_Input_>;
  _set?: InputMaybe<ExtractionJob_Set_Input_>;
  where: ExtractionJob_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_ExtractionJob_By_PkArgs_ = {
  _append?: InputMaybe<ExtractionJob_Append_Input_>;
  _delete_at_path?: InputMaybe<ExtractionJob_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<ExtractionJob_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<ExtractionJob_Delete_Key_Input_>;
  _inc?: InputMaybe<ExtractionJob_Inc_Input_>;
  _prepend?: InputMaybe<ExtractionJob_Prepend_Input_>;
  _set?: InputMaybe<ExtractionJob_Set_Input_>;
  pk_columns: ExtractionJob_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_ExtractionJob_ManyArgs_ = {
  updates: Array<ExtractionJob_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_FinancialsArgs_ = {
  _inc?: InputMaybe<Financials_Inc_Input_>;
  _set?: InputMaybe<Financials_Set_Input_>;
  where: Financials_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Financials_By_PkArgs_ = {
  _inc?: InputMaybe<Financials_Inc_Input_>;
  _set?: InputMaybe<Financials_Set_Input_>;
  pk_columns: Financials_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Financials_ManyArgs_ = {
  updates: Array<Financials_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_FrameworkArgs_ = {
  _set?: InputMaybe<Framework_Set_Input_>;
  where: Framework_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Framework_By_PkArgs_ = {
  _set?: InputMaybe<Framework_Set_Input_>;
  pk_columns: Framework_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Framework_ManyArgs_ = {
  updates: Array<Framework_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_GroupAssessmentArgs_ = {
  _set?: InputMaybe<GroupAssessment_Set_Input_>;
  where: GroupAssessment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_GroupAssessment_By_PkArgs_ = {
  _set?: InputMaybe<GroupAssessment_Set_Input_>;
  pk_columns: GroupAssessment_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_GroupAssessment_ManyArgs_ = {
  updates: Array<GroupAssessment_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_IdentityProviderArgs_ = {
  _set?: InputMaybe<IdentityProvider_Set_Input_>;
  where: IdentityProvider_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_IdentityProvider_By_PkArgs_ = {
  _set?: InputMaybe<IdentityProvider_Set_Input_>;
  pk_columns: IdentityProvider_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_IdentityProvider_ManyArgs_ = {
  updates: Array<IdentityProvider_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorToInvestorMetricArgs_ = {
  _set?: InputMaybe<IndicatorToInvestorMetric_Set_Input_>;
  where: IndicatorToInvestorMetric_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorToInvestorMetric_By_PkArgs_ = {
  _set?: InputMaybe<IndicatorToInvestorMetric_Set_Input_>;
  pk_columns: IndicatorToInvestorMetric_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_IndicatorToInvestorMetric_ManyArgs_ = {
  updates: Array<IndicatorToInvestorMetric_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_InvesteeMetricArgs_ = {
  _append?: InputMaybe<InvesteeMetric_Append_Input_>;
  _delete_at_path?: InputMaybe<InvesteeMetric_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<InvesteeMetric_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<InvesteeMetric_Delete_Key_Input_>;
  _inc?: InputMaybe<InvesteeMetric_Inc_Input_>;
  _prepend?: InputMaybe<InvesteeMetric_Prepend_Input_>;
  _set?: InputMaybe<InvesteeMetric_Set_Input_>;
  where: InvesteeMetric_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_InvesteeMetric_By_PkArgs_ = {
  _append?: InputMaybe<InvesteeMetric_Append_Input_>;
  _delete_at_path?: InputMaybe<InvesteeMetric_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<InvesteeMetric_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<InvesteeMetric_Delete_Key_Input_>;
  _inc?: InputMaybe<InvesteeMetric_Inc_Input_>;
  _prepend?: InputMaybe<InvesteeMetric_Prepend_Input_>;
  _set?: InputMaybe<InvesteeMetric_Set_Input_>;
  pk_columns: InvesteeMetric_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_InvesteeMetric_ManyArgs_ = {
  updates: Array<InvesteeMetric_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_InvestmentCategoryArgs_ = {
  _set?: InputMaybe<InvestmentCategory_Set_Input_>;
  where: InvestmentCategory_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_InvestmentCategory_By_PkArgs_ = {
  _set?: InputMaybe<InvestmentCategory_Set_Input_>;
  pk_columns: InvestmentCategory_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_InvestmentCategory_ManyArgs_ = {
  updates: Array<InvestmentCategory_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_InvestorMetricArgs_ = {
  _set?: InputMaybe<InvestorMetric_Set_Input_>;
  where: InvestorMetric_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_InvestorMetric_By_PkArgs_ = {
  _set?: InputMaybe<InvestorMetric_Set_Input_>;
  pk_columns: InvestorMetric_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_InvestorMetric_ManyArgs_ = {
  updates: Array<InvestorMetric_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_InvestorToInvesteeMetricArgs_ = {
  _set?: InputMaybe<InvestorToInvesteeMetric_Set_Input_>;
  where: InvestorToInvesteeMetric_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_InvestorToInvesteeMetric_By_PkArgs_ = {
  _set?: InputMaybe<InvestorToInvesteeMetric_Set_Input_>;
  pk_columns: InvestorToInvesteeMetric_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_InvestorToInvesteeMetric_ManyArgs_ = {
  updates: Array<InvestorToInvesteeMetric_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_MfCategoryArgs_ = {
  _inc?: InputMaybe<MfCategory_Inc_Input_>;
  _set?: InputMaybe<MfCategory_Set_Input_>;
  where: MfCategory_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_MfCategory_By_PkArgs_ = {
  _inc?: InputMaybe<MfCategory_Inc_Input_>;
  _set?: InputMaybe<MfCategory_Set_Input_>;
  pk_columns: MfCategory_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_MfCategory_ManyArgs_ = {
  updates: Array<MfCategory_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_MfDisclosureRequirementArgs_ = {
  _inc?: InputMaybe<MfDisclosureRequirement_Inc_Input_>;
  _set?: InputMaybe<MfDisclosureRequirement_Set_Input_>;
  where: MfDisclosureRequirement_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_MfDisclosureRequirementGroupArgs_ = {
  _inc?: InputMaybe<MfDisclosureRequirementGroup_Inc_Input_>;
  _set?: InputMaybe<MfDisclosureRequirementGroup_Set_Input_>;
  where: MfDisclosureRequirementGroup_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_MfDisclosureRequirementGroup_By_PkArgs_ = {
  _inc?: InputMaybe<MfDisclosureRequirementGroup_Inc_Input_>;
  _set?: InputMaybe<MfDisclosureRequirementGroup_Set_Input_>;
  pk_columns: MfDisclosureRequirementGroup_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_MfDisclosureRequirementGroup_ManyArgs_ = {
  updates: Array<MfDisclosureRequirementGroup_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_MfDisclosureRequirementItemArgs_ = {
  _inc?: InputMaybe<MfDisclosureRequirementItem_Inc_Input_>;
  _set?: InputMaybe<MfDisclosureRequirementItem_Set_Input_>;
  where: MfDisclosureRequirementItem_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_MfDisclosureRequirementItem_By_PkArgs_ = {
  _inc?: InputMaybe<MfDisclosureRequirementItem_Inc_Input_>;
  _set?: InputMaybe<MfDisclosureRequirementItem_Set_Input_>;
  pk_columns: MfDisclosureRequirementItem_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_MfDisclosureRequirementItem_ManyArgs_ = {
  updates: Array<MfDisclosureRequirementItem_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_MfDisclosureRequirement_By_PkArgs_ = {
  _inc?: InputMaybe<MfDisclosureRequirement_Inc_Input_>;
  _set?: InputMaybe<MfDisclosureRequirement_Set_Input_>;
  pk_columns: MfDisclosureRequirement_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_MfDisclosureRequirement_ManyArgs_ = {
  updates: Array<MfDisclosureRequirement_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_MfStandardArgs_ = {
  _inc?: InputMaybe<MfStandard_Inc_Input_>;
  _set?: InputMaybe<MfStandard_Set_Input_>;
  where: MfStandard_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_MfStandardItemArgs_ = {
  _inc?: InputMaybe<MfStandardItem_Inc_Input_>;
  _set?: InputMaybe<MfStandardItem_Set_Input_>;
  where: MfStandardItem_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_MfStandardItem_By_PkArgs_ = {
  _inc?: InputMaybe<MfStandardItem_Inc_Input_>;
  _set?: InputMaybe<MfStandardItem_Set_Input_>;
  pk_columns: MfStandardItem_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_MfStandardItem_ManyArgs_ = {
  updates: Array<MfStandardItem_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_MfStandard_By_PkArgs_ = {
  _inc?: InputMaybe<MfStandard_Inc_Input_>;
  _set?: InputMaybe<MfStandard_Set_Input_>;
  pk_columns: MfStandard_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_MfStandard_ManyArgs_ = {
  updates: Array<MfStandard_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialStandardOwnerArgs_ = {
  _set?: InputMaybe<MaterialStandardOwner_Set_Input_>;
  where: MaterialStandardOwner_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialStandardOwner_By_PkArgs_ = {
  _set?: InputMaybe<MaterialStandardOwner_Set_Input_>;
  pk_columns: MaterialStandardOwner_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_MaterialStandardOwner_ManyArgs_ = {
  updates: Array<MaterialStandardOwner_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_MetricDependencyArgs_ = {
  _inc?: InputMaybe<MetricDependency_Inc_Input_>;
  _set?: InputMaybe<MetricDependency_Set_Input_>;
  where: MetricDependency_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_MetricDependency_By_PkArgs_ = {
  _inc?: InputMaybe<MetricDependency_Inc_Input_>;
  _set?: InputMaybe<MetricDependency_Set_Input_>;
  pk_columns: MetricDependency_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_MetricDependency_ManyArgs_ = {
  updates: Array<MetricDependency_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_MetricTagArgs_ = {
  _set?: InputMaybe<MetricTag_Set_Input_>;
  where: MetricTag_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_MetricTag_By_PkArgs_ = {
  _set?: InputMaybe<MetricTag_Set_Input_>;
  pk_columns: MetricTag_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_MetricTag_ManyArgs_ = {
  updates: Array<MetricTag_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_NonMaterialFinancialsArgs_ = {
  _inc?: InputMaybe<NonMaterialFinancials_Inc_Input_>;
  _set?: InputMaybe<NonMaterialFinancials_Set_Input_>;
  where: NonMaterialFinancials_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_NonMaterialFinancials_ManyArgs_ = {
  updates: Array<NonMaterialFinancials_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_NoteArgs_ = {
  _set?: InputMaybe<Note_Set_Input_>;
  where: Note_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_NoteHistoryArgs_ = {
  _set?: InputMaybe<NoteHistory_Set_Input_>;
  where: NoteHistory_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_NoteHistory_By_PkArgs_ = {
  _set?: InputMaybe<NoteHistory_Set_Input_>;
  pk_columns: NoteHistory_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_NoteHistory_ManyArgs_ = {
  updates: Array<NoteHistory_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Note_By_PkArgs_ = {
  _set?: InputMaybe<Note_Set_Input_>;
  pk_columns: Note_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Note_ManyArgs_ = {
  updates: Array<Note_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_ObjectiveArgs_ = {
  _set?: InputMaybe<Objective_Set_Input_>;
  where: Objective_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Objective_By_PkArgs_ = {
  _set?: InputMaybe<Objective_Set_Input_>;
  pk_columns: Objective_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Objective_ManyArgs_ = {
  updates: Array<Objective_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_PaiAnswersArgs_ = {
  _set?: InputMaybe<PaiAnswers_Set_Input_>;
  where: PaiAnswers_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiAnswers_By_PkArgs_ = {
  _set?: InputMaybe<PaiAnswers_Set_Input_>;
  pk_columns: PaiAnswers_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiAnswers_ManyArgs_ = {
  updates: Array<PaiAnswers_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_PaiCategoryArgs_ = {
  _set?: InputMaybe<PaiCategory_Set_Input_>;
  where: PaiCategory_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiCategory_By_PkArgs_ = {
  _set?: InputMaybe<PaiCategory_Set_Input_>;
  pk_columns: PaiCategory_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiCategory_ManyArgs_ = {
  updates: Array<PaiCategory_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_PaiCompanyReportArgs_ = {
  _inc?: InputMaybe<PaiCompanyReport_Inc_Input_>;
  _set?: InputMaybe<PaiCompanyReport_Set_Input_>;
  where: PaiCompanyReport_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiCompanyReport_By_PkArgs_ = {
  _inc?: InputMaybe<PaiCompanyReport_Inc_Input_>;
  _set?: InputMaybe<PaiCompanyReport_Set_Input_>;
  pk_columns: PaiCompanyReport_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiCompanyReport_ManyArgs_ = {
  updates: Array<PaiCompanyReport_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_PaiMetricInsightArgs_ = {
  _set?: InputMaybe<PaiMetricInsight_Set_Input_>;
  where: PaiMetricInsight_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiMetricInsight_By_PkArgs_ = {
  _set?: InputMaybe<PaiMetricInsight_Set_Input_>;
  pk_columns: PaiMetricInsight_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiMetricInsight_ManyArgs_ = {
  updates: Array<PaiMetricInsight_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_PaiPortfolioReportArgs_ = {
  _append?: InputMaybe<PaiPortfolioReport_Append_Input_>;
  _delete_at_path?: InputMaybe<PaiPortfolioReport_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<PaiPortfolioReport_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<PaiPortfolioReport_Delete_Key_Input_>;
  _inc?: InputMaybe<PaiPortfolioReport_Inc_Input_>;
  _prepend?: InputMaybe<PaiPortfolioReport_Prepend_Input_>;
  _set?: InputMaybe<PaiPortfolioReport_Set_Input_>;
  where: PaiPortfolioReport_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiPortfolioReport_By_PkArgs_ = {
  _append?: InputMaybe<PaiPortfolioReport_Append_Input_>;
  _delete_at_path?: InputMaybe<PaiPortfolioReport_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<PaiPortfolioReport_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<PaiPortfolioReport_Delete_Key_Input_>;
  _inc?: InputMaybe<PaiPortfolioReport_Inc_Input_>;
  _prepend?: InputMaybe<PaiPortfolioReport_Prepend_Input_>;
  _set?: InputMaybe<PaiPortfolioReport_Set_Input_>;
  pk_columns: PaiPortfolioReport_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiPortfolioReport_ManyArgs_ = {
  updates: Array<PaiPortfolioReport_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_PaiReportIndicatorArgs_ = {
  _append?: InputMaybe<PaiReportIndicator_Append_Input_>;
  _delete_at_path?: InputMaybe<PaiReportIndicator_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<PaiReportIndicator_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<PaiReportIndicator_Delete_Key_Input_>;
  _prepend?: InputMaybe<PaiReportIndicator_Prepend_Input_>;
  _set?: InputMaybe<PaiReportIndicator_Set_Input_>;
  where: PaiReportIndicator_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiReportIndicatorPortfolioCompanyArgs_ = {
  _set?: InputMaybe<PaiReportIndicatorPortfolioCompany_Set_Input_>;
  where: PaiReportIndicatorPortfolioCompany_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiReportIndicatorPortfolioCompany_By_PkArgs_ = {
  _set?: InputMaybe<PaiReportIndicatorPortfolioCompany_Set_Input_>;
  pk_columns: PaiReportIndicatorPortfolioCompany_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiReportIndicatorPortfolioCompany_ManyArgs_ = {
  updates: Array<PaiReportIndicatorPortfolioCompany_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_PaiReportIndicator_By_PkArgs_ = {
  _append?: InputMaybe<PaiReportIndicator_Append_Input_>;
  _delete_at_path?: InputMaybe<PaiReportIndicator_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<PaiReportIndicator_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<PaiReportIndicator_Delete_Key_Input_>;
  _prepend?: InputMaybe<PaiReportIndicator_Prepend_Input_>;
  _set?: InputMaybe<PaiReportIndicator_Set_Input_>;
  pk_columns: PaiReportIndicator_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiReportIndicator_ManyArgs_ = {
  updates: Array<PaiReportIndicator_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_PaiTableArgs_ = {
  _set?: InputMaybe<PaiTable_Set_Input_>;
  where: PaiTable_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiTableIndicatorArgs_ = {
  _set?: InputMaybe<PaiTableIndicator_Set_Input_>;
  where: PaiTableIndicator_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiTableIndicator_By_PkArgs_ = {
  _set?: InputMaybe<PaiTableIndicator_Set_Input_>;
  pk_columns: PaiTableIndicator_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiTableIndicator_ManyArgs_ = {
  updates: Array<PaiTableIndicator_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_PaiTable_By_PkArgs_ = {
  _set?: InputMaybe<PaiTable_Set_Input_>;
  pk_columns: PaiTable_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_PaiTable_ManyArgs_ = {
  updates: Array<PaiTable_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_PortfolioArgs_ = {
  _inc?: InputMaybe<Portfolio_Inc_Input_>;
  _set?: InputMaybe<Portfolio_Set_Input_>;
  where: Portfolio_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_PortfolioCompanyArgs_ = {
  _append?: InputMaybe<PortfolioCompany_Append_Input_>;
  _delete_at_path?: InputMaybe<PortfolioCompany_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<PortfolioCompany_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<PortfolioCompany_Delete_Key_Input_>;
  _inc?: InputMaybe<PortfolioCompany_Inc_Input_>;
  _prepend?: InputMaybe<PortfolioCompany_Prepend_Input_>;
  _set?: InputMaybe<PortfolioCompany_Set_Input_>;
  where: PortfolioCompany_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_PortfolioCompany_By_PkArgs_ = {
  _append?: InputMaybe<PortfolioCompany_Append_Input_>;
  _delete_at_path?: InputMaybe<PortfolioCompany_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<PortfolioCompany_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<PortfolioCompany_Delete_Key_Input_>;
  _inc?: InputMaybe<PortfolioCompany_Inc_Input_>;
  _prepend?: InputMaybe<PortfolioCompany_Prepend_Input_>;
  _set?: InputMaybe<PortfolioCompany_Set_Input_>;
  pk_columns: PortfolioCompany_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_PortfolioCompany_ManyArgs_ = {
  updates: Array<PortfolioCompany_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_PortfolioNonEligibleFinancialsArgs_ = {
  _append?: InputMaybe<PortfolioNonEligibleFinancials_Append_Input_>;
  _delete_at_path?: InputMaybe<PortfolioNonEligibleFinancials_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<PortfolioNonEligibleFinancials_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<PortfolioNonEligibleFinancials_Delete_Key_Input_>;
  _inc?: InputMaybe<PortfolioNonEligibleFinancials_Inc_Input_>;
  _prepend?: InputMaybe<PortfolioNonEligibleFinancials_Prepend_Input_>;
  _set?: InputMaybe<PortfolioNonEligibleFinancials_Set_Input_>;
  where: PortfolioNonEligibleFinancials_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_PortfolioNonEligibleFinancials_By_PkArgs_ = {
  _append?: InputMaybe<PortfolioNonEligibleFinancials_Append_Input_>;
  _delete_at_path?: InputMaybe<PortfolioNonEligibleFinancials_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<PortfolioNonEligibleFinancials_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<PortfolioNonEligibleFinancials_Delete_Key_Input_>;
  _inc?: InputMaybe<PortfolioNonEligibleFinancials_Inc_Input_>;
  _prepend?: InputMaybe<PortfolioNonEligibleFinancials_Prepend_Input_>;
  _set?: InputMaybe<PortfolioNonEligibleFinancials_Set_Input_>;
  pk_columns: PortfolioNonEligibleFinancials_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_PortfolioNonEligibleFinancials_ManyArgs_ = {
  updates: Array<PortfolioNonEligibleFinancials_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Portfolio_By_PkArgs_ = {
  _inc?: InputMaybe<Portfolio_Inc_Input_>;
  _set?: InputMaybe<Portfolio_Set_Input_>;
  pk_columns: Portfolio_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Portfolio_ManyArgs_ = {
  updates: Array<Portfolio_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_QuarterEnumArgs_ = {
  _set?: InputMaybe<QuarterEnum_Set_Input_>;
  where: QuarterEnum_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_QuarterEnum_By_PkArgs_ = {
  _set?: InputMaybe<QuarterEnum_Set_Input_>;
  pk_columns: QuarterEnum_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_QuarterEnum_ManyArgs_ = {
  updates: Array<QuarterEnum_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionArgs_ = {
  _append?: InputMaybe<Question_Append_Input_>;
  _delete_at_path?: InputMaybe<Question_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Question_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Question_Delete_Key_Input_>;
  _prepend?: InputMaybe<Question_Prepend_Input_>;
  _set?: InputMaybe<Question_Set_Input_>;
  where: Question_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionChoiceArgs_ = {
  _inc?: InputMaybe<QuestionChoice_Inc_Input_>;
  _set?: InputMaybe<QuestionChoice_Set_Input_>;
  where: QuestionChoice_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionChoice_By_PkArgs_ = {
  _inc?: InputMaybe<QuestionChoice_Inc_Input_>;
  _set?: InputMaybe<QuestionChoice_Set_Input_>;
  pk_columns: QuestionChoice_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionChoice_ManyArgs_ = {
  updates: Array<QuestionChoice_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionLevelArgs_ = {
  _set?: InputMaybe<QuestionLevel_Set_Input_>;
  where: QuestionLevel_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionLevel_By_PkArgs_ = {
  _set?: InputMaybe<QuestionLevel_Set_Input_>;
  pk_columns: QuestionLevel_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionLevel_ManyArgs_ = {
  updates: Array<QuestionLevel_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionRevisionArgs_ = {
  _set?: InputMaybe<QuestionRevision_Set_Input_>;
  where: QuestionRevision_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionRevision_By_PkArgs_ = {
  _set?: InputMaybe<QuestionRevision_Set_Input_>;
  pk_columns: QuestionRevision_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionRevision_ManyArgs_ = {
  updates: Array<QuestionRevision_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionSetArgs_ = {
  _set?: InputMaybe<QuestionSet_Set_Input_>;
  where: QuestionSet_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionSetQuestionArgs_ = {
  _set?: InputMaybe<QuestionSetQuestion_Set_Input_>;
  where: QuestionSetQuestion_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionSetQuestion_By_PkArgs_ = {
  _set?: InputMaybe<QuestionSetQuestion_Set_Input_>;
  pk_columns: QuestionSetQuestion_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionSetQuestion_ManyArgs_ = {
  updates: Array<QuestionSetQuestion_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionSet_By_PkArgs_ = {
  _set?: InputMaybe<QuestionSet_Set_Input_>;
  pk_columns: QuestionSet_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionSet_ManyArgs_ = {
  updates: Array<QuestionSet_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionTypeArgs_ = {
  _set?: InputMaybe<QuestionType_Set_Input_>;
  where: QuestionType_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionType_By_PkArgs_ = {
  _set?: InputMaybe<QuestionType_Set_Input_>;
  pk_columns: QuestionType_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_QuestionType_ManyArgs_ = {
  updates: Array<QuestionType_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Question_By_PkArgs_ = {
  _append?: InputMaybe<Question_Append_Input_>;
  _delete_at_path?: InputMaybe<Question_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Question_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Question_Delete_Key_Input_>;
  _prepend?: InputMaybe<Question_Prepend_Input_>;
  _set?: InputMaybe<Question_Set_Input_>;
  pk_columns: Question_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Question_ManyArgs_ = {
  updates: Array<Question_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_ReportingGroupArgs_ = {
  _inc?: InputMaybe<ReportingGroup_Inc_Input_>;
  _set?: InputMaybe<ReportingGroup_Set_Input_>;
  where: ReportingGroup_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_ReportingGroup_By_PkArgs_ = {
  _inc?: InputMaybe<ReportingGroup_Inc_Input_>;
  _set?: InputMaybe<ReportingGroup_Set_Input_>;
  pk_columns: ReportingGroup_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_ReportingGroup_ManyArgs_ = {
  updates: Array<ReportingGroup_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_SectorArgs_ = {
  _set?: InputMaybe<Sector_Set_Input_>;
  where: Sector_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Sector_By_PkArgs_ = {
  _set?: InputMaybe<Sector_Set_Input_>;
  pk_columns: Sector_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Sector_ManyArgs_ = {
  updates: Array<Sector_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_SharedSpaceArgs_ = {
  _set?: InputMaybe<SharedSpace_Set_Input_>;
  where: SharedSpace_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_SharedSpace_By_PkArgs_ = {
  _set?: InputMaybe<SharedSpace_Set_Input_>;
  pk_columns: SharedSpace_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_SharedSpace_ManyArgs_ = {
  updates: Array<SharedSpace_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_SpaceArgs_ = {
  _set?: InputMaybe<Space_Set_Input_>;
  where: Space_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Space_By_PkArgs_ = {
  _set?: InputMaybe<Space_Set_Input_>;
  pk_columns: Space_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Space_ManyArgs_ = {
  updates: Array<Space_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_SubsidiaryArgs_ = {
  _set?: InputMaybe<Subsidiary_Set_Input_>;
  where: Subsidiary_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Subsidiary_By_PkArgs_ = {
  _set?: InputMaybe<Subsidiary_Set_Input_>;
  pk_columns: Subsidiary_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Subsidiary_ManyArgs_ = {
  updates: Array<Subsidiary_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_TagArgs_ = {
  _set?: InputMaybe<Tag_Set_Input_>;
  where: Tag_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_TagGroupArgs_ = {
  _set?: InputMaybe<TagGroup_Set_Input_>;
  where: TagGroup_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_TagGroup_By_PkArgs_ = {
  _set?: InputMaybe<TagGroup_Set_Input_>;
  pk_columns: TagGroup_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_TagGroup_ManyArgs_ = {
  updates: Array<TagGroup_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_TagTypeArgs_ = {
  _set?: InputMaybe<TagType_Set_Input_>;
  where: TagType_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_TagType_By_PkArgs_ = {
  _set?: InputMaybe<TagType_Set_Input_>;
  pk_columns: TagType_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_TagType_ManyArgs_ = {
  updates: Array<TagType_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_TagValueArgs_ = {
  _inc?: InputMaybe<TagValue_Inc_Input_>;
  _set?: InputMaybe<TagValue_Set_Input_>;
  where: TagValue_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_TagValue_By_PkArgs_ = {
  _inc?: InputMaybe<TagValue_Inc_Input_>;
  _set?: InputMaybe<TagValue_Set_Input_>;
  pk_columns: TagValue_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_TagValue_ManyArgs_ = {
  updates: Array<TagValue_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_ArticlesArgs_ = {
  _inc?: InputMaybe<Tag_Articles_Inc_Input_>;
  _set?: InputMaybe<Tag_Articles_Set_Input_>;
  where: Tag_Articles_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Articles_By_PkArgs_ = {
  _inc?: InputMaybe<Tag_Articles_Inc_Input_>;
  _set?: InputMaybe<Tag_Articles_Set_Input_>;
  pk_columns: Tag_Articles_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_Articles_ManyArgs_ = {
  updates: Array<Tag_Articles_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_By_PkArgs_ = {
  _set?: InputMaybe<Tag_Set_Input_>;
  pk_columns: Tag_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Tag_ManyArgs_ = {
  updates: Array<Tag_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_TargetQuestionArgs_ = {
  _inc?: InputMaybe<TargetQuestion_Inc_Input_>;
  _set?: InputMaybe<TargetQuestion_Set_Input_>;
  where: TargetQuestion_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_TargetQuestionGroupArgs_ = {
  _set?: InputMaybe<TargetQuestionGroup_Set_Input_>;
  where: TargetQuestionGroup_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_TargetQuestionGroup_By_PkArgs_ = {
  _set?: InputMaybe<TargetQuestionGroup_Set_Input_>;
  pk_columns: TargetQuestionGroup_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_TargetQuestionGroup_ManyArgs_ = {
  updates: Array<TargetQuestionGroup_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_TargetQuestion_By_PkArgs_ = {
  _inc?: InputMaybe<TargetQuestion_Inc_Input_>;
  _set?: InputMaybe<TargetQuestion_Set_Input_>;
  pk_columns: TargetQuestion_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_TargetQuestion_ManyArgs_ = {
  updates: Array<TargetQuestion_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_TaskArgs_ = {
  _set?: InputMaybe<Task_Set_Input_>;
  where: Task_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_TaskStatusEnumArgs_ = {
  _set?: InputMaybe<TaskStatusEnum_Set_Input_>;
  where: TaskStatusEnum_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_TaskStatusEnum_By_PkArgs_ = {
  _set?: InputMaybe<TaskStatusEnum_Set_Input_>;
  pk_columns: TaskStatusEnum_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_TaskStatusEnum_ManyArgs_ = {
  updates: Array<TaskStatusEnum_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Task_By_PkArgs_ = {
  _set?: InputMaybe<Task_Set_Input_>;
  pk_columns: Task_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Task_ManyArgs_ = {
  updates: Array<Task_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_TaxonomyPortfolioReportArgs_ = {
  _inc?: InputMaybe<TaxonomyPortfolioReport_Inc_Input_>;
  _set?: InputMaybe<TaxonomyPortfolioReport_Set_Input_>;
  where: TaxonomyPortfolioReport_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_TaxonomyPortfolioReport_By_PkArgs_ = {
  _inc?: InputMaybe<TaxonomyPortfolioReport_Inc_Input_>;
  _set?: InputMaybe<TaxonomyPortfolioReport_Set_Input_>;
  pk_columns: TaxonomyPortfolioReport_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_TaxonomyPortfolioReport_ManyArgs_ = {
  updates: Array<TaxonomyPortfolioReport_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_ThreadArgs_ = {
  _set?: InputMaybe<Thread_Set_Input_>;
  where: Thread_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_ThreadSubscriberArgs_ = {
  _set?: InputMaybe<ThreadSubscriber_Set_Input_>;
  where: ThreadSubscriber_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_ThreadSubscriber_By_PkArgs_ = {
  _set?: InputMaybe<ThreadSubscriber_Set_Input_>;
  pk_columns: ThreadSubscriber_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_ThreadSubscriber_ManyArgs_ = {
  updates: Array<ThreadSubscriber_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_By_PkArgs_ = {
  _set?: InputMaybe<Thread_Set_Input_>;
  pk_columns: Thread_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Thread_ManyArgs_ = {
  updates: Array<Thread_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_TotalComparisonFinancialsArgs_ = {
  _inc?: InputMaybe<TotalComparisonFinancials_Inc_Input_>;
  _set?: InputMaybe<TotalComparisonFinancials_Set_Input_>;
  where: TotalComparisonFinancials_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_TotalComparisonFinancials_ManyArgs_ = {
  updates: Array<TotalComparisonFinancials_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_TriggerTypesArgs_ = {
  _set?: InputMaybe<TriggerTypes_Set_Input_>;
  where: TriggerTypes_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_TriggerTypes_By_PkArgs_ = {
  _set?: InputMaybe<TriggerTypes_Set_Input_>;
  pk_columns: TriggerTypes_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_TriggerTypes_ManyArgs_ = {
  updates: Array<TriggerTypes_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_UserNotificationArgs_ = {
  _set?: InputMaybe<UserNotification_Set_Input_>;
  where: UserNotification_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_UserNotification_By_PkArgs_ = {
  _set?: InputMaybe<UserNotification_Set_Input_>;
  pk_columns: UserNotification_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_UserNotification_ManyArgs_ = {
  updates: Array<UserNotification_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_UserRoleArgs_ = {
  _set?: InputMaybe<UserRole_Set_Input_>;
  where: UserRole_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_UserRole_By_PkArgs_ = {
  _set?: InputMaybe<UserRole_Set_Input_>;
  pk_columns: UserRole_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_UserRole_ManyArgs_ = {
  updates: Array<UserRole_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_UserSessionMetadataArgs_ = {
  _set?: InputMaybe<UserSessionMetadata_Set_Input_>;
  where: UserSessionMetadata_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_UserSessionMetadata_By_PkArgs_ = {
  _set?: InputMaybe<UserSessionMetadata_Set_Input_>;
  pk_columns: UserSessionMetadata_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_UserSessionMetadata_ManyArgs_ = {
  updates: Array<UserSessionMetadata_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_WebsocketTestArgs_ = {
  _inc?: InputMaybe<WebsocketTest_Inc_Input_>;
  _set?: InputMaybe<WebsocketTest_Set_Input_>;
  where: WebsocketTest_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_WebsocketTest_By_PkArgs_ = {
  _inc?: InputMaybe<WebsocketTest_Inc_Input_>;
  _set?: InputMaybe<WebsocketTest_Set_Input_>;
  pk_columns: WebsocketTest_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_WebsocketTest_ManyArgs_ = {
  updates: Array<WebsocketTest_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthProviderRequests_ManyArgs_ = {
  updates: Array<AuthProviderRequests_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthProviders_ManyArgs_ = {
  updates: Array<AuthProviders_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRefreshTokenTypes_ManyArgs_ = {
  updates: Array<AuthRefreshTokenTypes_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRefreshTokens_ManyArgs_ = {
  updates: Array<AuthRefreshTokens_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthRoles_ManyArgs_ = {
  updates: Array<AuthRoles_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserProviders_ManyArgs_ = {
  updates: Array<AuthUserProviders_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserRoles_ManyArgs_ = {
  updates: Array<AuthUserRoles_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthUserSecurityKeys_ManyArgs_ = {
  updates: Array<AuthUserSecurityKeys_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Buckets_ManyArgs_ = {
  updates: Array<Buckets_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ActionReportingUnitArgs_ = {
  _set?: InputMaybe<Esrs_ActionReportingUnit_Set_Input_>;
  where: Esrs_ActionReportingUnit_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ActionReportingUnit_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_ActionReportingUnit_Set_Input_>;
  pk_columns: Esrs_ActionReportingUnit_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ActionReportingUnit_ManyArgs_ = {
  updates: Array<Esrs_ActionReportingUnit_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ActionSubsidiaryArgs_ = {
  _set?: InputMaybe<Esrs_ActionSubsidiary_Set_Input_>;
  where: Esrs_ActionSubsidiary_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ActionSubsidiary_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_ActionSubsidiary_Set_Input_>;
  pk_columns: Esrs_ActionSubsidiary_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ActionSubsidiary_ManyArgs_ = {
  updates: Array<Esrs_ActionSubsidiary_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ActionTargetArgs_ = {
  _inc?: InputMaybe<Esrs_ActionTarget_Inc_Input_>;
  _set?: InputMaybe<Esrs_ActionTarget_Set_Input_>;
  where: Esrs_ActionTarget_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ActionTarget_By_PkArgs_ = {
  _inc?: InputMaybe<Esrs_ActionTarget_Inc_Input_>;
  _set?: InputMaybe<Esrs_ActionTarget_Set_Input_>;
  pk_columns: Esrs_ActionTarget_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ActionTarget_ManyArgs_ = {
  updates: Array<Esrs_ActionTarget_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ActionsArgs_ = {
  _append?: InputMaybe<Esrs_Actions_Append_Input_>;
  _delete_at_path?: InputMaybe<Esrs_Actions_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Esrs_Actions_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Esrs_Actions_Delete_Key_Input_>;
  _inc?: InputMaybe<Esrs_Actions_Inc_Input_>;
  _prepend?: InputMaybe<Esrs_Actions_Prepend_Input_>;
  _set?: InputMaybe<Esrs_Actions_Set_Input_>;
  where: Esrs_Actions_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Actions_By_PkArgs_ = {
  _append?: InputMaybe<Esrs_Actions_Append_Input_>;
  _delete_at_path?: InputMaybe<Esrs_Actions_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Esrs_Actions_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Esrs_Actions_Delete_Key_Input_>;
  _inc?: InputMaybe<Esrs_Actions_Inc_Input_>;
  _prepend?: InputMaybe<Esrs_Actions_Prepend_Input_>;
  _set?: InputMaybe<Esrs_Actions_Set_Input_>;
  pk_columns: Esrs_Actions_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Actions_ManyArgs_ = {
  updates: Array<Esrs_Actions_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_AnswerArgs_ = {
  _set?: InputMaybe<Esrs_Answer_Set_Input_>;
  where: Esrs_Answer_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Answer_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_Answer_Set_Input_>;
  pk_columns: Esrs_Answer_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Answer_ManyArgs_ = {
  updates: Array<Esrs_Answer_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_AssessmentCurrencyConversionArgs_ = {
  _inc?: InputMaybe<Esrs_AssessmentCurrencyConversion_Inc_Input_>;
  _set?: InputMaybe<Esrs_AssessmentCurrencyConversion_Set_Input_>;
  where: Esrs_AssessmentCurrencyConversion_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_AssessmentCurrencyConversion_By_PkArgs_ = {
  _inc?: InputMaybe<Esrs_AssessmentCurrencyConversion_Inc_Input_>;
  _set?: InputMaybe<Esrs_AssessmentCurrencyConversion_Set_Input_>;
  pk_columns: Esrs_AssessmentCurrencyConversion_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_AssessmentCurrencyConversion_ManyArgs_ = {
  updates: Array<Esrs_AssessmentCurrencyConversion_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_BaselineArgs_ = {
  _set?: InputMaybe<Esrs_Baseline_Set_Input_>;
  where: Esrs_Baseline_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Baseline_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_Baseline_Set_Input_>;
  pk_columns: Esrs_Baseline_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Baseline_ManyArgs_ = {
  updates: Array<Esrs_Baseline_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_CompanyIntegrationArgs_ = {
  _set?: InputMaybe<Esrs_CompanyIntegration_Set_Input_>;
  where: Esrs_CompanyIntegration_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_CompanyIntegration_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_CompanyIntegration_Set_Input_>;
  pk_columns: Esrs_CompanyIntegration_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_CompanyIntegration_ManyArgs_ = {
  updates: Array<Esrs_CompanyIntegration_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_DatapointArgs_ = {
  _append?: InputMaybe<Esrs_Datapoint_Append_Input_>;
  _delete_at_path?: InputMaybe<Esrs_Datapoint_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Esrs_Datapoint_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Esrs_Datapoint_Delete_Key_Input_>;
  _prepend?: InputMaybe<Esrs_Datapoint_Prepend_Input_>;
  _set?: InputMaybe<Esrs_Datapoint_Set_Input_>;
  where: Esrs_Datapoint_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_DatapointChoiceArgs_ = {
  _set?: InputMaybe<Esrs_DatapointChoice_Set_Input_>;
  where: Esrs_DatapointChoice_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_DatapointChoice_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_DatapointChoice_Set_Input_>;
  pk_columns: Esrs_DatapointChoice_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_DatapointChoice_ManyArgs_ = {
  updates: Array<Esrs_DatapointChoice_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_DatapointMdrmArgs_ = {
  _set?: InputMaybe<Esrs_DatapointMdrm_Set_Input_>;
  where: Esrs_DatapointMdrm_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_DatapointMdrm_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_DatapointMdrm_Set_Input_>;
  pk_columns: Esrs_DatapointMdrm_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_DatapointMdrm_ManyArgs_ = {
  updates: Array<Esrs_DatapointMdrm_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_DatapointTagArgs_ = {
  _set?: InputMaybe<Esrs_DatapointTag_Set_Input_>;
  where: Esrs_DatapointTag_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_DatapointTag_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_DatapointTag_Set_Input_>;
  pk_columns: Esrs_DatapointTag_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_DatapointTag_ManyArgs_ = {
  updates: Array<Esrs_DatapointTag_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Datapoint_By_PkArgs_ = {
  _append?: InputMaybe<Esrs_Datapoint_Append_Input_>;
  _delete_at_path?: InputMaybe<Esrs_Datapoint_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Esrs_Datapoint_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Esrs_Datapoint_Delete_Key_Input_>;
  _prepend?: InputMaybe<Esrs_Datapoint_Prepend_Input_>;
  _set?: InputMaybe<Esrs_Datapoint_Set_Input_>;
  pk_columns: Esrs_Datapoint_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Datapoint_ManyArgs_ = {
  updates: Array<Esrs_Datapoint_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_ActionBusinessUnitArgs_ = {
  _set?: InputMaybe<Esrs_Deprecated_ActionBusinessUnit_Set_Input_>;
  where: Esrs_Deprecated_ActionBusinessUnit_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_ActionBusinessUnit_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_Deprecated_ActionBusinessUnit_Set_Input_>;
  pk_columns: Esrs_Deprecated_ActionBusinessUnit_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_ActionBusinessUnit_ManyArgs_ = {
  updates: Array<Esrs_Deprecated_ActionBusinessUnit_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_BusinessUnitEsrsAssessmentArgs_ = {
  _set?: InputMaybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Set_Input_>;
  where: Esrs_Deprecated_BusinessUnitEsrsAssessment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_BusinessUnitEsrsAssessment_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Set_Input_>;
  pk_columns: Esrs_Deprecated_BusinessUnitEsrsAssessment_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_BusinessUnitEsrsAssessment_ManyArgs_ = {
  updates: Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_CompanyMaterialityAssessmentArgs_ = {
  _set?: InputMaybe<Esrs_Deprecated_CompanyMaterialityAssessment_Set_Input_>;
  where: Esrs_Deprecated_CompanyMaterialityAssessment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_CompanyMaterialityAssessment_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_Deprecated_CompanyMaterialityAssessment_Set_Input_>;
  pk_columns: Esrs_Deprecated_CompanyMaterialityAssessment_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_CompanyMaterialityAssessment_ManyArgs_ = {
  updates: Array<Esrs_Deprecated_CompanyMaterialityAssessment_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_EsrsMdrmArgs_ = {
  _set?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Set_Input_>;
  where: Esrs_Deprecated_EsrsMdrm_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_EsrsMdrm_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Set_Input_>;
  pk_columns: Esrs_Deprecated_EsrsMdrm_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_EsrsMdrm_ManyArgs_ = {
  updates: Array<Esrs_Deprecated_EsrsMdrm_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_MaterialDisclosureRequirementArgs_ = {
  _set?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Set_Input_>;
  where: Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_MaterialDisclosureRequirement_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Set_Input_>;
  pk_columns: Esrs_Deprecated_MaterialDisclosureRequirement_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_MaterialDisclosureRequirement_ManyArgs_ = {
  updates: Array<Esrs_Deprecated_MaterialDisclosureRequirement_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_MetricAnswerArgs_ = {
  _append?: InputMaybe<Esrs_Deprecated_MetricAnswer_Append_Input_>;
  _delete_at_path?: InputMaybe<Esrs_Deprecated_MetricAnswer_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Esrs_Deprecated_MetricAnswer_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Esrs_Deprecated_MetricAnswer_Delete_Key_Input_>;
  _prepend?: InputMaybe<Esrs_Deprecated_MetricAnswer_Prepend_Input_>;
  _set?: InputMaybe<Esrs_Deprecated_MetricAnswer_Set_Input_>;
  where: Esrs_Deprecated_MetricAnswer_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_MetricAnswer_By_PkArgs_ = {
  _append?: InputMaybe<Esrs_Deprecated_MetricAnswer_Append_Input_>;
  _delete_at_path?: InputMaybe<Esrs_Deprecated_MetricAnswer_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Esrs_Deprecated_MetricAnswer_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Esrs_Deprecated_MetricAnswer_Delete_Key_Input_>;
  _prepend?: InputMaybe<Esrs_Deprecated_MetricAnswer_Prepend_Input_>;
  _set?: InputMaybe<Esrs_Deprecated_MetricAnswer_Set_Input_>;
  pk_columns: Esrs_Deprecated_MetricAnswer_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Deprecated_MetricAnswer_ManyArgs_ = {
  updates: Array<Esrs_Deprecated_MetricAnswer_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_DisclosureRequirementAttachmentArgs_ = {
  _set?: InputMaybe<Esrs_DisclosureRequirementAttachment_Set_Input_>;
  where: Esrs_DisclosureRequirementAttachment_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_DisclosureRequirementAttachment_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_DisclosureRequirementAttachment_Set_Input_>;
  pk_columns: Esrs_DisclosureRequirementAttachment_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_DisclosureRequirementAttachment_ManyArgs_ = {
  updates: Array<Esrs_DisclosureRequirementAttachment_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_EsrsAssessmentCompanyIntegrationArgs_ = {
  _set?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Set_Input_>;
  where: Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_EsrsAssessmentCompanyIntegrationRuArgs_ = {
  _set?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Set_Input_>;
  where: Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_EsrsAssessmentCompanyIntegrationRu_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Set_Input_>;
  pk_columns: Esrs_EsrsAssessmentCompanyIntegrationRu_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_EsrsAssessmentCompanyIntegrationRu_ManyArgs_ = {
  updates: Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_EsrsAssessmentCompanyIntegration_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Set_Input_>;
  pk_columns: Esrs_EsrsAssessmentCompanyIntegration_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_EsrsAssessmentCompanyIntegration_ManyArgs_ = {
  updates: Array<Esrs_EsrsAssessmentCompanyIntegration_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MaterialMetricArgs_ = {
  _append?: InputMaybe<Esrs_MaterialMetric_Append_Input_>;
  _delete_at_path?: InputMaybe<Esrs_MaterialMetric_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Esrs_MaterialMetric_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Esrs_MaterialMetric_Delete_Key_Input_>;
  _prepend?: InputMaybe<Esrs_MaterialMetric_Prepend_Input_>;
  _set?: InputMaybe<Esrs_MaterialMetric_Set_Input_>;
  where: Esrs_MaterialMetric_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MaterialMetricTagArgs_ = {
  _set?: InputMaybe<Esrs_MaterialMetricTag_Set_Input_>;
  where: Esrs_MaterialMetricTag_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MaterialMetricTag_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_MaterialMetricTag_Set_Input_>;
  pk_columns: Esrs_MaterialMetricTag_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MaterialMetricTag_ManyArgs_ = {
  updates: Array<Esrs_MaterialMetricTag_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MaterialMetric_By_PkArgs_ = {
  _append?: InputMaybe<Esrs_MaterialMetric_Append_Input_>;
  _delete_at_path?: InputMaybe<Esrs_MaterialMetric_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Esrs_MaterialMetric_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Esrs_MaterialMetric_Delete_Key_Input_>;
  _prepend?: InputMaybe<Esrs_MaterialMetric_Prepend_Input_>;
  _set?: InputMaybe<Esrs_MaterialMetric_Set_Input_>;
  pk_columns: Esrs_MaterialMetric_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MaterialMetric_ManyArgs_ = {
  updates: Array<Esrs_MaterialMetric_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MaterialStandardArgs_ = {
  _set?: InputMaybe<Esrs_MaterialStandard_Set_Input_>;
  where: Esrs_MaterialStandard_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MaterialStandard_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_MaterialStandard_Set_Input_>;
  pk_columns: Esrs_MaterialStandard_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MaterialStandard_ManyArgs_ = {
  updates: Array<Esrs_MaterialStandard_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MaterialTagValueArgs_ = {
  _set?: InputMaybe<Esrs_MaterialTagValue_Set_Input_>;
  where: Esrs_MaterialTagValue_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MaterialTagValue_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_MaterialTagValue_Set_Input_>;
  pk_columns: Esrs_MaterialTagValue_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MaterialTagValue_ManyArgs_ = {
  updates: Array<Esrs_MaterialTagValue_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MilestoneArgs_ = {
  _inc?: InputMaybe<Esrs_Milestone_Inc_Input_>;
  _set?: InputMaybe<Esrs_Milestone_Set_Input_>;
  where: Esrs_Milestone_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MilestoneResultArgs_ = {
  _inc?: InputMaybe<Esrs_MilestoneResult_Inc_Input_>;
  _set?: InputMaybe<Esrs_MilestoneResult_Set_Input_>;
  where: Esrs_MilestoneResult_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MilestoneResult_By_PkArgs_ = {
  _inc?: InputMaybe<Esrs_MilestoneResult_Inc_Input_>;
  _set?: InputMaybe<Esrs_MilestoneResult_Set_Input_>;
  pk_columns: Esrs_MilestoneResult_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_MilestoneResult_ManyArgs_ = {
  updates: Array<Esrs_MilestoneResult_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Milestone_By_PkArgs_ = {
  _inc?: InputMaybe<Esrs_Milestone_Inc_Input_>;
  _set?: InputMaybe<Esrs_Milestone_Set_Input_>;
  pk_columns: Esrs_Milestone_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Milestone_ManyArgs_ = {
  updates: Array<Esrs_Milestone_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_PolicyArgs_ = {
  _set?: InputMaybe<Esrs_Policy_Set_Input_>;
  where: Esrs_Policy_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Policy_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_Policy_Set_Input_>;
  pk_columns: Esrs_Policy_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Policy_ManyArgs_ = {
  updates: Array<Esrs_Policy_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ReportingUnitArgs_ = {
  _set?: InputMaybe<Esrs_ReportingUnit_Set_Input_>;
  where: Esrs_ReportingUnit_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ReportingUnitLineageArgs_ = {
  _set?: InputMaybe<Esrs_ReportingUnitLineage_Set_Input_>;
  where: Esrs_ReportingUnitLineage_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ReportingUnitLineage_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_ReportingUnitLineage_Set_Input_>;
  pk_columns: Esrs_ReportingUnitLineage_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ReportingUnitLineage_ManyArgs_ = {
  updates: Array<Esrs_ReportingUnitLineage_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ReportingUnit_By_PkArgs_ = {
  _set?: InputMaybe<Esrs_ReportingUnit_Set_Input_>;
  pk_columns: Esrs_ReportingUnit_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_ReportingUnit_ManyArgs_ = {
  updates: Array<Esrs_ReportingUnit_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_TargetArgs_ = {
  _append?: InputMaybe<Esrs_Target_Append_Input_>;
  _delete_at_path?: InputMaybe<Esrs_Target_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Esrs_Target_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Esrs_Target_Delete_Key_Input_>;
  _inc?: InputMaybe<Esrs_Target_Inc_Input_>;
  _prepend?: InputMaybe<Esrs_Target_Prepend_Input_>;
  _set?: InputMaybe<Esrs_Target_Set_Input_>;
  where: Esrs_Target_Bool_Exp_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Target_By_PkArgs_ = {
  _append?: InputMaybe<Esrs_Target_Append_Input_>;
  _delete_at_path?: InputMaybe<Esrs_Target_Delete_At_Path_Input_>;
  _delete_elem?: InputMaybe<Esrs_Target_Delete_Elem_Input_>;
  _delete_key?: InputMaybe<Esrs_Target_Delete_Key_Input_>;
  _inc?: InputMaybe<Esrs_Target_Inc_Input_>;
  _prepend?: InputMaybe<Esrs_Target_Prepend_Input_>;
  _set?: InputMaybe<Esrs_Target_Set_Input_>;
  pk_columns: Esrs_Target_Pk_Columns_Input_;
};


/** mutation root */
export type Mutation_RootUpdate_Esrs_Target_ManyArgs_ = {
  updates: Array<Esrs_Target_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Files_ManyArgs_ = {
  updates: Array<Files_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs_ = {
  updates: Array<Users_Updates_>;
};


/** mutation root */
export type Mutation_RootUpdate_Virus_ManyArgs_ = {
  updates: Array<Virus_Updates_>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp_ = {
  _eq?: InputMaybe<Scalars['numeric']['input']>;
  _gt?: InputMaybe<Scalars['numeric']['input']>;
  _gte?: InputMaybe<Scalars['numeric']['input']>;
  _in?: InputMaybe<Array<Scalars['numeric']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['numeric']['input']>;
  _lte?: InputMaybe<Scalars['numeric']['input']>;
  _neq?: InputMaybe<Scalars['numeric']['input']>;
  _nin?: InputMaybe<Array<Scalars['numeric']['input']>>;
};

/** column ordering options */
export enum Order_By_ {
  /** in ascending order, nulls last */
  Asc_ = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst_ = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast_ = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc_ = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst_ = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast_ = 'desc_nulls_last'
}

export type Query_Root_ = {
  __typename?: 'query_root';
  /** fetch data from the table: "AIConfig" */
  AIConfig: Array<AiConfig_>;
  /** fetch aggregated fields from the table: "AIConfig" */
  AIConfig_aggregate: AiConfig_Aggregate_;
  /** fetch data from the table: "AIConfig" using primary key columns */
  AIConfig_by_pk?: Maybe<AiConfig_>;
  /** fetch data from the table: "esrs.ActionQuestion" */
  ActionQuestion: Array<ActionQuestion_>;
  /** fetch data from the table: "esrs.ActionQuestionGroup" */
  ActionQuestionGroup: Array<ActionQuestionGroup_>;
  /** fetch aggregated fields from the table: "esrs.ActionQuestionGroup" */
  ActionQuestionGroup_aggregate: ActionQuestionGroup_Aggregate_;
  /** fetch data from the table: "esrs.ActionQuestionGroup" using primary key columns */
  ActionQuestionGroup_by_pk?: Maybe<ActionQuestionGroup_>;
  /** fetch aggregated fields from the table: "esrs.ActionQuestion" */
  ActionQuestion_aggregate: ActionQuestion_Aggregate_;
  /** fetch data from the table: "esrs.ActionQuestion" using primary key columns */
  ActionQuestion_by_pk?: Maybe<ActionQuestion_>;
  /** fetch data from the table: "Activity" */
  Activity: Array<Activity_>;
  /** fetch data from the table: "ActivityNaceCode" */
  ActivityNaceCode: Array<ActivityNaceCode_>;
  /** fetch aggregated fields from the table: "ActivityNaceCode" */
  ActivityNaceCode_aggregate: ActivityNaceCode_Aggregate_;
  /** fetch data from the table: "ActivityNaceCode" using primary key columns */
  ActivityNaceCode_by_pk?: Maybe<ActivityNaceCode_>;
  /** fetch data from the table: "ActivityQuestionSet" */
  ActivityQuestionSet: Array<ActivityQuestionSet_>;
  /** fetch aggregated fields from the table: "ActivityQuestionSet" */
  ActivityQuestionSet_aggregate: ActivityQuestionSet_Aggregate_;
  /** fetch data from the table: "ActivityQuestionSet" using primary key columns */
  ActivityQuestionSet_by_pk?: Maybe<ActivityQuestionSet_>;
  /** fetch data from the table: "ActivityReport" */
  ActivityReport: Array<ActivityReport_>;
  /** fetch aggregated fields from the table: "ActivityReport" */
  ActivityReport_aggregate: ActivityReport_Aggregate_;
  /** fetch data from the table: "ActivityReport" using primary key columns */
  ActivityReport_by_pk?: Maybe<ActivityReport_>;
  /** fetch data from the table: "ActivityVersion" */
  ActivityVersion: Array<ActivityVersion_>;
  /** fetch aggregated fields from the table: "ActivityVersion" */
  ActivityVersion_aggregate: ActivityVersion_Aggregate_;
  /** fetch data from the table: "ActivityVersion" using primary key columns */
  ActivityVersion_by_pk?: Maybe<ActivityVersion_>;
  /** fetch aggregated fields from the table: "Activity" */
  Activity_aggregate: Activity_Aggregate_;
  /** fetch data from the table: "Activity" using primary key columns */
  Activity_by_pk?: Maybe<Activity_>;
  /** fetch data from the table: "esrs.AdditionalType" */
  AdditionalType: Array<AdditionalType_>;
  /** fetch aggregated fields from the table: "esrs.AdditionalType" */
  AdditionalType_aggregate: AdditionalType_Aggregate_;
  /** fetch data from the table: "esrs.AdditionalType" using primary key columns */
  AdditionalType_by_pk?: Maybe<AdditionalType_>;
  /** fetch data from the table: "Answer" */
  Answer: Array<Answer_>;
  /** fetch data from the table: "AnswerCompany" */
  AnswerCompany: Array<AnswerCompany_>;
  /** fetch aggregated fields from the table: "AnswerCompany" */
  AnswerCompany_aggregate: AnswerCompany_Aggregate_;
  /** fetch aggregated fields from the table: "Answer" */
  Answer_aggregate: Answer_Aggregate_;
  /** fetch data from the table: "Answer" using primary key columns */
  Answer_by_pk?: Maybe<Answer_>;
  /** fetch data from the table: "AppConfig" */
  AppConfig: Array<AppConfig_>;
  /** fetch aggregated fields from the table: "AppConfig" */
  AppConfig_aggregate: AppConfig_Aggregate_;
  /** fetch data from the table: "AppConfig" using primary key columns */
  AppConfig_by_pk?: Maybe<AppConfig_>;
  /** fetch data from the table: "Article" */
  Article: Array<Article_>;
  /** fetch aggregated fields from the table: "Article" */
  Article_aggregate: Article_Aggregate_;
  /** fetch data from the table: "Article" using primary key columns */
  Article_by_pk?: Maybe<Article_>;
  /** fetch data from the table: "Attachment" */
  Attachment: Array<Attachment_>;
  /** fetch data from the table: "AttachmentBox" */
  AttachmentBox: Array<AttachmentBox_>;
  /** fetch aggregated fields from the table: "AttachmentBox" */
  AttachmentBox_aggregate: AttachmentBox_Aggregate_;
  /** fetch data from the table: "AttachmentBox" using primary key columns */
  AttachmentBox_by_pk?: Maybe<AttachmentBox_>;
  /** fetch aggregated fields from the table: "Attachment" */
  Attachment_aggregate: Attachment_Aggregate_;
  /** fetch data from the table: "Attachment" using primary key columns */
  Attachment_by_pk?: Maybe<Attachment_>;
  /** fetch data from the table: "AuditLogEntry" */
  AuditLogEntry: Array<AuditLogEntry_>;
  /** fetch aggregated fields from the table: "AuditLogEntry" */
  AuditLogEntry_aggregate: AuditLogEntry_Aggregate_;
  /** fetch data from the table: "AuditLogEntry" using primary key columns */
  AuditLogEntry_by_pk?: Maybe<AuditLogEntry_>;
  /** fetch data from the table: "BusinessUnit" */
  BusinessUnit: Array<BusinessUnit_>;
  /** fetch data from the table: "BusinessUnitAssessment" */
  BusinessUnitAssessment: Array<BusinessUnitAssessment_>;
  /** fetch aggregated fields from the table: "BusinessUnitAssessment" */
  BusinessUnitAssessment_aggregate: BusinessUnitAssessment_Aggregate_;
  /** fetch data from the table: "BusinessUnitAssessment" using primary key columns */
  BusinessUnitAssessment_by_pk?: Maybe<BusinessUnitAssessment_>;
  /** fetch aggregated fields from the table: "BusinessUnit" */
  BusinessUnit_aggregate: BusinessUnit_Aggregate_;
  /** fetch data from the table: "BusinessUnit" using primary key columns */
  BusinessUnit_by_pk?: Maybe<BusinessUnit_>;
  /** fetch data from the table: "CachedResult" */
  CachedResult: Array<CachedResult_>;
  /** fetch aggregated fields from the table: "CachedResult" */
  CachedResult_aggregate: CachedResult_Aggregate_;
  /** fetch data from the table: "CachedResult" using primary key columns */
  CachedResult_by_pk?: Maybe<CachedResult_>;
  /** fetch data from the table: "esrs.ChoiceSet" */
  ChoiceSet: Array<ChoiceSet_>;
  /** fetch aggregated fields from the table: "esrs.ChoiceSet" */
  ChoiceSet_aggregate: ChoiceSet_Aggregate_;
  /** fetch data from the table: "esrs.ChoiceSet" using primary key columns */
  ChoiceSet_by_pk?: Maybe<ChoiceSet_>;
  /** fetch data from the table: "Comment" */
  Comment: Array<Comment_>;
  /** fetch aggregated fields from the table: "Comment" */
  Comment_aggregate: Comment_Aggregate_;
  /** fetch data from the table: "Comment" using primary key columns */
  Comment_by_pk?: Maybe<Comment_>;
  /** fetch data from the table: "Company" */
  Company: Array<Company_>;
  /** fetch data from the table: "CompanyAssessment" */
  CompanyAssessment: Array<CompanyAssessment_>;
  /** fetch data from the table: "CompanyAssessmentAggregate" */
  CompanyAssessmentAggregate: Array<CompanyAssessmentAggregate_>;
  /** fetch aggregated fields from the table: "CompanyAssessmentAggregate" */
  CompanyAssessmentAggregate_aggregate: CompanyAssessmentAggregate_Aggregate_;
  /** fetch data from the table: "CompanyAssessmentAggregate" using primary key columns */
  CompanyAssessmentAggregate_by_pk?: Maybe<CompanyAssessmentAggregate_>;
  /** fetch aggregated fields from the table: "CompanyAssessment" */
  CompanyAssessment_aggregate: CompanyAssessment_Aggregate_;
  /** fetch data from the table: "CompanyAssessment" using primary key columns */
  CompanyAssessment_by_pk?: Maybe<CompanyAssessment_>;
  /** fetch data from the table: "CompanyIdentityProvider" */
  CompanyIdentityProvider: Array<CompanyIdentityProvider_>;
  /** fetch aggregated fields from the table: "CompanyIdentityProvider" */
  CompanyIdentityProvider_aggregate: CompanyIdentityProvider_Aggregate_;
  /** fetch data from the table: "CompanyIdentityProvider" using primary key columns */
  CompanyIdentityProvider_by_pk?: Maybe<CompanyIdentityProvider_>;
  /** fetch data from the table: "CompanyInvitation" */
  CompanyInvitation: Array<CompanyInvitation_>;
  /** fetch aggregated fields from the table: "CompanyInvitation" */
  CompanyInvitation_aggregate: CompanyInvitation_Aggregate_;
  /** fetch data from the table: "CompanyInvitation" using primary key columns */
  CompanyInvitation_by_pk?: Maybe<CompanyInvitation_>;
  /** fetch data from the table: "CompanyUser" */
  CompanyUser: Array<CompanyUser_>;
  /** fetch aggregated fields from the table: "CompanyUser" */
  CompanyUser_aggregate: CompanyUser_Aggregate_;
  /** fetch data from the table: "CompanyUser" using primary key columns */
  CompanyUser_by_pk?: Maybe<CompanyUser_>;
  /** fetch aggregated fields from the table: "Company" */
  Company_aggregate: Company_Aggregate_;
  /** fetch data from the table: "Company" using primary key columns */
  Company_by_pk?: Maybe<Company_>;
  /** fetch data from the table: "CompassPAT" */
  CompassPAT: Array<CompassPat_>;
  /** fetch aggregated fields from the table: "CompassPAT" */
  CompassPAT_aggregate: CompassPat_Aggregate_;
  /** fetch data from the table: "CompassPAT" using primary key columns */
  CompassPAT_by_pk?: Maybe<CompassPat_>;
  /** fetch data from the table: "esrs.DRToMFDisclosureRequirement" */
  DRToMFDisclosureRequirement: Array<DrToMfDisclosureRequirement_>;
  /** fetch aggregated fields from the table: "esrs.DRToMFDisclosureRequirement" */
  DRToMFDisclosureRequirement_aggregate: DrToMfDisclosureRequirement_Aggregate_;
  /** fetch data from the table: "esrs.DRToMFDisclosureRequirement" using primary key columns */
  DRToMFDisclosureRequirement_by_pk?: Maybe<DrToMfDisclosureRequirement_>;
  /** fetch data from the table: "esrs.DisclosureRequirement" */
  DisclosureRequirement: Array<DisclosureRequirement_>;
  /** fetch data from the table: "esrs.DisclosureRequirementAdditionalType" */
  DisclosureRequirementAdditionalType: Array<DisclosureRequirementAdditionalType_>;
  /** fetch aggregated fields from the table: "esrs.DisclosureRequirementAdditionalType" */
  DisclosureRequirementAdditionalType_aggregate: DisclosureRequirementAdditionalType_Aggregate_;
  /** fetch data from the table: "esrs.DisclosureRequirementAdditionalType" using primary key columns */
  DisclosureRequirementAdditionalType_by_pk?: Maybe<DisclosureRequirementAdditionalType_>;
  /** fetch data from the table: "esrs.DisclosureRequirementGroup" */
  DisclosureRequirementGroup: Array<DisclosureRequirementGroup_>;
  /** fetch aggregated fields from the table: "esrs.DisclosureRequirementGroup" */
  DisclosureRequirementGroup_aggregate: DisclosureRequirementGroup_Aggregate_;
  /** fetch data from the table: "esrs.DisclosureRequirementGroup" using primary key columns */
  DisclosureRequirementGroup_by_pk?: Maybe<DisclosureRequirementGroup_>;
  /** fetch data from the table: "esrs.DisclosureRequirementOwner" */
  DisclosureRequirementOwner: Array<DisclosureRequirementOwner_>;
  /** fetch aggregated fields from the table: "esrs.DisclosureRequirementOwner" */
  DisclosureRequirementOwner_aggregate: DisclosureRequirementOwner_Aggregate_;
  /** fetch data from the table: "esrs.DisclosureRequirementOwner" using primary key columns */
  DisclosureRequirementOwner_by_pk?: Maybe<DisclosureRequirementOwner_>;
  /** fetch data from the table: "esrs.DisclosureRequirementStatus" */
  DisclosureRequirementStatus: Array<DisclosureRequirementStatus_>;
  /** fetch aggregated fields from the table: "esrs.DisclosureRequirementStatus" */
  DisclosureRequirementStatus_aggregate: DisclosureRequirementStatus_Aggregate_;
  /** fetch data from the table: "esrs.DisclosureRequirementStatus" using primary key columns */
  DisclosureRequirementStatus_by_pk?: Maybe<DisclosureRequirementStatus_>;
  /** fetch aggregated fields from the table: "esrs.DisclosureRequirement" */
  DisclosureRequirement_aggregate: DisclosureRequirement_Aggregate_;
  /** fetch data from the table: "esrs.DisclosureRequirement" using primary key columns */
  DisclosureRequirement_by_pk?: Maybe<DisclosureRequirement_>;
  /** fetch data from the table: "DocumentInsight" */
  DocumentInsight: Array<DocumentInsight_>;
  /** fetch aggregated fields from the table: "DocumentInsight" */
  DocumentInsight_aggregate: DocumentInsight_Aggregate_;
  /** fetch data from the table: "DocumentInsight" using primary key columns */
  DocumentInsight_by_pk?: Maybe<DocumentInsight_>;
  /** fetch data from the table: "DocumentationFile" */
  DocumentationFile: Array<DocumentationFile_>;
  /** fetch aggregated fields from the table: "DocumentationFile" */
  DocumentationFile_aggregate: DocumentationFile_Aggregate_;
  /** fetch data from the table: "DocumentationFile" using primary key columns */
  DocumentationFile_by_pk?: Maybe<DocumentationFile_>;
  /** fetch data from the table: "esrs.EsrsAssessment" */
  EsrsAssessment: Array<EsrsAssessment_>;
  /** fetch aggregated fields from the table: "esrs.EsrsAssessment" */
  EsrsAssessment_aggregate: EsrsAssessment_Aggregate_;
  /** fetch data from the table: "esrs.EsrsAssessment" using primary key columns */
  EsrsAssessment_by_pk?: Maybe<EsrsAssessment_>;
  /** fetch data from the table: "esrs.EsrsCategory" */
  EsrsCategory: Array<EsrsCategory_>;
  /** fetch aggregated fields from the table: "esrs.EsrsCategory" */
  EsrsCategory_aggregate: EsrsCategory_Aggregate_;
  /** fetch data from the table: "esrs.EsrsCategory" using primary key columns */
  EsrsCategory_by_pk?: Maybe<EsrsCategory_>;
  /** fetch data from the table: "esrs.EsrsChoice" */
  EsrsChoice: Array<EsrsChoice_>;
  /** fetch aggregated fields from the table: "esrs.EsrsChoice" */
  EsrsChoice_aggregate: EsrsChoice_Aggregate_;
  /** fetch data from the table: "esrs.EsrsChoice" using primary key columns */
  EsrsChoice_by_pk?: Maybe<EsrsChoice_>;
  /** fetch data from the table: "esrs.EsrsMetric" */
  EsrsMetric: Array<EsrsMetric_>;
  /** fetch data from the table: "esrs.EsrsMetricAdditionalType" */
  EsrsMetricAdditionalType: Array<EsrsMetricAdditionalType_>;
  /** fetch aggregated fields from the table: "esrs.EsrsMetricAdditionalType" */
  EsrsMetricAdditionalType_aggregate: EsrsMetricAdditionalType_Aggregate_;
  /** fetch data from the table: "esrs.EsrsMetricAdditionalType" using primary key columns */
  EsrsMetricAdditionalType_by_pk?: Maybe<EsrsMetricAdditionalType_>;
  /** fetch aggregated fields from the table: "esrs.EsrsMetric" */
  EsrsMetric_aggregate: EsrsMetric_Aggregate_;
  /** fetch data from the table: "esrs.EsrsMetric" using primary key columns */
  EsrsMetric_by_pk?: Maybe<EsrsMetric_>;
  /** fetch data from the table: "esrs.EsrsStandard" */
  EsrsStandard: Array<EsrsStandard_>;
  /** fetch data from the table: "esrs.EsrsStandardAdditionalType" */
  EsrsStandardAdditionalType: Array<EsrsStandardAdditionalType_>;
  /** fetch aggregated fields from the table: "esrs.EsrsStandardAdditionalType" */
  EsrsStandardAdditionalType_aggregate: EsrsStandardAdditionalType_Aggregate_;
  /** fetch data from the table: "esrs.EsrsStandardAdditionalType" using primary key columns */
  EsrsStandardAdditionalType_by_pk?: Maybe<EsrsStandardAdditionalType_>;
  /** fetch aggregated fields from the table: "esrs.EsrsStandard" */
  EsrsStandard_aggregate: EsrsStandard_Aggregate_;
  /** fetch data from the table: "esrs.EsrsStandard" using primary key columns */
  EsrsStandard_by_pk?: Maybe<EsrsStandard_>;
  /** fetch data from the table: "EstimateCompany_deprecated" */
  EstimateCompany_deprecated: Array<EstimateCompany_Deprecated_>;
  /** fetch aggregated fields from the table: "EstimateCompany_deprecated" */
  EstimateCompany_deprecated_aggregate: EstimateCompany_Deprecated_Aggregate_;
  /** fetch data from the table: "EstimateCompany_deprecated" using primary key columns */
  EstimateCompany_deprecated_by_pk?: Maybe<EstimateCompany_Deprecated_>;
  /** fetch data from the table: "ExtractionJob" */
  ExtractionJob: Array<ExtractionJob_>;
  /** fetch aggregated fields from the table: "ExtractionJob" */
  ExtractionJob_aggregate: ExtractionJob_Aggregate_;
  /** fetch data from the table: "ExtractionJob" using primary key columns */
  ExtractionJob_by_pk?: Maybe<ExtractionJob_>;
  /** fetch data from the table: "Financials" */
  Financials: Array<Financials_>;
  /** fetch aggregated fields from the table: "Financials" */
  Financials_aggregate: Financials_Aggregate_;
  /** fetch data from the table: "Financials" using primary key columns */
  Financials_by_pk?: Maybe<Financials_>;
  /** fetch data from the table: "esrs.Framework" */
  Framework: Array<Framework_>;
  /** fetch aggregated fields from the table: "esrs.Framework" */
  Framework_aggregate: Framework_Aggregate_;
  /** fetch data from the table: "esrs.Framework" using primary key columns */
  Framework_by_pk?: Maybe<Framework_>;
  /** fetch data from the table: "GroupAssessment" */
  GroupAssessment: Array<GroupAssessment_>;
  /** fetch aggregated fields from the table: "GroupAssessment" */
  GroupAssessment_aggregate: GroupAssessment_Aggregate_;
  /** fetch data from the table: "GroupAssessment" using primary key columns */
  GroupAssessment_by_pk?: Maybe<GroupAssessment_>;
  /** fetch data from the table: "IdentityProvider" */
  IdentityProvider: Array<IdentityProvider_>;
  /** fetch aggregated fields from the table: "IdentityProvider" */
  IdentityProvider_aggregate: IdentityProvider_Aggregate_;
  /** fetch data from the table: "IdentityProvider" using primary key columns */
  IdentityProvider_by_pk?: Maybe<IdentityProvider_>;
  /** fetch data from the table: "IndicatorToInvestorMetric" */
  IndicatorToInvestorMetric: Array<IndicatorToInvestorMetric_>;
  /** fetch aggregated fields from the table: "IndicatorToInvestorMetric" */
  IndicatorToInvestorMetric_aggregate: IndicatorToInvestorMetric_Aggregate_;
  /** fetch data from the table: "IndicatorToInvestorMetric" using primary key columns */
  IndicatorToInvestorMetric_by_pk?: Maybe<IndicatorToInvestorMetric_>;
  /** fetch data from the table: "InvesteeMetric" */
  InvesteeMetric: Array<InvesteeMetric_>;
  /** fetch aggregated fields from the table: "InvesteeMetric" */
  InvesteeMetric_aggregate: InvesteeMetric_Aggregate_;
  /** fetch data from the table: "InvesteeMetric" using primary key columns */
  InvesteeMetric_by_pk?: Maybe<InvesteeMetric_>;
  /** fetch data from the table: "InvestmentCategory" */
  InvestmentCategory: Array<InvestmentCategory_>;
  /** fetch aggregated fields from the table: "InvestmentCategory" */
  InvestmentCategory_aggregate: InvestmentCategory_Aggregate_;
  /** fetch data from the table: "InvestmentCategory" using primary key columns */
  InvestmentCategory_by_pk?: Maybe<InvestmentCategory_>;
  /** fetch data from the table: "InvestorMetric" */
  InvestorMetric: Array<InvestorMetric_>;
  /** fetch aggregated fields from the table: "InvestorMetric" */
  InvestorMetric_aggregate: InvestorMetric_Aggregate_;
  /** fetch data from the table: "InvestorMetric" using primary key columns */
  InvestorMetric_by_pk?: Maybe<InvestorMetric_>;
  /** fetch data from the table: "InvestorToInvesteeMetric" */
  InvestorToInvesteeMetric: Array<InvestorToInvesteeMetric_>;
  /** fetch aggregated fields from the table: "InvestorToInvesteeMetric" */
  InvestorToInvesteeMetric_aggregate: InvestorToInvesteeMetric_Aggregate_;
  /** fetch data from the table: "InvestorToInvesteeMetric" using primary key columns */
  InvestorToInvesteeMetric_by_pk?: Maybe<InvestorToInvesteeMetric_>;
  /** fetch data from the table: "esrs.MFCategory" */
  MFCategory: Array<MfCategory_>;
  /** fetch aggregated fields from the table: "esrs.MFCategory" */
  MFCategory_aggregate: MfCategory_Aggregate_;
  /** fetch data from the table: "esrs.MFCategory" using primary key columns */
  MFCategory_by_pk?: Maybe<MfCategory_>;
  /** fetch data from the table: "esrs.MFDisclosureRequirement" */
  MFDisclosureRequirement: Array<MfDisclosureRequirement_>;
  /** fetch data from the table: "esrs.MFDisclosureRequirementGroup" */
  MFDisclosureRequirementGroup: Array<MfDisclosureRequirementGroup_>;
  /** fetch aggregated fields from the table: "esrs.MFDisclosureRequirementGroup" */
  MFDisclosureRequirementGroup_aggregate: MfDisclosureRequirementGroup_Aggregate_;
  /** fetch data from the table: "esrs.MFDisclosureRequirementGroup" using primary key columns */
  MFDisclosureRequirementGroup_by_pk?: Maybe<MfDisclosureRequirementGroup_>;
  /** fetch data from the table: "esrs.MFDisclosureRequirementItem" */
  MFDisclosureRequirementItem: Array<MfDisclosureRequirementItem_>;
  /** fetch aggregated fields from the table: "esrs.MFDisclosureRequirementItem" */
  MFDisclosureRequirementItem_aggregate: MfDisclosureRequirementItem_Aggregate_;
  /** fetch data from the table: "esrs.MFDisclosureRequirementItem" using primary key columns */
  MFDisclosureRequirementItem_by_pk?: Maybe<MfDisclosureRequirementItem_>;
  /** fetch aggregated fields from the table: "esrs.MFDisclosureRequirement" */
  MFDisclosureRequirement_aggregate: MfDisclosureRequirement_Aggregate_;
  /** fetch data from the table: "esrs.MFDisclosureRequirement" using primary key columns */
  MFDisclosureRequirement_by_pk?: Maybe<MfDisclosureRequirement_>;
  /** fetch data from the table: "esrs.MFStandard" */
  MFStandard: Array<MfStandard_>;
  /** fetch data from the table: "esrs.MFStandardItem" */
  MFStandardItem: Array<MfStandardItem_>;
  /** fetch aggregated fields from the table: "esrs.MFStandardItem" */
  MFStandardItem_aggregate: MfStandardItem_Aggregate_;
  /** fetch data from the table: "esrs.MFStandardItem" using primary key columns */
  MFStandardItem_by_pk?: Maybe<MfStandardItem_>;
  /** fetch aggregated fields from the table: "esrs.MFStandard" */
  MFStandard_aggregate: MfStandard_Aggregate_;
  /** fetch data from the table: "esrs.MFStandard" using primary key columns */
  MFStandard_by_pk?: Maybe<MfStandard_>;
  /** fetch data from the table: "esrs.MaterialStandardOwner" */
  MaterialStandardOwner: Array<MaterialStandardOwner_>;
  /** fetch aggregated fields from the table: "esrs.MaterialStandardOwner" */
  MaterialStandardOwner_aggregate: MaterialStandardOwner_Aggregate_;
  /** fetch data from the table: "esrs.MaterialStandardOwner" using primary key columns */
  MaterialStandardOwner_by_pk?: Maybe<MaterialStandardOwner_>;
  /** fetch data from the table: "esrs.MetricDependency" */
  MetricDependency: Array<MetricDependency_>;
  /** fetch aggregated fields from the table: "esrs.MetricDependency" */
  MetricDependency_aggregate: MetricDependency_Aggregate_;
  /** fetch data from the table: "esrs.MetricDependency" using primary key columns */
  MetricDependency_by_pk?: Maybe<MetricDependency_>;
  /** fetch data from the table: "esrs.MetricTag" */
  MetricTag: Array<MetricTag_>;
  /** fetch aggregated fields from the table: "esrs.MetricTag" */
  MetricTag_aggregate: MetricTag_Aggregate_;
  /** fetch data from the table: "esrs.MetricTag" using primary key columns */
  MetricTag_by_pk?: Maybe<MetricTag_>;
  /** fetch data from the table: "NonMaterialFinancials" */
  NonMaterialFinancials: Array<NonMaterialFinancials_>;
  /** fetch aggregated fields from the table: "NonMaterialFinancials" */
  NonMaterialFinancials_aggregate: NonMaterialFinancials_Aggregate_;
  /** fetch data from the table: "Note" */
  Note: Array<Note_>;
  /** fetch data from the table: "NoteHistory" */
  NoteHistory: Array<NoteHistory_>;
  /** fetch aggregated fields from the table: "NoteHistory" */
  NoteHistory_aggregate: NoteHistory_Aggregate_;
  /** fetch data from the table: "NoteHistory" using primary key columns */
  NoteHistory_by_pk?: Maybe<NoteHistory_>;
  /** fetch aggregated fields from the table: "Note" */
  Note_aggregate: Note_Aggregate_;
  /** fetch data from the table: "Note" using primary key columns */
  Note_by_pk?: Maybe<Note_>;
  /** fetch data from the table: "Objective" */
  Objective: Array<Objective_>;
  /** fetch aggregated fields from the table: "Objective" */
  Objective_aggregate: Objective_Aggregate_;
  /** fetch data from the table: "Objective" using primary key columns */
  Objective_by_pk?: Maybe<Objective_>;
  /** fetch data from the table: "PaiAnswers" */
  PaiAnswers: Array<PaiAnswers_>;
  /** fetch aggregated fields from the table: "PaiAnswers" */
  PaiAnswers_aggregate: PaiAnswers_Aggregate_;
  /** fetch data from the table: "PaiAnswers" using primary key columns */
  PaiAnswers_by_pk?: Maybe<PaiAnswers_>;
  /** fetch data from the table: "PaiCategory" */
  PaiCategory: Array<PaiCategory_>;
  /** fetch aggregated fields from the table: "PaiCategory" */
  PaiCategory_aggregate: PaiCategory_Aggregate_;
  /** fetch data from the table: "PaiCategory" using primary key columns */
  PaiCategory_by_pk?: Maybe<PaiCategory_>;
  /** fetch data from the table: "PaiCompanyReport" */
  PaiCompanyReport: Array<PaiCompanyReport_>;
  /** fetch aggregated fields from the table: "PaiCompanyReport" */
  PaiCompanyReport_aggregate: PaiCompanyReport_Aggregate_;
  /** fetch data from the table: "PaiCompanyReport" using primary key columns */
  PaiCompanyReport_by_pk?: Maybe<PaiCompanyReport_>;
  /** fetch data from the table: "PaiMetricInsight" */
  PaiMetricInsight: Array<PaiMetricInsight_>;
  /** fetch aggregated fields from the table: "PaiMetricInsight" */
  PaiMetricInsight_aggregate: PaiMetricInsight_Aggregate_;
  /** fetch data from the table: "PaiMetricInsight" using primary key columns */
  PaiMetricInsight_by_pk?: Maybe<PaiMetricInsight_>;
  /** fetch data from the table: "PaiPortfolioReport" */
  PaiPortfolioReport: Array<PaiPortfolioReport_>;
  /** fetch aggregated fields from the table: "PaiPortfolioReport" */
  PaiPortfolioReport_aggregate: PaiPortfolioReport_Aggregate_;
  /** fetch data from the table: "PaiPortfolioReport" using primary key columns */
  PaiPortfolioReport_by_pk?: Maybe<PaiPortfolioReport_>;
  /** fetch data from the table: "PaiReportIndicator" */
  PaiReportIndicator: Array<PaiReportIndicator_>;
  /** fetch data from the table: "PaiReportIndicatorPortfolioCompany" */
  PaiReportIndicatorPortfolioCompany: Array<PaiReportIndicatorPortfolioCompany_>;
  /** fetch aggregated fields from the table: "PaiReportIndicatorPortfolioCompany" */
  PaiReportIndicatorPortfolioCompany_aggregate: PaiReportIndicatorPortfolioCompany_Aggregate_;
  /** fetch data from the table: "PaiReportIndicatorPortfolioCompany" using primary key columns */
  PaiReportIndicatorPortfolioCompany_by_pk?: Maybe<PaiReportIndicatorPortfolioCompany_>;
  /** fetch aggregated fields from the table: "PaiReportIndicator" */
  PaiReportIndicator_aggregate: PaiReportIndicator_Aggregate_;
  /** fetch data from the table: "PaiReportIndicator" using primary key columns */
  PaiReportIndicator_by_pk?: Maybe<PaiReportIndicator_>;
  /** fetch data from the table: "PaiTable" */
  PaiTable: Array<PaiTable_>;
  /** fetch data from the table: "PaiTableIndicator" */
  PaiTableIndicator: Array<PaiTableIndicator_>;
  /** fetch aggregated fields from the table: "PaiTableIndicator" */
  PaiTableIndicator_aggregate: PaiTableIndicator_Aggregate_;
  /** fetch data from the table: "PaiTableIndicator" using primary key columns */
  PaiTableIndicator_by_pk?: Maybe<PaiTableIndicator_>;
  /** fetch aggregated fields from the table: "PaiTable" */
  PaiTable_aggregate: PaiTable_Aggregate_;
  /** fetch data from the table: "PaiTable" using primary key columns */
  PaiTable_by_pk?: Maybe<PaiTable_>;
  /** fetch data from the table: "Portfolio" */
  Portfolio: Array<Portfolio_>;
  /** fetch data from the table: "PortfolioCompany" */
  PortfolioCompany: Array<PortfolioCompany_>;
  /** fetch aggregated fields from the table: "PortfolioCompany" */
  PortfolioCompany_aggregate: PortfolioCompany_Aggregate_;
  /** fetch data from the table: "PortfolioCompany" using primary key columns */
  PortfolioCompany_by_pk?: Maybe<PortfolioCompany_>;
  /** fetch data from the table: "PortfolioNonEligibleFinancials" */
  PortfolioNonEligibleFinancials: Array<PortfolioNonEligibleFinancials_>;
  /** fetch aggregated fields from the table: "PortfolioNonEligibleFinancials" */
  PortfolioNonEligibleFinancials_aggregate: PortfolioNonEligibleFinancials_Aggregate_;
  /** fetch data from the table: "PortfolioNonEligibleFinancials" using primary key columns */
  PortfolioNonEligibleFinancials_by_pk?: Maybe<PortfolioNonEligibleFinancials_>;
  /** fetch aggregated fields from the table: "Portfolio" */
  Portfolio_aggregate: Portfolio_Aggregate_;
  /** fetch data from the table: "Portfolio" using primary key columns */
  Portfolio_by_pk?: Maybe<Portfolio_>;
  /** fetch data from the table: "QuarterEnum" */
  QuarterEnum: Array<QuarterEnum_>;
  /** fetch aggregated fields from the table: "QuarterEnum" */
  QuarterEnum_aggregate: QuarterEnum_Aggregate_;
  /** fetch data from the table: "QuarterEnum" using primary key columns */
  QuarterEnum_by_pk?: Maybe<QuarterEnum_>;
  /** fetch data from the table: "Question" */
  Question: Array<Question_>;
  /** fetch data from the table: "QuestionChoice" */
  QuestionChoice: Array<QuestionChoice_>;
  /** fetch aggregated fields from the table: "QuestionChoice" */
  QuestionChoice_aggregate: QuestionChoice_Aggregate_;
  /** fetch data from the table: "QuestionChoice" using primary key columns */
  QuestionChoice_by_pk?: Maybe<QuestionChoice_>;
  /** fetch data from the table: "QuestionLevel" */
  QuestionLevel: Array<QuestionLevel_>;
  /** fetch aggregated fields from the table: "QuestionLevel" */
  QuestionLevel_aggregate: QuestionLevel_Aggregate_;
  /** fetch data from the table: "QuestionLevel" using primary key columns */
  QuestionLevel_by_pk?: Maybe<QuestionLevel_>;
  /** fetch data from the table: "QuestionRevision" */
  QuestionRevision: Array<QuestionRevision_>;
  /** fetch aggregated fields from the table: "QuestionRevision" */
  QuestionRevision_aggregate: QuestionRevision_Aggregate_;
  /** fetch data from the table: "QuestionRevision" using primary key columns */
  QuestionRevision_by_pk?: Maybe<QuestionRevision_>;
  /** fetch data from the table: "QuestionSet" */
  QuestionSet: Array<QuestionSet_>;
  /** fetch data from the table: "QuestionSetQuestion" */
  QuestionSetQuestion: Array<QuestionSetQuestion_>;
  /** fetch aggregated fields from the table: "QuestionSetQuestion" */
  QuestionSetQuestion_aggregate: QuestionSetQuestion_Aggregate_;
  /** fetch data from the table: "QuestionSetQuestion" using primary key columns */
  QuestionSetQuestion_by_pk?: Maybe<QuestionSetQuestion_>;
  /** fetch aggregated fields from the table: "QuestionSet" */
  QuestionSet_aggregate: QuestionSet_Aggregate_;
  /** fetch data from the table: "QuestionSet" using primary key columns */
  QuestionSet_by_pk?: Maybe<QuestionSet_>;
  /** fetch data from the table: "QuestionType" */
  QuestionType: Array<QuestionType_>;
  /** fetch aggregated fields from the table: "QuestionType" */
  QuestionType_aggregate: QuestionType_Aggregate_;
  /** fetch data from the table: "QuestionType" using primary key columns */
  QuestionType_by_pk?: Maybe<QuestionType_>;
  /** fetch aggregated fields from the table: "Question" */
  Question_aggregate: Question_Aggregate_;
  /** fetch data from the table: "Question" using primary key columns */
  Question_by_pk?: Maybe<Question_>;
  /** fetch data from the table: "ReportingGroup" */
  ReportingGroup: Array<ReportingGroup_>;
  /** fetch aggregated fields from the table: "ReportingGroup" */
  ReportingGroup_aggregate: ReportingGroup_Aggregate_;
  /** fetch data from the table: "ReportingGroup" using primary key columns */
  ReportingGroup_by_pk?: Maybe<ReportingGroup_>;
  /** fetch data from the table: "Sector" */
  Sector: Array<Sector_>;
  /** fetch aggregated fields from the table: "Sector" */
  Sector_aggregate: Sector_Aggregate_;
  /** fetch data from the table: "Sector" using primary key columns */
  Sector_by_pk?: Maybe<Sector_>;
  /** fetch data from the table: "SharedSpace" */
  SharedSpace: Array<SharedSpace_>;
  /** fetch aggregated fields from the table: "SharedSpace" */
  SharedSpace_aggregate: SharedSpace_Aggregate_;
  /** fetch data from the table: "SharedSpace" using primary key columns */
  SharedSpace_by_pk?: Maybe<SharedSpace_>;
  /** fetch data from the table: "Space" */
  Space: Array<Space_>;
  /** fetch aggregated fields from the table: "Space" */
  Space_aggregate: Space_Aggregate_;
  /** fetch data from the table: "Space" using primary key columns */
  Space_by_pk?: Maybe<Space_>;
  /** fetch data from the table: "Subsidiary" */
  Subsidiary: Array<Subsidiary_>;
  /** fetch aggregated fields from the table: "Subsidiary" */
  Subsidiary_aggregate: Subsidiary_Aggregate_;
  /** fetch data from the table: "Subsidiary" using primary key columns */
  Subsidiary_by_pk?: Maybe<Subsidiary_>;
  /** fetch data from the table: "Tag" */
  Tag: Array<Tag_>;
  /** fetch data from the table: "TagGroup" */
  TagGroup: Array<TagGroup_>;
  /** fetch aggregated fields from the table: "TagGroup" */
  TagGroup_aggregate: TagGroup_Aggregate_;
  /** fetch data from the table: "TagGroup" using primary key columns */
  TagGroup_by_pk?: Maybe<TagGroup_>;
  /** fetch data from the table: "esrs.TagType" */
  TagType: Array<TagType_>;
  /** fetch aggregated fields from the table: "esrs.TagType" */
  TagType_aggregate: TagType_Aggregate_;
  /** fetch data from the table: "esrs.TagType" using primary key columns */
  TagType_by_pk?: Maybe<TagType_>;
  /** fetch data from the table: "esrs.TagValue" */
  TagValue: Array<TagValue_>;
  /** fetch aggregated fields from the table: "esrs.TagValue" */
  TagValue_aggregate: TagValue_Aggregate_;
  /** fetch data from the table: "esrs.TagValue" using primary key columns */
  TagValue_by_pk?: Maybe<TagValue_>;
  /** fetch aggregated fields from the table: "Tag" */
  Tag_aggregate: Tag_Aggregate_;
  /** An array relationship */
  Tag_articles: Array<Tag_Articles_>;
  /** An aggregate relationship */
  Tag_articles_aggregate: Tag_Articles_Aggregate_;
  /** fetch data from the table: "Tag_articles" using primary key columns */
  Tag_articles_by_pk?: Maybe<Tag_Articles_>;
  /** fetch data from the table: "Tag" using primary key columns */
  Tag_by_pk?: Maybe<Tag_>;
  /** fetch data from the table: "esrs.TargetQuestion" */
  TargetQuestion: Array<TargetQuestion_>;
  /** fetch data from the table: "esrs.TargetQuestionGroup" */
  TargetQuestionGroup: Array<TargetQuestionGroup_>;
  /** fetch aggregated fields from the table: "esrs.TargetQuestionGroup" */
  TargetQuestionGroup_aggregate: TargetQuestionGroup_Aggregate_;
  /** fetch data from the table: "esrs.TargetQuestionGroup" using primary key columns */
  TargetQuestionGroup_by_pk?: Maybe<TargetQuestionGroup_>;
  /** fetch aggregated fields from the table: "esrs.TargetQuestion" */
  TargetQuestion_aggregate: TargetQuestion_Aggregate_;
  /** fetch data from the table: "esrs.TargetQuestion" using primary key columns */
  TargetQuestion_by_pk?: Maybe<TargetQuestion_>;
  /** fetch data from the table: "Task" */
  Task: Array<Task_>;
  /** fetch data from the table: "TaskStatusEnum" */
  TaskStatusEnum: Array<TaskStatusEnum_>;
  /** fetch aggregated fields from the table: "TaskStatusEnum" */
  TaskStatusEnum_aggregate: TaskStatusEnum_Aggregate_;
  /** fetch data from the table: "TaskStatusEnum" using primary key columns */
  TaskStatusEnum_by_pk?: Maybe<TaskStatusEnum_>;
  /** fetch aggregated fields from the table: "Task" */
  Task_aggregate: Task_Aggregate_;
  /** fetch data from the table: "Task" using primary key columns */
  Task_by_pk?: Maybe<Task_>;
  /** fetch data from the table: "TaxonomyPortfolioReport" */
  TaxonomyPortfolioReport: Array<TaxonomyPortfolioReport_>;
  /** fetch aggregated fields from the table: "TaxonomyPortfolioReport" */
  TaxonomyPortfolioReport_aggregate: TaxonomyPortfolioReport_Aggregate_;
  /** fetch data from the table: "TaxonomyPortfolioReport" using primary key columns */
  TaxonomyPortfolioReport_by_pk?: Maybe<TaxonomyPortfolioReport_>;
  /** fetch data from the table: "Thread" */
  Thread: Array<Thread_>;
  /** fetch data from the table: "ThreadSubscriber" */
  ThreadSubscriber: Array<ThreadSubscriber_>;
  /** fetch aggregated fields from the table: "ThreadSubscriber" */
  ThreadSubscriber_aggregate: ThreadSubscriber_Aggregate_;
  /** fetch data from the table: "ThreadSubscriber" using primary key columns */
  ThreadSubscriber_by_pk?: Maybe<ThreadSubscriber_>;
  /** fetch aggregated fields from the table: "Thread" */
  Thread_aggregate: Thread_Aggregate_;
  /** fetch data from the table: "Thread" using primary key columns */
  Thread_by_pk?: Maybe<Thread_>;
  /** fetch data from the table: "TotalComparisonFinancials" */
  TotalComparisonFinancials: Array<TotalComparisonFinancials_>;
  /** fetch aggregated fields from the table: "TotalComparisonFinancials" */
  TotalComparisonFinancials_aggregate: TotalComparisonFinancials_Aggregate_;
  /** fetch data from the table: "TriggerTypes" */
  TriggerTypes: Array<TriggerTypes_>;
  /** fetch aggregated fields from the table: "TriggerTypes" */
  TriggerTypes_aggregate: TriggerTypes_Aggregate_;
  /** fetch data from the table: "TriggerTypes" using primary key columns */
  TriggerTypes_by_pk?: Maybe<TriggerTypes_>;
  /** fetch data from the table: "UserNotification" */
  UserNotification: Array<UserNotification_>;
  /** fetch aggregated fields from the table: "UserNotification" */
  UserNotification_aggregate: UserNotification_Aggregate_;
  /** fetch data from the table: "UserNotification" using primary key columns */
  UserNotification_by_pk?: Maybe<UserNotification_>;
  /** fetch data from the table: "UserRole" */
  UserRole: Array<UserRole_>;
  /** fetch aggregated fields from the table: "UserRole" */
  UserRole_aggregate: UserRole_Aggregate_;
  /** fetch data from the table: "UserRole" using primary key columns */
  UserRole_by_pk?: Maybe<UserRole_>;
  /** fetch data from the table: "UserSessionMetadata" */
  UserSessionMetadata: Array<UserSessionMetadata_>;
  /** fetch aggregated fields from the table: "UserSessionMetadata" */
  UserSessionMetadata_aggregate: UserSessionMetadata_Aggregate_;
  /** fetch data from the table: "UserSessionMetadata" using primary key columns */
  UserSessionMetadata_by_pk?: Maybe<UserSessionMetadata_>;
  /** fetch data from the table: "WebsocketTest" */
  WebsocketTest: Array<WebsocketTest_>;
  /** fetch aggregated fields from the table: "WebsocketTest" */
  WebsocketTest_aggregate: WebsocketTest_Aggregate_;
  /** fetch data from the table: "WebsocketTest" using primary key columns */
  WebsocketTest_by_pk?: Maybe<WebsocketTest_>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders_>;
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests_>;
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests_>;
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate_;
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders_>;
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate_;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens_>;
  /** fetch data from the table: "auth.refresh_token_types" using primary key columns */
  authRefreshTokenType?: Maybe<AuthRefreshTokenTypes_>;
  /** fetch data from the table: "auth.refresh_token_types" */
  authRefreshTokenTypes: Array<AuthRefreshTokenTypes_>;
  /** fetch aggregated fields from the table: "auth.refresh_token_types" */
  authRefreshTokenTypesAggregate: AuthRefreshTokenTypes_Aggregate_;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens_>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate_;
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles_>;
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles_>;
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate_;
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders_>;
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders_>;
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate_;
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles_>;
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles_>;
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate_;
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys_>;
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys_>;
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate_;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets_>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets_>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate_;
  /** fetch data from the table: "esrs.ActionReportingUnit" */
  esrs_ActionReportingUnit: Array<Esrs_ActionReportingUnit_>;
  /** fetch aggregated fields from the table: "esrs.ActionReportingUnit" */
  esrs_ActionReportingUnit_aggregate: Esrs_ActionReportingUnit_Aggregate_;
  /** fetch data from the table: "esrs.ActionReportingUnit" using primary key columns */
  esrs_ActionReportingUnit_by_pk?: Maybe<Esrs_ActionReportingUnit_>;
  /** fetch data from the table: "esrs.ActionSubsidiary" */
  esrs_ActionSubsidiary: Array<Esrs_ActionSubsidiary_>;
  /** fetch aggregated fields from the table: "esrs.ActionSubsidiary" */
  esrs_ActionSubsidiary_aggregate: Esrs_ActionSubsidiary_Aggregate_;
  /** fetch data from the table: "esrs.ActionSubsidiary" using primary key columns */
  esrs_ActionSubsidiary_by_pk?: Maybe<Esrs_ActionSubsidiary_>;
  /** fetch data from the table: "esrs.ActionTarget" */
  esrs_ActionTarget: Array<Esrs_ActionTarget_>;
  /** fetch aggregated fields from the table: "esrs.ActionTarget" */
  esrs_ActionTarget_aggregate: Esrs_ActionTarget_Aggregate_;
  /** fetch data from the table: "esrs.ActionTarget" using primary key columns */
  esrs_ActionTarget_by_pk?: Maybe<Esrs_ActionTarget_>;
  /** fetch data from the table: "esrs.Actions" */
  esrs_Actions: Array<Esrs_Actions_>;
  /** fetch aggregated fields from the table: "esrs.Actions" */
  esrs_Actions_aggregate: Esrs_Actions_Aggregate_;
  /** fetch data from the table: "esrs.Actions" using primary key columns */
  esrs_Actions_by_pk?: Maybe<Esrs_Actions_>;
  /** fetch data from the table: "esrs.Answer" */
  esrs_Answer: Array<Esrs_Answer_>;
  /** fetch aggregated fields from the table: "esrs.Answer" */
  esrs_Answer_aggregate: Esrs_Answer_Aggregate_;
  /** fetch data from the table: "esrs.Answer" using primary key columns */
  esrs_Answer_by_pk?: Maybe<Esrs_Answer_>;
  /** fetch data from the table: "esrs.AssessmentCurrencyConversion" */
  esrs_AssessmentCurrencyConversion: Array<Esrs_AssessmentCurrencyConversion_>;
  /** fetch aggregated fields from the table: "esrs.AssessmentCurrencyConversion" */
  esrs_AssessmentCurrencyConversion_aggregate: Esrs_AssessmentCurrencyConversion_Aggregate_;
  /** fetch data from the table: "esrs.AssessmentCurrencyConversion" using primary key columns */
  esrs_AssessmentCurrencyConversion_by_pk?: Maybe<Esrs_AssessmentCurrencyConversion_>;
  /** fetch data from the table: "esrs.Baseline" */
  esrs_Baseline: Array<Esrs_Baseline_>;
  /** fetch aggregated fields from the table: "esrs.Baseline" */
  esrs_Baseline_aggregate: Esrs_Baseline_Aggregate_;
  /** fetch data from the table: "esrs.Baseline" using primary key columns */
  esrs_Baseline_by_pk?: Maybe<Esrs_Baseline_>;
  /** fetch data from the table: "esrs.CompanyIntegration" */
  esrs_CompanyIntegration: Array<Esrs_CompanyIntegration_>;
  /** fetch aggregated fields from the table: "esrs.CompanyIntegration" */
  esrs_CompanyIntegration_aggregate: Esrs_CompanyIntegration_Aggregate_;
  /** fetch data from the table: "esrs.CompanyIntegration" using primary key columns */
  esrs_CompanyIntegration_by_pk?: Maybe<Esrs_CompanyIntegration_>;
  /** fetch data from the table: "esrs.Datapoint" */
  esrs_Datapoint: Array<Esrs_Datapoint_>;
  /** fetch data from the table: "esrs.DatapointChoice" */
  esrs_DatapointChoice: Array<Esrs_DatapointChoice_>;
  /** fetch aggregated fields from the table: "esrs.DatapointChoice" */
  esrs_DatapointChoice_aggregate: Esrs_DatapointChoice_Aggregate_;
  /** fetch data from the table: "esrs.DatapointChoice" using primary key columns */
  esrs_DatapointChoice_by_pk?: Maybe<Esrs_DatapointChoice_>;
  /** fetch data from the table: "esrs.DatapointMdrm" */
  esrs_DatapointMdrm: Array<Esrs_DatapointMdrm_>;
  /** fetch aggregated fields from the table: "esrs.DatapointMdrm" */
  esrs_DatapointMdrm_aggregate: Esrs_DatapointMdrm_Aggregate_;
  /** fetch data from the table: "esrs.DatapointMdrm" using primary key columns */
  esrs_DatapointMdrm_by_pk?: Maybe<Esrs_DatapointMdrm_>;
  /** fetch data from the table: "esrs.DatapointTag" */
  esrs_DatapointTag: Array<Esrs_DatapointTag_>;
  /** fetch aggregated fields from the table: "esrs.DatapointTag" */
  esrs_DatapointTag_aggregate: Esrs_DatapointTag_Aggregate_;
  /** fetch data from the table: "esrs.DatapointTag" using primary key columns */
  esrs_DatapointTag_by_pk?: Maybe<Esrs_DatapointTag_>;
  /** fetch aggregated fields from the table: "esrs.Datapoint" */
  esrs_Datapoint_aggregate: Esrs_Datapoint_Aggregate_;
  /** fetch data from the table: "esrs.Datapoint" using primary key columns */
  esrs_Datapoint_by_pk?: Maybe<Esrs_Datapoint_>;
  /** fetch data from the table: "esrs.Deprecated_ActionBusinessUnit" */
  esrs_Deprecated_ActionBusinessUnit: Array<Esrs_Deprecated_ActionBusinessUnit_>;
  /** fetch aggregated fields from the table: "esrs.Deprecated_ActionBusinessUnit" */
  esrs_Deprecated_ActionBusinessUnit_aggregate: Esrs_Deprecated_ActionBusinessUnit_Aggregate_;
  /** fetch data from the table: "esrs.Deprecated_ActionBusinessUnit" using primary key columns */
  esrs_Deprecated_ActionBusinessUnit_by_pk?: Maybe<Esrs_Deprecated_ActionBusinessUnit_>;
  /** fetch data from the table: "esrs.Deprecated_BusinessUnitEsrsAssessment" */
  esrs_Deprecated_BusinessUnitEsrsAssessment: Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_>;
  /** fetch aggregated fields from the table: "esrs.Deprecated_BusinessUnitEsrsAssessment" */
  esrs_Deprecated_BusinessUnitEsrsAssessment_aggregate: Esrs_Deprecated_BusinessUnitEsrsAssessment_Aggregate_;
  /** fetch data from the table: "esrs.Deprecated_BusinessUnitEsrsAssessment" using primary key columns */
  esrs_Deprecated_BusinessUnitEsrsAssessment_by_pk?: Maybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_>;
  /** fetch data from the table: "esrs.Deprecated_CompanyMaterialityAssessment" */
  esrs_Deprecated_CompanyMaterialityAssessment: Array<Esrs_Deprecated_CompanyMaterialityAssessment_>;
  /** fetch aggregated fields from the table: "esrs.Deprecated_CompanyMaterialityAssessment" */
  esrs_Deprecated_CompanyMaterialityAssessment_aggregate: Esrs_Deprecated_CompanyMaterialityAssessment_Aggregate_;
  /** fetch data from the table: "esrs.Deprecated_CompanyMaterialityAssessment" using primary key columns */
  esrs_Deprecated_CompanyMaterialityAssessment_by_pk?: Maybe<Esrs_Deprecated_CompanyMaterialityAssessment_>;
  /** fetch data from the table: "esrs.Deprecated_EsrsMDRM" */
  esrs_Deprecated_EsrsMDRM: Array<Esrs_Deprecated_EsrsMdrm_>;
  /** fetch aggregated fields from the table: "esrs.Deprecated_EsrsMDRM" */
  esrs_Deprecated_EsrsMDRM_aggregate: Esrs_Deprecated_EsrsMdrm_Aggregate_;
  /** fetch data from the table: "esrs.Deprecated_EsrsMDRM" using primary key columns */
  esrs_Deprecated_EsrsMDRM_by_pk?: Maybe<Esrs_Deprecated_EsrsMdrm_>;
  /** fetch data from the table: "esrs.Deprecated_MaterialDisclosureRequirement" */
  esrs_Deprecated_MaterialDisclosureRequirement: Array<Esrs_Deprecated_MaterialDisclosureRequirement_>;
  /** fetch aggregated fields from the table: "esrs.Deprecated_MaterialDisclosureRequirement" */
  esrs_Deprecated_MaterialDisclosureRequirement_aggregate: Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_;
  /** fetch data from the table: "esrs.Deprecated_MaterialDisclosureRequirement" using primary key columns */
  esrs_Deprecated_MaterialDisclosureRequirement_by_pk?: Maybe<Esrs_Deprecated_MaterialDisclosureRequirement_>;
  /** fetch data from the table: "esrs.Deprecated_MetricAnswer" */
  esrs_Deprecated_MetricAnswer: Array<Esrs_Deprecated_MetricAnswer_>;
  /** fetch aggregated fields from the table: "esrs.Deprecated_MetricAnswer" */
  esrs_Deprecated_MetricAnswer_aggregate: Esrs_Deprecated_MetricAnswer_Aggregate_;
  /** fetch data from the table: "esrs.Deprecated_MetricAnswer" using primary key columns */
  esrs_Deprecated_MetricAnswer_by_pk?: Maybe<Esrs_Deprecated_MetricAnswer_>;
  /** fetch data from the table: "esrs.DisclosureRequirementAttachment" */
  esrs_DisclosureRequirementAttachment: Array<Esrs_DisclosureRequirementAttachment_>;
  /** fetch aggregated fields from the table: "esrs.DisclosureRequirementAttachment" */
  esrs_DisclosureRequirementAttachment_aggregate: Esrs_DisclosureRequirementAttachment_Aggregate_;
  /** fetch data from the table: "esrs.DisclosureRequirementAttachment" using primary key columns */
  esrs_DisclosureRequirementAttachment_by_pk?: Maybe<Esrs_DisclosureRequirementAttachment_>;
  /** fetch data from the table: "esrs.EsrsAssessmentCompanyIntegration" */
  esrs_EsrsAssessmentCompanyIntegration: Array<Esrs_EsrsAssessmentCompanyIntegration_>;
  /** fetch data from the table: "esrs.EsrsAssessmentCompanyIntegrationRU" */
  esrs_EsrsAssessmentCompanyIntegrationRU: Array<Esrs_EsrsAssessmentCompanyIntegrationRu_>;
  /** fetch aggregated fields from the table: "esrs.EsrsAssessmentCompanyIntegrationRU" */
  esrs_EsrsAssessmentCompanyIntegrationRU_aggregate: Esrs_EsrsAssessmentCompanyIntegrationRu_Aggregate_;
  /** fetch data from the table: "esrs.EsrsAssessmentCompanyIntegrationRU" using primary key columns */
  esrs_EsrsAssessmentCompanyIntegrationRU_by_pk?: Maybe<Esrs_EsrsAssessmentCompanyIntegrationRu_>;
  /** fetch aggregated fields from the table: "esrs.EsrsAssessmentCompanyIntegration" */
  esrs_EsrsAssessmentCompanyIntegration_aggregate: Esrs_EsrsAssessmentCompanyIntegration_Aggregate_;
  /** fetch data from the table: "esrs.EsrsAssessmentCompanyIntegration" using primary key columns */
  esrs_EsrsAssessmentCompanyIntegration_by_pk?: Maybe<Esrs_EsrsAssessmentCompanyIntegration_>;
  /** fetch data from the table: "esrs.EsrsMetricHierarchyStatus" */
  esrs_EsrsMetricHierarchyStatus: Array<Esrs_EsrsMetricHierarchyStatus_>;
  /** fetch aggregated fields from the table: "esrs.EsrsMetricHierarchyStatus" */
  esrs_EsrsMetricHierarchyStatus_aggregate: Esrs_EsrsMetricHierarchyStatus_Aggregate_;
  /** fetch data from the table: "esrs.MaterialMetric" */
  esrs_MaterialMetric: Array<Esrs_MaterialMetric_>;
  /** fetch data from the table: "esrs.MaterialMetricTag" */
  esrs_MaterialMetricTag: Array<Esrs_MaterialMetricTag_>;
  /** fetch aggregated fields from the table: "esrs.MaterialMetricTag" */
  esrs_MaterialMetricTag_aggregate: Esrs_MaterialMetricTag_Aggregate_;
  /** fetch data from the table: "esrs.MaterialMetricTag" using primary key columns */
  esrs_MaterialMetricTag_by_pk?: Maybe<Esrs_MaterialMetricTag_>;
  /** fetch aggregated fields from the table: "esrs.MaterialMetric" */
  esrs_MaterialMetric_aggregate: Esrs_MaterialMetric_Aggregate_;
  /** fetch data from the table: "esrs.MaterialMetric" using primary key columns */
  esrs_MaterialMetric_by_pk?: Maybe<Esrs_MaterialMetric_>;
  /** fetch data from the table: "esrs.MaterialStandard" */
  esrs_MaterialStandard: Array<Esrs_MaterialStandard_>;
  /** fetch aggregated fields from the table: "esrs.MaterialStandard" */
  esrs_MaterialStandard_aggregate: Esrs_MaterialStandard_Aggregate_;
  /** fetch data from the table: "esrs.MaterialStandard" using primary key columns */
  esrs_MaterialStandard_by_pk?: Maybe<Esrs_MaterialStandard_>;
  /** fetch data from the table: "esrs.MaterialTagValue" */
  esrs_MaterialTagValue: Array<Esrs_MaterialTagValue_>;
  /** fetch aggregated fields from the table: "esrs.MaterialTagValue" */
  esrs_MaterialTagValue_aggregate: Esrs_MaterialTagValue_Aggregate_;
  /** fetch data from the table: "esrs.MaterialTagValue" using primary key columns */
  esrs_MaterialTagValue_by_pk?: Maybe<Esrs_MaterialTagValue_>;
  /** fetch data from the table: "esrs.MetricDependencyClosure" */
  esrs_MetricDependencyClosure: Array<Esrs_MetricDependencyClosure_>;
  /** fetch aggregated fields from the table: "esrs.MetricDependencyClosure" */
  esrs_MetricDependencyClosure_aggregate: Esrs_MetricDependencyClosure_Aggregate_;
  /** fetch data from the table: "esrs.MetricRelatedDisclosureRequirement" */
  esrs_MetricRelatedDisclosureRequirement: Array<Esrs_MetricRelatedDisclosureRequirement_>;
  /** fetch aggregated fields from the table: "esrs.MetricRelatedDisclosureRequirement" */
  esrs_MetricRelatedDisclosureRequirement_aggregate: Esrs_MetricRelatedDisclosureRequirement_Aggregate_;
  /** fetch data from the table: "esrs.Milestone" */
  esrs_Milestone: Array<Esrs_Milestone_>;
  /** fetch data from the table: "esrs.MilestoneResult" */
  esrs_MilestoneResult: Array<Esrs_MilestoneResult_>;
  /** fetch aggregated fields from the table: "esrs.MilestoneResult" */
  esrs_MilestoneResult_aggregate: Esrs_MilestoneResult_Aggregate_;
  /** fetch data from the table: "esrs.MilestoneResult" using primary key columns */
  esrs_MilestoneResult_by_pk?: Maybe<Esrs_MilestoneResult_>;
  /** fetch aggregated fields from the table: "esrs.Milestone" */
  esrs_Milestone_aggregate: Esrs_Milestone_Aggregate_;
  /** fetch data from the table: "esrs.Milestone" using primary key columns */
  esrs_Milestone_by_pk?: Maybe<Esrs_Milestone_>;
  /** fetch data from the table: "esrs.Policy" */
  esrs_Policy: Array<Esrs_Policy_>;
  /** fetch aggregated fields from the table: "esrs.Policy" */
  esrs_Policy_aggregate: Esrs_Policy_Aggregate_;
  /** fetch data from the table: "esrs.Policy" using primary key columns */
  esrs_Policy_by_pk?: Maybe<Esrs_Policy_>;
  /** fetch data from the table: "esrs.ReportingUnit" */
  esrs_ReportingUnit: Array<Esrs_ReportingUnit_>;
  /** fetch data from the table: "esrs.ReportingUnitLineage" */
  esrs_ReportingUnitLineage: Array<Esrs_ReportingUnitLineage_>;
  /** fetch aggregated fields from the table: "esrs.ReportingUnitLineage" */
  esrs_ReportingUnitLineage_aggregate: Esrs_ReportingUnitLineage_Aggregate_;
  /** fetch data from the table: "esrs.ReportingUnitLineage" using primary key columns */
  esrs_ReportingUnitLineage_by_pk?: Maybe<Esrs_ReportingUnitLineage_>;
  /** fetch aggregated fields from the table: "esrs.ReportingUnit" */
  esrs_ReportingUnit_aggregate: Esrs_ReportingUnit_Aggregate_;
  /** fetch data from the table: "esrs.ReportingUnit" using primary key columns */
  esrs_ReportingUnit_by_pk?: Maybe<Esrs_ReportingUnit_>;
  /** fetch data from the table: "esrs.Target" */
  esrs_Target: Array<Esrs_Target_>;
  /** fetch aggregated fields from the table: "esrs.Target" */
  esrs_Target_aggregate: Esrs_Target_Aggregate_;
  /** fetch data from the table: "esrs.Target" using primary key columns */
  esrs_Target_by_pk?: Maybe<Esrs_Target_>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files_>;
  /** An array relationship */
  files: Array<Files_>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate_;
  getInvitation?: Maybe<InvitationOutput_>;
  /** getPortfolioAggregate */
  getPortfolioAggregate?: Maybe<SampleOutput_>;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users_>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users_>;
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate_;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus_>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus_>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate_;
};


export type Query_RootAiConfigArgs_ = {
  distinct_on?: InputMaybe<Array<AiConfig_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AiConfig_Order_By_>>;
  where?: InputMaybe<AiConfig_Bool_Exp_>;
};


export type Query_RootAiConfig_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AiConfig_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AiConfig_Order_By_>>;
  where?: InputMaybe<AiConfig_Bool_Exp_>;
};


export type Query_RootAiConfig_By_PkArgs_ = {
  companyId: Scalars['uuid']['input'];
};


export type Query_RootActionQuestionArgs_ = {
  distinct_on?: InputMaybe<Array<ActionQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestion_Order_By_>>;
  where?: InputMaybe<ActionQuestion_Bool_Exp_>;
};


export type Query_RootActionQuestionGroupArgs_ = {
  distinct_on?: InputMaybe<Array<ActionQuestionGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestionGroup_Order_By_>>;
  where?: InputMaybe<ActionQuestionGroup_Bool_Exp_>;
};


export type Query_RootActionQuestionGroup_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActionQuestionGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestionGroup_Order_By_>>;
  where?: InputMaybe<ActionQuestionGroup_Bool_Exp_>;
};


export type Query_RootActionQuestionGroup_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootActionQuestion_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActionQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestion_Order_By_>>;
  where?: InputMaybe<ActionQuestion_Bool_Exp_>;
};


export type Query_RootActionQuestion_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootActivityArgs_ = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By_>>;
  where?: InputMaybe<Activity_Bool_Exp_>;
};


export type Query_RootActivityNaceCodeArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityNaceCode_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityNaceCode_Order_By_>>;
  where?: InputMaybe<ActivityNaceCode_Bool_Exp_>;
};


export type Query_RootActivityNaceCode_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityNaceCode_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityNaceCode_Order_By_>>;
  where?: InputMaybe<ActivityNaceCode_Bool_Exp_>;
};


export type Query_RootActivityNaceCode_By_PkArgs_ = {
  id: Scalars['bigint']['input'];
};


export type Query_RootActivityQuestionSetArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityQuestionSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityQuestionSet_Order_By_>>;
  where?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
};


export type Query_RootActivityQuestionSet_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityQuestionSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityQuestionSet_Order_By_>>;
  where?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
};


export type Query_RootActivityQuestionSet_By_PkArgs_ = {
  activityRef: Scalars['String']['input'];
  questionSetRef: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


export type Query_RootActivityReportArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityReport_Order_By_>>;
  where?: InputMaybe<ActivityReport_Bool_Exp_>;
};


export type Query_RootActivityReport_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityReport_Order_By_>>;
  where?: InputMaybe<ActivityReport_Bool_Exp_>;
};


export type Query_RootActivityReport_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootActivityVersionArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityVersion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityVersion_Order_By_>>;
  where?: InputMaybe<ActivityVersion_Bool_Exp_>;
};


export type Query_RootActivityVersion_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityVersion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityVersion_Order_By_>>;
  where?: InputMaybe<ActivityVersion_Bool_Exp_>;
};


export type Query_RootActivityVersion_By_PkArgs_ = {
  activityRef: Scalars['String']['input'];
  versionNumber: Scalars['Int']['input'];
};


export type Query_RootActivity_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By_>>;
  where?: InputMaybe<Activity_Bool_Exp_>;
};


export type Query_RootActivity_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootAdditionalTypeArgs_ = {
  distinct_on?: InputMaybe<Array<AdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AdditionalType_Order_By_>>;
  where?: InputMaybe<AdditionalType_Bool_Exp_>;
};


export type Query_RootAdditionalType_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AdditionalType_Order_By_>>;
  where?: InputMaybe<AdditionalType_Bool_Exp_>;
};


export type Query_RootAdditionalType_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootAnswerArgs_ = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By_>>;
  where?: InputMaybe<Answer_Bool_Exp_>;
};


export type Query_RootAnswerCompanyArgs_ = {
  distinct_on?: InputMaybe<Array<AnswerCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AnswerCompany_Order_By_>>;
  where?: InputMaybe<AnswerCompany_Bool_Exp_>;
};


export type Query_RootAnswerCompany_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AnswerCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AnswerCompany_Order_By_>>;
  where?: InputMaybe<AnswerCompany_Bool_Exp_>;
};


export type Query_RootAnswer_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By_>>;
  where?: InputMaybe<Answer_Bool_Exp_>;
};


export type Query_RootAnswer_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAppConfigArgs_ = {
  distinct_on?: InputMaybe<Array<AppConfig_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AppConfig_Order_By_>>;
  where?: InputMaybe<AppConfig_Bool_Exp_>;
};


export type Query_RootAppConfig_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AppConfig_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AppConfig_Order_By_>>;
  where?: InputMaybe<AppConfig_Bool_Exp_>;
};


export type Query_RootAppConfig_By_PkArgs_ = {
  id: Scalars['Boolean']['input'];
};


export type Query_RootArticleArgs_ = {
  distinct_on?: InputMaybe<Array<Article_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Article_Order_By_>>;
  where?: InputMaybe<Article_Bool_Exp_>;
};


export type Query_RootArticle_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Article_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Article_Order_By_>>;
  where?: InputMaybe<Article_Bool_Exp_>;
};


export type Query_RootArticle_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAttachmentArgs_ = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attachment_Order_By_>>;
  where?: InputMaybe<Attachment_Bool_Exp_>;
};


export type Query_RootAttachmentBoxArgs_ = {
  distinct_on?: InputMaybe<Array<AttachmentBox_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttachmentBox_Order_By_>>;
  where?: InputMaybe<AttachmentBox_Bool_Exp_>;
};


export type Query_RootAttachmentBox_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AttachmentBox_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttachmentBox_Order_By_>>;
  where?: InputMaybe<AttachmentBox_Bool_Exp_>;
};


export type Query_RootAttachmentBox_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAttachment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attachment_Order_By_>>;
  where?: InputMaybe<Attachment_Bool_Exp_>;
};


export type Query_RootAttachment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuditLogEntryArgs_ = {
  distinct_on?: InputMaybe<Array<AuditLogEntry_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuditLogEntry_Order_By_>>;
  where?: InputMaybe<AuditLogEntry_Bool_Exp_>;
};


export type Query_RootAuditLogEntry_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuditLogEntry_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuditLogEntry_Order_By_>>;
  where?: InputMaybe<AuditLogEntry_Bool_Exp_>;
};


export type Query_RootAuditLogEntry_By_PkArgs_ = {
  invocationId: Scalars['uuid']['input'];
};


export type Query_RootBusinessUnitArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnit_Order_By_>>;
  where?: InputMaybe<BusinessUnit_Bool_Exp_>;
};


export type Query_RootBusinessUnitAssessmentArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnitAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnitAssessment_Order_By_>>;
  where?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
};


export type Query_RootBusinessUnitAssessment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnitAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnitAssessment_Order_By_>>;
  where?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
};


export type Query_RootBusinessUnitAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBusinessUnit_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnit_Order_By_>>;
  where?: InputMaybe<BusinessUnit_Bool_Exp_>;
};


export type Query_RootBusinessUnit_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCachedResultArgs_ = {
  distinct_on?: InputMaybe<Array<CachedResult_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CachedResult_Order_By_>>;
  where?: InputMaybe<CachedResult_Bool_Exp_>;
};


export type Query_RootCachedResult_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CachedResult_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CachedResult_Order_By_>>;
  where?: InputMaybe<CachedResult_Bool_Exp_>;
};


export type Query_RootCachedResult_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootChoiceSetArgs_ = {
  distinct_on?: InputMaybe<Array<ChoiceSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ChoiceSet_Order_By_>>;
  where?: InputMaybe<ChoiceSet_Bool_Exp_>;
};


export type Query_RootChoiceSet_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ChoiceSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ChoiceSet_Order_By_>>;
  where?: InputMaybe<ChoiceSet_Bool_Exp_>;
};


export type Query_RootChoiceSet_By_PkArgs_ = {
  title: Scalars['String']['input'];
};


export type Query_RootCommentArgs_ = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comment_Order_By_>>;
  where?: InputMaybe<Comment_Bool_Exp_>;
};


export type Query_RootComment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comment_Order_By_>>;
  where?: InputMaybe<Comment_Bool_Exp_>;
};


export type Query_RootComment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCompanyArgs_ = {
  distinct_on?: InputMaybe<Array<Company_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Company_Order_By_>>;
  where?: InputMaybe<Company_Bool_Exp_>;
};


export type Query_RootCompanyAssessmentArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessment_Order_By_>>;
  where?: InputMaybe<CompanyAssessment_Bool_Exp_>;
};


export type Query_RootCompanyAssessmentAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessmentAggregate_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessmentAggregate_Order_By_>>;
  where?: InputMaybe<CompanyAssessmentAggregate_Bool_Exp_>;
};


export type Query_RootCompanyAssessmentAggregate_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessmentAggregate_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessmentAggregate_Order_By_>>;
  where?: InputMaybe<CompanyAssessmentAggregate_Bool_Exp_>;
};


export type Query_RootCompanyAssessmentAggregate_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCompanyAssessment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessment_Order_By_>>;
  where?: InputMaybe<CompanyAssessment_Bool_Exp_>;
};


export type Query_RootCompanyAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCompanyIdentityProviderArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyIdentityProvider_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyIdentityProvider_Order_By_>>;
  where?: InputMaybe<CompanyIdentityProvider_Bool_Exp_>;
};


export type Query_RootCompanyIdentityProvider_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyIdentityProvider_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyIdentityProvider_Order_By_>>;
  where?: InputMaybe<CompanyIdentityProvider_Bool_Exp_>;
};


export type Query_RootCompanyIdentityProvider_By_PkArgs_ = {
  companyId: Scalars['uuid']['input'];
};


export type Query_RootCompanyInvitationArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyInvitation_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyInvitation_Order_By_>>;
  where?: InputMaybe<CompanyInvitation_Bool_Exp_>;
};


export type Query_RootCompanyInvitation_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyInvitation_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyInvitation_Order_By_>>;
  where?: InputMaybe<CompanyInvitation_Bool_Exp_>;
};


export type Query_RootCompanyInvitation_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCompanyUserArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyUser_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyUser_Order_By_>>;
  where?: InputMaybe<CompanyUser_Bool_Exp_>;
};


export type Query_RootCompanyUser_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyUser_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyUser_Order_By_>>;
  where?: InputMaybe<CompanyUser_Bool_Exp_>;
};


export type Query_RootCompanyUser_By_PkArgs_ = {
  companyId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Query_RootCompany_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Company_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Company_Order_By_>>;
  where?: InputMaybe<Company_Bool_Exp_>;
};


export type Query_RootCompany_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCompassPatArgs_ = {
  distinct_on?: InputMaybe<Array<CompassPat_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompassPat_Order_By_>>;
  where?: InputMaybe<CompassPat_Bool_Exp_>;
};


export type Query_RootCompassPat_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompassPat_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompassPat_Order_By_>>;
  where?: InputMaybe<CompassPat_Bool_Exp_>;
};


export type Query_RootCompassPat_By_PkArgs_ = {
  userId: Scalars['uuid']['input'];
};


export type Query_RootDrToMfDisclosureRequirementArgs_ = {
  distinct_on?: InputMaybe<Array<DrToMfDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DrToMfDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<DrToMfDisclosureRequirement_Bool_Exp_>;
};


export type Query_RootDrToMfDisclosureRequirement_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DrToMfDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DrToMfDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<DrToMfDisclosureRequirement_Bool_Exp_>;
};


export type Query_RootDrToMfDisclosureRequirement_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDisclosureRequirementArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirement_Order_By_>>;
  where?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
};


export type Query_RootDisclosureRequirementAdditionalTypeArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementAdditionalType_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementAdditionalType_Bool_Exp_>;
};


export type Query_RootDisclosureRequirementAdditionalType_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementAdditionalType_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementAdditionalType_Bool_Exp_>;
};


export type Query_RootDisclosureRequirementAdditionalType_By_PkArgs_ = {
  additionalTypeRef: Scalars['String']['input'];
  disclosureRequirementRef: Scalars['String']['input'];
};


export type Query_RootDisclosureRequirementGroupArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementGroup_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementGroup_Bool_Exp_>;
};


export type Query_RootDisclosureRequirementGroup_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementGroup_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementGroup_Bool_Exp_>;
};


export type Query_RootDisclosureRequirementGroup_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootDisclosureRequirementOwnerArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementOwner_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementOwner_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementOwner_Bool_Exp_>;
};


export type Query_RootDisclosureRequirementOwner_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementOwner_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementOwner_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementOwner_Bool_Exp_>;
};


export type Query_RootDisclosureRequirementOwner_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDisclosureRequirementStatusArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementStatus_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementStatus_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementStatus_Bool_Exp_>;
};


export type Query_RootDisclosureRequirementStatus_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementStatus_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementStatus_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementStatus_Bool_Exp_>;
};


export type Query_RootDisclosureRequirementStatus_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDisclosureRequirement_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirement_Order_By_>>;
  where?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
};


export type Query_RootDisclosureRequirement_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootDocumentInsightArgs_ = {
  distinct_on?: InputMaybe<Array<DocumentInsight_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DocumentInsight_Order_By_>>;
  where?: InputMaybe<DocumentInsight_Bool_Exp_>;
};


export type Query_RootDocumentInsight_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DocumentInsight_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DocumentInsight_Order_By_>>;
  where?: InputMaybe<DocumentInsight_Bool_Exp_>;
};


export type Query_RootDocumentInsight_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDocumentationFileArgs_ = {
  distinct_on?: InputMaybe<Array<DocumentationFile_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DocumentationFile_Order_By_>>;
  where?: InputMaybe<DocumentationFile_Bool_Exp_>;
};


export type Query_RootDocumentationFile_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DocumentationFile_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DocumentationFile_Order_By_>>;
  where?: InputMaybe<DocumentationFile_Bool_Exp_>;
};


export type Query_RootDocumentationFile_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrsAssessmentArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsAssessment_Order_By_>>;
  where?: InputMaybe<EsrsAssessment_Bool_Exp_>;
};


export type Query_RootEsrsAssessment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsAssessment_Order_By_>>;
  where?: InputMaybe<EsrsAssessment_Bool_Exp_>;
};


export type Query_RootEsrsAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrsCategoryArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsCategory_Order_By_>>;
  where?: InputMaybe<EsrsCategory_Bool_Exp_>;
};


export type Query_RootEsrsCategory_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsCategory_Order_By_>>;
  where?: InputMaybe<EsrsCategory_Bool_Exp_>;
};


export type Query_RootEsrsCategory_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootEsrsChoiceArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsChoice_Order_By_>>;
  where?: InputMaybe<EsrsChoice_Bool_Exp_>;
};


export type Query_RootEsrsChoice_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsChoice_Order_By_>>;
  where?: InputMaybe<EsrsChoice_Bool_Exp_>;
};


export type Query_RootEsrsChoice_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootEsrsMetricArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetric_Order_By_>>;
  where?: InputMaybe<EsrsMetric_Bool_Exp_>;
};


export type Query_RootEsrsMetricAdditionalTypeArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsMetricAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetricAdditionalType_Order_By_>>;
  where?: InputMaybe<EsrsMetricAdditionalType_Bool_Exp_>;
};


export type Query_RootEsrsMetricAdditionalType_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsMetricAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetricAdditionalType_Order_By_>>;
  where?: InputMaybe<EsrsMetricAdditionalType_Bool_Exp_>;
};


export type Query_RootEsrsMetricAdditionalType_By_PkArgs_ = {
  additionalTypeRef: Scalars['String']['input'];
  metricRef: Scalars['String']['input'];
};


export type Query_RootEsrsMetric_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetric_Order_By_>>;
  where?: InputMaybe<EsrsMetric_Bool_Exp_>;
};


export type Query_RootEsrsMetric_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootEsrsStandardArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandard_Order_By_>>;
  where?: InputMaybe<EsrsStandard_Bool_Exp_>;
};


export type Query_RootEsrsStandardAdditionalTypeArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsStandardAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandardAdditionalType_Order_By_>>;
  where?: InputMaybe<EsrsStandardAdditionalType_Bool_Exp_>;
};


export type Query_RootEsrsStandardAdditionalType_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsStandardAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandardAdditionalType_Order_By_>>;
  where?: InputMaybe<EsrsStandardAdditionalType_Bool_Exp_>;
};


export type Query_RootEsrsStandardAdditionalType_By_PkArgs_ = {
  additionalTypeRef: Scalars['String']['input'];
  standardRef: Scalars['String']['input'];
};


export type Query_RootEsrsStandard_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandard_Order_By_>>;
  where?: InputMaybe<EsrsStandard_Bool_Exp_>;
};


export type Query_RootEsrsStandard_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootEstimateCompany_DeprecatedArgs_ = {
  distinct_on?: InputMaybe<Array<EstimateCompany_Deprecated_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EstimateCompany_Deprecated_Order_By_>>;
  where?: InputMaybe<EstimateCompany_Deprecated_Bool_Exp_>;
};


export type Query_RootEstimateCompany_Deprecated_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EstimateCompany_Deprecated_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EstimateCompany_Deprecated_Order_By_>>;
  where?: InputMaybe<EstimateCompany_Deprecated_Bool_Exp_>;
};


export type Query_RootEstimateCompany_Deprecated_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootExtractionJobArgs_ = {
  distinct_on?: InputMaybe<Array<ExtractionJob_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ExtractionJob_Order_By_>>;
  where?: InputMaybe<ExtractionJob_Bool_Exp_>;
};


export type Query_RootExtractionJob_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ExtractionJob_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ExtractionJob_Order_By_>>;
  where?: InputMaybe<ExtractionJob_Bool_Exp_>;
};


export type Query_RootExtractionJob_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFinancialsArgs_ = {
  distinct_on?: InputMaybe<Array<Financials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Financials_Order_By_>>;
  where?: InputMaybe<Financials_Bool_Exp_>;
};


export type Query_RootFinancials_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Financials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Financials_Order_By_>>;
  where?: InputMaybe<Financials_Bool_Exp_>;
};


export type Query_RootFinancials_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFrameworkArgs_ = {
  distinct_on?: InputMaybe<Array<Framework_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Framework_Order_By_>>;
  where?: InputMaybe<Framework_Bool_Exp_>;
};


export type Query_RootFramework_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Framework_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Framework_Order_By_>>;
  where?: InputMaybe<Framework_Bool_Exp_>;
};


export type Query_RootFramework_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootGroupAssessmentArgs_ = {
  distinct_on?: InputMaybe<Array<GroupAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GroupAssessment_Order_By_>>;
  where?: InputMaybe<GroupAssessment_Bool_Exp_>;
};


export type Query_RootGroupAssessment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<GroupAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GroupAssessment_Order_By_>>;
  where?: InputMaybe<GroupAssessment_Bool_Exp_>;
};


export type Query_RootGroupAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootIdentityProviderArgs_ = {
  distinct_on?: InputMaybe<Array<IdentityProvider_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IdentityProvider_Order_By_>>;
  where?: InputMaybe<IdentityProvider_Bool_Exp_>;
};


export type Query_RootIdentityProvider_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<IdentityProvider_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IdentityProvider_Order_By_>>;
  where?: InputMaybe<IdentityProvider_Bool_Exp_>;
};


export type Query_RootIdentityProvider_By_PkArgs_ = {
  name: Scalars['String']['input'];
};


export type Query_RootIndicatorToInvestorMetricArgs_ = {
  distinct_on?: InputMaybe<Array<IndicatorToInvestorMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorToInvestorMetric_Order_By_>>;
  where?: InputMaybe<IndicatorToInvestorMetric_Bool_Exp_>;
};


export type Query_RootIndicatorToInvestorMetric_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<IndicatorToInvestorMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorToInvestorMetric_Order_By_>>;
  where?: InputMaybe<IndicatorToInvestorMetric_Bool_Exp_>;
};


export type Query_RootIndicatorToInvestorMetric_By_PkArgs_ = {
  indicatorRef: Scalars['String']['input'];
  investorMetricRef: Scalars['String']['input'];
};


export type Query_RootInvesteeMetricArgs_ = {
  distinct_on?: InputMaybe<Array<InvesteeMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvesteeMetric_Order_By_>>;
  where?: InputMaybe<InvesteeMetric_Bool_Exp_>;
};


export type Query_RootInvesteeMetric_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<InvesteeMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvesteeMetric_Order_By_>>;
  where?: InputMaybe<InvesteeMetric_Bool_Exp_>;
};


export type Query_RootInvesteeMetric_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootInvestmentCategoryArgs_ = {
  distinct_on?: InputMaybe<Array<InvestmentCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestmentCategory_Order_By_>>;
  where?: InputMaybe<InvestmentCategory_Bool_Exp_>;
};


export type Query_RootInvestmentCategory_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<InvestmentCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestmentCategory_Order_By_>>;
  where?: InputMaybe<InvestmentCategory_Bool_Exp_>;
};


export type Query_RootInvestmentCategory_By_PkArgs_ = {
  value: Scalars['String']['input'];
};


export type Query_RootInvestorMetricArgs_ = {
  distinct_on?: InputMaybe<Array<InvestorMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestorMetric_Order_By_>>;
  where?: InputMaybe<InvestorMetric_Bool_Exp_>;
};


export type Query_RootInvestorMetric_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<InvestorMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestorMetric_Order_By_>>;
  where?: InputMaybe<InvestorMetric_Bool_Exp_>;
};


export type Query_RootInvestorMetric_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootInvestorToInvesteeMetricArgs_ = {
  distinct_on?: InputMaybe<Array<InvestorToInvesteeMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestorToInvesteeMetric_Order_By_>>;
  where?: InputMaybe<InvestorToInvesteeMetric_Bool_Exp_>;
};


export type Query_RootInvestorToInvesteeMetric_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<InvestorToInvesteeMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestorToInvesteeMetric_Order_By_>>;
  where?: InputMaybe<InvestorToInvesteeMetric_Bool_Exp_>;
};


export type Query_RootInvestorToInvesteeMetric_By_PkArgs_ = {
  investeeMetricReference: Scalars['String']['input'];
  investorMetricReference: Scalars['String']['input'];
};


export type Query_RootMfCategoryArgs_ = {
  distinct_on?: InputMaybe<Array<MfCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfCategory_Order_By_>>;
  where?: InputMaybe<MfCategory_Bool_Exp_>;
};


export type Query_RootMfCategory_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfCategory_Order_By_>>;
  where?: InputMaybe<MfCategory_Bool_Exp_>;
};


export type Query_RootMfCategory_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootMfDisclosureRequirementArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirement_Bool_Exp_>;
};


export type Query_RootMfDisclosureRequirementGroupArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirementGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementGroup_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirementGroup_Bool_Exp_>;
};


export type Query_RootMfDisclosureRequirementGroup_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirementGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementGroup_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirementGroup_Bool_Exp_>;
};


export type Query_RootMfDisclosureRequirementGroup_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootMfDisclosureRequirementItemArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirementItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementItem_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirementItem_Bool_Exp_>;
};


export type Query_RootMfDisclosureRequirementItem_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirementItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementItem_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirementItem_Bool_Exp_>;
};


export type Query_RootMfDisclosureRequirementItem_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMfDisclosureRequirement_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirement_Bool_Exp_>;
};


export type Query_RootMfDisclosureRequirement_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootMfStandardArgs_ = {
  distinct_on?: InputMaybe<Array<MfStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandard_Order_By_>>;
  where?: InputMaybe<MfStandard_Bool_Exp_>;
};


export type Query_RootMfStandardItemArgs_ = {
  distinct_on?: InputMaybe<Array<MfStandardItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandardItem_Order_By_>>;
  where?: InputMaybe<MfStandardItem_Bool_Exp_>;
};


export type Query_RootMfStandardItem_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfStandardItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandardItem_Order_By_>>;
  where?: InputMaybe<MfStandardItem_Bool_Exp_>;
};


export type Query_RootMfStandardItem_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMfStandard_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandard_Order_By_>>;
  where?: InputMaybe<MfStandard_Bool_Exp_>;
};


export type Query_RootMfStandard_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootMaterialStandardOwnerArgs_ = {
  distinct_on?: InputMaybe<Array<MaterialStandardOwner_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialStandardOwner_Order_By_>>;
  where?: InputMaybe<MaterialStandardOwner_Bool_Exp_>;
};


export type Query_RootMaterialStandardOwner_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MaterialStandardOwner_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialStandardOwner_Order_By_>>;
  where?: InputMaybe<MaterialStandardOwner_Bool_Exp_>;
};


export type Query_RootMaterialStandardOwner_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootMetricDependencyArgs_ = {
  distinct_on?: InputMaybe<Array<MetricDependency_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricDependency_Order_By_>>;
  where?: InputMaybe<MetricDependency_Bool_Exp_>;
};


export type Query_RootMetricDependency_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MetricDependency_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricDependency_Order_By_>>;
  where?: InputMaybe<MetricDependency_Bool_Exp_>;
};


export type Query_RootMetricDependency_By_PkArgs_ = {
  childMetricRef: Scalars['String']['input'];
  parentMetricRef: Scalars['String']['input'];
};


export type Query_RootMetricTagArgs_ = {
  distinct_on?: InputMaybe<Array<MetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricTag_Order_By_>>;
  where?: InputMaybe<MetricTag_Bool_Exp_>;
};


export type Query_RootMetricTag_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricTag_Order_By_>>;
  where?: InputMaybe<MetricTag_Bool_Exp_>;
};


export type Query_RootMetricTag_By_PkArgs_ = {
  metricRef: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type Query_RootNonMaterialFinancialsArgs_ = {
  distinct_on?: InputMaybe<Array<NonMaterialFinancials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NonMaterialFinancials_Order_By_>>;
  where?: InputMaybe<NonMaterialFinancials_Bool_Exp_>;
};


export type Query_RootNonMaterialFinancials_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<NonMaterialFinancials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NonMaterialFinancials_Order_By_>>;
  where?: InputMaybe<NonMaterialFinancials_Bool_Exp_>;
};


export type Query_RootNoteArgs_ = {
  distinct_on?: InputMaybe<Array<Note_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By_>>;
  where?: InputMaybe<Note_Bool_Exp_>;
};


export type Query_RootNoteHistoryArgs_ = {
  distinct_on?: InputMaybe<Array<NoteHistory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NoteHistory_Order_By_>>;
  where?: InputMaybe<NoteHistory_Bool_Exp_>;
};


export type Query_RootNoteHistory_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<NoteHistory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NoteHistory_Order_By_>>;
  where?: InputMaybe<NoteHistory_Bool_Exp_>;
};


export type Query_RootNoteHistory_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootNote_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Note_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By_>>;
  where?: InputMaybe<Note_Bool_Exp_>;
};


export type Query_RootNote_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootObjectiveArgs_ = {
  distinct_on?: InputMaybe<Array<Objective_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objective_Order_By_>>;
  where?: InputMaybe<Objective_Bool_Exp_>;
};


export type Query_RootObjective_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Objective_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objective_Order_By_>>;
  where?: InputMaybe<Objective_Bool_Exp_>;
};


export type Query_RootObjective_By_PkArgs_ = {
  key: Scalars['String']['input'];
};


export type Query_RootPaiAnswersArgs_ = {
  distinct_on?: InputMaybe<Array<PaiAnswers_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiAnswers_Order_By_>>;
  where?: InputMaybe<PaiAnswers_Bool_Exp_>;
};


export type Query_RootPaiAnswers_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiAnswers_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiAnswers_Order_By_>>;
  where?: InputMaybe<PaiAnswers_Bool_Exp_>;
};


export type Query_RootPaiAnswers_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPaiCategoryArgs_ = {
  distinct_on?: InputMaybe<Array<PaiCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiCategory_Order_By_>>;
  where?: InputMaybe<PaiCategory_Bool_Exp_>;
};


export type Query_RootPaiCategory_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiCategory_Order_By_>>;
  where?: InputMaybe<PaiCategory_Bool_Exp_>;
};


export type Query_RootPaiCategory_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootPaiCompanyReportArgs_ = {
  distinct_on?: InputMaybe<Array<PaiCompanyReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiCompanyReport_Order_By_>>;
  where?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
};


export type Query_RootPaiCompanyReport_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiCompanyReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiCompanyReport_Order_By_>>;
  where?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
};


export type Query_RootPaiCompanyReport_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPaiMetricInsightArgs_ = {
  distinct_on?: InputMaybe<Array<PaiMetricInsight_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiMetricInsight_Order_By_>>;
  where?: InputMaybe<PaiMetricInsight_Bool_Exp_>;
};


export type Query_RootPaiMetricInsight_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiMetricInsight_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiMetricInsight_Order_By_>>;
  where?: InputMaybe<PaiMetricInsight_Bool_Exp_>;
};


export type Query_RootPaiMetricInsight_By_PkArgs_ = {
  insightId: Scalars['uuid']['input'];
  investeeMetricRef: Scalars['String']['input'];
  reportId: Scalars['uuid']['input'];
};


export type Query_RootPaiPortfolioReportArgs_ = {
  distinct_on?: InputMaybe<Array<PaiPortfolioReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiPortfolioReport_Order_By_>>;
  where?: InputMaybe<PaiPortfolioReport_Bool_Exp_>;
};


export type Query_RootPaiPortfolioReport_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiPortfolioReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiPortfolioReport_Order_By_>>;
  where?: InputMaybe<PaiPortfolioReport_Bool_Exp_>;
};


export type Query_RootPaiPortfolioReport_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPaiReportIndicatorArgs_ = {
  distinct_on?: InputMaybe<Array<PaiReportIndicator_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiReportIndicator_Order_By_>>;
  where?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
};


export type Query_RootPaiReportIndicatorPortfolioCompanyArgs_ = {
  distinct_on?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Order_By_>>;
  where?: InputMaybe<PaiReportIndicatorPortfolioCompany_Bool_Exp_>;
};


export type Query_RootPaiReportIndicatorPortfolioCompany_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Order_By_>>;
  where?: InputMaybe<PaiReportIndicatorPortfolioCompany_Bool_Exp_>;
};


export type Query_RootPaiReportIndicatorPortfolioCompany_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPaiReportIndicator_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiReportIndicator_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiReportIndicator_Order_By_>>;
  where?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
};


export type Query_RootPaiReportIndicator_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPaiTableArgs_ = {
  distinct_on?: InputMaybe<Array<PaiTable_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiTable_Order_By_>>;
  where?: InputMaybe<PaiTable_Bool_Exp_>;
};


export type Query_RootPaiTableIndicatorArgs_ = {
  distinct_on?: InputMaybe<Array<PaiTableIndicator_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiTableIndicator_Order_By_>>;
  where?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
};


export type Query_RootPaiTableIndicator_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiTableIndicator_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiTableIndicator_Order_By_>>;
  where?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
};


export type Query_RootPaiTableIndicator_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootPaiTable_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiTable_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiTable_Order_By_>>;
  where?: InputMaybe<PaiTable_Bool_Exp_>;
};


export type Query_RootPaiTable_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootPortfolioArgs_ = {
  distinct_on?: InputMaybe<Array<Portfolio_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Order_By_>>;
  where?: InputMaybe<Portfolio_Bool_Exp_>;
};


export type Query_RootPortfolioCompanyArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


export type Query_RootPortfolioCompany_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


export type Query_RootPortfolioCompany_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPortfolioNonEligibleFinancialsArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioNonEligibleFinancials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioNonEligibleFinancials_Order_By_>>;
  where?: InputMaybe<PortfolioNonEligibleFinancials_Bool_Exp_>;
};


export type Query_RootPortfolioNonEligibleFinancials_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioNonEligibleFinancials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioNonEligibleFinancials_Order_By_>>;
  where?: InputMaybe<PortfolioNonEligibleFinancials_Bool_Exp_>;
};


export type Query_RootPortfolioNonEligibleFinancials_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPortfolio_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Portfolio_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Order_By_>>;
  where?: InputMaybe<Portfolio_Bool_Exp_>;
};


export type Query_RootPortfolio_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootQuarterEnumArgs_ = {
  distinct_on?: InputMaybe<Array<QuarterEnum_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuarterEnum_Order_By_>>;
  where?: InputMaybe<QuarterEnum_Bool_Exp_>;
};


export type Query_RootQuarterEnum_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuarterEnum_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuarterEnum_Order_By_>>;
  where?: InputMaybe<QuarterEnum_Bool_Exp_>;
};


export type Query_RootQuarterEnum_By_PkArgs_ = {
  quarter: Scalars['String']['input'];
};


export type Query_RootQuestionArgs_ = {
  distinct_on?: InputMaybe<Array<Question_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Order_By_>>;
  where?: InputMaybe<Question_Bool_Exp_>;
};


export type Query_RootQuestionChoiceArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionChoice_Order_By_>>;
  where?: InputMaybe<QuestionChoice_Bool_Exp_>;
};


export type Query_RootQuestionChoice_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionChoice_Order_By_>>;
  where?: InputMaybe<QuestionChoice_Bool_Exp_>;
};


export type Query_RootQuestionChoice_By_PkArgs_ = {
  id: Scalars['bigint']['input'];
};


export type Query_RootQuestionLevelArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionLevel_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionLevel_Order_By_>>;
  where?: InputMaybe<QuestionLevel_Bool_Exp_>;
};


export type Query_RootQuestionLevel_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionLevel_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionLevel_Order_By_>>;
  where?: InputMaybe<QuestionLevel_Bool_Exp_>;
};


export type Query_RootQuestionLevel_By_PkArgs_ = {
  level: Scalars['String']['input'];
};


export type Query_RootQuestionRevisionArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionRevision_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionRevision_Order_By_>>;
  where?: InputMaybe<QuestionRevision_Bool_Exp_>;
};


export type Query_RootQuestionRevision_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionRevision_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionRevision_Order_By_>>;
  where?: InputMaybe<QuestionRevision_Bool_Exp_>;
};


export type Query_RootQuestionRevision_By_PkArgs_ = {
  newQuestionId: Scalars['uuid']['input'];
  oldQuestionId: Scalars['uuid']['input'];
};


export type Query_RootQuestionSetArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionSet_Order_By_>>;
  where?: InputMaybe<QuestionSet_Bool_Exp_>;
};


export type Query_RootQuestionSetQuestionArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionSetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionSetQuestion_Order_By_>>;
  where?: InputMaybe<QuestionSetQuestion_Bool_Exp_>;
};


export type Query_RootQuestionSetQuestion_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionSetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionSetQuestion_Order_By_>>;
  where?: InputMaybe<QuestionSetQuestion_Bool_Exp_>;
};


export type Query_RootQuestionSetQuestion_By_PkArgs_ = {
  questionId: Scalars['uuid']['input'];
  questionSetRef: Scalars['String']['input'];
};


export type Query_RootQuestionSet_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionSet_Order_By_>>;
  where?: InputMaybe<QuestionSet_Bool_Exp_>;
};


export type Query_RootQuestionSet_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootQuestionTypeArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionType_Order_By_>>;
  where?: InputMaybe<QuestionType_Bool_Exp_>;
};


export type Query_RootQuestionType_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionType_Order_By_>>;
  where?: InputMaybe<QuestionType_Bool_Exp_>;
};


export type Query_RootQuestionType_By_PkArgs_ = {
  type: Scalars['String']['input'];
};


export type Query_RootQuestion_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Question_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Order_By_>>;
  where?: InputMaybe<Question_Bool_Exp_>;
};


export type Query_RootQuestion_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReportingGroupArgs_ = {
  distinct_on?: InputMaybe<Array<ReportingGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportingGroup_Order_By_>>;
  where?: InputMaybe<ReportingGroup_Bool_Exp_>;
};


export type Query_RootReportingGroup_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ReportingGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportingGroup_Order_By_>>;
  where?: InputMaybe<ReportingGroup_Bool_Exp_>;
};


export type Query_RootReportingGroup_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSectorArgs_ = {
  distinct_on?: InputMaybe<Array<Sector_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sector_Order_By_>>;
  where?: InputMaybe<Sector_Bool_Exp_>;
};


export type Query_RootSector_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Sector_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sector_Order_By_>>;
  where?: InputMaybe<Sector_Bool_Exp_>;
};


export type Query_RootSector_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootSharedSpaceArgs_ = {
  distinct_on?: InputMaybe<Array<SharedSpace_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SharedSpace_Order_By_>>;
  where?: InputMaybe<SharedSpace_Bool_Exp_>;
};


export type Query_RootSharedSpace_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<SharedSpace_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SharedSpace_Order_By_>>;
  where?: InputMaybe<SharedSpace_Bool_Exp_>;
};


export type Query_RootSharedSpace_By_PkArgs_ = {
  companyId: Scalars['uuid']['input'];
  spaceId: Scalars['String']['input'];
};


export type Query_RootSpaceArgs_ = {
  distinct_on?: InputMaybe<Array<Space_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Space_Order_By_>>;
  where?: InputMaybe<Space_Bool_Exp_>;
};


export type Query_RootSpace_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Space_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Space_Order_By_>>;
  where?: InputMaybe<Space_Bool_Exp_>;
};


export type Query_RootSpace_By_PkArgs_ = {
  id: Scalars['String']['input'];
};


export type Query_RootSubsidiaryArgs_ = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By_>>;
  where?: InputMaybe<Subsidiary_Bool_Exp_>;
};


export type Query_RootSubsidiary_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By_>>;
  where?: InputMaybe<Subsidiary_Bool_Exp_>;
};


export type Query_RootSubsidiary_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTagArgs_ = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By_>>;
  where?: InputMaybe<Tag_Bool_Exp_>;
};


export type Query_RootTagGroupArgs_ = {
  distinct_on?: InputMaybe<Array<TagGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagGroup_Order_By_>>;
  where?: InputMaybe<TagGroup_Bool_Exp_>;
};


export type Query_RootTagGroup_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TagGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagGroup_Order_By_>>;
  where?: InputMaybe<TagGroup_Bool_Exp_>;
};


export type Query_RootTagGroup_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTagTypeArgs_ = {
  distinct_on?: InputMaybe<Array<TagType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagType_Order_By_>>;
  where?: InputMaybe<TagType_Bool_Exp_>;
};


export type Query_RootTagType_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TagType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagType_Order_By_>>;
  where?: InputMaybe<TagType_Bool_Exp_>;
};


export type Query_RootTagType_By_PkArgs_ = {
  type: Scalars['String']['input'];
};


export type Query_RootTagValueArgs_ = {
  distinct_on?: InputMaybe<Array<TagValue_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagValue_Order_By_>>;
  where?: InputMaybe<TagValue_Bool_Exp_>;
};


export type Query_RootTagValue_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TagValue_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagValue_Order_By_>>;
  where?: InputMaybe<TagValue_Bool_Exp_>;
};


export type Query_RootTagValue_By_PkArgs_ = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type Query_RootTag_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By_>>;
  where?: InputMaybe<Tag_Bool_Exp_>;
};


export type Query_RootTag_ArticlesArgs_ = {
  distinct_on?: InputMaybe<Array<Tag_Articles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Articles_Order_By_>>;
  where?: InputMaybe<Tag_Articles_Bool_Exp_>;
};


export type Query_RootTag_Articles_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Tag_Articles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Articles_Order_By_>>;
  where?: InputMaybe<Tag_Articles_Bool_Exp_>;
};


export type Query_RootTag_Articles_By_PkArgs_ = {
  id: Scalars['bigint']['input'];
};


export type Query_RootTag_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTargetQuestionArgs_ = {
  distinct_on?: InputMaybe<Array<TargetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestion_Order_By_>>;
  where?: InputMaybe<TargetQuestion_Bool_Exp_>;
};


export type Query_RootTargetQuestionGroupArgs_ = {
  distinct_on?: InputMaybe<Array<TargetQuestionGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestionGroup_Order_By_>>;
  where?: InputMaybe<TargetQuestionGroup_Bool_Exp_>;
};


export type Query_RootTargetQuestionGroup_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TargetQuestionGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestionGroup_Order_By_>>;
  where?: InputMaybe<TargetQuestionGroup_Bool_Exp_>;
};


export type Query_RootTargetQuestionGroup_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootTargetQuestion_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TargetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestion_Order_By_>>;
  where?: InputMaybe<TargetQuestion_Bool_Exp_>;
};


export type Query_RootTargetQuestion_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Query_RootTaskArgs_ = {
  distinct_on?: InputMaybe<Array<Task_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By_>>;
  where?: InputMaybe<Task_Bool_Exp_>;
};


export type Query_RootTaskStatusEnumArgs_ = {
  distinct_on?: InputMaybe<Array<TaskStatusEnum_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskStatusEnum_Order_By_>>;
  where?: InputMaybe<TaskStatusEnum_Bool_Exp_>;
};


export type Query_RootTaskStatusEnum_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TaskStatusEnum_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskStatusEnum_Order_By_>>;
  where?: InputMaybe<TaskStatusEnum_Bool_Exp_>;
};


export type Query_RootTaskStatusEnum_By_PkArgs_ = {
  status: Scalars['String']['input'];
};


export type Query_RootTask_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Task_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By_>>;
  where?: InputMaybe<Task_Bool_Exp_>;
};


export type Query_RootTask_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTaxonomyPortfolioReportArgs_ = {
  distinct_on?: InputMaybe<Array<TaxonomyPortfolioReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaxonomyPortfolioReport_Order_By_>>;
  where?: InputMaybe<TaxonomyPortfolioReport_Bool_Exp_>;
};


export type Query_RootTaxonomyPortfolioReport_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TaxonomyPortfolioReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaxonomyPortfolioReport_Order_By_>>;
  where?: InputMaybe<TaxonomyPortfolioReport_Bool_Exp_>;
};


export type Query_RootTaxonomyPortfolioReport_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootThreadArgs_ = {
  distinct_on?: InputMaybe<Array<Thread_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Thread_Order_By_>>;
  where?: InputMaybe<Thread_Bool_Exp_>;
};


export type Query_RootThreadSubscriberArgs_ = {
  distinct_on?: InputMaybe<Array<ThreadSubscriber_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ThreadSubscriber_Order_By_>>;
  where?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
};


export type Query_RootThreadSubscriber_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ThreadSubscriber_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ThreadSubscriber_Order_By_>>;
  where?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
};


export type Query_RootThreadSubscriber_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootThread_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Thread_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Thread_Order_By_>>;
  where?: InputMaybe<Thread_Bool_Exp_>;
};


export type Query_RootThread_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTotalComparisonFinancialsArgs_ = {
  distinct_on?: InputMaybe<Array<TotalComparisonFinancials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TotalComparisonFinancials_Order_By_>>;
  where?: InputMaybe<TotalComparisonFinancials_Bool_Exp_>;
};


export type Query_RootTotalComparisonFinancials_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TotalComparisonFinancials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TotalComparisonFinancials_Order_By_>>;
  where?: InputMaybe<TotalComparisonFinancials_Bool_Exp_>;
};


export type Query_RootTriggerTypesArgs_ = {
  distinct_on?: InputMaybe<Array<TriggerTypes_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TriggerTypes_Order_By_>>;
  where?: InputMaybe<TriggerTypes_Bool_Exp_>;
};


export type Query_RootTriggerTypes_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TriggerTypes_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TriggerTypes_Order_By_>>;
  where?: InputMaybe<TriggerTypes_Bool_Exp_>;
};


export type Query_RootTriggerTypes_By_PkArgs_ = {
  type: Scalars['String']['input'];
};


export type Query_RootUserNotificationArgs_ = {
  distinct_on?: InputMaybe<Array<UserNotification_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserNotification_Order_By_>>;
  where?: InputMaybe<UserNotification_Bool_Exp_>;
};


export type Query_RootUserNotification_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<UserNotification_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserNotification_Order_By_>>;
  where?: InputMaybe<UserNotification_Bool_Exp_>;
};


export type Query_RootUserNotification_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUserRoleArgs_ = {
  distinct_on?: InputMaybe<Array<UserRole_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_Order_By_>>;
  where?: InputMaybe<UserRole_Bool_Exp_>;
};


export type Query_RootUserRole_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<UserRole_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_Order_By_>>;
  where?: InputMaybe<UserRole_Bool_Exp_>;
};


export type Query_RootUserRole_By_PkArgs_ = {
  role: Scalars['String']['input'];
};


export type Query_RootUserSessionMetadataArgs_ = {
  distinct_on?: InputMaybe<Array<UserSessionMetadata_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserSessionMetadata_Order_By_>>;
  where?: InputMaybe<UserSessionMetadata_Bool_Exp_>;
};


export type Query_RootUserSessionMetadata_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<UserSessionMetadata_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserSessionMetadata_Order_By_>>;
  where?: InputMaybe<UserSessionMetadata_Bool_Exp_>;
};


export type Query_RootUserSessionMetadata_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootWebsocketTestArgs_ = {
  distinct_on?: InputMaybe<Array<WebsocketTest_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<WebsocketTest_Order_By_>>;
  where?: InputMaybe<WebsocketTest_Bool_Exp_>;
};


export type Query_RootWebsocketTest_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<WebsocketTest_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<WebsocketTest_Order_By_>>;
  where?: InputMaybe<WebsocketTest_Bool_Exp_>;
};


export type Query_RootWebsocketTest_By_PkArgs_ = {
  id: Scalars['Int']['input'];
};


export type Query_RootAuthProviderArgs_ = {
  id: Scalars['String']['input'];
};


export type Query_RootAuthProviderRequestArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthProviderRequestsArgs_ = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By_>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp_>;
};


export type Query_RootAuthProviderRequestsAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By_>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp_>;
};


export type Query_RootAuthProvidersArgs_ = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By_>>;
  where?: InputMaybe<AuthProviders_Bool_Exp_>;
};


export type Query_RootAuthProvidersAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By_>>;
  where?: InputMaybe<AuthProviders_Bool_Exp_>;
};


export type Query_RootAuthRefreshTokenArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthRefreshTokenTypeArgs_ = {
  value: Scalars['String']['input'];
};


export type Query_RootAuthRefreshTokenTypesArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By_>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp_>;
};


export type Query_RootAuthRefreshTokenTypesAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By_>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp_>;
};


export type Query_RootAuthRefreshTokensArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By_>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp_>;
};


export type Query_RootAuthRefreshTokensAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By_>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp_>;
};


export type Query_RootAuthRoleArgs_ = {
  role: Scalars['String']['input'];
};


export type Query_RootAuthRolesArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By_>>;
  where?: InputMaybe<AuthRoles_Bool_Exp_>;
};


export type Query_RootAuthRolesAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By_>>;
  where?: InputMaybe<AuthRoles_Bool_Exp_>;
};


export type Query_RootAuthUserProviderArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthUserProvidersArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By_>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp_>;
};


export type Query_RootAuthUserProvidersAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By_>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp_>;
};


export type Query_RootAuthUserRoleArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthUserRolesArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By_>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp_>;
};


export type Query_RootAuthUserRolesAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By_>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp_>;
};


export type Query_RootAuthUserSecurityKeyArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootAuthUserSecurityKeysArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By_>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp_>;
};


export type Query_RootAuthUserSecurityKeysAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By_>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp_>;
};


export type Query_RootBucketArgs_ = {
  id: Scalars['String']['input'];
};


export type Query_RootBucketsArgs_ = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By_>>;
  where?: InputMaybe<Buckets_Bool_Exp_>;
};


export type Query_RootBucketsAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By_>>;
  where?: InputMaybe<Buckets_Bool_Exp_>;
};


export type Query_RootEsrs_ActionReportingUnitArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionReportingUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionReportingUnit_Order_By_>>;
  where?: InputMaybe<Esrs_ActionReportingUnit_Bool_Exp_>;
};


export type Query_RootEsrs_ActionReportingUnit_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionReportingUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionReportingUnit_Order_By_>>;
  where?: InputMaybe<Esrs_ActionReportingUnit_Bool_Exp_>;
};


export type Query_RootEsrs_ActionReportingUnit_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_ActionSubsidiaryArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionSubsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionSubsidiary_Order_By_>>;
  where?: InputMaybe<Esrs_ActionSubsidiary_Bool_Exp_>;
};


export type Query_RootEsrs_ActionSubsidiary_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionSubsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionSubsidiary_Order_By_>>;
  where?: InputMaybe<Esrs_ActionSubsidiary_Bool_Exp_>;
};


export type Query_RootEsrs_ActionSubsidiary_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_ActionTargetArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionTarget_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionTarget_Order_By_>>;
  where?: InputMaybe<Esrs_ActionTarget_Bool_Exp_>;
};


export type Query_RootEsrs_ActionTarget_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionTarget_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionTarget_Order_By_>>;
  where?: InputMaybe<Esrs_ActionTarget_Bool_Exp_>;
};


export type Query_RootEsrs_ActionTarget_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_ActionsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Actions_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Actions_Order_By_>>;
  where?: InputMaybe<Esrs_Actions_Bool_Exp_>;
};


export type Query_RootEsrs_Actions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Actions_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Actions_Order_By_>>;
  where?: InputMaybe<Esrs_Actions_Bool_Exp_>;
};


export type Query_RootEsrs_Actions_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_AnswerArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Answer_Order_By_>>;
  where?: InputMaybe<Esrs_Answer_Bool_Exp_>;
};


export type Query_RootEsrs_Answer_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Answer_Order_By_>>;
  where?: InputMaybe<Esrs_Answer_Bool_Exp_>;
};


export type Query_RootEsrs_Answer_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_AssessmentCurrencyConversionArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_AssessmentCurrencyConversion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_AssessmentCurrencyConversion_Order_By_>>;
  where?: InputMaybe<Esrs_AssessmentCurrencyConversion_Bool_Exp_>;
};


export type Query_RootEsrs_AssessmentCurrencyConversion_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_AssessmentCurrencyConversion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_AssessmentCurrencyConversion_Order_By_>>;
  where?: InputMaybe<Esrs_AssessmentCurrencyConversion_Bool_Exp_>;
};


export type Query_RootEsrs_AssessmentCurrencyConversion_By_PkArgs_ = {
  assessmentId: Scalars['uuid']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type Query_RootEsrs_BaselineArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Baseline_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Baseline_Order_By_>>;
  where?: InputMaybe<Esrs_Baseline_Bool_Exp_>;
};


export type Query_RootEsrs_Baseline_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Baseline_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Baseline_Order_By_>>;
  where?: InputMaybe<Esrs_Baseline_Bool_Exp_>;
};


export type Query_RootEsrs_Baseline_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_CompanyIntegrationArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_CompanyIntegration_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_CompanyIntegration_Order_By_>>;
  where?: InputMaybe<Esrs_CompanyIntegration_Bool_Exp_>;
};


export type Query_RootEsrs_CompanyIntegration_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_CompanyIntegration_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_CompanyIntegration_Order_By_>>;
  where?: InputMaybe<Esrs_CompanyIntegration_Bool_Exp_>;
};


export type Query_RootEsrs_CompanyIntegration_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_DatapointArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Datapoint_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Datapoint_Order_By_>>;
  where?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
};


export type Query_RootEsrs_DatapointChoiceArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointChoice_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointChoice_Bool_Exp_>;
};


export type Query_RootEsrs_DatapointChoice_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointChoice_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointChoice_Bool_Exp_>;
};


export type Query_RootEsrs_DatapointChoice_By_PkArgs_ = {
  choiceRef: Scalars['String']['input'];
  datapointId: Scalars['uuid']['input'];
};


export type Query_RootEsrs_DatapointMdrmArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointMdrm_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointMdrm_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointMdrm_Bool_Exp_>;
};


export type Query_RootEsrs_DatapointMdrm_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointMdrm_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointMdrm_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointMdrm_Bool_Exp_>;
};


export type Query_RootEsrs_DatapointMdrm_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_DatapointTagArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointTag_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointTag_Bool_Exp_>;
};


export type Query_RootEsrs_DatapointTag_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointTag_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointTag_Bool_Exp_>;
};


export type Query_RootEsrs_DatapointTag_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_Datapoint_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Datapoint_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Datapoint_Order_By_>>;
  where?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
};


export type Query_RootEsrs_Datapoint_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_Deprecated_ActionBusinessUnitArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_ActionBusinessUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_ActionBusinessUnit_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_ActionBusinessUnit_Bool_Exp_>;
};


export type Query_RootEsrs_Deprecated_ActionBusinessUnit_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_ActionBusinessUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_ActionBusinessUnit_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_ActionBusinessUnit_Bool_Exp_>;
};


export type Query_RootEsrs_Deprecated_ActionBusinessUnit_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_Deprecated_BusinessUnitEsrsAssessmentArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Bool_Exp_>;
};


export type Query_RootEsrs_Deprecated_BusinessUnitEsrsAssessment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Bool_Exp_>;
};


export type Query_RootEsrs_Deprecated_BusinessUnitEsrsAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_Deprecated_CompanyMaterialityAssessmentArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_CompanyMaterialityAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_CompanyMaterialityAssessment_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_CompanyMaterialityAssessment_Bool_Exp_>;
};


export type Query_RootEsrs_Deprecated_CompanyMaterialityAssessment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_CompanyMaterialityAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_CompanyMaterialityAssessment_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_CompanyMaterialityAssessment_Bool_Exp_>;
};


export type Query_RootEsrs_Deprecated_CompanyMaterialityAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_Deprecated_EsrsMdrmArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Bool_Exp_>;
};


export type Query_RootEsrs_Deprecated_EsrsMdrm_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Bool_Exp_>;
};


export type Query_RootEsrs_Deprecated_EsrsMdrm_By_PkArgs_ = {
  datapointId: Scalars['uuid']['input'];
  metricRef: Scalars['String']['input'];
};


export type Query_RootEsrs_Deprecated_MaterialDisclosureRequirementArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_>;
};


export type Query_RootEsrs_Deprecated_MaterialDisclosureRequirement_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_>;
};


export type Query_RootEsrs_Deprecated_MaterialDisclosureRequirement_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_Deprecated_MetricAnswerArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_MetricAnswer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_MetricAnswer_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_MetricAnswer_Bool_Exp_>;
};


export type Query_RootEsrs_Deprecated_MetricAnswer_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_MetricAnswer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_MetricAnswer_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_MetricAnswer_Bool_Exp_>;
};


export type Query_RootEsrs_Deprecated_MetricAnswer_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_DisclosureRequirementAttachmentArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Order_By_>>;
  where?: InputMaybe<Esrs_DisclosureRequirementAttachment_Bool_Exp_>;
};


export type Query_RootEsrs_DisclosureRequirementAttachment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Order_By_>>;
  where?: InputMaybe<Esrs_DisclosureRequirementAttachment_Bool_Exp_>;
};


export type Query_RootEsrs_DisclosureRequirementAttachment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_EsrsAssessmentCompanyIntegrationArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>;
};


export type Query_RootEsrs_EsrsAssessmentCompanyIntegrationRuArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_>;
};


export type Query_RootEsrs_EsrsAssessmentCompanyIntegrationRu_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_>;
};


export type Query_RootEsrs_EsrsAssessmentCompanyIntegrationRu_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_EsrsAssessmentCompanyIntegration_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>;
};


export type Query_RootEsrs_EsrsAssessmentCompanyIntegration_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_EsrsMetricHierarchyStatusArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsMetricHierarchyStatus_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsMetricHierarchyStatus_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsMetricHierarchyStatus_Bool_Exp_>;
};


export type Query_RootEsrs_EsrsMetricHierarchyStatus_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsMetricHierarchyStatus_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsMetricHierarchyStatus_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsMetricHierarchyStatus_Bool_Exp_>;
};


export type Query_RootEsrs_MaterialMetricArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetric_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
};


export type Query_RootEsrs_MaterialMetricTagArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetricTag_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
};


export type Query_RootEsrs_MaterialMetricTag_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetricTag_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
};


export type Query_RootEsrs_MaterialMetricTag_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_MaterialMetric_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetric_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
};


export type Query_RootEsrs_MaterialMetric_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_MaterialStandardArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialStandard_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
};


export type Query_RootEsrs_MaterialStandard_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialStandard_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
};


export type Query_RootEsrs_MaterialStandard_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_MaterialTagValueArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialTagValue_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialTagValue_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialTagValue_Bool_Exp_>;
};


export type Query_RootEsrs_MaterialTagValue_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialTagValue_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialTagValue_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialTagValue_Bool_Exp_>;
};


export type Query_RootEsrs_MaterialTagValue_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_MetricDependencyClosureArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MetricDependencyClosure_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MetricDependencyClosure_Order_By_>>;
  where?: InputMaybe<Esrs_MetricDependencyClosure_Bool_Exp_>;
};


export type Query_RootEsrs_MetricDependencyClosure_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MetricDependencyClosure_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MetricDependencyClosure_Order_By_>>;
  where?: InputMaybe<Esrs_MetricDependencyClosure_Bool_Exp_>;
};


export type Query_RootEsrs_MetricRelatedDisclosureRequirementArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Bool_Exp_>;
};


export type Query_RootEsrs_MetricRelatedDisclosureRequirement_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Bool_Exp_>;
};


export type Query_RootEsrs_MilestoneArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Milestone_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Milestone_Order_By_>>;
  where?: InputMaybe<Esrs_Milestone_Bool_Exp_>;
};


export type Query_RootEsrs_MilestoneResultArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MilestoneResult_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MilestoneResult_Order_By_>>;
  where?: InputMaybe<Esrs_MilestoneResult_Bool_Exp_>;
};


export type Query_RootEsrs_MilestoneResult_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MilestoneResult_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MilestoneResult_Order_By_>>;
  where?: InputMaybe<Esrs_MilestoneResult_Bool_Exp_>;
};


export type Query_RootEsrs_MilestoneResult_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_Milestone_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Milestone_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Milestone_Order_By_>>;
  where?: InputMaybe<Esrs_Milestone_Bool_Exp_>;
};


export type Query_RootEsrs_Milestone_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_PolicyArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Policy_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Policy_Order_By_>>;
  where?: InputMaybe<Esrs_Policy_Bool_Exp_>;
};


export type Query_RootEsrs_Policy_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Policy_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Policy_Order_By_>>;
  where?: InputMaybe<Esrs_Policy_Bool_Exp_>;
};


export type Query_RootEsrs_Policy_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_ReportingUnitArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ReportingUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ReportingUnit_Order_By_>>;
  where?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
};


export type Query_RootEsrs_ReportingUnitLineageArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ReportingUnitLineage_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ReportingUnitLineage_Order_By_>>;
  where?: InputMaybe<Esrs_ReportingUnitLineage_Bool_Exp_>;
};


export type Query_RootEsrs_ReportingUnitLineage_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ReportingUnitLineage_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ReportingUnitLineage_Order_By_>>;
  where?: InputMaybe<Esrs_ReportingUnitLineage_Bool_Exp_>;
};


export type Query_RootEsrs_ReportingUnitLineage_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_ReportingUnit_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ReportingUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ReportingUnit_Order_By_>>;
  where?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
};


export type Query_RootEsrs_ReportingUnit_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEsrs_TargetArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Target_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Target_Order_By_>>;
  where?: InputMaybe<Esrs_Target_Bool_Exp_>;
};


export type Query_RootEsrs_Target_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Target_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Target_Order_By_>>;
  where?: InputMaybe<Esrs_Target_Bool_Exp_>;
};


export type Query_RootEsrs_Target_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFileArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootFilesArgs_ = {
  distinct_on?: InputMaybe<Array<Files_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By_>>;
  where?: InputMaybe<Files_Bool_Exp_>;
};


export type Query_RootFilesAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Files_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By_>>;
  where?: InputMaybe<Files_Bool_Exp_>;
};


export type Query_RootGetInvitationArgs_ = {
  query: InvitationQuery_;
};


export type Query_RootGetPortfolioAggregateArgs_ = {
  input?: InputMaybe<PortfolioAgreggateInput_>;
};


export type Query_RootUserArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUsersArgs_ = {
  distinct_on?: InputMaybe<Array<Users_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By_>>;
  where?: InputMaybe<Users_Bool_Exp_>;
};


export type Query_RootUsersAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Users_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By_>>;
  where?: InputMaybe<Users_Bool_Exp_>;
};


export type Query_RootVirusArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Query_RootVirusesArgs_ = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By_>>;
  where?: InputMaybe<Virus_Bool_Exp_>;
};


export type Query_RootVirusesAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By_>>;
  where?: InputMaybe<Virus_Bool_Exp_>;
};

export type Subscription_Root_ = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "AIConfig" */
  AIConfig: Array<AiConfig_>;
  /** fetch aggregated fields from the table: "AIConfig" */
  AIConfig_aggregate: AiConfig_Aggregate_;
  /** fetch data from the table: "AIConfig" using primary key columns */
  AIConfig_by_pk?: Maybe<AiConfig_>;
  /** fetch data from the table in a streaming manner: "AIConfig" */
  AIConfig_stream: Array<AiConfig_>;
  /** fetch data from the table: "esrs.ActionQuestion" */
  ActionQuestion: Array<ActionQuestion_>;
  /** fetch data from the table: "esrs.ActionQuestionGroup" */
  ActionQuestionGroup: Array<ActionQuestionGroup_>;
  /** fetch aggregated fields from the table: "esrs.ActionQuestionGroup" */
  ActionQuestionGroup_aggregate: ActionQuestionGroup_Aggregate_;
  /** fetch data from the table: "esrs.ActionQuestionGroup" using primary key columns */
  ActionQuestionGroup_by_pk?: Maybe<ActionQuestionGroup_>;
  /** fetch data from the table in a streaming manner: "esrs.ActionQuestionGroup" */
  ActionQuestionGroup_stream: Array<ActionQuestionGroup_>;
  /** fetch aggregated fields from the table: "esrs.ActionQuestion" */
  ActionQuestion_aggregate: ActionQuestion_Aggregate_;
  /** fetch data from the table: "esrs.ActionQuestion" using primary key columns */
  ActionQuestion_by_pk?: Maybe<ActionQuestion_>;
  /** fetch data from the table in a streaming manner: "esrs.ActionQuestion" */
  ActionQuestion_stream: Array<ActionQuestion_>;
  /** fetch data from the table: "Activity" */
  Activity: Array<Activity_>;
  /** fetch data from the table: "ActivityNaceCode" */
  ActivityNaceCode: Array<ActivityNaceCode_>;
  /** fetch aggregated fields from the table: "ActivityNaceCode" */
  ActivityNaceCode_aggregate: ActivityNaceCode_Aggregate_;
  /** fetch data from the table: "ActivityNaceCode" using primary key columns */
  ActivityNaceCode_by_pk?: Maybe<ActivityNaceCode_>;
  /** fetch data from the table in a streaming manner: "ActivityNaceCode" */
  ActivityNaceCode_stream: Array<ActivityNaceCode_>;
  /** fetch data from the table: "ActivityQuestionSet" */
  ActivityQuestionSet: Array<ActivityQuestionSet_>;
  /** fetch aggregated fields from the table: "ActivityQuestionSet" */
  ActivityQuestionSet_aggregate: ActivityQuestionSet_Aggregate_;
  /** fetch data from the table: "ActivityQuestionSet" using primary key columns */
  ActivityQuestionSet_by_pk?: Maybe<ActivityQuestionSet_>;
  /** fetch data from the table in a streaming manner: "ActivityQuestionSet" */
  ActivityQuestionSet_stream: Array<ActivityQuestionSet_>;
  /** fetch data from the table: "ActivityReport" */
  ActivityReport: Array<ActivityReport_>;
  /** fetch aggregated fields from the table: "ActivityReport" */
  ActivityReport_aggregate: ActivityReport_Aggregate_;
  /** fetch data from the table: "ActivityReport" using primary key columns */
  ActivityReport_by_pk?: Maybe<ActivityReport_>;
  /** fetch data from the table in a streaming manner: "ActivityReport" */
  ActivityReport_stream: Array<ActivityReport_>;
  /** fetch data from the table: "ActivityVersion" */
  ActivityVersion: Array<ActivityVersion_>;
  /** fetch aggregated fields from the table: "ActivityVersion" */
  ActivityVersion_aggregate: ActivityVersion_Aggregate_;
  /** fetch data from the table: "ActivityVersion" using primary key columns */
  ActivityVersion_by_pk?: Maybe<ActivityVersion_>;
  /** fetch data from the table in a streaming manner: "ActivityVersion" */
  ActivityVersion_stream: Array<ActivityVersion_>;
  /** fetch aggregated fields from the table: "Activity" */
  Activity_aggregate: Activity_Aggregate_;
  /** fetch data from the table: "Activity" using primary key columns */
  Activity_by_pk?: Maybe<Activity_>;
  /** fetch data from the table in a streaming manner: "Activity" */
  Activity_stream: Array<Activity_>;
  /** fetch data from the table: "esrs.AdditionalType" */
  AdditionalType: Array<AdditionalType_>;
  /** fetch aggregated fields from the table: "esrs.AdditionalType" */
  AdditionalType_aggregate: AdditionalType_Aggregate_;
  /** fetch data from the table: "esrs.AdditionalType" using primary key columns */
  AdditionalType_by_pk?: Maybe<AdditionalType_>;
  /** fetch data from the table in a streaming manner: "esrs.AdditionalType" */
  AdditionalType_stream: Array<AdditionalType_>;
  /** fetch data from the table: "Answer" */
  Answer: Array<Answer_>;
  /** fetch data from the table: "AnswerCompany" */
  AnswerCompany: Array<AnswerCompany_>;
  /** fetch aggregated fields from the table: "AnswerCompany" */
  AnswerCompany_aggregate: AnswerCompany_Aggregate_;
  /** fetch data from the table in a streaming manner: "AnswerCompany" */
  AnswerCompany_stream: Array<AnswerCompany_>;
  /** fetch aggregated fields from the table: "Answer" */
  Answer_aggregate: Answer_Aggregate_;
  /** fetch data from the table: "Answer" using primary key columns */
  Answer_by_pk?: Maybe<Answer_>;
  /** fetch data from the table in a streaming manner: "Answer" */
  Answer_stream: Array<Answer_>;
  /** fetch data from the table: "AppConfig" */
  AppConfig: Array<AppConfig_>;
  /** fetch aggregated fields from the table: "AppConfig" */
  AppConfig_aggregate: AppConfig_Aggregate_;
  /** fetch data from the table: "AppConfig" using primary key columns */
  AppConfig_by_pk?: Maybe<AppConfig_>;
  /** fetch data from the table in a streaming manner: "AppConfig" */
  AppConfig_stream: Array<AppConfig_>;
  /** fetch data from the table: "Article" */
  Article: Array<Article_>;
  /** fetch aggregated fields from the table: "Article" */
  Article_aggregate: Article_Aggregate_;
  /** fetch data from the table: "Article" using primary key columns */
  Article_by_pk?: Maybe<Article_>;
  /** fetch data from the table in a streaming manner: "Article" */
  Article_stream: Array<Article_>;
  /** fetch data from the table: "Attachment" */
  Attachment: Array<Attachment_>;
  /** fetch data from the table: "AttachmentBox" */
  AttachmentBox: Array<AttachmentBox_>;
  /** fetch aggregated fields from the table: "AttachmentBox" */
  AttachmentBox_aggregate: AttachmentBox_Aggregate_;
  /** fetch data from the table: "AttachmentBox" using primary key columns */
  AttachmentBox_by_pk?: Maybe<AttachmentBox_>;
  /** fetch data from the table in a streaming manner: "AttachmentBox" */
  AttachmentBox_stream: Array<AttachmentBox_>;
  /** fetch aggregated fields from the table: "Attachment" */
  Attachment_aggregate: Attachment_Aggregate_;
  /** fetch data from the table: "Attachment" using primary key columns */
  Attachment_by_pk?: Maybe<Attachment_>;
  /** fetch data from the table in a streaming manner: "Attachment" */
  Attachment_stream: Array<Attachment_>;
  /** fetch data from the table: "AuditLogEntry" */
  AuditLogEntry: Array<AuditLogEntry_>;
  /** fetch aggregated fields from the table: "AuditLogEntry" */
  AuditLogEntry_aggregate: AuditLogEntry_Aggregate_;
  /** fetch data from the table: "AuditLogEntry" using primary key columns */
  AuditLogEntry_by_pk?: Maybe<AuditLogEntry_>;
  /** fetch data from the table in a streaming manner: "AuditLogEntry" */
  AuditLogEntry_stream: Array<AuditLogEntry_>;
  /** fetch data from the table: "BusinessUnit" */
  BusinessUnit: Array<BusinessUnit_>;
  /** fetch data from the table: "BusinessUnitAssessment" */
  BusinessUnitAssessment: Array<BusinessUnitAssessment_>;
  /** fetch aggregated fields from the table: "BusinessUnitAssessment" */
  BusinessUnitAssessment_aggregate: BusinessUnitAssessment_Aggregate_;
  /** fetch data from the table: "BusinessUnitAssessment" using primary key columns */
  BusinessUnitAssessment_by_pk?: Maybe<BusinessUnitAssessment_>;
  /** fetch data from the table in a streaming manner: "BusinessUnitAssessment" */
  BusinessUnitAssessment_stream: Array<BusinessUnitAssessment_>;
  /** fetch aggregated fields from the table: "BusinessUnit" */
  BusinessUnit_aggregate: BusinessUnit_Aggregate_;
  /** fetch data from the table: "BusinessUnit" using primary key columns */
  BusinessUnit_by_pk?: Maybe<BusinessUnit_>;
  /** fetch data from the table in a streaming manner: "BusinessUnit" */
  BusinessUnit_stream: Array<BusinessUnit_>;
  /** fetch data from the table: "CachedResult" */
  CachedResult: Array<CachedResult_>;
  /** fetch aggregated fields from the table: "CachedResult" */
  CachedResult_aggregate: CachedResult_Aggregate_;
  /** fetch data from the table: "CachedResult" using primary key columns */
  CachedResult_by_pk?: Maybe<CachedResult_>;
  /** fetch data from the table in a streaming manner: "CachedResult" */
  CachedResult_stream: Array<CachedResult_>;
  /** fetch data from the table: "esrs.ChoiceSet" */
  ChoiceSet: Array<ChoiceSet_>;
  /** fetch aggregated fields from the table: "esrs.ChoiceSet" */
  ChoiceSet_aggregate: ChoiceSet_Aggregate_;
  /** fetch data from the table: "esrs.ChoiceSet" using primary key columns */
  ChoiceSet_by_pk?: Maybe<ChoiceSet_>;
  /** fetch data from the table in a streaming manner: "esrs.ChoiceSet" */
  ChoiceSet_stream: Array<ChoiceSet_>;
  /** fetch data from the table: "Comment" */
  Comment: Array<Comment_>;
  /** fetch aggregated fields from the table: "Comment" */
  Comment_aggregate: Comment_Aggregate_;
  /** fetch data from the table: "Comment" using primary key columns */
  Comment_by_pk?: Maybe<Comment_>;
  /** fetch data from the table in a streaming manner: "Comment" */
  Comment_stream: Array<Comment_>;
  /** fetch data from the table: "Company" */
  Company: Array<Company_>;
  /** fetch data from the table: "CompanyAssessment" */
  CompanyAssessment: Array<CompanyAssessment_>;
  /** fetch data from the table: "CompanyAssessmentAggregate" */
  CompanyAssessmentAggregate: Array<CompanyAssessmentAggregate_>;
  /** fetch aggregated fields from the table: "CompanyAssessmentAggregate" */
  CompanyAssessmentAggregate_aggregate: CompanyAssessmentAggregate_Aggregate_;
  /** fetch data from the table: "CompanyAssessmentAggregate" using primary key columns */
  CompanyAssessmentAggregate_by_pk?: Maybe<CompanyAssessmentAggregate_>;
  /** fetch data from the table in a streaming manner: "CompanyAssessmentAggregate" */
  CompanyAssessmentAggregate_stream: Array<CompanyAssessmentAggregate_>;
  /** fetch aggregated fields from the table: "CompanyAssessment" */
  CompanyAssessment_aggregate: CompanyAssessment_Aggregate_;
  /** fetch data from the table: "CompanyAssessment" using primary key columns */
  CompanyAssessment_by_pk?: Maybe<CompanyAssessment_>;
  /** fetch data from the table in a streaming manner: "CompanyAssessment" */
  CompanyAssessment_stream: Array<CompanyAssessment_>;
  /** fetch data from the table: "CompanyIdentityProvider" */
  CompanyIdentityProvider: Array<CompanyIdentityProvider_>;
  /** fetch aggregated fields from the table: "CompanyIdentityProvider" */
  CompanyIdentityProvider_aggregate: CompanyIdentityProvider_Aggregate_;
  /** fetch data from the table: "CompanyIdentityProvider" using primary key columns */
  CompanyIdentityProvider_by_pk?: Maybe<CompanyIdentityProvider_>;
  /** fetch data from the table in a streaming manner: "CompanyIdentityProvider" */
  CompanyIdentityProvider_stream: Array<CompanyIdentityProvider_>;
  /** fetch data from the table: "CompanyInvitation" */
  CompanyInvitation: Array<CompanyInvitation_>;
  /** fetch aggregated fields from the table: "CompanyInvitation" */
  CompanyInvitation_aggregate: CompanyInvitation_Aggregate_;
  /** fetch data from the table: "CompanyInvitation" using primary key columns */
  CompanyInvitation_by_pk?: Maybe<CompanyInvitation_>;
  /** fetch data from the table in a streaming manner: "CompanyInvitation" */
  CompanyInvitation_stream: Array<CompanyInvitation_>;
  /** fetch data from the table: "CompanyUser" */
  CompanyUser: Array<CompanyUser_>;
  /** fetch aggregated fields from the table: "CompanyUser" */
  CompanyUser_aggregate: CompanyUser_Aggregate_;
  /** fetch data from the table: "CompanyUser" using primary key columns */
  CompanyUser_by_pk?: Maybe<CompanyUser_>;
  /** fetch data from the table in a streaming manner: "CompanyUser" */
  CompanyUser_stream: Array<CompanyUser_>;
  /** fetch aggregated fields from the table: "Company" */
  Company_aggregate: Company_Aggregate_;
  /** fetch data from the table: "Company" using primary key columns */
  Company_by_pk?: Maybe<Company_>;
  /** fetch data from the table in a streaming manner: "Company" */
  Company_stream: Array<Company_>;
  /** fetch data from the table: "CompassPAT" */
  CompassPAT: Array<CompassPat_>;
  /** fetch aggregated fields from the table: "CompassPAT" */
  CompassPAT_aggregate: CompassPat_Aggregate_;
  /** fetch data from the table: "CompassPAT" using primary key columns */
  CompassPAT_by_pk?: Maybe<CompassPat_>;
  /** fetch data from the table in a streaming manner: "CompassPAT" */
  CompassPAT_stream: Array<CompassPat_>;
  /** fetch data from the table: "esrs.DRToMFDisclosureRequirement" */
  DRToMFDisclosureRequirement: Array<DrToMfDisclosureRequirement_>;
  /** fetch aggregated fields from the table: "esrs.DRToMFDisclosureRequirement" */
  DRToMFDisclosureRequirement_aggregate: DrToMfDisclosureRequirement_Aggregate_;
  /** fetch data from the table: "esrs.DRToMFDisclosureRequirement" using primary key columns */
  DRToMFDisclosureRequirement_by_pk?: Maybe<DrToMfDisclosureRequirement_>;
  /** fetch data from the table in a streaming manner: "esrs.DRToMFDisclosureRequirement" */
  DRToMFDisclosureRequirement_stream: Array<DrToMfDisclosureRequirement_>;
  /** fetch data from the table: "esrs.DisclosureRequirement" */
  DisclosureRequirement: Array<DisclosureRequirement_>;
  /** fetch data from the table: "esrs.DisclosureRequirementAdditionalType" */
  DisclosureRequirementAdditionalType: Array<DisclosureRequirementAdditionalType_>;
  /** fetch aggregated fields from the table: "esrs.DisclosureRequirementAdditionalType" */
  DisclosureRequirementAdditionalType_aggregate: DisclosureRequirementAdditionalType_Aggregate_;
  /** fetch data from the table: "esrs.DisclosureRequirementAdditionalType" using primary key columns */
  DisclosureRequirementAdditionalType_by_pk?: Maybe<DisclosureRequirementAdditionalType_>;
  /** fetch data from the table in a streaming manner: "esrs.DisclosureRequirementAdditionalType" */
  DisclosureRequirementAdditionalType_stream: Array<DisclosureRequirementAdditionalType_>;
  /** fetch data from the table: "esrs.DisclosureRequirementGroup" */
  DisclosureRequirementGroup: Array<DisclosureRequirementGroup_>;
  /** fetch aggregated fields from the table: "esrs.DisclosureRequirementGroup" */
  DisclosureRequirementGroup_aggregate: DisclosureRequirementGroup_Aggregate_;
  /** fetch data from the table: "esrs.DisclosureRequirementGroup" using primary key columns */
  DisclosureRequirementGroup_by_pk?: Maybe<DisclosureRequirementGroup_>;
  /** fetch data from the table in a streaming manner: "esrs.DisclosureRequirementGroup" */
  DisclosureRequirementGroup_stream: Array<DisclosureRequirementGroup_>;
  /** fetch data from the table: "esrs.DisclosureRequirementOwner" */
  DisclosureRequirementOwner: Array<DisclosureRequirementOwner_>;
  /** fetch aggregated fields from the table: "esrs.DisclosureRequirementOwner" */
  DisclosureRequirementOwner_aggregate: DisclosureRequirementOwner_Aggregate_;
  /** fetch data from the table: "esrs.DisclosureRequirementOwner" using primary key columns */
  DisclosureRequirementOwner_by_pk?: Maybe<DisclosureRequirementOwner_>;
  /** fetch data from the table in a streaming manner: "esrs.DisclosureRequirementOwner" */
  DisclosureRequirementOwner_stream: Array<DisclosureRequirementOwner_>;
  /** fetch data from the table: "esrs.DisclosureRequirementStatus" */
  DisclosureRequirementStatus: Array<DisclosureRequirementStatus_>;
  /** fetch aggregated fields from the table: "esrs.DisclosureRequirementStatus" */
  DisclosureRequirementStatus_aggregate: DisclosureRequirementStatus_Aggregate_;
  /** fetch data from the table: "esrs.DisclosureRequirementStatus" using primary key columns */
  DisclosureRequirementStatus_by_pk?: Maybe<DisclosureRequirementStatus_>;
  /** fetch data from the table in a streaming manner: "esrs.DisclosureRequirementStatus" */
  DisclosureRequirementStatus_stream: Array<DisclosureRequirementStatus_>;
  /** fetch aggregated fields from the table: "esrs.DisclosureRequirement" */
  DisclosureRequirement_aggregate: DisclosureRequirement_Aggregate_;
  /** fetch data from the table: "esrs.DisclosureRequirement" using primary key columns */
  DisclosureRequirement_by_pk?: Maybe<DisclosureRequirement_>;
  /** fetch data from the table in a streaming manner: "esrs.DisclosureRequirement" */
  DisclosureRequirement_stream: Array<DisclosureRequirement_>;
  /** fetch data from the table: "DocumentInsight" */
  DocumentInsight: Array<DocumentInsight_>;
  /** fetch aggregated fields from the table: "DocumentInsight" */
  DocumentInsight_aggregate: DocumentInsight_Aggregate_;
  /** fetch data from the table: "DocumentInsight" using primary key columns */
  DocumentInsight_by_pk?: Maybe<DocumentInsight_>;
  /** fetch data from the table in a streaming manner: "DocumentInsight" */
  DocumentInsight_stream: Array<DocumentInsight_>;
  /** fetch data from the table: "DocumentationFile" */
  DocumentationFile: Array<DocumentationFile_>;
  /** fetch aggregated fields from the table: "DocumentationFile" */
  DocumentationFile_aggregate: DocumentationFile_Aggregate_;
  /** fetch data from the table: "DocumentationFile" using primary key columns */
  DocumentationFile_by_pk?: Maybe<DocumentationFile_>;
  /** fetch data from the table in a streaming manner: "DocumentationFile" */
  DocumentationFile_stream: Array<DocumentationFile_>;
  /** fetch data from the table: "esrs.EsrsAssessment" */
  EsrsAssessment: Array<EsrsAssessment_>;
  /** fetch aggregated fields from the table: "esrs.EsrsAssessment" */
  EsrsAssessment_aggregate: EsrsAssessment_Aggregate_;
  /** fetch data from the table: "esrs.EsrsAssessment" using primary key columns */
  EsrsAssessment_by_pk?: Maybe<EsrsAssessment_>;
  /** fetch data from the table in a streaming manner: "esrs.EsrsAssessment" */
  EsrsAssessment_stream: Array<EsrsAssessment_>;
  /** fetch data from the table: "esrs.EsrsCategory" */
  EsrsCategory: Array<EsrsCategory_>;
  /** fetch aggregated fields from the table: "esrs.EsrsCategory" */
  EsrsCategory_aggregate: EsrsCategory_Aggregate_;
  /** fetch data from the table: "esrs.EsrsCategory" using primary key columns */
  EsrsCategory_by_pk?: Maybe<EsrsCategory_>;
  /** fetch data from the table in a streaming manner: "esrs.EsrsCategory" */
  EsrsCategory_stream: Array<EsrsCategory_>;
  /** fetch data from the table: "esrs.EsrsChoice" */
  EsrsChoice: Array<EsrsChoice_>;
  /** fetch aggregated fields from the table: "esrs.EsrsChoice" */
  EsrsChoice_aggregate: EsrsChoice_Aggregate_;
  /** fetch data from the table: "esrs.EsrsChoice" using primary key columns */
  EsrsChoice_by_pk?: Maybe<EsrsChoice_>;
  /** fetch data from the table in a streaming manner: "esrs.EsrsChoice" */
  EsrsChoice_stream: Array<EsrsChoice_>;
  /** fetch data from the table: "esrs.EsrsMetric" */
  EsrsMetric: Array<EsrsMetric_>;
  /** fetch data from the table: "esrs.EsrsMetricAdditionalType" */
  EsrsMetricAdditionalType: Array<EsrsMetricAdditionalType_>;
  /** fetch aggregated fields from the table: "esrs.EsrsMetricAdditionalType" */
  EsrsMetricAdditionalType_aggregate: EsrsMetricAdditionalType_Aggregate_;
  /** fetch data from the table: "esrs.EsrsMetricAdditionalType" using primary key columns */
  EsrsMetricAdditionalType_by_pk?: Maybe<EsrsMetricAdditionalType_>;
  /** fetch data from the table in a streaming manner: "esrs.EsrsMetricAdditionalType" */
  EsrsMetricAdditionalType_stream: Array<EsrsMetricAdditionalType_>;
  /** fetch aggregated fields from the table: "esrs.EsrsMetric" */
  EsrsMetric_aggregate: EsrsMetric_Aggregate_;
  /** fetch data from the table: "esrs.EsrsMetric" using primary key columns */
  EsrsMetric_by_pk?: Maybe<EsrsMetric_>;
  /** fetch data from the table in a streaming manner: "esrs.EsrsMetric" */
  EsrsMetric_stream: Array<EsrsMetric_>;
  /** fetch data from the table: "esrs.EsrsStandard" */
  EsrsStandard: Array<EsrsStandard_>;
  /** fetch data from the table: "esrs.EsrsStandardAdditionalType" */
  EsrsStandardAdditionalType: Array<EsrsStandardAdditionalType_>;
  /** fetch aggregated fields from the table: "esrs.EsrsStandardAdditionalType" */
  EsrsStandardAdditionalType_aggregate: EsrsStandardAdditionalType_Aggregate_;
  /** fetch data from the table: "esrs.EsrsStandardAdditionalType" using primary key columns */
  EsrsStandardAdditionalType_by_pk?: Maybe<EsrsStandardAdditionalType_>;
  /** fetch data from the table in a streaming manner: "esrs.EsrsStandardAdditionalType" */
  EsrsStandardAdditionalType_stream: Array<EsrsStandardAdditionalType_>;
  /** fetch aggregated fields from the table: "esrs.EsrsStandard" */
  EsrsStandard_aggregate: EsrsStandard_Aggregate_;
  /** fetch data from the table: "esrs.EsrsStandard" using primary key columns */
  EsrsStandard_by_pk?: Maybe<EsrsStandard_>;
  /** fetch data from the table in a streaming manner: "esrs.EsrsStandard" */
  EsrsStandard_stream: Array<EsrsStandard_>;
  /** fetch data from the table: "EstimateCompany_deprecated" */
  EstimateCompany_deprecated: Array<EstimateCompany_Deprecated_>;
  /** fetch aggregated fields from the table: "EstimateCompany_deprecated" */
  EstimateCompany_deprecated_aggregate: EstimateCompany_Deprecated_Aggregate_;
  /** fetch data from the table: "EstimateCompany_deprecated" using primary key columns */
  EstimateCompany_deprecated_by_pk?: Maybe<EstimateCompany_Deprecated_>;
  /** fetch data from the table in a streaming manner: "EstimateCompany_deprecated" */
  EstimateCompany_deprecated_stream: Array<EstimateCompany_Deprecated_>;
  /** fetch data from the table: "ExtractionJob" */
  ExtractionJob: Array<ExtractionJob_>;
  /** fetch aggregated fields from the table: "ExtractionJob" */
  ExtractionJob_aggregate: ExtractionJob_Aggregate_;
  /** fetch data from the table: "ExtractionJob" using primary key columns */
  ExtractionJob_by_pk?: Maybe<ExtractionJob_>;
  /** fetch data from the table in a streaming manner: "ExtractionJob" */
  ExtractionJob_stream: Array<ExtractionJob_>;
  /** fetch data from the table: "Financials" */
  Financials: Array<Financials_>;
  /** fetch aggregated fields from the table: "Financials" */
  Financials_aggregate: Financials_Aggregate_;
  /** fetch data from the table: "Financials" using primary key columns */
  Financials_by_pk?: Maybe<Financials_>;
  /** fetch data from the table in a streaming manner: "Financials" */
  Financials_stream: Array<Financials_>;
  /** fetch data from the table: "esrs.Framework" */
  Framework: Array<Framework_>;
  /** fetch aggregated fields from the table: "esrs.Framework" */
  Framework_aggregate: Framework_Aggregate_;
  /** fetch data from the table: "esrs.Framework" using primary key columns */
  Framework_by_pk?: Maybe<Framework_>;
  /** fetch data from the table in a streaming manner: "esrs.Framework" */
  Framework_stream: Array<Framework_>;
  /** fetch data from the table: "GroupAssessment" */
  GroupAssessment: Array<GroupAssessment_>;
  /** fetch aggregated fields from the table: "GroupAssessment" */
  GroupAssessment_aggregate: GroupAssessment_Aggregate_;
  /** fetch data from the table: "GroupAssessment" using primary key columns */
  GroupAssessment_by_pk?: Maybe<GroupAssessment_>;
  /** fetch data from the table in a streaming manner: "GroupAssessment" */
  GroupAssessment_stream: Array<GroupAssessment_>;
  /** fetch data from the table: "IdentityProvider" */
  IdentityProvider: Array<IdentityProvider_>;
  /** fetch aggregated fields from the table: "IdentityProvider" */
  IdentityProvider_aggregate: IdentityProvider_Aggregate_;
  /** fetch data from the table: "IdentityProvider" using primary key columns */
  IdentityProvider_by_pk?: Maybe<IdentityProvider_>;
  /** fetch data from the table in a streaming manner: "IdentityProvider" */
  IdentityProvider_stream: Array<IdentityProvider_>;
  /** fetch data from the table: "IndicatorToInvestorMetric" */
  IndicatorToInvestorMetric: Array<IndicatorToInvestorMetric_>;
  /** fetch aggregated fields from the table: "IndicatorToInvestorMetric" */
  IndicatorToInvestorMetric_aggregate: IndicatorToInvestorMetric_Aggregate_;
  /** fetch data from the table: "IndicatorToInvestorMetric" using primary key columns */
  IndicatorToInvestorMetric_by_pk?: Maybe<IndicatorToInvestorMetric_>;
  /** fetch data from the table in a streaming manner: "IndicatorToInvestorMetric" */
  IndicatorToInvestorMetric_stream: Array<IndicatorToInvestorMetric_>;
  /** fetch data from the table: "InvesteeMetric" */
  InvesteeMetric: Array<InvesteeMetric_>;
  /** fetch aggregated fields from the table: "InvesteeMetric" */
  InvesteeMetric_aggregate: InvesteeMetric_Aggregate_;
  /** fetch data from the table: "InvesteeMetric" using primary key columns */
  InvesteeMetric_by_pk?: Maybe<InvesteeMetric_>;
  /** fetch data from the table in a streaming manner: "InvesteeMetric" */
  InvesteeMetric_stream: Array<InvesteeMetric_>;
  /** fetch data from the table: "InvestmentCategory" */
  InvestmentCategory: Array<InvestmentCategory_>;
  /** fetch aggregated fields from the table: "InvestmentCategory" */
  InvestmentCategory_aggregate: InvestmentCategory_Aggregate_;
  /** fetch data from the table: "InvestmentCategory" using primary key columns */
  InvestmentCategory_by_pk?: Maybe<InvestmentCategory_>;
  /** fetch data from the table in a streaming manner: "InvestmentCategory" */
  InvestmentCategory_stream: Array<InvestmentCategory_>;
  /** fetch data from the table: "InvestorMetric" */
  InvestorMetric: Array<InvestorMetric_>;
  /** fetch aggregated fields from the table: "InvestorMetric" */
  InvestorMetric_aggregate: InvestorMetric_Aggregate_;
  /** fetch data from the table: "InvestorMetric" using primary key columns */
  InvestorMetric_by_pk?: Maybe<InvestorMetric_>;
  /** fetch data from the table in a streaming manner: "InvestorMetric" */
  InvestorMetric_stream: Array<InvestorMetric_>;
  /** fetch data from the table: "InvestorToInvesteeMetric" */
  InvestorToInvesteeMetric: Array<InvestorToInvesteeMetric_>;
  /** fetch aggregated fields from the table: "InvestorToInvesteeMetric" */
  InvestorToInvesteeMetric_aggregate: InvestorToInvesteeMetric_Aggregate_;
  /** fetch data from the table: "InvestorToInvesteeMetric" using primary key columns */
  InvestorToInvesteeMetric_by_pk?: Maybe<InvestorToInvesteeMetric_>;
  /** fetch data from the table in a streaming manner: "InvestorToInvesteeMetric" */
  InvestorToInvesteeMetric_stream: Array<InvestorToInvesteeMetric_>;
  /** fetch data from the table: "esrs.MFCategory" */
  MFCategory: Array<MfCategory_>;
  /** fetch aggregated fields from the table: "esrs.MFCategory" */
  MFCategory_aggregate: MfCategory_Aggregate_;
  /** fetch data from the table: "esrs.MFCategory" using primary key columns */
  MFCategory_by_pk?: Maybe<MfCategory_>;
  /** fetch data from the table in a streaming manner: "esrs.MFCategory" */
  MFCategory_stream: Array<MfCategory_>;
  /** fetch data from the table: "esrs.MFDisclosureRequirement" */
  MFDisclosureRequirement: Array<MfDisclosureRequirement_>;
  /** fetch data from the table: "esrs.MFDisclosureRequirementGroup" */
  MFDisclosureRequirementGroup: Array<MfDisclosureRequirementGroup_>;
  /** fetch aggregated fields from the table: "esrs.MFDisclosureRequirementGroup" */
  MFDisclosureRequirementGroup_aggregate: MfDisclosureRequirementGroup_Aggregate_;
  /** fetch data from the table: "esrs.MFDisclosureRequirementGroup" using primary key columns */
  MFDisclosureRequirementGroup_by_pk?: Maybe<MfDisclosureRequirementGroup_>;
  /** fetch data from the table in a streaming manner: "esrs.MFDisclosureRequirementGroup" */
  MFDisclosureRequirementGroup_stream: Array<MfDisclosureRequirementGroup_>;
  /** fetch data from the table: "esrs.MFDisclosureRequirementItem" */
  MFDisclosureRequirementItem: Array<MfDisclosureRequirementItem_>;
  /** fetch aggregated fields from the table: "esrs.MFDisclosureRequirementItem" */
  MFDisclosureRequirementItem_aggregate: MfDisclosureRequirementItem_Aggregate_;
  /** fetch data from the table: "esrs.MFDisclosureRequirementItem" using primary key columns */
  MFDisclosureRequirementItem_by_pk?: Maybe<MfDisclosureRequirementItem_>;
  /** fetch data from the table in a streaming manner: "esrs.MFDisclosureRequirementItem" */
  MFDisclosureRequirementItem_stream: Array<MfDisclosureRequirementItem_>;
  /** fetch aggregated fields from the table: "esrs.MFDisclosureRequirement" */
  MFDisclosureRequirement_aggregate: MfDisclosureRequirement_Aggregate_;
  /** fetch data from the table: "esrs.MFDisclosureRequirement" using primary key columns */
  MFDisclosureRequirement_by_pk?: Maybe<MfDisclosureRequirement_>;
  /** fetch data from the table in a streaming manner: "esrs.MFDisclosureRequirement" */
  MFDisclosureRequirement_stream: Array<MfDisclosureRequirement_>;
  /** fetch data from the table: "esrs.MFStandard" */
  MFStandard: Array<MfStandard_>;
  /** fetch data from the table: "esrs.MFStandardItem" */
  MFStandardItem: Array<MfStandardItem_>;
  /** fetch aggregated fields from the table: "esrs.MFStandardItem" */
  MFStandardItem_aggregate: MfStandardItem_Aggregate_;
  /** fetch data from the table: "esrs.MFStandardItem" using primary key columns */
  MFStandardItem_by_pk?: Maybe<MfStandardItem_>;
  /** fetch data from the table in a streaming manner: "esrs.MFStandardItem" */
  MFStandardItem_stream: Array<MfStandardItem_>;
  /** fetch aggregated fields from the table: "esrs.MFStandard" */
  MFStandard_aggregate: MfStandard_Aggregate_;
  /** fetch data from the table: "esrs.MFStandard" using primary key columns */
  MFStandard_by_pk?: Maybe<MfStandard_>;
  /** fetch data from the table in a streaming manner: "esrs.MFStandard" */
  MFStandard_stream: Array<MfStandard_>;
  /** fetch data from the table: "esrs.MaterialStandardOwner" */
  MaterialStandardOwner: Array<MaterialStandardOwner_>;
  /** fetch aggregated fields from the table: "esrs.MaterialStandardOwner" */
  MaterialStandardOwner_aggregate: MaterialStandardOwner_Aggregate_;
  /** fetch data from the table: "esrs.MaterialStandardOwner" using primary key columns */
  MaterialStandardOwner_by_pk?: Maybe<MaterialStandardOwner_>;
  /** fetch data from the table in a streaming manner: "esrs.MaterialStandardOwner" */
  MaterialStandardOwner_stream: Array<MaterialStandardOwner_>;
  /** fetch data from the table: "esrs.MetricDependency" */
  MetricDependency: Array<MetricDependency_>;
  /** fetch aggregated fields from the table: "esrs.MetricDependency" */
  MetricDependency_aggregate: MetricDependency_Aggregate_;
  /** fetch data from the table: "esrs.MetricDependency" using primary key columns */
  MetricDependency_by_pk?: Maybe<MetricDependency_>;
  /** fetch data from the table in a streaming manner: "esrs.MetricDependency" */
  MetricDependency_stream: Array<MetricDependency_>;
  /** fetch data from the table: "esrs.MetricTag" */
  MetricTag: Array<MetricTag_>;
  /** fetch aggregated fields from the table: "esrs.MetricTag" */
  MetricTag_aggregate: MetricTag_Aggregate_;
  /** fetch data from the table: "esrs.MetricTag" using primary key columns */
  MetricTag_by_pk?: Maybe<MetricTag_>;
  /** fetch data from the table in a streaming manner: "esrs.MetricTag" */
  MetricTag_stream: Array<MetricTag_>;
  /** fetch data from the table: "NonMaterialFinancials" */
  NonMaterialFinancials: Array<NonMaterialFinancials_>;
  /** fetch aggregated fields from the table: "NonMaterialFinancials" */
  NonMaterialFinancials_aggregate: NonMaterialFinancials_Aggregate_;
  /** fetch data from the table in a streaming manner: "NonMaterialFinancials" */
  NonMaterialFinancials_stream: Array<NonMaterialFinancials_>;
  /** fetch data from the table: "Note" */
  Note: Array<Note_>;
  /** fetch data from the table: "NoteHistory" */
  NoteHistory: Array<NoteHistory_>;
  /** fetch aggregated fields from the table: "NoteHistory" */
  NoteHistory_aggregate: NoteHistory_Aggregate_;
  /** fetch data from the table: "NoteHistory" using primary key columns */
  NoteHistory_by_pk?: Maybe<NoteHistory_>;
  /** fetch data from the table in a streaming manner: "NoteHistory" */
  NoteHistory_stream: Array<NoteHistory_>;
  /** fetch aggregated fields from the table: "Note" */
  Note_aggregate: Note_Aggregate_;
  /** fetch data from the table: "Note" using primary key columns */
  Note_by_pk?: Maybe<Note_>;
  /** fetch data from the table in a streaming manner: "Note" */
  Note_stream: Array<Note_>;
  /** fetch data from the table: "Objective" */
  Objective: Array<Objective_>;
  /** fetch aggregated fields from the table: "Objective" */
  Objective_aggregate: Objective_Aggregate_;
  /** fetch data from the table: "Objective" using primary key columns */
  Objective_by_pk?: Maybe<Objective_>;
  /** fetch data from the table in a streaming manner: "Objective" */
  Objective_stream: Array<Objective_>;
  /** fetch data from the table: "PaiAnswers" */
  PaiAnswers: Array<PaiAnswers_>;
  /** fetch aggregated fields from the table: "PaiAnswers" */
  PaiAnswers_aggregate: PaiAnswers_Aggregate_;
  /** fetch data from the table: "PaiAnswers" using primary key columns */
  PaiAnswers_by_pk?: Maybe<PaiAnswers_>;
  /** fetch data from the table in a streaming manner: "PaiAnswers" */
  PaiAnswers_stream: Array<PaiAnswers_>;
  /** fetch data from the table: "PaiCategory" */
  PaiCategory: Array<PaiCategory_>;
  /** fetch aggregated fields from the table: "PaiCategory" */
  PaiCategory_aggregate: PaiCategory_Aggregate_;
  /** fetch data from the table: "PaiCategory" using primary key columns */
  PaiCategory_by_pk?: Maybe<PaiCategory_>;
  /** fetch data from the table in a streaming manner: "PaiCategory" */
  PaiCategory_stream: Array<PaiCategory_>;
  /** fetch data from the table: "PaiCompanyReport" */
  PaiCompanyReport: Array<PaiCompanyReport_>;
  /** fetch aggregated fields from the table: "PaiCompanyReport" */
  PaiCompanyReport_aggregate: PaiCompanyReport_Aggregate_;
  /** fetch data from the table: "PaiCompanyReport" using primary key columns */
  PaiCompanyReport_by_pk?: Maybe<PaiCompanyReport_>;
  /** fetch data from the table in a streaming manner: "PaiCompanyReport" */
  PaiCompanyReport_stream: Array<PaiCompanyReport_>;
  /** fetch data from the table: "PaiMetricInsight" */
  PaiMetricInsight: Array<PaiMetricInsight_>;
  /** fetch aggregated fields from the table: "PaiMetricInsight" */
  PaiMetricInsight_aggregate: PaiMetricInsight_Aggregate_;
  /** fetch data from the table: "PaiMetricInsight" using primary key columns */
  PaiMetricInsight_by_pk?: Maybe<PaiMetricInsight_>;
  /** fetch data from the table in a streaming manner: "PaiMetricInsight" */
  PaiMetricInsight_stream: Array<PaiMetricInsight_>;
  /** fetch data from the table: "PaiPortfolioReport" */
  PaiPortfolioReport: Array<PaiPortfolioReport_>;
  /** fetch aggregated fields from the table: "PaiPortfolioReport" */
  PaiPortfolioReport_aggregate: PaiPortfolioReport_Aggregate_;
  /** fetch data from the table: "PaiPortfolioReport" using primary key columns */
  PaiPortfolioReport_by_pk?: Maybe<PaiPortfolioReport_>;
  /** fetch data from the table in a streaming manner: "PaiPortfolioReport" */
  PaiPortfolioReport_stream: Array<PaiPortfolioReport_>;
  /** fetch data from the table: "PaiReportIndicator" */
  PaiReportIndicator: Array<PaiReportIndicator_>;
  /** fetch data from the table: "PaiReportIndicatorPortfolioCompany" */
  PaiReportIndicatorPortfolioCompany: Array<PaiReportIndicatorPortfolioCompany_>;
  /** fetch aggregated fields from the table: "PaiReportIndicatorPortfolioCompany" */
  PaiReportIndicatorPortfolioCompany_aggregate: PaiReportIndicatorPortfolioCompany_Aggregate_;
  /** fetch data from the table: "PaiReportIndicatorPortfolioCompany" using primary key columns */
  PaiReportIndicatorPortfolioCompany_by_pk?: Maybe<PaiReportIndicatorPortfolioCompany_>;
  /** fetch data from the table in a streaming manner: "PaiReportIndicatorPortfolioCompany" */
  PaiReportIndicatorPortfolioCompany_stream: Array<PaiReportIndicatorPortfolioCompany_>;
  /** fetch aggregated fields from the table: "PaiReportIndicator" */
  PaiReportIndicator_aggregate: PaiReportIndicator_Aggregate_;
  /** fetch data from the table: "PaiReportIndicator" using primary key columns */
  PaiReportIndicator_by_pk?: Maybe<PaiReportIndicator_>;
  /** fetch data from the table in a streaming manner: "PaiReportIndicator" */
  PaiReportIndicator_stream: Array<PaiReportIndicator_>;
  /** fetch data from the table: "PaiTable" */
  PaiTable: Array<PaiTable_>;
  /** fetch data from the table: "PaiTableIndicator" */
  PaiTableIndicator: Array<PaiTableIndicator_>;
  /** fetch aggregated fields from the table: "PaiTableIndicator" */
  PaiTableIndicator_aggregate: PaiTableIndicator_Aggregate_;
  /** fetch data from the table: "PaiTableIndicator" using primary key columns */
  PaiTableIndicator_by_pk?: Maybe<PaiTableIndicator_>;
  /** fetch data from the table in a streaming manner: "PaiTableIndicator" */
  PaiTableIndicator_stream: Array<PaiTableIndicator_>;
  /** fetch aggregated fields from the table: "PaiTable" */
  PaiTable_aggregate: PaiTable_Aggregate_;
  /** fetch data from the table: "PaiTable" using primary key columns */
  PaiTable_by_pk?: Maybe<PaiTable_>;
  /** fetch data from the table in a streaming manner: "PaiTable" */
  PaiTable_stream: Array<PaiTable_>;
  /** fetch data from the table: "Portfolio" */
  Portfolio: Array<Portfolio_>;
  /** fetch data from the table: "PortfolioCompany" */
  PortfolioCompany: Array<PortfolioCompany_>;
  /** fetch aggregated fields from the table: "PortfolioCompany" */
  PortfolioCompany_aggregate: PortfolioCompany_Aggregate_;
  /** fetch data from the table: "PortfolioCompany" using primary key columns */
  PortfolioCompany_by_pk?: Maybe<PortfolioCompany_>;
  /** fetch data from the table in a streaming manner: "PortfolioCompany" */
  PortfolioCompany_stream: Array<PortfolioCompany_>;
  /** fetch data from the table: "PortfolioNonEligibleFinancials" */
  PortfolioNonEligibleFinancials: Array<PortfolioNonEligibleFinancials_>;
  /** fetch aggregated fields from the table: "PortfolioNonEligibleFinancials" */
  PortfolioNonEligibleFinancials_aggregate: PortfolioNonEligibleFinancials_Aggregate_;
  /** fetch data from the table: "PortfolioNonEligibleFinancials" using primary key columns */
  PortfolioNonEligibleFinancials_by_pk?: Maybe<PortfolioNonEligibleFinancials_>;
  /** fetch data from the table in a streaming manner: "PortfolioNonEligibleFinancials" */
  PortfolioNonEligibleFinancials_stream: Array<PortfolioNonEligibleFinancials_>;
  /** fetch aggregated fields from the table: "Portfolio" */
  Portfolio_aggregate: Portfolio_Aggregate_;
  /** fetch data from the table: "Portfolio" using primary key columns */
  Portfolio_by_pk?: Maybe<Portfolio_>;
  /** fetch data from the table in a streaming manner: "Portfolio" */
  Portfolio_stream: Array<Portfolio_>;
  /** fetch data from the table: "QuarterEnum" */
  QuarterEnum: Array<QuarterEnum_>;
  /** fetch aggregated fields from the table: "QuarterEnum" */
  QuarterEnum_aggregate: QuarterEnum_Aggregate_;
  /** fetch data from the table: "QuarterEnum" using primary key columns */
  QuarterEnum_by_pk?: Maybe<QuarterEnum_>;
  /** fetch data from the table in a streaming manner: "QuarterEnum" */
  QuarterEnum_stream: Array<QuarterEnum_>;
  /** fetch data from the table: "Question" */
  Question: Array<Question_>;
  /** fetch data from the table: "QuestionChoice" */
  QuestionChoice: Array<QuestionChoice_>;
  /** fetch aggregated fields from the table: "QuestionChoice" */
  QuestionChoice_aggregate: QuestionChoice_Aggregate_;
  /** fetch data from the table: "QuestionChoice" using primary key columns */
  QuestionChoice_by_pk?: Maybe<QuestionChoice_>;
  /** fetch data from the table in a streaming manner: "QuestionChoice" */
  QuestionChoice_stream: Array<QuestionChoice_>;
  /** fetch data from the table: "QuestionLevel" */
  QuestionLevel: Array<QuestionLevel_>;
  /** fetch aggregated fields from the table: "QuestionLevel" */
  QuestionLevel_aggregate: QuestionLevel_Aggregate_;
  /** fetch data from the table: "QuestionLevel" using primary key columns */
  QuestionLevel_by_pk?: Maybe<QuestionLevel_>;
  /** fetch data from the table in a streaming manner: "QuestionLevel" */
  QuestionLevel_stream: Array<QuestionLevel_>;
  /** fetch data from the table: "QuestionRevision" */
  QuestionRevision: Array<QuestionRevision_>;
  /** fetch aggregated fields from the table: "QuestionRevision" */
  QuestionRevision_aggregate: QuestionRevision_Aggregate_;
  /** fetch data from the table: "QuestionRevision" using primary key columns */
  QuestionRevision_by_pk?: Maybe<QuestionRevision_>;
  /** fetch data from the table in a streaming manner: "QuestionRevision" */
  QuestionRevision_stream: Array<QuestionRevision_>;
  /** fetch data from the table: "QuestionSet" */
  QuestionSet: Array<QuestionSet_>;
  /** fetch data from the table: "QuestionSetQuestion" */
  QuestionSetQuestion: Array<QuestionSetQuestion_>;
  /** fetch aggregated fields from the table: "QuestionSetQuestion" */
  QuestionSetQuestion_aggregate: QuestionSetQuestion_Aggregate_;
  /** fetch data from the table: "QuestionSetQuestion" using primary key columns */
  QuestionSetQuestion_by_pk?: Maybe<QuestionSetQuestion_>;
  /** fetch data from the table in a streaming manner: "QuestionSetQuestion" */
  QuestionSetQuestion_stream: Array<QuestionSetQuestion_>;
  /** fetch aggregated fields from the table: "QuestionSet" */
  QuestionSet_aggregate: QuestionSet_Aggregate_;
  /** fetch data from the table: "QuestionSet" using primary key columns */
  QuestionSet_by_pk?: Maybe<QuestionSet_>;
  /** fetch data from the table in a streaming manner: "QuestionSet" */
  QuestionSet_stream: Array<QuestionSet_>;
  /** fetch data from the table: "QuestionType" */
  QuestionType: Array<QuestionType_>;
  /** fetch aggregated fields from the table: "QuestionType" */
  QuestionType_aggregate: QuestionType_Aggregate_;
  /** fetch data from the table: "QuestionType" using primary key columns */
  QuestionType_by_pk?: Maybe<QuestionType_>;
  /** fetch data from the table in a streaming manner: "QuestionType" */
  QuestionType_stream: Array<QuestionType_>;
  /** fetch aggregated fields from the table: "Question" */
  Question_aggregate: Question_Aggregate_;
  /** fetch data from the table: "Question" using primary key columns */
  Question_by_pk?: Maybe<Question_>;
  /** fetch data from the table in a streaming manner: "Question" */
  Question_stream: Array<Question_>;
  /** fetch data from the table: "ReportingGroup" */
  ReportingGroup: Array<ReportingGroup_>;
  /** fetch aggregated fields from the table: "ReportingGroup" */
  ReportingGroup_aggregate: ReportingGroup_Aggregate_;
  /** fetch data from the table: "ReportingGroup" using primary key columns */
  ReportingGroup_by_pk?: Maybe<ReportingGroup_>;
  /** fetch data from the table in a streaming manner: "ReportingGroup" */
  ReportingGroup_stream: Array<ReportingGroup_>;
  /** fetch data from the table: "Sector" */
  Sector: Array<Sector_>;
  /** fetch aggregated fields from the table: "Sector" */
  Sector_aggregate: Sector_Aggregate_;
  /** fetch data from the table: "Sector" using primary key columns */
  Sector_by_pk?: Maybe<Sector_>;
  /** fetch data from the table in a streaming manner: "Sector" */
  Sector_stream: Array<Sector_>;
  /** fetch data from the table: "SharedSpace" */
  SharedSpace: Array<SharedSpace_>;
  /** fetch aggregated fields from the table: "SharedSpace" */
  SharedSpace_aggregate: SharedSpace_Aggregate_;
  /** fetch data from the table: "SharedSpace" using primary key columns */
  SharedSpace_by_pk?: Maybe<SharedSpace_>;
  /** fetch data from the table in a streaming manner: "SharedSpace" */
  SharedSpace_stream: Array<SharedSpace_>;
  /** fetch data from the table: "Space" */
  Space: Array<Space_>;
  /** fetch aggregated fields from the table: "Space" */
  Space_aggregate: Space_Aggregate_;
  /** fetch data from the table: "Space" using primary key columns */
  Space_by_pk?: Maybe<Space_>;
  /** fetch data from the table in a streaming manner: "Space" */
  Space_stream: Array<Space_>;
  /** fetch data from the table: "Subsidiary" */
  Subsidiary: Array<Subsidiary_>;
  /** fetch aggregated fields from the table: "Subsidiary" */
  Subsidiary_aggregate: Subsidiary_Aggregate_;
  /** fetch data from the table: "Subsidiary" using primary key columns */
  Subsidiary_by_pk?: Maybe<Subsidiary_>;
  /** fetch data from the table in a streaming manner: "Subsidiary" */
  Subsidiary_stream: Array<Subsidiary_>;
  /** fetch data from the table: "Tag" */
  Tag: Array<Tag_>;
  /** fetch data from the table: "TagGroup" */
  TagGroup: Array<TagGroup_>;
  /** fetch aggregated fields from the table: "TagGroup" */
  TagGroup_aggregate: TagGroup_Aggregate_;
  /** fetch data from the table: "TagGroup" using primary key columns */
  TagGroup_by_pk?: Maybe<TagGroup_>;
  /** fetch data from the table in a streaming manner: "TagGroup" */
  TagGroup_stream: Array<TagGroup_>;
  /** fetch data from the table: "esrs.TagType" */
  TagType: Array<TagType_>;
  /** fetch aggregated fields from the table: "esrs.TagType" */
  TagType_aggregate: TagType_Aggregate_;
  /** fetch data from the table: "esrs.TagType" using primary key columns */
  TagType_by_pk?: Maybe<TagType_>;
  /** fetch data from the table in a streaming manner: "esrs.TagType" */
  TagType_stream: Array<TagType_>;
  /** fetch data from the table: "esrs.TagValue" */
  TagValue: Array<TagValue_>;
  /** fetch aggregated fields from the table: "esrs.TagValue" */
  TagValue_aggregate: TagValue_Aggregate_;
  /** fetch data from the table: "esrs.TagValue" using primary key columns */
  TagValue_by_pk?: Maybe<TagValue_>;
  /** fetch data from the table in a streaming manner: "esrs.TagValue" */
  TagValue_stream: Array<TagValue_>;
  /** fetch aggregated fields from the table: "Tag" */
  Tag_aggregate: Tag_Aggregate_;
  /** An array relationship */
  Tag_articles: Array<Tag_Articles_>;
  /** An aggregate relationship */
  Tag_articles_aggregate: Tag_Articles_Aggregate_;
  /** fetch data from the table: "Tag_articles" using primary key columns */
  Tag_articles_by_pk?: Maybe<Tag_Articles_>;
  /** fetch data from the table in a streaming manner: "Tag_articles" */
  Tag_articles_stream: Array<Tag_Articles_>;
  /** fetch data from the table: "Tag" using primary key columns */
  Tag_by_pk?: Maybe<Tag_>;
  /** fetch data from the table in a streaming manner: "Tag" */
  Tag_stream: Array<Tag_>;
  /** fetch data from the table: "esrs.TargetQuestion" */
  TargetQuestion: Array<TargetQuestion_>;
  /** fetch data from the table: "esrs.TargetQuestionGroup" */
  TargetQuestionGroup: Array<TargetQuestionGroup_>;
  /** fetch aggregated fields from the table: "esrs.TargetQuestionGroup" */
  TargetQuestionGroup_aggregate: TargetQuestionGroup_Aggregate_;
  /** fetch data from the table: "esrs.TargetQuestionGroup" using primary key columns */
  TargetQuestionGroup_by_pk?: Maybe<TargetQuestionGroup_>;
  /** fetch data from the table in a streaming manner: "esrs.TargetQuestionGroup" */
  TargetQuestionGroup_stream: Array<TargetQuestionGroup_>;
  /** fetch aggregated fields from the table: "esrs.TargetQuestion" */
  TargetQuestion_aggregate: TargetQuestion_Aggregate_;
  /** fetch data from the table: "esrs.TargetQuestion" using primary key columns */
  TargetQuestion_by_pk?: Maybe<TargetQuestion_>;
  /** fetch data from the table in a streaming manner: "esrs.TargetQuestion" */
  TargetQuestion_stream: Array<TargetQuestion_>;
  /** fetch data from the table: "Task" */
  Task: Array<Task_>;
  /** fetch data from the table: "TaskStatusEnum" */
  TaskStatusEnum: Array<TaskStatusEnum_>;
  /** fetch aggregated fields from the table: "TaskStatusEnum" */
  TaskStatusEnum_aggregate: TaskStatusEnum_Aggregate_;
  /** fetch data from the table: "TaskStatusEnum" using primary key columns */
  TaskStatusEnum_by_pk?: Maybe<TaskStatusEnum_>;
  /** fetch data from the table in a streaming manner: "TaskStatusEnum" */
  TaskStatusEnum_stream: Array<TaskStatusEnum_>;
  /** fetch aggregated fields from the table: "Task" */
  Task_aggregate: Task_Aggregate_;
  /** fetch data from the table: "Task" using primary key columns */
  Task_by_pk?: Maybe<Task_>;
  /** fetch data from the table in a streaming manner: "Task" */
  Task_stream: Array<Task_>;
  /** fetch data from the table: "TaxonomyPortfolioReport" */
  TaxonomyPortfolioReport: Array<TaxonomyPortfolioReport_>;
  /** fetch aggregated fields from the table: "TaxonomyPortfolioReport" */
  TaxonomyPortfolioReport_aggregate: TaxonomyPortfolioReport_Aggregate_;
  /** fetch data from the table: "TaxonomyPortfolioReport" using primary key columns */
  TaxonomyPortfolioReport_by_pk?: Maybe<TaxonomyPortfolioReport_>;
  /** fetch data from the table in a streaming manner: "TaxonomyPortfolioReport" */
  TaxonomyPortfolioReport_stream: Array<TaxonomyPortfolioReport_>;
  /** fetch data from the table: "Thread" */
  Thread: Array<Thread_>;
  /** fetch data from the table: "ThreadSubscriber" */
  ThreadSubscriber: Array<ThreadSubscriber_>;
  /** fetch aggregated fields from the table: "ThreadSubscriber" */
  ThreadSubscriber_aggregate: ThreadSubscriber_Aggregate_;
  /** fetch data from the table: "ThreadSubscriber" using primary key columns */
  ThreadSubscriber_by_pk?: Maybe<ThreadSubscriber_>;
  /** fetch data from the table in a streaming manner: "ThreadSubscriber" */
  ThreadSubscriber_stream: Array<ThreadSubscriber_>;
  /** fetch aggregated fields from the table: "Thread" */
  Thread_aggregate: Thread_Aggregate_;
  /** fetch data from the table: "Thread" using primary key columns */
  Thread_by_pk?: Maybe<Thread_>;
  /** fetch data from the table in a streaming manner: "Thread" */
  Thread_stream: Array<Thread_>;
  /** fetch data from the table: "TotalComparisonFinancials" */
  TotalComparisonFinancials: Array<TotalComparisonFinancials_>;
  /** fetch aggregated fields from the table: "TotalComparisonFinancials" */
  TotalComparisonFinancials_aggregate: TotalComparisonFinancials_Aggregate_;
  /** fetch data from the table in a streaming manner: "TotalComparisonFinancials" */
  TotalComparisonFinancials_stream: Array<TotalComparisonFinancials_>;
  /** fetch data from the table: "TriggerTypes" */
  TriggerTypes: Array<TriggerTypes_>;
  /** fetch aggregated fields from the table: "TriggerTypes" */
  TriggerTypes_aggregate: TriggerTypes_Aggregate_;
  /** fetch data from the table: "TriggerTypes" using primary key columns */
  TriggerTypes_by_pk?: Maybe<TriggerTypes_>;
  /** fetch data from the table in a streaming manner: "TriggerTypes" */
  TriggerTypes_stream: Array<TriggerTypes_>;
  /** fetch data from the table: "UserNotification" */
  UserNotification: Array<UserNotification_>;
  /** fetch aggregated fields from the table: "UserNotification" */
  UserNotification_aggregate: UserNotification_Aggregate_;
  /** fetch data from the table: "UserNotification" using primary key columns */
  UserNotification_by_pk?: Maybe<UserNotification_>;
  /** fetch data from the table in a streaming manner: "UserNotification" */
  UserNotification_stream: Array<UserNotification_>;
  /** fetch data from the table: "UserRole" */
  UserRole: Array<UserRole_>;
  /** fetch aggregated fields from the table: "UserRole" */
  UserRole_aggregate: UserRole_Aggregate_;
  /** fetch data from the table: "UserRole" using primary key columns */
  UserRole_by_pk?: Maybe<UserRole_>;
  /** fetch data from the table in a streaming manner: "UserRole" */
  UserRole_stream: Array<UserRole_>;
  /** fetch data from the table: "UserSessionMetadata" */
  UserSessionMetadata: Array<UserSessionMetadata_>;
  /** fetch aggregated fields from the table: "UserSessionMetadata" */
  UserSessionMetadata_aggregate: UserSessionMetadata_Aggregate_;
  /** fetch data from the table: "UserSessionMetadata" using primary key columns */
  UserSessionMetadata_by_pk?: Maybe<UserSessionMetadata_>;
  /** fetch data from the table in a streaming manner: "UserSessionMetadata" */
  UserSessionMetadata_stream: Array<UserSessionMetadata_>;
  /** fetch data from the table: "WebsocketTest" */
  WebsocketTest: Array<WebsocketTest_>;
  /** fetch aggregated fields from the table: "WebsocketTest" */
  WebsocketTest_aggregate: WebsocketTest_Aggregate_;
  /** fetch data from the table: "WebsocketTest" using primary key columns */
  WebsocketTest_by_pk?: Maybe<WebsocketTest_>;
  /** fetch data from the table in a streaming manner: "WebsocketTest" */
  WebsocketTest_stream: Array<WebsocketTest_>;
  /** fetch data from the table: "auth.providers" using primary key columns */
  authProvider?: Maybe<AuthProviders_>;
  /** fetch data from the table: "auth.provider_requests" using primary key columns */
  authProviderRequest?: Maybe<AuthProviderRequests_>;
  /** fetch data from the table: "auth.provider_requests" */
  authProviderRequests: Array<AuthProviderRequests_>;
  /** fetch aggregated fields from the table: "auth.provider_requests" */
  authProviderRequestsAggregate: AuthProviderRequests_Aggregate_;
  /** fetch data from the table in a streaming manner: "auth.provider_requests" */
  authProviderRequests_stream: Array<AuthProviderRequests_>;
  /** fetch data from the table: "auth.providers" */
  authProviders: Array<AuthProviders_>;
  /** fetch aggregated fields from the table: "auth.providers" */
  authProvidersAggregate: AuthProviders_Aggregate_;
  /** fetch data from the table in a streaming manner: "auth.providers" */
  authProviders_stream: Array<AuthProviders_>;
  /** fetch data from the table: "auth.refresh_tokens" using primary key columns */
  authRefreshToken?: Maybe<AuthRefreshTokens_>;
  /** fetch data from the table: "auth.refresh_token_types" using primary key columns */
  authRefreshTokenType?: Maybe<AuthRefreshTokenTypes_>;
  /** fetch data from the table: "auth.refresh_token_types" */
  authRefreshTokenTypes: Array<AuthRefreshTokenTypes_>;
  /** fetch aggregated fields from the table: "auth.refresh_token_types" */
  authRefreshTokenTypesAggregate: AuthRefreshTokenTypes_Aggregate_;
  /** fetch data from the table in a streaming manner: "auth.refresh_token_types" */
  authRefreshTokenTypes_stream: Array<AuthRefreshTokenTypes_>;
  /** fetch data from the table: "auth.refresh_tokens" */
  authRefreshTokens: Array<AuthRefreshTokens_>;
  /** fetch aggregated fields from the table: "auth.refresh_tokens" */
  authRefreshTokensAggregate: AuthRefreshTokens_Aggregate_;
  /** fetch data from the table in a streaming manner: "auth.refresh_tokens" */
  authRefreshTokens_stream: Array<AuthRefreshTokens_>;
  /** fetch data from the table: "auth.roles" using primary key columns */
  authRole?: Maybe<AuthRoles_>;
  /** fetch data from the table: "auth.roles" */
  authRoles: Array<AuthRoles_>;
  /** fetch aggregated fields from the table: "auth.roles" */
  authRolesAggregate: AuthRoles_Aggregate_;
  /** fetch data from the table in a streaming manner: "auth.roles" */
  authRoles_stream: Array<AuthRoles_>;
  /** fetch data from the table: "auth.user_providers" using primary key columns */
  authUserProvider?: Maybe<AuthUserProviders_>;
  /** fetch data from the table: "auth.user_providers" */
  authUserProviders: Array<AuthUserProviders_>;
  /** fetch aggregated fields from the table: "auth.user_providers" */
  authUserProvidersAggregate: AuthUserProviders_Aggregate_;
  /** fetch data from the table in a streaming manner: "auth.user_providers" */
  authUserProviders_stream: Array<AuthUserProviders_>;
  /** fetch data from the table: "auth.user_roles" using primary key columns */
  authUserRole?: Maybe<AuthUserRoles_>;
  /** fetch data from the table: "auth.user_roles" */
  authUserRoles: Array<AuthUserRoles_>;
  /** fetch aggregated fields from the table: "auth.user_roles" */
  authUserRolesAggregate: AuthUserRoles_Aggregate_;
  /** fetch data from the table in a streaming manner: "auth.user_roles" */
  authUserRoles_stream: Array<AuthUserRoles_>;
  /** fetch data from the table: "auth.user_security_keys" using primary key columns */
  authUserSecurityKey?: Maybe<AuthUserSecurityKeys_>;
  /** fetch data from the table: "auth.user_security_keys" */
  authUserSecurityKeys: Array<AuthUserSecurityKeys_>;
  /** fetch aggregated fields from the table: "auth.user_security_keys" */
  authUserSecurityKeysAggregate: AuthUserSecurityKeys_Aggregate_;
  /** fetch data from the table in a streaming manner: "auth.user_security_keys" */
  authUserSecurityKeys_stream: Array<AuthUserSecurityKeys_>;
  /** fetch data from the table: "storage.buckets" using primary key columns */
  bucket?: Maybe<Buckets_>;
  /** fetch data from the table: "storage.buckets" */
  buckets: Array<Buckets_>;
  /** fetch aggregated fields from the table: "storage.buckets" */
  bucketsAggregate: Buckets_Aggregate_;
  /** fetch data from the table in a streaming manner: "storage.buckets" */
  buckets_stream: Array<Buckets_>;
  /** fetch data from the table: "esrs.ActionReportingUnit" */
  esrs_ActionReportingUnit: Array<Esrs_ActionReportingUnit_>;
  /** fetch aggregated fields from the table: "esrs.ActionReportingUnit" */
  esrs_ActionReportingUnit_aggregate: Esrs_ActionReportingUnit_Aggregate_;
  /** fetch data from the table: "esrs.ActionReportingUnit" using primary key columns */
  esrs_ActionReportingUnit_by_pk?: Maybe<Esrs_ActionReportingUnit_>;
  /** fetch data from the table in a streaming manner: "esrs.ActionReportingUnit" */
  esrs_ActionReportingUnit_stream: Array<Esrs_ActionReportingUnit_>;
  /** fetch data from the table: "esrs.ActionSubsidiary" */
  esrs_ActionSubsidiary: Array<Esrs_ActionSubsidiary_>;
  /** fetch aggregated fields from the table: "esrs.ActionSubsidiary" */
  esrs_ActionSubsidiary_aggregate: Esrs_ActionSubsidiary_Aggregate_;
  /** fetch data from the table: "esrs.ActionSubsidiary" using primary key columns */
  esrs_ActionSubsidiary_by_pk?: Maybe<Esrs_ActionSubsidiary_>;
  /** fetch data from the table in a streaming manner: "esrs.ActionSubsidiary" */
  esrs_ActionSubsidiary_stream: Array<Esrs_ActionSubsidiary_>;
  /** fetch data from the table: "esrs.ActionTarget" */
  esrs_ActionTarget: Array<Esrs_ActionTarget_>;
  /** fetch aggregated fields from the table: "esrs.ActionTarget" */
  esrs_ActionTarget_aggregate: Esrs_ActionTarget_Aggregate_;
  /** fetch data from the table: "esrs.ActionTarget" using primary key columns */
  esrs_ActionTarget_by_pk?: Maybe<Esrs_ActionTarget_>;
  /** fetch data from the table in a streaming manner: "esrs.ActionTarget" */
  esrs_ActionTarget_stream: Array<Esrs_ActionTarget_>;
  /** fetch data from the table: "esrs.Actions" */
  esrs_Actions: Array<Esrs_Actions_>;
  /** fetch aggregated fields from the table: "esrs.Actions" */
  esrs_Actions_aggregate: Esrs_Actions_Aggregate_;
  /** fetch data from the table: "esrs.Actions" using primary key columns */
  esrs_Actions_by_pk?: Maybe<Esrs_Actions_>;
  /** fetch data from the table in a streaming manner: "esrs.Actions" */
  esrs_Actions_stream: Array<Esrs_Actions_>;
  /** fetch data from the table: "esrs.Answer" */
  esrs_Answer: Array<Esrs_Answer_>;
  /** fetch aggregated fields from the table: "esrs.Answer" */
  esrs_Answer_aggregate: Esrs_Answer_Aggregate_;
  /** fetch data from the table: "esrs.Answer" using primary key columns */
  esrs_Answer_by_pk?: Maybe<Esrs_Answer_>;
  /** fetch data from the table in a streaming manner: "esrs.Answer" */
  esrs_Answer_stream: Array<Esrs_Answer_>;
  /** fetch data from the table: "esrs.AssessmentCurrencyConversion" */
  esrs_AssessmentCurrencyConversion: Array<Esrs_AssessmentCurrencyConversion_>;
  /** fetch aggregated fields from the table: "esrs.AssessmentCurrencyConversion" */
  esrs_AssessmentCurrencyConversion_aggregate: Esrs_AssessmentCurrencyConversion_Aggregate_;
  /** fetch data from the table: "esrs.AssessmentCurrencyConversion" using primary key columns */
  esrs_AssessmentCurrencyConversion_by_pk?: Maybe<Esrs_AssessmentCurrencyConversion_>;
  /** fetch data from the table in a streaming manner: "esrs.AssessmentCurrencyConversion" */
  esrs_AssessmentCurrencyConversion_stream: Array<Esrs_AssessmentCurrencyConversion_>;
  /** fetch data from the table: "esrs.Baseline" */
  esrs_Baseline: Array<Esrs_Baseline_>;
  /** fetch aggregated fields from the table: "esrs.Baseline" */
  esrs_Baseline_aggregate: Esrs_Baseline_Aggregate_;
  /** fetch data from the table: "esrs.Baseline" using primary key columns */
  esrs_Baseline_by_pk?: Maybe<Esrs_Baseline_>;
  /** fetch data from the table in a streaming manner: "esrs.Baseline" */
  esrs_Baseline_stream: Array<Esrs_Baseline_>;
  /** fetch data from the table: "esrs.CompanyIntegration" */
  esrs_CompanyIntegration: Array<Esrs_CompanyIntegration_>;
  /** fetch aggregated fields from the table: "esrs.CompanyIntegration" */
  esrs_CompanyIntegration_aggregate: Esrs_CompanyIntegration_Aggregate_;
  /** fetch data from the table: "esrs.CompanyIntegration" using primary key columns */
  esrs_CompanyIntegration_by_pk?: Maybe<Esrs_CompanyIntegration_>;
  /** fetch data from the table in a streaming manner: "esrs.CompanyIntegration" */
  esrs_CompanyIntegration_stream: Array<Esrs_CompanyIntegration_>;
  /** fetch data from the table: "esrs.Datapoint" */
  esrs_Datapoint: Array<Esrs_Datapoint_>;
  /** fetch data from the table: "esrs.DatapointChoice" */
  esrs_DatapointChoice: Array<Esrs_DatapointChoice_>;
  /** fetch aggregated fields from the table: "esrs.DatapointChoice" */
  esrs_DatapointChoice_aggregate: Esrs_DatapointChoice_Aggregate_;
  /** fetch data from the table: "esrs.DatapointChoice" using primary key columns */
  esrs_DatapointChoice_by_pk?: Maybe<Esrs_DatapointChoice_>;
  /** fetch data from the table in a streaming manner: "esrs.DatapointChoice" */
  esrs_DatapointChoice_stream: Array<Esrs_DatapointChoice_>;
  /** fetch data from the table: "esrs.DatapointMdrm" */
  esrs_DatapointMdrm: Array<Esrs_DatapointMdrm_>;
  /** fetch aggregated fields from the table: "esrs.DatapointMdrm" */
  esrs_DatapointMdrm_aggregate: Esrs_DatapointMdrm_Aggregate_;
  /** fetch data from the table: "esrs.DatapointMdrm" using primary key columns */
  esrs_DatapointMdrm_by_pk?: Maybe<Esrs_DatapointMdrm_>;
  /** fetch data from the table in a streaming manner: "esrs.DatapointMdrm" */
  esrs_DatapointMdrm_stream: Array<Esrs_DatapointMdrm_>;
  /** fetch data from the table: "esrs.DatapointTag" */
  esrs_DatapointTag: Array<Esrs_DatapointTag_>;
  /** fetch aggregated fields from the table: "esrs.DatapointTag" */
  esrs_DatapointTag_aggregate: Esrs_DatapointTag_Aggregate_;
  /** fetch data from the table: "esrs.DatapointTag" using primary key columns */
  esrs_DatapointTag_by_pk?: Maybe<Esrs_DatapointTag_>;
  /** fetch data from the table in a streaming manner: "esrs.DatapointTag" */
  esrs_DatapointTag_stream: Array<Esrs_DatapointTag_>;
  /** fetch aggregated fields from the table: "esrs.Datapoint" */
  esrs_Datapoint_aggregate: Esrs_Datapoint_Aggregate_;
  /** fetch data from the table: "esrs.Datapoint" using primary key columns */
  esrs_Datapoint_by_pk?: Maybe<Esrs_Datapoint_>;
  /** fetch data from the table in a streaming manner: "esrs.Datapoint" */
  esrs_Datapoint_stream: Array<Esrs_Datapoint_>;
  /** fetch data from the table: "esrs.Deprecated_ActionBusinessUnit" */
  esrs_Deprecated_ActionBusinessUnit: Array<Esrs_Deprecated_ActionBusinessUnit_>;
  /** fetch aggregated fields from the table: "esrs.Deprecated_ActionBusinessUnit" */
  esrs_Deprecated_ActionBusinessUnit_aggregate: Esrs_Deprecated_ActionBusinessUnit_Aggregate_;
  /** fetch data from the table: "esrs.Deprecated_ActionBusinessUnit" using primary key columns */
  esrs_Deprecated_ActionBusinessUnit_by_pk?: Maybe<Esrs_Deprecated_ActionBusinessUnit_>;
  /** fetch data from the table in a streaming manner: "esrs.Deprecated_ActionBusinessUnit" */
  esrs_Deprecated_ActionBusinessUnit_stream: Array<Esrs_Deprecated_ActionBusinessUnit_>;
  /** fetch data from the table: "esrs.Deprecated_BusinessUnitEsrsAssessment" */
  esrs_Deprecated_BusinessUnitEsrsAssessment: Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_>;
  /** fetch aggregated fields from the table: "esrs.Deprecated_BusinessUnitEsrsAssessment" */
  esrs_Deprecated_BusinessUnitEsrsAssessment_aggregate: Esrs_Deprecated_BusinessUnitEsrsAssessment_Aggregate_;
  /** fetch data from the table: "esrs.Deprecated_BusinessUnitEsrsAssessment" using primary key columns */
  esrs_Deprecated_BusinessUnitEsrsAssessment_by_pk?: Maybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_>;
  /** fetch data from the table in a streaming manner: "esrs.Deprecated_BusinessUnitEsrsAssessment" */
  esrs_Deprecated_BusinessUnitEsrsAssessment_stream: Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_>;
  /** fetch data from the table: "esrs.Deprecated_CompanyMaterialityAssessment" */
  esrs_Deprecated_CompanyMaterialityAssessment: Array<Esrs_Deprecated_CompanyMaterialityAssessment_>;
  /** fetch aggregated fields from the table: "esrs.Deprecated_CompanyMaterialityAssessment" */
  esrs_Deprecated_CompanyMaterialityAssessment_aggregate: Esrs_Deprecated_CompanyMaterialityAssessment_Aggregate_;
  /** fetch data from the table: "esrs.Deprecated_CompanyMaterialityAssessment" using primary key columns */
  esrs_Deprecated_CompanyMaterialityAssessment_by_pk?: Maybe<Esrs_Deprecated_CompanyMaterialityAssessment_>;
  /** fetch data from the table in a streaming manner: "esrs.Deprecated_CompanyMaterialityAssessment" */
  esrs_Deprecated_CompanyMaterialityAssessment_stream: Array<Esrs_Deprecated_CompanyMaterialityAssessment_>;
  /** fetch data from the table: "esrs.Deprecated_EsrsMDRM" */
  esrs_Deprecated_EsrsMDRM: Array<Esrs_Deprecated_EsrsMdrm_>;
  /** fetch aggregated fields from the table: "esrs.Deprecated_EsrsMDRM" */
  esrs_Deprecated_EsrsMDRM_aggregate: Esrs_Deprecated_EsrsMdrm_Aggregate_;
  /** fetch data from the table: "esrs.Deprecated_EsrsMDRM" using primary key columns */
  esrs_Deprecated_EsrsMDRM_by_pk?: Maybe<Esrs_Deprecated_EsrsMdrm_>;
  /** fetch data from the table in a streaming manner: "esrs.Deprecated_EsrsMDRM" */
  esrs_Deprecated_EsrsMDRM_stream: Array<Esrs_Deprecated_EsrsMdrm_>;
  /** fetch data from the table: "esrs.Deprecated_MaterialDisclosureRequirement" */
  esrs_Deprecated_MaterialDisclosureRequirement: Array<Esrs_Deprecated_MaterialDisclosureRequirement_>;
  /** fetch aggregated fields from the table: "esrs.Deprecated_MaterialDisclosureRequirement" */
  esrs_Deprecated_MaterialDisclosureRequirement_aggregate: Esrs_Deprecated_MaterialDisclosureRequirement_Aggregate_;
  /** fetch data from the table: "esrs.Deprecated_MaterialDisclosureRequirement" using primary key columns */
  esrs_Deprecated_MaterialDisclosureRequirement_by_pk?: Maybe<Esrs_Deprecated_MaterialDisclosureRequirement_>;
  /** fetch data from the table in a streaming manner: "esrs.Deprecated_MaterialDisclosureRequirement" */
  esrs_Deprecated_MaterialDisclosureRequirement_stream: Array<Esrs_Deprecated_MaterialDisclosureRequirement_>;
  /** fetch data from the table: "esrs.Deprecated_MetricAnswer" */
  esrs_Deprecated_MetricAnswer: Array<Esrs_Deprecated_MetricAnswer_>;
  /** fetch aggregated fields from the table: "esrs.Deprecated_MetricAnswer" */
  esrs_Deprecated_MetricAnswer_aggregate: Esrs_Deprecated_MetricAnswer_Aggregate_;
  /** fetch data from the table: "esrs.Deprecated_MetricAnswer" using primary key columns */
  esrs_Deprecated_MetricAnswer_by_pk?: Maybe<Esrs_Deprecated_MetricAnswer_>;
  /** fetch data from the table in a streaming manner: "esrs.Deprecated_MetricAnswer" */
  esrs_Deprecated_MetricAnswer_stream: Array<Esrs_Deprecated_MetricAnswer_>;
  /** fetch data from the table: "esrs.DisclosureRequirementAttachment" */
  esrs_DisclosureRequirementAttachment: Array<Esrs_DisclosureRequirementAttachment_>;
  /** fetch aggregated fields from the table: "esrs.DisclosureRequirementAttachment" */
  esrs_DisclosureRequirementAttachment_aggregate: Esrs_DisclosureRequirementAttachment_Aggregate_;
  /** fetch data from the table: "esrs.DisclosureRequirementAttachment" using primary key columns */
  esrs_DisclosureRequirementAttachment_by_pk?: Maybe<Esrs_DisclosureRequirementAttachment_>;
  /** fetch data from the table in a streaming manner: "esrs.DisclosureRequirementAttachment" */
  esrs_DisclosureRequirementAttachment_stream: Array<Esrs_DisclosureRequirementAttachment_>;
  /** fetch data from the table: "esrs.EsrsAssessmentCompanyIntegration" */
  esrs_EsrsAssessmentCompanyIntegration: Array<Esrs_EsrsAssessmentCompanyIntegration_>;
  /** fetch data from the table: "esrs.EsrsAssessmentCompanyIntegrationRU" */
  esrs_EsrsAssessmentCompanyIntegrationRU: Array<Esrs_EsrsAssessmentCompanyIntegrationRu_>;
  /** fetch aggregated fields from the table: "esrs.EsrsAssessmentCompanyIntegrationRU" */
  esrs_EsrsAssessmentCompanyIntegrationRU_aggregate: Esrs_EsrsAssessmentCompanyIntegrationRu_Aggregate_;
  /** fetch data from the table: "esrs.EsrsAssessmentCompanyIntegrationRU" using primary key columns */
  esrs_EsrsAssessmentCompanyIntegrationRU_by_pk?: Maybe<Esrs_EsrsAssessmentCompanyIntegrationRu_>;
  /** fetch data from the table in a streaming manner: "esrs.EsrsAssessmentCompanyIntegrationRU" */
  esrs_EsrsAssessmentCompanyIntegrationRU_stream: Array<Esrs_EsrsAssessmentCompanyIntegrationRu_>;
  /** fetch aggregated fields from the table: "esrs.EsrsAssessmentCompanyIntegration" */
  esrs_EsrsAssessmentCompanyIntegration_aggregate: Esrs_EsrsAssessmentCompanyIntegration_Aggregate_;
  /** fetch data from the table: "esrs.EsrsAssessmentCompanyIntegration" using primary key columns */
  esrs_EsrsAssessmentCompanyIntegration_by_pk?: Maybe<Esrs_EsrsAssessmentCompanyIntegration_>;
  /** fetch data from the table in a streaming manner: "esrs.EsrsAssessmentCompanyIntegration" */
  esrs_EsrsAssessmentCompanyIntegration_stream: Array<Esrs_EsrsAssessmentCompanyIntegration_>;
  /** fetch data from the table: "esrs.EsrsMetricHierarchyStatus" */
  esrs_EsrsMetricHierarchyStatus: Array<Esrs_EsrsMetricHierarchyStatus_>;
  /** fetch aggregated fields from the table: "esrs.EsrsMetricHierarchyStatus" */
  esrs_EsrsMetricHierarchyStatus_aggregate: Esrs_EsrsMetricHierarchyStatus_Aggregate_;
  /** fetch data from the table in a streaming manner: "esrs.EsrsMetricHierarchyStatus" */
  esrs_EsrsMetricHierarchyStatus_stream: Array<Esrs_EsrsMetricHierarchyStatus_>;
  /** fetch data from the table: "esrs.MaterialMetric" */
  esrs_MaterialMetric: Array<Esrs_MaterialMetric_>;
  /** fetch data from the table: "esrs.MaterialMetricTag" */
  esrs_MaterialMetricTag: Array<Esrs_MaterialMetricTag_>;
  /** fetch aggregated fields from the table: "esrs.MaterialMetricTag" */
  esrs_MaterialMetricTag_aggregate: Esrs_MaterialMetricTag_Aggregate_;
  /** fetch data from the table: "esrs.MaterialMetricTag" using primary key columns */
  esrs_MaterialMetricTag_by_pk?: Maybe<Esrs_MaterialMetricTag_>;
  /** fetch data from the table in a streaming manner: "esrs.MaterialMetricTag" */
  esrs_MaterialMetricTag_stream: Array<Esrs_MaterialMetricTag_>;
  /** fetch aggregated fields from the table: "esrs.MaterialMetric" */
  esrs_MaterialMetric_aggregate: Esrs_MaterialMetric_Aggregate_;
  /** fetch data from the table: "esrs.MaterialMetric" using primary key columns */
  esrs_MaterialMetric_by_pk?: Maybe<Esrs_MaterialMetric_>;
  /** fetch data from the table in a streaming manner: "esrs.MaterialMetric" */
  esrs_MaterialMetric_stream: Array<Esrs_MaterialMetric_>;
  /** fetch data from the table: "esrs.MaterialStandard" */
  esrs_MaterialStandard: Array<Esrs_MaterialStandard_>;
  /** fetch aggregated fields from the table: "esrs.MaterialStandard" */
  esrs_MaterialStandard_aggregate: Esrs_MaterialStandard_Aggregate_;
  /** fetch data from the table: "esrs.MaterialStandard" using primary key columns */
  esrs_MaterialStandard_by_pk?: Maybe<Esrs_MaterialStandard_>;
  /** fetch data from the table in a streaming manner: "esrs.MaterialStandard" */
  esrs_MaterialStandard_stream: Array<Esrs_MaterialStandard_>;
  /** fetch data from the table: "esrs.MaterialTagValue" */
  esrs_MaterialTagValue: Array<Esrs_MaterialTagValue_>;
  /** fetch aggregated fields from the table: "esrs.MaterialTagValue" */
  esrs_MaterialTagValue_aggregate: Esrs_MaterialTagValue_Aggregate_;
  /** fetch data from the table: "esrs.MaterialTagValue" using primary key columns */
  esrs_MaterialTagValue_by_pk?: Maybe<Esrs_MaterialTagValue_>;
  /** fetch data from the table in a streaming manner: "esrs.MaterialTagValue" */
  esrs_MaterialTagValue_stream: Array<Esrs_MaterialTagValue_>;
  /** fetch data from the table: "esrs.MetricDependencyClosure" */
  esrs_MetricDependencyClosure: Array<Esrs_MetricDependencyClosure_>;
  /** fetch aggregated fields from the table: "esrs.MetricDependencyClosure" */
  esrs_MetricDependencyClosure_aggregate: Esrs_MetricDependencyClosure_Aggregate_;
  /** fetch data from the table in a streaming manner: "esrs.MetricDependencyClosure" */
  esrs_MetricDependencyClosure_stream: Array<Esrs_MetricDependencyClosure_>;
  /** fetch data from the table: "esrs.MetricRelatedDisclosureRequirement" */
  esrs_MetricRelatedDisclosureRequirement: Array<Esrs_MetricRelatedDisclosureRequirement_>;
  /** fetch aggregated fields from the table: "esrs.MetricRelatedDisclosureRequirement" */
  esrs_MetricRelatedDisclosureRequirement_aggregate: Esrs_MetricRelatedDisclosureRequirement_Aggregate_;
  /** fetch data from the table in a streaming manner: "esrs.MetricRelatedDisclosureRequirement" */
  esrs_MetricRelatedDisclosureRequirement_stream: Array<Esrs_MetricRelatedDisclosureRequirement_>;
  /** fetch data from the table: "esrs.Milestone" */
  esrs_Milestone: Array<Esrs_Milestone_>;
  /** fetch data from the table: "esrs.MilestoneResult" */
  esrs_MilestoneResult: Array<Esrs_MilestoneResult_>;
  /** fetch aggregated fields from the table: "esrs.MilestoneResult" */
  esrs_MilestoneResult_aggregate: Esrs_MilestoneResult_Aggregate_;
  /** fetch data from the table: "esrs.MilestoneResult" using primary key columns */
  esrs_MilestoneResult_by_pk?: Maybe<Esrs_MilestoneResult_>;
  /** fetch data from the table in a streaming manner: "esrs.MilestoneResult" */
  esrs_MilestoneResult_stream: Array<Esrs_MilestoneResult_>;
  /** fetch aggregated fields from the table: "esrs.Milestone" */
  esrs_Milestone_aggregate: Esrs_Milestone_Aggregate_;
  /** fetch data from the table: "esrs.Milestone" using primary key columns */
  esrs_Milestone_by_pk?: Maybe<Esrs_Milestone_>;
  /** fetch data from the table in a streaming manner: "esrs.Milestone" */
  esrs_Milestone_stream: Array<Esrs_Milestone_>;
  /** fetch data from the table: "esrs.Policy" */
  esrs_Policy: Array<Esrs_Policy_>;
  /** fetch aggregated fields from the table: "esrs.Policy" */
  esrs_Policy_aggregate: Esrs_Policy_Aggregate_;
  /** fetch data from the table: "esrs.Policy" using primary key columns */
  esrs_Policy_by_pk?: Maybe<Esrs_Policy_>;
  /** fetch data from the table in a streaming manner: "esrs.Policy" */
  esrs_Policy_stream: Array<Esrs_Policy_>;
  /** fetch data from the table: "esrs.ReportingUnit" */
  esrs_ReportingUnit: Array<Esrs_ReportingUnit_>;
  /** fetch data from the table: "esrs.ReportingUnitLineage" */
  esrs_ReportingUnitLineage: Array<Esrs_ReportingUnitLineage_>;
  /** fetch aggregated fields from the table: "esrs.ReportingUnitLineage" */
  esrs_ReportingUnitLineage_aggregate: Esrs_ReportingUnitLineage_Aggregate_;
  /** fetch data from the table: "esrs.ReportingUnitLineage" using primary key columns */
  esrs_ReportingUnitLineage_by_pk?: Maybe<Esrs_ReportingUnitLineage_>;
  /** fetch data from the table in a streaming manner: "esrs.ReportingUnitLineage" */
  esrs_ReportingUnitLineage_stream: Array<Esrs_ReportingUnitLineage_>;
  /** fetch aggregated fields from the table: "esrs.ReportingUnit" */
  esrs_ReportingUnit_aggregate: Esrs_ReportingUnit_Aggregate_;
  /** fetch data from the table: "esrs.ReportingUnit" using primary key columns */
  esrs_ReportingUnit_by_pk?: Maybe<Esrs_ReportingUnit_>;
  /** fetch data from the table in a streaming manner: "esrs.ReportingUnit" */
  esrs_ReportingUnit_stream: Array<Esrs_ReportingUnit_>;
  /** fetch data from the table: "esrs.Target" */
  esrs_Target: Array<Esrs_Target_>;
  /** fetch aggregated fields from the table: "esrs.Target" */
  esrs_Target_aggregate: Esrs_Target_Aggregate_;
  /** fetch data from the table: "esrs.Target" using primary key columns */
  esrs_Target_by_pk?: Maybe<Esrs_Target_>;
  /** fetch data from the table in a streaming manner: "esrs.Target" */
  esrs_Target_stream: Array<Esrs_Target_>;
  /** fetch data from the table: "storage.files" using primary key columns */
  file?: Maybe<Files_>;
  /** An array relationship */
  files: Array<Files_>;
  /** fetch aggregated fields from the table: "storage.files" */
  filesAggregate: Files_Aggregate_;
  /** fetch data from the table in a streaming manner: "storage.files" */
  files_stream: Array<Files_>;
  /** fetch data from the table: "auth.users" using primary key columns */
  user?: Maybe<Users_>;
  /** fetch data from the table: "auth.users" */
  users: Array<Users_>;
  /** fetch aggregated fields from the table: "auth.users" */
  usersAggregate: Users_Aggregate_;
  /** fetch data from the table in a streaming manner: "auth.users" */
  users_stream: Array<Users_>;
  /** fetch data from the table: "storage.virus" using primary key columns */
  virus?: Maybe<Virus_>;
  /** fetch data from the table in a streaming manner: "storage.virus" */
  virus_stream: Array<Virus_>;
  /** fetch data from the table: "storage.virus" */
  viruses: Array<Virus_>;
  /** fetch aggregated fields from the table: "storage.virus" */
  virusesAggregate: Virus_Aggregate_;
};


export type Subscription_RootAiConfigArgs_ = {
  distinct_on?: InputMaybe<Array<AiConfig_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AiConfig_Order_By_>>;
  where?: InputMaybe<AiConfig_Bool_Exp_>;
};


export type Subscription_RootAiConfig_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AiConfig_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AiConfig_Order_By_>>;
  where?: InputMaybe<AiConfig_Bool_Exp_>;
};


export type Subscription_RootAiConfig_By_PkArgs_ = {
  companyId: Scalars['uuid']['input'];
};


export type Subscription_RootAiConfig_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AiConfig_Stream_Cursor_Input_>>;
  where?: InputMaybe<AiConfig_Bool_Exp_>;
};


export type Subscription_RootActionQuestionArgs_ = {
  distinct_on?: InputMaybe<Array<ActionQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestion_Order_By_>>;
  where?: InputMaybe<ActionQuestion_Bool_Exp_>;
};


export type Subscription_RootActionQuestionGroupArgs_ = {
  distinct_on?: InputMaybe<Array<ActionQuestionGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestionGroup_Order_By_>>;
  where?: InputMaybe<ActionQuestionGroup_Bool_Exp_>;
};


export type Subscription_RootActionQuestionGroup_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActionQuestionGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestionGroup_Order_By_>>;
  where?: InputMaybe<ActionQuestionGroup_Bool_Exp_>;
};


export type Subscription_RootActionQuestionGroup_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootActionQuestionGroup_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ActionQuestionGroup_Stream_Cursor_Input_>>;
  where?: InputMaybe<ActionQuestionGroup_Bool_Exp_>;
};


export type Subscription_RootActionQuestion_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActionQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestion_Order_By_>>;
  where?: InputMaybe<ActionQuestion_Bool_Exp_>;
};


export type Subscription_RootActionQuestion_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootActionQuestion_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ActionQuestion_Stream_Cursor_Input_>>;
  where?: InputMaybe<ActionQuestion_Bool_Exp_>;
};


export type Subscription_RootActivityArgs_ = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By_>>;
  where?: InputMaybe<Activity_Bool_Exp_>;
};


export type Subscription_RootActivityNaceCodeArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityNaceCode_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityNaceCode_Order_By_>>;
  where?: InputMaybe<ActivityNaceCode_Bool_Exp_>;
};


export type Subscription_RootActivityNaceCode_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityNaceCode_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityNaceCode_Order_By_>>;
  where?: InputMaybe<ActivityNaceCode_Bool_Exp_>;
};


export type Subscription_RootActivityNaceCode_By_PkArgs_ = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootActivityNaceCode_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ActivityNaceCode_Stream_Cursor_Input_>>;
  where?: InputMaybe<ActivityNaceCode_Bool_Exp_>;
};


export type Subscription_RootActivityQuestionSetArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityQuestionSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityQuestionSet_Order_By_>>;
  where?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
};


export type Subscription_RootActivityQuestionSet_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityQuestionSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityQuestionSet_Order_By_>>;
  where?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
};


export type Subscription_RootActivityQuestionSet_By_PkArgs_ = {
  activityRef: Scalars['String']['input'];
  questionSetRef: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


export type Subscription_RootActivityQuestionSet_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ActivityQuestionSet_Stream_Cursor_Input_>>;
  where?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
};


export type Subscription_RootActivityReportArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityReport_Order_By_>>;
  where?: InputMaybe<ActivityReport_Bool_Exp_>;
};


export type Subscription_RootActivityReport_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityReport_Order_By_>>;
  where?: InputMaybe<ActivityReport_Bool_Exp_>;
};


export type Subscription_RootActivityReport_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootActivityReport_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ActivityReport_Stream_Cursor_Input_>>;
  where?: InputMaybe<ActivityReport_Bool_Exp_>;
};


export type Subscription_RootActivityVersionArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityVersion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityVersion_Order_By_>>;
  where?: InputMaybe<ActivityVersion_Bool_Exp_>;
};


export type Subscription_RootActivityVersion_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ActivityVersion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityVersion_Order_By_>>;
  where?: InputMaybe<ActivityVersion_Bool_Exp_>;
};


export type Subscription_RootActivityVersion_By_PkArgs_ = {
  activityRef: Scalars['String']['input'];
  versionNumber: Scalars['Int']['input'];
};


export type Subscription_RootActivityVersion_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ActivityVersion_Stream_Cursor_Input_>>;
  where?: InputMaybe<ActivityVersion_Bool_Exp_>;
};


export type Subscription_RootActivity_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Activity_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By_>>;
  where?: InputMaybe<Activity_Bool_Exp_>;
};


export type Subscription_RootActivity_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootActivity_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Activity_Stream_Cursor_Input_>>;
  where?: InputMaybe<Activity_Bool_Exp_>;
};


export type Subscription_RootAdditionalTypeArgs_ = {
  distinct_on?: InputMaybe<Array<AdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AdditionalType_Order_By_>>;
  where?: InputMaybe<AdditionalType_Bool_Exp_>;
};


export type Subscription_RootAdditionalType_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AdditionalType_Order_By_>>;
  where?: InputMaybe<AdditionalType_Bool_Exp_>;
};


export type Subscription_RootAdditionalType_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootAdditionalType_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AdditionalType_Stream_Cursor_Input_>>;
  where?: InputMaybe<AdditionalType_Bool_Exp_>;
};


export type Subscription_RootAnswerArgs_ = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By_>>;
  where?: InputMaybe<Answer_Bool_Exp_>;
};


export type Subscription_RootAnswerCompanyArgs_ = {
  distinct_on?: InputMaybe<Array<AnswerCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AnswerCompany_Order_By_>>;
  where?: InputMaybe<AnswerCompany_Bool_Exp_>;
};


export type Subscription_RootAnswerCompany_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AnswerCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AnswerCompany_Order_By_>>;
  where?: InputMaybe<AnswerCompany_Bool_Exp_>;
};


export type Subscription_RootAnswerCompany_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AnswerCompany_Stream_Cursor_Input_>>;
  where?: InputMaybe<AnswerCompany_Bool_Exp_>;
};


export type Subscription_RootAnswer_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Answer_Order_By_>>;
  where?: InputMaybe<Answer_Bool_Exp_>;
};


export type Subscription_RootAnswer_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAnswer_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Answer_Stream_Cursor_Input_>>;
  where?: InputMaybe<Answer_Bool_Exp_>;
};


export type Subscription_RootAppConfigArgs_ = {
  distinct_on?: InputMaybe<Array<AppConfig_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AppConfig_Order_By_>>;
  where?: InputMaybe<AppConfig_Bool_Exp_>;
};


export type Subscription_RootAppConfig_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AppConfig_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AppConfig_Order_By_>>;
  where?: InputMaybe<AppConfig_Bool_Exp_>;
};


export type Subscription_RootAppConfig_By_PkArgs_ = {
  id: Scalars['Boolean']['input'];
};


export type Subscription_RootAppConfig_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AppConfig_Stream_Cursor_Input_>>;
  where?: InputMaybe<AppConfig_Bool_Exp_>;
};


export type Subscription_RootArticleArgs_ = {
  distinct_on?: InputMaybe<Array<Article_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Article_Order_By_>>;
  where?: InputMaybe<Article_Bool_Exp_>;
};


export type Subscription_RootArticle_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Article_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Article_Order_By_>>;
  where?: InputMaybe<Article_Bool_Exp_>;
};


export type Subscription_RootArticle_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootArticle_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Article_Stream_Cursor_Input_>>;
  where?: InputMaybe<Article_Bool_Exp_>;
};


export type Subscription_RootAttachmentArgs_ = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attachment_Order_By_>>;
  where?: InputMaybe<Attachment_Bool_Exp_>;
};


export type Subscription_RootAttachmentBoxArgs_ = {
  distinct_on?: InputMaybe<Array<AttachmentBox_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttachmentBox_Order_By_>>;
  where?: InputMaybe<AttachmentBox_Bool_Exp_>;
};


export type Subscription_RootAttachmentBox_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AttachmentBox_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AttachmentBox_Order_By_>>;
  where?: InputMaybe<AttachmentBox_Bool_Exp_>;
};


export type Subscription_RootAttachmentBox_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAttachmentBox_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AttachmentBox_Stream_Cursor_Input_>>;
  where?: InputMaybe<AttachmentBox_Bool_Exp_>;
};


export type Subscription_RootAttachment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Attachment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Attachment_Order_By_>>;
  where?: InputMaybe<Attachment_Bool_Exp_>;
};


export type Subscription_RootAttachment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAttachment_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Attachment_Stream_Cursor_Input_>>;
  where?: InputMaybe<Attachment_Bool_Exp_>;
};


export type Subscription_RootAuditLogEntryArgs_ = {
  distinct_on?: InputMaybe<Array<AuditLogEntry_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuditLogEntry_Order_By_>>;
  where?: InputMaybe<AuditLogEntry_Bool_Exp_>;
};


export type Subscription_RootAuditLogEntry_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuditLogEntry_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuditLogEntry_Order_By_>>;
  where?: InputMaybe<AuditLogEntry_Bool_Exp_>;
};


export type Subscription_RootAuditLogEntry_By_PkArgs_ = {
  invocationId: Scalars['uuid']['input'];
};


export type Subscription_RootAuditLogEntry_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuditLogEntry_Stream_Cursor_Input_>>;
  where?: InputMaybe<AuditLogEntry_Bool_Exp_>;
};


export type Subscription_RootBusinessUnitArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnit_Order_By_>>;
  where?: InputMaybe<BusinessUnit_Bool_Exp_>;
};


export type Subscription_RootBusinessUnitAssessmentArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnitAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnitAssessment_Order_By_>>;
  where?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
};


export type Subscription_RootBusinessUnitAssessment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnitAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnitAssessment_Order_By_>>;
  where?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
};


export type Subscription_RootBusinessUnitAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBusinessUnitAssessment_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessUnitAssessment_Stream_Cursor_Input_>>;
  where?: InputMaybe<BusinessUnitAssessment_Bool_Exp_>;
};


export type Subscription_RootBusinessUnit_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<BusinessUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<BusinessUnit_Order_By_>>;
  where?: InputMaybe<BusinessUnit_Bool_Exp_>;
};


export type Subscription_RootBusinessUnit_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBusinessUnit_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BusinessUnit_Stream_Cursor_Input_>>;
  where?: InputMaybe<BusinessUnit_Bool_Exp_>;
};


export type Subscription_RootCachedResultArgs_ = {
  distinct_on?: InputMaybe<Array<CachedResult_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CachedResult_Order_By_>>;
  where?: InputMaybe<CachedResult_Bool_Exp_>;
};


export type Subscription_RootCachedResult_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CachedResult_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CachedResult_Order_By_>>;
  where?: InputMaybe<CachedResult_Bool_Exp_>;
};


export type Subscription_RootCachedResult_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCachedResult_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CachedResult_Stream_Cursor_Input_>>;
  where?: InputMaybe<CachedResult_Bool_Exp_>;
};


export type Subscription_RootChoiceSetArgs_ = {
  distinct_on?: InputMaybe<Array<ChoiceSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ChoiceSet_Order_By_>>;
  where?: InputMaybe<ChoiceSet_Bool_Exp_>;
};


export type Subscription_RootChoiceSet_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ChoiceSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ChoiceSet_Order_By_>>;
  where?: InputMaybe<ChoiceSet_Bool_Exp_>;
};


export type Subscription_RootChoiceSet_By_PkArgs_ = {
  title: Scalars['String']['input'];
};


export type Subscription_RootChoiceSet_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ChoiceSet_Stream_Cursor_Input_>>;
  where?: InputMaybe<ChoiceSet_Bool_Exp_>;
};


export type Subscription_RootCommentArgs_ = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comment_Order_By_>>;
  where?: InputMaybe<Comment_Bool_Exp_>;
};


export type Subscription_RootComment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Comment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Comment_Order_By_>>;
  where?: InputMaybe<Comment_Bool_Exp_>;
};


export type Subscription_RootComment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootComment_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Comment_Stream_Cursor_Input_>>;
  where?: InputMaybe<Comment_Bool_Exp_>;
};


export type Subscription_RootCompanyArgs_ = {
  distinct_on?: InputMaybe<Array<Company_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Company_Order_By_>>;
  where?: InputMaybe<Company_Bool_Exp_>;
};


export type Subscription_RootCompanyAssessmentArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessment_Order_By_>>;
  where?: InputMaybe<CompanyAssessment_Bool_Exp_>;
};


export type Subscription_RootCompanyAssessmentAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessmentAggregate_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessmentAggregate_Order_By_>>;
  where?: InputMaybe<CompanyAssessmentAggregate_Bool_Exp_>;
};


export type Subscription_RootCompanyAssessmentAggregate_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessmentAggregate_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessmentAggregate_Order_By_>>;
  where?: InputMaybe<CompanyAssessmentAggregate_Bool_Exp_>;
};


export type Subscription_RootCompanyAssessmentAggregate_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCompanyAssessmentAggregate_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CompanyAssessmentAggregate_Stream_Cursor_Input_>>;
  where?: InputMaybe<CompanyAssessmentAggregate_Bool_Exp_>;
};


export type Subscription_RootCompanyAssessment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessment_Order_By_>>;
  where?: InputMaybe<CompanyAssessment_Bool_Exp_>;
};


export type Subscription_RootCompanyAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCompanyAssessment_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CompanyAssessment_Stream_Cursor_Input_>>;
  where?: InputMaybe<CompanyAssessment_Bool_Exp_>;
};


export type Subscription_RootCompanyIdentityProviderArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyIdentityProvider_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyIdentityProvider_Order_By_>>;
  where?: InputMaybe<CompanyIdentityProvider_Bool_Exp_>;
};


export type Subscription_RootCompanyIdentityProvider_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyIdentityProvider_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyIdentityProvider_Order_By_>>;
  where?: InputMaybe<CompanyIdentityProvider_Bool_Exp_>;
};


export type Subscription_RootCompanyIdentityProvider_By_PkArgs_ = {
  companyId: Scalars['uuid']['input'];
};


export type Subscription_RootCompanyIdentityProvider_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CompanyIdentityProvider_Stream_Cursor_Input_>>;
  where?: InputMaybe<CompanyIdentityProvider_Bool_Exp_>;
};


export type Subscription_RootCompanyInvitationArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyInvitation_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyInvitation_Order_By_>>;
  where?: InputMaybe<CompanyInvitation_Bool_Exp_>;
};


export type Subscription_RootCompanyInvitation_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyInvitation_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyInvitation_Order_By_>>;
  where?: InputMaybe<CompanyInvitation_Bool_Exp_>;
};


export type Subscription_RootCompanyInvitation_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCompanyInvitation_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CompanyInvitation_Stream_Cursor_Input_>>;
  where?: InputMaybe<CompanyInvitation_Bool_Exp_>;
};


export type Subscription_RootCompanyUserArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyUser_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyUser_Order_By_>>;
  where?: InputMaybe<CompanyUser_Bool_Exp_>;
};


export type Subscription_RootCompanyUser_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyUser_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyUser_Order_By_>>;
  where?: InputMaybe<CompanyUser_Bool_Exp_>;
};


export type Subscription_RootCompanyUser_By_PkArgs_ = {
  companyId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Subscription_RootCompanyUser_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CompanyUser_Stream_Cursor_Input_>>;
  where?: InputMaybe<CompanyUser_Bool_Exp_>;
};


export type Subscription_RootCompany_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Company_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Company_Order_By_>>;
  where?: InputMaybe<Company_Bool_Exp_>;
};


export type Subscription_RootCompany_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCompany_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Company_Stream_Cursor_Input_>>;
  where?: InputMaybe<Company_Bool_Exp_>;
};


export type Subscription_RootCompassPatArgs_ = {
  distinct_on?: InputMaybe<Array<CompassPat_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompassPat_Order_By_>>;
  where?: InputMaybe<CompassPat_Bool_Exp_>;
};


export type Subscription_RootCompassPat_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompassPat_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompassPat_Order_By_>>;
  where?: InputMaybe<CompassPat_Bool_Exp_>;
};


export type Subscription_RootCompassPat_By_PkArgs_ = {
  userId: Scalars['uuid']['input'];
};


export type Subscription_RootCompassPat_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CompassPat_Stream_Cursor_Input_>>;
  where?: InputMaybe<CompassPat_Bool_Exp_>;
};


export type Subscription_RootDrToMfDisclosureRequirementArgs_ = {
  distinct_on?: InputMaybe<Array<DrToMfDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DrToMfDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<DrToMfDisclosureRequirement_Bool_Exp_>;
};


export type Subscription_RootDrToMfDisclosureRequirement_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DrToMfDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DrToMfDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<DrToMfDisclosureRequirement_Bool_Exp_>;
};


export type Subscription_RootDrToMfDisclosureRequirement_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDrToMfDisclosureRequirement_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DrToMfDisclosureRequirement_Stream_Cursor_Input_>>;
  where?: InputMaybe<DrToMfDisclosureRequirement_Bool_Exp_>;
};


export type Subscription_RootDisclosureRequirementArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirement_Order_By_>>;
  where?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
};


export type Subscription_RootDisclosureRequirementAdditionalTypeArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementAdditionalType_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementAdditionalType_Bool_Exp_>;
};


export type Subscription_RootDisclosureRequirementAdditionalType_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementAdditionalType_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementAdditionalType_Bool_Exp_>;
};


export type Subscription_RootDisclosureRequirementAdditionalType_By_PkArgs_ = {
  additionalTypeRef: Scalars['String']['input'];
  disclosureRequirementRef: Scalars['String']['input'];
};


export type Subscription_RootDisclosureRequirementAdditionalType_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DisclosureRequirementAdditionalType_Stream_Cursor_Input_>>;
  where?: InputMaybe<DisclosureRequirementAdditionalType_Bool_Exp_>;
};


export type Subscription_RootDisclosureRequirementGroupArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementGroup_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementGroup_Bool_Exp_>;
};


export type Subscription_RootDisclosureRequirementGroup_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementGroup_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementGroup_Bool_Exp_>;
};


export type Subscription_RootDisclosureRequirementGroup_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootDisclosureRequirementGroup_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DisclosureRequirementGroup_Stream_Cursor_Input_>>;
  where?: InputMaybe<DisclosureRequirementGroup_Bool_Exp_>;
};


export type Subscription_RootDisclosureRequirementOwnerArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementOwner_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementOwner_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementOwner_Bool_Exp_>;
};


export type Subscription_RootDisclosureRequirementOwner_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementOwner_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementOwner_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementOwner_Bool_Exp_>;
};


export type Subscription_RootDisclosureRequirementOwner_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDisclosureRequirementOwner_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DisclosureRequirementOwner_Stream_Cursor_Input_>>;
  where?: InputMaybe<DisclosureRequirementOwner_Bool_Exp_>;
};


export type Subscription_RootDisclosureRequirementStatusArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementStatus_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementStatus_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementStatus_Bool_Exp_>;
};


export type Subscription_RootDisclosureRequirementStatus_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirementStatus_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementStatus_Order_By_>>;
  where?: InputMaybe<DisclosureRequirementStatus_Bool_Exp_>;
};


export type Subscription_RootDisclosureRequirementStatus_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDisclosureRequirementStatus_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DisclosureRequirementStatus_Stream_Cursor_Input_>>;
  where?: InputMaybe<DisclosureRequirementStatus_Bool_Exp_>;
};


export type Subscription_RootDisclosureRequirement_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirement_Order_By_>>;
  where?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
};


export type Subscription_RootDisclosureRequirement_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootDisclosureRequirement_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DisclosureRequirement_Stream_Cursor_Input_>>;
  where?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
};


export type Subscription_RootDocumentInsightArgs_ = {
  distinct_on?: InputMaybe<Array<DocumentInsight_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DocumentInsight_Order_By_>>;
  where?: InputMaybe<DocumentInsight_Bool_Exp_>;
};


export type Subscription_RootDocumentInsight_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DocumentInsight_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DocumentInsight_Order_By_>>;
  where?: InputMaybe<DocumentInsight_Bool_Exp_>;
};


export type Subscription_RootDocumentInsight_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDocumentInsight_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DocumentInsight_Stream_Cursor_Input_>>;
  where?: InputMaybe<DocumentInsight_Bool_Exp_>;
};


export type Subscription_RootDocumentationFileArgs_ = {
  distinct_on?: InputMaybe<Array<DocumentationFile_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DocumentationFile_Order_By_>>;
  where?: InputMaybe<DocumentationFile_Bool_Exp_>;
};


export type Subscription_RootDocumentationFile_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<DocumentationFile_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DocumentationFile_Order_By_>>;
  where?: InputMaybe<DocumentationFile_Bool_Exp_>;
};


export type Subscription_RootDocumentationFile_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDocumentationFile_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DocumentationFile_Stream_Cursor_Input_>>;
  where?: InputMaybe<DocumentationFile_Bool_Exp_>;
};


export type Subscription_RootEsrsAssessmentArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsAssessment_Order_By_>>;
  where?: InputMaybe<EsrsAssessment_Bool_Exp_>;
};


export type Subscription_RootEsrsAssessment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsAssessment_Order_By_>>;
  where?: InputMaybe<EsrsAssessment_Bool_Exp_>;
};


export type Subscription_RootEsrsAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrsAssessment_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EsrsAssessment_Stream_Cursor_Input_>>;
  where?: InputMaybe<EsrsAssessment_Bool_Exp_>;
};


export type Subscription_RootEsrsCategoryArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsCategory_Order_By_>>;
  where?: InputMaybe<EsrsCategory_Bool_Exp_>;
};


export type Subscription_RootEsrsCategory_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsCategory_Order_By_>>;
  where?: InputMaybe<EsrsCategory_Bool_Exp_>;
};


export type Subscription_RootEsrsCategory_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootEsrsCategory_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EsrsCategory_Stream_Cursor_Input_>>;
  where?: InputMaybe<EsrsCategory_Bool_Exp_>;
};


export type Subscription_RootEsrsChoiceArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsChoice_Order_By_>>;
  where?: InputMaybe<EsrsChoice_Bool_Exp_>;
};


export type Subscription_RootEsrsChoice_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsChoice_Order_By_>>;
  where?: InputMaybe<EsrsChoice_Bool_Exp_>;
};


export type Subscription_RootEsrsChoice_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootEsrsChoice_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EsrsChoice_Stream_Cursor_Input_>>;
  where?: InputMaybe<EsrsChoice_Bool_Exp_>;
};


export type Subscription_RootEsrsMetricArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetric_Order_By_>>;
  where?: InputMaybe<EsrsMetric_Bool_Exp_>;
};


export type Subscription_RootEsrsMetricAdditionalTypeArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsMetricAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetricAdditionalType_Order_By_>>;
  where?: InputMaybe<EsrsMetricAdditionalType_Bool_Exp_>;
};


export type Subscription_RootEsrsMetricAdditionalType_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsMetricAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetricAdditionalType_Order_By_>>;
  where?: InputMaybe<EsrsMetricAdditionalType_Bool_Exp_>;
};


export type Subscription_RootEsrsMetricAdditionalType_By_PkArgs_ = {
  additionalTypeRef: Scalars['String']['input'];
  metricRef: Scalars['String']['input'];
};


export type Subscription_RootEsrsMetricAdditionalType_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EsrsMetricAdditionalType_Stream_Cursor_Input_>>;
  where?: InputMaybe<EsrsMetricAdditionalType_Bool_Exp_>;
};


export type Subscription_RootEsrsMetric_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetric_Order_By_>>;
  where?: InputMaybe<EsrsMetric_Bool_Exp_>;
};


export type Subscription_RootEsrsMetric_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootEsrsMetric_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EsrsMetric_Stream_Cursor_Input_>>;
  where?: InputMaybe<EsrsMetric_Bool_Exp_>;
};


export type Subscription_RootEsrsStandardArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandard_Order_By_>>;
  where?: InputMaybe<EsrsStandard_Bool_Exp_>;
};


export type Subscription_RootEsrsStandardAdditionalTypeArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsStandardAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandardAdditionalType_Order_By_>>;
  where?: InputMaybe<EsrsStandardAdditionalType_Bool_Exp_>;
};


export type Subscription_RootEsrsStandardAdditionalType_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsStandardAdditionalType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandardAdditionalType_Order_By_>>;
  where?: InputMaybe<EsrsStandardAdditionalType_Bool_Exp_>;
};


export type Subscription_RootEsrsStandardAdditionalType_By_PkArgs_ = {
  additionalTypeRef: Scalars['String']['input'];
  standardRef: Scalars['String']['input'];
};


export type Subscription_RootEsrsStandardAdditionalType_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EsrsStandardAdditionalType_Stream_Cursor_Input_>>;
  where?: InputMaybe<EsrsStandardAdditionalType_Bool_Exp_>;
};


export type Subscription_RootEsrsStandard_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EsrsStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandard_Order_By_>>;
  where?: InputMaybe<EsrsStandard_Bool_Exp_>;
};


export type Subscription_RootEsrsStandard_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootEsrsStandard_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EsrsStandard_Stream_Cursor_Input_>>;
  where?: InputMaybe<EsrsStandard_Bool_Exp_>;
};


export type Subscription_RootEstimateCompany_DeprecatedArgs_ = {
  distinct_on?: InputMaybe<Array<EstimateCompany_Deprecated_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EstimateCompany_Deprecated_Order_By_>>;
  where?: InputMaybe<EstimateCompany_Deprecated_Bool_Exp_>;
};


export type Subscription_RootEstimateCompany_Deprecated_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<EstimateCompany_Deprecated_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EstimateCompany_Deprecated_Order_By_>>;
  where?: InputMaybe<EstimateCompany_Deprecated_Bool_Exp_>;
};


export type Subscription_RootEstimateCompany_Deprecated_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEstimateCompany_Deprecated_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EstimateCompany_Deprecated_Stream_Cursor_Input_>>;
  where?: InputMaybe<EstimateCompany_Deprecated_Bool_Exp_>;
};


export type Subscription_RootExtractionJobArgs_ = {
  distinct_on?: InputMaybe<Array<ExtractionJob_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ExtractionJob_Order_By_>>;
  where?: InputMaybe<ExtractionJob_Bool_Exp_>;
};


export type Subscription_RootExtractionJob_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ExtractionJob_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ExtractionJob_Order_By_>>;
  where?: InputMaybe<ExtractionJob_Bool_Exp_>;
};


export type Subscription_RootExtractionJob_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootExtractionJob_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ExtractionJob_Stream_Cursor_Input_>>;
  where?: InputMaybe<ExtractionJob_Bool_Exp_>;
};


export type Subscription_RootFinancialsArgs_ = {
  distinct_on?: InputMaybe<Array<Financials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Financials_Order_By_>>;
  where?: InputMaybe<Financials_Bool_Exp_>;
};


export type Subscription_RootFinancials_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Financials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Financials_Order_By_>>;
  where?: InputMaybe<Financials_Bool_Exp_>;
};


export type Subscription_RootFinancials_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFinancials_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Financials_Stream_Cursor_Input_>>;
  where?: InputMaybe<Financials_Bool_Exp_>;
};


export type Subscription_RootFrameworkArgs_ = {
  distinct_on?: InputMaybe<Array<Framework_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Framework_Order_By_>>;
  where?: InputMaybe<Framework_Bool_Exp_>;
};


export type Subscription_RootFramework_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Framework_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Framework_Order_By_>>;
  where?: InputMaybe<Framework_Bool_Exp_>;
};


export type Subscription_RootFramework_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootFramework_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Framework_Stream_Cursor_Input_>>;
  where?: InputMaybe<Framework_Bool_Exp_>;
};


export type Subscription_RootGroupAssessmentArgs_ = {
  distinct_on?: InputMaybe<Array<GroupAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GroupAssessment_Order_By_>>;
  where?: InputMaybe<GroupAssessment_Bool_Exp_>;
};


export type Subscription_RootGroupAssessment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<GroupAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GroupAssessment_Order_By_>>;
  where?: InputMaybe<GroupAssessment_Bool_Exp_>;
};


export type Subscription_RootGroupAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootGroupAssessment_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<GroupAssessment_Stream_Cursor_Input_>>;
  where?: InputMaybe<GroupAssessment_Bool_Exp_>;
};


export type Subscription_RootIdentityProviderArgs_ = {
  distinct_on?: InputMaybe<Array<IdentityProvider_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IdentityProvider_Order_By_>>;
  where?: InputMaybe<IdentityProvider_Bool_Exp_>;
};


export type Subscription_RootIdentityProvider_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<IdentityProvider_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IdentityProvider_Order_By_>>;
  where?: InputMaybe<IdentityProvider_Bool_Exp_>;
};


export type Subscription_RootIdentityProvider_By_PkArgs_ = {
  name: Scalars['String']['input'];
};


export type Subscription_RootIdentityProvider_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<IdentityProvider_Stream_Cursor_Input_>>;
  where?: InputMaybe<IdentityProvider_Bool_Exp_>;
};


export type Subscription_RootIndicatorToInvestorMetricArgs_ = {
  distinct_on?: InputMaybe<Array<IndicatorToInvestorMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorToInvestorMetric_Order_By_>>;
  where?: InputMaybe<IndicatorToInvestorMetric_Bool_Exp_>;
};


export type Subscription_RootIndicatorToInvestorMetric_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<IndicatorToInvestorMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorToInvestorMetric_Order_By_>>;
  where?: InputMaybe<IndicatorToInvestorMetric_Bool_Exp_>;
};


export type Subscription_RootIndicatorToInvestorMetric_By_PkArgs_ = {
  indicatorRef: Scalars['String']['input'];
  investorMetricRef: Scalars['String']['input'];
};


export type Subscription_RootIndicatorToInvestorMetric_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<IndicatorToInvestorMetric_Stream_Cursor_Input_>>;
  where?: InputMaybe<IndicatorToInvestorMetric_Bool_Exp_>;
};


export type Subscription_RootInvesteeMetricArgs_ = {
  distinct_on?: InputMaybe<Array<InvesteeMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvesteeMetric_Order_By_>>;
  where?: InputMaybe<InvesteeMetric_Bool_Exp_>;
};


export type Subscription_RootInvesteeMetric_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<InvesteeMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvesteeMetric_Order_By_>>;
  where?: InputMaybe<InvesteeMetric_Bool_Exp_>;
};


export type Subscription_RootInvesteeMetric_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootInvesteeMetric_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<InvesteeMetric_Stream_Cursor_Input_>>;
  where?: InputMaybe<InvesteeMetric_Bool_Exp_>;
};


export type Subscription_RootInvestmentCategoryArgs_ = {
  distinct_on?: InputMaybe<Array<InvestmentCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestmentCategory_Order_By_>>;
  where?: InputMaybe<InvestmentCategory_Bool_Exp_>;
};


export type Subscription_RootInvestmentCategory_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<InvestmentCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestmentCategory_Order_By_>>;
  where?: InputMaybe<InvestmentCategory_Bool_Exp_>;
};


export type Subscription_RootInvestmentCategory_By_PkArgs_ = {
  value: Scalars['String']['input'];
};


export type Subscription_RootInvestmentCategory_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<InvestmentCategory_Stream_Cursor_Input_>>;
  where?: InputMaybe<InvestmentCategory_Bool_Exp_>;
};


export type Subscription_RootInvestorMetricArgs_ = {
  distinct_on?: InputMaybe<Array<InvestorMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestorMetric_Order_By_>>;
  where?: InputMaybe<InvestorMetric_Bool_Exp_>;
};


export type Subscription_RootInvestorMetric_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<InvestorMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestorMetric_Order_By_>>;
  where?: InputMaybe<InvestorMetric_Bool_Exp_>;
};


export type Subscription_RootInvestorMetric_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootInvestorMetric_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<InvestorMetric_Stream_Cursor_Input_>>;
  where?: InputMaybe<InvestorMetric_Bool_Exp_>;
};


export type Subscription_RootInvestorToInvesteeMetricArgs_ = {
  distinct_on?: InputMaybe<Array<InvestorToInvesteeMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestorToInvesteeMetric_Order_By_>>;
  where?: InputMaybe<InvestorToInvesteeMetric_Bool_Exp_>;
};


export type Subscription_RootInvestorToInvesteeMetric_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<InvestorToInvesteeMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestorToInvesteeMetric_Order_By_>>;
  where?: InputMaybe<InvestorToInvesteeMetric_Bool_Exp_>;
};


export type Subscription_RootInvestorToInvesteeMetric_By_PkArgs_ = {
  investeeMetricReference: Scalars['String']['input'];
  investorMetricReference: Scalars['String']['input'];
};


export type Subscription_RootInvestorToInvesteeMetric_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<InvestorToInvesteeMetric_Stream_Cursor_Input_>>;
  where?: InputMaybe<InvestorToInvesteeMetric_Bool_Exp_>;
};


export type Subscription_RootMfCategoryArgs_ = {
  distinct_on?: InputMaybe<Array<MfCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfCategory_Order_By_>>;
  where?: InputMaybe<MfCategory_Bool_Exp_>;
};


export type Subscription_RootMfCategory_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfCategory_Order_By_>>;
  where?: InputMaybe<MfCategory_Bool_Exp_>;
};


export type Subscription_RootMfCategory_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootMfCategory_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MfCategory_Stream_Cursor_Input_>>;
  where?: InputMaybe<MfCategory_Bool_Exp_>;
};


export type Subscription_RootMfDisclosureRequirementArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirement_Bool_Exp_>;
};


export type Subscription_RootMfDisclosureRequirementGroupArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirementGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementGroup_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirementGroup_Bool_Exp_>;
};


export type Subscription_RootMfDisclosureRequirementGroup_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirementGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementGroup_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirementGroup_Bool_Exp_>;
};


export type Subscription_RootMfDisclosureRequirementGroup_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootMfDisclosureRequirementGroup_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MfDisclosureRequirementGroup_Stream_Cursor_Input_>>;
  where?: InputMaybe<MfDisclosureRequirementGroup_Bool_Exp_>;
};


export type Subscription_RootMfDisclosureRequirementItemArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirementItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementItem_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirementItem_Bool_Exp_>;
};


export type Subscription_RootMfDisclosureRequirementItem_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirementItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementItem_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirementItem_Bool_Exp_>;
};


export type Subscription_RootMfDisclosureRequirementItem_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMfDisclosureRequirementItem_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MfDisclosureRequirementItem_Stream_Cursor_Input_>>;
  where?: InputMaybe<MfDisclosureRequirementItem_Bool_Exp_>;
};


export type Subscription_RootMfDisclosureRequirement_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<MfDisclosureRequirement_Bool_Exp_>;
};


export type Subscription_RootMfDisclosureRequirement_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootMfDisclosureRequirement_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MfDisclosureRequirement_Stream_Cursor_Input_>>;
  where?: InputMaybe<MfDisclosureRequirement_Bool_Exp_>;
};


export type Subscription_RootMfStandardArgs_ = {
  distinct_on?: InputMaybe<Array<MfStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandard_Order_By_>>;
  where?: InputMaybe<MfStandard_Bool_Exp_>;
};


export type Subscription_RootMfStandardItemArgs_ = {
  distinct_on?: InputMaybe<Array<MfStandardItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandardItem_Order_By_>>;
  where?: InputMaybe<MfStandardItem_Bool_Exp_>;
};


export type Subscription_RootMfStandardItem_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfStandardItem_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandardItem_Order_By_>>;
  where?: InputMaybe<MfStandardItem_Bool_Exp_>;
};


export type Subscription_RootMfStandardItem_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMfStandardItem_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MfStandardItem_Stream_Cursor_Input_>>;
  where?: InputMaybe<MfStandardItem_Bool_Exp_>;
};


export type Subscription_RootMfStandard_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MfStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandard_Order_By_>>;
  where?: InputMaybe<MfStandard_Bool_Exp_>;
};


export type Subscription_RootMfStandard_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootMfStandard_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MfStandard_Stream_Cursor_Input_>>;
  where?: InputMaybe<MfStandard_Bool_Exp_>;
};


export type Subscription_RootMaterialStandardOwnerArgs_ = {
  distinct_on?: InputMaybe<Array<MaterialStandardOwner_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialStandardOwner_Order_By_>>;
  where?: InputMaybe<MaterialStandardOwner_Bool_Exp_>;
};


export type Subscription_RootMaterialStandardOwner_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MaterialStandardOwner_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MaterialStandardOwner_Order_By_>>;
  where?: InputMaybe<MaterialStandardOwner_Bool_Exp_>;
};


export type Subscription_RootMaterialStandardOwner_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootMaterialStandardOwner_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MaterialStandardOwner_Stream_Cursor_Input_>>;
  where?: InputMaybe<MaterialStandardOwner_Bool_Exp_>;
};


export type Subscription_RootMetricDependencyArgs_ = {
  distinct_on?: InputMaybe<Array<MetricDependency_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricDependency_Order_By_>>;
  where?: InputMaybe<MetricDependency_Bool_Exp_>;
};


export type Subscription_RootMetricDependency_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MetricDependency_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricDependency_Order_By_>>;
  where?: InputMaybe<MetricDependency_Bool_Exp_>;
};


export type Subscription_RootMetricDependency_By_PkArgs_ = {
  childMetricRef: Scalars['String']['input'];
  parentMetricRef: Scalars['String']['input'];
};


export type Subscription_RootMetricDependency_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MetricDependency_Stream_Cursor_Input_>>;
  where?: InputMaybe<MetricDependency_Bool_Exp_>;
};


export type Subscription_RootMetricTagArgs_ = {
  distinct_on?: InputMaybe<Array<MetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricTag_Order_By_>>;
  where?: InputMaybe<MetricTag_Bool_Exp_>;
};


export type Subscription_RootMetricTag_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<MetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricTag_Order_By_>>;
  where?: InputMaybe<MetricTag_Bool_Exp_>;
};


export type Subscription_RootMetricTag_By_PkArgs_ = {
  metricRef: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type Subscription_RootMetricTag_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<MetricTag_Stream_Cursor_Input_>>;
  where?: InputMaybe<MetricTag_Bool_Exp_>;
};


export type Subscription_RootNonMaterialFinancialsArgs_ = {
  distinct_on?: InputMaybe<Array<NonMaterialFinancials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NonMaterialFinancials_Order_By_>>;
  where?: InputMaybe<NonMaterialFinancials_Bool_Exp_>;
};


export type Subscription_RootNonMaterialFinancials_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<NonMaterialFinancials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NonMaterialFinancials_Order_By_>>;
  where?: InputMaybe<NonMaterialFinancials_Bool_Exp_>;
};


export type Subscription_RootNonMaterialFinancials_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<NonMaterialFinancials_Stream_Cursor_Input_>>;
  where?: InputMaybe<NonMaterialFinancials_Bool_Exp_>;
};


export type Subscription_RootNoteArgs_ = {
  distinct_on?: InputMaybe<Array<Note_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By_>>;
  where?: InputMaybe<Note_Bool_Exp_>;
};


export type Subscription_RootNoteHistoryArgs_ = {
  distinct_on?: InputMaybe<Array<NoteHistory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NoteHistory_Order_By_>>;
  where?: InputMaybe<NoteHistory_Bool_Exp_>;
};


export type Subscription_RootNoteHistory_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<NoteHistory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<NoteHistory_Order_By_>>;
  where?: InputMaybe<NoteHistory_Bool_Exp_>;
};


export type Subscription_RootNoteHistory_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootNoteHistory_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<NoteHistory_Stream_Cursor_Input_>>;
  where?: InputMaybe<NoteHistory_Bool_Exp_>;
};


export type Subscription_RootNote_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Note_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Note_Order_By_>>;
  where?: InputMaybe<Note_Bool_Exp_>;
};


export type Subscription_RootNote_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootNote_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Note_Stream_Cursor_Input_>>;
  where?: InputMaybe<Note_Bool_Exp_>;
};


export type Subscription_RootObjectiveArgs_ = {
  distinct_on?: InputMaybe<Array<Objective_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objective_Order_By_>>;
  where?: InputMaybe<Objective_Bool_Exp_>;
};


export type Subscription_RootObjective_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Objective_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objective_Order_By_>>;
  where?: InputMaybe<Objective_Bool_Exp_>;
};


export type Subscription_RootObjective_By_PkArgs_ = {
  key: Scalars['String']['input'];
};


export type Subscription_RootObjective_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Objective_Stream_Cursor_Input_>>;
  where?: InputMaybe<Objective_Bool_Exp_>;
};


export type Subscription_RootPaiAnswersArgs_ = {
  distinct_on?: InputMaybe<Array<PaiAnswers_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiAnswers_Order_By_>>;
  where?: InputMaybe<PaiAnswers_Bool_Exp_>;
};


export type Subscription_RootPaiAnswers_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiAnswers_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiAnswers_Order_By_>>;
  where?: InputMaybe<PaiAnswers_Bool_Exp_>;
};


export type Subscription_RootPaiAnswers_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPaiAnswers_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PaiAnswers_Stream_Cursor_Input_>>;
  where?: InputMaybe<PaiAnswers_Bool_Exp_>;
};


export type Subscription_RootPaiCategoryArgs_ = {
  distinct_on?: InputMaybe<Array<PaiCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiCategory_Order_By_>>;
  where?: InputMaybe<PaiCategory_Bool_Exp_>;
};


export type Subscription_RootPaiCategory_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiCategory_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiCategory_Order_By_>>;
  where?: InputMaybe<PaiCategory_Bool_Exp_>;
};


export type Subscription_RootPaiCategory_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootPaiCategory_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PaiCategory_Stream_Cursor_Input_>>;
  where?: InputMaybe<PaiCategory_Bool_Exp_>;
};


export type Subscription_RootPaiCompanyReportArgs_ = {
  distinct_on?: InputMaybe<Array<PaiCompanyReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiCompanyReport_Order_By_>>;
  where?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
};


export type Subscription_RootPaiCompanyReport_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiCompanyReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiCompanyReport_Order_By_>>;
  where?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
};


export type Subscription_RootPaiCompanyReport_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPaiCompanyReport_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PaiCompanyReport_Stream_Cursor_Input_>>;
  where?: InputMaybe<PaiCompanyReport_Bool_Exp_>;
};


export type Subscription_RootPaiMetricInsightArgs_ = {
  distinct_on?: InputMaybe<Array<PaiMetricInsight_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiMetricInsight_Order_By_>>;
  where?: InputMaybe<PaiMetricInsight_Bool_Exp_>;
};


export type Subscription_RootPaiMetricInsight_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiMetricInsight_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiMetricInsight_Order_By_>>;
  where?: InputMaybe<PaiMetricInsight_Bool_Exp_>;
};


export type Subscription_RootPaiMetricInsight_By_PkArgs_ = {
  insightId: Scalars['uuid']['input'];
  investeeMetricRef: Scalars['String']['input'];
  reportId: Scalars['uuid']['input'];
};


export type Subscription_RootPaiMetricInsight_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PaiMetricInsight_Stream_Cursor_Input_>>;
  where?: InputMaybe<PaiMetricInsight_Bool_Exp_>;
};


export type Subscription_RootPaiPortfolioReportArgs_ = {
  distinct_on?: InputMaybe<Array<PaiPortfolioReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiPortfolioReport_Order_By_>>;
  where?: InputMaybe<PaiPortfolioReport_Bool_Exp_>;
};


export type Subscription_RootPaiPortfolioReport_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiPortfolioReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiPortfolioReport_Order_By_>>;
  where?: InputMaybe<PaiPortfolioReport_Bool_Exp_>;
};


export type Subscription_RootPaiPortfolioReport_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPaiPortfolioReport_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PaiPortfolioReport_Stream_Cursor_Input_>>;
  where?: InputMaybe<PaiPortfolioReport_Bool_Exp_>;
};


export type Subscription_RootPaiReportIndicatorArgs_ = {
  distinct_on?: InputMaybe<Array<PaiReportIndicator_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiReportIndicator_Order_By_>>;
  where?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
};


export type Subscription_RootPaiReportIndicatorPortfolioCompanyArgs_ = {
  distinct_on?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Order_By_>>;
  where?: InputMaybe<PaiReportIndicatorPortfolioCompany_Bool_Exp_>;
};


export type Subscription_RootPaiReportIndicatorPortfolioCompany_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiReportIndicatorPortfolioCompany_Order_By_>>;
  where?: InputMaybe<PaiReportIndicatorPortfolioCompany_Bool_Exp_>;
};


export type Subscription_RootPaiReportIndicatorPortfolioCompany_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPaiReportIndicatorPortfolioCompany_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PaiReportIndicatorPortfolioCompany_Stream_Cursor_Input_>>;
  where?: InputMaybe<PaiReportIndicatorPortfolioCompany_Bool_Exp_>;
};


export type Subscription_RootPaiReportIndicator_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiReportIndicator_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiReportIndicator_Order_By_>>;
  where?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
};


export type Subscription_RootPaiReportIndicator_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPaiReportIndicator_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PaiReportIndicator_Stream_Cursor_Input_>>;
  where?: InputMaybe<PaiReportIndicator_Bool_Exp_>;
};


export type Subscription_RootPaiTableArgs_ = {
  distinct_on?: InputMaybe<Array<PaiTable_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiTable_Order_By_>>;
  where?: InputMaybe<PaiTable_Bool_Exp_>;
};


export type Subscription_RootPaiTableIndicatorArgs_ = {
  distinct_on?: InputMaybe<Array<PaiTableIndicator_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiTableIndicator_Order_By_>>;
  where?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
};


export type Subscription_RootPaiTableIndicator_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiTableIndicator_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiTableIndicator_Order_By_>>;
  where?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
};


export type Subscription_RootPaiTableIndicator_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootPaiTableIndicator_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PaiTableIndicator_Stream_Cursor_Input_>>;
  where?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
};


export type Subscription_RootPaiTable_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PaiTable_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiTable_Order_By_>>;
  where?: InputMaybe<PaiTable_Bool_Exp_>;
};


export type Subscription_RootPaiTable_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootPaiTable_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PaiTable_Stream_Cursor_Input_>>;
  where?: InputMaybe<PaiTable_Bool_Exp_>;
};


export type Subscription_RootPortfolioArgs_ = {
  distinct_on?: InputMaybe<Array<Portfolio_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Order_By_>>;
  where?: InputMaybe<Portfolio_Bool_Exp_>;
};


export type Subscription_RootPortfolioCompanyArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


export type Subscription_RootPortfolioCompany_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioCompany_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioCompany_Order_By_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


export type Subscription_RootPortfolioCompany_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPortfolioCompany_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PortfolioCompany_Stream_Cursor_Input_>>;
  where?: InputMaybe<PortfolioCompany_Bool_Exp_>;
};


export type Subscription_RootPortfolioNonEligibleFinancialsArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioNonEligibleFinancials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioNonEligibleFinancials_Order_By_>>;
  where?: InputMaybe<PortfolioNonEligibleFinancials_Bool_Exp_>;
};


export type Subscription_RootPortfolioNonEligibleFinancials_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<PortfolioNonEligibleFinancials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PortfolioNonEligibleFinancials_Order_By_>>;
  where?: InputMaybe<PortfolioNonEligibleFinancials_Bool_Exp_>;
};


export type Subscription_RootPortfolioNonEligibleFinancials_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPortfolioNonEligibleFinancials_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PortfolioNonEligibleFinancials_Stream_Cursor_Input_>>;
  where?: InputMaybe<PortfolioNonEligibleFinancials_Bool_Exp_>;
};


export type Subscription_RootPortfolio_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Portfolio_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Portfolio_Order_By_>>;
  where?: InputMaybe<Portfolio_Bool_Exp_>;
};


export type Subscription_RootPortfolio_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPortfolio_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Portfolio_Stream_Cursor_Input_>>;
  where?: InputMaybe<Portfolio_Bool_Exp_>;
};


export type Subscription_RootQuarterEnumArgs_ = {
  distinct_on?: InputMaybe<Array<QuarterEnum_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuarterEnum_Order_By_>>;
  where?: InputMaybe<QuarterEnum_Bool_Exp_>;
};


export type Subscription_RootQuarterEnum_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuarterEnum_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuarterEnum_Order_By_>>;
  where?: InputMaybe<QuarterEnum_Bool_Exp_>;
};


export type Subscription_RootQuarterEnum_By_PkArgs_ = {
  quarter: Scalars['String']['input'];
};


export type Subscription_RootQuarterEnum_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<QuarterEnum_Stream_Cursor_Input_>>;
  where?: InputMaybe<QuarterEnum_Bool_Exp_>;
};


export type Subscription_RootQuestionArgs_ = {
  distinct_on?: InputMaybe<Array<Question_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Order_By_>>;
  where?: InputMaybe<Question_Bool_Exp_>;
};


export type Subscription_RootQuestionChoiceArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionChoice_Order_By_>>;
  where?: InputMaybe<QuestionChoice_Bool_Exp_>;
};


export type Subscription_RootQuestionChoice_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionChoice_Order_By_>>;
  where?: InputMaybe<QuestionChoice_Bool_Exp_>;
};


export type Subscription_RootQuestionChoice_By_PkArgs_ = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootQuestionChoice_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<QuestionChoice_Stream_Cursor_Input_>>;
  where?: InputMaybe<QuestionChoice_Bool_Exp_>;
};


export type Subscription_RootQuestionLevelArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionLevel_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionLevel_Order_By_>>;
  where?: InputMaybe<QuestionLevel_Bool_Exp_>;
};


export type Subscription_RootQuestionLevel_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionLevel_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionLevel_Order_By_>>;
  where?: InputMaybe<QuestionLevel_Bool_Exp_>;
};


export type Subscription_RootQuestionLevel_By_PkArgs_ = {
  level: Scalars['String']['input'];
};


export type Subscription_RootQuestionLevel_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<QuestionLevel_Stream_Cursor_Input_>>;
  where?: InputMaybe<QuestionLevel_Bool_Exp_>;
};


export type Subscription_RootQuestionRevisionArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionRevision_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionRevision_Order_By_>>;
  where?: InputMaybe<QuestionRevision_Bool_Exp_>;
};


export type Subscription_RootQuestionRevision_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionRevision_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionRevision_Order_By_>>;
  where?: InputMaybe<QuestionRevision_Bool_Exp_>;
};


export type Subscription_RootQuestionRevision_By_PkArgs_ = {
  newQuestionId: Scalars['uuid']['input'];
  oldQuestionId: Scalars['uuid']['input'];
};


export type Subscription_RootQuestionRevision_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<QuestionRevision_Stream_Cursor_Input_>>;
  where?: InputMaybe<QuestionRevision_Bool_Exp_>;
};


export type Subscription_RootQuestionSetArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionSet_Order_By_>>;
  where?: InputMaybe<QuestionSet_Bool_Exp_>;
};


export type Subscription_RootQuestionSetQuestionArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionSetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionSetQuestion_Order_By_>>;
  where?: InputMaybe<QuestionSetQuestion_Bool_Exp_>;
};


export type Subscription_RootQuestionSetQuestion_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionSetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionSetQuestion_Order_By_>>;
  where?: InputMaybe<QuestionSetQuestion_Bool_Exp_>;
};


export type Subscription_RootQuestionSetQuestion_By_PkArgs_ = {
  questionId: Scalars['uuid']['input'];
  questionSetRef: Scalars['String']['input'];
};


export type Subscription_RootQuestionSetQuestion_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<QuestionSetQuestion_Stream_Cursor_Input_>>;
  where?: InputMaybe<QuestionSetQuestion_Bool_Exp_>;
};


export type Subscription_RootQuestionSet_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionSet_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionSet_Order_By_>>;
  where?: InputMaybe<QuestionSet_Bool_Exp_>;
};


export type Subscription_RootQuestionSet_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootQuestionSet_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<QuestionSet_Stream_Cursor_Input_>>;
  where?: InputMaybe<QuestionSet_Bool_Exp_>;
};


export type Subscription_RootQuestionTypeArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionType_Order_By_>>;
  where?: InputMaybe<QuestionType_Bool_Exp_>;
};


export type Subscription_RootQuestionType_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<QuestionType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionType_Order_By_>>;
  where?: InputMaybe<QuestionType_Bool_Exp_>;
};


export type Subscription_RootQuestionType_By_PkArgs_ = {
  type: Scalars['String']['input'];
};


export type Subscription_RootQuestionType_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<QuestionType_Stream_Cursor_Input_>>;
  where?: InputMaybe<QuestionType_Bool_Exp_>;
};


export type Subscription_RootQuestion_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Question_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Order_By_>>;
  where?: InputMaybe<Question_Bool_Exp_>;
};


export type Subscription_RootQuestion_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootQuestion_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Question_Stream_Cursor_Input_>>;
  where?: InputMaybe<Question_Bool_Exp_>;
};


export type Subscription_RootReportingGroupArgs_ = {
  distinct_on?: InputMaybe<Array<ReportingGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportingGroup_Order_By_>>;
  where?: InputMaybe<ReportingGroup_Bool_Exp_>;
};


export type Subscription_RootReportingGroup_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ReportingGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ReportingGroup_Order_By_>>;
  where?: InputMaybe<ReportingGroup_Bool_Exp_>;
};


export type Subscription_RootReportingGroup_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReportingGroup_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ReportingGroup_Stream_Cursor_Input_>>;
  where?: InputMaybe<ReportingGroup_Bool_Exp_>;
};


export type Subscription_RootSectorArgs_ = {
  distinct_on?: InputMaybe<Array<Sector_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sector_Order_By_>>;
  where?: InputMaybe<Sector_Bool_Exp_>;
};


export type Subscription_RootSector_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Sector_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sector_Order_By_>>;
  where?: InputMaybe<Sector_Bool_Exp_>;
};


export type Subscription_RootSector_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootSector_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Sector_Stream_Cursor_Input_>>;
  where?: InputMaybe<Sector_Bool_Exp_>;
};


export type Subscription_RootSharedSpaceArgs_ = {
  distinct_on?: InputMaybe<Array<SharedSpace_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SharedSpace_Order_By_>>;
  where?: InputMaybe<SharedSpace_Bool_Exp_>;
};


export type Subscription_RootSharedSpace_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<SharedSpace_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<SharedSpace_Order_By_>>;
  where?: InputMaybe<SharedSpace_Bool_Exp_>;
};


export type Subscription_RootSharedSpace_By_PkArgs_ = {
  companyId: Scalars['uuid']['input'];
  spaceId: Scalars['String']['input'];
};


export type Subscription_RootSharedSpace_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SharedSpace_Stream_Cursor_Input_>>;
  where?: InputMaybe<SharedSpace_Bool_Exp_>;
};


export type Subscription_RootSpaceArgs_ = {
  distinct_on?: InputMaybe<Array<Space_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Space_Order_By_>>;
  where?: InputMaybe<Space_Bool_Exp_>;
};


export type Subscription_RootSpace_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Space_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Space_Order_By_>>;
  where?: InputMaybe<Space_Bool_Exp_>;
};


export type Subscription_RootSpace_By_PkArgs_ = {
  id: Scalars['String']['input'];
};


export type Subscription_RootSpace_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Space_Stream_Cursor_Input_>>;
  where?: InputMaybe<Space_Bool_Exp_>;
};


export type Subscription_RootSubsidiaryArgs_ = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By_>>;
  where?: InputMaybe<Subsidiary_Bool_Exp_>;
};


export type Subscription_RootSubsidiary_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Subsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Subsidiary_Order_By_>>;
  where?: InputMaybe<Subsidiary_Bool_Exp_>;
};


export type Subscription_RootSubsidiary_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootSubsidiary_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Subsidiary_Stream_Cursor_Input_>>;
  where?: InputMaybe<Subsidiary_Bool_Exp_>;
};


export type Subscription_RootTagArgs_ = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By_>>;
  where?: InputMaybe<Tag_Bool_Exp_>;
};


export type Subscription_RootTagGroupArgs_ = {
  distinct_on?: InputMaybe<Array<TagGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagGroup_Order_By_>>;
  where?: InputMaybe<TagGroup_Bool_Exp_>;
};


export type Subscription_RootTagGroup_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TagGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagGroup_Order_By_>>;
  where?: InputMaybe<TagGroup_Bool_Exp_>;
};


export type Subscription_RootTagGroup_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTagGroup_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TagGroup_Stream_Cursor_Input_>>;
  where?: InputMaybe<TagGroup_Bool_Exp_>;
};


export type Subscription_RootTagTypeArgs_ = {
  distinct_on?: InputMaybe<Array<TagType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagType_Order_By_>>;
  where?: InputMaybe<TagType_Bool_Exp_>;
};


export type Subscription_RootTagType_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TagType_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagType_Order_By_>>;
  where?: InputMaybe<TagType_Bool_Exp_>;
};


export type Subscription_RootTagType_By_PkArgs_ = {
  type: Scalars['String']['input'];
};


export type Subscription_RootTagType_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TagType_Stream_Cursor_Input_>>;
  where?: InputMaybe<TagType_Bool_Exp_>;
};


export type Subscription_RootTagValueArgs_ = {
  distinct_on?: InputMaybe<Array<TagValue_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagValue_Order_By_>>;
  where?: InputMaybe<TagValue_Bool_Exp_>;
};


export type Subscription_RootTagValue_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TagValue_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagValue_Order_By_>>;
  where?: InputMaybe<TagValue_Bool_Exp_>;
};


export type Subscription_RootTagValue_By_PkArgs_ = {
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type Subscription_RootTagValue_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TagValue_Stream_Cursor_Input_>>;
  where?: InputMaybe<TagValue_Bool_Exp_>;
};


export type Subscription_RootTag_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Tag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By_>>;
  where?: InputMaybe<Tag_Bool_Exp_>;
};


export type Subscription_RootTag_ArticlesArgs_ = {
  distinct_on?: InputMaybe<Array<Tag_Articles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Articles_Order_By_>>;
  where?: InputMaybe<Tag_Articles_Bool_Exp_>;
};


export type Subscription_RootTag_Articles_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Tag_Articles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Articles_Order_By_>>;
  where?: InputMaybe<Tag_Articles_Bool_Exp_>;
};


export type Subscription_RootTag_Articles_By_PkArgs_ = {
  id: Scalars['bigint']['input'];
};


export type Subscription_RootTag_Articles_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tag_Articles_Stream_Cursor_Input_>>;
  where?: InputMaybe<Tag_Articles_Bool_Exp_>;
};


export type Subscription_RootTag_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTag_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Tag_Stream_Cursor_Input_>>;
  where?: InputMaybe<Tag_Bool_Exp_>;
};


export type Subscription_RootTargetQuestionArgs_ = {
  distinct_on?: InputMaybe<Array<TargetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestion_Order_By_>>;
  where?: InputMaybe<TargetQuestion_Bool_Exp_>;
};


export type Subscription_RootTargetQuestionGroupArgs_ = {
  distinct_on?: InputMaybe<Array<TargetQuestionGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestionGroup_Order_By_>>;
  where?: InputMaybe<TargetQuestionGroup_Bool_Exp_>;
};


export type Subscription_RootTargetQuestionGroup_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TargetQuestionGroup_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestionGroup_Order_By_>>;
  where?: InputMaybe<TargetQuestionGroup_Bool_Exp_>;
};


export type Subscription_RootTargetQuestionGroup_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootTargetQuestionGroup_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TargetQuestionGroup_Stream_Cursor_Input_>>;
  where?: InputMaybe<TargetQuestionGroup_Bool_Exp_>;
};


export type Subscription_RootTargetQuestion_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TargetQuestion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestion_Order_By_>>;
  where?: InputMaybe<TargetQuestion_Bool_Exp_>;
};


export type Subscription_RootTargetQuestion_By_PkArgs_ = {
  reference: Scalars['String']['input'];
};


export type Subscription_RootTargetQuestion_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TargetQuestion_Stream_Cursor_Input_>>;
  where?: InputMaybe<TargetQuestion_Bool_Exp_>;
};


export type Subscription_RootTaskArgs_ = {
  distinct_on?: InputMaybe<Array<Task_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By_>>;
  where?: InputMaybe<Task_Bool_Exp_>;
};


export type Subscription_RootTaskStatusEnumArgs_ = {
  distinct_on?: InputMaybe<Array<TaskStatusEnum_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskStatusEnum_Order_By_>>;
  where?: InputMaybe<TaskStatusEnum_Bool_Exp_>;
};


export type Subscription_RootTaskStatusEnum_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TaskStatusEnum_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaskStatusEnum_Order_By_>>;
  where?: InputMaybe<TaskStatusEnum_Bool_Exp_>;
};


export type Subscription_RootTaskStatusEnum_By_PkArgs_ = {
  status: Scalars['String']['input'];
};


export type Subscription_RootTaskStatusEnum_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TaskStatusEnum_Stream_Cursor_Input_>>;
  where?: InputMaybe<TaskStatusEnum_Bool_Exp_>;
};


export type Subscription_RootTask_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Task_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Task_Order_By_>>;
  where?: InputMaybe<Task_Bool_Exp_>;
};


export type Subscription_RootTask_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTask_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Task_Stream_Cursor_Input_>>;
  where?: InputMaybe<Task_Bool_Exp_>;
};


export type Subscription_RootTaxonomyPortfolioReportArgs_ = {
  distinct_on?: InputMaybe<Array<TaxonomyPortfolioReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaxonomyPortfolioReport_Order_By_>>;
  where?: InputMaybe<TaxonomyPortfolioReport_Bool_Exp_>;
};


export type Subscription_RootTaxonomyPortfolioReport_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TaxonomyPortfolioReport_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TaxonomyPortfolioReport_Order_By_>>;
  where?: InputMaybe<TaxonomyPortfolioReport_Bool_Exp_>;
};


export type Subscription_RootTaxonomyPortfolioReport_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTaxonomyPortfolioReport_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TaxonomyPortfolioReport_Stream_Cursor_Input_>>;
  where?: InputMaybe<TaxonomyPortfolioReport_Bool_Exp_>;
};


export type Subscription_RootThreadArgs_ = {
  distinct_on?: InputMaybe<Array<Thread_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Thread_Order_By_>>;
  where?: InputMaybe<Thread_Bool_Exp_>;
};


export type Subscription_RootThreadSubscriberArgs_ = {
  distinct_on?: InputMaybe<Array<ThreadSubscriber_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ThreadSubscriber_Order_By_>>;
  where?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
};


export type Subscription_RootThreadSubscriber_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ThreadSubscriber_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ThreadSubscriber_Order_By_>>;
  where?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
};


export type Subscription_RootThreadSubscriber_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootThreadSubscriber_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ThreadSubscriber_Stream_Cursor_Input_>>;
  where?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
};


export type Subscription_RootThread_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Thread_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Thread_Order_By_>>;
  where?: InputMaybe<Thread_Bool_Exp_>;
};


export type Subscription_RootThread_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootThread_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Thread_Stream_Cursor_Input_>>;
  where?: InputMaybe<Thread_Bool_Exp_>;
};


export type Subscription_RootTotalComparisonFinancialsArgs_ = {
  distinct_on?: InputMaybe<Array<TotalComparisonFinancials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TotalComparisonFinancials_Order_By_>>;
  where?: InputMaybe<TotalComparisonFinancials_Bool_Exp_>;
};


export type Subscription_RootTotalComparisonFinancials_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TotalComparisonFinancials_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TotalComparisonFinancials_Order_By_>>;
  where?: InputMaybe<TotalComparisonFinancials_Bool_Exp_>;
};


export type Subscription_RootTotalComparisonFinancials_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TotalComparisonFinancials_Stream_Cursor_Input_>>;
  where?: InputMaybe<TotalComparisonFinancials_Bool_Exp_>;
};


export type Subscription_RootTriggerTypesArgs_ = {
  distinct_on?: InputMaybe<Array<TriggerTypes_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TriggerTypes_Order_By_>>;
  where?: InputMaybe<TriggerTypes_Bool_Exp_>;
};


export type Subscription_RootTriggerTypes_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<TriggerTypes_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TriggerTypes_Order_By_>>;
  where?: InputMaybe<TriggerTypes_Bool_Exp_>;
};


export type Subscription_RootTriggerTypes_By_PkArgs_ = {
  type: Scalars['String']['input'];
};


export type Subscription_RootTriggerTypes_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TriggerTypes_Stream_Cursor_Input_>>;
  where?: InputMaybe<TriggerTypes_Bool_Exp_>;
};


export type Subscription_RootUserNotificationArgs_ = {
  distinct_on?: InputMaybe<Array<UserNotification_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserNotification_Order_By_>>;
  where?: InputMaybe<UserNotification_Bool_Exp_>;
};


export type Subscription_RootUserNotification_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<UserNotification_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserNotification_Order_By_>>;
  where?: InputMaybe<UserNotification_Bool_Exp_>;
};


export type Subscription_RootUserNotification_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUserNotification_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserNotification_Stream_Cursor_Input_>>;
  where?: InputMaybe<UserNotification_Bool_Exp_>;
};


export type Subscription_RootUserRoleArgs_ = {
  distinct_on?: InputMaybe<Array<UserRole_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_Order_By_>>;
  where?: InputMaybe<UserRole_Bool_Exp_>;
};


export type Subscription_RootUserRole_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<UserRole_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserRole_Order_By_>>;
  where?: InputMaybe<UserRole_Bool_Exp_>;
};


export type Subscription_RootUserRole_By_PkArgs_ = {
  role: Scalars['String']['input'];
};


export type Subscription_RootUserRole_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserRole_Stream_Cursor_Input_>>;
  where?: InputMaybe<UserRole_Bool_Exp_>;
};


export type Subscription_RootUserSessionMetadataArgs_ = {
  distinct_on?: InputMaybe<Array<UserSessionMetadata_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserSessionMetadata_Order_By_>>;
  where?: InputMaybe<UserSessionMetadata_Bool_Exp_>;
};


export type Subscription_RootUserSessionMetadata_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<UserSessionMetadata_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserSessionMetadata_Order_By_>>;
  where?: InputMaybe<UserSessionMetadata_Bool_Exp_>;
};


export type Subscription_RootUserSessionMetadata_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUserSessionMetadata_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserSessionMetadata_Stream_Cursor_Input_>>;
  where?: InputMaybe<UserSessionMetadata_Bool_Exp_>;
};


export type Subscription_RootWebsocketTestArgs_ = {
  distinct_on?: InputMaybe<Array<WebsocketTest_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<WebsocketTest_Order_By_>>;
  where?: InputMaybe<WebsocketTest_Bool_Exp_>;
};


export type Subscription_RootWebsocketTest_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<WebsocketTest_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<WebsocketTest_Order_By_>>;
  where?: InputMaybe<WebsocketTest_Bool_Exp_>;
};


export type Subscription_RootWebsocketTest_By_PkArgs_ = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootWebsocketTest_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<WebsocketTest_Stream_Cursor_Input_>>;
  where?: InputMaybe<WebsocketTest_Bool_Exp_>;
};


export type Subscription_RootAuthProviderArgs_ = {
  id: Scalars['String']['input'];
};


export type Subscription_RootAuthProviderRequestArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthProviderRequestsArgs_ = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By_>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp_>;
};


export type Subscription_RootAuthProviderRequestsAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthProviderRequests_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviderRequests_Order_By_>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp_>;
};


export type Subscription_RootAuthProviderRequests_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthProviderRequests_Stream_Cursor_Input_>>;
  where?: InputMaybe<AuthProviderRequests_Bool_Exp_>;
};


export type Subscription_RootAuthProvidersArgs_ = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By_>>;
  where?: InputMaybe<AuthProviders_Bool_Exp_>;
};


export type Subscription_RootAuthProvidersAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthProviders_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthProviders_Order_By_>>;
  where?: InputMaybe<AuthProviders_Bool_Exp_>;
};


export type Subscription_RootAuthProviders_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthProviders_Stream_Cursor_Input_>>;
  where?: InputMaybe<AuthProviders_Bool_Exp_>;
};


export type Subscription_RootAuthRefreshTokenArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthRefreshTokenTypeArgs_ = {
  value: Scalars['String']['input'];
};


export type Subscription_RootAuthRefreshTokenTypesArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By_>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp_>;
};


export type Subscription_RootAuthRefreshTokenTypesAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokenTypes_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokenTypes_Order_By_>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp_>;
};


export type Subscription_RootAuthRefreshTokenTypes_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRefreshTokenTypes_Stream_Cursor_Input_>>;
  where?: InputMaybe<AuthRefreshTokenTypes_Bool_Exp_>;
};


export type Subscription_RootAuthRefreshTokensArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By_>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp_>;
};


export type Subscription_RootAuthRefreshTokensAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By_>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp_>;
};


export type Subscription_RootAuthRefreshTokens_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRefreshTokens_Stream_Cursor_Input_>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp_>;
};


export type Subscription_RootAuthRoleArgs_ = {
  role: Scalars['String']['input'];
};


export type Subscription_RootAuthRolesArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By_>>;
  where?: InputMaybe<AuthRoles_Bool_Exp_>;
};


export type Subscription_RootAuthRolesAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRoles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRoles_Order_By_>>;
  where?: InputMaybe<AuthRoles_Bool_Exp_>;
};


export type Subscription_RootAuthRoles_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthRoles_Stream_Cursor_Input_>>;
  where?: InputMaybe<AuthRoles_Bool_Exp_>;
};


export type Subscription_RootAuthUserProviderArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthUserProvidersArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By_>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp_>;
};


export type Subscription_RootAuthUserProvidersAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By_>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp_>;
};


export type Subscription_RootAuthUserProviders_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthUserProviders_Stream_Cursor_Input_>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp_>;
};


export type Subscription_RootAuthUserRoleArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthUserRolesArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By_>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp_>;
};


export type Subscription_RootAuthUserRolesAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By_>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp_>;
};


export type Subscription_RootAuthUserRoles_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthUserRoles_Stream_Cursor_Input_>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp_>;
};


export type Subscription_RootAuthUserSecurityKeyArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootAuthUserSecurityKeysArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By_>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp_>;
};


export type Subscription_RootAuthUserSecurityKeysAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By_>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp_>;
};


export type Subscription_RootAuthUserSecurityKeys_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AuthUserSecurityKeys_Stream_Cursor_Input_>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp_>;
};


export type Subscription_RootBucketArgs_ = {
  id: Scalars['String']['input'];
};


export type Subscription_RootBucketsArgs_ = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By_>>;
  where?: InputMaybe<Buckets_Bool_Exp_>;
};


export type Subscription_RootBucketsAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Buckets_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Buckets_Order_By_>>;
  where?: InputMaybe<Buckets_Bool_Exp_>;
};


export type Subscription_RootBuckets_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Buckets_Stream_Cursor_Input_>>;
  where?: InputMaybe<Buckets_Bool_Exp_>;
};


export type Subscription_RootEsrs_ActionReportingUnitArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionReportingUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionReportingUnit_Order_By_>>;
  where?: InputMaybe<Esrs_ActionReportingUnit_Bool_Exp_>;
};


export type Subscription_RootEsrs_ActionReportingUnit_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionReportingUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionReportingUnit_Order_By_>>;
  where?: InputMaybe<Esrs_ActionReportingUnit_Bool_Exp_>;
};


export type Subscription_RootEsrs_ActionReportingUnit_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_ActionReportingUnit_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_ActionReportingUnit_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_ActionReportingUnit_Bool_Exp_>;
};


export type Subscription_RootEsrs_ActionSubsidiaryArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionSubsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionSubsidiary_Order_By_>>;
  where?: InputMaybe<Esrs_ActionSubsidiary_Bool_Exp_>;
};


export type Subscription_RootEsrs_ActionSubsidiary_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionSubsidiary_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionSubsidiary_Order_By_>>;
  where?: InputMaybe<Esrs_ActionSubsidiary_Bool_Exp_>;
};


export type Subscription_RootEsrs_ActionSubsidiary_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_ActionSubsidiary_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_ActionSubsidiary_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_ActionSubsidiary_Bool_Exp_>;
};


export type Subscription_RootEsrs_ActionTargetArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionTarget_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionTarget_Order_By_>>;
  where?: InputMaybe<Esrs_ActionTarget_Bool_Exp_>;
};


export type Subscription_RootEsrs_ActionTarget_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ActionTarget_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ActionTarget_Order_By_>>;
  where?: InputMaybe<Esrs_ActionTarget_Bool_Exp_>;
};


export type Subscription_RootEsrs_ActionTarget_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_ActionTarget_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_ActionTarget_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_ActionTarget_Bool_Exp_>;
};


export type Subscription_RootEsrs_ActionsArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Actions_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Actions_Order_By_>>;
  where?: InputMaybe<Esrs_Actions_Bool_Exp_>;
};


export type Subscription_RootEsrs_Actions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Actions_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Actions_Order_By_>>;
  where?: InputMaybe<Esrs_Actions_Bool_Exp_>;
};


export type Subscription_RootEsrs_Actions_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_Actions_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_Actions_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_Actions_Bool_Exp_>;
};


export type Subscription_RootEsrs_AnswerArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Answer_Order_By_>>;
  where?: InputMaybe<Esrs_Answer_Bool_Exp_>;
};


export type Subscription_RootEsrs_Answer_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Answer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Answer_Order_By_>>;
  where?: InputMaybe<Esrs_Answer_Bool_Exp_>;
};


export type Subscription_RootEsrs_Answer_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_Answer_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_Answer_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_Answer_Bool_Exp_>;
};


export type Subscription_RootEsrs_AssessmentCurrencyConversionArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_AssessmentCurrencyConversion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_AssessmentCurrencyConversion_Order_By_>>;
  where?: InputMaybe<Esrs_AssessmentCurrencyConversion_Bool_Exp_>;
};


export type Subscription_RootEsrs_AssessmentCurrencyConversion_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_AssessmentCurrencyConversion_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_AssessmentCurrencyConversion_Order_By_>>;
  where?: InputMaybe<Esrs_AssessmentCurrencyConversion_Bool_Exp_>;
};


export type Subscription_RootEsrs_AssessmentCurrencyConversion_By_PkArgs_ = {
  assessmentId: Scalars['uuid']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type Subscription_RootEsrs_AssessmentCurrencyConversion_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_AssessmentCurrencyConversion_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_AssessmentCurrencyConversion_Bool_Exp_>;
};


export type Subscription_RootEsrs_BaselineArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Baseline_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Baseline_Order_By_>>;
  where?: InputMaybe<Esrs_Baseline_Bool_Exp_>;
};


export type Subscription_RootEsrs_Baseline_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Baseline_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Baseline_Order_By_>>;
  where?: InputMaybe<Esrs_Baseline_Bool_Exp_>;
};


export type Subscription_RootEsrs_Baseline_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_Baseline_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_Baseline_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_Baseline_Bool_Exp_>;
};


export type Subscription_RootEsrs_CompanyIntegrationArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_CompanyIntegration_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_CompanyIntegration_Order_By_>>;
  where?: InputMaybe<Esrs_CompanyIntegration_Bool_Exp_>;
};


export type Subscription_RootEsrs_CompanyIntegration_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_CompanyIntegration_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_CompanyIntegration_Order_By_>>;
  where?: InputMaybe<Esrs_CompanyIntegration_Bool_Exp_>;
};


export type Subscription_RootEsrs_CompanyIntegration_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_CompanyIntegration_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_CompanyIntegration_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_CompanyIntegration_Bool_Exp_>;
};


export type Subscription_RootEsrs_DatapointArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Datapoint_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Datapoint_Order_By_>>;
  where?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
};


export type Subscription_RootEsrs_DatapointChoiceArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointChoice_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointChoice_Bool_Exp_>;
};


export type Subscription_RootEsrs_DatapointChoice_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointChoice_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointChoice_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointChoice_Bool_Exp_>;
};


export type Subscription_RootEsrs_DatapointChoice_By_PkArgs_ = {
  choiceRef: Scalars['String']['input'];
  datapointId: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_DatapointChoice_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_DatapointChoice_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_DatapointChoice_Bool_Exp_>;
};


export type Subscription_RootEsrs_DatapointMdrmArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointMdrm_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointMdrm_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointMdrm_Bool_Exp_>;
};


export type Subscription_RootEsrs_DatapointMdrm_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointMdrm_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointMdrm_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointMdrm_Bool_Exp_>;
};


export type Subscription_RootEsrs_DatapointMdrm_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_DatapointMdrm_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_DatapointMdrm_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_DatapointMdrm_Bool_Exp_>;
};


export type Subscription_RootEsrs_DatapointTagArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointTag_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointTag_Bool_Exp_>;
};


export type Subscription_RootEsrs_DatapointTag_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DatapointTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DatapointTag_Order_By_>>;
  where?: InputMaybe<Esrs_DatapointTag_Bool_Exp_>;
};


export type Subscription_RootEsrs_DatapointTag_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_DatapointTag_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_DatapointTag_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_DatapointTag_Bool_Exp_>;
};


export type Subscription_RootEsrs_Datapoint_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Datapoint_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Datapoint_Order_By_>>;
  where?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
};


export type Subscription_RootEsrs_Datapoint_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_Datapoint_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_Datapoint_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_Datapoint_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_ActionBusinessUnitArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_ActionBusinessUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_ActionBusinessUnit_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_ActionBusinessUnit_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_ActionBusinessUnit_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_ActionBusinessUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_ActionBusinessUnit_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_ActionBusinessUnit_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_ActionBusinessUnit_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_Deprecated_ActionBusinessUnit_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_Deprecated_ActionBusinessUnit_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_Deprecated_ActionBusinessUnit_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_BusinessUnitEsrsAssessmentArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_BusinessUnitEsrsAssessment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_BusinessUnitEsrsAssessment_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_BusinessUnitEsrsAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_Deprecated_BusinessUnitEsrsAssessment_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_Deprecated_BusinessUnitEsrsAssessment_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_CompanyMaterialityAssessmentArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_CompanyMaterialityAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_CompanyMaterialityAssessment_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_CompanyMaterialityAssessment_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_CompanyMaterialityAssessment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_CompanyMaterialityAssessment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_CompanyMaterialityAssessment_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_CompanyMaterialityAssessment_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_CompanyMaterialityAssessment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_Deprecated_CompanyMaterialityAssessment_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_Deprecated_CompanyMaterialityAssessment_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_Deprecated_CompanyMaterialityAssessment_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_EsrsMdrmArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_EsrsMdrm_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_EsrsMdrm_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_EsrsMdrm_By_PkArgs_ = {
  datapointId: Scalars['uuid']['input'];
  metricRef: Scalars['String']['input'];
};


export type Subscription_RootEsrs_Deprecated_EsrsMdrm_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_Deprecated_EsrsMdrm_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_Deprecated_EsrsMdrm_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_MaterialDisclosureRequirementArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_MaterialDisclosureRequirement_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_MaterialDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_MaterialDisclosureRequirement_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_Deprecated_MaterialDisclosureRequirement_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_Deprecated_MaterialDisclosureRequirement_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_MetricAnswerArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_MetricAnswer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_MetricAnswer_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_MetricAnswer_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_MetricAnswer_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Deprecated_MetricAnswer_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Deprecated_MetricAnswer_Order_By_>>;
  where?: InputMaybe<Esrs_Deprecated_MetricAnswer_Bool_Exp_>;
};


export type Subscription_RootEsrs_Deprecated_MetricAnswer_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_Deprecated_MetricAnswer_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_Deprecated_MetricAnswer_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_Deprecated_MetricAnswer_Bool_Exp_>;
};


export type Subscription_RootEsrs_DisclosureRequirementAttachmentArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Order_By_>>;
  where?: InputMaybe<Esrs_DisclosureRequirementAttachment_Bool_Exp_>;
};


export type Subscription_RootEsrs_DisclosureRequirementAttachment_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_DisclosureRequirementAttachment_Order_By_>>;
  where?: InputMaybe<Esrs_DisclosureRequirementAttachment_Bool_Exp_>;
};


export type Subscription_RootEsrs_DisclosureRequirementAttachment_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_DisclosureRequirementAttachment_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_DisclosureRequirementAttachment_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_DisclosureRequirementAttachment_Bool_Exp_>;
};


export type Subscription_RootEsrs_EsrsAssessmentCompanyIntegrationArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>;
};


export type Subscription_RootEsrs_EsrsAssessmentCompanyIntegrationRuArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_>;
};


export type Subscription_RootEsrs_EsrsAssessmentCompanyIntegrationRu_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegrationRu_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_>;
};


export type Subscription_RootEsrs_EsrsAssessmentCompanyIntegrationRu_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_EsrsAssessmentCompanyIntegrationRu_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegrationRu_Bool_Exp_>;
};


export type Subscription_RootEsrs_EsrsAssessmentCompanyIntegration_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsAssessmentCompanyIntegration_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>;
};


export type Subscription_RootEsrs_EsrsAssessmentCompanyIntegration_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_EsrsAssessmentCompanyIntegration_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_EsrsAssessmentCompanyIntegration_Bool_Exp_>;
};


export type Subscription_RootEsrs_EsrsMetricHierarchyStatusArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsMetricHierarchyStatus_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsMetricHierarchyStatus_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsMetricHierarchyStatus_Bool_Exp_>;
};


export type Subscription_RootEsrs_EsrsMetricHierarchyStatus_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_EsrsMetricHierarchyStatus_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_EsrsMetricHierarchyStatus_Order_By_>>;
  where?: InputMaybe<Esrs_EsrsMetricHierarchyStatus_Bool_Exp_>;
};


export type Subscription_RootEsrs_EsrsMetricHierarchyStatus_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_EsrsMetricHierarchyStatus_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_EsrsMetricHierarchyStatus_Bool_Exp_>;
};


export type Subscription_RootEsrs_MaterialMetricArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetric_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
};


export type Subscription_RootEsrs_MaterialMetricTagArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetricTag_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
};


export type Subscription_RootEsrs_MaterialMetricTag_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetricTag_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetricTag_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
};


export type Subscription_RootEsrs_MaterialMetricTag_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_MaterialMetricTag_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_MaterialMetricTag_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_MaterialMetricTag_Bool_Exp_>;
};


export type Subscription_RootEsrs_MaterialMetric_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialMetric_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetric_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
};


export type Subscription_RootEsrs_MaterialMetric_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_MaterialMetric_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_MaterialMetric_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
};


export type Subscription_RootEsrs_MaterialStandardArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialStandard_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
};


export type Subscription_RootEsrs_MaterialStandard_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialStandard_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialStandard_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
};


export type Subscription_RootEsrs_MaterialStandard_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_MaterialStandard_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_MaterialStandard_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_MaterialStandard_Bool_Exp_>;
};


export type Subscription_RootEsrs_MaterialTagValueArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialTagValue_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialTagValue_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialTagValue_Bool_Exp_>;
};


export type Subscription_RootEsrs_MaterialTagValue_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MaterialTagValue_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialTagValue_Order_By_>>;
  where?: InputMaybe<Esrs_MaterialTagValue_Bool_Exp_>;
};


export type Subscription_RootEsrs_MaterialTagValue_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_MaterialTagValue_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_MaterialTagValue_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_MaterialTagValue_Bool_Exp_>;
};


export type Subscription_RootEsrs_MetricDependencyClosureArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MetricDependencyClosure_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MetricDependencyClosure_Order_By_>>;
  where?: InputMaybe<Esrs_MetricDependencyClosure_Bool_Exp_>;
};


export type Subscription_RootEsrs_MetricDependencyClosure_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MetricDependencyClosure_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MetricDependencyClosure_Order_By_>>;
  where?: InputMaybe<Esrs_MetricDependencyClosure_Bool_Exp_>;
};


export type Subscription_RootEsrs_MetricDependencyClosure_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_MetricDependencyClosure_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_MetricDependencyClosure_Bool_Exp_>;
};


export type Subscription_RootEsrs_MetricRelatedDisclosureRequirementArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Bool_Exp_>;
};


export type Subscription_RootEsrs_MetricRelatedDisclosureRequirement_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MetricRelatedDisclosureRequirement_Order_By_>>;
  where?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Bool_Exp_>;
};


export type Subscription_RootEsrs_MetricRelatedDisclosureRequirement_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_MetricRelatedDisclosureRequirement_Bool_Exp_>;
};


export type Subscription_RootEsrs_MilestoneArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Milestone_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Milestone_Order_By_>>;
  where?: InputMaybe<Esrs_Milestone_Bool_Exp_>;
};


export type Subscription_RootEsrs_MilestoneResultArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MilestoneResult_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MilestoneResult_Order_By_>>;
  where?: InputMaybe<Esrs_MilestoneResult_Bool_Exp_>;
};


export type Subscription_RootEsrs_MilestoneResult_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_MilestoneResult_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MilestoneResult_Order_By_>>;
  where?: InputMaybe<Esrs_MilestoneResult_Bool_Exp_>;
};


export type Subscription_RootEsrs_MilestoneResult_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_MilestoneResult_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_MilestoneResult_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_MilestoneResult_Bool_Exp_>;
};


export type Subscription_RootEsrs_Milestone_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Milestone_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Milestone_Order_By_>>;
  where?: InputMaybe<Esrs_Milestone_Bool_Exp_>;
};


export type Subscription_RootEsrs_Milestone_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_Milestone_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_Milestone_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_Milestone_Bool_Exp_>;
};


export type Subscription_RootEsrs_PolicyArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Policy_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Policy_Order_By_>>;
  where?: InputMaybe<Esrs_Policy_Bool_Exp_>;
};


export type Subscription_RootEsrs_Policy_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Policy_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Policy_Order_By_>>;
  where?: InputMaybe<Esrs_Policy_Bool_Exp_>;
};


export type Subscription_RootEsrs_Policy_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_Policy_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_Policy_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_Policy_Bool_Exp_>;
};


export type Subscription_RootEsrs_ReportingUnitArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ReportingUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ReportingUnit_Order_By_>>;
  where?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
};


export type Subscription_RootEsrs_ReportingUnitLineageArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ReportingUnitLineage_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ReportingUnitLineage_Order_By_>>;
  where?: InputMaybe<Esrs_ReportingUnitLineage_Bool_Exp_>;
};


export type Subscription_RootEsrs_ReportingUnitLineage_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ReportingUnitLineage_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ReportingUnitLineage_Order_By_>>;
  where?: InputMaybe<Esrs_ReportingUnitLineage_Bool_Exp_>;
};


export type Subscription_RootEsrs_ReportingUnitLineage_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_ReportingUnitLineage_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_ReportingUnitLineage_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_ReportingUnitLineage_Bool_Exp_>;
};


export type Subscription_RootEsrs_ReportingUnit_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_ReportingUnit_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_ReportingUnit_Order_By_>>;
  where?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
};


export type Subscription_RootEsrs_ReportingUnit_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_ReportingUnit_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_ReportingUnit_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_ReportingUnit_Bool_Exp_>;
};


export type Subscription_RootEsrs_TargetArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Target_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Target_Order_By_>>;
  where?: InputMaybe<Esrs_Target_Bool_Exp_>;
};


export type Subscription_RootEsrs_Target_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Esrs_Target_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Target_Order_By_>>;
  where?: InputMaybe<Esrs_Target_Bool_Exp_>;
};


export type Subscription_RootEsrs_Target_By_PkArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEsrs_Target_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Esrs_Target_Stream_Cursor_Input_>>;
  where?: InputMaybe<Esrs_Target_Bool_Exp_>;
};


export type Subscription_RootFileArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootFilesArgs_ = {
  distinct_on?: InputMaybe<Array<Files_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By_>>;
  where?: InputMaybe<Files_Bool_Exp_>;
};


export type Subscription_RootFilesAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Files_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Files_Order_By_>>;
  where?: InputMaybe<Files_Bool_Exp_>;
};


export type Subscription_RootFiles_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Files_Stream_Cursor_Input_>>;
  where?: InputMaybe<Files_Bool_Exp_>;
};


export type Subscription_RootUserArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUsersArgs_ = {
  distinct_on?: InputMaybe<Array<Users_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By_>>;
  where?: InputMaybe<Users_Bool_Exp_>;
};


export type Subscription_RootUsersAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Users_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By_>>;
  where?: InputMaybe<Users_Bool_Exp_>;
};


export type Subscription_RootUsers_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input_>>;
  where?: InputMaybe<Users_Bool_Exp_>;
};


export type Subscription_RootVirusArgs_ = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootVirus_StreamArgs_ = {
  batch_size: Scalars['Int']['input'];
  cursor: Array<InputMaybe<Virus_Stream_Cursor_Input_>>;
  where?: InputMaybe<Virus_Bool_Exp_>;
};


export type Subscription_RootVirusesArgs_ = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By_>>;
  where?: InputMaybe<Virus_Bool_Exp_>;
};


export type Subscription_RootVirusesAggregateArgs_ = {
  distinct_on?: InputMaybe<Array<Virus_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Virus_Order_By_>>;
  where?: InputMaybe<Virus_Bool_Exp_>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp_ = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp_ = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type Users_ = {
  __typename?: 'users';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  avatarUrl: Scalars['String']['output'];
  /** An array relationship */
  companyUsers: Array<CompanyUser_>;
  /** An aggregate relationship */
  companyUsers_aggregate: CompanyUser_Aggregate_;
  /** An object relationship */
  compassPAT?: Maybe<CompassPat_>;
  createdAt: Scalars['timestamptz']['output'];
  currentChallenge?: Maybe<Scalars['String']['output']>;
  defaultRole: Scalars['String']['output'];
  /** An object relationship */
  defaultRoleByRole: AuthRoles_;
  disabled: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  email?: Maybe<Scalars['citext']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  invitations: Array<CompanyInvitation_>;
  /** An aggregate relationship */
  invitations_aggregate: CompanyInvitation_Aggregate_;
  isAnonymous: Scalars['Boolean']['output'];
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  locale: Scalars['String']['output'];
  metadata?: Maybe<Scalars['jsonb']['output']>;
  newEmail?: Maybe<Scalars['citext']['output']>;
  /** An array relationship */
  notifications: Array<UserNotification_>;
  /** An aggregate relationship */
  notifications_aggregate: UserNotification_Aggregate_;
  otpHash?: Maybe<Scalars['String']['output']>;
  otpHashExpiresAt: Scalars['timestamptz']['output'];
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberVerified: Scalars['Boolean']['output'];
  /** An array relationship */
  refreshTokens: Array<AuthRefreshTokens_>;
  /** An aggregate relationship */
  refreshTokens_aggregate: AuthRefreshTokens_Aggregate_;
  /** An array relationship */
  roles: Array<AuthUserRoles_>;
  /** An aggregate relationship */
  roles_aggregate: AuthUserRoles_Aggregate_;
  /** An array relationship */
  securityKeys: Array<AuthUserSecurityKeys_>;
  /** An aggregate relationship */
  securityKeys_aggregate: AuthUserSecurityKeys_Aggregate_;
  /** An array relationship */
  threadSubscriptions: Array<ThreadSubscriber_>;
  /** An aggregate relationship */
  threadSubscriptions_aggregate: ThreadSubscriber_Aggregate_;
  ticket?: Maybe<Scalars['String']['output']>;
  ticketExpiresAt: Scalars['timestamptz']['output'];
  totpSecret?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userProviders: Array<AuthUserProviders_>;
  /** An aggregate relationship */
  userProviders_aggregate: AuthUserProviders_Aggregate_;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersCompanyUsersArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyUser_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyUser_Order_By_>>;
  where?: InputMaybe<CompanyUser_Bool_Exp_>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersCompanyUsers_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyUser_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyUser_Order_By_>>;
  where?: InputMaybe<CompanyUser_Bool_Exp_>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersInvitationsArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyInvitation_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyInvitation_Order_By_>>;
  where?: InputMaybe<CompanyInvitation_Bool_Exp_>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersInvitations_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<CompanyInvitation_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyInvitation_Order_By_>>;
  where?: InputMaybe<CompanyInvitation_Bool_Exp_>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersMetadataArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersNotificationsArgs_ = {
  distinct_on?: InputMaybe<Array<UserNotification_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserNotification_Order_By_>>;
  where?: InputMaybe<UserNotification_Bool_Exp_>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersNotifications_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<UserNotification_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<UserNotification_Order_By_>>;
  where?: InputMaybe<UserNotification_Bool_Exp_>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokensArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By_>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp_>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRefreshTokens_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthRefreshTokens_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthRefreshTokens_Order_By_>>;
  where?: InputMaybe<AuthRefreshTokens_Bool_Exp_>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRolesArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By_>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp_>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersRoles_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserRoles_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By_>>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp_>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeysArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By_>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp_>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersSecurityKeys_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserSecurityKeys_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserSecurityKeys_Order_By_>>;
  where?: InputMaybe<AuthUserSecurityKeys_Bool_Exp_>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersThreadSubscriptionsArgs_ = {
  distinct_on?: InputMaybe<Array<ThreadSubscriber_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ThreadSubscriber_Order_By_>>;
  where?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersThreadSubscriptions_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<ThreadSubscriber_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ThreadSubscriber_Order_By_>>;
  where?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProvidersArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By_>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp_>;
};


/** User account information. Don't modify its structure as Hasura Auth relies on it to function properly. */
export type UsersUserProviders_AggregateArgs_ = {
  distinct_on?: InputMaybe<Array<AuthUserProviders_Select_Column_>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserProviders_Order_By_>>;
  where?: InputMaybe<AuthUserProviders_Bool_Exp_>;
};

/** aggregated selection of "auth.users" */
export type Users_Aggregate_ = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields_>;
  nodes: Array<Users_>;
};

export type Users_Aggregate_Bool_Exp_ = {
  bool_and?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_And_>;
  bool_or?: InputMaybe<Users_Aggregate_Bool_Exp_Bool_Or_>;
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count_>;
};

export type Users_Aggregate_Bool_Exp_Bool_And_ = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Users_Aggregate_Bool_Exp_Bool_Or_ = {
  arguments: Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp_>;
  predicate: Boolean_Comparison_Exp_;
};

export type Users_Aggregate_Bool_Exp_Count_ = {
  arguments?: InputMaybe<Array<Users_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Users_Bool_Exp_>;
  predicate: Int_Comparison_Exp_;
};

/** aggregate fields of "auth.users" */
export type Users_Aggregate_Fields_ = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Users_Max_Fields_>;
  min?: Maybe<Users_Min_Fields_>;
};


/** aggregate fields of "auth.users" */
export type Users_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Users_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "auth.users" */
export type Users_Aggregate_Order_By_ = {
  count?: InputMaybe<Order_By_>;
  max?: InputMaybe<Users_Max_Order_By_>;
  min?: InputMaybe<Users_Min_Order_By_>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input_ = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "auth.users" */
export type Users_Arr_Rel_Insert_Input_ = {
  data: Array<Users_Insert_Input_>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict_>;
};

/** Boolean expression to filter rows from the table "auth.users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp_ = {
  _and?: InputMaybe<Array<Users_Bool_Exp_>>;
  _not?: InputMaybe<Users_Bool_Exp_>;
  _or?: InputMaybe<Array<Users_Bool_Exp_>>;
  activeMfaType?: InputMaybe<String_Comparison_Exp_>;
  avatarUrl?: InputMaybe<String_Comparison_Exp_>;
  companyUsers?: InputMaybe<CompanyUser_Bool_Exp_>;
  companyUsers_aggregate?: InputMaybe<CompanyUser_Aggregate_Bool_Exp_>;
  compassPAT?: InputMaybe<CompassPat_Bool_Exp_>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  currentChallenge?: InputMaybe<String_Comparison_Exp_>;
  defaultRole?: InputMaybe<String_Comparison_Exp_>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Bool_Exp_>;
  disabled?: InputMaybe<Boolean_Comparison_Exp_>;
  displayName?: InputMaybe<String_Comparison_Exp_>;
  email?: InputMaybe<Citext_Comparison_Exp_>;
  emailVerified?: InputMaybe<Boolean_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  invitations?: InputMaybe<CompanyInvitation_Bool_Exp_>;
  invitations_aggregate?: InputMaybe<CompanyInvitation_Aggregate_Bool_Exp_>;
  isAnonymous?: InputMaybe<Boolean_Comparison_Exp_>;
  lastSeen?: InputMaybe<Timestamptz_Comparison_Exp_>;
  locale?: InputMaybe<String_Comparison_Exp_>;
  metadata?: InputMaybe<Jsonb_Comparison_Exp_>;
  newEmail?: InputMaybe<Citext_Comparison_Exp_>;
  notifications?: InputMaybe<UserNotification_Bool_Exp_>;
  notifications_aggregate?: InputMaybe<UserNotification_Aggregate_Bool_Exp_>;
  otpHash?: InputMaybe<String_Comparison_Exp_>;
  otpHashExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  otpMethodLastUsed?: InputMaybe<String_Comparison_Exp_>;
  passwordHash?: InputMaybe<String_Comparison_Exp_>;
  phoneNumber?: InputMaybe<String_Comparison_Exp_>;
  phoneNumberVerified?: InputMaybe<Boolean_Comparison_Exp_>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Bool_Exp_>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Bool_Exp_>;
  roles?: InputMaybe<AuthUserRoles_Bool_Exp_>;
  roles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Bool_Exp_>;
  securityKeys?: InputMaybe<AuthUserSecurityKeys_Bool_Exp_>;
  securityKeys_aggregate?: InputMaybe<AuthUserSecurityKeys_Aggregate_Bool_Exp_>;
  threadSubscriptions?: InputMaybe<ThreadSubscriber_Bool_Exp_>;
  threadSubscriptions_aggregate?: InputMaybe<ThreadSubscriber_Aggregate_Bool_Exp_>;
  ticket?: InputMaybe<String_Comparison_Exp_>;
  ticketExpiresAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  totpSecret?: InputMaybe<String_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  userProviders?: InputMaybe<AuthUserProviders_Bool_Exp_>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Bool_Exp_>;
};

/** unique or primary key constraints on table "auth.users" */
export enum Users_Constraint_ {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey_ = 'users_email_key',
  /** unique or primary key constraint on columns "phone_number" */
  UsersPhoneNumberKey_ = 'users_phone_number_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey_ = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input_ = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input_ = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input_ = {
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "auth.users" */
export type Users_Insert_Input_ = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  companyUsers?: InputMaybe<CompanyUser_Arr_Rel_Insert_Input_>;
  compassPAT?: InputMaybe<CompassPat_Obj_Rel_Insert_Input_>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currentChallenge?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<Scalars['String']['input']>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Obj_Rel_Insert_Input_>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  invitations?: InputMaybe<CompanyInvitation_Arr_Rel_Insert_Input_>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  newEmail?: InputMaybe<Scalars['citext']['input']>;
  notifications?: InputMaybe<UserNotification_Arr_Rel_Insert_Input_>;
  otpHash?: InputMaybe<Scalars['String']['input']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  refreshTokens?: InputMaybe<AuthRefreshTokens_Arr_Rel_Insert_Input_>;
  roles?: InputMaybe<AuthUserRoles_Arr_Rel_Insert_Input_>;
  securityKeys?: InputMaybe<AuthUserSecurityKeys_Arr_Rel_Insert_Input_>;
  threadSubscriptions?: InputMaybe<ThreadSubscriber_Arr_Rel_Insert_Input_>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userProviders?: InputMaybe<AuthUserProviders_Arr_Rel_Insert_Input_>;
};

/** aggregate max on columns */
export type Users_Max_Fields_ = {
  __typename?: 'users_max_fields';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currentChallenge?: Maybe<Scalars['String']['output']>;
  defaultRole?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  newEmail?: Maybe<Scalars['citext']['output']>;
  otpHash?: Maybe<Scalars['String']['output']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Scalars['String']['output']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  totpSecret?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "auth.users" */
export type Users_Max_Order_By_ = {
  activeMfaType?: InputMaybe<Order_By_>;
  avatarUrl?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  currentChallenge?: InputMaybe<Order_By_>;
  defaultRole?: InputMaybe<Order_By_>;
  displayName?: InputMaybe<Order_By_>;
  email?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  lastSeen?: InputMaybe<Order_By_>;
  locale?: InputMaybe<Order_By_>;
  newEmail?: InputMaybe<Order_By_>;
  otpHash?: InputMaybe<Order_By_>;
  otpHashExpiresAt?: InputMaybe<Order_By_>;
  otpMethodLastUsed?: InputMaybe<Order_By_>;
  passwordHash?: InputMaybe<Order_By_>;
  phoneNumber?: InputMaybe<Order_By_>;
  ticket?: InputMaybe<Order_By_>;
  ticketExpiresAt?: InputMaybe<Order_By_>;
  totpSecret?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** aggregate min on columns */
export type Users_Min_Fields_ = {
  __typename?: 'users_min_fields';
  activeMfaType?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  currentChallenge?: Maybe<Scalars['String']['output']>;
  defaultRole?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['citext']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lastSeen?: Maybe<Scalars['timestamptz']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  newEmail?: Maybe<Scalars['citext']['output']>;
  otpHash?: Maybe<Scalars['String']['output']>;
  otpHashExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  otpMethodLastUsed?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Scalars['String']['output']>;
  ticketExpiresAt?: Maybe<Scalars['timestamptz']['output']>;
  totpSecret?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "auth.users" */
export type Users_Min_Order_By_ = {
  activeMfaType?: InputMaybe<Order_By_>;
  avatarUrl?: InputMaybe<Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  currentChallenge?: InputMaybe<Order_By_>;
  defaultRole?: InputMaybe<Order_By_>;
  displayName?: InputMaybe<Order_By_>;
  email?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  lastSeen?: InputMaybe<Order_By_>;
  locale?: InputMaybe<Order_By_>;
  newEmail?: InputMaybe<Order_By_>;
  otpHash?: InputMaybe<Order_By_>;
  otpHashExpiresAt?: InputMaybe<Order_By_>;
  otpMethodLastUsed?: InputMaybe<Order_By_>;
  passwordHash?: InputMaybe<Order_By_>;
  phoneNumber?: InputMaybe<Order_By_>;
  ticket?: InputMaybe<Order_By_>;
  ticketExpiresAt?: InputMaybe<Order_By_>;
  totpSecret?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
};

/** response of any mutation on the table "auth.users" */
export type Users_Mutation_Response_ = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users_>;
};

/** input type for inserting object relation for remote table "auth.users" */
export type Users_Obj_Rel_Insert_Input_ = {
  data: Users_Insert_Input_;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict_>;
};

/** on_conflict condition type for table "auth.users" */
export type Users_On_Conflict_ = {
  constraint: Users_Constraint_;
  update_columns?: Array<Users_Update_Column_>;
  where?: InputMaybe<Users_Bool_Exp_>;
};

/** Ordering options when selecting data from "auth.users". */
export type Users_Order_By_ = {
  activeMfaType?: InputMaybe<Order_By_>;
  avatarUrl?: InputMaybe<Order_By_>;
  companyUsers_aggregate?: InputMaybe<CompanyUser_Aggregate_Order_By_>;
  compassPAT?: InputMaybe<CompassPat_Order_By_>;
  createdAt?: InputMaybe<Order_By_>;
  currentChallenge?: InputMaybe<Order_By_>;
  defaultRole?: InputMaybe<Order_By_>;
  defaultRoleByRole?: InputMaybe<AuthRoles_Order_By_>;
  disabled?: InputMaybe<Order_By_>;
  displayName?: InputMaybe<Order_By_>;
  email?: InputMaybe<Order_By_>;
  emailVerified?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  invitations_aggregate?: InputMaybe<CompanyInvitation_Aggregate_Order_By_>;
  isAnonymous?: InputMaybe<Order_By_>;
  lastSeen?: InputMaybe<Order_By_>;
  locale?: InputMaybe<Order_By_>;
  metadata?: InputMaybe<Order_By_>;
  newEmail?: InputMaybe<Order_By_>;
  notifications_aggregate?: InputMaybe<UserNotification_Aggregate_Order_By_>;
  otpHash?: InputMaybe<Order_By_>;
  otpHashExpiresAt?: InputMaybe<Order_By_>;
  otpMethodLastUsed?: InputMaybe<Order_By_>;
  passwordHash?: InputMaybe<Order_By_>;
  phoneNumber?: InputMaybe<Order_By_>;
  phoneNumberVerified?: InputMaybe<Order_By_>;
  refreshTokens_aggregate?: InputMaybe<AuthRefreshTokens_Aggregate_Order_By_>;
  roles_aggregate?: InputMaybe<AuthUserRoles_Aggregate_Order_By_>;
  securityKeys_aggregate?: InputMaybe<AuthUserSecurityKeys_Aggregate_Order_By_>;
  threadSubscriptions_aggregate?: InputMaybe<ThreadSubscriber_Aggregate_Order_By_>;
  ticket?: InputMaybe<Order_By_>;
  ticketExpiresAt?: InputMaybe<Order_By_>;
  totpSecret?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  userProviders_aggregate?: InputMaybe<AuthUserProviders_Aggregate_Order_By_>;
};

/** primary key columns input for table: auth.users */
export type Users_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input_ = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "auth.users" */
export enum Users_Select_Column_ {
  /** column name */
  ActiveMfaType_ = 'activeMfaType',
  /** column name */
  AvatarUrl_ = 'avatarUrl',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  CurrentChallenge_ = 'currentChallenge',
  /** column name */
  DefaultRole_ = 'defaultRole',
  /** column name */
  Disabled_ = 'disabled',
  /** column name */
  DisplayName_ = 'displayName',
  /** column name */
  Email_ = 'email',
  /** column name */
  EmailVerified_ = 'emailVerified',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsAnonymous_ = 'isAnonymous',
  /** column name */
  LastSeen_ = 'lastSeen',
  /** column name */
  Locale_ = 'locale',
  /** column name */
  Metadata_ = 'metadata',
  /** column name */
  NewEmail_ = 'newEmail',
  /** column name */
  OtpHash_ = 'otpHash',
  /** column name */
  OtpHashExpiresAt_ = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed_ = 'otpMethodLastUsed',
  /** column name */
  PasswordHash_ = 'passwordHash',
  /** column name */
  PhoneNumber_ = 'phoneNumber',
  /** column name */
  PhoneNumberVerified_ = 'phoneNumberVerified',
  /** column name */
  Ticket_ = 'ticket',
  /** column name */
  TicketExpiresAt_ = 'ticketExpiresAt',
  /** column name */
  TotpSecret_ = 'totpSecret',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

/** select "users_aggregate_bool_exp_bool_and_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_And_Arguments_Columns_ {
  /** column name */
  Disabled_ = 'disabled',
  /** column name */
  EmailVerified_ = 'emailVerified',
  /** column name */
  IsAnonymous_ = 'isAnonymous',
  /** column name */
  PhoneNumberVerified_ = 'phoneNumberVerified'
}

/** select "users_aggregate_bool_exp_bool_or_arguments_columns" columns of table "auth.users" */
export enum Users_Select_Column_Users_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns_ {
  /** column name */
  Disabled_ = 'disabled',
  /** column name */
  EmailVerified_ = 'emailVerified',
  /** column name */
  IsAnonymous_ = 'isAnonymous',
  /** column name */
  PhoneNumberVerified_ = 'phoneNumberVerified'
}

/** input type for updating data in table "auth.users" */
export type Users_Set_Input_ = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currentChallenge?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  newEmail?: InputMaybe<Scalars['citext']['input']>;
  otpHash?: InputMaybe<Scalars['String']['input']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input_ = {
  activeMfaType?: InputMaybe<Scalars['String']['input']>;
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  currentChallenge?: InputMaybe<Scalars['String']['input']>;
  defaultRole?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['citext']['input']>;
  emailVerified?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeen?: InputMaybe<Scalars['timestamptz']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  newEmail?: InputMaybe<Scalars['citext']['input']>;
  otpHash?: InputMaybe<Scalars['String']['input']>;
  otpHashExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  otpMethodLastUsed?: InputMaybe<Scalars['String']['input']>;
  passwordHash?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberVerified?: InputMaybe<Scalars['Boolean']['input']>;
  ticket?: InputMaybe<Scalars['String']['input']>;
  ticketExpiresAt?: InputMaybe<Scalars['timestamptz']['input']>;
  totpSecret?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "auth.users" */
export enum Users_Update_Column_ {
  /** column name */
  ActiveMfaType_ = 'activeMfaType',
  /** column name */
  AvatarUrl_ = 'avatarUrl',
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  CurrentChallenge_ = 'currentChallenge',
  /** column name */
  DefaultRole_ = 'defaultRole',
  /** column name */
  Disabled_ = 'disabled',
  /** column name */
  DisplayName_ = 'displayName',
  /** column name */
  Email_ = 'email',
  /** column name */
  EmailVerified_ = 'emailVerified',
  /** column name */
  Id_ = 'id',
  /** column name */
  IsAnonymous_ = 'isAnonymous',
  /** column name */
  LastSeen_ = 'lastSeen',
  /** column name */
  Locale_ = 'locale',
  /** column name */
  Metadata_ = 'metadata',
  /** column name */
  NewEmail_ = 'newEmail',
  /** column name */
  OtpHash_ = 'otpHash',
  /** column name */
  OtpHashExpiresAt_ = 'otpHashExpiresAt',
  /** column name */
  OtpMethodLastUsed_ = 'otpMethodLastUsed',
  /** column name */
  PasswordHash_ = 'passwordHash',
  /** column name */
  PhoneNumber_ = 'phoneNumber',
  /** column name */
  PhoneNumberVerified_ = 'phoneNumberVerified',
  /** column name */
  Ticket_ = 'ticket',
  /** column name */
  TicketExpiresAt_ = 'ticketExpiresAt',
  /** column name */
  TotpSecret_ = 'totpSecret',
  /** column name */
  UpdatedAt_ = 'updatedAt'
}

export type Users_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp_;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp_ = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _is_null?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

/** columns and relationships of "storage.virus" */
export type Virus_ = {
  __typename?: 'virus';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  file: Files_;
  fileId: Scalars['uuid']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userSession: Scalars['jsonb']['output'];
  virus: Scalars['String']['output'];
};


/** columns and relationships of "storage.virus" */
export type VirusUserSessionArgs_ = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "storage.virus" */
export type Virus_Aggregate_ = {
  __typename?: 'virus_aggregate';
  aggregate?: Maybe<Virus_Aggregate_Fields_>;
  nodes: Array<Virus_>;
};

/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_Fields_ = {
  __typename?: 'virus_aggregate_fields';
  count: Scalars['Int']['output'];
  max?: Maybe<Virus_Max_Fields_>;
  min?: Maybe<Virus_Min_Fields_>;
};


/** aggregate fields of "storage.virus" */
export type Virus_Aggregate_FieldsCountArgs_ = {
  columns?: InputMaybe<Array<Virus_Select_Column_>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Virus_Append_Input_ = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "storage.virus". All fields are combined with a logical 'AND'. */
export type Virus_Bool_Exp_ = {
  _and?: InputMaybe<Array<Virus_Bool_Exp_>>;
  _not?: InputMaybe<Virus_Bool_Exp_>;
  _or?: InputMaybe<Array<Virus_Bool_Exp_>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  file?: InputMaybe<Files_Bool_Exp_>;
  fileId?: InputMaybe<Uuid_Comparison_Exp_>;
  filename?: InputMaybe<String_Comparison_Exp_>;
  id?: InputMaybe<Uuid_Comparison_Exp_>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp_>;
  userSession?: InputMaybe<Jsonb_Comparison_Exp_>;
  virus?: InputMaybe<String_Comparison_Exp_>;
};

/** unique or primary key constraints on table "storage.virus" */
export enum Virus_Constraint_ {
  /** unique or primary key constraint on columns "id" */
  VirusPkey_ = 'virus_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Virus_Delete_At_Path_Input_ = {
  userSession?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Virus_Delete_Elem_Input_ = {
  userSession?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Virus_Delete_Key_Input_ = {
  userSession?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "storage.virus" */
export type Virus_Insert_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  file?: InputMaybe<Files_Obj_Rel_Insert_Input_>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type Virus_Max_Fields_ = {
  __typename?: 'virus_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virus?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type Virus_Min_Fields_ = {
  __typename?: 'virus_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  fileId?: Maybe<Scalars['uuid']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  virus?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "storage.virus" */
export type Virus_Mutation_Response_ = {
  __typename?: 'virus_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Virus_>;
};

/** on_conflict condition type for table "storage.virus" */
export type Virus_On_Conflict_ = {
  constraint: Virus_Constraint_;
  update_columns?: Array<Virus_Update_Column_>;
  where?: InputMaybe<Virus_Bool_Exp_>;
};

/** Ordering options when selecting data from "storage.virus". */
export type Virus_Order_By_ = {
  createdAt?: InputMaybe<Order_By_>;
  file?: InputMaybe<Files_Order_By_>;
  fileId?: InputMaybe<Order_By_>;
  filename?: InputMaybe<Order_By_>;
  id?: InputMaybe<Order_By_>;
  updatedAt?: InputMaybe<Order_By_>;
  userSession?: InputMaybe<Order_By_>;
  virus?: InputMaybe<Order_By_>;
};

/** primary key columns input for table: storage.virus */
export type Virus_Pk_Columns_Input_ = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Virus_Prepend_Input_ = {
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "storage.virus" */
export enum Virus_Select_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  FileId_ = 'fileId',
  /** column name */
  Filename_ = 'filename',
  /** column name */
  Id_ = 'id',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UserSession_ = 'userSession',
  /** column name */
  Virus_ = 'virus'
}

/** input type for updating data in table "storage.virus" */
export type Virus_Set_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "virus" */
export type Virus_Stream_Cursor_Input_ = {
  /** Stream column input with initial value */
  initial_value: Virus_Stream_Cursor_Value_Input_;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering_>;
};

/** Initial value of the column from where the streaming should start */
export type Virus_Stream_Cursor_Value_Input_ = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  fileId?: InputMaybe<Scalars['uuid']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userSession?: InputMaybe<Scalars['jsonb']['input']>;
  virus?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "storage.virus" */
export enum Virus_Update_Column_ {
  /** column name */
  CreatedAt_ = 'createdAt',
  /** column name */
  FileId_ = 'fileId',
  /** column name */
  Filename_ = 'filename',
  /** column name */
  Id_ = 'id',
  /** column name */
  UpdatedAt_ = 'updatedAt',
  /** column name */
  UserSession_ = 'userSession',
  /** column name */
  Virus_ = 'virus'
}

export type Virus_Updates_ = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Virus_Append_Input_>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Virus_Delete_At_Path_Input_>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Virus_Delete_Elem_Input_>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Virus_Delete_Key_Input_>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Virus_Prepend_Input_>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Virus_Set_Input_>;
  /** filter the rows which have to be updated */
  where: Virus_Bool_Exp_;
};

export type AdminGetCompaniesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Company_Order_By_> | Company_Order_By_>;
  where?: InputMaybe<Company_Bool_Exp_>;
}>;


export type AdminGetCompaniesQuery_ = { __typename?: 'query_root', Company: Array<{ __typename?: 'Company', id: any, compassId?: string | null, name: string, settings: any, logoUrl?: string | null, isPortfolioOwner: boolean, isGroupOwner: boolean, hasPaiAccess: boolean, hasAiAccess: boolean, hasCustomQuestionsAccess: boolean, hasTaxonomyAccess: boolean, hasBulkUploadAccess?: boolean | null, canDownloadTaxonomyReport: boolean, isReal: boolean, hasESRSAccess: boolean, hasVSMEAccess: boolean, hasIFRSAccess?: boolean | null, hasTCFDAccess: boolean, hasESRSOilAndGasAccess: boolean, hasEntitySpecificAccess: boolean, hasSASBAccess: boolean, canDownloadEsrsReport: boolean, cancelledAt?: any | null, portfolios: Array<{ __typename?: 'Portfolio', id: any, name: string, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, companyId?: any | null }> }>, groupAssessments: Array<{ __typename?: 'GroupAssessment', id: any, name: string, subsidiaries: Array<{ __typename?: 'Subsidiary', id: any, companyId?: any | null }> }> }>, Company_aggregate: { __typename?: 'Company_aggregate', aggregate?: { __typename?: 'Company_aggregate_fields', count: number } | null } };

export type AdminGetAppConfigQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AppConfig_Order_By_> | AppConfig_Order_By_>;
  where?: InputMaybe<AppConfig_Bool_Exp_>;
}>;


export type AdminGetAppConfigQuery_ = { __typename?: 'query_root', AppConfig: Array<{ __typename?: 'AppConfig', mergeInProgress: boolean, id: boolean, identifier: string }> };

export type AdminGetOneAppConfigQueryVariables_ = Exact<{
  id: Scalars['Boolean']['input'];
}>;


export type AdminGetOneAppConfigQuery_ = { __typename?: 'query_root', AppConfig_by_pk?: { __typename?: 'AppConfig', mergeInProgress: boolean } | null };

export type AdminGetCompanyInvitationsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyInvitation_Order_By_> | CompanyInvitation_Order_By_>;
  where?: InputMaybe<CompanyInvitation_Bool_Exp_>;
}>;


export type AdminGetCompanyInvitationsQuery_ = { __typename?: 'query_root', CompanyInvitation: Array<{ __typename?: 'CompanyInvitation', id: any, companyId: any, userEmail: any, role: UserRole_Enum_, status: string, createdAt?: any | null, updatedAt?: any | null }>, CompanyInvitation_aggregate: { __typename?: 'CompanyInvitation_aggregate', aggregate?: { __typename?: 'CompanyInvitation_aggregate_fields', count: number } | null } };

export type AdminUpdateCompanyInvitationsMutationVariables_ = Exact<{
  pk_columns: CompanyInvitation_Pk_Columns_Input_;
  _set: CompanyInvitation_Set_Input_;
}>;


export type AdminUpdateCompanyInvitationsMutation_ = { __typename?: 'mutation_root', update_CompanyInvitation_by_pk?: { __typename?: 'CompanyInvitation', id: any, companyId: any, userEmail: any, role: UserRole_Enum_, status: string, createdAt?: any | null, updatedAt?: any | null } | null };

export type AdminUpdateAppConfigMutationVariables_ = Exact<{
  pk_columns: AppConfig_Pk_Columns_Input_;
  _set: AppConfig_Set_Input_;
}>;


export type AdminUpdateAppConfigMutation_ = { __typename?: 'mutation_root', update_AppConfig_by_pk?: { __typename?: 'AppConfig', id: boolean, mergeInProgress: boolean } | null };

export type AdminCreateCompanyInvitationsMutationVariables_ = Exact<{
  objects: Array<CompanyInvitation_Insert_Input_> | CompanyInvitation_Insert_Input_;
}>;


export type AdminCreateCompanyInvitationsMutation_ = { __typename?: 'mutation_root', insert_CompanyInvitation?: { __typename?: 'CompanyInvitation_mutation_response', returning: Array<{ __typename?: 'CompanyInvitation', id: any }> } | null };

export type AdminGetCompanyQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminGetCompanyQuery_ = { __typename?: 'query_root', Company_by_pk?: { __typename?: 'Company', id: any, compassId?: string | null, name: string, settings: any, logoUrl?: string | null, isPortfolioOwner: boolean, isGroupOwner: boolean, hasPaiAccess: boolean, hasAiAccess: boolean, hasCustomQuestionsAccess: boolean, hasTaxonomyAccess: boolean, hasBulkUploadAccess?: boolean | null, canDownloadTaxonomyReport: boolean, isReal: boolean, hasESRSAccess: boolean, hasVSMEAccess: boolean, hasIFRSAccess?: boolean | null, hasTCFDAccess: boolean, hasESRSOilAndGasAccess: boolean, hasEntitySpecificAccess: boolean, hasSASBAccess: boolean, canDownloadEsrsReport: boolean, cancelledAt?: any | null, cAssessments: Array<{ __typename?: 'CompanyAssessment', aggregate: { __typename?: 'CompanyAssessmentAggregate', title: string }, bAssesssments: Array<{ __typename?: 'BusinessUnitAssessment', businessUnit?: { __typename?: 'BusinessUnit', name: string } | null, activityReports: Array<{ __typename?: 'ActivityReport', activityVersionNumber: number, activityRef: string }> }> }>, portfolios: Array<{ __typename?: 'Portfolio', id: any, name: string, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, companyId?: any | null }> }>, groupAssessments: Array<{ __typename?: 'GroupAssessment', id: any, name: string, subsidiaries: Array<{ __typename?: 'Subsidiary', id: any, companyId?: any | null }> }>, esrsAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, companyId: any, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, companyId: any }> }> } | null };

export type AdminUpdateCompanyMutationVariables_ = Exact<{
  pk_columns: Company_Pk_Columns_Input_;
  _set: Company_Set_Input_;
}>;


export type AdminUpdateCompanyMutation_ = { __typename?: 'mutation_root', update_Company_by_pk?: { __typename?: 'Company', id: any, compassId?: string | null, name: string, settings: any, logoUrl?: string | null, isPortfolioOwner: boolean, isGroupOwner: boolean, hasPaiAccess: boolean, hasAiAccess: boolean, hasBulkUploadAccess?: boolean | null, hasCustomQuestionsAccess: boolean, hasTaxonomyAccess: boolean, canDownloadTaxonomyReport: boolean, isReal: boolean, hasESRSAccess: boolean, hasVSMEAccess: boolean, hasIFRSAccess?: boolean | null, hasTCFDAccess: boolean, hasESRSOilAndGasAccess: boolean, hasEntitySpecificAccess: boolean, hasSASBAccess: boolean, canDownloadEsrsReport: boolean, cancelledAt?: any | null } | null };

export type AdminUpdateCompaniesByIdsMutationVariables_ = Exact<{
  where: Company_Bool_Exp_;
  _set: Company_Set_Input_;
}>;


export type AdminUpdateCompaniesByIdsMutation_ = { __typename?: 'mutation_root', update_Company?: { __typename?: 'Company_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'Company', id: any, isReal: boolean }> } | null };

export type AdminDeleteCompanyMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminDeleteCompanyMutation_ = { __typename?: 'mutation_root', delete_Company_by_pk?: { __typename?: 'Company', id: any } | null };

export type AdminGetCompanyUsersQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyUser_Order_By_> | CompanyUser_Order_By_>;
  where?: InputMaybe<CompanyUser_Bool_Exp_>;
}>;


export type AdminGetCompanyUsersQuery_ = { __typename?: 'query_root', CompanyUser: Array<{ __typename?: 'CompanyUser', id: any, companyId: any, userId: any, role: UserRole_Enum_ }>, CompanyUser_aggregate: { __typename?: 'CompanyUser_aggregate', aggregate?: { __typename?: 'CompanyUser_aggregate_fields', count: number } | null } };

export type AdminDeleteCompanyUsersMutationVariables_ = Exact<{
  userIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  companyId: Scalars['uuid']['input'];
}>;


export type AdminDeleteCompanyUsersMutation_ = { __typename?: 'mutation_root', delete_CompanyUser?: { __typename?: 'CompanyUser_mutation_response', affected_rows: number } | null };

export type AdminDeleteCompanyUserMutationVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
  companyId: Scalars['uuid']['input'];
}>;


export type AdminDeleteCompanyUserMutation_ = { __typename?: 'mutation_root', delete_CompanyUser_by_pk?: { __typename?: 'CompanyUser', id: any } | null };

export type AdminGetusersQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Users_Order_By_> | Users_Order_By_>;
  where?: InputMaybe<Users_Bool_Exp_>;
}>;


export type AdminGetusersQuery_ = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email?: any | null, displayName: string, disabled: boolean }>, users_aggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null } };

export type AdminGetUserQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminGetUserQuery_ = { __typename?: 'query_root', user?: { __typename?: 'users', id: any, email?: any | null, displayName: string, disabled: boolean } | null };

export type AdminUpdateusersMutationVariables_ = Exact<{
  updates: Array<Users_Updates_> | Users_Updates_;
}>;


export type AdminUpdateusersMutation_ = { __typename?: 'mutation_root', update_users_many?: Array<{ __typename?: 'users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'users', displayName: string, disabled: boolean, id: any }> } | null> | null };

export type AdminCreateUserMutationVariables_ = Exact<{
  object: Users_Insert_Input_;
  on_conflict: Users_On_Conflict_;
}>;


export type AdminCreateUserMutation_ = { __typename?: 'mutation_root', insertUser?: { __typename?: 'users', id: any, email?: any | null } | null };

export type AdminCreateCompanyUsersMutationVariables_ = Exact<{
  objects: Array<CompanyUser_Insert_Input_> | CompanyUser_Insert_Input_;
}>;


export type AdminCreateCompanyUsersMutation_ = { __typename?: 'mutation_root', insert_CompanyUser?: { __typename?: 'CompanyUser_mutation_response', returning: Array<{ __typename?: 'CompanyUser', id: any }> } | null };

export type AdminGetCompanyAssessmentsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<CompanyAssessment_Order_By_> | CompanyAssessment_Order_By_>;
  where?: InputMaybe<CompanyAssessment_Bool_Exp_>;
}>;


export type AdminGetCompanyAssessmentsQuery_ = { __typename?: 'query_root', CompanyAssessment: Array<{ __typename?: 'CompanyAssessment', id: any, createdAt: any, updatedAt: any, aggregateId: any, companyId: any, isLocked: boolean }>, CompanyAssessment_aggregate: { __typename?: 'CompanyAssessment_aggregate', aggregate?: { __typename?: 'CompanyAssessment_aggregate_fields', count: number } | null } };

export type AdminGetGroupAssessmentsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<GroupAssessment_Order_By_> | GroupAssessment_Order_By_>;
  where?: InputMaybe<GroupAssessment_Bool_Exp_>;
}>;


export type AdminGetGroupAssessmentsQuery_ = { __typename?: 'query_root', GroupAssessment: Array<{ __typename?: 'GroupAssessment', id: any, createdAt: any, name: string, period: any, companyId: any, updatedAt: any, consolidatedCompanyAssessmentId?: any | null, subsidiaries: Array<{ __typename?: 'Subsidiary', id: any, company?: { __typename?: 'Company', name: string } | null }> }>, GroupAssessment_aggregate: { __typename?: 'GroupAssessment_aggregate', aggregate?: { __typename?: 'GroupAssessment_aggregate_fields', count: number } | null } };

export type AdminGetCompanyAssessmentAggregatesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CompanyAssessmentAggregate_Bool_Exp_>;
}>;


export type AdminGetCompanyAssessmentAggregatesQuery_ = { __typename?: 'query_root', CompanyAssessmentAggregate: Array<{ __typename?: 'CompanyAssessmentAggregate', id: any, title: string, createdAt: any, updatedAt: any, companyId: any, isReal: boolean }>, CompanyAssessmentAggregate_aggregate: { __typename?: 'CompanyAssessmentAggregate_aggregate', aggregate?: { __typename?: 'CompanyAssessmentAggregate_aggregate_fields', count: number } | null } };

export type AdminUpdateCompanyAssessmentMutationVariables_ = Exact<{
  pk_columns: CompanyAssessment_Pk_Columns_Input_;
  _set: CompanyAssessment_Set_Input_;
}>;


export type AdminUpdateCompanyAssessmentMutation_ = { __typename?: 'mutation_root', update_CompanyAssessment_by_pk?: { __typename?: 'CompanyAssessment', id: any, createdAt: any, updatedAt: any, aggregateId: any, companyId: any, isLocked: boolean } | null };

export type AdminUpdateGroupAssessmentMutationVariables_ = Exact<{
  pk_columns: GroupAssessment_Pk_Columns_Input_;
  _set: GroupAssessment_Set_Input_;
}>;


export type AdminUpdateGroupAssessmentMutation_ = { __typename?: 'mutation_root', update_GroupAssessment_by_pk?: { __typename?: 'GroupAssessment', id: any, createdAt: any, name: string, period: any, companyId: any, updatedAt: any, consolidatedCompanyAssessmentId?: any | null } | null };

export type AdminGetSpacesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Space_Order_By_> | Space_Order_By_>;
  where?: InputMaybe<Space_Bool_Exp_>;
}>;


export type AdminGetSpacesQuery_ = { __typename?: 'query_root', Space: Array<{ __typename?: 'Space', id: string, name: string, sharedWith: Array<{ __typename?: 'SharedSpace', companyId: any, company: { __typename?: 'Company', name: string } }> }>, Space_aggregate: { __typename?: 'Space_aggregate', aggregate?: { __typename?: 'Space_aggregate_fields', count: number } | null } };

export type AdminCreateSpaceMutationVariables_ = Exact<{
  object: Space_Insert_Input_;
}>;


export type AdminCreateSpaceMutation_ = { __typename?: 'mutation_root', insert_Space_one?: { __typename?: 'Space', id: string, name: string, sharedWith: Array<{ __typename?: 'SharedSpace', companyId: any, company: { __typename?: 'Company', name: string } }> } | null };

export type AdminGetActivitiesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Activity_Order_By_> | Activity_Order_By_>;
  where?: InputMaybe<Activity_Bool_Exp_>;
}>;


export type AdminGetActivitiesQuery_ = { __typename?: 'query_root', Activity: Array<{ __typename?: 'Activity', name: string, reference: string, description: string, sectorRef: string, referenceNumber?: string | null, currentQuestionSetVersion?: number | null, isHidden: boolean, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, activityReports: Array<{ __typename?: 'ActivityReport', activityVersionNumber: number, bAssessment: { __typename?: 'BusinessUnitAssessment', cAssessment: { __typename?: 'CompanyAssessment', company: { __typename?: 'Company', name: string, isReal: boolean }, aggregate: { __typename?: 'CompanyAssessmentAggregate', title: string } }, businessUnit?: { __typename?: 'BusinessUnit', name: string } | null } }> }>, Activity_aggregate: { __typename?: 'Activity_aggregate', aggregate?: { __typename?: 'Activity_aggregate_fields', count: number } | null } };

export type AdminGetSectorsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Sector_Order_By_> | Sector_Order_By_>;
  where?: InputMaybe<Sector_Bool_Exp_>;
}>;


export type AdminGetSectorsQuery_ = { __typename?: 'query_root', Sector: Array<{ __typename?: 'Sector', name: string, reference: string, referenceNumber?: string | null }>, Sector_aggregate: { __typename?: 'Sector_aggregate', aggregate?: { __typename?: 'Sector_aggregate_fields', count: number } | null } };

export type AdminGetActivityQuestionSetsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityQuestionSet_Order_By_> | ActivityQuestionSet_Order_By_>;
  where?: InputMaybe<ActivityQuestionSet_Bool_Exp_>;
}>;


export type AdminGetActivityQuestionSetsQuery_ = { __typename?: 'query_root', ActivityQuestionSet: Array<{ __typename?: 'ActivityQuestionSet', activityRef: string, questionSetRef: string, id: any, version: number }>, ActivityQuestionSet_aggregate: { __typename?: 'ActivityQuestionSet_aggregate', aggregate?: { __typename?: 'ActivityQuestionSet_aggregate_fields', count: number } | null } };

export type AdminGetQuestionSetsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionSet_Order_By_> | QuestionSet_Order_By_>;
  where?: InputMaybe<QuestionSet_Bool_Exp_>;
}>;


export type AdminGetQuestionSetsQuery_ = { __typename?: 'query_root', QuestionSet: Array<{ __typename?: 'QuestionSet', reference: string, questions: Array<{ __typename?: 'QuestionSetQuestion', questionId: any, question: { __typename?: 'Question', uniqueId: string, version: string, id: any } }> }>, QuestionSet_aggregate: { __typename?: 'QuestionSet_aggregate', aggregate?: { __typename?: 'QuestionSet_aggregate_fields', count: number } | null } };

export type AdminGetQuestionsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Question_Order_By_> | Question_Order_By_>;
  where?: InputMaybe<Question_Bool_Exp_>;
}>;


export type AdminGetQuestionsQuery_ = { __typename?: 'query_root', Question: Array<{ __typename?: 'Question', uniqueId: string, version: string, title: string, description?: string | null, type: QuestionType_Enum_, level: QuestionLevel_Enum_, group?: string | null, orderIndex: string, unit?: string | null, alignmentErrorMessage?: string | null, dependencyDescription?: string | null, extendedDescription?: string | null, resourceLink?: string | null, documentationRequired: boolean, relevantDirectives?: string | null, objectiveKey: string, id: any, other?: any | null, isAligned?: string | null, isRequired?: string | null, isVisible?: string | null, isEditable?: string | null, levelExpression?: string | null, learnMoreArticleSlug?: string | null, olderRevisions: Array<{ __typename?: 'QuestionRevision', oldQuestionId: any, newQuestionId: any, description: string, oldQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string } }> }>, Question_aggregate: { __typename?: 'Question_aggregate', aggregate?: { __typename?: 'Question_aggregate_fields', count: number } | null } };

export type AdminGetQuestionRevisionsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionRevision_Order_By_> | QuestionRevision_Order_By_>;
  where?: InputMaybe<QuestionRevision_Bool_Exp_>;
}>;


export type AdminGetQuestionRevisionsQuery_ = { __typename?: 'query_root', QuestionRevision: Array<{ __typename?: 'QuestionRevision', oldQuestionId: any, newQuestionId: any, description: string, oldQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string }, newQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string } }>, QuestionRevision_aggregate: { __typename?: 'QuestionRevision_aggregate', aggregate?: { __typename?: 'QuestionRevision_aggregate_fields', count: number } | null } };

export type AdminGetObjectivesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Objective_Order_By_> | Objective_Order_By_>;
  where?: InputMaybe<Objective_Bool_Exp_>;
}>;


export type AdminGetObjectivesQuery_ = { __typename?: 'query_root', Objective: Array<{ __typename?: 'Objective', key: string, title: string, description?: string | null }>, Objective_aggregate: { __typename?: 'Objective_aggregate', aggregate?: { __typename?: 'Objective_aggregate_fields', count: number } | null } };

export type AdminGetQuestionSetQuestionsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionSetQuestion_Order_By_> | QuestionSetQuestion_Order_By_>;
  where?: InputMaybe<QuestionSetQuestion_Bool_Exp_>;
}>;


export type AdminGetQuestionSetQuestionsQuery_ = { __typename?: 'query_root', QuestionSetQuestion: Array<{ __typename?: 'QuestionSetQuestion', questionSetRef: string, questionId: any }>, QuestionSetQuestion_aggregate: { __typename?: 'QuestionSetQuestion_aggregate', aggregate?: { __typename?: 'QuestionSetQuestion_aggregate_fields', count: number } | null } };

export type AdminGetQuestionChoicesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<QuestionChoice_Order_By_> | QuestionChoice_Order_By_>;
  where?: InputMaybe<QuestionChoice_Bool_Exp_>;
}>;


export type AdminGetQuestionChoicesQuery_ = { __typename?: 'query_root', QuestionChoice: Array<{ __typename?: 'QuestionChoice', id: any, order: string, value: string, displayName: string, question_id: any }>, QuestionChoice_aggregate: { __typename?: 'QuestionChoice_aggregate', aggregate?: { __typename?: 'QuestionChoice_aggregate_fields', count: number } | null } };

export type AdminGetActivityNaceCodesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityNaceCode_Order_By_> | ActivityNaceCode_Order_By_>;
  where?: InputMaybe<ActivityNaceCode_Bool_Exp_>;
}>;


export type AdminGetActivityNaceCodesQuery_ = { __typename?: 'query_root', ActivityNaceCode: Array<{ __typename?: 'ActivityNaceCode', activityRef: string, code: string, id: any }>, ActivityNaceCode_aggregate: { __typename?: 'ActivityNaceCode_aggregate', aggregate?: { __typename?: 'ActivityNaceCode_aggregate_fields', count: number } | null } };

export type AdminGetActivityVersionsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActivityVersion_Order_By_> | ActivityVersion_Order_By_>;
  where?: InputMaybe<ActivityVersion_Bool_Exp_>;
}>;


export type AdminGetActivityVersionsQuery_ = { __typename?: 'query_root', ActivityVersion: Array<{ __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, tagExpression: string, tagObjective?: string | null, changeDescription: string, validFrom: any, activityQuestionSets: Array<{ __typename?: 'ActivityQuestionSet', questionSetRef: string, version: number, activityRef: string, questionSet: { __typename?: 'QuestionSet', reference: string } }> }>, ActivityVersion_aggregate: { __typename?: 'ActivityVersion_aggregate', aggregate?: { __typename?: 'ActivityVersion_aggregate_fields', count: number } | null } };

export type AdminGetArticlesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Article_Order_By_> | Article_Order_By_>;
  where?: InputMaybe<Article_Bool_Exp_>;
}>;


export type AdminGetArticlesQuery_ = { __typename?: 'query_root', Article: Array<{ __typename?: 'Article', title: string, body: string, id: any, slug?: string | null, isHidden: boolean, order: string }>, Article_aggregate: { __typename?: 'Article_aggregate', aggregate?: { __typename?: 'Article_aggregate_fields', count: number } | null } };

export type AdminGetTagsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Order_By_> | Tag_Order_By_>;
  where?: InputMaybe<Tag_Bool_Exp_>;
}>;


export type AdminGetTagsQuery_ = { __typename?: 'query_root', Tag: Array<{ __typename?: 'Tag', id: any, name: string, description: string, tagGroupId?: any | null }>, Tag_aggregate: { __typename?: 'Tag_aggregate', aggregate?: { __typename?: 'Tag_aggregate_fields', count: number } | null } };

export type AdminGetTagGroupsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagGroup_Order_By_> | TagGroup_Order_By_>;
  where?: InputMaybe<TagGroup_Bool_Exp_>;
}>;


export type AdminGetTagGroupsQuery_ = { __typename?: 'query_root', TagGroup: Array<{ __typename?: 'TagGroup', id: any, name: string, description?: string | null }>, TagGroup_aggregate: { __typename?: 'TagGroup_aggregate', aggregate?: { __typename?: 'TagGroup_aggregate_fields', count: number } | null } };

export type AdminGetTag_ArticlesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Tag_Articles_Order_By_> | Tag_Articles_Order_By_>;
  where?: InputMaybe<Tag_Articles_Bool_Exp_>;
}>;


export type AdminGetTag_ArticlesQuery_ = { __typename?: 'query_root', Tag_articles: Array<{ __typename?: 'Tag_articles', id: any, tag_id: any, article_id: any }>, Tag_articles_aggregate: { __typename?: 'Tag_articles_aggregate', aggregate?: { __typename?: 'Tag_articles_aggregate_fields', count: number } | null } };

export type AdminGetPaiCategoriesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiCategory_Order_By_> | PaiCategory_Order_By_>;
  where?: InputMaybe<PaiCategory_Bool_Exp_>;
}>;


export type AdminGetPaiCategoriesQuery_ = { __typename?: 'query_root', PaiCategory: Array<{ __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, tableReference: string }>, PaiCategory_aggregate: { __typename?: 'PaiCategory_aggregate', aggregate?: { __typename?: 'PaiCategory_aggregate_fields', count: number } | null } };

export type AdminGetPaiTablesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiTable_Order_By_> | PaiTable_Order_By_>;
  where?: InputMaybe<PaiTable_Bool_Exp_>;
}>;


export type AdminGetPaiTablesQuery_ = { __typename?: 'query_root', PaiTable: Array<{ __typename?: 'PaiTable', title: string, reference: string, isMandatory: boolean, subtitle?: string | null, isCustom: boolean }>, PaiTable_aggregate: { __typename?: 'PaiTable_aggregate', aggregate?: { __typename?: 'PaiTable_aggregate_fields', count: number } | null } };

export type AdminGetPaiTableIndicatorsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<PaiTableIndicator_Order_By_> | PaiTableIndicator_Order_By_>;
  where?: InputMaybe<PaiTableIndicator_Bool_Exp_>;
}>;


export type AdminGetPaiTableIndicatorsQuery_ = { __typename?: 'query_root', PaiTableIndicator: Array<{ __typename?: 'PaiTableIndicator', title: string, reference: string, categoryReference: string, description?: string | null, isHidden: boolean, order?: string | null }>, PaiTableIndicator_aggregate: { __typename?: 'PaiTableIndicator_aggregate', aggregate?: { __typename?: 'PaiTableIndicator_aggregate_fields', count: number } | null } };

export type AdminGetInvestorMetricsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestorMetric_Order_By_> | InvestorMetric_Order_By_>;
  where?: InputMaybe<InvestorMetric_Bool_Exp_>;
}>;


export type AdminGetInvestorMetricsQuery_ = { __typename?: 'query_root', InvestorMetric: Array<{ __typename?: 'InvestorMetric', title: string, reference: string, description?: string | null, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null }>, InvestorMetric_aggregate: { __typename?: 'InvestorMetric_aggregate', aggregate?: { __typename?: 'InvestorMetric_aggregate_fields', count: number } | null } };

export type AdminGetInvesteeMetricsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvesteeMetric_Order_By_> | InvesteeMetric_Order_By_>;
  where?: InputMaybe<InvesteeMetric_Bool_Exp_>;
}>;


export type AdminGetInvesteeMetricsQuery_ = { __typename?: 'query_root', InvesteeMetric: Array<{ __typename?: 'InvesteeMetric', title: string, reference: string, methodology?: string | null, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, unit?: string | null, order: number }>, InvesteeMetric_aggregate: { __typename?: 'InvesteeMetric_aggregate', aggregate?: { __typename?: 'InvesteeMetric_aggregate_fields', count: number } | null } };

export type AdminGetIndicatorToInvestorMetricsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<IndicatorToInvestorMetric_Order_By_> | IndicatorToInvestorMetric_Order_By_>;
  where?: InputMaybe<IndicatorToInvestorMetric_Bool_Exp_>;
}>;


export type AdminGetIndicatorToInvestorMetricsQuery_ = { __typename?: 'query_root', IndicatorToInvestorMetric: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetricRef: string, indicatorRef: string }>, IndicatorToInvestorMetric_aggregate: { __typename?: 'IndicatorToInvestorMetric_aggregate', aggregate?: { __typename?: 'IndicatorToInvestorMetric_aggregate_fields', count: number } | null } };

export type AdminGetInvestorToInvesteeMetricsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<InvestorToInvesteeMetric_Order_By_> | InvestorToInvesteeMetric_Order_By_>;
  where?: InputMaybe<InvestorToInvesteeMetric_Bool_Exp_>;
}>;


export type AdminGetInvestorToInvesteeMetricsQuery_ = { __typename?: 'query_root', InvestorToInvesteeMetric: Array<{ __typename?: 'InvestorToInvesteeMetric', investeeMetricReference: string, investorMetricReference: string }>, InvestorToInvesteeMetric_aggregate: { __typename?: 'InvestorToInvesteeMetric_aggregate', aggregate?: { __typename?: 'InvestorToInvesteeMetric_aggregate_fields', count: number } | null } };

export type AdminGetEsrsCategoriesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsCategory_Order_By_> | EsrsCategory_Order_By_>;
  where?: InputMaybe<EsrsCategory_Bool_Exp_>;
}>;


export type AdminGetEsrsCategoriesQuery_ = { __typename?: 'query_root', EsrsCategory: Array<{ __typename?: 'EsrsCategory', title: string, reference: string }>, EsrsCategory_aggregate: { __typename?: 'EsrsCategory_aggregate', aggregate?: { __typename?: 'EsrsCategory_aggregate_fields', count: number } | null } };

export type AdminGetEsrsAssessmentsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsAssessment_Order_By_> | EsrsAssessment_Order_By_>;
  where?: InputMaybe<EsrsAssessment_Bool_Exp_>;
}>;


export type AdminGetEsrsAssessmentsQuery_ = { __typename?: 'query_root', EsrsAssessment: Array<{ __typename?: 'EsrsAssessment', id: any, reportingYear: number, companyId: any, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingYear: number, company: { __typename?: 'Company', name: string } }> }>, EsrsAssessment_aggregate: { __typename?: 'EsrsAssessment_aggregate', aggregate?: { __typename?: 'EsrsAssessment_aggregate_fields', count: number } | null } };

export type AdminGetEsrsStandardsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandard_Order_By_> | EsrsStandard_Order_By_>;
  where?: InputMaybe<EsrsStandard_Bool_Exp_>;
}>;


export type AdminGetEsrsStandardsQuery_ = { __typename?: 'query_root', EsrsStandard: Array<{ __typename?: 'EsrsStandard', title: string, reference: string, description?: string | null, isTopical: boolean, categoryRef: string, formattedPolicyChecklist?: string | null, aiPolicyChecklist?: string | null, frameworkRef?: string | null, order: number }>, EsrsStandard_aggregate: { __typename?: 'EsrsStandard_aggregate', aggregate?: { __typename?: 'EsrsStandard_aggregate_fields', count: number } | null } };

export type AdminGetEsrsStandardAdditionalTypesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsStandardAdditionalType_Order_By_> | EsrsStandardAdditionalType_Order_By_>;
  where?: InputMaybe<EsrsStandardAdditionalType_Bool_Exp_>;
}>;


export type AdminGetEsrsStandardAdditionalTypesQuery_ = { __typename?: 'query_root', EsrsStandardAdditionalType: Array<{ __typename?: 'EsrsStandardAdditionalType', standardRef: string, additionalTypeRef: string }>, EsrsStandardAdditionalType_aggregate: { __typename?: 'EsrsStandardAdditionalType_aggregate', aggregate?: { __typename?: 'EsrsStandardAdditionalType_aggregate_fields', count: number } | null } };

export type AdminGetDisclosureRequirementGroupsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementGroup_Order_By_> | DisclosureRequirementGroup_Order_By_>;
  where?: InputMaybe<DisclosureRequirementGroup_Bool_Exp_>;
}>;


export type AdminGetDisclosureRequirementGroupsQuery_ = { __typename?: 'query_root', DisclosureRequirementGroup: Array<{ __typename?: 'DisclosureRequirementGroup', title: string, reference: string, standardRef: string, order: number }>, DisclosureRequirementGroup_aggregate: { __typename?: 'DisclosureRequirementGroup_aggregate', aggregate?: { __typename?: 'DisclosureRequirementGroup_aggregate_fields', count: number } | null } };

export type AdminGetDisclosureRequirementsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirement_Order_By_> | DisclosureRequirement_Order_By_>;
  where?: InputMaybe<DisclosureRequirement_Bool_Exp_>;
}>;


export type AdminGetDisclosureRequirementsQuery_ = { __typename?: 'query_root', DisclosureRequirement: Array<{ __typename?: 'DisclosureRequirement', title: string, shortTitle?: string | null, reference: string, groupRef: string, type: string, order: number, description?: string | null, isMandatory: boolean }>, DisclosureRequirement_aggregate: { __typename?: 'DisclosureRequirement_aggregate', aggregate?: { __typename?: 'DisclosureRequirement_aggregate_fields', count: number } | null } };

export type AdminGetDisclosureRequirementAdditionalTypesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DisclosureRequirementAdditionalType_Order_By_> | DisclosureRequirementAdditionalType_Order_By_>;
  where?: InputMaybe<DisclosureRequirementAdditionalType_Bool_Exp_>;
}>;


export type AdminGetDisclosureRequirementAdditionalTypesQuery_ = { __typename?: 'query_root', DisclosureRequirementAdditionalType: Array<{ __typename?: 'DisclosureRequirementAdditionalType', disclosureRequirementRef: string, additionalTypeRef: string }>, DisclosureRequirementAdditionalType_aggregate: { __typename?: 'DisclosureRequirementAdditionalType_aggregate', aggregate?: { __typename?: 'DisclosureRequirementAdditionalType_aggregate_fields', count: number } | null } };

export type AdminGetEsrsMetricsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetric_Order_By_> | EsrsMetric_Order_By_>;
  where?: InputMaybe<EsrsMetric_Bool_Exp_>;
}>;


export type AdminGetEsrsMetricsQuery_ = { __typename?: 'query_root', EsrsMetric: Array<{ __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, reference: string, description?: string | null, calculation?: string | null, disclosureRequirementRef: string, metricType?: QuestionType_Enum_ | null, unitOfMeasurement?: string | null, isAssessable: boolean, firstLevel?: string | null, secondLevel?: string | null, order: number, isGroup: boolean, showAsPercentage?: boolean | null, isAR: boolean, globalOrder?: string | null, hasAssociation: boolean, canBeUsedForTarget: boolean, unlockCondition?: boolean | null, choiceSetRef?: string | null, showPercentageWithTag: boolean, notAggregatable: boolean, abbreviation?: string | null, dr: { __typename?: 'DisclosureRequirement', group: { __typename?: 'DisclosureRequirementGroup', standard: { __typename?: 'EsrsStandard', frameworkRef?: string | null } } } }>, EsrsMetric_aggregate: { __typename?: 'EsrsMetric_aggregate', aggregate?: { __typename?: 'EsrsMetric_aggregate_fields', count: number } | null } };

export type AdminGetMetricDependenciesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricDependency_Order_By_> | MetricDependency_Order_By_>;
  where?: InputMaybe<MetricDependency_Bool_Exp_>;
}>;


export type AdminGetMetricDependenciesQuery_ = { __typename?: 'query_root', MetricDependency: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, childMetricRef: string }>, MetricDependency_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null } };

export type AdminGetMetricTagsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MetricTag_Order_By_> | MetricTag_Order_By_>;
  where?: InputMaybe<MetricTag_Bool_Exp_>;
}>;


export type AdminGetMetricTagsQuery_ = { __typename?: 'query_root', MetricTag: Array<{ __typename?: 'MetricTag', metricRef: string, type: string, isOptional: boolean }>, MetricTag_aggregate: { __typename?: 'MetricTag_aggregate', aggregate?: { __typename?: 'MetricTag_aggregate_fields', count: number } | null } };

export type AdminGetEsrsMetricAdditionalTypesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsMetricAdditionalType_Order_By_> | EsrsMetricAdditionalType_Order_By_>;
  where?: InputMaybe<EsrsMetricAdditionalType_Bool_Exp_>;
}>;


export type AdminGetEsrsMetricAdditionalTypesQuery_ = { __typename?: 'query_root', EsrsMetricAdditionalType: Array<{ __typename?: 'EsrsMetricAdditionalType', metricRef: string, additionalTypeRef: string }>, EsrsMetricAdditionalType_aggregate: { __typename?: 'EsrsMetricAdditionalType_aggregate', aggregate?: { __typename?: 'EsrsMetricAdditionalType_aggregate_fields', count: number } | null } };

export type AdminGetTagTypesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagType_Order_By_> | TagType_Order_By_>;
  where?: InputMaybe<TagType_Bool_Exp_>;
}>;


export type AdminGetTagTypesQuery_ = { __typename?: 'query_root', TagType: Array<{ __typename?: 'TagType', type: string, alwaysAll: boolean }>, TagType_aggregate: { __typename?: 'TagType_aggregate', aggregate?: { __typename?: 'TagType_aggregate_fields', count: number } | null } };

export type AdminGetTagValuesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TagValue_Order_By_> | TagValue_Order_By_>;
  where?: InputMaybe<TagValue_Bool_Exp_>;
}>;


export type AdminGetTagValuesQuery_ = { __typename?: 'query_root', TagValue: Array<{ __typename?: 'TagValue', value: string, type: string, order: number }>, TagValue_aggregate: { __typename?: 'TagValue_aggregate', aggregate?: { __typename?: 'TagValue_aggregate_fields', count: number } | null } };

export type AdminGetAdditionalTypesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AdditionalType_Order_By_> | AdditionalType_Order_By_>;
  where?: InputMaybe<AdditionalType_Bool_Exp_>;
}>;


export type AdminGetAdditionalTypesQuery_ = { __typename?: 'query_root', AdditionalType: Array<{ __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null }>, AdditionalType_aggregate: { __typename?: 'AdditionalType_aggregate', aggregate?: { __typename?: 'AdditionalType_aggregate_fields', count: number } | null } };

export type AdminGetTargetQuestionsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestion_Order_By_> | TargetQuestion_Order_By_>;
  where?: InputMaybe<TargetQuestion_Bool_Exp_>;
}>;


export type AdminGetTargetQuestionsQuery_ = { __typename?: 'query_root', TargetQuestion: Array<{ __typename?: 'TargetQuestion', title: string, reference: string, standardRef: string, unit?: string | null, questionType: QuestionType_Enum_, order: number, description?: string | null, groupRef?: string | null, globalOrder?: string | null, firstLevel?: string | null, secondLevel?: string | null, isAR: boolean, choiceSetRef?: string | null }>, TargetQuestion_aggregate: { __typename?: 'TargetQuestion_aggregate', aggregate?: { __typename?: 'TargetQuestion_aggregate_fields', count: number } | null } };

export type AdminGetTargetQuestionGroupsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<TargetQuestionGroup_Order_By_> | TargetQuestionGroup_Order_By_>;
  where?: InputMaybe<TargetQuestionGroup_Bool_Exp_>;
}>;


export type AdminGetTargetQuestionGroupsQuery_ = { __typename?: 'query_root', TargetQuestionGroup: Array<{ __typename?: 'TargetQuestionGroup', title: string, reference: string }>, TargetQuestionGroup_aggregate: { __typename?: 'TargetQuestionGroup_aggregate', aggregate?: { __typename?: 'TargetQuestionGroup_aggregate_fields', count: number } | null } };

export type AdminGetCompanyAssessmentQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminGetCompanyAssessmentQuery_ = { __typename?: 'query_root', CompanyAssessment_by_pk?: { __typename?: 'CompanyAssessment', id: any, createdAt: any, updatedAt: any, aggregateId: any, companyId: any, isLocked: boolean } | null };

export type AdminGetGroupAssessmentQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminGetGroupAssessmentQuery_ = { __typename?: 'query_root', GroupAssessment_by_pk?: { __typename?: 'GroupAssessment', id: any, createdAt: any, name: string, period: any, companyId: any, updatedAt: any, consolidatedCompanyAssessmentId?: any | null, subsidiaries: Array<{ __typename?: 'Subsidiary', id: any, company?: { __typename?: 'Company', name: string } | null }> } | null };

export type AdminCreateSharedSpacesMutationVariables_ = Exact<{
  objects: Array<SharedSpace_Insert_Input_> | SharedSpace_Insert_Input_;
}>;


export type AdminCreateSharedSpacesMutation_ = { __typename?: 'mutation_root', insert_SharedSpace?: { __typename?: 'SharedSpace_mutation_response', returning: Array<{ __typename?: 'SharedSpace', spaceId: string, companyId: any }> } | null };

export type AdminDeleteSharedSpaceMutationVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
  spaceId: Scalars['String']['input'];
}>;


export type AdminDeleteSharedSpaceMutation_ = { __typename?: 'mutation_root', delete_SharedSpace_by_pk?: { __typename?: 'SharedSpace', companyId: any, spaceId: string } | null };

export type AdminGetSpaceQueryVariables_ = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminGetSpaceQuery_ = { __typename?: 'query_root', Space_by_pk?: { __typename?: 'Space', id: string, name: string, sharedWith: Array<{ __typename?: 'SharedSpace', companyId: any, company: { __typename?: 'Company', name: string } }> } | null };

export type AdminUpdateSpaceMutationVariables_ = Exact<{
  pk_columns: Space_Pk_Columns_Input_;
  _set: Space_Set_Input_;
}>;


export type AdminUpdateSpaceMutation_ = { __typename?: 'mutation_root', update_Space_by_pk?: { __typename?: 'Space', id: string, name: string, sharedWith: Array<{ __typename?: 'SharedSpace', companyId: any, company: { __typename?: 'Company', name: string } }> } | null };

export type AdminDeleteSpaceMutationVariables_ = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminDeleteSpaceMutation_ = { __typename?: 'mutation_root', delete_Space_by_pk?: { __typename?: 'Space', id: string } | null };

export type AdminGetActivityQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetActivityQuery_ = { __typename?: 'query_root', Activity_by_pk?: { __typename?: 'Activity', name: string, reference: string, description: string, sectorRef: string, referenceNumber?: string | null, currentQuestionSetVersion?: number | null, isHidden: boolean, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, activityReports: Array<{ __typename?: 'ActivityReport', activityVersionNumber: number, bAssessment: { __typename?: 'BusinessUnitAssessment', cAssessment: { __typename?: 'CompanyAssessment', company: { __typename?: 'Company', name: string, isReal: boolean }, aggregate: { __typename?: 'CompanyAssessmentAggregate', title: string } }, businessUnit?: { __typename?: 'BusinessUnit', name: string } | null } }> } | null };

export type AdminGetQuestionQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminGetQuestionQuery_ = { __typename?: 'query_root', Question_by_pk?: { __typename?: 'Question', uniqueId: string, version: string, title: string, description?: string | null, type: QuestionType_Enum_, level: QuestionLevel_Enum_, group?: string | null, orderIndex: string, unit?: string | null, alignmentErrorMessage?: string | null, dependencyDescription?: string | null, extendedDescription?: string | null, resourceLink?: string | null, documentationRequired: boolean, relevantDirectives?: string | null, objectiveKey: string, id: any, other?: any | null, isAligned?: string | null, isRequired?: string | null, isVisible?: string | null, isEditable?: string | null, levelExpression?: string | null, learnMoreArticleSlug?: string | null, olderRevisions: Array<{ __typename?: 'QuestionRevision', oldQuestionId: any, newQuestionId: any, description: string, oldQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string } }> } | null };

export type AdminGetQuestionTypesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QuestionType_Bool_Exp_>;
}>;


export type AdminGetQuestionTypesQuery_ = { __typename?: 'query_root', QuestionType: Array<{ __typename?: 'QuestionType', type: string }>, QuestionType_aggregate: { __typename?: 'QuestionType_aggregate', aggregate?: { __typename?: 'QuestionType_aggregate_fields', count: number } | null } };

export type AdminGetQuestionRevisionQueryVariables_ = Exact<{
  oldQuestionId: Scalars['uuid']['input'];
  newQuestionId: Scalars['uuid']['input'];
}>;


export type AdminGetQuestionRevisionQuery_ = { __typename?: 'query_root', QuestionRevision_by_pk?: { __typename?: 'QuestionRevision', oldQuestionId: any, newQuestionId: any, description: string, oldQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string }, newQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string } } | null };

export type AdminDeleteQuestionRevisionMutationVariables_ = Exact<{
  oldQuestionId: Scalars['uuid']['input'];
  newQuestionId: Scalars['uuid']['input'];
}>;


export type AdminDeleteQuestionRevisionMutation_ = { __typename?: 'mutation_root', delete_QuestionRevision_by_pk?: { __typename?: 'QuestionRevision', oldQuestionId: any, newQuestionId: any, description: string, oldQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string }, newQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string } } | null };

export type AdminGetObjectiveQueryVariables_ = Exact<{
  key: Scalars['String']['input'];
}>;


export type AdminGetObjectiveQuery_ = { __typename?: 'query_root', Objective_by_pk?: { __typename?: 'Objective', key: string, title: string, description?: string | null } | null };

export type AdminDeleteObjectiveMutationVariables_ = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminDeleteObjectiveMutation_ = { __typename?: 'mutation_root', delete_Objective_by_pk?: { __typename?: 'Objective', key: string } | null };

export type AdminGetQuestionSetQuestionQueryVariables_ = Exact<{
  questionSetRef: Scalars['String']['input'];
  questionId: Scalars['uuid']['input'];
}>;


export type AdminGetQuestionSetQuestionQuery_ = { __typename?: 'query_root', QuestionSetQuestion_by_pk?: { __typename?: 'QuestionSetQuestion', questionSetRef: string, questionId: any } | null };

export type AdminGetQuestionChoiceQueryVariables_ = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type AdminGetQuestionChoiceQuery_ = { __typename?: 'query_root', QuestionChoice_by_pk?: { __typename?: 'QuestionChoice', id: any, order: string, value: string, displayName: string, question_id: any } | null };

export type AdminDeleteQuestionChoiceMutationVariables_ = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type AdminDeleteQuestionChoiceMutation_ = { __typename?: 'mutation_root', delete_QuestionChoice_by_pk?: { __typename?: 'QuestionChoice', id: any } | null };

export type AdminGetActivityNaceCodeQueryVariables_ = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type AdminGetActivityNaceCodeQuery_ = { __typename?: 'query_root', ActivityNaceCode_by_pk?: { __typename?: 'ActivityNaceCode', activityRef: string, code: string, id: any } | null };

export type AdminDeleteActivityNaceCodeMutationVariables_ = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type AdminDeleteActivityNaceCodeMutation_ = { __typename?: 'mutation_root', delete_ActivityNaceCode_by_pk?: { __typename?: 'ActivityNaceCode', id: any } | null };

export type AdminGetActivityVersionQueryVariables_ = Exact<{
  activityRef: Scalars['String']['input'];
  versionNumber: Scalars['Int']['input'];
}>;


export type AdminGetActivityVersionQuery_ = { __typename?: 'query_root', ActivityVersion_by_pk?: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, tagExpression: string, tagObjective?: string | null, changeDescription: string, validFrom: any, activityQuestionSets: Array<{ __typename?: 'ActivityQuestionSet', questionSetRef: string, version: number, activityRef: string, questionSet: { __typename?: 'QuestionSet', reference: string } }> } | null };

export type AdminGetArticleQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminGetArticleQuery_ = { __typename?: 'query_root', Article_by_pk?: { __typename?: 'Article', title: string, body: string, id: any, slug?: string | null, isHidden: boolean, order: string } | null };

export type AdminDeleteArticleMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminDeleteArticleMutation_ = { __typename?: 'mutation_root', delete_Article_by_pk?: { __typename?: 'Article', id: any } | null };

export type AdminGetTagQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminGetTagQuery_ = { __typename?: 'query_root', Tag_by_pk?: { __typename?: 'Tag', id: any, name: string, description: string, tagGroupId?: any | null } | null };

export type AdminGetTagGroupQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminGetTagGroupQuery_ = { __typename?: 'query_root', TagGroup_by_pk?: { __typename?: 'TagGroup', id: any, name: string, description?: string | null } | null };

export type AdminDeleteTagMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminDeleteTagMutation_ = { __typename?: 'mutation_root', delete_Tag_by_pk?: { __typename?: 'Tag', id: any } | null };

export type AdminDeleteTagGroupMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminDeleteTagGroupMutation_ = { __typename?: 'mutation_root', delete_TagGroup_by_pk?: { __typename?: 'TagGroup', id: any } | null };

export type AdminGetTag_ArticleQueryVariables_ = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type AdminGetTag_ArticleQuery_ = { __typename?: 'query_root', Tag_articles_by_pk?: { __typename?: 'Tag_articles', id: any, tag_id: any, article_id: any } | null };

export type AdminDeleteTag_ArticleMutationVariables_ = Exact<{
  id: Scalars['bigint']['input'];
}>;


export type AdminDeleteTag_ArticleMutation_ = { __typename?: 'mutation_root', delete_Tag_articles_by_pk?: { __typename?: 'Tag_articles', id: any } | null };

export type AdminGetPaiCategoryQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetPaiCategoryQuery_ = { __typename?: 'query_root', PaiCategory_by_pk?: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, tableReference: string } | null };

export type AdminDeletePaiCategoryMutationVariables_ = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminDeletePaiCategoryMutation_ = { __typename?: 'mutation_root', delete_PaiCategory_by_pk?: { __typename?: 'PaiCategory', reference: string } | null };

export type AdminGetPaiTableQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetPaiTableQuery_ = { __typename?: 'query_root', PaiTable_by_pk?: { __typename?: 'PaiTable', title: string, reference: string, isMandatory: boolean, subtitle?: string | null, isCustom: boolean } | null };

export type AdminDeletePaiTableMutationVariables_ = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminDeletePaiTableMutation_ = { __typename?: 'mutation_root', delete_PaiTable_by_pk?: { __typename?: 'PaiTable', reference: string } | null };

export type AdminGetPaiTableIndicatorQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetPaiTableIndicatorQuery_ = { __typename?: 'query_root', PaiTableIndicator_by_pk?: { __typename?: 'PaiTableIndicator', title: string, reference: string, categoryReference: string, description?: string | null, isHidden: boolean, order?: string | null } | null };

export type AdminDeletePaiTableIndicatorMutationVariables_ = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminDeletePaiTableIndicatorMutation_ = { __typename?: 'mutation_root', delete_PaiTableIndicator_by_pk?: { __typename?: 'PaiTableIndicator', reference: string } | null };

export type AdminGetInvestorMetricQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetInvestorMetricQuery_ = { __typename?: 'query_root', InvestorMetric_by_pk?: { __typename?: 'InvestorMetric', title: string, reference: string, description?: string | null, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null } | null };

export type AdminDeleteInvestorMetricMutationVariables_ = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminDeleteInvestorMetricMutation_ = { __typename?: 'mutation_root', delete_InvestorMetric_by_pk?: { __typename?: 'InvestorMetric', reference: string } | null };

export type AdminGetInvesteeMetricQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetInvesteeMetricQuery_ = { __typename?: 'query_root', InvesteeMetric_by_pk?: { __typename?: 'InvesteeMetric', title: string, reference: string, methodology?: string | null, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, unit?: string | null, order: number } | null };

export type AdminDeleteInvesteeMetricMutationVariables_ = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminDeleteInvesteeMetricMutation_ = { __typename?: 'mutation_root', delete_InvesteeMetric_by_pk?: { __typename?: 'InvesteeMetric', reference: string } | null };

export type AdminGetIndicatorToInvestorMetricQueryVariables_ = Exact<{
  investorMetricRef: Scalars['String']['input'];
  indicatorRef: Scalars['String']['input'];
}>;


export type AdminGetIndicatorToInvestorMetricQuery_ = { __typename?: 'query_root', IndicatorToInvestorMetric_by_pk?: { __typename?: 'IndicatorToInvestorMetric', investorMetricRef: string, indicatorRef: string } | null };

export type AdminGetInvestorToInvesteeMetricQueryVariables_ = Exact<{
  investorMetricReference: Scalars['String']['input'];
  investeeMetricReference: Scalars['String']['input'];
}>;


export type AdminGetInvestorToInvesteeMetricQuery_ = { __typename?: 'query_root', InvestorToInvesteeMetric_by_pk?: { __typename?: 'InvestorToInvesteeMetric', investeeMetricReference: string, investorMetricReference: string } | null };

export type AdminGetEsrsCategoryQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetEsrsCategoryQuery_ = { __typename?: 'query_root', EsrsCategory_by_pk?: { __typename?: 'EsrsCategory', title: string, reference: string } | null };

export type AdminGetEsrsAssessmentQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminGetEsrsAssessmentQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, reportingYear: number, companyId: any, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingYear: number, company: { __typename?: 'Company', name: string } }> } | null };

export type AdminDeleteEsrsCategoryMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteEsrsCategoryMutation_ = { __typename?: 'mutation_root', delete_EsrsCategory_by_pk?: { __typename?: 'EsrsCategory', reference: string } | null };

export type AdminGetEsrsStandardQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetEsrsStandardQuery_ = { __typename?: 'query_root', EsrsStandard_by_pk?: { __typename?: 'EsrsStandard', title: string, reference: string, description?: string | null, isTopical: boolean, categoryRef: string, formattedPolicyChecklist?: string | null, aiPolicyChecklist?: string | null, frameworkRef?: string | null, order: number } | null };

export type AdminDeleteEsrsStandardMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteEsrsStandardMutation_ = { __typename?: 'mutation_root', delete_EsrsStandard_by_pk?: { __typename?: 'EsrsStandard', reference: string } | null };

export type AdminGetDisclosureRequirementGroupQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetDisclosureRequirementGroupQuery_ = { __typename?: 'query_root', DisclosureRequirementGroup_by_pk?: { __typename?: 'DisclosureRequirementGroup', title: string, reference: string, standardRef: string, order: number } | null };

export type AdminDeleteDisclosureRequirementGroupMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteDisclosureRequirementGroupMutation_ = { __typename?: 'mutation_root', delete_DisclosureRequirementGroup_by_pk?: { __typename?: 'DisclosureRequirementGroup', reference: string } | null };

export type AdminGetDisclosureRequirementQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetDisclosureRequirementQuery_ = { __typename?: 'query_root', DisclosureRequirement_by_pk?: { __typename?: 'DisclosureRequirement', title: string, shortTitle?: string | null, reference: string, groupRef: string, type: string, order: number, description?: string | null, isMandatory: boolean } | null };

export type AdminDeleteDisclosureRequirementMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteDisclosureRequirementMutation_ = { __typename?: 'mutation_root', delete_DisclosureRequirement_by_pk?: { __typename?: 'DisclosureRequirement', reference: string } | null };

export type AdminGetEsrsMetricQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetEsrsMetricQuery_ = { __typename?: 'query_root', EsrsMetric_by_pk?: { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, reference: string, description?: string | null, calculation?: string | null, disclosureRequirementRef: string, metricType?: QuestionType_Enum_ | null, unitOfMeasurement?: string | null, isAssessable: boolean, firstLevel?: string | null, secondLevel?: string | null, order: number, isGroup: boolean, showAsPercentage?: boolean | null, isAR: boolean, globalOrder?: string | null, hasAssociation: boolean, canBeUsedForTarget: boolean, showPercentageWithTag: boolean, unlockCondition?: boolean | null, choiceSetRef?: string | null, notAggregatable: boolean, abbreviation?: string | null } | null };

export type AdminDeleteEsrsMetricMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteEsrsMetricMutation_ = { __typename?: 'mutation_root', delete_EsrsMetric_by_pk?: { __typename?: 'EsrsMetric', reference: string } | null };

export type AdminGetTagTypeQueryVariables_ = Exact<{
  type: Scalars['String']['input'];
}>;


export type AdminGetTagTypeQuery_ = { __typename?: 'query_root', TagType_by_pk?: { __typename?: 'TagType', type: string, alwaysAll: boolean } | null };

export type AdminDeleteTagTypeMutationVariables_ = Exact<{
  type: Scalars['String']['input'];
}>;


export type AdminDeleteTagTypeMutation_ = { __typename?: 'mutation_root', delete_TagType_by_pk?: { __typename?: 'TagType', type: string } | null };

export type AdminGetTagValueQueryVariables_ = Exact<{
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
}>;


export type AdminGetTagValueQuery_ = { __typename?: 'query_root', TagValue_by_pk?: { __typename?: 'TagValue', value: string, type: string, order: number } | null };

export type AdminDeleteTagValueMutationVariables_ = Exact<{
  type: Scalars['String']['input'];
  value: Scalars['String']['input'];
}>;


export type AdminDeleteTagValueMutation_ = { __typename?: 'mutation_root', delete_TagValue_by_pk?: { __typename?: 'TagValue', value: string, type: string, order: number } | null };

export type AdminGetAdditionalTypeQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetAdditionalTypeQuery_ = { __typename?: 'query_root', AdditionalType_by_pk?: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } | null };

export type AdminDeleteAdditionalTypeMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteAdditionalTypeMutation_ = { __typename?: 'mutation_root', delete_AdditionalType_by_pk?: { __typename?: 'AdditionalType', reference: string } | null };

export type AdminCreateTargetQuestionGroupMutationVariables_ = Exact<{
  object: TargetQuestionGroup_Insert_Input_;
}>;


export type AdminCreateTargetQuestionGroupMutation_ = { __typename?: 'mutation_root', insert_TargetQuestionGroup_one?: { __typename?: 'TargetQuestionGroup', title: string, reference: string } | null };

export type AdminGetCompanyAssessmentAggregateQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminGetCompanyAssessmentAggregateQuery_ = { __typename?: 'query_root', CompanyAssessmentAggregate_by_pk?: { __typename?: 'CompanyAssessmentAggregate', id: any, title: string, createdAt: any, updatedAt: any, companyId: any, isReal: boolean } | null };

export type AdminUpdateActivityMutationVariables_ = Exact<{
  pk_columns: Activity_Pk_Columns_Input_;
  _set: Activity_Set_Input_;
}>;


export type AdminUpdateActivityMutation_ = { __typename?: 'mutation_root', update_Activity_by_pk?: { __typename?: 'Activity', name: string, reference: string, description: string, sectorRef: string, referenceNumber?: string | null, currentQuestionSetVersion?: number | null, isHidden: boolean, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null } | null };

export type AdminCreateActivityMutationVariables_ = Exact<{
  object: Activity_Insert_Input_;
}>;


export type AdminCreateActivityMutation_ = { __typename?: 'mutation_root', insert_Activity_one?: { __typename?: 'Activity', name: string, reference: string, description: string, sectorRef: string, referenceNumber?: string | null, currentQuestionSetVersion?: number | null, isHidden: boolean, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null } | null };

export type AdminCreateSectorMutationVariables_ = Exact<{
  object: Sector_Insert_Input_;
}>;


export type AdminCreateSectorMutation_ = { __typename?: 'mutation_root', insert_Sector_one?: { __typename?: 'Sector', name: string, reference: string, referenceNumber?: string | null } | null };

export type AdminUpdateQuestionMutationVariables_ = Exact<{
  pk_columns: Question_Pk_Columns_Input_;
  _set: Question_Set_Input_;
}>;


export type AdminUpdateQuestionMutation_ = { __typename?: 'mutation_root', update_Question_by_pk?: { __typename?: 'Question', uniqueId: string, version: string, title: string, description?: string | null, type: QuestionType_Enum_, level: QuestionLevel_Enum_, group?: string | null, orderIndex: string, unit?: string | null, alignmentErrorMessage?: string | null, dependencyDescription?: string | null, extendedDescription?: string | null, resourceLink?: string | null, documentationRequired: boolean, relevantDirectives?: string | null, objectiveKey: string, id: any, other?: any | null, isAligned?: string | null, isRequired?: string | null, isVisible?: string | null, isEditable?: string | null, levelExpression?: string | null, learnMoreArticleSlug?: string | null, olderRevisions: Array<{ __typename?: 'QuestionRevision', oldQuestionId: any, newQuestionId: any, description: string, oldQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string } }> } | null };

export type AdminCreateQuestionMutationVariables_ = Exact<{
  object: Question_Insert_Input_;
}>;


export type AdminCreateQuestionMutation_ = { __typename?: 'mutation_root', insert_Question_one?: { __typename?: 'Question', uniqueId: string, version: string, title: string, description?: string | null, type: QuestionType_Enum_, level: QuestionLevel_Enum_, group?: string | null, orderIndex: string, unit?: string | null, alignmentErrorMessage?: string | null, dependencyDescription?: string | null, extendedDescription?: string | null, resourceLink?: string | null, documentationRequired: boolean, relevantDirectives?: string | null, objectiveKey: string, id: any, other?: any | null, isAligned?: string | null, isRequired?: string | null, isVisible?: string | null, isEditable?: string | null, levelExpression?: string | null, learnMoreArticleSlug?: string | null, olderRevisions: Array<{ __typename?: 'QuestionRevision', oldQuestionId: any, newQuestionId: any, description: string, oldQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string } }> } | null };

export type AdminUpdateQuestionRevisionMutationVariables_ = Exact<{
  pk_columns: QuestionRevision_Pk_Columns_Input_;
  _set: QuestionRevision_Set_Input_;
}>;


export type AdminUpdateQuestionRevisionMutation_ = { __typename?: 'mutation_root', update_QuestionRevision_by_pk?: { __typename?: 'QuestionRevision', oldQuestionId: any, newQuestionId: any, description: string, oldQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string }, newQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string } } | null };

export type AdminCreateQuestionRevisionMutationVariables_ = Exact<{
  object: QuestionRevision_Insert_Input_;
}>;


export type AdminCreateQuestionRevisionMutation_ = { __typename?: 'mutation_root', insert_QuestionRevision_one?: { __typename?: 'QuestionRevision', oldQuestionId: any, newQuestionId: any, description: string, oldQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string }, newQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string } } | null };

export type AdminCreateQuestionRevisionsMutationVariables_ = Exact<{
  objects: Array<QuestionRevision_Insert_Input_> | QuestionRevision_Insert_Input_;
}>;


export type AdminCreateQuestionRevisionsMutation_ = { __typename?: 'mutation_root', insert_QuestionRevision?: { __typename?: 'QuestionRevision_mutation_response', returning: Array<{ __typename?: 'QuestionRevision', oldQuestionId: any, newQuestionId: any, description: string, oldQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string }, newQuestion: { __typename?: 'Question', id: any, uniqueId: string, version: string } }> } | null };

export type AdminUpdateObjectiveMutationVariables_ = Exact<{
  pk_columns: Objective_Pk_Columns_Input_;
  _set: Objective_Set_Input_;
}>;


export type AdminUpdateObjectiveMutation_ = { __typename?: 'mutation_root', update_Objective_by_pk?: { __typename?: 'Objective', key: string, title: string, description?: string | null } | null };

export type AdminCreateObjectiveMutationVariables_ = Exact<{
  object: Objective_Insert_Input_;
}>;


export type AdminCreateObjectiveMutation_ = { __typename?: 'mutation_root', insert_Objective_one?: { __typename?: 'Objective', key: string, title: string, description?: string | null } | null };

export type AdminCreateQuestionSetMutationVariables_ = Exact<{
  object: QuestionSet_Insert_Input_;
}>;


export type AdminCreateQuestionSetMutation_ = { __typename?: 'mutation_root', insert_QuestionSet_one?: { __typename?: 'QuestionSet', reference: string, questions: Array<{ __typename?: 'QuestionSetQuestion', questionId: any, question: { __typename?: 'Question', uniqueId: string, version: string, id: any } }> } | null };

export type AdminUpdateQuestionSetQuestionMutationVariables_ = Exact<{
  pk_columns: QuestionSetQuestion_Pk_Columns_Input_;
  _set: QuestionSetQuestion_Set_Input_;
}>;


export type AdminUpdateQuestionSetQuestionMutation_ = { __typename?: 'mutation_root', update_QuestionSetQuestion_by_pk?: { __typename?: 'QuestionSetQuestion', questionSetRef: string, questionId: any } | null };

export type AdminCreateQuestionSetQuestionMutationVariables_ = Exact<{
  object: QuestionSetQuestion_Insert_Input_;
}>;


export type AdminCreateQuestionSetQuestionMutation_ = { __typename?: 'mutation_root', insert_QuestionSetQuestion_one?: { __typename?: 'QuestionSetQuestion', questionSetRef: string, questionId: any } | null };

export type AdminUpdateQuestionChoiceMutationVariables_ = Exact<{
  pk_columns: QuestionChoice_Pk_Columns_Input_;
  _set: QuestionChoice_Set_Input_;
}>;


export type AdminUpdateQuestionChoiceMutation_ = { __typename?: 'mutation_root', update_QuestionChoice_by_pk?: { __typename?: 'QuestionChoice', id: any, order: string, value: string, displayName: string, question_id: any } | null };

export type AdminCreateQuestionChoiceMutationVariables_ = Exact<{
  object: QuestionChoice_Insert_Input_;
}>;


export type AdminCreateQuestionChoiceMutation_ = { __typename?: 'mutation_root', insert_QuestionChoice_one?: { __typename?: 'QuestionChoice', id: any, order: string, value: string, displayName: string, question_id: any } | null };

export type AdminCreateActivityQuestionSetMutationVariables_ = Exact<{
  object: ActivityQuestionSet_Insert_Input_;
}>;


export type AdminCreateActivityQuestionSetMutation_ = { __typename?: 'mutation_root', insert_ActivityQuestionSet_one?: { __typename?: 'ActivityQuestionSet', activityRef: string, questionSetRef: string, id: any, version: number } | null };

export type AdminCreateActivityQuestionSetsMutationVariables_ = Exact<{
  objects: Array<ActivityQuestionSet_Insert_Input_> | ActivityQuestionSet_Insert_Input_;
}>;


export type AdminCreateActivityQuestionSetsMutation_ = { __typename?: 'mutation_root', insert_ActivityQuestionSet?: { __typename?: 'ActivityQuestionSet_mutation_response', returning: Array<{ __typename?: 'ActivityQuestionSet', activityRef: string, questionSetRef: string, id: any, version: number }> } | null };

export type AdminCreateActivityNaceCodeMutationVariables_ = Exact<{
  object: ActivityNaceCode_Insert_Input_;
}>;


export type AdminCreateActivityNaceCodeMutation_ = { __typename?: 'mutation_root', insert_ActivityNaceCode_one?: { __typename?: 'ActivityNaceCode', activityRef: string, code: string, id: any } | null };

export type AdminUpdateActivityNaceCodeMutationVariables_ = Exact<{
  pk_columns: ActivityNaceCode_Pk_Columns_Input_;
  _set: ActivityNaceCode_Set_Input_;
}>;


export type AdminUpdateActivityNaceCodeMutation_ = { __typename?: 'mutation_root', update_ActivityNaceCode_by_pk?: { __typename?: 'ActivityNaceCode', activityRef: string, code: string, id: any } | null };

export type AdminUpdateActivityVersionMutationVariables_ = Exact<{
  pk_columns: ActivityVersion_Pk_Columns_Input_;
  _set: ActivityVersion_Set_Input_;
}>;


export type AdminUpdateActivityVersionMutation_ = { __typename?: 'mutation_root', update_ActivityVersion_by_pk?: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, tagExpression: string, tagObjective?: string | null, changeDescription: string, validFrom: any, activityQuestionSets: Array<{ __typename?: 'ActivityQuestionSet', questionSetRef: string, version: number, activityRef: string, questionSet: { __typename?: 'QuestionSet', reference: string } }> } | null };

export type AdminCreateActivityVersionMutationVariables_ = Exact<{
  object: ActivityVersion_Insert_Input_;
}>;


export type AdminCreateActivityVersionMutation_ = { __typename?: 'mutation_root', insert_ActivityVersion_one?: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, tagExpression: string, tagObjective?: string | null, changeDescription: string, validFrom: any, activityQuestionSets: Array<{ __typename?: 'ActivityQuestionSet', questionSetRef: string, version: number, activityRef: string, questionSet: { __typename?: 'QuestionSet', reference: string } }> } | null };

export type AdminCreateActivityVersionsMutationVariables_ = Exact<{
  objects: Array<ActivityVersion_Insert_Input_> | ActivityVersion_Insert_Input_;
}>;


export type AdminCreateActivityVersionsMutation_ = { __typename?: 'mutation_root', insert_ActivityVersion?: { __typename?: 'ActivityVersion_mutation_response', returning: Array<{ __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, tagExpression: string, tagObjective?: string | null, changeDescription: string, validFrom: any, activityQuestionSets: Array<{ __typename?: 'ActivityQuestionSet', questionSetRef: string, version: number, activityRef: string, questionSet: { __typename?: 'QuestionSet', reference: string } }> }> } | null };

export type AdminUpdateArticleMutationVariables_ = Exact<{
  pk_columns: Article_Pk_Columns_Input_;
  _set: Article_Set_Input_;
}>;


export type AdminUpdateArticleMutation_ = { __typename?: 'mutation_root', update_Article_by_pk?: { __typename?: 'Article', title: string, body: string, id: any, slug?: string | null, isHidden: boolean, order: string } | null };

export type AdminCreateArticleMutationVariables_ = Exact<{
  object: Article_Insert_Input_;
}>;


export type AdminCreateArticleMutation_ = { __typename?: 'mutation_root', insert_Article_one?: { __typename?: 'Article', title: string, body: string, id: any, slug?: string | null, isHidden: boolean, order: string } | null };

export type AdminDeleteActivityMutationVariables_ = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminDeleteActivityMutation_ = { __typename?: 'mutation_root', delete_Activity_by_pk?: { __typename?: 'Activity', reference: string } | null };

export type AdminUpdateTagMutationVariables_ = Exact<{
  pk_columns: Tag_Pk_Columns_Input_;
  _set: Tag_Set_Input_;
}>;


export type AdminUpdateTagMutation_ = { __typename?: 'mutation_root', update_Tag_by_pk?: { __typename?: 'Tag', id: any, name: string, description: string } | null };

export type AdminUpdateTagGroupMutationVariables_ = Exact<{
  pk_columns: TagGroup_Pk_Columns_Input_;
  _set: TagGroup_Set_Input_;
}>;


export type AdminUpdateTagGroupMutation_ = { __typename?: 'mutation_root', update_TagGroup_by_pk?: { __typename?: 'TagGroup', id: any, name: string, description?: string | null } | null };

export type AdminUpdateTag_ArticleMutationVariables_ = Exact<{
  pk_columns: Tag_Articles_Pk_Columns_Input_;
  _set: Tag_Articles_Set_Input_;
}>;


export type AdminUpdateTag_ArticleMutation_ = { __typename?: 'mutation_root', update_Tag_articles_by_pk?: { __typename?: 'Tag_articles', id: any, tag_id: any, article_id: any } | null };

export type AdminCreateTag_ArticleMutationVariables_ = Exact<{
  object: Tag_Articles_Insert_Input_;
}>;


export type AdminCreateTag_ArticleMutation_ = { __typename?: 'mutation_root', insert_Tag_articles_one?: { __typename?: 'Tag_articles', id: any, tag_id: any, article_id: any } | null };

export type AdminUpdatePaiCategoryMutationVariables_ = Exact<{
  pk_columns: PaiCategory_Pk_Columns_Input_;
  _set: PaiCategory_Set_Input_;
}>;


export type AdminUpdatePaiCategoryMutation_ = { __typename?: 'mutation_root', update_PaiCategory_by_pk?: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, tableReference: string } | null };

export type AdminCreatePaiCategoryMutationVariables_ = Exact<{
  object: PaiCategory_Insert_Input_;
}>;


export type AdminCreatePaiCategoryMutation_ = { __typename?: 'mutation_root', insert_PaiCategory_one?: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, tableReference: string } | null };

export type AdminUpdatePaiTableMutationVariables_ = Exact<{
  pk_columns: PaiTable_Pk_Columns_Input_;
  _set: PaiTable_Set_Input_;
}>;


export type AdminUpdatePaiTableMutation_ = { __typename?: 'mutation_root', update_PaiTable_by_pk?: { __typename?: 'PaiTable', title: string, reference: string, isMandatory: boolean, subtitle?: string | null, isCustom: boolean } | null };

export type AdminCreatePaiTableMutationVariables_ = Exact<{
  object: PaiTable_Insert_Input_;
}>;


export type AdminCreatePaiTableMutation_ = { __typename?: 'mutation_root', insert_PaiTable_one?: { __typename?: 'PaiTable', title: string, reference: string, isMandatory: boolean, subtitle?: string | null, isCustom: boolean } | null };

export type AdminUpdatePaiTableIndicatorMutationVariables_ = Exact<{
  pk_columns: PaiTableIndicator_Pk_Columns_Input_;
  _set: PaiTableIndicator_Set_Input_;
}>;


export type AdminUpdatePaiTableIndicatorMutation_ = { __typename?: 'mutation_root', update_PaiTableIndicator_by_pk?: { __typename?: 'PaiTableIndicator', title: string, reference: string, categoryReference: string, description?: string | null, isHidden: boolean, order?: string | null } | null };

export type AdminCreatePaiTableIndicatorMutationVariables_ = Exact<{
  object: PaiTableIndicator_Insert_Input_;
}>;


export type AdminCreatePaiTableIndicatorMutation_ = { __typename?: 'mutation_root', insert_PaiTableIndicator_one?: { __typename?: 'PaiTableIndicator', title: string, reference: string, categoryReference: string, description?: string | null, isHidden: boolean, order?: string | null } | null };

export type AdminUpdateInvestorMetricMutationVariables_ = Exact<{
  pk_columns: InvestorMetric_Pk_Columns_Input_;
  _set: InvestorMetric_Set_Input_;
}>;


export type AdminUpdateInvestorMetricMutation_ = { __typename?: 'mutation_root', update_InvestorMetric_by_pk?: { __typename?: 'InvestorMetric', title: string, reference: string, description?: string | null, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null } | null };

export type AdminCreateInvestorMetricMutationVariables_ = Exact<{
  object: InvestorMetric_Insert_Input_;
}>;


export type AdminCreateInvestorMetricMutation_ = { __typename?: 'mutation_root', insert_InvestorMetric_one?: { __typename?: 'InvestorMetric', title: string, reference: string, description?: string | null, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null } | null };

export type AdminUpdateInvesteeMetricMutationVariables_ = Exact<{
  pk_columns: InvesteeMetric_Pk_Columns_Input_;
  _set: InvesteeMetric_Set_Input_;
}>;


export type AdminUpdateInvesteeMetricMutation_ = { __typename?: 'mutation_root', update_InvesteeMetric_by_pk?: { __typename?: 'InvesteeMetric', title: string, reference: string, methodology?: string | null, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, unit?: string | null, order: number } | null };

export type AdminCreateInvesteeMetricMutationVariables_ = Exact<{
  object: InvesteeMetric_Insert_Input_;
}>;


export type AdminCreateInvesteeMetricMutation_ = { __typename?: 'mutation_root', insert_InvesteeMetric_one?: { __typename?: 'InvesteeMetric', title: string, reference: string, methodology?: string | null, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, unit?: string | null, order: number } | null };

export type AdminUpdateIndicatorToInvestorMetricMutationVariables_ = Exact<{
  pk_columns: IndicatorToInvestorMetric_Pk_Columns_Input_;
  _set: IndicatorToInvestorMetric_Set_Input_;
}>;


export type AdminUpdateIndicatorToInvestorMetricMutation_ = { __typename?: 'mutation_root', update_IndicatorToInvestorMetric_by_pk?: { __typename?: 'IndicatorToInvestorMetric', investorMetricRef: string, indicatorRef: string } | null };

export type AdminCreateIndicatorToInvestorMetricMutationVariables_ = Exact<{
  object: IndicatorToInvestorMetric_Insert_Input_;
}>;


export type AdminCreateIndicatorToInvestorMetricMutation_ = { __typename?: 'mutation_root', insert_IndicatorToInvestorMetric_one?: { __typename?: 'IndicatorToInvestorMetric', investorMetricRef: string, indicatorRef: string } | null };

export type AdminUpdateInvestorToInvesteeMetricMutationVariables_ = Exact<{
  pk_columns: InvestorToInvesteeMetric_Pk_Columns_Input_;
  _set: InvestorToInvesteeMetric_Set_Input_;
}>;


export type AdminUpdateInvestorToInvesteeMetricMutation_ = { __typename?: 'mutation_root', update_InvestorToInvesteeMetric_by_pk?: { __typename?: 'InvestorToInvesteeMetric', investeeMetricReference: string, investorMetricReference: string } | null };

export type AdminCreateInvestorToInvesteeMetricMutationVariables_ = Exact<{
  object: InvestorToInvesteeMetric_Insert_Input_;
}>;


export type AdminCreateInvestorToInvesteeMetricMutation_ = { __typename?: 'mutation_root', insert_InvestorToInvesteeMetric_one?: { __typename?: 'InvestorToInvesteeMetric', investeeMetricReference: string, investorMetricReference: string } | null };

export type AdminUpdateEsrsCategoryMutationVariables_ = Exact<{
  pk_columns: EsrsCategory_Pk_Columns_Input_;
  _set: EsrsCategory_Set_Input_;
}>;


export type AdminUpdateEsrsCategoryMutation_ = { __typename?: 'mutation_root', update_EsrsCategory_by_pk?: { __typename?: 'EsrsCategory', title: string, reference: string } | null };

export type AdminCreateEsrsCategoryMutationVariables_ = Exact<{
  object: EsrsCategory_Insert_Input_;
}>;


export type AdminCreateEsrsCategoryMutation_ = { __typename?: 'mutation_root', insert_EsrsCategory_one?: { __typename?: 'EsrsCategory', title: string, reference: string } | null };

export type AdminUpdateEsrsStandardMutationVariables_ = Exact<{
  pk_columns: EsrsStandard_Pk_Columns_Input_;
  _set: EsrsStandard_Set_Input_;
}>;


export type AdminUpdateEsrsStandardMutation_ = { __typename?: 'mutation_root', update_EsrsStandard_by_pk?: { __typename?: 'EsrsStandard', title: string, reference: string, description?: string | null, isTopical: boolean, categoryRef: string, formattedPolicyChecklist?: string | null, aiPolicyChecklist?: string | null, frameworkRef?: string | null } | null };

export type AdminCreateEsrsStandardMutationVariables_ = Exact<{
  object: EsrsStandard_Insert_Input_;
}>;


export type AdminCreateEsrsStandardMutation_ = { __typename?: 'mutation_root', insert_EsrsStandard_one?: { __typename?: 'EsrsStandard', title: string, reference: string, description?: string | null, isTopical: boolean, categoryRef: string, formattedPolicyChecklist?: string | null, aiPolicyChecklist?: string | null, frameworkRef?: string | null } | null };

export type AdminCreateEsrsStandardAdditionalTypesMutationVariables_ = Exact<{
  objects: Array<EsrsStandardAdditionalType_Insert_Input_> | EsrsStandardAdditionalType_Insert_Input_;
}>;


export type AdminCreateEsrsStandardAdditionalTypesMutation_ = { __typename?: 'mutation_root', insert_EsrsStandardAdditionalType?: { __typename?: 'EsrsStandardAdditionalType_mutation_response', returning: Array<{ __typename?: 'EsrsStandardAdditionalType', standardRef: string, additionalTypeRef: string }> } | null };

export type AdminUpdateDisclosureRequirementGroupMutationVariables_ = Exact<{
  pk_columns: DisclosureRequirementGroup_Pk_Columns_Input_;
  _set: DisclosureRequirementGroup_Set_Input_;
}>;


export type AdminUpdateDisclosureRequirementGroupMutation_ = { __typename?: 'mutation_root', update_DisclosureRequirementGroup_by_pk?: { __typename?: 'DisclosureRequirementGroup', title: string, reference: string, standardRef: string } | null };

export type AdminCreateDisclosureRequirementGroupMutationVariables_ = Exact<{
  object: DisclosureRequirementGroup_Insert_Input_;
}>;


export type AdminCreateDisclosureRequirementGroupMutation_ = { __typename?: 'mutation_root', insert_DisclosureRequirementGroup_one?: { __typename?: 'DisclosureRequirementGroup', title: string, reference: string, standardRef: string } | null };

export type AdminUpdateDisclosureRequirementMutationVariables_ = Exact<{
  pk_columns: DisclosureRequirement_Pk_Columns_Input_;
  _set: DisclosureRequirement_Set_Input_;
}>;


export type AdminUpdateDisclosureRequirementMutation_ = { __typename?: 'mutation_root', update_DisclosureRequirement_by_pk?: { __typename?: 'DisclosureRequirement', title: string, shortTitle?: string | null, reference: string, groupRef: string, type: string, order: number, description?: string | null, isMandatory: boolean } | null };

export type AdminCreateDisclosureRequirementMutationVariables_ = Exact<{
  object: DisclosureRequirement_Insert_Input_;
}>;


export type AdminCreateDisclosureRequirementMutation_ = { __typename?: 'mutation_root', insert_DisclosureRequirement_one?: { __typename?: 'DisclosureRequirement', title: string, shortTitle?: string | null, reference: string, groupRef: string, type: string, order: number, description?: string | null, isMandatory: boolean } | null };

export type AdminCreateDisclosureRequirementAdditionalTypesMutationVariables_ = Exact<{
  objects: Array<DisclosureRequirementAdditionalType_Insert_Input_> | DisclosureRequirementAdditionalType_Insert_Input_;
}>;


export type AdminCreateDisclosureRequirementAdditionalTypesMutation_ = { __typename?: 'mutation_root', insert_DisclosureRequirementAdditionalType?: { __typename?: 'DisclosureRequirementAdditionalType_mutation_response', returning: Array<{ __typename?: 'DisclosureRequirementAdditionalType', disclosureRequirementRef: string, additionalTypeRef: string }> } | null };

export type AdminCreateEsrsMetricMutationVariables_ = Exact<{
  object: EsrsMetric_Insert_Input_;
}>;


export type AdminCreateEsrsMetricMutation_ = { __typename?: 'mutation_root', insert_EsrsMetric_one?: { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, reference: string, description?: string | null, calculation?: string | null, disclosureRequirementRef: string, metricType?: QuestionType_Enum_ | null, unitOfMeasurement?: string | null, isAssessable: boolean, firstLevel?: string | null, secondLevel?: string | null, order: number, isGroup: boolean, showAsPercentage?: boolean | null, isAR: boolean, globalOrder?: string | null, hasAssociation: boolean, canBeUsedForTarget: boolean, unlockCondition?: boolean | null, choiceSetRef?: string | null, showPercentageWithTag: boolean, notAggregatable: boolean, abbreviation?: string | null } | null };

export type AdminUpdateEsrsMetricMutationVariables_ = Exact<{
  pk_columns: EsrsMetric_Pk_Columns_Input_;
  _set: EsrsMetric_Set_Input_;
}>;


export type AdminUpdateEsrsMetricMutation_ = { __typename?: 'mutation_root', update_EsrsMetric_by_pk?: { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, reference: string, description?: string | null, calculation?: string | null, disclosureRequirementRef: string, metricType?: QuestionType_Enum_ | null, unitOfMeasurement?: string | null, isAssessable: boolean, firstLevel?: string | null, secondLevel?: string | null, order: number, isGroup: boolean, showAsPercentage?: boolean | null, isAR: boolean, globalOrder?: string | null, hasAssociation: boolean, canBeUsedForTarget: boolean, unlockCondition?: boolean | null, choiceSetRef?: string | null, showPercentageWithTag: boolean, notAggregatable: boolean, abbreviation?: string | null } | null };

export type AdminCreateMetricDependenciesMutationVariables_ = Exact<{
  objects: Array<MetricDependency_Insert_Input_> | MetricDependency_Insert_Input_;
}>;


export type AdminCreateMetricDependenciesMutation_ = { __typename?: 'mutation_root', insert_MetricDependency?: { __typename?: 'MetricDependency_mutation_response', returning: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, childMetricRef: string }> } | null };

export type AdminCreateMetricTagsMutationVariables_ = Exact<{
  objects: Array<MetricTag_Insert_Input_> | MetricTag_Insert_Input_;
}>;


export type AdminCreateMetricTagsMutation_ = { __typename?: 'mutation_root', insert_MetricTag?: { __typename?: 'MetricTag_mutation_response', returning: Array<{ __typename?: 'MetricTag', metricRef: string, type: string, isOptional: boolean }> } | null };

export type AdminCreateEsrsMetricAdditionalTypesMutationVariables_ = Exact<{
  objects: Array<EsrsMetricAdditionalType_Insert_Input_> | EsrsMetricAdditionalType_Insert_Input_;
}>;


export type AdminCreateEsrsMetricAdditionalTypesMutation_ = { __typename?: 'mutation_root', insert_EsrsMetricAdditionalType?: { __typename?: 'EsrsMetricAdditionalType_mutation_response', returning: Array<{ __typename?: 'EsrsMetricAdditionalType', metricRef: string, additionalTypeRef: string }> } | null };

export type AdminUpdateTagTypeMutationVariables_ = Exact<{
  pk_columns: TagType_Pk_Columns_Input_;
  _set: TagType_Set_Input_;
}>;


export type AdminUpdateTagTypeMutation_ = { __typename?: 'mutation_root', update_TagType_by_pk?: { __typename?: 'TagType', type: string, alwaysAll: boolean } | null };

export type AdminCreateTagTypeMutationVariables_ = Exact<{
  object: TagType_Insert_Input_;
}>;


export type AdminCreateTagTypeMutation_ = { __typename?: 'mutation_root', insert_TagType_one?: { __typename?: 'TagType', type: string, alwaysAll: boolean } | null };

export type AdminCreateTagValuesMutationVariables_ = Exact<{
  objects: Array<TagValue_Insert_Input_> | TagValue_Insert_Input_;
}>;


export type AdminCreateTagValuesMutation_ = { __typename?: 'mutation_root', insert_TagValue?: { __typename?: 'TagValue_mutation_response', returning: Array<{ __typename?: 'TagValue', value: string, type: string, order: number }> } | null };

export type AdminUpdateTagValueMutationVariables_ = Exact<{
  pk_columns: TagValue_Pk_Columns_Input_;
  _set: TagValue_Set_Input_;
}>;


export type AdminUpdateTagValueMutation_ = { __typename?: 'mutation_root', update_TagValue_by_pk?: { __typename?: 'TagValue', value: string, type: string, order: number } | null };

export type AdminCreateTagValueMutationVariables_ = Exact<{
  object: TagValue_Insert_Input_;
}>;


export type AdminCreateTagValueMutation_ = { __typename?: 'mutation_root', insert_TagValue_one?: { __typename?: 'TagValue', value: string, type: string, order: number } | null };

export type AdminUpdateAdditionalTypeMutationVariables_ = Exact<{
  pk_columns: AdditionalType_Pk_Columns_Input_;
  _set: AdditionalType_Set_Input_;
}>;


export type AdminUpdateAdditionalTypeMutation_ = { __typename?: 'mutation_root', update_AdditionalType_by_pk?: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } | null };

export type AdminCreateAdditionalTypeMutationVariables_ = Exact<{
  object: AdditionalType_Insert_Input_;
}>;


export type AdminCreateAdditionalTypeMutation_ = { __typename?: 'mutation_root', insert_AdditionalType_one?: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } | null };

export type AdminCreateTargetQuestionMutationVariables_ = Exact<{
  object: TargetQuestion_Insert_Input_;
}>;


export type AdminCreateTargetQuestionMutation_ = { __typename?: 'mutation_root', insert_TargetQuestion_one?: { __typename?: 'TargetQuestion', title: string, reference: string, standardRef: string, unit?: string | null, questionType: QuestionType_Enum_, order: number, description?: string | null, groupRef?: string | null, choiceSetRef?: string | null } | null };

export type AdminGetTargetQuestionQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetTargetQuestionQuery_ = { __typename?: 'query_root', TargetQuestion_by_pk?: { __typename?: 'TargetQuestion', title: string, reference: string, standardRef: string, unit?: string | null, questionType: QuestionType_Enum_, order: number, description?: string | null, groupRef?: string | null, globalOrder?: string | null, firstLevel?: string | null, secondLevel?: string | null, isAR: boolean, choiceSetRef?: string | null } | null };

export type AdminUpdateTargetQuestionMutationVariables_ = Exact<{
  pk_columns: TargetQuestion_Pk_Columns_Input_;
  _set: TargetQuestion_Set_Input_;
}>;


export type AdminUpdateTargetQuestionMutation_ = { __typename?: 'mutation_root', update_TargetQuestion_by_pk?: { __typename?: 'TargetQuestion', title: string, reference: string, standardRef: string, unit?: string | null, questionType: QuestionType_Enum_, order: number, description?: string | null, groupRef?: string | null, choiceSetRef?: string | null } | null };

export type AdminDeleteTargetQuestionMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteTargetQuestionMutation_ = { __typename?: 'mutation_root', delete_TargetQuestion_by_pk?: { __typename?: 'TargetQuestion', title: string, reference: string, standardRef: string, unit?: string | null, questionType: QuestionType_Enum_, order: number, description?: string | null, groupRef?: string | null, choiceSetRef?: string | null } | null };

export type AdminGetTargetQuestionGroupQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetTargetQuestionGroupQuery_ = { __typename?: 'query_root', TargetQuestionGroup_by_pk?: { __typename?: 'TargetQuestionGroup', title: string, reference: string } | null };

export type AdminDeleteTargetQuestionGroupMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteTargetQuestionGroupMutation_ = { __typename?: 'mutation_root', delete_TargetQuestionGroup_by_pk?: { __typename?: 'TargetQuestionGroup', title: string, reference: string } | null };

export type AdminUpdateTargetQuestionGroupMutationVariables_ = Exact<{
  pk_columns: TargetQuestionGroup_Pk_Columns_Input_;
  _set: TargetQuestionGroup_Set_Input_;
}>;


export type AdminUpdateTargetQuestionGroupMutation_ = { __typename?: 'mutation_root', update_TargetQuestionGroup_by_pk?: { __typename?: 'TargetQuestionGroup', title: string, reference: string } | null };

export type AdminGetEsrsMetricAdditionalTypeQueryVariables_ = Exact<{
  metricRef: Scalars['String']['input'];
  additionalTypeRef: Scalars['String']['input'];
}>;


export type AdminGetEsrsMetricAdditionalTypeQuery_ = { __typename?: 'query_root', EsrsMetricAdditionalType_by_pk?: { __typename?: 'EsrsMetricAdditionalType', metricRef: string, additionalTypeRef: string } | null };

export type AdminUpdateEsrsMetricAdditionalTypeMutationVariables_ = Exact<{
  pk_columns: EsrsMetricAdditionalType_Pk_Columns_Input_;
  _set: EsrsMetricAdditionalType_Set_Input_;
}>;


export type AdminUpdateEsrsMetricAdditionalTypeMutation_ = { __typename?: 'mutation_root', update_EsrsMetricAdditionalType_by_pk?: { __typename?: 'EsrsMetricAdditionalType', metricRef: string, additionalTypeRef: string } | null };

export type AdminDeleteEsrsMetricAdditionalTypeMutationVariables_ = Exact<{
  metricRef: Scalars['String']['input'];
  additionalTypeRef: Scalars['String']['input'];
}>;


export type AdminDeleteEsrsMetricAdditionalTypeMutation_ = { __typename?: 'mutation_root', delete_EsrsMetricAdditionalType_by_pk?: { __typename?: 'EsrsMetricAdditionalType', metricRef: string, additionalTypeRef: string } | null };

export type AdminCreateEsrsMetricAdditionalTypeMutationVariables_ = Exact<{
  object: EsrsMetricAdditionalType_Insert_Input_;
}>;


export type AdminCreateEsrsMetricAdditionalTypeMutation_ = { __typename?: 'mutation_root', insert_EsrsMetricAdditionalType_one?: { __typename?: 'EsrsMetricAdditionalType', metricRef: string, additionalTypeRef: string } | null };

export type AdminGetDisclosureRequirementAdditionalTypeQueryVariables_ = Exact<{
  disclosureRequirementRef: Scalars['String']['input'];
  additionalTypeRef: Scalars['String']['input'];
}>;


export type AdminGetDisclosureRequirementAdditionalTypeQuery_ = { __typename?: 'query_root', DisclosureRequirementAdditionalType_by_pk?: { __typename?: 'DisclosureRequirementAdditionalType', disclosureRequirementRef: string, additionalTypeRef: string } | null };

export type AdminDeleteDisclosureRequirementAdditionalTypeMutationVariables_ = Exact<{
  disclosureRequirementRef: Scalars['String']['input'];
  additionalTypeRef: Scalars['String']['input'];
}>;


export type AdminDeleteDisclosureRequirementAdditionalTypeMutation_ = { __typename?: 'mutation_root', delete_DisclosureRequirementAdditionalType_by_pk?: { __typename?: 'DisclosureRequirementAdditionalType', disclosureRequirementRef: string, additionalTypeRef: string } | null };

export type AdminCreateDisclosureRequirementAdditionalTypeMutationVariables_ = Exact<{
  object: DisclosureRequirementAdditionalType_Insert_Input_;
}>;


export type AdminCreateDisclosureRequirementAdditionalTypeMutation_ = { __typename?: 'mutation_root', insert_DisclosureRequirementAdditionalType_one?: { __typename?: 'DisclosureRequirementAdditionalType', disclosureRequirementRef: string, additionalTypeRef: string } | null };

export type AdminUpdateDisclosureRequirementAdditionalTypeMutationVariables_ = Exact<{
  pk_columns: DisclosureRequirementAdditionalType_Pk_Columns_Input_;
  _set: DisclosureRequirementAdditionalType_Set_Input_;
}>;


export type AdminUpdateDisclosureRequirementAdditionalTypeMutation_ = { __typename?: 'mutation_root', update_DisclosureRequirementAdditionalType_by_pk?: { __typename?: 'DisclosureRequirementAdditionalType', disclosureRequirementRef: string, additionalTypeRef: string } | null };

export type AdminCreateEsrsStandardAdditionalTypeMutationVariables_ = Exact<{
  object: EsrsStandardAdditionalType_Insert_Input_;
}>;


export type AdminCreateEsrsStandardAdditionalTypeMutation_ = { __typename?: 'mutation_root', insert_EsrsStandardAdditionalType_one?: { __typename?: 'EsrsStandardAdditionalType', standardRef: string, additionalTypeRef: string } | null };

export type AdminGetEsrsStandardAdditionalTypeQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
  additionalTypeRef: Scalars['String']['input'];
}>;


export type AdminGetEsrsStandardAdditionalTypeQuery_ = { __typename?: 'query_root', EsrsStandardAdditionalType_by_pk?: { __typename?: 'EsrsStandardAdditionalType', standardRef: string, additionalTypeRef: string } | null };

export type AdminUpdateEsrsStandardAdditionalTypeMutationVariables_ = Exact<{
  pk_columns: EsrsStandardAdditionalType_Pk_Columns_Input_;
  _set: EsrsStandardAdditionalType_Set_Input_;
}>;


export type AdminUpdateEsrsStandardAdditionalTypeMutation_ = { __typename?: 'mutation_root', update_EsrsStandardAdditionalType_by_pk?: { __typename?: 'EsrsStandardAdditionalType', standardRef: string, additionalTypeRef: string } | null };

export type AdminDeleteEsrsStandardAdditionalTypeMutationVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
  additionalTypeRef: Scalars['String']['input'];
}>;


export type AdminDeleteEsrsStandardAdditionalTypeMutation_ = { __typename?: 'mutation_root', delete_EsrsStandardAdditionalType_by_pk?: { __typename?: 'EsrsStandardAdditionalType', standardRef: string, additionalTypeRef: string } | null };

export type AdminGetMetricTagQueryVariables_ = Exact<{
  metricRef: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type AdminGetMetricTagQuery_ = { __typename?: 'query_root', MetricTag_by_pk?: { __typename?: 'MetricTag', metricRef: string, type: string, isOptional: boolean } | null };

export type AdminUpdateMetricTagMutationVariables_ = Exact<{
  pk_columns: MetricTag_Pk_Columns_Input_;
  _set: MetricTag_Set_Input_;
}>;


export type AdminUpdateMetricTagMutation_ = { __typename?: 'mutation_root', update_MetricTag_by_pk?: { __typename?: 'MetricTag', metricRef: string, type: string, isOptional: boolean } | null };

export type AdminCreateMetricTagMutationVariables_ = Exact<{
  object: MetricTag_Insert_Input_;
}>;


export type AdminCreateMetricTagMutation_ = { __typename?: 'mutation_root', insert_MetricTag_one?: { __typename?: 'MetricTag', metricRef: string, type: string, isOptional: boolean } | null };

export type AdminDeleteMetricTagMutationVariables_ = Exact<{
  metricRef: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type AdminDeleteMetricTagMutation_ = { __typename?: 'mutation_root', delete_MetricTag_by_pk?: { __typename?: 'MetricTag', metricRef: string, type: string, isOptional: boolean } | null };

export type AdminGetMetricDependencyQueryVariables_ = Exact<{
  parentMetricRef: Scalars['String']['input'];
  childMetricRef: Scalars['String']['input'];
}>;


export type AdminGetMetricDependencyQuery_ = { __typename?: 'query_root', MetricDependency_by_pk?: { __typename?: 'MetricDependency', parentMetricRef: string, childMetricRef: string } | null };

export type AdminUpdateMetricDependencyMutationVariables_ = Exact<{
  pk_columns: MetricDependency_Pk_Columns_Input_;
  _set: MetricDependency_Set_Input_;
}>;


export type AdminUpdateMetricDependencyMutation_ = { __typename?: 'mutation_root', update_MetricDependency_by_pk?: { __typename?: 'MetricDependency', parentMetricRef: string, childMetricRef: string } | null };

export type AdminDeleteMetricDependencyMutationVariables_ = Exact<{
  parentMetricRef: Scalars['String']['input'];
  childMetricRef: Scalars['String']['input'];
}>;


export type AdminDeleteMetricDependencyMutation_ = { __typename?: 'mutation_root', delete_MetricDependency_by_pk?: { __typename?: 'MetricDependency', parentMetricRef: string, childMetricRef: string } | null };

export type AdminCreateMetricDependencyMutationVariables_ = Exact<{
  object: MetricDependency_Insert_Input_;
}>;


export type AdminCreateMetricDependencyMutation_ = { __typename?: 'mutation_root', insert_MetricDependency_one?: { __typename?: 'MetricDependency', parentMetricRef: string, childMetricRef: string } | null };

export type AdminGetActivityQuestionSetQueryVariables_ = Exact<{
  activityRef: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  questionSetRef: Scalars['String']['input'];
}>;


export type AdminGetActivityQuestionSetQuery_ = { __typename?: 'query_root', ActivityQuestionSet_by_pk?: { __typename?: 'ActivityQuestionSet', activityRef: string, questionSetRef: string, id: any, version: number } | null };

export type AdminUpdateActivityQuestionSetMutationVariables_ = Exact<{
  pk_columns: ActivityQuestionSet_Pk_Columns_Input_;
  _set: ActivityQuestionSet_Set_Input_;
}>;


export type AdminUpdateActivityQuestionSetMutation_ = { __typename?: 'mutation_root', update_ActivityQuestionSet_by_pk?: { __typename?: 'ActivityQuestionSet', activityRef: string, questionSetRef: string, id: any, version: number } | null };

export type AdminGetQuestionSetQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetQuestionSetQuery_ = { __typename?: 'query_root', QuestionSet_by_pk?: { __typename?: 'QuestionSet', reference: string, questions: Array<{ __typename?: 'QuestionSetQuestion', questionId: any, question: { __typename?: 'Question', uniqueId: string, version: string, id: any } }> } | null };

export type AdminUpdateQuestionSetMutationVariables_ = Exact<{
  pk_columns: QuestionSet_Pk_Columns_Input_;
  _set: QuestionSet_Set_Input_;
}>;


export type AdminUpdateQuestionSetMutation_ = { __typename?: 'mutation_root', update_QuestionSet_by_pk?: { __typename?: 'QuestionSet', reference: string, questions: Array<{ __typename?: 'QuestionSetQuestion', questionId: any, question: { __typename?: 'Question', uniqueId: string, version: string, id: any } }> } | null };

export type AdminDeleteQuestionSetMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteQuestionSetMutation_ = { __typename?: 'mutation_root', delete_QuestionSet_by_pk?: { __typename?: 'QuestionSet', reference: string } | null };

export type AdminCreateQuestionSetQuestionsMutationVariables_ = Exact<{
  objects: Array<QuestionSetQuestion_Insert_Input_> | QuestionSetQuestion_Insert_Input_;
}>;


export type AdminCreateQuestionSetQuestionsMutation_ = { __typename?: 'mutation_root', insert_QuestionSetQuestion?: { __typename?: 'QuestionSetQuestion_mutation_response', returning: Array<{ __typename?: 'QuestionSetQuestion', questionSetRef: string, questionId: any }> } | null };

export type AdminGetSectorQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetSectorQuery_ = { __typename?: 'query_root', Sector_by_pk?: { __typename?: 'Sector', name: string, reference: string, referenceNumber?: string | null } | null };

export type AdminUpdateSectorMutationVariables_ = Exact<{
  pk_columns: Sector_Pk_Columns_Input_;
  _set: Sector_Set_Input_;
}>;


export type AdminUpdateSectorMutation_ = { __typename?: 'mutation_root', update_Sector_by_pk?: { __typename?: 'Sector', name: string, reference: string, referenceNumber?: string | null } | null };

export type AdminDeleteSectorMutationVariables_ = Exact<{
  id: Scalars['String']['input'];
}>;


export type AdminDeleteSectorMutation_ = { __typename?: 'mutation_root', delete_Sector_by_pk?: { __typename?: 'Sector', reference: string } | null };

export type AdminDeleteQuestionMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminDeleteQuestionMutation_ = { __typename?: 'mutation_root', delete_Question_by_pk?: { __typename?: 'Question', id: any } | null };

export type AdminDeleteQuestionSetQuestionMutationVariables_ = Exact<{
  questionSetRef: Scalars['String']['input'];
  questionId: Scalars['uuid']['input'];
}>;


export type AdminDeleteQuestionSetQuestionMutation_ = { __typename?: 'mutation_root', delete_QuestionSetQuestion_by_pk?: { __typename?: 'QuestionSetQuestion', questionSetRef: string, questionId: any } | null };

export type AdminCreateTagMutationVariables_ = Exact<{
  object: Tag_Insert_Input_;
}>;


export type AdminCreateTagMutation_ = { __typename?: 'mutation_root', insert_Tag_one?: { __typename?: 'Tag', id: any, name: string, description: string } | null };

export type AdminCreateTagGroupMutationVariables_ = Exact<{
  object: TagGroup_Insert_Input_;
}>;


export type AdminCreateTagGroupMutation_ = { __typename?: 'mutation_root', insert_TagGroup_one?: { __typename?: 'TagGroup', id: any, name: string, description?: string | null } | null };

export type AdminDeleteActivityQuestionSetMutationVariables_ = Exact<{
  questionSetRef: Scalars['String']['input'];
  activityRef: Scalars['String']['input'];
  version: Scalars['Int']['input'];
}>;


export type AdminDeleteActivityQuestionSetMutation_ = { __typename?: 'mutation_root', delete_ActivityQuestionSet_by_pk?: { __typename?: 'ActivityQuestionSet', activityRef: string, questionSetRef: string, id: any, version: number } | null };

export type AdminDeleteActivityVersionMutationVariables_ = Exact<{
  activityRef: Scalars['String']['input'];
  versionNumber: Scalars['Int']['input'];
}>;


export type AdminDeleteActivityVersionMutation_ = { __typename?: 'mutation_root', delete_ActivityVersion_by_pk?: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number } | null };

export type AdminGetCompanySubsidiariesQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type AdminGetCompanySubsidiariesQuery_ = { __typename?: 'query_root', company: Array<{ __typename?: 'Company', id: any, taxonomySubsidiaries: Array<{ __typename?: 'GroupAssessment', period: any, subsidiaries: Array<{ __typename?: 'Subsidiary', companyId?: any | null }> }>, esrsSubsidiaries: Array<{ __typename?: 'EsrsAssessment', reportingYear: number, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', companyId: any }> }> }> };

export type AdminGetCompanyPortfoliosQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type AdminGetCompanyPortfoliosQuery_ = { __typename?: 'query_root', company: Array<{ __typename?: 'Company', id: any, portfolios: Array<{ __typename?: 'Portfolio', id: any, name: string, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, year?: number | null, company?: { __typename?: 'Company', id: any } | null }> }> }> };

export type AdminGetActionQuestionsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestion_Order_By_> | ActionQuestion_Order_By_>;
  where?: InputMaybe<ActionQuestion_Bool_Exp_>;
}>;


export type AdminGetActionQuestionsQuery_ = { __typename?: 'query_root', ActionQuestion: Array<{ __typename?: 'ActionQuestion', title: string, reference: string, standardRef: string, unit?: string | null, questionType: QuestionType_Enum_, order: number, description?: string | null, groupRef?: string | null, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, isAR: boolean, choiceSetRef?: string | null }>, ActionQuestion_aggregate: { __typename?: 'ActionQuestion_aggregate', aggregate?: { __typename?: 'ActionQuestion_aggregate_fields', count: number } | null } };

export type AdminGetActionQuestionQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetActionQuestionQuery_ = { __typename?: 'query_root', ActionQuestion_by_pk?: { __typename?: 'ActionQuestion', title: string, reference: string, standardRef: string, unit?: string | null, questionType: QuestionType_Enum_, order: number, description?: string | null, groupRef?: string | null, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, isAR: boolean, choiceSetRef?: string | null } | null };

export type AdminGetActionQuestionGroupsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ActionQuestionGroup_Order_By_> | ActionQuestionGroup_Order_By_>;
  where?: InputMaybe<ActionQuestionGroup_Bool_Exp_>;
}>;


export type AdminGetActionQuestionGroupsQuery_ = { __typename?: 'query_root', ActionQuestionGroup: Array<{ __typename?: 'ActionQuestionGroup', title: string, reference: string }>, ActionQuestionGroup_aggregate: { __typename?: 'ActionQuestionGroup_aggregate', aggregate?: { __typename?: 'ActionQuestionGroup_aggregate_fields', count: number } | null } };

export type AdminGetActionQuestionGroupQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetActionQuestionGroupQuery_ = { __typename?: 'query_root', ActionQuestionGroup_by_pk?: { __typename?: 'ActionQuestionGroup', title: string, reference: string } | null };

export type AdminCreateActionQuestionMutationVariables_ = Exact<{
  object: ActionQuestion_Insert_Input_;
}>;


export type AdminCreateActionQuestionMutation_ = { __typename?: 'mutation_root', insert_ActionQuestion_one?: { __typename?: 'ActionQuestion', title: string, reference: string, standardRef: string, unit?: string | null, questionType: QuestionType_Enum_, order: number, description?: string | null, groupRef?: string | null, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, isAR: boolean, choiceSetRef?: string | null } | null };

export type AdminCreateActionQuestionGroupMutationVariables_ = Exact<{
  object: ActionQuestionGroup_Insert_Input_;
}>;


export type AdminCreateActionQuestionGroupMutation_ = { __typename?: 'mutation_root', insert_ActionQuestionGroup_one?: { __typename?: 'ActionQuestionGroup', title: string, reference: string } | null };

export type AdminUpdateActionQuestionMutationVariables_ = Exact<{
  pk_columns: ActionQuestion_Pk_Columns_Input_;
  _set: ActionQuestion_Set_Input_;
}>;


export type AdminUpdateActionQuestionMutation_ = { __typename?: 'mutation_root', update_ActionQuestion_by_pk?: { __typename?: 'ActionQuestion', title: string, reference: string, standardRef: string, unit?: string | null, questionType: QuestionType_Enum_, order: number, description?: string | null, groupRef?: string | null, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, isAR: boolean, choiceSetRef?: string | null } | null };

export type AdminUpdateActionQuestionGroupMutationVariables_ = Exact<{
  pk_columns: ActionQuestionGroup_Pk_Columns_Input_;
  _set: ActionQuestionGroup_Set_Input_;
}>;


export type AdminUpdateActionQuestionGroupMutation_ = { __typename?: 'mutation_root', update_ActionQuestionGroup_by_pk?: { __typename?: 'ActionQuestionGroup', title: string, reference: string } | null };

export type AdminDeleteActionQuestionMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteActionQuestionMutation_ = { __typename?: 'mutation_root', delete_ActionQuestion_by_pk?: { __typename?: 'ActionQuestion', title: string, reference: string, standardRef: string, unit?: string | null, questionType: QuestionType_Enum_, order: number, description?: string | null, groupRef?: string | null, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, isAR: boolean, choiceSetRef?: string | null } | null };

export type AdminDeleteActionQuestionGroupMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteActionQuestionGroupMutation_ = { __typename?: 'mutation_root', delete_ActionQuestionGroup_by_pk?: { __typename?: 'ActionQuestionGroup', title: string, reference: string } | null };

export type AdminGetEsrsChoicesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<EsrsChoice_Order_By_> | EsrsChoice_Order_By_>;
  where?: InputMaybe<EsrsChoice_Bool_Exp_>;
}>;


export type AdminGetEsrsChoicesQuery_ = { __typename?: 'query_root', EsrsChoice: Array<{ __typename?: 'EsrsChoice', title: string, reference: string, order: any, choiceSetRef?: string | null }>, EsrsChoice_aggregate: { __typename?: 'EsrsChoice_aggregate', aggregate?: { __typename?: 'EsrsChoice_aggregate_fields', count: number } | null } };

export type AdminGetEsrsChoiceQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetEsrsChoiceQuery_ = { __typename?: 'query_root', EsrsChoice_by_pk?: { __typename?: 'EsrsChoice', title: string, reference: string, order: any, choiceSetRef?: string | null } | null };

export type AdminCreateEsrsChoiceMutationVariables_ = Exact<{
  object: EsrsChoice_Insert_Input_;
}>;


export type AdminCreateEsrsChoiceMutation_ = { __typename?: 'mutation_root', insert_EsrsChoice_one?: { __typename?: 'EsrsChoice', title: string, reference: string, order: any, choiceSetRef?: string | null } | null };

export type AdminCreateEsrsChoicesMutationVariables_ = Exact<{
  objects: Array<EsrsChoice_Insert_Input_> | EsrsChoice_Insert_Input_;
}>;


export type AdminCreateEsrsChoicesMutation_ = { __typename?: 'mutation_root', insert_EsrsChoice?: { __typename?: 'EsrsChoice_mutation_response', returning: Array<{ __typename?: 'EsrsChoice', reference: string }> } | null };

export type AdminUpdateEsrsChoiceMutationVariables_ = Exact<{
  pk_columns: EsrsChoice_Pk_Columns_Input_;
  _set: EsrsChoice_Set_Input_;
}>;


export type AdminUpdateEsrsChoiceMutation_ = { __typename?: 'mutation_root', update_EsrsChoice_by_pk?: { __typename?: 'EsrsChoice', title: string, reference: string, order: any, choiceSetRef?: string | null } | null };

export type AdminUpdateEsrsChoicesMutationVariables_ = Exact<{
  updates: Array<EsrsChoice_Updates_> | EsrsChoice_Updates_;
}>;


export type AdminUpdateEsrsChoicesMutation_ = { __typename?: 'mutation_root', update_EsrsChoice_many?: Array<{ __typename?: 'EsrsChoice_mutation_response', affected_rows: number } | null> | null };

export type AdminDeleteEsrsChoiceMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteEsrsChoiceMutation_ = { __typename?: 'mutation_root', delete_EsrsChoice_by_pk?: { __typename?: 'EsrsChoice', title: string, reference: string, order: any, choiceSetRef?: string | null } | null };

export type AdminGetChoiceSetsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<ChoiceSet_Order_By_> | ChoiceSet_Order_By_>;
  where?: InputMaybe<ChoiceSet_Bool_Exp_>;
}>;


export type AdminGetChoiceSetsQuery_ = { __typename?: 'query_root', ChoiceSet: Array<{ __typename?: 'ChoiceSet', title: string }>, ChoiceSet_aggregate: { __typename?: 'ChoiceSet_aggregate', aggregate?: { __typename?: 'ChoiceSet_aggregate_fields', count: number } | null } };

export type AdminGetChoiceSetQueryVariables_ = Exact<{
  title: Scalars['String']['input'];
}>;


export type AdminGetChoiceSetQuery_ = { __typename?: 'query_root', ChoiceSet_by_pk?: { __typename?: 'ChoiceSet', title: string } | null };

export type AdminCreateChoiceSetMutationVariables_ = Exact<{
  object: ChoiceSet_Insert_Input_;
}>;


export type AdminCreateChoiceSetMutation_ = { __typename?: 'mutation_root', insert_ChoiceSet_one?: { __typename?: 'ChoiceSet', title: string } | null };

export type AdminUpdateChoiceSetMutationVariables_ = Exact<{
  pk_columns: ChoiceSet_Pk_Columns_Input_;
  _set: ChoiceSet_Set_Input_;
}>;


export type AdminUpdateChoiceSetMutation_ = { __typename?: 'mutation_root', update_ChoiceSet_by_pk?: { __typename?: 'ChoiceSet', title: string } | null };

export type AdminDeleteChoiceSetMutationVariables_ = Exact<{
  title: Scalars['String']['input'];
}>;


export type AdminDeleteChoiceSetMutation_ = { __typename?: 'mutation_root', delete_ChoiceSet_by_pk?: { __typename?: 'ChoiceSet', title: string } | null };

export type AdminGetEsrsAnswersQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_Answer_Order_By_> | Esrs_Answer_Order_By_>;
  where?: InputMaybe<Esrs_Answer_Bool_Exp_>;
}>;


export type AdminGetEsrsAnswersQuery_ = { __typename?: 'query_root', esrs_Answer: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean }, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, reportingYear: number, company: { __typename?: 'Company', isGroupOwner: boolean, id: any, name: string, isReal: boolean }, parentAssessment?: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } | null }, datapoints_aggregate: { __typename?: 'esrs_Datapoint_aggregate', aggregate?: { __typename?: 'esrs_Datapoint_aggregate_fields', count: number } | null }, datapoints: Array<{ __typename?: 'esrs_Datapoint', value?: string | null, factValue?: string | null, timeframe: string, metadata?: any | null, datapointId: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }> }> }>, esrs_Answer_aggregate: { __typename?: 'esrs_Answer_aggregate', aggregate?: { __typename?: 'esrs_Answer_aggregate_fields', count: number } | null } };

export type AdminGetMaterialMetricsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Esrs_MaterialMetric_Order_By_> | Esrs_MaterialMetric_Order_By_>;
  where?: InputMaybe<Esrs_MaterialMetric_Bool_Exp_>;
}>;


export type AdminGetMaterialMetricsQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, reportingYear: number, company: { __typename?: 'Company', id: any, name: string } } } }>, esrs_MaterialMetric_aggregate: { __typename?: 'esrs_MaterialMetric_aggregate', aggregate?: { __typename?: 'esrs_MaterialMetric_aggregate_fields', count: number } | null } };

export type AdminGetAuthUserRolesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<AuthUserRoles_Order_By_> | AuthUserRoles_Order_By_>;
  where?: InputMaybe<AuthUserRoles_Bool_Exp_>;
}>;


export type AdminGetAuthUserRolesQuery_ = { __typename?: 'query_root', authUserRoles: Array<{ __typename?: 'authUserRoles', id: any, role: string, userId: any }>, authUserRolesAggregate: { __typename?: 'authUserRoles_aggregate', aggregate?: { __typename?: 'authUserRoles_aggregate_fields', count: number } | null } };

export type AdminCreateAuthUserRolesMutationVariables_ = Exact<{
  objects: Array<AuthUserRoles_Insert_Input_> | AuthUserRoles_Insert_Input_;
}>;


export type AdminCreateAuthUserRolesMutation_ = { __typename?: 'mutation_root', insert_authUserRoles?: { __typename?: 'authUserRoles_mutation_response', returning: Array<{ __typename?: 'authUserRoles', id: any, role: string, userId: any }> } | null };

export type AdminDeleteAuthUserRolesMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminDeleteAuthUserRolesMutation_ = { __typename?: 'mutation_root', deleteAuthUserRoles?: { __typename?: 'authUserRoles_mutation_response', returning: Array<{ __typename?: 'authUserRoles', id: any, role: string, userId: any }> } | null };

export type AdminGetFrameworksQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<Framework_Order_By_> | Framework_Order_By_>;
  where?: InputMaybe<Framework_Bool_Exp_>;
}>;


export type AdminGetFrameworksQuery_ = { __typename?: 'query_root', Framework: Array<{ __typename?: 'Framework', name: string, reference: string }>, Framework_aggregate: { __typename?: 'Framework_aggregate', aggregate?: { __typename?: 'Framework_aggregate_fields', count: number } | null } };

export type AdminGetFrameworkQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetFrameworkQuery_ = { __typename?: 'query_root', Framework_by_pk?: { __typename?: 'Framework', name: string, reference: string } | null };

export type AdminDeleteFrameworkMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteFrameworkMutation_ = { __typename?: 'mutation_root', delete_Framework_by_pk?: { __typename?: 'Framework', reference: string } | null };

export type AdminUpdateFrameworkMutationVariables_ = Exact<{
  pk_columns: Framework_Pk_Columns_Input_;
  _set: Framework_Set_Input_;
}>;


export type AdminUpdateFrameworkMutation_ = { __typename?: 'mutation_root', update_Framework_by_pk?: { __typename?: 'Framework', name: string, reference: string } | null };

export type AdminCreateFrameworkMutationVariables_ = Exact<{
  object: Framework_Insert_Input_;
}>;


export type AdminCreateFrameworkMutation_ = { __typename?: 'mutation_root', insert_Framework_one?: { __typename?: 'Framework', name: string, reference: string } | null };

export type AdminGetFrameworkStructureQueryVariables_ = Exact<{
  frameworkRef: Scalars['String']['input'];
}>;


export type AdminGetFrameworkStructureQuery_ = { __typename?: 'query_root', framework?: { __typename?: 'Framework', reference: string, name: string, standards: Array<{ __typename?: 'EsrsStandard', reference: string, categoryRef: string, title: string, description?: string | null, order: number, disclosureRequirementGroups: Array<{ __typename?: 'DisclosureRequirementGroup', reference: string, standardRef: string, title: string, order: number, disclosureRequirements: Array<{ __typename?: 'DisclosureRequirement', reference: string, groupRef: string, title: string, description?: string | null, order: number, type: string, metrics: Array<{ __typename?: 'EsrsMetric', reference: string, disclosureRequirementRef: string }> }> }> }> } | null };

export type AdminDuplicateFrameworkStructureMutationVariables_ = Exact<{
  objects: Array<MfStandard_Insert_Input_> | MfStandard_Insert_Input_;
}>;


export type AdminDuplicateFrameworkStructureMutation_ = { __typename?: 'mutation_root', insert_MFStandard?: { __typename?: 'MFStandard_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'MFStandard', reference: string }> } | null };

export type AdminGetMfCategoriesQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfCategory_Order_By_> | MfCategory_Order_By_>;
  where?: InputMaybe<MfCategory_Bool_Exp_>;
}>;


export type AdminGetMfCategoriesQuery_ = { __typename?: 'query_root', MFCategory: Array<{ __typename?: 'MFCategory', title: string, reference: string, order: number }>, MFCategory_aggregate: { __typename?: 'MFCategory_aggregate', aggregate?: { __typename?: 'MFCategory_aggregate_fields', count: number } | null } };

export type AdminGetMfCategoryQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetMfCategoryQuery_ = { __typename?: 'query_root', MFCategory_by_pk?: { __typename?: 'MFCategory', title: string, reference: string, order: number } | null };

export type AdminDeleteMfCategoryMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteMfCategoryMutation_ = { __typename?: 'mutation_root', delete_MFCategory_by_pk?: { __typename?: 'MFCategory', reference: string } | null };

export type AdminUpdateMfCategoryMutationVariables_ = Exact<{
  pk_columns: MfCategory_Pk_Columns_Input_;
  _set: MfCategory_Set_Input_;
}>;


export type AdminUpdateMfCategoryMutation_ = { __typename?: 'mutation_root', update_MFCategory_by_pk?: { __typename?: 'MFCategory', title: string, reference: string, order: number } | null };

export type AdminCreateMfCategoryMutationVariables_ = Exact<{
  object: MfCategory_Insert_Input_;
}>;


export type AdminCreateMfCategoryMutation_ = { __typename?: 'mutation_root', insert_MFCategory_one?: { __typename?: 'MFCategory', title: string, reference: string, order: number } | null };

export type AdminGetMfStandardsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandard_Order_By_> | MfStandard_Order_By_>;
  where?: InputMaybe<MfStandard_Bool_Exp_>;
}>;


export type AdminGetMfStandardsQuery_ = { __typename?: 'query_root', MFStandard: Array<{ __typename?: 'MFStandard', title: string, reference: string, description?: string | null, order: number, mfCategoryRef: string }>, MFStandard_aggregate: { __typename?: 'MFStandard_aggregate', aggregate?: { __typename?: 'MFStandard_aggregate_fields', count: number } | null } };

export type AdminGetMfStandardQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetMfStandardQuery_ = { __typename?: 'query_root', MFStandard_by_pk?: { __typename?: 'MFStandard', title: string, reference: string, description?: string | null, order: number, mfCategoryRef: string } | null };

export type AdminDeleteMfStandardMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteMfStandardMutation_ = { __typename?: 'mutation_root', delete_MFStandard_by_pk?: { __typename?: 'MFStandard', reference: string } | null };

export type AdminUpdateMfStandardMutationVariables_ = Exact<{
  pk_columns: MfStandard_Pk_Columns_Input_;
  _set: MfStandard_Set_Input_;
}>;


export type AdminUpdateMfStandardMutation_ = { __typename?: 'mutation_root', update_MFStandard_by_pk?: { __typename?: 'MFStandard', title: string, reference: string, description?: string | null, order: number, mfCategoryRef: string } | null };

export type AdminCreateMfStandardMutationVariables_ = Exact<{
  object: MfStandard_Insert_Input_;
}>;


export type AdminCreateMfStandardMutation_ = { __typename?: 'mutation_root', insert_MFStandard_one?: { __typename?: 'MFStandard', title: string, reference: string, description?: string | null, order: number, mfCategoryRef: string } | null };

export type AdminGetMfStandardsItemsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfStandardItem_Order_By_> | MfStandardItem_Order_By_>;
  where?: InputMaybe<MfStandardItem_Bool_Exp_>;
}>;


export type AdminGetMfStandardsItemsQuery_ = { __typename?: 'query_root', MFStandardItem: Array<{ __typename?: 'MFStandardItem', id: any, standardRef: string, mfStandardRef: string, order: number }>, MFStandardItem_aggregate: { __typename?: 'MFStandardItem_aggregate', aggregate?: { __typename?: 'MFStandardItem_aggregate_fields', count: number } | null } };

export type AdminGetMfStandardItemQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminGetMfStandardItemQuery_ = { __typename?: 'query_root', MFStandardItem_by_pk?: { __typename?: 'MFStandardItem', id: any, standardRef: string, mfStandardRef: string, order: number } | null };

export type AdminDeleteMfStandardItemMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminDeleteMfStandardItemMutation_ = { __typename?: 'mutation_root', delete_MFStandardItem_by_pk?: { __typename?: 'MFStandardItem', id: any } | null };

export type AdminDeleteMfStandardItemByRefsMutationVariables_ = Exact<{
  mfStandardRef: Scalars['String']['input'];
  standardRef: Scalars['String']['input'];
}>;


export type AdminDeleteMfStandardItemByRefsMutation_ = { __typename?: 'mutation_root', delete_MFStandardItem?: { __typename?: 'MFStandardItem_mutation_response', returning: Array<{ __typename?: 'MFStandardItem', id: any, standardRef: string, mfStandardRef: string }> } | null };

export type AdminUpdateMfStandardItemMutationVariables_ = Exact<{
  pk_columns: MfStandardItem_Pk_Columns_Input_;
  _set: MfStandardItem_Set_Input_;
}>;


export type AdminUpdateMfStandardItemMutation_ = { __typename?: 'mutation_root', update_MFStandardItem_by_pk?: { __typename?: 'MFStandardItem', id: any, standardRef: string, mfStandardRef: string, order: number } | null };

export type AdminCreateMfStandardItemMutationVariables_ = Exact<{
  object: MfStandardItem_Insert_Input_;
}>;


export type AdminCreateMfStandardItemMutation_ = { __typename?: 'mutation_root', insert_MFStandardItem_one?: { __typename?: 'MFStandardItem', id: any, standardRef: string, mfStandardRef: string, order: number } | null };

export type AdminCreateMfStandardItemsMutationVariables_ = Exact<{
  objects: Array<MfStandardItem_Insert_Input_> | MfStandardItem_Insert_Input_;
}>;


export type AdminCreateMfStandardItemsMutation_ = { __typename?: 'mutation_root', insert_MFStandardItem?: { __typename?: 'MFStandardItem_mutation_response', returning: Array<{ __typename?: 'MFStandardItem', id: any, standardRef: string, mfStandardRef: string, order: number }> } | null };

export type AdminGetMfDisclosureRequirementGroupsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementGroup_Order_By_> | MfDisclosureRequirementGroup_Order_By_>;
  where?: InputMaybe<MfDisclosureRequirementGroup_Bool_Exp_>;
}>;


export type AdminGetMfDisclosureRequirementGroupsQuery_ = { __typename?: 'query_root', MFDisclosureRequirementGroup: Array<{ __typename?: 'MFDisclosureRequirementGroup', title: string, reference: string, order: number, mfStandardRef: string }>, MFDisclosureRequirementGroup_aggregate: { __typename?: 'MFDisclosureRequirementGroup_aggregate', aggregate?: { __typename?: 'MFDisclosureRequirementGroup_aggregate_fields', count: number } | null } };

export type AdminGetMfDisclosureRequirementGroupQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetMfDisclosureRequirementGroupQuery_ = { __typename?: 'query_root', MFDisclosureRequirementGroup_by_pk?: { __typename?: 'MFDisclosureRequirementGroup', title: string, reference: string, order: number, mfStandardRef: string } | null };

export type AdminDeleteMfDisclosureRequirementGroupMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteMfDisclosureRequirementGroupMutation_ = { __typename?: 'mutation_root', delete_MFDisclosureRequirementGroup_by_pk?: { __typename?: 'MFDisclosureRequirementGroup', reference: string } | null };

export type AdminUpdateMfDisclosureRequirementGroupMutationVariables_ = Exact<{
  pk_columns: MfDisclosureRequirementGroup_Pk_Columns_Input_;
  _set: MfDisclosureRequirementGroup_Set_Input_;
}>;


export type AdminUpdateMfDisclosureRequirementGroupMutation_ = { __typename?: 'mutation_root', update_MFDisclosureRequirementGroup_by_pk?: { __typename?: 'MFDisclosureRequirementGroup', title: string, reference: string, order: number, mfStandardRef: string } | null };

export type AdminCreateMfDisclosureRequirementGroupMutationVariables_ = Exact<{
  object: MfDisclosureRequirementGroup_Insert_Input_;
}>;


export type AdminCreateMfDisclosureRequirementGroupMutation_ = { __typename?: 'mutation_root', insert_MFDisclosureRequirementGroup_one?: { __typename?: 'MFDisclosureRequirementGroup', title: string, reference: string, order: number, mfStandardRef: string } | null };

export type AdminGetMfDisclosureRequirementsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirement_Order_By_> | MfDisclosureRequirement_Order_By_>;
  where?: InputMaybe<MfDisclosureRequirement_Bool_Exp_>;
}>;


export type AdminGetMfDisclosureRequirementsQuery_ = { __typename?: 'query_root', MFDisclosureRequirement: Array<{ __typename?: 'MFDisclosureRequirement', title: string, reference: string, order: number, mfDisclosureRequirementGroupRef: string, type: string, description?: string | null }>, MFDisclosureRequirement_aggregate: { __typename?: 'MFDisclosureRequirement_aggregate', aggregate?: { __typename?: 'MFDisclosureRequirement_aggregate_fields', count: number } | null } };

export type AdminGetMfDisclosureRequirementQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminGetMfDisclosureRequirementQuery_ = { __typename?: 'query_root', MFDisclosureRequirement_by_pk?: { __typename?: 'MFDisclosureRequirement', title: string, reference: string, order: number, mfDisclosureRequirementGroupRef: string, type: string, description?: string | null } | null };

export type AdminDeleteMfDisclosureRequirementMutationVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type AdminDeleteMfDisclosureRequirementMutation_ = { __typename?: 'mutation_root', delete_MFDisclosureRequirement_by_pk?: { __typename?: 'MFDisclosureRequirement', reference: string } | null };

export type AdminUpdateMfDisclosureRequirementMutationVariables_ = Exact<{
  pk_columns: MfDisclosureRequirement_Pk_Columns_Input_;
  _set: MfDisclosureRequirement_Set_Input_;
}>;


export type AdminUpdateMfDisclosureRequirementMutation_ = { __typename?: 'mutation_root', update_MFDisclosureRequirement_by_pk?: { __typename?: 'MFDisclosureRequirement', title: string, reference: string, order: number, mfDisclosureRequirementGroupRef: string, type: string, description?: string | null } | null };

export type AdminCreateMfDisclosureRequirementMutationVariables_ = Exact<{
  object: MfDisclosureRequirement_Insert_Input_;
}>;


export type AdminCreateMfDisclosureRequirementMutation_ = { __typename?: 'mutation_root', insert_MFDisclosureRequirement_one?: { __typename?: 'MFDisclosureRequirement', title: string, reference: string, order: number, mfDisclosureRequirementGroupRef: string, type: string, description?: string | null } | null };

export type AdminGetMfDisclosureRequirementItemsQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<MfDisclosureRequirementItem_Order_By_> | MfDisclosureRequirementItem_Order_By_>;
  where?: InputMaybe<MfDisclosureRequirementItem_Bool_Exp_>;
}>;


export type AdminGetMfDisclosureRequirementItemsQuery_ = { __typename?: 'query_root', MFDisclosureRequirementItem: Array<{ __typename?: 'MFDisclosureRequirementItem', id: any, mfDisclosureRequirementRef: string, metricRef: string, order: number, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string } }>, MFDisclosureRequirementItem_aggregate: { __typename?: 'MFDisclosureRequirementItem_aggregate', aggregate?: { __typename?: 'MFDisclosureRequirementItem_aggregate_fields', count: number } | null } };

export type AdminGetMfDisclosureRequirementItemQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminGetMfDisclosureRequirementItemQuery_ = { __typename?: 'query_root', MFDisclosureRequirementItem_by_pk?: { __typename?: 'MFDisclosureRequirementItem', id: any, mfDisclosureRequirementRef: string, metricRef: string, order: number } | null };

export type AdminDeleteMfDisclosureRequirementItemMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type AdminDeleteMfDisclosureRequirementItemMutation_ = { __typename?: 'mutation_root', delete_MFDisclosureRequirementItem_by_pk?: { __typename?: 'MFDisclosureRequirementItem', id: any } | null };

export type AdminDeleteMfDisclosureRequirementItemByRefsMutationVariables_ = Exact<{
  mfDisclosureRequirementRef: Scalars['String']['input'];
  metricRef: Scalars['String']['input'];
}>;


export type AdminDeleteMfDisclosureRequirementItemByRefsMutation_ = { __typename?: 'mutation_root', delete_MFDisclosureRequirementItem?: { __typename?: 'MFDisclosureRequirementItem_mutation_response', returning: Array<{ __typename?: 'MFDisclosureRequirementItem', id: any, mfDisclosureRequirementRef: string, metricRef: string }> } | null };

export type AdminUpdateMfDisclosureRequirementItemMutationVariables_ = Exact<{
  pk_columns: MfDisclosureRequirementItem_Pk_Columns_Input_;
  _set: MfDisclosureRequirementItem_Set_Input_;
}>;


export type AdminUpdateMfDisclosureRequirementItemMutation_ = { __typename?: 'mutation_root', update_MFDisclosureRequirementItem_by_pk?: { __typename?: 'MFDisclosureRequirementItem', id: any, mfDisclosureRequirementRef: string, metricRef: string, order: number } | null };

export type AdminCreateMfDisclosureRequirementItemMutationVariables_ = Exact<{
  object: MfDisclosureRequirementItem_Insert_Input_;
}>;


export type AdminCreateMfDisclosureRequirementItemMutation_ = { __typename?: 'mutation_root', insert_MFDisclosureRequirementItem_one?: { __typename?: 'MFDisclosureRequirementItem', id: any, mfDisclosureRequirementRef: string, metricRef: string, order: number } | null };

export type AdminCreateMfDisclosureRequirementItemsMutationVariables_ = Exact<{
  objects: Array<MfDisclosureRequirementItem_Insert_Input_> | MfDisclosureRequirementItem_Insert_Input_;
}>;


export type AdminCreateMfDisclosureRequirementItemsMutation_ = { __typename?: 'mutation_root', insert_MFDisclosureRequirementItem?: { __typename?: 'MFDisclosureRequirementItem_mutation_response', returning: Array<{ __typename?: 'MFDisclosureRequirementItem', id: any, mfDisclosureRequirementRef: string, metricRef: string, order: number }> } | null };

export type AdminGetDrToMfDisclosureRequirementQueryVariables_ = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<Array<DrToMfDisclosureRequirement_Order_By_> | DrToMfDisclosureRequirement_Order_By_>;
  where?: InputMaybe<DrToMfDisclosureRequirement_Bool_Exp_>;
}>;


export type AdminGetDrToMfDisclosureRequirementQuery_ = { __typename?: 'query_root', DRToMFDisclosureRequirement: Array<{ __typename?: 'DRToMFDisclosureRequirement', id: any, disclosureRequirementRef: string, mfDisclosureRequirementRef: string }>, DRToMFDisclosureRequirement_aggregate: { __typename?: 'DRToMFDisclosureRequirement_aggregate', aggregate?: { __typename?: 'DRToMFDisclosureRequirement_aggregate_fields', count: number } | null } };

export type AdminDeleteDrToMfDisclosureRequirementMutationVariables_ = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type AdminDeleteDrToMfDisclosureRequirementMutation_ = { __typename?: 'mutation_root', delete_DRToMFDisclosureRequirement?: { __typename?: 'DRToMFDisclosureRequirement_mutation_response', returning: Array<{ __typename?: 'DRToMFDisclosureRequirement', id: any }> } | null };

export type AdminInsertDrtomfDisclosureRequirementMutationVariables_ = Exact<{
  objects: Array<DrToMfDisclosureRequirement_Insert_Input_> | DrToMfDisclosureRequirement_Insert_Input_;
}>;


export type AdminInsertDrtomfDisclosureRequirementMutation_ = { __typename?: 'mutation_root', insert_DRToMFDisclosureRequirement?: { __typename?: 'DRToMFDisclosureRequirement_mutation_response', returning: Array<{ __typename?: 'DRToMFDisclosureRequirement', id: any }> } | null };

export type CompanyAssessmentsQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type CompanyAssessmentsQuery_ = { __typename?: 'query_root', assessments: Array<{ __typename?: 'CompanyAssessment', id: any, startDate: any, endDate: any, isLocked: boolean, createdAt: any, deletedAt?: any | null, cachedResultId?: any | null, updatedAt: any, aggregate: { __typename?: 'CompanyAssessmentAggregate', id: any, title: string, interval: string, startDate: any, contactPerson?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }, bAssesssments: Array<{ __typename?: 'BusinessUnitAssessment', updatedAt: any, activityReports: Array<{ __typename?: 'ActivityReport', answers: Array<{ __typename?: 'Answer', updatedAt: any }> }>, lastEditedFinancials: Array<{ __typename?: 'ActivityReport', financials?: { __typename?: 'Financials', updatedAt: any } | null }> }>, portfoliosWithAccess: Array<{ __typename?: 'PortfolioCompany', quarter: QuarterEnum_Enum_, year?: number | null, contactPersonName?: string | null, contactPersonEmail?: string | null, portfolio: { __typename?: 'Portfolio', name: string, ownerCompany: { __typename?: 'Company', name: string } } }> }> };

export type GroupCompanyAssessmentNameQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GroupCompanyAssessmentNameQuery_ = { __typename?: 'query_root', assessment: Array<{ __typename?: 'GroupAssessment', name: string }> };

export type CompanyAssessmentQueryVariables_ = Exact<{
  cAssessmentId: Scalars['uuid']['input'];
}>;


export type CompanyAssessmentQuery_ = { __typename?: 'query_root', companyAssessment?: { __typename?: 'CompanyAssessment', id: any, startDate: any, endDate: any, isLocked: boolean, createdAt: any, deletedAt?: any | null, cachedResultId?: any | null, updatedAt: any, generalAssessment: Array<{ __typename?: 'BusinessUnitAssessment', id: any, cAssessmentId: any, deletedAt?: any | null, hasGeneralAssessment: boolean, orderIndex?: any | null, businessUnit?: { __typename?: 'BusinessUnit', id: any, createdAt: any, name: string, companyId: any, description?: string | null, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, generalAssessment: Array<{ __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, activityReports: Array<{ __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, reportingGroup?: { __typename?: 'ReportingGroup', id: any } | null }>, bAssessments: Array<{ __typename?: 'BusinessUnitAssessment', id: any, cAssessmentId: any, deletedAt?: any | null, hasGeneralAssessment: boolean, orderIndex?: any | null, businessUnit?: { __typename?: 'BusinessUnit', id: any, createdAt: any, name: string, companyId: any, description?: string | null, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, generalAssessment: Array<{ __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, activityReports: Array<{ __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, reportingGroup?: { __typename?: 'ReportingGroup', id: any } | null }>, aggregate: { __typename?: 'CompanyAssessmentAggregate', id: any, title: string, interval: string, startDate: any, contactPerson?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }, bAssesssments: Array<{ __typename?: 'BusinessUnitAssessment', updatedAt: any, activityReports: Array<{ __typename?: 'ActivityReport', answers: Array<{ __typename?: 'Answer', updatedAt: any }> }>, lastEditedFinancials: Array<{ __typename?: 'ActivityReport', financials?: { __typename?: 'Financials', updatedAt: any } | null }> }>, portfoliosWithAccess: Array<{ __typename?: 'PortfolioCompany', quarter: QuarterEnum_Enum_, year?: number | null, contactPersonName?: string | null, contactPersonEmail?: string | null, portfolio: { __typename?: 'Portfolio', name: string, ownerCompany: { __typename?: 'Company', name: string } } }> } | null };

export type CompanyAssessmentTitleQueryVariables_ = Exact<{
  cAssessmentId: Scalars['uuid']['input'];
}>;


export type CompanyAssessmentTitleQuery_ = { __typename?: 'query_root', companyAssessment?: { __typename?: 'CompanyAssessment', id: any, aggregate: { __typename?: 'CompanyAssessmentAggregate', id: any, title: string } } | null };

export type CompanyAssessmentIsLockedQueryVariables_ = Exact<{
  cAssessmentId: Scalars['uuid']['input'];
}>;


export type CompanyAssessmentIsLockedQuery_ = { __typename?: 'query_root', companyAssessment?: { __typename?: 'CompanyAssessment', id: any, isLocked: boolean } | null };

export type CompanyAssessmentFormQueryVariables_ = Exact<{
  cAssessmentId: Scalars['uuid']['input'];
}>;


export type CompanyAssessmentFormQuery_ = { __typename?: 'query_root', companyAssessment?: { __typename?: 'CompanyAssessment', id: any, startDate: any, isLocked: boolean, cachedResultId?: any | null, aggregate: { __typename?: 'CompanyAssessmentAggregate', id: any, title: string, contactPerson?: { __typename?: 'users', id: any } | null }, bAssessments: Array<{ __typename?: 'BusinessUnitAssessment', id: any, deletedAt?: any | null, businessUnit?: { __typename?: 'BusinessUnit', id: any } | null }> } | null };

export type ActivityAssessmentAnswersQueryVariables_ = Exact<{
  activityAssessmentId: Scalars['uuid']['input'];
  version: Scalars['Int']['input'];
}>;


export type ActivityAssessmentAnswersQuery_ = { __typename?: 'query_root', answers: Array<{ __typename?: 'Answer', flagged?: boolean | null, id: any, questionId: any, updatedAt: any, createdAt: any, data?: any | null, reportId?: any | null, answeredBy: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string }, question: { __typename?: 'Question', id: any, uniqueId: string }, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, thread?: { __typename?: 'Thread', id: any, commentsAggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null }, comments: Array<{ __typename?: 'Comment', id: any, data: string }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }> };

export type GetActivityAssessmentVersionQueryVariables_ = Exact<{
  activityAssessmentId: Scalars['uuid']['input'];
}>;


export type GetActivityAssessmentVersionQuery_ = { __typename?: 'query_root', activityAssessment?: { __typename?: 'ActivityReport', id: any, activityRef: string, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessment: { __typename?: 'BusinessUnitAssessment', cAssessment: { __typename?: 'CompanyAssessment', startDate: any } }, activity: { __typename?: 'Activity', name: string, currentVersion?: { __typename?: 'ActivityVersion', validFrom: any, versionNumber: number, changeDescription: string } | null } } | null };

export type ActivityAssessmentQueryVariables_ = Exact<{
  activityAssessmentId: Scalars['uuid']['input'];
  version: Scalars['Int']['input'];
  prevVersion: Scalars['Int']['input'];
}>;


export type ActivityAssessmentQuery_ = { __typename?: 'query_root', activityAssessment?: { __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, bAssessment: { __typename?: 'BusinessUnitAssessment', cAssessment: { __typename?: 'CompanyAssessment', bAssesssments: Array<{ __typename?: 'BusinessUnitAssessment', activityReports: Array<{ __typename?: 'ActivityReport', cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null }> }> } }, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null } | null, objectives: Array<{ __typename?: 'Objective', title: string, key: string, questions: Array<{ __typename?: 'Question', id: any, title: string, questionSetRef?: string | null, description?: string | null, type: QuestionType_Enum_, level: QuestionLevel_Enum_, levelExpression?: string | null, group?: string | null, orderIndex: string, uniqueId: string, unit?: string | null, resourceLink?: string | null, documentationRequired: boolean, aboutDocumentation?: string | null, alignmentErrorMessage?: string | null, isVisible?: string | null, isEditable?: string | null, isRequired?: string | null, isAligned?: string | null, dependencyDescription?: string | null, extendedDescription?: string | null, other?: any | null, learnMoreArticleSlug?: string | null, answers: Array<{ __typename?: 'Answer', id: any, questionId: any, updatedAt: any, createdAt: any, data?: any | null, reportId?: any | null, thread?: { __typename?: 'Thread', id: any, commentsAggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null }>, olderRevisions: Array<{ __typename?: 'QuestionRevision', description: string, oldQuestion: { __typename?: 'Question', id: any } }>, questionSets: Array<{ __typename?: 'QuestionSetQuestion', questionSet: { __typename?: 'QuestionSet', reference: string } }>, objective: { __typename?: 'Objective', key: string, title: string }, choices: Array<{ __typename?: 'QuestionChoice', value: string, displayName: string, order: string }> }> }> };

export type OldActivityAssessmentQueryVariables_ = Exact<{
  activityAssessmentId: Scalars['uuid']['input'];
  currentVersion: Scalars['Int']['input'];
  previousVersion: Scalars['Int']['input'];
}>;


export type OldActivityAssessmentQuery_ = { __typename?: 'query_root', objectives: Array<{ __typename?: 'Objective', title: string, key: string, oldQuestions: Array<{ __typename?: 'Question', id: any, newerRevisions: Array<{ __typename?: 'QuestionRevision', description: string, newQuestion: { __typename?: 'Question', id: any } }> }> }> };

export type AllActivityAssessmentsWithVersionQueryVariables_ = Exact<{
  cAssessmentId: Scalars['uuid']['input'];
}>;


export type AllActivityAssessmentsWithVersionQuery_ = { __typename?: 'query_root', ActivityReport: Array<{ __typename?: 'ActivityReport', id: any, activityRef: string, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessment: { __typename?: 'BusinessUnitAssessment', id: any, cAssessment: { __typename?: 'CompanyAssessment', id: any, isLocked: boolean, startDate: any, cachedResultId?: any | null } }, activity: { __typename?: 'Activity', name: string, currentVersion?: { __typename?: 'ActivityVersion', validFrom: any, versionNumber: number, changeDescription: string } | null, versions: Array<{ __typename?: 'ActivityVersion', validFrom: any, versionNumber: number, changeDescription: string }> } }> };

export type ValidActivityVersionsQueryVariables_ = Exact<{
  activityRef: Scalars['String']['input'];
  startDate: Scalars['date']['input'];
}>;


export type ValidActivityVersionsQuery_ = { __typename?: 'query_root', activity?: { __typename?: 'Activity', currentQuestionSetVersion?: number | null, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, validFrom: any }> } | null };

export type ValidActivityVersionsForCompanyQueryVariables_ = Exact<{
  activityRef: Scalars['String']['input'];
  startDate: Scalars['date']['input'];
  cAssessmentId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type ValidActivityVersionsForCompanyQuery_ = { __typename?: 'query_root', activity?: { __typename?: 'Activity', currentQuestionSetVersion?: number | null, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, validFrom: any }>, versionsInCompanyAssessment: Array<{ __typename?: 'ActivityReport', activityVersionNumber: number }> } | null };

export type ValidActivityVersionsManyQueryVariables_ = Exact<{
  activityRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
  startDate: Scalars['date']['input'];
}>;


export type ValidActivityVersionsManyQuery_ = { __typename?: 'query_root', activity: Array<{ __typename?: 'Activity', currentQuestionSetVersion?: number | null, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, validFrom: any }> }> };

export type DuplicationCompanyAssessmentQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DuplicationCompanyAssessmentQuery_ = { __typename?: 'query_root', assessment?: { __typename?: 'CompanyAssessment', id: any, companyId: any, aggregate: { __typename?: 'CompanyAssessmentAggregate', title: string, interval: string, contactPerson?: { __typename?: 'users', id: any } | null }, totalComparisonFinancials?: { __typename?: 'TotalComparisonFinancials', id?: any | null, revenue?: any | null, capex?: any | null, opex?: any | null, adaptationCapex?: any | null, adaptationOpex?: any | null, isEstimate?: boolean | null } | null, nonMaterialFinancials?: { __typename?: 'NonMaterialFinancials', id?: any | null, revenue?: any | null, capex?: any | null, opex?: any | null, adaptationCapex?: any | null, adaptationOpex?: any | null, isEstimate?: boolean | null } | null, generalAssessment: Array<{ __typename?: 'BusinessUnitAssessment', cAssessmentId: any, orderIndex?: any | null, hasGeneralAssessment: boolean, reportingGroupId?: any | null, activityReports: Array<{ __typename?: 'ActivityReport', activityRef: string, activityVersionNumber: number, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, authorId: any }> } | null } | null, answers: Array<{ __typename?: 'Answer', data?: any | null, answeredById: any, questionId: any, thread?: { __typename?: 'Thread', comments: Array<{ __typename?: 'Comment', id: any, data: string, authorId: any, createdAt: any, updatedAt: any, duplicatedFrom?: any | null }>, subscribers: Array<{ __typename?: 'ThreadSubscriber', userId: any }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, authorId: any }> } | null }>, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, authorId: any }> } | null }> }>, businessUnits: Array<{ __typename?: 'BusinessUnitAssessment', id: any, reportingGroupId?: any | null, cAssessmentId: any, businessUnit?: { __typename?: 'BusinessUnit', id: any, name: string } | null }> } | null, reportingGroups: Array<{ __typename?: 'ReportingGroup', id: any, ownerId?: any | null, name: string, orderIndex: any, parentId?: any | null, businessUnits: Array<{ __typename?: 'BusinessUnitAssessment', businessUnitId?: any | null }> }> };

export type DuplicationBusinessUnitAssessmentQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DuplicationBusinessUnitAssessmentQuery_ = { __typename?: 'query_root', assessment?: { __typename?: 'BusinessUnitAssessment', id: any, cAssessmentId: any, orderIndex?: any | null, hasGeneralAssessment: boolean, reportingGroupId?: any | null, businessUnit?: { __typename?: 'BusinessUnit', id: any, name: string, companyId: any, contactPersonId: any, description?: string | null, labels: any } | null, activityReports: Array<{ __typename?: 'ActivityReport', activityRef: string, activityVersionNumber: number, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, authorId: any }> } | null } | null, answers: Array<{ __typename?: 'Answer', data?: any | null, answeredById: any, questionId: any, thread?: { __typename?: 'Thread', comments: Array<{ __typename?: 'Comment', id: any, data: string, authorId: any, createdAt: any, updatedAt: any, duplicatedFrom?: any | null }>, subscribers: Array<{ __typename?: 'ThreadSubscriber', userId: any }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, authorId: any }> } | null }>, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, authorId: any }> } | null }> } | null };

export type PortfolioBulkAssessmentExportQueryVariables_ = Exact<{
  ownerCompanyId: Scalars['uuid']['input'];
  activityRef: Scalars['String']['input'];
  activityVersion: Scalars['Int']['input'];
  reportingPeriod: Scalars['Int']['input'];
  startDate: Scalars['date']['input'];
  endDate: Scalars['date']['input'];
  isCompanyLevel?: Scalars['Boolean']['input'];
}>;


export type PortfolioBulkAssessmentExportQuery_ = { __typename?: 'query_root', activity?: { __typename?: 'Activity', name: string, reference: string, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, validFrom: any }> } | null, objectives: Array<{ __typename?: 'Objective', title: string, key: string, questions: Array<{ __typename?: 'Question', id: any, title: string, type: QuestionType_Enum_, group?: string | null, orderIndex: string, uniqueId: string, unit?: string | null, isAligned?: string | null, isEditable?: string | null, isVisible?: string | null, objective: { __typename?: 'Objective', key: string, title: string }, choices: Array<{ __typename?: 'QuestionChoice', value: string, displayName: string, order: string }> }> }>, assessments: Array<{ __typename?: 'CompanyAssessment', id: any, company: { __typename?: 'Company', name: string, id: any, portfolioMemberships: Array<{ __typename?: 'PortfolioCompany', year?: number | null, contactPersonName?: string | null, contactPersonEmail?: string | null, marketValue?: any | null, valueOfInvestments?: any | null, sharedCompanyAssessmentId?: any | null, portfolio: { __typename?: 'Portfolio', id: any, name: string } }> }, aggregate: { __typename?: 'CompanyAssessmentAggregate', title: string, startDate: any }, bAssesssments: Array<{ __typename?: 'BusinessUnitAssessment', hasGeneralAssessment: boolean, id: any, businessUnit?: { __typename?: 'BusinessUnit', name: string, id: any } | null, activityReports: Array<{ __typename?: 'ActivityReport', id: any, activityRef: string, answers: Array<{ __typename?: 'Answer', id: any, questionId: any, reportId?: any | null, data?: any | null, updatedAt: any, answeredBy: { __typename?: 'users', id: any, email?: any | null }, noteHistory?: { __typename?: 'NoteHistory', id: any } | null }> }> }> }> };

export type PortfolioBulkNotesExportQueryVariables_ = Exact<{
  noteHistoryIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type PortfolioBulkNotesExportQuery_ = { __typename?: 'query_root', notes: Array<{ __typename?: 'Note', noteHistoryId: any, id: any, body?: string | null, updatedAt: any }> };

export type DeleteCompanyAssessmentMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type DeleteCompanyAssessmentMutation_ = { __typename?: 'mutation_root', update_CompanyAssessment_by_pk?: { __typename?: 'CompanyAssessment', id: any, deletedAt?: any | null } | null };

export type UpsertActivityReportsMutationVariables_ = Exact<{
  activityReports: Array<ActivityReport_Insert_Input_> | ActivityReport_Insert_Input_;
}>;


export type UpsertActivityReportsMutation_ = { __typename?: 'mutation_root', activityReport?: { __typename?: 'ActivityReport_mutation_response', returning: Array<{ __typename?: 'ActivityReport', deletedAt?: any | null, id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, activityQuestionSets: Array<{ __typename?: 'ActivityQuestionSet', questionSet: { __typename?: 'QuestionSet', reference: string, activityQuestionSets: Array<{ __typename?: 'ActivityQuestionSet', activityRef: string }>, questions: Array<{ __typename?: 'QuestionSetQuestion', question: { __typename?: 'Question', id: any, title: string, questionSetRef?: string | null, description?: string | null, type: QuestionType_Enum_, level: QuestionLevel_Enum_, levelExpression?: string | null, group?: string | null, orderIndex: string, uniqueId: string, unit?: string | null, resourceLink?: string | null, documentationRequired: boolean, aboutDocumentation?: string | null, alignmentErrorMessage?: string | null, isVisible?: string | null, isEditable?: string | null, isRequired?: string | null, isAligned?: string | null, dependencyDescription?: string | null, extendedDescription?: string | null, other?: any | null, learnMoreArticleSlug?: string | null, questionSets: Array<{ __typename?: 'QuestionSetQuestion', questionSet: { __typename?: 'QuestionSet', reference: string } }>, objective: { __typename?: 'Objective', key: string, title: string }, choices: Array<{ __typename?: 'QuestionChoice', value: string, displayName: string, order: string }> } }> } }>, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }> } | null };

export type UpsertCompanyAssessmentMutationVariables_ = Exact<{
  cAssessment: CompanyAssessment_Insert_Input_;
}>;


export type UpsertCompanyAssessmentMutation_ = { __typename?: 'mutation_root', cAssessment?: { __typename?: 'CompanyAssessment', id: any, startDate: any, endDate: any, isLocked: boolean, createdAt: any, deletedAt?: any | null, companyId: any, cachedResultId?: any | null, aggregate: { __typename?: 'CompanyAssessmentAggregate', id: any, title: string, interval: string, startDate: any, companyId: any, createdAt: any, company: { __typename?: 'Company', id: any, name: string, cAssessmentAggregates: Array<{ __typename?: 'CompanyAssessmentAggregate', id: any }> }, contactPerson?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, cAssessments: Array<{ __typename?: 'CompanyAssessment', id: any, startDate: any, endDate: any, isLocked: boolean }> }, bAssessments: Array<{ __typename?: 'BusinessUnitAssessment', id: any, cAssessmentId: any, deletedAt?: any | null, hasGeneralAssessment: boolean, orderIndex?: any | null, businessUnit?: { __typename?: 'BusinessUnit', id: any, createdAt: any, name: string, companyId: any, description?: string | null, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, generalAssessment: Array<{ __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, activityReports: Array<{ __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, reportingGroup?: { __typename?: 'ReportingGroup', id: any } | null }>, deletedBAssessments: Array<{ __typename?: 'BusinessUnitAssessment', id: any, cAssessmentId: any, deletedAt?: any | null, hasGeneralAssessment: boolean, orderIndex?: any | null, businessUnit?: { __typename?: 'BusinessUnit', id: any, createdAt: any, name: string, companyId: any, description?: string | null, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, generalAssessment: Array<{ __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, activityReports: Array<{ __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, reportingGroup?: { __typename?: 'ReportingGroup', id: any } | null }> } | null };

export type InsertBusinessUnitAssessmentMutationVariables_ = Exact<{
  bAssessment: BusinessUnitAssessment_Insert_Input_;
}>;


export type InsertBusinessUnitAssessmentMutation_ = { __typename?: 'mutation_root', bAssessment?: { __typename?: 'BusinessUnitAssessment', cAssessmentId: any, businessUnit?: { __typename?: 'BusinessUnit', id: any, name: string } | null } | null };

export type InsertNewTotalFinancialsMutationVariables_ = Exact<{
  financials: Financials_Insert_Input_;
}>;


export type InsertNewTotalFinancialsMutation_ = { __typename?: 'mutation_root', financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null };

export type UpdateAssessmentLockMutationVariables_ = Exact<{
  companyAssessmentId: Scalars['uuid']['input'];
  isLocked: Scalars['Boolean']['input'];
}>;


export type UpdateAssessmentLockMutation_ = { __typename?: 'mutation_root', update_CompanyAssessment_by_pk?: { __typename?: 'CompanyAssessment', id: any, isLocked: boolean } | null };

export type UpdateActivityAssessmentVersionMutationVariables_ = Exact<{
  updates: Array<ActivityReport_Updates_> | ActivityReport_Updates_;
}>;


export type UpdateActivityAssessmentVersionMutation_ = { __typename?: 'mutation_root', update_ActivityReport_many?: Array<{ __typename?: 'ActivityReport_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null }> } | null> | null };

export type GetCompanyAssessmentsActivitiesQueryVariables_ = Exact<{
  companyIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  startDate: Scalars['date']['input'];
}>;


export type GetCompanyAssessmentsActivitiesQuery_ = { __typename?: 'query_root', companies: Array<{ __typename?: 'Company', cAssessments: Array<{ __typename?: 'CompanyAssessment', bAssesssments: Array<{ __typename?: 'BusinessUnitAssessment', activityReports: Array<{ __typename?: 'ActivityReport', activityRef: string }> }> }> }> };

export type CompanyAssessmentContextQueryVariables_ = Exact<{
  cAssessmentId: Scalars['uuid']['input'];
}>;


export type CompanyAssessmentContextQuery_ = { __typename?: 'query_root', company?: { __typename?: 'CompanyAssessment', id: any, portfoliosWithAccess: Array<{ __typename?: 'PortfolioCompany', id: any, sharedCompanyAssessmentId?: any | null, year?: number | null, portfolio: { __typename?: 'Portfolio', id: any, name: string, ownerCompany: { __typename?: 'Company', id: any, name: string } } }>, company: { __typename?: 'Company', id: any, files: Array<{ __typename?: 'DocumentationFile', id: any, title: string, storageFile?: { __typename?: 'files', id: any, name?: string | null } | null }>, users: Array<{ __typename?: 'CompanyUser', user: { __typename?: 'users', id: any, displayName: string } }> }, aggregate: { __typename?: 'CompanyAssessmentAggregate', id: any, title: string, startDate: any, contactPersonId?: any | null }, cachedResult?: { __typename?: 'CachedResult', id: any } | null, totalComparisonFinancials?: { __typename?: 'TotalComparisonFinancials', id?: any | null, reportId?: any | null, capex?: any | null, opex?: any | null, revenue?: any | null, adaptationOpex?: any | null, adaptationCapex?: any | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', id: any, body?: string | null }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any }> } | null } | null, nonMaterialFinancials?: { __typename?: 'NonMaterialFinancials', id?: any | null, reportId?: any | null, capex?: any | null, opex?: any | null, revenue?: any | null, adaptationOpex?: any | null, adaptationCapex?: any | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', id: any, body?: string | null }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any }> } | null } | null, bAssesssments: Array<{ __typename?: 'BusinessUnitAssessment', id: any }>, reportingGroups: Array<{ __typename?: 'ReportingGroup', id: any, name: string, parent?: { __typename?: 'ReportingGroup', id: any, name: string } | null }> } | null, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, year?: number | null, portfolio: { __typename?: 'Portfolio', id: any, name: string, ownerCompany: { __typename?: 'Company', id: any, name: string } } }> };

export type BusinessUnitAssessmentQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type BusinessUnitAssessmentQuery_ = { __typename?: 'query_root', bAssessment?: { __typename?: 'BusinessUnitAssessment', id: any, hasGeneralAssessment: boolean, businessUnit?: { __typename?: 'BusinessUnit', name: string, id: any } | null, reportingGroup?: { __typename?: 'ReportingGroup', id: any, name: string } | null, cachedResult?: { __typename?: 'CachedResult', id: any } | null, activityReports: Array<{ __typename?: 'ActivityReport', id: any, activityRef: string, activity: { __typename?: 'Activity', name: string }, cachedResult?: { __typename?: 'CachedResult', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', id: any, body?: string | null }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any }> } | null, answers: Array<{ __typename?: 'Answer', id: any, question: { __typename?: 'Question', title: string, type: QuestionType_Enum_ }, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', id: any, body?: string | null }> } | null, thread?: { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any, authorId: any, data: string }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any }> } | null }>, financials?: { __typename?: 'Financials', id: any, reportId?: any | null, capex: any, opex: any, revenue: any, adaptationOpex: any, adaptationCapex: any, activityReport?: { __typename?: 'ActivityReport', id: any, bAssessment: { __typename?: 'BusinessUnitAssessment', id: any } } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', id: any, body?: string | null }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any }> } | null } | null }> } | null };

export type EsrsAssessmentContextQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type EsrsAssessmentContextQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, owner?: { __typename?: 'users', displayName: string } | null, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choice: { __typename?: 'EsrsChoice', reference: string, title: string } }> }>, metric: { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, metricType?: QuestionType_Enum_ | null, requirement: { __typename?: 'DisclosureRequirement', title: string, reference: string, group: { __typename?: 'DisclosureRequirementGroup', standard: { __typename?: 'EsrsStandard', title: string, reference: string } } } } }> }>, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standard: { __typename?: 'EsrsStandard', reference: string, title: string }, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, title: string, shortTitle?: string | null, reference: string, requirement: { __typename?: 'DisclosureRequirement', title: string } } }> }> } | null };

export type AuditLogEntriesQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type AuditLogEntriesQuery_ = { __typename?: 'query_root', auditLogEntries: Array<{ __typename?: 'AuditLogEntry', invocationId: any, timestamp: any, newData?: any | null, oldData?: any | null, operation: string, table: string, schema: string, userId?: any | null, companyId?: any | null, user?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }> };

export type EsrsAuditLogEntriesQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type EsrsAuditLogEntriesQuery_ = { __typename?: 'query_root', auditLogEntries: Array<{ __typename?: 'AuditLogEntry', invocationId: any, timestamp: any, newData?: any | null, oldData?: any | null, operation: string, table: string, schema: string, userId?: any | null, companyId?: any | null, user?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }> };

export type BusinessUnitsQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type BusinessUnitsQuery_ = { __typename?: 'query_root', businessunits: Array<{ __typename?: 'BusinessUnit', id: any, name: string, labels: any, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string }, cAssessmentIds: Array<{ __typename?: 'BusinessUnitAssessment', cAssessmentId: any, cachedResultId?: any | null }>, deletedCAssessmentIds: Array<{ __typename?: 'BusinessUnitAssessment', cAssessmentId: any }> }> };

export type SimpleBusinessUnitQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type SimpleBusinessUnitQuery_ = { __typename?: 'query_root', businessUnit?: { __typename?: 'BusinessUnit', id: any, name: string, labels: any, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string }, cAssessmentIds: Array<{ __typename?: 'BusinessUnitAssessment', cAssessmentId: any, cachedResultId?: any | null }>, deletedCAssessmentIds: Array<{ __typename?: 'BusinessUnitAssessment', cAssessmentId: any }> } | null };

export type BusinessUnitQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type BusinessUnitQuery_ = { __typename?: 'query_root', businessUnit?: { __typename?: 'BusinessUnit', companyId: any, contactPersonId: any, id: any, name: string, labels: any, bAssessments: Array<{ __typename?: 'BusinessUnitAssessment', id: any, cAssessmentId: any, orderIndex?: any | null, hasGeneralAssessment: boolean, reportingGroupId?: any | null, cAssessment: { __typename?: 'CompanyAssessment', cachedResultId?: any | null, id: any, isLocked: boolean }, activityReports: Array<{ __typename?: 'ActivityReport', activityRef: string, activityVersionNumber: number, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, answers: Array<{ __typename?: 'Answer', data?: any | null, answeredById: any, questionId: any, flagged?: boolean | null, attachmentBox?: { __typename?: 'AttachmentBox', attachments: Array<{ __typename?: 'Attachment', fileId: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, authorId: any }> } | null }>, attachmentBox?: { __typename?: 'AttachmentBox', attachments: Array<{ __typename?: 'Attachment', fileId: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, authorId: any }> } | null }> }>, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string }, cAssessmentIds: Array<{ __typename?: 'BusinessUnitAssessment', cAssessmentId: any, cachedResultId?: any | null }>, deletedCAssessmentIds: Array<{ __typename?: 'BusinessUnitAssessment', cAssessmentId: any }> } | null };

export type GetBusinessUnitReportingGroupQueryVariables_ = Exact<{
  businessUnitId: Scalars['uuid']['input'];
  cAssessmentId: Scalars['uuid']['input'];
}>;


export type GetBusinessUnitReportingGroupQuery_ = { __typename?: 'query_root', group: Array<{ __typename?: 'BusinessUnitAssessment', businessUnitId?: any | null, id?: any | null, reportingGroup?: { __typename?: 'ReportingGroup', name: string, id: any } | null }> };

export type UpdateBAssessmentsCompanyStructureMutationVariables_ = Exact<{
  input: Array<BusinessUnitAssessment_Insert_Input_> | BusinessUnitAssessment_Insert_Input_;
}>;


export type UpdateBAssessmentsCompanyStructureMutation_ = { __typename?: 'mutation_root', insert_BusinessUnitAssessment?: { __typename?: 'BusinessUnitAssessment_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'BusinessUnitAssessment', id: any, businessUnit?: { __typename?: 'BusinessUnit', id: any } | null }> } | null };

export type UpsertBusinessUnitMutationVariables_ = Exact<{
  businessUnit: BusinessUnit_Insert_Input_;
}>;


export type UpsertBusinessUnitMutation_ = { __typename?: 'mutation_root', businessUnit?: { __typename?: 'BusinessUnit', id: any, name: string, labels: any, bAssessments: Array<{ __typename?: 'BusinessUnitAssessment', id: any, activityReports: Array<{ __typename?: 'ActivityReport', id: any }> }>, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string }, cAssessmentIds: Array<{ __typename?: 'BusinessUnitAssessment', cAssessmentId: any, cachedResultId?: any | null }>, deletedCAssessmentIds: Array<{ __typename?: 'BusinessUnitAssessment', cAssessmentId: any }> } | null };

export type ToggleBusinessUnitInCAssessmentMutationVariables_ = Exact<{
  cAssessmentId: Scalars['uuid']['input'];
  businessUnitId: Scalars['uuid']['input'];
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type ToggleBusinessUnitInCAssessmentMutation_ = { __typename?: 'mutation_root', insert_BusinessUnitAssessment_one?: { __typename?: 'BusinessUnitAssessment', id: any } | null };

export type DeleteBusinessUnitMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type DeleteBusinessUnitMutation_ = { __typename?: 'mutation_root', businessUnit?: { __typename?: 'BusinessUnit', id: any, name: string, labels: any, company: { __typename?: 'Company', id: any, businessUnits: Array<{ __typename?: 'BusinessUnit', id: any }> }, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string }, cAssessmentIds: Array<{ __typename?: 'BusinessUnitAssessment', cAssessmentId: any, cachedResultId?: any | null }>, deletedCAssessmentIds: Array<{ __typename?: 'BusinessUnitAssessment', cAssessmentId: any }> } | null, insert_BusinessUnitAssessment_one?: { __typename?: 'BusinessUnitAssessment', cAssessment: { __typename?: 'CompanyAssessment', id: any, bAssesssments: Array<{ __typename?: 'BusinessUnitAssessment', id: any }> } } | null };

export type UpdateHasGeneralAssessmentOnBusinessUnitMutationVariables_ = Exact<{
  bAssessmentId: Scalars['uuid']['input'];
  hasGeneralAssessment: Scalars['Boolean']['input'];
  cAssessmentId: Scalars['uuid']['input'];
}>;


export type UpdateHasGeneralAssessmentOnBusinessUnitMutation_ = { __typename?: 'mutation_root', insert_BusinessUnitAssessment_one?: { __typename?: 'BusinessUnitAssessment', id: any, hasGeneralAssessment: boolean } | null };

export type UpsertBusinessUnitReportingGroupMutationVariables_ = Exact<{
  businessUnitId: Scalars['uuid']['input'];
  cAssessmentId: Scalars['uuid']['input'];
  reportingGroupId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type UpsertBusinessUnitReportingGroupMutation_ = { __typename?: 'mutation_root', insert_BusinessUnitAssessment_one?: { __typename?: 'BusinessUnitAssessment', reportingGroupId?: any | null, id: any, cAssessmentId: any } | null };

export type GroupAssessmentsQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type GroupAssessmentsQuery_ = { __typename?: 'query_root', assessments: Array<{ __typename?: 'GroupAssessment', id: any, name: string, period: any, uploadedAt?: any | null, consolidatedCompanyAssessmentId?: any | null, consolidatedCsvId?: any | null, consolidatedCompanyAssessment?: { __typename?: 'CompanyAssessment', aggregateId: any, isLocked: boolean } | null }> };

export type GroupAssessmentQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GroupAssessmentQuery_ = { __typename?: 'query_root', assessment?: { __typename?: 'GroupAssessment', id: any, name: string, period: any, uploadedAt?: any | null, consolidatedCompanyAssessmentId?: any | null, consolidatedCsvId?: any | null, subsidiaries: Array<{ __typename?: 'Subsidiary', id: any, contactPersonName?: string | null, contactPersonEmail?: string | null, sharedCompanyAssessment?: { __typename?: 'CompanyAssessment', id: any, isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', financials: any, score: any, progress: any } | null } | null, company?: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null, isGroupOwner: boolean } | null }>, consolidatedCompanyAssessment?: { __typename?: 'CompanyAssessment', aggregateId: any, isLocked: boolean } | null } | null };

export type GroupsQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type GroupsQuery_ = { __typename?: 'query_root', groups: Array<{ __typename?: 'Subsidiary', id: any, sharedCompanyAssessmentId?: any | null, ownerGroupAssessmentId: any, ownerGroupAssessment: { __typename?: 'GroupAssessment', id: any, name: string, company?: { __typename?: 'Company', name: string, logoUrl?: string | null } | null } }> };

export type UpsertGroupAssessmentMutationVariables_ = Exact<{
  assessmentInputs: GroupAssessment_Insert_Input_;
}>;


export type UpsertGroupAssessmentMutation_ = { __typename?: 'mutation_root', insert_GroupAssessment_one?: { __typename?: 'GroupAssessment', id: any, name: string, period: any, uploadedAt?: any | null, consolidatedCompanyAssessmentId?: any | null, consolidatedCsvId?: any | null, consolidatedCompanyAssessment?: { __typename?: 'CompanyAssessment', aggregateId: any, isLocked: boolean } | null } | null };

export type DeleteGroupAssessmentMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  deletedAt?: InputMaybe<Scalars['timestamptz']['input']>;
}>;


export type DeleteGroupAssessmentMutation_ = { __typename?: 'mutation_root', update_GroupAssessment_by_pk?: { __typename?: 'GroupAssessment', id: any, deletedAt?: any | null } | null };

export type UpsertSubsidiaryMutationVariables_ = Exact<{
  subsidiary: Subsidiary_Insert_Input_;
}>;


export type UpsertSubsidiaryMutation_ = { __typename?: 'mutation_root', insert_Subsidiary_one?: { __typename?: 'Subsidiary', id: any } | null };

export type UpdateGroupAssessmentResultsMutationVariables_ = Exact<{
  groupAssessmentId: Scalars['uuid']['input'];
  uploadedAt: Scalars['date']['input'];
  deletedAt: Scalars['timestamptz']['input'];
  consolidatedCsvId: Scalars['uuid']['input'];
  consolidatedCompanyAssessmentId: Scalars['uuid']['input'];
  bAssessments: BusinessUnitAssessment_Arr_Rel_Insert_Input_;
  companyId: Scalars['uuid']['input'];
  cachedResult: CachedResult_Obj_Rel_Insert_Input_;
  aggregateId: Scalars['uuid']['input'];
  nonMaterialFinancials: Financials_Insert_Input_;
}>;


export type UpdateGroupAssessmentResultsMutation_ = { __typename?: 'mutation_root', update_BusinessUnitAssessment_many?: Array<{ __typename?: 'BusinessUnitAssessment_mutation_response', affected_rows: number } | null> | null, update_ActivityReport_many?: Array<{ __typename?: 'ActivityReport_mutation_response', affected_rows: number } | null> | null, update_GroupAssessment_by_pk?: { __typename?: 'GroupAssessment', id: any } | null, insert_Financials_one?: { __typename?: 'Financials', id: any } | null, insert_CompanyAssessment?: { __typename?: 'CompanyAssessment_mutation_response', affected_rows: number } | null };

export type ToggleShareCompanyAssessmentWithGroupMutationVariables_ = Exact<{
  object: Subsidiary_Insert_Input_;
}>;


export type ToggleShareCompanyAssessmentWithGroupMutation_ = { __typename?: 'mutation_root', insert_Subsidiary_one?: { __typename?: 'Subsidiary', id: any, sharedCompanyAssessmentId?: any | null } | null };

export type DeleteSubsidiaryMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteSubsidiaryMutation_ = { __typename?: 'mutation_root', update_Subsidiary_by_pk?: { __typename?: 'Subsidiary', deletedAt?: any | null } | null };

export type UpdateGroupAssessmentLockMutationVariables_ = Exact<{
  cAssessmentId: Scalars['uuid']['input'];
  isLocked: Scalars['Boolean']['input'];
}>;


export type UpdateGroupAssessmentLockMutation_ = { __typename?: 'mutation_root', update_CompanyAssessment_by_pk?: { __typename?: 'CompanyAssessment', id: any } | null };

export type GetGroupConsolidatedAssessmentResultQueryVariables_ = Exact<{
  cAssessmentId: Scalars['uuid']['input'];
}>;


export type GetGroupConsolidatedAssessmentResultQuery_ = { __typename?: 'query_root', companyAssessment?: { __typename?: 'CompanyAssessment', id: any, startDate: any, endDate: any, isLocked: boolean, createdAt: any, deletedAt?: any | null, cachedResultId?: any | null, updatedAt: any, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null, nonMaterialFinancials?: { __typename?: 'NonMaterialFinancials', id?: any | null, revenue?: any | null, capex?: any | null, opex?: any | null, adaptationCapex?: any | null, adaptationOpex?: any | null, isEstimate?: boolean | null } | null, generalAssessment: Array<{ __typename?: 'BusinessUnitAssessment', id: any, generalAssessment: Array<{ __typename?: 'ActivityReport', id: any, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null }> }>, bAssessments: Array<{ __typename?: 'BusinessUnitAssessment', id: any, cAssessmentId: any, deletedAt?: any | null, hasGeneralAssessment: boolean, orderIndex?: any | null, activityReports: Array<{ __typename?: 'ActivityReport', id: any, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersionNumber: number, activityVersionConfig?: any | null, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, generalAssessment: Array<{ __typename?: 'ActivityReport', id: any, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersionNumber: number, activityVersionConfig?: any | null, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null, businessUnit?: { __typename?: 'BusinessUnit', id: any, createdAt: any, name: string, companyId: any, description?: string | null, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, reportingGroup?: { __typename?: 'ReportingGroup', id: any } | null }>, aggregate: { __typename?: 'CompanyAssessmentAggregate', id: any, title: string, interval: string, startDate: any, contactPerson?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }, bAssesssments: Array<{ __typename?: 'BusinessUnitAssessment', updatedAt: any, activityReports: Array<{ __typename?: 'ActivityReport', answers: Array<{ __typename?: 'Answer', updatedAt: any }> }>, lastEditedFinancials: Array<{ __typename?: 'ActivityReport', financials?: { __typename?: 'Financials', updatedAt: any } | null }> }>, portfoliosWithAccess: Array<{ __typename?: 'PortfolioCompany', quarter: QuarterEnum_Enum_, year?: number | null, contactPersonName?: string | null, contactPersonEmail?: string | null, portfolio: { __typename?: 'Portfolio', name: string, ownerCompany: { __typename?: 'Company', name: string } } }> } | null };

export type CompanyDetailsQueryVariables_ = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type CompanyDetailsQuery_ = { __typename?: 'query_root', company: Array<{ __typename?: 'Company', id: any, isPortfolioOwner: boolean, isGroupOwner: boolean, logoUrl?: string | null, name: string, settings: any, currency: string, compassId?: string | null, hasPaiAccess: boolean, hasIFRSAccess?: boolean | null, hasTCFDAccess: boolean, hasESRSOilAndGasAccess: boolean, hasEntitySpecificAccess: boolean, hasCustomQuestionsAccess: boolean, hasTaxonomyAccess: boolean, hasAiAccess: boolean, hasBulkUploadAccess?: boolean | null, hasSASBAccess: boolean, canDownloadEsrsReport: boolean, canDownloadTaxonomyReport: boolean, hasESRSAccess: boolean, hasVSMEAccess: boolean, isReal: boolean, isDemo: boolean, invitations: Array<{ __typename?: 'CompanyInvitation', userEmail: any, status: string, id: any }>, aiConfig?: { __typename?: 'AIConfig', preferredLanguage: string, toneOfVoice?: string | null } | null, subsidiaries: Array<{ __typename?: 'Subsidiary', id: any, ownerGroupAssessment: { __typename?: 'GroupAssessment', company?: { __typename?: 'Company', hasTaxonomyAccess: boolean } | null } }>, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, eligibilityStatus: string, portfolio: { __typename?: 'Portfolio', ownerCompany: { __typename?: 'Company', id: any, hasTaxonomyAccess: boolean } } }>, esrsAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingYear: number, frameworkRef?: string | null, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean, reportingUnitLineage: { __typename?: 'esrs_ReportingUnitLineage', id: any } }> }> }> };

export type CompanyInvitationsQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CompanyInvitationsQuery_ = { __typename?: 'query_root', invitations: Array<{ __typename?: 'CompanyInvitation', companyId: any, id: any, status: string, userEmail: any, role: UserRole_Enum_, user?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }> };

export type CompanyUsersQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CompanyUsersQuery_ = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email?: any | null, displayName: string, avatarUrl: string, disabled: boolean, roles: Array<{ __typename?: 'authUserRoles', role: string }>, companyUsers: Array<{ __typename?: 'CompanyUser', role: UserRole_Enum_ }> }> };

export type GetReportsQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type GetReportsQuery_ = { __typename?: 'query_root', taxonomyReports: Array<{ __typename?: 'CompanyAssessment', id: any, isLocked: boolean, startDate: any, updatedAt: any, aggregate: { __typename?: 'CompanyAssessmentAggregate', title: string }, cachedResult?: { __typename?: 'CachedResult', progress: any } | null, bAssesssments: Array<{ __typename?: 'BusinessUnitAssessment', updatedAt: any, activityReports: Array<{ __typename?: 'ActivityReport', answers: Array<{ __typename?: 'Answer', updatedAt: any }> }>, lastEditedFinancials: Array<{ __typename?: 'ActivityReport', financials?: { __typename?: 'Financials', updatedAt: any } | null }> }> }>, groupTaxonomyReports: Array<{ __typename?: 'GroupAssessment', id: any, name: string, consolidatedCompanyAssessment?: { __typename?: 'CompanyAssessment', startDate: any, isLocked: boolean, updatedAt: any, bAssesssments: Array<{ __typename?: 'BusinessUnitAssessment', updatedAt: any, activityReports: Array<{ __typename?: 'ActivityReport', answers: Array<{ __typename?: 'Answer', updatedAt: any }> }>, lastEditedFinancials: Array<{ __typename?: 'ActivityReport', financials?: { __typename?: 'Financials', updatedAt: any } | null }> }> } | null }>, paiCompanyReports: Array<{ __typename?: 'PaiCompanyReport', id: any, period: string, year?: number | null, updatedAt?: any | null, answers: Array<{ __typename?: 'PaiAnswers', data?: string | null, investeeMetricReference: string }>, lastEditedAnswer: Array<{ __typename?: 'PaiAnswers', updatedAt?: any | null }> }>, paiCompanyRequests: Array<{ __typename?: 'PaiPortfolioReport', year?: number | null, selectedIndicators: Array<{ __typename?: 'PaiReportIndicator', periods?: any | null, indicator: { __typename?: 'PaiTableIndicator', investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', investeeMetricReference: string }> } }> } }> }>, sustainabilityReportingAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingYear: number, frameworkRef?: string | null, updatedAt: any, latestMaterialMetricUpdate?: any | null, latestDatapointUpdate?: any | null }> };

export type GetPaiRequestersQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type GetPaiRequestersQuery_ = { __typename?: 'query_root', requesters: Array<{ __typename?: 'PaiPortfolioReport', portfolio: { __typename?: 'Portfolio', ownerCompany: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null } } }> };

export type UpsertCompanyUserMutationVariables_ = Exact<{
  companyUser: CompanyUser_Insert_Input_;
}>;


export type UpsertCompanyUserMutation_ = { __typename?: 'mutation_root', companyUser?: { __typename?: 'CompanyUser', id: any, role: UserRole_Enum_, user: { __typename?: 'users', id: any, companyUsers: Array<{ __typename?: 'CompanyUser', id: any, companyId: any }> }, company: { __typename?: 'Company', id: any, isPortfolioOwner: boolean, isGroupOwner: boolean, logoUrl?: string | null, name: string, settings: any, currency: string, compassId?: string | null, hasPaiAccess: boolean, hasIFRSAccess?: boolean | null, hasTCFDAccess: boolean, hasESRSOilAndGasAccess: boolean, hasEntitySpecificAccess: boolean, hasCustomQuestionsAccess: boolean, hasTaxonomyAccess: boolean, hasAiAccess: boolean, hasBulkUploadAccess?: boolean | null, hasSASBAccess: boolean, canDownloadEsrsReport: boolean, canDownloadTaxonomyReport: boolean, hasESRSAccess: boolean, hasVSMEAccess: boolean, isReal: boolean, isDemo: boolean, invitations: Array<{ __typename?: 'CompanyInvitation', userEmail: any, status: string, id: any }>, aiConfig?: { __typename?: 'AIConfig', preferredLanguage: string, toneOfVoice?: string | null } | null, subsidiaries: Array<{ __typename?: 'Subsidiary', id: any, ownerGroupAssessment: { __typename?: 'GroupAssessment', company?: { __typename?: 'Company', hasTaxonomyAccess: boolean } | null } }>, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, eligibilityStatus: string, portfolio: { __typename?: 'Portfolio', ownerCompany: { __typename?: 'Company', id: any, hasTaxonomyAccess: boolean } } }>, esrsAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingYear: number, frameworkRef?: string | null, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean, reportingUnitLineage: { __typename?: 'esrs_ReportingUnitLineage', id: any } }> }> } } | null };

export type UpdateCompanyMutationVariables_ = Exact<{
  company: Company_Insert_Input_;
}>;


export type UpdateCompanyMutation_ = { __typename?: 'mutation_root', company?: { __typename?: 'Company', name: string } | null };

export type GetAnswerDocumentationByIdQueryVariables_ = Exact<{
  answerId: Scalars['uuid']['input'];
}>;


export type GetAnswerDocumentationByIdQuery_ = { __typename?: 'query_root', Answer_by_pk?: { __typename?: 'Answer', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null } | null };

export type GetActivityDocumentationQueryVariables_ = Exact<{
  activityReportId: Scalars['uuid']['input'];
}>;


export type GetActivityDocumentationQuery_ = { __typename?: 'query_root', ActivityReport_by_pk?: { __typename?: 'ActivityReport', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null } | null };

export type GetFinancialsDocumentationByIdQueryVariables_ = Exact<{
  financialsId: Scalars['uuid']['input'];
}>;


export type GetFinancialsDocumentationByIdQuery_ = { __typename?: 'query_root', Financials_by_pk?: { __typename?: 'Financials', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null } | null };

export type GetPaiAnswerDocumentationByIdQueryVariables_ = Exact<{
  answerId: Scalars['uuid']['input'];
}>;


export type GetPaiAnswerDocumentationByIdQuery_ = { __typename?: 'query_root', PaiAnswers_by_pk?: { __typename?: 'PaiAnswers', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null } | null };

export type GetPoliciesDocumentationByIdQueryVariables_ = Exact<{
  policyId: Scalars['uuid']['input'];
}>;


export type GetPoliciesDocumentationByIdQuery_ = { __typename?: 'query_root', esrs_Policy_by_pk?: { __typename?: 'esrs_Policy', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null } | null };

export type GetMetricAnswerDocumentationByIdQueryVariables_ = Exact<{
  metricAnswerId: Scalars['uuid']['input'];
}>;


export type GetMetricAnswerDocumentationByIdQuery_ = { __typename?: 'query_root', esrs_Answer_by_pk?: { __typename?: 'esrs_Answer', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null } | null };

export type GetActionDocumentationByIdQueryVariables_ = Exact<{
  actionId: Scalars['uuid']['input'];
}>;


export type GetActionDocumentationByIdQuery_ = { __typename?: 'query_root', esrs_Actions_by_pk?: { __typename?: 'esrs_Actions', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null } | null };

export type GetDisclosureRequirementAttachmentQueryVariables_ = Exact<{
  disclosureRequirementRef: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
  reportingUnitId: Scalars['uuid']['input'];
}>;


export type GetDisclosureRequirementAttachmentQuery_ = { __typename?: 'query_root', esrs_DisclosureRequirementAttachment: Array<{ __typename?: 'esrs_DisclosureRequirementAttachment', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null }> };

export type GetTargetDocumentationByIdQueryVariables_ = Exact<{
  targetId: Scalars['uuid']['input'];
}>;


export type GetTargetDocumentationByIdQuery_ = { __typename?: 'query_root', esrs_Target_by_pk?: { __typename?: 'esrs_Target', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null } | null };

export type AddNoteMutationVariables_ = Exact<{
  noteInput: Note_Insert_Input_;
}>;


export type AddNoteMutation_ = { __typename?: 'mutation_root', insert_Note_one?: { __typename?: 'Note', body?: string | null, noteHistory: { __typename?: 'NoteHistory', id: any } } | null };

export type UpsertAttachmentsMutationVariables_ = Exact<{
  attachmentInputs: Array<Attachment_Insert_Input_> | Attachment_Insert_Input_;
}>;


export type UpsertAttachmentsMutation_ = { __typename?: 'mutation_root', insert_Attachment?: { __typename?: 'Attachment_mutation_response', affected_rows: number } | null };

export type RemoveAttachmentMutationVariables_ = Exact<{
  attachmentId: Scalars['uuid']['input'];
}>;


export type RemoveAttachmentMutation_ = { __typename?: 'mutation_root', update_Attachment_by_pk?: { __typename?: 'Attachment', id: any } | null };

export type AddFileMutationVariables_ = Exact<{
  input: DocumentationFile_Insert_Input_;
}>;


export type AddFileMutation_ = { __typename?: 'mutation_root', file?: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null };

export type RemoveFileMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RemoveFileMutation_ = { __typename?: 'mutation_root', file?: { __typename?: 'DocumentationFile', id: any } | null };

export type GetDocumentationFileByIdQueryVariables_ = Exact<{
  fileId: Scalars['uuid']['input'];
}>;


export type GetDocumentationFileByIdQuery_ = { __typename?: 'query_root', files?: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null };

export type CompanyFilesQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type CompanyFilesQuery_ = { __typename?: 'query_root', files: Array<{ __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }> };

export type ActionQuestionFieldsFragment_ = { __typename?: 'ActionQuestion', title: string, reference: string, unit?: string | null, questionType: QuestionType_Enum_, description?: string | null, groupRef?: string | null, group?: { __typename?: 'ActionQuestionGroup', reference: string, title: string } | null, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null };

export type GetActionsDrQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
  esrsAssessmentId: Scalars['uuid']['input'];
  standardRef: Scalars['String']['input'];
}>;


export type GetActionsDrQuery_ = { __typename?: 'query_root', DisclosureRequirement_by_pk?: { __typename?: 'DisclosureRequirement', reference: string, title: string, description?: string | null, type: string, actions: Array<{ __typename?: 'esrs_Actions', id: any, disclosureRequirementRef: string, title: string, deadline: any, startDate: any, ownerId?: any | null, capex?: any | null, noteReference?: string | null, timeHorizon?: string | null, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, statusOfKeyAction?: string | null, scope?: string | null, expectedOutcome?: string | null, provisionOfRemedy?: boolean | null, provisionOfRemedyExplanation?: string | null, progressInfo?: string | null, investmentsAndResources?: string | null, hasPreconditions?: boolean | null, hasPreconditionsExplanation?: string | null, opex?: any | null, opexShortTerm?: any | null, opexMediumTerm?: any | null, opexLongTerm?: any | null, capexShortTerm?: any | null, capexMediumTerm?: any | null, capexLongTerm?: any | null, scopeValueChain?: string | null, coverage?: string | null, coverageExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, statusOfKeyActionExplanation?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, estimate?: any | null, target: { __typename?: 'esrs_Target', id: any, direction?: string | null, name: string, metric?: { __typename?: 'EsrsMetric', title: string, unitOfMeasurement?: string | null } | null } }>, actionReportingUnits: Array<{ __typename?: 'esrs_ActionReportingUnit', id: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string } }>, actionSubsidiaries: Array<{ __typename?: 'esrs_ActionSubsidiary', id: any, subsidiaryAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }>, materialStandard: { __typename?: 'esrs_MaterialStandard', assessmentId: any, standard: { __typename?: 'EsrsStandard', reference: string }, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, attachmentBox?: { __typename?: 'AttachmentBox', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any } | null }> } | null };

export type GetActionsByStandardAndAssessmentQueryVariables_ = Exact<{
  disclosureRequirementRef: Scalars['String']['input'];
  esrsAssessmentId: Scalars['uuid']['input'];
  standardRef: Scalars['String']['input'];
}>;


export type GetActionsByStandardAndAssessmentQuery_ = { __typename?: 'query_root', actions: Array<{ __typename?: 'esrs_Actions', id: any, disclosureRequirementRef: string, title: string, deadline: any, startDate: any, ownerId?: any | null, capex?: any | null, noteReference?: string | null, timeHorizon?: string | null, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, statusOfKeyAction?: string | null, scope?: string | null, expectedOutcome?: string | null, provisionOfRemedy?: boolean | null, provisionOfRemedyExplanation?: string | null, progressInfo?: string | null, investmentsAndResources?: string | null, hasPreconditions?: boolean | null, hasPreconditionsExplanation?: string | null, opex?: any | null, opexShortTerm?: any | null, opexMediumTerm?: any | null, opexLongTerm?: any | null, capexShortTerm?: any | null, capexMediumTerm?: any | null, capexLongTerm?: any | null, scopeValueChain?: string | null, coverage?: string | null, coverageExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, statusOfKeyActionExplanation?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, estimate?: any | null, target: { __typename?: 'esrs_Target', id: any, direction?: string | null, name: string, metric?: { __typename?: 'EsrsMetric', title: string, unitOfMeasurement?: string | null } | null } }>, actionReportingUnits: Array<{ __typename?: 'esrs_ActionReportingUnit', id: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string } }>, actionSubsidiaries: Array<{ __typename?: 'esrs_ActionSubsidiary', id: any, subsidiaryAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }>, materialStandard: { __typename?: 'esrs_MaterialStandard', assessmentId: any, standard: { __typename?: 'EsrsStandard', reference: string }, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, attachmentBox?: { __typename?: 'AttachmentBox', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any } | null }> };

export type GetActionsSubsidiariesQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetActionsSubsidiariesQuery_ = { __typename?: 'query_root', esrs?: { __typename?: 'EsrsAssessment', id: any, subsidiaries: Array<{ __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string }, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, actions: Array<{ __typename?: 'esrs_Actions', id: any, disclosureRequirementRef: string, title: string, deadline: any, startDate: any, ownerId?: any | null, capex?: any | null, noteReference?: string | null, timeHorizon?: string | null, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, statusOfKeyAction?: string | null, scope?: string | null, expectedOutcome?: string | null, provisionOfRemedy?: boolean | null, provisionOfRemedyExplanation?: string | null, progressInfo?: string | null, investmentsAndResources?: string | null, hasPreconditions?: boolean | null, hasPreconditionsExplanation?: string | null, opex?: any | null, opexShortTerm?: any | null, opexMediumTerm?: any | null, opexLongTerm?: any | null, capexShortTerm?: any | null, capexMediumTerm?: any | null, capexLongTerm?: any | null, scopeValueChain?: string | null, coverage?: string | null, coverageExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, statusOfKeyActionExplanation?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, estimate?: any | null, target: { __typename?: 'esrs_Target', id: any, direction?: string | null, name: string, metric?: { __typename?: 'EsrsMetric', title: string, unitOfMeasurement?: string | null } | null } }>, actionReportingUnits: Array<{ __typename?: 'esrs_ActionReportingUnit', id: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string } }>, actionSubsidiaries: Array<{ __typename?: 'esrs_ActionSubsidiary', id: any, subsidiaryAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }>, materialStandard: { __typename?: 'esrs_MaterialStandard', assessmentId: any, standard: { __typename?: 'EsrsStandard', reference: string }, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, attachmentBox?: { __typename?: 'AttachmentBox', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any } | null }> }> }> } | null };

export type GetParentActionsDrQueryVariables_ = Exact<{
  parentStandardId: Scalars['uuid']['input'];
}>;


export type GetParentActionsDrQuery_ = { __typename?: 'query_root', esrs_Actions: Array<{ __typename?: 'esrs_Actions', id: any, disclosureRequirementRef: string, title: string, deadline: any, startDate: any, ownerId?: any | null, capex?: any | null, noteReference?: string | null, timeHorizon?: string | null, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, statusOfKeyAction?: string | null, scope?: string | null, expectedOutcome?: string | null, provisionOfRemedy?: boolean | null, provisionOfRemedyExplanation?: string | null, progressInfo?: string | null, investmentsAndResources?: string | null, hasPreconditions?: boolean | null, hasPreconditionsExplanation?: string | null, opex?: any | null, opexShortTerm?: any | null, opexMediumTerm?: any | null, opexLongTerm?: any | null, capexShortTerm?: any | null, capexMediumTerm?: any | null, capexLongTerm?: any | null, scopeValueChain?: string | null, coverage?: string | null, coverageExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, statusOfKeyActionExplanation?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, estimate?: any | null, target: { __typename?: 'esrs_Target', id: any, direction?: string | null, name: string, metric?: { __typename?: 'EsrsMetric', title: string, unitOfMeasurement?: string | null } | null } }>, actionReportingUnits: Array<{ __typename?: 'esrs_ActionReportingUnit', id: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string } }>, actionSubsidiaries: Array<{ __typename?: 'esrs_ActionSubsidiary', id: any, subsidiaryAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }>, materialStandard: { __typename?: 'esrs_MaterialStandard', assessmentId: any, standard: { __typename?: 'EsrsStandard', reference: string }, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, attachmentBox?: { __typename?: 'AttachmentBox', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any } | null }> };

export type GetActionsQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  disclosureRequirementRef: Scalars['String']['input'];
}>;


export type GetActionsQuery_ = { __typename?: 'query_root', actions: Array<{ __typename?: 'esrs_Actions', id: any, disclosureRequirementRef: string, title: string, deadline: any, startDate: any, ownerId?: any | null, capex?: any | null, noteReference?: string | null, timeHorizon?: string | null, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, statusOfKeyAction?: string | null, scope?: string | null, expectedOutcome?: string | null, provisionOfRemedy?: boolean | null, provisionOfRemedyExplanation?: string | null, progressInfo?: string | null, investmentsAndResources?: string | null, hasPreconditions?: boolean | null, hasPreconditionsExplanation?: string | null, opex?: any | null, opexShortTerm?: any | null, opexMediumTerm?: any | null, opexLongTerm?: any | null, capexShortTerm?: any | null, capexMediumTerm?: any | null, capexLongTerm?: any | null, scopeValueChain?: string | null, coverage?: string | null, coverageExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, statusOfKeyActionExplanation?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, estimate?: any | null, target: { __typename?: 'esrs_Target', id: any, direction?: string | null, name: string, metric?: { __typename?: 'EsrsMetric', title: string, unitOfMeasurement?: string | null } | null } }>, actionReportingUnits: Array<{ __typename?: 'esrs_ActionReportingUnit', id: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string } }>, actionSubsidiaries: Array<{ __typename?: 'esrs_ActionSubsidiary', id: any, subsidiaryAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }>, materialStandard: { __typename?: 'esrs_MaterialStandard', assessmentId: any, standard: { __typename?: 'EsrsStandard', reference: string }, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, attachmentBox?: { __typename?: 'AttachmentBox', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any } | null }> };

export type EsrsAssessmentActionsQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type EsrsAssessmentActionsQuery_ = { __typename?: 'query_root', esrs_Actions: Array<{ __typename?: 'esrs_Actions', id: any, disclosureRequirementRef: string, title: string, deadline: any, startDate: any, ownerId?: any | null, capex?: any | null, noteReference?: string | null, timeHorizon?: string | null, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, statusOfKeyAction?: string | null, scope?: string | null, expectedOutcome?: string | null, provisionOfRemedy?: boolean | null, provisionOfRemedyExplanation?: string | null, progressInfo?: string | null, investmentsAndResources?: string | null, hasPreconditions?: boolean | null, hasPreconditionsExplanation?: string | null, opex?: any | null, opexShortTerm?: any | null, opexMediumTerm?: any | null, opexLongTerm?: any | null, capexShortTerm?: any | null, capexMediumTerm?: any | null, capexLongTerm?: any | null, scopeValueChain?: string | null, coverage?: string | null, coverageExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, statusOfKeyActionExplanation?: string | null, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, parentAssessmentId?: any | null, company: { __typename?: 'Company', id: any, name: string, isGroupOwner: boolean } }, standard: { __typename?: 'EsrsStandard', reference: string } }, disclosureRequirement: { __typename?: 'DisclosureRequirement', group: { __typename?: 'DisclosureRequirementGroup', reference: string, standard: { __typename?: 'EsrsStandard', title: string, reference: string, category: { __typename?: 'EsrsCategory', title: string, reference: string } } } }, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, estimate?: any | null, target: { __typename?: 'esrs_Target', id: any, direction?: string | null, name: string, metric?: { __typename?: 'EsrsMetric', title: string, unitOfMeasurement?: string | null } | null } }>, actionReportingUnits: Array<{ __typename?: 'esrs_ActionReportingUnit', id: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string } }>, actionSubsidiaries: Array<{ __typename?: 'esrs_ActionSubsidiary', id: any, subsidiaryAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }>, attachmentBox?: { __typename?: 'AttachmentBox', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any } | null }> };

export type GetActionQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetActionQuery_ = { __typename?: 'query_root', esrs_Actions_by_pk?: { __typename?: 'esrs_Actions', id: any, disclosureRequirementRef: string, title: string, deadline: any, startDate: any, ownerId?: any | null, capex?: any | null, noteReference?: string | null, timeHorizon?: string | null, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, statusOfKeyAction?: string | null, scope?: string | null, expectedOutcome?: string | null, provisionOfRemedy?: boolean | null, provisionOfRemedyExplanation?: string | null, progressInfo?: string | null, investmentsAndResources?: string | null, hasPreconditions?: boolean | null, hasPreconditionsExplanation?: string | null, opex?: any | null, opexShortTerm?: any | null, opexMediumTerm?: any | null, opexLongTerm?: any | null, capexShortTerm?: any | null, capexMediumTerm?: any | null, capexLongTerm?: any | null, scopeValueChain?: string | null, coverage?: string | null, coverageExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, statusOfKeyActionExplanation?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, estimate?: any | null, target: { __typename?: 'esrs_Target', id: any, direction?: string | null, name: string, metric?: { __typename?: 'EsrsMetric', title: string, unitOfMeasurement?: string | null } | null } }>, actionReportingUnits: Array<{ __typename?: 'esrs_ActionReportingUnit', id: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string } }>, actionSubsidiaries: Array<{ __typename?: 'esrs_ActionSubsidiary', id: any, subsidiaryAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }>, materialStandard: { __typename?: 'esrs_MaterialStandard', assessmentId: any, standard: { __typename?: 'EsrsStandard', reference: string }, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, attachmentBox?: { __typename?: 'AttachmentBox', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any } | null } | null };

export type ActionQuestionsQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
}>;


export type ActionQuestionsQuery_ = { __typename?: 'query_root', ActionQuestion: Array<{ __typename?: 'ActionQuestion', title: string, reference: string, unit?: string | null, questionType: QuestionType_Enum_, description?: string | null, groupRef?: string | null, group?: { __typename?: 'ActionQuestionGroup', reference: string, title: string } | null, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null }> };

export type UpsertActionMutationVariables_ = Exact<{
  input: Esrs_Actions_Insert_Input_;
}>;


export type UpsertActionMutation_ = { __typename?: 'mutation_root', insert_esrs_Actions_one?: { __typename?: 'esrs_Actions', id: any, title: string, attachmentBox?: { __typename?: 'AttachmentBox', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any } | null } | null };

export type UpsertDrawerActionMutationVariables_ = Exact<{
  input: Esrs_Actions_Insert_Input_;
}>;


export type UpsertDrawerActionMutation_ = { __typename?: 'mutation_root', insert_esrs_Actions_one?: { __typename?: 'esrs_Actions', id: any, title: string, attachmentBox?: { __typename?: 'AttachmentBox', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any } | null } | null };

export type UpsertManyActionsMutationVariables_ = Exact<{
  actions: Array<Esrs_Actions_Insert_Input_> | Esrs_Actions_Insert_Input_;
}>;


export type UpsertManyActionsMutation_ = { __typename?: 'mutation_root', insert_esrs_Actions?: { __typename?: 'esrs_Actions_mutation_response', returning: Array<{ __typename?: 'esrs_Actions', id: any, title: string, attachmentBox?: { __typename?: 'AttachmentBox', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any } | null }> } | null };

export type DeleteActionTargetMutationVariables_ = Exact<{
  id?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteActionTargetMutation_ = { __typename?: 'mutation_root', delete_esrs_ActionTarget?: { __typename?: 'esrs_ActionTarget_mutation_response', affected_rows: number } | null };

export type DeleteActionMutationVariables_ = Exact<{
  actionId: Scalars['uuid']['input'];
}>;


export type DeleteActionMutation_ = { __typename?: 'mutation_root', delete_esrs_Actions_by_pk?: { __typename?: 'esrs_Actions', id: any } | null };

export type DeleteActionReportingsUnitMutationVariables_ = Exact<{
  id?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteActionReportingsUnitMutation_ = { __typename?: 'mutation_root', delete_esrs_ActionReportingUnit?: { __typename?: 'esrs_ActionReportingUnit_mutation_response', returning: Array<{ __typename?: 'esrs_ActionReportingUnit', id: any }> } | null };

export type DeleteActionSubsidiaryMutationVariables_ = Exact<{
  id?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type DeleteActionSubsidiaryMutation_ = { __typename?: 'mutation_root', delete_esrs_ActionSubsidiary?: { __typename?: 'esrs_ActionSubsidiary_mutation_response', returning: Array<{ __typename?: 'esrs_ActionSubsidiary', id: any }> } | null };

export type UpsertManyActionTargetsMutationVariables_ = Exact<{
  objects: Array<Esrs_ActionTarget_Insert_Input_> | Esrs_ActionTarget_Insert_Input_;
}>;


export type UpsertManyActionTargetsMutation_ = { __typename?: 'mutation_root', insert_esrs_ActionTarget?: { __typename?: 'esrs_ActionTarget_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_ActionTarget', id: any, actionId: any, targetId: any }> } | null };

export type ReportingUnitAnswersFieldsForAggregatedLevelFragment_ = { __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, metric: { __typename?: 'EsrsMetric', childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, factValue?: string | null, timeframe: string, metadata?: any | null, isMdrmDisclosed?: boolean | null, answerId: any, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }>, owner?: { __typename?: 'users', id: any, displayName: string } | null, author?: { __typename?: 'users', displayName: string } | null }>, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean } };

export type MaterialMetricWithChildrenFieldsForAggregatedLevelFragment_ = { __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, dataCollection?: string | null, isMaterial?: boolean | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string } };

export type GetEsrsMetricsDatapointsQueryVariables_ = Exact<{
  reportingUnitId: Scalars['uuid']['input'];
  assessmentId: Scalars['uuid']['input'];
  metricRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetEsrsMetricsDatapointsQuery_ = { __typename?: 'query_root', answers: Array<{ __typename?: 'esrs_Answer', id: any, reportingUnitId: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, optOutAuthorId?: any | null, assessmentId: any, metric: { __typename?: 'EsrsMetric', title: string, reference: string, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, optOutAuthor?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, answerId: any, authorId?: any | null, ownerId?: any | null, value?: string | null, factValue?: string | null, timeframe: string, source?: string | null, metadata?: any | null, lastEdited?: any | null, updatedAt: any, isMdrmDisclosed?: boolean | null, mdrmElsewhereDisclosure?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, author?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, task?: { __typename?: 'Task', id: any, dueDate?: any | null, status: TaskStatusEnum_Enum_, owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, thread?: { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any }>, comments_aggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }> }> }> };

export type GetStandardAnswersOnCompanyLevelQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
  drRef: Scalars['String']['input'];
}>;


export type GetStandardAnswersOnCompanyLevelQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, updatedAt: any, metric: { __typename?: 'EsrsMetric', childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, ownerId?: any | null, source?: string | null, value?: string | null, factValue?: string | null, metadata?: any | null, timeframe: string, lastEdited?: any | null, answerId: any, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }>, author?: { __typename?: 'users', displayName: string } | null, owner?: { __typename?: 'users', displayName: string } | null }>, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean } }> }> } | null };

export type GetStandardAnswersOnGroupLevelQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
  drRef: Scalars['String']['input'];
}>;


export type GetStandardAnswersOnGroupLevelQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string }, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, updatedAt: any, metric: { __typename?: 'EsrsMetric', childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, ownerId?: any | null, source?: string | null, value?: string | null, factValue?: string | null, metadata?: any | null, timeframe: string, lastEdited?: any | null, answerId: any, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }>, author?: { __typename?: 'users', displayName: string } | null, owner?: { __typename?: 'users', displayName: string } | null }>, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean } }> }>, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, standard: { __typename?: 'EsrsStandard', title: string, reference: string }, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, isMaterial?: boolean | null, frequency: string, materialStandardId: any, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string, title: string, requirement: { __typename?: 'DisclosureRequirement', reference: string }, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', reference: string }, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', reference: string }, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', reference: string }, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', reference: string }, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', reference: string } } | null }> } | null }> } | null }> } | null }> } | null }> }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }> }> }> } | null };

export type GetAnswersForMetricsOnCompanyLevelQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetAnswersForMetricsOnCompanyLevelQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, metric: { __typename?: 'EsrsMetric', childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, factValue?: string | null, timeframe: string, metadata?: any | null, isMdrmDisclosed?: boolean | null, answerId: any, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }>, owner?: { __typename?: 'users', id: any, displayName: string } | null, author?: { __typename?: 'users', displayName: string } | null }>, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean } }>, optedOutAnswers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string }> }> } | null };

export type GetAnswersForMetricsOnGroupLevelQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetAnswersForMetricsOnGroupLevelQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string, currency: string }, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, metric: { __typename?: 'EsrsMetric', childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, factValue?: string | null, timeframe: string, metadata?: any | null, isMdrmDisclosed?: boolean | null, answerId: any, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }>, owner?: { __typename?: 'users', id: any, displayName: string } | null, author?: { __typename?: 'users', displayName: string } | null }>, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean } }> }>, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, dataCollection?: string | null, isMaterial?: boolean | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string } }> }> }> } | null };

export type GetAnswersForDrMetricsOnCompanyLevelQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
  disclosureRequirementRef: Scalars['String']['input'];
  frameworkRef: Scalars['String']['input'];
}>;


export type GetAnswersForDrMetricsOnCompanyLevelQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, metric: { __typename?: 'EsrsMetric', childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, factValue?: string | null, timeframe: string, metadata?: any | null, isMdrmDisclosed?: boolean | null, answerId: any, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }>, owner?: { __typename?: 'users', id: any, displayName: string } | null, author?: { __typename?: 'users', displayName: string } | null }>, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean } }>, optedOutAnswers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string }> }> } | null };

export type GetAnswersForDrMetricsOnGroupLevelQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
  disclosureRequirementRef: Scalars['String']['input'];
  frameworkRef: Scalars['String']['input'];
}>;


export type GetAnswersForDrMetricsOnGroupLevelQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string, currency: string }, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, metric: { __typename?: 'EsrsMetric', childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, factValue?: string | null, timeframe: string, metadata?: any | null, isMdrmDisclosed?: boolean | null, answerId: any, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }>, owner?: { __typename?: 'users', id: any, displayName: string } | null, author?: { __typename?: 'users', displayName: string } | null }>, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean } }> }>, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, dataCollection?: string | null, isMaterial?: boolean | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string } }> }> }> } | null };

export type GetSubAnswersPerDrOnGroupLevelQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
  disclosureRequirementRef: Scalars['String']['input'];
}>;


export type GetSubAnswersPerDrOnGroupLevelQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string, currency: string }, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, metric: { __typename?: 'EsrsMetric', childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, factValue?: string | null, timeframe: string, metadata?: any | null, isMdrmDisclosed?: boolean | null, answerId: any, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }>, owner?: { __typename?: 'users', id: any, displayName: string } | null, author?: { __typename?: 'users', displayName: string } | null }>, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean } }> }> }> } | null };

export type GetSubMaterialMetricsPerDrOnGroupLevelQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
  disclosureRequirementRef: Scalars['String']['input'];
}>;


export type GetSubMaterialMetricsPerDrOnGroupLevelQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string, currency: string }, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, dataCollection?: string | null, isMaterial?: boolean | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string } }> }> }> } | null };

export type GetSubAnswersEnvironmentQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
  environmentDisclosures: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetSubAnswersEnvironmentQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, metric: { __typename?: 'EsrsMetric', childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, factValue?: string | null, timeframe: string, metadata?: any | null, isMdrmDisclosed?: boolean | null, answerId: any, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }>, owner?: { __typename?: 'users', id: any, displayName: string } | null, author?: { __typename?: 'users', displayName: string } | null }>, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean } }> }> }> } | null };

export type GetSubAnswersOtherQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
  environmentDisclosures: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetSubAnswersOtherQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, metric: { __typename?: 'EsrsMetric', childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, factValue?: string | null, timeframe: string, metadata?: any | null, isMdrmDisclosed?: boolean | null, answerId: any, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }>, owner?: { __typename?: 'users', id: any, displayName: string } | null, author?: { __typename?: 'users', displayName: string } | null }>, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean } }> }> }> } | null };

export type GetDatapointsPerDrQueryVariables_ = Exact<{
  drRef: Scalars['String']['input'];
}>;


export type GetDatapointsPerDrQuery_ = { __typename?: 'query_root', esrs_Datapoint: Array<{ __typename?: 'esrs_Datapoint', id: any, answer: { __typename?: 'esrs_Answer', metric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null } }, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagType: string, tagValue: string }> }> };

export type GetSubMaterialMetricsOnGroupLevelQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetSubMaterialMetricsOnGroupLevelQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string, currency: string }, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, dataCollection?: string | null, isMaterial?: boolean | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string } }> }> }> } | null };

export type GetEsrsMetricsAnswerssQueryVariables_ = Exact<{
  reportingUnitId: Scalars['uuid']['input'];
  assessmentId: Scalars['uuid']['input'];
  metricRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetEsrsMetricsAnswerssQuery_ = { __typename?: 'query_root', answers: Array<{ __typename?: 'esrs_Answer', id: any, reportingUnitId: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, optOutAuthorId?: any | null, assessmentId: any, metric: { __typename?: 'EsrsMetric', title: string, reference: string, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, optOutAuthor?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, answerId: any, authorId?: any | null, ownerId?: any | null, value?: string | null, factValue?: string | null, timeframe: string, source?: string | null, metadata?: any | null, lastEdited?: any | null, updatedAt: any, isMdrmDisclosed?: boolean | null, mdrmElsewhereDisclosure?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, author?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, task?: { __typename?: 'Task', id: any, dueDate?: any | null, status: TaskStatusEnum_Enum_, owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, thread?: { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any }>, comments_aggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }> }> }> };

export type GetEsrsMetricsAnswersSubscriptionVariables_ = Exact<{
  reportingUnitId: Scalars['uuid']['input'];
  assessmentId: Scalars['uuid']['input'];
  metricRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetEsrsMetricsAnswersSubscription_ = { __typename?: 'subscription_root', answers: Array<{ __typename?: 'esrs_Answer', id: any, reportingUnitId: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, optOutAuthorId?: any | null, assessmentId: any, metric: { __typename?: 'EsrsMetric', title: string, reference: string, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, optOutAuthor?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, answerId: any, authorId?: any | null, ownerId?: any | null, value?: string | null, factValue?: string | null, timeframe: string, source?: string | null, metadata?: any | null, lastEdited?: any | null, updatedAt: any, isMdrmDisclosed?: boolean | null, mdrmElsewhereDisclosure?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, author?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, task?: { __typename?: 'Task', id: any, dueDate?: any | null, status: TaskStatusEnum_Enum_, owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, thread?: { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any }>, comments_aggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }> }> }> };

export type GetEsrsMetricAnswerSubscriptionVariables_ = Exact<{
  reportingUnitId: Scalars['uuid']['input'];
  assessmentId: Scalars['uuid']['input'];
  metricRef: Scalars['String']['input'];
}>;


export type GetEsrsMetricAnswerSubscription_ = { __typename?: 'subscription_root', esrs_Answer: Array<{ __typename?: 'esrs_Answer', id: any, reportingUnitId: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, optOutAuthorId?: any | null, assessmentId: any, metric: { __typename?: 'EsrsMetric', title: string, reference: string, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, optOutAuthor?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, answerId: any, authorId?: any | null, ownerId?: any | null, value?: string | null, factValue?: string | null, timeframe: string, source?: string | null, metadata?: any | null, lastEdited?: any | null, updatedAt: any, isMdrmDisclosed?: boolean | null, mdrmElsewhereDisclosure?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, author?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, task?: { __typename?: 'Task', id: any, dueDate?: any | null, status: TaskStatusEnum_Enum_, owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, thread?: { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any }>, comments_aggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }> }> }> };

export type GetEsrsMetricAnswersQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  metricRef: Scalars['String']['input'];
}>;


export type GetEsrsMetricAnswersQuery_ = { __typename?: 'query_root', esrs_Answer: Array<{ __typename?: 'esrs_Answer', id: any, reportingUnitId: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, optOutAuthorId?: any | null, assessmentId: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean }, metric: { __typename?: 'EsrsMetric', unitOfMeasurement?: string | null, title: string, reference: string, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, optOutAuthor?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, answerId: any, authorId?: any | null, ownerId?: any | null, value?: string | null, factValue?: string | null, timeframe: string, source?: string | null, metadata?: any | null, lastEdited?: any | null, updatedAt: any, isMdrmDisclosed?: boolean | null, mdrmElsewhereDisclosure?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, author?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, task?: { __typename?: 'Task', id: any, dueDate?: any | null, status: TaskStatusEnum_Enum_, owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, thread?: { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any }>, comments_aggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }> }> }> };

export type GetMetricAnswersQueryVariables_ = Exact<{
  reportingUnitId: Scalars['uuid']['input'];
}>;


export type GetMetricAnswersQuery_ = { __typename?: 'query_root', esrs_Answer: Array<{ __typename?: 'esrs_Answer', id: any, reportingUnitId: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, optOutAuthorId?: any | null, assessmentId: any, metric: { __typename?: 'EsrsMetric', title: string, reference: string, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, optOutAuthor?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, answerId: any, authorId?: any | null, ownerId?: any | null, value?: string | null, factValue?: string | null, timeframe: string, source?: string | null, metadata?: any | null, lastEdited?: any | null, updatedAt: any, isMdrmDisclosed?: boolean | null, mdrmElsewhereDisclosure?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, author?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, task?: { __typename?: 'Task', id: any, dueDate?: any | null, status: TaskStatusEnum_Enum_, owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, thread?: { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any }>, comments_aggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }> }> }> };

export type GetMetricAnswersPerDrQueryVariables_ = Exact<{
  reportingUnitId: Scalars['uuid']['input'];
  drRef: Scalars['String']['input'];
  frameworkRef: Scalars['String']['input'];
}>;


export type GetMetricAnswersPerDrQuery_ = { __typename?: 'query_root', esrs_Answer: Array<{ __typename?: 'esrs_Answer', id: any, reportingUnitId: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, optOutAuthorId?: any | null, assessmentId: any, metric: { __typename?: 'EsrsMetric', title: string, reference: string, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, optOutAuthor?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, answerId: any, authorId?: any | null, ownerId?: any | null, value?: string | null, factValue?: string | null, timeframe: string, source?: string | null, metadata?: any | null, lastEdited?: any | null, updatedAt: any, isMdrmDisclosed?: boolean | null, mdrmElsewhereDisclosure?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, author?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, task?: { __typename?: 'Task', id: any, dueDate?: any | null, status: TaskStatusEnum_Enum_, owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, thread?: { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any }>, comments_aggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }> }> }> };

export type GetSingleEsrsMetricAnswerQueryVariables_ = Exact<{
  reportingUnitId: Scalars['uuid']['input'];
  assessmentId: Scalars['uuid']['input'];
  metricRef: Scalars['String']['input'];
}>;


export type GetSingleEsrsMetricAnswerQuery_ = { __typename?: 'query_root', esrs_Answer: Array<{ __typename?: 'esrs_Answer', id: any, reportingUnitId: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, optOutAuthorId?: any | null, assessmentId: any, metric: { __typename?: 'EsrsMetric', title: string, reference: string, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, optOutAuthor?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, answerId: any, authorId?: any | null, ownerId?: any | null, value?: string | null, factValue?: string | null, timeframe: string, source?: string | null, metadata?: any | null, lastEdited?: any | null, updatedAt: any, isMdrmDisclosed?: boolean | null, mdrmElsewhereDisclosure?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, author?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, task?: { __typename?: 'Task', id: any, dueDate?: any | null, status: TaskStatusEnum_Enum_, owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, thread?: { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any }>, comments_aggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }> }> }> };

export type UpsertMetricsAnswerMutationVariables_ = Exact<{
  objects: Array<Esrs_Answer_Insert_Input_> | Esrs_Answer_Insert_Input_;
}>;


export type UpsertMetricsAnswerMutation_ = { __typename?: 'mutation_root', insert_esrs_Answer?: { __typename?: 'esrs_Answer_mutation_response', returning: Array<{ __typename?: 'esrs_Answer', id: any }> } | null };

export type UpsertDatapointMutationVariables_ = Exact<{
  objects: Array<Esrs_Datapoint_Insert_Input_> | Esrs_Datapoint_Insert_Input_;
}>;


export type UpsertDatapointMutation_ = { __typename?: 'mutation_root', insert_esrs_Datapoint?: { __typename?: 'esrs_Datapoint_mutation_response', returning: Array<{ __typename?: 'esrs_Datapoint', id: any, answer: { __typename?: 'esrs_Answer', id: any, reportingUnitId: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, optOutAuthorId?: any | null, assessmentId: any, metric: { __typename?: 'EsrsMetric', title: string, reference: string, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, optOutAuthor?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, answerId: any, authorId?: any | null, ownerId?: any | null, value?: string | null, factValue?: string | null, timeframe: string, source?: string | null, metadata?: any | null, lastEdited?: any | null, updatedAt: any, isMdrmDisclosed?: boolean | null, mdrmElsewhereDisclosure?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, author?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, task?: { __typename?: 'Task', id: any, dueDate?: any | null, status: TaskStatusEnum_Enum_, owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, thread?: { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any }>, comments_aggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }> }> }, thread?: { __typename?: 'Thread', id: any } | null }> } | null };

export type UpsertDatapointTaskMutationVariables_ = Exact<{
  objects: Array<Esrs_Datapoint_Insert_Input_> | Esrs_Datapoint_Insert_Input_;
}>;


export type UpsertDatapointTaskMutation_ = { __typename?: 'mutation_root', insert_esrs_Datapoint?: { __typename?: 'esrs_Datapoint_mutation_response', returning: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, factValue?: string | null, task?: { __typename?: 'Task', id: any, status: TaskStatusEnum_Enum_ } | null }> } | null };

export type DeleteDatapointChoicesMutationVariables_ = Exact<{
  datapointId: Scalars['uuid']['input'];
  choices: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteDatapointChoicesMutation_ = { __typename?: 'mutation_root', delete_esrs_DatapointChoice?: { __typename?: 'esrs_DatapointChoice_mutation_response', affected_rows: number } | null };

export type GetOptedOutMetricsQueryVariables_ = Exact<{
  reportingUnitId: Scalars['uuid']['input'];
  assessmentId: Scalars['uuid']['input'];
  drRef?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOptedOutMetricsQuery_ = { __typename?: 'query_root', esrs_Answer: Array<{ __typename?: 'esrs_Answer', metric: { __typename?: 'EsrsMetric', reference: string } }> };

export type DisclosureRequirementStatusQueryVariables_ = Exact<{
  disclosureRequirementRef: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
}>;


export type DisclosureRequirementStatusQuery_ = { __typename?: 'query_root', drInfo?: { __typename?: 'DisclosureRequirement', title: string, type: string } | null, drStatus: Array<{ __typename?: 'DisclosureRequirementStatus', isConfigured: boolean }> };

export type MfDisclosureRequirementStatusQueryVariables_ = Exact<{
  mfDisclosureRequirementRef: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
}>;


export type MfDisclosureRequirementStatusQuery_ = { __typename?: 'query_root', drInfo?: { __typename?: 'MFDisclosureRequirement', title: string, type: string } | null, drStatus: Array<{ __typename?: 'DisclosureRequirementStatus', isConfigured: boolean }> };

export type GetRequiredDataCollectionMaterialMetricsQueryVariables_ = Exact<{
  disclosureRequirementRef: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
  frameworkRef: Scalars['String']['input'];
  parentStandardId: Scalars['uuid']['input'];
}>;


export type GetRequiredDataCollectionMaterialMetricsQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, materialStandardId: any, metric: { __typename?: 'EsrsMetric', reference: string } }> };

export type MaterialMetricsPerDisclosureQueryVariables_ = Exact<{
  disclosureRequirementRef: Scalars['String']['input'];
  companyStandardId: Scalars['uuid']['input'];
  parentStandardId?: InputMaybe<Scalars['uuid']['input']>;
  requiredMetrics: Array<Scalars['String']['input']> | Scalars['String']['input'];
  frameworkRef: Scalars['String']['input'];
}>;


export type MaterialMetricsPerDisclosureQuery_ = { __typename?: 'query_root', assessableMetrics: Array<{ __typename?: 'EsrsMetric', reference: string, title: string, shortTitle?: string | null, description?: string | null, metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, hasAssociation: boolean, notAggregatable: boolean, abbreviation?: string | null, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, frequency: string, dataCollection?: string | null, materialStandardId: any, isMaterial?: boolean | null, materialStandard: { __typename?: 'esrs_MaterialStandard', isMaterial?: boolean | null }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', tagType: string, isOptional: boolean, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string }> }> }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, title: string, shortTitle?: string | null, description?: string | null, metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, hasAssociation: boolean, notAggregatable: boolean, abbreviation?: string | null, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, frequency: string, dataCollection?: string | null, materialStandardId: any, isMaterial?: boolean | null, materialStandard: { __typename?: 'esrs_MaterialStandard', isMaterial?: boolean | null }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', tagType: string, isOptional: boolean, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string }> }> }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, title: string, shortTitle?: string | null, description?: string | null, metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, hasAssociation: boolean, notAggregatable: boolean, abbreviation?: string | null, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, frequency: string, dataCollection?: string | null, materialStandardId: any, isMaterial?: boolean | null, materialStandard: { __typename?: 'esrs_MaterialStandard', isMaterial?: boolean | null }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', tagType: string, isOptional: boolean, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string }> }> }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, title: string, shortTitle?: string | null, description?: string | null, metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, hasAssociation: boolean, notAggregatable: boolean, abbreviation?: string | null, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, frequency: string, dataCollection?: string | null, materialStandardId: any, isMaterial?: boolean | null, materialStandard: { __typename?: 'esrs_MaterialStandard', isMaterial?: boolean | null }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', tagType: string, isOptional: boolean, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string }> }> }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, title: string, shortTitle?: string | null, description?: string | null, metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, hasAssociation: boolean, notAggregatable: boolean, abbreviation?: string | null, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, frequency: string, dataCollection?: string | null, materialStandardId: any, isMaterial?: boolean | null, materialStandard: { __typename?: 'esrs_MaterialStandard', isMaterial?: boolean | null }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', tagType: string, isOptional: boolean, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string }> }> }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', title: string } }>, childMetricsCount: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetricsCount: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', title: string } }>, childMetricsCount: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetricsCount: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', title: string } }>, childMetricsCount: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetricsCount: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', title: string } }>, childMetricsCount: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetricsCount: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', title: string } }>, childMetricsCount: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetricsCount: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> }> };

export type MaterialStandardMaterialRequirementsQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
  companyStandardId: Scalars['uuid']['input'];
  parentStandardId: Scalars['uuid']['input'];
}>;


export type MaterialStandardMaterialRequirementsQuery_ = { __typename?: 'query_root', DisclosureRequirement: Array<{ __typename?: 'DisclosureRequirement', title: string, reference: string, order: number, type: string, nonAggregatableMetrics: Array<{ __typename?: 'EsrsMetric', title: string, order: number, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, frequency: string, dataCollection?: string | null, isMaterial?: boolean | null }> }> }> };

export type GroupMetricRequiredTagsPerStandardQueryVariables_ = Exact<{
  materialStandardId: Scalars['uuid']['input'];
}>;


export type GroupMetricRequiredTagsPerStandardQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string, dataCollection?: string | null, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requiredTags: Array<{ __typename?: 'MetricTag', type: string }> }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', tagType: string }> }> };

export type CompanyMetricRequiredTagsPerStandardQueryVariables_ = Exact<{
  materialStandardId: Scalars['uuid']['input'];
}>;


export type CompanyMetricRequiredTagsPerStandardQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string, dataCollection?: string | null, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requiredTags: Array<{ __typename?: 'MetricTag', type: string }> }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', tagType: string }> }> };

export type BusinessUnitMetricRequiredTagsPerStandardQueryVariables_ = Exact<{
  materialStandardId: Scalars['uuid']['input'];
  parentStandardId: Scalars['uuid']['input'];
}>;


export type BusinessUnitMetricRequiredTagsPerStandardQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string, dataCollection?: string | null, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requiredTags: Array<{ __typename?: 'MetricTag', type: string }> }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', tagType: string }> }> };

export type UpsertDisclosureRequirementStatusMutationVariables_ = Exact<{
  drRef: Scalars['String']['input'];
  isConfigured: Scalars['Boolean']['input'];
  materialStandardId: Scalars['uuid']['input'];
}>;


export type UpsertDisclosureRequirementStatusMutation_ = { __typename?: 'mutation_root', insert_DisclosureRequirementStatus?: { __typename?: 'DisclosureRequirementStatus_mutation_response', returning: Array<{ __typename?: 'DisclosureRequirementStatus', disclosureRequirementRef?: string | null, isConfigured: boolean }> } | null };

export type UpsertMfDisclosureRequirementStatusMutationVariables_ = Exact<{
  mfDrRef?: InputMaybe<Scalars['String']['input']>;
  isConfigured: Scalars['Boolean']['input'];
  materialStandardId: Scalars['uuid']['input'];
}>;


export type UpsertMfDisclosureRequirementStatusMutation_ = { __typename?: 'mutation_root', insert_DisclosureRequirementStatus?: { __typename?: 'DisclosureRequirementStatus_mutation_response', returning: Array<{ __typename?: 'DisclosureRequirementStatus', mfDisclosureRequirementRef?: string | null, isConfigured: boolean }> } | null };

export type DeleteMaterialMetricTagValueMutationVariables_ = Exact<{
  tagType: Scalars['String']['input'];
  tagValue: Scalars['String']['input'];
  materialMetricId: Scalars['uuid']['input'];
}>;


export type DeleteMaterialMetricTagValueMutation_ = { __typename?: 'mutation_root', delete_esrs_MaterialTagValue?: { __typename?: 'esrs_MaterialTagValue_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_MaterialTagValue', id: any }> } | null };

export type DeleteMaterialMetricTagMutationVariables_ = Exact<{
  tagTypes: Array<Scalars['String']['input']> | Scalars['String']['input'];
  materialMetricId: Scalars['uuid']['input'];
}>;


export type DeleteMaterialMetricTagMutation_ = { __typename?: 'mutation_root', delete_esrs_MaterialMetricTag?: { __typename?: 'esrs_MaterialMetricTag_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any }> } | null };

export type DeleteManyMaterialTagValuesMutationVariables_ = Exact<{
  materialMetricTagValues: Array<Esrs_MaterialTagValue_Bool_Exp_> | Esrs_MaterialTagValue_Bool_Exp_;
}>;


export type DeleteManyMaterialTagValuesMutation_ = { __typename?: 'mutation_root', delete_esrs_MaterialTagValue?: { __typename?: 'esrs_MaterialTagValue_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_MaterialTagValue', id: any }> } | null };

export type GetRequiredTagsMaterialMetricsQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetRequiredTagsMaterialMetricsQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', id: any, materialStandardId: any, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', tagType: string, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', reference: string, title: string, tags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, tagType: { __typename?: 'TagType', tagValues: Array<{ __typename?: 'TagValue', type: string, value: string }> } }> } }> };

export type GetMetricTagsDetailForSubsidiariesQueryVariables_ = Exact<{
  assessmentId?: InputMaybe<Scalars['uuid']['input']>;
  drRef?: InputMaybe<Scalars['String']['input']>;
  frameworkRef: Scalars['String']['input'];
}>;


export type GetMetricTagsDetailForSubsidiariesQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string, metric: { __typename?: 'EsrsMetric', tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean }> }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', tagType: string }>, materialStandard: { __typename?: 'esrs_MaterialStandard', esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', name: string, id: any } } } }> };

export type GetSubsidiaryRequiredTagsMaterialMetricsQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
  parentEsrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetSubsidiaryRequiredTagsMaterialMetricsQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', id: any, materialStandardId: any, isMaterial?: boolean | null, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', tagType: string, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', assessmentId: any }, metric: { __typename?: 'EsrsMetric', reference: string, title: string, tags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, tagType: { __typename?: 'TagType', tagValues: Array<{ __typename?: 'TagValue', type: string, value: string }> } }> } }> };

export type SimplifiedAttachmentBoxFragment_ = { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> };

export type SimplifiedNoteHistoryFragment_ = { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', authorId: any, body?: string | null, isAIGenerated: boolean, updatedAt: any }> };

export type SimplifiedThreadFragment_ = { __typename?: 'Thread', companyId: any, comments: Array<{ __typename?: 'Comment', id: any, data: string, authorId: any, updatedAt: any, duplicatedFrom?: any | null }>, subscribers: Array<{ __typename?: 'ThreadSubscriber', userId: any }> };

export type DuplicationActionFieldsFragment_ = { __typename?: 'esrs_Actions', updatedAt: any, title: string, disclosureRequirementRef: string, ownerId?: any | null, answers?: any | null, capex?: any | null, capexLongTerm?: any | null, capexShortTerm?: any | null, capexMediumTerm?: any | null, deadline: any, expectedOutcome?: string | null, hasPreconditions?: boolean | null, hasPreconditionsExplanation?: string | null, investmentsAndResources?: string | null, noteReference?: string | null, opex?: any | null, opexLongTerm?: any | null, opexShortTerm?: any | null, opexMediumTerm?: any | null, progressInfo?: string | null, provisionOfRemedy?: boolean | null, provisionOfRemedyExplanation?: string | null, relatedIRO?: string | null, relatedPolicy?: string | null, statusOfKeyAction?: string | null, scope?: string | null, startDate: any, timeHorizon?: string | null, scopeValueChain?: string | null, coverage?: string | null, coverageExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, materialStandard: { __typename?: 'esrs_MaterialStandard', standardRef: string }, actionReportingUnits: Array<{ __typename?: 'esrs_ActionReportingUnit', reportingUnitId: any, updatedAt: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', lineageId: any } }>, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', authorId: any, body?: string | null, isAIGenerated: boolean, updatedAt: any }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null };

export type EsrsAssessmentForDuplicationQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type EsrsAssessmentForDuplicationQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', projectLeaderId?: any | null, metadata?: any | null, companyId: any, companySize?: string | null, onboardingStep?: number | null, reportingYear: number, updatedAt: any, collectOnly?: boolean | null, frameworkRef?: string | null, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', updatedAt: any, standardRef: string, isMaterial?: boolean | null, isDataGatheringOnly: boolean, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', authorId: any, body?: string | null, isAIGenerated: boolean, updatedAt: any }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', updatedAt: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, frequency: string, dataCollection?: string | null, isHidden: boolean, metricRef: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', updatedAt: any, tagType: string, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', updatedAt: any, tagType: string, tagValue: string }> }> }>, policies: Array<{ __typename?: 'esrs_Policy', updatedAt: any, disclosureRequirementRef: string, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', authorId: any, body?: string | null, isAIGenerated: boolean, updatedAt: any }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null }>, targets: Array<{ __typename?: 'esrs_Target', updatedAt: any, name: string, metricRef?: string | null, disclosureRequirementRef: string, ownerId?: any | null, answers?: any | null, description?: string | null, direction?: string | null, isEvidenceScientific?: boolean | null, isEvidenceScientificExplanation?: string | null, isProgressAligned?: boolean | null, isProgressAlignedExplanation?: string | null, isBottomUp: boolean, isRequired: boolean, methodologies?: string | null, relatedPolicy?: string | null, performanceNumber?: any | null, performanceText?: string | null, periodExplanation?: string | null, scope?: string | null, targetChangeDescription?: string | null, withStakeholders?: boolean | null, withStakeholdersDescription?: string | null, withStakeholdersExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, relationshipToPolicy?: string | null, coverageExplanation?: string | null, coverage?: string | null, materialStandard: { __typename?: 'esrs_MaterialStandard', standardRef: string }, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', authorId: any, body?: string | null, isAIGenerated: boolean, updatedAt: any }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, keyResults: Array<{ __typename?: 'esrs_Baseline', updatedAt: any, baseYear?: any | null, baseline?: string | null, isFlagged: boolean, reportingUnitId?: any | null, reportingUnit?: { __typename?: 'esrs_ReportingUnit', lineageId: any } | null }>, milestones: Array<{ __typename?: 'esrs_Milestone', updated_at?: any | null, isRelative: boolean, isRequired: boolean, year: number, milestoneResults: Array<{ __typename?: 'esrs_MilestoneResult', updatedAt: any, value?: any | null, reportingUnitId?: any | null, reportingUnit?: { __typename?: 'esrs_ReportingUnit', lineageId: any } | null }> }>, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', estimate?: any | null, updatedAt: any, action: { __typename?: 'esrs_Actions', updatedAt: any, title: string, disclosureRequirementRef: string, ownerId?: any | null, answers?: any | null, capex?: any | null, capexLongTerm?: any | null, capexShortTerm?: any | null, capexMediumTerm?: any | null, deadline: any, expectedOutcome?: string | null, hasPreconditions?: boolean | null, hasPreconditionsExplanation?: string | null, investmentsAndResources?: string | null, noteReference?: string | null, opex?: any | null, opexLongTerm?: any | null, opexShortTerm?: any | null, opexMediumTerm?: any | null, progressInfo?: string | null, provisionOfRemedy?: boolean | null, provisionOfRemedyExplanation?: string | null, relatedIRO?: string | null, relatedPolicy?: string | null, statusOfKeyAction?: string | null, scope?: string | null, startDate: any, timeHorizon?: string | null, scopeValueChain?: string | null, coverage?: string | null, coverageExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, materialStandard: { __typename?: 'esrs_MaterialStandard', standardRef: string }, actionReportingUnits: Array<{ __typename?: 'esrs_ActionReportingUnit', reportingUnitId: any, updatedAt: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', lineageId: any } }>, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', authorId: any, body?: string | null, isAIGenerated: boolean, updatedAt: any }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null } }> }>, actionsWithoutTargets: Array<{ __typename?: 'esrs_Actions', updatedAt: any, title: string, disclosureRequirementRef: string, ownerId?: any | null, answers?: any | null, capex?: any | null, capexLongTerm?: any | null, capexShortTerm?: any | null, capexMediumTerm?: any | null, deadline: any, expectedOutcome?: string | null, hasPreconditions?: boolean | null, hasPreconditionsExplanation?: string | null, investmentsAndResources?: string | null, noteReference?: string | null, opex?: any | null, opexLongTerm?: any | null, opexShortTerm?: any | null, opexMediumTerm?: any | null, progressInfo?: string | null, provisionOfRemedy?: boolean | null, provisionOfRemedyExplanation?: string | null, relatedIRO?: string | null, relatedPolicy?: string | null, statusOfKeyAction?: string | null, scope?: string | null, startDate: any, timeHorizon?: string | null, scopeValueChain?: string | null, coverage?: string | null, coverageExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, materialStandard: { __typename?: 'esrs_MaterialStandard', standardRef: string }, actionReportingUnits: Array<{ __typename?: 'esrs_ActionReportingUnit', reportingUnitId: any, updatedAt: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', lineageId: any } }>, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', authorId: any, body?: string | null, isAIGenerated: boolean, updatedAt: any }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null }>, disclosureRequirementStatuses: Array<{ __typename?: 'DisclosureRequirementStatus', isConfigured: boolean, disclosureRequirementRef?: string | null, mfDisclosureRequirementRef?: string | null }> }>, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', lineageId: any, updatedAt: any, name: string, isCompanyLevel: boolean, projectLeaderId?: any | null, answers: Array<{ __typename?: 'esrs_Answer', updatedAt: any, hasOptedOut: boolean, metricRef: string, optOutAuthorId?: any | null, optOutReason?: string | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', authorId: any, body?: string | null, isAIGenerated: boolean, updatedAt: any }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null }, datapoints: Array<{ __typename?: 'esrs_Datapoint', updatedAt: any, authorId?: any | null, source?: string | null, tagCombination?: string | null, metadata?: any | null, isMdrmDisclosed?: boolean | null, mdrmElsewhereDisclosure?: string | null, ownerId?: any | null, value?: string | null, timeframe: string, factValue?: string | null, thread?: { __typename?: 'Thread', companyId: any, comments: Array<{ __typename?: 'Comment', id: any, data: string, authorId: any, updatedAt: any, duplicatedFrom?: any | null }>, subscribers: Array<{ __typename?: 'ThreadSubscriber', userId: any }> } | null, datapointMdrms: Array<{ __typename?: 'esrs_DatapointMdrm', authorId?: any | null, hasOptedOut: boolean, value?: string | null, mdrmRef: string, thread?: { __typename?: 'Thread', companyId: any, comments: Array<{ __typename?: 'Comment', id: any, data: string, authorId: any, updatedAt: any, duplicatedFrom?: any | null }>, subscribers: Array<{ __typename?: 'ThreadSubscriber', userId: any }> } | null }>, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', updatedAt: any, tagType: string, tagValue: string }>, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string }> }> }>, disclosureRequirementAttachments: Array<{ __typename?: 'esrs_DisclosureRequirementAttachment', updatedAt?: any | null, disclosureRequirementRef: string, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, materialStandard: { __typename?: 'esrs_MaterialStandard', standardRef: string } }> }> } | null };

export type UpsertDuplicatedReportingUnitsMutationVariables_ = Exact<{
  objects?: InputMaybe<Array<Esrs_ReportingUnit_Insert_Input_> | Esrs_ReportingUnit_Insert_Input_>;
}>;


export type UpsertDuplicatedReportingUnitsMutation_ = { __typename?: 'mutation_root', insert_esrs_ReportingUnit?: { __typename?: 'esrs_ReportingUnit_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean, lineageId: any }> } | null };

export type EsrsAssessmentsQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type EsrsAssessmentsQuery_ = { __typename?: 'query_root', esrsAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingYear: number, onboardingStep?: number | null, companySize?: string | null, parentAssessment?: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null } } | null, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string }>, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, onboardingStep?: number | null, company: { __typename?: 'Company', name: string, id: any }, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }>, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, assessmentId: any, isCompanyLevel: boolean, lineageId: any, projectLeaderId?: any | null, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }>, company: { __typename?: 'Company', id: any, name: string }, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }> };

export type EsrsAssessmentsListQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type EsrsAssessmentsListQuery_ = { __typename?: 'query_root', esrsAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingYear: number, onboardingStep?: number | null, framework?: { __typename?: 'Framework', name: string, reference: string } | null, parentAssessment?: { __typename?: 'EsrsAssessment', id: any, projectLeaderId?: any | null, company: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null }, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any }> }> };

export type EsrsAssessmentsYearsQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
  companyIntegrationId: Scalars['uuid']['input'];
}>;


export type EsrsAssessmentsYearsQuery_ = { __typename?: 'query_root', esrsAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingYear: number, projectLeaderId?: any | null, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any }>, esrsAssessmentCompanyIntegrations: Array<{ __typename?: 'esrs_EsrsAssessmentCompanyIntegration', syncedAt?: any | null }> }> };

export type EsrsAssessmentQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type EsrsAssessmentQuery_ = { __typename?: 'query_root', esrsAssessment?: { __typename?: 'EsrsAssessment', id: any, reportingYear: number, onboardingStep?: number | null, companySize?: string | null, parentAssessment?: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null } } | null, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string }>, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, onboardingStep?: number | null, company: { __typename?: 'Company', name: string, id: any }, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }>, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, assessmentId: any, isCompanyLevel: boolean, lineageId: any, projectLeaderId?: any | null, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }>, company: { __typename?: 'Company', id: any, name: string }, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null };

export type ShortEsrsAssessmentQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type ShortEsrsAssessmentQuery_ = { __typename?: 'query_root', esrsAssessment?: { __typename?: 'EsrsAssessment', id: any, reportingYear: number, collectOnly?: boolean | null, company: { __typename?: 'Company', id: any, isGroupOwner: boolean }, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, parentAssessment?: { __typename?: 'EsrsAssessment', id: any } | null, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, materialStandardOwners: Array<{ __typename?: 'MaterialStandardOwner', id: any, reportingUnitId: any, owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> }> } | null };

export type EsrsAssessmentYearQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type EsrsAssessmentYearQuery_ = { __typename?: 'query_root', esrsAssessment?: { __typename?: 'EsrsAssessment', id: any, reportingYear: number, framework?: { __typename?: 'Framework', name: string } | null } | null };

export type EsrsAssessmentProjectLeaderQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type EsrsAssessmentProjectLeaderQuery_ = { __typename?: 'query_root', esrsAssessment?: { __typename?: 'EsrsAssessment', id: any, projectLeaderId?: any | null, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null };

export type EsrsAssessmentMaterialStandardsQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type EsrsAssessmentMaterialStandardsQuery_ = { __typename?: 'query_root', esrsAssessment?: { __typename?: 'EsrsAssessment', id: any, collectOnly?: boolean | null, parentAssessmentId?: any | null, reportingYear: number, company: { __typename?: 'Company', name: string }, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, standard: { __typename?: 'EsrsStandard', reference: string, frameworkRef?: string | null, category: { __typename?: 'EsrsCategory', title: string, reference: string } }, disclosureRequirementStatuses: Array<{ __typename?: 'DisclosureRequirementStatus', disclosureRequirementRef?: string | null, mfDisclosureRequirementRef?: string | null, isConfigured: boolean }>, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, isDataGatheringOnly: boolean, metric: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, disclosureRequirementRef: string, childrenMetricsCount?: number | null, requirement: { __typename?: 'DisclosureRequirement', reference: string, type: string, frameworkRef?: string | null }, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }> }> } | null };

export type ReportingUnitLineageQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type ReportingUnitLineageQuery_ = { __typename?: 'query_root', esrs_ReportingUnitLineage: Array<{ __typename?: 'esrs_ReportingUnitLineage', reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, lineageId: any, projectLeaderId?: any | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, reportingYear: number }, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }> }> };

export type GetSubsidiariesWithAssessmentsQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
  standardRef: Scalars['String']['input'];
}>;


export type GetSubsidiariesWithAssessmentsQuery_ = { __typename?: 'query_root', esrs?: { __typename?: 'EsrsAssessment', id: any, subsidiaries: Array<{ __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string }, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, isMaterial?: boolean | null }> }> } | null };

export type GetSubsidiariesQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetSubsidiariesQuery_ = { __typename?: 'query_root', esrs?: { __typename?: 'EsrsAssessment', id: any, subsidiaries: Array<{ __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } }> } | null };

export type GetReportingUnitsQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetReportingUnitsQuery_ = { __typename?: 'query_root', reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean }> };

export type GetEsrsAssessmentMetadataQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetEsrsAssessmentMetadataQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, metadata?: any | null } | null };

export type GetEsrsAssessmentShortDetailsQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetEsrsAssessmentShortDetailsQuery_ = { __typename?: 'query_root', assessment?: { __typename?: 'EsrsAssessment', id: any, reportingYear: number, companyId: any, collectOnly?: boolean | null, parentAssessmentId?: any | null, company: { __typename?: 'Company', name: string } } | null };

export type GetOnboardingEsrsAssessmentQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetOnboardingEsrsAssessmentQuery_ = { __typename?: 'query_root', esrsAssessment?: { __typename?: 'EsrsAssessment', id: any, onboardingStep?: number | null, collectOnly?: boolean | null, company: { __typename?: 'Company', id: any, name: string }, parentAssessment?: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null } } | null } | null };

export type GetParentAssessmentToCopyQueryVariables_ = Exact<{
  childAssessmentId: Scalars['uuid']['input'];
}>;


export type GetParentAssessmentToCopyQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, parentAssessment?: { __typename?: 'EsrsAssessment', materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, isMaterial?: boolean | null, standardRef: string, standard: { __typename?: 'EsrsStandard', reference: string, disclosureRequirementGroups: Array<{ __typename?: 'DisclosureRequirementGroup', policyRequirements: Array<{ __typename?: 'DisclosureRequirement', reference: string }> }> }, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, metric: { __typename?: 'EsrsMetric', reference: string, disclosureRequirementRef: string } }> }> } | null } | null };

export type GetReportingUnitQueryVariables_ = Exact<{
  reportingUnitId: Scalars['uuid']['input'];
}>;


export type GetReportingUnitQuery_ = { __typename?: 'query_root', bu?: { __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean, name: string } | null };

export type GetSubsidiaryTypeQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetSubsidiaryTypeQuery_ = { __typename?: 'query_root', esrsAssessment?: { __typename?: 'EsrsAssessment', id: any, collectOnly?: boolean | null } | null };

export type GetFlaggedTargetsQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetFlaggedTargetsQuery_ = { __typename?: 'query_root', targets: Array<{ __typename?: 'esrs_Target', id: any, name: string, disclosureRequirementRef: string, assessmentId: any, materialStandard: { __typename?: 'esrs_MaterialStandard', standardRef: string, standard: { __typename?: 'EsrsStandard', title: string } } }> };

export type GetGroupMaterialMetricsQueryVariables_ = Exact<{
  materialStandardId: Scalars['uuid']['input'];
}>;


export type GetGroupMaterialMetricsQuery_ = { __typename?: 'query_root', materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, metric: { __typename?: 'EsrsMetric', tags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, tagType: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } }> };

export type GetMaterialStandardPolicyRefQueryVariables_ = Exact<{
  materialStandardId: Scalars['uuid']['input'];
}>;


export type GetMaterialStandardPolicyRefQuery_ = { __typename?: 'query_root', esrs_MaterialStandard_by_pk?: { __typename?: 'esrs_MaterialStandard', id: any, standard: { __typename?: 'EsrsStandard', reference: string, disclosureRequirementGroups: Array<{ __typename?: 'DisclosureRequirementGroup', requirements: Array<{ __typename?: 'DisclosureRequirement', reference: string, type: string }> }> } } | null };

export type GetIntegrationApiKeyQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
  integrationSystemName: Scalars['String']['input'];
}>;


export type GetIntegrationApiKeyQuery_ = { __typename?: 'query_root', esrs_CompanyIntegration: Array<{ __typename?: 'esrs_CompanyIntegration', id: any, apiKey?: string | null, isDisaggregated?: boolean | null }> };

export type GetE16MaterialMetricsCountQueryVariables_ = Exact<{
  esrsAssessment: Scalars['uuid']['input'];
}>;


export type GetE16MaterialMetricsCountQuery_ = { __typename?: 'query_root', esrs_MaterialMetric_aggregate: { __typename?: 'esrs_MaterialMetric_aggregate', aggregate?: { __typename?: 'esrs_MaterialMetric_aggregate_fields', count: number } | null } };

export type UpsertEsrsAssessmentMutationVariables_ = Exact<{
  esrsAssessment: EsrsAssessment_Insert_Input_;
}>;


export type UpsertEsrsAssessmentMutation_ = { __typename?: 'mutation_root', insert_EsrsAssessment_one?: { __typename?: 'EsrsAssessment', id: any, reportingYear: number, onboardingStep?: number | null, companySize?: string | null, parentAssessment?: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null } } | null, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string }>, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, onboardingStep?: number | null, company: { __typename?: 'Company', name: string, id: any }, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }>, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, assessmentId: any, isCompanyLevel: boolean, lineageId: any, projectLeaderId?: any | null, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }>, company: { __typename?: 'Company', id: any, name: string }, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null };

export type UpsertReportingUnitLineageMutationVariables_ = Exact<{
  reportingUnitLineage: Esrs_ReportingUnitLineage_Insert_Input_;
}>;


export type UpsertReportingUnitLineageMutation_ = { __typename?: 'mutation_root', insert_esrs_ReportingUnitLineage_one?: { __typename?: 'esrs_ReportingUnitLineage', id: any, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', name: string, id: any }> } | null };

export type UpsertEsrsReportingUnitMutationVariables_ = Exact<{
  reportingUnit: Esrs_ReportingUnit_Insert_Input_;
}>;


export type UpsertEsrsReportingUnitMutation_ = { __typename?: 'mutation_root', insert_esrs_ReportingUnit_one?: { __typename?: 'esrs_ReportingUnit', id: any, assessmentId: any } | null };

export type UpdateAssessmentOnboardingMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  onboardingStep: Scalars['Int']['input'];
}>;


export type UpdateAssessmentOnboardingMutation_ = { __typename?: 'mutation_root', update_EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, onboardingStep?: number | null } | null };

export type UpdateAssessmentCompanySizeMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  companySize: Scalars['String']['input'];
}>;


export type UpdateAssessmentCompanySizeMutation_ = { __typename?: 'mutation_root', update_EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, companySize?: string | null } | null };

export type UpdateAssessmentCompanyProjectLeaderMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  projectLeaderId: Scalars['uuid']['input'];
}>;


export type UpdateAssessmentCompanyProjectLeaderMutation_ = { __typename?: 'mutation_root', update_EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, projectLeaderId?: any | null } | null };

export type AddEsrsSubsidaryMutationVariables_ = Exact<{
  esrsAssessment: EsrsAssessment_Insert_Input_;
}>;


export type AddEsrsSubsidaryMutation_ = { __typename?: 'mutation_root', insert_EsrsAssessment_one?: { __typename?: 'EsrsAssessment', id: any, parentAssessmentId?: any | null } | null };

export type UpdateEsrsSubsidaryMutationVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
  reportingYear: Scalars['Int']['input'];
  parentAssessmentId: Scalars['uuid']['input'];
  projectLeaderId: Scalars['uuid']['input'];
  frameworkRef: Scalars['String']['input'];
}>;


export type UpdateEsrsSubsidaryMutation_ = { __typename?: 'mutation_root', update_EsrsAssessment?: { __typename?: 'EsrsAssessment_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'EsrsAssessment', id: any, parentAssessmentId?: any | null }> } | null };

export type RemoveEsrsSubsidiaryMutationVariables_ = Exact<{
  childAssessmentId: Scalars['uuid']['input'];
}>;


export type RemoveEsrsSubsidiaryMutation_ = { __typename?: 'mutation_root', update_EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any } | null };

export type UpdateEsrsAssessmentMetaDataMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  metadata: Scalars['jsonb']['input'];
}>;


export type UpdateEsrsAssessmentMetaDataMutation_ = { __typename?: 'mutation_root', update_EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, metadata?: any | null } | null };

export type DeleteEsrsAssessmentMutationVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type DeleteEsrsAssessmentMutation_ = { __typename?: 'mutation_root', update_EsrsAssessment?: { __typename?: 'EsrsAssessment_mutation_response', returning: Array<{ __typename?: 'EsrsAssessment', id: any }> } | null };

export type UpdateSubsidiaryDataCollectionTypeMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  collectOnly: Scalars['Boolean']['input'];
}>;


export type UpdateSubsidiaryDataCollectionTypeMutation_ = { __typename?: 'mutation_root', update_EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, collectOnly?: boolean | null } | null };

export type DeleteReportingUnitMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteReportingUnitMutation_ = { __typename?: 'mutation_root', delete_esrs_ReportingUnit_by_pk?: { __typename?: 'esrs_ReportingUnit', id: any } | null };

export type EsrsAssessmentAnswersAggregateQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type EsrsAssessmentAnswersAggregateQuery_ = { __typename?: 'query_root', esrs_Answer_aggregate: { __typename?: 'esrs_Answer_aggregate', aggregate?: { __typename?: 'esrs_Answer_aggregate_fields', count: number } | null } };

export type UpsertIntegrationKeyMutationVariables_ = Exact<{
  object: Esrs_CompanyIntegration_Insert_Input_;
}>;


export type UpsertIntegrationKeyMutation_ = { __typename?: 'mutation_root', insert_esrs_CompanyIntegration_one?: { __typename?: 'esrs_CompanyIntegration', id: any } | null };

export type GetParentEsrsAssessmentIdQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetParentEsrsAssessmentIdQuery_ = { __typename?: 'query_root', esrsAssessment?: { __typename?: 'EsrsAssessment', id: any, parentAssessmentId?: any | null } | null };

export type UpsertAssessmentCompanyIntegrationMutationVariables_ = Exact<{
  object: Esrs_EsrsAssessmentCompanyIntegration_Insert_Input_;
}>;


export type UpsertAssessmentCompanyIntegrationMutation_ = { __typename?: 'mutation_root', insert_esrs_EsrsAssessmentCompanyIntegration_one?: { __typename?: 'esrs_EsrsAssessmentCompanyIntegration', id: any } | null };

export type AssessmentCompanyIntegrationRuQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
  companyIntegrationId: Scalars['uuid']['input'];
}>;


export type AssessmentCompanyIntegrationRuQuery_ = { __typename?: 'query_root', esrsAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingYear: number, projectLeaderId?: any | null, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, esrsAssessment: { __typename?: 'EsrsAssessment', esrsAssessmentCompanyIntegrations: Array<{ __typename?: 'esrs_EsrsAssessmentCompanyIntegration', esrsAssessmentCompanyIntegrationRUs: Array<{ __typename?: 'esrs_EsrsAssessmentCompanyIntegrationRU', esrsReportingUnitId: any, syncedAt?: any | null, apiKey?: string | null, esrsAssessmentCompanyIntegrationId: any }> }> } }> }> };

export type UpsertAssessmentCompanyIntegrationRuMutationVariables_ = Exact<{
  object: Esrs_EsrsAssessmentCompanyIntegrationRu_Insert_Input_;
}>;


export type UpsertAssessmentCompanyIntegrationRuMutation_ = { __typename?: 'mutation_root', insert_esrs_EsrsAssessmentCompanyIntegrationRU_one?: { __typename?: 'esrs_EsrsAssessmentCompanyIntegrationRU', id: any } | null };

export type SingleAssessmentCompanyIntegrationRuQueryVariables_ = Exact<{
  reportingUnitId: Scalars['uuid']['input'];
  assessmentCompanyIntegrationId: Scalars['uuid']['input'];
}>;


export type SingleAssessmentCompanyIntegrationRuQuery_ = { __typename?: 'query_root', esrs_EsrsAssessmentCompanyIntegrationRU: Array<{ __typename?: 'esrs_EsrsAssessmentCompanyIntegrationRU', syncedAt?: any | null, apiKey?: string | null }> };

export type GetMaterialStandardsIdsQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetMaterialStandardsIdsQuery_ = { __typename?: 'query_root', esrs_MaterialStandard: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string }> };

export type GetEsrsCategoriesQueryVariables_ = Exact<{
  frameworkRef: Scalars['String']['input'];
}>;


export type GetEsrsCategoriesQuery_ = { __typename?: 'query_root', EsrsCategory: Array<{ __typename?: 'EsrsCategory', title: string, reference: string, standards: Array<{ __typename?: 'EsrsStandard', title: string, reference: string, description?: string | null, isTopical: boolean, disclosureRequirementGroups: Array<{ __typename?: 'DisclosureRequirementGroup', reference: string, requirements: Array<{ __typename?: 'DisclosureRequirement', reference: string, isMandatory: boolean }> }>, specificMFStandard?: { __typename?: 'MFStandard', title: string, reference: string, description?: string | null, disclosureRequirementGroups: Array<{ __typename?: 'MFDisclosureRequirementGroup', reference: string, requirements: Array<{ __typename?: 'MFDisclosureRequirement', reference: string }> }> } | null }> }> };

export type GetFullEsrsCategoriesQueryVariables_ = Exact<{
  frameworkRef: Scalars['String']['input'];
}>;


export type GetFullEsrsCategoriesQuery_ = { __typename?: 'query_root', EsrsCategory: Array<{ __typename?: 'EsrsCategory', title: string, reference: string, standards: Array<{ __typename?: 'EsrsStandard', title: string, reference: string, description?: string | null, isTopical: boolean, disclosureRequirementGroups: Array<{ __typename?: 'DisclosureRequirementGroup', reference: string, requirements: Array<{ __typename?: 'DisclosureRequirement', reference: string, isMandatory: boolean, metrics: Array<{ __typename?: 'EsrsMetric', reference: string, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string }> } }> }> }> }>, specificMFStandard?: { __typename?: 'MFStandard', title: string, reference: string, description?: string | null, disclosureRequirementGroups: Array<{ __typename?: 'MFDisclosureRequirementGroup', reference: string, requirements: Array<{ __typename?: 'MFDisclosureRequirement', reference: string }> }> } | null }> }> };

export type GetMfStandardsQueryVariables_ = Exact<{
  mfStandardRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetMfStandardsQuery_ = { __typename?: 'query_root', MFStandard: Array<{ __typename?: 'MFStandard', title: string, reference: string, description?: string | null, mfDisclosureRequirementGroups: Array<{ __typename?: 'MFDisclosureRequirementGroup', reference: string, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirement', reference: string, mfDisclosureRequirementItems: Array<{ __typename?: 'MFDisclosureRequirementItem', metric: { __typename?: 'EsrsMetric', reference: string, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string }> } }> } }> }> }> }> };

export type GetEsrsStandardQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type GetEsrsStandardQuery_ = { __typename?: 'query_root', esrsStandard?: { __typename?: 'EsrsStandard', reference: string, title: string, description?: string | null, aiPolicyChecklist?: string | null, formattedPolicyChecklist?: string | null, isTopical: boolean, additionalTypes: Array<{ __typename?: 'EsrsStandardAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, disclosureRequirementGroups: Array<{ __typename?: 'DisclosureRequirementGroup', title: string, reference: string, requirements: Array<{ __typename?: 'DisclosureRequirement', title: string, reference: string, isMandatory: boolean, description?: string | null, order: number, frameworkRef?: string | null, mfDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', mfDisclosureRequirementRef: string }>, additionalTypes: Array<{ __typename?: 'DisclosureRequirementAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, metrics: Array<{ __typename?: 'EsrsMetric', reference: string, title: string, shortTitle?: string | null, metricType?: QuestionType_Enum_ | null, description?: string | null, order: number, firstLevel?: string | null, secondLevel?: string | null, disclosureRequirementRef: string, isAR: boolean, isAssessable: boolean, abbreviation?: string | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string }> } }> } }>, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string }> } }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }> } | null }> } | null }> } | null }> } | null }> }>, metrics_aggregate: { __typename?: 'EsrsMetric_aggregate', aggregate?: { __typename?: 'EsrsMetric_aggregate_fields', count: number } | null } }> }> } | null };

export type GetEsrsStandardHeaderQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type GetEsrsStandardHeaderQuery_ = { __typename?: 'query_root', esrsStandard?: { __typename?: 'EsrsStandard', title: string, reference: string, isTopical: boolean } | null };

export type GetShortEsrsStandardQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type GetShortEsrsStandardQuery_ = { __typename?: 'query_root', esrsStandard?: { __typename?: 'EsrsStandard', title: string, description?: string | null, reference: string } | null };

export type GetDisclosureRequirementGroupsQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
  parentStandardId: Scalars['uuid']['input'];
}>;


export type GetDisclosureRequirementGroupsQuery_ = { __typename?: 'query_root', requirementGroup: Array<{ __typename?: 'DisclosureRequirementGroup', reference: string, title: string, standardRef: string, requirements: Array<{ __typename?: 'DisclosureRequirement', reference: string, title: string, description?: string | null, type: string, policies: Array<{ __typename?: 'esrs_Policy', attachmentBox?: { __typename?: 'AttachmentBox', attachments: Array<{ __typename?: 'Attachment', id: any }> } | null }>, actions_aggregate: { __typename?: 'esrs_Actions_aggregate', aggregate?: { __typename?: 'esrs_Actions_aggregate_fields', count: number } | null }, targets_aggregate: { __typename?: 'esrs_Target_aggregate', aggregate?: { __typename?: 'esrs_Target_aggregate_fields', count: number } | null }, metrics: Array<{ __typename?: 'EsrsMetric', reference: string, childrenMetricsCount?: number | null }>, mfDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', mfDisclosureRequirementItems: Array<{ __typename?: 'MFDisclosureRequirementItem', metric: { __typename?: 'EsrsMetric', reference: string, childrenMetricsCount?: number | null } }> } }> }> }> };

export type GetMfDisclosureRequirementGroupsQueryVariables_ = Exact<{
  mfStandardRef: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
  parentStandardId: Scalars['uuid']['input'];
}>;


export type GetMfDisclosureRequirementGroupsQuery_ = { __typename?: 'query_root', requirementGroup: Array<{ __typename?: 'MFDisclosureRequirementGroup', reference: string, title: string, standardRef: string, requirements: Array<{ __typename?: 'MFDisclosureRequirement', reference: string, title: string, description?: string | null, type: string, policies: Array<{ __typename?: 'esrs_Policy', attachmentBox?: { __typename?: 'AttachmentBox', attachments: Array<{ __typename?: 'Attachment', id: any }> } | null }>, actions_aggregate: { __typename?: 'esrs_Actions_aggregate', aggregate?: { __typename?: 'esrs_Actions_aggregate_fields', count: number } | null }, targets_aggregate: { __typename?: 'esrs_Target_aggregate', aggregate?: { __typename?: 'esrs_Target_aggregate_fields', count: number } | null }, metrics: Array<{ __typename?: 'MFDisclosureRequirementItem', metric: { __typename?: 'EsrsMetric', reference: string, childrenMetricsCount?: number | null } }> }> }> };

export type GetSubsidiariesDRsCountQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetSubsidiariesDRsCountQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, subsidiaries: Array<{ __typename?: 'EsrsAssessment', id: any, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', policies: Array<{ __typename?: 'esrs_Policy', attachmentBox?: { __typename?: 'AttachmentBox', attachments: Array<{ __typename?: 'Attachment', id: any }> } | null }>, targets_aggregate: { __typename?: 'esrs_Target_aggregate', aggregate?: { __typename?: 'esrs_Target_aggregate_fields', count: number } | null }, actions_aggregate: { __typename?: 'esrs_Actions_aggregate', aggregate?: { __typename?: 'esrs_Actions_aggregate_fields', count: number } | null } }> }> } | null };

export type GetDisclosureRequirementQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type GetDisclosureRequirementQuery_ = { __typename?: 'query_root', DisclosureRequirement?: { __typename?: 'DisclosureRequirement', title: string, reference: string, isMandatory: boolean, description?: string | null, order: number, metrics: Array<{ __typename?: 'EsrsMetric', reference: string, description?: string | null, title: string, metricType?: QuestionType_Enum_ | null, calculation?: string | null, isAssessable: boolean }> } | null };

export type GetDisclosureRequirementRefQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type GetDisclosureRequirementRefQuery_ = { __typename?: 'query_root', disclosureRequirement?: { __typename?: 'DisclosureRequirement', group: { __typename?: 'DisclosureRequirementGroup', reference: string, requirements: Array<{ __typename?: 'DisclosureRequirement', reference: string }> } } | null };

export type GetAssessmentCurrencyConversionQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetAssessmentCurrencyConversionQuery_ = { __typename?: 'query_root', esrs_AssessmentCurrencyConversion: Array<{ __typename?: 'esrs_AssessmentCurrencyConversion', assessmentId: any, from: string, rate?: any | null, to: string }> };

export type GetSubCurrenciesQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetSubCurrenciesQuery_ = { __typename?: 'query_root', EsrsAssessment: Array<{ __typename?: 'EsrsAssessment', company: { __typename?: 'Company', currency: string, name: string } }> };

export type GetCurrencyConversionRateQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
}>;


export type GetCurrencyConversionRateQuery_ = { __typename?: 'query_root', esrs_AssessmentCurrencyConversion_by_pk?: { __typename?: 'esrs_AssessmentCurrencyConversion', rate?: any | null } | null };

export type GetStandardMetricsQueryVariables_ = Exact<{
  standard: Scalars['String']['input'];
}>;


export type GetStandardMetricsQuery_ = { __typename?: 'query_root', metrics: Array<{ __typename?: 'EsrsMetric', reference: string }> };

export type GetQualitativeMetricsQueryVariables_ = Exact<{ [key: string]: never; }>;


export type GetQualitativeMetricsQuery_ = { __typename?: 'query_root', EsrsMetric: Array<{ __typename?: 'EsrsMetric', reference: string, title: string, description?: string | null }> };

export type GetMaterialStandardDrStatusesQueryVariables_ = Exact<{
  materialStandardId: Scalars['uuid']['input'];
}>;


export type GetMaterialStandardDrStatusesQuery_ = { __typename?: 'query_root', DisclosureRequirementStatus: Array<{ __typename?: 'DisclosureRequirementStatus', disclosureRequirementRef?: string | null, mfDisclosureRequirementRef?: string | null, isConfigured: boolean }> };

export type FlaggedTargetsCountQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type FlaggedTargetsCountQuery_ = { __typename?: 'query_root', esrs_Target_aggregate: { __typename?: 'esrs_Target_aggregate', aggregate?: { __typename?: 'esrs_Target_aggregate_fields', count: number } | null } };

export type UpsertDisclosureRequirementAttachmentMutationVariables_ = Exact<{
  objects: Array<Esrs_DisclosureRequirementAttachment_Insert_Input_> | Esrs_DisclosureRequirementAttachment_Insert_Input_;
}>;


export type UpsertDisclosureRequirementAttachmentMutation_ = { __typename?: 'mutation_root', insert_esrs_DisclosureRequirementAttachment?: { __typename?: 'esrs_DisclosureRequirementAttachment_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_DisclosureRequirementAttachment', id: any }> } | null };

export type UpsertCurrencyConversionRateMutationVariables_ = Exact<{
  object: Esrs_AssessmentCurrencyConversion_Insert_Input_;
}>;


export type UpsertCurrencyConversionRateMutation_ = { __typename?: 'mutation_root', insert_esrs_AssessmentCurrencyConversion_one?: { __typename?: 'esrs_AssessmentCurrencyConversion', assessmentId: any, from: string, to: string, rate?: any | null } | null };

export type GetEsrsReportStructureQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  groupMetrics: Array<Scalars['String']['input']> | Scalars['String']['input'];
  groupStandards: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetEsrsReportStructureQuery_ = { __typename?: 'query_root', esrs_MaterialStandard: Array<{ __typename?: 'esrs_MaterialStandard', standard: { __typename?: 'EsrsStandard', reference: string, title: string, category: { __typename?: 'EsrsCategory', reference: string, title: string }, disclosureRequirementGroups: Array<{ __typename?: 'DisclosureRequirementGroup', title: string, reference: string, requirements: Array<{ __typename?: 'DisclosureRequirement', title: string, reference: string, order: number, type: string, additionalTypes: Array<{ __typename?: 'DisclosureRequirementAdditionalType', additionalTypeRef: string }>, notHiddenCount: { __typename?: 'EsrsMetric_aggregate', aggregate?: { __typename?: 'EsrsMetric_aggregate_fields', count: number } | null } }> }>, specificMFStandard?: { __typename?: 'MFStandard', reference: string, title: string, category: { __typename?: 'MFCategory', reference: string, title: string }, disclosureRequirementGroups: Array<{ __typename?: 'MFDisclosureRequirementGroup', title: string, reference: string, requirements: Array<{ __typename?: 'MFDisclosureRequirement', title: string, reference: string, order: number, type: string, notHiddenCount: { __typename?: 'MFDisclosureRequirementItem_aggregate', aggregate?: { __typename?: 'MFDisclosureRequirementItem_aggregate_fields', count: number } | null } }> }> } | null } }> };

export type GetReportMetricsPerDisclosureQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  disclosureRequirementRef: Scalars['String']['input'];
  groupMetrics: Array<Scalars['String']['input']> | Scalars['String']['input'];
  frameworkRef: Scalars['String']['input'];
}>;


export type GetReportMetricsPerDisclosureQuery_ = { __typename?: 'query_root', EsrsMetric: Array<{ __typename?: 'EsrsMetric', reference: string, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, materialStandardId: any, dataCollection?: string | null, frequency: string, isMaterial?: boolean | null, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string, title: string, shortTitle?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, hasAssociation: boolean, unitOfMeasurement?: string | null, unlockCondition?: boolean | null, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, showPercentageWithTag: boolean, notAggregatable: boolean, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirementRef: string }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null }, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, reference: string, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, hasAssociation: boolean, unitOfMeasurement?: string | null, unlockCondition?: boolean | null, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, showPercentageWithTag: boolean, notAggregatable: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }> }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, reference: string, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, hasAssociation: boolean, unitOfMeasurement?: string | null, unlockCondition?: boolean | null, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, showPercentageWithTag: boolean, notAggregatable: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }> }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, reference: string, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, hasAssociation: boolean, unitOfMeasurement?: string | null, unlockCondition?: boolean | null, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, showPercentageWithTag: boolean, notAggregatable: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }> }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, reference: string, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, hasAssociation: boolean, unitOfMeasurement?: string | null, unlockCondition?: boolean | null, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, showPercentageWithTag: boolean, notAggregatable: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }> }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirementRef: string }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirementRef: string }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirementRef: string }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirementRef: string }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null } | null }>, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }> }> }> };

export type GetReportGeneralDisclosureRequirementsQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetReportGeneralDisclosureRequirementsQuery_ = { __typename?: 'query_root', DisclosureRequirement: Array<{ __typename?: 'DisclosureRequirement', title: string, reference: string, order: number, type: string, additionalTypes: Array<{ __typename?: 'DisclosureRequirementAdditionalType', additionalTypeRef: string }>, notHiddenCount: { __typename?: 'EsrsMetric_aggregate', aggregate?: { __typename?: 'EsrsMetric_aggregate_fields', count: number } | null } }> };

export type GetMetricVisibilityStatusQueryVariables_ = Exact<{
  materialStandardId: Scalars['uuid']['input'];
  metricRef: Scalars['String']['input'];
}>;


export type GetMetricVisibilityStatusQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isHidden: boolean }> };

export type GetReportMaterialStandardsQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
  groupMetrics: Array<Scalars['String']['input']> | Scalars['String']['input'];
  groupStandards: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetReportMaterialStandardsQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, standard: { __typename?: 'EsrsStandard', order: number, categoryRef: string, title: string, disclosureRequirementGroups: Array<{ __typename?: 'DisclosureRequirementGroup', reference: string, requirements: Array<{ __typename?: 'DisclosureRequirement', order: number, reference: string, title: string, frameworkRef?: string | null, type: string, additionalTypes: Array<{ __typename?: 'DisclosureRequirementAdditionalType', additionalTypeRef: string }>, metrics: Array<{ __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, reference: string, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, hasAssociation: boolean, unitOfMeasurement?: string | null, unlockCondition?: boolean | null, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, showPercentageWithTag: boolean, notAggregatable: boolean, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirementRef: string }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null }>, targets: Array<{ __typename?: 'esrs_Target', id: any, disclosureRequirementRef: string, name: string, direction?: string | null, metricRef?: string | null, isBottomUp: boolean, description?: string | null, assessmentId: any, ownerId?: any | null, isRequired: boolean, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, period?: string | null, periodExplanation?: string | null, scope?: string | null, methodologies?: string | null, isEvidenceScientific?: boolean | null, isEvidenceScientificExplanation?: string | null, withStakeholders?: boolean | null, withStakeholdersExplanation?: string | null, withStakeholdersDescription?: string | null, targetChangeDescription?: string | null, isProgressAligned?: boolean | null, performanceNumber?: any | null, performanceText?: string | null, isProgressAlignedExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, relationshipToPolicy?: string | null, coverage?: string | null, coverageExplanation?: string | null, parentTargetId?: any | null, owner?: { __typename?: 'users', id: any, displayName: string, avatarUrl: string } | null, metric?: { __typename?: 'EsrsMetric', reference: string, title: string, unitOfMeasurement?: string | null } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, actionId: any, estimate?: any | null, action: { __typename?: 'esrs_Actions', id: any, title: string } }>, keyResults: Array<{ __typename?: 'esrs_Baseline', id: any, baseline?: string | null, baseYear?: any | null, reportingUnitId?: any | null, isFlagged: boolean }>, parentTarget?: { __typename?: 'esrs_Target', name: string, materialStandard: { __typename?: 'esrs_MaterialStandard', esrsAssessment: { __typename?: 'EsrsAssessment', company: { __typename?: 'Company', name: string } } }, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number }> } | null, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any, standardRef: string, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, subsidiariesTargets: Array<{ __typename?: 'esrs_Target', id: any, metricRef?: string | null }>, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number, isRelative: boolean, isRequired: boolean, milestoneResults: Array<{ __typename?: 'esrs_MilestoneResult', id: any, value?: any | null, reportingUnitId?: any | null }> }> }>, actions: Array<{ __typename?: 'esrs_Actions', id: any, disclosureRequirementRef: string, title: string, deadline: any, startDate: any, ownerId?: any | null, capex?: any | null, noteReference?: string | null, timeHorizon?: string | null, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, statusOfKeyAction?: string | null, scope?: string | null, expectedOutcome?: string | null, provisionOfRemedy?: boolean | null, provisionOfRemedyExplanation?: string | null, progressInfo?: string | null, investmentsAndResources?: string | null, hasPreconditions?: boolean | null, hasPreconditionsExplanation?: string | null, opex?: any | null, opexShortTerm?: any | null, opexMediumTerm?: any | null, opexLongTerm?: any | null, capexShortTerm?: any | null, capexMediumTerm?: any | null, capexLongTerm?: any | null, scopeValueChain?: string | null, coverage?: string | null, coverageExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, statusOfKeyActionExplanation?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, estimate?: any | null, target: { __typename?: 'esrs_Target', id: any, direction?: string | null, name: string, metric?: { __typename?: 'EsrsMetric', title: string, unitOfMeasurement?: string | null } | null } }>, actionReportingUnits: Array<{ __typename?: 'esrs_ActionReportingUnit', id: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string } }>, actionSubsidiaries: Array<{ __typename?: 'esrs_ActionSubsidiary', id: any, subsidiaryAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }>, materialStandard: { __typename?: 'esrs_MaterialStandard', assessmentId: any, standard: { __typename?: 'EsrsStandard', reference: string }, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, attachmentBox?: { __typename?: 'AttachmentBox', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any } | null }> }> }>, targetQuestions: Array<{ __typename?: 'TargetQuestion', title: string, reference: string, unit?: string | null, questionType: QuestionType_Enum_, description?: string | null, groupRef?: string | null, group?: { __typename?: 'TargetQuestionGroup', reference: string, title: string } | null, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null }>, actionQuestions: Array<{ __typename?: 'ActionQuestion', title: string, reference: string, unit?: string | null, questionType: QuestionType_Enum_, description?: string | null, groupRef?: string | null, group?: { __typename?: 'ActionQuestionGroup', reference: string, title: string } | null, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null }>, category: { __typename?: 'EsrsCategory', title: string } }, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, materialStandardId: any, dataCollection?: string | null, frequency: string, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', abbreviation?: string | null, reference: string, title: string, shortTitle?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, hasAssociation: boolean, unitOfMeasurement?: string | null, unlockCondition?: boolean | null, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, showPercentageWithTag: boolean, notAggregatable: boolean, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirementRef: string, mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', order: number, reference: string, title: string, type: string, mfDisclosureRequirementGroup: { __typename?: 'MFDisclosureRequirementGroup', mfStandard: { __typename?: 'MFStandard', reference: string } }, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', order: number, reference: string, title: string, frameworkRef?: string | null, shortTitle?: string | null, type: string, additionalTypes: Array<{ __typename?: 'DisclosureRequirementAdditionalType', additionalTypeRef: string }>, group: { __typename?: 'DisclosureRequirementGroup', standard: { __typename?: 'EsrsStandard', reference: string } } } }> } }>, requirement: { __typename?: 'DisclosureRequirement', order: number, reference: string, title: string, frameworkRef?: string | null, shortTitle?: string | null, type: string, additionalTypes: Array<{ __typename?: 'DisclosureRequirementAdditionalType', additionalTypeRef: string }>, group: { __typename?: 'DisclosureRequirementGroup', standard: { __typename?: 'EsrsStandard', title: string, reference: string } } }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null }, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', abbreviation?: string | null, title: string, shortTitle?: string | null, reference: string, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, hasAssociation: boolean, unitOfMeasurement?: string | null, unlockCondition?: boolean | null, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, showPercentageWithTag: boolean, notAggregatable: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', abbreviation?: string | null, title: string, shortTitle?: string | null, reference: string, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, hasAssociation: boolean, unitOfMeasurement?: string | null, unlockCondition?: boolean | null, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, showPercentageWithTag: boolean, notAggregatable: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', abbreviation?: string | null, title: string, shortTitle?: string | null, reference: string, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, hasAssociation: boolean, unitOfMeasurement?: string | null, unlockCondition?: boolean | null, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, showPercentageWithTag: boolean, notAggregatable: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', abbreviation?: string | null, title: string, shortTitle?: string | null, reference: string, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, hasAssociation: boolean, unitOfMeasurement?: string | null, unlockCondition?: boolean | null, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, showPercentageWithTag: boolean, notAggregatable: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirementRef: string }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirementRef: string }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirementRef: string }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirementRef: string }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null } | null }>, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }> }> } | null };

export type GetRequiredGroupMaterialMetricsQueryVariables_ = Exact<{
  parentAssessmentId: Scalars['uuid']['input'];
}>;


export type GetRequiredGroupMaterialMetricsQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, materialStandard: { __typename?: 'esrs_MaterialStandard', standardRef: string } }> };

export type ReportTargetQuestionsQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
}>;


export type ReportTargetQuestionsQuery_ = { __typename?: 'query_root', groups: Array<{ __typename?: 'TargetQuestionGroup', title: string, reference: string, targetQuestions: Array<{ __typename?: 'TargetQuestion', title: string, reference: string, unit?: string | null, questionType: QuestionType_Enum_, description?: string | null, groupRef?: string | null, group?: { __typename?: 'TargetQuestionGroup', reference: string, title: string } | null, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null }> }>, singleQuestions: Array<{ __typename?: 'TargetQuestion', title: string, reference: string, unit?: string | null, questionType: QuestionType_Enum_, description?: string | null, groupRef?: string | null, group?: { __typename?: 'TargetQuestionGroup', reference: string, title: string } | null, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null }> };

export type ReportActionQuestionsQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
}>;


export type ReportActionQuestionsQuery_ = { __typename?: 'query_root', groups: Array<{ __typename?: 'ActionQuestionGroup', title: string, reference: string, actionQuestions: Array<{ __typename?: 'ActionQuestion', title: string, reference: string, unit?: string | null, questionType: QuestionType_Enum_, description?: string | null, groupRef?: string | null, group?: { __typename?: 'ActionQuestionGroup', reference: string, title: string } | null, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null }> }>, singleQuestions: Array<{ __typename?: 'ActionQuestion', title: string, reference: string, unit?: string | null, questionType: QuestionType_Enum_, description?: string | null, groupRef?: string | null, group?: { __typename?: 'ActionQuestionGroup', reference: string, title: string } | null, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null }> };

export type HideDrMutationVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  drRef: Scalars['String']['input'];
  isHidden: Scalars['Boolean']['input'];
}>;


export type HideDrMutation_ = { __typename?: 'mutation_root', update_esrs_MaterialMetric?: { __typename?: 'esrs_MaterialMetric_mutation_response', returning: Array<{ __typename?: 'esrs_MaterialMetric', id: any, isHidden: boolean }> } | null };

export type HideMetricMutationVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  metricRef: Scalars['String']['input'];
  isHidden: Scalars['Boolean']['input'];
}>;


export type HideMetricMutation_ = { __typename?: 'mutation_root', update_esrs_MaterialMetric?: { __typename?: 'esrs_MaterialMetric_mutation_response', returning: Array<{ __typename?: 'esrs_MaterialMetric', id: any, isHidden: boolean }> } | null };

export type GetMetricReportStatusSubscriptionVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetMetricReportStatusSubscription_ = { __typename?: 'subscription_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string, isHidden: boolean, id: any }> };

export type GetAnswersExportQueryVariables_ = Exact<{
  esrsAssessment: Scalars['uuid']['input'];
}>;


export type GetAnswersExportQuery_ = { __typename?: 'query_root', esrs_Datapoint: Array<{ __typename?: 'esrs_Datapoint', value?: string | null, timeframe: string, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string }>, answer: { __typename?: 'esrs_Answer', metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, title: string, reference: string, order: number, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, requirement: { __typename?: 'DisclosureRequirement', reference: string, title: string, order: number, group: { __typename?: 'DisclosureRequirementGroup', standard: { __typename?: 'EsrsStandard', title: string, reference: string } } } } } }> };

export type GetDmaDataQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetDmaDataQuery_ = { __typename?: 'query_root', irrelevantDPs: Array<{ __typename?: 'esrs_Datapoint', answer: { __typename?: 'esrs_Answer', metricRef: string } }>, esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', isMaterial?: boolean | null, frequency: string, dataCollection?: string | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, materialStandard: { __typename?: 'esrs_MaterialStandard', isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean }, metric: { __typename?: 'EsrsMetric', title: string, reference: string, globalOrder?: string | null, order: number, firstLevel?: string | null, secondLevel?: string | null, type?: QuestionType_Enum_ | null, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', title?: string | null } }>, requirement: { __typename?: 'DisclosureRequirement', reference: string, order: number, title: string, group: { __typename?: 'DisclosureRequirementGroup', standard: { __typename?: 'EsrsStandard', reference: string, title: string } } } } }> };

export type GetSpecificMaterialityQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
  standardRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
  metricRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetSpecificMaterialityQuery_ = { __typename?: 'query_root', esrs_MaterialStandard: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, isMaterial?: boolean | null, metricRef: string, metric: { __typename?: 'EsrsMetric', reference: string, disclosureRequirementRef: string, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirementRef: string }> } }> }> };

export type EsrsAssessmentFieldsFragment_ = { __typename?: 'EsrsAssessment', id: any, reportingYear: number, onboardingStep?: number | null, companySize?: string | null, parentAssessment?: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null } } | null, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string }>, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, onboardingStep?: number | null, company: { __typename?: 'Company', name: string, id: any }, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }>, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, name: string, assessmentId: any, isCompanyLevel: boolean, lineageId: any, projectLeaderId?: any | null, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }>, company: { __typename?: 'Company', id: any, name: string }, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null };

export type AssessmentMaterialStandardsFieldsFragment_ = { __typename?: 'EsrsAssessment', id: any, collectOnly?: boolean | null, parentAssessmentId?: any | null, reportingYear: number, company: { __typename?: 'Company', name: string }, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, standard: { __typename?: 'EsrsStandard', reference: string, frameworkRef?: string | null, category: { __typename?: 'EsrsCategory', title: string, reference: string } }, disclosureRequirementStatuses: Array<{ __typename?: 'DisclosureRequirementStatus', disclosureRequirementRef?: string | null, mfDisclosureRequirementRef?: string | null, isConfigured: boolean }>, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, isDataGatheringOnly: boolean, metric: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, disclosureRequirementRef: string, childrenMetricsCount?: number | null, requirement: { __typename?: 'DisclosureRequirement', reference: string, type: string, frameworkRef?: string | null }, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }> }> };

export type TargetFieldsFragment_ = { __typename?: 'esrs_Target', id: any, disclosureRequirementRef: string, name: string, direction?: string | null, metricRef?: string | null, isBottomUp: boolean, description?: string | null, assessmentId: any, ownerId?: any | null, isRequired: boolean, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, period?: string | null, periodExplanation?: string | null, scope?: string | null, methodologies?: string | null, isEvidenceScientific?: boolean | null, isEvidenceScientificExplanation?: string | null, withStakeholders?: boolean | null, withStakeholdersExplanation?: string | null, withStakeholdersDescription?: string | null, targetChangeDescription?: string | null, isProgressAligned?: boolean | null, performanceNumber?: any | null, performanceText?: string | null, isProgressAlignedExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, relationshipToPolicy?: string | null, coverage?: string | null, coverageExplanation?: string | null, parentTargetId?: any | null, owner?: { __typename?: 'users', id: any, displayName: string, avatarUrl: string } | null, metric?: { __typename?: 'EsrsMetric', reference: string, title: string, unitOfMeasurement?: string | null } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, actionId: any, estimate?: any | null, action: { __typename?: 'esrs_Actions', id: any, title: string } }>, keyResults: Array<{ __typename?: 'esrs_Baseline', id: any, baseline?: string | null, baseYear?: any | null, reportingUnitId?: any | null, isFlagged: boolean }>, parentTarget?: { __typename?: 'esrs_Target', name: string, materialStandard: { __typename?: 'esrs_MaterialStandard', esrsAssessment: { __typename?: 'EsrsAssessment', company: { __typename?: 'Company', name: string } } }, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number }> } | null, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any, standardRef: string, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, subsidiariesTargets: Array<{ __typename?: 'esrs_Target', id: any, metricRef?: string | null }>, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number, isRelative: boolean, isRequired: boolean, milestoneResults: Array<{ __typename?: 'esrs_MilestoneResult', id: any, value?: any | null, reportingUnitId?: any | null }> }> };

export type PolicyFieldsFragment_ = { __typename?: 'esrs_Policy', id: any, disclosureRequirementRef: string, assessmentId: any, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null };

export type ActionFieldsFragment_ = { __typename?: 'esrs_Actions', id: any, disclosureRequirementRef: string, title: string, deadline: any, startDate: any, ownerId?: any | null, capex?: any | null, noteReference?: string | null, timeHorizon?: string | null, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, statusOfKeyAction?: string | null, scope?: string | null, expectedOutcome?: string | null, provisionOfRemedy?: boolean | null, provisionOfRemedyExplanation?: string | null, progressInfo?: string | null, investmentsAndResources?: string | null, hasPreconditions?: boolean | null, hasPreconditionsExplanation?: string | null, opex?: any | null, opexShortTerm?: any | null, opexMediumTerm?: any | null, opexLongTerm?: any | null, capexShortTerm?: any | null, capexMediumTerm?: any | null, capexLongTerm?: any | null, scopeValueChain?: string | null, coverage?: string | null, coverageExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, statusOfKeyActionExplanation?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, estimate?: any | null, target: { __typename?: 'esrs_Target', id: any, direction?: string | null, name: string, metric?: { __typename?: 'EsrsMetric', title: string, unitOfMeasurement?: string | null } | null } }>, actionReportingUnits: Array<{ __typename?: 'esrs_ActionReportingUnit', id: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string } }>, actionSubsidiaries: Array<{ __typename?: 'esrs_ActionSubsidiary', id: any, subsidiaryAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }>, materialStandard: { __typename?: 'esrs_MaterialStandard', assessmentId: any, standard: { __typename?: 'EsrsStandard', reference: string }, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, attachmentBox?: { __typename?: 'AttachmentBox', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any } | null };

export type TargetsWithSubsidiariesFragment_ = { __typename?: 'esrs_Target', id: any, disclosureRequirementRef: string, name: string, direction?: string | null, metricRef?: string | null, isBottomUp: boolean, description?: string | null, assessmentId: any, ownerId?: any | null, isRequired: boolean, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, period?: string | null, periodExplanation?: string | null, scope?: string | null, methodologies?: string | null, isEvidenceScientific?: boolean | null, isEvidenceScientificExplanation?: string | null, withStakeholders?: boolean | null, withStakeholdersExplanation?: string | null, withStakeholdersDescription?: string | null, targetChangeDescription?: string | null, isProgressAligned?: boolean | null, performanceNumber?: any | null, performanceText?: string | null, isProgressAlignedExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, relationshipToPolicy?: string | null, coverage?: string | null, coverageExplanation?: string | null, parentTargetId?: any | null, parentTarget?: { __typename?: 'esrs_Target', name: string, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, actionId: any, estimate?: any | null, action: { __typename?: 'esrs_Actions', id: any, disclosureRequirementRef: string, title: string, deadline: any, startDate: any, ownerId?: any | null, capex?: any | null, noteReference?: string | null, timeHorizon?: string | null, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, statusOfKeyAction?: string | null, scope?: string | null, expectedOutcome?: string | null, provisionOfRemedy?: boolean | null, provisionOfRemedyExplanation?: string | null, progressInfo?: string | null, investmentsAndResources?: string | null, hasPreconditions?: boolean | null, hasPreconditionsExplanation?: string | null, opex?: any | null, opexShortTerm?: any | null, opexMediumTerm?: any | null, opexLongTerm?: any | null, capexShortTerm?: any | null, capexMediumTerm?: any | null, capexLongTerm?: any | null, scopeValueChain?: string | null, coverage?: string | null, coverageExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, statusOfKeyActionExplanation?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, estimate?: any | null, target: { __typename?: 'esrs_Target', id: any, direction?: string | null, name: string, metric?: { __typename?: 'EsrsMetric', title: string, unitOfMeasurement?: string | null } | null } }>, actionReportingUnits: Array<{ __typename?: 'esrs_ActionReportingUnit', id: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string } }>, actionSubsidiaries: Array<{ __typename?: 'esrs_ActionSubsidiary', id: any, subsidiaryAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }>, materialStandard: { __typename?: 'esrs_MaterialStandard', assessmentId: any, standard: { __typename?: 'EsrsStandard', reference: string }, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, attachmentBox?: { __typename?: 'AttachmentBox', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any } | null } }>, materialStandard: { __typename?: 'esrs_MaterialStandard', esrsAssessment: { __typename?: 'EsrsAssessment', company: { __typename?: 'Company', name: string } } }, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number }> } | null, subsidiariesTargets: Array<{ __typename?: 'esrs_Target', id: any, metricRef?: string | null, disclosureRequirementRef: string, name: string, direction?: string | null, isBottomUp: boolean, description?: string | null, assessmentId: any, ownerId?: any | null, isRequired: boolean, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, period?: string | null, periodExplanation?: string | null, scope?: string | null, methodologies?: string | null, isEvidenceScientific?: boolean | null, isEvidenceScientificExplanation?: string | null, withStakeholders?: boolean | null, withStakeholdersExplanation?: string | null, withStakeholdersDescription?: string | null, targetChangeDescription?: string | null, isProgressAligned?: boolean | null, performanceNumber?: any | null, performanceText?: string | null, isProgressAlignedExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, relationshipToPolicy?: string | null, coverage?: string | null, coverageExplanation?: string | null, parentTargetId?: any | null, owner?: { __typename?: 'users', id: any, displayName: string, avatarUrl: string } | null, metric?: { __typename?: 'EsrsMetric', reference: string, title: string, unitOfMeasurement?: string | null } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, actionId: any, estimate?: any | null, action: { __typename?: 'esrs_Actions', id: any, title: string } }>, keyResults: Array<{ __typename?: 'esrs_Baseline', id: any, baseline?: string | null, baseYear?: any | null, reportingUnitId?: any | null, isFlagged: boolean }>, parentTarget?: { __typename?: 'esrs_Target', name: string, materialStandard: { __typename?: 'esrs_MaterialStandard', esrsAssessment: { __typename?: 'EsrsAssessment', company: { __typename?: 'Company', name: string } } }, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number }> } | null, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any, standardRef: string, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, subsidiariesTargets: Array<{ __typename?: 'esrs_Target', id: any, metricRef?: string | null }>, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number, isRelative: boolean, isRequired: boolean, milestoneResults: Array<{ __typename?: 'esrs_MilestoneResult', id: any, value?: any | null, reportingUnitId?: any | null }> }> }>, owner?: { __typename?: 'users', id: any, displayName: string, avatarUrl: string } | null, metric?: { __typename?: 'EsrsMetric', reference: string, title: string, unitOfMeasurement?: string | null } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, actionId: any, estimate?: any | null, action: { __typename?: 'esrs_Actions', id: any, title: string } }>, keyResults: Array<{ __typename?: 'esrs_Baseline', id: any, baseline?: string | null, baseYear?: any | null, reportingUnitId?: any | null, isFlagged: boolean }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any, standardRef: string, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number, isRelative: boolean, isRequired: boolean, milestoneResults: Array<{ __typename?: 'esrs_MilestoneResult', id: any, value?: any | null, reportingUnitId?: any | null }> }> };

export type TargetQuestionFieldsFragment_ = { __typename?: 'TargetQuestion', title: string, reference: string, unit?: string | null, questionType: QuestionType_Enum_, description?: string | null, groupRef?: string | null, group?: { __typename?: 'TargetQuestionGroup', reference: string, title: string } | null, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null };

export type ChildMetricFieldsFragment_ = { __typename?: 'EsrsMetric', reference: string, title: string };

export type EsrsMetricsFieldsFragment_ = { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, calculation?: string | null, unitOfMeasurement?: string | null, showAsPercentage?: boolean | null, hasAssociation: boolean, order: number, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, isAR: boolean, unlockCondition?: boolean | null, showPercentageWithTag: boolean, notAggregatable: boolean, abbreviation?: string | null, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, title: string } | null }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> };

export type ChildlessEsrsMetricsFieldsFragment_ = { __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> };

export type EsrsMetricDetailedFieldsFragment_ = { __typename?: 'EsrsMetric', notAggregatable: boolean, childMetricsCount: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetricsCount: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> };

export type ChildlessEsrsReportMetricsFieldsFragment_ = { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, reference: string, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, hasAssociation: boolean, unitOfMeasurement?: string | null, unlockCondition?: boolean | null, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, showPercentageWithTag: boolean, notAggregatable: boolean, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirementRef: string }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null };

export type EsrsMetricChildDetailedFieldsFragment_ = { __typename?: 'esrs_MaterialMetric', id: any, frequency: string, dataCollection?: string | null, materialStandardId: any, isMaterial?: boolean | null, materialStandard: { __typename?: 'esrs_MaterialStandard', isMaterial?: boolean | null }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', tagType: string, isOptional: boolean, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string }> }> };

export type DataCollectionChildlessMetricsFieldsFragment_ = { __typename?: 'EsrsMetric', reference: string, title: string, shortTitle?: string | null, description?: string | null, metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, hasAssociation: boolean, notAggregatable: boolean, abbreviation?: string | null, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', title: string } }> };

export type DatapointFieldsFragment_ = { __typename?: 'esrs_Datapoint', id: any, answerId: any, authorId?: any | null, ownerId?: any | null, value?: string | null, factValue?: string | null, timeframe: string, source?: string | null, metadata?: any | null, lastEdited?: any | null, updatedAt: any, isMdrmDisclosed?: boolean | null, mdrmElsewhereDisclosure?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, author?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, task?: { __typename?: 'Task', id: any, dueDate?: any | null, status: TaskStatusEnum_Enum_, owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, thread?: { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any }>, comments_aggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }> };

export type ShortMetricFragment_ = { __typename?: 'EsrsMetric', title: string, reference: string };

export type EsrsAnswersFieldsFragment_ = { __typename?: 'esrs_Answer', id: any, reportingUnitId: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, optOutAuthorId?: any | null, assessmentId: any, metric: { __typename?: 'EsrsMetric', title: string, reference: string, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, optOutAuthor?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, answerId: any, authorId?: any | null, ownerId?: any | null, value?: string | null, factValue?: string | null, timeframe: string, source?: string | null, metadata?: any | null, lastEdited?: any | null, updatedAt: any, isMdrmDisclosed?: boolean | null, mdrmElsewhereDisclosure?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, author?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, task?: { __typename?: 'Task', id: any, dueDate?: any | null, status: TaskStatusEnum_Enum_, owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, thread?: { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any }>, comments_aggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }> }> };

export type MaterialMetricTagFieldsFragment_ = { __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> };

export type ReportMaterialMetricsFieldsFragment_ = { __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }> };

export type MaterialMetricsFieldsFragment_ = { __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } };

export type ReportingUnitAnswersFieldsFragment_ = { __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, optOutReason?: string | null, updatedAt: any, metric: { __typename?: 'EsrsMetric', childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, ownerId?: any | null, source?: string | null, value?: string | null, factValue?: string | null, metadata?: any | null, timeframe: string, lastEdited?: any | null, answerId: any, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices: Array<{ __typename?: 'esrs_DatapointChoice', choiceRef: string, choice: { __typename?: 'EsrsChoice', reference: string, title: string } }>, author?: { __typename?: 'users', displayName: string } | null, owner?: { __typename?: 'users', displayName: string } | null }>, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean } };

export type MaterialMetricWithChildrenFieldsFragment_ = { __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, isMaterial?: boolean | null, frequency: string, materialStandardId: any, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string, title: string, requirement: { __typename?: 'DisclosureRequirement', reference: string }, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', reference: string }, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', reference: string }, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', reference: string }, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', reference: string }, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', reference: string } } | null }> } | null }> } | null }> } | null }> } | null }> }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } };

export type UpsertMaterialStandardMutationVariables_ = Exact<{
  materialStandard: Esrs_MaterialStandard_Insert_Input_;
}>;


export type UpsertMaterialStandardMutation_ = { __typename?: 'mutation_root', insert_esrs_MaterialStandard_one?: { __typename?: 'esrs_MaterialStandard', id: any, standard: { __typename?: 'EsrsStandard', reference: string, disclosureRequirementGroups: Array<{ __typename?: 'DisclosureRequirementGroup', requirements: Array<{ __typename?: 'DisclosureRequirement', reference: string, type: string }> }> } } | null };

export type UpsertDrMaterialMetricsMutationVariables_ = Exact<{
  objects: Array<Esrs_MaterialMetric_Insert_Input_> | Esrs_MaterialMetric_Insert_Input_;
}>;


export type UpsertDrMaterialMetricsMutation_ = { __typename?: 'mutation_root', insert_esrs_MaterialMetric?: { __typename?: 'esrs_MaterialMetric_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string }> } | null };

export type UpsertMaterialMetricsMutationVariables_ = Exact<{
  objects: Array<Esrs_MaterialMetric_Insert_Input_> | Esrs_MaterialMetric_Insert_Input_;
}>;


export type UpsertMaterialMetricsMutation_ = { __typename?: 'mutation_root', insert_esrs_MaterialMetric?: { __typename?: 'esrs_MaterialMetric_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isHidden: boolean, materialStandardId: any }> } | null };

export type UpsertNewMaterialMetricsMutationVariables_ = Exact<{
  objects: Array<Esrs_MaterialMetric_Insert_Input_> | Esrs_MaterialMetric_Insert_Input_;
}>;


export type UpsertNewMaterialMetricsMutation_ = { __typename?: 'mutation_root', insert_esrs_MaterialMetric?: { __typename?: 'esrs_MaterialMetric_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isHidden: boolean, materialStandardId: any }> } | null };

export type UpsertMultipleMaterialStandardsMutationVariables_ = Exact<{
  materialStandards: Array<Esrs_MaterialStandard_Insert_Input_> | Esrs_MaterialStandard_Insert_Input_;
}>;


export type UpsertMultipleMaterialStandardsMutation_ = { __typename?: 'mutation_root', insert_esrs_MaterialStandard?: { __typename?: 'esrs_MaterialStandard_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any }> } | null };

export type CopyMultipleMaterialStandardsMutationVariables_ = Exact<{
  materialStandards: Array<Esrs_MaterialStandard_Insert_Input_> | Esrs_MaterialStandard_Insert_Input_;
}>;


export type CopyMultipleMaterialStandardsMutation_ = { __typename?: 'mutation_root', insert_esrs_MaterialStandard?: { __typename?: 'esrs_MaterialStandard_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any }> } | null };

export type UpsertBulkTagsMaterialMetricsMutationVariables_ = Exact<{
  objects: Array<Esrs_MaterialMetric_Insert_Input_> | Esrs_MaterialMetric_Insert_Input_;
}>;


export type UpsertBulkTagsMaterialMetricsMutation_ = { __typename?: 'mutation_root', insert_esrs_MaterialMetric?: { __typename?: 'esrs_MaterialMetric_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_MaterialMetric', id: any }> } | null };

export type GetMaterialStandardQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  standardRef: Scalars['String']['input'];
}>;


export type GetMaterialStandardQuery_ = { __typename?: 'query_root', materialityAssessment: Array<{ __typename?: 'esrs_MaterialStandard', id: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, dataCollection?: string | null, isDataGatheringOnly: boolean, isMaterial?: boolean | null, isPhasedIn: boolean, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, metric: { __typename?: 'EsrsMetric', reference: string, disclosureRequirementRef: string, isAssessable: boolean, childrenMetricsCount?: number | null, description?: string | null, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string }> } }> } }>, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, onboardingStep?: number | null, parentData?: { __typename?: 'EsrsAssessment', id: any, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, metric: { __typename?: 'EsrsMetric', reference: string, childrenMetricsCount?: number | null, tags: Array<{ __typename?: 'MetricTag', type: string }> } }> }> } | null }, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null }> };

export type GetParentMaterialityAssessmentQueryVariables_ = Exact<{
  childAssessmentId: Scalars['uuid']['input'];
}>;


export type GetParentMaterialityAssessmentQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, parentAssessment?: { __typename?: 'EsrsAssessment', id: any, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, standardRef: string, isPhasedIn: boolean, standard: { __typename?: 'EsrsStandard', categoryRef: string }, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, isPhasedIn: boolean, dataCollection?: string | null, isDataGatheringOnly: boolean, frequency: string, metric: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, disclosureRequirementRef: string, childrenMetricsCount?: number | null, requirement: { __typename?: 'DisclosureRequirement', reference: string, type: string, frameworkRef?: string | null }, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }> }> } | null } | null };

export type GetParentMaterialityQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  standardRef: Scalars['String']['input'];
}>;


export type GetParentMaterialityQuery_ = { __typename?: 'query_root', materialityAssessment: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isDataGatheringOnly: boolean, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, reportingYear: number, parentData?: { __typename?: 'EsrsAssessment', id: any, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string }> } | null }, standard: { __typename?: 'EsrsStandard', frameworkRef?: string | null } }> };

export type GetMaterialStandardsForSubsidiariesQueryVariables_ = Exact<{
  groupAssessmentId: Scalars['uuid']['input'];
}>;


export type GetMaterialStandardsForSubsidiariesQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, isMaterial?: boolean | null, standardRef: string }> }>, allAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, isMaterial?: boolean | null, standardRef: string }> }> } | null };

export type GetDrMaterialMetricsQueryVariables_ = Exact<{
  drRef: Scalars['String']['input'];
}>;


export type GetDrMaterialMetricsQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string, isMaterial?: boolean | null, isDataGatheringOnly: boolean }> };

export type GetTargetMetricsQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
  companyAssessmentId: Scalars['uuid']['input'];
  parentAssessmentId: Scalars['uuid']['input'];
}>;


export type GetTargetMetricsQuery_ = { __typename?: 'query_root', metrics: Array<{ __typename?: 'EsrsMetric', title: string, reference: string, unitOfMeasurement?: string | null, description?: string | null, calculation?: string | null }> };

export type GetSetTargetMetricsQueryVariables_ = Exact<{
  companyAssessmentId: Scalars['uuid']['input'];
  requiredMetrics: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetSetTargetMetricsQuery_ = { __typename?: 'query_root', metrics: Array<{ __typename?: 'EsrsMetric', title: string, reference: string, unitOfMeasurement?: string | null, description?: string | null, calculation?: string | null, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', dataCollection?: string | null, isMaterial?: boolean | null }> }> };

export type GetMaterialMetricByIdQueryVariables_ = Exact<{
  materialMetricId: Scalars['uuid']['input'];
}>;


export type GetMaterialMetricByIdQuery_ = { __typename?: 'query_root', esrs_MaterialMetric_by_pk?: { __typename?: 'esrs_MaterialMetric', id: any, frequency: string, dataCollection?: string | null, isMaterial?: boolean | null, metricRef: string, metric: { __typename?: 'EsrsMetric', description?: string | null, metricType?: QuestionType_Enum_ | null, title: string, reference: string, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean }> }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, metricTagType: { __typename?: 'TagType', type: string, tagValues: Array<{ __typename?: 'TagValue', type: string, value: string }> }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }> } | null };

export type GetAssessmentMaterialStandardsQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetAssessmentMaterialStandardsQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', standardRef: string, standard: { __typename?: 'EsrsStandard', categoryRef: string }, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string, dataCollection?: string | null }> }> } | null };

export type GetAssessmentEsrs2MaterialMetricsQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetAssessmentEsrs2MaterialMetricsQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any }> }> } | null };

export type InsertSubsidiariesMaterialStandardMutationVariables_ = Exact<{
  materialStandards: Array<Esrs_MaterialStandard_Insert_Input_> | Esrs_MaterialStandard_Insert_Input_;
}>;


export type InsertSubsidiariesMaterialStandardMutation_ = { __typename?: 'mutation_root', insert_esrs_MaterialStandard?: { __typename?: 'esrs_MaterialStandard_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any }> } | null };

export type InsertSubsidiariesMaterialMetricsMutationVariables_ = Exact<{
  materialMetrics: Array<Esrs_MaterialMetric_Insert_Input_> | Esrs_MaterialMetric_Insert_Input_;
}>;


export type InsertSubsidiariesMaterialMetricsMutation_ = { __typename?: 'mutation_root', insert_esrs_MaterialMetric?: { __typename?: 'esrs_MaterialMetric_mutation_response', returning: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string }> } | null };

export type UpdateSubsidiariesMaterialityMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpdateSubsidiariesMaterialityMutation_ = { __typename?: 'mutation_root', update_esrs_MaterialStandard_by_pk?: { __typename?: 'esrs_MaterialStandard', id: any } | null };

export type UpdateManySubsidiariesMaterialityMutationVariables_ = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpdateManySubsidiariesMaterialityMutation_ = { __typename?: 'mutation_root', update_esrs_MaterialStandard_many?: Array<{ __typename?: 'esrs_MaterialStandard_mutation_response', affected_rows: number } | null> | null };

export type SwitchOffUpdateSubsidiariesMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type SwitchOffUpdateSubsidiariesMutation_ = { __typename?: 'mutation_root', update_esrs_MaterialStandard_by_pk?: { __typename?: 'esrs_MaterialStandard', id: any } | null };

export type InsertMaterialMetricTagsMutationVariables_ = Exact<{
  objects: Array<Esrs_MaterialMetricTag_Insert_Input_> | Esrs_MaterialMetricTag_Insert_Input_;
}>;


export type InsertMaterialMetricTagsMutation_ = { __typename?: 'mutation_root', insert_esrs_MaterialMetricTag?: { __typename?: 'esrs_MaterialMetricTag_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any }> } | null };

export type UpdateEsrs2MaterialMetricsMutationVariables_ = Exact<{
  materialMetricsIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateEsrs2MaterialMetricsMutation_ = { __typename?: 'mutation_root', update_esrs_MaterialMetric_many?: Array<{ __typename?: 'esrs_MaterialMetric_mutation_response', affected_rows: number } | null> | null };

export type UpdateEsrs2MaterialStandardMutationVariables_ = Exact<{
  materialStandardId: Scalars['uuid']['input'];
  isMaterial?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateEsrs2MaterialStandardMutation_ = { __typename?: 'mutation_root', update_esrs_MaterialStandard_many?: Array<{ __typename?: 'esrs_MaterialStandard_mutation_response', affected_rows: number } | null> | null };

export type GetAllMaterialStandardsByRefQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
}>;


export type GetAllMaterialStandardsByRefQuery_ = { __typename?: 'query_root', esrs_MaterialStandard: Array<{ __typename?: 'esrs_MaterialStandard', id: any, esrsAssessment: { __typename?: 'EsrsAssessment', collectOnly?: boolean | null, company: { __typename?: 'Company', isGroupOwner: boolean } } }> };

export type UpsertDatapointMdrmMutationVariables_ = Exact<{
  object: Esrs_DatapointMdrm_Insert_Input_;
}>;


export type UpsertDatapointMdrmMutation_ = { __typename?: 'mutation_root', insert_esrs_DatapointMdrm_one?: { __typename?: 'esrs_DatapointMdrm', id: any, datapointId: any, mdrmRef: string, hasOptedOut: boolean, value?: string | null, thread?: { __typename?: 'Thread', id: any } | null } | null };

export type UpsertMultipleMdrmDatapointsMutationVariables_ = Exact<{
  objects: Array<Esrs_DatapointMdrm_Insert_Input_> | Esrs_DatapointMdrm_Insert_Input_;
}>;


export type UpsertMultipleMdrmDatapointsMutation_ = { __typename?: 'mutation_root', insert_esrs_DatapointMdrm?: { __typename?: 'esrs_DatapointMdrm_mutation_response', returning: Array<{ __typename?: 'esrs_DatapointMdrm', mdrmRef: string, datapointId: any }> } | null };

export type UpdateDatapointMdrmOptOutMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  hasOptedOut: Scalars['Boolean']['input'];
}>;


export type UpdateDatapointMdrmOptOutMutation_ = { __typename?: 'mutation_root', update_esrs_DatapointMdrm_by_pk?: { __typename?: 'esrs_DatapointMdrm', id: any, hasOptedOut: boolean } | null };

export type GetDatapointMdrmAnswersQueryVariables_ = Exact<{
  datapointId: Scalars['uuid']['input'];
}>;


export type GetDatapointMdrmAnswersQuery_ = { __typename?: 'query_root', esrs_DatapointMdrm: Array<{ __typename?: 'esrs_DatapointMdrm', id: any, authorId?: any | null, ownerId?: any | null, mdrmRef: string, value?: string | null, updated_at: any, hasOptedOut: boolean, author?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, task?: { __typename?: 'Task', dueDate?: any | null, status: TaskStatusEnum_Enum_, owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, thread?: { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any }>, comments_aggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null }> };

export type UpdateDatapointMdrmDisclosureMutationVariables_ = Exact<{
  datapointId: Scalars['uuid']['input'];
  isMdrmDisclosed?: InputMaybe<Scalars['Boolean']['input']>;
  mdrmElsewhereDisclosure?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateDatapointMdrmDisclosureMutation_ = { __typename?: 'mutation_root', update_esrs_Datapoint_by_pk?: { __typename?: 'esrs_Datapoint', id: any, isMdrmDisclosed?: boolean | null, mdrmElsewhereDisclosure?: string | null } | null };

export type GetCompanyLevelMdrmAnswersQueryVariables_ = Exact<{
  reportingUnitId: Scalars['uuid']['input'];
}>;


export type GetCompanyLevelMdrmAnswersQuery_ = { __typename?: 'query_root', esrs_DatapointMdrm: Array<{ __typename?: 'esrs_DatapointMdrm', id: any, datapointId: any, mdrmRef: string, value?: string | null, hasOptedOut: boolean, datapoint: { __typename?: 'esrs_Datapoint', answer: { __typename?: 'esrs_Answer', metricRef: string } } }> };

export type GetEsrsMetricQueryVariables_ = Exact<{
  metricRef: Scalars['String']['input'];
}>;


export type GetEsrsMetricQuery_ = { __typename?: 'query_root', metric?: { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, calculation?: string | null, unitOfMeasurement?: string | null, showAsPercentage?: boolean | null, hasAssociation: boolean, order: number, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, isAR: boolean, unlockCondition?: boolean | null, showPercentageWithTag: boolean, notAggregatable: boolean, abbreviation?: string | null, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, title: string } | null }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null };

export type GetAllMetricsQueryVariables_ = Exact<{ [key: string]: never; }>;


export type GetAllMetricsQuery_ = { __typename?: 'query_root', metrics: Array<{ __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, calculation?: string | null, unitOfMeasurement?: string | null, showAsPercentage?: boolean | null, hasAssociation: boolean, order: number, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, isAR: boolean, unlockCondition?: boolean | null, showPercentageWithTag: boolean, notAggregatable: boolean, abbreviation?: string | null, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, title: string } | null }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> }> };

export type GetAllMetricRefsQueryVariables_ = Exact<{ [key: string]: never; }>;


export type GetAllMetricRefsQuery_ = { __typename?: 'query_root', data: Array<{ __typename?: 'EsrsMetric', reference: string }> };

export type GetEsrsMetricsQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
}>;


export type GetEsrsMetricsQuery_ = { __typename?: 'query_root', metrics: Array<{ __typename?: 'EsrsMetric', title: string, reference: string }> };

export type GetChildrenMetricsMetadataQueryVariables_ = Exact<{
  reportingUnitId: Scalars['uuid']['input'];
  assessmentId: Scalars['uuid']['input'];
  parentMetricRef: Scalars['String']['input'];
}>;


export type GetChildrenMetricsMetadataQuery_ = { __typename?: 'query_root', esrs_Answer: Array<{ __typename?: 'esrs_Answer', datapoints: Array<{ __typename?: 'esrs_Datapoint', updatedAt: any, lastEdited?: any | null, source?: string | null, author?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }> }> };

export type GetStandardMandatoryMetricsQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetStandardMandatoryMetricsQuery_ = { __typename?: 'query_root', EsrsMetric: Array<{ __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', isMandatory: boolean }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } }>, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalTypeRef: string }>, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, materialStandardId: any }> }> };

export type GetStandardNonMandatoryMetricsQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetStandardNonMandatoryMetricsQuery_ = { __typename?: 'query_root', EsrsMetric: Array<{ __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', isMandatory: boolean }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } }>, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalTypeRef: string }>, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, materialStandardId: any }> }> };

export type GetRequiredMaterialMetricsQueryVariables_ = Exact<{
  disclosureRequirementRef: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
  parentStandardId: Scalars['uuid']['input'];
  frameworkRef: Scalars['String']['input'];
}>;


export type GetRequiredMaterialMetricsQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, materialStandardId: any, metric: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, notAggregatable: boolean, abbreviation?: string | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string }> } }> };

export type GetRequiredBuMaterialMetricsQueryVariables_ = Exact<{
  disclosureRequirementRef: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
  parentStandardId: Scalars['uuid']['input'];
}>;


export type GetRequiredBuMaterialMetricsQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, materialStandardId: any, metric: { __typename?: 'EsrsMetric', isAssessable: boolean, notAggregatable: boolean, reference: string, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string }> } }> };

export type GetMetricsDrQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
  parentStandardId: Scalars['uuid']['input'];
  requiredMetrics: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetMetricsDrQuery_ = { __typename?: 'query_root', DisclosureRequirement_by_pk?: { __typename?: 'DisclosureRequirement', reference: string, title: string, description?: string | null, type: string, metrics: Array<{ __typename?: 'EsrsMetric', notAggregatable: boolean, abbreviation?: string | null, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', abbreviation?: string | null, notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', abbreviation?: string | null, notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', notAggregatable: boolean, abbreviation?: string | null, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', abbreviation?: string | null, notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> }>, mfDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', mfDisclosureRequirementItems: Array<{ __typename?: 'MFDisclosureRequirementItem', metric: { __typename?: 'EsrsMetric', notAggregatable: boolean, abbreviation?: string | null, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', abbreviation?: string | null, notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', abbreviation?: string | null, notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', abbreviation?: string | null, notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', abbreviation?: string | null, notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } }> } }> } | null };

export type GetOptimizedMetricsDrQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
  parentStandardId: Scalars['uuid']['input'];
  requiredMetrics: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetOptimizedMetricsDrQuery_ = { __typename?: 'query_root', DisclosureRequirement_by_pk?: { __typename?: 'DisclosureRequirement', reference: string, title: string, description?: string | null, type: string, metrics: Array<{ __typename?: 'EsrsMetric', notAggregatable: boolean, abbreviation?: string | null, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'esrs_MetricDependencyClosure', depth?: number | null, parentMetricRef?: string | null, childMetricRef?: string | null, childMetric?: { __typename?: 'EsrsMetric', abbreviation?: string | null, notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> }>, mfDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', mfDisclosureRequirementItems: Array<{ __typename?: 'MFDisclosureRequirementItem', metric: { __typename?: 'EsrsMetric', notAggregatable: boolean, abbreviation?: string | null, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'esrs_MetricDependencyClosure', depth?: number | null, childMetricRef?: string | null, parentMetricRef?: string | null, childMetric?: { __typename?: 'EsrsMetric', abbreviation?: string | null, notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } }> } }> } | null };

export type GetMetricsMfdrQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
  parentStandardId: Scalars['uuid']['input'];
  requiredMetrics: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetMetricsMfdrQuery_ = { __typename?: 'query_root', MFDisclosureRequirement_by_pk?: { __typename?: 'MFDisclosureRequirement', reference: string, title: string, description?: string | null, type: string, mfDisclosureRequirementItems: Array<{ __typename?: 'MFDisclosureRequirementItem', metric: { __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } }> } | null };

export type GetMetricNameQueryVariables_ = Exact<{
  ref: Scalars['String']['input'];
}>;


export type GetMetricNameQuery_ = { __typename?: 'query_root', EsrsMetric: Array<{ __typename?: 'EsrsMetric', title: string, reference: string }> };

export type GetMfDisclosureRequirementsMetricsQueryVariables_ = Exact<{
  mfDRrefs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetMfDisclosureRequirementsMetricsQuery_ = { __typename?: 'query_root', MFDisclosureRequirementItem: Array<{ __typename?: 'MFDisclosureRequirementItem', metricRef: string, mfDisclosureRequirementRef: string, mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', title: string }, metric: { __typename?: 'EsrsMetric', reference: string, title: string, shortTitle?: string | null, metricType?: QuestionType_Enum_ | null, description?: string | null, order: number, firstLevel?: string | null, secondLevel?: string | null, disclosureRequirementRef: string, isAR: boolean, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', group: { __typename?: 'DisclosureRequirementGroup', standard: { __typename?: 'EsrsStandard', frameworkRef?: string | null } } }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string }> } }> } }>, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string }> } }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }> } | null }> } | null }> } | null }> } | null }> } }> };

export type GetMetricWithChildrenQueryVariables_ = Exact<{
  metricRef: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
}>;


export type GetMetricWithChildrenQuery_ = { __typename?: 'query_root', EsrsMetric: Array<{ __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> }> };

export type ReportingUnitsMetricsPerDisclosureQueryVariables_ = Exact<{
  disclosureRequirementRef: Scalars['String']['input'];
  companyAssessmentId: Scalars['uuid']['input'];
  parentAssessmentId: Scalars['uuid']['input'];
  requiredMetrics: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReportingUnitsMetricsPerDisclosureQuery_ = { __typename?: 'query_root', assessableMetrics: Array<{ __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', notAggregatable: boolean, title: string, shortTitle?: string | null, reference: string, description?: string | null, metricType?: QuestionType_Enum_ | null, isAssessable: boolean, disclosureRequirementRef: string, showAsPercentage?: boolean | null, calculation?: string | null, unitOfMeasurement?: string | null, hasAssociation: boolean, order: number, isAR: boolean, firstLevel?: string | null, secondLevel?: string | null, globalOrder?: string | null, unlockCondition?: boolean | null, showPercentageWithTag: boolean, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, dataCollection?: string | null, frequency: string, materialStandardId: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isHidden: boolean, metric: { __typename?: 'EsrsMetric', reference: string }, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null, esrsAssessment: { __typename?: 'EsrsAssessment', id: any } } }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> } | null }>, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string, parentMetric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null } }>, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null, adminPanelTags: Array<{ __typename?: 'MetricTag', isOptional: boolean, type: string, values: { __typename?: 'TagType', alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string, type: string }> } }> }> };

export type GetBuDisclosureRequirementMetricsQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
  companyStandardId: Scalars['uuid']['input'];
  parentStandardId: Scalars['uuid']['input'];
}>;


export type GetBuDisclosureRequirementMetricsQuery_ = { __typename?: 'query_root', requirements: Array<{ __typename?: 'DisclosureRequirement', title: string, reference: string, type: string, description?: string | null, groupRef: string, order: number, group: { __typename?: 'DisclosureRequirementGroup', standardRef: string }, metrics: Array<{ __typename?: 'EsrsMetric', relatedDRs: Array<{ __typename?: 'esrs_MetricRelatedDisclosureRequirement', disclosureRequirement?: { __typename?: 'DisclosureRequirement', title: string, reference: string, type: string, description?: string | null, groupRef: string, order: number, group: { __typename?: 'DisclosureRequirementGroup', standardRef: string } } | null }> }> }> };

export type GetBumfDisclosureRequirementMetricsQueryVariables_ = Exact<{
  mfStandardRef: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
  parentStandardId: Scalars['uuid']['input'];
}>;


export type GetBumfDisclosureRequirementMetricsQuery_ = { __typename?: 'query_root', requirements: Array<{ __typename?: 'MFDisclosureRequirement', title: string, reference: string, type: string, description?: string | null, order: number, groupRef: string }> };

export type OptOutMetricMutationVariables_ = Exact<{
  objects: Array<Esrs_Answer_Insert_Input_> | Esrs_Answer_Insert_Input_;
}>;


export type OptOutMetricMutation_ = { __typename?: 'mutation_root', insert_esrs_Answer?: { __typename?: 'esrs_Answer_mutation_response', affected_rows: number } | null };

export type GetMetricDRandStandardQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type GetMetricDRandStandardQuery_ = { __typename?: 'query_root', EsrsMetric_by_pk?: { __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', reference: string, isMandatory: boolean, group: { __typename?: 'DisclosureRequirementGroup', standardRef: string } } } | null };

export type GetMetricMaterialityQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
}>;


export type GetMetricMaterialityQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, isDataGatheringOnly: boolean, isHidden: boolean, materialStandardId: any }> };

export type GetAllChildrenMetricsQueryVariables_ = Exact<{
  requiredMetrics: Array<Scalars['String']['input']> | Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
}>;


export type GetAllChildrenMetricsQuery_ = { __typename?: 'query_root', EsrsMetric: Array<{ __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetric?: { __typename?: 'EsrsMetric', reference: string, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any }> } | null }>, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, materialStandardId: any, isMaterial?: boolean | null }> }> };

export type DeleteMaterialMetricsMutationVariables_ = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteMaterialMetricsMutation_ = { __typename?: 'mutation_root', delete_esrs_MaterialMetric?: { __typename?: 'esrs_MaterialMetric_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_MaterialMetric', id: any }> } | null };

export type DeleteMaterialMetricMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteMaterialMetricMutation_ = { __typename?: 'mutation_root', delete_esrs_MaterialMetric_by_pk?: { __typename?: 'esrs_MaterialMetric', id: any } | null };

export type GetParentAssessmentMaterialMetricsQueryVariables_ = Exact<{
  parentAssessmentId: Scalars['uuid']['input'];
}>;


export type GetParentAssessmentMaterialMetricsQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, dataCollection?: string | null, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, isMaterial?: boolean | null }, metric: { __typename?: 'EsrsMetric', requirement: { __typename?: 'DisclosureRequirement', reference: string } } }> };

export type GetCategoryAndStandardsQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  framework: Scalars['String']['input'];
  frameworkRefs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetCategoryAndStandardsQuery_ = { __typename?: 'query_root', MFCategory: Array<{ __typename?: 'MFCategory', title: string, reference: string, mfStandards: Array<{ __typename?: 'MFStandard', title: string, reference: string, mfStandardItems: Array<{ __typename?: 'MFStandardItem', standard: { __typename?: 'EsrsStandard', title: string, reference: string, isTopical: boolean, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, isDataCollected: boolean }>, framework?: { __typename?: 'Framework', name: string, reference: string } | null, disclosureRequirementGroups: Array<{ __typename?: 'DisclosureRequirementGroup', requirements: Array<{ __typename?: 'DisclosureRequirement', metrics_aggregate: { __typename?: 'EsrsMetric_aggregate', aggregate?: { __typename?: 'EsrsMetric_aggregate_fields', count: number } | null } }> }> } }> }> }> };

export type GetMFdrForMFstandardQueryVariables_ = Exact<{
  mfStandardRef?: InputMaybe<Scalars['String']['input']>;
  frameworkRefs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  assessmentId: Scalars['uuid']['input'];
  assessmentFrameworkRef: Scalars['String']['input'];
}>;


export type GetMFdrForMFstandardQuery_ = { __typename?: 'query_root', MFStandard: Array<{ __typename?: 'MFStandard', mfDisclosureRequirementGroups: Array<{ __typename?: 'MFDisclosureRequirementGroup', mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirement', title: string, reference: string, mfDisclosureRequirementItems: Array<{ __typename?: 'MFDisclosureRequirementItem', metric: { __typename?: 'EsrsMetric', reference: string, title: string, shortTitle?: string | null, metricType?: QuestionType_Enum_ | null, description?: string | null, order: number, firstLevel?: string | null, secondLevel?: string | null, disclosureRequirementRef: string, isAR: boolean, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, title: string, frameworkRef?: string | null, isMandatory: boolean, group: { __typename?: 'DisclosureRequirementGroup', standard: { __typename?: 'EsrsStandard', reference: string, frameworkRef?: string | null } } }, mfDisclosureRequirements_aggregate: { __typename?: 'MFDisclosureRequirementItem_aggregate', aggregate?: { __typename?: 'MFDisclosureRequirementItem_aggregate_fields', count: number } | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', mfDisclosureRequirementGroup: { __typename?: 'MFDisclosureRequirementGroup', mfStandardRef: string } } }>, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string }> } }>, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, materialStandardId: any, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', type: string }> }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string }> } }> } }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }> } | null }> } | null }> } | null }> } | null }> } }> }> }> }> };

export type GetSelectedDataPointsQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  framework: Scalars['String']['input'];
}>;


export type GetSelectedDataPointsQuery_ = { __typename?: 'query_root', EsrsMetric: Array<{ __typename?: 'EsrsMetric', reference: string, title: string, shortTitle?: string | null, metricType?: QuestionType_Enum_ | null, description?: string | null, order: number, firstLevel?: string | null, secondLevel?: string | null, disclosureRequirementRef: string, isAR: boolean, isAssessable: boolean, mfDisclosureRequirements_aggregate: { __typename?: 'MFDisclosureRequirementItem_aggregate', aggregate?: { __typename?: 'MFDisclosureRequirementItem_aggregate_fields', count: number } | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', title: string, reference: string, mfDisclosureRequirementGroup: { __typename?: 'MFDisclosureRequirementGroup', mfStandardRef: string } } }>, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, materialStandardId: any, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', type: string }> }>, requirement: { __typename?: 'DisclosureRequirement', reference: string, title: string, isMandatory: boolean, group: { __typename?: 'DisclosureRequirementGroup', standard: { __typename?: 'EsrsStandard', reference: string, frameworkRef?: string | null } } }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string }> } }> } }>, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string }> } }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }> } | null }> } | null }> } | null }> } | null }> }> };

export type GetMetricsForMfDrQueryVariables_ = Exact<{
  mfDrRef?: InputMaybe<Scalars['String']['input']>;
  frameworkRefs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  assessmentId: Scalars['uuid']['input'];
  assessmentFrameworkRef: Scalars['String']['input'];
}>;


export type GetMetricsForMfDrQuery_ = { __typename?: 'query_root', MFDisclosureRequirementItem: Array<{ __typename?: 'MFDisclosureRequirementItem', metric: { __typename?: 'EsrsMetric', reference: string, title: string, shortTitle?: string | null, metricType?: QuestionType_Enum_ | null, description?: string | null, order: number, firstLevel?: string | null, secondLevel?: string | null, disclosureRequirementRef: string, isAR: boolean, isAssessable: boolean, mfDisclosureRequirements_aggregate: { __typename?: 'MFDisclosureRequirementItem_aggregate', aggregate?: { __typename?: 'MFDisclosureRequirementItem_aggregate_fields', count: number } | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', mfDisclosureRequirementGroup: { __typename?: 'MFDisclosureRequirementGroup', mfStandardRef: string } } }>, requirement: { __typename?: 'DisclosureRequirement', title: string, frameworkRef?: string | null, isMandatory: boolean, group: { __typename?: 'DisclosureRequirementGroup', standard: { __typename?: 'EsrsStandard', reference: string, frameworkRef?: string | null } } }, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string }> } }>, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, isMaterial?: boolean | null, isDataGatheringOnly: boolean, isPhasedIn: boolean, materialStandardId: any, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', type: string }> }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, tags: Array<{ __typename?: 'MetricTag', type: string, isOptional: boolean, tagType: { __typename?: 'TagType', type: string, alwaysAll: boolean, tagValues: Array<{ __typename?: 'TagValue', value: string }> } }> } }>, additionalTypes: Array<{ __typename?: 'EsrsMetricAdditionalType', additionalType: { __typename?: 'AdditionalType', reference: string, title?: string | null, description?: string | null, learnMore?: string | null } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }>, childrenMetrics: Array<{ __typename?: 'MetricDependency', childMetricRef: string, order: number, parentMetricRef: string, childMetric?: { __typename?: 'EsrsMetric', reference: string, isAssessable: boolean, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }> } | null }> } | null }> } | null }> } | null }> } }> };

export type GetSubsidiariesMaterialMetricsQueryVariables_ = Exact<{
  parentAssessmentId: Scalars['uuid']['input'];
  metricRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetSubsidiariesMaterialMetricsQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', id: any, frequency: string, metricRef: string, materialStandardId: any, dataCollection?: string | null }> };

export type GetDrOwnerQueryVariables_ = Exact<{
  drRef: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
  reportingUnitId: Scalars['uuid']['input'];
}>;


export type GetDrOwnerQuery_ = { __typename?: 'query_root', DisclosureRequirementOwner: Array<{ __typename?: 'DisclosureRequirementOwner', owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> };

export type GetRequiredStandardMaterialMetricsQueryVariables_ = Exact<{
  materialStandardId: Scalars['uuid']['input'];
  parentStandardId: Scalars['uuid']['input'];
}>;


export type GetRequiredStandardMaterialMetricsQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string }> };

export type GetMaterialStandardMetricsQueryVariables_ = Exact<{
  materialStandardId: Scalars['uuid']['input'];
  requiredMetrics: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetMaterialStandardMetricsQuery_ = { __typename?: 'query_root', EsrsMetric: Array<{ __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirementRef: string, mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }>, view_childrenMetrics: Array<{ __typename?: 'esrs_MetricDependencyClosure', childMetricRef?: string | null }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string }>, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }> }> }> };

export type GetMfDrOwnerQueryVariables_ = Exact<{
  mfDrRef: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
  reportingUnitId: Scalars['uuid']['input'];
}>;


export type GetMfDrOwnerQuery_ = { __typename?: 'query_root', DisclosureRequirementOwner: Array<{ __typename?: 'DisclosureRequirementOwner', owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> };

export type GetDrDatapointsTasksQueryVariables_ = Exact<{
  taskReferences: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetDrDatapointsTasksQuery_ = { __typename?: 'query_root', Task: Array<{ __typename?: 'Task', dueDate?: any | null, id: any, status: TaskStatusEnum_Enum_, taskReference?: string | null, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, answer: { __typename?: 'esrs_Answer', id: any, metricRef: string } }>, owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> };

export type GetDisclosureRequirementsOwnerQueryVariables_ = Exact<{
  drRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
  reportingUnitId: Scalars['uuid']['input'];
}>;


export type GetDisclosureRequirementsOwnerQuery_ = { __typename?: 'query_root', DisclosureRequirementOwner: Array<{ __typename?: 'DisclosureRequirementOwner', disclosureRequirementRef?: string | null, mfDisclosureRequirementRef?: string | null, owner: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> };

export type UpdateMaterialMetricsMutationVariables_ = Exact<{
  updates: Array<Esrs_MaterialMetric_Updates_> | Esrs_MaterialMetric_Updates_;
}>;


export type UpdateMaterialMetricsMutation_ = { __typename?: 'mutation_root', update_esrs_MaterialMetric_many?: Array<{ __typename?: 'esrs_MaterialMetric_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, frequency: string }> } | null> | null };

export type UpsertDrOwnerMutationVariables_ = Exact<{
  drRef: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
  ownerId: Scalars['uuid']['input'];
  reportingUnitId: Scalars['uuid']['input'];
}>;


export type UpsertDrOwnerMutation_ = { __typename?: 'mutation_root', insert_DisclosureRequirementOwner_one?: { __typename?: 'DisclosureRequirementOwner', disclosureRequirementRef?: string | null, ownerId: any } | null };

export type UpsertMfDrOwnerMutationVariables_ = Exact<{
  mfDrRef: Scalars['String']['input'];
  materialStandardId: Scalars['uuid']['input'];
  ownerId: Scalars['uuid']['input'];
  reportingUnitId: Scalars['uuid']['input'];
}>;


export type UpsertMfDrOwnerMutation_ = { __typename?: 'mutation_root', insert_DisclosureRequirementOwner_one?: { __typename?: 'DisclosureRequirementOwner', disclosureRequirementRef?: string | null, ownerId: any } | null };

export type UpsertDisclosureRequirementsOwnerMutationVariables_ = Exact<{
  objects: Array<DisclosureRequirementOwner_Insert_Input_> | DisclosureRequirementOwner_Insert_Input_;
  on_conflict?: InputMaybe<DisclosureRequirementOwner_On_Conflict_>;
}>;


export type UpsertDisclosureRequirementsOwnerMutation_ = { __typename?: 'mutation_root', insert_DisclosureRequirementOwner?: { __typename?: 'DisclosureRequirementOwner_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'DisclosureRequirementOwner', disclosureRequirementRef?: string | null }> } | null };

export type UpsertMaterialStandardOwnerMutationVariables_ = Exact<{
  materialStandardId: Scalars['uuid']['input'];
  ownerId: Scalars['uuid']['input'];
  reportingUnitId: Scalars['uuid']['input'];
}>;


export type UpsertMaterialStandardOwnerMutation_ = { __typename?: 'mutation_root', insert_MaterialStandardOwner_one?: { __typename?: 'MaterialStandardOwner', id: any, ownerId: any } | null };

export type GetMetricDisclosureRequirementRefQueryVariables_ = Exact<{
  metricRef: Scalars['String']['input'];
}>;


export type GetMetricDisclosureRequirementRefQuery_ = { __typename?: 'query_root', EsrsMetric_by_pk?: { __typename?: 'EsrsMetric', disclosureRequirementRef: string } | null };

export type UpsertDrToMfDisclousreRequirementMutationVariables_ = Exact<{
  object: DrToMfDisclosureRequirement_Insert_Input_;
}>;


export type UpsertDrToMfDisclousreRequirementMutation_ = { __typename?: 'mutation_root', insert_DRToMFDisclosureRequirement_one?: { __typename?: 'DRToMFDisclosureRequirement', id: any } | null };

export type UpsertEsrsStandardMutationVariables_ = Exact<{
  object: EsrsStandard_Insert_Input_;
}>;


export type UpsertEsrsStandardMutation_ = { __typename?: 'mutation_root', insert_EsrsStandard_one?: { __typename?: 'EsrsStandard', reference: string } | null };

export type UpdateEsrsStandardMutationVariables_ = Exact<{
  pk_columns: EsrsStandard_Pk_Columns_Input_;
  _set: EsrsStandard_Set_Input_;
}>;


export type UpdateEsrsStandardMutation_ = { __typename?: 'mutation_root', update_EsrsStandard_by_pk?: { __typename?: 'EsrsStandard', reference: string } | null };

export type UpsertPolicyMutationVariables_ = Exact<{
  input: Array<Esrs_Policy_Insert_Input_> | Esrs_Policy_Insert_Input_;
}>;


export type UpsertPolicyMutation_ = { __typename?: 'mutation_root', insert_esrs_Policy?: { __typename?: 'esrs_Policy_mutation_response', returning: Array<{ __typename?: 'esrs_Policy', id: any, disclosureRequirementRef: string, assessmentId: any, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null }> } | null };

export type GetPoliciesDrQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
  esrsAssessmentId: Scalars['uuid']['input'];
  standardRef: Scalars['String']['input'];
}>;


export type GetPoliciesDrQuery_ = { __typename?: 'query_root', DisclosureRequirement_by_pk?: { __typename?: 'DisclosureRequirement', reference: string, title: string, description?: string | null, policies: Array<{ __typename?: 'esrs_Policy', id: any, disclosureRequirementRef: string, assessmentId: any, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null }> } | null };

export type GetPoliciesSubsidiariesQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetPoliciesSubsidiariesQuery_ = { __typename?: 'query_root', esrs?: { __typename?: 'EsrsAssessment', id: any, subsidiaries: Array<{ __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string }, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, policies: Array<{ __typename?: 'esrs_Policy', id: any, disclosureRequirementRef: string, assessmentId: any, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null }> }> }> } | null };

export type ProgressMaterialMetricsFragmentFragment_ = { __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } };

export type ProgressAnswersFragmentFragment_ = { __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> };

export type MetricMfDisclosureRequirementsFragmentFragment_ = { __typename?: 'EsrsMetric', mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> };

export type GetGroupLevelDrProgressQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  drRef: Scalars['String']['input'];
  standardRef: Scalars['String']['input'];
  frameworkRef: Scalars['String']['input'];
}>;


export type GetGroupLevelDrProgressQuery_ = { __typename?: 'query_root', groupLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, subsidiaryLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }> } }> } }>, groupLevelAnswers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }> };

export type GetSubsidiariesOnGroupLevelDrProgressQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  drRef: Scalars['String']['input'];
  standardRef: Scalars['String']['input'];
  frameworkRef: Scalars['String']['input'];
}>;


export type GetSubsidiariesOnGroupLevelDrProgressQuery_ = { __typename?: 'query_root', subsidiaries?: { __typename?: 'EsrsAssessment', id: any, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }> }>, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }> }> }> } | null };

export type GetCompanyLevelDrProgressQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  drRef: Scalars['String']['input'];
  standardRef: Scalars['String']['input'];
  parentAssessmentId: Scalars['uuid']['input'];
  frameworkRef: Scalars['String']['input'];
}>;


export type GetCompanyLevelDrProgressQuery_ = { __typename?: 'query_root', requiredMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string } }>, companyLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, buLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, companyLevelAnswers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }>, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }> }> };

export type GetReportingUnitDrProgressQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  drRef: Scalars['String']['input'];
  standardRef: Scalars['String']['input'];
  parentAssessmentId: Scalars['uuid']['input'];
  reportingUnitId: Scalars['uuid']['input'];
  frameworkRef: Scalars['String']['input'];
}>;


export type GetReportingUnitDrProgressQuery_ = { __typename?: 'query_root', requiredMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string } }>, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, reportingUnit: Array<{ __typename?: 'esrs_ReportingUnit', id: any, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }> }> };

export type GetGroupLevelStandardProgressQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  drRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
  standardRef: Scalars['String']['input'];
  frameworkRef: Scalars['String']['input'];
}>;


export type GetGroupLevelStandardProgressQuery_ = { __typename?: 'query_root', groupLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, subsidiaryLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, groupLevelAnswers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }> };

export type GetSubsidiariesOnGroupLevelStandardProgressQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  drRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
  standardRef: Scalars['String']['input'];
  frameworkRef: Scalars['String']['input'];
}>;


export type GetSubsidiariesOnGroupLevelStandardProgressQuery_ = { __typename?: 'query_root', subsidiaries?: { __typename?: 'EsrsAssessment', id: any, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }> }>, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }> }> }> } | null };

export type GetCompanyLevelStandardProgressQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  drRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
  standardRef: Scalars['String']['input'];
  parentAssessmentId: Scalars['uuid']['input'];
  frameworkRef: Scalars['String']['input'];
}>;


export type GetCompanyLevelStandardProgressQuery_ = { __typename?: 'query_root', requiredMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, companyLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, buLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, companyLevelAnswers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }>, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }> }> };

export type GetReportingUnitStandardProgressQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  drRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
  standardRef: Scalars['String']['input'];
  parentAssessmentId: Scalars['uuid']['input'];
  reportingUnitId: Scalars['uuid']['input'];
  frameworkRef: Scalars['String']['input'];
}>;


export type GetReportingUnitStandardProgressQuery_ = { __typename?: 'query_root', requiredMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, reportingUnit: Array<{ __typename?: 'esrs_ReportingUnit', id: any, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }> }> };

export type GetGroupLevelCategoryProgressQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  categoryRef: Scalars['String']['input'];
}>;


export type GetGroupLevelCategoryProgressQuery_ = { __typename?: 'query_root', EsrsCategory_by_pk?: { __typename?: 'EsrsCategory', standards: Array<{ __typename?: 'EsrsStandard', reference: string, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', groupLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, subsidiaryLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }> }> }> } | null, groupLevelAnswers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }> };

export type GetSubsidiariesOnGroupLevelCategoryProgressQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  categoryRef: Scalars['String']['input'];
}>;


export type GetSubsidiariesOnGroupLevelCategoryProgressQuery_ = { __typename?: 'query_root', subsidiaries?: { __typename?: 'EsrsAssessment', id: any, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }> }>, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }> }> }> } | null };

export type GetCompanyLevelCategoryProgressQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  categoryRef: Scalars['String']['input'];
}>;


export type GetCompanyLevelCategoryProgressQuery_ = { __typename?: 'query_root', EsrsCategory_by_pk?: { __typename?: 'EsrsCategory', standards: Array<{ __typename?: 'EsrsStandard', reference: string, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', companyLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, buLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }> }> }> } | null, companyLevelAnswers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }>, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }> }> };

export type GetGroupLevelProgressQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetGroupLevelProgressQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, groupLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, subsidiaryLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }> }>, subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }> }>, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }> }> }> } | null, groupLevelAnswers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }>, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }> }> };

export type GetCompanyReportLevelProgressQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetCompanyReportLevelProgressQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, companyLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, buLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }> }> } | null, companyLevelAnswers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }>, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }> }> };

export type GetAssessmentRequiredMaterialMetricsQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  parentAssessmentId: Scalars['uuid']['input'];
}>;


export type GetAssessmentRequiredMaterialMetricsQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string }> };

export type GetCompanyLevelProgressQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  requiredMetrics: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetCompanyLevelProgressQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, standardRef: string, companyLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }>, buLevelMaterialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, isMaterial?: boolean | null, dataCollection?: string | null, frequency: string, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', id: any, tagType: string, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string }> }>, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, disclosureRequirementRef: string, isAssessable: boolean, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null }, childrenMetrics_aggregate: { __typename?: 'MetricDependency_aggregate', aggregate?: { __typename?: 'MetricDependency_aggregate_fields', count: number } | null }, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, unlockCondition?: boolean | null } }> } }>, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> } }> }> } | null, companyLevelAnswers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }>, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, answers: Array<{ __typename?: 'esrs_Answer', id: any, metricRef: string, hasOptedOut: boolean, metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string, requirement: { __typename?: 'DisclosureRequirement', frameworkRef?: string | null }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null } }> } }> }, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, timeframe: string, factValue?: string | null, metadata?: any | null, updatedAt: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagValue: string, tagType: string }>, datapointChoices_aggregate: { __typename?: 'esrs_DatapointChoice_aggregate', aggregate?: { __typename?: 'esrs_DatapointChoice_aggregate_fields', count: number } | null } }> }> }> };

export type GetNarrativeParentMetricAnswersQueryVariables_ = Exact<{ [key: string]: never; }>;


export type GetNarrativeParentMetricAnswersQuery_ = { __typename?: 'query_root', datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, value?: string | null, metadata?: any | null }> };

export type GetAllDatapointsQueryVariables_ = Exact<{ [key: string]: never; }>;


export type GetAllDatapointsQuery_ = { __typename?: 'query_root', esrs_Datapoint: Array<{ __typename?: 'esrs_Datapoint', id: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagType: string, tagValue: string }> }> };

export type GetDatapointTagsQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetDatapointTagsQuery_ = { __typename?: 'query_root', esrs_Datapoint: Array<{ __typename?: 'esrs_Datapoint', datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagType: string, tagValue: string }> }> };

export type GetDatapointsByTagValueQueryVariables_ = Exact<{
  tagValue: Scalars['String']['input'];
}>;


export type GetDatapointsByTagValueQuery_ = { __typename?: 'query_root', esrs_Datapoint: Array<{ __typename?: 'esrs_Datapoint', id: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagType: string, tagValue: string }> }> };

export type GetDatapointsByTagTypeQueryVariables_ = Exact<{
  tagType: Scalars['String']['input'];
}>;


export type GetDatapointsByTagTypeQuery_ = { __typename?: 'query_root', esrs_Datapoint: Array<{ __typename?: 'esrs_Datapoint', id: any, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', tagType: string, tagValue: string }> }> };

export type UpdateDatapointsTagCombinationsMutationVariables_ = Exact<{
  datapointUpdates: Array<Esrs_Datapoint_Updates_> | Esrs_Datapoint_Updates_;
}>;


export type UpdateDatapointsTagCombinationsMutation_ = { __typename?: 'mutation_root', updates?: Array<{ __typename?: 'esrs_Datapoint_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_Datapoint', id: any, tagCombination?: string | null }> } | null> | null };

export type UpdateDatapointMetaDataWithValuesMutationVariables_ = Exact<{
  datapointUpdates: Array<Esrs_Datapoint_Updates_> | Esrs_Datapoint_Updates_;
}>;


export type UpdateDatapointMetaDataWithValuesMutation_ = { __typename?: 'mutation_root', updates?: Array<{ __typename?: 'esrs_Datapoint_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_Datapoint', id: any, metadata?: any | null, value?: string | null, answer: { __typename?: 'esrs_Answer', metricRef: string } }> } | null> | null };

export type GetAllConfiguredMaterialStandardsQueryVariables_ = Exact<{ [key: string]: never; }>;


export type GetAllConfiguredMaterialStandardsQuery_ = { __typename?: 'query_root', esrs_MaterialStandard: Array<{ __typename?: 'esrs_MaterialStandard', id: any, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', metric: { __typename?: 'EsrsMetric', disclosureRequirementRef: string } }> }> };

export type UpsertAllDisclosureRequirementStatusesMutationVariables_ = Exact<{
  objects: Array<DisclosureRequirementStatus_Insert_Input_> | DisclosureRequirementStatus_Insert_Input_;
}>;


export type UpsertAllDisclosureRequirementStatusesMutation_ = { __typename?: 'mutation_root', insert_DisclosureRequirementStatus?: { __typename?: 'DisclosureRequirementStatus_mutation_response', returning: Array<{ __typename?: 'DisclosureRequirementStatus', materialStandardId: any, disclosureRequirementRef?: string | null, isConfigured: boolean }> } | null };

export type GetOldMdrmAnswersQueryVariables_ = Exact<{ [key: string]: never; }>;


export type GetOldMdrmAnswersQuery_ = { __typename?: 'query_root', esrs_Deprecated_EsrsMDRM: Array<{ __typename?: 'esrs_Deprecated_EsrsMDRM', metricRef: string, metricUsed?: string | null, methodology?: string | null, validation?: string | null, answeredByUserId: any, datapoint: { __typename?: 'esrs_Datapoint', id: any, timeframe: string, answer: { __typename?: 'esrs_Answer', id: any, reportingUnitId: any, assessmentId: any, metricRef: string, metric: { __typename?: 'EsrsMetric', reference: string, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetric: { __typename?: 'EsrsMetric', reference: string } }> } }> } }> } }> } }> } }, datapointTags: Array<{ __typename?: 'esrs_DatapointTag', datapointTagValue: { __typename?: 'TagValue', type: string, value: string } }> } }> };

export type GetTopLevelDatapointsQueryVariables_ = Exact<{ [key: string]: never; }>;


export type GetTopLevelDatapointsQuery_ = { __typename?: 'query_root', esrs_Datapoint: Array<{ __typename?: 'esrs_Datapoint', id: any, timeframe: string, answer: { __typename?: 'esrs_Answer', assessmentId: any, metricRef: string, reportingUnitId: any } }> };

export type GetMaterialMetricsInfoQueryVariables_ = Exact<{
  metricRef: Scalars['String']['input'];
}>;


export type GetMaterialMetricsInfoQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', materialStandardId: any, dataCollection?: string | null, metricRef: string, isMaterial?: boolean | null, isDataGatheringOnly: boolean }> };

export type UpsertMultipleDatapointMdrmMutationVariables_ = Exact<{
  objects: Array<Esrs_DatapointMdrm_Insert_Input_> | Esrs_DatapointMdrm_Insert_Input_;
}>;


export type UpsertMultipleDatapointMdrmMutation_ = { __typename?: 'mutation_root', insert_esrs_DatapointMdrm?: { __typename?: 'esrs_DatapointMdrm_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_DatapointMdrm', id: any, datapointId: any }> } | null };

export type UpsertMultipleMaterialMetricsMutationVariables_ = Exact<{
  objects: Array<Esrs_MaterialMetric_Insert_Input_> | Esrs_MaterialMetric_Insert_Input_;
}>;


export type UpsertMultipleMaterialMetricsMutation_ = { __typename?: 'mutation_root', insert_esrs_MaterialMetric?: { __typename?: 'esrs_MaterialMetric_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_MaterialMetric', id: any, metricRef: string, materialStandardId: any }> } | null };

export type GetParentMetricEmptyDatapointsQueryVariables_ = Exact<{ [key: string]: never; }>;


export type GetParentMetricEmptyDatapointsQuery_ = { __typename?: 'query_root', esrs_Datapoint: Array<{ __typename?: 'esrs_Datapoint', id: any, answerId: any, timeframe: string, answer: { __typename?: 'esrs_Answer', metricRef: string }, datapointMdrms: Array<{ __typename?: 'esrs_DatapointMdrm', id: any, mdrmRef: string, value?: string | null }> }> };

export type GetOldCollectDataAssessmentsQueryVariables_ = Exact<{ [key: string]: never; }>;


export type GetOldCollectDataAssessmentsQuery_ = { __typename?: 'query_root', EsrsAssessment: Array<{ __typename?: 'EsrsAssessment', id: any, reportingYear: number, company: { __typename?: 'Company', name: string }, parentAssessment?: { __typename?: 'EsrsAssessment', materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', standardRef: string, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string }> }> } | null, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', standardRef: string, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string }> }> }> };

export type DeleteDatapointsMutationVariables_ = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteDatapointsMutation_ = { __typename?: 'mutation_root', delete_esrs_Datapoint?: { __typename?: 'esrs_Datapoint_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'esrs_Datapoint', id: any }> } | null };

export type GetTargetsDrQueryVariables_ = Exact<{
  reference: Scalars['String']['input'];
  esrsAssessmentId: Scalars['uuid']['input'];
  standardRef: Scalars['String']['input'];
}>;


export type GetTargetsDrQuery_ = { __typename?: 'query_root', DisclosureRequirement_by_pk?: { __typename?: 'DisclosureRequirement', reference: string, title: string, description?: string | null, type: string, targets: Array<{ __typename?: 'esrs_Target', id: any, disclosureRequirementRef: string, name: string, direction?: string | null, metricRef?: string | null, isBottomUp: boolean, description?: string | null, assessmentId: any, ownerId?: any | null, isRequired: boolean, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, period?: string | null, periodExplanation?: string | null, scope?: string | null, methodologies?: string | null, isEvidenceScientific?: boolean | null, isEvidenceScientificExplanation?: string | null, withStakeholders?: boolean | null, withStakeholdersExplanation?: string | null, withStakeholdersDescription?: string | null, targetChangeDescription?: string | null, isProgressAligned?: boolean | null, performanceNumber?: any | null, performanceText?: string | null, isProgressAlignedExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, relationshipToPolicy?: string | null, coverage?: string | null, coverageExplanation?: string | null, parentTargetId?: any | null, owner?: { __typename?: 'users', id: any, displayName: string, avatarUrl: string } | null, metric?: { __typename?: 'EsrsMetric', reference: string, title: string, unitOfMeasurement?: string | null } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, actionId: any, estimate?: any | null, action: { __typename?: 'esrs_Actions', id: any, title: string } }>, keyResults: Array<{ __typename?: 'esrs_Baseline', id: any, baseline?: string | null, baseYear?: any | null, reportingUnitId?: any | null, isFlagged: boolean }>, parentTarget?: { __typename?: 'esrs_Target', name: string, materialStandard: { __typename?: 'esrs_MaterialStandard', esrsAssessment: { __typename?: 'EsrsAssessment', company: { __typename?: 'Company', name: string } } }, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number }> } | null, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any, standardRef: string, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, subsidiariesTargets: Array<{ __typename?: 'esrs_Target', id: any, metricRef?: string | null }>, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number, isRelative: boolean, isRequired: boolean, milestoneResults: Array<{ __typename?: 'esrs_MilestoneResult', id: any, value?: any | null, reportingUnitId?: any | null }> }> }> } | null };

export type GetTargetQueryVariables_ = Exact<{
  targetId: Scalars['uuid']['input'];
}>;


export type GetTargetQuery_ = { __typename?: 'query_root', target?: { __typename?: 'esrs_Target', id: any, disclosureRequirementRef: string, name: string, direction?: string | null, metricRef?: string | null, isBottomUp: boolean, description?: string | null, assessmentId: any, ownerId?: any | null, isRequired: boolean, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, period?: string | null, periodExplanation?: string | null, scope?: string | null, methodologies?: string | null, isEvidenceScientific?: boolean | null, isEvidenceScientificExplanation?: string | null, withStakeholders?: boolean | null, withStakeholdersExplanation?: string | null, withStakeholdersDescription?: string | null, targetChangeDescription?: string | null, isProgressAligned?: boolean | null, performanceNumber?: any | null, performanceText?: string | null, isProgressAlignedExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, relationshipToPolicy?: string | null, coverage?: string | null, coverageExplanation?: string | null, parentTargetId?: any | null, parentTarget?: { __typename?: 'esrs_Target', name: string, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, actionId: any, estimate?: any | null, action: { __typename?: 'esrs_Actions', id: any, disclosureRequirementRef: string, title: string, deadline: any, startDate: any, ownerId?: any | null, capex?: any | null, noteReference?: string | null, timeHorizon?: string | null, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, statusOfKeyAction?: string | null, scope?: string | null, expectedOutcome?: string | null, provisionOfRemedy?: boolean | null, provisionOfRemedyExplanation?: string | null, progressInfo?: string | null, investmentsAndResources?: string | null, hasPreconditions?: boolean | null, hasPreconditionsExplanation?: string | null, opex?: any | null, opexShortTerm?: any | null, opexMediumTerm?: any | null, opexLongTerm?: any | null, capexShortTerm?: any | null, capexMediumTerm?: any | null, capexLongTerm?: any | null, scopeValueChain?: string | null, coverage?: string | null, coverageExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, statusOfKeyActionExplanation?: string | null, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, estimate?: any | null, target: { __typename?: 'esrs_Target', id: any, direction?: string | null, name: string, metric?: { __typename?: 'EsrsMetric', title: string, unitOfMeasurement?: string | null } | null } }>, actionReportingUnits: Array<{ __typename?: 'esrs_ActionReportingUnit', id: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string } }>, actionSubsidiaries: Array<{ __typename?: 'esrs_ActionSubsidiary', id: any, subsidiaryAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }>, materialStandard: { __typename?: 'esrs_MaterialStandard', assessmentId: any, standard: { __typename?: 'EsrsStandard', reference: string }, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, attachmentBox?: { __typename?: 'AttachmentBox', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any } | null } }>, materialStandard: { __typename?: 'esrs_MaterialStandard', esrsAssessment: { __typename?: 'EsrsAssessment', company: { __typename?: 'Company', name: string } } }, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number }> } | null, subsidiariesTargets: Array<{ __typename?: 'esrs_Target', id: any, metricRef?: string | null, disclosureRequirementRef: string, name: string, direction?: string | null, isBottomUp: boolean, description?: string | null, assessmentId: any, ownerId?: any | null, isRequired: boolean, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, period?: string | null, periodExplanation?: string | null, scope?: string | null, methodologies?: string | null, isEvidenceScientific?: boolean | null, isEvidenceScientificExplanation?: string | null, withStakeholders?: boolean | null, withStakeholdersExplanation?: string | null, withStakeholdersDescription?: string | null, targetChangeDescription?: string | null, isProgressAligned?: boolean | null, performanceNumber?: any | null, performanceText?: string | null, isProgressAlignedExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, relationshipToPolicy?: string | null, coverage?: string | null, coverageExplanation?: string | null, parentTargetId?: any | null, owner?: { __typename?: 'users', id: any, displayName: string, avatarUrl: string } | null, metric?: { __typename?: 'EsrsMetric', reference: string, title: string, unitOfMeasurement?: string | null } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, actionId: any, estimate?: any | null, action: { __typename?: 'esrs_Actions', id: any, title: string } }>, keyResults: Array<{ __typename?: 'esrs_Baseline', id: any, baseline?: string | null, baseYear?: any | null, reportingUnitId?: any | null, isFlagged: boolean }>, parentTarget?: { __typename?: 'esrs_Target', name: string, materialStandard: { __typename?: 'esrs_MaterialStandard', esrsAssessment: { __typename?: 'EsrsAssessment', company: { __typename?: 'Company', name: string } } }, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number }> } | null, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any, standardRef: string, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, subsidiariesTargets: Array<{ __typename?: 'esrs_Target', id: any, metricRef?: string | null }>, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number, isRelative: boolean, isRequired: boolean, milestoneResults: Array<{ __typename?: 'esrs_MilestoneResult', id: any, value?: any | null, reportingUnitId?: any | null }> }> }>, owner?: { __typename?: 'users', id: any, displayName: string, avatarUrl: string } | null, metric?: { __typename?: 'EsrsMetric', reference: string, title: string, unitOfMeasurement?: string | null } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, actionId: any, estimate?: any | null, action: { __typename?: 'esrs_Actions', id: any, title: string } }>, keyResults: Array<{ __typename?: 'esrs_Baseline', id: any, baseline?: string | null, baseYear?: any | null, reportingUnitId?: any | null, isFlagged: boolean }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any, standardRef: string, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number, isRelative: boolean, isRequired: boolean, milestoneResults: Array<{ __typename?: 'esrs_MilestoneResult', id: any, value?: any | null, reportingUnitId?: any | null }> }> } | null };

export type GetTargetsSubsidiariesQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetTargetsSubsidiariesQuery_ = { __typename?: 'query_root', esrs?: { __typename?: 'EsrsAssessment', id: any, subsidiaries: Array<{ __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string }, materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', id: any, isMaterial?: boolean | null, targets: Array<{ __typename?: 'esrs_Target', id: any, disclosureRequirementRef: string, name: string, direction?: string | null, metricRef?: string | null, isBottomUp: boolean, description?: string | null, assessmentId: any, ownerId?: any | null, isRequired: boolean, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, period?: string | null, periodExplanation?: string | null, scope?: string | null, methodologies?: string | null, isEvidenceScientific?: boolean | null, isEvidenceScientificExplanation?: string | null, withStakeholders?: boolean | null, withStakeholdersExplanation?: string | null, withStakeholdersDescription?: string | null, targetChangeDescription?: string | null, isProgressAligned?: boolean | null, performanceNumber?: any | null, performanceText?: string | null, isProgressAlignedExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, relationshipToPolicy?: string | null, coverage?: string | null, coverageExplanation?: string | null, parentTargetId?: any | null, owner?: { __typename?: 'users', id: any, displayName: string, avatarUrl: string } | null, metric?: { __typename?: 'EsrsMetric', reference: string, title: string, unitOfMeasurement?: string | null } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, actionId: any, estimate?: any | null, action: { __typename?: 'esrs_Actions', id: any, title: string } }>, keyResults: Array<{ __typename?: 'esrs_Baseline', id: any, baseline?: string | null, baseYear?: any | null, reportingUnitId?: any | null, isFlagged: boolean }>, parentTarget?: { __typename?: 'esrs_Target', name: string, materialStandard: { __typename?: 'esrs_MaterialStandard', esrsAssessment: { __typename?: 'EsrsAssessment', company: { __typename?: 'Company', name: string } } }, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number }> } | null, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any, standardRef: string, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, subsidiariesTargets: Array<{ __typename?: 'esrs_Target', id: any, metricRef?: string | null }>, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number, isRelative: boolean, isRequired: boolean, milestoneResults: Array<{ __typename?: 'esrs_MilestoneResult', id: any, value?: any | null, reportingUnitId?: any | null }> }> }> }> }> } | null };

export type GetParentTargetsDrQueryVariables_ = Exact<{
  parentStandardId: Scalars['uuid']['input'];
}>;


export type GetParentTargetsDrQuery_ = { __typename?: 'query_root', esrs_Target: Array<{ __typename?: 'esrs_Target', id: any, disclosureRequirementRef: string, name: string, direction?: string | null, metricRef?: string | null, isBottomUp: boolean, description?: string | null, assessmentId: any, ownerId?: any | null, isRequired: boolean, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, period?: string | null, periodExplanation?: string | null, scope?: string | null, methodologies?: string | null, isEvidenceScientific?: boolean | null, isEvidenceScientificExplanation?: string | null, withStakeholders?: boolean | null, withStakeholdersExplanation?: string | null, withStakeholdersDescription?: string | null, targetChangeDescription?: string | null, isProgressAligned?: boolean | null, performanceNumber?: any | null, performanceText?: string | null, isProgressAlignedExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, relationshipToPolicy?: string | null, coverage?: string | null, coverageExplanation?: string | null, parentTargetId?: any | null, owner?: { __typename?: 'users', id: any, displayName: string, avatarUrl: string } | null, metric?: { __typename?: 'EsrsMetric', reference: string, title: string, unitOfMeasurement?: string | null } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, actionId: any, estimate?: any | null, action: { __typename?: 'esrs_Actions', id: any, title: string } }>, keyResults: Array<{ __typename?: 'esrs_Baseline', id: any, baseline?: string | null, baseYear?: any | null, reportingUnitId?: any | null, isFlagged: boolean }>, parentTarget?: { __typename?: 'esrs_Target', name: string, materialStandard: { __typename?: 'esrs_MaterialStandard', esrsAssessment: { __typename?: 'EsrsAssessment', company: { __typename?: 'Company', name: string } } }, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number }> } | null, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any, standardRef: string, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, subsidiariesTargets: Array<{ __typename?: 'esrs_Target', id: any, metricRef?: string | null }>, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number, isRelative: boolean, isRequired: boolean, milestoneResults: Array<{ __typename?: 'esrs_MilestoneResult', id: any, value?: any | null, reportingUnitId?: any | null }> }> }> };

export type GetTargetsQueryVariables_ = Exact<{
  disclosureRequirementRef: Scalars['String']['input'];
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetTargetsQuery_ = { __typename?: 'query_root', targets: Array<{ __typename?: 'esrs_Target', id: any, disclosureRequirementRef: string, name: string, direction?: string | null, metricRef?: string | null, isBottomUp: boolean, description?: string | null, assessmentId: any, ownerId?: any | null, isRequired: boolean, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, period?: string | null, periodExplanation?: string | null, scope?: string | null, methodologies?: string | null, isEvidenceScientific?: boolean | null, isEvidenceScientificExplanation?: string | null, withStakeholders?: boolean | null, withStakeholdersExplanation?: string | null, withStakeholdersDescription?: string | null, targetChangeDescription?: string | null, isProgressAligned?: boolean | null, performanceNumber?: any | null, performanceText?: string | null, isProgressAlignedExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, relationshipToPolicy?: string | null, coverage?: string | null, coverageExplanation?: string | null, parentTargetId?: any | null, owner?: { __typename?: 'users', id: any, displayName: string, avatarUrl: string } | null, metric?: { __typename?: 'EsrsMetric', reference: string, title: string, unitOfMeasurement?: string | null } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, actionId: any, estimate?: any | null, action: { __typename?: 'esrs_Actions', id: any, title: string } }>, keyResults: Array<{ __typename?: 'esrs_Baseline', id: any, baseline?: string | null, baseYear?: any | null, reportingUnitId?: any | null, isFlagged: boolean }>, parentTarget?: { __typename?: 'esrs_Target', name: string, materialStandard: { __typename?: 'esrs_MaterialStandard', esrsAssessment: { __typename?: 'EsrsAssessment', company: { __typename?: 'Company', name: string } } }, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number }> } | null, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any, standardRef: string, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, subsidiariesTargets: Array<{ __typename?: 'esrs_Target', id: any, metricRef?: string | null }>, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number, isRelative: boolean, isRequired: boolean, milestoneResults: Array<{ __typename?: 'esrs_MilestoneResult', id: any, value?: any | null, reportingUnitId?: any | null }> }> }> };

export type GetTargetsByStandardAndAssessmentQueryVariables_ = Exact<{
  disclosureRequirementRef: Scalars['String']['input'];
  esrsAssessmentId: Scalars['uuid']['input'];
  standardRef: Scalars['String']['input'];
}>;


export type GetTargetsByStandardAndAssessmentQuery_ = { __typename?: 'query_root', targets: Array<{ __typename?: 'esrs_Target', id: any, disclosureRequirementRef: string, name: string, direction?: string | null, metricRef?: string | null, isBottomUp: boolean, description?: string | null, assessmentId: any, ownerId?: any | null, isRequired: boolean, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, period?: string | null, periodExplanation?: string | null, scope?: string | null, methodologies?: string | null, isEvidenceScientific?: boolean | null, isEvidenceScientificExplanation?: string | null, withStakeholders?: boolean | null, withStakeholdersExplanation?: string | null, withStakeholdersDescription?: string | null, targetChangeDescription?: string | null, isProgressAligned?: boolean | null, performanceNumber?: any | null, performanceText?: string | null, isProgressAlignedExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, relationshipToPolicy?: string | null, coverage?: string | null, coverageExplanation?: string | null, parentTargetId?: any | null, owner?: { __typename?: 'users', id: any, displayName: string, avatarUrl: string } | null, metric?: { __typename?: 'EsrsMetric', reference: string, title: string, unitOfMeasurement?: string | null } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, actionId: any, estimate?: any | null, action: { __typename?: 'esrs_Actions', id: any, title: string } }>, keyResults: Array<{ __typename?: 'esrs_Baseline', id: any, baseline?: string | null, baseYear?: any | null, reportingUnitId?: any | null, isFlagged: boolean }>, parentTarget?: { __typename?: 'esrs_Target', name: string, materialStandard: { __typename?: 'esrs_MaterialStandard', esrsAssessment: { __typename?: 'EsrsAssessment', company: { __typename?: 'Company', name: string } } }, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number }> } | null, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any, standardRef: string, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } } }, subsidiariesTargets: Array<{ __typename?: 'esrs_Target', id: any, metricRef?: string | null }>, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number, isRelative: boolean, isRequired: boolean, milestoneResults: Array<{ __typename?: 'esrs_MilestoneResult', id: any, value?: any | null, reportingUnitId?: any | null }> }> }> };

export type EsrsAssessmentTargetsQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type EsrsAssessmentTargetsQuery_ = { __typename?: 'query_root', esrs_Target: Array<{ __typename?: 'esrs_Target', id: any, disclosureRequirementRef: string, name: string, direction?: string | null, metricRef?: string | null, isBottomUp: boolean, description?: string | null, assessmentId: any, ownerId?: any | null, isRequired: boolean, answers?: any | null, relatedIRO?: string | null, relatedPolicy?: string | null, period?: string | null, periodExplanation?: string | null, scope?: string | null, methodologies?: string | null, isEvidenceScientific?: boolean | null, isEvidenceScientificExplanation?: string | null, withStakeholders?: boolean | null, withStakeholdersExplanation?: string | null, withStakeholdersDescription?: string | null, targetChangeDescription?: string | null, isProgressAligned?: boolean | null, performanceNumber?: any | null, performanceText?: string | null, isProgressAlignedExplanation?: string | null, sustainabilityMatter?: string | null, sustainabilityMatterExplanation?: string | null, relationshipToPolicy?: string | null, coverage?: string | null, coverageExplanation?: string | null, parentTargetId?: any | null, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, assessmentId: any, standardRef: string, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, parentAssessmentId?: any | null, company: { __typename?: 'Company', id: any, name: string, isGroupOwner: boolean } } }, disclosureRequirement: { __typename?: 'DisclosureRequirement', reference: string, group: { __typename?: 'DisclosureRequirementGroup', reference: string, standard: { __typename?: 'EsrsStandard', title: string, reference: string, category: { __typename?: 'EsrsCategory', title: string, reference: string } } } }, owner?: { __typename?: 'users', id: any, displayName: string, avatarUrl: string } | null, metric?: { __typename?: 'EsrsMetric', reference: string, title: string, unitOfMeasurement?: string | null } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', id: any, actionId: any, estimate?: any | null, action: { __typename?: 'esrs_Actions', id: any, title: string } }>, keyResults: Array<{ __typename?: 'esrs_Baseline', id: any, baseline?: string | null, baseYear?: any | null, reportingUnitId?: any | null, isFlagged: boolean }>, parentTarget?: { __typename?: 'esrs_Target', name: string, materialStandard: { __typename?: 'esrs_MaterialStandard', esrsAssessment: { __typename?: 'EsrsAssessment', company: { __typename?: 'Company', name: string } } }, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number }> } | null, subsidiariesTargets: Array<{ __typename?: 'esrs_Target', id: any, metricRef?: string | null }>, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number, isRelative: boolean, isRequired: boolean, milestoneResults: Array<{ __typename?: 'esrs_MilestoneResult', id: any, value?: any | null, reportingUnitId?: any | null }> }> }> };

export type TargetQuestionsQueryVariables_ = Exact<{
  standardRef: Scalars['String']['input'];
}>;


export type TargetQuestionsQuery_ = { __typename?: 'query_root', TargetQuestion: Array<{ __typename?: 'TargetQuestion', title: string, reference: string, unit?: string | null, questionType: QuestionType_Enum_, description?: string | null, groupRef?: string | null, group?: { __typename?: 'TargetQuestionGroup', reference: string, title: string } | null, choiceSet?: { __typename?: 'ChoiceSet', choices: Array<{ __typename?: 'EsrsChoice', title: string, reference: string }> } | null }> };

export type GetRequiredTargetMaterialMetricsQueryVariables_ = Exact<{
  materialStandardId: Scalars['uuid']['input'];
  parentStandardId: Scalars['uuid']['input'];
}>;


export type GetRequiredTargetMaterialMetricsQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string }> };

export type UpsertTargetMutationVariables_ = Exact<{
  target: Array<Esrs_Target_Insert_Input_> | Esrs_Target_Insert_Input_;
}>;


export type UpsertTargetMutation_ = { __typename?: 'mutation_root', insert_esrs_Target?: { __typename?: 'esrs_Target_mutation_response', returning: Array<{ __typename?: 'esrs_Target', id: any, metricRef?: string | null, milestones: Array<{ __typename?: 'esrs_Milestone', id: any, year: number }>, attachmentBox?: { __typename?: 'AttachmentBox', id: any } | null, noteHistory?: { __typename?: 'NoteHistory', id: any } | null, actionTargets: Array<{ __typename?: 'esrs_ActionTarget', actionId: any }> }> } | null };

export type CreateShortTargetMutationVariables_ = Exact<{
  target: Esrs_Target_Insert_Input_;
}>;


export type CreateShortTargetMutation_ = { __typename?: 'mutation_root', insert_esrs_Target_one?: { __typename?: 'esrs_Target', id: any } | null };

export type DeleteTargetMutationVariables_ = Exact<{
  targetId: Scalars['uuid']['input'];
}>;


export type DeleteTargetMutation_ = { __typename?: 'mutation_root', delete_esrs_Target_by_pk?: { __typename?: 'esrs_Target', id: any } | null };

export type DeleteBaselinesMutationVariables_ = Exact<{
  baselineIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type DeleteBaselinesMutation_ = { __typename?: 'mutation_root', delete_esrs_Baseline?: { __typename?: 'esrs_Baseline_mutation_response', affected_rows: number } | null };

export type DeleteMilestoneMutationVariables_ = Exact<{
  milestoneId: Scalars['uuid']['input'];
}>;


export type DeleteMilestoneMutation_ = { __typename?: 'mutation_root', delete_esrs_MilestoneResult?: { __typename?: 'esrs_MilestoneResult_mutation_response', affected_rows: number } | null, delete_esrs_Milestone_by_pk?: { __typename?: 'esrs_Milestone', id: any } | null };

export type UnlinkTargetParentMutationVariables_ = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UnlinkTargetParentMutation_ = { __typename?: 'mutation_root', update_esrs_Target_many?: Array<{ __typename?: 'esrs_Target_mutation_response', returning: Array<{ __typename?: 'esrs_Target', id: any }> } | null> | null };

export type InsertProviderRequestMutationVariables_ = Exact<{
  providerRequest: AuthProviderRequests_Insert_Input_;
}>;


export type InsertProviderRequestMutation_ = { __typename?: 'mutation_root', insertAuthProviderRequest?: { __typename?: 'authProviderRequests', id: any, options?: any | null } | null };

export type DeleteProviderRequestMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteProviderRequestMutation_ = { __typename?: 'mutation_root', deleteAuthProviderRequest?: { __typename?: 'authProviderRequests', id: any, options?: any | null } | null };

export type ProviderRequestQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ProviderRequestQuery_ = { __typename?: 'query_root', authProviderRequest?: { __typename?: 'authProviderRequests', id: any, options?: any | null } | null };

export type InsertRefreshTokenMutationVariables_ = Exact<{
  refreshToken: AuthRefreshTokens_Insert_Input_;
}>;


export type InsertRefreshTokenMutation_ = { __typename?: 'mutation_root', insertAuthRefreshToken?: { __typename?: 'authRefreshTokens', id: any } | null };

export type DeleteRefreshTokenMutationVariables_ = Exact<{
  refreshTokenHash: Scalars['String']['input'];
}>;


export type DeleteRefreshTokenMutation_ = { __typename?: 'mutation_root', deleteAuthRefreshTokens?: { __typename?: 'authRefreshTokens_mutation_response', affected_rows: number } | null };

export type DeleteUserRefreshTokensMutationVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type DeleteUserRefreshTokensMutation_ = { __typename?: 'mutation_root', deleteAuthRefreshTokens?: { __typename?: 'authRefreshTokens_mutation_response', affected_rows: number } | null };

export type DeleteExpiredRefreshTokensMutationVariables_ = Exact<{ [key: string]: never; }>;


export type DeleteExpiredRefreshTokensMutation_ = { __typename?: 'mutation_root', deleteAuthRefreshTokens?: { __typename?: 'authRefreshTokens_mutation_response', affected_rows: number } | null };

export type UpsertRolesMutationVariables_ = Exact<{
  roles: Array<AuthRoles_Insert_Input_> | AuthRoles_Insert_Input_;
}>;


export type UpsertRolesMutation_ = { __typename?: 'mutation_root', insertAuthRoles?: { __typename?: 'authRoles_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'authRoles', role: string }> } | null };

export type GetUserSecurityKeysQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserSecurityKeysQuery_ = { __typename?: 'query_root', authUserSecurityKeys: Array<{ __typename?: 'authUserSecurityKeys', counter: any, credentialId: string, credentialPublicKey?: any | null, transports: string, id: any, user: { __typename?: 'users', id: any } }> };

export type GetUserChallengeQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetUserChallengeQuery_ = { __typename?: 'query_root', user?: { __typename?: 'users', id: any, currentChallenge?: string | null } | null };

export type UpdateUserChallengeMutationVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
  challenge: Scalars['String']['input'];
}>;


export type UpdateUserChallengeMutation_ = { __typename?: 'mutation_root', updateUser?: { __typename?: 'users', id: any } | null };

export type AddUserSecurityKeyMutationVariables_ = Exact<{
  userSecurityKey: AuthUserSecurityKeys_Insert_Input_;
}>;


export type AddUserSecurityKeyMutation_ = { __typename?: 'mutation_root', insertAuthUserSecurityKey?: { __typename?: 'authUserSecurityKeys', id: any } | null };

export type UpdateUserSecurityKeyMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  counter: Scalars['bigint']['input'];
}>;


export type UpdateUserSecurityKeyMutation_ = { __typename?: 'mutation_root', updateAuthUserSecurityKey?: { __typename?: 'authUserSecurityKeys', id: any } | null };

export type AuthUserProvidersQueryVariables_ = Exact<{
  provider: Scalars['String']['input'];
  providerUserId: Scalars['String']['input'];
}>;


export type AuthUserProvidersQuery_ = { __typename?: 'query_root', authUserProviders: Array<{ __typename?: 'authUserProviders', id: any, user: { __typename?: 'users', id: any, createdAt: any, disabled: boolean, displayName: string, avatarUrl: string, email?: any | null, passwordHash?: string | null, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, defaultRole: string, isAnonymous: boolean, ticket?: string | null, otpHash?: string | null, totpSecret?: string | null, activeMfaType?: string | null, newEmail?: any | null, locale: string, metadata?: any | null, roles: Array<{ __typename?: 'authUserRoles', role: string }> } }> };

export type UserProviderQueryVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
  providerId: Scalars['String']['input'];
}>;


export type UserProviderQuery_ = { __typename?: 'query_root', authUserProviders: Array<{ __typename?: 'authUserProviders', id: any, refreshToken?: string | null }> };

export type UpdateAuthUserproviderMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  authUserProvider: AuthUserProviders_Set_Input_;
}>;


export type UpdateAuthUserproviderMutation_ = { __typename?: 'mutation_root', updateAuthUserProvider?: { __typename?: 'authUserProviders', id: any } | null };

export type InsertUserRolesMutationVariables_ = Exact<{
  userRoles: Array<AuthUserRoles_Insert_Input_> | AuthUserRoles_Insert_Input_;
}>;


export type InsertUserRolesMutation_ = { __typename?: 'mutation_root', insertAuthUserRoles?: { __typename?: 'authUserRoles_mutation_response', affected_rows: number } | null };

export type DeleteUserRolesByUserIdMutationVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type DeleteUserRolesByUserIdMutation_ = { __typename?: 'mutation_root', deleteAuthUserRoles?: { __typename?: 'authUserRoles_mutation_response', affected_rows: number } | null };

export type UserFieldsFragment_ = { __typename?: 'users', id: any, createdAt: any, disabled: boolean, displayName: string, avatarUrl: string, email?: any | null, passwordHash?: string | null, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, defaultRole: string, isAnonymous: boolean, ticket?: string | null, otpHash?: string | null, totpSecret?: string | null, activeMfaType?: string | null, newEmail?: any | null, locale: string, metadata?: any | null, roles: Array<{ __typename?: 'authUserRoles', role: string }> };

export type UserQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UserQuery_ = { __typename?: 'query_root', user?: { __typename?: 'users', id: any, createdAt: any, disabled: boolean, displayName: string, avatarUrl: string, email?: any | null, passwordHash?: string | null, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, defaultRole: string, isAnonymous: boolean, ticket?: string | null, otpHash?: string | null, totpSecret?: string | null, activeMfaType?: string | null, newEmail?: any | null, locale: string, metadata?: any | null, roles: Array<{ __typename?: 'authUserRoles', role: string }> } | null };

export type UsersQueryVariables_ = Exact<{
  where: Users_Bool_Exp_;
}>;


export type UsersQuery_ = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, createdAt: any, disabled: boolean, displayName: string, avatarUrl: string, email?: any | null, passwordHash?: string | null, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, defaultRole: string, isAnonymous: boolean, ticket?: string | null, otpHash?: string | null, totpSecret?: string | null, activeMfaType?: string | null, newEmail?: any | null, locale: string, metadata?: any | null, roles: Array<{ __typename?: 'authUserRoles', role: string }> }> };

export type GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutationVariables_ = Exact<{
  refreshTokenHash: Scalars['String']['input'];
  expiresAt: Scalars['timestamptz']['input'];
}>;


export type GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutation_ = { __typename?: 'mutation_root', updateAuthRefreshTokens?: { __typename?: 'authRefreshTokens_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'authRefreshTokens', id: any }> } | null };

export type GetUsersByRefreshTokenQueryVariables_ = Exact<{
  refreshTokenHash: Scalars['String']['input'];
}>;


export type GetUsersByRefreshTokenQuery_ = { __typename?: 'query_root', authRefreshTokens: Array<{ __typename?: 'authRefreshTokens', id: any, user: { __typename?: 'users', id: any, createdAt: any, disabled: boolean, displayName: string, avatarUrl: string, email?: any | null, passwordHash?: string | null, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, defaultRole: string, isAnonymous: boolean, ticket?: string | null, otpHash?: string | null, totpSecret?: string | null, activeMfaType?: string | null, newEmail?: any | null, locale: string, metadata?: any | null, roles: Array<{ __typename?: 'authUserRoles', role: string }> } }> };

export type GetUsersByPatQueryVariables_ = Exact<{
  patHash: Scalars['String']['input'];
}>;


export type GetUsersByPatQuery_ = { __typename?: 'query_root', authRefreshTokens: Array<{ __typename?: 'authRefreshTokens', id: any, user: { __typename?: 'users', id: any, createdAt: any, disabled: boolean, displayName: string, avatarUrl: string, email?: any | null, passwordHash?: string | null, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, defaultRole: string, isAnonymous: boolean, ticket?: string | null, otpHash?: string | null, totpSecret?: string | null, activeMfaType?: string | null, newEmail?: any | null, locale: string, metadata?: any | null, roles: Array<{ __typename?: 'authUserRoles', role: string }> } }> };

export type UpdateUserMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  user: Users_Set_Input_;
}>;


export type UpdateUserMutation_ = { __typename?: 'mutation_root', updateUser?: { __typename?: 'users', id: any, createdAt: any, disabled: boolean, displayName: string, avatarUrl: string, email?: any | null, passwordHash?: string | null, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, defaultRole: string, isAnonymous: boolean, ticket?: string | null, otpHash?: string | null, totpSecret?: string | null, activeMfaType?: string | null, newEmail?: any | null, locale: string, metadata?: any | null, roles: Array<{ __typename?: 'authUserRoles', role: string }> } | null };

export type UpdateUserWhereMutationVariables_ = Exact<{
  where: Users_Bool_Exp_;
  user: Users_Set_Input_;
}>;


export type UpdateUserWhereMutation_ = { __typename?: 'mutation_root', updateUsers?: { __typename?: 'users_mutation_response', affected_rows: number } | null };

export type RotateUsersTicketMutationVariables_ = Exact<{
  oldTicket: Scalars['String']['input'];
  newTicket: Scalars['String']['input'];
  newTicketExpiresAt: Scalars['timestamptz']['input'];
}>;


export type RotateUsersTicketMutation_ = { __typename?: 'mutation_root', updateUsers?: { __typename?: 'users_mutation_response', affected_rows: number } | null };

export type ChangeEmailsByTicketMutationVariables_ = Exact<{
  ticket: Scalars['String']['input'];
  email: Scalars['citext']['input'];
  newTicket: Scalars['String']['input'];
  now: Scalars['timestamptz']['input'];
}>;


export type ChangeEmailsByTicketMutation_ = { __typename?: 'mutation_root', updateUsers?: { __typename?: 'users_mutation_response', returning: Array<{ __typename?: 'users', id: any, createdAt: any, disabled: boolean, displayName: string, avatarUrl: string, email?: any | null, passwordHash?: string | null, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, defaultRole: string, isAnonymous: boolean, ticket?: string | null, otpHash?: string | null, totpSecret?: string | null, activeMfaType?: string | null, newEmail?: any | null, locale: string, metadata?: any | null, roles: Array<{ __typename?: 'authUserRoles', role: string }> }> } | null };

export type InsertUserMutationVariables_ = Exact<{
  user: Users_Insert_Input_;
}>;


export type InsertUserMutation_ = { __typename?: 'mutation_root', insertUser?: { __typename?: 'users', id: any, createdAt: any, disabled: boolean, displayName: string, avatarUrl: string, email?: any | null, passwordHash?: string | null, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, defaultRole: string, isAnonymous: boolean, ticket?: string | null, otpHash?: string | null, totpSecret?: string | null, activeMfaType?: string | null, newEmail?: any | null, locale: string, metadata?: any | null, roles: Array<{ __typename?: 'authUserRoles', role: string }> } | null };

export type DeleteUserMutationVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type DeleteUserMutation_ = { __typename?: 'mutation_root', deleteAuthUserRoles?: { __typename?: 'authUserRoles_mutation_response', affected_rows: number } | null, deleteUser?: { __typename?: 'users', id: any, createdAt: any, disabled: boolean, displayName: string, avatarUrl: string, email?: any | null, passwordHash?: string | null, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, defaultRole: string, isAnonymous: boolean, ticket?: string | null, otpHash?: string | null, totpSecret?: string | null, activeMfaType?: string | null, newEmail?: any | null, locale: string, metadata?: any | null, roles: Array<{ __typename?: 'authUserRoles', role: string }> } | null };

export type DeanonymizeUserMutationVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  role: Scalars['String']['input'];
}>;


export type DeanonymizeUserMutation_ = { __typename?: 'mutation_root', updateAuthUserRoles?: { __typename?: 'authUserRoles_mutation_response', affected_rows: number } | null, updateUser?: { __typename?: 'users', id: any } | null };

export type InsertUserProviderToUserMutationVariables_ = Exact<{
  userProvider: AuthUserProviders_Insert_Input_;
}>;


export type InsertUserProviderToUserMutation_ = { __typename?: 'mutation_root', insertAuthUserProvider?: { __typename?: 'authUserProviders', id: any } | null };

export type GetUserByTicketQueryVariables_ = Exact<{
  ticket: Scalars['String']['input'];
}>;


export type GetUserByTicketQuery_ = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, createdAt: any, disabled: boolean, displayName: string, avatarUrl: string, email?: any | null, passwordHash?: string | null, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, defaultRole: string, isAnonymous: boolean, ticket?: string | null, otpHash?: string | null, totpSecret?: string | null, activeMfaType?: string | null, newEmail?: any | null, locale: string, metadata?: any | null, roles: Array<{ __typename?: 'authUserRoles', role: string }> }> };

export type UpdateUsersByTicketMutationVariables_ = Exact<{
  ticket: Scalars['String']['input'];
  user: Users_Set_Input_;
}>;


export type UpdateUsersByTicketMutation_ = { __typename?: 'mutation_root', updateUsers?: { __typename?: 'users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'users', id: any, createdAt: any, disabled: boolean, displayName: string, avatarUrl: string, email?: any | null, passwordHash?: string | null, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, defaultRole: string, isAnonymous: boolean, ticket?: string | null, otpHash?: string | null, totpSecret?: string | null, activeMfaType?: string | null, newEmail?: any | null, locale: string, metadata?: any | null, roles: Array<{ __typename?: 'authUserRoles', role: string }> }> } | null };

export type FileMetadataFragmentFragment_ = { __typename?: 'files', id: any, name?: string | null, size?: number | null, bucketId: string, etag?: string | null, createdAt: any, updatedAt: any, isUploaded?: boolean | null, mimeType?: string | null, uploadedByUserId?: any | null, metadata?: any | null };

export type FileMetadataSummaryFragmentFragment_ = { __typename?: 'files', id: any, name?: string | null, bucketId: string, isUploaded?: boolean | null };

export type BucketMetadataFragmentFragment_ = { __typename?: 'buckets', id: string, minUploadFileSize: number, maxUploadFileSize: number, presignedUrlsEnabled: boolean, downloadExpiration: number, createdAt: any, updatedAt: any, cacheControl?: string | null };

export type GetBucketQueryVariables_ = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetBucketQuery_ = { __typename?: 'query_root', bucket?: { __typename?: 'buckets', id: string, minUploadFileSize: number, maxUploadFileSize: number, presignedUrlsEnabled: boolean, downloadExpiration: number, createdAt: any, updatedAt: any, cacheControl?: string | null } | null };

export type GetFileQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetFileQuery_ = { __typename?: 'query_root', file?: { __typename?: 'files', id: any, name?: string | null, size?: number | null, bucketId: string, etag?: string | null, createdAt: any, updatedAt: any, isUploaded?: boolean | null, mimeType?: string | null, uploadedByUserId?: any | null, metadata?: any | null } | null };

export type ListFilesSummaryQueryVariables_ = Exact<{ [key: string]: never; }>;


export type ListFilesSummaryQuery_ = { __typename?: 'query_root', files: Array<{ __typename?: 'files', id: any, name?: string | null, bucketId: string, isUploaded?: boolean | null }> };

export type InsertFileMutationVariables_ = Exact<{
  object: Files_Insert_Input_;
}>;


export type InsertFileMutation_ = { __typename?: 'mutation_root', insertFile?: { __typename?: 'files', id: any } | null };

export type UpdateFileMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  _set: Files_Set_Input_;
}>;


export type UpdateFileMutation_ = { __typename?: 'mutation_root', updateFile?: { __typename?: 'files', id: any, name?: string | null, size?: number | null, bucketId: string, etag?: string | null, createdAt: any, updatedAt: any, isUploaded?: boolean | null, mimeType?: string | null, uploadedByUserId?: any | null, metadata?: any | null } | null };

export type DeleteFileMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteFileMutation_ = { __typename?: 'mutation_root', deleteFile?: { __typename?: 'files', id: any } | null };

export type InsertVirusMutationVariables_ = Exact<{
  object: Virus_Insert_Input_;
}>;


export type InsertVirusMutation_ = { __typename?: 'mutation_root', insertVirus?: { __typename?: 'virus', id: any } | null };

export type RemoteAppDeleteUserMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RemoteAppDeleteUserMutation_ = { __typename?: 'mutation_root', deleteUser?: { __typename?: 'users', id: any } | null };

export type GetRemoteAppMetricsQueryVariables_ = Exact<{ [key: string]: never; }>;


export type GetRemoteAppMetricsQuery_ = { __typename?: 'query_root', filesAggregate: { __typename?: 'files_aggregate', aggregate?: { __typename?: 'files_aggregate_fields', count: number, sum?: { __typename?: 'files_sum_fields', size?: number | null } | null } | null }, usersAggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null } };

export type RemoteAppGetUsersFragment_ = { __typename?: 'users', id: any, createdAt: any, displayName: string, avatarUrl: string, email?: any | null, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, disabled: boolean, defaultRole: string, lastSeen?: any | null, locale: string, roles: Array<{ __typename?: 'authUserRoles', id: any, role: string }>, userProviders: Array<{ __typename?: 'authUserProviders', id: any, providerId: string }> };

export type RemoteAppGetUsersQueryVariables_ = Exact<{
  where: Users_Bool_Exp_;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type RemoteAppGetUsersQuery_ = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, createdAt: any, displayName: string, avatarUrl: string, email?: any | null, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, disabled: boolean, defaultRole: string, lastSeen?: any | null, locale: string, roles: Array<{ __typename?: 'authUserRoles', id: any, role: string }>, userProviders: Array<{ __typename?: 'authUserProviders', id: any, providerId: string }> }>, filteredUsersAggreggate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null }, usersAggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null } };

export type RemoteAppGetUsersCustomQueryVariables_ = Exact<{
  where: Users_Bool_Exp_;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type RemoteAppGetUsersCustomQuery_ = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, createdAt: any, displayName: string, phoneNumber?: string | null, avatarUrl: string, email?: any | null, disabled: boolean, defaultRole: string, isAnonymous: boolean, roles: Array<{ __typename?: 'authUserRoles', role: string }> }> };

export type RemoteAppGetUsersWholeQueryVariables_ = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type RemoteAppGetUsersWholeQuery_ = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, createdAt: any, displayName: string, avatarUrl: string, email?: any | null, emailVerified: boolean, phoneNumber?: string | null, phoneNumberVerified: boolean, disabled: boolean, defaultRole: string, lastSeen?: any | null, locale: string, roles: Array<{ __typename?: 'authUserRoles', id: any, role: string }>, userProviders: Array<{ __typename?: 'authUserProviders', id: any, providerId: string }> }>, usersAggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null } };

export type TotalUsersQueryVariables_ = Exact<{ [key: string]: never; }>;


export type TotalUsersQuery_ = { __typename?: 'query_root', usersAggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null } };

export type TotalUsersByDateQueryVariables_ = Exact<{
  where: Users_Bool_Exp_;
}>;


export type TotalUsersByDateQuery_ = { __typename?: 'query_root', usersAggregate: { __typename?: 'users_aggregate', aggregate?: { __typename?: 'users_aggregate_fields', count: number } | null } };

export type UpdateRemoteAppUserMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  user: Users_Set_Input_;
}>;


export type UpdateRemoteAppUserMutation_ = { __typename?: 'mutation_root', updateUser?: { __typename?: 'users', id: any } | null };

export type InsertRemoteAppUserRolesMutationVariables_ = Exact<{
  roles: Array<AuthUserRoles_Insert_Input_> | AuthUserRoles_Insert_Input_;
}>;


export type InsertRemoteAppUserRolesMutation_ = { __typename?: 'mutation_root', insertAuthUserRoles?: { __typename?: 'authUserRoles_mutation_response', affected_rows: number } | null };

export type DeleteRemoteAppUserRolesMutationVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
  roles: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteRemoteAppUserRolesMutation_ = { __typename?: 'mutation_root', deleteAuthUserRoles?: { __typename?: 'authUserRoles_mutation_response', affected_rows: number } | null };

export type GetFinancialsQueryVariables_ = Exact<{
  cId: Scalars['uuid']['input'];
}>;


export type GetFinancialsQuery_ = { __typename?: 'query_root', notEligibleFinancials: Array<{ __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean }>, totalComparisonFinancials: Array<{ __typename?: 'TotalComparisonFinancials', id?: any | null, revenue?: any | null, capex?: any | null, opex?: any | null, adaptationCapex?: any | null, adaptationOpex?: any | null, isEstimate?: boolean | null }>, nonMaterialFinancials: Array<{ __typename?: 'NonMaterialFinancials', id?: any | null, revenue?: any | null, capex?: any | null, opex?: any | null, adaptationCapex?: any | null, adaptationOpex?: any | null, isEstimate?: boolean | null }>, businessUnits: Array<{ __typename?: 'BusinessUnitAssessment', id: any, orderIndex?: any | null, reportingGroupId?: any | null, businessUnit?: { __typename?: 'BusinessUnit', id: any, name: string, labels: any } | null, businessUnitFinancials: Array<{ __typename?: 'ActivityReport', financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null }>, activities: Array<{ __typename?: 'ActivityReport', id: any, bAssessmentId: any, activity: { __typename?: 'Activity', name: string, reference: string }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null }> }> };

export type NonMaterialFinancialsQueryVariables_ = Exact<{
  cAssessmentId: Scalars['uuid']['input'];
}>;


export type NonMaterialFinancialsQuery_ = { __typename?: 'query_root', NonMaterialFinancials: Array<{ __typename?: 'NonMaterialFinancials', id?: any | null, revenue?: any | null, capex?: any | null, opex?: any | null, adaptationCapex?: any | null, adaptationOpex?: any | null, isEstimate?: boolean | null }> };

export type GetFinancialsByIdQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetFinancialsByIdQuery_ = { __typename?: 'query_root', Financials_by_pk?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null };

export type GetActivityReportObjectivesStateFromFinancialsQueryVariables_ = Exact<{
  financialsId: Scalars['uuid']['input'];
}>;


export type GetActivityReportObjectivesStateFromFinancialsQuery_ = { __typename?: 'query_root', ActivityReport: Array<{ __typename?: 'ActivityReport', cachedResult?: { __typename?: 'CachedResult', objectivesState: any, isAligned?: boolean | null } | null }> };

export type UpdateFinancialsByIdMutationVariables_ = Exact<{
  _set: Financials_Set_Input_;
  id: Scalars['uuid']['input'];
}>;


export type UpdateFinancialsByIdMutation_ = { __typename?: 'mutation_root', update_Financials_by_pk?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, cachedResult?: { __typename?: 'CachedResult_mutation_response', returning: Array<{ __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null }> } | null };

export type UpdateFinancialEstimateManyMutationVariables_ = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  isEstimate: Scalars['Boolean']['input'];
}>;


export type UpdateFinancialEstimateManyMutation_ = { __typename?: 'mutation_root', update_Financials_many?: Array<{ __typename?: 'Financials_mutation_response', returning: Array<{ __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean }> } | null> | null, cachedResult?: { __typename?: 'CachedResult_mutation_response', returning: Array<{ __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null }> } | null };

export type UpdateFinancialsMutationVariables_ = Exact<{
  financialsToUpdate: Array<Financials_Insert_Input_> | Financials_Insert_Input_;
  financialsToCreate: Array<Financials_Insert_Input_> | Financials_Insert_Input_;
}>;


export type UpdateFinancialsMutation_ = { __typename?: 'mutation_root', updates?: { __typename?: 'Financials_mutation_response', returning: Array<{ __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean }> } | null, new?: { __typename?: 'Financials_mutation_response', returning: Array<{ __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean }> } | null };

export type TargetDocumentationFragment_ = { __typename?: 'esrs_Target', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null };

export type DisclosureRequirementAttachmentDocumentationFragment_ = { __typename?: 'esrs_DisclosureRequirementAttachment', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null };

export type CompanyAssessmentDetailsFieldsFragment_ = { __typename?: 'CompanyAssessment', id: any, startDate: any, endDate: any, isLocked: boolean, createdAt: any, deletedAt?: any | null, cachedResultId?: any | null, updatedAt: any, aggregate: { __typename?: 'CompanyAssessmentAggregate', id: any, title: string, interval: string, startDate: any, contactPerson?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }, bAssesssments: Array<{ __typename?: 'BusinessUnitAssessment', updatedAt: any, activityReports: Array<{ __typename?: 'ActivityReport', answers: Array<{ __typename?: 'Answer', updatedAt: any }> }>, lastEditedFinancials: Array<{ __typename?: 'ActivityReport', financials?: { __typename?: 'Financials', updatedAt: any } | null }> }>, portfoliosWithAccess: Array<{ __typename?: 'PortfolioCompany', quarter: QuarterEnum_Enum_, year?: number | null, contactPersonName?: string | null, contactPersonEmail?: string | null, portfolio: { __typename?: 'Portfolio', name: string, ownerCompany: { __typename?: 'Company', name: string } } }> };

export type GroupAssessmentFieldsFragment_ = { __typename?: 'GroupAssessment', id: any, name: string, period: any, uploadedAt?: any | null, consolidatedCompanyAssessmentId?: any | null, consolidatedCsvId?: any | null, consolidatedCompanyAssessment?: { __typename?: 'CompanyAssessment', aggregateId: any, isLocked: boolean } | null };

export type GroupAssessmentSubsidiariesFieldsFragment_ = { __typename?: 'Subsidiary', id: any, contactPersonName?: string | null, contactPersonEmail?: string | null, sharedCompanyAssessment?: { __typename?: 'CompanyAssessment', id: any, isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', financials: any, score: any, progress: any } | null } | null, company?: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null, isGroupOwner: boolean } | null };

export type TagGroupFieldsFragment_ = { __typename?: 'TagGroup', id: any, name: string, description?: string | null };

export type TagFieldsFragment_ = { __typename?: 'Tag', id: any, description: string, name: string, tagGroup?: { __typename?: 'TagGroup', id: any, name: string, description?: string | null } | null };

export type ArticleFieldsFragment_ = { __typename?: 'Article', id: any, body: string, title: string, slug?: string | null, isHidden: boolean, order: string, tags: Array<{ __typename?: 'Tag_articles', Tag: { __typename?: 'Tag', id: any, description: string, name: string, tagGroup?: { __typename?: 'TagGroup', id: any, name: string, description?: string | null } | null } }> };

export type InvestorFieldsFragment_ = { __typename?: 'PortfolioCompany', id: any, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, updatedAt: any, contactPersonName?: string | null, contactPersonEmail?: string | null, portfolioId: any, sharedCompanyAssessmentId?: any | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, portfolio: { __typename?: 'Portfolio', name: string, ownerCompany: { __typename?: 'Company', name: string, hasPaiAccess: boolean, logoUrl?: string | null } }, sharedAssessment?: { __typename?: 'CompanyAssessment', id: any, startDate: any, aggregate: { __typename?: 'CompanyAssessmentAggregate', title: string }, cachedResult?: { __typename?: 'CachedResult', progress: any } | null } | null };

export type UserPortfolioCompanyFragment_ = { __typename?: 'PortfolioCompany', id: any, scores?: any | null };

export type UpdateOwnerCompanyFieldsFragment_ = { __typename?: 'Portfolio', ownerCompany: { __typename?: 'Company', id: any, portfolios: Array<{ __typename?: 'Portfolio', name: string }> } };

export type NudgePortfolioCompaniesFieldsFragment_ = { __typename?: 'NudgePortfolioCompaniesOutput', emailsSent: number, error?: string | null };

export type NudgeGroupCompaniesFieldsFragment_ = { __typename?: 'NudgeGroupCompaniesOutput', emailsSent: number, error?: string | null };

export type ObjectiveFieldsFragment_ = { __typename?: 'Objective', title: string, description?: string | null, key: string };

export type CachedResultFieldsFragment_ = { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null };

export type UserFragment_ = { __typename?: 'users', id: any, displayName: string, email?: any | null, createdAt: any, updatedAt: any, metadata?: any | null, avatarUrl: string, locale: string, lastSeen?: any | null };

export type ThreadFieldsFragment_ = { __typename?: 'Thread', id: any, companyId: any, answerId?: any | null, esrsDatapointId?: any | null, comments: Array<{ __typename?: 'Comment', id: any, createdAt: any, updatedAt: any, authorId: any, data: string, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }>, subscribers: Array<{ __typename?: 'ThreadSubscriber', userId: any }>, commentsAggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } };

export type CommentFieldsFragment_ = { __typename?: 'Comment', id: any, createdAt: any, updatedAt: any, authorId: any, data: string, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } };

export type ThreadUpdateFragment_ = { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any }>, commentsAggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } };

export type ReportingGroupFieldsFragment_ = { __typename?: 'ReportingGroup', id: any, name: string, orderIndex: any, parentId?: any | null, updatedAt: any, createdAt: any, businessUnits: Array<{ __typename?: 'BusinessUnitAssessment', orderIndex?: any | null, bAssessmentId: any, businessUnit?: { __typename?: 'BusinessUnit', id: any, createdAt: any, name: string, companyId: any, description?: string | null, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null }>, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null };

export type QuestionSetFieldsFragment_ = { __typename?: 'QuestionSet', reference: string, activityQuestionSets: Array<{ __typename?: 'ActivityQuestionSet', activityRef: string }>, questions: Array<{ __typename?: 'QuestionSetQuestion', question: { __typename?: 'Question', id: any, title: string, questionSetRef?: string | null, description?: string | null, type: QuestionType_Enum_, level: QuestionLevel_Enum_, levelExpression?: string | null, group?: string | null, orderIndex: string, uniqueId: string, unit?: string | null, resourceLink?: string | null, documentationRequired: boolean, aboutDocumentation?: string | null, alignmentErrorMessage?: string | null, isVisible?: string | null, isEditable?: string | null, isRequired?: string | null, isAligned?: string | null, dependencyDescription?: string | null, extendedDescription?: string | null, other?: any | null, learnMoreArticleSlug?: string | null, questionSets: Array<{ __typename?: 'QuestionSetQuestion', questionSet: { __typename?: 'QuestionSet', reference: string } }>, objective: { __typename?: 'Objective', key: string, title: string }, choices: Array<{ __typename?: 'QuestionChoice', value: string, displayName: string, order: string }> } }> };

export type QuestionFieldsFragment_ = { __typename?: 'Question', id: any, title: string, questionSetRef?: string | null, description?: string | null, type: QuestionType_Enum_, level: QuestionLevel_Enum_, levelExpression?: string | null, group?: string | null, orderIndex: string, uniqueId: string, unit?: string | null, resourceLink?: string | null, documentationRequired: boolean, aboutDocumentation?: string | null, alignmentErrorMessage?: string | null, isVisible?: string | null, isEditable?: string | null, isRequired?: string | null, isAligned?: string | null, dependencyDescription?: string | null, extendedDescription?: string | null, other?: any | null, learnMoreArticleSlug?: string | null, questionSets: Array<{ __typename?: 'QuestionSetQuestion', questionSet: { __typename?: 'QuestionSet', reference: string } }>, objective: { __typename?: 'Objective', key: string, title: string }, choices: Array<{ __typename?: 'QuestionChoice', value: string, displayName: string, order: string }> };

export type AnswerFieldsFragment_ = { __typename?: 'Answer', flagged?: boolean | null, id: any, questionId: any, updatedAt: any, createdAt: any, data?: any | null, reportId?: any | null, answeredBy: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string }, question: { __typename?: 'Question', id: any, uniqueId: string }, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, thread?: { __typename?: 'Thread', id: any, commentsAggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null }, comments: Array<{ __typename?: 'Comment', id: any, data: string }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null };

export type ShortAnswerFieldsFragment_ = { __typename?: 'Answer', id: any, questionId: any, updatedAt: any, createdAt: any, data?: any | null, reportId?: any | null, thread?: { __typename?: 'Thread', id: any, commentsAggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null };

export type PortfolioFieldsFragment_ = { __typename?: 'Portfolio', id: any, name: string, description: string, totalAmount: any, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, company?: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean, currency: string, portfolios: Array<{ __typename?: 'Portfolio', id: any, name: string, description: string, totalAmount: any, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, company?: { __typename?: 'Company', currency: string, id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null }>, taxonomyReports: Array<{ __typename?: 'TaxonomyPortfolioReport', year: number, sendOutDate?: any | null, dueDate?: any | null, contactPerson?: { __typename?: 'users', displayName: string } | null }> }> } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null }>, taxonomyReports: Array<{ __typename?: 'TaxonomyPortfolioReport', year: number, quarter: QuarterEnum_Enum_, sendOutDate?: any | null, dueDate?: any | null, contactPerson?: { __typename?: 'users', displayName: string } | null }>, portfolioNonEligibleFinancials: Array<{ __typename?: 'PortfolioNonEligibleFinancials', id: any, value?: any | null, type: InvestmentCategory_Enum_, year?: number | null, quarter: QuarterEnum_Enum_ }> };

export type PortfolioCompanyFragment_ = { __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, company?: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean, currency: string, portfolios: Array<{ __typename?: 'Portfolio', id: any, name: string, description: string, totalAmount: any, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, company?: { __typename?: 'Company', currency: string, id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null }>, taxonomyReports: Array<{ __typename?: 'TaxonomyPortfolioReport', year: number, sendOutDate?: any | null, dueDate?: any | null, contactPerson?: { __typename?: 'users', displayName: string } | null }> }> } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null };

export type PossibleInvestmentFirmFragment_ = { __typename?: 'Company', id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean, currency: string, portfolios: Array<{ __typename?: 'Portfolio', id: any, name: string, description: string, totalAmount: any, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, company?: { __typename?: 'Company', currency: string, id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null }>, taxonomyReports: Array<{ __typename?: 'TaxonomyPortfolioReport', year: number, sendOutDate?: any | null, dueDate?: any | null, contactPerson?: { __typename?: 'users', displayName: string } | null }> }> };

export type EstimateCompanyFieldsFragment_ = { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string };

export type CompanyShortFragment_ = { __typename?: 'Company', id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean };

export type PaiPortfolioReportFieldsFragment_ = { __typename?: 'PaiPortfolioReport', dueDate?: any | null, id: any, reportingPeriod?: any | null, year?: number | null, quarter: QuarterEnum_Enum_, sendOutDates?: any | null, dueDates?: any | null, contactPerson?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, portfolio: { __typename?: 'Portfolio', id: any, name: string }, selectedIndicators: Array<{ __typename?: 'PaiReportIndicator', paiTableIndicatorReference: string, isNew: boolean, periods?: any | null, isForAllCompanies: boolean, indicator: { __typename?: 'PaiTableIndicator', title: string, description?: string | null, reference: string, isHidden: boolean, category: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, table: { __typename?: 'PaiTable', isCustom: boolean, title: string } }, investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', title: string, description?: string | null, reference: string, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null, investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number } }> } }> }, paiReportIndicatorPortfolioCompanies: Array<{ __typename?: 'PaiReportIndicatorPortfolioCompany', portfolioCompanyId: any, portfolioCompany?: { __typename?: 'PortfolioCompany', year?: number | null, company?: { __typename?: 'Company', name: string, id: any } | null } | null }> }> };

export type PaiPortfolioReportFieldsV2Fragment_ = { __typename?: 'PaiPortfolioReport', dueDate?: any | null, id: any, reportingPeriod?: any | null, year?: number | null, quarter: QuarterEnum_Enum_, sendOutDates?: any | null, dueDates?: any | null, contactPerson?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, portfolio: { __typename?: 'Portfolio', id: any, name: string }, selectedIndicators: Array<{ __typename?: 'PaiReportIndicator', paiTableIndicatorReference: string, isNew: boolean, periods?: any | null, isForAllCompanies: boolean, indicator: { __typename?: 'PaiTableIndicator', title: string, description?: string | null, reference: string, isHidden: boolean, order?: string | null, category: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, table: { __typename?: 'PaiTable', isCustom: boolean, title: string, reference: string } }, investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', title: string, description?: string | null, reference: string, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null, investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number } }> } }> }, paiReportIndicatorPortfolioCompanies: Array<{ __typename?: 'PaiReportIndicatorPortfolioCompany', portfolioCompanyId: any, portfolioCompany?: { __typename?: 'PortfolioCompany', year?: number | null, company?: { __typename?: 'Company', name: string, id: any } | null } | null }> }> };

export type PaiTableFieldsFragment_ = { __typename?: 'PaiTable', isMandatory: boolean, title: string, reference: string, subtitle?: string | null, isCustom: boolean, categories: Array<{ __typename?: 'PaiCategory', title: string, subtitle?: string | null, reference: string, indicators: Array<{ __typename?: 'PaiTableIndicator', title: string, description?: string | null, reference: string, isHidden: boolean, category: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, table: { __typename?: 'PaiTable', isCustom: boolean, title: string } }, investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', title: string, description?: string | null, reference: string, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null, investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number } }> } }> }> }> };

export type PaiTableFieldsV2Fragment_ = { __typename?: 'PaiTable', isMandatory: boolean, title: string, reference: string, subtitle?: string | null, isCustom: boolean, categories: Array<{ __typename?: 'PaiCategory', title: string, subtitle?: string | null, reference: string, indicators: Array<{ __typename?: 'PaiTableIndicator', title: string, description?: string | null, reference: string, isHidden: boolean, order?: string | null, category: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, table: { __typename?: 'PaiTable', isCustom: boolean, title: string, reference: string } }, investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', title: string, description?: string | null, reference: string, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null, investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number } }> } }> }> }> };

export type PaiCategoryFieldsFragment_ = { __typename?: 'PaiCategory', title: string, subtitle?: string | null, reference: string, indicators: Array<{ __typename?: 'PaiTableIndicator', title: string, description?: string | null, reference: string, isHidden: boolean, category: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, table: { __typename?: 'PaiTable', isCustom: boolean, title: string } }, investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', title: string, description?: string | null, reference: string, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null, investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number } }> } }> }> };

export type PaiCategoryFieldsV2Fragment_ = { __typename?: 'PaiCategory', title: string, subtitle?: string | null, reference: string, indicators: Array<{ __typename?: 'PaiTableIndicator', title: string, description?: string | null, reference: string, isHidden: boolean, order?: string | null, category: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, table: { __typename?: 'PaiTable', isCustom: boolean, title: string, reference: string } }, investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', title: string, description?: string | null, reference: string, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null, investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number } }> } }> }> };

export type PaiIndicatorFieldsFragment_ = { __typename?: 'PaiTableIndicator', title: string, description?: string | null, reference: string, isHidden: boolean, category: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, table: { __typename?: 'PaiTable', isCustom: boolean, title: string } }, investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', title: string, description?: string | null, reference: string, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null, investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number } }> } }> };

export type PaiIndicatorFieldsV2Fragment_ = { __typename?: 'PaiTableIndicator', title: string, description?: string | null, reference: string, isHidden: boolean, order?: string | null, category: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, table: { __typename?: 'PaiTable', isCustom: boolean, title: string, reference: string } }, investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', title: string, description?: string | null, reference: string, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null, investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number } }> } }> };

export type InvestorMetricFieldsFragment_ = { __typename?: 'InvestorMetric', title: string, description?: string | null, reference: string, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null, investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number } }> };

export type InvesteeMetricFieldsFragment_ = { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number };

export type PaiInvesteeAnswerFieldsFragment_ = { __typename?: 'PaiAnswers', id: any, data?: string | null, answeredById?: any | null, investeeMetricReference: string, answeredBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null };

export type NotificationFieldsFragment_ = { __typename?: 'UserNotification', id: any, createdAt: any, isRead: boolean, comment: { __typename?: 'Comment', id: any, data: string, createdAt: any, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string }, thread: { __typename?: 'Thread', answer?: { __typename?: 'Answer', question: { __typename?: 'Question', uniqueId: string }, activityReport?: { __typename?: 'ActivityReport', activity: { __typename?: 'Activity', reference: string, name: string }, bAssessment: { __typename?: 'BusinessUnitAssessment', id: any, cAssessmentId: any, businessUnit?: { __typename?: 'BusinessUnit', id: any, name: string, company: { __typename?: 'Company', id: any, name: string } } | null, cAssessment: { __typename?: 'CompanyAssessment', aggregate: { __typename?: 'CompanyAssessmentAggregate', title: string } } } } | null, answerCompany?: { __typename?: 'AnswerCompany', company?: { __typename?: 'Company', id: any, name: string } | null } | null } | null, esrsDatapoint?: { __typename?: 'esrs_Datapoint', id: any, answer: { __typename?: 'esrs_Answer', id: any, metricRef: string, metric: { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, requirement: { __typename?: 'DisclosureRequirement', reference: string, type: string, frameworkRef?: string | null, group: { __typename?: 'DisclosureRequirementGroup', standardRef: string } } }, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, reportingYear: number, company: { __typename?: 'Company', id: any, name: string } } } } } | null, esrsDatapointMdrm?: { __typename?: 'esrs_DatapointMdrm', id: any, mdrmRef: string, datapoint: { __typename?: 'esrs_Datapoint', id: any, answer: { __typename?: 'esrs_Answer', id: any, metricRef: string, metric: { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null, type: string, group: { __typename?: 'DisclosureRequirementGroup', standardRef: string } } }, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, reportingYear: number, company: { __typename?: 'Company', id: any, name: string } } } } } } | null } } };

export type ActionDocumentationFragment_ = { __typename?: 'esrs_Actions', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null };

export type MetricAnswerDocumentationFragment_ = { __typename?: 'esrs_Answer', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null };

export type PolicyDocumentationFragment_ = { __typename?: 'esrs_Policy', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null };

export type PaiAnswerDocumentationFragment_ = { __typename?: 'PaiAnswers', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null };

export type FinancialsDocumentationFragment_ = { __typename?: 'Financials', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null };

export type ActivityDocumentationFragment_ = { __typename?: 'ActivityReport', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null };

export type AnswerDocumentationFragment_ = { __typename?: 'Answer', id: any, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null };

export type NoteHistoryFragment_ = { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> };

export type AttachmentBoxFragment_ = { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> };

export type AttachmentFragment_ = { __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } };

export type DocumentationFileDetailsFragment_ = { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null };

export type CompanyDetailsFieldsFragment_ = { __typename?: 'Company', id: any, isPortfolioOwner: boolean, isGroupOwner: boolean, logoUrl?: string | null, name: string, settings: any, currency: string, compassId?: string | null, hasPaiAccess: boolean, hasIFRSAccess?: boolean | null, hasTCFDAccess: boolean, hasESRSOilAndGasAccess: boolean, hasEntitySpecificAccess: boolean, hasCustomQuestionsAccess: boolean, hasTaxonomyAccess: boolean, hasAiAccess: boolean, hasBulkUploadAccess?: boolean | null, hasSASBAccess: boolean, canDownloadEsrsReport: boolean, canDownloadTaxonomyReport: boolean, hasESRSAccess: boolean, hasVSMEAccess: boolean, isReal: boolean, isDemo: boolean, invitations: Array<{ __typename?: 'CompanyInvitation', userEmail: any, status: string, id: any }>, aiConfig?: { __typename?: 'AIConfig', preferredLanguage: string, toneOfVoice?: string | null } | null, subsidiaries: Array<{ __typename?: 'Subsidiary', id: any, ownerGroupAssessment: { __typename?: 'GroupAssessment', company?: { __typename?: 'Company', hasTaxonomyAccess: boolean } | null } }>, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, eligibilityStatus: string, portfolio: { __typename?: 'Portfolio', ownerCompany: { __typename?: 'Company', id: any, hasTaxonomyAccess: boolean } } }>, esrsAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingYear: number, frameworkRef?: string | null, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean, reportingUnitLineage: { __typename?: 'esrs_ReportingUnitLineage', id: any } }> }> };

export type SimpleBusinessUnitFragment_ = { __typename?: 'BusinessUnit', id: any, name: string, labels: any, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string }, cAssessmentIds: Array<{ __typename?: 'BusinessUnitAssessment', cAssessmentId: any, cachedResultId?: any | null }>, deletedCAssessmentIds: Array<{ __typename?: 'BusinessUnitAssessment', cAssessmentId: any }> };

export type AuditLogEntryFieldsFragment_ = { __typename?: 'AuditLogEntry', invocationId: any, timestamp: any, newData?: any | null, oldData?: any | null, operation: string, table: string, schema: string, userId?: any | null, companyId?: any | null, user?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null };

export type CompanyAssessmentFieldsFragment_ = { __typename?: 'CompanyAssessment', id: any, startDate: any, endDate: any, isLocked: boolean, createdAt: any, deletedAt?: any | null, companyId: any, cachedResultId?: any | null, aggregate: { __typename?: 'CompanyAssessmentAggregate', id: any, title: string, interval: string, startDate: any, contactPerson?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, company: { __typename?: 'Company', id: any, name: string } }, bAssessments: Array<{ __typename?: 'BusinessUnitAssessment', id: any, cAssessmentId: any, deletedAt?: any | null, hasGeneralAssessment: boolean, orderIndex?: any | null, businessUnit?: { __typename?: 'BusinessUnit', id: any, createdAt: any, name: string, companyId: any, description?: string | null, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, generalAssessment: Array<{ __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, activityReports: Array<{ __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, reportingGroup?: { __typename?: 'ReportingGroup', id: any } | null }>, deletedBAssessments: Array<{ __typename?: 'BusinessUnitAssessment', id: any, cAssessmentId: any, deletedAt?: any | null, hasGeneralAssessment: boolean, orderIndex?: any | null, businessUnit?: { __typename?: 'BusinessUnit', id: any, createdAt: any, name: string, companyId: any, description?: string | null, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, generalAssessment: Array<{ __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, activityReports: Array<{ __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, reportingGroup?: { __typename?: 'ReportingGroup', id: any } | null }> };

export type BusinessUnitAssessmentFieldsFragment_ = { __typename?: 'BusinessUnitAssessment', id: any, cAssessmentId: any, deletedAt?: any | null, hasGeneralAssessment: boolean, orderIndex?: any | null, businessUnit?: { __typename?: 'BusinessUnit', id: any, createdAt: any, name: string, companyId: any, description?: string | null, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, generalAssessment: Array<{ __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, activityReports: Array<{ __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null }>, reportingGroup?: { __typename?: 'ReportingGroup', id: any } | null };

export type ActivityReportFieldsFragment_ = { __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null };

export type ActivityReportWithoutAnswersFieldsFragment_ = { __typename?: 'ActivityReport', id: any, activityVersionNumber: number, activityVersionConfig?: any | null, bAssessmentId: any, completedAt?: any | null, createdAt: any, activityVersion: { __typename?: 'ActivityVersion', activityRef: string, versionNumber: number, changeDescription: string, tagExpression: string }, activity: { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }, financials?: { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', fileId: any, updatedAt: any }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', updatedAt: any, body?: string | null, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null };

export type FinancialsFieldsFragment_ = { __typename?: 'Financials', id: any, revenue: any, capex: any, opex: any, adaptationCapex: any, adaptationOpex: any, isEstimate: boolean };

export type NonMaterialFinancialsFieldsFragment_ = { __typename?: 'NonMaterialFinancials', id?: any | null, revenue?: any | null, capex?: any | null, opex?: any | null, adaptationCapex?: any | null, adaptationOpex?: any | null, isEstimate?: boolean | null };

export type TotalComparisonFinancialsFieldsFragment_ = { __typename?: 'TotalComparisonFinancials', id?: any | null, revenue?: any | null, capex?: any | null, opex?: any | null, adaptationCapex?: any | null, adaptationOpex?: any | null, isEstimate?: boolean | null };

export type ActivityFieldsFragment_ = { __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> };

export type SectorFieldsFragment_ = { __typename?: 'Sector', reference: string, name: string };

export type BusinessUnitInAssessmentFragment_ = { __typename?: 'BusinessUnit', id: any, createdAt: any, name: string, companyId: any, description?: string | null, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } };

export type CompanyAssessmentAggregateFieldsFragment_ = { __typename?: 'CompanyAssessmentAggregate', id: any, companyId: any, title: string, createdAt: any, cAssessments: Array<{ __typename?: 'CompanyAssessment', id: any, startDate: any, endDate: any, isLocked: boolean }>, contactPerson?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null };

export type ShortUserFragment_ = { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string };

export type TaskFieldsFragment_ = { __typename?: 'Task', id: any, ownerId: any, dueDate?: any | null, status: TaskStatusEnum_Enum_, table: string, taskReference?: string | null };

export type GetCompassPatQueryVariables_ = Exact<{
  userEmail: Scalars['citext']['input'];
}>;


export type GetCompassPatQuery_ = { __typename?: 'query_root', users: Array<{ __typename?: 'users', roles: Array<{ __typename?: 'authUserRoles', role: string }>, companies: Array<{ __typename?: 'CompanyUser', companyId: any }>, compassPAT?: { __typename?: 'CompassPAT', personalAccessToken: any, expiresAt: any } | null }> };

export type GetCompanyIdFromCompassIdQueryVariables_ = Exact<{
  compassId: Scalars['String']['input'];
}>;


export type GetCompanyIdFromCompassIdQuery_ = { __typename?: 'query_root', Company: Array<{ __typename?: 'Company', id: any, name: string }> };

export type StoreCompassPatMutationVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
  pat: Scalars['uuid']['input'];
  expiresAt: Scalars['timestamptz']['input'];
}>;


export type StoreCompassPatMutation_ = { __typename?: 'mutation_root', insert_CompassPAT_one?: { __typename?: 'CompassPAT', userId: any, expiresAt: any } | null };

export type GetUserFromEmailQueryVariables_ = Exact<{
  userEmail: Scalars['citext']['input'];
}>;


export type GetUserFromEmailQuery_ = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, email?: any | null, disabled: boolean }> };

export type RemovePasswordHashMutationVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type RemovePasswordHashMutation_ = { __typename?: 'mutation_root', updateUser?: { __typename?: 'users', id: any, passwordHash?: string | null } | null };

export type PendingInvitationsPerEmailQueryVariables_ = Exact<{
  userEmail: Scalars['citext']['input'];
}>;


export type PendingInvitationsPerEmailQuery_ = { __typename?: 'query_root', invitations: Array<{ __typename?: 'CompanyInvitation', id: any, status: string, companyId: any }> };

export type GetSubsidiaryResultsQueryVariables_ = Exact<{
  gAssessmentId: Scalars['uuid']['input'];
}>;


export type GetSubsidiaryResultsQuery_ = { __typename?: 'query_root', GroupAssessment: Array<{ __typename?: 'GroupAssessment', name: string, period: any, subsidiaries: Array<{ __typename?: 'Subsidiary', id: any, company?: { __typename?: 'Company', name: string, currency: string } | null, sharedCompanyAssessment?: { __typename?: 'CompanyAssessment', id: any, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null, generalBusinessUnitResult: Array<{ __typename?: 'BusinessUnitAssessment', generalAssessmentResults: Array<{ __typename?: 'ActivityReport', bAssessmentId: any, activityVersionNumber: number, activityAssessmentId: any, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null }> }>, businessUnitResults: Array<{ __typename?: 'BusinessUnitAssessment', hasGeneralAssessment: boolean, bAssessmentId: any, businessUnit?: { __typename?: 'BusinessUnit', name: string, id: any } | null, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null, generalAssessmentResults: Array<{ __typename?: 'ActivityReport', bAssessmentId: any, activityVersionNumber: number, activityAssessmentId: any, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null, financials?: { __typename?: 'Financials', adaptationCapex: any, adaptationOpex: any, capex: any, opex: any, revenue: any } | null }>, activityResults: Array<{ __typename?: 'ActivityReport', activityRef: string, activityVersionNumber: number, activityAssessmentId: any, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null, financials?: { __typename?: 'Financials', adaptationCapex: any, adaptationOpex: any, capex: any, opex: any, revenue: any } | null }> }> } | null }> }> };

export type InsertGeneralActivityAssessmentMutationVariables_ = Exact<{
  bAssessmentId: Scalars['uuid']['input'];
  versionNumber: Scalars['Int']['input'];
}>;


export type InsertGeneralActivityAssessmentMutation_ = { __typename?: 'mutation_root', insert_ActivityReport_one?: { __typename?: 'ActivityReport', id: any } | null };

export type ValidateInviteQueryVariables_ = Exact<{
  invitationId: Scalars['uuid']['input'];
}>;


export type ValidateInviteQuery_ = { __typename?: 'query_root', result?: { __typename?: 'CompanyInvitation', id: any, userEmail: any, status: string, companyId: any, inviteToChildCompanies?: boolean | null, company: { __typename?: 'Company', logoUrl?: string | null, name: string }, user?: { __typename?: 'users', displayName: string, email?: any | null } | null } | null };

export type ValidateOrgQueryVariables_ = Exact<{
  orgName: Scalars['String']['input'];
}>;


export type ValidateOrgQuery_ = { __typename?: 'query_root', organization?: { __typename?: 'IdentityProvider', name: string, orgId: string } | null };

export type GetUserWithCompaniesQueryVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type GetUserWithCompaniesQuery_ = { __typename?: 'query_root', user?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string, companies: Array<{ __typename?: 'CompanyUser', company: { __typename?: 'Company', id: any, name: string, hasTaxonomyAccess: boolean, hasPaiAccess: boolean, hasESRSAccess: boolean, investorsWithAccess: Array<{ __typename?: 'PortfolioCompany', investor: { __typename?: 'Portfolio', access: { __typename?: 'Company', hasTaxonomyAccess: boolean, hasPaiAccess: boolean, hasESRSAccess: boolean } } }> } }> } | null };

export type GetGAssessmentUsersQueryVariables_ = Exact<{
  gAssessmentId: Scalars['uuid']['input'];
}>;


export type GetGAssessmentUsersQuery_ = { __typename?: 'query_root', GroupAssessment: Array<{ __typename?: 'GroupAssessment', company?: { __typename?: 'Company', users: Array<{ __typename?: 'CompanyUser', user: { __typename?: 'users', id: any } }> } | null }> };

export type AddUserNotificationMutationVariables_ = Exact<{
  userNotification: Array<UserNotification_Insert_Input_> | UserNotification_Insert_Input_;
}>;


export type AddUserNotificationMutation_ = { __typename?: 'mutation_root', userNotification?: { __typename?: 'UserNotification_mutation_response', returning: Array<{ __typename?: 'UserNotification', id: any }> } | null };

export type GetEsrsAssessmentUserQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetEsrsAssessmentUserQuery_ = { __typename?: 'query_root', esrsAssessment?: { __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', users: Array<{ __typename?: 'CompanyUser', user: { __typename?: 'users', id: any } }> } } | null };

export type GetEsrsAssessmentQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetEsrsAssessmentQuery_ = { __typename?: 'query_root', assessment?: { __typename?: 'EsrsAssessment', id: any, companyId: any, companySize?: string | null, reportingYear: number, parentAssessmentId?: any | null, projectLeaderId?: any | null, onboardingStep?: number | null, frameworkRef?: string | null, company: { __typename?: 'Company', users: Array<{ __typename?: 'CompanyUser', user: { __typename?: 'users', id: any, email?: any | null, displayName: string, avatarUrl: string, disabled: boolean, roles: Array<{ __typename?: 'authUserRoles', role: string }>, invitations: Array<{ __typename?: 'CompanyInvitation', id: any, status: string, companyId: any, shouldAddToSubs?: boolean | null }> } }> } } | null };

export type UpsertCompanyInvitationsMutationVariables_ = Exact<{
  companyInvitations: Array<CompanyInvitation_Insert_Input_> | CompanyInvitation_Insert_Input_;
}>;


export type UpsertCompanyInvitationsMutation_ = { __typename?: 'mutation_root', insert_CompanyInvitation?: { __typename?: 'CompanyInvitation_mutation_response', returning: Array<{ __typename?: 'CompanyInvitation', id: any, status: string, userEmail: any, company: { __typename?: 'Company', id: any, name: string, invitations: Array<{ __typename?: 'CompanyInvitation', id: any }> }, user?: { __typename?: 'users', displayName: string, id: any } | null }> } | null };

export type CompanyQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type CompanyQuery_ = { __typename?: 'query_root', company: Array<{ __typename?: 'Company', id: any, name: string, isGroupOwner: boolean, esrsAssessments: Array<{ __typename?: 'EsrsAssessment', subsidiaryAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, company: { __typename?: 'Company', id: any, name: string } }> }> }> };

export type CompanyInvitationsPerEmailQueryVariables_ = Exact<{
  userEmail: Scalars['citext']['input'];
}>;


export type CompanyInvitationsPerEmailQuery_ = { __typename?: 'query_root', invitations: Array<{ __typename?: 'CompanyInvitation', id: any, userEmail: any, status: string, companyId: any, shouldAddToSubs?: boolean | null }> };

export type GetCompanyNameQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type GetCompanyNameQuery_ = { __typename?: 'query_root', company?: { __typename?: 'Company', name: string } | null };

export type GetCompanyIdQueryVariables_ = Exact<{
  cAssessmentId: Scalars['uuid']['input'];
}>;


export type GetCompanyIdQuery_ = { __typename?: 'query_root', companyAssessment?: { __typename?: 'CompanyAssessment', company: { __typename?: 'Company', id: any } } | null };

export type CreateUserMutationVariables_ = Exact<{
  object: Users_Insert_Input_;
  on_conflict: Users_On_Conflict_;
}>;


export type CreateUserMutation_ = { __typename?: 'mutation_root', insertUser?: { __typename?: 'users', id: any } | null };

export type PortfoliosWithScoresQueryVariables_ = Exact<{
  companyId?: InputMaybe<Scalars['uuid']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
  reportPeriod?: InputMaybe<ReportPeriod_>;
}>;


export type PortfoliosWithScoresQuery_ = { __typename?: 'query_root', results?: { __typename?: 'SampleOutput', portfolios?: Array<{ __typename?: 'Portfolios', name?: string | null, description?: string | null, portfolioProgress?: { __typename?: 'PortfolioProgress', financials?: number | null, screening?: number | null, markedAsCompleted?: boolean | null } | null, portfolioScore?: { __typename?: 'PortfolioScore', revenue?: { __typename?: 'Revenue', aligned?: number | null, eligible?: number | null, inProgress?: number | null, enabling?: number | null, transitional?: number | null } | null, capex?: { __typename?: 'Capex', aligned?: number | null, eligible?: number | null, inProgress?: number | null, enabling?: number | null, transitional?: number | null } | null, opex?: { __typename?: 'Opex', aligned?: number | null, eligible?: number | null, inProgress?: number | null, enabling?: number | null, transitional?: number | null } | null } | null, portfolioSubstantialContributionProportion?: { __typename?: 'SubstantialContributionProportion', mitigation?: { __typename?: 'Proportion', revenue?: number | null, capex?: number | null, opex?: number | null } | null, adaptation?: { __typename?: 'Proportion', revenue?: number | null, capex?: number | null, opex?: number | null } | null, biodiversity?: { __typename?: 'Proportion', revenue?: number | null, capex?: number | null, opex?: number | null } | null, circular?: { __typename?: 'Proportion', revenue?: number | null, capex?: number | null, opex?: number | null } | null, pollution?: { __typename?: 'Proportion', revenue?: number | null, capex?: number | null, opex?: number | null } | null, water?: { __typename?: 'Proportion', revenue?: number | null, capex?: number | null, opex?: number | null } | null } | null, portfolioCompanies?: Array<{ __typename?: 'PortfolioCompanies', name?: string | null, amount?: number | null, progress?: { __typename?: 'Progress', financials?: number | null, screening?: number | null, markedAsCompleted?: boolean | null } | null, score?: { __typename?: 'Scores', revenue?: { __typename?: 'Revenue', aligned?: number | null, eligible?: number | null, inProgress?: number | null, enabling?: number | null, transitional?: number | null } | null, capex?: { __typename?: 'Capex', aligned?: number | null, eligible?: number | null, inProgress?: number | null, enabling?: number | null, transitional?: number | null } | null, opex?: { __typename?: 'Opex', aligned?: number | null, eligible?: number | null, inProgress?: number | null, enabling?: number | null, transitional?: number | null } | null } | null, substantialContributionProportion?: { __typename?: 'SubstantialContributionProportion', mitigation?: { __typename?: 'Proportion', revenue?: number | null, capex?: number | null, opex?: number | null } | null, adaptation?: { __typename?: 'Proportion', revenue?: number | null, capex?: number | null, opex?: number | null } | null, biodiversity?: { __typename?: 'Proportion', revenue?: number | null, capex?: number | null, opex?: number | null } | null, circular?: { __typename?: 'Proportion', revenue?: number | null, capex?: number | null, opex?: number | null } | null, pollution?: { __typename?: 'Proportion', revenue?: number | null, capex?: number | null, opex?: number | null } | null, water?: { __typename?: 'Proportion', revenue?: number | null, capex?: number | null, opex?: number | null } | null } | null } | null> | null } | null> | null } | null };

export type UpdateActivityFinancialsMutationVariables_ = Exact<{
  activityReportId: Scalars['uuid']['input'];
  capex?: InputMaybe<Scalars['float8']['input']>;
  opex?: InputMaybe<Scalars['float8']['input']>;
  revenue?: InputMaybe<Scalars['float8']['input']>;
  adaptationCapex?: InputMaybe<Scalars['float8']['input']>;
  adaptationOpex?: InputMaybe<Scalars['float8']['input']>;
}>;


export type UpdateActivityFinancialsMutation_ = { __typename?: 'mutation_root', update_Financials?: { __typename?: 'Financials_mutation_response', affected_rows: number } | null };

export type UpdateTaxonomyFinancialsMutationVariables_ = Exact<{
  adaptationCapex?: InputMaybe<Scalars['float8']['input']>;
  adaptationOpex?: InputMaybe<Scalars['float8']['input']>;
  capex?: InputMaybe<Scalars['float8']['input']>;
  opex?: InputMaybe<Scalars['float8']['input']>;
  revenue?: InputMaybe<Scalars['float8']['input']>;
  activityReportId: Scalars['uuid']['input'];
}>;


export type UpdateTaxonomyFinancialsMutation_ = { __typename?: 'mutation_root', updateActivityFinancials?: { __typename?: 'UpdateFinancialsOutput', id: string } | null };

export type CompanyAssessmentCachedResultsQueryQueryVariables_ = Exact<{
  cAssessmentId: Scalars['uuid']['input'];
}>;


export type CompanyAssessmentCachedResultsQueryQuery_ = { __typename?: 'query_root', companyResults?: { __typename?: 'CompanyAssessment', aggregateId: any, endDate: any, startDate: any, companyId: any, companyAssessmentId: any, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null, generalBusinessUnitResult: Array<{ __typename?: 'BusinessUnitAssessment', generalAssessmentResults: Array<{ __typename?: 'ActivityReport', activityVersionNumber: number, bAssessmentId: any, activityAssessmentId: any, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null }> }>, businessUnitResults: Array<{ __typename?: 'BusinessUnitAssessment', hasGeneralAssessment: boolean, bAssessmentId: any, businessUnit?: { __typename?: 'BusinessUnit', name: string, id: any } | null, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null, generalAssessmentResults: Array<{ __typename?: 'ActivityReport', activityVersionNumber: number, bAssessmentId: any, activityAssessmentId: any, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null }>, activityResults: Array<{ __typename?: 'ActivityReport', activityVersionNumber: number, activityRef: string, activityAssessmentId: any, financials?: { __typename?: 'Financials', id: any } | null, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null }> }> } | null };

export type TaxonomyAssessmentFinancialsQueryVariables_ = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type TaxonomyAssessmentFinancialsQuery_ = { __typename?: 'query_root', taxonomyAssessment: Array<{ __typename?: 'CompanyAssessment', id: any, bAssesssments: Array<{ __typename?: 'BusinessUnitAssessment', activityReports: Array<{ __typename?: 'ActivityReport', activityRef: string, financials?: { __typename?: 'Financials', adaptationCapex: any, adaptationOpex: any, capex: any, id: any, opex: any, revenue: any, reportId?: any | null, cAssessmentId?: any | null } | null }> }> }> };

export type TaxonomyAssessmentsQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TaxonomyAssessmentsQuery_ = { __typename?: 'query_root', taxonomyAssessment: Array<{ __typename?: 'CompanyAssessment', id: any, startDate: any, metaData: { __typename?: 'CompanyAssessmentAggregate', title: string }, bAssesssments: Array<{ __typename?: 'BusinessUnitAssessment', id: any, businessUnit?: { __typename?: 'BusinessUnit', name: string } | null, activityReports: Array<{ __typename?: 'ActivityReport', activityRef: string, id: any, activity: { __typename?: 'Activity', name: string } }> }> }> };

export type TaxonomyAssessmentScoresQueryVariables_ = Exact<{
  id?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type TaxonomyAssessmentScoresQuery_ = { __typename?: 'query_root', taxonomyAssessment: Array<{ __typename?: 'CompanyAssessment', id: any, cachedResult?: { __typename?: 'CachedResult', isCompleted: boolean, isDirty?: boolean | null, score: any, financials: any } | null }> };

export type CompaniesQueryVariables_ = Exact<{ [key: string]: never; }>;


export type CompaniesQuery_ = { __typename?: 'query_root', Company: Array<{ __typename?: 'Company', id: any, name: string }> };

export type GetOldActivityReportFinancialDataQueryVariables_ = Exact<{
  activityReportId: Scalars['uuid']['input'];
}>;


export type GetOldActivityReportFinancialDataQuery_ = { __typename?: 'query_root', ActivityReport_by_pk?: { __typename?: 'ActivityReport', bAssessment: { __typename?: 'BusinessUnitAssessment', id: any, cAssessmentId: any, activityReports: Array<{ __typename?: 'ActivityReport', financials?: { __typename?: 'Financials', adaptationCapex: any, adaptationOpex: any, capex: any, opex: any, revenue: any, reportId?: any | null } | null }>, cAssessment: { __typename?: 'CompanyAssessment', bAssesssments: Array<{ __typename?: 'BusinessUnitAssessment', activityReports: Array<{ __typename?: 'ActivityReport', financials?: { __typename?: 'Financials', adaptationCapex: any, adaptationOpex: any, capex: any, revenue: any, opex: any, reportId?: any | null } | null }> }> } }, financials?: { __typename?: 'Financials', adaptationCapex: any, adaptationOpex: any, revenue: any, opex: any, capex: any } | null } | null };

export type ActivityReportAnswersQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ActivityReportAnswersQuery_ = { __typename?: 'query_root', ActivityReport_by_pk?: { __typename?: 'ActivityReport', activity: { __typename?: 'Activity', name: string }, answers: Array<{ __typename?: 'Answer', data?: any | null, question: { __typename?: 'Question', title: string, choices: Array<{ __typename?: 'QuestionChoice', displayName: string, value: string }> } }> } | null };

export type UserInvitationsQueryVariables_ = Exact<{
  status: Scalars['String']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type UserInvitationsQuery_ = { __typename?: 'query_root', invitations: Array<{ __typename?: 'CompanyInvitation', id: any, status: string, role: UserRole_Enum_ }> };

export type AcceptAllCompanyInvitationsMutationVariables_ = Exact<{
  companyUsers: Array<CompanyUser_Insert_Input_> | CompanyUser_Insert_Input_;
  invitations: Array<CompanyInvitation_Insert_Input_> | CompanyInvitation_Insert_Input_;
}>;


export type AcceptAllCompanyInvitationsMutation_ = { __typename?: 'mutation_root', joinedCompanies?: { __typename?: 'CompanyUser_mutation_response', returning: Array<{ __typename?: 'CompanyUser', id: any, role: UserRole_Enum_, userId: any, companyId: any, user: { __typename?: 'users', id: any, companyUsers: Array<{ __typename?: 'CompanyUser', id: any, companyId: any }> }, company: { __typename?: 'Company', id: any, isPortfolioOwner: boolean, isGroupOwner: boolean, logoUrl?: string | null, name: string, settings: any, currency: string, compassId?: string | null, hasPaiAccess: boolean, hasIFRSAccess?: boolean | null, hasTCFDAccess: boolean, hasESRSOilAndGasAccess: boolean, hasEntitySpecificAccess: boolean, hasCustomQuestionsAccess: boolean, hasTaxonomyAccess: boolean, hasAiAccess: boolean, hasBulkUploadAccess?: boolean | null, hasSASBAccess: boolean, canDownloadEsrsReport: boolean, canDownloadTaxonomyReport: boolean, hasESRSAccess: boolean, hasVSMEAccess: boolean, isReal: boolean, isDemo: boolean, invitations: Array<{ __typename?: 'CompanyInvitation', userEmail: any, status: string, id: any }>, aiConfig?: { __typename?: 'AIConfig', preferredLanguage: string, toneOfVoice?: string | null } | null, subsidiaries: Array<{ __typename?: 'Subsidiary', id: any, ownerGroupAssessment: { __typename?: 'GroupAssessment', company?: { __typename?: 'Company', hasTaxonomyAccess: boolean } | null } }>, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, eligibilityStatus: string, portfolio: { __typename?: 'Portfolio', ownerCompany: { __typename?: 'Company', id: any, hasTaxonomyAccess: boolean } } }>, esrsAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingYear: number, frameworkRef?: string | null, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean, reportingUnitLineage: { __typename?: 'esrs_ReportingUnitLineage', id: any } }> }> } }> } | null, acceptedInvitations?: { __typename?: 'CompanyInvitation_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'CompanyInvitation', id: any, status: string, role: UserRole_Enum_ }> } | null };

export type UpsertCompanyInvitationMutationVariables_ = Exact<{
  companyInvitation: CompanyInvitation_Insert_Input_;
}>;


export type UpsertCompanyInvitationMutation_ = { __typename?: 'mutation_root', insert_CompanyInvitation_one?: { __typename?: 'CompanyInvitation', id: any, status: string, userEmail: any, role: UserRole_Enum_, company: { __typename?: 'Company', id: any, name: string, invitations: Array<{ __typename?: 'CompanyInvitation', id: any }> }, user?: { __typename?: 'users', displayName: string, id: any } | null } | null };

export type UpdateCompanyInvitationMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  companyInvitation: CompanyInvitation_Set_Input_;
}>;


export type UpdateCompanyInvitationMutation_ = { __typename?: 'mutation_root', update_CompanyInvitation_by_pk?: { __typename?: 'CompanyInvitation', id: any, status: string, role: UserRole_Enum_ } | null };

export type GetInvitationQueryVariables_ = Exact<{
  data: InvitationQuery_;
}>;


export type GetInvitationQuery_ = { __typename?: 'query_root', invitation?: { __typename?: 'InvitationOutput', id: any, userEmail: string, status: string, userExists: boolean, inviteToChildCompanies: boolean, companyId: any, companyName: string, companyLogoUrl?: string | null } | null };

export type InvitationsSubscriptionVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type InvitationsSubscription_ = { __typename?: 'subscription_root', invitations: Array<{ __typename?: 'CompanyInvitation', id: any, status: string }> };

export type ArticleByIdQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ArticleByIdQuery_ = { __typename?: 'query_root', article?: { __typename?: 'Article', id: any, body: string, title: string, slug?: string | null, isHidden: boolean, order: string, tags: Array<{ __typename?: 'Tag_articles', Tag: { __typename?: 'Tag', id: any, description: string, name: string, tagGroup?: { __typename?: 'TagGroup', id: any, name: string, description?: string | null } | null } }> } | null };

export type ArticlesBySlugQueryVariables_ = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ArticlesBySlugQuery_ = { __typename?: 'query_root', articles: Array<{ __typename?: 'Article', id: any, body: string, title: string, slug?: string | null, isHidden: boolean, order: string, tags: Array<{ __typename?: 'Tag_articles', Tag: { __typename?: 'Tag', id: any, description: string, name: string, tagGroup?: { __typename?: 'TagGroup', id: any, name: string, description?: string | null } | null } }> }> };

export type TagByIdQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type TagByIdQuery_ = { __typename?: 'query_root', tag?: { __typename?: 'Tag', id: any, description: string, name: string, tagGroup?: { __typename?: 'TagGroup', id: any, name: string, description?: string | null } | null } | null };

export type ArticlesByTagIdQueryVariables_ = Exact<{
  tagId: Scalars['uuid']['input'];
}>;


export type ArticlesByTagIdQuery_ = { __typename?: 'query_root', articles: Array<{ __typename?: 'Tag_articles', article_id: any }> };

export type TagsByArticleIdQueryVariables_ = Exact<{
  articleId: Scalars['uuid']['input'];
}>;


export type TagsByArticleIdQuery_ = { __typename?: 'query_root', tags: Array<{ __typename?: 'Tag_articles', tag_id: any }> };

export type ArticlesQueryVariables_ = Exact<{ [key: string]: never; }>;


export type ArticlesQuery_ = { __typename?: 'query_root', Article: Array<{ __typename?: 'Article', id: any, body: string, title: string, slug?: string | null, isHidden: boolean, order: string, tags: Array<{ __typename?: 'Tag_articles', Tag: { __typename?: 'Tag', id: any, description: string, name: string, tagGroup?: { __typename?: 'TagGroup', id: any, name: string, description?: string | null } | null } }> }> };

export type TagsQueryVariables_ = Exact<{ [key: string]: never; }>;


export type TagsQuery_ = { __typename?: 'query_root', Tag: Array<{ __typename?: 'Tag', id: any, description: string, name: string, tagGroup?: { __typename?: 'TagGroup', id: any, name: string, description?: string | null } | null }> };

export type ArticleBodySearchQueryVariables_ = Exact<{
  q: Scalars['String']['input'];
}>;


export type ArticleBodySearchQuery_ = { __typename?: 'query_root', Article: Array<{ __typename?: 'Article', id: any, body: string, title: string, slug?: string | null, isHidden: boolean, order: string, tags: Array<{ __typename?: 'Tag_articles', Tag: { __typename?: 'Tag', id: any, description: string, name: string, tagGroup?: { __typename?: 'TagGroup', id: any, name: string, description?: string | null } | null } }> }> };

export type ArticleTitleSearchQueryVariables_ = Exact<{
  q: Scalars['String']['input'];
}>;


export type ArticleTitleSearchQuery_ = { __typename?: 'query_root', Article: Array<{ __typename?: 'Article', id: any, body: string, title: string, slug?: string | null, isHidden: boolean, order: string, tags: Array<{ __typename?: 'Tag_articles', Tag: { __typename?: 'Tag', id: any, description: string, name: string, tagGroup?: { __typename?: 'TagGroup', id: any, name: string, description?: string | null } | null } }> }> };

export type TagGroupsQueryVariables_ = Exact<{ [key: string]: never; }>;


export type TagGroupsQuery_ = { __typename?: 'query_root', TagGroup: Array<{ __typename?: 'TagGroup', id: any, name: string, description?: string | null }> };

export type TagsWithArticlesQueryVariables_ = Exact<{ [key: string]: never; }>;


export type TagsWithArticlesQuery_ = { __typename?: 'query_root', Tag: Array<{ __typename?: 'Tag', id: any, description: string, name: string, articles: Array<{ __typename?: 'Tag_articles', Article: { __typename?: 'Article', id: any, body: string, title: string, slug?: string | null, isHidden: boolean, order: string, tags: Array<{ __typename?: 'Tag_articles', Tag: { __typename?: 'Tag', id: any, description: string, name: string, tagGroup?: { __typename?: 'TagGroup', id: any, name: string, description?: string | null } | null } }> } }>, tagGroup?: { __typename?: 'TagGroup', id: any, name: string, description?: string | null } | null }> };

export type ReadUserNotificationsMutationVariables_ = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  isRead: Scalars['Boolean']['input'];
}>;


export type ReadUserNotificationsMutation_ = { __typename?: 'mutation_root', update_UserNotification_many?: Array<{ __typename?: 'UserNotification_mutation_response', returning: Array<{ __typename?: 'UserNotification', id: any, isRead: boolean }> } | null> | null };

export type NotificationsSubscriptionVariables_ = Exact<{ [key: string]: never; }>;


export type NotificationsSubscription_ = { __typename?: 'subscription_root', notifications: Array<{ __typename?: 'UserNotification', id: any, createdAt: any, isRead: boolean, comment: { __typename?: 'Comment', id: any, data: string, createdAt: any, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string }, thread: { __typename?: 'Thread', answer?: { __typename?: 'Answer', question: { __typename?: 'Question', uniqueId: string }, activityReport?: { __typename?: 'ActivityReport', activity: { __typename?: 'Activity', reference: string, name: string }, bAssessment: { __typename?: 'BusinessUnitAssessment', id: any, cAssessmentId: any, businessUnit?: { __typename?: 'BusinessUnit', id: any, name: string, company: { __typename?: 'Company', id: any, name: string } } | null, cAssessment: { __typename?: 'CompanyAssessment', aggregate: { __typename?: 'CompanyAssessmentAggregate', title: string } } } } | null, answerCompany?: { __typename?: 'AnswerCompany', company?: { __typename?: 'Company', id: any, name: string } | null } | null } | null, esrsDatapoint?: { __typename?: 'esrs_Datapoint', id: any, answer: { __typename?: 'esrs_Answer', id: any, metricRef: string, metric: { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, requirement: { __typename?: 'DisclosureRequirement', reference: string, type: string, frameworkRef?: string | null, group: { __typename?: 'DisclosureRequirementGroup', standardRef: string } } }, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, reportingYear: number, company: { __typename?: 'Company', id: any, name: string } } } } } | null, esrsDatapointMdrm?: { __typename?: 'esrs_DatapointMdrm', id: any, mdrmRef: string, datapoint: { __typename?: 'esrs_Datapoint', id: any, answer: { __typename?: 'esrs_Answer', id: any, metricRef: string, metric: { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, requirement: { __typename?: 'DisclosureRequirement', reference: string, frameworkRef?: string | null, type: string, group: { __typename?: 'DisclosureRequirementGroup', standardRef: string } } }, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string, isCompanyLevel: boolean, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, reportingYear: number, company: { __typename?: 'Company', id: any, name: string } } } } } } | null } } }> };

export type UnreadUnsentUserNotificationsQueryVariables_ = Exact<{
  sentEmailsNotificationIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type UnreadUnsentUserNotificationsQuery_ = { __typename?: 'query_root', UserNotifications: Array<{ __typename?: 'UserNotification', id: any, createdAt: any, user: { __typename?: 'users', id: any, createdAt: any, displayName: string, email?: any | null, metadata?: any | null }, comment: { __typename?: 'Comment', data: string, createdAt: any, author: { __typename?: 'users', displayName: string, avatarUrl: string }, thread: { __typename?: 'Thread', company: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null }, answer?: { __typename?: 'Answer', question: { __typename?: 'Question', title: string }, activityReport?: { __typename?: 'ActivityReport', bAssessment: { __typename?: 'BusinessUnitAssessment', businessUnit?: { __typename?: 'BusinessUnit', id: any, name: string } | null, cAssessment: { __typename?: 'CompanyAssessment', id: any, aggregate: { __typename?: 'CompanyAssessmentAggregate', title: string }, company: { __typename?: 'Company', id: any, name: string } } }, activity: { __typename?: 'Activity', name: string } } | null } | null, esrsDatapoint?: { __typename?: 'esrs_Datapoint', answer: { __typename?: 'esrs_Answer', metric: { __typename?: 'EsrsMetric', title: string, shortTitle?: string | null, requirement: { __typename?: 'DisclosureRequirement', title: string, reference: string } }, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, reportingYear: number, company: { __typename?: 'Company', id: any, name: string } } } } | null, esrsDatapointMdrm?: { __typename?: 'esrs_DatapointMdrm', mdrmRef: string, datapoint: { __typename?: 'esrs_Datapoint', answer: { __typename?: 'esrs_Answer', metric: { __typename?: 'EsrsMetric', shortTitle?: string | null, title: string, requirement: { __typename?: 'DisclosureRequirement', title: string, reference: string } }, esrsAssessment: { __typename?: 'EsrsAssessment', id: any, reportingYear: number, company: { __typename?: 'Company', id: any, name: string } } } } } | null } } }>, UserNotification_aggregate: { __typename?: 'UserNotification_aggregate', aggregate?: { __typename?: 'UserNotification_aggregate_fields', count: number } | null } };

export type UpsertUserNotificationEmailsSentMutationVariables_ = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpsertUserNotificationEmailsSentMutation_ = { __typename?: 'mutation_root', update_UserNotification_many?: Array<{ __typename?: 'UserNotification_mutation_response', returning: Array<{ __typename?: 'UserNotification', id: any, emailSentAt?: any | null }> } | null> | null };

export type GetMaintainanceStatusSubscriptionVariables_ = Exact<{ [key: string]: never; }>;


export type GetMaintainanceStatusSubscription_ = { __typename?: 'subscription_root', AppConfig_by_pk?: { __typename?: 'AppConfig', mergeInProgress: boolean } | null };

export type PaiReportRequestsQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type PaiReportRequestsQuery_ = { __typename?: 'query_root', paiReportRequests: Array<{ __typename?: 'PaiPortfolioReport', id: any, dueDates?: any | null, sendOutDates?: any | null, year?: number | null, updatedAt: any, portfolio: { __typename?: 'Portfolio', id: any, name: string, ownerCompany: { __typename?: 'Company', name: string }, companyMemberships: Array<{ __typename?: 'PortfolioCompany', year?: number | null, valueOfInvestments?: any | null, sharedPaiCompanyReportId?: any | null, sharedPaiCompanyReportQ1Id?: any | null, sharedPaiCompanyReportQ2Id?: any | null, sharedPaiCompanyReportQ3Id?: any | null, sharedPaiCompanyReportQ4Id?: any | null }> }, selectedIndicators: Array<{ __typename?: 'PaiReportIndicator', isForAllCompanies: boolean, periods?: any | null, isNew: boolean, indicator: { __typename?: 'PaiTableIndicator', title: string, description?: string | null, reference: string, isHidden: boolean, category: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, table: { __typename?: 'PaiTable', isCustom: boolean, title: string } }, investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', title: string, description?: string | null, reference: string, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null, investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number } }> } }> }, paiReportIndicatorPortfolioCompanies: Array<{ __typename?: 'PaiReportIndicatorPortfolioCompany', portfolioCompany?: { __typename?: 'PortfolioCompany', companyId?: any | null } | null }> }> }> };

export type PaiReportRequestsV2QueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type PaiReportRequestsV2Query_ = { __typename?: 'query_root', paiReportRequests: Array<{ __typename?: 'PaiPortfolioReport', id: any, dueDates?: any | null, sendOutDates?: any | null, year?: number | null, updatedAt: any, portfolio: { __typename?: 'Portfolio', id: any, name: string, ownerCompany: { __typename?: 'Company', name: string }, companyMemberships: Array<{ __typename?: 'PortfolioCompany', year?: number | null, valueOfInvestments?: any | null, sharedPaiCompanyReportId?: any | null, sharedPaiCompanyReportQ1Id?: any | null, sharedPaiCompanyReportQ2Id?: any | null, sharedPaiCompanyReportQ3Id?: any | null, sharedPaiCompanyReportQ4Id?: any | null }> }, selectedIndicators: Array<{ __typename?: 'PaiReportIndicator', isForAllCompanies: boolean, periods?: any | null, isNew: boolean, indicator: { __typename?: 'PaiTableIndicator', title: string, description?: string | null, reference: string, isHidden: boolean, order?: string | null, category: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, table: { __typename?: 'PaiTable', isCustom: boolean, title: string, reference: string } }, investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', title: string, description?: string | null, reference: string, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null, investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number } }> } }> }, paiReportIndicatorPortfolioCompanies: Array<{ __typename?: 'PaiReportIndicatorPortfolioCompany', portfolioCompany?: { __typename?: 'PortfolioCompany', companyId?: any | null } | null }> }> }> };

export type HasPaiRequestsSubscriptionVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type HasPaiRequestsSubscription_ = { __typename?: 'subscription_root', paiReportRequests: Array<{ __typename?: 'PaiPortfolioReport', id: any, portfolio: { __typename?: 'Portfolio', id: any, name: string, ownerCompany: { __typename?: 'Company', name: string } } }> };

export type PaiCompanyReportsQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type PaiCompanyReportsQuery_ = { __typename?: 'query_root', paiCompanyReports: Array<{ __typename?: 'PaiCompanyReport', id: any, reportingPeriod?: any | null, contactPersonId?: any | null, year?: number | null, period: string, updatedAt?: any | null, lastEditedAnswer: Array<{ __typename?: 'PaiAnswers', updatedAt?: any | null }> }> };

export type PortfoliosWithAccessToReportQueryVariables_ = Exact<{
  reportId: Scalars['uuid']['input'];
  companyId: Scalars['uuid']['input'];
  year: Scalars['Int']['input'];
}>;


export type PortfoliosWithAccessToReportQuery_ = { __typename?: 'query_root', Portfolio: Array<{ __typename?: 'Portfolio', name: string, id: any, ownerCompany: { __typename?: 'Company', name: string }, companies: Array<{ __typename?: 'PortfolioCompany', id: any, sharedPaiCompanyReportId?: any | null, sharedPaiCompanyReportQ1Id?: any | null, sharedPaiCompanyReportQ2Id?: any | null, sharedPaiCompanyReportQ3Id?: any | null, sharedPaiCompanyReportQ4Id?: any | null }> }> };

export type ReportInsightsSubscriptionVariables_ = Exact<{
  reportId: Scalars['uuid']['input'];
}>;


export type ReportInsightsSubscription_ = { __typename?: 'subscription_root', insights: Array<{ __typename?: 'PaiMetricInsight', investeeMetricRef: string, insight: { __typename?: 'DocumentInsight', insight?: any | null, extractionJob: { __typename?: 'ExtractionJob', documentationFile: { __typename?: 'DocumentationFile', id: any, storageFile?: { __typename?: 'files', name?: string | null } | null } } } }> };

export type AttachPaiDocumentMutationVariables_ = Exact<{
  documentId: Scalars['uuid']['input'];
  paiAnswerId: Scalars['uuid']['input'];
}>;


export type AttachPaiDocumentMutation_ = { __typename?: 'mutation_root', insert_Attachment?: { __typename?: 'Attachment_mutation_response', returning: Array<{ __typename?: 'Attachment', attachmentBox: { __typename?: 'AttachmentBox', paiAnswerId?: any | null }, file: { __typename?: 'DocumentationFile', id: any } }> } | null };

export type AllPaiReportAnswersSubscriptionVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type AllPaiReportAnswersSubscription_ = { __typename?: 'subscription_root', reportAnswers: Array<{ __typename?: 'PaiCompanyReport', id: any, reportingPeriod?: any | null, year?: number | null, period: string, answers: Array<{ __typename?: 'PaiAnswers', id: any, data?: string | null, investeeMetricReference: string, metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, methodology?: string | null, type: QuestionType_Enum_, reference: string, investorMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvestorMetric', indicators: Array<{ __typename?: 'IndicatorToInvestorMetric', reference: string }> } }> } }> }> };

export type UpsertPaiCompanyReportMutationVariables_ = Exact<{
  input: PaiCompanyReport_Insert_Input_;
}>;


export type UpsertPaiCompanyReportMutation_ = { __typename?: 'mutation_root', insert_PaiCompanyReport_one?: { __typename?: 'PaiCompanyReport', id: any, contactPersonId?: any | null, reportingPeriod?: any | null } | null };

export type InsertInitialPaiAnswerForDocumentationMutationVariables_ = Exact<{
  input: PaiAnswers_Insert_Input_;
}>;


export type InsertInitialPaiAnswerForDocumentationMutation_ = { __typename?: 'mutation_root', insert_PaiAnswers_one?: { __typename?: 'PaiAnswers', id: any, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null } | null };

export type UpsertPaiAnswerMutationVariables_ = Exact<{
  input: PaiAnswers_Insert_Input_;
}>;


export type UpsertPaiAnswerMutation_ = { __typename?: 'mutation_root', insert_PaiAnswers_one?: { __typename?: 'PaiAnswers', id: any, data?: string | null, answeredById?: any | null, investeeMetricReference: string, answeredBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null };

export type UpsertPaiAnswersMutationVariables_ = Exact<{
  answers: Array<PaiAnswers_Insert_Input_> | PaiAnswers_Insert_Input_;
}>;


export type UpsertPaiAnswersMutation_ = { __typename?: 'mutation_root', insert_PaiAnswers?: { __typename?: 'PaiAnswers_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'PaiAnswers', id: any, data?: string | null, answeredById?: any | null, investeeMetricReference: string, answeredBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }> } | null };

export type GetPaiAnswerSubscriptionVariables_ = Exact<{
  paiReportId: Scalars['uuid']['input'];
  investeeMetricRef: Scalars['String']['input'];
}>;


export type GetPaiAnswerSubscription_ = { __typename?: 'subscription_root', answers: Array<{ __typename?: 'PaiAnswers', id: any, data?: string | null, answeredById?: any | null, investeeMetricReference: string, answeredBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }> };

export type GetPaiIndicatorAnswersSubscriptionVariables_ = Exact<{
  paiReportId: Scalars['uuid']['input'];
  indicatorRef: Scalars['String']['input'];
}>;


export type GetPaiIndicatorAnswersSubscription_ = { __typename?: 'subscription_root', answers: Array<{ __typename?: 'PaiAnswers', id: any, data?: string | null, answeredById?: any | null, investeeMetricReference: string, metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, methodology?: string | null, type: QuestionType_Enum_, reference: string, investorMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvestorMetric', indicators: Array<{ __typename?: 'IndicatorToInvestorMetric', reference: string }> } }> }, answeredBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }> };

export type GetJobProgressSubscriptionVariables_ = Exact<{
  jobId: Scalars['uuid']['input'];
}>;


export type GetJobProgressSubscription_ = { __typename?: 'subscription_root', ExtractionJob_by_pk?: { __typename?: 'ExtractionJob', progress: number, insights_aggregate: { __typename?: 'DocumentInsight_aggregate', aggregate?: { __typename?: 'DocumentInsight_aggregate_fields', count: number } | null } } | null };

export type GetPaiCategoryAnswersSubscriptionVariables_ = Exact<{
  paiReportId: Scalars['uuid']['input'];
  categoryRef: Scalars['String']['input'];
}>;


export type GetPaiCategoryAnswersSubscription_ = { __typename?: 'subscription_root', answers: Array<{ __typename?: 'PaiAnswers', id: any, metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, methodology?: string | null, type: QuestionType_Enum_, reference: string, investorMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvestorMetric', indicators: Array<{ __typename?: 'IndicatorToInvestorMetric', reference: string }> } }> } }> };

export type PaiBulkAnswersQueryVariables_ = Exact<{
  companyIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  year: Scalars['Int']['input'];
}>;


export type PaiBulkAnswersQuery_ = { __typename?: 'query_root', yearlyMetrics: Array<{ __typename?: 'InvesteeMetric', reference: string, title: string, type: QuestionType_Enum_, order: number }>, quarterlyMetrics: Array<{ __typename?: 'InvesteeMetric', reference: string, title: string, type: QuestionType_Enum_, order: number }>, companies: Array<{ __typename?: 'Company', id: any, name: string, yearly: Array<{ __typename?: 'PaiCompanyReport', answers: Array<{ __typename?: 'PaiAnswers', investeeMetricReference: string, data?: string | null, noteHistory?: { __typename?: 'NoteHistory', notes: Array<{ __typename?: 'Note', body?: string | null }> } | null }> }>, q1: Array<{ __typename?: 'PaiCompanyReport', answers: Array<{ __typename?: 'PaiAnswers', investeeMetricReference: string, data?: string | null, noteHistory?: { __typename?: 'NoteHistory', notes: Array<{ __typename?: 'Note', body?: string | null }> } | null }> }>, q2: Array<{ __typename?: 'PaiCompanyReport', answers: Array<{ __typename?: 'PaiAnswers', investeeMetricReference: string, data?: string | null, noteHistory?: { __typename?: 'NoteHistory', notes: Array<{ __typename?: 'Note', body?: string | null }> } | null }> }>, q3: Array<{ __typename?: 'PaiCompanyReport', answers: Array<{ __typename?: 'PaiAnswers', investeeMetricReference: string, data?: string | null, noteHistory?: { __typename?: 'NoteHistory', notes: Array<{ __typename?: 'Note', body?: string | null }> } | null }> }>, q4: Array<{ __typename?: 'PaiCompanyReport', answers: Array<{ __typename?: 'PaiAnswers', investeeMetricReference: string, data?: string | null, noteHistory?: { __typename?: 'NoteHistory', notes: Array<{ __typename?: 'Note', body?: string | null }> } | null }> }> }> };

export type PaiTablesQueryVariables_ = Exact<{ [key: string]: never; }>;


export type PaiTablesQuery_ = { __typename?: 'query_root', tables: Array<{ __typename?: 'PaiTable', isMandatory: boolean, title: string, reference: string, subtitle?: string | null, isCustom: boolean, categories: Array<{ __typename?: 'PaiCategory', title: string, subtitle?: string | null, reference: string, indicators: Array<{ __typename?: 'PaiTableIndicator', title: string, description?: string | null, reference: string, isHidden: boolean, category: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, table: { __typename?: 'PaiTable', isCustom: boolean, title: string } }, investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', title: string, description?: string | null, reference: string, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null, investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number } }> } }> }> }> }> };

export type PaiTablesV2QueryVariables_ = Exact<{ [key: string]: never; }>;


export type PaiTablesV2Query_ = { __typename?: 'query_root', tables: Array<{ __typename?: 'PaiTable', isMandatory: boolean, title: string, reference: string, subtitle?: string | null, isCustom: boolean, categories: Array<{ __typename?: 'PaiCategory', title: string, subtitle?: string | null, reference: string, indicators: Array<{ __typename?: 'PaiTableIndicator', title: string, description?: string | null, reference: string, isHidden: boolean, order?: string | null, category: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, table: { __typename?: 'PaiTable', isCustom: boolean, title: string, reference: string } }, investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', title: string, description?: string | null, reference: string, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null, investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number } }> } }> }> }> }> };

export type GetPaiPortfolioReportQueryVariables_ = Exact<{
  portfolioId: Scalars['uuid']['input'];
  year: Scalars['Int']['input'];
  quarter: QuarterEnum_Enum_;
}>;


export type GetPaiPortfolioReportQuery_ = { __typename?: 'query_root', report: Array<{ __typename?: 'PaiPortfolioReport', dueDate?: any | null, id: any, reportingPeriod?: any | null, year?: number | null, quarter: QuarterEnum_Enum_, sendOutDates?: any | null, dueDates?: any | null, contactPerson?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, portfolio: { __typename?: 'Portfolio', id: any, name: string }, selectedIndicators: Array<{ __typename?: 'PaiReportIndicator', paiTableIndicatorReference: string, isNew: boolean, periods?: any | null, isForAllCompanies: boolean, indicator: { __typename?: 'PaiTableIndicator', title: string, description?: string | null, reference: string, isHidden: boolean, category: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, table: { __typename?: 'PaiTable', isCustom: boolean, title: string } }, investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', title: string, description?: string | null, reference: string, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null, investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number } }> } }> }, paiReportIndicatorPortfolioCompanies: Array<{ __typename?: 'PaiReportIndicatorPortfolioCompany', portfolioCompanyId: any, portfolioCompany?: { __typename?: 'PortfolioCompany', year?: number | null, company?: { __typename?: 'Company', name: string, id: any } | null } | null }> }> }> };

export type GetPaiPortfolioReportV2QueryVariables_ = Exact<{
  portfolioId: Scalars['uuid']['input'];
  year: Scalars['Int']['input'];
  quarter: QuarterEnum_Enum_;
}>;


export type GetPaiPortfolioReportV2Query_ = { __typename?: 'query_root', report: Array<{ __typename?: 'PaiPortfolioReport', dueDate?: any | null, id: any, reportingPeriod?: any | null, year?: number | null, quarter: QuarterEnum_Enum_, sendOutDates?: any | null, dueDates?: any | null, contactPerson?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, portfolio: { __typename?: 'Portfolio', id: any, name: string }, selectedIndicators: Array<{ __typename?: 'PaiReportIndicator', paiTableIndicatorReference: string, isNew: boolean, periods?: any | null, isForAllCompanies: boolean, indicator: { __typename?: 'PaiTableIndicator', title: string, description?: string | null, reference: string, isHidden: boolean, order?: string | null, category: { __typename?: 'PaiCategory', title: string, reference: string, subtitle?: string | null, table: { __typename?: 'PaiTable', isCustom: boolean, title: string, reference: string } }, investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', title: string, description?: string | null, reference: string, methodology?: string | null, unit?: string | null, isAggregatable?: boolean | null, investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', metric: { __typename?: 'InvesteeMetric', title: string, description?: string | null, dependencies?: string | null, additionalResources?: string | null, type: QuestionType_Enum_, methodology?: string | null, reference: string, unit?: string | null, order: number } }> } }> }, paiReportIndicatorPortfolioCompanies: Array<{ __typename?: 'PaiReportIndicatorPortfolioCompany', portfolioCompanyId: any, portfolioCompany?: { __typename?: 'PortfolioCompany', year?: number | null, company?: { __typename?: 'Company', name: string, id: any } | null } | null }> }> }> };

export type AddPaiPortfolioReportMutationVariables_ = Exact<{
  input: PaiPortfolioReport_Insert_Input_;
}>;


export type AddPaiPortfolioReportMutation_ = { __typename?: 'mutation_root', insert_PaiPortfolioReport_one?: { __typename?: 'PaiPortfolioReport', id: any } | null };

export type UpsertPaiPortfolioReportMutationVariables_ = Exact<{
  object: PaiPortfolioReport_Insert_Input_;
}>;


export type UpsertPaiPortfolioReportMutation_ = { __typename?: 'mutation_root', insert_PaiPortfolioReport_one?: { __typename?: 'PaiPortfolioReport', portfolioId: any, sendOutDates?: any | null, dueDates?: any | null, contactPersonId?: any | null, selectedIndicators: Array<{ __typename?: 'PaiReportIndicator', id: any }>, contactPerson?: { __typename?: 'users', displayName: string } | null } | null };

export type DeletePaiReportIndicatorMutationVariables_ = Exact<{
  paiPortfolioReportId?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  paiTableIndicatorReference?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DeletePaiReportIndicatorMutation_ = { __typename?: 'mutation_root', delete_PaiReportIndicator?: { __typename?: 'PaiReportIndicator_mutation_response', affected_rows: number } | null };

export type DeletePaiReportIndicatorPortfolioCompanyMutationVariables_ = Exact<{
  portfolioCompanyId: Scalars['uuid']['input'];
  indicatorRef: Scalars['String']['input'];
}>;


export type DeletePaiReportIndicatorPortfolioCompanyMutation_ = { __typename?: 'mutation_root', delete_PaiReportIndicatorPortfolioCompany?: { __typename?: 'PaiReportIndicatorPortfolioCompany_mutation_response', affected_rows: number } | null };

export type PaiCompanyResultsWithNotesQueryVariables_ = Exact<{
  portfolioId: Scalars['uuid']['input'];
  year: Scalars['Int']['input'];
}>;


export type PaiCompanyResultsWithNotesQuery_ = { __typename?: 'query_root', companies: Array<{ __typename?: 'PortfolioCompany', marketValue?: any | null, valueOfInvestments?: any | null, company?: { __typename?: 'Company', name: string, id: any } | null, paiYearReport?: { __typename?: 'PaiCompanyReport', answers: Array<{ __typename?: 'PaiAnswers', data?: string | null, metric: { __typename?: 'InvesteeMetric', investorMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', investeeMetric: { __typename?: 'InvesteeMetric', reference: string } }> }, noteHistory?: { __typename?: 'NoteHistory', notes: Array<{ __typename?: 'Note', body?: string | null }> } | null }> } | null, paiQ1Report?: { __typename?: 'PaiCompanyReport', answers: Array<{ __typename?: 'PaiAnswers', data?: string | null, metric: { __typename?: 'InvesteeMetric', investorMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', investeeMetric: { __typename?: 'InvesteeMetric', reference: string } }> }, noteHistory?: { __typename?: 'NoteHistory', notes: Array<{ __typename?: 'Note', body?: string | null }> } | null }> } | null, paiQ2Report?: { __typename?: 'PaiCompanyReport', answers: Array<{ __typename?: 'PaiAnswers', data?: string | null, metric: { __typename?: 'InvesteeMetric', investorMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', investeeMetric: { __typename?: 'InvesteeMetric', reference: string } }> }, noteHistory?: { __typename?: 'NoteHistory', notes: Array<{ __typename?: 'Note', body?: string | null }> } | null }> } | null, paiQ3Report?: { __typename?: 'PaiCompanyReport', answers: Array<{ __typename?: 'PaiAnswers', data?: string | null, metric: { __typename?: 'InvesteeMetric', investorMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', investeeMetric: { __typename?: 'InvesteeMetric', reference: string } }> }, noteHistory?: { __typename?: 'NoteHistory', notes: Array<{ __typename?: 'Note', body?: string | null }> } | null }> } | null, paiQ4Report?: { __typename?: 'PaiCompanyReport', answers: Array<{ __typename?: 'PaiAnswers', data?: string | null, metric: { __typename?: 'InvesteeMetric', investorMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', investeeMetric: { __typename?: 'InvesteeMetric', reference: string } }> }, noteHistory?: { __typename?: 'NoteHistory', notes: Array<{ __typename?: 'Note', body?: string | null }> } | null }> } | null }>, indicators: Array<{ __typename?: 'PaiReportIndicator', id: any, periods?: any | null, isForAllCompanies: boolean, paiReportIndicatorPortfolioCompanies: Array<{ __typename?: 'PaiReportIndicatorPortfolioCompany', id: any, portfolioCompany?: { __typename?: 'PortfolioCompany', companyId?: any | null } | null }>, indicator: { __typename?: 'PaiTableIndicator', investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', investeeMetricReference: string }> } }> } }> };

export type PaiCompanyResultsWithoutNotesQueryVariables_ = Exact<{
  portfolioId: Scalars['uuid']['input'];
  year: Scalars['Int']['input'];
}>;


export type PaiCompanyResultsWithoutNotesQuery_ = { __typename?: 'query_root', companies: Array<{ __typename?: 'PortfolioCompany', marketValue?: any | null, valueOfInvestments?: any | null, company?: { __typename?: 'Company', name: string, id: any } | null, paiYearReport?: { __typename?: 'PaiCompanyReport', answers: Array<{ __typename?: 'PaiAnswers', data?: string | null, metric: { __typename?: 'InvesteeMetric', investorMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', investeeMetric: { __typename?: 'InvesteeMetric', reference: string } }> } }> } | null, paiQ1Report?: { __typename?: 'PaiCompanyReport', answers: Array<{ __typename?: 'PaiAnswers', data?: string | null, metric: { __typename?: 'InvesteeMetric', investorMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', investeeMetric: { __typename?: 'InvesteeMetric', reference: string } }> } }> } | null, paiQ2Report?: { __typename?: 'PaiCompanyReport', answers: Array<{ __typename?: 'PaiAnswers', data?: string | null, metric: { __typename?: 'InvesteeMetric', investorMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', investeeMetric: { __typename?: 'InvesteeMetric', reference: string } }> } }> } | null, paiQ3Report?: { __typename?: 'PaiCompanyReport', answers: Array<{ __typename?: 'PaiAnswers', data?: string | null, metric: { __typename?: 'InvesteeMetric', investorMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', investeeMetric: { __typename?: 'InvesteeMetric', reference: string } }> } }> } | null, paiQ4Report?: { __typename?: 'PaiCompanyReport', answers: Array<{ __typename?: 'PaiAnswers', data?: string | null, metric: { __typename?: 'InvesteeMetric', investorMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', investeeMetric: { __typename?: 'InvesteeMetric', reference: string } }> } }> } | null }>, indicators: Array<{ __typename?: 'PaiReportIndicator', id: any, periods?: any | null, isForAllCompanies: boolean, paiReportIndicatorPortfolioCompanies: Array<{ __typename?: 'PaiReportIndicatorPortfolioCompany', id: any, portfolioCompany?: { __typename?: 'PortfolioCompany', companyId?: any | null } | null }>, indicator: { __typename?: 'PaiTableIndicator', investorMetrics: Array<{ __typename?: 'IndicatorToInvestorMetric', investorMetric: { __typename?: 'InvestorMetric', investeeMetrics: Array<{ __typename?: 'InvestorToInvesteeMetric', investeeMetricReference: string }> } }> } }> };

export type PortfoliosQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type PortfoliosQuery_ = { __typename?: 'query_root', portfolios: Array<{ __typename?: 'Portfolio', id: any, name: string, description: string, totalAmount: any, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, company?: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean, currency: string, portfolios: Array<{ __typename?: 'Portfolio', id: any, name: string, description: string, totalAmount: any, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, company?: { __typename?: 'Company', currency: string, id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null }>, taxonomyReports: Array<{ __typename?: 'TaxonomyPortfolioReport', year: number, sendOutDate?: any | null, dueDate?: any | null, contactPerson?: { __typename?: 'users', displayName: string } | null }> }> } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null }>, taxonomyReports: Array<{ __typename?: 'TaxonomyPortfolioReport', year: number, quarter: QuarterEnum_Enum_, sendOutDate?: any | null, dueDate?: any | null, contactPerson?: { __typename?: 'users', displayName: string } | null }>, portfolioNonEligibleFinancials: Array<{ __typename?: 'PortfolioNonEligibleFinancials', id: any, value?: any | null, type: InvestmentCategory_Enum_, year?: number | null, quarter: QuarterEnum_Enum_ }> }> };

export type InvestorsQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type InvestorsQuery_ = { __typename?: 'query_root', investors: Array<{ __typename?: 'PortfolioCompany', id: any, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, updatedAt: any, contactPersonName?: string | null, contactPersonEmail?: string | null, portfolioId: any, sharedCompanyAssessmentId?: any | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, portfolio: { __typename?: 'Portfolio', name: string, ownerCompany: { __typename?: 'Company', name: string, hasPaiAccess: boolean, logoUrl?: string | null } }, sharedAssessment?: { __typename?: 'CompanyAssessment', id: any, startDate: any, aggregate: { __typename?: 'CompanyAssessmentAggregate', title: string }, cachedResult?: { __typename?: 'CachedResult', progress: any } | null } | null }> };

export type GetPortfolioNameQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetPortfolioNameQuery_ = { __typename?: 'query_root', portfolio?: { __typename?: 'Portfolio', name: string } | null };

export type CompaniesFromAllPortfoliosQueryVariables_ = Exact<{
  ownerCompanyId: Scalars['uuid']['input'];
}>;


export type CompaniesFromAllPortfoliosQuery_ = { __typename?: 'query_root', allCompanies: Array<{ __typename?: 'Company', id: any, name: string, portfolioMemberships: Array<{ __typename?: 'PortfolioCompany', contactPersonName?: string | null, contactPersonEmail?: string | null, portfolio: { __typename?: 'Portfolio', id: any, name: string }, sharedAssessment?: { __typename?: 'CompanyAssessment', aggregate: { __typename?: 'CompanyAssessmentAggregate', title: string, startDate: any } } | null }> }> };

export type GetTaxonomyPortfolioReportQueryVariables_ = Exact<{
  portfolioId: Scalars['uuid']['input'];
  year: Scalars['Int']['input'];
  quarter: QuarterEnum_Enum_;
}>;


export type GetTaxonomyPortfolioReportQuery_ = { __typename?: 'query_root', TaxonomyPortfolioReport: Array<{ __typename?: 'TaxonomyPortfolioReport', id: any, year: number, sendOutDate?: any | null, contactPersonId?: any | null, dueDate?: any | null, quarter: QuarterEnum_Enum_ }> };

export type PortfolioCompaniesQueryVariables_ = Exact<{
  portfolioId: Scalars['uuid']['input'];
}>;


export type PortfolioCompaniesQuery_ = { __typename?: 'query_root', portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', contactPersonEmail?: string | null, company?: { __typename?: 'Company', id: any, users: Array<{ __typename?: 'CompanyUser', user: { __typename?: 'users', email?: any | null } }> } | null }> };

export type ToggleShareAssessmentWithPortfolioMutationVariables_ = Exact<{
  object: PortfolioCompany_Insert_Input_;
}>;


export type ToggleShareAssessmentWithPortfolioMutation_ = { __typename?: 'mutation_root', insert_PortfolioCompany_one?: { __typename?: 'PortfolioCompany', id: any, sharedCompanyAssessmentId?: any | null, sharedAssessment?: { __typename?: 'CompanyAssessment', id: any } | null } | null };

export type UpsertPortfolioCompaniesReportingPeriodsMutationVariables_ = Exact<{
  objects: Array<PortfolioCompany_Insert_Input_> | PortfolioCompany_Insert_Input_;
}>;


export type UpsertPortfolioCompaniesReportingPeriodsMutation_ = { __typename?: 'mutation_root', insert_PortfolioCompany?: { __typename?: 'PortfolioCompany_mutation_response', returning: Array<{ __typename?: 'PortfolioCompany', id: any, year?: number | null }> } | null };

export type UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutationVariables_ = Exact<{
  objects: Array<PortfolioCompany_Insert_Input_> | PortfolioCompany_Insert_Input_;
}>;


export type UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutation_ = { __typename?: 'mutation_root', insert_PortfolioCompany?: { __typename?: 'PortfolioCompany_mutation_response', returning: Array<{ __typename?: 'PortfolioCompany', id: any, year?: number | null }> } | null };

export type ToggleSharePaiWithPortfolioMutationVariables_ = Exact<{
  objects: Array<PortfolioCompany_Insert_Input_> | PortfolioCompany_Insert_Input_;
}>;


export type ToggleSharePaiWithPortfolioMutation_ = { __typename?: 'mutation_root', insert_PortfolioCompany?: { __typename?: 'PortfolioCompany_mutation_response', affected_rows: number } | null };

export type UpsertPortfolioMutationVariables_ = Exact<{
  portfolio: Portfolio_Insert_Input_;
}>;


export type UpsertPortfolioMutation_ = { __typename?: 'mutation_root', portfolio?: { __typename?: 'Portfolio', id: any, name: string, description: string, totalAmount: any, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, company?: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean, currency: string, portfolios: Array<{ __typename?: 'Portfolio', id: any, name: string, description: string, totalAmount: any, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, company?: { __typename?: 'Company', currency: string, id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null }>, taxonomyReports: Array<{ __typename?: 'TaxonomyPortfolioReport', year: number, sendOutDate?: any | null, dueDate?: any | null, contactPerson?: { __typename?: 'users', displayName: string } | null }> }> } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null }>, taxonomyReports: Array<{ __typename?: 'TaxonomyPortfolioReport', year: number, quarter: QuarterEnum_Enum_, sendOutDate?: any | null, dueDate?: any | null, contactPerson?: { __typename?: 'users', displayName: string } | null }>, portfolioNonEligibleFinancials: Array<{ __typename?: 'PortfolioNonEligibleFinancials', id: any, value?: any | null, type: InvestmentCategory_Enum_, year?: number | null, quarter: QuarterEnum_Enum_ }>, ownerCompany: { __typename?: 'Company', id: any, portfolios: Array<{ __typename?: 'Portfolio', name: string }> } } | null };

export type CreatePortfolioCompaniesMutationVariables_ = Exact<{
  companies: Array<CompanyUser_Insert_Input_> | CompanyUser_Insert_Input_;
}>;


export type CreatePortfolioCompaniesMutation_ = { __typename?: 'mutation_root', result?: { __typename?: 'CompanyUser_mutation_response', returning: Array<{ __typename?: 'CompanyUser', company: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean } }> } | null };

export type UpdatePortfolioCompanyMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  data?: InputMaybe<PortfolioCompany_Set_Input_>;
}>;


export type UpdatePortfolioCompanyMutation_ = { __typename?: 'mutation_root', portfolioCompany?: { __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, company?: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean, currency: string, portfolios: Array<{ __typename?: 'Portfolio', id: any, name: string, description: string, totalAmount: any, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, company?: { __typename?: 'Company', currency: string, id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null }>, taxonomyReports: Array<{ __typename?: 'TaxonomyPortfolioReport', year: number, sendOutDate?: any | null, dueDate?: any | null, contactPerson?: { __typename?: 'users', displayName: string } | null }> }> } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null } | null };

export type UploadPortfolioCompanyScoreMutationVariables_ = Exact<{
  portfolioId: Scalars['uuid']['input'];
  companyId: Scalars['uuid']['input'];
  scores?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UploadPortfolioCompanyScoreMutation_ = { __typename?: 'mutation_root', portfolioCompany?: { __typename?: 'PortfolioCompany_mutation_response', returning: Array<{ __typename?: 'PortfolioCompany', id: any, scores?: any | null }> } | null };

export type DeletePortfolioCompanyMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeletePortfolioCompanyMutation_ = { __typename?: 'mutation_root', portfolioCompany?: { __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, portfolio: { __typename?: 'Portfolio', id: any, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any }> }, company?: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean, currency: string, portfolios: Array<{ __typename?: 'Portfolio', id: any, name: string, description: string, totalAmount: any, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, company?: { __typename?: 'Company', currency: string, id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null }>, taxonomyReports: Array<{ __typename?: 'TaxonomyPortfolioReport', year: number, sendOutDate?: any | null, dueDate?: any | null, contactPerson?: { __typename?: 'users', displayName: string } | null }> }> } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null } | null };

export type UpsertPortfolioCompanyMutationVariables_ = Exact<{
  portfolioCompany: PortfolioCompany_Insert_Input_;
}>;


export type UpsertPortfolioCompanyMutation_ = { __typename?: 'mutation_root', portfolioCompany?: { __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, portfolio: { __typename?: 'Portfolio', id: any, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any }> }, company?: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean, currency: string, portfolios: Array<{ __typename?: 'Portfolio', id: any, name: string, description: string, totalAmount: any, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, company?: { __typename?: 'Company', currency: string, id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null }>, taxonomyReports: Array<{ __typename?: 'TaxonomyPortfolioReport', year: number, sendOutDate?: any | null, dueDate?: any | null, contactPerson?: { __typename?: 'users', displayName: string } | null }> }> } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null } | null };

export type UpsertPortfolioCompaniesMutationVariables_ = Exact<{
  portfolioCompanies: Array<PortfolioCompany_Insert_Input_> | PortfolioCompany_Insert_Input_;
}>;


export type UpsertPortfolioCompaniesMutation_ = { __typename?: 'mutation_root', portfolioCompanies?: { __typename?: 'PortfolioCompany_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'PortfolioCompany', id: any, company?: { __typename?: 'Company', id: any } | null }> } | null };

export type DeletePortfolioMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeletePortfolioMutation_ = { __typename?: 'mutation_root', portfolio?: { __typename?: 'Portfolio', id: any, name: string, description: string, totalAmount: any, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, company?: { __typename?: 'Company', id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean, currency: string, portfolios: Array<{ __typename?: 'Portfolio', id: any, name: string, description: string, totalAmount: any, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, scores?: any | null, marketValue?: any | null, contactPersonEmail?: string | null, contactPersonName?: string | null, sharedPaiCompanyReportId?: any | null, eligibilityStatus: string, year?: number | null, quarter: QuarterEnum_Enum_, valueOfInvestments?: any | null, createdAt: any, company?: { __typename?: 'Company', currency: string, id: any, name: string, logoUrl?: string | null, isPortfolioOwner: boolean } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null }>, taxonomyReports: Array<{ __typename?: 'TaxonomyPortfolioReport', year: number, sendOutDate?: any | null, dueDate?: any | null, contactPerson?: { __typename?: 'users', displayName: string } | null }> }> } | null, estimateCompany?: { __typename?: 'EstimateCompany_deprecated', createdAt: any, id: any, industries: any, logoUrl?: string | null, metadata: any, name: string, scores: any, updatedAt: any, scoreType: string } | null, sharedAssessment?: { __typename?: 'CompanyAssessment', isLocked: boolean, cachedResult?: { __typename?: 'CachedResult', score: any, progress: any, objectivesState: any } | null } | null }>, taxonomyReports: Array<{ __typename?: 'TaxonomyPortfolioReport', year: number, quarter: QuarterEnum_Enum_, sendOutDate?: any | null, dueDate?: any | null, contactPerson?: { __typename?: 'users', displayName: string } | null }>, portfolioNonEligibleFinancials: Array<{ __typename?: 'PortfolioNonEligibleFinancials', id: any, value?: any | null, type: InvestmentCategory_Enum_, year?: number | null, quarter: QuarterEnum_Enum_ }>, ownerCompany: { __typename?: 'Company', id: any, portfolios: Array<{ __typename?: 'Portfolio', name: string }> } } | null };

export type InsertPortfolioCompaniesMutationVariables_ = Exact<{
  objects: Array<PortfolioCompany_Insert_Input_> | PortfolioCompany_Insert_Input_;
}>;


export type InsertPortfolioCompaniesMutation_ = { __typename?: 'mutation_root', insert_PortfolioCompany?: { __typename?: 'PortfolioCompany_mutation_response', affected_rows: number } | null };

export type NudgePortfolioCompaniesMutationVariables_ = Exact<{
  recipients: Array<EmailItem_> | EmailItem_;
  data: NudgePortfolioCompaniesInput_;
}>;


export type NudgePortfolioCompaniesMutation_ = { __typename?: 'mutation_root', nudgePortfolioCompanies?: { __typename?: 'NudgePortfolioCompaniesOutput', emailsSent: number, error?: string | null } | null };

export type NudgeGroupCompaniesMutationVariables_ = Exact<{
  recipients: Array<EmailItem_> | EmailItem_;
  data: NudgeGroupCompaniesInput_;
}>;


export type NudgeGroupCompaniesMutation_ = { __typename?: 'mutation_root', nudgeGroupCompanies?: { __typename?: 'NudgeGroupCompaniesOutput', emailsSent: number, error?: string | null } | null };

export type UpsertPortfolioCompaniesFinancialsMutationVariables_ = Exact<{
  portfolioCompanies: Array<PortfolioCompany_Insert_Input_> | PortfolioCompany_Insert_Input_;
}>;


export type UpsertPortfolioCompaniesFinancialsMutation_ = { __typename?: 'mutation_root', insert_PortfolioCompany?: { __typename?: 'PortfolioCompany_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'PortfolioCompany', valueOfInvestments?: any | null }> } | null };

export type UpdatePortfolioCompanyMarketValueMutationVariables_ = Exact<{
  portfolioCompanyId: Scalars['uuid']['input'];
  newMarketValue?: InputMaybe<Scalars['numeric']['input']>;
}>;


export type UpdatePortfolioCompanyMarketValueMutation_ = { __typename?: 'mutation_root', portfolioCompany?: { __typename?: 'PortfolioCompany_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'PortfolioCompany', id: any, companyId?: any | null, marketValue?: any | null, company?: { __typename?: 'Company', name: string } | null }> } | null };

export type UpsertTaxonomyPortfolioMutationVariables_ = Exact<{
  object: TaxonomyPortfolioReport_Insert_Input_;
}>;


export type UpsertTaxonomyPortfolioMutation_ = { __typename?: 'mutation_root', insert_TaxonomyPortfolioReport_one?: { __typename?: 'TaxonomyPortfolioReport', id: any, year: number, sendOutDate?: any | null, dueDate?: any | null, contactPersonId?: any | null, quarter: QuarterEnum_Enum_ } | null };

export type UpsertPortfolioNonEligibleFinancialsMutationVariables_ = Exact<{
  objects: Array<PortfolioNonEligibleFinancials_Insert_Input_> | PortfolioNonEligibleFinancials_Insert_Input_;
}>;


export type UpsertPortfolioNonEligibleFinancialsMutation_ = { __typename?: 'mutation_root', insert_PortfolioNonEligibleFinancials?: { __typename?: 'PortfolioNonEligibleFinancials_mutation_response', returning: Array<{ __typename?: 'PortfolioNonEligibleFinancials', id: any }> } | null };

export type GetPortfolioNonEligibleFinancialsQueryVariables_ = Exact<{
  portfolioId: Scalars['uuid']['input'];
  year: Scalars['Int']['input'];
  quarter: QuarterEnum_Enum_;
}>;


export type GetPortfolioNonEligibleFinancialsQuery_ = { __typename?: 'query_root', PortfolioNonEligibleFinancials: Array<{ __typename?: 'PortfolioNonEligibleFinancials', id: any, value?: any | null, type: InvestmentCategory_Enum_, isSelected: boolean }> };

export type AllObjectivesQueryVariables_ = Exact<{ [key: string]: never; }>;


export type AllObjectivesQuery_ = { __typename?: 'query_root', allObjectives: Array<{ __typename?: 'Objective', title: string, description?: string | null, key: string }> };

export type AllSectorsQueryVariables_ = Exact<{ [key: string]: never; }>;


export type AllSectorsQuery_ = { __typename?: 'query_root', sectors: Array<{ __typename?: 'Sector', reference: string, name: string }> };

export type AllActivitiesQueryVariables_ = Exact<{
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AllActivitiesQuery_ = { __typename?: 'query_root', allActivities: Array<{ __typename?: 'Activity', name: string, description: string, reference: string, currentQuestionSetVersion?: number | null, referenceNumber?: string | null, additionalGuidance?: string | null, celsiaComment?: string | null, descriptionSource?: string | null, guidanceSource?: string | null, sector: { __typename?: 'Sector', reference: string, name: string }, naceCodes: Array<{ __typename?: 'ActivityNaceCode', code: string }>, versions: Array<{ __typename?: 'ActivityVersion', versionNumber: number, tagExpression: string }> }> };

export type GetActivityObjectivesStatusQueryVariables_ = Exact<{
  activityRef: Scalars['String']['input'];
  versionNumber: Scalars['Int']['input'];
}>;


export type GetActivityObjectivesStatusQuery_ = { __typename?: 'query_root', ActivityVersion: Array<{ __typename?: 'ActivityVersion', tagObjective?: string | null, tagExpression: string, activity: { __typename?: 'Activity', reference: string, name: string, canBeEnabling: { __typename?: 'ActivityVersion_aggregate', aggregate?: { __typename?: 'ActivityVersion_aggregate_fields', count: number } | null }, canBeTransitional: { __typename?: 'ActivityVersion_aggregate', aggregate?: { __typename?: 'ActivityVersion_aggregate_fields', count: number } | null }, canBeGreen: { __typename?: 'ActivityVersion_aggregate', aggregate?: { __typename?: 'ActivityVersion_aggregate_fields', count: number } | null } }, mitigationSC: { __typename?: 'ActivityQuestionSet_aggregate', aggregate?: { __typename?: 'ActivityQuestionSet_aggregate_fields', count: number } | null }, mitigationDNSH: { __typename?: 'ActivityQuestionSet_aggregate', aggregate?: { __typename?: 'ActivityQuestionSet_aggregate_fields', count: number } | null }, adaptationSC: { __typename?: 'ActivityQuestionSet_aggregate', aggregate?: { __typename?: 'ActivityQuestionSet_aggregate_fields', count: number } | null }, adaptationDNSH: { __typename?: 'ActivityQuestionSet_aggregate', aggregate?: { __typename?: 'ActivityQuestionSet_aggregate_fields', count: number } | null }, waterSC: { __typename?: 'ActivityQuestionSet_aggregate', aggregate?: { __typename?: 'ActivityQuestionSet_aggregate_fields', count: number } | null }, waterDNSH: { __typename?: 'ActivityQuestionSet_aggregate', aggregate?: { __typename?: 'ActivityQuestionSet_aggregate_fields', count: number } | null }, circularSC: { __typename?: 'ActivityQuestionSet_aggregate', aggregate?: { __typename?: 'ActivityQuestionSet_aggregate_fields', count: number } | null }, circularDNSH: { __typename?: 'ActivityQuestionSet_aggregate', aggregate?: { __typename?: 'ActivityQuestionSet_aggregate_fields', count: number } | null }, pollutionSC: { __typename?: 'ActivityQuestionSet_aggregate', aggregate?: { __typename?: 'ActivityQuestionSet_aggregate_fields', count: number } | null }, pollutionDNSH: { __typename?: 'ActivityQuestionSet_aggregate', aggregate?: { __typename?: 'ActivityQuestionSet_aggregate_fields', count: number } | null }, biodiversitySC: { __typename?: 'ActivityQuestionSet_aggregate', aggregate?: { __typename?: 'ActivityQuestionSet_aggregate_fields', count: number } | null }, biodiversityDNSH: { __typename?: 'ActivityQuestionSet_aggregate', aggregate?: { __typename?: 'ActivityQuestionSet_aggregate_fields', count: number } | null } }> };

export type AddAnswerMutationVariables_ = Exact<{
  answer: Answer_Insert_Input_;
  reportId: Scalars['uuid']['input'];
}>;


export type AddAnswerMutation_ = { __typename?: 'mutation_root', answer?: { __typename?: 'Answer', flagged?: boolean | null, id: any, questionId: any, updatedAt: any, createdAt: any, data?: any | null, reportId?: any | null, activityReport?: { __typename?: 'ActivityReport', id: any, answers: Array<{ __typename?: 'Answer', id: any }> } | null, answeredBy: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string }, question: { __typename?: 'Question', id: any, uniqueId: string }, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, thread?: { __typename?: 'Thread', id: any, commentsAggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null }, comments: Array<{ __typename?: 'Comment', id: any, data: string }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null } | null, cachedResult?: { __typename?: 'CachedResult_mutation_response', returning: Array<{ __typename?: 'CachedResult', id: any, isDirty?: boolean | null }> } | null };

export type AddAnswerWithoutDataMutationVariables_ = Exact<{
  answer: Answer_Insert_Input_;
}>;


export type AddAnswerWithoutDataMutation_ = { __typename?: 'mutation_root', answer?: { __typename?: 'Answer', flagged?: boolean | null, id: any, questionId: any, updatedAt: any, createdAt: any, data?: any | null, reportId?: any | null, activityReport?: { __typename?: 'ActivityReport', id: any, answers: Array<{ __typename?: 'Answer', id: any }> } | null, answeredBy: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string }, question: { __typename?: 'Question', id: any, uniqueId: string }, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, thread?: { __typename?: 'Thread', id: any, commentsAggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null }, comments: Array<{ __typename?: 'Comment', id: any, data: string }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null } | null };

export type UpsertAnswerDataMutationVariables_ = Exact<{
  answers: Array<Answer_Insert_Input_> | Answer_Insert_Input_;
}>;


export type UpsertAnswerDataMutation_ = { __typename?: 'mutation_root', insert_Answer?: { __typename?: 'Answer_mutation_response', returning: Array<{ __typename?: 'Answer', id: any }> } | null };

export type GetAnswerQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetAnswerQuery_ = { __typename?: 'query_root', answer?: { __typename?: 'Answer', flagged?: boolean | null, id: any, questionId: any, updatedAt: any, createdAt: any, data?: any | null, reportId?: any | null, answeredBy: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string }, question: { __typename?: 'Question', id: any, uniqueId: string }, attachmentBox?: { __typename?: 'AttachmentBox', id: any, attachments: Array<{ __typename?: 'Attachment', id: any, file: { __typename?: 'DocumentationFile', id: any, title: string, description: string, source: string, tags: any, creationDate?: any | null, updatedAt: any, deletedAt?: any | null, storageFile?: { __typename?: 'files', mimeType?: string | null, id: any, name?: string | null, createdAt: any, uploadedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } | null, lastUpdatedBy?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null } }> } | null, thread?: { __typename?: 'Thread', id: any, commentsAggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null }, comments: Array<{ __typename?: 'Comment', id: any, data: string }> } | null, noteHistory?: { __typename?: 'NoteHistory', id: any, notes: Array<{ __typename?: 'Note', body?: string | null, updatedAt: any, isAIGenerated: boolean, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> } | null } | null };

export type ReportingGroupsQueryVariables_ = Exact<{
  cAssessmentId: Scalars['uuid']['input'];
}>;


export type ReportingGroupsQuery_ = { __typename?: 'query_root', reportingGroups: Array<{ __typename?: 'ReportingGroup', id: any, name: string, orderIndex: any, parentId?: any | null, updatedAt: any, createdAt: any, businessUnits: Array<{ __typename?: 'BusinessUnitAssessment', orderIndex?: any | null, bAssessmentId: any, businessUnit?: { __typename?: 'BusinessUnit', id: any, createdAt: any, name: string, companyId: any, description?: string | null, contactPerson: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null }>, owner?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null }> };

export type UpsertReportingGroupsMutationVariables_ = Exact<{
  input: Array<ReportingGroup_Insert_Input_> | ReportingGroup_Insert_Input_;
}>;


export type UpsertReportingGroupsMutation_ = { __typename?: 'mutation_root', insert_ReportingGroup?: { __typename?: 'ReportingGroup_mutation_response', affected_rows: number } | null };

export type DeleteReportingGroupMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteReportingGroupMutation_ = { __typename?: 'mutation_root', update_ReportingGroup_by_pk?: { __typename?: 'ReportingGroup', id: any } | null, update_BusinessUnitAssessment_many?: Array<{ __typename?: 'BusinessUnitAssessment_mutation_response', affected_rows: number } | null> | null, update_ReportingGroup_many?: Array<{ __typename?: 'ReportingGroup_mutation_response', affected_rows: number } | null> | null };

export type CompanyAssessmentCachedResultsSubscriptionVariables_ = Exact<{
  cAssessmentId: Scalars['uuid']['input'];
}>;


export type CompanyAssessmentCachedResultsSubscription_ = { __typename?: 'subscription_root', companyResults?: { __typename?: 'CompanyAssessment', aggregateId: any, endDate: any, startDate: any, companyAssessmentId: any, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null, nonMaterialFinancials?: { __typename?: 'NonMaterialFinancials', id?: any | null, revenue?: any | null, capex?: any | null, opex?: any | null, adaptationCapex?: any | null, adaptationOpex?: any | null, isEstimate?: boolean | null } | null, generalBusinessUnitResult: Array<{ __typename?: 'BusinessUnitAssessment', generalAssessmentResults: Array<{ __typename?: 'ActivityReport', activityVersionNumber: number, bAssessmentId: any, activityAssessmentId: any, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null }> }>, businessUnitResults: Array<{ __typename?: 'BusinessUnitAssessment', hasGeneralAssessment: boolean, bAssessmentId: any, businessUnit?: { __typename?: 'BusinessUnit', name: string, id: any } | null, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null, generalAssessmentResults: Array<{ __typename?: 'ActivityReport', activityVersionNumber: number, bAssessmentId: any, activityAssessmentId: any, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null }>, activityResults: Array<{ __typename?: 'ActivityReport', activityVersionNumber: number, activityRef: string, activityAssessmentId: any, financials?: { __typename?: 'Financials', id: any } | null, cachedResult?: { __typename?: 'CachedResult', id: any, score: any, progress: any, activityRef?: string | null, activityVersionNumber?: number | null, financials: any, activityTag?: string | null, isAligned?: boolean | null, isCompleted: boolean, isDirty?: boolean | null, objectivesState: any, status?: string | null } | null }> }> } | null };

export type UpsertCacheResultsMutationVariables_ = Exact<{
  objects: Array<CachedResult_Insert_Input_> | CachedResult_Insert_Input_;
}>;


export type UpsertCacheResultsMutation_ = { __typename?: 'mutation_root', insert_CachedResult?: { __typename?: 'CachedResult_mutation_response', update: Array<{ __typename?: 'CachedResult', id: any, activityTag?: string | null, activityVersionNumber?: number | null, isAligned?: boolean | null, financials: any, isCompleted: boolean, score: any, status?: string | null, objectivesState: any, cAssessments: Array<{ __typename?: 'CompanyAssessment', id: any }>, activity?: { __typename?: 'Activity', reference: string } | null, activityReports: Array<{ __typename?: 'ActivityReport', id: any }> }> } | null };

export type UpsertCompanyAssessmentResultsMutationVariables_ = Exact<{
  companyUpdate: CompanyAssessment_Insert_Input_;
  bAssessmentsResults: Array<BusinessUnitAssessment_Insert_Input_> | BusinessUnitAssessment_Insert_Input_;
  activityAssesments: Array<ActivityReport_Insert_Input_> | ActivityReport_Insert_Input_;
}>;


export type UpsertCompanyAssessmentResultsMutation_ = { __typename?: 'mutation_root', company?: { __typename?: 'CompanyAssessment', id: any, cachedResultId?: any | null } | null, businessUnits?: { __typename?: 'BusinessUnitAssessment_mutation_response', returning: Array<{ __typename?: 'BusinessUnitAssessment', id: any, cachedResultId?: any | null }> } | null, activities?: { __typename?: 'ActivityReport_mutation_response', returning: Array<{ __typename?: 'ActivityReport', id: any, cachedResultId?: any | null, cachedResult?: { __typename?: 'CachedResult', isAligned?: boolean | null, status?: string | null } | null }> } | null };

export type FlagCompanyAssessmentAsDirtyMutationVariables_ = Exact<{
  cachedResultId: Scalars['uuid']['input'];
}>;


export type FlagCompanyAssessmentAsDirtyMutation_ = { __typename?: 'mutation_root', insert_CachedResult_one?: { __typename?: 'CachedResult', id: any } | null };

export type MetricDetailsFragment_ = { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', materialStandard: { __typename?: 'esrs_MaterialStandard', standardRef: string, standard: { __typename?: 'EsrsStandard', title: string, order: number } } }> };

export type AnswerDetailsFragment_ = { __typename?: 'esrs_Answer', id: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string }, metric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', materialStandard: { __typename?: 'esrs_MaterialStandard', standardRef: string, standard: { __typename?: 'EsrsStandard', title: string, order: number } } }> } };

export type MetricDisclosureDetailsFragment_ = { __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', title: string, reference: string, frameworkRef?: string | null, type: string, order: number }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, title: string, type: string, order: number, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', title: string, reference: string, frameworkRef?: string | null, type: string, order: number } }> } }> };

export type UserCompaniesWithSustainabilityAssessmentsQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UserCompaniesWithSustainabilityAssessmentsQuery_ = { __typename?: 'query_root', data?: { __typename?: 'users', companies: Array<{ __typename?: 'CompanyUser', company: { __typename?: 'Company', id: any, name: string, esrsAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingYear: number, frameworkRef?: string | null, updatedAt: any, latestMaterialMetricUpdate?: any | null, latestDatapointUpdate?: any | null }> } }> } | null };

export type GetAssessmentDataQueryVariables_ = Exact<{
  esrsAssessmentId: Scalars['uuid']['input'];
}>;


export type GetAssessmentDataQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', id: any, parentAssessmentId?: any | null, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean }> } | null };

export type GetRequiredAssessmentMaterialMetricsQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  parentAssessmentId: Scalars['uuid']['input'];
}>;


export type GetRequiredAssessmentMaterialMetricsQuery_ = { __typename?: 'query_root', esrs_MaterialMetric: Array<{ __typename?: 'esrs_MaterialMetric', metricRef: string }> };

export type GetAssessmentMetricsQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
  requiredMetrics: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetAssessmentMetricsQuery_ = { __typename?: 'query_root', EsrsMetric: Array<{ __typename?: 'EsrsMetric', reference: string, disclosureRequirementRef: string, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirementRef: string }>, view_childrenMetrics: Array<{ __typename?: 'esrs_MetricDependencyClosure', childMetricRef?: string | null }>, parentMetrics: Array<{ __typename?: 'MetricDependency', parentMetricRef: string }>, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', id: any, frequency: string, dataCollection?: string | null, materialMetricTags: Array<{ __typename?: 'esrs_MaterialMetricTag', isOptional: boolean, tagType: string, id: any, metricTagType: { __typename?: 'TagType', alwaysAll: boolean }, materialTagValues: Array<{ __typename?: 'esrs_MaterialTagValue', tagType: string, tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }>, valueOptions: Array<{ __typename?: 'esrs_MaterialTagValue', tagValue: string, tag?: { __typename?: 'TagValue', order: number } | null }> }>, materialStandard: { __typename?: 'esrs_MaterialStandard', id: any, standardRef: string } }> }> };

export type GetTasksByAssessmentQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetTasksByAssessmentQuery_ = { __typename?: 'query_root', Task: Array<{ __typename?: 'Task', taskReference?: string | null, owner: { __typename?: 'users', displayName: string } }> };

export type GetMdrmDatapointsTasksQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetMdrmDatapointsTasksQuery_ = { __typename?: 'query_root', Task: Array<{ __typename?: 'Task', id: any, ownerId: any, dueDate?: any | null, status: TaskStatusEnum_Enum_, table: string, taskReference?: string | null, datapointMdrm?: { __typename?: 'esrs_DatapointMdrm', mdrmRef: string, datapoint: { __typename?: 'esrs_Datapoint', answer: { __typename?: 'esrs_Answer', metricRef: string } } } | null }> };

export type GetDatapointsTasksQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetDatapointsTasksQuery_ = { __typename?: 'query_root', Task: Array<{ __typename?: 'Task', id: any, ownerId: any, dueDate?: any | null, status: TaskStatusEnum_Enum_, table: string, taskReference?: string | null, datapoints: Array<{ __typename?: 'esrs_Datapoint', id: any, answer: { __typename?: 'esrs_Answer', id: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string }, metric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', materialStandard: { __typename?: 'esrs_MaterialStandard', standardRef: string, standard: { __typename?: 'EsrsStandard', title: string, order: number } } }> } } }> }> };

export type GetDatapointMdrmTasksQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetDatapointMdrmTasksQuery_ = { __typename?: 'query_root', Task: Array<{ __typename?: 'Task', id: any, ownerId: any, dueDate?: any | null, status: TaskStatusEnum_Enum_, table: string, taskReference?: string | null, datapointMdrm?: { __typename?: 'esrs_DatapointMdrm', id: any, datapoint: { __typename?: 'esrs_Datapoint', isMdrmDisclosed?: boolean | null, answer: { __typename?: 'esrs_Answer', id: any, reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string }, metric: { __typename?: 'EsrsMetric', reference: string, metricType?: QuestionType_Enum_ | null, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', materialStandard: { __typename?: 'esrs_MaterialStandard', standardRef: string, standard: { __typename?: 'EsrsStandard', title: string, order: number } } }> } } } } | null }> };

export type GetMetricsDisclosureRequirementsQueryVariables_ = Exact<{
  metricRefs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetMetricsDisclosureRequirementsQuery_ = { __typename?: 'query_root', EsrsMetric: Array<{ __typename?: 'EsrsMetric', reference: string, requirement: { __typename?: 'DisclosureRequirement', title: string, reference: string, frameworkRef?: string | null, type: string, order: number }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, title: string, type: string, order: number, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', title: string, reference: string, frameworkRef?: string | null, type: string, order: number } }> } }> }> };

export type GetCompanyUsersQueryVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
}>;


export type GetCompanyUsersQuery_ = { __typename?: 'query_root', CompanyUser: Array<{ __typename?: 'CompanyUser', user: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }> };

export type GetAssessmentDisclosureRequirementsQueryVariables_ = Exact<{
  assessmentId: Scalars['uuid']['input'];
}>;


export type GetAssessmentDisclosureRequirementsQuery_ = { __typename?: 'query_root', EsrsAssessment_by_pk?: { __typename?: 'EsrsAssessment', materialStandards: Array<{ __typename?: 'esrs_MaterialStandard', standard: { __typename?: 'EsrsStandard', title: string, order: number, reference: string }, materialMetrics: Array<{ __typename?: 'esrs_MaterialMetric', dataCollection?: string | null, metric: { __typename?: 'EsrsMetric', metricType?: QuestionType_Enum_ | null, reference: string, answers: Array<{ __typename?: 'esrs_Answer', reportingUnit: { __typename?: 'esrs_ReportingUnit', id: any, name: string }, datapoints: Array<{ __typename?: 'esrs_Datapoint', taskId?: any | null }> }>, requirement: { __typename?: 'DisclosureRequirement', title: string, reference: string, frameworkRef?: string | null, type: string, order: number }, mfDisclosureRequirements: Array<{ __typename?: 'MFDisclosureRequirementItem', mfDisclosureRequirement: { __typename?: 'MFDisclosureRequirement', reference: string, title: string, type: string, order: number, drToMFDisclosureRequirements: Array<{ __typename?: 'DRToMFDisclosureRequirement', disclosureRequirement: { __typename?: 'DisclosureRequirement', title: string, reference: string, frameworkRef?: string | null, type: string, order: number } }> } }> } }> }> } | null };

export type UpdateTasksMutationVariables_ = Exact<{
  tasksIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  _set: Task_Set_Input_;
}>;


export type UpdateTasksMutation_ = { __typename?: 'mutation_root', update_Task?: { __typename?: 'Task_mutation_response', affected_rows: number } | null };

export type UpdateTaskInProgressMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpdateTaskInProgressMutation_ = { __typename?: 'mutation_root', update_Task_by_pk?: { __typename?: 'Task', id: any } | null };

export type UpdateTaskCompletedMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UpdateTaskCompletedMutation_ = { __typename?: 'mutation_root', update_Task_by_pk?: { __typename?: 'Task', id: any } | null };

export type UpdateManyTasksInProgressMutationVariables_ = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type UpdateManyTasksInProgressMutation_ = { __typename?: 'mutation_root', update_Task?: { __typename?: 'Task_mutation_response', affected_rows: number } | null };

export type GetThreadQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetThreadQuery_ = { __typename?: 'query_root', thread?: { __typename?: 'Thread', id: any, companyId: any, answerId?: any | null, esrsDatapointId?: any | null, comments: Array<{ __typename?: 'Comment', id: any, createdAt: any, updatedAt: any, authorId: any, data: string, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }>, subscribers: Array<{ __typename?: 'ThreadSubscriber', userId: any }>, commentsAggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null };

export type ThreadSubscriptionVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ThreadSubscription_ = { __typename?: 'subscription_root', thread?: { __typename?: 'Thread', id: any, companyId: any, answerId?: any | null, esrsDatapointId?: any | null, comments: Array<{ __typename?: 'Comment', id: any, createdAt: any, updatedAt: any, authorId: any, data: string, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }>, subscribers: Array<{ __typename?: 'ThreadSubscriber', userId: any }>, commentsAggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null };

export type UpsertThreadMutationVariables_ = Exact<{
  thread: Thread_Insert_Input_;
}>;


export type UpsertThreadMutation_ = { __typename?: 'mutation_root', thread?: { __typename?: 'Thread', id: any, companyId: any, answerId?: any | null, esrsDatapointId?: any | null, answer?: { __typename?: 'Answer', id: any, thread?: { __typename?: 'Thread', id: any } | null } | null, esrsDatapoint?: { __typename?: 'esrs_Datapoint', id: any, thread?: { __typename?: 'Thread', id: any } | null } | null, comments: Array<{ __typename?: 'Comment', id: any, createdAt: any, updatedAt: any, authorId: any, data: string, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } }>, subscribers: Array<{ __typename?: 'ThreadSubscriber', userId: any }>, commentsAggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } | null };

export type AddCommentMutationVariables_ = Exact<{
  input: Comment_Insert_Input_;
  subscription: ThreadSubscriber_Insert_Input_;
}>;


export type AddCommentMutation_ = { __typename?: 'mutation_root', createComment?: { __typename?: 'Comment', id: any, createdAt: any, updatedAt: any, authorId: any, data: string, thread: { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any }>, commentsAggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } }, notificationsSent: { __typename?: 'UserNotification_aggregate', aggregate?: { __typename?: 'UserNotification_aggregate_fields', count: number } | null }, author: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } } | null, subscription?: { __typename?: 'ThreadSubscriber', id: any, isSubscribed: boolean, userId: any } | null };

export type RemoveCommentMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RemoveCommentMutation_ = { __typename?: 'mutation_root', deleteComment?: { __typename?: 'Comment', thread: { __typename?: 'Thread', id: any, comments: Array<{ __typename?: 'Comment', id: any }>, commentsAggregate: { __typename?: 'Comment_aggregate', aggregate?: { __typename?: 'Comment_aggregate_fields', count: number } | null } } } | null };

export type GetUserRoleInCompanyQueryVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
  companyId: Scalars['uuid']['input'];
}>;


export type GetUserRoleInCompanyQuery_ = { __typename?: 'query_root', roleInCompany?: { __typename?: 'CompanyUser', role: UserRole_Enum_ } | null };

export type UserCompaniesQueryVariables_ = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type UserCompaniesQuery_ = { __typename?: 'query_root', data?: { __typename?: 'users', companies: Array<{ __typename?: 'CompanyUser', company: { __typename?: 'Company', id: any, isPortfolioOwner: boolean, isGroupOwner: boolean, logoUrl?: string | null, name: string, settings: any, currency: string, compassId?: string | null, hasPaiAccess: boolean, hasIFRSAccess?: boolean | null, hasTCFDAccess: boolean, hasESRSOilAndGasAccess: boolean, hasEntitySpecificAccess: boolean, hasCustomQuestionsAccess: boolean, hasTaxonomyAccess: boolean, hasAiAccess: boolean, hasBulkUploadAccess?: boolean | null, hasSASBAccess: boolean, canDownloadEsrsReport: boolean, canDownloadTaxonomyReport: boolean, hasESRSAccess: boolean, hasVSMEAccess: boolean, isReal: boolean, isDemo: boolean, invitations: Array<{ __typename?: 'CompanyInvitation', userEmail: any, status: string, id: any }>, aiConfig?: { __typename?: 'AIConfig', preferredLanguage: string, toneOfVoice?: string | null } | null, subsidiaries: Array<{ __typename?: 'Subsidiary', id: any, ownerGroupAssessment: { __typename?: 'GroupAssessment', company?: { __typename?: 'Company', hasTaxonomyAccess: boolean } | null } }>, portfolioCompanies: Array<{ __typename?: 'PortfolioCompany', id: any, eligibilityStatus: string, portfolio: { __typename?: 'Portfolio', ownerCompany: { __typename?: 'Company', id: any, hasTaxonomyAccess: boolean } } }>, esrsAssessments: Array<{ __typename?: 'EsrsAssessment', id: any, reportingYear: number, frameworkRef?: string | null, projectLeader?: { __typename?: 'users', id: any, email?: any | null, avatarUrl: string, displayName: string } | null, reportingUnits: Array<{ __typename?: 'esrs_ReportingUnit', id: any, isCompanyLevel: boolean, reportingUnitLineage: { __typename?: 'esrs_ReportingUnitLineage', id: any } }> }> } }> } | null };

export type UserProvidersQueryVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type UserProvidersQuery_ = { __typename?: 'query_root', providers: Array<{ __typename?: 'authUserProviders', providerId: string }> };

export type UserDetailsQueryVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type UserDetailsQuery_ = { __typename?: 'query_root', user?: { __typename?: 'users', avatarUrl: string, displayName: string, email?: any | null } | null };

export type UpdateUserProfileMutationVariables_ = Exact<{
  id: Scalars['uuid']['input'];
  user?: InputMaybe<Users_Set_Input_>;
}>;


export type UpdateUserProfileMutation_ = { __typename?: 'mutation_root', user?: { __typename?: 'users', id: any, displayName: string, email?: any | null, metadata?: any | null, avatarUrl: string, locale: string } | null };

export type UpdateCompanyUserMutationVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
  role: UserRole_Enum_;
}>;


export type UpdateCompanyUserMutation_ = { __typename?: 'mutation_root', companyUser?: { __typename?: 'CompanyUser', companyId: any, userId: any, role: UserRole_Enum_ } | null };

export type GetUserIdFromRefreshTokenIdQueryVariables_ = Exact<{
  refreshTokenId: Scalars['uuid']['input'];
}>;


export type GetUserIdFromRefreshTokenIdQuery_ = { __typename?: 'query_root', authRefreshToken?: { __typename?: 'authRefreshTokens', userId: any } | null };

export type UserSessionsQueryVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type UserSessionsQuery_ = { __typename?: 'query_root', activeSessions: Array<{ __typename?: 'UserSessionMetadata', id: any, refreshTokenId?: any | null, userId: any, ipAddress?: string | null, operatingSystem?: string | null, browser?: string | null, device?: string | null, createdAt: any, updatedAt: any }>, inactiveSessions: Array<{ __typename?: 'UserSessionMetadata', id: any, refreshTokenId?: any | null, userId: any, ipAddress?: string | null, operatingSystem?: string | null, browser?: string | null, device?: string | null, createdAt: any, updatedAt: any }> };

export type DeleteCompanyUserMutationVariables_ = Exact<{
  companyId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
}>;


export type DeleteCompanyUserMutation_ = { __typename?: 'mutation_root', delete_CompanyUser_by_pk?: { __typename?: 'CompanyUser', companyId: any, userId: any } | null };

export type UpsertUserSessionMetadataMutationVariables_ = Exact<{
  sessionData: UserSessionMetadata_Insert_Input_;
}>;


export type UpsertUserSessionMetadataMutation_ = { __typename?: 'mutation_root', insert_UserSessionMetadata_one?: { __typename?: 'UserSessionMetadata', id: any, userId: any, refreshTokenId?: any | null, ipAddress?: string | null, operatingSystem?: string | null, browser?: string | null, device?: string | null, createdAt: any, updatedAt: any, deletedAt?: any | null } | null };

export type LogOutFromSessionMutationVariables_ = Exact<{
  sessionId: Scalars['uuid']['input'];
}>;


export type LogOutFromSessionMutation_ = { __typename?: 'mutation_root', deleteAuthRefreshToken?: { __typename?: 'authRefreshTokens', id: any, userId: any } | null };

export type UserMetadataQueryVariables_ = Exact<{
  userId: Scalars['uuid']['input'];
}>;


export type UserMetadataQuery_ = { __typename?: 'query_root', user?: { __typename?: 'users', id: any, metadata?: any | null } | null };

export type ProfilePictureQueryVariables_ = Exact<{ [key: string]: never; }>;


export type ProfilePictureQuery_ = { __typename?: 'query_root', files: Array<{ __typename?: 'files', id: any, name?: string | null }> };

export type HighestNumberSubscriptionVariables_ = Exact<{ [key: string]: never; }>;


export type HighestNumberSubscription_ = { __typename?: 'subscription_root', WebsocketTest_aggregate: { __typename?: 'WebsocketTest_aggregate', aggregate?: { __typename?: 'WebsocketTest_aggregate_fields', max?: { __typename?: 'WebsocketTest_max_fields', id?: number | null } | null } | null } };

export type CreateNumberMutationVariables_ = Exact<{ [key: string]: never; }>;


export type CreateNumberMutation_ = { __typename?: 'mutation_root', insert_WebsocketTest_one?: { __typename?: 'WebsocketTest', id: number } | null };

export const ActionQuestionFieldsFragmentDoc_ = gql`
    fragment ActionQuestionFields on ActionQuestion {
  title
  reference
  unit
  questionType
  description
  groupRef
  group {
    reference
    title
  }
  choiceSet {
    choices(order_by: {order: asc}) {
      title
      reference
    }
  }
}
    `;
export const ReportingUnitAnswersFieldsForAggregatedLevelFragmentDoc_ = gql`
    fragment ReportingUnitAnswersFieldsForAggregatedLevel on esrs_Answer {
  id
  metricRef
  hasOptedOut
  optOutReason
  metric {
    childrenMetrics {
      childMetricRef
    }
  }
  datapoints(order_by: {updatedAt: desc}) {
    id
    value
    factValue
    timeframe
    metadata
    isMdrmDisclosed
    datapointTags {
      tagValue
      tagType
    }
    answerId
    updatedAt
    datapointChoices(order_by: {choice: {order: asc}}) {
      choiceRef
      choice {
        reference
        title
      }
    }
    owner {
      id
      displayName
    }
    author {
      displayName
    }
  }
  reportingUnit {
    id
    isCompanyLevel
  }
}
    `;
export const MaterialMetricTagFieldsFragmentDoc_ = gql`
    fragment MaterialMetricTagFields on esrs_MaterialMetricTag {
  isOptional
  tagType
  id
  metricTagType {
    alwaysAll
  }
  materialTagValues(order_by: [{tag: {order: asc}}, {tag: {value: asc}}]) {
    tagType
    tagValue
    tag {
      order
    }
  }
  valueOptions: materialTagValues(
    order_by: [{tag: {order: asc}}, {tag: {value: asc}}]
  ) {
    tagValue
    tag {
      order
    }
  }
}
    `;
export const MaterialMetricWithChildrenFieldsForAggregatedLevelFragmentDoc_ = gql`
    fragment MaterialMetricWithChildrenFieldsForAggregatedLevel on esrs_MaterialMetric {
  id
  metricRef
  dataCollection
  isMaterial
  frequency
  materialMetricTags {
    ...MaterialMetricTagFields
  }
  materialStandard {
    id
    standardRef
  }
}
    ${MaterialMetricTagFieldsFragmentDoc_}`;
export const SimplifiedThreadFragmentDoc_ = gql`
    fragment SimplifiedThread on Thread {
  comments(where: {deletedAt: {_is_null: true}}) {
    id
    data
    authorId
    updatedAt
    duplicatedFrom
  }
  subscribers {
    userId
  }
  companyId
}
    `;
export const SimplifiedNoteHistoryFragmentDoc_ = gql`
    fragment SimplifiedNoteHistory on NoteHistory {
  id
  notes {
    authorId
    body
    isAIGenerated
    updatedAt
  }
}
    `;
export const SimplifiedAttachmentBoxFragmentDoc_ = gql`
    fragment SimplifiedAttachmentBox on AttachmentBox {
  id
  attachments(
    where: {deletedAt: {_is_null: true}, file: {deletedAt: {_is_null: true}}}
  ) {
    fileId
    updatedAt
  }
}
    `;
export const DuplicationActionFieldsFragmentDoc_ = gql`
    fragment DuplicationActionFields on esrs_Actions {
  updatedAt
  materialStandard {
    standardRef
  }
  actionReportingUnits {
    reportingUnitId
    reportingUnit {
      lineageId
    }
    updatedAt
  }
  noteHistory {
    ...SimplifiedNoteHistory
  }
  attachmentBox {
    ...SimplifiedAttachmentBox
  }
  title
  disclosureRequirementRef
  ownerId
  answers
  capex
  capexLongTerm
  capexShortTerm
  capexMediumTerm
  deadline
  expectedOutcome
  hasPreconditions
  hasPreconditionsExplanation
  investmentsAndResources
  noteReference
  opex
  opexLongTerm
  opexShortTerm
  opexMediumTerm
  progressInfo
  provisionOfRemedy
  provisionOfRemedyExplanation
  relatedIRO
  relatedPolicy
  statusOfKeyAction
  scope
  startDate
  timeHorizon
  scopeValueChain
  coverage
  coverageExplanation
  sustainabilityMatter
  sustainabilityMatterExplanation
}
    ${SimplifiedNoteHistoryFragmentDoc_}
${SimplifiedAttachmentBoxFragmentDoc_}`;
export const ShortUserFragmentDoc_ = gql`
    fragment ShortUser on users {
  id
  email
  avatarUrl
  displayName
}
    `;
export const EsrsAssessmentFieldsFragmentDoc_ = gql`
    fragment EsrsAssessmentFields on EsrsAssessment {
  id
  reportingYear
  onboardingStep
  companySize
  parentAssessment {
    id
    company {
      id
      name
      logoUrl
    }
  }
  materialStandards {
    id
    standardRef
  }
  subsidiaryAssessments(where: {deletedAt: {_is_null: true}}) {
    id
    onboardingStep
    company {
      name
      id
    }
    projectLeader {
      ...ShortUser
    }
  }
  reportingUnits {
    id
    name
    assessmentId
    isCompanyLevel
    lineageId
    projectLeaderId
    projectLeader {
      ...ShortUser
    }
  }
  company {
    id
    name
  }
  projectLeader {
    ...ShortUser
  }
}
    ${ShortUserFragmentDoc_}`;
export const MetricMfDisclosureRequirementsFragmentFragmentDoc_ = gql`
    fragment MetricMFDisclosureRequirementsFragment on EsrsMetric {
  mfDisclosureRequirements {
    mfDisclosureRequirement {
      reference
      drToMFDisclosureRequirements {
        disclosureRequirement {
          reference
          frameworkRef
        }
      }
    }
  }
}
    `;
export const AssessmentMaterialStandardsFieldsFragmentDoc_ = gql`
    fragment AssessmentMaterialStandardsFields on EsrsAssessment {
  id
  collectOnly
  parentAssessmentId
  reportingYear
  company {
    name
  }
  materialStandards(order_by: {standard: {order: asc}}) {
    id
    standardRef
    standard {
      reference
      frameworkRef
      category {
        title
        reference
      }
    }
    isMaterial
    isDataGatheringOnly
    isPhasedIn
    disclosureRequirementStatuses {
      disclosureRequirementRef
      mfDisclosureRequirementRef
      isConfigured
    }
    materialMetrics {
      id
      metricRef
      isMaterial
      dataCollection
      isDataGatheringOnly
      metric {
        reference
        isAssessable
        disclosureRequirementRef
        ...MetricMFDisclosureRequirementsFragment
        requirement {
          reference
          type
          frameworkRef
        }
        childrenMetrics {
          childMetricRef
        }
        childrenMetricsCount
      }
    }
  }
}
    ${MetricMfDisclosureRequirementsFragmentFragmentDoc_}`;
export const NoteHistoryFragmentDoc_ = gql`
    fragment NoteHistory on NoteHistory {
  id
  notes(order_by: {updatedAt: desc}) {
    body
    author {
      ...ShortUser
    }
    updatedAt
    isAIGenerated
  }
}
    ${ShortUserFragmentDoc_}`;
export const DocumentationFileDetailsFragmentDoc_ = gql`
    fragment DocumentationFileDetails on DocumentationFile {
  id
  title
  description
  storageFile {
    mimeType
    id
    name
    createdAt
    uploadedBy {
      ...ShortUser
    }
  }
  source
  tags
  creationDate
  updatedAt
  lastUpdatedBy {
    ...ShortUser
  }
  deletedAt
}
    ${ShortUserFragmentDoc_}`;
export const AttachmentFragmentDoc_ = gql`
    fragment Attachment on Attachment {
  id
  file {
    ...DocumentationFileDetails
  }
}
    ${DocumentationFileDetailsFragmentDoc_}`;
export const AttachmentBoxFragmentDoc_ = gql`
    fragment AttachmentBox on AttachmentBox {
  id
  attachments(
    order_by: {updatedAt: asc}
    where: {deletedAt: {_is_null: true}, file: {deletedAt: {_is_null: true}}}
  ) {
    ...Attachment
  }
}
    ${AttachmentFragmentDoc_}`;
export const PolicyFieldsFragmentDoc_ = gql`
    fragment PolicyFields on esrs_Policy {
  id
  disclosureRequirementRef
  assessmentId
  noteHistory {
    ...NoteHistory
  }
  attachmentBox {
    ...AttachmentBox
  }
}
    ${NoteHistoryFragmentDoc_}
${AttachmentBoxFragmentDoc_}`;
export const TargetFieldsFragmentDoc_ = gql`
    fragment TargetFields on esrs_Target {
  id
  disclosureRequirementRef
  name
  direction
  metricRef
  isBottomUp
  description
  assessmentId
  ownerId
  isRequired
  answers
  relatedIRO
  relatedPolicy
  period
  periodExplanation
  scope
  methodologies
  isEvidenceScientific
  isEvidenceScientificExplanation
  withStakeholders
  withStakeholdersExplanation
  withStakeholdersDescription
  targetChangeDescription
  isProgressAligned
  performanceNumber
  performanceText
  isProgressAlignedExplanation
  sustainabilityMatter
  sustainabilityMatterExplanation
  relationshipToPolicy
  coverage
  coverageExplanation
  owner {
    id
    displayName
    avatarUrl
  }
  metric {
    reference
    title
    unitOfMeasurement
  }
  actionTargets {
    id
    actionId
    action {
      id
      title
    }
    estimate
  }
  keyResults {
    id
    baseline
    baseYear
    reportingUnitId
    isFlagged
  }
  parentTargetId
  parentTarget {
    name
    materialStandard {
      esrsAssessment {
        company {
          name
        }
      }
    }
    milestones {
      id
      year
    }
  }
  materialStandard {
    id
    assessmentId
    standardRef
    esrsAssessment {
      id
      company {
        id
        name
      }
    }
  }
  subsidiariesTargets {
    id
    metricRef
  }
  milestones {
    id
    year
    isRelative
    isRequired
    milestoneResults {
      id
      value
      reportingUnitId
    }
  }
}
    `;
export const ActionFieldsFragmentDoc_ = gql`
    fragment ActionFields on esrs_Actions {
  id
  disclosureRequirementRef
  title
  deadline
  startDate
  ownerId
  capex
  noteReference
  timeHorizon
  answers
  relatedIRO
  relatedPolicy
  statusOfKeyAction
  scope
  expectedOutcome
  provisionOfRemedy
  provisionOfRemedyExplanation
  progressInfo
  investmentsAndResources
  hasPreconditions
  hasPreconditionsExplanation
  opex
  opexShortTerm
  opexMediumTerm
  opexLongTerm
  capexShortTerm
  capexMediumTerm
  capexLongTerm
  scopeValueChain
  coverage
  coverageExplanation
  sustainabilityMatter
  sustainabilityMatterExplanation
  statusOfKeyActionExplanation
  owner {
    ...ShortUser
  }
  actionTargets {
    id
    estimate
    target {
      id
      direction
      name
      metric {
        title
        unitOfMeasurement
      }
    }
  }
  actionReportingUnits {
    id
    reportingUnit {
      id
      name
    }
  }
  actionSubsidiaries(where: {subsidiaryAssessment: {deletedAt: {_is_null: true}}}) {
    id
    subsidiaryAssessment {
      id
      company {
        id
        name
      }
    }
  }
  materialStandard {
    assessmentId
    standard {
      reference
    }
    esrsAssessment {
      id
      company {
        id
        name
      }
    }
  }
  attachmentBox {
    id
  }
  noteHistory {
    id
  }
}
    ${ShortUserFragmentDoc_}`;
export const TargetsWithSubsidiariesFragmentDoc_ = gql`
    fragment TargetsWithSubsidiaries on esrs_Target {
  ...TargetFields
  parentTarget {
    actionTargets {
      id
      actionId
      estimate
      action {
        ...ActionFields
      }
    }
  }
  subsidiariesTargets {
    ...TargetFields
  }
}
    ${TargetFieldsFragmentDoc_}
${ActionFieldsFragmentDoc_}`;
export const TargetQuestionFieldsFragmentDoc_ = gql`
    fragment TargetQuestionFields on TargetQuestion {
  title
  reference
  unit
  questionType
  description
  groupRef
  group {
    reference
    title
  }
  choiceSet {
    choices(order_by: {order: asc}) {
      title
      reference
    }
  }
}
    `;
export const ChildMetricFieldsFragmentDoc_ = gql`
    fragment ChildMetricFields on EsrsMetric {
  reference
  title
}
    `;
export const EsrsMetricsFieldsFragmentDoc_ = gql`
    fragment EsrsMetricsFields on EsrsMetric {
  title
  shortTitle
  reference
  description
  metricType
  disclosureRequirementRef
  isAssessable
  calculation
  unitOfMeasurement
  showAsPercentage
  hasAssociation
  childrenMetrics {
    childMetric {
      ...ChildMetricFields
    }
  }
  order
  firstLevel
  secondLevel
  globalOrder
  isAR
  additionalTypes {
    additionalType {
      reference
      title
      description
      learnMore
    }
  }
  hasAssociation
  unlockCondition
  showPercentageWithTag
  adminPanelTags: tags {
    values: tagType {
      alwaysAll
      tagValues(order_by: [{order: asc}, {value: asc}]) {
        value
        type
      }
    }
    isOptional
    type
  }
  notAggregatable
  abbreviation
}
    ${ChildMetricFieldsFragmentDoc_}`;
export const ChildlessEsrsMetricsFieldsFragmentDoc_ = gql`
    fragment ChildlessEsrsMetricsFields on EsrsMetric {
  notAggregatable
  title
  shortTitle
  reference
  description
  metricType
  isAssessable
  disclosureRequirementRef
  requirement {
    frameworkRef
  }
  showAsPercentage
  calculation
  unitOfMeasurement
  hasAssociation
  additionalTypes {
    additionalType {
      reference
      title
      description
      learnMore
    }
  }
  order
  isAR
  firstLevel
  secondLevel
  globalOrder
  parentMetrics {
    parentMetricRef
    parentMetric {
      metricType
    }
  }
  unlockCondition
  showPercentageWithTag
  choiceSet {
    choices(order_by: {order: asc}) {
      title
      reference
    }
  }
  adminPanelTags: tags {
    values: tagType {
      alwaysAll
      tagValues(order_by: [{order: asc}, {value: asc}]) {
        value
        type
      }
    }
    isOptional
    type
  }
}
    `;
export const EsrsMetricDetailedFieldsFragmentDoc_ = gql`
    fragment EsrsMetricDetailedFields on EsrsMetric {
  childMetricsCount: childrenMetrics_aggregate {
    aggregate {
      count
    }
  }
  parentMetricsCount: parentMetrics_aggregate {
    aggregate {
      count
    }
  }
  notAggregatable
  adminPanelTags: tags {
    values: tagType {
      alwaysAll
      tagValues(order_by: [{order: asc}, {value: asc}]) {
        value
        type
      }
    }
    isOptional
    type
  }
}
    `;
export const ChildlessEsrsReportMetricsFieldsFragmentDoc_ = gql`
    fragment ChildlessEsrsReportMetricsFields on EsrsMetric {
  title
  shortTitle
  reference
  metricType
  isAssessable
  disclosureRequirementRef
  requirement {
    frameworkRef
  }
  mfDisclosureRequirements {
    mfDisclosureRequirementRef
  }
  showAsPercentage
  calculation
  hasAssociation
  unitOfMeasurement
  unlockCondition
  hasAssociation
  additionalTypes {
    additionalType {
      reference
      title
    }
  }
  order
  isAR
  firstLevel
  secondLevel
  globalOrder
  parentMetrics {
    parentMetricRef
    parentMetric {
      metricType
    }
  }
  hasAssociation
  showPercentageWithTag
  choiceSet {
    choices(order_by: {order: asc}) {
      title
      reference
    }
  }
  notAggregatable
}
    `;
export const EsrsMetricChildDetailedFieldsFragmentDoc_ = gql`
    fragment EsrsMetricChildDetailedFields on esrs_MaterialMetric {
  id
  frequency
  dataCollection
  materialStandardId
  isMaterial
  materialStandard {
    isMaterial
  }
  materialMetricTags {
    tagType
    isOptional
    id
    metricTagType {
      alwaysAll
    }
    materialTagValues(order_by: [{tag: {order: asc}}, {tag: {value: asc}}]) {
      tagType
      tagValue
    }
  }
}
    `;
export const DataCollectionChildlessMetricsFieldsFragmentDoc_ = gql`
    fragment DataCollectionChildlessMetricsFields on EsrsMetric {
  reference
  title
  shortTitle
  description
  metricType
  disclosureRequirementRef
  requirement {
    frameworkRef
  }
  order
  isAR
  firstLevel
  secondLevel
  hasAssociation
  additionalTypes {
    additionalType {
      reference
      title
      description
      learnMore
    }
  }
  parentMetrics {
    parentMetricRef
    parentMetric {
      title
    }
  }
  hasAssociation
  notAggregatable
  abbreviation
}
    `;
export const ShortMetricFragmentDoc_ = gql`
    fragment ShortMetric on EsrsMetric {
  title
  reference
}
    `;
export const DatapointFieldsFragmentDoc_ = gql`
    fragment DatapointFields on esrs_Datapoint {
  id
  answerId
  authorId
  ownerId
  value
  factValue
  timeframe
  source
  metadata
  lastEdited
  owner {
    ...ShortUser
  }
  author {
    ...ShortUser
  }
  updatedAt
  datapointTags {
    tagValue
    tagType
  }
  task {
    id
    dueDate
    status
    owner {
      ...ShortUser
    }
  }
  thread {
    id
    comments {
      id
    }
    comments_aggregate(where: {deletedAt: {_is_null: true}}) {
      aggregate {
        count
      }
    }
  }
  datapointChoices(order_by: {choice: {order: asc}}) {
    choiceRef
    choice {
      reference
      title
    }
  }
  isMdrmDisclosed
  mdrmElsewhereDisclosure
}
    ${ShortUserFragmentDoc_}`;
export const EsrsAnswersFieldsFragmentDoc_ = gql`
    fragment EsrsAnswersFields on esrs_Answer {
  id
  reportingUnitId
  metricRef
  metric {
    ...ShortMetric
    childrenMetrics {
      childMetricRef
    }
  }
  hasOptedOut
  optOutReason
  optOutAuthorId
  optOutAuthor {
    ...ShortUser
  }
  assessmentId
  datapoints(order_by: {updatedAt: desc}) {
    ...DatapointFields
  }
}
    ${ShortMetricFragmentDoc_}
${ShortUserFragmentDoc_}
${DatapointFieldsFragmentDoc_}`;
export const ReportMaterialMetricsFieldsFragmentDoc_ = gql`
    fragment ReportMaterialMetricsFields on esrs_MaterialMetric {
  metric {
    reference
  }
  id
  dataCollection
  frequency
  materialStandardId
  isMaterial
  isHidden
  materialMetricTags {
    ...MaterialMetricTagFields
  }
}
    ${MaterialMetricTagFieldsFragmentDoc_}`;
export const MaterialMetricsFieldsFragmentDoc_ = gql`
    fragment MaterialMetricsFields on esrs_MaterialMetric {
  metric {
    reference
  }
  id
  dataCollection
  frequency
  materialStandardId
  isMaterial
  isDataGatheringOnly
  isPhasedIn
  isHidden
  materialMetricTags {
    ...MaterialMetricTagFields
  }
  materialStandard {
    id
    standardRef
    isMaterial
    esrsAssessment {
      id
    }
  }
}
    ${MaterialMetricTagFieldsFragmentDoc_}`;
export const ReportingUnitAnswersFieldsFragmentDoc_ = gql`
    fragment ReportingUnitAnswersFields on esrs_Answer {
  id
  metricRef
  metric {
    childrenMetrics {
      childMetricRef
    }
  }
  hasOptedOut
  optOutReason
  datapoints(order_by: {updatedAt: desc}) {
    id
    ownerId
    source
    value
    factValue
    metadata
    timeframe
    lastEdited
    datapointTags {
      tagValue
      tagType
    }
    datapointChoices(order_by: {choice: {order: asc}}) {
      choiceRef
      choice {
        reference
        title
      }
    }
    answerId
    author {
      displayName
    }
    owner {
      displayName
    }
    updatedAt
  }
  updatedAt
  reportingUnit {
    id
    isCompanyLevel
  }
}
    `;
export const MaterialMetricWithChildrenFieldsFragmentDoc_ = gql`
    fragment MaterialMetricWithChildrenFields on esrs_MaterialMetric {
  metric {
    reference
  }
  id
  dataCollection
  isMaterial
  frequency
  materialStandardId
  isHidden
  materialMetricTags {
    ...MaterialMetricTagFields
  }
  materialStandard {
    id
    standardRef
    esrsAssessment {
      id
    }
  }
  metric {
    title
    reference
    requirement {
      reference
    }
    childrenMetrics {
      childMetric {
        reference
        requirement {
          reference
        }
        childrenMetrics {
          childMetric {
            reference
            requirement {
              reference
            }
            childrenMetrics {
              childMetric {
                reference
                requirement {
                  reference
                }
                childrenMetrics {
                  childMetric {
                    reference
                    requirement {
                      reference
                    }
                    childrenMetrics {
                      childMetric {
                        reference
                        requirement {
                          reference
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${MaterialMetricTagFieldsFragmentDoc_}`;
export const ProgressMaterialMetricsFragmentFragmentDoc_ = gql`
    fragment ProgressMaterialMetricsFragment on esrs_MaterialMetric {
  id
  metricRef
  isMaterial
  dataCollection
  frequency
  materialMetricTags {
    id
    tagType
    valueOptions: materialTagValues(
      order_by: [{tag: {order: asc}}, {tag: {value: asc}}]
    ) {
      tagValue
    }
  }
  metric {
    metricType
    disclosureRequirementRef
    requirement {
      reference
      frameworkRef
    }
    ...MetricMFDisclosureRequirementsFragment
    isAssessable
    childrenMetrics_aggregate {
      aggregate {
        count
      }
    }
    parentMetrics {
      parentMetric {
        reference
        metricType
        unlockCondition
        parentMetrics {
          parentMetric {
            reference
            metricType
            unlockCondition
          }
        }
      }
    }
  }
}
    ${MetricMfDisclosureRequirementsFragmentFragmentDoc_}`;
export const ProgressAnswersFragmentFragmentDoc_ = gql`
    fragment ProgressAnswersFragment on esrs_Answer {
  id
  metricRef
  hasOptedOut
  metric {
    disclosureRequirementRef
    requirement {
      frameworkRef
    }
    ...MetricMFDisclosureRequirementsFragment
  }
  datapoints(order_by: {updatedAt: desc}) {
    id
    value
    timeframe
    factValue
    metadata
    updatedAt
    datapointTags {
      tagValue
      tagType
    }
    datapointChoices_aggregate {
      aggregate {
        count
      }
    }
  }
}
    ${MetricMfDisclosureRequirementsFragmentFragmentDoc_}`;
export const UserFieldsFragmentDoc_ = gql`
    fragment userFields on users {
  id
  createdAt
  disabled
  displayName
  avatarUrl
  email
  passwordHash
  emailVerified
  phoneNumber
  phoneNumberVerified
  defaultRole
  isAnonymous
  ticket
  otpHash
  totpSecret
  activeMfaType
  newEmail
  locale
  metadata
  roles {
    role
  }
}
    `;
export const FileMetadataFragmentFragmentDoc_ = gql`
    fragment FileMetadataFragment on files {
  id
  name
  size
  bucketId
  etag
  createdAt
  updatedAt
  isUploaded
  mimeType
  uploadedByUserId
  metadata
}
    `;
export const FileMetadataSummaryFragmentFragmentDoc_ = gql`
    fragment FileMetadataSummaryFragment on files {
  id
  name
  bucketId
  isUploaded
}
    `;
export const BucketMetadataFragmentFragmentDoc_ = gql`
    fragment BucketMetadataFragment on buckets {
  id
  minUploadFileSize
  maxUploadFileSize
  presignedUrlsEnabled
  downloadExpiration
  createdAt
  updatedAt
  cacheControl
}
    `;
export const RemoteAppGetUsersFragmentDoc_ = gql`
    fragment RemoteAppGetUsers on users {
  id
  createdAt
  displayName
  avatarUrl
  email
  emailVerified
  phoneNumber
  phoneNumberVerified
  disabled
  defaultRole
  lastSeen
  locale
  roles {
    id
    role
  }
  userProviders {
    id
    providerId
  }
  disabled
}
    `;
export const TargetDocumentationFragmentDoc_ = gql`
    fragment TargetDocumentation on esrs_Target {
  id
  attachmentBox {
    ...AttachmentBox
  }
  noteHistory {
    ...NoteHistory
  }
}
    ${AttachmentBoxFragmentDoc_}
${NoteHistoryFragmentDoc_}`;
export const DisclosureRequirementAttachmentDocumentationFragmentDoc_ = gql`
    fragment DisclosureRequirementAttachmentDocumentation on esrs_DisclosureRequirementAttachment {
  id
  attachmentBox {
    ...AttachmentBox
  }
}
    ${AttachmentBoxFragmentDoc_}`;
export const CompanyAssessmentDetailsFieldsFragmentDoc_ = gql`
    fragment CompanyAssessmentDetailsFields on CompanyAssessment {
  id
  startDate
  endDate
  isLocked
  createdAt
  deletedAt
  cachedResultId
  aggregate {
    id
    title
    interval
    startDate
    contactPerson {
      id
      email
      avatarUrl
      displayName
    }
  }
  bAssesssments {
    updatedAt
    activityReports {
      answers(limit: 1, order_by: {updatedAt: asc}) {
        updatedAt
      }
    }
    lastEditedFinancials: activityReports(
      limit: 1
      order_by: {financials: {updatedAt: asc}}
    ) {
      financials {
        updatedAt
      }
    }
  }
  updatedAt
  portfoliosWithAccess {
    quarter
    year
    portfolio {
      name
      ownerCompany {
        name
      }
    }
    contactPersonName
    contactPersonEmail
  }
}
    `;
export const GroupAssessmentFieldsFragmentDoc_ = gql`
    fragment GroupAssessmentFields on GroupAssessment {
  id
  name
  period
  uploadedAt
  consolidatedCompanyAssessmentId
  consolidatedCompanyAssessment {
    aggregateId
    isLocked
  }
  consolidatedCsvId
}
    `;
export const GroupAssessmentSubsidiariesFieldsFragmentDoc_ = gql`
    fragment GroupAssessmentSubsidiariesFields on Subsidiary {
  id
  sharedCompanyAssessment {
    id
    isLocked
    cachedResult {
      financials
      score
      progress
    }
  }
  company {
    id
    name
    logoUrl
    isGroupOwner
  }
  contactPersonName
  contactPersonEmail
}
    `;
export const TagGroupFieldsFragmentDoc_ = gql`
    fragment TagGroupFields on TagGroup {
  id
  name
  description
}
    `;
export const TagFieldsFragmentDoc_ = gql`
    fragment TagFields on Tag {
  id
  description
  name
  tagGroup {
    ...TagGroupFields
  }
}
    ${TagGroupFieldsFragmentDoc_}`;
export const ArticleFieldsFragmentDoc_ = gql`
    fragment ArticleFields on Article {
  id
  body
  title
  slug
  isHidden
  order
  tags {
    Tag {
      ...TagFields
    }
  }
}
    ${TagFieldsFragmentDoc_}`;
export const InvestorFieldsFragmentDoc_ = gql`
    fragment InvestorFields on PortfolioCompany {
  id
  year
  quarter
  valueOfInvestments
  updatedAt
  contactPersonName
  contactPersonEmail
  portfolioId
  portfolio {
    name
    ownerCompany {
      name
      hasPaiAccess
      logoUrl
    }
  }
  sharedCompanyAssessmentId
  sharedPaiCompanyReportId
  sharedAssessment {
    id
    aggregate {
      title
    }
    startDate
    cachedResult {
      progress
    }
  }
  eligibilityStatus
}
    `;
export const UserPortfolioCompanyFragmentDoc_ = gql`
    fragment UserPortfolioCompany on PortfolioCompany {
  id
  scores
}
    `;
export const UpdateOwnerCompanyFieldsFragmentDoc_ = gql`
    fragment UpdateOwnerCompanyFields on Portfolio {
  ownerCompany {
    id
    portfolios {
      name
    }
  }
}
    `;
export const NudgePortfolioCompaniesFieldsFragmentDoc_ = gql`
    fragment NudgePortfolioCompaniesFields on NudgePortfolioCompaniesOutput {
  emailsSent
  error
}
    `;
export const NudgeGroupCompaniesFieldsFragmentDoc_ = gql`
    fragment NudgeGroupCompaniesFields on NudgeGroupCompaniesOutput {
  emailsSent
  error
}
    `;
export const ObjectiveFieldsFragmentDoc_ = gql`
    fragment ObjectiveFields on Objective {
  title
  description
  key
}
    `;
export const CachedResultFieldsFragmentDoc_ = gql`
    fragment CachedResultFields on CachedResult {
  id
  score
  progress
  activityRef
  activityVersionNumber
  financials
  activityTag
  isAligned
  isCompleted
  isDirty
  objectivesState
  status
}
    `;
export const UserFragmentDoc_ = gql`
    fragment User on users {
  id
  displayName
  email
  createdAt
  updatedAt
  metadata
  avatarUrl
  locale
  lastSeen
}
    `;
export const ThreadUpdateFragmentDoc_ = gql`
    fragment ThreadUpdate on Thread {
  id
  comments(where: {deletedAt: {_is_null: true}}) {
    id
  }
  commentsAggregate: comments_aggregate(where: {deletedAt: {_is_null: true}}) {
    aggregate {
      count
    }
  }
}
    `;
export const CommentFieldsFragmentDoc_ = gql`
    fragment CommentFields on Comment {
  id
  createdAt
  updatedAt
  authorId
  author {
    ...ShortUser
  }
  data
}
    ${ShortUserFragmentDoc_}`;
export const ThreadFieldsFragmentDoc_ = gql`
    fragment ThreadFields on Thread {
  id
  companyId
  answerId
  esrsDatapointId
  ...ThreadUpdate
  comments(where: {deletedAt: {_is_null: true}}) {
    ...CommentFields
  }
  subscribers(where: {isSubscribed: {_eq: true}}) {
    userId
  }
}
    ${ThreadUpdateFragmentDoc_}
${CommentFieldsFragmentDoc_}`;
export const BusinessUnitInAssessmentFragmentDoc_ = gql`
    fragment BusinessUnitInAssessment on BusinessUnit {
  id
  createdAt
  name
  companyId
  description
  contactPerson {
    ...ShortUser
  }
}
    ${ShortUserFragmentDoc_}`;
export const ReportingGroupFieldsFragmentDoc_ = gql`
    fragment ReportingGroupFields on ReportingGroup {
  id
  name
  businessUnits(where: {deletedAt: {_is_null: true}}) {
    businessUnit {
      ...BusinessUnitInAssessment
    }
    bAssessmentId: id
    orderIndex
  }
  orderIndex
  owner {
    ...ShortUser
  }
  parentId
  updatedAt
  createdAt
}
    ${BusinessUnitInAssessmentFragmentDoc_}
${ShortUserFragmentDoc_}`;
export const QuestionFieldsFragmentDoc_ = gql`
    fragment QuestionFields on Question {
  id
  title
  questionSetRef
  questionSets {
    questionSet {
      reference
    }
  }
  description
  type
  level
  levelExpression
  group
  orderIndex
  uniqueId
  unit
  resourceLink
  documentationRequired
  aboutDocumentation
  alignmentErrorMessage
  objective {
    key
    title
  }
  isVisible
  isEditable
  isRequired
  isAligned
  dependencyDescription
  choices(order_by: {order: asc}) {
    value
    displayName
    order
  }
  extendedDescription
  other
  learnMoreArticleSlug
}
    `;
export const QuestionSetFieldsFragmentDoc_ = gql`
    fragment QuestionSetFields on QuestionSet {
  reference
  activityQuestionSets {
    activityRef
  }
  questions {
    question {
      ...QuestionFields
    }
  }
}
    ${QuestionFieldsFragmentDoc_}`;
export const ShortAnswerFieldsFragmentDoc_ = gql`
    fragment ShortAnswerFields on Answer {
  id
  questionId
  updatedAt
  createdAt
  data
  reportId
  thread {
    id
    commentsAggregate: comments_aggregate(where: {deletedAt: {_is_null: true}}) {
      aggregate {
        count
      }
    }
  }
}
    `;
export const AnswerFieldsFragmentDoc_ = gql`
    fragment AnswerFields on Answer {
  ...ShortAnswerFields
  answeredBy {
    ...ShortUser
  }
  question {
    id
    uniqueId
  }
  flagged
  attachmentBox {
    id
    attachments(
      where: {deletedAt: {_is_null: true}, file: {deletedAt: {_is_null: true}}}
      order_by: {updatedAt: asc}
    ) {
      id
      file {
        ...DocumentationFileDetails
      }
    }
  }
  thread {
    id
    commentsAggregate: comments_aggregate(where: {deletedAt: {_is_null: true}}) {
      aggregate {
        count
      }
    }
    comments(where: {deletedAt: {_is_null: true}}) {
      id
      data
    }
  }
  noteHistory {
    id
    notes(order_by: {updatedAt: desc}) {
      body
      updatedAt
      author {
        ...ShortUser
      }
      isAIGenerated
    }
  }
}
    ${ShortAnswerFieldsFragmentDoc_}
${ShortUserFragmentDoc_}
${DocumentationFileDetailsFragmentDoc_}`;
export const CompanyShortFragmentDoc_ = gql`
    fragment CompanyShort on Company {
  id
  name
  logoUrl
  isPortfolioOwner
}
    `;
export const EstimateCompanyFieldsFragmentDoc_ = gql`
    fragment EstimateCompanyFields on EstimateCompany_deprecated {
  createdAt
  id
  industries
  logoUrl
  metadata
  name
  scores
  updatedAt
  scoreType
}
    `;
export const PossibleInvestmentFirmFragmentDoc_ = gql`
    fragment PossibleInvestmentFirm on Company {
  id
  name
  logoUrl
  isPortfolioOwner
  currency
  portfolios(where: {deletedAt: {_is_null: true}}) {
    id
    name
    description
    totalAmount
    portfolioCompanies {
      id
      scores
      marketValue
      company {
        currency
        ...CompanyShort
      }
      estimateCompany {
        ...EstimateCompanyFields
      }
      contactPersonEmail
      contactPersonName
      sharedAssessment {
        isLocked
        cachedResult {
          score
          progress
          objectivesState
        }
      }
      sharedPaiCompanyReportId
      eligibilityStatus
      year
      quarter
      valueOfInvestments
      createdAt
    }
    taxonomyReports {
      year
      sendOutDate
      dueDate
      contactPerson {
        displayName
      }
    }
  }
}
    ${CompanyShortFragmentDoc_}
${EstimateCompanyFieldsFragmentDoc_}`;
export const PortfolioCompanyFragmentDoc_ = gql`
    fragment PortfolioCompany on PortfolioCompany {
  id
  scores
  marketValue
  company {
    ...PossibleInvestmentFirm
  }
  estimateCompany {
    ...EstimateCompanyFields
  }
  contactPersonEmail
  contactPersonName
  sharedAssessment {
    isLocked
    cachedResult {
      score
      progress
      objectivesState
    }
  }
  sharedPaiCompanyReportId
  eligibilityStatus
  year
  quarter
  valueOfInvestments
  createdAt
}
    ${PossibleInvestmentFirmFragmentDoc_}
${EstimateCompanyFieldsFragmentDoc_}`;
export const PortfolioFieldsFragmentDoc_ = gql`
    fragment PortfolioFields on Portfolio {
  id
  name
  description
  totalAmount
  portfolioCompanies(where: {companyId: {_is_null: false}}) {
    ...PortfolioCompany
  }
  taxonomyReports {
    year
    quarter
    sendOutDate
    dueDate
    contactPerson {
      displayName
    }
  }
  portfolioNonEligibleFinancials {
    id
    value
    type
    year
    quarter
  }
}
    ${PortfolioCompanyFragmentDoc_}`;
export const InvesteeMetricFieldsFragmentDoc_ = gql`
    fragment InvesteeMetricFields on InvesteeMetric {
  title
  description
  dependencies
  additionalResources
  type
  methodology
  reference
  unit
  order
}
    `;
export const InvestorMetricFieldsFragmentDoc_ = gql`
    fragment InvestorMetricFields on InvestorMetric {
  title
  description
  reference
  methodology
  unit
  isAggregatable
  investeeMetrics {
    metric: investeeMetric {
      ...InvesteeMetricFields
    }
  }
}
    ${InvesteeMetricFieldsFragmentDoc_}`;
export const PaiIndicatorFieldsFragmentDoc_ = gql`
    fragment PaiIndicatorFields on PaiTableIndicator {
  category {
    title
    reference
    subtitle
    table {
      isCustom
      title
    }
  }
  title
  description
  reference
  isHidden
  investorMetrics {
    investorMetric {
      ...InvestorMetricFields
    }
  }
}
    ${InvestorMetricFieldsFragmentDoc_}`;
export const PaiPortfolioReportFieldsFragmentDoc_ = gql`
    fragment PaiPortfolioReportFields on PaiPortfolioReport {
  dueDate
  id
  reportingPeriod
  year
  quarter
  sendOutDates
  dueDates
  contactPerson {
    ...ShortUser
  }
  portfolio {
    id
    name
  }
  selectedIndicators {
    indicator {
      ...PaiIndicatorFields
    }
    paiTableIndicatorReference
    isNew
    periods
    isForAllCompanies
    paiReportIndicatorPortfolioCompanies {
      portfolioCompanyId
      portfolioCompany {
        year
        company {
          name
          id
        }
      }
    }
  }
}
    ${ShortUserFragmentDoc_}
${PaiIndicatorFieldsFragmentDoc_}`;
export const PaiIndicatorFieldsV2FragmentDoc_ = gql`
    fragment PaiIndicatorFieldsV2 on PaiTableIndicator {
  category {
    title
    reference
    subtitle
    table {
      isCustom
      title
      reference
    }
  }
  title
  description
  reference
  isHidden
  investorMetrics {
    investorMetric {
      ...InvestorMetricFields
    }
  }
  order
}
    ${InvestorMetricFieldsFragmentDoc_}`;
export const PaiPortfolioReportFieldsV2FragmentDoc_ = gql`
    fragment PaiPortfolioReportFieldsV2 on PaiPortfolioReport {
  dueDate
  id
  reportingPeriod
  year
  quarter
  sendOutDates
  dueDates
  contactPerson {
    ...ShortUser
  }
  portfolio {
    id
    name
  }
  selectedIndicators {
    indicator {
      ...PaiIndicatorFieldsV2
    }
    paiTableIndicatorReference
    isNew
    periods
    isForAllCompanies
    paiReportIndicatorPortfolioCompanies {
      portfolioCompanyId
      portfolioCompany {
        year
        company {
          name
          id
        }
      }
    }
  }
}
    ${ShortUserFragmentDoc_}
${PaiIndicatorFieldsV2FragmentDoc_}`;
export const PaiCategoryFieldsFragmentDoc_ = gql`
    fragment PaiCategoryFields on PaiCategory {
  title
  subtitle
  reference
  indicators {
    ...PaiIndicatorFields
  }
}
    ${PaiIndicatorFieldsFragmentDoc_}`;
export const PaiTableFieldsFragmentDoc_ = gql`
    fragment PaiTableFields on PaiTable {
  isMandatory
  title
  reference
  subtitle
  isCustom
  categories {
    ...PaiCategoryFields
  }
}
    ${PaiCategoryFieldsFragmentDoc_}`;
export const PaiCategoryFieldsV2FragmentDoc_ = gql`
    fragment PaiCategoryFieldsV2 on PaiCategory {
  title
  subtitle
  reference
  indicators {
    ...PaiIndicatorFieldsV2
  }
}
    ${PaiIndicatorFieldsV2FragmentDoc_}`;
export const PaiTableFieldsV2FragmentDoc_ = gql`
    fragment PaiTableFieldsV2 on PaiTable {
  isMandatory
  title
  reference
  subtitle
  isCustom
  categories {
    ...PaiCategoryFieldsV2
  }
}
    ${PaiCategoryFieldsV2FragmentDoc_}`;
export const PaiInvesteeAnswerFieldsFragmentDoc_ = gql`
    fragment PaiInvesteeAnswerFields on PaiAnswers {
  id
  data
  answeredById
  answeredBy {
    ...ShortUser
  }
  investeeMetricReference
}
    ${ShortUserFragmentDoc_}`;
export const NotificationFieldsFragmentDoc_ = gql`
    fragment NotificationFields on UserNotification {
  id
  createdAt
  isRead
  comment {
    id
    data
    createdAt
    author {
      ...ShortUser
    }
    thread {
      answer {
        question {
          uniqueId
        }
        activityReport {
          activity {
            reference
            name
          }
          bAssessment {
            id
            cAssessmentId
            businessUnit {
              id
              name
              company {
                id
                name
              }
            }
            cAssessment {
              aggregate {
                title
              }
            }
          }
        }
        answerCompany {
          company {
            id
            name
          }
        }
      }
      esrsDatapoint {
        id
        answer {
          id
          metricRef
          metric {
            title
            shortTitle
            requirement {
              reference
              type
              frameworkRef
              group {
                standardRef
              }
            }
          }
          reportingUnit {
            id
            name
            isCompanyLevel
            esrsAssessment {
              id
              reportingYear
              company {
                id
                name
              }
            }
          }
        }
      }
      esrsDatapointMdrm {
        id
        mdrmRef
        datapoint {
          id
          answer {
            id
            metricRef
            metric {
              title
              shortTitle
              requirement {
                reference
                frameworkRef
                type
                group {
                  standardRef
                }
              }
            }
            reportingUnit {
              id
              name
              isCompanyLevel
              esrsAssessment {
                id
                reportingYear
                company {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ShortUserFragmentDoc_}`;
export const ActionDocumentationFragmentDoc_ = gql`
    fragment ActionDocumentation on esrs_Actions {
  id
  attachmentBox {
    ...AttachmentBox
  }
  noteHistory {
    ...NoteHistory
  }
}
    ${AttachmentBoxFragmentDoc_}
${NoteHistoryFragmentDoc_}`;
export const MetricAnswerDocumentationFragmentDoc_ = gql`
    fragment MetricAnswerDocumentation on esrs_Answer {
  id
  attachmentBox {
    ...AttachmentBox
  }
  noteHistory {
    ...NoteHistory
  }
}
    ${AttachmentBoxFragmentDoc_}
${NoteHistoryFragmentDoc_}`;
export const PolicyDocumentationFragmentDoc_ = gql`
    fragment PolicyDocumentation on esrs_Policy {
  id
  attachmentBox {
    ...AttachmentBox
  }
  noteHistory {
    ...NoteHistory
  }
}
    ${AttachmentBoxFragmentDoc_}
${NoteHistoryFragmentDoc_}`;
export const PaiAnswerDocumentationFragmentDoc_ = gql`
    fragment PaiAnswerDocumentation on PaiAnswers {
  id
  attachmentBox {
    ...AttachmentBox
  }
  noteHistory {
    ...NoteHistory
  }
}
    ${AttachmentBoxFragmentDoc_}
${NoteHistoryFragmentDoc_}`;
export const FinancialsDocumentationFragmentDoc_ = gql`
    fragment FinancialsDocumentation on Financials {
  id
  attachmentBox {
    ...AttachmentBox
  }
  noteHistory {
    ...NoteHistory
  }
}
    ${AttachmentBoxFragmentDoc_}
${NoteHistoryFragmentDoc_}`;
export const ActivityDocumentationFragmentDoc_ = gql`
    fragment ActivityDocumentation on ActivityReport {
  id
  attachmentBox {
    ...AttachmentBox
  }
  noteHistory {
    ...NoteHistory
  }
}
    ${AttachmentBoxFragmentDoc_}
${NoteHistoryFragmentDoc_}`;
export const AnswerDocumentationFragmentDoc_ = gql`
    fragment AnswerDocumentation on Answer {
  id
  attachmentBox {
    ...AttachmentBox
  }
  noteHistory {
    ...NoteHistory
  }
}
    ${AttachmentBoxFragmentDoc_}
${NoteHistoryFragmentDoc_}`;
export const CompanyDetailsFieldsFragmentDoc_ = gql`
    fragment CompanyDetailsFields on Company {
  id
  isPortfolioOwner
  isGroupOwner
  logoUrl
  name
  settings
  currency
  compassId
  invitations {
    userEmail
    status
    id
  }
  hasPaiAccess
  hasIFRSAccess
  hasTCFDAccess
  hasESRSOilAndGasAccess
  hasEntitySpecificAccess
  hasCustomQuestionsAccess
  hasTaxonomyAccess
  hasAiAccess
  hasBulkUploadAccess
  hasSASBAccess
  canDownloadEsrsReport
  canDownloadTaxonomyReport
  hasESRSAccess
  hasVSMEAccess
  isReal
  isDemo
  aiConfig {
    preferredLanguage
    toneOfVoice
  }
  subsidiaries(where: {deletedAt: {_is_null: true}}) {
    id
    ownerGroupAssessment {
      company {
        hasTaxonomyAccess
      }
    }
  }
  portfolioCompanies {
    id
    eligibilityStatus
    portfolio {
      ownerCompany {
        id
        hasTaxonomyAccess
      }
    }
  }
  esrsAssessments(where: {deletedAt: {_is_null: true}}) {
    id
    reportingYear
    frameworkRef
    projectLeader {
      ...ShortUser
    }
    reportingUnits {
      id
      isCompanyLevel
      reportingUnitLineage {
        id
      }
    }
  }
}
    ${ShortUserFragmentDoc_}`;
export const SimpleBusinessUnitFragmentDoc_ = gql`
    fragment SimpleBusinessUnit on BusinessUnit {
  id
  contactPerson {
    ...ShortUser
  }
  name
  labels
  cAssessmentIds: bAssessments(where: {deletedAt: {_is_null: true}}) {
    cAssessmentId
    cachedResultId
  }
  deletedCAssessmentIds: bAssessments(where: {deletedAt: {_is_null: false}}) {
    cAssessmentId
  }
}
    ${ShortUserFragmentDoc_}`;
export const AuditLogEntryFieldsFragmentDoc_ = gql`
    fragment AuditLogEntryFields on AuditLogEntry {
  invocationId
  timestamp
  newData
  oldData
  operation
  table
  schema
  userId
  companyId
  user {
    ...ShortUser
  }
}
    ${ShortUserFragmentDoc_}`;
export const SectorFieldsFragmentDoc_ = gql`
    fragment SectorFields on Sector {
  reference
  name
}
    `;
export const ActivityFieldsFragmentDoc_ = gql`
    fragment ActivityFields on Activity {
  name
  description
  reference
  sector {
    ...SectorFields
  }
  naceCodes: activityNaceCodes {
    code
  }
  versions {
    versionNumber
    tagExpression
  }
  currentQuestionSetVersion
  referenceNumber
  additionalGuidance
  celsiaComment
  descriptionSource
  guidanceSource
}
    ${SectorFieldsFragmentDoc_}`;
export const FinancialsFieldsFragmentDoc_ = gql`
    fragment FinancialsFields on Financials {
  id
  revenue
  capex
  opex
  adaptationCapex
  adaptationOpex
  isEstimate
}
    `;
export const ActivityReportWithoutAnswersFieldsFragmentDoc_ = gql`
    fragment ActivityReportWithoutAnswersFields on ActivityReport {
  id
  activityVersionNumber
  activityVersionConfig
  activityVersion {
    activityRef
    versionNumber
    changeDescription
    tagExpression
  }
  activity {
    ...ActivityFields
  }
  bAssessmentId
  completedAt
  createdAt
  financials {
    ...FinancialsFields
  }
  attachmentBox {
    id
    attachments(
      where: {deletedAt: {_is_null: true}, file: {deletedAt: {_is_null: true}}}
    ) {
      fileId
      updatedAt
    }
  }
  noteHistory {
    id
    notes {
      updatedAt
      body
      author {
        ...ShortUser
      }
    }
  }
}
    ${ActivityFieldsFragmentDoc_}
${FinancialsFieldsFragmentDoc_}
${ShortUserFragmentDoc_}`;
export const ActivityReportFieldsFragmentDoc_ = gql`
    fragment ActivityReportFields on ActivityReport {
  ...ActivityReportWithoutAnswersFields
}
    ${ActivityReportWithoutAnswersFieldsFragmentDoc_}`;
export const BusinessUnitAssessmentFieldsFragmentDoc_ = gql`
    fragment BusinessUnitAssessmentFields on BusinessUnitAssessment {
  id
  cAssessmentId
  deletedAt
  hasGeneralAssessment
  businessUnit {
    ...BusinessUnitInAssessment
  }
  generalAssessment: activityReports(where: {activityRef: {_eq: "0.0"}}) {
    ...ActivityReportFields
  }
  activityReports(
    where: {deletedAt: {_is_null: true}, activityRef: {_neq: "0.0"}}
  ) {
    ...ActivityReportFields
  }
  orderIndex
  reportingGroup {
    id
  }
}
    ${BusinessUnitInAssessmentFragmentDoc_}
${ActivityReportFieldsFragmentDoc_}`;
export const CompanyAssessmentFieldsFragmentDoc_ = gql`
    fragment CompanyAssessmentFields on CompanyAssessment {
  id
  startDate
  endDate
  isLocked
  createdAt
  deletedAt
  companyId
  cachedResultId
  aggregate {
    id
    title
    interval
    startDate
    contactPerson {
      ...ShortUser
    }
    company {
      id
      name
    }
  }
  bAssessments: bAssesssments(
    where: {deletedAt: {_is_null: true}}
    order_by: {createdAt: asc}
  ) {
    ...BusinessUnitAssessmentFields
  }
  deletedBAssessments: bAssesssments(where: {deletedAt: {_is_null: false}}) {
    ...BusinessUnitAssessmentFields
  }
}
    ${ShortUserFragmentDoc_}
${BusinessUnitAssessmentFieldsFragmentDoc_}`;
export const NonMaterialFinancialsFieldsFragmentDoc_ = gql`
    fragment NonMaterialFinancialsFields on NonMaterialFinancials {
  id
  revenue
  capex
  opex
  adaptationCapex
  adaptationOpex
  isEstimate
}
    `;
export const TotalComparisonFinancialsFieldsFragmentDoc_ = gql`
    fragment TotalComparisonFinancialsFields on TotalComparisonFinancials {
  id
  revenue
  capex
  opex
  adaptationCapex
  adaptationOpex
  isEstimate
}
    `;
export const CompanyAssessmentAggregateFieldsFragmentDoc_ = gql`
    fragment CompanyAssessmentAggregateFields on CompanyAssessmentAggregate {
  id
  companyId
  title
  createdAt
  cAssessments {
    id
    startDate
    endDate
    isLocked
  }
  contactPerson {
    ...ShortUser
  }
}
    ${ShortUserFragmentDoc_}`;
export const TaskFieldsFragmentDoc_ = gql`
    fragment TaskFields on Task {
  id
  ownerId
  dueDate
  status
  table
  taskReference
}
    `;
export const MetricDetailsFragmentDoc_ = gql`
    fragment MetricDetails on EsrsMetric {
  reference
  metricType
  materialMetrics(where: {materialStandard: {assessmentId: {_eq: $assessmentId}}}) {
    materialStandard {
      standardRef
      standard {
        title
        order
      }
    }
  }
}
    `;
export const AnswerDetailsFragmentDoc_ = gql`
    fragment AnswerDetails on esrs_Answer {
  id
  reportingUnit {
    id
    name
  }
  metric {
    ...MetricDetails
  }
}
    ${MetricDetailsFragmentDoc_}`;
export const MetricDisclosureDetailsFragmentDoc_ = gql`
    fragment MetricDisclosureDetails on EsrsMetric {
  reference
  requirement {
    title
    reference
    frameworkRef
    type
    order
  }
  mfDisclosureRequirements {
    mfDisclosureRequirement {
      reference
      title
      type
      order
      drToMFDisclosureRequirements {
        disclosureRequirement {
          title
          reference
          frameworkRef
          type
          order
        }
      }
    }
  }
}
    `;
export const AdminGetCompaniesDocument_ = gql`
    query AdminGetCompanies($limit: Int, $offset: Int, $order_by: [Company_order_by!], $where: Company_bool_exp) {
  Company(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    id
    compassId
    name
    settings
    logoUrl
    isPortfolioOwner
    isGroupOwner
    hasPaiAccess
    hasAiAccess
    hasCustomQuestionsAccess
    hasTaxonomyAccess
    hasBulkUploadAccess
    canDownloadTaxonomyReport
    isReal
    hasESRSAccess
    hasVSMEAccess
    hasIFRSAccess
    hasTCFDAccess
    hasESRSOilAndGasAccess
    hasEntitySpecificAccess
    hasSASBAccess
    canDownloadEsrsReport
    cancelledAt
    portfolios(where: {deletedAt: {_is_null: true}}) {
      id
      name
      portfolioCompanies {
        id
        companyId
      }
    }
    groupAssessments(where: {deletedAt: {_is_null: true}}) {
      id
      name
      subsidiaries {
        id
        companyId
      }
    }
  }
  Company_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetCompaniesQuery__
 *
 * To run a query within a React component, call `useAdminGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetCompaniesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetCompaniesQuery_, AdminGetCompaniesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetCompaniesQuery_, AdminGetCompaniesQueryVariables_>(AdminGetCompaniesDocument_, options);
      }
export function useAdminGetCompaniesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetCompaniesQuery_, AdminGetCompaniesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetCompaniesQuery_, AdminGetCompaniesQueryVariables_>(AdminGetCompaniesDocument_, options);
        }
export function useAdminGetCompaniesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetCompaniesQuery_, AdminGetCompaniesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetCompaniesQuery_, AdminGetCompaniesQueryVariables_>(AdminGetCompaniesDocument_, options);
        }
export type AdminGetCompaniesQueryHookResult = ReturnType<typeof useAdminGetCompaniesQuery>;
export type AdminGetCompaniesLazyQuery_HookResult = ReturnType<typeof useAdminGetCompaniesLazyQuery_>;
export type AdminGetCompaniesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetCompaniesSuspenseQuery_>;
export type AdminGetCompaniesQueryResult_ = Apollo.QueryResult<AdminGetCompaniesQuery_, AdminGetCompaniesQueryVariables_>;
export function refetchAdminGetCompaniesQuery_(variables?: AdminGetCompaniesQueryVariables_) {
      return { query: AdminGetCompaniesDocument_, variables: variables }
    }
export const AdminGetAppConfigDocument_ = gql`
    query AdminGetAppConfig($limit: Int, $offset: Int, $order_by: [AppConfig_order_by!], $where: AppConfig_bool_exp) {
  AppConfig(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    mergeInProgress
    id
    identifier
  }
}
    `;

/**
 * __useAdminGetAppConfigQuery__
 *
 * To run a query within a React component, call `useAdminGetAppConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetAppConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetAppConfigQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetAppConfigQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetAppConfigQuery_, AdminGetAppConfigQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetAppConfigQuery_, AdminGetAppConfigQueryVariables_>(AdminGetAppConfigDocument_, options);
      }
export function useAdminGetAppConfigLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetAppConfigQuery_, AdminGetAppConfigQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetAppConfigQuery_, AdminGetAppConfigQueryVariables_>(AdminGetAppConfigDocument_, options);
        }
export function useAdminGetAppConfigSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetAppConfigQuery_, AdminGetAppConfigQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetAppConfigQuery_, AdminGetAppConfigQueryVariables_>(AdminGetAppConfigDocument_, options);
        }
export type AdminGetAppConfigQueryHookResult = ReturnType<typeof useAdminGetAppConfigQuery>;
export type AdminGetAppConfigLazyQuery_HookResult = ReturnType<typeof useAdminGetAppConfigLazyQuery_>;
export type AdminGetAppConfigSuspenseQuery_HookResult = ReturnType<typeof useAdminGetAppConfigSuspenseQuery_>;
export type AdminGetAppConfigQueryResult_ = Apollo.QueryResult<AdminGetAppConfigQuery_, AdminGetAppConfigQueryVariables_>;
export function refetchAdminGetAppConfigQuery_(variables?: AdminGetAppConfigQueryVariables_) {
      return { query: AdminGetAppConfigDocument_, variables: variables }
    }
export const AdminGetOneAppConfigDocument_ = gql`
    query AdminGetOneAppConfig($id: Boolean!) {
  AppConfig_by_pk(id: $id) {
    mergeInProgress
  }
}
    `;

/**
 * __useAdminGetOneAppConfigQuery__
 *
 * To run a query within a React component, call `useAdminGetOneAppConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetOneAppConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetOneAppConfigQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetOneAppConfigQuery(baseOptions: Apollo.QueryHookOptions<AdminGetOneAppConfigQuery_, AdminGetOneAppConfigQueryVariables_> & ({ variables: AdminGetOneAppConfigQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetOneAppConfigQuery_, AdminGetOneAppConfigQueryVariables_>(AdminGetOneAppConfigDocument_, options);
      }
export function useAdminGetOneAppConfigLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetOneAppConfigQuery_, AdminGetOneAppConfigQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetOneAppConfigQuery_, AdminGetOneAppConfigQueryVariables_>(AdminGetOneAppConfigDocument_, options);
        }
export function useAdminGetOneAppConfigSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetOneAppConfigQuery_, AdminGetOneAppConfigQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetOneAppConfigQuery_, AdminGetOneAppConfigQueryVariables_>(AdminGetOneAppConfigDocument_, options);
        }
export type AdminGetOneAppConfigQueryHookResult = ReturnType<typeof useAdminGetOneAppConfigQuery>;
export type AdminGetOneAppConfigLazyQuery_HookResult = ReturnType<typeof useAdminGetOneAppConfigLazyQuery_>;
export type AdminGetOneAppConfigSuspenseQuery_HookResult = ReturnType<typeof useAdminGetOneAppConfigSuspenseQuery_>;
export type AdminGetOneAppConfigQueryResult_ = Apollo.QueryResult<AdminGetOneAppConfigQuery_, AdminGetOneAppConfigQueryVariables_>;
export function refetchAdminGetOneAppConfigQuery_(variables: AdminGetOneAppConfigQueryVariables_) {
      return { query: AdminGetOneAppConfigDocument_, variables: variables }
    }
export const AdminGetCompanyInvitationsDocument_ = gql`
    query AdminGetCompanyInvitations($limit: Int, $offset: Int, $order_by: [CompanyInvitation_order_by!], $where: CompanyInvitation_bool_exp) {
  CompanyInvitation(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    companyId
    userEmail
    role
    status
    createdAt
    updatedAt
  }
  CompanyInvitation_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetCompanyInvitationsQuery__
 *
 * To run a query within a React component, call `useAdminGetCompanyInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetCompanyInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetCompanyInvitationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetCompanyInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetCompanyInvitationsQuery_, AdminGetCompanyInvitationsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetCompanyInvitationsQuery_, AdminGetCompanyInvitationsQueryVariables_>(AdminGetCompanyInvitationsDocument_, options);
      }
export function useAdminGetCompanyInvitationsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetCompanyInvitationsQuery_, AdminGetCompanyInvitationsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetCompanyInvitationsQuery_, AdminGetCompanyInvitationsQueryVariables_>(AdminGetCompanyInvitationsDocument_, options);
        }
export function useAdminGetCompanyInvitationsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetCompanyInvitationsQuery_, AdminGetCompanyInvitationsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetCompanyInvitationsQuery_, AdminGetCompanyInvitationsQueryVariables_>(AdminGetCompanyInvitationsDocument_, options);
        }
export type AdminGetCompanyInvitationsQueryHookResult = ReturnType<typeof useAdminGetCompanyInvitationsQuery>;
export type AdminGetCompanyInvitationsLazyQuery_HookResult = ReturnType<typeof useAdminGetCompanyInvitationsLazyQuery_>;
export type AdminGetCompanyInvitationsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetCompanyInvitationsSuspenseQuery_>;
export type AdminGetCompanyInvitationsQueryResult_ = Apollo.QueryResult<AdminGetCompanyInvitationsQuery_, AdminGetCompanyInvitationsQueryVariables_>;
export function refetchAdminGetCompanyInvitationsQuery_(variables?: AdminGetCompanyInvitationsQueryVariables_) {
      return { query: AdminGetCompanyInvitationsDocument_, variables: variables }
    }
export const AdminUpdateCompanyInvitationsDocument_ = gql`
    mutation AdminUpdateCompanyInvitations($pk_columns: CompanyInvitation_pk_columns_input!, $_set: CompanyInvitation_set_input!) {
  update_CompanyInvitation_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    companyId
    userEmail
    role
    status
    createdAt
    updatedAt
  }
}
    `;
export type AdminUpdateCompanyInvitationsMutationFn_ = Apollo.MutationFunction<AdminUpdateCompanyInvitationsMutation_, AdminUpdateCompanyInvitationsMutationVariables_>;

/**
 * __useAdminUpdateCompanyInvitationsMutation__
 *
 * To run a mutation, you first call `useAdminUpdateCompanyInvitationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateCompanyInvitationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateCompanyInvitationsMutation, { data, loading, error }] = useAdminUpdateCompanyInvitationsMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateCompanyInvitationsMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateCompanyInvitationsMutation_, AdminUpdateCompanyInvitationsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateCompanyInvitationsMutation_, AdminUpdateCompanyInvitationsMutationVariables_>(AdminUpdateCompanyInvitationsDocument_, options);
      }
export type AdminUpdateCompanyInvitationsMutationHookResult = ReturnType<typeof useAdminUpdateCompanyInvitationsMutation>;
export type AdminUpdateCompanyInvitationsMutationResult_ = Apollo.MutationResult<AdminUpdateCompanyInvitationsMutation_>;
export type AdminUpdateCompanyInvitationsMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateCompanyInvitationsMutation_, AdminUpdateCompanyInvitationsMutationVariables_>;
export const AdminUpdateAppConfigDocument_ = gql`
    mutation AdminUpdateAppConfig($pk_columns: AppConfig_pk_columns_input!, $_set: AppConfig_set_input!) {
  update_AppConfig_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    mergeInProgress
  }
}
    `;
export type AdminUpdateAppConfigMutationFn_ = Apollo.MutationFunction<AdminUpdateAppConfigMutation_, AdminUpdateAppConfigMutationVariables_>;

/**
 * __useAdminUpdateAppConfigMutation__
 *
 * To run a mutation, you first call `useAdminUpdateAppConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateAppConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateAppConfigMutation, { data, loading, error }] = useAdminUpdateAppConfigMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateAppConfigMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateAppConfigMutation_, AdminUpdateAppConfigMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateAppConfigMutation_, AdminUpdateAppConfigMutationVariables_>(AdminUpdateAppConfigDocument_, options);
      }
export type AdminUpdateAppConfigMutationHookResult = ReturnType<typeof useAdminUpdateAppConfigMutation>;
export type AdminUpdateAppConfigMutationResult_ = Apollo.MutationResult<AdminUpdateAppConfigMutation_>;
export type AdminUpdateAppConfigMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateAppConfigMutation_, AdminUpdateAppConfigMutationVariables_>;
export const AdminCreateCompanyInvitationsDocument_ = gql`
    mutation AdminCreateCompanyInvitations($objects: [CompanyInvitation_insert_input!]!) {
  insert_CompanyInvitation(objects: $objects) {
    returning {
      id
    }
  }
}
    `;
export type AdminCreateCompanyInvitationsMutationFn_ = Apollo.MutationFunction<AdminCreateCompanyInvitationsMutation_, AdminCreateCompanyInvitationsMutationVariables_>;

/**
 * __useAdminCreateCompanyInvitationsMutation__
 *
 * To run a mutation, you first call `useAdminCreateCompanyInvitationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateCompanyInvitationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateCompanyInvitationsMutation, { data, loading, error }] = useAdminCreateCompanyInvitationsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateCompanyInvitationsMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateCompanyInvitationsMutation_, AdminCreateCompanyInvitationsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateCompanyInvitationsMutation_, AdminCreateCompanyInvitationsMutationVariables_>(AdminCreateCompanyInvitationsDocument_, options);
      }
export type AdminCreateCompanyInvitationsMutationHookResult = ReturnType<typeof useAdminCreateCompanyInvitationsMutation>;
export type AdminCreateCompanyInvitationsMutationResult_ = Apollo.MutationResult<AdminCreateCompanyInvitationsMutation_>;
export type AdminCreateCompanyInvitationsMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateCompanyInvitationsMutation_, AdminCreateCompanyInvitationsMutationVariables_>;
export const AdminGetCompanyDocument_ = gql`
    query AdminGetCompany($id: uuid!) {
  Company_by_pk(id: $id) {
    id
    compassId
    name
    settings
    logoUrl
    isPortfolioOwner
    isGroupOwner
    hasPaiAccess
    hasAiAccess
    hasCustomQuestionsAccess
    hasTaxonomyAccess
    hasBulkUploadAccess
    canDownloadTaxonomyReport
    isReal
    hasESRSAccess
    hasVSMEAccess
    hasIFRSAccess
    hasTCFDAccess
    hasESRSOilAndGasAccess
    hasEntitySpecificAccess
    hasSASBAccess
    cAssessments {
      aggregate {
        title
      }
      bAssesssments {
        businessUnit {
          name
        }
        activityReports {
          activityVersionNumber
          activityRef
        }
      }
    }
    canDownloadEsrsReport
    cancelledAt
    portfolios(where: {deletedAt: {_is_null: true}}) {
      id
      name
      portfolioCompanies {
        id
        companyId
      }
    }
    groupAssessments(where: {deletedAt: {_is_null: true}}) {
      id
      name
      subsidiaries {
        id
        companyId
      }
    }
    esrsAssessments(where: {deletedAt: {_is_null: true}}) {
      id
      companyId
      subsidiaryAssessments {
        id
        companyId
      }
    }
  }
}
    `;

/**
 * __useAdminGetCompanyQuery__
 *
 * To run a query within a React component, call `useAdminGetCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetCompanyQuery(baseOptions: Apollo.QueryHookOptions<AdminGetCompanyQuery_, AdminGetCompanyQueryVariables_> & ({ variables: AdminGetCompanyQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetCompanyQuery_, AdminGetCompanyQueryVariables_>(AdminGetCompanyDocument_, options);
      }
export function useAdminGetCompanyLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetCompanyQuery_, AdminGetCompanyQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetCompanyQuery_, AdminGetCompanyQueryVariables_>(AdminGetCompanyDocument_, options);
        }
export function useAdminGetCompanySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetCompanyQuery_, AdminGetCompanyQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetCompanyQuery_, AdminGetCompanyQueryVariables_>(AdminGetCompanyDocument_, options);
        }
export type AdminGetCompanyQueryHookResult = ReturnType<typeof useAdminGetCompanyQuery>;
export type AdminGetCompanyLazyQuery_HookResult = ReturnType<typeof useAdminGetCompanyLazyQuery_>;
export type AdminGetCompanySuspenseQuery_HookResult = ReturnType<typeof useAdminGetCompanySuspenseQuery_>;
export type AdminGetCompanyQueryResult_ = Apollo.QueryResult<AdminGetCompanyQuery_, AdminGetCompanyQueryVariables_>;
export function refetchAdminGetCompanyQuery_(variables: AdminGetCompanyQueryVariables_) {
      return { query: AdminGetCompanyDocument_, variables: variables }
    }
export const AdminUpdateCompanyDocument_ = gql`
    mutation AdminUpdateCompany($pk_columns: Company_pk_columns_input!, $_set: Company_set_input!) {
  update_Company_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    compassId
    name
    settings
    logoUrl
    isPortfolioOwner
    isGroupOwner
    hasPaiAccess
    hasAiAccess
    hasBulkUploadAccess
    hasCustomQuestionsAccess
    hasTaxonomyAccess
    canDownloadTaxonomyReport
    isReal
    hasESRSAccess
    hasVSMEAccess
    hasIFRSAccess
    hasTCFDAccess
    hasESRSOilAndGasAccess
    hasEntitySpecificAccess
    hasSASBAccess
    canDownloadEsrsReport
    cancelledAt
  }
}
    `;
export type AdminUpdateCompanyMutationFn_ = Apollo.MutationFunction<AdminUpdateCompanyMutation_, AdminUpdateCompanyMutationVariables_>;

/**
 * __useAdminUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useAdminUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateCompanyMutation, { data, loading, error }] = useAdminUpdateCompanyMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateCompanyMutation_, AdminUpdateCompanyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateCompanyMutation_, AdminUpdateCompanyMutationVariables_>(AdminUpdateCompanyDocument_, options);
      }
export type AdminUpdateCompanyMutationHookResult = ReturnType<typeof useAdminUpdateCompanyMutation>;
export type AdminUpdateCompanyMutationResult_ = Apollo.MutationResult<AdminUpdateCompanyMutation_>;
export type AdminUpdateCompanyMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateCompanyMutation_, AdminUpdateCompanyMutationVariables_>;
export const AdminUpdateCompaniesByIdsDocument_ = gql`
    mutation AdminUpdateCompaniesByIds($where: Company_bool_exp!, $_set: Company_set_input!) {
  update_Company(where: $where, _set: $_set) {
    affected_rows
    returning {
      id
      isReal
    }
  }
}
    `;
export type AdminUpdateCompaniesByIdsMutationFn_ = Apollo.MutationFunction<AdminUpdateCompaniesByIdsMutation_, AdminUpdateCompaniesByIdsMutationVariables_>;

/**
 * __useAdminUpdateCompaniesByIdsMutation__
 *
 * To run a mutation, you first call `useAdminUpdateCompaniesByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateCompaniesByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateCompaniesByIdsMutation, { data, loading, error }] = useAdminUpdateCompaniesByIdsMutation({
 *   variables: {
 *      where: // value for 'where'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateCompaniesByIdsMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateCompaniesByIdsMutation_, AdminUpdateCompaniesByIdsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateCompaniesByIdsMutation_, AdminUpdateCompaniesByIdsMutationVariables_>(AdminUpdateCompaniesByIdsDocument_, options);
      }
export type AdminUpdateCompaniesByIdsMutationHookResult = ReturnType<typeof useAdminUpdateCompaniesByIdsMutation>;
export type AdminUpdateCompaniesByIdsMutationResult_ = Apollo.MutationResult<AdminUpdateCompaniesByIdsMutation_>;
export type AdminUpdateCompaniesByIdsMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateCompaniesByIdsMutation_, AdminUpdateCompaniesByIdsMutationVariables_>;
export const AdminDeleteCompanyDocument_ = gql`
    mutation AdminDeleteCompany($id: uuid!) {
  delete_Company_by_pk(id: $id) {
    id
  }
}
    `;
export type AdminDeleteCompanyMutationFn_ = Apollo.MutationFunction<AdminDeleteCompanyMutation_, AdminDeleteCompanyMutationVariables_>;

/**
 * __useAdminDeleteCompanyMutation__
 *
 * To run a mutation, you first call `useAdminDeleteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteCompanyMutation, { data, loading, error }] = useAdminDeleteCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteCompanyMutation_, AdminDeleteCompanyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteCompanyMutation_, AdminDeleteCompanyMutationVariables_>(AdminDeleteCompanyDocument_, options);
      }
export type AdminDeleteCompanyMutationHookResult = ReturnType<typeof useAdminDeleteCompanyMutation>;
export type AdminDeleteCompanyMutationResult_ = Apollo.MutationResult<AdminDeleteCompanyMutation_>;
export type AdminDeleteCompanyMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteCompanyMutation_, AdminDeleteCompanyMutationVariables_>;
export const AdminGetCompanyUsersDocument_ = gql`
    query AdminGetCompanyUsers($limit: Int, $offset: Int, $order_by: [CompanyUser_order_by!], $where: CompanyUser_bool_exp) {
  CompanyUser(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    id
    companyId
    userId
    role
  }
  CompanyUser_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetCompanyUsersQuery__
 *
 * To run a query within a React component, call `useAdminGetCompanyUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetCompanyUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetCompanyUsersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetCompanyUsersQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetCompanyUsersQuery_, AdminGetCompanyUsersQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetCompanyUsersQuery_, AdminGetCompanyUsersQueryVariables_>(AdminGetCompanyUsersDocument_, options);
      }
export function useAdminGetCompanyUsersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetCompanyUsersQuery_, AdminGetCompanyUsersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetCompanyUsersQuery_, AdminGetCompanyUsersQueryVariables_>(AdminGetCompanyUsersDocument_, options);
        }
export function useAdminGetCompanyUsersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetCompanyUsersQuery_, AdminGetCompanyUsersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetCompanyUsersQuery_, AdminGetCompanyUsersQueryVariables_>(AdminGetCompanyUsersDocument_, options);
        }
export type AdminGetCompanyUsersQueryHookResult = ReturnType<typeof useAdminGetCompanyUsersQuery>;
export type AdminGetCompanyUsersLazyQuery_HookResult = ReturnType<typeof useAdminGetCompanyUsersLazyQuery_>;
export type AdminGetCompanyUsersSuspenseQuery_HookResult = ReturnType<typeof useAdminGetCompanyUsersSuspenseQuery_>;
export type AdminGetCompanyUsersQueryResult_ = Apollo.QueryResult<AdminGetCompanyUsersQuery_, AdminGetCompanyUsersQueryVariables_>;
export function refetchAdminGetCompanyUsersQuery_(variables?: AdminGetCompanyUsersQueryVariables_) {
      return { query: AdminGetCompanyUsersDocument_, variables: variables }
    }
export const AdminDeleteCompanyUsersDocument_ = gql`
    mutation AdminDeleteCompanyUsers($userIds: [uuid!]!, $companyId: uuid!) {
  delete_CompanyUser(
    where: {userId: {_in: $userIds}, companyId: {_eq: $companyId}}
  ) {
    affected_rows
  }
}
    `;
export type AdminDeleteCompanyUsersMutationFn_ = Apollo.MutationFunction<AdminDeleteCompanyUsersMutation_, AdminDeleteCompanyUsersMutationVariables_>;

/**
 * __useAdminDeleteCompanyUsersMutation__
 *
 * To run a mutation, you first call `useAdminDeleteCompanyUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteCompanyUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteCompanyUsersMutation, { data, loading, error }] = useAdminDeleteCompanyUsersMutation({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAdminDeleteCompanyUsersMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteCompanyUsersMutation_, AdminDeleteCompanyUsersMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteCompanyUsersMutation_, AdminDeleteCompanyUsersMutationVariables_>(AdminDeleteCompanyUsersDocument_, options);
      }
export type AdminDeleteCompanyUsersMutationHookResult = ReturnType<typeof useAdminDeleteCompanyUsersMutation>;
export type AdminDeleteCompanyUsersMutationResult_ = Apollo.MutationResult<AdminDeleteCompanyUsersMutation_>;
export type AdminDeleteCompanyUsersMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteCompanyUsersMutation_, AdminDeleteCompanyUsersMutationVariables_>;
export const AdminDeleteCompanyUserDocument_ = gql`
    mutation AdminDeleteCompanyUser($userId: uuid!, $companyId: uuid!) {
  delete_CompanyUser_by_pk(userId: $userId, companyId: $companyId) {
    id
  }
}
    `;
export type AdminDeleteCompanyUserMutationFn_ = Apollo.MutationFunction<AdminDeleteCompanyUserMutation_, AdminDeleteCompanyUserMutationVariables_>;

/**
 * __useAdminDeleteCompanyUserMutation__
 *
 * To run a mutation, you first call `useAdminDeleteCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteCompanyUserMutation, { data, loading, error }] = useAdminDeleteCompanyUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAdminDeleteCompanyUserMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteCompanyUserMutation_, AdminDeleteCompanyUserMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteCompanyUserMutation_, AdminDeleteCompanyUserMutationVariables_>(AdminDeleteCompanyUserDocument_, options);
      }
export type AdminDeleteCompanyUserMutationHookResult = ReturnType<typeof useAdminDeleteCompanyUserMutation>;
export type AdminDeleteCompanyUserMutationResult_ = Apollo.MutationResult<AdminDeleteCompanyUserMutation_>;
export type AdminDeleteCompanyUserMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteCompanyUserMutation_, AdminDeleteCompanyUserMutationVariables_>;
export const AdminGetusersDocument_ = gql`
    query AdminGetusers($limit: Int, $offset: Int, $order_by: [users_order_by!], $where: users_bool_exp) {
  users(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    id
    email
    displayName
    disabled
  }
  users_aggregate: usersAggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetusersQuery__
 *
 * To run a query within a React component, call `useAdminGetusersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetusersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetusersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetusersQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetusersQuery_, AdminGetusersQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetusersQuery_, AdminGetusersQueryVariables_>(AdminGetusersDocument_, options);
      }
export function useAdminGetusersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetusersQuery_, AdminGetusersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetusersQuery_, AdminGetusersQueryVariables_>(AdminGetusersDocument_, options);
        }
export function useAdminGetusersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetusersQuery_, AdminGetusersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetusersQuery_, AdminGetusersQueryVariables_>(AdminGetusersDocument_, options);
        }
export type AdminGetusersQueryHookResult = ReturnType<typeof useAdminGetusersQuery>;
export type AdminGetusersLazyQuery_HookResult = ReturnType<typeof useAdminGetusersLazyQuery_>;
export type AdminGetusersSuspenseQuery_HookResult = ReturnType<typeof useAdminGetusersSuspenseQuery_>;
export type AdminGetusersQueryResult_ = Apollo.QueryResult<AdminGetusersQuery_, AdminGetusersQueryVariables_>;
export function refetchAdminGetusersQuery_(variables?: AdminGetusersQueryVariables_) {
      return { query: AdminGetusersDocument_, variables: variables }
    }
export const AdminGetUserDocument_ = gql`
    query AdminGetUser($id: uuid!) {
  user(id: $id) {
    id
    email
    displayName
    disabled
  }
}
    `;

/**
 * __useAdminGetUserQuery__
 *
 * To run a query within a React component, call `useAdminGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetUserQuery(baseOptions: Apollo.QueryHookOptions<AdminGetUserQuery_, AdminGetUserQueryVariables_> & ({ variables: AdminGetUserQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetUserQuery_, AdminGetUserQueryVariables_>(AdminGetUserDocument_, options);
      }
export function useAdminGetUserLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetUserQuery_, AdminGetUserQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetUserQuery_, AdminGetUserQueryVariables_>(AdminGetUserDocument_, options);
        }
export function useAdminGetUserSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetUserQuery_, AdminGetUserQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetUserQuery_, AdminGetUserQueryVariables_>(AdminGetUserDocument_, options);
        }
export type AdminGetUserQueryHookResult = ReturnType<typeof useAdminGetUserQuery>;
export type AdminGetUserLazyQuery_HookResult = ReturnType<typeof useAdminGetUserLazyQuery_>;
export type AdminGetUserSuspenseQuery_HookResult = ReturnType<typeof useAdminGetUserSuspenseQuery_>;
export type AdminGetUserQueryResult_ = Apollo.QueryResult<AdminGetUserQuery_, AdminGetUserQueryVariables_>;
export function refetchAdminGetUserQuery_(variables: AdminGetUserQueryVariables_) {
      return { query: AdminGetUserDocument_, variables: variables }
    }
export const AdminUpdateusersDocument_ = gql`
    mutation AdminUpdateusers($updates: [users_updates!]!) {
  update_users_many(updates: $updates) {
    returning {
      displayName
      disabled
      id
    }
    affected_rows
  }
}
    `;
export type AdminUpdateusersMutationFn_ = Apollo.MutationFunction<AdminUpdateusersMutation_, AdminUpdateusersMutationVariables_>;

/**
 * __useAdminUpdateusersMutation__
 *
 * To run a mutation, you first call `useAdminUpdateusersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateusersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateusersMutation, { data, loading, error }] = useAdminUpdateusersMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useAdminUpdateusersMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateusersMutation_, AdminUpdateusersMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateusersMutation_, AdminUpdateusersMutationVariables_>(AdminUpdateusersDocument_, options);
      }
export type AdminUpdateusersMutationHookResult = ReturnType<typeof useAdminUpdateusersMutation>;
export type AdminUpdateusersMutationResult_ = Apollo.MutationResult<AdminUpdateusersMutation_>;
export type AdminUpdateusersMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateusersMutation_, AdminUpdateusersMutationVariables_>;
export const AdminCreateUserDocument_ = gql`
    mutation AdminCreateUser($object: users_insert_input!, $on_conflict: users_on_conflict!) {
  insertUser(object: $object, on_conflict: $on_conflict) {
    id
    email
  }
}
    `;
export type AdminCreateUserMutationFn_ = Apollo.MutationFunction<AdminCreateUserMutation_, AdminCreateUserMutationVariables_>;

/**
 * __useAdminCreateUserMutation__
 *
 * To run a mutation, you first call `useAdminCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateUserMutation, { data, loading, error }] = useAdminCreateUserMutation({
 *   variables: {
 *      object: // value for 'object'
 *      on_conflict: // value for 'on_conflict'
 *   },
 * });
 */
export function useAdminCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateUserMutation_, AdminCreateUserMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateUserMutation_, AdminCreateUserMutationVariables_>(AdminCreateUserDocument_, options);
      }
export type AdminCreateUserMutationHookResult = ReturnType<typeof useAdminCreateUserMutation>;
export type AdminCreateUserMutationResult_ = Apollo.MutationResult<AdminCreateUserMutation_>;
export type AdminCreateUserMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateUserMutation_, AdminCreateUserMutationVariables_>;
export const AdminCreateCompanyUsersDocument_ = gql`
    mutation AdminCreateCompanyUsers($objects: [CompanyUser_insert_input!]!) {
  insert_CompanyUser(
    objects: $objects
    on_conflict: {constraint: CompanyUser_companyId_userId_10e185ba_uniq, update_columns: []}
  ) {
    returning {
      id
    }
  }
}
    `;
export type AdminCreateCompanyUsersMutationFn_ = Apollo.MutationFunction<AdminCreateCompanyUsersMutation_, AdminCreateCompanyUsersMutationVariables_>;

/**
 * __useAdminCreateCompanyUsersMutation__
 *
 * To run a mutation, you first call `useAdminCreateCompanyUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateCompanyUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateCompanyUsersMutation, { data, loading, error }] = useAdminCreateCompanyUsersMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateCompanyUsersMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateCompanyUsersMutation_, AdminCreateCompanyUsersMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateCompanyUsersMutation_, AdminCreateCompanyUsersMutationVariables_>(AdminCreateCompanyUsersDocument_, options);
      }
export type AdminCreateCompanyUsersMutationHookResult = ReturnType<typeof useAdminCreateCompanyUsersMutation>;
export type AdminCreateCompanyUsersMutationResult_ = Apollo.MutationResult<AdminCreateCompanyUsersMutation_>;
export type AdminCreateCompanyUsersMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateCompanyUsersMutation_, AdminCreateCompanyUsersMutationVariables_>;
export const AdminGetCompanyAssessmentsDocument_ = gql`
    query AdminGetCompanyAssessments($limit: Int, $offset: Int, $order_by: [CompanyAssessment_order_by!], $where: CompanyAssessment_bool_exp) {
  CompanyAssessment(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    createdAt
    updatedAt
    aggregateId
    companyId
    isLocked
  }
  CompanyAssessment_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetCompanyAssessmentsQuery__
 *
 * To run a query within a React component, call `useAdminGetCompanyAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetCompanyAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetCompanyAssessmentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetCompanyAssessmentsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetCompanyAssessmentsQuery_, AdminGetCompanyAssessmentsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetCompanyAssessmentsQuery_, AdminGetCompanyAssessmentsQueryVariables_>(AdminGetCompanyAssessmentsDocument_, options);
      }
export function useAdminGetCompanyAssessmentsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetCompanyAssessmentsQuery_, AdminGetCompanyAssessmentsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetCompanyAssessmentsQuery_, AdminGetCompanyAssessmentsQueryVariables_>(AdminGetCompanyAssessmentsDocument_, options);
        }
export function useAdminGetCompanyAssessmentsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetCompanyAssessmentsQuery_, AdminGetCompanyAssessmentsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetCompanyAssessmentsQuery_, AdminGetCompanyAssessmentsQueryVariables_>(AdminGetCompanyAssessmentsDocument_, options);
        }
export type AdminGetCompanyAssessmentsQueryHookResult = ReturnType<typeof useAdminGetCompanyAssessmentsQuery>;
export type AdminGetCompanyAssessmentsLazyQuery_HookResult = ReturnType<typeof useAdminGetCompanyAssessmentsLazyQuery_>;
export type AdminGetCompanyAssessmentsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetCompanyAssessmentsSuspenseQuery_>;
export type AdminGetCompanyAssessmentsQueryResult_ = Apollo.QueryResult<AdminGetCompanyAssessmentsQuery_, AdminGetCompanyAssessmentsQueryVariables_>;
export function refetchAdminGetCompanyAssessmentsQuery_(variables?: AdminGetCompanyAssessmentsQueryVariables_) {
      return { query: AdminGetCompanyAssessmentsDocument_, variables: variables }
    }
export const AdminGetGroupAssessmentsDocument_ = gql`
    query AdminGetGroupAssessments($limit: Int, $offset: Int, $order_by: [GroupAssessment_order_by!], $where: GroupAssessment_bool_exp) {
  GroupAssessment(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    createdAt
    name
    period
    companyId
    updatedAt
    consolidatedCompanyAssessmentId
    subsidiaries {
      id
      company {
        name
      }
    }
  }
  GroupAssessment_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetGroupAssessmentsQuery__
 *
 * To run a query within a React component, call `useAdminGetGroupAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetGroupAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetGroupAssessmentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetGroupAssessmentsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetGroupAssessmentsQuery_, AdminGetGroupAssessmentsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetGroupAssessmentsQuery_, AdminGetGroupAssessmentsQueryVariables_>(AdminGetGroupAssessmentsDocument_, options);
      }
export function useAdminGetGroupAssessmentsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetGroupAssessmentsQuery_, AdminGetGroupAssessmentsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetGroupAssessmentsQuery_, AdminGetGroupAssessmentsQueryVariables_>(AdminGetGroupAssessmentsDocument_, options);
        }
export function useAdminGetGroupAssessmentsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetGroupAssessmentsQuery_, AdminGetGroupAssessmentsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetGroupAssessmentsQuery_, AdminGetGroupAssessmentsQueryVariables_>(AdminGetGroupAssessmentsDocument_, options);
        }
export type AdminGetGroupAssessmentsQueryHookResult = ReturnType<typeof useAdminGetGroupAssessmentsQuery>;
export type AdminGetGroupAssessmentsLazyQuery_HookResult = ReturnType<typeof useAdminGetGroupAssessmentsLazyQuery_>;
export type AdminGetGroupAssessmentsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetGroupAssessmentsSuspenseQuery_>;
export type AdminGetGroupAssessmentsQueryResult_ = Apollo.QueryResult<AdminGetGroupAssessmentsQuery_, AdminGetGroupAssessmentsQueryVariables_>;
export function refetchAdminGetGroupAssessmentsQuery_(variables?: AdminGetGroupAssessmentsQueryVariables_) {
      return { query: AdminGetGroupAssessmentsDocument_, variables: variables }
    }
export const AdminGetCompanyAssessmentAggregatesDocument_ = gql`
    query AdminGetCompanyAssessmentAggregates($limit: Int, $offset: Int, $where: CompanyAssessmentAggregate_bool_exp) {
  CompanyAssessmentAggregate(limit: $limit, offset: $offset, where: $where) {
    id
    title
    createdAt
    updatedAt
    companyId
    isReal
  }
  CompanyAssessmentAggregate_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetCompanyAssessmentAggregatesQuery__
 *
 * To run a query within a React component, call `useAdminGetCompanyAssessmentAggregatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetCompanyAssessmentAggregatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetCompanyAssessmentAggregatesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetCompanyAssessmentAggregatesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetCompanyAssessmentAggregatesQuery_, AdminGetCompanyAssessmentAggregatesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetCompanyAssessmentAggregatesQuery_, AdminGetCompanyAssessmentAggregatesQueryVariables_>(AdminGetCompanyAssessmentAggregatesDocument_, options);
      }
export function useAdminGetCompanyAssessmentAggregatesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetCompanyAssessmentAggregatesQuery_, AdminGetCompanyAssessmentAggregatesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetCompanyAssessmentAggregatesQuery_, AdminGetCompanyAssessmentAggregatesQueryVariables_>(AdminGetCompanyAssessmentAggregatesDocument_, options);
        }
export function useAdminGetCompanyAssessmentAggregatesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetCompanyAssessmentAggregatesQuery_, AdminGetCompanyAssessmentAggregatesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetCompanyAssessmentAggregatesQuery_, AdminGetCompanyAssessmentAggregatesQueryVariables_>(AdminGetCompanyAssessmentAggregatesDocument_, options);
        }
export type AdminGetCompanyAssessmentAggregatesQueryHookResult = ReturnType<typeof useAdminGetCompanyAssessmentAggregatesQuery>;
export type AdminGetCompanyAssessmentAggregatesLazyQuery_HookResult = ReturnType<typeof useAdminGetCompanyAssessmentAggregatesLazyQuery_>;
export type AdminGetCompanyAssessmentAggregatesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetCompanyAssessmentAggregatesSuspenseQuery_>;
export type AdminGetCompanyAssessmentAggregatesQueryResult_ = Apollo.QueryResult<AdminGetCompanyAssessmentAggregatesQuery_, AdminGetCompanyAssessmentAggregatesQueryVariables_>;
export function refetchAdminGetCompanyAssessmentAggregatesQuery_(variables?: AdminGetCompanyAssessmentAggregatesQueryVariables_) {
      return { query: AdminGetCompanyAssessmentAggregatesDocument_, variables: variables }
    }
export const AdminUpdateCompanyAssessmentDocument_ = gql`
    mutation AdminUpdateCompanyAssessment($pk_columns: CompanyAssessment_pk_columns_input!, $_set: CompanyAssessment_set_input!) {
  update_CompanyAssessment_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    createdAt
    updatedAt
    aggregateId
    companyId
    isLocked
  }
}
    `;
export type AdminUpdateCompanyAssessmentMutationFn_ = Apollo.MutationFunction<AdminUpdateCompanyAssessmentMutation_, AdminUpdateCompanyAssessmentMutationVariables_>;

/**
 * __useAdminUpdateCompanyAssessmentMutation__
 *
 * To run a mutation, you first call `useAdminUpdateCompanyAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateCompanyAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateCompanyAssessmentMutation, { data, loading, error }] = useAdminUpdateCompanyAssessmentMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateCompanyAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateCompanyAssessmentMutation_, AdminUpdateCompanyAssessmentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateCompanyAssessmentMutation_, AdminUpdateCompanyAssessmentMutationVariables_>(AdminUpdateCompanyAssessmentDocument_, options);
      }
export type AdminUpdateCompanyAssessmentMutationHookResult = ReturnType<typeof useAdminUpdateCompanyAssessmentMutation>;
export type AdminUpdateCompanyAssessmentMutationResult_ = Apollo.MutationResult<AdminUpdateCompanyAssessmentMutation_>;
export type AdminUpdateCompanyAssessmentMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateCompanyAssessmentMutation_, AdminUpdateCompanyAssessmentMutationVariables_>;
export const AdminUpdateGroupAssessmentDocument_ = gql`
    mutation AdminUpdateGroupAssessment($pk_columns: GroupAssessment_pk_columns_input!, $_set: GroupAssessment_set_input!) {
  update_GroupAssessment_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    createdAt
    name
    period
    companyId
    updatedAt
    consolidatedCompanyAssessmentId
  }
}
    `;
export type AdminUpdateGroupAssessmentMutationFn_ = Apollo.MutationFunction<AdminUpdateGroupAssessmentMutation_, AdminUpdateGroupAssessmentMutationVariables_>;

/**
 * __useAdminUpdateGroupAssessmentMutation__
 *
 * To run a mutation, you first call `useAdminUpdateGroupAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateGroupAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateGroupAssessmentMutation, { data, loading, error }] = useAdminUpdateGroupAssessmentMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateGroupAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateGroupAssessmentMutation_, AdminUpdateGroupAssessmentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateGroupAssessmentMutation_, AdminUpdateGroupAssessmentMutationVariables_>(AdminUpdateGroupAssessmentDocument_, options);
      }
export type AdminUpdateGroupAssessmentMutationHookResult = ReturnType<typeof useAdminUpdateGroupAssessmentMutation>;
export type AdminUpdateGroupAssessmentMutationResult_ = Apollo.MutationResult<AdminUpdateGroupAssessmentMutation_>;
export type AdminUpdateGroupAssessmentMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateGroupAssessmentMutation_, AdminUpdateGroupAssessmentMutationVariables_>;
export const AdminGetSpacesDocument_ = gql`
    query AdminGetSpaces($limit: Int, $offset: Int, $order_by: [Space_order_by!], $where: Space_bool_exp) {
  Space(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    id
    name
    sharedWith {
      companyId
      company {
        name
      }
    }
  }
  Space_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetSpacesQuery__
 *
 * To run a query within a React component, call `useAdminGetSpacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetSpacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetSpacesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetSpacesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetSpacesQuery_, AdminGetSpacesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetSpacesQuery_, AdminGetSpacesQueryVariables_>(AdminGetSpacesDocument_, options);
      }
export function useAdminGetSpacesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetSpacesQuery_, AdminGetSpacesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetSpacesQuery_, AdminGetSpacesQueryVariables_>(AdminGetSpacesDocument_, options);
        }
export function useAdminGetSpacesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetSpacesQuery_, AdminGetSpacesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetSpacesQuery_, AdminGetSpacesQueryVariables_>(AdminGetSpacesDocument_, options);
        }
export type AdminGetSpacesQueryHookResult = ReturnType<typeof useAdminGetSpacesQuery>;
export type AdminGetSpacesLazyQuery_HookResult = ReturnType<typeof useAdminGetSpacesLazyQuery_>;
export type AdminGetSpacesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetSpacesSuspenseQuery_>;
export type AdminGetSpacesQueryResult_ = Apollo.QueryResult<AdminGetSpacesQuery_, AdminGetSpacesQueryVariables_>;
export function refetchAdminGetSpacesQuery_(variables?: AdminGetSpacesQueryVariables_) {
      return { query: AdminGetSpacesDocument_, variables: variables }
    }
export const AdminCreateSpaceDocument_ = gql`
    mutation AdminCreateSpace($object: Space_insert_input!) {
  insert_Space_one(object: $object) {
    id
    name
    sharedWith {
      companyId
      company {
        name
      }
    }
  }
}
    `;
export type AdminCreateSpaceMutationFn_ = Apollo.MutationFunction<AdminCreateSpaceMutation_, AdminCreateSpaceMutationVariables_>;

/**
 * __useAdminCreateSpaceMutation__
 *
 * To run a mutation, you first call `useAdminCreateSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateSpaceMutation, { data, loading, error }] = useAdminCreateSpaceMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateSpaceMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateSpaceMutation_, AdminCreateSpaceMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateSpaceMutation_, AdminCreateSpaceMutationVariables_>(AdminCreateSpaceDocument_, options);
      }
export type AdminCreateSpaceMutationHookResult = ReturnType<typeof useAdminCreateSpaceMutation>;
export type AdminCreateSpaceMutationResult_ = Apollo.MutationResult<AdminCreateSpaceMutation_>;
export type AdminCreateSpaceMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateSpaceMutation_, AdminCreateSpaceMutationVariables_>;
export const AdminGetActivitiesDocument_ = gql`
    query AdminGetActivities($limit: Int, $offset: Int, $order_by: [Activity_order_by!], $where: Activity_bool_exp) {
  Activity(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    name
    reference
    description
    sectorRef
    referenceNumber
    currentQuestionSetVersion
    isHidden
    additionalGuidance
    celsiaComment
    descriptionSource
    guidanceSource
    activityReports {
      bAssessment {
        cAssessment {
          company {
            name
            isReal
          }
          aggregate {
            title
          }
        }
        businessUnit {
          name
        }
      }
      activityVersionNumber
    }
  }
  Activity_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetActivitiesQuery__
 *
 * To run a query within a React component, call `useAdminGetActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetActivitiesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetActivitiesQuery_, AdminGetActivitiesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetActivitiesQuery_, AdminGetActivitiesQueryVariables_>(AdminGetActivitiesDocument_, options);
      }
export function useAdminGetActivitiesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetActivitiesQuery_, AdminGetActivitiesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetActivitiesQuery_, AdminGetActivitiesQueryVariables_>(AdminGetActivitiesDocument_, options);
        }
export function useAdminGetActivitiesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetActivitiesQuery_, AdminGetActivitiesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetActivitiesQuery_, AdminGetActivitiesQueryVariables_>(AdminGetActivitiesDocument_, options);
        }
export type AdminGetActivitiesQueryHookResult = ReturnType<typeof useAdminGetActivitiesQuery>;
export type AdminGetActivitiesLazyQuery_HookResult = ReturnType<typeof useAdminGetActivitiesLazyQuery_>;
export type AdminGetActivitiesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetActivitiesSuspenseQuery_>;
export type AdminGetActivitiesQueryResult_ = Apollo.QueryResult<AdminGetActivitiesQuery_, AdminGetActivitiesQueryVariables_>;
export function refetchAdminGetActivitiesQuery_(variables?: AdminGetActivitiesQueryVariables_) {
      return { query: AdminGetActivitiesDocument_, variables: variables }
    }
export const AdminGetSectorsDocument_ = gql`
    query AdminGetSectors($limit: Int, $offset: Int, $order_by: [Sector_order_by!], $where: Sector_bool_exp) {
  Sector(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    name
    reference
    referenceNumber
  }
  Sector_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetSectorsQuery__
 *
 * To run a query within a React component, call `useAdminGetSectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetSectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetSectorsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetSectorsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetSectorsQuery_, AdminGetSectorsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetSectorsQuery_, AdminGetSectorsQueryVariables_>(AdminGetSectorsDocument_, options);
      }
export function useAdminGetSectorsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetSectorsQuery_, AdminGetSectorsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetSectorsQuery_, AdminGetSectorsQueryVariables_>(AdminGetSectorsDocument_, options);
        }
export function useAdminGetSectorsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetSectorsQuery_, AdminGetSectorsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetSectorsQuery_, AdminGetSectorsQueryVariables_>(AdminGetSectorsDocument_, options);
        }
export type AdminGetSectorsQueryHookResult = ReturnType<typeof useAdminGetSectorsQuery>;
export type AdminGetSectorsLazyQuery_HookResult = ReturnType<typeof useAdminGetSectorsLazyQuery_>;
export type AdminGetSectorsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetSectorsSuspenseQuery_>;
export type AdminGetSectorsQueryResult_ = Apollo.QueryResult<AdminGetSectorsQuery_, AdminGetSectorsQueryVariables_>;
export function refetchAdminGetSectorsQuery_(variables?: AdminGetSectorsQueryVariables_) {
      return { query: AdminGetSectorsDocument_, variables: variables }
    }
export const AdminGetActivityQuestionSetsDocument_ = gql`
    query AdminGetActivityQuestionSets($limit: Int, $offset: Int, $order_by: [ActivityQuestionSet_order_by!], $where: ActivityQuestionSet_bool_exp) {
  ActivityQuestionSet(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    activityRef
    questionSetRef
    id
    version
  }
  ActivityQuestionSet_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetActivityQuestionSetsQuery__
 *
 * To run a query within a React component, call `useAdminGetActivityQuestionSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetActivityQuestionSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetActivityQuestionSetsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetActivityQuestionSetsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetActivityQuestionSetsQuery_, AdminGetActivityQuestionSetsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetActivityQuestionSetsQuery_, AdminGetActivityQuestionSetsQueryVariables_>(AdminGetActivityQuestionSetsDocument_, options);
      }
export function useAdminGetActivityQuestionSetsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetActivityQuestionSetsQuery_, AdminGetActivityQuestionSetsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetActivityQuestionSetsQuery_, AdminGetActivityQuestionSetsQueryVariables_>(AdminGetActivityQuestionSetsDocument_, options);
        }
export function useAdminGetActivityQuestionSetsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetActivityQuestionSetsQuery_, AdminGetActivityQuestionSetsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetActivityQuestionSetsQuery_, AdminGetActivityQuestionSetsQueryVariables_>(AdminGetActivityQuestionSetsDocument_, options);
        }
export type AdminGetActivityQuestionSetsQueryHookResult = ReturnType<typeof useAdminGetActivityQuestionSetsQuery>;
export type AdminGetActivityQuestionSetsLazyQuery_HookResult = ReturnType<typeof useAdminGetActivityQuestionSetsLazyQuery_>;
export type AdminGetActivityQuestionSetsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetActivityQuestionSetsSuspenseQuery_>;
export type AdminGetActivityQuestionSetsQueryResult_ = Apollo.QueryResult<AdminGetActivityQuestionSetsQuery_, AdminGetActivityQuestionSetsQueryVariables_>;
export function refetchAdminGetActivityQuestionSetsQuery_(variables?: AdminGetActivityQuestionSetsQueryVariables_) {
      return { query: AdminGetActivityQuestionSetsDocument_, variables: variables }
    }
export const AdminGetQuestionSetsDocument_ = gql`
    query AdminGetQuestionSets($limit: Int, $offset: Int, $order_by: [QuestionSet_order_by!], $where: QuestionSet_bool_exp) {
  QuestionSet(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    reference
    questions {
      questionId
      question {
        uniqueId
        version
        id
      }
    }
  }
  QuestionSet_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetQuestionSetsQuery__
 *
 * To run a query within a React component, call `useAdminGetQuestionSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetQuestionSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetQuestionSetsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetQuestionSetsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetQuestionSetsQuery_, AdminGetQuestionSetsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetQuestionSetsQuery_, AdminGetQuestionSetsQueryVariables_>(AdminGetQuestionSetsDocument_, options);
      }
export function useAdminGetQuestionSetsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetQuestionSetsQuery_, AdminGetQuestionSetsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetQuestionSetsQuery_, AdminGetQuestionSetsQueryVariables_>(AdminGetQuestionSetsDocument_, options);
        }
export function useAdminGetQuestionSetsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetQuestionSetsQuery_, AdminGetQuestionSetsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetQuestionSetsQuery_, AdminGetQuestionSetsQueryVariables_>(AdminGetQuestionSetsDocument_, options);
        }
export type AdminGetQuestionSetsQueryHookResult = ReturnType<typeof useAdminGetQuestionSetsQuery>;
export type AdminGetQuestionSetsLazyQuery_HookResult = ReturnType<typeof useAdminGetQuestionSetsLazyQuery_>;
export type AdminGetQuestionSetsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetQuestionSetsSuspenseQuery_>;
export type AdminGetQuestionSetsQueryResult_ = Apollo.QueryResult<AdminGetQuestionSetsQuery_, AdminGetQuestionSetsQueryVariables_>;
export function refetchAdminGetQuestionSetsQuery_(variables?: AdminGetQuestionSetsQueryVariables_) {
      return { query: AdminGetQuestionSetsDocument_, variables: variables }
    }
export const AdminGetQuestionsDocument_ = gql`
    query AdminGetQuestions($limit: Int, $offset: Int, $order_by: [Question_order_by!], $where: Question_bool_exp) {
  Question(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    uniqueId
    version
    title
    description
    type
    level
    group
    orderIndex
    unit
    alignmentErrorMessage
    dependencyDescription
    extendedDescription
    resourceLink
    documentationRequired
    relevantDirectives
    objectiveKey
    id
    other
    isAligned
    isRequired
    isVisible
    isEditable
    levelExpression
    learnMoreArticleSlug
    olderRevisions {
      oldQuestion {
        id
        uniqueId
        version
      }
      oldQuestionId
      newQuestionId
      description
    }
  }
  Question_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetQuestionsQuery__
 *
 * To run a query within a React component, call `useAdminGetQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetQuestionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetQuestionsQuery_, AdminGetQuestionsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetQuestionsQuery_, AdminGetQuestionsQueryVariables_>(AdminGetQuestionsDocument_, options);
      }
export function useAdminGetQuestionsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetQuestionsQuery_, AdminGetQuestionsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetQuestionsQuery_, AdminGetQuestionsQueryVariables_>(AdminGetQuestionsDocument_, options);
        }
export function useAdminGetQuestionsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetQuestionsQuery_, AdminGetQuestionsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetQuestionsQuery_, AdminGetQuestionsQueryVariables_>(AdminGetQuestionsDocument_, options);
        }
export type AdminGetQuestionsQueryHookResult = ReturnType<typeof useAdminGetQuestionsQuery>;
export type AdminGetQuestionsLazyQuery_HookResult = ReturnType<typeof useAdminGetQuestionsLazyQuery_>;
export type AdminGetQuestionsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetQuestionsSuspenseQuery_>;
export type AdminGetQuestionsQueryResult_ = Apollo.QueryResult<AdminGetQuestionsQuery_, AdminGetQuestionsQueryVariables_>;
export function refetchAdminGetQuestionsQuery_(variables?: AdminGetQuestionsQueryVariables_) {
      return { query: AdminGetQuestionsDocument_, variables: variables }
    }
export const AdminGetQuestionRevisionsDocument_ = gql`
    query AdminGetQuestionRevisions($limit: Int, $offset: Int, $order_by: [QuestionRevision_order_by!], $where: QuestionRevision_bool_exp) {
  QuestionRevision(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    oldQuestionId
    newQuestionId
    description
    oldQuestion {
      id
      uniqueId
      version
    }
    newQuestion {
      id
      uniqueId
      version
    }
  }
  QuestionRevision_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetQuestionRevisionsQuery__
 *
 * To run a query within a React component, call `useAdminGetQuestionRevisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetQuestionRevisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetQuestionRevisionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetQuestionRevisionsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetQuestionRevisionsQuery_, AdminGetQuestionRevisionsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetQuestionRevisionsQuery_, AdminGetQuestionRevisionsQueryVariables_>(AdminGetQuestionRevisionsDocument_, options);
      }
export function useAdminGetQuestionRevisionsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetQuestionRevisionsQuery_, AdminGetQuestionRevisionsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetQuestionRevisionsQuery_, AdminGetQuestionRevisionsQueryVariables_>(AdminGetQuestionRevisionsDocument_, options);
        }
export function useAdminGetQuestionRevisionsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetQuestionRevisionsQuery_, AdminGetQuestionRevisionsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetQuestionRevisionsQuery_, AdminGetQuestionRevisionsQueryVariables_>(AdminGetQuestionRevisionsDocument_, options);
        }
export type AdminGetQuestionRevisionsQueryHookResult = ReturnType<typeof useAdminGetQuestionRevisionsQuery>;
export type AdminGetQuestionRevisionsLazyQuery_HookResult = ReturnType<typeof useAdminGetQuestionRevisionsLazyQuery_>;
export type AdminGetQuestionRevisionsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetQuestionRevisionsSuspenseQuery_>;
export type AdminGetQuestionRevisionsQueryResult_ = Apollo.QueryResult<AdminGetQuestionRevisionsQuery_, AdminGetQuestionRevisionsQueryVariables_>;
export function refetchAdminGetQuestionRevisionsQuery_(variables?: AdminGetQuestionRevisionsQueryVariables_) {
      return { query: AdminGetQuestionRevisionsDocument_, variables: variables }
    }
export const AdminGetObjectivesDocument_ = gql`
    query AdminGetObjectives($limit: Int, $offset: Int, $order_by: [Objective_order_by!], $where: Objective_bool_exp) {
  Objective(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    key
    title
    description
  }
  Objective_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetObjectivesQuery__
 *
 * To run a query within a React component, call `useAdminGetObjectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetObjectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetObjectivesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetObjectivesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetObjectivesQuery_, AdminGetObjectivesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetObjectivesQuery_, AdminGetObjectivesQueryVariables_>(AdminGetObjectivesDocument_, options);
      }
export function useAdminGetObjectivesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetObjectivesQuery_, AdminGetObjectivesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetObjectivesQuery_, AdminGetObjectivesQueryVariables_>(AdminGetObjectivesDocument_, options);
        }
export function useAdminGetObjectivesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetObjectivesQuery_, AdminGetObjectivesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetObjectivesQuery_, AdminGetObjectivesQueryVariables_>(AdminGetObjectivesDocument_, options);
        }
export type AdminGetObjectivesQueryHookResult = ReturnType<typeof useAdminGetObjectivesQuery>;
export type AdminGetObjectivesLazyQuery_HookResult = ReturnType<typeof useAdminGetObjectivesLazyQuery_>;
export type AdminGetObjectivesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetObjectivesSuspenseQuery_>;
export type AdminGetObjectivesQueryResult_ = Apollo.QueryResult<AdminGetObjectivesQuery_, AdminGetObjectivesQueryVariables_>;
export function refetchAdminGetObjectivesQuery_(variables?: AdminGetObjectivesQueryVariables_) {
      return { query: AdminGetObjectivesDocument_, variables: variables }
    }
export const AdminGetQuestionSetQuestionsDocument_ = gql`
    query AdminGetQuestionSetQuestions($limit: Int, $offset: Int, $order_by: [QuestionSetQuestion_order_by!], $where: QuestionSetQuestion_bool_exp) {
  QuestionSetQuestion(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    questionSetRef
    questionId
  }
  QuestionSetQuestion_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetQuestionSetQuestionsQuery__
 *
 * To run a query within a React component, call `useAdminGetQuestionSetQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetQuestionSetQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetQuestionSetQuestionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetQuestionSetQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetQuestionSetQuestionsQuery_, AdminGetQuestionSetQuestionsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetQuestionSetQuestionsQuery_, AdminGetQuestionSetQuestionsQueryVariables_>(AdminGetQuestionSetQuestionsDocument_, options);
      }
export function useAdminGetQuestionSetQuestionsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetQuestionSetQuestionsQuery_, AdminGetQuestionSetQuestionsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetQuestionSetQuestionsQuery_, AdminGetQuestionSetQuestionsQueryVariables_>(AdminGetQuestionSetQuestionsDocument_, options);
        }
export function useAdminGetQuestionSetQuestionsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetQuestionSetQuestionsQuery_, AdminGetQuestionSetQuestionsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetQuestionSetQuestionsQuery_, AdminGetQuestionSetQuestionsQueryVariables_>(AdminGetQuestionSetQuestionsDocument_, options);
        }
export type AdminGetQuestionSetQuestionsQueryHookResult = ReturnType<typeof useAdminGetQuestionSetQuestionsQuery>;
export type AdminGetQuestionSetQuestionsLazyQuery_HookResult = ReturnType<typeof useAdminGetQuestionSetQuestionsLazyQuery_>;
export type AdminGetQuestionSetQuestionsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetQuestionSetQuestionsSuspenseQuery_>;
export type AdminGetQuestionSetQuestionsQueryResult_ = Apollo.QueryResult<AdminGetQuestionSetQuestionsQuery_, AdminGetQuestionSetQuestionsQueryVariables_>;
export function refetchAdminGetQuestionSetQuestionsQuery_(variables?: AdminGetQuestionSetQuestionsQueryVariables_) {
      return { query: AdminGetQuestionSetQuestionsDocument_, variables: variables }
    }
export const AdminGetQuestionChoicesDocument_ = gql`
    query AdminGetQuestionChoices($limit: Int, $offset: Int, $order_by: [QuestionChoice_order_by!], $where: QuestionChoice_bool_exp) {
  QuestionChoice(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    order
    value
    displayName
    question_id
  }
  QuestionChoice_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetQuestionChoicesQuery__
 *
 * To run a query within a React component, call `useAdminGetQuestionChoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetQuestionChoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetQuestionChoicesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetQuestionChoicesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetQuestionChoicesQuery_, AdminGetQuestionChoicesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetQuestionChoicesQuery_, AdminGetQuestionChoicesQueryVariables_>(AdminGetQuestionChoicesDocument_, options);
      }
export function useAdminGetQuestionChoicesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetQuestionChoicesQuery_, AdminGetQuestionChoicesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetQuestionChoicesQuery_, AdminGetQuestionChoicesQueryVariables_>(AdminGetQuestionChoicesDocument_, options);
        }
export function useAdminGetQuestionChoicesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetQuestionChoicesQuery_, AdminGetQuestionChoicesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetQuestionChoicesQuery_, AdminGetQuestionChoicesQueryVariables_>(AdminGetQuestionChoicesDocument_, options);
        }
export type AdminGetQuestionChoicesQueryHookResult = ReturnType<typeof useAdminGetQuestionChoicesQuery>;
export type AdminGetQuestionChoicesLazyQuery_HookResult = ReturnType<typeof useAdminGetQuestionChoicesLazyQuery_>;
export type AdminGetQuestionChoicesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetQuestionChoicesSuspenseQuery_>;
export type AdminGetQuestionChoicesQueryResult_ = Apollo.QueryResult<AdminGetQuestionChoicesQuery_, AdminGetQuestionChoicesQueryVariables_>;
export function refetchAdminGetQuestionChoicesQuery_(variables?: AdminGetQuestionChoicesQueryVariables_) {
      return { query: AdminGetQuestionChoicesDocument_, variables: variables }
    }
export const AdminGetActivityNaceCodesDocument_ = gql`
    query AdminGetActivityNaceCodes($limit: Int, $offset: Int, $order_by: [ActivityNaceCode_order_by!], $where: ActivityNaceCode_bool_exp) {
  ActivityNaceCode(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    activityRef
    code
    id
  }
  ActivityNaceCode_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetActivityNaceCodesQuery__
 *
 * To run a query within a React component, call `useAdminGetActivityNaceCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetActivityNaceCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetActivityNaceCodesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetActivityNaceCodesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetActivityNaceCodesQuery_, AdminGetActivityNaceCodesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetActivityNaceCodesQuery_, AdminGetActivityNaceCodesQueryVariables_>(AdminGetActivityNaceCodesDocument_, options);
      }
export function useAdminGetActivityNaceCodesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetActivityNaceCodesQuery_, AdminGetActivityNaceCodesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetActivityNaceCodesQuery_, AdminGetActivityNaceCodesQueryVariables_>(AdminGetActivityNaceCodesDocument_, options);
        }
export function useAdminGetActivityNaceCodesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetActivityNaceCodesQuery_, AdminGetActivityNaceCodesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetActivityNaceCodesQuery_, AdminGetActivityNaceCodesQueryVariables_>(AdminGetActivityNaceCodesDocument_, options);
        }
export type AdminGetActivityNaceCodesQueryHookResult = ReturnType<typeof useAdminGetActivityNaceCodesQuery>;
export type AdminGetActivityNaceCodesLazyQuery_HookResult = ReturnType<typeof useAdminGetActivityNaceCodesLazyQuery_>;
export type AdminGetActivityNaceCodesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetActivityNaceCodesSuspenseQuery_>;
export type AdminGetActivityNaceCodesQueryResult_ = Apollo.QueryResult<AdminGetActivityNaceCodesQuery_, AdminGetActivityNaceCodesQueryVariables_>;
export function refetchAdminGetActivityNaceCodesQuery_(variables?: AdminGetActivityNaceCodesQueryVariables_) {
      return { query: AdminGetActivityNaceCodesDocument_, variables: variables }
    }
export const AdminGetActivityVersionsDocument_ = gql`
    query AdminGetActivityVersions($limit: Int, $offset: Int, $order_by: [ActivityVersion_order_by!], $where: ActivityVersion_bool_exp) {
  ActivityVersion(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    activityRef
    versionNumber
    tagExpression
    tagObjective
    changeDescription
    validFrom
    activityQuestionSets {
      questionSetRef
      version
      activityRef
      questionSet {
        reference
      }
    }
  }
  ActivityVersion_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetActivityVersionsQuery__
 *
 * To run a query within a React component, call `useAdminGetActivityVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetActivityVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetActivityVersionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetActivityVersionsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetActivityVersionsQuery_, AdminGetActivityVersionsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetActivityVersionsQuery_, AdminGetActivityVersionsQueryVariables_>(AdminGetActivityVersionsDocument_, options);
      }
export function useAdminGetActivityVersionsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetActivityVersionsQuery_, AdminGetActivityVersionsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetActivityVersionsQuery_, AdminGetActivityVersionsQueryVariables_>(AdminGetActivityVersionsDocument_, options);
        }
export function useAdminGetActivityVersionsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetActivityVersionsQuery_, AdminGetActivityVersionsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetActivityVersionsQuery_, AdminGetActivityVersionsQueryVariables_>(AdminGetActivityVersionsDocument_, options);
        }
export type AdminGetActivityVersionsQueryHookResult = ReturnType<typeof useAdminGetActivityVersionsQuery>;
export type AdminGetActivityVersionsLazyQuery_HookResult = ReturnType<typeof useAdminGetActivityVersionsLazyQuery_>;
export type AdminGetActivityVersionsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetActivityVersionsSuspenseQuery_>;
export type AdminGetActivityVersionsQueryResult_ = Apollo.QueryResult<AdminGetActivityVersionsQuery_, AdminGetActivityVersionsQueryVariables_>;
export function refetchAdminGetActivityVersionsQuery_(variables?: AdminGetActivityVersionsQueryVariables_) {
      return { query: AdminGetActivityVersionsDocument_, variables: variables }
    }
export const AdminGetArticlesDocument_ = gql`
    query AdminGetArticles($limit: Int, $offset: Int, $order_by: [Article_order_by!], $where: Article_bool_exp) {
  Article(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    title
    body
    id
    slug
    isHidden
    order
  }
  Article_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetArticlesQuery__
 *
 * To run a query within a React component, call `useAdminGetArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetArticlesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetArticlesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetArticlesQuery_, AdminGetArticlesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetArticlesQuery_, AdminGetArticlesQueryVariables_>(AdminGetArticlesDocument_, options);
      }
export function useAdminGetArticlesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetArticlesQuery_, AdminGetArticlesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetArticlesQuery_, AdminGetArticlesQueryVariables_>(AdminGetArticlesDocument_, options);
        }
export function useAdminGetArticlesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetArticlesQuery_, AdminGetArticlesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetArticlesQuery_, AdminGetArticlesQueryVariables_>(AdminGetArticlesDocument_, options);
        }
export type AdminGetArticlesQueryHookResult = ReturnType<typeof useAdminGetArticlesQuery>;
export type AdminGetArticlesLazyQuery_HookResult = ReturnType<typeof useAdminGetArticlesLazyQuery_>;
export type AdminGetArticlesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetArticlesSuspenseQuery_>;
export type AdminGetArticlesQueryResult_ = Apollo.QueryResult<AdminGetArticlesQuery_, AdminGetArticlesQueryVariables_>;
export function refetchAdminGetArticlesQuery_(variables?: AdminGetArticlesQueryVariables_) {
      return { query: AdminGetArticlesDocument_, variables: variables }
    }
export const AdminGetTagsDocument_ = gql`
    query AdminGetTags($limit: Int, $offset: Int, $order_by: [Tag_order_by!], $where: Tag_bool_exp) {
  Tag(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    id
    name
    description
    tagGroupId
  }
  Tag_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetTagsQuery__
 *
 * To run a query within a React component, call `useAdminGetTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetTagsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetTagsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetTagsQuery_, AdminGetTagsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetTagsQuery_, AdminGetTagsQueryVariables_>(AdminGetTagsDocument_, options);
      }
export function useAdminGetTagsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetTagsQuery_, AdminGetTagsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetTagsQuery_, AdminGetTagsQueryVariables_>(AdminGetTagsDocument_, options);
        }
export function useAdminGetTagsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetTagsQuery_, AdminGetTagsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetTagsQuery_, AdminGetTagsQueryVariables_>(AdminGetTagsDocument_, options);
        }
export type AdminGetTagsQueryHookResult = ReturnType<typeof useAdminGetTagsQuery>;
export type AdminGetTagsLazyQuery_HookResult = ReturnType<typeof useAdminGetTagsLazyQuery_>;
export type AdminGetTagsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetTagsSuspenseQuery_>;
export type AdminGetTagsQueryResult_ = Apollo.QueryResult<AdminGetTagsQuery_, AdminGetTagsQueryVariables_>;
export function refetchAdminGetTagsQuery_(variables?: AdminGetTagsQueryVariables_) {
      return { query: AdminGetTagsDocument_, variables: variables }
    }
export const AdminGetTagGroupsDocument_ = gql`
    query AdminGetTagGroups($limit: Int, $offset: Int, $order_by: [TagGroup_order_by!], $where: TagGroup_bool_exp) {
  TagGroup(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    id
    name
    description
  }
  TagGroup_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetTagGroupsQuery__
 *
 * To run a query within a React component, call `useAdminGetTagGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetTagGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetTagGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetTagGroupsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetTagGroupsQuery_, AdminGetTagGroupsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetTagGroupsQuery_, AdminGetTagGroupsQueryVariables_>(AdminGetTagGroupsDocument_, options);
      }
export function useAdminGetTagGroupsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetTagGroupsQuery_, AdminGetTagGroupsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetTagGroupsQuery_, AdminGetTagGroupsQueryVariables_>(AdminGetTagGroupsDocument_, options);
        }
export function useAdminGetTagGroupsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetTagGroupsQuery_, AdminGetTagGroupsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetTagGroupsQuery_, AdminGetTagGroupsQueryVariables_>(AdminGetTagGroupsDocument_, options);
        }
export type AdminGetTagGroupsQueryHookResult = ReturnType<typeof useAdminGetTagGroupsQuery>;
export type AdminGetTagGroupsLazyQuery_HookResult = ReturnType<typeof useAdminGetTagGroupsLazyQuery_>;
export type AdminGetTagGroupsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetTagGroupsSuspenseQuery_>;
export type AdminGetTagGroupsQueryResult_ = Apollo.QueryResult<AdminGetTagGroupsQuery_, AdminGetTagGroupsQueryVariables_>;
export function refetchAdminGetTagGroupsQuery_(variables?: AdminGetTagGroupsQueryVariables_) {
      return { query: AdminGetTagGroupsDocument_, variables: variables }
    }
export const AdminGetTag_ArticlesDocument_ = gql`
    query AdminGetTag_articles($limit: Int, $offset: Int, $order_by: [Tag_articles_order_by!], $where: Tag_articles_bool_exp) {
  Tag_articles(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    id
    tag_id
    article_id
  }
  Tag_articles_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetTag_ArticlesQuery__
 *
 * To run a query within a React component, call `useAdminGetTag_ArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetTag_ArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetTag_ArticlesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetTag_ArticlesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetTag_ArticlesQuery_, AdminGetTag_ArticlesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetTag_ArticlesQuery_, AdminGetTag_ArticlesQueryVariables_>(AdminGetTag_ArticlesDocument_, options);
      }
export function useAdminGetTag_ArticlesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetTag_ArticlesQuery_, AdminGetTag_ArticlesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetTag_ArticlesQuery_, AdminGetTag_ArticlesQueryVariables_>(AdminGetTag_ArticlesDocument_, options);
        }
export function useAdminGetTag_ArticlesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetTag_ArticlesQuery_, AdminGetTag_ArticlesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetTag_ArticlesQuery_, AdminGetTag_ArticlesQueryVariables_>(AdminGetTag_ArticlesDocument_, options);
        }
export type AdminGetTag_ArticlesQueryHookResult = ReturnType<typeof useAdminGetTag_ArticlesQuery>;
export type AdminGetTag_ArticlesLazyQuery_HookResult = ReturnType<typeof useAdminGetTag_ArticlesLazyQuery_>;
export type AdminGetTag_ArticlesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetTag_ArticlesSuspenseQuery_>;
export type AdminGetTag_ArticlesQueryResult_ = Apollo.QueryResult<AdminGetTag_ArticlesQuery_, AdminGetTag_ArticlesQueryVariables_>;
export function refetchAdminGetTag_ArticlesQuery_(variables?: AdminGetTag_ArticlesQueryVariables_) {
      return { query: AdminGetTag_ArticlesDocument_, variables: variables }
    }
export const AdminGetPaiCategoriesDocument_ = gql`
    query AdminGetPaiCategories($limit: Int, $offset: Int, $order_by: [PaiCategory_order_by!], $where: PaiCategory_bool_exp) {
  PaiCategory(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    title
    reference
    subtitle
    tableReference
  }
  PaiCategory_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetPaiCategoriesQuery__
 *
 * To run a query within a React component, call `useAdminGetPaiCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetPaiCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetPaiCategoriesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetPaiCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetPaiCategoriesQuery_, AdminGetPaiCategoriesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetPaiCategoriesQuery_, AdminGetPaiCategoriesQueryVariables_>(AdminGetPaiCategoriesDocument_, options);
      }
export function useAdminGetPaiCategoriesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetPaiCategoriesQuery_, AdminGetPaiCategoriesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetPaiCategoriesQuery_, AdminGetPaiCategoriesQueryVariables_>(AdminGetPaiCategoriesDocument_, options);
        }
export function useAdminGetPaiCategoriesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetPaiCategoriesQuery_, AdminGetPaiCategoriesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetPaiCategoriesQuery_, AdminGetPaiCategoriesQueryVariables_>(AdminGetPaiCategoriesDocument_, options);
        }
export type AdminGetPaiCategoriesQueryHookResult = ReturnType<typeof useAdminGetPaiCategoriesQuery>;
export type AdminGetPaiCategoriesLazyQuery_HookResult = ReturnType<typeof useAdminGetPaiCategoriesLazyQuery_>;
export type AdminGetPaiCategoriesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetPaiCategoriesSuspenseQuery_>;
export type AdminGetPaiCategoriesQueryResult_ = Apollo.QueryResult<AdminGetPaiCategoriesQuery_, AdminGetPaiCategoriesQueryVariables_>;
export function refetchAdminGetPaiCategoriesQuery_(variables?: AdminGetPaiCategoriesQueryVariables_) {
      return { query: AdminGetPaiCategoriesDocument_, variables: variables }
    }
export const AdminGetPaiTablesDocument_ = gql`
    query AdminGetPaiTables($limit: Int, $offset: Int, $order_by: [PaiTable_order_by!], $where: PaiTable_bool_exp) {
  PaiTable(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    title
    reference
    isMandatory
    subtitle
    isCustom
  }
  PaiTable_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetPaiTablesQuery__
 *
 * To run a query within a React component, call `useAdminGetPaiTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetPaiTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetPaiTablesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetPaiTablesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetPaiTablesQuery_, AdminGetPaiTablesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetPaiTablesQuery_, AdminGetPaiTablesQueryVariables_>(AdminGetPaiTablesDocument_, options);
      }
export function useAdminGetPaiTablesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetPaiTablesQuery_, AdminGetPaiTablesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetPaiTablesQuery_, AdminGetPaiTablesQueryVariables_>(AdminGetPaiTablesDocument_, options);
        }
export function useAdminGetPaiTablesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetPaiTablesQuery_, AdminGetPaiTablesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetPaiTablesQuery_, AdminGetPaiTablesQueryVariables_>(AdminGetPaiTablesDocument_, options);
        }
export type AdminGetPaiTablesQueryHookResult = ReturnType<typeof useAdminGetPaiTablesQuery>;
export type AdminGetPaiTablesLazyQuery_HookResult = ReturnType<typeof useAdminGetPaiTablesLazyQuery_>;
export type AdminGetPaiTablesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetPaiTablesSuspenseQuery_>;
export type AdminGetPaiTablesQueryResult_ = Apollo.QueryResult<AdminGetPaiTablesQuery_, AdminGetPaiTablesQueryVariables_>;
export function refetchAdminGetPaiTablesQuery_(variables?: AdminGetPaiTablesQueryVariables_) {
      return { query: AdminGetPaiTablesDocument_, variables: variables }
    }
export const AdminGetPaiTableIndicatorsDocument_ = gql`
    query AdminGetPaiTableIndicators($limit: Int, $offset: Int, $order_by: [PaiTableIndicator_order_by!], $where: PaiTableIndicator_bool_exp) {
  PaiTableIndicator(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    title
    reference
    categoryReference
    description
    isHidden
    order
  }
  PaiTableIndicator_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetPaiTableIndicatorsQuery__
 *
 * To run a query within a React component, call `useAdminGetPaiTableIndicatorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetPaiTableIndicatorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetPaiTableIndicatorsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetPaiTableIndicatorsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetPaiTableIndicatorsQuery_, AdminGetPaiTableIndicatorsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetPaiTableIndicatorsQuery_, AdminGetPaiTableIndicatorsQueryVariables_>(AdminGetPaiTableIndicatorsDocument_, options);
      }
export function useAdminGetPaiTableIndicatorsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetPaiTableIndicatorsQuery_, AdminGetPaiTableIndicatorsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetPaiTableIndicatorsQuery_, AdminGetPaiTableIndicatorsQueryVariables_>(AdminGetPaiTableIndicatorsDocument_, options);
        }
export function useAdminGetPaiTableIndicatorsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetPaiTableIndicatorsQuery_, AdminGetPaiTableIndicatorsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetPaiTableIndicatorsQuery_, AdminGetPaiTableIndicatorsQueryVariables_>(AdminGetPaiTableIndicatorsDocument_, options);
        }
export type AdminGetPaiTableIndicatorsQueryHookResult = ReturnType<typeof useAdminGetPaiTableIndicatorsQuery>;
export type AdminGetPaiTableIndicatorsLazyQuery_HookResult = ReturnType<typeof useAdminGetPaiTableIndicatorsLazyQuery_>;
export type AdminGetPaiTableIndicatorsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetPaiTableIndicatorsSuspenseQuery_>;
export type AdminGetPaiTableIndicatorsQueryResult_ = Apollo.QueryResult<AdminGetPaiTableIndicatorsQuery_, AdminGetPaiTableIndicatorsQueryVariables_>;
export function refetchAdminGetPaiTableIndicatorsQuery_(variables?: AdminGetPaiTableIndicatorsQueryVariables_) {
      return { query: AdminGetPaiTableIndicatorsDocument_, variables: variables }
    }
export const AdminGetInvestorMetricsDocument_ = gql`
    query AdminGetInvestorMetrics($limit: Int, $offset: Int, $order_by: [InvestorMetric_order_by!], $where: InvestorMetric_bool_exp) {
  InvestorMetric(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    title
    reference
    description
    methodology
    unit
    isAggregatable
  }
  InvestorMetric_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetInvestorMetricsQuery__
 *
 * To run a query within a React component, call `useAdminGetInvestorMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetInvestorMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetInvestorMetricsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetInvestorMetricsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetInvestorMetricsQuery_, AdminGetInvestorMetricsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetInvestorMetricsQuery_, AdminGetInvestorMetricsQueryVariables_>(AdminGetInvestorMetricsDocument_, options);
      }
export function useAdminGetInvestorMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetInvestorMetricsQuery_, AdminGetInvestorMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetInvestorMetricsQuery_, AdminGetInvestorMetricsQueryVariables_>(AdminGetInvestorMetricsDocument_, options);
        }
export function useAdminGetInvestorMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetInvestorMetricsQuery_, AdminGetInvestorMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetInvestorMetricsQuery_, AdminGetInvestorMetricsQueryVariables_>(AdminGetInvestorMetricsDocument_, options);
        }
export type AdminGetInvestorMetricsQueryHookResult = ReturnType<typeof useAdminGetInvestorMetricsQuery>;
export type AdminGetInvestorMetricsLazyQuery_HookResult = ReturnType<typeof useAdminGetInvestorMetricsLazyQuery_>;
export type AdminGetInvestorMetricsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetInvestorMetricsSuspenseQuery_>;
export type AdminGetInvestorMetricsQueryResult_ = Apollo.QueryResult<AdminGetInvestorMetricsQuery_, AdminGetInvestorMetricsQueryVariables_>;
export function refetchAdminGetInvestorMetricsQuery_(variables?: AdminGetInvestorMetricsQueryVariables_) {
      return { query: AdminGetInvestorMetricsDocument_, variables: variables }
    }
export const AdminGetInvesteeMetricsDocument_ = gql`
    query AdminGetInvesteeMetrics($limit: Int, $offset: Int, $order_by: [InvesteeMetric_order_by!], $where: InvesteeMetric_bool_exp) {
  InvesteeMetric(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    title
    reference
    methodology
    description
    dependencies
    additionalResources
    type
    unit
    order
  }
  InvesteeMetric_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetInvesteeMetricsQuery__
 *
 * To run a query within a React component, call `useAdminGetInvesteeMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetInvesteeMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetInvesteeMetricsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetInvesteeMetricsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetInvesteeMetricsQuery_, AdminGetInvesteeMetricsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetInvesteeMetricsQuery_, AdminGetInvesteeMetricsQueryVariables_>(AdminGetInvesteeMetricsDocument_, options);
      }
export function useAdminGetInvesteeMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetInvesteeMetricsQuery_, AdminGetInvesteeMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetInvesteeMetricsQuery_, AdminGetInvesteeMetricsQueryVariables_>(AdminGetInvesteeMetricsDocument_, options);
        }
export function useAdminGetInvesteeMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetInvesteeMetricsQuery_, AdminGetInvesteeMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetInvesteeMetricsQuery_, AdminGetInvesteeMetricsQueryVariables_>(AdminGetInvesteeMetricsDocument_, options);
        }
export type AdminGetInvesteeMetricsQueryHookResult = ReturnType<typeof useAdminGetInvesteeMetricsQuery>;
export type AdminGetInvesteeMetricsLazyQuery_HookResult = ReturnType<typeof useAdminGetInvesteeMetricsLazyQuery_>;
export type AdminGetInvesteeMetricsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetInvesteeMetricsSuspenseQuery_>;
export type AdminGetInvesteeMetricsQueryResult_ = Apollo.QueryResult<AdminGetInvesteeMetricsQuery_, AdminGetInvesteeMetricsQueryVariables_>;
export function refetchAdminGetInvesteeMetricsQuery_(variables?: AdminGetInvesteeMetricsQueryVariables_) {
      return { query: AdminGetInvesteeMetricsDocument_, variables: variables }
    }
export const AdminGetIndicatorToInvestorMetricsDocument_ = gql`
    query AdminGetIndicatorToInvestorMetrics($limit: Int, $offset: Int, $order_by: [IndicatorToInvestorMetric_order_by!], $where: IndicatorToInvestorMetric_bool_exp) {
  IndicatorToInvestorMetric(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    investorMetricRef
    indicatorRef
  }
  IndicatorToInvestorMetric_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetIndicatorToInvestorMetricsQuery__
 *
 * To run a query within a React component, call `useAdminGetIndicatorToInvestorMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetIndicatorToInvestorMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetIndicatorToInvestorMetricsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetIndicatorToInvestorMetricsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetIndicatorToInvestorMetricsQuery_, AdminGetIndicatorToInvestorMetricsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetIndicatorToInvestorMetricsQuery_, AdminGetIndicatorToInvestorMetricsQueryVariables_>(AdminGetIndicatorToInvestorMetricsDocument_, options);
      }
export function useAdminGetIndicatorToInvestorMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetIndicatorToInvestorMetricsQuery_, AdminGetIndicatorToInvestorMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetIndicatorToInvestorMetricsQuery_, AdminGetIndicatorToInvestorMetricsQueryVariables_>(AdminGetIndicatorToInvestorMetricsDocument_, options);
        }
export function useAdminGetIndicatorToInvestorMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetIndicatorToInvestorMetricsQuery_, AdminGetIndicatorToInvestorMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetIndicatorToInvestorMetricsQuery_, AdminGetIndicatorToInvestorMetricsQueryVariables_>(AdminGetIndicatorToInvestorMetricsDocument_, options);
        }
export type AdminGetIndicatorToInvestorMetricsQueryHookResult = ReturnType<typeof useAdminGetIndicatorToInvestorMetricsQuery>;
export type AdminGetIndicatorToInvestorMetricsLazyQuery_HookResult = ReturnType<typeof useAdminGetIndicatorToInvestorMetricsLazyQuery_>;
export type AdminGetIndicatorToInvestorMetricsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetIndicatorToInvestorMetricsSuspenseQuery_>;
export type AdminGetIndicatorToInvestorMetricsQueryResult_ = Apollo.QueryResult<AdminGetIndicatorToInvestorMetricsQuery_, AdminGetIndicatorToInvestorMetricsQueryVariables_>;
export function refetchAdminGetIndicatorToInvestorMetricsQuery_(variables?: AdminGetIndicatorToInvestorMetricsQueryVariables_) {
      return { query: AdminGetIndicatorToInvestorMetricsDocument_, variables: variables }
    }
export const AdminGetInvestorToInvesteeMetricsDocument_ = gql`
    query AdminGetInvestorToInvesteeMetrics($limit: Int, $offset: Int, $order_by: [InvestorToInvesteeMetric_order_by!], $where: InvestorToInvesteeMetric_bool_exp) {
  InvestorToInvesteeMetric(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    investeeMetricReference
    investorMetricReference
  }
  InvestorToInvesteeMetric_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetInvestorToInvesteeMetricsQuery__
 *
 * To run a query within a React component, call `useAdminGetInvestorToInvesteeMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetInvestorToInvesteeMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetInvestorToInvesteeMetricsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetInvestorToInvesteeMetricsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetInvestorToInvesteeMetricsQuery_, AdminGetInvestorToInvesteeMetricsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetInvestorToInvesteeMetricsQuery_, AdminGetInvestorToInvesteeMetricsQueryVariables_>(AdminGetInvestorToInvesteeMetricsDocument_, options);
      }
export function useAdminGetInvestorToInvesteeMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetInvestorToInvesteeMetricsQuery_, AdminGetInvestorToInvesteeMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetInvestorToInvesteeMetricsQuery_, AdminGetInvestorToInvesteeMetricsQueryVariables_>(AdminGetInvestorToInvesteeMetricsDocument_, options);
        }
export function useAdminGetInvestorToInvesteeMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetInvestorToInvesteeMetricsQuery_, AdminGetInvestorToInvesteeMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetInvestorToInvesteeMetricsQuery_, AdminGetInvestorToInvesteeMetricsQueryVariables_>(AdminGetInvestorToInvesteeMetricsDocument_, options);
        }
export type AdminGetInvestorToInvesteeMetricsQueryHookResult = ReturnType<typeof useAdminGetInvestorToInvesteeMetricsQuery>;
export type AdminGetInvestorToInvesteeMetricsLazyQuery_HookResult = ReturnType<typeof useAdminGetInvestorToInvesteeMetricsLazyQuery_>;
export type AdminGetInvestorToInvesteeMetricsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetInvestorToInvesteeMetricsSuspenseQuery_>;
export type AdminGetInvestorToInvesteeMetricsQueryResult_ = Apollo.QueryResult<AdminGetInvestorToInvesteeMetricsQuery_, AdminGetInvestorToInvesteeMetricsQueryVariables_>;
export function refetchAdminGetInvestorToInvesteeMetricsQuery_(variables?: AdminGetInvestorToInvesteeMetricsQueryVariables_) {
      return { query: AdminGetInvestorToInvesteeMetricsDocument_, variables: variables }
    }
export const AdminGetEsrsCategoriesDocument_ = gql`
    query AdminGetEsrsCategories($limit: Int, $offset: Int, $order_by: [EsrsCategory_order_by!], $where: EsrsCategory_bool_exp) {
  EsrsCategory(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    title
    reference
  }
  EsrsCategory_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetEsrsCategoriesQuery__
 *
 * To run a query within a React component, call `useAdminGetEsrsCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetEsrsCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetEsrsCategoriesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetEsrsCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetEsrsCategoriesQuery_, AdminGetEsrsCategoriesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetEsrsCategoriesQuery_, AdminGetEsrsCategoriesQueryVariables_>(AdminGetEsrsCategoriesDocument_, options);
      }
export function useAdminGetEsrsCategoriesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetEsrsCategoriesQuery_, AdminGetEsrsCategoriesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetEsrsCategoriesQuery_, AdminGetEsrsCategoriesQueryVariables_>(AdminGetEsrsCategoriesDocument_, options);
        }
export function useAdminGetEsrsCategoriesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetEsrsCategoriesQuery_, AdminGetEsrsCategoriesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetEsrsCategoriesQuery_, AdminGetEsrsCategoriesQueryVariables_>(AdminGetEsrsCategoriesDocument_, options);
        }
export type AdminGetEsrsCategoriesQueryHookResult = ReturnType<typeof useAdminGetEsrsCategoriesQuery>;
export type AdminGetEsrsCategoriesLazyQuery_HookResult = ReturnType<typeof useAdminGetEsrsCategoriesLazyQuery_>;
export type AdminGetEsrsCategoriesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetEsrsCategoriesSuspenseQuery_>;
export type AdminGetEsrsCategoriesQueryResult_ = Apollo.QueryResult<AdminGetEsrsCategoriesQuery_, AdminGetEsrsCategoriesQueryVariables_>;
export function refetchAdminGetEsrsCategoriesQuery_(variables?: AdminGetEsrsCategoriesQueryVariables_) {
      return { query: AdminGetEsrsCategoriesDocument_, variables: variables }
    }
export const AdminGetEsrsAssessmentsDocument_ = gql`
    query AdminGetEsrsAssessments($limit: Int, $offset: Int, $order_by: [EsrsAssessment_order_by!], $where: EsrsAssessment_bool_exp) {
  EsrsAssessment(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    reportingYear
    companyId
    subsidiaryAssessments {
      id
      reportingYear
      company {
        name
      }
    }
  }
  EsrsAssessment_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetEsrsAssessmentsQuery__
 *
 * To run a query within a React component, call `useAdminGetEsrsAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetEsrsAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetEsrsAssessmentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetEsrsAssessmentsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetEsrsAssessmentsQuery_, AdminGetEsrsAssessmentsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetEsrsAssessmentsQuery_, AdminGetEsrsAssessmentsQueryVariables_>(AdminGetEsrsAssessmentsDocument_, options);
      }
export function useAdminGetEsrsAssessmentsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetEsrsAssessmentsQuery_, AdminGetEsrsAssessmentsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetEsrsAssessmentsQuery_, AdminGetEsrsAssessmentsQueryVariables_>(AdminGetEsrsAssessmentsDocument_, options);
        }
export function useAdminGetEsrsAssessmentsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetEsrsAssessmentsQuery_, AdminGetEsrsAssessmentsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetEsrsAssessmentsQuery_, AdminGetEsrsAssessmentsQueryVariables_>(AdminGetEsrsAssessmentsDocument_, options);
        }
export type AdminGetEsrsAssessmentsQueryHookResult = ReturnType<typeof useAdminGetEsrsAssessmentsQuery>;
export type AdminGetEsrsAssessmentsLazyQuery_HookResult = ReturnType<typeof useAdminGetEsrsAssessmentsLazyQuery_>;
export type AdminGetEsrsAssessmentsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetEsrsAssessmentsSuspenseQuery_>;
export type AdminGetEsrsAssessmentsQueryResult_ = Apollo.QueryResult<AdminGetEsrsAssessmentsQuery_, AdminGetEsrsAssessmentsQueryVariables_>;
export function refetchAdminGetEsrsAssessmentsQuery_(variables?: AdminGetEsrsAssessmentsQueryVariables_) {
      return { query: AdminGetEsrsAssessmentsDocument_, variables: variables }
    }
export const AdminGetEsrsStandardsDocument_ = gql`
    query AdminGetEsrsStandards($limit: Int, $offset: Int, $order_by: [EsrsStandard_order_by!], $where: EsrsStandard_bool_exp) {
  EsrsStandard(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    title
    reference
    description
    isTopical
    categoryRef
    formattedPolicyChecklist
    aiPolicyChecklist
    frameworkRef
    order
  }
  EsrsStandard_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetEsrsStandardsQuery__
 *
 * To run a query within a React component, call `useAdminGetEsrsStandardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetEsrsStandardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetEsrsStandardsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetEsrsStandardsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetEsrsStandardsQuery_, AdminGetEsrsStandardsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetEsrsStandardsQuery_, AdminGetEsrsStandardsQueryVariables_>(AdminGetEsrsStandardsDocument_, options);
      }
export function useAdminGetEsrsStandardsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetEsrsStandardsQuery_, AdminGetEsrsStandardsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetEsrsStandardsQuery_, AdminGetEsrsStandardsQueryVariables_>(AdminGetEsrsStandardsDocument_, options);
        }
export function useAdminGetEsrsStandardsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetEsrsStandardsQuery_, AdminGetEsrsStandardsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetEsrsStandardsQuery_, AdminGetEsrsStandardsQueryVariables_>(AdminGetEsrsStandardsDocument_, options);
        }
export type AdminGetEsrsStandardsQueryHookResult = ReturnType<typeof useAdminGetEsrsStandardsQuery>;
export type AdminGetEsrsStandardsLazyQuery_HookResult = ReturnType<typeof useAdminGetEsrsStandardsLazyQuery_>;
export type AdminGetEsrsStandardsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetEsrsStandardsSuspenseQuery_>;
export type AdminGetEsrsStandardsQueryResult_ = Apollo.QueryResult<AdminGetEsrsStandardsQuery_, AdminGetEsrsStandardsQueryVariables_>;
export function refetchAdminGetEsrsStandardsQuery_(variables?: AdminGetEsrsStandardsQueryVariables_) {
      return { query: AdminGetEsrsStandardsDocument_, variables: variables }
    }
export const AdminGetEsrsStandardAdditionalTypesDocument_ = gql`
    query AdminGetEsrsStandardAdditionalTypes($limit: Int, $offset: Int, $order_by: [EsrsStandardAdditionalType_order_by!], $where: EsrsStandardAdditionalType_bool_exp) {
  EsrsStandardAdditionalType(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    standardRef
    additionalTypeRef
  }
  EsrsStandardAdditionalType_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetEsrsStandardAdditionalTypesQuery__
 *
 * To run a query within a React component, call `useAdminGetEsrsStandardAdditionalTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetEsrsStandardAdditionalTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetEsrsStandardAdditionalTypesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetEsrsStandardAdditionalTypesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetEsrsStandardAdditionalTypesQuery_, AdminGetEsrsStandardAdditionalTypesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetEsrsStandardAdditionalTypesQuery_, AdminGetEsrsStandardAdditionalTypesQueryVariables_>(AdminGetEsrsStandardAdditionalTypesDocument_, options);
      }
export function useAdminGetEsrsStandardAdditionalTypesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetEsrsStandardAdditionalTypesQuery_, AdminGetEsrsStandardAdditionalTypesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetEsrsStandardAdditionalTypesQuery_, AdminGetEsrsStandardAdditionalTypesQueryVariables_>(AdminGetEsrsStandardAdditionalTypesDocument_, options);
        }
export function useAdminGetEsrsStandardAdditionalTypesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetEsrsStandardAdditionalTypesQuery_, AdminGetEsrsStandardAdditionalTypesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetEsrsStandardAdditionalTypesQuery_, AdminGetEsrsStandardAdditionalTypesQueryVariables_>(AdminGetEsrsStandardAdditionalTypesDocument_, options);
        }
export type AdminGetEsrsStandardAdditionalTypesQueryHookResult = ReturnType<typeof useAdminGetEsrsStandardAdditionalTypesQuery>;
export type AdminGetEsrsStandardAdditionalTypesLazyQuery_HookResult = ReturnType<typeof useAdminGetEsrsStandardAdditionalTypesLazyQuery_>;
export type AdminGetEsrsStandardAdditionalTypesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetEsrsStandardAdditionalTypesSuspenseQuery_>;
export type AdminGetEsrsStandardAdditionalTypesQueryResult_ = Apollo.QueryResult<AdminGetEsrsStandardAdditionalTypesQuery_, AdminGetEsrsStandardAdditionalTypesQueryVariables_>;
export function refetchAdminGetEsrsStandardAdditionalTypesQuery_(variables?: AdminGetEsrsStandardAdditionalTypesQueryVariables_) {
      return { query: AdminGetEsrsStandardAdditionalTypesDocument_, variables: variables }
    }
export const AdminGetDisclosureRequirementGroupsDocument_ = gql`
    query AdminGetDisclosureRequirementGroups($limit: Int, $offset: Int, $order_by: [DisclosureRequirementGroup_order_by!], $where: DisclosureRequirementGroup_bool_exp) {
  DisclosureRequirementGroup(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    title
    reference
    standardRef
    order
  }
  DisclosureRequirementGroup_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetDisclosureRequirementGroupsQuery__
 *
 * To run a query within a React component, call `useAdminGetDisclosureRequirementGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetDisclosureRequirementGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetDisclosureRequirementGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetDisclosureRequirementGroupsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetDisclosureRequirementGroupsQuery_, AdminGetDisclosureRequirementGroupsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetDisclosureRequirementGroupsQuery_, AdminGetDisclosureRequirementGroupsQueryVariables_>(AdminGetDisclosureRequirementGroupsDocument_, options);
      }
export function useAdminGetDisclosureRequirementGroupsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetDisclosureRequirementGroupsQuery_, AdminGetDisclosureRequirementGroupsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetDisclosureRequirementGroupsQuery_, AdminGetDisclosureRequirementGroupsQueryVariables_>(AdminGetDisclosureRequirementGroupsDocument_, options);
        }
export function useAdminGetDisclosureRequirementGroupsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetDisclosureRequirementGroupsQuery_, AdminGetDisclosureRequirementGroupsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetDisclosureRequirementGroupsQuery_, AdminGetDisclosureRequirementGroupsQueryVariables_>(AdminGetDisclosureRequirementGroupsDocument_, options);
        }
export type AdminGetDisclosureRequirementGroupsQueryHookResult = ReturnType<typeof useAdminGetDisclosureRequirementGroupsQuery>;
export type AdminGetDisclosureRequirementGroupsLazyQuery_HookResult = ReturnType<typeof useAdminGetDisclosureRequirementGroupsLazyQuery_>;
export type AdminGetDisclosureRequirementGroupsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetDisclosureRequirementGroupsSuspenseQuery_>;
export type AdminGetDisclosureRequirementGroupsQueryResult_ = Apollo.QueryResult<AdminGetDisclosureRequirementGroupsQuery_, AdminGetDisclosureRequirementGroupsQueryVariables_>;
export function refetchAdminGetDisclosureRequirementGroupsQuery_(variables?: AdminGetDisclosureRequirementGroupsQueryVariables_) {
      return { query: AdminGetDisclosureRequirementGroupsDocument_, variables: variables }
    }
export const AdminGetDisclosureRequirementsDocument_ = gql`
    query AdminGetDisclosureRequirements($limit: Int, $offset: Int, $order_by: [DisclosureRequirement_order_by!], $where: DisclosureRequirement_bool_exp) {
  DisclosureRequirement(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    title
    shortTitle
    reference
    groupRef
    type
    order
    description
    isMandatory
  }
  DisclosureRequirement_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetDisclosureRequirementsQuery__
 *
 * To run a query within a React component, call `useAdminGetDisclosureRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetDisclosureRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetDisclosureRequirementsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetDisclosureRequirementsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetDisclosureRequirementsQuery_, AdminGetDisclosureRequirementsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetDisclosureRequirementsQuery_, AdminGetDisclosureRequirementsQueryVariables_>(AdminGetDisclosureRequirementsDocument_, options);
      }
export function useAdminGetDisclosureRequirementsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetDisclosureRequirementsQuery_, AdminGetDisclosureRequirementsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetDisclosureRequirementsQuery_, AdminGetDisclosureRequirementsQueryVariables_>(AdminGetDisclosureRequirementsDocument_, options);
        }
export function useAdminGetDisclosureRequirementsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetDisclosureRequirementsQuery_, AdminGetDisclosureRequirementsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetDisclosureRequirementsQuery_, AdminGetDisclosureRequirementsQueryVariables_>(AdminGetDisclosureRequirementsDocument_, options);
        }
export type AdminGetDisclosureRequirementsQueryHookResult = ReturnType<typeof useAdminGetDisclosureRequirementsQuery>;
export type AdminGetDisclosureRequirementsLazyQuery_HookResult = ReturnType<typeof useAdminGetDisclosureRequirementsLazyQuery_>;
export type AdminGetDisclosureRequirementsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetDisclosureRequirementsSuspenseQuery_>;
export type AdminGetDisclosureRequirementsQueryResult_ = Apollo.QueryResult<AdminGetDisclosureRequirementsQuery_, AdminGetDisclosureRequirementsQueryVariables_>;
export function refetchAdminGetDisclosureRequirementsQuery_(variables?: AdminGetDisclosureRequirementsQueryVariables_) {
      return { query: AdminGetDisclosureRequirementsDocument_, variables: variables }
    }
export const AdminGetDisclosureRequirementAdditionalTypesDocument_ = gql`
    query AdminGetDisclosureRequirementAdditionalTypes($limit: Int, $offset: Int, $order_by: [DisclosureRequirementAdditionalType_order_by!], $where: DisclosureRequirementAdditionalType_bool_exp) {
  DisclosureRequirementAdditionalType(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    disclosureRequirementRef
    additionalTypeRef
  }
  DisclosureRequirementAdditionalType_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetDisclosureRequirementAdditionalTypesQuery__
 *
 * To run a query within a React component, call `useAdminGetDisclosureRequirementAdditionalTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetDisclosureRequirementAdditionalTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetDisclosureRequirementAdditionalTypesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetDisclosureRequirementAdditionalTypesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetDisclosureRequirementAdditionalTypesQuery_, AdminGetDisclosureRequirementAdditionalTypesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetDisclosureRequirementAdditionalTypesQuery_, AdminGetDisclosureRequirementAdditionalTypesQueryVariables_>(AdminGetDisclosureRequirementAdditionalTypesDocument_, options);
      }
export function useAdminGetDisclosureRequirementAdditionalTypesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetDisclosureRequirementAdditionalTypesQuery_, AdminGetDisclosureRequirementAdditionalTypesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetDisclosureRequirementAdditionalTypesQuery_, AdminGetDisclosureRequirementAdditionalTypesQueryVariables_>(AdminGetDisclosureRequirementAdditionalTypesDocument_, options);
        }
export function useAdminGetDisclosureRequirementAdditionalTypesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetDisclosureRequirementAdditionalTypesQuery_, AdminGetDisclosureRequirementAdditionalTypesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetDisclosureRequirementAdditionalTypesQuery_, AdminGetDisclosureRequirementAdditionalTypesQueryVariables_>(AdminGetDisclosureRequirementAdditionalTypesDocument_, options);
        }
export type AdminGetDisclosureRequirementAdditionalTypesQueryHookResult = ReturnType<typeof useAdminGetDisclosureRequirementAdditionalTypesQuery>;
export type AdminGetDisclosureRequirementAdditionalTypesLazyQuery_HookResult = ReturnType<typeof useAdminGetDisclosureRequirementAdditionalTypesLazyQuery_>;
export type AdminGetDisclosureRequirementAdditionalTypesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetDisclosureRequirementAdditionalTypesSuspenseQuery_>;
export type AdminGetDisclosureRequirementAdditionalTypesQueryResult_ = Apollo.QueryResult<AdminGetDisclosureRequirementAdditionalTypesQuery_, AdminGetDisclosureRequirementAdditionalTypesQueryVariables_>;
export function refetchAdminGetDisclosureRequirementAdditionalTypesQuery_(variables?: AdminGetDisclosureRequirementAdditionalTypesQueryVariables_) {
      return { query: AdminGetDisclosureRequirementAdditionalTypesDocument_, variables: variables }
    }
export const AdminGetEsrsMetricsDocument_ = gql`
    query AdminGetEsrsMetrics($limit: Int, $offset: Int, $order_by: [EsrsMetric_order_by!], $where: EsrsMetric_bool_exp) {
  EsrsMetric(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    title
    shortTitle
    reference
    description
    calculation
    disclosureRequirementRef
    metricType
    unitOfMeasurement
    isAssessable
    firstLevel
    secondLevel
    order
    isGroup
    showAsPercentage
    isAR
    globalOrder
    hasAssociation
    canBeUsedForTarget
    unlockCondition
    choiceSetRef
    showPercentageWithTag
    notAggregatable
    abbreviation
    dr: requirement {
      group {
        standard {
          frameworkRef
        }
      }
    }
  }
  EsrsMetric_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetEsrsMetricsQuery__
 *
 * To run a query within a React component, call `useAdminGetEsrsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetEsrsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetEsrsMetricsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetEsrsMetricsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetEsrsMetricsQuery_, AdminGetEsrsMetricsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetEsrsMetricsQuery_, AdminGetEsrsMetricsQueryVariables_>(AdminGetEsrsMetricsDocument_, options);
      }
export function useAdminGetEsrsMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetEsrsMetricsQuery_, AdminGetEsrsMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetEsrsMetricsQuery_, AdminGetEsrsMetricsQueryVariables_>(AdminGetEsrsMetricsDocument_, options);
        }
export function useAdminGetEsrsMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetEsrsMetricsQuery_, AdminGetEsrsMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetEsrsMetricsQuery_, AdminGetEsrsMetricsQueryVariables_>(AdminGetEsrsMetricsDocument_, options);
        }
export type AdminGetEsrsMetricsQueryHookResult = ReturnType<typeof useAdminGetEsrsMetricsQuery>;
export type AdminGetEsrsMetricsLazyQuery_HookResult = ReturnType<typeof useAdminGetEsrsMetricsLazyQuery_>;
export type AdminGetEsrsMetricsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetEsrsMetricsSuspenseQuery_>;
export type AdminGetEsrsMetricsQueryResult_ = Apollo.QueryResult<AdminGetEsrsMetricsQuery_, AdminGetEsrsMetricsQueryVariables_>;
export function refetchAdminGetEsrsMetricsQuery_(variables?: AdminGetEsrsMetricsQueryVariables_) {
      return { query: AdminGetEsrsMetricsDocument_, variables: variables }
    }
export const AdminGetMetricDependenciesDocument_ = gql`
    query AdminGetMetricDependencies($limit: Int, $offset: Int, $order_by: [MetricDependency_order_by!], $where: MetricDependency_bool_exp) {
  MetricDependency(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    parentMetricRef
    childMetricRef
  }
  MetricDependency_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetMetricDependenciesQuery__
 *
 * To run a query within a React component, call `useAdminGetMetricDependenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMetricDependenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMetricDependenciesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetMetricDependenciesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetMetricDependenciesQuery_, AdminGetMetricDependenciesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMetricDependenciesQuery_, AdminGetMetricDependenciesQueryVariables_>(AdminGetMetricDependenciesDocument_, options);
      }
export function useAdminGetMetricDependenciesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMetricDependenciesQuery_, AdminGetMetricDependenciesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMetricDependenciesQuery_, AdminGetMetricDependenciesQueryVariables_>(AdminGetMetricDependenciesDocument_, options);
        }
export function useAdminGetMetricDependenciesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMetricDependenciesQuery_, AdminGetMetricDependenciesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMetricDependenciesQuery_, AdminGetMetricDependenciesQueryVariables_>(AdminGetMetricDependenciesDocument_, options);
        }
export type AdminGetMetricDependenciesQueryHookResult = ReturnType<typeof useAdminGetMetricDependenciesQuery>;
export type AdminGetMetricDependenciesLazyQuery_HookResult = ReturnType<typeof useAdminGetMetricDependenciesLazyQuery_>;
export type AdminGetMetricDependenciesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetMetricDependenciesSuspenseQuery_>;
export type AdminGetMetricDependenciesQueryResult_ = Apollo.QueryResult<AdminGetMetricDependenciesQuery_, AdminGetMetricDependenciesQueryVariables_>;
export function refetchAdminGetMetricDependenciesQuery_(variables?: AdminGetMetricDependenciesQueryVariables_) {
      return { query: AdminGetMetricDependenciesDocument_, variables: variables }
    }
export const AdminGetMetricTagsDocument_ = gql`
    query AdminGetMetricTags($limit: Int, $offset: Int, $order_by: [MetricTag_order_by!], $where: MetricTag_bool_exp) {
  MetricTag(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    metricRef
    type
    isOptional
  }
  MetricTag_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetMetricTagsQuery__
 *
 * To run a query within a React component, call `useAdminGetMetricTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMetricTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMetricTagsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetMetricTagsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetMetricTagsQuery_, AdminGetMetricTagsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMetricTagsQuery_, AdminGetMetricTagsQueryVariables_>(AdminGetMetricTagsDocument_, options);
      }
export function useAdminGetMetricTagsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMetricTagsQuery_, AdminGetMetricTagsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMetricTagsQuery_, AdminGetMetricTagsQueryVariables_>(AdminGetMetricTagsDocument_, options);
        }
export function useAdminGetMetricTagsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMetricTagsQuery_, AdminGetMetricTagsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMetricTagsQuery_, AdminGetMetricTagsQueryVariables_>(AdminGetMetricTagsDocument_, options);
        }
export type AdminGetMetricTagsQueryHookResult = ReturnType<typeof useAdminGetMetricTagsQuery>;
export type AdminGetMetricTagsLazyQuery_HookResult = ReturnType<typeof useAdminGetMetricTagsLazyQuery_>;
export type AdminGetMetricTagsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetMetricTagsSuspenseQuery_>;
export type AdminGetMetricTagsQueryResult_ = Apollo.QueryResult<AdminGetMetricTagsQuery_, AdminGetMetricTagsQueryVariables_>;
export function refetchAdminGetMetricTagsQuery_(variables?: AdminGetMetricTagsQueryVariables_) {
      return { query: AdminGetMetricTagsDocument_, variables: variables }
    }
export const AdminGetEsrsMetricAdditionalTypesDocument_ = gql`
    query AdminGetEsrsMetricAdditionalTypes($limit: Int, $offset: Int, $order_by: [EsrsMetricAdditionalType_order_by!], $where: EsrsMetricAdditionalType_bool_exp) {
  EsrsMetricAdditionalType(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    metricRef
    additionalTypeRef
  }
  EsrsMetricAdditionalType_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetEsrsMetricAdditionalTypesQuery__
 *
 * To run a query within a React component, call `useAdminGetEsrsMetricAdditionalTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetEsrsMetricAdditionalTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetEsrsMetricAdditionalTypesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetEsrsMetricAdditionalTypesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetEsrsMetricAdditionalTypesQuery_, AdminGetEsrsMetricAdditionalTypesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetEsrsMetricAdditionalTypesQuery_, AdminGetEsrsMetricAdditionalTypesQueryVariables_>(AdminGetEsrsMetricAdditionalTypesDocument_, options);
      }
export function useAdminGetEsrsMetricAdditionalTypesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetEsrsMetricAdditionalTypesQuery_, AdminGetEsrsMetricAdditionalTypesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetEsrsMetricAdditionalTypesQuery_, AdminGetEsrsMetricAdditionalTypesQueryVariables_>(AdminGetEsrsMetricAdditionalTypesDocument_, options);
        }
export function useAdminGetEsrsMetricAdditionalTypesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetEsrsMetricAdditionalTypesQuery_, AdminGetEsrsMetricAdditionalTypesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetEsrsMetricAdditionalTypesQuery_, AdminGetEsrsMetricAdditionalTypesQueryVariables_>(AdminGetEsrsMetricAdditionalTypesDocument_, options);
        }
export type AdminGetEsrsMetricAdditionalTypesQueryHookResult = ReturnType<typeof useAdminGetEsrsMetricAdditionalTypesQuery>;
export type AdminGetEsrsMetricAdditionalTypesLazyQuery_HookResult = ReturnType<typeof useAdminGetEsrsMetricAdditionalTypesLazyQuery_>;
export type AdminGetEsrsMetricAdditionalTypesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetEsrsMetricAdditionalTypesSuspenseQuery_>;
export type AdminGetEsrsMetricAdditionalTypesQueryResult_ = Apollo.QueryResult<AdminGetEsrsMetricAdditionalTypesQuery_, AdminGetEsrsMetricAdditionalTypesQueryVariables_>;
export function refetchAdminGetEsrsMetricAdditionalTypesQuery_(variables?: AdminGetEsrsMetricAdditionalTypesQueryVariables_) {
      return { query: AdminGetEsrsMetricAdditionalTypesDocument_, variables: variables }
    }
export const AdminGetTagTypesDocument_ = gql`
    query AdminGetTagTypes($limit: Int, $offset: Int, $order_by: [TagType_order_by!], $where: TagType_bool_exp) {
  TagType(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    type
    alwaysAll
  }
  TagType_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetTagTypesQuery__
 *
 * To run a query within a React component, call `useAdminGetTagTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetTagTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetTagTypesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetTagTypesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetTagTypesQuery_, AdminGetTagTypesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetTagTypesQuery_, AdminGetTagTypesQueryVariables_>(AdminGetTagTypesDocument_, options);
      }
export function useAdminGetTagTypesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetTagTypesQuery_, AdminGetTagTypesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetTagTypesQuery_, AdminGetTagTypesQueryVariables_>(AdminGetTagTypesDocument_, options);
        }
export function useAdminGetTagTypesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetTagTypesQuery_, AdminGetTagTypesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetTagTypesQuery_, AdminGetTagTypesQueryVariables_>(AdminGetTagTypesDocument_, options);
        }
export type AdminGetTagTypesQueryHookResult = ReturnType<typeof useAdminGetTagTypesQuery>;
export type AdminGetTagTypesLazyQuery_HookResult = ReturnType<typeof useAdminGetTagTypesLazyQuery_>;
export type AdminGetTagTypesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetTagTypesSuspenseQuery_>;
export type AdminGetTagTypesQueryResult_ = Apollo.QueryResult<AdminGetTagTypesQuery_, AdminGetTagTypesQueryVariables_>;
export function refetchAdminGetTagTypesQuery_(variables?: AdminGetTagTypesQueryVariables_) {
      return { query: AdminGetTagTypesDocument_, variables: variables }
    }
export const AdminGetTagValuesDocument_ = gql`
    query AdminGetTagValues($limit: Int, $offset: Int, $order_by: [TagValue_order_by!], $where: TagValue_bool_exp) {
  TagValue(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    value
    type
    order
  }
  TagValue_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetTagValuesQuery__
 *
 * To run a query within a React component, call `useAdminGetTagValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetTagValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetTagValuesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetTagValuesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetTagValuesQuery_, AdminGetTagValuesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetTagValuesQuery_, AdminGetTagValuesQueryVariables_>(AdminGetTagValuesDocument_, options);
      }
export function useAdminGetTagValuesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetTagValuesQuery_, AdminGetTagValuesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetTagValuesQuery_, AdminGetTagValuesQueryVariables_>(AdminGetTagValuesDocument_, options);
        }
export function useAdminGetTagValuesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetTagValuesQuery_, AdminGetTagValuesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetTagValuesQuery_, AdminGetTagValuesQueryVariables_>(AdminGetTagValuesDocument_, options);
        }
export type AdminGetTagValuesQueryHookResult = ReturnType<typeof useAdminGetTagValuesQuery>;
export type AdminGetTagValuesLazyQuery_HookResult = ReturnType<typeof useAdminGetTagValuesLazyQuery_>;
export type AdminGetTagValuesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetTagValuesSuspenseQuery_>;
export type AdminGetTagValuesQueryResult_ = Apollo.QueryResult<AdminGetTagValuesQuery_, AdminGetTagValuesQueryVariables_>;
export function refetchAdminGetTagValuesQuery_(variables?: AdminGetTagValuesQueryVariables_) {
      return { query: AdminGetTagValuesDocument_, variables: variables }
    }
export const AdminGetAdditionalTypesDocument_ = gql`
    query AdminGetAdditionalTypes($limit: Int, $offset: Int, $order_by: [AdditionalType_order_by!], $where: AdditionalType_bool_exp) {
  AdditionalType(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    reference
    title
    description
    learnMore
  }
  AdditionalType_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetAdditionalTypesQuery__
 *
 * To run a query within a React component, call `useAdminGetAdditionalTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetAdditionalTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetAdditionalTypesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetAdditionalTypesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetAdditionalTypesQuery_, AdminGetAdditionalTypesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetAdditionalTypesQuery_, AdminGetAdditionalTypesQueryVariables_>(AdminGetAdditionalTypesDocument_, options);
      }
export function useAdminGetAdditionalTypesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetAdditionalTypesQuery_, AdminGetAdditionalTypesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetAdditionalTypesQuery_, AdminGetAdditionalTypesQueryVariables_>(AdminGetAdditionalTypesDocument_, options);
        }
export function useAdminGetAdditionalTypesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetAdditionalTypesQuery_, AdminGetAdditionalTypesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetAdditionalTypesQuery_, AdminGetAdditionalTypesQueryVariables_>(AdminGetAdditionalTypesDocument_, options);
        }
export type AdminGetAdditionalTypesQueryHookResult = ReturnType<typeof useAdminGetAdditionalTypesQuery>;
export type AdminGetAdditionalTypesLazyQuery_HookResult = ReturnType<typeof useAdminGetAdditionalTypesLazyQuery_>;
export type AdminGetAdditionalTypesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetAdditionalTypesSuspenseQuery_>;
export type AdminGetAdditionalTypesQueryResult_ = Apollo.QueryResult<AdminGetAdditionalTypesQuery_, AdminGetAdditionalTypesQueryVariables_>;
export function refetchAdminGetAdditionalTypesQuery_(variables?: AdminGetAdditionalTypesQueryVariables_) {
      return { query: AdminGetAdditionalTypesDocument_, variables: variables }
    }
export const AdminGetTargetQuestionsDocument_ = gql`
    query AdminGetTargetQuestions($limit: Int, $offset: Int, $order_by: [TargetQuestion_order_by!], $where: TargetQuestion_bool_exp) {
  TargetQuestion(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    title
    reference
    standardRef
    unit
    questionType
    order
    description
    groupRef
    globalOrder
    firstLevel
    secondLevel
    isAR
    choiceSetRef
  }
  TargetQuestion_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetTargetQuestionsQuery__
 *
 * To run a query within a React component, call `useAdminGetTargetQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetTargetQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetTargetQuestionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetTargetQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetTargetQuestionsQuery_, AdminGetTargetQuestionsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetTargetQuestionsQuery_, AdminGetTargetQuestionsQueryVariables_>(AdminGetTargetQuestionsDocument_, options);
      }
export function useAdminGetTargetQuestionsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetTargetQuestionsQuery_, AdminGetTargetQuestionsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetTargetQuestionsQuery_, AdminGetTargetQuestionsQueryVariables_>(AdminGetTargetQuestionsDocument_, options);
        }
export function useAdminGetTargetQuestionsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetTargetQuestionsQuery_, AdminGetTargetQuestionsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetTargetQuestionsQuery_, AdminGetTargetQuestionsQueryVariables_>(AdminGetTargetQuestionsDocument_, options);
        }
export type AdminGetTargetQuestionsQueryHookResult = ReturnType<typeof useAdminGetTargetQuestionsQuery>;
export type AdminGetTargetQuestionsLazyQuery_HookResult = ReturnType<typeof useAdminGetTargetQuestionsLazyQuery_>;
export type AdminGetTargetQuestionsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetTargetQuestionsSuspenseQuery_>;
export type AdminGetTargetQuestionsQueryResult_ = Apollo.QueryResult<AdminGetTargetQuestionsQuery_, AdminGetTargetQuestionsQueryVariables_>;
export function refetchAdminGetTargetQuestionsQuery_(variables?: AdminGetTargetQuestionsQueryVariables_) {
      return { query: AdminGetTargetQuestionsDocument_, variables: variables }
    }
export const AdminGetTargetQuestionGroupsDocument_ = gql`
    query AdminGetTargetQuestionGroups($limit: Int, $offset: Int, $order_by: [TargetQuestionGroup_order_by!], $where: TargetQuestionGroup_bool_exp) {
  TargetQuestionGroup(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    title
    reference
  }
  TargetQuestionGroup_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetTargetQuestionGroupsQuery__
 *
 * To run a query within a React component, call `useAdminGetTargetQuestionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetTargetQuestionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetTargetQuestionGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetTargetQuestionGroupsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetTargetQuestionGroupsQuery_, AdminGetTargetQuestionGroupsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetTargetQuestionGroupsQuery_, AdminGetTargetQuestionGroupsQueryVariables_>(AdminGetTargetQuestionGroupsDocument_, options);
      }
export function useAdminGetTargetQuestionGroupsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetTargetQuestionGroupsQuery_, AdminGetTargetQuestionGroupsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetTargetQuestionGroupsQuery_, AdminGetTargetQuestionGroupsQueryVariables_>(AdminGetTargetQuestionGroupsDocument_, options);
        }
export function useAdminGetTargetQuestionGroupsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetTargetQuestionGroupsQuery_, AdminGetTargetQuestionGroupsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetTargetQuestionGroupsQuery_, AdminGetTargetQuestionGroupsQueryVariables_>(AdminGetTargetQuestionGroupsDocument_, options);
        }
export type AdminGetTargetQuestionGroupsQueryHookResult = ReturnType<typeof useAdminGetTargetQuestionGroupsQuery>;
export type AdminGetTargetQuestionGroupsLazyQuery_HookResult = ReturnType<typeof useAdminGetTargetQuestionGroupsLazyQuery_>;
export type AdminGetTargetQuestionGroupsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetTargetQuestionGroupsSuspenseQuery_>;
export type AdminGetTargetQuestionGroupsQueryResult_ = Apollo.QueryResult<AdminGetTargetQuestionGroupsQuery_, AdminGetTargetQuestionGroupsQueryVariables_>;
export function refetchAdminGetTargetQuestionGroupsQuery_(variables?: AdminGetTargetQuestionGroupsQueryVariables_) {
      return { query: AdminGetTargetQuestionGroupsDocument_, variables: variables }
    }
export const AdminGetCompanyAssessmentDocument_ = gql`
    query AdminGetCompanyAssessment($id: uuid!) {
  CompanyAssessment_by_pk(id: $id) {
    id
    createdAt
    updatedAt
    aggregateId
    companyId
    isLocked
  }
}
    `;

/**
 * __useAdminGetCompanyAssessmentQuery__
 *
 * To run a query within a React component, call `useAdminGetCompanyAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetCompanyAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetCompanyAssessmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetCompanyAssessmentQuery(baseOptions: Apollo.QueryHookOptions<AdminGetCompanyAssessmentQuery_, AdminGetCompanyAssessmentQueryVariables_> & ({ variables: AdminGetCompanyAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetCompanyAssessmentQuery_, AdminGetCompanyAssessmentQueryVariables_>(AdminGetCompanyAssessmentDocument_, options);
      }
export function useAdminGetCompanyAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetCompanyAssessmentQuery_, AdminGetCompanyAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetCompanyAssessmentQuery_, AdminGetCompanyAssessmentQueryVariables_>(AdminGetCompanyAssessmentDocument_, options);
        }
export function useAdminGetCompanyAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetCompanyAssessmentQuery_, AdminGetCompanyAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetCompanyAssessmentQuery_, AdminGetCompanyAssessmentQueryVariables_>(AdminGetCompanyAssessmentDocument_, options);
        }
export type AdminGetCompanyAssessmentQueryHookResult = ReturnType<typeof useAdminGetCompanyAssessmentQuery>;
export type AdminGetCompanyAssessmentLazyQuery_HookResult = ReturnType<typeof useAdminGetCompanyAssessmentLazyQuery_>;
export type AdminGetCompanyAssessmentSuspenseQuery_HookResult = ReturnType<typeof useAdminGetCompanyAssessmentSuspenseQuery_>;
export type AdminGetCompanyAssessmentQueryResult_ = Apollo.QueryResult<AdminGetCompanyAssessmentQuery_, AdminGetCompanyAssessmentQueryVariables_>;
export function refetchAdminGetCompanyAssessmentQuery_(variables: AdminGetCompanyAssessmentQueryVariables_) {
      return { query: AdminGetCompanyAssessmentDocument_, variables: variables }
    }
export const AdminGetGroupAssessmentDocument_ = gql`
    query AdminGetGroupAssessment($id: uuid!) {
  GroupAssessment_by_pk(id: $id) {
    id
    createdAt
    name
    period
    companyId
    updatedAt
    consolidatedCompanyAssessmentId
    subsidiaries {
      id
      company {
        name
      }
    }
  }
}
    `;

/**
 * __useAdminGetGroupAssessmentQuery__
 *
 * To run a query within a React component, call `useAdminGetGroupAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetGroupAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetGroupAssessmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetGroupAssessmentQuery(baseOptions: Apollo.QueryHookOptions<AdminGetGroupAssessmentQuery_, AdminGetGroupAssessmentQueryVariables_> & ({ variables: AdminGetGroupAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetGroupAssessmentQuery_, AdminGetGroupAssessmentQueryVariables_>(AdminGetGroupAssessmentDocument_, options);
      }
export function useAdminGetGroupAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetGroupAssessmentQuery_, AdminGetGroupAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetGroupAssessmentQuery_, AdminGetGroupAssessmentQueryVariables_>(AdminGetGroupAssessmentDocument_, options);
        }
export function useAdminGetGroupAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetGroupAssessmentQuery_, AdminGetGroupAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetGroupAssessmentQuery_, AdminGetGroupAssessmentQueryVariables_>(AdminGetGroupAssessmentDocument_, options);
        }
export type AdminGetGroupAssessmentQueryHookResult = ReturnType<typeof useAdminGetGroupAssessmentQuery>;
export type AdminGetGroupAssessmentLazyQuery_HookResult = ReturnType<typeof useAdminGetGroupAssessmentLazyQuery_>;
export type AdminGetGroupAssessmentSuspenseQuery_HookResult = ReturnType<typeof useAdminGetGroupAssessmentSuspenseQuery_>;
export type AdminGetGroupAssessmentQueryResult_ = Apollo.QueryResult<AdminGetGroupAssessmentQuery_, AdminGetGroupAssessmentQueryVariables_>;
export function refetchAdminGetGroupAssessmentQuery_(variables: AdminGetGroupAssessmentQueryVariables_) {
      return { query: AdminGetGroupAssessmentDocument_, variables: variables }
    }
export const AdminCreateSharedSpacesDocument_ = gql`
    mutation AdminCreateSharedSpaces($objects: [SharedSpace_insert_input!]!) {
  insert_SharedSpace(objects: $objects) {
    returning {
      spaceId
      companyId
    }
  }
}
    `;
export type AdminCreateSharedSpacesMutationFn_ = Apollo.MutationFunction<AdminCreateSharedSpacesMutation_, AdminCreateSharedSpacesMutationVariables_>;

/**
 * __useAdminCreateSharedSpacesMutation__
 *
 * To run a mutation, you first call `useAdminCreateSharedSpacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateSharedSpacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateSharedSpacesMutation, { data, loading, error }] = useAdminCreateSharedSpacesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateSharedSpacesMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateSharedSpacesMutation_, AdminCreateSharedSpacesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateSharedSpacesMutation_, AdminCreateSharedSpacesMutationVariables_>(AdminCreateSharedSpacesDocument_, options);
      }
export type AdminCreateSharedSpacesMutationHookResult = ReturnType<typeof useAdminCreateSharedSpacesMutation>;
export type AdminCreateSharedSpacesMutationResult_ = Apollo.MutationResult<AdminCreateSharedSpacesMutation_>;
export type AdminCreateSharedSpacesMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateSharedSpacesMutation_, AdminCreateSharedSpacesMutationVariables_>;
export const AdminDeleteSharedSpaceDocument_ = gql`
    mutation AdminDeleteSharedSpace($companyId: uuid!, $spaceId: String!) {
  delete_SharedSpace_by_pk(companyId: $companyId, spaceId: $spaceId) {
    companyId
    spaceId
  }
}
    `;
export type AdminDeleteSharedSpaceMutationFn_ = Apollo.MutationFunction<AdminDeleteSharedSpaceMutation_, AdminDeleteSharedSpaceMutationVariables_>;

/**
 * __useAdminDeleteSharedSpaceMutation__
 *
 * To run a mutation, you first call `useAdminDeleteSharedSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteSharedSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteSharedSpaceMutation, { data, loading, error }] = useAdminDeleteSharedSpaceMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      spaceId: // value for 'spaceId'
 *   },
 * });
 */
export function useAdminDeleteSharedSpaceMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteSharedSpaceMutation_, AdminDeleteSharedSpaceMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteSharedSpaceMutation_, AdminDeleteSharedSpaceMutationVariables_>(AdminDeleteSharedSpaceDocument_, options);
      }
export type AdminDeleteSharedSpaceMutationHookResult = ReturnType<typeof useAdminDeleteSharedSpaceMutation>;
export type AdminDeleteSharedSpaceMutationResult_ = Apollo.MutationResult<AdminDeleteSharedSpaceMutation_>;
export type AdminDeleteSharedSpaceMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteSharedSpaceMutation_, AdminDeleteSharedSpaceMutationVariables_>;
export const AdminGetSpaceDocument_ = gql`
    query AdminGetSpace($id: String!) {
  Space_by_pk(id: $id) {
    id
    name
    sharedWith {
      companyId
      company {
        name
      }
    }
  }
}
    `;

/**
 * __useAdminGetSpaceQuery__
 *
 * To run a query within a React component, call `useAdminGetSpaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetSpaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetSpaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetSpaceQuery(baseOptions: Apollo.QueryHookOptions<AdminGetSpaceQuery_, AdminGetSpaceQueryVariables_> & ({ variables: AdminGetSpaceQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetSpaceQuery_, AdminGetSpaceQueryVariables_>(AdminGetSpaceDocument_, options);
      }
export function useAdminGetSpaceLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetSpaceQuery_, AdminGetSpaceQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetSpaceQuery_, AdminGetSpaceQueryVariables_>(AdminGetSpaceDocument_, options);
        }
export function useAdminGetSpaceSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetSpaceQuery_, AdminGetSpaceQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetSpaceQuery_, AdminGetSpaceQueryVariables_>(AdminGetSpaceDocument_, options);
        }
export type AdminGetSpaceQueryHookResult = ReturnType<typeof useAdminGetSpaceQuery>;
export type AdminGetSpaceLazyQuery_HookResult = ReturnType<typeof useAdminGetSpaceLazyQuery_>;
export type AdminGetSpaceSuspenseQuery_HookResult = ReturnType<typeof useAdminGetSpaceSuspenseQuery_>;
export type AdminGetSpaceQueryResult_ = Apollo.QueryResult<AdminGetSpaceQuery_, AdminGetSpaceQueryVariables_>;
export function refetchAdminGetSpaceQuery_(variables: AdminGetSpaceQueryVariables_) {
      return { query: AdminGetSpaceDocument_, variables: variables }
    }
export const AdminUpdateSpaceDocument_ = gql`
    mutation AdminUpdateSpace($pk_columns: Space_pk_columns_input!, $_set: Space_set_input!) {
  update_Space_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    name
    sharedWith {
      companyId
      company {
        name
      }
    }
  }
}
    `;
export type AdminUpdateSpaceMutationFn_ = Apollo.MutationFunction<AdminUpdateSpaceMutation_, AdminUpdateSpaceMutationVariables_>;

/**
 * __useAdminUpdateSpaceMutation__
 *
 * To run a mutation, you first call `useAdminUpdateSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateSpaceMutation, { data, loading, error }] = useAdminUpdateSpaceMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateSpaceMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateSpaceMutation_, AdminUpdateSpaceMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateSpaceMutation_, AdminUpdateSpaceMutationVariables_>(AdminUpdateSpaceDocument_, options);
      }
export type AdminUpdateSpaceMutationHookResult = ReturnType<typeof useAdminUpdateSpaceMutation>;
export type AdminUpdateSpaceMutationResult_ = Apollo.MutationResult<AdminUpdateSpaceMutation_>;
export type AdminUpdateSpaceMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateSpaceMutation_, AdminUpdateSpaceMutationVariables_>;
export const AdminDeleteSpaceDocument_ = gql`
    mutation AdminDeleteSpace($id: String!) {
  delete_Space_by_pk(id: $id) {
    id
  }
}
    `;
export type AdminDeleteSpaceMutationFn_ = Apollo.MutationFunction<AdminDeleteSpaceMutation_, AdminDeleteSpaceMutationVariables_>;

/**
 * __useAdminDeleteSpaceMutation__
 *
 * To run a mutation, you first call `useAdminDeleteSpaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteSpaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteSpaceMutation, { data, loading, error }] = useAdminDeleteSpaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteSpaceMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteSpaceMutation_, AdminDeleteSpaceMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteSpaceMutation_, AdminDeleteSpaceMutationVariables_>(AdminDeleteSpaceDocument_, options);
      }
export type AdminDeleteSpaceMutationHookResult = ReturnType<typeof useAdminDeleteSpaceMutation>;
export type AdminDeleteSpaceMutationResult_ = Apollo.MutationResult<AdminDeleteSpaceMutation_>;
export type AdminDeleteSpaceMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteSpaceMutation_, AdminDeleteSpaceMutationVariables_>;
export const AdminGetActivityDocument_ = gql`
    query AdminGetActivity($reference: String!) {
  Activity_by_pk(reference: $reference) {
    name
    reference
    description
    sectorRef
    referenceNumber
    currentQuestionSetVersion
    isHidden
    additionalGuidance
    celsiaComment
    descriptionSource
    guidanceSource
    activityReports {
      bAssessment {
        cAssessment {
          company {
            name
            isReal
          }
          aggregate {
            title
          }
        }
        businessUnit {
          name
        }
      }
      activityVersionNumber
    }
  }
}
    `;

/**
 * __useAdminGetActivityQuery__
 *
 * To run a query within a React component, call `useAdminGetActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetActivityQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetActivityQuery(baseOptions: Apollo.QueryHookOptions<AdminGetActivityQuery_, AdminGetActivityQueryVariables_> & ({ variables: AdminGetActivityQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetActivityQuery_, AdminGetActivityQueryVariables_>(AdminGetActivityDocument_, options);
      }
export function useAdminGetActivityLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetActivityQuery_, AdminGetActivityQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetActivityQuery_, AdminGetActivityQueryVariables_>(AdminGetActivityDocument_, options);
        }
export function useAdminGetActivitySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetActivityQuery_, AdminGetActivityQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetActivityQuery_, AdminGetActivityQueryVariables_>(AdminGetActivityDocument_, options);
        }
export type AdminGetActivityQueryHookResult = ReturnType<typeof useAdminGetActivityQuery>;
export type AdminGetActivityLazyQuery_HookResult = ReturnType<typeof useAdminGetActivityLazyQuery_>;
export type AdminGetActivitySuspenseQuery_HookResult = ReturnType<typeof useAdminGetActivitySuspenseQuery_>;
export type AdminGetActivityQueryResult_ = Apollo.QueryResult<AdminGetActivityQuery_, AdminGetActivityQueryVariables_>;
export function refetchAdminGetActivityQuery_(variables: AdminGetActivityQueryVariables_) {
      return { query: AdminGetActivityDocument_, variables: variables }
    }
export const AdminGetQuestionDocument_ = gql`
    query AdminGetQuestion($id: uuid!) {
  Question_by_pk(id: $id) {
    uniqueId
    version
    title
    description
    type
    level
    group
    orderIndex
    unit
    alignmentErrorMessage
    dependencyDescription
    extendedDescription
    resourceLink
    documentationRequired
    relevantDirectives
    objectiveKey
    id
    other
    isAligned
    isRequired
    isVisible
    isEditable
    levelExpression
    learnMoreArticleSlug
    olderRevisions {
      oldQuestion {
        id
        uniqueId
        version
      }
      oldQuestionId
      newQuestionId
      description
    }
  }
}
    `;

/**
 * __useAdminGetQuestionQuery__
 *
 * To run a query within a React component, call `useAdminGetQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetQuestionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetQuestionQuery(baseOptions: Apollo.QueryHookOptions<AdminGetQuestionQuery_, AdminGetQuestionQueryVariables_> & ({ variables: AdminGetQuestionQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetQuestionQuery_, AdminGetQuestionQueryVariables_>(AdminGetQuestionDocument_, options);
      }
export function useAdminGetQuestionLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetQuestionQuery_, AdminGetQuestionQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetQuestionQuery_, AdminGetQuestionQueryVariables_>(AdminGetQuestionDocument_, options);
        }
export function useAdminGetQuestionSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetQuestionQuery_, AdminGetQuestionQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetQuestionQuery_, AdminGetQuestionQueryVariables_>(AdminGetQuestionDocument_, options);
        }
export type AdminGetQuestionQueryHookResult = ReturnType<typeof useAdminGetQuestionQuery>;
export type AdminGetQuestionLazyQuery_HookResult = ReturnType<typeof useAdminGetQuestionLazyQuery_>;
export type AdminGetQuestionSuspenseQuery_HookResult = ReturnType<typeof useAdminGetQuestionSuspenseQuery_>;
export type AdminGetQuestionQueryResult_ = Apollo.QueryResult<AdminGetQuestionQuery_, AdminGetQuestionQueryVariables_>;
export function refetchAdminGetQuestionQuery_(variables: AdminGetQuestionQueryVariables_) {
      return { query: AdminGetQuestionDocument_, variables: variables }
    }
export const AdminGetQuestionTypesDocument_ = gql`
    query AdminGetQuestionTypes($limit: Int, $offset: Int, $where: QuestionType_bool_exp) {
  QuestionType(limit: $limit, offset: $offset, where: $where) {
    type
  }
  QuestionType_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetQuestionTypesQuery__
 *
 * To run a query within a React component, call `useAdminGetQuestionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetQuestionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetQuestionTypesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetQuestionTypesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetQuestionTypesQuery_, AdminGetQuestionTypesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetQuestionTypesQuery_, AdminGetQuestionTypesQueryVariables_>(AdminGetQuestionTypesDocument_, options);
      }
export function useAdminGetQuestionTypesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetQuestionTypesQuery_, AdminGetQuestionTypesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetQuestionTypesQuery_, AdminGetQuestionTypesQueryVariables_>(AdminGetQuestionTypesDocument_, options);
        }
export function useAdminGetQuestionTypesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetQuestionTypesQuery_, AdminGetQuestionTypesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetQuestionTypesQuery_, AdminGetQuestionTypesQueryVariables_>(AdminGetQuestionTypesDocument_, options);
        }
export type AdminGetQuestionTypesQueryHookResult = ReturnType<typeof useAdminGetQuestionTypesQuery>;
export type AdminGetQuestionTypesLazyQuery_HookResult = ReturnType<typeof useAdminGetQuestionTypesLazyQuery_>;
export type AdminGetQuestionTypesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetQuestionTypesSuspenseQuery_>;
export type AdminGetQuestionTypesQueryResult_ = Apollo.QueryResult<AdminGetQuestionTypesQuery_, AdminGetQuestionTypesQueryVariables_>;
export function refetchAdminGetQuestionTypesQuery_(variables?: AdminGetQuestionTypesQueryVariables_) {
      return { query: AdminGetQuestionTypesDocument_, variables: variables }
    }
export const AdminGetQuestionRevisionDocument_ = gql`
    query AdminGetQuestionRevision($oldQuestionId: uuid!, $newQuestionId: uuid!) {
  QuestionRevision_by_pk(
    oldQuestionId: $oldQuestionId
    newQuestionId: $newQuestionId
  ) {
    oldQuestionId
    newQuestionId
    description
    oldQuestion {
      id
      uniqueId
      version
    }
    newQuestion {
      id
      uniqueId
      version
    }
  }
}
    `;

/**
 * __useAdminGetQuestionRevisionQuery__
 *
 * To run a query within a React component, call `useAdminGetQuestionRevisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetQuestionRevisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetQuestionRevisionQuery({
 *   variables: {
 *      oldQuestionId: // value for 'oldQuestionId'
 *      newQuestionId: // value for 'newQuestionId'
 *   },
 * });
 */
export function useAdminGetQuestionRevisionQuery(baseOptions: Apollo.QueryHookOptions<AdminGetQuestionRevisionQuery_, AdminGetQuestionRevisionQueryVariables_> & ({ variables: AdminGetQuestionRevisionQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetQuestionRevisionQuery_, AdminGetQuestionRevisionQueryVariables_>(AdminGetQuestionRevisionDocument_, options);
      }
export function useAdminGetQuestionRevisionLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetQuestionRevisionQuery_, AdminGetQuestionRevisionQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetQuestionRevisionQuery_, AdminGetQuestionRevisionQueryVariables_>(AdminGetQuestionRevisionDocument_, options);
        }
export function useAdminGetQuestionRevisionSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetQuestionRevisionQuery_, AdminGetQuestionRevisionQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetQuestionRevisionQuery_, AdminGetQuestionRevisionQueryVariables_>(AdminGetQuestionRevisionDocument_, options);
        }
export type AdminGetQuestionRevisionQueryHookResult = ReturnType<typeof useAdminGetQuestionRevisionQuery>;
export type AdminGetQuestionRevisionLazyQuery_HookResult = ReturnType<typeof useAdminGetQuestionRevisionLazyQuery_>;
export type AdminGetQuestionRevisionSuspenseQuery_HookResult = ReturnType<typeof useAdminGetQuestionRevisionSuspenseQuery_>;
export type AdminGetQuestionRevisionQueryResult_ = Apollo.QueryResult<AdminGetQuestionRevisionQuery_, AdminGetQuestionRevisionQueryVariables_>;
export function refetchAdminGetQuestionRevisionQuery_(variables: AdminGetQuestionRevisionQueryVariables_) {
      return { query: AdminGetQuestionRevisionDocument_, variables: variables }
    }
export const AdminDeleteQuestionRevisionDocument_ = gql`
    mutation AdminDeleteQuestionRevision($oldQuestionId: uuid!, $newQuestionId: uuid!) {
  delete_QuestionRevision_by_pk(
    oldQuestionId: $oldQuestionId
    newQuestionId: $newQuestionId
  ) {
    oldQuestionId
    newQuestionId
    description
    oldQuestion {
      id
      uniqueId
      version
    }
    newQuestion {
      id
      uniqueId
      version
    }
  }
}
    `;
export type AdminDeleteQuestionRevisionMutationFn_ = Apollo.MutationFunction<AdminDeleteQuestionRevisionMutation_, AdminDeleteQuestionRevisionMutationVariables_>;

/**
 * __useAdminDeleteQuestionRevisionMutation__
 *
 * To run a mutation, you first call `useAdminDeleteQuestionRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteQuestionRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteQuestionRevisionMutation, { data, loading, error }] = useAdminDeleteQuestionRevisionMutation({
 *   variables: {
 *      oldQuestionId: // value for 'oldQuestionId'
 *      newQuestionId: // value for 'newQuestionId'
 *   },
 * });
 */
export function useAdminDeleteQuestionRevisionMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteQuestionRevisionMutation_, AdminDeleteQuestionRevisionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteQuestionRevisionMutation_, AdminDeleteQuestionRevisionMutationVariables_>(AdminDeleteQuestionRevisionDocument_, options);
      }
export type AdminDeleteQuestionRevisionMutationHookResult = ReturnType<typeof useAdminDeleteQuestionRevisionMutation>;
export type AdminDeleteQuestionRevisionMutationResult_ = Apollo.MutationResult<AdminDeleteQuestionRevisionMutation_>;
export type AdminDeleteQuestionRevisionMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteQuestionRevisionMutation_, AdminDeleteQuestionRevisionMutationVariables_>;
export const AdminGetObjectiveDocument_ = gql`
    query AdminGetObjective($key: String!) {
  Objective_by_pk(key: $key) {
    key
    title
    description
  }
}
    `;

/**
 * __useAdminGetObjectiveQuery__
 *
 * To run a query within a React component, call `useAdminGetObjectiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetObjectiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetObjectiveQuery({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useAdminGetObjectiveQuery(baseOptions: Apollo.QueryHookOptions<AdminGetObjectiveQuery_, AdminGetObjectiveQueryVariables_> & ({ variables: AdminGetObjectiveQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetObjectiveQuery_, AdminGetObjectiveQueryVariables_>(AdminGetObjectiveDocument_, options);
      }
export function useAdminGetObjectiveLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetObjectiveQuery_, AdminGetObjectiveQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetObjectiveQuery_, AdminGetObjectiveQueryVariables_>(AdminGetObjectiveDocument_, options);
        }
export function useAdminGetObjectiveSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetObjectiveQuery_, AdminGetObjectiveQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetObjectiveQuery_, AdminGetObjectiveQueryVariables_>(AdminGetObjectiveDocument_, options);
        }
export type AdminGetObjectiveQueryHookResult = ReturnType<typeof useAdminGetObjectiveQuery>;
export type AdminGetObjectiveLazyQuery_HookResult = ReturnType<typeof useAdminGetObjectiveLazyQuery_>;
export type AdminGetObjectiveSuspenseQuery_HookResult = ReturnType<typeof useAdminGetObjectiveSuspenseQuery_>;
export type AdminGetObjectiveQueryResult_ = Apollo.QueryResult<AdminGetObjectiveQuery_, AdminGetObjectiveQueryVariables_>;
export function refetchAdminGetObjectiveQuery_(variables: AdminGetObjectiveQueryVariables_) {
      return { query: AdminGetObjectiveDocument_, variables: variables }
    }
export const AdminDeleteObjectiveDocument_ = gql`
    mutation AdminDeleteObjective($id: String!) {
  delete_Objective_by_pk(key: $id) {
    key
  }
}
    `;
export type AdminDeleteObjectiveMutationFn_ = Apollo.MutationFunction<AdminDeleteObjectiveMutation_, AdminDeleteObjectiveMutationVariables_>;

/**
 * __useAdminDeleteObjectiveMutation__
 *
 * To run a mutation, you first call `useAdminDeleteObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteObjectiveMutation, { data, loading, error }] = useAdminDeleteObjectiveMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteObjectiveMutation_, AdminDeleteObjectiveMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteObjectiveMutation_, AdminDeleteObjectiveMutationVariables_>(AdminDeleteObjectiveDocument_, options);
      }
export type AdminDeleteObjectiveMutationHookResult = ReturnType<typeof useAdminDeleteObjectiveMutation>;
export type AdminDeleteObjectiveMutationResult_ = Apollo.MutationResult<AdminDeleteObjectiveMutation_>;
export type AdminDeleteObjectiveMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteObjectiveMutation_, AdminDeleteObjectiveMutationVariables_>;
export const AdminGetQuestionSetQuestionDocument_ = gql`
    query AdminGetQuestionSetQuestion($questionSetRef: String!, $questionId: uuid!) {
  QuestionSetQuestion_by_pk(
    questionSetRef: $questionSetRef
    questionId: $questionId
  ) {
    questionSetRef
    questionId
  }
}
    `;

/**
 * __useAdminGetQuestionSetQuestionQuery__
 *
 * To run a query within a React component, call `useAdminGetQuestionSetQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetQuestionSetQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetQuestionSetQuestionQuery({
 *   variables: {
 *      questionSetRef: // value for 'questionSetRef'
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useAdminGetQuestionSetQuestionQuery(baseOptions: Apollo.QueryHookOptions<AdminGetQuestionSetQuestionQuery_, AdminGetQuestionSetQuestionQueryVariables_> & ({ variables: AdminGetQuestionSetQuestionQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetQuestionSetQuestionQuery_, AdminGetQuestionSetQuestionQueryVariables_>(AdminGetQuestionSetQuestionDocument_, options);
      }
export function useAdminGetQuestionSetQuestionLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetQuestionSetQuestionQuery_, AdminGetQuestionSetQuestionQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetQuestionSetQuestionQuery_, AdminGetQuestionSetQuestionQueryVariables_>(AdminGetQuestionSetQuestionDocument_, options);
        }
export function useAdminGetQuestionSetQuestionSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetQuestionSetQuestionQuery_, AdminGetQuestionSetQuestionQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetQuestionSetQuestionQuery_, AdminGetQuestionSetQuestionQueryVariables_>(AdminGetQuestionSetQuestionDocument_, options);
        }
export type AdminGetQuestionSetQuestionQueryHookResult = ReturnType<typeof useAdminGetQuestionSetQuestionQuery>;
export type AdminGetQuestionSetQuestionLazyQuery_HookResult = ReturnType<typeof useAdminGetQuestionSetQuestionLazyQuery_>;
export type AdminGetQuestionSetQuestionSuspenseQuery_HookResult = ReturnType<typeof useAdminGetQuestionSetQuestionSuspenseQuery_>;
export type AdminGetQuestionSetQuestionQueryResult_ = Apollo.QueryResult<AdminGetQuestionSetQuestionQuery_, AdminGetQuestionSetQuestionQueryVariables_>;
export function refetchAdminGetQuestionSetQuestionQuery_(variables: AdminGetQuestionSetQuestionQueryVariables_) {
      return { query: AdminGetQuestionSetQuestionDocument_, variables: variables }
    }
export const AdminGetQuestionChoiceDocument_ = gql`
    query AdminGetQuestionChoice($id: bigint!) {
  QuestionChoice_by_pk(id: $id) {
    id
    order
    value
    displayName
    question_id
  }
}
    `;

/**
 * __useAdminGetQuestionChoiceQuery__
 *
 * To run a query within a React component, call `useAdminGetQuestionChoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetQuestionChoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetQuestionChoiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetQuestionChoiceQuery(baseOptions: Apollo.QueryHookOptions<AdminGetQuestionChoiceQuery_, AdminGetQuestionChoiceQueryVariables_> & ({ variables: AdminGetQuestionChoiceQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetQuestionChoiceQuery_, AdminGetQuestionChoiceQueryVariables_>(AdminGetQuestionChoiceDocument_, options);
      }
export function useAdminGetQuestionChoiceLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetQuestionChoiceQuery_, AdminGetQuestionChoiceQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetQuestionChoiceQuery_, AdminGetQuestionChoiceQueryVariables_>(AdminGetQuestionChoiceDocument_, options);
        }
export function useAdminGetQuestionChoiceSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetQuestionChoiceQuery_, AdminGetQuestionChoiceQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetQuestionChoiceQuery_, AdminGetQuestionChoiceQueryVariables_>(AdminGetQuestionChoiceDocument_, options);
        }
export type AdminGetQuestionChoiceQueryHookResult = ReturnType<typeof useAdminGetQuestionChoiceQuery>;
export type AdminGetQuestionChoiceLazyQuery_HookResult = ReturnType<typeof useAdminGetQuestionChoiceLazyQuery_>;
export type AdminGetQuestionChoiceSuspenseQuery_HookResult = ReturnType<typeof useAdminGetQuestionChoiceSuspenseQuery_>;
export type AdminGetQuestionChoiceQueryResult_ = Apollo.QueryResult<AdminGetQuestionChoiceQuery_, AdminGetQuestionChoiceQueryVariables_>;
export function refetchAdminGetQuestionChoiceQuery_(variables: AdminGetQuestionChoiceQueryVariables_) {
      return { query: AdminGetQuestionChoiceDocument_, variables: variables }
    }
export const AdminDeleteQuestionChoiceDocument_ = gql`
    mutation AdminDeleteQuestionChoice($id: bigint!) {
  delete_QuestionChoice_by_pk(id: $id) {
    id
  }
}
    `;
export type AdminDeleteQuestionChoiceMutationFn_ = Apollo.MutationFunction<AdminDeleteQuestionChoiceMutation_, AdminDeleteQuestionChoiceMutationVariables_>;

/**
 * __useAdminDeleteQuestionChoiceMutation__
 *
 * To run a mutation, you first call `useAdminDeleteQuestionChoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteQuestionChoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteQuestionChoiceMutation, { data, loading, error }] = useAdminDeleteQuestionChoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteQuestionChoiceMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteQuestionChoiceMutation_, AdminDeleteQuestionChoiceMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteQuestionChoiceMutation_, AdminDeleteQuestionChoiceMutationVariables_>(AdminDeleteQuestionChoiceDocument_, options);
      }
export type AdminDeleteQuestionChoiceMutationHookResult = ReturnType<typeof useAdminDeleteQuestionChoiceMutation>;
export type AdminDeleteQuestionChoiceMutationResult_ = Apollo.MutationResult<AdminDeleteQuestionChoiceMutation_>;
export type AdminDeleteQuestionChoiceMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteQuestionChoiceMutation_, AdminDeleteQuestionChoiceMutationVariables_>;
export const AdminGetActivityNaceCodeDocument_ = gql`
    query AdminGetActivityNaceCode($id: bigint!) {
  ActivityNaceCode_by_pk(id: $id) {
    activityRef
    code
    id
  }
}
    `;

/**
 * __useAdminGetActivityNaceCodeQuery__
 *
 * To run a query within a React component, call `useAdminGetActivityNaceCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetActivityNaceCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetActivityNaceCodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetActivityNaceCodeQuery(baseOptions: Apollo.QueryHookOptions<AdminGetActivityNaceCodeQuery_, AdminGetActivityNaceCodeQueryVariables_> & ({ variables: AdminGetActivityNaceCodeQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetActivityNaceCodeQuery_, AdminGetActivityNaceCodeQueryVariables_>(AdminGetActivityNaceCodeDocument_, options);
      }
export function useAdminGetActivityNaceCodeLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetActivityNaceCodeQuery_, AdminGetActivityNaceCodeQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetActivityNaceCodeQuery_, AdminGetActivityNaceCodeQueryVariables_>(AdminGetActivityNaceCodeDocument_, options);
        }
export function useAdminGetActivityNaceCodeSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetActivityNaceCodeQuery_, AdminGetActivityNaceCodeQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetActivityNaceCodeQuery_, AdminGetActivityNaceCodeQueryVariables_>(AdminGetActivityNaceCodeDocument_, options);
        }
export type AdminGetActivityNaceCodeQueryHookResult = ReturnType<typeof useAdminGetActivityNaceCodeQuery>;
export type AdminGetActivityNaceCodeLazyQuery_HookResult = ReturnType<typeof useAdminGetActivityNaceCodeLazyQuery_>;
export type AdminGetActivityNaceCodeSuspenseQuery_HookResult = ReturnType<typeof useAdminGetActivityNaceCodeSuspenseQuery_>;
export type AdminGetActivityNaceCodeQueryResult_ = Apollo.QueryResult<AdminGetActivityNaceCodeQuery_, AdminGetActivityNaceCodeQueryVariables_>;
export function refetchAdminGetActivityNaceCodeQuery_(variables: AdminGetActivityNaceCodeQueryVariables_) {
      return { query: AdminGetActivityNaceCodeDocument_, variables: variables }
    }
export const AdminDeleteActivityNaceCodeDocument_ = gql`
    mutation AdminDeleteActivityNaceCode($id: bigint!) {
  delete_ActivityNaceCode_by_pk(id: $id) {
    id
  }
}
    `;
export type AdminDeleteActivityNaceCodeMutationFn_ = Apollo.MutationFunction<AdminDeleteActivityNaceCodeMutation_, AdminDeleteActivityNaceCodeMutationVariables_>;

/**
 * __useAdminDeleteActivityNaceCodeMutation__
 *
 * To run a mutation, you first call `useAdminDeleteActivityNaceCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteActivityNaceCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteActivityNaceCodeMutation, { data, loading, error }] = useAdminDeleteActivityNaceCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteActivityNaceCodeMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteActivityNaceCodeMutation_, AdminDeleteActivityNaceCodeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteActivityNaceCodeMutation_, AdminDeleteActivityNaceCodeMutationVariables_>(AdminDeleteActivityNaceCodeDocument_, options);
      }
export type AdminDeleteActivityNaceCodeMutationHookResult = ReturnType<typeof useAdminDeleteActivityNaceCodeMutation>;
export type AdminDeleteActivityNaceCodeMutationResult_ = Apollo.MutationResult<AdminDeleteActivityNaceCodeMutation_>;
export type AdminDeleteActivityNaceCodeMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteActivityNaceCodeMutation_, AdminDeleteActivityNaceCodeMutationVariables_>;
export const AdminGetActivityVersionDocument_ = gql`
    query AdminGetActivityVersion($activityRef: String!, $versionNumber: Int!) {
  ActivityVersion_by_pk(activityRef: $activityRef, versionNumber: $versionNumber) {
    activityRef
    versionNumber
    tagExpression
    tagObjective
    changeDescription
    validFrom
    activityQuestionSets {
      questionSetRef
      version
      activityRef
      questionSet {
        reference
      }
    }
  }
}
    `;

/**
 * __useAdminGetActivityVersionQuery__
 *
 * To run a query within a React component, call `useAdminGetActivityVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetActivityVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetActivityVersionQuery({
 *   variables: {
 *      activityRef: // value for 'activityRef'
 *      versionNumber: // value for 'versionNumber'
 *   },
 * });
 */
export function useAdminGetActivityVersionQuery(baseOptions: Apollo.QueryHookOptions<AdminGetActivityVersionQuery_, AdminGetActivityVersionQueryVariables_> & ({ variables: AdminGetActivityVersionQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetActivityVersionQuery_, AdminGetActivityVersionQueryVariables_>(AdminGetActivityVersionDocument_, options);
      }
export function useAdminGetActivityVersionLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetActivityVersionQuery_, AdminGetActivityVersionQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetActivityVersionQuery_, AdminGetActivityVersionQueryVariables_>(AdminGetActivityVersionDocument_, options);
        }
export function useAdminGetActivityVersionSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetActivityVersionQuery_, AdminGetActivityVersionQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetActivityVersionQuery_, AdminGetActivityVersionQueryVariables_>(AdminGetActivityVersionDocument_, options);
        }
export type AdminGetActivityVersionQueryHookResult = ReturnType<typeof useAdminGetActivityVersionQuery>;
export type AdminGetActivityVersionLazyQuery_HookResult = ReturnType<typeof useAdminGetActivityVersionLazyQuery_>;
export type AdminGetActivityVersionSuspenseQuery_HookResult = ReturnType<typeof useAdminGetActivityVersionSuspenseQuery_>;
export type AdminGetActivityVersionQueryResult_ = Apollo.QueryResult<AdminGetActivityVersionQuery_, AdminGetActivityVersionQueryVariables_>;
export function refetchAdminGetActivityVersionQuery_(variables: AdminGetActivityVersionQueryVariables_) {
      return { query: AdminGetActivityVersionDocument_, variables: variables }
    }
export const AdminGetArticleDocument_ = gql`
    query AdminGetArticle($id: uuid!) {
  Article_by_pk(id: $id) {
    title
    body
    id
    slug
    isHidden
    order
  }
}
    `;

/**
 * __useAdminGetArticleQuery__
 *
 * To run a query within a React component, call `useAdminGetArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetArticleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetArticleQuery(baseOptions: Apollo.QueryHookOptions<AdminGetArticleQuery_, AdminGetArticleQueryVariables_> & ({ variables: AdminGetArticleQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetArticleQuery_, AdminGetArticleQueryVariables_>(AdminGetArticleDocument_, options);
      }
export function useAdminGetArticleLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetArticleQuery_, AdminGetArticleQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetArticleQuery_, AdminGetArticleQueryVariables_>(AdminGetArticleDocument_, options);
        }
export function useAdminGetArticleSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetArticleQuery_, AdminGetArticleQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetArticleQuery_, AdminGetArticleQueryVariables_>(AdminGetArticleDocument_, options);
        }
export type AdminGetArticleQueryHookResult = ReturnType<typeof useAdminGetArticleQuery>;
export type AdminGetArticleLazyQuery_HookResult = ReturnType<typeof useAdminGetArticleLazyQuery_>;
export type AdminGetArticleSuspenseQuery_HookResult = ReturnType<typeof useAdminGetArticleSuspenseQuery_>;
export type AdminGetArticleQueryResult_ = Apollo.QueryResult<AdminGetArticleQuery_, AdminGetArticleQueryVariables_>;
export function refetchAdminGetArticleQuery_(variables: AdminGetArticleQueryVariables_) {
      return { query: AdminGetArticleDocument_, variables: variables }
    }
export const AdminDeleteArticleDocument_ = gql`
    mutation AdminDeleteArticle($id: uuid!) {
  delete_Article_by_pk(id: $id) {
    id
  }
}
    `;
export type AdminDeleteArticleMutationFn_ = Apollo.MutationFunction<AdminDeleteArticleMutation_, AdminDeleteArticleMutationVariables_>;

/**
 * __useAdminDeleteArticleMutation__
 *
 * To run a mutation, you first call `useAdminDeleteArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteArticleMutation, { data, loading, error }] = useAdminDeleteArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteArticleMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteArticleMutation_, AdminDeleteArticleMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteArticleMutation_, AdminDeleteArticleMutationVariables_>(AdminDeleteArticleDocument_, options);
      }
export type AdminDeleteArticleMutationHookResult = ReturnType<typeof useAdminDeleteArticleMutation>;
export type AdminDeleteArticleMutationResult_ = Apollo.MutationResult<AdminDeleteArticleMutation_>;
export type AdminDeleteArticleMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteArticleMutation_, AdminDeleteArticleMutationVariables_>;
export const AdminGetTagDocument_ = gql`
    query AdminGetTag($id: uuid!) {
  Tag_by_pk(id: $id) {
    id
    name
    description
    tagGroupId
  }
}
    `;

/**
 * __useAdminGetTagQuery__
 *
 * To run a query within a React component, call `useAdminGetTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetTagQuery(baseOptions: Apollo.QueryHookOptions<AdminGetTagQuery_, AdminGetTagQueryVariables_> & ({ variables: AdminGetTagQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetTagQuery_, AdminGetTagQueryVariables_>(AdminGetTagDocument_, options);
      }
export function useAdminGetTagLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetTagQuery_, AdminGetTagQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetTagQuery_, AdminGetTagQueryVariables_>(AdminGetTagDocument_, options);
        }
export function useAdminGetTagSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetTagQuery_, AdminGetTagQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetTagQuery_, AdminGetTagQueryVariables_>(AdminGetTagDocument_, options);
        }
export type AdminGetTagQueryHookResult = ReturnType<typeof useAdminGetTagQuery>;
export type AdminGetTagLazyQuery_HookResult = ReturnType<typeof useAdminGetTagLazyQuery_>;
export type AdminGetTagSuspenseQuery_HookResult = ReturnType<typeof useAdminGetTagSuspenseQuery_>;
export type AdminGetTagQueryResult_ = Apollo.QueryResult<AdminGetTagQuery_, AdminGetTagQueryVariables_>;
export function refetchAdminGetTagQuery_(variables: AdminGetTagQueryVariables_) {
      return { query: AdminGetTagDocument_, variables: variables }
    }
export const AdminGetTagGroupDocument_ = gql`
    query AdminGetTagGroup($id: uuid!) {
  TagGroup_by_pk(id: $id) {
    id
    name
    description
  }
}
    `;

/**
 * __useAdminGetTagGroupQuery__
 *
 * To run a query within a React component, call `useAdminGetTagGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetTagGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetTagGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetTagGroupQuery(baseOptions: Apollo.QueryHookOptions<AdminGetTagGroupQuery_, AdminGetTagGroupQueryVariables_> & ({ variables: AdminGetTagGroupQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetTagGroupQuery_, AdminGetTagGroupQueryVariables_>(AdminGetTagGroupDocument_, options);
      }
export function useAdminGetTagGroupLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetTagGroupQuery_, AdminGetTagGroupQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetTagGroupQuery_, AdminGetTagGroupQueryVariables_>(AdminGetTagGroupDocument_, options);
        }
export function useAdminGetTagGroupSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetTagGroupQuery_, AdminGetTagGroupQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetTagGroupQuery_, AdminGetTagGroupQueryVariables_>(AdminGetTagGroupDocument_, options);
        }
export type AdminGetTagGroupQueryHookResult = ReturnType<typeof useAdminGetTagGroupQuery>;
export type AdminGetTagGroupLazyQuery_HookResult = ReturnType<typeof useAdminGetTagGroupLazyQuery_>;
export type AdminGetTagGroupSuspenseQuery_HookResult = ReturnType<typeof useAdminGetTagGroupSuspenseQuery_>;
export type AdminGetTagGroupQueryResult_ = Apollo.QueryResult<AdminGetTagGroupQuery_, AdminGetTagGroupQueryVariables_>;
export function refetchAdminGetTagGroupQuery_(variables: AdminGetTagGroupQueryVariables_) {
      return { query: AdminGetTagGroupDocument_, variables: variables }
    }
export const AdminDeleteTagDocument_ = gql`
    mutation AdminDeleteTag($id: uuid!) {
  delete_Tag_by_pk(id: $id) {
    id
  }
}
    `;
export type AdminDeleteTagMutationFn_ = Apollo.MutationFunction<AdminDeleteTagMutation_, AdminDeleteTagMutationVariables_>;

/**
 * __useAdminDeleteTagMutation__
 *
 * To run a mutation, you first call `useAdminDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteTagMutation, { data, loading, error }] = useAdminDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteTagMutation_, AdminDeleteTagMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteTagMutation_, AdminDeleteTagMutationVariables_>(AdminDeleteTagDocument_, options);
      }
export type AdminDeleteTagMutationHookResult = ReturnType<typeof useAdminDeleteTagMutation>;
export type AdminDeleteTagMutationResult_ = Apollo.MutationResult<AdminDeleteTagMutation_>;
export type AdminDeleteTagMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteTagMutation_, AdminDeleteTagMutationVariables_>;
export const AdminDeleteTagGroupDocument_ = gql`
    mutation AdminDeleteTagGroup($id: uuid!) {
  delete_TagGroup_by_pk(id: $id) {
    id
  }
}
    `;
export type AdminDeleteTagGroupMutationFn_ = Apollo.MutationFunction<AdminDeleteTagGroupMutation_, AdminDeleteTagGroupMutationVariables_>;

/**
 * __useAdminDeleteTagGroupMutation__
 *
 * To run a mutation, you first call `useAdminDeleteTagGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteTagGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteTagGroupMutation, { data, loading, error }] = useAdminDeleteTagGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteTagGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteTagGroupMutation_, AdminDeleteTagGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteTagGroupMutation_, AdminDeleteTagGroupMutationVariables_>(AdminDeleteTagGroupDocument_, options);
      }
export type AdminDeleteTagGroupMutationHookResult = ReturnType<typeof useAdminDeleteTagGroupMutation>;
export type AdminDeleteTagGroupMutationResult_ = Apollo.MutationResult<AdminDeleteTagGroupMutation_>;
export type AdminDeleteTagGroupMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteTagGroupMutation_, AdminDeleteTagGroupMutationVariables_>;
export const AdminGetTag_ArticleDocument_ = gql`
    query AdminGetTag_article($id: bigint!) {
  Tag_articles_by_pk(id: $id) {
    id
    tag_id
    article_id
  }
}
    `;

/**
 * __useAdminGetTag_ArticleQuery__
 *
 * To run a query within a React component, call `useAdminGetTag_ArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetTag_ArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetTag_ArticleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetTag_ArticleQuery(baseOptions: Apollo.QueryHookOptions<AdminGetTag_ArticleQuery_, AdminGetTag_ArticleQueryVariables_> & ({ variables: AdminGetTag_ArticleQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetTag_ArticleQuery_, AdminGetTag_ArticleQueryVariables_>(AdminGetTag_ArticleDocument_, options);
      }
export function useAdminGetTag_ArticleLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetTag_ArticleQuery_, AdminGetTag_ArticleQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetTag_ArticleQuery_, AdminGetTag_ArticleQueryVariables_>(AdminGetTag_ArticleDocument_, options);
        }
export function useAdminGetTag_ArticleSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetTag_ArticleQuery_, AdminGetTag_ArticleQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetTag_ArticleQuery_, AdminGetTag_ArticleQueryVariables_>(AdminGetTag_ArticleDocument_, options);
        }
export type AdminGetTag_ArticleQueryHookResult = ReturnType<typeof useAdminGetTag_ArticleQuery>;
export type AdminGetTag_ArticleLazyQuery_HookResult = ReturnType<typeof useAdminGetTag_ArticleLazyQuery_>;
export type AdminGetTag_ArticleSuspenseQuery_HookResult = ReturnType<typeof useAdminGetTag_ArticleSuspenseQuery_>;
export type AdminGetTag_ArticleQueryResult_ = Apollo.QueryResult<AdminGetTag_ArticleQuery_, AdminGetTag_ArticleQueryVariables_>;
export function refetchAdminGetTag_ArticleQuery_(variables: AdminGetTag_ArticleQueryVariables_) {
      return { query: AdminGetTag_ArticleDocument_, variables: variables }
    }
export const AdminDeleteTag_ArticleDocument_ = gql`
    mutation AdminDeleteTag_article($id: bigint!) {
  delete_Tag_articles_by_pk(id: $id) {
    id
  }
}
    `;
export type AdminDeleteTag_ArticleMutationFn_ = Apollo.MutationFunction<AdminDeleteTag_ArticleMutation_, AdminDeleteTag_ArticleMutationVariables_>;

/**
 * __useAdminDeleteTag_ArticleMutation__
 *
 * To run a mutation, you first call `useAdminDeleteTag_ArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteTag_ArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteTagArticleMutation, { data, loading, error }] = useAdminDeleteTag_ArticleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteTag_ArticleMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteTag_ArticleMutation_, AdminDeleteTag_ArticleMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteTag_ArticleMutation_, AdminDeleteTag_ArticleMutationVariables_>(AdminDeleteTag_ArticleDocument_, options);
      }
export type AdminDeleteTag_ArticleMutationHookResult = ReturnType<typeof useAdminDeleteTag_ArticleMutation>;
export type AdminDeleteTag_ArticleMutationResult_ = Apollo.MutationResult<AdminDeleteTag_ArticleMutation_>;
export type AdminDeleteTag_ArticleMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteTag_ArticleMutation_, AdminDeleteTag_ArticleMutationVariables_>;
export const AdminGetPaiCategoryDocument_ = gql`
    query AdminGetPaiCategory($reference: String!) {
  PaiCategory_by_pk(reference: $reference) {
    title
    reference
    subtitle
    tableReference
  }
}
    `;

/**
 * __useAdminGetPaiCategoryQuery__
 *
 * To run a query within a React component, call `useAdminGetPaiCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetPaiCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetPaiCategoryQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetPaiCategoryQuery(baseOptions: Apollo.QueryHookOptions<AdminGetPaiCategoryQuery_, AdminGetPaiCategoryQueryVariables_> & ({ variables: AdminGetPaiCategoryQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetPaiCategoryQuery_, AdminGetPaiCategoryQueryVariables_>(AdminGetPaiCategoryDocument_, options);
      }
export function useAdminGetPaiCategoryLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetPaiCategoryQuery_, AdminGetPaiCategoryQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetPaiCategoryQuery_, AdminGetPaiCategoryQueryVariables_>(AdminGetPaiCategoryDocument_, options);
        }
export function useAdminGetPaiCategorySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetPaiCategoryQuery_, AdminGetPaiCategoryQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetPaiCategoryQuery_, AdminGetPaiCategoryQueryVariables_>(AdminGetPaiCategoryDocument_, options);
        }
export type AdminGetPaiCategoryQueryHookResult = ReturnType<typeof useAdminGetPaiCategoryQuery>;
export type AdminGetPaiCategoryLazyQuery_HookResult = ReturnType<typeof useAdminGetPaiCategoryLazyQuery_>;
export type AdminGetPaiCategorySuspenseQuery_HookResult = ReturnType<typeof useAdminGetPaiCategorySuspenseQuery_>;
export type AdminGetPaiCategoryQueryResult_ = Apollo.QueryResult<AdminGetPaiCategoryQuery_, AdminGetPaiCategoryQueryVariables_>;
export function refetchAdminGetPaiCategoryQuery_(variables: AdminGetPaiCategoryQueryVariables_) {
      return { query: AdminGetPaiCategoryDocument_, variables: variables }
    }
export const AdminDeletePaiCategoryDocument_ = gql`
    mutation AdminDeletePaiCategory($id: String!) {
  delete_PaiCategory_by_pk(reference: $id) {
    reference
  }
}
    `;
export type AdminDeletePaiCategoryMutationFn_ = Apollo.MutationFunction<AdminDeletePaiCategoryMutation_, AdminDeletePaiCategoryMutationVariables_>;

/**
 * __useAdminDeletePaiCategoryMutation__
 *
 * To run a mutation, you first call `useAdminDeletePaiCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeletePaiCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeletePaiCategoryMutation, { data, loading, error }] = useAdminDeletePaiCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeletePaiCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeletePaiCategoryMutation_, AdminDeletePaiCategoryMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeletePaiCategoryMutation_, AdminDeletePaiCategoryMutationVariables_>(AdminDeletePaiCategoryDocument_, options);
      }
export type AdminDeletePaiCategoryMutationHookResult = ReturnType<typeof useAdminDeletePaiCategoryMutation>;
export type AdminDeletePaiCategoryMutationResult_ = Apollo.MutationResult<AdminDeletePaiCategoryMutation_>;
export type AdminDeletePaiCategoryMutationOptions_ = Apollo.BaseMutationOptions<AdminDeletePaiCategoryMutation_, AdminDeletePaiCategoryMutationVariables_>;
export const AdminGetPaiTableDocument_ = gql`
    query AdminGetPaiTable($reference: String!) {
  PaiTable_by_pk(reference: $reference) {
    title
    reference
    isMandatory
    subtitle
    isCustom
  }
}
    `;

/**
 * __useAdminGetPaiTableQuery__
 *
 * To run a query within a React component, call `useAdminGetPaiTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetPaiTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetPaiTableQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetPaiTableQuery(baseOptions: Apollo.QueryHookOptions<AdminGetPaiTableQuery_, AdminGetPaiTableQueryVariables_> & ({ variables: AdminGetPaiTableQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetPaiTableQuery_, AdminGetPaiTableQueryVariables_>(AdminGetPaiTableDocument_, options);
      }
export function useAdminGetPaiTableLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetPaiTableQuery_, AdminGetPaiTableQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetPaiTableQuery_, AdminGetPaiTableQueryVariables_>(AdminGetPaiTableDocument_, options);
        }
export function useAdminGetPaiTableSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetPaiTableQuery_, AdminGetPaiTableQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetPaiTableQuery_, AdminGetPaiTableQueryVariables_>(AdminGetPaiTableDocument_, options);
        }
export type AdminGetPaiTableQueryHookResult = ReturnType<typeof useAdminGetPaiTableQuery>;
export type AdminGetPaiTableLazyQuery_HookResult = ReturnType<typeof useAdminGetPaiTableLazyQuery_>;
export type AdminGetPaiTableSuspenseQuery_HookResult = ReturnType<typeof useAdminGetPaiTableSuspenseQuery_>;
export type AdminGetPaiTableQueryResult_ = Apollo.QueryResult<AdminGetPaiTableQuery_, AdminGetPaiTableQueryVariables_>;
export function refetchAdminGetPaiTableQuery_(variables: AdminGetPaiTableQueryVariables_) {
      return { query: AdminGetPaiTableDocument_, variables: variables }
    }
export const AdminDeletePaiTableDocument_ = gql`
    mutation AdminDeletePaiTable($id: String!) {
  delete_PaiTable_by_pk(reference: $id) {
    reference
  }
}
    `;
export type AdminDeletePaiTableMutationFn_ = Apollo.MutationFunction<AdminDeletePaiTableMutation_, AdminDeletePaiTableMutationVariables_>;

/**
 * __useAdminDeletePaiTableMutation__
 *
 * To run a mutation, you first call `useAdminDeletePaiTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeletePaiTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeletePaiTableMutation, { data, loading, error }] = useAdminDeletePaiTableMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeletePaiTableMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeletePaiTableMutation_, AdminDeletePaiTableMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeletePaiTableMutation_, AdminDeletePaiTableMutationVariables_>(AdminDeletePaiTableDocument_, options);
      }
export type AdminDeletePaiTableMutationHookResult = ReturnType<typeof useAdminDeletePaiTableMutation>;
export type AdminDeletePaiTableMutationResult_ = Apollo.MutationResult<AdminDeletePaiTableMutation_>;
export type AdminDeletePaiTableMutationOptions_ = Apollo.BaseMutationOptions<AdminDeletePaiTableMutation_, AdminDeletePaiTableMutationVariables_>;
export const AdminGetPaiTableIndicatorDocument_ = gql`
    query AdminGetPaiTableIndicator($reference: String!) {
  PaiTableIndicator_by_pk(reference: $reference) {
    title
    reference
    categoryReference
    description
    isHidden
    order
  }
}
    `;

/**
 * __useAdminGetPaiTableIndicatorQuery__
 *
 * To run a query within a React component, call `useAdminGetPaiTableIndicatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetPaiTableIndicatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetPaiTableIndicatorQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetPaiTableIndicatorQuery(baseOptions: Apollo.QueryHookOptions<AdminGetPaiTableIndicatorQuery_, AdminGetPaiTableIndicatorQueryVariables_> & ({ variables: AdminGetPaiTableIndicatorQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetPaiTableIndicatorQuery_, AdminGetPaiTableIndicatorQueryVariables_>(AdminGetPaiTableIndicatorDocument_, options);
      }
export function useAdminGetPaiTableIndicatorLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetPaiTableIndicatorQuery_, AdminGetPaiTableIndicatorQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetPaiTableIndicatorQuery_, AdminGetPaiTableIndicatorQueryVariables_>(AdminGetPaiTableIndicatorDocument_, options);
        }
export function useAdminGetPaiTableIndicatorSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetPaiTableIndicatorQuery_, AdminGetPaiTableIndicatorQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetPaiTableIndicatorQuery_, AdminGetPaiTableIndicatorQueryVariables_>(AdminGetPaiTableIndicatorDocument_, options);
        }
export type AdminGetPaiTableIndicatorQueryHookResult = ReturnType<typeof useAdminGetPaiTableIndicatorQuery>;
export type AdminGetPaiTableIndicatorLazyQuery_HookResult = ReturnType<typeof useAdminGetPaiTableIndicatorLazyQuery_>;
export type AdminGetPaiTableIndicatorSuspenseQuery_HookResult = ReturnType<typeof useAdminGetPaiTableIndicatorSuspenseQuery_>;
export type AdminGetPaiTableIndicatorQueryResult_ = Apollo.QueryResult<AdminGetPaiTableIndicatorQuery_, AdminGetPaiTableIndicatorQueryVariables_>;
export function refetchAdminGetPaiTableIndicatorQuery_(variables: AdminGetPaiTableIndicatorQueryVariables_) {
      return { query: AdminGetPaiTableIndicatorDocument_, variables: variables }
    }
export const AdminDeletePaiTableIndicatorDocument_ = gql`
    mutation AdminDeletePaiTableIndicator($id: String!) {
  delete_PaiTableIndicator_by_pk(reference: $id) {
    reference
  }
}
    `;
export type AdminDeletePaiTableIndicatorMutationFn_ = Apollo.MutationFunction<AdminDeletePaiTableIndicatorMutation_, AdminDeletePaiTableIndicatorMutationVariables_>;

/**
 * __useAdminDeletePaiTableIndicatorMutation__
 *
 * To run a mutation, you first call `useAdminDeletePaiTableIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeletePaiTableIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeletePaiTableIndicatorMutation, { data, loading, error }] = useAdminDeletePaiTableIndicatorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeletePaiTableIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeletePaiTableIndicatorMutation_, AdminDeletePaiTableIndicatorMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeletePaiTableIndicatorMutation_, AdminDeletePaiTableIndicatorMutationVariables_>(AdminDeletePaiTableIndicatorDocument_, options);
      }
export type AdminDeletePaiTableIndicatorMutationHookResult = ReturnType<typeof useAdminDeletePaiTableIndicatorMutation>;
export type AdminDeletePaiTableIndicatorMutationResult_ = Apollo.MutationResult<AdminDeletePaiTableIndicatorMutation_>;
export type AdminDeletePaiTableIndicatorMutationOptions_ = Apollo.BaseMutationOptions<AdminDeletePaiTableIndicatorMutation_, AdminDeletePaiTableIndicatorMutationVariables_>;
export const AdminGetInvestorMetricDocument_ = gql`
    query AdminGetInvestorMetric($reference: String!) {
  InvestorMetric_by_pk(reference: $reference) {
    title
    reference
    description
    methodology
    unit
    isAggregatable
  }
}
    `;

/**
 * __useAdminGetInvestorMetricQuery__
 *
 * To run a query within a React component, call `useAdminGetInvestorMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetInvestorMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetInvestorMetricQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetInvestorMetricQuery(baseOptions: Apollo.QueryHookOptions<AdminGetInvestorMetricQuery_, AdminGetInvestorMetricQueryVariables_> & ({ variables: AdminGetInvestorMetricQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetInvestorMetricQuery_, AdminGetInvestorMetricQueryVariables_>(AdminGetInvestorMetricDocument_, options);
      }
export function useAdminGetInvestorMetricLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetInvestorMetricQuery_, AdminGetInvestorMetricQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetInvestorMetricQuery_, AdminGetInvestorMetricQueryVariables_>(AdminGetInvestorMetricDocument_, options);
        }
export function useAdminGetInvestorMetricSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetInvestorMetricQuery_, AdminGetInvestorMetricQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetInvestorMetricQuery_, AdminGetInvestorMetricQueryVariables_>(AdminGetInvestorMetricDocument_, options);
        }
export type AdminGetInvestorMetricQueryHookResult = ReturnType<typeof useAdminGetInvestorMetricQuery>;
export type AdminGetInvestorMetricLazyQuery_HookResult = ReturnType<typeof useAdminGetInvestorMetricLazyQuery_>;
export type AdminGetInvestorMetricSuspenseQuery_HookResult = ReturnType<typeof useAdminGetInvestorMetricSuspenseQuery_>;
export type AdminGetInvestorMetricQueryResult_ = Apollo.QueryResult<AdminGetInvestorMetricQuery_, AdminGetInvestorMetricQueryVariables_>;
export function refetchAdminGetInvestorMetricQuery_(variables: AdminGetInvestorMetricQueryVariables_) {
      return { query: AdminGetInvestorMetricDocument_, variables: variables }
    }
export const AdminDeleteInvestorMetricDocument_ = gql`
    mutation AdminDeleteInvestorMetric($id: String!) {
  delete_InvestorMetric_by_pk(reference: $id) {
    reference
  }
}
    `;
export type AdminDeleteInvestorMetricMutationFn_ = Apollo.MutationFunction<AdminDeleteInvestorMetricMutation_, AdminDeleteInvestorMetricMutationVariables_>;

/**
 * __useAdminDeleteInvestorMetricMutation__
 *
 * To run a mutation, you first call `useAdminDeleteInvestorMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteInvestorMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteInvestorMetricMutation, { data, loading, error }] = useAdminDeleteInvestorMetricMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteInvestorMetricMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteInvestorMetricMutation_, AdminDeleteInvestorMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteInvestorMetricMutation_, AdminDeleteInvestorMetricMutationVariables_>(AdminDeleteInvestorMetricDocument_, options);
      }
export type AdminDeleteInvestorMetricMutationHookResult = ReturnType<typeof useAdminDeleteInvestorMetricMutation>;
export type AdminDeleteInvestorMetricMutationResult_ = Apollo.MutationResult<AdminDeleteInvestorMetricMutation_>;
export type AdminDeleteInvestorMetricMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteInvestorMetricMutation_, AdminDeleteInvestorMetricMutationVariables_>;
export const AdminGetInvesteeMetricDocument_ = gql`
    query AdminGetInvesteeMetric($reference: String!) {
  InvesteeMetric_by_pk(reference: $reference) {
    title
    reference
    methodology
    description
    dependencies
    additionalResources
    type
    unit
    order
  }
}
    `;

/**
 * __useAdminGetInvesteeMetricQuery__
 *
 * To run a query within a React component, call `useAdminGetInvesteeMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetInvesteeMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetInvesteeMetricQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetInvesteeMetricQuery(baseOptions: Apollo.QueryHookOptions<AdminGetInvesteeMetricQuery_, AdminGetInvesteeMetricQueryVariables_> & ({ variables: AdminGetInvesteeMetricQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetInvesteeMetricQuery_, AdminGetInvesteeMetricQueryVariables_>(AdminGetInvesteeMetricDocument_, options);
      }
export function useAdminGetInvesteeMetricLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetInvesteeMetricQuery_, AdminGetInvesteeMetricQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetInvesteeMetricQuery_, AdminGetInvesteeMetricQueryVariables_>(AdminGetInvesteeMetricDocument_, options);
        }
export function useAdminGetInvesteeMetricSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetInvesteeMetricQuery_, AdminGetInvesteeMetricQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetInvesteeMetricQuery_, AdminGetInvesteeMetricQueryVariables_>(AdminGetInvesteeMetricDocument_, options);
        }
export type AdminGetInvesteeMetricQueryHookResult = ReturnType<typeof useAdminGetInvesteeMetricQuery>;
export type AdminGetInvesteeMetricLazyQuery_HookResult = ReturnType<typeof useAdminGetInvesteeMetricLazyQuery_>;
export type AdminGetInvesteeMetricSuspenseQuery_HookResult = ReturnType<typeof useAdminGetInvesteeMetricSuspenseQuery_>;
export type AdminGetInvesteeMetricQueryResult_ = Apollo.QueryResult<AdminGetInvesteeMetricQuery_, AdminGetInvesteeMetricQueryVariables_>;
export function refetchAdminGetInvesteeMetricQuery_(variables: AdminGetInvesteeMetricQueryVariables_) {
      return { query: AdminGetInvesteeMetricDocument_, variables: variables }
    }
export const AdminDeleteInvesteeMetricDocument_ = gql`
    mutation AdminDeleteInvesteeMetric($id: String!) {
  delete_InvesteeMetric_by_pk(reference: $id) {
    reference
  }
}
    `;
export type AdminDeleteInvesteeMetricMutationFn_ = Apollo.MutationFunction<AdminDeleteInvesteeMetricMutation_, AdminDeleteInvesteeMetricMutationVariables_>;

/**
 * __useAdminDeleteInvesteeMetricMutation__
 *
 * To run a mutation, you first call `useAdminDeleteInvesteeMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteInvesteeMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteInvesteeMetricMutation, { data, loading, error }] = useAdminDeleteInvesteeMetricMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteInvesteeMetricMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteInvesteeMetricMutation_, AdminDeleteInvesteeMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteInvesteeMetricMutation_, AdminDeleteInvesteeMetricMutationVariables_>(AdminDeleteInvesteeMetricDocument_, options);
      }
export type AdminDeleteInvesteeMetricMutationHookResult = ReturnType<typeof useAdminDeleteInvesteeMetricMutation>;
export type AdminDeleteInvesteeMetricMutationResult_ = Apollo.MutationResult<AdminDeleteInvesteeMetricMutation_>;
export type AdminDeleteInvesteeMetricMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteInvesteeMetricMutation_, AdminDeleteInvesteeMetricMutationVariables_>;
export const AdminGetIndicatorToInvestorMetricDocument_ = gql`
    query AdminGetIndicatorToInvestorMetric($investorMetricRef: String!, $indicatorRef: String!) {
  IndicatorToInvestorMetric_by_pk(
    investorMetricRef: $investorMetricRef
    indicatorRef: $indicatorRef
  ) {
    investorMetricRef
    indicatorRef
  }
}
    `;

/**
 * __useAdminGetIndicatorToInvestorMetricQuery__
 *
 * To run a query within a React component, call `useAdminGetIndicatorToInvestorMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetIndicatorToInvestorMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetIndicatorToInvestorMetricQuery({
 *   variables: {
 *      investorMetricRef: // value for 'investorMetricRef'
 *      indicatorRef: // value for 'indicatorRef'
 *   },
 * });
 */
export function useAdminGetIndicatorToInvestorMetricQuery(baseOptions: Apollo.QueryHookOptions<AdminGetIndicatorToInvestorMetricQuery_, AdminGetIndicatorToInvestorMetricQueryVariables_> & ({ variables: AdminGetIndicatorToInvestorMetricQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetIndicatorToInvestorMetricQuery_, AdminGetIndicatorToInvestorMetricQueryVariables_>(AdminGetIndicatorToInvestorMetricDocument_, options);
      }
export function useAdminGetIndicatorToInvestorMetricLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetIndicatorToInvestorMetricQuery_, AdminGetIndicatorToInvestorMetricQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetIndicatorToInvestorMetricQuery_, AdminGetIndicatorToInvestorMetricQueryVariables_>(AdminGetIndicatorToInvestorMetricDocument_, options);
        }
export function useAdminGetIndicatorToInvestorMetricSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetIndicatorToInvestorMetricQuery_, AdminGetIndicatorToInvestorMetricQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetIndicatorToInvestorMetricQuery_, AdminGetIndicatorToInvestorMetricQueryVariables_>(AdminGetIndicatorToInvestorMetricDocument_, options);
        }
export type AdminGetIndicatorToInvestorMetricQueryHookResult = ReturnType<typeof useAdminGetIndicatorToInvestorMetricQuery>;
export type AdminGetIndicatorToInvestorMetricLazyQuery_HookResult = ReturnType<typeof useAdminGetIndicatorToInvestorMetricLazyQuery_>;
export type AdminGetIndicatorToInvestorMetricSuspenseQuery_HookResult = ReturnType<typeof useAdminGetIndicatorToInvestorMetricSuspenseQuery_>;
export type AdminGetIndicatorToInvestorMetricQueryResult_ = Apollo.QueryResult<AdminGetIndicatorToInvestorMetricQuery_, AdminGetIndicatorToInvestorMetricQueryVariables_>;
export function refetchAdminGetIndicatorToInvestorMetricQuery_(variables: AdminGetIndicatorToInvestorMetricQueryVariables_) {
      return { query: AdminGetIndicatorToInvestorMetricDocument_, variables: variables }
    }
export const AdminGetInvestorToInvesteeMetricDocument_ = gql`
    query AdminGetInvestorToInvesteeMetric($investorMetricReference: String!, $investeeMetricReference: String!) {
  InvestorToInvesteeMetric_by_pk(
    investorMetricReference: $investorMetricReference
    investeeMetricReference: $investeeMetricReference
  ) {
    investeeMetricReference
    investorMetricReference
  }
}
    `;

/**
 * __useAdminGetInvestorToInvesteeMetricQuery__
 *
 * To run a query within a React component, call `useAdminGetInvestorToInvesteeMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetInvestorToInvesteeMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetInvestorToInvesteeMetricQuery({
 *   variables: {
 *      investorMetricReference: // value for 'investorMetricReference'
 *      investeeMetricReference: // value for 'investeeMetricReference'
 *   },
 * });
 */
export function useAdminGetInvestorToInvesteeMetricQuery(baseOptions: Apollo.QueryHookOptions<AdminGetInvestorToInvesteeMetricQuery_, AdminGetInvestorToInvesteeMetricQueryVariables_> & ({ variables: AdminGetInvestorToInvesteeMetricQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetInvestorToInvesteeMetricQuery_, AdminGetInvestorToInvesteeMetricQueryVariables_>(AdminGetInvestorToInvesteeMetricDocument_, options);
      }
export function useAdminGetInvestorToInvesteeMetricLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetInvestorToInvesteeMetricQuery_, AdminGetInvestorToInvesteeMetricQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetInvestorToInvesteeMetricQuery_, AdminGetInvestorToInvesteeMetricQueryVariables_>(AdminGetInvestorToInvesteeMetricDocument_, options);
        }
export function useAdminGetInvestorToInvesteeMetricSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetInvestorToInvesteeMetricQuery_, AdminGetInvestorToInvesteeMetricQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetInvestorToInvesteeMetricQuery_, AdminGetInvestorToInvesteeMetricQueryVariables_>(AdminGetInvestorToInvesteeMetricDocument_, options);
        }
export type AdminGetInvestorToInvesteeMetricQueryHookResult = ReturnType<typeof useAdminGetInvestorToInvesteeMetricQuery>;
export type AdminGetInvestorToInvesteeMetricLazyQuery_HookResult = ReturnType<typeof useAdminGetInvestorToInvesteeMetricLazyQuery_>;
export type AdminGetInvestorToInvesteeMetricSuspenseQuery_HookResult = ReturnType<typeof useAdminGetInvestorToInvesteeMetricSuspenseQuery_>;
export type AdminGetInvestorToInvesteeMetricQueryResult_ = Apollo.QueryResult<AdminGetInvestorToInvesteeMetricQuery_, AdminGetInvestorToInvesteeMetricQueryVariables_>;
export function refetchAdminGetInvestorToInvesteeMetricQuery_(variables: AdminGetInvestorToInvesteeMetricQueryVariables_) {
      return { query: AdminGetInvestorToInvesteeMetricDocument_, variables: variables }
    }
export const AdminGetEsrsCategoryDocument_ = gql`
    query AdminGetEsrsCategory($reference: String!) {
  EsrsCategory_by_pk(reference: $reference) {
    title
    reference
  }
}
    `;

/**
 * __useAdminGetEsrsCategoryQuery__
 *
 * To run a query within a React component, call `useAdminGetEsrsCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetEsrsCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetEsrsCategoryQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetEsrsCategoryQuery(baseOptions: Apollo.QueryHookOptions<AdminGetEsrsCategoryQuery_, AdminGetEsrsCategoryQueryVariables_> & ({ variables: AdminGetEsrsCategoryQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetEsrsCategoryQuery_, AdminGetEsrsCategoryQueryVariables_>(AdminGetEsrsCategoryDocument_, options);
      }
export function useAdminGetEsrsCategoryLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetEsrsCategoryQuery_, AdminGetEsrsCategoryQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetEsrsCategoryQuery_, AdminGetEsrsCategoryQueryVariables_>(AdminGetEsrsCategoryDocument_, options);
        }
export function useAdminGetEsrsCategorySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetEsrsCategoryQuery_, AdminGetEsrsCategoryQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetEsrsCategoryQuery_, AdminGetEsrsCategoryQueryVariables_>(AdminGetEsrsCategoryDocument_, options);
        }
export type AdminGetEsrsCategoryQueryHookResult = ReturnType<typeof useAdminGetEsrsCategoryQuery>;
export type AdminGetEsrsCategoryLazyQuery_HookResult = ReturnType<typeof useAdminGetEsrsCategoryLazyQuery_>;
export type AdminGetEsrsCategorySuspenseQuery_HookResult = ReturnType<typeof useAdminGetEsrsCategorySuspenseQuery_>;
export type AdminGetEsrsCategoryQueryResult_ = Apollo.QueryResult<AdminGetEsrsCategoryQuery_, AdminGetEsrsCategoryQueryVariables_>;
export function refetchAdminGetEsrsCategoryQuery_(variables: AdminGetEsrsCategoryQueryVariables_) {
      return { query: AdminGetEsrsCategoryDocument_, variables: variables }
    }
export const AdminGetEsrsAssessmentDocument_ = gql`
    query AdminGetEsrsAssessment($id: uuid!) {
  EsrsAssessment_by_pk(id: $id) {
    id
    reportingYear
    companyId
    subsidiaryAssessments {
      id
      reportingYear
      company {
        name
      }
    }
  }
}
    `;

/**
 * __useAdminGetEsrsAssessmentQuery__
 *
 * To run a query within a React component, call `useAdminGetEsrsAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetEsrsAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetEsrsAssessmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetEsrsAssessmentQuery(baseOptions: Apollo.QueryHookOptions<AdminGetEsrsAssessmentQuery_, AdminGetEsrsAssessmentQueryVariables_> & ({ variables: AdminGetEsrsAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetEsrsAssessmentQuery_, AdminGetEsrsAssessmentQueryVariables_>(AdminGetEsrsAssessmentDocument_, options);
      }
export function useAdminGetEsrsAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetEsrsAssessmentQuery_, AdminGetEsrsAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetEsrsAssessmentQuery_, AdminGetEsrsAssessmentQueryVariables_>(AdminGetEsrsAssessmentDocument_, options);
        }
export function useAdminGetEsrsAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetEsrsAssessmentQuery_, AdminGetEsrsAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetEsrsAssessmentQuery_, AdminGetEsrsAssessmentQueryVariables_>(AdminGetEsrsAssessmentDocument_, options);
        }
export type AdminGetEsrsAssessmentQueryHookResult = ReturnType<typeof useAdminGetEsrsAssessmentQuery>;
export type AdminGetEsrsAssessmentLazyQuery_HookResult = ReturnType<typeof useAdminGetEsrsAssessmentLazyQuery_>;
export type AdminGetEsrsAssessmentSuspenseQuery_HookResult = ReturnType<typeof useAdminGetEsrsAssessmentSuspenseQuery_>;
export type AdminGetEsrsAssessmentQueryResult_ = Apollo.QueryResult<AdminGetEsrsAssessmentQuery_, AdminGetEsrsAssessmentQueryVariables_>;
export function refetchAdminGetEsrsAssessmentQuery_(variables: AdminGetEsrsAssessmentQueryVariables_) {
      return { query: AdminGetEsrsAssessmentDocument_, variables: variables }
    }
export const AdminDeleteEsrsCategoryDocument_ = gql`
    mutation AdminDeleteEsrsCategory($reference: String!) {
  delete_EsrsCategory_by_pk(reference: $reference) {
    reference
  }
}
    `;
export type AdminDeleteEsrsCategoryMutationFn_ = Apollo.MutationFunction<AdminDeleteEsrsCategoryMutation_, AdminDeleteEsrsCategoryMutationVariables_>;

/**
 * __useAdminDeleteEsrsCategoryMutation__
 *
 * To run a mutation, you first call `useAdminDeleteEsrsCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteEsrsCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteEsrsCategoryMutation, { data, loading, error }] = useAdminDeleteEsrsCategoryMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteEsrsCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteEsrsCategoryMutation_, AdminDeleteEsrsCategoryMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteEsrsCategoryMutation_, AdminDeleteEsrsCategoryMutationVariables_>(AdminDeleteEsrsCategoryDocument_, options);
      }
export type AdminDeleteEsrsCategoryMutationHookResult = ReturnType<typeof useAdminDeleteEsrsCategoryMutation>;
export type AdminDeleteEsrsCategoryMutationResult_ = Apollo.MutationResult<AdminDeleteEsrsCategoryMutation_>;
export type AdminDeleteEsrsCategoryMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteEsrsCategoryMutation_, AdminDeleteEsrsCategoryMutationVariables_>;
export const AdminGetEsrsStandardDocument_ = gql`
    query AdminGetEsrsStandard($reference: String!) {
  EsrsStandard_by_pk(reference: $reference) {
    title
    reference
    description
    isTopical
    categoryRef
    formattedPolicyChecklist
    aiPolicyChecklist
    frameworkRef
    order
  }
}
    `;

/**
 * __useAdminGetEsrsStandardQuery__
 *
 * To run a query within a React component, call `useAdminGetEsrsStandardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetEsrsStandardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetEsrsStandardQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetEsrsStandardQuery(baseOptions: Apollo.QueryHookOptions<AdminGetEsrsStandardQuery_, AdminGetEsrsStandardQueryVariables_> & ({ variables: AdminGetEsrsStandardQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetEsrsStandardQuery_, AdminGetEsrsStandardQueryVariables_>(AdminGetEsrsStandardDocument_, options);
      }
export function useAdminGetEsrsStandardLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetEsrsStandardQuery_, AdminGetEsrsStandardQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetEsrsStandardQuery_, AdminGetEsrsStandardQueryVariables_>(AdminGetEsrsStandardDocument_, options);
        }
export function useAdminGetEsrsStandardSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetEsrsStandardQuery_, AdminGetEsrsStandardQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetEsrsStandardQuery_, AdminGetEsrsStandardQueryVariables_>(AdminGetEsrsStandardDocument_, options);
        }
export type AdminGetEsrsStandardQueryHookResult = ReturnType<typeof useAdminGetEsrsStandardQuery>;
export type AdminGetEsrsStandardLazyQuery_HookResult = ReturnType<typeof useAdminGetEsrsStandardLazyQuery_>;
export type AdminGetEsrsStandardSuspenseQuery_HookResult = ReturnType<typeof useAdminGetEsrsStandardSuspenseQuery_>;
export type AdminGetEsrsStandardQueryResult_ = Apollo.QueryResult<AdminGetEsrsStandardQuery_, AdminGetEsrsStandardQueryVariables_>;
export function refetchAdminGetEsrsStandardQuery_(variables: AdminGetEsrsStandardQueryVariables_) {
      return { query: AdminGetEsrsStandardDocument_, variables: variables }
    }
export const AdminDeleteEsrsStandardDocument_ = gql`
    mutation AdminDeleteEsrsStandard($reference: String!) {
  delete_EsrsStandard_by_pk(reference: $reference) {
    reference
  }
}
    `;
export type AdminDeleteEsrsStandardMutationFn_ = Apollo.MutationFunction<AdminDeleteEsrsStandardMutation_, AdminDeleteEsrsStandardMutationVariables_>;

/**
 * __useAdminDeleteEsrsStandardMutation__
 *
 * To run a mutation, you first call `useAdminDeleteEsrsStandardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteEsrsStandardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteEsrsStandardMutation, { data, loading, error }] = useAdminDeleteEsrsStandardMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteEsrsStandardMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteEsrsStandardMutation_, AdminDeleteEsrsStandardMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteEsrsStandardMutation_, AdminDeleteEsrsStandardMutationVariables_>(AdminDeleteEsrsStandardDocument_, options);
      }
export type AdminDeleteEsrsStandardMutationHookResult = ReturnType<typeof useAdminDeleteEsrsStandardMutation>;
export type AdminDeleteEsrsStandardMutationResult_ = Apollo.MutationResult<AdminDeleteEsrsStandardMutation_>;
export type AdminDeleteEsrsStandardMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteEsrsStandardMutation_, AdminDeleteEsrsStandardMutationVariables_>;
export const AdminGetDisclosureRequirementGroupDocument_ = gql`
    query AdminGetDisclosureRequirementGroup($reference: String!) {
  DisclosureRequirementGroup_by_pk(reference: $reference) {
    title
    reference
    standardRef
    order
  }
}
    `;

/**
 * __useAdminGetDisclosureRequirementGroupQuery__
 *
 * To run a query within a React component, call `useAdminGetDisclosureRequirementGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetDisclosureRequirementGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetDisclosureRequirementGroupQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetDisclosureRequirementGroupQuery(baseOptions: Apollo.QueryHookOptions<AdminGetDisclosureRequirementGroupQuery_, AdminGetDisclosureRequirementGroupQueryVariables_> & ({ variables: AdminGetDisclosureRequirementGroupQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetDisclosureRequirementGroupQuery_, AdminGetDisclosureRequirementGroupQueryVariables_>(AdminGetDisclosureRequirementGroupDocument_, options);
      }
export function useAdminGetDisclosureRequirementGroupLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetDisclosureRequirementGroupQuery_, AdminGetDisclosureRequirementGroupQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetDisclosureRequirementGroupQuery_, AdminGetDisclosureRequirementGroupQueryVariables_>(AdminGetDisclosureRequirementGroupDocument_, options);
        }
export function useAdminGetDisclosureRequirementGroupSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetDisclosureRequirementGroupQuery_, AdminGetDisclosureRequirementGroupQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetDisclosureRequirementGroupQuery_, AdminGetDisclosureRequirementGroupQueryVariables_>(AdminGetDisclosureRequirementGroupDocument_, options);
        }
export type AdminGetDisclosureRequirementGroupQueryHookResult = ReturnType<typeof useAdminGetDisclosureRequirementGroupQuery>;
export type AdminGetDisclosureRequirementGroupLazyQuery_HookResult = ReturnType<typeof useAdminGetDisclosureRequirementGroupLazyQuery_>;
export type AdminGetDisclosureRequirementGroupSuspenseQuery_HookResult = ReturnType<typeof useAdminGetDisclosureRequirementGroupSuspenseQuery_>;
export type AdminGetDisclosureRequirementGroupQueryResult_ = Apollo.QueryResult<AdminGetDisclosureRequirementGroupQuery_, AdminGetDisclosureRequirementGroupQueryVariables_>;
export function refetchAdminGetDisclosureRequirementGroupQuery_(variables: AdminGetDisclosureRequirementGroupQueryVariables_) {
      return { query: AdminGetDisclosureRequirementGroupDocument_, variables: variables }
    }
export const AdminDeleteDisclosureRequirementGroupDocument_ = gql`
    mutation AdminDeleteDisclosureRequirementGroup($reference: String!) {
  delete_DisclosureRequirementGroup_by_pk(reference: $reference) {
    reference
  }
}
    `;
export type AdminDeleteDisclosureRequirementGroupMutationFn_ = Apollo.MutationFunction<AdminDeleteDisclosureRequirementGroupMutation_, AdminDeleteDisclosureRequirementGroupMutationVariables_>;

/**
 * __useAdminDeleteDisclosureRequirementGroupMutation__
 *
 * To run a mutation, you first call `useAdminDeleteDisclosureRequirementGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteDisclosureRequirementGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteDisclosureRequirementGroupMutation, { data, loading, error }] = useAdminDeleteDisclosureRequirementGroupMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteDisclosureRequirementGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteDisclosureRequirementGroupMutation_, AdminDeleteDisclosureRequirementGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteDisclosureRequirementGroupMutation_, AdminDeleteDisclosureRequirementGroupMutationVariables_>(AdminDeleteDisclosureRequirementGroupDocument_, options);
      }
export type AdminDeleteDisclosureRequirementGroupMutationHookResult = ReturnType<typeof useAdminDeleteDisclosureRequirementGroupMutation>;
export type AdminDeleteDisclosureRequirementGroupMutationResult_ = Apollo.MutationResult<AdminDeleteDisclosureRequirementGroupMutation_>;
export type AdminDeleteDisclosureRequirementGroupMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteDisclosureRequirementGroupMutation_, AdminDeleteDisclosureRequirementGroupMutationVariables_>;
export const AdminGetDisclosureRequirementDocument_ = gql`
    query AdminGetDisclosureRequirement($reference: String!) {
  DisclosureRequirement_by_pk(reference: $reference) {
    title
    shortTitle
    reference
    groupRef
    type
    order
    description
    isMandatory
  }
}
    `;

/**
 * __useAdminGetDisclosureRequirementQuery__
 *
 * To run a query within a React component, call `useAdminGetDisclosureRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetDisclosureRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetDisclosureRequirementQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetDisclosureRequirementQuery(baseOptions: Apollo.QueryHookOptions<AdminGetDisclosureRequirementQuery_, AdminGetDisclosureRequirementQueryVariables_> & ({ variables: AdminGetDisclosureRequirementQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetDisclosureRequirementQuery_, AdminGetDisclosureRequirementQueryVariables_>(AdminGetDisclosureRequirementDocument_, options);
      }
export function useAdminGetDisclosureRequirementLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetDisclosureRequirementQuery_, AdminGetDisclosureRequirementQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetDisclosureRequirementQuery_, AdminGetDisclosureRequirementQueryVariables_>(AdminGetDisclosureRequirementDocument_, options);
        }
export function useAdminGetDisclosureRequirementSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetDisclosureRequirementQuery_, AdminGetDisclosureRequirementQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetDisclosureRequirementQuery_, AdminGetDisclosureRequirementQueryVariables_>(AdminGetDisclosureRequirementDocument_, options);
        }
export type AdminGetDisclosureRequirementQueryHookResult = ReturnType<typeof useAdminGetDisclosureRequirementQuery>;
export type AdminGetDisclosureRequirementLazyQuery_HookResult = ReturnType<typeof useAdminGetDisclosureRequirementLazyQuery_>;
export type AdminGetDisclosureRequirementSuspenseQuery_HookResult = ReturnType<typeof useAdminGetDisclosureRequirementSuspenseQuery_>;
export type AdminGetDisclosureRequirementQueryResult_ = Apollo.QueryResult<AdminGetDisclosureRequirementQuery_, AdminGetDisclosureRequirementQueryVariables_>;
export function refetchAdminGetDisclosureRequirementQuery_(variables: AdminGetDisclosureRequirementQueryVariables_) {
      return { query: AdminGetDisclosureRequirementDocument_, variables: variables }
    }
export const AdminDeleteDisclosureRequirementDocument_ = gql`
    mutation AdminDeleteDisclosureRequirement($reference: String!) {
  delete_DisclosureRequirement_by_pk(reference: $reference) {
    reference
  }
}
    `;
export type AdminDeleteDisclosureRequirementMutationFn_ = Apollo.MutationFunction<AdminDeleteDisclosureRequirementMutation_, AdminDeleteDisclosureRequirementMutationVariables_>;

/**
 * __useAdminDeleteDisclosureRequirementMutation__
 *
 * To run a mutation, you first call `useAdminDeleteDisclosureRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteDisclosureRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteDisclosureRequirementMutation, { data, loading, error }] = useAdminDeleteDisclosureRequirementMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteDisclosureRequirementMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteDisclosureRequirementMutation_, AdminDeleteDisclosureRequirementMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteDisclosureRequirementMutation_, AdminDeleteDisclosureRequirementMutationVariables_>(AdminDeleteDisclosureRequirementDocument_, options);
      }
export type AdminDeleteDisclosureRequirementMutationHookResult = ReturnType<typeof useAdminDeleteDisclosureRequirementMutation>;
export type AdminDeleteDisclosureRequirementMutationResult_ = Apollo.MutationResult<AdminDeleteDisclosureRequirementMutation_>;
export type AdminDeleteDisclosureRequirementMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteDisclosureRequirementMutation_, AdminDeleteDisclosureRequirementMutationVariables_>;
export const AdminGetEsrsMetricDocument_ = gql`
    query AdminGetEsrsMetric($reference: String!) {
  EsrsMetric_by_pk(reference: $reference) {
    title
    shortTitle
    reference
    description
    calculation
    disclosureRequirementRef
    metricType
    unitOfMeasurement
    isAssessable
    firstLevel
    secondLevel
    order
    isGroup
    showAsPercentage
    isAR
    globalOrder
    hasAssociation
    canBeUsedForTarget
    showPercentageWithTag
    unlockCondition
    choiceSetRef
    notAggregatable
    abbreviation
  }
}
    `;

/**
 * __useAdminGetEsrsMetricQuery__
 *
 * To run a query within a React component, call `useAdminGetEsrsMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetEsrsMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetEsrsMetricQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetEsrsMetricQuery(baseOptions: Apollo.QueryHookOptions<AdminGetEsrsMetricQuery_, AdminGetEsrsMetricQueryVariables_> & ({ variables: AdminGetEsrsMetricQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetEsrsMetricQuery_, AdminGetEsrsMetricQueryVariables_>(AdminGetEsrsMetricDocument_, options);
      }
export function useAdminGetEsrsMetricLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetEsrsMetricQuery_, AdminGetEsrsMetricQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetEsrsMetricQuery_, AdminGetEsrsMetricQueryVariables_>(AdminGetEsrsMetricDocument_, options);
        }
export function useAdminGetEsrsMetricSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetEsrsMetricQuery_, AdminGetEsrsMetricQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetEsrsMetricQuery_, AdminGetEsrsMetricQueryVariables_>(AdminGetEsrsMetricDocument_, options);
        }
export type AdminGetEsrsMetricQueryHookResult = ReturnType<typeof useAdminGetEsrsMetricQuery>;
export type AdminGetEsrsMetricLazyQuery_HookResult = ReturnType<typeof useAdminGetEsrsMetricLazyQuery_>;
export type AdminGetEsrsMetricSuspenseQuery_HookResult = ReturnType<typeof useAdminGetEsrsMetricSuspenseQuery_>;
export type AdminGetEsrsMetricQueryResult_ = Apollo.QueryResult<AdminGetEsrsMetricQuery_, AdminGetEsrsMetricQueryVariables_>;
export function refetchAdminGetEsrsMetricQuery_(variables: AdminGetEsrsMetricQueryVariables_) {
      return { query: AdminGetEsrsMetricDocument_, variables: variables }
    }
export const AdminDeleteEsrsMetricDocument_ = gql`
    mutation AdminDeleteEsrsMetric($reference: String!) {
  delete_EsrsMetric_by_pk(reference: $reference) {
    reference
  }
}
    `;
export type AdminDeleteEsrsMetricMutationFn_ = Apollo.MutationFunction<AdminDeleteEsrsMetricMutation_, AdminDeleteEsrsMetricMutationVariables_>;

/**
 * __useAdminDeleteEsrsMetricMutation__
 *
 * To run a mutation, you first call `useAdminDeleteEsrsMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteEsrsMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteEsrsMetricMutation, { data, loading, error }] = useAdminDeleteEsrsMetricMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteEsrsMetricMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteEsrsMetricMutation_, AdminDeleteEsrsMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteEsrsMetricMutation_, AdminDeleteEsrsMetricMutationVariables_>(AdminDeleteEsrsMetricDocument_, options);
      }
export type AdminDeleteEsrsMetricMutationHookResult = ReturnType<typeof useAdminDeleteEsrsMetricMutation>;
export type AdminDeleteEsrsMetricMutationResult_ = Apollo.MutationResult<AdminDeleteEsrsMetricMutation_>;
export type AdminDeleteEsrsMetricMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteEsrsMetricMutation_, AdminDeleteEsrsMetricMutationVariables_>;
export const AdminGetTagTypeDocument_ = gql`
    query AdminGetTagType($type: String!) {
  TagType_by_pk(type: $type) {
    type
    alwaysAll
  }
}
    `;

/**
 * __useAdminGetTagTypeQuery__
 *
 * To run a query within a React component, call `useAdminGetTagTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetTagTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetTagTypeQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAdminGetTagTypeQuery(baseOptions: Apollo.QueryHookOptions<AdminGetTagTypeQuery_, AdminGetTagTypeQueryVariables_> & ({ variables: AdminGetTagTypeQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetTagTypeQuery_, AdminGetTagTypeQueryVariables_>(AdminGetTagTypeDocument_, options);
      }
export function useAdminGetTagTypeLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetTagTypeQuery_, AdminGetTagTypeQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetTagTypeQuery_, AdminGetTagTypeQueryVariables_>(AdminGetTagTypeDocument_, options);
        }
export function useAdminGetTagTypeSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetTagTypeQuery_, AdminGetTagTypeQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetTagTypeQuery_, AdminGetTagTypeQueryVariables_>(AdminGetTagTypeDocument_, options);
        }
export type AdminGetTagTypeQueryHookResult = ReturnType<typeof useAdminGetTagTypeQuery>;
export type AdminGetTagTypeLazyQuery_HookResult = ReturnType<typeof useAdminGetTagTypeLazyQuery_>;
export type AdminGetTagTypeSuspenseQuery_HookResult = ReturnType<typeof useAdminGetTagTypeSuspenseQuery_>;
export type AdminGetTagTypeQueryResult_ = Apollo.QueryResult<AdminGetTagTypeQuery_, AdminGetTagTypeQueryVariables_>;
export function refetchAdminGetTagTypeQuery_(variables: AdminGetTagTypeQueryVariables_) {
      return { query: AdminGetTagTypeDocument_, variables: variables }
    }
export const AdminDeleteTagTypeDocument_ = gql`
    mutation AdminDeleteTagType($type: String!) {
  delete_TagType_by_pk(type: $type) {
    type
  }
}
    `;
export type AdminDeleteTagTypeMutationFn_ = Apollo.MutationFunction<AdminDeleteTagTypeMutation_, AdminDeleteTagTypeMutationVariables_>;

/**
 * __useAdminDeleteTagTypeMutation__
 *
 * To run a mutation, you first call `useAdminDeleteTagTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteTagTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteTagTypeMutation, { data, loading, error }] = useAdminDeleteTagTypeMutation({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAdminDeleteTagTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteTagTypeMutation_, AdminDeleteTagTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteTagTypeMutation_, AdminDeleteTagTypeMutationVariables_>(AdminDeleteTagTypeDocument_, options);
      }
export type AdminDeleteTagTypeMutationHookResult = ReturnType<typeof useAdminDeleteTagTypeMutation>;
export type AdminDeleteTagTypeMutationResult_ = Apollo.MutationResult<AdminDeleteTagTypeMutation_>;
export type AdminDeleteTagTypeMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteTagTypeMutation_, AdminDeleteTagTypeMutationVariables_>;
export const AdminGetTagValueDocument_ = gql`
    query AdminGetTagValue($type: String!, $value: String!) {
  TagValue_by_pk(type: $type, value: $value) {
    value
    type
    order
  }
}
    `;

/**
 * __useAdminGetTagValueQuery__
 *
 * To run a query within a React component, call `useAdminGetTagValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetTagValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetTagValueQuery({
 *   variables: {
 *      type: // value for 'type'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useAdminGetTagValueQuery(baseOptions: Apollo.QueryHookOptions<AdminGetTagValueQuery_, AdminGetTagValueQueryVariables_> & ({ variables: AdminGetTagValueQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetTagValueQuery_, AdminGetTagValueQueryVariables_>(AdminGetTagValueDocument_, options);
      }
export function useAdminGetTagValueLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetTagValueQuery_, AdminGetTagValueQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetTagValueQuery_, AdminGetTagValueQueryVariables_>(AdminGetTagValueDocument_, options);
        }
export function useAdminGetTagValueSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetTagValueQuery_, AdminGetTagValueQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetTagValueQuery_, AdminGetTagValueQueryVariables_>(AdminGetTagValueDocument_, options);
        }
export type AdminGetTagValueQueryHookResult = ReturnType<typeof useAdminGetTagValueQuery>;
export type AdminGetTagValueLazyQuery_HookResult = ReturnType<typeof useAdminGetTagValueLazyQuery_>;
export type AdminGetTagValueSuspenseQuery_HookResult = ReturnType<typeof useAdminGetTagValueSuspenseQuery_>;
export type AdminGetTagValueQueryResult_ = Apollo.QueryResult<AdminGetTagValueQuery_, AdminGetTagValueQueryVariables_>;
export function refetchAdminGetTagValueQuery_(variables: AdminGetTagValueQueryVariables_) {
      return { query: AdminGetTagValueDocument_, variables: variables }
    }
export const AdminDeleteTagValueDocument_ = gql`
    mutation AdminDeleteTagValue($type: String!, $value: String!) {
  delete_TagValue_by_pk(type: $type, value: $value) {
    value
    type
    order
  }
}
    `;
export type AdminDeleteTagValueMutationFn_ = Apollo.MutationFunction<AdminDeleteTagValueMutation_, AdminDeleteTagValueMutationVariables_>;

/**
 * __useAdminDeleteTagValueMutation__
 *
 * To run a mutation, you first call `useAdminDeleteTagValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteTagValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteTagValueMutation, { data, loading, error }] = useAdminDeleteTagValueMutation({
 *   variables: {
 *      type: // value for 'type'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useAdminDeleteTagValueMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteTagValueMutation_, AdminDeleteTagValueMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteTagValueMutation_, AdminDeleteTagValueMutationVariables_>(AdminDeleteTagValueDocument_, options);
      }
export type AdminDeleteTagValueMutationHookResult = ReturnType<typeof useAdminDeleteTagValueMutation>;
export type AdminDeleteTagValueMutationResult_ = Apollo.MutationResult<AdminDeleteTagValueMutation_>;
export type AdminDeleteTagValueMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteTagValueMutation_, AdminDeleteTagValueMutationVariables_>;
export const AdminGetAdditionalTypeDocument_ = gql`
    query AdminGetAdditionalType($reference: String!) {
  AdditionalType_by_pk(reference: $reference) {
    reference
    title
    description
    learnMore
  }
}
    `;

/**
 * __useAdminGetAdditionalTypeQuery__
 *
 * To run a query within a React component, call `useAdminGetAdditionalTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetAdditionalTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetAdditionalTypeQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetAdditionalTypeQuery(baseOptions: Apollo.QueryHookOptions<AdminGetAdditionalTypeQuery_, AdminGetAdditionalTypeQueryVariables_> & ({ variables: AdminGetAdditionalTypeQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetAdditionalTypeQuery_, AdminGetAdditionalTypeQueryVariables_>(AdminGetAdditionalTypeDocument_, options);
      }
export function useAdminGetAdditionalTypeLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetAdditionalTypeQuery_, AdminGetAdditionalTypeQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetAdditionalTypeQuery_, AdminGetAdditionalTypeQueryVariables_>(AdminGetAdditionalTypeDocument_, options);
        }
export function useAdminGetAdditionalTypeSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetAdditionalTypeQuery_, AdminGetAdditionalTypeQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetAdditionalTypeQuery_, AdminGetAdditionalTypeQueryVariables_>(AdminGetAdditionalTypeDocument_, options);
        }
export type AdminGetAdditionalTypeQueryHookResult = ReturnType<typeof useAdminGetAdditionalTypeQuery>;
export type AdminGetAdditionalTypeLazyQuery_HookResult = ReturnType<typeof useAdminGetAdditionalTypeLazyQuery_>;
export type AdminGetAdditionalTypeSuspenseQuery_HookResult = ReturnType<typeof useAdminGetAdditionalTypeSuspenseQuery_>;
export type AdminGetAdditionalTypeQueryResult_ = Apollo.QueryResult<AdminGetAdditionalTypeQuery_, AdminGetAdditionalTypeQueryVariables_>;
export function refetchAdminGetAdditionalTypeQuery_(variables: AdminGetAdditionalTypeQueryVariables_) {
      return { query: AdminGetAdditionalTypeDocument_, variables: variables }
    }
export const AdminDeleteAdditionalTypeDocument_ = gql`
    mutation AdminDeleteAdditionalType($reference: String!) {
  delete_AdditionalType_by_pk(reference: $reference) {
    reference
  }
}
    `;
export type AdminDeleteAdditionalTypeMutationFn_ = Apollo.MutationFunction<AdminDeleteAdditionalTypeMutation_, AdminDeleteAdditionalTypeMutationVariables_>;

/**
 * __useAdminDeleteAdditionalTypeMutation__
 *
 * To run a mutation, you first call `useAdminDeleteAdditionalTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteAdditionalTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteAdditionalTypeMutation, { data, loading, error }] = useAdminDeleteAdditionalTypeMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteAdditionalTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteAdditionalTypeMutation_, AdminDeleteAdditionalTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteAdditionalTypeMutation_, AdminDeleteAdditionalTypeMutationVariables_>(AdminDeleteAdditionalTypeDocument_, options);
      }
export type AdminDeleteAdditionalTypeMutationHookResult = ReturnType<typeof useAdminDeleteAdditionalTypeMutation>;
export type AdminDeleteAdditionalTypeMutationResult_ = Apollo.MutationResult<AdminDeleteAdditionalTypeMutation_>;
export type AdminDeleteAdditionalTypeMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteAdditionalTypeMutation_, AdminDeleteAdditionalTypeMutationVariables_>;
export const AdminCreateTargetQuestionGroupDocument_ = gql`
    mutation AdminCreateTargetQuestionGroup($object: TargetQuestionGroup_insert_input!) {
  insert_TargetQuestionGroup_one(object: $object) {
    title
    reference
  }
}
    `;
export type AdminCreateTargetQuestionGroupMutationFn_ = Apollo.MutationFunction<AdminCreateTargetQuestionGroupMutation_, AdminCreateTargetQuestionGroupMutationVariables_>;

/**
 * __useAdminCreateTargetQuestionGroupMutation__
 *
 * To run a mutation, you first call `useAdminCreateTargetQuestionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateTargetQuestionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateTargetQuestionGroupMutation, { data, loading, error }] = useAdminCreateTargetQuestionGroupMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateTargetQuestionGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateTargetQuestionGroupMutation_, AdminCreateTargetQuestionGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateTargetQuestionGroupMutation_, AdminCreateTargetQuestionGroupMutationVariables_>(AdminCreateTargetQuestionGroupDocument_, options);
      }
export type AdminCreateTargetQuestionGroupMutationHookResult = ReturnType<typeof useAdminCreateTargetQuestionGroupMutation>;
export type AdminCreateTargetQuestionGroupMutationResult_ = Apollo.MutationResult<AdminCreateTargetQuestionGroupMutation_>;
export type AdminCreateTargetQuestionGroupMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateTargetQuestionGroupMutation_, AdminCreateTargetQuestionGroupMutationVariables_>;
export const AdminGetCompanyAssessmentAggregateDocument_ = gql`
    query AdminGetCompanyAssessmentAggregate($id: uuid!) {
  CompanyAssessmentAggregate_by_pk(id: $id) {
    id
    title
    createdAt
    updatedAt
    companyId
    isReal
  }
}
    `;

/**
 * __useAdminGetCompanyAssessmentAggregateQuery__
 *
 * To run a query within a React component, call `useAdminGetCompanyAssessmentAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetCompanyAssessmentAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetCompanyAssessmentAggregateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetCompanyAssessmentAggregateQuery(baseOptions: Apollo.QueryHookOptions<AdminGetCompanyAssessmentAggregateQuery_, AdminGetCompanyAssessmentAggregateQueryVariables_> & ({ variables: AdminGetCompanyAssessmentAggregateQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetCompanyAssessmentAggregateQuery_, AdminGetCompanyAssessmentAggregateQueryVariables_>(AdminGetCompanyAssessmentAggregateDocument_, options);
      }
export function useAdminGetCompanyAssessmentAggregateLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetCompanyAssessmentAggregateQuery_, AdminGetCompanyAssessmentAggregateQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetCompanyAssessmentAggregateQuery_, AdminGetCompanyAssessmentAggregateQueryVariables_>(AdminGetCompanyAssessmentAggregateDocument_, options);
        }
export function useAdminGetCompanyAssessmentAggregateSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetCompanyAssessmentAggregateQuery_, AdminGetCompanyAssessmentAggregateQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetCompanyAssessmentAggregateQuery_, AdminGetCompanyAssessmentAggregateQueryVariables_>(AdminGetCompanyAssessmentAggregateDocument_, options);
        }
export type AdminGetCompanyAssessmentAggregateQueryHookResult = ReturnType<typeof useAdminGetCompanyAssessmentAggregateQuery>;
export type AdminGetCompanyAssessmentAggregateLazyQuery_HookResult = ReturnType<typeof useAdminGetCompanyAssessmentAggregateLazyQuery_>;
export type AdminGetCompanyAssessmentAggregateSuspenseQuery_HookResult = ReturnType<typeof useAdminGetCompanyAssessmentAggregateSuspenseQuery_>;
export type AdminGetCompanyAssessmentAggregateQueryResult_ = Apollo.QueryResult<AdminGetCompanyAssessmentAggregateQuery_, AdminGetCompanyAssessmentAggregateQueryVariables_>;
export function refetchAdminGetCompanyAssessmentAggregateQuery_(variables: AdminGetCompanyAssessmentAggregateQueryVariables_) {
      return { query: AdminGetCompanyAssessmentAggregateDocument_, variables: variables }
    }
export const AdminUpdateActivityDocument_ = gql`
    mutation AdminUpdateActivity($pk_columns: Activity_pk_columns_input!, $_set: Activity_set_input!) {
  update_Activity_by_pk(pk_columns: $pk_columns, _set: $_set) {
    name
    reference
    description
    sectorRef
    referenceNumber
    currentQuestionSetVersion
    isHidden
    additionalGuidance
    celsiaComment
    descriptionSource
    guidanceSource
  }
}
    `;
export type AdminUpdateActivityMutationFn_ = Apollo.MutationFunction<AdminUpdateActivityMutation_, AdminUpdateActivityMutationVariables_>;

/**
 * __useAdminUpdateActivityMutation__
 *
 * To run a mutation, you first call `useAdminUpdateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateActivityMutation, { data, loading, error }] = useAdminUpdateActivityMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateActivityMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateActivityMutation_, AdminUpdateActivityMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateActivityMutation_, AdminUpdateActivityMutationVariables_>(AdminUpdateActivityDocument_, options);
      }
export type AdminUpdateActivityMutationHookResult = ReturnType<typeof useAdminUpdateActivityMutation>;
export type AdminUpdateActivityMutationResult_ = Apollo.MutationResult<AdminUpdateActivityMutation_>;
export type AdminUpdateActivityMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateActivityMutation_, AdminUpdateActivityMutationVariables_>;
export const AdminCreateActivityDocument_ = gql`
    mutation AdminCreateActivity($object: Activity_insert_input!) {
  insert_Activity_one(object: $object) {
    name
    reference
    description
    sectorRef
    referenceNumber
    currentQuestionSetVersion
    isHidden
    additionalGuidance
    celsiaComment
    descriptionSource
    guidanceSource
  }
}
    `;
export type AdminCreateActivityMutationFn_ = Apollo.MutationFunction<AdminCreateActivityMutation_, AdminCreateActivityMutationVariables_>;

/**
 * __useAdminCreateActivityMutation__
 *
 * To run a mutation, you first call `useAdminCreateActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateActivityMutation, { data, loading, error }] = useAdminCreateActivityMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateActivityMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateActivityMutation_, AdminCreateActivityMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateActivityMutation_, AdminCreateActivityMutationVariables_>(AdminCreateActivityDocument_, options);
      }
export type AdminCreateActivityMutationHookResult = ReturnType<typeof useAdminCreateActivityMutation>;
export type AdminCreateActivityMutationResult_ = Apollo.MutationResult<AdminCreateActivityMutation_>;
export type AdminCreateActivityMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateActivityMutation_, AdminCreateActivityMutationVariables_>;
export const AdminCreateSectorDocument_ = gql`
    mutation AdminCreateSector($object: Sector_insert_input!) {
  insert_Sector_one(object: $object) {
    name
    reference
    referenceNumber
  }
}
    `;
export type AdminCreateSectorMutationFn_ = Apollo.MutationFunction<AdminCreateSectorMutation_, AdminCreateSectorMutationVariables_>;

/**
 * __useAdminCreateSectorMutation__
 *
 * To run a mutation, you first call `useAdminCreateSectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateSectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateSectorMutation, { data, loading, error }] = useAdminCreateSectorMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateSectorMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateSectorMutation_, AdminCreateSectorMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateSectorMutation_, AdminCreateSectorMutationVariables_>(AdminCreateSectorDocument_, options);
      }
export type AdminCreateSectorMutationHookResult = ReturnType<typeof useAdminCreateSectorMutation>;
export type AdminCreateSectorMutationResult_ = Apollo.MutationResult<AdminCreateSectorMutation_>;
export type AdminCreateSectorMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateSectorMutation_, AdminCreateSectorMutationVariables_>;
export const AdminUpdateQuestionDocument_ = gql`
    mutation AdminUpdateQuestion($pk_columns: Question_pk_columns_input!, $_set: Question_set_input!) {
  update_Question_by_pk(pk_columns: $pk_columns, _set: $_set) {
    uniqueId
    version
    title
    description
    type
    level
    group
    orderIndex
    unit
    alignmentErrorMessage
    dependencyDescription
    extendedDescription
    resourceLink
    documentationRequired
    relevantDirectives
    objectiveKey
    id
    other
    isAligned
    isRequired
    isVisible
    isEditable
    levelExpression
    learnMoreArticleSlug
    olderRevisions {
      oldQuestion {
        id
        uniqueId
        version
      }
      oldQuestionId
      newQuestionId
      description
    }
  }
}
    `;
export type AdminUpdateQuestionMutationFn_ = Apollo.MutationFunction<AdminUpdateQuestionMutation_, AdminUpdateQuestionMutationVariables_>;

/**
 * __useAdminUpdateQuestionMutation__
 *
 * To run a mutation, you first call `useAdminUpdateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateQuestionMutation, { data, loading, error }] = useAdminUpdateQuestionMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateQuestionMutation_, AdminUpdateQuestionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateQuestionMutation_, AdminUpdateQuestionMutationVariables_>(AdminUpdateQuestionDocument_, options);
      }
export type AdminUpdateQuestionMutationHookResult = ReturnType<typeof useAdminUpdateQuestionMutation>;
export type AdminUpdateQuestionMutationResult_ = Apollo.MutationResult<AdminUpdateQuestionMutation_>;
export type AdminUpdateQuestionMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateQuestionMutation_, AdminUpdateQuestionMutationVariables_>;
export const AdminCreateQuestionDocument_ = gql`
    mutation AdminCreateQuestion($object: Question_insert_input!) {
  insert_Question_one(object: $object) {
    uniqueId
    version
    title
    description
    type
    level
    group
    orderIndex
    unit
    alignmentErrorMessage
    dependencyDescription
    extendedDescription
    resourceLink
    documentationRequired
    relevantDirectives
    objectiveKey
    id
    other
    isAligned
    isRequired
    isVisible
    isEditable
    levelExpression
    learnMoreArticleSlug
    olderRevisions {
      oldQuestion {
        id
        uniqueId
        version
      }
      oldQuestionId
      newQuestionId
      description
    }
  }
}
    `;
export type AdminCreateQuestionMutationFn_ = Apollo.MutationFunction<AdminCreateQuestionMutation_, AdminCreateQuestionMutationVariables_>;

/**
 * __useAdminCreateQuestionMutation__
 *
 * To run a mutation, you first call `useAdminCreateQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateQuestionMutation, { data, loading, error }] = useAdminCreateQuestionMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateQuestionMutation_, AdminCreateQuestionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateQuestionMutation_, AdminCreateQuestionMutationVariables_>(AdminCreateQuestionDocument_, options);
      }
export type AdminCreateQuestionMutationHookResult = ReturnType<typeof useAdminCreateQuestionMutation>;
export type AdminCreateQuestionMutationResult_ = Apollo.MutationResult<AdminCreateQuestionMutation_>;
export type AdminCreateQuestionMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateQuestionMutation_, AdminCreateQuestionMutationVariables_>;
export const AdminUpdateQuestionRevisionDocument_ = gql`
    mutation AdminUpdateQuestionRevision($pk_columns: QuestionRevision_pk_columns_input!, $_set: QuestionRevision_set_input!) {
  update_QuestionRevision_by_pk(pk_columns: $pk_columns, _set: $_set) {
    oldQuestionId
    newQuestionId
    description
    oldQuestion {
      id
      uniqueId
      version
    }
    newQuestion {
      id
      uniqueId
      version
    }
  }
}
    `;
export type AdminUpdateQuestionRevisionMutationFn_ = Apollo.MutationFunction<AdminUpdateQuestionRevisionMutation_, AdminUpdateQuestionRevisionMutationVariables_>;

/**
 * __useAdminUpdateQuestionRevisionMutation__
 *
 * To run a mutation, you first call `useAdminUpdateQuestionRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateQuestionRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateQuestionRevisionMutation, { data, loading, error }] = useAdminUpdateQuestionRevisionMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateQuestionRevisionMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateQuestionRevisionMutation_, AdminUpdateQuestionRevisionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateQuestionRevisionMutation_, AdminUpdateQuestionRevisionMutationVariables_>(AdminUpdateQuestionRevisionDocument_, options);
      }
export type AdminUpdateQuestionRevisionMutationHookResult = ReturnType<typeof useAdminUpdateQuestionRevisionMutation>;
export type AdminUpdateQuestionRevisionMutationResult_ = Apollo.MutationResult<AdminUpdateQuestionRevisionMutation_>;
export type AdminUpdateQuestionRevisionMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateQuestionRevisionMutation_, AdminUpdateQuestionRevisionMutationVariables_>;
export const AdminCreateQuestionRevisionDocument_ = gql`
    mutation AdminCreateQuestionRevision($object: QuestionRevision_insert_input!) {
  insert_QuestionRevision_one(object: $object) {
    oldQuestionId
    newQuestionId
    description
    oldQuestion {
      id
      uniqueId
      version
    }
    newQuestion {
      id
      uniqueId
      version
    }
  }
}
    `;
export type AdminCreateQuestionRevisionMutationFn_ = Apollo.MutationFunction<AdminCreateQuestionRevisionMutation_, AdminCreateQuestionRevisionMutationVariables_>;

/**
 * __useAdminCreateQuestionRevisionMutation__
 *
 * To run a mutation, you first call `useAdminCreateQuestionRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateQuestionRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateQuestionRevisionMutation, { data, loading, error }] = useAdminCreateQuestionRevisionMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateQuestionRevisionMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateQuestionRevisionMutation_, AdminCreateQuestionRevisionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateQuestionRevisionMutation_, AdminCreateQuestionRevisionMutationVariables_>(AdminCreateQuestionRevisionDocument_, options);
      }
export type AdminCreateQuestionRevisionMutationHookResult = ReturnType<typeof useAdminCreateQuestionRevisionMutation>;
export type AdminCreateQuestionRevisionMutationResult_ = Apollo.MutationResult<AdminCreateQuestionRevisionMutation_>;
export type AdminCreateQuestionRevisionMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateQuestionRevisionMutation_, AdminCreateQuestionRevisionMutationVariables_>;
export const AdminCreateQuestionRevisionsDocument_ = gql`
    mutation AdminCreateQuestionRevisions($objects: [QuestionRevision_insert_input!]!) {
  insert_QuestionRevision(objects: $objects) {
    returning {
      oldQuestionId
      newQuestionId
      description
      oldQuestion {
        id
        uniqueId
        version
      }
      newQuestion {
        id
        uniqueId
        version
      }
    }
  }
}
    `;
export type AdminCreateQuestionRevisionsMutationFn_ = Apollo.MutationFunction<AdminCreateQuestionRevisionsMutation_, AdminCreateQuestionRevisionsMutationVariables_>;

/**
 * __useAdminCreateQuestionRevisionsMutation__
 *
 * To run a mutation, you first call `useAdminCreateQuestionRevisionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateQuestionRevisionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateQuestionRevisionsMutation, { data, loading, error }] = useAdminCreateQuestionRevisionsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateQuestionRevisionsMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateQuestionRevisionsMutation_, AdminCreateQuestionRevisionsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateQuestionRevisionsMutation_, AdminCreateQuestionRevisionsMutationVariables_>(AdminCreateQuestionRevisionsDocument_, options);
      }
export type AdminCreateQuestionRevisionsMutationHookResult = ReturnType<typeof useAdminCreateQuestionRevisionsMutation>;
export type AdminCreateQuestionRevisionsMutationResult_ = Apollo.MutationResult<AdminCreateQuestionRevisionsMutation_>;
export type AdminCreateQuestionRevisionsMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateQuestionRevisionsMutation_, AdminCreateQuestionRevisionsMutationVariables_>;
export const AdminUpdateObjectiveDocument_ = gql`
    mutation AdminUpdateObjective($pk_columns: Objective_pk_columns_input!, $_set: Objective_set_input!) {
  update_Objective_by_pk(pk_columns: $pk_columns, _set: $_set) {
    key
    title
    description
  }
}
    `;
export type AdminUpdateObjectiveMutationFn_ = Apollo.MutationFunction<AdminUpdateObjectiveMutation_, AdminUpdateObjectiveMutationVariables_>;

/**
 * __useAdminUpdateObjectiveMutation__
 *
 * To run a mutation, you first call `useAdminUpdateObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateObjectiveMutation, { data, loading, error }] = useAdminUpdateObjectiveMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateObjectiveMutation_, AdminUpdateObjectiveMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateObjectiveMutation_, AdminUpdateObjectiveMutationVariables_>(AdminUpdateObjectiveDocument_, options);
      }
export type AdminUpdateObjectiveMutationHookResult = ReturnType<typeof useAdminUpdateObjectiveMutation>;
export type AdminUpdateObjectiveMutationResult_ = Apollo.MutationResult<AdminUpdateObjectiveMutation_>;
export type AdminUpdateObjectiveMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateObjectiveMutation_, AdminUpdateObjectiveMutationVariables_>;
export const AdminCreateObjectiveDocument_ = gql`
    mutation AdminCreateObjective($object: Objective_insert_input!) {
  insert_Objective_one(object: $object) {
    key
    title
    description
  }
}
    `;
export type AdminCreateObjectiveMutationFn_ = Apollo.MutationFunction<AdminCreateObjectiveMutation_, AdminCreateObjectiveMutationVariables_>;

/**
 * __useAdminCreateObjectiveMutation__
 *
 * To run a mutation, you first call `useAdminCreateObjectiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateObjectiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateObjectiveMutation, { data, loading, error }] = useAdminCreateObjectiveMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateObjectiveMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateObjectiveMutation_, AdminCreateObjectiveMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateObjectiveMutation_, AdminCreateObjectiveMutationVariables_>(AdminCreateObjectiveDocument_, options);
      }
export type AdminCreateObjectiveMutationHookResult = ReturnType<typeof useAdminCreateObjectiveMutation>;
export type AdminCreateObjectiveMutationResult_ = Apollo.MutationResult<AdminCreateObjectiveMutation_>;
export type AdminCreateObjectiveMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateObjectiveMutation_, AdminCreateObjectiveMutationVariables_>;
export const AdminCreateQuestionSetDocument_ = gql`
    mutation AdminCreateQuestionSet($object: QuestionSet_insert_input!) {
  insert_QuestionSet_one(object: $object) {
    reference
    questions {
      questionId
      question {
        uniqueId
        version
        id
      }
    }
  }
}
    `;
export type AdminCreateQuestionSetMutationFn_ = Apollo.MutationFunction<AdminCreateQuestionSetMutation_, AdminCreateQuestionSetMutationVariables_>;

/**
 * __useAdminCreateQuestionSetMutation__
 *
 * To run a mutation, you first call `useAdminCreateQuestionSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateQuestionSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateQuestionSetMutation, { data, loading, error }] = useAdminCreateQuestionSetMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateQuestionSetMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateQuestionSetMutation_, AdminCreateQuestionSetMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateQuestionSetMutation_, AdminCreateQuestionSetMutationVariables_>(AdminCreateQuestionSetDocument_, options);
      }
export type AdminCreateQuestionSetMutationHookResult = ReturnType<typeof useAdminCreateQuestionSetMutation>;
export type AdminCreateQuestionSetMutationResult_ = Apollo.MutationResult<AdminCreateQuestionSetMutation_>;
export type AdminCreateQuestionSetMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateQuestionSetMutation_, AdminCreateQuestionSetMutationVariables_>;
export const AdminUpdateQuestionSetQuestionDocument_ = gql`
    mutation AdminUpdateQuestionSetQuestion($pk_columns: QuestionSetQuestion_pk_columns_input!, $_set: QuestionSetQuestion_set_input!) {
  update_QuestionSetQuestion_by_pk(pk_columns: $pk_columns, _set: $_set) {
    questionSetRef
    questionId
  }
}
    `;
export type AdminUpdateQuestionSetQuestionMutationFn_ = Apollo.MutationFunction<AdminUpdateQuestionSetQuestionMutation_, AdminUpdateQuestionSetQuestionMutationVariables_>;

/**
 * __useAdminUpdateQuestionSetQuestionMutation__
 *
 * To run a mutation, you first call `useAdminUpdateQuestionSetQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateQuestionSetQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateQuestionSetQuestionMutation, { data, loading, error }] = useAdminUpdateQuestionSetQuestionMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateQuestionSetQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateQuestionSetQuestionMutation_, AdminUpdateQuestionSetQuestionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateQuestionSetQuestionMutation_, AdminUpdateQuestionSetQuestionMutationVariables_>(AdminUpdateQuestionSetQuestionDocument_, options);
      }
export type AdminUpdateQuestionSetQuestionMutationHookResult = ReturnType<typeof useAdminUpdateQuestionSetQuestionMutation>;
export type AdminUpdateQuestionSetQuestionMutationResult_ = Apollo.MutationResult<AdminUpdateQuestionSetQuestionMutation_>;
export type AdminUpdateQuestionSetQuestionMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateQuestionSetQuestionMutation_, AdminUpdateQuestionSetQuestionMutationVariables_>;
export const AdminCreateQuestionSetQuestionDocument_ = gql`
    mutation AdminCreateQuestionSetQuestion($object: QuestionSetQuestion_insert_input!) {
  insert_QuestionSetQuestion_one(object: $object) {
    questionSetRef
    questionId
  }
}
    `;
export type AdminCreateQuestionSetQuestionMutationFn_ = Apollo.MutationFunction<AdminCreateQuestionSetQuestionMutation_, AdminCreateQuestionSetQuestionMutationVariables_>;

/**
 * __useAdminCreateQuestionSetQuestionMutation__
 *
 * To run a mutation, you first call `useAdminCreateQuestionSetQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateQuestionSetQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateQuestionSetQuestionMutation, { data, loading, error }] = useAdminCreateQuestionSetQuestionMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateQuestionSetQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateQuestionSetQuestionMutation_, AdminCreateQuestionSetQuestionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateQuestionSetQuestionMutation_, AdminCreateQuestionSetQuestionMutationVariables_>(AdminCreateQuestionSetQuestionDocument_, options);
      }
export type AdminCreateQuestionSetQuestionMutationHookResult = ReturnType<typeof useAdminCreateQuestionSetQuestionMutation>;
export type AdminCreateQuestionSetQuestionMutationResult_ = Apollo.MutationResult<AdminCreateQuestionSetQuestionMutation_>;
export type AdminCreateQuestionSetQuestionMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateQuestionSetQuestionMutation_, AdminCreateQuestionSetQuestionMutationVariables_>;
export const AdminUpdateQuestionChoiceDocument_ = gql`
    mutation AdminUpdateQuestionChoice($pk_columns: QuestionChoice_pk_columns_input!, $_set: QuestionChoice_set_input!) {
  update_QuestionChoice_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    order
    value
    displayName
    question_id
  }
}
    `;
export type AdminUpdateQuestionChoiceMutationFn_ = Apollo.MutationFunction<AdminUpdateQuestionChoiceMutation_, AdminUpdateQuestionChoiceMutationVariables_>;

/**
 * __useAdminUpdateQuestionChoiceMutation__
 *
 * To run a mutation, you first call `useAdminUpdateQuestionChoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateQuestionChoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateQuestionChoiceMutation, { data, loading, error }] = useAdminUpdateQuestionChoiceMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateQuestionChoiceMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateQuestionChoiceMutation_, AdminUpdateQuestionChoiceMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateQuestionChoiceMutation_, AdminUpdateQuestionChoiceMutationVariables_>(AdminUpdateQuestionChoiceDocument_, options);
      }
export type AdminUpdateQuestionChoiceMutationHookResult = ReturnType<typeof useAdminUpdateQuestionChoiceMutation>;
export type AdminUpdateQuestionChoiceMutationResult_ = Apollo.MutationResult<AdminUpdateQuestionChoiceMutation_>;
export type AdminUpdateQuestionChoiceMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateQuestionChoiceMutation_, AdminUpdateQuestionChoiceMutationVariables_>;
export const AdminCreateQuestionChoiceDocument_ = gql`
    mutation AdminCreateQuestionChoice($object: QuestionChoice_insert_input!) {
  insert_QuestionChoice_one(object: $object) {
    id
    order
    value
    displayName
    question_id
  }
}
    `;
export type AdminCreateQuestionChoiceMutationFn_ = Apollo.MutationFunction<AdminCreateQuestionChoiceMutation_, AdminCreateQuestionChoiceMutationVariables_>;

/**
 * __useAdminCreateQuestionChoiceMutation__
 *
 * To run a mutation, you first call `useAdminCreateQuestionChoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateQuestionChoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateQuestionChoiceMutation, { data, loading, error }] = useAdminCreateQuestionChoiceMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateQuestionChoiceMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateQuestionChoiceMutation_, AdminCreateQuestionChoiceMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateQuestionChoiceMutation_, AdminCreateQuestionChoiceMutationVariables_>(AdminCreateQuestionChoiceDocument_, options);
      }
export type AdminCreateQuestionChoiceMutationHookResult = ReturnType<typeof useAdminCreateQuestionChoiceMutation>;
export type AdminCreateQuestionChoiceMutationResult_ = Apollo.MutationResult<AdminCreateQuestionChoiceMutation_>;
export type AdminCreateQuestionChoiceMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateQuestionChoiceMutation_, AdminCreateQuestionChoiceMutationVariables_>;
export const AdminCreateActivityQuestionSetDocument_ = gql`
    mutation AdminCreateActivityQuestionSet($object: ActivityQuestionSet_insert_input!) {
  insert_ActivityQuestionSet_one(object: $object) {
    activityRef
    questionSetRef
    id
    version
  }
}
    `;
export type AdminCreateActivityQuestionSetMutationFn_ = Apollo.MutationFunction<AdminCreateActivityQuestionSetMutation_, AdminCreateActivityQuestionSetMutationVariables_>;

/**
 * __useAdminCreateActivityQuestionSetMutation__
 *
 * To run a mutation, you first call `useAdminCreateActivityQuestionSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateActivityQuestionSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateActivityQuestionSetMutation, { data, loading, error }] = useAdminCreateActivityQuestionSetMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateActivityQuestionSetMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateActivityQuestionSetMutation_, AdminCreateActivityQuestionSetMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateActivityQuestionSetMutation_, AdminCreateActivityQuestionSetMutationVariables_>(AdminCreateActivityQuestionSetDocument_, options);
      }
export type AdminCreateActivityQuestionSetMutationHookResult = ReturnType<typeof useAdminCreateActivityQuestionSetMutation>;
export type AdminCreateActivityQuestionSetMutationResult_ = Apollo.MutationResult<AdminCreateActivityQuestionSetMutation_>;
export type AdminCreateActivityQuestionSetMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateActivityQuestionSetMutation_, AdminCreateActivityQuestionSetMutationVariables_>;
export const AdminCreateActivityQuestionSetsDocument_ = gql`
    mutation AdminCreateActivityQuestionSets($objects: [ActivityQuestionSet_insert_input!]!) {
  insert_ActivityQuestionSet(objects: $objects) {
    returning {
      activityRef
      questionSetRef
      id
      version
    }
  }
}
    `;
export type AdminCreateActivityQuestionSetsMutationFn_ = Apollo.MutationFunction<AdminCreateActivityQuestionSetsMutation_, AdminCreateActivityQuestionSetsMutationVariables_>;

/**
 * __useAdminCreateActivityQuestionSetsMutation__
 *
 * To run a mutation, you first call `useAdminCreateActivityQuestionSetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateActivityQuestionSetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateActivityQuestionSetsMutation, { data, loading, error }] = useAdminCreateActivityQuestionSetsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateActivityQuestionSetsMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateActivityQuestionSetsMutation_, AdminCreateActivityQuestionSetsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateActivityQuestionSetsMutation_, AdminCreateActivityQuestionSetsMutationVariables_>(AdminCreateActivityQuestionSetsDocument_, options);
      }
export type AdminCreateActivityQuestionSetsMutationHookResult = ReturnType<typeof useAdminCreateActivityQuestionSetsMutation>;
export type AdminCreateActivityQuestionSetsMutationResult_ = Apollo.MutationResult<AdminCreateActivityQuestionSetsMutation_>;
export type AdminCreateActivityQuestionSetsMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateActivityQuestionSetsMutation_, AdminCreateActivityQuestionSetsMutationVariables_>;
export const AdminCreateActivityNaceCodeDocument_ = gql`
    mutation AdminCreateActivityNaceCode($object: ActivityNaceCode_insert_input!) {
  insert_ActivityNaceCode_one(object: $object) {
    activityRef
    code
    id
  }
}
    `;
export type AdminCreateActivityNaceCodeMutationFn_ = Apollo.MutationFunction<AdminCreateActivityNaceCodeMutation_, AdminCreateActivityNaceCodeMutationVariables_>;

/**
 * __useAdminCreateActivityNaceCodeMutation__
 *
 * To run a mutation, you first call `useAdminCreateActivityNaceCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateActivityNaceCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateActivityNaceCodeMutation, { data, loading, error }] = useAdminCreateActivityNaceCodeMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateActivityNaceCodeMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateActivityNaceCodeMutation_, AdminCreateActivityNaceCodeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateActivityNaceCodeMutation_, AdminCreateActivityNaceCodeMutationVariables_>(AdminCreateActivityNaceCodeDocument_, options);
      }
export type AdminCreateActivityNaceCodeMutationHookResult = ReturnType<typeof useAdminCreateActivityNaceCodeMutation>;
export type AdminCreateActivityNaceCodeMutationResult_ = Apollo.MutationResult<AdminCreateActivityNaceCodeMutation_>;
export type AdminCreateActivityNaceCodeMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateActivityNaceCodeMutation_, AdminCreateActivityNaceCodeMutationVariables_>;
export const AdminUpdateActivityNaceCodeDocument_ = gql`
    mutation AdminUpdateActivityNaceCode($pk_columns: ActivityNaceCode_pk_columns_input!, $_set: ActivityNaceCode_set_input!) {
  update_ActivityNaceCode_by_pk(pk_columns: $pk_columns, _set: $_set) {
    activityRef
    code
    id
  }
}
    `;
export type AdminUpdateActivityNaceCodeMutationFn_ = Apollo.MutationFunction<AdminUpdateActivityNaceCodeMutation_, AdminUpdateActivityNaceCodeMutationVariables_>;

/**
 * __useAdminUpdateActivityNaceCodeMutation__
 *
 * To run a mutation, you first call `useAdminUpdateActivityNaceCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateActivityNaceCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateActivityNaceCodeMutation, { data, loading, error }] = useAdminUpdateActivityNaceCodeMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateActivityNaceCodeMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateActivityNaceCodeMutation_, AdminUpdateActivityNaceCodeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateActivityNaceCodeMutation_, AdminUpdateActivityNaceCodeMutationVariables_>(AdminUpdateActivityNaceCodeDocument_, options);
      }
export type AdminUpdateActivityNaceCodeMutationHookResult = ReturnType<typeof useAdminUpdateActivityNaceCodeMutation>;
export type AdminUpdateActivityNaceCodeMutationResult_ = Apollo.MutationResult<AdminUpdateActivityNaceCodeMutation_>;
export type AdminUpdateActivityNaceCodeMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateActivityNaceCodeMutation_, AdminUpdateActivityNaceCodeMutationVariables_>;
export const AdminUpdateActivityVersionDocument_ = gql`
    mutation AdminUpdateActivityVersion($pk_columns: ActivityVersion_pk_columns_input!, $_set: ActivityVersion_set_input!) {
  update_ActivityVersion_by_pk(pk_columns: $pk_columns, _set: $_set) {
    activityRef
    versionNumber
    tagExpression
    tagObjective
    changeDescription
    validFrom
    activityQuestionSets {
      questionSetRef
      version
      activityRef
      questionSet {
        reference
      }
    }
  }
}
    `;
export type AdminUpdateActivityVersionMutationFn_ = Apollo.MutationFunction<AdminUpdateActivityVersionMutation_, AdminUpdateActivityVersionMutationVariables_>;

/**
 * __useAdminUpdateActivityVersionMutation__
 *
 * To run a mutation, you first call `useAdminUpdateActivityVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateActivityVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateActivityVersionMutation, { data, loading, error }] = useAdminUpdateActivityVersionMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateActivityVersionMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateActivityVersionMutation_, AdminUpdateActivityVersionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateActivityVersionMutation_, AdminUpdateActivityVersionMutationVariables_>(AdminUpdateActivityVersionDocument_, options);
      }
export type AdminUpdateActivityVersionMutationHookResult = ReturnType<typeof useAdminUpdateActivityVersionMutation>;
export type AdminUpdateActivityVersionMutationResult_ = Apollo.MutationResult<AdminUpdateActivityVersionMutation_>;
export type AdminUpdateActivityVersionMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateActivityVersionMutation_, AdminUpdateActivityVersionMutationVariables_>;
export const AdminCreateActivityVersionDocument_ = gql`
    mutation AdminCreateActivityVersion($object: ActivityVersion_insert_input!) {
  insert_ActivityVersion_one(object: $object) {
    activityRef
    versionNumber
    tagExpression
    tagObjective
    changeDescription
    validFrom
    activityQuestionSets {
      questionSetRef
      version
      activityRef
      questionSet {
        reference
      }
    }
  }
}
    `;
export type AdminCreateActivityVersionMutationFn_ = Apollo.MutationFunction<AdminCreateActivityVersionMutation_, AdminCreateActivityVersionMutationVariables_>;

/**
 * __useAdminCreateActivityVersionMutation__
 *
 * To run a mutation, you first call `useAdminCreateActivityVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateActivityVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateActivityVersionMutation, { data, loading, error }] = useAdminCreateActivityVersionMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateActivityVersionMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateActivityVersionMutation_, AdminCreateActivityVersionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateActivityVersionMutation_, AdminCreateActivityVersionMutationVariables_>(AdminCreateActivityVersionDocument_, options);
      }
export type AdminCreateActivityVersionMutationHookResult = ReturnType<typeof useAdminCreateActivityVersionMutation>;
export type AdminCreateActivityVersionMutationResult_ = Apollo.MutationResult<AdminCreateActivityVersionMutation_>;
export type AdminCreateActivityVersionMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateActivityVersionMutation_, AdminCreateActivityVersionMutationVariables_>;
export const AdminCreateActivityVersionsDocument_ = gql`
    mutation AdminCreateActivityVersions($objects: [ActivityVersion_insert_input!]!) {
  insert_ActivityVersion(objects: $objects) {
    returning {
      activityRef
      versionNumber
      tagExpression
      tagObjective
      changeDescription
      validFrom
      activityQuestionSets {
        questionSetRef
        version
        activityRef
        questionSet {
          reference
        }
      }
    }
  }
}
    `;
export type AdminCreateActivityVersionsMutationFn_ = Apollo.MutationFunction<AdminCreateActivityVersionsMutation_, AdminCreateActivityVersionsMutationVariables_>;

/**
 * __useAdminCreateActivityVersionsMutation__
 *
 * To run a mutation, you first call `useAdminCreateActivityVersionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateActivityVersionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateActivityVersionsMutation, { data, loading, error }] = useAdminCreateActivityVersionsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateActivityVersionsMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateActivityVersionsMutation_, AdminCreateActivityVersionsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateActivityVersionsMutation_, AdminCreateActivityVersionsMutationVariables_>(AdminCreateActivityVersionsDocument_, options);
      }
export type AdminCreateActivityVersionsMutationHookResult = ReturnType<typeof useAdminCreateActivityVersionsMutation>;
export type AdminCreateActivityVersionsMutationResult_ = Apollo.MutationResult<AdminCreateActivityVersionsMutation_>;
export type AdminCreateActivityVersionsMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateActivityVersionsMutation_, AdminCreateActivityVersionsMutationVariables_>;
export const AdminUpdateArticleDocument_ = gql`
    mutation AdminUpdateArticle($pk_columns: Article_pk_columns_input!, $_set: Article_set_input!) {
  update_Article_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    body
    id
    slug
    isHidden
    order
  }
}
    `;
export type AdminUpdateArticleMutationFn_ = Apollo.MutationFunction<AdminUpdateArticleMutation_, AdminUpdateArticleMutationVariables_>;

/**
 * __useAdminUpdateArticleMutation__
 *
 * To run a mutation, you first call `useAdminUpdateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateArticleMutation, { data, loading, error }] = useAdminUpdateArticleMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateArticleMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateArticleMutation_, AdminUpdateArticleMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateArticleMutation_, AdminUpdateArticleMutationVariables_>(AdminUpdateArticleDocument_, options);
      }
export type AdminUpdateArticleMutationHookResult = ReturnType<typeof useAdminUpdateArticleMutation>;
export type AdminUpdateArticleMutationResult_ = Apollo.MutationResult<AdminUpdateArticleMutation_>;
export type AdminUpdateArticleMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateArticleMutation_, AdminUpdateArticleMutationVariables_>;
export const AdminCreateArticleDocument_ = gql`
    mutation AdminCreateArticle($object: Article_insert_input!) {
  insert_Article_one(object: $object) {
    title
    body
    id
    slug
    isHidden
    order
  }
}
    `;
export type AdminCreateArticleMutationFn_ = Apollo.MutationFunction<AdminCreateArticleMutation_, AdminCreateArticleMutationVariables_>;

/**
 * __useAdminCreateArticleMutation__
 *
 * To run a mutation, you first call `useAdminCreateArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateArticleMutation, { data, loading, error }] = useAdminCreateArticleMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateArticleMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateArticleMutation_, AdminCreateArticleMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateArticleMutation_, AdminCreateArticleMutationVariables_>(AdminCreateArticleDocument_, options);
      }
export type AdminCreateArticleMutationHookResult = ReturnType<typeof useAdminCreateArticleMutation>;
export type AdminCreateArticleMutationResult_ = Apollo.MutationResult<AdminCreateArticleMutation_>;
export type AdminCreateArticleMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateArticleMutation_, AdminCreateArticleMutationVariables_>;
export const AdminDeleteActivityDocument_ = gql`
    mutation AdminDeleteActivity($id: String!) {
  delete_Activity_by_pk(reference: $id) {
    reference
  }
}
    `;
export type AdminDeleteActivityMutationFn_ = Apollo.MutationFunction<AdminDeleteActivityMutation_, AdminDeleteActivityMutationVariables_>;

/**
 * __useAdminDeleteActivityMutation__
 *
 * To run a mutation, you first call `useAdminDeleteActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteActivityMutation, { data, loading, error }] = useAdminDeleteActivityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteActivityMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteActivityMutation_, AdminDeleteActivityMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteActivityMutation_, AdminDeleteActivityMutationVariables_>(AdminDeleteActivityDocument_, options);
      }
export type AdminDeleteActivityMutationHookResult = ReturnType<typeof useAdminDeleteActivityMutation>;
export type AdminDeleteActivityMutationResult_ = Apollo.MutationResult<AdminDeleteActivityMutation_>;
export type AdminDeleteActivityMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteActivityMutation_, AdminDeleteActivityMutationVariables_>;
export const AdminUpdateTagDocument_ = gql`
    mutation AdminUpdateTag($pk_columns: Tag_pk_columns_input!, $_set: Tag_set_input!) {
  update_Tag_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    name
    description
  }
}
    `;
export type AdminUpdateTagMutationFn_ = Apollo.MutationFunction<AdminUpdateTagMutation_, AdminUpdateTagMutationVariables_>;

/**
 * __useAdminUpdateTagMutation__
 *
 * To run a mutation, you first call `useAdminUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateTagMutation, { data, loading, error }] = useAdminUpdateTagMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateTagMutation_, AdminUpdateTagMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateTagMutation_, AdminUpdateTagMutationVariables_>(AdminUpdateTagDocument_, options);
      }
export type AdminUpdateTagMutationHookResult = ReturnType<typeof useAdminUpdateTagMutation>;
export type AdminUpdateTagMutationResult_ = Apollo.MutationResult<AdminUpdateTagMutation_>;
export type AdminUpdateTagMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateTagMutation_, AdminUpdateTagMutationVariables_>;
export const AdminUpdateTagGroupDocument_ = gql`
    mutation AdminUpdateTagGroup($pk_columns: TagGroup_pk_columns_input!, $_set: TagGroup_set_input!) {
  update_TagGroup_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    name
    description
  }
}
    `;
export type AdminUpdateTagGroupMutationFn_ = Apollo.MutationFunction<AdminUpdateTagGroupMutation_, AdminUpdateTagGroupMutationVariables_>;

/**
 * __useAdminUpdateTagGroupMutation__
 *
 * To run a mutation, you first call `useAdminUpdateTagGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateTagGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateTagGroupMutation, { data, loading, error }] = useAdminUpdateTagGroupMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateTagGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateTagGroupMutation_, AdminUpdateTagGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateTagGroupMutation_, AdminUpdateTagGroupMutationVariables_>(AdminUpdateTagGroupDocument_, options);
      }
export type AdminUpdateTagGroupMutationHookResult = ReturnType<typeof useAdminUpdateTagGroupMutation>;
export type AdminUpdateTagGroupMutationResult_ = Apollo.MutationResult<AdminUpdateTagGroupMutation_>;
export type AdminUpdateTagGroupMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateTagGroupMutation_, AdminUpdateTagGroupMutationVariables_>;
export const AdminUpdateTag_ArticleDocument_ = gql`
    mutation AdminUpdateTag_article($pk_columns: Tag_articles_pk_columns_input!, $_set: Tag_articles_set_input!) {
  update_Tag_articles_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    tag_id
    article_id
  }
}
    `;
export type AdminUpdateTag_ArticleMutationFn_ = Apollo.MutationFunction<AdminUpdateTag_ArticleMutation_, AdminUpdateTag_ArticleMutationVariables_>;

/**
 * __useAdminUpdateTag_ArticleMutation__
 *
 * To run a mutation, you first call `useAdminUpdateTag_ArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateTag_ArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateTagArticleMutation, { data, loading, error }] = useAdminUpdateTag_ArticleMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateTag_ArticleMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateTag_ArticleMutation_, AdminUpdateTag_ArticleMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateTag_ArticleMutation_, AdminUpdateTag_ArticleMutationVariables_>(AdminUpdateTag_ArticleDocument_, options);
      }
export type AdminUpdateTag_ArticleMutationHookResult = ReturnType<typeof useAdminUpdateTag_ArticleMutation>;
export type AdminUpdateTag_ArticleMutationResult_ = Apollo.MutationResult<AdminUpdateTag_ArticleMutation_>;
export type AdminUpdateTag_ArticleMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateTag_ArticleMutation_, AdminUpdateTag_ArticleMutationVariables_>;
export const AdminCreateTag_ArticleDocument_ = gql`
    mutation AdminCreateTag_article($object: Tag_articles_insert_input!) {
  insert_Tag_articles_one(object: $object) {
    id
    tag_id
    article_id
  }
}
    `;
export type AdminCreateTag_ArticleMutationFn_ = Apollo.MutationFunction<AdminCreateTag_ArticleMutation_, AdminCreateTag_ArticleMutationVariables_>;

/**
 * __useAdminCreateTag_ArticleMutation__
 *
 * To run a mutation, you first call `useAdminCreateTag_ArticleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateTag_ArticleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateTagArticleMutation, { data, loading, error }] = useAdminCreateTag_ArticleMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateTag_ArticleMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateTag_ArticleMutation_, AdminCreateTag_ArticleMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateTag_ArticleMutation_, AdminCreateTag_ArticleMutationVariables_>(AdminCreateTag_ArticleDocument_, options);
      }
export type AdminCreateTag_ArticleMutationHookResult = ReturnType<typeof useAdminCreateTag_ArticleMutation>;
export type AdminCreateTag_ArticleMutationResult_ = Apollo.MutationResult<AdminCreateTag_ArticleMutation_>;
export type AdminCreateTag_ArticleMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateTag_ArticleMutation_, AdminCreateTag_ArticleMutationVariables_>;
export const AdminUpdatePaiCategoryDocument_ = gql`
    mutation AdminUpdatePaiCategory($pk_columns: PaiCategory_pk_columns_input!, $_set: PaiCategory_set_input!) {
  update_PaiCategory_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
    subtitle
    tableReference
  }
}
    `;
export type AdminUpdatePaiCategoryMutationFn_ = Apollo.MutationFunction<AdminUpdatePaiCategoryMutation_, AdminUpdatePaiCategoryMutationVariables_>;

/**
 * __useAdminUpdatePaiCategoryMutation__
 *
 * To run a mutation, you first call `useAdminUpdatePaiCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdatePaiCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdatePaiCategoryMutation, { data, loading, error }] = useAdminUpdatePaiCategoryMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdatePaiCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdatePaiCategoryMutation_, AdminUpdatePaiCategoryMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdatePaiCategoryMutation_, AdminUpdatePaiCategoryMutationVariables_>(AdminUpdatePaiCategoryDocument_, options);
      }
export type AdminUpdatePaiCategoryMutationHookResult = ReturnType<typeof useAdminUpdatePaiCategoryMutation>;
export type AdminUpdatePaiCategoryMutationResult_ = Apollo.MutationResult<AdminUpdatePaiCategoryMutation_>;
export type AdminUpdatePaiCategoryMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdatePaiCategoryMutation_, AdminUpdatePaiCategoryMutationVariables_>;
export const AdminCreatePaiCategoryDocument_ = gql`
    mutation AdminCreatePaiCategory($object: PaiCategory_insert_input!) {
  insert_PaiCategory_one(object: $object) {
    title
    reference
    subtitle
    tableReference
  }
}
    `;
export type AdminCreatePaiCategoryMutationFn_ = Apollo.MutationFunction<AdminCreatePaiCategoryMutation_, AdminCreatePaiCategoryMutationVariables_>;

/**
 * __useAdminCreatePaiCategoryMutation__
 *
 * To run a mutation, you first call `useAdminCreatePaiCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreatePaiCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreatePaiCategoryMutation, { data, loading, error }] = useAdminCreatePaiCategoryMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreatePaiCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreatePaiCategoryMutation_, AdminCreatePaiCategoryMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreatePaiCategoryMutation_, AdminCreatePaiCategoryMutationVariables_>(AdminCreatePaiCategoryDocument_, options);
      }
export type AdminCreatePaiCategoryMutationHookResult = ReturnType<typeof useAdminCreatePaiCategoryMutation>;
export type AdminCreatePaiCategoryMutationResult_ = Apollo.MutationResult<AdminCreatePaiCategoryMutation_>;
export type AdminCreatePaiCategoryMutationOptions_ = Apollo.BaseMutationOptions<AdminCreatePaiCategoryMutation_, AdminCreatePaiCategoryMutationVariables_>;
export const AdminUpdatePaiTableDocument_ = gql`
    mutation AdminUpdatePaiTable($pk_columns: PaiTable_pk_columns_input!, $_set: PaiTable_set_input!) {
  update_PaiTable_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
    isMandatory
    subtitle
    isCustom
  }
}
    `;
export type AdminUpdatePaiTableMutationFn_ = Apollo.MutationFunction<AdminUpdatePaiTableMutation_, AdminUpdatePaiTableMutationVariables_>;

/**
 * __useAdminUpdatePaiTableMutation__
 *
 * To run a mutation, you first call `useAdminUpdatePaiTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdatePaiTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdatePaiTableMutation, { data, loading, error }] = useAdminUpdatePaiTableMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdatePaiTableMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdatePaiTableMutation_, AdminUpdatePaiTableMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdatePaiTableMutation_, AdminUpdatePaiTableMutationVariables_>(AdminUpdatePaiTableDocument_, options);
      }
export type AdminUpdatePaiTableMutationHookResult = ReturnType<typeof useAdminUpdatePaiTableMutation>;
export type AdminUpdatePaiTableMutationResult_ = Apollo.MutationResult<AdminUpdatePaiTableMutation_>;
export type AdminUpdatePaiTableMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdatePaiTableMutation_, AdminUpdatePaiTableMutationVariables_>;
export const AdminCreatePaiTableDocument_ = gql`
    mutation AdminCreatePaiTable($object: PaiTable_insert_input!) {
  insert_PaiTable_one(object: $object) {
    title
    reference
    isMandatory
    subtitle
    isCustom
  }
}
    `;
export type AdminCreatePaiTableMutationFn_ = Apollo.MutationFunction<AdminCreatePaiTableMutation_, AdminCreatePaiTableMutationVariables_>;

/**
 * __useAdminCreatePaiTableMutation__
 *
 * To run a mutation, you first call `useAdminCreatePaiTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreatePaiTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreatePaiTableMutation, { data, loading, error }] = useAdminCreatePaiTableMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreatePaiTableMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreatePaiTableMutation_, AdminCreatePaiTableMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreatePaiTableMutation_, AdminCreatePaiTableMutationVariables_>(AdminCreatePaiTableDocument_, options);
      }
export type AdminCreatePaiTableMutationHookResult = ReturnType<typeof useAdminCreatePaiTableMutation>;
export type AdminCreatePaiTableMutationResult_ = Apollo.MutationResult<AdminCreatePaiTableMutation_>;
export type AdminCreatePaiTableMutationOptions_ = Apollo.BaseMutationOptions<AdminCreatePaiTableMutation_, AdminCreatePaiTableMutationVariables_>;
export const AdminUpdatePaiTableIndicatorDocument_ = gql`
    mutation AdminUpdatePaiTableIndicator($pk_columns: PaiTableIndicator_pk_columns_input!, $_set: PaiTableIndicator_set_input!) {
  update_PaiTableIndicator_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
    categoryReference
    description
    isHidden
    order
  }
}
    `;
export type AdminUpdatePaiTableIndicatorMutationFn_ = Apollo.MutationFunction<AdminUpdatePaiTableIndicatorMutation_, AdminUpdatePaiTableIndicatorMutationVariables_>;

/**
 * __useAdminUpdatePaiTableIndicatorMutation__
 *
 * To run a mutation, you first call `useAdminUpdatePaiTableIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdatePaiTableIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdatePaiTableIndicatorMutation, { data, loading, error }] = useAdminUpdatePaiTableIndicatorMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdatePaiTableIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdatePaiTableIndicatorMutation_, AdminUpdatePaiTableIndicatorMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdatePaiTableIndicatorMutation_, AdminUpdatePaiTableIndicatorMutationVariables_>(AdminUpdatePaiTableIndicatorDocument_, options);
      }
export type AdminUpdatePaiTableIndicatorMutationHookResult = ReturnType<typeof useAdminUpdatePaiTableIndicatorMutation>;
export type AdminUpdatePaiTableIndicatorMutationResult_ = Apollo.MutationResult<AdminUpdatePaiTableIndicatorMutation_>;
export type AdminUpdatePaiTableIndicatorMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdatePaiTableIndicatorMutation_, AdminUpdatePaiTableIndicatorMutationVariables_>;
export const AdminCreatePaiTableIndicatorDocument_ = gql`
    mutation AdminCreatePaiTableIndicator($object: PaiTableIndicator_insert_input!) {
  insert_PaiTableIndicator_one(object: $object) {
    title
    reference
    categoryReference
    description
    isHidden
    order
  }
}
    `;
export type AdminCreatePaiTableIndicatorMutationFn_ = Apollo.MutationFunction<AdminCreatePaiTableIndicatorMutation_, AdminCreatePaiTableIndicatorMutationVariables_>;

/**
 * __useAdminCreatePaiTableIndicatorMutation__
 *
 * To run a mutation, you first call `useAdminCreatePaiTableIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreatePaiTableIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreatePaiTableIndicatorMutation, { data, loading, error }] = useAdminCreatePaiTableIndicatorMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreatePaiTableIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreatePaiTableIndicatorMutation_, AdminCreatePaiTableIndicatorMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreatePaiTableIndicatorMutation_, AdminCreatePaiTableIndicatorMutationVariables_>(AdminCreatePaiTableIndicatorDocument_, options);
      }
export type AdminCreatePaiTableIndicatorMutationHookResult = ReturnType<typeof useAdminCreatePaiTableIndicatorMutation>;
export type AdminCreatePaiTableIndicatorMutationResult_ = Apollo.MutationResult<AdminCreatePaiTableIndicatorMutation_>;
export type AdminCreatePaiTableIndicatorMutationOptions_ = Apollo.BaseMutationOptions<AdminCreatePaiTableIndicatorMutation_, AdminCreatePaiTableIndicatorMutationVariables_>;
export const AdminUpdateInvestorMetricDocument_ = gql`
    mutation AdminUpdateInvestorMetric($pk_columns: InvestorMetric_pk_columns_input!, $_set: InvestorMetric_set_input!) {
  update_InvestorMetric_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
    description
    methodology
    unit
    isAggregatable
  }
}
    `;
export type AdminUpdateInvestorMetricMutationFn_ = Apollo.MutationFunction<AdminUpdateInvestorMetricMutation_, AdminUpdateInvestorMetricMutationVariables_>;

/**
 * __useAdminUpdateInvestorMetricMutation__
 *
 * To run a mutation, you first call `useAdminUpdateInvestorMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateInvestorMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateInvestorMetricMutation, { data, loading, error }] = useAdminUpdateInvestorMetricMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateInvestorMetricMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateInvestorMetricMutation_, AdminUpdateInvestorMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateInvestorMetricMutation_, AdminUpdateInvestorMetricMutationVariables_>(AdminUpdateInvestorMetricDocument_, options);
      }
export type AdminUpdateInvestorMetricMutationHookResult = ReturnType<typeof useAdminUpdateInvestorMetricMutation>;
export type AdminUpdateInvestorMetricMutationResult_ = Apollo.MutationResult<AdminUpdateInvestorMetricMutation_>;
export type AdminUpdateInvestorMetricMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateInvestorMetricMutation_, AdminUpdateInvestorMetricMutationVariables_>;
export const AdminCreateInvestorMetricDocument_ = gql`
    mutation AdminCreateInvestorMetric($object: InvestorMetric_insert_input!) {
  insert_InvestorMetric_one(object: $object) {
    title
    reference
    description
    methodology
    unit
    isAggregatable
  }
}
    `;
export type AdminCreateInvestorMetricMutationFn_ = Apollo.MutationFunction<AdminCreateInvestorMetricMutation_, AdminCreateInvestorMetricMutationVariables_>;

/**
 * __useAdminCreateInvestorMetricMutation__
 *
 * To run a mutation, you first call `useAdminCreateInvestorMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateInvestorMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateInvestorMetricMutation, { data, loading, error }] = useAdminCreateInvestorMetricMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateInvestorMetricMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateInvestorMetricMutation_, AdminCreateInvestorMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateInvestorMetricMutation_, AdminCreateInvestorMetricMutationVariables_>(AdminCreateInvestorMetricDocument_, options);
      }
export type AdminCreateInvestorMetricMutationHookResult = ReturnType<typeof useAdminCreateInvestorMetricMutation>;
export type AdminCreateInvestorMetricMutationResult_ = Apollo.MutationResult<AdminCreateInvestorMetricMutation_>;
export type AdminCreateInvestorMetricMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateInvestorMetricMutation_, AdminCreateInvestorMetricMutationVariables_>;
export const AdminUpdateInvesteeMetricDocument_ = gql`
    mutation AdminUpdateInvesteeMetric($pk_columns: InvesteeMetric_pk_columns_input!, $_set: InvesteeMetric_set_input!) {
  update_InvesteeMetric_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
    methodology
    description
    dependencies
    additionalResources
    type
    unit
    order
  }
}
    `;
export type AdminUpdateInvesteeMetricMutationFn_ = Apollo.MutationFunction<AdminUpdateInvesteeMetricMutation_, AdminUpdateInvesteeMetricMutationVariables_>;

/**
 * __useAdminUpdateInvesteeMetricMutation__
 *
 * To run a mutation, you first call `useAdminUpdateInvesteeMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateInvesteeMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateInvesteeMetricMutation, { data, loading, error }] = useAdminUpdateInvesteeMetricMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateInvesteeMetricMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateInvesteeMetricMutation_, AdminUpdateInvesteeMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateInvesteeMetricMutation_, AdminUpdateInvesteeMetricMutationVariables_>(AdminUpdateInvesteeMetricDocument_, options);
      }
export type AdminUpdateInvesteeMetricMutationHookResult = ReturnType<typeof useAdminUpdateInvesteeMetricMutation>;
export type AdminUpdateInvesteeMetricMutationResult_ = Apollo.MutationResult<AdminUpdateInvesteeMetricMutation_>;
export type AdminUpdateInvesteeMetricMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateInvesteeMetricMutation_, AdminUpdateInvesteeMetricMutationVariables_>;
export const AdminCreateInvesteeMetricDocument_ = gql`
    mutation AdminCreateInvesteeMetric($object: InvesteeMetric_insert_input!) {
  insert_InvesteeMetric_one(object: $object) {
    title
    reference
    methodology
    description
    dependencies
    additionalResources
    type
    unit
    order
  }
}
    `;
export type AdminCreateInvesteeMetricMutationFn_ = Apollo.MutationFunction<AdminCreateInvesteeMetricMutation_, AdminCreateInvesteeMetricMutationVariables_>;

/**
 * __useAdminCreateInvesteeMetricMutation__
 *
 * To run a mutation, you first call `useAdminCreateInvesteeMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateInvesteeMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateInvesteeMetricMutation, { data, loading, error }] = useAdminCreateInvesteeMetricMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateInvesteeMetricMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateInvesteeMetricMutation_, AdminCreateInvesteeMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateInvesteeMetricMutation_, AdminCreateInvesteeMetricMutationVariables_>(AdminCreateInvesteeMetricDocument_, options);
      }
export type AdminCreateInvesteeMetricMutationHookResult = ReturnType<typeof useAdminCreateInvesteeMetricMutation>;
export type AdminCreateInvesteeMetricMutationResult_ = Apollo.MutationResult<AdminCreateInvesteeMetricMutation_>;
export type AdminCreateInvesteeMetricMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateInvesteeMetricMutation_, AdminCreateInvesteeMetricMutationVariables_>;
export const AdminUpdateIndicatorToInvestorMetricDocument_ = gql`
    mutation AdminUpdateIndicatorToInvestorMetric($pk_columns: IndicatorToInvestorMetric_pk_columns_input!, $_set: IndicatorToInvestorMetric_set_input!) {
  update_IndicatorToInvestorMetric_by_pk(pk_columns: $pk_columns, _set: $_set) {
    investorMetricRef
    indicatorRef
  }
}
    `;
export type AdminUpdateIndicatorToInvestorMetricMutationFn_ = Apollo.MutationFunction<AdminUpdateIndicatorToInvestorMetricMutation_, AdminUpdateIndicatorToInvestorMetricMutationVariables_>;

/**
 * __useAdminUpdateIndicatorToInvestorMetricMutation__
 *
 * To run a mutation, you first call `useAdminUpdateIndicatorToInvestorMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateIndicatorToInvestorMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateIndicatorToInvestorMetricMutation, { data, loading, error }] = useAdminUpdateIndicatorToInvestorMetricMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateIndicatorToInvestorMetricMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateIndicatorToInvestorMetricMutation_, AdminUpdateIndicatorToInvestorMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateIndicatorToInvestorMetricMutation_, AdminUpdateIndicatorToInvestorMetricMutationVariables_>(AdminUpdateIndicatorToInvestorMetricDocument_, options);
      }
export type AdminUpdateIndicatorToInvestorMetricMutationHookResult = ReturnType<typeof useAdminUpdateIndicatorToInvestorMetricMutation>;
export type AdminUpdateIndicatorToInvestorMetricMutationResult_ = Apollo.MutationResult<AdminUpdateIndicatorToInvestorMetricMutation_>;
export type AdminUpdateIndicatorToInvestorMetricMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateIndicatorToInvestorMetricMutation_, AdminUpdateIndicatorToInvestorMetricMutationVariables_>;
export const AdminCreateIndicatorToInvestorMetricDocument_ = gql`
    mutation AdminCreateIndicatorToInvestorMetric($object: IndicatorToInvestorMetric_insert_input!) {
  insert_IndicatorToInvestorMetric_one(object: $object) {
    investorMetricRef
    indicatorRef
  }
}
    `;
export type AdminCreateIndicatorToInvestorMetricMutationFn_ = Apollo.MutationFunction<AdminCreateIndicatorToInvestorMetricMutation_, AdminCreateIndicatorToInvestorMetricMutationVariables_>;

/**
 * __useAdminCreateIndicatorToInvestorMetricMutation__
 *
 * To run a mutation, you first call `useAdminCreateIndicatorToInvestorMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateIndicatorToInvestorMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateIndicatorToInvestorMetricMutation, { data, loading, error }] = useAdminCreateIndicatorToInvestorMetricMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateIndicatorToInvestorMetricMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateIndicatorToInvestorMetricMutation_, AdminCreateIndicatorToInvestorMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateIndicatorToInvestorMetricMutation_, AdminCreateIndicatorToInvestorMetricMutationVariables_>(AdminCreateIndicatorToInvestorMetricDocument_, options);
      }
export type AdminCreateIndicatorToInvestorMetricMutationHookResult = ReturnType<typeof useAdminCreateIndicatorToInvestorMetricMutation>;
export type AdminCreateIndicatorToInvestorMetricMutationResult_ = Apollo.MutationResult<AdminCreateIndicatorToInvestorMetricMutation_>;
export type AdminCreateIndicatorToInvestorMetricMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateIndicatorToInvestorMetricMutation_, AdminCreateIndicatorToInvestorMetricMutationVariables_>;
export const AdminUpdateInvestorToInvesteeMetricDocument_ = gql`
    mutation AdminUpdateInvestorToInvesteeMetric($pk_columns: InvestorToInvesteeMetric_pk_columns_input!, $_set: InvestorToInvesteeMetric_set_input!) {
  update_InvestorToInvesteeMetric_by_pk(pk_columns: $pk_columns, _set: $_set) {
    investeeMetricReference
    investorMetricReference
  }
}
    `;
export type AdminUpdateInvestorToInvesteeMetricMutationFn_ = Apollo.MutationFunction<AdminUpdateInvestorToInvesteeMetricMutation_, AdminUpdateInvestorToInvesteeMetricMutationVariables_>;

/**
 * __useAdminUpdateInvestorToInvesteeMetricMutation__
 *
 * To run a mutation, you first call `useAdminUpdateInvestorToInvesteeMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateInvestorToInvesteeMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateInvestorToInvesteeMetricMutation, { data, loading, error }] = useAdminUpdateInvestorToInvesteeMetricMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateInvestorToInvesteeMetricMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateInvestorToInvesteeMetricMutation_, AdminUpdateInvestorToInvesteeMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateInvestorToInvesteeMetricMutation_, AdminUpdateInvestorToInvesteeMetricMutationVariables_>(AdminUpdateInvestorToInvesteeMetricDocument_, options);
      }
export type AdminUpdateInvestorToInvesteeMetricMutationHookResult = ReturnType<typeof useAdminUpdateInvestorToInvesteeMetricMutation>;
export type AdminUpdateInvestorToInvesteeMetricMutationResult_ = Apollo.MutationResult<AdminUpdateInvestorToInvesteeMetricMutation_>;
export type AdminUpdateInvestorToInvesteeMetricMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateInvestorToInvesteeMetricMutation_, AdminUpdateInvestorToInvesteeMetricMutationVariables_>;
export const AdminCreateInvestorToInvesteeMetricDocument_ = gql`
    mutation AdminCreateInvestorToInvesteeMetric($object: InvestorToInvesteeMetric_insert_input!) {
  insert_InvestorToInvesteeMetric_one(object: $object) {
    investeeMetricReference
    investorMetricReference
  }
}
    `;
export type AdminCreateInvestorToInvesteeMetricMutationFn_ = Apollo.MutationFunction<AdminCreateInvestorToInvesteeMetricMutation_, AdminCreateInvestorToInvesteeMetricMutationVariables_>;

/**
 * __useAdminCreateInvestorToInvesteeMetricMutation__
 *
 * To run a mutation, you first call `useAdminCreateInvestorToInvesteeMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateInvestorToInvesteeMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateInvestorToInvesteeMetricMutation, { data, loading, error }] = useAdminCreateInvestorToInvesteeMetricMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateInvestorToInvesteeMetricMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateInvestorToInvesteeMetricMutation_, AdminCreateInvestorToInvesteeMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateInvestorToInvesteeMetricMutation_, AdminCreateInvestorToInvesteeMetricMutationVariables_>(AdminCreateInvestorToInvesteeMetricDocument_, options);
      }
export type AdminCreateInvestorToInvesteeMetricMutationHookResult = ReturnType<typeof useAdminCreateInvestorToInvesteeMetricMutation>;
export type AdminCreateInvestorToInvesteeMetricMutationResult_ = Apollo.MutationResult<AdminCreateInvestorToInvesteeMetricMutation_>;
export type AdminCreateInvestorToInvesteeMetricMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateInvestorToInvesteeMetricMutation_, AdminCreateInvestorToInvesteeMetricMutationVariables_>;
export const AdminUpdateEsrsCategoryDocument_ = gql`
    mutation AdminUpdateEsrsCategory($pk_columns: EsrsCategory_pk_columns_input!, $_set: EsrsCategory_set_input!) {
  update_EsrsCategory_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
  }
}
    `;
export type AdminUpdateEsrsCategoryMutationFn_ = Apollo.MutationFunction<AdminUpdateEsrsCategoryMutation_, AdminUpdateEsrsCategoryMutationVariables_>;

/**
 * __useAdminUpdateEsrsCategoryMutation__
 *
 * To run a mutation, you first call `useAdminUpdateEsrsCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateEsrsCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateEsrsCategoryMutation, { data, loading, error }] = useAdminUpdateEsrsCategoryMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateEsrsCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateEsrsCategoryMutation_, AdminUpdateEsrsCategoryMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateEsrsCategoryMutation_, AdminUpdateEsrsCategoryMutationVariables_>(AdminUpdateEsrsCategoryDocument_, options);
      }
export type AdminUpdateEsrsCategoryMutationHookResult = ReturnType<typeof useAdminUpdateEsrsCategoryMutation>;
export type AdminUpdateEsrsCategoryMutationResult_ = Apollo.MutationResult<AdminUpdateEsrsCategoryMutation_>;
export type AdminUpdateEsrsCategoryMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateEsrsCategoryMutation_, AdminUpdateEsrsCategoryMutationVariables_>;
export const AdminCreateEsrsCategoryDocument_ = gql`
    mutation AdminCreateEsrsCategory($object: EsrsCategory_insert_input!) {
  insert_EsrsCategory_one(object: $object) {
    title
    reference
  }
}
    `;
export type AdminCreateEsrsCategoryMutationFn_ = Apollo.MutationFunction<AdminCreateEsrsCategoryMutation_, AdminCreateEsrsCategoryMutationVariables_>;

/**
 * __useAdminCreateEsrsCategoryMutation__
 *
 * To run a mutation, you first call `useAdminCreateEsrsCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateEsrsCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateEsrsCategoryMutation, { data, loading, error }] = useAdminCreateEsrsCategoryMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateEsrsCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateEsrsCategoryMutation_, AdminCreateEsrsCategoryMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateEsrsCategoryMutation_, AdminCreateEsrsCategoryMutationVariables_>(AdminCreateEsrsCategoryDocument_, options);
      }
export type AdminCreateEsrsCategoryMutationHookResult = ReturnType<typeof useAdminCreateEsrsCategoryMutation>;
export type AdminCreateEsrsCategoryMutationResult_ = Apollo.MutationResult<AdminCreateEsrsCategoryMutation_>;
export type AdminCreateEsrsCategoryMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateEsrsCategoryMutation_, AdminCreateEsrsCategoryMutationVariables_>;
export const AdminUpdateEsrsStandardDocument_ = gql`
    mutation AdminUpdateEsrsStandard($pk_columns: EsrsStandard_pk_columns_input!, $_set: EsrsStandard_set_input!) {
  update_EsrsStandard_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
    description
    isTopical
    categoryRef
    formattedPolicyChecklist
    aiPolicyChecklist
    frameworkRef
  }
}
    `;
export type AdminUpdateEsrsStandardMutationFn_ = Apollo.MutationFunction<AdminUpdateEsrsStandardMutation_, AdminUpdateEsrsStandardMutationVariables_>;

/**
 * __useAdminUpdateEsrsStandardMutation__
 *
 * To run a mutation, you first call `useAdminUpdateEsrsStandardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateEsrsStandardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateEsrsStandardMutation, { data, loading, error }] = useAdminUpdateEsrsStandardMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateEsrsStandardMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateEsrsStandardMutation_, AdminUpdateEsrsStandardMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateEsrsStandardMutation_, AdminUpdateEsrsStandardMutationVariables_>(AdminUpdateEsrsStandardDocument_, options);
      }
export type AdminUpdateEsrsStandardMutationHookResult = ReturnType<typeof useAdminUpdateEsrsStandardMutation>;
export type AdminUpdateEsrsStandardMutationResult_ = Apollo.MutationResult<AdminUpdateEsrsStandardMutation_>;
export type AdminUpdateEsrsStandardMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateEsrsStandardMutation_, AdminUpdateEsrsStandardMutationVariables_>;
export const AdminCreateEsrsStandardDocument_ = gql`
    mutation AdminCreateEsrsStandard($object: EsrsStandard_insert_input!) {
  insert_EsrsStandard_one(object: $object) {
    title
    reference
    description
    isTopical
    categoryRef
    formattedPolicyChecklist
    aiPolicyChecklist
    frameworkRef
  }
}
    `;
export type AdminCreateEsrsStandardMutationFn_ = Apollo.MutationFunction<AdminCreateEsrsStandardMutation_, AdminCreateEsrsStandardMutationVariables_>;

/**
 * __useAdminCreateEsrsStandardMutation__
 *
 * To run a mutation, you first call `useAdminCreateEsrsStandardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateEsrsStandardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateEsrsStandardMutation, { data, loading, error }] = useAdminCreateEsrsStandardMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateEsrsStandardMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateEsrsStandardMutation_, AdminCreateEsrsStandardMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateEsrsStandardMutation_, AdminCreateEsrsStandardMutationVariables_>(AdminCreateEsrsStandardDocument_, options);
      }
export type AdminCreateEsrsStandardMutationHookResult = ReturnType<typeof useAdminCreateEsrsStandardMutation>;
export type AdminCreateEsrsStandardMutationResult_ = Apollo.MutationResult<AdminCreateEsrsStandardMutation_>;
export type AdminCreateEsrsStandardMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateEsrsStandardMutation_, AdminCreateEsrsStandardMutationVariables_>;
export const AdminCreateEsrsStandardAdditionalTypesDocument_ = gql`
    mutation AdminCreateEsrsStandardAdditionalTypes($objects: [EsrsStandardAdditionalType_insert_input!]!) {
  insert_EsrsStandardAdditionalType(objects: $objects) {
    returning {
      standardRef
      additionalTypeRef
    }
  }
}
    `;
export type AdminCreateEsrsStandardAdditionalTypesMutationFn_ = Apollo.MutationFunction<AdminCreateEsrsStandardAdditionalTypesMutation_, AdminCreateEsrsStandardAdditionalTypesMutationVariables_>;

/**
 * __useAdminCreateEsrsStandardAdditionalTypesMutation__
 *
 * To run a mutation, you first call `useAdminCreateEsrsStandardAdditionalTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateEsrsStandardAdditionalTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateEsrsStandardAdditionalTypesMutation, { data, loading, error }] = useAdminCreateEsrsStandardAdditionalTypesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateEsrsStandardAdditionalTypesMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateEsrsStandardAdditionalTypesMutation_, AdminCreateEsrsStandardAdditionalTypesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateEsrsStandardAdditionalTypesMutation_, AdminCreateEsrsStandardAdditionalTypesMutationVariables_>(AdminCreateEsrsStandardAdditionalTypesDocument_, options);
      }
export type AdminCreateEsrsStandardAdditionalTypesMutationHookResult = ReturnType<typeof useAdminCreateEsrsStandardAdditionalTypesMutation>;
export type AdminCreateEsrsStandardAdditionalTypesMutationResult_ = Apollo.MutationResult<AdminCreateEsrsStandardAdditionalTypesMutation_>;
export type AdminCreateEsrsStandardAdditionalTypesMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateEsrsStandardAdditionalTypesMutation_, AdminCreateEsrsStandardAdditionalTypesMutationVariables_>;
export const AdminUpdateDisclosureRequirementGroupDocument_ = gql`
    mutation AdminUpdateDisclosureRequirementGroup($pk_columns: DisclosureRequirementGroup_pk_columns_input!, $_set: DisclosureRequirementGroup_set_input!) {
  update_DisclosureRequirementGroup_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
    standardRef
  }
}
    `;
export type AdminUpdateDisclosureRequirementGroupMutationFn_ = Apollo.MutationFunction<AdminUpdateDisclosureRequirementGroupMutation_, AdminUpdateDisclosureRequirementGroupMutationVariables_>;

/**
 * __useAdminUpdateDisclosureRequirementGroupMutation__
 *
 * To run a mutation, you first call `useAdminUpdateDisclosureRequirementGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateDisclosureRequirementGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateDisclosureRequirementGroupMutation, { data, loading, error }] = useAdminUpdateDisclosureRequirementGroupMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateDisclosureRequirementGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateDisclosureRequirementGroupMutation_, AdminUpdateDisclosureRequirementGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateDisclosureRequirementGroupMutation_, AdminUpdateDisclosureRequirementGroupMutationVariables_>(AdminUpdateDisclosureRequirementGroupDocument_, options);
      }
export type AdminUpdateDisclosureRequirementGroupMutationHookResult = ReturnType<typeof useAdminUpdateDisclosureRequirementGroupMutation>;
export type AdminUpdateDisclosureRequirementGroupMutationResult_ = Apollo.MutationResult<AdminUpdateDisclosureRequirementGroupMutation_>;
export type AdminUpdateDisclosureRequirementGroupMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateDisclosureRequirementGroupMutation_, AdminUpdateDisclosureRequirementGroupMutationVariables_>;
export const AdminCreateDisclosureRequirementGroupDocument_ = gql`
    mutation AdminCreateDisclosureRequirementGroup($object: DisclosureRequirementGroup_insert_input!) {
  insert_DisclosureRequirementGroup_one(object: $object) {
    title
    reference
    standardRef
  }
}
    `;
export type AdminCreateDisclosureRequirementGroupMutationFn_ = Apollo.MutationFunction<AdminCreateDisclosureRequirementGroupMutation_, AdminCreateDisclosureRequirementGroupMutationVariables_>;

/**
 * __useAdminCreateDisclosureRequirementGroupMutation__
 *
 * To run a mutation, you first call `useAdminCreateDisclosureRequirementGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateDisclosureRequirementGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateDisclosureRequirementGroupMutation, { data, loading, error }] = useAdminCreateDisclosureRequirementGroupMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateDisclosureRequirementGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateDisclosureRequirementGroupMutation_, AdminCreateDisclosureRequirementGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateDisclosureRequirementGroupMutation_, AdminCreateDisclosureRequirementGroupMutationVariables_>(AdminCreateDisclosureRequirementGroupDocument_, options);
      }
export type AdminCreateDisclosureRequirementGroupMutationHookResult = ReturnType<typeof useAdminCreateDisclosureRequirementGroupMutation>;
export type AdminCreateDisclosureRequirementGroupMutationResult_ = Apollo.MutationResult<AdminCreateDisclosureRequirementGroupMutation_>;
export type AdminCreateDisclosureRequirementGroupMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateDisclosureRequirementGroupMutation_, AdminCreateDisclosureRequirementGroupMutationVariables_>;
export const AdminUpdateDisclosureRequirementDocument_ = gql`
    mutation AdminUpdateDisclosureRequirement($pk_columns: DisclosureRequirement_pk_columns_input!, $_set: DisclosureRequirement_set_input!) {
  update_DisclosureRequirement_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    shortTitle
    reference
    groupRef
    type
    order
    description
    isMandatory
  }
}
    `;
export type AdminUpdateDisclosureRequirementMutationFn_ = Apollo.MutationFunction<AdminUpdateDisclosureRequirementMutation_, AdminUpdateDisclosureRequirementMutationVariables_>;

/**
 * __useAdminUpdateDisclosureRequirementMutation__
 *
 * To run a mutation, you first call `useAdminUpdateDisclosureRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateDisclosureRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateDisclosureRequirementMutation, { data, loading, error }] = useAdminUpdateDisclosureRequirementMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateDisclosureRequirementMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateDisclosureRequirementMutation_, AdminUpdateDisclosureRequirementMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateDisclosureRequirementMutation_, AdminUpdateDisclosureRequirementMutationVariables_>(AdminUpdateDisclosureRequirementDocument_, options);
      }
export type AdminUpdateDisclosureRequirementMutationHookResult = ReturnType<typeof useAdminUpdateDisclosureRequirementMutation>;
export type AdminUpdateDisclosureRequirementMutationResult_ = Apollo.MutationResult<AdminUpdateDisclosureRequirementMutation_>;
export type AdminUpdateDisclosureRequirementMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateDisclosureRequirementMutation_, AdminUpdateDisclosureRequirementMutationVariables_>;
export const AdminCreateDisclosureRequirementDocument_ = gql`
    mutation AdminCreateDisclosureRequirement($object: DisclosureRequirement_insert_input!) {
  insert_DisclosureRequirement_one(object: $object) {
    title
    shortTitle
    reference
    groupRef
    type
    order
    description
    isMandatory
  }
}
    `;
export type AdminCreateDisclosureRequirementMutationFn_ = Apollo.MutationFunction<AdminCreateDisclosureRequirementMutation_, AdminCreateDisclosureRequirementMutationVariables_>;

/**
 * __useAdminCreateDisclosureRequirementMutation__
 *
 * To run a mutation, you first call `useAdminCreateDisclosureRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateDisclosureRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateDisclosureRequirementMutation, { data, loading, error }] = useAdminCreateDisclosureRequirementMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateDisclosureRequirementMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateDisclosureRequirementMutation_, AdminCreateDisclosureRequirementMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateDisclosureRequirementMutation_, AdminCreateDisclosureRequirementMutationVariables_>(AdminCreateDisclosureRequirementDocument_, options);
      }
export type AdminCreateDisclosureRequirementMutationHookResult = ReturnType<typeof useAdminCreateDisclosureRequirementMutation>;
export type AdminCreateDisclosureRequirementMutationResult_ = Apollo.MutationResult<AdminCreateDisclosureRequirementMutation_>;
export type AdminCreateDisclosureRequirementMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateDisclosureRequirementMutation_, AdminCreateDisclosureRequirementMutationVariables_>;
export const AdminCreateDisclosureRequirementAdditionalTypesDocument_ = gql`
    mutation AdminCreateDisclosureRequirementAdditionalTypes($objects: [DisclosureRequirementAdditionalType_insert_input!]!) {
  insert_DisclosureRequirementAdditionalType(objects: $objects) {
    returning {
      disclosureRequirementRef
      additionalTypeRef
    }
  }
}
    `;
export type AdminCreateDisclosureRequirementAdditionalTypesMutationFn_ = Apollo.MutationFunction<AdminCreateDisclosureRequirementAdditionalTypesMutation_, AdminCreateDisclosureRequirementAdditionalTypesMutationVariables_>;

/**
 * __useAdminCreateDisclosureRequirementAdditionalTypesMutation__
 *
 * To run a mutation, you first call `useAdminCreateDisclosureRequirementAdditionalTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateDisclosureRequirementAdditionalTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateDisclosureRequirementAdditionalTypesMutation, { data, loading, error }] = useAdminCreateDisclosureRequirementAdditionalTypesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateDisclosureRequirementAdditionalTypesMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateDisclosureRequirementAdditionalTypesMutation_, AdminCreateDisclosureRequirementAdditionalTypesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateDisclosureRequirementAdditionalTypesMutation_, AdminCreateDisclosureRequirementAdditionalTypesMutationVariables_>(AdminCreateDisclosureRequirementAdditionalTypesDocument_, options);
      }
export type AdminCreateDisclosureRequirementAdditionalTypesMutationHookResult = ReturnType<typeof useAdminCreateDisclosureRequirementAdditionalTypesMutation>;
export type AdminCreateDisclosureRequirementAdditionalTypesMutationResult_ = Apollo.MutationResult<AdminCreateDisclosureRequirementAdditionalTypesMutation_>;
export type AdminCreateDisclosureRequirementAdditionalTypesMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateDisclosureRequirementAdditionalTypesMutation_, AdminCreateDisclosureRequirementAdditionalTypesMutationVariables_>;
export const AdminCreateEsrsMetricDocument_ = gql`
    mutation AdminCreateEsrsMetric($object: EsrsMetric_insert_input!) {
  insert_EsrsMetric_one(object: $object) {
    title
    shortTitle
    reference
    description
    calculation
    disclosureRequirementRef
    metricType
    unitOfMeasurement
    isAssessable
    firstLevel
    secondLevel
    order
    isGroup
    showAsPercentage
    isAR
    globalOrder
    hasAssociation
    canBeUsedForTarget
    unlockCondition
    choiceSetRef
    showPercentageWithTag
    notAggregatable
    abbreviation
  }
}
    `;
export type AdminCreateEsrsMetricMutationFn_ = Apollo.MutationFunction<AdminCreateEsrsMetricMutation_, AdminCreateEsrsMetricMutationVariables_>;

/**
 * __useAdminCreateEsrsMetricMutation__
 *
 * To run a mutation, you first call `useAdminCreateEsrsMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateEsrsMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateEsrsMetricMutation, { data, loading, error }] = useAdminCreateEsrsMetricMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateEsrsMetricMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateEsrsMetricMutation_, AdminCreateEsrsMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateEsrsMetricMutation_, AdminCreateEsrsMetricMutationVariables_>(AdminCreateEsrsMetricDocument_, options);
      }
export type AdminCreateEsrsMetricMutationHookResult = ReturnType<typeof useAdminCreateEsrsMetricMutation>;
export type AdminCreateEsrsMetricMutationResult_ = Apollo.MutationResult<AdminCreateEsrsMetricMutation_>;
export type AdminCreateEsrsMetricMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateEsrsMetricMutation_, AdminCreateEsrsMetricMutationVariables_>;
export const AdminUpdateEsrsMetricDocument_ = gql`
    mutation AdminUpdateEsrsMetric($pk_columns: EsrsMetric_pk_columns_input!, $_set: EsrsMetric_set_input!) {
  update_EsrsMetric_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    shortTitle
    reference
    description
    calculation
    disclosureRequirementRef
    metricType
    unitOfMeasurement
    isAssessable
    firstLevel
    secondLevel
    order
    isGroup
    showAsPercentage
    isAR
    globalOrder
    hasAssociation
    canBeUsedForTarget
    unlockCondition
    choiceSetRef
    showPercentageWithTag
    notAggregatable
    abbreviation
  }
}
    `;
export type AdminUpdateEsrsMetricMutationFn_ = Apollo.MutationFunction<AdminUpdateEsrsMetricMutation_, AdminUpdateEsrsMetricMutationVariables_>;

/**
 * __useAdminUpdateEsrsMetricMutation__
 *
 * To run a mutation, you first call `useAdminUpdateEsrsMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateEsrsMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateEsrsMetricMutation, { data, loading, error }] = useAdminUpdateEsrsMetricMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateEsrsMetricMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateEsrsMetricMutation_, AdminUpdateEsrsMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateEsrsMetricMutation_, AdminUpdateEsrsMetricMutationVariables_>(AdminUpdateEsrsMetricDocument_, options);
      }
export type AdminUpdateEsrsMetricMutationHookResult = ReturnType<typeof useAdminUpdateEsrsMetricMutation>;
export type AdminUpdateEsrsMetricMutationResult_ = Apollo.MutationResult<AdminUpdateEsrsMetricMutation_>;
export type AdminUpdateEsrsMetricMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateEsrsMetricMutation_, AdminUpdateEsrsMetricMutationVariables_>;
export const AdminCreateMetricDependenciesDocument_ = gql`
    mutation AdminCreateMetricDependencies($objects: [MetricDependency_insert_input!]!) {
  insert_MetricDependency(objects: $objects) {
    returning {
      parentMetricRef
      childMetricRef
    }
  }
}
    `;
export type AdminCreateMetricDependenciesMutationFn_ = Apollo.MutationFunction<AdminCreateMetricDependenciesMutation_, AdminCreateMetricDependenciesMutationVariables_>;

/**
 * __useAdminCreateMetricDependenciesMutation__
 *
 * To run a mutation, you first call `useAdminCreateMetricDependenciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMetricDependenciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMetricDependenciesMutation, { data, loading, error }] = useAdminCreateMetricDependenciesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateMetricDependenciesMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMetricDependenciesMutation_, AdminCreateMetricDependenciesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMetricDependenciesMutation_, AdminCreateMetricDependenciesMutationVariables_>(AdminCreateMetricDependenciesDocument_, options);
      }
export type AdminCreateMetricDependenciesMutationHookResult = ReturnType<typeof useAdminCreateMetricDependenciesMutation>;
export type AdminCreateMetricDependenciesMutationResult_ = Apollo.MutationResult<AdminCreateMetricDependenciesMutation_>;
export type AdminCreateMetricDependenciesMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateMetricDependenciesMutation_, AdminCreateMetricDependenciesMutationVariables_>;
export const AdminCreateMetricTagsDocument_ = gql`
    mutation AdminCreateMetricTags($objects: [MetricTag_insert_input!]!) {
  insert_MetricTag(objects: $objects) {
    returning {
      metricRef
      type
      isOptional
    }
  }
}
    `;
export type AdminCreateMetricTagsMutationFn_ = Apollo.MutationFunction<AdminCreateMetricTagsMutation_, AdminCreateMetricTagsMutationVariables_>;

/**
 * __useAdminCreateMetricTagsMutation__
 *
 * To run a mutation, you first call `useAdminCreateMetricTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMetricTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMetricTagsMutation, { data, loading, error }] = useAdminCreateMetricTagsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateMetricTagsMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMetricTagsMutation_, AdminCreateMetricTagsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMetricTagsMutation_, AdminCreateMetricTagsMutationVariables_>(AdminCreateMetricTagsDocument_, options);
      }
export type AdminCreateMetricTagsMutationHookResult = ReturnType<typeof useAdminCreateMetricTagsMutation>;
export type AdminCreateMetricTagsMutationResult_ = Apollo.MutationResult<AdminCreateMetricTagsMutation_>;
export type AdminCreateMetricTagsMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateMetricTagsMutation_, AdminCreateMetricTagsMutationVariables_>;
export const AdminCreateEsrsMetricAdditionalTypesDocument_ = gql`
    mutation AdminCreateEsrsMetricAdditionalTypes($objects: [EsrsMetricAdditionalType_insert_input!]!) {
  insert_EsrsMetricAdditionalType(objects: $objects) {
    returning {
      metricRef
      additionalTypeRef
    }
  }
}
    `;
export type AdminCreateEsrsMetricAdditionalTypesMutationFn_ = Apollo.MutationFunction<AdminCreateEsrsMetricAdditionalTypesMutation_, AdminCreateEsrsMetricAdditionalTypesMutationVariables_>;

/**
 * __useAdminCreateEsrsMetricAdditionalTypesMutation__
 *
 * To run a mutation, you first call `useAdminCreateEsrsMetricAdditionalTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateEsrsMetricAdditionalTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateEsrsMetricAdditionalTypesMutation, { data, loading, error }] = useAdminCreateEsrsMetricAdditionalTypesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateEsrsMetricAdditionalTypesMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateEsrsMetricAdditionalTypesMutation_, AdminCreateEsrsMetricAdditionalTypesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateEsrsMetricAdditionalTypesMutation_, AdminCreateEsrsMetricAdditionalTypesMutationVariables_>(AdminCreateEsrsMetricAdditionalTypesDocument_, options);
      }
export type AdminCreateEsrsMetricAdditionalTypesMutationHookResult = ReturnType<typeof useAdminCreateEsrsMetricAdditionalTypesMutation>;
export type AdminCreateEsrsMetricAdditionalTypesMutationResult_ = Apollo.MutationResult<AdminCreateEsrsMetricAdditionalTypesMutation_>;
export type AdminCreateEsrsMetricAdditionalTypesMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateEsrsMetricAdditionalTypesMutation_, AdminCreateEsrsMetricAdditionalTypesMutationVariables_>;
export const AdminUpdateTagTypeDocument_ = gql`
    mutation AdminUpdateTagType($pk_columns: TagType_pk_columns_input!, $_set: TagType_set_input!) {
  update_TagType_by_pk(pk_columns: $pk_columns, _set: $_set) {
    type
    alwaysAll
  }
}
    `;
export type AdminUpdateTagTypeMutationFn_ = Apollo.MutationFunction<AdminUpdateTagTypeMutation_, AdminUpdateTagTypeMutationVariables_>;

/**
 * __useAdminUpdateTagTypeMutation__
 *
 * To run a mutation, you first call `useAdminUpdateTagTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateTagTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateTagTypeMutation, { data, loading, error }] = useAdminUpdateTagTypeMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateTagTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateTagTypeMutation_, AdminUpdateTagTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateTagTypeMutation_, AdminUpdateTagTypeMutationVariables_>(AdminUpdateTagTypeDocument_, options);
      }
export type AdminUpdateTagTypeMutationHookResult = ReturnType<typeof useAdminUpdateTagTypeMutation>;
export type AdminUpdateTagTypeMutationResult_ = Apollo.MutationResult<AdminUpdateTagTypeMutation_>;
export type AdminUpdateTagTypeMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateTagTypeMutation_, AdminUpdateTagTypeMutationVariables_>;
export const AdminCreateTagTypeDocument_ = gql`
    mutation AdminCreateTagType($object: TagType_insert_input!) {
  insert_TagType_one(object: $object) {
    type
    alwaysAll
  }
}
    `;
export type AdminCreateTagTypeMutationFn_ = Apollo.MutationFunction<AdminCreateTagTypeMutation_, AdminCreateTagTypeMutationVariables_>;

/**
 * __useAdminCreateTagTypeMutation__
 *
 * To run a mutation, you first call `useAdminCreateTagTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateTagTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateTagTypeMutation, { data, loading, error }] = useAdminCreateTagTypeMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateTagTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateTagTypeMutation_, AdminCreateTagTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateTagTypeMutation_, AdminCreateTagTypeMutationVariables_>(AdminCreateTagTypeDocument_, options);
      }
export type AdminCreateTagTypeMutationHookResult = ReturnType<typeof useAdminCreateTagTypeMutation>;
export type AdminCreateTagTypeMutationResult_ = Apollo.MutationResult<AdminCreateTagTypeMutation_>;
export type AdminCreateTagTypeMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateTagTypeMutation_, AdminCreateTagTypeMutationVariables_>;
export const AdminCreateTagValuesDocument_ = gql`
    mutation AdminCreateTagValues($objects: [TagValue_insert_input!]!) {
  insert_TagValue(objects: $objects) {
    returning {
      value
      type
      order
    }
  }
}
    `;
export type AdminCreateTagValuesMutationFn_ = Apollo.MutationFunction<AdminCreateTagValuesMutation_, AdminCreateTagValuesMutationVariables_>;

/**
 * __useAdminCreateTagValuesMutation__
 *
 * To run a mutation, you first call `useAdminCreateTagValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateTagValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateTagValuesMutation, { data, loading, error }] = useAdminCreateTagValuesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateTagValuesMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateTagValuesMutation_, AdminCreateTagValuesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateTagValuesMutation_, AdminCreateTagValuesMutationVariables_>(AdminCreateTagValuesDocument_, options);
      }
export type AdminCreateTagValuesMutationHookResult = ReturnType<typeof useAdminCreateTagValuesMutation>;
export type AdminCreateTagValuesMutationResult_ = Apollo.MutationResult<AdminCreateTagValuesMutation_>;
export type AdminCreateTagValuesMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateTagValuesMutation_, AdminCreateTagValuesMutationVariables_>;
export const AdminUpdateTagValueDocument_ = gql`
    mutation AdminUpdateTagValue($pk_columns: TagValue_pk_columns_input!, $_set: TagValue_set_input!) {
  update_TagValue_by_pk(pk_columns: $pk_columns, _set: $_set) {
    value
    type
    order
  }
}
    `;
export type AdminUpdateTagValueMutationFn_ = Apollo.MutationFunction<AdminUpdateTagValueMutation_, AdminUpdateTagValueMutationVariables_>;

/**
 * __useAdminUpdateTagValueMutation__
 *
 * To run a mutation, you first call `useAdminUpdateTagValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateTagValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateTagValueMutation, { data, loading, error }] = useAdminUpdateTagValueMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateTagValueMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateTagValueMutation_, AdminUpdateTagValueMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateTagValueMutation_, AdminUpdateTagValueMutationVariables_>(AdminUpdateTagValueDocument_, options);
      }
export type AdminUpdateTagValueMutationHookResult = ReturnType<typeof useAdminUpdateTagValueMutation>;
export type AdminUpdateTagValueMutationResult_ = Apollo.MutationResult<AdminUpdateTagValueMutation_>;
export type AdminUpdateTagValueMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateTagValueMutation_, AdminUpdateTagValueMutationVariables_>;
export const AdminCreateTagValueDocument_ = gql`
    mutation AdminCreateTagValue($object: TagValue_insert_input!) {
  insert_TagValue_one(object: $object) {
    value
    type
    order
  }
}
    `;
export type AdminCreateTagValueMutationFn_ = Apollo.MutationFunction<AdminCreateTagValueMutation_, AdminCreateTagValueMutationVariables_>;

/**
 * __useAdminCreateTagValueMutation__
 *
 * To run a mutation, you first call `useAdminCreateTagValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateTagValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateTagValueMutation, { data, loading, error }] = useAdminCreateTagValueMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateTagValueMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateTagValueMutation_, AdminCreateTagValueMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateTagValueMutation_, AdminCreateTagValueMutationVariables_>(AdminCreateTagValueDocument_, options);
      }
export type AdminCreateTagValueMutationHookResult = ReturnType<typeof useAdminCreateTagValueMutation>;
export type AdminCreateTagValueMutationResult_ = Apollo.MutationResult<AdminCreateTagValueMutation_>;
export type AdminCreateTagValueMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateTagValueMutation_, AdminCreateTagValueMutationVariables_>;
export const AdminUpdateAdditionalTypeDocument_ = gql`
    mutation AdminUpdateAdditionalType($pk_columns: AdditionalType_pk_columns_input!, $_set: AdditionalType_set_input!) {
  update_AdditionalType_by_pk(pk_columns: $pk_columns, _set: $_set) {
    reference
    title
    description
    learnMore
  }
}
    `;
export type AdminUpdateAdditionalTypeMutationFn_ = Apollo.MutationFunction<AdminUpdateAdditionalTypeMutation_, AdminUpdateAdditionalTypeMutationVariables_>;

/**
 * __useAdminUpdateAdditionalTypeMutation__
 *
 * To run a mutation, you first call `useAdminUpdateAdditionalTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateAdditionalTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateAdditionalTypeMutation, { data, loading, error }] = useAdminUpdateAdditionalTypeMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateAdditionalTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateAdditionalTypeMutation_, AdminUpdateAdditionalTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateAdditionalTypeMutation_, AdminUpdateAdditionalTypeMutationVariables_>(AdminUpdateAdditionalTypeDocument_, options);
      }
export type AdminUpdateAdditionalTypeMutationHookResult = ReturnType<typeof useAdminUpdateAdditionalTypeMutation>;
export type AdminUpdateAdditionalTypeMutationResult_ = Apollo.MutationResult<AdminUpdateAdditionalTypeMutation_>;
export type AdminUpdateAdditionalTypeMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateAdditionalTypeMutation_, AdminUpdateAdditionalTypeMutationVariables_>;
export const AdminCreateAdditionalTypeDocument_ = gql`
    mutation AdminCreateAdditionalType($object: AdditionalType_insert_input!) {
  insert_AdditionalType_one(object: $object) {
    reference
    title
    description
    learnMore
  }
}
    `;
export type AdminCreateAdditionalTypeMutationFn_ = Apollo.MutationFunction<AdminCreateAdditionalTypeMutation_, AdminCreateAdditionalTypeMutationVariables_>;

/**
 * __useAdminCreateAdditionalTypeMutation__
 *
 * To run a mutation, you first call `useAdminCreateAdditionalTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateAdditionalTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateAdditionalTypeMutation, { data, loading, error }] = useAdminCreateAdditionalTypeMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateAdditionalTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateAdditionalTypeMutation_, AdminCreateAdditionalTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateAdditionalTypeMutation_, AdminCreateAdditionalTypeMutationVariables_>(AdminCreateAdditionalTypeDocument_, options);
      }
export type AdminCreateAdditionalTypeMutationHookResult = ReturnType<typeof useAdminCreateAdditionalTypeMutation>;
export type AdminCreateAdditionalTypeMutationResult_ = Apollo.MutationResult<AdminCreateAdditionalTypeMutation_>;
export type AdminCreateAdditionalTypeMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateAdditionalTypeMutation_, AdminCreateAdditionalTypeMutationVariables_>;
export const AdminCreateTargetQuestionDocument_ = gql`
    mutation AdminCreateTargetQuestion($object: TargetQuestion_insert_input!) {
  insert_TargetQuestion_one(object: $object) {
    title
    reference
    standardRef
    unit
    questionType
    order
    description
    groupRef
    choiceSetRef
  }
}
    `;
export type AdminCreateTargetQuestionMutationFn_ = Apollo.MutationFunction<AdminCreateTargetQuestionMutation_, AdminCreateTargetQuestionMutationVariables_>;

/**
 * __useAdminCreateTargetQuestionMutation__
 *
 * To run a mutation, you first call `useAdminCreateTargetQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateTargetQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateTargetQuestionMutation, { data, loading, error }] = useAdminCreateTargetQuestionMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateTargetQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateTargetQuestionMutation_, AdminCreateTargetQuestionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateTargetQuestionMutation_, AdminCreateTargetQuestionMutationVariables_>(AdminCreateTargetQuestionDocument_, options);
      }
export type AdminCreateTargetQuestionMutationHookResult = ReturnType<typeof useAdminCreateTargetQuestionMutation>;
export type AdminCreateTargetQuestionMutationResult_ = Apollo.MutationResult<AdminCreateTargetQuestionMutation_>;
export type AdminCreateTargetQuestionMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateTargetQuestionMutation_, AdminCreateTargetQuestionMutationVariables_>;
export const AdminGetTargetQuestionDocument_ = gql`
    query AdminGetTargetQuestion($reference: String!) {
  TargetQuestion_by_pk(reference: $reference) {
    title
    reference
    standardRef
    unit
    questionType
    order
    description
    groupRef
    globalOrder
    firstLevel
    secondLevel
    isAR
    choiceSetRef
  }
}
    `;

/**
 * __useAdminGetTargetQuestionQuery__
 *
 * To run a query within a React component, call `useAdminGetTargetQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetTargetQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetTargetQuestionQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetTargetQuestionQuery(baseOptions: Apollo.QueryHookOptions<AdminGetTargetQuestionQuery_, AdminGetTargetQuestionQueryVariables_> & ({ variables: AdminGetTargetQuestionQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetTargetQuestionQuery_, AdminGetTargetQuestionQueryVariables_>(AdminGetTargetQuestionDocument_, options);
      }
export function useAdminGetTargetQuestionLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetTargetQuestionQuery_, AdminGetTargetQuestionQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetTargetQuestionQuery_, AdminGetTargetQuestionQueryVariables_>(AdminGetTargetQuestionDocument_, options);
        }
export function useAdminGetTargetQuestionSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetTargetQuestionQuery_, AdminGetTargetQuestionQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetTargetQuestionQuery_, AdminGetTargetQuestionQueryVariables_>(AdminGetTargetQuestionDocument_, options);
        }
export type AdminGetTargetQuestionQueryHookResult = ReturnType<typeof useAdminGetTargetQuestionQuery>;
export type AdminGetTargetQuestionLazyQuery_HookResult = ReturnType<typeof useAdminGetTargetQuestionLazyQuery_>;
export type AdminGetTargetQuestionSuspenseQuery_HookResult = ReturnType<typeof useAdminGetTargetQuestionSuspenseQuery_>;
export type AdminGetTargetQuestionQueryResult_ = Apollo.QueryResult<AdminGetTargetQuestionQuery_, AdminGetTargetQuestionQueryVariables_>;
export function refetchAdminGetTargetQuestionQuery_(variables: AdminGetTargetQuestionQueryVariables_) {
      return { query: AdminGetTargetQuestionDocument_, variables: variables }
    }
export const AdminUpdateTargetQuestionDocument_ = gql`
    mutation AdminUpdateTargetQuestion($pk_columns: TargetQuestion_pk_columns_input!, $_set: TargetQuestion_set_input!) {
  update_TargetQuestion_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
    standardRef
    unit
    questionType
    order
    description
    groupRef
    choiceSetRef
  }
}
    `;
export type AdminUpdateTargetQuestionMutationFn_ = Apollo.MutationFunction<AdminUpdateTargetQuestionMutation_, AdminUpdateTargetQuestionMutationVariables_>;

/**
 * __useAdminUpdateTargetQuestionMutation__
 *
 * To run a mutation, you first call `useAdminUpdateTargetQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateTargetQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateTargetQuestionMutation, { data, loading, error }] = useAdminUpdateTargetQuestionMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateTargetQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateTargetQuestionMutation_, AdminUpdateTargetQuestionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateTargetQuestionMutation_, AdminUpdateTargetQuestionMutationVariables_>(AdminUpdateTargetQuestionDocument_, options);
      }
export type AdminUpdateTargetQuestionMutationHookResult = ReturnType<typeof useAdminUpdateTargetQuestionMutation>;
export type AdminUpdateTargetQuestionMutationResult_ = Apollo.MutationResult<AdminUpdateTargetQuestionMutation_>;
export type AdminUpdateTargetQuestionMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateTargetQuestionMutation_, AdminUpdateTargetQuestionMutationVariables_>;
export const AdminDeleteTargetQuestionDocument_ = gql`
    mutation AdminDeleteTargetQuestion($reference: String!) {
  delete_TargetQuestion_by_pk(reference: $reference) {
    title
    reference
    standardRef
    unit
    questionType
    order
    description
    groupRef
    choiceSetRef
  }
}
    `;
export type AdminDeleteTargetQuestionMutationFn_ = Apollo.MutationFunction<AdminDeleteTargetQuestionMutation_, AdminDeleteTargetQuestionMutationVariables_>;

/**
 * __useAdminDeleteTargetQuestionMutation__
 *
 * To run a mutation, you first call `useAdminDeleteTargetQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteTargetQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteTargetQuestionMutation, { data, loading, error }] = useAdminDeleteTargetQuestionMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteTargetQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteTargetQuestionMutation_, AdminDeleteTargetQuestionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteTargetQuestionMutation_, AdminDeleteTargetQuestionMutationVariables_>(AdminDeleteTargetQuestionDocument_, options);
      }
export type AdminDeleteTargetQuestionMutationHookResult = ReturnType<typeof useAdminDeleteTargetQuestionMutation>;
export type AdminDeleteTargetQuestionMutationResult_ = Apollo.MutationResult<AdminDeleteTargetQuestionMutation_>;
export type AdminDeleteTargetQuestionMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteTargetQuestionMutation_, AdminDeleteTargetQuestionMutationVariables_>;
export const AdminGetTargetQuestionGroupDocument_ = gql`
    query AdminGetTargetQuestionGroup($reference: String!) {
  TargetQuestionGroup_by_pk(reference: $reference) {
    title
    reference
  }
}
    `;

/**
 * __useAdminGetTargetQuestionGroupQuery__
 *
 * To run a query within a React component, call `useAdminGetTargetQuestionGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetTargetQuestionGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetTargetQuestionGroupQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetTargetQuestionGroupQuery(baseOptions: Apollo.QueryHookOptions<AdminGetTargetQuestionGroupQuery_, AdminGetTargetQuestionGroupQueryVariables_> & ({ variables: AdminGetTargetQuestionGroupQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetTargetQuestionGroupQuery_, AdminGetTargetQuestionGroupQueryVariables_>(AdminGetTargetQuestionGroupDocument_, options);
      }
export function useAdminGetTargetQuestionGroupLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetTargetQuestionGroupQuery_, AdminGetTargetQuestionGroupQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetTargetQuestionGroupQuery_, AdminGetTargetQuestionGroupQueryVariables_>(AdminGetTargetQuestionGroupDocument_, options);
        }
export function useAdminGetTargetQuestionGroupSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetTargetQuestionGroupQuery_, AdminGetTargetQuestionGroupQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetTargetQuestionGroupQuery_, AdminGetTargetQuestionGroupQueryVariables_>(AdminGetTargetQuestionGroupDocument_, options);
        }
export type AdminGetTargetQuestionGroupQueryHookResult = ReturnType<typeof useAdminGetTargetQuestionGroupQuery>;
export type AdminGetTargetQuestionGroupLazyQuery_HookResult = ReturnType<typeof useAdminGetTargetQuestionGroupLazyQuery_>;
export type AdminGetTargetQuestionGroupSuspenseQuery_HookResult = ReturnType<typeof useAdminGetTargetQuestionGroupSuspenseQuery_>;
export type AdminGetTargetQuestionGroupQueryResult_ = Apollo.QueryResult<AdminGetTargetQuestionGroupQuery_, AdminGetTargetQuestionGroupQueryVariables_>;
export function refetchAdminGetTargetQuestionGroupQuery_(variables: AdminGetTargetQuestionGroupQueryVariables_) {
      return { query: AdminGetTargetQuestionGroupDocument_, variables: variables }
    }
export const AdminDeleteTargetQuestionGroupDocument_ = gql`
    mutation AdminDeleteTargetQuestionGroup($reference: String!) {
  delete_TargetQuestionGroup_by_pk(reference: $reference) {
    title
    reference
  }
}
    `;
export type AdminDeleteTargetQuestionGroupMutationFn_ = Apollo.MutationFunction<AdminDeleteTargetQuestionGroupMutation_, AdminDeleteTargetQuestionGroupMutationVariables_>;

/**
 * __useAdminDeleteTargetQuestionGroupMutation__
 *
 * To run a mutation, you first call `useAdminDeleteTargetQuestionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteTargetQuestionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteTargetQuestionGroupMutation, { data, loading, error }] = useAdminDeleteTargetQuestionGroupMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteTargetQuestionGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteTargetQuestionGroupMutation_, AdminDeleteTargetQuestionGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteTargetQuestionGroupMutation_, AdminDeleteTargetQuestionGroupMutationVariables_>(AdminDeleteTargetQuestionGroupDocument_, options);
      }
export type AdminDeleteTargetQuestionGroupMutationHookResult = ReturnType<typeof useAdminDeleteTargetQuestionGroupMutation>;
export type AdminDeleteTargetQuestionGroupMutationResult_ = Apollo.MutationResult<AdminDeleteTargetQuestionGroupMutation_>;
export type AdminDeleteTargetQuestionGroupMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteTargetQuestionGroupMutation_, AdminDeleteTargetQuestionGroupMutationVariables_>;
export const AdminUpdateTargetQuestionGroupDocument_ = gql`
    mutation AdminUpdateTargetQuestionGroup($pk_columns: TargetQuestionGroup_pk_columns_input!, $_set: TargetQuestionGroup_set_input!) {
  update_TargetQuestionGroup_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
  }
}
    `;
export type AdminUpdateTargetQuestionGroupMutationFn_ = Apollo.MutationFunction<AdminUpdateTargetQuestionGroupMutation_, AdminUpdateTargetQuestionGroupMutationVariables_>;

/**
 * __useAdminUpdateTargetQuestionGroupMutation__
 *
 * To run a mutation, you first call `useAdminUpdateTargetQuestionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateTargetQuestionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateTargetQuestionGroupMutation, { data, loading, error }] = useAdminUpdateTargetQuestionGroupMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateTargetQuestionGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateTargetQuestionGroupMutation_, AdminUpdateTargetQuestionGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateTargetQuestionGroupMutation_, AdminUpdateTargetQuestionGroupMutationVariables_>(AdminUpdateTargetQuestionGroupDocument_, options);
      }
export type AdminUpdateTargetQuestionGroupMutationHookResult = ReturnType<typeof useAdminUpdateTargetQuestionGroupMutation>;
export type AdminUpdateTargetQuestionGroupMutationResult_ = Apollo.MutationResult<AdminUpdateTargetQuestionGroupMutation_>;
export type AdminUpdateTargetQuestionGroupMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateTargetQuestionGroupMutation_, AdminUpdateTargetQuestionGroupMutationVariables_>;
export const AdminGetEsrsMetricAdditionalTypeDocument_ = gql`
    query AdminGetEsrsMetricAdditionalType($metricRef: String!, $additionalTypeRef: String!) {
  EsrsMetricAdditionalType_by_pk(
    metricRef: $metricRef
    additionalTypeRef: $additionalTypeRef
  ) {
    metricRef
    additionalTypeRef
  }
}
    `;

/**
 * __useAdminGetEsrsMetricAdditionalTypeQuery__
 *
 * To run a query within a React component, call `useAdminGetEsrsMetricAdditionalTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetEsrsMetricAdditionalTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetEsrsMetricAdditionalTypeQuery({
 *   variables: {
 *      metricRef: // value for 'metricRef'
 *      additionalTypeRef: // value for 'additionalTypeRef'
 *   },
 * });
 */
export function useAdminGetEsrsMetricAdditionalTypeQuery(baseOptions: Apollo.QueryHookOptions<AdminGetEsrsMetricAdditionalTypeQuery_, AdminGetEsrsMetricAdditionalTypeQueryVariables_> & ({ variables: AdminGetEsrsMetricAdditionalTypeQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetEsrsMetricAdditionalTypeQuery_, AdminGetEsrsMetricAdditionalTypeQueryVariables_>(AdminGetEsrsMetricAdditionalTypeDocument_, options);
      }
export function useAdminGetEsrsMetricAdditionalTypeLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetEsrsMetricAdditionalTypeQuery_, AdminGetEsrsMetricAdditionalTypeQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetEsrsMetricAdditionalTypeQuery_, AdminGetEsrsMetricAdditionalTypeQueryVariables_>(AdminGetEsrsMetricAdditionalTypeDocument_, options);
        }
export function useAdminGetEsrsMetricAdditionalTypeSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetEsrsMetricAdditionalTypeQuery_, AdminGetEsrsMetricAdditionalTypeQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetEsrsMetricAdditionalTypeQuery_, AdminGetEsrsMetricAdditionalTypeQueryVariables_>(AdminGetEsrsMetricAdditionalTypeDocument_, options);
        }
export type AdminGetEsrsMetricAdditionalTypeQueryHookResult = ReturnType<typeof useAdminGetEsrsMetricAdditionalTypeQuery>;
export type AdminGetEsrsMetricAdditionalTypeLazyQuery_HookResult = ReturnType<typeof useAdminGetEsrsMetricAdditionalTypeLazyQuery_>;
export type AdminGetEsrsMetricAdditionalTypeSuspenseQuery_HookResult = ReturnType<typeof useAdminGetEsrsMetricAdditionalTypeSuspenseQuery_>;
export type AdminGetEsrsMetricAdditionalTypeQueryResult_ = Apollo.QueryResult<AdminGetEsrsMetricAdditionalTypeQuery_, AdminGetEsrsMetricAdditionalTypeQueryVariables_>;
export function refetchAdminGetEsrsMetricAdditionalTypeQuery_(variables: AdminGetEsrsMetricAdditionalTypeQueryVariables_) {
      return { query: AdminGetEsrsMetricAdditionalTypeDocument_, variables: variables }
    }
export const AdminUpdateEsrsMetricAdditionalTypeDocument_ = gql`
    mutation AdminUpdateEsrsMetricAdditionalType($pk_columns: EsrsMetricAdditionalType_pk_columns_input!, $_set: EsrsMetricAdditionalType_set_input!) {
  update_EsrsMetricAdditionalType_by_pk(pk_columns: $pk_columns, _set: $_set) {
    metricRef
    additionalTypeRef
  }
}
    `;
export type AdminUpdateEsrsMetricAdditionalTypeMutationFn_ = Apollo.MutationFunction<AdminUpdateEsrsMetricAdditionalTypeMutation_, AdminUpdateEsrsMetricAdditionalTypeMutationVariables_>;

/**
 * __useAdminUpdateEsrsMetricAdditionalTypeMutation__
 *
 * To run a mutation, you first call `useAdminUpdateEsrsMetricAdditionalTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateEsrsMetricAdditionalTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateEsrsMetricAdditionalTypeMutation, { data, loading, error }] = useAdminUpdateEsrsMetricAdditionalTypeMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateEsrsMetricAdditionalTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateEsrsMetricAdditionalTypeMutation_, AdminUpdateEsrsMetricAdditionalTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateEsrsMetricAdditionalTypeMutation_, AdminUpdateEsrsMetricAdditionalTypeMutationVariables_>(AdminUpdateEsrsMetricAdditionalTypeDocument_, options);
      }
export type AdminUpdateEsrsMetricAdditionalTypeMutationHookResult = ReturnType<typeof useAdminUpdateEsrsMetricAdditionalTypeMutation>;
export type AdminUpdateEsrsMetricAdditionalTypeMutationResult_ = Apollo.MutationResult<AdminUpdateEsrsMetricAdditionalTypeMutation_>;
export type AdminUpdateEsrsMetricAdditionalTypeMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateEsrsMetricAdditionalTypeMutation_, AdminUpdateEsrsMetricAdditionalTypeMutationVariables_>;
export const AdminDeleteEsrsMetricAdditionalTypeDocument_ = gql`
    mutation AdminDeleteEsrsMetricAdditionalType($metricRef: String!, $additionalTypeRef: String!) {
  delete_EsrsMetricAdditionalType_by_pk(
    metricRef: $metricRef
    additionalTypeRef: $additionalTypeRef
  ) {
    metricRef
    additionalTypeRef
  }
}
    `;
export type AdminDeleteEsrsMetricAdditionalTypeMutationFn_ = Apollo.MutationFunction<AdminDeleteEsrsMetricAdditionalTypeMutation_, AdminDeleteEsrsMetricAdditionalTypeMutationVariables_>;

/**
 * __useAdminDeleteEsrsMetricAdditionalTypeMutation__
 *
 * To run a mutation, you first call `useAdminDeleteEsrsMetricAdditionalTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteEsrsMetricAdditionalTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteEsrsMetricAdditionalTypeMutation, { data, loading, error }] = useAdminDeleteEsrsMetricAdditionalTypeMutation({
 *   variables: {
 *      metricRef: // value for 'metricRef'
 *      additionalTypeRef: // value for 'additionalTypeRef'
 *   },
 * });
 */
export function useAdminDeleteEsrsMetricAdditionalTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteEsrsMetricAdditionalTypeMutation_, AdminDeleteEsrsMetricAdditionalTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteEsrsMetricAdditionalTypeMutation_, AdminDeleteEsrsMetricAdditionalTypeMutationVariables_>(AdminDeleteEsrsMetricAdditionalTypeDocument_, options);
      }
export type AdminDeleteEsrsMetricAdditionalTypeMutationHookResult = ReturnType<typeof useAdminDeleteEsrsMetricAdditionalTypeMutation>;
export type AdminDeleteEsrsMetricAdditionalTypeMutationResult_ = Apollo.MutationResult<AdminDeleteEsrsMetricAdditionalTypeMutation_>;
export type AdminDeleteEsrsMetricAdditionalTypeMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteEsrsMetricAdditionalTypeMutation_, AdminDeleteEsrsMetricAdditionalTypeMutationVariables_>;
export const AdminCreateEsrsMetricAdditionalTypeDocument_ = gql`
    mutation AdminCreateEsrsMetricAdditionalType($object: EsrsMetricAdditionalType_insert_input!) {
  insert_EsrsMetricAdditionalType_one(object: $object) {
    metricRef
    additionalTypeRef
  }
}
    `;
export type AdminCreateEsrsMetricAdditionalTypeMutationFn_ = Apollo.MutationFunction<AdminCreateEsrsMetricAdditionalTypeMutation_, AdminCreateEsrsMetricAdditionalTypeMutationVariables_>;

/**
 * __useAdminCreateEsrsMetricAdditionalTypeMutation__
 *
 * To run a mutation, you first call `useAdminCreateEsrsMetricAdditionalTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateEsrsMetricAdditionalTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateEsrsMetricAdditionalTypeMutation, { data, loading, error }] = useAdminCreateEsrsMetricAdditionalTypeMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateEsrsMetricAdditionalTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateEsrsMetricAdditionalTypeMutation_, AdminCreateEsrsMetricAdditionalTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateEsrsMetricAdditionalTypeMutation_, AdminCreateEsrsMetricAdditionalTypeMutationVariables_>(AdminCreateEsrsMetricAdditionalTypeDocument_, options);
      }
export type AdminCreateEsrsMetricAdditionalTypeMutationHookResult = ReturnType<typeof useAdminCreateEsrsMetricAdditionalTypeMutation>;
export type AdminCreateEsrsMetricAdditionalTypeMutationResult_ = Apollo.MutationResult<AdminCreateEsrsMetricAdditionalTypeMutation_>;
export type AdminCreateEsrsMetricAdditionalTypeMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateEsrsMetricAdditionalTypeMutation_, AdminCreateEsrsMetricAdditionalTypeMutationVariables_>;
export const AdminGetDisclosureRequirementAdditionalTypeDocument_ = gql`
    query AdminGetDisclosureRequirementAdditionalType($disclosureRequirementRef: String!, $additionalTypeRef: String!) {
  DisclosureRequirementAdditionalType_by_pk(
    disclosureRequirementRef: $disclosureRequirementRef
    additionalTypeRef: $additionalTypeRef
  ) {
    disclosureRequirementRef
    additionalTypeRef
  }
}
    `;

/**
 * __useAdminGetDisclosureRequirementAdditionalTypeQuery__
 *
 * To run a query within a React component, call `useAdminGetDisclosureRequirementAdditionalTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetDisclosureRequirementAdditionalTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetDisclosureRequirementAdditionalTypeQuery({
 *   variables: {
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *      additionalTypeRef: // value for 'additionalTypeRef'
 *   },
 * });
 */
export function useAdminGetDisclosureRequirementAdditionalTypeQuery(baseOptions: Apollo.QueryHookOptions<AdminGetDisclosureRequirementAdditionalTypeQuery_, AdminGetDisclosureRequirementAdditionalTypeQueryVariables_> & ({ variables: AdminGetDisclosureRequirementAdditionalTypeQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetDisclosureRequirementAdditionalTypeQuery_, AdminGetDisclosureRequirementAdditionalTypeQueryVariables_>(AdminGetDisclosureRequirementAdditionalTypeDocument_, options);
      }
export function useAdminGetDisclosureRequirementAdditionalTypeLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetDisclosureRequirementAdditionalTypeQuery_, AdminGetDisclosureRequirementAdditionalTypeQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetDisclosureRequirementAdditionalTypeQuery_, AdminGetDisclosureRequirementAdditionalTypeQueryVariables_>(AdminGetDisclosureRequirementAdditionalTypeDocument_, options);
        }
export function useAdminGetDisclosureRequirementAdditionalTypeSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetDisclosureRequirementAdditionalTypeQuery_, AdminGetDisclosureRequirementAdditionalTypeQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetDisclosureRequirementAdditionalTypeQuery_, AdminGetDisclosureRequirementAdditionalTypeQueryVariables_>(AdminGetDisclosureRequirementAdditionalTypeDocument_, options);
        }
export type AdminGetDisclosureRequirementAdditionalTypeQueryHookResult = ReturnType<typeof useAdminGetDisclosureRequirementAdditionalTypeQuery>;
export type AdminGetDisclosureRequirementAdditionalTypeLazyQuery_HookResult = ReturnType<typeof useAdminGetDisclosureRequirementAdditionalTypeLazyQuery_>;
export type AdminGetDisclosureRequirementAdditionalTypeSuspenseQuery_HookResult = ReturnType<typeof useAdminGetDisclosureRequirementAdditionalTypeSuspenseQuery_>;
export type AdminGetDisclosureRequirementAdditionalTypeQueryResult_ = Apollo.QueryResult<AdminGetDisclosureRequirementAdditionalTypeQuery_, AdminGetDisclosureRequirementAdditionalTypeQueryVariables_>;
export function refetchAdminGetDisclosureRequirementAdditionalTypeQuery_(variables: AdminGetDisclosureRequirementAdditionalTypeQueryVariables_) {
      return { query: AdminGetDisclosureRequirementAdditionalTypeDocument_, variables: variables }
    }
export const AdminDeleteDisclosureRequirementAdditionalTypeDocument_ = gql`
    mutation AdminDeleteDisclosureRequirementAdditionalType($disclosureRequirementRef: String!, $additionalTypeRef: String!) {
  delete_DisclosureRequirementAdditionalType_by_pk(
    disclosureRequirementRef: $disclosureRequirementRef
    additionalTypeRef: $additionalTypeRef
  ) {
    disclosureRequirementRef
    additionalTypeRef
  }
}
    `;
export type AdminDeleteDisclosureRequirementAdditionalTypeMutationFn_ = Apollo.MutationFunction<AdminDeleteDisclosureRequirementAdditionalTypeMutation_, AdminDeleteDisclosureRequirementAdditionalTypeMutationVariables_>;

/**
 * __useAdminDeleteDisclosureRequirementAdditionalTypeMutation__
 *
 * To run a mutation, you first call `useAdminDeleteDisclosureRequirementAdditionalTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteDisclosureRequirementAdditionalTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteDisclosureRequirementAdditionalTypeMutation, { data, loading, error }] = useAdminDeleteDisclosureRequirementAdditionalTypeMutation({
 *   variables: {
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *      additionalTypeRef: // value for 'additionalTypeRef'
 *   },
 * });
 */
export function useAdminDeleteDisclosureRequirementAdditionalTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteDisclosureRequirementAdditionalTypeMutation_, AdminDeleteDisclosureRequirementAdditionalTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteDisclosureRequirementAdditionalTypeMutation_, AdminDeleteDisclosureRequirementAdditionalTypeMutationVariables_>(AdminDeleteDisclosureRequirementAdditionalTypeDocument_, options);
      }
export type AdminDeleteDisclosureRequirementAdditionalTypeMutationHookResult = ReturnType<typeof useAdminDeleteDisclosureRequirementAdditionalTypeMutation>;
export type AdminDeleteDisclosureRequirementAdditionalTypeMutationResult_ = Apollo.MutationResult<AdminDeleteDisclosureRequirementAdditionalTypeMutation_>;
export type AdminDeleteDisclosureRequirementAdditionalTypeMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteDisclosureRequirementAdditionalTypeMutation_, AdminDeleteDisclosureRequirementAdditionalTypeMutationVariables_>;
export const AdminCreateDisclosureRequirementAdditionalTypeDocument_ = gql`
    mutation AdminCreateDisclosureRequirementAdditionalType($object: DisclosureRequirementAdditionalType_insert_input!) {
  insert_DisclosureRequirementAdditionalType_one(object: $object) {
    disclosureRequirementRef
    additionalTypeRef
  }
}
    `;
export type AdminCreateDisclosureRequirementAdditionalTypeMutationFn_ = Apollo.MutationFunction<AdminCreateDisclosureRequirementAdditionalTypeMutation_, AdminCreateDisclosureRequirementAdditionalTypeMutationVariables_>;

/**
 * __useAdminCreateDisclosureRequirementAdditionalTypeMutation__
 *
 * To run a mutation, you first call `useAdminCreateDisclosureRequirementAdditionalTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateDisclosureRequirementAdditionalTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateDisclosureRequirementAdditionalTypeMutation, { data, loading, error }] = useAdminCreateDisclosureRequirementAdditionalTypeMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateDisclosureRequirementAdditionalTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateDisclosureRequirementAdditionalTypeMutation_, AdminCreateDisclosureRequirementAdditionalTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateDisclosureRequirementAdditionalTypeMutation_, AdminCreateDisclosureRequirementAdditionalTypeMutationVariables_>(AdminCreateDisclosureRequirementAdditionalTypeDocument_, options);
      }
export type AdminCreateDisclosureRequirementAdditionalTypeMutationHookResult = ReturnType<typeof useAdminCreateDisclosureRequirementAdditionalTypeMutation>;
export type AdminCreateDisclosureRequirementAdditionalTypeMutationResult_ = Apollo.MutationResult<AdminCreateDisclosureRequirementAdditionalTypeMutation_>;
export type AdminCreateDisclosureRequirementAdditionalTypeMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateDisclosureRequirementAdditionalTypeMutation_, AdminCreateDisclosureRequirementAdditionalTypeMutationVariables_>;
export const AdminUpdateDisclosureRequirementAdditionalTypeDocument_ = gql`
    mutation AdminUpdateDisclosureRequirementAdditionalType($pk_columns: DisclosureRequirementAdditionalType_pk_columns_input!, $_set: DisclosureRequirementAdditionalType_set_input!) {
  update_DisclosureRequirementAdditionalType_by_pk(
    pk_columns: $pk_columns
    _set: $_set
  ) {
    disclosureRequirementRef
    additionalTypeRef
  }
}
    `;
export type AdminUpdateDisclosureRequirementAdditionalTypeMutationFn_ = Apollo.MutationFunction<AdminUpdateDisclosureRequirementAdditionalTypeMutation_, AdminUpdateDisclosureRequirementAdditionalTypeMutationVariables_>;

/**
 * __useAdminUpdateDisclosureRequirementAdditionalTypeMutation__
 *
 * To run a mutation, you first call `useAdminUpdateDisclosureRequirementAdditionalTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateDisclosureRequirementAdditionalTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateDisclosureRequirementAdditionalTypeMutation, { data, loading, error }] = useAdminUpdateDisclosureRequirementAdditionalTypeMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateDisclosureRequirementAdditionalTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateDisclosureRequirementAdditionalTypeMutation_, AdminUpdateDisclosureRequirementAdditionalTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateDisclosureRequirementAdditionalTypeMutation_, AdminUpdateDisclosureRequirementAdditionalTypeMutationVariables_>(AdminUpdateDisclosureRequirementAdditionalTypeDocument_, options);
      }
export type AdminUpdateDisclosureRequirementAdditionalTypeMutationHookResult = ReturnType<typeof useAdminUpdateDisclosureRequirementAdditionalTypeMutation>;
export type AdminUpdateDisclosureRequirementAdditionalTypeMutationResult_ = Apollo.MutationResult<AdminUpdateDisclosureRequirementAdditionalTypeMutation_>;
export type AdminUpdateDisclosureRequirementAdditionalTypeMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateDisclosureRequirementAdditionalTypeMutation_, AdminUpdateDisclosureRequirementAdditionalTypeMutationVariables_>;
export const AdminCreateEsrsStandardAdditionalTypeDocument_ = gql`
    mutation AdminCreateEsrsStandardAdditionalType($object: EsrsStandardAdditionalType_insert_input!) {
  insert_EsrsStandardAdditionalType_one(object: $object) {
    standardRef
    additionalTypeRef
  }
}
    `;
export type AdminCreateEsrsStandardAdditionalTypeMutationFn_ = Apollo.MutationFunction<AdminCreateEsrsStandardAdditionalTypeMutation_, AdminCreateEsrsStandardAdditionalTypeMutationVariables_>;

/**
 * __useAdminCreateEsrsStandardAdditionalTypeMutation__
 *
 * To run a mutation, you first call `useAdminCreateEsrsStandardAdditionalTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateEsrsStandardAdditionalTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateEsrsStandardAdditionalTypeMutation, { data, loading, error }] = useAdminCreateEsrsStandardAdditionalTypeMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateEsrsStandardAdditionalTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateEsrsStandardAdditionalTypeMutation_, AdminCreateEsrsStandardAdditionalTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateEsrsStandardAdditionalTypeMutation_, AdminCreateEsrsStandardAdditionalTypeMutationVariables_>(AdminCreateEsrsStandardAdditionalTypeDocument_, options);
      }
export type AdminCreateEsrsStandardAdditionalTypeMutationHookResult = ReturnType<typeof useAdminCreateEsrsStandardAdditionalTypeMutation>;
export type AdminCreateEsrsStandardAdditionalTypeMutationResult_ = Apollo.MutationResult<AdminCreateEsrsStandardAdditionalTypeMutation_>;
export type AdminCreateEsrsStandardAdditionalTypeMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateEsrsStandardAdditionalTypeMutation_, AdminCreateEsrsStandardAdditionalTypeMutationVariables_>;
export const AdminGetEsrsStandardAdditionalTypeDocument_ = gql`
    query AdminGetEsrsStandardAdditionalType($standardRef: String!, $additionalTypeRef: String!) {
  EsrsStandardAdditionalType_by_pk(
    standardRef: $standardRef
    additionalTypeRef: $additionalTypeRef
  ) {
    standardRef
    additionalTypeRef
  }
}
    `;

/**
 * __useAdminGetEsrsStandardAdditionalTypeQuery__
 *
 * To run a query within a React component, call `useAdminGetEsrsStandardAdditionalTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetEsrsStandardAdditionalTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetEsrsStandardAdditionalTypeQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *      additionalTypeRef: // value for 'additionalTypeRef'
 *   },
 * });
 */
export function useAdminGetEsrsStandardAdditionalTypeQuery(baseOptions: Apollo.QueryHookOptions<AdminGetEsrsStandardAdditionalTypeQuery_, AdminGetEsrsStandardAdditionalTypeQueryVariables_> & ({ variables: AdminGetEsrsStandardAdditionalTypeQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetEsrsStandardAdditionalTypeQuery_, AdminGetEsrsStandardAdditionalTypeQueryVariables_>(AdminGetEsrsStandardAdditionalTypeDocument_, options);
      }
export function useAdminGetEsrsStandardAdditionalTypeLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetEsrsStandardAdditionalTypeQuery_, AdminGetEsrsStandardAdditionalTypeQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetEsrsStandardAdditionalTypeQuery_, AdminGetEsrsStandardAdditionalTypeQueryVariables_>(AdminGetEsrsStandardAdditionalTypeDocument_, options);
        }
export function useAdminGetEsrsStandardAdditionalTypeSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetEsrsStandardAdditionalTypeQuery_, AdminGetEsrsStandardAdditionalTypeQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetEsrsStandardAdditionalTypeQuery_, AdminGetEsrsStandardAdditionalTypeQueryVariables_>(AdminGetEsrsStandardAdditionalTypeDocument_, options);
        }
export type AdminGetEsrsStandardAdditionalTypeQueryHookResult = ReturnType<typeof useAdminGetEsrsStandardAdditionalTypeQuery>;
export type AdminGetEsrsStandardAdditionalTypeLazyQuery_HookResult = ReturnType<typeof useAdminGetEsrsStandardAdditionalTypeLazyQuery_>;
export type AdminGetEsrsStandardAdditionalTypeSuspenseQuery_HookResult = ReturnType<typeof useAdminGetEsrsStandardAdditionalTypeSuspenseQuery_>;
export type AdminGetEsrsStandardAdditionalTypeQueryResult_ = Apollo.QueryResult<AdminGetEsrsStandardAdditionalTypeQuery_, AdminGetEsrsStandardAdditionalTypeQueryVariables_>;
export function refetchAdminGetEsrsStandardAdditionalTypeQuery_(variables: AdminGetEsrsStandardAdditionalTypeQueryVariables_) {
      return { query: AdminGetEsrsStandardAdditionalTypeDocument_, variables: variables }
    }
export const AdminUpdateEsrsStandardAdditionalTypeDocument_ = gql`
    mutation AdminUpdateEsrsStandardAdditionalType($pk_columns: EsrsStandardAdditionalType_pk_columns_input!, $_set: EsrsStandardAdditionalType_set_input!) {
  update_EsrsStandardAdditionalType_by_pk(pk_columns: $pk_columns, _set: $_set) {
    standardRef
    additionalTypeRef
  }
}
    `;
export type AdminUpdateEsrsStandardAdditionalTypeMutationFn_ = Apollo.MutationFunction<AdminUpdateEsrsStandardAdditionalTypeMutation_, AdminUpdateEsrsStandardAdditionalTypeMutationVariables_>;

/**
 * __useAdminUpdateEsrsStandardAdditionalTypeMutation__
 *
 * To run a mutation, you first call `useAdminUpdateEsrsStandardAdditionalTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateEsrsStandardAdditionalTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateEsrsStandardAdditionalTypeMutation, { data, loading, error }] = useAdminUpdateEsrsStandardAdditionalTypeMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateEsrsStandardAdditionalTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateEsrsStandardAdditionalTypeMutation_, AdminUpdateEsrsStandardAdditionalTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateEsrsStandardAdditionalTypeMutation_, AdminUpdateEsrsStandardAdditionalTypeMutationVariables_>(AdminUpdateEsrsStandardAdditionalTypeDocument_, options);
      }
export type AdminUpdateEsrsStandardAdditionalTypeMutationHookResult = ReturnType<typeof useAdminUpdateEsrsStandardAdditionalTypeMutation>;
export type AdminUpdateEsrsStandardAdditionalTypeMutationResult_ = Apollo.MutationResult<AdminUpdateEsrsStandardAdditionalTypeMutation_>;
export type AdminUpdateEsrsStandardAdditionalTypeMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateEsrsStandardAdditionalTypeMutation_, AdminUpdateEsrsStandardAdditionalTypeMutationVariables_>;
export const AdminDeleteEsrsStandardAdditionalTypeDocument_ = gql`
    mutation AdminDeleteEsrsStandardAdditionalType($standardRef: String!, $additionalTypeRef: String!) {
  delete_EsrsStandardAdditionalType_by_pk(
    standardRef: $standardRef
    additionalTypeRef: $additionalTypeRef
  ) {
    standardRef
    additionalTypeRef
  }
}
    `;
export type AdminDeleteEsrsStandardAdditionalTypeMutationFn_ = Apollo.MutationFunction<AdminDeleteEsrsStandardAdditionalTypeMutation_, AdminDeleteEsrsStandardAdditionalTypeMutationVariables_>;

/**
 * __useAdminDeleteEsrsStandardAdditionalTypeMutation__
 *
 * To run a mutation, you first call `useAdminDeleteEsrsStandardAdditionalTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteEsrsStandardAdditionalTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteEsrsStandardAdditionalTypeMutation, { data, loading, error }] = useAdminDeleteEsrsStandardAdditionalTypeMutation({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *      additionalTypeRef: // value for 'additionalTypeRef'
 *   },
 * });
 */
export function useAdminDeleteEsrsStandardAdditionalTypeMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteEsrsStandardAdditionalTypeMutation_, AdminDeleteEsrsStandardAdditionalTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteEsrsStandardAdditionalTypeMutation_, AdminDeleteEsrsStandardAdditionalTypeMutationVariables_>(AdminDeleteEsrsStandardAdditionalTypeDocument_, options);
      }
export type AdminDeleteEsrsStandardAdditionalTypeMutationHookResult = ReturnType<typeof useAdminDeleteEsrsStandardAdditionalTypeMutation>;
export type AdminDeleteEsrsStandardAdditionalTypeMutationResult_ = Apollo.MutationResult<AdminDeleteEsrsStandardAdditionalTypeMutation_>;
export type AdminDeleteEsrsStandardAdditionalTypeMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteEsrsStandardAdditionalTypeMutation_, AdminDeleteEsrsStandardAdditionalTypeMutationVariables_>;
export const AdminGetMetricTagDocument_ = gql`
    query AdminGetMetricTag($metricRef: String!, $type: String!) {
  MetricTag_by_pk(metricRef: $metricRef, type: $type) {
    metricRef
    type
    isOptional
  }
}
    `;

/**
 * __useAdminGetMetricTagQuery__
 *
 * To run a query within a React component, call `useAdminGetMetricTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMetricTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMetricTagQuery({
 *   variables: {
 *      metricRef: // value for 'metricRef'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAdminGetMetricTagQuery(baseOptions: Apollo.QueryHookOptions<AdminGetMetricTagQuery_, AdminGetMetricTagQueryVariables_> & ({ variables: AdminGetMetricTagQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMetricTagQuery_, AdminGetMetricTagQueryVariables_>(AdminGetMetricTagDocument_, options);
      }
export function useAdminGetMetricTagLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMetricTagQuery_, AdminGetMetricTagQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMetricTagQuery_, AdminGetMetricTagQueryVariables_>(AdminGetMetricTagDocument_, options);
        }
export function useAdminGetMetricTagSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMetricTagQuery_, AdminGetMetricTagQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMetricTagQuery_, AdminGetMetricTagQueryVariables_>(AdminGetMetricTagDocument_, options);
        }
export type AdminGetMetricTagQueryHookResult = ReturnType<typeof useAdminGetMetricTagQuery>;
export type AdminGetMetricTagLazyQuery_HookResult = ReturnType<typeof useAdminGetMetricTagLazyQuery_>;
export type AdminGetMetricTagSuspenseQuery_HookResult = ReturnType<typeof useAdminGetMetricTagSuspenseQuery_>;
export type AdminGetMetricTagQueryResult_ = Apollo.QueryResult<AdminGetMetricTagQuery_, AdminGetMetricTagQueryVariables_>;
export function refetchAdminGetMetricTagQuery_(variables: AdminGetMetricTagQueryVariables_) {
      return { query: AdminGetMetricTagDocument_, variables: variables }
    }
export const AdminUpdateMetricTagDocument_ = gql`
    mutation AdminUpdateMetricTag($pk_columns: MetricTag_pk_columns_input!, $_set: MetricTag_set_input!) {
  update_MetricTag_by_pk(pk_columns: $pk_columns, _set: $_set) {
    metricRef
    type
    isOptional
  }
}
    `;
export type AdminUpdateMetricTagMutationFn_ = Apollo.MutationFunction<AdminUpdateMetricTagMutation_, AdminUpdateMetricTagMutationVariables_>;

/**
 * __useAdminUpdateMetricTagMutation__
 *
 * To run a mutation, you first call `useAdminUpdateMetricTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateMetricTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateMetricTagMutation, { data, loading, error }] = useAdminUpdateMetricTagMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateMetricTagMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateMetricTagMutation_, AdminUpdateMetricTagMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateMetricTagMutation_, AdminUpdateMetricTagMutationVariables_>(AdminUpdateMetricTagDocument_, options);
      }
export type AdminUpdateMetricTagMutationHookResult = ReturnType<typeof useAdminUpdateMetricTagMutation>;
export type AdminUpdateMetricTagMutationResult_ = Apollo.MutationResult<AdminUpdateMetricTagMutation_>;
export type AdminUpdateMetricTagMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateMetricTagMutation_, AdminUpdateMetricTagMutationVariables_>;
export const AdminCreateMetricTagDocument_ = gql`
    mutation AdminCreateMetricTag($object: MetricTag_insert_input!) {
  insert_MetricTag_one(object: $object) {
    metricRef
    type
    isOptional
  }
}
    `;
export type AdminCreateMetricTagMutationFn_ = Apollo.MutationFunction<AdminCreateMetricTagMutation_, AdminCreateMetricTagMutationVariables_>;

/**
 * __useAdminCreateMetricTagMutation__
 *
 * To run a mutation, you first call `useAdminCreateMetricTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMetricTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMetricTagMutation, { data, loading, error }] = useAdminCreateMetricTagMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateMetricTagMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMetricTagMutation_, AdminCreateMetricTagMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMetricTagMutation_, AdminCreateMetricTagMutationVariables_>(AdminCreateMetricTagDocument_, options);
      }
export type AdminCreateMetricTagMutationHookResult = ReturnType<typeof useAdminCreateMetricTagMutation>;
export type AdminCreateMetricTagMutationResult_ = Apollo.MutationResult<AdminCreateMetricTagMutation_>;
export type AdminCreateMetricTagMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateMetricTagMutation_, AdminCreateMetricTagMutationVariables_>;
export const AdminDeleteMetricTagDocument_ = gql`
    mutation AdminDeleteMetricTag($metricRef: String!, $type: String!) {
  delete_MetricTag_by_pk(metricRef: $metricRef, type: $type) {
    metricRef
    type
    isOptional
  }
}
    `;
export type AdminDeleteMetricTagMutationFn_ = Apollo.MutationFunction<AdminDeleteMetricTagMutation_, AdminDeleteMetricTagMutationVariables_>;

/**
 * __useAdminDeleteMetricTagMutation__
 *
 * To run a mutation, you first call `useAdminDeleteMetricTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteMetricTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteMetricTagMutation, { data, loading, error }] = useAdminDeleteMetricTagMutation({
 *   variables: {
 *      metricRef: // value for 'metricRef'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAdminDeleteMetricTagMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteMetricTagMutation_, AdminDeleteMetricTagMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteMetricTagMutation_, AdminDeleteMetricTagMutationVariables_>(AdminDeleteMetricTagDocument_, options);
      }
export type AdminDeleteMetricTagMutationHookResult = ReturnType<typeof useAdminDeleteMetricTagMutation>;
export type AdminDeleteMetricTagMutationResult_ = Apollo.MutationResult<AdminDeleteMetricTagMutation_>;
export type AdminDeleteMetricTagMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteMetricTagMutation_, AdminDeleteMetricTagMutationVariables_>;
export const AdminGetMetricDependencyDocument_ = gql`
    query AdminGetMetricDependency($parentMetricRef: String!, $childMetricRef: String!) {
  MetricDependency_by_pk(
    parentMetricRef: $parentMetricRef
    childMetricRef: $childMetricRef
  ) {
    parentMetricRef
    childMetricRef
  }
}
    `;

/**
 * __useAdminGetMetricDependencyQuery__
 *
 * To run a query within a React component, call `useAdminGetMetricDependencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMetricDependencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMetricDependencyQuery({
 *   variables: {
 *      parentMetricRef: // value for 'parentMetricRef'
 *      childMetricRef: // value for 'childMetricRef'
 *   },
 * });
 */
export function useAdminGetMetricDependencyQuery(baseOptions: Apollo.QueryHookOptions<AdminGetMetricDependencyQuery_, AdminGetMetricDependencyQueryVariables_> & ({ variables: AdminGetMetricDependencyQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMetricDependencyQuery_, AdminGetMetricDependencyQueryVariables_>(AdminGetMetricDependencyDocument_, options);
      }
export function useAdminGetMetricDependencyLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMetricDependencyQuery_, AdminGetMetricDependencyQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMetricDependencyQuery_, AdminGetMetricDependencyQueryVariables_>(AdminGetMetricDependencyDocument_, options);
        }
export function useAdminGetMetricDependencySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMetricDependencyQuery_, AdminGetMetricDependencyQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMetricDependencyQuery_, AdminGetMetricDependencyQueryVariables_>(AdminGetMetricDependencyDocument_, options);
        }
export type AdminGetMetricDependencyQueryHookResult = ReturnType<typeof useAdminGetMetricDependencyQuery>;
export type AdminGetMetricDependencyLazyQuery_HookResult = ReturnType<typeof useAdminGetMetricDependencyLazyQuery_>;
export type AdminGetMetricDependencySuspenseQuery_HookResult = ReturnType<typeof useAdminGetMetricDependencySuspenseQuery_>;
export type AdminGetMetricDependencyQueryResult_ = Apollo.QueryResult<AdminGetMetricDependencyQuery_, AdminGetMetricDependencyQueryVariables_>;
export function refetchAdminGetMetricDependencyQuery_(variables: AdminGetMetricDependencyQueryVariables_) {
      return { query: AdminGetMetricDependencyDocument_, variables: variables }
    }
export const AdminUpdateMetricDependencyDocument_ = gql`
    mutation AdminUpdateMetricDependency($pk_columns: MetricDependency_pk_columns_input!, $_set: MetricDependency_set_input!) {
  update_MetricDependency_by_pk(pk_columns: $pk_columns, _set: $_set) {
    parentMetricRef
    childMetricRef
  }
}
    `;
export type AdminUpdateMetricDependencyMutationFn_ = Apollo.MutationFunction<AdminUpdateMetricDependencyMutation_, AdminUpdateMetricDependencyMutationVariables_>;

/**
 * __useAdminUpdateMetricDependencyMutation__
 *
 * To run a mutation, you first call `useAdminUpdateMetricDependencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateMetricDependencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateMetricDependencyMutation, { data, loading, error }] = useAdminUpdateMetricDependencyMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateMetricDependencyMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateMetricDependencyMutation_, AdminUpdateMetricDependencyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateMetricDependencyMutation_, AdminUpdateMetricDependencyMutationVariables_>(AdminUpdateMetricDependencyDocument_, options);
      }
export type AdminUpdateMetricDependencyMutationHookResult = ReturnType<typeof useAdminUpdateMetricDependencyMutation>;
export type AdminUpdateMetricDependencyMutationResult_ = Apollo.MutationResult<AdminUpdateMetricDependencyMutation_>;
export type AdminUpdateMetricDependencyMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateMetricDependencyMutation_, AdminUpdateMetricDependencyMutationVariables_>;
export const AdminDeleteMetricDependencyDocument_ = gql`
    mutation AdminDeleteMetricDependency($parentMetricRef: String!, $childMetricRef: String!) {
  delete_MetricDependency_by_pk(
    parentMetricRef: $parentMetricRef
    childMetricRef: $childMetricRef
  ) {
    parentMetricRef
    childMetricRef
  }
}
    `;
export type AdminDeleteMetricDependencyMutationFn_ = Apollo.MutationFunction<AdminDeleteMetricDependencyMutation_, AdminDeleteMetricDependencyMutationVariables_>;

/**
 * __useAdminDeleteMetricDependencyMutation__
 *
 * To run a mutation, you first call `useAdminDeleteMetricDependencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteMetricDependencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteMetricDependencyMutation, { data, loading, error }] = useAdminDeleteMetricDependencyMutation({
 *   variables: {
 *      parentMetricRef: // value for 'parentMetricRef'
 *      childMetricRef: // value for 'childMetricRef'
 *   },
 * });
 */
export function useAdminDeleteMetricDependencyMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteMetricDependencyMutation_, AdminDeleteMetricDependencyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteMetricDependencyMutation_, AdminDeleteMetricDependencyMutationVariables_>(AdminDeleteMetricDependencyDocument_, options);
      }
export type AdminDeleteMetricDependencyMutationHookResult = ReturnType<typeof useAdminDeleteMetricDependencyMutation>;
export type AdminDeleteMetricDependencyMutationResult_ = Apollo.MutationResult<AdminDeleteMetricDependencyMutation_>;
export type AdminDeleteMetricDependencyMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteMetricDependencyMutation_, AdminDeleteMetricDependencyMutationVariables_>;
export const AdminCreateMetricDependencyDocument_ = gql`
    mutation AdminCreateMetricDependency($object: MetricDependency_insert_input!) {
  insert_MetricDependency_one(object: $object) {
    parentMetricRef
    childMetricRef
  }
}
    `;
export type AdminCreateMetricDependencyMutationFn_ = Apollo.MutationFunction<AdminCreateMetricDependencyMutation_, AdminCreateMetricDependencyMutationVariables_>;

/**
 * __useAdminCreateMetricDependencyMutation__
 *
 * To run a mutation, you first call `useAdminCreateMetricDependencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMetricDependencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMetricDependencyMutation, { data, loading, error }] = useAdminCreateMetricDependencyMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateMetricDependencyMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMetricDependencyMutation_, AdminCreateMetricDependencyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMetricDependencyMutation_, AdminCreateMetricDependencyMutationVariables_>(AdminCreateMetricDependencyDocument_, options);
      }
export type AdminCreateMetricDependencyMutationHookResult = ReturnType<typeof useAdminCreateMetricDependencyMutation>;
export type AdminCreateMetricDependencyMutationResult_ = Apollo.MutationResult<AdminCreateMetricDependencyMutation_>;
export type AdminCreateMetricDependencyMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateMetricDependencyMutation_, AdminCreateMetricDependencyMutationVariables_>;
export const AdminGetActivityQuestionSetDocument_ = gql`
    query AdminGetActivityQuestionSet($activityRef: String!, $version: Int!, $questionSetRef: String!) {
  ActivityQuestionSet_by_pk(
    activityRef: $activityRef
    version: $version
    questionSetRef: $questionSetRef
  ) {
    activityRef
    questionSetRef
    id
    version
  }
}
    `;

/**
 * __useAdminGetActivityQuestionSetQuery__
 *
 * To run a query within a React component, call `useAdminGetActivityQuestionSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetActivityQuestionSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetActivityQuestionSetQuery({
 *   variables: {
 *      activityRef: // value for 'activityRef'
 *      version: // value for 'version'
 *      questionSetRef: // value for 'questionSetRef'
 *   },
 * });
 */
export function useAdminGetActivityQuestionSetQuery(baseOptions: Apollo.QueryHookOptions<AdminGetActivityQuestionSetQuery_, AdminGetActivityQuestionSetQueryVariables_> & ({ variables: AdminGetActivityQuestionSetQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetActivityQuestionSetQuery_, AdminGetActivityQuestionSetQueryVariables_>(AdminGetActivityQuestionSetDocument_, options);
      }
export function useAdminGetActivityQuestionSetLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetActivityQuestionSetQuery_, AdminGetActivityQuestionSetQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetActivityQuestionSetQuery_, AdminGetActivityQuestionSetQueryVariables_>(AdminGetActivityQuestionSetDocument_, options);
        }
export function useAdminGetActivityQuestionSetSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetActivityQuestionSetQuery_, AdminGetActivityQuestionSetQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetActivityQuestionSetQuery_, AdminGetActivityQuestionSetQueryVariables_>(AdminGetActivityQuestionSetDocument_, options);
        }
export type AdminGetActivityQuestionSetQueryHookResult = ReturnType<typeof useAdminGetActivityQuestionSetQuery>;
export type AdminGetActivityQuestionSetLazyQuery_HookResult = ReturnType<typeof useAdminGetActivityQuestionSetLazyQuery_>;
export type AdminGetActivityQuestionSetSuspenseQuery_HookResult = ReturnType<typeof useAdminGetActivityQuestionSetSuspenseQuery_>;
export type AdminGetActivityQuestionSetQueryResult_ = Apollo.QueryResult<AdminGetActivityQuestionSetQuery_, AdminGetActivityQuestionSetQueryVariables_>;
export function refetchAdminGetActivityQuestionSetQuery_(variables: AdminGetActivityQuestionSetQueryVariables_) {
      return { query: AdminGetActivityQuestionSetDocument_, variables: variables }
    }
export const AdminUpdateActivityQuestionSetDocument_ = gql`
    mutation AdminUpdateActivityQuestionSet($pk_columns: ActivityQuestionSet_pk_columns_input!, $_set: ActivityQuestionSet_set_input!) {
  update_ActivityQuestionSet_by_pk(pk_columns: $pk_columns, _set: $_set) {
    activityRef
    questionSetRef
    id
    version
  }
}
    `;
export type AdminUpdateActivityQuestionSetMutationFn_ = Apollo.MutationFunction<AdminUpdateActivityQuestionSetMutation_, AdminUpdateActivityQuestionSetMutationVariables_>;

/**
 * __useAdminUpdateActivityQuestionSetMutation__
 *
 * To run a mutation, you first call `useAdminUpdateActivityQuestionSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateActivityQuestionSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateActivityQuestionSetMutation, { data, loading, error }] = useAdminUpdateActivityQuestionSetMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateActivityQuestionSetMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateActivityQuestionSetMutation_, AdminUpdateActivityQuestionSetMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateActivityQuestionSetMutation_, AdminUpdateActivityQuestionSetMutationVariables_>(AdminUpdateActivityQuestionSetDocument_, options);
      }
export type AdminUpdateActivityQuestionSetMutationHookResult = ReturnType<typeof useAdminUpdateActivityQuestionSetMutation>;
export type AdminUpdateActivityQuestionSetMutationResult_ = Apollo.MutationResult<AdminUpdateActivityQuestionSetMutation_>;
export type AdminUpdateActivityQuestionSetMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateActivityQuestionSetMutation_, AdminUpdateActivityQuestionSetMutationVariables_>;
export const AdminGetQuestionSetDocument_ = gql`
    query AdminGetQuestionSet($reference: String!) {
  QuestionSet_by_pk(reference: $reference) {
    reference
    questions {
      questionId
      question {
        uniqueId
        version
        id
      }
    }
  }
}
    `;

/**
 * __useAdminGetQuestionSetQuery__
 *
 * To run a query within a React component, call `useAdminGetQuestionSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetQuestionSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetQuestionSetQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetQuestionSetQuery(baseOptions: Apollo.QueryHookOptions<AdminGetQuestionSetQuery_, AdminGetQuestionSetQueryVariables_> & ({ variables: AdminGetQuestionSetQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetQuestionSetQuery_, AdminGetQuestionSetQueryVariables_>(AdminGetQuestionSetDocument_, options);
      }
export function useAdminGetQuestionSetLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetQuestionSetQuery_, AdminGetQuestionSetQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetQuestionSetQuery_, AdminGetQuestionSetQueryVariables_>(AdminGetQuestionSetDocument_, options);
        }
export function useAdminGetQuestionSetSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetQuestionSetQuery_, AdminGetQuestionSetQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetQuestionSetQuery_, AdminGetQuestionSetQueryVariables_>(AdminGetQuestionSetDocument_, options);
        }
export type AdminGetQuestionSetQueryHookResult = ReturnType<typeof useAdminGetQuestionSetQuery>;
export type AdminGetQuestionSetLazyQuery_HookResult = ReturnType<typeof useAdminGetQuestionSetLazyQuery_>;
export type AdminGetQuestionSetSuspenseQuery_HookResult = ReturnType<typeof useAdminGetQuestionSetSuspenseQuery_>;
export type AdminGetQuestionSetQueryResult_ = Apollo.QueryResult<AdminGetQuestionSetQuery_, AdminGetQuestionSetQueryVariables_>;
export function refetchAdminGetQuestionSetQuery_(variables: AdminGetQuestionSetQueryVariables_) {
      return { query: AdminGetQuestionSetDocument_, variables: variables }
    }
export const AdminUpdateQuestionSetDocument_ = gql`
    mutation AdminUpdateQuestionSet($pk_columns: QuestionSet_pk_columns_input!, $_set: QuestionSet_set_input!) {
  update_QuestionSet_by_pk(pk_columns: $pk_columns, _set: $_set) {
    reference
    questions {
      questionId
      question {
        uniqueId
        version
        id
      }
    }
  }
}
    `;
export type AdminUpdateQuestionSetMutationFn_ = Apollo.MutationFunction<AdminUpdateQuestionSetMutation_, AdminUpdateQuestionSetMutationVariables_>;

/**
 * __useAdminUpdateQuestionSetMutation__
 *
 * To run a mutation, you first call `useAdminUpdateQuestionSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateQuestionSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateQuestionSetMutation, { data, loading, error }] = useAdminUpdateQuestionSetMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateQuestionSetMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateQuestionSetMutation_, AdminUpdateQuestionSetMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateQuestionSetMutation_, AdminUpdateQuestionSetMutationVariables_>(AdminUpdateQuestionSetDocument_, options);
      }
export type AdminUpdateQuestionSetMutationHookResult = ReturnType<typeof useAdminUpdateQuestionSetMutation>;
export type AdminUpdateQuestionSetMutationResult_ = Apollo.MutationResult<AdminUpdateQuestionSetMutation_>;
export type AdminUpdateQuestionSetMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateQuestionSetMutation_, AdminUpdateQuestionSetMutationVariables_>;
export const AdminDeleteQuestionSetDocument_ = gql`
    mutation AdminDeleteQuestionSet($reference: String!) {
  delete_QuestionSet_by_pk(reference: $reference) {
    reference
  }
}
    `;
export type AdminDeleteQuestionSetMutationFn_ = Apollo.MutationFunction<AdminDeleteQuestionSetMutation_, AdminDeleteQuestionSetMutationVariables_>;

/**
 * __useAdminDeleteQuestionSetMutation__
 *
 * To run a mutation, you first call `useAdminDeleteQuestionSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteQuestionSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteQuestionSetMutation, { data, loading, error }] = useAdminDeleteQuestionSetMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteQuestionSetMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteQuestionSetMutation_, AdminDeleteQuestionSetMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteQuestionSetMutation_, AdminDeleteQuestionSetMutationVariables_>(AdminDeleteQuestionSetDocument_, options);
      }
export type AdminDeleteQuestionSetMutationHookResult = ReturnType<typeof useAdminDeleteQuestionSetMutation>;
export type AdminDeleteQuestionSetMutationResult_ = Apollo.MutationResult<AdminDeleteQuestionSetMutation_>;
export type AdminDeleteQuestionSetMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteQuestionSetMutation_, AdminDeleteQuestionSetMutationVariables_>;
export const AdminCreateQuestionSetQuestionsDocument_ = gql`
    mutation AdminCreateQuestionSetQuestions($objects: [QuestionSetQuestion_insert_input!]!) {
  insert_QuestionSetQuestion(objects: $objects) {
    returning {
      questionSetRef
      questionId
    }
  }
}
    `;
export type AdminCreateQuestionSetQuestionsMutationFn_ = Apollo.MutationFunction<AdminCreateQuestionSetQuestionsMutation_, AdminCreateQuestionSetQuestionsMutationVariables_>;

/**
 * __useAdminCreateQuestionSetQuestionsMutation__
 *
 * To run a mutation, you first call `useAdminCreateQuestionSetQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateQuestionSetQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateQuestionSetQuestionsMutation, { data, loading, error }] = useAdminCreateQuestionSetQuestionsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateQuestionSetQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateQuestionSetQuestionsMutation_, AdminCreateQuestionSetQuestionsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateQuestionSetQuestionsMutation_, AdminCreateQuestionSetQuestionsMutationVariables_>(AdminCreateQuestionSetQuestionsDocument_, options);
      }
export type AdminCreateQuestionSetQuestionsMutationHookResult = ReturnType<typeof useAdminCreateQuestionSetQuestionsMutation>;
export type AdminCreateQuestionSetQuestionsMutationResult_ = Apollo.MutationResult<AdminCreateQuestionSetQuestionsMutation_>;
export type AdminCreateQuestionSetQuestionsMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateQuestionSetQuestionsMutation_, AdminCreateQuestionSetQuestionsMutationVariables_>;
export const AdminGetSectorDocument_ = gql`
    query AdminGetSector($reference: String!) {
  Sector_by_pk(reference: $reference) {
    name
    reference
    referenceNumber
  }
}
    `;

/**
 * __useAdminGetSectorQuery__
 *
 * To run a query within a React component, call `useAdminGetSectorQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetSectorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetSectorQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetSectorQuery(baseOptions: Apollo.QueryHookOptions<AdminGetSectorQuery_, AdminGetSectorQueryVariables_> & ({ variables: AdminGetSectorQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetSectorQuery_, AdminGetSectorQueryVariables_>(AdminGetSectorDocument_, options);
      }
export function useAdminGetSectorLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetSectorQuery_, AdminGetSectorQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetSectorQuery_, AdminGetSectorQueryVariables_>(AdminGetSectorDocument_, options);
        }
export function useAdminGetSectorSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetSectorQuery_, AdminGetSectorQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetSectorQuery_, AdminGetSectorQueryVariables_>(AdminGetSectorDocument_, options);
        }
export type AdminGetSectorQueryHookResult = ReturnType<typeof useAdminGetSectorQuery>;
export type AdminGetSectorLazyQuery_HookResult = ReturnType<typeof useAdminGetSectorLazyQuery_>;
export type AdminGetSectorSuspenseQuery_HookResult = ReturnType<typeof useAdminGetSectorSuspenseQuery_>;
export type AdminGetSectorQueryResult_ = Apollo.QueryResult<AdminGetSectorQuery_, AdminGetSectorQueryVariables_>;
export function refetchAdminGetSectorQuery_(variables: AdminGetSectorQueryVariables_) {
      return { query: AdminGetSectorDocument_, variables: variables }
    }
export const AdminUpdateSectorDocument_ = gql`
    mutation AdminUpdateSector($pk_columns: Sector_pk_columns_input!, $_set: Sector_set_input!) {
  update_Sector_by_pk(pk_columns: $pk_columns, _set: $_set) {
    name
    reference
    referenceNumber
  }
}
    `;
export type AdminUpdateSectorMutationFn_ = Apollo.MutationFunction<AdminUpdateSectorMutation_, AdminUpdateSectorMutationVariables_>;

/**
 * __useAdminUpdateSectorMutation__
 *
 * To run a mutation, you first call `useAdminUpdateSectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateSectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateSectorMutation, { data, loading, error }] = useAdminUpdateSectorMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateSectorMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateSectorMutation_, AdminUpdateSectorMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateSectorMutation_, AdminUpdateSectorMutationVariables_>(AdminUpdateSectorDocument_, options);
      }
export type AdminUpdateSectorMutationHookResult = ReturnType<typeof useAdminUpdateSectorMutation>;
export type AdminUpdateSectorMutationResult_ = Apollo.MutationResult<AdminUpdateSectorMutation_>;
export type AdminUpdateSectorMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateSectorMutation_, AdminUpdateSectorMutationVariables_>;
export const AdminDeleteSectorDocument_ = gql`
    mutation AdminDeleteSector($id: String!) {
  delete_Sector_by_pk(reference: $id) {
    reference
  }
}
    `;
export type AdminDeleteSectorMutationFn_ = Apollo.MutationFunction<AdminDeleteSectorMutation_, AdminDeleteSectorMutationVariables_>;

/**
 * __useAdminDeleteSectorMutation__
 *
 * To run a mutation, you first call `useAdminDeleteSectorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteSectorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteSectorMutation, { data, loading, error }] = useAdminDeleteSectorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteSectorMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteSectorMutation_, AdminDeleteSectorMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteSectorMutation_, AdminDeleteSectorMutationVariables_>(AdminDeleteSectorDocument_, options);
      }
export type AdminDeleteSectorMutationHookResult = ReturnType<typeof useAdminDeleteSectorMutation>;
export type AdminDeleteSectorMutationResult_ = Apollo.MutationResult<AdminDeleteSectorMutation_>;
export type AdminDeleteSectorMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteSectorMutation_, AdminDeleteSectorMutationVariables_>;
export const AdminDeleteQuestionDocument_ = gql`
    mutation AdminDeleteQuestion($id: uuid!) {
  delete_Question_by_pk(id: $id) {
    id
  }
}
    `;
export type AdminDeleteQuestionMutationFn_ = Apollo.MutationFunction<AdminDeleteQuestionMutation_, AdminDeleteQuestionMutationVariables_>;

/**
 * __useAdminDeleteQuestionMutation__
 *
 * To run a mutation, you first call `useAdminDeleteQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteQuestionMutation, { data, loading, error }] = useAdminDeleteQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteQuestionMutation_, AdminDeleteQuestionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteQuestionMutation_, AdminDeleteQuestionMutationVariables_>(AdminDeleteQuestionDocument_, options);
      }
export type AdminDeleteQuestionMutationHookResult = ReturnType<typeof useAdminDeleteQuestionMutation>;
export type AdminDeleteQuestionMutationResult_ = Apollo.MutationResult<AdminDeleteQuestionMutation_>;
export type AdminDeleteQuestionMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteQuestionMutation_, AdminDeleteQuestionMutationVariables_>;
export const AdminDeleteQuestionSetQuestionDocument_ = gql`
    mutation AdminDeleteQuestionSetQuestion($questionSetRef: String!, $questionId: uuid!) {
  delete_QuestionSetQuestion_by_pk(
    questionSetRef: $questionSetRef
    questionId: $questionId
  ) {
    questionSetRef
    questionId
  }
}
    `;
export type AdminDeleteQuestionSetQuestionMutationFn_ = Apollo.MutationFunction<AdminDeleteQuestionSetQuestionMutation_, AdminDeleteQuestionSetQuestionMutationVariables_>;

/**
 * __useAdminDeleteQuestionSetQuestionMutation__
 *
 * To run a mutation, you first call `useAdminDeleteQuestionSetQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteQuestionSetQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteQuestionSetQuestionMutation, { data, loading, error }] = useAdminDeleteQuestionSetQuestionMutation({
 *   variables: {
 *      questionSetRef: // value for 'questionSetRef'
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useAdminDeleteQuestionSetQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteQuestionSetQuestionMutation_, AdminDeleteQuestionSetQuestionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteQuestionSetQuestionMutation_, AdminDeleteQuestionSetQuestionMutationVariables_>(AdminDeleteQuestionSetQuestionDocument_, options);
      }
export type AdminDeleteQuestionSetQuestionMutationHookResult = ReturnType<typeof useAdminDeleteQuestionSetQuestionMutation>;
export type AdminDeleteQuestionSetQuestionMutationResult_ = Apollo.MutationResult<AdminDeleteQuestionSetQuestionMutation_>;
export type AdminDeleteQuestionSetQuestionMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteQuestionSetQuestionMutation_, AdminDeleteQuestionSetQuestionMutationVariables_>;
export const AdminCreateTagDocument_ = gql`
    mutation AdminCreateTag($object: Tag_insert_input!) {
  insert_Tag_one(object: $object) {
    id
    name
    description
  }
}
    `;
export type AdminCreateTagMutationFn_ = Apollo.MutationFunction<AdminCreateTagMutation_, AdminCreateTagMutationVariables_>;

/**
 * __useAdminCreateTagMutation__
 *
 * To run a mutation, you first call `useAdminCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateTagMutation, { data, loading, error }] = useAdminCreateTagMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateTagMutation_, AdminCreateTagMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateTagMutation_, AdminCreateTagMutationVariables_>(AdminCreateTagDocument_, options);
      }
export type AdminCreateTagMutationHookResult = ReturnType<typeof useAdminCreateTagMutation>;
export type AdminCreateTagMutationResult_ = Apollo.MutationResult<AdminCreateTagMutation_>;
export type AdminCreateTagMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateTagMutation_, AdminCreateTagMutationVariables_>;
export const AdminCreateTagGroupDocument_ = gql`
    mutation AdminCreateTagGroup($object: TagGroup_insert_input!) {
  insert_TagGroup_one(object: $object) {
    id
    name
    description
  }
}
    `;
export type AdminCreateTagGroupMutationFn_ = Apollo.MutationFunction<AdminCreateTagGroupMutation_, AdminCreateTagGroupMutationVariables_>;

/**
 * __useAdminCreateTagGroupMutation__
 *
 * To run a mutation, you first call `useAdminCreateTagGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateTagGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateTagGroupMutation, { data, loading, error }] = useAdminCreateTagGroupMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateTagGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateTagGroupMutation_, AdminCreateTagGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateTagGroupMutation_, AdminCreateTagGroupMutationVariables_>(AdminCreateTagGroupDocument_, options);
      }
export type AdminCreateTagGroupMutationHookResult = ReturnType<typeof useAdminCreateTagGroupMutation>;
export type AdminCreateTagGroupMutationResult_ = Apollo.MutationResult<AdminCreateTagGroupMutation_>;
export type AdminCreateTagGroupMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateTagGroupMutation_, AdminCreateTagGroupMutationVariables_>;
export const AdminDeleteActivityQuestionSetDocument_ = gql`
    mutation AdminDeleteActivityQuestionSet($questionSetRef: String!, $activityRef: String!, $version: Int!) {
  delete_ActivityQuestionSet_by_pk(
    questionSetRef: $questionSetRef
    activityRef: $activityRef
    version: $version
  ) {
    activityRef
    questionSetRef
    id
    version
  }
}
    `;
export type AdminDeleteActivityQuestionSetMutationFn_ = Apollo.MutationFunction<AdminDeleteActivityQuestionSetMutation_, AdminDeleteActivityQuestionSetMutationVariables_>;

/**
 * __useAdminDeleteActivityQuestionSetMutation__
 *
 * To run a mutation, you first call `useAdminDeleteActivityQuestionSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteActivityQuestionSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteActivityQuestionSetMutation, { data, loading, error }] = useAdminDeleteActivityQuestionSetMutation({
 *   variables: {
 *      questionSetRef: // value for 'questionSetRef'
 *      activityRef: // value for 'activityRef'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useAdminDeleteActivityQuestionSetMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteActivityQuestionSetMutation_, AdminDeleteActivityQuestionSetMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteActivityQuestionSetMutation_, AdminDeleteActivityQuestionSetMutationVariables_>(AdminDeleteActivityQuestionSetDocument_, options);
      }
export type AdminDeleteActivityQuestionSetMutationHookResult = ReturnType<typeof useAdminDeleteActivityQuestionSetMutation>;
export type AdminDeleteActivityQuestionSetMutationResult_ = Apollo.MutationResult<AdminDeleteActivityQuestionSetMutation_>;
export type AdminDeleteActivityQuestionSetMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteActivityQuestionSetMutation_, AdminDeleteActivityQuestionSetMutationVariables_>;
export const AdminDeleteActivityVersionDocument_ = gql`
    mutation AdminDeleteActivityVersion($activityRef: String!, $versionNumber: Int!) {
  delete_ActivityVersion_by_pk(
    activityRef: $activityRef
    versionNumber: $versionNumber
  ) {
    activityRef
    versionNumber
  }
}
    `;
export type AdminDeleteActivityVersionMutationFn_ = Apollo.MutationFunction<AdminDeleteActivityVersionMutation_, AdminDeleteActivityVersionMutationVariables_>;

/**
 * __useAdminDeleteActivityVersionMutation__
 *
 * To run a mutation, you first call `useAdminDeleteActivityVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteActivityVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteActivityVersionMutation, { data, loading, error }] = useAdminDeleteActivityVersionMutation({
 *   variables: {
 *      activityRef: // value for 'activityRef'
 *      versionNumber: // value for 'versionNumber'
 *   },
 * });
 */
export function useAdminDeleteActivityVersionMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteActivityVersionMutation_, AdminDeleteActivityVersionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteActivityVersionMutation_, AdminDeleteActivityVersionMutationVariables_>(AdminDeleteActivityVersionDocument_, options);
      }
export type AdminDeleteActivityVersionMutationHookResult = ReturnType<typeof useAdminDeleteActivityVersionMutation>;
export type AdminDeleteActivityVersionMutationResult_ = Apollo.MutationResult<AdminDeleteActivityVersionMutation_>;
export type AdminDeleteActivityVersionMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteActivityVersionMutation_, AdminDeleteActivityVersionMutationVariables_>;
export const AdminGetCompanySubsidiariesDocument_ = gql`
    query AdminGetCompanySubsidiaries($companyId: uuid!) {
  company: Company(where: {id: {_eq: $companyId}}) {
    id
    taxonomySubsidiaries: groupAssessments(where: {deletedAt: {_is_null: true}}) {
      subsidiaries(where: {deletedAt: {_is_null: true}}) {
        companyId
      }
      period
    }
    esrsSubsidiaries: esrsAssessments(where: {deletedAt: {_is_null: true}}) {
      subsidiaryAssessments(where: {deletedAt: {_is_null: true}}) {
        companyId
      }
      reportingYear
    }
  }
}
    `;

/**
 * __useAdminGetCompanySubsidiariesQuery__
 *
 * To run a query within a React component, call `useAdminGetCompanySubsidiariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetCompanySubsidiariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetCompanySubsidiariesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAdminGetCompanySubsidiariesQuery(baseOptions: Apollo.QueryHookOptions<AdminGetCompanySubsidiariesQuery_, AdminGetCompanySubsidiariesQueryVariables_> & ({ variables: AdminGetCompanySubsidiariesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetCompanySubsidiariesQuery_, AdminGetCompanySubsidiariesQueryVariables_>(AdminGetCompanySubsidiariesDocument_, options);
      }
export function useAdminGetCompanySubsidiariesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetCompanySubsidiariesQuery_, AdminGetCompanySubsidiariesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetCompanySubsidiariesQuery_, AdminGetCompanySubsidiariesQueryVariables_>(AdminGetCompanySubsidiariesDocument_, options);
        }
export function useAdminGetCompanySubsidiariesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetCompanySubsidiariesQuery_, AdminGetCompanySubsidiariesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetCompanySubsidiariesQuery_, AdminGetCompanySubsidiariesQueryVariables_>(AdminGetCompanySubsidiariesDocument_, options);
        }
export type AdminGetCompanySubsidiariesQueryHookResult = ReturnType<typeof useAdminGetCompanySubsidiariesQuery>;
export type AdminGetCompanySubsidiariesLazyQuery_HookResult = ReturnType<typeof useAdminGetCompanySubsidiariesLazyQuery_>;
export type AdminGetCompanySubsidiariesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetCompanySubsidiariesSuspenseQuery_>;
export type AdminGetCompanySubsidiariesQueryResult_ = Apollo.QueryResult<AdminGetCompanySubsidiariesQuery_, AdminGetCompanySubsidiariesQueryVariables_>;
export function refetchAdminGetCompanySubsidiariesQuery_(variables: AdminGetCompanySubsidiariesQueryVariables_) {
      return { query: AdminGetCompanySubsidiariesDocument_, variables: variables }
    }
export const AdminGetCompanyPortfoliosDocument_ = gql`
    query AdminGetCompanyPortfolios($companyId: uuid!) {
  company: Company(where: {id: {_eq: $companyId}}) {
    id
    portfolios(where: {deletedAt: {_is_null: true}}) {
      id
      name
      portfolioCompanies {
        id
        company {
          id
        }
        year
      }
    }
  }
}
    `;

/**
 * __useAdminGetCompanyPortfoliosQuery__
 *
 * To run a query within a React component, call `useAdminGetCompanyPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetCompanyPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetCompanyPortfoliosQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAdminGetCompanyPortfoliosQuery(baseOptions: Apollo.QueryHookOptions<AdminGetCompanyPortfoliosQuery_, AdminGetCompanyPortfoliosQueryVariables_> & ({ variables: AdminGetCompanyPortfoliosQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetCompanyPortfoliosQuery_, AdminGetCompanyPortfoliosQueryVariables_>(AdminGetCompanyPortfoliosDocument_, options);
      }
export function useAdminGetCompanyPortfoliosLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetCompanyPortfoliosQuery_, AdminGetCompanyPortfoliosQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetCompanyPortfoliosQuery_, AdminGetCompanyPortfoliosQueryVariables_>(AdminGetCompanyPortfoliosDocument_, options);
        }
export function useAdminGetCompanyPortfoliosSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetCompanyPortfoliosQuery_, AdminGetCompanyPortfoliosQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetCompanyPortfoliosQuery_, AdminGetCompanyPortfoliosQueryVariables_>(AdminGetCompanyPortfoliosDocument_, options);
        }
export type AdminGetCompanyPortfoliosQueryHookResult = ReturnType<typeof useAdminGetCompanyPortfoliosQuery>;
export type AdminGetCompanyPortfoliosLazyQuery_HookResult = ReturnType<typeof useAdminGetCompanyPortfoliosLazyQuery_>;
export type AdminGetCompanyPortfoliosSuspenseQuery_HookResult = ReturnType<typeof useAdminGetCompanyPortfoliosSuspenseQuery_>;
export type AdminGetCompanyPortfoliosQueryResult_ = Apollo.QueryResult<AdminGetCompanyPortfoliosQuery_, AdminGetCompanyPortfoliosQueryVariables_>;
export function refetchAdminGetCompanyPortfoliosQuery_(variables: AdminGetCompanyPortfoliosQueryVariables_) {
      return { query: AdminGetCompanyPortfoliosDocument_, variables: variables }
    }
export const AdminGetActionQuestionsDocument_ = gql`
    query AdminGetActionQuestions($limit: Int, $offset: Int, $order_by: [ActionQuestion_order_by!], $where: ActionQuestion_bool_exp) {
  ActionQuestion(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    title
    reference
    standardRef
    unit
    questionType
    order
    description
    groupRef
    firstLevel
    secondLevel
    globalOrder
    isAR
    choiceSetRef
  }
  ActionQuestion_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetActionQuestionsQuery__
 *
 * To run a query within a React component, call `useAdminGetActionQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetActionQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetActionQuestionsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetActionQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetActionQuestionsQuery_, AdminGetActionQuestionsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetActionQuestionsQuery_, AdminGetActionQuestionsQueryVariables_>(AdminGetActionQuestionsDocument_, options);
      }
export function useAdminGetActionQuestionsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetActionQuestionsQuery_, AdminGetActionQuestionsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetActionQuestionsQuery_, AdminGetActionQuestionsQueryVariables_>(AdminGetActionQuestionsDocument_, options);
        }
export function useAdminGetActionQuestionsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetActionQuestionsQuery_, AdminGetActionQuestionsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetActionQuestionsQuery_, AdminGetActionQuestionsQueryVariables_>(AdminGetActionQuestionsDocument_, options);
        }
export type AdminGetActionQuestionsQueryHookResult = ReturnType<typeof useAdminGetActionQuestionsQuery>;
export type AdminGetActionQuestionsLazyQuery_HookResult = ReturnType<typeof useAdminGetActionQuestionsLazyQuery_>;
export type AdminGetActionQuestionsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetActionQuestionsSuspenseQuery_>;
export type AdminGetActionQuestionsQueryResult_ = Apollo.QueryResult<AdminGetActionQuestionsQuery_, AdminGetActionQuestionsQueryVariables_>;
export function refetchAdminGetActionQuestionsQuery_(variables?: AdminGetActionQuestionsQueryVariables_) {
      return { query: AdminGetActionQuestionsDocument_, variables: variables }
    }
export const AdminGetActionQuestionDocument_ = gql`
    query AdminGetActionQuestion($reference: String!) {
  ActionQuestion_by_pk(reference: $reference) {
    title
    reference
    standardRef
    unit
    questionType
    order
    description
    groupRef
    firstLevel
    secondLevel
    globalOrder
    isAR
    choiceSetRef
  }
}
    `;

/**
 * __useAdminGetActionQuestionQuery__
 *
 * To run a query within a React component, call `useAdminGetActionQuestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetActionQuestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetActionQuestionQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetActionQuestionQuery(baseOptions: Apollo.QueryHookOptions<AdminGetActionQuestionQuery_, AdminGetActionQuestionQueryVariables_> & ({ variables: AdminGetActionQuestionQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetActionQuestionQuery_, AdminGetActionQuestionQueryVariables_>(AdminGetActionQuestionDocument_, options);
      }
export function useAdminGetActionQuestionLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetActionQuestionQuery_, AdminGetActionQuestionQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetActionQuestionQuery_, AdminGetActionQuestionQueryVariables_>(AdminGetActionQuestionDocument_, options);
        }
export function useAdminGetActionQuestionSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetActionQuestionQuery_, AdminGetActionQuestionQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetActionQuestionQuery_, AdminGetActionQuestionQueryVariables_>(AdminGetActionQuestionDocument_, options);
        }
export type AdminGetActionQuestionQueryHookResult = ReturnType<typeof useAdminGetActionQuestionQuery>;
export type AdminGetActionQuestionLazyQuery_HookResult = ReturnType<typeof useAdminGetActionQuestionLazyQuery_>;
export type AdminGetActionQuestionSuspenseQuery_HookResult = ReturnType<typeof useAdminGetActionQuestionSuspenseQuery_>;
export type AdminGetActionQuestionQueryResult_ = Apollo.QueryResult<AdminGetActionQuestionQuery_, AdminGetActionQuestionQueryVariables_>;
export function refetchAdminGetActionQuestionQuery_(variables: AdminGetActionQuestionQueryVariables_) {
      return { query: AdminGetActionQuestionDocument_, variables: variables }
    }
export const AdminGetActionQuestionGroupsDocument_ = gql`
    query AdminGetActionQuestionGroups($limit: Int, $offset: Int, $order_by: [ActionQuestionGroup_order_by!], $where: ActionQuestionGroup_bool_exp) {
  ActionQuestionGroup(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    title
    reference
  }
  ActionQuestionGroup_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetActionQuestionGroupsQuery__
 *
 * To run a query within a React component, call `useAdminGetActionQuestionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetActionQuestionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetActionQuestionGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetActionQuestionGroupsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetActionQuestionGroupsQuery_, AdminGetActionQuestionGroupsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetActionQuestionGroupsQuery_, AdminGetActionQuestionGroupsQueryVariables_>(AdminGetActionQuestionGroupsDocument_, options);
      }
export function useAdminGetActionQuestionGroupsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetActionQuestionGroupsQuery_, AdminGetActionQuestionGroupsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetActionQuestionGroupsQuery_, AdminGetActionQuestionGroupsQueryVariables_>(AdminGetActionQuestionGroupsDocument_, options);
        }
export function useAdminGetActionQuestionGroupsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetActionQuestionGroupsQuery_, AdminGetActionQuestionGroupsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetActionQuestionGroupsQuery_, AdminGetActionQuestionGroupsQueryVariables_>(AdminGetActionQuestionGroupsDocument_, options);
        }
export type AdminGetActionQuestionGroupsQueryHookResult = ReturnType<typeof useAdminGetActionQuestionGroupsQuery>;
export type AdminGetActionQuestionGroupsLazyQuery_HookResult = ReturnType<typeof useAdminGetActionQuestionGroupsLazyQuery_>;
export type AdminGetActionQuestionGroupsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetActionQuestionGroupsSuspenseQuery_>;
export type AdminGetActionQuestionGroupsQueryResult_ = Apollo.QueryResult<AdminGetActionQuestionGroupsQuery_, AdminGetActionQuestionGroupsQueryVariables_>;
export function refetchAdminGetActionQuestionGroupsQuery_(variables?: AdminGetActionQuestionGroupsQueryVariables_) {
      return { query: AdminGetActionQuestionGroupsDocument_, variables: variables }
    }
export const AdminGetActionQuestionGroupDocument_ = gql`
    query AdminGetActionQuestionGroup($reference: String!) {
  ActionQuestionGroup_by_pk(reference: $reference) {
    title
    reference
  }
}
    `;

/**
 * __useAdminGetActionQuestionGroupQuery__
 *
 * To run a query within a React component, call `useAdminGetActionQuestionGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetActionQuestionGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetActionQuestionGroupQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetActionQuestionGroupQuery(baseOptions: Apollo.QueryHookOptions<AdminGetActionQuestionGroupQuery_, AdminGetActionQuestionGroupQueryVariables_> & ({ variables: AdminGetActionQuestionGroupQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetActionQuestionGroupQuery_, AdminGetActionQuestionGroupQueryVariables_>(AdminGetActionQuestionGroupDocument_, options);
      }
export function useAdminGetActionQuestionGroupLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetActionQuestionGroupQuery_, AdminGetActionQuestionGroupQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetActionQuestionGroupQuery_, AdminGetActionQuestionGroupQueryVariables_>(AdminGetActionQuestionGroupDocument_, options);
        }
export function useAdminGetActionQuestionGroupSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetActionQuestionGroupQuery_, AdminGetActionQuestionGroupQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetActionQuestionGroupQuery_, AdminGetActionQuestionGroupQueryVariables_>(AdminGetActionQuestionGroupDocument_, options);
        }
export type AdminGetActionQuestionGroupQueryHookResult = ReturnType<typeof useAdminGetActionQuestionGroupQuery>;
export type AdminGetActionQuestionGroupLazyQuery_HookResult = ReturnType<typeof useAdminGetActionQuestionGroupLazyQuery_>;
export type AdminGetActionQuestionGroupSuspenseQuery_HookResult = ReturnType<typeof useAdminGetActionQuestionGroupSuspenseQuery_>;
export type AdminGetActionQuestionGroupQueryResult_ = Apollo.QueryResult<AdminGetActionQuestionGroupQuery_, AdminGetActionQuestionGroupQueryVariables_>;
export function refetchAdminGetActionQuestionGroupQuery_(variables: AdminGetActionQuestionGroupQueryVariables_) {
      return { query: AdminGetActionQuestionGroupDocument_, variables: variables }
    }
export const AdminCreateActionQuestionDocument_ = gql`
    mutation AdminCreateActionQuestion($object: ActionQuestion_insert_input!) {
  insert_ActionQuestion_one(object: $object) {
    title
    reference
    standardRef
    unit
    questionType
    order
    description
    groupRef
    firstLevel
    secondLevel
    globalOrder
    isAR
    choiceSetRef
  }
}
    `;
export type AdminCreateActionQuestionMutationFn_ = Apollo.MutationFunction<AdminCreateActionQuestionMutation_, AdminCreateActionQuestionMutationVariables_>;

/**
 * __useAdminCreateActionQuestionMutation__
 *
 * To run a mutation, you first call `useAdminCreateActionQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateActionQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateActionQuestionMutation, { data, loading, error }] = useAdminCreateActionQuestionMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateActionQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateActionQuestionMutation_, AdminCreateActionQuestionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateActionQuestionMutation_, AdminCreateActionQuestionMutationVariables_>(AdminCreateActionQuestionDocument_, options);
      }
export type AdminCreateActionQuestionMutationHookResult = ReturnType<typeof useAdminCreateActionQuestionMutation>;
export type AdminCreateActionQuestionMutationResult_ = Apollo.MutationResult<AdminCreateActionQuestionMutation_>;
export type AdminCreateActionQuestionMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateActionQuestionMutation_, AdminCreateActionQuestionMutationVariables_>;
export const AdminCreateActionQuestionGroupDocument_ = gql`
    mutation AdminCreateActionQuestionGroup($object: ActionQuestionGroup_insert_input!) {
  insert_ActionQuestionGroup_one(object: $object) {
    title
    reference
  }
}
    `;
export type AdminCreateActionQuestionGroupMutationFn_ = Apollo.MutationFunction<AdminCreateActionQuestionGroupMutation_, AdminCreateActionQuestionGroupMutationVariables_>;

/**
 * __useAdminCreateActionQuestionGroupMutation__
 *
 * To run a mutation, you first call `useAdminCreateActionQuestionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateActionQuestionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateActionQuestionGroupMutation, { data, loading, error }] = useAdminCreateActionQuestionGroupMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateActionQuestionGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateActionQuestionGroupMutation_, AdminCreateActionQuestionGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateActionQuestionGroupMutation_, AdminCreateActionQuestionGroupMutationVariables_>(AdminCreateActionQuestionGroupDocument_, options);
      }
export type AdminCreateActionQuestionGroupMutationHookResult = ReturnType<typeof useAdminCreateActionQuestionGroupMutation>;
export type AdminCreateActionQuestionGroupMutationResult_ = Apollo.MutationResult<AdminCreateActionQuestionGroupMutation_>;
export type AdminCreateActionQuestionGroupMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateActionQuestionGroupMutation_, AdminCreateActionQuestionGroupMutationVariables_>;
export const AdminUpdateActionQuestionDocument_ = gql`
    mutation AdminUpdateActionQuestion($pk_columns: ActionQuestion_pk_columns_input!, $_set: ActionQuestion_set_input!) {
  update_ActionQuestion_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
    standardRef
    unit
    questionType
    order
    description
    groupRef
    firstLevel
    secondLevel
    globalOrder
    isAR
    choiceSetRef
  }
}
    `;
export type AdminUpdateActionQuestionMutationFn_ = Apollo.MutationFunction<AdminUpdateActionQuestionMutation_, AdminUpdateActionQuestionMutationVariables_>;

/**
 * __useAdminUpdateActionQuestionMutation__
 *
 * To run a mutation, you first call `useAdminUpdateActionQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateActionQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateActionQuestionMutation, { data, loading, error }] = useAdminUpdateActionQuestionMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateActionQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateActionQuestionMutation_, AdminUpdateActionQuestionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateActionQuestionMutation_, AdminUpdateActionQuestionMutationVariables_>(AdminUpdateActionQuestionDocument_, options);
      }
export type AdminUpdateActionQuestionMutationHookResult = ReturnType<typeof useAdminUpdateActionQuestionMutation>;
export type AdminUpdateActionQuestionMutationResult_ = Apollo.MutationResult<AdminUpdateActionQuestionMutation_>;
export type AdminUpdateActionQuestionMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateActionQuestionMutation_, AdminUpdateActionQuestionMutationVariables_>;
export const AdminUpdateActionQuestionGroupDocument_ = gql`
    mutation AdminUpdateActionQuestionGroup($pk_columns: ActionQuestionGroup_pk_columns_input!, $_set: ActionQuestionGroup_set_input!) {
  update_ActionQuestionGroup_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
  }
}
    `;
export type AdminUpdateActionQuestionGroupMutationFn_ = Apollo.MutationFunction<AdminUpdateActionQuestionGroupMutation_, AdminUpdateActionQuestionGroupMutationVariables_>;

/**
 * __useAdminUpdateActionQuestionGroupMutation__
 *
 * To run a mutation, you first call `useAdminUpdateActionQuestionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateActionQuestionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateActionQuestionGroupMutation, { data, loading, error }] = useAdminUpdateActionQuestionGroupMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateActionQuestionGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateActionQuestionGroupMutation_, AdminUpdateActionQuestionGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateActionQuestionGroupMutation_, AdminUpdateActionQuestionGroupMutationVariables_>(AdminUpdateActionQuestionGroupDocument_, options);
      }
export type AdminUpdateActionQuestionGroupMutationHookResult = ReturnType<typeof useAdminUpdateActionQuestionGroupMutation>;
export type AdminUpdateActionQuestionGroupMutationResult_ = Apollo.MutationResult<AdminUpdateActionQuestionGroupMutation_>;
export type AdminUpdateActionQuestionGroupMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateActionQuestionGroupMutation_, AdminUpdateActionQuestionGroupMutationVariables_>;
export const AdminDeleteActionQuestionDocument_ = gql`
    mutation AdminDeleteActionQuestion($reference: String!) {
  delete_ActionQuestion_by_pk(reference: $reference) {
    title
    reference
    standardRef
    unit
    questionType
    order
    description
    groupRef
    firstLevel
    secondLevel
    globalOrder
    isAR
    choiceSetRef
  }
}
    `;
export type AdminDeleteActionQuestionMutationFn_ = Apollo.MutationFunction<AdminDeleteActionQuestionMutation_, AdminDeleteActionQuestionMutationVariables_>;

/**
 * __useAdminDeleteActionQuestionMutation__
 *
 * To run a mutation, you first call `useAdminDeleteActionQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteActionQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteActionQuestionMutation, { data, loading, error }] = useAdminDeleteActionQuestionMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteActionQuestionMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteActionQuestionMutation_, AdminDeleteActionQuestionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteActionQuestionMutation_, AdminDeleteActionQuestionMutationVariables_>(AdminDeleteActionQuestionDocument_, options);
      }
export type AdminDeleteActionQuestionMutationHookResult = ReturnType<typeof useAdminDeleteActionQuestionMutation>;
export type AdminDeleteActionQuestionMutationResult_ = Apollo.MutationResult<AdminDeleteActionQuestionMutation_>;
export type AdminDeleteActionQuestionMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteActionQuestionMutation_, AdminDeleteActionQuestionMutationVariables_>;
export const AdminDeleteActionQuestionGroupDocument_ = gql`
    mutation AdminDeleteActionQuestionGroup($reference: String!) {
  delete_ActionQuestionGroup_by_pk(reference: $reference) {
    title
    reference
  }
}
    `;
export type AdminDeleteActionQuestionGroupMutationFn_ = Apollo.MutationFunction<AdminDeleteActionQuestionGroupMutation_, AdminDeleteActionQuestionGroupMutationVariables_>;

/**
 * __useAdminDeleteActionQuestionGroupMutation__
 *
 * To run a mutation, you first call `useAdminDeleteActionQuestionGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteActionQuestionGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteActionQuestionGroupMutation, { data, loading, error }] = useAdminDeleteActionQuestionGroupMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteActionQuestionGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteActionQuestionGroupMutation_, AdminDeleteActionQuestionGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteActionQuestionGroupMutation_, AdminDeleteActionQuestionGroupMutationVariables_>(AdminDeleteActionQuestionGroupDocument_, options);
      }
export type AdminDeleteActionQuestionGroupMutationHookResult = ReturnType<typeof useAdminDeleteActionQuestionGroupMutation>;
export type AdminDeleteActionQuestionGroupMutationResult_ = Apollo.MutationResult<AdminDeleteActionQuestionGroupMutation_>;
export type AdminDeleteActionQuestionGroupMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteActionQuestionGroupMutation_, AdminDeleteActionQuestionGroupMutationVariables_>;
export const AdminGetEsrsChoicesDocument_ = gql`
    query AdminGetEsrsChoices($limit: Int, $offset: Int, $order_by: [EsrsChoice_order_by!], $where: EsrsChoice_bool_exp) {
  EsrsChoice(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    title
    reference
    order
    choiceSetRef
  }
  EsrsChoice_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetEsrsChoicesQuery__
 *
 * To run a query within a React component, call `useAdminGetEsrsChoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetEsrsChoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetEsrsChoicesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetEsrsChoicesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetEsrsChoicesQuery_, AdminGetEsrsChoicesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetEsrsChoicesQuery_, AdminGetEsrsChoicesQueryVariables_>(AdminGetEsrsChoicesDocument_, options);
      }
export function useAdminGetEsrsChoicesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetEsrsChoicesQuery_, AdminGetEsrsChoicesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetEsrsChoicesQuery_, AdminGetEsrsChoicesQueryVariables_>(AdminGetEsrsChoicesDocument_, options);
        }
export function useAdminGetEsrsChoicesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetEsrsChoicesQuery_, AdminGetEsrsChoicesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetEsrsChoicesQuery_, AdminGetEsrsChoicesQueryVariables_>(AdminGetEsrsChoicesDocument_, options);
        }
export type AdminGetEsrsChoicesQueryHookResult = ReturnType<typeof useAdminGetEsrsChoicesQuery>;
export type AdminGetEsrsChoicesLazyQuery_HookResult = ReturnType<typeof useAdminGetEsrsChoicesLazyQuery_>;
export type AdminGetEsrsChoicesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetEsrsChoicesSuspenseQuery_>;
export type AdminGetEsrsChoicesQueryResult_ = Apollo.QueryResult<AdminGetEsrsChoicesQuery_, AdminGetEsrsChoicesQueryVariables_>;
export function refetchAdminGetEsrsChoicesQuery_(variables?: AdminGetEsrsChoicesQueryVariables_) {
      return { query: AdminGetEsrsChoicesDocument_, variables: variables }
    }
export const AdminGetEsrsChoiceDocument_ = gql`
    query AdminGetEsrsChoice($reference: String!) {
  EsrsChoice_by_pk(reference: $reference) {
    title
    reference
    order
    choiceSetRef
  }
}
    `;

/**
 * __useAdminGetEsrsChoiceQuery__
 *
 * To run a query within a React component, call `useAdminGetEsrsChoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetEsrsChoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetEsrsChoiceQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetEsrsChoiceQuery(baseOptions: Apollo.QueryHookOptions<AdminGetEsrsChoiceQuery_, AdminGetEsrsChoiceQueryVariables_> & ({ variables: AdminGetEsrsChoiceQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetEsrsChoiceQuery_, AdminGetEsrsChoiceQueryVariables_>(AdminGetEsrsChoiceDocument_, options);
      }
export function useAdminGetEsrsChoiceLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetEsrsChoiceQuery_, AdminGetEsrsChoiceQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetEsrsChoiceQuery_, AdminGetEsrsChoiceQueryVariables_>(AdminGetEsrsChoiceDocument_, options);
        }
export function useAdminGetEsrsChoiceSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetEsrsChoiceQuery_, AdminGetEsrsChoiceQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetEsrsChoiceQuery_, AdminGetEsrsChoiceQueryVariables_>(AdminGetEsrsChoiceDocument_, options);
        }
export type AdminGetEsrsChoiceQueryHookResult = ReturnType<typeof useAdminGetEsrsChoiceQuery>;
export type AdminGetEsrsChoiceLazyQuery_HookResult = ReturnType<typeof useAdminGetEsrsChoiceLazyQuery_>;
export type AdminGetEsrsChoiceSuspenseQuery_HookResult = ReturnType<typeof useAdminGetEsrsChoiceSuspenseQuery_>;
export type AdminGetEsrsChoiceQueryResult_ = Apollo.QueryResult<AdminGetEsrsChoiceQuery_, AdminGetEsrsChoiceQueryVariables_>;
export function refetchAdminGetEsrsChoiceQuery_(variables: AdminGetEsrsChoiceQueryVariables_) {
      return { query: AdminGetEsrsChoiceDocument_, variables: variables }
    }
export const AdminCreateEsrsChoiceDocument_ = gql`
    mutation AdminCreateEsrsChoice($object: EsrsChoice_insert_input!) {
  insert_EsrsChoice_one(object: $object) {
    title
    reference
    order
    choiceSetRef
  }
}
    `;
export type AdminCreateEsrsChoiceMutationFn_ = Apollo.MutationFunction<AdminCreateEsrsChoiceMutation_, AdminCreateEsrsChoiceMutationVariables_>;

/**
 * __useAdminCreateEsrsChoiceMutation__
 *
 * To run a mutation, you first call `useAdminCreateEsrsChoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateEsrsChoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateEsrsChoiceMutation, { data, loading, error }] = useAdminCreateEsrsChoiceMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateEsrsChoiceMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateEsrsChoiceMutation_, AdminCreateEsrsChoiceMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateEsrsChoiceMutation_, AdminCreateEsrsChoiceMutationVariables_>(AdminCreateEsrsChoiceDocument_, options);
      }
export type AdminCreateEsrsChoiceMutationHookResult = ReturnType<typeof useAdminCreateEsrsChoiceMutation>;
export type AdminCreateEsrsChoiceMutationResult_ = Apollo.MutationResult<AdminCreateEsrsChoiceMutation_>;
export type AdminCreateEsrsChoiceMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateEsrsChoiceMutation_, AdminCreateEsrsChoiceMutationVariables_>;
export const AdminCreateEsrsChoicesDocument_ = gql`
    mutation AdminCreateEsrsChoices($objects: [EsrsChoice_insert_input!]!) {
  insert_EsrsChoice(objects: $objects) {
    returning {
      reference
    }
  }
}
    `;
export type AdminCreateEsrsChoicesMutationFn_ = Apollo.MutationFunction<AdminCreateEsrsChoicesMutation_, AdminCreateEsrsChoicesMutationVariables_>;

/**
 * __useAdminCreateEsrsChoicesMutation__
 *
 * To run a mutation, you first call `useAdminCreateEsrsChoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateEsrsChoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateEsrsChoicesMutation, { data, loading, error }] = useAdminCreateEsrsChoicesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateEsrsChoicesMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateEsrsChoicesMutation_, AdminCreateEsrsChoicesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateEsrsChoicesMutation_, AdminCreateEsrsChoicesMutationVariables_>(AdminCreateEsrsChoicesDocument_, options);
      }
export type AdminCreateEsrsChoicesMutationHookResult = ReturnType<typeof useAdminCreateEsrsChoicesMutation>;
export type AdminCreateEsrsChoicesMutationResult_ = Apollo.MutationResult<AdminCreateEsrsChoicesMutation_>;
export type AdminCreateEsrsChoicesMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateEsrsChoicesMutation_, AdminCreateEsrsChoicesMutationVariables_>;
export const AdminUpdateEsrsChoiceDocument_ = gql`
    mutation AdminUpdateEsrsChoice($pk_columns: EsrsChoice_pk_columns_input!, $_set: EsrsChoice_set_input!) {
  update_EsrsChoice_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
    order
    choiceSetRef
  }
}
    `;
export type AdminUpdateEsrsChoiceMutationFn_ = Apollo.MutationFunction<AdminUpdateEsrsChoiceMutation_, AdminUpdateEsrsChoiceMutationVariables_>;

/**
 * __useAdminUpdateEsrsChoiceMutation__
 *
 * To run a mutation, you first call `useAdminUpdateEsrsChoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateEsrsChoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateEsrsChoiceMutation, { data, loading, error }] = useAdminUpdateEsrsChoiceMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateEsrsChoiceMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateEsrsChoiceMutation_, AdminUpdateEsrsChoiceMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateEsrsChoiceMutation_, AdminUpdateEsrsChoiceMutationVariables_>(AdminUpdateEsrsChoiceDocument_, options);
      }
export type AdminUpdateEsrsChoiceMutationHookResult = ReturnType<typeof useAdminUpdateEsrsChoiceMutation>;
export type AdminUpdateEsrsChoiceMutationResult_ = Apollo.MutationResult<AdminUpdateEsrsChoiceMutation_>;
export type AdminUpdateEsrsChoiceMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateEsrsChoiceMutation_, AdminUpdateEsrsChoiceMutationVariables_>;
export const AdminUpdateEsrsChoicesDocument_ = gql`
    mutation AdminUpdateEsrsChoices($updates: [EsrsChoice_updates!]!) {
  update_EsrsChoice_many(updates: $updates) {
    affected_rows
  }
}
    `;
export type AdminUpdateEsrsChoicesMutationFn_ = Apollo.MutationFunction<AdminUpdateEsrsChoicesMutation_, AdminUpdateEsrsChoicesMutationVariables_>;

/**
 * __useAdminUpdateEsrsChoicesMutation__
 *
 * To run a mutation, you first call `useAdminUpdateEsrsChoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateEsrsChoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateEsrsChoicesMutation, { data, loading, error }] = useAdminUpdateEsrsChoicesMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useAdminUpdateEsrsChoicesMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateEsrsChoicesMutation_, AdminUpdateEsrsChoicesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateEsrsChoicesMutation_, AdminUpdateEsrsChoicesMutationVariables_>(AdminUpdateEsrsChoicesDocument_, options);
      }
export type AdminUpdateEsrsChoicesMutationHookResult = ReturnType<typeof useAdminUpdateEsrsChoicesMutation>;
export type AdminUpdateEsrsChoicesMutationResult_ = Apollo.MutationResult<AdminUpdateEsrsChoicesMutation_>;
export type AdminUpdateEsrsChoicesMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateEsrsChoicesMutation_, AdminUpdateEsrsChoicesMutationVariables_>;
export const AdminDeleteEsrsChoiceDocument_ = gql`
    mutation AdminDeleteEsrsChoice($reference: String!) {
  delete_EsrsChoice_by_pk(reference: $reference) {
    title
    reference
    order
    choiceSetRef
  }
}
    `;
export type AdminDeleteEsrsChoiceMutationFn_ = Apollo.MutationFunction<AdminDeleteEsrsChoiceMutation_, AdminDeleteEsrsChoiceMutationVariables_>;

/**
 * __useAdminDeleteEsrsChoiceMutation__
 *
 * To run a mutation, you first call `useAdminDeleteEsrsChoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteEsrsChoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteEsrsChoiceMutation, { data, loading, error }] = useAdminDeleteEsrsChoiceMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteEsrsChoiceMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteEsrsChoiceMutation_, AdminDeleteEsrsChoiceMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteEsrsChoiceMutation_, AdminDeleteEsrsChoiceMutationVariables_>(AdminDeleteEsrsChoiceDocument_, options);
      }
export type AdminDeleteEsrsChoiceMutationHookResult = ReturnType<typeof useAdminDeleteEsrsChoiceMutation>;
export type AdminDeleteEsrsChoiceMutationResult_ = Apollo.MutationResult<AdminDeleteEsrsChoiceMutation_>;
export type AdminDeleteEsrsChoiceMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteEsrsChoiceMutation_, AdminDeleteEsrsChoiceMutationVariables_>;
export const AdminGetChoiceSetsDocument_ = gql`
    query AdminGetChoiceSets($limit: Int, $offset: Int, $order_by: [ChoiceSet_order_by!], $where: ChoiceSet_bool_exp) {
  ChoiceSet(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    title
  }
  ChoiceSet_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetChoiceSetsQuery__
 *
 * To run a query within a React component, call `useAdminGetChoiceSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetChoiceSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetChoiceSetsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetChoiceSetsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetChoiceSetsQuery_, AdminGetChoiceSetsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetChoiceSetsQuery_, AdminGetChoiceSetsQueryVariables_>(AdminGetChoiceSetsDocument_, options);
      }
export function useAdminGetChoiceSetsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetChoiceSetsQuery_, AdminGetChoiceSetsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetChoiceSetsQuery_, AdminGetChoiceSetsQueryVariables_>(AdminGetChoiceSetsDocument_, options);
        }
export function useAdminGetChoiceSetsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetChoiceSetsQuery_, AdminGetChoiceSetsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetChoiceSetsQuery_, AdminGetChoiceSetsQueryVariables_>(AdminGetChoiceSetsDocument_, options);
        }
export type AdminGetChoiceSetsQueryHookResult = ReturnType<typeof useAdminGetChoiceSetsQuery>;
export type AdminGetChoiceSetsLazyQuery_HookResult = ReturnType<typeof useAdminGetChoiceSetsLazyQuery_>;
export type AdminGetChoiceSetsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetChoiceSetsSuspenseQuery_>;
export type AdminGetChoiceSetsQueryResult_ = Apollo.QueryResult<AdminGetChoiceSetsQuery_, AdminGetChoiceSetsQueryVariables_>;
export function refetchAdminGetChoiceSetsQuery_(variables?: AdminGetChoiceSetsQueryVariables_) {
      return { query: AdminGetChoiceSetsDocument_, variables: variables }
    }
export const AdminGetChoiceSetDocument_ = gql`
    query AdminGetChoiceSet($title: String!) {
  ChoiceSet_by_pk(title: $title) {
    title
  }
}
    `;

/**
 * __useAdminGetChoiceSetQuery__
 *
 * To run a query within a React component, call `useAdminGetChoiceSetQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetChoiceSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetChoiceSetQuery({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useAdminGetChoiceSetQuery(baseOptions: Apollo.QueryHookOptions<AdminGetChoiceSetQuery_, AdminGetChoiceSetQueryVariables_> & ({ variables: AdminGetChoiceSetQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetChoiceSetQuery_, AdminGetChoiceSetQueryVariables_>(AdminGetChoiceSetDocument_, options);
      }
export function useAdminGetChoiceSetLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetChoiceSetQuery_, AdminGetChoiceSetQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetChoiceSetQuery_, AdminGetChoiceSetQueryVariables_>(AdminGetChoiceSetDocument_, options);
        }
export function useAdminGetChoiceSetSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetChoiceSetQuery_, AdminGetChoiceSetQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetChoiceSetQuery_, AdminGetChoiceSetQueryVariables_>(AdminGetChoiceSetDocument_, options);
        }
export type AdminGetChoiceSetQueryHookResult = ReturnType<typeof useAdminGetChoiceSetQuery>;
export type AdminGetChoiceSetLazyQuery_HookResult = ReturnType<typeof useAdminGetChoiceSetLazyQuery_>;
export type AdminGetChoiceSetSuspenseQuery_HookResult = ReturnType<typeof useAdminGetChoiceSetSuspenseQuery_>;
export type AdminGetChoiceSetQueryResult_ = Apollo.QueryResult<AdminGetChoiceSetQuery_, AdminGetChoiceSetQueryVariables_>;
export function refetchAdminGetChoiceSetQuery_(variables: AdminGetChoiceSetQueryVariables_) {
      return { query: AdminGetChoiceSetDocument_, variables: variables }
    }
export const AdminCreateChoiceSetDocument_ = gql`
    mutation AdminCreateChoiceSet($object: ChoiceSet_insert_input!) {
  insert_ChoiceSet_one(object: $object) {
    title
  }
}
    `;
export type AdminCreateChoiceSetMutationFn_ = Apollo.MutationFunction<AdminCreateChoiceSetMutation_, AdminCreateChoiceSetMutationVariables_>;

/**
 * __useAdminCreateChoiceSetMutation__
 *
 * To run a mutation, you first call `useAdminCreateChoiceSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateChoiceSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateChoiceSetMutation, { data, loading, error }] = useAdminCreateChoiceSetMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateChoiceSetMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateChoiceSetMutation_, AdminCreateChoiceSetMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateChoiceSetMutation_, AdminCreateChoiceSetMutationVariables_>(AdminCreateChoiceSetDocument_, options);
      }
export type AdminCreateChoiceSetMutationHookResult = ReturnType<typeof useAdminCreateChoiceSetMutation>;
export type AdminCreateChoiceSetMutationResult_ = Apollo.MutationResult<AdminCreateChoiceSetMutation_>;
export type AdminCreateChoiceSetMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateChoiceSetMutation_, AdminCreateChoiceSetMutationVariables_>;
export const AdminUpdateChoiceSetDocument_ = gql`
    mutation AdminUpdateChoiceSet($pk_columns: ChoiceSet_pk_columns_input!, $_set: ChoiceSet_set_input!) {
  update_ChoiceSet_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
  }
}
    `;
export type AdminUpdateChoiceSetMutationFn_ = Apollo.MutationFunction<AdminUpdateChoiceSetMutation_, AdminUpdateChoiceSetMutationVariables_>;

/**
 * __useAdminUpdateChoiceSetMutation__
 *
 * To run a mutation, you first call `useAdminUpdateChoiceSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateChoiceSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateChoiceSetMutation, { data, loading, error }] = useAdminUpdateChoiceSetMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateChoiceSetMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateChoiceSetMutation_, AdminUpdateChoiceSetMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateChoiceSetMutation_, AdminUpdateChoiceSetMutationVariables_>(AdminUpdateChoiceSetDocument_, options);
      }
export type AdminUpdateChoiceSetMutationHookResult = ReturnType<typeof useAdminUpdateChoiceSetMutation>;
export type AdminUpdateChoiceSetMutationResult_ = Apollo.MutationResult<AdminUpdateChoiceSetMutation_>;
export type AdminUpdateChoiceSetMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateChoiceSetMutation_, AdminUpdateChoiceSetMutationVariables_>;
export const AdminDeleteChoiceSetDocument_ = gql`
    mutation AdminDeleteChoiceSet($title: String!) {
  delete_ChoiceSet_by_pk(title: $title) {
    title
  }
}
    `;
export type AdminDeleteChoiceSetMutationFn_ = Apollo.MutationFunction<AdminDeleteChoiceSetMutation_, AdminDeleteChoiceSetMutationVariables_>;

/**
 * __useAdminDeleteChoiceSetMutation__
 *
 * To run a mutation, you first call `useAdminDeleteChoiceSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteChoiceSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteChoiceSetMutation, { data, loading, error }] = useAdminDeleteChoiceSetMutation({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useAdminDeleteChoiceSetMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteChoiceSetMutation_, AdminDeleteChoiceSetMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteChoiceSetMutation_, AdminDeleteChoiceSetMutationVariables_>(AdminDeleteChoiceSetDocument_, options);
      }
export type AdminDeleteChoiceSetMutationHookResult = ReturnType<typeof useAdminDeleteChoiceSetMutation>;
export type AdminDeleteChoiceSetMutationResult_ = Apollo.MutationResult<AdminDeleteChoiceSetMutation_>;
export type AdminDeleteChoiceSetMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteChoiceSetMutation_, AdminDeleteChoiceSetMutationVariables_>;
export const AdminGetEsrsAnswersDocument_ = gql`
    query AdminGetEsrsAnswers($limit: Int, $offset: Int, $order_by: [esrs_Answer_order_by!], $where: esrs_Answer_bool_exp) {
  esrs_Answer(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    id
    metricRef
    hasOptedOut
    reportingUnit {
      id
      name
      isCompanyLevel
    }
    esrsAssessment {
      id
      reportingYear
      company {
        isGroupOwner
        id
        name
        isReal
      }
      parentAssessment {
        id
        company {
          id
          name
        }
      }
    }
    datapoints_aggregate(where: {value: {_is_null: false}}) {
      aggregate {
        count
      }
    }
    datapoints(where: {value: {_is_null: false}}) {
      datapointId: id
      value
      factValue
      timeframe
      metadata
      datapointTags {
        tagValue
        tagType
      }
    }
  }
  esrs_Answer_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetEsrsAnswersQuery__
 *
 * To run a query within a React component, call `useAdminGetEsrsAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetEsrsAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetEsrsAnswersQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetEsrsAnswersQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetEsrsAnswersQuery_, AdminGetEsrsAnswersQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetEsrsAnswersQuery_, AdminGetEsrsAnswersQueryVariables_>(AdminGetEsrsAnswersDocument_, options);
      }
export function useAdminGetEsrsAnswersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetEsrsAnswersQuery_, AdminGetEsrsAnswersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetEsrsAnswersQuery_, AdminGetEsrsAnswersQueryVariables_>(AdminGetEsrsAnswersDocument_, options);
        }
export function useAdminGetEsrsAnswersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetEsrsAnswersQuery_, AdminGetEsrsAnswersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetEsrsAnswersQuery_, AdminGetEsrsAnswersQueryVariables_>(AdminGetEsrsAnswersDocument_, options);
        }
export type AdminGetEsrsAnswersQueryHookResult = ReturnType<typeof useAdminGetEsrsAnswersQuery>;
export type AdminGetEsrsAnswersLazyQuery_HookResult = ReturnType<typeof useAdminGetEsrsAnswersLazyQuery_>;
export type AdminGetEsrsAnswersSuspenseQuery_HookResult = ReturnType<typeof useAdminGetEsrsAnswersSuspenseQuery_>;
export type AdminGetEsrsAnswersQueryResult_ = Apollo.QueryResult<AdminGetEsrsAnswersQuery_, AdminGetEsrsAnswersQueryVariables_>;
export function refetchAdminGetEsrsAnswersQuery_(variables?: AdminGetEsrsAnswersQueryVariables_) {
      return { query: AdminGetEsrsAnswersDocument_, variables: variables }
    }
export const AdminGetMaterialMetricsDocument_ = gql`
    query AdminGetMaterialMetrics($limit: Int, $offset: Int, $order_by: [esrs_MaterialMetric_order_by!], $where: esrs_MaterialMetric_bool_exp) {
  esrs_MaterialMetric(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    metricRef
    isMaterial
    materialMetricTags {
      id
      tagType
      materialTagValues {
        tagValue
      }
    }
    materialStandard {
      id
      standardRef
      esrsAssessment {
        id
        reportingYear
        company {
          id
          name
        }
      }
    }
  }
  esrs_MaterialMetric_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetMaterialMetricsQuery__
 *
 * To run a query within a React component, call `useAdminGetMaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMaterialMetricsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetMaterialMetricsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetMaterialMetricsQuery_, AdminGetMaterialMetricsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMaterialMetricsQuery_, AdminGetMaterialMetricsQueryVariables_>(AdminGetMaterialMetricsDocument_, options);
      }
export function useAdminGetMaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMaterialMetricsQuery_, AdminGetMaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMaterialMetricsQuery_, AdminGetMaterialMetricsQueryVariables_>(AdminGetMaterialMetricsDocument_, options);
        }
export function useAdminGetMaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMaterialMetricsQuery_, AdminGetMaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMaterialMetricsQuery_, AdminGetMaterialMetricsQueryVariables_>(AdminGetMaterialMetricsDocument_, options);
        }
export type AdminGetMaterialMetricsQueryHookResult = ReturnType<typeof useAdminGetMaterialMetricsQuery>;
export type AdminGetMaterialMetricsLazyQuery_HookResult = ReturnType<typeof useAdminGetMaterialMetricsLazyQuery_>;
export type AdminGetMaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetMaterialMetricsSuspenseQuery_>;
export type AdminGetMaterialMetricsQueryResult_ = Apollo.QueryResult<AdminGetMaterialMetricsQuery_, AdminGetMaterialMetricsQueryVariables_>;
export function refetchAdminGetMaterialMetricsQuery_(variables?: AdminGetMaterialMetricsQueryVariables_) {
      return { query: AdminGetMaterialMetricsDocument_, variables: variables }
    }
export const AdminGetAuthUserRolesDocument_ = gql`
    query AdminGetAuthUserRoles($limit: Int, $offset: Int, $order_by: [authUserRoles_order_by!], $where: authUserRoles_bool_exp) {
  authUserRoles(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    role
    userId
  }
  authUserRolesAggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetAuthUserRolesQuery__
 *
 * To run a query within a React component, call `useAdminGetAuthUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetAuthUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetAuthUserRolesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetAuthUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetAuthUserRolesQuery_, AdminGetAuthUserRolesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetAuthUserRolesQuery_, AdminGetAuthUserRolesQueryVariables_>(AdminGetAuthUserRolesDocument_, options);
      }
export function useAdminGetAuthUserRolesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetAuthUserRolesQuery_, AdminGetAuthUserRolesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetAuthUserRolesQuery_, AdminGetAuthUserRolesQueryVariables_>(AdminGetAuthUserRolesDocument_, options);
        }
export function useAdminGetAuthUserRolesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetAuthUserRolesQuery_, AdminGetAuthUserRolesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetAuthUserRolesQuery_, AdminGetAuthUserRolesQueryVariables_>(AdminGetAuthUserRolesDocument_, options);
        }
export type AdminGetAuthUserRolesQueryHookResult = ReturnType<typeof useAdminGetAuthUserRolesQuery>;
export type AdminGetAuthUserRolesLazyQuery_HookResult = ReturnType<typeof useAdminGetAuthUserRolesLazyQuery_>;
export type AdminGetAuthUserRolesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetAuthUserRolesSuspenseQuery_>;
export type AdminGetAuthUserRolesQueryResult_ = Apollo.QueryResult<AdminGetAuthUserRolesQuery_, AdminGetAuthUserRolesQueryVariables_>;
export function refetchAdminGetAuthUserRolesQuery_(variables?: AdminGetAuthUserRolesQueryVariables_) {
      return { query: AdminGetAuthUserRolesDocument_, variables: variables }
    }
export const AdminCreateAuthUserRolesDocument_ = gql`
    mutation AdminCreateAuthUserRoles($objects: [authUserRoles_insert_input!]!) {
  insert_authUserRoles: insertAuthUserRoles(objects: $objects) {
    returning {
      id
      role
      userId
    }
  }
}
    `;
export type AdminCreateAuthUserRolesMutationFn_ = Apollo.MutationFunction<AdminCreateAuthUserRolesMutation_, AdminCreateAuthUserRolesMutationVariables_>;

/**
 * __useAdminCreateAuthUserRolesMutation__
 *
 * To run a mutation, you first call `useAdminCreateAuthUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateAuthUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateAuthUserRolesMutation, { data, loading, error }] = useAdminCreateAuthUserRolesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateAuthUserRolesMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateAuthUserRolesMutation_, AdminCreateAuthUserRolesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateAuthUserRolesMutation_, AdminCreateAuthUserRolesMutationVariables_>(AdminCreateAuthUserRolesDocument_, options);
      }
export type AdminCreateAuthUserRolesMutationHookResult = ReturnType<typeof useAdminCreateAuthUserRolesMutation>;
export type AdminCreateAuthUserRolesMutationResult_ = Apollo.MutationResult<AdminCreateAuthUserRolesMutation_>;
export type AdminCreateAuthUserRolesMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateAuthUserRolesMutation_, AdminCreateAuthUserRolesMutationVariables_>;
export const AdminDeleteAuthUserRolesDocument_ = gql`
    mutation AdminDeleteAuthUserRoles($id: uuid!) {
  deleteAuthUserRoles(where: {id: {_eq: $id}}) {
    returning {
      id
      role
      userId
    }
  }
}
    `;
export type AdminDeleteAuthUserRolesMutationFn_ = Apollo.MutationFunction<AdminDeleteAuthUserRolesMutation_, AdminDeleteAuthUserRolesMutationVariables_>;

/**
 * __useAdminDeleteAuthUserRolesMutation__
 *
 * To run a mutation, you first call `useAdminDeleteAuthUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteAuthUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteAuthUserRolesMutation, { data, loading, error }] = useAdminDeleteAuthUserRolesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteAuthUserRolesMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteAuthUserRolesMutation_, AdminDeleteAuthUserRolesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteAuthUserRolesMutation_, AdminDeleteAuthUserRolesMutationVariables_>(AdminDeleteAuthUserRolesDocument_, options);
      }
export type AdminDeleteAuthUserRolesMutationHookResult = ReturnType<typeof useAdminDeleteAuthUserRolesMutation>;
export type AdminDeleteAuthUserRolesMutationResult_ = Apollo.MutationResult<AdminDeleteAuthUserRolesMutation_>;
export type AdminDeleteAuthUserRolesMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteAuthUserRolesMutation_, AdminDeleteAuthUserRolesMutationVariables_>;
export const AdminGetFrameworksDocument_ = gql`
    query AdminGetFrameworks($limit: Int, $offset: Int, $order_by: [Framework_order_by!], $where: Framework_bool_exp) {
  Framework(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    name
    reference
  }
  Framework_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetFrameworksQuery__
 *
 * To run a query within a React component, call `useAdminGetFrameworksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetFrameworksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetFrameworksQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetFrameworksQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetFrameworksQuery_, AdminGetFrameworksQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetFrameworksQuery_, AdminGetFrameworksQueryVariables_>(AdminGetFrameworksDocument_, options);
      }
export function useAdminGetFrameworksLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetFrameworksQuery_, AdminGetFrameworksQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetFrameworksQuery_, AdminGetFrameworksQueryVariables_>(AdminGetFrameworksDocument_, options);
        }
export function useAdminGetFrameworksSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetFrameworksQuery_, AdminGetFrameworksQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetFrameworksQuery_, AdminGetFrameworksQueryVariables_>(AdminGetFrameworksDocument_, options);
        }
export type AdminGetFrameworksQueryHookResult = ReturnType<typeof useAdminGetFrameworksQuery>;
export type AdminGetFrameworksLazyQuery_HookResult = ReturnType<typeof useAdminGetFrameworksLazyQuery_>;
export type AdminGetFrameworksSuspenseQuery_HookResult = ReturnType<typeof useAdminGetFrameworksSuspenseQuery_>;
export type AdminGetFrameworksQueryResult_ = Apollo.QueryResult<AdminGetFrameworksQuery_, AdminGetFrameworksQueryVariables_>;
export function refetchAdminGetFrameworksQuery_(variables?: AdminGetFrameworksQueryVariables_) {
      return { query: AdminGetFrameworksDocument_, variables: variables }
    }
export const AdminGetFrameworkDocument_ = gql`
    query AdminGetFramework($reference: String!) {
  Framework_by_pk(reference: $reference) {
    name
    reference
  }
}
    `;

/**
 * __useAdminGetFrameworkQuery__
 *
 * To run a query within a React component, call `useAdminGetFrameworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetFrameworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetFrameworkQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetFrameworkQuery(baseOptions: Apollo.QueryHookOptions<AdminGetFrameworkQuery_, AdminGetFrameworkQueryVariables_> & ({ variables: AdminGetFrameworkQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetFrameworkQuery_, AdminGetFrameworkQueryVariables_>(AdminGetFrameworkDocument_, options);
      }
export function useAdminGetFrameworkLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetFrameworkQuery_, AdminGetFrameworkQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetFrameworkQuery_, AdminGetFrameworkQueryVariables_>(AdminGetFrameworkDocument_, options);
        }
export function useAdminGetFrameworkSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetFrameworkQuery_, AdminGetFrameworkQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetFrameworkQuery_, AdminGetFrameworkQueryVariables_>(AdminGetFrameworkDocument_, options);
        }
export type AdminGetFrameworkQueryHookResult = ReturnType<typeof useAdminGetFrameworkQuery>;
export type AdminGetFrameworkLazyQuery_HookResult = ReturnType<typeof useAdminGetFrameworkLazyQuery_>;
export type AdminGetFrameworkSuspenseQuery_HookResult = ReturnType<typeof useAdminGetFrameworkSuspenseQuery_>;
export type AdminGetFrameworkQueryResult_ = Apollo.QueryResult<AdminGetFrameworkQuery_, AdminGetFrameworkQueryVariables_>;
export function refetchAdminGetFrameworkQuery_(variables: AdminGetFrameworkQueryVariables_) {
      return { query: AdminGetFrameworkDocument_, variables: variables }
    }
export const AdminDeleteFrameworkDocument_ = gql`
    mutation AdminDeleteFramework($reference: String!) {
  delete_Framework_by_pk(reference: $reference) {
    reference
  }
}
    `;
export type AdminDeleteFrameworkMutationFn_ = Apollo.MutationFunction<AdminDeleteFrameworkMutation_, AdminDeleteFrameworkMutationVariables_>;

/**
 * __useAdminDeleteFrameworkMutation__
 *
 * To run a mutation, you first call `useAdminDeleteFrameworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteFrameworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteFrameworkMutation, { data, loading, error }] = useAdminDeleteFrameworkMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteFrameworkMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteFrameworkMutation_, AdminDeleteFrameworkMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteFrameworkMutation_, AdminDeleteFrameworkMutationVariables_>(AdminDeleteFrameworkDocument_, options);
      }
export type AdminDeleteFrameworkMutationHookResult = ReturnType<typeof useAdminDeleteFrameworkMutation>;
export type AdminDeleteFrameworkMutationResult_ = Apollo.MutationResult<AdminDeleteFrameworkMutation_>;
export type AdminDeleteFrameworkMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteFrameworkMutation_, AdminDeleteFrameworkMutationVariables_>;
export const AdminUpdateFrameworkDocument_ = gql`
    mutation AdminUpdateFramework($pk_columns: Framework_pk_columns_input!, $_set: Framework_set_input!) {
  update_Framework_by_pk(pk_columns: $pk_columns, _set: $_set) {
    name
    reference
  }
}
    `;
export type AdminUpdateFrameworkMutationFn_ = Apollo.MutationFunction<AdminUpdateFrameworkMutation_, AdminUpdateFrameworkMutationVariables_>;

/**
 * __useAdminUpdateFrameworkMutation__
 *
 * To run a mutation, you first call `useAdminUpdateFrameworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateFrameworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateFrameworkMutation, { data, loading, error }] = useAdminUpdateFrameworkMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateFrameworkMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateFrameworkMutation_, AdminUpdateFrameworkMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateFrameworkMutation_, AdminUpdateFrameworkMutationVariables_>(AdminUpdateFrameworkDocument_, options);
      }
export type AdminUpdateFrameworkMutationHookResult = ReturnType<typeof useAdminUpdateFrameworkMutation>;
export type AdminUpdateFrameworkMutationResult_ = Apollo.MutationResult<AdminUpdateFrameworkMutation_>;
export type AdminUpdateFrameworkMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateFrameworkMutation_, AdminUpdateFrameworkMutationVariables_>;
export const AdminCreateFrameworkDocument_ = gql`
    mutation AdminCreateFramework($object: Framework_insert_input!) {
  insert_Framework_one(object: $object) {
    name
    reference
  }
}
    `;
export type AdminCreateFrameworkMutationFn_ = Apollo.MutationFunction<AdminCreateFrameworkMutation_, AdminCreateFrameworkMutationVariables_>;

/**
 * __useAdminCreateFrameworkMutation__
 *
 * To run a mutation, you first call `useAdminCreateFrameworkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateFrameworkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateFrameworkMutation, { data, loading, error }] = useAdminCreateFrameworkMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateFrameworkMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateFrameworkMutation_, AdminCreateFrameworkMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateFrameworkMutation_, AdminCreateFrameworkMutationVariables_>(AdminCreateFrameworkDocument_, options);
      }
export type AdminCreateFrameworkMutationHookResult = ReturnType<typeof useAdminCreateFrameworkMutation>;
export type AdminCreateFrameworkMutationResult_ = Apollo.MutationResult<AdminCreateFrameworkMutation_>;
export type AdminCreateFrameworkMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateFrameworkMutation_, AdminCreateFrameworkMutationVariables_>;
export const AdminGetFrameworkStructureDocument_ = gql`
    query AdminGetFrameworkStructure($frameworkRef: String!) {
  framework: Framework_by_pk(reference: $frameworkRef) {
    reference
    name
    standards {
      reference
      categoryRef
      title
      description
      order
      disclosureRequirementGroups {
        reference
        standardRef
        title
        order
        disclosureRequirements: requirements {
          reference
          groupRef
          title
          description
          order
          type
          metrics {
            reference
            disclosureRequirementRef
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAdminGetFrameworkStructureQuery__
 *
 * To run a query within a React component, call `useAdminGetFrameworkStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetFrameworkStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetFrameworkStructureQuery({
 *   variables: {
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useAdminGetFrameworkStructureQuery(baseOptions: Apollo.QueryHookOptions<AdminGetFrameworkStructureQuery_, AdminGetFrameworkStructureQueryVariables_> & ({ variables: AdminGetFrameworkStructureQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetFrameworkStructureQuery_, AdminGetFrameworkStructureQueryVariables_>(AdminGetFrameworkStructureDocument_, options);
      }
export function useAdminGetFrameworkStructureLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetFrameworkStructureQuery_, AdminGetFrameworkStructureQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetFrameworkStructureQuery_, AdminGetFrameworkStructureQueryVariables_>(AdminGetFrameworkStructureDocument_, options);
        }
export function useAdminGetFrameworkStructureSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetFrameworkStructureQuery_, AdminGetFrameworkStructureQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetFrameworkStructureQuery_, AdminGetFrameworkStructureQueryVariables_>(AdminGetFrameworkStructureDocument_, options);
        }
export type AdminGetFrameworkStructureQueryHookResult = ReturnType<typeof useAdminGetFrameworkStructureQuery>;
export type AdminGetFrameworkStructureLazyQuery_HookResult = ReturnType<typeof useAdminGetFrameworkStructureLazyQuery_>;
export type AdminGetFrameworkStructureSuspenseQuery_HookResult = ReturnType<typeof useAdminGetFrameworkStructureSuspenseQuery_>;
export type AdminGetFrameworkStructureQueryResult_ = Apollo.QueryResult<AdminGetFrameworkStructureQuery_, AdminGetFrameworkStructureQueryVariables_>;
export function refetchAdminGetFrameworkStructureQuery_(variables: AdminGetFrameworkStructureQueryVariables_) {
      return { query: AdminGetFrameworkStructureDocument_, variables: variables }
    }
export const AdminDuplicateFrameworkStructureDocument_ = gql`
    mutation AdminDuplicateFrameworkStructure($objects: [MFStandard_insert_input!]!) {
  insert_MFStandard(
    objects: $objects
    on_conflict: {constraint: MFStandard_pkey, update_columns: [title, description, order]}
  ) {
    affected_rows
    returning {
      reference
    }
  }
}
    `;
export type AdminDuplicateFrameworkStructureMutationFn_ = Apollo.MutationFunction<AdminDuplicateFrameworkStructureMutation_, AdminDuplicateFrameworkStructureMutationVariables_>;

/**
 * __useAdminDuplicateFrameworkStructureMutation__
 *
 * To run a mutation, you first call `useAdminDuplicateFrameworkStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDuplicateFrameworkStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDuplicateFrameworkStructureMutation, { data, loading, error }] = useAdminDuplicateFrameworkStructureMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminDuplicateFrameworkStructureMutation(baseOptions?: Apollo.MutationHookOptions<AdminDuplicateFrameworkStructureMutation_, AdminDuplicateFrameworkStructureMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDuplicateFrameworkStructureMutation_, AdminDuplicateFrameworkStructureMutationVariables_>(AdminDuplicateFrameworkStructureDocument_, options);
      }
export type AdminDuplicateFrameworkStructureMutationHookResult = ReturnType<typeof useAdminDuplicateFrameworkStructureMutation>;
export type AdminDuplicateFrameworkStructureMutationResult_ = Apollo.MutationResult<AdminDuplicateFrameworkStructureMutation_>;
export type AdminDuplicateFrameworkStructureMutationOptions_ = Apollo.BaseMutationOptions<AdminDuplicateFrameworkStructureMutation_, AdminDuplicateFrameworkStructureMutationVariables_>;
export const AdminGetMfCategoriesDocument_ = gql`
    query AdminGetMFCategories($limit: Int, $offset: Int, $order_by: [MFCategory_order_by!], $where: MFCategory_bool_exp) {
  MFCategory(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    title
    reference
    order
  }
  MFCategory_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetMfCategoriesQuery__
 *
 * To run a query within a React component, call `useAdminGetMfCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMfCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMfCategoriesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetMfCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetMfCategoriesQuery_, AdminGetMfCategoriesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMfCategoriesQuery_, AdminGetMfCategoriesQueryVariables_>(AdminGetMfCategoriesDocument_, options);
      }
export function useAdminGetMfCategoriesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMfCategoriesQuery_, AdminGetMfCategoriesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMfCategoriesQuery_, AdminGetMfCategoriesQueryVariables_>(AdminGetMfCategoriesDocument_, options);
        }
export function useAdminGetMfCategoriesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMfCategoriesQuery_, AdminGetMfCategoriesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMfCategoriesQuery_, AdminGetMfCategoriesQueryVariables_>(AdminGetMfCategoriesDocument_, options);
        }
export type AdminGetMfCategoriesQueryHookResult = ReturnType<typeof useAdminGetMfCategoriesQuery>;
export type AdminGetMfCategoriesLazyQuery_HookResult = ReturnType<typeof useAdminGetMfCategoriesLazyQuery_>;
export type AdminGetMfCategoriesSuspenseQuery_HookResult = ReturnType<typeof useAdminGetMfCategoriesSuspenseQuery_>;
export type AdminGetMfCategoriesQueryResult_ = Apollo.QueryResult<AdminGetMfCategoriesQuery_, AdminGetMfCategoriesQueryVariables_>;
export function refetchAdminGetMfCategoriesQuery_(variables?: AdminGetMfCategoriesQueryVariables_) {
      return { query: AdminGetMfCategoriesDocument_, variables: variables }
    }
export const AdminGetMfCategoryDocument_ = gql`
    query AdminGetMFCategory($reference: String!) {
  MFCategory_by_pk(reference: $reference) {
    title
    reference
    order
  }
}
    `;

/**
 * __useAdminGetMfCategoryQuery__
 *
 * To run a query within a React component, call `useAdminGetMfCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMfCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMfCategoryQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetMfCategoryQuery(baseOptions: Apollo.QueryHookOptions<AdminGetMfCategoryQuery_, AdminGetMfCategoryQueryVariables_> & ({ variables: AdminGetMfCategoryQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMfCategoryQuery_, AdminGetMfCategoryQueryVariables_>(AdminGetMfCategoryDocument_, options);
      }
export function useAdminGetMfCategoryLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMfCategoryQuery_, AdminGetMfCategoryQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMfCategoryQuery_, AdminGetMfCategoryQueryVariables_>(AdminGetMfCategoryDocument_, options);
        }
export function useAdminGetMfCategorySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMfCategoryQuery_, AdminGetMfCategoryQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMfCategoryQuery_, AdminGetMfCategoryQueryVariables_>(AdminGetMfCategoryDocument_, options);
        }
export type AdminGetMfCategoryQueryHookResult = ReturnType<typeof useAdminGetMfCategoryQuery>;
export type AdminGetMfCategoryLazyQuery_HookResult = ReturnType<typeof useAdminGetMfCategoryLazyQuery_>;
export type AdminGetMfCategorySuspenseQuery_HookResult = ReturnType<typeof useAdminGetMfCategorySuspenseQuery_>;
export type AdminGetMfCategoryQueryResult_ = Apollo.QueryResult<AdminGetMfCategoryQuery_, AdminGetMfCategoryQueryVariables_>;
export function refetchAdminGetMfCategoryQuery_(variables: AdminGetMfCategoryQueryVariables_) {
      return { query: AdminGetMfCategoryDocument_, variables: variables }
    }
export const AdminDeleteMfCategoryDocument_ = gql`
    mutation AdminDeleteMFCategory($reference: String!) {
  delete_MFCategory_by_pk(reference: $reference) {
    reference
  }
}
    `;
export type AdminDeleteMfCategoryMutationFn_ = Apollo.MutationFunction<AdminDeleteMfCategoryMutation_, AdminDeleteMfCategoryMutationVariables_>;

/**
 * __useAdminDeleteMfCategoryMutation__
 *
 * To run a mutation, you first call `useAdminDeleteMfCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteMfCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteMfCategoryMutation, { data, loading, error }] = useAdminDeleteMfCategoryMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteMfCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteMfCategoryMutation_, AdminDeleteMfCategoryMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteMfCategoryMutation_, AdminDeleteMfCategoryMutationVariables_>(AdminDeleteMfCategoryDocument_, options);
      }
export type AdminDeleteMfCategoryMutationHookResult = ReturnType<typeof useAdminDeleteMfCategoryMutation>;
export type AdminDeleteMfCategoryMutationResult_ = Apollo.MutationResult<AdminDeleteMfCategoryMutation_>;
export type AdminDeleteMfCategoryMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteMfCategoryMutation_, AdminDeleteMfCategoryMutationVariables_>;
export const AdminUpdateMfCategoryDocument_ = gql`
    mutation AdminUpdateMFCategory($pk_columns: MFCategory_pk_columns_input!, $_set: MFCategory_set_input!) {
  update_MFCategory_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
    order
  }
}
    `;
export type AdminUpdateMfCategoryMutationFn_ = Apollo.MutationFunction<AdminUpdateMfCategoryMutation_, AdminUpdateMfCategoryMutationVariables_>;

/**
 * __useAdminUpdateMfCategoryMutation__
 *
 * To run a mutation, you first call `useAdminUpdateMfCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateMfCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateMfCategoryMutation, { data, loading, error }] = useAdminUpdateMfCategoryMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateMfCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateMfCategoryMutation_, AdminUpdateMfCategoryMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateMfCategoryMutation_, AdminUpdateMfCategoryMutationVariables_>(AdminUpdateMfCategoryDocument_, options);
      }
export type AdminUpdateMfCategoryMutationHookResult = ReturnType<typeof useAdminUpdateMfCategoryMutation>;
export type AdminUpdateMfCategoryMutationResult_ = Apollo.MutationResult<AdminUpdateMfCategoryMutation_>;
export type AdminUpdateMfCategoryMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateMfCategoryMutation_, AdminUpdateMfCategoryMutationVariables_>;
export const AdminCreateMfCategoryDocument_ = gql`
    mutation AdminCreateMFCategory($object: MFCategory_insert_input!) {
  insert_MFCategory_one(object: $object) {
    title
    reference
    order
  }
}
    `;
export type AdminCreateMfCategoryMutationFn_ = Apollo.MutationFunction<AdminCreateMfCategoryMutation_, AdminCreateMfCategoryMutationVariables_>;

/**
 * __useAdminCreateMfCategoryMutation__
 *
 * To run a mutation, you first call `useAdminCreateMfCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMfCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMfCategoryMutation, { data, loading, error }] = useAdminCreateMfCategoryMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateMfCategoryMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMfCategoryMutation_, AdminCreateMfCategoryMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMfCategoryMutation_, AdminCreateMfCategoryMutationVariables_>(AdminCreateMfCategoryDocument_, options);
      }
export type AdminCreateMfCategoryMutationHookResult = ReturnType<typeof useAdminCreateMfCategoryMutation>;
export type AdminCreateMfCategoryMutationResult_ = Apollo.MutationResult<AdminCreateMfCategoryMutation_>;
export type AdminCreateMfCategoryMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateMfCategoryMutation_, AdminCreateMfCategoryMutationVariables_>;
export const AdminGetMfStandardsDocument_ = gql`
    query AdminGetMFStandards($limit: Int, $offset: Int, $order_by: [MFStandard_order_by!], $where: MFStandard_bool_exp) {
  MFStandard(limit: $limit, offset: $offset, order_by: $order_by, where: $where) {
    title
    reference
    description
    order
    mfCategoryRef
  }
  MFStandard_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetMfStandardsQuery__
 *
 * To run a query within a React component, call `useAdminGetMfStandardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMfStandardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMfStandardsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetMfStandardsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetMfStandardsQuery_, AdminGetMfStandardsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMfStandardsQuery_, AdminGetMfStandardsQueryVariables_>(AdminGetMfStandardsDocument_, options);
      }
export function useAdminGetMfStandardsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMfStandardsQuery_, AdminGetMfStandardsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMfStandardsQuery_, AdminGetMfStandardsQueryVariables_>(AdminGetMfStandardsDocument_, options);
        }
export function useAdminGetMfStandardsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMfStandardsQuery_, AdminGetMfStandardsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMfStandardsQuery_, AdminGetMfStandardsQueryVariables_>(AdminGetMfStandardsDocument_, options);
        }
export type AdminGetMfStandardsQueryHookResult = ReturnType<typeof useAdminGetMfStandardsQuery>;
export type AdminGetMfStandardsLazyQuery_HookResult = ReturnType<typeof useAdminGetMfStandardsLazyQuery_>;
export type AdminGetMfStandardsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetMfStandardsSuspenseQuery_>;
export type AdminGetMfStandardsQueryResult_ = Apollo.QueryResult<AdminGetMfStandardsQuery_, AdminGetMfStandardsQueryVariables_>;
export function refetchAdminGetMfStandardsQuery_(variables?: AdminGetMfStandardsQueryVariables_) {
      return { query: AdminGetMfStandardsDocument_, variables: variables }
    }
export const AdminGetMfStandardDocument_ = gql`
    query AdminGetMFStandard($reference: String!) {
  MFStandard_by_pk(reference: $reference) {
    title
    reference
    description
    order
    mfCategoryRef
  }
}
    `;

/**
 * __useAdminGetMfStandardQuery__
 *
 * To run a query within a React component, call `useAdminGetMfStandardQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMfStandardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMfStandardQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetMfStandardQuery(baseOptions: Apollo.QueryHookOptions<AdminGetMfStandardQuery_, AdminGetMfStandardQueryVariables_> & ({ variables: AdminGetMfStandardQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMfStandardQuery_, AdminGetMfStandardQueryVariables_>(AdminGetMfStandardDocument_, options);
      }
export function useAdminGetMfStandardLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMfStandardQuery_, AdminGetMfStandardQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMfStandardQuery_, AdminGetMfStandardQueryVariables_>(AdminGetMfStandardDocument_, options);
        }
export function useAdminGetMfStandardSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMfStandardQuery_, AdminGetMfStandardQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMfStandardQuery_, AdminGetMfStandardQueryVariables_>(AdminGetMfStandardDocument_, options);
        }
export type AdminGetMfStandardQueryHookResult = ReturnType<typeof useAdminGetMfStandardQuery>;
export type AdminGetMfStandardLazyQuery_HookResult = ReturnType<typeof useAdminGetMfStandardLazyQuery_>;
export type AdminGetMfStandardSuspenseQuery_HookResult = ReturnType<typeof useAdminGetMfStandardSuspenseQuery_>;
export type AdminGetMfStandardQueryResult_ = Apollo.QueryResult<AdminGetMfStandardQuery_, AdminGetMfStandardQueryVariables_>;
export function refetchAdminGetMfStandardQuery_(variables: AdminGetMfStandardQueryVariables_) {
      return { query: AdminGetMfStandardDocument_, variables: variables }
    }
export const AdminDeleteMfStandardDocument_ = gql`
    mutation AdminDeleteMFStandard($reference: String!) {
  delete_MFStandard_by_pk(reference: $reference) {
    reference
  }
}
    `;
export type AdminDeleteMfStandardMutationFn_ = Apollo.MutationFunction<AdminDeleteMfStandardMutation_, AdminDeleteMfStandardMutationVariables_>;

/**
 * __useAdminDeleteMfStandardMutation__
 *
 * To run a mutation, you first call `useAdminDeleteMfStandardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteMfStandardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteMfStandardMutation, { data, loading, error }] = useAdminDeleteMfStandardMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteMfStandardMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteMfStandardMutation_, AdminDeleteMfStandardMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteMfStandardMutation_, AdminDeleteMfStandardMutationVariables_>(AdminDeleteMfStandardDocument_, options);
      }
export type AdminDeleteMfStandardMutationHookResult = ReturnType<typeof useAdminDeleteMfStandardMutation>;
export type AdminDeleteMfStandardMutationResult_ = Apollo.MutationResult<AdminDeleteMfStandardMutation_>;
export type AdminDeleteMfStandardMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteMfStandardMutation_, AdminDeleteMfStandardMutationVariables_>;
export const AdminUpdateMfStandardDocument_ = gql`
    mutation AdminUpdateMFStandard($pk_columns: MFStandard_pk_columns_input!, $_set: MFStandard_set_input!) {
  update_MFStandard_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
    description
    order
    mfCategoryRef
  }
}
    `;
export type AdminUpdateMfStandardMutationFn_ = Apollo.MutationFunction<AdminUpdateMfStandardMutation_, AdminUpdateMfStandardMutationVariables_>;

/**
 * __useAdminUpdateMfStandardMutation__
 *
 * To run a mutation, you first call `useAdminUpdateMfStandardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateMfStandardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateMfStandardMutation, { data, loading, error }] = useAdminUpdateMfStandardMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateMfStandardMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateMfStandardMutation_, AdminUpdateMfStandardMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateMfStandardMutation_, AdminUpdateMfStandardMutationVariables_>(AdminUpdateMfStandardDocument_, options);
      }
export type AdminUpdateMfStandardMutationHookResult = ReturnType<typeof useAdminUpdateMfStandardMutation>;
export type AdminUpdateMfStandardMutationResult_ = Apollo.MutationResult<AdminUpdateMfStandardMutation_>;
export type AdminUpdateMfStandardMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateMfStandardMutation_, AdminUpdateMfStandardMutationVariables_>;
export const AdminCreateMfStandardDocument_ = gql`
    mutation AdminCreateMFStandard($object: MFStandard_insert_input!) {
  insert_MFStandard_one(object: $object) {
    title
    reference
    description
    order
    mfCategoryRef
  }
}
    `;
export type AdminCreateMfStandardMutationFn_ = Apollo.MutationFunction<AdminCreateMfStandardMutation_, AdminCreateMfStandardMutationVariables_>;

/**
 * __useAdminCreateMfStandardMutation__
 *
 * To run a mutation, you first call `useAdminCreateMfStandardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMfStandardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMfStandardMutation, { data, loading, error }] = useAdminCreateMfStandardMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateMfStandardMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMfStandardMutation_, AdminCreateMfStandardMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMfStandardMutation_, AdminCreateMfStandardMutationVariables_>(AdminCreateMfStandardDocument_, options);
      }
export type AdminCreateMfStandardMutationHookResult = ReturnType<typeof useAdminCreateMfStandardMutation>;
export type AdminCreateMfStandardMutationResult_ = Apollo.MutationResult<AdminCreateMfStandardMutation_>;
export type AdminCreateMfStandardMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateMfStandardMutation_, AdminCreateMfStandardMutationVariables_>;
export const AdminGetMfStandardsItemsDocument_ = gql`
    query AdminGetMFStandardsItems($limit: Int, $offset: Int, $order_by: [MFStandardItem_order_by!], $where: MFStandardItem_bool_exp) {
  MFStandardItem(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    standardRef
    mfStandardRef
    order
  }
  MFStandardItem_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetMfStandardsItemsQuery__
 *
 * To run a query within a React component, call `useAdminGetMfStandardsItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMfStandardsItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMfStandardsItemsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetMfStandardsItemsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetMfStandardsItemsQuery_, AdminGetMfStandardsItemsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMfStandardsItemsQuery_, AdminGetMfStandardsItemsQueryVariables_>(AdminGetMfStandardsItemsDocument_, options);
      }
export function useAdminGetMfStandardsItemsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMfStandardsItemsQuery_, AdminGetMfStandardsItemsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMfStandardsItemsQuery_, AdminGetMfStandardsItemsQueryVariables_>(AdminGetMfStandardsItemsDocument_, options);
        }
export function useAdminGetMfStandardsItemsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMfStandardsItemsQuery_, AdminGetMfStandardsItemsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMfStandardsItemsQuery_, AdminGetMfStandardsItemsQueryVariables_>(AdminGetMfStandardsItemsDocument_, options);
        }
export type AdminGetMfStandardsItemsQueryHookResult = ReturnType<typeof useAdminGetMfStandardsItemsQuery>;
export type AdminGetMfStandardsItemsLazyQuery_HookResult = ReturnType<typeof useAdminGetMfStandardsItemsLazyQuery_>;
export type AdminGetMfStandardsItemsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetMfStandardsItemsSuspenseQuery_>;
export type AdminGetMfStandardsItemsQueryResult_ = Apollo.QueryResult<AdminGetMfStandardsItemsQuery_, AdminGetMfStandardsItemsQueryVariables_>;
export function refetchAdminGetMfStandardsItemsQuery_(variables?: AdminGetMfStandardsItemsQueryVariables_) {
      return { query: AdminGetMfStandardsItemsDocument_, variables: variables }
    }
export const AdminGetMfStandardItemDocument_ = gql`
    query AdminGetMFStandardItem($id: uuid!) {
  MFStandardItem_by_pk(id: $id) {
    id
    standardRef
    mfStandardRef
    order
  }
}
    `;

/**
 * __useAdminGetMfStandardItemQuery__
 *
 * To run a query within a React component, call `useAdminGetMfStandardItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMfStandardItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMfStandardItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetMfStandardItemQuery(baseOptions: Apollo.QueryHookOptions<AdminGetMfStandardItemQuery_, AdminGetMfStandardItemQueryVariables_> & ({ variables: AdminGetMfStandardItemQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMfStandardItemQuery_, AdminGetMfStandardItemQueryVariables_>(AdminGetMfStandardItemDocument_, options);
      }
export function useAdminGetMfStandardItemLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMfStandardItemQuery_, AdminGetMfStandardItemQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMfStandardItemQuery_, AdminGetMfStandardItemQueryVariables_>(AdminGetMfStandardItemDocument_, options);
        }
export function useAdminGetMfStandardItemSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMfStandardItemQuery_, AdminGetMfStandardItemQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMfStandardItemQuery_, AdminGetMfStandardItemQueryVariables_>(AdminGetMfStandardItemDocument_, options);
        }
export type AdminGetMfStandardItemQueryHookResult = ReturnType<typeof useAdminGetMfStandardItemQuery>;
export type AdminGetMfStandardItemLazyQuery_HookResult = ReturnType<typeof useAdminGetMfStandardItemLazyQuery_>;
export type AdminGetMfStandardItemSuspenseQuery_HookResult = ReturnType<typeof useAdminGetMfStandardItemSuspenseQuery_>;
export type AdminGetMfStandardItemQueryResult_ = Apollo.QueryResult<AdminGetMfStandardItemQuery_, AdminGetMfStandardItemQueryVariables_>;
export function refetchAdminGetMfStandardItemQuery_(variables: AdminGetMfStandardItemQueryVariables_) {
      return { query: AdminGetMfStandardItemDocument_, variables: variables }
    }
export const AdminDeleteMfStandardItemDocument_ = gql`
    mutation AdminDeleteMFStandardItem($id: uuid!) {
  delete_MFStandardItem_by_pk(id: $id) {
    id
  }
}
    `;
export type AdminDeleteMfStandardItemMutationFn_ = Apollo.MutationFunction<AdminDeleteMfStandardItemMutation_, AdminDeleteMfStandardItemMutationVariables_>;

/**
 * __useAdminDeleteMfStandardItemMutation__
 *
 * To run a mutation, you first call `useAdminDeleteMfStandardItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteMfStandardItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteMfStandardItemMutation, { data, loading, error }] = useAdminDeleteMfStandardItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteMfStandardItemMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteMfStandardItemMutation_, AdminDeleteMfStandardItemMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteMfStandardItemMutation_, AdminDeleteMfStandardItemMutationVariables_>(AdminDeleteMfStandardItemDocument_, options);
      }
export type AdminDeleteMfStandardItemMutationHookResult = ReturnType<typeof useAdminDeleteMfStandardItemMutation>;
export type AdminDeleteMfStandardItemMutationResult_ = Apollo.MutationResult<AdminDeleteMfStandardItemMutation_>;
export type AdminDeleteMfStandardItemMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteMfStandardItemMutation_, AdminDeleteMfStandardItemMutationVariables_>;
export const AdminDeleteMfStandardItemByRefsDocument_ = gql`
    mutation AdminDeleteMFStandardItemByRefs($mfStandardRef: String!, $standardRef: String!) {
  delete_MFStandardItem(
    where: {mfStandardRef: {_eq: $mfStandardRef}, standardRef: {_eq: $standardRef}}
  ) {
    returning {
      id
      standardRef
      mfStandardRef
    }
  }
}
    `;
export type AdminDeleteMfStandardItemByRefsMutationFn_ = Apollo.MutationFunction<AdminDeleteMfStandardItemByRefsMutation_, AdminDeleteMfStandardItemByRefsMutationVariables_>;

/**
 * __useAdminDeleteMfStandardItemByRefsMutation__
 *
 * To run a mutation, you first call `useAdminDeleteMfStandardItemByRefsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteMfStandardItemByRefsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteMfStandardItemByRefsMutation, { data, loading, error }] = useAdminDeleteMfStandardItemByRefsMutation({
 *   variables: {
 *      mfStandardRef: // value for 'mfStandardRef'
 *      standardRef: // value for 'standardRef'
 *   },
 * });
 */
export function useAdminDeleteMfStandardItemByRefsMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteMfStandardItemByRefsMutation_, AdminDeleteMfStandardItemByRefsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteMfStandardItemByRefsMutation_, AdminDeleteMfStandardItemByRefsMutationVariables_>(AdminDeleteMfStandardItemByRefsDocument_, options);
      }
export type AdminDeleteMfStandardItemByRefsMutationHookResult = ReturnType<typeof useAdminDeleteMfStandardItemByRefsMutation>;
export type AdminDeleteMfStandardItemByRefsMutationResult_ = Apollo.MutationResult<AdminDeleteMfStandardItemByRefsMutation_>;
export type AdminDeleteMfStandardItemByRefsMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteMfStandardItemByRefsMutation_, AdminDeleteMfStandardItemByRefsMutationVariables_>;
export const AdminUpdateMfStandardItemDocument_ = gql`
    mutation AdminUpdateMFStandardItem($pk_columns: MFStandardItem_pk_columns_input!, $_set: MFStandardItem_set_input!) {
  update_MFStandardItem_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    standardRef
    mfStandardRef
    order
  }
}
    `;
export type AdminUpdateMfStandardItemMutationFn_ = Apollo.MutationFunction<AdminUpdateMfStandardItemMutation_, AdminUpdateMfStandardItemMutationVariables_>;

/**
 * __useAdminUpdateMfStandardItemMutation__
 *
 * To run a mutation, you first call `useAdminUpdateMfStandardItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateMfStandardItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateMfStandardItemMutation, { data, loading, error }] = useAdminUpdateMfStandardItemMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateMfStandardItemMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateMfStandardItemMutation_, AdminUpdateMfStandardItemMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateMfStandardItemMutation_, AdminUpdateMfStandardItemMutationVariables_>(AdminUpdateMfStandardItemDocument_, options);
      }
export type AdminUpdateMfStandardItemMutationHookResult = ReturnType<typeof useAdminUpdateMfStandardItemMutation>;
export type AdminUpdateMfStandardItemMutationResult_ = Apollo.MutationResult<AdminUpdateMfStandardItemMutation_>;
export type AdminUpdateMfStandardItemMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateMfStandardItemMutation_, AdminUpdateMfStandardItemMutationVariables_>;
export const AdminCreateMfStandardItemDocument_ = gql`
    mutation AdminCreateMFStandardItem($object: MFStandardItem_insert_input!) {
  insert_MFStandardItem_one(object: $object) {
    id
    standardRef
    mfStandardRef
    order
  }
}
    `;
export type AdminCreateMfStandardItemMutationFn_ = Apollo.MutationFunction<AdminCreateMfStandardItemMutation_, AdminCreateMfStandardItemMutationVariables_>;

/**
 * __useAdminCreateMfStandardItemMutation__
 *
 * To run a mutation, you first call `useAdminCreateMfStandardItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMfStandardItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMfStandardItemMutation, { data, loading, error }] = useAdminCreateMfStandardItemMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateMfStandardItemMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMfStandardItemMutation_, AdminCreateMfStandardItemMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMfStandardItemMutation_, AdminCreateMfStandardItemMutationVariables_>(AdminCreateMfStandardItemDocument_, options);
      }
export type AdminCreateMfStandardItemMutationHookResult = ReturnType<typeof useAdminCreateMfStandardItemMutation>;
export type AdminCreateMfStandardItemMutationResult_ = Apollo.MutationResult<AdminCreateMfStandardItemMutation_>;
export type AdminCreateMfStandardItemMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateMfStandardItemMutation_, AdminCreateMfStandardItemMutationVariables_>;
export const AdminCreateMfStandardItemsDocument_ = gql`
    mutation AdminCreateMFStandardItems($objects: [MFStandardItem_insert_input!]!) {
  insert_MFStandardItem(objects: $objects) {
    returning {
      id
      standardRef
      mfStandardRef
      order
    }
  }
}
    `;
export type AdminCreateMfStandardItemsMutationFn_ = Apollo.MutationFunction<AdminCreateMfStandardItemsMutation_, AdminCreateMfStandardItemsMutationVariables_>;

/**
 * __useAdminCreateMfStandardItemsMutation__
 *
 * To run a mutation, you first call `useAdminCreateMfStandardItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMfStandardItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMfStandardItemsMutation, { data, loading, error }] = useAdminCreateMfStandardItemsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateMfStandardItemsMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMfStandardItemsMutation_, AdminCreateMfStandardItemsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMfStandardItemsMutation_, AdminCreateMfStandardItemsMutationVariables_>(AdminCreateMfStandardItemsDocument_, options);
      }
export type AdminCreateMfStandardItemsMutationHookResult = ReturnType<typeof useAdminCreateMfStandardItemsMutation>;
export type AdminCreateMfStandardItemsMutationResult_ = Apollo.MutationResult<AdminCreateMfStandardItemsMutation_>;
export type AdminCreateMfStandardItemsMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateMfStandardItemsMutation_, AdminCreateMfStandardItemsMutationVariables_>;
export const AdminGetMfDisclosureRequirementGroupsDocument_ = gql`
    query AdminGetMFDisclosureRequirementGroups($limit: Int, $offset: Int, $order_by: [MFDisclosureRequirementGroup_order_by!], $where: MFDisclosureRequirementGroup_bool_exp) {
  MFDisclosureRequirementGroup(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    title
    reference
    order
    mfStandardRef
  }
  MFDisclosureRequirementGroup_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetMfDisclosureRequirementGroupsQuery__
 *
 * To run a query within a React component, call `useAdminGetMfDisclosureRequirementGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMfDisclosureRequirementGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMfDisclosureRequirementGroupsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetMfDisclosureRequirementGroupsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetMfDisclosureRequirementGroupsQuery_, AdminGetMfDisclosureRequirementGroupsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMfDisclosureRequirementGroupsQuery_, AdminGetMfDisclosureRequirementGroupsQueryVariables_>(AdminGetMfDisclosureRequirementGroupsDocument_, options);
      }
export function useAdminGetMfDisclosureRequirementGroupsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMfDisclosureRequirementGroupsQuery_, AdminGetMfDisclosureRequirementGroupsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMfDisclosureRequirementGroupsQuery_, AdminGetMfDisclosureRequirementGroupsQueryVariables_>(AdminGetMfDisclosureRequirementGroupsDocument_, options);
        }
export function useAdminGetMfDisclosureRequirementGroupsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMfDisclosureRequirementGroupsQuery_, AdminGetMfDisclosureRequirementGroupsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMfDisclosureRequirementGroupsQuery_, AdminGetMfDisclosureRequirementGroupsQueryVariables_>(AdminGetMfDisclosureRequirementGroupsDocument_, options);
        }
export type AdminGetMfDisclosureRequirementGroupsQueryHookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementGroupsQuery>;
export type AdminGetMfDisclosureRequirementGroupsLazyQuery_HookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementGroupsLazyQuery_>;
export type AdminGetMfDisclosureRequirementGroupsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementGroupsSuspenseQuery_>;
export type AdminGetMfDisclosureRequirementGroupsQueryResult_ = Apollo.QueryResult<AdminGetMfDisclosureRequirementGroupsQuery_, AdminGetMfDisclosureRequirementGroupsQueryVariables_>;
export function refetchAdminGetMfDisclosureRequirementGroupsQuery_(variables?: AdminGetMfDisclosureRequirementGroupsQueryVariables_) {
      return { query: AdminGetMfDisclosureRequirementGroupsDocument_, variables: variables }
    }
export const AdminGetMfDisclosureRequirementGroupDocument_ = gql`
    query AdminGetMFDisclosureRequirementGroup($reference: String!) {
  MFDisclosureRequirementGroup_by_pk(reference: $reference) {
    title
    reference
    order
    mfStandardRef
  }
}
    `;

/**
 * __useAdminGetMfDisclosureRequirementGroupQuery__
 *
 * To run a query within a React component, call `useAdminGetMfDisclosureRequirementGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMfDisclosureRequirementGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMfDisclosureRequirementGroupQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetMfDisclosureRequirementGroupQuery(baseOptions: Apollo.QueryHookOptions<AdminGetMfDisclosureRequirementGroupQuery_, AdminGetMfDisclosureRequirementGroupQueryVariables_> & ({ variables: AdminGetMfDisclosureRequirementGroupQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMfDisclosureRequirementGroupQuery_, AdminGetMfDisclosureRequirementGroupQueryVariables_>(AdminGetMfDisclosureRequirementGroupDocument_, options);
      }
export function useAdminGetMfDisclosureRequirementGroupLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMfDisclosureRequirementGroupQuery_, AdminGetMfDisclosureRequirementGroupQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMfDisclosureRequirementGroupQuery_, AdminGetMfDisclosureRequirementGroupQueryVariables_>(AdminGetMfDisclosureRequirementGroupDocument_, options);
        }
export function useAdminGetMfDisclosureRequirementGroupSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMfDisclosureRequirementGroupQuery_, AdminGetMfDisclosureRequirementGroupQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMfDisclosureRequirementGroupQuery_, AdminGetMfDisclosureRequirementGroupQueryVariables_>(AdminGetMfDisclosureRequirementGroupDocument_, options);
        }
export type AdminGetMfDisclosureRequirementGroupQueryHookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementGroupQuery>;
export type AdminGetMfDisclosureRequirementGroupLazyQuery_HookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementGroupLazyQuery_>;
export type AdminGetMfDisclosureRequirementGroupSuspenseQuery_HookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementGroupSuspenseQuery_>;
export type AdminGetMfDisclosureRequirementGroupQueryResult_ = Apollo.QueryResult<AdminGetMfDisclosureRequirementGroupQuery_, AdminGetMfDisclosureRequirementGroupQueryVariables_>;
export function refetchAdminGetMfDisclosureRequirementGroupQuery_(variables: AdminGetMfDisclosureRequirementGroupQueryVariables_) {
      return { query: AdminGetMfDisclosureRequirementGroupDocument_, variables: variables }
    }
export const AdminDeleteMfDisclosureRequirementGroupDocument_ = gql`
    mutation AdminDeleteMFDisclosureRequirementGroup($reference: String!) {
  delete_MFDisclosureRequirementGroup_by_pk(reference: $reference) {
    reference
  }
}
    `;
export type AdminDeleteMfDisclosureRequirementGroupMutationFn_ = Apollo.MutationFunction<AdminDeleteMfDisclosureRequirementGroupMutation_, AdminDeleteMfDisclosureRequirementGroupMutationVariables_>;

/**
 * __useAdminDeleteMfDisclosureRequirementGroupMutation__
 *
 * To run a mutation, you first call `useAdminDeleteMfDisclosureRequirementGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteMfDisclosureRequirementGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteMfDisclosureRequirementGroupMutation, { data, loading, error }] = useAdminDeleteMfDisclosureRequirementGroupMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteMfDisclosureRequirementGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteMfDisclosureRequirementGroupMutation_, AdminDeleteMfDisclosureRequirementGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteMfDisclosureRequirementGroupMutation_, AdminDeleteMfDisclosureRequirementGroupMutationVariables_>(AdminDeleteMfDisclosureRequirementGroupDocument_, options);
      }
export type AdminDeleteMfDisclosureRequirementGroupMutationHookResult = ReturnType<typeof useAdminDeleteMfDisclosureRequirementGroupMutation>;
export type AdminDeleteMfDisclosureRequirementGroupMutationResult_ = Apollo.MutationResult<AdminDeleteMfDisclosureRequirementGroupMutation_>;
export type AdminDeleteMfDisclosureRequirementGroupMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteMfDisclosureRequirementGroupMutation_, AdminDeleteMfDisclosureRequirementGroupMutationVariables_>;
export const AdminUpdateMfDisclosureRequirementGroupDocument_ = gql`
    mutation AdminUpdateMFDisclosureRequirementGroup($pk_columns: MFDisclosureRequirementGroup_pk_columns_input!, $_set: MFDisclosureRequirementGroup_set_input!) {
  update_MFDisclosureRequirementGroup_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
    order
    mfStandardRef
  }
}
    `;
export type AdminUpdateMfDisclosureRequirementGroupMutationFn_ = Apollo.MutationFunction<AdminUpdateMfDisclosureRequirementGroupMutation_, AdminUpdateMfDisclosureRequirementGroupMutationVariables_>;

/**
 * __useAdminUpdateMfDisclosureRequirementGroupMutation__
 *
 * To run a mutation, you first call `useAdminUpdateMfDisclosureRequirementGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateMfDisclosureRequirementGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateMfDisclosureRequirementGroupMutation, { data, loading, error }] = useAdminUpdateMfDisclosureRequirementGroupMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateMfDisclosureRequirementGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateMfDisclosureRequirementGroupMutation_, AdminUpdateMfDisclosureRequirementGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateMfDisclosureRequirementGroupMutation_, AdminUpdateMfDisclosureRequirementGroupMutationVariables_>(AdminUpdateMfDisclosureRequirementGroupDocument_, options);
      }
export type AdminUpdateMfDisclosureRequirementGroupMutationHookResult = ReturnType<typeof useAdminUpdateMfDisclosureRequirementGroupMutation>;
export type AdminUpdateMfDisclosureRequirementGroupMutationResult_ = Apollo.MutationResult<AdminUpdateMfDisclosureRequirementGroupMutation_>;
export type AdminUpdateMfDisclosureRequirementGroupMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateMfDisclosureRequirementGroupMutation_, AdminUpdateMfDisclosureRequirementGroupMutationVariables_>;
export const AdminCreateMfDisclosureRequirementGroupDocument_ = gql`
    mutation AdminCreateMFDisclosureRequirementGroup($object: MFDisclosureRequirementGroup_insert_input!) {
  insert_MFDisclosureRequirementGroup_one(object: $object) {
    title
    reference
    order
    mfStandardRef
  }
}
    `;
export type AdminCreateMfDisclosureRequirementGroupMutationFn_ = Apollo.MutationFunction<AdminCreateMfDisclosureRequirementGroupMutation_, AdminCreateMfDisclosureRequirementGroupMutationVariables_>;

/**
 * __useAdminCreateMfDisclosureRequirementGroupMutation__
 *
 * To run a mutation, you first call `useAdminCreateMfDisclosureRequirementGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMfDisclosureRequirementGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMfDisclosureRequirementGroupMutation, { data, loading, error }] = useAdminCreateMfDisclosureRequirementGroupMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateMfDisclosureRequirementGroupMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMfDisclosureRequirementGroupMutation_, AdminCreateMfDisclosureRequirementGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMfDisclosureRequirementGroupMutation_, AdminCreateMfDisclosureRequirementGroupMutationVariables_>(AdminCreateMfDisclosureRequirementGroupDocument_, options);
      }
export type AdminCreateMfDisclosureRequirementGroupMutationHookResult = ReturnType<typeof useAdminCreateMfDisclosureRequirementGroupMutation>;
export type AdminCreateMfDisclosureRequirementGroupMutationResult_ = Apollo.MutationResult<AdminCreateMfDisclosureRequirementGroupMutation_>;
export type AdminCreateMfDisclosureRequirementGroupMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateMfDisclosureRequirementGroupMutation_, AdminCreateMfDisclosureRequirementGroupMutationVariables_>;
export const AdminGetMfDisclosureRequirementsDocument_ = gql`
    query AdminGetMFDisclosureRequirements($limit: Int, $offset: Int, $order_by: [MFDisclosureRequirement_order_by!], $where: MFDisclosureRequirement_bool_exp) {
  MFDisclosureRequirement(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    title
    reference
    order
    mfDisclosureRequirementGroupRef
    type
    description
  }
  MFDisclosureRequirement_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetMfDisclosureRequirementsQuery__
 *
 * To run a query within a React component, call `useAdminGetMfDisclosureRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMfDisclosureRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMfDisclosureRequirementsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetMfDisclosureRequirementsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetMfDisclosureRequirementsQuery_, AdminGetMfDisclosureRequirementsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMfDisclosureRequirementsQuery_, AdminGetMfDisclosureRequirementsQueryVariables_>(AdminGetMfDisclosureRequirementsDocument_, options);
      }
export function useAdminGetMfDisclosureRequirementsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMfDisclosureRequirementsQuery_, AdminGetMfDisclosureRequirementsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMfDisclosureRequirementsQuery_, AdminGetMfDisclosureRequirementsQueryVariables_>(AdminGetMfDisclosureRequirementsDocument_, options);
        }
export function useAdminGetMfDisclosureRequirementsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMfDisclosureRequirementsQuery_, AdminGetMfDisclosureRequirementsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMfDisclosureRequirementsQuery_, AdminGetMfDisclosureRequirementsQueryVariables_>(AdminGetMfDisclosureRequirementsDocument_, options);
        }
export type AdminGetMfDisclosureRequirementsQueryHookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementsQuery>;
export type AdminGetMfDisclosureRequirementsLazyQuery_HookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementsLazyQuery_>;
export type AdminGetMfDisclosureRequirementsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementsSuspenseQuery_>;
export type AdminGetMfDisclosureRequirementsQueryResult_ = Apollo.QueryResult<AdminGetMfDisclosureRequirementsQuery_, AdminGetMfDisclosureRequirementsQueryVariables_>;
export function refetchAdminGetMfDisclosureRequirementsQuery_(variables?: AdminGetMfDisclosureRequirementsQueryVariables_) {
      return { query: AdminGetMfDisclosureRequirementsDocument_, variables: variables }
    }
export const AdminGetMfDisclosureRequirementDocument_ = gql`
    query AdminGetMFDisclosureRequirement($reference: String!) {
  MFDisclosureRequirement_by_pk(reference: $reference) {
    title
    reference
    order
    mfDisclosureRequirementGroupRef
    type
    description
  }
}
    `;

/**
 * __useAdminGetMfDisclosureRequirementQuery__
 *
 * To run a query within a React component, call `useAdminGetMfDisclosureRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMfDisclosureRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMfDisclosureRequirementQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminGetMfDisclosureRequirementQuery(baseOptions: Apollo.QueryHookOptions<AdminGetMfDisclosureRequirementQuery_, AdminGetMfDisclosureRequirementQueryVariables_> & ({ variables: AdminGetMfDisclosureRequirementQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMfDisclosureRequirementQuery_, AdminGetMfDisclosureRequirementQueryVariables_>(AdminGetMfDisclosureRequirementDocument_, options);
      }
export function useAdminGetMfDisclosureRequirementLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMfDisclosureRequirementQuery_, AdminGetMfDisclosureRequirementQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMfDisclosureRequirementQuery_, AdminGetMfDisclosureRequirementQueryVariables_>(AdminGetMfDisclosureRequirementDocument_, options);
        }
export function useAdminGetMfDisclosureRequirementSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMfDisclosureRequirementQuery_, AdminGetMfDisclosureRequirementQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMfDisclosureRequirementQuery_, AdminGetMfDisclosureRequirementQueryVariables_>(AdminGetMfDisclosureRequirementDocument_, options);
        }
export type AdminGetMfDisclosureRequirementQueryHookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementQuery>;
export type AdminGetMfDisclosureRequirementLazyQuery_HookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementLazyQuery_>;
export type AdminGetMfDisclosureRequirementSuspenseQuery_HookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementSuspenseQuery_>;
export type AdminGetMfDisclosureRequirementQueryResult_ = Apollo.QueryResult<AdminGetMfDisclosureRequirementQuery_, AdminGetMfDisclosureRequirementQueryVariables_>;
export function refetchAdminGetMfDisclosureRequirementQuery_(variables: AdminGetMfDisclosureRequirementQueryVariables_) {
      return { query: AdminGetMfDisclosureRequirementDocument_, variables: variables }
    }
export const AdminDeleteMfDisclosureRequirementDocument_ = gql`
    mutation AdminDeleteMFDisclosureRequirement($reference: String!) {
  delete_MFDisclosureRequirement_by_pk(reference: $reference) {
    reference
  }
}
    `;
export type AdminDeleteMfDisclosureRequirementMutationFn_ = Apollo.MutationFunction<AdminDeleteMfDisclosureRequirementMutation_, AdminDeleteMfDisclosureRequirementMutationVariables_>;

/**
 * __useAdminDeleteMfDisclosureRequirementMutation__
 *
 * To run a mutation, you first call `useAdminDeleteMfDisclosureRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteMfDisclosureRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteMfDisclosureRequirementMutation, { data, loading, error }] = useAdminDeleteMfDisclosureRequirementMutation({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useAdminDeleteMfDisclosureRequirementMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteMfDisclosureRequirementMutation_, AdminDeleteMfDisclosureRequirementMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteMfDisclosureRequirementMutation_, AdminDeleteMfDisclosureRequirementMutationVariables_>(AdminDeleteMfDisclosureRequirementDocument_, options);
      }
export type AdminDeleteMfDisclosureRequirementMutationHookResult = ReturnType<typeof useAdminDeleteMfDisclosureRequirementMutation>;
export type AdminDeleteMfDisclosureRequirementMutationResult_ = Apollo.MutationResult<AdminDeleteMfDisclosureRequirementMutation_>;
export type AdminDeleteMfDisclosureRequirementMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteMfDisclosureRequirementMutation_, AdminDeleteMfDisclosureRequirementMutationVariables_>;
export const AdminUpdateMfDisclosureRequirementDocument_ = gql`
    mutation AdminUpdateMFDisclosureRequirement($pk_columns: MFDisclosureRequirement_pk_columns_input!, $_set: MFDisclosureRequirement_set_input!) {
  update_MFDisclosureRequirement_by_pk(pk_columns: $pk_columns, _set: $_set) {
    title
    reference
    order
    mfDisclosureRequirementGroupRef
    type
    description
  }
}
    `;
export type AdminUpdateMfDisclosureRequirementMutationFn_ = Apollo.MutationFunction<AdminUpdateMfDisclosureRequirementMutation_, AdminUpdateMfDisclosureRequirementMutationVariables_>;

/**
 * __useAdminUpdateMfDisclosureRequirementMutation__
 *
 * To run a mutation, you first call `useAdminUpdateMfDisclosureRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateMfDisclosureRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateMfDisclosureRequirementMutation, { data, loading, error }] = useAdminUpdateMfDisclosureRequirementMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateMfDisclosureRequirementMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateMfDisclosureRequirementMutation_, AdminUpdateMfDisclosureRequirementMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateMfDisclosureRequirementMutation_, AdminUpdateMfDisclosureRequirementMutationVariables_>(AdminUpdateMfDisclosureRequirementDocument_, options);
      }
export type AdminUpdateMfDisclosureRequirementMutationHookResult = ReturnType<typeof useAdminUpdateMfDisclosureRequirementMutation>;
export type AdminUpdateMfDisclosureRequirementMutationResult_ = Apollo.MutationResult<AdminUpdateMfDisclosureRequirementMutation_>;
export type AdminUpdateMfDisclosureRequirementMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateMfDisclosureRequirementMutation_, AdminUpdateMfDisclosureRequirementMutationVariables_>;
export const AdminCreateMfDisclosureRequirementDocument_ = gql`
    mutation AdminCreateMFDisclosureRequirement($object: MFDisclosureRequirement_insert_input!) {
  insert_MFDisclosureRequirement_one(object: $object) {
    title
    reference
    order
    mfDisclosureRequirementGroupRef
    type
    description
  }
}
    `;
export type AdminCreateMfDisclosureRequirementMutationFn_ = Apollo.MutationFunction<AdminCreateMfDisclosureRequirementMutation_, AdminCreateMfDisclosureRequirementMutationVariables_>;

/**
 * __useAdminCreateMfDisclosureRequirementMutation__
 *
 * To run a mutation, you first call `useAdminCreateMfDisclosureRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMfDisclosureRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMfDisclosureRequirementMutation, { data, loading, error }] = useAdminCreateMfDisclosureRequirementMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateMfDisclosureRequirementMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMfDisclosureRequirementMutation_, AdminCreateMfDisclosureRequirementMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMfDisclosureRequirementMutation_, AdminCreateMfDisclosureRequirementMutationVariables_>(AdminCreateMfDisclosureRequirementDocument_, options);
      }
export type AdminCreateMfDisclosureRequirementMutationHookResult = ReturnType<typeof useAdminCreateMfDisclosureRequirementMutation>;
export type AdminCreateMfDisclosureRequirementMutationResult_ = Apollo.MutationResult<AdminCreateMfDisclosureRequirementMutation_>;
export type AdminCreateMfDisclosureRequirementMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateMfDisclosureRequirementMutation_, AdminCreateMfDisclosureRequirementMutationVariables_>;
export const AdminGetMfDisclosureRequirementItemsDocument_ = gql`
    query AdminGetMFDisclosureRequirementItems($limit: Int, $offset: Int, $order_by: [MFDisclosureRequirementItem_order_by!], $where: MFDisclosureRequirementItem_bool_exp) {
  MFDisclosureRequirementItem(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    mfDisclosureRequirementRef
    metricRef
    order
    metric {
      disclosureRequirementRef
    }
  }
  MFDisclosureRequirementItem_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetMfDisclosureRequirementItemsQuery__
 *
 * To run a query within a React component, call `useAdminGetMfDisclosureRequirementItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMfDisclosureRequirementItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMfDisclosureRequirementItemsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetMfDisclosureRequirementItemsQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetMfDisclosureRequirementItemsQuery_, AdminGetMfDisclosureRequirementItemsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMfDisclosureRequirementItemsQuery_, AdminGetMfDisclosureRequirementItemsQueryVariables_>(AdminGetMfDisclosureRequirementItemsDocument_, options);
      }
export function useAdminGetMfDisclosureRequirementItemsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMfDisclosureRequirementItemsQuery_, AdminGetMfDisclosureRequirementItemsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMfDisclosureRequirementItemsQuery_, AdminGetMfDisclosureRequirementItemsQueryVariables_>(AdminGetMfDisclosureRequirementItemsDocument_, options);
        }
export function useAdminGetMfDisclosureRequirementItemsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMfDisclosureRequirementItemsQuery_, AdminGetMfDisclosureRequirementItemsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMfDisclosureRequirementItemsQuery_, AdminGetMfDisclosureRequirementItemsQueryVariables_>(AdminGetMfDisclosureRequirementItemsDocument_, options);
        }
export type AdminGetMfDisclosureRequirementItemsQueryHookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementItemsQuery>;
export type AdminGetMfDisclosureRequirementItemsLazyQuery_HookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementItemsLazyQuery_>;
export type AdminGetMfDisclosureRequirementItemsSuspenseQuery_HookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementItemsSuspenseQuery_>;
export type AdminGetMfDisclosureRequirementItemsQueryResult_ = Apollo.QueryResult<AdminGetMfDisclosureRequirementItemsQuery_, AdminGetMfDisclosureRequirementItemsQueryVariables_>;
export function refetchAdminGetMfDisclosureRequirementItemsQuery_(variables?: AdminGetMfDisclosureRequirementItemsQueryVariables_) {
      return { query: AdminGetMfDisclosureRequirementItemsDocument_, variables: variables }
    }
export const AdminGetMfDisclosureRequirementItemDocument_ = gql`
    query AdminGetMFDisclosureRequirementItem($id: uuid!) {
  MFDisclosureRequirementItem_by_pk(id: $id) {
    id
    mfDisclosureRequirementRef
    metricRef
    order
  }
}
    `;

/**
 * __useAdminGetMfDisclosureRequirementItemQuery__
 *
 * To run a query within a React component, call `useAdminGetMfDisclosureRequirementItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetMfDisclosureRequirementItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetMfDisclosureRequirementItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminGetMfDisclosureRequirementItemQuery(baseOptions: Apollo.QueryHookOptions<AdminGetMfDisclosureRequirementItemQuery_, AdminGetMfDisclosureRequirementItemQueryVariables_> & ({ variables: AdminGetMfDisclosureRequirementItemQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetMfDisclosureRequirementItemQuery_, AdminGetMfDisclosureRequirementItemQueryVariables_>(AdminGetMfDisclosureRequirementItemDocument_, options);
      }
export function useAdminGetMfDisclosureRequirementItemLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetMfDisclosureRequirementItemQuery_, AdminGetMfDisclosureRequirementItemQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetMfDisclosureRequirementItemQuery_, AdminGetMfDisclosureRequirementItemQueryVariables_>(AdminGetMfDisclosureRequirementItemDocument_, options);
        }
export function useAdminGetMfDisclosureRequirementItemSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetMfDisclosureRequirementItemQuery_, AdminGetMfDisclosureRequirementItemQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetMfDisclosureRequirementItemQuery_, AdminGetMfDisclosureRequirementItemQueryVariables_>(AdminGetMfDisclosureRequirementItemDocument_, options);
        }
export type AdminGetMfDisclosureRequirementItemQueryHookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementItemQuery>;
export type AdminGetMfDisclosureRequirementItemLazyQuery_HookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementItemLazyQuery_>;
export type AdminGetMfDisclosureRequirementItemSuspenseQuery_HookResult = ReturnType<typeof useAdminGetMfDisclosureRequirementItemSuspenseQuery_>;
export type AdminGetMfDisclosureRequirementItemQueryResult_ = Apollo.QueryResult<AdminGetMfDisclosureRequirementItemQuery_, AdminGetMfDisclosureRequirementItemQueryVariables_>;
export function refetchAdminGetMfDisclosureRequirementItemQuery_(variables: AdminGetMfDisclosureRequirementItemQueryVariables_) {
      return { query: AdminGetMfDisclosureRequirementItemDocument_, variables: variables }
    }
export const AdminDeleteMfDisclosureRequirementItemDocument_ = gql`
    mutation AdminDeleteMFDisclosureRequirementItem($id: uuid!) {
  delete_MFDisclosureRequirementItem_by_pk(id: $id) {
    id
  }
}
    `;
export type AdminDeleteMfDisclosureRequirementItemMutationFn_ = Apollo.MutationFunction<AdminDeleteMfDisclosureRequirementItemMutation_, AdminDeleteMfDisclosureRequirementItemMutationVariables_>;

/**
 * __useAdminDeleteMfDisclosureRequirementItemMutation__
 *
 * To run a mutation, you first call `useAdminDeleteMfDisclosureRequirementItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteMfDisclosureRequirementItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteMfDisclosureRequirementItemMutation, { data, loading, error }] = useAdminDeleteMfDisclosureRequirementItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminDeleteMfDisclosureRequirementItemMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteMfDisclosureRequirementItemMutation_, AdminDeleteMfDisclosureRequirementItemMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteMfDisclosureRequirementItemMutation_, AdminDeleteMfDisclosureRequirementItemMutationVariables_>(AdminDeleteMfDisclosureRequirementItemDocument_, options);
      }
export type AdminDeleteMfDisclosureRequirementItemMutationHookResult = ReturnType<typeof useAdminDeleteMfDisclosureRequirementItemMutation>;
export type AdminDeleteMfDisclosureRequirementItemMutationResult_ = Apollo.MutationResult<AdminDeleteMfDisclosureRequirementItemMutation_>;
export type AdminDeleteMfDisclosureRequirementItemMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteMfDisclosureRequirementItemMutation_, AdminDeleteMfDisclosureRequirementItemMutationVariables_>;
export const AdminDeleteMfDisclosureRequirementItemByRefsDocument_ = gql`
    mutation AdminDeleteMFDisclosureRequirementItemByRefs($mfDisclosureRequirementRef: String!, $metricRef: String!) {
  delete_MFDisclosureRequirementItem(
    where: {mfDisclosureRequirementRef: {_eq: $mfDisclosureRequirementRef}, metricRef: {_eq: $metricRef}}
  ) {
    returning {
      id
      mfDisclosureRequirementRef
      metricRef
    }
  }
}
    `;
export type AdminDeleteMfDisclosureRequirementItemByRefsMutationFn_ = Apollo.MutationFunction<AdminDeleteMfDisclosureRequirementItemByRefsMutation_, AdminDeleteMfDisclosureRequirementItemByRefsMutationVariables_>;

/**
 * __useAdminDeleteMfDisclosureRequirementItemByRefsMutation__
 *
 * To run a mutation, you first call `useAdminDeleteMfDisclosureRequirementItemByRefsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteMfDisclosureRequirementItemByRefsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteMfDisclosureRequirementItemByRefsMutation, { data, loading, error }] = useAdminDeleteMfDisclosureRequirementItemByRefsMutation({
 *   variables: {
 *      mfDisclosureRequirementRef: // value for 'mfDisclosureRequirementRef'
 *      metricRef: // value for 'metricRef'
 *   },
 * });
 */
export function useAdminDeleteMfDisclosureRequirementItemByRefsMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteMfDisclosureRequirementItemByRefsMutation_, AdminDeleteMfDisclosureRequirementItemByRefsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteMfDisclosureRequirementItemByRefsMutation_, AdminDeleteMfDisclosureRequirementItemByRefsMutationVariables_>(AdminDeleteMfDisclosureRequirementItemByRefsDocument_, options);
      }
export type AdminDeleteMfDisclosureRequirementItemByRefsMutationHookResult = ReturnType<typeof useAdminDeleteMfDisclosureRequirementItemByRefsMutation>;
export type AdminDeleteMfDisclosureRequirementItemByRefsMutationResult_ = Apollo.MutationResult<AdminDeleteMfDisclosureRequirementItemByRefsMutation_>;
export type AdminDeleteMfDisclosureRequirementItemByRefsMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteMfDisclosureRequirementItemByRefsMutation_, AdminDeleteMfDisclosureRequirementItemByRefsMutationVariables_>;
export const AdminUpdateMfDisclosureRequirementItemDocument_ = gql`
    mutation AdminUpdateMFDisclosureRequirementItem($pk_columns: MFDisclosureRequirementItem_pk_columns_input!, $_set: MFDisclosureRequirementItem_set_input!) {
  update_MFDisclosureRequirementItem_by_pk(pk_columns: $pk_columns, _set: $_set) {
    id
    mfDisclosureRequirementRef
    metricRef
    order
  }
}
    `;
export type AdminUpdateMfDisclosureRequirementItemMutationFn_ = Apollo.MutationFunction<AdminUpdateMfDisclosureRequirementItemMutation_, AdminUpdateMfDisclosureRequirementItemMutationVariables_>;

/**
 * __useAdminUpdateMfDisclosureRequirementItemMutation__
 *
 * To run a mutation, you first call `useAdminUpdateMfDisclosureRequirementItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateMfDisclosureRequirementItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateMfDisclosureRequirementItemMutation, { data, loading, error }] = useAdminUpdateMfDisclosureRequirementItemMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useAdminUpdateMfDisclosureRequirementItemMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateMfDisclosureRequirementItemMutation_, AdminUpdateMfDisclosureRequirementItemMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminUpdateMfDisclosureRequirementItemMutation_, AdminUpdateMfDisclosureRequirementItemMutationVariables_>(AdminUpdateMfDisclosureRequirementItemDocument_, options);
      }
export type AdminUpdateMfDisclosureRequirementItemMutationHookResult = ReturnType<typeof useAdminUpdateMfDisclosureRequirementItemMutation>;
export type AdminUpdateMfDisclosureRequirementItemMutationResult_ = Apollo.MutationResult<AdminUpdateMfDisclosureRequirementItemMutation_>;
export type AdminUpdateMfDisclosureRequirementItemMutationOptions_ = Apollo.BaseMutationOptions<AdminUpdateMfDisclosureRequirementItemMutation_, AdminUpdateMfDisclosureRequirementItemMutationVariables_>;
export const AdminCreateMfDisclosureRequirementItemDocument_ = gql`
    mutation AdminCreateMFDisclosureRequirementItem($object: MFDisclosureRequirementItem_insert_input!) {
  insert_MFDisclosureRequirementItem_one(object: $object) {
    id
    mfDisclosureRequirementRef
    metricRef
    order
  }
}
    `;
export type AdminCreateMfDisclosureRequirementItemMutationFn_ = Apollo.MutationFunction<AdminCreateMfDisclosureRequirementItemMutation_, AdminCreateMfDisclosureRequirementItemMutationVariables_>;

/**
 * __useAdminCreateMfDisclosureRequirementItemMutation__
 *
 * To run a mutation, you first call `useAdminCreateMfDisclosureRequirementItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMfDisclosureRequirementItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMfDisclosureRequirementItemMutation, { data, loading, error }] = useAdminCreateMfDisclosureRequirementItemMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useAdminCreateMfDisclosureRequirementItemMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMfDisclosureRequirementItemMutation_, AdminCreateMfDisclosureRequirementItemMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMfDisclosureRequirementItemMutation_, AdminCreateMfDisclosureRequirementItemMutationVariables_>(AdminCreateMfDisclosureRequirementItemDocument_, options);
      }
export type AdminCreateMfDisclosureRequirementItemMutationHookResult = ReturnType<typeof useAdminCreateMfDisclosureRequirementItemMutation>;
export type AdminCreateMfDisclosureRequirementItemMutationResult_ = Apollo.MutationResult<AdminCreateMfDisclosureRequirementItemMutation_>;
export type AdminCreateMfDisclosureRequirementItemMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateMfDisclosureRequirementItemMutation_, AdminCreateMfDisclosureRequirementItemMutationVariables_>;
export const AdminCreateMfDisclosureRequirementItemsDocument_ = gql`
    mutation AdminCreateMFDisclosureRequirementItems($objects: [MFDisclosureRequirementItem_insert_input!]!) {
  insert_MFDisclosureRequirementItem(objects: $objects) {
    returning {
      id
      mfDisclosureRequirementRef
      metricRef
      order
    }
  }
}
    `;
export type AdminCreateMfDisclosureRequirementItemsMutationFn_ = Apollo.MutationFunction<AdminCreateMfDisclosureRequirementItemsMutation_, AdminCreateMfDisclosureRequirementItemsMutationVariables_>;

/**
 * __useAdminCreateMfDisclosureRequirementItemsMutation__
 *
 * To run a mutation, you first call `useAdminCreateMfDisclosureRequirementItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateMfDisclosureRequirementItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateMfDisclosureRequirementItemsMutation, { data, loading, error }] = useAdminCreateMfDisclosureRequirementItemsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminCreateMfDisclosureRequirementItemsMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateMfDisclosureRequirementItemsMutation_, AdminCreateMfDisclosureRequirementItemsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateMfDisclosureRequirementItemsMutation_, AdminCreateMfDisclosureRequirementItemsMutationVariables_>(AdminCreateMfDisclosureRequirementItemsDocument_, options);
      }
export type AdminCreateMfDisclosureRequirementItemsMutationHookResult = ReturnType<typeof useAdminCreateMfDisclosureRequirementItemsMutation>;
export type AdminCreateMfDisclosureRequirementItemsMutationResult_ = Apollo.MutationResult<AdminCreateMfDisclosureRequirementItemsMutation_>;
export type AdminCreateMfDisclosureRequirementItemsMutationOptions_ = Apollo.BaseMutationOptions<AdminCreateMfDisclosureRequirementItemsMutation_, AdminCreateMfDisclosureRequirementItemsMutationVariables_>;
export const AdminGetDrToMfDisclosureRequirementDocument_ = gql`
    query AdminGetDRToMFDisclosureRequirement($limit: Int, $offset: Int, $order_by: [DRToMFDisclosureRequirement_order_by!], $where: DRToMFDisclosureRequirement_bool_exp) {
  DRToMFDisclosureRequirement(
    limit: $limit
    offset: $offset
    order_by: $order_by
    where: $where
  ) {
    id
    disclosureRequirementRef
    mfDisclosureRequirementRef
  }
  DRToMFDisclosureRequirement_aggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useAdminGetDrToMfDisclosureRequirementQuery__
 *
 * To run a query within a React component, call `useAdminGetDrToMfDisclosureRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminGetDrToMfDisclosureRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminGetDrToMfDisclosureRequirementQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      order_by: // value for 'order_by'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useAdminGetDrToMfDisclosureRequirementQuery(baseOptions?: Apollo.QueryHookOptions<AdminGetDrToMfDisclosureRequirementQuery_, AdminGetDrToMfDisclosureRequirementQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminGetDrToMfDisclosureRequirementQuery_, AdminGetDrToMfDisclosureRequirementQueryVariables_>(AdminGetDrToMfDisclosureRequirementDocument_, options);
      }
export function useAdminGetDrToMfDisclosureRequirementLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AdminGetDrToMfDisclosureRequirementQuery_, AdminGetDrToMfDisclosureRequirementQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminGetDrToMfDisclosureRequirementQuery_, AdminGetDrToMfDisclosureRequirementQueryVariables_>(AdminGetDrToMfDisclosureRequirementDocument_, options);
        }
export function useAdminGetDrToMfDisclosureRequirementSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminGetDrToMfDisclosureRequirementQuery_, AdminGetDrToMfDisclosureRequirementQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminGetDrToMfDisclosureRequirementQuery_, AdminGetDrToMfDisclosureRequirementQueryVariables_>(AdminGetDrToMfDisclosureRequirementDocument_, options);
        }
export type AdminGetDrToMfDisclosureRequirementQueryHookResult = ReturnType<typeof useAdminGetDrToMfDisclosureRequirementQuery>;
export type AdminGetDrToMfDisclosureRequirementLazyQuery_HookResult = ReturnType<typeof useAdminGetDrToMfDisclosureRequirementLazyQuery_>;
export type AdminGetDrToMfDisclosureRequirementSuspenseQuery_HookResult = ReturnType<typeof useAdminGetDrToMfDisclosureRequirementSuspenseQuery_>;
export type AdminGetDrToMfDisclosureRequirementQueryResult_ = Apollo.QueryResult<AdminGetDrToMfDisclosureRequirementQuery_, AdminGetDrToMfDisclosureRequirementQueryVariables_>;
export function refetchAdminGetDrToMfDisclosureRequirementQuery_(variables?: AdminGetDrToMfDisclosureRequirementQueryVariables_) {
      return { query: AdminGetDrToMfDisclosureRequirementDocument_, variables: variables }
    }
export const AdminDeleteDrToMfDisclosureRequirementDocument_ = gql`
    mutation AdminDeleteDRToMFDisclosureRequirement($ids: [uuid!]!) {
  delete_DRToMFDisclosureRequirement(where: {id: {_in: $ids}}) {
    returning {
      id
    }
  }
}
    `;
export type AdminDeleteDrToMfDisclosureRequirementMutationFn_ = Apollo.MutationFunction<AdminDeleteDrToMfDisclosureRequirementMutation_, AdminDeleteDrToMfDisclosureRequirementMutationVariables_>;

/**
 * __useAdminDeleteDrToMfDisclosureRequirementMutation__
 *
 * To run a mutation, you first call `useAdminDeleteDrToMfDisclosureRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminDeleteDrToMfDisclosureRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminDeleteDrToMfDisclosureRequirementMutation, { data, loading, error }] = useAdminDeleteDrToMfDisclosureRequirementMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAdminDeleteDrToMfDisclosureRequirementMutation(baseOptions?: Apollo.MutationHookOptions<AdminDeleteDrToMfDisclosureRequirementMutation_, AdminDeleteDrToMfDisclosureRequirementMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminDeleteDrToMfDisclosureRequirementMutation_, AdminDeleteDrToMfDisclosureRequirementMutationVariables_>(AdminDeleteDrToMfDisclosureRequirementDocument_, options);
      }
export type AdminDeleteDrToMfDisclosureRequirementMutationHookResult = ReturnType<typeof useAdminDeleteDrToMfDisclosureRequirementMutation>;
export type AdminDeleteDrToMfDisclosureRequirementMutationResult_ = Apollo.MutationResult<AdminDeleteDrToMfDisclosureRequirementMutation_>;
export type AdminDeleteDrToMfDisclosureRequirementMutationOptions_ = Apollo.BaseMutationOptions<AdminDeleteDrToMfDisclosureRequirementMutation_, AdminDeleteDrToMfDisclosureRequirementMutationVariables_>;
export const AdminInsertDrtomfDisclosureRequirementDocument_ = gql`
    mutation AdminInsertDRTOMFDisclosureRequirement($objects: [DRToMFDisclosureRequirement_insert_input!]!) {
  insert_DRToMFDisclosureRequirement(objects: $objects) {
    returning {
      id
    }
  }
}
    `;
export type AdminInsertDrtomfDisclosureRequirementMutationFn_ = Apollo.MutationFunction<AdminInsertDrtomfDisclosureRequirementMutation_, AdminInsertDrtomfDisclosureRequirementMutationVariables_>;

/**
 * __useAdminInsertDrtomfDisclosureRequirementMutation__
 *
 * To run a mutation, you first call `useAdminInsertDrtomfDisclosureRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInsertDrtomfDisclosureRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInsertDrtomfDisclosureRequirementMutation, { data, loading, error }] = useAdminInsertDrtomfDisclosureRequirementMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useAdminInsertDrtomfDisclosureRequirementMutation(baseOptions?: Apollo.MutationHookOptions<AdminInsertDrtomfDisclosureRequirementMutation_, AdminInsertDrtomfDisclosureRequirementMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminInsertDrtomfDisclosureRequirementMutation_, AdminInsertDrtomfDisclosureRequirementMutationVariables_>(AdminInsertDrtomfDisclosureRequirementDocument_, options);
      }
export type AdminInsertDrtomfDisclosureRequirementMutationHookResult = ReturnType<typeof useAdminInsertDrtomfDisclosureRequirementMutation>;
export type AdminInsertDrtomfDisclosureRequirementMutationResult_ = Apollo.MutationResult<AdminInsertDrtomfDisclosureRequirementMutation_>;
export type AdminInsertDrtomfDisclosureRequirementMutationOptions_ = Apollo.BaseMutationOptions<AdminInsertDrtomfDisclosureRequirementMutation_, AdminInsertDrtomfDisclosureRequirementMutationVariables_>;
export const CompanyAssessmentsDocument_ = gql`
    query CompanyAssessments($companyId: uuid!) {
  assessments: CompanyAssessment(
    where: {companyId: {_eq: $companyId}, _and: {deletedAt: {_is_null: true}}}
  ) {
    ...CompanyAssessmentDetailsFields
  }
}
    ${CompanyAssessmentDetailsFieldsFragmentDoc_}`;

/**
 * __useCompanyAssessmentsQuery__
 *
 * To run a query within a React component, call `useCompanyAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAssessmentsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyAssessmentsQuery(baseOptions: Apollo.QueryHookOptions<CompanyAssessmentsQuery_, CompanyAssessmentsQueryVariables_> & ({ variables: CompanyAssessmentsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAssessmentsQuery_, CompanyAssessmentsQueryVariables_>(CompanyAssessmentsDocument_, options);
      }
export function useCompanyAssessmentsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAssessmentsQuery_, CompanyAssessmentsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAssessmentsQuery_, CompanyAssessmentsQueryVariables_>(CompanyAssessmentsDocument_, options);
        }
export function useCompanyAssessmentsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyAssessmentsQuery_, CompanyAssessmentsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyAssessmentsQuery_, CompanyAssessmentsQueryVariables_>(CompanyAssessmentsDocument_, options);
        }
export type CompanyAssessmentsQueryHookResult = ReturnType<typeof useCompanyAssessmentsQuery>;
export type CompanyAssessmentsLazyQuery_HookResult = ReturnType<typeof useCompanyAssessmentsLazyQuery_>;
export type CompanyAssessmentsSuspenseQuery_HookResult = ReturnType<typeof useCompanyAssessmentsSuspenseQuery_>;
export type CompanyAssessmentsQueryResult_ = Apollo.QueryResult<CompanyAssessmentsQuery_, CompanyAssessmentsQueryVariables_>;
export function refetchCompanyAssessmentsQuery_(variables: CompanyAssessmentsQueryVariables_) {
      return { query: CompanyAssessmentsDocument_, variables: variables }
    }
export const GroupCompanyAssessmentNameDocument_ = gql`
    query GroupCompanyAssessmentName($assessmentId: uuid!) {
  assessment: GroupAssessment(where: {id: {_eq: $assessmentId}}) {
    name
  }
}
    `;

/**
 * __useGroupCompanyAssessmentNameQuery__
 *
 * To run a query within a React component, call `useGroupCompanyAssessmentNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupCompanyAssessmentNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupCompanyAssessmentNameQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGroupCompanyAssessmentNameQuery(baseOptions: Apollo.QueryHookOptions<GroupCompanyAssessmentNameQuery_, GroupCompanyAssessmentNameQueryVariables_> & ({ variables: GroupCompanyAssessmentNameQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupCompanyAssessmentNameQuery_, GroupCompanyAssessmentNameQueryVariables_>(GroupCompanyAssessmentNameDocument_, options);
      }
export function useGroupCompanyAssessmentNameLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GroupCompanyAssessmentNameQuery_, GroupCompanyAssessmentNameQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupCompanyAssessmentNameQuery_, GroupCompanyAssessmentNameQueryVariables_>(GroupCompanyAssessmentNameDocument_, options);
        }
export function useGroupCompanyAssessmentNameSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupCompanyAssessmentNameQuery_, GroupCompanyAssessmentNameQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupCompanyAssessmentNameQuery_, GroupCompanyAssessmentNameQueryVariables_>(GroupCompanyAssessmentNameDocument_, options);
        }
export type GroupCompanyAssessmentNameQueryHookResult = ReturnType<typeof useGroupCompanyAssessmentNameQuery>;
export type GroupCompanyAssessmentNameLazyQuery_HookResult = ReturnType<typeof useGroupCompanyAssessmentNameLazyQuery_>;
export type GroupCompanyAssessmentNameSuspenseQuery_HookResult = ReturnType<typeof useGroupCompanyAssessmentNameSuspenseQuery_>;
export type GroupCompanyAssessmentNameQueryResult_ = Apollo.QueryResult<GroupCompanyAssessmentNameQuery_, GroupCompanyAssessmentNameQueryVariables_>;
export function refetchGroupCompanyAssessmentNameQuery_(variables: GroupCompanyAssessmentNameQueryVariables_) {
      return { query: GroupCompanyAssessmentNameDocument_, variables: variables }
    }
export const CompanyAssessmentDocument_ = gql`
    query CompanyAssessment($cAssessmentId: uuid!) {
  companyAssessment: CompanyAssessment_by_pk(id: $cAssessmentId) {
    ...CompanyAssessmentDetailsFields
    generalAssessment: bAssesssments(where: {businessUnitId: {_is_null: true}}) {
      ...BusinessUnitAssessmentFields
    }
    bAssessments: bAssesssments(
      where: {businessUnitId: {_is_null: false}, deletedAt: {_is_null: true}}
      order_by: {createdAt: asc}
    ) {
      ...BusinessUnitAssessmentFields
    }
  }
}
    ${CompanyAssessmentDetailsFieldsFragmentDoc_}
${BusinessUnitAssessmentFieldsFragmentDoc_}`;

/**
 * __useCompanyAssessmentQuery__
 *
 * To run a query within a React component, call `useCompanyAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAssessmentQuery({
 *   variables: {
 *      cAssessmentId: // value for 'cAssessmentId'
 *   },
 * });
 */
export function useCompanyAssessmentQuery(baseOptions: Apollo.QueryHookOptions<CompanyAssessmentQuery_, CompanyAssessmentQueryVariables_> & ({ variables: CompanyAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAssessmentQuery_, CompanyAssessmentQueryVariables_>(CompanyAssessmentDocument_, options);
      }
export function useCompanyAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAssessmentQuery_, CompanyAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAssessmentQuery_, CompanyAssessmentQueryVariables_>(CompanyAssessmentDocument_, options);
        }
export function useCompanyAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyAssessmentQuery_, CompanyAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyAssessmentQuery_, CompanyAssessmentQueryVariables_>(CompanyAssessmentDocument_, options);
        }
export type CompanyAssessmentQueryHookResult = ReturnType<typeof useCompanyAssessmentQuery>;
export type CompanyAssessmentLazyQuery_HookResult = ReturnType<typeof useCompanyAssessmentLazyQuery_>;
export type CompanyAssessmentSuspenseQuery_HookResult = ReturnType<typeof useCompanyAssessmentSuspenseQuery_>;
export type CompanyAssessmentQueryResult_ = Apollo.QueryResult<CompanyAssessmentQuery_, CompanyAssessmentQueryVariables_>;
export function refetchCompanyAssessmentQuery_(variables: CompanyAssessmentQueryVariables_) {
      return { query: CompanyAssessmentDocument_, variables: variables }
    }
export const CompanyAssessmentTitleDocument_ = gql`
    query companyAssessmentTitle($cAssessmentId: uuid!) {
  companyAssessment: CompanyAssessment_by_pk(id: $cAssessmentId) {
    id
    aggregate {
      id
      title
    }
  }
}
    `;

/**
 * __useCompanyAssessmentTitleQuery__
 *
 * To run a query within a React component, call `useCompanyAssessmentTitleQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAssessmentTitleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAssessmentTitleQuery({
 *   variables: {
 *      cAssessmentId: // value for 'cAssessmentId'
 *   },
 * });
 */
export function useCompanyAssessmentTitleQuery(baseOptions: Apollo.QueryHookOptions<CompanyAssessmentTitleQuery_, CompanyAssessmentTitleQueryVariables_> & ({ variables: CompanyAssessmentTitleQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAssessmentTitleQuery_, CompanyAssessmentTitleQueryVariables_>(CompanyAssessmentTitleDocument_, options);
      }
export function useCompanyAssessmentTitleLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAssessmentTitleQuery_, CompanyAssessmentTitleQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAssessmentTitleQuery_, CompanyAssessmentTitleQueryVariables_>(CompanyAssessmentTitleDocument_, options);
        }
export function useCompanyAssessmentTitleSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyAssessmentTitleQuery_, CompanyAssessmentTitleQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyAssessmentTitleQuery_, CompanyAssessmentTitleQueryVariables_>(CompanyAssessmentTitleDocument_, options);
        }
export type CompanyAssessmentTitleQueryHookResult = ReturnType<typeof useCompanyAssessmentTitleQuery>;
export type CompanyAssessmentTitleLazyQuery_HookResult = ReturnType<typeof useCompanyAssessmentTitleLazyQuery_>;
export type CompanyAssessmentTitleSuspenseQuery_HookResult = ReturnType<typeof useCompanyAssessmentTitleSuspenseQuery_>;
export type CompanyAssessmentTitleQueryResult_ = Apollo.QueryResult<CompanyAssessmentTitleQuery_, CompanyAssessmentTitleQueryVariables_>;
export function refetchCompanyAssessmentTitleQuery_(variables: CompanyAssessmentTitleQueryVariables_) {
      return { query: CompanyAssessmentTitleDocument_, variables: variables }
    }
export const CompanyAssessmentIsLockedDocument_ = gql`
    query companyAssessmentIsLocked($cAssessmentId: uuid!) {
  companyAssessment: CompanyAssessment_by_pk(id: $cAssessmentId) {
    id
    isLocked
  }
}
    `;

/**
 * __useCompanyAssessmentIsLockedQuery__
 *
 * To run a query within a React component, call `useCompanyAssessmentIsLockedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAssessmentIsLockedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAssessmentIsLockedQuery({
 *   variables: {
 *      cAssessmentId: // value for 'cAssessmentId'
 *   },
 * });
 */
export function useCompanyAssessmentIsLockedQuery(baseOptions: Apollo.QueryHookOptions<CompanyAssessmentIsLockedQuery_, CompanyAssessmentIsLockedQueryVariables_> & ({ variables: CompanyAssessmentIsLockedQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAssessmentIsLockedQuery_, CompanyAssessmentIsLockedQueryVariables_>(CompanyAssessmentIsLockedDocument_, options);
      }
export function useCompanyAssessmentIsLockedLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAssessmentIsLockedQuery_, CompanyAssessmentIsLockedQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAssessmentIsLockedQuery_, CompanyAssessmentIsLockedQueryVariables_>(CompanyAssessmentIsLockedDocument_, options);
        }
export function useCompanyAssessmentIsLockedSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyAssessmentIsLockedQuery_, CompanyAssessmentIsLockedQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyAssessmentIsLockedQuery_, CompanyAssessmentIsLockedQueryVariables_>(CompanyAssessmentIsLockedDocument_, options);
        }
export type CompanyAssessmentIsLockedQueryHookResult = ReturnType<typeof useCompanyAssessmentIsLockedQuery>;
export type CompanyAssessmentIsLockedLazyQuery_HookResult = ReturnType<typeof useCompanyAssessmentIsLockedLazyQuery_>;
export type CompanyAssessmentIsLockedSuspenseQuery_HookResult = ReturnType<typeof useCompanyAssessmentIsLockedSuspenseQuery_>;
export type CompanyAssessmentIsLockedQueryResult_ = Apollo.QueryResult<CompanyAssessmentIsLockedQuery_, CompanyAssessmentIsLockedQueryVariables_>;
export function refetchCompanyAssessmentIsLockedQuery_(variables: CompanyAssessmentIsLockedQueryVariables_) {
      return { query: CompanyAssessmentIsLockedDocument_, variables: variables }
    }
export const CompanyAssessmentFormDocument_ = gql`
    query companyAssessmentForm($cAssessmentId: uuid!) {
  companyAssessment: CompanyAssessment_by_pk(id: $cAssessmentId) {
    id
    startDate
    isLocked
    cachedResultId
    aggregate {
      id
      title
      contactPerson {
        id
      }
    }
    bAssessments: bAssesssments(
      where: {businessUnitId: {_is_null: false}, deletedAt: {_is_null: true}}
      order_by: {createdAt: asc}
    ) {
      id
      deletedAt
      businessUnit {
        id
      }
    }
  }
}
    `;

/**
 * __useCompanyAssessmentFormQuery__
 *
 * To run a query within a React component, call `useCompanyAssessmentFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAssessmentFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAssessmentFormQuery({
 *   variables: {
 *      cAssessmentId: // value for 'cAssessmentId'
 *   },
 * });
 */
export function useCompanyAssessmentFormQuery(baseOptions: Apollo.QueryHookOptions<CompanyAssessmentFormQuery_, CompanyAssessmentFormQueryVariables_> & ({ variables: CompanyAssessmentFormQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAssessmentFormQuery_, CompanyAssessmentFormQueryVariables_>(CompanyAssessmentFormDocument_, options);
      }
export function useCompanyAssessmentFormLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAssessmentFormQuery_, CompanyAssessmentFormQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAssessmentFormQuery_, CompanyAssessmentFormQueryVariables_>(CompanyAssessmentFormDocument_, options);
        }
export function useCompanyAssessmentFormSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyAssessmentFormQuery_, CompanyAssessmentFormQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyAssessmentFormQuery_, CompanyAssessmentFormQueryVariables_>(CompanyAssessmentFormDocument_, options);
        }
export type CompanyAssessmentFormQueryHookResult = ReturnType<typeof useCompanyAssessmentFormQuery>;
export type CompanyAssessmentFormLazyQuery_HookResult = ReturnType<typeof useCompanyAssessmentFormLazyQuery_>;
export type CompanyAssessmentFormSuspenseQuery_HookResult = ReturnType<typeof useCompanyAssessmentFormSuspenseQuery_>;
export type CompanyAssessmentFormQueryResult_ = Apollo.QueryResult<CompanyAssessmentFormQuery_, CompanyAssessmentFormQueryVariables_>;
export function refetchCompanyAssessmentFormQuery_(variables: CompanyAssessmentFormQueryVariables_) {
      return { query: CompanyAssessmentFormDocument_, variables: variables }
    }
export const ActivityAssessmentAnswersDocument_ = gql`
    query ActivityAssessmentAnswers($activityAssessmentId: uuid!, $version: Int!) {
  answers: Answer(
    where: {reportId: {_eq: $activityAssessmentId}, question: {questionSets: {questionSet: {activityQuestionSets: {version: {_eq: $version}, activity: {activityReports: {id: {_eq: $activityAssessmentId}}}}}}}}
  ) {
    ...AnswerFields
  }
}
    ${AnswerFieldsFragmentDoc_}`;

/**
 * __useActivityAssessmentAnswersQuery__
 *
 * To run a query within a React component, call `useActivityAssessmentAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityAssessmentAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityAssessmentAnswersQuery({
 *   variables: {
 *      activityAssessmentId: // value for 'activityAssessmentId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useActivityAssessmentAnswersQuery(baseOptions: Apollo.QueryHookOptions<ActivityAssessmentAnswersQuery_, ActivityAssessmentAnswersQueryVariables_> & ({ variables: ActivityAssessmentAnswersQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityAssessmentAnswersQuery_, ActivityAssessmentAnswersQueryVariables_>(ActivityAssessmentAnswersDocument_, options);
      }
export function useActivityAssessmentAnswersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ActivityAssessmentAnswersQuery_, ActivityAssessmentAnswersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityAssessmentAnswersQuery_, ActivityAssessmentAnswersQueryVariables_>(ActivityAssessmentAnswersDocument_, options);
        }
export function useActivityAssessmentAnswersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityAssessmentAnswersQuery_, ActivityAssessmentAnswersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityAssessmentAnswersQuery_, ActivityAssessmentAnswersQueryVariables_>(ActivityAssessmentAnswersDocument_, options);
        }
export type ActivityAssessmentAnswersQueryHookResult = ReturnType<typeof useActivityAssessmentAnswersQuery>;
export type ActivityAssessmentAnswersLazyQuery_HookResult = ReturnType<typeof useActivityAssessmentAnswersLazyQuery_>;
export type ActivityAssessmentAnswersSuspenseQuery_HookResult = ReturnType<typeof useActivityAssessmentAnswersSuspenseQuery_>;
export type ActivityAssessmentAnswersQueryResult_ = Apollo.QueryResult<ActivityAssessmentAnswersQuery_, ActivityAssessmentAnswersQueryVariables_>;
export function refetchActivityAssessmentAnswersQuery_(variables: ActivityAssessmentAnswersQueryVariables_) {
      return { query: ActivityAssessmentAnswersDocument_, variables: variables }
    }
export const GetActivityAssessmentVersionDocument_ = gql`
    query getActivityAssessmentVersion($activityAssessmentId: uuid!) {
  activityAssessment: ActivityReport_by_pk(id: $activityAssessmentId) {
    id
    activityRef
    activityVersionNumber
    activityVersionConfig
    bAssessment {
      cAssessment {
        startDate
      }
    }
    activity {
      name
      currentVersion {
        validFrom
        versionNumber
        changeDescription
      }
    }
  }
}
    `;

/**
 * __useGetActivityAssessmentVersionQuery__
 *
 * To run a query within a React component, call `useGetActivityAssessmentVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityAssessmentVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityAssessmentVersionQuery({
 *   variables: {
 *      activityAssessmentId: // value for 'activityAssessmentId'
 *   },
 * });
 */
export function useGetActivityAssessmentVersionQuery(baseOptions: Apollo.QueryHookOptions<GetActivityAssessmentVersionQuery_, GetActivityAssessmentVersionQueryVariables_> & ({ variables: GetActivityAssessmentVersionQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityAssessmentVersionQuery_, GetActivityAssessmentVersionQueryVariables_>(GetActivityAssessmentVersionDocument_, options);
      }
export function useGetActivityAssessmentVersionLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityAssessmentVersionQuery_, GetActivityAssessmentVersionQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityAssessmentVersionQuery_, GetActivityAssessmentVersionQueryVariables_>(GetActivityAssessmentVersionDocument_, options);
        }
export function useGetActivityAssessmentVersionSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityAssessmentVersionQuery_, GetActivityAssessmentVersionQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivityAssessmentVersionQuery_, GetActivityAssessmentVersionQueryVariables_>(GetActivityAssessmentVersionDocument_, options);
        }
export type GetActivityAssessmentVersionQueryHookResult = ReturnType<typeof useGetActivityAssessmentVersionQuery>;
export type GetActivityAssessmentVersionLazyQuery_HookResult = ReturnType<typeof useGetActivityAssessmentVersionLazyQuery_>;
export type GetActivityAssessmentVersionSuspenseQuery_HookResult = ReturnType<typeof useGetActivityAssessmentVersionSuspenseQuery_>;
export type GetActivityAssessmentVersionQueryResult_ = Apollo.QueryResult<GetActivityAssessmentVersionQuery_, GetActivityAssessmentVersionQueryVariables_>;
export function refetchGetActivityAssessmentVersionQuery_(variables: GetActivityAssessmentVersionQueryVariables_) {
      return { query: GetActivityAssessmentVersionDocument_, variables: variables }
    }
export const ActivityAssessmentDocument_ = gql`
    query ActivityAssessment($activityAssessmentId: uuid!, $version: Int!, $prevVersion: Int!) {
  activityAssessment: ActivityReport_by_pk(id: $activityAssessmentId) {
    ...ActivityReportFields
    bAssessment {
      cAssessment {
        bAssesssments(where: {businessUnitId: {_is_null: true}}) {
          activityReports {
            cachedResult {
              ...CachedResultFields
            }
          }
        }
      }
    }
  }
  objectives: Objective {
    title
    key
    questions(
      where: {questionSets: {questionSet: {activityQuestionSets: {activity: {activityReports: {id: {_eq: $activityAssessmentId}}}, version: {_eq: $version}}}}}
      order_by: [{group: asc}, {orderIndex: asc}]
    ) {
      ...QuestionFields
      answers: Answers(where: {reportId: {_eq: $activityAssessmentId}}) {
        ...ShortAnswerFields
      }
      olderRevisions(
        where: {oldQuestion: {questionSets: {questionSet: {activityQuestionSets: {activity: {activityReports: {id: {_eq: $activityAssessmentId}}}, version: {_eq: $prevVersion}}}}}}
      ) {
        description
        oldQuestion {
          id
        }
      }
    }
  }
}
    ${ActivityReportFieldsFragmentDoc_}
${CachedResultFieldsFragmentDoc_}
${QuestionFieldsFragmentDoc_}
${ShortAnswerFieldsFragmentDoc_}`;

/**
 * __useActivityAssessmentQuery__
 *
 * To run a query within a React component, call `useActivityAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityAssessmentQuery({
 *   variables: {
 *      activityAssessmentId: // value for 'activityAssessmentId'
 *      version: // value for 'version'
 *      prevVersion: // value for 'prevVersion'
 *   },
 * });
 */
export function useActivityAssessmentQuery(baseOptions: Apollo.QueryHookOptions<ActivityAssessmentQuery_, ActivityAssessmentQueryVariables_> & ({ variables: ActivityAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityAssessmentQuery_, ActivityAssessmentQueryVariables_>(ActivityAssessmentDocument_, options);
      }
export function useActivityAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ActivityAssessmentQuery_, ActivityAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityAssessmentQuery_, ActivityAssessmentQueryVariables_>(ActivityAssessmentDocument_, options);
        }
export function useActivityAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityAssessmentQuery_, ActivityAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityAssessmentQuery_, ActivityAssessmentQueryVariables_>(ActivityAssessmentDocument_, options);
        }
export type ActivityAssessmentQueryHookResult = ReturnType<typeof useActivityAssessmentQuery>;
export type ActivityAssessmentLazyQuery_HookResult = ReturnType<typeof useActivityAssessmentLazyQuery_>;
export type ActivityAssessmentSuspenseQuery_HookResult = ReturnType<typeof useActivityAssessmentSuspenseQuery_>;
export type ActivityAssessmentQueryResult_ = Apollo.QueryResult<ActivityAssessmentQuery_, ActivityAssessmentQueryVariables_>;
export function refetchActivityAssessmentQuery_(variables: ActivityAssessmentQueryVariables_) {
      return { query: ActivityAssessmentDocument_, variables: variables }
    }
export const OldActivityAssessmentDocument_ = gql`
    query OldActivityAssessment($activityAssessmentId: uuid!, $currentVersion: Int!, $previousVersion: Int!) {
  objectives: Objective {
    title
    key
    oldQuestions: questions(
      where: {_and: [{questionSets: {questionSet: {activityQuestionSets: {activity: {activityReports: {id: {_eq: $activityAssessmentId}}}, version: {_gte: $previousVersion}}}}}, {_not: {questionSets: {questionSet: {activityQuestionSets: {activity: {activityReports: {id: {_eq: $activityAssessmentId}}}, version: {_eq: $currentVersion}}}}}}]}
      order_by: [{group: asc}, {orderIndex: asc}]
    ) {
      id
      newerRevisions {
        description
        newQuestion {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useOldActivityAssessmentQuery__
 *
 * To run a query within a React component, call `useOldActivityAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useOldActivityAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOldActivityAssessmentQuery({
 *   variables: {
 *      activityAssessmentId: // value for 'activityAssessmentId'
 *      currentVersion: // value for 'currentVersion'
 *      previousVersion: // value for 'previousVersion'
 *   },
 * });
 */
export function useOldActivityAssessmentQuery(baseOptions: Apollo.QueryHookOptions<OldActivityAssessmentQuery_, OldActivityAssessmentQueryVariables_> & ({ variables: OldActivityAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OldActivityAssessmentQuery_, OldActivityAssessmentQueryVariables_>(OldActivityAssessmentDocument_, options);
      }
export function useOldActivityAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<OldActivityAssessmentQuery_, OldActivityAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OldActivityAssessmentQuery_, OldActivityAssessmentQueryVariables_>(OldActivityAssessmentDocument_, options);
        }
export function useOldActivityAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OldActivityAssessmentQuery_, OldActivityAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OldActivityAssessmentQuery_, OldActivityAssessmentQueryVariables_>(OldActivityAssessmentDocument_, options);
        }
export type OldActivityAssessmentQueryHookResult = ReturnType<typeof useOldActivityAssessmentQuery>;
export type OldActivityAssessmentLazyQuery_HookResult = ReturnType<typeof useOldActivityAssessmentLazyQuery_>;
export type OldActivityAssessmentSuspenseQuery_HookResult = ReturnType<typeof useOldActivityAssessmentSuspenseQuery_>;
export type OldActivityAssessmentQueryResult_ = Apollo.QueryResult<OldActivityAssessmentQuery_, OldActivityAssessmentQueryVariables_>;
export function refetchOldActivityAssessmentQuery_(variables: OldActivityAssessmentQueryVariables_) {
      return { query: OldActivityAssessmentDocument_, variables: variables }
    }
export const AllActivityAssessmentsWithVersionDocument_ = gql`
    query allActivityAssessmentsWithVersion($cAssessmentId: uuid!) {
  ActivityReport(
    where: {bAssessment: {cAssessmentId: {_eq: $cAssessmentId}, deletedAt: {_is_null: true}}, deletedAt: {_is_null: true}}
    order_by: {activityRef: asc}
  ) {
    id
    activityRef
    activityVersionNumber
    activityVersionConfig
    bAssessment {
      id
      cAssessment {
        id
        isLocked
        startDate
        cachedResultId
      }
    }
    activity {
      name
      currentVersion {
        validFrom
        versionNumber
        changeDescription
      }
      versions {
        validFrom
        versionNumber
        changeDescription
      }
    }
  }
}
    `;

/**
 * __useAllActivityAssessmentsWithVersionQuery__
 *
 * To run a query within a React component, call `useAllActivityAssessmentsWithVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllActivityAssessmentsWithVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllActivityAssessmentsWithVersionQuery({
 *   variables: {
 *      cAssessmentId: // value for 'cAssessmentId'
 *   },
 * });
 */
export function useAllActivityAssessmentsWithVersionQuery(baseOptions: Apollo.QueryHookOptions<AllActivityAssessmentsWithVersionQuery_, AllActivityAssessmentsWithVersionQueryVariables_> & ({ variables: AllActivityAssessmentsWithVersionQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllActivityAssessmentsWithVersionQuery_, AllActivityAssessmentsWithVersionQueryVariables_>(AllActivityAssessmentsWithVersionDocument_, options);
      }
export function useAllActivityAssessmentsWithVersionLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AllActivityAssessmentsWithVersionQuery_, AllActivityAssessmentsWithVersionQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllActivityAssessmentsWithVersionQuery_, AllActivityAssessmentsWithVersionQueryVariables_>(AllActivityAssessmentsWithVersionDocument_, options);
        }
export function useAllActivityAssessmentsWithVersionSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllActivityAssessmentsWithVersionQuery_, AllActivityAssessmentsWithVersionQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllActivityAssessmentsWithVersionQuery_, AllActivityAssessmentsWithVersionQueryVariables_>(AllActivityAssessmentsWithVersionDocument_, options);
        }
export type AllActivityAssessmentsWithVersionQueryHookResult = ReturnType<typeof useAllActivityAssessmentsWithVersionQuery>;
export type AllActivityAssessmentsWithVersionLazyQuery_HookResult = ReturnType<typeof useAllActivityAssessmentsWithVersionLazyQuery_>;
export type AllActivityAssessmentsWithVersionSuspenseQuery_HookResult = ReturnType<typeof useAllActivityAssessmentsWithVersionSuspenseQuery_>;
export type AllActivityAssessmentsWithVersionQueryResult_ = Apollo.QueryResult<AllActivityAssessmentsWithVersionQuery_, AllActivityAssessmentsWithVersionQueryVariables_>;
export function refetchAllActivityAssessmentsWithVersionQuery_(variables: AllActivityAssessmentsWithVersionQueryVariables_) {
      return { query: AllActivityAssessmentsWithVersionDocument_, variables: variables }
    }
export const ValidActivityVersionsDocument_ = gql`
    query validActivityVersions($activityRef: String!, $startDate: date!) {
  activity: Activity_by_pk(reference: $activityRef) {
    currentQuestionSetVersion
    versions(
      where: {validFrom: {_lte: $startDate}}
      order_by: {versionNumber: desc}
      limit: 1
    ) {
      versionNumber
      validFrom
    }
  }
}
    `;

/**
 * __useValidActivityVersionsQuery__
 *
 * To run a query within a React component, call `useValidActivityVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidActivityVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidActivityVersionsQuery({
 *   variables: {
 *      activityRef: // value for 'activityRef'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useValidActivityVersionsQuery(baseOptions: Apollo.QueryHookOptions<ValidActivityVersionsQuery_, ValidActivityVersionsQueryVariables_> & ({ variables: ValidActivityVersionsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidActivityVersionsQuery_, ValidActivityVersionsQueryVariables_>(ValidActivityVersionsDocument_, options);
      }
export function useValidActivityVersionsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ValidActivityVersionsQuery_, ValidActivityVersionsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidActivityVersionsQuery_, ValidActivityVersionsQueryVariables_>(ValidActivityVersionsDocument_, options);
        }
export function useValidActivityVersionsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidActivityVersionsQuery_, ValidActivityVersionsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidActivityVersionsQuery_, ValidActivityVersionsQueryVariables_>(ValidActivityVersionsDocument_, options);
        }
export type ValidActivityVersionsQueryHookResult = ReturnType<typeof useValidActivityVersionsQuery>;
export type ValidActivityVersionsLazyQuery_HookResult = ReturnType<typeof useValidActivityVersionsLazyQuery_>;
export type ValidActivityVersionsSuspenseQuery_HookResult = ReturnType<typeof useValidActivityVersionsSuspenseQuery_>;
export type ValidActivityVersionsQueryResult_ = Apollo.QueryResult<ValidActivityVersionsQuery_, ValidActivityVersionsQueryVariables_>;
export function refetchValidActivityVersionsQuery_(variables: ValidActivityVersionsQueryVariables_) {
      return { query: ValidActivityVersionsDocument_, variables: variables }
    }
export const ValidActivityVersionsForCompanyDocument_ = gql`
    query validActivityVersionsForCompany($activityRef: String!, $startDate: date!, $cAssessmentId: uuid) {
  activity: Activity_by_pk(reference: $activityRef) {
    currentQuestionSetVersion
    versions(
      where: {validFrom: {_lte: $startDate}}
      order_by: {versionNumber: desc}
      limit: 1
    ) {
      versionNumber
      validFrom
    }
    versionsInCompanyAssessment: activityReports(
      where: {deletedAt: {_is_null: true}, bAssessment: {deletedAt: {_is_null: true}, cAssessment: {deletedAt: {_is_null: true}, id: {_eq: $cAssessmentId}}}}
      order_by: {activityVersionNumber: desc}
      distinct_on: [activityVersionNumber]
    ) {
      activityVersionNumber
    }
  }
}
    `;

/**
 * __useValidActivityVersionsForCompanyQuery__
 *
 * To run a query within a React component, call `useValidActivityVersionsForCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidActivityVersionsForCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidActivityVersionsForCompanyQuery({
 *   variables: {
 *      activityRef: // value for 'activityRef'
 *      startDate: // value for 'startDate'
 *      cAssessmentId: // value for 'cAssessmentId'
 *   },
 * });
 */
export function useValidActivityVersionsForCompanyQuery(baseOptions: Apollo.QueryHookOptions<ValidActivityVersionsForCompanyQuery_, ValidActivityVersionsForCompanyQueryVariables_> & ({ variables: ValidActivityVersionsForCompanyQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidActivityVersionsForCompanyQuery_, ValidActivityVersionsForCompanyQueryVariables_>(ValidActivityVersionsForCompanyDocument_, options);
      }
export function useValidActivityVersionsForCompanyLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ValidActivityVersionsForCompanyQuery_, ValidActivityVersionsForCompanyQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidActivityVersionsForCompanyQuery_, ValidActivityVersionsForCompanyQueryVariables_>(ValidActivityVersionsForCompanyDocument_, options);
        }
export function useValidActivityVersionsForCompanySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidActivityVersionsForCompanyQuery_, ValidActivityVersionsForCompanyQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidActivityVersionsForCompanyQuery_, ValidActivityVersionsForCompanyQueryVariables_>(ValidActivityVersionsForCompanyDocument_, options);
        }
export type ValidActivityVersionsForCompanyQueryHookResult = ReturnType<typeof useValidActivityVersionsForCompanyQuery>;
export type ValidActivityVersionsForCompanyLazyQuery_HookResult = ReturnType<typeof useValidActivityVersionsForCompanyLazyQuery_>;
export type ValidActivityVersionsForCompanySuspenseQuery_HookResult = ReturnType<typeof useValidActivityVersionsForCompanySuspenseQuery_>;
export type ValidActivityVersionsForCompanyQueryResult_ = Apollo.QueryResult<ValidActivityVersionsForCompanyQuery_, ValidActivityVersionsForCompanyQueryVariables_>;
export function refetchValidActivityVersionsForCompanyQuery_(variables: ValidActivityVersionsForCompanyQueryVariables_) {
      return { query: ValidActivityVersionsForCompanyDocument_, variables: variables }
    }
export const ValidActivityVersionsManyDocument_ = gql`
    query validActivityVersionsMany($activityRefs: [String!]!, $startDate: date!) {
  activity: Activity(where: {reference: {_in: $activityRefs}}) {
    currentQuestionSetVersion
    versions(
      where: {validFrom: {_lte: $startDate}}
      order_by: {versionNumber: desc}
      limit: 1
    ) {
      versionNumber
      validFrom
    }
  }
}
    `;

/**
 * __useValidActivityVersionsManyQuery__
 *
 * To run a query within a React component, call `useValidActivityVersionsManyQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidActivityVersionsManyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidActivityVersionsManyQuery({
 *   variables: {
 *      activityRefs: // value for 'activityRefs'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useValidActivityVersionsManyQuery(baseOptions: Apollo.QueryHookOptions<ValidActivityVersionsManyQuery_, ValidActivityVersionsManyQueryVariables_> & ({ variables: ValidActivityVersionsManyQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidActivityVersionsManyQuery_, ValidActivityVersionsManyQueryVariables_>(ValidActivityVersionsManyDocument_, options);
      }
export function useValidActivityVersionsManyLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ValidActivityVersionsManyQuery_, ValidActivityVersionsManyQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidActivityVersionsManyQuery_, ValidActivityVersionsManyQueryVariables_>(ValidActivityVersionsManyDocument_, options);
        }
export function useValidActivityVersionsManySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidActivityVersionsManyQuery_, ValidActivityVersionsManyQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidActivityVersionsManyQuery_, ValidActivityVersionsManyQueryVariables_>(ValidActivityVersionsManyDocument_, options);
        }
export type ValidActivityVersionsManyQueryHookResult = ReturnType<typeof useValidActivityVersionsManyQuery>;
export type ValidActivityVersionsManyLazyQuery_HookResult = ReturnType<typeof useValidActivityVersionsManyLazyQuery_>;
export type ValidActivityVersionsManySuspenseQuery_HookResult = ReturnType<typeof useValidActivityVersionsManySuspenseQuery_>;
export type ValidActivityVersionsManyQueryResult_ = Apollo.QueryResult<ValidActivityVersionsManyQuery_, ValidActivityVersionsManyQueryVariables_>;
export function refetchValidActivityVersionsManyQuery_(variables: ValidActivityVersionsManyQueryVariables_) {
      return { query: ValidActivityVersionsManyDocument_, variables: variables }
    }
export const DuplicationCompanyAssessmentDocument_ = gql`
    query DuplicationCompanyAssessment($id: uuid!) {
  assessment: CompanyAssessment_by_pk(id: $id) {
    id
    companyId
    aggregate {
      title
      interval
      contactPerson {
        id
      }
    }
    totalComparisonFinancials {
      ...TotalComparisonFinancialsFields
    }
    nonMaterialFinancials {
      ...NonMaterialFinancialsFields
    }
    generalAssessment: bAssesssments(where: {businessUnitId: {_is_null: true}}) {
      cAssessmentId
      orderIndex
      hasGeneralAssessment
      reportingGroupId
      activityReports(where: {deletedAt: {_is_null: true}}) {
        activityRef
        activityVersionNumber
        financials {
          ...FinancialsFields
          attachmentBox {
            id
            attachments(
              where: {deletedAt: {_is_null: true}, file: {deletedAt: {_is_null: true}}}
            ) {
              fileId
              updatedAt
            }
          }
          noteHistory {
            id
            notes(limit: 1, order_by: {updatedAt: desc}) {
              updatedAt
              body
              authorId
            }
          }
        }
        answers {
          thread {
            comments(where: {deletedAt: {_is_null: true}}) {
              id
              data
              authorId
              createdAt
              updatedAt
              duplicatedFrom
            }
            subscribers {
              userId
            }
          }
          data
          answeredById
          questionId
          attachmentBox {
            id
            attachments(
              where: {deletedAt: {_is_null: true}, file: {deletedAt: {_is_null: true}}}
            ) {
              fileId
              updatedAt
            }
          }
          noteHistory {
            id
            notes(limit: 1, order_by: {updatedAt: desc}) {
              updatedAt
              body
              authorId
            }
          }
        }
        attachmentBox {
          id
          attachments(
            where: {deletedAt: {_is_null: true}, file: {deletedAt: {_is_null: true}}}
          ) {
            fileId
            updatedAt
          }
        }
        noteHistory {
          id
          notes(limit: 1, order_by: {updatedAt: desc}) {
            updatedAt
            body
            authorId
          }
        }
      }
    }
    businessUnits: bAssesssments(
      where: {deletedAt: {_is_null: true}, businessUnitId: {_is_null: false}}
    ) {
      id
      reportingGroupId
      cAssessmentId
      businessUnit {
        id
        name
      }
    }
  }
  reportingGroups: ReportingGroup(
    where: {companyAssessmentId: {_eq: $id}, deletedAt: {_is_null: true}}
  ) {
    id
    ownerId
    name
    orderIndex
    parentId
    businessUnits {
      businessUnitId
    }
  }
}
    ${TotalComparisonFinancialsFieldsFragmentDoc_}
${NonMaterialFinancialsFieldsFragmentDoc_}
${FinancialsFieldsFragmentDoc_}`;

/**
 * __useDuplicationCompanyAssessmentQuery__
 *
 * To run a query within a React component, call `useDuplicationCompanyAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicationCompanyAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicationCompanyAssessmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicationCompanyAssessmentQuery(baseOptions: Apollo.QueryHookOptions<DuplicationCompanyAssessmentQuery_, DuplicationCompanyAssessmentQueryVariables_> & ({ variables: DuplicationCompanyAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DuplicationCompanyAssessmentQuery_, DuplicationCompanyAssessmentQueryVariables_>(DuplicationCompanyAssessmentDocument_, options);
      }
export function useDuplicationCompanyAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<DuplicationCompanyAssessmentQuery_, DuplicationCompanyAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DuplicationCompanyAssessmentQuery_, DuplicationCompanyAssessmentQueryVariables_>(DuplicationCompanyAssessmentDocument_, options);
        }
export function useDuplicationCompanyAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DuplicationCompanyAssessmentQuery_, DuplicationCompanyAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DuplicationCompanyAssessmentQuery_, DuplicationCompanyAssessmentQueryVariables_>(DuplicationCompanyAssessmentDocument_, options);
        }
export type DuplicationCompanyAssessmentQueryHookResult = ReturnType<typeof useDuplicationCompanyAssessmentQuery>;
export type DuplicationCompanyAssessmentLazyQuery_HookResult = ReturnType<typeof useDuplicationCompanyAssessmentLazyQuery_>;
export type DuplicationCompanyAssessmentSuspenseQuery_HookResult = ReturnType<typeof useDuplicationCompanyAssessmentSuspenseQuery_>;
export type DuplicationCompanyAssessmentQueryResult_ = Apollo.QueryResult<DuplicationCompanyAssessmentQuery_, DuplicationCompanyAssessmentQueryVariables_>;
export function refetchDuplicationCompanyAssessmentQuery_(variables: DuplicationCompanyAssessmentQueryVariables_) {
      return { query: DuplicationCompanyAssessmentDocument_, variables: variables }
    }
export const DuplicationBusinessUnitAssessmentDocument_ = gql`
    query DuplicationBusinessUnitAssessment($id: uuid!) {
  assessment: BusinessUnitAssessment_by_pk(id: $id) {
    id
    businessUnit {
      id
      name
      companyId
      contactPersonId
      description
      labels
    }
    cAssessmentId
    orderIndex
    hasGeneralAssessment
    reportingGroupId
    activityReports(where: {deletedAt: {_is_null: true}}) {
      activityRef
      activityVersionNumber
      financials {
        ...FinancialsFields
        attachmentBox {
          id
          attachments(
            where: {deletedAt: {_is_null: true}, file: {deletedAt: {_is_null: true}}}
          ) {
            fileId
            updatedAt
          }
        }
        noteHistory {
          id
          notes(limit: 1, order_by: {createdAt: desc}) {
            updatedAt
            body
            authorId
          }
        }
      }
      answers {
        thread {
          comments(where: {deletedAt: {_is_null: true}}) {
            id
            data
            authorId
            createdAt
            updatedAt
            duplicatedFrom
          }
          subscribers {
            userId
          }
        }
        data
        answeredById
        questionId
        attachmentBox {
          id
          attachments(
            where: {deletedAt: {_is_null: true}, file: {deletedAt: {_is_null: true}}}
          ) {
            fileId
            updatedAt
          }
        }
        noteHistory {
          id
          notes(limit: 1, order_by: {createdAt: desc}) {
            updatedAt
            body
            authorId
          }
        }
      }
      attachmentBox {
        id
        attachments(
          where: {deletedAt: {_is_null: true}, file: {deletedAt: {_is_null: true}}}
        ) {
          fileId
          updatedAt
        }
      }
      noteHistory {
        id
        notes(limit: 1, order_by: {createdAt: desc}) {
          updatedAt
          body
          authorId
        }
      }
    }
  }
}
    ${FinancialsFieldsFragmentDoc_}`;

/**
 * __useDuplicationBusinessUnitAssessmentQuery__
 *
 * To run a query within a React component, call `useDuplicationBusinessUnitAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDuplicationBusinessUnitAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDuplicationBusinessUnitAssessmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicationBusinessUnitAssessmentQuery(baseOptions: Apollo.QueryHookOptions<DuplicationBusinessUnitAssessmentQuery_, DuplicationBusinessUnitAssessmentQueryVariables_> & ({ variables: DuplicationBusinessUnitAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DuplicationBusinessUnitAssessmentQuery_, DuplicationBusinessUnitAssessmentQueryVariables_>(DuplicationBusinessUnitAssessmentDocument_, options);
      }
export function useDuplicationBusinessUnitAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<DuplicationBusinessUnitAssessmentQuery_, DuplicationBusinessUnitAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DuplicationBusinessUnitAssessmentQuery_, DuplicationBusinessUnitAssessmentQueryVariables_>(DuplicationBusinessUnitAssessmentDocument_, options);
        }
export function useDuplicationBusinessUnitAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DuplicationBusinessUnitAssessmentQuery_, DuplicationBusinessUnitAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DuplicationBusinessUnitAssessmentQuery_, DuplicationBusinessUnitAssessmentQueryVariables_>(DuplicationBusinessUnitAssessmentDocument_, options);
        }
export type DuplicationBusinessUnitAssessmentQueryHookResult = ReturnType<typeof useDuplicationBusinessUnitAssessmentQuery>;
export type DuplicationBusinessUnitAssessmentLazyQuery_HookResult = ReturnType<typeof useDuplicationBusinessUnitAssessmentLazyQuery_>;
export type DuplicationBusinessUnitAssessmentSuspenseQuery_HookResult = ReturnType<typeof useDuplicationBusinessUnitAssessmentSuspenseQuery_>;
export type DuplicationBusinessUnitAssessmentQueryResult_ = Apollo.QueryResult<DuplicationBusinessUnitAssessmentQuery_, DuplicationBusinessUnitAssessmentQueryVariables_>;
export function refetchDuplicationBusinessUnitAssessmentQuery_(variables: DuplicationBusinessUnitAssessmentQueryVariables_) {
      return { query: DuplicationBusinessUnitAssessmentDocument_, variables: variables }
    }
export const PortfolioBulkAssessmentExportDocument_ = gql`
    query PortfolioBulkAssessmentExport($ownerCompanyId: uuid!, $activityRef: String!, $activityVersion: Int!, $reportingPeriod: Int!, $startDate: date!, $endDate: date!, $isCompanyLevel: Boolean! = false) {
  activity: Activity_by_pk(reference: $activityRef) {
    name
    reference
    versions(where: {versionNumber: {_eq: $activityVersion}}) {
      versionNumber
      validFrom
    }
  }
  objectives: Objective {
    title
    key
    questions(
      where: {questionSets: {questionSet: {activityQuestionSets: {activity: {reference: {_eq: $activityRef}}, version: {_eq: $activityVersion}}}}}
      order_by: [{group: asc}, {orderIndex: asc}]
    ) {
      id
      title
      type
      group
      orderIndex
      uniqueId
      unit
      isAligned
      isEditable
      isVisible
      objective {
        key
        title
      }
      choices(order_by: {order: asc}) {
        value
        displayName
        order
      }
    }
  }
  assessments: CompanyAssessment(
    order_by: {company: {name: asc}}
    where: {deletedAt: {_is_null: true}, startDate: {_gte: $startDate, _lte: $endDate}, company: {portfolioCompanies: {portfolio: {deletedAt: {_is_null: true}, ownerCompanyId: {_eq: $ownerCompanyId}}}}}
  ) {
    company {
      name
      id
      portfolioMemberships: portfolioCompanies(
        where: {year: {_eq: $reportingPeriod}, portfolio: {deletedAt: {_is_null: true}, ownerCompanyId: {_eq: $ownerCompanyId}}}
      ) {
        year
        portfolio {
          id
          name
        }
        contactPersonName
        contactPersonEmail
        marketValue
        valueOfInvestments
        sharedCompanyAssessmentId
      }
    }
    id
    aggregate {
      title
      startDate
    }
    id
    bAssesssments(
      order_by: {businessUnit: {name: asc}}
      where: {deletedAt: {_is_null: true}}
    ) {
      hasGeneralAssessment
      businessUnit {
        name
        id
      }
      id
      activityReports(
        where: {deletedAt: {_is_null: true}, activityRef: {_eq: $activityRef}}
      ) {
        id
        activityRef
        answers {
          id
          questionId
          reportId
          data
          updatedAt
          answeredBy {
            id
            email
          }
          noteHistory {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePortfolioBulkAssessmentExportQuery__
 *
 * To run a query within a React component, call `usePortfolioBulkAssessmentExportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfolioBulkAssessmentExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfolioBulkAssessmentExportQuery({
 *   variables: {
 *      ownerCompanyId: // value for 'ownerCompanyId'
 *      activityRef: // value for 'activityRef'
 *      activityVersion: // value for 'activityVersion'
 *      reportingPeriod: // value for 'reportingPeriod'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      isCompanyLevel: // value for 'isCompanyLevel'
 *   },
 * });
 */
export function usePortfolioBulkAssessmentExportQuery(baseOptions: Apollo.QueryHookOptions<PortfolioBulkAssessmentExportQuery_, PortfolioBulkAssessmentExportQueryVariables_> & ({ variables: PortfolioBulkAssessmentExportQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortfolioBulkAssessmentExportQuery_, PortfolioBulkAssessmentExportQueryVariables_>(PortfolioBulkAssessmentExportDocument_, options);
      }
export function usePortfolioBulkAssessmentExportLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<PortfolioBulkAssessmentExportQuery_, PortfolioBulkAssessmentExportQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortfolioBulkAssessmentExportQuery_, PortfolioBulkAssessmentExportQueryVariables_>(PortfolioBulkAssessmentExportDocument_, options);
        }
export function usePortfolioBulkAssessmentExportSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortfolioBulkAssessmentExportQuery_, PortfolioBulkAssessmentExportQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortfolioBulkAssessmentExportQuery_, PortfolioBulkAssessmentExportQueryVariables_>(PortfolioBulkAssessmentExportDocument_, options);
        }
export type PortfolioBulkAssessmentExportQueryHookResult = ReturnType<typeof usePortfolioBulkAssessmentExportQuery>;
export type PortfolioBulkAssessmentExportLazyQuery_HookResult = ReturnType<typeof usePortfolioBulkAssessmentExportLazyQuery_>;
export type PortfolioBulkAssessmentExportSuspenseQuery_HookResult = ReturnType<typeof usePortfolioBulkAssessmentExportSuspenseQuery_>;
export type PortfolioBulkAssessmentExportQueryResult_ = Apollo.QueryResult<PortfolioBulkAssessmentExportQuery_, PortfolioBulkAssessmentExportQueryVariables_>;
export function refetchPortfolioBulkAssessmentExportQuery_(variables: PortfolioBulkAssessmentExportQueryVariables_) {
      return { query: PortfolioBulkAssessmentExportDocument_, variables: variables }
    }
export const PortfolioBulkNotesExportDocument_ = gql`
    query PortfolioBulkNotesExport($noteHistoryIds: [uuid!]!) {
  notes: Note(
    distinct_on: [noteHistoryId]
    order_by: {noteHistoryId: asc, updatedAt: desc}
    where: {noteHistoryId: {_in: $noteHistoryIds}}
  ) {
    noteHistoryId
    id
    body
    updatedAt
  }
}
    `;

/**
 * __usePortfolioBulkNotesExportQuery__
 *
 * To run a query within a React component, call `usePortfolioBulkNotesExportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfolioBulkNotesExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfolioBulkNotesExportQuery({
 *   variables: {
 *      noteHistoryIds: // value for 'noteHistoryIds'
 *   },
 * });
 */
export function usePortfolioBulkNotesExportQuery(baseOptions: Apollo.QueryHookOptions<PortfolioBulkNotesExportQuery_, PortfolioBulkNotesExportQueryVariables_> & ({ variables: PortfolioBulkNotesExportQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortfolioBulkNotesExportQuery_, PortfolioBulkNotesExportQueryVariables_>(PortfolioBulkNotesExportDocument_, options);
      }
export function usePortfolioBulkNotesExportLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<PortfolioBulkNotesExportQuery_, PortfolioBulkNotesExportQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortfolioBulkNotesExportQuery_, PortfolioBulkNotesExportQueryVariables_>(PortfolioBulkNotesExportDocument_, options);
        }
export function usePortfolioBulkNotesExportSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortfolioBulkNotesExportQuery_, PortfolioBulkNotesExportQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortfolioBulkNotesExportQuery_, PortfolioBulkNotesExportQueryVariables_>(PortfolioBulkNotesExportDocument_, options);
        }
export type PortfolioBulkNotesExportQueryHookResult = ReturnType<typeof usePortfolioBulkNotesExportQuery>;
export type PortfolioBulkNotesExportLazyQuery_HookResult = ReturnType<typeof usePortfolioBulkNotesExportLazyQuery_>;
export type PortfolioBulkNotesExportSuspenseQuery_HookResult = ReturnType<typeof usePortfolioBulkNotesExportSuspenseQuery_>;
export type PortfolioBulkNotesExportQueryResult_ = Apollo.QueryResult<PortfolioBulkNotesExportQuery_, PortfolioBulkNotesExportQueryVariables_>;
export function refetchPortfolioBulkNotesExportQuery_(variables: PortfolioBulkNotesExportQueryVariables_) {
      return { query: PortfolioBulkNotesExportDocument_, variables: variables }
    }
export const DeleteCompanyAssessmentDocument_ = gql`
    mutation deleteCompanyAssessment($id: uuid!, $deletedAt: timestamptz) {
  update_CompanyAssessment_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: $deletedAt}
  ) {
    id
    deletedAt
  }
}
    `;
export type DeleteCompanyAssessmentMutationFn_ = Apollo.MutationFunction<DeleteCompanyAssessmentMutation_, DeleteCompanyAssessmentMutationVariables_>;

/**
 * __useDeleteCompanyAssessmentMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyAssessmentMutation, { data, loading, error }] = useDeleteCompanyAssessmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deletedAt: // value for 'deletedAt'
 *   },
 * });
 */
export function useDeleteCompanyAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyAssessmentMutation_, DeleteCompanyAssessmentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyAssessmentMutation_, DeleteCompanyAssessmentMutationVariables_>(DeleteCompanyAssessmentDocument_, options);
      }
export type DeleteCompanyAssessmentMutationHookResult = ReturnType<typeof useDeleteCompanyAssessmentMutation>;
export type DeleteCompanyAssessmentMutationResult_ = Apollo.MutationResult<DeleteCompanyAssessmentMutation_>;
export type DeleteCompanyAssessmentMutationOptions_ = Apollo.BaseMutationOptions<DeleteCompanyAssessmentMutation_, DeleteCompanyAssessmentMutationVariables_>;
export const UpsertActivityReportsDocument_ = gql`
    mutation upsertActivityReports($activityReports: [ActivityReport_insert_input!]!) {
  activityReport: insert_ActivityReport(
    objects: $activityReports
    on_conflict: {constraint: ActivityReport_bAssessmentId_activityRef_614b7372_uniq, update_columns: [completedAt, deletedAt, createdAt, activityVersionNumber]}
  ) {
    returning {
      ...ActivityReportFields
      activity {
        activityQuestionSets {
          questionSet {
            ...QuestionSetFields
          }
        }
      }
      deletedAt
    }
  }
}
    ${ActivityReportFieldsFragmentDoc_}
${QuestionSetFieldsFragmentDoc_}`;
export type UpsertActivityReportsMutationFn_ = Apollo.MutationFunction<UpsertActivityReportsMutation_, UpsertActivityReportsMutationVariables_>;

/**
 * __useUpsertActivityReportsMutation__
 *
 * To run a mutation, you first call `useUpsertActivityReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertActivityReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertActivityReportsMutation, { data, loading, error }] = useUpsertActivityReportsMutation({
 *   variables: {
 *      activityReports: // value for 'activityReports'
 *   },
 * });
 */
export function useUpsertActivityReportsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertActivityReportsMutation_, UpsertActivityReportsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertActivityReportsMutation_, UpsertActivityReportsMutationVariables_>(UpsertActivityReportsDocument_, options);
      }
export type UpsertActivityReportsMutationHookResult = ReturnType<typeof useUpsertActivityReportsMutation>;
export type UpsertActivityReportsMutationResult_ = Apollo.MutationResult<UpsertActivityReportsMutation_>;
export type UpsertActivityReportsMutationOptions_ = Apollo.BaseMutationOptions<UpsertActivityReportsMutation_, UpsertActivityReportsMutationVariables_>;
export const UpsertCompanyAssessmentDocument_ = gql`
    mutation upsertCompanyAssessment($cAssessment: CompanyAssessment_insert_input!) {
  cAssessment: insert_CompanyAssessment_one(
    object: $cAssessment
    on_conflict: {constraint: companyAssessment_pkey, update_columns: [startDate, endDate, isLocked]}
  ) {
    ...CompanyAssessmentFields
    aggregate {
      ...CompanyAssessmentAggregateFields
      company {
        id
        cAssessmentAggregates {
          id
        }
      }
    }
  }
}
    ${CompanyAssessmentFieldsFragmentDoc_}
${CompanyAssessmentAggregateFieldsFragmentDoc_}`;
export type UpsertCompanyAssessmentMutationFn_ = Apollo.MutationFunction<UpsertCompanyAssessmentMutation_, UpsertCompanyAssessmentMutationVariables_>;

/**
 * __useUpsertCompanyAssessmentMutation__
 *
 * To run a mutation, you first call `useUpsertCompanyAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCompanyAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCompanyAssessmentMutation, { data, loading, error }] = useUpsertCompanyAssessmentMutation({
 *   variables: {
 *      cAssessment: // value for 'cAssessment'
 *   },
 * });
 */
export function useUpsertCompanyAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCompanyAssessmentMutation_, UpsertCompanyAssessmentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCompanyAssessmentMutation_, UpsertCompanyAssessmentMutationVariables_>(UpsertCompanyAssessmentDocument_, options);
      }
export type UpsertCompanyAssessmentMutationHookResult = ReturnType<typeof useUpsertCompanyAssessmentMutation>;
export type UpsertCompanyAssessmentMutationResult_ = Apollo.MutationResult<UpsertCompanyAssessmentMutation_>;
export type UpsertCompanyAssessmentMutationOptions_ = Apollo.BaseMutationOptions<UpsertCompanyAssessmentMutation_, UpsertCompanyAssessmentMutationVariables_>;
export const InsertBusinessUnitAssessmentDocument_ = gql`
    mutation insertBusinessUnitAssessment($bAssessment: BusinessUnitAssessment_insert_input!) {
  bAssessment: insert_BusinessUnitAssessment_one(object: $bAssessment) {
    cAssessmentId
    businessUnit {
      id
      name
    }
  }
}
    `;
export type InsertBusinessUnitAssessmentMutationFn_ = Apollo.MutationFunction<InsertBusinessUnitAssessmentMutation_, InsertBusinessUnitAssessmentMutationVariables_>;

/**
 * __useInsertBusinessUnitAssessmentMutation__
 *
 * To run a mutation, you first call `useInsertBusinessUnitAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertBusinessUnitAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertBusinessUnitAssessmentMutation, { data, loading, error }] = useInsertBusinessUnitAssessmentMutation({
 *   variables: {
 *      bAssessment: // value for 'bAssessment'
 *   },
 * });
 */
export function useInsertBusinessUnitAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<InsertBusinessUnitAssessmentMutation_, InsertBusinessUnitAssessmentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertBusinessUnitAssessmentMutation_, InsertBusinessUnitAssessmentMutationVariables_>(InsertBusinessUnitAssessmentDocument_, options);
      }
export type InsertBusinessUnitAssessmentMutationHookResult = ReturnType<typeof useInsertBusinessUnitAssessmentMutation>;
export type InsertBusinessUnitAssessmentMutationResult_ = Apollo.MutationResult<InsertBusinessUnitAssessmentMutation_>;
export type InsertBusinessUnitAssessmentMutationOptions_ = Apollo.BaseMutationOptions<InsertBusinessUnitAssessmentMutation_, InsertBusinessUnitAssessmentMutationVariables_>;
export const InsertNewTotalFinancialsDocument_ = gql`
    mutation insertNewTotalFinancials($financials: Financials_insert_input!) {
  financials: insert_Financials_one(object: $financials) {
    ...FinancialsFields
  }
}
    ${FinancialsFieldsFragmentDoc_}`;
export type InsertNewTotalFinancialsMutationFn_ = Apollo.MutationFunction<InsertNewTotalFinancialsMutation_, InsertNewTotalFinancialsMutationVariables_>;

/**
 * __useInsertNewTotalFinancialsMutation__
 *
 * To run a mutation, you first call `useInsertNewTotalFinancialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertNewTotalFinancialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertNewTotalFinancialsMutation, { data, loading, error }] = useInsertNewTotalFinancialsMutation({
 *   variables: {
 *      financials: // value for 'financials'
 *   },
 * });
 */
export function useInsertNewTotalFinancialsMutation(baseOptions?: Apollo.MutationHookOptions<InsertNewTotalFinancialsMutation_, InsertNewTotalFinancialsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertNewTotalFinancialsMutation_, InsertNewTotalFinancialsMutationVariables_>(InsertNewTotalFinancialsDocument_, options);
      }
export type InsertNewTotalFinancialsMutationHookResult = ReturnType<typeof useInsertNewTotalFinancialsMutation>;
export type InsertNewTotalFinancialsMutationResult_ = Apollo.MutationResult<InsertNewTotalFinancialsMutation_>;
export type InsertNewTotalFinancialsMutationOptions_ = Apollo.BaseMutationOptions<InsertNewTotalFinancialsMutation_, InsertNewTotalFinancialsMutationVariables_>;
export const UpdateAssessmentLockDocument_ = gql`
    mutation updateAssessmentLock($companyAssessmentId: uuid!, $isLocked: Boolean!) {
  update_CompanyAssessment_by_pk(
    pk_columns: {id: $companyAssessmentId}
    _set: {isLocked: $isLocked}
  ) {
    id
    isLocked
  }
}
    `;
export type UpdateAssessmentLockMutationFn_ = Apollo.MutationFunction<UpdateAssessmentLockMutation_, UpdateAssessmentLockMutationVariables_>;

/**
 * __useUpdateAssessmentLockMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentLockMutation, { data, loading, error }] = useUpdateAssessmentLockMutation({
 *   variables: {
 *      companyAssessmentId: // value for 'companyAssessmentId'
 *      isLocked: // value for 'isLocked'
 *   },
 * });
 */
export function useUpdateAssessmentLockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssessmentLockMutation_, UpdateAssessmentLockMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssessmentLockMutation_, UpdateAssessmentLockMutationVariables_>(UpdateAssessmentLockDocument_, options);
      }
export type UpdateAssessmentLockMutationHookResult = ReturnType<typeof useUpdateAssessmentLockMutation>;
export type UpdateAssessmentLockMutationResult_ = Apollo.MutationResult<UpdateAssessmentLockMutation_>;
export type UpdateAssessmentLockMutationOptions_ = Apollo.BaseMutationOptions<UpdateAssessmentLockMutation_, UpdateAssessmentLockMutationVariables_>;
export const UpdateActivityAssessmentVersionDocument_ = gql`
    mutation updateActivityAssessmentVersion($updates: [ActivityReport_updates!]!) {
  update_ActivityReport_many(updates: $updates) {
    affected_rows
    returning {
      id
      activityVersionNumber
      activityVersionConfig
    }
  }
}
    `;
export type UpdateActivityAssessmentVersionMutationFn_ = Apollo.MutationFunction<UpdateActivityAssessmentVersionMutation_, UpdateActivityAssessmentVersionMutationVariables_>;

/**
 * __useUpdateActivityAssessmentVersionMutation__
 *
 * To run a mutation, you first call `useUpdateActivityAssessmentVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityAssessmentVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityAssessmentVersionMutation, { data, loading, error }] = useUpdateActivityAssessmentVersionMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateActivityAssessmentVersionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityAssessmentVersionMutation_, UpdateActivityAssessmentVersionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityAssessmentVersionMutation_, UpdateActivityAssessmentVersionMutationVariables_>(UpdateActivityAssessmentVersionDocument_, options);
      }
export type UpdateActivityAssessmentVersionMutationHookResult = ReturnType<typeof useUpdateActivityAssessmentVersionMutation>;
export type UpdateActivityAssessmentVersionMutationResult_ = Apollo.MutationResult<UpdateActivityAssessmentVersionMutation_>;
export type UpdateActivityAssessmentVersionMutationOptions_ = Apollo.BaseMutationOptions<UpdateActivityAssessmentVersionMutation_, UpdateActivityAssessmentVersionMutationVariables_>;
export const GetCompanyAssessmentsActivitiesDocument_ = gql`
    query getCompanyAssessmentsActivities($companyIds: [uuid!]!, $startDate: date!) {
  companies: Company(where: {id: {_in: $companyIds}}) {
    cAssessments(where: {startDate: {_eq: $startDate}, deletedAt: {_is_null: true}}) {
      bAssesssments(where: {deletedAt: {_is_null: true}}) {
        activityReports(where: {deletedAt: {_is_null: true}}) {
          activityRef
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompanyAssessmentsActivitiesQuery__
 *
 * To run a query within a React component, call `useGetCompanyAssessmentsActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyAssessmentsActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyAssessmentsActivitiesQuery({
 *   variables: {
 *      companyIds: // value for 'companyIds'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useGetCompanyAssessmentsActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyAssessmentsActivitiesQuery_, GetCompanyAssessmentsActivitiesQueryVariables_> & ({ variables: GetCompanyAssessmentsActivitiesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyAssessmentsActivitiesQuery_, GetCompanyAssessmentsActivitiesQueryVariables_>(GetCompanyAssessmentsActivitiesDocument_, options);
      }
export function useGetCompanyAssessmentsActivitiesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyAssessmentsActivitiesQuery_, GetCompanyAssessmentsActivitiesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyAssessmentsActivitiesQuery_, GetCompanyAssessmentsActivitiesQueryVariables_>(GetCompanyAssessmentsActivitiesDocument_, options);
        }
export function useGetCompanyAssessmentsActivitiesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyAssessmentsActivitiesQuery_, GetCompanyAssessmentsActivitiesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyAssessmentsActivitiesQuery_, GetCompanyAssessmentsActivitiesQueryVariables_>(GetCompanyAssessmentsActivitiesDocument_, options);
        }
export type GetCompanyAssessmentsActivitiesQueryHookResult = ReturnType<typeof useGetCompanyAssessmentsActivitiesQuery>;
export type GetCompanyAssessmentsActivitiesLazyQuery_HookResult = ReturnType<typeof useGetCompanyAssessmentsActivitiesLazyQuery_>;
export type GetCompanyAssessmentsActivitiesSuspenseQuery_HookResult = ReturnType<typeof useGetCompanyAssessmentsActivitiesSuspenseQuery_>;
export type GetCompanyAssessmentsActivitiesQueryResult_ = Apollo.QueryResult<GetCompanyAssessmentsActivitiesQuery_, GetCompanyAssessmentsActivitiesQueryVariables_>;
export function refetchGetCompanyAssessmentsActivitiesQuery_(variables: GetCompanyAssessmentsActivitiesQueryVariables_) {
      return { query: GetCompanyAssessmentsActivitiesDocument_, variables: variables }
    }
export const CompanyAssessmentContextDocument_ = gql`
    query CompanyAssessmentContext($cAssessmentId: uuid!) {
  company: CompanyAssessment_by_pk(id: $cAssessmentId) {
    id
    portfoliosWithAccess {
      id
      sharedCompanyAssessmentId
      year
      portfolio {
        id
        name
        ownerCompany {
          id
          name
        }
      }
    }
    company {
      id
      files {
        id
        title
        storageFile {
          id
          name
        }
      }
      users {
        user {
          id
          displayName
        }
      }
    }
    aggregate {
      id
      title
      startDate
      contactPersonId
    }
    cachedResult {
      id
    }
    totalComparisonFinancials {
      id
      reportId
      capex
      opex
      revenue
      adaptationOpex
      adaptationCapex
      noteHistory {
        id
        notes {
          id
          body
        }
      }
      attachmentBox {
        id
        attachments {
          id
        }
      }
    }
    nonMaterialFinancials {
      id
      reportId
      capex
      opex
      revenue
      adaptationOpex
      adaptationCapex
      noteHistory {
        id
        notes {
          id
          body
        }
      }
      attachmentBox {
        id
        attachments {
          id
        }
      }
    }
    bAssesssments {
      id
    }
    reportingGroups {
      id
      name
      parent {
        id
        name
      }
    }
  }
  portfolioCompanies: PortfolioCompany(
    where: {company: {cAssessments: {id: {_eq: $cAssessmentId}}}}
  ) {
    id
    year
    portfolio {
      id
      name
      ownerCompany {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCompanyAssessmentContextQuery__
 *
 * To run a query within a React component, call `useCompanyAssessmentContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAssessmentContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAssessmentContextQuery({
 *   variables: {
 *      cAssessmentId: // value for 'cAssessmentId'
 *   },
 * });
 */
export function useCompanyAssessmentContextQuery(baseOptions: Apollo.QueryHookOptions<CompanyAssessmentContextQuery_, CompanyAssessmentContextQueryVariables_> & ({ variables: CompanyAssessmentContextQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAssessmentContextQuery_, CompanyAssessmentContextQueryVariables_>(CompanyAssessmentContextDocument_, options);
      }
export function useCompanyAssessmentContextLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAssessmentContextQuery_, CompanyAssessmentContextQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAssessmentContextQuery_, CompanyAssessmentContextQueryVariables_>(CompanyAssessmentContextDocument_, options);
        }
export function useCompanyAssessmentContextSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyAssessmentContextQuery_, CompanyAssessmentContextQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyAssessmentContextQuery_, CompanyAssessmentContextQueryVariables_>(CompanyAssessmentContextDocument_, options);
        }
export type CompanyAssessmentContextQueryHookResult = ReturnType<typeof useCompanyAssessmentContextQuery>;
export type CompanyAssessmentContextLazyQuery_HookResult = ReturnType<typeof useCompanyAssessmentContextLazyQuery_>;
export type CompanyAssessmentContextSuspenseQuery_HookResult = ReturnType<typeof useCompanyAssessmentContextSuspenseQuery_>;
export type CompanyAssessmentContextQueryResult_ = Apollo.QueryResult<CompanyAssessmentContextQuery_, CompanyAssessmentContextQueryVariables_>;
export function refetchCompanyAssessmentContextQuery_(variables: CompanyAssessmentContextQueryVariables_) {
      return { query: CompanyAssessmentContextDocument_, variables: variables }
    }
export const BusinessUnitAssessmentDocument_ = gql`
    query BusinessUnitAssessment($id: uuid!) {
  bAssessment: BusinessUnitAssessment_by_pk(id: $id) {
    id
    hasGeneralAssessment
    businessUnit {
      name
      id
    }
    reportingGroup {
      id
      name
    }
    cachedResult {
      id
    }
    activityReports {
      id
      activityRef
      activity {
        name
      }
      cachedResult {
        id
      }
      noteHistory {
        id
        notes {
          id
          body
        }
      }
      attachmentBox {
        id
        attachments {
          id
        }
      }
      answers {
        id
        question {
          title
          type
        }
        noteHistory {
          id
          notes {
            id
            body
          }
        }
        thread {
          id
          comments {
            id
            authorId
            data
          }
        }
        attachmentBox {
          id
          attachments {
            id
          }
        }
      }
      financials {
        id
        reportId
        capex
        opex
        revenue
        adaptationOpex
        adaptationCapex
        activityReport {
          id
          bAssessment {
            id
          }
        }
        noteHistory {
          id
          notes {
            id
            body
          }
        }
        attachmentBox {
          id
          attachments {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBusinessUnitAssessmentQuery__
 *
 * To run a query within a React component, call `useBusinessUnitAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessUnitAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessUnitAssessmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBusinessUnitAssessmentQuery(baseOptions: Apollo.QueryHookOptions<BusinessUnitAssessmentQuery_, BusinessUnitAssessmentQueryVariables_> & ({ variables: BusinessUnitAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessUnitAssessmentQuery_, BusinessUnitAssessmentQueryVariables_>(BusinessUnitAssessmentDocument_, options);
      }
export function useBusinessUnitAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<BusinessUnitAssessmentQuery_, BusinessUnitAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessUnitAssessmentQuery_, BusinessUnitAssessmentQueryVariables_>(BusinessUnitAssessmentDocument_, options);
        }
export function useBusinessUnitAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessUnitAssessmentQuery_, BusinessUnitAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessUnitAssessmentQuery_, BusinessUnitAssessmentQueryVariables_>(BusinessUnitAssessmentDocument_, options);
        }
export type BusinessUnitAssessmentQueryHookResult = ReturnType<typeof useBusinessUnitAssessmentQuery>;
export type BusinessUnitAssessmentLazyQuery_HookResult = ReturnType<typeof useBusinessUnitAssessmentLazyQuery_>;
export type BusinessUnitAssessmentSuspenseQuery_HookResult = ReturnType<typeof useBusinessUnitAssessmentSuspenseQuery_>;
export type BusinessUnitAssessmentQueryResult_ = Apollo.QueryResult<BusinessUnitAssessmentQuery_, BusinessUnitAssessmentQueryVariables_>;
export function refetchBusinessUnitAssessmentQuery_(variables: BusinessUnitAssessmentQueryVariables_) {
      return { query: BusinessUnitAssessmentDocument_, variables: variables }
    }
export const EsrsAssessmentContextDocument_ = gql`
    query EsrsAssessmentContext($esrsAssessmentId: uuid!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    reportingUnits {
      id
      name
      answers {
        id
        metricRef
        datapoints {
          id
          owner {
            displayName
          }
          datapointChoices {
            choice {
              reference
              title
            }
          }
        }
        metric {
          title
          shortTitle
          metricType
          requirement {
            title
            reference
            group {
              standard {
                title
                reference
              }
            }
          }
        }
      }
    }
    materialStandards {
      id
      standard {
        reference
        title
      }
      materialMetrics {
        id
        metric {
          requirement {
            title
          }
          metricType
          title
          shortTitle
          reference
        }
      }
    }
  }
}
    `;

/**
 * __useEsrsAssessmentContextQuery__
 *
 * To run a query within a React component, call `useEsrsAssessmentContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsrsAssessmentContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsrsAssessmentContextQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useEsrsAssessmentContextQuery(baseOptions: Apollo.QueryHookOptions<EsrsAssessmentContextQuery_, EsrsAssessmentContextQueryVariables_> & ({ variables: EsrsAssessmentContextQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsrsAssessmentContextQuery_, EsrsAssessmentContextQueryVariables_>(EsrsAssessmentContextDocument_, options);
      }
export function useEsrsAssessmentContextLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<EsrsAssessmentContextQuery_, EsrsAssessmentContextQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsrsAssessmentContextQuery_, EsrsAssessmentContextQueryVariables_>(EsrsAssessmentContextDocument_, options);
        }
export function useEsrsAssessmentContextSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsrsAssessmentContextQuery_, EsrsAssessmentContextQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsrsAssessmentContextQuery_, EsrsAssessmentContextQueryVariables_>(EsrsAssessmentContextDocument_, options);
        }
export type EsrsAssessmentContextQueryHookResult = ReturnType<typeof useEsrsAssessmentContextQuery>;
export type EsrsAssessmentContextLazyQuery_HookResult = ReturnType<typeof useEsrsAssessmentContextLazyQuery_>;
export type EsrsAssessmentContextSuspenseQuery_HookResult = ReturnType<typeof useEsrsAssessmentContextSuspenseQuery_>;
export type EsrsAssessmentContextQueryResult_ = Apollo.QueryResult<EsrsAssessmentContextQuery_, EsrsAssessmentContextQueryVariables_>;
export function refetchEsrsAssessmentContextQuery_(variables: EsrsAssessmentContextQueryVariables_) {
      return { query: EsrsAssessmentContextDocument_, variables: variables }
    }
export const AuditLogEntriesDocument_ = gql`
    query auditLogEntries($companyId: uuid!, $limit: Int!, $offset: Int!) {
  auditLogEntries: AuditLogEntry(
    order_by: {createdAt: desc}
    where: {companyId: {_eq: $companyId}, table: {_in: ["ReportingGroup", "Answer", "Note", "Comment", "BusinessUnit", "Attachment", "BusinessUnitAssessment", "CompanyAssessmentAggregate", "ActivityReport", "Financials", "PortfolioCompany", "ReportDownloads"]}}
    limit: $limit
    offset: $offset
  ) {
    ...AuditLogEntryFields
  }
}
    ${AuditLogEntryFieldsFragmentDoc_}`;

/**
 * __useAuditLogEntriesQuery__
 *
 * To run a query within a React component, call `useAuditLogEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditLogEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditLogEntriesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useAuditLogEntriesQuery(baseOptions: Apollo.QueryHookOptions<AuditLogEntriesQuery_, AuditLogEntriesQueryVariables_> & ({ variables: AuditLogEntriesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditLogEntriesQuery_, AuditLogEntriesQueryVariables_>(AuditLogEntriesDocument_, options);
      }
export function useAuditLogEntriesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AuditLogEntriesQuery_, AuditLogEntriesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditLogEntriesQuery_, AuditLogEntriesQueryVariables_>(AuditLogEntriesDocument_, options);
        }
export function useAuditLogEntriesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditLogEntriesQuery_, AuditLogEntriesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuditLogEntriesQuery_, AuditLogEntriesQueryVariables_>(AuditLogEntriesDocument_, options);
        }
export type AuditLogEntriesQueryHookResult = ReturnType<typeof useAuditLogEntriesQuery>;
export type AuditLogEntriesLazyQuery_HookResult = ReturnType<typeof useAuditLogEntriesLazyQuery_>;
export type AuditLogEntriesSuspenseQuery_HookResult = ReturnType<typeof useAuditLogEntriesSuspenseQuery_>;
export type AuditLogEntriesQueryResult_ = Apollo.QueryResult<AuditLogEntriesQuery_, AuditLogEntriesQueryVariables_>;
export function refetchAuditLogEntriesQuery_(variables: AuditLogEntriesQueryVariables_) {
      return { query: AuditLogEntriesDocument_, variables: variables }
    }
export const EsrsAuditLogEntriesDocument_ = gql`
    query esrsAuditLogEntries($companyId: uuid!, $limit: Int!, $offset: Int!) {
  auditLogEntries: AuditLogEntry(
    order_by: {timestamp: desc}
    where: {companyId: {_eq: $companyId}, table: {_in: ["Answer", "Datapoint", "DatapointMdrm", "DatapointChoice"]}, schema: {_eq: "esrs"}}
    limit: $limit
    offset: $offset
  ) {
    ...AuditLogEntryFields
  }
}
    ${AuditLogEntryFieldsFragmentDoc_}`;

/**
 * __useEsrsAuditLogEntriesQuery__
 *
 * To run a query within a React component, call `useEsrsAuditLogEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsrsAuditLogEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsrsAuditLogEntriesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useEsrsAuditLogEntriesQuery(baseOptions: Apollo.QueryHookOptions<EsrsAuditLogEntriesQuery_, EsrsAuditLogEntriesQueryVariables_> & ({ variables: EsrsAuditLogEntriesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsrsAuditLogEntriesQuery_, EsrsAuditLogEntriesQueryVariables_>(EsrsAuditLogEntriesDocument_, options);
      }
export function useEsrsAuditLogEntriesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<EsrsAuditLogEntriesQuery_, EsrsAuditLogEntriesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsrsAuditLogEntriesQuery_, EsrsAuditLogEntriesQueryVariables_>(EsrsAuditLogEntriesDocument_, options);
        }
export function useEsrsAuditLogEntriesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsrsAuditLogEntriesQuery_, EsrsAuditLogEntriesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsrsAuditLogEntriesQuery_, EsrsAuditLogEntriesQueryVariables_>(EsrsAuditLogEntriesDocument_, options);
        }
export type EsrsAuditLogEntriesQueryHookResult = ReturnType<typeof useEsrsAuditLogEntriesQuery>;
export type EsrsAuditLogEntriesLazyQuery_HookResult = ReturnType<typeof useEsrsAuditLogEntriesLazyQuery_>;
export type EsrsAuditLogEntriesSuspenseQuery_HookResult = ReturnType<typeof useEsrsAuditLogEntriesSuspenseQuery_>;
export type EsrsAuditLogEntriesQueryResult_ = Apollo.QueryResult<EsrsAuditLogEntriesQuery_, EsrsAuditLogEntriesQueryVariables_>;
export function refetchEsrsAuditLogEntriesQuery_(variables: EsrsAuditLogEntriesQueryVariables_) {
      return { query: EsrsAuditLogEntriesDocument_, variables: variables }
    }
export const BusinessUnitsDocument_ = gql`
    query BusinessUnits($companyId: uuid!) {
  businessunits: BusinessUnit(where: {companyId: {_eq: $companyId}}) {
    ...SimpleBusinessUnit
  }
}
    ${SimpleBusinessUnitFragmentDoc_}`;

/**
 * __useBusinessUnitsQuery__
 *
 * To run a query within a React component, call `useBusinessUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessUnitsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useBusinessUnitsQuery(baseOptions: Apollo.QueryHookOptions<BusinessUnitsQuery_, BusinessUnitsQueryVariables_> & ({ variables: BusinessUnitsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessUnitsQuery_, BusinessUnitsQueryVariables_>(BusinessUnitsDocument_, options);
      }
export function useBusinessUnitsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<BusinessUnitsQuery_, BusinessUnitsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessUnitsQuery_, BusinessUnitsQueryVariables_>(BusinessUnitsDocument_, options);
        }
export function useBusinessUnitsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessUnitsQuery_, BusinessUnitsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessUnitsQuery_, BusinessUnitsQueryVariables_>(BusinessUnitsDocument_, options);
        }
export type BusinessUnitsQueryHookResult = ReturnType<typeof useBusinessUnitsQuery>;
export type BusinessUnitsLazyQuery_HookResult = ReturnType<typeof useBusinessUnitsLazyQuery_>;
export type BusinessUnitsSuspenseQuery_HookResult = ReturnType<typeof useBusinessUnitsSuspenseQuery_>;
export type BusinessUnitsQueryResult_ = Apollo.QueryResult<BusinessUnitsQuery_, BusinessUnitsQueryVariables_>;
export function refetchBusinessUnitsQuery_(variables: BusinessUnitsQueryVariables_) {
      return { query: BusinessUnitsDocument_, variables: variables }
    }
export const SimpleBusinessUnitDocument_ = gql`
    query SimpleBusinessUnit($id: uuid!) {
  businessUnit: BusinessUnit_by_pk(id: $id) {
    ...SimpleBusinessUnit
  }
}
    ${SimpleBusinessUnitFragmentDoc_}`;

/**
 * __useSimpleBusinessUnitQuery__
 *
 * To run a query within a React component, call `useSimpleBusinessUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimpleBusinessUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimpleBusinessUnitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSimpleBusinessUnitQuery(baseOptions: Apollo.QueryHookOptions<SimpleBusinessUnitQuery_, SimpleBusinessUnitQueryVariables_> & ({ variables: SimpleBusinessUnitQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimpleBusinessUnitQuery_, SimpleBusinessUnitQueryVariables_>(SimpleBusinessUnitDocument_, options);
      }
export function useSimpleBusinessUnitLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<SimpleBusinessUnitQuery_, SimpleBusinessUnitQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimpleBusinessUnitQuery_, SimpleBusinessUnitQueryVariables_>(SimpleBusinessUnitDocument_, options);
        }
export function useSimpleBusinessUnitSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SimpleBusinessUnitQuery_, SimpleBusinessUnitQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SimpleBusinessUnitQuery_, SimpleBusinessUnitQueryVariables_>(SimpleBusinessUnitDocument_, options);
        }
export type SimpleBusinessUnitQueryHookResult = ReturnType<typeof useSimpleBusinessUnitQuery>;
export type SimpleBusinessUnitLazyQuery_HookResult = ReturnType<typeof useSimpleBusinessUnitLazyQuery_>;
export type SimpleBusinessUnitSuspenseQuery_HookResult = ReturnType<typeof useSimpleBusinessUnitSuspenseQuery_>;
export type SimpleBusinessUnitQueryResult_ = Apollo.QueryResult<SimpleBusinessUnitQuery_, SimpleBusinessUnitQueryVariables_>;
export function refetchSimpleBusinessUnitQuery_(variables: SimpleBusinessUnitQueryVariables_) {
      return { query: SimpleBusinessUnitDocument_, variables: variables }
    }
export const BusinessUnitDocument_ = gql`
    query BusinessUnit($id: uuid!) {
  businessUnit: BusinessUnit_by_pk(id: $id) {
    ...SimpleBusinessUnit
    companyId
    contactPersonId
    bAssessments(where: {deletedAt: {_is_null: true}}) {
      id
      cAssessment {
        cachedResultId
        id
        isLocked
      }
      cAssessmentId
      orderIndex
      hasGeneralAssessment
      reportingGroupId
      activityReports(where: {deletedAt: {_is_null: true}}) {
        activityRef
        activityVersionNumber
        financials {
          ...FinancialsFields
        }
        answers {
          data
          answeredById
          questionId
          flagged
          attachmentBox {
            attachments(
              where: {deletedAt: {_is_null: true}, file: {deletedAt: {_is_null: true}}}
            ) {
              fileId
            }
          }
          noteHistory {
            notes {
              updatedAt
              body
              authorId
            }
          }
        }
        attachmentBox {
          attachments(
            where: {deletedAt: {_is_null: true}, file: {deletedAt: {_is_null: true}}}
          ) {
            fileId
          }
        }
        noteHistory {
          notes {
            updatedAt
            body
            authorId
          }
        }
      }
    }
  }
}
    ${SimpleBusinessUnitFragmentDoc_}
${FinancialsFieldsFragmentDoc_}`;

/**
 * __useBusinessUnitQuery__
 *
 * To run a query within a React component, call `useBusinessUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessUnitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBusinessUnitQuery(baseOptions: Apollo.QueryHookOptions<BusinessUnitQuery_, BusinessUnitQueryVariables_> & ({ variables: BusinessUnitQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessUnitQuery_, BusinessUnitQueryVariables_>(BusinessUnitDocument_, options);
      }
export function useBusinessUnitLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<BusinessUnitQuery_, BusinessUnitQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessUnitQuery_, BusinessUnitQueryVariables_>(BusinessUnitDocument_, options);
        }
export function useBusinessUnitSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessUnitQuery_, BusinessUnitQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessUnitQuery_, BusinessUnitQueryVariables_>(BusinessUnitDocument_, options);
        }
export type BusinessUnitQueryHookResult = ReturnType<typeof useBusinessUnitQuery>;
export type BusinessUnitLazyQuery_HookResult = ReturnType<typeof useBusinessUnitLazyQuery_>;
export type BusinessUnitSuspenseQuery_HookResult = ReturnType<typeof useBusinessUnitSuspenseQuery_>;
export type BusinessUnitQueryResult_ = Apollo.QueryResult<BusinessUnitQuery_, BusinessUnitQueryVariables_>;
export function refetchBusinessUnitQuery_(variables: BusinessUnitQueryVariables_) {
      return { query: BusinessUnitDocument_, variables: variables }
    }
export const GetBusinessUnitReportingGroupDocument_ = gql`
    query getBusinessUnitReportingGroup($businessUnitId: uuid!, $cAssessmentId: uuid!) {
  group: BusinessUnitAssessment(
    where: {businessUnitId: {_eq: $businessUnitId}, cAssessmentId: {_eq: $cAssessmentId}, reportingGroup: {deletedAt: {_is_null: true}}}
  ) {
    id: reportingGroupId
    reportingGroup {
      name
      id
    }
    businessUnitId
  }
}
    `;

/**
 * __useGetBusinessUnitReportingGroupQuery__
 *
 * To run a query within a React component, call `useGetBusinessUnitReportingGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessUnitReportingGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessUnitReportingGroupQuery({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *      cAssessmentId: // value for 'cAssessmentId'
 *   },
 * });
 */
export function useGetBusinessUnitReportingGroupQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessUnitReportingGroupQuery_, GetBusinessUnitReportingGroupQueryVariables_> & ({ variables: GetBusinessUnitReportingGroupQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessUnitReportingGroupQuery_, GetBusinessUnitReportingGroupQueryVariables_>(GetBusinessUnitReportingGroupDocument_, options);
      }
export function useGetBusinessUnitReportingGroupLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessUnitReportingGroupQuery_, GetBusinessUnitReportingGroupQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessUnitReportingGroupQuery_, GetBusinessUnitReportingGroupQueryVariables_>(GetBusinessUnitReportingGroupDocument_, options);
        }
export function useGetBusinessUnitReportingGroupSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessUnitReportingGroupQuery_, GetBusinessUnitReportingGroupQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessUnitReportingGroupQuery_, GetBusinessUnitReportingGroupQueryVariables_>(GetBusinessUnitReportingGroupDocument_, options);
        }
export type GetBusinessUnitReportingGroupQueryHookResult = ReturnType<typeof useGetBusinessUnitReportingGroupQuery>;
export type GetBusinessUnitReportingGroupLazyQuery_HookResult = ReturnType<typeof useGetBusinessUnitReportingGroupLazyQuery_>;
export type GetBusinessUnitReportingGroupSuspenseQuery_HookResult = ReturnType<typeof useGetBusinessUnitReportingGroupSuspenseQuery_>;
export type GetBusinessUnitReportingGroupQueryResult_ = Apollo.QueryResult<GetBusinessUnitReportingGroupQuery_, GetBusinessUnitReportingGroupQueryVariables_>;
export function refetchGetBusinessUnitReportingGroupQuery_(variables: GetBusinessUnitReportingGroupQueryVariables_) {
      return { query: GetBusinessUnitReportingGroupDocument_, variables: variables }
    }
export const UpdateBAssessmentsCompanyStructureDocument_ = gql`
    mutation updateBAssessmentsCompanyStructure($input: [BusinessUnitAssessment_insert_input!]!) {
  insert_BusinessUnitAssessment(
    objects: $input
    on_conflict: {constraint: BusinessUnitAssessment_pkey, update_columns: [orderIndex, reportingGroupId]}
  ) {
    affected_rows
    returning {
      id
      businessUnit {
        id
      }
    }
  }
}
    `;
export type UpdateBAssessmentsCompanyStructureMutationFn_ = Apollo.MutationFunction<UpdateBAssessmentsCompanyStructureMutation_, UpdateBAssessmentsCompanyStructureMutationVariables_>;

/**
 * __useUpdateBAssessmentsCompanyStructureMutation__
 *
 * To run a mutation, you first call `useUpdateBAssessmentsCompanyStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBAssessmentsCompanyStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBAssessmentsCompanyStructureMutation, { data, loading, error }] = useUpdateBAssessmentsCompanyStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBAssessmentsCompanyStructureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBAssessmentsCompanyStructureMutation_, UpdateBAssessmentsCompanyStructureMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBAssessmentsCompanyStructureMutation_, UpdateBAssessmentsCompanyStructureMutationVariables_>(UpdateBAssessmentsCompanyStructureDocument_, options);
      }
export type UpdateBAssessmentsCompanyStructureMutationHookResult = ReturnType<typeof useUpdateBAssessmentsCompanyStructureMutation>;
export type UpdateBAssessmentsCompanyStructureMutationResult_ = Apollo.MutationResult<UpdateBAssessmentsCompanyStructureMutation_>;
export type UpdateBAssessmentsCompanyStructureMutationOptions_ = Apollo.BaseMutationOptions<UpdateBAssessmentsCompanyStructureMutation_, UpdateBAssessmentsCompanyStructureMutationVariables_>;
export const UpsertBusinessUnitDocument_ = gql`
    mutation upsertBusinessUnit($businessUnit: BusinessUnit_insert_input!) {
  businessUnit: insert_BusinessUnit_one(
    object: $businessUnit
    on_conflict: {constraint: businessUnit_pkey, update_columns: [contactPersonId, description, name, labels]}
  ) {
    ...SimpleBusinessUnit
    bAssessments {
      id
      activityReports {
        id
      }
    }
  }
}
    ${SimpleBusinessUnitFragmentDoc_}`;
export type UpsertBusinessUnitMutationFn_ = Apollo.MutationFunction<UpsertBusinessUnitMutation_, UpsertBusinessUnitMutationVariables_>;

/**
 * __useUpsertBusinessUnitMutation__
 *
 * To run a mutation, you first call `useUpsertBusinessUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBusinessUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBusinessUnitMutation, { data, loading, error }] = useUpsertBusinessUnitMutation({
 *   variables: {
 *      businessUnit: // value for 'businessUnit'
 *   },
 * });
 */
export function useUpsertBusinessUnitMutation(baseOptions?: Apollo.MutationHookOptions<UpsertBusinessUnitMutation_, UpsertBusinessUnitMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertBusinessUnitMutation_, UpsertBusinessUnitMutationVariables_>(UpsertBusinessUnitDocument_, options);
      }
export type UpsertBusinessUnitMutationHookResult = ReturnType<typeof useUpsertBusinessUnitMutation>;
export type UpsertBusinessUnitMutationResult_ = Apollo.MutationResult<UpsertBusinessUnitMutation_>;
export type UpsertBusinessUnitMutationOptions_ = Apollo.BaseMutationOptions<UpsertBusinessUnitMutation_, UpsertBusinessUnitMutationVariables_>;
export const ToggleBusinessUnitInCAssessmentDocument_ = gql`
    mutation toggleBusinessUnitInCAssessment($cAssessmentId: uuid!, $businessUnitId: uuid!, $deletedAt: timestamptz) {
  insert_BusinessUnitAssessment_one(
    object: {cAssessmentId: $cAssessmentId, businessUnitId: $businessUnitId, deletedAt: $deletedAt}
    on_conflict: {constraint: BusinessUnitAssessment_cAssessmentId_businessUnitIdN_8db61b88_u, update_columns: [deletedAt]}
  ) {
    id
  }
}
    `;
export type ToggleBusinessUnitInCAssessmentMutationFn_ = Apollo.MutationFunction<ToggleBusinessUnitInCAssessmentMutation_, ToggleBusinessUnitInCAssessmentMutationVariables_>;

/**
 * __useToggleBusinessUnitInCAssessmentMutation__
 *
 * To run a mutation, you first call `useToggleBusinessUnitInCAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleBusinessUnitInCAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleBusinessUnitInCAssessmentMutation, { data, loading, error }] = useToggleBusinessUnitInCAssessmentMutation({
 *   variables: {
 *      cAssessmentId: // value for 'cAssessmentId'
 *      businessUnitId: // value for 'businessUnitId'
 *      deletedAt: // value for 'deletedAt'
 *   },
 * });
 */
export function useToggleBusinessUnitInCAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<ToggleBusinessUnitInCAssessmentMutation_, ToggleBusinessUnitInCAssessmentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleBusinessUnitInCAssessmentMutation_, ToggleBusinessUnitInCAssessmentMutationVariables_>(ToggleBusinessUnitInCAssessmentDocument_, options);
      }
export type ToggleBusinessUnitInCAssessmentMutationHookResult = ReturnType<typeof useToggleBusinessUnitInCAssessmentMutation>;
export type ToggleBusinessUnitInCAssessmentMutationResult_ = Apollo.MutationResult<ToggleBusinessUnitInCAssessmentMutation_>;
export type ToggleBusinessUnitInCAssessmentMutationOptions_ = Apollo.BaseMutationOptions<ToggleBusinessUnitInCAssessmentMutation_, ToggleBusinessUnitInCAssessmentMutationVariables_>;
export const DeleteBusinessUnitDocument_ = gql`
    mutation deleteBusinessUnit($id: uuid!, $deletedAt: timestamptz) {
  businessUnit: insert_BusinessUnit_one(
    object: {id: $id, deletedAt: $deletedAt}
    on_conflict: {constraint: businessUnit_pkey, update_columns: [deletedAt]}
  ) {
    ...SimpleBusinessUnit
    company {
      id
      businessUnits {
        id
      }
    }
  }
  insert_BusinessUnitAssessment_one(
    object: {businessUnitId: $id, deletedAt: $deletedAt}
    on_conflict: {constraint: BusinessUnitAssessment_cAssessmentId_businessUnitIdN_8db61b88_u, update_columns: [deletedAt]}
  ) {
    cAssessment {
      id
      bAssesssments {
        id
      }
    }
  }
}
    ${SimpleBusinessUnitFragmentDoc_}`;
export type DeleteBusinessUnitMutationFn_ = Apollo.MutationFunction<DeleteBusinessUnitMutation_, DeleteBusinessUnitMutationVariables_>;

/**
 * __useDeleteBusinessUnitMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessUnitMutation, { data, loading, error }] = useDeleteBusinessUnitMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deletedAt: // value for 'deletedAt'
 *   },
 * });
 */
export function useDeleteBusinessUnitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBusinessUnitMutation_, DeleteBusinessUnitMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBusinessUnitMutation_, DeleteBusinessUnitMutationVariables_>(DeleteBusinessUnitDocument_, options);
      }
export type DeleteBusinessUnitMutationHookResult = ReturnType<typeof useDeleteBusinessUnitMutation>;
export type DeleteBusinessUnitMutationResult_ = Apollo.MutationResult<DeleteBusinessUnitMutation_>;
export type DeleteBusinessUnitMutationOptions_ = Apollo.BaseMutationOptions<DeleteBusinessUnitMutation_, DeleteBusinessUnitMutationVariables_>;
export const UpdateHasGeneralAssessmentOnBusinessUnitDocument_ = gql`
    mutation updateHasGeneralAssessmentOnBusinessUnit($bAssessmentId: uuid!, $hasGeneralAssessment: Boolean!, $cAssessmentId: uuid!) {
  insert_BusinessUnitAssessment_one(
    object: {id: $bAssessmentId, hasGeneralAssessment: $hasGeneralAssessment, cAssessmentId: $cAssessmentId}
    on_conflict: {constraint: BusinessUnitAssessment_pkey, update_columns: [hasGeneralAssessment]}
  ) {
    id
    hasGeneralAssessment
  }
}
    `;
export type UpdateHasGeneralAssessmentOnBusinessUnitMutationFn_ = Apollo.MutationFunction<UpdateHasGeneralAssessmentOnBusinessUnitMutation_, UpdateHasGeneralAssessmentOnBusinessUnitMutationVariables_>;

/**
 * __useUpdateHasGeneralAssessmentOnBusinessUnitMutation__
 *
 * To run a mutation, you first call `useUpdateHasGeneralAssessmentOnBusinessUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHasGeneralAssessmentOnBusinessUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHasGeneralAssessmentOnBusinessUnitMutation, { data, loading, error }] = useUpdateHasGeneralAssessmentOnBusinessUnitMutation({
 *   variables: {
 *      bAssessmentId: // value for 'bAssessmentId'
 *      hasGeneralAssessment: // value for 'hasGeneralAssessment'
 *      cAssessmentId: // value for 'cAssessmentId'
 *   },
 * });
 */
export function useUpdateHasGeneralAssessmentOnBusinessUnitMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHasGeneralAssessmentOnBusinessUnitMutation_, UpdateHasGeneralAssessmentOnBusinessUnitMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHasGeneralAssessmentOnBusinessUnitMutation_, UpdateHasGeneralAssessmentOnBusinessUnitMutationVariables_>(UpdateHasGeneralAssessmentOnBusinessUnitDocument_, options);
      }
export type UpdateHasGeneralAssessmentOnBusinessUnitMutationHookResult = ReturnType<typeof useUpdateHasGeneralAssessmentOnBusinessUnitMutation>;
export type UpdateHasGeneralAssessmentOnBusinessUnitMutationResult_ = Apollo.MutationResult<UpdateHasGeneralAssessmentOnBusinessUnitMutation_>;
export type UpdateHasGeneralAssessmentOnBusinessUnitMutationOptions_ = Apollo.BaseMutationOptions<UpdateHasGeneralAssessmentOnBusinessUnitMutation_, UpdateHasGeneralAssessmentOnBusinessUnitMutationVariables_>;
export const UpsertBusinessUnitReportingGroupDocument_ = gql`
    mutation upsertBusinessUnitReportingGroup($businessUnitId: uuid!, $cAssessmentId: uuid!, $reportingGroupId: uuid) {
  insert_BusinessUnitAssessment_one(
    object: {reportingGroupId: $reportingGroupId, businessUnitId: $businessUnitId, cAssessmentId: $cAssessmentId}
    on_conflict: {constraint: BusinessUnitAssessment_cAssessmentId_businessUnitIdN_8db61b88_u, update_columns: [reportingGroupId]}
  ) {
    reportingGroupId
    id
    cAssessmentId
  }
}
    `;
export type UpsertBusinessUnitReportingGroupMutationFn_ = Apollo.MutationFunction<UpsertBusinessUnitReportingGroupMutation_, UpsertBusinessUnitReportingGroupMutationVariables_>;

/**
 * __useUpsertBusinessUnitReportingGroupMutation__
 *
 * To run a mutation, you first call `useUpsertBusinessUnitReportingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBusinessUnitReportingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBusinessUnitReportingGroupMutation, { data, loading, error }] = useUpsertBusinessUnitReportingGroupMutation({
 *   variables: {
 *      businessUnitId: // value for 'businessUnitId'
 *      cAssessmentId: // value for 'cAssessmentId'
 *      reportingGroupId: // value for 'reportingGroupId'
 *   },
 * });
 */
export function useUpsertBusinessUnitReportingGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpsertBusinessUnitReportingGroupMutation_, UpsertBusinessUnitReportingGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertBusinessUnitReportingGroupMutation_, UpsertBusinessUnitReportingGroupMutationVariables_>(UpsertBusinessUnitReportingGroupDocument_, options);
      }
export type UpsertBusinessUnitReportingGroupMutationHookResult = ReturnType<typeof useUpsertBusinessUnitReportingGroupMutation>;
export type UpsertBusinessUnitReportingGroupMutationResult_ = Apollo.MutationResult<UpsertBusinessUnitReportingGroupMutation_>;
export type UpsertBusinessUnitReportingGroupMutationOptions_ = Apollo.BaseMutationOptions<UpsertBusinessUnitReportingGroupMutation_, UpsertBusinessUnitReportingGroupMutationVariables_>;
export const GroupAssessmentsDocument_ = gql`
    query GroupAssessments($companyId: uuid!) {
  assessments: GroupAssessment(
    where: {companyId: {_eq: $companyId}, _and: {deletedAt: {_is_null: true}}}
  ) {
    ...GroupAssessmentFields
  }
}
    ${GroupAssessmentFieldsFragmentDoc_}`;

/**
 * __useGroupAssessmentsQuery__
 *
 * To run a query within a React component, call `useGroupAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupAssessmentsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGroupAssessmentsQuery(baseOptions: Apollo.QueryHookOptions<GroupAssessmentsQuery_, GroupAssessmentsQueryVariables_> & ({ variables: GroupAssessmentsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupAssessmentsQuery_, GroupAssessmentsQueryVariables_>(GroupAssessmentsDocument_, options);
      }
export function useGroupAssessmentsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GroupAssessmentsQuery_, GroupAssessmentsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupAssessmentsQuery_, GroupAssessmentsQueryVariables_>(GroupAssessmentsDocument_, options);
        }
export function useGroupAssessmentsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupAssessmentsQuery_, GroupAssessmentsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupAssessmentsQuery_, GroupAssessmentsQueryVariables_>(GroupAssessmentsDocument_, options);
        }
export type GroupAssessmentsQueryHookResult = ReturnType<typeof useGroupAssessmentsQuery>;
export type GroupAssessmentsLazyQuery_HookResult = ReturnType<typeof useGroupAssessmentsLazyQuery_>;
export type GroupAssessmentsSuspenseQuery_HookResult = ReturnType<typeof useGroupAssessmentsSuspenseQuery_>;
export type GroupAssessmentsQueryResult_ = Apollo.QueryResult<GroupAssessmentsQuery_, GroupAssessmentsQueryVariables_>;
export function refetchGroupAssessmentsQuery_(variables: GroupAssessmentsQueryVariables_) {
      return { query: GroupAssessmentsDocument_, variables: variables }
    }
export const GroupAssessmentDocument_ = gql`
    query GroupAssessment($assessmentId: uuid!) {
  assessment: GroupAssessment_by_pk(id: $assessmentId) {
    ...GroupAssessmentFields
    subsidiaries(where: {deletedAt: {_is_null: true}}) {
      id
      ...GroupAssessmentSubsidiariesFields
    }
  }
}
    ${GroupAssessmentFieldsFragmentDoc_}
${GroupAssessmentSubsidiariesFieldsFragmentDoc_}`;

/**
 * __useGroupAssessmentQuery__
 *
 * To run a query within a React component, call `useGroupAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupAssessmentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGroupAssessmentQuery(baseOptions: Apollo.QueryHookOptions<GroupAssessmentQuery_, GroupAssessmentQueryVariables_> & ({ variables: GroupAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupAssessmentQuery_, GroupAssessmentQueryVariables_>(GroupAssessmentDocument_, options);
      }
export function useGroupAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GroupAssessmentQuery_, GroupAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupAssessmentQuery_, GroupAssessmentQueryVariables_>(GroupAssessmentDocument_, options);
        }
export function useGroupAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupAssessmentQuery_, GroupAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupAssessmentQuery_, GroupAssessmentQueryVariables_>(GroupAssessmentDocument_, options);
        }
export type GroupAssessmentQueryHookResult = ReturnType<typeof useGroupAssessmentQuery>;
export type GroupAssessmentLazyQuery_HookResult = ReturnType<typeof useGroupAssessmentLazyQuery_>;
export type GroupAssessmentSuspenseQuery_HookResult = ReturnType<typeof useGroupAssessmentSuspenseQuery_>;
export type GroupAssessmentQueryResult_ = Apollo.QueryResult<GroupAssessmentQuery_, GroupAssessmentQueryVariables_>;
export function refetchGroupAssessmentQuery_(variables: GroupAssessmentQueryVariables_) {
      return { query: GroupAssessmentDocument_, variables: variables }
    }
export const GroupsDocument_ = gql`
    query Groups($companyId: uuid!) {
  groups: Subsidiary(
    where: {companyId: {_eq: $companyId}, ownerGroupAssessment: {deletedAt: {_is_null: true}}, deletedAt: {_is_null: true}}
  ) {
    id
    sharedCompanyAssessmentId
    ownerGroupAssessmentId
    ownerGroupAssessment {
      id
      name
      company {
        name
        logoUrl
      }
    }
  }
}
    `;

/**
 * __useGroupsQuery__
 *
 * To run a query within a React component, call `useGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGroupsQuery(baseOptions: Apollo.QueryHookOptions<GroupsQuery_, GroupsQueryVariables_> & ({ variables: GroupsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupsQuery_, GroupsQueryVariables_>(GroupsDocument_, options);
      }
export function useGroupsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GroupsQuery_, GroupsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupsQuery_, GroupsQueryVariables_>(GroupsDocument_, options);
        }
export function useGroupsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupsQuery_, GroupsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupsQuery_, GroupsQueryVariables_>(GroupsDocument_, options);
        }
export type GroupsQueryHookResult = ReturnType<typeof useGroupsQuery>;
export type GroupsLazyQuery_HookResult = ReturnType<typeof useGroupsLazyQuery_>;
export type GroupsSuspenseQuery_HookResult = ReturnType<typeof useGroupsSuspenseQuery_>;
export type GroupsQueryResult_ = Apollo.QueryResult<GroupsQuery_, GroupsQueryVariables_>;
export function refetchGroupsQuery_(variables: GroupsQueryVariables_) {
      return { query: GroupsDocument_, variables: variables }
    }
export const UpsertGroupAssessmentDocument_ = gql`
    mutation upsertGroupAssessment($assessmentInputs: GroupAssessment_insert_input!) {
  insert_GroupAssessment_one(
    object: $assessmentInputs
    on_conflict: {constraint: GroupAssessment_pkey, update_columns: [name, period]}
  ) {
    ...GroupAssessmentFields
  }
}
    ${GroupAssessmentFieldsFragmentDoc_}`;
export type UpsertGroupAssessmentMutationFn_ = Apollo.MutationFunction<UpsertGroupAssessmentMutation_, UpsertGroupAssessmentMutationVariables_>;

/**
 * __useUpsertGroupAssessmentMutation__
 *
 * To run a mutation, you first call `useUpsertGroupAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertGroupAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertGroupAssessmentMutation, { data, loading, error }] = useUpsertGroupAssessmentMutation({
 *   variables: {
 *      assessmentInputs: // value for 'assessmentInputs'
 *   },
 * });
 */
export function useUpsertGroupAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertGroupAssessmentMutation_, UpsertGroupAssessmentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertGroupAssessmentMutation_, UpsertGroupAssessmentMutationVariables_>(UpsertGroupAssessmentDocument_, options);
      }
export type UpsertGroupAssessmentMutationHookResult = ReturnType<typeof useUpsertGroupAssessmentMutation>;
export type UpsertGroupAssessmentMutationResult_ = Apollo.MutationResult<UpsertGroupAssessmentMutation_>;
export type UpsertGroupAssessmentMutationOptions_ = Apollo.BaseMutationOptions<UpsertGroupAssessmentMutation_, UpsertGroupAssessmentMutationVariables_>;
export const DeleteGroupAssessmentDocument_ = gql`
    mutation deleteGroupAssessment($id: uuid!, $deletedAt: timestamptz) {
  update_GroupAssessment_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: $deletedAt}
  ) {
    id
    deletedAt
  }
}
    `;
export type DeleteGroupAssessmentMutationFn_ = Apollo.MutationFunction<DeleteGroupAssessmentMutation_, DeleteGroupAssessmentMutationVariables_>;

/**
 * __useDeleteGroupAssessmentMutation__
 *
 * To run a mutation, you first call `useDeleteGroupAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGroupAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGroupAssessmentMutation, { data, loading, error }] = useDeleteGroupAssessmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      deletedAt: // value for 'deletedAt'
 *   },
 * });
 */
export function useDeleteGroupAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGroupAssessmentMutation_, DeleteGroupAssessmentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGroupAssessmentMutation_, DeleteGroupAssessmentMutationVariables_>(DeleteGroupAssessmentDocument_, options);
      }
export type DeleteGroupAssessmentMutationHookResult = ReturnType<typeof useDeleteGroupAssessmentMutation>;
export type DeleteGroupAssessmentMutationResult_ = Apollo.MutationResult<DeleteGroupAssessmentMutation_>;
export type DeleteGroupAssessmentMutationOptions_ = Apollo.BaseMutationOptions<DeleteGroupAssessmentMutation_, DeleteGroupAssessmentMutationVariables_>;
export const UpsertSubsidiaryDocument_ = gql`
    mutation upsertSubsidiary($subsidiary: Subsidiary_insert_input!) {
  insert_Subsidiary_one(
    object: $subsidiary
    on_conflict: {constraint: Subsidiary_pkey, update_columns: []}
  ) {
    id
  }
}
    `;
export type UpsertSubsidiaryMutationFn_ = Apollo.MutationFunction<UpsertSubsidiaryMutation_, UpsertSubsidiaryMutationVariables_>;

/**
 * __useUpsertSubsidiaryMutation__
 *
 * To run a mutation, you first call `useUpsertSubsidiaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSubsidiaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertSubsidiaryMutation, { data, loading, error }] = useUpsertSubsidiaryMutation({
 *   variables: {
 *      subsidiary: // value for 'subsidiary'
 *   },
 * });
 */
export function useUpsertSubsidiaryMutation(baseOptions?: Apollo.MutationHookOptions<UpsertSubsidiaryMutation_, UpsertSubsidiaryMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertSubsidiaryMutation_, UpsertSubsidiaryMutationVariables_>(UpsertSubsidiaryDocument_, options);
      }
export type UpsertSubsidiaryMutationHookResult = ReturnType<typeof useUpsertSubsidiaryMutation>;
export type UpsertSubsidiaryMutationResult_ = Apollo.MutationResult<UpsertSubsidiaryMutation_>;
export type UpsertSubsidiaryMutationOptions_ = Apollo.BaseMutationOptions<UpsertSubsidiaryMutation_, UpsertSubsidiaryMutationVariables_>;
export const UpdateGroupAssessmentResultsDocument_ = gql`
    mutation updateGroupAssessmentResults($groupAssessmentId: uuid!, $uploadedAt: date!, $deletedAt: timestamptz!, $consolidatedCsvId: uuid!, $consolidatedCompanyAssessmentId: uuid!, $bAssessments: BusinessUnitAssessment_arr_rel_insert_input!, $companyId: uuid!, $cachedResult: CachedResult_obj_rel_insert_input!, $aggregateId: uuid!, $nonMaterialFinancials: Financials_insert_input!) {
  update_BusinessUnitAssessment_many(
    updates: {where: {cAssessmentId: {_eq: $consolidatedCompanyAssessmentId}}, _set: {deletedAt: $deletedAt}}
  ) {
    affected_rows
  }
  update_ActivityReport_many(
    updates: {where: {bAssessment: {cAssessmentId: {_eq: $consolidatedCompanyAssessmentId}}}, _set: {deletedAt: $deletedAt}}
  ) {
    affected_rows
  }
  update_GroupAssessment_by_pk(
    pk_columns: {id: $groupAssessmentId}
    _set: {consolidatedCsvId: $consolidatedCsvId, uploadedAt: $uploadedAt}
  ) {
    id
  }
  insert_Financials_one(
    object: $nonMaterialFinancials
    on_conflict: {constraint: Financials_cAssessmentId_isMaterial_key, update_columns: [revenue, capex, opex]}
  ) {
    id
  }
  insert_CompanyAssessment(
    objects: {id: $consolidatedCompanyAssessmentId, startDate: "2023-04-18", endDate: "2023-04-18", aggregateId: $aggregateId, companyId: $companyId, bAssesssments: $bAssessments, cachedResult: $cachedResult}
    on_conflict: {constraint: companyAssessment_pkey, update_columns: [cachedResultId]}
  ) {
    affected_rows
  }
}
    `;
export type UpdateGroupAssessmentResultsMutationFn_ = Apollo.MutationFunction<UpdateGroupAssessmentResultsMutation_, UpdateGroupAssessmentResultsMutationVariables_>;

/**
 * __useUpdateGroupAssessmentResultsMutation__
 *
 * To run a mutation, you first call `useUpdateGroupAssessmentResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupAssessmentResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupAssessmentResultsMutation, { data, loading, error }] = useUpdateGroupAssessmentResultsMutation({
 *   variables: {
 *      groupAssessmentId: // value for 'groupAssessmentId'
 *      uploadedAt: // value for 'uploadedAt'
 *      deletedAt: // value for 'deletedAt'
 *      consolidatedCsvId: // value for 'consolidatedCsvId'
 *      consolidatedCompanyAssessmentId: // value for 'consolidatedCompanyAssessmentId'
 *      bAssessments: // value for 'bAssessments'
 *      companyId: // value for 'companyId'
 *      cachedResult: // value for 'cachedResult'
 *      aggregateId: // value for 'aggregateId'
 *      nonMaterialFinancials: // value for 'nonMaterialFinancials'
 *   },
 * });
 */
export function useUpdateGroupAssessmentResultsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupAssessmentResultsMutation_, UpdateGroupAssessmentResultsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupAssessmentResultsMutation_, UpdateGroupAssessmentResultsMutationVariables_>(UpdateGroupAssessmentResultsDocument_, options);
      }
export type UpdateGroupAssessmentResultsMutationHookResult = ReturnType<typeof useUpdateGroupAssessmentResultsMutation>;
export type UpdateGroupAssessmentResultsMutationResult_ = Apollo.MutationResult<UpdateGroupAssessmentResultsMutation_>;
export type UpdateGroupAssessmentResultsMutationOptions_ = Apollo.BaseMutationOptions<UpdateGroupAssessmentResultsMutation_, UpdateGroupAssessmentResultsMutationVariables_>;
export const ToggleShareCompanyAssessmentWithGroupDocument_ = gql`
    mutation toggleShareCompanyAssessmentWithGroup($object: Subsidiary_insert_input!) {
  insert_Subsidiary_one(
    object: $object
    on_conflict: {constraint: Subsidiary_pkey, update_columns: [sharedCompanyAssessmentId]}
  ) {
    id
    sharedCompanyAssessmentId
  }
}
    `;
export type ToggleShareCompanyAssessmentWithGroupMutationFn_ = Apollo.MutationFunction<ToggleShareCompanyAssessmentWithGroupMutation_, ToggleShareCompanyAssessmentWithGroupMutationVariables_>;

/**
 * __useToggleShareCompanyAssessmentWithGroupMutation__
 *
 * To run a mutation, you first call `useToggleShareCompanyAssessmentWithGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleShareCompanyAssessmentWithGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleShareCompanyAssessmentWithGroupMutation, { data, loading, error }] = useToggleShareCompanyAssessmentWithGroupMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useToggleShareCompanyAssessmentWithGroupMutation(baseOptions?: Apollo.MutationHookOptions<ToggleShareCompanyAssessmentWithGroupMutation_, ToggleShareCompanyAssessmentWithGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleShareCompanyAssessmentWithGroupMutation_, ToggleShareCompanyAssessmentWithGroupMutationVariables_>(ToggleShareCompanyAssessmentWithGroupDocument_, options);
      }
export type ToggleShareCompanyAssessmentWithGroupMutationHookResult = ReturnType<typeof useToggleShareCompanyAssessmentWithGroupMutation>;
export type ToggleShareCompanyAssessmentWithGroupMutationResult_ = Apollo.MutationResult<ToggleShareCompanyAssessmentWithGroupMutation_>;
export type ToggleShareCompanyAssessmentWithGroupMutationOptions_ = Apollo.BaseMutationOptions<ToggleShareCompanyAssessmentWithGroupMutation_, ToggleShareCompanyAssessmentWithGroupMutationVariables_>;
export const DeleteSubsidiaryDocument_ = gql`
    mutation deleteSubsidiary($id: uuid!) {
  update_Subsidiary_by_pk(pk_columns: {id: $id}, _set: {deletedAt: "now()"}) {
    deletedAt
  }
}
    `;
export type DeleteSubsidiaryMutationFn_ = Apollo.MutationFunction<DeleteSubsidiaryMutation_, DeleteSubsidiaryMutationVariables_>;

/**
 * __useDeleteSubsidiaryMutation__
 *
 * To run a mutation, you first call `useDeleteSubsidiaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubsidiaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubsidiaryMutation, { data, loading, error }] = useDeleteSubsidiaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSubsidiaryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubsidiaryMutation_, DeleteSubsidiaryMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSubsidiaryMutation_, DeleteSubsidiaryMutationVariables_>(DeleteSubsidiaryDocument_, options);
      }
export type DeleteSubsidiaryMutationHookResult = ReturnType<typeof useDeleteSubsidiaryMutation>;
export type DeleteSubsidiaryMutationResult_ = Apollo.MutationResult<DeleteSubsidiaryMutation_>;
export type DeleteSubsidiaryMutationOptions_ = Apollo.BaseMutationOptions<DeleteSubsidiaryMutation_, DeleteSubsidiaryMutationVariables_>;
export const UpdateGroupAssessmentLockDocument_ = gql`
    mutation updateGroupAssessmentLock($cAssessmentId: uuid!, $isLocked: Boolean!) {
  update_CompanyAssessment_by_pk(
    pk_columns: {id: $cAssessmentId}
    _set: {isLocked: $isLocked}
  ) {
    id
  }
}
    `;
export type UpdateGroupAssessmentLockMutationFn_ = Apollo.MutationFunction<UpdateGroupAssessmentLockMutation_, UpdateGroupAssessmentLockMutationVariables_>;

/**
 * __useUpdateGroupAssessmentLockMutation__
 *
 * To run a mutation, you first call `useUpdateGroupAssessmentLockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupAssessmentLockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupAssessmentLockMutation, { data, loading, error }] = useUpdateGroupAssessmentLockMutation({
 *   variables: {
 *      cAssessmentId: // value for 'cAssessmentId'
 *      isLocked: // value for 'isLocked'
 *   },
 * });
 */
export function useUpdateGroupAssessmentLockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupAssessmentLockMutation_, UpdateGroupAssessmentLockMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupAssessmentLockMutation_, UpdateGroupAssessmentLockMutationVariables_>(UpdateGroupAssessmentLockDocument_, options);
      }
export type UpdateGroupAssessmentLockMutationHookResult = ReturnType<typeof useUpdateGroupAssessmentLockMutation>;
export type UpdateGroupAssessmentLockMutationResult_ = Apollo.MutationResult<UpdateGroupAssessmentLockMutation_>;
export type UpdateGroupAssessmentLockMutationOptions_ = Apollo.BaseMutationOptions<UpdateGroupAssessmentLockMutation_, UpdateGroupAssessmentLockMutationVariables_>;
export const GetGroupConsolidatedAssessmentResultDocument_ = gql`
    query getGroupConsolidatedAssessmentResult($cAssessmentId: uuid!) {
  companyAssessment: CompanyAssessment_by_pk(id: $cAssessmentId) {
    ...CompanyAssessmentDetailsFields
    cachedResult {
      ...CachedResultFields
    }
    nonMaterialFinancials {
      ...NonMaterialFinancialsFields
    }
    generalAssessment: bAssesssments(where: {businessUnitId: {_is_null: true}}) {
      id
      generalAssessment: activityReports(where: {activityRef: {_eq: "0.0"}}) {
        id
        cachedResult {
          ...CachedResultFields
        }
      }
    }
    bAssessments: bAssesssments(
      where: {businessUnitId: {_is_null: false}, deletedAt: {_is_null: true}}
      order_by: {createdAt: asc}
    ) {
      ...BusinessUnitAssessmentFields
      activityReports(
        where: {deletedAt: {_is_null: true}, activityRef: {_neq: "0.0"}}
      ) {
        id
        activity {
          ...ActivityFields
        }
        bAssessmentId
        completedAt
        createdAt
        cachedResult {
          ...CachedResultFields
        }
      }
      generalAssessment: activityReports(where: {activityRef: {_eq: "0.0"}}) {
        id
        cachedResult {
          ...CachedResultFields
        }
      }
      cachedResult {
        ...CachedResultFields
      }
    }
  }
}
    ${CompanyAssessmentDetailsFieldsFragmentDoc_}
${CachedResultFieldsFragmentDoc_}
${NonMaterialFinancialsFieldsFragmentDoc_}
${BusinessUnitAssessmentFieldsFragmentDoc_}
${ActivityFieldsFragmentDoc_}`;

/**
 * __useGetGroupConsolidatedAssessmentResultQuery__
 *
 * To run a query within a React component, call `useGetGroupConsolidatedAssessmentResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupConsolidatedAssessmentResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupConsolidatedAssessmentResultQuery({
 *   variables: {
 *      cAssessmentId: // value for 'cAssessmentId'
 *   },
 * });
 */
export function useGetGroupConsolidatedAssessmentResultQuery(baseOptions: Apollo.QueryHookOptions<GetGroupConsolidatedAssessmentResultQuery_, GetGroupConsolidatedAssessmentResultQueryVariables_> & ({ variables: GetGroupConsolidatedAssessmentResultQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupConsolidatedAssessmentResultQuery_, GetGroupConsolidatedAssessmentResultQueryVariables_>(GetGroupConsolidatedAssessmentResultDocument_, options);
      }
export function useGetGroupConsolidatedAssessmentResultLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupConsolidatedAssessmentResultQuery_, GetGroupConsolidatedAssessmentResultQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupConsolidatedAssessmentResultQuery_, GetGroupConsolidatedAssessmentResultQueryVariables_>(GetGroupConsolidatedAssessmentResultDocument_, options);
        }
export function useGetGroupConsolidatedAssessmentResultSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupConsolidatedAssessmentResultQuery_, GetGroupConsolidatedAssessmentResultQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupConsolidatedAssessmentResultQuery_, GetGroupConsolidatedAssessmentResultQueryVariables_>(GetGroupConsolidatedAssessmentResultDocument_, options);
        }
export type GetGroupConsolidatedAssessmentResultQueryHookResult = ReturnType<typeof useGetGroupConsolidatedAssessmentResultQuery>;
export type GetGroupConsolidatedAssessmentResultLazyQuery_HookResult = ReturnType<typeof useGetGroupConsolidatedAssessmentResultLazyQuery_>;
export type GetGroupConsolidatedAssessmentResultSuspenseQuery_HookResult = ReturnType<typeof useGetGroupConsolidatedAssessmentResultSuspenseQuery_>;
export type GetGroupConsolidatedAssessmentResultQueryResult_ = Apollo.QueryResult<GetGroupConsolidatedAssessmentResultQuery_, GetGroupConsolidatedAssessmentResultQueryVariables_>;
export function refetchGetGroupConsolidatedAssessmentResultQuery_(variables: GetGroupConsolidatedAssessmentResultQueryVariables_) {
      return { query: GetGroupConsolidatedAssessmentResultDocument_, variables: variables }
    }
export const CompanyDetailsDocument_ = gql`
    query CompanyDetails($id: uuid) {
  company: Company(where: {id: {_eq: $id}}) {
    ...CompanyDetailsFields
  }
}
    ${CompanyDetailsFieldsFragmentDoc_}`;

/**
 * __useCompanyDetailsQuery__
 *
 * To run a query within a React component, call `useCompanyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyDetailsQuery(baseOptions?: Apollo.QueryHookOptions<CompanyDetailsQuery_, CompanyDetailsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyDetailsQuery_, CompanyDetailsQueryVariables_>(CompanyDetailsDocument_, options);
      }
export function useCompanyDetailsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompanyDetailsQuery_, CompanyDetailsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyDetailsQuery_, CompanyDetailsQueryVariables_>(CompanyDetailsDocument_, options);
        }
export function useCompanyDetailsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyDetailsQuery_, CompanyDetailsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyDetailsQuery_, CompanyDetailsQueryVariables_>(CompanyDetailsDocument_, options);
        }
export type CompanyDetailsQueryHookResult = ReturnType<typeof useCompanyDetailsQuery>;
export type CompanyDetailsLazyQuery_HookResult = ReturnType<typeof useCompanyDetailsLazyQuery_>;
export type CompanyDetailsSuspenseQuery_HookResult = ReturnType<typeof useCompanyDetailsSuspenseQuery_>;
export type CompanyDetailsQueryResult_ = Apollo.QueryResult<CompanyDetailsQuery_, CompanyDetailsQueryVariables_>;
export function refetchCompanyDetailsQuery_(variables?: CompanyDetailsQueryVariables_) {
      return { query: CompanyDetailsDocument_, variables: variables }
    }
export const CompanyInvitationsDocument_ = gql`
    query CompanyInvitations($id: uuid!) {
  invitations: CompanyInvitation(where: {companyId: {_eq: $id}}) {
    companyId
    id
    status
    userEmail
    user {
      ...ShortUser
    }
    role
  }
}
    ${ShortUserFragmentDoc_}`;

/**
 * __useCompanyInvitationsQuery__
 *
 * To run a query within a React component, call `useCompanyInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyInvitationsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyInvitationsQuery(baseOptions: Apollo.QueryHookOptions<CompanyInvitationsQuery_, CompanyInvitationsQueryVariables_> & ({ variables: CompanyInvitationsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyInvitationsQuery_, CompanyInvitationsQueryVariables_>(CompanyInvitationsDocument_, options);
      }
export function useCompanyInvitationsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompanyInvitationsQuery_, CompanyInvitationsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyInvitationsQuery_, CompanyInvitationsQueryVariables_>(CompanyInvitationsDocument_, options);
        }
export function useCompanyInvitationsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyInvitationsQuery_, CompanyInvitationsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyInvitationsQuery_, CompanyInvitationsQueryVariables_>(CompanyInvitationsDocument_, options);
        }
export type CompanyInvitationsQueryHookResult = ReturnType<typeof useCompanyInvitationsQuery>;
export type CompanyInvitationsLazyQuery_HookResult = ReturnType<typeof useCompanyInvitationsLazyQuery_>;
export type CompanyInvitationsSuspenseQuery_HookResult = ReturnType<typeof useCompanyInvitationsSuspenseQuery_>;
export type CompanyInvitationsQueryResult_ = Apollo.QueryResult<CompanyInvitationsQuery_, CompanyInvitationsQueryVariables_>;
export function refetchCompanyInvitationsQuery_(variables: CompanyInvitationsQueryVariables_) {
      return { query: CompanyInvitationsDocument_, variables: variables }
    }
export const CompanyUsersDocument_ = gql`
    query CompanyUsers($id: uuid!) {
  users(where: {companyUsers: {companyId: {_eq: $id}}}) {
    id
    email
    displayName
    avatarUrl
    roles {
      role
    }
    companyUsers(where: {companyId: {_eq: $id}}) {
      role
    }
    disabled
  }
}
    `;

/**
 * __useCompanyUsersQuery__
 *
 * To run a query within a React component, call `useCompanyUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyUsersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCompanyUsersQuery(baseOptions: Apollo.QueryHookOptions<CompanyUsersQuery_, CompanyUsersQueryVariables_> & ({ variables: CompanyUsersQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyUsersQuery_, CompanyUsersQueryVariables_>(CompanyUsersDocument_, options);
      }
export function useCompanyUsersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompanyUsersQuery_, CompanyUsersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyUsersQuery_, CompanyUsersQueryVariables_>(CompanyUsersDocument_, options);
        }
export function useCompanyUsersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyUsersQuery_, CompanyUsersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyUsersQuery_, CompanyUsersQueryVariables_>(CompanyUsersDocument_, options);
        }
export type CompanyUsersQueryHookResult = ReturnType<typeof useCompanyUsersQuery>;
export type CompanyUsersLazyQuery_HookResult = ReturnType<typeof useCompanyUsersLazyQuery_>;
export type CompanyUsersSuspenseQuery_HookResult = ReturnType<typeof useCompanyUsersSuspenseQuery_>;
export type CompanyUsersQueryResult_ = Apollo.QueryResult<CompanyUsersQuery_, CompanyUsersQueryVariables_>;
export function refetchCompanyUsersQuery_(variables: CompanyUsersQueryVariables_) {
      return { query: CompanyUsersDocument_, variables: variables }
    }
export const GetReportsDocument_ = gql`
    query getReports($companyId: uuid!) {
  taxonomyReports: CompanyAssessment(
    where: {companyId: {_eq: $companyId}, _and: {deletedAt: {_is_null: true}}}
    order_by: {updatedAt: desc}
  ) {
    id
    aggregate {
      title
    }
    cachedResult {
      progress
    }
    isLocked
    startDate
    bAssesssments {
      updatedAt
      activityReports {
        answers(limit: 1, order_by: {updatedAt: asc}) {
          updatedAt
        }
      }
      lastEditedFinancials: activityReports(
        limit: 1
        order_by: {financials: {updatedAt: asc}}
      ) {
        financials {
          updatedAt
        }
      }
    }
    updatedAt
  }
  groupTaxonomyReports: GroupAssessment(
    where: {companyId: {_eq: $companyId}, _and: {deletedAt: {_is_null: true}}}
    order_by: {updatedAt: desc}
  ) {
    id
    name
    consolidatedCompanyAssessment {
      startDate
      isLocked
      bAssesssments {
        updatedAt
        activityReports {
          answers(limit: 1, order_by: {updatedAt: asc}) {
            updatedAt
          }
        }
        lastEditedFinancials: activityReports(
          limit: 1
          order_by: {financials: {updatedAt: asc}}
        ) {
          financials {
            updatedAt
          }
        }
      }
      updatedAt
    }
  }
  paiCompanyReports: PaiCompanyReport(where: {companyId: {_eq: $companyId}}) {
    id
    period
    year
    updatedAt
    answers {
      data
      investeeMetricReference
    }
    lastEditedAnswer: answers(limit: 1, order_by: {updatedAt: asc}) {
      updatedAt
    }
  }
  paiCompanyRequests: PaiPortfolioReport(
    where: {portfolio: {portfolioCompanies: {companyId: {_eq: $companyId}}}}
  ) {
    year
    selectedIndicators(
      where: {_or: [{isForAllCompanies: {_eq: true}}, {paiReportIndicatorPortfolioCompanies: {portfolioCompany: {companyId: {_eq: $companyId}}}}]}
    ) {
      periods
      indicator {
        investorMetrics {
          investorMetric {
            investeeMetrics {
              investeeMetricReference
            }
          }
        }
      }
    }
  }
  sustainabilityReportingAssessments: EsrsAssessment(
    where: {companyId: {_eq: $companyId}, deletedAt: {_is_null: true}}
  ) {
    id
    reportingYear
    frameworkRef
    updatedAt
    latestMaterialMetricUpdate
    latestDatapointUpdate
  }
}
    `;

/**
 * __useGetReportsQuery__
 *
 * To run a query within a React component, call `useGetReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetReportsQuery(baseOptions: Apollo.QueryHookOptions<GetReportsQuery_, GetReportsQueryVariables_> & ({ variables: GetReportsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportsQuery_, GetReportsQueryVariables_>(GetReportsDocument_, options);
      }
export function useGetReportsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetReportsQuery_, GetReportsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportsQuery_, GetReportsQueryVariables_>(GetReportsDocument_, options);
        }
export function useGetReportsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportsQuery_, GetReportsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportsQuery_, GetReportsQueryVariables_>(GetReportsDocument_, options);
        }
export type GetReportsQueryHookResult = ReturnType<typeof useGetReportsQuery>;
export type GetReportsLazyQuery_HookResult = ReturnType<typeof useGetReportsLazyQuery_>;
export type GetReportsSuspenseQuery_HookResult = ReturnType<typeof useGetReportsSuspenseQuery_>;
export type GetReportsQueryResult_ = Apollo.QueryResult<GetReportsQuery_, GetReportsQueryVariables_>;
export function refetchGetReportsQuery_(variables: GetReportsQueryVariables_) {
      return { query: GetReportsDocument_, variables: variables }
    }
export const GetPaiRequestersDocument_ = gql`
    query getPAIRequesters($companyId: uuid!) {
  requesters: PaiPortfolioReport(
    where: {portfolio: {portfolioCompanies: {companyId: {_eq: $companyId}}}}
  ) {
    portfolio {
      ownerCompany {
        id
        name
        logoUrl
      }
    }
  }
}
    `;

/**
 * __useGetPaiRequestersQuery__
 *
 * To run a query within a React component, call `useGetPaiRequestersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaiRequestersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaiRequestersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetPaiRequestersQuery(baseOptions: Apollo.QueryHookOptions<GetPaiRequestersQuery_, GetPaiRequestersQueryVariables_> & ({ variables: GetPaiRequestersQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaiRequestersQuery_, GetPaiRequestersQueryVariables_>(GetPaiRequestersDocument_, options);
      }
export function useGetPaiRequestersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetPaiRequestersQuery_, GetPaiRequestersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaiRequestersQuery_, GetPaiRequestersQueryVariables_>(GetPaiRequestersDocument_, options);
        }
export function useGetPaiRequestersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaiRequestersQuery_, GetPaiRequestersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaiRequestersQuery_, GetPaiRequestersQueryVariables_>(GetPaiRequestersDocument_, options);
        }
export type GetPaiRequestersQueryHookResult = ReturnType<typeof useGetPaiRequestersQuery>;
export type GetPaiRequestersLazyQuery_HookResult = ReturnType<typeof useGetPaiRequestersLazyQuery_>;
export type GetPaiRequestersSuspenseQuery_HookResult = ReturnType<typeof useGetPaiRequestersSuspenseQuery_>;
export type GetPaiRequestersQueryResult_ = Apollo.QueryResult<GetPaiRequestersQuery_, GetPaiRequestersQueryVariables_>;
export function refetchGetPaiRequestersQuery_(variables: GetPaiRequestersQueryVariables_) {
      return { query: GetPaiRequestersDocument_, variables: variables }
    }
export const UpsertCompanyUserDocument_ = gql`
    mutation upsertCompanyUser($companyUser: CompanyUser_insert_input!) {
  companyUser: insert_CompanyUser_one(
    object: $companyUser
    on_conflict: {constraint: CompanyUser_companyId_userId_10e185ba_uniq, update_columns: [role]}
  ) {
    id
    role
    user {
      id
      companyUsers {
        id
        companyId
      }
    }
    company {
      ...CompanyDetailsFields
    }
  }
}
    ${CompanyDetailsFieldsFragmentDoc_}`;
export type UpsertCompanyUserMutationFn_ = Apollo.MutationFunction<UpsertCompanyUserMutation_, UpsertCompanyUserMutationVariables_>;

/**
 * __useUpsertCompanyUserMutation__
 *
 * To run a mutation, you first call `useUpsertCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCompanyUserMutation, { data, loading, error }] = useUpsertCompanyUserMutation({
 *   variables: {
 *      companyUser: // value for 'companyUser'
 *   },
 * });
 */
export function useUpsertCompanyUserMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCompanyUserMutation_, UpsertCompanyUserMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCompanyUserMutation_, UpsertCompanyUserMutationVariables_>(UpsertCompanyUserDocument_, options);
      }
export type UpsertCompanyUserMutationHookResult = ReturnType<typeof useUpsertCompanyUserMutation>;
export type UpsertCompanyUserMutationResult_ = Apollo.MutationResult<UpsertCompanyUserMutation_>;
export type UpsertCompanyUserMutationOptions_ = Apollo.BaseMutationOptions<UpsertCompanyUserMutation_, UpsertCompanyUserMutationVariables_>;
export const UpdateCompanyDocument_ = gql`
    mutation updateCompany($company: Company_insert_input!) {
  company: insert_Company_one(
    object: $company
    on_conflict: {constraint: company_pkey, update_columns: [settings, name, currency, logoUrl]}
  ) {
    name
  }
}
    `;
export type UpdateCompanyMutationFn_ = Apollo.MutationFunction<UpdateCompanyMutation_, UpdateCompanyMutationVariables_>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      company: // value for 'company'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation_, UpdateCompanyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation_, UpdateCompanyMutationVariables_>(UpdateCompanyDocument_, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult_ = Apollo.MutationResult<UpdateCompanyMutation_>;
export type UpdateCompanyMutationOptions_ = Apollo.BaseMutationOptions<UpdateCompanyMutation_, UpdateCompanyMutationVariables_>;
export const GetAnswerDocumentationByIdDocument_ = gql`
    query getAnswerDocumentationById($answerId: uuid!) {
  Answer_by_pk(id: $answerId) {
    ...AnswerDocumentation
  }
}
    ${AnswerDocumentationFragmentDoc_}`;

/**
 * __useGetAnswerDocumentationByIdQuery__
 *
 * To run a query within a React component, call `useGetAnswerDocumentationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswerDocumentationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswerDocumentationByIdQuery({
 *   variables: {
 *      answerId: // value for 'answerId'
 *   },
 * });
 */
export function useGetAnswerDocumentationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetAnswerDocumentationByIdQuery_, GetAnswerDocumentationByIdQueryVariables_> & ({ variables: GetAnswerDocumentationByIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnswerDocumentationByIdQuery_, GetAnswerDocumentationByIdQueryVariables_>(GetAnswerDocumentationByIdDocument_, options);
      }
export function useGetAnswerDocumentationByIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAnswerDocumentationByIdQuery_, GetAnswerDocumentationByIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnswerDocumentationByIdQuery_, GetAnswerDocumentationByIdQueryVariables_>(GetAnswerDocumentationByIdDocument_, options);
        }
export function useGetAnswerDocumentationByIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnswerDocumentationByIdQuery_, GetAnswerDocumentationByIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnswerDocumentationByIdQuery_, GetAnswerDocumentationByIdQueryVariables_>(GetAnswerDocumentationByIdDocument_, options);
        }
export type GetAnswerDocumentationByIdQueryHookResult = ReturnType<typeof useGetAnswerDocumentationByIdQuery>;
export type GetAnswerDocumentationByIdLazyQuery_HookResult = ReturnType<typeof useGetAnswerDocumentationByIdLazyQuery_>;
export type GetAnswerDocumentationByIdSuspenseQuery_HookResult = ReturnType<typeof useGetAnswerDocumentationByIdSuspenseQuery_>;
export type GetAnswerDocumentationByIdQueryResult_ = Apollo.QueryResult<GetAnswerDocumentationByIdQuery_, GetAnswerDocumentationByIdQueryVariables_>;
export function refetchGetAnswerDocumentationByIdQuery_(variables: GetAnswerDocumentationByIdQueryVariables_) {
      return { query: GetAnswerDocumentationByIdDocument_, variables: variables }
    }
export const GetActivityDocumentationDocument_ = gql`
    query getActivityDocumentation($activityReportId: uuid!) {
  ActivityReport_by_pk(id: $activityReportId) {
    ...ActivityDocumentation
  }
}
    ${ActivityDocumentationFragmentDoc_}`;

/**
 * __useGetActivityDocumentationQuery__
 *
 * To run a query within a React component, call `useGetActivityDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityDocumentationQuery({
 *   variables: {
 *      activityReportId: // value for 'activityReportId'
 *   },
 * });
 */
export function useGetActivityDocumentationQuery(baseOptions: Apollo.QueryHookOptions<GetActivityDocumentationQuery_, GetActivityDocumentationQueryVariables_> & ({ variables: GetActivityDocumentationQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityDocumentationQuery_, GetActivityDocumentationQueryVariables_>(GetActivityDocumentationDocument_, options);
      }
export function useGetActivityDocumentationLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityDocumentationQuery_, GetActivityDocumentationQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityDocumentationQuery_, GetActivityDocumentationQueryVariables_>(GetActivityDocumentationDocument_, options);
        }
export function useGetActivityDocumentationSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityDocumentationQuery_, GetActivityDocumentationQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivityDocumentationQuery_, GetActivityDocumentationQueryVariables_>(GetActivityDocumentationDocument_, options);
        }
export type GetActivityDocumentationQueryHookResult = ReturnType<typeof useGetActivityDocumentationQuery>;
export type GetActivityDocumentationLazyQuery_HookResult = ReturnType<typeof useGetActivityDocumentationLazyQuery_>;
export type GetActivityDocumentationSuspenseQuery_HookResult = ReturnType<typeof useGetActivityDocumentationSuspenseQuery_>;
export type GetActivityDocumentationQueryResult_ = Apollo.QueryResult<GetActivityDocumentationQuery_, GetActivityDocumentationQueryVariables_>;
export function refetchGetActivityDocumentationQuery_(variables: GetActivityDocumentationQueryVariables_) {
      return { query: GetActivityDocumentationDocument_, variables: variables }
    }
export const GetFinancialsDocumentationByIdDocument_ = gql`
    query getFinancialsDocumentationById($financialsId: uuid!) {
  Financials_by_pk(id: $financialsId) {
    id
    ...FinancialsDocumentation
  }
}
    ${FinancialsDocumentationFragmentDoc_}`;

/**
 * __useGetFinancialsDocumentationByIdQuery__
 *
 * To run a query within a React component, call `useGetFinancialsDocumentationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialsDocumentationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialsDocumentationByIdQuery({
 *   variables: {
 *      financialsId: // value for 'financialsId'
 *   },
 * });
 */
export function useGetFinancialsDocumentationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetFinancialsDocumentationByIdQuery_, GetFinancialsDocumentationByIdQueryVariables_> & ({ variables: GetFinancialsDocumentationByIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialsDocumentationByIdQuery_, GetFinancialsDocumentationByIdQueryVariables_>(GetFinancialsDocumentationByIdDocument_, options);
      }
export function useGetFinancialsDocumentationByIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialsDocumentationByIdQuery_, GetFinancialsDocumentationByIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialsDocumentationByIdQuery_, GetFinancialsDocumentationByIdQueryVariables_>(GetFinancialsDocumentationByIdDocument_, options);
        }
export function useGetFinancialsDocumentationByIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFinancialsDocumentationByIdQuery_, GetFinancialsDocumentationByIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFinancialsDocumentationByIdQuery_, GetFinancialsDocumentationByIdQueryVariables_>(GetFinancialsDocumentationByIdDocument_, options);
        }
export type GetFinancialsDocumentationByIdQueryHookResult = ReturnType<typeof useGetFinancialsDocumentationByIdQuery>;
export type GetFinancialsDocumentationByIdLazyQuery_HookResult = ReturnType<typeof useGetFinancialsDocumentationByIdLazyQuery_>;
export type GetFinancialsDocumentationByIdSuspenseQuery_HookResult = ReturnType<typeof useGetFinancialsDocumentationByIdSuspenseQuery_>;
export type GetFinancialsDocumentationByIdQueryResult_ = Apollo.QueryResult<GetFinancialsDocumentationByIdQuery_, GetFinancialsDocumentationByIdQueryVariables_>;
export function refetchGetFinancialsDocumentationByIdQuery_(variables: GetFinancialsDocumentationByIdQueryVariables_) {
      return { query: GetFinancialsDocumentationByIdDocument_, variables: variables }
    }
export const GetPaiAnswerDocumentationByIdDocument_ = gql`
    query getPaiAnswerDocumentationById($answerId: uuid!) {
  PaiAnswers_by_pk(id: $answerId) {
    id
    ...PaiAnswerDocumentation
  }
}
    ${PaiAnswerDocumentationFragmentDoc_}`;

/**
 * __useGetPaiAnswerDocumentationByIdQuery__
 *
 * To run a query within a React component, call `useGetPaiAnswerDocumentationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaiAnswerDocumentationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaiAnswerDocumentationByIdQuery({
 *   variables: {
 *      answerId: // value for 'answerId'
 *   },
 * });
 */
export function useGetPaiAnswerDocumentationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPaiAnswerDocumentationByIdQuery_, GetPaiAnswerDocumentationByIdQueryVariables_> & ({ variables: GetPaiAnswerDocumentationByIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaiAnswerDocumentationByIdQuery_, GetPaiAnswerDocumentationByIdQueryVariables_>(GetPaiAnswerDocumentationByIdDocument_, options);
      }
export function useGetPaiAnswerDocumentationByIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetPaiAnswerDocumentationByIdQuery_, GetPaiAnswerDocumentationByIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaiAnswerDocumentationByIdQuery_, GetPaiAnswerDocumentationByIdQueryVariables_>(GetPaiAnswerDocumentationByIdDocument_, options);
        }
export function useGetPaiAnswerDocumentationByIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaiAnswerDocumentationByIdQuery_, GetPaiAnswerDocumentationByIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaiAnswerDocumentationByIdQuery_, GetPaiAnswerDocumentationByIdQueryVariables_>(GetPaiAnswerDocumentationByIdDocument_, options);
        }
export type GetPaiAnswerDocumentationByIdQueryHookResult = ReturnType<typeof useGetPaiAnswerDocumentationByIdQuery>;
export type GetPaiAnswerDocumentationByIdLazyQuery_HookResult = ReturnType<typeof useGetPaiAnswerDocumentationByIdLazyQuery_>;
export type GetPaiAnswerDocumentationByIdSuspenseQuery_HookResult = ReturnType<typeof useGetPaiAnswerDocumentationByIdSuspenseQuery_>;
export type GetPaiAnswerDocumentationByIdQueryResult_ = Apollo.QueryResult<GetPaiAnswerDocumentationByIdQuery_, GetPaiAnswerDocumentationByIdQueryVariables_>;
export function refetchGetPaiAnswerDocumentationByIdQuery_(variables: GetPaiAnswerDocumentationByIdQueryVariables_) {
      return { query: GetPaiAnswerDocumentationByIdDocument_, variables: variables }
    }
export const GetPoliciesDocumentationByIdDocument_ = gql`
    query getPoliciesDocumentationById($policyId: uuid!) {
  esrs_Policy_by_pk(id: $policyId) {
    id
    ...PolicyDocumentation
  }
}
    ${PolicyDocumentationFragmentDoc_}`;

/**
 * __useGetPoliciesDocumentationByIdQuery__
 *
 * To run a query within a React component, call `useGetPoliciesDocumentationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPoliciesDocumentationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPoliciesDocumentationByIdQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useGetPoliciesDocumentationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetPoliciesDocumentationByIdQuery_, GetPoliciesDocumentationByIdQueryVariables_> & ({ variables: GetPoliciesDocumentationByIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPoliciesDocumentationByIdQuery_, GetPoliciesDocumentationByIdQueryVariables_>(GetPoliciesDocumentationByIdDocument_, options);
      }
export function useGetPoliciesDocumentationByIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetPoliciesDocumentationByIdQuery_, GetPoliciesDocumentationByIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPoliciesDocumentationByIdQuery_, GetPoliciesDocumentationByIdQueryVariables_>(GetPoliciesDocumentationByIdDocument_, options);
        }
export function useGetPoliciesDocumentationByIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPoliciesDocumentationByIdQuery_, GetPoliciesDocumentationByIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPoliciesDocumentationByIdQuery_, GetPoliciesDocumentationByIdQueryVariables_>(GetPoliciesDocumentationByIdDocument_, options);
        }
export type GetPoliciesDocumentationByIdQueryHookResult = ReturnType<typeof useGetPoliciesDocumentationByIdQuery>;
export type GetPoliciesDocumentationByIdLazyQuery_HookResult = ReturnType<typeof useGetPoliciesDocumentationByIdLazyQuery_>;
export type GetPoliciesDocumentationByIdSuspenseQuery_HookResult = ReturnType<typeof useGetPoliciesDocumentationByIdSuspenseQuery_>;
export type GetPoliciesDocumentationByIdQueryResult_ = Apollo.QueryResult<GetPoliciesDocumentationByIdQuery_, GetPoliciesDocumentationByIdQueryVariables_>;
export function refetchGetPoliciesDocumentationByIdQuery_(variables: GetPoliciesDocumentationByIdQueryVariables_) {
      return { query: GetPoliciesDocumentationByIdDocument_, variables: variables }
    }
export const GetMetricAnswerDocumentationByIdDocument_ = gql`
    query getMetricAnswerDocumentationById($metricAnswerId: uuid!) {
  esrs_Answer_by_pk(id: $metricAnswerId) {
    id
    ...MetricAnswerDocumentation
  }
}
    ${MetricAnswerDocumentationFragmentDoc_}`;

/**
 * __useGetMetricAnswerDocumentationByIdQuery__
 *
 * To run a query within a React component, call `useGetMetricAnswerDocumentationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricAnswerDocumentationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricAnswerDocumentationByIdQuery({
 *   variables: {
 *      metricAnswerId: // value for 'metricAnswerId'
 *   },
 * });
 */
export function useGetMetricAnswerDocumentationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMetricAnswerDocumentationByIdQuery_, GetMetricAnswerDocumentationByIdQueryVariables_> & ({ variables: GetMetricAnswerDocumentationByIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricAnswerDocumentationByIdQuery_, GetMetricAnswerDocumentationByIdQueryVariables_>(GetMetricAnswerDocumentationByIdDocument_, options);
      }
export function useGetMetricAnswerDocumentationByIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricAnswerDocumentationByIdQuery_, GetMetricAnswerDocumentationByIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricAnswerDocumentationByIdQuery_, GetMetricAnswerDocumentationByIdQueryVariables_>(GetMetricAnswerDocumentationByIdDocument_, options);
        }
export function useGetMetricAnswerDocumentationByIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricAnswerDocumentationByIdQuery_, GetMetricAnswerDocumentationByIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricAnswerDocumentationByIdQuery_, GetMetricAnswerDocumentationByIdQueryVariables_>(GetMetricAnswerDocumentationByIdDocument_, options);
        }
export type GetMetricAnswerDocumentationByIdQueryHookResult = ReturnType<typeof useGetMetricAnswerDocumentationByIdQuery>;
export type GetMetricAnswerDocumentationByIdLazyQuery_HookResult = ReturnType<typeof useGetMetricAnswerDocumentationByIdLazyQuery_>;
export type GetMetricAnswerDocumentationByIdSuspenseQuery_HookResult = ReturnType<typeof useGetMetricAnswerDocumentationByIdSuspenseQuery_>;
export type GetMetricAnswerDocumentationByIdQueryResult_ = Apollo.QueryResult<GetMetricAnswerDocumentationByIdQuery_, GetMetricAnswerDocumentationByIdQueryVariables_>;
export function refetchGetMetricAnswerDocumentationByIdQuery_(variables: GetMetricAnswerDocumentationByIdQueryVariables_) {
      return { query: GetMetricAnswerDocumentationByIdDocument_, variables: variables }
    }
export const GetActionDocumentationByIdDocument_ = gql`
    query getActionDocumentationById($actionId: uuid!) {
  esrs_Actions_by_pk(id: $actionId) {
    id
    ...ActionDocumentation
  }
}
    ${ActionDocumentationFragmentDoc_}`;

/**
 * __useGetActionDocumentationByIdQuery__
 *
 * To run a query within a React component, call `useGetActionDocumentationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionDocumentationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionDocumentationByIdQuery({
 *   variables: {
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useGetActionDocumentationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetActionDocumentationByIdQuery_, GetActionDocumentationByIdQueryVariables_> & ({ variables: GetActionDocumentationByIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionDocumentationByIdQuery_, GetActionDocumentationByIdQueryVariables_>(GetActionDocumentationByIdDocument_, options);
      }
export function useGetActionDocumentationByIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetActionDocumentationByIdQuery_, GetActionDocumentationByIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionDocumentationByIdQuery_, GetActionDocumentationByIdQueryVariables_>(GetActionDocumentationByIdDocument_, options);
        }
export function useGetActionDocumentationByIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActionDocumentationByIdQuery_, GetActionDocumentationByIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionDocumentationByIdQuery_, GetActionDocumentationByIdQueryVariables_>(GetActionDocumentationByIdDocument_, options);
        }
export type GetActionDocumentationByIdQueryHookResult = ReturnType<typeof useGetActionDocumentationByIdQuery>;
export type GetActionDocumentationByIdLazyQuery_HookResult = ReturnType<typeof useGetActionDocumentationByIdLazyQuery_>;
export type GetActionDocumentationByIdSuspenseQuery_HookResult = ReturnType<typeof useGetActionDocumentationByIdSuspenseQuery_>;
export type GetActionDocumentationByIdQueryResult_ = Apollo.QueryResult<GetActionDocumentationByIdQuery_, GetActionDocumentationByIdQueryVariables_>;
export function refetchGetActionDocumentationByIdQuery_(variables: GetActionDocumentationByIdQueryVariables_) {
      return { query: GetActionDocumentationByIdDocument_, variables: variables }
    }
export const GetDisclosureRequirementAttachmentDocument_ = gql`
    query getDisclosureRequirementAttachment($disclosureRequirementRef: String!, $materialStandardId: uuid!, $reportingUnitId: uuid!) {
  esrs_DisclosureRequirementAttachment(
    where: {disclosureRequirementRef: {_eq: $disclosureRequirementRef}, materialStandardId: {_eq: $materialStandardId}, reportingUnitId: {_eq: $reportingUnitId}}
  ) {
    id
    ...DisclosureRequirementAttachmentDocumentation
  }
}
    ${DisclosureRequirementAttachmentDocumentationFragmentDoc_}`;

/**
 * __useGetDisclosureRequirementAttachmentQuery__
 *
 * To run a query within a React component, call `useGetDisclosureRequirementAttachmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisclosureRequirementAttachmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisclosureRequirementAttachmentQuery({
 *   variables: {
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *      materialStandardId: // value for 'materialStandardId'
 *      reportingUnitId: // value for 'reportingUnitId'
 *   },
 * });
 */
export function useGetDisclosureRequirementAttachmentQuery(baseOptions: Apollo.QueryHookOptions<GetDisclosureRequirementAttachmentQuery_, GetDisclosureRequirementAttachmentQueryVariables_> & ({ variables: GetDisclosureRequirementAttachmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisclosureRequirementAttachmentQuery_, GetDisclosureRequirementAttachmentQueryVariables_>(GetDisclosureRequirementAttachmentDocument_, options);
      }
export function useGetDisclosureRequirementAttachmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDisclosureRequirementAttachmentQuery_, GetDisclosureRequirementAttachmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisclosureRequirementAttachmentQuery_, GetDisclosureRequirementAttachmentQueryVariables_>(GetDisclosureRequirementAttachmentDocument_, options);
        }
export function useGetDisclosureRequirementAttachmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDisclosureRequirementAttachmentQuery_, GetDisclosureRequirementAttachmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDisclosureRequirementAttachmentQuery_, GetDisclosureRequirementAttachmentQueryVariables_>(GetDisclosureRequirementAttachmentDocument_, options);
        }
export type GetDisclosureRequirementAttachmentQueryHookResult = ReturnType<typeof useGetDisclosureRequirementAttachmentQuery>;
export type GetDisclosureRequirementAttachmentLazyQuery_HookResult = ReturnType<typeof useGetDisclosureRequirementAttachmentLazyQuery_>;
export type GetDisclosureRequirementAttachmentSuspenseQuery_HookResult = ReturnType<typeof useGetDisclosureRequirementAttachmentSuspenseQuery_>;
export type GetDisclosureRequirementAttachmentQueryResult_ = Apollo.QueryResult<GetDisclosureRequirementAttachmentQuery_, GetDisclosureRequirementAttachmentQueryVariables_>;
export function refetchGetDisclosureRequirementAttachmentQuery_(variables: GetDisclosureRequirementAttachmentQueryVariables_) {
      return { query: GetDisclosureRequirementAttachmentDocument_, variables: variables }
    }
export const GetTargetDocumentationByIdDocument_ = gql`
    query getTargetDocumentationById($targetId: uuid!) {
  esrs_Target_by_pk(id: $targetId) {
    id
    ...TargetDocumentation
  }
}
    ${TargetDocumentationFragmentDoc_}`;

/**
 * __useGetTargetDocumentationByIdQuery__
 *
 * To run a query within a React component, call `useGetTargetDocumentationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetDocumentationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetDocumentationByIdQuery({
 *   variables: {
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useGetTargetDocumentationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTargetDocumentationByIdQuery_, GetTargetDocumentationByIdQueryVariables_> & ({ variables: GetTargetDocumentationByIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTargetDocumentationByIdQuery_, GetTargetDocumentationByIdQueryVariables_>(GetTargetDocumentationByIdDocument_, options);
      }
export function useGetTargetDocumentationByIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetTargetDocumentationByIdQuery_, GetTargetDocumentationByIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTargetDocumentationByIdQuery_, GetTargetDocumentationByIdQueryVariables_>(GetTargetDocumentationByIdDocument_, options);
        }
export function useGetTargetDocumentationByIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTargetDocumentationByIdQuery_, GetTargetDocumentationByIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTargetDocumentationByIdQuery_, GetTargetDocumentationByIdQueryVariables_>(GetTargetDocumentationByIdDocument_, options);
        }
export type GetTargetDocumentationByIdQueryHookResult = ReturnType<typeof useGetTargetDocumentationByIdQuery>;
export type GetTargetDocumentationByIdLazyQuery_HookResult = ReturnType<typeof useGetTargetDocumentationByIdLazyQuery_>;
export type GetTargetDocumentationByIdSuspenseQuery_HookResult = ReturnType<typeof useGetTargetDocumentationByIdSuspenseQuery_>;
export type GetTargetDocumentationByIdQueryResult_ = Apollo.QueryResult<GetTargetDocumentationByIdQuery_, GetTargetDocumentationByIdQueryVariables_>;
export function refetchGetTargetDocumentationByIdQuery_(variables: GetTargetDocumentationByIdQueryVariables_) {
      return { query: GetTargetDocumentationByIdDocument_, variables: variables }
    }
export const AddNoteDocument_ = gql`
    mutation addNote($noteInput: Note_insert_input!) {
  insert_Note_one(object: $noteInput) {
    body
    noteHistory {
      id
    }
  }
}
    `;
export type AddNoteMutationFn_ = Apollo.MutationFunction<AddNoteMutation_, AddNoteMutationVariables_>;

/**
 * __useAddNoteMutation__
 *
 * To run a mutation, you first call `useAddNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNoteMutation, { data, loading, error }] = useAddNoteMutation({
 *   variables: {
 *      noteInput: // value for 'noteInput'
 *   },
 * });
 */
export function useAddNoteMutation(baseOptions?: Apollo.MutationHookOptions<AddNoteMutation_, AddNoteMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddNoteMutation_, AddNoteMutationVariables_>(AddNoteDocument_, options);
      }
export type AddNoteMutationHookResult = ReturnType<typeof useAddNoteMutation>;
export type AddNoteMutationResult_ = Apollo.MutationResult<AddNoteMutation_>;
export type AddNoteMutationOptions_ = Apollo.BaseMutationOptions<AddNoteMutation_, AddNoteMutationVariables_>;
export const UpsertAttachmentsDocument_ = gql`
    mutation upsertAttachments($attachmentInputs: [Attachment_insert_input!]!) {
  insert_Attachment(
    objects: $attachmentInputs
    on_conflict: {constraint: Attachment_attachmentBoxId_fileId_key, update_columns: [deletedAt]}
  ) {
    affected_rows
  }
}
    `;
export type UpsertAttachmentsMutationFn_ = Apollo.MutationFunction<UpsertAttachmentsMutation_, UpsertAttachmentsMutationVariables_>;

/**
 * __useUpsertAttachmentsMutation__
 *
 * To run a mutation, you first call `useUpsertAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAttachmentsMutation, { data, loading, error }] = useUpsertAttachmentsMutation({
 *   variables: {
 *      attachmentInputs: // value for 'attachmentInputs'
 *   },
 * });
 */
export function useUpsertAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAttachmentsMutation_, UpsertAttachmentsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAttachmentsMutation_, UpsertAttachmentsMutationVariables_>(UpsertAttachmentsDocument_, options);
      }
export type UpsertAttachmentsMutationHookResult = ReturnType<typeof useUpsertAttachmentsMutation>;
export type UpsertAttachmentsMutationResult_ = Apollo.MutationResult<UpsertAttachmentsMutation_>;
export type UpsertAttachmentsMutationOptions_ = Apollo.BaseMutationOptions<UpsertAttachmentsMutation_, UpsertAttachmentsMutationVariables_>;
export const RemoveAttachmentDocument_ = gql`
    mutation removeAttachment($attachmentId: uuid!) {
  update_Attachment_by_pk(
    pk_columns: {id: $attachmentId}
    _set: {deletedAt: "now()"}
  ) {
    id
  }
}
    `;
export type RemoveAttachmentMutationFn_ = Apollo.MutationFunction<RemoveAttachmentMutation_, RemoveAttachmentMutationVariables_>;

/**
 * __useRemoveAttachmentMutation__
 *
 * To run a mutation, you first call `useRemoveAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAttachmentMutation, { data, loading, error }] = useRemoveAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useRemoveAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAttachmentMutation_, RemoveAttachmentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAttachmentMutation_, RemoveAttachmentMutationVariables_>(RemoveAttachmentDocument_, options);
      }
export type RemoveAttachmentMutationHookResult = ReturnType<typeof useRemoveAttachmentMutation>;
export type RemoveAttachmentMutationResult_ = Apollo.MutationResult<RemoveAttachmentMutation_>;
export type RemoveAttachmentMutationOptions_ = Apollo.BaseMutationOptions<RemoveAttachmentMutation_, RemoveAttachmentMutationVariables_>;
export const AddFileDocument_ = gql`
    mutation addFile($input: DocumentationFile_insert_input!) {
  file: insert_DocumentationFile_one(
    object: $input
    on_conflict: {constraint: File_pkey, update_columns: [creationDate, description, source, tags, title]}
  ) {
    ...DocumentationFileDetails
  }
}
    ${DocumentationFileDetailsFragmentDoc_}`;
export type AddFileMutationFn_ = Apollo.MutationFunction<AddFileMutation_, AddFileMutationVariables_>;

/**
 * __useAddFileMutation__
 *
 * To run a mutation, you first call `useAddFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFileMutation, { data, loading, error }] = useAddFileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddFileMutation(baseOptions?: Apollo.MutationHookOptions<AddFileMutation_, AddFileMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFileMutation_, AddFileMutationVariables_>(AddFileDocument_, options);
      }
export type AddFileMutationHookResult = ReturnType<typeof useAddFileMutation>;
export type AddFileMutationResult_ = Apollo.MutationResult<AddFileMutation_>;
export type AddFileMutationOptions_ = Apollo.BaseMutationOptions<AddFileMutation_, AddFileMutationVariables_>;
export const RemoveFileDocument_ = gql`
    mutation removeFile($id: uuid!) {
  file: update_DocumentationFile_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    id
  }
}
    `;
export type RemoveFileMutationFn_ = Apollo.MutationFunction<RemoveFileMutation_, RemoveFileMutationVariables_>;

/**
 * __useRemoveFileMutation__
 *
 * To run a mutation, you first call `useRemoveFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFileMutation, { data, loading, error }] = useRemoveFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveFileMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFileMutation_, RemoveFileMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFileMutation_, RemoveFileMutationVariables_>(RemoveFileDocument_, options);
      }
export type RemoveFileMutationHookResult = ReturnType<typeof useRemoveFileMutation>;
export type RemoveFileMutationResult_ = Apollo.MutationResult<RemoveFileMutation_>;
export type RemoveFileMutationOptions_ = Apollo.BaseMutationOptions<RemoveFileMutation_, RemoveFileMutationVariables_>;
export const GetDocumentationFileByIdDocument_ = gql`
    query getDocumentationFileById($fileId: uuid!) {
  files: DocumentationFile_by_pk(id: $fileId) {
    ...DocumentationFileDetails
  }
}
    ${DocumentationFileDetailsFragmentDoc_}`;

/**
 * __useGetDocumentationFileByIdQuery__
 *
 * To run a query within a React component, call `useGetDocumentationFileByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentationFileByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentationFileByIdQuery({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useGetDocumentationFileByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDocumentationFileByIdQuery_, GetDocumentationFileByIdQueryVariables_> & ({ variables: GetDocumentationFileByIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDocumentationFileByIdQuery_, GetDocumentationFileByIdQueryVariables_>(GetDocumentationFileByIdDocument_, options);
      }
export function useGetDocumentationFileByIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDocumentationFileByIdQuery_, GetDocumentationFileByIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDocumentationFileByIdQuery_, GetDocumentationFileByIdQueryVariables_>(GetDocumentationFileByIdDocument_, options);
        }
export function useGetDocumentationFileByIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDocumentationFileByIdQuery_, GetDocumentationFileByIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDocumentationFileByIdQuery_, GetDocumentationFileByIdQueryVariables_>(GetDocumentationFileByIdDocument_, options);
        }
export type GetDocumentationFileByIdQueryHookResult = ReturnType<typeof useGetDocumentationFileByIdQuery>;
export type GetDocumentationFileByIdLazyQuery_HookResult = ReturnType<typeof useGetDocumentationFileByIdLazyQuery_>;
export type GetDocumentationFileByIdSuspenseQuery_HookResult = ReturnType<typeof useGetDocumentationFileByIdSuspenseQuery_>;
export type GetDocumentationFileByIdQueryResult_ = Apollo.QueryResult<GetDocumentationFileByIdQuery_, GetDocumentationFileByIdQueryVariables_>;
export function refetchGetDocumentationFileByIdQuery_(variables: GetDocumentationFileByIdQueryVariables_) {
      return { query: GetDocumentationFileByIdDocument_, variables: variables }
    }
export const CompanyFilesDocument_ = gql`
    query CompanyFiles($companyId: uuid!) {
  files: DocumentationFile(
    where: {companyId: {_eq: $companyId}, storageFileId: {_is_null: false}, deletedAt: {_is_null: true}}
  ) {
    ...DocumentationFileDetails
  }
}
    ${DocumentationFileDetailsFragmentDoc_}`;

/**
 * __useCompanyFilesQuery__
 *
 * To run a query within a React component, call `useCompanyFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyFilesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyFilesQuery(baseOptions: Apollo.QueryHookOptions<CompanyFilesQuery_, CompanyFilesQueryVariables_> & ({ variables: CompanyFilesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyFilesQuery_, CompanyFilesQueryVariables_>(CompanyFilesDocument_, options);
      }
export function useCompanyFilesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompanyFilesQuery_, CompanyFilesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyFilesQuery_, CompanyFilesQueryVariables_>(CompanyFilesDocument_, options);
        }
export function useCompanyFilesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyFilesQuery_, CompanyFilesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyFilesQuery_, CompanyFilesQueryVariables_>(CompanyFilesDocument_, options);
        }
export type CompanyFilesQueryHookResult = ReturnType<typeof useCompanyFilesQuery>;
export type CompanyFilesLazyQuery_HookResult = ReturnType<typeof useCompanyFilesLazyQuery_>;
export type CompanyFilesSuspenseQuery_HookResult = ReturnType<typeof useCompanyFilesSuspenseQuery_>;
export type CompanyFilesQueryResult_ = Apollo.QueryResult<CompanyFilesQuery_, CompanyFilesQueryVariables_>;
export function refetchCompanyFilesQuery_(variables: CompanyFilesQueryVariables_) {
      return { query: CompanyFilesDocument_, variables: variables }
    }
export const GetActionsDrDocument_ = gql`
    query getActionsDR($reference: String!, $esrsAssessmentId: uuid!, $standardRef: String!) {
  DisclosureRequirement_by_pk(reference: $reference) {
    reference
    title
    description
    type
    actions(
      order_by: {createdAt: asc}
      where: {materialStandard: {assessmentId: {_eq: $esrsAssessmentId}, standardRef: {_eq: $standardRef}}}
    ) {
      ...ActionFields
    }
  }
}
    ${ActionFieldsFragmentDoc_}`;

/**
 * __useGetActionsDrQuery__
 *
 * To run a query within a React component, call `useGetActionsDrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionsDrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionsDrQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      standardRef: // value for 'standardRef'
 *   },
 * });
 */
export function useGetActionsDrQuery(baseOptions: Apollo.QueryHookOptions<GetActionsDrQuery_, GetActionsDrQueryVariables_> & ({ variables: GetActionsDrQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionsDrQuery_, GetActionsDrQueryVariables_>(GetActionsDrDocument_, options);
      }
export function useGetActionsDrLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetActionsDrQuery_, GetActionsDrQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionsDrQuery_, GetActionsDrQueryVariables_>(GetActionsDrDocument_, options);
        }
export function useGetActionsDrSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActionsDrQuery_, GetActionsDrQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionsDrQuery_, GetActionsDrQueryVariables_>(GetActionsDrDocument_, options);
        }
export type GetActionsDrQueryHookResult = ReturnType<typeof useGetActionsDrQuery>;
export type GetActionsDrLazyQuery_HookResult = ReturnType<typeof useGetActionsDrLazyQuery_>;
export type GetActionsDrSuspenseQuery_HookResult = ReturnType<typeof useGetActionsDrSuspenseQuery_>;
export type GetActionsDrQueryResult_ = Apollo.QueryResult<GetActionsDrQuery_, GetActionsDrQueryVariables_>;
export function refetchGetActionsDrQuery_(variables: GetActionsDrQueryVariables_) {
      return { query: GetActionsDrDocument_, variables: variables }
    }
export const GetActionsByStandardAndAssessmentDocument_ = gql`
    query getActionsByStandardAndAssessment($disclosureRequirementRef: String!, $esrsAssessmentId: uuid!, $standardRef: String!) {
  actions: esrs_Actions(
    order_by: {createdAt: asc}
    where: {disclosureRequirementRef: {_eq: $disclosureRequirementRef}, materialStandard: {assessmentId: {_eq: $esrsAssessmentId}, standardRef: {_eq: $standardRef}}}
  ) {
    ...ActionFields
  }
}
    ${ActionFieldsFragmentDoc_}`;

/**
 * __useGetActionsByStandardAndAssessmentQuery__
 *
 * To run a query within a React component, call `useGetActionsByStandardAndAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionsByStandardAndAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionsByStandardAndAssessmentQuery({
 *   variables: {
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      standardRef: // value for 'standardRef'
 *   },
 * });
 */
export function useGetActionsByStandardAndAssessmentQuery(baseOptions: Apollo.QueryHookOptions<GetActionsByStandardAndAssessmentQuery_, GetActionsByStandardAndAssessmentQueryVariables_> & ({ variables: GetActionsByStandardAndAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionsByStandardAndAssessmentQuery_, GetActionsByStandardAndAssessmentQueryVariables_>(GetActionsByStandardAndAssessmentDocument_, options);
      }
export function useGetActionsByStandardAndAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetActionsByStandardAndAssessmentQuery_, GetActionsByStandardAndAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionsByStandardAndAssessmentQuery_, GetActionsByStandardAndAssessmentQueryVariables_>(GetActionsByStandardAndAssessmentDocument_, options);
        }
export function useGetActionsByStandardAndAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActionsByStandardAndAssessmentQuery_, GetActionsByStandardAndAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionsByStandardAndAssessmentQuery_, GetActionsByStandardAndAssessmentQueryVariables_>(GetActionsByStandardAndAssessmentDocument_, options);
        }
export type GetActionsByStandardAndAssessmentQueryHookResult = ReturnType<typeof useGetActionsByStandardAndAssessmentQuery>;
export type GetActionsByStandardAndAssessmentLazyQuery_HookResult = ReturnType<typeof useGetActionsByStandardAndAssessmentLazyQuery_>;
export type GetActionsByStandardAndAssessmentSuspenseQuery_HookResult = ReturnType<typeof useGetActionsByStandardAndAssessmentSuspenseQuery_>;
export type GetActionsByStandardAndAssessmentQueryResult_ = Apollo.QueryResult<GetActionsByStandardAndAssessmentQuery_, GetActionsByStandardAndAssessmentQueryVariables_>;
export function refetchGetActionsByStandardAndAssessmentQuery_(variables: GetActionsByStandardAndAssessmentQueryVariables_) {
      return { query: GetActionsByStandardAndAssessmentDocument_, variables: variables }
    }
export const GetActionsSubsidiariesDocument_ = gql`
    query getActionsSubsidiaries($standardRef: String!, $esrsAssessmentId: uuid!) {
  esrs: EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    subsidiaries: subsidiaryAssessments {
      id
      company {
        id
        name
      }
      materialStandards(where: {standardRef: {_eq: $standardRef}}) {
        id
        actions {
          ...ActionFields
        }
      }
    }
  }
}
    ${ActionFieldsFragmentDoc_}`;

/**
 * __useGetActionsSubsidiariesQuery__
 *
 * To run a query within a React component, call `useGetActionsSubsidiariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionsSubsidiariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionsSubsidiariesQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetActionsSubsidiariesQuery(baseOptions: Apollo.QueryHookOptions<GetActionsSubsidiariesQuery_, GetActionsSubsidiariesQueryVariables_> & ({ variables: GetActionsSubsidiariesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionsSubsidiariesQuery_, GetActionsSubsidiariesQueryVariables_>(GetActionsSubsidiariesDocument_, options);
      }
export function useGetActionsSubsidiariesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetActionsSubsidiariesQuery_, GetActionsSubsidiariesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionsSubsidiariesQuery_, GetActionsSubsidiariesQueryVariables_>(GetActionsSubsidiariesDocument_, options);
        }
export function useGetActionsSubsidiariesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActionsSubsidiariesQuery_, GetActionsSubsidiariesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionsSubsidiariesQuery_, GetActionsSubsidiariesQueryVariables_>(GetActionsSubsidiariesDocument_, options);
        }
export type GetActionsSubsidiariesQueryHookResult = ReturnType<typeof useGetActionsSubsidiariesQuery>;
export type GetActionsSubsidiariesLazyQuery_HookResult = ReturnType<typeof useGetActionsSubsidiariesLazyQuery_>;
export type GetActionsSubsidiariesSuspenseQuery_HookResult = ReturnType<typeof useGetActionsSubsidiariesSuspenseQuery_>;
export type GetActionsSubsidiariesQueryResult_ = Apollo.QueryResult<GetActionsSubsidiariesQuery_, GetActionsSubsidiariesQueryVariables_>;
export function refetchGetActionsSubsidiariesQuery_(variables: GetActionsSubsidiariesQueryVariables_) {
      return { query: GetActionsSubsidiariesDocument_, variables: variables }
    }
export const GetParentActionsDrDocument_ = gql`
    query getParentActionsDR($parentStandardId: uuid!) {
  esrs_Actions(
    order_by: {createdAt: asc}
    where: {assessmentId: {_eq: $parentStandardId}}
  ) {
    ...ActionFields
  }
}
    ${ActionFieldsFragmentDoc_}`;

/**
 * __useGetParentActionsDrQuery__
 *
 * To run a query within a React component, call `useGetParentActionsDrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentActionsDrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentActionsDrQuery({
 *   variables: {
 *      parentStandardId: // value for 'parentStandardId'
 *   },
 * });
 */
export function useGetParentActionsDrQuery(baseOptions: Apollo.QueryHookOptions<GetParentActionsDrQuery_, GetParentActionsDrQueryVariables_> & ({ variables: GetParentActionsDrQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParentActionsDrQuery_, GetParentActionsDrQueryVariables_>(GetParentActionsDrDocument_, options);
      }
export function useGetParentActionsDrLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetParentActionsDrQuery_, GetParentActionsDrQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParentActionsDrQuery_, GetParentActionsDrQueryVariables_>(GetParentActionsDrDocument_, options);
        }
export function useGetParentActionsDrSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParentActionsDrQuery_, GetParentActionsDrQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParentActionsDrQuery_, GetParentActionsDrQueryVariables_>(GetParentActionsDrDocument_, options);
        }
export type GetParentActionsDrQueryHookResult = ReturnType<typeof useGetParentActionsDrQuery>;
export type GetParentActionsDrLazyQuery_HookResult = ReturnType<typeof useGetParentActionsDrLazyQuery_>;
export type GetParentActionsDrSuspenseQuery_HookResult = ReturnType<typeof useGetParentActionsDrSuspenseQuery_>;
export type GetParentActionsDrQueryResult_ = Apollo.QueryResult<GetParentActionsDrQuery_, GetParentActionsDrQueryVariables_>;
export function refetchGetParentActionsDrQuery_(variables: GetParentActionsDrQueryVariables_) {
      return { query: GetParentActionsDrDocument_, variables: variables }
    }
export const GetActionsDocument_ = gql`
    query getActions($assessmentId: uuid!, $disclosureRequirementRef: String!) {
  actions: esrs_Actions(
    where: {assessmentId: {_eq: $assessmentId}, disclosureRequirement: {type: {_eq: "action"}, group: {standard: {disclosureRequirementGroups: {requirements: {reference: {_eq: $disclosureRequirementRef}}}}}}}
  ) {
    ...ActionFields
  }
}
    ${ActionFieldsFragmentDoc_}`;

/**
 * __useGetActionsQuery__
 *
 * To run a query within a React component, call `useGetActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *   },
 * });
 */
export function useGetActionsQuery(baseOptions: Apollo.QueryHookOptions<GetActionsQuery_, GetActionsQueryVariables_> & ({ variables: GetActionsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionsQuery_, GetActionsQueryVariables_>(GetActionsDocument_, options);
      }
export function useGetActionsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetActionsQuery_, GetActionsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionsQuery_, GetActionsQueryVariables_>(GetActionsDocument_, options);
        }
export function useGetActionsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActionsQuery_, GetActionsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionsQuery_, GetActionsQueryVariables_>(GetActionsDocument_, options);
        }
export type GetActionsQueryHookResult = ReturnType<typeof useGetActionsQuery>;
export type GetActionsLazyQuery_HookResult = ReturnType<typeof useGetActionsLazyQuery_>;
export type GetActionsSuspenseQuery_HookResult = ReturnType<typeof useGetActionsSuspenseQuery_>;
export type GetActionsQueryResult_ = Apollo.QueryResult<GetActionsQuery_, GetActionsQueryVariables_>;
export function refetchGetActionsQuery_(variables: GetActionsQueryVariables_) {
      return { query: GetActionsDocument_, variables: variables }
    }
export const EsrsAssessmentActionsDocument_ = gql`
    query EsrsAssessmentActions($esrsAssessmentId: uuid!) {
  esrs_Actions(
    where: {_or: [{materialStandard: {esrsAssessment: {id: {_eq: $esrsAssessmentId}}}}, {materialStandard: {esrsAssessment: {parentAssessmentId: {_eq: $esrsAssessmentId}}}}]}
  ) {
    ...ActionFields
    materialStandard {
      id
      esrsAssessment {
        id
        parentAssessmentId
        company {
          id
          name
          isGroupOwner
        }
      }
    }
    disclosureRequirement {
      group {
        reference
        standard {
          title
          reference
          category {
            title
            reference
          }
        }
      }
    }
  }
}
    ${ActionFieldsFragmentDoc_}`;

/**
 * __useEsrsAssessmentActionsQuery__
 *
 * To run a query within a React component, call `useEsrsAssessmentActionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsrsAssessmentActionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsrsAssessmentActionsQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useEsrsAssessmentActionsQuery(baseOptions: Apollo.QueryHookOptions<EsrsAssessmentActionsQuery_, EsrsAssessmentActionsQueryVariables_> & ({ variables: EsrsAssessmentActionsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsrsAssessmentActionsQuery_, EsrsAssessmentActionsQueryVariables_>(EsrsAssessmentActionsDocument_, options);
      }
export function useEsrsAssessmentActionsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<EsrsAssessmentActionsQuery_, EsrsAssessmentActionsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsrsAssessmentActionsQuery_, EsrsAssessmentActionsQueryVariables_>(EsrsAssessmentActionsDocument_, options);
        }
export function useEsrsAssessmentActionsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsrsAssessmentActionsQuery_, EsrsAssessmentActionsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsrsAssessmentActionsQuery_, EsrsAssessmentActionsQueryVariables_>(EsrsAssessmentActionsDocument_, options);
        }
export type EsrsAssessmentActionsQueryHookResult = ReturnType<typeof useEsrsAssessmentActionsQuery>;
export type EsrsAssessmentActionsLazyQuery_HookResult = ReturnType<typeof useEsrsAssessmentActionsLazyQuery_>;
export type EsrsAssessmentActionsSuspenseQuery_HookResult = ReturnType<typeof useEsrsAssessmentActionsSuspenseQuery_>;
export type EsrsAssessmentActionsQueryResult_ = Apollo.QueryResult<EsrsAssessmentActionsQuery_, EsrsAssessmentActionsQueryVariables_>;
export function refetchEsrsAssessmentActionsQuery_(variables: EsrsAssessmentActionsQueryVariables_) {
      return { query: EsrsAssessmentActionsDocument_, variables: variables }
    }
export const GetActionDocument_ = gql`
    query getAction($id: uuid!) {
  esrs_Actions_by_pk(id: $id) {
    ...ActionFields
  }
}
    ${ActionFieldsFragmentDoc_}`;

/**
 * __useGetActionQuery__
 *
 * To run a query within a React component, call `useGetActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetActionQuery(baseOptions: Apollo.QueryHookOptions<GetActionQuery_, GetActionQueryVariables_> & ({ variables: GetActionQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActionQuery_, GetActionQueryVariables_>(GetActionDocument_, options);
      }
export function useGetActionLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetActionQuery_, GetActionQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActionQuery_, GetActionQueryVariables_>(GetActionDocument_, options);
        }
export function useGetActionSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActionQuery_, GetActionQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActionQuery_, GetActionQueryVariables_>(GetActionDocument_, options);
        }
export type GetActionQueryHookResult = ReturnType<typeof useGetActionQuery>;
export type GetActionLazyQuery_HookResult = ReturnType<typeof useGetActionLazyQuery_>;
export type GetActionSuspenseQuery_HookResult = ReturnType<typeof useGetActionSuspenseQuery_>;
export type GetActionQueryResult_ = Apollo.QueryResult<GetActionQuery_, GetActionQueryVariables_>;
export function refetchGetActionQuery_(variables: GetActionQueryVariables_) {
      return { query: GetActionDocument_, variables: variables }
    }
export const ActionQuestionsDocument_ = gql`
    query actionQuestions($standardRef: String!) {
  ActionQuestion(
    order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
    where: {standardRef: {_eq: $standardRef}}
  ) {
    ...ActionQuestionFields
  }
}
    ${ActionQuestionFieldsFragmentDoc_}`;

/**
 * __useActionQuestionsQuery__
 *
 * To run a query within a React component, call `useActionQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionQuestionsQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *   },
 * });
 */
export function useActionQuestionsQuery(baseOptions: Apollo.QueryHookOptions<ActionQuestionsQuery_, ActionQuestionsQueryVariables_> & ({ variables: ActionQuestionsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionQuestionsQuery_, ActionQuestionsQueryVariables_>(ActionQuestionsDocument_, options);
      }
export function useActionQuestionsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ActionQuestionsQuery_, ActionQuestionsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionQuestionsQuery_, ActionQuestionsQueryVariables_>(ActionQuestionsDocument_, options);
        }
export function useActionQuestionsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActionQuestionsQuery_, ActionQuestionsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActionQuestionsQuery_, ActionQuestionsQueryVariables_>(ActionQuestionsDocument_, options);
        }
export type ActionQuestionsQueryHookResult = ReturnType<typeof useActionQuestionsQuery>;
export type ActionQuestionsLazyQuery_HookResult = ReturnType<typeof useActionQuestionsLazyQuery_>;
export type ActionQuestionsSuspenseQuery_HookResult = ReturnType<typeof useActionQuestionsSuspenseQuery_>;
export type ActionQuestionsQueryResult_ = Apollo.QueryResult<ActionQuestionsQuery_, ActionQuestionsQueryVariables_>;
export function refetchActionQuestionsQuery_(variables: ActionQuestionsQueryVariables_) {
      return { query: ActionQuestionsDocument_, variables: variables }
    }
export const UpsertActionDocument_ = gql`
    mutation upsertAction($input: esrs_Actions_insert_input!) {
  insert_esrs_Actions_one(
    object: $input
    on_conflict: {constraint: Actions_pkey, update_columns: [title, startDate, deadline, ownerId, capex, noteReference, timeHorizon, answers, relatedIRO, relatedPolicy, statusOfKeyAction, scope, expectedOutcome, provisionOfRemedy, provisionOfRemedyExplanation, progressInfo, investmentsAndResources, hasPreconditions, hasPreconditionsExplanation, opex, opexShortTerm, opexMediumTerm, opexLongTerm, capexShortTerm, capexMediumTerm, capexLongTerm, scopeValueChain, coverage, coverageExplanation, sustainabilityMatter, sustainabilityMatterExplanation, statusOfKeyActionExplanation]}
  ) {
    id
    title
    attachmentBox {
      id
    }
    noteHistory {
      id
    }
  }
}
    `;
export type UpsertActionMutationFn_ = Apollo.MutationFunction<UpsertActionMutation_, UpsertActionMutationVariables_>;

/**
 * __useUpsertActionMutation__
 *
 * To run a mutation, you first call `useUpsertActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertActionMutation, { data, loading, error }] = useUpsertActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertActionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertActionMutation_, UpsertActionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertActionMutation_, UpsertActionMutationVariables_>(UpsertActionDocument_, options);
      }
export type UpsertActionMutationHookResult = ReturnType<typeof useUpsertActionMutation>;
export type UpsertActionMutationResult_ = Apollo.MutationResult<UpsertActionMutation_>;
export type UpsertActionMutationOptions_ = Apollo.BaseMutationOptions<UpsertActionMutation_, UpsertActionMutationVariables_>;
export const UpsertDrawerActionDocument_ = gql`
    mutation upsertDrawerAction($input: esrs_Actions_insert_input!) {
  insert_esrs_Actions_one(
    object: $input
    on_conflict: {constraint: Actions_pkey, update_columns: [title, startDate, deadline, ownerId, timeHorizon]}
  ) {
    id
    title
    attachmentBox {
      id
    }
    noteHistory {
      id
    }
  }
}
    `;
export type UpsertDrawerActionMutationFn_ = Apollo.MutationFunction<UpsertDrawerActionMutation_, UpsertDrawerActionMutationVariables_>;

/**
 * __useUpsertDrawerActionMutation__
 *
 * To run a mutation, you first call `useUpsertDrawerActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDrawerActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDrawerActionMutation, { data, loading, error }] = useUpsertDrawerActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertDrawerActionMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDrawerActionMutation_, UpsertDrawerActionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDrawerActionMutation_, UpsertDrawerActionMutationVariables_>(UpsertDrawerActionDocument_, options);
      }
export type UpsertDrawerActionMutationHookResult = ReturnType<typeof useUpsertDrawerActionMutation>;
export type UpsertDrawerActionMutationResult_ = Apollo.MutationResult<UpsertDrawerActionMutation_>;
export type UpsertDrawerActionMutationOptions_ = Apollo.BaseMutationOptions<UpsertDrawerActionMutation_, UpsertDrawerActionMutationVariables_>;
export const UpsertManyActionsDocument_ = gql`
    mutation upsertManyActions($actions: [esrs_Actions_insert_input!]!) {
  insert_esrs_Actions(
    objects: $actions
    on_conflict: {constraint: Actions_pkey, update_columns: [title, startDate, deadline, ownerId, capex, noteReference, timeHorizon, answers, relatedIRO, relatedPolicy, statusOfKeyAction, scope, expectedOutcome, provisionOfRemedy, provisionOfRemedyExplanation, progressInfo, investmentsAndResources, hasPreconditions, hasPreconditionsExplanation, opex, opexShortTerm, opexMediumTerm, opexLongTerm, capexShortTerm, capexMediumTerm, capexLongTerm, scopeValueChain, coverage, coverageExplanation, sustainabilityMatter, sustainabilityMatterExplanation]}
  ) {
    returning {
      id
      title
      attachmentBox {
        id
      }
      noteHistory {
        id
      }
    }
  }
}
    `;
export type UpsertManyActionsMutationFn_ = Apollo.MutationFunction<UpsertManyActionsMutation_, UpsertManyActionsMutationVariables_>;

/**
 * __useUpsertManyActionsMutation__
 *
 * To run a mutation, you first call `useUpsertManyActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertManyActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertManyActionsMutation, { data, loading, error }] = useUpsertManyActionsMutation({
 *   variables: {
 *      actions: // value for 'actions'
 *   },
 * });
 */
export function useUpsertManyActionsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertManyActionsMutation_, UpsertManyActionsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertManyActionsMutation_, UpsertManyActionsMutationVariables_>(UpsertManyActionsDocument_, options);
      }
export type UpsertManyActionsMutationHookResult = ReturnType<typeof useUpsertManyActionsMutation>;
export type UpsertManyActionsMutationResult_ = Apollo.MutationResult<UpsertManyActionsMutation_>;
export type UpsertManyActionsMutationOptions_ = Apollo.BaseMutationOptions<UpsertManyActionsMutation_, UpsertManyActionsMutationVariables_>;
export const DeleteActionTargetDocument_ = gql`
    mutation deleteActionTarget($id: [uuid!]) {
  delete_esrs_ActionTarget(where: {id: {_in: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteActionTargetMutationFn_ = Apollo.MutationFunction<DeleteActionTargetMutation_, DeleteActionTargetMutationVariables_>;

/**
 * __useDeleteActionTargetMutation__
 *
 * To run a mutation, you first call `useDeleteActionTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionTargetMutation, { data, loading, error }] = useDeleteActionTargetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteActionTargetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActionTargetMutation_, DeleteActionTargetMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActionTargetMutation_, DeleteActionTargetMutationVariables_>(DeleteActionTargetDocument_, options);
      }
export type DeleteActionTargetMutationHookResult = ReturnType<typeof useDeleteActionTargetMutation>;
export type DeleteActionTargetMutationResult_ = Apollo.MutationResult<DeleteActionTargetMutation_>;
export type DeleteActionTargetMutationOptions_ = Apollo.BaseMutationOptions<DeleteActionTargetMutation_, DeleteActionTargetMutationVariables_>;
export const DeleteActionDocument_ = gql`
    mutation deleteAction($actionId: uuid!) {
  delete_esrs_Actions_by_pk(id: $actionId) {
    id
  }
}
    `;
export type DeleteActionMutationFn_ = Apollo.MutationFunction<DeleteActionMutation_, DeleteActionMutationVariables_>;

/**
 * __useDeleteActionMutation__
 *
 * To run a mutation, you first call `useDeleteActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionMutation, { data, loading, error }] = useDeleteActionMutation({
 *   variables: {
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useDeleteActionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActionMutation_, DeleteActionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActionMutation_, DeleteActionMutationVariables_>(DeleteActionDocument_, options);
      }
export type DeleteActionMutationHookResult = ReturnType<typeof useDeleteActionMutation>;
export type DeleteActionMutationResult_ = Apollo.MutationResult<DeleteActionMutation_>;
export type DeleteActionMutationOptions_ = Apollo.BaseMutationOptions<DeleteActionMutation_, DeleteActionMutationVariables_>;
export const DeleteActionReportingsUnitDocument_ = gql`
    mutation deleteActionReportingsUnit($id: [uuid!]) {
  delete_esrs_ActionReportingUnit(where: {id: {_in: $id}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteActionReportingsUnitMutationFn_ = Apollo.MutationFunction<DeleteActionReportingsUnitMutation_, DeleteActionReportingsUnitMutationVariables_>;

/**
 * __useDeleteActionReportingsUnitMutation__
 *
 * To run a mutation, you first call `useDeleteActionReportingsUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionReportingsUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionReportingsUnitMutation, { data, loading, error }] = useDeleteActionReportingsUnitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteActionReportingsUnitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActionReportingsUnitMutation_, DeleteActionReportingsUnitMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActionReportingsUnitMutation_, DeleteActionReportingsUnitMutationVariables_>(DeleteActionReportingsUnitDocument_, options);
      }
export type DeleteActionReportingsUnitMutationHookResult = ReturnType<typeof useDeleteActionReportingsUnitMutation>;
export type DeleteActionReportingsUnitMutationResult_ = Apollo.MutationResult<DeleteActionReportingsUnitMutation_>;
export type DeleteActionReportingsUnitMutationOptions_ = Apollo.BaseMutationOptions<DeleteActionReportingsUnitMutation_, DeleteActionReportingsUnitMutationVariables_>;
export const DeleteActionSubsidiaryDocument_ = gql`
    mutation deleteActionSubsidiary($id: [uuid!]) {
  delete_esrs_ActionSubsidiary(where: {id: {_in: $id}}) {
    returning {
      id
    }
  }
}
    `;
export type DeleteActionSubsidiaryMutationFn_ = Apollo.MutationFunction<DeleteActionSubsidiaryMutation_, DeleteActionSubsidiaryMutationVariables_>;

/**
 * __useDeleteActionSubsidiaryMutation__
 *
 * To run a mutation, you first call `useDeleteActionSubsidiaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionSubsidiaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionSubsidiaryMutation, { data, loading, error }] = useDeleteActionSubsidiaryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteActionSubsidiaryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteActionSubsidiaryMutation_, DeleteActionSubsidiaryMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteActionSubsidiaryMutation_, DeleteActionSubsidiaryMutationVariables_>(DeleteActionSubsidiaryDocument_, options);
      }
export type DeleteActionSubsidiaryMutationHookResult = ReturnType<typeof useDeleteActionSubsidiaryMutation>;
export type DeleteActionSubsidiaryMutationResult_ = Apollo.MutationResult<DeleteActionSubsidiaryMutation_>;
export type DeleteActionSubsidiaryMutationOptions_ = Apollo.BaseMutationOptions<DeleteActionSubsidiaryMutation_, DeleteActionSubsidiaryMutationVariables_>;
export const UpsertManyActionTargetsDocument_ = gql`
    mutation upsertManyActionTargets($objects: [esrs_ActionTarget_insert_input!]!) {
  insert_esrs_ActionTarget(
    objects: $objects
    on_conflict: {constraint: ActionTarget_pkey, update_columns: [updatedAt]}
  ) {
    affected_rows
    returning {
      id
      actionId
      targetId
    }
  }
}
    `;
export type UpsertManyActionTargetsMutationFn_ = Apollo.MutationFunction<UpsertManyActionTargetsMutation_, UpsertManyActionTargetsMutationVariables_>;

/**
 * __useUpsertManyActionTargetsMutation__
 *
 * To run a mutation, you first call `useUpsertManyActionTargetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertManyActionTargetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertManyActionTargetsMutation, { data, loading, error }] = useUpsertManyActionTargetsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertManyActionTargetsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertManyActionTargetsMutation_, UpsertManyActionTargetsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertManyActionTargetsMutation_, UpsertManyActionTargetsMutationVariables_>(UpsertManyActionTargetsDocument_, options);
      }
export type UpsertManyActionTargetsMutationHookResult = ReturnType<typeof useUpsertManyActionTargetsMutation>;
export type UpsertManyActionTargetsMutationResult_ = Apollo.MutationResult<UpsertManyActionTargetsMutation_>;
export type UpsertManyActionTargetsMutationOptions_ = Apollo.BaseMutationOptions<UpsertManyActionTargetsMutation_, UpsertManyActionTargetsMutationVariables_>;
export const GetEsrsMetricsDatapointsDocument_ = gql`
    query getEsrsMetricsDatapoints($reportingUnitId: uuid!, $assessmentId: uuid!, $metricRefs: [String!]!) {
  answers: esrs_Answer(
    where: {reportingUnitId: {_eq: $reportingUnitId}, assessmentId: {_eq: $assessmentId}, metricRef: {_in: $metricRefs}}
  ) {
    ...EsrsAnswersFields
  }
}
    ${EsrsAnswersFieldsFragmentDoc_}`;

/**
 * __useGetEsrsMetricsDatapointsQuery__
 *
 * To run a query within a React component, call `useGetEsrsMetricsDatapointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsrsMetricsDatapointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsrsMetricsDatapointsQuery({
 *   variables: {
 *      reportingUnitId: // value for 'reportingUnitId'
 *      assessmentId: // value for 'assessmentId'
 *      metricRefs: // value for 'metricRefs'
 *   },
 * });
 */
export function useGetEsrsMetricsDatapointsQuery(baseOptions: Apollo.QueryHookOptions<GetEsrsMetricsDatapointsQuery_, GetEsrsMetricsDatapointsQueryVariables_> & ({ variables: GetEsrsMetricsDatapointsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsrsMetricsDatapointsQuery_, GetEsrsMetricsDatapointsQueryVariables_>(GetEsrsMetricsDatapointsDocument_, options);
      }
export function useGetEsrsMetricsDatapointsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetEsrsMetricsDatapointsQuery_, GetEsrsMetricsDatapointsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsrsMetricsDatapointsQuery_, GetEsrsMetricsDatapointsQueryVariables_>(GetEsrsMetricsDatapointsDocument_, options);
        }
export function useGetEsrsMetricsDatapointsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEsrsMetricsDatapointsQuery_, GetEsrsMetricsDatapointsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEsrsMetricsDatapointsQuery_, GetEsrsMetricsDatapointsQueryVariables_>(GetEsrsMetricsDatapointsDocument_, options);
        }
export type GetEsrsMetricsDatapointsQueryHookResult = ReturnType<typeof useGetEsrsMetricsDatapointsQuery>;
export type GetEsrsMetricsDatapointsLazyQuery_HookResult = ReturnType<typeof useGetEsrsMetricsDatapointsLazyQuery_>;
export type GetEsrsMetricsDatapointsSuspenseQuery_HookResult = ReturnType<typeof useGetEsrsMetricsDatapointsSuspenseQuery_>;
export type GetEsrsMetricsDatapointsQueryResult_ = Apollo.QueryResult<GetEsrsMetricsDatapointsQuery_, GetEsrsMetricsDatapointsQueryVariables_>;
export function refetchGetEsrsMetricsDatapointsQuery_(variables: GetEsrsMetricsDatapointsQueryVariables_) {
      return { query: GetEsrsMetricsDatapointsDocument_, variables: variables }
    }
export const GetStandardAnswersOnCompanyLevelDocument_ = gql`
    query getStandardAnswersOnCompanyLevel($esrsAssessmentId: uuid!, $drRef: String!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    reportingUnits {
      id
      name
      isCompanyLevel
      answers(
        where: {_and: [{hasOptedOut: {_eq: false}}, {metric: {_or: [{disclosureRequirementRef: {_eq: $drRef}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {drToMFDisclosureRequirements: {disclosureRequirementRef: {_eq: $drRef}}}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}}]}
      ) {
        ...ReportingUnitAnswersFields
      }
    }
  }
}
    ${ReportingUnitAnswersFieldsFragmentDoc_}`;

/**
 * __useGetStandardAnswersOnCompanyLevelQuery__
 *
 * To run a query within a React component, call `useGetStandardAnswersOnCompanyLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandardAnswersOnCompanyLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandardAnswersOnCompanyLevelQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      drRef: // value for 'drRef'
 *   },
 * });
 */
export function useGetStandardAnswersOnCompanyLevelQuery(baseOptions: Apollo.QueryHookOptions<GetStandardAnswersOnCompanyLevelQuery_, GetStandardAnswersOnCompanyLevelQueryVariables_> & ({ variables: GetStandardAnswersOnCompanyLevelQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandardAnswersOnCompanyLevelQuery_, GetStandardAnswersOnCompanyLevelQueryVariables_>(GetStandardAnswersOnCompanyLevelDocument_, options);
      }
export function useGetStandardAnswersOnCompanyLevelLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetStandardAnswersOnCompanyLevelQuery_, GetStandardAnswersOnCompanyLevelQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandardAnswersOnCompanyLevelQuery_, GetStandardAnswersOnCompanyLevelQueryVariables_>(GetStandardAnswersOnCompanyLevelDocument_, options);
        }
export function useGetStandardAnswersOnCompanyLevelSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStandardAnswersOnCompanyLevelQuery_, GetStandardAnswersOnCompanyLevelQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStandardAnswersOnCompanyLevelQuery_, GetStandardAnswersOnCompanyLevelQueryVariables_>(GetStandardAnswersOnCompanyLevelDocument_, options);
        }
export type GetStandardAnswersOnCompanyLevelQueryHookResult = ReturnType<typeof useGetStandardAnswersOnCompanyLevelQuery>;
export type GetStandardAnswersOnCompanyLevelLazyQuery_HookResult = ReturnType<typeof useGetStandardAnswersOnCompanyLevelLazyQuery_>;
export type GetStandardAnswersOnCompanyLevelSuspenseQuery_HookResult = ReturnType<typeof useGetStandardAnswersOnCompanyLevelSuspenseQuery_>;
export type GetStandardAnswersOnCompanyLevelQueryResult_ = Apollo.QueryResult<GetStandardAnswersOnCompanyLevelQuery_, GetStandardAnswersOnCompanyLevelQueryVariables_>;
export function refetchGetStandardAnswersOnCompanyLevelQuery_(variables: GetStandardAnswersOnCompanyLevelQueryVariables_) {
      return { query: GetStandardAnswersOnCompanyLevelDocument_, variables: variables }
    }
export const GetStandardAnswersOnGroupLevelDocument_ = gql`
    query getStandardAnswersOnGroupLevel($esrsAssessmentId: uuid!, $drRef: String!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    subsidiaryAssessments {
      id
      company {
        id
        name
      }
      reportingUnits {
        id
        name
        isCompanyLevel
        answers(
          where: {_and: [{hasOptedOut: {_eq: false}}, {metric: {_or: [{disclosureRequirementRef: {_eq: $drRef}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {drToMFDisclosureRequirements: {disclosureRequirementRef: {_eq: $drRef}}}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}}]}
        ) {
          ...ReportingUnitAnswersFields
        }
      }
      materialStandards {
        id
        standardRef
        isMaterial
        standard {
          title
          reference
        }
        materialMetrics {
          ...MaterialMetricWithChildrenFields
        }
      }
    }
  }
}
    ${ReportingUnitAnswersFieldsFragmentDoc_}
${MaterialMetricWithChildrenFieldsFragmentDoc_}`;

/**
 * __useGetStandardAnswersOnGroupLevelQuery__
 *
 * To run a query within a React component, call `useGetStandardAnswersOnGroupLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandardAnswersOnGroupLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandardAnswersOnGroupLevelQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      drRef: // value for 'drRef'
 *   },
 * });
 */
export function useGetStandardAnswersOnGroupLevelQuery(baseOptions: Apollo.QueryHookOptions<GetStandardAnswersOnGroupLevelQuery_, GetStandardAnswersOnGroupLevelQueryVariables_> & ({ variables: GetStandardAnswersOnGroupLevelQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandardAnswersOnGroupLevelQuery_, GetStandardAnswersOnGroupLevelQueryVariables_>(GetStandardAnswersOnGroupLevelDocument_, options);
      }
export function useGetStandardAnswersOnGroupLevelLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetStandardAnswersOnGroupLevelQuery_, GetStandardAnswersOnGroupLevelQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandardAnswersOnGroupLevelQuery_, GetStandardAnswersOnGroupLevelQueryVariables_>(GetStandardAnswersOnGroupLevelDocument_, options);
        }
export function useGetStandardAnswersOnGroupLevelSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStandardAnswersOnGroupLevelQuery_, GetStandardAnswersOnGroupLevelQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStandardAnswersOnGroupLevelQuery_, GetStandardAnswersOnGroupLevelQueryVariables_>(GetStandardAnswersOnGroupLevelDocument_, options);
        }
export type GetStandardAnswersOnGroupLevelQueryHookResult = ReturnType<typeof useGetStandardAnswersOnGroupLevelQuery>;
export type GetStandardAnswersOnGroupLevelLazyQuery_HookResult = ReturnType<typeof useGetStandardAnswersOnGroupLevelLazyQuery_>;
export type GetStandardAnswersOnGroupLevelSuspenseQuery_HookResult = ReturnType<typeof useGetStandardAnswersOnGroupLevelSuspenseQuery_>;
export type GetStandardAnswersOnGroupLevelQueryResult_ = Apollo.QueryResult<GetStandardAnswersOnGroupLevelQuery_, GetStandardAnswersOnGroupLevelQueryVariables_>;
export function refetchGetStandardAnswersOnGroupLevelQuery_(variables: GetStandardAnswersOnGroupLevelQueryVariables_) {
      return { query: GetStandardAnswersOnGroupLevelDocument_, variables: variables }
    }
export const GetAnswersForMetricsOnCompanyLevelDocument_ = gql`
    query getAnswersForMetricsOnCompanyLevel($esrsAssessmentId: uuid!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    reportingUnits {
      id
      name
      isCompanyLevel
      answers(where: {hasOptedOut: {_eq: false}}) {
        ...ReportingUnitAnswersFieldsForAggregatedLevel
      }
      optedOutAnswers: answers(where: {hasOptedOut: {_eq: true}}) {
        id
        metricRef
      }
    }
  }
}
    ${ReportingUnitAnswersFieldsForAggregatedLevelFragmentDoc_}`;

/**
 * __useGetAnswersForMetricsOnCompanyLevelQuery__
 *
 * To run a query within a React component, call `useGetAnswersForMetricsOnCompanyLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswersForMetricsOnCompanyLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswersForMetricsOnCompanyLevelQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetAnswersForMetricsOnCompanyLevelQuery(baseOptions: Apollo.QueryHookOptions<GetAnswersForMetricsOnCompanyLevelQuery_, GetAnswersForMetricsOnCompanyLevelQueryVariables_> & ({ variables: GetAnswersForMetricsOnCompanyLevelQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnswersForMetricsOnCompanyLevelQuery_, GetAnswersForMetricsOnCompanyLevelQueryVariables_>(GetAnswersForMetricsOnCompanyLevelDocument_, options);
      }
export function useGetAnswersForMetricsOnCompanyLevelLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAnswersForMetricsOnCompanyLevelQuery_, GetAnswersForMetricsOnCompanyLevelQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnswersForMetricsOnCompanyLevelQuery_, GetAnswersForMetricsOnCompanyLevelQueryVariables_>(GetAnswersForMetricsOnCompanyLevelDocument_, options);
        }
export function useGetAnswersForMetricsOnCompanyLevelSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnswersForMetricsOnCompanyLevelQuery_, GetAnswersForMetricsOnCompanyLevelQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnswersForMetricsOnCompanyLevelQuery_, GetAnswersForMetricsOnCompanyLevelQueryVariables_>(GetAnswersForMetricsOnCompanyLevelDocument_, options);
        }
export type GetAnswersForMetricsOnCompanyLevelQueryHookResult = ReturnType<typeof useGetAnswersForMetricsOnCompanyLevelQuery>;
export type GetAnswersForMetricsOnCompanyLevelLazyQuery_HookResult = ReturnType<typeof useGetAnswersForMetricsOnCompanyLevelLazyQuery_>;
export type GetAnswersForMetricsOnCompanyLevelSuspenseQuery_HookResult = ReturnType<typeof useGetAnswersForMetricsOnCompanyLevelSuspenseQuery_>;
export type GetAnswersForMetricsOnCompanyLevelQueryResult_ = Apollo.QueryResult<GetAnswersForMetricsOnCompanyLevelQuery_, GetAnswersForMetricsOnCompanyLevelQueryVariables_>;
export function refetchGetAnswersForMetricsOnCompanyLevelQuery_(variables: GetAnswersForMetricsOnCompanyLevelQueryVariables_) {
      return { query: GetAnswersForMetricsOnCompanyLevelDocument_, variables: variables }
    }
export const GetAnswersForMetricsOnGroupLevelDocument_ = gql`
    query getAnswersForMetricsOnGroupLevel($esrsAssessmentId: uuid!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    subsidiaryAssessments(where: {deletedAt: {_is_null: true}}) {
      id
      company {
        id
        name
        currency
      }
      reportingUnits {
        id
        name
        isCompanyLevel
        answers(where: {hasOptedOut: {_eq: false}}) {
          ...ReportingUnitAnswersFieldsForAggregatedLevel
        }
      }
      materialStandards {
        id
        standardRef
        materialMetrics {
          ...MaterialMetricWithChildrenFieldsForAggregatedLevel
        }
      }
    }
  }
}
    ${ReportingUnitAnswersFieldsForAggregatedLevelFragmentDoc_}
${MaterialMetricWithChildrenFieldsForAggregatedLevelFragmentDoc_}`;

/**
 * __useGetAnswersForMetricsOnGroupLevelQuery__
 *
 * To run a query within a React component, call `useGetAnswersForMetricsOnGroupLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswersForMetricsOnGroupLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswersForMetricsOnGroupLevelQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetAnswersForMetricsOnGroupLevelQuery(baseOptions: Apollo.QueryHookOptions<GetAnswersForMetricsOnGroupLevelQuery_, GetAnswersForMetricsOnGroupLevelQueryVariables_> & ({ variables: GetAnswersForMetricsOnGroupLevelQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnswersForMetricsOnGroupLevelQuery_, GetAnswersForMetricsOnGroupLevelQueryVariables_>(GetAnswersForMetricsOnGroupLevelDocument_, options);
      }
export function useGetAnswersForMetricsOnGroupLevelLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAnswersForMetricsOnGroupLevelQuery_, GetAnswersForMetricsOnGroupLevelQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnswersForMetricsOnGroupLevelQuery_, GetAnswersForMetricsOnGroupLevelQueryVariables_>(GetAnswersForMetricsOnGroupLevelDocument_, options);
        }
export function useGetAnswersForMetricsOnGroupLevelSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnswersForMetricsOnGroupLevelQuery_, GetAnswersForMetricsOnGroupLevelQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnswersForMetricsOnGroupLevelQuery_, GetAnswersForMetricsOnGroupLevelQueryVariables_>(GetAnswersForMetricsOnGroupLevelDocument_, options);
        }
export type GetAnswersForMetricsOnGroupLevelQueryHookResult = ReturnType<typeof useGetAnswersForMetricsOnGroupLevelQuery>;
export type GetAnswersForMetricsOnGroupLevelLazyQuery_HookResult = ReturnType<typeof useGetAnswersForMetricsOnGroupLevelLazyQuery_>;
export type GetAnswersForMetricsOnGroupLevelSuspenseQuery_HookResult = ReturnType<typeof useGetAnswersForMetricsOnGroupLevelSuspenseQuery_>;
export type GetAnswersForMetricsOnGroupLevelQueryResult_ = Apollo.QueryResult<GetAnswersForMetricsOnGroupLevelQuery_, GetAnswersForMetricsOnGroupLevelQueryVariables_>;
export function refetchGetAnswersForMetricsOnGroupLevelQuery_(variables: GetAnswersForMetricsOnGroupLevelQueryVariables_) {
      return { query: GetAnswersForMetricsOnGroupLevelDocument_, variables: variables }
    }
export const GetAnswersForDrMetricsOnCompanyLevelDocument_ = gql`
    query getAnswersForDRMetricsOnCompanyLevel($esrsAssessmentId: uuid!, $disclosureRequirementRef: String!, $frameworkRef: String!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    reportingUnits {
      id
      name
      isCompanyLevel
      answers(
        where: {hasOptedOut: {_eq: false}, metric: {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $disclosureRequirementRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $disclosureRequirementRef}}}}]}}
      ) {
        ...ReportingUnitAnswersFieldsForAggregatedLevel
      }
      optedOutAnswers: answers(where: {hasOptedOut: {_eq: true}}) {
        id
        metricRef
      }
    }
  }
}
    ${ReportingUnitAnswersFieldsForAggregatedLevelFragmentDoc_}`;

/**
 * __useGetAnswersForDrMetricsOnCompanyLevelQuery__
 *
 * To run a query within a React component, call `useGetAnswersForDrMetricsOnCompanyLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswersForDrMetricsOnCompanyLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswersForDrMetricsOnCompanyLevelQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetAnswersForDrMetricsOnCompanyLevelQuery(baseOptions: Apollo.QueryHookOptions<GetAnswersForDrMetricsOnCompanyLevelQuery_, GetAnswersForDrMetricsOnCompanyLevelQueryVariables_> & ({ variables: GetAnswersForDrMetricsOnCompanyLevelQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnswersForDrMetricsOnCompanyLevelQuery_, GetAnswersForDrMetricsOnCompanyLevelQueryVariables_>(GetAnswersForDrMetricsOnCompanyLevelDocument_, options);
      }
export function useGetAnswersForDrMetricsOnCompanyLevelLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAnswersForDrMetricsOnCompanyLevelQuery_, GetAnswersForDrMetricsOnCompanyLevelQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnswersForDrMetricsOnCompanyLevelQuery_, GetAnswersForDrMetricsOnCompanyLevelQueryVariables_>(GetAnswersForDrMetricsOnCompanyLevelDocument_, options);
        }
export function useGetAnswersForDrMetricsOnCompanyLevelSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnswersForDrMetricsOnCompanyLevelQuery_, GetAnswersForDrMetricsOnCompanyLevelQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnswersForDrMetricsOnCompanyLevelQuery_, GetAnswersForDrMetricsOnCompanyLevelQueryVariables_>(GetAnswersForDrMetricsOnCompanyLevelDocument_, options);
        }
export type GetAnswersForDrMetricsOnCompanyLevelQueryHookResult = ReturnType<typeof useGetAnswersForDrMetricsOnCompanyLevelQuery>;
export type GetAnswersForDrMetricsOnCompanyLevelLazyQuery_HookResult = ReturnType<typeof useGetAnswersForDrMetricsOnCompanyLevelLazyQuery_>;
export type GetAnswersForDrMetricsOnCompanyLevelSuspenseQuery_HookResult = ReturnType<typeof useGetAnswersForDrMetricsOnCompanyLevelSuspenseQuery_>;
export type GetAnswersForDrMetricsOnCompanyLevelQueryResult_ = Apollo.QueryResult<GetAnswersForDrMetricsOnCompanyLevelQuery_, GetAnswersForDrMetricsOnCompanyLevelQueryVariables_>;
export function refetchGetAnswersForDrMetricsOnCompanyLevelQuery_(variables: GetAnswersForDrMetricsOnCompanyLevelQueryVariables_) {
      return { query: GetAnswersForDrMetricsOnCompanyLevelDocument_, variables: variables }
    }
export const GetAnswersForDrMetricsOnGroupLevelDocument_ = gql`
    query getAnswersForDRMetricsOnGroupLevel($esrsAssessmentId: uuid!, $disclosureRequirementRef: String!, $frameworkRef: String!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    subsidiaryAssessments(where: {deletedAt: {_is_null: true}}) {
      id
      company {
        id
        name
        currency
      }
      reportingUnits {
        id
        name
        isCompanyLevel
        answers(
          where: {hasOptedOut: {_eq: false}, metric: {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $disclosureRequirementRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $disclosureRequirementRef}}}}]}}
        ) {
          ...ReportingUnitAnswersFieldsForAggregatedLevel
        }
      }
      materialStandards {
        id
        standardRef
        materialMetrics(
          where: {metric: {_or: [{disclosureRequirementRef: {_eq: $disclosureRequirementRef}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {drToMFDisclosureRequirements: {disclosureRequirementRef: {_eq: $disclosureRequirementRef}}}}}]}}
        ) {
          ...MaterialMetricWithChildrenFieldsForAggregatedLevel
        }
      }
    }
  }
}
    ${ReportingUnitAnswersFieldsForAggregatedLevelFragmentDoc_}
${MaterialMetricWithChildrenFieldsForAggregatedLevelFragmentDoc_}`;

/**
 * __useGetAnswersForDrMetricsOnGroupLevelQuery__
 *
 * To run a query within a React component, call `useGetAnswersForDrMetricsOnGroupLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswersForDrMetricsOnGroupLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswersForDrMetricsOnGroupLevelQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetAnswersForDrMetricsOnGroupLevelQuery(baseOptions: Apollo.QueryHookOptions<GetAnswersForDrMetricsOnGroupLevelQuery_, GetAnswersForDrMetricsOnGroupLevelQueryVariables_> & ({ variables: GetAnswersForDrMetricsOnGroupLevelQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnswersForDrMetricsOnGroupLevelQuery_, GetAnswersForDrMetricsOnGroupLevelQueryVariables_>(GetAnswersForDrMetricsOnGroupLevelDocument_, options);
      }
export function useGetAnswersForDrMetricsOnGroupLevelLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAnswersForDrMetricsOnGroupLevelQuery_, GetAnswersForDrMetricsOnGroupLevelQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnswersForDrMetricsOnGroupLevelQuery_, GetAnswersForDrMetricsOnGroupLevelQueryVariables_>(GetAnswersForDrMetricsOnGroupLevelDocument_, options);
        }
export function useGetAnswersForDrMetricsOnGroupLevelSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnswersForDrMetricsOnGroupLevelQuery_, GetAnswersForDrMetricsOnGroupLevelQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnswersForDrMetricsOnGroupLevelQuery_, GetAnswersForDrMetricsOnGroupLevelQueryVariables_>(GetAnswersForDrMetricsOnGroupLevelDocument_, options);
        }
export type GetAnswersForDrMetricsOnGroupLevelQueryHookResult = ReturnType<typeof useGetAnswersForDrMetricsOnGroupLevelQuery>;
export type GetAnswersForDrMetricsOnGroupLevelLazyQuery_HookResult = ReturnType<typeof useGetAnswersForDrMetricsOnGroupLevelLazyQuery_>;
export type GetAnswersForDrMetricsOnGroupLevelSuspenseQuery_HookResult = ReturnType<typeof useGetAnswersForDrMetricsOnGroupLevelSuspenseQuery_>;
export type GetAnswersForDrMetricsOnGroupLevelQueryResult_ = Apollo.QueryResult<GetAnswersForDrMetricsOnGroupLevelQuery_, GetAnswersForDrMetricsOnGroupLevelQueryVariables_>;
export function refetchGetAnswersForDrMetricsOnGroupLevelQuery_(variables: GetAnswersForDrMetricsOnGroupLevelQueryVariables_) {
      return { query: GetAnswersForDrMetricsOnGroupLevelDocument_, variables: variables }
    }
export const GetSubAnswersPerDrOnGroupLevelDocument_ = gql`
    query getSubAnswersPerDrOnGroupLevel($esrsAssessmentId: uuid!, $disclosureRequirementRef: String!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    subsidiaryAssessments(where: {deletedAt: {_is_null: true}}) {
      id
      company {
        id
        name
        currency
      }
      reportingUnits {
        id
        name
        isCompanyLevel
        answers(
          where: {hasOptedOut: {_eq: false}, metric: {_or: [{disclosureRequirementRef: {_eq: $disclosureRequirementRef}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {drToMFDisclosureRequirements: {disclosureRequirementRef: {_eq: $disclosureRequirementRef}}}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $disclosureRequirementRef}}}}]}}
        ) {
          ...ReportingUnitAnswersFieldsForAggregatedLevel
        }
      }
    }
  }
}
    ${ReportingUnitAnswersFieldsForAggregatedLevelFragmentDoc_}`;

/**
 * __useGetSubAnswersPerDrOnGroupLevelQuery__
 *
 * To run a query within a React component, call `useGetSubAnswersPerDrOnGroupLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubAnswersPerDrOnGroupLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubAnswersPerDrOnGroupLevelQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *   },
 * });
 */
export function useGetSubAnswersPerDrOnGroupLevelQuery(baseOptions: Apollo.QueryHookOptions<GetSubAnswersPerDrOnGroupLevelQuery_, GetSubAnswersPerDrOnGroupLevelQueryVariables_> & ({ variables: GetSubAnswersPerDrOnGroupLevelQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubAnswersPerDrOnGroupLevelQuery_, GetSubAnswersPerDrOnGroupLevelQueryVariables_>(GetSubAnswersPerDrOnGroupLevelDocument_, options);
      }
export function useGetSubAnswersPerDrOnGroupLevelLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubAnswersPerDrOnGroupLevelQuery_, GetSubAnswersPerDrOnGroupLevelQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubAnswersPerDrOnGroupLevelQuery_, GetSubAnswersPerDrOnGroupLevelQueryVariables_>(GetSubAnswersPerDrOnGroupLevelDocument_, options);
        }
export function useGetSubAnswersPerDrOnGroupLevelSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubAnswersPerDrOnGroupLevelQuery_, GetSubAnswersPerDrOnGroupLevelQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubAnswersPerDrOnGroupLevelQuery_, GetSubAnswersPerDrOnGroupLevelQueryVariables_>(GetSubAnswersPerDrOnGroupLevelDocument_, options);
        }
export type GetSubAnswersPerDrOnGroupLevelQueryHookResult = ReturnType<typeof useGetSubAnswersPerDrOnGroupLevelQuery>;
export type GetSubAnswersPerDrOnGroupLevelLazyQuery_HookResult = ReturnType<typeof useGetSubAnswersPerDrOnGroupLevelLazyQuery_>;
export type GetSubAnswersPerDrOnGroupLevelSuspenseQuery_HookResult = ReturnType<typeof useGetSubAnswersPerDrOnGroupLevelSuspenseQuery_>;
export type GetSubAnswersPerDrOnGroupLevelQueryResult_ = Apollo.QueryResult<GetSubAnswersPerDrOnGroupLevelQuery_, GetSubAnswersPerDrOnGroupLevelQueryVariables_>;
export function refetchGetSubAnswersPerDrOnGroupLevelQuery_(variables: GetSubAnswersPerDrOnGroupLevelQueryVariables_) {
      return { query: GetSubAnswersPerDrOnGroupLevelDocument_, variables: variables }
    }
export const GetSubMaterialMetricsPerDrOnGroupLevelDocument_ = gql`
    query getSubMaterialMetricsPerDrOnGroupLevel($esrsAssessmentId: uuid!, $disclosureRequirementRef: String!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    subsidiaryAssessments(where: {deletedAt: {_is_null: true}}) {
      id
      company {
        id
        name
        currency
      }
      materialStandards {
        id
        standardRef
        materialMetrics(
          where: {metric: {_or: [{disclosureRequirementRef: {_eq: $disclosureRequirementRef}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {drToMFDisclosureRequirements: {disclosureRequirementRef: {_eq: $disclosureRequirementRef}}}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $disclosureRequirementRef}}}}]}}
        ) {
          ...MaterialMetricWithChildrenFieldsForAggregatedLevel
        }
      }
    }
  }
}
    ${MaterialMetricWithChildrenFieldsForAggregatedLevelFragmentDoc_}`;

/**
 * __useGetSubMaterialMetricsPerDrOnGroupLevelQuery__
 *
 * To run a query within a React component, call `useGetSubMaterialMetricsPerDrOnGroupLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubMaterialMetricsPerDrOnGroupLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubMaterialMetricsPerDrOnGroupLevelQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *   },
 * });
 */
export function useGetSubMaterialMetricsPerDrOnGroupLevelQuery(baseOptions: Apollo.QueryHookOptions<GetSubMaterialMetricsPerDrOnGroupLevelQuery_, GetSubMaterialMetricsPerDrOnGroupLevelQueryVariables_> & ({ variables: GetSubMaterialMetricsPerDrOnGroupLevelQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubMaterialMetricsPerDrOnGroupLevelQuery_, GetSubMaterialMetricsPerDrOnGroupLevelQueryVariables_>(GetSubMaterialMetricsPerDrOnGroupLevelDocument_, options);
      }
export function useGetSubMaterialMetricsPerDrOnGroupLevelLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubMaterialMetricsPerDrOnGroupLevelQuery_, GetSubMaterialMetricsPerDrOnGroupLevelQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubMaterialMetricsPerDrOnGroupLevelQuery_, GetSubMaterialMetricsPerDrOnGroupLevelQueryVariables_>(GetSubMaterialMetricsPerDrOnGroupLevelDocument_, options);
        }
export function useGetSubMaterialMetricsPerDrOnGroupLevelSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubMaterialMetricsPerDrOnGroupLevelQuery_, GetSubMaterialMetricsPerDrOnGroupLevelQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubMaterialMetricsPerDrOnGroupLevelQuery_, GetSubMaterialMetricsPerDrOnGroupLevelQueryVariables_>(GetSubMaterialMetricsPerDrOnGroupLevelDocument_, options);
        }
export type GetSubMaterialMetricsPerDrOnGroupLevelQueryHookResult = ReturnType<typeof useGetSubMaterialMetricsPerDrOnGroupLevelQuery>;
export type GetSubMaterialMetricsPerDrOnGroupLevelLazyQuery_HookResult = ReturnType<typeof useGetSubMaterialMetricsPerDrOnGroupLevelLazyQuery_>;
export type GetSubMaterialMetricsPerDrOnGroupLevelSuspenseQuery_HookResult = ReturnType<typeof useGetSubMaterialMetricsPerDrOnGroupLevelSuspenseQuery_>;
export type GetSubMaterialMetricsPerDrOnGroupLevelQueryResult_ = Apollo.QueryResult<GetSubMaterialMetricsPerDrOnGroupLevelQuery_, GetSubMaterialMetricsPerDrOnGroupLevelQueryVariables_>;
export function refetchGetSubMaterialMetricsPerDrOnGroupLevelQuery_(variables: GetSubMaterialMetricsPerDrOnGroupLevelQueryVariables_) {
      return { query: GetSubMaterialMetricsPerDrOnGroupLevelDocument_, variables: variables }
    }
export const GetSubAnswersEnvironmentDocument_ = gql`
    query GetSubAnswersEnvironment($esrsAssessmentId: uuid!, $environmentDisclosures: [String!]!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    subsidiaryAssessments(where: {deletedAt: {_is_null: true}}) {
      id
      reportingUnits {
        id
        name
        isCompanyLevel
        answers(
          where: {hasOptedOut: {_eq: false}, metric: {disclosureRequirementRef: {_in: $environmentDisclosures}}}
        ) {
          ...ReportingUnitAnswersFieldsForAggregatedLevel
        }
      }
    }
  }
}
    ${ReportingUnitAnswersFieldsForAggregatedLevelFragmentDoc_}`;

/**
 * __useGetSubAnswersEnvironmentQuery__
 *
 * To run a query within a React component, call `useGetSubAnswersEnvironmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubAnswersEnvironmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubAnswersEnvironmentQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      environmentDisclosures: // value for 'environmentDisclosures'
 *   },
 * });
 */
export function useGetSubAnswersEnvironmentQuery(baseOptions: Apollo.QueryHookOptions<GetSubAnswersEnvironmentQuery_, GetSubAnswersEnvironmentQueryVariables_> & ({ variables: GetSubAnswersEnvironmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubAnswersEnvironmentQuery_, GetSubAnswersEnvironmentQueryVariables_>(GetSubAnswersEnvironmentDocument_, options);
      }
export function useGetSubAnswersEnvironmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubAnswersEnvironmentQuery_, GetSubAnswersEnvironmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubAnswersEnvironmentQuery_, GetSubAnswersEnvironmentQueryVariables_>(GetSubAnswersEnvironmentDocument_, options);
        }
export function useGetSubAnswersEnvironmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubAnswersEnvironmentQuery_, GetSubAnswersEnvironmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubAnswersEnvironmentQuery_, GetSubAnswersEnvironmentQueryVariables_>(GetSubAnswersEnvironmentDocument_, options);
        }
export type GetSubAnswersEnvironmentQueryHookResult = ReturnType<typeof useGetSubAnswersEnvironmentQuery>;
export type GetSubAnswersEnvironmentLazyQuery_HookResult = ReturnType<typeof useGetSubAnswersEnvironmentLazyQuery_>;
export type GetSubAnswersEnvironmentSuspenseQuery_HookResult = ReturnType<typeof useGetSubAnswersEnvironmentSuspenseQuery_>;
export type GetSubAnswersEnvironmentQueryResult_ = Apollo.QueryResult<GetSubAnswersEnvironmentQuery_, GetSubAnswersEnvironmentQueryVariables_>;
export function refetchGetSubAnswersEnvironmentQuery_(variables: GetSubAnswersEnvironmentQueryVariables_) {
      return { query: GetSubAnswersEnvironmentDocument_, variables: variables }
    }
export const GetSubAnswersOtherDocument_ = gql`
    query GetSubAnswersOther($esrsAssessmentId: uuid!, $environmentDisclosures: [String!]!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    subsidiaryAssessments(where: {deletedAt: {_is_null: true}}) {
      id
      reportingUnits {
        id
        name
        isCompanyLevel
        answers(
          where: {hasOptedOut: {_eq: false}, metric: {_or: [{disclosureRequirementRef: {_nin: $environmentDisclosures}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {drToMFDisclosureRequirements: {disclosureRequirementRef: {_nin: $environmentDisclosures}}}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_nin: $environmentDisclosures}}}}]}}
        ) {
          ...ReportingUnitAnswersFieldsForAggregatedLevel
        }
      }
    }
  }
}
    ${ReportingUnitAnswersFieldsForAggregatedLevelFragmentDoc_}`;

/**
 * __useGetSubAnswersOtherQuery__
 *
 * To run a query within a React component, call `useGetSubAnswersOtherQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubAnswersOtherQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubAnswersOtherQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      environmentDisclosures: // value for 'environmentDisclosures'
 *   },
 * });
 */
export function useGetSubAnswersOtherQuery(baseOptions: Apollo.QueryHookOptions<GetSubAnswersOtherQuery_, GetSubAnswersOtherQueryVariables_> & ({ variables: GetSubAnswersOtherQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubAnswersOtherQuery_, GetSubAnswersOtherQueryVariables_>(GetSubAnswersOtherDocument_, options);
      }
export function useGetSubAnswersOtherLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubAnswersOtherQuery_, GetSubAnswersOtherQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubAnswersOtherQuery_, GetSubAnswersOtherQueryVariables_>(GetSubAnswersOtherDocument_, options);
        }
export function useGetSubAnswersOtherSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubAnswersOtherQuery_, GetSubAnswersOtherQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubAnswersOtherQuery_, GetSubAnswersOtherQueryVariables_>(GetSubAnswersOtherDocument_, options);
        }
export type GetSubAnswersOtherQueryHookResult = ReturnType<typeof useGetSubAnswersOtherQuery>;
export type GetSubAnswersOtherLazyQuery_HookResult = ReturnType<typeof useGetSubAnswersOtherLazyQuery_>;
export type GetSubAnswersOtherSuspenseQuery_HookResult = ReturnType<typeof useGetSubAnswersOtherSuspenseQuery_>;
export type GetSubAnswersOtherQueryResult_ = Apollo.QueryResult<GetSubAnswersOtherQuery_, GetSubAnswersOtherQueryVariables_>;
export function refetchGetSubAnswersOtherQuery_(variables: GetSubAnswersOtherQueryVariables_) {
      return { query: GetSubAnswersOtherDocument_, variables: variables }
    }
export const GetDatapointsPerDrDocument_ = gql`
    query getDatapointsPerDr($drRef: String!) {
  esrs_Datapoint(
    where: {answer: {metric: {disclosureRequirementRef: {_eq: $drRef}}}}
  ) {
    id
    answer {
      metric {
        reference
        metricType
      }
    }
    datapointTags {
      tagType
      tagValue
    }
  }
}
    `;

/**
 * __useGetDatapointsPerDrQuery__
 *
 * To run a query within a React component, call `useGetDatapointsPerDrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatapointsPerDrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatapointsPerDrQuery({
 *   variables: {
 *      drRef: // value for 'drRef'
 *   },
 * });
 */
export function useGetDatapointsPerDrQuery(baseOptions: Apollo.QueryHookOptions<GetDatapointsPerDrQuery_, GetDatapointsPerDrQueryVariables_> & ({ variables: GetDatapointsPerDrQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatapointsPerDrQuery_, GetDatapointsPerDrQueryVariables_>(GetDatapointsPerDrDocument_, options);
      }
export function useGetDatapointsPerDrLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDatapointsPerDrQuery_, GetDatapointsPerDrQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatapointsPerDrQuery_, GetDatapointsPerDrQueryVariables_>(GetDatapointsPerDrDocument_, options);
        }
export function useGetDatapointsPerDrSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatapointsPerDrQuery_, GetDatapointsPerDrQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatapointsPerDrQuery_, GetDatapointsPerDrQueryVariables_>(GetDatapointsPerDrDocument_, options);
        }
export type GetDatapointsPerDrQueryHookResult = ReturnType<typeof useGetDatapointsPerDrQuery>;
export type GetDatapointsPerDrLazyQuery_HookResult = ReturnType<typeof useGetDatapointsPerDrLazyQuery_>;
export type GetDatapointsPerDrSuspenseQuery_HookResult = ReturnType<typeof useGetDatapointsPerDrSuspenseQuery_>;
export type GetDatapointsPerDrQueryResult_ = Apollo.QueryResult<GetDatapointsPerDrQuery_, GetDatapointsPerDrQueryVariables_>;
export function refetchGetDatapointsPerDrQuery_(variables: GetDatapointsPerDrQueryVariables_) {
      return { query: GetDatapointsPerDrDocument_, variables: variables }
    }
export const GetSubMaterialMetricsOnGroupLevelDocument_ = gql`
    query getSubMaterialMetricsOnGroupLevel($esrsAssessmentId: uuid!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    subsidiaryAssessments(where: {deletedAt: {_is_null: true}}) {
      id
      company {
        id
        name
        currency
      }
      materialStandards {
        id
        standardRef
        materialMetrics {
          ...MaterialMetricWithChildrenFieldsForAggregatedLevel
        }
      }
    }
  }
}
    ${MaterialMetricWithChildrenFieldsForAggregatedLevelFragmentDoc_}`;

/**
 * __useGetSubMaterialMetricsOnGroupLevelQuery__
 *
 * To run a query within a React component, call `useGetSubMaterialMetricsOnGroupLevelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubMaterialMetricsOnGroupLevelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubMaterialMetricsOnGroupLevelQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetSubMaterialMetricsOnGroupLevelQuery(baseOptions: Apollo.QueryHookOptions<GetSubMaterialMetricsOnGroupLevelQuery_, GetSubMaterialMetricsOnGroupLevelQueryVariables_> & ({ variables: GetSubMaterialMetricsOnGroupLevelQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubMaterialMetricsOnGroupLevelQuery_, GetSubMaterialMetricsOnGroupLevelQueryVariables_>(GetSubMaterialMetricsOnGroupLevelDocument_, options);
      }
export function useGetSubMaterialMetricsOnGroupLevelLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubMaterialMetricsOnGroupLevelQuery_, GetSubMaterialMetricsOnGroupLevelQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubMaterialMetricsOnGroupLevelQuery_, GetSubMaterialMetricsOnGroupLevelQueryVariables_>(GetSubMaterialMetricsOnGroupLevelDocument_, options);
        }
export function useGetSubMaterialMetricsOnGroupLevelSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubMaterialMetricsOnGroupLevelQuery_, GetSubMaterialMetricsOnGroupLevelQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubMaterialMetricsOnGroupLevelQuery_, GetSubMaterialMetricsOnGroupLevelQueryVariables_>(GetSubMaterialMetricsOnGroupLevelDocument_, options);
        }
export type GetSubMaterialMetricsOnGroupLevelQueryHookResult = ReturnType<typeof useGetSubMaterialMetricsOnGroupLevelQuery>;
export type GetSubMaterialMetricsOnGroupLevelLazyQuery_HookResult = ReturnType<typeof useGetSubMaterialMetricsOnGroupLevelLazyQuery_>;
export type GetSubMaterialMetricsOnGroupLevelSuspenseQuery_HookResult = ReturnType<typeof useGetSubMaterialMetricsOnGroupLevelSuspenseQuery_>;
export type GetSubMaterialMetricsOnGroupLevelQueryResult_ = Apollo.QueryResult<GetSubMaterialMetricsOnGroupLevelQuery_, GetSubMaterialMetricsOnGroupLevelQueryVariables_>;
export function refetchGetSubMaterialMetricsOnGroupLevelQuery_(variables: GetSubMaterialMetricsOnGroupLevelQueryVariables_) {
      return { query: GetSubMaterialMetricsOnGroupLevelDocument_, variables: variables }
    }
export const GetEsrsMetricsAnswerssDocument_ = gql`
    query getEsrsMetricsAnswerss($reportingUnitId: uuid!, $assessmentId: uuid!, $metricRefs: [String!]!) {
  answers: esrs_Answer(
    where: {reportingUnitId: {_eq: $reportingUnitId}, assessmentId: {_eq: $assessmentId}, metricRef: {_in: $metricRefs}}
  ) {
    ...EsrsAnswersFields
  }
}
    ${EsrsAnswersFieldsFragmentDoc_}`;

/**
 * __useGetEsrsMetricsAnswerssQuery__
 *
 * To run a query within a React component, call `useGetEsrsMetricsAnswerssQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsrsMetricsAnswerssQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsrsMetricsAnswerssQuery({
 *   variables: {
 *      reportingUnitId: // value for 'reportingUnitId'
 *      assessmentId: // value for 'assessmentId'
 *      metricRefs: // value for 'metricRefs'
 *   },
 * });
 */
export function useGetEsrsMetricsAnswerssQuery(baseOptions: Apollo.QueryHookOptions<GetEsrsMetricsAnswerssQuery_, GetEsrsMetricsAnswerssQueryVariables_> & ({ variables: GetEsrsMetricsAnswerssQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsrsMetricsAnswerssQuery_, GetEsrsMetricsAnswerssQueryVariables_>(GetEsrsMetricsAnswerssDocument_, options);
      }
export function useGetEsrsMetricsAnswerssLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetEsrsMetricsAnswerssQuery_, GetEsrsMetricsAnswerssQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsrsMetricsAnswerssQuery_, GetEsrsMetricsAnswerssQueryVariables_>(GetEsrsMetricsAnswerssDocument_, options);
        }
export function useGetEsrsMetricsAnswerssSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEsrsMetricsAnswerssQuery_, GetEsrsMetricsAnswerssQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEsrsMetricsAnswerssQuery_, GetEsrsMetricsAnswerssQueryVariables_>(GetEsrsMetricsAnswerssDocument_, options);
        }
export type GetEsrsMetricsAnswerssQueryHookResult = ReturnType<typeof useGetEsrsMetricsAnswerssQuery>;
export type GetEsrsMetricsAnswerssLazyQuery_HookResult = ReturnType<typeof useGetEsrsMetricsAnswerssLazyQuery_>;
export type GetEsrsMetricsAnswerssSuspenseQuery_HookResult = ReturnType<typeof useGetEsrsMetricsAnswerssSuspenseQuery_>;
export type GetEsrsMetricsAnswerssQueryResult_ = Apollo.QueryResult<GetEsrsMetricsAnswerssQuery_, GetEsrsMetricsAnswerssQueryVariables_>;
export function refetchGetEsrsMetricsAnswerssQuery_(variables: GetEsrsMetricsAnswerssQueryVariables_) {
      return { query: GetEsrsMetricsAnswerssDocument_, variables: variables }
    }
export const GetEsrsMetricsAnswersDocument_ = gql`
    subscription getEsrsMetricsAnswers($reportingUnitId: uuid!, $assessmentId: uuid!, $metricRefs: [String!]!) {
  answers: esrs_Answer(
    where: {reportingUnitId: {_eq: $reportingUnitId}, assessmentId: {_eq: $assessmentId}, metricRef: {_in: $metricRefs}}
  ) {
    ...EsrsAnswersFields
  }
}
    ${EsrsAnswersFieldsFragmentDoc_}`;

/**
 * __useGetEsrsMetricsAnswersSubscription__
 *
 * To run a query within a React component, call `useGetEsrsMetricsAnswersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetEsrsMetricsAnswersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsrsMetricsAnswersSubscription({
 *   variables: {
 *      reportingUnitId: // value for 'reportingUnitId'
 *      assessmentId: // value for 'assessmentId'
 *      metricRefs: // value for 'metricRefs'
 *   },
 * });
 */
export function useGetEsrsMetricsAnswersSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetEsrsMetricsAnswersSubscription_, GetEsrsMetricsAnswersSubscriptionVariables_> & ({ variables: GetEsrsMetricsAnswersSubscriptionVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetEsrsMetricsAnswersSubscription_, GetEsrsMetricsAnswersSubscriptionVariables_>(GetEsrsMetricsAnswersDocument_, options);
      }
export type GetEsrsMetricsAnswersSubscriptionHookResult = ReturnType<typeof useGetEsrsMetricsAnswersSubscription>;
export type GetEsrsMetricsAnswersSubscriptionResult_ = Apollo.SubscriptionResult<GetEsrsMetricsAnswersSubscription_>;
export const GetEsrsMetricAnswerDocument_ = gql`
    subscription getEsrsMetricAnswer($reportingUnitId: uuid!, $assessmentId: uuid!, $metricRef: String!) {
  esrs_Answer(
    where: {reportingUnitId: {_eq: $reportingUnitId}, assessmentId: {_eq: $assessmentId}, metricRef: {_eq: $metricRef}}
  ) {
    ...EsrsAnswersFields
  }
}
    ${EsrsAnswersFieldsFragmentDoc_}`;

/**
 * __useGetEsrsMetricAnswerSubscription__
 *
 * To run a query within a React component, call `useGetEsrsMetricAnswerSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetEsrsMetricAnswerSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsrsMetricAnswerSubscription({
 *   variables: {
 *      reportingUnitId: // value for 'reportingUnitId'
 *      assessmentId: // value for 'assessmentId'
 *      metricRef: // value for 'metricRef'
 *   },
 * });
 */
export function useGetEsrsMetricAnswerSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetEsrsMetricAnswerSubscription_, GetEsrsMetricAnswerSubscriptionVariables_> & ({ variables: GetEsrsMetricAnswerSubscriptionVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetEsrsMetricAnswerSubscription_, GetEsrsMetricAnswerSubscriptionVariables_>(GetEsrsMetricAnswerDocument_, options);
      }
export type GetEsrsMetricAnswerSubscriptionHookResult = ReturnType<typeof useGetEsrsMetricAnswerSubscription>;
export type GetEsrsMetricAnswerSubscriptionResult_ = Apollo.SubscriptionResult<GetEsrsMetricAnswerSubscription_>;
export const GetEsrsMetricAnswersDocument_ = gql`
    query getEsrsMetricAnswers($assessmentId: uuid!, $metricRef: String!) {
  esrs_Answer(
    where: {assessmentId: {_eq: $assessmentId}, metricRef: {_eq: $metricRef}}
  ) {
    reportingUnit {
      id
      name
      isCompanyLevel
    }
    ...EsrsAnswersFields
    metric {
      ...ShortMetric
      unitOfMeasurement
    }
  }
}
    ${EsrsAnswersFieldsFragmentDoc_}
${ShortMetricFragmentDoc_}`;

/**
 * __useGetEsrsMetricAnswersQuery__
 *
 * To run a query within a React component, call `useGetEsrsMetricAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsrsMetricAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsrsMetricAnswersQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      metricRef: // value for 'metricRef'
 *   },
 * });
 */
export function useGetEsrsMetricAnswersQuery(baseOptions: Apollo.QueryHookOptions<GetEsrsMetricAnswersQuery_, GetEsrsMetricAnswersQueryVariables_> & ({ variables: GetEsrsMetricAnswersQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsrsMetricAnswersQuery_, GetEsrsMetricAnswersQueryVariables_>(GetEsrsMetricAnswersDocument_, options);
      }
export function useGetEsrsMetricAnswersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetEsrsMetricAnswersQuery_, GetEsrsMetricAnswersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsrsMetricAnswersQuery_, GetEsrsMetricAnswersQueryVariables_>(GetEsrsMetricAnswersDocument_, options);
        }
export function useGetEsrsMetricAnswersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEsrsMetricAnswersQuery_, GetEsrsMetricAnswersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEsrsMetricAnswersQuery_, GetEsrsMetricAnswersQueryVariables_>(GetEsrsMetricAnswersDocument_, options);
        }
export type GetEsrsMetricAnswersQueryHookResult = ReturnType<typeof useGetEsrsMetricAnswersQuery>;
export type GetEsrsMetricAnswersLazyQuery_HookResult = ReturnType<typeof useGetEsrsMetricAnswersLazyQuery_>;
export type GetEsrsMetricAnswersSuspenseQuery_HookResult = ReturnType<typeof useGetEsrsMetricAnswersSuspenseQuery_>;
export type GetEsrsMetricAnswersQueryResult_ = Apollo.QueryResult<GetEsrsMetricAnswersQuery_, GetEsrsMetricAnswersQueryVariables_>;
export function refetchGetEsrsMetricAnswersQuery_(variables: GetEsrsMetricAnswersQueryVariables_) {
      return { query: GetEsrsMetricAnswersDocument_, variables: variables }
    }
export const GetMetricAnswersDocument_ = gql`
    query getMetricAnswers($reportingUnitId: uuid!) {
  esrs_Answer(where: {reportingUnitId: {_eq: $reportingUnitId}}) {
    ...EsrsAnswersFields
  }
}
    ${EsrsAnswersFieldsFragmentDoc_}`;

/**
 * __useGetMetricAnswersQuery__
 *
 * To run a query within a React component, call `useGetMetricAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricAnswersQuery({
 *   variables: {
 *      reportingUnitId: // value for 'reportingUnitId'
 *   },
 * });
 */
export function useGetMetricAnswersQuery(baseOptions: Apollo.QueryHookOptions<GetMetricAnswersQuery_, GetMetricAnswersQueryVariables_> & ({ variables: GetMetricAnswersQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricAnswersQuery_, GetMetricAnswersQueryVariables_>(GetMetricAnswersDocument_, options);
      }
export function useGetMetricAnswersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricAnswersQuery_, GetMetricAnswersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricAnswersQuery_, GetMetricAnswersQueryVariables_>(GetMetricAnswersDocument_, options);
        }
export function useGetMetricAnswersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricAnswersQuery_, GetMetricAnswersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricAnswersQuery_, GetMetricAnswersQueryVariables_>(GetMetricAnswersDocument_, options);
        }
export type GetMetricAnswersQueryHookResult = ReturnType<typeof useGetMetricAnswersQuery>;
export type GetMetricAnswersLazyQuery_HookResult = ReturnType<typeof useGetMetricAnswersLazyQuery_>;
export type GetMetricAnswersSuspenseQuery_HookResult = ReturnType<typeof useGetMetricAnswersSuspenseQuery_>;
export type GetMetricAnswersQueryResult_ = Apollo.QueryResult<GetMetricAnswersQuery_, GetMetricAnswersQueryVariables_>;
export function refetchGetMetricAnswersQuery_(variables: GetMetricAnswersQueryVariables_) {
      return { query: GetMetricAnswersDocument_, variables: variables }
    }
export const GetMetricAnswersPerDrDocument_ = gql`
    query getMetricAnswersPerDr($reportingUnitId: uuid!, $drRef: String!, $frameworkRef: String!) {
  esrs_Answer(
    where: {_and: [{reportingUnitId: {_eq: $reportingUnitId}}, {metric: {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}}]}
  ) {
    ...EsrsAnswersFields
  }
}
    ${EsrsAnswersFieldsFragmentDoc_}`;

/**
 * __useGetMetricAnswersPerDrQuery__
 *
 * To run a query within a React component, call `useGetMetricAnswersPerDrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricAnswersPerDrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricAnswersPerDrQuery({
 *   variables: {
 *      reportingUnitId: // value for 'reportingUnitId'
 *      drRef: // value for 'drRef'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetMetricAnswersPerDrQuery(baseOptions: Apollo.QueryHookOptions<GetMetricAnswersPerDrQuery_, GetMetricAnswersPerDrQueryVariables_> & ({ variables: GetMetricAnswersPerDrQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricAnswersPerDrQuery_, GetMetricAnswersPerDrQueryVariables_>(GetMetricAnswersPerDrDocument_, options);
      }
export function useGetMetricAnswersPerDrLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricAnswersPerDrQuery_, GetMetricAnswersPerDrQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricAnswersPerDrQuery_, GetMetricAnswersPerDrQueryVariables_>(GetMetricAnswersPerDrDocument_, options);
        }
export function useGetMetricAnswersPerDrSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricAnswersPerDrQuery_, GetMetricAnswersPerDrQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricAnswersPerDrQuery_, GetMetricAnswersPerDrQueryVariables_>(GetMetricAnswersPerDrDocument_, options);
        }
export type GetMetricAnswersPerDrQueryHookResult = ReturnType<typeof useGetMetricAnswersPerDrQuery>;
export type GetMetricAnswersPerDrLazyQuery_HookResult = ReturnType<typeof useGetMetricAnswersPerDrLazyQuery_>;
export type GetMetricAnswersPerDrSuspenseQuery_HookResult = ReturnType<typeof useGetMetricAnswersPerDrSuspenseQuery_>;
export type GetMetricAnswersPerDrQueryResult_ = Apollo.QueryResult<GetMetricAnswersPerDrQuery_, GetMetricAnswersPerDrQueryVariables_>;
export function refetchGetMetricAnswersPerDrQuery_(variables: GetMetricAnswersPerDrQueryVariables_) {
      return { query: GetMetricAnswersPerDrDocument_, variables: variables }
    }
export const GetSingleEsrsMetricAnswerDocument_ = gql`
    query getSingleEsrsMetricAnswer($reportingUnitId: uuid!, $assessmentId: uuid!, $metricRef: String!) {
  esrs_Answer(
    where: {reportingUnitId: {_eq: $reportingUnitId}, assessmentId: {_eq: $assessmentId}, metricRef: {_eq: $metricRef}}
  ) {
    ...EsrsAnswersFields
  }
}
    ${EsrsAnswersFieldsFragmentDoc_}`;

/**
 * __useGetSingleEsrsMetricAnswerQuery__
 *
 * To run a query within a React component, call `useGetSingleEsrsMetricAnswerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSingleEsrsMetricAnswerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSingleEsrsMetricAnswerQuery({
 *   variables: {
 *      reportingUnitId: // value for 'reportingUnitId'
 *      assessmentId: // value for 'assessmentId'
 *      metricRef: // value for 'metricRef'
 *   },
 * });
 */
export function useGetSingleEsrsMetricAnswerQuery(baseOptions: Apollo.QueryHookOptions<GetSingleEsrsMetricAnswerQuery_, GetSingleEsrsMetricAnswerQueryVariables_> & ({ variables: GetSingleEsrsMetricAnswerQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSingleEsrsMetricAnswerQuery_, GetSingleEsrsMetricAnswerQueryVariables_>(GetSingleEsrsMetricAnswerDocument_, options);
      }
export function useGetSingleEsrsMetricAnswerLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSingleEsrsMetricAnswerQuery_, GetSingleEsrsMetricAnswerQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSingleEsrsMetricAnswerQuery_, GetSingleEsrsMetricAnswerQueryVariables_>(GetSingleEsrsMetricAnswerDocument_, options);
        }
export function useGetSingleEsrsMetricAnswerSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSingleEsrsMetricAnswerQuery_, GetSingleEsrsMetricAnswerQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSingleEsrsMetricAnswerQuery_, GetSingleEsrsMetricAnswerQueryVariables_>(GetSingleEsrsMetricAnswerDocument_, options);
        }
export type GetSingleEsrsMetricAnswerQueryHookResult = ReturnType<typeof useGetSingleEsrsMetricAnswerQuery>;
export type GetSingleEsrsMetricAnswerLazyQuery_HookResult = ReturnType<typeof useGetSingleEsrsMetricAnswerLazyQuery_>;
export type GetSingleEsrsMetricAnswerSuspenseQuery_HookResult = ReturnType<typeof useGetSingleEsrsMetricAnswerSuspenseQuery_>;
export type GetSingleEsrsMetricAnswerQueryResult_ = Apollo.QueryResult<GetSingleEsrsMetricAnswerQuery_, GetSingleEsrsMetricAnswerQueryVariables_>;
export function refetchGetSingleEsrsMetricAnswerQuery_(variables: GetSingleEsrsMetricAnswerQueryVariables_) {
      return { query: GetSingleEsrsMetricAnswerDocument_, variables: variables }
    }
export const UpsertMetricsAnswerDocument_ = gql`
    mutation upsertMetricsAnswer($objects: [esrs_Answer_insert_input!]!) {
  insert_esrs_Answer(
    objects: $objects
    on_conflict: {constraint: Answer_metricRef_assessmentId_reportingUnitId_key, update_columns: [hasOptedOut, optOutReason, optOutAuthorId]}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpsertMetricsAnswerMutationFn_ = Apollo.MutationFunction<UpsertMetricsAnswerMutation_, UpsertMetricsAnswerMutationVariables_>;

/**
 * __useUpsertMetricsAnswerMutation__
 *
 * To run a mutation, you first call `useUpsertMetricsAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMetricsAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMetricsAnswerMutation, { data, loading, error }] = useUpsertMetricsAnswerMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertMetricsAnswerMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMetricsAnswerMutation_, UpsertMetricsAnswerMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMetricsAnswerMutation_, UpsertMetricsAnswerMutationVariables_>(UpsertMetricsAnswerDocument_, options);
      }
export type UpsertMetricsAnswerMutationHookResult = ReturnType<typeof useUpsertMetricsAnswerMutation>;
export type UpsertMetricsAnswerMutationResult_ = Apollo.MutationResult<UpsertMetricsAnswerMutation_>;
export type UpsertMetricsAnswerMutationOptions_ = Apollo.BaseMutationOptions<UpsertMetricsAnswerMutation_, UpsertMetricsAnswerMutationVariables_>;
export const UpsertDatapointDocument_ = gql`
    mutation upsertDatapoint($objects: [esrs_Datapoint_insert_input!]!) {
  insert_esrs_Datapoint(
    objects: $objects
    on_conflict: {constraint: Datapoint_answerId_timeframe_tagCombination_key, update_columns: [value, factValue, authorId, source, metadata, lastEdited]}
  ) {
    returning {
      id
      answer {
        ...EsrsAnswersFields
      }
      thread {
        id
      }
    }
  }
}
    ${EsrsAnswersFieldsFragmentDoc_}`;
export type UpsertDatapointMutationFn_ = Apollo.MutationFunction<UpsertDatapointMutation_, UpsertDatapointMutationVariables_>;

/**
 * __useUpsertDatapointMutation__
 *
 * To run a mutation, you first call `useUpsertDatapointMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDatapointMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDatapointMutation, { data, loading, error }] = useUpsertDatapointMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertDatapointMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDatapointMutation_, UpsertDatapointMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDatapointMutation_, UpsertDatapointMutationVariables_>(UpsertDatapointDocument_, options);
      }
export type UpsertDatapointMutationHookResult = ReturnType<typeof useUpsertDatapointMutation>;
export type UpsertDatapointMutationResult_ = Apollo.MutationResult<UpsertDatapointMutation_>;
export type UpsertDatapointMutationOptions_ = Apollo.BaseMutationOptions<UpsertDatapointMutation_, UpsertDatapointMutationVariables_>;
export const UpsertDatapointTaskDocument_ = gql`
    mutation upsertDatapointTask($objects: [esrs_Datapoint_insert_input!]!) {
  insert_esrs_Datapoint(
    objects: $objects
    on_conflict: {constraint: Datapoint_answerId_timeframe_tagCombination_key, update_columns: [taskId]}
  ) {
    returning {
      id
      value
      factValue
      task {
        id
        status
      }
    }
  }
}
    `;
export type UpsertDatapointTaskMutationFn_ = Apollo.MutationFunction<UpsertDatapointTaskMutation_, UpsertDatapointTaskMutationVariables_>;

/**
 * __useUpsertDatapointTaskMutation__
 *
 * To run a mutation, you first call `useUpsertDatapointTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDatapointTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDatapointTaskMutation, { data, loading, error }] = useUpsertDatapointTaskMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertDatapointTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDatapointTaskMutation_, UpsertDatapointTaskMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDatapointTaskMutation_, UpsertDatapointTaskMutationVariables_>(UpsertDatapointTaskDocument_, options);
      }
export type UpsertDatapointTaskMutationHookResult = ReturnType<typeof useUpsertDatapointTaskMutation>;
export type UpsertDatapointTaskMutationResult_ = Apollo.MutationResult<UpsertDatapointTaskMutation_>;
export type UpsertDatapointTaskMutationOptions_ = Apollo.BaseMutationOptions<UpsertDatapointTaskMutation_, UpsertDatapointTaskMutationVariables_>;
export const DeleteDatapointChoicesDocument_ = gql`
    mutation deleteDatapointChoices($datapointId: uuid!, $choices: [String!]!) {
  delete_esrs_DatapointChoice(
    where: {_and: [{datapointId: {_eq: $datapointId}}, {choiceRef: {_in: $choices}}]}
  ) {
    affected_rows
  }
}
    `;
export type DeleteDatapointChoicesMutationFn_ = Apollo.MutationFunction<DeleteDatapointChoicesMutation_, DeleteDatapointChoicesMutationVariables_>;

/**
 * __useDeleteDatapointChoicesMutation__
 *
 * To run a mutation, you first call `useDeleteDatapointChoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDatapointChoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDatapointChoicesMutation, { data, loading, error }] = useDeleteDatapointChoicesMutation({
 *   variables: {
 *      datapointId: // value for 'datapointId'
 *      choices: // value for 'choices'
 *   },
 * });
 */
export function useDeleteDatapointChoicesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDatapointChoicesMutation_, DeleteDatapointChoicesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDatapointChoicesMutation_, DeleteDatapointChoicesMutationVariables_>(DeleteDatapointChoicesDocument_, options);
      }
export type DeleteDatapointChoicesMutationHookResult = ReturnType<typeof useDeleteDatapointChoicesMutation>;
export type DeleteDatapointChoicesMutationResult_ = Apollo.MutationResult<DeleteDatapointChoicesMutation_>;
export type DeleteDatapointChoicesMutationOptions_ = Apollo.BaseMutationOptions<DeleteDatapointChoicesMutation_, DeleteDatapointChoicesMutationVariables_>;
export const GetOptedOutMetricsDocument_ = gql`
    query getOptedOutMetrics($reportingUnitId: uuid!, $assessmentId: uuid!, $drRef: String) {
  esrs_Answer(
    where: {reportingUnitId: {_eq: $reportingUnitId}, assessmentId: {_eq: $assessmentId}, metric: {_or: [{disclosureRequirementRef: {_eq: $drRef}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {drToMFDisclosureRequirements: {disclosureRequirementRef: {_eq: $drRef}}}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}, hasOptedOut: {_eq: true}}
  ) {
    metric {
      reference
    }
  }
}
    `;

/**
 * __useGetOptedOutMetricsQuery__
 *
 * To run a query within a React component, call `useGetOptedOutMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptedOutMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptedOutMetricsQuery({
 *   variables: {
 *      reportingUnitId: // value for 'reportingUnitId'
 *      assessmentId: // value for 'assessmentId'
 *      drRef: // value for 'drRef'
 *   },
 * });
 */
export function useGetOptedOutMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetOptedOutMetricsQuery_, GetOptedOutMetricsQueryVariables_> & ({ variables: GetOptedOutMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOptedOutMetricsQuery_, GetOptedOutMetricsQueryVariables_>(GetOptedOutMetricsDocument_, options);
      }
export function useGetOptedOutMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetOptedOutMetricsQuery_, GetOptedOutMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOptedOutMetricsQuery_, GetOptedOutMetricsQueryVariables_>(GetOptedOutMetricsDocument_, options);
        }
export function useGetOptedOutMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOptedOutMetricsQuery_, GetOptedOutMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOptedOutMetricsQuery_, GetOptedOutMetricsQueryVariables_>(GetOptedOutMetricsDocument_, options);
        }
export type GetOptedOutMetricsQueryHookResult = ReturnType<typeof useGetOptedOutMetricsQuery>;
export type GetOptedOutMetricsLazyQuery_HookResult = ReturnType<typeof useGetOptedOutMetricsLazyQuery_>;
export type GetOptedOutMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetOptedOutMetricsSuspenseQuery_>;
export type GetOptedOutMetricsQueryResult_ = Apollo.QueryResult<GetOptedOutMetricsQuery_, GetOptedOutMetricsQueryVariables_>;
export function refetchGetOptedOutMetricsQuery_(variables: GetOptedOutMetricsQueryVariables_) {
      return { query: GetOptedOutMetricsDocument_, variables: variables }
    }
export const DisclosureRequirementStatusDocument_ = gql`
    query DisclosureRequirementStatus($disclosureRequirementRef: String!, $materialStandardId: uuid!) {
  drInfo: DisclosureRequirement_by_pk(reference: $disclosureRequirementRef) {
    title
    type
  }
  drStatus: DisclosureRequirementStatus(
    where: {disclosureRequirementRef: {_eq: $disclosureRequirementRef}, materialStandardId: {_eq: $materialStandardId}}
  ) {
    isConfigured
  }
}
    `;

/**
 * __useDisclosureRequirementStatusQuery__
 *
 * To run a query within a React component, call `useDisclosureRequirementStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisclosureRequirementStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisclosureRequirementStatusQuery({
 *   variables: {
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *      materialStandardId: // value for 'materialStandardId'
 *   },
 * });
 */
export function useDisclosureRequirementStatusQuery(baseOptions: Apollo.QueryHookOptions<DisclosureRequirementStatusQuery_, DisclosureRequirementStatusQueryVariables_> & ({ variables: DisclosureRequirementStatusQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DisclosureRequirementStatusQuery_, DisclosureRequirementStatusQueryVariables_>(DisclosureRequirementStatusDocument_, options);
      }
export function useDisclosureRequirementStatusLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<DisclosureRequirementStatusQuery_, DisclosureRequirementStatusQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DisclosureRequirementStatusQuery_, DisclosureRequirementStatusQueryVariables_>(DisclosureRequirementStatusDocument_, options);
        }
export function useDisclosureRequirementStatusSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DisclosureRequirementStatusQuery_, DisclosureRequirementStatusQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DisclosureRequirementStatusQuery_, DisclosureRequirementStatusQueryVariables_>(DisclosureRequirementStatusDocument_, options);
        }
export type DisclosureRequirementStatusQueryHookResult = ReturnType<typeof useDisclosureRequirementStatusQuery>;
export type DisclosureRequirementStatusLazyQuery_HookResult = ReturnType<typeof useDisclosureRequirementStatusLazyQuery_>;
export type DisclosureRequirementStatusSuspenseQuery_HookResult = ReturnType<typeof useDisclosureRequirementStatusSuspenseQuery_>;
export type DisclosureRequirementStatusQueryResult_ = Apollo.QueryResult<DisclosureRequirementStatusQuery_, DisclosureRequirementStatusQueryVariables_>;
export function refetchDisclosureRequirementStatusQuery_(variables: DisclosureRequirementStatusQueryVariables_) {
      return { query: DisclosureRequirementStatusDocument_, variables: variables }
    }
export const MfDisclosureRequirementStatusDocument_ = gql`
    query MFDisclosureRequirementStatus($mfDisclosureRequirementRef: String!, $materialStandardId: uuid!) {
  drInfo: MFDisclosureRequirement_by_pk(reference: $mfDisclosureRequirementRef) {
    title
    type
  }
  drStatus: DisclosureRequirementStatus(
    where: {mfDisclosureRequirementRef: {_eq: $mfDisclosureRequirementRef}, materialStandardId: {_eq: $materialStandardId}}
  ) {
    isConfigured
  }
}
    `;

/**
 * __useMfDisclosureRequirementStatusQuery__
 *
 * To run a query within a React component, call `useMfDisclosureRequirementStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMfDisclosureRequirementStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMfDisclosureRequirementStatusQuery({
 *   variables: {
 *      mfDisclosureRequirementRef: // value for 'mfDisclosureRequirementRef'
 *      materialStandardId: // value for 'materialStandardId'
 *   },
 * });
 */
export function useMfDisclosureRequirementStatusQuery(baseOptions: Apollo.QueryHookOptions<MfDisclosureRequirementStatusQuery_, MfDisclosureRequirementStatusQueryVariables_> & ({ variables: MfDisclosureRequirementStatusQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MfDisclosureRequirementStatusQuery_, MfDisclosureRequirementStatusQueryVariables_>(MfDisclosureRequirementStatusDocument_, options);
      }
export function useMfDisclosureRequirementStatusLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<MfDisclosureRequirementStatusQuery_, MfDisclosureRequirementStatusQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MfDisclosureRequirementStatusQuery_, MfDisclosureRequirementStatusQueryVariables_>(MfDisclosureRequirementStatusDocument_, options);
        }
export function useMfDisclosureRequirementStatusSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MfDisclosureRequirementStatusQuery_, MfDisclosureRequirementStatusQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MfDisclosureRequirementStatusQuery_, MfDisclosureRequirementStatusQueryVariables_>(MfDisclosureRequirementStatusDocument_, options);
        }
export type MfDisclosureRequirementStatusQueryHookResult = ReturnType<typeof useMfDisclosureRequirementStatusQuery>;
export type MfDisclosureRequirementStatusLazyQuery_HookResult = ReturnType<typeof useMfDisclosureRequirementStatusLazyQuery_>;
export type MfDisclosureRequirementStatusSuspenseQuery_HookResult = ReturnType<typeof useMfDisclosureRequirementStatusSuspenseQuery_>;
export type MfDisclosureRequirementStatusQueryResult_ = Apollo.QueryResult<MfDisclosureRequirementStatusQuery_, MfDisclosureRequirementStatusQueryVariables_>;
export function refetchMfDisclosureRequirementStatusQuery_(variables: MfDisclosureRequirementStatusQueryVariables_) {
      return { query: MfDisclosureRequirementStatusDocument_, variables: variables }
    }
export const GetRequiredDataCollectionMaterialMetricsDocument_ = gql`
    query getRequiredDataCollectionMaterialMetrics($disclosureRequirementRef: String!, $materialStandardId: uuid!, $frameworkRef: String!, $parentStandardId: uuid!) {
  esrs_MaterialMetric(
    where: {metric: {_or: [{disclosureRequirementRef: {_eq: $disclosureRequirementRef}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {drToMFDisclosureRequirements: {disclosureRequirementRef: {_eq: $disclosureRequirementRef}}}}, requirement: {frameworkRef: {_neq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $disclosureRequirementRef}}}}]}, _or: [{isMaterial: {_eq: true}, materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}}, {isMaterial: {_eq: true}, materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}, metric: {hierarchyStatus: {isLeaf: {_eq: true}}}}]}
  ) {
    id
    dataCollection
    materialStandardId
    metric {
      reference
    }
  }
}
    `;

/**
 * __useGetRequiredDataCollectionMaterialMetricsQuery__
 *
 * To run a query within a React component, call `useGetRequiredDataCollectionMaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredDataCollectionMaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredDataCollectionMaterialMetricsQuery({
 *   variables: {
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *      materialStandardId: // value for 'materialStandardId'
 *      frameworkRef: // value for 'frameworkRef'
 *      parentStandardId: // value for 'parentStandardId'
 *   },
 * });
 */
export function useGetRequiredDataCollectionMaterialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetRequiredDataCollectionMaterialMetricsQuery_, GetRequiredDataCollectionMaterialMetricsQueryVariables_> & ({ variables: GetRequiredDataCollectionMaterialMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequiredDataCollectionMaterialMetricsQuery_, GetRequiredDataCollectionMaterialMetricsQueryVariables_>(GetRequiredDataCollectionMaterialMetricsDocument_, options);
      }
export function useGetRequiredDataCollectionMaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetRequiredDataCollectionMaterialMetricsQuery_, GetRequiredDataCollectionMaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequiredDataCollectionMaterialMetricsQuery_, GetRequiredDataCollectionMaterialMetricsQueryVariables_>(GetRequiredDataCollectionMaterialMetricsDocument_, options);
        }
export function useGetRequiredDataCollectionMaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequiredDataCollectionMaterialMetricsQuery_, GetRequiredDataCollectionMaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequiredDataCollectionMaterialMetricsQuery_, GetRequiredDataCollectionMaterialMetricsQueryVariables_>(GetRequiredDataCollectionMaterialMetricsDocument_, options);
        }
export type GetRequiredDataCollectionMaterialMetricsQueryHookResult = ReturnType<typeof useGetRequiredDataCollectionMaterialMetricsQuery>;
export type GetRequiredDataCollectionMaterialMetricsLazyQuery_HookResult = ReturnType<typeof useGetRequiredDataCollectionMaterialMetricsLazyQuery_>;
export type GetRequiredDataCollectionMaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetRequiredDataCollectionMaterialMetricsSuspenseQuery_>;
export type GetRequiredDataCollectionMaterialMetricsQueryResult_ = Apollo.QueryResult<GetRequiredDataCollectionMaterialMetricsQuery_, GetRequiredDataCollectionMaterialMetricsQueryVariables_>;
export function refetchGetRequiredDataCollectionMaterialMetricsQuery_(variables: GetRequiredDataCollectionMaterialMetricsQueryVariables_) {
      return { query: GetRequiredDataCollectionMaterialMetricsDocument_, variables: variables }
    }
export const MaterialMetricsPerDisclosureDocument_ = gql`
    query MaterialMetricsPerDisclosure($disclosureRequirementRef: String!, $companyStandardId: uuid!, $parentStandardId: uuid, $requiredMetrics: [String!]!, $frameworkRef: String!) {
  assessableMetrics: EsrsMetric(
    order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
    where: {_and: [{_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $disclosureRequirementRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $disclosureRequirementRef}}}}]}, {isAssessable: {_eq: true}}, {materialMetrics: {isMaterial: {_eq: true}, _or: [{materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}}, {materialStandard: {id: {_eq: $companyStandardId}, isMaterial: {_eq: true}}}]}}, {_or: [{reference: {_in: $requiredMetrics}}, {view_childrenMetrics: {childMetricRef: {_in: $requiredMetrics}}}]}]}
  ) {
    ...DataCollectionChildlessMetricsFields
    ...EsrsMetricDetailedFields
    materialMetrics(
      where: {_or: [{_or: [{isMaterial: {_is_null: true}}, {isMaterial: {_eq: true}}], dataCollection: {_eq: "subsidiaries"}, materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}}, {materialStandard: {id: {_eq: $companyStandardId}}}]}
    ) {
      ...EsrsMetricChildDetailedFields
    }
    childrenMetrics(
      order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}]
    ) {
      childMetric {
        ...DataCollectionChildlessMetricsFields
        ...EsrsMetricDetailedFields
        materialMetrics(where: {materialStandardId: {_eq: $companyStandardId}}) {
          ...EsrsMetricChildDetailedFields
        }
        childrenMetrics(
          order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}]
        ) {
          childMetric {
            ...DataCollectionChildlessMetricsFields
            ...EsrsMetricDetailedFields
            materialMetrics(where: {materialStandardId: {_eq: $companyStandardId}}) {
              ...EsrsMetricChildDetailedFields
            }
            childrenMetrics(
              order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}]
            ) {
              childMetric {
                ...DataCollectionChildlessMetricsFields
                ...EsrsMetricDetailedFields
                materialMetrics(where: {materialStandardId: {_eq: $companyStandardId}}) {
                  ...EsrsMetricChildDetailedFields
                }
                childrenMetrics(
                  order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}]
                ) {
                  childMetric {
                    ...DataCollectionChildlessMetricsFields
                    ...EsrsMetricDetailedFields
                    materialMetrics(where: {materialStandardId: {_eq: $companyStandardId}}) {
                      ...EsrsMetricChildDetailedFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${DataCollectionChildlessMetricsFieldsFragmentDoc_}
${EsrsMetricDetailedFieldsFragmentDoc_}
${EsrsMetricChildDetailedFieldsFragmentDoc_}`;

/**
 * __useMaterialMetricsPerDisclosureQuery__
 *
 * To run a query within a React component, call `useMaterialMetricsPerDisclosureQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialMetricsPerDisclosureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialMetricsPerDisclosureQuery({
 *   variables: {
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *      companyStandardId: // value for 'companyStandardId'
 *      parentStandardId: // value for 'parentStandardId'
 *      requiredMetrics: // value for 'requiredMetrics'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useMaterialMetricsPerDisclosureQuery(baseOptions: Apollo.QueryHookOptions<MaterialMetricsPerDisclosureQuery_, MaterialMetricsPerDisclosureQueryVariables_> & ({ variables: MaterialMetricsPerDisclosureQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialMetricsPerDisclosureQuery_, MaterialMetricsPerDisclosureQueryVariables_>(MaterialMetricsPerDisclosureDocument_, options);
      }
export function useMaterialMetricsPerDisclosureLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<MaterialMetricsPerDisclosureQuery_, MaterialMetricsPerDisclosureQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialMetricsPerDisclosureQuery_, MaterialMetricsPerDisclosureQueryVariables_>(MaterialMetricsPerDisclosureDocument_, options);
        }
export function useMaterialMetricsPerDisclosureSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MaterialMetricsPerDisclosureQuery_, MaterialMetricsPerDisclosureQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaterialMetricsPerDisclosureQuery_, MaterialMetricsPerDisclosureQueryVariables_>(MaterialMetricsPerDisclosureDocument_, options);
        }
export type MaterialMetricsPerDisclosureQueryHookResult = ReturnType<typeof useMaterialMetricsPerDisclosureQuery>;
export type MaterialMetricsPerDisclosureLazyQuery_HookResult = ReturnType<typeof useMaterialMetricsPerDisclosureLazyQuery_>;
export type MaterialMetricsPerDisclosureSuspenseQuery_HookResult = ReturnType<typeof useMaterialMetricsPerDisclosureSuspenseQuery_>;
export type MaterialMetricsPerDisclosureQueryResult_ = Apollo.QueryResult<MaterialMetricsPerDisclosureQuery_, MaterialMetricsPerDisclosureQueryVariables_>;
export function refetchMaterialMetricsPerDisclosureQuery_(variables: MaterialMetricsPerDisclosureQueryVariables_) {
      return { query: MaterialMetricsPerDisclosureDocument_, variables: variables }
    }
export const MaterialStandardMaterialRequirementsDocument_ = gql`
    query materialStandardMaterialRequirements($standardRef: String!, $companyStandardId: uuid!, $parentStandardId: uuid!) {
  DisclosureRequirement(
    order_by: [{order: asc}, {reference: asc}]
    where: {group: {standardRef: {_eq: $standardRef}}, metrics: {_or: [{materialMetrics: {isMaterial: {_eq: true}, materialStandard: {id: {_eq: $companyStandardId}, isMaterial: {_eq: true}}}}, {materialMetrics: {dataCollection: {_eq: "subsidiaries"}, isMaterial: {_eq: true}, materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}}, childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}}]}}
  ) {
    title
    reference
    order
    type
    nonAggregatableMetrics: metrics(where: {notAggregatable: {_eq: true}}) {
      title
      order
      materialMetrics(
        where: {_or: [{isMaterial: {_is_null: true}}, {isMaterial: {_eq: true}}, {materialStandard: {id: {_eq: $parentStandardId}}}], materialStandard: {id: {_eq: $companyStandardId}, isMaterial: {_eq: true}}}
      ) {
        id
        frequency
        dataCollection
        isMaterial
      }
    }
  }
}
    `;

/**
 * __useMaterialStandardMaterialRequirementsQuery__
 *
 * To run a query within a React component, call `useMaterialStandardMaterialRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaterialStandardMaterialRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaterialStandardMaterialRequirementsQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *      companyStandardId: // value for 'companyStandardId'
 *      parentStandardId: // value for 'parentStandardId'
 *   },
 * });
 */
export function useMaterialStandardMaterialRequirementsQuery(baseOptions: Apollo.QueryHookOptions<MaterialStandardMaterialRequirementsQuery_, MaterialStandardMaterialRequirementsQueryVariables_> & ({ variables: MaterialStandardMaterialRequirementsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaterialStandardMaterialRequirementsQuery_, MaterialStandardMaterialRequirementsQueryVariables_>(MaterialStandardMaterialRequirementsDocument_, options);
      }
export function useMaterialStandardMaterialRequirementsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<MaterialStandardMaterialRequirementsQuery_, MaterialStandardMaterialRequirementsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaterialStandardMaterialRequirementsQuery_, MaterialStandardMaterialRequirementsQueryVariables_>(MaterialStandardMaterialRequirementsDocument_, options);
        }
export function useMaterialStandardMaterialRequirementsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MaterialStandardMaterialRequirementsQuery_, MaterialStandardMaterialRequirementsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MaterialStandardMaterialRequirementsQuery_, MaterialStandardMaterialRequirementsQueryVariables_>(MaterialStandardMaterialRequirementsDocument_, options);
        }
export type MaterialStandardMaterialRequirementsQueryHookResult = ReturnType<typeof useMaterialStandardMaterialRequirementsQuery>;
export type MaterialStandardMaterialRequirementsLazyQuery_HookResult = ReturnType<typeof useMaterialStandardMaterialRequirementsLazyQuery_>;
export type MaterialStandardMaterialRequirementsSuspenseQuery_HookResult = ReturnType<typeof useMaterialStandardMaterialRequirementsSuspenseQuery_>;
export type MaterialStandardMaterialRequirementsQueryResult_ = Apollo.QueryResult<MaterialStandardMaterialRequirementsQuery_, MaterialStandardMaterialRequirementsQueryVariables_>;
export function refetchMaterialStandardMaterialRequirementsQuery_(variables: MaterialStandardMaterialRequirementsQueryVariables_) {
      return { query: MaterialStandardMaterialRequirementsDocument_, variables: variables }
    }
export const GroupMetricRequiredTagsPerStandardDocument_ = gql`
    query GroupMetricRequiredTagsPerStandard($materialStandardId: uuid!) {
  esrs_MaterialMetric(
    where: {metric: {tags: {isOptional: {_eq: false}}}, isMaterial: {_eq: true}, materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}, _or: [{dataCollection: {_eq: "group"}, childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}}, {childrenMetrics_aggregate: {count: {predicate: {_gt: 0}, filter: {childMetric: {materialMetrics: {materialStandard: {id: {_eq: $materialStandardId}}, dataCollection: {_eq: "group"}}}}}}}]}
  ) {
    metricRef
    dataCollection
    childrenMetrics_aggregate {
      aggregate {
        count
      }
    }
    metric {
      disclosureRequirementRef
    }
    materialMetricTags(
      where: {materialTagValues_aggregate: {count: {predicate: {_gt: 0}}}}
    ) {
      tagType
    }
    metric {
      requiredTags: tags(where: {isOptional: {_eq: false}}) {
        type
      }
    }
  }
}
    `;

/**
 * __useGroupMetricRequiredTagsPerStandardQuery__
 *
 * To run a query within a React component, call `useGroupMetricRequiredTagsPerStandardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupMetricRequiredTagsPerStandardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupMetricRequiredTagsPerStandardQuery({
 *   variables: {
 *      materialStandardId: // value for 'materialStandardId'
 *   },
 * });
 */
export function useGroupMetricRequiredTagsPerStandardQuery(baseOptions: Apollo.QueryHookOptions<GroupMetricRequiredTagsPerStandardQuery_, GroupMetricRequiredTagsPerStandardQueryVariables_> & ({ variables: GroupMetricRequiredTagsPerStandardQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupMetricRequiredTagsPerStandardQuery_, GroupMetricRequiredTagsPerStandardQueryVariables_>(GroupMetricRequiredTagsPerStandardDocument_, options);
      }
export function useGroupMetricRequiredTagsPerStandardLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GroupMetricRequiredTagsPerStandardQuery_, GroupMetricRequiredTagsPerStandardQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupMetricRequiredTagsPerStandardQuery_, GroupMetricRequiredTagsPerStandardQueryVariables_>(GroupMetricRequiredTagsPerStandardDocument_, options);
        }
export function useGroupMetricRequiredTagsPerStandardSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupMetricRequiredTagsPerStandardQuery_, GroupMetricRequiredTagsPerStandardQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupMetricRequiredTagsPerStandardQuery_, GroupMetricRequiredTagsPerStandardQueryVariables_>(GroupMetricRequiredTagsPerStandardDocument_, options);
        }
export type GroupMetricRequiredTagsPerStandardQueryHookResult = ReturnType<typeof useGroupMetricRequiredTagsPerStandardQuery>;
export type GroupMetricRequiredTagsPerStandardLazyQuery_HookResult = ReturnType<typeof useGroupMetricRequiredTagsPerStandardLazyQuery_>;
export type GroupMetricRequiredTagsPerStandardSuspenseQuery_HookResult = ReturnType<typeof useGroupMetricRequiredTagsPerStandardSuspenseQuery_>;
export type GroupMetricRequiredTagsPerStandardQueryResult_ = Apollo.QueryResult<GroupMetricRequiredTagsPerStandardQuery_, GroupMetricRequiredTagsPerStandardQueryVariables_>;
export function refetchGroupMetricRequiredTagsPerStandardQuery_(variables: GroupMetricRequiredTagsPerStandardQueryVariables_) {
      return { query: GroupMetricRequiredTagsPerStandardDocument_, variables: variables }
    }
export const CompanyMetricRequiredTagsPerStandardDocument_ = gql`
    query CompanyMetricRequiredTagsPerStandard($materialStandardId: uuid!) {
  esrs_MaterialMetric(
    where: {metric: {tags: {isOptional: {_eq: false}}}, _or: [{materialStandard: {id: {_eq: $materialStandardId}}, dataCollection: {_eq: "company"}, isMaterial: {_eq: true}}]}
  ) {
    metricRef
    dataCollection
    childrenMetrics_aggregate {
      aggregate {
        count
      }
    }
    metric {
      disclosureRequirementRef
    }
    materialMetricTags(
      where: {materialTagValues_aggregate: {count: {predicate: {_gt: 0}}}}
    ) {
      tagType
    }
    metric {
      requiredTags: tags(where: {isOptional: {_eq: false}}) {
        type
      }
    }
  }
}
    `;

/**
 * __useCompanyMetricRequiredTagsPerStandardQuery__
 *
 * To run a query within a React component, call `useCompanyMetricRequiredTagsPerStandardQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyMetricRequiredTagsPerStandardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyMetricRequiredTagsPerStandardQuery({
 *   variables: {
 *      materialStandardId: // value for 'materialStandardId'
 *   },
 * });
 */
export function useCompanyMetricRequiredTagsPerStandardQuery(baseOptions: Apollo.QueryHookOptions<CompanyMetricRequiredTagsPerStandardQuery_, CompanyMetricRequiredTagsPerStandardQueryVariables_> & ({ variables: CompanyMetricRequiredTagsPerStandardQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyMetricRequiredTagsPerStandardQuery_, CompanyMetricRequiredTagsPerStandardQueryVariables_>(CompanyMetricRequiredTagsPerStandardDocument_, options);
      }
export function useCompanyMetricRequiredTagsPerStandardLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompanyMetricRequiredTagsPerStandardQuery_, CompanyMetricRequiredTagsPerStandardQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyMetricRequiredTagsPerStandardQuery_, CompanyMetricRequiredTagsPerStandardQueryVariables_>(CompanyMetricRequiredTagsPerStandardDocument_, options);
        }
export function useCompanyMetricRequiredTagsPerStandardSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyMetricRequiredTagsPerStandardQuery_, CompanyMetricRequiredTagsPerStandardQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyMetricRequiredTagsPerStandardQuery_, CompanyMetricRequiredTagsPerStandardQueryVariables_>(CompanyMetricRequiredTagsPerStandardDocument_, options);
        }
export type CompanyMetricRequiredTagsPerStandardQueryHookResult = ReturnType<typeof useCompanyMetricRequiredTagsPerStandardQuery>;
export type CompanyMetricRequiredTagsPerStandardLazyQuery_HookResult = ReturnType<typeof useCompanyMetricRequiredTagsPerStandardLazyQuery_>;
export type CompanyMetricRequiredTagsPerStandardSuspenseQuery_HookResult = ReturnType<typeof useCompanyMetricRequiredTagsPerStandardSuspenseQuery_>;
export type CompanyMetricRequiredTagsPerStandardQueryResult_ = Apollo.QueryResult<CompanyMetricRequiredTagsPerStandardQuery_, CompanyMetricRequiredTagsPerStandardQueryVariables_>;
export function refetchCompanyMetricRequiredTagsPerStandardQuery_(variables: CompanyMetricRequiredTagsPerStandardQueryVariables_) {
      return { query: CompanyMetricRequiredTagsPerStandardDocument_, variables: variables }
    }
export const BusinessUnitMetricRequiredTagsPerStandardDocument_ = gql`
    query BusinessUnitMetricRequiredTagsPerStandard($materialStandardId: uuid!, $parentStandardId: uuid!) {
  esrs_MaterialMetric(
    where: {metric: {tags: {isOptional: {_eq: false}}}, isMaterial: {_eq: true}, _or: [{materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}, dataCollection: {_eq: "reportingUnits"}}, {materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}, _and: {metric: {hierarchyStatus: {isLeaf: {_eq: true}}, materialMetrics: {materialStandardId: {_eq: $materialStandardId}, dataCollection: {_eq: "reportingUnits"}}}}}]}
  ) {
    metricRef
    dataCollection
    childrenMetrics_aggregate {
      aggregate {
        count
      }
    }
    metric {
      disclosureRequirementRef
    }
    materialMetricTags(
      where: {materialTagValues_aggregate: {count: {predicate: {_gt: 0}}}}
    ) {
      tagType
    }
    metric {
      requiredTags: tags(where: {isOptional: {_eq: false}}) {
        type
      }
    }
  }
}
    `;

/**
 * __useBusinessUnitMetricRequiredTagsPerStandardQuery__
 *
 * To run a query within a React component, call `useBusinessUnitMetricRequiredTagsPerStandardQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessUnitMetricRequiredTagsPerStandardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessUnitMetricRequiredTagsPerStandardQuery({
 *   variables: {
 *      materialStandardId: // value for 'materialStandardId'
 *      parentStandardId: // value for 'parentStandardId'
 *   },
 * });
 */
export function useBusinessUnitMetricRequiredTagsPerStandardQuery(baseOptions: Apollo.QueryHookOptions<BusinessUnitMetricRequiredTagsPerStandardQuery_, BusinessUnitMetricRequiredTagsPerStandardQueryVariables_> & ({ variables: BusinessUnitMetricRequiredTagsPerStandardQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BusinessUnitMetricRequiredTagsPerStandardQuery_, BusinessUnitMetricRequiredTagsPerStandardQueryVariables_>(BusinessUnitMetricRequiredTagsPerStandardDocument_, options);
      }
export function useBusinessUnitMetricRequiredTagsPerStandardLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<BusinessUnitMetricRequiredTagsPerStandardQuery_, BusinessUnitMetricRequiredTagsPerStandardQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BusinessUnitMetricRequiredTagsPerStandardQuery_, BusinessUnitMetricRequiredTagsPerStandardQueryVariables_>(BusinessUnitMetricRequiredTagsPerStandardDocument_, options);
        }
export function useBusinessUnitMetricRequiredTagsPerStandardSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BusinessUnitMetricRequiredTagsPerStandardQuery_, BusinessUnitMetricRequiredTagsPerStandardQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BusinessUnitMetricRequiredTagsPerStandardQuery_, BusinessUnitMetricRequiredTagsPerStandardQueryVariables_>(BusinessUnitMetricRequiredTagsPerStandardDocument_, options);
        }
export type BusinessUnitMetricRequiredTagsPerStandardQueryHookResult = ReturnType<typeof useBusinessUnitMetricRequiredTagsPerStandardQuery>;
export type BusinessUnitMetricRequiredTagsPerStandardLazyQuery_HookResult = ReturnType<typeof useBusinessUnitMetricRequiredTagsPerStandardLazyQuery_>;
export type BusinessUnitMetricRequiredTagsPerStandardSuspenseQuery_HookResult = ReturnType<typeof useBusinessUnitMetricRequiredTagsPerStandardSuspenseQuery_>;
export type BusinessUnitMetricRequiredTagsPerStandardQueryResult_ = Apollo.QueryResult<BusinessUnitMetricRequiredTagsPerStandardQuery_, BusinessUnitMetricRequiredTagsPerStandardQueryVariables_>;
export function refetchBusinessUnitMetricRequiredTagsPerStandardQuery_(variables: BusinessUnitMetricRequiredTagsPerStandardQueryVariables_) {
      return { query: BusinessUnitMetricRequiredTagsPerStandardDocument_, variables: variables }
    }
export const UpsertDisclosureRequirementStatusDocument_ = gql`
    mutation upsertDisclosureRequirementStatus($drRef: String!, $isConfigured: Boolean!, $materialStandardId: uuid!) {
  insert_DisclosureRequirementStatus(
    objects: {disclosureRequirementRef: $drRef, isConfigured: $isConfigured, materialStandardId: $materialStandardId}
    on_conflict: {constraint: DisclosureRequirementStatus_materialStandardId_disclosureRequir, update_columns: [isConfigured]}
  ) {
    returning {
      disclosureRequirementRef
      isConfigured
    }
  }
}
    `;
export type UpsertDisclosureRequirementStatusMutationFn_ = Apollo.MutationFunction<UpsertDisclosureRequirementStatusMutation_, UpsertDisclosureRequirementStatusMutationVariables_>;

/**
 * __useUpsertDisclosureRequirementStatusMutation__
 *
 * To run a mutation, you first call `useUpsertDisclosureRequirementStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDisclosureRequirementStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDisclosureRequirementStatusMutation, { data, loading, error }] = useUpsertDisclosureRequirementStatusMutation({
 *   variables: {
 *      drRef: // value for 'drRef'
 *      isConfigured: // value for 'isConfigured'
 *      materialStandardId: // value for 'materialStandardId'
 *   },
 * });
 */
export function useUpsertDisclosureRequirementStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDisclosureRequirementStatusMutation_, UpsertDisclosureRequirementStatusMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDisclosureRequirementStatusMutation_, UpsertDisclosureRequirementStatusMutationVariables_>(UpsertDisclosureRequirementStatusDocument_, options);
      }
export type UpsertDisclosureRequirementStatusMutationHookResult = ReturnType<typeof useUpsertDisclosureRequirementStatusMutation>;
export type UpsertDisclosureRequirementStatusMutationResult_ = Apollo.MutationResult<UpsertDisclosureRequirementStatusMutation_>;
export type UpsertDisclosureRequirementStatusMutationOptions_ = Apollo.BaseMutationOptions<UpsertDisclosureRequirementStatusMutation_, UpsertDisclosureRequirementStatusMutationVariables_>;
export const UpsertMfDisclosureRequirementStatusDocument_ = gql`
    mutation upsertMFDisclosureRequirementStatus($mfDrRef: String, $isConfigured: Boolean!, $materialStandardId: uuid!) {
  insert_DisclosureRequirementStatus(
    objects: {mfDisclosureRequirementRef: $mfDrRef, isConfigured: $isConfigured, materialStandardId: $materialStandardId}
    on_conflict: {constraint: DisclosureRequirementStatus_materialStandardId_mfDisclosureRequ, update_columns: [isConfigured]}
  ) {
    returning {
      mfDisclosureRequirementRef
      isConfigured
    }
  }
}
    `;
export type UpsertMfDisclosureRequirementStatusMutationFn_ = Apollo.MutationFunction<UpsertMfDisclosureRequirementStatusMutation_, UpsertMfDisclosureRequirementStatusMutationVariables_>;

/**
 * __useUpsertMfDisclosureRequirementStatusMutation__
 *
 * To run a mutation, you first call `useUpsertMfDisclosureRequirementStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMfDisclosureRequirementStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMfDisclosureRequirementStatusMutation, { data, loading, error }] = useUpsertMfDisclosureRequirementStatusMutation({
 *   variables: {
 *      mfDrRef: // value for 'mfDrRef'
 *      isConfigured: // value for 'isConfigured'
 *      materialStandardId: // value for 'materialStandardId'
 *   },
 * });
 */
export function useUpsertMfDisclosureRequirementStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMfDisclosureRequirementStatusMutation_, UpsertMfDisclosureRequirementStatusMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMfDisclosureRequirementStatusMutation_, UpsertMfDisclosureRequirementStatusMutationVariables_>(UpsertMfDisclosureRequirementStatusDocument_, options);
      }
export type UpsertMfDisclosureRequirementStatusMutationHookResult = ReturnType<typeof useUpsertMfDisclosureRequirementStatusMutation>;
export type UpsertMfDisclosureRequirementStatusMutationResult_ = Apollo.MutationResult<UpsertMfDisclosureRequirementStatusMutation_>;
export type UpsertMfDisclosureRequirementStatusMutationOptions_ = Apollo.BaseMutationOptions<UpsertMfDisclosureRequirementStatusMutation_, UpsertMfDisclosureRequirementStatusMutationVariables_>;
export const DeleteMaterialMetricTagValueDocument_ = gql`
    mutation deleteMaterialMetricTagValue($tagType: String!, $tagValue: String!, $materialMetricId: uuid!) {
  delete_esrs_MaterialTagValue(
    where: {tagType: {_eq: $tagType}, tagValue: {_eq: $tagValue}, materialMetricTag: {materialMetricId: {_eq: $materialMetricId}}}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type DeleteMaterialMetricTagValueMutationFn_ = Apollo.MutationFunction<DeleteMaterialMetricTagValueMutation_, DeleteMaterialMetricTagValueMutationVariables_>;

/**
 * __useDeleteMaterialMetricTagValueMutation__
 *
 * To run a mutation, you first call `useDeleteMaterialMetricTagValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMaterialMetricTagValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMaterialMetricTagValueMutation, { data, loading, error }] = useDeleteMaterialMetricTagValueMutation({
 *   variables: {
 *      tagType: // value for 'tagType'
 *      tagValue: // value for 'tagValue'
 *      materialMetricId: // value for 'materialMetricId'
 *   },
 * });
 */
export function useDeleteMaterialMetricTagValueMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMaterialMetricTagValueMutation_, DeleteMaterialMetricTagValueMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMaterialMetricTagValueMutation_, DeleteMaterialMetricTagValueMutationVariables_>(DeleteMaterialMetricTagValueDocument_, options);
      }
export type DeleteMaterialMetricTagValueMutationHookResult = ReturnType<typeof useDeleteMaterialMetricTagValueMutation>;
export type DeleteMaterialMetricTagValueMutationResult_ = Apollo.MutationResult<DeleteMaterialMetricTagValueMutation_>;
export type DeleteMaterialMetricTagValueMutationOptions_ = Apollo.BaseMutationOptions<DeleteMaterialMetricTagValueMutation_, DeleteMaterialMetricTagValueMutationVariables_>;
export const DeleteMaterialMetricTagDocument_ = gql`
    mutation deleteMaterialMetricTag($tagTypes: [String!]!, $materialMetricId: uuid!) {
  delete_esrs_MaterialMetricTag(
    where: {materialMetricId: {_eq: $materialMetricId}, tagType: {_in: $tagTypes}}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type DeleteMaterialMetricTagMutationFn_ = Apollo.MutationFunction<DeleteMaterialMetricTagMutation_, DeleteMaterialMetricTagMutationVariables_>;

/**
 * __useDeleteMaterialMetricTagMutation__
 *
 * To run a mutation, you first call `useDeleteMaterialMetricTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMaterialMetricTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMaterialMetricTagMutation, { data, loading, error }] = useDeleteMaterialMetricTagMutation({
 *   variables: {
 *      tagTypes: // value for 'tagTypes'
 *      materialMetricId: // value for 'materialMetricId'
 *   },
 * });
 */
export function useDeleteMaterialMetricTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMaterialMetricTagMutation_, DeleteMaterialMetricTagMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMaterialMetricTagMutation_, DeleteMaterialMetricTagMutationVariables_>(DeleteMaterialMetricTagDocument_, options);
      }
export type DeleteMaterialMetricTagMutationHookResult = ReturnType<typeof useDeleteMaterialMetricTagMutation>;
export type DeleteMaterialMetricTagMutationResult_ = Apollo.MutationResult<DeleteMaterialMetricTagMutation_>;
export type DeleteMaterialMetricTagMutationOptions_ = Apollo.BaseMutationOptions<DeleteMaterialMetricTagMutation_, DeleteMaterialMetricTagMutationVariables_>;
export const DeleteManyMaterialTagValuesDocument_ = gql`
    mutation deleteManyMaterialTagValues($materialMetricTagValues: [esrs_MaterialTagValue_bool_exp!]!) {
  delete_esrs_MaterialTagValue(where: {_or: $materialMetricTagValues}) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type DeleteManyMaterialTagValuesMutationFn_ = Apollo.MutationFunction<DeleteManyMaterialTagValuesMutation_, DeleteManyMaterialTagValuesMutationVariables_>;

/**
 * __useDeleteManyMaterialTagValuesMutation__
 *
 * To run a mutation, you first call `useDeleteManyMaterialTagValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteManyMaterialTagValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteManyMaterialTagValuesMutation, { data, loading, error }] = useDeleteManyMaterialTagValuesMutation({
 *   variables: {
 *      materialMetricTagValues: // value for 'materialMetricTagValues'
 *   },
 * });
 */
export function useDeleteManyMaterialTagValuesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteManyMaterialTagValuesMutation_, DeleteManyMaterialTagValuesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteManyMaterialTagValuesMutation_, DeleteManyMaterialTagValuesMutationVariables_>(DeleteManyMaterialTagValuesDocument_, options);
      }
export type DeleteManyMaterialTagValuesMutationHookResult = ReturnType<typeof useDeleteManyMaterialTagValuesMutation>;
export type DeleteManyMaterialTagValuesMutationResult_ = Apollo.MutationResult<DeleteManyMaterialTagValuesMutation_>;
export type DeleteManyMaterialTagValuesMutationOptions_ = Apollo.BaseMutationOptions<DeleteManyMaterialTagValuesMutation_, DeleteManyMaterialTagValuesMutationVariables_>;
export const GetRequiredTagsMaterialMetricsDocument_ = gql`
    query getRequiredTagsMaterialMetrics($esrsAssessmentId: uuid!) {
  esrs_MaterialMetric(
    where: {isMaterial: {_eq: true}, materialStandard: {assessmentId: {_eq: $esrsAssessmentId}, isMaterial: {_eq: true}}, _or: [{dataCollection: {_eq: "group"}, childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}}, {childrenMetrics_aggregate: {count: {predicate: {_gt: 0}, filter: {childMetric: {materialMetrics: {materialStandard: {assessmentId: {_eq: $esrsAssessmentId}}, dataCollection: {_eq: "group"}}}}}}}], metric: {tags: {isOptional: {_eq: false}}}}
  ) {
    id
    materialStandardId
    materialMetricTags {
      tagType
      materialTagValues {
        tagType
        tagValue
      }
    }
    metric {
      reference
      title
      tags(where: {isOptional: {_eq: false}}) {
        isOptional
        type
        tagType {
          tagValues(order_by: [{order: asc}, {value: asc}]) {
            type
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRequiredTagsMaterialMetricsQuery__
 *
 * To run a query within a React component, call `useGetRequiredTagsMaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredTagsMaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredTagsMaterialMetricsQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetRequiredTagsMaterialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetRequiredTagsMaterialMetricsQuery_, GetRequiredTagsMaterialMetricsQueryVariables_> & ({ variables: GetRequiredTagsMaterialMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequiredTagsMaterialMetricsQuery_, GetRequiredTagsMaterialMetricsQueryVariables_>(GetRequiredTagsMaterialMetricsDocument_, options);
      }
export function useGetRequiredTagsMaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetRequiredTagsMaterialMetricsQuery_, GetRequiredTagsMaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequiredTagsMaterialMetricsQuery_, GetRequiredTagsMaterialMetricsQueryVariables_>(GetRequiredTagsMaterialMetricsDocument_, options);
        }
export function useGetRequiredTagsMaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequiredTagsMaterialMetricsQuery_, GetRequiredTagsMaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequiredTagsMaterialMetricsQuery_, GetRequiredTagsMaterialMetricsQueryVariables_>(GetRequiredTagsMaterialMetricsDocument_, options);
        }
export type GetRequiredTagsMaterialMetricsQueryHookResult = ReturnType<typeof useGetRequiredTagsMaterialMetricsQuery>;
export type GetRequiredTagsMaterialMetricsLazyQuery_HookResult = ReturnType<typeof useGetRequiredTagsMaterialMetricsLazyQuery_>;
export type GetRequiredTagsMaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetRequiredTagsMaterialMetricsSuspenseQuery_>;
export type GetRequiredTagsMaterialMetricsQueryResult_ = Apollo.QueryResult<GetRequiredTagsMaterialMetricsQuery_, GetRequiredTagsMaterialMetricsQueryVariables_>;
export function refetchGetRequiredTagsMaterialMetricsQuery_(variables: GetRequiredTagsMaterialMetricsQueryVariables_) {
      return { query: GetRequiredTagsMaterialMetricsDocument_, variables: variables }
    }
export const GetMetricTagsDetailForSubsidiariesDocument_ = gql`
    query getMetricTagsDetailForSubsidiaries($assessmentId: uuid, $drRef: String, $frameworkRef: String!) {
  esrs_MaterialMetric(
    where: {materialStandard: {esrsAssessment: {parentAssessmentId: {_eq: $assessmentId}}}, _or: [{dataCollection: {_eq: "company"}}, {dataCollection: {_eq: "reportingUnits"}}], metric: {_or: [{disclosureRequirementRef: {_eq: $drRef}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {drToMFDisclosureRequirements: {disclosureRequirementRef: {_eq: $drRef}}}}, requirement: {frameworkRef: {_neq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}], tags_aggregate: {count: {predicate: {_gt: 0}}}}}
  ) {
    metricRef
    metric {
      tags(where: {isOptional: {_eq: false}}) {
        type
        isOptional
      }
    }
    materialMetricTags(
      where: {materialTagValues_aggregate: {count: {predicate: {_gt: 0}}}}
    ) {
      tagType
    }
    materialStandard {
      esrsAssessment {
        company {
          name
          id
        }
        id
      }
    }
  }
}
    `;

/**
 * __useGetMetricTagsDetailForSubsidiariesQuery__
 *
 * To run a query within a React component, call `useGetMetricTagsDetailForSubsidiariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricTagsDetailForSubsidiariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricTagsDetailForSubsidiariesQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      drRef: // value for 'drRef'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetMetricTagsDetailForSubsidiariesQuery(baseOptions: Apollo.QueryHookOptions<GetMetricTagsDetailForSubsidiariesQuery_, GetMetricTagsDetailForSubsidiariesQueryVariables_> & ({ variables: GetMetricTagsDetailForSubsidiariesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricTagsDetailForSubsidiariesQuery_, GetMetricTagsDetailForSubsidiariesQueryVariables_>(GetMetricTagsDetailForSubsidiariesDocument_, options);
      }
export function useGetMetricTagsDetailForSubsidiariesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricTagsDetailForSubsidiariesQuery_, GetMetricTagsDetailForSubsidiariesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricTagsDetailForSubsidiariesQuery_, GetMetricTagsDetailForSubsidiariesQueryVariables_>(GetMetricTagsDetailForSubsidiariesDocument_, options);
        }
export function useGetMetricTagsDetailForSubsidiariesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricTagsDetailForSubsidiariesQuery_, GetMetricTagsDetailForSubsidiariesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricTagsDetailForSubsidiariesQuery_, GetMetricTagsDetailForSubsidiariesQueryVariables_>(GetMetricTagsDetailForSubsidiariesDocument_, options);
        }
export type GetMetricTagsDetailForSubsidiariesQueryHookResult = ReturnType<typeof useGetMetricTagsDetailForSubsidiariesQuery>;
export type GetMetricTagsDetailForSubsidiariesLazyQuery_HookResult = ReturnType<typeof useGetMetricTagsDetailForSubsidiariesLazyQuery_>;
export type GetMetricTagsDetailForSubsidiariesSuspenseQuery_HookResult = ReturnType<typeof useGetMetricTagsDetailForSubsidiariesSuspenseQuery_>;
export type GetMetricTagsDetailForSubsidiariesQueryResult_ = Apollo.QueryResult<GetMetricTagsDetailForSubsidiariesQuery_, GetMetricTagsDetailForSubsidiariesQueryVariables_>;
export function refetchGetMetricTagsDetailForSubsidiariesQuery_(variables: GetMetricTagsDetailForSubsidiariesQueryVariables_) {
      return { query: GetMetricTagsDetailForSubsidiariesDocument_, variables: variables }
    }
export const GetSubsidiaryRequiredTagsMaterialMetricsDocument_ = gql`
    query getSubsidiaryRequiredTagsMaterialMetrics($esrsAssessmentId: uuid!, $parentEsrsAssessmentId: uuid!) {
  esrs_MaterialMetric(
    where: {metric: {tags: {isOptional: {_eq: false}}}, _or: [{materialStandard: {assessmentId: {_eq: $esrsAssessmentId}, isMaterial: {_eq: true}}}, {isMaterial: {_eq: true}, materialStandard: {assessmentId: {_eq: $parentEsrsAssessmentId}, isMaterial: {_eq: true}}, _or: [{dataCollection: {_eq: "subsidiaries"}, childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}}, {childrenMetrics_aggregate: {count: {predicate: {_gt: 0}, filter: {childMetric: {materialMetrics: {materialStandard: {assessmentId: {_eq: $parentEsrsAssessmentId}}, dataCollection: {_eq: "subsidiaries"}}}}}}}]}]}
  ) {
    id
    materialStandardId
    isMaterial
    materialMetricTags {
      tagType
      materialTagValues {
        tagType
        tagValue
      }
    }
    materialStandard {
      assessmentId
    }
    metric {
      reference
      title
      tags(where: {isOptional: {_eq: false}}) {
        isOptional
        type
        tagType {
          tagValues(order_by: [{order: asc}, {value: asc}]) {
            type
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSubsidiaryRequiredTagsMaterialMetricsQuery__
 *
 * To run a query within a React component, call `useGetSubsidiaryRequiredTagsMaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsidiaryRequiredTagsMaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsidiaryRequiredTagsMaterialMetricsQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      parentEsrsAssessmentId: // value for 'parentEsrsAssessmentId'
 *   },
 * });
 */
export function useGetSubsidiaryRequiredTagsMaterialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetSubsidiaryRequiredTagsMaterialMetricsQuery_, GetSubsidiaryRequiredTagsMaterialMetricsQueryVariables_> & ({ variables: GetSubsidiaryRequiredTagsMaterialMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsidiaryRequiredTagsMaterialMetricsQuery_, GetSubsidiaryRequiredTagsMaterialMetricsQueryVariables_>(GetSubsidiaryRequiredTagsMaterialMetricsDocument_, options);
      }
export function useGetSubsidiaryRequiredTagsMaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsidiaryRequiredTagsMaterialMetricsQuery_, GetSubsidiaryRequiredTagsMaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsidiaryRequiredTagsMaterialMetricsQuery_, GetSubsidiaryRequiredTagsMaterialMetricsQueryVariables_>(GetSubsidiaryRequiredTagsMaterialMetricsDocument_, options);
        }
export function useGetSubsidiaryRequiredTagsMaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubsidiaryRequiredTagsMaterialMetricsQuery_, GetSubsidiaryRequiredTagsMaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubsidiaryRequiredTagsMaterialMetricsQuery_, GetSubsidiaryRequiredTagsMaterialMetricsQueryVariables_>(GetSubsidiaryRequiredTagsMaterialMetricsDocument_, options);
        }
export type GetSubsidiaryRequiredTagsMaterialMetricsQueryHookResult = ReturnType<typeof useGetSubsidiaryRequiredTagsMaterialMetricsQuery>;
export type GetSubsidiaryRequiredTagsMaterialMetricsLazyQuery_HookResult = ReturnType<typeof useGetSubsidiaryRequiredTagsMaterialMetricsLazyQuery_>;
export type GetSubsidiaryRequiredTagsMaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetSubsidiaryRequiredTagsMaterialMetricsSuspenseQuery_>;
export type GetSubsidiaryRequiredTagsMaterialMetricsQueryResult_ = Apollo.QueryResult<GetSubsidiaryRequiredTagsMaterialMetricsQuery_, GetSubsidiaryRequiredTagsMaterialMetricsQueryVariables_>;
export function refetchGetSubsidiaryRequiredTagsMaterialMetricsQuery_(variables: GetSubsidiaryRequiredTagsMaterialMetricsQueryVariables_) {
      return { query: GetSubsidiaryRequiredTagsMaterialMetricsDocument_, variables: variables }
    }
export const EsrsAssessmentForDuplicationDocument_ = gql`
    query esrsAssessmentForDuplication($esrsAssessmentId: uuid!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    projectLeaderId
    metadata
    companyId
    companySize
    onboardingStep
    reportingYear
    updatedAt
    collectOnly
    frameworkRef
    materialStandards {
      updatedAt
      standardRef
      isMaterial
      isDataGatheringOnly
      noteHistory {
        ...SimplifiedNoteHistory
      }
      attachmentBox {
        ...SimplifiedAttachmentBox
      }
      materialMetrics {
        updatedAt
        isMaterial
        isDataGatheringOnly
        frequency
        dataCollection
        isHidden
        metricRef
        materialMetricTags {
          updatedAt
          tagType
          materialTagValues(order_by: [{tag: {order: asc}}, {tag: {value: asc}}]) {
            updatedAt
            tagType
            tagValue
          }
        }
      }
      policies {
        updatedAt
        disclosureRequirementRef
        noteHistory {
          ...SimplifiedNoteHistory
        }
        attachmentBox {
          ...SimplifiedAttachmentBox
        }
      }
      targets {
        materialStandard {
          standardRef
        }
        updatedAt
        noteHistory {
          ...SimplifiedNoteHistory
        }
        attachmentBox {
          ...SimplifiedAttachmentBox
        }
        name
        metricRef
        disclosureRequirementRef
        ownerId
        answers
        description
        direction
        isEvidenceScientific
        isEvidenceScientificExplanation
        isProgressAligned
        isProgressAlignedExplanation
        isBottomUp
        isRequired
        methodologies
        relatedPolicy
        performanceNumber
        performanceText
        periodExplanation
        scope
        targetChangeDescription
        withStakeholders
        withStakeholdersDescription
        withStakeholdersExplanation
        sustainabilityMatter
        sustainabilityMatterExplanation
        relationshipToPolicy
        coverageExplanation
        coverage
        keyResults {
          updatedAt
          baseYear
          baseline
          isFlagged
          reportingUnitId
          reportingUnit {
            lineageId
          }
        }
        milestones {
          updated_at
          isRelative
          isRequired
          year
          milestoneResults {
            updatedAt
            value
            reportingUnitId
            reportingUnit {
              lineageId
            }
          }
        }
        actionTargets {
          estimate
          updatedAt
          action {
            ...DuplicationActionFields
          }
        }
      }
      actionsWithoutTargets: actions(
        where: {actionTargets_aggregate: {count: {predicate: {_eq: 0}}}}
      ) {
        ...DuplicationActionFields
      }
      disclosureRequirementStatuses {
        isConfigured
        disclosureRequirementRef
        mfDisclosureRequirementRef
      }
    }
    reportingUnits {
      lineageId
      updatedAt
      name
      isCompanyLevel
      projectLeaderId
      answers {
        updatedAt
        noteHistory {
          ...SimplifiedNoteHistory
        }
        attachmentBox {
          ...SimplifiedAttachmentBox
        }
        hasOptedOut
        metricRef
        metric {
          metricType
        }
        optOutAuthorId
        optOutReason
        datapoints {
          thread {
            ...SimplifiedThread
          }
          updatedAt
          authorId
          source
          tagCombination
          metadata
          isMdrmDisclosed
          mdrmElsewhereDisclosure
          datapointMdrms {
            authorId
            hasOptedOut
            value
            mdrmRef
            thread {
              ...SimplifiedThread
            }
          }
          datapointTags {
            updatedAt
            tagType
            tagValue
          }
          ownerId
          value
          timeframe
          factValue
          datapointChoices {
            choiceRef
          }
        }
      }
      disclosureRequirementAttachments {
        updatedAt
        disclosureRequirementRef
        attachmentBox {
          ...SimplifiedAttachmentBox
        }
        materialStandard {
          standardRef
        }
      }
    }
  }
}
    ${SimplifiedNoteHistoryFragmentDoc_}
${SimplifiedAttachmentBoxFragmentDoc_}
${DuplicationActionFieldsFragmentDoc_}
${SimplifiedThreadFragmentDoc_}`;

/**
 * __useEsrsAssessmentForDuplicationQuery__
 *
 * To run a query within a React component, call `useEsrsAssessmentForDuplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsrsAssessmentForDuplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsrsAssessmentForDuplicationQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useEsrsAssessmentForDuplicationQuery(baseOptions: Apollo.QueryHookOptions<EsrsAssessmentForDuplicationQuery_, EsrsAssessmentForDuplicationQueryVariables_> & ({ variables: EsrsAssessmentForDuplicationQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsrsAssessmentForDuplicationQuery_, EsrsAssessmentForDuplicationQueryVariables_>(EsrsAssessmentForDuplicationDocument_, options);
      }
export function useEsrsAssessmentForDuplicationLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<EsrsAssessmentForDuplicationQuery_, EsrsAssessmentForDuplicationQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsrsAssessmentForDuplicationQuery_, EsrsAssessmentForDuplicationQueryVariables_>(EsrsAssessmentForDuplicationDocument_, options);
        }
export function useEsrsAssessmentForDuplicationSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsrsAssessmentForDuplicationQuery_, EsrsAssessmentForDuplicationQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsrsAssessmentForDuplicationQuery_, EsrsAssessmentForDuplicationQueryVariables_>(EsrsAssessmentForDuplicationDocument_, options);
        }
export type EsrsAssessmentForDuplicationQueryHookResult = ReturnType<typeof useEsrsAssessmentForDuplicationQuery>;
export type EsrsAssessmentForDuplicationLazyQuery_HookResult = ReturnType<typeof useEsrsAssessmentForDuplicationLazyQuery_>;
export type EsrsAssessmentForDuplicationSuspenseQuery_HookResult = ReturnType<typeof useEsrsAssessmentForDuplicationSuspenseQuery_>;
export type EsrsAssessmentForDuplicationQueryResult_ = Apollo.QueryResult<EsrsAssessmentForDuplicationQuery_, EsrsAssessmentForDuplicationQueryVariables_>;
export function refetchEsrsAssessmentForDuplicationQuery_(variables: EsrsAssessmentForDuplicationQueryVariables_) {
      return { query: EsrsAssessmentForDuplicationDocument_, variables: variables }
    }
export const UpsertDuplicatedReportingUnitsDocument_ = gql`
    mutation upsertDuplicatedReportingUnits($objects: [esrs_ReportingUnit_insert_input!] = {}) {
  insert_esrs_ReportingUnit(
    objects: $objects
    on_conflict: {constraint: ReportingUnit_pkey, update_columns: [name, projectLeaderId]}
  ) {
    affected_rows
    returning {
      id
      name
      isCompanyLevel
      lineageId
    }
  }
}
    `;
export type UpsertDuplicatedReportingUnitsMutationFn_ = Apollo.MutationFunction<UpsertDuplicatedReportingUnitsMutation_, UpsertDuplicatedReportingUnitsMutationVariables_>;

/**
 * __useUpsertDuplicatedReportingUnitsMutation__
 *
 * To run a mutation, you first call `useUpsertDuplicatedReportingUnitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDuplicatedReportingUnitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDuplicatedReportingUnitsMutation, { data, loading, error }] = useUpsertDuplicatedReportingUnitsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertDuplicatedReportingUnitsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDuplicatedReportingUnitsMutation_, UpsertDuplicatedReportingUnitsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDuplicatedReportingUnitsMutation_, UpsertDuplicatedReportingUnitsMutationVariables_>(UpsertDuplicatedReportingUnitsDocument_, options);
      }
export type UpsertDuplicatedReportingUnitsMutationHookResult = ReturnType<typeof useUpsertDuplicatedReportingUnitsMutation>;
export type UpsertDuplicatedReportingUnitsMutationResult_ = Apollo.MutationResult<UpsertDuplicatedReportingUnitsMutation_>;
export type UpsertDuplicatedReportingUnitsMutationOptions_ = Apollo.BaseMutationOptions<UpsertDuplicatedReportingUnitsMutation_, UpsertDuplicatedReportingUnitsMutationVariables_>;
export const EsrsAssessmentsDocument_ = gql`
    query esrsAssessments($companyId: uuid!) {
  esrsAssessments: EsrsAssessment(
    where: {companyId: {_eq: $companyId}, deletedAt: {_is_null: true}}
    order_by: {reportingYear: asc}
  ) {
    ...EsrsAssessmentFields
  }
}
    ${EsrsAssessmentFieldsFragmentDoc_}`;

/**
 * __useEsrsAssessmentsQuery__
 *
 * To run a query within a React component, call `useEsrsAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsrsAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsrsAssessmentsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useEsrsAssessmentsQuery(baseOptions: Apollo.QueryHookOptions<EsrsAssessmentsQuery_, EsrsAssessmentsQueryVariables_> & ({ variables: EsrsAssessmentsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsrsAssessmentsQuery_, EsrsAssessmentsQueryVariables_>(EsrsAssessmentsDocument_, options);
      }
export function useEsrsAssessmentsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<EsrsAssessmentsQuery_, EsrsAssessmentsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsrsAssessmentsQuery_, EsrsAssessmentsQueryVariables_>(EsrsAssessmentsDocument_, options);
        }
export function useEsrsAssessmentsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsrsAssessmentsQuery_, EsrsAssessmentsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsrsAssessmentsQuery_, EsrsAssessmentsQueryVariables_>(EsrsAssessmentsDocument_, options);
        }
export type EsrsAssessmentsQueryHookResult = ReturnType<typeof useEsrsAssessmentsQuery>;
export type EsrsAssessmentsLazyQuery_HookResult = ReturnType<typeof useEsrsAssessmentsLazyQuery_>;
export type EsrsAssessmentsSuspenseQuery_HookResult = ReturnType<typeof useEsrsAssessmentsSuspenseQuery_>;
export type EsrsAssessmentsQueryResult_ = Apollo.QueryResult<EsrsAssessmentsQuery_, EsrsAssessmentsQueryVariables_>;
export function refetchEsrsAssessmentsQuery_(variables: EsrsAssessmentsQueryVariables_) {
      return { query: EsrsAssessmentsDocument_, variables: variables }
    }
export const EsrsAssessmentsListDocument_ = gql`
    query esrsAssessmentsList($companyId: uuid!) {
  esrsAssessments: EsrsAssessment(
    where: {companyId: {_eq: $companyId}, deletedAt: {_is_null: true}}
    order_by: {reportingYear: asc}
  ) {
    id
    reportingYear
    onboardingStep
    framework {
      name
      reference
    }
    parentAssessment {
      id
      company {
        id
        name
        logoUrl
      }
      projectLeaderId
      projectLeader {
        ...ShortUser
      }
    }
    materialStandards {
      id
    }
  }
}
    ${ShortUserFragmentDoc_}`;

/**
 * __useEsrsAssessmentsListQuery__
 *
 * To run a query within a React component, call `useEsrsAssessmentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsrsAssessmentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsrsAssessmentsListQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useEsrsAssessmentsListQuery(baseOptions: Apollo.QueryHookOptions<EsrsAssessmentsListQuery_, EsrsAssessmentsListQueryVariables_> & ({ variables: EsrsAssessmentsListQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsrsAssessmentsListQuery_, EsrsAssessmentsListQueryVariables_>(EsrsAssessmentsListDocument_, options);
      }
export function useEsrsAssessmentsListLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<EsrsAssessmentsListQuery_, EsrsAssessmentsListQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsrsAssessmentsListQuery_, EsrsAssessmentsListQueryVariables_>(EsrsAssessmentsListDocument_, options);
        }
export function useEsrsAssessmentsListSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsrsAssessmentsListQuery_, EsrsAssessmentsListQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsrsAssessmentsListQuery_, EsrsAssessmentsListQueryVariables_>(EsrsAssessmentsListDocument_, options);
        }
export type EsrsAssessmentsListQueryHookResult = ReturnType<typeof useEsrsAssessmentsListQuery>;
export type EsrsAssessmentsListLazyQuery_HookResult = ReturnType<typeof useEsrsAssessmentsListLazyQuery_>;
export type EsrsAssessmentsListSuspenseQuery_HookResult = ReturnType<typeof useEsrsAssessmentsListSuspenseQuery_>;
export type EsrsAssessmentsListQueryResult_ = Apollo.QueryResult<EsrsAssessmentsListQuery_, EsrsAssessmentsListQueryVariables_>;
export function refetchEsrsAssessmentsListQuery_(variables: EsrsAssessmentsListQueryVariables_) {
      return { query: EsrsAssessmentsListDocument_, variables: variables }
    }
export const EsrsAssessmentsYearsDocument_ = gql`
    query esrsAssessmentsYears($companyId: uuid!, $companyIntegrationId: uuid!) {
  esrsAssessments: EsrsAssessment(
    where: {companyId: {_eq: $companyId}, deletedAt: {_is_null: true}}
    order_by: {reportingYear: asc}
  ) {
    id
    reportingYear
    projectLeaderId
    reportingUnits(where: {isCompanyLevel: {_eq: true}}) {
      id
    }
    esrsAssessmentCompanyIntegrations(
      where: {companyIntegrationId: {_eq: $companyIntegrationId}}
    ) {
      syncedAt
    }
  }
}
    `;

/**
 * __useEsrsAssessmentsYearsQuery__
 *
 * To run a query within a React component, call `useEsrsAssessmentsYearsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsrsAssessmentsYearsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsrsAssessmentsYearsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      companyIntegrationId: // value for 'companyIntegrationId'
 *   },
 * });
 */
export function useEsrsAssessmentsYearsQuery(baseOptions: Apollo.QueryHookOptions<EsrsAssessmentsYearsQuery_, EsrsAssessmentsYearsQueryVariables_> & ({ variables: EsrsAssessmentsYearsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsrsAssessmentsYearsQuery_, EsrsAssessmentsYearsQueryVariables_>(EsrsAssessmentsYearsDocument_, options);
      }
export function useEsrsAssessmentsYearsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<EsrsAssessmentsYearsQuery_, EsrsAssessmentsYearsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsrsAssessmentsYearsQuery_, EsrsAssessmentsYearsQueryVariables_>(EsrsAssessmentsYearsDocument_, options);
        }
export function useEsrsAssessmentsYearsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsrsAssessmentsYearsQuery_, EsrsAssessmentsYearsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsrsAssessmentsYearsQuery_, EsrsAssessmentsYearsQueryVariables_>(EsrsAssessmentsYearsDocument_, options);
        }
export type EsrsAssessmentsYearsQueryHookResult = ReturnType<typeof useEsrsAssessmentsYearsQuery>;
export type EsrsAssessmentsYearsLazyQuery_HookResult = ReturnType<typeof useEsrsAssessmentsYearsLazyQuery_>;
export type EsrsAssessmentsYearsSuspenseQuery_HookResult = ReturnType<typeof useEsrsAssessmentsYearsSuspenseQuery_>;
export type EsrsAssessmentsYearsQueryResult_ = Apollo.QueryResult<EsrsAssessmentsYearsQuery_, EsrsAssessmentsYearsQueryVariables_>;
export function refetchEsrsAssessmentsYearsQuery_(variables: EsrsAssessmentsYearsQueryVariables_) {
      return { query: EsrsAssessmentsYearsDocument_, variables: variables }
    }
export const EsrsAssessmentDocument_ = gql`
    query esrsAssessment($esrsAssessmentId: uuid!) {
  esrsAssessment: EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    ...EsrsAssessmentFields
  }
}
    ${EsrsAssessmentFieldsFragmentDoc_}`;

/**
 * __useEsrsAssessmentQuery__
 *
 * To run a query within a React component, call `useEsrsAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsrsAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsrsAssessmentQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useEsrsAssessmentQuery(baseOptions: Apollo.QueryHookOptions<EsrsAssessmentQuery_, EsrsAssessmentQueryVariables_> & ({ variables: EsrsAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsrsAssessmentQuery_, EsrsAssessmentQueryVariables_>(EsrsAssessmentDocument_, options);
      }
export function useEsrsAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<EsrsAssessmentQuery_, EsrsAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsrsAssessmentQuery_, EsrsAssessmentQueryVariables_>(EsrsAssessmentDocument_, options);
        }
export function useEsrsAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsrsAssessmentQuery_, EsrsAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsrsAssessmentQuery_, EsrsAssessmentQueryVariables_>(EsrsAssessmentDocument_, options);
        }
export type EsrsAssessmentQueryHookResult = ReturnType<typeof useEsrsAssessmentQuery>;
export type EsrsAssessmentLazyQuery_HookResult = ReturnType<typeof useEsrsAssessmentLazyQuery_>;
export type EsrsAssessmentSuspenseQuery_HookResult = ReturnType<typeof useEsrsAssessmentSuspenseQuery_>;
export type EsrsAssessmentQueryResult_ = Apollo.QueryResult<EsrsAssessmentQuery_, EsrsAssessmentQueryVariables_>;
export function refetchEsrsAssessmentQuery_(variables: EsrsAssessmentQueryVariables_) {
      return { query: EsrsAssessmentDocument_, variables: variables }
    }
export const ShortEsrsAssessmentDocument_ = gql`
    query shortEsrsAssessment($esrsAssessmentId: uuid!) {
  esrsAssessment: EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    reportingYear
    collectOnly
    company {
      id
      isGroupOwner
    }
    projectLeader {
      ...ShortUser
    }
    parentAssessment {
      id
    }
    materialStandards {
      id
      standardRef
      materialStandardOwners {
        id
        reportingUnitId
        owner {
          ...ShortUser
        }
      }
    }
  }
}
    ${ShortUserFragmentDoc_}`;

/**
 * __useShortEsrsAssessmentQuery__
 *
 * To run a query within a React component, call `useShortEsrsAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useShortEsrsAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShortEsrsAssessmentQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useShortEsrsAssessmentQuery(baseOptions: Apollo.QueryHookOptions<ShortEsrsAssessmentQuery_, ShortEsrsAssessmentQueryVariables_> & ({ variables: ShortEsrsAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShortEsrsAssessmentQuery_, ShortEsrsAssessmentQueryVariables_>(ShortEsrsAssessmentDocument_, options);
      }
export function useShortEsrsAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ShortEsrsAssessmentQuery_, ShortEsrsAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShortEsrsAssessmentQuery_, ShortEsrsAssessmentQueryVariables_>(ShortEsrsAssessmentDocument_, options);
        }
export function useShortEsrsAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShortEsrsAssessmentQuery_, ShortEsrsAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShortEsrsAssessmentQuery_, ShortEsrsAssessmentQueryVariables_>(ShortEsrsAssessmentDocument_, options);
        }
export type ShortEsrsAssessmentQueryHookResult = ReturnType<typeof useShortEsrsAssessmentQuery>;
export type ShortEsrsAssessmentLazyQuery_HookResult = ReturnType<typeof useShortEsrsAssessmentLazyQuery_>;
export type ShortEsrsAssessmentSuspenseQuery_HookResult = ReturnType<typeof useShortEsrsAssessmentSuspenseQuery_>;
export type ShortEsrsAssessmentQueryResult_ = Apollo.QueryResult<ShortEsrsAssessmentQuery_, ShortEsrsAssessmentQueryVariables_>;
export function refetchShortEsrsAssessmentQuery_(variables: ShortEsrsAssessmentQueryVariables_) {
      return { query: ShortEsrsAssessmentDocument_, variables: variables }
    }
export const EsrsAssessmentYearDocument_ = gql`
    query esrsAssessmentYear($esrsAssessmentId: uuid!) {
  esrsAssessment: EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    reportingYear
    framework {
      name
    }
  }
}
    `;

/**
 * __useEsrsAssessmentYearQuery__
 *
 * To run a query within a React component, call `useEsrsAssessmentYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsrsAssessmentYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsrsAssessmentYearQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useEsrsAssessmentYearQuery(baseOptions: Apollo.QueryHookOptions<EsrsAssessmentYearQuery_, EsrsAssessmentYearQueryVariables_> & ({ variables: EsrsAssessmentYearQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsrsAssessmentYearQuery_, EsrsAssessmentYearQueryVariables_>(EsrsAssessmentYearDocument_, options);
      }
export function useEsrsAssessmentYearLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<EsrsAssessmentYearQuery_, EsrsAssessmentYearQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsrsAssessmentYearQuery_, EsrsAssessmentYearQueryVariables_>(EsrsAssessmentYearDocument_, options);
        }
export function useEsrsAssessmentYearSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsrsAssessmentYearQuery_, EsrsAssessmentYearQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsrsAssessmentYearQuery_, EsrsAssessmentYearQueryVariables_>(EsrsAssessmentYearDocument_, options);
        }
export type EsrsAssessmentYearQueryHookResult = ReturnType<typeof useEsrsAssessmentYearQuery>;
export type EsrsAssessmentYearLazyQuery_HookResult = ReturnType<typeof useEsrsAssessmentYearLazyQuery_>;
export type EsrsAssessmentYearSuspenseQuery_HookResult = ReturnType<typeof useEsrsAssessmentYearSuspenseQuery_>;
export type EsrsAssessmentYearQueryResult_ = Apollo.QueryResult<EsrsAssessmentYearQuery_, EsrsAssessmentYearQueryVariables_>;
export function refetchEsrsAssessmentYearQuery_(variables: EsrsAssessmentYearQueryVariables_) {
      return { query: EsrsAssessmentYearDocument_, variables: variables }
    }
export const EsrsAssessmentProjectLeaderDocument_ = gql`
    query esrsAssessmentProjectLeader($esrsAssessmentId: uuid!) {
  esrsAssessment: EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    projectLeaderId
    projectLeader {
      ...ShortUser
    }
  }
}
    ${ShortUserFragmentDoc_}`;

/**
 * __useEsrsAssessmentProjectLeaderQuery__
 *
 * To run a query within a React component, call `useEsrsAssessmentProjectLeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsrsAssessmentProjectLeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsrsAssessmentProjectLeaderQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useEsrsAssessmentProjectLeaderQuery(baseOptions: Apollo.QueryHookOptions<EsrsAssessmentProjectLeaderQuery_, EsrsAssessmentProjectLeaderQueryVariables_> & ({ variables: EsrsAssessmentProjectLeaderQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsrsAssessmentProjectLeaderQuery_, EsrsAssessmentProjectLeaderQueryVariables_>(EsrsAssessmentProjectLeaderDocument_, options);
      }
export function useEsrsAssessmentProjectLeaderLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<EsrsAssessmentProjectLeaderQuery_, EsrsAssessmentProjectLeaderQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsrsAssessmentProjectLeaderQuery_, EsrsAssessmentProjectLeaderQueryVariables_>(EsrsAssessmentProjectLeaderDocument_, options);
        }
export function useEsrsAssessmentProjectLeaderSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsrsAssessmentProjectLeaderQuery_, EsrsAssessmentProjectLeaderQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsrsAssessmentProjectLeaderQuery_, EsrsAssessmentProjectLeaderQueryVariables_>(EsrsAssessmentProjectLeaderDocument_, options);
        }
export type EsrsAssessmentProjectLeaderQueryHookResult = ReturnType<typeof useEsrsAssessmentProjectLeaderQuery>;
export type EsrsAssessmentProjectLeaderLazyQuery_HookResult = ReturnType<typeof useEsrsAssessmentProjectLeaderLazyQuery_>;
export type EsrsAssessmentProjectLeaderSuspenseQuery_HookResult = ReturnType<typeof useEsrsAssessmentProjectLeaderSuspenseQuery_>;
export type EsrsAssessmentProjectLeaderQueryResult_ = Apollo.QueryResult<EsrsAssessmentProjectLeaderQuery_, EsrsAssessmentProjectLeaderQueryVariables_>;
export function refetchEsrsAssessmentProjectLeaderQuery_(variables: EsrsAssessmentProjectLeaderQueryVariables_) {
      return { query: EsrsAssessmentProjectLeaderDocument_, variables: variables }
    }
export const EsrsAssessmentMaterialStandardsDocument_ = gql`
    query esrsAssessmentMaterialStandards($esrsAssessmentId: uuid!) {
  esrsAssessment: EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    ...AssessmentMaterialStandardsFields
  }
}
    ${AssessmentMaterialStandardsFieldsFragmentDoc_}`;

/**
 * __useEsrsAssessmentMaterialStandardsQuery__
 *
 * To run a query within a React component, call `useEsrsAssessmentMaterialStandardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsrsAssessmentMaterialStandardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsrsAssessmentMaterialStandardsQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useEsrsAssessmentMaterialStandardsQuery(baseOptions: Apollo.QueryHookOptions<EsrsAssessmentMaterialStandardsQuery_, EsrsAssessmentMaterialStandardsQueryVariables_> & ({ variables: EsrsAssessmentMaterialStandardsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsrsAssessmentMaterialStandardsQuery_, EsrsAssessmentMaterialStandardsQueryVariables_>(EsrsAssessmentMaterialStandardsDocument_, options);
      }
export function useEsrsAssessmentMaterialStandardsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<EsrsAssessmentMaterialStandardsQuery_, EsrsAssessmentMaterialStandardsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsrsAssessmentMaterialStandardsQuery_, EsrsAssessmentMaterialStandardsQueryVariables_>(EsrsAssessmentMaterialStandardsDocument_, options);
        }
export function useEsrsAssessmentMaterialStandardsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsrsAssessmentMaterialStandardsQuery_, EsrsAssessmentMaterialStandardsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsrsAssessmentMaterialStandardsQuery_, EsrsAssessmentMaterialStandardsQueryVariables_>(EsrsAssessmentMaterialStandardsDocument_, options);
        }
export type EsrsAssessmentMaterialStandardsQueryHookResult = ReturnType<typeof useEsrsAssessmentMaterialStandardsQuery>;
export type EsrsAssessmentMaterialStandardsLazyQuery_HookResult = ReturnType<typeof useEsrsAssessmentMaterialStandardsLazyQuery_>;
export type EsrsAssessmentMaterialStandardsSuspenseQuery_HookResult = ReturnType<typeof useEsrsAssessmentMaterialStandardsSuspenseQuery_>;
export type EsrsAssessmentMaterialStandardsQueryResult_ = Apollo.QueryResult<EsrsAssessmentMaterialStandardsQuery_, EsrsAssessmentMaterialStandardsQueryVariables_>;
export function refetchEsrsAssessmentMaterialStandardsQuery_(variables: EsrsAssessmentMaterialStandardsQueryVariables_) {
      return { query: EsrsAssessmentMaterialStandardsDocument_, variables: variables }
    }
export const ReportingUnitLineageDocument_ = gql`
    query reportingUnitLineage($companyId: uuid!) {
  esrs_ReportingUnitLineage(where: {companyId: {_eq: $companyId}}) {
    reportingUnits(
      where: {isCompanyLevel: {_eq: false}, esrsAssessment: {deletedAt: {_is_null: false}}}
    ) {
      id
      name
      lineageId
      esrsAssessment {
        id
        reportingYear
      }
      projectLeaderId
      projectLeader {
        ...ShortUser
      }
    }
  }
}
    ${ShortUserFragmentDoc_}`;

/**
 * __useReportingUnitLineageQuery__
 *
 * To run a query within a React component, call `useReportingUnitLineageQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingUnitLineageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingUnitLineageQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useReportingUnitLineageQuery(baseOptions: Apollo.QueryHookOptions<ReportingUnitLineageQuery_, ReportingUnitLineageQueryVariables_> & ({ variables: ReportingUnitLineageQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingUnitLineageQuery_, ReportingUnitLineageQueryVariables_>(ReportingUnitLineageDocument_, options);
      }
export function useReportingUnitLineageLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ReportingUnitLineageQuery_, ReportingUnitLineageQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingUnitLineageQuery_, ReportingUnitLineageQueryVariables_>(ReportingUnitLineageDocument_, options);
        }
export function useReportingUnitLineageSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingUnitLineageQuery_, ReportingUnitLineageQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingUnitLineageQuery_, ReportingUnitLineageQueryVariables_>(ReportingUnitLineageDocument_, options);
        }
export type ReportingUnitLineageQueryHookResult = ReturnType<typeof useReportingUnitLineageQuery>;
export type ReportingUnitLineageLazyQuery_HookResult = ReturnType<typeof useReportingUnitLineageLazyQuery_>;
export type ReportingUnitLineageSuspenseQuery_HookResult = ReturnType<typeof useReportingUnitLineageSuspenseQuery_>;
export type ReportingUnitLineageQueryResult_ = Apollo.QueryResult<ReportingUnitLineageQuery_, ReportingUnitLineageQueryVariables_>;
export function refetchReportingUnitLineageQuery_(variables: ReportingUnitLineageQueryVariables_) {
      return { query: ReportingUnitLineageDocument_, variables: variables }
    }
export const GetSubsidiariesWithAssessmentsDocument_ = gql`
    query getSubsidiariesWithAssessments($esrsAssessmentId: uuid!, $standardRef: String!) {
  esrs: EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    subsidiaries: subsidiaryAssessments {
      id
      company {
        id
        name
      }
      materialStandards(where: {standardRef: {_eq: $standardRef}}) {
        id
        isMaterial
      }
    }
  }
}
    `;

/**
 * __useGetSubsidiariesWithAssessmentsQuery__
 *
 * To run a query within a React component, call `useGetSubsidiariesWithAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsidiariesWithAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsidiariesWithAssessmentsQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      standardRef: // value for 'standardRef'
 *   },
 * });
 */
export function useGetSubsidiariesWithAssessmentsQuery(baseOptions: Apollo.QueryHookOptions<GetSubsidiariesWithAssessmentsQuery_, GetSubsidiariesWithAssessmentsQueryVariables_> & ({ variables: GetSubsidiariesWithAssessmentsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsidiariesWithAssessmentsQuery_, GetSubsidiariesWithAssessmentsQueryVariables_>(GetSubsidiariesWithAssessmentsDocument_, options);
      }
export function useGetSubsidiariesWithAssessmentsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsidiariesWithAssessmentsQuery_, GetSubsidiariesWithAssessmentsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsidiariesWithAssessmentsQuery_, GetSubsidiariesWithAssessmentsQueryVariables_>(GetSubsidiariesWithAssessmentsDocument_, options);
        }
export function useGetSubsidiariesWithAssessmentsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubsidiariesWithAssessmentsQuery_, GetSubsidiariesWithAssessmentsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubsidiariesWithAssessmentsQuery_, GetSubsidiariesWithAssessmentsQueryVariables_>(GetSubsidiariesWithAssessmentsDocument_, options);
        }
export type GetSubsidiariesWithAssessmentsQueryHookResult = ReturnType<typeof useGetSubsidiariesWithAssessmentsQuery>;
export type GetSubsidiariesWithAssessmentsLazyQuery_HookResult = ReturnType<typeof useGetSubsidiariesWithAssessmentsLazyQuery_>;
export type GetSubsidiariesWithAssessmentsSuspenseQuery_HookResult = ReturnType<typeof useGetSubsidiariesWithAssessmentsSuspenseQuery_>;
export type GetSubsidiariesWithAssessmentsQueryResult_ = Apollo.QueryResult<GetSubsidiariesWithAssessmentsQuery_, GetSubsidiariesWithAssessmentsQueryVariables_>;
export function refetchGetSubsidiariesWithAssessmentsQuery_(variables: GetSubsidiariesWithAssessmentsQueryVariables_) {
      return { query: GetSubsidiariesWithAssessmentsDocument_, variables: variables }
    }
export const GetSubsidiariesDocument_ = gql`
    query getSubsidiaries($esrsAssessmentId: uuid!) {
  esrs: EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    subsidiaries: subsidiaryAssessments(where: {deletedAt: {_is_null: true}}) {
      id
      company {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetSubsidiariesQuery__
 *
 * To run a query within a React component, call `useGetSubsidiariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsidiariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsidiariesQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetSubsidiariesQuery(baseOptions: Apollo.QueryHookOptions<GetSubsidiariesQuery_, GetSubsidiariesQueryVariables_> & ({ variables: GetSubsidiariesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsidiariesQuery_, GetSubsidiariesQueryVariables_>(GetSubsidiariesDocument_, options);
      }
export function useGetSubsidiariesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsidiariesQuery_, GetSubsidiariesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsidiariesQuery_, GetSubsidiariesQueryVariables_>(GetSubsidiariesDocument_, options);
        }
export function useGetSubsidiariesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubsidiariesQuery_, GetSubsidiariesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubsidiariesQuery_, GetSubsidiariesQueryVariables_>(GetSubsidiariesDocument_, options);
        }
export type GetSubsidiariesQueryHookResult = ReturnType<typeof useGetSubsidiariesQuery>;
export type GetSubsidiariesLazyQuery_HookResult = ReturnType<typeof useGetSubsidiariesLazyQuery_>;
export type GetSubsidiariesSuspenseQuery_HookResult = ReturnType<typeof useGetSubsidiariesSuspenseQuery_>;
export type GetSubsidiariesQueryResult_ = Apollo.QueryResult<GetSubsidiariesQuery_, GetSubsidiariesQueryVariables_>;
export function refetchGetSubsidiariesQuery_(variables: GetSubsidiariesQueryVariables_) {
      return { query: GetSubsidiariesDocument_, variables: variables }
    }
export const GetReportingUnitsDocument_ = gql`
    query getReportingUnits($assessmentId: uuid!) {
  reportingUnits: esrs_ReportingUnit(
    where: {assessmentId: {_eq: $assessmentId}}
    order_by: {isCompanyLevel: desc}
  ) {
    id
    name
    isCompanyLevel
  }
}
    `;

/**
 * __useGetReportingUnitsQuery__
 *
 * To run a query within a React component, call `useGetReportingUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingUnitsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetReportingUnitsQuery(baseOptions: Apollo.QueryHookOptions<GetReportingUnitsQuery_, GetReportingUnitsQueryVariables_> & ({ variables: GetReportingUnitsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportingUnitsQuery_, GetReportingUnitsQueryVariables_>(GetReportingUnitsDocument_, options);
      }
export function useGetReportingUnitsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetReportingUnitsQuery_, GetReportingUnitsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportingUnitsQuery_, GetReportingUnitsQueryVariables_>(GetReportingUnitsDocument_, options);
        }
export function useGetReportingUnitsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportingUnitsQuery_, GetReportingUnitsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportingUnitsQuery_, GetReportingUnitsQueryVariables_>(GetReportingUnitsDocument_, options);
        }
export type GetReportingUnitsQueryHookResult = ReturnType<typeof useGetReportingUnitsQuery>;
export type GetReportingUnitsLazyQuery_HookResult = ReturnType<typeof useGetReportingUnitsLazyQuery_>;
export type GetReportingUnitsSuspenseQuery_HookResult = ReturnType<typeof useGetReportingUnitsSuspenseQuery_>;
export type GetReportingUnitsQueryResult_ = Apollo.QueryResult<GetReportingUnitsQuery_, GetReportingUnitsQueryVariables_>;
export function refetchGetReportingUnitsQuery_(variables: GetReportingUnitsQueryVariables_) {
      return { query: GetReportingUnitsDocument_, variables: variables }
    }
export const GetEsrsAssessmentMetadataDocument_ = gql`
    query getEsrsAssessmentMetadata($id: uuid!) {
  EsrsAssessment_by_pk(id: $id) {
    id
    metadata
  }
}
    `;

/**
 * __useGetEsrsAssessmentMetadataQuery__
 *
 * To run a query within a React component, call `useGetEsrsAssessmentMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsrsAssessmentMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsrsAssessmentMetadataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEsrsAssessmentMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetEsrsAssessmentMetadataQuery_, GetEsrsAssessmentMetadataQueryVariables_> & ({ variables: GetEsrsAssessmentMetadataQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsrsAssessmentMetadataQuery_, GetEsrsAssessmentMetadataQueryVariables_>(GetEsrsAssessmentMetadataDocument_, options);
      }
export function useGetEsrsAssessmentMetadataLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetEsrsAssessmentMetadataQuery_, GetEsrsAssessmentMetadataQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsrsAssessmentMetadataQuery_, GetEsrsAssessmentMetadataQueryVariables_>(GetEsrsAssessmentMetadataDocument_, options);
        }
export function useGetEsrsAssessmentMetadataSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEsrsAssessmentMetadataQuery_, GetEsrsAssessmentMetadataQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEsrsAssessmentMetadataQuery_, GetEsrsAssessmentMetadataQueryVariables_>(GetEsrsAssessmentMetadataDocument_, options);
        }
export type GetEsrsAssessmentMetadataQueryHookResult = ReturnType<typeof useGetEsrsAssessmentMetadataQuery>;
export type GetEsrsAssessmentMetadataLazyQuery_HookResult = ReturnType<typeof useGetEsrsAssessmentMetadataLazyQuery_>;
export type GetEsrsAssessmentMetadataSuspenseQuery_HookResult = ReturnType<typeof useGetEsrsAssessmentMetadataSuspenseQuery_>;
export type GetEsrsAssessmentMetadataQueryResult_ = Apollo.QueryResult<GetEsrsAssessmentMetadataQuery_, GetEsrsAssessmentMetadataQueryVariables_>;
export function refetchGetEsrsAssessmentMetadataQuery_(variables: GetEsrsAssessmentMetadataQueryVariables_) {
      return { query: GetEsrsAssessmentMetadataDocument_, variables: variables }
    }
export const GetEsrsAssessmentShortDetailsDocument_ = gql`
    query getEsrsAssessmentShortDetails($esrsAssessmentId: uuid!) {
  assessment: EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    reportingYear
    companyId
    collectOnly
    parentAssessmentId
    company {
      name
    }
  }
}
    `;

/**
 * __useGetEsrsAssessmentShortDetailsQuery__
 *
 * To run a query within a React component, call `useGetEsrsAssessmentShortDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsrsAssessmentShortDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsrsAssessmentShortDetailsQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetEsrsAssessmentShortDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetEsrsAssessmentShortDetailsQuery_, GetEsrsAssessmentShortDetailsQueryVariables_> & ({ variables: GetEsrsAssessmentShortDetailsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsrsAssessmentShortDetailsQuery_, GetEsrsAssessmentShortDetailsQueryVariables_>(GetEsrsAssessmentShortDetailsDocument_, options);
      }
export function useGetEsrsAssessmentShortDetailsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetEsrsAssessmentShortDetailsQuery_, GetEsrsAssessmentShortDetailsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsrsAssessmentShortDetailsQuery_, GetEsrsAssessmentShortDetailsQueryVariables_>(GetEsrsAssessmentShortDetailsDocument_, options);
        }
export function useGetEsrsAssessmentShortDetailsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEsrsAssessmentShortDetailsQuery_, GetEsrsAssessmentShortDetailsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEsrsAssessmentShortDetailsQuery_, GetEsrsAssessmentShortDetailsQueryVariables_>(GetEsrsAssessmentShortDetailsDocument_, options);
        }
export type GetEsrsAssessmentShortDetailsQueryHookResult = ReturnType<typeof useGetEsrsAssessmentShortDetailsQuery>;
export type GetEsrsAssessmentShortDetailsLazyQuery_HookResult = ReturnType<typeof useGetEsrsAssessmentShortDetailsLazyQuery_>;
export type GetEsrsAssessmentShortDetailsSuspenseQuery_HookResult = ReturnType<typeof useGetEsrsAssessmentShortDetailsSuspenseQuery_>;
export type GetEsrsAssessmentShortDetailsQueryResult_ = Apollo.QueryResult<GetEsrsAssessmentShortDetailsQuery_, GetEsrsAssessmentShortDetailsQueryVariables_>;
export function refetchGetEsrsAssessmentShortDetailsQuery_(variables: GetEsrsAssessmentShortDetailsQueryVariables_) {
      return { query: GetEsrsAssessmentShortDetailsDocument_, variables: variables }
    }
export const GetOnboardingEsrsAssessmentDocument_ = gql`
    query getOnboardingEsrsAssessment($esrsAssessmentId: uuid!) {
  esrsAssessment: EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    onboardingStep
    collectOnly
    company {
      id
      name
    }
    parentAssessment {
      id
      company {
        id
        name
        logoUrl
      }
    }
  }
}
    `;

/**
 * __useGetOnboardingEsrsAssessmentQuery__
 *
 * To run a query within a React component, call `useGetOnboardingEsrsAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOnboardingEsrsAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOnboardingEsrsAssessmentQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetOnboardingEsrsAssessmentQuery(baseOptions: Apollo.QueryHookOptions<GetOnboardingEsrsAssessmentQuery_, GetOnboardingEsrsAssessmentQueryVariables_> & ({ variables: GetOnboardingEsrsAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOnboardingEsrsAssessmentQuery_, GetOnboardingEsrsAssessmentQueryVariables_>(GetOnboardingEsrsAssessmentDocument_, options);
      }
export function useGetOnboardingEsrsAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetOnboardingEsrsAssessmentQuery_, GetOnboardingEsrsAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOnboardingEsrsAssessmentQuery_, GetOnboardingEsrsAssessmentQueryVariables_>(GetOnboardingEsrsAssessmentDocument_, options);
        }
export function useGetOnboardingEsrsAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOnboardingEsrsAssessmentQuery_, GetOnboardingEsrsAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOnboardingEsrsAssessmentQuery_, GetOnboardingEsrsAssessmentQueryVariables_>(GetOnboardingEsrsAssessmentDocument_, options);
        }
export type GetOnboardingEsrsAssessmentQueryHookResult = ReturnType<typeof useGetOnboardingEsrsAssessmentQuery>;
export type GetOnboardingEsrsAssessmentLazyQuery_HookResult = ReturnType<typeof useGetOnboardingEsrsAssessmentLazyQuery_>;
export type GetOnboardingEsrsAssessmentSuspenseQuery_HookResult = ReturnType<typeof useGetOnboardingEsrsAssessmentSuspenseQuery_>;
export type GetOnboardingEsrsAssessmentQueryResult_ = Apollo.QueryResult<GetOnboardingEsrsAssessmentQuery_, GetOnboardingEsrsAssessmentQueryVariables_>;
export function refetchGetOnboardingEsrsAssessmentQuery_(variables: GetOnboardingEsrsAssessmentQueryVariables_) {
      return { query: GetOnboardingEsrsAssessmentDocument_, variables: variables }
    }
export const GetParentAssessmentToCopyDocument_ = gql`
    query getParentAssessmentToCopy($childAssessmentId: uuid!) {
  EsrsAssessment_by_pk(id: $childAssessmentId) {
    id
    parentAssessment {
      materialStandards(
        where: {materialMetrics: {dataCollection: {_eq: "subsidiaries"}}}
      ) {
        id
        isMaterial
        standardRef
        standard {
          reference
          disclosureRequirementGroups {
            policyRequirements: requirements(where: {type: {_eq: "policy"}}) {
              reference
            }
          }
        }
        materialMetrics {
          id
          metricRef
          isMaterial
          dataCollection
          frequency
          childrenMetrics_aggregate {
            aggregate {
              count
            }
          }
          metric {
            reference
            disclosureRequirementRef
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetParentAssessmentToCopyQuery__
 *
 * To run a query within a React component, call `useGetParentAssessmentToCopyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentAssessmentToCopyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentAssessmentToCopyQuery({
 *   variables: {
 *      childAssessmentId: // value for 'childAssessmentId'
 *   },
 * });
 */
export function useGetParentAssessmentToCopyQuery(baseOptions: Apollo.QueryHookOptions<GetParentAssessmentToCopyQuery_, GetParentAssessmentToCopyQueryVariables_> & ({ variables: GetParentAssessmentToCopyQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParentAssessmentToCopyQuery_, GetParentAssessmentToCopyQueryVariables_>(GetParentAssessmentToCopyDocument_, options);
      }
export function useGetParentAssessmentToCopyLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetParentAssessmentToCopyQuery_, GetParentAssessmentToCopyQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParentAssessmentToCopyQuery_, GetParentAssessmentToCopyQueryVariables_>(GetParentAssessmentToCopyDocument_, options);
        }
export function useGetParentAssessmentToCopySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParentAssessmentToCopyQuery_, GetParentAssessmentToCopyQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParentAssessmentToCopyQuery_, GetParentAssessmentToCopyQueryVariables_>(GetParentAssessmentToCopyDocument_, options);
        }
export type GetParentAssessmentToCopyQueryHookResult = ReturnType<typeof useGetParentAssessmentToCopyQuery>;
export type GetParentAssessmentToCopyLazyQuery_HookResult = ReturnType<typeof useGetParentAssessmentToCopyLazyQuery_>;
export type GetParentAssessmentToCopySuspenseQuery_HookResult = ReturnType<typeof useGetParentAssessmentToCopySuspenseQuery_>;
export type GetParentAssessmentToCopyQueryResult_ = Apollo.QueryResult<GetParentAssessmentToCopyQuery_, GetParentAssessmentToCopyQueryVariables_>;
export function refetchGetParentAssessmentToCopyQuery_(variables: GetParentAssessmentToCopyQueryVariables_) {
      return { query: GetParentAssessmentToCopyDocument_, variables: variables }
    }
export const GetReportingUnitDocument_ = gql`
    query getReportingUnit($reportingUnitId: uuid!) {
  bu: esrs_ReportingUnit_by_pk(id: $reportingUnitId) {
    id
    isCompanyLevel
    name
  }
}
    `;

/**
 * __useGetReportingUnitQuery__
 *
 * To run a query within a React component, call `useGetReportingUnitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingUnitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingUnitQuery({
 *   variables: {
 *      reportingUnitId: // value for 'reportingUnitId'
 *   },
 * });
 */
export function useGetReportingUnitQuery(baseOptions: Apollo.QueryHookOptions<GetReportingUnitQuery_, GetReportingUnitQueryVariables_> & ({ variables: GetReportingUnitQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportingUnitQuery_, GetReportingUnitQueryVariables_>(GetReportingUnitDocument_, options);
      }
export function useGetReportingUnitLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetReportingUnitQuery_, GetReportingUnitQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportingUnitQuery_, GetReportingUnitQueryVariables_>(GetReportingUnitDocument_, options);
        }
export function useGetReportingUnitSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportingUnitQuery_, GetReportingUnitQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportingUnitQuery_, GetReportingUnitQueryVariables_>(GetReportingUnitDocument_, options);
        }
export type GetReportingUnitQueryHookResult = ReturnType<typeof useGetReportingUnitQuery>;
export type GetReportingUnitLazyQuery_HookResult = ReturnType<typeof useGetReportingUnitLazyQuery_>;
export type GetReportingUnitSuspenseQuery_HookResult = ReturnType<typeof useGetReportingUnitSuspenseQuery_>;
export type GetReportingUnitQueryResult_ = Apollo.QueryResult<GetReportingUnitQuery_, GetReportingUnitQueryVariables_>;
export function refetchGetReportingUnitQuery_(variables: GetReportingUnitQueryVariables_) {
      return { query: GetReportingUnitDocument_, variables: variables }
    }
export const GetSubsidiaryTypeDocument_ = gql`
    query getSubsidiaryType($esrsAssessmentId: uuid!) {
  esrsAssessment: EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    collectOnly
  }
}
    `;

/**
 * __useGetSubsidiaryTypeQuery__
 *
 * To run a query within a React component, call `useGetSubsidiaryTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsidiaryTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsidiaryTypeQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetSubsidiaryTypeQuery(baseOptions: Apollo.QueryHookOptions<GetSubsidiaryTypeQuery_, GetSubsidiaryTypeQueryVariables_> & ({ variables: GetSubsidiaryTypeQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsidiaryTypeQuery_, GetSubsidiaryTypeQueryVariables_>(GetSubsidiaryTypeDocument_, options);
      }
export function useGetSubsidiaryTypeLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsidiaryTypeQuery_, GetSubsidiaryTypeQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsidiaryTypeQuery_, GetSubsidiaryTypeQueryVariables_>(GetSubsidiaryTypeDocument_, options);
        }
export function useGetSubsidiaryTypeSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubsidiaryTypeQuery_, GetSubsidiaryTypeQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubsidiaryTypeQuery_, GetSubsidiaryTypeQueryVariables_>(GetSubsidiaryTypeDocument_, options);
        }
export type GetSubsidiaryTypeQueryHookResult = ReturnType<typeof useGetSubsidiaryTypeQuery>;
export type GetSubsidiaryTypeLazyQuery_HookResult = ReturnType<typeof useGetSubsidiaryTypeLazyQuery_>;
export type GetSubsidiaryTypeSuspenseQuery_HookResult = ReturnType<typeof useGetSubsidiaryTypeSuspenseQuery_>;
export type GetSubsidiaryTypeQueryResult_ = Apollo.QueryResult<GetSubsidiaryTypeQuery_, GetSubsidiaryTypeQueryVariables_>;
export function refetchGetSubsidiaryTypeQuery_(variables: GetSubsidiaryTypeQueryVariables_) {
      return { query: GetSubsidiaryTypeDocument_, variables: variables }
    }
export const GetFlaggedTargetsDocument_ = gql`
    query GetFlaggedTargets($esrsAssessmentId: uuid!) {
  targets: esrs_Target(
    where: {parentTargetId: {_is_null: false}, materialStandard: {assessmentId: {_eq: $esrsAssessmentId}}, keyResults_aggregate: {bool_and: {predicate: {_eq: true}, arguments: isFlagged}}}
  ) {
    id
    name
    disclosureRequirementRef
    assessmentId
    materialStandard {
      standardRef
      standard {
        title
      }
    }
  }
}
    `;

/**
 * __useGetFlaggedTargetsQuery__
 *
 * To run a query within a React component, call `useGetFlaggedTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFlaggedTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFlaggedTargetsQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetFlaggedTargetsQuery(baseOptions: Apollo.QueryHookOptions<GetFlaggedTargetsQuery_, GetFlaggedTargetsQueryVariables_> & ({ variables: GetFlaggedTargetsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFlaggedTargetsQuery_, GetFlaggedTargetsQueryVariables_>(GetFlaggedTargetsDocument_, options);
      }
export function useGetFlaggedTargetsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetFlaggedTargetsQuery_, GetFlaggedTargetsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFlaggedTargetsQuery_, GetFlaggedTargetsQueryVariables_>(GetFlaggedTargetsDocument_, options);
        }
export function useGetFlaggedTargetsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFlaggedTargetsQuery_, GetFlaggedTargetsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFlaggedTargetsQuery_, GetFlaggedTargetsQueryVariables_>(GetFlaggedTargetsDocument_, options);
        }
export type GetFlaggedTargetsQueryHookResult = ReturnType<typeof useGetFlaggedTargetsQuery>;
export type GetFlaggedTargetsLazyQuery_HookResult = ReturnType<typeof useGetFlaggedTargetsLazyQuery_>;
export type GetFlaggedTargetsSuspenseQuery_HookResult = ReturnType<typeof useGetFlaggedTargetsSuspenseQuery_>;
export type GetFlaggedTargetsQueryResult_ = Apollo.QueryResult<GetFlaggedTargetsQuery_, GetFlaggedTargetsQueryVariables_>;
export function refetchGetFlaggedTargetsQuery_(variables: GetFlaggedTargetsQueryVariables_) {
      return { query: GetFlaggedTargetsDocument_, variables: variables }
    }
export const GetGroupMaterialMetricsDocument_ = gql`
    query getGroupMaterialMetrics($materialStandardId: uuid!) {
  materialMetrics: esrs_MaterialMetric(
    where: {materialStandardId: {_eq: $materialStandardId}, _or: [{isMaterial: {_is_null: true}, _or: [{dataCollection: {_eq: "subsidiaries"}}, {childrenMetrics: {childMetric: {materialMetrics: {materialStandardId: {_eq: $materialStandardId}, dataCollection: {_eq: "subsidiaries"}}}}}, {childrenMetrics: {childMetric: {childrenMetrics: {childMetric: {materialMetrics: {materialStandardId: {_eq: $materialStandardId}, dataCollection: {_eq: "subsidiaries"}}}}}}}, {childrenMetrics: {childMetric: {childrenMetrics: {childMetric: {childrenMetrics: {childMetric: {materialMetrics: {materialStandardId: {_eq: $materialStandardId}, dataCollection: {_eq: "subsidiaries"}}}}}}}}}, {childrenMetrics: {childMetric: {childrenMetrics: {childMetric: {childrenMetrics: {childMetric: {childrenMetrics: {childMetric: {materialMetrics: {materialStandardId: {_eq: $materialStandardId}, dataCollection: {_eq: "subsidiaries"}}}}}}}}}}}, {childrenMetrics: {childMetric: {childrenMetrics: {childMetric: {childrenMetrics: {childMetric: {childrenMetrics: {childMetric: {childrenMetrics: {childMetric: {materialMetrics: {materialStandardId: {_eq: $materialStandardId}, dataCollection: {_eq: "subsidiaries"}}}}}}}}}}}}}]}, {isMaterial: {_eq: true}}]}
  ) {
    id
    metricRef
    metric {
      tags {
        tagType {
          alwaysAll
          tagValues(order_by: [{order: asc}, {value: asc}]) {
            value
            type
          }
        }
        isOptional
        type
      }
    }
  }
}
    `;

/**
 * __useGetGroupMaterialMetricsQuery__
 *
 * To run a query within a React component, call `useGetGroupMaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupMaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupMaterialMetricsQuery({
 *   variables: {
 *      materialStandardId: // value for 'materialStandardId'
 *   },
 * });
 */
export function useGetGroupMaterialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupMaterialMetricsQuery_, GetGroupMaterialMetricsQueryVariables_> & ({ variables: GetGroupMaterialMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupMaterialMetricsQuery_, GetGroupMaterialMetricsQueryVariables_>(GetGroupMaterialMetricsDocument_, options);
      }
export function useGetGroupMaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupMaterialMetricsQuery_, GetGroupMaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupMaterialMetricsQuery_, GetGroupMaterialMetricsQueryVariables_>(GetGroupMaterialMetricsDocument_, options);
        }
export function useGetGroupMaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupMaterialMetricsQuery_, GetGroupMaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupMaterialMetricsQuery_, GetGroupMaterialMetricsQueryVariables_>(GetGroupMaterialMetricsDocument_, options);
        }
export type GetGroupMaterialMetricsQueryHookResult = ReturnType<typeof useGetGroupMaterialMetricsQuery>;
export type GetGroupMaterialMetricsLazyQuery_HookResult = ReturnType<typeof useGetGroupMaterialMetricsLazyQuery_>;
export type GetGroupMaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetGroupMaterialMetricsSuspenseQuery_>;
export type GetGroupMaterialMetricsQueryResult_ = Apollo.QueryResult<GetGroupMaterialMetricsQuery_, GetGroupMaterialMetricsQueryVariables_>;
export function refetchGetGroupMaterialMetricsQuery_(variables: GetGroupMaterialMetricsQueryVariables_) {
      return { query: GetGroupMaterialMetricsDocument_, variables: variables }
    }
export const GetMaterialStandardPolicyRefDocument_ = gql`
    query getMaterialStandardPolicyRef($materialStandardId: uuid!) {
  esrs_MaterialStandard_by_pk(id: $materialStandardId) {
    id
    standard {
      reference
      disclosureRequirementGroups {
        requirements(where: {type: {_eq: "policy"}}) {
          reference
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGetMaterialStandardPolicyRefQuery__
 *
 * To run a query within a React component, call `useGetMaterialStandardPolicyRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialStandardPolicyRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialStandardPolicyRefQuery({
 *   variables: {
 *      materialStandardId: // value for 'materialStandardId'
 *   },
 * });
 */
export function useGetMaterialStandardPolicyRefQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialStandardPolicyRefQuery_, GetMaterialStandardPolicyRefQueryVariables_> & ({ variables: GetMaterialStandardPolicyRefQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialStandardPolicyRefQuery_, GetMaterialStandardPolicyRefQueryVariables_>(GetMaterialStandardPolicyRefDocument_, options);
      }
export function useGetMaterialStandardPolicyRefLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialStandardPolicyRefQuery_, GetMaterialStandardPolicyRefQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialStandardPolicyRefQuery_, GetMaterialStandardPolicyRefQueryVariables_>(GetMaterialStandardPolicyRefDocument_, options);
        }
export function useGetMaterialStandardPolicyRefSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaterialStandardPolicyRefQuery_, GetMaterialStandardPolicyRefQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaterialStandardPolicyRefQuery_, GetMaterialStandardPolicyRefQueryVariables_>(GetMaterialStandardPolicyRefDocument_, options);
        }
export type GetMaterialStandardPolicyRefQueryHookResult = ReturnType<typeof useGetMaterialStandardPolicyRefQuery>;
export type GetMaterialStandardPolicyRefLazyQuery_HookResult = ReturnType<typeof useGetMaterialStandardPolicyRefLazyQuery_>;
export type GetMaterialStandardPolicyRefSuspenseQuery_HookResult = ReturnType<typeof useGetMaterialStandardPolicyRefSuspenseQuery_>;
export type GetMaterialStandardPolicyRefQueryResult_ = Apollo.QueryResult<GetMaterialStandardPolicyRefQuery_, GetMaterialStandardPolicyRefQueryVariables_>;
export function refetchGetMaterialStandardPolicyRefQuery_(variables: GetMaterialStandardPolicyRefQueryVariables_) {
      return { query: GetMaterialStandardPolicyRefDocument_, variables: variables }
    }
export const GetIntegrationApiKeyDocument_ = gql`
    query getIntegrationApiKey($companyId: uuid!, $integrationSystemName: String!) {
  esrs_CompanyIntegration(
    where: {companyId: {_eq: $companyId}, integrationSystemName: {_eq: $integrationSystemName}}
  ) {
    id
    apiKey
    isDisaggregated
  }
}
    `;

/**
 * __useGetIntegrationApiKeyQuery__
 *
 * To run a query within a React component, call `useGetIntegrationApiKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationApiKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationApiKeyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      integrationSystemName: // value for 'integrationSystemName'
 *   },
 * });
 */
export function useGetIntegrationApiKeyQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationApiKeyQuery_, GetIntegrationApiKeyQueryVariables_> & ({ variables: GetIntegrationApiKeyQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationApiKeyQuery_, GetIntegrationApiKeyQueryVariables_>(GetIntegrationApiKeyDocument_, options);
      }
export function useGetIntegrationApiKeyLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationApiKeyQuery_, GetIntegrationApiKeyQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationApiKeyQuery_, GetIntegrationApiKeyQueryVariables_>(GetIntegrationApiKeyDocument_, options);
        }
export function useGetIntegrationApiKeySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationApiKeyQuery_, GetIntegrationApiKeyQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationApiKeyQuery_, GetIntegrationApiKeyQueryVariables_>(GetIntegrationApiKeyDocument_, options);
        }
export type GetIntegrationApiKeyQueryHookResult = ReturnType<typeof useGetIntegrationApiKeyQuery>;
export type GetIntegrationApiKeyLazyQuery_HookResult = ReturnType<typeof useGetIntegrationApiKeyLazyQuery_>;
export type GetIntegrationApiKeySuspenseQuery_HookResult = ReturnType<typeof useGetIntegrationApiKeySuspenseQuery_>;
export type GetIntegrationApiKeyQueryResult_ = Apollo.QueryResult<GetIntegrationApiKeyQuery_, GetIntegrationApiKeyQueryVariables_>;
export function refetchGetIntegrationApiKeyQuery_(variables: GetIntegrationApiKeyQueryVariables_) {
      return { query: GetIntegrationApiKeyDocument_, variables: variables }
    }
export const GetE16MaterialMetricsCountDocument_ = gql`
    query GetE16MaterialMetricsCount($esrsAssessment: uuid!) {
  esrs_MaterialMetric_aggregate(
    where: {materialStandard: {assessmentId: {_eq: $esrsAssessment}, standardRef: {_eq: "ESRS-E1"}}, metric: {disclosureRequirementRef: {_eq: "E1-6"}}}
  ) {
    aggregate {
      count(columns: id)
    }
  }
}
    `;

/**
 * __useGetE16MaterialMetricsCountQuery__
 *
 * To run a query within a React component, call `useGetE16MaterialMetricsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetE16MaterialMetricsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetE16MaterialMetricsCountQuery({
 *   variables: {
 *      esrsAssessment: // value for 'esrsAssessment'
 *   },
 * });
 */
export function useGetE16MaterialMetricsCountQuery(baseOptions: Apollo.QueryHookOptions<GetE16MaterialMetricsCountQuery_, GetE16MaterialMetricsCountQueryVariables_> & ({ variables: GetE16MaterialMetricsCountQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetE16MaterialMetricsCountQuery_, GetE16MaterialMetricsCountQueryVariables_>(GetE16MaterialMetricsCountDocument_, options);
      }
export function useGetE16MaterialMetricsCountLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetE16MaterialMetricsCountQuery_, GetE16MaterialMetricsCountQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetE16MaterialMetricsCountQuery_, GetE16MaterialMetricsCountQueryVariables_>(GetE16MaterialMetricsCountDocument_, options);
        }
export function useGetE16MaterialMetricsCountSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetE16MaterialMetricsCountQuery_, GetE16MaterialMetricsCountQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetE16MaterialMetricsCountQuery_, GetE16MaterialMetricsCountQueryVariables_>(GetE16MaterialMetricsCountDocument_, options);
        }
export type GetE16MaterialMetricsCountQueryHookResult = ReturnType<typeof useGetE16MaterialMetricsCountQuery>;
export type GetE16MaterialMetricsCountLazyQuery_HookResult = ReturnType<typeof useGetE16MaterialMetricsCountLazyQuery_>;
export type GetE16MaterialMetricsCountSuspenseQuery_HookResult = ReturnType<typeof useGetE16MaterialMetricsCountSuspenseQuery_>;
export type GetE16MaterialMetricsCountQueryResult_ = Apollo.QueryResult<GetE16MaterialMetricsCountQuery_, GetE16MaterialMetricsCountQueryVariables_>;
export function refetchGetE16MaterialMetricsCountQuery_(variables: GetE16MaterialMetricsCountQueryVariables_) {
      return { query: GetE16MaterialMetricsCountDocument_, variables: variables }
    }
export const UpsertEsrsAssessmentDocument_ = gql`
    mutation upsertEsrsAssessment($esrsAssessment: EsrsAssessment_insert_input!) {
  insert_EsrsAssessment_one(
    object: $esrsAssessment
    on_conflict: {constraint: EsrsAssessment_pkey, update_columns: [reportingYear, companySize]}
  ) {
    ...EsrsAssessmentFields
  }
}
    ${EsrsAssessmentFieldsFragmentDoc_}`;
export type UpsertEsrsAssessmentMutationFn_ = Apollo.MutationFunction<UpsertEsrsAssessmentMutation_, UpsertEsrsAssessmentMutationVariables_>;

/**
 * __useUpsertEsrsAssessmentMutation__
 *
 * To run a mutation, you first call `useUpsertEsrsAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEsrsAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEsrsAssessmentMutation, { data, loading, error }] = useUpsertEsrsAssessmentMutation({
 *   variables: {
 *      esrsAssessment: // value for 'esrsAssessment'
 *   },
 * });
 */
export function useUpsertEsrsAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEsrsAssessmentMutation_, UpsertEsrsAssessmentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEsrsAssessmentMutation_, UpsertEsrsAssessmentMutationVariables_>(UpsertEsrsAssessmentDocument_, options);
      }
export type UpsertEsrsAssessmentMutationHookResult = ReturnType<typeof useUpsertEsrsAssessmentMutation>;
export type UpsertEsrsAssessmentMutationResult_ = Apollo.MutationResult<UpsertEsrsAssessmentMutation_>;
export type UpsertEsrsAssessmentMutationOptions_ = Apollo.BaseMutationOptions<UpsertEsrsAssessmentMutation_, UpsertEsrsAssessmentMutationVariables_>;
export const UpsertReportingUnitLineageDocument_ = gql`
    mutation upsertReportingUnitLineage($reportingUnitLineage: esrs_ReportingUnitLineage_insert_input!) {
  insert_esrs_ReportingUnitLineage_one(object: $reportingUnitLineage) {
    id
    reportingUnits {
      name
      id
    }
  }
}
    `;
export type UpsertReportingUnitLineageMutationFn_ = Apollo.MutationFunction<UpsertReportingUnitLineageMutation_, UpsertReportingUnitLineageMutationVariables_>;

/**
 * __useUpsertReportingUnitLineageMutation__
 *
 * To run a mutation, you first call `useUpsertReportingUnitLineageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertReportingUnitLineageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertReportingUnitLineageMutation, { data, loading, error }] = useUpsertReportingUnitLineageMutation({
 *   variables: {
 *      reportingUnitLineage: // value for 'reportingUnitLineage'
 *   },
 * });
 */
export function useUpsertReportingUnitLineageMutation(baseOptions?: Apollo.MutationHookOptions<UpsertReportingUnitLineageMutation_, UpsertReportingUnitLineageMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertReportingUnitLineageMutation_, UpsertReportingUnitLineageMutationVariables_>(UpsertReportingUnitLineageDocument_, options);
      }
export type UpsertReportingUnitLineageMutationHookResult = ReturnType<typeof useUpsertReportingUnitLineageMutation>;
export type UpsertReportingUnitLineageMutationResult_ = Apollo.MutationResult<UpsertReportingUnitLineageMutation_>;
export type UpsertReportingUnitLineageMutationOptions_ = Apollo.BaseMutationOptions<UpsertReportingUnitLineageMutation_, UpsertReportingUnitLineageMutationVariables_>;
export const UpsertEsrsReportingUnitDocument_ = gql`
    mutation upsertEsrsReportingUnit($reportingUnit: esrs_ReportingUnit_insert_input!) {
  insert_esrs_ReportingUnit_one(
    object: $reportingUnit
    on_conflict: {constraint: ReportingUnit_pkey, update_columns: [name, projectLeaderId]}
  ) {
    id
    assessmentId
  }
}
    `;
export type UpsertEsrsReportingUnitMutationFn_ = Apollo.MutationFunction<UpsertEsrsReportingUnitMutation_, UpsertEsrsReportingUnitMutationVariables_>;

/**
 * __useUpsertEsrsReportingUnitMutation__
 *
 * To run a mutation, you first call `useUpsertEsrsReportingUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEsrsReportingUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEsrsReportingUnitMutation, { data, loading, error }] = useUpsertEsrsReportingUnitMutation({
 *   variables: {
 *      reportingUnit: // value for 'reportingUnit'
 *   },
 * });
 */
export function useUpsertEsrsReportingUnitMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEsrsReportingUnitMutation_, UpsertEsrsReportingUnitMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEsrsReportingUnitMutation_, UpsertEsrsReportingUnitMutationVariables_>(UpsertEsrsReportingUnitDocument_, options);
      }
export type UpsertEsrsReportingUnitMutationHookResult = ReturnType<typeof useUpsertEsrsReportingUnitMutation>;
export type UpsertEsrsReportingUnitMutationResult_ = Apollo.MutationResult<UpsertEsrsReportingUnitMutation_>;
export type UpsertEsrsReportingUnitMutationOptions_ = Apollo.BaseMutationOptions<UpsertEsrsReportingUnitMutation_, UpsertEsrsReportingUnitMutationVariables_>;
export const UpdateAssessmentOnboardingDocument_ = gql`
    mutation updateAssessmentOnboarding($id: uuid!, $onboardingStep: Int!) {
  update_EsrsAssessment_by_pk(
    pk_columns: {id: $id}
    _set: {onboardingStep: $onboardingStep}
  ) {
    id
    onboardingStep
  }
}
    `;
export type UpdateAssessmentOnboardingMutationFn_ = Apollo.MutationFunction<UpdateAssessmentOnboardingMutation_, UpdateAssessmentOnboardingMutationVariables_>;

/**
 * __useUpdateAssessmentOnboardingMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentOnboardingMutation, { data, loading, error }] = useUpdateAssessmentOnboardingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      onboardingStep: // value for 'onboardingStep'
 *   },
 * });
 */
export function useUpdateAssessmentOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssessmentOnboardingMutation_, UpdateAssessmentOnboardingMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssessmentOnboardingMutation_, UpdateAssessmentOnboardingMutationVariables_>(UpdateAssessmentOnboardingDocument_, options);
      }
export type UpdateAssessmentOnboardingMutationHookResult = ReturnType<typeof useUpdateAssessmentOnboardingMutation>;
export type UpdateAssessmentOnboardingMutationResult_ = Apollo.MutationResult<UpdateAssessmentOnboardingMutation_>;
export type UpdateAssessmentOnboardingMutationOptions_ = Apollo.BaseMutationOptions<UpdateAssessmentOnboardingMutation_, UpdateAssessmentOnboardingMutationVariables_>;
export const UpdateAssessmentCompanySizeDocument_ = gql`
    mutation updateAssessmentCompanySize($id: uuid!, $companySize: String!) {
  update_EsrsAssessment_by_pk(
    pk_columns: {id: $id}
    _set: {companySize: $companySize}
  ) {
    id
    companySize
  }
}
    `;
export type UpdateAssessmentCompanySizeMutationFn_ = Apollo.MutationFunction<UpdateAssessmentCompanySizeMutation_, UpdateAssessmentCompanySizeMutationVariables_>;

/**
 * __useUpdateAssessmentCompanySizeMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentCompanySizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentCompanySizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentCompanySizeMutation, { data, loading, error }] = useUpdateAssessmentCompanySizeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companySize: // value for 'companySize'
 *   },
 * });
 */
export function useUpdateAssessmentCompanySizeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssessmentCompanySizeMutation_, UpdateAssessmentCompanySizeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssessmentCompanySizeMutation_, UpdateAssessmentCompanySizeMutationVariables_>(UpdateAssessmentCompanySizeDocument_, options);
      }
export type UpdateAssessmentCompanySizeMutationHookResult = ReturnType<typeof useUpdateAssessmentCompanySizeMutation>;
export type UpdateAssessmentCompanySizeMutationResult_ = Apollo.MutationResult<UpdateAssessmentCompanySizeMutation_>;
export type UpdateAssessmentCompanySizeMutationOptions_ = Apollo.BaseMutationOptions<UpdateAssessmentCompanySizeMutation_, UpdateAssessmentCompanySizeMutationVariables_>;
export const UpdateAssessmentCompanyProjectLeaderDocument_ = gql`
    mutation updateAssessmentCompanyProjectLeader($id: uuid!, $projectLeaderId: uuid!) {
  update_EsrsAssessment_by_pk(
    pk_columns: {id: $id}
    _set: {projectLeaderId: $projectLeaderId}
  ) {
    id
    projectLeaderId
  }
}
    `;
export type UpdateAssessmentCompanyProjectLeaderMutationFn_ = Apollo.MutationFunction<UpdateAssessmentCompanyProjectLeaderMutation_, UpdateAssessmentCompanyProjectLeaderMutationVariables_>;

/**
 * __useUpdateAssessmentCompanyProjectLeaderMutation__
 *
 * To run a mutation, you first call `useUpdateAssessmentCompanyProjectLeaderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAssessmentCompanyProjectLeaderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAssessmentCompanyProjectLeaderMutation, { data, loading, error }] = useUpdateAssessmentCompanyProjectLeaderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      projectLeaderId: // value for 'projectLeaderId'
 *   },
 * });
 */
export function useUpdateAssessmentCompanyProjectLeaderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAssessmentCompanyProjectLeaderMutation_, UpdateAssessmentCompanyProjectLeaderMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAssessmentCompanyProjectLeaderMutation_, UpdateAssessmentCompanyProjectLeaderMutationVariables_>(UpdateAssessmentCompanyProjectLeaderDocument_, options);
      }
export type UpdateAssessmentCompanyProjectLeaderMutationHookResult = ReturnType<typeof useUpdateAssessmentCompanyProjectLeaderMutation>;
export type UpdateAssessmentCompanyProjectLeaderMutationResult_ = Apollo.MutationResult<UpdateAssessmentCompanyProjectLeaderMutation_>;
export type UpdateAssessmentCompanyProjectLeaderMutationOptions_ = Apollo.BaseMutationOptions<UpdateAssessmentCompanyProjectLeaderMutation_, UpdateAssessmentCompanyProjectLeaderMutationVariables_>;
export const AddEsrsSubsidaryDocument_ = gql`
    mutation addEsrsSubsidary($esrsAssessment: EsrsAssessment_insert_input!) {
  insert_EsrsAssessment_one(
    object: $esrsAssessment
    on_conflict: {constraint: EsrsAssessment_companyId_reportingYear_deletedAt_key, update_columns: [parentAssessmentId]}
  ) {
    id
    parentAssessmentId
  }
}
    `;
export type AddEsrsSubsidaryMutationFn_ = Apollo.MutationFunction<AddEsrsSubsidaryMutation_, AddEsrsSubsidaryMutationVariables_>;

/**
 * __useAddEsrsSubsidaryMutation__
 *
 * To run a mutation, you first call `useAddEsrsSubsidaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEsrsSubsidaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEsrsSubsidaryMutation, { data, loading, error }] = useAddEsrsSubsidaryMutation({
 *   variables: {
 *      esrsAssessment: // value for 'esrsAssessment'
 *   },
 * });
 */
export function useAddEsrsSubsidaryMutation(baseOptions?: Apollo.MutationHookOptions<AddEsrsSubsidaryMutation_, AddEsrsSubsidaryMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEsrsSubsidaryMutation_, AddEsrsSubsidaryMutationVariables_>(AddEsrsSubsidaryDocument_, options);
      }
export type AddEsrsSubsidaryMutationHookResult = ReturnType<typeof useAddEsrsSubsidaryMutation>;
export type AddEsrsSubsidaryMutationResult_ = Apollo.MutationResult<AddEsrsSubsidaryMutation_>;
export type AddEsrsSubsidaryMutationOptions_ = Apollo.BaseMutationOptions<AddEsrsSubsidaryMutation_, AddEsrsSubsidaryMutationVariables_>;
export const UpdateEsrsSubsidaryDocument_ = gql`
    mutation updateEsrsSubsidary($companyId: uuid!, $reportingYear: Int!, $parentAssessmentId: uuid!, $projectLeaderId: uuid!, $frameworkRef: String!) {
  update_EsrsAssessment(
    where: {companyId: {_eq: $companyId}, reportingYear: {_eq: $reportingYear}, frameworkRef: {_eq: $frameworkRef}}
    _set: {parentAssessmentId: $parentAssessmentId, projectLeaderId: $projectLeaderId}
  ) {
    affected_rows
    returning {
      id
      parentAssessmentId
    }
  }
}
    `;
export type UpdateEsrsSubsidaryMutationFn_ = Apollo.MutationFunction<UpdateEsrsSubsidaryMutation_, UpdateEsrsSubsidaryMutationVariables_>;

/**
 * __useUpdateEsrsSubsidaryMutation__
 *
 * To run a mutation, you first call `useUpdateEsrsSubsidaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsrsSubsidaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsrsSubsidaryMutation, { data, loading, error }] = useUpdateEsrsSubsidaryMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      reportingYear: // value for 'reportingYear'
 *      parentAssessmentId: // value for 'parentAssessmentId'
 *      projectLeaderId: // value for 'projectLeaderId'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useUpdateEsrsSubsidaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsrsSubsidaryMutation_, UpdateEsrsSubsidaryMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsrsSubsidaryMutation_, UpdateEsrsSubsidaryMutationVariables_>(UpdateEsrsSubsidaryDocument_, options);
      }
export type UpdateEsrsSubsidaryMutationHookResult = ReturnType<typeof useUpdateEsrsSubsidaryMutation>;
export type UpdateEsrsSubsidaryMutationResult_ = Apollo.MutationResult<UpdateEsrsSubsidaryMutation_>;
export type UpdateEsrsSubsidaryMutationOptions_ = Apollo.BaseMutationOptions<UpdateEsrsSubsidaryMutation_, UpdateEsrsSubsidaryMutationVariables_>;
export const RemoveEsrsSubsidiaryDocument_ = gql`
    mutation removeEsrsSubsidiary($childAssessmentId: uuid!) {
  update_EsrsAssessment_by_pk(
    pk_columns: {id: $childAssessmentId}
    _set: {parentAssessmentId: null}
  ) {
    id
  }
}
    `;
export type RemoveEsrsSubsidiaryMutationFn_ = Apollo.MutationFunction<RemoveEsrsSubsidiaryMutation_, RemoveEsrsSubsidiaryMutationVariables_>;

/**
 * __useRemoveEsrsSubsidiaryMutation__
 *
 * To run a mutation, you first call `useRemoveEsrsSubsidiaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEsrsSubsidiaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEsrsSubsidiaryMutation, { data, loading, error }] = useRemoveEsrsSubsidiaryMutation({
 *   variables: {
 *      childAssessmentId: // value for 'childAssessmentId'
 *   },
 * });
 */
export function useRemoveEsrsSubsidiaryMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEsrsSubsidiaryMutation_, RemoveEsrsSubsidiaryMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEsrsSubsidiaryMutation_, RemoveEsrsSubsidiaryMutationVariables_>(RemoveEsrsSubsidiaryDocument_, options);
      }
export type RemoveEsrsSubsidiaryMutationHookResult = ReturnType<typeof useRemoveEsrsSubsidiaryMutation>;
export type RemoveEsrsSubsidiaryMutationResult_ = Apollo.MutationResult<RemoveEsrsSubsidiaryMutation_>;
export type RemoveEsrsSubsidiaryMutationOptions_ = Apollo.BaseMutationOptions<RemoveEsrsSubsidiaryMutation_, RemoveEsrsSubsidiaryMutationVariables_>;
export const UpdateEsrsAssessmentMetaDataDocument_ = gql`
    mutation updateEsrsAssessmentMetaData($id: uuid!, $metadata: jsonb!) {
  update_EsrsAssessment_by_pk(pk_columns: {id: $id}, _set: {metadata: $metadata}) {
    id
    metadata
  }
}
    `;
export type UpdateEsrsAssessmentMetaDataMutationFn_ = Apollo.MutationFunction<UpdateEsrsAssessmentMetaDataMutation_, UpdateEsrsAssessmentMetaDataMutationVariables_>;

/**
 * __useUpdateEsrsAssessmentMetaDataMutation__
 *
 * To run a mutation, you first call `useUpdateEsrsAssessmentMetaDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsrsAssessmentMetaDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsrsAssessmentMetaDataMutation, { data, loading, error }] = useUpdateEsrsAssessmentMetaDataMutation({
 *   variables: {
 *      id: // value for 'id'
 *      metadata: // value for 'metadata'
 *   },
 * });
 */
export function useUpdateEsrsAssessmentMetaDataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsrsAssessmentMetaDataMutation_, UpdateEsrsAssessmentMetaDataMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsrsAssessmentMetaDataMutation_, UpdateEsrsAssessmentMetaDataMutationVariables_>(UpdateEsrsAssessmentMetaDataDocument_, options);
      }
export type UpdateEsrsAssessmentMetaDataMutationHookResult = ReturnType<typeof useUpdateEsrsAssessmentMetaDataMutation>;
export type UpdateEsrsAssessmentMetaDataMutationResult_ = Apollo.MutationResult<UpdateEsrsAssessmentMetaDataMutation_>;
export type UpdateEsrsAssessmentMetaDataMutationOptions_ = Apollo.BaseMutationOptions<UpdateEsrsAssessmentMetaDataMutation_, UpdateEsrsAssessmentMetaDataMutationVariables_>;
export const DeleteEsrsAssessmentDocument_ = gql`
    mutation deleteEsrsAssessment($assessmentId: uuid!) {
  update_EsrsAssessment(
    where: {id: {_eq: $assessmentId}}
    _set: {deletedAt: "now()"}
  ) {
    returning {
      id
    }
  }
}
    `;
export type DeleteEsrsAssessmentMutationFn_ = Apollo.MutationFunction<DeleteEsrsAssessmentMutation_, DeleteEsrsAssessmentMutationVariables_>;

/**
 * __useDeleteEsrsAssessmentMutation__
 *
 * To run a mutation, you first call `useDeleteEsrsAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEsrsAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEsrsAssessmentMutation, { data, loading, error }] = useDeleteEsrsAssessmentMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useDeleteEsrsAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEsrsAssessmentMutation_, DeleteEsrsAssessmentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEsrsAssessmentMutation_, DeleteEsrsAssessmentMutationVariables_>(DeleteEsrsAssessmentDocument_, options);
      }
export type DeleteEsrsAssessmentMutationHookResult = ReturnType<typeof useDeleteEsrsAssessmentMutation>;
export type DeleteEsrsAssessmentMutationResult_ = Apollo.MutationResult<DeleteEsrsAssessmentMutation_>;
export type DeleteEsrsAssessmentMutationOptions_ = Apollo.BaseMutationOptions<DeleteEsrsAssessmentMutation_, DeleteEsrsAssessmentMutationVariables_>;
export const UpdateSubsidiaryDataCollectionTypeDocument_ = gql`
    mutation updateSubsidiaryDataCollectionType($id: uuid!, $collectOnly: Boolean!) {
  update_EsrsAssessment_by_pk(
    pk_columns: {id: $id}
    _set: {collectOnly: $collectOnly}
  ) {
    id
    collectOnly
  }
}
    `;
export type UpdateSubsidiaryDataCollectionTypeMutationFn_ = Apollo.MutationFunction<UpdateSubsidiaryDataCollectionTypeMutation_, UpdateSubsidiaryDataCollectionTypeMutationVariables_>;

/**
 * __useUpdateSubsidiaryDataCollectionTypeMutation__
 *
 * To run a mutation, you first call `useUpdateSubsidiaryDataCollectionTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubsidiaryDataCollectionTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubsidiaryDataCollectionTypeMutation, { data, loading, error }] = useUpdateSubsidiaryDataCollectionTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      collectOnly: // value for 'collectOnly'
 *   },
 * });
 */
export function useUpdateSubsidiaryDataCollectionTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubsidiaryDataCollectionTypeMutation_, UpdateSubsidiaryDataCollectionTypeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubsidiaryDataCollectionTypeMutation_, UpdateSubsidiaryDataCollectionTypeMutationVariables_>(UpdateSubsidiaryDataCollectionTypeDocument_, options);
      }
export type UpdateSubsidiaryDataCollectionTypeMutationHookResult = ReturnType<typeof useUpdateSubsidiaryDataCollectionTypeMutation>;
export type UpdateSubsidiaryDataCollectionTypeMutationResult_ = Apollo.MutationResult<UpdateSubsidiaryDataCollectionTypeMutation_>;
export type UpdateSubsidiaryDataCollectionTypeMutationOptions_ = Apollo.BaseMutationOptions<UpdateSubsidiaryDataCollectionTypeMutation_, UpdateSubsidiaryDataCollectionTypeMutationVariables_>;
export const DeleteReportingUnitDocument_ = gql`
    mutation deleteReportingUnit($id: uuid!) {
  delete_esrs_ReportingUnit_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteReportingUnitMutationFn_ = Apollo.MutationFunction<DeleteReportingUnitMutation_, DeleteReportingUnitMutationVariables_>;

/**
 * __useDeleteReportingUnitMutation__
 *
 * To run a mutation, you first call `useDeleteReportingUnitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportingUnitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportingUnitMutation, { data, loading, error }] = useDeleteReportingUnitMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReportingUnitMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportingUnitMutation_, DeleteReportingUnitMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportingUnitMutation_, DeleteReportingUnitMutationVariables_>(DeleteReportingUnitDocument_, options);
      }
export type DeleteReportingUnitMutationHookResult = ReturnType<typeof useDeleteReportingUnitMutation>;
export type DeleteReportingUnitMutationResult_ = Apollo.MutationResult<DeleteReportingUnitMutation_>;
export type DeleteReportingUnitMutationOptions_ = Apollo.BaseMutationOptions<DeleteReportingUnitMutation_, DeleteReportingUnitMutationVariables_>;
export const EsrsAssessmentAnswersAggregateDocument_ = gql`
    query esrsAssessmentAnswersAggregate($esrsAssessmentId: uuid!) {
  esrs_Answer_aggregate(where: {assessmentId: {_eq: $esrsAssessmentId}}) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useEsrsAssessmentAnswersAggregateQuery__
 *
 * To run a query within a React component, call `useEsrsAssessmentAnswersAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsrsAssessmentAnswersAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsrsAssessmentAnswersAggregateQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useEsrsAssessmentAnswersAggregateQuery(baseOptions: Apollo.QueryHookOptions<EsrsAssessmentAnswersAggregateQuery_, EsrsAssessmentAnswersAggregateQueryVariables_> & ({ variables: EsrsAssessmentAnswersAggregateQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsrsAssessmentAnswersAggregateQuery_, EsrsAssessmentAnswersAggregateQueryVariables_>(EsrsAssessmentAnswersAggregateDocument_, options);
      }
export function useEsrsAssessmentAnswersAggregateLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<EsrsAssessmentAnswersAggregateQuery_, EsrsAssessmentAnswersAggregateQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsrsAssessmentAnswersAggregateQuery_, EsrsAssessmentAnswersAggregateQueryVariables_>(EsrsAssessmentAnswersAggregateDocument_, options);
        }
export function useEsrsAssessmentAnswersAggregateSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsrsAssessmentAnswersAggregateQuery_, EsrsAssessmentAnswersAggregateQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsrsAssessmentAnswersAggregateQuery_, EsrsAssessmentAnswersAggregateQueryVariables_>(EsrsAssessmentAnswersAggregateDocument_, options);
        }
export type EsrsAssessmentAnswersAggregateQueryHookResult = ReturnType<typeof useEsrsAssessmentAnswersAggregateQuery>;
export type EsrsAssessmentAnswersAggregateLazyQuery_HookResult = ReturnType<typeof useEsrsAssessmentAnswersAggregateLazyQuery_>;
export type EsrsAssessmentAnswersAggregateSuspenseQuery_HookResult = ReturnType<typeof useEsrsAssessmentAnswersAggregateSuspenseQuery_>;
export type EsrsAssessmentAnswersAggregateQueryResult_ = Apollo.QueryResult<EsrsAssessmentAnswersAggregateQuery_, EsrsAssessmentAnswersAggregateQueryVariables_>;
export function refetchEsrsAssessmentAnswersAggregateQuery_(variables: EsrsAssessmentAnswersAggregateQueryVariables_) {
      return { query: EsrsAssessmentAnswersAggregateDocument_, variables: variables }
    }
export const UpsertIntegrationKeyDocument_ = gql`
    mutation upsertIntegrationKey($object: esrs_CompanyIntegration_insert_input!) {
  insert_esrs_CompanyIntegration_one(
    object: $object
    on_conflict: {constraint: CompanyIntegration_pkey, update_columns: [apiKey, isDisaggregated]}
  ) {
    id
  }
}
    `;
export type UpsertIntegrationKeyMutationFn_ = Apollo.MutationFunction<UpsertIntegrationKeyMutation_, UpsertIntegrationKeyMutationVariables_>;

/**
 * __useUpsertIntegrationKeyMutation__
 *
 * To run a mutation, you first call `useUpsertIntegrationKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertIntegrationKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertIntegrationKeyMutation, { data, loading, error }] = useUpsertIntegrationKeyMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpsertIntegrationKeyMutation(baseOptions?: Apollo.MutationHookOptions<UpsertIntegrationKeyMutation_, UpsertIntegrationKeyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertIntegrationKeyMutation_, UpsertIntegrationKeyMutationVariables_>(UpsertIntegrationKeyDocument_, options);
      }
export type UpsertIntegrationKeyMutationHookResult = ReturnType<typeof useUpsertIntegrationKeyMutation>;
export type UpsertIntegrationKeyMutationResult_ = Apollo.MutationResult<UpsertIntegrationKeyMutation_>;
export type UpsertIntegrationKeyMutationOptions_ = Apollo.BaseMutationOptions<UpsertIntegrationKeyMutation_, UpsertIntegrationKeyMutationVariables_>;
export const GetParentEsrsAssessmentIdDocument_ = gql`
    query getParentEsrsAssessmentId($esrsAssessmentId: uuid!) {
  esrsAssessment: EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    parentAssessmentId
  }
}
    `;

/**
 * __useGetParentEsrsAssessmentIdQuery__
 *
 * To run a query within a React component, call `useGetParentEsrsAssessmentIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentEsrsAssessmentIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentEsrsAssessmentIdQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetParentEsrsAssessmentIdQuery(baseOptions: Apollo.QueryHookOptions<GetParentEsrsAssessmentIdQuery_, GetParentEsrsAssessmentIdQueryVariables_> & ({ variables: GetParentEsrsAssessmentIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParentEsrsAssessmentIdQuery_, GetParentEsrsAssessmentIdQueryVariables_>(GetParentEsrsAssessmentIdDocument_, options);
      }
export function useGetParentEsrsAssessmentIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetParentEsrsAssessmentIdQuery_, GetParentEsrsAssessmentIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParentEsrsAssessmentIdQuery_, GetParentEsrsAssessmentIdQueryVariables_>(GetParentEsrsAssessmentIdDocument_, options);
        }
export function useGetParentEsrsAssessmentIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParentEsrsAssessmentIdQuery_, GetParentEsrsAssessmentIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParentEsrsAssessmentIdQuery_, GetParentEsrsAssessmentIdQueryVariables_>(GetParentEsrsAssessmentIdDocument_, options);
        }
export type GetParentEsrsAssessmentIdQueryHookResult = ReturnType<typeof useGetParentEsrsAssessmentIdQuery>;
export type GetParentEsrsAssessmentIdLazyQuery_HookResult = ReturnType<typeof useGetParentEsrsAssessmentIdLazyQuery_>;
export type GetParentEsrsAssessmentIdSuspenseQuery_HookResult = ReturnType<typeof useGetParentEsrsAssessmentIdSuspenseQuery_>;
export type GetParentEsrsAssessmentIdQueryResult_ = Apollo.QueryResult<GetParentEsrsAssessmentIdQuery_, GetParentEsrsAssessmentIdQueryVariables_>;
export function refetchGetParentEsrsAssessmentIdQuery_(variables: GetParentEsrsAssessmentIdQueryVariables_) {
      return { query: GetParentEsrsAssessmentIdDocument_, variables: variables }
    }
export const UpsertAssessmentCompanyIntegrationDocument_ = gql`
    mutation upsertAssessmentCompanyIntegration($object: esrs_EsrsAssessmentCompanyIntegration_insert_input!) {
  insert_esrs_EsrsAssessmentCompanyIntegration_one(
    object: $object
    on_conflict: {constraint: EsrsAssessmentCompanyIntegration_esrsAssessmentId_companyIntegr, update_columns: [syncedAt]}
  ) {
    id
  }
}
    `;
export type UpsertAssessmentCompanyIntegrationMutationFn_ = Apollo.MutationFunction<UpsertAssessmentCompanyIntegrationMutation_, UpsertAssessmentCompanyIntegrationMutationVariables_>;

/**
 * __useUpsertAssessmentCompanyIntegrationMutation__
 *
 * To run a mutation, you first call `useUpsertAssessmentCompanyIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAssessmentCompanyIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAssessmentCompanyIntegrationMutation, { data, loading, error }] = useUpsertAssessmentCompanyIntegrationMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpsertAssessmentCompanyIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAssessmentCompanyIntegrationMutation_, UpsertAssessmentCompanyIntegrationMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAssessmentCompanyIntegrationMutation_, UpsertAssessmentCompanyIntegrationMutationVariables_>(UpsertAssessmentCompanyIntegrationDocument_, options);
      }
export type UpsertAssessmentCompanyIntegrationMutationHookResult = ReturnType<typeof useUpsertAssessmentCompanyIntegrationMutation>;
export type UpsertAssessmentCompanyIntegrationMutationResult_ = Apollo.MutationResult<UpsertAssessmentCompanyIntegrationMutation_>;
export type UpsertAssessmentCompanyIntegrationMutationOptions_ = Apollo.BaseMutationOptions<UpsertAssessmentCompanyIntegrationMutation_, UpsertAssessmentCompanyIntegrationMutationVariables_>;
export const AssessmentCompanyIntegrationRuDocument_ = gql`
    query assessmentCompanyIntegrationRU($companyId: uuid!, $companyIntegrationId: uuid!) {
  esrsAssessments: EsrsAssessment(
    where: {companyId: {_eq: $companyId}, deletedAt: {_is_null: true}}
    order_by: {reportingYear: asc}
  ) {
    id
    reportingYear
    projectLeaderId
    reportingUnits(where: {isCompanyLevel: {_eq: false}}) {
      id
      name
      esrsAssessment {
        esrsAssessmentCompanyIntegrations(
          where: {companyIntegrationId: {_eq: $companyIntegrationId}}
        ) {
          esrsAssessmentCompanyIntegrationRUs {
            esrsReportingUnitId
            syncedAt
            apiKey
            esrsAssessmentCompanyIntegrationId
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAssessmentCompanyIntegrationRuQuery__
 *
 * To run a query within a React component, call `useAssessmentCompanyIntegrationRuQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssessmentCompanyIntegrationRuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssessmentCompanyIntegrationRuQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      companyIntegrationId: // value for 'companyIntegrationId'
 *   },
 * });
 */
export function useAssessmentCompanyIntegrationRuQuery(baseOptions: Apollo.QueryHookOptions<AssessmentCompanyIntegrationRuQuery_, AssessmentCompanyIntegrationRuQueryVariables_> & ({ variables: AssessmentCompanyIntegrationRuQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssessmentCompanyIntegrationRuQuery_, AssessmentCompanyIntegrationRuQueryVariables_>(AssessmentCompanyIntegrationRuDocument_, options);
      }
export function useAssessmentCompanyIntegrationRuLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AssessmentCompanyIntegrationRuQuery_, AssessmentCompanyIntegrationRuQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssessmentCompanyIntegrationRuQuery_, AssessmentCompanyIntegrationRuQueryVariables_>(AssessmentCompanyIntegrationRuDocument_, options);
        }
export function useAssessmentCompanyIntegrationRuSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssessmentCompanyIntegrationRuQuery_, AssessmentCompanyIntegrationRuQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssessmentCompanyIntegrationRuQuery_, AssessmentCompanyIntegrationRuQueryVariables_>(AssessmentCompanyIntegrationRuDocument_, options);
        }
export type AssessmentCompanyIntegrationRuQueryHookResult = ReturnType<typeof useAssessmentCompanyIntegrationRuQuery>;
export type AssessmentCompanyIntegrationRuLazyQuery_HookResult = ReturnType<typeof useAssessmentCompanyIntegrationRuLazyQuery_>;
export type AssessmentCompanyIntegrationRuSuspenseQuery_HookResult = ReturnType<typeof useAssessmentCompanyIntegrationRuSuspenseQuery_>;
export type AssessmentCompanyIntegrationRuQueryResult_ = Apollo.QueryResult<AssessmentCompanyIntegrationRuQuery_, AssessmentCompanyIntegrationRuQueryVariables_>;
export function refetchAssessmentCompanyIntegrationRuQuery_(variables: AssessmentCompanyIntegrationRuQueryVariables_) {
      return { query: AssessmentCompanyIntegrationRuDocument_, variables: variables }
    }
export const UpsertAssessmentCompanyIntegrationRuDocument_ = gql`
    mutation upsertAssessmentCompanyIntegrationRU($object: esrs_EsrsAssessmentCompanyIntegrationRU_insert_input!) {
  insert_esrs_EsrsAssessmentCompanyIntegrationRU_one(
    object: $object
    on_conflict: {constraint: EsrsAssessmentCompanyIntegrationRU_esrsReportingUnitId_esrsAsse, update_columns: [syncedAt]}
  ) {
    id
  }
}
    `;
export type UpsertAssessmentCompanyIntegrationRuMutationFn_ = Apollo.MutationFunction<UpsertAssessmentCompanyIntegrationRuMutation_, UpsertAssessmentCompanyIntegrationRuMutationVariables_>;

/**
 * __useUpsertAssessmentCompanyIntegrationRuMutation__
 *
 * To run a mutation, you first call `useUpsertAssessmentCompanyIntegrationRuMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAssessmentCompanyIntegrationRuMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAssessmentCompanyIntegrationRuMutation, { data, loading, error }] = useUpsertAssessmentCompanyIntegrationRuMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpsertAssessmentCompanyIntegrationRuMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAssessmentCompanyIntegrationRuMutation_, UpsertAssessmentCompanyIntegrationRuMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAssessmentCompanyIntegrationRuMutation_, UpsertAssessmentCompanyIntegrationRuMutationVariables_>(UpsertAssessmentCompanyIntegrationRuDocument_, options);
      }
export type UpsertAssessmentCompanyIntegrationRuMutationHookResult = ReturnType<typeof useUpsertAssessmentCompanyIntegrationRuMutation>;
export type UpsertAssessmentCompanyIntegrationRuMutationResult_ = Apollo.MutationResult<UpsertAssessmentCompanyIntegrationRuMutation_>;
export type UpsertAssessmentCompanyIntegrationRuMutationOptions_ = Apollo.BaseMutationOptions<UpsertAssessmentCompanyIntegrationRuMutation_, UpsertAssessmentCompanyIntegrationRuMutationVariables_>;
export const SingleAssessmentCompanyIntegrationRuDocument_ = gql`
    query singleAssessmentCompanyIntegrationRU($reportingUnitId: uuid!, $assessmentCompanyIntegrationId: uuid!) {
  esrs_EsrsAssessmentCompanyIntegrationRU(
    where: {esrsReportingUnitId: {_eq: $reportingUnitId}, esrsAssessmentCompanyIntegrationId: {_eq: $assessmentCompanyIntegrationId}}
  ) {
    syncedAt
    apiKey
  }
}
    `;

/**
 * __useSingleAssessmentCompanyIntegrationRuQuery__
 *
 * To run a query within a React component, call `useSingleAssessmentCompanyIntegrationRuQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleAssessmentCompanyIntegrationRuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleAssessmentCompanyIntegrationRuQuery({
 *   variables: {
 *      reportingUnitId: // value for 'reportingUnitId'
 *      assessmentCompanyIntegrationId: // value for 'assessmentCompanyIntegrationId'
 *   },
 * });
 */
export function useSingleAssessmentCompanyIntegrationRuQuery(baseOptions: Apollo.QueryHookOptions<SingleAssessmentCompanyIntegrationRuQuery_, SingleAssessmentCompanyIntegrationRuQueryVariables_> & ({ variables: SingleAssessmentCompanyIntegrationRuQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleAssessmentCompanyIntegrationRuQuery_, SingleAssessmentCompanyIntegrationRuQueryVariables_>(SingleAssessmentCompanyIntegrationRuDocument_, options);
      }
export function useSingleAssessmentCompanyIntegrationRuLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<SingleAssessmentCompanyIntegrationRuQuery_, SingleAssessmentCompanyIntegrationRuQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleAssessmentCompanyIntegrationRuQuery_, SingleAssessmentCompanyIntegrationRuQueryVariables_>(SingleAssessmentCompanyIntegrationRuDocument_, options);
        }
export function useSingleAssessmentCompanyIntegrationRuSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleAssessmentCompanyIntegrationRuQuery_, SingleAssessmentCompanyIntegrationRuQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleAssessmentCompanyIntegrationRuQuery_, SingleAssessmentCompanyIntegrationRuQueryVariables_>(SingleAssessmentCompanyIntegrationRuDocument_, options);
        }
export type SingleAssessmentCompanyIntegrationRuQueryHookResult = ReturnType<typeof useSingleAssessmentCompanyIntegrationRuQuery>;
export type SingleAssessmentCompanyIntegrationRuLazyQuery_HookResult = ReturnType<typeof useSingleAssessmentCompanyIntegrationRuLazyQuery_>;
export type SingleAssessmentCompanyIntegrationRuSuspenseQuery_HookResult = ReturnType<typeof useSingleAssessmentCompanyIntegrationRuSuspenseQuery_>;
export type SingleAssessmentCompanyIntegrationRuQueryResult_ = Apollo.QueryResult<SingleAssessmentCompanyIntegrationRuQuery_, SingleAssessmentCompanyIntegrationRuQueryVariables_>;
export function refetchSingleAssessmentCompanyIntegrationRuQuery_(variables: SingleAssessmentCompanyIntegrationRuQueryVariables_) {
      return { query: SingleAssessmentCompanyIntegrationRuDocument_, variables: variables }
    }
export const GetMaterialStandardsIdsDocument_ = gql`
    query GetMaterialStandardsIds($esrsAssessmentId: uuid!) {
  esrs_MaterialStandard(where: {assessmentId: {_eq: $esrsAssessmentId}}) {
    id
    standardRef
  }
}
    `;

/**
 * __useGetMaterialStandardsIdsQuery__
 *
 * To run a query within a React component, call `useGetMaterialStandardsIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialStandardsIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialStandardsIdsQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetMaterialStandardsIdsQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialStandardsIdsQuery_, GetMaterialStandardsIdsQueryVariables_> & ({ variables: GetMaterialStandardsIdsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialStandardsIdsQuery_, GetMaterialStandardsIdsQueryVariables_>(GetMaterialStandardsIdsDocument_, options);
      }
export function useGetMaterialStandardsIdsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialStandardsIdsQuery_, GetMaterialStandardsIdsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialStandardsIdsQuery_, GetMaterialStandardsIdsQueryVariables_>(GetMaterialStandardsIdsDocument_, options);
        }
export function useGetMaterialStandardsIdsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaterialStandardsIdsQuery_, GetMaterialStandardsIdsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaterialStandardsIdsQuery_, GetMaterialStandardsIdsQueryVariables_>(GetMaterialStandardsIdsDocument_, options);
        }
export type GetMaterialStandardsIdsQueryHookResult = ReturnType<typeof useGetMaterialStandardsIdsQuery>;
export type GetMaterialStandardsIdsLazyQuery_HookResult = ReturnType<typeof useGetMaterialStandardsIdsLazyQuery_>;
export type GetMaterialStandardsIdsSuspenseQuery_HookResult = ReturnType<typeof useGetMaterialStandardsIdsSuspenseQuery_>;
export type GetMaterialStandardsIdsQueryResult_ = Apollo.QueryResult<GetMaterialStandardsIdsQuery_, GetMaterialStandardsIdsQueryVariables_>;
export function refetchGetMaterialStandardsIdsQuery_(variables: GetMaterialStandardsIdsQueryVariables_) {
      return { query: GetMaterialStandardsIdsDocument_, variables: variables }
    }
export const GetEsrsCategoriesDocument_ = gql`
    query getEsrsCategories($frameworkRef: String!) {
  EsrsCategory {
    title
    reference
    standards(
      where: {frameworkRef: {_in: [$frameworkRef, "multi-framework"]}}
      order_by: {order: asc}
    ) {
      title
      reference
      description
      isTopical
      disclosureRequirementGroups {
        reference
        requirements {
          reference
          isMandatory
        }
      }
      specificMFStandard {
        title
        reference
        description
        disclosureRequirementGroups: mfDisclosureRequirementGroups {
          reference
          requirements: mfDisclosureRequirements {
            reference
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEsrsCategoriesQuery__
 *
 * To run a query within a React component, call `useGetEsrsCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsrsCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsrsCategoriesQuery({
 *   variables: {
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetEsrsCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetEsrsCategoriesQuery_, GetEsrsCategoriesQueryVariables_> & ({ variables: GetEsrsCategoriesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsrsCategoriesQuery_, GetEsrsCategoriesQueryVariables_>(GetEsrsCategoriesDocument_, options);
      }
export function useGetEsrsCategoriesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetEsrsCategoriesQuery_, GetEsrsCategoriesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsrsCategoriesQuery_, GetEsrsCategoriesQueryVariables_>(GetEsrsCategoriesDocument_, options);
        }
export function useGetEsrsCategoriesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEsrsCategoriesQuery_, GetEsrsCategoriesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEsrsCategoriesQuery_, GetEsrsCategoriesQueryVariables_>(GetEsrsCategoriesDocument_, options);
        }
export type GetEsrsCategoriesQueryHookResult = ReturnType<typeof useGetEsrsCategoriesQuery>;
export type GetEsrsCategoriesLazyQuery_HookResult = ReturnType<typeof useGetEsrsCategoriesLazyQuery_>;
export type GetEsrsCategoriesSuspenseQuery_HookResult = ReturnType<typeof useGetEsrsCategoriesSuspenseQuery_>;
export type GetEsrsCategoriesQueryResult_ = Apollo.QueryResult<GetEsrsCategoriesQuery_, GetEsrsCategoriesQueryVariables_>;
export function refetchGetEsrsCategoriesQuery_(variables: GetEsrsCategoriesQueryVariables_) {
      return { query: GetEsrsCategoriesDocument_, variables: variables }
    }
export const GetFullEsrsCategoriesDocument_ = gql`
    query getFullEsrsCategories($frameworkRef: String!) {
  EsrsCategory {
    title
    reference
    standards(
      where: {frameworkRef: {_in: [$frameworkRef, "multi-framework"]}}
      order_by: {order: asc}
    ) {
      title
      reference
      description
      isTopical
      disclosureRequirementGroups {
        reference
        requirements {
          reference
          isMandatory
          metrics {
            reference
            tags {
              type
              isOptional
              tagType {
                alwaysAll
                tagValues(order_by: [{order: asc}, {value: asc}]) {
                  value
                }
              }
            }
          }
        }
      }
      specificMFStandard {
        title
        reference
        description
        disclosureRequirementGroups: mfDisclosureRequirementGroups {
          reference
          requirements: mfDisclosureRequirements {
            reference
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetFullEsrsCategoriesQuery__
 *
 * To run a query within a React component, call `useGetFullEsrsCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFullEsrsCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFullEsrsCategoriesQuery({
 *   variables: {
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetFullEsrsCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetFullEsrsCategoriesQuery_, GetFullEsrsCategoriesQueryVariables_> & ({ variables: GetFullEsrsCategoriesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFullEsrsCategoriesQuery_, GetFullEsrsCategoriesQueryVariables_>(GetFullEsrsCategoriesDocument_, options);
      }
export function useGetFullEsrsCategoriesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetFullEsrsCategoriesQuery_, GetFullEsrsCategoriesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFullEsrsCategoriesQuery_, GetFullEsrsCategoriesQueryVariables_>(GetFullEsrsCategoriesDocument_, options);
        }
export function useGetFullEsrsCategoriesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFullEsrsCategoriesQuery_, GetFullEsrsCategoriesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFullEsrsCategoriesQuery_, GetFullEsrsCategoriesQueryVariables_>(GetFullEsrsCategoriesDocument_, options);
        }
export type GetFullEsrsCategoriesQueryHookResult = ReturnType<typeof useGetFullEsrsCategoriesQuery>;
export type GetFullEsrsCategoriesLazyQuery_HookResult = ReturnType<typeof useGetFullEsrsCategoriesLazyQuery_>;
export type GetFullEsrsCategoriesSuspenseQuery_HookResult = ReturnType<typeof useGetFullEsrsCategoriesSuspenseQuery_>;
export type GetFullEsrsCategoriesQueryResult_ = Apollo.QueryResult<GetFullEsrsCategoriesQuery_, GetFullEsrsCategoriesQueryVariables_>;
export function refetchGetFullEsrsCategoriesQuery_(variables: GetFullEsrsCategoriesQueryVariables_) {
      return { query: GetFullEsrsCategoriesDocument_, variables: variables }
    }
export const GetMfStandardsDocument_ = gql`
    query getMFStandards($mfStandardRefs: [String!]!) {
  MFStandard(where: {reference: {_in: $mfStandardRefs}}) {
    title
    reference
    description
    mfDisclosureRequirementGroups {
      reference
      mfDisclosureRequirements {
        reference
        mfDisclosureRequirementItems {
          metric {
            reference
            tags {
              type
              isOptional
              tagType {
                alwaysAll
                tagValues(order_by: [{order: asc}, {value: asc}]) {
                  value
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMfStandardsQuery__
 *
 * To run a query within a React component, call `useGetMfStandardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMfStandardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMfStandardsQuery({
 *   variables: {
 *      mfStandardRefs: // value for 'mfStandardRefs'
 *   },
 * });
 */
export function useGetMfStandardsQuery(baseOptions: Apollo.QueryHookOptions<GetMfStandardsQuery_, GetMfStandardsQueryVariables_> & ({ variables: GetMfStandardsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMfStandardsQuery_, GetMfStandardsQueryVariables_>(GetMfStandardsDocument_, options);
      }
export function useGetMfStandardsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMfStandardsQuery_, GetMfStandardsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMfStandardsQuery_, GetMfStandardsQueryVariables_>(GetMfStandardsDocument_, options);
        }
export function useGetMfStandardsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMfStandardsQuery_, GetMfStandardsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMfStandardsQuery_, GetMfStandardsQueryVariables_>(GetMfStandardsDocument_, options);
        }
export type GetMfStandardsQueryHookResult = ReturnType<typeof useGetMfStandardsQuery>;
export type GetMfStandardsLazyQuery_HookResult = ReturnType<typeof useGetMfStandardsLazyQuery_>;
export type GetMfStandardsSuspenseQuery_HookResult = ReturnType<typeof useGetMfStandardsSuspenseQuery_>;
export type GetMfStandardsQueryResult_ = Apollo.QueryResult<GetMfStandardsQuery_, GetMfStandardsQueryVariables_>;
export function refetchGetMfStandardsQuery_(variables: GetMfStandardsQueryVariables_) {
      return { query: GetMfStandardsDocument_, variables: variables }
    }
export const GetEsrsStandardDocument_ = gql`
    query getEsrsStandard($reference: String!) {
  esrsStandard: EsrsStandard_by_pk(reference: $reference) {
    reference
    title
    description
    aiPolicyChecklist
    formattedPolicyChecklist
    isTopical
    additionalTypes {
      additionalType {
        reference
        title
        description
        learnMore
      }
    }
    disclosureRequirementGroups {
      title
      reference
      requirements(order_by: [{order: asc}, {reference: asc}]) {
        title
        reference
        isMandatory
        description
        order
        frameworkRef
        mfDisclosureRequirements {
          mfDisclosureRequirementRef
        }
        additionalTypes {
          additionalType {
            reference
            title
            description
            learnMore
          }
        }
        metrics(
          order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
        ) {
          reference
          title
          shortTitle
          metricType
          description
          order
          firstLevel
          secondLevel
          disclosureRequirementRef
          parentMetrics {
            parentMetric {
              reference
              tags {
                type
                isOptional
                tagType {
                  type
                  alwaysAll
                  tagValues(order_by: [{order: asc}, {value: asc}]) {
                    value
                  }
                }
              }
            }
          }
          description
          tags {
            type
            isOptional
            tagType {
              type
              alwaysAll
              tagValues(order_by: [{order: asc}, {value: asc}]) {
                value
              }
            }
          }
          isAR
          isAssessable
          additionalTypes {
            additionalType {
              reference
              title
              description
              learnMore
            }
          }
          abbreviation
          childrenMetrics {
            childMetricRef
            order
            parentMetricRef
            childMetric {
              reference
              isAssessable
              parentMetrics {
                parentMetric {
                  reference
                }
              }
              childrenMetrics {
                childMetricRef
                order
                parentMetricRef
                childMetric {
                  reference
                  isAssessable
                  parentMetrics {
                    parentMetric {
                      reference
                    }
                  }
                  childrenMetrics {
                    childMetricRef
                    order
                    parentMetricRef
                    childMetric {
                      reference
                      isAssessable
                      parentMetrics {
                        parentMetric {
                          reference
                        }
                      }
                      childrenMetrics {
                        childMetricRef
                        order
                        parentMetricRef
                        childMetric {
                          reference
                          isAssessable
                          parentMetrics {
                            parentMetric {
                              reference
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        metrics_aggregate {
          aggregate {
            count
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEsrsStandardQuery__
 *
 * To run a query within a React component, call `useGetEsrsStandardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsrsStandardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsrsStandardQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useGetEsrsStandardQuery(baseOptions: Apollo.QueryHookOptions<GetEsrsStandardQuery_, GetEsrsStandardQueryVariables_> & ({ variables: GetEsrsStandardQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsrsStandardQuery_, GetEsrsStandardQueryVariables_>(GetEsrsStandardDocument_, options);
      }
export function useGetEsrsStandardLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetEsrsStandardQuery_, GetEsrsStandardQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsrsStandardQuery_, GetEsrsStandardQueryVariables_>(GetEsrsStandardDocument_, options);
        }
export function useGetEsrsStandardSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEsrsStandardQuery_, GetEsrsStandardQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEsrsStandardQuery_, GetEsrsStandardQueryVariables_>(GetEsrsStandardDocument_, options);
        }
export type GetEsrsStandardQueryHookResult = ReturnType<typeof useGetEsrsStandardQuery>;
export type GetEsrsStandardLazyQuery_HookResult = ReturnType<typeof useGetEsrsStandardLazyQuery_>;
export type GetEsrsStandardSuspenseQuery_HookResult = ReturnType<typeof useGetEsrsStandardSuspenseQuery_>;
export type GetEsrsStandardQueryResult_ = Apollo.QueryResult<GetEsrsStandardQuery_, GetEsrsStandardQueryVariables_>;
export function refetchGetEsrsStandardQuery_(variables: GetEsrsStandardQueryVariables_) {
      return { query: GetEsrsStandardDocument_, variables: variables }
    }
export const GetEsrsStandardHeaderDocument_ = gql`
    query getEsrsStandardHeader($reference: String!) {
  esrsStandard: EsrsStandard_by_pk(reference: $reference) {
    title
    reference
    isTopical
  }
}
    `;

/**
 * __useGetEsrsStandardHeaderQuery__
 *
 * To run a query within a React component, call `useGetEsrsStandardHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsrsStandardHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsrsStandardHeaderQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useGetEsrsStandardHeaderQuery(baseOptions: Apollo.QueryHookOptions<GetEsrsStandardHeaderQuery_, GetEsrsStandardHeaderQueryVariables_> & ({ variables: GetEsrsStandardHeaderQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsrsStandardHeaderQuery_, GetEsrsStandardHeaderQueryVariables_>(GetEsrsStandardHeaderDocument_, options);
      }
export function useGetEsrsStandardHeaderLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetEsrsStandardHeaderQuery_, GetEsrsStandardHeaderQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsrsStandardHeaderQuery_, GetEsrsStandardHeaderQueryVariables_>(GetEsrsStandardHeaderDocument_, options);
        }
export function useGetEsrsStandardHeaderSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEsrsStandardHeaderQuery_, GetEsrsStandardHeaderQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEsrsStandardHeaderQuery_, GetEsrsStandardHeaderQueryVariables_>(GetEsrsStandardHeaderDocument_, options);
        }
export type GetEsrsStandardHeaderQueryHookResult = ReturnType<typeof useGetEsrsStandardHeaderQuery>;
export type GetEsrsStandardHeaderLazyQuery_HookResult = ReturnType<typeof useGetEsrsStandardHeaderLazyQuery_>;
export type GetEsrsStandardHeaderSuspenseQuery_HookResult = ReturnType<typeof useGetEsrsStandardHeaderSuspenseQuery_>;
export type GetEsrsStandardHeaderQueryResult_ = Apollo.QueryResult<GetEsrsStandardHeaderQuery_, GetEsrsStandardHeaderQueryVariables_>;
export function refetchGetEsrsStandardHeaderQuery_(variables: GetEsrsStandardHeaderQueryVariables_) {
      return { query: GetEsrsStandardHeaderDocument_, variables: variables }
    }
export const GetShortEsrsStandardDocument_ = gql`
    query getShortEsrsStandard($reference: String!) {
  esrsStandard: EsrsStandard_by_pk(reference: $reference) {
    title
    description
    reference
  }
}
    `;

/**
 * __useGetShortEsrsStandardQuery__
 *
 * To run a query within a React component, call `useGetShortEsrsStandardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShortEsrsStandardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShortEsrsStandardQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useGetShortEsrsStandardQuery(baseOptions: Apollo.QueryHookOptions<GetShortEsrsStandardQuery_, GetShortEsrsStandardQueryVariables_> & ({ variables: GetShortEsrsStandardQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShortEsrsStandardQuery_, GetShortEsrsStandardQueryVariables_>(GetShortEsrsStandardDocument_, options);
      }
export function useGetShortEsrsStandardLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetShortEsrsStandardQuery_, GetShortEsrsStandardQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShortEsrsStandardQuery_, GetShortEsrsStandardQueryVariables_>(GetShortEsrsStandardDocument_, options);
        }
export function useGetShortEsrsStandardSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetShortEsrsStandardQuery_, GetShortEsrsStandardQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetShortEsrsStandardQuery_, GetShortEsrsStandardQueryVariables_>(GetShortEsrsStandardDocument_, options);
        }
export type GetShortEsrsStandardQueryHookResult = ReturnType<typeof useGetShortEsrsStandardQuery>;
export type GetShortEsrsStandardLazyQuery_HookResult = ReturnType<typeof useGetShortEsrsStandardLazyQuery_>;
export type GetShortEsrsStandardSuspenseQuery_HookResult = ReturnType<typeof useGetShortEsrsStandardSuspenseQuery_>;
export type GetShortEsrsStandardQueryResult_ = Apollo.QueryResult<GetShortEsrsStandardQuery_, GetShortEsrsStandardQueryVariables_>;
export function refetchGetShortEsrsStandardQuery_(variables: GetShortEsrsStandardQueryVariables_) {
      return { query: GetShortEsrsStandardDocument_, variables: variables }
    }
export const GetDisclosureRequirementGroupsDocument_ = gql`
    query getDisclosureRequirementGroups($standardRef: String!, $materialStandardId: uuid!, $parentStandardId: uuid!) {
  requirementGroup: DisclosureRequirementGroup(
    where: {standardRef: {_eq: $standardRef}}
    order_by: {order: asc}
  ) {
    reference
    title
    standardRef
    requirements(order_by: [{order: asc}, {reference: asc}]) {
      reference
      title
      description
      type
      policies(where: {assessmentId: {_eq: $materialStandardId}}) {
        attachmentBox {
          attachments(
            where: {deletedAt: {_is_null: true}, file: {deletedAt: {_is_null: true}}}
          ) {
            id
          }
        }
      }
      actions_aggregate(
        where: {_or: [{assessmentId: {_eq: $materialStandardId}}, {assessmentId: {_eq: $parentStandardId}}]}
      ) {
        aggregate {
          count
        }
      }
      targets_aggregate(where: {assessmentId: {_eq: $materialStandardId}}) {
        aggregate {
          count
        }
      }
      metrics(
        order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
        where: {_or: [{materialMetrics: {isMaterial: {_eq: true}, materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}}}, {materialMetrics: {isMaterial: {_eq: true}, materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}}, childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}, _and: {materialMetrics: {materialStandardId: {_eq: $materialStandardId}}}}]}
      ) {
        reference
        childrenMetricsCount
      }
      mfDisclosureRequirements {
        mfDisclosureRequirement {
          mfDisclosureRequirementItems(
            where: {metric: {_or: [{materialMetrics: {isMaterial: {_eq: true}, materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}}}, {materialMetrics: {isMaterial: {_eq: true}, materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}}, childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}, _and: {materialMetrics: {materialStandardId: {_eq: $materialStandardId}}}}]}}
          ) {
            metric {
              reference
              childrenMetricsCount
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDisclosureRequirementGroupsQuery__
 *
 * To run a query within a React component, call `useGetDisclosureRequirementGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisclosureRequirementGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisclosureRequirementGroupsQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *      materialStandardId: // value for 'materialStandardId'
 *      parentStandardId: // value for 'parentStandardId'
 *   },
 * });
 */
export function useGetDisclosureRequirementGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetDisclosureRequirementGroupsQuery_, GetDisclosureRequirementGroupsQueryVariables_> & ({ variables: GetDisclosureRequirementGroupsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisclosureRequirementGroupsQuery_, GetDisclosureRequirementGroupsQueryVariables_>(GetDisclosureRequirementGroupsDocument_, options);
      }
export function useGetDisclosureRequirementGroupsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDisclosureRequirementGroupsQuery_, GetDisclosureRequirementGroupsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisclosureRequirementGroupsQuery_, GetDisclosureRequirementGroupsQueryVariables_>(GetDisclosureRequirementGroupsDocument_, options);
        }
export function useGetDisclosureRequirementGroupsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDisclosureRequirementGroupsQuery_, GetDisclosureRequirementGroupsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDisclosureRequirementGroupsQuery_, GetDisclosureRequirementGroupsQueryVariables_>(GetDisclosureRequirementGroupsDocument_, options);
        }
export type GetDisclosureRequirementGroupsQueryHookResult = ReturnType<typeof useGetDisclosureRequirementGroupsQuery>;
export type GetDisclosureRequirementGroupsLazyQuery_HookResult = ReturnType<typeof useGetDisclosureRequirementGroupsLazyQuery_>;
export type GetDisclosureRequirementGroupsSuspenseQuery_HookResult = ReturnType<typeof useGetDisclosureRequirementGroupsSuspenseQuery_>;
export type GetDisclosureRequirementGroupsQueryResult_ = Apollo.QueryResult<GetDisclosureRequirementGroupsQuery_, GetDisclosureRequirementGroupsQueryVariables_>;
export function refetchGetDisclosureRequirementGroupsQuery_(variables: GetDisclosureRequirementGroupsQueryVariables_) {
      return { query: GetDisclosureRequirementGroupsDocument_, variables: variables }
    }
export const GetMfDisclosureRequirementGroupsDocument_ = gql`
    query getMFDisclosureRequirementGroups($mfStandardRef: String!, $materialStandardId: uuid!, $parentStandardId: uuid!) {
  requirementGroup: MFDisclosureRequirementGroup(
    where: {mfStandardRef: {_eq: $mfStandardRef}}
  ) {
    reference
    title
    standardRef: mfStandardRef
    requirements: mfDisclosureRequirements(
      order_by: [{order: asc}, {reference: asc}]
    ) {
      reference
      title
      description
      type
      policies(where: {assessmentId: {_eq: $materialStandardId}}) {
        attachmentBox {
          attachments(
            where: {deletedAt: {_is_null: true}, file: {deletedAt: {_is_null: true}}}
          ) {
            id
          }
        }
      }
      actions_aggregate(
        where: {_or: [{assessmentId: {_eq: $materialStandardId}}, {assessmentId: {_eq: $parentStandardId}}]}
      ) {
        aggregate {
          count
        }
      }
      targets_aggregate(where: {assessmentId: {_eq: $materialStandardId}}) {
        aggregate {
          count
        }
      }
      metrics: mfDisclosureRequirementItems(
        order_by: {order: asc}
        where: {metric: {_or: [{materialMetrics: {isMaterial: {_eq: true}, materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}}}, {materialMetrics: {_or: [{isMaterial: {_is_null: true}}, {isMaterial: {_eq: true}}], materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}}, childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}, _and: {materialMetrics: {materialStandardId: {_eq: $materialStandardId}}}}]}}
      ) {
        metric {
          reference
          childrenMetricsCount
        }
      }
    }
  }
}
    `;

/**
 * __useGetMfDisclosureRequirementGroupsQuery__
 *
 * To run a query within a React component, call `useGetMfDisclosureRequirementGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMfDisclosureRequirementGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMfDisclosureRequirementGroupsQuery({
 *   variables: {
 *      mfStandardRef: // value for 'mfStandardRef'
 *      materialStandardId: // value for 'materialStandardId'
 *      parentStandardId: // value for 'parentStandardId'
 *   },
 * });
 */
export function useGetMfDisclosureRequirementGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetMfDisclosureRequirementGroupsQuery_, GetMfDisclosureRequirementGroupsQueryVariables_> & ({ variables: GetMfDisclosureRequirementGroupsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMfDisclosureRequirementGroupsQuery_, GetMfDisclosureRequirementGroupsQueryVariables_>(GetMfDisclosureRequirementGroupsDocument_, options);
      }
export function useGetMfDisclosureRequirementGroupsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMfDisclosureRequirementGroupsQuery_, GetMfDisclosureRequirementGroupsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMfDisclosureRequirementGroupsQuery_, GetMfDisclosureRequirementGroupsQueryVariables_>(GetMfDisclosureRequirementGroupsDocument_, options);
        }
export function useGetMfDisclosureRequirementGroupsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMfDisclosureRequirementGroupsQuery_, GetMfDisclosureRequirementGroupsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMfDisclosureRequirementGroupsQuery_, GetMfDisclosureRequirementGroupsQueryVariables_>(GetMfDisclosureRequirementGroupsDocument_, options);
        }
export type GetMfDisclosureRequirementGroupsQueryHookResult = ReturnType<typeof useGetMfDisclosureRequirementGroupsQuery>;
export type GetMfDisclosureRequirementGroupsLazyQuery_HookResult = ReturnType<typeof useGetMfDisclosureRequirementGroupsLazyQuery_>;
export type GetMfDisclosureRequirementGroupsSuspenseQuery_HookResult = ReturnType<typeof useGetMfDisclosureRequirementGroupsSuspenseQuery_>;
export type GetMfDisclosureRequirementGroupsQueryResult_ = Apollo.QueryResult<GetMfDisclosureRequirementGroupsQuery_, GetMfDisclosureRequirementGroupsQueryVariables_>;
export function refetchGetMfDisclosureRequirementGroupsQuery_(variables: GetMfDisclosureRequirementGroupsQueryVariables_) {
      return { query: GetMfDisclosureRequirementGroupsDocument_, variables: variables }
    }
export const GetSubsidiariesDRsCountDocument_ = gql`
    query getSubsidiariesDRsCount($standardRef: String!, $esrsAssessmentId: uuid!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    subsidiaries: subsidiaryAssessments(where: {deletedAt: {_is_null: true}}) {
      id
      materialStandards(where: {standardRef: {_eq: $standardRef}}) {
        policies {
          attachmentBox {
            attachments {
              id
            }
          }
        }
        targets_aggregate {
          aggregate {
            count
          }
        }
        actions_aggregate {
          aggregate {
            count
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSubsidiariesDRsCountQuery__
 *
 * To run a query within a React component, call `useGetSubsidiariesDRsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsidiariesDRsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsidiariesDRsCountQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetSubsidiariesDRsCountQuery(baseOptions: Apollo.QueryHookOptions<GetSubsidiariesDRsCountQuery_, GetSubsidiariesDRsCountQueryVariables_> & ({ variables: GetSubsidiariesDRsCountQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsidiariesDRsCountQuery_, GetSubsidiariesDRsCountQueryVariables_>(GetSubsidiariesDRsCountDocument_, options);
      }
export function useGetSubsidiariesDRsCountLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsidiariesDRsCountQuery_, GetSubsidiariesDRsCountQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsidiariesDRsCountQuery_, GetSubsidiariesDRsCountQueryVariables_>(GetSubsidiariesDRsCountDocument_, options);
        }
export function useGetSubsidiariesDRsCountSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubsidiariesDRsCountQuery_, GetSubsidiariesDRsCountQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubsidiariesDRsCountQuery_, GetSubsidiariesDRsCountQueryVariables_>(GetSubsidiariesDRsCountDocument_, options);
        }
export type GetSubsidiariesDRsCountQueryHookResult = ReturnType<typeof useGetSubsidiariesDRsCountQuery>;
export type GetSubsidiariesDRsCountLazyQuery_HookResult = ReturnType<typeof useGetSubsidiariesDRsCountLazyQuery_>;
export type GetSubsidiariesDRsCountSuspenseQuery_HookResult = ReturnType<typeof useGetSubsidiariesDRsCountSuspenseQuery_>;
export type GetSubsidiariesDRsCountQueryResult_ = Apollo.QueryResult<GetSubsidiariesDRsCountQuery_, GetSubsidiariesDRsCountQueryVariables_>;
export function refetchGetSubsidiariesDRsCountQuery_(variables: GetSubsidiariesDRsCountQueryVariables_) {
      return { query: GetSubsidiariesDRsCountDocument_, variables: variables }
    }
export const GetDisclosureRequirementDocument_ = gql`
    query getDisclosureRequirement($reference: String!) {
  DisclosureRequirement: DisclosureRequirement_by_pk(reference: $reference) {
    title
    reference
    isMandatory
    description
    order
    metrics(
      order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
    ) {
      reference
      description
      title
      metricType
      calculation
      isAssessable
    }
  }
}
    `;

/**
 * __useGetDisclosureRequirementQuery__
 *
 * To run a query within a React component, call `useGetDisclosureRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisclosureRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisclosureRequirementQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useGetDisclosureRequirementQuery(baseOptions: Apollo.QueryHookOptions<GetDisclosureRequirementQuery_, GetDisclosureRequirementQueryVariables_> & ({ variables: GetDisclosureRequirementQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisclosureRequirementQuery_, GetDisclosureRequirementQueryVariables_>(GetDisclosureRequirementDocument_, options);
      }
export function useGetDisclosureRequirementLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDisclosureRequirementQuery_, GetDisclosureRequirementQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisclosureRequirementQuery_, GetDisclosureRequirementQueryVariables_>(GetDisclosureRequirementDocument_, options);
        }
export function useGetDisclosureRequirementSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDisclosureRequirementQuery_, GetDisclosureRequirementQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDisclosureRequirementQuery_, GetDisclosureRequirementQueryVariables_>(GetDisclosureRequirementDocument_, options);
        }
export type GetDisclosureRequirementQueryHookResult = ReturnType<typeof useGetDisclosureRequirementQuery>;
export type GetDisclosureRequirementLazyQuery_HookResult = ReturnType<typeof useGetDisclosureRequirementLazyQuery_>;
export type GetDisclosureRequirementSuspenseQuery_HookResult = ReturnType<typeof useGetDisclosureRequirementSuspenseQuery_>;
export type GetDisclosureRequirementQueryResult_ = Apollo.QueryResult<GetDisclosureRequirementQuery_, GetDisclosureRequirementQueryVariables_>;
export function refetchGetDisclosureRequirementQuery_(variables: GetDisclosureRequirementQueryVariables_) {
      return { query: GetDisclosureRequirementDocument_, variables: variables }
    }
export const GetDisclosureRequirementRefDocument_ = gql`
    query getDisclosureRequirementRef($reference: String!, $type: String!) {
  disclosureRequirement: DisclosureRequirement_by_pk(reference: $reference) {
    group {
      reference
      requirements(where: {type: {_eq: $type}}) {
        reference
      }
    }
  }
}
    `;

/**
 * __useGetDisclosureRequirementRefQuery__
 *
 * To run a query within a React component, call `useGetDisclosureRequirementRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisclosureRequirementRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisclosureRequirementRefQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetDisclosureRequirementRefQuery(baseOptions: Apollo.QueryHookOptions<GetDisclosureRequirementRefQuery_, GetDisclosureRequirementRefQueryVariables_> & ({ variables: GetDisclosureRequirementRefQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisclosureRequirementRefQuery_, GetDisclosureRequirementRefQueryVariables_>(GetDisclosureRequirementRefDocument_, options);
      }
export function useGetDisclosureRequirementRefLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDisclosureRequirementRefQuery_, GetDisclosureRequirementRefQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisclosureRequirementRefQuery_, GetDisclosureRequirementRefQueryVariables_>(GetDisclosureRequirementRefDocument_, options);
        }
export function useGetDisclosureRequirementRefSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDisclosureRequirementRefQuery_, GetDisclosureRequirementRefQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDisclosureRequirementRefQuery_, GetDisclosureRequirementRefQueryVariables_>(GetDisclosureRequirementRefDocument_, options);
        }
export type GetDisclosureRequirementRefQueryHookResult = ReturnType<typeof useGetDisclosureRequirementRefQuery>;
export type GetDisclosureRequirementRefLazyQuery_HookResult = ReturnType<typeof useGetDisclosureRequirementRefLazyQuery_>;
export type GetDisclosureRequirementRefSuspenseQuery_HookResult = ReturnType<typeof useGetDisclosureRequirementRefSuspenseQuery_>;
export type GetDisclosureRequirementRefQueryResult_ = Apollo.QueryResult<GetDisclosureRequirementRefQuery_, GetDisclosureRequirementRefQueryVariables_>;
export function refetchGetDisclosureRequirementRefQuery_(variables: GetDisclosureRequirementRefQueryVariables_) {
      return { query: GetDisclosureRequirementRefDocument_, variables: variables }
    }
export const GetAssessmentCurrencyConversionDocument_ = gql`
    query getAssessmentCurrencyConversion($assessmentId: uuid!) {
  esrs_AssessmentCurrencyConversion(where: {assessmentId: {_eq: $assessmentId}}) {
    assessmentId
    from
    rate
    to
  }
}
    `;

/**
 * __useGetAssessmentCurrencyConversionQuery__
 *
 * To run a query within a React component, call `useGetAssessmentCurrencyConversionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentCurrencyConversionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentCurrencyConversionQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetAssessmentCurrencyConversionQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentCurrencyConversionQuery_, GetAssessmentCurrencyConversionQueryVariables_> & ({ variables: GetAssessmentCurrencyConversionQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentCurrencyConversionQuery_, GetAssessmentCurrencyConversionQueryVariables_>(GetAssessmentCurrencyConversionDocument_, options);
      }
export function useGetAssessmentCurrencyConversionLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentCurrencyConversionQuery_, GetAssessmentCurrencyConversionQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentCurrencyConversionQuery_, GetAssessmentCurrencyConversionQueryVariables_>(GetAssessmentCurrencyConversionDocument_, options);
        }
export function useGetAssessmentCurrencyConversionSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentCurrencyConversionQuery_, GetAssessmentCurrencyConversionQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentCurrencyConversionQuery_, GetAssessmentCurrencyConversionQueryVariables_>(GetAssessmentCurrencyConversionDocument_, options);
        }
export type GetAssessmentCurrencyConversionQueryHookResult = ReturnType<typeof useGetAssessmentCurrencyConversionQuery>;
export type GetAssessmentCurrencyConversionLazyQuery_HookResult = ReturnType<typeof useGetAssessmentCurrencyConversionLazyQuery_>;
export type GetAssessmentCurrencyConversionSuspenseQuery_HookResult = ReturnType<typeof useGetAssessmentCurrencyConversionSuspenseQuery_>;
export type GetAssessmentCurrencyConversionQueryResult_ = Apollo.QueryResult<GetAssessmentCurrencyConversionQuery_, GetAssessmentCurrencyConversionQueryVariables_>;
export function refetchGetAssessmentCurrencyConversionQuery_(variables: GetAssessmentCurrencyConversionQueryVariables_) {
      return { query: GetAssessmentCurrencyConversionDocument_, variables: variables }
    }
export const GetSubCurrenciesDocument_ = gql`
    query getSubCurrencies($assessmentId: uuid!) {
  EsrsAssessment(where: {parentAssessmentId: {_eq: $assessmentId}}) {
    company {
      currency
      name
    }
  }
}
    `;

/**
 * __useGetSubCurrenciesQuery__
 *
 * To run a query within a React component, call `useGetSubCurrenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubCurrenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubCurrenciesQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetSubCurrenciesQuery(baseOptions: Apollo.QueryHookOptions<GetSubCurrenciesQuery_, GetSubCurrenciesQueryVariables_> & ({ variables: GetSubCurrenciesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubCurrenciesQuery_, GetSubCurrenciesQueryVariables_>(GetSubCurrenciesDocument_, options);
      }
export function useGetSubCurrenciesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubCurrenciesQuery_, GetSubCurrenciesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubCurrenciesQuery_, GetSubCurrenciesQueryVariables_>(GetSubCurrenciesDocument_, options);
        }
export function useGetSubCurrenciesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubCurrenciesQuery_, GetSubCurrenciesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubCurrenciesQuery_, GetSubCurrenciesQueryVariables_>(GetSubCurrenciesDocument_, options);
        }
export type GetSubCurrenciesQueryHookResult = ReturnType<typeof useGetSubCurrenciesQuery>;
export type GetSubCurrenciesLazyQuery_HookResult = ReturnType<typeof useGetSubCurrenciesLazyQuery_>;
export type GetSubCurrenciesSuspenseQuery_HookResult = ReturnType<typeof useGetSubCurrenciesSuspenseQuery_>;
export type GetSubCurrenciesQueryResult_ = Apollo.QueryResult<GetSubCurrenciesQuery_, GetSubCurrenciesQueryVariables_>;
export function refetchGetSubCurrenciesQuery_(variables: GetSubCurrenciesQueryVariables_) {
      return { query: GetSubCurrenciesDocument_, variables: variables }
    }
export const GetCurrencyConversionRateDocument_ = gql`
    query getCurrencyConversionRate($assessmentId: uuid!, $from: String!, $to: String!) {
  esrs_AssessmentCurrencyConversion_by_pk(
    assessmentId: $assessmentId
    from: $from
    to: $to
  ) {
    rate
  }
}
    `;

/**
 * __useGetCurrencyConversionRateQuery__
 *
 * To run a query within a React component, call `useGetCurrencyConversionRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrencyConversionRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrencyConversionRateQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useGetCurrencyConversionRateQuery(baseOptions: Apollo.QueryHookOptions<GetCurrencyConversionRateQuery_, GetCurrencyConversionRateQueryVariables_> & ({ variables: GetCurrencyConversionRateQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrencyConversionRateQuery_, GetCurrencyConversionRateQueryVariables_>(GetCurrencyConversionRateDocument_, options);
      }
export function useGetCurrencyConversionRateLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrencyConversionRateQuery_, GetCurrencyConversionRateQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrencyConversionRateQuery_, GetCurrencyConversionRateQueryVariables_>(GetCurrencyConversionRateDocument_, options);
        }
export function useGetCurrencyConversionRateSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrencyConversionRateQuery_, GetCurrencyConversionRateQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrencyConversionRateQuery_, GetCurrencyConversionRateQueryVariables_>(GetCurrencyConversionRateDocument_, options);
        }
export type GetCurrencyConversionRateQueryHookResult = ReturnType<typeof useGetCurrencyConversionRateQuery>;
export type GetCurrencyConversionRateLazyQuery_HookResult = ReturnType<typeof useGetCurrencyConversionRateLazyQuery_>;
export type GetCurrencyConversionRateSuspenseQuery_HookResult = ReturnType<typeof useGetCurrencyConversionRateSuspenseQuery_>;
export type GetCurrencyConversionRateQueryResult_ = Apollo.QueryResult<GetCurrencyConversionRateQuery_, GetCurrencyConversionRateQueryVariables_>;
export function refetchGetCurrencyConversionRateQuery_(variables: GetCurrencyConversionRateQueryVariables_) {
      return { query: GetCurrencyConversionRateDocument_, variables: variables }
    }
export const GetStandardMetricsDocument_ = gql`
    query getStandardMetrics($standard: String!) {
  metrics: EsrsMetric(
    order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
    where: {requirement: {group: {standard: {reference: {_eq: $standard}}}}}
  ) {
    reference
  }
}
    `;

/**
 * __useGetStandardMetricsQuery__
 *
 * To run a query within a React component, call `useGetStandardMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandardMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandardMetricsQuery({
 *   variables: {
 *      standard: // value for 'standard'
 *   },
 * });
 */
export function useGetStandardMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetStandardMetricsQuery_, GetStandardMetricsQueryVariables_> & ({ variables: GetStandardMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandardMetricsQuery_, GetStandardMetricsQueryVariables_>(GetStandardMetricsDocument_, options);
      }
export function useGetStandardMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetStandardMetricsQuery_, GetStandardMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandardMetricsQuery_, GetStandardMetricsQueryVariables_>(GetStandardMetricsDocument_, options);
        }
export function useGetStandardMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStandardMetricsQuery_, GetStandardMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStandardMetricsQuery_, GetStandardMetricsQueryVariables_>(GetStandardMetricsDocument_, options);
        }
export type GetStandardMetricsQueryHookResult = ReturnType<typeof useGetStandardMetricsQuery>;
export type GetStandardMetricsLazyQuery_HookResult = ReturnType<typeof useGetStandardMetricsLazyQuery_>;
export type GetStandardMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetStandardMetricsSuspenseQuery_>;
export type GetStandardMetricsQueryResult_ = Apollo.QueryResult<GetStandardMetricsQuery_, GetStandardMetricsQueryVariables_>;
export function refetchGetStandardMetricsQuery_(variables: GetStandardMetricsQueryVariables_) {
      return { query: GetStandardMetricsDocument_, variables: variables }
    }
export const GetQualitativeMetricsDocument_ = gql`
    query getQualitativeMetrics {
  EsrsMetric(where: {metricType: {_in: [LONG_TEXT]}}) {
    reference
    title
    description
  }
}
    `;

/**
 * __useGetQualitativeMetricsQuery__
 *
 * To run a query within a React component, call `useGetQualitativeMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQualitativeMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQualitativeMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQualitativeMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetQualitativeMetricsQuery_, GetQualitativeMetricsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQualitativeMetricsQuery_, GetQualitativeMetricsQueryVariables_>(GetQualitativeMetricsDocument_, options);
      }
export function useGetQualitativeMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetQualitativeMetricsQuery_, GetQualitativeMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQualitativeMetricsQuery_, GetQualitativeMetricsQueryVariables_>(GetQualitativeMetricsDocument_, options);
        }
export function useGetQualitativeMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetQualitativeMetricsQuery_, GetQualitativeMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetQualitativeMetricsQuery_, GetQualitativeMetricsQueryVariables_>(GetQualitativeMetricsDocument_, options);
        }
export type GetQualitativeMetricsQueryHookResult = ReturnType<typeof useGetQualitativeMetricsQuery>;
export type GetQualitativeMetricsLazyQuery_HookResult = ReturnType<typeof useGetQualitativeMetricsLazyQuery_>;
export type GetQualitativeMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetQualitativeMetricsSuspenseQuery_>;
export type GetQualitativeMetricsQueryResult_ = Apollo.QueryResult<GetQualitativeMetricsQuery_, GetQualitativeMetricsQueryVariables_>;
export function refetchGetQualitativeMetricsQuery_(variables?: GetQualitativeMetricsQueryVariables_) {
      return { query: GetQualitativeMetricsDocument_, variables: variables }
    }
export const GetMaterialStandardDrStatusesDocument_ = gql`
    query getMaterialStandardDrStatuses($materialStandardId: uuid!) {
  DisclosureRequirementStatus(
    where: {materialStandardId: {_eq: $materialStandardId}}
  ) {
    disclosureRequirementRef
    mfDisclosureRequirementRef
    isConfigured
  }
}
    `;

/**
 * __useGetMaterialStandardDrStatusesQuery__
 *
 * To run a query within a React component, call `useGetMaterialStandardDrStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialStandardDrStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialStandardDrStatusesQuery({
 *   variables: {
 *      materialStandardId: // value for 'materialStandardId'
 *   },
 * });
 */
export function useGetMaterialStandardDrStatusesQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialStandardDrStatusesQuery_, GetMaterialStandardDrStatusesQueryVariables_> & ({ variables: GetMaterialStandardDrStatusesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialStandardDrStatusesQuery_, GetMaterialStandardDrStatusesQueryVariables_>(GetMaterialStandardDrStatusesDocument_, options);
      }
export function useGetMaterialStandardDrStatusesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialStandardDrStatusesQuery_, GetMaterialStandardDrStatusesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialStandardDrStatusesQuery_, GetMaterialStandardDrStatusesQueryVariables_>(GetMaterialStandardDrStatusesDocument_, options);
        }
export function useGetMaterialStandardDrStatusesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaterialStandardDrStatusesQuery_, GetMaterialStandardDrStatusesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaterialStandardDrStatusesQuery_, GetMaterialStandardDrStatusesQueryVariables_>(GetMaterialStandardDrStatusesDocument_, options);
        }
export type GetMaterialStandardDrStatusesQueryHookResult = ReturnType<typeof useGetMaterialStandardDrStatusesQuery>;
export type GetMaterialStandardDrStatusesLazyQuery_HookResult = ReturnType<typeof useGetMaterialStandardDrStatusesLazyQuery_>;
export type GetMaterialStandardDrStatusesSuspenseQuery_HookResult = ReturnType<typeof useGetMaterialStandardDrStatusesSuspenseQuery_>;
export type GetMaterialStandardDrStatusesQueryResult_ = Apollo.QueryResult<GetMaterialStandardDrStatusesQuery_, GetMaterialStandardDrStatusesQueryVariables_>;
export function refetchGetMaterialStandardDrStatusesQuery_(variables: GetMaterialStandardDrStatusesQueryVariables_) {
      return { query: GetMaterialStandardDrStatusesDocument_, variables: variables }
    }
export const FlaggedTargetsCountDocument_ = gql`
    query FlaggedTargetsCount($esrsAssessmentId: uuid!) {
  esrs_Target_aggregate(
    where: {parentTargetId: {_is_null: false}, materialStandard: {assessmentId: {_eq: $esrsAssessmentId}}, keyResults_aggregate: {bool_and: {predicate: {_eq: true}, arguments: isFlagged}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useFlaggedTargetsCountQuery__
 *
 * To run a query within a React component, call `useFlaggedTargetsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlaggedTargetsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlaggedTargetsCountQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useFlaggedTargetsCountQuery(baseOptions: Apollo.QueryHookOptions<FlaggedTargetsCountQuery_, FlaggedTargetsCountQueryVariables_> & ({ variables: FlaggedTargetsCountQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlaggedTargetsCountQuery_, FlaggedTargetsCountQueryVariables_>(FlaggedTargetsCountDocument_, options);
      }
export function useFlaggedTargetsCountLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<FlaggedTargetsCountQuery_, FlaggedTargetsCountQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlaggedTargetsCountQuery_, FlaggedTargetsCountQueryVariables_>(FlaggedTargetsCountDocument_, options);
        }
export function useFlaggedTargetsCountSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FlaggedTargetsCountQuery_, FlaggedTargetsCountQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FlaggedTargetsCountQuery_, FlaggedTargetsCountQueryVariables_>(FlaggedTargetsCountDocument_, options);
        }
export type FlaggedTargetsCountQueryHookResult = ReturnType<typeof useFlaggedTargetsCountQuery>;
export type FlaggedTargetsCountLazyQuery_HookResult = ReturnType<typeof useFlaggedTargetsCountLazyQuery_>;
export type FlaggedTargetsCountSuspenseQuery_HookResult = ReturnType<typeof useFlaggedTargetsCountSuspenseQuery_>;
export type FlaggedTargetsCountQueryResult_ = Apollo.QueryResult<FlaggedTargetsCountQuery_, FlaggedTargetsCountQueryVariables_>;
export function refetchFlaggedTargetsCountQuery_(variables: FlaggedTargetsCountQueryVariables_) {
      return { query: FlaggedTargetsCountDocument_, variables: variables }
    }
export const UpsertDisclosureRequirementAttachmentDocument_ = gql`
    mutation upsertDisclosureRequirementAttachment($objects: [esrs_DisclosureRequirementAttachment_insert_input!]!) {
  insert_esrs_DisclosureRequirementAttachment(
    objects: $objects
    on_conflict: {constraint: DisclosureRequirementAttachment_materialStandardId_reportingUni, update_columns: [updatedAt]}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type UpsertDisclosureRequirementAttachmentMutationFn_ = Apollo.MutationFunction<UpsertDisclosureRequirementAttachmentMutation_, UpsertDisclosureRequirementAttachmentMutationVariables_>;

/**
 * __useUpsertDisclosureRequirementAttachmentMutation__
 *
 * To run a mutation, you first call `useUpsertDisclosureRequirementAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDisclosureRequirementAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDisclosureRequirementAttachmentMutation, { data, loading, error }] = useUpsertDisclosureRequirementAttachmentMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertDisclosureRequirementAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDisclosureRequirementAttachmentMutation_, UpsertDisclosureRequirementAttachmentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDisclosureRequirementAttachmentMutation_, UpsertDisclosureRequirementAttachmentMutationVariables_>(UpsertDisclosureRequirementAttachmentDocument_, options);
      }
export type UpsertDisclosureRequirementAttachmentMutationHookResult = ReturnType<typeof useUpsertDisclosureRequirementAttachmentMutation>;
export type UpsertDisclosureRequirementAttachmentMutationResult_ = Apollo.MutationResult<UpsertDisclosureRequirementAttachmentMutation_>;
export type UpsertDisclosureRequirementAttachmentMutationOptions_ = Apollo.BaseMutationOptions<UpsertDisclosureRequirementAttachmentMutation_, UpsertDisclosureRequirementAttachmentMutationVariables_>;
export const UpsertCurrencyConversionRateDocument_ = gql`
    mutation upsertCurrencyConversionRate($object: esrs_AssessmentCurrencyConversion_insert_input!) {
  insert_esrs_AssessmentCurrencyConversion_one(
    object: $object
    on_conflict: {constraint: AssessmentCurrencyConversion_pkey, update_columns: [rate]}
  ) {
    assessmentId
    from
    to
    rate
  }
}
    `;
export type UpsertCurrencyConversionRateMutationFn_ = Apollo.MutationFunction<UpsertCurrencyConversionRateMutation_, UpsertCurrencyConversionRateMutationVariables_>;

/**
 * __useUpsertCurrencyConversionRateMutation__
 *
 * To run a mutation, you first call `useUpsertCurrencyConversionRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCurrencyConversionRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCurrencyConversionRateMutation, { data, loading, error }] = useUpsertCurrencyConversionRateMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpsertCurrencyConversionRateMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCurrencyConversionRateMutation_, UpsertCurrencyConversionRateMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCurrencyConversionRateMutation_, UpsertCurrencyConversionRateMutationVariables_>(UpsertCurrencyConversionRateDocument_, options);
      }
export type UpsertCurrencyConversionRateMutationHookResult = ReturnType<typeof useUpsertCurrencyConversionRateMutation>;
export type UpsertCurrencyConversionRateMutationResult_ = Apollo.MutationResult<UpsertCurrencyConversionRateMutation_>;
export type UpsertCurrencyConversionRateMutationOptions_ = Apollo.BaseMutationOptions<UpsertCurrencyConversionRateMutation_, UpsertCurrencyConversionRateMutationVariables_>;
export const GetEsrsReportStructureDocument_ = gql`
    query GetEsrsReportStructure($assessmentId: uuid!, $groupMetrics: [String!]!, $groupStandards: [String!]!) {
  esrs_MaterialStandard(
    where: {_or: [{isMaterial: {_eq: true}, assessmentId: {_eq: $assessmentId}, isDataGatheringOnly: {_eq: false}}, {standardRef: {_in: $groupStandards}, assessmentId: {_eq: $assessmentId}}]}
    order_by: {standard: {order: asc}}
  ) {
    standard {
      reference
      title
      category {
        reference
        title
      }
      disclosureRequirementGroups {
        title
        reference
        requirements(
          where: {_and: [{group: {standard: {reference: {_neq: "ESRS-2"}}}}, {reference: {_nin: ["E1-GOV-3", "G1-GOV-1"]}}, {metrics: {_or: [{materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}, isMaterial: {_eq: true}, isDataGatheringOnly: {_eq: false}}}, {materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}}, _or: [{reference: {_in: $groupMetrics}}, {view_childrenMetrics: {childMetricRef: {_in: $groupMetrics}}}]}]}}]}
        ) {
          title
          reference
          order
          type
          additionalTypes {
            additionalTypeRef
          }
          notHiddenCount: metrics_aggregate(
            where: {materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}, isHidden: {_eq: false}}}
          ) {
            aggregate {
              count
            }
          }
        }
      }
      specificMFStandard {
        reference
        title
        category: mfCategory {
          reference
          title
        }
        disclosureRequirementGroups: mfDisclosureRequirementGroups {
          title
          reference
          requirements: mfDisclosureRequirements(
            where: {_and: [{mfDisclosureRequirementItems: {_or: [{metric: {materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}, isMaterial: {_eq: true}, isDataGatheringOnly: {_eq: false}}}}, {metric: {materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}}, _or: [{reference: {_in: $groupMetrics}}, {view_childrenMetrics: {childMetricRef: {_in: $groupMetrics}}}]}}]}}]}
          ) {
            title
            reference
            order
            type
            notHiddenCount: mfDisclosureRequirementItems_aggregate(
              where: {metric: {materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}, isHidden: {_eq: false}}}}
            ) {
              aggregate {
                count
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEsrsReportStructureQuery__
 *
 * To run a query within a React component, call `useGetEsrsReportStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsrsReportStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsrsReportStructureQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      groupMetrics: // value for 'groupMetrics'
 *      groupStandards: // value for 'groupStandards'
 *   },
 * });
 */
export function useGetEsrsReportStructureQuery(baseOptions: Apollo.QueryHookOptions<GetEsrsReportStructureQuery_, GetEsrsReportStructureQueryVariables_> & ({ variables: GetEsrsReportStructureQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsrsReportStructureQuery_, GetEsrsReportStructureQueryVariables_>(GetEsrsReportStructureDocument_, options);
      }
export function useGetEsrsReportStructureLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetEsrsReportStructureQuery_, GetEsrsReportStructureQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsrsReportStructureQuery_, GetEsrsReportStructureQueryVariables_>(GetEsrsReportStructureDocument_, options);
        }
export function useGetEsrsReportStructureSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEsrsReportStructureQuery_, GetEsrsReportStructureQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEsrsReportStructureQuery_, GetEsrsReportStructureQueryVariables_>(GetEsrsReportStructureDocument_, options);
        }
export type GetEsrsReportStructureQueryHookResult = ReturnType<typeof useGetEsrsReportStructureQuery>;
export type GetEsrsReportStructureLazyQuery_HookResult = ReturnType<typeof useGetEsrsReportStructureLazyQuery_>;
export type GetEsrsReportStructureSuspenseQuery_HookResult = ReturnType<typeof useGetEsrsReportStructureSuspenseQuery_>;
export type GetEsrsReportStructureQueryResult_ = Apollo.QueryResult<GetEsrsReportStructureQuery_, GetEsrsReportStructureQueryVariables_>;
export function refetchGetEsrsReportStructureQuery_(variables: GetEsrsReportStructureQueryVariables_) {
      return { query: GetEsrsReportStructureDocument_, variables: variables }
    }
export const GetReportMetricsPerDisclosureDocument_ = gql`
    query getReportMetricsPerDisclosure($assessmentId: uuid!, $disclosureRequirementRef: String!, $groupMetrics: [String!]!, $frameworkRef: String!) {
  EsrsMetric(
    order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}, {reference: asc}]
    where: {_and: [{_or: [{materialMetrics: {isMaterial: {_eq: true}, materialStandard: {assessmentId: {_eq: $assessmentId}}, isDataGatheringOnly: {_eq: false}}}, {materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}}, _or: [{reference: {_in: $groupMetrics}}, {view_childrenMetrics: {childMetricRef: {_in: $groupMetrics}}}]}]}, {relatedDRs: {disclosureRequirementRef: {_eq: $disclosureRequirementRef}, frameworkRef: {_eq: $frameworkRef}}}]}
  ) {
    reference
    materialMetrics(
      order_by: [{metric: {globalOrder: asc}}, {metric: {isAR: asc}}, {metric: {order: asc}}, {metric: {firstLevel: asc}}, {metric: {secondLevel: asc}}, {metric: {reference: asc}}]
      where: {materialStandard: {assessmentId: {_eq: $assessmentId}}}
    ) {
      id
      metricRef
      materialStandardId
      metric {
        ...ChildlessEsrsReportMetricsFields
      }
      ...ReportMaterialMetricsFields
      childrenMetrics(
        order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
        where: {childMetric: {materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}, _or: [{isMaterial: {_eq: true}}, {metric: {metricType: {_eq: DECIMAL}}}]}}}
      ) {
        childMetric {
          ...ChildlessEsrsReportMetricsFields
          materialMetrics(where: {materialStandard: {assessmentId: {_eq: $assessmentId}}}) {
            ...ReportMaterialMetricsFields
          }
          childrenMetrics(
            order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
            where: {childMetric: {materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}, _or: [{isMaterial: {_eq: true}}, {metric: {metricType: {_eq: DECIMAL}}}]}}}
          ) {
            childMetric {
              ...ChildlessEsrsReportMetricsFields
              materialMetrics(where: {materialStandard: {assessmentId: {_eq: $assessmentId}}}) {
                ...ReportMaterialMetricsFields
              }
              childrenMetrics(
                order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
                where: {childMetric: {materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}, _or: [{isMaterial: {_eq: true}}, {metric: {metricType: {_eq: DECIMAL}}}]}}}
              ) {
                childMetric {
                  ...ChildlessEsrsReportMetricsFields
                  materialMetrics(where: {materialStandard: {assessmentId: {_eq: $assessmentId}}}) {
                    ...ReportMaterialMetricsFields
                  }
                  childrenMetrics(
                    order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
                    where: {childMetric: {materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}, _or: [{isMaterial: {_eq: true}}, {metric: {metricType: {_eq: DECIMAL}}}]}}}
                  ) {
                    childMetric {
                      ...ChildlessEsrsReportMetricsFields
                      materialMetrics(where: {materialStandard: {assessmentId: {_eq: $assessmentId}}}) {
                        ...ReportMaterialMetricsFields
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ChildlessEsrsReportMetricsFieldsFragmentDoc_}
${ReportMaterialMetricsFieldsFragmentDoc_}`;

/**
 * __useGetReportMetricsPerDisclosureQuery__
 *
 * To run a query within a React component, call `useGetReportMetricsPerDisclosureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportMetricsPerDisclosureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportMetricsPerDisclosureQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *      groupMetrics: // value for 'groupMetrics'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetReportMetricsPerDisclosureQuery(baseOptions: Apollo.QueryHookOptions<GetReportMetricsPerDisclosureQuery_, GetReportMetricsPerDisclosureQueryVariables_> & ({ variables: GetReportMetricsPerDisclosureQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportMetricsPerDisclosureQuery_, GetReportMetricsPerDisclosureQueryVariables_>(GetReportMetricsPerDisclosureDocument_, options);
      }
export function useGetReportMetricsPerDisclosureLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetReportMetricsPerDisclosureQuery_, GetReportMetricsPerDisclosureQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportMetricsPerDisclosureQuery_, GetReportMetricsPerDisclosureQueryVariables_>(GetReportMetricsPerDisclosureDocument_, options);
        }
export function useGetReportMetricsPerDisclosureSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportMetricsPerDisclosureQuery_, GetReportMetricsPerDisclosureQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportMetricsPerDisclosureQuery_, GetReportMetricsPerDisclosureQueryVariables_>(GetReportMetricsPerDisclosureDocument_, options);
        }
export type GetReportMetricsPerDisclosureQueryHookResult = ReturnType<typeof useGetReportMetricsPerDisclosureQuery>;
export type GetReportMetricsPerDisclosureLazyQuery_HookResult = ReturnType<typeof useGetReportMetricsPerDisclosureLazyQuery_>;
export type GetReportMetricsPerDisclosureSuspenseQuery_HookResult = ReturnType<typeof useGetReportMetricsPerDisclosureSuspenseQuery_>;
export type GetReportMetricsPerDisclosureQueryResult_ = Apollo.QueryResult<GetReportMetricsPerDisclosureQuery_, GetReportMetricsPerDisclosureQueryVariables_>;
export function refetchGetReportMetricsPerDisclosureQuery_(variables: GetReportMetricsPerDisclosureQueryVariables_) {
      return { query: GetReportMetricsPerDisclosureDocument_, variables: variables }
    }
export const GetReportGeneralDisclosureRequirementsDocument_ = gql`
    query getReportGeneralDisclosureRequirements($assessmentId: uuid!) {
  DisclosureRequirement(
    where: {_and: [{_or: [{group: {standard: {reference: {_eq: "ESRS-2"}}}}, {reference: {_in: ["E1-GOV-3", "G1-GOV-1"]}}]}, {metrics: {materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}, isMaterial: {_eq: true}, isDataGatheringOnly: {_eq: false}}}}]}
  ) {
    title
    reference
    order
    type
    additionalTypes {
      additionalTypeRef
    }
    notHiddenCount: metrics_aggregate(
      where: {materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}, isHidden: {_eq: false}}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetReportGeneralDisclosureRequirementsQuery__
 *
 * To run a query within a React component, call `useGetReportGeneralDisclosureRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportGeneralDisclosureRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportGeneralDisclosureRequirementsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetReportGeneralDisclosureRequirementsQuery(baseOptions: Apollo.QueryHookOptions<GetReportGeneralDisclosureRequirementsQuery_, GetReportGeneralDisclosureRequirementsQueryVariables_> & ({ variables: GetReportGeneralDisclosureRequirementsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportGeneralDisclosureRequirementsQuery_, GetReportGeneralDisclosureRequirementsQueryVariables_>(GetReportGeneralDisclosureRequirementsDocument_, options);
      }
export function useGetReportGeneralDisclosureRequirementsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetReportGeneralDisclosureRequirementsQuery_, GetReportGeneralDisclosureRequirementsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportGeneralDisclosureRequirementsQuery_, GetReportGeneralDisclosureRequirementsQueryVariables_>(GetReportGeneralDisclosureRequirementsDocument_, options);
        }
export function useGetReportGeneralDisclosureRequirementsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportGeneralDisclosureRequirementsQuery_, GetReportGeneralDisclosureRequirementsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportGeneralDisclosureRequirementsQuery_, GetReportGeneralDisclosureRequirementsQueryVariables_>(GetReportGeneralDisclosureRequirementsDocument_, options);
        }
export type GetReportGeneralDisclosureRequirementsQueryHookResult = ReturnType<typeof useGetReportGeneralDisclosureRequirementsQuery>;
export type GetReportGeneralDisclosureRequirementsLazyQuery_HookResult = ReturnType<typeof useGetReportGeneralDisclosureRequirementsLazyQuery_>;
export type GetReportGeneralDisclosureRequirementsSuspenseQuery_HookResult = ReturnType<typeof useGetReportGeneralDisclosureRequirementsSuspenseQuery_>;
export type GetReportGeneralDisclosureRequirementsQueryResult_ = Apollo.QueryResult<GetReportGeneralDisclosureRequirementsQuery_, GetReportGeneralDisclosureRequirementsQueryVariables_>;
export function refetchGetReportGeneralDisclosureRequirementsQuery_(variables: GetReportGeneralDisclosureRequirementsQueryVariables_) {
      return { query: GetReportGeneralDisclosureRequirementsDocument_, variables: variables }
    }
export const GetMetricVisibilityStatusDocument_ = gql`
    query getMetricVisibilityStatus($materialStandardId: uuid!, $metricRef: String!) {
  esrs_MaterialMetric(
    where: {materialStandardId: {_eq: $materialStandardId}, metricRef: {_eq: $metricRef}, isMaterial: {_eq: true}, isDataGatheringOnly: {_eq: false}}
  ) {
    id
    metricRef
    isHidden
  }
}
    `;

/**
 * __useGetMetricVisibilityStatusQuery__
 *
 * To run a query within a React component, call `useGetMetricVisibilityStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricVisibilityStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricVisibilityStatusQuery({
 *   variables: {
 *      materialStandardId: // value for 'materialStandardId'
 *      metricRef: // value for 'metricRef'
 *   },
 * });
 */
export function useGetMetricVisibilityStatusQuery(baseOptions: Apollo.QueryHookOptions<GetMetricVisibilityStatusQuery_, GetMetricVisibilityStatusQueryVariables_> & ({ variables: GetMetricVisibilityStatusQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricVisibilityStatusQuery_, GetMetricVisibilityStatusQueryVariables_>(GetMetricVisibilityStatusDocument_, options);
      }
export function useGetMetricVisibilityStatusLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricVisibilityStatusQuery_, GetMetricVisibilityStatusQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricVisibilityStatusQuery_, GetMetricVisibilityStatusQueryVariables_>(GetMetricVisibilityStatusDocument_, options);
        }
export function useGetMetricVisibilityStatusSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricVisibilityStatusQuery_, GetMetricVisibilityStatusQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricVisibilityStatusQuery_, GetMetricVisibilityStatusQueryVariables_>(GetMetricVisibilityStatusDocument_, options);
        }
export type GetMetricVisibilityStatusQueryHookResult = ReturnType<typeof useGetMetricVisibilityStatusQuery>;
export type GetMetricVisibilityStatusLazyQuery_HookResult = ReturnType<typeof useGetMetricVisibilityStatusLazyQuery_>;
export type GetMetricVisibilityStatusSuspenseQuery_HookResult = ReturnType<typeof useGetMetricVisibilityStatusSuspenseQuery_>;
export type GetMetricVisibilityStatusQueryResult_ = Apollo.QueryResult<GetMetricVisibilityStatusQuery_, GetMetricVisibilityStatusQueryVariables_>;
export function refetchGetMetricVisibilityStatusQuery_(variables: GetMetricVisibilityStatusQueryVariables_) {
      return { query: GetMetricVisibilityStatusDocument_, variables: variables }
    }
export const GetReportMaterialStandardsDocument_ = gql`
    query getReportMaterialStandards($esrsAssessmentId: uuid!, $groupMetrics: [String!]!, $groupStandards: [String!]!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    materialStandards(
      where: {_or: [{isMaterial: {_eq: true}, isDataGatheringOnly: {_eq: false}}, {standardRef: {_in: $groupStandards}}]}
      order_by: {standard: {order: asc}}
    ) {
      id
      standardRef
      standard {
        order
        disclosureRequirementGroups {
          reference
          requirements(where: {isMandatory: {_eq: true}}) {
            order
            reference
            title
            frameworkRef
            type
            additionalTypes {
              additionalTypeRef
            }
            metrics {
              ...ChildlessEsrsReportMetricsFields
            }
            targets(
              order_by: {createdAt: asc}
              where: {materialStandard: {assessmentId: {_eq: $esrsAssessmentId}}}
            ) {
              ...TargetFields
            }
            actions(
              order_by: {createdAt: asc}
              where: {materialStandard: {assessmentId: {_eq: $esrsAssessmentId}}}
            ) {
              ...ActionFields
            }
          }
        }
        targetQuestions(
          order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
        ) {
          ...TargetQuestionFields
        }
        actionQuestions(
          order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
        ) {
          ...ActionQuestionFields
        }
        categoryRef
        title
        category {
          title
        }
      }
      materialMetrics(
        order_by: [{metric: {globalOrder: asc}}, {metric: {isAR: asc}}, {metric: {order: asc}}, {metric: {firstLevel: asc}}, {metric: {secondLevel: asc}}, {metric: {reference: asc}}]
        where: {_or: [{isDataGatheringOnly: {_eq: false}}, {metric: {_or: [{reference: {_in: $groupMetrics}}, {view_childrenMetrics: {childMetricRef: {_in: $groupMetrics}}}]}}]}
      ) {
        id
        metricRef
        materialStandardId
        metric {
          ...ChildlessEsrsReportMetricsFields
          abbreviation
          mfDisclosureRequirements {
            mfDisclosureRequirement {
              order
              reference
              title
              type
              mfDisclosureRequirementGroup {
                mfStandard {
                  reference
                }
              }
              drToMFDisclosureRequirements {
                disclosureRequirement {
                  order
                  reference
                  title
                  frameworkRef
                  shortTitle
                  additionalTypes {
                    additionalTypeRef
                  }
                  type
                  group {
                    standard {
                      reference
                    }
                  }
                }
              }
            }
          }
          requirement {
            order
            reference
            title
            frameworkRef
            shortTitle
            additionalTypes {
              additionalTypeRef
            }
            type
            group {
              standard {
                title
                reference
              }
            }
          }
        }
        ...MaterialMetricsFields
        childrenMetrics(
          order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
        ) {
          childMetric {
            ...ChildlessEsrsReportMetricsFields
            abbreviation
            materialMetrics(
              where: {materialStandard: {assessmentId: {_eq: $esrsAssessmentId}}}
            ) {
              ...MaterialMetricsFields
            }
            childrenMetrics(
              order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
            ) {
              childMetric {
                ...ChildlessEsrsReportMetricsFields
                abbreviation
                materialMetrics(
                  where: {materialStandard: {assessmentId: {_eq: $esrsAssessmentId}}}
                ) {
                  ...MaterialMetricsFields
                }
                childrenMetrics(
                  order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
                ) {
                  childMetric {
                    ...ChildlessEsrsReportMetricsFields
                    abbreviation
                    materialMetrics(
                      where: {materialStandard: {assessmentId: {_eq: $esrsAssessmentId}}}
                    ) {
                      ...MaterialMetricsFields
                    }
                    childrenMetrics(
                      order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
                    ) {
                      childMetric {
                        ...ChildlessEsrsReportMetricsFields
                        abbreviation
                        materialMetrics(
                          where: {materialStandard: {assessmentId: {_eq: $esrsAssessmentId}}}
                        ) {
                          ...MaterialMetricsFields
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ChildlessEsrsReportMetricsFieldsFragmentDoc_}
${TargetFieldsFragmentDoc_}
${ActionFieldsFragmentDoc_}
${TargetQuestionFieldsFragmentDoc_}
${ActionQuestionFieldsFragmentDoc_}
${MaterialMetricsFieldsFragmentDoc_}`;

/**
 * __useGetReportMaterialStandardsQuery__
 *
 * To run a query within a React component, call `useGetReportMaterialStandardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportMaterialStandardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportMaterialStandardsQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      groupMetrics: // value for 'groupMetrics'
 *      groupStandards: // value for 'groupStandards'
 *   },
 * });
 */
export function useGetReportMaterialStandardsQuery(baseOptions: Apollo.QueryHookOptions<GetReportMaterialStandardsQuery_, GetReportMaterialStandardsQueryVariables_> & ({ variables: GetReportMaterialStandardsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportMaterialStandardsQuery_, GetReportMaterialStandardsQueryVariables_>(GetReportMaterialStandardsDocument_, options);
      }
export function useGetReportMaterialStandardsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetReportMaterialStandardsQuery_, GetReportMaterialStandardsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportMaterialStandardsQuery_, GetReportMaterialStandardsQueryVariables_>(GetReportMaterialStandardsDocument_, options);
        }
export function useGetReportMaterialStandardsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportMaterialStandardsQuery_, GetReportMaterialStandardsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportMaterialStandardsQuery_, GetReportMaterialStandardsQueryVariables_>(GetReportMaterialStandardsDocument_, options);
        }
export type GetReportMaterialStandardsQueryHookResult = ReturnType<typeof useGetReportMaterialStandardsQuery>;
export type GetReportMaterialStandardsLazyQuery_HookResult = ReturnType<typeof useGetReportMaterialStandardsLazyQuery_>;
export type GetReportMaterialStandardsSuspenseQuery_HookResult = ReturnType<typeof useGetReportMaterialStandardsSuspenseQuery_>;
export type GetReportMaterialStandardsQueryResult_ = Apollo.QueryResult<GetReportMaterialStandardsQuery_, GetReportMaterialStandardsQueryVariables_>;
export function refetchGetReportMaterialStandardsQuery_(variables: GetReportMaterialStandardsQueryVariables_) {
      return { query: GetReportMaterialStandardsDocument_, variables: variables }
    }
export const GetRequiredGroupMaterialMetricsDocument_ = gql`
    query getRequiredGroupMaterialMetrics($parentAssessmentId: uuid!) {
  esrs_MaterialMetric(
    where: {isMaterial: {_eq: true}, materialStandard: {assessmentId: {_eq: $parentAssessmentId}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}, metric: {hierarchyStatus: {isLeaf: {_eq: true}}}}
  ) {
    id
    metricRef
    materialStandard {
      standardRef
    }
  }
}
    `;

/**
 * __useGetRequiredGroupMaterialMetricsQuery__
 *
 * To run a query within a React component, call `useGetRequiredGroupMaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredGroupMaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredGroupMaterialMetricsQuery({
 *   variables: {
 *      parentAssessmentId: // value for 'parentAssessmentId'
 *   },
 * });
 */
export function useGetRequiredGroupMaterialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetRequiredGroupMaterialMetricsQuery_, GetRequiredGroupMaterialMetricsQueryVariables_> & ({ variables: GetRequiredGroupMaterialMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequiredGroupMaterialMetricsQuery_, GetRequiredGroupMaterialMetricsQueryVariables_>(GetRequiredGroupMaterialMetricsDocument_, options);
      }
export function useGetRequiredGroupMaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetRequiredGroupMaterialMetricsQuery_, GetRequiredGroupMaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequiredGroupMaterialMetricsQuery_, GetRequiredGroupMaterialMetricsQueryVariables_>(GetRequiredGroupMaterialMetricsDocument_, options);
        }
export function useGetRequiredGroupMaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequiredGroupMaterialMetricsQuery_, GetRequiredGroupMaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequiredGroupMaterialMetricsQuery_, GetRequiredGroupMaterialMetricsQueryVariables_>(GetRequiredGroupMaterialMetricsDocument_, options);
        }
export type GetRequiredGroupMaterialMetricsQueryHookResult = ReturnType<typeof useGetRequiredGroupMaterialMetricsQuery>;
export type GetRequiredGroupMaterialMetricsLazyQuery_HookResult = ReturnType<typeof useGetRequiredGroupMaterialMetricsLazyQuery_>;
export type GetRequiredGroupMaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetRequiredGroupMaterialMetricsSuspenseQuery_>;
export type GetRequiredGroupMaterialMetricsQueryResult_ = Apollo.QueryResult<GetRequiredGroupMaterialMetricsQuery_, GetRequiredGroupMaterialMetricsQueryVariables_>;
export function refetchGetRequiredGroupMaterialMetricsQuery_(variables: GetRequiredGroupMaterialMetricsQueryVariables_) {
      return { query: GetRequiredGroupMaterialMetricsDocument_, variables: variables }
    }
export const ReportTargetQuestionsDocument_ = gql`
    query reportTargetQuestions($standardRef: String!) {
  groups: TargetQuestionGroup(
    where: {targetQuestions_aggregate: {count: {predicate: {_gt: 0}, filter: {standardRef: {_eq: $standardRef}}}}}
  ) {
    title
    reference
    targetQuestions(
      order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
      where: {standardRef: {_eq: $standardRef}}
    ) {
      ...TargetQuestionFields
    }
  }
  singleQuestions: TargetQuestion(
    order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
    where: {standardRef: {_eq: $standardRef}, groupRef: {_is_null: true}}
  ) {
    ...TargetQuestionFields
  }
}
    ${TargetQuestionFieldsFragmentDoc_}`;

/**
 * __useReportTargetQuestionsQuery__
 *
 * To run a query within a React component, call `useReportTargetQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportTargetQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportTargetQuestionsQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *   },
 * });
 */
export function useReportTargetQuestionsQuery(baseOptions: Apollo.QueryHookOptions<ReportTargetQuestionsQuery_, ReportTargetQuestionsQueryVariables_> & ({ variables: ReportTargetQuestionsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportTargetQuestionsQuery_, ReportTargetQuestionsQueryVariables_>(ReportTargetQuestionsDocument_, options);
      }
export function useReportTargetQuestionsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ReportTargetQuestionsQuery_, ReportTargetQuestionsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportTargetQuestionsQuery_, ReportTargetQuestionsQueryVariables_>(ReportTargetQuestionsDocument_, options);
        }
export function useReportTargetQuestionsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportTargetQuestionsQuery_, ReportTargetQuestionsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportTargetQuestionsQuery_, ReportTargetQuestionsQueryVariables_>(ReportTargetQuestionsDocument_, options);
        }
export type ReportTargetQuestionsQueryHookResult = ReturnType<typeof useReportTargetQuestionsQuery>;
export type ReportTargetQuestionsLazyQuery_HookResult = ReturnType<typeof useReportTargetQuestionsLazyQuery_>;
export type ReportTargetQuestionsSuspenseQuery_HookResult = ReturnType<typeof useReportTargetQuestionsSuspenseQuery_>;
export type ReportTargetQuestionsQueryResult_ = Apollo.QueryResult<ReportTargetQuestionsQuery_, ReportTargetQuestionsQueryVariables_>;
export function refetchReportTargetQuestionsQuery_(variables: ReportTargetQuestionsQueryVariables_) {
      return { query: ReportTargetQuestionsDocument_, variables: variables }
    }
export const ReportActionQuestionsDocument_ = gql`
    query reportActionQuestions($standardRef: String!) {
  groups: ActionQuestionGroup(
    where: {actionQuestions_aggregate: {count: {predicate: {_gt: 0}, filter: {standardRef: {_eq: $standardRef}}}}}
  ) {
    title
    reference
    actionQuestions(
      order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
      where: {standardRef: {_eq: $standardRef}}
    ) {
      ...ActionQuestionFields
    }
  }
  singleQuestions: ActionQuestion(
    order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
    where: {standardRef: {_eq: $standardRef}, groupRef: {_is_null: true}}
  ) {
    ...ActionQuestionFields
  }
}
    ${ActionQuestionFieldsFragmentDoc_}`;

/**
 * __useReportActionQuestionsQuery__
 *
 * To run a query within a React component, call `useReportActionQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportActionQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportActionQuestionsQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *   },
 * });
 */
export function useReportActionQuestionsQuery(baseOptions: Apollo.QueryHookOptions<ReportActionQuestionsQuery_, ReportActionQuestionsQueryVariables_> & ({ variables: ReportActionQuestionsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportActionQuestionsQuery_, ReportActionQuestionsQueryVariables_>(ReportActionQuestionsDocument_, options);
      }
export function useReportActionQuestionsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ReportActionQuestionsQuery_, ReportActionQuestionsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportActionQuestionsQuery_, ReportActionQuestionsQueryVariables_>(ReportActionQuestionsDocument_, options);
        }
export function useReportActionQuestionsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportActionQuestionsQuery_, ReportActionQuestionsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportActionQuestionsQuery_, ReportActionQuestionsQueryVariables_>(ReportActionQuestionsDocument_, options);
        }
export type ReportActionQuestionsQueryHookResult = ReturnType<typeof useReportActionQuestionsQuery>;
export type ReportActionQuestionsLazyQuery_HookResult = ReturnType<typeof useReportActionQuestionsLazyQuery_>;
export type ReportActionQuestionsSuspenseQuery_HookResult = ReturnType<typeof useReportActionQuestionsSuspenseQuery_>;
export type ReportActionQuestionsQueryResult_ = Apollo.QueryResult<ReportActionQuestionsQuery_, ReportActionQuestionsQueryVariables_>;
export function refetchReportActionQuestionsQuery_(variables: ReportActionQuestionsQueryVariables_) {
      return { query: ReportActionQuestionsDocument_, variables: variables }
    }
export const HideDrDocument_ = gql`
    mutation hideDR($assessmentId: uuid!, $drRef: String!, $isHidden: Boolean!) {
  update_esrs_MaterialMetric(
    where: {_or: [{metric: {disclosureRequirementRef: {_eq: $drRef}}}, {metric: {mfDisclosureRequirements: {mfDisclosureRequirementRef: {_eq: $drRef}}}}], materialStandard: {assessmentId: {_eq: $assessmentId}, isMaterial: {_eq: true}}}
    _set: {isHidden: $isHidden}
  ) {
    returning {
      id
      isHidden
    }
  }
}
    `;
export type HideDrMutationFn_ = Apollo.MutationFunction<HideDrMutation_, HideDrMutationVariables_>;

/**
 * __useHideDrMutation__
 *
 * To run a mutation, you first call `useHideDrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideDrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideDrMutation, { data, loading, error }] = useHideDrMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      drRef: // value for 'drRef'
 *      isHidden: // value for 'isHidden'
 *   },
 * });
 */
export function useHideDrMutation(baseOptions?: Apollo.MutationHookOptions<HideDrMutation_, HideDrMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideDrMutation_, HideDrMutationVariables_>(HideDrDocument_, options);
      }
export type HideDrMutationHookResult = ReturnType<typeof useHideDrMutation>;
export type HideDrMutationResult_ = Apollo.MutationResult<HideDrMutation_>;
export type HideDrMutationOptions_ = Apollo.BaseMutationOptions<HideDrMutation_, HideDrMutationVariables_>;
export const HideMetricDocument_ = gql`
    mutation hideMetric($assessmentId: uuid!, $metricRef: String!, $isHidden: Boolean!) {
  update_esrs_MaterialMetric(
    where: {_or: [{metricRef: {_eq: $metricRef}}, {parentMetrics: {parentMetricRef: {_eq: $metricRef}}}, {parentMetrics: {parentMetric: {parentMetrics: {parentMetricRef: {_eq: $metricRef}}}}}, {parentMetrics: {parentMetric: {parentMetrics: {parentMetric: {parentMetrics: {parentMetricRef: {_eq: $metricRef}}}}}}}], materialStandard: {assessmentId: {_eq: $assessmentId}, isMaterial: {_eq: true}}}
    _set: {isHidden: $isHidden}
  ) {
    returning {
      id
      isHidden
    }
  }
}
    `;
export type HideMetricMutationFn_ = Apollo.MutationFunction<HideMetricMutation_, HideMetricMutationVariables_>;

/**
 * __useHideMetricMutation__
 *
 * To run a mutation, you first call `useHideMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideMetricMutation, { data, loading, error }] = useHideMetricMutation({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      metricRef: // value for 'metricRef'
 *      isHidden: // value for 'isHidden'
 *   },
 * });
 */
export function useHideMetricMutation(baseOptions?: Apollo.MutationHookOptions<HideMetricMutation_, HideMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideMetricMutation_, HideMetricMutationVariables_>(HideMetricDocument_, options);
      }
export type HideMetricMutationHookResult = ReturnType<typeof useHideMetricMutation>;
export type HideMetricMutationResult_ = Apollo.MutationResult<HideMetricMutation_>;
export type HideMetricMutationOptions_ = Apollo.BaseMutationOptions<HideMetricMutation_, HideMetricMutationVariables_>;
export const GetMetricReportStatusDocument_ = gql`
    subscription getMetricReportStatus($esrsAssessmentId: uuid!) {
  esrs_MaterialMetric(
    where: {materialStandard: {assessmentId: {_eq: $esrsAssessmentId}}}
  ) {
    metricRef
    isHidden
    id
  }
}
    `;

/**
 * __useGetMetricReportStatusSubscription__
 *
 * To run a query within a React component, call `useGetMetricReportStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricReportStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricReportStatusSubscription({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetMetricReportStatusSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetMetricReportStatusSubscription_, GetMetricReportStatusSubscriptionVariables_> & ({ variables: GetMetricReportStatusSubscriptionVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetMetricReportStatusSubscription_, GetMetricReportStatusSubscriptionVariables_>(GetMetricReportStatusDocument_, options);
      }
export type GetMetricReportStatusSubscriptionHookResult = ReturnType<typeof useGetMetricReportStatusSubscription>;
export type GetMetricReportStatusSubscriptionResult_ = Apollo.SubscriptionResult<GetMetricReportStatusSubscription_>;
export const GetAnswersExportDocument_ = gql`
    query getAnswersExport($esrsAssessment: uuid!) {
  esrs_Datapoint(where: {answer: {assessmentId: {_eq: $esrsAssessment}}}) {
    value
    timeframe
    datapointTags {
      tagValue
    }
    answer {
      metric {
        metricType
        title
        reference
        order
        firstLevel
        secondLevel
        globalOrder
        requirement {
          reference
          title
          order
          group {
            standard {
              title
              reference
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAnswersExportQuery__
 *
 * To run a query within a React component, call `useGetAnswersExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswersExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswersExportQuery({
 *   variables: {
 *      esrsAssessment: // value for 'esrsAssessment'
 *   },
 * });
 */
export function useGetAnswersExportQuery(baseOptions: Apollo.QueryHookOptions<GetAnswersExportQuery_, GetAnswersExportQueryVariables_> & ({ variables: GetAnswersExportQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnswersExportQuery_, GetAnswersExportQueryVariables_>(GetAnswersExportDocument_, options);
      }
export function useGetAnswersExportLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAnswersExportQuery_, GetAnswersExportQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnswersExportQuery_, GetAnswersExportQueryVariables_>(GetAnswersExportDocument_, options);
        }
export function useGetAnswersExportSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnswersExportQuery_, GetAnswersExportQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnswersExportQuery_, GetAnswersExportQueryVariables_>(GetAnswersExportDocument_, options);
        }
export type GetAnswersExportQueryHookResult = ReturnType<typeof useGetAnswersExportQuery>;
export type GetAnswersExportLazyQuery_HookResult = ReturnType<typeof useGetAnswersExportLazyQuery_>;
export type GetAnswersExportSuspenseQuery_HookResult = ReturnType<typeof useGetAnswersExportSuspenseQuery_>;
export type GetAnswersExportQueryResult_ = Apollo.QueryResult<GetAnswersExportQuery_, GetAnswersExportQueryVariables_>;
export function refetchGetAnswersExportQuery_(variables: GetAnswersExportQueryVariables_) {
      return { query: GetAnswersExportDocument_, variables: variables }
    }
export const GetDmaDataDocument_ = gql`
    query getDMAData($assessmentId: uuid!) {
  irrelevantDPs: esrs_Datapoint(
    where: {answer: {assessmentId: {_eq: $assessmentId}, hasOptedOut: {_eq: true}}}
  ) {
    answer {
      metricRef
    }
  }
  esrs_MaterialMetric(
    where: {materialStandard: {assessmentId: {_eq: $assessmentId}}, metric: {isAssessable: {_eq: true}}}
  ) {
    isMaterial
    frequency
    dataCollection
    isDataGatheringOnly
    isPhasedIn
    materialStandard {
      isMaterial
      isDataGatheringOnly
      isPhasedIn
    }
    metric {
      title
      reference
      globalOrder
      order
      firstLevel
      additionalTypes {
        additionalType {
          title
        }
      }
      type: metricType
      secondLevel
      requirement {
        reference
        order
        title
        group {
          standard {
            reference
            title
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDmaDataQuery__
 *
 * To run a query within a React component, call `useGetDmaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDmaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDmaDataQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetDmaDataQuery(baseOptions: Apollo.QueryHookOptions<GetDmaDataQuery_, GetDmaDataQueryVariables_> & ({ variables: GetDmaDataQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDmaDataQuery_, GetDmaDataQueryVariables_>(GetDmaDataDocument_, options);
      }
export function useGetDmaDataLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDmaDataQuery_, GetDmaDataQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDmaDataQuery_, GetDmaDataQueryVariables_>(GetDmaDataDocument_, options);
        }
export function useGetDmaDataSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDmaDataQuery_, GetDmaDataQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDmaDataQuery_, GetDmaDataQueryVariables_>(GetDmaDataDocument_, options);
        }
export type GetDmaDataQueryHookResult = ReturnType<typeof useGetDmaDataQuery>;
export type GetDmaDataLazyQuery_HookResult = ReturnType<typeof useGetDmaDataLazyQuery_>;
export type GetDmaDataSuspenseQuery_HookResult = ReturnType<typeof useGetDmaDataSuspenseQuery_>;
export type GetDmaDataQueryResult_ = Apollo.QueryResult<GetDmaDataQuery_, GetDmaDataQueryVariables_>;
export function refetchGetDmaDataQuery_(variables: GetDmaDataQueryVariables_) {
      return { query: GetDmaDataDocument_, variables: variables }
    }
export const GetSpecificMaterialityDocument_ = gql`
    query getSpecificMateriality($esrsAssessmentId: uuid!, $standardRefs: [String!]!, $metricRefs: [String!]!) {
  esrs_MaterialStandard(
    where: {assessmentId: {_eq: $esrsAssessmentId}, standardRef: {_in: $standardRefs}}
  ) {
    id
    standardRef
    isMaterial
    materialMetrics(where: {metricRef: {_in: $metricRefs}}) {
      id
      isMaterial
      metricRef
      metric {
        reference
        disclosureRequirementRef
        mfDisclosureRequirements {
          mfDisclosureRequirementRef
        }
      }
    }
  }
}
    `;

/**
 * __useGetSpecificMaterialityQuery__
 *
 * To run a query within a React component, call `useGetSpecificMaterialityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSpecificMaterialityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSpecificMaterialityQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      standardRefs: // value for 'standardRefs'
 *      metricRefs: // value for 'metricRefs'
 *   },
 * });
 */
export function useGetSpecificMaterialityQuery(baseOptions: Apollo.QueryHookOptions<GetSpecificMaterialityQuery_, GetSpecificMaterialityQueryVariables_> & ({ variables: GetSpecificMaterialityQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSpecificMaterialityQuery_, GetSpecificMaterialityQueryVariables_>(GetSpecificMaterialityDocument_, options);
      }
export function useGetSpecificMaterialityLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSpecificMaterialityQuery_, GetSpecificMaterialityQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSpecificMaterialityQuery_, GetSpecificMaterialityQueryVariables_>(GetSpecificMaterialityDocument_, options);
        }
export function useGetSpecificMaterialitySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSpecificMaterialityQuery_, GetSpecificMaterialityQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSpecificMaterialityQuery_, GetSpecificMaterialityQueryVariables_>(GetSpecificMaterialityDocument_, options);
        }
export type GetSpecificMaterialityQueryHookResult = ReturnType<typeof useGetSpecificMaterialityQuery>;
export type GetSpecificMaterialityLazyQuery_HookResult = ReturnType<typeof useGetSpecificMaterialityLazyQuery_>;
export type GetSpecificMaterialitySuspenseQuery_HookResult = ReturnType<typeof useGetSpecificMaterialitySuspenseQuery_>;
export type GetSpecificMaterialityQueryResult_ = Apollo.QueryResult<GetSpecificMaterialityQuery_, GetSpecificMaterialityQueryVariables_>;
export function refetchGetSpecificMaterialityQuery_(variables: GetSpecificMaterialityQueryVariables_) {
      return { query: GetSpecificMaterialityDocument_, variables: variables }
    }
export const UpsertMaterialStandardDocument_ = gql`
    mutation upsertMaterialStandard($materialStandard: esrs_MaterialStandard_insert_input!) {
  insert_esrs_MaterialStandard_one(
    object: $materialStandard
    on_conflict: {constraint: MaterialStandard_standardRef_assessmentId_key, update_columns: [isMaterial, isDataGatheringOnly, isPhasedIn]}
  ) {
    id
    standard {
      reference
      disclosureRequirementGroups {
        requirements(where: {type: {_eq: "policy"}}) {
          reference
          type
        }
      }
    }
  }
}
    `;
export type UpsertMaterialStandardMutationFn_ = Apollo.MutationFunction<UpsertMaterialStandardMutation_, UpsertMaterialStandardMutationVariables_>;

/**
 * __useUpsertMaterialStandardMutation__
 *
 * To run a mutation, you first call `useUpsertMaterialStandardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMaterialStandardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMaterialStandardMutation, { data, loading, error }] = useUpsertMaterialStandardMutation({
 *   variables: {
 *      materialStandard: // value for 'materialStandard'
 *   },
 * });
 */
export function useUpsertMaterialStandardMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMaterialStandardMutation_, UpsertMaterialStandardMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMaterialStandardMutation_, UpsertMaterialStandardMutationVariables_>(UpsertMaterialStandardDocument_, options);
      }
export type UpsertMaterialStandardMutationHookResult = ReturnType<typeof useUpsertMaterialStandardMutation>;
export type UpsertMaterialStandardMutationResult_ = Apollo.MutationResult<UpsertMaterialStandardMutation_>;
export type UpsertMaterialStandardMutationOptions_ = Apollo.BaseMutationOptions<UpsertMaterialStandardMutation_, UpsertMaterialStandardMutationVariables_>;
export const UpsertDrMaterialMetricsDocument_ = gql`
    mutation upsertDrMaterialMetrics($objects: [esrs_MaterialMetric_insert_input!]!) {
  insert_esrs_MaterialMetric(
    objects: $objects
    on_conflict: {constraint: MaterialMetric_materialStandardId_metricRef_key, update_columns: [isMaterial, isDataGatheringOnly, isPhasedIn]}
  ) {
    affected_rows
    returning {
      id
      metricRef
    }
  }
}
    `;
export type UpsertDrMaterialMetricsMutationFn_ = Apollo.MutationFunction<UpsertDrMaterialMetricsMutation_, UpsertDrMaterialMetricsMutationVariables_>;

/**
 * __useUpsertDrMaterialMetricsMutation__
 *
 * To run a mutation, you first call `useUpsertDrMaterialMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDrMaterialMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDrMaterialMetricsMutation, { data, loading, error }] = useUpsertDrMaterialMetricsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertDrMaterialMetricsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDrMaterialMetricsMutation_, UpsertDrMaterialMetricsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDrMaterialMetricsMutation_, UpsertDrMaterialMetricsMutationVariables_>(UpsertDrMaterialMetricsDocument_, options);
      }
export type UpsertDrMaterialMetricsMutationHookResult = ReturnType<typeof useUpsertDrMaterialMetricsMutation>;
export type UpsertDrMaterialMetricsMutationResult_ = Apollo.MutationResult<UpsertDrMaterialMetricsMutation_>;
export type UpsertDrMaterialMetricsMutationOptions_ = Apollo.BaseMutationOptions<UpsertDrMaterialMetricsMutation_, UpsertDrMaterialMetricsMutationVariables_>;
export const UpsertMaterialMetricsDocument_ = gql`
    mutation upsertMaterialMetrics($objects: [esrs_MaterialMetric_insert_input!]!) {
  insert_esrs_MaterialMetric(
    objects: $objects
    on_conflict: {constraint: MaterialMetric_pkey, update_columns: [frequency, isMaterial, dataCollection, isHidden]}
  ) {
    affected_rows
    returning {
      id
      metricRef
      isHidden
      materialStandardId
    }
  }
}
    `;
export type UpsertMaterialMetricsMutationFn_ = Apollo.MutationFunction<UpsertMaterialMetricsMutation_, UpsertMaterialMetricsMutationVariables_>;

/**
 * __useUpsertMaterialMetricsMutation__
 *
 * To run a mutation, you first call `useUpsertMaterialMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMaterialMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMaterialMetricsMutation, { data, loading, error }] = useUpsertMaterialMetricsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertMaterialMetricsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMaterialMetricsMutation_, UpsertMaterialMetricsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMaterialMetricsMutation_, UpsertMaterialMetricsMutationVariables_>(UpsertMaterialMetricsDocument_, options);
      }
export type UpsertMaterialMetricsMutationHookResult = ReturnType<typeof useUpsertMaterialMetricsMutation>;
export type UpsertMaterialMetricsMutationResult_ = Apollo.MutationResult<UpsertMaterialMetricsMutation_>;
export type UpsertMaterialMetricsMutationOptions_ = Apollo.BaseMutationOptions<UpsertMaterialMetricsMutation_, UpsertMaterialMetricsMutationVariables_>;
export const UpsertNewMaterialMetricsDocument_ = gql`
    mutation upsertNewMaterialMetrics($objects: [esrs_MaterialMetric_insert_input!]!) {
  insert_esrs_MaterialMetric(
    objects: $objects
    on_conflict: {constraint: MaterialMetric_materialStandardId_metricRef_key, update_columns: []}
  ) {
    affected_rows
    returning {
      id
      metricRef
      isHidden
      materialStandardId
    }
  }
}
    `;
export type UpsertNewMaterialMetricsMutationFn_ = Apollo.MutationFunction<UpsertNewMaterialMetricsMutation_, UpsertNewMaterialMetricsMutationVariables_>;

/**
 * __useUpsertNewMaterialMetricsMutation__
 *
 * To run a mutation, you first call `useUpsertNewMaterialMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertNewMaterialMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertNewMaterialMetricsMutation, { data, loading, error }] = useUpsertNewMaterialMetricsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertNewMaterialMetricsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertNewMaterialMetricsMutation_, UpsertNewMaterialMetricsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertNewMaterialMetricsMutation_, UpsertNewMaterialMetricsMutationVariables_>(UpsertNewMaterialMetricsDocument_, options);
      }
export type UpsertNewMaterialMetricsMutationHookResult = ReturnType<typeof useUpsertNewMaterialMetricsMutation>;
export type UpsertNewMaterialMetricsMutationResult_ = Apollo.MutationResult<UpsertNewMaterialMetricsMutation_>;
export type UpsertNewMaterialMetricsMutationOptions_ = Apollo.BaseMutationOptions<UpsertNewMaterialMetricsMutation_, UpsertNewMaterialMetricsMutationVariables_>;
export const UpsertMultipleMaterialStandardsDocument_ = gql`
    mutation upsertMultipleMaterialStandards($materialStandards: [esrs_MaterialStandard_insert_input!]!) {
  insert_esrs_MaterialStandard(
    objects: $materialStandards
    on_conflict: {constraint: MaterialStandard_standardRef_assessmentId_key, update_columns: [isMaterial, isDataGatheringOnly]}
  ) {
    affected_rows
    returning {
      id
      assessmentId
    }
  }
}
    `;
export type UpsertMultipleMaterialStandardsMutationFn_ = Apollo.MutationFunction<UpsertMultipleMaterialStandardsMutation_, UpsertMultipleMaterialStandardsMutationVariables_>;

/**
 * __useUpsertMultipleMaterialStandardsMutation__
 *
 * To run a mutation, you first call `useUpsertMultipleMaterialStandardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMultipleMaterialStandardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMultipleMaterialStandardsMutation, { data, loading, error }] = useUpsertMultipleMaterialStandardsMutation({
 *   variables: {
 *      materialStandards: // value for 'materialStandards'
 *   },
 * });
 */
export function useUpsertMultipleMaterialStandardsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMultipleMaterialStandardsMutation_, UpsertMultipleMaterialStandardsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMultipleMaterialStandardsMutation_, UpsertMultipleMaterialStandardsMutationVariables_>(UpsertMultipleMaterialStandardsDocument_, options);
      }
export type UpsertMultipleMaterialStandardsMutationHookResult = ReturnType<typeof useUpsertMultipleMaterialStandardsMutation>;
export type UpsertMultipleMaterialStandardsMutationResult_ = Apollo.MutationResult<UpsertMultipleMaterialStandardsMutation_>;
export type UpsertMultipleMaterialStandardsMutationOptions_ = Apollo.BaseMutationOptions<UpsertMultipleMaterialStandardsMutation_, UpsertMultipleMaterialStandardsMutationVariables_>;
export const CopyMultipleMaterialStandardsDocument_ = gql`
    mutation copyMultipleMaterialStandards($materialStandards: [esrs_MaterialStandard_insert_input!]!) {
  insert_esrs_MaterialStandard(
    objects: $materialStandards
    on_conflict: {constraint: MaterialStandard_standardRef_assessmentId_key, update_columns: [isMaterial, isDataGatheringOnly]}
  ) {
    affected_rows
    returning {
      id
      assessmentId
    }
  }
}
    `;
export type CopyMultipleMaterialStandardsMutationFn_ = Apollo.MutationFunction<CopyMultipleMaterialStandardsMutation_, CopyMultipleMaterialStandardsMutationVariables_>;

/**
 * __useCopyMultipleMaterialStandardsMutation__
 *
 * To run a mutation, you first call `useCopyMultipleMaterialStandardsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyMultipleMaterialStandardsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyMultipleMaterialStandardsMutation, { data, loading, error }] = useCopyMultipleMaterialStandardsMutation({
 *   variables: {
 *      materialStandards: // value for 'materialStandards'
 *   },
 * });
 */
export function useCopyMultipleMaterialStandardsMutation(baseOptions?: Apollo.MutationHookOptions<CopyMultipleMaterialStandardsMutation_, CopyMultipleMaterialStandardsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyMultipleMaterialStandardsMutation_, CopyMultipleMaterialStandardsMutationVariables_>(CopyMultipleMaterialStandardsDocument_, options);
      }
export type CopyMultipleMaterialStandardsMutationHookResult = ReturnType<typeof useCopyMultipleMaterialStandardsMutation>;
export type CopyMultipleMaterialStandardsMutationResult_ = Apollo.MutationResult<CopyMultipleMaterialStandardsMutation_>;
export type CopyMultipleMaterialStandardsMutationOptions_ = Apollo.BaseMutationOptions<CopyMultipleMaterialStandardsMutation_, CopyMultipleMaterialStandardsMutationVariables_>;
export const UpsertBulkTagsMaterialMetricsDocument_ = gql`
    mutation upsertBulkTagsMaterialMetrics($objects: [esrs_MaterialMetric_insert_input!]!) {
  insert_esrs_MaterialMetric(
    objects: $objects
    on_conflict: {constraint: MaterialMetric_pkey, update_columns: [isHidden]}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type UpsertBulkTagsMaterialMetricsMutationFn_ = Apollo.MutationFunction<UpsertBulkTagsMaterialMetricsMutation_, UpsertBulkTagsMaterialMetricsMutationVariables_>;

/**
 * __useUpsertBulkTagsMaterialMetricsMutation__
 *
 * To run a mutation, you first call `useUpsertBulkTagsMaterialMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBulkTagsMaterialMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBulkTagsMaterialMetricsMutation, { data, loading, error }] = useUpsertBulkTagsMaterialMetricsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertBulkTagsMaterialMetricsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertBulkTagsMaterialMetricsMutation_, UpsertBulkTagsMaterialMetricsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertBulkTagsMaterialMetricsMutation_, UpsertBulkTagsMaterialMetricsMutationVariables_>(UpsertBulkTagsMaterialMetricsDocument_, options);
      }
export type UpsertBulkTagsMaterialMetricsMutationHookResult = ReturnType<typeof useUpsertBulkTagsMaterialMetricsMutation>;
export type UpsertBulkTagsMaterialMetricsMutationResult_ = Apollo.MutationResult<UpsertBulkTagsMaterialMetricsMutation_>;
export type UpsertBulkTagsMaterialMetricsMutationOptions_ = Apollo.BaseMutationOptions<UpsertBulkTagsMaterialMetricsMutation_, UpsertBulkTagsMaterialMetricsMutationVariables_>;
export const GetMaterialStandardDocument_ = gql`
    query getMaterialStandard($assessmentId: uuid!, $standardRef: String!) {
  materialityAssessment: esrs_MaterialStandard(
    where: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}
  ) {
    id
    isMaterial
    isDataGatheringOnly
    isPhasedIn
    materialMetrics(
      order_by: [{metric: {globalOrder: asc}}, {metric: {isAR: asc}}, {metric: {order: asc}}, {metric: {firstLevel: asc}}, {metric: {secondLevel: asc}}]
    ) {
      id
      metricRef
      dataCollection
      isDataGatheringOnly
      isMaterial
      isPhasedIn
      materialMetricTags {
        ...MaterialMetricTagFields
      }
      metric {
        reference
        disclosureRequirementRef
        requirement {
          reference
          frameworkRef
        }
        isAssessable
        childrenMetricsCount
        ...MetricMFDisclosureRequirementsFragment
        parentMetrics {
          parentMetric {
            tags {
              type
              isOptional
              tagType {
                type
                alwaysAll
                tagValues(order_by: [{order: asc}, {value: asc}]) {
                  value
                }
              }
            }
          }
        }
        description
        tags {
          type
          isOptional
          tagType {
            type
            alwaysAll
            tagValues(order_by: [{order: asc}, {value: asc}]) {
              value
            }
          }
        }
      }
    }
    esrsAssessment {
      id
      onboardingStep
      parentData: parentAssessment {
        id
        materialStandards(where: {standardRef: {_eq: $standardRef}}) {
          id
          standardRef
          isMaterial
          materialMetrics(
            order_by: [{metric: {globalOrder: asc}}, {metric: {isAR: asc}}, {metric: {order: asc}}, {metric: {firstLevel: asc}}, {metric: {secondLevel: asc}}]
          ) {
            id
            metricRef
            isMaterial
            dataCollection
            materialMetricTags {
              ...MaterialMetricTagFields
            }
            metric {
              reference
              childrenMetricsCount
              tags {
                type
              }
            }
          }
        }
      }
    }
    noteHistory {
      ...NoteHistory
    }
    attachmentBox {
      ...AttachmentBox
    }
  }
}
    ${MaterialMetricTagFieldsFragmentDoc_}
${MetricMfDisclosureRequirementsFragmentFragmentDoc_}
${NoteHistoryFragmentDoc_}
${AttachmentBoxFragmentDoc_}`;

/**
 * __useGetMaterialStandardQuery__
 *
 * To run a query within a React component, call `useGetMaterialStandardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialStandardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialStandardQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      standardRef: // value for 'standardRef'
 *   },
 * });
 */
export function useGetMaterialStandardQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialStandardQuery_, GetMaterialStandardQueryVariables_> & ({ variables: GetMaterialStandardQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialStandardQuery_, GetMaterialStandardQueryVariables_>(GetMaterialStandardDocument_, options);
      }
export function useGetMaterialStandardLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialStandardQuery_, GetMaterialStandardQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialStandardQuery_, GetMaterialStandardQueryVariables_>(GetMaterialStandardDocument_, options);
        }
export function useGetMaterialStandardSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaterialStandardQuery_, GetMaterialStandardQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaterialStandardQuery_, GetMaterialStandardQueryVariables_>(GetMaterialStandardDocument_, options);
        }
export type GetMaterialStandardQueryHookResult = ReturnType<typeof useGetMaterialStandardQuery>;
export type GetMaterialStandardLazyQuery_HookResult = ReturnType<typeof useGetMaterialStandardLazyQuery_>;
export type GetMaterialStandardSuspenseQuery_HookResult = ReturnType<typeof useGetMaterialStandardSuspenseQuery_>;
export type GetMaterialStandardQueryResult_ = Apollo.QueryResult<GetMaterialStandardQuery_, GetMaterialStandardQueryVariables_>;
export function refetchGetMaterialStandardQuery_(variables: GetMaterialStandardQueryVariables_) {
      return { query: GetMaterialStandardDocument_, variables: variables }
    }
export const GetParentMaterialityAssessmentDocument_ = gql`
    query getParentMaterialityAssessment($childAssessmentId: uuid!) {
  EsrsAssessment_by_pk(id: $childAssessmentId) {
    id
    parentAssessment {
      id
      materialStandards {
        id
        isMaterial
        isDataGatheringOnly
        standardRef
        isPhasedIn
        standard {
          categoryRef
        }
        materialMetrics {
          id
          metricRef
          isMaterial
          isPhasedIn
          dataCollection
          isDataGatheringOnly
          frequency
          metric {
            reference
            isAssessable
            disclosureRequirementRef
            requirement {
              reference
              type
              frameworkRef
            }
            ...MetricMFDisclosureRequirementsFragment
            childrenMetricsCount
            childrenMetrics {
              childMetricRef
            }
          }
        }
      }
    }
  }
}
    ${MetricMfDisclosureRequirementsFragmentFragmentDoc_}`;

/**
 * __useGetParentMaterialityAssessmentQuery__
 *
 * To run a query within a React component, call `useGetParentMaterialityAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentMaterialityAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentMaterialityAssessmentQuery({
 *   variables: {
 *      childAssessmentId: // value for 'childAssessmentId'
 *   },
 * });
 */
export function useGetParentMaterialityAssessmentQuery(baseOptions: Apollo.QueryHookOptions<GetParentMaterialityAssessmentQuery_, GetParentMaterialityAssessmentQueryVariables_> & ({ variables: GetParentMaterialityAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParentMaterialityAssessmentQuery_, GetParentMaterialityAssessmentQueryVariables_>(GetParentMaterialityAssessmentDocument_, options);
      }
export function useGetParentMaterialityAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetParentMaterialityAssessmentQuery_, GetParentMaterialityAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParentMaterialityAssessmentQuery_, GetParentMaterialityAssessmentQueryVariables_>(GetParentMaterialityAssessmentDocument_, options);
        }
export function useGetParentMaterialityAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParentMaterialityAssessmentQuery_, GetParentMaterialityAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParentMaterialityAssessmentQuery_, GetParentMaterialityAssessmentQueryVariables_>(GetParentMaterialityAssessmentDocument_, options);
        }
export type GetParentMaterialityAssessmentQueryHookResult = ReturnType<typeof useGetParentMaterialityAssessmentQuery>;
export type GetParentMaterialityAssessmentLazyQuery_HookResult = ReturnType<typeof useGetParentMaterialityAssessmentLazyQuery_>;
export type GetParentMaterialityAssessmentSuspenseQuery_HookResult = ReturnType<typeof useGetParentMaterialityAssessmentSuspenseQuery_>;
export type GetParentMaterialityAssessmentQueryResult_ = Apollo.QueryResult<GetParentMaterialityAssessmentQuery_, GetParentMaterialityAssessmentQueryVariables_>;
export function refetchGetParentMaterialityAssessmentQuery_(variables: GetParentMaterialityAssessmentQueryVariables_) {
      return { query: GetParentMaterialityAssessmentDocument_, variables: variables }
    }
export const GetParentMaterialityDocument_ = gql`
    query getParentMateriality($assessmentId: uuid!, $standardRef: String!) {
  materialityAssessment: esrs_MaterialStandard(
    where: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}
  ) {
    id
    standardRef
    isDataGatheringOnly
    esrsAssessment {
      id
      reportingYear
      parentData: parentAssessment {
        id
        materialStandards(where: {standardRef: {_eq: $standardRef}}) {
          id
          standardRef
        }
      }
    }
    standard {
      frameworkRef
    }
  }
}
    `;

/**
 * __useGetParentMaterialityQuery__
 *
 * To run a query within a React component, call `useGetParentMaterialityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentMaterialityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentMaterialityQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      standardRef: // value for 'standardRef'
 *   },
 * });
 */
export function useGetParentMaterialityQuery(baseOptions: Apollo.QueryHookOptions<GetParentMaterialityQuery_, GetParentMaterialityQueryVariables_> & ({ variables: GetParentMaterialityQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParentMaterialityQuery_, GetParentMaterialityQueryVariables_>(GetParentMaterialityDocument_, options);
      }
export function useGetParentMaterialityLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetParentMaterialityQuery_, GetParentMaterialityQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParentMaterialityQuery_, GetParentMaterialityQueryVariables_>(GetParentMaterialityDocument_, options);
        }
export function useGetParentMaterialitySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParentMaterialityQuery_, GetParentMaterialityQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParentMaterialityQuery_, GetParentMaterialityQueryVariables_>(GetParentMaterialityDocument_, options);
        }
export type GetParentMaterialityQueryHookResult = ReturnType<typeof useGetParentMaterialityQuery>;
export type GetParentMaterialityLazyQuery_HookResult = ReturnType<typeof useGetParentMaterialityLazyQuery_>;
export type GetParentMaterialitySuspenseQuery_HookResult = ReturnType<typeof useGetParentMaterialitySuspenseQuery_>;
export type GetParentMaterialityQueryResult_ = Apollo.QueryResult<GetParentMaterialityQuery_, GetParentMaterialityQueryVariables_>;
export function refetchGetParentMaterialityQuery_(variables: GetParentMaterialityQueryVariables_) {
      return { query: GetParentMaterialityDocument_, variables: variables }
    }
export const GetMaterialStandardsForSubsidiariesDocument_ = gql`
    query getMaterialStandardsForSubsidiaries($groupAssessmentId: uuid!) {
  EsrsAssessment_by_pk(id: $groupAssessmentId) {
    id
    subsidiaryAssessments {
      id
      materialStandards(
        where: {isMaterial: {_eq: true}, isDataGatheringOnly: {_eq: false}}
      ) {
        id
        isMaterial
        standardRef
      }
    }
    allAssessments: subsidiaryAssessments {
      id
      materialStandards {
        id
        isMaterial
        standardRef
      }
    }
  }
}
    `;

/**
 * __useGetMaterialStandardsForSubsidiariesQuery__
 *
 * To run a query within a React component, call `useGetMaterialStandardsForSubsidiariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialStandardsForSubsidiariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialStandardsForSubsidiariesQuery({
 *   variables: {
 *      groupAssessmentId: // value for 'groupAssessmentId'
 *   },
 * });
 */
export function useGetMaterialStandardsForSubsidiariesQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialStandardsForSubsidiariesQuery_, GetMaterialStandardsForSubsidiariesQueryVariables_> & ({ variables: GetMaterialStandardsForSubsidiariesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialStandardsForSubsidiariesQuery_, GetMaterialStandardsForSubsidiariesQueryVariables_>(GetMaterialStandardsForSubsidiariesDocument_, options);
      }
export function useGetMaterialStandardsForSubsidiariesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialStandardsForSubsidiariesQuery_, GetMaterialStandardsForSubsidiariesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialStandardsForSubsidiariesQuery_, GetMaterialStandardsForSubsidiariesQueryVariables_>(GetMaterialStandardsForSubsidiariesDocument_, options);
        }
export function useGetMaterialStandardsForSubsidiariesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaterialStandardsForSubsidiariesQuery_, GetMaterialStandardsForSubsidiariesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaterialStandardsForSubsidiariesQuery_, GetMaterialStandardsForSubsidiariesQueryVariables_>(GetMaterialStandardsForSubsidiariesDocument_, options);
        }
export type GetMaterialStandardsForSubsidiariesQueryHookResult = ReturnType<typeof useGetMaterialStandardsForSubsidiariesQuery>;
export type GetMaterialStandardsForSubsidiariesLazyQuery_HookResult = ReturnType<typeof useGetMaterialStandardsForSubsidiariesLazyQuery_>;
export type GetMaterialStandardsForSubsidiariesSuspenseQuery_HookResult = ReturnType<typeof useGetMaterialStandardsForSubsidiariesSuspenseQuery_>;
export type GetMaterialStandardsForSubsidiariesQueryResult_ = Apollo.QueryResult<GetMaterialStandardsForSubsidiariesQuery_, GetMaterialStandardsForSubsidiariesQueryVariables_>;
export function refetchGetMaterialStandardsForSubsidiariesQuery_(variables: GetMaterialStandardsForSubsidiariesQueryVariables_) {
      return { query: GetMaterialStandardsForSubsidiariesDocument_, variables: variables }
    }
export const GetDrMaterialMetricsDocument_ = gql`
    query getDrMaterialMetrics($drRef: String!) {
  esrs_MaterialMetric(where: {metric: {requirement: {reference: {_eq: $drRef}}}}) {
    metricRef
    isMaterial
    isDataGatheringOnly
  }
}
    `;

/**
 * __useGetDrMaterialMetricsQuery__
 *
 * To run a query within a React component, call `useGetDrMaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrMaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrMaterialMetricsQuery({
 *   variables: {
 *      drRef: // value for 'drRef'
 *   },
 * });
 */
export function useGetDrMaterialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetDrMaterialMetricsQuery_, GetDrMaterialMetricsQueryVariables_> & ({ variables: GetDrMaterialMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDrMaterialMetricsQuery_, GetDrMaterialMetricsQueryVariables_>(GetDrMaterialMetricsDocument_, options);
      }
export function useGetDrMaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDrMaterialMetricsQuery_, GetDrMaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDrMaterialMetricsQuery_, GetDrMaterialMetricsQueryVariables_>(GetDrMaterialMetricsDocument_, options);
        }
export function useGetDrMaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDrMaterialMetricsQuery_, GetDrMaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDrMaterialMetricsQuery_, GetDrMaterialMetricsQueryVariables_>(GetDrMaterialMetricsDocument_, options);
        }
export type GetDrMaterialMetricsQueryHookResult = ReturnType<typeof useGetDrMaterialMetricsQuery>;
export type GetDrMaterialMetricsLazyQuery_HookResult = ReturnType<typeof useGetDrMaterialMetricsLazyQuery_>;
export type GetDrMaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetDrMaterialMetricsSuspenseQuery_>;
export type GetDrMaterialMetricsQueryResult_ = Apollo.QueryResult<GetDrMaterialMetricsQuery_, GetDrMaterialMetricsQueryVariables_>;
export function refetchGetDrMaterialMetricsQuery_(variables: GetDrMaterialMetricsQueryVariables_) {
      return { query: GetDrMaterialMetricsDocument_, variables: variables }
    }
export const GetTargetMetricsDocument_ = gql`
    query getTargetMetrics($standardRef: String!, $companyAssessmentId: uuid!, $parentAssessmentId: uuid!) {
  metrics: EsrsMetric(
    order_by: [{requirement: {order: asc}}, {globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
    where: {requirement: {group: {standardRef: {_eq: $standardRef}}}, canBeUsedForTarget: {_eq: true}, materialMetrics: {materialStandard: {_or: [{id: {_eq: $companyAssessmentId}}, {id: {_eq: $parentAssessmentId}}], isMaterial: {_eq: true}}}}
  ) {
    title
    reference
    unitOfMeasurement
    description
    calculation
  }
}
    `;

/**
 * __useGetTargetMetricsQuery__
 *
 * To run a query within a React component, call `useGetTargetMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetMetricsQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *      companyAssessmentId: // value for 'companyAssessmentId'
 *      parentAssessmentId: // value for 'parentAssessmentId'
 *   },
 * });
 */
export function useGetTargetMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetTargetMetricsQuery_, GetTargetMetricsQueryVariables_> & ({ variables: GetTargetMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTargetMetricsQuery_, GetTargetMetricsQueryVariables_>(GetTargetMetricsDocument_, options);
      }
export function useGetTargetMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetTargetMetricsQuery_, GetTargetMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTargetMetricsQuery_, GetTargetMetricsQueryVariables_>(GetTargetMetricsDocument_, options);
        }
export function useGetTargetMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTargetMetricsQuery_, GetTargetMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTargetMetricsQuery_, GetTargetMetricsQueryVariables_>(GetTargetMetricsDocument_, options);
        }
export type GetTargetMetricsQueryHookResult = ReturnType<typeof useGetTargetMetricsQuery>;
export type GetTargetMetricsLazyQuery_HookResult = ReturnType<typeof useGetTargetMetricsLazyQuery_>;
export type GetTargetMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetTargetMetricsSuspenseQuery_>;
export type GetTargetMetricsQueryResult_ = Apollo.QueryResult<GetTargetMetricsQuery_, GetTargetMetricsQueryVariables_>;
export function refetchGetTargetMetricsQuery_(variables: GetTargetMetricsQueryVariables_) {
      return { query: GetTargetMetricsDocument_, variables: variables }
    }
export const GetSetTargetMetricsDocument_ = gql`
    query getSetTargetMetrics($companyAssessmentId: uuid!, $requiredMetrics: [String!]!) {
  metrics: EsrsMetric(
    order_by: [{requirement: {order: asc}}, {globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
    where: {canBeUsedForTarget: {_eq: true}, _or: [{reference: {_in: $requiredMetrics}}, {view_childrenMetrics: {childMetricRef: {_in: $requiredMetrics}}}]}
  ) {
    title
    reference
    unitOfMeasurement
    description
    calculation
    materialMetrics(
      where: {materialStandard: {id: {_eq: $companyAssessmentId}}, isMaterial: {_eq: true}}
    ) {
      dataCollection
      isMaterial
    }
  }
}
    `;

/**
 * __useGetSetTargetMetricsQuery__
 *
 * To run a query within a React component, call `useGetSetTargetMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSetTargetMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSetTargetMetricsQuery({
 *   variables: {
 *      companyAssessmentId: // value for 'companyAssessmentId'
 *      requiredMetrics: // value for 'requiredMetrics'
 *   },
 * });
 */
export function useGetSetTargetMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetSetTargetMetricsQuery_, GetSetTargetMetricsQueryVariables_> & ({ variables: GetSetTargetMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSetTargetMetricsQuery_, GetSetTargetMetricsQueryVariables_>(GetSetTargetMetricsDocument_, options);
      }
export function useGetSetTargetMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSetTargetMetricsQuery_, GetSetTargetMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSetTargetMetricsQuery_, GetSetTargetMetricsQueryVariables_>(GetSetTargetMetricsDocument_, options);
        }
export function useGetSetTargetMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSetTargetMetricsQuery_, GetSetTargetMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSetTargetMetricsQuery_, GetSetTargetMetricsQueryVariables_>(GetSetTargetMetricsDocument_, options);
        }
export type GetSetTargetMetricsQueryHookResult = ReturnType<typeof useGetSetTargetMetricsQuery>;
export type GetSetTargetMetricsLazyQuery_HookResult = ReturnType<typeof useGetSetTargetMetricsLazyQuery_>;
export type GetSetTargetMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetSetTargetMetricsSuspenseQuery_>;
export type GetSetTargetMetricsQueryResult_ = Apollo.QueryResult<GetSetTargetMetricsQuery_, GetSetTargetMetricsQueryVariables_>;
export function refetchGetSetTargetMetricsQuery_(variables: GetSetTargetMetricsQueryVariables_) {
      return { query: GetSetTargetMetricsDocument_, variables: variables }
    }
export const GetMaterialMetricByIdDocument_ = gql`
    query getMaterialMetricById($materialMetricId: uuid!) {
  esrs_MaterialMetric_by_pk(id: $materialMetricId) {
    id
    frequency
    dataCollection
    isMaterial
    metricRef
    metric {
      tags {
        type
        isOptional
      }
      description
      metricType
      title
      reference
    }
    materialMetricTags {
      isOptional
      metricTagType {
        type
        tagValues(order_by: [{order: asc}, {value: asc}]) {
          type
          value
        }
      }
      materialTagValues(order_by: [{tag: {order: asc}}, {tag: {value: asc}}]) {
        tagValue
      }
    }
  }
}
    `;

/**
 * __useGetMaterialMetricByIdQuery__
 *
 * To run a query within a React component, call `useGetMaterialMetricByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialMetricByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialMetricByIdQuery({
 *   variables: {
 *      materialMetricId: // value for 'materialMetricId'
 *   },
 * });
 */
export function useGetMaterialMetricByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialMetricByIdQuery_, GetMaterialMetricByIdQueryVariables_> & ({ variables: GetMaterialMetricByIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialMetricByIdQuery_, GetMaterialMetricByIdQueryVariables_>(GetMaterialMetricByIdDocument_, options);
      }
export function useGetMaterialMetricByIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialMetricByIdQuery_, GetMaterialMetricByIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialMetricByIdQuery_, GetMaterialMetricByIdQueryVariables_>(GetMaterialMetricByIdDocument_, options);
        }
export function useGetMaterialMetricByIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaterialMetricByIdQuery_, GetMaterialMetricByIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaterialMetricByIdQuery_, GetMaterialMetricByIdQueryVariables_>(GetMaterialMetricByIdDocument_, options);
        }
export type GetMaterialMetricByIdQueryHookResult = ReturnType<typeof useGetMaterialMetricByIdQuery>;
export type GetMaterialMetricByIdLazyQuery_HookResult = ReturnType<typeof useGetMaterialMetricByIdLazyQuery_>;
export type GetMaterialMetricByIdSuspenseQuery_HookResult = ReturnType<typeof useGetMaterialMetricByIdSuspenseQuery_>;
export type GetMaterialMetricByIdQueryResult_ = Apollo.QueryResult<GetMaterialMetricByIdQuery_, GetMaterialMetricByIdQueryVariables_>;
export function refetchGetMaterialMetricByIdQuery_(variables: GetMaterialMetricByIdQueryVariables_) {
      return { query: GetMaterialMetricByIdDocument_, variables: variables }
    }
export const GetAssessmentMaterialStandardsDocument_ = gql`
    query getAssessmentMaterialStandards($esrsAssessmentId: uuid!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    materialStandards(where: {isMaterial: {_eq: true}}) {
      standardRef
      standard {
        categoryRef
      }
      materialMetrics(where: {isMaterial: {_eq: true}}) {
        metricRef
        dataCollection
      }
    }
  }
}
    `;

/**
 * __useGetAssessmentMaterialStandardsQuery__
 *
 * To run a query within a React component, call `useGetAssessmentMaterialStandardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentMaterialStandardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentMaterialStandardsQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetAssessmentMaterialStandardsQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentMaterialStandardsQuery_, GetAssessmentMaterialStandardsQueryVariables_> & ({ variables: GetAssessmentMaterialStandardsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentMaterialStandardsQuery_, GetAssessmentMaterialStandardsQueryVariables_>(GetAssessmentMaterialStandardsDocument_, options);
      }
export function useGetAssessmentMaterialStandardsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentMaterialStandardsQuery_, GetAssessmentMaterialStandardsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentMaterialStandardsQuery_, GetAssessmentMaterialStandardsQueryVariables_>(GetAssessmentMaterialStandardsDocument_, options);
        }
export function useGetAssessmentMaterialStandardsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentMaterialStandardsQuery_, GetAssessmentMaterialStandardsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentMaterialStandardsQuery_, GetAssessmentMaterialStandardsQueryVariables_>(GetAssessmentMaterialStandardsDocument_, options);
        }
export type GetAssessmentMaterialStandardsQueryHookResult = ReturnType<typeof useGetAssessmentMaterialStandardsQuery>;
export type GetAssessmentMaterialStandardsLazyQuery_HookResult = ReturnType<typeof useGetAssessmentMaterialStandardsLazyQuery_>;
export type GetAssessmentMaterialStandardsSuspenseQuery_HookResult = ReturnType<typeof useGetAssessmentMaterialStandardsSuspenseQuery_>;
export type GetAssessmentMaterialStandardsQueryResult_ = Apollo.QueryResult<GetAssessmentMaterialStandardsQuery_, GetAssessmentMaterialStandardsQueryVariables_>;
export function refetchGetAssessmentMaterialStandardsQuery_(variables: GetAssessmentMaterialStandardsQueryVariables_) {
      return { query: GetAssessmentMaterialStandardsDocument_, variables: variables }
    }
export const GetAssessmentEsrs2MaterialMetricsDocument_ = gql`
    query getAssessmentESRS2MaterialMetrics($esrsAssessmentId: uuid!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    materialStandards(where: {standardRef: {_eq: "ESRS-2"}}) {
      id
      materialMetrics {
        id
      }
    }
  }
}
    `;

/**
 * __useGetAssessmentEsrs2MaterialMetricsQuery__
 *
 * To run a query within a React component, call `useGetAssessmentEsrs2MaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentEsrs2MaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentEsrs2MaterialMetricsQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetAssessmentEsrs2MaterialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentEsrs2MaterialMetricsQuery_, GetAssessmentEsrs2MaterialMetricsQueryVariables_> & ({ variables: GetAssessmentEsrs2MaterialMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentEsrs2MaterialMetricsQuery_, GetAssessmentEsrs2MaterialMetricsQueryVariables_>(GetAssessmentEsrs2MaterialMetricsDocument_, options);
      }
export function useGetAssessmentEsrs2MaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentEsrs2MaterialMetricsQuery_, GetAssessmentEsrs2MaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentEsrs2MaterialMetricsQuery_, GetAssessmentEsrs2MaterialMetricsQueryVariables_>(GetAssessmentEsrs2MaterialMetricsDocument_, options);
        }
export function useGetAssessmentEsrs2MaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentEsrs2MaterialMetricsQuery_, GetAssessmentEsrs2MaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentEsrs2MaterialMetricsQuery_, GetAssessmentEsrs2MaterialMetricsQueryVariables_>(GetAssessmentEsrs2MaterialMetricsDocument_, options);
        }
export type GetAssessmentEsrs2MaterialMetricsQueryHookResult = ReturnType<typeof useGetAssessmentEsrs2MaterialMetricsQuery>;
export type GetAssessmentEsrs2MaterialMetricsLazyQuery_HookResult = ReturnType<typeof useGetAssessmentEsrs2MaterialMetricsLazyQuery_>;
export type GetAssessmentEsrs2MaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetAssessmentEsrs2MaterialMetricsSuspenseQuery_>;
export type GetAssessmentEsrs2MaterialMetricsQueryResult_ = Apollo.QueryResult<GetAssessmentEsrs2MaterialMetricsQuery_, GetAssessmentEsrs2MaterialMetricsQueryVariables_>;
export function refetchGetAssessmentEsrs2MaterialMetricsQuery_(variables: GetAssessmentEsrs2MaterialMetricsQueryVariables_) {
      return { query: GetAssessmentEsrs2MaterialMetricsDocument_, variables: variables }
    }
export const InsertSubsidiariesMaterialStandardDocument_ = gql`
    mutation insertSubsidiariesMaterialStandard($materialStandards: [esrs_MaterialStandard_insert_input!]!) {
  insert_esrs_MaterialStandard(
    objects: $materialStandards
    on_conflict: {constraint: MaterialStandard_standardRef_assessmentId_key, update_columns: []}
  ) {
    affected_rows
    returning {
      id
      assessmentId
    }
  }
}
    `;
export type InsertSubsidiariesMaterialStandardMutationFn_ = Apollo.MutationFunction<InsertSubsidiariesMaterialStandardMutation_, InsertSubsidiariesMaterialStandardMutationVariables_>;

/**
 * __useInsertSubsidiariesMaterialStandardMutation__
 *
 * To run a mutation, you first call `useInsertSubsidiariesMaterialStandardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSubsidiariesMaterialStandardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSubsidiariesMaterialStandardMutation, { data, loading, error }] = useInsertSubsidiariesMaterialStandardMutation({
 *   variables: {
 *      materialStandards: // value for 'materialStandards'
 *   },
 * });
 */
export function useInsertSubsidiariesMaterialStandardMutation(baseOptions?: Apollo.MutationHookOptions<InsertSubsidiariesMaterialStandardMutation_, InsertSubsidiariesMaterialStandardMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertSubsidiariesMaterialStandardMutation_, InsertSubsidiariesMaterialStandardMutationVariables_>(InsertSubsidiariesMaterialStandardDocument_, options);
      }
export type InsertSubsidiariesMaterialStandardMutationHookResult = ReturnType<typeof useInsertSubsidiariesMaterialStandardMutation>;
export type InsertSubsidiariesMaterialStandardMutationResult_ = Apollo.MutationResult<InsertSubsidiariesMaterialStandardMutation_>;
export type InsertSubsidiariesMaterialStandardMutationOptions_ = Apollo.BaseMutationOptions<InsertSubsidiariesMaterialStandardMutation_, InsertSubsidiariesMaterialStandardMutationVariables_>;
export const InsertSubsidiariesMaterialMetricsDocument_ = gql`
    mutation insertSubsidiariesMaterialMetrics($materialMetrics: [esrs_MaterialMetric_insert_input!]!) {
  insert_esrs_MaterialMetric(
    objects: $materialMetrics
    on_conflict: {constraint: MaterialMetric_materialStandardId_metricRef_key, update_columns: []}
  ) {
    returning {
      id
      metricRef
    }
  }
}
    `;
export type InsertSubsidiariesMaterialMetricsMutationFn_ = Apollo.MutationFunction<InsertSubsidiariesMaterialMetricsMutation_, InsertSubsidiariesMaterialMetricsMutationVariables_>;

/**
 * __useInsertSubsidiariesMaterialMetricsMutation__
 *
 * To run a mutation, you first call `useInsertSubsidiariesMaterialMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertSubsidiariesMaterialMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertSubsidiariesMaterialMetricsMutation, { data, loading, error }] = useInsertSubsidiariesMaterialMetricsMutation({
 *   variables: {
 *      materialMetrics: // value for 'materialMetrics'
 *   },
 * });
 */
export function useInsertSubsidiariesMaterialMetricsMutation(baseOptions?: Apollo.MutationHookOptions<InsertSubsidiariesMaterialMetricsMutation_, InsertSubsidiariesMaterialMetricsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertSubsidiariesMaterialMetricsMutation_, InsertSubsidiariesMaterialMetricsMutationVariables_>(InsertSubsidiariesMaterialMetricsDocument_, options);
      }
export type InsertSubsidiariesMaterialMetricsMutationHookResult = ReturnType<typeof useInsertSubsidiariesMaterialMetricsMutation>;
export type InsertSubsidiariesMaterialMetricsMutationResult_ = Apollo.MutationResult<InsertSubsidiariesMaterialMetricsMutation_>;
export type InsertSubsidiariesMaterialMetricsMutationOptions_ = Apollo.BaseMutationOptions<InsertSubsidiariesMaterialMetricsMutation_, InsertSubsidiariesMaterialMetricsMutationVariables_>;
export const UpdateSubsidiariesMaterialityDocument_ = gql`
    mutation updateSubsidiariesMateriality($id: uuid!) {
  update_esrs_MaterialStandard_by_pk(
    pk_columns: {id: $id}
    _set: {updateSubsidiaries: true}
  ) {
    id
  }
}
    `;
export type UpdateSubsidiariesMaterialityMutationFn_ = Apollo.MutationFunction<UpdateSubsidiariesMaterialityMutation_, UpdateSubsidiariesMaterialityMutationVariables_>;

/**
 * __useUpdateSubsidiariesMaterialityMutation__
 *
 * To run a mutation, you first call `useUpdateSubsidiariesMaterialityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubsidiariesMaterialityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubsidiariesMaterialityMutation, { data, loading, error }] = useUpdateSubsidiariesMaterialityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateSubsidiariesMaterialityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubsidiariesMaterialityMutation_, UpdateSubsidiariesMaterialityMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubsidiariesMaterialityMutation_, UpdateSubsidiariesMaterialityMutationVariables_>(UpdateSubsidiariesMaterialityDocument_, options);
      }
export type UpdateSubsidiariesMaterialityMutationHookResult = ReturnType<typeof useUpdateSubsidiariesMaterialityMutation>;
export type UpdateSubsidiariesMaterialityMutationResult_ = Apollo.MutationResult<UpdateSubsidiariesMaterialityMutation_>;
export type UpdateSubsidiariesMaterialityMutationOptions_ = Apollo.BaseMutationOptions<UpdateSubsidiariesMaterialityMutation_, UpdateSubsidiariesMaterialityMutationVariables_>;
export const UpdateManySubsidiariesMaterialityDocument_ = gql`
    mutation updateManySubsidiariesMateriality($ids: [uuid!]!) {
  update_esrs_MaterialStandard_many(
    updates: {where: {id: {_in: $ids}}, _set: {updateSubsidiaries: true}}
  ) {
    affected_rows
  }
}
    `;
export type UpdateManySubsidiariesMaterialityMutationFn_ = Apollo.MutationFunction<UpdateManySubsidiariesMaterialityMutation_, UpdateManySubsidiariesMaterialityMutationVariables_>;

/**
 * __useUpdateManySubsidiariesMaterialityMutation__
 *
 * To run a mutation, you first call `useUpdateManySubsidiariesMaterialityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManySubsidiariesMaterialityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManySubsidiariesMaterialityMutation, { data, loading, error }] = useUpdateManySubsidiariesMaterialityMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUpdateManySubsidiariesMaterialityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManySubsidiariesMaterialityMutation_, UpdateManySubsidiariesMaterialityMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManySubsidiariesMaterialityMutation_, UpdateManySubsidiariesMaterialityMutationVariables_>(UpdateManySubsidiariesMaterialityDocument_, options);
      }
export type UpdateManySubsidiariesMaterialityMutationHookResult = ReturnType<typeof useUpdateManySubsidiariesMaterialityMutation>;
export type UpdateManySubsidiariesMaterialityMutationResult_ = Apollo.MutationResult<UpdateManySubsidiariesMaterialityMutation_>;
export type UpdateManySubsidiariesMaterialityMutationOptions_ = Apollo.BaseMutationOptions<UpdateManySubsidiariesMaterialityMutation_, UpdateManySubsidiariesMaterialityMutationVariables_>;
export const SwitchOffUpdateSubsidiariesDocument_ = gql`
    mutation switchOffUpdateSubsidiaries($id: uuid!) {
  update_esrs_MaterialStandard_by_pk(
    pk_columns: {id: $id}
    _set: {updateSubsidiaries: false}
  ) {
    id
  }
}
    `;
export type SwitchOffUpdateSubsidiariesMutationFn_ = Apollo.MutationFunction<SwitchOffUpdateSubsidiariesMutation_, SwitchOffUpdateSubsidiariesMutationVariables_>;

/**
 * __useSwitchOffUpdateSubsidiariesMutation__
 *
 * To run a mutation, you first call `useSwitchOffUpdateSubsidiariesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchOffUpdateSubsidiariesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchOffUpdateSubsidiariesMutation, { data, loading, error }] = useSwitchOffUpdateSubsidiariesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSwitchOffUpdateSubsidiariesMutation(baseOptions?: Apollo.MutationHookOptions<SwitchOffUpdateSubsidiariesMutation_, SwitchOffUpdateSubsidiariesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchOffUpdateSubsidiariesMutation_, SwitchOffUpdateSubsidiariesMutationVariables_>(SwitchOffUpdateSubsidiariesDocument_, options);
      }
export type SwitchOffUpdateSubsidiariesMutationHookResult = ReturnType<typeof useSwitchOffUpdateSubsidiariesMutation>;
export type SwitchOffUpdateSubsidiariesMutationResult_ = Apollo.MutationResult<SwitchOffUpdateSubsidiariesMutation_>;
export type SwitchOffUpdateSubsidiariesMutationOptions_ = Apollo.BaseMutationOptions<SwitchOffUpdateSubsidiariesMutation_, SwitchOffUpdateSubsidiariesMutationVariables_>;
export const InsertMaterialMetricTagsDocument_ = gql`
    mutation insertMaterialMetricTags($objects: [esrs_MaterialMetricTag_insert_input!]!) {
  insert_esrs_MaterialMetricTag(
    objects: $objects
    on_conflict: {constraint: MaterialMetricTag_materialMetricId_tagType_key, update_columns: []}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type InsertMaterialMetricTagsMutationFn_ = Apollo.MutationFunction<InsertMaterialMetricTagsMutation_, InsertMaterialMetricTagsMutationVariables_>;

/**
 * __useInsertMaterialMetricTagsMutation__
 *
 * To run a mutation, you first call `useInsertMaterialMetricTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertMaterialMetricTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertMaterialMetricTagsMutation, { data, loading, error }] = useInsertMaterialMetricTagsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertMaterialMetricTagsMutation(baseOptions?: Apollo.MutationHookOptions<InsertMaterialMetricTagsMutation_, InsertMaterialMetricTagsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertMaterialMetricTagsMutation_, InsertMaterialMetricTagsMutationVariables_>(InsertMaterialMetricTagsDocument_, options);
      }
export type InsertMaterialMetricTagsMutationHookResult = ReturnType<typeof useInsertMaterialMetricTagsMutation>;
export type InsertMaterialMetricTagsMutationResult_ = Apollo.MutationResult<InsertMaterialMetricTagsMutation_>;
export type InsertMaterialMetricTagsMutationOptions_ = Apollo.BaseMutationOptions<InsertMaterialMetricTagsMutation_, InsertMaterialMetricTagsMutationVariables_>;
export const UpdateEsrs2MaterialMetricsDocument_ = gql`
    mutation updateESRS2MaterialMetrics($materialMetricsIds: [uuid!]!, $isMaterial: Boolean) {
  update_esrs_MaterialMetric_many(
    updates: {where: {id: {_in: $materialMetricsIds}}, _set: {isMaterial: $isMaterial}}
  ) {
    affected_rows
  }
}
    `;
export type UpdateEsrs2MaterialMetricsMutationFn_ = Apollo.MutationFunction<UpdateEsrs2MaterialMetricsMutation_, UpdateEsrs2MaterialMetricsMutationVariables_>;

/**
 * __useUpdateEsrs2MaterialMetricsMutation__
 *
 * To run a mutation, you first call `useUpdateEsrs2MaterialMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsrs2MaterialMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsrs2MaterialMetricsMutation, { data, loading, error }] = useUpdateEsrs2MaterialMetricsMutation({
 *   variables: {
 *      materialMetricsIds: // value for 'materialMetricsIds'
 *      isMaterial: // value for 'isMaterial'
 *   },
 * });
 */
export function useUpdateEsrs2MaterialMetricsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsrs2MaterialMetricsMutation_, UpdateEsrs2MaterialMetricsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsrs2MaterialMetricsMutation_, UpdateEsrs2MaterialMetricsMutationVariables_>(UpdateEsrs2MaterialMetricsDocument_, options);
      }
export type UpdateEsrs2MaterialMetricsMutationHookResult = ReturnType<typeof useUpdateEsrs2MaterialMetricsMutation>;
export type UpdateEsrs2MaterialMetricsMutationResult_ = Apollo.MutationResult<UpdateEsrs2MaterialMetricsMutation_>;
export type UpdateEsrs2MaterialMetricsMutationOptions_ = Apollo.BaseMutationOptions<UpdateEsrs2MaterialMetricsMutation_, UpdateEsrs2MaterialMetricsMutationVariables_>;
export const UpdateEsrs2MaterialStandardDocument_ = gql`
    mutation updateESRS2MaterialStandard($materialStandardId: uuid!, $isMaterial: Boolean) {
  update_esrs_MaterialStandard_many(
    updates: {where: {id: {_eq: $materialStandardId}}, _set: {isMaterial: $isMaterial}}
  ) {
    affected_rows
  }
}
    `;
export type UpdateEsrs2MaterialStandardMutationFn_ = Apollo.MutationFunction<UpdateEsrs2MaterialStandardMutation_, UpdateEsrs2MaterialStandardMutationVariables_>;

/**
 * __useUpdateEsrs2MaterialStandardMutation__
 *
 * To run a mutation, you first call `useUpdateEsrs2MaterialStandardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsrs2MaterialStandardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsrs2MaterialStandardMutation, { data, loading, error }] = useUpdateEsrs2MaterialStandardMutation({
 *   variables: {
 *      materialStandardId: // value for 'materialStandardId'
 *      isMaterial: // value for 'isMaterial'
 *   },
 * });
 */
export function useUpdateEsrs2MaterialStandardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsrs2MaterialStandardMutation_, UpdateEsrs2MaterialStandardMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsrs2MaterialStandardMutation_, UpdateEsrs2MaterialStandardMutationVariables_>(UpdateEsrs2MaterialStandardDocument_, options);
      }
export type UpdateEsrs2MaterialStandardMutationHookResult = ReturnType<typeof useUpdateEsrs2MaterialStandardMutation>;
export type UpdateEsrs2MaterialStandardMutationResult_ = Apollo.MutationResult<UpdateEsrs2MaterialStandardMutation_>;
export type UpdateEsrs2MaterialStandardMutationOptions_ = Apollo.BaseMutationOptions<UpdateEsrs2MaterialStandardMutation_, UpdateEsrs2MaterialStandardMutationVariables_>;
export const GetAllMaterialStandardsByRefDocument_ = gql`
    query GetAllMaterialStandardsByRef($standardRef: String!) {
  esrs_MaterialStandard(where: {standardRef: {_eq: $standardRef}}) {
    id
    esrsAssessment {
      collectOnly
      company {
        isGroupOwner
      }
    }
  }
}
    `;

/**
 * __useGetAllMaterialStandardsByRefQuery__
 *
 * To run a query within a React component, call `useGetAllMaterialStandardsByRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMaterialStandardsByRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMaterialStandardsByRefQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *   },
 * });
 */
export function useGetAllMaterialStandardsByRefQuery(baseOptions: Apollo.QueryHookOptions<GetAllMaterialStandardsByRefQuery_, GetAllMaterialStandardsByRefQueryVariables_> & ({ variables: GetAllMaterialStandardsByRefQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMaterialStandardsByRefQuery_, GetAllMaterialStandardsByRefQueryVariables_>(GetAllMaterialStandardsByRefDocument_, options);
      }
export function useGetAllMaterialStandardsByRefLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMaterialStandardsByRefQuery_, GetAllMaterialStandardsByRefQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMaterialStandardsByRefQuery_, GetAllMaterialStandardsByRefQueryVariables_>(GetAllMaterialStandardsByRefDocument_, options);
        }
export function useGetAllMaterialStandardsByRefSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllMaterialStandardsByRefQuery_, GetAllMaterialStandardsByRefQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllMaterialStandardsByRefQuery_, GetAllMaterialStandardsByRefQueryVariables_>(GetAllMaterialStandardsByRefDocument_, options);
        }
export type GetAllMaterialStandardsByRefQueryHookResult = ReturnType<typeof useGetAllMaterialStandardsByRefQuery>;
export type GetAllMaterialStandardsByRefLazyQuery_HookResult = ReturnType<typeof useGetAllMaterialStandardsByRefLazyQuery_>;
export type GetAllMaterialStandardsByRefSuspenseQuery_HookResult = ReturnType<typeof useGetAllMaterialStandardsByRefSuspenseQuery_>;
export type GetAllMaterialStandardsByRefQueryResult_ = Apollo.QueryResult<GetAllMaterialStandardsByRefQuery_, GetAllMaterialStandardsByRefQueryVariables_>;
export function refetchGetAllMaterialStandardsByRefQuery_(variables: GetAllMaterialStandardsByRefQueryVariables_) {
      return { query: GetAllMaterialStandardsByRefDocument_, variables: variables }
    }
export const UpsertDatapointMdrmDocument_ = gql`
    mutation upsertDatapointMdrm($object: esrs_DatapointMdrm_insert_input!) {
  insert_esrs_DatapointMdrm_one(
    object: $object
    on_conflict: {constraint: DatapointMdrm_datapointId_mdrmRef_key, update_columns: [authorId, updated_at, ownerId, value, hasOptedOut, taskId]}
  ) {
    id
    datapointId
    mdrmRef
    hasOptedOut
    value
    thread {
      id
    }
  }
}
    `;
export type UpsertDatapointMdrmMutationFn_ = Apollo.MutationFunction<UpsertDatapointMdrmMutation_, UpsertDatapointMdrmMutationVariables_>;

/**
 * __useUpsertDatapointMdrmMutation__
 *
 * To run a mutation, you first call `useUpsertDatapointMdrmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDatapointMdrmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDatapointMdrmMutation, { data, loading, error }] = useUpsertDatapointMdrmMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpsertDatapointMdrmMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDatapointMdrmMutation_, UpsertDatapointMdrmMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDatapointMdrmMutation_, UpsertDatapointMdrmMutationVariables_>(UpsertDatapointMdrmDocument_, options);
      }
export type UpsertDatapointMdrmMutationHookResult = ReturnType<typeof useUpsertDatapointMdrmMutation>;
export type UpsertDatapointMdrmMutationResult_ = Apollo.MutationResult<UpsertDatapointMdrmMutation_>;
export type UpsertDatapointMdrmMutationOptions_ = Apollo.BaseMutationOptions<UpsertDatapointMdrmMutation_, UpsertDatapointMdrmMutationVariables_>;
export const UpsertMultipleMdrmDatapointsDocument_ = gql`
    mutation upsertMultipleMdrmDatapoints($objects: [esrs_DatapointMdrm_insert_input!]!) {
  insert_esrs_DatapointMdrm(
    objects: $objects
    on_conflict: {constraint: DatapointMdrm_datapointId_mdrmRef_key, update_columns: mdrmRef}
  ) {
    returning {
      mdrmRef
      datapointId
    }
  }
}
    `;
export type UpsertMultipleMdrmDatapointsMutationFn_ = Apollo.MutationFunction<UpsertMultipleMdrmDatapointsMutation_, UpsertMultipleMdrmDatapointsMutationVariables_>;

/**
 * __useUpsertMultipleMdrmDatapointsMutation__
 *
 * To run a mutation, you first call `useUpsertMultipleMdrmDatapointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMultipleMdrmDatapointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMultipleMdrmDatapointsMutation, { data, loading, error }] = useUpsertMultipleMdrmDatapointsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertMultipleMdrmDatapointsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMultipleMdrmDatapointsMutation_, UpsertMultipleMdrmDatapointsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMultipleMdrmDatapointsMutation_, UpsertMultipleMdrmDatapointsMutationVariables_>(UpsertMultipleMdrmDatapointsDocument_, options);
      }
export type UpsertMultipleMdrmDatapointsMutationHookResult = ReturnType<typeof useUpsertMultipleMdrmDatapointsMutation>;
export type UpsertMultipleMdrmDatapointsMutationResult_ = Apollo.MutationResult<UpsertMultipleMdrmDatapointsMutation_>;
export type UpsertMultipleMdrmDatapointsMutationOptions_ = Apollo.BaseMutationOptions<UpsertMultipleMdrmDatapointsMutation_, UpsertMultipleMdrmDatapointsMutationVariables_>;
export const UpdateDatapointMdrmOptOutDocument_ = gql`
    mutation updateDatapointMdrmOptOut($id: uuid!, $hasOptedOut: Boolean!) {
  update_esrs_DatapointMdrm_by_pk(
    pk_columns: {id: $id}
    _set: {hasOptedOut: $hasOptedOut}
  ) {
    id
    hasOptedOut
  }
}
    `;
export type UpdateDatapointMdrmOptOutMutationFn_ = Apollo.MutationFunction<UpdateDatapointMdrmOptOutMutation_, UpdateDatapointMdrmOptOutMutationVariables_>;

/**
 * __useUpdateDatapointMdrmOptOutMutation__
 *
 * To run a mutation, you first call `useUpdateDatapointMdrmOptOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDatapointMdrmOptOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDatapointMdrmOptOutMutation, { data, loading, error }] = useUpdateDatapointMdrmOptOutMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hasOptedOut: // value for 'hasOptedOut'
 *   },
 * });
 */
export function useUpdateDatapointMdrmOptOutMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDatapointMdrmOptOutMutation_, UpdateDatapointMdrmOptOutMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDatapointMdrmOptOutMutation_, UpdateDatapointMdrmOptOutMutationVariables_>(UpdateDatapointMdrmOptOutDocument_, options);
      }
export type UpdateDatapointMdrmOptOutMutationHookResult = ReturnType<typeof useUpdateDatapointMdrmOptOutMutation>;
export type UpdateDatapointMdrmOptOutMutationResult_ = Apollo.MutationResult<UpdateDatapointMdrmOptOutMutation_>;
export type UpdateDatapointMdrmOptOutMutationOptions_ = Apollo.BaseMutationOptions<UpdateDatapointMdrmOptOutMutation_, UpdateDatapointMdrmOptOutMutationVariables_>;
export const GetDatapointMdrmAnswersDocument_ = gql`
    query getDatapointMdrmAnswers($datapointId: uuid!) {
  esrs_DatapointMdrm(where: {datapointId: {_eq: $datapointId}}) {
    id
    authorId
    ownerId
    mdrmRef
    value
    updated_at
    hasOptedOut
    author {
      ...ShortUser
    }
    owner {
      ...ShortUser
    }
    task {
      owner {
        ...ShortUser
      }
      dueDate
      status
    }
    thread {
      id
      comments {
        id
      }
      comments_aggregate(where: {deletedAt: {_is_null: true}}) {
        aggregate {
          count
        }
      }
    }
  }
}
    ${ShortUserFragmentDoc_}`;

/**
 * __useGetDatapointMdrmAnswersQuery__
 *
 * To run a query within a React component, call `useGetDatapointMdrmAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatapointMdrmAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatapointMdrmAnswersQuery({
 *   variables: {
 *      datapointId: // value for 'datapointId'
 *   },
 * });
 */
export function useGetDatapointMdrmAnswersQuery(baseOptions: Apollo.QueryHookOptions<GetDatapointMdrmAnswersQuery_, GetDatapointMdrmAnswersQueryVariables_> & ({ variables: GetDatapointMdrmAnswersQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatapointMdrmAnswersQuery_, GetDatapointMdrmAnswersQueryVariables_>(GetDatapointMdrmAnswersDocument_, options);
      }
export function useGetDatapointMdrmAnswersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDatapointMdrmAnswersQuery_, GetDatapointMdrmAnswersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatapointMdrmAnswersQuery_, GetDatapointMdrmAnswersQueryVariables_>(GetDatapointMdrmAnswersDocument_, options);
        }
export function useGetDatapointMdrmAnswersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatapointMdrmAnswersQuery_, GetDatapointMdrmAnswersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatapointMdrmAnswersQuery_, GetDatapointMdrmAnswersQueryVariables_>(GetDatapointMdrmAnswersDocument_, options);
        }
export type GetDatapointMdrmAnswersQueryHookResult = ReturnType<typeof useGetDatapointMdrmAnswersQuery>;
export type GetDatapointMdrmAnswersLazyQuery_HookResult = ReturnType<typeof useGetDatapointMdrmAnswersLazyQuery_>;
export type GetDatapointMdrmAnswersSuspenseQuery_HookResult = ReturnType<typeof useGetDatapointMdrmAnswersSuspenseQuery_>;
export type GetDatapointMdrmAnswersQueryResult_ = Apollo.QueryResult<GetDatapointMdrmAnswersQuery_, GetDatapointMdrmAnswersQueryVariables_>;
export function refetchGetDatapointMdrmAnswersQuery_(variables: GetDatapointMdrmAnswersQueryVariables_) {
      return { query: GetDatapointMdrmAnswersDocument_, variables: variables }
    }
export const UpdateDatapointMdrmDisclosureDocument_ = gql`
    mutation updateDatapointMdrmDisclosure($datapointId: uuid!, $isMdrmDisclosed: Boolean, $mdrmElsewhereDisclosure: String) {
  update_esrs_Datapoint_by_pk(
    pk_columns: {id: $datapointId}
    _set: {isMdrmDisclosed: $isMdrmDisclosed, mdrmElsewhereDisclosure: $mdrmElsewhereDisclosure}
  ) {
    id
    isMdrmDisclosed
    mdrmElsewhereDisclosure
  }
}
    `;
export type UpdateDatapointMdrmDisclosureMutationFn_ = Apollo.MutationFunction<UpdateDatapointMdrmDisclosureMutation_, UpdateDatapointMdrmDisclosureMutationVariables_>;

/**
 * __useUpdateDatapointMdrmDisclosureMutation__
 *
 * To run a mutation, you first call `useUpdateDatapointMdrmDisclosureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDatapointMdrmDisclosureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDatapointMdrmDisclosureMutation, { data, loading, error }] = useUpdateDatapointMdrmDisclosureMutation({
 *   variables: {
 *      datapointId: // value for 'datapointId'
 *      isMdrmDisclosed: // value for 'isMdrmDisclosed'
 *      mdrmElsewhereDisclosure: // value for 'mdrmElsewhereDisclosure'
 *   },
 * });
 */
export function useUpdateDatapointMdrmDisclosureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDatapointMdrmDisclosureMutation_, UpdateDatapointMdrmDisclosureMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDatapointMdrmDisclosureMutation_, UpdateDatapointMdrmDisclosureMutationVariables_>(UpdateDatapointMdrmDisclosureDocument_, options);
      }
export type UpdateDatapointMdrmDisclosureMutationHookResult = ReturnType<typeof useUpdateDatapointMdrmDisclosureMutation>;
export type UpdateDatapointMdrmDisclosureMutationResult_ = Apollo.MutationResult<UpdateDatapointMdrmDisclosureMutation_>;
export type UpdateDatapointMdrmDisclosureMutationOptions_ = Apollo.BaseMutationOptions<UpdateDatapointMdrmDisclosureMutation_, UpdateDatapointMdrmDisclosureMutationVariables_>;
export const GetCompanyLevelMdrmAnswersDocument_ = gql`
    query getCompanyLevelMdrmAnswers($reportingUnitId: uuid!) {
  esrs_DatapointMdrm(
    where: {datapoint: {answer: {reportingUnitId: {_eq: $reportingUnitId}}}}
  ) {
    id
    datapointId
    datapoint {
      answer {
        metricRef
      }
    }
    mdrmRef
    value
    hasOptedOut
  }
}
    `;

/**
 * __useGetCompanyLevelMdrmAnswersQuery__
 *
 * To run a query within a React component, call `useGetCompanyLevelMdrmAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyLevelMdrmAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyLevelMdrmAnswersQuery({
 *   variables: {
 *      reportingUnitId: // value for 'reportingUnitId'
 *   },
 * });
 */
export function useGetCompanyLevelMdrmAnswersQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyLevelMdrmAnswersQuery_, GetCompanyLevelMdrmAnswersQueryVariables_> & ({ variables: GetCompanyLevelMdrmAnswersQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyLevelMdrmAnswersQuery_, GetCompanyLevelMdrmAnswersQueryVariables_>(GetCompanyLevelMdrmAnswersDocument_, options);
      }
export function useGetCompanyLevelMdrmAnswersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyLevelMdrmAnswersQuery_, GetCompanyLevelMdrmAnswersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyLevelMdrmAnswersQuery_, GetCompanyLevelMdrmAnswersQueryVariables_>(GetCompanyLevelMdrmAnswersDocument_, options);
        }
export function useGetCompanyLevelMdrmAnswersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyLevelMdrmAnswersQuery_, GetCompanyLevelMdrmAnswersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyLevelMdrmAnswersQuery_, GetCompanyLevelMdrmAnswersQueryVariables_>(GetCompanyLevelMdrmAnswersDocument_, options);
        }
export type GetCompanyLevelMdrmAnswersQueryHookResult = ReturnType<typeof useGetCompanyLevelMdrmAnswersQuery>;
export type GetCompanyLevelMdrmAnswersLazyQuery_HookResult = ReturnType<typeof useGetCompanyLevelMdrmAnswersLazyQuery_>;
export type GetCompanyLevelMdrmAnswersSuspenseQuery_HookResult = ReturnType<typeof useGetCompanyLevelMdrmAnswersSuspenseQuery_>;
export type GetCompanyLevelMdrmAnswersQueryResult_ = Apollo.QueryResult<GetCompanyLevelMdrmAnswersQuery_, GetCompanyLevelMdrmAnswersQueryVariables_>;
export function refetchGetCompanyLevelMdrmAnswersQuery_(variables: GetCompanyLevelMdrmAnswersQueryVariables_) {
      return { query: GetCompanyLevelMdrmAnswersDocument_, variables: variables }
    }
export const GetEsrsMetricDocument_ = gql`
    query getEsrsMetric($metricRef: String!) {
  metric: EsrsMetric_by_pk(reference: $metricRef) {
    ...EsrsMetricsFields
  }
}
    ${EsrsMetricsFieldsFragmentDoc_}`;

/**
 * __useGetEsrsMetricQuery__
 *
 * To run a query within a React component, call `useGetEsrsMetricQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsrsMetricQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsrsMetricQuery({
 *   variables: {
 *      metricRef: // value for 'metricRef'
 *   },
 * });
 */
export function useGetEsrsMetricQuery(baseOptions: Apollo.QueryHookOptions<GetEsrsMetricQuery_, GetEsrsMetricQueryVariables_> & ({ variables: GetEsrsMetricQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsrsMetricQuery_, GetEsrsMetricQueryVariables_>(GetEsrsMetricDocument_, options);
      }
export function useGetEsrsMetricLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetEsrsMetricQuery_, GetEsrsMetricQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsrsMetricQuery_, GetEsrsMetricQueryVariables_>(GetEsrsMetricDocument_, options);
        }
export function useGetEsrsMetricSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEsrsMetricQuery_, GetEsrsMetricQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEsrsMetricQuery_, GetEsrsMetricQueryVariables_>(GetEsrsMetricDocument_, options);
        }
export type GetEsrsMetricQueryHookResult = ReturnType<typeof useGetEsrsMetricQuery>;
export type GetEsrsMetricLazyQuery_HookResult = ReturnType<typeof useGetEsrsMetricLazyQuery_>;
export type GetEsrsMetricSuspenseQuery_HookResult = ReturnType<typeof useGetEsrsMetricSuspenseQuery_>;
export type GetEsrsMetricQueryResult_ = Apollo.QueryResult<GetEsrsMetricQuery_, GetEsrsMetricQueryVariables_>;
export function refetchGetEsrsMetricQuery_(variables: GetEsrsMetricQueryVariables_) {
      return { query: GetEsrsMetricDocument_, variables: variables }
    }
export const GetAllMetricsDocument_ = gql`
    query getAllMetrics {
  metrics: EsrsMetric(
    order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
  ) {
    ...EsrsMetricsFields
  }
}
    ${EsrsMetricsFieldsFragmentDoc_}`;

/**
 * __useGetAllMetricsQuery__
 *
 * To run a query within a React component, call `useGetAllMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMetricsQuery_, GetAllMetricsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMetricsQuery_, GetAllMetricsQueryVariables_>(GetAllMetricsDocument_, options);
      }
export function useGetAllMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMetricsQuery_, GetAllMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMetricsQuery_, GetAllMetricsQueryVariables_>(GetAllMetricsDocument_, options);
        }
export function useGetAllMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllMetricsQuery_, GetAllMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllMetricsQuery_, GetAllMetricsQueryVariables_>(GetAllMetricsDocument_, options);
        }
export type GetAllMetricsQueryHookResult = ReturnType<typeof useGetAllMetricsQuery>;
export type GetAllMetricsLazyQuery_HookResult = ReturnType<typeof useGetAllMetricsLazyQuery_>;
export type GetAllMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetAllMetricsSuspenseQuery_>;
export type GetAllMetricsQueryResult_ = Apollo.QueryResult<GetAllMetricsQuery_, GetAllMetricsQueryVariables_>;
export function refetchGetAllMetricsQuery_(variables?: GetAllMetricsQueryVariables_) {
      return { query: GetAllMetricsDocument_, variables: variables }
    }
export const GetAllMetricRefsDocument_ = gql`
    query getAllMetricRefs {
  data: EsrsMetric {
    reference
  }
}
    `;

/**
 * __useGetAllMetricRefsQuery__
 *
 * To run a query within a React component, call `useGetAllMetricRefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMetricRefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMetricRefsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllMetricRefsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllMetricRefsQuery_, GetAllMetricRefsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllMetricRefsQuery_, GetAllMetricRefsQueryVariables_>(GetAllMetricRefsDocument_, options);
      }
export function useGetAllMetricRefsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMetricRefsQuery_, GetAllMetricRefsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllMetricRefsQuery_, GetAllMetricRefsQueryVariables_>(GetAllMetricRefsDocument_, options);
        }
export function useGetAllMetricRefsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllMetricRefsQuery_, GetAllMetricRefsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllMetricRefsQuery_, GetAllMetricRefsQueryVariables_>(GetAllMetricRefsDocument_, options);
        }
export type GetAllMetricRefsQueryHookResult = ReturnType<typeof useGetAllMetricRefsQuery>;
export type GetAllMetricRefsLazyQuery_HookResult = ReturnType<typeof useGetAllMetricRefsLazyQuery_>;
export type GetAllMetricRefsSuspenseQuery_HookResult = ReturnType<typeof useGetAllMetricRefsSuspenseQuery_>;
export type GetAllMetricRefsQueryResult_ = Apollo.QueryResult<GetAllMetricRefsQuery_, GetAllMetricRefsQueryVariables_>;
export function refetchGetAllMetricRefsQuery_(variables?: GetAllMetricRefsQueryVariables_) {
      return { query: GetAllMetricRefsDocument_, variables: variables }
    }
export const GetEsrsMetricsDocument_ = gql`
    query getEsrsMetrics($standardRef: String!) {
  metrics: EsrsMetric(
    where: {requirement: {group: {standardRef: {_eq: $standardRef}}}, isAssessable: {_eq: true}}
    order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
  ) {
    title
    reference
  }
}
    `;

/**
 * __useGetEsrsMetricsQuery__
 *
 * To run a query within a React component, call `useGetEsrsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsrsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsrsMetricsQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *   },
 * });
 */
export function useGetEsrsMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetEsrsMetricsQuery_, GetEsrsMetricsQueryVariables_> & ({ variables: GetEsrsMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsrsMetricsQuery_, GetEsrsMetricsQueryVariables_>(GetEsrsMetricsDocument_, options);
      }
export function useGetEsrsMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetEsrsMetricsQuery_, GetEsrsMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsrsMetricsQuery_, GetEsrsMetricsQueryVariables_>(GetEsrsMetricsDocument_, options);
        }
export function useGetEsrsMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEsrsMetricsQuery_, GetEsrsMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEsrsMetricsQuery_, GetEsrsMetricsQueryVariables_>(GetEsrsMetricsDocument_, options);
        }
export type GetEsrsMetricsQueryHookResult = ReturnType<typeof useGetEsrsMetricsQuery>;
export type GetEsrsMetricsLazyQuery_HookResult = ReturnType<typeof useGetEsrsMetricsLazyQuery_>;
export type GetEsrsMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetEsrsMetricsSuspenseQuery_>;
export type GetEsrsMetricsQueryResult_ = Apollo.QueryResult<GetEsrsMetricsQuery_, GetEsrsMetricsQueryVariables_>;
export function refetchGetEsrsMetricsQuery_(variables: GetEsrsMetricsQueryVariables_) {
      return { query: GetEsrsMetricsDocument_, variables: variables }
    }
export const GetChildrenMetricsMetadataDocument_ = gql`
    query getChildrenMetricsMetadata($reportingUnitId: uuid!, $assessmentId: uuid!, $parentMetricRef: String!) {
  esrs_Answer(
    where: {reportingUnitId: {_eq: $reportingUnitId}, assessmentId: {_eq: $assessmentId}, metric: {parentMetrics: {parentMetricRef: {_eq: $parentMetricRef}}}}
  ) {
    datapoints(order_by: {updatedAt: desc}) {
      updatedAt
      lastEdited
      author {
        ...ShortUser
      }
      source
    }
  }
}
    ${ShortUserFragmentDoc_}`;

/**
 * __useGetChildrenMetricsMetadataQuery__
 *
 * To run a query within a React component, call `useGetChildrenMetricsMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildrenMetricsMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildrenMetricsMetadataQuery({
 *   variables: {
 *      reportingUnitId: // value for 'reportingUnitId'
 *      assessmentId: // value for 'assessmentId'
 *      parentMetricRef: // value for 'parentMetricRef'
 *   },
 * });
 */
export function useGetChildrenMetricsMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetChildrenMetricsMetadataQuery_, GetChildrenMetricsMetadataQueryVariables_> & ({ variables: GetChildrenMetricsMetadataQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildrenMetricsMetadataQuery_, GetChildrenMetricsMetadataQueryVariables_>(GetChildrenMetricsMetadataDocument_, options);
      }
export function useGetChildrenMetricsMetadataLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetChildrenMetricsMetadataQuery_, GetChildrenMetricsMetadataQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildrenMetricsMetadataQuery_, GetChildrenMetricsMetadataQueryVariables_>(GetChildrenMetricsMetadataDocument_, options);
        }
export function useGetChildrenMetricsMetadataSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChildrenMetricsMetadataQuery_, GetChildrenMetricsMetadataQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChildrenMetricsMetadataQuery_, GetChildrenMetricsMetadataQueryVariables_>(GetChildrenMetricsMetadataDocument_, options);
        }
export type GetChildrenMetricsMetadataQueryHookResult = ReturnType<typeof useGetChildrenMetricsMetadataQuery>;
export type GetChildrenMetricsMetadataLazyQuery_HookResult = ReturnType<typeof useGetChildrenMetricsMetadataLazyQuery_>;
export type GetChildrenMetricsMetadataSuspenseQuery_HookResult = ReturnType<typeof useGetChildrenMetricsMetadataSuspenseQuery_>;
export type GetChildrenMetricsMetadataQueryResult_ = Apollo.QueryResult<GetChildrenMetricsMetadataQuery_, GetChildrenMetricsMetadataQueryVariables_>;
export function refetchGetChildrenMetricsMetadataQuery_(variables: GetChildrenMetricsMetadataQueryVariables_) {
      return { query: GetChildrenMetricsMetadataDocument_, variables: variables }
    }
export const GetStandardMandatoryMetricsDocument_ = gql`
    query getStandardMandatoryMetrics($standardRef: String!, $esrsAssessmentId: uuid!) {
  EsrsMetric(
    where: {requirement: {_and: [{isMandatory: {_eq: true}}, {group: {standard: {reference: {_eq: $standardRef}}}}]}}
  ) {
    reference
    requirement {
      isMandatory
    }
    parentMetrics {
      parentMetric {
        tags {
          type
          isOptional
          tagType {
            type
            alwaysAll
            tagValues(order_by: [{order: asc}, {value: asc}]) {
              value
              type
            }
          }
        }
      }
    }
    tags {
      type
      isOptional
      tagType {
        type
        alwaysAll
        tagValues(order_by: [{order: asc}, {value: asc}]) {
          value
          type
        }
      }
    }
    additionalTypes {
      additionalTypeRef
    }
    materialMetrics(
      where: {materialStandard: {assessmentId: {_eq: $esrsAssessmentId}, standardRef: {_eq: $standardRef}}}
    ) {
      isMaterial
      isDataGatheringOnly
      isPhasedIn
      materialStandardId
    }
  }
}
    `;

/**
 * __useGetStandardMandatoryMetricsQuery__
 *
 * To run a query within a React component, call `useGetStandardMandatoryMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandardMandatoryMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandardMandatoryMetricsQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetStandardMandatoryMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetStandardMandatoryMetricsQuery_, GetStandardMandatoryMetricsQueryVariables_> & ({ variables: GetStandardMandatoryMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandardMandatoryMetricsQuery_, GetStandardMandatoryMetricsQueryVariables_>(GetStandardMandatoryMetricsDocument_, options);
      }
export function useGetStandardMandatoryMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetStandardMandatoryMetricsQuery_, GetStandardMandatoryMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandardMandatoryMetricsQuery_, GetStandardMandatoryMetricsQueryVariables_>(GetStandardMandatoryMetricsDocument_, options);
        }
export function useGetStandardMandatoryMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStandardMandatoryMetricsQuery_, GetStandardMandatoryMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStandardMandatoryMetricsQuery_, GetStandardMandatoryMetricsQueryVariables_>(GetStandardMandatoryMetricsDocument_, options);
        }
export type GetStandardMandatoryMetricsQueryHookResult = ReturnType<typeof useGetStandardMandatoryMetricsQuery>;
export type GetStandardMandatoryMetricsLazyQuery_HookResult = ReturnType<typeof useGetStandardMandatoryMetricsLazyQuery_>;
export type GetStandardMandatoryMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetStandardMandatoryMetricsSuspenseQuery_>;
export type GetStandardMandatoryMetricsQueryResult_ = Apollo.QueryResult<GetStandardMandatoryMetricsQuery_, GetStandardMandatoryMetricsQueryVariables_>;
export function refetchGetStandardMandatoryMetricsQuery_(variables: GetStandardMandatoryMetricsQueryVariables_) {
      return { query: GetStandardMandatoryMetricsDocument_, variables: variables }
    }
export const GetStandardNonMandatoryMetricsDocument_ = gql`
    query getStandardNonMandatoryMetrics($standardRef: String!, $esrsAssessmentId: uuid!) {
  EsrsMetric(
    where: {requirement: {_and: [{isMandatory: {_eq: false}}, {group: {standard: {reference: {_eq: $standardRef}}}}]}}
  ) {
    reference
    requirement {
      isMandatory
    }
    parentMetrics {
      parentMetric {
        tags {
          type
          isOptional
          tagType {
            type
            alwaysAll
            tagValues(order_by: [{order: asc}, {value: asc}]) {
              value
              type
            }
          }
        }
      }
    }
    tags {
      type
      isOptional
      tagType {
        type
        alwaysAll
        tagValues(order_by: [{order: asc}, {value: asc}]) {
          value
          type
        }
      }
    }
    additionalTypes {
      additionalTypeRef
    }
    materialMetrics(
      where: {materialStandard: {assessmentId: {_eq: $esrsAssessmentId}, standardRef: {_eq: $standardRef}}}
    ) {
      isMaterial
      isDataGatheringOnly
      isPhasedIn
      materialStandardId
    }
  }
}
    `;

/**
 * __useGetStandardNonMandatoryMetricsQuery__
 *
 * To run a query within a React component, call `useGetStandardNonMandatoryMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStandardNonMandatoryMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStandardNonMandatoryMetricsQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetStandardNonMandatoryMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetStandardNonMandatoryMetricsQuery_, GetStandardNonMandatoryMetricsQueryVariables_> & ({ variables: GetStandardNonMandatoryMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStandardNonMandatoryMetricsQuery_, GetStandardNonMandatoryMetricsQueryVariables_>(GetStandardNonMandatoryMetricsDocument_, options);
      }
export function useGetStandardNonMandatoryMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetStandardNonMandatoryMetricsQuery_, GetStandardNonMandatoryMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStandardNonMandatoryMetricsQuery_, GetStandardNonMandatoryMetricsQueryVariables_>(GetStandardNonMandatoryMetricsDocument_, options);
        }
export function useGetStandardNonMandatoryMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStandardNonMandatoryMetricsQuery_, GetStandardNonMandatoryMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStandardNonMandatoryMetricsQuery_, GetStandardNonMandatoryMetricsQueryVariables_>(GetStandardNonMandatoryMetricsDocument_, options);
        }
export type GetStandardNonMandatoryMetricsQueryHookResult = ReturnType<typeof useGetStandardNonMandatoryMetricsQuery>;
export type GetStandardNonMandatoryMetricsLazyQuery_HookResult = ReturnType<typeof useGetStandardNonMandatoryMetricsLazyQuery_>;
export type GetStandardNonMandatoryMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetStandardNonMandatoryMetricsSuspenseQuery_>;
export type GetStandardNonMandatoryMetricsQueryResult_ = Apollo.QueryResult<GetStandardNonMandatoryMetricsQuery_, GetStandardNonMandatoryMetricsQueryVariables_>;
export function refetchGetStandardNonMandatoryMetricsQuery_(variables: GetStandardNonMandatoryMetricsQueryVariables_) {
      return { query: GetStandardNonMandatoryMetricsDocument_, variables: variables }
    }
export const GetRequiredMaterialMetricsDocument_ = gql`
    query getRequiredMaterialMetrics($disclosureRequirementRef: String!, $materialStandardId: uuid!, $parentStandardId: uuid!, $frameworkRef: String!) {
  esrs_MaterialMetric(
    where: {metric: {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $disclosureRequirementRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $disclosureRequirementRef}}}}]}, _or: [{isMaterial: {_eq: true}, materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}}, {isMaterial: {_eq: true}, materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}, metric: {hierarchyStatus: {isLeaf: {_eq: true}}}, _and: {metric: {materialMetrics: {materialStandardId: {_eq: $materialStandardId}}}}}]}
  ) {
    id
    dataCollection
    materialStandardId
    metric {
      reference
      isAssessable
      parentMetrics {
        parentMetricRef
      }
      notAggregatable
      abbreviation
    }
  }
}
    `;

/**
 * __useGetRequiredMaterialMetricsQuery__
 *
 * To run a query within a React component, call `useGetRequiredMaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredMaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredMaterialMetricsQuery({
 *   variables: {
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *      materialStandardId: // value for 'materialStandardId'
 *      parentStandardId: // value for 'parentStandardId'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetRequiredMaterialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetRequiredMaterialMetricsQuery_, GetRequiredMaterialMetricsQueryVariables_> & ({ variables: GetRequiredMaterialMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequiredMaterialMetricsQuery_, GetRequiredMaterialMetricsQueryVariables_>(GetRequiredMaterialMetricsDocument_, options);
      }
export function useGetRequiredMaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetRequiredMaterialMetricsQuery_, GetRequiredMaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequiredMaterialMetricsQuery_, GetRequiredMaterialMetricsQueryVariables_>(GetRequiredMaterialMetricsDocument_, options);
        }
export function useGetRequiredMaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequiredMaterialMetricsQuery_, GetRequiredMaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequiredMaterialMetricsQuery_, GetRequiredMaterialMetricsQueryVariables_>(GetRequiredMaterialMetricsDocument_, options);
        }
export type GetRequiredMaterialMetricsQueryHookResult = ReturnType<typeof useGetRequiredMaterialMetricsQuery>;
export type GetRequiredMaterialMetricsLazyQuery_HookResult = ReturnType<typeof useGetRequiredMaterialMetricsLazyQuery_>;
export type GetRequiredMaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetRequiredMaterialMetricsSuspenseQuery_>;
export type GetRequiredMaterialMetricsQueryResult_ = Apollo.QueryResult<GetRequiredMaterialMetricsQuery_, GetRequiredMaterialMetricsQueryVariables_>;
export function refetchGetRequiredMaterialMetricsQuery_(variables: GetRequiredMaterialMetricsQueryVariables_) {
      return { query: GetRequiredMaterialMetricsDocument_, variables: variables }
    }
export const GetRequiredBuMaterialMetricsDocument_ = gql`
    query getRequiredBUMaterialMetrics($disclosureRequirementRef: String!, $materialStandardId: uuid!, $parentStandardId: uuid!) {
  esrs_MaterialMetric(
    where: {metric: {_or: [{disclosureRequirementRef: {_eq: $disclosureRequirementRef}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {drToMFDisclosureRequirements: {disclosureRequirementRef: {_eq: $disclosureRequirementRef}}}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $disclosureRequirementRef}}}}]}, _or: [{isMaterial: {_eq: true}, materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}, dataCollection: {_eq: "reportingUnits"}}, {isMaterial: {_eq: true}, materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}, _and: {metric: {hierarchyStatus: {isLeaf: {_eq: true}}, materialMetrics: {materialStandardId: {_eq: $materialStandardId}, dataCollection: {_eq: "reportingUnits"}}}}}]}
  ) {
    id
    dataCollection
    materialStandardId
    metric {
      isAssessable
      notAggregatable
      reference
      parentMetrics {
        parentMetricRef
      }
    }
  }
}
    `;

/**
 * __useGetRequiredBuMaterialMetricsQuery__
 *
 * To run a query within a React component, call `useGetRequiredBuMaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredBuMaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredBuMaterialMetricsQuery({
 *   variables: {
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *      materialStandardId: // value for 'materialStandardId'
 *      parentStandardId: // value for 'parentStandardId'
 *   },
 * });
 */
export function useGetRequiredBuMaterialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetRequiredBuMaterialMetricsQuery_, GetRequiredBuMaterialMetricsQueryVariables_> & ({ variables: GetRequiredBuMaterialMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequiredBuMaterialMetricsQuery_, GetRequiredBuMaterialMetricsQueryVariables_>(GetRequiredBuMaterialMetricsDocument_, options);
      }
export function useGetRequiredBuMaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetRequiredBuMaterialMetricsQuery_, GetRequiredBuMaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequiredBuMaterialMetricsQuery_, GetRequiredBuMaterialMetricsQueryVariables_>(GetRequiredBuMaterialMetricsDocument_, options);
        }
export function useGetRequiredBuMaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequiredBuMaterialMetricsQuery_, GetRequiredBuMaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequiredBuMaterialMetricsQuery_, GetRequiredBuMaterialMetricsQueryVariables_>(GetRequiredBuMaterialMetricsDocument_, options);
        }
export type GetRequiredBuMaterialMetricsQueryHookResult = ReturnType<typeof useGetRequiredBuMaterialMetricsQuery>;
export type GetRequiredBuMaterialMetricsLazyQuery_HookResult = ReturnType<typeof useGetRequiredBuMaterialMetricsLazyQuery_>;
export type GetRequiredBuMaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetRequiredBuMaterialMetricsSuspenseQuery_>;
export type GetRequiredBuMaterialMetricsQueryResult_ = Apollo.QueryResult<GetRequiredBuMaterialMetricsQuery_, GetRequiredBuMaterialMetricsQueryVariables_>;
export function refetchGetRequiredBuMaterialMetricsQuery_(variables: GetRequiredBuMaterialMetricsQueryVariables_) {
      return { query: GetRequiredBuMaterialMetricsDocument_, variables: variables }
    }
export const GetMetricsDrDocument_ = gql`
    query getMetricsDR($reference: String!, $materialStandardId: uuid!, $parentStandardId: uuid!, $requiredMetrics: [String!]!) {
  DisclosureRequirement_by_pk(reference: $reference) {
    reference
    title
    description
    type
    metrics(
      order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}, {reference: asc}]
      where: {isAssessable: {_eq: true}, materialMetrics: {isMaterial: {_eq: true}, _or: [{materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}}, {materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}}]}, _or: [{reference: {_in: $requiredMetrics}}, {view_childrenMetrics: {childMetricRef: {_in: $requiredMetrics}}}]}
    ) {
      ...ChildlessEsrsMetricsFields
      notAggregatable
      abbreviation
      materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
        ...MaterialMetricsFields
      }
      childrenMetrics(
        order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
        where: {_or: [{childMetric: {isAssessable: {_eq: false}}}, {childMetric: {metricType: {_eq: DECIMAL}}}, {_and: [{childMetric: {isAssessable: {_eq: true}}}, {childMetric: {reference: {_in: $requiredMetrics}}}]}]}
      ) {
        childMetric {
          ...ChildlessEsrsMetricsFields
          abbreviation
          notAggregatable
          materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
            ...MaterialMetricsFields
          }
          childrenMetrics(
            order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
            where: {_or: [{childMetric: {isAssessable: {_eq: false}}}, {childMetric: {metricType: {_eq: DECIMAL}}}, {_and: [{childMetric: {isAssessable: {_eq: true}}}, {childMetric: {reference: {_in: $requiredMetrics}}}]}]}
          ) {
            childMetric {
              ...ChildlessEsrsMetricsFields
              abbreviation
              notAggregatable
              materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
                ...MaterialMetricsFields
              }
              childrenMetrics(
                order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
                where: {_or: [{childMetric: {isAssessable: {_eq: false}}}, {childMetric: {metricType: {_eq: DECIMAL}}}, {_and: [{childMetric: {isAssessable: {_eq: true}}}, {childMetric: {reference: {_in: $requiredMetrics}}}]}]}
              ) {
                childMetric {
                  ...ChildlessEsrsMetricsFields
                  notAggregatable
                  abbreviation
                  materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
                    ...MaterialMetricsFields
                  }
                  childrenMetrics(
                    order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
                    where: {_or: [{childMetric: {isAssessable: {_eq: false}}}, {childMetric: {metricType: {_eq: DECIMAL}}}, {_and: [{childMetric: {isAssessable: {_eq: true}}}, {childMetric: {reference: {_in: $requiredMetrics}}}]}]}
                  ) {
                    childMetric {
                      ...ChildlessEsrsMetricsFields
                      abbreviation
                      notAggregatable
                      materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
                        ...MaterialMetricsFields
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    mfDisclosureRequirements {
      mfDisclosureRequirement {
        mfDisclosureRequirementItems(
          where: {metric: {isAssessable: {_eq: true}, disclosureRequirementRef: {_neq: $reference}, materialMetrics: {isMaterial: {_eq: true}, _or: [{materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}}, {materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}}]}, _or: [{reference: {_in: $requiredMetrics}}, {view_childrenMetrics: {childMetricRef: {_in: $requiredMetrics}}}]}}
        ) {
          metric {
            ...ChildlessEsrsMetricsFields
            notAggregatable
            abbreviation
            materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
              ...MaterialMetricsFields
            }
            childrenMetrics(
              order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
            ) {
              childMetric {
                ...ChildlessEsrsMetricsFields
                abbreviation
                notAggregatable
                materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
                  ...MaterialMetricsFields
                }
                childrenMetrics(
                  order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
                ) {
                  childMetric {
                    ...ChildlessEsrsMetricsFields
                    abbreviation
                    notAggregatable
                    materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
                      ...MaterialMetricsFields
                    }
                    childrenMetrics(
                      order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
                    ) {
                      childMetric {
                        ...ChildlessEsrsMetricsFields
                        abbreviation
                        notAggregatable
                        materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
                          ...MaterialMetricsFields
                        }
                        childrenMetrics(
                          order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
                        ) {
                          childMetric {
                            ...ChildlessEsrsMetricsFields
                            abbreviation
                            notAggregatable
                            materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
                              ...MaterialMetricsFields
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ChildlessEsrsMetricsFieldsFragmentDoc_}
${MaterialMetricsFieldsFragmentDoc_}`;

/**
 * __useGetMetricsDrQuery__
 *
 * To run a query within a React component, call `useGetMetricsDrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricsDrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricsDrQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *      materialStandardId: // value for 'materialStandardId'
 *      parentStandardId: // value for 'parentStandardId'
 *      requiredMetrics: // value for 'requiredMetrics'
 *   },
 * });
 */
export function useGetMetricsDrQuery(baseOptions: Apollo.QueryHookOptions<GetMetricsDrQuery_, GetMetricsDrQueryVariables_> & ({ variables: GetMetricsDrQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricsDrQuery_, GetMetricsDrQueryVariables_>(GetMetricsDrDocument_, options);
      }
export function useGetMetricsDrLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricsDrQuery_, GetMetricsDrQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricsDrQuery_, GetMetricsDrQueryVariables_>(GetMetricsDrDocument_, options);
        }
export function useGetMetricsDrSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricsDrQuery_, GetMetricsDrQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricsDrQuery_, GetMetricsDrQueryVariables_>(GetMetricsDrDocument_, options);
        }
export type GetMetricsDrQueryHookResult = ReturnType<typeof useGetMetricsDrQuery>;
export type GetMetricsDrLazyQuery_HookResult = ReturnType<typeof useGetMetricsDrLazyQuery_>;
export type GetMetricsDrSuspenseQuery_HookResult = ReturnType<typeof useGetMetricsDrSuspenseQuery_>;
export type GetMetricsDrQueryResult_ = Apollo.QueryResult<GetMetricsDrQuery_, GetMetricsDrQueryVariables_>;
export function refetchGetMetricsDrQuery_(variables: GetMetricsDrQueryVariables_) {
      return { query: GetMetricsDrDocument_, variables: variables }
    }
export const GetOptimizedMetricsDrDocument_ = gql`
    query getOptimizedMetricsDR($reference: String!, $materialStandardId: uuid!, $parentStandardId: uuid!, $requiredMetrics: [String!]!) {
  DisclosureRequirement_by_pk(reference: $reference) {
    reference
    title
    description
    type
    metrics(
      order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}, {reference: asc}]
      where: {isAssessable: {_eq: true}, materialMetrics: {isMaterial: {_eq: true}, _or: [{materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}}, {materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}}]}, _or: [{reference: {_in: $requiredMetrics}}, {view_childrenMetrics: {childMetricRef: {_in: $requiredMetrics}}}]}
    ) {
      ...ChildlessEsrsMetricsFields
      notAggregatable
      abbreviation
      materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
        ...MaterialMetricsFields
      }
      childrenMetrics: view_childrenMetrics(
        order_by: [{view_childMetric: {globalOrder: asc}}, {view_childMetric: {isAR: asc}}, {view_childMetric: {order: asc}}, {view_childMetric: {firstLevel: asc}}, {view_childMetric: {secondLevel: asc}}, {view_childMetric: {reference: asc}}]
      ) {
        depth
        parentMetricRef
        childMetricRef
        childMetric: view_childMetric {
          ...ChildlessEsrsMetricsFields
          abbreviation
          notAggregatable
          materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
            ...MaterialMetricsFields
          }
        }
      }
    }
    mfDisclosureRequirements {
      mfDisclosureRequirement {
        mfDisclosureRequirementItems(
          where: {metric: {isAssessable: {_eq: true}, disclosureRequirementRef: {_neq: $reference}, materialMetrics: {isMaterial: {_eq: true}, _or: [{materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}}, {materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}}]}, _or: [{reference: {_in: $requiredMetrics}}, {view_childrenMetrics: {childMetricRef: {_in: $requiredMetrics}}}]}}
        ) {
          metric {
            ...ChildlessEsrsMetricsFields
            notAggregatable
            abbreviation
            materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
              ...MaterialMetricsFields
            }
            childrenMetrics: view_childrenMetrics(
              order_by: [{view_childMetric: {globalOrder: asc}}, {view_childMetric: {isAR: asc}}, {view_childMetric: {order: asc}}, {view_childMetric: {firstLevel: asc}}, {view_childMetric: {secondLevel: asc}}, {view_childMetric: {reference: asc}}]
            ) {
              depth
              childMetricRef
              parentMetricRef
              childMetric: view_childMetric {
                ...ChildlessEsrsMetricsFields
                abbreviation
                notAggregatable
                materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
                  ...MaterialMetricsFields
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ChildlessEsrsMetricsFieldsFragmentDoc_}
${MaterialMetricsFieldsFragmentDoc_}`;

/**
 * __useGetOptimizedMetricsDrQuery__
 *
 * To run a query within a React component, call `useGetOptimizedMetricsDrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptimizedMetricsDrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptimizedMetricsDrQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *      materialStandardId: // value for 'materialStandardId'
 *      parentStandardId: // value for 'parentStandardId'
 *      requiredMetrics: // value for 'requiredMetrics'
 *   },
 * });
 */
export function useGetOptimizedMetricsDrQuery(baseOptions: Apollo.QueryHookOptions<GetOptimizedMetricsDrQuery_, GetOptimizedMetricsDrQueryVariables_> & ({ variables: GetOptimizedMetricsDrQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOptimizedMetricsDrQuery_, GetOptimizedMetricsDrQueryVariables_>(GetOptimizedMetricsDrDocument_, options);
      }
export function useGetOptimizedMetricsDrLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetOptimizedMetricsDrQuery_, GetOptimizedMetricsDrQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOptimizedMetricsDrQuery_, GetOptimizedMetricsDrQueryVariables_>(GetOptimizedMetricsDrDocument_, options);
        }
export function useGetOptimizedMetricsDrSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOptimizedMetricsDrQuery_, GetOptimizedMetricsDrQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOptimizedMetricsDrQuery_, GetOptimizedMetricsDrQueryVariables_>(GetOptimizedMetricsDrDocument_, options);
        }
export type GetOptimizedMetricsDrQueryHookResult = ReturnType<typeof useGetOptimizedMetricsDrQuery>;
export type GetOptimizedMetricsDrLazyQuery_HookResult = ReturnType<typeof useGetOptimizedMetricsDrLazyQuery_>;
export type GetOptimizedMetricsDrSuspenseQuery_HookResult = ReturnType<typeof useGetOptimizedMetricsDrSuspenseQuery_>;
export type GetOptimizedMetricsDrQueryResult_ = Apollo.QueryResult<GetOptimizedMetricsDrQuery_, GetOptimizedMetricsDrQueryVariables_>;
export function refetchGetOptimizedMetricsDrQuery_(variables: GetOptimizedMetricsDrQueryVariables_) {
      return { query: GetOptimizedMetricsDrDocument_, variables: variables }
    }
export const GetMetricsMfdrDocument_ = gql`
    query getMetricsMFDR($reference: String!, $materialStandardId: uuid!, $parentStandardId: uuid!, $requiredMetrics: [String!]!) {
  MFDisclosureRequirement_by_pk(reference: $reference) {
    reference
    title
    description
    type
    mfDisclosureRequirementItems(
      order_by: {order: asc}
      where: {metric: {isAssessable: {_eq: true}, materialMetrics: {isMaterial: {_eq: true}, _or: [{materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}}, {materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}}]}, _or: [{reference: {_in: $requiredMetrics}}, {view_childrenMetrics: {childMetricRef: {_in: $requiredMetrics}}}]}}
    ) {
      metric {
        ...ChildlessEsrsMetricsFields
        notAggregatable
        materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
          ...MaterialMetricsFields
        }
        childrenMetrics(
          order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
        ) {
          childMetric {
            ...ChildlessEsrsMetricsFields
            notAggregatable
            materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
              ...MaterialMetricsFields
            }
            childrenMetrics(
              order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
            ) {
              childMetric {
                ...ChildlessEsrsMetricsFields
                notAggregatable
                materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
                  ...MaterialMetricsFields
                }
                childrenMetrics(
                  order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
                ) {
                  childMetric {
                    ...ChildlessEsrsMetricsFields
                    notAggregatable
                    materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
                      ...MaterialMetricsFields
                    }
                    childrenMetrics(
                      order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}, {childMetric: {reference: asc}}]
                    ) {
                      childMetric {
                        ...ChildlessEsrsMetricsFields
                        notAggregatable
                        materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
                          ...MaterialMetricsFields
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ChildlessEsrsMetricsFieldsFragmentDoc_}
${MaterialMetricsFieldsFragmentDoc_}`;

/**
 * __useGetMetricsMfdrQuery__
 *
 * To run a query within a React component, call `useGetMetricsMfdrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricsMfdrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricsMfdrQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *      materialStandardId: // value for 'materialStandardId'
 *      parentStandardId: // value for 'parentStandardId'
 *      requiredMetrics: // value for 'requiredMetrics'
 *   },
 * });
 */
export function useGetMetricsMfdrQuery(baseOptions: Apollo.QueryHookOptions<GetMetricsMfdrQuery_, GetMetricsMfdrQueryVariables_> & ({ variables: GetMetricsMfdrQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricsMfdrQuery_, GetMetricsMfdrQueryVariables_>(GetMetricsMfdrDocument_, options);
      }
export function useGetMetricsMfdrLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricsMfdrQuery_, GetMetricsMfdrQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricsMfdrQuery_, GetMetricsMfdrQueryVariables_>(GetMetricsMfdrDocument_, options);
        }
export function useGetMetricsMfdrSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricsMfdrQuery_, GetMetricsMfdrQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricsMfdrQuery_, GetMetricsMfdrQueryVariables_>(GetMetricsMfdrDocument_, options);
        }
export type GetMetricsMfdrQueryHookResult = ReturnType<typeof useGetMetricsMfdrQuery>;
export type GetMetricsMfdrLazyQuery_HookResult = ReturnType<typeof useGetMetricsMfdrLazyQuery_>;
export type GetMetricsMfdrSuspenseQuery_HookResult = ReturnType<typeof useGetMetricsMfdrSuspenseQuery_>;
export type GetMetricsMfdrQueryResult_ = Apollo.QueryResult<GetMetricsMfdrQuery_, GetMetricsMfdrQueryVariables_>;
export function refetchGetMetricsMfdrQuery_(variables: GetMetricsMfdrQueryVariables_) {
      return { query: GetMetricsMfdrDocument_, variables: variables }
    }
export const GetMetricNameDocument_ = gql`
    query getMetricName($ref: String!) {
  EsrsMetric(where: {reference: {_eq: $ref}}) {
    title
    reference
  }
}
    `;

/**
 * __useGetMetricNameQuery__
 *
 * To run a query within a React component, call `useGetMetricNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricNameQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetMetricNameQuery(baseOptions: Apollo.QueryHookOptions<GetMetricNameQuery_, GetMetricNameQueryVariables_> & ({ variables: GetMetricNameQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricNameQuery_, GetMetricNameQueryVariables_>(GetMetricNameDocument_, options);
      }
export function useGetMetricNameLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricNameQuery_, GetMetricNameQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricNameQuery_, GetMetricNameQueryVariables_>(GetMetricNameDocument_, options);
        }
export function useGetMetricNameSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricNameQuery_, GetMetricNameQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricNameQuery_, GetMetricNameQueryVariables_>(GetMetricNameDocument_, options);
        }
export type GetMetricNameQueryHookResult = ReturnType<typeof useGetMetricNameQuery>;
export type GetMetricNameLazyQuery_HookResult = ReturnType<typeof useGetMetricNameLazyQuery_>;
export type GetMetricNameSuspenseQuery_HookResult = ReturnType<typeof useGetMetricNameSuspenseQuery_>;
export type GetMetricNameQueryResult_ = Apollo.QueryResult<GetMetricNameQuery_, GetMetricNameQueryVariables_>;
export function refetchGetMetricNameQuery_(variables: GetMetricNameQueryVariables_) {
      return { query: GetMetricNameDocument_, variables: variables }
    }
export const GetMfDisclosureRequirementsMetricsDocument_ = gql`
    query getMFDisclosureRequirementsMetrics($mfDRrefs: [String!]) {
  MFDisclosureRequirementItem(
    where: {mfDisclosureRequirementRef: {_in: $mfDRrefs}}
    order_by: {order: asc}
  ) {
    metricRef
    mfDisclosureRequirementRef
    mfDisclosureRequirement {
      title
    }
    metric {
      reference
      title
      shortTitle
      metricType
      description
      order
      firstLevel
      secondLevel
      disclosureRequirementRef
      requirement {
        group {
          standard {
            frameworkRef
          }
        }
      }
      parentMetrics {
        parentMetric {
          reference
          tags {
            type
            isOptional
            tagType {
              type
              alwaysAll
              tagValues(order_by: [{order: asc}, {value: asc}]) {
                value
              }
            }
          }
        }
      }
      description
      tags {
        type
        isOptional
        tagType {
          type
          alwaysAll
          tagValues(order_by: [{order: asc}, {value: asc}]) {
            value
          }
        }
      }
      isAR
      isAssessable
      additionalTypes {
        additionalType {
          reference
          title
          description
          learnMore
        }
      }
      childrenMetrics {
        childMetricRef
        order
        parentMetricRef
        childMetric {
          reference
          isAssessable
          parentMetrics {
            parentMetric {
              reference
            }
          }
          childrenMetrics {
            childMetricRef
            order
            parentMetricRef
            childMetric {
              reference
              isAssessable
              parentMetrics {
                parentMetric {
                  reference
                }
              }
              childrenMetrics {
                childMetricRef
                order
                parentMetricRef
                childMetric {
                  reference
                  isAssessable
                  parentMetrics {
                    parentMetric {
                      reference
                    }
                  }
                  childrenMetrics {
                    childMetricRef
                    order
                    parentMetricRef
                    childMetric {
                      reference
                      isAssessable
                      parentMetrics {
                        parentMetric {
                          reference
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMfDisclosureRequirementsMetricsQuery__
 *
 * To run a query within a React component, call `useGetMfDisclosureRequirementsMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMfDisclosureRequirementsMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMfDisclosureRequirementsMetricsQuery({
 *   variables: {
 *      mfDRrefs: // value for 'mfDRrefs'
 *   },
 * });
 */
export function useGetMfDisclosureRequirementsMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetMfDisclosureRequirementsMetricsQuery_, GetMfDisclosureRequirementsMetricsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMfDisclosureRequirementsMetricsQuery_, GetMfDisclosureRequirementsMetricsQueryVariables_>(GetMfDisclosureRequirementsMetricsDocument_, options);
      }
export function useGetMfDisclosureRequirementsMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMfDisclosureRequirementsMetricsQuery_, GetMfDisclosureRequirementsMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMfDisclosureRequirementsMetricsQuery_, GetMfDisclosureRequirementsMetricsQueryVariables_>(GetMfDisclosureRequirementsMetricsDocument_, options);
        }
export function useGetMfDisclosureRequirementsMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMfDisclosureRequirementsMetricsQuery_, GetMfDisclosureRequirementsMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMfDisclosureRequirementsMetricsQuery_, GetMfDisclosureRequirementsMetricsQueryVariables_>(GetMfDisclosureRequirementsMetricsDocument_, options);
        }
export type GetMfDisclosureRequirementsMetricsQueryHookResult = ReturnType<typeof useGetMfDisclosureRequirementsMetricsQuery>;
export type GetMfDisclosureRequirementsMetricsLazyQuery_HookResult = ReturnType<typeof useGetMfDisclosureRequirementsMetricsLazyQuery_>;
export type GetMfDisclosureRequirementsMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetMfDisclosureRequirementsMetricsSuspenseQuery_>;
export type GetMfDisclosureRequirementsMetricsQueryResult_ = Apollo.QueryResult<GetMfDisclosureRequirementsMetricsQuery_, GetMfDisclosureRequirementsMetricsQueryVariables_>;
export function refetchGetMfDisclosureRequirementsMetricsQuery_(variables?: GetMfDisclosureRequirementsMetricsQueryVariables_) {
      return { query: GetMfDisclosureRequirementsMetricsDocument_, variables: variables }
    }
export const GetMetricWithChildrenDocument_ = gql`
    query getMetricWithChildren($metricRef: String!, $materialStandardId: uuid!) {
  EsrsMetric(where: {reference: {_eq: $metricRef}}) {
    ...ChildlessEsrsMetricsFields
    materialMetrics(where: {materialStandardId: {_eq: $materialStandardId}}) {
      ...MaterialMetricsFields
    }
    childrenMetrics(where: {childMetric: {metricType: {_in: [DECIMAL, OTHER]}}}) {
      childMetric {
        ...ChildlessEsrsMetricsFields
        materialMetrics(where: {materialStandardId: {_eq: $materialStandardId}}) {
          ...MaterialMetricsFields
        }
        childrenMetrics(where: {childMetric: {metricType: {_in: [DECIMAL, OTHER]}}}) {
          childMetric {
            ...ChildlessEsrsMetricsFields
            materialMetrics(where: {materialStandardId: {_eq: $materialStandardId}}) {
              ...MaterialMetricsFields
            }
            childrenMetrics(where: {childMetric: {metricType: {_in: [DECIMAL, OTHER]}}}) {
              childMetric {
                ...ChildlessEsrsMetricsFields
                materialMetrics(where: {materialStandardId: {_eq: $materialStandardId}}) {
                  ...MaterialMetricsFields
                }
                childrenMetrics(where: {childMetric: {metricType: {_in: [DECIMAL, OTHER]}}}) {
                  childMetric {
                    ...ChildlessEsrsMetricsFields
                    materialMetrics(where: {materialStandardId: {_eq: $materialStandardId}}) {
                      ...MaterialMetricsFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ChildlessEsrsMetricsFieldsFragmentDoc_}
${MaterialMetricsFieldsFragmentDoc_}`;

/**
 * __useGetMetricWithChildrenQuery__
 *
 * To run a query within a React component, call `useGetMetricWithChildrenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricWithChildrenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricWithChildrenQuery({
 *   variables: {
 *      metricRef: // value for 'metricRef'
 *      materialStandardId: // value for 'materialStandardId'
 *   },
 * });
 */
export function useGetMetricWithChildrenQuery(baseOptions: Apollo.QueryHookOptions<GetMetricWithChildrenQuery_, GetMetricWithChildrenQueryVariables_> & ({ variables: GetMetricWithChildrenQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricWithChildrenQuery_, GetMetricWithChildrenQueryVariables_>(GetMetricWithChildrenDocument_, options);
      }
export function useGetMetricWithChildrenLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricWithChildrenQuery_, GetMetricWithChildrenQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricWithChildrenQuery_, GetMetricWithChildrenQueryVariables_>(GetMetricWithChildrenDocument_, options);
        }
export function useGetMetricWithChildrenSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricWithChildrenQuery_, GetMetricWithChildrenQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricWithChildrenQuery_, GetMetricWithChildrenQueryVariables_>(GetMetricWithChildrenDocument_, options);
        }
export type GetMetricWithChildrenQueryHookResult = ReturnType<typeof useGetMetricWithChildrenQuery>;
export type GetMetricWithChildrenLazyQuery_HookResult = ReturnType<typeof useGetMetricWithChildrenLazyQuery_>;
export type GetMetricWithChildrenSuspenseQuery_HookResult = ReturnType<typeof useGetMetricWithChildrenSuspenseQuery_>;
export type GetMetricWithChildrenQueryResult_ = Apollo.QueryResult<GetMetricWithChildrenQuery_, GetMetricWithChildrenQueryVariables_>;
export function refetchGetMetricWithChildrenQuery_(variables: GetMetricWithChildrenQueryVariables_) {
      return { query: GetMetricWithChildrenDocument_, variables: variables }
    }
export const ReportingUnitsMetricsPerDisclosureDocument_ = gql`
    query reportingUnitsMetricsPerDisclosure($disclosureRequirementRef: String!, $companyAssessmentId: uuid!, $parentAssessmentId: uuid!, $requiredMetrics: [String!]!) {
  assessableMetrics: EsrsMetric(
    order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
    where: {_and: [{_or: [{disclosureRequirementRef: {_eq: $disclosureRequirementRef}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {drToMFDisclosureRequirements: {disclosureRequirementRef: {_eq: $disclosureRequirementRef}}}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $disclosureRequirementRef}}}}]}, {isAssessable: {_eq: true}}, {materialMetrics: {isMaterial: {_eq: true}, _or: [{materialStandard: {id: {_eq: $parentAssessmentId}, isMaterial: {_eq: true}}}, {materialStandard: {id: {_eq: $companyAssessmentId}, isMaterial: {_eq: true}}}]}}, {_or: [{reference: {_in: $requiredMetrics}}, {view_childrenMetrics: {childMetricRef: {_in: $requiredMetrics}}}]}]}
  ) {
    ...ChildlessEsrsMetricsFields
    materialMetrics(where: {materialStandard: {id: {_eq: $companyAssessmentId}}}) {
      ...MaterialMetricsFields
    }
    childrenMetrics(
      order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}]
    ) {
      childMetric {
        ...ChildlessEsrsMetricsFields
        materialMetrics(where: {materialStandardId: {_eq: $companyAssessmentId}}) {
          ...MaterialMetricsFields
        }
        childrenMetrics(
          order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}]
        ) {
          childMetric {
            ...ChildlessEsrsMetricsFields
            materialMetrics(where: {materialStandardId: {_eq: $companyAssessmentId}}) {
              ...MaterialMetricsFields
            }
            childrenMetrics(
              order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}]
            ) {
              childMetric {
                ...ChildlessEsrsMetricsFields
                materialMetrics(where: {materialStandardId: {_eq: $companyAssessmentId}}) {
                  ...MaterialMetricsFields
                }
                childrenMetrics(
                  order_by: [{childMetric: {globalOrder: asc}}, {childMetric: {isAR: asc}}, {childMetric: {order: asc}}, {childMetric: {firstLevel: asc}}, {childMetric: {secondLevel: asc}}]
                ) {
                  childMetric {
                    ...ChildlessEsrsMetricsFields
                    materialMetrics(where: {materialStandardId: {_eq: $companyAssessmentId}}) {
                      ...MaterialMetricsFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${ChildlessEsrsMetricsFieldsFragmentDoc_}
${MaterialMetricsFieldsFragmentDoc_}`;

/**
 * __useReportingUnitsMetricsPerDisclosureQuery__
 *
 * To run a query within a React component, call `useReportingUnitsMetricsPerDisclosureQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingUnitsMetricsPerDisclosureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingUnitsMetricsPerDisclosureQuery({
 *   variables: {
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *      companyAssessmentId: // value for 'companyAssessmentId'
 *      parentAssessmentId: // value for 'parentAssessmentId'
 *      requiredMetrics: // value for 'requiredMetrics'
 *   },
 * });
 */
export function useReportingUnitsMetricsPerDisclosureQuery(baseOptions: Apollo.QueryHookOptions<ReportingUnitsMetricsPerDisclosureQuery_, ReportingUnitsMetricsPerDisclosureQueryVariables_> & ({ variables: ReportingUnitsMetricsPerDisclosureQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingUnitsMetricsPerDisclosureQuery_, ReportingUnitsMetricsPerDisclosureQueryVariables_>(ReportingUnitsMetricsPerDisclosureDocument_, options);
      }
export function useReportingUnitsMetricsPerDisclosureLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ReportingUnitsMetricsPerDisclosureQuery_, ReportingUnitsMetricsPerDisclosureQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingUnitsMetricsPerDisclosureQuery_, ReportingUnitsMetricsPerDisclosureQueryVariables_>(ReportingUnitsMetricsPerDisclosureDocument_, options);
        }
export function useReportingUnitsMetricsPerDisclosureSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingUnitsMetricsPerDisclosureQuery_, ReportingUnitsMetricsPerDisclosureQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingUnitsMetricsPerDisclosureQuery_, ReportingUnitsMetricsPerDisclosureQueryVariables_>(ReportingUnitsMetricsPerDisclosureDocument_, options);
        }
export type ReportingUnitsMetricsPerDisclosureQueryHookResult = ReturnType<typeof useReportingUnitsMetricsPerDisclosureQuery>;
export type ReportingUnitsMetricsPerDisclosureLazyQuery_HookResult = ReturnType<typeof useReportingUnitsMetricsPerDisclosureLazyQuery_>;
export type ReportingUnitsMetricsPerDisclosureSuspenseQuery_HookResult = ReturnType<typeof useReportingUnitsMetricsPerDisclosureSuspenseQuery_>;
export type ReportingUnitsMetricsPerDisclosureQueryResult_ = Apollo.QueryResult<ReportingUnitsMetricsPerDisclosureQuery_, ReportingUnitsMetricsPerDisclosureQueryVariables_>;
export function refetchReportingUnitsMetricsPerDisclosureQuery_(variables: ReportingUnitsMetricsPerDisclosureQueryVariables_) {
      return { query: ReportingUnitsMetricsPerDisclosureDocument_, variables: variables }
    }
export const GetBuDisclosureRequirementMetricsDocument_ = gql`
    query getBUDisclosureRequirementMetrics($standardRef: String!, $companyStandardId: uuid!, $parentStandardId: uuid!) {
  requirements: DisclosureRequirement(
    where: {type: {_eq: "metric"}, _or: [{group: {standardRef: {_eq: $standardRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {mfDisclosureRequirementGroup: {mfStandard: {mfStandardItems: {standardRef: {_eq: $standardRef}}}}}}}], metrics: {_or: [{materialMetrics: {dataCollection: {_eq: "reportingUnits"}, isMaterial: {_eq: true}, materialStandard: {id: {_eq: $companyStandardId}, isMaterial: {_eq: true}}, childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}}}, {materialMetrics: {dataCollection: {_eq: "subsidiaries"}, isMaterial: {_eq: true}, materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}}, childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}, _and: {materialMetrics: {materialStandardId: {_eq: $companyStandardId}, dataCollection: {_eq: "reportingUnits"}}}}]}}
  ) {
    title
    reference
    type
    description
    groupRef
    order
    group {
      standardRef
    }
    metrics(
      where: {_or: [{materialMetrics: {dataCollection: {_eq: "reportingUnits"}, isMaterial: {_eq: true}, materialStandard: {id: {_eq: $companyStandardId}, isMaterial: {_eq: true}}, childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}}}, {materialMetrics: {dataCollection: {_eq: "subsidiaries"}, isMaterial: {_eq: true}, materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}}, childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}, _and: {materialMetrics: {materialStandardId: {_eq: $companyStandardId}, dataCollection: {_eq: "reportingUnits"}}}}]}
    ) {
      relatedDRs(
        where: {disclosureRequirement: {group: {standardRef: {_eq: $standardRef}}}}
      ) {
        disclosureRequirement {
          title
          reference
          type
          description
          groupRef
          order
          group {
            standardRef
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBuDisclosureRequirementMetricsQuery__
 *
 * To run a query within a React component, call `useGetBuDisclosureRequirementMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuDisclosureRequirementMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuDisclosureRequirementMetricsQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *      companyStandardId: // value for 'companyStandardId'
 *      parentStandardId: // value for 'parentStandardId'
 *   },
 * });
 */
export function useGetBuDisclosureRequirementMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetBuDisclosureRequirementMetricsQuery_, GetBuDisclosureRequirementMetricsQueryVariables_> & ({ variables: GetBuDisclosureRequirementMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuDisclosureRequirementMetricsQuery_, GetBuDisclosureRequirementMetricsQueryVariables_>(GetBuDisclosureRequirementMetricsDocument_, options);
      }
export function useGetBuDisclosureRequirementMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetBuDisclosureRequirementMetricsQuery_, GetBuDisclosureRequirementMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuDisclosureRequirementMetricsQuery_, GetBuDisclosureRequirementMetricsQueryVariables_>(GetBuDisclosureRequirementMetricsDocument_, options);
        }
export function useGetBuDisclosureRequirementMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBuDisclosureRequirementMetricsQuery_, GetBuDisclosureRequirementMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBuDisclosureRequirementMetricsQuery_, GetBuDisclosureRequirementMetricsQueryVariables_>(GetBuDisclosureRequirementMetricsDocument_, options);
        }
export type GetBuDisclosureRequirementMetricsQueryHookResult = ReturnType<typeof useGetBuDisclosureRequirementMetricsQuery>;
export type GetBuDisclosureRequirementMetricsLazyQuery_HookResult = ReturnType<typeof useGetBuDisclosureRequirementMetricsLazyQuery_>;
export type GetBuDisclosureRequirementMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetBuDisclosureRequirementMetricsSuspenseQuery_>;
export type GetBuDisclosureRequirementMetricsQueryResult_ = Apollo.QueryResult<GetBuDisclosureRequirementMetricsQuery_, GetBuDisclosureRequirementMetricsQueryVariables_>;
export function refetchGetBuDisclosureRequirementMetricsQuery_(variables: GetBuDisclosureRequirementMetricsQueryVariables_) {
      return { query: GetBuDisclosureRequirementMetricsDocument_, variables: variables }
    }
export const GetBumfDisclosureRequirementMetricsDocument_ = gql`
    query getBUMFDisclosureRequirementMetrics($mfStandardRef: String!, $materialStandardId: uuid!, $parentStandardId: uuid!) {
  requirements: MFDisclosureRequirement(
    where: {type: {_eq: "metric"}, mfDisclosureRequirementGroup: {mfStandardRef: {_eq: $mfStandardRef}}, mfDisclosureRequirementItems: {metric: {_or: [{materialMetrics: {dataCollection: {_eq: "reportingUnits"}, isMaterial: {_eq: true}, materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}, childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}}}, {materialMetrics: {dataCollection: {_eq: "subsidiaries"}, isMaterial: {_eq: true}, materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}}, childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}, _and: {materialMetrics: {materialStandardId: {_eq: $materialStandardId}, dataCollection: {_eq: "reportingUnits"}}}}]}}}
  ) {
    title
    reference
    type
    description
    groupRef: mfDisclosureRequirementGroupRef
    order
  }
}
    `;

/**
 * __useGetBumfDisclosureRequirementMetricsQuery__
 *
 * To run a query within a React component, call `useGetBumfDisclosureRequirementMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBumfDisclosureRequirementMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBumfDisclosureRequirementMetricsQuery({
 *   variables: {
 *      mfStandardRef: // value for 'mfStandardRef'
 *      materialStandardId: // value for 'materialStandardId'
 *      parentStandardId: // value for 'parentStandardId'
 *   },
 * });
 */
export function useGetBumfDisclosureRequirementMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetBumfDisclosureRequirementMetricsQuery_, GetBumfDisclosureRequirementMetricsQueryVariables_> & ({ variables: GetBumfDisclosureRequirementMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBumfDisclosureRequirementMetricsQuery_, GetBumfDisclosureRequirementMetricsQueryVariables_>(GetBumfDisclosureRequirementMetricsDocument_, options);
      }
export function useGetBumfDisclosureRequirementMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetBumfDisclosureRequirementMetricsQuery_, GetBumfDisclosureRequirementMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBumfDisclosureRequirementMetricsQuery_, GetBumfDisclosureRequirementMetricsQueryVariables_>(GetBumfDisclosureRequirementMetricsDocument_, options);
        }
export function useGetBumfDisclosureRequirementMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBumfDisclosureRequirementMetricsQuery_, GetBumfDisclosureRequirementMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBumfDisclosureRequirementMetricsQuery_, GetBumfDisclosureRequirementMetricsQueryVariables_>(GetBumfDisclosureRequirementMetricsDocument_, options);
        }
export type GetBumfDisclosureRequirementMetricsQueryHookResult = ReturnType<typeof useGetBumfDisclosureRequirementMetricsQuery>;
export type GetBumfDisclosureRequirementMetricsLazyQuery_HookResult = ReturnType<typeof useGetBumfDisclosureRequirementMetricsLazyQuery_>;
export type GetBumfDisclosureRequirementMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetBumfDisclosureRequirementMetricsSuspenseQuery_>;
export type GetBumfDisclosureRequirementMetricsQueryResult_ = Apollo.QueryResult<GetBumfDisclosureRequirementMetricsQuery_, GetBumfDisclosureRequirementMetricsQueryVariables_>;
export function refetchGetBumfDisclosureRequirementMetricsQuery_(variables: GetBumfDisclosureRequirementMetricsQueryVariables_) {
      return { query: GetBumfDisclosureRequirementMetricsDocument_, variables: variables }
    }
export const OptOutMetricDocument_ = gql`
    mutation optOutMetric($objects: [esrs_Answer_insert_input!]!) {
  insert_esrs_Answer(
    objects: $objects
    on_conflict: {constraint: Answer_metricRef_assessmentId_reportingUnitId_key, update_columns: [hasOptedOut, optOutReason]}
  ) {
    affected_rows
  }
}
    `;
export type OptOutMetricMutationFn_ = Apollo.MutationFunction<OptOutMetricMutation_, OptOutMetricMutationVariables_>;

/**
 * __useOptOutMetricMutation__
 *
 * To run a mutation, you first call `useOptOutMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptOutMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optOutMetricMutation, { data, loading, error }] = useOptOutMetricMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useOptOutMetricMutation(baseOptions?: Apollo.MutationHookOptions<OptOutMetricMutation_, OptOutMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptOutMetricMutation_, OptOutMetricMutationVariables_>(OptOutMetricDocument_, options);
      }
export type OptOutMetricMutationHookResult = ReturnType<typeof useOptOutMetricMutation>;
export type OptOutMetricMutationResult_ = Apollo.MutationResult<OptOutMetricMutation_>;
export type OptOutMetricMutationOptions_ = Apollo.BaseMutationOptions<OptOutMetricMutation_, OptOutMetricMutationVariables_>;
export const GetMetricDRandStandardDocument_ = gql`
    query GetMetricDRandStandard($reference: String!) {
  EsrsMetric_by_pk(reference: $reference) {
    reference
    requirement {
      reference
      isMandatory
      group {
        standardRef
      }
    }
  }
}
    `;

/**
 * __useGetMetricDRandStandardQuery__
 *
 * To run a query within a React component, call `useGetMetricDRandStandardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricDRandStandardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricDRandStandardQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useGetMetricDRandStandardQuery(baseOptions: Apollo.QueryHookOptions<GetMetricDRandStandardQuery_, GetMetricDRandStandardQueryVariables_> & ({ variables: GetMetricDRandStandardQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricDRandStandardQuery_, GetMetricDRandStandardQueryVariables_>(GetMetricDRandStandardDocument_, options);
      }
export function useGetMetricDRandStandardLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricDRandStandardQuery_, GetMetricDRandStandardQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricDRandStandardQuery_, GetMetricDRandStandardQueryVariables_>(GetMetricDRandStandardDocument_, options);
        }
export function useGetMetricDRandStandardSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricDRandStandardQuery_, GetMetricDRandStandardQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricDRandStandardQuery_, GetMetricDRandStandardQueryVariables_>(GetMetricDRandStandardDocument_, options);
        }
export type GetMetricDRandStandardQueryHookResult = ReturnType<typeof useGetMetricDRandStandardQuery>;
export type GetMetricDRandStandardLazyQuery_HookResult = ReturnType<typeof useGetMetricDRandStandardLazyQuery_>;
export type GetMetricDRandStandardSuspenseQuery_HookResult = ReturnType<typeof useGetMetricDRandStandardSuspenseQuery_>;
export type GetMetricDRandStandardQueryResult_ = Apollo.QueryResult<GetMetricDRandStandardQuery_, GetMetricDRandStandardQueryVariables_>;
export function refetchGetMetricDRandStandardQuery_(variables: GetMetricDRandStandardQueryVariables_) {
      return { query: GetMetricDRandStandardDocument_, variables: variables }
    }
export const GetMetricMaterialityDocument_ = gql`
    query getMetricMateriality($reference: String!) {
  esrs_MaterialMetric(where: {metricRef: {_eq: $reference}}) {
    isMaterial
    dataCollection
    frequency
    isDataGatheringOnly
    isHidden
    materialStandardId
  }
}
    `;

/**
 * __useGetMetricMaterialityQuery__
 *
 * To run a query within a React component, call `useGetMetricMaterialityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricMaterialityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricMaterialityQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useGetMetricMaterialityQuery(baseOptions: Apollo.QueryHookOptions<GetMetricMaterialityQuery_, GetMetricMaterialityQueryVariables_> & ({ variables: GetMetricMaterialityQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricMaterialityQuery_, GetMetricMaterialityQueryVariables_>(GetMetricMaterialityDocument_, options);
      }
export function useGetMetricMaterialityLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricMaterialityQuery_, GetMetricMaterialityQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricMaterialityQuery_, GetMetricMaterialityQueryVariables_>(GetMetricMaterialityDocument_, options);
        }
export function useGetMetricMaterialitySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricMaterialityQuery_, GetMetricMaterialityQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricMaterialityQuery_, GetMetricMaterialityQueryVariables_>(GetMetricMaterialityDocument_, options);
        }
export type GetMetricMaterialityQueryHookResult = ReturnType<typeof useGetMetricMaterialityQuery>;
export type GetMetricMaterialityLazyQuery_HookResult = ReturnType<typeof useGetMetricMaterialityLazyQuery_>;
export type GetMetricMaterialitySuspenseQuery_HookResult = ReturnType<typeof useGetMetricMaterialitySuspenseQuery_>;
export type GetMetricMaterialityQueryResult_ = Apollo.QueryResult<GetMetricMaterialityQuery_, GetMetricMaterialityQueryVariables_>;
export function refetchGetMetricMaterialityQuery_(variables: GetMetricMaterialityQueryVariables_) {
      return { query: GetMetricMaterialityDocument_, variables: variables }
    }
export const GetAllChildrenMetricsDocument_ = gql`
    query getAllChildrenMetrics($requiredMetrics: [String!]!, $materialStandardId: uuid!) {
  EsrsMetric(
    where: {reference: {_in: $requiredMetrics}, materialMetrics: {materialStandardId: {_eq: $materialStandardId}}}
  ) {
    reference
    metricType
    childrenMetrics {
      childMetric {
        reference
        materialMetrics(where: {materialStandardId: {_eq: $materialStandardId}}) {
          id
        }
      }
    }
    materialMetrics(where: {materialStandardId: {_eq: $materialStandardId}}) {
      id
      materialStandardId
      isMaterial
    }
  }
}
    `;

/**
 * __useGetAllChildrenMetricsQuery__
 *
 * To run a query within a React component, call `useGetAllChildrenMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllChildrenMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllChildrenMetricsQuery({
 *   variables: {
 *      requiredMetrics: // value for 'requiredMetrics'
 *      materialStandardId: // value for 'materialStandardId'
 *   },
 * });
 */
export function useGetAllChildrenMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetAllChildrenMetricsQuery_, GetAllChildrenMetricsQueryVariables_> & ({ variables: GetAllChildrenMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllChildrenMetricsQuery_, GetAllChildrenMetricsQueryVariables_>(GetAllChildrenMetricsDocument_, options);
      }
export function useGetAllChildrenMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAllChildrenMetricsQuery_, GetAllChildrenMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllChildrenMetricsQuery_, GetAllChildrenMetricsQueryVariables_>(GetAllChildrenMetricsDocument_, options);
        }
export function useGetAllChildrenMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllChildrenMetricsQuery_, GetAllChildrenMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllChildrenMetricsQuery_, GetAllChildrenMetricsQueryVariables_>(GetAllChildrenMetricsDocument_, options);
        }
export type GetAllChildrenMetricsQueryHookResult = ReturnType<typeof useGetAllChildrenMetricsQuery>;
export type GetAllChildrenMetricsLazyQuery_HookResult = ReturnType<typeof useGetAllChildrenMetricsLazyQuery_>;
export type GetAllChildrenMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetAllChildrenMetricsSuspenseQuery_>;
export type GetAllChildrenMetricsQueryResult_ = Apollo.QueryResult<GetAllChildrenMetricsQuery_, GetAllChildrenMetricsQueryVariables_>;
export function refetchGetAllChildrenMetricsQuery_(variables: GetAllChildrenMetricsQueryVariables_) {
      return { query: GetAllChildrenMetricsDocument_, variables: variables }
    }
export const DeleteMaterialMetricsDocument_ = gql`
    mutation deleteMaterialMetrics($ids: [uuid!]!) {
  delete_esrs_MaterialMetric(where: {id: {_in: $ids}}) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type DeleteMaterialMetricsMutationFn_ = Apollo.MutationFunction<DeleteMaterialMetricsMutation_, DeleteMaterialMetricsMutationVariables_>;

/**
 * __useDeleteMaterialMetricsMutation__
 *
 * To run a mutation, you first call `useDeleteMaterialMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMaterialMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMaterialMetricsMutation, { data, loading, error }] = useDeleteMaterialMetricsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteMaterialMetricsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMaterialMetricsMutation_, DeleteMaterialMetricsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMaterialMetricsMutation_, DeleteMaterialMetricsMutationVariables_>(DeleteMaterialMetricsDocument_, options);
      }
export type DeleteMaterialMetricsMutationHookResult = ReturnType<typeof useDeleteMaterialMetricsMutation>;
export type DeleteMaterialMetricsMutationResult_ = Apollo.MutationResult<DeleteMaterialMetricsMutation_>;
export type DeleteMaterialMetricsMutationOptions_ = Apollo.BaseMutationOptions<DeleteMaterialMetricsMutation_, DeleteMaterialMetricsMutationVariables_>;
export const DeleteMaterialMetricDocument_ = gql`
    mutation deleteMaterialMetric($id: uuid!) {
  delete_esrs_MaterialMetric_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteMaterialMetricMutationFn_ = Apollo.MutationFunction<DeleteMaterialMetricMutation_, DeleteMaterialMetricMutationVariables_>;

/**
 * __useDeleteMaterialMetricMutation__
 *
 * To run a mutation, you first call `useDeleteMaterialMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMaterialMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMaterialMetricMutation, { data, loading, error }] = useDeleteMaterialMetricMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMaterialMetricMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMaterialMetricMutation_, DeleteMaterialMetricMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMaterialMetricMutation_, DeleteMaterialMetricMutationVariables_>(DeleteMaterialMetricDocument_, options);
      }
export type DeleteMaterialMetricMutationHookResult = ReturnType<typeof useDeleteMaterialMetricMutation>;
export type DeleteMaterialMetricMutationResult_ = Apollo.MutationResult<DeleteMaterialMetricMutation_>;
export type DeleteMaterialMetricMutationOptions_ = Apollo.BaseMutationOptions<DeleteMaterialMetricMutation_, DeleteMaterialMetricMutationVariables_>;
export const GetParentAssessmentMaterialMetricsDocument_ = gql`
    query getParentAssessmentMaterialMetrics($parentAssessmentId: uuid!) {
  esrs_MaterialMetric(
    where: {materialStandard: {assessmentId: {_eq: $parentAssessmentId}}}
  ) {
    id
    metricRef
    isMaterial
    isDataGatheringOnly
    isPhasedIn
    dataCollection
    materialStandard {
      id
      standardRef
      isMaterial
    }
    metric {
      requirement {
        reference
      }
    }
  }
}
    `;

/**
 * __useGetParentAssessmentMaterialMetricsQuery__
 *
 * To run a query within a React component, call `useGetParentAssessmentMaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentAssessmentMaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentAssessmentMaterialMetricsQuery({
 *   variables: {
 *      parentAssessmentId: // value for 'parentAssessmentId'
 *   },
 * });
 */
export function useGetParentAssessmentMaterialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetParentAssessmentMaterialMetricsQuery_, GetParentAssessmentMaterialMetricsQueryVariables_> & ({ variables: GetParentAssessmentMaterialMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParentAssessmentMaterialMetricsQuery_, GetParentAssessmentMaterialMetricsQueryVariables_>(GetParentAssessmentMaterialMetricsDocument_, options);
      }
export function useGetParentAssessmentMaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetParentAssessmentMaterialMetricsQuery_, GetParentAssessmentMaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParentAssessmentMaterialMetricsQuery_, GetParentAssessmentMaterialMetricsQueryVariables_>(GetParentAssessmentMaterialMetricsDocument_, options);
        }
export function useGetParentAssessmentMaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParentAssessmentMaterialMetricsQuery_, GetParentAssessmentMaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParentAssessmentMaterialMetricsQuery_, GetParentAssessmentMaterialMetricsQueryVariables_>(GetParentAssessmentMaterialMetricsDocument_, options);
        }
export type GetParentAssessmentMaterialMetricsQueryHookResult = ReturnType<typeof useGetParentAssessmentMaterialMetricsQuery>;
export type GetParentAssessmentMaterialMetricsLazyQuery_HookResult = ReturnType<typeof useGetParentAssessmentMaterialMetricsLazyQuery_>;
export type GetParentAssessmentMaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetParentAssessmentMaterialMetricsSuspenseQuery_>;
export type GetParentAssessmentMaterialMetricsQueryResult_ = Apollo.QueryResult<GetParentAssessmentMaterialMetricsQuery_, GetParentAssessmentMaterialMetricsQueryVariables_>;
export function refetchGetParentAssessmentMaterialMetricsQuery_(variables: GetParentAssessmentMaterialMetricsQueryVariables_) {
      return { query: GetParentAssessmentMaterialMetricsDocument_, variables: variables }
    }
export const GetCategoryAndStandardsDocument_ = gql`
    query getCategoryAndStandards($assessmentId: uuid!, $framework: String!, $frameworkRefs: [String!]) {
  MFCategory {
    title
    reference
    mfStandards {
      title
      reference
      mfStandardItems(
        where: {standard: {framework: {reference: {_in: $frameworkRefs}}}}
      ) {
        standard {
          title
          reference
          isTopical
          materialStandards(where: {assessmentId: {_eq: $assessmentId}}) {
            id
            isMaterial
            isDataGatheringOnly
            isPhasedIn
            isDataCollected
          }
          framework {
            name
            reference
          }
          disclosureRequirementGroups {
            requirements {
              metrics_aggregate(
                where: {_or: [{requirement: {isMandatory: {_eq: false}}}, {requirement: {frameworkRef: {_neq: $framework}}}]}
              ) {
                aggregate {
                  count
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCategoryAndStandardsQuery__
 *
 * To run a query within a React component, call `useGetCategoryAndStandardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCategoryAndStandardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCategoryAndStandardsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      framework: // value for 'framework'
 *      frameworkRefs: // value for 'frameworkRefs'
 *   },
 * });
 */
export function useGetCategoryAndStandardsQuery(baseOptions: Apollo.QueryHookOptions<GetCategoryAndStandardsQuery_, GetCategoryAndStandardsQueryVariables_> & ({ variables: GetCategoryAndStandardsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCategoryAndStandardsQuery_, GetCategoryAndStandardsQueryVariables_>(GetCategoryAndStandardsDocument_, options);
      }
export function useGetCategoryAndStandardsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetCategoryAndStandardsQuery_, GetCategoryAndStandardsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCategoryAndStandardsQuery_, GetCategoryAndStandardsQueryVariables_>(GetCategoryAndStandardsDocument_, options);
        }
export function useGetCategoryAndStandardsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCategoryAndStandardsQuery_, GetCategoryAndStandardsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCategoryAndStandardsQuery_, GetCategoryAndStandardsQueryVariables_>(GetCategoryAndStandardsDocument_, options);
        }
export type GetCategoryAndStandardsQueryHookResult = ReturnType<typeof useGetCategoryAndStandardsQuery>;
export type GetCategoryAndStandardsLazyQuery_HookResult = ReturnType<typeof useGetCategoryAndStandardsLazyQuery_>;
export type GetCategoryAndStandardsSuspenseQuery_HookResult = ReturnType<typeof useGetCategoryAndStandardsSuspenseQuery_>;
export type GetCategoryAndStandardsQueryResult_ = Apollo.QueryResult<GetCategoryAndStandardsQuery_, GetCategoryAndStandardsQueryVariables_>;
export function refetchGetCategoryAndStandardsQuery_(variables: GetCategoryAndStandardsQueryVariables_) {
      return { query: GetCategoryAndStandardsDocument_, variables: variables }
    }
export const GetMFdrForMFstandardDocument_ = gql`
    query getMFdrForMFstandard($mfStandardRef: String, $frameworkRefs: [String!], $assessmentId: uuid!, $assessmentFrameworkRef: String!) {
  MFStandard(where: {reference: {_eq: $mfStandardRef}}) {
    mfDisclosureRequirementGroups {
      mfDisclosureRequirements {
        title
        reference
        mfDisclosureRequirementItems(
          where: {metric: {requirement: {frameworkRef: {_in: $frameworkRefs}}}}
        ) {
          metric {
            reference
            title
            shortTitle
            metricType
            description
            order
            firstLevel
            secondLevel
            disclosureRequirementRef
            requirement {
              reference
              title
              frameworkRef
              isMandatory
              group {
                standard {
                  reference
                  frameworkRef
                }
              }
            }
            mfDisclosureRequirements_aggregate(
              where: {mfDisclosureRequirement: {drToMFDisclosureRequirements: {disclosureRequirement: {frameworkRef: {_eq: $assessmentFrameworkRef}}}}}
            ) {
              aggregate {
                count
              }
            }
            mfDisclosureRequirements {
              mfDisclosureRequirement {
                mfDisclosureRequirementGroup {
                  mfStandardRef
                }
              }
            }
            tags {
              type
            }
            materialMetrics(where: {materialStandard: {assessmentId: {_eq: $assessmentId}}}) {
              id
              isMaterial
              isDataGatheringOnly
              isPhasedIn
              materialStandardId
              materialMetricTags {
                type: tagType
              }
            }
            parentMetrics {
              parentMetric {
                reference
                tags {
                  type
                  isOptional
                  tagType {
                    type
                    alwaysAll
                    tagValues(order_by: [{order: asc}, {value: asc}]) {
                      value
                    }
                  }
                }
              }
            }
            description
            tags {
              type
              isOptional
              tagType {
                type
                alwaysAll
                tagValues(order_by: [{order: asc}, {value: asc}]) {
                  value
                }
              }
            }
            isAR
            isAssessable
            additionalTypes {
              additionalType {
                reference
                title
                description
                learnMore
              }
            }
            childrenMetrics {
              childMetricRef
              order
              parentMetricRef
              childMetric {
                reference
                isAssessable
                parentMetrics {
                  parentMetric {
                    reference
                  }
                }
                childrenMetrics {
                  childMetricRef
                  order
                  parentMetricRef
                  childMetric {
                    reference
                    isAssessable
                    parentMetrics {
                      parentMetric {
                        reference
                      }
                    }
                    childrenMetrics {
                      childMetricRef
                      order
                      parentMetricRef
                      childMetric {
                        reference
                        isAssessable
                        parentMetrics {
                          parentMetric {
                            reference
                          }
                        }
                        childrenMetrics {
                          childMetricRef
                          order
                          parentMetricRef
                          childMetric {
                            reference
                            isAssessable
                            parentMetrics {
                              parentMetric {
                                reference
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMFdrForMFstandardQuery__
 *
 * To run a query within a React component, call `useGetMFdrForMFstandardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMFdrForMFstandardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMFdrForMFstandardQuery({
 *   variables: {
 *      mfStandardRef: // value for 'mfStandardRef'
 *      frameworkRefs: // value for 'frameworkRefs'
 *      assessmentId: // value for 'assessmentId'
 *      assessmentFrameworkRef: // value for 'assessmentFrameworkRef'
 *   },
 * });
 */
export function useGetMFdrForMFstandardQuery(baseOptions: Apollo.QueryHookOptions<GetMFdrForMFstandardQuery_, GetMFdrForMFstandardQueryVariables_> & ({ variables: GetMFdrForMFstandardQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMFdrForMFstandardQuery_, GetMFdrForMFstandardQueryVariables_>(GetMFdrForMFstandardDocument_, options);
      }
export function useGetMFdrForMFstandardLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMFdrForMFstandardQuery_, GetMFdrForMFstandardQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMFdrForMFstandardQuery_, GetMFdrForMFstandardQueryVariables_>(GetMFdrForMFstandardDocument_, options);
        }
export function useGetMFdrForMFstandardSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMFdrForMFstandardQuery_, GetMFdrForMFstandardQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMFdrForMFstandardQuery_, GetMFdrForMFstandardQueryVariables_>(GetMFdrForMFstandardDocument_, options);
        }
export type GetMFdrForMFstandardQueryHookResult = ReturnType<typeof useGetMFdrForMFstandardQuery>;
export type GetMFdrForMFstandardLazyQuery_HookResult = ReturnType<typeof useGetMFdrForMFstandardLazyQuery_>;
export type GetMFdrForMFstandardSuspenseQuery_HookResult = ReturnType<typeof useGetMFdrForMFstandardSuspenseQuery_>;
export type GetMFdrForMFstandardQueryResult_ = Apollo.QueryResult<GetMFdrForMFstandardQuery_, GetMFdrForMFstandardQueryVariables_>;
export function refetchGetMFdrForMFstandardQuery_(variables: GetMFdrForMFstandardQueryVariables_) {
      return { query: GetMFdrForMFstandardDocument_, variables: variables }
    }
export const GetSelectedDataPointsDocument_ = gql`
    query getSelectedDataPoints($assessmentId: uuid!, $framework: String!) {
  EsrsMetric(
    where: {requirement: {frameworkRef: {_neq: $framework}}, materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}, isMaterial: {_is_null: false}}}
  ) {
    reference
    title
    shortTitle
    metricType
    description
    order
    firstLevel
    secondLevel
    disclosureRequirementRef
    mfDisclosureRequirements_aggregate(
      where: {mfDisclosureRequirement: {drToMFDisclosureRequirements: {disclosureRequirement: {frameworkRef: {_eq: $framework}}}}}
    ) {
      aggregate {
        count
      }
    }
    mfDisclosureRequirements {
      mfDisclosureRequirement {
        title
        reference
        mfDisclosureRequirementGroup {
          mfStandardRef
        }
      }
    }
    materialMetrics(where: {materialStandard: {assessmentId: {_eq: $assessmentId}}}) {
      id
      isMaterial
      isDataGatheringOnly
      isPhasedIn
      materialStandardId
      materialMetricTags {
        type: tagType
      }
    }
    requirement {
      reference
      title
      isMandatory
      group {
        standard {
          reference
          frameworkRef
        }
      }
    }
    parentMetrics {
      parentMetric {
        reference
        tags {
          type
          isOptional
          tagType {
            type
            alwaysAll
            tagValues(order_by: [{order: asc}, {value: asc}]) {
              value
            }
          }
        }
      }
    }
    description
    tags {
      type
      isOptional
      tagType {
        type
        alwaysAll
        tagValues(order_by: [{order: asc}, {value: asc}]) {
          value
        }
      }
    }
    isAR
    isAssessable
    additionalTypes {
      additionalType {
        reference
        title
        description
        learnMore
      }
    }
    childrenMetrics {
      childMetricRef
      order
      parentMetricRef
      childMetric {
        reference
        isAssessable
        parentMetrics {
          parentMetric {
            reference
          }
        }
        childrenMetrics {
          childMetricRef
          order
          parentMetricRef
          childMetric {
            reference
            isAssessable
            parentMetrics {
              parentMetric {
                reference
              }
            }
            childrenMetrics {
              childMetricRef
              order
              parentMetricRef
              childMetric {
                reference
                isAssessable
                parentMetrics {
                  parentMetric {
                    reference
                  }
                }
                childrenMetrics {
                  childMetricRef
                  order
                  parentMetricRef
                  childMetric {
                    reference
                    isAssessable
                    parentMetrics {
                      parentMetric {
                        reference
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSelectedDataPointsQuery__
 *
 * To run a query within a React component, call `useGetSelectedDataPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSelectedDataPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSelectedDataPointsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      framework: // value for 'framework'
 *   },
 * });
 */
export function useGetSelectedDataPointsQuery(baseOptions: Apollo.QueryHookOptions<GetSelectedDataPointsQuery_, GetSelectedDataPointsQueryVariables_> & ({ variables: GetSelectedDataPointsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSelectedDataPointsQuery_, GetSelectedDataPointsQueryVariables_>(GetSelectedDataPointsDocument_, options);
      }
export function useGetSelectedDataPointsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSelectedDataPointsQuery_, GetSelectedDataPointsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSelectedDataPointsQuery_, GetSelectedDataPointsQueryVariables_>(GetSelectedDataPointsDocument_, options);
        }
export function useGetSelectedDataPointsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSelectedDataPointsQuery_, GetSelectedDataPointsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSelectedDataPointsQuery_, GetSelectedDataPointsQueryVariables_>(GetSelectedDataPointsDocument_, options);
        }
export type GetSelectedDataPointsQueryHookResult = ReturnType<typeof useGetSelectedDataPointsQuery>;
export type GetSelectedDataPointsLazyQuery_HookResult = ReturnType<typeof useGetSelectedDataPointsLazyQuery_>;
export type GetSelectedDataPointsSuspenseQuery_HookResult = ReturnType<typeof useGetSelectedDataPointsSuspenseQuery_>;
export type GetSelectedDataPointsQueryResult_ = Apollo.QueryResult<GetSelectedDataPointsQuery_, GetSelectedDataPointsQueryVariables_>;
export function refetchGetSelectedDataPointsQuery_(variables: GetSelectedDataPointsQueryVariables_) {
      return { query: GetSelectedDataPointsDocument_, variables: variables }
    }
export const GetMetricsForMfDrDocument_ = gql`
    query getMetricsForMfDr($mfDrRef: String, $frameworkRefs: [String!], $assessmentId: uuid!, $assessmentFrameworkRef: String!) {
  MFDisclosureRequirementItem(
    where: {mfDisclosureRequirementRef: {_eq: $mfDrRef}, metric: {requirement: {frameworkRef: {_in: $frameworkRefs}}}}
  ) {
    metric {
      reference
      title
      shortTitle
      metricType
      description
      order
      firstLevel
      secondLevel
      disclosureRequirementRef
      mfDisclosureRequirements_aggregate(
        where: {mfDisclosureRequirement: {drToMFDisclosureRequirements: {disclosureRequirement: {frameworkRef: {_eq: $assessmentFrameworkRef}}}}}
      ) {
        aggregate {
          count
        }
      }
      mfDisclosureRequirements {
        mfDisclosureRequirement {
          mfDisclosureRequirementGroup {
            mfStandardRef
          }
        }
      }
      requirement {
        title
        frameworkRef
        isMandatory
        group {
          standard {
            reference
            frameworkRef
          }
        }
      }
      tags {
        type
      }
      materialMetrics(where: {materialStandard: {assessmentId: {_eq: $assessmentId}}}) {
        id
        isMaterial
        isDataGatheringOnly
        isPhasedIn
        materialStandardId
        materialMetricTags {
          type: tagType
        }
      }
      parentMetrics {
        parentMetric {
          reference
          tags {
            type
            isOptional
            tagType {
              type
              alwaysAll
              tagValues(order_by: [{order: asc}, {value: asc}]) {
                value
              }
            }
          }
        }
      }
      description
      tags {
        type
        isOptional
        tagType {
          type
          alwaysAll
          tagValues(order_by: [{order: asc}, {value: asc}]) {
            value
          }
        }
      }
      isAR
      isAssessable
      additionalTypes {
        additionalType {
          reference
          title
          description
          learnMore
        }
      }
      childrenMetrics {
        childMetricRef
        order
        parentMetricRef
        childMetric {
          reference
          isAssessable
          parentMetrics {
            parentMetric {
              reference
            }
          }
          childrenMetrics {
            childMetricRef
            order
            parentMetricRef
            childMetric {
              reference
              isAssessable
              parentMetrics {
                parentMetric {
                  reference
                }
              }
              childrenMetrics {
                childMetricRef
                order
                parentMetricRef
                childMetric {
                  reference
                  isAssessable
                  parentMetrics {
                    parentMetric {
                      reference
                    }
                  }
                  childrenMetrics {
                    childMetricRef
                    order
                    parentMetricRef
                    childMetric {
                      reference
                      isAssessable
                      parentMetrics {
                        parentMetric {
                          reference
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMetricsForMfDrQuery__
 *
 * To run a query within a React component, call `useGetMetricsForMfDrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricsForMfDrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricsForMfDrQuery({
 *   variables: {
 *      mfDrRef: // value for 'mfDrRef'
 *      frameworkRefs: // value for 'frameworkRefs'
 *      assessmentId: // value for 'assessmentId'
 *      assessmentFrameworkRef: // value for 'assessmentFrameworkRef'
 *   },
 * });
 */
export function useGetMetricsForMfDrQuery(baseOptions: Apollo.QueryHookOptions<GetMetricsForMfDrQuery_, GetMetricsForMfDrQueryVariables_> & ({ variables: GetMetricsForMfDrQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricsForMfDrQuery_, GetMetricsForMfDrQueryVariables_>(GetMetricsForMfDrDocument_, options);
      }
export function useGetMetricsForMfDrLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricsForMfDrQuery_, GetMetricsForMfDrQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricsForMfDrQuery_, GetMetricsForMfDrQueryVariables_>(GetMetricsForMfDrDocument_, options);
        }
export function useGetMetricsForMfDrSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricsForMfDrQuery_, GetMetricsForMfDrQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricsForMfDrQuery_, GetMetricsForMfDrQueryVariables_>(GetMetricsForMfDrDocument_, options);
        }
export type GetMetricsForMfDrQueryHookResult = ReturnType<typeof useGetMetricsForMfDrQuery>;
export type GetMetricsForMfDrLazyQuery_HookResult = ReturnType<typeof useGetMetricsForMfDrLazyQuery_>;
export type GetMetricsForMfDrSuspenseQuery_HookResult = ReturnType<typeof useGetMetricsForMfDrSuspenseQuery_>;
export type GetMetricsForMfDrQueryResult_ = Apollo.QueryResult<GetMetricsForMfDrQuery_, GetMetricsForMfDrQueryVariables_>;
export function refetchGetMetricsForMfDrQuery_(variables: GetMetricsForMfDrQueryVariables_) {
      return { query: GetMetricsForMfDrDocument_, variables: variables }
    }
export const GetSubsidiariesMaterialMetricsDocument_ = gql`
    query getSubsidiariesMaterialMetrics($parentAssessmentId: uuid!, $metricRefs: [String!]!) {
  esrs_MaterialMetric(
    where: {metricRef: {_in: $metricRefs}, materialStandard: {esrsAssessment: {parentAssessmentId: {_eq: $parentAssessmentId}}}}
  ) {
    id
    frequency
    metricRef
    materialStandardId
    dataCollection
  }
}
    `;

/**
 * __useGetSubsidiariesMaterialMetricsQuery__
 *
 * To run a query within a React component, call `useGetSubsidiariesMaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsidiariesMaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsidiariesMaterialMetricsQuery({
 *   variables: {
 *      parentAssessmentId: // value for 'parentAssessmentId'
 *      metricRefs: // value for 'metricRefs'
 *   },
 * });
 */
export function useGetSubsidiariesMaterialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetSubsidiariesMaterialMetricsQuery_, GetSubsidiariesMaterialMetricsQueryVariables_> & ({ variables: GetSubsidiariesMaterialMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsidiariesMaterialMetricsQuery_, GetSubsidiariesMaterialMetricsQueryVariables_>(GetSubsidiariesMaterialMetricsDocument_, options);
      }
export function useGetSubsidiariesMaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsidiariesMaterialMetricsQuery_, GetSubsidiariesMaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsidiariesMaterialMetricsQuery_, GetSubsidiariesMaterialMetricsQueryVariables_>(GetSubsidiariesMaterialMetricsDocument_, options);
        }
export function useGetSubsidiariesMaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubsidiariesMaterialMetricsQuery_, GetSubsidiariesMaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubsidiariesMaterialMetricsQuery_, GetSubsidiariesMaterialMetricsQueryVariables_>(GetSubsidiariesMaterialMetricsDocument_, options);
        }
export type GetSubsidiariesMaterialMetricsQueryHookResult = ReturnType<typeof useGetSubsidiariesMaterialMetricsQuery>;
export type GetSubsidiariesMaterialMetricsLazyQuery_HookResult = ReturnType<typeof useGetSubsidiariesMaterialMetricsLazyQuery_>;
export type GetSubsidiariesMaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetSubsidiariesMaterialMetricsSuspenseQuery_>;
export type GetSubsidiariesMaterialMetricsQueryResult_ = Apollo.QueryResult<GetSubsidiariesMaterialMetricsQuery_, GetSubsidiariesMaterialMetricsQueryVariables_>;
export function refetchGetSubsidiariesMaterialMetricsQuery_(variables: GetSubsidiariesMaterialMetricsQueryVariables_) {
      return { query: GetSubsidiariesMaterialMetricsDocument_, variables: variables }
    }
export const GetDrOwnerDocument_ = gql`
    query getDrOwner($drRef: String!, $materialStandardId: uuid!, $reportingUnitId: uuid!) {
  DisclosureRequirementOwner(
    limit: 1
    where: {materialStandardId: {_eq: $materialStandardId}, disclosureRequirementRef: {_eq: $drRef}, reportingUnitId: {_eq: $reportingUnitId}}
  ) {
    owner {
      ...ShortUser
    }
  }
}
    ${ShortUserFragmentDoc_}`;

/**
 * __useGetDrOwnerQuery__
 *
 * To run a query within a React component, call `useGetDrOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrOwnerQuery({
 *   variables: {
 *      drRef: // value for 'drRef'
 *      materialStandardId: // value for 'materialStandardId'
 *      reportingUnitId: // value for 'reportingUnitId'
 *   },
 * });
 */
export function useGetDrOwnerQuery(baseOptions: Apollo.QueryHookOptions<GetDrOwnerQuery_, GetDrOwnerQueryVariables_> & ({ variables: GetDrOwnerQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDrOwnerQuery_, GetDrOwnerQueryVariables_>(GetDrOwnerDocument_, options);
      }
export function useGetDrOwnerLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDrOwnerQuery_, GetDrOwnerQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDrOwnerQuery_, GetDrOwnerQueryVariables_>(GetDrOwnerDocument_, options);
        }
export function useGetDrOwnerSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDrOwnerQuery_, GetDrOwnerQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDrOwnerQuery_, GetDrOwnerQueryVariables_>(GetDrOwnerDocument_, options);
        }
export type GetDrOwnerQueryHookResult = ReturnType<typeof useGetDrOwnerQuery>;
export type GetDrOwnerLazyQuery_HookResult = ReturnType<typeof useGetDrOwnerLazyQuery_>;
export type GetDrOwnerSuspenseQuery_HookResult = ReturnType<typeof useGetDrOwnerSuspenseQuery_>;
export type GetDrOwnerQueryResult_ = Apollo.QueryResult<GetDrOwnerQuery_, GetDrOwnerQueryVariables_>;
export function refetchGetDrOwnerQuery_(variables: GetDrOwnerQueryVariables_) {
      return { query: GetDrOwnerDocument_, variables: variables }
    }
export const GetRequiredStandardMaterialMetricsDocument_ = gql`
    query getRequiredStandardMaterialMetrics($materialStandardId: uuid!, $parentStandardId: uuid!) {
  esrs_MaterialMetric(
    where: {_or: [{isMaterial: {_eq: true}, materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}}, {isMaterial: {_eq: true}, materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}, metric: {hierarchyStatus: {isLeaf: {_eq: true}}}, _and: {metric: {materialMetrics: {materialStandardId: {_eq: $materialStandardId}}}}}]}
  ) {
    metricRef
  }
}
    `;

/**
 * __useGetRequiredStandardMaterialMetricsQuery__
 *
 * To run a query within a React component, call `useGetRequiredStandardMaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredStandardMaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredStandardMaterialMetricsQuery({
 *   variables: {
 *      materialStandardId: // value for 'materialStandardId'
 *      parentStandardId: // value for 'parentStandardId'
 *   },
 * });
 */
export function useGetRequiredStandardMaterialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetRequiredStandardMaterialMetricsQuery_, GetRequiredStandardMaterialMetricsQueryVariables_> & ({ variables: GetRequiredStandardMaterialMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequiredStandardMaterialMetricsQuery_, GetRequiredStandardMaterialMetricsQueryVariables_>(GetRequiredStandardMaterialMetricsDocument_, options);
      }
export function useGetRequiredStandardMaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetRequiredStandardMaterialMetricsQuery_, GetRequiredStandardMaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequiredStandardMaterialMetricsQuery_, GetRequiredStandardMaterialMetricsQueryVariables_>(GetRequiredStandardMaterialMetricsDocument_, options);
        }
export function useGetRequiredStandardMaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequiredStandardMaterialMetricsQuery_, GetRequiredStandardMaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequiredStandardMaterialMetricsQuery_, GetRequiredStandardMaterialMetricsQueryVariables_>(GetRequiredStandardMaterialMetricsDocument_, options);
        }
export type GetRequiredStandardMaterialMetricsQueryHookResult = ReturnType<typeof useGetRequiredStandardMaterialMetricsQuery>;
export type GetRequiredStandardMaterialMetricsLazyQuery_HookResult = ReturnType<typeof useGetRequiredStandardMaterialMetricsLazyQuery_>;
export type GetRequiredStandardMaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetRequiredStandardMaterialMetricsSuspenseQuery_>;
export type GetRequiredStandardMaterialMetricsQueryResult_ = Apollo.QueryResult<GetRequiredStandardMaterialMetricsQuery_, GetRequiredStandardMaterialMetricsQueryVariables_>;
export function refetchGetRequiredStandardMaterialMetricsQuery_(variables: GetRequiredStandardMaterialMetricsQueryVariables_) {
      return { query: GetRequiredStandardMaterialMetricsDocument_, variables: variables }
    }
export const GetMaterialStandardMetricsDocument_ = gql`
    query getMaterialStandardMetrics($materialStandardId: uuid!, $requiredMetrics: [String!]!) {
  EsrsMetric(
    where: {_or: [{reference: {_in: $requiredMetrics}}, {view_childrenMetrics: {childMetricRef: {_in: $requiredMetrics}}}]}
  ) {
    reference
    requirement {
      reference
      frameworkRef
    }
    mfDisclosureRequirements {
      mfDisclosureRequirementRef
      mfDisclosureRequirement {
        drToMFDisclosureRequirements {
          disclosureRequirement {
            reference
            frameworkRef
          }
        }
      }
    }
    view_childrenMetrics {
      childMetricRef
    }
    parentMetrics {
      parentMetricRef
    }
    materialMetrics(where: {materialStandard: {id: {_eq: $materialStandardId}}}) {
      id
      frequency
      materialMetricTags {
        ...MaterialMetricTagFields
      }
    }
  }
}
    ${MaterialMetricTagFieldsFragmentDoc_}`;

/**
 * __useGetMaterialStandardMetricsQuery__
 *
 * To run a query within a React component, call `useGetMaterialStandardMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialStandardMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialStandardMetricsQuery({
 *   variables: {
 *      materialStandardId: // value for 'materialStandardId'
 *      requiredMetrics: // value for 'requiredMetrics'
 *   },
 * });
 */
export function useGetMaterialStandardMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialStandardMetricsQuery_, GetMaterialStandardMetricsQueryVariables_> & ({ variables: GetMaterialStandardMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialStandardMetricsQuery_, GetMaterialStandardMetricsQueryVariables_>(GetMaterialStandardMetricsDocument_, options);
      }
export function useGetMaterialStandardMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialStandardMetricsQuery_, GetMaterialStandardMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialStandardMetricsQuery_, GetMaterialStandardMetricsQueryVariables_>(GetMaterialStandardMetricsDocument_, options);
        }
export function useGetMaterialStandardMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaterialStandardMetricsQuery_, GetMaterialStandardMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaterialStandardMetricsQuery_, GetMaterialStandardMetricsQueryVariables_>(GetMaterialStandardMetricsDocument_, options);
        }
export type GetMaterialStandardMetricsQueryHookResult = ReturnType<typeof useGetMaterialStandardMetricsQuery>;
export type GetMaterialStandardMetricsLazyQuery_HookResult = ReturnType<typeof useGetMaterialStandardMetricsLazyQuery_>;
export type GetMaterialStandardMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetMaterialStandardMetricsSuspenseQuery_>;
export type GetMaterialStandardMetricsQueryResult_ = Apollo.QueryResult<GetMaterialStandardMetricsQuery_, GetMaterialStandardMetricsQueryVariables_>;
export function refetchGetMaterialStandardMetricsQuery_(variables: GetMaterialStandardMetricsQueryVariables_) {
      return { query: GetMaterialStandardMetricsDocument_, variables: variables }
    }
export const GetMfDrOwnerDocument_ = gql`
    query getMfDrOwner($mfDrRef: String!, $materialStandardId: uuid!, $reportingUnitId: uuid!) {
  DisclosureRequirementOwner(
    limit: 1
    where: {materialStandardId: {_eq: $materialStandardId}, mfDisclosureRequirementRef: {_eq: $mfDrRef}, reportingUnitId: {_eq: $reportingUnitId}}
  ) {
    owner {
      ...ShortUser
    }
  }
}
    ${ShortUserFragmentDoc_}`;

/**
 * __useGetMfDrOwnerQuery__
 *
 * To run a query within a React component, call `useGetMfDrOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMfDrOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMfDrOwnerQuery({
 *   variables: {
 *      mfDrRef: // value for 'mfDrRef'
 *      materialStandardId: // value for 'materialStandardId'
 *      reportingUnitId: // value for 'reportingUnitId'
 *   },
 * });
 */
export function useGetMfDrOwnerQuery(baseOptions: Apollo.QueryHookOptions<GetMfDrOwnerQuery_, GetMfDrOwnerQueryVariables_> & ({ variables: GetMfDrOwnerQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMfDrOwnerQuery_, GetMfDrOwnerQueryVariables_>(GetMfDrOwnerDocument_, options);
      }
export function useGetMfDrOwnerLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMfDrOwnerQuery_, GetMfDrOwnerQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMfDrOwnerQuery_, GetMfDrOwnerQueryVariables_>(GetMfDrOwnerDocument_, options);
        }
export function useGetMfDrOwnerSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMfDrOwnerQuery_, GetMfDrOwnerQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMfDrOwnerQuery_, GetMfDrOwnerQueryVariables_>(GetMfDrOwnerDocument_, options);
        }
export type GetMfDrOwnerQueryHookResult = ReturnType<typeof useGetMfDrOwnerQuery>;
export type GetMfDrOwnerLazyQuery_HookResult = ReturnType<typeof useGetMfDrOwnerLazyQuery_>;
export type GetMfDrOwnerSuspenseQuery_HookResult = ReturnType<typeof useGetMfDrOwnerSuspenseQuery_>;
export type GetMfDrOwnerQueryResult_ = Apollo.QueryResult<GetMfDrOwnerQuery_, GetMfDrOwnerQueryVariables_>;
export function refetchGetMfDrOwnerQuery_(variables: GetMfDrOwnerQueryVariables_) {
      return { query: GetMfDrOwnerDocument_, variables: variables }
    }
export const GetDrDatapointsTasksDocument_ = gql`
    query getDrDatapointsTasks($taskReferences: [String!]!) {
  Task(where: {table: {_eq: "Datapoint"}, taskReference: {_in: $taskReferences}}) {
    dueDate
    id
    status
    taskReference
    datapoints {
      id
      answer {
        id
        metricRef
      }
    }
    owner {
      ...ShortUser
    }
  }
}
    ${ShortUserFragmentDoc_}`;

/**
 * __useGetDrDatapointsTasksQuery__
 *
 * To run a query within a React component, call `useGetDrDatapointsTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDrDatapointsTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDrDatapointsTasksQuery({
 *   variables: {
 *      taskReferences: // value for 'taskReferences'
 *   },
 * });
 */
export function useGetDrDatapointsTasksQuery(baseOptions: Apollo.QueryHookOptions<GetDrDatapointsTasksQuery_, GetDrDatapointsTasksQueryVariables_> & ({ variables: GetDrDatapointsTasksQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDrDatapointsTasksQuery_, GetDrDatapointsTasksQueryVariables_>(GetDrDatapointsTasksDocument_, options);
      }
export function useGetDrDatapointsTasksLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDrDatapointsTasksQuery_, GetDrDatapointsTasksQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDrDatapointsTasksQuery_, GetDrDatapointsTasksQueryVariables_>(GetDrDatapointsTasksDocument_, options);
        }
export function useGetDrDatapointsTasksSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDrDatapointsTasksQuery_, GetDrDatapointsTasksQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDrDatapointsTasksQuery_, GetDrDatapointsTasksQueryVariables_>(GetDrDatapointsTasksDocument_, options);
        }
export type GetDrDatapointsTasksQueryHookResult = ReturnType<typeof useGetDrDatapointsTasksQuery>;
export type GetDrDatapointsTasksLazyQuery_HookResult = ReturnType<typeof useGetDrDatapointsTasksLazyQuery_>;
export type GetDrDatapointsTasksSuspenseQuery_HookResult = ReturnType<typeof useGetDrDatapointsTasksSuspenseQuery_>;
export type GetDrDatapointsTasksQueryResult_ = Apollo.QueryResult<GetDrDatapointsTasksQuery_, GetDrDatapointsTasksQueryVariables_>;
export function refetchGetDrDatapointsTasksQuery_(variables: GetDrDatapointsTasksQueryVariables_) {
      return { query: GetDrDatapointsTasksDocument_, variables: variables }
    }
export const GetDisclosureRequirementsOwnerDocument_ = gql`
    query getDisclosureRequirementsOwner($drRefs: [String!]!, $materialStandardId: uuid!, $reportingUnitId: uuid!) {
  DisclosureRequirementOwner(
    where: {_or: [{disclosureRequirementRef: {_in: $drRefs}}, {mfDisclosureRequirementRef: {_in: $drRefs}}], materialStandardId: {_eq: $materialStandardId}, reportingUnitId: {_eq: $reportingUnitId}}
  ) {
    disclosureRequirementRef
    mfDisclosureRequirementRef
    owner {
      ...ShortUser
    }
  }
}
    ${ShortUserFragmentDoc_}`;

/**
 * __useGetDisclosureRequirementsOwnerQuery__
 *
 * To run a query within a React component, call `useGetDisclosureRequirementsOwnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisclosureRequirementsOwnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisclosureRequirementsOwnerQuery({
 *   variables: {
 *      drRefs: // value for 'drRefs'
 *      materialStandardId: // value for 'materialStandardId'
 *      reportingUnitId: // value for 'reportingUnitId'
 *   },
 * });
 */
export function useGetDisclosureRequirementsOwnerQuery(baseOptions: Apollo.QueryHookOptions<GetDisclosureRequirementsOwnerQuery_, GetDisclosureRequirementsOwnerQueryVariables_> & ({ variables: GetDisclosureRequirementsOwnerQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisclosureRequirementsOwnerQuery_, GetDisclosureRequirementsOwnerQueryVariables_>(GetDisclosureRequirementsOwnerDocument_, options);
      }
export function useGetDisclosureRequirementsOwnerLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDisclosureRequirementsOwnerQuery_, GetDisclosureRequirementsOwnerQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisclosureRequirementsOwnerQuery_, GetDisclosureRequirementsOwnerQueryVariables_>(GetDisclosureRequirementsOwnerDocument_, options);
        }
export function useGetDisclosureRequirementsOwnerSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDisclosureRequirementsOwnerQuery_, GetDisclosureRequirementsOwnerQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDisclosureRequirementsOwnerQuery_, GetDisclosureRequirementsOwnerQueryVariables_>(GetDisclosureRequirementsOwnerDocument_, options);
        }
export type GetDisclosureRequirementsOwnerQueryHookResult = ReturnType<typeof useGetDisclosureRequirementsOwnerQuery>;
export type GetDisclosureRequirementsOwnerLazyQuery_HookResult = ReturnType<typeof useGetDisclosureRequirementsOwnerLazyQuery_>;
export type GetDisclosureRequirementsOwnerSuspenseQuery_HookResult = ReturnType<typeof useGetDisclosureRequirementsOwnerSuspenseQuery_>;
export type GetDisclosureRequirementsOwnerQueryResult_ = Apollo.QueryResult<GetDisclosureRequirementsOwnerQuery_, GetDisclosureRequirementsOwnerQueryVariables_>;
export function refetchGetDisclosureRequirementsOwnerQuery_(variables: GetDisclosureRequirementsOwnerQueryVariables_) {
      return { query: GetDisclosureRequirementsOwnerDocument_, variables: variables }
    }
export const UpdateMaterialMetricsDocument_ = gql`
    mutation updateMaterialMetrics($updates: [esrs_MaterialMetric_updates!]!) {
  update_esrs_MaterialMetric_many(updates: $updates) {
    affected_rows
    returning {
      id
      metricRef
      frequency
    }
  }
}
    `;
export type UpdateMaterialMetricsMutationFn_ = Apollo.MutationFunction<UpdateMaterialMetricsMutation_, UpdateMaterialMetricsMutationVariables_>;

/**
 * __useUpdateMaterialMetricsMutation__
 *
 * To run a mutation, you first call `useUpdateMaterialMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMaterialMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMaterialMetricsMutation, { data, loading, error }] = useUpdateMaterialMetricsMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateMaterialMetricsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMaterialMetricsMutation_, UpdateMaterialMetricsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMaterialMetricsMutation_, UpdateMaterialMetricsMutationVariables_>(UpdateMaterialMetricsDocument_, options);
      }
export type UpdateMaterialMetricsMutationHookResult = ReturnType<typeof useUpdateMaterialMetricsMutation>;
export type UpdateMaterialMetricsMutationResult_ = Apollo.MutationResult<UpdateMaterialMetricsMutation_>;
export type UpdateMaterialMetricsMutationOptions_ = Apollo.BaseMutationOptions<UpdateMaterialMetricsMutation_, UpdateMaterialMetricsMutationVariables_>;
export const UpsertDrOwnerDocument_ = gql`
    mutation upsertDrOwner($drRef: String!, $materialStandardId: uuid!, $ownerId: uuid!, $reportingUnitId: uuid!) {
  insert_DisclosureRequirementOwner_one(
    object: {disclosureRequirementRef: $drRef, materialStandardId: $materialStandardId, ownerId: $ownerId, reportingUnitId: $reportingUnitId}
    on_conflict: {constraint: DisclosureRequirementOwner_materialStandardId_disclosureReq_key, update_columns: ownerId}
  ) {
    disclosureRequirementRef
    ownerId
  }
}
    `;
export type UpsertDrOwnerMutationFn_ = Apollo.MutationFunction<UpsertDrOwnerMutation_, UpsertDrOwnerMutationVariables_>;

/**
 * __useUpsertDrOwnerMutation__
 *
 * To run a mutation, you first call `useUpsertDrOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDrOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDrOwnerMutation, { data, loading, error }] = useUpsertDrOwnerMutation({
 *   variables: {
 *      drRef: // value for 'drRef'
 *      materialStandardId: // value for 'materialStandardId'
 *      ownerId: // value for 'ownerId'
 *      reportingUnitId: // value for 'reportingUnitId'
 *   },
 * });
 */
export function useUpsertDrOwnerMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDrOwnerMutation_, UpsertDrOwnerMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDrOwnerMutation_, UpsertDrOwnerMutationVariables_>(UpsertDrOwnerDocument_, options);
      }
export type UpsertDrOwnerMutationHookResult = ReturnType<typeof useUpsertDrOwnerMutation>;
export type UpsertDrOwnerMutationResult_ = Apollo.MutationResult<UpsertDrOwnerMutation_>;
export type UpsertDrOwnerMutationOptions_ = Apollo.BaseMutationOptions<UpsertDrOwnerMutation_, UpsertDrOwnerMutationVariables_>;
export const UpsertMfDrOwnerDocument_ = gql`
    mutation upsertMfDrOwner($mfDrRef: String!, $materialStandardId: uuid!, $ownerId: uuid!, $reportingUnitId: uuid!) {
  insert_DisclosureRequirementOwner_one(
    object: {mfDisclosureRequirementRef: $mfDrRef, materialStandardId: $materialStandardId, ownerId: $ownerId, reportingUnitId: $reportingUnitId}
    on_conflict: {constraint: DisclosureRequirementOwner_materialStandardId_mfDisclosureR_key, update_columns: ownerId}
  ) {
    disclosureRequirementRef
    ownerId
  }
}
    `;
export type UpsertMfDrOwnerMutationFn_ = Apollo.MutationFunction<UpsertMfDrOwnerMutation_, UpsertMfDrOwnerMutationVariables_>;

/**
 * __useUpsertMfDrOwnerMutation__
 *
 * To run a mutation, you first call `useUpsertMfDrOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMfDrOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMfDrOwnerMutation, { data, loading, error }] = useUpsertMfDrOwnerMutation({
 *   variables: {
 *      mfDrRef: // value for 'mfDrRef'
 *      materialStandardId: // value for 'materialStandardId'
 *      ownerId: // value for 'ownerId'
 *      reportingUnitId: // value for 'reportingUnitId'
 *   },
 * });
 */
export function useUpsertMfDrOwnerMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMfDrOwnerMutation_, UpsertMfDrOwnerMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMfDrOwnerMutation_, UpsertMfDrOwnerMutationVariables_>(UpsertMfDrOwnerDocument_, options);
      }
export type UpsertMfDrOwnerMutationHookResult = ReturnType<typeof useUpsertMfDrOwnerMutation>;
export type UpsertMfDrOwnerMutationResult_ = Apollo.MutationResult<UpsertMfDrOwnerMutation_>;
export type UpsertMfDrOwnerMutationOptions_ = Apollo.BaseMutationOptions<UpsertMfDrOwnerMutation_, UpsertMfDrOwnerMutationVariables_>;
export const UpsertDisclosureRequirementsOwnerDocument_ = gql`
    mutation upsertDisclosureRequirementsOwner($objects: [DisclosureRequirementOwner_insert_input!]!, $on_conflict: DisclosureRequirementOwner_on_conflict) {
  insert_DisclosureRequirementOwner(objects: $objects, on_conflict: $on_conflict) {
    affected_rows
    returning {
      disclosureRequirementRef
    }
  }
}
    `;
export type UpsertDisclosureRequirementsOwnerMutationFn_ = Apollo.MutationFunction<UpsertDisclosureRequirementsOwnerMutation_, UpsertDisclosureRequirementsOwnerMutationVariables_>;

/**
 * __useUpsertDisclosureRequirementsOwnerMutation__
 *
 * To run a mutation, you first call `useUpsertDisclosureRequirementsOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDisclosureRequirementsOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDisclosureRequirementsOwnerMutation, { data, loading, error }] = useUpsertDisclosureRequirementsOwnerMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *      on_conflict: // value for 'on_conflict'
 *   },
 * });
 */
export function useUpsertDisclosureRequirementsOwnerMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDisclosureRequirementsOwnerMutation_, UpsertDisclosureRequirementsOwnerMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDisclosureRequirementsOwnerMutation_, UpsertDisclosureRequirementsOwnerMutationVariables_>(UpsertDisclosureRequirementsOwnerDocument_, options);
      }
export type UpsertDisclosureRequirementsOwnerMutationHookResult = ReturnType<typeof useUpsertDisclosureRequirementsOwnerMutation>;
export type UpsertDisclosureRequirementsOwnerMutationResult_ = Apollo.MutationResult<UpsertDisclosureRequirementsOwnerMutation_>;
export type UpsertDisclosureRequirementsOwnerMutationOptions_ = Apollo.BaseMutationOptions<UpsertDisclosureRequirementsOwnerMutation_, UpsertDisclosureRequirementsOwnerMutationVariables_>;
export const UpsertMaterialStandardOwnerDocument_ = gql`
    mutation upsertMaterialStandardOwner($materialStandardId: uuid!, $ownerId: uuid!, $reportingUnitId: uuid!) {
  insert_MaterialStandardOwner_one(
    object: {materialStandardId: $materialStandardId, ownerId: $ownerId, reportingUnitId: $reportingUnitId}
    on_conflict: {constraint: MaterialStandardOwner_materialStandardId_reportingUnitId_key, update_columns: ownerId}
  ) {
    id
    ownerId
  }
}
    `;
export type UpsertMaterialStandardOwnerMutationFn_ = Apollo.MutationFunction<UpsertMaterialStandardOwnerMutation_, UpsertMaterialStandardOwnerMutationVariables_>;

/**
 * __useUpsertMaterialStandardOwnerMutation__
 *
 * To run a mutation, you first call `useUpsertMaterialStandardOwnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMaterialStandardOwnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMaterialStandardOwnerMutation, { data, loading, error }] = useUpsertMaterialStandardOwnerMutation({
 *   variables: {
 *      materialStandardId: // value for 'materialStandardId'
 *      ownerId: // value for 'ownerId'
 *      reportingUnitId: // value for 'reportingUnitId'
 *   },
 * });
 */
export function useUpsertMaterialStandardOwnerMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMaterialStandardOwnerMutation_, UpsertMaterialStandardOwnerMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMaterialStandardOwnerMutation_, UpsertMaterialStandardOwnerMutationVariables_>(UpsertMaterialStandardOwnerDocument_, options);
      }
export type UpsertMaterialStandardOwnerMutationHookResult = ReturnType<typeof useUpsertMaterialStandardOwnerMutation>;
export type UpsertMaterialStandardOwnerMutationResult_ = Apollo.MutationResult<UpsertMaterialStandardOwnerMutation_>;
export type UpsertMaterialStandardOwnerMutationOptions_ = Apollo.BaseMutationOptions<UpsertMaterialStandardOwnerMutation_, UpsertMaterialStandardOwnerMutationVariables_>;
export const GetMetricDisclosureRequirementRefDocument_ = gql`
    query getMetricDisclosureRequirementRef($metricRef: String!) {
  EsrsMetric_by_pk(reference: $metricRef) {
    disclosureRequirementRef
  }
}
    `;

/**
 * __useGetMetricDisclosureRequirementRefQuery__
 *
 * To run a query within a React component, call `useGetMetricDisclosureRequirementRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricDisclosureRequirementRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricDisclosureRequirementRefQuery({
 *   variables: {
 *      metricRef: // value for 'metricRef'
 *   },
 * });
 */
export function useGetMetricDisclosureRequirementRefQuery(baseOptions: Apollo.QueryHookOptions<GetMetricDisclosureRequirementRefQuery_, GetMetricDisclosureRequirementRefQueryVariables_> & ({ variables: GetMetricDisclosureRequirementRefQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricDisclosureRequirementRefQuery_, GetMetricDisclosureRequirementRefQueryVariables_>(GetMetricDisclosureRequirementRefDocument_, options);
      }
export function useGetMetricDisclosureRequirementRefLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricDisclosureRequirementRefQuery_, GetMetricDisclosureRequirementRefQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricDisclosureRequirementRefQuery_, GetMetricDisclosureRequirementRefQueryVariables_>(GetMetricDisclosureRequirementRefDocument_, options);
        }
export function useGetMetricDisclosureRequirementRefSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricDisclosureRequirementRefQuery_, GetMetricDisclosureRequirementRefQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricDisclosureRequirementRefQuery_, GetMetricDisclosureRequirementRefQueryVariables_>(GetMetricDisclosureRequirementRefDocument_, options);
        }
export type GetMetricDisclosureRequirementRefQueryHookResult = ReturnType<typeof useGetMetricDisclosureRequirementRefQuery>;
export type GetMetricDisclosureRequirementRefLazyQuery_HookResult = ReturnType<typeof useGetMetricDisclosureRequirementRefLazyQuery_>;
export type GetMetricDisclosureRequirementRefSuspenseQuery_HookResult = ReturnType<typeof useGetMetricDisclosureRequirementRefSuspenseQuery_>;
export type GetMetricDisclosureRequirementRefQueryResult_ = Apollo.QueryResult<GetMetricDisclosureRequirementRefQuery_, GetMetricDisclosureRequirementRefQueryVariables_>;
export function refetchGetMetricDisclosureRequirementRefQuery_(variables: GetMetricDisclosureRequirementRefQueryVariables_) {
      return { query: GetMetricDisclosureRequirementRefDocument_, variables: variables }
    }
export const UpsertDrToMfDisclousreRequirementDocument_ = gql`
    mutation upsertDrToMfDisclousreRequirement($object: DRToMFDisclosureRequirement_insert_input!) {
  insert_DRToMFDisclosureRequirement_one(
    object: $object
    on_conflict: {constraint: DRToMFDisclosureRequirement_disclosureRequirementRef_mfDisc_key, update_columns: []}
  ) {
    id
  }
}
    `;
export type UpsertDrToMfDisclousreRequirementMutationFn_ = Apollo.MutationFunction<UpsertDrToMfDisclousreRequirementMutation_, UpsertDrToMfDisclousreRequirementMutationVariables_>;

/**
 * __useUpsertDrToMfDisclousreRequirementMutation__
 *
 * To run a mutation, you first call `useUpsertDrToMfDisclousreRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertDrToMfDisclousreRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertDrToMfDisclousreRequirementMutation, { data, loading, error }] = useUpsertDrToMfDisclousreRequirementMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpsertDrToMfDisclousreRequirementMutation(baseOptions?: Apollo.MutationHookOptions<UpsertDrToMfDisclousreRequirementMutation_, UpsertDrToMfDisclousreRequirementMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertDrToMfDisclousreRequirementMutation_, UpsertDrToMfDisclousreRequirementMutationVariables_>(UpsertDrToMfDisclousreRequirementDocument_, options);
      }
export type UpsertDrToMfDisclousreRequirementMutationHookResult = ReturnType<typeof useUpsertDrToMfDisclousreRequirementMutation>;
export type UpsertDrToMfDisclousreRequirementMutationResult_ = Apollo.MutationResult<UpsertDrToMfDisclousreRequirementMutation_>;
export type UpsertDrToMfDisclousreRequirementMutationOptions_ = Apollo.BaseMutationOptions<UpsertDrToMfDisclousreRequirementMutation_, UpsertDrToMfDisclousreRequirementMutationVariables_>;
export const UpsertEsrsStandardDocument_ = gql`
    mutation upsertEsrsStandard($object: EsrsStandard_insert_input!) {
  insert_EsrsStandard_one(
    object: $object
    on_conflict: {constraint: EsrsStandard_reference_key, update_columns: []}
  ) {
    reference
  }
}
    `;
export type UpsertEsrsStandardMutationFn_ = Apollo.MutationFunction<UpsertEsrsStandardMutation_, UpsertEsrsStandardMutationVariables_>;

/**
 * __useUpsertEsrsStandardMutation__
 *
 * To run a mutation, you first call `useUpsertEsrsStandardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertEsrsStandardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertEsrsStandardMutation, { data, loading, error }] = useUpsertEsrsStandardMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpsertEsrsStandardMutation(baseOptions?: Apollo.MutationHookOptions<UpsertEsrsStandardMutation_, UpsertEsrsStandardMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertEsrsStandardMutation_, UpsertEsrsStandardMutationVariables_>(UpsertEsrsStandardDocument_, options);
      }
export type UpsertEsrsStandardMutationHookResult = ReturnType<typeof useUpsertEsrsStandardMutation>;
export type UpsertEsrsStandardMutationResult_ = Apollo.MutationResult<UpsertEsrsStandardMutation_>;
export type UpsertEsrsStandardMutationOptions_ = Apollo.BaseMutationOptions<UpsertEsrsStandardMutation_, UpsertEsrsStandardMutationVariables_>;
export const UpdateEsrsStandardDocument_ = gql`
    mutation updateEsrsStandard($pk_columns: EsrsStandard_pk_columns_input!, $_set: EsrsStandard_set_input!) {
  update_EsrsStandard_by_pk(pk_columns: $pk_columns, _set: $_set) {
    reference
  }
}
    `;
export type UpdateEsrsStandardMutationFn_ = Apollo.MutationFunction<UpdateEsrsStandardMutation_, UpdateEsrsStandardMutationVariables_>;

/**
 * __useUpdateEsrsStandardMutation__
 *
 * To run a mutation, you first call `useUpdateEsrsStandardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEsrsStandardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEsrsStandardMutation, { data, loading, error }] = useUpdateEsrsStandardMutation({
 *   variables: {
 *      pk_columns: // value for 'pk_columns'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateEsrsStandardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEsrsStandardMutation_, UpdateEsrsStandardMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEsrsStandardMutation_, UpdateEsrsStandardMutationVariables_>(UpdateEsrsStandardDocument_, options);
      }
export type UpdateEsrsStandardMutationHookResult = ReturnType<typeof useUpdateEsrsStandardMutation>;
export type UpdateEsrsStandardMutationResult_ = Apollo.MutationResult<UpdateEsrsStandardMutation_>;
export type UpdateEsrsStandardMutationOptions_ = Apollo.BaseMutationOptions<UpdateEsrsStandardMutation_, UpdateEsrsStandardMutationVariables_>;
export const UpsertPolicyDocument_ = gql`
    mutation upsertPolicy($input: [esrs_Policy_insert_input!]!) {
  insert_esrs_Policy(
    objects: $input
    on_conflict: {constraint: Policy_assessmentId_disclosureRequirementRef_key, update_columns: [disclosureRequirementRef]}
  ) {
    returning {
      ...PolicyFields
    }
  }
}
    ${PolicyFieldsFragmentDoc_}`;
export type UpsertPolicyMutationFn_ = Apollo.MutationFunction<UpsertPolicyMutation_, UpsertPolicyMutationVariables_>;

/**
 * __useUpsertPolicyMutation__
 *
 * To run a mutation, you first call `useUpsertPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPolicyMutation, { data, loading, error }] = useUpsertPolicyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPolicyMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPolicyMutation_, UpsertPolicyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPolicyMutation_, UpsertPolicyMutationVariables_>(UpsertPolicyDocument_, options);
      }
export type UpsertPolicyMutationHookResult = ReturnType<typeof useUpsertPolicyMutation>;
export type UpsertPolicyMutationResult_ = Apollo.MutationResult<UpsertPolicyMutation_>;
export type UpsertPolicyMutationOptions_ = Apollo.BaseMutationOptions<UpsertPolicyMutation_, UpsertPolicyMutationVariables_>;
export const GetPoliciesDrDocument_ = gql`
    query getPoliciesDR($reference: String!, $esrsAssessmentId: uuid!, $standardRef: String!) {
  DisclosureRequirement_by_pk(reference: $reference) {
    reference
    title
    description
    policies(
      order_by: {createdAt: asc}
      where: {materialStandard: {assessmentId: {_eq: $esrsAssessmentId}, standardRef: {_eq: $standardRef}}}
    ) {
      ...PolicyFields
    }
  }
}
    ${PolicyFieldsFragmentDoc_}`;

/**
 * __useGetPoliciesDrQuery__
 *
 * To run a query within a React component, call `useGetPoliciesDrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPoliciesDrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPoliciesDrQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      standardRef: // value for 'standardRef'
 *   },
 * });
 */
export function useGetPoliciesDrQuery(baseOptions: Apollo.QueryHookOptions<GetPoliciesDrQuery_, GetPoliciesDrQueryVariables_> & ({ variables: GetPoliciesDrQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPoliciesDrQuery_, GetPoliciesDrQueryVariables_>(GetPoliciesDrDocument_, options);
      }
export function useGetPoliciesDrLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetPoliciesDrQuery_, GetPoliciesDrQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPoliciesDrQuery_, GetPoliciesDrQueryVariables_>(GetPoliciesDrDocument_, options);
        }
export function useGetPoliciesDrSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPoliciesDrQuery_, GetPoliciesDrQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPoliciesDrQuery_, GetPoliciesDrQueryVariables_>(GetPoliciesDrDocument_, options);
        }
export type GetPoliciesDrQueryHookResult = ReturnType<typeof useGetPoliciesDrQuery>;
export type GetPoliciesDrLazyQuery_HookResult = ReturnType<typeof useGetPoliciesDrLazyQuery_>;
export type GetPoliciesDrSuspenseQuery_HookResult = ReturnType<typeof useGetPoliciesDrSuspenseQuery_>;
export type GetPoliciesDrQueryResult_ = Apollo.QueryResult<GetPoliciesDrQuery_, GetPoliciesDrQueryVariables_>;
export function refetchGetPoliciesDrQuery_(variables: GetPoliciesDrQueryVariables_) {
      return { query: GetPoliciesDrDocument_, variables: variables }
    }
export const GetPoliciesSubsidiariesDocument_ = gql`
    query getPoliciesSubsidiaries($standardRef: String!, $esrsAssessmentId: uuid!) {
  esrs: EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    subsidiaries: subsidiaryAssessments(where: {deletedAt: {_is_null: true}}) {
      id
      company {
        id
        name
      }
      materialStandards(where: {standardRef: {_eq: $standardRef}}) {
        id
        policies {
          ...PolicyFields
        }
      }
    }
  }
}
    ${PolicyFieldsFragmentDoc_}`;

/**
 * __useGetPoliciesSubsidiariesQuery__
 *
 * To run a query within a React component, call `useGetPoliciesSubsidiariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPoliciesSubsidiariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPoliciesSubsidiariesQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetPoliciesSubsidiariesQuery(baseOptions: Apollo.QueryHookOptions<GetPoliciesSubsidiariesQuery_, GetPoliciesSubsidiariesQueryVariables_> & ({ variables: GetPoliciesSubsidiariesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPoliciesSubsidiariesQuery_, GetPoliciesSubsidiariesQueryVariables_>(GetPoliciesSubsidiariesDocument_, options);
      }
export function useGetPoliciesSubsidiariesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetPoliciesSubsidiariesQuery_, GetPoliciesSubsidiariesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPoliciesSubsidiariesQuery_, GetPoliciesSubsidiariesQueryVariables_>(GetPoliciesSubsidiariesDocument_, options);
        }
export function useGetPoliciesSubsidiariesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPoliciesSubsidiariesQuery_, GetPoliciesSubsidiariesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPoliciesSubsidiariesQuery_, GetPoliciesSubsidiariesQueryVariables_>(GetPoliciesSubsidiariesDocument_, options);
        }
export type GetPoliciesSubsidiariesQueryHookResult = ReturnType<typeof useGetPoliciesSubsidiariesQuery>;
export type GetPoliciesSubsidiariesLazyQuery_HookResult = ReturnType<typeof useGetPoliciesSubsidiariesLazyQuery_>;
export type GetPoliciesSubsidiariesSuspenseQuery_HookResult = ReturnType<typeof useGetPoliciesSubsidiariesSuspenseQuery_>;
export type GetPoliciesSubsidiariesQueryResult_ = Apollo.QueryResult<GetPoliciesSubsidiariesQuery_, GetPoliciesSubsidiariesQueryVariables_>;
export function refetchGetPoliciesSubsidiariesQuery_(variables: GetPoliciesSubsidiariesQueryVariables_) {
      return { query: GetPoliciesSubsidiariesDocument_, variables: variables }
    }
export const GetGroupLevelDrProgressDocument_ = gql`
    query GetGroupLevelDRProgress($assessmentId: uuid!, $drRef: String!, $standardRef: String!, $frameworkRef: String!) {
  groupLevelMaterialMetrics: esrs_MaterialMetric(
    where: {materialStandard: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}, isMaterial: {_eq: true}, dataCollection: {_in: ["subsidiaries", "group"]}, _or: [{metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}]}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}, {dataCollection: {_eq: "group"}, metric: {_and: [{childrenMetricsCount: {_eq: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}]}}, {dataCollection: {_eq: "subsidiaries"}, metric: {_and: [{childrenMetricsCount: {_eq: 0}}, {metricType: {_neq: DECIMAL}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}]}}, {metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {metricType: {_eq: YES_NO}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}]}}]}
  ) {
    ...ProgressMaterialMetricsFragment
  }
  subsidiaryLevelMaterialMetrics: esrs_MaterialMetric(
    where: {materialStandard: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}, isMaterial: {_eq: true}, dataCollection: {_eq: "subsidiaries"}, _or: [{metric: {_and: [{_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}, {_or: [{childrenMetricsCount: {_eq: 0}}, {metricType: {_eq: YES_NO}}]}]}}, {metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}]}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}]}
  ) {
    id
    metricRef
    metric {
      disclosureRequirementRef
      childrenMetrics_aggregate {
        aggregate {
          count
        }
      }
      parentMetrics {
        parentMetric {
          reference
          parentMetrics {
            parentMetric {
              reference
            }
          }
        }
      }
    }
  }
  groupLevelAnswers: esrs_Answer(
    where: {assessmentId: {_eq: $assessmentId}, reportingUnit: {isCompanyLevel: {_eq: true}}, metric: {_and: [{_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}, {_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}]}], materialMetrics: {isMaterial: {_eq: true}, materialStandard: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}}}}
  ) {
    ...ProgressAnswersFragment
  }
}
    ${ProgressMaterialMetricsFragmentFragmentDoc_}
${ProgressAnswersFragmentFragmentDoc_}`;

/**
 * __useGetGroupLevelDrProgressQuery__
 *
 * To run a query within a React component, call `useGetGroupLevelDrProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupLevelDrProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupLevelDrProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      drRef: // value for 'drRef'
 *      standardRef: // value for 'standardRef'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetGroupLevelDrProgressQuery(baseOptions: Apollo.QueryHookOptions<GetGroupLevelDrProgressQuery_, GetGroupLevelDrProgressQueryVariables_> & ({ variables: GetGroupLevelDrProgressQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupLevelDrProgressQuery_, GetGroupLevelDrProgressQueryVariables_>(GetGroupLevelDrProgressDocument_, options);
      }
export function useGetGroupLevelDrProgressLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupLevelDrProgressQuery_, GetGroupLevelDrProgressQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupLevelDrProgressQuery_, GetGroupLevelDrProgressQueryVariables_>(GetGroupLevelDrProgressDocument_, options);
        }
export function useGetGroupLevelDrProgressSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupLevelDrProgressQuery_, GetGroupLevelDrProgressQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupLevelDrProgressQuery_, GetGroupLevelDrProgressQueryVariables_>(GetGroupLevelDrProgressDocument_, options);
        }
export type GetGroupLevelDrProgressQueryHookResult = ReturnType<typeof useGetGroupLevelDrProgressQuery>;
export type GetGroupLevelDrProgressLazyQuery_HookResult = ReturnType<typeof useGetGroupLevelDrProgressLazyQuery_>;
export type GetGroupLevelDrProgressSuspenseQuery_HookResult = ReturnType<typeof useGetGroupLevelDrProgressSuspenseQuery_>;
export type GetGroupLevelDrProgressQueryResult_ = Apollo.QueryResult<GetGroupLevelDrProgressQuery_, GetGroupLevelDrProgressQueryVariables_>;
export function refetchGetGroupLevelDrProgressQuery_(variables: GetGroupLevelDrProgressQueryVariables_) {
      return { query: GetGroupLevelDrProgressDocument_, variables: variables }
    }
export const GetSubsidiariesOnGroupLevelDrProgressDocument_ = gql`
    query GetSubsidiariesOnGroupLevelDRProgress($assessmentId: uuid!, $drRef: String!, $standardRef: String!, $frameworkRef: String!) {
  subsidiaries: EsrsAssessment_by_pk(id: $assessmentId) {
    id
    subsidiaryAssessments {
      id
      reportingUnits {
        id
        isCompanyLevel
        answers(
          where: {metric: {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}}
        ) {
          ...ProgressAnswersFragment
        }
      }
      materialStandards(where: {standardRef: {_eq: $standardRef}}) {
        id
        materialMetrics {
          ...ProgressMaterialMetricsFragment
        }
      }
    }
  }
}
    ${ProgressAnswersFragmentFragmentDoc_}
${ProgressMaterialMetricsFragmentFragmentDoc_}`;

/**
 * __useGetSubsidiariesOnGroupLevelDrProgressQuery__
 *
 * To run a query within a React component, call `useGetSubsidiariesOnGroupLevelDrProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsidiariesOnGroupLevelDrProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsidiariesOnGroupLevelDrProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      drRef: // value for 'drRef'
 *      standardRef: // value for 'standardRef'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetSubsidiariesOnGroupLevelDrProgressQuery(baseOptions: Apollo.QueryHookOptions<GetSubsidiariesOnGroupLevelDrProgressQuery_, GetSubsidiariesOnGroupLevelDrProgressQueryVariables_> & ({ variables: GetSubsidiariesOnGroupLevelDrProgressQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsidiariesOnGroupLevelDrProgressQuery_, GetSubsidiariesOnGroupLevelDrProgressQueryVariables_>(GetSubsidiariesOnGroupLevelDrProgressDocument_, options);
      }
export function useGetSubsidiariesOnGroupLevelDrProgressLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsidiariesOnGroupLevelDrProgressQuery_, GetSubsidiariesOnGroupLevelDrProgressQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsidiariesOnGroupLevelDrProgressQuery_, GetSubsidiariesOnGroupLevelDrProgressQueryVariables_>(GetSubsidiariesOnGroupLevelDrProgressDocument_, options);
        }
export function useGetSubsidiariesOnGroupLevelDrProgressSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubsidiariesOnGroupLevelDrProgressQuery_, GetSubsidiariesOnGroupLevelDrProgressQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubsidiariesOnGroupLevelDrProgressQuery_, GetSubsidiariesOnGroupLevelDrProgressQueryVariables_>(GetSubsidiariesOnGroupLevelDrProgressDocument_, options);
        }
export type GetSubsidiariesOnGroupLevelDrProgressQueryHookResult = ReturnType<typeof useGetSubsidiariesOnGroupLevelDrProgressQuery>;
export type GetSubsidiariesOnGroupLevelDrProgressLazyQuery_HookResult = ReturnType<typeof useGetSubsidiariesOnGroupLevelDrProgressLazyQuery_>;
export type GetSubsidiariesOnGroupLevelDrProgressSuspenseQuery_HookResult = ReturnType<typeof useGetSubsidiariesOnGroupLevelDrProgressSuspenseQuery_>;
export type GetSubsidiariesOnGroupLevelDrProgressQueryResult_ = Apollo.QueryResult<GetSubsidiariesOnGroupLevelDrProgressQuery_, GetSubsidiariesOnGroupLevelDrProgressQueryVariables_>;
export function refetchGetSubsidiariesOnGroupLevelDrProgressQuery_(variables: GetSubsidiariesOnGroupLevelDrProgressQueryVariables_) {
      return { query: GetSubsidiariesOnGroupLevelDrProgressDocument_, variables: variables }
    }
export const GetCompanyLevelDrProgressDocument_ = gql`
    query GetCompanyLevelDRProgress($assessmentId: uuid!, $drRef: String!, $standardRef: String!, $parentAssessmentId: uuid!, $frameworkRef: String!) {
  requiredMaterialMetrics: esrs_MaterialMetric(
    where: {isMaterial: {_eq: true}, materialStandard: {assessmentId: {_eq: $parentAssessmentId}, standardRef: {_eq: $standardRef}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}, metric: {_and: [{_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}, {_or: [{childrenMetricsCount: {_eq: 0}}, {metricType: {_eq: YES_NO}}, {metricType: {_eq: DECIMAL}}]}]}}
  ) {
    metricRef
    metric {
      disclosureRequirementRef
    }
  }
  companyLevelMaterialMetrics: esrs_MaterialMetric(
    where: {materialStandard: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}, _or: [{dataCollection: {_eq: "company"}, metric: {_and: [{_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}]}, {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}]}}, {dataCollection: {_eq: "company"}, metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}]}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}]}
  ) {
    ...ProgressMaterialMetricsFragment
  }
  buLevelMaterialMetrics: esrs_MaterialMetric(
    where: {materialStandard: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}, _or: [{dataCollection: {_eq: "reportingUnits"}, metric: {_and: [{childrenMetricsCount: {_eq: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}]}}, {metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}]}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}, {metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {metricType: {_eq: YES_NO}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}]}}]}
  ) {
    ...ProgressMaterialMetricsFragment
  }
  companyLevelAnswers: esrs_Answer(
    where: {assessmentId: {_eq: $assessmentId}, reportingUnit: {isCompanyLevel: {_eq: true}}, metric: {_and: [{_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}, {_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}]}], materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}}}}
  ) {
    ...ProgressAnswersFragment
  }
  reportingUnits: esrs_ReportingUnit(
    where: {assessmentId: {_eq: $assessmentId}, isCompanyLevel: {_eq: false}}
  ) {
    id
    answers(
      where: {metric: {_and: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {childrenMetricsCount: {_eq: 0}}]}}
    ) {
      ...ProgressAnswersFragment
    }
  }
}
    ${ProgressMaterialMetricsFragmentFragmentDoc_}
${ProgressAnswersFragmentFragmentDoc_}`;

/**
 * __useGetCompanyLevelDrProgressQuery__
 *
 * To run a query within a React component, call `useGetCompanyLevelDrProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyLevelDrProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyLevelDrProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      drRef: // value for 'drRef'
 *      standardRef: // value for 'standardRef'
 *      parentAssessmentId: // value for 'parentAssessmentId'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetCompanyLevelDrProgressQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyLevelDrProgressQuery_, GetCompanyLevelDrProgressQueryVariables_> & ({ variables: GetCompanyLevelDrProgressQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyLevelDrProgressQuery_, GetCompanyLevelDrProgressQueryVariables_>(GetCompanyLevelDrProgressDocument_, options);
      }
export function useGetCompanyLevelDrProgressLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyLevelDrProgressQuery_, GetCompanyLevelDrProgressQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyLevelDrProgressQuery_, GetCompanyLevelDrProgressQueryVariables_>(GetCompanyLevelDrProgressDocument_, options);
        }
export function useGetCompanyLevelDrProgressSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyLevelDrProgressQuery_, GetCompanyLevelDrProgressQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyLevelDrProgressQuery_, GetCompanyLevelDrProgressQueryVariables_>(GetCompanyLevelDrProgressDocument_, options);
        }
export type GetCompanyLevelDrProgressQueryHookResult = ReturnType<typeof useGetCompanyLevelDrProgressQuery>;
export type GetCompanyLevelDrProgressLazyQuery_HookResult = ReturnType<typeof useGetCompanyLevelDrProgressLazyQuery_>;
export type GetCompanyLevelDrProgressSuspenseQuery_HookResult = ReturnType<typeof useGetCompanyLevelDrProgressSuspenseQuery_>;
export type GetCompanyLevelDrProgressQueryResult_ = Apollo.QueryResult<GetCompanyLevelDrProgressQuery_, GetCompanyLevelDrProgressQueryVariables_>;
export function refetchGetCompanyLevelDrProgressQuery_(variables: GetCompanyLevelDrProgressQueryVariables_) {
      return { query: GetCompanyLevelDrProgressDocument_, variables: variables }
    }
export const GetReportingUnitDrProgressDocument_ = gql`
    query GetReportingUnitDRProgress($assessmentId: uuid!, $drRef: String!, $standardRef: String!, $parentAssessmentId: uuid!, $reportingUnitId: uuid!, $frameworkRef: String!) {
  requiredMaterialMetrics: esrs_MaterialMetric(
    where: {isMaterial: {_eq: true}, materialStandard: {assessmentId: {_eq: $parentAssessmentId}, standardRef: {_eq: $standardRef}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}, metric: {_and: [{_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}, {_or: [{childrenMetricsCount: {_eq: 0}}, {metricType: {_eq: YES_NO}}, {metricType: {_eq: DECIMAL}}]}]}}
  ) {
    metricRef
    metric {
      disclosureRequirementRef
    }
  }
  materialMetrics: esrs_MaterialMetric(
    where: {materialStandard: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}, _or: [{dataCollection: {_eq: "reportingUnits"}, metric: {_and: [{childrenMetricsCount: {_eq: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}]}}, {metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}]}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}, {metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {metricType: {_eq: YES_NO}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}]}}]}
  ) {
    ...ProgressMaterialMetricsFragment
  }
  reportingUnit: esrs_ReportingUnit(where: {id: {_eq: $reportingUnitId}}) {
    id
    answers(
      where: {metric: {_and: [{_or: [{relatedDRs: {disclosureRequirementRef: {_eq: $drRef}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_eq: $drRef}}}}]}, {childrenMetricsCount: {_eq: 0}}]}}
    ) {
      ...ProgressAnswersFragment
    }
  }
}
    ${ProgressMaterialMetricsFragmentFragmentDoc_}
${ProgressAnswersFragmentFragmentDoc_}`;

/**
 * __useGetReportingUnitDrProgressQuery__
 *
 * To run a query within a React component, call `useGetReportingUnitDrProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingUnitDrProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingUnitDrProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      drRef: // value for 'drRef'
 *      standardRef: // value for 'standardRef'
 *      parentAssessmentId: // value for 'parentAssessmentId'
 *      reportingUnitId: // value for 'reportingUnitId'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetReportingUnitDrProgressQuery(baseOptions: Apollo.QueryHookOptions<GetReportingUnitDrProgressQuery_, GetReportingUnitDrProgressQueryVariables_> & ({ variables: GetReportingUnitDrProgressQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportingUnitDrProgressQuery_, GetReportingUnitDrProgressQueryVariables_>(GetReportingUnitDrProgressDocument_, options);
      }
export function useGetReportingUnitDrProgressLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetReportingUnitDrProgressQuery_, GetReportingUnitDrProgressQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportingUnitDrProgressQuery_, GetReportingUnitDrProgressQueryVariables_>(GetReportingUnitDrProgressDocument_, options);
        }
export function useGetReportingUnitDrProgressSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportingUnitDrProgressQuery_, GetReportingUnitDrProgressQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportingUnitDrProgressQuery_, GetReportingUnitDrProgressQueryVariables_>(GetReportingUnitDrProgressDocument_, options);
        }
export type GetReportingUnitDrProgressQueryHookResult = ReturnType<typeof useGetReportingUnitDrProgressQuery>;
export type GetReportingUnitDrProgressLazyQuery_HookResult = ReturnType<typeof useGetReportingUnitDrProgressLazyQuery_>;
export type GetReportingUnitDrProgressSuspenseQuery_HookResult = ReturnType<typeof useGetReportingUnitDrProgressSuspenseQuery_>;
export type GetReportingUnitDrProgressQueryResult_ = Apollo.QueryResult<GetReportingUnitDrProgressQuery_, GetReportingUnitDrProgressQueryVariables_>;
export function refetchGetReportingUnitDrProgressQuery_(variables: GetReportingUnitDrProgressQueryVariables_) {
      return { query: GetReportingUnitDrProgressDocument_, variables: variables }
    }
export const GetGroupLevelStandardProgressDocument_ = gql`
    query GetGroupLevelStandardProgress($assessmentId: uuid!, $drRefs: [String!]!, $standardRef: String!, $frameworkRef: String!) {
  groupLevelMaterialMetrics: esrs_MaterialMetric(
    where: {materialStandard: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}, isMaterial: {_eq: true}, dataCollection: {_in: ["subsidiaries", "group"]}, _or: [{metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}]}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}, {dataCollection: {_eq: "group"}, metric: {_and: [{childrenMetricsCount: {_eq: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}]}}, {dataCollection: {_eq: "subsidiaries"}, metric: {_and: [{childrenMetricsCount: {_eq: 0}}, {metricType: {_neq: DECIMAL}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}]}}, {metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {metricType: {_eq: YES_NO}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}]}}]}
  ) {
    ...ProgressMaterialMetricsFragment
  }
  subsidiaryLevelMaterialMetrics: esrs_MaterialMetric(
    where: {materialStandard: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}, isMaterial: {_eq: true}, dataCollection: {_eq: "subsidiaries"}, _or: [{metric: {_and: [{_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}, {_or: [{childrenMetricsCount: {_eq: 0}}, {metricType: {_eq: YES_NO}}]}]}}, {metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}]}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}]}
  ) {
    id
    metricRef
    metric {
      disclosureRequirementRef
      ...MetricMFDisclosureRequirementsFragment
      childrenMetrics_aggregate {
        aggregate {
          count
        }
      }
      parentMetrics {
        parentMetric {
          reference
          parentMetrics {
            parentMetric {
              reference
            }
          }
        }
      }
    }
  }
  groupLevelAnswers: esrs_Answer(
    where: {assessmentId: {_eq: $assessmentId}, reportingUnit: {isCompanyLevel: {_eq: true}}, metric: {_and: [{_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}, {_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}]}], materialMetrics: {isMaterial: {_eq: true}, materialStandard: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}}}}
  ) {
    ...ProgressAnswersFragment
  }
}
    ${ProgressMaterialMetricsFragmentFragmentDoc_}
${MetricMfDisclosureRequirementsFragmentFragmentDoc_}
${ProgressAnswersFragmentFragmentDoc_}`;

/**
 * __useGetGroupLevelStandardProgressQuery__
 *
 * To run a query within a React component, call `useGetGroupLevelStandardProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupLevelStandardProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupLevelStandardProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      drRefs: // value for 'drRefs'
 *      standardRef: // value for 'standardRef'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetGroupLevelStandardProgressQuery(baseOptions: Apollo.QueryHookOptions<GetGroupLevelStandardProgressQuery_, GetGroupLevelStandardProgressQueryVariables_> & ({ variables: GetGroupLevelStandardProgressQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupLevelStandardProgressQuery_, GetGroupLevelStandardProgressQueryVariables_>(GetGroupLevelStandardProgressDocument_, options);
      }
export function useGetGroupLevelStandardProgressLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupLevelStandardProgressQuery_, GetGroupLevelStandardProgressQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupLevelStandardProgressQuery_, GetGroupLevelStandardProgressQueryVariables_>(GetGroupLevelStandardProgressDocument_, options);
        }
export function useGetGroupLevelStandardProgressSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupLevelStandardProgressQuery_, GetGroupLevelStandardProgressQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupLevelStandardProgressQuery_, GetGroupLevelStandardProgressQueryVariables_>(GetGroupLevelStandardProgressDocument_, options);
        }
export type GetGroupLevelStandardProgressQueryHookResult = ReturnType<typeof useGetGroupLevelStandardProgressQuery>;
export type GetGroupLevelStandardProgressLazyQuery_HookResult = ReturnType<typeof useGetGroupLevelStandardProgressLazyQuery_>;
export type GetGroupLevelStandardProgressSuspenseQuery_HookResult = ReturnType<typeof useGetGroupLevelStandardProgressSuspenseQuery_>;
export type GetGroupLevelStandardProgressQueryResult_ = Apollo.QueryResult<GetGroupLevelStandardProgressQuery_, GetGroupLevelStandardProgressQueryVariables_>;
export function refetchGetGroupLevelStandardProgressQuery_(variables: GetGroupLevelStandardProgressQueryVariables_) {
      return { query: GetGroupLevelStandardProgressDocument_, variables: variables }
    }
export const GetSubsidiariesOnGroupLevelStandardProgressDocument_ = gql`
    query GetSubsidiariesOnGroupLevelStandardProgress($assessmentId: uuid!, $drRefs: [String!]!, $standardRef: String!, $frameworkRef: String!) {
  subsidiaries: EsrsAssessment_by_pk(id: $assessmentId) {
    id
    subsidiaryAssessments {
      id
      reportingUnits {
        id
        isCompanyLevel
        answers(
          where: {metric: {_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}}
        ) {
          ...ProgressAnswersFragment
        }
      }
      materialStandards(where: {standardRef: {_eq: $standardRef}}) {
        id
        materialMetrics {
          ...ProgressMaterialMetricsFragment
        }
      }
    }
  }
}
    ${ProgressAnswersFragmentFragmentDoc_}
${ProgressMaterialMetricsFragmentFragmentDoc_}`;

/**
 * __useGetSubsidiariesOnGroupLevelStandardProgressQuery__
 *
 * To run a query within a React component, call `useGetSubsidiariesOnGroupLevelStandardProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsidiariesOnGroupLevelStandardProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsidiariesOnGroupLevelStandardProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      drRefs: // value for 'drRefs'
 *      standardRef: // value for 'standardRef'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetSubsidiariesOnGroupLevelStandardProgressQuery(baseOptions: Apollo.QueryHookOptions<GetSubsidiariesOnGroupLevelStandardProgressQuery_, GetSubsidiariesOnGroupLevelStandardProgressQueryVariables_> & ({ variables: GetSubsidiariesOnGroupLevelStandardProgressQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsidiariesOnGroupLevelStandardProgressQuery_, GetSubsidiariesOnGroupLevelStandardProgressQueryVariables_>(GetSubsidiariesOnGroupLevelStandardProgressDocument_, options);
      }
export function useGetSubsidiariesOnGroupLevelStandardProgressLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsidiariesOnGroupLevelStandardProgressQuery_, GetSubsidiariesOnGroupLevelStandardProgressQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsidiariesOnGroupLevelStandardProgressQuery_, GetSubsidiariesOnGroupLevelStandardProgressQueryVariables_>(GetSubsidiariesOnGroupLevelStandardProgressDocument_, options);
        }
export function useGetSubsidiariesOnGroupLevelStandardProgressSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubsidiariesOnGroupLevelStandardProgressQuery_, GetSubsidiariesOnGroupLevelStandardProgressQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubsidiariesOnGroupLevelStandardProgressQuery_, GetSubsidiariesOnGroupLevelStandardProgressQueryVariables_>(GetSubsidiariesOnGroupLevelStandardProgressDocument_, options);
        }
export type GetSubsidiariesOnGroupLevelStandardProgressQueryHookResult = ReturnType<typeof useGetSubsidiariesOnGroupLevelStandardProgressQuery>;
export type GetSubsidiariesOnGroupLevelStandardProgressLazyQuery_HookResult = ReturnType<typeof useGetSubsidiariesOnGroupLevelStandardProgressLazyQuery_>;
export type GetSubsidiariesOnGroupLevelStandardProgressSuspenseQuery_HookResult = ReturnType<typeof useGetSubsidiariesOnGroupLevelStandardProgressSuspenseQuery_>;
export type GetSubsidiariesOnGroupLevelStandardProgressQueryResult_ = Apollo.QueryResult<GetSubsidiariesOnGroupLevelStandardProgressQuery_, GetSubsidiariesOnGroupLevelStandardProgressQueryVariables_>;
export function refetchGetSubsidiariesOnGroupLevelStandardProgressQuery_(variables: GetSubsidiariesOnGroupLevelStandardProgressQueryVariables_) {
      return { query: GetSubsidiariesOnGroupLevelStandardProgressDocument_, variables: variables }
    }
export const GetCompanyLevelStandardProgressDocument_ = gql`
    query GetCompanyLevelStandardProgress($assessmentId: uuid!, $drRefs: [String!]!, $standardRef: String!, $parentAssessmentId: uuid!, $frameworkRef: String!) {
  requiredMaterialMetrics: esrs_MaterialMetric(
    where: {isMaterial: {_eq: true}, materialStandard: {assessmentId: {_eq: $parentAssessmentId}, standardRef: {_eq: $standardRef}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}, metric: {_and: [{_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}, {_or: [{childrenMetricsCount: {_eq: 0}}, {metricType: {_eq: YES_NO}}, {metricType: {_eq: DECIMAL}}]}]}}
  ) {
    metricRef
    metric {
      disclosureRequirementRef
      ...MetricMFDisclosureRequirementsFragment
    }
  }
  companyLevelMaterialMetrics: esrs_MaterialMetric(
    where: {materialStandard: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}, _or: [{dataCollection: {_eq: "company"}, metric: {_and: [{_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}]}, {_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}]}}, {dataCollection: {_eq: "company"}, metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}]}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}]}
  ) {
    ...ProgressMaterialMetricsFragment
  }
  buLevelMaterialMetrics: esrs_MaterialMetric(
    where: {materialStandard: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}, _or: [{dataCollection: {_eq: "reportingUnits"}, metric: {_and: [{childrenMetricsCount: {_eq: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}]}}, {metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}]}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}, {metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {metricType: {_eq: YES_NO}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}]}}]}
  ) {
    ...ProgressMaterialMetricsFragment
  }
  companyLevelAnswers: esrs_Answer(
    where: {assessmentId: {_eq: $assessmentId}, reportingUnit: {isCompanyLevel: {_eq: true}}, metric: {_and: [{_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}, {_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}]}], materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}}}}
  ) {
    ...ProgressAnswersFragment
  }
  reportingUnits: esrs_ReportingUnit(
    where: {assessmentId: {_eq: $assessmentId}, isCompanyLevel: {_eq: false}}
  ) {
    id
    answers(
      where: {metric: {_and: [{_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}, {childrenMetricsCount: {_eq: 0}}]}}
    ) {
      ...ProgressAnswersFragment
    }
  }
}
    ${MetricMfDisclosureRequirementsFragmentFragmentDoc_}
${ProgressMaterialMetricsFragmentFragmentDoc_}
${ProgressAnswersFragmentFragmentDoc_}`;

/**
 * __useGetCompanyLevelStandardProgressQuery__
 *
 * To run a query within a React component, call `useGetCompanyLevelStandardProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyLevelStandardProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyLevelStandardProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      drRefs: // value for 'drRefs'
 *      standardRef: // value for 'standardRef'
 *      parentAssessmentId: // value for 'parentAssessmentId'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetCompanyLevelStandardProgressQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyLevelStandardProgressQuery_, GetCompanyLevelStandardProgressQueryVariables_> & ({ variables: GetCompanyLevelStandardProgressQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyLevelStandardProgressQuery_, GetCompanyLevelStandardProgressQueryVariables_>(GetCompanyLevelStandardProgressDocument_, options);
      }
export function useGetCompanyLevelStandardProgressLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyLevelStandardProgressQuery_, GetCompanyLevelStandardProgressQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyLevelStandardProgressQuery_, GetCompanyLevelStandardProgressQueryVariables_>(GetCompanyLevelStandardProgressDocument_, options);
        }
export function useGetCompanyLevelStandardProgressSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyLevelStandardProgressQuery_, GetCompanyLevelStandardProgressQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyLevelStandardProgressQuery_, GetCompanyLevelStandardProgressQueryVariables_>(GetCompanyLevelStandardProgressDocument_, options);
        }
export type GetCompanyLevelStandardProgressQueryHookResult = ReturnType<typeof useGetCompanyLevelStandardProgressQuery>;
export type GetCompanyLevelStandardProgressLazyQuery_HookResult = ReturnType<typeof useGetCompanyLevelStandardProgressLazyQuery_>;
export type GetCompanyLevelStandardProgressSuspenseQuery_HookResult = ReturnType<typeof useGetCompanyLevelStandardProgressSuspenseQuery_>;
export type GetCompanyLevelStandardProgressQueryResult_ = Apollo.QueryResult<GetCompanyLevelStandardProgressQuery_, GetCompanyLevelStandardProgressQueryVariables_>;
export function refetchGetCompanyLevelStandardProgressQuery_(variables: GetCompanyLevelStandardProgressQueryVariables_) {
      return { query: GetCompanyLevelStandardProgressDocument_, variables: variables }
    }
export const GetReportingUnitStandardProgressDocument_ = gql`
    query GetReportingUnitStandardProgress($assessmentId: uuid!, $drRefs: [String!]!, $standardRef: String!, $parentAssessmentId: uuid!, $reportingUnitId: uuid!, $frameworkRef: String!) {
  requiredMaterialMetrics: esrs_MaterialMetric(
    where: {isMaterial: {_eq: true}, materialStandard: {assessmentId: {_eq: $parentAssessmentId}, standardRef: {_eq: $standardRef}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}, metric: {_and: [{_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}, {_or: [{childrenMetricsCount: {_eq: 0}}, {metricType: {_eq: YES_NO}}, {metricType: {_eq: DECIMAL}}]}]}}
  ) {
    metricRef
    metric {
      disclosureRequirementRef
      ...MetricMFDisclosureRequirementsFragment
    }
  }
  materialMetrics: esrs_MaterialMetric(
    where: {materialStandard: {assessmentId: {_eq: $assessmentId}, standardRef: {_eq: $standardRef}}, _or: [{dataCollection: {_eq: "reportingUnits"}, metric: {_and: [{childrenMetricsCount: {_eq: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}]}}, {metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}]}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}, {metric: {_and: [{childrenMetricsCount: {_gt: 0}}, {metricType: {_eq: YES_NO}}, {_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}]}}]}
  ) {
    ...ProgressMaterialMetricsFragment
  }
  reportingUnit: esrs_ReportingUnit(where: {id: {_eq: $reportingUnitId}}) {
    id
    answers(
      where: {metric: {_and: [{_or: [{relatedDRs: {disclosureRequirementRef: {_in: $drRefs}, frameworkRef: {_eq: $frameworkRef}}}, {mfDisclosureRequirements: {mfDisclosureRequirement: {reference: {_in: $drRefs}}}}]}, {childrenMetricsCount: {_eq: 0}}]}}
    ) {
      ...ProgressAnswersFragment
    }
  }
}
    ${MetricMfDisclosureRequirementsFragmentFragmentDoc_}
${ProgressMaterialMetricsFragmentFragmentDoc_}
${ProgressAnswersFragmentFragmentDoc_}`;

/**
 * __useGetReportingUnitStandardProgressQuery__
 *
 * To run a query within a React component, call `useGetReportingUnitStandardProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportingUnitStandardProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportingUnitStandardProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      drRefs: // value for 'drRefs'
 *      standardRef: // value for 'standardRef'
 *      parentAssessmentId: // value for 'parentAssessmentId'
 *      reportingUnitId: // value for 'reportingUnitId'
 *      frameworkRef: // value for 'frameworkRef'
 *   },
 * });
 */
export function useGetReportingUnitStandardProgressQuery(baseOptions: Apollo.QueryHookOptions<GetReportingUnitStandardProgressQuery_, GetReportingUnitStandardProgressQueryVariables_> & ({ variables: GetReportingUnitStandardProgressQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportingUnitStandardProgressQuery_, GetReportingUnitStandardProgressQueryVariables_>(GetReportingUnitStandardProgressDocument_, options);
      }
export function useGetReportingUnitStandardProgressLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetReportingUnitStandardProgressQuery_, GetReportingUnitStandardProgressQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportingUnitStandardProgressQuery_, GetReportingUnitStandardProgressQueryVariables_>(GetReportingUnitStandardProgressDocument_, options);
        }
export function useGetReportingUnitStandardProgressSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReportingUnitStandardProgressQuery_, GetReportingUnitStandardProgressQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReportingUnitStandardProgressQuery_, GetReportingUnitStandardProgressQueryVariables_>(GetReportingUnitStandardProgressDocument_, options);
        }
export type GetReportingUnitStandardProgressQueryHookResult = ReturnType<typeof useGetReportingUnitStandardProgressQuery>;
export type GetReportingUnitStandardProgressLazyQuery_HookResult = ReturnType<typeof useGetReportingUnitStandardProgressLazyQuery_>;
export type GetReportingUnitStandardProgressSuspenseQuery_HookResult = ReturnType<typeof useGetReportingUnitStandardProgressSuspenseQuery_>;
export type GetReportingUnitStandardProgressQueryResult_ = Apollo.QueryResult<GetReportingUnitStandardProgressQuery_, GetReportingUnitStandardProgressQueryVariables_>;
export function refetchGetReportingUnitStandardProgressQuery_(variables: GetReportingUnitStandardProgressQueryVariables_) {
      return { query: GetReportingUnitStandardProgressDocument_, variables: variables }
    }
export const GetGroupLevelCategoryProgressDocument_ = gql`
    query GetGroupLevelCategoryProgress($assessmentId: uuid!, $categoryRef: String!) {
  EsrsCategory_by_pk(reference: $categoryRef) {
    standards {
      reference
      materialStandards(
        where: {assessmentId: {_eq: $assessmentId}, isMaterial: {_eq: true}}
      ) {
        groupLevelMaterialMetrics: materialMetrics(
          where: {isMaterial: {_eq: true}, _or: [{dataCollection: {_eq: "group"}, metric: {_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}]}}, {dataCollection: {_eq: "group"}, metric: {childrenMetricsCount: {_gt: 0}}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}, {metric: {childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}, metricType: {_neq: DECIMAL}}}]}
        ) {
          ...ProgressMaterialMetricsFragment
        }
        subsidiaryLevelMaterialMetrics: materialMetrics(
          where: {isMaterial: {_eq: true}, _or: [{dataCollection: {_eq: "subsidiaries"}, metric: {childrenMetricsCount: {_eq: 0}}}, {metric: {childrenMetricsCount: {_gt: 0}}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}]}
        ) {
          ...ProgressMaterialMetricsFragment
        }
      }
    }
  }
  groupLevelAnswers: esrs_Answer(
    where: {assessmentId: {_eq: $assessmentId}, reportingUnit: {isCompanyLevel: {_eq: true}}, metric: {_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}], requirement: {group: {standard: {categoryRef: {_eq: $categoryRef}}}}}}
  ) {
    ...ProgressAnswersFragment
  }
}
    ${ProgressMaterialMetricsFragmentFragmentDoc_}
${ProgressAnswersFragmentFragmentDoc_}`;

/**
 * __useGetGroupLevelCategoryProgressQuery__
 *
 * To run a query within a React component, call `useGetGroupLevelCategoryProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupLevelCategoryProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupLevelCategoryProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      categoryRef: // value for 'categoryRef'
 *   },
 * });
 */
export function useGetGroupLevelCategoryProgressQuery(baseOptions: Apollo.QueryHookOptions<GetGroupLevelCategoryProgressQuery_, GetGroupLevelCategoryProgressQueryVariables_> & ({ variables: GetGroupLevelCategoryProgressQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupLevelCategoryProgressQuery_, GetGroupLevelCategoryProgressQueryVariables_>(GetGroupLevelCategoryProgressDocument_, options);
      }
export function useGetGroupLevelCategoryProgressLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupLevelCategoryProgressQuery_, GetGroupLevelCategoryProgressQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupLevelCategoryProgressQuery_, GetGroupLevelCategoryProgressQueryVariables_>(GetGroupLevelCategoryProgressDocument_, options);
        }
export function useGetGroupLevelCategoryProgressSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupLevelCategoryProgressQuery_, GetGroupLevelCategoryProgressQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupLevelCategoryProgressQuery_, GetGroupLevelCategoryProgressQueryVariables_>(GetGroupLevelCategoryProgressDocument_, options);
        }
export type GetGroupLevelCategoryProgressQueryHookResult = ReturnType<typeof useGetGroupLevelCategoryProgressQuery>;
export type GetGroupLevelCategoryProgressLazyQuery_HookResult = ReturnType<typeof useGetGroupLevelCategoryProgressLazyQuery_>;
export type GetGroupLevelCategoryProgressSuspenseQuery_HookResult = ReturnType<typeof useGetGroupLevelCategoryProgressSuspenseQuery_>;
export type GetGroupLevelCategoryProgressQueryResult_ = Apollo.QueryResult<GetGroupLevelCategoryProgressQuery_, GetGroupLevelCategoryProgressQueryVariables_>;
export function refetchGetGroupLevelCategoryProgressQuery_(variables: GetGroupLevelCategoryProgressQueryVariables_) {
      return { query: GetGroupLevelCategoryProgressDocument_, variables: variables }
    }
export const GetSubsidiariesOnGroupLevelCategoryProgressDocument_ = gql`
    query GetSubsidiariesOnGroupLevelCategoryProgress($assessmentId: uuid!, $categoryRef: String!) {
  subsidiaries: EsrsAssessment_by_pk(id: $assessmentId) {
    id
    subsidiaryAssessments {
      id
      reportingUnits {
        id
        isCompanyLevel
        answers(
          where: {metric: {requirement: {group: {standard: {categoryRef: {_eq: $categoryRef}}}}}}
        ) {
          ...ProgressAnswersFragment
        }
      }
      materialStandards(where: {standard: {categoryRef: {_eq: $categoryRef}}}) {
        id
        standardRef
        materialMetrics {
          ...ProgressMaterialMetricsFragment
        }
      }
    }
  }
}
    ${ProgressAnswersFragmentFragmentDoc_}
${ProgressMaterialMetricsFragmentFragmentDoc_}`;

/**
 * __useGetSubsidiariesOnGroupLevelCategoryProgressQuery__
 *
 * To run a query within a React component, call `useGetSubsidiariesOnGroupLevelCategoryProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsidiariesOnGroupLevelCategoryProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsidiariesOnGroupLevelCategoryProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      categoryRef: // value for 'categoryRef'
 *   },
 * });
 */
export function useGetSubsidiariesOnGroupLevelCategoryProgressQuery(baseOptions: Apollo.QueryHookOptions<GetSubsidiariesOnGroupLevelCategoryProgressQuery_, GetSubsidiariesOnGroupLevelCategoryProgressQueryVariables_> & ({ variables: GetSubsidiariesOnGroupLevelCategoryProgressQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsidiariesOnGroupLevelCategoryProgressQuery_, GetSubsidiariesOnGroupLevelCategoryProgressQueryVariables_>(GetSubsidiariesOnGroupLevelCategoryProgressDocument_, options);
      }
export function useGetSubsidiariesOnGroupLevelCategoryProgressLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsidiariesOnGroupLevelCategoryProgressQuery_, GetSubsidiariesOnGroupLevelCategoryProgressQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsidiariesOnGroupLevelCategoryProgressQuery_, GetSubsidiariesOnGroupLevelCategoryProgressQueryVariables_>(GetSubsidiariesOnGroupLevelCategoryProgressDocument_, options);
        }
export function useGetSubsidiariesOnGroupLevelCategoryProgressSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubsidiariesOnGroupLevelCategoryProgressQuery_, GetSubsidiariesOnGroupLevelCategoryProgressQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubsidiariesOnGroupLevelCategoryProgressQuery_, GetSubsidiariesOnGroupLevelCategoryProgressQueryVariables_>(GetSubsidiariesOnGroupLevelCategoryProgressDocument_, options);
        }
export type GetSubsidiariesOnGroupLevelCategoryProgressQueryHookResult = ReturnType<typeof useGetSubsidiariesOnGroupLevelCategoryProgressQuery>;
export type GetSubsidiariesOnGroupLevelCategoryProgressLazyQuery_HookResult = ReturnType<typeof useGetSubsidiariesOnGroupLevelCategoryProgressLazyQuery_>;
export type GetSubsidiariesOnGroupLevelCategoryProgressSuspenseQuery_HookResult = ReturnType<typeof useGetSubsidiariesOnGroupLevelCategoryProgressSuspenseQuery_>;
export type GetSubsidiariesOnGroupLevelCategoryProgressQueryResult_ = Apollo.QueryResult<GetSubsidiariesOnGroupLevelCategoryProgressQuery_, GetSubsidiariesOnGroupLevelCategoryProgressQueryVariables_>;
export function refetchGetSubsidiariesOnGroupLevelCategoryProgressQuery_(variables: GetSubsidiariesOnGroupLevelCategoryProgressQueryVariables_) {
      return { query: GetSubsidiariesOnGroupLevelCategoryProgressDocument_, variables: variables }
    }
export const GetCompanyLevelCategoryProgressDocument_ = gql`
    query GetCompanyLevelCategoryProgress($assessmentId: uuid!, $categoryRef: String!) {
  EsrsCategory_by_pk(reference: $categoryRef) {
    standards {
      reference
      materialStandards(
        where: {assessmentId: {_eq: $assessmentId}, isMaterial: {_eq: true}}
      ) {
        companyLevelMaterialMetrics: materialMetrics(
          where: {isMaterial: {_eq: true}, _or: [{dataCollection: {_eq: "company"}, metric: {_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}]}}, {dataCollection: {_eq: "company"}, metric: {childrenMetricsCount: {_gt: 0}}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}, {metric: {childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}, metricType: {_neq: DECIMAL}}}]}
        ) {
          ...ProgressMaterialMetricsFragment
        }
        buLevelMaterialMetrics: materialMetrics(
          where: {isMaterial: {_eq: true}, _or: [{dataCollection: {_eq: "reportingUnits"}, metric: {childrenMetricsCount: {_eq: 0}}}, {metric: {childrenMetricsCount: {_gt: 0}}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}]}
        ) {
          ...ProgressMaterialMetricsFragment
        }
      }
    }
  }
  companyLevelAnswers: esrs_Answer(
    where: {assessmentId: {_eq: $assessmentId}, reportingUnit: {isCompanyLevel: {_eq: true}}, metric: {_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}], requirement: {group: {standard: {categoryRef: {_eq: $categoryRef}}}}}}
  ) {
    ...ProgressAnswersFragment
  }
  reportingUnits: esrs_ReportingUnit(
    where: {assessmentId: {_eq: $assessmentId}, isCompanyLevel: {_eq: false}}
  ) {
    id
    answers(
      where: {metric: {childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}, requirement: {group: {standard: {categoryRef: {_eq: $categoryRef}}}}}}
    ) {
      ...ProgressAnswersFragment
    }
  }
}
    ${ProgressMaterialMetricsFragmentFragmentDoc_}
${ProgressAnswersFragmentFragmentDoc_}`;

/**
 * __useGetCompanyLevelCategoryProgressQuery__
 *
 * To run a query within a React component, call `useGetCompanyLevelCategoryProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyLevelCategoryProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyLevelCategoryProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      categoryRef: // value for 'categoryRef'
 *   },
 * });
 */
export function useGetCompanyLevelCategoryProgressQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyLevelCategoryProgressQuery_, GetCompanyLevelCategoryProgressQueryVariables_> & ({ variables: GetCompanyLevelCategoryProgressQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyLevelCategoryProgressQuery_, GetCompanyLevelCategoryProgressQueryVariables_>(GetCompanyLevelCategoryProgressDocument_, options);
      }
export function useGetCompanyLevelCategoryProgressLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyLevelCategoryProgressQuery_, GetCompanyLevelCategoryProgressQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyLevelCategoryProgressQuery_, GetCompanyLevelCategoryProgressQueryVariables_>(GetCompanyLevelCategoryProgressDocument_, options);
        }
export function useGetCompanyLevelCategoryProgressSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyLevelCategoryProgressQuery_, GetCompanyLevelCategoryProgressQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyLevelCategoryProgressQuery_, GetCompanyLevelCategoryProgressQueryVariables_>(GetCompanyLevelCategoryProgressDocument_, options);
        }
export type GetCompanyLevelCategoryProgressQueryHookResult = ReturnType<typeof useGetCompanyLevelCategoryProgressQuery>;
export type GetCompanyLevelCategoryProgressLazyQuery_HookResult = ReturnType<typeof useGetCompanyLevelCategoryProgressLazyQuery_>;
export type GetCompanyLevelCategoryProgressSuspenseQuery_HookResult = ReturnType<typeof useGetCompanyLevelCategoryProgressSuspenseQuery_>;
export type GetCompanyLevelCategoryProgressQueryResult_ = Apollo.QueryResult<GetCompanyLevelCategoryProgressQuery_, GetCompanyLevelCategoryProgressQueryVariables_>;
export function refetchGetCompanyLevelCategoryProgressQuery_(variables: GetCompanyLevelCategoryProgressQueryVariables_) {
      return { query: GetCompanyLevelCategoryProgressDocument_, variables: variables }
    }
export const GetGroupLevelProgressDocument_ = gql`
    query GetGroupLevelProgress($assessmentId: uuid!) {
  EsrsAssessment_by_pk(id: $assessmentId) {
    id
    materialStandards(
      where: {assessmentId: {_eq: $assessmentId}, isMaterial: {_eq: true}}
    ) {
      id
      standardRef
      groupLevelMaterialMetrics: materialMetrics(
        where: {isMaterial: {_eq: true}, _or: [{dataCollection: {_eq: "group"}, metric: {_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}]}}, {dataCollection: {_eq: "group"}, metric: {childrenMetricsCount: {_gt: 0}}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}, {metric: {childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}, metricType: {_neq: DECIMAL}}}]}
      ) {
        ...ProgressMaterialMetricsFragment
      }
      subsidiaryLevelMaterialMetrics: materialMetrics(
        where: {isMaterial: {_eq: true}, dataCollection: {_eq: "subsidiaries"}, metric: {childrenMetricsCount: {_eq: 0}}}
      ) {
        ...ProgressMaterialMetricsFragment
      }
    }
    subsidiaryAssessments {
      id
      reportingUnits {
        id
        isCompanyLevel
        answers {
          ...ProgressAnswersFragment
        }
      }
      materialStandards {
        id
        standardRef
        materialMetrics {
          ...ProgressMaterialMetricsFragment
        }
      }
    }
  }
  groupLevelAnswers: esrs_Answer(
    where: {assessmentId: {_eq: $assessmentId}, reportingUnit: {isCompanyLevel: {_eq: true}}, metric: {_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}], materialMetrics: {isMaterial: {_eq: true}}}}
  ) {
    ...ProgressAnswersFragment
  }
  reportingUnits: esrs_ReportingUnit(
    where: {assessmentId: {_eq: $assessmentId}, isCompanyLevel: {_eq: false}}
  ) {
    id
    answers(where: {metric: {childrenMetricsCount: {_eq: 0}}}) {
      ...ProgressAnswersFragment
    }
  }
}
    ${ProgressMaterialMetricsFragmentFragmentDoc_}
${ProgressAnswersFragmentFragmentDoc_}`;

/**
 * __useGetGroupLevelProgressQuery__
 *
 * To run a query within a React component, call `useGetGroupLevelProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupLevelProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupLevelProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetGroupLevelProgressQuery(baseOptions: Apollo.QueryHookOptions<GetGroupLevelProgressQuery_, GetGroupLevelProgressQueryVariables_> & ({ variables: GetGroupLevelProgressQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupLevelProgressQuery_, GetGroupLevelProgressQueryVariables_>(GetGroupLevelProgressDocument_, options);
      }
export function useGetGroupLevelProgressLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupLevelProgressQuery_, GetGroupLevelProgressQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupLevelProgressQuery_, GetGroupLevelProgressQueryVariables_>(GetGroupLevelProgressDocument_, options);
        }
export function useGetGroupLevelProgressSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGroupLevelProgressQuery_, GetGroupLevelProgressQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGroupLevelProgressQuery_, GetGroupLevelProgressQueryVariables_>(GetGroupLevelProgressDocument_, options);
        }
export type GetGroupLevelProgressQueryHookResult = ReturnType<typeof useGetGroupLevelProgressQuery>;
export type GetGroupLevelProgressLazyQuery_HookResult = ReturnType<typeof useGetGroupLevelProgressLazyQuery_>;
export type GetGroupLevelProgressSuspenseQuery_HookResult = ReturnType<typeof useGetGroupLevelProgressSuspenseQuery_>;
export type GetGroupLevelProgressQueryResult_ = Apollo.QueryResult<GetGroupLevelProgressQuery_, GetGroupLevelProgressQueryVariables_>;
export function refetchGetGroupLevelProgressQuery_(variables: GetGroupLevelProgressQueryVariables_) {
      return { query: GetGroupLevelProgressDocument_, variables: variables }
    }
export const GetCompanyReportLevelProgressDocument_ = gql`
    query GetCompanyReportLevelProgress($assessmentId: uuid!) {
  EsrsAssessment_by_pk(id: $assessmentId) {
    id
    materialStandards(
      where: {assessmentId: {_eq: $assessmentId}, isMaterial: {_eq: true}}
    ) {
      id
      standardRef
      companyLevelMaterialMetrics: materialMetrics(
        where: {isMaterial: {_eq: true}, _or: [{dataCollection: {_eq: "company"}, metric: {_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}]}}, {dataCollection: {_eq: "company"}, metric: {childrenMetricsCount: {_gt: 0}}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}, {metric: {childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}, metricType: {_neq: DECIMAL}}}]}
      ) {
        ...ProgressMaterialMetricsFragment
      }
      buLevelMaterialMetrics: materialMetrics(
        where: {isMaterial: {_eq: true}, _or: [{dataCollection: {_eq: "reportingUnits"}, metric: {childrenMetricsCount: {_eq: 0}}}, {metric: {childrenMetricsCount: {_gt: 0}}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}}]}
      ) {
        ...ProgressMaterialMetricsFragment
      }
    }
  }
  companyLevelAnswers: esrs_Answer(
    where: {assessmentId: {_eq: $assessmentId}, reportingUnit: {isCompanyLevel: {_eq: true}}, metric: {_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}]}}
  ) {
    ...ProgressAnswersFragment
  }
  reportingUnits: esrs_ReportingUnit(
    where: {assessmentId: {_eq: $assessmentId}, isCompanyLevel: {_eq: false}}
  ) {
    id
    answers(where: {metric: {childrenMetricsCount: {_eq: 0}}}) {
      ...ProgressAnswersFragment
    }
  }
}
    ${ProgressMaterialMetricsFragmentFragmentDoc_}
${ProgressAnswersFragmentFragmentDoc_}`;

/**
 * __useGetCompanyReportLevelProgressQuery__
 *
 * To run a query within a React component, call `useGetCompanyReportLevelProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyReportLevelProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyReportLevelProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetCompanyReportLevelProgressQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyReportLevelProgressQuery_, GetCompanyReportLevelProgressQueryVariables_> & ({ variables: GetCompanyReportLevelProgressQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyReportLevelProgressQuery_, GetCompanyReportLevelProgressQueryVariables_>(GetCompanyReportLevelProgressDocument_, options);
      }
export function useGetCompanyReportLevelProgressLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyReportLevelProgressQuery_, GetCompanyReportLevelProgressQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyReportLevelProgressQuery_, GetCompanyReportLevelProgressQueryVariables_>(GetCompanyReportLevelProgressDocument_, options);
        }
export function useGetCompanyReportLevelProgressSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyReportLevelProgressQuery_, GetCompanyReportLevelProgressQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyReportLevelProgressQuery_, GetCompanyReportLevelProgressQueryVariables_>(GetCompanyReportLevelProgressDocument_, options);
        }
export type GetCompanyReportLevelProgressQueryHookResult = ReturnType<typeof useGetCompanyReportLevelProgressQuery>;
export type GetCompanyReportLevelProgressLazyQuery_HookResult = ReturnType<typeof useGetCompanyReportLevelProgressLazyQuery_>;
export type GetCompanyReportLevelProgressSuspenseQuery_HookResult = ReturnType<typeof useGetCompanyReportLevelProgressSuspenseQuery_>;
export type GetCompanyReportLevelProgressQueryResult_ = Apollo.QueryResult<GetCompanyReportLevelProgressQuery_, GetCompanyReportLevelProgressQueryVariables_>;
export function refetchGetCompanyReportLevelProgressQuery_(variables: GetCompanyReportLevelProgressQueryVariables_) {
      return { query: GetCompanyReportLevelProgressDocument_, variables: variables }
    }
export const GetAssessmentRequiredMaterialMetricsDocument_ = gql`
    query getAssessmentRequiredMaterialMetrics($assessmentId: uuid!, $parentAssessmentId: uuid!) {
  esrs_MaterialMetric(
    where: {_or: [{isMaterial: {_eq: true}, materialStandard: {assessmentId: {_eq: $assessmentId}, isMaterial: {_eq: true}}}, {isMaterial: {_eq: true}, materialStandard: {assessmentId: {_eq: $parentAssessmentId}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}, metric: {hierarchyStatus: {isLeaf: {_eq: true}}}, _and: {metric: {materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}}}}}]}
  ) {
    id
    metricRef
  }
}
    `;

/**
 * __useGetAssessmentRequiredMaterialMetricsQuery__
 *
 * To run a query within a React component, call `useGetAssessmentRequiredMaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentRequiredMaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentRequiredMaterialMetricsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      parentAssessmentId: // value for 'parentAssessmentId'
 *   },
 * });
 */
export function useGetAssessmentRequiredMaterialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentRequiredMaterialMetricsQuery_, GetAssessmentRequiredMaterialMetricsQueryVariables_> & ({ variables: GetAssessmentRequiredMaterialMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentRequiredMaterialMetricsQuery_, GetAssessmentRequiredMaterialMetricsQueryVariables_>(GetAssessmentRequiredMaterialMetricsDocument_, options);
      }
export function useGetAssessmentRequiredMaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentRequiredMaterialMetricsQuery_, GetAssessmentRequiredMaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentRequiredMaterialMetricsQuery_, GetAssessmentRequiredMaterialMetricsQueryVariables_>(GetAssessmentRequiredMaterialMetricsDocument_, options);
        }
export function useGetAssessmentRequiredMaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentRequiredMaterialMetricsQuery_, GetAssessmentRequiredMaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentRequiredMaterialMetricsQuery_, GetAssessmentRequiredMaterialMetricsQueryVariables_>(GetAssessmentRequiredMaterialMetricsDocument_, options);
        }
export type GetAssessmentRequiredMaterialMetricsQueryHookResult = ReturnType<typeof useGetAssessmentRequiredMaterialMetricsQuery>;
export type GetAssessmentRequiredMaterialMetricsLazyQuery_HookResult = ReturnType<typeof useGetAssessmentRequiredMaterialMetricsLazyQuery_>;
export type GetAssessmentRequiredMaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetAssessmentRequiredMaterialMetricsSuspenseQuery_>;
export type GetAssessmentRequiredMaterialMetricsQueryResult_ = Apollo.QueryResult<GetAssessmentRequiredMaterialMetricsQuery_, GetAssessmentRequiredMaterialMetricsQueryVariables_>;
export function refetchGetAssessmentRequiredMaterialMetricsQuery_(variables: GetAssessmentRequiredMaterialMetricsQueryVariables_) {
      return { query: GetAssessmentRequiredMaterialMetricsDocument_, variables: variables }
    }
export const GetCompanyLevelProgressDocument_ = gql`
    query GetCompanyLevelProgress($assessmentId: uuid!, $requiredMetrics: [String!]!) {
  EsrsAssessment_by_pk(id: $assessmentId) {
    id
    materialStandards(
      where: {assessmentId: {_eq: $assessmentId}, materialMetrics: {metricRef: {_in: $requiredMetrics}}}
    ) {
      id
      standardRef
      companyLevelMaterialMetrics: materialMetrics(
        where: {_or: [{dataCollection: {_eq: "company"}, metric: {_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}]}, _or: [{metricRef: {_in: $requiredMetrics}}, {metric: {view_childrenMetrics: {childMetricRef: {_in: $requiredMetrics}}}}]}, {dataCollection: {_eq: "company"}, metric: {childrenMetricsCount: {_gt: 0}}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}, _or: [{metricRef: {_in: $requiredMetrics}}, {metric: {view_childrenMetrics: {childMetricRef: {_in: $requiredMetrics}}}}]}, {metric: {childrenMetrics_aggregate: {count: {predicate: {_eq: 0}}}, metricType: {_neq: DECIMAL}}, _or: [{metricRef: {_in: $requiredMetrics}}, {metric: {view_childrenMetrics: {childMetricRef: {_in: $requiredMetrics}}}}]}]}
      ) {
        ...ProgressMaterialMetricsFragment
      }
      buLevelMaterialMetrics: materialMetrics(
        where: {_or: [{dataCollection: {_eq: "reportingUnits"}, metric: {childrenMetricsCount: {_eq: 0}}, _or: [{metricRef: {_in: $requiredMetrics}}, {metric: {view_childrenMetrics: {childMetricRef: {_in: $requiredMetrics}}}}]}, {metric: {childrenMetricsCount: {_gt: 0}}, materialMetricTags_aggregate: {count: {predicate: {_gt: 0}}}, _or: [{metricRef: {_in: $requiredMetrics}}, {metric: {view_childrenMetrics: {childMetricRef: {_in: $requiredMetrics}}}}]}]}
      ) {
        ...ProgressMaterialMetricsFragment
      }
    }
  }
  companyLevelAnswers: esrs_Answer(
    where: {assessmentId: {_eq: $assessmentId}, reportingUnit: {isCompanyLevel: {_eq: true}}, metric: {_or: [{childrenMetricsCount: {_eq: 0}}, {childrenMetricsCount: {_gt: 0}, metricType: {_eq: YES_NO}}]}}
  ) {
    ...ProgressAnswersFragment
  }
  reportingUnits: esrs_ReportingUnit(
    where: {assessmentId: {_eq: $assessmentId}, isCompanyLevel: {_eq: false}}
  ) {
    id
    answers(where: {metric: {childrenMetricsCount: {_eq: 0}}}) {
      ...ProgressAnswersFragment
    }
  }
}
    ${ProgressMaterialMetricsFragmentFragmentDoc_}
${ProgressAnswersFragmentFragmentDoc_}`;

/**
 * __useGetCompanyLevelProgressQuery__
 *
 * To run a query within a React component, call `useGetCompanyLevelProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyLevelProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyLevelProgressQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      requiredMetrics: // value for 'requiredMetrics'
 *   },
 * });
 */
export function useGetCompanyLevelProgressQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyLevelProgressQuery_, GetCompanyLevelProgressQueryVariables_> & ({ variables: GetCompanyLevelProgressQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyLevelProgressQuery_, GetCompanyLevelProgressQueryVariables_>(GetCompanyLevelProgressDocument_, options);
      }
export function useGetCompanyLevelProgressLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyLevelProgressQuery_, GetCompanyLevelProgressQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyLevelProgressQuery_, GetCompanyLevelProgressQueryVariables_>(GetCompanyLevelProgressDocument_, options);
        }
export function useGetCompanyLevelProgressSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyLevelProgressQuery_, GetCompanyLevelProgressQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyLevelProgressQuery_, GetCompanyLevelProgressQueryVariables_>(GetCompanyLevelProgressDocument_, options);
        }
export type GetCompanyLevelProgressQueryHookResult = ReturnType<typeof useGetCompanyLevelProgressQuery>;
export type GetCompanyLevelProgressLazyQuery_HookResult = ReturnType<typeof useGetCompanyLevelProgressLazyQuery_>;
export type GetCompanyLevelProgressSuspenseQuery_HookResult = ReturnType<typeof useGetCompanyLevelProgressSuspenseQuery_>;
export type GetCompanyLevelProgressQueryResult_ = Apollo.QueryResult<GetCompanyLevelProgressQuery_, GetCompanyLevelProgressQueryVariables_>;
export function refetchGetCompanyLevelProgressQuery_(variables: GetCompanyLevelProgressQueryVariables_) {
      return { query: GetCompanyLevelProgressDocument_, variables: variables }
    }
export const GetNarrativeParentMetricAnswersDocument_ = gql`
    query getNarrativeParentMetricAnswers {
  datapoints: esrs_Datapoint(
    where: {answer: {metric: {childrenMetrics_aggregate: {count: {predicate: {_gt: 0}}}, metricType: {_neq: DECIMAL}}}, value: {_is_null: false, _neq: ""}}
  ) {
    id
    value
    metadata
  }
}
    `;

/**
 * __useGetNarrativeParentMetricAnswersQuery__
 *
 * To run a query within a React component, call `useGetNarrativeParentMetricAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNarrativeParentMetricAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNarrativeParentMetricAnswersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNarrativeParentMetricAnswersQuery(baseOptions?: Apollo.QueryHookOptions<GetNarrativeParentMetricAnswersQuery_, GetNarrativeParentMetricAnswersQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNarrativeParentMetricAnswersQuery_, GetNarrativeParentMetricAnswersQueryVariables_>(GetNarrativeParentMetricAnswersDocument_, options);
      }
export function useGetNarrativeParentMetricAnswersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetNarrativeParentMetricAnswersQuery_, GetNarrativeParentMetricAnswersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNarrativeParentMetricAnswersQuery_, GetNarrativeParentMetricAnswersQueryVariables_>(GetNarrativeParentMetricAnswersDocument_, options);
        }
export function useGetNarrativeParentMetricAnswersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNarrativeParentMetricAnswersQuery_, GetNarrativeParentMetricAnswersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNarrativeParentMetricAnswersQuery_, GetNarrativeParentMetricAnswersQueryVariables_>(GetNarrativeParentMetricAnswersDocument_, options);
        }
export type GetNarrativeParentMetricAnswersQueryHookResult = ReturnType<typeof useGetNarrativeParentMetricAnswersQuery>;
export type GetNarrativeParentMetricAnswersLazyQuery_HookResult = ReturnType<typeof useGetNarrativeParentMetricAnswersLazyQuery_>;
export type GetNarrativeParentMetricAnswersSuspenseQuery_HookResult = ReturnType<typeof useGetNarrativeParentMetricAnswersSuspenseQuery_>;
export type GetNarrativeParentMetricAnswersQueryResult_ = Apollo.QueryResult<GetNarrativeParentMetricAnswersQuery_, GetNarrativeParentMetricAnswersQueryVariables_>;
export function refetchGetNarrativeParentMetricAnswersQuery_(variables?: GetNarrativeParentMetricAnswersQueryVariables_) {
      return { query: GetNarrativeParentMetricAnswersDocument_, variables: variables }
    }
export const GetAllDatapointsDocument_ = gql`
    query getAllDatapoints {
  esrs_Datapoint {
    id
    datapointTags {
      tagType
      tagValue
    }
  }
}
    `;

/**
 * __useGetAllDatapointsQuery__
 *
 * To run a query within a React component, call `useGetAllDatapointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDatapointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDatapointsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllDatapointsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllDatapointsQuery_, GetAllDatapointsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDatapointsQuery_, GetAllDatapointsQueryVariables_>(GetAllDatapointsDocument_, options);
      }
export function useGetAllDatapointsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDatapointsQuery_, GetAllDatapointsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDatapointsQuery_, GetAllDatapointsQueryVariables_>(GetAllDatapointsDocument_, options);
        }
export function useGetAllDatapointsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllDatapointsQuery_, GetAllDatapointsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllDatapointsQuery_, GetAllDatapointsQueryVariables_>(GetAllDatapointsDocument_, options);
        }
export type GetAllDatapointsQueryHookResult = ReturnType<typeof useGetAllDatapointsQuery>;
export type GetAllDatapointsLazyQuery_HookResult = ReturnType<typeof useGetAllDatapointsLazyQuery_>;
export type GetAllDatapointsSuspenseQuery_HookResult = ReturnType<typeof useGetAllDatapointsSuspenseQuery_>;
export type GetAllDatapointsQueryResult_ = Apollo.QueryResult<GetAllDatapointsQuery_, GetAllDatapointsQueryVariables_>;
export function refetchGetAllDatapointsQuery_(variables?: GetAllDatapointsQueryVariables_) {
      return { query: GetAllDatapointsDocument_, variables: variables }
    }
export const GetDatapointTagsDocument_ = gql`
    query getDatapointTags($id: uuid!) {
  esrs_Datapoint(where: {id: {_eq: $id}}) {
    datapointTags {
      tagType
      tagValue
    }
  }
}
    `;

/**
 * __useGetDatapointTagsQuery__
 *
 * To run a query within a React component, call `useGetDatapointTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatapointTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatapointTagsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDatapointTagsQuery(baseOptions: Apollo.QueryHookOptions<GetDatapointTagsQuery_, GetDatapointTagsQueryVariables_> & ({ variables: GetDatapointTagsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatapointTagsQuery_, GetDatapointTagsQueryVariables_>(GetDatapointTagsDocument_, options);
      }
export function useGetDatapointTagsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDatapointTagsQuery_, GetDatapointTagsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatapointTagsQuery_, GetDatapointTagsQueryVariables_>(GetDatapointTagsDocument_, options);
        }
export function useGetDatapointTagsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatapointTagsQuery_, GetDatapointTagsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatapointTagsQuery_, GetDatapointTagsQueryVariables_>(GetDatapointTagsDocument_, options);
        }
export type GetDatapointTagsQueryHookResult = ReturnType<typeof useGetDatapointTagsQuery>;
export type GetDatapointTagsLazyQuery_HookResult = ReturnType<typeof useGetDatapointTagsLazyQuery_>;
export type GetDatapointTagsSuspenseQuery_HookResult = ReturnType<typeof useGetDatapointTagsSuspenseQuery_>;
export type GetDatapointTagsQueryResult_ = Apollo.QueryResult<GetDatapointTagsQuery_, GetDatapointTagsQueryVariables_>;
export function refetchGetDatapointTagsQuery_(variables: GetDatapointTagsQueryVariables_) {
      return { query: GetDatapointTagsDocument_, variables: variables }
    }
export const GetDatapointsByTagValueDocument_ = gql`
    query getDatapointsByTagValue($tagValue: String!) {
  esrs_Datapoint(where: {datapointTags: {tagValue: {_eq: $tagValue}}}) {
    id
    datapointTags {
      tagType
      tagValue
    }
  }
}
    `;

/**
 * __useGetDatapointsByTagValueQuery__
 *
 * To run a query within a React component, call `useGetDatapointsByTagValueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatapointsByTagValueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatapointsByTagValueQuery({
 *   variables: {
 *      tagValue: // value for 'tagValue'
 *   },
 * });
 */
export function useGetDatapointsByTagValueQuery(baseOptions: Apollo.QueryHookOptions<GetDatapointsByTagValueQuery_, GetDatapointsByTagValueQueryVariables_> & ({ variables: GetDatapointsByTagValueQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatapointsByTagValueQuery_, GetDatapointsByTagValueQueryVariables_>(GetDatapointsByTagValueDocument_, options);
      }
export function useGetDatapointsByTagValueLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDatapointsByTagValueQuery_, GetDatapointsByTagValueQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatapointsByTagValueQuery_, GetDatapointsByTagValueQueryVariables_>(GetDatapointsByTagValueDocument_, options);
        }
export function useGetDatapointsByTagValueSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatapointsByTagValueQuery_, GetDatapointsByTagValueQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatapointsByTagValueQuery_, GetDatapointsByTagValueQueryVariables_>(GetDatapointsByTagValueDocument_, options);
        }
export type GetDatapointsByTagValueQueryHookResult = ReturnType<typeof useGetDatapointsByTagValueQuery>;
export type GetDatapointsByTagValueLazyQuery_HookResult = ReturnType<typeof useGetDatapointsByTagValueLazyQuery_>;
export type GetDatapointsByTagValueSuspenseQuery_HookResult = ReturnType<typeof useGetDatapointsByTagValueSuspenseQuery_>;
export type GetDatapointsByTagValueQueryResult_ = Apollo.QueryResult<GetDatapointsByTagValueQuery_, GetDatapointsByTagValueQueryVariables_>;
export function refetchGetDatapointsByTagValueQuery_(variables: GetDatapointsByTagValueQueryVariables_) {
      return { query: GetDatapointsByTagValueDocument_, variables: variables }
    }
export const GetDatapointsByTagTypeDocument_ = gql`
    query getDatapointsByTagType($tagType: String!) {
  esrs_Datapoint(where: {datapointTags: {tagType: {_eq: $tagType}}}) {
    id
    datapointTags {
      tagType
      tagValue
    }
  }
}
    `;

/**
 * __useGetDatapointsByTagTypeQuery__
 *
 * To run a query within a React component, call `useGetDatapointsByTagTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatapointsByTagTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatapointsByTagTypeQuery({
 *   variables: {
 *      tagType: // value for 'tagType'
 *   },
 * });
 */
export function useGetDatapointsByTagTypeQuery(baseOptions: Apollo.QueryHookOptions<GetDatapointsByTagTypeQuery_, GetDatapointsByTagTypeQueryVariables_> & ({ variables: GetDatapointsByTagTypeQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatapointsByTagTypeQuery_, GetDatapointsByTagTypeQueryVariables_>(GetDatapointsByTagTypeDocument_, options);
      }
export function useGetDatapointsByTagTypeLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDatapointsByTagTypeQuery_, GetDatapointsByTagTypeQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatapointsByTagTypeQuery_, GetDatapointsByTagTypeQueryVariables_>(GetDatapointsByTagTypeDocument_, options);
        }
export function useGetDatapointsByTagTypeSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatapointsByTagTypeQuery_, GetDatapointsByTagTypeQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatapointsByTagTypeQuery_, GetDatapointsByTagTypeQueryVariables_>(GetDatapointsByTagTypeDocument_, options);
        }
export type GetDatapointsByTagTypeQueryHookResult = ReturnType<typeof useGetDatapointsByTagTypeQuery>;
export type GetDatapointsByTagTypeLazyQuery_HookResult = ReturnType<typeof useGetDatapointsByTagTypeLazyQuery_>;
export type GetDatapointsByTagTypeSuspenseQuery_HookResult = ReturnType<typeof useGetDatapointsByTagTypeSuspenseQuery_>;
export type GetDatapointsByTagTypeQueryResult_ = Apollo.QueryResult<GetDatapointsByTagTypeQuery_, GetDatapointsByTagTypeQueryVariables_>;
export function refetchGetDatapointsByTagTypeQuery_(variables: GetDatapointsByTagTypeQueryVariables_) {
      return { query: GetDatapointsByTagTypeDocument_, variables: variables }
    }
export const UpdateDatapointsTagCombinationsDocument_ = gql`
    mutation updateDatapointsTagCombinations($datapointUpdates: [esrs_Datapoint_updates!]!) {
  updates: update_esrs_Datapoint_many(updates: $datapointUpdates) {
    affected_rows
    returning {
      id
      tagCombination
    }
  }
}
    `;
export type UpdateDatapointsTagCombinationsMutationFn_ = Apollo.MutationFunction<UpdateDatapointsTagCombinationsMutation_, UpdateDatapointsTagCombinationsMutationVariables_>;

/**
 * __useUpdateDatapointsTagCombinationsMutation__
 *
 * To run a mutation, you first call `useUpdateDatapointsTagCombinationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDatapointsTagCombinationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDatapointsTagCombinationsMutation, { data, loading, error }] = useUpdateDatapointsTagCombinationsMutation({
 *   variables: {
 *      datapointUpdates: // value for 'datapointUpdates'
 *   },
 * });
 */
export function useUpdateDatapointsTagCombinationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDatapointsTagCombinationsMutation_, UpdateDatapointsTagCombinationsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDatapointsTagCombinationsMutation_, UpdateDatapointsTagCombinationsMutationVariables_>(UpdateDatapointsTagCombinationsDocument_, options);
      }
export type UpdateDatapointsTagCombinationsMutationHookResult = ReturnType<typeof useUpdateDatapointsTagCombinationsMutation>;
export type UpdateDatapointsTagCombinationsMutationResult_ = Apollo.MutationResult<UpdateDatapointsTagCombinationsMutation_>;
export type UpdateDatapointsTagCombinationsMutationOptions_ = Apollo.BaseMutationOptions<UpdateDatapointsTagCombinationsMutation_, UpdateDatapointsTagCombinationsMutationVariables_>;
export const UpdateDatapointMetaDataWithValuesDocument_ = gql`
    mutation updateDatapointMetaDataWithValues($datapointUpdates: [esrs_Datapoint_updates!]!) {
  updates: update_esrs_Datapoint_many(updates: $datapointUpdates) {
    affected_rows
    returning {
      id
      metadata
      value
      answer {
        metricRef
      }
    }
  }
}
    `;
export type UpdateDatapointMetaDataWithValuesMutationFn_ = Apollo.MutationFunction<UpdateDatapointMetaDataWithValuesMutation_, UpdateDatapointMetaDataWithValuesMutationVariables_>;

/**
 * __useUpdateDatapointMetaDataWithValuesMutation__
 *
 * To run a mutation, you first call `useUpdateDatapointMetaDataWithValuesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDatapointMetaDataWithValuesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDatapointMetaDataWithValuesMutation, { data, loading, error }] = useUpdateDatapointMetaDataWithValuesMutation({
 *   variables: {
 *      datapointUpdates: // value for 'datapointUpdates'
 *   },
 * });
 */
export function useUpdateDatapointMetaDataWithValuesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDatapointMetaDataWithValuesMutation_, UpdateDatapointMetaDataWithValuesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDatapointMetaDataWithValuesMutation_, UpdateDatapointMetaDataWithValuesMutationVariables_>(UpdateDatapointMetaDataWithValuesDocument_, options);
      }
export type UpdateDatapointMetaDataWithValuesMutationHookResult = ReturnType<typeof useUpdateDatapointMetaDataWithValuesMutation>;
export type UpdateDatapointMetaDataWithValuesMutationResult_ = Apollo.MutationResult<UpdateDatapointMetaDataWithValuesMutation_>;
export type UpdateDatapointMetaDataWithValuesMutationOptions_ = Apollo.BaseMutationOptions<UpdateDatapointMetaDataWithValuesMutation_, UpdateDatapointMetaDataWithValuesMutationVariables_>;
export const GetAllConfiguredMaterialStandardsDocument_ = gql`
    query getAllConfiguredMaterialStandards {
  esrs_MaterialStandard(where: {isDataCollected: {_eq: true}}) {
    id
    materialMetrics {
      metric {
        disclosureRequirementRef
      }
    }
  }
}
    `;

/**
 * __useGetAllConfiguredMaterialStandardsQuery__
 *
 * To run a query within a React component, call `useGetAllConfiguredMaterialStandardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllConfiguredMaterialStandardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllConfiguredMaterialStandardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllConfiguredMaterialStandardsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllConfiguredMaterialStandardsQuery_, GetAllConfiguredMaterialStandardsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllConfiguredMaterialStandardsQuery_, GetAllConfiguredMaterialStandardsQueryVariables_>(GetAllConfiguredMaterialStandardsDocument_, options);
      }
export function useGetAllConfiguredMaterialStandardsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAllConfiguredMaterialStandardsQuery_, GetAllConfiguredMaterialStandardsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllConfiguredMaterialStandardsQuery_, GetAllConfiguredMaterialStandardsQueryVariables_>(GetAllConfiguredMaterialStandardsDocument_, options);
        }
export function useGetAllConfiguredMaterialStandardsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllConfiguredMaterialStandardsQuery_, GetAllConfiguredMaterialStandardsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllConfiguredMaterialStandardsQuery_, GetAllConfiguredMaterialStandardsQueryVariables_>(GetAllConfiguredMaterialStandardsDocument_, options);
        }
export type GetAllConfiguredMaterialStandardsQueryHookResult = ReturnType<typeof useGetAllConfiguredMaterialStandardsQuery>;
export type GetAllConfiguredMaterialStandardsLazyQuery_HookResult = ReturnType<typeof useGetAllConfiguredMaterialStandardsLazyQuery_>;
export type GetAllConfiguredMaterialStandardsSuspenseQuery_HookResult = ReturnType<typeof useGetAllConfiguredMaterialStandardsSuspenseQuery_>;
export type GetAllConfiguredMaterialStandardsQueryResult_ = Apollo.QueryResult<GetAllConfiguredMaterialStandardsQuery_, GetAllConfiguredMaterialStandardsQueryVariables_>;
export function refetchGetAllConfiguredMaterialStandardsQuery_(variables?: GetAllConfiguredMaterialStandardsQueryVariables_) {
      return { query: GetAllConfiguredMaterialStandardsDocument_, variables: variables }
    }
export const UpsertAllDisclosureRequirementStatusesDocument_ = gql`
    mutation upsertAllDisclosureRequirementStatuses($objects: [DisclosureRequirementStatus_insert_input!]!) {
  insert_DisclosureRequirementStatus(
    objects: $objects
    on_conflict: {constraint: DisclosureRequirementStatus_materialStandardId_disclosureRequir, update_columns: [isConfigured]}
  ) {
    returning {
      materialStandardId
      disclosureRequirementRef
      isConfigured
    }
  }
}
    `;
export type UpsertAllDisclosureRequirementStatusesMutationFn_ = Apollo.MutationFunction<UpsertAllDisclosureRequirementStatusesMutation_, UpsertAllDisclosureRequirementStatusesMutationVariables_>;

/**
 * __useUpsertAllDisclosureRequirementStatusesMutation__
 *
 * To run a mutation, you first call `useUpsertAllDisclosureRequirementStatusesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAllDisclosureRequirementStatusesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAllDisclosureRequirementStatusesMutation, { data, loading, error }] = useUpsertAllDisclosureRequirementStatusesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertAllDisclosureRequirementStatusesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAllDisclosureRequirementStatusesMutation_, UpsertAllDisclosureRequirementStatusesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAllDisclosureRequirementStatusesMutation_, UpsertAllDisclosureRequirementStatusesMutationVariables_>(UpsertAllDisclosureRequirementStatusesDocument_, options);
      }
export type UpsertAllDisclosureRequirementStatusesMutationHookResult = ReturnType<typeof useUpsertAllDisclosureRequirementStatusesMutation>;
export type UpsertAllDisclosureRequirementStatusesMutationResult_ = Apollo.MutationResult<UpsertAllDisclosureRequirementStatusesMutation_>;
export type UpsertAllDisclosureRequirementStatusesMutationOptions_ = Apollo.BaseMutationOptions<UpsertAllDisclosureRequirementStatusesMutation_, UpsertAllDisclosureRequirementStatusesMutationVariables_>;
export const GetOldMdrmAnswersDocument_ = gql`
    query getOldMdrmAnswers {
  esrs_Deprecated_EsrsMDRM {
    metricRef
    metricUsed
    methodology
    validation
    answeredByUserId
    datapoint {
      id
      answer {
        id
        reportingUnitId
        assessmentId
        metricRef
        metric {
          reference
          parentMetrics {
            parentMetric {
              reference
              parentMetrics {
                parentMetric {
                  reference
                  parentMetrics {
                    parentMetric {
                      reference
                      parentMetrics {
                        parentMetric {
                          reference
                          parentMetrics {
                            parentMetric {
                              reference
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      datapointTags {
        datapointTagValue {
          type
          value
        }
      }
      timeframe
    }
  }
}
    `;

/**
 * __useGetOldMdrmAnswersQuery__
 *
 * To run a query within a React component, call `useGetOldMdrmAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOldMdrmAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOldMdrmAnswersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOldMdrmAnswersQuery(baseOptions?: Apollo.QueryHookOptions<GetOldMdrmAnswersQuery_, GetOldMdrmAnswersQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOldMdrmAnswersQuery_, GetOldMdrmAnswersQueryVariables_>(GetOldMdrmAnswersDocument_, options);
      }
export function useGetOldMdrmAnswersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetOldMdrmAnswersQuery_, GetOldMdrmAnswersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOldMdrmAnswersQuery_, GetOldMdrmAnswersQueryVariables_>(GetOldMdrmAnswersDocument_, options);
        }
export function useGetOldMdrmAnswersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOldMdrmAnswersQuery_, GetOldMdrmAnswersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOldMdrmAnswersQuery_, GetOldMdrmAnswersQueryVariables_>(GetOldMdrmAnswersDocument_, options);
        }
export type GetOldMdrmAnswersQueryHookResult = ReturnType<typeof useGetOldMdrmAnswersQuery>;
export type GetOldMdrmAnswersLazyQuery_HookResult = ReturnType<typeof useGetOldMdrmAnswersLazyQuery_>;
export type GetOldMdrmAnswersSuspenseQuery_HookResult = ReturnType<typeof useGetOldMdrmAnswersSuspenseQuery_>;
export type GetOldMdrmAnswersQueryResult_ = Apollo.QueryResult<GetOldMdrmAnswersQuery_, GetOldMdrmAnswersQueryVariables_>;
export function refetchGetOldMdrmAnswersQuery_(variables?: GetOldMdrmAnswersQueryVariables_) {
      return { query: GetOldMdrmAnswersDocument_, variables: variables }
    }
export const GetTopLevelDatapointsDocument_ = gql`
    query getTopLevelDatapoints {
  esrs_Datapoint(
    where: {datapointTags_aggregate: {count: {predicate: {_eq: 0}}}, answer: {metric: {metricType: {_eq: DECIMAL}, parentMetrics_aggregate: {count: {predicate: {_eq: 0}}}}}}
  ) {
    id
    timeframe
    answer {
      assessmentId
      metricRef
      reportingUnitId
    }
  }
}
    `;

/**
 * __useGetTopLevelDatapointsQuery__
 *
 * To run a query within a React component, call `useGetTopLevelDatapointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTopLevelDatapointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTopLevelDatapointsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTopLevelDatapointsQuery(baseOptions?: Apollo.QueryHookOptions<GetTopLevelDatapointsQuery_, GetTopLevelDatapointsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTopLevelDatapointsQuery_, GetTopLevelDatapointsQueryVariables_>(GetTopLevelDatapointsDocument_, options);
      }
export function useGetTopLevelDatapointsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetTopLevelDatapointsQuery_, GetTopLevelDatapointsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTopLevelDatapointsQuery_, GetTopLevelDatapointsQueryVariables_>(GetTopLevelDatapointsDocument_, options);
        }
export function useGetTopLevelDatapointsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTopLevelDatapointsQuery_, GetTopLevelDatapointsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTopLevelDatapointsQuery_, GetTopLevelDatapointsQueryVariables_>(GetTopLevelDatapointsDocument_, options);
        }
export type GetTopLevelDatapointsQueryHookResult = ReturnType<typeof useGetTopLevelDatapointsQuery>;
export type GetTopLevelDatapointsLazyQuery_HookResult = ReturnType<typeof useGetTopLevelDatapointsLazyQuery_>;
export type GetTopLevelDatapointsSuspenseQuery_HookResult = ReturnType<typeof useGetTopLevelDatapointsSuspenseQuery_>;
export type GetTopLevelDatapointsQueryResult_ = Apollo.QueryResult<GetTopLevelDatapointsQuery_, GetTopLevelDatapointsQueryVariables_>;
export function refetchGetTopLevelDatapointsQuery_(variables?: GetTopLevelDatapointsQueryVariables_) {
      return { query: GetTopLevelDatapointsDocument_, variables: variables }
    }
export const GetMaterialMetricsInfoDocument_ = gql`
    query getMaterialMetricsInfo($metricRef: String!) {
  esrs_MaterialMetric(where: {metricRef: {_eq: $metricRef}}) {
    materialStandardId
    dataCollection
    metricRef
    isMaterial
    isDataGatheringOnly
  }
}
    `;

/**
 * __useGetMaterialMetricsInfoQuery__
 *
 * To run a query within a React component, call `useGetMaterialMetricsInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaterialMetricsInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaterialMetricsInfoQuery({
 *   variables: {
 *      metricRef: // value for 'metricRef'
 *   },
 * });
 */
export function useGetMaterialMetricsInfoQuery(baseOptions: Apollo.QueryHookOptions<GetMaterialMetricsInfoQuery_, GetMaterialMetricsInfoQueryVariables_> & ({ variables: GetMaterialMetricsInfoQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaterialMetricsInfoQuery_, GetMaterialMetricsInfoQueryVariables_>(GetMaterialMetricsInfoDocument_, options);
      }
export function useGetMaterialMetricsInfoLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMaterialMetricsInfoQuery_, GetMaterialMetricsInfoQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaterialMetricsInfoQuery_, GetMaterialMetricsInfoQueryVariables_>(GetMaterialMetricsInfoDocument_, options);
        }
export function useGetMaterialMetricsInfoSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMaterialMetricsInfoQuery_, GetMaterialMetricsInfoQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMaterialMetricsInfoQuery_, GetMaterialMetricsInfoQueryVariables_>(GetMaterialMetricsInfoDocument_, options);
        }
export type GetMaterialMetricsInfoQueryHookResult = ReturnType<typeof useGetMaterialMetricsInfoQuery>;
export type GetMaterialMetricsInfoLazyQuery_HookResult = ReturnType<typeof useGetMaterialMetricsInfoLazyQuery_>;
export type GetMaterialMetricsInfoSuspenseQuery_HookResult = ReturnType<typeof useGetMaterialMetricsInfoSuspenseQuery_>;
export type GetMaterialMetricsInfoQueryResult_ = Apollo.QueryResult<GetMaterialMetricsInfoQuery_, GetMaterialMetricsInfoQueryVariables_>;
export function refetchGetMaterialMetricsInfoQuery_(variables: GetMaterialMetricsInfoQueryVariables_) {
      return { query: GetMaterialMetricsInfoDocument_, variables: variables }
    }
export const UpsertMultipleDatapointMdrmDocument_ = gql`
    mutation upsertMultipleDatapointMdrm($objects: [esrs_DatapointMdrm_insert_input!]!) {
  insert_esrs_DatapointMdrm(
    objects: $objects
    on_conflict: {constraint: DatapointMdrm_datapointId_mdrmRef_key, update_columns: [value]}
  ) {
    affected_rows
    returning {
      id
      datapointId
    }
  }
}
    `;
export type UpsertMultipleDatapointMdrmMutationFn_ = Apollo.MutationFunction<UpsertMultipleDatapointMdrmMutation_, UpsertMultipleDatapointMdrmMutationVariables_>;

/**
 * __useUpsertMultipleDatapointMdrmMutation__
 *
 * To run a mutation, you first call `useUpsertMultipleDatapointMdrmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMultipleDatapointMdrmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMultipleDatapointMdrmMutation, { data, loading, error }] = useUpsertMultipleDatapointMdrmMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertMultipleDatapointMdrmMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMultipleDatapointMdrmMutation_, UpsertMultipleDatapointMdrmMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMultipleDatapointMdrmMutation_, UpsertMultipleDatapointMdrmMutationVariables_>(UpsertMultipleDatapointMdrmDocument_, options);
      }
export type UpsertMultipleDatapointMdrmMutationHookResult = ReturnType<typeof useUpsertMultipleDatapointMdrmMutation>;
export type UpsertMultipleDatapointMdrmMutationResult_ = Apollo.MutationResult<UpsertMultipleDatapointMdrmMutation_>;
export type UpsertMultipleDatapointMdrmMutationOptions_ = Apollo.BaseMutationOptions<UpsertMultipleDatapointMdrmMutation_, UpsertMultipleDatapointMdrmMutationVariables_>;
export const UpsertMultipleMaterialMetricsDocument_ = gql`
    mutation upsertMultipleMaterialMetrics($objects: [esrs_MaterialMetric_insert_input!]!) {
  insert_esrs_MaterialMetric(
    objects: $objects
    on_conflict: {constraint: MaterialMetric_materialStandardId_metricRef_key, update_columns: []}
  ) {
    affected_rows
    returning {
      id
      metricRef
      materialStandardId
    }
  }
}
    `;
export type UpsertMultipleMaterialMetricsMutationFn_ = Apollo.MutationFunction<UpsertMultipleMaterialMetricsMutation_, UpsertMultipleMaterialMetricsMutationVariables_>;

/**
 * __useUpsertMultipleMaterialMetricsMutation__
 *
 * To run a mutation, you first call `useUpsertMultipleMaterialMetricsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMultipleMaterialMetricsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMultipleMaterialMetricsMutation, { data, loading, error }] = useUpsertMultipleMaterialMetricsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertMultipleMaterialMetricsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMultipleMaterialMetricsMutation_, UpsertMultipleMaterialMetricsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMultipleMaterialMetricsMutation_, UpsertMultipleMaterialMetricsMutationVariables_>(UpsertMultipleMaterialMetricsDocument_, options);
      }
export type UpsertMultipleMaterialMetricsMutationHookResult = ReturnType<typeof useUpsertMultipleMaterialMetricsMutation>;
export type UpsertMultipleMaterialMetricsMutationResult_ = Apollo.MutationResult<UpsertMultipleMaterialMetricsMutation_>;
export type UpsertMultipleMaterialMetricsMutationOptions_ = Apollo.BaseMutationOptions<UpsertMultipleMaterialMetricsMutation_, UpsertMultipleMaterialMetricsMutationVariables_>;
export const GetParentMetricEmptyDatapointsDocument_ = gql`
    query getParentMetricEmptyDatapoints {
  esrs_Datapoint(
    where: {datapointTags_aggregate: {count: {predicate: {_eq: 0}}}, datapointChoices_aggregate: {count: {predicate: {_eq: 0}}}, value: {_is_null: true}, answer: {metric: {metricType: {_eq: DECIMAL}, parentMetrics_aggregate: {count: {predicate: {_eq: 0}}}}}}
  ) {
    id
    answerId
    timeframe
    answer {
      metricRef
    }
    datapointMdrms {
      id
      mdrmRef
      value
    }
  }
}
    `;

/**
 * __useGetParentMetricEmptyDatapointsQuery__
 *
 * To run a query within a React component, call `useGetParentMetricEmptyDatapointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentMetricEmptyDatapointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentMetricEmptyDatapointsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetParentMetricEmptyDatapointsQuery(baseOptions?: Apollo.QueryHookOptions<GetParentMetricEmptyDatapointsQuery_, GetParentMetricEmptyDatapointsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParentMetricEmptyDatapointsQuery_, GetParentMetricEmptyDatapointsQueryVariables_>(GetParentMetricEmptyDatapointsDocument_, options);
      }
export function useGetParentMetricEmptyDatapointsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetParentMetricEmptyDatapointsQuery_, GetParentMetricEmptyDatapointsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParentMetricEmptyDatapointsQuery_, GetParentMetricEmptyDatapointsQueryVariables_>(GetParentMetricEmptyDatapointsDocument_, options);
        }
export function useGetParentMetricEmptyDatapointsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParentMetricEmptyDatapointsQuery_, GetParentMetricEmptyDatapointsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParentMetricEmptyDatapointsQuery_, GetParentMetricEmptyDatapointsQueryVariables_>(GetParentMetricEmptyDatapointsDocument_, options);
        }
export type GetParentMetricEmptyDatapointsQueryHookResult = ReturnType<typeof useGetParentMetricEmptyDatapointsQuery>;
export type GetParentMetricEmptyDatapointsLazyQuery_HookResult = ReturnType<typeof useGetParentMetricEmptyDatapointsLazyQuery_>;
export type GetParentMetricEmptyDatapointsSuspenseQuery_HookResult = ReturnType<typeof useGetParentMetricEmptyDatapointsSuspenseQuery_>;
export type GetParentMetricEmptyDatapointsQueryResult_ = Apollo.QueryResult<GetParentMetricEmptyDatapointsQuery_, GetParentMetricEmptyDatapointsQueryVariables_>;
export function refetchGetParentMetricEmptyDatapointsQuery_(variables?: GetParentMetricEmptyDatapointsQueryVariables_) {
      return { query: GetParentMetricEmptyDatapointsDocument_, variables: variables }
    }
export const GetOldCollectDataAssessmentsDocument_ = gql`
    query getOldCollectDataAssessments {
  EsrsAssessment(
    where: {collectOnly: {_eq: true}, company: {isReal: {_eq: true}}, createdAt: {_lt: "2025-01-28T00:00:00.000Z"}}
  ) {
    id
    reportingYear
    company {
      name
    }
    parentAssessment {
      materialStandards {
        standardRef
        materialMetrics {
          metricRef
        }
      }
    }
    materialStandards {
      standardRef
      materialMetrics {
        metricRef
      }
    }
  }
}
    `;

/**
 * __useGetOldCollectDataAssessmentsQuery__
 *
 * To run a query within a React component, call `useGetOldCollectDataAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOldCollectDataAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOldCollectDataAssessmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOldCollectDataAssessmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetOldCollectDataAssessmentsQuery_, GetOldCollectDataAssessmentsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOldCollectDataAssessmentsQuery_, GetOldCollectDataAssessmentsQueryVariables_>(GetOldCollectDataAssessmentsDocument_, options);
      }
export function useGetOldCollectDataAssessmentsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetOldCollectDataAssessmentsQuery_, GetOldCollectDataAssessmentsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOldCollectDataAssessmentsQuery_, GetOldCollectDataAssessmentsQueryVariables_>(GetOldCollectDataAssessmentsDocument_, options);
        }
export function useGetOldCollectDataAssessmentsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOldCollectDataAssessmentsQuery_, GetOldCollectDataAssessmentsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOldCollectDataAssessmentsQuery_, GetOldCollectDataAssessmentsQueryVariables_>(GetOldCollectDataAssessmentsDocument_, options);
        }
export type GetOldCollectDataAssessmentsQueryHookResult = ReturnType<typeof useGetOldCollectDataAssessmentsQuery>;
export type GetOldCollectDataAssessmentsLazyQuery_HookResult = ReturnType<typeof useGetOldCollectDataAssessmentsLazyQuery_>;
export type GetOldCollectDataAssessmentsSuspenseQuery_HookResult = ReturnType<typeof useGetOldCollectDataAssessmentsSuspenseQuery_>;
export type GetOldCollectDataAssessmentsQueryResult_ = Apollo.QueryResult<GetOldCollectDataAssessmentsQuery_, GetOldCollectDataAssessmentsQueryVariables_>;
export function refetchGetOldCollectDataAssessmentsQuery_(variables?: GetOldCollectDataAssessmentsQueryVariables_) {
      return { query: GetOldCollectDataAssessmentsDocument_, variables: variables }
    }
export const DeleteDatapointsDocument_ = gql`
    mutation deleteDatapoints($ids: [uuid!]!) {
  delete_esrs_Datapoint(where: {id: {_in: $ids}}) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type DeleteDatapointsMutationFn_ = Apollo.MutationFunction<DeleteDatapointsMutation_, DeleteDatapointsMutationVariables_>;

/**
 * __useDeleteDatapointsMutation__
 *
 * To run a mutation, you first call `useDeleteDatapointsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDatapointsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDatapointsMutation, { data, loading, error }] = useDeleteDatapointsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteDatapointsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDatapointsMutation_, DeleteDatapointsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDatapointsMutation_, DeleteDatapointsMutationVariables_>(DeleteDatapointsDocument_, options);
      }
export type DeleteDatapointsMutationHookResult = ReturnType<typeof useDeleteDatapointsMutation>;
export type DeleteDatapointsMutationResult_ = Apollo.MutationResult<DeleteDatapointsMutation_>;
export type DeleteDatapointsMutationOptions_ = Apollo.BaseMutationOptions<DeleteDatapointsMutation_, DeleteDatapointsMutationVariables_>;
export const GetTargetsDrDocument_ = gql`
    query getTargetsDR($reference: String!, $esrsAssessmentId: uuid!, $standardRef: String!) {
  DisclosureRequirement_by_pk(reference: $reference) {
    reference
    title
    description
    type
    targets(
      order_by: {createdAt: asc}
      where: {materialStandard: {assessmentId: {_eq: $esrsAssessmentId}, standardRef: {_eq: $standardRef}}}
    ) {
      ...TargetFields
    }
  }
}
    ${TargetFieldsFragmentDoc_}`;

/**
 * __useGetTargetsDrQuery__
 *
 * To run a query within a React component, call `useGetTargetsDrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetsDrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetsDrQuery({
 *   variables: {
 *      reference: // value for 'reference'
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      standardRef: // value for 'standardRef'
 *   },
 * });
 */
export function useGetTargetsDrQuery(baseOptions: Apollo.QueryHookOptions<GetTargetsDrQuery_, GetTargetsDrQueryVariables_> & ({ variables: GetTargetsDrQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTargetsDrQuery_, GetTargetsDrQueryVariables_>(GetTargetsDrDocument_, options);
      }
export function useGetTargetsDrLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetTargetsDrQuery_, GetTargetsDrQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTargetsDrQuery_, GetTargetsDrQueryVariables_>(GetTargetsDrDocument_, options);
        }
export function useGetTargetsDrSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTargetsDrQuery_, GetTargetsDrQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTargetsDrQuery_, GetTargetsDrQueryVariables_>(GetTargetsDrDocument_, options);
        }
export type GetTargetsDrQueryHookResult = ReturnType<typeof useGetTargetsDrQuery>;
export type GetTargetsDrLazyQuery_HookResult = ReturnType<typeof useGetTargetsDrLazyQuery_>;
export type GetTargetsDrSuspenseQuery_HookResult = ReturnType<typeof useGetTargetsDrSuspenseQuery_>;
export type GetTargetsDrQueryResult_ = Apollo.QueryResult<GetTargetsDrQuery_, GetTargetsDrQueryVariables_>;
export function refetchGetTargetsDrQuery_(variables: GetTargetsDrQueryVariables_) {
      return { query: GetTargetsDrDocument_, variables: variables }
    }
export const GetTargetDocument_ = gql`
    query getTarget($targetId: uuid!) {
  target: esrs_Target_by_pk(id: $targetId) {
    ...TargetsWithSubsidiaries
  }
}
    ${TargetsWithSubsidiariesFragmentDoc_}`;

/**
 * __useGetTargetQuery__
 *
 * To run a query within a React component, call `useGetTargetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetQuery({
 *   variables: {
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useGetTargetQuery(baseOptions: Apollo.QueryHookOptions<GetTargetQuery_, GetTargetQueryVariables_> & ({ variables: GetTargetQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTargetQuery_, GetTargetQueryVariables_>(GetTargetDocument_, options);
      }
export function useGetTargetLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetTargetQuery_, GetTargetQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTargetQuery_, GetTargetQueryVariables_>(GetTargetDocument_, options);
        }
export function useGetTargetSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTargetQuery_, GetTargetQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTargetQuery_, GetTargetQueryVariables_>(GetTargetDocument_, options);
        }
export type GetTargetQueryHookResult = ReturnType<typeof useGetTargetQuery>;
export type GetTargetLazyQuery_HookResult = ReturnType<typeof useGetTargetLazyQuery_>;
export type GetTargetSuspenseQuery_HookResult = ReturnType<typeof useGetTargetSuspenseQuery_>;
export type GetTargetQueryResult_ = Apollo.QueryResult<GetTargetQuery_, GetTargetQueryVariables_>;
export function refetchGetTargetQuery_(variables: GetTargetQueryVariables_) {
      return { query: GetTargetDocument_, variables: variables }
    }
export const GetTargetsSubsidiariesDocument_ = gql`
    query getTargetsSubsidiaries($standardRef: String!, $esrsAssessmentId: uuid!) {
  esrs: EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    subsidiaries: subsidiaryAssessments {
      id
      company {
        id
        name
      }
      materialStandards(where: {standardRef: {_eq: $standardRef}}) {
        id
        isMaterial
        targets {
          ...TargetFields
        }
      }
    }
  }
}
    ${TargetFieldsFragmentDoc_}`;

/**
 * __useGetTargetsSubsidiariesQuery__
 *
 * To run a query within a React component, call `useGetTargetsSubsidiariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetsSubsidiariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetsSubsidiariesQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetTargetsSubsidiariesQuery(baseOptions: Apollo.QueryHookOptions<GetTargetsSubsidiariesQuery_, GetTargetsSubsidiariesQueryVariables_> & ({ variables: GetTargetsSubsidiariesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTargetsSubsidiariesQuery_, GetTargetsSubsidiariesQueryVariables_>(GetTargetsSubsidiariesDocument_, options);
      }
export function useGetTargetsSubsidiariesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetTargetsSubsidiariesQuery_, GetTargetsSubsidiariesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTargetsSubsidiariesQuery_, GetTargetsSubsidiariesQueryVariables_>(GetTargetsSubsidiariesDocument_, options);
        }
export function useGetTargetsSubsidiariesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTargetsSubsidiariesQuery_, GetTargetsSubsidiariesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTargetsSubsidiariesQuery_, GetTargetsSubsidiariesQueryVariables_>(GetTargetsSubsidiariesDocument_, options);
        }
export type GetTargetsSubsidiariesQueryHookResult = ReturnType<typeof useGetTargetsSubsidiariesQuery>;
export type GetTargetsSubsidiariesLazyQuery_HookResult = ReturnType<typeof useGetTargetsSubsidiariesLazyQuery_>;
export type GetTargetsSubsidiariesSuspenseQuery_HookResult = ReturnType<typeof useGetTargetsSubsidiariesSuspenseQuery_>;
export type GetTargetsSubsidiariesQueryResult_ = Apollo.QueryResult<GetTargetsSubsidiariesQuery_, GetTargetsSubsidiariesQueryVariables_>;
export function refetchGetTargetsSubsidiariesQuery_(variables: GetTargetsSubsidiariesQueryVariables_) {
      return { query: GetTargetsSubsidiariesDocument_, variables: variables }
    }
export const GetParentTargetsDrDocument_ = gql`
    query getParentTargetsDR($parentStandardId: uuid!) {
  esrs_Target(
    order_by: {createdAt: asc}
    where: {assessmentId: {_eq: $parentStandardId}, isBottomUp: {_eq: false}}
  ) {
    ...TargetFields
  }
}
    ${TargetFieldsFragmentDoc_}`;

/**
 * __useGetParentTargetsDrQuery__
 *
 * To run a query within a React component, call `useGetParentTargetsDrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentTargetsDrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentTargetsDrQuery({
 *   variables: {
 *      parentStandardId: // value for 'parentStandardId'
 *   },
 * });
 */
export function useGetParentTargetsDrQuery(baseOptions: Apollo.QueryHookOptions<GetParentTargetsDrQuery_, GetParentTargetsDrQueryVariables_> & ({ variables: GetParentTargetsDrQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParentTargetsDrQuery_, GetParentTargetsDrQueryVariables_>(GetParentTargetsDrDocument_, options);
      }
export function useGetParentTargetsDrLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetParentTargetsDrQuery_, GetParentTargetsDrQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParentTargetsDrQuery_, GetParentTargetsDrQueryVariables_>(GetParentTargetsDrDocument_, options);
        }
export function useGetParentTargetsDrSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetParentTargetsDrQuery_, GetParentTargetsDrQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetParentTargetsDrQuery_, GetParentTargetsDrQueryVariables_>(GetParentTargetsDrDocument_, options);
        }
export type GetParentTargetsDrQueryHookResult = ReturnType<typeof useGetParentTargetsDrQuery>;
export type GetParentTargetsDrLazyQuery_HookResult = ReturnType<typeof useGetParentTargetsDrLazyQuery_>;
export type GetParentTargetsDrSuspenseQuery_HookResult = ReturnType<typeof useGetParentTargetsDrSuspenseQuery_>;
export type GetParentTargetsDrQueryResult_ = Apollo.QueryResult<GetParentTargetsDrQuery_, GetParentTargetsDrQueryVariables_>;
export function refetchGetParentTargetsDrQuery_(variables: GetParentTargetsDrQueryVariables_) {
      return { query: GetParentTargetsDrDocument_, variables: variables }
    }
export const GetTargetsDocument_ = gql`
    query getTargets($disclosureRequirementRef: String!, $assessmentId: uuid!) {
  targets: esrs_Target(
    where: {disclosureRequirement: {type: {_eq: "target"}, group: {standard: {disclosureRequirementGroups: {requirements: {reference: {_eq: $disclosureRequirementRef}}}}}}, assessmentId: {_eq: $assessmentId}}
  ) {
    ...TargetFields
  }
}
    ${TargetFieldsFragmentDoc_}`;

/**
 * __useGetTargetsQuery__
 *
 * To run a query within a React component, call `useGetTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetsQuery({
 *   variables: {
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetTargetsQuery(baseOptions: Apollo.QueryHookOptions<GetTargetsQuery_, GetTargetsQueryVariables_> & ({ variables: GetTargetsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTargetsQuery_, GetTargetsQueryVariables_>(GetTargetsDocument_, options);
      }
export function useGetTargetsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetTargetsQuery_, GetTargetsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTargetsQuery_, GetTargetsQueryVariables_>(GetTargetsDocument_, options);
        }
export function useGetTargetsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTargetsQuery_, GetTargetsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTargetsQuery_, GetTargetsQueryVariables_>(GetTargetsDocument_, options);
        }
export type GetTargetsQueryHookResult = ReturnType<typeof useGetTargetsQuery>;
export type GetTargetsLazyQuery_HookResult = ReturnType<typeof useGetTargetsLazyQuery_>;
export type GetTargetsSuspenseQuery_HookResult = ReturnType<typeof useGetTargetsSuspenseQuery_>;
export type GetTargetsQueryResult_ = Apollo.QueryResult<GetTargetsQuery_, GetTargetsQueryVariables_>;
export function refetchGetTargetsQuery_(variables: GetTargetsQueryVariables_) {
      return { query: GetTargetsDocument_, variables: variables }
    }
export const GetTargetsByStandardAndAssessmentDocument_ = gql`
    query getTargetsByStandardAndAssessment($disclosureRequirementRef: String!, $esrsAssessmentId: uuid!, $standardRef: String!) {
  targets: esrs_Target(
    order_by: {createdAt: asc}
    where: {disclosureRequirementRef: {_eq: $disclosureRequirementRef}, materialStandard: {assessmentId: {_eq: $esrsAssessmentId}, standardRef: {_eq: $standardRef}}}
  ) {
    ...TargetFields
  }
}
    ${TargetFieldsFragmentDoc_}`;

/**
 * __useGetTargetsByStandardAndAssessmentQuery__
 *
 * To run a query within a React component, call `useGetTargetsByStandardAndAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTargetsByStandardAndAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTargetsByStandardAndAssessmentQuery({
 *   variables: {
 *      disclosureRequirementRef: // value for 'disclosureRequirementRef'
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *      standardRef: // value for 'standardRef'
 *   },
 * });
 */
export function useGetTargetsByStandardAndAssessmentQuery(baseOptions: Apollo.QueryHookOptions<GetTargetsByStandardAndAssessmentQuery_, GetTargetsByStandardAndAssessmentQueryVariables_> & ({ variables: GetTargetsByStandardAndAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTargetsByStandardAndAssessmentQuery_, GetTargetsByStandardAndAssessmentQueryVariables_>(GetTargetsByStandardAndAssessmentDocument_, options);
      }
export function useGetTargetsByStandardAndAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetTargetsByStandardAndAssessmentQuery_, GetTargetsByStandardAndAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTargetsByStandardAndAssessmentQuery_, GetTargetsByStandardAndAssessmentQueryVariables_>(GetTargetsByStandardAndAssessmentDocument_, options);
        }
export function useGetTargetsByStandardAndAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTargetsByStandardAndAssessmentQuery_, GetTargetsByStandardAndAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTargetsByStandardAndAssessmentQuery_, GetTargetsByStandardAndAssessmentQueryVariables_>(GetTargetsByStandardAndAssessmentDocument_, options);
        }
export type GetTargetsByStandardAndAssessmentQueryHookResult = ReturnType<typeof useGetTargetsByStandardAndAssessmentQuery>;
export type GetTargetsByStandardAndAssessmentLazyQuery_HookResult = ReturnType<typeof useGetTargetsByStandardAndAssessmentLazyQuery_>;
export type GetTargetsByStandardAndAssessmentSuspenseQuery_HookResult = ReturnType<typeof useGetTargetsByStandardAndAssessmentSuspenseQuery_>;
export type GetTargetsByStandardAndAssessmentQueryResult_ = Apollo.QueryResult<GetTargetsByStandardAndAssessmentQuery_, GetTargetsByStandardAndAssessmentQueryVariables_>;
export function refetchGetTargetsByStandardAndAssessmentQuery_(variables: GetTargetsByStandardAndAssessmentQueryVariables_) {
      return { query: GetTargetsByStandardAndAssessmentDocument_, variables: variables }
    }
export const EsrsAssessmentTargetsDocument_ = gql`
    query EsrsAssessmentTargets($esrsAssessmentId: uuid!) {
  esrs_Target(
    where: {_or: [{materialStandard: {esrsAssessment: {id: {_eq: $esrsAssessmentId}}}}, {materialStandard: {esrsAssessment: {parentAssessmentId: {_eq: $esrsAssessmentId}}}}]}
  ) {
    ...TargetFields
    materialStandard {
      esrsAssessment {
        id
        parentAssessmentId
        company {
          id
          name
          isGroupOwner
        }
      }
    }
    disclosureRequirement {
      reference
      group {
        reference
        standard {
          title
          reference
          category {
            title
            reference
          }
        }
      }
    }
  }
}
    ${TargetFieldsFragmentDoc_}`;

/**
 * __useEsrsAssessmentTargetsQuery__
 *
 * To run a query within a React component, call `useEsrsAssessmentTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEsrsAssessmentTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEsrsAssessmentTargetsQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useEsrsAssessmentTargetsQuery(baseOptions: Apollo.QueryHookOptions<EsrsAssessmentTargetsQuery_, EsrsAssessmentTargetsQueryVariables_> & ({ variables: EsrsAssessmentTargetsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EsrsAssessmentTargetsQuery_, EsrsAssessmentTargetsQueryVariables_>(EsrsAssessmentTargetsDocument_, options);
      }
export function useEsrsAssessmentTargetsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<EsrsAssessmentTargetsQuery_, EsrsAssessmentTargetsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EsrsAssessmentTargetsQuery_, EsrsAssessmentTargetsQueryVariables_>(EsrsAssessmentTargetsDocument_, options);
        }
export function useEsrsAssessmentTargetsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EsrsAssessmentTargetsQuery_, EsrsAssessmentTargetsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EsrsAssessmentTargetsQuery_, EsrsAssessmentTargetsQueryVariables_>(EsrsAssessmentTargetsDocument_, options);
        }
export type EsrsAssessmentTargetsQueryHookResult = ReturnType<typeof useEsrsAssessmentTargetsQuery>;
export type EsrsAssessmentTargetsLazyQuery_HookResult = ReturnType<typeof useEsrsAssessmentTargetsLazyQuery_>;
export type EsrsAssessmentTargetsSuspenseQuery_HookResult = ReturnType<typeof useEsrsAssessmentTargetsSuspenseQuery_>;
export type EsrsAssessmentTargetsQueryResult_ = Apollo.QueryResult<EsrsAssessmentTargetsQuery_, EsrsAssessmentTargetsQueryVariables_>;
export function refetchEsrsAssessmentTargetsQuery_(variables: EsrsAssessmentTargetsQueryVariables_) {
      return { query: EsrsAssessmentTargetsDocument_, variables: variables }
    }
export const TargetQuestionsDocument_ = gql`
    query targetQuestions($standardRef: String!) {
  TargetQuestion(
    order_by: [{globalOrder: asc}, {isAR: asc}, {order: asc}, {firstLevel: asc}, {secondLevel: asc}]
    where: {standardRef: {_eq: $standardRef}}
  ) {
    ...TargetQuestionFields
  }
}
    ${TargetQuestionFieldsFragmentDoc_}`;

/**
 * __useTargetQuestionsQuery__
 *
 * To run a query within a React component, call `useTargetQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetQuestionsQuery({
 *   variables: {
 *      standardRef: // value for 'standardRef'
 *   },
 * });
 */
export function useTargetQuestionsQuery(baseOptions: Apollo.QueryHookOptions<TargetQuestionsQuery_, TargetQuestionsQueryVariables_> & ({ variables: TargetQuestionsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetQuestionsQuery_, TargetQuestionsQueryVariables_>(TargetQuestionsDocument_, options);
      }
export function useTargetQuestionsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<TargetQuestionsQuery_, TargetQuestionsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetQuestionsQuery_, TargetQuestionsQueryVariables_>(TargetQuestionsDocument_, options);
        }
export function useTargetQuestionsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TargetQuestionsQuery_, TargetQuestionsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TargetQuestionsQuery_, TargetQuestionsQueryVariables_>(TargetQuestionsDocument_, options);
        }
export type TargetQuestionsQueryHookResult = ReturnType<typeof useTargetQuestionsQuery>;
export type TargetQuestionsLazyQuery_HookResult = ReturnType<typeof useTargetQuestionsLazyQuery_>;
export type TargetQuestionsSuspenseQuery_HookResult = ReturnType<typeof useTargetQuestionsSuspenseQuery_>;
export type TargetQuestionsQueryResult_ = Apollo.QueryResult<TargetQuestionsQuery_, TargetQuestionsQueryVariables_>;
export function refetchTargetQuestionsQuery_(variables: TargetQuestionsQueryVariables_) {
      return { query: TargetQuestionsDocument_, variables: variables }
    }
export const GetRequiredTargetMaterialMetricsDocument_ = gql`
    query getRequiredTargetMaterialMetrics($materialStandardId: uuid!, $parentStandardId: uuid!) {
  esrs_MaterialMetric(
    where: {_or: [{isMaterial: {_eq: true}, materialStandard: {id: {_eq: $materialStandardId}, isMaterial: {_eq: true}}}, {isMaterial: {_eq: true}, materialStandard: {id: {_eq: $parentStandardId}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}, metric: {hierarchyStatus: {isLeaf: {_eq: true}}}, _and: {metric: {materialMetrics: {materialStandardId: {_eq: $materialStandardId}}}}}]}
  ) {
    metricRef
  }
}
    `;

/**
 * __useGetRequiredTargetMaterialMetricsQuery__
 *
 * To run a query within a React component, call `useGetRequiredTargetMaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredTargetMaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredTargetMaterialMetricsQuery({
 *   variables: {
 *      materialStandardId: // value for 'materialStandardId'
 *      parentStandardId: // value for 'parentStandardId'
 *   },
 * });
 */
export function useGetRequiredTargetMaterialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetRequiredTargetMaterialMetricsQuery_, GetRequiredTargetMaterialMetricsQueryVariables_> & ({ variables: GetRequiredTargetMaterialMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequiredTargetMaterialMetricsQuery_, GetRequiredTargetMaterialMetricsQueryVariables_>(GetRequiredTargetMaterialMetricsDocument_, options);
      }
export function useGetRequiredTargetMaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetRequiredTargetMaterialMetricsQuery_, GetRequiredTargetMaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequiredTargetMaterialMetricsQuery_, GetRequiredTargetMaterialMetricsQueryVariables_>(GetRequiredTargetMaterialMetricsDocument_, options);
        }
export function useGetRequiredTargetMaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequiredTargetMaterialMetricsQuery_, GetRequiredTargetMaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequiredTargetMaterialMetricsQuery_, GetRequiredTargetMaterialMetricsQueryVariables_>(GetRequiredTargetMaterialMetricsDocument_, options);
        }
export type GetRequiredTargetMaterialMetricsQueryHookResult = ReturnType<typeof useGetRequiredTargetMaterialMetricsQuery>;
export type GetRequiredTargetMaterialMetricsLazyQuery_HookResult = ReturnType<typeof useGetRequiredTargetMaterialMetricsLazyQuery_>;
export type GetRequiredTargetMaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetRequiredTargetMaterialMetricsSuspenseQuery_>;
export type GetRequiredTargetMaterialMetricsQueryResult_ = Apollo.QueryResult<GetRequiredTargetMaterialMetricsQuery_, GetRequiredTargetMaterialMetricsQueryVariables_>;
export function refetchGetRequiredTargetMaterialMetricsQuery_(variables: GetRequiredTargetMaterialMetricsQueryVariables_) {
      return { query: GetRequiredTargetMaterialMetricsDocument_, variables: variables }
    }
export const UpsertTargetDocument_ = gql`
    mutation upsertTarget($target: [esrs_Target_insert_input!]!) {
  insert_esrs_Target(
    objects: $target
    on_conflict: {constraint: Target_pkey, update_columns: [answers, relatedIRO, relatedPolicy, period, isBottomUp, periodExplanation, scope, methodologies, isEvidenceScientific, isEvidenceScientificExplanation, withStakeholders, withStakeholdersExplanation, withStakeholdersDescription, targetChangeDescription, performanceNumber, performanceText, isProgressAligned, isProgressAlignedExplanation, sustainabilityMatter, sustainabilityMatterExplanation, relationshipToPolicy, coverageExplanation, coverage]}
  ) {
    returning {
      id
      metricRef
      milestones {
        id
        year
      }
      attachmentBox {
        id
      }
      noteHistory {
        id
      }
      actionTargets {
        actionId
      }
    }
  }
}
    `;
export type UpsertTargetMutationFn_ = Apollo.MutationFunction<UpsertTargetMutation_, UpsertTargetMutationVariables_>;

/**
 * __useUpsertTargetMutation__
 *
 * To run a mutation, you first call `useUpsertTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTargetMutation, { data, loading, error }] = useUpsertTargetMutation({
 *   variables: {
 *      target: // value for 'target'
 *   },
 * });
 */
export function useUpsertTargetMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTargetMutation_, UpsertTargetMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTargetMutation_, UpsertTargetMutationVariables_>(UpsertTargetDocument_, options);
      }
export type UpsertTargetMutationHookResult = ReturnType<typeof useUpsertTargetMutation>;
export type UpsertTargetMutationResult_ = Apollo.MutationResult<UpsertTargetMutation_>;
export type UpsertTargetMutationOptions_ = Apollo.BaseMutationOptions<UpsertTargetMutation_, UpsertTargetMutationVariables_>;
export const CreateShortTargetDocument_ = gql`
    mutation createShortTarget($target: esrs_Target_insert_input!) {
  insert_esrs_Target_one(
    object: $target
    on_conflict: {constraint: Target_pkey, update_columns: [name, ownerId, isBottomUp, isRequired]}
  ) {
    id
  }
}
    `;
export type CreateShortTargetMutationFn_ = Apollo.MutationFunction<CreateShortTargetMutation_, CreateShortTargetMutationVariables_>;

/**
 * __useCreateShortTargetMutation__
 *
 * To run a mutation, you first call `useCreateShortTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShortTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShortTargetMutation, { data, loading, error }] = useCreateShortTargetMutation({
 *   variables: {
 *      target: // value for 'target'
 *   },
 * });
 */
export function useCreateShortTargetMutation(baseOptions?: Apollo.MutationHookOptions<CreateShortTargetMutation_, CreateShortTargetMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateShortTargetMutation_, CreateShortTargetMutationVariables_>(CreateShortTargetDocument_, options);
      }
export type CreateShortTargetMutationHookResult = ReturnType<typeof useCreateShortTargetMutation>;
export type CreateShortTargetMutationResult_ = Apollo.MutationResult<CreateShortTargetMutation_>;
export type CreateShortTargetMutationOptions_ = Apollo.BaseMutationOptions<CreateShortTargetMutation_, CreateShortTargetMutationVariables_>;
export const DeleteTargetDocument_ = gql`
    mutation deleteTarget($targetId: uuid!) {
  delete_esrs_Target_by_pk(id: $targetId) {
    id
  }
}
    `;
export type DeleteTargetMutationFn_ = Apollo.MutationFunction<DeleteTargetMutation_, DeleteTargetMutationVariables_>;

/**
 * __useDeleteTargetMutation__
 *
 * To run a mutation, you first call `useDeleteTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTargetMutation, { data, loading, error }] = useDeleteTargetMutation({
 *   variables: {
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useDeleteTargetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTargetMutation_, DeleteTargetMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTargetMutation_, DeleteTargetMutationVariables_>(DeleteTargetDocument_, options);
      }
export type DeleteTargetMutationHookResult = ReturnType<typeof useDeleteTargetMutation>;
export type DeleteTargetMutationResult_ = Apollo.MutationResult<DeleteTargetMutation_>;
export type DeleteTargetMutationOptions_ = Apollo.BaseMutationOptions<DeleteTargetMutation_, DeleteTargetMutationVariables_>;
export const DeleteBaselinesDocument_ = gql`
    mutation deleteBaselines($baselineIds: [uuid!]!) {
  delete_esrs_Baseline(where: {id: {_in: $baselineIds}}) {
    affected_rows
  }
}
    `;
export type DeleteBaselinesMutationFn_ = Apollo.MutationFunction<DeleteBaselinesMutation_, DeleteBaselinesMutationVariables_>;

/**
 * __useDeleteBaselinesMutation__
 *
 * To run a mutation, you first call `useDeleteBaselinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBaselinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBaselinesMutation, { data, loading, error }] = useDeleteBaselinesMutation({
 *   variables: {
 *      baselineIds: // value for 'baselineIds'
 *   },
 * });
 */
export function useDeleteBaselinesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBaselinesMutation_, DeleteBaselinesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBaselinesMutation_, DeleteBaselinesMutationVariables_>(DeleteBaselinesDocument_, options);
      }
export type DeleteBaselinesMutationHookResult = ReturnType<typeof useDeleteBaselinesMutation>;
export type DeleteBaselinesMutationResult_ = Apollo.MutationResult<DeleteBaselinesMutation_>;
export type DeleteBaselinesMutationOptions_ = Apollo.BaseMutationOptions<DeleteBaselinesMutation_, DeleteBaselinesMutationVariables_>;
export const DeleteMilestoneDocument_ = gql`
    mutation deleteMilestone($milestoneId: uuid!) {
  delete_esrs_MilestoneResult(where: {milestoneId: {_eq: $milestoneId}}) {
    affected_rows
  }
  delete_esrs_Milestone_by_pk(id: $milestoneId) {
    id
  }
}
    `;
export type DeleteMilestoneMutationFn_ = Apollo.MutationFunction<DeleteMilestoneMutation_, DeleteMilestoneMutationVariables_>;

/**
 * __useDeleteMilestoneMutation__
 *
 * To run a mutation, you first call `useDeleteMilestoneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMilestoneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMilestoneMutation, { data, loading, error }] = useDeleteMilestoneMutation({
 *   variables: {
 *      milestoneId: // value for 'milestoneId'
 *   },
 * });
 */
export function useDeleteMilestoneMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMilestoneMutation_, DeleteMilestoneMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMilestoneMutation_, DeleteMilestoneMutationVariables_>(DeleteMilestoneDocument_, options);
      }
export type DeleteMilestoneMutationHookResult = ReturnType<typeof useDeleteMilestoneMutation>;
export type DeleteMilestoneMutationResult_ = Apollo.MutationResult<DeleteMilestoneMutation_>;
export type DeleteMilestoneMutationOptions_ = Apollo.BaseMutationOptions<DeleteMilestoneMutation_, DeleteMilestoneMutationVariables_>;
export const UnlinkTargetParentDocument_ = gql`
    mutation unlinkTargetParent($ids: [uuid!]!) {
  update_esrs_Target_many(
    updates: {where: {id: {_in: $ids}}, _set: {parentTargetId: null}}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UnlinkTargetParentMutationFn_ = Apollo.MutationFunction<UnlinkTargetParentMutation_, UnlinkTargetParentMutationVariables_>;

/**
 * __useUnlinkTargetParentMutation__
 *
 * To run a mutation, you first call `useUnlinkTargetParentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkTargetParentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkTargetParentMutation, { data, loading, error }] = useUnlinkTargetParentMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUnlinkTargetParentMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkTargetParentMutation_, UnlinkTargetParentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkTargetParentMutation_, UnlinkTargetParentMutationVariables_>(UnlinkTargetParentDocument_, options);
      }
export type UnlinkTargetParentMutationHookResult = ReturnType<typeof useUnlinkTargetParentMutation>;
export type UnlinkTargetParentMutationResult_ = Apollo.MutationResult<UnlinkTargetParentMutation_>;
export type UnlinkTargetParentMutationOptions_ = Apollo.BaseMutationOptions<UnlinkTargetParentMutation_, UnlinkTargetParentMutationVariables_>;
export const InsertProviderRequestDocument_ = gql`
    mutation insertProviderRequest($providerRequest: authProviderRequests_insert_input!) {
  insertAuthProviderRequest(
    object: $providerRequest
    on_conflict: {constraint: provider_requests_pkey, update_columns: [options]}
  ) {
    id
    options
  }
}
    `;
export type InsertProviderRequestMutationFn_ = Apollo.MutationFunction<InsertProviderRequestMutation_, InsertProviderRequestMutationVariables_>;

/**
 * __useInsertProviderRequestMutation__
 *
 * To run a mutation, you first call `useInsertProviderRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertProviderRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertProviderRequestMutation, { data, loading, error }] = useInsertProviderRequestMutation({
 *   variables: {
 *      providerRequest: // value for 'providerRequest'
 *   },
 * });
 */
export function useInsertProviderRequestMutation(baseOptions?: Apollo.MutationHookOptions<InsertProviderRequestMutation_, InsertProviderRequestMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertProviderRequestMutation_, InsertProviderRequestMutationVariables_>(InsertProviderRequestDocument_, options);
      }
export type InsertProviderRequestMutationHookResult = ReturnType<typeof useInsertProviderRequestMutation>;
export type InsertProviderRequestMutationResult_ = Apollo.MutationResult<InsertProviderRequestMutation_>;
export type InsertProviderRequestMutationOptions_ = Apollo.BaseMutationOptions<InsertProviderRequestMutation_, InsertProviderRequestMutationVariables_>;
export const DeleteProviderRequestDocument_ = gql`
    mutation deleteProviderRequest($id: uuid!) {
  deleteAuthProviderRequest(id: $id) {
    id
    options
  }
}
    `;
export type DeleteProviderRequestMutationFn_ = Apollo.MutationFunction<DeleteProviderRequestMutation_, DeleteProviderRequestMutationVariables_>;

/**
 * __useDeleteProviderRequestMutation__
 *
 * To run a mutation, you first call `useDeleteProviderRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProviderRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProviderRequestMutation, { data, loading, error }] = useDeleteProviderRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProviderRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProviderRequestMutation_, DeleteProviderRequestMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProviderRequestMutation_, DeleteProviderRequestMutationVariables_>(DeleteProviderRequestDocument_, options);
      }
export type DeleteProviderRequestMutationHookResult = ReturnType<typeof useDeleteProviderRequestMutation>;
export type DeleteProviderRequestMutationResult_ = Apollo.MutationResult<DeleteProviderRequestMutation_>;
export type DeleteProviderRequestMutationOptions_ = Apollo.BaseMutationOptions<DeleteProviderRequestMutation_, DeleteProviderRequestMutationVariables_>;
export const ProviderRequestDocument_ = gql`
    query providerRequest($id: uuid!) {
  authProviderRequest(id: $id) {
    id
    options
  }
}
    `;

/**
 * __useProviderRequestQuery__
 *
 * To run a query within a React component, call `useProviderRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProviderRequestQuery(baseOptions: Apollo.QueryHookOptions<ProviderRequestQuery_, ProviderRequestQueryVariables_> & ({ variables: ProviderRequestQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderRequestQuery_, ProviderRequestQueryVariables_>(ProviderRequestDocument_, options);
      }
export function useProviderRequestLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ProviderRequestQuery_, ProviderRequestQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderRequestQuery_, ProviderRequestQueryVariables_>(ProviderRequestDocument_, options);
        }
export function useProviderRequestSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProviderRequestQuery_, ProviderRequestQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProviderRequestQuery_, ProviderRequestQueryVariables_>(ProviderRequestDocument_, options);
        }
export type ProviderRequestQueryHookResult = ReturnType<typeof useProviderRequestQuery>;
export type ProviderRequestLazyQuery_HookResult = ReturnType<typeof useProviderRequestLazyQuery_>;
export type ProviderRequestSuspenseQuery_HookResult = ReturnType<typeof useProviderRequestSuspenseQuery_>;
export type ProviderRequestQueryResult_ = Apollo.QueryResult<ProviderRequestQuery_, ProviderRequestQueryVariables_>;
export function refetchProviderRequestQuery_(variables: ProviderRequestQueryVariables_) {
      return { query: ProviderRequestDocument_, variables: variables }
    }
export const InsertRefreshTokenDocument_ = gql`
    mutation insertRefreshToken($refreshToken: authRefreshTokens_insert_input!) {
  insertAuthRefreshToken(object: $refreshToken) {
    id
  }
}
    `;
export type InsertRefreshTokenMutationFn_ = Apollo.MutationFunction<InsertRefreshTokenMutation_, InsertRefreshTokenMutationVariables_>;

/**
 * __useInsertRefreshTokenMutation__
 *
 * To run a mutation, you first call `useInsertRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertRefreshTokenMutation, { data, loading, error }] = useInsertRefreshTokenMutation({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useInsertRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<InsertRefreshTokenMutation_, InsertRefreshTokenMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertRefreshTokenMutation_, InsertRefreshTokenMutationVariables_>(InsertRefreshTokenDocument_, options);
      }
export type InsertRefreshTokenMutationHookResult = ReturnType<typeof useInsertRefreshTokenMutation>;
export type InsertRefreshTokenMutationResult_ = Apollo.MutationResult<InsertRefreshTokenMutation_>;
export type InsertRefreshTokenMutationOptions_ = Apollo.BaseMutationOptions<InsertRefreshTokenMutation_, InsertRefreshTokenMutationVariables_>;
export const DeleteRefreshTokenDocument_ = gql`
    mutation deleteRefreshToken($refreshTokenHash: String!) {
  deleteAuthRefreshTokens(where: {refreshTokenHash: {_eq: $refreshTokenHash}}) {
    affected_rows
  }
}
    `;
export type DeleteRefreshTokenMutationFn_ = Apollo.MutationFunction<DeleteRefreshTokenMutation_, DeleteRefreshTokenMutationVariables_>;

/**
 * __useDeleteRefreshTokenMutation__
 *
 * To run a mutation, you first call `useDeleteRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRefreshTokenMutation, { data, loading, error }] = useDeleteRefreshTokenMutation({
 *   variables: {
 *      refreshTokenHash: // value for 'refreshTokenHash'
 *   },
 * });
 */
export function useDeleteRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRefreshTokenMutation_, DeleteRefreshTokenMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRefreshTokenMutation_, DeleteRefreshTokenMutationVariables_>(DeleteRefreshTokenDocument_, options);
      }
export type DeleteRefreshTokenMutationHookResult = ReturnType<typeof useDeleteRefreshTokenMutation>;
export type DeleteRefreshTokenMutationResult_ = Apollo.MutationResult<DeleteRefreshTokenMutation_>;
export type DeleteRefreshTokenMutationOptions_ = Apollo.BaseMutationOptions<DeleteRefreshTokenMutation_, DeleteRefreshTokenMutationVariables_>;
export const DeleteUserRefreshTokensDocument_ = gql`
    mutation deleteUserRefreshTokens($userId: uuid!) {
  deleteAuthRefreshTokens(where: {user: {id: {_eq: $userId}}}) {
    affected_rows
  }
}
    `;
export type DeleteUserRefreshTokensMutationFn_ = Apollo.MutationFunction<DeleteUserRefreshTokensMutation_, DeleteUserRefreshTokensMutationVariables_>;

/**
 * __useDeleteUserRefreshTokensMutation__
 *
 * To run a mutation, you first call `useDeleteUserRefreshTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserRefreshTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserRefreshTokensMutation, { data, loading, error }] = useDeleteUserRefreshTokensMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserRefreshTokensMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserRefreshTokensMutation_, DeleteUserRefreshTokensMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserRefreshTokensMutation_, DeleteUserRefreshTokensMutationVariables_>(DeleteUserRefreshTokensDocument_, options);
      }
export type DeleteUserRefreshTokensMutationHookResult = ReturnType<typeof useDeleteUserRefreshTokensMutation>;
export type DeleteUserRefreshTokensMutationResult_ = Apollo.MutationResult<DeleteUserRefreshTokensMutation_>;
export type DeleteUserRefreshTokensMutationOptions_ = Apollo.BaseMutationOptions<DeleteUserRefreshTokensMutation_, DeleteUserRefreshTokensMutationVariables_>;
export const DeleteExpiredRefreshTokensDocument_ = gql`
    mutation deleteExpiredRefreshTokens {
  deleteAuthRefreshTokens(where: {expiresAt: {_lt: now}}) {
    affected_rows
  }
}
    `;
export type DeleteExpiredRefreshTokensMutationFn_ = Apollo.MutationFunction<DeleteExpiredRefreshTokensMutation_, DeleteExpiredRefreshTokensMutationVariables_>;

/**
 * __useDeleteExpiredRefreshTokensMutation__
 *
 * To run a mutation, you first call `useDeleteExpiredRefreshTokensMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteExpiredRefreshTokensMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteExpiredRefreshTokensMutation, { data, loading, error }] = useDeleteExpiredRefreshTokensMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteExpiredRefreshTokensMutation(baseOptions?: Apollo.MutationHookOptions<DeleteExpiredRefreshTokensMutation_, DeleteExpiredRefreshTokensMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteExpiredRefreshTokensMutation_, DeleteExpiredRefreshTokensMutationVariables_>(DeleteExpiredRefreshTokensDocument_, options);
      }
export type DeleteExpiredRefreshTokensMutationHookResult = ReturnType<typeof useDeleteExpiredRefreshTokensMutation>;
export type DeleteExpiredRefreshTokensMutationResult_ = Apollo.MutationResult<DeleteExpiredRefreshTokensMutation_>;
export type DeleteExpiredRefreshTokensMutationOptions_ = Apollo.BaseMutationOptions<DeleteExpiredRefreshTokensMutation_, DeleteExpiredRefreshTokensMutationVariables_>;
export const UpsertRolesDocument_ = gql`
    mutation upsertRoles($roles: [authRoles_insert_input!]!) {
  insertAuthRoles(
    objects: $roles
    on_conflict: {constraint: roles_pkey, update_columns: []}
  ) {
    affected_rows
    returning {
      role
    }
  }
}
    `;
export type UpsertRolesMutationFn_ = Apollo.MutationFunction<UpsertRolesMutation_, UpsertRolesMutationVariables_>;

/**
 * __useUpsertRolesMutation__
 *
 * To run a mutation, you first call `useUpsertRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRolesMutation, { data, loading, error }] = useUpsertRolesMutation({
 *   variables: {
 *      roles: // value for 'roles'
 *   },
 * });
 */
export function useUpsertRolesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertRolesMutation_, UpsertRolesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertRolesMutation_, UpsertRolesMutationVariables_>(UpsertRolesDocument_, options);
      }
export type UpsertRolesMutationHookResult = ReturnType<typeof useUpsertRolesMutation>;
export type UpsertRolesMutationResult_ = Apollo.MutationResult<UpsertRolesMutation_>;
export type UpsertRolesMutationOptions_ = Apollo.BaseMutationOptions<UpsertRolesMutation_, UpsertRolesMutationVariables_>;
export const GetUserSecurityKeysDocument_ = gql`
    query getUserSecurityKeys($id: uuid!) {
  authUserSecurityKeys(where: {userId: {_eq: $id}}) {
    counter
    credentialId
    credentialPublicKey
    transports
    id
    user {
      id
    }
  }
}
    `;

/**
 * __useGetUserSecurityKeysQuery__
 *
 * To run a query within a React component, call `useGetUserSecurityKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSecurityKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSecurityKeysQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserSecurityKeysQuery(baseOptions: Apollo.QueryHookOptions<GetUserSecurityKeysQuery_, GetUserSecurityKeysQueryVariables_> & ({ variables: GetUserSecurityKeysQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserSecurityKeysQuery_, GetUserSecurityKeysQueryVariables_>(GetUserSecurityKeysDocument_, options);
      }
export function useGetUserSecurityKeysLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetUserSecurityKeysQuery_, GetUserSecurityKeysQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserSecurityKeysQuery_, GetUserSecurityKeysQueryVariables_>(GetUserSecurityKeysDocument_, options);
        }
export function useGetUserSecurityKeysSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserSecurityKeysQuery_, GetUserSecurityKeysQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserSecurityKeysQuery_, GetUserSecurityKeysQueryVariables_>(GetUserSecurityKeysDocument_, options);
        }
export type GetUserSecurityKeysQueryHookResult = ReturnType<typeof useGetUserSecurityKeysQuery>;
export type GetUserSecurityKeysLazyQuery_HookResult = ReturnType<typeof useGetUserSecurityKeysLazyQuery_>;
export type GetUserSecurityKeysSuspenseQuery_HookResult = ReturnType<typeof useGetUserSecurityKeysSuspenseQuery_>;
export type GetUserSecurityKeysQueryResult_ = Apollo.QueryResult<GetUserSecurityKeysQuery_, GetUserSecurityKeysQueryVariables_>;
export function refetchGetUserSecurityKeysQuery_(variables: GetUserSecurityKeysQueryVariables_) {
      return { query: GetUserSecurityKeysDocument_, variables: variables }
    }
export const GetUserChallengeDocument_ = gql`
    query getUserChallenge($id: uuid!) {
  user(id: $id) {
    id
    currentChallenge
  }
}
    `;

/**
 * __useGetUserChallengeQuery__
 *
 * To run a query within a React component, call `useGetUserChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserChallengeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserChallengeQuery(baseOptions: Apollo.QueryHookOptions<GetUserChallengeQuery_, GetUserChallengeQueryVariables_> & ({ variables: GetUserChallengeQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserChallengeQuery_, GetUserChallengeQueryVariables_>(GetUserChallengeDocument_, options);
      }
export function useGetUserChallengeLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetUserChallengeQuery_, GetUserChallengeQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserChallengeQuery_, GetUserChallengeQueryVariables_>(GetUserChallengeDocument_, options);
        }
export function useGetUserChallengeSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserChallengeQuery_, GetUserChallengeQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserChallengeQuery_, GetUserChallengeQueryVariables_>(GetUserChallengeDocument_, options);
        }
export type GetUserChallengeQueryHookResult = ReturnType<typeof useGetUserChallengeQuery>;
export type GetUserChallengeLazyQuery_HookResult = ReturnType<typeof useGetUserChallengeLazyQuery_>;
export type GetUserChallengeSuspenseQuery_HookResult = ReturnType<typeof useGetUserChallengeSuspenseQuery_>;
export type GetUserChallengeQueryResult_ = Apollo.QueryResult<GetUserChallengeQuery_, GetUserChallengeQueryVariables_>;
export function refetchGetUserChallengeQuery_(variables: GetUserChallengeQueryVariables_) {
      return { query: GetUserChallengeDocument_, variables: variables }
    }
export const UpdateUserChallengeDocument_ = gql`
    mutation updateUserChallenge($userId: uuid!, $challenge: String!) {
  updateUser(pk_columns: {id: $userId}, _set: {currentChallenge: $challenge}) {
    id
  }
}
    `;
export type UpdateUserChallengeMutationFn_ = Apollo.MutationFunction<UpdateUserChallengeMutation_, UpdateUserChallengeMutationVariables_>;

/**
 * __useUpdateUserChallengeMutation__
 *
 * To run a mutation, you first call `useUpdateUserChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserChallengeMutation, { data, loading, error }] = useUpdateUserChallengeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      challenge: // value for 'challenge'
 *   },
 * });
 */
export function useUpdateUserChallengeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserChallengeMutation_, UpdateUserChallengeMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserChallengeMutation_, UpdateUserChallengeMutationVariables_>(UpdateUserChallengeDocument_, options);
      }
export type UpdateUserChallengeMutationHookResult = ReturnType<typeof useUpdateUserChallengeMutation>;
export type UpdateUserChallengeMutationResult_ = Apollo.MutationResult<UpdateUserChallengeMutation_>;
export type UpdateUserChallengeMutationOptions_ = Apollo.BaseMutationOptions<UpdateUserChallengeMutation_, UpdateUserChallengeMutationVariables_>;
export const AddUserSecurityKeyDocument_ = gql`
    mutation addUserSecurityKey($userSecurityKey: authUserSecurityKeys_insert_input!) {
  insertAuthUserSecurityKey(object: $userSecurityKey) {
    id
  }
}
    `;
export type AddUserSecurityKeyMutationFn_ = Apollo.MutationFunction<AddUserSecurityKeyMutation_, AddUserSecurityKeyMutationVariables_>;

/**
 * __useAddUserSecurityKeyMutation__
 *
 * To run a mutation, you first call `useAddUserSecurityKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserSecurityKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserSecurityKeyMutation, { data, loading, error }] = useAddUserSecurityKeyMutation({
 *   variables: {
 *      userSecurityKey: // value for 'userSecurityKey'
 *   },
 * });
 */
export function useAddUserSecurityKeyMutation(baseOptions?: Apollo.MutationHookOptions<AddUserSecurityKeyMutation_, AddUserSecurityKeyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserSecurityKeyMutation_, AddUserSecurityKeyMutationVariables_>(AddUserSecurityKeyDocument_, options);
      }
export type AddUserSecurityKeyMutationHookResult = ReturnType<typeof useAddUserSecurityKeyMutation>;
export type AddUserSecurityKeyMutationResult_ = Apollo.MutationResult<AddUserSecurityKeyMutation_>;
export type AddUserSecurityKeyMutationOptions_ = Apollo.BaseMutationOptions<AddUserSecurityKeyMutation_, AddUserSecurityKeyMutationVariables_>;
export const UpdateUserSecurityKeyDocument_ = gql`
    mutation updateUserSecurityKey($id: uuid!, $counter: bigint!) {
  updateAuthUserSecurityKey(pk_columns: {id: $id}, _set: {counter: $counter}) {
    id
  }
}
    `;
export type UpdateUserSecurityKeyMutationFn_ = Apollo.MutationFunction<UpdateUserSecurityKeyMutation_, UpdateUserSecurityKeyMutationVariables_>;

/**
 * __useUpdateUserSecurityKeyMutation__
 *
 * To run a mutation, you first call `useUpdateUserSecurityKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSecurityKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSecurityKeyMutation, { data, loading, error }] = useUpdateUserSecurityKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      counter: // value for 'counter'
 *   },
 * });
 */
export function useUpdateUserSecurityKeyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSecurityKeyMutation_, UpdateUserSecurityKeyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSecurityKeyMutation_, UpdateUserSecurityKeyMutationVariables_>(UpdateUserSecurityKeyDocument_, options);
      }
export type UpdateUserSecurityKeyMutationHookResult = ReturnType<typeof useUpdateUserSecurityKeyMutation>;
export type UpdateUserSecurityKeyMutationResult_ = Apollo.MutationResult<UpdateUserSecurityKeyMutation_>;
export type UpdateUserSecurityKeyMutationOptions_ = Apollo.BaseMutationOptions<UpdateUserSecurityKeyMutation_, UpdateUserSecurityKeyMutationVariables_>;
export const AuthUserProvidersDocument_ = gql`
    query authUserProviders($provider: String!, $providerUserId: String!) {
  authUserProviders(
    where: {_and: {provider: {id: {_eq: $provider}}, providerUserId: {_eq: $providerUserId}}}
    limit: 1
  ) {
    id
    user {
      ...userFields
    }
  }
}
    ${UserFieldsFragmentDoc_}`;

/**
 * __useAuthUserProvidersQuery__
 *
 * To run a query within a React component, call `useAuthUserProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthUserProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthUserProvidersQuery({
 *   variables: {
 *      provider: // value for 'provider'
 *      providerUserId: // value for 'providerUserId'
 *   },
 * });
 */
export function useAuthUserProvidersQuery(baseOptions: Apollo.QueryHookOptions<AuthUserProvidersQuery_, AuthUserProvidersQueryVariables_> & ({ variables: AuthUserProvidersQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthUserProvidersQuery_, AuthUserProvidersQueryVariables_>(AuthUserProvidersDocument_, options);
      }
export function useAuthUserProvidersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AuthUserProvidersQuery_, AuthUserProvidersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthUserProvidersQuery_, AuthUserProvidersQueryVariables_>(AuthUserProvidersDocument_, options);
        }
export function useAuthUserProvidersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuthUserProvidersQuery_, AuthUserProvidersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuthUserProvidersQuery_, AuthUserProvidersQueryVariables_>(AuthUserProvidersDocument_, options);
        }
export type AuthUserProvidersQueryHookResult = ReturnType<typeof useAuthUserProvidersQuery>;
export type AuthUserProvidersLazyQuery_HookResult = ReturnType<typeof useAuthUserProvidersLazyQuery_>;
export type AuthUserProvidersSuspenseQuery_HookResult = ReturnType<typeof useAuthUserProvidersSuspenseQuery_>;
export type AuthUserProvidersQueryResult_ = Apollo.QueryResult<AuthUserProvidersQuery_, AuthUserProvidersQueryVariables_>;
export function refetchAuthUserProvidersQuery_(variables: AuthUserProvidersQueryVariables_) {
      return { query: AuthUserProvidersDocument_, variables: variables }
    }
export const UserProviderDocument_ = gql`
    query userProvider($userId: uuid!, $providerId: String!) {
  authUserProviders(
    where: {_and: [{userId: {_eq: $userId}}, {providerId: {_eq: $providerId}}]}
    limit: 1
  ) {
    id
    refreshToken
  }
}
    `;

/**
 * __useUserProviderQuery__
 *
 * To run a query within a React component, call `useUserProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProviderQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useUserProviderQuery(baseOptions: Apollo.QueryHookOptions<UserProviderQuery_, UserProviderQueryVariables_> & ({ variables: UserProviderQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProviderQuery_, UserProviderQueryVariables_>(UserProviderDocument_, options);
      }
export function useUserProviderLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<UserProviderQuery_, UserProviderQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProviderQuery_, UserProviderQueryVariables_>(UserProviderDocument_, options);
        }
export function useUserProviderSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserProviderQuery_, UserProviderQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserProviderQuery_, UserProviderQueryVariables_>(UserProviderDocument_, options);
        }
export type UserProviderQueryHookResult = ReturnType<typeof useUserProviderQuery>;
export type UserProviderLazyQuery_HookResult = ReturnType<typeof useUserProviderLazyQuery_>;
export type UserProviderSuspenseQuery_HookResult = ReturnType<typeof useUserProviderSuspenseQuery_>;
export type UserProviderQueryResult_ = Apollo.QueryResult<UserProviderQuery_, UserProviderQueryVariables_>;
export function refetchUserProviderQuery_(variables: UserProviderQueryVariables_) {
      return { query: UserProviderDocument_, variables: variables }
    }
export const UpdateAuthUserproviderDocument_ = gql`
    mutation updateAuthUserprovider($id: uuid!, $authUserProvider: authUserProviders_set_input!) {
  updateAuthUserProvider(pk_columns: {id: $id}, _set: $authUserProvider) {
    id
  }
}
    `;
export type UpdateAuthUserproviderMutationFn_ = Apollo.MutationFunction<UpdateAuthUserproviderMutation_, UpdateAuthUserproviderMutationVariables_>;

/**
 * __useUpdateAuthUserproviderMutation__
 *
 * To run a mutation, you first call `useUpdateAuthUserproviderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAuthUserproviderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAuthUserproviderMutation, { data, loading, error }] = useUpdateAuthUserproviderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      authUserProvider: // value for 'authUserProvider'
 *   },
 * });
 */
export function useUpdateAuthUserproviderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAuthUserproviderMutation_, UpdateAuthUserproviderMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAuthUserproviderMutation_, UpdateAuthUserproviderMutationVariables_>(UpdateAuthUserproviderDocument_, options);
      }
export type UpdateAuthUserproviderMutationHookResult = ReturnType<typeof useUpdateAuthUserproviderMutation>;
export type UpdateAuthUserproviderMutationResult_ = Apollo.MutationResult<UpdateAuthUserproviderMutation_>;
export type UpdateAuthUserproviderMutationOptions_ = Apollo.BaseMutationOptions<UpdateAuthUserproviderMutation_, UpdateAuthUserproviderMutationVariables_>;
export const InsertUserRolesDocument_ = gql`
    mutation insertUserRoles($userRoles: [authUserRoles_insert_input!]!) {
  insertAuthUserRoles(objects: $userRoles) {
    affected_rows
  }
}
    `;
export type InsertUserRolesMutationFn_ = Apollo.MutationFunction<InsertUserRolesMutation_, InsertUserRolesMutationVariables_>;

/**
 * __useInsertUserRolesMutation__
 *
 * To run a mutation, you first call `useInsertUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserRolesMutation, { data, loading, error }] = useInsertUserRolesMutation({
 *   variables: {
 *      userRoles: // value for 'userRoles'
 *   },
 * });
 */
export function useInsertUserRolesMutation(baseOptions?: Apollo.MutationHookOptions<InsertUserRolesMutation_, InsertUserRolesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUserRolesMutation_, InsertUserRolesMutationVariables_>(InsertUserRolesDocument_, options);
      }
export type InsertUserRolesMutationHookResult = ReturnType<typeof useInsertUserRolesMutation>;
export type InsertUserRolesMutationResult_ = Apollo.MutationResult<InsertUserRolesMutation_>;
export type InsertUserRolesMutationOptions_ = Apollo.BaseMutationOptions<InsertUserRolesMutation_, InsertUserRolesMutationVariables_>;
export const DeleteUserRolesByUserIdDocument_ = gql`
    mutation deleteUserRolesByUserId($userId: uuid!) {
  deleteAuthUserRoles(where: {userId: {_eq: $userId}}) {
    affected_rows
  }
}
    `;
export type DeleteUserRolesByUserIdMutationFn_ = Apollo.MutationFunction<DeleteUserRolesByUserIdMutation_, DeleteUserRolesByUserIdMutationVariables_>;

/**
 * __useDeleteUserRolesByUserIdMutation__
 *
 * To run a mutation, you first call `useDeleteUserRolesByUserIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserRolesByUserIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserRolesByUserIdMutation, { data, loading, error }] = useDeleteUserRolesByUserIdMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserRolesByUserIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserRolesByUserIdMutation_, DeleteUserRolesByUserIdMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserRolesByUserIdMutation_, DeleteUserRolesByUserIdMutationVariables_>(DeleteUserRolesByUserIdDocument_, options);
      }
export type DeleteUserRolesByUserIdMutationHookResult = ReturnType<typeof useDeleteUserRolesByUserIdMutation>;
export type DeleteUserRolesByUserIdMutationResult_ = Apollo.MutationResult<DeleteUserRolesByUserIdMutation_>;
export type DeleteUserRolesByUserIdMutationOptions_ = Apollo.BaseMutationOptions<DeleteUserRolesByUserIdMutation_, DeleteUserRolesByUserIdMutationVariables_>;
export const UserDocument_ = gql`
    query user($id: uuid!) {
  user(id: $id) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc_}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserQuery(baseOptions: Apollo.QueryHookOptions<UserQuery_, UserQueryVariables_> & ({ variables: UserQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery_, UserQueryVariables_>(UserDocument_, options);
      }
export function useUserLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery_, UserQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery_, UserQueryVariables_>(UserDocument_, options);
        }
export function useUserSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery_, UserQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery_, UserQueryVariables_>(UserDocument_, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQuery_HookResult = ReturnType<typeof useUserLazyQuery_>;
export type UserSuspenseQuery_HookResult = ReturnType<typeof useUserSuspenseQuery_>;
export type UserQueryResult_ = Apollo.QueryResult<UserQuery_, UserQueryVariables_>;
export function refetchUserQuery_(variables: UserQueryVariables_) {
      return { query: UserDocument_, variables: variables }
    }
export const UsersDocument_ = gql`
    query users($where: users_bool_exp!) {
  users(where: $where) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc_}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUsersQuery(baseOptions: Apollo.QueryHookOptions<UsersQuery_, UsersQueryVariables_> & ({ variables: UsersQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsersQuery_, UsersQueryVariables_>(UsersDocument_, options);
      }
export function useUsersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<UsersQuery_, UsersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsersQuery_, UsersQueryVariables_>(UsersDocument_, options);
        }
export function useUsersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsersQuery_, UsersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsersQuery_, UsersQueryVariables_>(UsersDocument_, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQuery_HookResult = ReturnType<typeof useUsersLazyQuery_>;
export type UsersSuspenseQuery_HookResult = ReturnType<typeof useUsersSuspenseQuery_>;
export type UsersQueryResult_ = Apollo.QueryResult<UsersQuery_, UsersQueryVariables_>;
export function refetchUsersQuery_(variables: UsersQueryVariables_) {
      return { query: UsersDocument_, variables: variables }
    }
export const GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtDocument_ = gql`
    mutation getUsersByRefreshTokenAndUpdateRefreshTokenExpiresAt($refreshTokenHash: String!, $expiresAt: timestamptz!) {
  updateAuthRefreshTokens(
    _set: {expiresAt: $expiresAt}
    where: {_and: [{refreshTokenHash: {_eq: $refreshTokenHash}}, {user: {disabled: {_eq: false}}}, {expiresAt: {_gte: now}}]}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutationFn_ = Apollo.MutationFunction<GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutation_, GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutationVariables_>;

/**
 * __useGetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutation__
 *
 * To run a mutation, you first call `useGetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutation, { data, loading, error }] = useGetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutation({
 *   variables: {
 *      refreshTokenHash: // value for 'refreshTokenHash'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useGetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutation(baseOptions?: Apollo.MutationHookOptions<GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutation_, GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutation_, GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutationVariables_>(GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtDocument_, options);
      }
export type GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutationHookResult = ReturnType<typeof useGetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutation>;
export type GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutationResult_ = Apollo.MutationResult<GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutation_>;
export type GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutationOptions_ = Apollo.BaseMutationOptions<GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutation_, GetUsersByRefreshTokenAndUpdateRefreshTokenExpiresAtMutationVariables_>;
export const GetUsersByRefreshTokenDocument_ = gql`
    query getUsersByRefreshToken($refreshTokenHash: String!) {
  authRefreshTokens(
    where: {_and: [{refreshTokenHash: {_eq: $refreshTokenHash}}, {user: {disabled: {_eq: false}}}, {expiresAt: {_gte: now}}]}
  ) {
    id
    user {
      ...userFields
    }
  }
}
    ${UserFieldsFragmentDoc_}`;

/**
 * __useGetUsersByRefreshTokenQuery__
 *
 * To run a query within a React component, call `useGetUsersByRefreshTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByRefreshTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByRefreshTokenQuery({
 *   variables: {
 *      refreshTokenHash: // value for 'refreshTokenHash'
 *   },
 * });
 */
export function useGetUsersByRefreshTokenQuery(baseOptions: Apollo.QueryHookOptions<GetUsersByRefreshTokenQuery_, GetUsersByRefreshTokenQueryVariables_> & ({ variables: GetUsersByRefreshTokenQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersByRefreshTokenQuery_, GetUsersByRefreshTokenQueryVariables_>(GetUsersByRefreshTokenDocument_, options);
      }
export function useGetUsersByRefreshTokenLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByRefreshTokenQuery_, GetUsersByRefreshTokenQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersByRefreshTokenQuery_, GetUsersByRefreshTokenQueryVariables_>(GetUsersByRefreshTokenDocument_, options);
        }
export function useGetUsersByRefreshTokenSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersByRefreshTokenQuery_, GetUsersByRefreshTokenQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersByRefreshTokenQuery_, GetUsersByRefreshTokenQueryVariables_>(GetUsersByRefreshTokenDocument_, options);
        }
export type GetUsersByRefreshTokenQueryHookResult = ReturnType<typeof useGetUsersByRefreshTokenQuery>;
export type GetUsersByRefreshTokenLazyQuery_HookResult = ReturnType<typeof useGetUsersByRefreshTokenLazyQuery_>;
export type GetUsersByRefreshTokenSuspenseQuery_HookResult = ReturnType<typeof useGetUsersByRefreshTokenSuspenseQuery_>;
export type GetUsersByRefreshTokenQueryResult_ = Apollo.QueryResult<GetUsersByRefreshTokenQuery_, GetUsersByRefreshTokenQueryVariables_>;
export function refetchGetUsersByRefreshTokenQuery_(variables: GetUsersByRefreshTokenQueryVariables_) {
      return { query: GetUsersByRefreshTokenDocument_, variables: variables }
    }
export const GetUsersByPatDocument_ = gql`
    query getUsersByPAT($patHash: String!) {
  authRefreshTokens(
    where: {_and: [{refreshTokenHash: {_eq: $patHash}}, {user: {disabled: {_eq: false}}}, {expiresAt: {_gte: now}}, {type: {_eq: pat}}]}
  ) {
    id
    user {
      ...userFields
    }
  }
}
    ${UserFieldsFragmentDoc_}`;

/**
 * __useGetUsersByPatQuery__
 *
 * To run a query within a React component, call `useGetUsersByPatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByPatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByPatQuery({
 *   variables: {
 *      patHash: // value for 'patHash'
 *   },
 * });
 */
export function useGetUsersByPatQuery(baseOptions: Apollo.QueryHookOptions<GetUsersByPatQuery_, GetUsersByPatQueryVariables_> & ({ variables: GetUsersByPatQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersByPatQuery_, GetUsersByPatQueryVariables_>(GetUsersByPatDocument_, options);
      }
export function useGetUsersByPatLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByPatQuery_, GetUsersByPatQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersByPatQuery_, GetUsersByPatQueryVariables_>(GetUsersByPatDocument_, options);
        }
export function useGetUsersByPatSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersByPatQuery_, GetUsersByPatQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersByPatQuery_, GetUsersByPatQueryVariables_>(GetUsersByPatDocument_, options);
        }
export type GetUsersByPatQueryHookResult = ReturnType<typeof useGetUsersByPatQuery>;
export type GetUsersByPatLazyQuery_HookResult = ReturnType<typeof useGetUsersByPatLazyQuery_>;
export type GetUsersByPatSuspenseQuery_HookResult = ReturnType<typeof useGetUsersByPatSuspenseQuery_>;
export type GetUsersByPatQueryResult_ = Apollo.QueryResult<GetUsersByPatQuery_, GetUsersByPatQueryVariables_>;
export function refetchGetUsersByPatQuery_(variables: GetUsersByPatQueryVariables_) {
      return { query: GetUsersByPatDocument_, variables: variables }
    }
export const UpdateUserDocument_ = gql`
    mutation updateUser($id: uuid!, $user: users_set_input!) {
  updateUser(pk_columns: {id: $id}, _set: $user) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc_}`;
export type UpdateUserMutationFn_ = Apollo.MutationFunction<UpdateUserMutation_, UpdateUserMutationVariables_>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation_, UpdateUserMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation_, UpdateUserMutationVariables_>(UpdateUserDocument_, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult_ = Apollo.MutationResult<UpdateUserMutation_>;
export type UpdateUserMutationOptions_ = Apollo.BaseMutationOptions<UpdateUserMutation_, UpdateUserMutationVariables_>;
export const UpdateUserWhereDocument_ = gql`
    mutation updateUserWhere($where: users_bool_exp!, $user: users_set_input!) {
  updateUsers(where: $where, _set: $user) {
    affected_rows
  }
}
    `;
export type UpdateUserWhereMutationFn_ = Apollo.MutationFunction<UpdateUserWhereMutation_, UpdateUserWhereMutationVariables_>;

/**
 * __useUpdateUserWhereMutation__
 *
 * To run a mutation, you first call `useUpdateUserWhereMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserWhereMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserWhereMutation, { data, loading, error }] = useUpdateUserWhereMutation({
 *   variables: {
 *      where: // value for 'where'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserWhereMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserWhereMutation_, UpdateUserWhereMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserWhereMutation_, UpdateUserWhereMutationVariables_>(UpdateUserWhereDocument_, options);
      }
export type UpdateUserWhereMutationHookResult = ReturnType<typeof useUpdateUserWhereMutation>;
export type UpdateUserWhereMutationResult_ = Apollo.MutationResult<UpdateUserWhereMutation_>;
export type UpdateUserWhereMutationOptions_ = Apollo.BaseMutationOptions<UpdateUserWhereMutation_, UpdateUserWhereMutationVariables_>;
export const RotateUsersTicketDocument_ = gql`
    mutation rotateUsersTicket($oldTicket: String!, $newTicket: String!, $newTicketExpiresAt: timestamptz!) {
  updateUsers(
    _set: {ticket: $newTicket, ticketExpiresAt: $newTicketExpiresAt}
    where: {ticket: {_eq: $oldTicket}}
  ) {
    affected_rows
  }
}
    `;
export type RotateUsersTicketMutationFn_ = Apollo.MutationFunction<RotateUsersTicketMutation_, RotateUsersTicketMutationVariables_>;

/**
 * __useRotateUsersTicketMutation__
 *
 * To run a mutation, you first call `useRotateUsersTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotateUsersTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotateUsersTicketMutation, { data, loading, error }] = useRotateUsersTicketMutation({
 *   variables: {
 *      oldTicket: // value for 'oldTicket'
 *      newTicket: // value for 'newTicket'
 *      newTicketExpiresAt: // value for 'newTicketExpiresAt'
 *   },
 * });
 */
export function useRotateUsersTicketMutation(baseOptions?: Apollo.MutationHookOptions<RotateUsersTicketMutation_, RotateUsersTicketMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RotateUsersTicketMutation_, RotateUsersTicketMutationVariables_>(RotateUsersTicketDocument_, options);
      }
export type RotateUsersTicketMutationHookResult = ReturnType<typeof useRotateUsersTicketMutation>;
export type RotateUsersTicketMutationResult_ = Apollo.MutationResult<RotateUsersTicketMutation_>;
export type RotateUsersTicketMutationOptions_ = Apollo.BaseMutationOptions<RotateUsersTicketMutation_, RotateUsersTicketMutationVariables_>;
export const ChangeEmailsByTicketDocument_ = gql`
    mutation changeEmailsByTicket($ticket: String!, $email: citext!, $newTicket: String!, $now: timestamptz!) {
  updateUsers(
    where: {_and: [{ticket: {_eq: $ticket}}, {ticketExpiresAt: {_gt: $now}}]}
    _set: {email: $email, newEmail: null, ticket: $newTicket, ticketExpiresAt: $now}
  ) {
    returning {
      ...userFields
    }
  }
}
    ${UserFieldsFragmentDoc_}`;
export type ChangeEmailsByTicketMutationFn_ = Apollo.MutationFunction<ChangeEmailsByTicketMutation_, ChangeEmailsByTicketMutationVariables_>;

/**
 * __useChangeEmailsByTicketMutation__
 *
 * To run a mutation, you first call `useChangeEmailsByTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailsByTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailsByTicketMutation, { data, loading, error }] = useChangeEmailsByTicketMutation({
 *   variables: {
 *      ticket: // value for 'ticket'
 *      email: // value for 'email'
 *      newTicket: // value for 'newTicket'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useChangeEmailsByTicketMutation(baseOptions?: Apollo.MutationHookOptions<ChangeEmailsByTicketMutation_, ChangeEmailsByTicketMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeEmailsByTicketMutation_, ChangeEmailsByTicketMutationVariables_>(ChangeEmailsByTicketDocument_, options);
      }
export type ChangeEmailsByTicketMutationHookResult = ReturnType<typeof useChangeEmailsByTicketMutation>;
export type ChangeEmailsByTicketMutationResult_ = Apollo.MutationResult<ChangeEmailsByTicketMutation_>;
export type ChangeEmailsByTicketMutationOptions_ = Apollo.BaseMutationOptions<ChangeEmailsByTicketMutation_, ChangeEmailsByTicketMutationVariables_>;
export const InsertUserDocument_ = gql`
    mutation insertUser($user: users_insert_input!) {
  insertUser(object: $user) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc_}`;
export type InsertUserMutationFn_ = Apollo.MutationFunction<InsertUserMutation_, InsertUserMutationVariables_>;

/**
 * __useInsertUserMutation__
 *
 * To run a mutation, you first call `useInsertUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserMutation, { data, loading, error }] = useInsertUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useInsertUserMutation(baseOptions?: Apollo.MutationHookOptions<InsertUserMutation_, InsertUserMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUserMutation_, InsertUserMutationVariables_>(InsertUserDocument_, options);
      }
export type InsertUserMutationHookResult = ReturnType<typeof useInsertUserMutation>;
export type InsertUserMutationResult_ = Apollo.MutationResult<InsertUserMutation_>;
export type InsertUserMutationOptions_ = Apollo.BaseMutationOptions<InsertUserMutation_, InsertUserMutationVariables_>;
export const DeleteUserDocument_ = gql`
    mutation deleteUser($userId: uuid!) {
  deleteAuthUserRoles(where: {userId: {_eq: $userId}}) {
    affected_rows
  }
  deleteUser(id: $userId) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc_}`;
export type DeleteUserMutationFn_ = Apollo.MutationFunction<DeleteUserMutation_, DeleteUserMutationVariables_>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation_, DeleteUserMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation_, DeleteUserMutationVariables_>(DeleteUserDocument_, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult_ = Apollo.MutationResult<DeleteUserMutation_>;
export type DeleteUserMutationOptions_ = Apollo.BaseMutationOptions<DeleteUserMutation_, DeleteUserMutationVariables_>;
export const DeanonymizeUserDocument_ = gql`
    mutation deanonymizeUser($userId: uuid!, $avatarUrl: String, $role: String!) {
  updateAuthUserRoles(where: {user: {id: {_eq: $userId}}}, _set: {role: $role}) {
    affected_rows
  }
  updateUser(
    pk_columns: {id: $userId}
    _set: {avatarUrl: $avatarUrl, defaultRole: $role}
  ) {
    id
  }
}
    `;
export type DeanonymizeUserMutationFn_ = Apollo.MutationFunction<DeanonymizeUserMutation_, DeanonymizeUserMutationVariables_>;

/**
 * __useDeanonymizeUserMutation__
 *
 * To run a mutation, you first call `useDeanonymizeUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeanonymizeUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deanonymizeUserMutation, { data, loading, error }] = useDeanonymizeUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      avatarUrl: // value for 'avatarUrl'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useDeanonymizeUserMutation(baseOptions?: Apollo.MutationHookOptions<DeanonymizeUserMutation_, DeanonymizeUserMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeanonymizeUserMutation_, DeanonymizeUserMutationVariables_>(DeanonymizeUserDocument_, options);
      }
export type DeanonymizeUserMutationHookResult = ReturnType<typeof useDeanonymizeUserMutation>;
export type DeanonymizeUserMutationResult_ = Apollo.MutationResult<DeanonymizeUserMutation_>;
export type DeanonymizeUserMutationOptions_ = Apollo.BaseMutationOptions<DeanonymizeUserMutation_, DeanonymizeUserMutationVariables_>;
export const InsertUserProviderToUserDocument_ = gql`
    mutation insertUserProviderToUser($userProvider: authUserProviders_insert_input!) {
  insertAuthUserProvider(object: $userProvider) {
    id
  }
}
    `;
export type InsertUserProviderToUserMutationFn_ = Apollo.MutationFunction<InsertUserProviderToUserMutation_, InsertUserProviderToUserMutationVariables_>;

/**
 * __useInsertUserProviderToUserMutation__
 *
 * To run a mutation, you first call `useInsertUserProviderToUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserProviderToUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserProviderToUserMutation, { data, loading, error }] = useInsertUserProviderToUserMutation({
 *   variables: {
 *      userProvider: // value for 'userProvider'
 *   },
 * });
 */
export function useInsertUserProviderToUserMutation(baseOptions?: Apollo.MutationHookOptions<InsertUserProviderToUserMutation_, InsertUserProviderToUserMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUserProviderToUserMutation_, InsertUserProviderToUserMutationVariables_>(InsertUserProviderToUserDocument_, options);
      }
export type InsertUserProviderToUserMutationHookResult = ReturnType<typeof useInsertUserProviderToUserMutation>;
export type InsertUserProviderToUserMutationResult_ = Apollo.MutationResult<InsertUserProviderToUserMutation_>;
export type InsertUserProviderToUserMutationOptions_ = Apollo.BaseMutationOptions<InsertUserProviderToUserMutation_, InsertUserProviderToUserMutationVariables_>;
export const GetUserByTicketDocument_ = gql`
    query getUserByTicket($ticket: String!) {
  users(where: {ticket: {_eq: $ticket}}) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc_}`;

/**
 * __useGetUserByTicketQuery__
 *
 * To run a query within a React component, call `useGetUserByTicketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByTicketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByTicketQuery({
 *   variables: {
 *      ticket: // value for 'ticket'
 *   },
 * });
 */
export function useGetUserByTicketQuery(baseOptions: Apollo.QueryHookOptions<GetUserByTicketQuery_, GetUserByTicketQueryVariables_> & ({ variables: GetUserByTicketQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByTicketQuery_, GetUserByTicketQueryVariables_>(GetUserByTicketDocument_, options);
      }
export function useGetUserByTicketLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByTicketQuery_, GetUserByTicketQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByTicketQuery_, GetUserByTicketQueryVariables_>(GetUserByTicketDocument_, options);
        }
export function useGetUserByTicketSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserByTicketQuery_, GetUserByTicketQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserByTicketQuery_, GetUserByTicketQueryVariables_>(GetUserByTicketDocument_, options);
        }
export type GetUserByTicketQueryHookResult = ReturnType<typeof useGetUserByTicketQuery>;
export type GetUserByTicketLazyQuery_HookResult = ReturnType<typeof useGetUserByTicketLazyQuery_>;
export type GetUserByTicketSuspenseQuery_HookResult = ReturnType<typeof useGetUserByTicketSuspenseQuery_>;
export type GetUserByTicketQueryResult_ = Apollo.QueryResult<GetUserByTicketQuery_, GetUserByTicketQueryVariables_>;
export function refetchGetUserByTicketQuery_(variables: GetUserByTicketQueryVariables_) {
      return { query: GetUserByTicketDocument_, variables: variables }
    }
export const UpdateUsersByTicketDocument_ = gql`
    mutation updateUsersByTicket($ticket: String!, $user: users_set_input!) {
  updateUsers(
    where: {_and: [{ticket: {_eq: $ticket}}, {ticketExpiresAt: {_gt: now}}]}
    _set: $user
  ) {
    affected_rows
    returning {
      ...userFields
    }
  }
}
    ${UserFieldsFragmentDoc_}`;
export type UpdateUsersByTicketMutationFn_ = Apollo.MutationFunction<UpdateUsersByTicketMutation_, UpdateUsersByTicketMutationVariables_>;

/**
 * __useUpdateUsersByTicketMutation__
 *
 * To run a mutation, you first call `useUpdateUsersByTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUsersByTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUsersByTicketMutation, { data, loading, error }] = useUpdateUsersByTicketMutation({
 *   variables: {
 *      ticket: // value for 'ticket'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUsersByTicketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUsersByTicketMutation_, UpdateUsersByTicketMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUsersByTicketMutation_, UpdateUsersByTicketMutationVariables_>(UpdateUsersByTicketDocument_, options);
      }
export type UpdateUsersByTicketMutationHookResult = ReturnType<typeof useUpdateUsersByTicketMutation>;
export type UpdateUsersByTicketMutationResult_ = Apollo.MutationResult<UpdateUsersByTicketMutation_>;
export type UpdateUsersByTicketMutationOptions_ = Apollo.BaseMutationOptions<UpdateUsersByTicketMutation_, UpdateUsersByTicketMutationVariables_>;
export const GetBucketDocument_ = gql`
    query GetBucket($id: String!) {
  bucket(id: $id) {
    ...BucketMetadataFragment
  }
}
    ${BucketMetadataFragmentFragmentDoc_}`;

/**
 * __useGetBucketQuery__
 *
 * To run a query within a React component, call `useGetBucketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBucketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBucketQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBucketQuery(baseOptions: Apollo.QueryHookOptions<GetBucketQuery_, GetBucketQueryVariables_> & ({ variables: GetBucketQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBucketQuery_, GetBucketQueryVariables_>(GetBucketDocument_, options);
      }
export function useGetBucketLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetBucketQuery_, GetBucketQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBucketQuery_, GetBucketQueryVariables_>(GetBucketDocument_, options);
        }
export function useGetBucketSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBucketQuery_, GetBucketQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBucketQuery_, GetBucketQueryVariables_>(GetBucketDocument_, options);
        }
export type GetBucketQueryHookResult = ReturnType<typeof useGetBucketQuery>;
export type GetBucketLazyQuery_HookResult = ReturnType<typeof useGetBucketLazyQuery_>;
export type GetBucketSuspenseQuery_HookResult = ReturnType<typeof useGetBucketSuspenseQuery_>;
export type GetBucketQueryResult_ = Apollo.QueryResult<GetBucketQuery_, GetBucketQueryVariables_>;
export function refetchGetBucketQuery_(variables: GetBucketQueryVariables_) {
      return { query: GetBucketDocument_, variables: variables }
    }
export const GetFileDocument_ = gql`
    query GetFile($id: uuid!) {
  file(id: $id) {
    ...FileMetadataFragment
  }
}
    ${FileMetadataFragmentFragmentDoc_}`;

/**
 * __useGetFileQuery__
 *
 * To run a query within a React component, call `useGetFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFileQuery(baseOptions: Apollo.QueryHookOptions<GetFileQuery_, GetFileQueryVariables_> & ({ variables: GetFileQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFileQuery_, GetFileQueryVariables_>(GetFileDocument_, options);
      }
export function useGetFileLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetFileQuery_, GetFileQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFileQuery_, GetFileQueryVariables_>(GetFileDocument_, options);
        }
export function useGetFileSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFileQuery_, GetFileQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFileQuery_, GetFileQueryVariables_>(GetFileDocument_, options);
        }
export type GetFileQueryHookResult = ReturnType<typeof useGetFileQuery>;
export type GetFileLazyQuery_HookResult = ReturnType<typeof useGetFileLazyQuery_>;
export type GetFileSuspenseQuery_HookResult = ReturnType<typeof useGetFileSuspenseQuery_>;
export type GetFileQueryResult_ = Apollo.QueryResult<GetFileQuery_, GetFileQueryVariables_>;
export function refetchGetFileQuery_(variables: GetFileQueryVariables_) {
      return { query: GetFileDocument_, variables: variables }
    }
export const ListFilesSummaryDocument_ = gql`
    query ListFilesSummary {
  files {
    ...FileMetadataSummaryFragment
  }
}
    ${FileMetadataSummaryFragmentFragmentDoc_}`;

/**
 * __useListFilesSummaryQuery__
 *
 * To run a query within a React component, call `useListFilesSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFilesSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFilesSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useListFilesSummaryQuery(baseOptions?: Apollo.QueryHookOptions<ListFilesSummaryQuery_, ListFilesSummaryQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFilesSummaryQuery_, ListFilesSummaryQueryVariables_>(ListFilesSummaryDocument_, options);
      }
export function useListFilesSummaryLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ListFilesSummaryQuery_, ListFilesSummaryQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFilesSummaryQuery_, ListFilesSummaryQueryVariables_>(ListFilesSummaryDocument_, options);
        }
export function useListFilesSummarySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListFilesSummaryQuery_, ListFilesSummaryQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListFilesSummaryQuery_, ListFilesSummaryQueryVariables_>(ListFilesSummaryDocument_, options);
        }
export type ListFilesSummaryQueryHookResult = ReturnType<typeof useListFilesSummaryQuery>;
export type ListFilesSummaryLazyQuery_HookResult = ReturnType<typeof useListFilesSummaryLazyQuery_>;
export type ListFilesSummarySuspenseQuery_HookResult = ReturnType<typeof useListFilesSummarySuspenseQuery_>;
export type ListFilesSummaryQueryResult_ = Apollo.QueryResult<ListFilesSummaryQuery_, ListFilesSummaryQueryVariables_>;
export function refetchListFilesSummaryQuery_(variables?: ListFilesSummaryQueryVariables_) {
      return { query: ListFilesSummaryDocument_, variables: variables }
    }
export const InsertFileDocument_ = gql`
    mutation InsertFile($object: files_insert_input!) {
  insertFile(object: $object) {
    id
  }
}
    `;
export type InsertFileMutationFn_ = Apollo.MutationFunction<InsertFileMutation_, InsertFileMutationVariables_>;

/**
 * __useInsertFileMutation__
 *
 * To run a mutation, you first call `useInsertFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertFileMutation, { data, loading, error }] = useInsertFileMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertFileMutation(baseOptions?: Apollo.MutationHookOptions<InsertFileMutation_, InsertFileMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertFileMutation_, InsertFileMutationVariables_>(InsertFileDocument_, options);
      }
export type InsertFileMutationHookResult = ReturnType<typeof useInsertFileMutation>;
export type InsertFileMutationResult_ = Apollo.MutationResult<InsertFileMutation_>;
export type InsertFileMutationOptions_ = Apollo.BaseMutationOptions<InsertFileMutation_, InsertFileMutationVariables_>;
export const UpdateFileDocument_ = gql`
    mutation UpdateFile($id: uuid!, $_set: files_set_input!) {
  updateFile(pk_columns: {id: $id}, _set: $_set) {
    ...FileMetadataFragment
  }
}
    ${FileMetadataFragmentFragmentDoc_}`;
export type UpdateFileMutationFn_ = Apollo.MutationFunction<UpdateFileMutation_, UpdateFileMutationVariables_>;

/**
 * __useUpdateFileMutation__
 *
 * To run a mutation, you first call `useUpdateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFileMutation, { data, loading, error }] = useUpdateFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateFileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFileMutation_, UpdateFileMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFileMutation_, UpdateFileMutationVariables_>(UpdateFileDocument_, options);
      }
export type UpdateFileMutationHookResult = ReturnType<typeof useUpdateFileMutation>;
export type UpdateFileMutationResult_ = Apollo.MutationResult<UpdateFileMutation_>;
export type UpdateFileMutationOptions_ = Apollo.BaseMutationOptions<UpdateFileMutation_, UpdateFileMutationVariables_>;
export const DeleteFileDocument_ = gql`
    mutation DeleteFile($id: uuid!) {
  deleteFile(id: $id) {
    id
  }
}
    `;
export type DeleteFileMutationFn_ = Apollo.MutationFunction<DeleteFileMutation_, DeleteFileMutationVariables_>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation_, DeleteFileMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation_, DeleteFileMutationVariables_>(DeleteFileDocument_, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult_ = Apollo.MutationResult<DeleteFileMutation_>;
export type DeleteFileMutationOptions_ = Apollo.BaseMutationOptions<DeleteFileMutation_, DeleteFileMutationVariables_>;
export const InsertVirusDocument_ = gql`
    mutation InsertVirus($object: virus_insert_input!) {
  insertVirus(object: $object) {
    id
  }
}
    `;
export type InsertVirusMutationFn_ = Apollo.MutationFunction<InsertVirusMutation_, InsertVirusMutationVariables_>;

/**
 * __useInsertVirusMutation__
 *
 * To run a mutation, you first call `useInsertVirusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertVirusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertVirusMutation, { data, loading, error }] = useInsertVirusMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertVirusMutation(baseOptions?: Apollo.MutationHookOptions<InsertVirusMutation_, InsertVirusMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertVirusMutation_, InsertVirusMutationVariables_>(InsertVirusDocument_, options);
      }
export type InsertVirusMutationHookResult = ReturnType<typeof useInsertVirusMutation>;
export type InsertVirusMutationResult_ = Apollo.MutationResult<InsertVirusMutation_>;
export type InsertVirusMutationOptions_ = Apollo.BaseMutationOptions<InsertVirusMutation_, InsertVirusMutationVariables_>;
export const RemoteAppDeleteUserDocument_ = gql`
    mutation remoteAppDeleteUser($id: uuid!) {
  deleteUser(id: $id) {
    id
  }
}
    `;
export type RemoteAppDeleteUserMutationFn_ = Apollo.MutationFunction<RemoteAppDeleteUserMutation_, RemoteAppDeleteUserMutationVariables_>;

/**
 * __useRemoteAppDeleteUserMutation__
 *
 * To run a mutation, you first call `useRemoteAppDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoteAppDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remoteAppDeleteUserMutation, { data, loading, error }] = useRemoteAppDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoteAppDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoteAppDeleteUserMutation_, RemoteAppDeleteUserMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoteAppDeleteUserMutation_, RemoteAppDeleteUserMutationVariables_>(RemoteAppDeleteUserDocument_, options);
      }
export type RemoteAppDeleteUserMutationHookResult = ReturnType<typeof useRemoteAppDeleteUserMutation>;
export type RemoteAppDeleteUserMutationResult_ = Apollo.MutationResult<RemoteAppDeleteUserMutation_>;
export type RemoteAppDeleteUserMutationOptions_ = Apollo.BaseMutationOptions<RemoteAppDeleteUserMutation_, RemoteAppDeleteUserMutationVariables_>;
export const GetRemoteAppMetricsDocument_ = gql`
    query getRemoteAppMetrics {
  filesAggregate {
    aggregate {
      count
      sum {
        size
      }
    }
  }
  usersAggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useGetRemoteAppMetricsQuery__
 *
 * To run a query within a React component, call `useGetRemoteAppMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRemoteAppMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRemoteAppMetricsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRemoteAppMetricsQuery(baseOptions?: Apollo.QueryHookOptions<GetRemoteAppMetricsQuery_, GetRemoteAppMetricsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRemoteAppMetricsQuery_, GetRemoteAppMetricsQueryVariables_>(GetRemoteAppMetricsDocument_, options);
      }
export function useGetRemoteAppMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetRemoteAppMetricsQuery_, GetRemoteAppMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRemoteAppMetricsQuery_, GetRemoteAppMetricsQueryVariables_>(GetRemoteAppMetricsDocument_, options);
        }
export function useGetRemoteAppMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRemoteAppMetricsQuery_, GetRemoteAppMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRemoteAppMetricsQuery_, GetRemoteAppMetricsQueryVariables_>(GetRemoteAppMetricsDocument_, options);
        }
export type GetRemoteAppMetricsQueryHookResult = ReturnType<typeof useGetRemoteAppMetricsQuery>;
export type GetRemoteAppMetricsLazyQuery_HookResult = ReturnType<typeof useGetRemoteAppMetricsLazyQuery_>;
export type GetRemoteAppMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetRemoteAppMetricsSuspenseQuery_>;
export type GetRemoteAppMetricsQueryResult_ = Apollo.QueryResult<GetRemoteAppMetricsQuery_, GetRemoteAppMetricsQueryVariables_>;
export function refetchGetRemoteAppMetricsQuery_(variables?: GetRemoteAppMetricsQueryVariables_) {
      return { query: GetRemoteAppMetricsDocument_, variables: variables }
    }
export const RemoteAppGetUsersDocument_ = gql`
    query remoteAppGetUsers($where: users_bool_exp!, $limit: Int!, $offset: Int!) {
  users(
    where: $where
    limit: $limit
    offset: $offset
    order_by: {createdAt: desc}
  ) {
    ...RemoteAppGetUsers
  }
  filteredUsersAggreggate: usersAggregate(where: $where) {
    aggregate {
      count
    }
  }
  usersAggregate {
    aggregate {
      count
    }
  }
}
    ${RemoteAppGetUsersFragmentDoc_}`;

/**
 * __useRemoteAppGetUsersQuery__
 *
 * To run a query within a React component, call `useRemoteAppGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemoteAppGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemoteAppGetUsersQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useRemoteAppGetUsersQuery(baseOptions: Apollo.QueryHookOptions<RemoteAppGetUsersQuery_, RemoteAppGetUsersQueryVariables_> & ({ variables: RemoteAppGetUsersQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemoteAppGetUsersQuery_, RemoteAppGetUsersQueryVariables_>(RemoteAppGetUsersDocument_, options);
      }
export function useRemoteAppGetUsersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<RemoteAppGetUsersQuery_, RemoteAppGetUsersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemoteAppGetUsersQuery_, RemoteAppGetUsersQueryVariables_>(RemoteAppGetUsersDocument_, options);
        }
export function useRemoteAppGetUsersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RemoteAppGetUsersQuery_, RemoteAppGetUsersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RemoteAppGetUsersQuery_, RemoteAppGetUsersQueryVariables_>(RemoteAppGetUsersDocument_, options);
        }
export type RemoteAppGetUsersQueryHookResult = ReturnType<typeof useRemoteAppGetUsersQuery>;
export type RemoteAppGetUsersLazyQuery_HookResult = ReturnType<typeof useRemoteAppGetUsersLazyQuery_>;
export type RemoteAppGetUsersSuspenseQuery_HookResult = ReturnType<typeof useRemoteAppGetUsersSuspenseQuery_>;
export type RemoteAppGetUsersQueryResult_ = Apollo.QueryResult<RemoteAppGetUsersQuery_, RemoteAppGetUsersQueryVariables_>;
export function refetchRemoteAppGetUsersQuery_(variables: RemoteAppGetUsersQueryVariables_) {
      return { query: RemoteAppGetUsersDocument_, variables: variables }
    }
export const RemoteAppGetUsersCustomDocument_ = gql`
    query remoteAppGetUsersCustom($where: users_bool_exp!, $limit: Int!, $offset: Int!) {
  users(
    where: $where
    limit: $limit
    offset: $offset
    order_by: {createdAt: desc}
  ) {
    id
    createdAt
    displayName
    phoneNumber
    avatarUrl
    email
    disabled
    defaultRole
    roles(order_by: {role: asc}) {
      role
    }
    isAnonymous
  }
}
    `;

/**
 * __useRemoteAppGetUsersCustomQuery__
 *
 * To run a query within a React component, call `useRemoteAppGetUsersCustomQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemoteAppGetUsersCustomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemoteAppGetUsersCustomQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useRemoteAppGetUsersCustomQuery(baseOptions: Apollo.QueryHookOptions<RemoteAppGetUsersCustomQuery_, RemoteAppGetUsersCustomQueryVariables_> & ({ variables: RemoteAppGetUsersCustomQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemoteAppGetUsersCustomQuery_, RemoteAppGetUsersCustomQueryVariables_>(RemoteAppGetUsersCustomDocument_, options);
      }
export function useRemoteAppGetUsersCustomLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<RemoteAppGetUsersCustomQuery_, RemoteAppGetUsersCustomQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemoteAppGetUsersCustomQuery_, RemoteAppGetUsersCustomQueryVariables_>(RemoteAppGetUsersCustomDocument_, options);
        }
export function useRemoteAppGetUsersCustomSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RemoteAppGetUsersCustomQuery_, RemoteAppGetUsersCustomQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RemoteAppGetUsersCustomQuery_, RemoteAppGetUsersCustomQueryVariables_>(RemoteAppGetUsersCustomDocument_, options);
        }
export type RemoteAppGetUsersCustomQueryHookResult = ReturnType<typeof useRemoteAppGetUsersCustomQuery>;
export type RemoteAppGetUsersCustomLazyQuery_HookResult = ReturnType<typeof useRemoteAppGetUsersCustomLazyQuery_>;
export type RemoteAppGetUsersCustomSuspenseQuery_HookResult = ReturnType<typeof useRemoteAppGetUsersCustomSuspenseQuery_>;
export type RemoteAppGetUsersCustomQueryResult_ = Apollo.QueryResult<RemoteAppGetUsersCustomQuery_, RemoteAppGetUsersCustomQueryVariables_>;
export function refetchRemoteAppGetUsersCustomQuery_(variables: RemoteAppGetUsersCustomQueryVariables_) {
      return { query: RemoteAppGetUsersCustomDocument_, variables: variables }
    }
export const RemoteAppGetUsersWholeDocument_ = gql`
    query remoteAppGetUsersWhole($limit: Int!, $offset: Int!) {
  users(limit: $limit, offset: $offset) {
    ...RemoteAppGetUsers
  }
  usersAggregate {
    aggregate {
      count
    }
  }
}
    ${RemoteAppGetUsersFragmentDoc_}`;

/**
 * __useRemoteAppGetUsersWholeQuery__
 *
 * To run a query within a React component, call `useRemoteAppGetUsersWholeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemoteAppGetUsersWholeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemoteAppGetUsersWholeQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useRemoteAppGetUsersWholeQuery(baseOptions: Apollo.QueryHookOptions<RemoteAppGetUsersWholeQuery_, RemoteAppGetUsersWholeQueryVariables_> & ({ variables: RemoteAppGetUsersWholeQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemoteAppGetUsersWholeQuery_, RemoteAppGetUsersWholeQueryVariables_>(RemoteAppGetUsersWholeDocument_, options);
      }
export function useRemoteAppGetUsersWholeLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<RemoteAppGetUsersWholeQuery_, RemoteAppGetUsersWholeQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemoteAppGetUsersWholeQuery_, RemoteAppGetUsersWholeQueryVariables_>(RemoteAppGetUsersWholeDocument_, options);
        }
export function useRemoteAppGetUsersWholeSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RemoteAppGetUsersWholeQuery_, RemoteAppGetUsersWholeQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RemoteAppGetUsersWholeQuery_, RemoteAppGetUsersWholeQueryVariables_>(RemoteAppGetUsersWholeDocument_, options);
        }
export type RemoteAppGetUsersWholeQueryHookResult = ReturnType<typeof useRemoteAppGetUsersWholeQuery>;
export type RemoteAppGetUsersWholeLazyQuery_HookResult = ReturnType<typeof useRemoteAppGetUsersWholeLazyQuery_>;
export type RemoteAppGetUsersWholeSuspenseQuery_HookResult = ReturnType<typeof useRemoteAppGetUsersWholeSuspenseQuery_>;
export type RemoteAppGetUsersWholeQueryResult_ = Apollo.QueryResult<RemoteAppGetUsersWholeQuery_, RemoteAppGetUsersWholeQueryVariables_>;
export function refetchRemoteAppGetUsersWholeQuery_(variables: RemoteAppGetUsersWholeQueryVariables_) {
      return { query: RemoteAppGetUsersWholeDocument_, variables: variables }
    }
export const TotalUsersDocument_ = gql`
    query totalUsers {
  usersAggregate {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useTotalUsersQuery__
 *
 * To run a query within a React component, call `useTotalUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useTotalUsersQuery(baseOptions?: Apollo.QueryHookOptions<TotalUsersQuery_, TotalUsersQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotalUsersQuery_, TotalUsersQueryVariables_>(TotalUsersDocument_, options);
      }
export function useTotalUsersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<TotalUsersQuery_, TotalUsersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotalUsersQuery_, TotalUsersQueryVariables_>(TotalUsersDocument_, options);
        }
export function useTotalUsersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TotalUsersQuery_, TotalUsersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TotalUsersQuery_, TotalUsersQueryVariables_>(TotalUsersDocument_, options);
        }
export type TotalUsersQueryHookResult = ReturnType<typeof useTotalUsersQuery>;
export type TotalUsersLazyQuery_HookResult = ReturnType<typeof useTotalUsersLazyQuery_>;
export type TotalUsersSuspenseQuery_HookResult = ReturnType<typeof useTotalUsersSuspenseQuery_>;
export type TotalUsersQueryResult_ = Apollo.QueryResult<TotalUsersQuery_, TotalUsersQueryVariables_>;
export function refetchTotalUsersQuery_(variables?: TotalUsersQueryVariables_) {
      return { query: TotalUsersDocument_, variables: variables }
    }
export const TotalUsersByDateDocument_ = gql`
    query totalUsersByDate($where: users_bool_exp!) {
  usersAggregate(where: $where) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useTotalUsersByDateQuery__
 *
 * To run a query within a React component, call `useTotalUsersByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useTotalUsersByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTotalUsersByDateQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useTotalUsersByDateQuery(baseOptions: Apollo.QueryHookOptions<TotalUsersByDateQuery_, TotalUsersByDateQueryVariables_> & ({ variables: TotalUsersByDateQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TotalUsersByDateQuery_, TotalUsersByDateQueryVariables_>(TotalUsersByDateDocument_, options);
      }
export function useTotalUsersByDateLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<TotalUsersByDateQuery_, TotalUsersByDateQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TotalUsersByDateQuery_, TotalUsersByDateQueryVariables_>(TotalUsersByDateDocument_, options);
        }
export function useTotalUsersByDateSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TotalUsersByDateQuery_, TotalUsersByDateQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TotalUsersByDateQuery_, TotalUsersByDateQueryVariables_>(TotalUsersByDateDocument_, options);
        }
export type TotalUsersByDateQueryHookResult = ReturnType<typeof useTotalUsersByDateQuery>;
export type TotalUsersByDateLazyQuery_HookResult = ReturnType<typeof useTotalUsersByDateLazyQuery_>;
export type TotalUsersByDateSuspenseQuery_HookResult = ReturnType<typeof useTotalUsersByDateSuspenseQuery_>;
export type TotalUsersByDateQueryResult_ = Apollo.QueryResult<TotalUsersByDateQuery_, TotalUsersByDateQueryVariables_>;
export function refetchTotalUsersByDateQuery_(variables: TotalUsersByDateQueryVariables_) {
      return { query: TotalUsersByDateDocument_, variables: variables }
    }
export const UpdateRemoteAppUserDocument_ = gql`
    mutation updateRemoteAppUser($id: uuid!, $user: users_set_input!) {
  updateUser(pk_columns: {id: $id}, _set: $user) {
    id
  }
}
    `;
export type UpdateRemoteAppUserMutationFn_ = Apollo.MutationFunction<UpdateRemoteAppUserMutation_, UpdateRemoteAppUserMutationVariables_>;

/**
 * __useUpdateRemoteAppUserMutation__
 *
 * To run a mutation, you first call `useUpdateRemoteAppUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRemoteAppUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRemoteAppUserMutation, { data, loading, error }] = useUpdateRemoteAppUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateRemoteAppUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRemoteAppUserMutation_, UpdateRemoteAppUserMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRemoteAppUserMutation_, UpdateRemoteAppUserMutationVariables_>(UpdateRemoteAppUserDocument_, options);
      }
export type UpdateRemoteAppUserMutationHookResult = ReturnType<typeof useUpdateRemoteAppUserMutation>;
export type UpdateRemoteAppUserMutationResult_ = Apollo.MutationResult<UpdateRemoteAppUserMutation_>;
export type UpdateRemoteAppUserMutationOptions_ = Apollo.BaseMutationOptions<UpdateRemoteAppUserMutation_, UpdateRemoteAppUserMutationVariables_>;
export const InsertRemoteAppUserRolesDocument_ = gql`
    mutation insertRemoteAppUserRoles($roles: [authUserRoles_insert_input!]!) {
  insertAuthUserRoles(objects: $roles) {
    affected_rows
  }
}
    `;
export type InsertRemoteAppUserRolesMutationFn_ = Apollo.MutationFunction<InsertRemoteAppUserRolesMutation_, InsertRemoteAppUserRolesMutationVariables_>;

/**
 * __useInsertRemoteAppUserRolesMutation__
 *
 * To run a mutation, you first call `useInsertRemoteAppUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertRemoteAppUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertRemoteAppUserRolesMutation, { data, loading, error }] = useInsertRemoteAppUserRolesMutation({
 *   variables: {
 *      roles: // value for 'roles'
 *   },
 * });
 */
export function useInsertRemoteAppUserRolesMutation(baseOptions?: Apollo.MutationHookOptions<InsertRemoteAppUserRolesMutation_, InsertRemoteAppUserRolesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertRemoteAppUserRolesMutation_, InsertRemoteAppUserRolesMutationVariables_>(InsertRemoteAppUserRolesDocument_, options);
      }
export type InsertRemoteAppUserRolesMutationHookResult = ReturnType<typeof useInsertRemoteAppUserRolesMutation>;
export type InsertRemoteAppUserRolesMutationResult_ = Apollo.MutationResult<InsertRemoteAppUserRolesMutation_>;
export type InsertRemoteAppUserRolesMutationOptions_ = Apollo.BaseMutationOptions<InsertRemoteAppUserRolesMutation_, InsertRemoteAppUserRolesMutationVariables_>;
export const DeleteRemoteAppUserRolesDocument_ = gql`
    mutation deleteRemoteAppUserRoles($userId: uuid!, $roles: [String!]!) {
  deleteAuthUserRoles(
    where: {_and: [{userId: {_eq: $userId}}, {role: {_in: $roles}}]}
  ) {
    affected_rows
  }
}
    `;
export type DeleteRemoteAppUserRolesMutationFn_ = Apollo.MutationFunction<DeleteRemoteAppUserRolesMutation_, DeleteRemoteAppUserRolesMutationVariables_>;

/**
 * __useDeleteRemoteAppUserRolesMutation__
 *
 * To run a mutation, you first call `useDeleteRemoteAppUserRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRemoteAppUserRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRemoteAppUserRolesMutation, { data, loading, error }] = useDeleteRemoteAppUserRolesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      roles: // value for 'roles'
 *   },
 * });
 */
export function useDeleteRemoteAppUserRolesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRemoteAppUserRolesMutation_, DeleteRemoteAppUserRolesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRemoteAppUserRolesMutation_, DeleteRemoteAppUserRolesMutationVariables_>(DeleteRemoteAppUserRolesDocument_, options);
      }
export type DeleteRemoteAppUserRolesMutationHookResult = ReturnType<typeof useDeleteRemoteAppUserRolesMutation>;
export type DeleteRemoteAppUserRolesMutationResult_ = Apollo.MutationResult<DeleteRemoteAppUserRolesMutation_>;
export type DeleteRemoteAppUserRolesMutationOptions_ = Apollo.BaseMutationOptions<DeleteRemoteAppUserRolesMutation_, DeleteRemoteAppUserRolesMutationVariables_>;
export const GetFinancialsDocument_ = gql`
    query getFinancials($cId: uuid!) {
  notEligibleFinancials: Financials(
    where: {activityReport: {activityRef: {_eq: "0.0"}, bAssessment: {businessUnitId: {_is_null: true}, cAssessmentId: {_eq: $cId}}}}
  ) {
    ...FinancialsFields
  }
  totalComparisonFinancials: TotalComparisonFinancials(
    where: {cAssessmentId: {_eq: $cId}}
  ) {
    ...TotalComparisonFinancialsFields
  }
  nonMaterialFinancials: NonMaterialFinancials(
    where: {cAssessmentId: {_eq: $cId}}
  ) {
    ...NonMaterialFinancialsFields
  }
  businessUnits: BusinessUnitAssessment(
    where: {cAssessmentId: {_eq: $cId}, businessUnitId: {_is_null: false}, deletedAt: {_is_null: true}}
  ) {
    id
    businessUnit {
      id
      name
      labels
    }
    orderIndex
    reportingGroupId
    businessUnitFinancials: activityReports(
      where: {activityRef: {_eq: "0.0"}, bAssessment: {businessUnitId: {_is_null: false}, deletedAt: {_is_null: true}}, deletedAt: {_is_null: true}}
    ) {
      financials {
        ...FinancialsFields
      }
    }
    activities: activityReports(
      where: {activityRef: {_neq: "0.0"}, deletedAt: {_is_null: true}}
    ) {
      id
      bAssessmentId
      activity {
        name
        reference
      }
      financials {
        ...FinancialsFields
      }
    }
  }
}
    ${FinancialsFieldsFragmentDoc_}
${TotalComparisonFinancialsFieldsFragmentDoc_}
${NonMaterialFinancialsFieldsFragmentDoc_}`;

/**
 * __useGetFinancialsQuery__
 *
 * To run a query within a React component, call `useGetFinancialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialsQuery({
 *   variables: {
 *      cId: // value for 'cId'
 *   },
 * });
 */
export function useGetFinancialsQuery(baseOptions: Apollo.QueryHookOptions<GetFinancialsQuery_, GetFinancialsQueryVariables_> & ({ variables: GetFinancialsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialsQuery_, GetFinancialsQueryVariables_>(GetFinancialsDocument_, options);
      }
export function useGetFinancialsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialsQuery_, GetFinancialsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialsQuery_, GetFinancialsQueryVariables_>(GetFinancialsDocument_, options);
        }
export function useGetFinancialsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFinancialsQuery_, GetFinancialsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFinancialsQuery_, GetFinancialsQueryVariables_>(GetFinancialsDocument_, options);
        }
export type GetFinancialsQueryHookResult = ReturnType<typeof useGetFinancialsQuery>;
export type GetFinancialsLazyQuery_HookResult = ReturnType<typeof useGetFinancialsLazyQuery_>;
export type GetFinancialsSuspenseQuery_HookResult = ReturnType<typeof useGetFinancialsSuspenseQuery_>;
export type GetFinancialsQueryResult_ = Apollo.QueryResult<GetFinancialsQuery_, GetFinancialsQueryVariables_>;
export function refetchGetFinancialsQuery_(variables: GetFinancialsQueryVariables_) {
      return { query: GetFinancialsDocument_, variables: variables }
    }
export const NonMaterialFinancialsDocument_ = gql`
    query nonMaterialFinancials($cAssessmentId: uuid!) {
  NonMaterialFinancials(where: {cAssessmentId: {_eq: $cAssessmentId}}) {
    ...NonMaterialFinancialsFields
  }
}
    ${NonMaterialFinancialsFieldsFragmentDoc_}`;

/**
 * __useNonMaterialFinancialsQuery__
 *
 * To run a query within a React component, call `useNonMaterialFinancialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNonMaterialFinancialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNonMaterialFinancialsQuery({
 *   variables: {
 *      cAssessmentId: // value for 'cAssessmentId'
 *   },
 * });
 */
export function useNonMaterialFinancialsQuery(baseOptions: Apollo.QueryHookOptions<NonMaterialFinancialsQuery_, NonMaterialFinancialsQueryVariables_> & ({ variables: NonMaterialFinancialsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NonMaterialFinancialsQuery_, NonMaterialFinancialsQueryVariables_>(NonMaterialFinancialsDocument_, options);
      }
export function useNonMaterialFinancialsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<NonMaterialFinancialsQuery_, NonMaterialFinancialsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NonMaterialFinancialsQuery_, NonMaterialFinancialsQueryVariables_>(NonMaterialFinancialsDocument_, options);
        }
export function useNonMaterialFinancialsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NonMaterialFinancialsQuery_, NonMaterialFinancialsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NonMaterialFinancialsQuery_, NonMaterialFinancialsQueryVariables_>(NonMaterialFinancialsDocument_, options);
        }
export type NonMaterialFinancialsQueryHookResult = ReturnType<typeof useNonMaterialFinancialsQuery>;
export type NonMaterialFinancialsLazyQuery_HookResult = ReturnType<typeof useNonMaterialFinancialsLazyQuery_>;
export type NonMaterialFinancialsSuspenseQuery_HookResult = ReturnType<typeof useNonMaterialFinancialsSuspenseQuery_>;
export type NonMaterialFinancialsQueryResult_ = Apollo.QueryResult<NonMaterialFinancialsQuery_, NonMaterialFinancialsQueryVariables_>;
export function refetchNonMaterialFinancialsQuery_(variables: NonMaterialFinancialsQueryVariables_) {
      return { query: NonMaterialFinancialsDocument_, variables: variables }
    }
export const GetFinancialsByIdDocument_ = gql`
    query getFinancialsById($id: uuid!) {
  Financials_by_pk(id: $id) {
    ...FinancialsFields
  }
}
    ${FinancialsFieldsFragmentDoc_}`;

/**
 * __useGetFinancialsByIdQuery__
 *
 * To run a query within a React component, call `useGetFinancialsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialsByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFinancialsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetFinancialsByIdQuery_, GetFinancialsByIdQueryVariables_> & ({ variables: GetFinancialsByIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialsByIdQuery_, GetFinancialsByIdQueryVariables_>(GetFinancialsByIdDocument_, options);
      }
export function useGetFinancialsByIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialsByIdQuery_, GetFinancialsByIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialsByIdQuery_, GetFinancialsByIdQueryVariables_>(GetFinancialsByIdDocument_, options);
        }
export function useGetFinancialsByIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFinancialsByIdQuery_, GetFinancialsByIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFinancialsByIdQuery_, GetFinancialsByIdQueryVariables_>(GetFinancialsByIdDocument_, options);
        }
export type GetFinancialsByIdQueryHookResult = ReturnType<typeof useGetFinancialsByIdQuery>;
export type GetFinancialsByIdLazyQuery_HookResult = ReturnType<typeof useGetFinancialsByIdLazyQuery_>;
export type GetFinancialsByIdSuspenseQuery_HookResult = ReturnType<typeof useGetFinancialsByIdSuspenseQuery_>;
export type GetFinancialsByIdQueryResult_ = Apollo.QueryResult<GetFinancialsByIdQuery_, GetFinancialsByIdQueryVariables_>;
export function refetchGetFinancialsByIdQuery_(variables: GetFinancialsByIdQueryVariables_) {
      return { query: GetFinancialsByIdDocument_, variables: variables }
    }
export const GetActivityReportObjectivesStateFromFinancialsDocument_ = gql`
    query getActivityReportObjectivesStateFromFinancials($financialsId: uuid!) {
  ActivityReport(where: {financials: {id: {_eq: $financialsId}}}) {
    cachedResult {
      objectivesState
      isAligned
    }
  }
}
    `;

/**
 * __useGetActivityReportObjectivesStateFromFinancialsQuery__
 *
 * To run a query within a React component, call `useGetActivityReportObjectivesStateFromFinancialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityReportObjectivesStateFromFinancialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityReportObjectivesStateFromFinancialsQuery({
 *   variables: {
 *      financialsId: // value for 'financialsId'
 *   },
 * });
 */
export function useGetActivityReportObjectivesStateFromFinancialsQuery(baseOptions: Apollo.QueryHookOptions<GetActivityReportObjectivesStateFromFinancialsQuery_, GetActivityReportObjectivesStateFromFinancialsQueryVariables_> & ({ variables: GetActivityReportObjectivesStateFromFinancialsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityReportObjectivesStateFromFinancialsQuery_, GetActivityReportObjectivesStateFromFinancialsQueryVariables_>(GetActivityReportObjectivesStateFromFinancialsDocument_, options);
      }
export function useGetActivityReportObjectivesStateFromFinancialsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityReportObjectivesStateFromFinancialsQuery_, GetActivityReportObjectivesStateFromFinancialsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityReportObjectivesStateFromFinancialsQuery_, GetActivityReportObjectivesStateFromFinancialsQueryVariables_>(GetActivityReportObjectivesStateFromFinancialsDocument_, options);
        }
export function useGetActivityReportObjectivesStateFromFinancialsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityReportObjectivesStateFromFinancialsQuery_, GetActivityReportObjectivesStateFromFinancialsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivityReportObjectivesStateFromFinancialsQuery_, GetActivityReportObjectivesStateFromFinancialsQueryVariables_>(GetActivityReportObjectivesStateFromFinancialsDocument_, options);
        }
export type GetActivityReportObjectivesStateFromFinancialsQueryHookResult = ReturnType<typeof useGetActivityReportObjectivesStateFromFinancialsQuery>;
export type GetActivityReportObjectivesStateFromFinancialsLazyQuery_HookResult = ReturnType<typeof useGetActivityReportObjectivesStateFromFinancialsLazyQuery_>;
export type GetActivityReportObjectivesStateFromFinancialsSuspenseQuery_HookResult = ReturnType<typeof useGetActivityReportObjectivesStateFromFinancialsSuspenseQuery_>;
export type GetActivityReportObjectivesStateFromFinancialsQueryResult_ = Apollo.QueryResult<GetActivityReportObjectivesStateFromFinancialsQuery_, GetActivityReportObjectivesStateFromFinancialsQueryVariables_>;
export function refetchGetActivityReportObjectivesStateFromFinancialsQuery_(variables: GetActivityReportObjectivesStateFromFinancialsQueryVariables_) {
      return { query: GetActivityReportObjectivesStateFromFinancialsDocument_, variables: variables }
    }
export const UpdateFinancialsByIdDocument_ = gql`
    mutation updateFinancialsById($_set: Financials_set_input!, $id: uuid!) {
  update_Financials_by_pk(pk_columns: {id: $id}, _set: $_set) {
    ...FinancialsFields
  }
  cachedResult: update_CachedResult(
    where: {cAssessments: {bAssesssments: {activityReports: {financials: {id: {_eq: $id}}}}}}
    _set: {isDirty: true}
  ) {
    returning {
      ...CachedResultFields
    }
  }
}
    ${FinancialsFieldsFragmentDoc_}
${CachedResultFieldsFragmentDoc_}`;
export type UpdateFinancialsByIdMutationFn_ = Apollo.MutationFunction<UpdateFinancialsByIdMutation_, UpdateFinancialsByIdMutationVariables_>;

/**
 * __useUpdateFinancialsByIdMutation__
 *
 * To run a mutation, you first call `useUpdateFinancialsByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinancialsByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinancialsByIdMutation, { data, loading, error }] = useUpdateFinancialsByIdMutation({
 *   variables: {
 *      _set: // value for '_set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateFinancialsByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFinancialsByIdMutation_, UpdateFinancialsByIdMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFinancialsByIdMutation_, UpdateFinancialsByIdMutationVariables_>(UpdateFinancialsByIdDocument_, options);
      }
export type UpdateFinancialsByIdMutationHookResult = ReturnType<typeof useUpdateFinancialsByIdMutation>;
export type UpdateFinancialsByIdMutationResult_ = Apollo.MutationResult<UpdateFinancialsByIdMutation_>;
export type UpdateFinancialsByIdMutationOptions_ = Apollo.BaseMutationOptions<UpdateFinancialsByIdMutation_, UpdateFinancialsByIdMutationVariables_>;
export const UpdateFinancialEstimateManyDocument_ = gql`
    mutation updateFinancialEstimateMany($ids: [uuid!]!, $isEstimate: Boolean!) {
  update_Financials_many(
    updates: {where: {id: {_in: $ids}}, _set: {isEstimate: $isEstimate}}
  ) {
    returning {
      ...FinancialsFields
    }
  }
  cachedResult: update_CachedResult(
    where: {cAssessments: {bAssesssments: {activityReports: {financials: {id: {_in: $ids}}}}}}
    _set: {isDirty: true}
  ) {
    returning {
      ...CachedResultFields
    }
  }
}
    ${FinancialsFieldsFragmentDoc_}
${CachedResultFieldsFragmentDoc_}`;
export type UpdateFinancialEstimateManyMutationFn_ = Apollo.MutationFunction<UpdateFinancialEstimateManyMutation_, UpdateFinancialEstimateManyMutationVariables_>;

/**
 * __useUpdateFinancialEstimateManyMutation__
 *
 * To run a mutation, you first call `useUpdateFinancialEstimateManyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinancialEstimateManyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinancialEstimateManyMutation, { data, loading, error }] = useUpdateFinancialEstimateManyMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      isEstimate: // value for 'isEstimate'
 *   },
 * });
 */
export function useUpdateFinancialEstimateManyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFinancialEstimateManyMutation_, UpdateFinancialEstimateManyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFinancialEstimateManyMutation_, UpdateFinancialEstimateManyMutationVariables_>(UpdateFinancialEstimateManyDocument_, options);
      }
export type UpdateFinancialEstimateManyMutationHookResult = ReturnType<typeof useUpdateFinancialEstimateManyMutation>;
export type UpdateFinancialEstimateManyMutationResult_ = Apollo.MutationResult<UpdateFinancialEstimateManyMutation_>;
export type UpdateFinancialEstimateManyMutationOptions_ = Apollo.BaseMutationOptions<UpdateFinancialEstimateManyMutation_, UpdateFinancialEstimateManyMutationVariables_>;
export const UpdateFinancialsDocument_ = gql`
    mutation updateFinancials($financialsToUpdate: [Financials_insert_input!]!, $financialsToCreate: [Financials_insert_input!]!) {
  updates: insert_Financials(
    objects: $financialsToUpdate
    on_conflict: {constraint: financials_pkey, update_columns: [revenue, capex, opex, isEstimate, adaptationOpex, adaptationCapex]}
  ) {
    returning {
      ...FinancialsFields
    }
  }
  new: insert_Financials(objects: $financialsToCreate) {
    returning {
      ...FinancialsFields
    }
  }
}
    ${FinancialsFieldsFragmentDoc_}`;
export type UpdateFinancialsMutationFn_ = Apollo.MutationFunction<UpdateFinancialsMutation_, UpdateFinancialsMutationVariables_>;

/**
 * __useUpdateFinancialsMutation__
 *
 * To run a mutation, you first call `useUpdateFinancialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinancialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinancialsMutation, { data, loading, error }] = useUpdateFinancialsMutation({
 *   variables: {
 *      financialsToUpdate: // value for 'financialsToUpdate'
 *      financialsToCreate: // value for 'financialsToCreate'
 *   },
 * });
 */
export function useUpdateFinancialsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFinancialsMutation_, UpdateFinancialsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFinancialsMutation_, UpdateFinancialsMutationVariables_>(UpdateFinancialsDocument_, options);
      }
export type UpdateFinancialsMutationHookResult = ReturnType<typeof useUpdateFinancialsMutation>;
export type UpdateFinancialsMutationResult_ = Apollo.MutationResult<UpdateFinancialsMutation_>;
export type UpdateFinancialsMutationOptions_ = Apollo.BaseMutationOptions<UpdateFinancialsMutation_, UpdateFinancialsMutationVariables_>;
export const GetCompassPatDocument_ = gql`
    query GetCompassPAT($userEmail: citext!) {
  users(where: {email: {_eq: $userEmail}}) {
    roles {
      role
    }
    companies: companyUsers {
      companyId
    }
    compassPAT {
      personalAccessToken
      expiresAt
    }
  }
}
    `;

/**
 * __useGetCompassPatQuery__
 *
 * To run a query within a React component, call `useGetCompassPatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompassPatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompassPatQuery({
 *   variables: {
 *      userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function useGetCompassPatQuery(baseOptions: Apollo.QueryHookOptions<GetCompassPatQuery_, GetCompassPatQueryVariables_> & ({ variables: GetCompassPatQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompassPatQuery_, GetCompassPatQueryVariables_>(GetCompassPatDocument_, options);
      }
export function useGetCompassPatLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetCompassPatQuery_, GetCompassPatQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompassPatQuery_, GetCompassPatQueryVariables_>(GetCompassPatDocument_, options);
        }
export function useGetCompassPatSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompassPatQuery_, GetCompassPatQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompassPatQuery_, GetCompassPatQueryVariables_>(GetCompassPatDocument_, options);
        }
export type GetCompassPatQueryHookResult = ReturnType<typeof useGetCompassPatQuery>;
export type GetCompassPatLazyQuery_HookResult = ReturnType<typeof useGetCompassPatLazyQuery_>;
export type GetCompassPatSuspenseQuery_HookResult = ReturnType<typeof useGetCompassPatSuspenseQuery_>;
export type GetCompassPatQueryResult_ = Apollo.QueryResult<GetCompassPatQuery_, GetCompassPatQueryVariables_>;
export function refetchGetCompassPatQuery_(variables: GetCompassPatQueryVariables_) {
      return { query: GetCompassPatDocument_, variables: variables }
    }
export const GetCompanyIdFromCompassIdDocument_ = gql`
    query GetCompanyIdFromCompassId($compassId: String!) {
  Company(where: {compassId: {_eq: $compassId}}) {
    id
    name
  }
}
    `;

/**
 * __useGetCompanyIdFromCompassIdQuery__
 *
 * To run a query within a React component, call `useGetCompanyIdFromCompassIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyIdFromCompassIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyIdFromCompassIdQuery({
 *   variables: {
 *      compassId: // value for 'compassId'
 *   },
 * });
 */
export function useGetCompanyIdFromCompassIdQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyIdFromCompassIdQuery_, GetCompanyIdFromCompassIdQueryVariables_> & ({ variables: GetCompanyIdFromCompassIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyIdFromCompassIdQuery_, GetCompanyIdFromCompassIdQueryVariables_>(GetCompanyIdFromCompassIdDocument_, options);
      }
export function useGetCompanyIdFromCompassIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyIdFromCompassIdQuery_, GetCompanyIdFromCompassIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyIdFromCompassIdQuery_, GetCompanyIdFromCompassIdQueryVariables_>(GetCompanyIdFromCompassIdDocument_, options);
        }
export function useGetCompanyIdFromCompassIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyIdFromCompassIdQuery_, GetCompanyIdFromCompassIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyIdFromCompassIdQuery_, GetCompanyIdFromCompassIdQueryVariables_>(GetCompanyIdFromCompassIdDocument_, options);
        }
export type GetCompanyIdFromCompassIdQueryHookResult = ReturnType<typeof useGetCompanyIdFromCompassIdQuery>;
export type GetCompanyIdFromCompassIdLazyQuery_HookResult = ReturnType<typeof useGetCompanyIdFromCompassIdLazyQuery_>;
export type GetCompanyIdFromCompassIdSuspenseQuery_HookResult = ReturnType<typeof useGetCompanyIdFromCompassIdSuspenseQuery_>;
export type GetCompanyIdFromCompassIdQueryResult_ = Apollo.QueryResult<GetCompanyIdFromCompassIdQuery_, GetCompanyIdFromCompassIdQueryVariables_>;
export function refetchGetCompanyIdFromCompassIdQuery_(variables: GetCompanyIdFromCompassIdQueryVariables_) {
      return { query: GetCompanyIdFromCompassIdDocument_, variables: variables }
    }
export const StoreCompassPatDocument_ = gql`
    mutation StoreCompassPAT($userId: uuid!, $pat: uuid!, $expiresAt: timestamptz!) {
  insert_CompassPAT_one(
    object: {userId: $userId, personalAccessToken: $pat, expiresAt: $expiresAt}
  ) {
    userId
    expiresAt
  }
}
    `;
export type StoreCompassPatMutationFn_ = Apollo.MutationFunction<StoreCompassPatMutation_, StoreCompassPatMutationVariables_>;

/**
 * __useStoreCompassPatMutation__
 *
 * To run a mutation, you first call `useStoreCompassPatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStoreCompassPatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [storeCompassPatMutation, { data, loading, error }] = useStoreCompassPatMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      pat: // value for 'pat'
 *      expiresAt: // value for 'expiresAt'
 *   },
 * });
 */
export function useStoreCompassPatMutation(baseOptions?: Apollo.MutationHookOptions<StoreCompassPatMutation_, StoreCompassPatMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StoreCompassPatMutation_, StoreCompassPatMutationVariables_>(StoreCompassPatDocument_, options);
      }
export type StoreCompassPatMutationHookResult = ReturnType<typeof useStoreCompassPatMutation>;
export type StoreCompassPatMutationResult_ = Apollo.MutationResult<StoreCompassPatMutation_>;
export type StoreCompassPatMutationOptions_ = Apollo.BaseMutationOptions<StoreCompassPatMutation_, StoreCompassPatMutationVariables_>;
export const GetUserFromEmailDocument_ = gql`
    query getUserFromEmail($userEmail: citext!) {
  users(where: {email: {_ilike: $userEmail}}) {
    id
    email
    disabled
  }
}
    `;

/**
 * __useGetUserFromEmailQuery__
 *
 * To run a query within a React component, call `useGetUserFromEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserFromEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserFromEmailQuery({
 *   variables: {
 *      userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function useGetUserFromEmailQuery(baseOptions: Apollo.QueryHookOptions<GetUserFromEmailQuery_, GetUserFromEmailQueryVariables_> & ({ variables: GetUserFromEmailQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserFromEmailQuery_, GetUserFromEmailQueryVariables_>(GetUserFromEmailDocument_, options);
      }
export function useGetUserFromEmailLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetUserFromEmailQuery_, GetUserFromEmailQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserFromEmailQuery_, GetUserFromEmailQueryVariables_>(GetUserFromEmailDocument_, options);
        }
export function useGetUserFromEmailSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserFromEmailQuery_, GetUserFromEmailQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserFromEmailQuery_, GetUserFromEmailQueryVariables_>(GetUserFromEmailDocument_, options);
        }
export type GetUserFromEmailQueryHookResult = ReturnType<typeof useGetUserFromEmailQuery>;
export type GetUserFromEmailLazyQuery_HookResult = ReturnType<typeof useGetUserFromEmailLazyQuery_>;
export type GetUserFromEmailSuspenseQuery_HookResult = ReturnType<typeof useGetUserFromEmailSuspenseQuery_>;
export type GetUserFromEmailQueryResult_ = Apollo.QueryResult<GetUserFromEmailQuery_, GetUserFromEmailQueryVariables_>;
export function refetchGetUserFromEmailQuery_(variables: GetUserFromEmailQueryVariables_) {
      return { query: GetUserFromEmailDocument_, variables: variables }
    }
export const RemovePasswordHashDocument_ = gql`
    mutation removePasswordHash($userId: uuid!) {
  updateUser(_set: {passwordHash: null}, pk_columns: {id: $userId}) {
    id
    passwordHash
  }
}
    `;
export type RemovePasswordHashMutationFn_ = Apollo.MutationFunction<RemovePasswordHashMutation_, RemovePasswordHashMutationVariables_>;

/**
 * __useRemovePasswordHashMutation__
 *
 * To run a mutation, you first call `useRemovePasswordHashMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePasswordHashMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePasswordHashMutation, { data, loading, error }] = useRemovePasswordHashMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemovePasswordHashMutation(baseOptions?: Apollo.MutationHookOptions<RemovePasswordHashMutation_, RemovePasswordHashMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePasswordHashMutation_, RemovePasswordHashMutationVariables_>(RemovePasswordHashDocument_, options);
      }
export type RemovePasswordHashMutationHookResult = ReturnType<typeof useRemovePasswordHashMutation>;
export type RemovePasswordHashMutationResult_ = Apollo.MutationResult<RemovePasswordHashMutation_>;
export type RemovePasswordHashMutationOptions_ = Apollo.BaseMutationOptions<RemovePasswordHashMutation_, RemovePasswordHashMutationVariables_>;
export const PendingInvitationsPerEmailDocument_ = gql`
    query pendingInvitationsPerEmail($userEmail: citext!) {
  invitations: CompanyInvitation(
    where: {status: {_eq: "pending"}, userEmail: {_ilike: $userEmail}}
  ) {
    id
    status
    companyId
  }
}
    `;

/**
 * __usePendingInvitationsPerEmailQuery__
 *
 * To run a query within a React component, call `usePendingInvitationsPerEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingInvitationsPerEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingInvitationsPerEmailQuery({
 *   variables: {
 *      userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function usePendingInvitationsPerEmailQuery(baseOptions: Apollo.QueryHookOptions<PendingInvitationsPerEmailQuery_, PendingInvitationsPerEmailQueryVariables_> & ({ variables: PendingInvitationsPerEmailQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingInvitationsPerEmailQuery_, PendingInvitationsPerEmailQueryVariables_>(PendingInvitationsPerEmailDocument_, options);
      }
export function usePendingInvitationsPerEmailLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<PendingInvitationsPerEmailQuery_, PendingInvitationsPerEmailQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingInvitationsPerEmailQuery_, PendingInvitationsPerEmailQueryVariables_>(PendingInvitationsPerEmailDocument_, options);
        }
export function usePendingInvitationsPerEmailSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PendingInvitationsPerEmailQuery_, PendingInvitationsPerEmailQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PendingInvitationsPerEmailQuery_, PendingInvitationsPerEmailQueryVariables_>(PendingInvitationsPerEmailDocument_, options);
        }
export type PendingInvitationsPerEmailQueryHookResult = ReturnType<typeof usePendingInvitationsPerEmailQuery>;
export type PendingInvitationsPerEmailLazyQuery_HookResult = ReturnType<typeof usePendingInvitationsPerEmailLazyQuery_>;
export type PendingInvitationsPerEmailSuspenseQuery_HookResult = ReturnType<typeof usePendingInvitationsPerEmailSuspenseQuery_>;
export type PendingInvitationsPerEmailQueryResult_ = Apollo.QueryResult<PendingInvitationsPerEmailQuery_, PendingInvitationsPerEmailQueryVariables_>;
export function refetchPendingInvitationsPerEmailQuery_(variables: PendingInvitationsPerEmailQueryVariables_) {
      return { query: PendingInvitationsPerEmailDocument_, variables: variables }
    }
export const GetSubsidiaryResultsDocument_ = gql`
    query GetSubsidiaryResults($gAssessmentId: uuid!) {
  GroupAssessment(
    where: {id: {_eq: $gAssessmentId}, _and: {deletedAt: {_is_null: true}}}
  ) {
    name
    period
    subsidiaries {
      id
      company {
        name
        currency
      }
      sharedCompanyAssessment {
        id
        cachedResult {
          ...CachedResultFields
        }
        generalBusinessUnitResult: bAssesssments(
          where: {businessUnitId: {_is_null: true}, deletedAt: {_is_null: true}}
        ) {
          generalAssessmentResults: activityReports(
            where: {activityRef: {_eq: "0.0"}, deletedAt: {_is_null: true}}
          ) {
            activityAssessmentId: id
            bAssessmentId
            activityVersionNumber
            cachedResult {
              ...CachedResultFields
            }
          }
        }
        businessUnitResults: bAssesssments(
          where: {businessUnitId: {_is_null: false}, deletedAt: {_is_null: true}, businessUnit: {deletedAt: {_is_null: true}}}
        ) {
          bAssessmentId: id
          businessUnit {
            name
            id
          }
          cachedResult {
            ...CachedResultFields
          }
          hasGeneralAssessment
          generalAssessmentResults: activityReports(
            where: {activityRef: {_eq: "0.0"}, deletedAt: {_is_null: true}}
          ) {
            activityAssessmentId: id
            bAssessmentId
            activityVersionNumber
            cachedResult {
              ...CachedResultFields
            }
            financials {
              adaptationCapex
              adaptationOpex
              capex
              opex
              revenue
            }
          }
          activityResults: activityReports(
            where: {activityRef: {_neq: "0.0"}, deletedAt: {_is_null: true}}
          ) {
            activityAssessmentId: id
            activityRef
            activityVersionNumber
            cachedResult {
              ...CachedResultFields
            }
            financials {
              adaptationCapex
              adaptationOpex
              capex
              opex
              revenue
            }
          }
        }
      }
    }
  }
}
    ${CachedResultFieldsFragmentDoc_}`;

/**
 * __useGetSubsidiaryResultsQuery__
 *
 * To run a query within a React component, call `useGetSubsidiaryResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubsidiaryResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubsidiaryResultsQuery({
 *   variables: {
 *      gAssessmentId: // value for 'gAssessmentId'
 *   },
 * });
 */
export function useGetSubsidiaryResultsQuery(baseOptions: Apollo.QueryHookOptions<GetSubsidiaryResultsQuery_, GetSubsidiaryResultsQueryVariables_> & ({ variables: GetSubsidiaryResultsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubsidiaryResultsQuery_, GetSubsidiaryResultsQueryVariables_>(GetSubsidiaryResultsDocument_, options);
      }
export function useGetSubsidiaryResultsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetSubsidiaryResultsQuery_, GetSubsidiaryResultsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubsidiaryResultsQuery_, GetSubsidiaryResultsQueryVariables_>(GetSubsidiaryResultsDocument_, options);
        }
export function useGetSubsidiaryResultsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubsidiaryResultsQuery_, GetSubsidiaryResultsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubsidiaryResultsQuery_, GetSubsidiaryResultsQueryVariables_>(GetSubsidiaryResultsDocument_, options);
        }
export type GetSubsidiaryResultsQueryHookResult = ReturnType<typeof useGetSubsidiaryResultsQuery>;
export type GetSubsidiaryResultsLazyQuery_HookResult = ReturnType<typeof useGetSubsidiaryResultsLazyQuery_>;
export type GetSubsidiaryResultsSuspenseQuery_HookResult = ReturnType<typeof useGetSubsidiaryResultsSuspenseQuery_>;
export type GetSubsidiaryResultsQueryResult_ = Apollo.QueryResult<GetSubsidiaryResultsQuery_, GetSubsidiaryResultsQueryVariables_>;
export function refetchGetSubsidiaryResultsQuery_(variables: GetSubsidiaryResultsQueryVariables_) {
      return { query: GetSubsidiaryResultsDocument_, variables: variables }
    }
export const InsertGeneralActivityAssessmentDocument_ = gql`
    mutation insertGeneralActivityAssessment($bAssessmentId: uuid!, $versionNumber: Int!) {
  insert_ActivityReport_one(
    object: {bAssessmentId: $bAssessmentId, activityRef: "0.0", activityVersionNumber: $versionNumber, financials: {data: {capex: 0, opex: 0, revenue: 0, adaptationOpex: 0, adaptationCapex: 0, isEstimate: true, attachmentBox: {data: {}}, noteHistory: {data: {}}}}}
    on_conflict: {constraint: ActivityReport_bAssessmentId_activityRef_614b7372_uniq, update_columns: [activityRef, activityVersionNumber]}
  ) {
    id
  }
}
    `;
export type InsertGeneralActivityAssessmentMutationFn_ = Apollo.MutationFunction<InsertGeneralActivityAssessmentMutation_, InsertGeneralActivityAssessmentMutationVariables_>;

/**
 * __useInsertGeneralActivityAssessmentMutation__
 *
 * To run a mutation, you first call `useInsertGeneralActivityAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertGeneralActivityAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertGeneralActivityAssessmentMutation, { data, loading, error }] = useInsertGeneralActivityAssessmentMutation({
 *   variables: {
 *      bAssessmentId: // value for 'bAssessmentId'
 *      versionNumber: // value for 'versionNumber'
 *   },
 * });
 */
export function useInsertGeneralActivityAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<InsertGeneralActivityAssessmentMutation_, InsertGeneralActivityAssessmentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertGeneralActivityAssessmentMutation_, InsertGeneralActivityAssessmentMutationVariables_>(InsertGeneralActivityAssessmentDocument_, options);
      }
export type InsertGeneralActivityAssessmentMutationHookResult = ReturnType<typeof useInsertGeneralActivityAssessmentMutation>;
export type InsertGeneralActivityAssessmentMutationResult_ = Apollo.MutationResult<InsertGeneralActivityAssessmentMutation_>;
export type InsertGeneralActivityAssessmentMutationOptions_ = Apollo.BaseMutationOptions<InsertGeneralActivityAssessmentMutation_, InsertGeneralActivityAssessmentMutationVariables_>;
export const ValidateInviteDocument_ = gql`
    query validateInvite($invitationId: uuid!) {
  result: CompanyInvitation_by_pk(id: $invitationId) {
    company {
      logoUrl
      name
    }
    user {
      displayName
      email
    }
    id
    userEmail
    status
    companyId
    inviteToChildCompanies
  }
}
    `;

/**
 * __useValidateInviteQuery__
 *
 * To run a query within a React component, call `useValidateInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateInviteQuery({
 *   variables: {
 *      invitationId: // value for 'invitationId'
 *   },
 * });
 */
export function useValidateInviteQuery(baseOptions: Apollo.QueryHookOptions<ValidateInviteQuery_, ValidateInviteQueryVariables_> & ({ variables: ValidateInviteQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateInviteQuery_, ValidateInviteQueryVariables_>(ValidateInviteDocument_, options);
      }
export function useValidateInviteLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ValidateInviteQuery_, ValidateInviteQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateInviteQuery_, ValidateInviteQueryVariables_>(ValidateInviteDocument_, options);
        }
export function useValidateInviteSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateInviteQuery_, ValidateInviteQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateInviteQuery_, ValidateInviteQueryVariables_>(ValidateInviteDocument_, options);
        }
export type ValidateInviteQueryHookResult = ReturnType<typeof useValidateInviteQuery>;
export type ValidateInviteLazyQuery_HookResult = ReturnType<typeof useValidateInviteLazyQuery_>;
export type ValidateInviteSuspenseQuery_HookResult = ReturnType<typeof useValidateInviteSuspenseQuery_>;
export type ValidateInviteQueryResult_ = Apollo.QueryResult<ValidateInviteQuery_, ValidateInviteQueryVariables_>;
export function refetchValidateInviteQuery_(variables: ValidateInviteQueryVariables_) {
      return { query: ValidateInviteDocument_, variables: variables }
    }
export const ValidateOrgDocument_ = gql`
    query validateOrg($orgName: String!) {
  organization: IdentityProvider_by_pk(name: $orgName) {
    name
    orgId: workosOrgId
  }
}
    `;

/**
 * __useValidateOrgQuery__
 *
 * To run a query within a React component, call `useValidateOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateOrgQuery({
 *   variables: {
 *      orgName: // value for 'orgName'
 *   },
 * });
 */
export function useValidateOrgQuery(baseOptions: Apollo.QueryHookOptions<ValidateOrgQuery_, ValidateOrgQueryVariables_> & ({ variables: ValidateOrgQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateOrgQuery_, ValidateOrgQueryVariables_>(ValidateOrgDocument_, options);
      }
export function useValidateOrgLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ValidateOrgQuery_, ValidateOrgQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateOrgQuery_, ValidateOrgQueryVariables_>(ValidateOrgDocument_, options);
        }
export function useValidateOrgSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateOrgQuery_, ValidateOrgQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateOrgQuery_, ValidateOrgQueryVariables_>(ValidateOrgDocument_, options);
        }
export type ValidateOrgQueryHookResult = ReturnType<typeof useValidateOrgQuery>;
export type ValidateOrgLazyQuery_HookResult = ReturnType<typeof useValidateOrgLazyQuery_>;
export type ValidateOrgSuspenseQuery_HookResult = ReturnType<typeof useValidateOrgSuspenseQuery_>;
export type ValidateOrgQueryResult_ = Apollo.QueryResult<ValidateOrgQuery_, ValidateOrgQueryVariables_>;
export function refetchValidateOrgQuery_(variables: ValidateOrgQueryVariables_) {
      return { query: ValidateOrgDocument_, variables: variables }
    }
export const GetUserWithCompaniesDocument_ = gql`
    query getUserWithCompanies($userId: uuid!) {
  user(id: $userId) {
    ...ShortUser
    companies: companyUsers {
      company {
        id
        name
        hasTaxonomyAccess
        hasPaiAccess
        hasESRSAccess
        investorsWithAccess: portfolioCompanies {
          investor: portfolio {
            access: ownerCompany {
              hasTaxonomyAccess
              hasPaiAccess
              hasESRSAccess
            }
          }
        }
      }
    }
  }
}
    ${ShortUserFragmentDoc_}`;

/**
 * __useGetUserWithCompaniesQuery__
 *
 * To run a query within a React component, call `useGetUserWithCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserWithCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserWithCompaniesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserWithCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetUserWithCompaniesQuery_, GetUserWithCompaniesQueryVariables_> & ({ variables: GetUserWithCompaniesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserWithCompaniesQuery_, GetUserWithCompaniesQueryVariables_>(GetUserWithCompaniesDocument_, options);
      }
export function useGetUserWithCompaniesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetUserWithCompaniesQuery_, GetUserWithCompaniesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserWithCompaniesQuery_, GetUserWithCompaniesQueryVariables_>(GetUserWithCompaniesDocument_, options);
        }
export function useGetUserWithCompaniesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserWithCompaniesQuery_, GetUserWithCompaniesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserWithCompaniesQuery_, GetUserWithCompaniesQueryVariables_>(GetUserWithCompaniesDocument_, options);
        }
export type GetUserWithCompaniesQueryHookResult = ReturnType<typeof useGetUserWithCompaniesQuery>;
export type GetUserWithCompaniesLazyQuery_HookResult = ReturnType<typeof useGetUserWithCompaniesLazyQuery_>;
export type GetUserWithCompaniesSuspenseQuery_HookResult = ReturnType<typeof useGetUserWithCompaniesSuspenseQuery_>;
export type GetUserWithCompaniesQueryResult_ = Apollo.QueryResult<GetUserWithCompaniesQuery_, GetUserWithCompaniesQueryVariables_>;
export function refetchGetUserWithCompaniesQuery_(variables: GetUserWithCompaniesQueryVariables_) {
      return { query: GetUserWithCompaniesDocument_, variables: variables }
    }
export const GetGAssessmentUsersDocument_ = gql`
    query GetGAssessmentUsers($gAssessmentId: uuid!) {
  GroupAssessment(
    where: {id: {_eq: $gAssessmentId}, _and: {deletedAt: {_is_null: true}}}
  ) {
    company {
      users {
        user {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetGAssessmentUsersQuery__
 *
 * To run a query within a React component, call `useGetGAssessmentUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGAssessmentUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGAssessmentUsersQuery({
 *   variables: {
 *      gAssessmentId: // value for 'gAssessmentId'
 *   },
 * });
 */
export function useGetGAssessmentUsersQuery(baseOptions: Apollo.QueryHookOptions<GetGAssessmentUsersQuery_, GetGAssessmentUsersQueryVariables_> & ({ variables: GetGAssessmentUsersQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGAssessmentUsersQuery_, GetGAssessmentUsersQueryVariables_>(GetGAssessmentUsersDocument_, options);
      }
export function useGetGAssessmentUsersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetGAssessmentUsersQuery_, GetGAssessmentUsersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGAssessmentUsersQuery_, GetGAssessmentUsersQueryVariables_>(GetGAssessmentUsersDocument_, options);
        }
export function useGetGAssessmentUsersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGAssessmentUsersQuery_, GetGAssessmentUsersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGAssessmentUsersQuery_, GetGAssessmentUsersQueryVariables_>(GetGAssessmentUsersDocument_, options);
        }
export type GetGAssessmentUsersQueryHookResult = ReturnType<typeof useGetGAssessmentUsersQuery>;
export type GetGAssessmentUsersLazyQuery_HookResult = ReturnType<typeof useGetGAssessmentUsersLazyQuery_>;
export type GetGAssessmentUsersSuspenseQuery_HookResult = ReturnType<typeof useGetGAssessmentUsersSuspenseQuery_>;
export type GetGAssessmentUsersQueryResult_ = Apollo.QueryResult<GetGAssessmentUsersQuery_, GetGAssessmentUsersQueryVariables_>;
export function refetchGetGAssessmentUsersQuery_(variables: GetGAssessmentUsersQueryVariables_) {
      return { query: GetGAssessmentUsersDocument_, variables: variables }
    }
export const AddUserNotificationDocument_ = gql`
    mutation addUserNotification($userNotification: [UserNotification_insert_input!]!) {
  userNotification: insert_UserNotification(
    objects: $userNotification
    on_conflict: {constraint: UserNotification_pkey}
  ) {
    returning {
      id
    }
  }
}
    `;
export type AddUserNotificationMutationFn_ = Apollo.MutationFunction<AddUserNotificationMutation_, AddUserNotificationMutationVariables_>;

/**
 * __useAddUserNotificationMutation__
 *
 * To run a mutation, you first call `useAddUserNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserNotificationMutation, { data, loading, error }] = useAddUserNotificationMutation({
 *   variables: {
 *      userNotification: // value for 'userNotification'
 *   },
 * });
 */
export function useAddUserNotificationMutation(baseOptions?: Apollo.MutationHookOptions<AddUserNotificationMutation_, AddUserNotificationMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserNotificationMutation_, AddUserNotificationMutationVariables_>(AddUserNotificationDocument_, options);
      }
export type AddUserNotificationMutationHookResult = ReturnType<typeof useAddUserNotificationMutation>;
export type AddUserNotificationMutationResult_ = Apollo.MutationResult<AddUserNotificationMutation_>;
export type AddUserNotificationMutationOptions_ = Apollo.BaseMutationOptions<AddUserNotificationMutation_, AddUserNotificationMutationVariables_>;
export const GetEsrsAssessmentUserDocument_ = gql`
    query GetEsrsAssessmentUser($assessmentId: uuid!) {
  esrsAssessment: EsrsAssessment_by_pk(id: $assessmentId) {
    id
    company {
      users {
        user {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetEsrsAssessmentUserQuery__
 *
 * To run a query within a React component, call `useGetEsrsAssessmentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsrsAssessmentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsrsAssessmentUserQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetEsrsAssessmentUserQuery(baseOptions: Apollo.QueryHookOptions<GetEsrsAssessmentUserQuery_, GetEsrsAssessmentUserQueryVariables_> & ({ variables: GetEsrsAssessmentUserQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsrsAssessmentUserQuery_, GetEsrsAssessmentUserQueryVariables_>(GetEsrsAssessmentUserDocument_, options);
      }
export function useGetEsrsAssessmentUserLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetEsrsAssessmentUserQuery_, GetEsrsAssessmentUserQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsrsAssessmentUserQuery_, GetEsrsAssessmentUserQueryVariables_>(GetEsrsAssessmentUserDocument_, options);
        }
export function useGetEsrsAssessmentUserSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEsrsAssessmentUserQuery_, GetEsrsAssessmentUserQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEsrsAssessmentUserQuery_, GetEsrsAssessmentUserQueryVariables_>(GetEsrsAssessmentUserDocument_, options);
        }
export type GetEsrsAssessmentUserQueryHookResult = ReturnType<typeof useGetEsrsAssessmentUserQuery>;
export type GetEsrsAssessmentUserLazyQuery_HookResult = ReturnType<typeof useGetEsrsAssessmentUserLazyQuery_>;
export type GetEsrsAssessmentUserSuspenseQuery_HookResult = ReturnType<typeof useGetEsrsAssessmentUserSuspenseQuery_>;
export type GetEsrsAssessmentUserQueryResult_ = Apollo.QueryResult<GetEsrsAssessmentUserQuery_, GetEsrsAssessmentUserQueryVariables_>;
export function refetchGetEsrsAssessmentUserQuery_(variables: GetEsrsAssessmentUserQueryVariables_) {
      return { query: GetEsrsAssessmentUserDocument_, variables: variables }
    }
export const GetEsrsAssessmentDocument_ = gql`
    query GetEsrsAssessment($assessmentId: uuid!) {
  assessment: EsrsAssessment_by_pk(id: $assessmentId) {
    id
    companyId
    companySize
    reportingYear
    parentAssessmentId
    projectLeaderId
    onboardingStep
    frameworkRef
    company {
      users {
        user {
          id
          email
          displayName
          avatarUrl
          roles {
            role
          }
          disabled
          invitations {
            id
            status
            companyId
            shouldAddToSubs
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEsrsAssessmentQuery__
 *
 * To run a query within a React component, call `useGetEsrsAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEsrsAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEsrsAssessmentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetEsrsAssessmentQuery(baseOptions: Apollo.QueryHookOptions<GetEsrsAssessmentQuery_, GetEsrsAssessmentQueryVariables_> & ({ variables: GetEsrsAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEsrsAssessmentQuery_, GetEsrsAssessmentQueryVariables_>(GetEsrsAssessmentDocument_, options);
      }
export function useGetEsrsAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetEsrsAssessmentQuery_, GetEsrsAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEsrsAssessmentQuery_, GetEsrsAssessmentQueryVariables_>(GetEsrsAssessmentDocument_, options);
        }
export function useGetEsrsAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEsrsAssessmentQuery_, GetEsrsAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEsrsAssessmentQuery_, GetEsrsAssessmentQueryVariables_>(GetEsrsAssessmentDocument_, options);
        }
export type GetEsrsAssessmentQueryHookResult = ReturnType<typeof useGetEsrsAssessmentQuery>;
export type GetEsrsAssessmentLazyQuery_HookResult = ReturnType<typeof useGetEsrsAssessmentLazyQuery_>;
export type GetEsrsAssessmentSuspenseQuery_HookResult = ReturnType<typeof useGetEsrsAssessmentSuspenseQuery_>;
export type GetEsrsAssessmentQueryResult_ = Apollo.QueryResult<GetEsrsAssessmentQuery_, GetEsrsAssessmentQueryVariables_>;
export function refetchGetEsrsAssessmentQuery_(variables: GetEsrsAssessmentQueryVariables_) {
      return { query: GetEsrsAssessmentDocument_, variables: variables }
    }
export const UpsertCompanyInvitationsDocument_ = gql`
    mutation upsertCompanyInvitations($companyInvitations: [CompanyInvitation_insert_input!]!) {
  insert_CompanyInvitation(
    objects: $companyInvitations
    on_conflict: {constraint: CompanyInvitation_pkey, update_columns: [status]}
  ) {
    returning {
      id
      company {
        id
        name
        invitations {
          id
        }
      }
      user {
        displayName
        id
      }
      status
      userEmail
    }
  }
}
    `;
export type UpsertCompanyInvitationsMutationFn_ = Apollo.MutationFunction<UpsertCompanyInvitationsMutation_, UpsertCompanyInvitationsMutationVariables_>;

/**
 * __useUpsertCompanyInvitationsMutation__
 *
 * To run a mutation, you first call `useUpsertCompanyInvitationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCompanyInvitationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCompanyInvitationsMutation, { data, loading, error }] = useUpsertCompanyInvitationsMutation({
 *   variables: {
 *      companyInvitations: // value for 'companyInvitations'
 *   },
 * });
 */
export function useUpsertCompanyInvitationsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCompanyInvitationsMutation_, UpsertCompanyInvitationsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCompanyInvitationsMutation_, UpsertCompanyInvitationsMutationVariables_>(UpsertCompanyInvitationsDocument_, options);
      }
export type UpsertCompanyInvitationsMutationHookResult = ReturnType<typeof useUpsertCompanyInvitationsMutation>;
export type UpsertCompanyInvitationsMutationResult_ = Apollo.MutationResult<UpsertCompanyInvitationsMutation_>;
export type UpsertCompanyInvitationsMutationOptions_ = Apollo.BaseMutationOptions<UpsertCompanyInvitationsMutation_, UpsertCompanyInvitationsMutationVariables_>;
export const CompanyDocument_ = gql`
    query Company($companyId: uuid!) {
  company: Company(where: {id: {_eq: $companyId}}) {
    id
    name
    isGroupOwner
    esrsAssessments {
      subsidiaryAssessments {
        id
        company {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useCompanyQuery__
 *
 * To run a query within a React component, call `useCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyQuery(baseOptions: Apollo.QueryHookOptions<CompanyQuery_, CompanyQueryVariables_> & ({ variables: CompanyQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyQuery_, CompanyQueryVariables_>(CompanyDocument_, options);
      }
export function useCompanyLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompanyQuery_, CompanyQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyQuery_, CompanyQueryVariables_>(CompanyDocument_, options);
        }
export function useCompanySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyQuery_, CompanyQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyQuery_, CompanyQueryVariables_>(CompanyDocument_, options);
        }
export type CompanyQueryHookResult = ReturnType<typeof useCompanyQuery>;
export type CompanyLazyQuery_HookResult = ReturnType<typeof useCompanyLazyQuery_>;
export type CompanySuspenseQuery_HookResult = ReturnType<typeof useCompanySuspenseQuery_>;
export type CompanyQueryResult_ = Apollo.QueryResult<CompanyQuery_, CompanyQueryVariables_>;
export function refetchCompanyQuery_(variables: CompanyQueryVariables_) {
      return { query: CompanyDocument_, variables: variables }
    }
export const CompanyInvitationsPerEmailDocument_ = gql`
    query CompanyInvitationsPerEmail($userEmail: citext!) {
  invitations: CompanyInvitation(where: {userEmail: {_eq: $userEmail}}) {
    id
    userEmail
    status
    companyId
    shouldAddToSubs
  }
}
    `;

/**
 * __useCompanyInvitationsPerEmailQuery__
 *
 * To run a query within a React component, call `useCompanyInvitationsPerEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyInvitationsPerEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyInvitationsPerEmailQuery({
 *   variables: {
 *      userEmail: // value for 'userEmail'
 *   },
 * });
 */
export function useCompanyInvitationsPerEmailQuery(baseOptions: Apollo.QueryHookOptions<CompanyInvitationsPerEmailQuery_, CompanyInvitationsPerEmailQueryVariables_> & ({ variables: CompanyInvitationsPerEmailQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyInvitationsPerEmailQuery_, CompanyInvitationsPerEmailQueryVariables_>(CompanyInvitationsPerEmailDocument_, options);
      }
export function useCompanyInvitationsPerEmailLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompanyInvitationsPerEmailQuery_, CompanyInvitationsPerEmailQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyInvitationsPerEmailQuery_, CompanyInvitationsPerEmailQueryVariables_>(CompanyInvitationsPerEmailDocument_, options);
        }
export function useCompanyInvitationsPerEmailSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyInvitationsPerEmailQuery_, CompanyInvitationsPerEmailQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyInvitationsPerEmailQuery_, CompanyInvitationsPerEmailQueryVariables_>(CompanyInvitationsPerEmailDocument_, options);
        }
export type CompanyInvitationsPerEmailQueryHookResult = ReturnType<typeof useCompanyInvitationsPerEmailQuery>;
export type CompanyInvitationsPerEmailLazyQuery_HookResult = ReturnType<typeof useCompanyInvitationsPerEmailLazyQuery_>;
export type CompanyInvitationsPerEmailSuspenseQuery_HookResult = ReturnType<typeof useCompanyInvitationsPerEmailSuspenseQuery_>;
export type CompanyInvitationsPerEmailQueryResult_ = Apollo.QueryResult<CompanyInvitationsPerEmailQuery_, CompanyInvitationsPerEmailQueryVariables_>;
export function refetchCompanyInvitationsPerEmailQuery_(variables: CompanyInvitationsPerEmailQueryVariables_) {
      return { query: CompanyInvitationsPerEmailDocument_, variables: variables }
    }
export const GetCompanyNameDocument_ = gql`
    query GetCompanyName($companyId: uuid!) {
  company: Company_by_pk(id: $companyId) {
    name
  }
}
    `;

/**
 * __useGetCompanyNameQuery__
 *
 * To run a query within a React component, call `useGetCompanyNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyNameQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyNameQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyNameQuery_, GetCompanyNameQueryVariables_> & ({ variables: GetCompanyNameQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyNameQuery_, GetCompanyNameQueryVariables_>(GetCompanyNameDocument_, options);
      }
export function useGetCompanyNameLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyNameQuery_, GetCompanyNameQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyNameQuery_, GetCompanyNameQueryVariables_>(GetCompanyNameDocument_, options);
        }
export function useGetCompanyNameSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyNameQuery_, GetCompanyNameQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyNameQuery_, GetCompanyNameQueryVariables_>(GetCompanyNameDocument_, options);
        }
export type GetCompanyNameQueryHookResult = ReturnType<typeof useGetCompanyNameQuery>;
export type GetCompanyNameLazyQuery_HookResult = ReturnType<typeof useGetCompanyNameLazyQuery_>;
export type GetCompanyNameSuspenseQuery_HookResult = ReturnType<typeof useGetCompanyNameSuspenseQuery_>;
export type GetCompanyNameQueryResult_ = Apollo.QueryResult<GetCompanyNameQuery_, GetCompanyNameQueryVariables_>;
export function refetchGetCompanyNameQuery_(variables: GetCompanyNameQueryVariables_) {
      return { query: GetCompanyNameDocument_, variables: variables }
    }
export const GetCompanyIdDocument_ = gql`
    query GetCompanyId($cAssessmentId: uuid!) {
  companyAssessment: CompanyAssessment_by_pk(id: $cAssessmentId) {
    company {
      id
    }
  }
}
    `;

/**
 * __useGetCompanyIdQuery__
 *
 * To run a query within a React component, call `useGetCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyIdQuery({
 *   variables: {
 *      cAssessmentId: // value for 'cAssessmentId'
 *   },
 * });
 */
export function useGetCompanyIdQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyIdQuery_, GetCompanyIdQueryVariables_> & ({ variables: GetCompanyIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyIdQuery_, GetCompanyIdQueryVariables_>(GetCompanyIdDocument_, options);
      }
export function useGetCompanyIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyIdQuery_, GetCompanyIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyIdQuery_, GetCompanyIdQueryVariables_>(GetCompanyIdDocument_, options);
        }
export function useGetCompanyIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyIdQuery_, GetCompanyIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyIdQuery_, GetCompanyIdQueryVariables_>(GetCompanyIdDocument_, options);
        }
export type GetCompanyIdQueryHookResult = ReturnType<typeof useGetCompanyIdQuery>;
export type GetCompanyIdLazyQuery_HookResult = ReturnType<typeof useGetCompanyIdLazyQuery_>;
export type GetCompanyIdSuspenseQuery_HookResult = ReturnType<typeof useGetCompanyIdSuspenseQuery_>;
export type GetCompanyIdQueryResult_ = Apollo.QueryResult<GetCompanyIdQuery_, GetCompanyIdQueryVariables_>;
export function refetchGetCompanyIdQuery_(variables: GetCompanyIdQueryVariables_) {
      return { query: GetCompanyIdDocument_, variables: variables }
    }
export const CreateUserDocument_ = gql`
    mutation CreateUser($object: users_insert_input!, $on_conflict: users_on_conflict!) {
  insertUser(object: $object, on_conflict: $on_conflict) {
    id
  }
}
    `;
export type CreateUserMutationFn_ = Apollo.MutationFunction<CreateUserMutation_, CreateUserMutationVariables_>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      object: // value for 'object'
 *      on_conflict: // value for 'on_conflict'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation_, CreateUserMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation_, CreateUserMutationVariables_>(CreateUserDocument_, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult_ = Apollo.MutationResult<CreateUserMutation_>;
export type CreateUserMutationOptions_ = Apollo.BaseMutationOptions<CreateUserMutation_, CreateUserMutationVariables_>;
export const PortfoliosWithScoresDocument_ = gql`
    query PortfoliosWithScores($companyId: uuid, $year: Int, $reportPeriod: ReportPeriod) {
  results: getPortfolioAggregate(
    input: {companyId: $companyId, year: $year, reportPeriod: $reportPeriod}
  ) {
    portfolios {
      name
      description
      portfolioProgress {
        financials
        screening
        markedAsCompleted: isLocked
      }
      portfolioScore {
        revenue {
          aligned
          eligible
          inProgress
          enabling
          transitional
        }
        capex {
          aligned
          eligible
          inProgress
          enabling
          transitional
        }
        opex {
          aligned
          eligible
          inProgress
          enabling
          transitional
        }
      }
      portfolioSubstantialContributionProportion {
        mitigation {
          revenue
          capex
          opex
        }
        adaptation {
          revenue
          capex
          opex
        }
        biodiversity {
          revenue
          capex
          opex
        }
        circular {
          revenue
          capex
          opex
        }
        pollution {
          revenue
          capex
          opex
        }
        water {
          revenue
          capex
          opex
        }
      }
      portfolioCompanies {
        name
        amount
        progress {
          financials
          screening
          markedAsCompleted: isLocked
        }
        score {
          revenue {
            aligned
            eligible
            inProgress
            enabling
            transitional
          }
          capex {
            aligned
            eligible
            inProgress
            enabling
            transitional
          }
          opex {
            aligned
            eligible
            inProgress
            enabling
            transitional
          }
        }
        substantialContributionProportion {
          mitigation {
            revenue
            capex
            opex
          }
          adaptation {
            revenue
            capex
            opex
          }
          biodiversity {
            revenue
            capex
            opex
          }
          circular {
            revenue
            capex
            opex
          }
          pollution {
            revenue
            capex
            opex
          }
          water {
            revenue
            capex
            opex
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePortfoliosWithScoresQuery__
 *
 * To run a query within a React component, call `usePortfoliosWithScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfoliosWithScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfoliosWithScoresQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      year: // value for 'year'
 *      reportPeriod: // value for 'reportPeriod'
 *   },
 * });
 */
export function usePortfoliosWithScoresQuery(baseOptions?: Apollo.QueryHookOptions<PortfoliosWithScoresQuery_, PortfoliosWithScoresQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortfoliosWithScoresQuery_, PortfoliosWithScoresQueryVariables_>(PortfoliosWithScoresDocument_, options);
      }
export function usePortfoliosWithScoresLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<PortfoliosWithScoresQuery_, PortfoliosWithScoresQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortfoliosWithScoresQuery_, PortfoliosWithScoresQueryVariables_>(PortfoliosWithScoresDocument_, options);
        }
export function usePortfoliosWithScoresSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortfoliosWithScoresQuery_, PortfoliosWithScoresQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortfoliosWithScoresQuery_, PortfoliosWithScoresQueryVariables_>(PortfoliosWithScoresDocument_, options);
        }
export type PortfoliosWithScoresQueryHookResult = ReturnType<typeof usePortfoliosWithScoresQuery>;
export type PortfoliosWithScoresLazyQuery_HookResult = ReturnType<typeof usePortfoliosWithScoresLazyQuery_>;
export type PortfoliosWithScoresSuspenseQuery_HookResult = ReturnType<typeof usePortfoliosWithScoresSuspenseQuery_>;
export type PortfoliosWithScoresQueryResult_ = Apollo.QueryResult<PortfoliosWithScoresQuery_, PortfoliosWithScoresQueryVariables_>;
export function refetchPortfoliosWithScoresQuery_(variables?: PortfoliosWithScoresQueryVariables_) {
      return { query: PortfoliosWithScoresDocument_, variables: variables }
    }
export const UpdateActivityFinancialsDocument_ = gql`
    mutation UpdateActivityFinancials($activityReportId: uuid!, $capex: float8, $opex: float8, $revenue: float8, $adaptationCapex: float8, $adaptationOpex: float8) {
  update_Financials(
    _set: {capex: $capex, opex: $opex, revenue: $revenue, adaptationCapex: $adaptationCapex, adaptationOpex: $adaptationOpex}
    where: {activityReport: {id: {_eq: $activityReportId}}}
  ) {
    affected_rows
  }
}
    `;
export type UpdateActivityFinancialsMutationFn_ = Apollo.MutationFunction<UpdateActivityFinancialsMutation_, UpdateActivityFinancialsMutationVariables_>;

/**
 * __useUpdateActivityFinancialsMutation__
 *
 * To run a mutation, you first call `useUpdateActivityFinancialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActivityFinancialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActivityFinancialsMutation, { data, loading, error }] = useUpdateActivityFinancialsMutation({
 *   variables: {
 *      activityReportId: // value for 'activityReportId'
 *      capex: // value for 'capex'
 *      opex: // value for 'opex'
 *      revenue: // value for 'revenue'
 *      adaptationCapex: // value for 'adaptationCapex'
 *      adaptationOpex: // value for 'adaptationOpex'
 *   },
 * });
 */
export function useUpdateActivityFinancialsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateActivityFinancialsMutation_, UpdateActivityFinancialsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateActivityFinancialsMutation_, UpdateActivityFinancialsMutationVariables_>(UpdateActivityFinancialsDocument_, options);
      }
export type UpdateActivityFinancialsMutationHookResult = ReturnType<typeof useUpdateActivityFinancialsMutation>;
export type UpdateActivityFinancialsMutationResult_ = Apollo.MutationResult<UpdateActivityFinancialsMutation_>;
export type UpdateActivityFinancialsMutationOptions_ = Apollo.BaseMutationOptions<UpdateActivityFinancialsMutation_, UpdateActivityFinancialsMutationVariables_>;
export const UpdateTaxonomyFinancialsDocument_ = gql`
    mutation UpdateTaxonomyFinancials($adaptationCapex: float8, $adaptationOpex: float8, $capex: float8, $opex: float8, $revenue: float8, $activityReportId: uuid!) {
  updateActivityFinancials(
    input: {adaptationCapex: $adaptationCapex, adaptationOpex: $adaptationOpex, capex: $capex, opex: $opex, revenue: $revenue, activityReportId: $activityReportId}
  ) {
    id
  }
}
    `;
export type UpdateTaxonomyFinancialsMutationFn_ = Apollo.MutationFunction<UpdateTaxonomyFinancialsMutation_, UpdateTaxonomyFinancialsMutationVariables_>;

/**
 * __useUpdateTaxonomyFinancialsMutation__
 *
 * To run a mutation, you first call `useUpdateTaxonomyFinancialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaxonomyFinancialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaxonomyFinancialsMutation, { data, loading, error }] = useUpdateTaxonomyFinancialsMutation({
 *   variables: {
 *      adaptationCapex: // value for 'adaptationCapex'
 *      adaptationOpex: // value for 'adaptationOpex'
 *      capex: // value for 'capex'
 *      opex: // value for 'opex'
 *      revenue: // value for 'revenue'
 *      activityReportId: // value for 'activityReportId'
 *   },
 * });
 */
export function useUpdateTaxonomyFinancialsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaxonomyFinancialsMutation_, UpdateTaxonomyFinancialsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaxonomyFinancialsMutation_, UpdateTaxonomyFinancialsMutationVariables_>(UpdateTaxonomyFinancialsDocument_, options);
      }
export type UpdateTaxonomyFinancialsMutationHookResult = ReturnType<typeof useUpdateTaxonomyFinancialsMutation>;
export type UpdateTaxonomyFinancialsMutationResult_ = Apollo.MutationResult<UpdateTaxonomyFinancialsMutation_>;
export type UpdateTaxonomyFinancialsMutationOptions_ = Apollo.BaseMutationOptions<UpdateTaxonomyFinancialsMutation_, UpdateTaxonomyFinancialsMutationVariables_>;
export const CompanyAssessmentCachedResultsQueryDocument_ = gql`
    query CompanyAssessmentCachedResultsQuery($cAssessmentId: uuid!) {
  companyResults: CompanyAssessment_by_pk(id: $cAssessmentId) {
    companyAssessmentId: id
    aggregateId
    endDate
    startDate
    companyId
    cachedResult {
      ...CachedResultFields
    }
    generalBusinessUnitResult: bAssesssments(
      where: {businessUnitId: {_is_null: true}, deletedAt: {_is_null: true}}
    ) {
      generalAssessmentResults: activityReports(
        where: {activityRef: {_eq: "0.0"}, deletedAt: {_is_null: true}}
      ) {
        activityAssessmentId: id
        activityVersionNumber
        bAssessmentId
        cachedResult {
          ...CachedResultFields
        }
      }
    }
    businessUnitResults: bAssesssments(
      where: {businessUnitId: {_is_null: false}, deletedAt: {_is_null: true}}
    ) {
      bAssessmentId: id
      businessUnit {
        name
        id
      }
      cachedResult {
        ...CachedResultFields
      }
      hasGeneralAssessment
      generalAssessmentResults: activityReports(
        where: {activityRef: {_eq: "0.0"}, deletedAt: {_is_null: true}}
      ) {
        activityAssessmentId: id
        activityVersionNumber
        bAssessmentId
        cachedResult {
          ...CachedResultFields
        }
      }
      activityResults: activityReports(
        where: {activityRef: {_neq: "0.0"}, deletedAt: {_is_null: true}}
      ) {
        activityAssessmentId: id
        activityVersionNumber
        activityRef
        financials {
          id
        }
        cachedResult {
          ...CachedResultFields
        }
      }
    }
  }
}
    ${CachedResultFieldsFragmentDoc_}`;

/**
 * __useCompanyAssessmentCachedResultsQueryQuery__
 *
 * To run a query within a React component, call `useCompanyAssessmentCachedResultsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAssessmentCachedResultsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAssessmentCachedResultsQueryQuery({
 *   variables: {
 *      cAssessmentId: // value for 'cAssessmentId'
 *   },
 * });
 */
export function useCompanyAssessmentCachedResultsQueryQuery(baseOptions: Apollo.QueryHookOptions<CompanyAssessmentCachedResultsQueryQuery_, CompanyAssessmentCachedResultsQueryQueryVariables_> & ({ variables: CompanyAssessmentCachedResultsQueryQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyAssessmentCachedResultsQueryQuery_, CompanyAssessmentCachedResultsQueryQueryVariables_>(CompanyAssessmentCachedResultsQueryDocument_, options);
      }
export function useCompanyAssessmentCachedResultsQueryLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompanyAssessmentCachedResultsQueryQuery_, CompanyAssessmentCachedResultsQueryQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyAssessmentCachedResultsQueryQuery_, CompanyAssessmentCachedResultsQueryQueryVariables_>(CompanyAssessmentCachedResultsQueryDocument_, options);
        }
export function useCompanyAssessmentCachedResultsQuerySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompanyAssessmentCachedResultsQueryQuery_, CompanyAssessmentCachedResultsQueryQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompanyAssessmentCachedResultsQueryQuery_, CompanyAssessmentCachedResultsQueryQueryVariables_>(CompanyAssessmentCachedResultsQueryDocument_, options);
        }
export type CompanyAssessmentCachedResultsQueryQueryHookResult = ReturnType<typeof useCompanyAssessmentCachedResultsQueryQuery>;
export type CompanyAssessmentCachedResultsQueryLazyQuery_HookResult = ReturnType<typeof useCompanyAssessmentCachedResultsQueryLazyQuery_>;
export type CompanyAssessmentCachedResultsQuerySuspenseQuery_HookResult = ReturnType<typeof useCompanyAssessmentCachedResultsQuerySuspenseQuery_>;
export type CompanyAssessmentCachedResultsQueryQueryResult_ = Apollo.QueryResult<CompanyAssessmentCachedResultsQueryQuery_, CompanyAssessmentCachedResultsQueryQueryVariables_>;
export function refetchCompanyAssessmentCachedResultsQueryQuery_(variables: CompanyAssessmentCachedResultsQueryQueryVariables_) {
      return { query: CompanyAssessmentCachedResultsQueryDocument_, variables: variables }
    }
export const TaxonomyAssessmentFinancialsDocument_ = gql`
    query TaxonomyAssessmentFinancials($id: uuid) {
  taxonomyAssessment: CompanyAssessment(
    where: {id: {_eq: $id}, deletedAt: {_is_null: true}}
  ) {
    id
    bAssesssments {
      activityReports {
        activityRef
        financials {
          adaptationCapex
          adaptationOpex
          capex
          id
          opex
          revenue
          reportId
          cAssessmentId
        }
      }
    }
  }
}
    `;

/**
 * __useTaxonomyAssessmentFinancialsQuery__
 *
 * To run a query within a React component, call `useTaxonomyAssessmentFinancialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyAssessmentFinancialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomyAssessmentFinancialsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaxonomyAssessmentFinancialsQuery(baseOptions?: Apollo.QueryHookOptions<TaxonomyAssessmentFinancialsQuery_, TaxonomyAssessmentFinancialsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxonomyAssessmentFinancialsQuery_, TaxonomyAssessmentFinancialsQueryVariables_>(TaxonomyAssessmentFinancialsDocument_, options);
      }
export function useTaxonomyAssessmentFinancialsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<TaxonomyAssessmentFinancialsQuery_, TaxonomyAssessmentFinancialsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxonomyAssessmentFinancialsQuery_, TaxonomyAssessmentFinancialsQueryVariables_>(TaxonomyAssessmentFinancialsDocument_, options);
        }
export function useTaxonomyAssessmentFinancialsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxonomyAssessmentFinancialsQuery_, TaxonomyAssessmentFinancialsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxonomyAssessmentFinancialsQuery_, TaxonomyAssessmentFinancialsQueryVariables_>(TaxonomyAssessmentFinancialsDocument_, options);
        }
export type TaxonomyAssessmentFinancialsQueryHookResult = ReturnType<typeof useTaxonomyAssessmentFinancialsQuery>;
export type TaxonomyAssessmentFinancialsLazyQuery_HookResult = ReturnType<typeof useTaxonomyAssessmentFinancialsLazyQuery_>;
export type TaxonomyAssessmentFinancialsSuspenseQuery_HookResult = ReturnType<typeof useTaxonomyAssessmentFinancialsSuspenseQuery_>;
export type TaxonomyAssessmentFinancialsQueryResult_ = Apollo.QueryResult<TaxonomyAssessmentFinancialsQuery_, TaxonomyAssessmentFinancialsQueryVariables_>;
export function refetchTaxonomyAssessmentFinancialsQuery_(variables?: TaxonomyAssessmentFinancialsQueryVariables_) {
      return { query: TaxonomyAssessmentFinancialsDocument_, variables: variables }
    }
export const TaxonomyAssessmentsDocument_ = gql`
    query TaxonomyAssessments($id: uuid!) {
  taxonomyAssessment: CompanyAssessment(
    where: {companyId: {_eq: $id}, deletedAt: {_is_null: true}}
  ) {
    id
    startDate
    metaData: aggregate {
      title
    }
    bAssesssments {
      businessUnit {
        name
      }
      id
      activityReports {
        activityRef
        id
        activity {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useTaxonomyAssessmentsQuery__
 *
 * To run a query within a React component, call `useTaxonomyAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomyAssessmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaxonomyAssessmentsQuery(baseOptions: Apollo.QueryHookOptions<TaxonomyAssessmentsQuery_, TaxonomyAssessmentsQueryVariables_> & ({ variables: TaxonomyAssessmentsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxonomyAssessmentsQuery_, TaxonomyAssessmentsQueryVariables_>(TaxonomyAssessmentsDocument_, options);
      }
export function useTaxonomyAssessmentsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<TaxonomyAssessmentsQuery_, TaxonomyAssessmentsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxonomyAssessmentsQuery_, TaxonomyAssessmentsQueryVariables_>(TaxonomyAssessmentsDocument_, options);
        }
export function useTaxonomyAssessmentsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxonomyAssessmentsQuery_, TaxonomyAssessmentsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxonomyAssessmentsQuery_, TaxonomyAssessmentsQueryVariables_>(TaxonomyAssessmentsDocument_, options);
        }
export type TaxonomyAssessmentsQueryHookResult = ReturnType<typeof useTaxonomyAssessmentsQuery>;
export type TaxonomyAssessmentsLazyQuery_HookResult = ReturnType<typeof useTaxonomyAssessmentsLazyQuery_>;
export type TaxonomyAssessmentsSuspenseQuery_HookResult = ReturnType<typeof useTaxonomyAssessmentsSuspenseQuery_>;
export type TaxonomyAssessmentsQueryResult_ = Apollo.QueryResult<TaxonomyAssessmentsQuery_, TaxonomyAssessmentsQueryVariables_>;
export function refetchTaxonomyAssessmentsQuery_(variables: TaxonomyAssessmentsQueryVariables_) {
      return { query: TaxonomyAssessmentsDocument_, variables: variables }
    }
export const TaxonomyAssessmentScoresDocument_ = gql`
    query TaxonomyAssessmentScores($id: uuid) {
  taxonomyAssessment: CompanyAssessment(
    where: {id: {_eq: $id}, deletedAt: {_is_null: true}}
  ) {
    id
    cachedResult {
      isCompleted
      isDirty
      score
      financials
    }
  }
}
    `;

/**
 * __useTaxonomyAssessmentScoresQuery__
 *
 * To run a query within a React component, call `useTaxonomyAssessmentScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaxonomyAssessmentScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaxonomyAssessmentScoresQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaxonomyAssessmentScoresQuery(baseOptions?: Apollo.QueryHookOptions<TaxonomyAssessmentScoresQuery_, TaxonomyAssessmentScoresQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaxonomyAssessmentScoresQuery_, TaxonomyAssessmentScoresQueryVariables_>(TaxonomyAssessmentScoresDocument_, options);
      }
export function useTaxonomyAssessmentScoresLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<TaxonomyAssessmentScoresQuery_, TaxonomyAssessmentScoresQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaxonomyAssessmentScoresQuery_, TaxonomyAssessmentScoresQueryVariables_>(TaxonomyAssessmentScoresDocument_, options);
        }
export function useTaxonomyAssessmentScoresSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TaxonomyAssessmentScoresQuery_, TaxonomyAssessmentScoresQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TaxonomyAssessmentScoresQuery_, TaxonomyAssessmentScoresQueryVariables_>(TaxonomyAssessmentScoresDocument_, options);
        }
export type TaxonomyAssessmentScoresQueryHookResult = ReturnType<typeof useTaxonomyAssessmentScoresQuery>;
export type TaxonomyAssessmentScoresLazyQuery_HookResult = ReturnType<typeof useTaxonomyAssessmentScoresLazyQuery_>;
export type TaxonomyAssessmentScoresSuspenseQuery_HookResult = ReturnType<typeof useTaxonomyAssessmentScoresSuspenseQuery_>;
export type TaxonomyAssessmentScoresQueryResult_ = Apollo.QueryResult<TaxonomyAssessmentScoresQuery_, TaxonomyAssessmentScoresQueryVariables_>;
export function refetchTaxonomyAssessmentScoresQuery_(variables?: TaxonomyAssessmentScoresQueryVariables_) {
      return { query: TaxonomyAssessmentScoresDocument_, variables: variables }
    }
export const CompaniesDocument_ = gql`
    query companies {
  Company {
    id
    name
  }
}
    `;

/**
 * __useCompaniesQuery__
 *
 * To run a query within a React component, call `useCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<CompaniesQuery_, CompaniesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesQuery_, CompaniesQueryVariables_>(CompaniesDocument_, options);
      }
export function useCompaniesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesQuery_, CompaniesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesQuery_, CompaniesQueryVariables_>(CompaniesDocument_, options);
        }
export function useCompaniesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompaniesQuery_, CompaniesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompaniesQuery_, CompaniesQueryVariables_>(CompaniesDocument_, options);
        }
export type CompaniesQueryHookResult = ReturnType<typeof useCompaniesQuery>;
export type CompaniesLazyQuery_HookResult = ReturnType<typeof useCompaniesLazyQuery_>;
export type CompaniesSuspenseQuery_HookResult = ReturnType<typeof useCompaniesSuspenseQuery_>;
export type CompaniesQueryResult_ = Apollo.QueryResult<CompaniesQuery_, CompaniesQueryVariables_>;
export function refetchCompaniesQuery_(variables?: CompaniesQueryVariables_) {
      return { query: CompaniesDocument_, variables: variables }
    }
export const GetOldActivityReportFinancialDataDocument_ = gql`
    query getOldActivityReportFinancialData($activityReportId: uuid!) {
  ActivityReport_by_pk(id: $activityReportId) {
    bAssessment {
      id
      cAssessmentId
      activityReports(where: {activityRef: {_eq: "0.0"}}) {
        financials {
          adaptationCapex
          adaptationOpex
          capex
          opex
          revenue
          reportId
        }
      }
      cAssessment {
        bAssesssments(where: {businessUnitId: {_is_null: true}}) {
          activityReports(where: {activityRef: {_eq: "0.0"}}) {
            financials {
              adaptationCapex
              adaptationOpex
              capex
              revenue
              opex
              reportId
            }
          }
        }
      }
    }
    financials {
      adaptationCapex
      adaptationOpex
      revenue
      opex
      capex
    }
  }
}
    `;

/**
 * __useGetOldActivityReportFinancialDataQuery__
 *
 * To run a query within a React component, call `useGetOldActivityReportFinancialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOldActivityReportFinancialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOldActivityReportFinancialDataQuery({
 *   variables: {
 *      activityReportId: // value for 'activityReportId'
 *   },
 * });
 */
export function useGetOldActivityReportFinancialDataQuery(baseOptions: Apollo.QueryHookOptions<GetOldActivityReportFinancialDataQuery_, GetOldActivityReportFinancialDataQueryVariables_> & ({ variables: GetOldActivityReportFinancialDataQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOldActivityReportFinancialDataQuery_, GetOldActivityReportFinancialDataQueryVariables_>(GetOldActivityReportFinancialDataDocument_, options);
      }
export function useGetOldActivityReportFinancialDataLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetOldActivityReportFinancialDataQuery_, GetOldActivityReportFinancialDataQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOldActivityReportFinancialDataQuery_, GetOldActivityReportFinancialDataQueryVariables_>(GetOldActivityReportFinancialDataDocument_, options);
        }
export function useGetOldActivityReportFinancialDataSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOldActivityReportFinancialDataQuery_, GetOldActivityReportFinancialDataQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOldActivityReportFinancialDataQuery_, GetOldActivityReportFinancialDataQueryVariables_>(GetOldActivityReportFinancialDataDocument_, options);
        }
export type GetOldActivityReportFinancialDataQueryHookResult = ReturnType<typeof useGetOldActivityReportFinancialDataQuery>;
export type GetOldActivityReportFinancialDataLazyQuery_HookResult = ReturnType<typeof useGetOldActivityReportFinancialDataLazyQuery_>;
export type GetOldActivityReportFinancialDataSuspenseQuery_HookResult = ReturnType<typeof useGetOldActivityReportFinancialDataSuspenseQuery_>;
export type GetOldActivityReportFinancialDataQueryResult_ = Apollo.QueryResult<GetOldActivityReportFinancialDataQuery_, GetOldActivityReportFinancialDataQueryVariables_>;
export function refetchGetOldActivityReportFinancialDataQuery_(variables: GetOldActivityReportFinancialDataQueryVariables_) {
      return { query: GetOldActivityReportFinancialDataDocument_, variables: variables }
    }
export const ActivityReportAnswersDocument_ = gql`
    query ActivityReportAnswers($id: uuid!) {
  ActivityReport_by_pk(id: $id) {
    activity {
      name
    }
    answers {
      data
      question {
        title
        choices {
          displayName
          value
        }
      }
    }
  }
}
    `;

/**
 * __useActivityReportAnswersQuery__
 *
 * To run a query within a React component, call `useActivityReportAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityReportAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityReportAnswersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivityReportAnswersQuery(baseOptions: Apollo.QueryHookOptions<ActivityReportAnswersQuery_, ActivityReportAnswersQueryVariables_> & ({ variables: ActivityReportAnswersQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityReportAnswersQuery_, ActivityReportAnswersQueryVariables_>(ActivityReportAnswersDocument_, options);
      }
export function useActivityReportAnswersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ActivityReportAnswersQuery_, ActivityReportAnswersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityReportAnswersQuery_, ActivityReportAnswersQueryVariables_>(ActivityReportAnswersDocument_, options);
        }
export function useActivityReportAnswersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityReportAnswersQuery_, ActivityReportAnswersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityReportAnswersQuery_, ActivityReportAnswersQueryVariables_>(ActivityReportAnswersDocument_, options);
        }
export type ActivityReportAnswersQueryHookResult = ReturnType<typeof useActivityReportAnswersQuery>;
export type ActivityReportAnswersLazyQuery_HookResult = ReturnType<typeof useActivityReportAnswersLazyQuery_>;
export type ActivityReportAnswersSuspenseQuery_HookResult = ReturnType<typeof useActivityReportAnswersSuspenseQuery_>;
export type ActivityReportAnswersQueryResult_ = Apollo.QueryResult<ActivityReportAnswersQuery_, ActivityReportAnswersQueryVariables_>;
export function refetchActivityReportAnswersQuery_(variables: ActivityReportAnswersQueryVariables_) {
      return { query: ActivityReportAnswersDocument_, variables: variables }
    }
export const UserInvitationsDocument_ = gql`
    query UserInvitations($status: String!, $userId: uuid!) {
  invitations: CompanyInvitation(
    where: {status: {_eq: $status}, user: {id: {_eq: $userId}}}
  ) {
    id
    status
    role
  }
}
    `;

/**
 * __useUserInvitationsQuery__
 *
 * To run a query within a React component, call `useUserInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInvitationsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserInvitationsQuery(baseOptions: Apollo.QueryHookOptions<UserInvitationsQuery_, UserInvitationsQueryVariables_> & ({ variables: UserInvitationsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInvitationsQuery_, UserInvitationsQueryVariables_>(UserInvitationsDocument_, options);
      }
export function useUserInvitationsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<UserInvitationsQuery_, UserInvitationsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInvitationsQuery_, UserInvitationsQueryVariables_>(UserInvitationsDocument_, options);
        }
export function useUserInvitationsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserInvitationsQuery_, UserInvitationsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserInvitationsQuery_, UserInvitationsQueryVariables_>(UserInvitationsDocument_, options);
        }
export type UserInvitationsQueryHookResult = ReturnType<typeof useUserInvitationsQuery>;
export type UserInvitationsLazyQuery_HookResult = ReturnType<typeof useUserInvitationsLazyQuery_>;
export type UserInvitationsSuspenseQuery_HookResult = ReturnType<typeof useUserInvitationsSuspenseQuery_>;
export type UserInvitationsQueryResult_ = Apollo.QueryResult<UserInvitationsQuery_, UserInvitationsQueryVariables_>;
export function refetchUserInvitationsQuery_(variables: UserInvitationsQueryVariables_) {
      return { query: UserInvitationsDocument_, variables: variables }
    }
export const AcceptAllCompanyInvitationsDocument_ = gql`
    mutation acceptAllCompanyInvitations($companyUsers: [CompanyUser_insert_input!]!, $invitations: [CompanyInvitation_insert_input!]!) {
  joinedCompanies: insert_CompanyUser(
    objects: $companyUsers
    on_conflict: {constraint: CompanyUser_companyId_userId_10e185ba_uniq, update_columns: [role]}
  ) {
    returning {
      id
      role
      userId
      user {
        id
        companyUsers {
          id
          companyId
        }
      }
      companyId
      company {
        ...CompanyDetailsFields
      }
    }
  }
  acceptedInvitations: insert_CompanyInvitation(
    objects: $invitations
    on_conflict: {constraint: CompanyInvitation_companyId_userEmail_68f64bff_uniq, update_columns: [status]}
  ) {
    affected_rows
    returning {
      id
      status
      role
    }
  }
}
    ${CompanyDetailsFieldsFragmentDoc_}`;
export type AcceptAllCompanyInvitationsMutationFn_ = Apollo.MutationFunction<AcceptAllCompanyInvitationsMutation_, AcceptAllCompanyInvitationsMutationVariables_>;

/**
 * __useAcceptAllCompanyInvitationsMutation__
 *
 * To run a mutation, you first call `useAcceptAllCompanyInvitationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAllCompanyInvitationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAllCompanyInvitationsMutation, { data, loading, error }] = useAcceptAllCompanyInvitationsMutation({
 *   variables: {
 *      companyUsers: // value for 'companyUsers'
 *      invitations: // value for 'invitations'
 *   },
 * });
 */
export function useAcceptAllCompanyInvitationsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptAllCompanyInvitationsMutation_, AcceptAllCompanyInvitationsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptAllCompanyInvitationsMutation_, AcceptAllCompanyInvitationsMutationVariables_>(AcceptAllCompanyInvitationsDocument_, options);
      }
export type AcceptAllCompanyInvitationsMutationHookResult = ReturnType<typeof useAcceptAllCompanyInvitationsMutation>;
export type AcceptAllCompanyInvitationsMutationResult_ = Apollo.MutationResult<AcceptAllCompanyInvitationsMutation_>;
export type AcceptAllCompanyInvitationsMutationOptions_ = Apollo.BaseMutationOptions<AcceptAllCompanyInvitationsMutation_, AcceptAllCompanyInvitationsMutationVariables_>;
export const UpsertCompanyInvitationDocument_ = gql`
    mutation upsertCompanyInvitation($companyInvitation: CompanyInvitation_insert_input!) {
  insert_CompanyInvitation_one(
    object: $companyInvitation
    on_conflict: {constraint: CompanyInvitation_pkey, update_columns: [status, role]}
  ) {
    id
    company {
      id
      name
      invitations {
        id
      }
    }
    user {
      displayName
      id
    }
    status
    userEmail
    role
  }
}
    `;
export type UpsertCompanyInvitationMutationFn_ = Apollo.MutationFunction<UpsertCompanyInvitationMutation_, UpsertCompanyInvitationMutationVariables_>;

/**
 * __useUpsertCompanyInvitationMutation__
 *
 * To run a mutation, you first call `useUpsertCompanyInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCompanyInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCompanyInvitationMutation, { data, loading, error }] = useUpsertCompanyInvitationMutation({
 *   variables: {
 *      companyInvitation: // value for 'companyInvitation'
 *   },
 * });
 */
export function useUpsertCompanyInvitationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCompanyInvitationMutation_, UpsertCompanyInvitationMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCompanyInvitationMutation_, UpsertCompanyInvitationMutationVariables_>(UpsertCompanyInvitationDocument_, options);
      }
export type UpsertCompanyInvitationMutationHookResult = ReturnType<typeof useUpsertCompanyInvitationMutation>;
export type UpsertCompanyInvitationMutationResult_ = Apollo.MutationResult<UpsertCompanyInvitationMutation_>;
export type UpsertCompanyInvitationMutationOptions_ = Apollo.BaseMutationOptions<UpsertCompanyInvitationMutation_, UpsertCompanyInvitationMutationVariables_>;
export const UpdateCompanyInvitationDocument_ = gql`
    mutation updateCompanyInvitation($id: uuid!, $companyInvitation: CompanyInvitation_set_input!) {
  update_CompanyInvitation_by_pk(pk_columns: {id: $id}, _set: $companyInvitation) {
    id
    status
    role
  }
}
    `;
export type UpdateCompanyInvitationMutationFn_ = Apollo.MutationFunction<UpdateCompanyInvitationMutation_, UpdateCompanyInvitationMutationVariables_>;

/**
 * __useUpdateCompanyInvitationMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyInvitationMutation, { data, loading, error }] = useUpdateCompanyInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyInvitation: // value for 'companyInvitation'
 *   },
 * });
 */
export function useUpdateCompanyInvitationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyInvitationMutation_, UpdateCompanyInvitationMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyInvitationMutation_, UpdateCompanyInvitationMutationVariables_>(UpdateCompanyInvitationDocument_, options);
      }
export type UpdateCompanyInvitationMutationHookResult = ReturnType<typeof useUpdateCompanyInvitationMutation>;
export type UpdateCompanyInvitationMutationResult_ = Apollo.MutationResult<UpdateCompanyInvitationMutation_>;
export type UpdateCompanyInvitationMutationOptions_ = Apollo.BaseMutationOptions<UpdateCompanyInvitationMutation_, UpdateCompanyInvitationMutationVariables_>;
export const GetInvitationDocument_ = gql`
    query getInvitation($data: InvitationQuery!) {
  invitation: getInvitation(query: $data) {
    id
    userEmail
    status
    userExists
    inviteToChildCompanies
    companyId
    companyName
    companyLogoUrl
  }
}
    `;

/**
 * __useGetInvitationQuery__
 *
 * To run a query within a React component, call `useGetInvitationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitationQuery({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useGetInvitationQuery(baseOptions: Apollo.QueryHookOptions<GetInvitationQuery_, GetInvitationQueryVariables_> & ({ variables: GetInvitationQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvitationQuery_, GetInvitationQueryVariables_>(GetInvitationDocument_, options);
      }
export function useGetInvitationLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetInvitationQuery_, GetInvitationQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvitationQuery_, GetInvitationQueryVariables_>(GetInvitationDocument_, options);
        }
export function useGetInvitationSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvitationQuery_, GetInvitationQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvitationQuery_, GetInvitationQueryVariables_>(GetInvitationDocument_, options);
        }
export type GetInvitationQueryHookResult = ReturnType<typeof useGetInvitationQuery>;
export type GetInvitationLazyQuery_HookResult = ReturnType<typeof useGetInvitationLazyQuery_>;
export type GetInvitationSuspenseQuery_HookResult = ReturnType<typeof useGetInvitationSuspenseQuery_>;
export type GetInvitationQueryResult_ = Apollo.QueryResult<GetInvitationQuery_, GetInvitationQueryVariables_>;
export function refetchGetInvitationQuery_(variables: GetInvitationQueryVariables_) {
      return { query: GetInvitationDocument_, variables: variables }
    }
export const InvitationsDocument_ = gql`
    subscription invitations($userId: uuid!) {
  invitations: CompanyInvitation(
    where: {status: {_eq: "pending"}, user: {id: {_eq: $userId}}}
  ) {
    id
    status
  }
}
    `;

/**
 * __useInvitationsSubscription__
 *
 * To run a query within a React component, call `useInvitationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useInvitationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvitationsSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useInvitationsSubscription(baseOptions: Apollo.SubscriptionHookOptions<InvitationsSubscription_, InvitationsSubscriptionVariables_> & ({ variables: InvitationsSubscriptionVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<InvitationsSubscription_, InvitationsSubscriptionVariables_>(InvitationsDocument_, options);
      }
export type InvitationsSubscriptionHookResult = ReturnType<typeof useInvitationsSubscription>;
export type InvitationsSubscriptionResult_ = Apollo.SubscriptionResult<InvitationsSubscription_>;
export const ArticleByIdDocument_ = gql`
    query ArticleById($id: uuid!) {
  article: Article_by_pk(id: $id) {
    ...ArticleFields
  }
}
    ${ArticleFieldsFragmentDoc_}`;

/**
 * __useArticleByIdQuery__
 *
 * To run a query within a React component, call `useArticleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArticleByIdQuery(baseOptions: Apollo.QueryHookOptions<ArticleByIdQuery_, ArticleByIdQueryVariables_> & ({ variables: ArticleByIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleByIdQuery_, ArticleByIdQueryVariables_>(ArticleByIdDocument_, options);
      }
export function useArticleByIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ArticleByIdQuery_, ArticleByIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleByIdQuery_, ArticleByIdQueryVariables_>(ArticleByIdDocument_, options);
        }
export function useArticleByIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleByIdQuery_, ArticleByIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleByIdQuery_, ArticleByIdQueryVariables_>(ArticleByIdDocument_, options);
        }
export type ArticleByIdQueryHookResult = ReturnType<typeof useArticleByIdQuery>;
export type ArticleByIdLazyQuery_HookResult = ReturnType<typeof useArticleByIdLazyQuery_>;
export type ArticleByIdSuspenseQuery_HookResult = ReturnType<typeof useArticleByIdSuspenseQuery_>;
export type ArticleByIdQueryResult_ = Apollo.QueryResult<ArticleByIdQuery_, ArticleByIdQueryVariables_>;
export function refetchArticleByIdQuery_(variables: ArticleByIdQueryVariables_) {
      return { query: ArticleByIdDocument_, variables: variables }
    }
export const ArticlesBySlugDocument_ = gql`
    query ArticlesBySlug($slug: String!) {
  articles: Article(where: {slug: {_eq: $slug}}) {
    ...ArticleFields
  }
}
    ${ArticleFieldsFragmentDoc_}`;

/**
 * __useArticlesBySlugQuery__
 *
 * To run a query within a React component, call `useArticlesBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlesBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useArticlesBySlugQuery(baseOptions: Apollo.QueryHookOptions<ArticlesBySlugQuery_, ArticlesBySlugQueryVariables_> & ({ variables: ArticlesBySlugQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticlesBySlugQuery_, ArticlesBySlugQueryVariables_>(ArticlesBySlugDocument_, options);
      }
export function useArticlesBySlugLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ArticlesBySlugQuery_, ArticlesBySlugQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticlesBySlugQuery_, ArticlesBySlugQueryVariables_>(ArticlesBySlugDocument_, options);
        }
export function useArticlesBySlugSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticlesBySlugQuery_, ArticlesBySlugQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticlesBySlugQuery_, ArticlesBySlugQueryVariables_>(ArticlesBySlugDocument_, options);
        }
export type ArticlesBySlugQueryHookResult = ReturnType<typeof useArticlesBySlugQuery>;
export type ArticlesBySlugLazyQuery_HookResult = ReturnType<typeof useArticlesBySlugLazyQuery_>;
export type ArticlesBySlugSuspenseQuery_HookResult = ReturnType<typeof useArticlesBySlugSuspenseQuery_>;
export type ArticlesBySlugQueryResult_ = Apollo.QueryResult<ArticlesBySlugQuery_, ArticlesBySlugQueryVariables_>;
export function refetchArticlesBySlugQuery_(variables: ArticlesBySlugQueryVariables_) {
      return { query: ArticlesBySlugDocument_, variables: variables }
    }
export const TagByIdDocument_ = gql`
    query TagById($id: uuid!) {
  tag: Tag_by_pk(id: $id) {
    ...TagFields
  }
}
    ${TagFieldsFragmentDoc_}`;

/**
 * __useTagByIdQuery__
 *
 * To run a query within a React component, call `useTagByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagByIdQuery(baseOptions: Apollo.QueryHookOptions<TagByIdQuery_, TagByIdQueryVariables_> & ({ variables: TagByIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagByIdQuery_, TagByIdQueryVariables_>(TagByIdDocument_, options);
      }
export function useTagByIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<TagByIdQuery_, TagByIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagByIdQuery_, TagByIdQueryVariables_>(TagByIdDocument_, options);
        }
export function useTagByIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagByIdQuery_, TagByIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagByIdQuery_, TagByIdQueryVariables_>(TagByIdDocument_, options);
        }
export type TagByIdQueryHookResult = ReturnType<typeof useTagByIdQuery>;
export type TagByIdLazyQuery_HookResult = ReturnType<typeof useTagByIdLazyQuery_>;
export type TagByIdSuspenseQuery_HookResult = ReturnType<typeof useTagByIdSuspenseQuery_>;
export type TagByIdQueryResult_ = Apollo.QueryResult<TagByIdQuery_, TagByIdQueryVariables_>;
export function refetchTagByIdQuery_(variables: TagByIdQueryVariables_) {
      return { query: TagByIdDocument_, variables: variables }
    }
export const ArticlesByTagIdDocument_ = gql`
    query ArticlesByTagId($tagId: uuid!) {
  articles: Tag_articles(where: {tag_id: {_eq: $tagId}}) {
    article_id
  }
}
    `;

/**
 * __useArticlesByTagIdQuery__
 *
 * To run a query within a React component, call `useArticlesByTagIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesByTagIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlesByTagIdQuery({
 *   variables: {
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useArticlesByTagIdQuery(baseOptions: Apollo.QueryHookOptions<ArticlesByTagIdQuery_, ArticlesByTagIdQueryVariables_> & ({ variables: ArticlesByTagIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticlesByTagIdQuery_, ArticlesByTagIdQueryVariables_>(ArticlesByTagIdDocument_, options);
      }
export function useArticlesByTagIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ArticlesByTagIdQuery_, ArticlesByTagIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticlesByTagIdQuery_, ArticlesByTagIdQueryVariables_>(ArticlesByTagIdDocument_, options);
        }
export function useArticlesByTagIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticlesByTagIdQuery_, ArticlesByTagIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticlesByTagIdQuery_, ArticlesByTagIdQueryVariables_>(ArticlesByTagIdDocument_, options);
        }
export type ArticlesByTagIdQueryHookResult = ReturnType<typeof useArticlesByTagIdQuery>;
export type ArticlesByTagIdLazyQuery_HookResult = ReturnType<typeof useArticlesByTagIdLazyQuery_>;
export type ArticlesByTagIdSuspenseQuery_HookResult = ReturnType<typeof useArticlesByTagIdSuspenseQuery_>;
export type ArticlesByTagIdQueryResult_ = Apollo.QueryResult<ArticlesByTagIdQuery_, ArticlesByTagIdQueryVariables_>;
export function refetchArticlesByTagIdQuery_(variables: ArticlesByTagIdQueryVariables_) {
      return { query: ArticlesByTagIdDocument_, variables: variables }
    }
export const TagsByArticleIdDocument_ = gql`
    query TagsByArticleId($articleId: uuid!) {
  tags: Tag_articles(where: {article_id: {_eq: $articleId}}) {
    tag_id
  }
}
    `;

/**
 * __useTagsByArticleIdQuery__
 *
 * To run a query within a React component, call `useTagsByArticleIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsByArticleIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsByArticleIdQuery({
 *   variables: {
 *      articleId: // value for 'articleId'
 *   },
 * });
 */
export function useTagsByArticleIdQuery(baseOptions: Apollo.QueryHookOptions<TagsByArticleIdQuery_, TagsByArticleIdQueryVariables_> & ({ variables: TagsByArticleIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsByArticleIdQuery_, TagsByArticleIdQueryVariables_>(TagsByArticleIdDocument_, options);
      }
export function useTagsByArticleIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<TagsByArticleIdQuery_, TagsByArticleIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsByArticleIdQuery_, TagsByArticleIdQueryVariables_>(TagsByArticleIdDocument_, options);
        }
export function useTagsByArticleIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagsByArticleIdQuery_, TagsByArticleIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagsByArticleIdQuery_, TagsByArticleIdQueryVariables_>(TagsByArticleIdDocument_, options);
        }
export type TagsByArticleIdQueryHookResult = ReturnType<typeof useTagsByArticleIdQuery>;
export type TagsByArticleIdLazyQuery_HookResult = ReturnType<typeof useTagsByArticleIdLazyQuery_>;
export type TagsByArticleIdSuspenseQuery_HookResult = ReturnType<typeof useTagsByArticleIdSuspenseQuery_>;
export type TagsByArticleIdQueryResult_ = Apollo.QueryResult<TagsByArticleIdQuery_, TagsByArticleIdQueryVariables_>;
export function refetchTagsByArticleIdQuery_(variables: TagsByArticleIdQueryVariables_) {
      return { query: TagsByArticleIdDocument_, variables: variables }
    }
export const ArticlesDocument_ = gql`
    query Articles {
  Article {
    ...ArticleFields
  }
}
    ${ArticleFieldsFragmentDoc_}`;

/**
 * __useArticlesQuery__
 *
 * To run a query within a React component, call `useArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useArticlesQuery(baseOptions?: Apollo.QueryHookOptions<ArticlesQuery_, ArticlesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticlesQuery_, ArticlesQueryVariables_>(ArticlesDocument_, options);
      }
export function useArticlesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ArticlesQuery_, ArticlesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticlesQuery_, ArticlesQueryVariables_>(ArticlesDocument_, options);
        }
export function useArticlesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticlesQuery_, ArticlesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticlesQuery_, ArticlesQueryVariables_>(ArticlesDocument_, options);
        }
export type ArticlesQueryHookResult = ReturnType<typeof useArticlesQuery>;
export type ArticlesLazyQuery_HookResult = ReturnType<typeof useArticlesLazyQuery_>;
export type ArticlesSuspenseQuery_HookResult = ReturnType<typeof useArticlesSuspenseQuery_>;
export type ArticlesQueryResult_ = Apollo.QueryResult<ArticlesQuery_, ArticlesQueryVariables_>;
export function refetchArticlesQuery_(variables?: ArticlesQueryVariables_) {
      return { query: ArticlesDocument_, variables: variables }
    }
export const TagsDocument_ = gql`
    query Tags {
  Tag {
    ...TagFields
  }
}
    ${TagFieldsFragmentDoc_}`;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery_, TagsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery_, TagsQueryVariables_>(TagsDocument_, options);
      }
export function useTagsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery_, TagsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery_, TagsQueryVariables_>(TagsDocument_, options);
        }
export function useTagsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagsQuery_, TagsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagsQuery_, TagsQueryVariables_>(TagsDocument_, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQuery_HookResult = ReturnType<typeof useTagsLazyQuery_>;
export type TagsSuspenseQuery_HookResult = ReturnType<typeof useTagsSuspenseQuery_>;
export type TagsQueryResult_ = Apollo.QueryResult<TagsQuery_, TagsQueryVariables_>;
export function refetchTagsQuery_(variables?: TagsQueryVariables_) {
      return { query: TagsDocument_, variables: variables }
    }
export const ArticleBodySearchDocument_ = gql`
    query ArticleBodySearch($q: String!) {
  Article(where: {body: {_ilike: $q}}) {
    ...ArticleFields
  }
}
    ${ArticleFieldsFragmentDoc_}`;

/**
 * __useArticleBodySearchQuery__
 *
 * To run a query within a React component, call `useArticleBodySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleBodySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleBodySearchQuery({
 *   variables: {
 *      q: // value for 'q'
 *   },
 * });
 */
export function useArticleBodySearchQuery(baseOptions: Apollo.QueryHookOptions<ArticleBodySearchQuery_, ArticleBodySearchQueryVariables_> & ({ variables: ArticleBodySearchQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleBodySearchQuery_, ArticleBodySearchQueryVariables_>(ArticleBodySearchDocument_, options);
      }
export function useArticleBodySearchLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ArticleBodySearchQuery_, ArticleBodySearchQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleBodySearchQuery_, ArticleBodySearchQueryVariables_>(ArticleBodySearchDocument_, options);
        }
export function useArticleBodySearchSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleBodySearchQuery_, ArticleBodySearchQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleBodySearchQuery_, ArticleBodySearchQueryVariables_>(ArticleBodySearchDocument_, options);
        }
export type ArticleBodySearchQueryHookResult = ReturnType<typeof useArticleBodySearchQuery>;
export type ArticleBodySearchLazyQuery_HookResult = ReturnType<typeof useArticleBodySearchLazyQuery_>;
export type ArticleBodySearchSuspenseQuery_HookResult = ReturnType<typeof useArticleBodySearchSuspenseQuery_>;
export type ArticleBodySearchQueryResult_ = Apollo.QueryResult<ArticleBodySearchQuery_, ArticleBodySearchQueryVariables_>;
export function refetchArticleBodySearchQuery_(variables: ArticleBodySearchQueryVariables_) {
      return { query: ArticleBodySearchDocument_, variables: variables }
    }
export const ArticleTitleSearchDocument_ = gql`
    query ArticleTitleSearch($q: String!) {
  Article(where: {title: {_ilike: $q}}) {
    ...ArticleFields
  }
}
    ${ArticleFieldsFragmentDoc_}`;

/**
 * __useArticleTitleSearchQuery__
 *
 * To run a query within a React component, call `useArticleTitleSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleTitleSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleTitleSearchQuery({
 *   variables: {
 *      q: // value for 'q'
 *   },
 * });
 */
export function useArticleTitleSearchQuery(baseOptions: Apollo.QueryHookOptions<ArticleTitleSearchQuery_, ArticleTitleSearchQueryVariables_> & ({ variables: ArticleTitleSearchQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleTitleSearchQuery_, ArticleTitleSearchQueryVariables_>(ArticleTitleSearchDocument_, options);
      }
export function useArticleTitleSearchLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ArticleTitleSearchQuery_, ArticleTitleSearchQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleTitleSearchQuery_, ArticleTitleSearchQueryVariables_>(ArticleTitleSearchDocument_, options);
        }
export function useArticleTitleSearchSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ArticleTitleSearchQuery_, ArticleTitleSearchQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ArticleTitleSearchQuery_, ArticleTitleSearchQueryVariables_>(ArticleTitleSearchDocument_, options);
        }
export type ArticleTitleSearchQueryHookResult = ReturnType<typeof useArticleTitleSearchQuery>;
export type ArticleTitleSearchLazyQuery_HookResult = ReturnType<typeof useArticleTitleSearchLazyQuery_>;
export type ArticleTitleSearchSuspenseQuery_HookResult = ReturnType<typeof useArticleTitleSearchSuspenseQuery_>;
export type ArticleTitleSearchQueryResult_ = Apollo.QueryResult<ArticleTitleSearchQuery_, ArticleTitleSearchQueryVariables_>;
export function refetchArticleTitleSearchQuery_(variables: ArticleTitleSearchQueryVariables_) {
      return { query: ArticleTitleSearchDocument_, variables: variables }
    }
export const TagGroupsDocument_ = gql`
    query TagGroups {
  TagGroup {
    ...TagGroupFields
  }
}
    ${TagGroupFieldsFragmentDoc_}`;

/**
 * __useTagGroupsQuery__
 *
 * To run a query within a React component, call `useTagGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagGroupsQuery(baseOptions?: Apollo.QueryHookOptions<TagGroupsQuery_, TagGroupsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagGroupsQuery_, TagGroupsQueryVariables_>(TagGroupsDocument_, options);
      }
export function useTagGroupsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<TagGroupsQuery_, TagGroupsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagGroupsQuery_, TagGroupsQueryVariables_>(TagGroupsDocument_, options);
        }
export function useTagGroupsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagGroupsQuery_, TagGroupsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagGroupsQuery_, TagGroupsQueryVariables_>(TagGroupsDocument_, options);
        }
export type TagGroupsQueryHookResult = ReturnType<typeof useTagGroupsQuery>;
export type TagGroupsLazyQuery_HookResult = ReturnType<typeof useTagGroupsLazyQuery_>;
export type TagGroupsSuspenseQuery_HookResult = ReturnType<typeof useTagGroupsSuspenseQuery_>;
export type TagGroupsQueryResult_ = Apollo.QueryResult<TagGroupsQuery_, TagGroupsQueryVariables_>;
export function refetchTagGroupsQuery_(variables?: TagGroupsQueryVariables_) {
      return { query: TagGroupsDocument_, variables: variables }
    }
export const TagsWithArticlesDocument_ = gql`
    query TagsWithArticles {
  Tag {
    ...TagFields
    articles: Tag_articles {
      Article {
        ...ArticleFields
      }
    }
  }
}
    ${TagFieldsFragmentDoc_}
${ArticleFieldsFragmentDoc_}`;

/**
 * __useTagsWithArticlesQuery__
 *
 * To run a query within a React component, call `useTagsWithArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsWithArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsWithArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsWithArticlesQuery(baseOptions?: Apollo.QueryHookOptions<TagsWithArticlesQuery_, TagsWithArticlesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsWithArticlesQuery_, TagsWithArticlesQueryVariables_>(TagsWithArticlesDocument_, options);
      }
export function useTagsWithArticlesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<TagsWithArticlesQuery_, TagsWithArticlesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsWithArticlesQuery_, TagsWithArticlesQueryVariables_>(TagsWithArticlesDocument_, options);
        }
export function useTagsWithArticlesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TagsWithArticlesQuery_, TagsWithArticlesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TagsWithArticlesQuery_, TagsWithArticlesQueryVariables_>(TagsWithArticlesDocument_, options);
        }
export type TagsWithArticlesQueryHookResult = ReturnType<typeof useTagsWithArticlesQuery>;
export type TagsWithArticlesLazyQuery_HookResult = ReturnType<typeof useTagsWithArticlesLazyQuery_>;
export type TagsWithArticlesSuspenseQuery_HookResult = ReturnType<typeof useTagsWithArticlesSuspenseQuery_>;
export type TagsWithArticlesQueryResult_ = Apollo.QueryResult<TagsWithArticlesQuery_, TagsWithArticlesQueryVariables_>;
export function refetchTagsWithArticlesQuery_(variables?: TagsWithArticlesQueryVariables_) {
      return { query: TagsWithArticlesDocument_, variables: variables }
    }
export const ReadUserNotificationsDocument_ = gql`
    mutation readUserNotifications($ids: [uuid!]!, $isRead: Boolean!) {
  update_UserNotification_many(
    updates: {where: {id: {_in: $ids}}, _set: {isRead: $isRead}}
  ) {
    returning {
      id
      isRead
    }
  }
}
    `;
export type ReadUserNotificationsMutationFn_ = Apollo.MutationFunction<ReadUserNotificationsMutation_, ReadUserNotificationsMutationVariables_>;

/**
 * __useReadUserNotificationsMutation__
 *
 * To run a mutation, you first call `useReadUserNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadUserNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readUserNotificationsMutation, { data, loading, error }] = useReadUserNotificationsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      isRead: // value for 'isRead'
 *   },
 * });
 */
export function useReadUserNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ReadUserNotificationsMutation_, ReadUserNotificationsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadUserNotificationsMutation_, ReadUserNotificationsMutationVariables_>(ReadUserNotificationsDocument_, options);
      }
export type ReadUserNotificationsMutationHookResult = ReturnType<typeof useReadUserNotificationsMutation>;
export type ReadUserNotificationsMutationResult_ = Apollo.MutationResult<ReadUserNotificationsMutation_>;
export type ReadUserNotificationsMutationOptions_ = Apollo.BaseMutationOptions<ReadUserNotificationsMutation_, ReadUserNotificationsMutationVariables_>;
export const NotificationsDocument_ = gql`
    subscription notifications {
  notifications: UserNotification(
    where: {comment: {thread: {_or: [{answer: {activityReport: {bAssessment: {cAssessment: {deletedAt: {_is_null: true}}}}}, esrsDatapointId: {_is_null: true}, esrsDatapointMdrmId: {_is_null: true}}, {esrsDatapoint: {answer: {reportingUnit: {esrsAssessment: {deletedAt: {_is_null: true}}}}}, answerId: {_is_null: true}, esrsDatapointMdrmId: {_is_null: true}}, {esrsDatapointMdrm: {datapoint: {answer: {reportingUnit: {esrsAssessment: {deletedAt: {_is_null: true}}}}}}, answerId: {_is_null: true}, esrsDatapointId: {_is_null: true}}]}, deletedAt: {_is_null: true}}}
  ) {
    ...NotificationFields
  }
}
    ${NotificationFieldsFragmentDoc_}`;

/**
 * __useNotificationsSubscription__
 *
 * To run a query within a React component, call `useNotificationsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<NotificationsSubscription_, NotificationsSubscriptionVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<NotificationsSubscription_, NotificationsSubscriptionVariables_>(NotificationsDocument_, options);
      }
export type NotificationsSubscriptionHookResult = ReturnType<typeof useNotificationsSubscription>;
export type NotificationsSubscriptionResult_ = Apollo.SubscriptionResult<NotificationsSubscription_>;
export const UnreadUnsentUserNotificationsDocument_ = gql`
    query unreadUnsentUserNotifications($sentEmailsNotificationIds: [uuid!]) {
  UserNotifications: UserNotification(
    where: {_and: {isRead: {_eq: false}, emailSentAt: {_is_null: true}, id: {_nin: $sentEmailsNotificationIds}}}
  ) {
    id
    createdAt
    user {
      id
      createdAt
      displayName
      email
      metadata
    }
    comment {
      data
      createdAt
      author {
        displayName
        avatarUrl
      }
      thread {
        company {
          id
          name
          logoUrl
        }
        answer {
          question {
            title
          }
          activityReport {
            bAssessment {
              businessUnit {
                id
                name
              }
              cAssessment {
                id
                aggregate {
                  title
                }
                company {
                  id
                  name
                }
              }
            }
            activity {
              name
            }
          }
        }
        esrsDatapoint {
          answer {
            metric {
              title
              shortTitle
              requirement {
                title
                reference
              }
            }
            esrsAssessment {
              id
              reportingYear
              company {
                id
                name
              }
            }
          }
        }
        esrsDatapointMdrm {
          mdrmRef
          datapoint {
            answer {
              metric {
                shortTitle
                title
                requirement {
                  title
                  reference
                }
              }
              esrsAssessment {
                id
                reportingYear
                company {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
  UserNotification_aggregate(
    where: {_and: {isRead: {_eq: false}, emailSentAt: {_is_null: true}}}
  ) {
    aggregate {
      count
    }
  }
}
    `;

/**
 * __useUnreadUnsentUserNotificationsQuery__
 *
 * To run a query within a React component, call `useUnreadUnsentUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadUnsentUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadUnsentUserNotificationsQuery({
 *   variables: {
 *      sentEmailsNotificationIds: // value for 'sentEmailsNotificationIds'
 *   },
 * });
 */
export function useUnreadUnsentUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<UnreadUnsentUserNotificationsQuery_, UnreadUnsentUserNotificationsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnreadUnsentUserNotificationsQuery_, UnreadUnsentUserNotificationsQueryVariables_>(UnreadUnsentUserNotificationsDocument_, options);
      }
export function useUnreadUnsentUserNotificationsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<UnreadUnsentUserNotificationsQuery_, UnreadUnsentUserNotificationsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnreadUnsentUserNotificationsQuery_, UnreadUnsentUserNotificationsQueryVariables_>(UnreadUnsentUserNotificationsDocument_, options);
        }
export function useUnreadUnsentUserNotificationsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UnreadUnsentUserNotificationsQuery_, UnreadUnsentUserNotificationsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UnreadUnsentUserNotificationsQuery_, UnreadUnsentUserNotificationsQueryVariables_>(UnreadUnsentUserNotificationsDocument_, options);
        }
export type UnreadUnsentUserNotificationsQueryHookResult = ReturnType<typeof useUnreadUnsentUserNotificationsQuery>;
export type UnreadUnsentUserNotificationsLazyQuery_HookResult = ReturnType<typeof useUnreadUnsentUserNotificationsLazyQuery_>;
export type UnreadUnsentUserNotificationsSuspenseQuery_HookResult = ReturnType<typeof useUnreadUnsentUserNotificationsSuspenseQuery_>;
export type UnreadUnsentUserNotificationsQueryResult_ = Apollo.QueryResult<UnreadUnsentUserNotificationsQuery_, UnreadUnsentUserNotificationsQueryVariables_>;
export function refetchUnreadUnsentUserNotificationsQuery_(variables?: UnreadUnsentUserNotificationsQueryVariables_) {
      return { query: UnreadUnsentUserNotificationsDocument_, variables: variables }
    }
export const UpsertUserNotificationEmailsSentDocument_ = gql`
    mutation upsertUserNotificationEmailsSent($ids: [uuid!]!) {
  update_UserNotification_many(
    updates: {where: {id: {_in: $ids}}, _set: {emailSentAt: "now()"}}
  ) {
    returning {
      id
      emailSentAt
    }
  }
}
    `;
export type UpsertUserNotificationEmailsSentMutationFn_ = Apollo.MutationFunction<UpsertUserNotificationEmailsSentMutation_, UpsertUserNotificationEmailsSentMutationVariables_>;

/**
 * __useUpsertUserNotificationEmailsSentMutation__
 *
 * To run a mutation, you first call `useUpsertUserNotificationEmailsSentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserNotificationEmailsSentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserNotificationEmailsSentMutation, { data, loading, error }] = useUpsertUserNotificationEmailsSentMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUpsertUserNotificationEmailsSentMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserNotificationEmailsSentMutation_, UpsertUserNotificationEmailsSentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserNotificationEmailsSentMutation_, UpsertUserNotificationEmailsSentMutationVariables_>(UpsertUserNotificationEmailsSentDocument_, options);
      }
export type UpsertUserNotificationEmailsSentMutationHookResult = ReturnType<typeof useUpsertUserNotificationEmailsSentMutation>;
export type UpsertUserNotificationEmailsSentMutationResult_ = Apollo.MutationResult<UpsertUserNotificationEmailsSentMutation_>;
export type UpsertUserNotificationEmailsSentMutationOptions_ = Apollo.BaseMutationOptions<UpsertUserNotificationEmailsSentMutation_, UpsertUserNotificationEmailsSentMutationVariables_>;
export const GetMaintainanceStatusDocument_ = gql`
    subscription getMaintainanceStatus {
  AppConfig_by_pk(id: true) {
    mergeInProgress
  }
}
    `;

/**
 * __useGetMaintainanceStatusSubscription__
 *
 * To run a query within a React component, call `useGetMaintainanceStatusSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetMaintainanceStatusSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaintainanceStatusSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetMaintainanceStatusSubscription(baseOptions?: Apollo.SubscriptionHookOptions<GetMaintainanceStatusSubscription_, GetMaintainanceStatusSubscriptionVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetMaintainanceStatusSubscription_, GetMaintainanceStatusSubscriptionVariables_>(GetMaintainanceStatusDocument_, options);
      }
export type GetMaintainanceStatusSubscriptionHookResult = ReturnType<typeof useGetMaintainanceStatusSubscription>;
export type GetMaintainanceStatusSubscriptionResult_ = Apollo.SubscriptionResult<GetMaintainanceStatusSubscription_>;
export const PaiReportRequestsDocument_ = gql`
    query paiReportRequests($companyId: uuid!) {
  paiReportRequests: PaiPortfolioReport(
    where: {portfolio: {portfolioCompanies: {companyId: {_eq: $companyId}}}, selectedIndicators: {_or: [{isForAllCompanies: {_eq: true}}, {paiReportIndicatorPortfolioCompanies: {portfolioCompany: {companyId: {_eq: $companyId}}}}]}}
  ) {
    id
    portfolio {
      id
      name
      ownerCompany {
        name
      }
      companyMemberships: portfolioCompanies(where: {companyId: {_eq: $companyId}}) {
        year
        valueOfInvestments
        sharedPaiCompanyReportId
        sharedPaiCompanyReportQ1Id
        sharedPaiCompanyReportQ2Id
        sharedPaiCompanyReportQ3Id
        sharedPaiCompanyReportQ4Id
      }
    }
    dueDates
    sendOutDates
    year
    selectedIndicators(
      where: {_or: [{isForAllCompanies: {_eq: true}}, {paiReportIndicatorPortfolioCompanies: {portfolioCompany: {companyId: {_eq: $companyId}}}}]}
    ) {
      indicator {
        ...PaiIndicatorFields
      }
      isForAllCompanies
      paiReportIndicatorPortfolioCompanies {
        portfolioCompany {
          companyId
        }
      }
      periods
      isNew
    }
    updatedAt
  }
}
    ${PaiIndicatorFieldsFragmentDoc_}`;

/**
 * __usePaiReportRequestsQuery__
 *
 * To run a query within a React component, call `usePaiReportRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaiReportRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaiReportRequestsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function usePaiReportRequestsQuery(baseOptions: Apollo.QueryHookOptions<PaiReportRequestsQuery_, PaiReportRequestsQueryVariables_> & ({ variables: PaiReportRequestsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaiReportRequestsQuery_, PaiReportRequestsQueryVariables_>(PaiReportRequestsDocument_, options);
      }
export function usePaiReportRequestsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<PaiReportRequestsQuery_, PaiReportRequestsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaiReportRequestsQuery_, PaiReportRequestsQueryVariables_>(PaiReportRequestsDocument_, options);
        }
export function usePaiReportRequestsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaiReportRequestsQuery_, PaiReportRequestsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaiReportRequestsQuery_, PaiReportRequestsQueryVariables_>(PaiReportRequestsDocument_, options);
        }
export type PaiReportRequestsQueryHookResult = ReturnType<typeof usePaiReportRequestsQuery>;
export type PaiReportRequestsLazyQuery_HookResult = ReturnType<typeof usePaiReportRequestsLazyQuery_>;
export type PaiReportRequestsSuspenseQuery_HookResult = ReturnType<typeof usePaiReportRequestsSuspenseQuery_>;
export type PaiReportRequestsQueryResult_ = Apollo.QueryResult<PaiReportRequestsQuery_, PaiReportRequestsQueryVariables_>;
export function refetchPaiReportRequestsQuery_(variables: PaiReportRequestsQueryVariables_) {
      return { query: PaiReportRequestsDocument_, variables: variables }
    }
export const PaiReportRequestsV2Document_ = gql`
    query paiReportRequestsV2($companyId: uuid!) {
  paiReportRequests: PaiPortfolioReport(
    where: {portfolio: {portfolioCompanies: {companyId: {_eq: $companyId}}}, selectedIndicators: {_or: [{isForAllCompanies: {_eq: true}}, {paiReportIndicatorPortfolioCompanies: {portfolioCompany: {companyId: {_eq: $companyId}}}}]}}
  ) {
    id
    portfolio {
      id
      name
      ownerCompany {
        name
      }
      companyMemberships: portfolioCompanies(where: {companyId: {_eq: $companyId}}) {
        year
        valueOfInvestments
        sharedPaiCompanyReportId
        sharedPaiCompanyReportQ1Id
        sharedPaiCompanyReportQ2Id
        sharedPaiCompanyReportQ3Id
        sharedPaiCompanyReportQ4Id
      }
    }
    dueDates
    sendOutDates
    year
    selectedIndicators(
      where: {_or: [{isForAllCompanies: {_eq: true}}, {paiReportIndicatorPortfolioCompanies: {portfolioCompany: {companyId: {_eq: $companyId}}}}]}
    ) {
      indicator {
        ...PaiIndicatorFieldsV2
      }
      isForAllCompanies
      paiReportIndicatorPortfolioCompanies {
        portfolioCompany {
          companyId
        }
      }
      periods
      isNew
    }
    updatedAt
  }
}
    ${PaiIndicatorFieldsV2FragmentDoc_}`;

/**
 * __usePaiReportRequestsV2Query__
 *
 * To run a query within a React component, call `usePaiReportRequestsV2Query` and pass it any options that fit your needs.
 * When your component renders, `usePaiReportRequestsV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaiReportRequestsV2Query({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function usePaiReportRequestsV2Query(baseOptions: Apollo.QueryHookOptions<PaiReportRequestsV2Query_, PaiReportRequestsV2QueryVariables_> & ({ variables: PaiReportRequestsV2QueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaiReportRequestsV2Query_, PaiReportRequestsV2QueryVariables_>(PaiReportRequestsV2Document_, options);
      }
export function usePaiReportRequestsV2LazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<PaiReportRequestsV2Query_, PaiReportRequestsV2QueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaiReportRequestsV2Query_, PaiReportRequestsV2QueryVariables_>(PaiReportRequestsV2Document_, options);
        }
export function usePaiReportRequestsV2SuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaiReportRequestsV2Query_, PaiReportRequestsV2QueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaiReportRequestsV2Query_, PaiReportRequestsV2QueryVariables_>(PaiReportRequestsV2Document_, options);
        }
export type PaiReportRequestsV2QueryHookResult = ReturnType<typeof usePaiReportRequestsV2Query>;
export type PaiReportRequestsV2LazyQuery_HookResult = ReturnType<typeof usePaiReportRequestsV2LazyQuery_>;
export type PaiReportRequestsV2SuspenseQuery_HookResult = ReturnType<typeof usePaiReportRequestsV2SuspenseQuery_>;
export type PaiReportRequestsV2QueryResult_ = Apollo.QueryResult<PaiReportRequestsV2Query_, PaiReportRequestsV2QueryVariables_>;
export function refetchPaiReportRequestsV2Query_(variables: PaiReportRequestsV2QueryVariables_) {
      return { query: PaiReportRequestsV2Document_, variables: variables }
    }
export const HasPaiRequestsDocument_ = gql`
    subscription hasPaiRequests($companyId: uuid!) {
  paiReportRequests: PaiPortfolioReport(
    where: {portfolio: {portfolioCompanies: {companyId: {_eq: $companyId}}}}
  ) {
    id
    portfolio {
      id
      name
      ownerCompany {
        name
      }
    }
  }
}
    `;

/**
 * __useHasPaiRequestsSubscription__
 *
 * To run a query within a React component, call `useHasPaiRequestsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHasPaiRequestsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasPaiRequestsSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useHasPaiRequestsSubscription(baseOptions: Apollo.SubscriptionHookOptions<HasPaiRequestsSubscription_, HasPaiRequestsSubscriptionVariables_> & ({ variables: HasPaiRequestsSubscriptionVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<HasPaiRequestsSubscription_, HasPaiRequestsSubscriptionVariables_>(HasPaiRequestsDocument_, options);
      }
export type HasPaiRequestsSubscriptionHookResult = ReturnType<typeof useHasPaiRequestsSubscription>;
export type HasPaiRequestsSubscriptionResult_ = Apollo.SubscriptionResult<HasPaiRequestsSubscription_>;
export const PaiCompanyReportsDocument_ = gql`
    query paiCompanyReports($companyId: uuid!) {
  paiCompanyReports: PaiCompanyReport(where: {companyId: {_eq: $companyId}}) {
    id
    reportingPeriod
    contactPersonId
    year
    period
    lastEditedAnswer: answers(limit: 1, order_by: {updatedAt: asc}) {
      updatedAt
    }
    updatedAt
  }
}
    `;

/**
 * __usePaiCompanyReportsQuery__
 *
 * To run a query within a React component, call `usePaiCompanyReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaiCompanyReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaiCompanyReportsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function usePaiCompanyReportsQuery(baseOptions: Apollo.QueryHookOptions<PaiCompanyReportsQuery_, PaiCompanyReportsQueryVariables_> & ({ variables: PaiCompanyReportsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaiCompanyReportsQuery_, PaiCompanyReportsQueryVariables_>(PaiCompanyReportsDocument_, options);
      }
export function usePaiCompanyReportsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<PaiCompanyReportsQuery_, PaiCompanyReportsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaiCompanyReportsQuery_, PaiCompanyReportsQueryVariables_>(PaiCompanyReportsDocument_, options);
        }
export function usePaiCompanyReportsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaiCompanyReportsQuery_, PaiCompanyReportsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaiCompanyReportsQuery_, PaiCompanyReportsQueryVariables_>(PaiCompanyReportsDocument_, options);
        }
export type PaiCompanyReportsQueryHookResult = ReturnType<typeof usePaiCompanyReportsQuery>;
export type PaiCompanyReportsLazyQuery_HookResult = ReturnType<typeof usePaiCompanyReportsLazyQuery_>;
export type PaiCompanyReportsSuspenseQuery_HookResult = ReturnType<typeof usePaiCompanyReportsSuspenseQuery_>;
export type PaiCompanyReportsQueryResult_ = Apollo.QueryResult<PaiCompanyReportsQuery_, PaiCompanyReportsQueryVariables_>;
export function refetchPaiCompanyReportsQuery_(variables: PaiCompanyReportsQueryVariables_) {
      return { query: PaiCompanyReportsDocument_, variables: variables }
    }
export const PortfoliosWithAccessToReportDocument_ = gql`
    query PortfoliosWithAccessToReport($reportId: uuid!, $companyId: uuid!, $year: Int!) {
  Portfolio(
    where: {portfolioCompanies: {_or: [{sharedPaiCompanyReportId: {_eq: $reportId}}, {sharedPaiCompanyReportQ1Id: {_eq: $reportId}}, {sharedPaiCompanyReportQ2Id: {_eq: $reportId}}, {sharedPaiCompanyReportQ3Id: {_eq: $reportId}}, {sharedPaiCompanyReportQ4Id: {_eq: $reportId}}]}}
  ) {
    ownerCompany {
      name
    }
    companies: portfolioCompanies(
      where: {companyId: {_eq: $companyId}, year: {_eq: $year}}
    ) {
      id
      sharedPaiCompanyReportId
      sharedPaiCompanyReportQ1Id
      sharedPaiCompanyReportQ2Id
      sharedPaiCompanyReportQ3Id
      sharedPaiCompanyReportQ4Id
    }
    name
    id
  }
}
    `;

/**
 * __usePortfoliosWithAccessToReportQuery__
 *
 * To run a query within a React component, call `usePortfoliosWithAccessToReportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfoliosWithAccessToReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfoliosWithAccessToReportQuery({
 *   variables: {
 *      reportId: // value for 'reportId'
 *      companyId: // value for 'companyId'
 *      year: // value for 'year'
 *   },
 * });
 */
export function usePortfoliosWithAccessToReportQuery(baseOptions: Apollo.QueryHookOptions<PortfoliosWithAccessToReportQuery_, PortfoliosWithAccessToReportQueryVariables_> & ({ variables: PortfoliosWithAccessToReportQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortfoliosWithAccessToReportQuery_, PortfoliosWithAccessToReportQueryVariables_>(PortfoliosWithAccessToReportDocument_, options);
      }
export function usePortfoliosWithAccessToReportLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<PortfoliosWithAccessToReportQuery_, PortfoliosWithAccessToReportQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortfoliosWithAccessToReportQuery_, PortfoliosWithAccessToReportQueryVariables_>(PortfoliosWithAccessToReportDocument_, options);
        }
export function usePortfoliosWithAccessToReportSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortfoliosWithAccessToReportQuery_, PortfoliosWithAccessToReportQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortfoliosWithAccessToReportQuery_, PortfoliosWithAccessToReportQueryVariables_>(PortfoliosWithAccessToReportDocument_, options);
        }
export type PortfoliosWithAccessToReportQueryHookResult = ReturnType<typeof usePortfoliosWithAccessToReportQuery>;
export type PortfoliosWithAccessToReportLazyQuery_HookResult = ReturnType<typeof usePortfoliosWithAccessToReportLazyQuery_>;
export type PortfoliosWithAccessToReportSuspenseQuery_HookResult = ReturnType<typeof usePortfoliosWithAccessToReportSuspenseQuery_>;
export type PortfoliosWithAccessToReportQueryResult_ = Apollo.QueryResult<PortfoliosWithAccessToReportQuery_, PortfoliosWithAccessToReportQueryVariables_>;
export function refetchPortfoliosWithAccessToReportQuery_(variables: PortfoliosWithAccessToReportQueryVariables_) {
      return { query: PortfoliosWithAccessToReportDocument_, variables: variables }
    }
export const ReportInsightsDocument_ = gql`
    subscription ReportInsights($reportId: uuid!) {
  insights: PaiMetricInsight(where: {reportId: {_eq: $reportId}}) {
    investeeMetricRef
    insight {
      insight
      extractionJob {
        documentationFile {
          id
          storageFile {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useReportInsightsSubscription__
 *
 * To run a query within a React component, call `useReportInsightsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useReportInsightsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportInsightsSubscription({
 *   variables: {
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useReportInsightsSubscription(baseOptions: Apollo.SubscriptionHookOptions<ReportInsightsSubscription_, ReportInsightsSubscriptionVariables_> & ({ variables: ReportInsightsSubscriptionVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ReportInsightsSubscription_, ReportInsightsSubscriptionVariables_>(ReportInsightsDocument_, options);
      }
export type ReportInsightsSubscriptionHookResult = ReturnType<typeof useReportInsightsSubscription>;
export type ReportInsightsSubscriptionResult_ = Apollo.SubscriptionResult<ReportInsightsSubscription_>;
export const AttachPaiDocumentDocument_ = gql`
    mutation AttachPaiDocument($documentId: uuid!, $paiAnswerId: uuid!) {
  insert_Attachment(
    objects: {fileId: $documentId, attachmentBox: {data: {paiAnswerId: $paiAnswerId}, on_conflict: {constraint: AttachmentBox_paiAnswerId_key, update_columns: [paiAnswerId]}}}
  ) {
    returning {
      attachmentBox {
        paiAnswerId
      }
      file {
        id
      }
    }
  }
}
    `;
export type AttachPaiDocumentMutationFn_ = Apollo.MutationFunction<AttachPaiDocumentMutation_, AttachPaiDocumentMutationVariables_>;

/**
 * __useAttachPaiDocumentMutation__
 *
 * To run a mutation, you first call `useAttachPaiDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAttachPaiDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [attachPaiDocumentMutation, { data, loading, error }] = useAttachPaiDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      paiAnswerId: // value for 'paiAnswerId'
 *   },
 * });
 */
export function useAttachPaiDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AttachPaiDocumentMutation_, AttachPaiDocumentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AttachPaiDocumentMutation_, AttachPaiDocumentMutationVariables_>(AttachPaiDocumentDocument_, options);
      }
export type AttachPaiDocumentMutationHookResult = ReturnType<typeof useAttachPaiDocumentMutation>;
export type AttachPaiDocumentMutationResult_ = Apollo.MutationResult<AttachPaiDocumentMutation_>;
export type AttachPaiDocumentMutationOptions_ = Apollo.BaseMutationOptions<AttachPaiDocumentMutation_, AttachPaiDocumentMutationVariables_>;
export const AllPaiReportAnswersDocument_ = gql`
    subscription allPaiReportAnswers($companyId: uuid!) {
  reportAnswers: PaiCompanyReport(where: {companyId: {_eq: $companyId}}) {
    id
    reportingPeriod
    year
    period
    answers(
      order_by: {investeeMetricReference: desc, updatedAt: desc}
      distinct_on: investeeMetricReference
    ) {
      id
      data
      investeeMetricReference
      metric {
        title
        description
        methodology
        type
        reference
        investorMetrics {
          metric: investorMetric {
            indicators {
              reference: indicatorRef
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAllPaiReportAnswersSubscription__
 *
 * To run a query within a React component, call `useAllPaiReportAnswersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAllPaiReportAnswersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllPaiReportAnswersSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useAllPaiReportAnswersSubscription(baseOptions: Apollo.SubscriptionHookOptions<AllPaiReportAnswersSubscription_, AllPaiReportAnswersSubscriptionVariables_> & ({ variables: AllPaiReportAnswersSubscriptionVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AllPaiReportAnswersSubscription_, AllPaiReportAnswersSubscriptionVariables_>(AllPaiReportAnswersDocument_, options);
      }
export type AllPaiReportAnswersSubscriptionHookResult = ReturnType<typeof useAllPaiReportAnswersSubscription>;
export type AllPaiReportAnswersSubscriptionResult_ = Apollo.SubscriptionResult<AllPaiReportAnswersSubscription_>;
export const UpsertPaiCompanyReportDocument_ = gql`
    mutation upsertPaiCompanyReport($input: PaiCompanyReport_insert_input!) {
  insert_PaiCompanyReport_one(
    object: $input
    on_conflict: {constraint: PaiCompanyReport_companyId_year_period_key, update_columns: []}
  ) {
    id
    contactPersonId
    reportingPeriod
  }
}
    `;
export type UpsertPaiCompanyReportMutationFn_ = Apollo.MutationFunction<UpsertPaiCompanyReportMutation_, UpsertPaiCompanyReportMutationVariables_>;

/**
 * __useUpsertPaiCompanyReportMutation__
 *
 * To run a mutation, you first call `useUpsertPaiCompanyReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPaiCompanyReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPaiCompanyReportMutation, { data, loading, error }] = useUpsertPaiCompanyReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPaiCompanyReportMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPaiCompanyReportMutation_, UpsertPaiCompanyReportMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPaiCompanyReportMutation_, UpsertPaiCompanyReportMutationVariables_>(UpsertPaiCompanyReportDocument_, options);
      }
export type UpsertPaiCompanyReportMutationHookResult = ReturnType<typeof useUpsertPaiCompanyReportMutation>;
export type UpsertPaiCompanyReportMutationResult_ = Apollo.MutationResult<UpsertPaiCompanyReportMutation_>;
export type UpsertPaiCompanyReportMutationOptions_ = Apollo.BaseMutationOptions<UpsertPaiCompanyReportMutation_, UpsertPaiCompanyReportMutationVariables_>;
export const InsertInitialPaiAnswerForDocumentationDocument_ = gql`
    mutation insertInitialPaiAnswerForDocumentation($input: PaiAnswers_insert_input!) {
  insert_PaiAnswers_one(
    object: $input
    on_conflict: {constraint: PaiAnswers_pkey, update_columns: [data]}
  ) {
    id
    noteHistory {
      ...NoteHistory
    }
    attachmentBox {
      ...AttachmentBox
    }
  }
}
    ${NoteHistoryFragmentDoc_}
${AttachmentBoxFragmentDoc_}`;
export type InsertInitialPaiAnswerForDocumentationMutationFn_ = Apollo.MutationFunction<InsertInitialPaiAnswerForDocumentationMutation_, InsertInitialPaiAnswerForDocumentationMutationVariables_>;

/**
 * __useInsertInitialPaiAnswerForDocumentationMutation__
 *
 * To run a mutation, you first call `useInsertInitialPaiAnswerForDocumentationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertInitialPaiAnswerForDocumentationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertInitialPaiAnswerForDocumentationMutation, { data, loading, error }] = useInsertInitialPaiAnswerForDocumentationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInsertInitialPaiAnswerForDocumentationMutation(baseOptions?: Apollo.MutationHookOptions<InsertInitialPaiAnswerForDocumentationMutation_, InsertInitialPaiAnswerForDocumentationMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertInitialPaiAnswerForDocumentationMutation_, InsertInitialPaiAnswerForDocumentationMutationVariables_>(InsertInitialPaiAnswerForDocumentationDocument_, options);
      }
export type InsertInitialPaiAnswerForDocumentationMutationHookResult = ReturnType<typeof useInsertInitialPaiAnswerForDocumentationMutation>;
export type InsertInitialPaiAnswerForDocumentationMutationResult_ = Apollo.MutationResult<InsertInitialPaiAnswerForDocumentationMutation_>;
export type InsertInitialPaiAnswerForDocumentationMutationOptions_ = Apollo.BaseMutationOptions<InsertInitialPaiAnswerForDocumentationMutation_, InsertInitialPaiAnswerForDocumentationMutationVariables_>;
export const UpsertPaiAnswerDocument_ = gql`
    mutation upsertPaiAnswer($input: PaiAnswers_insert_input!) {
  insert_PaiAnswers_one(
    object: $input
    on_conflict: {constraint: PaiAnswers_pkey, update_columns: [data]}
  ) {
    ...PaiInvesteeAnswerFields
  }
}
    ${PaiInvesteeAnswerFieldsFragmentDoc_}`;
export type UpsertPaiAnswerMutationFn_ = Apollo.MutationFunction<UpsertPaiAnswerMutation_, UpsertPaiAnswerMutationVariables_>;

/**
 * __useUpsertPaiAnswerMutation__
 *
 * To run a mutation, you first call `useUpsertPaiAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPaiAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPaiAnswerMutation, { data, loading, error }] = useUpsertPaiAnswerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertPaiAnswerMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPaiAnswerMutation_, UpsertPaiAnswerMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPaiAnswerMutation_, UpsertPaiAnswerMutationVariables_>(UpsertPaiAnswerDocument_, options);
      }
export type UpsertPaiAnswerMutationHookResult = ReturnType<typeof useUpsertPaiAnswerMutation>;
export type UpsertPaiAnswerMutationResult_ = Apollo.MutationResult<UpsertPaiAnswerMutation_>;
export type UpsertPaiAnswerMutationOptions_ = Apollo.BaseMutationOptions<UpsertPaiAnswerMutation_, UpsertPaiAnswerMutationVariables_>;
export const UpsertPaiAnswersDocument_ = gql`
    mutation upsertPaiAnswers($answers: [PaiAnswers_insert_input!]!) {
  insert_PaiAnswers(
    objects: $answers
    on_conflict: {constraint: PaiAnswers_pkey, update_columns: [data]}
  ) {
    returning {
      ...PaiInvesteeAnswerFields
    }
    affected_rows
  }
}
    ${PaiInvesteeAnswerFieldsFragmentDoc_}`;
export type UpsertPaiAnswersMutationFn_ = Apollo.MutationFunction<UpsertPaiAnswersMutation_, UpsertPaiAnswersMutationVariables_>;

/**
 * __useUpsertPaiAnswersMutation__
 *
 * To run a mutation, you first call `useUpsertPaiAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPaiAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPaiAnswersMutation, { data, loading, error }] = useUpsertPaiAnswersMutation({
 *   variables: {
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useUpsertPaiAnswersMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPaiAnswersMutation_, UpsertPaiAnswersMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPaiAnswersMutation_, UpsertPaiAnswersMutationVariables_>(UpsertPaiAnswersDocument_, options);
      }
export type UpsertPaiAnswersMutationHookResult = ReturnType<typeof useUpsertPaiAnswersMutation>;
export type UpsertPaiAnswersMutationResult_ = Apollo.MutationResult<UpsertPaiAnswersMutation_>;
export type UpsertPaiAnswersMutationOptions_ = Apollo.BaseMutationOptions<UpsertPaiAnswersMutation_, UpsertPaiAnswersMutationVariables_>;
export const GetPaiAnswerDocument_ = gql`
    subscription GetPaiAnswer($paiReportId: uuid!, $investeeMetricRef: String!) {
  answers: PaiAnswers(
    where: {paiCompanyReportId: {_eq: $paiReportId}, investeeMetricReference: {_eq: $investeeMetricRef}}
    order_by: {investeeMetricReference: desc, updatedAt: desc}
    distinct_on: investeeMetricReference
  ) {
    ...PaiInvesteeAnswerFields
  }
}
    ${PaiInvesteeAnswerFieldsFragmentDoc_}`;

/**
 * __useGetPaiAnswerSubscription__
 *
 * To run a query within a React component, call `useGetPaiAnswerSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetPaiAnswerSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaiAnswerSubscription({
 *   variables: {
 *      paiReportId: // value for 'paiReportId'
 *      investeeMetricRef: // value for 'investeeMetricRef'
 *   },
 * });
 */
export function useGetPaiAnswerSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetPaiAnswerSubscription_, GetPaiAnswerSubscriptionVariables_> & ({ variables: GetPaiAnswerSubscriptionVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetPaiAnswerSubscription_, GetPaiAnswerSubscriptionVariables_>(GetPaiAnswerDocument_, options);
      }
export type GetPaiAnswerSubscriptionHookResult = ReturnType<typeof useGetPaiAnswerSubscription>;
export type GetPaiAnswerSubscriptionResult_ = Apollo.SubscriptionResult<GetPaiAnswerSubscription_>;
export const GetPaiIndicatorAnswersDocument_ = gql`
    subscription GetPaiIndicatorAnswers($paiReportId: uuid!, $indicatorRef: String!) {
  answers: PaiAnswers(
    where: {paiCompanyReportId: {_eq: $paiReportId}, metric: {investorMetrics: {investorMetric: {indicators: {indicatorRef: {_eq: $indicatorRef}}}}}}
    order_by: {investeeMetricReference: desc, updatedAt: desc}
    distinct_on: investeeMetricReference
  ) {
    ...PaiInvesteeAnswerFields
    metric {
      title
      description
      methodology
      type
      reference
      investorMetrics {
        metric: investorMetric {
          indicators {
            reference: indicatorRef
          }
        }
      }
    }
  }
}
    ${PaiInvesteeAnswerFieldsFragmentDoc_}`;

/**
 * __useGetPaiIndicatorAnswersSubscription__
 *
 * To run a query within a React component, call `useGetPaiIndicatorAnswersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetPaiIndicatorAnswersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaiIndicatorAnswersSubscription({
 *   variables: {
 *      paiReportId: // value for 'paiReportId'
 *      indicatorRef: // value for 'indicatorRef'
 *   },
 * });
 */
export function useGetPaiIndicatorAnswersSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetPaiIndicatorAnswersSubscription_, GetPaiIndicatorAnswersSubscriptionVariables_> & ({ variables: GetPaiIndicatorAnswersSubscriptionVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetPaiIndicatorAnswersSubscription_, GetPaiIndicatorAnswersSubscriptionVariables_>(GetPaiIndicatorAnswersDocument_, options);
      }
export type GetPaiIndicatorAnswersSubscriptionHookResult = ReturnType<typeof useGetPaiIndicatorAnswersSubscription>;
export type GetPaiIndicatorAnswersSubscriptionResult_ = Apollo.SubscriptionResult<GetPaiIndicatorAnswersSubscription_>;
export const GetJobProgressDocument_ = gql`
    subscription getJobProgress($jobId: uuid!) {
  ExtractionJob_by_pk(id: $jobId) {
    progress
    insights_aggregate {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetJobProgressSubscription__
 *
 * To run a query within a React component, call `useGetJobProgressSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetJobProgressSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobProgressSubscription({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useGetJobProgressSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetJobProgressSubscription_, GetJobProgressSubscriptionVariables_> & ({ variables: GetJobProgressSubscriptionVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetJobProgressSubscription_, GetJobProgressSubscriptionVariables_>(GetJobProgressDocument_, options);
      }
export type GetJobProgressSubscriptionHookResult = ReturnType<typeof useGetJobProgressSubscription>;
export type GetJobProgressSubscriptionResult_ = Apollo.SubscriptionResult<GetJobProgressSubscription_>;
export const GetPaiCategoryAnswersDocument_ = gql`
    subscription GetPaiCategoryAnswers($paiReportId: uuid!, $categoryRef: String!) {
  answers: PaiAnswers(
    where: {paiCompanyReportId: {_eq: $paiReportId}, metric: {investorMetrics: {investorMetric: {indicators: {indicator: {categoryReference: {_eq: $categoryRef}}}}}}}
    order_by: {investeeMetricReference: desc, updatedAt: desc}
    distinct_on: investeeMetricReference
  ) {
    id
    metric {
      title
      description
      methodology
      type
      reference
      investorMetrics {
        metric: investorMetric {
          indicators {
            reference: indicatorRef
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPaiCategoryAnswersSubscription__
 *
 * To run a query within a React component, call `useGetPaiCategoryAnswersSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetPaiCategoryAnswersSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaiCategoryAnswersSubscription({
 *   variables: {
 *      paiReportId: // value for 'paiReportId'
 *      categoryRef: // value for 'categoryRef'
 *   },
 * });
 */
export function useGetPaiCategoryAnswersSubscription(baseOptions: Apollo.SubscriptionHookOptions<GetPaiCategoryAnswersSubscription_, GetPaiCategoryAnswersSubscriptionVariables_> & ({ variables: GetPaiCategoryAnswersSubscriptionVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GetPaiCategoryAnswersSubscription_, GetPaiCategoryAnswersSubscriptionVariables_>(GetPaiCategoryAnswersDocument_, options);
      }
export type GetPaiCategoryAnswersSubscriptionHookResult = ReturnType<typeof useGetPaiCategoryAnswersSubscription>;
export type GetPaiCategoryAnswersSubscriptionResult_ = Apollo.SubscriptionResult<GetPaiCategoryAnswersSubscription_>;
export const PaiBulkAnswersDocument_ = gql`
    query PaiBulkAnswers($companyIds: [uuid!]!, $year: Int!) {
  yearlyMetrics: InvesteeMetric(
    where: {investorMetrics: {investorMetric: {indicators: {indicator: {reports: {periods: {_contains: {year: true}}, paiPortfolioReport: {year: {_eq: $year}, portfolio: {portfolioCompanies: {year: {_eq: $year}, companyId: {_in: $companyIds}}}}}}}}}}
    order_by: {order: asc}
  ) {
    reference
    title
    type
    order
  }
  quarterlyMetrics: InvesteeMetric(
    where: {investorMetrics: {investorMetric: {indicators: {indicator: {reports: {_or: [{periods: {_contains: {q1: true}}}, {periods: {_contains: {q2: true}}}, {periods: {_contains: {q3: true}}}, {periods: {_contains: {q4: true}}}], paiPortfolioReport: {year: {_eq: $year}, portfolio: {portfolioCompanies: {year: {_eq: $year}, companyId: {_in: $companyIds}}}}}}}}}}
    order_by: {order: asc}
  ) {
    reference
    title
    type
    order
  }
  companies: Company(where: {id: {_in: $companyIds}}, order_by: {name: asc}) {
    id
    name
    yearly: paiReports(where: {period: {_ilike: "year"}, year: {_eq: $year}}) {
      answers(
        order_by: {investeeMetricReference: desc, updatedAt: desc}
        distinct_on: [investeeMetricReference]
      ) {
        investeeMetricReference
        data
        noteHistory {
          notes(order_by: {updatedAt: desc}, limit: 1) {
            body
          }
        }
      }
    }
    q1: paiReports(where: {period: {_ilike: "q1"}, year: {_eq: $year}}) {
      answers(
        order_by: {updatedAt: desc, investeeMetricReference: desc}
        distinct_on: [investeeMetricReference]
      ) {
        investeeMetricReference
        data
        noteHistory {
          notes(order_by: {updatedAt: desc}, limit: 1) {
            body
          }
        }
      }
    }
    q2: paiReports(where: {period: {_ilike: "q2"}, year: {_eq: $year}}) {
      answers(
        order_by: {updatedAt: desc, investeeMetricReference: desc}
        distinct_on: [investeeMetricReference]
      ) {
        investeeMetricReference
        data
        noteHistory {
          notes(order_by: {updatedAt: desc}, limit: 1) {
            body
          }
        }
      }
    }
    q3: paiReports(where: {period: {_ilike: "q3"}, year: {_eq: $year}}) {
      answers(
        order_by: {updatedAt: desc, investeeMetricReference: desc}
        distinct_on: [investeeMetricReference]
      ) {
        investeeMetricReference
        data
        noteHistory {
          notes(order_by: {updatedAt: desc}, limit: 1) {
            body
          }
        }
      }
    }
    q4: paiReports(where: {period: {_ilike: "q4"}, year: {_eq: $year}}) {
      answers(
        order_by: {updatedAt: desc, investeeMetricReference: desc}
        distinct_on: [investeeMetricReference]
      ) {
        investeeMetricReference
        data
        noteHistory {
          notes(order_by: {updatedAt: desc}, limit: 1) {
            body
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePaiBulkAnswersQuery__
 *
 * To run a query within a React component, call `usePaiBulkAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaiBulkAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaiBulkAnswersQuery({
 *   variables: {
 *      companyIds: // value for 'companyIds'
 *      year: // value for 'year'
 *   },
 * });
 */
export function usePaiBulkAnswersQuery(baseOptions: Apollo.QueryHookOptions<PaiBulkAnswersQuery_, PaiBulkAnswersQueryVariables_> & ({ variables: PaiBulkAnswersQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaiBulkAnswersQuery_, PaiBulkAnswersQueryVariables_>(PaiBulkAnswersDocument_, options);
      }
export function usePaiBulkAnswersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<PaiBulkAnswersQuery_, PaiBulkAnswersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaiBulkAnswersQuery_, PaiBulkAnswersQueryVariables_>(PaiBulkAnswersDocument_, options);
        }
export function usePaiBulkAnswersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaiBulkAnswersQuery_, PaiBulkAnswersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaiBulkAnswersQuery_, PaiBulkAnswersQueryVariables_>(PaiBulkAnswersDocument_, options);
        }
export type PaiBulkAnswersQueryHookResult = ReturnType<typeof usePaiBulkAnswersQuery>;
export type PaiBulkAnswersLazyQuery_HookResult = ReturnType<typeof usePaiBulkAnswersLazyQuery_>;
export type PaiBulkAnswersSuspenseQuery_HookResult = ReturnType<typeof usePaiBulkAnswersSuspenseQuery_>;
export type PaiBulkAnswersQueryResult_ = Apollo.QueryResult<PaiBulkAnswersQuery_, PaiBulkAnswersQueryVariables_>;
export function refetchPaiBulkAnswersQuery_(variables: PaiBulkAnswersQueryVariables_) {
      return { query: PaiBulkAnswersDocument_, variables: variables }
    }
export const PaiTablesDocument_ = gql`
    query PaiTables {
  tables: PaiTable(where: {}) {
    ...PaiTableFields
  }
}
    ${PaiTableFieldsFragmentDoc_}`;

/**
 * __usePaiTablesQuery__
 *
 * To run a query within a React component, call `usePaiTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaiTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaiTablesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaiTablesQuery(baseOptions?: Apollo.QueryHookOptions<PaiTablesQuery_, PaiTablesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaiTablesQuery_, PaiTablesQueryVariables_>(PaiTablesDocument_, options);
      }
export function usePaiTablesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<PaiTablesQuery_, PaiTablesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaiTablesQuery_, PaiTablesQueryVariables_>(PaiTablesDocument_, options);
        }
export function usePaiTablesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaiTablesQuery_, PaiTablesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaiTablesQuery_, PaiTablesQueryVariables_>(PaiTablesDocument_, options);
        }
export type PaiTablesQueryHookResult = ReturnType<typeof usePaiTablesQuery>;
export type PaiTablesLazyQuery_HookResult = ReturnType<typeof usePaiTablesLazyQuery_>;
export type PaiTablesSuspenseQuery_HookResult = ReturnType<typeof usePaiTablesSuspenseQuery_>;
export type PaiTablesQueryResult_ = Apollo.QueryResult<PaiTablesQuery_, PaiTablesQueryVariables_>;
export function refetchPaiTablesQuery_(variables?: PaiTablesQueryVariables_) {
      return { query: PaiTablesDocument_, variables: variables }
    }
export const PaiTablesV2Document_ = gql`
    query PaiTablesV2 {
  tables: PaiTable(where: {}) {
    ...PaiTableFieldsV2
  }
}
    ${PaiTableFieldsV2FragmentDoc_}`;

/**
 * __usePaiTablesV2Query__
 *
 * To run a query within a React component, call `usePaiTablesV2Query` and pass it any options that fit your needs.
 * When your component renders, `usePaiTablesV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaiTablesV2Query({
 *   variables: {
 *   },
 * });
 */
export function usePaiTablesV2Query(baseOptions?: Apollo.QueryHookOptions<PaiTablesV2Query_, PaiTablesV2QueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaiTablesV2Query_, PaiTablesV2QueryVariables_>(PaiTablesV2Document_, options);
      }
export function usePaiTablesV2LazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<PaiTablesV2Query_, PaiTablesV2QueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaiTablesV2Query_, PaiTablesV2QueryVariables_>(PaiTablesV2Document_, options);
        }
export function usePaiTablesV2SuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaiTablesV2Query_, PaiTablesV2QueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaiTablesV2Query_, PaiTablesV2QueryVariables_>(PaiTablesV2Document_, options);
        }
export type PaiTablesV2QueryHookResult = ReturnType<typeof usePaiTablesV2Query>;
export type PaiTablesV2LazyQuery_HookResult = ReturnType<typeof usePaiTablesV2LazyQuery_>;
export type PaiTablesV2SuspenseQuery_HookResult = ReturnType<typeof usePaiTablesV2SuspenseQuery_>;
export type PaiTablesV2QueryResult_ = Apollo.QueryResult<PaiTablesV2Query_, PaiTablesV2QueryVariables_>;
export function refetchPaiTablesV2Query_(variables?: PaiTablesV2QueryVariables_) {
      return { query: PaiTablesV2Document_, variables: variables }
    }
export const GetPaiPortfolioReportDocument_ = gql`
    query getPaiPortfolioReport($portfolioId: uuid!, $year: Int!, $quarter: QuarterEnum_enum!) {
  report: PaiPortfolioReport(
    where: {portfolioId: {_eq: $portfolioId}, year: {_eq: $year}, quarter: {_eq: $quarter}}
  ) {
    ...PaiPortfolioReportFields
  }
}
    ${PaiPortfolioReportFieldsFragmentDoc_}`;

/**
 * __useGetPaiPortfolioReportQuery__
 *
 * To run a query within a React component, call `useGetPaiPortfolioReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaiPortfolioReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaiPortfolioReportQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      year: // value for 'year'
 *      quarter: // value for 'quarter'
 *   },
 * });
 */
export function useGetPaiPortfolioReportQuery(baseOptions: Apollo.QueryHookOptions<GetPaiPortfolioReportQuery_, GetPaiPortfolioReportQueryVariables_> & ({ variables: GetPaiPortfolioReportQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaiPortfolioReportQuery_, GetPaiPortfolioReportQueryVariables_>(GetPaiPortfolioReportDocument_, options);
      }
export function useGetPaiPortfolioReportLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetPaiPortfolioReportQuery_, GetPaiPortfolioReportQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaiPortfolioReportQuery_, GetPaiPortfolioReportQueryVariables_>(GetPaiPortfolioReportDocument_, options);
        }
export function useGetPaiPortfolioReportSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaiPortfolioReportQuery_, GetPaiPortfolioReportQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaiPortfolioReportQuery_, GetPaiPortfolioReportQueryVariables_>(GetPaiPortfolioReportDocument_, options);
        }
export type GetPaiPortfolioReportQueryHookResult = ReturnType<typeof useGetPaiPortfolioReportQuery>;
export type GetPaiPortfolioReportLazyQuery_HookResult = ReturnType<typeof useGetPaiPortfolioReportLazyQuery_>;
export type GetPaiPortfolioReportSuspenseQuery_HookResult = ReturnType<typeof useGetPaiPortfolioReportSuspenseQuery_>;
export type GetPaiPortfolioReportQueryResult_ = Apollo.QueryResult<GetPaiPortfolioReportQuery_, GetPaiPortfolioReportQueryVariables_>;
export function refetchGetPaiPortfolioReportQuery_(variables: GetPaiPortfolioReportQueryVariables_) {
      return { query: GetPaiPortfolioReportDocument_, variables: variables }
    }
export const GetPaiPortfolioReportV2Document_ = gql`
    query getPaiPortfolioReportV2($portfolioId: uuid!, $year: Int!, $quarter: QuarterEnum_enum!) {
  report: PaiPortfolioReport(
    where: {portfolioId: {_eq: $portfolioId}, year: {_eq: $year}, quarter: {_eq: $quarter}}
  ) {
    ...PaiPortfolioReportFieldsV2
  }
}
    ${PaiPortfolioReportFieldsV2FragmentDoc_}`;

/**
 * __useGetPaiPortfolioReportV2Query__
 *
 * To run a query within a React component, call `useGetPaiPortfolioReportV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetPaiPortfolioReportV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaiPortfolioReportV2Query({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      year: // value for 'year'
 *      quarter: // value for 'quarter'
 *   },
 * });
 */
export function useGetPaiPortfolioReportV2Query(baseOptions: Apollo.QueryHookOptions<GetPaiPortfolioReportV2Query_, GetPaiPortfolioReportV2QueryVariables_> & ({ variables: GetPaiPortfolioReportV2QueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaiPortfolioReportV2Query_, GetPaiPortfolioReportV2QueryVariables_>(GetPaiPortfolioReportV2Document_, options);
      }
export function useGetPaiPortfolioReportV2LazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetPaiPortfolioReportV2Query_, GetPaiPortfolioReportV2QueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaiPortfolioReportV2Query_, GetPaiPortfolioReportV2QueryVariables_>(GetPaiPortfolioReportV2Document_, options);
        }
export function useGetPaiPortfolioReportV2SuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPaiPortfolioReportV2Query_, GetPaiPortfolioReportV2QueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPaiPortfolioReportV2Query_, GetPaiPortfolioReportV2QueryVariables_>(GetPaiPortfolioReportV2Document_, options);
        }
export type GetPaiPortfolioReportV2QueryHookResult = ReturnType<typeof useGetPaiPortfolioReportV2Query>;
export type GetPaiPortfolioReportV2LazyQuery_HookResult = ReturnType<typeof useGetPaiPortfolioReportV2LazyQuery_>;
export type GetPaiPortfolioReportV2SuspenseQuery_HookResult = ReturnType<typeof useGetPaiPortfolioReportV2SuspenseQuery_>;
export type GetPaiPortfolioReportV2QueryResult_ = Apollo.QueryResult<GetPaiPortfolioReportV2Query_, GetPaiPortfolioReportV2QueryVariables_>;
export function refetchGetPaiPortfolioReportV2Query_(variables: GetPaiPortfolioReportV2QueryVariables_) {
      return { query: GetPaiPortfolioReportV2Document_, variables: variables }
    }
export const AddPaiPortfolioReportDocument_ = gql`
    mutation addPaiPortfolioReport($input: PaiPortfolioReport_insert_input!) {
  insert_PaiPortfolioReport_one(
    object: $input
    on_conflict: {constraint: PaiPortfolioReport_pkey, update_columns: [dueDate, reportingPeriod, contactPersonId]}
  ) {
    id
  }
}
    `;
export type AddPaiPortfolioReportMutationFn_ = Apollo.MutationFunction<AddPaiPortfolioReportMutation_, AddPaiPortfolioReportMutationVariables_>;

/**
 * __useAddPaiPortfolioReportMutation__
 *
 * To run a mutation, you first call `useAddPaiPortfolioReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPaiPortfolioReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPaiPortfolioReportMutation, { data, loading, error }] = useAddPaiPortfolioReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPaiPortfolioReportMutation(baseOptions?: Apollo.MutationHookOptions<AddPaiPortfolioReportMutation_, AddPaiPortfolioReportMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPaiPortfolioReportMutation_, AddPaiPortfolioReportMutationVariables_>(AddPaiPortfolioReportDocument_, options);
      }
export type AddPaiPortfolioReportMutationHookResult = ReturnType<typeof useAddPaiPortfolioReportMutation>;
export type AddPaiPortfolioReportMutationResult_ = Apollo.MutationResult<AddPaiPortfolioReportMutation_>;
export type AddPaiPortfolioReportMutationOptions_ = Apollo.BaseMutationOptions<AddPaiPortfolioReportMutation_, AddPaiPortfolioReportMutationVariables_>;
export const UpsertPaiPortfolioReportDocument_ = gql`
    mutation upsertPaiPortfolioReport($object: PaiPortfolioReport_insert_input!) {
  insert_PaiPortfolioReport_one(
    object: $object
    on_conflict: {constraint: PaiPortfolioReport_portfolioId_year_quarter_key, update_columns: [contactPersonId, sendOutDates, dueDates, year, quarter]}
  ) {
    portfolioId
    sendOutDates
    dueDates
    selectedIndicators {
      id
    }
    contactPersonId
    contactPerson {
      displayName
    }
  }
}
    `;
export type UpsertPaiPortfolioReportMutationFn_ = Apollo.MutationFunction<UpsertPaiPortfolioReportMutation_, UpsertPaiPortfolioReportMutationVariables_>;

/**
 * __useUpsertPaiPortfolioReportMutation__
 *
 * To run a mutation, you first call `useUpsertPaiPortfolioReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPaiPortfolioReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPaiPortfolioReportMutation, { data, loading, error }] = useUpsertPaiPortfolioReportMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpsertPaiPortfolioReportMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPaiPortfolioReportMutation_, UpsertPaiPortfolioReportMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPaiPortfolioReportMutation_, UpsertPaiPortfolioReportMutationVariables_>(UpsertPaiPortfolioReportDocument_, options);
      }
export type UpsertPaiPortfolioReportMutationHookResult = ReturnType<typeof useUpsertPaiPortfolioReportMutation>;
export type UpsertPaiPortfolioReportMutationResult_ = Apollo.MutationResult<UpsertPaiPortfolioReportMutation_>;
export type UpsertPaiPortfolioReportMutationOptions_ = Apollo.BaseMutationOptions<UpsertPaiPortfolioReportMutation_, UpsertPaiPortfolioReportMutationVariables_>;
export const DeletePaiReportIndicatorDocument_ = gql`
    mutation deletePaiReportIndicator($paiPortfolioReportId: [uuid!], $paiTableIndicatorReference: [String!]) {
  delete_PaiReportIndicator(
    where: {paiPortfolioReportId: {_in: $paiPortfolioReportId}, paiTableIndicatorReference: {_in: $paiTableIndicatorReference}}
  ) {
    affected_rows
  }
}
    `;
export type DeletePaiReportIndicatorMutationFn_ = Apollo.MutationFunction<DeletePaiReportIndicatorMutation_, DeletePaiReportIndicatorMutationVariables_>;

/**
 * __useDeletePaiReportIndicatorMutation__
 *
 * To run a mutation, you first call `useDeletePaiReportIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaiReportIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaiReportIndicatorMutation, { data, loading, error }] = useDeletePaiReportIndicatorMutation({
 *   variables: {
 *      paiPortfolioReportId: // value for 'paiPortfolioReportId'
 *      paiTableIndicatorReference: // value for 'paiTableIndicatorReference'
 *   },
 * });
 */
export function useDeletePaiReportIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaiReportIndicatorMutation_, DeletePaiReportIndicatorMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaiReportIndicatorMutation_, DeletePaiReportIndicatorMutationVariables_>(DeletePaiReportIndicatorDocument_, options);
      }
export type DeletePaiReportIndicatorMutationHookResult = ReturnType<typeof useDeletePaiReportIndicatorMutation>;
export type DeletePaiReportIndicatorMutationResult_ = Apollo.MutationResult<DeletePaiReportIndicatorMutation_>;
export type DeletePaiReportIndicatorMutationOptions_ = Apollo.BaseMutationOptions<DeletePaiReportIndicatorMutation_, DeletePaiReportIndicatorMutationVariables_>;
export const DeletePaiReportIndicatorPortfolioCompanyDocument_ = gql`
    mutation deletePaiReportIndicatorPortfolioCompany($portfolioCompanyId: uuid!, $indicatorRef: String!) {
  delete_PaiReportIndicatorPortfolioCompany(
    where: {portfolioCompanyId: {_eq: $portfolioCompanyId}, paiReportIndicator: {paiTableIndicatorReference: {_eq: $indicatorRef}}}
  ) {
    affected_rows
  }
}
    `;
export type DeletePaiReportIndicatorPortfolioCompanyMutationFn_ = Apollo.MutationFunction<DeletePaiReportIndicatorPortfolioCompanyMutation_, DeletePaiReportIndicatorPortfolioCompanyMutationVariables_>;

/**
 * __useDeletePaiReportIndicatorPortfolioCompanyMutation__
 *
 * To run a mutation, you first call `useDeletePaiReportIndicatorPortfolioCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaiReportIndicatorPortfolioCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaiReportIndicatorPortfolioCompanyMutation, { data, loading, error }] = useDeletePaiReportIndicatorPortfolioCompanyMutation({
 *   variables: {
 *      portfolioCompanyId: // value for 'portfolioCompanyId'
 *      indicatorRef: // value for 'indicatorRef'
 *   },
 * });
 */
export function useDeletePaiReportIndicatorPortfolioCompanyMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaiReportIndicatorPortfolioCompanyMutation_, DeletePaiReportIndicatorPortfolioCompanyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaiReportIndicatorPortfolioCompanyMutation_, DeletePaiReportIndicatorPortfolioCompanyMutationVariables_>(DeletePaiReportIndicatorPortfolioCompanyDocument_, options);
      }
export type DeletePaiReportIndicatorPortfolioCompanyMutationHookResult = ReturnType<typeof useDeletePaiReportIndicatorPortfolioCompanyMutation>;
export type DeletePaiReportIndicatorPortfolioCompanyMutationResult_ = Apollo.MutationResult<DeletePaiReportIndicatorPortfolioCompanyMutation_>;
export type DeletePaiReportIndicatorPortfolioCompanyMutationOptions_ = Apollo.BaseMutationOptions<DeletePaiReportIndicatorPortfolioCompanyMutation_, DeletePaiReportIndicatorPortfolioCompanyMutationVariables_>;
export const PaiCompanyResultsWithNotesDocument_ = gql`
    query PaiCompanyResultsWithNotes($portfolioId: uuid!, $year: Int!) {
  companies: PortfolioCompany(
    where: {portfolioId: {_eq: $portfolioId}, year: {_eq: $year}}
  ) {
    company {
      name
      id
    }
    marketValue
    valueOfInvestments
    paiYearReport: paiCompanyReport {
      answers(
        order_by: {investeeMetricReference: desc, updatedAt: desc}
        distinct_on: investeeMetricReference
      ) {
        metric {
          investorMetrics {
            investeeMetric {
              reference
            }
          }
        }
        data
        noteHistory {
          notes(order_by: {createdAt: desc}, limit: 1) {
            body
          }
        }
      }
    }
    paiQ1Report: paiCompanyReportQ1 {
      answers(
        order_by: {investeeMetricReference: desc, updatedAt: desc}
        distinct_on: investeeMetricReference
      ) {
        metric {
          investorMetrics {
            investeeMetric {
              reference
            }
          }
        }
        data
        noteHistory {
          notes(order_by: {createdAt: desc}, limit: 1) {
            body
          }
        }
      }
    }
    paiQ2Report: paiCompanyReportQ2 {
      answers(
        order_by: {investeeMetricReference: desc, updatedAt: desc}
        distinct_on: investeeMetricReference
      ) {
        metric {
          investorMetrics {
            investeeMetric {
              reference
            }
          }
        }
        data
        noteHistory {
          notes(order_by: {createdAt: desc}, limit: 1) {
            body
          }
        }
      }
    }
    paiQ3Report: paiCompanyReportQ3 {
      answers(
        order_by: {investeeMetricReference: desc, updatedAt: desc}
        distinct_on: investeeMetricReference
      ) {
        metric {
          investorMetrics {
            investeeMetric {
              reference
            }
          }
        }
        data
        noteHistory {
          notes(order_by: {createdAt: desc}, limit: 1) {
            body
          }
        }
      }
    }
    paiQ4Report: paiCompanyReportQ4 {
      answers(
        order_by: {investeeMetricReference: desc, updatedAt: desc}
        distinct_on: investeeMetricReference
      ) {
        metric {
          investorMetrics {
            investeeMetric {
              reference
            }
          }
        }
        data
        noteHistory {
          notes(order_by: {createdAt: desc}, limit: 1) {
            body
          }
        }
      }
    }
  }
  indicators: PaiReportIndicator(
    where: {paiPortfolioReport: {portfolioId: {_eq: $portfolioId}, year: {_eq: $year}}}
  ) {
    id
    periods
    isForAllCompanies
    paiReportIndicatorPortfolioCompanies {
      id
      portfolioCompany {
        companyId
      }
    }
    indicator {
      investorMetrics {
        investorMetric {
          investeeMetrics {
            investeeMetricReference
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePaiCompanyResultsWithNotesQuery__
 *
 * To run a query within a React component, call `usePaiCompanyResultsWithNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaiCompanyResultsWithNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaiCompanyResultsWithNotesQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      year: // value for 'year'
 *   },
 * });
 */
export function usePaiCompanyResultsWithNotesQuery(baseOptions: Apollo.QueryHookOptions<PaiCompanyResultsWithNotesQuery_, PaiCompanyResultsWithNotesQueryVariables_> & ({ variables: PaiCompanyResultsWithNotesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaiCompanyResultsWithNotesQuery_, PaiCompanyResultsWithNotesQueryVariables_>(PaiCompanyResultsWithNotesDocument_, options);
      }
export function usePaiCompanyResultsWithNotesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<PaiCompanyResultsWithNotesQuery_, PaiCompanyResultsWithNotesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaiCompanyResultsWithNotesQuery_, PaiCompanyResultsWithNotesQueryVariables_>(PaiCompanyResultsWithNotesDocument_, options);
        }
export function usePaiCompanyResultsWithNotesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaiCompanyResultsWithNotesQuery_, PaiCompanyResultsWithNotesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaiCompanyResultsWithNotesQuery_, PaiCompanyResultsWithNotesQueryVariables_>(PaiCompanyResultsWithNotesDocument_, options);
        }
export type PaiCompanyResultsWithNotesQueryHookResult = ReturnType<typeof usePaiCompanyResultsWithNotesQuery>;
export type PaiCompanyResultsWithNotesLazyQuery_HookResult = ReturnType<typeof usePaiCompanyResultsWithNotesLazyQuery_>;
export type PaiCompanyResultsWithNotesSuspenseQuery_HookResult = ReturnType<typeof usePaiCompanyResultsWithNotesSuspenseQuery_>;
export type PaiCompanyResultsWithNotesQueryResult_ = Apollo.QueryResult<PaiCompanyResultsWithNotesQuery_, PaiCompanyResultsWithNotesQueryVariables_>;
export function refetchPaiCompanyResultsWithNotesQuery_(variables: PaiCompanyResultsWithNotesQueryVariables_) {
      return { query: PaiCompanyResultsWithNotesDocument_, variables: variables }
    }
export const PaiCompanyResultsWithoutNotesDocument_ = gql`
    query PaiCompanyResultsWithoutNotes($portfolioId: uuid!, $year: Int!) {
  companies: PortfolioCompany(
    where: {portfolioId: {_eq: $portfolioId}, year: {_eq: $year}}
  ) {
    company {
      name
      id
    }
    marketValue
    valueOfInvestments
    paiYearReport: paiCompanyReport {
      answers(
        order_by: {investeeMetricReference: desc, updatedAt: desc}
        distinct_on: investeeMetricReference
      ) {
        metric {
          investorMetrics {
            investeeMetric {
              reference
            }
          }
        }
        data
      }
    }
    paiQ1Report: paiCompanyReportQ1 {
      answers(
        order_by: {investeeMetricReference: desc, updatedAt: desc}
        distinct_on: investeeMetricReference
      ) {
        metric {
          investorMetrics {
            investeeMetric {
              reference
            }
          }
        }
        data
      }
    }
    paiQ2Report: paiCompanyReportQ2 {
      answers(
        order_by: {investeeMetricReference: desc, updatedAt: desc}
        distinct_on: investeeMetricReference
      ) {
        metric {
          investorMetrics {
            investeeMetric {
              reference
            }
          }
        }
        data
      }
    }
    paiQ3Report: paiCompanyReportQ3 {
      answers(
        order_by: {investeeMetricReference: desc, updatedAt: desc}
        distinct_on: investeeMetricReference
      ) {
        metric {
          investorMetrics {
            investeeMetric {
              reference
            }
          }
        }
        data
      }
    }
    paiQ4Report: paiCompanyReportQ4 {
      answers(
        order_by: {investeeMetricReference: desc, updatedAt: desc}
        distinct_on: investeeMetricReference
      ) {
        metric {
          investorMetrics {
            investeeMetric {
              reference
            }
          }
        }
        data
      }
    }
  }
  indicators: PaiReportIndicator(
    where: {paiPortfolioReport: {portfolioId: {_eq: $portfolioId}, year: {_eq: $year}}}
  ) {
    id
    periods
    isForAllCompanies
    paiReportIndicatorPortfolioCompanies {
      id
      portfolioCompany {
        companyId
      }
    }
    indicator {
      investorMetrics {
        investorMetric {
          investeeMetrics {
            investeeMetricReference
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePaiCompanyResultsWithoutNotesQuery__
 *
 * To run a query within a React component, call `usePaiCompanyResultsWithoutNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaiCompanyResultsWithoutNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaiCompanyResultsWithoutNotesQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      year: // value for 'year'
 *   },
 * });
 */
export function usePaiCompanyResultsWithoutNotesQuery(baseOptions: Apollo.QueryHookOptions<PaiCompanyResultsWithoutNotesQuery_, PaiCompanyResultsWithoutNotesQueryVariables_> & ({ variables: PaiCompanyResultsWithoutNotesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaiCompanyResultsWithoutNotesQuery_, PaiCompanyResultsWithoutNotesQueryVariables_>(PaiCompanyResultsWithoutNotesDocument_, options);
      }
export function usePaiCompanyResultsWithoutNotesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<PaiCompanyResultsWithoutNotesQuery_, PaiCompanyResultsWithoutNotesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaiCompanyResultsWithoutNotesQuery_, PaiCompanyResultsWithoutNotesQueryVariables_>(PaiCompanyResultsWithoutNotesDocument_, options);
        }
export function usePaiCompanyResultsWithoutNotesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaiCompanyResultsWithoutNotesQuery_, PaiCompanyResultsWithoutNotesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaiCompanyResultsWithoutNotesQuery_, PaiCompanyResultsWithoutNotesQueryVariables_>(PaiCompanyResultsWithoutNotesDocument_, options);
        }
export type PaiCompanyResultsWithoutNotesQueryHookResult = ReturnType<typeof usePaiCompanyResultsWithoutNotesQuery>;
export type PaiCompanyResultsWithoutNotesLazyQuery_HookResult = ReturnType<typeof usePaiCompanyResultsWithoutNotesLazyQuery_>;
export type PaiCompanyResultsWithoutNotesSuspenseQuery_HookResult = ReturnType<typeof usePaiCompanyResultsWithoutNotesSuspenseQuery_>;
export type PaiCompanyResultsWithoutNotesQueryResult_ = Apollo.QueryResult<PaiCompanyResultsWithoutNotesQuery_, PaiCompanyResultsWithoutNotesQueryVariables_>;
export function refetchPaiCompanyResultsWithoutNotesQuery_(variables: PaiCompanyResultsWithoutNotesQueryVariables_) {
      return { query: PaiCompanyResultsWithoutNotesDocument_, variables: variables }
    }
export const PortfoliosDocument_ = gql`
    query Portfolios($companyId: uuid!) {
  portfolios: Portfolio(
    where: {ownerCompanyId: {_eq: $companyId}, deletedAt: {_is_null: true}}
  ) {
    ...PortfolioFields
  }
}
    ${PortfolioFieldsFragmentDoc_}`;

/**
 * __usePortfoliosQuery__
 *
 * To run a query within a React component, call `usePortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfoliosQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function usePortfoliosQuery(baseOptions: Apollo.QueryHookOptions<PortfoliosQuery_, PortfoliosQueryVariables_> & ({ variables: PortfoliosQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortfoliosQuery_, PortfoliosQueryVariables_>(PortfoliosDocument_, options);
      }
export function usePortfoliosLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<PortfoliosQuery_, PortfoliosQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortfoliosQuery_, PortfoliosQueryVariables_>(PortfoliosDocument_, options);
        }
export function usePortfoliosSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortfoliosQuery_, PortfoliosQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortfoliosQuery_, PortfoliosQueryVariables_>(PortfoliosDocument_, options);
        }
export type PortfoliosQueryHookResult = ReturnType<typeof usePortfoliosQuery>;
export type PortfoliosLazyQuery_HookResult = ReturnType<typeof usePortfoliosLazyQuery_>;
export type PortfoliosSuspenseQuery_HookResult = ReturnType<typeof usePortfoliosSuspenseQuery_>;
export type PortfoliosQueryResult_ = Apollo.QueryResult<PortfoliosQuery_, PortfoliosQueryVariables_>;
export function refetchPortfoliosQuery_(variables: PortfoliosQueryVariables_) {
      return { query: PortfoliosDocument_, variables: variables }
    }
export const InvestorsDocument_ = gql`
    query Investors($companyId: uuid!) {
  investors: PortfolioCompany(
    where: {companyId: {_eq: $companyId}, portfolio: {deletedAt: {_is_null: true}}}
  ) {
    ...InvestorFields
  }
}
    ${InvestorFieldsFragmentDoc_}`;

/**
 * __useInvestorsQuery__
 *
 * To run a query within a React component, call `useInvestorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestorsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useInvestorsQuery(baseOptions: Apollo.QueryHookOptions<InvestorsQuery_, InvestorsQueryVariables_> & ({ variables: InvestorsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvestorsQuery_, InvestorsQueryVariables_>(InvestorsDocument_, options);
      }
export function useInvestorsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<InvestorsQuery_, InvestorsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvestorsQuery_, InvestorsQueryVariables_>(InvestorsDocument_, options);
        }
export function useInvestorsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InvestorsQuery_, InvestorsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InvestorsQuery_, InvestorsQueryVariables_>(InvestorsDocument_, options);
        }
export type InvestorsQueryHookResult = ReturnType<typeof useInvestorsQuery>;
export type InvestorsLazyQuery_HookResult = ReturnType<typeof useInvestorsLazyQuery_>;
export type InvestorsSuspenseQuery_HookResult = ReturnType<typeof useInvestorsSuspenseQuery_>;
export type InvestorsQueryResult_ = Apollo.QueryResult<InvestorsQuery_, InvestorsQueryVariables_>;
export function refetchInvestorsQuery_(variables: InvestorsQueryVariables_) {
      return { query: InvestorsDocument_, variables: variables }
    }
export const GetPortfolioNameDocument_ = gql`
    query GetPortfolioName($id: uuid!) {
  portfolio: Portfolio_by_pk(id: $id) {
    name
  }
}
    `;

/**
 * __useGetPortfolioNameQuery__
 *
 * To run a query within a React component, call `useGetPortfolioNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPortfolioNameQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioNameQuery_, GetPortfolioNameQueryVariables_> & ({ variables: GetPortfolioNameQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioNameQuery_, GetPortfolioNameQueryVariables_>(GetPortfolioNameDocument_, options);
      }
export function useGetPortfolioNameLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioNameQuery_, GetPortfolioNameQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioNameQuery_, GetPortfolioNameQueryVariables_>(GetPortfolioNameDocument_, options);
        }
export function useGetPortfolioNameSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfolioNameQuery_, GetPortfolioNameQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfolioNameQuery_, GetPortfolioNameQueryVariables_>(GetPortfolioNameDocument_, options);
        }
export type GetPortfolioNameQueryHookResult = ReturnType<typeof useGetPortfolioNameQuery>;
export type GetPortfolioNameLazyQuery_HookResult = ReturnType<typeof useGetPortfolioNameLazyQuery_>;
export type GetPortfolioNameSuspenseQuery_HookResult = ReturnType<typeof useGetPortfolioNameSuspenseQuery_>;
export type GetPortfolioNameQueryResult_ = Apollo.QueryResult<GetPortfolioNameQuery_, GetPortfolioNameQueryVariables_>;
export function refetchGetPortfolioNameQuery_(variables: GetPortfolioNameQueryVariables_) {
      return { query: GetPortfolioNameDocument_, variables: variables }
    }
export const CompaniesFromAllPortfoliosDocument_ = gql`
    query companiesFromAllPortfolios($ownerCompanyId: uuid!) {
  allCompanies: Company(
    where: {portfolioCompanies: {portfolio: {ownerCompanyId: {_eq: $ownerCompanyId}}}}
  ) {
    id
    name
    portfolioMemberships: portfolioCompanies(
      where: {portfolio: {ownerCompanyId: {_eq: $ownerCompanyId}}}
      order_by: {sharedAssessment: {aggregate: {startDate: desc}}}
    ) {
      portfolio {
        id
        name
      }
      sharedAssessment {
        aggregate {
          title
          startDate
        }
      }
      contactPersonName
      contactPersonEmail
    }
  }
}
    `;

/**
 * __useCompaniesFromAllPortfoliosQuery__
 *
 * To run a query within a React component, call `useCompaniesFromAllPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompaniesFromAllPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompaniesFromAllPortfoliosQuery({
 *   variables: {
 *      ownerCompanyId: // value for 'ownerCompanyId'
 *   },
 * });
 */
export function useCompaniesFromAllPortfoliosQuery(baseOptions: Apollo.QueryHookOptions<CompaniesFromAllPortfoliosQuery_, CompaniesFromAllPortfoliosQueryVariables_> & ({ variables: CompaniesFromAllPortfoliosQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompaniesFromAllPortfoliosQuery_, CompaniesFromAllPortfoliosQueryVariables_>(CompaniesFromAllPortfoliosDocument_, options);
      }
export function useCompaniesFromAllPortfoliosLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<CompaniesFromAllPortfoliosQuery_, CompaniesFromAllPortfoliosQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompaniesFromAllPortfoliosQuery_, CompaniesFromAllPortfoliosQueryVariables_>(CompaniesFromAllPortfoliosDocument_, options);
        }
export function useCompaniesFromAllPortfoliosSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompaniesFromAllPortfoliosQuery_, CompaniesFromAllPortfoliosQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompaniesFromAllPortfoliosQuery_, CompaniesFromAllPortfoliosQueryVariables_>(CompaniesFromAllPortfoliosDocument_, options);
        }
export type CompaniesFromAllPortfoliosQueryHookResult = ReturnType<typeof useCompaniesFromAllPortfoliosQuery>;
export type CompaniesFromAllPortfoliosLazyQuery_HookResult = ReturnType<typeof useCompaniesFromAllPortfoliosLazyQuery_>;
export type CompaniesFromAllPortfoliosSuspenseQuery_HookResult = ReturnType<typeof useCompaniesFromAllPortfoliosSuspenseQuery_>;
export type CompaniesFromAllPortfoliosQueryResult_ = Apollo.QueryResult<CompaniesFromAllPortfoliosQuery_, CompaniesFromAllPortfoliosQueryVariables_>;
export function refetchCompaniesFromAllPortfoliosQuery_(variables: CompaniesFromAllPortfoliosQueryVariables_) {
      return { query: CompaniesFromAllPortfoliosDocument_, variables: variables }
    }
export const GetTaxonomyPortfolioReportDocument_ = gql`
    query getTaxonomyPortfolioReport($portfolioId: uuid!, $year: Int!, $quarter: QuarterEnum_enum!) {
  TaxonomyPortfolioReport(
    where: {portfolioId: {_eq: $portfolioId}, year: {_eq: $year}, quarter: {_eq: $quarter}}
  ) {
    id
    year
    sendOutDate
    contactPersonId
    dueDate
    quarter
  }
}
    `;

/**
 * __useGetTaxonomyPortfolioReportQuery__
 *
 * To run a query within a React component, call `useGetTaxonomyPortfolioReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTaxonomyPortfolioReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTaxonomyPortfolioReportQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      year: // value for 'year'
 *      quarter: // value for 'quarter'
 *   },
 * });
 */
export function useGetTaxonomyPortfolioReportQuery(baseOptions: Apollo.QueryHookOptions<GetTaxonomyPortfolioReportQuery_, GetTaxonomyPortfolioReportQueryVariables_> & ({ variables: GetTaxonomyPortfolioReportQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTaxonomyPortfolioReportQuery_, GetTaxonomyPortfolioReportQueryVariables_>(GetTaxonomyPortfolioReportDocument_, options);
      }
export function useGetTaxonomyPortfolioReportLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetTaxonomyPortfolioReportQuery_, GetTaxonomyPortfolioReportQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTaxonomyPortfolioReportQuery_, GetTaxonomyPortfolioReportQueryVariables_>(GetTaxonomyPortfolioReportDocument_, options);
        }
export function useGetTaxonomyPortfolioReportSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTaxonomyPortfolioReportQuery_, GetTaxonomyPortfolioReportQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTaxonomyPortfolioReportQuery_, GetTaxonomyPortfolioReportQueryVariables_>(GetTaxonomyPortfolioReportDocument_, options);
        }
export type GetTaxonomyPortfolioReportQueryHookResult = ReturnType<typeof useGetTaxonomyPortfolioReportQuery>;
export type GetTaxonomyPortfolioReportLazyQuery_HookResult = ReturnType<typeof useGetTaxonomyPortfolioReportLazyQuery_>;
export type GetTaxonomyPortfolioReportSuspenseQuery_HookResult = ReturnType<typeof useGetTaxonomyPortfolioReportSuspenseQuery_>;
export type GetTaxonomyPortfolioReportQueryResult_ = Apollo.QueryResult<GetTaxonomyPortfolioReportQuery_, GetTaxonomyPortfolioReportQueryVariables_>;
export function refetchGetTaxonomyPortfolioReportQuery_(variables: GetTaxonomyPortfolioReportQueryVariables_) {
      return { query: GetTaxonomyPortfolioReportDocument_, variables: variables }
    }
export const PortfolioCompaniesDocument_ = gql`
    query portfolioCompanies($portfolioId: uuid!) {
  portfolioCompanies: PortfolioCompany(where: {portfolioId: {_eq: $portfolioId}}) {
    contactPersonEmail
    company {
      id
      users {
        user {
          email
        }
      }
    }
  }
}
    `;

/**
 * __usePortfolioCompaniesQuery__
 *
 * To run a query within a React component, call `usePortfolioCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfolioCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfolioCompaniesQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *   },
 * });
 */
export function usePortfolioCompaniesQuery(baseOptions: Apollo.QueryHookOptions<PortfolioCompaniesQuery_, PortfolioCompaniesQueryVariables_> & ({ variables: PortfolioCompaniesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortfolioCompaniesQuery_, PortfolioCompaniesQueryVariables_>(PortfolioCompaniesDocument_, options);
      }
export function usePortfolioCompaniesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<PortfolioCompaniesQuery_, PortfolioCompaniesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortfolioCompaniesQuery_, PortfolioCompaniesQueryVariables_>(PortfolioCompaniesDocument_, options);
        }
export function usePortfolioCompaniesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PortfolioCompaniesQuery_, PortfolioCompaniesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PortfolioCompaniesQuery_, PortfolioCompaniesQueryVariables_>(PortfolioCompaniesDocument_, options);
        }
export type PortfolioCompaniesQueryHookResult = ReturnType<typeof usePortfolioCompaniesQuery>;
export type PortfolioCompaniesLazyQuery_HookResult = ReturnType<typeof usePortfolioCompaniesLazyQuery_>;
export type PortfolioCompaniesSuspenseQuery_HookResult = ReturnType<typeof usePortfolioCompaniesSuspenseQuery_>;
export type PortfolioCompaniesQueryResult_ = Apollo.QueryResult<PortfolioCompaniesQuery_, PortfolioCompaniesQueryVariables_>;
export function refetchPortfolioCompaniesQuery_(variables: PortfolioCompaniesQueryVariables_) {
      return { query: PortfolioCompaniesDocument_, variables: variables }
    }
export const ToggleShareAssessmentWithPortfolioDocument_ = gql`
    mutation toggleShareAssessmentWithPortfolio($object: PortfolioCompany_insert_input!) {
  insert_PortfolioCompany_one(
    object: $object
    on_conflict: {constraint: PortfolioCompany_pkey, update_columns: [sharedCompanyAssessmentId]}
  ) {
    id
    sharedCompanyAssessmentId
    sharedAssessment {
      id
    }
  }
}
    `;
export type ToggleShareAssessmentWithPortfolioMutationFn_ = Apollo.MutationFunction<ToggleShareAssessmentWithPortfolioMutation_, ToggleShareAssessmentWithPortfolioMutationVariables_>;

/**
 * __useToggleShareAssessmentWithPortfolioMutation__
 *
 * To run a mutation, you first call `useToggleShareAssessmentWithPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleShareAssessmentWithPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleShareAssessmentWithPortfolioMutation, { data, loading, error }] = useToggleShareAssessmentWithPortfolioMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useToggleShareAssessmentWithPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<ToggleShareAssessmentWithPortfolioMutation_, ToggleShareAssessmentWithPortfolioMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleShareAssessmentWithPortfolioMutation_, ToggleShareAssessmentWithPortfolioMutationVariables_>(ToggleShareAssessmentWithPortfolioDocument_, options);
      }
export type ToggleShareAssessmentWithPortfolioMutationHookResult = ReturnType<typeof useToggleShareAssessmentWithPortfolioMutation>;
export type ToggleShareAssessmentWithPortfolioMutationResult_ = Apollo.MutationResult<ToggleShareAssessmentWithPortfolioMutation_>;
export type ToggleShareAssessmentWithPortfolioMutationOptions_ = Apollo.BaseMutationOptions<ToggleShareAssessmentWithPortfolioMutation_, ToggleShareAssessmentWithPortfolioMutationVariables_>;
export const UpsertPortfolioCompaniesReportingPeriodsDocument_ = gql`
    mutation upsertPortfolioCompaniesReportingPeriods($objects: [PortfolioCompany_insert_input!]!) {
  insert_PortfolioCompany(
    objects: $objects
    on_conflict: {constraint: PortfolioCompany_portfolioId_companyId_year_quarter_key, update_columns: [year]}
  ) {
    returning {
      id
      year
    }
  }
}
    `;
export type UpsertPortfolioCompaniesReportingPeriodsMutationFn_ = Apollo.MutationFunction<UpsertPortfolioCompaniesReportingPeriodsMutation_, UpsertPortfolioCompaniesReportingPeriodsMutationVariables_>;

/**
 * __useUpsertPortfolioCompaniesReportingPeriodsMutation__
 *
 * To run a mutation, you first call `useUpsertPortfolioCompaniesReportingPeriodsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPortfolioCompaniesReportingPeriodsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPortfolioCompaniesReportingPeriodsMutation, { data, loading, error }] = useUpsertPortfolioCompaniesReportingPeriodsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertPortfolioCompaniesReportingPeriodsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPortfolioCompaniesReportingPeriodsMutation_, UpsertPortfolioCompaniesReportingPeriodsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPortfolioCompaniesReportingPeriodsMutation_, UpsertPortfolioCompaniesReportingPeriodsMutationVariables_>(UpsertPortfolioCompaniesReportingPeriodsDocument_, options);
      }
export type UpsertPortfolioCompaniesReportingPeriodsMutationHookResult = ReturnType<typeof useUpsertPortfolioCompaniesReportingPeriodsMutation>;
export type UpsertPortfolioCompaniesReportingPeriodsMutationResult_ = Apollo.MutationResult<UpsertPortfolioCompaniesReportingPeriodsMutation_>;
export type UpsertPortfolioCompaniesReportingPeriodsMutationOptions_ = Apollo.BaseMutationOptions<UpsertPortfolioCompaniesReportingPeriodsMutation_, UpsertPortfolioCompaniesReportingPeriodsMutationVariables_>;
export const UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintDocument_ = gql`
    mutation upsertPortfolioCompaniesReportingPeriodsWithPKeyConstraint($objects: [PortfolioCompany_insert_input!]!) {
  insert_PortfolioCompany(
    objects: $objects
    on_conflict: {constraint: PortfolioCompany_pkey, update_columns: [year]}
  ) {
    returning {
      id
      year
    }
  }
}
    `;
export type UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutationFn_ = Apollo.MutationFunction<UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutation_, UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutationVariables_>;

/**
 * __useUpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutation__
 *
 * To run a mutation, you first call `useUpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutation, { data, loading, error }] = useUpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutation_, UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutation_, UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutationVariables_>(UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintDocument_, options);
      }
export type UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutationHookResult = ReturnType<typeof useUpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutation>;
export type UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutationResult_ = Apollo.MutationResult<UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutation_>;
export type UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutationOptions_ = Apollo.BaseMutationOptions<UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutation_, UpsertPortfolioCompaniesReportingPeriodsWithPKeyConstraintMutationVariables_>;
export const ToggleSharePaiWithPortfolioDocument_ = gql`
    mutation toggleSharePAIWithPortfolio($objects: [PortfolioCompany_insert_input!]!) {
  insert_PortfolioCompany(
    objects: $objects
    on_conflict: {constraint: PortfolioCompany_portfolioId_companyId_year_quarter_key, update_columns: [sharedPaiCompanyReportId, sharedPaiCompanyReportQ1Id, sharedPaiCompanyReportQ2Id, sharedPaiCompanyReportQ3Id, sharedPaiCompanyReportQ4Id]}
  ) {
    affected_rows
  }
}
    `;
export type ToggleSharePaiWithPortfolioMutationFn_ = Apollo.MutationFunction<ToggleSharePaiWithPortfolioMutation_, ToggleSharePaiWithPortfolioMutationVariables_>;

/**
 * __useToggleSharePaiWithPortfolioMutation__
 *
 * To run a mutation, you first call `useToggleSharePaiWithPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleSharePaiWithPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleSharePaiWithPortfolioMutation, { data, loading, error }] = useToggleSharePaiWithPortfolioMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useToggleSharePaiWithPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<ToggleSharePaiWithPortfolioMutation_, ToggleSharePaiWithPortfolioMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleSharePaiWithPortfolioMutation_, ToggleSharePaiWithPortfolioMutationVariables_>(ToggleSharePaiWithPortfolioDocument_, options);
      }
export type ToggleSharePaiWithPortfolioMutationHookResult = ReturnType<typeof useToggleSharePaiWithPortfolioMutation>;
export type ToggleSharePaiWithPortfolioMutationResult_ = Apollo.MutationResult<ToggleSharePaiWithPortfolioMutation_>;
export type ToggleSharePaiWithPortfolioMutationOptions_ = Apollo.BaseMutationOptions<ToggleSharePaiWithPortfolioMutation_, ToggleSharePaiWithPortfolioMutationVariables_>;
export const UpsertPortfolioDocument_ = gql`
    mutation upsertPortfolio($portfolio: Portfolio_insert_input!) {
  portfolio: insert_Portfolio_one(
    object: $portfolio
    on_conflict: {constraint: Portfolio_pkey, update_columns: [name, totalAmount, description]}
  ) {
    ...PortfolioFields
    ...UpdateOwnerCompanyFields
  }
}
    ${PortfolioFieldsFragmentDoc_}
${UpdateOwnerCompanyFieldsFragmentDoc_}`;
export type UpsertPortfolioMutationFn_ = Apollo.MutationFunction<UpsertPortfolioMutation_, UpsertPortfolioMutationVariables_>;

/**
 * __useUpsertPortfolioMutation__
 *
 * To run a mutation, you first call `useUpsertPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPortfolioMutation, { data, loading, error }] = useUpsertPortfolioMutation({
 *   variables: {
 *      portfolio: // value for 'portfolio'
 *   },
 * });
 */
export function useUpsertPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPortfolioMutation_, UpsertPortfolioMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPortfolioMutation_, UpsertPortfolioMutationVariables_>(UpsertPortfolioDocument_, options);
      }
export type UpsertPortfolioMutationHookResult = ReturnType<typeof useUpsertPortfolioMutation>;
export type UpsertPortfolioMutationResult_ = Apollo.MutationResult<UpsertPortfolioMutation_>;
export type UpsertPortfolioMutationOptions_ = Apollo.BaseMutationOptions<UpsertPortfolioMutation_, UpsertPortfolioMutationVariables_>;
export const CreatePortfolioCompaniesDocument_ = gql`
    mutation createPortfolioCompanies($companies: [CompanyUser_insert_input!]!) {
  result: insert_CompanyUser(objects: $companies) {
    returning {
      company {
        ...CompanyShort
      }
    }
  }
}
    ${CompanyShortFragmentDoc_}`;
export type CreatePortfolioCompaniesMutationFn_ = Apollo.MutationFunction<CreatePortfolioCompaniesMutation_, CreatePortfolioCompaniesMutationVariables_>;

/**
 * __useCreatePortfolioCompaniesMutation__
 *
 * To run a mutation, you first call `useCreatePortfolioCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePortfolioCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPortfolioCompaniesMutation, { data, loading, error }] = useCreatePortfolioCompaniesMutation({
 *   variables: {
 *      companies: // value for 'companies'
 *   },
 * });
 */
export function useCreatePortfolioCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<CreatePortfolioCompaniesMutation_, CreatePortfolioCompaniesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePortfolioCompaniesMutation_, CreatePortfolioCompaniesMutationVariables_>(CreatePortfolioCompaniesDocument_, options);
      }
export type CreatePortfolioCompaniesMutationHookResult = ReturnType<typeof useCreatePortfolioCompaniesMutation>;
export type CreatePortfolioCompaniesMutationResult_ = Apollo.MutationResult<CreatePortfolioCompaniesMutation_>;
export type CreatePortfolioCompaniesMutationOptions_ = Apollo.BaseMutationOptions<CreatePortfolioCompaniesMutation_, CreatePortfolioCompaniesMutationVariables_>;
export const UpdatePortfolioCompanyDocument_ = gql`
    mutation updatePortfolioCompany($id: uuid!, $data: PortfolioCompany_set_input) {
  portfolioCompany: update_PortfolioCompany_by_pk(
    pk_columns: {id: $id}
    _set: $data
  ) {
    ...PortfolioCompany
  }
}
    ${PortfolioCompanyFragmentDoc_}`;
export type UpdatePortfolioCompanyMutationFn_ = Apollo.MutationFunction<UpdatePortfolioCompanyMutation_, UpdatePortfolioCompanyMutationVariables_>;

/**
 * __useUpdatePortfolioCompanyMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortfolioCompanyMutation, { data, loading, error }] = useUpdatePortfolioCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePortfolioCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortfolioCompanyMutation_, UpdatePortfolioCompanyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortfolioCompanyMutation_, UpdatePortfolioCompanyMutationVariables_>(UpdatePortfolioCompanyDocument_, options);
      }
export type UpdatePortfolioCompanyMutationHookResult = ReturnType<typeof useUpdatePortfolioCompanyMutation>;
export type UpdatePortfolioCompanyMutationResult_ = Apollo.MutationResult<UpdatePortfolioCompanyMutation_>;
export type UpdatePortfolioCompanyMutationOptions_ = Apollo.BaseMutationOptions<UpdatePortfolioCompanyMutation_, UpdatePortfolioCompanyMutationVariables_>;
export const UploadPortfolioCompanyScoreDocument_ = gql`
    mutation uploadPortfolioCompanyScore($portfolioId: uuid!, $companyId: uuid!, $scores: jsonb) {
  portfolioCompany: update_PortfolioCompany(
    where: {portfolioId: {_eq: $portfolioId}, _and: {companyId: {_eq: $companyId}}}
    _set: {scores: $scores}
  ) {
    returning {
      ...UserPortfolioCompany
    }
  }
}
    ${UserPortfolioCompanyFragmentDoc_}`;
export type UploadPortfolioCompanyScoreMutationFn_ = Apollo.MutationFunction<UploadPortfolioCompanyScoreMutation_, UploadPortfolioCompanyScoreMutationVariables_>;

/**
 * __useUploadPortfolioCompanyScoreMutation__
 *
 * To run a mutation, you first call `useUploadPortfolioCompanyScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPortfolioCompanyScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPortfolioCompanyScoreMutation, { data, loading, error }] = useUploadPortfolioCompanyScoreMutation({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      companyId: // value for 'companyId'
 *      scores: // value for 'scores'
 *   },
 * });
 */
export function useUploadPortfolioCompanyScoreMutation(baseOptions?: Apollo.MutationHookOptions<UploadPortfolioCompanyScoreMutation_, UploadPortfolioCompanyScoreMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadPortfolioCompanyScoreMutation_, UploadPortfolioCompanyScoreMutationVariables_>(UploadPortfolioCompanyScoreDocument_, options);
      }
export type UploadPortfolioCompanyScoreMutationHookResult = ReturnType<typeof useUploadPortfolioCompanyScoreMutation>;
export type UploadPortfolioCompanyScoreMutationResult_ = Apollo.MutationResult<UploadPortfolioCompanyScoreMutation_>;
export type UploadPortfolioCompanyScoreMutationOptions_ = Apollo.BaseMutationOptions<UploadPortfolioCompanyScoreMutation_, UploadPortfolioCompanyScoreMutationVariables_>;
export const DeletePortfolioCompanyDocument_ = gql`
    mutation deletePortfolioCompany($id: uuid!) {
  portfolioCompany: delete_PortfolioCompany_by_pk(id: $id) {
    ...PortfolioCompany
    portfolio {
      id
      portfolioCompanies {
        id
      }
    }
  }
}
    ${PortfolioCompanyFragmentDoc_}`;
export type DeletePortfolioCompanyMutationFn_ = Apollo.MutationFunction<DeletePortfolioCompanyMutation_, DeletePortfolioCompanyMutationVariables_>;

/**
 * __useDeletePortfolioCompanyMutation__
 *
 * To run a mutation, you first call `useDeletePortfolioCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePortfolioCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePortfolioCompanyMutation, { data, loading, error }] = useDeletePortfolioCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePortfolioCompanyMutation(baseOptions?: Apollo.MutationHookOptions<DeletePortfolioCompanyMutation_, DeletePortfolioCompanyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePortfolioCompanyMutation_, DeletePortfolioCompanyMutationVariables_>(DeletePortfolioCompanyDocument_, options);
      }
export type DeletePortfolioCompanyMutationHookResult = ReturnType<typeof useDeletePortfolioCompanyMutation>;
export type DeletePortfolioCompanyMutationResult_ = Apollo.MutationResult<DeletePortfolioCompanyMutation_>;
export type DeletePortfolioCompanyMutationOptions_ = Apollo.BaseMutationOptions<DeletePortfolioCompanyMutation_, DeletePortfolioCompanyMutationVariables_>;
export const UpsertPortfolioCompanyDocument_ = gql`
    mutation upsertPortfolioCompany($portfolioCompany: PortfolioCompany_insert_input!) {
  portfolioCompany: insert_PortfolioCompany_one(
    object: $portfolioCompany
    on_conflict: {constraint: PortfolioCompany_portfolioId_companyId_year_quarter_key, update_columns: [contactPersonEmail, contactPersonName, marketValue, eligibilityStatus, valueOfInvestments, year]}
  ) {
    ...PortfolioCompany
    portfolio {
      id
      portfolioCompanies {
        id
      }
    }
  }
}
    ${PortfolioCompanyFragmentDoc_}`;
export type UpsertPortfolioCompanyMutationFn_ = Apollo.MutationFunction<UpsertPortfolioCompanyMutation_, UpsertPortfolioCompanyMutationVariables_>;

/**
 * __useUpsertPortfolioCompanyMutation__
 *
 * To run a mutation, you first call `useUpsertPortfolioCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPortfolioCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPortfolioCompanyMutation, { data, loading, error }] = useUpsertPortfolioCompanyMutation({
 *   variables: {
 *      portfolioCompany: // value for 'portfolioCompany'
 *   },
 * });
 */
export function useUpsertPortfolioCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPortfolioCompanyMutation_, UpsertPortfolioCompanyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPortfolioCompanyMutation_, UpsertPortfolioCompanyMutationVariables_>(UpsertPortfolioCompanyDocument_, options);
      }
export type UpsertPortfolioCompanyMutationHookResult = ReturnType<typeof useUpsertPortfolioCompanyMutation>;
export type UpsertPortfolioCompanyMutationResult_ = Apollo.MutationResult<UpsertPortfolioCompanyMutation_>;
export type UpsertPortfolioCompanyMutationOptions_ = Apollo.BaseMutationOptions<UpsertPortfolioCompanyMutation_, UpsertPortfolioCompanyMutationVariables_>;
export const UpsertPortfolioCompaniesDocument_ = gql`
    mutation upsertPortfolioCompanies($portfolioCompanies: [PortfolioCompany_insert_input!]!) {
  portfolioCompanies: insert_PortfolioCompany(
    objects: $portfolioCompanies
    on_conflict: {constraint: PortfolioCompany_portfolioId_companyId_year_quarter_key, update_columns: [marketValue, year]}
  ) {
    affected_rows
    returning {
      id
      company {
        id
      }
    }
  }
}
    `;
export type UpsertPortfolioCompaniesMutationFn_ = Apollo.MutationFunction<UpsertPortfolioCompaniesMutation_, UpsertPortfolioCompaniesMutationVariables_>;

/**
 * __useUpsertPortfolioCompaniesMutation__
 *
 * To run a mutation, you first call `useUpsertPortfolioCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPortfolioCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPortfolioCompaniesMutation, { data, loading, error }] = useUpsertPortfolioCompaniesMutation({
 *   variables: {
 *      portfolioCompanies: // value for 'portfolioCompanies'
 *   },
 * });
 */
export function useUpsertPortfolioCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPortfolioCompaniesMutation_, UpsertPortfolioCompaniesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPortfolioCompaniesMutation_, UpsertPortfolioCompaniesMutationVariables_>(UpsertPortfolioCompaniesDocument_, options);
      }
export type UpsertPortfolioCompaniesMutationHookResult = ReturnType<typeof useUpsertPortfolioCompaniesMutation>;
export type UpsertPortfolioCompaniesMutationResult_ = Apollo.MutationResult<UpsertPortfolioCompaniesMutation_>;
export type UpsertPortfolioCompaniesMutationOptions_ = Apollo.BaseMutationOptions<UpsertPortfolioCompaniesMutation_, UpsertPortfolioCompaniesMutationVariables_>;
export const DeletePortfolioDocument_ = gql`
    mutation deletePortfolio($id: uuid!) {
  portfolio: update_Portfolio_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    ...PortfolioFields
    ...UpdateOwnerCompanyFields
  }
}
    ${PortfolioFieldsFragmentDoc_}
${UpdateOwnerCompanyFieldsFragmentDoc_}`;
export type DeletePortfolioMutationFn_ = Apollo.MutationFunction<DeletePortfolioMutation_, DeletePortfolioMutationVariables_>;

/**
 * __useDeletePortfolioMutation__
 *
 * To run a mutation, you first call `useDeletePortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePortfolioMutation, { data, loading, error }] = useDeletePortfolioMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePortfolioMutation(baseOptions?: Apollo.MutationHookOptions<DeletePortfolioMutation_, DeletePortfolioMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePortfolioMutation_, DeletePortfolioMutationVariables_>(DeletePortfolioDocument_, options);
      }
export type DeletePortfolioMutationHookResult = ReturnType<typeof useDeletePortfolioMutation>;
export type DeletePortfolioMutationResult_ = Apollo.MutationResult<DeletePortfolioMutation_>;
export type DeletePortfolioMutationOptions_ = Apollo.BaseMutationOptions<DeletePortfolioMutation_, DeletePortfolioMutationVariables_>;
export const InsertPortfolioCompaniesDocument_ = gql`
    mutation InsertPortfolioCompanies($objects: [PortfolioCompany_insert_input!]!) {
  insert_PortfolioCompany(
    objects: $objects
    on_conflict: {constraint: PortfolioCompany_portfolioId_estimateCompanyId_fd25d65d_uniq, update_columns: [marketValue]}
  ) {
    affected_rows
  }
}
    `;
export type InsertPortfolioCompaniesMutationFn_ = Apollo.MutationFunction<InsertPortfolioCompaniesMutation_, InsertPortfolioCompaniesMutationVariables_>;

/**
 * __useInsertPortfolioCompaniesMutation__
 *
 * To run a mutation, you first call `useInsertPortfolioCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPortfolioCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPortfolioCompaniesMutation, { data, loading, error }] = useInsertPortfolioCompaniesMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertPortfolioCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<InsertPortfolioCompaniesMutation_, InsertPortfolioCompaniesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPortfolioCompaniesMutation_, InsertPortfolioCompaniesMutationVariables_>(InsertPortfolioCompaniesDocument_, options);
      }
export type InsertPortfolioCompaniesMutationHookResult = ReturnType<typeof useInsertPortfolioCompaniesMutation>;
export type InsertPortfolioCompaniesMutationResult_ = Apollo.MutationResult<InsertPortfolioCompaniesMutation_>;
export type InsertPortfolioCompaniesMutationOptions_ = Apollo.BaseMutationOptions<InsertPortfolioCompaniesMutation_, InsertPortfolioCompaniesMutationVariables_>;
export const NudgePortfolioCompaniesDocument_ = gql`
    mutation nudgePortfolioCompanies($recipients: [EmailItem!]!, $data: NudgePortfolioCompaniesInput!) {
  nudgePortfolioCompanies(recipients: $recipients, data: $data) {
    ...NudgePortfolioCompaniesFields
  }
}
    ${NudgePortfolioCompaniesFieldsFragmentDoc_}`;
export type NudgePortfolioCompaniesMutationFn_ = Apollo.MutationFunction<NudgePortfolioCompaniesMutation_, NudgePortfolioCompaniesMutationVariables_>;

/**
 * __useNudgePortfolioCompaniesMutation__
 *
 * To run a mutation, you first call `useNudgePortfolioCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNudgePortfolioCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nudgePortfolioCompaniesMutation, { data, loading, error }] = useNudgePortfolioCompaniesMutation({
 *   variables: {
 *      recipients: // value for 'recipients'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNudgePortfolioCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<NudgePortfolioCompaniesMutation_, NudgePortfolioCompaniesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NudgePortfolioCompaniesMutation_, NudgePortfolioCompaniesMutationVariables_>(NudgePortfolioCompaniesDocument_, options);
      }
export type NudgePortfolioCompaniesMutationHookResult = ReturnType<typeof useNudgePortfolioCompaniesMutation>;
export type NudgePortfolioCompaniesMutationResult_ = Apollo.MutationResult<NudgePortfolioCompaniesMutation_>;
export type NudgePortfolioCompaniesMutationOptions_ = Apollo.BaseMutationOptions<NudgePortfolioCompaniesMutation_, NudgePortfolioCompaniesMutationVariables_>;
export const NudgeGroupCompaniesDocument_ = gql`
    mutation nudgeGroupCompanies($recipients: [EmailItem!]!, $data: NudgeGroupCompaniesInput!) {
  nudgeGroupCompanies(recipients: $recipients, data: $data) {
    ...NudgeGroupCompaniesFields
  }
}
    ${NudgeGroupCompaniesFieldsFragmentDoc_}`;
export type NudgeGroupCompaniesMutationFn_ = Apollo.MutationFunction<NudgeGroupCompaniesMutation_, NudgeGroupCompaniesMutationVariables_>;

/**
 * __useNudgeGroupCompaniesMutation__
 *
 * To run a mutation, you first call `useNudgeGroupCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNudgeGroupCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nudgeGroupCompaniesMutation, { data, loading, error }] = useNudgeGroupCompaniesMutation({
 *   variables: {
 *      recipients: // value for 'recipients'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useNudgeGroupCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<NudgeGroupCompaniesMutation_, NudgeGroupCompaniesMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NudgeGroupCompaniesMutation_, NudgeGroupCompaniesMutationVariables_>(NudgeGroupCompaniesDocument_, options);
      }
export type NudgeGroupCompaniesMutationHookResult = ReturnType<typeof useNudgeGroupCompaniesMutation>;
export type NudgeGroupCompaniesMutationResult_ = Apollo.MutationResult<NudgeGroupCompaniesMutation_>;
export type NudgeGroupCompaniesMutationOptions_ = Apollo.BaseMutationOptions<NudgeGroupCompaniesMutation_, NudgeGroupCompaniesMutationVariables_>;
export const UpsertPortfolioCompaniesFinancialsDocument_ = gql`
    mutation upsertPortfolioCompaniesFinancials($portfolioCompanies: [PortfolioCompany_insert_input!]!) {
  insert_PortfolioCompany(
    objects: $portfolioCompanies
    on_conflict: {constraint: PortfolioCompany_pkey, update_columns: valueOfInvestments}
  ) {
    affected_rows
    returning {
      valueOfInvestments
    }
  }
}
    `;
export type UpsertPortfolioCompaniesFinancialsMutationFn_ = Apollo.MutationFunction<UpsertPortfolioCompaniesFinancialsMutation_, UpsertPortfolioCompaniesFinancialsMutationVariables_>;

/**
 * __useUpsertPortfolioCompaniesFinancialsMutation__
 *
 * To run a mutation, you first call `useUpsertPortfolioCompaniesFinancialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPortfolioCompaniesFinancialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPortfolioCompaniesFinancialsMutation, { data, loading, error }] = useUpsertPortfolioCompaniesFinancialsMutation({
 *   variables: {
 *      portfolioCompanies: // value for 'portfolioCompanies'
 *   },
 * });
 */
export function useUpsertPortfolioCompaniesFinancialsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPortfolioCompaniesFinancialsMutation_, UpsertPortfolioCompaniesFinancialsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPortfolioCompaniesFinancialsMutation_, UpsertPortfolioCompaniesFinancialsMutationVariables_>(UpsertPortfolioCompaniesFinancialsDocument_, options);
      }
export type UpsertPortfolioCompaniesFinancialsMutationHookResult = ReturnType<typeof useUpsertPortfolioCompaniesFinancialsMutation>;
export type UpsertPortfolioCompaniesFinancialsMutationResult_ = Apollo.MutationResult<UpsertPortfolioCompaniesFinancialsMutation_>;
export type UpsertPortfolioCompaniesFinancialsMutationOptions_ = Apollo.BaseMutationOptions<UpsertPortfolioCompaniesFinancialsMutation_, UpsertPortfolioCompaniesFinancialsMutationVariables_>;
export const UpdatePortfolioCompanyMarketValueDocument_ = gql`
    mutation updatePortfolioCompanyMarketValue($portfolioCompanyId: uuid!, $newMarketValue: numeric) {
  portfolioCompany: update_PortfolioCompany(
    where: {id: {_eq: $portfolioCompanyId}}
    _set: {marketValue: $newMarketValue}
  ) {
    affected_rows
    returning {
      id
      companyId
      company {
        name
      }
      marketValue
    }
  }
}
    `;
export type UpdatePortfolioCompanyMarketValueMutationFn_ = Apollo.MutationFunction<UpdatePortfolioCompanyMarketValueMutation_, UpdatePortfolioCompanyMarketValueMutationVariables_>;

/**
 * __useUpdatePortfolioCompanyMarketValueMutation__
 *
 * To run a mutation, you first call `useUpdatePortfolioCompanyMarketValueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePortfolioCompanyMarketValueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePortfolioCompanyMarketValueMutation, { data, loading, error }] = useUpdatePortfolioCompanyMarketValueMutation({
 *   variables: {
 *      portfolioCompanyId: // value for 'portfolioCompanyId'
 *      newMarketValue: // value for 'newMarketValue'
 *   },
 * });
 */
export function useUpdatePortfolioCompanyMarketValueMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePortfolioCompanyMarketValueMutation_, UpdatePortfolioCompanyMarketValueMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePortfolioCompanyMarketValueMutation_, UpdatePortfolioCompanyMarketValueMutationVariables_>(UpdatePortfolioCompanyMarketValueDocument_, options);
      }
export type UpdatePortfolioCompanyMarketValueMutationHookResult = ReturnType<typeof useUpdatePortfolioCompanyMarketValueMutation>;
export type UpdatePortfolioCompanyMarketValueMutationResult_ = Apollo.MutationResult<UpdatePortfolioCompanyMarketValueMutation_>;
export type UpdatePortfolioCompanyMarketValueMutationOptions_ = Apollo.BaseMutationOptions<UpdatePortfolioCompanyMarketValueMutation_, UpdatePortfolioCompanyMarketValueMutationVariables_>;
export const UpsertTaxonomyPortfolioDocument_ = gql`
    mutation upsertTaxonomyPortfolio($object: TaxonomyPortfolioReport_insert_input!) {
  insert_TaxonomyPortfolioReport_one(
    object: $object
    on_conflict: {constraint: TaxonomyPortfolioReport_year_portfolioId_quarter_key, update_columns: [contactPersonId, sendOutDate, dueDate, year, quarter]}
  ) {
    id
    year
    sendOutDate
    dueDate
    contactPersonId
    quarter
  }
}
    `;
export type UpsertTaxonomyPortfolioMutationFn_ = Apollo.MutationFunction<UpsertTaxonomyPortfolioMutation_, UpsertTaxonomyPortfolioMutationVariables_>;

/**
 * __useUpsertTaxonomyPortfolioMutation__
 *
 * To run a mutation, you first call `useUpsertTaxonomyPortfolioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTaxonomyPortfolioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTaxonomyPortfolioMutation, { data, loading, error }] = useUpsertTaxonomyPortfolioMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useUpsertTaxonomyPortfolioMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTaxonomyPortfolioMutation_, UpsertTaxonomyPortfolioMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTaxonomyPortfolioMutation_, UpsertTaxonomyPortfolioMutationVariables_>(UpsertTaxonomyPortfolioDocument_, options);
      }
export type UpsertTaxonomyPortfolioMutationHookResult = ReturnType<typeof useUpsertTaxonomyPortfolioMutation>;
export type UpsertTaxonomyPortfolioMutationResult_ = Apollo.MutationResult<UpsertTaxonomyPortfolioMutation_>;
export type UpsertTaxonomyPortfolioMutationOptions_ = Apollo.BaseMutationOptions<UpsertTaxonomyPortfolioMutation_, UpsertTaxonomyPortfolioMutationVariables_>;
export const UpsertPortfolioNonEligibleFinancialsDocument_ = gql`
    mutation upsertPortfolioNonEligibleFinancials($objects: [PortfolioNonEligibleFinancials_insert_input!]!) {
  insert_PortfolioNonEligibleFinancials(
    objects: $objects
    on_conflict: {constraint: PortfolioNonEligibleFinancial_portfolioId_year_type_quarter_key, update_columns: [value, isSelected]}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpsertPortfolioNonEligibleFinancialsMutationFn_ = Apollo.MutationFunction<UpsertPortfolioNonEligibleFinancialsMutation_, UpsertPortfolioNonEligibleFinancialsMutationVariables_>;

/**
 * __useUpsertPortfolioNonEligibleFinancialsMutation__
 *
 * To run a mutation, you first call `useUpsertPortfolioNonEligibleFinancialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertPortfolioNonEligibleFinancialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertPortfolioNonEligibleFinancialsMutation, { data, loading, error }] = useUpsertPortfolioNonEligibleFinancialsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertPortfolioNonEligibleFinancialsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertPortfolioNonEligibleFinancialsMutation_, UpsertPortfolioNonEligibleFinancialsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertPortfolioNonEligibleFinancialsMutation_, UpsertPortfolioNonEligibleFinancialsMutationVariables_>(UpsertPortfolioNonEligibleFinancialsDocument_, options);
      }
export type UpsertPortfolioNonEligibleFinancialsMutationHookResult = ReturnType<typeof useUpsertPortfolioNonEligibleFinancialsMutation>;
export type UpsertPortfolioNonEligibleFinancialsMutationResult_ = Apollo.MutationResult<UpsertPortfolioNonEligibleFinancialsMutation_>;
export type UpsertPortfolioNonEligibleFinancialsMutationOptions_ = Apollo.BaseMutationOptions<UpsertPortfolioNonEligibleFinancialsMutation_, UpsertPortfolioNonEligibleFinancialsMutationVariables_>;
export const GetPortfolioNonEligibleFinancialsDocument_ = gql`
    query getPortfolioNonEligibleFinancials($portfolioId: uuid!, $year: Int!, $quarter: QuarterEnum_enum!) {
  PortfolioNonEligibleFinancials(
    where: {portfolioId: {_eq: $portfolioId}, year: {_eq: $year}, quarter: {_eq: $quarter}}
  ) {
    id
    value
    type
    isSelected
  }
}
    `;

/**
 * __useGetPortfolioNonEligibleFinancialsQuery__
 *
 * To run a query within a React component, call `useGetPortfolioNonEligibleFinancialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioNonEligibleFinancialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioNonEligibleFinancialsQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      year: // value for 'year'
 *      quarter: // value for 'quarter'
 *   },
 * });
 */
export function useGetPortfolioNonEligibleFinancialsQuery(baseOptions: Apollo.QueryHookOptions<GetPortfolioNonEligibleFinancialsQuery_, GetPortfolioNonEligibleFinancialsQueryVariables_> & ({ variables: GetPortfolioNonEligibleFinancialsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPortfolioNonEligibleFinancialsQuery_, GetPortfolioNonEligibleFinancialsQueryVariables_>(GetPortfolioNonEligibleFinancialsDocument_, options);
      }
export function useGetPortfolioNonEligibleFinancialsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioNonEligibleFinancialsQuery_, GetPortfolioNonEligibleFinancialsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPortfolioNonEligibleFinancialsQuery_, GetPortfolioNonEligibleFinancialsQueryVariables_>(GetPortfolioNonEligibleFinancialsDocument_, options);
        }
export function useGetPortfolioNonEligibleFinancialsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPortfolioNonEligibleFinancialsQuery_, GetPortfolioNonEligibleFinancialsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPortfolioNonEligibleFinancialsQuery_, GetPortfolioNonEligibleFinancialsQueryVariables_>(GetPortfolioNonEligibleFinancialsDocument_, options);
        }
export type GetPortfolioNonEligibleFinancialsQueryHookResult = ReturnType<typeof useGetPortfolioNonEligibleFinancialsQuery>;
export type GetPortfolioNonEligibleFinancialsLazyQuery_HookResult = ReturnType<typeof useGetPortfolioNonEligibleFinancialsLazyQuery_>;
export type GetPortfolioNonEligibleFinancialsSuspenseQuery_HookResult = ReturnType<typeof useGetPortfolioNonEligibleFinancialsSuspenseQuery_>;
export type GetPortfolioNonEligibleFinancialsQueryResult_ = Apollo.QueryResult<GetPortfolioNonEligibleFinancialsQuery_, GetPortfolioNonEligibleFinancialsQueryVariables_>;
export function refetchGetPortfolioNonEligibleFinancialsQuery_(variables: GetPortfolioNonEligibleFinancialsQueryVariables_) {
      return { query: GetPortfolioNonEligibleFinancialsDocument_, variables: variables }
    }
export const AllObjectivesDocument_ = gql`
    query allObjectives {
  allObjectives: Objective {
    ...ObjectiveFields
  }
}
    ${ObjectiveFieldsFragmentDoc_}`;

/**
 * __useAllObjectivesQuery__
 *
 * To run a query within a React component, call `useAllObjectivesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllObjectivesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllObjectivesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllObjectivesQuery(baseOptions?: Apollo.QueryHookOptions<AllObjectivesQuery_, AllObjectivesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllObjectivesQuery_, AllObjectivesQueryVariables_>(AllObjectivesDocument_, options);
      }
export function useAllObjectivesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AllObjectivesQuery_, AllObjectivesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllObjectivesQuery_, AllObjectivesQueryVariables_>(AllObjectivesDocument_, options);
        }
export function useAllObjectivesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllObjectivesQuery_, AllObjectivesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllObjectivesQuery_, AllObjectivesQueryVariables_>(AllObjectivesDocument_, options);
        }
export type AllObjectivesQueryHookResult = ReturnType<typeof useAllObjectivesQuery>;
export type AllObjectivesLazyQuery_HookResult = ReturnType<typeof useAllObjectivesLazyQuery_>;
export type AllObjectivesSuspenseQuery_HookResult = ReturnType<typeof useAllObjectivesSuspenseQuery_>;
export type AllObjectivesQueryResult_ = Apollo.QueryResult<AllObjectivesQuery_, AllObjectivesQueryVariables_>;
export function refetchAllObjectivesQuery_(variables?: AllObjectivesQueryVariables_) {
      return { query: AllObjectivesDocument_, variables: variables }
    }
export const AllSectorsDocument_ = gql`
    query allSectors {
  sectors: Sector(where: {reference: {_neq: "0"}}) {
    ...SectorFields
  }
}
    ${SectorFieldsFragmentDoc_}`;

/**
 * __useAllSectorsQuery__
 *
 * To run a query within a React component, call `useAllSectorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSectorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSectorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSectorsQuery(baseOptions?: Apollo.QueryHookOptions<AllSectorsQuery_, AllSectorsQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllSectorsQuery_, AllSectorsQueryVariables_>(AllSectorsDocument_, options);
      }
export function useAllSectorsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AllSectorsQuery_, AllSectorsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllSectorsQuery_, AllSectorsQueryVariables_>(AllSectorsDocument_, options);
        }
export function useAllSectorsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllSectorsQuery_, AllSectorsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllSectorsQuery_, AllSectorsQueryVariables_>(AllSectorsDocument_, options);
        }
export type AllSectorsQueryHookResult = ReturnType<typeof useAllSectorsQuery>;
export type AllSectorsLazyQuery_HookResult = ReturnType<typeof useAllSectorsLazyQuery_>;
export type AllSectorsSuspenseQuery_HookResult = ReturnType<typeof useAllSectorsSuspenseQuery_>;
export type AllSectorsQueryResult_ = Apollo.QueryResult<AllSectorsQuery_, AllSectorsQueryVariables_>;
export function refetchAllSectorsQuery_(variables?: AllSectorsQueryVariables_) {
      return { query: AllSectorsDocument_, variables: variables }
    }
export const AllActivitiesDocument_ = gql`
    query allActivities($showHidden: Boolean = false) {
  allActivities: Activity(
    where: {reference: {_neq: "0.0"}, _or: [{isHidden: {_eq: false}}, {isHidden: {_eq: $showHidden}}]}
  ) {
    ...ActivityFields
  }
}
    ${ActivityFieldsFragmentDoc_}`;

/**
 * __useAllActivitiesQuery__
 *
 * To run a query within a React component, call `useAllActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllActivitiesQuery({
 *   variables: {
 *      showHidden: // value for 'showHidden'
 *   },
 * });
 */
export function useAllActivitiesQuery(baseOptions?: Apollo.QueryHookOptions<AllActivitiesQuery_, AllActivitiesQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllActivitiesQuery_, AllActivitiesQueryVariables_>(AllActivitiesDocument_, options);
      }
export function useAllActivitiesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<AllActivitiesQuery_, AllActivitiesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllActivitiesQuery_, AllActivitiesQueryVariables_>(AllActivitiesDocument_, options);
        }
export function useAllActivitiesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllActivitiesQuery_, AllActivitiesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllActivitiesQuery_, AllActivitiesQueryVariables_>(AllActivitiesDocument_, options);
        }
export type AllActivitiesQueryHookResult = ReturnType<typeof useAllActivitiesQuery>;
export type AllActivitiesLazyQuery_HookResult = ReturnType<typeof useAllActivitiesLazyQuery_>;
export type AllActivitiesSuspenseQuery_HookResult = ReturnType<typeof useAllActivitiesSuspenseQuery_>;
export type AllActivitiesQueryResult_ = Apollo.QueryResult<AllActivitiesQuery_, AllActivitiesQueryVariables_>;
export function refetchAllActivitiesQuery_(variables?: AllActivitiesQueryVariables_) {
      return { query: AllActivitiesDocument_, variables: variables }
    }
export const GetActivityObjectivesStatusDocument_ = gql`
    query getActivityObjectivesStatus($activityRef: String!, $versionNumber: Int!) {
  ActivityVersion(
    where: {activityRef: {_eq: $activityRef}, versionNumber: {_eq: $versionNumber}}
  ) {
    tagObjective
    tagExpression
    activity {
      reference
      name
      canBeEnabling: versions_aggregate(
        where: {versionNumber: {_eq: $versionNumber}, tagExpression: {_ilike: "%ENABLING%"}}
      ) {
        aggregate {
          count
        }
      }
      canBeTransitional: versions_aggregate(
        where: {versionNumber: {_eq: $versionNumber}, tagExpression: {_ilike: "%TRANSITIONAL%"}}
      ) {
        aggregate {
          count
        }
      }
      canBeGreen: versions_aggregate(
        where: {versionNumber: {_eq: $versionNumber}, tagExpression: {_ilike: "%GREEN%"}}
      ) {
        aggregate {
          count
        }
      }
    }
    mitigationSC: activityQuestionSets_aggregate(
      where: {questionSet: {questions: {question: {objectiveKey: {_eq: "mitigation"}, _or: [{level: {_eq: SUBSTANTIAL_CONTRIBUTION}}, {levelExpression: {_ilike: "%SC%"}}]}}}}
    ) {
      aggregate {
        count
      }
    }
    mitigationDNSH: activityQuestionSets_aggregate(
      where: {questionSet: {questions: {question: {objectiveKey: {_eq: "mitigation"}, _or: [{level: {_eq: DO_NO_SIGNIFICANT_HARM}}, {levelExpression: {_ilike: "%DNSH%"}}]}}}}
    ) {
      aggregate {
        count
      }
    }
    adaptationSC: activityQuestionSets_aggregate(
      where: {questionSet: {questions: {question: {objectiveKey: {_eq: "adaptation"}, _or: [{level: {_eq: SUBSTANTIAL_CONTRIBUTION}}, {levelExpression: {_ilike: "%SC%"}}]}}}}
    ) {
      aggregate {
        count
      }
    }
    adaptationDNSH: activityQuestionSets_aggregate(
      where: {questionSet: {questions: {question: {objectiveKey: {_eq: "adaptation"}, _or: [{level: {_eq: DO_NO_SIGNIFICANT_HARM}}, {levelExpression: {_ilike: "%DNSH%"}}]}}}}
    ) {
      aggregate {
        count
      }
    }
    waterSC: activityQuestionSets_aggregate(
      where: {questionSet: {questions: {question: {objectiveKey: {_eq: "water"}, _or: [{level: {_eq: SUBSTANTIAL_CONTRIBUTION}}, {levelExpression: {_ilike: "%SC%"}}]}}}}
    ) {
      aggregate {
        count
      }
    }
    waterDNSH: activityQuestionSets_aggregate(
      where: {questionSet: {questions: {question: {objectiveKey: {_eq: "water"}, _or: [{level: {_eq: DO_NO_SIGNIFICANT_HARM}}, {levelExpression: {_ilike: "%DNSH%"}}]}}}}
    ) {
      aggregate {
        count
      }
    }
    circularSC: activityQuestionSets_aggregate(
      where: {questionSet: {questions: {question: {objectiveKey: {_eq: "circular"}, _or: [{level: {_eq: SUBSTANTIAL_CONTRIBUTION}}, {levelExpression: {_ilike: "%SC%"}}]}}}}
    ) {
      aggregate {
        count
      }
    }
    circularDNSH: activityQuestionSets_aggregate(
      where: {questionSet: {questions: {question: {objectiveKey: {_eq: "circular"}, _or: [{level: {_eq: DO_NO_SIGNIFICANT_HARM}}, {levelExpression: {_ilike: "%DNSH%"}}]}}}}
    ) {
      aggregate {
        count
      }
    }
    pollutionSC: activityQuestionSets_aggregate(
      where: {questionSet: {questions: {question: {objectiveKey: {_eq: "pollution"}, _or: [{level: {_eq: SUBSTANTIAL_CONTRIBUTION}}, {levelExpression: {_ilike: "%SC%"}}]}}}}
    ) {
      aggregate {
        count
      }
    }
    pollutionDNSH: activityQuestionSets_aggregate(
      where: {questionSet: {questions: {question: {objectiveKey: {_eq: "pollution"}, _or: [{level: {_eq: DO_NO_SIGNIFICANT_HARM}}, {levelExpression: {_ilike: "%DNSH%"}}]}}}}
    ) {
      aggregate {
        count
      }
    }
    biodiversitySC: activityQuestionSets_aggregate(
      where: {questionSet: {questions: {question: {objectiveKey: {_eq: "biodiversity"}, _or: [{level: {_eq: SUBSTANTIAL_CONTRIBUTION}}, {levelExpression: {_ilike: "%SC%"}}]}}}}
    ) {
      aggregate {
        count
      }
    }
    biodiversityDNSH: activityQuestionSets_aggregate(
      where: {questionSet: {questions: {question: {objectiveKey: {_eq: "biodiversity"}, _or: [{level: {_eq: DO_NO_SIGNIFICANT_HARM}}, {levelExpression: {_ilike: "%DNSH%"}}]}}}}
    ) {
      aggregate {
        count
      }
    }
  }
}
    `;

/**
 * __useGetActivityObjectivesStatusQuery__
 *
 * To run a query within a React component, call `useGetActivityObjectivesStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityObjectivesStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityObjectivesStatusQuery({
 *   variables: {
 *      activityRef: // value for 'activityRef'
 *      versionNumber: // value for 'versionNumber'
 *   },
 * });
 */
export function useGetActivityObjectivesStatusQuery(baseOptions: Apollo.QueryHookOptions<GetActivityObjectivesStatusQuery_, GetActivityObjectivesStatusQueryVariables_> & ({ variables: GetActivityObjectivesStatusQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityObjectivesStatusQuery_, GetActivityObjectivesStatusQueryVariables_>(GetActivityObjectivesStatusDocument_, options);
      }
export function useGetActivityObjectivesStatusLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityObjectivesStatusQuery_, GetActivityObjectivesStatusQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityObjectivesStatusQuery_, GetActivityObjectivesStatusQueryVariables_>(GetActivityObjectivesStatusDocument_, options);
        }
export function useGetActivityObjectivesStatusSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityObjectivesStatusQuery_, GetActivityObjectivesStatusQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivityObjectivesStatusQuery_, GetActivityObjectivesStatusQueryVariables_>(GetActivityObjectivesStatusDocument_, options);
        }
export type GetActivityObjectivesStatusQueryHookResult = ReturnType<typeof useGetActivityObjectivesStatusQuery>;
export type GetActivityObjectivesStatusLazyQuery_HookResult = ReturnType<typeof useGetActivityObjectivesStatusLazyQuery_>;
export type GetActivityObjectivesStatusSuspenseQuery_HookResult = ReturnType<typeof useGetActivityObjectivesStatusSuspenseQuery_>;
export type GetActivityObjectivesStatusQueryResult_ = Apollo.QueryResult<GetActivityObjectivesStatusQuery_, GetActivityObjectivesStatusQueryVariables_>;
export function refetchGetActivityObjectivesStatusQuery_(variables: GetActivityObjectivesStatusQueryVariables_) {
      return { query: GetActivityObjectivesStatusDocument_, variables: variables }
    }
export const AddAnswerDocument_ = gql`
    mutation addAnswer($answer: Answer_insert_input!, $reportId: uuid!) {
  answer: insert_Answer_one(
    object: $answer
    on_conflict: {constraint: Answer_questionId_reportId_22331f7f_uniq, update_columns: [data, flagged, answeredById]}
  ) {
    ...AnswerFields
    activityReport {
      id
      answers {
        id
      }
    }
  }
  cachedResult: update_CachedResult(
    where: {cAssessments: {bAssesssments: {activityReports: {id: {_eq: $reportId}}}}}
    _set: {isDirty: true}
  ) {
    returning {
      id
      isDirty
    }
  }
}
    ${AnswerFieldsFragmentDoc_}`;
export type AddAnswerMutationFn_ = Apollo.MutationFunction<AddAnswerMutation_, AddAnswerMutationVariables_>;

/**
 * __useAddAnswerMutation__
 *
 * To run a mutation, you first call `useAddAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAnswerMutation, { data, loading, error }] = useAddAnswerMutation({
 *   variables: {
 *      answer: // value for 'answer'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useAddAnswerMutation(baseOptions?: Apollo.MutationHookOptions<AddAnswerMutation_, AddAnswerMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAnswerMutation_, AddAnswerMutationVariables_>(AddAnswerDocument_, options);
      }
export type AddAnswerMutationHookResult = ReturnType<typeof useAddAnswerMutation>;
export type AddAnswerMutationResult_ = Apollo.MutationResult<AddAnswerMutation_>;
export type AddAnswerMutationOptions_ = Apollo.BaseMutationOptions<AddAnswerMutation_, AddAnswerMutationVariables_>;
export const AddAnswerWithoutDataDocument_ = gql`
    mutation addAnswerWithoutData($answer: Answer_insert_input!) {
  answer: insert_Answer_one(
    object: $answer
    on_conflict: {constraint: Answer_questionId_reportId_22331f7f_uniq, update_columns: [flagged, answeredById]}
  ) {
    ...AnswerFields
    activityReport {
      id
      answers {
        id
      }
    }
  }
}
    ${AnswerFieldsFragmentDoc_}`;
export type AddAnswerWithoutDataMutationFn_ = Apollo.MutationFunction<AddAnswerWithoutDataMutation_, AddAnswerWithoutDataMutationVariables_>;

/**
 * __useAddAnswerWithoutDataMutation__
 *
 * To run a mutation, you first call `useAddAnswerWithoutDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAnswerWithoutDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAnswerWithoutDataMutation, { data, loading, error }] = useAddAnswerWithoutDataMutation({
 *   variables: {
 *      answer: // value for 'answer'
 *   },
 * });
 */
export function useAddAnswerWithoutDataMutation(baseOptions?: Apollo.MutationHookOptions<AddAnswerWithoutDataMutation_, AddAnswerWithoutDataMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAnswerWithoutDataMutation_, AddAnswerWithoutDataMutationVariables_>(AddAnswerWithoutDataDocument_, options);
      }
export type AddAnswerWithoutDataMutationHookResult = ReturnType<typeof useAddAnswerWithoutDataMutation>;
export type AddAnswerWithoutDataMutationResult_ = Apollo.MutationResult<AddAnswerWithoutDataMutation_>;
export type AddAnswerWithoutDataMutationOptions_ = Apollo.BaseMutationOptions<AddAnswerWithoutDataMutation_, AddAnswerWithoutDataMutationVariables_>;
export const UpsertAnswerDataDocument_ = gql`
    mutation upsertAnswerData($answers: [Answer_insert_input!]!) {
  insert_Answer(
    objects: $answers
    on_conflict: {constraint: Answer_questionId_reportId_22331f7f_uniq, update_columns: [data, answeredById]}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpsertAnswerDataMutationFn_ = Apollo.MutationFunction<UpsertAnswerDataMutation_, UpsertAnswerDataMutationVariables_>;

/**
 * __useUpsertAnswerDataMutation__
 *
 * To run a mutation, you first call `useUpsertAnswerDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAnswerDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAnswerDataMutation, { data, loading, error }] = useUpsertAnswerDataMutation({
 *   variables: {
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useUpsertAnswerDataMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAnswerDataMutation_, UpsertAnswerDataMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAnswerDataMutation_, UpsertAnswerDataMutationVariables_>(UpsertAnswerDataDocument_, options);
      }
export type UpsertAnswerDataMutationHookResult = ReturnType<typeof useUpsertAnswerDataMutation>;
export type UpsertAnswerDataMutationResult_ = Apollo.MutationResult<UpsertAnswerDataMutation_>;
export type UpsertAnswerDataMutationOptions_ = Apollo.BaseMutationOptions<UpsertAnswerDataMutation_, UpsertAnswerDataMutationVariables_>;
export const GetAnswerDocument_ = gql`
    query getAnswer($id: uuid!) {
  answer: Answer_by_pk(id: $id) {
    ...AnswerFields
  }
}
    ${AnswerFieldsFragmentDoc_}`;

/**
 * __useGetAnswerQuery__
 *
 * To run a query within a React component, call `useGetAnswerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnswerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnswerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAnswerQuery(baseOptions: Apollo.QueryHookOptions<GetAnswerQuery_, GetAnswerQueryVariables_> & ({ variables: GetAnswerQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnswerQuery_, GetAnswerQueryVariables_>(GetAnswerDocument_, options);
      }
export function useGetAnswerLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAnswerQuery_, GetAnswerQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnswerQuery_, GetAnswerQueryVariables_>(GetAnswerDocument_, options);
        }
export function useGetAnswerSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAnswerQuery_, GetAnswerQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAnswerQuery_, GetAnswerQueryVariables_>(GetAnswerDocument_, options);
        }
export type GetAnswerQueryHookResult = ReturnType<typeof useGetAnswerQuery>;
export type GetAnswerLazyQuery_HookResult = ReturnType<typeof useGetAnswerLazyQuery_>;
export type GetAnswerSuspenseQuery_HookResult = ReturnType<typeof useGetAnswerSuspenseQuery_>;
export type GetAnswerQueryResult_ = Apollo.QueryResult<GetAnswerQuery_, GetAnswerQueryVariables_>;
export function refetchGetAnswerQuery_(variables: GetAnswerQueryVariables_) {
      return { query: GetAnswerDocument_, variables: variables }
    }
export const ReportingGroupsDocument_ = gql`
    query ReportingGroups($cAssessmentId: uuid!) {
  reportingGroups: ReportingGroup(
    where: {companyAssessmentId: {_eq: $cAssessmentId}, deletedAt: {_is_null: true}}
  ) {
    ...ReportingGroupFields
  }
}
    ${ReportingGroupFieldsFragmentDoc_}`;

/**
 * __useReportingGroupsQuery__
 *
 * To run a query within a React component, call `useReportingGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingGroupsQuery({
 *   variables: {
 *      cAssessmentId: // value for 'cAssessmentId'
 *   },
 * });
 */
export function useReportingGroupsQuery(baseOptions: Apollo.QueryHookOptions<ReportingGroupsQuery_, ReportingGroupsQueryVariables_> & ({ variables: ReportingGroupsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingGroupsQuery_, ReportingGroupsQueryVariables_>(ReportingGroupsDocument_, options);
      }
export function useReportingGroupsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ReportingGroupsQuery_, ReportingGroupsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingGroupsQuery_, ReportingGroupsQueryVariables_>(ReportingGroupsDocument_, options);
        }
export function useReportingGroupsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReportingGroupsQuery_, ReportingGroupsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportingGroupsQuery_, ReportingGroupsQueryVariables_>(ReportingGroupsDocument_, options);
        }
export type ReportingGroupsQueryHookResult = ReturnType<typeof useReportingGroupsQuery>;
export type ReportingGroupsLazyQuery_HookResult = ReturnType<typeof useReportingGroupsLazyQuery_>;
export type ReportingGroupsSuspenseQuery_HookResult = ReturnType<typeof useReportingGroupsSuspenseQuery_>;
export type ReportingGroupsQueryResult_ = Apollo.QueryResult<ReportingGroupsQuery_, ReportingGroupsQueryVariables_>;
export function refetchReportingGroupsQuery_(variables: ReportingGroupsQueryVariables_) {
      return { query: ReportingGroupsDocument_, variables: variables }
    }
export const UpsertReportingGroupsDocument_ = gql`
    mutation upsertReportingGroups($input: [ReportingGroup_insert_input!]!) {
  insert_ReportingGroup(
    objects: $input
    on_conflict: {constraint: ReportingGroup_pkey, update_columns: [name, ownerId, orderIndex, parentId]}
  ) {
    affected_rows
  }
}
    `;
export type UpsertReportingGroupsMutationFn_ = Apollo.MutationFunction<UpsertReportingGroupsMutation_, UpsertReportingGroupsMutationVariables_>;

/**
 * __useUpsertReportingGroupsMutation__
 *
 * To run a mutation, you first call `useUpsertReportingGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertReportingGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertReportingGroupsMutation, { data, loading, error }] = useUpsertReportingGroupsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertReportingGroupsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertReportingGroupsMutation_, UpsertReportingGroupsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertReportingGroupsMutation_, UpsertReportingGroupsMutationVariables_>(UpsertReportingGroupsDocument_, options);
      }
export type UpsertReportingGroupsMutationHookResult = ReturnType<typeof useUpsertReportingGroupsMutation>;
export type UpsertReportingGroupsMutationResult_ = Apollo.MutationResult<UpsertReportingGroupsMutation_>;
export type UpsertReportingGroupsMutationOptions_ = Apollo.BaseMutationOptions<UpsertReportingGroupsMutation_, UpsertReportingGroupsMutationVariables_>;
export const DeleteReportingGroupDocument_ = gql`
    mutation deleteReportingGroup($id: uuid!) {
  update_ReportingGroup_by_pk(pk_columns: {id: $id}, _set: {deletedAt: "now()"}) {
    id
  }
  update_BusinessUnitAssessment_many(
    updates: {where: {reportingGroupId: {_eq: $id}}, _set: {reportingGroupId: null}}
  ) {
    affected_rows
  }
  update_ReportingGroup_many(
    updates: {where: {parentId: {_eq: $id}}, _set: {parentId: null}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteReportingGroupMutationFn_ = Apollo.MutationFunction<DeleteReportingGroupMutation_, DeleteReportingGroupMutationVariables_>;

/**
 * __useDeleteReportingGroupMutation__
 *
 * To run a mutation, you first call `useDeleteReportingGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportingGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportingGroupMutation, { data, loading, error }] = useDeleteReportingGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteReportingGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportingGroupMutation_, DeleteReportingGroupMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportingGroupMutation_, DeleteReportingGroupMutationVariables_>(DeleteReportingGroupDocument_, options);
      }
export type DeleteReportingGroupMutationHookResult = ReturnType<typeof useDeleteReportingGroupMutation>;
export type DeleteReportingGroupMutationResult_ = Apollo.MutationResult<DeleteReportingGroupMutation_>;
export type DeleteReportingGroupMutationOptions_ = Apollo.BaseMutationOptions<DeleteReportingGroupMutation_, DeleteReportingGroupMutationVariables_>;
export const CompanyAssessmentCachedResultsDocument_ = gql`
    subscription CompanyAssessmentCachedResults($cAssessmentId: uuid!) {
  companyResults: CompanyAssessment_by_pk(id: $cAssessmentId) {
    companyAssessmentId: id
    aggregateId
    endDate
    startDate
    cachedResult {
      ...CachedResultFields
    }
    nonMaterialFinancials {
      ...NonMaterialFinancialsFields
    }
    generalBusinessUnitResult: bAssesssments(
      where: {businessUnitId: {_is_null: true}, deletedAt: {_is_null: true}}
    ) {
      generalAssessmentResults: activityReports(
        where: {activityRef: {_eq: "0.0"}, deletedAt: {_is_null: true}}
      ) {
        activityAssessmentId: id
        activityVersionNumber
        bAssessmentId
        cachedResult {
          ...CachedResultFields
        }
      }
    }
    businessUnitResults: bAssesssments(
      where: {businessUnitId: {_is_null: false}, deletedAt: {_is_null: true}}
    ) {
      bAssessmentId: id
      businessUnit {
        name
        id
      }
      cachedResult {
        ...CachedResultFields
      }
      hasGeneralAssessment
      generalAssessmentResults: activityReports(
        where: {activityRef: {_eq: "0.0"}, deletedAt: {_is_null: true}}
      ) {
        activityAssessmentId: id
        activityVersionNumber
        bAssessmentId
        cachedResult {
          ...CachedResultFields
        }
      }
      activityResults: activityReports(
        where: {activityRef: {_neq: "0.0"}, deletedAt: {_is_null: true}}
      ) {
        activityAssessmentId: id
        activityVersionNumber
        activityRef
        financials {
          id
        }
        cachedResult {
          ...CachedResultFields
        }
      }
    }
  }
}
    ${CachedResultFieldsFragmentDoc_}
${NonMaterialFinancialsFieldsFragmentDoc_}`;

/**
 * __useCompanyAssessmentCachedResultsSubscription__
 *
 * To run a query within a React component, call `useCompanyAssessmentCachedResultsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useCompanyAssessmentCachedResultsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyAssessmentCachedResultsSubscription({
 *   variables: {
 *      cAssessmentId: // value for 'cAssessmentId'
 *   },
 * });
 */
export function useCompanyAssessmentCachedResultsSubscription(baseOptions: Apollo.SubscriptionHookOptions<CompanyAssessmentCachedResultsSubscription_, CompanyAssessmentCachedResultsSubscriptionVariables_> & ({ variables: CompanyAssessmentCachedResultsSubscriptionVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<CompanyAssessmentCachedResultsSubscription_, CompanyAssessmentCachedResultsSubscriptionVariables_>(CompanyAssessmentCachedResultsDocument_, options);
      }
export type CompanyAssessmentCachedResultsSubscriptionHookResult = ReturnType<typeof useCompanyAssessmentCachedResultsSubscription>;
export type CompanyAssessmentCachedResultsSubscriptionResult_ = Apollo.SubscriptionResult<CompanyAssessmentCachedResultsSubscription_>;
export const UpsertCacheResultsDocument_ = gql`
    mutation upsertCacheResults($objects: [CachedResult_insert_input!]!) {
  insert_CachedResult(
    objects: $objects
    on_conflict: {constraint: CachedResult_pkey, update_columns: [score, financials, activityTag, isAligned, isCompleted, progress, objectivesState, status]}
  ) {
    update: returning {
      id
      activityTag
      activityVersionNumber
      isAligned
      financials
      isCompleted
      score
      financials
      status
      cAssessments {
        id
      }
      activity {
        reference
      }
      activityReports {
        id
      }
      objectivesState
    }
  }
}
    `;
export type UpsertCacheResultsMutationFn_ = Apollo.MutationFunction<UpsertCacheResultsMutation_, UpsertCacheResultsMutationVariables_>;

/**
 * __useUpsertCacheResultsMutation__
 *
 * To run a mutation, you first call `useUpsertCacheResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCacheResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCacheResultsMutation, { data, loading, error }] = useUpsertCacheResultsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertCacheResultsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCacheResultsMutation_, UpsertCacheResultsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCacheResultsMutation_, UpsertCacheResultsMutationVariables_>(UpsertCacheResultsDocument_, options);
      }
export type UpsertCacheResultsMutationHookResult = ReturnType<typeof useUpsertCacheResultsMutation>;
export type UpsertCacheResultsMutationResult_ = Apollo.MutationResult<UpsertCacheResultsMutation_>;
export type UpsertCacheResultsMutationOptions_ = Apollo.BaseMutationOptions<UpsertCacheResultsMutation_, UpsertCacheResultsMutationVariables_>;
export const UpsertCompanyAssessmentResultsDocument_ = gql`
    mutation upsertCompanyAssessmentResults($companyUpdate: CompanyAssessment_insert_input!, $bAssessmentsResults: [BusinessUnitAssessment_insert_input!]!, $activityAssesments: [ActivityReport_insert_input!]!) {
  company: insert_CompanyAssessment_one(
    object: $companyUpdate
    on_conflict: {constraint: companyAssessment_pkey, update_columns: [cachedResultId]}
  ) {
    id
    cachedResultId
  }
  businessUnits: insert_BusinessUnitAssessment(
    objects: $bAssessmentsResults
    on_conflict: {constraint: BusinessUnitAssessment_pkey, update_columns: [cachedResultId]}
  ) {
    returning {
      id
      cachedResultId
    }
  }
  activities: insert_ActivityReport(
    objects: $activityAssesments
    on_conflict: {constraint: activityReport_pkey, update_columns: [cachedResultId]}
  ) {
    returning {
      id
      cachedResultId
      cachedResult {
        isAligned
        status
      }
    }
  }
}
    `;
export type UpsertCompanyAssessmentResultsMutationFn_ = Apollo.MutationFunction<UpsertCompanyAssessmentResultsMutation_, UpsertCompanyAssessmentResultsMutationVariables_>;

/**
 * __useUpsertCompanyAssessmentResultsMutation__
 *
 * To run a mutation, you first call `useUpsertCompanyAssessmentResultsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCompanyAssessmentResultsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCompanyAssessmentResultsMutation, { data, loading, error }] = useUpsertCompanyAssessmentResultsMutation({
 *   variables: {
 *      companyUpdate: // value for 'companyUpdate'
 *      bAssessmentsResults: // value for 'bAssessmentsResults'
 *      activityAssesments: // value for 'activityAssesments'
 *   },
 * });
 */
export function useUpsertCompanyAssessmentResultsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCompanyAssessmentResultsMutation_, UpsertCompanyAssessmentResultsMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCompanyAssessmentResultsMutation_, UpsertCompanyAssessmentResultsMutationVariables_>(UpsertCompanyAssessmentResultsDocument_, options);
      }
export type UpsertCompanyAssessmentResultsMutationHookResult = ReturnType<typeof useUpsertCompanyAssessmentResultsMutation>;
export type UpsertCompanyAssessmentResultsMutationResult_ = Apollo.MutationResult<UpsertCompanyAssessmentResultsMutation_>;
export type UpsertCompanyAssessmentResultsMutationOptions_ = Apollo.BaseMutationOptions<UpsertCompanyAssessmentResultsMutation_, UpsertCompanyAssessmentResultsMutationVariables_>;
export const FlagCompanyAssessmentAsDirtyDocument_ = gql`
    mutation flagCompanyAssessmentAsDirty($cachedResultId: uuid!) {
  insert_CachedResult_one(
    object: {id: $cachedResultId, isDirty: true, isCompleted: false}
    on_conflict: {constraint: CachedResult_pkey, update_columns: [isDirty]}
  ) {
    id
  }
}
    `;
export type FlagCompanyAssessmentAsDirtyMutationFn_ = Apollo.MutationFunction<FlagCompanyAssessmentAsDirtyMutation_, FlagCompanyAssessmentAsDirtyMutationVariables_>;

/**
 * __useFlagCompanyAssessmentAsDirtyMutation__
 *
 * To run a mutation, you first call `useFlagCompanyAssessmentAsDirtyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagCompanyAssessmentAsDirtyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagCompanyAssessmentAsDirtyMutation, { data, loading, error }] = useFlagCompanyAssessmentAsDirtyMutation({
 *   variables: {
 *      cachedResultId: // value for 'cachedResultId'
 *   },
 * });
 */
export function useFlagCompanyAssessmentAsDirtyMutation(baseOptions?: Apollo.MutationHookOptions<FlagCompanyAssessmentAsDirtyMutation_, FlagCompanyAssessmentAsDirtyMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FlagCompanyAssessmentAsDirtyMutation_, FlagCompanyAssessmentAsDirtyMutationVariables_>(FlagCompanyAssessmentAsDirtyDocument_, options);
      }
export type FlagCompanyAssessmentAsDirtyMutationHookResult = ReturnType<typeof useFlagCompanyAssessmentAsDirtyMutation>;
export type FlagCompanyAssessmentAsDirtyMutationResult_ = Apollo.MutationResult<FlagCompanyAssessmentAsDirtyMutation_>;
export type FlagCompanyAssessmentAsDirtyMutationOptions_ = Apollo.BaseMutationOptions<FlagCompanyAssessmentAsDirtyMutation_, FlagCompanyAssessmentAsDirtyMutationVariables_>;
export const UserCompaniesWithSustainabilityAssessmentsDocument_ = gql`
    query userCompaniesWithSustainabilityAssessments($id: uuid!) {
  data: user(id: $id) {
    companies: companyUsers {
      company {
        id
        name
        esrsAssessments {
          id
          reportingYear
          frameworkRef
          updatedAt
          latestMaterialMetricUpdate
          latestDatapointUpdate
        }
      }
    }
  }
}
    `;

/**
 * __useUserCompaniesWithSustainabilityAssessmentsQuery__
 *
 * To run a query within a React component, call `useUserCompaniesWithSustainabilityAssessmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCompaniesWithSustainabilityAssessmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCompaniesWithSustainabilityAssessmentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserCompaniesWithSustainabilityAssessmentsQuery(baseOptions: Apollo.QueryHookOptions<UserCompaniesWithSustainabilityAssessmentsQuery_, UserCompaniesWithSustainabilityAssessmentsQueryVariables_> & ({ variables: UserCompaniesWithSustainabilityAssessmentsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCompaniesWithSustainabilityAssessmentsQuery_, UserCompaniesWithSustainabilityAssessmentsQueryVariables_>(UserCompaniesWithSustainabilityAssessmentsDocument_, options);
      }
export function useUserCompaniesWithSustainabilityAssessmentsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<UserCompaniesWithSustainabilityAssessmentsQuery_, UserCompaniesWithSustainabilityAssessmentsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCompaniesWithSustainabilityAssessmentsQuery_, UserCompaniesWithSustainabilityAssessmentsQueryVariables_>(UserCompaniesWithSustainabilityAssessmentsDocument_, options);
        }
export function useUserCompaniesWithSustainabilityAssessmentsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCompaniesWithSustainabilityAssessmentsQuery_, UserCompaniesWithSustainabilityAssessmentsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserCompaniesWithSustainabilityAssessmentsQuery_, UserCompaniesWithSustainabilityAssessmentsQueryVariables_>(UserCompaniesWithSustainabilityAssessmentsDocument_, options);
        }
export type UserCompaniesWithSustainabilityAssessmentsQueryHookResult = ReturnType<typeof useUserCompaniesWithSustainabilityAssessmentsQuery>;
export type UserCompaniesWithSustainabilityAssessmentsLazyQuery_HookResult = ReturnType<typeof useUserCompaniesWithSustainabilityAssessmentsLazyQuery_>;
export type UserCompaniesWithSustainabilityAssessmentsSuspenseQuery_HookResult = ReturnType<typeof useUserCompaniesWithSustainabilityAssessmentsSuspenseQuery_>;
export type UserCompaniesWithSustainabilityAssessmentsQueryResult_ = Apollo.QueryResult<UserCompaniesWithSustainabilityAssessmentsQuery_, UserCompaniesWithSustainabilityAssessmentsQueryVariables_>;
export function refetchUserCompaniesWithSustainabilityAssessmentsQuery_(variables: UserCompaniesWithSustainabilityAssessmentsQueryVariables_) {
      return { query: UserCompaniesWithSustainabilityAssessmentsDocument_, variables: variables }
    }
export const GetAssessmentDataDocument_ = gql`
    query getAssessmentData($esrsAssessmentId: uuid!) {
  EsrsAssessment_by_pk(id: $esrsAssessmentId) {
    id
    parentAssessmentId
    reportingUnits {
      id
      isCompanyLevel
    }
  }
}
    `;

/**
 * __useGetAssessmentDataQuery__
 *
 * To run a query within a React component, call `useGetAssessmentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentDataQuery({
 *   variables: {
 *      esrsAssessmentId: // value for 'esrsAssessmentId'
 *   },
 * });
 */
export function useGetAssessmentDataQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentDataQuery_, GetAssessmentDataQueryVariables_> & ({ variables: GetAssessmentDataQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentDataQuery_, GetAssessmentDataQueryVariables_>(GetAssessmentDataDocument_, options);
      }
export function useGetAssessmentDataLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentDataQuery_, GetAssessmentDataQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentDataQuery_, GetAssessmentDataQueryVariables_>(GetAssessmentDataDocument_, options);
        }
export function useGetAssessmentDataSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentDataQuery_, GetAssessmentDataQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentDataQuery_, GetAssessmentDataQueryVariables_>(GetAssessmentDataDocument_, options);
        }
export type GetAssessmentDataQueryHookResult = ReturnType<typeof useGetAssessmentDataQuery>;
export type GetAssessmentDataLazyQuery_HookResult = ReturnType<typeof useGetAssessmentDataLazyQuery_>;
export type GetAssessmentDataSuspenseQuery_HookResult = ReturnType<typeof useGetAssessmentDataSuspenseQuery_>;
export type GetAssessmentDataQueryResult_ = Apollo.QueryResult<GetAssessmentDataQuery_, GetAssessmentDataQueryVariables_>;
export function refetchGetAssessmentDataQuery_(variables: GetAssessmentDataQueryVariables_) {
      return { query: GetAssessmentDataDocument_, variables: variables }
    }
export const GetRequiredAssessmentMaterialMetricsDocument_ = gql`
    query getRequiredAssessmentMaterialMetrics($assessmentId: uuid!, $parentAssessmentId: uuid!) {
  esrs_MaterialMetric(
    where: {_or: [{isMaterial: {_eq: true}, materialStandard: {assessmentId: {_eq: $assessmentId}, isMaterial: {_eq: true}}}, {isMaterial: {_eq: true}, materialStandard: {assessmentId: {_eq: $parentAssessmentId}, isMaterial: {_eq: true}}, dataCollection: {_eq: "subsidiaries"}, metric: {hierarchyStatus: {isLeaf: {_eq: true}}}, _and: {metric: {materialMetrics: {materialStandard: {assessmentId: {_eq: $assessmentId}}}}}}]}
  ) {
    metricRef
  }
}
    `;

/**
 * __useGetRequiredAssessmentMaterialMetricsQuery__
 *
 * To run a query within a React component, call `useGetRequiredAssessmentMaterialMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRequiredAssessmentMaterialMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRequiredAssessmentMaterialMetricsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      parentAssessmentId: // value for 'parentAssessmentId'
 *   },
 * });
 */
export function useGetRequiredAssessmentMaterialMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetRequiredAssessmentMaterialMetricsQuery_, GetRequiredAssessmentMaterialMetricsQueryVariables_> & ({ variables: GetRequiredAssessmentMaterialMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRequiredAssessmentMaterialMetricsQuery_, GetRequiredAssessmentMaterialMetricsQueryVariables_>(GetRequiredAssessmentMaterialMetricsDocument_, options);
      }
export function useGetRequiredAssessmentMaterialMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetRequiredAssessmentMaterialMetricsQuery_, GetRequiredAssessmentMaterialMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRequiredAssessmentMaterialMetricsQuery_, GetRequiredAssessmentMaterialMetricsQueryVariables_>(GetRequiredAssessmentMaterialMetricsDocument_, options);
        }
export function useGetRequiredAssessmentMaterialMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRequiredAssessmentMaterialMetricsQuery_, GetRequiredAssessmentMaterialMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRequiredAssessmentMaterialMetricsQuery_, GetRequiredAssessmentMaterialMetricsQueryVariables_>(GetRequiredAssessmentMaterialMetricsDocument_, options);
        }
export type GetRequiredAssessmentMaterialMetricsQueryHookResult = ReturnType<typeof useGetRequiredAssessmentMaterialMetricsQuery>;
export type GetRequiredAssessmentMaterialMetricsLazyQuery_HookResult = ReturnType<typeof useGetRequiredAssessmentMaterialMetricsLazyQuery_>;
export type GetRequiredAssessmentMaterialMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetRequiredAssessmentMaterialMetricsSuspenseQuery_>;
export type GetRequiredAssessmentMaterialMetricsQueryResult_ = Apollo.QueryResult<GetRequiredAssessmentMaterialMetricsQuery_, GetRequiredAssessmentMaterialMetricsQueryVariables_>;
export function refetchGetRequiredAssessmentMaterialMetricsQuery_(variables: GetRequiredAssessmentMaterialMetricsQueryVariables_) {
      return { query: GetRequiredAssessmentMaterialMetricsDocument_, variables: variables }
    }
export const GetAssessmentMetricsDocument_ = gql`
    query getAssessmentMetrics($assessmentId: uuid!, $requiredMetrics: [String!]!) {
  EsrsMetric(
    where: {_or: [{reference: {_in: $requiredMetrics}}, {view_childrenMetrics: {childMetricRef: {_in: $requiredMetrics}}}]}
  ) {
    reference
    disclosureRequirementRef
    mfDisclosureRequirements {
      mfDisclosureRequirementRef
    }
    view_childrenMetrics {
      childMetricRef
    }
    parentMetrics {
      parentMetricRef
    }
    materialMetrics(where: {materialStandard: {assessmentId: {_eq: $assessmentId}}}) {
      id
      frequency
      dataCollection
      materialMetricTags {
        ...MaterialMetricTagFields
      }
      materialStandard {
        id
        standardRef
      }
    }
  }
}
    ${MaterialMetricTagFieldsFragmentDoc_}`;

/**
 * __useGetAssessmentMetricsQuery__
 *
 * To run a query within a React component, call `useGetAssessmentMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentMetricsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *      requiredMetrics: // value for 'requiredMetrics'
 *   },
 * });
 */
export function useGetAssessmentMetricsQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentMetricsQuery_, GetAssessmentMetricsQueryVariables_> & ({ variables: GetAssessmentMetricsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentMetricsQuery_, GetAssessmentMetricsQueryVariables_>(GetAssessmentMetricsDocument_, options);
      }
export function useGetAssessmentMetricsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentMetricsQuery_, GetAssessmentMetricsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentMetricsQuery_, GetAssessmentMetricsQueryVariables_>(GetAssessmentMetricsDocument_, options);
        }
export function useGetAssessmentMetricsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentMetricsQuery_, GetAssessmentMetricsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentMetricsQuery_, GetAssessmentMetricsQueryVariables_>(GetAssessmentMetricsDocument_, options);
        }
export type GetAssessmentMetricsQueryHookResult = ReturnType<typeof useGetAssessmentMetricsQuery>;
export type GetAssessmentMetricsLazyQuery_HookResult = ReturnType<typeof useGetAssessmentMetricsLazyQuery_>;
export type GetAssessmentMetricsSuspenseQuery_HookResult = ReturnType<typeof useGetAssessmentMetricsSuspenseQuery_>;
export type GetAssessmentMetricsQueryResult_ = Apollo.QueryResult<GetAssessmentMetricsQuery_, GetAssessmentMetricsQueryVariables_>;
export function refetchGetAssessmentMetricsQuery_(variables: GetAssessmentMetricsQueryVariables_) {
      return { query: GetAssessmentMetricsDocument_, variables: variables }
    }
export const GetTasksByAssessmentDocument_ = gql`
    query getTasksByAssessment($assessmentId: uuid!) {
  Task(where: {assessmentId: {_eq: $assessmentId}}) {
    taskReference
    owner {
      displayName
    }
  }
}
    `;

/**
 * __useGetTasksByAssessmentQuery__
 *
 * To run a query within a React component, call `useGetTasksByAssessmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTasksByAssessmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasksByAssessmentQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetTasksByAssessmentQuery(baseOptions: Apollo.QueryHookOptions<GetTasksByAssessmentQuery_, GetTasksByAssessmentQueryVariables_> & ({ variables: GetTasksByAssessmentQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTasksByAssessmentQuery_, GetTasksByAssessmentQueryVariables_>(GetTasksByAssessmentDocument_, options);
      }
export function useGetTasksByAssessmentLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetTasksByAssessmentQuery_, GetTasksByAssessmentQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTasksByAssessmentQuery_, GetTasksByAssessmentQueryVariables_>(GetTasksByAssessmentDocument_, options);
        }
export function useGetTasksByAssessmentSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTasksByAssessmentQuery_, GetTasksByAssessmentQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTasksByAssessmentQuery_, GetTasksByAssessmentQueryVariables_>(GetTasksByAssessmentDocument_, options);
        }
export type GetTasksByAssessmentQueryHookResult = ReturnType<typeof useGetTasksByAssessmentQuery>;
export type GetTasksByAssessmentLazyQuery_HookResult = ReturnType<typeof useGetTasksByAssessmentLazyQuery_>;
export type GetTasksByAssessmentSuspenseQuery_HookResult = ReturnType<typeof useGetTasksByAssessmentSuspenseQuery_>;
export type GetTasksByAssessmentQueryResult_ = Apollo.QueryResult<GetTasksByAssessmentQuery_, GetTasksByAssessmentQueryVariables_>;
export function refetchGetTasksByAssessmentQuery_(variables: GetTasksByAssessmentQueryVariables_) {
      return { query: GetTasksByAssessmentDocument_, variables: variables }
    }
export const GetMdrmDatapointsTasksDocument_ = gql`
    query getMdrmDatapointsTasks($assessmentId: uuid!) {
  Task(
    where: {table: {_eq: "DatapointMdrm"}, datapointMdrm: {datapoint: {_and: [{answer: {assessmentId: {_eq: $assessmentId}}}, {isMdrmDisclosed: {_eq: true}}]}}}
  ) {
    ...TaskFields
    datapointMdrm {
      mdrmRef
      datapoint {
        answer {
          metricRef
        }
      }
    }
  }
}
    ${TaskFieldsFragmentDoc_}`;

/**
 * __useGetMdrmDatapointsTasksQuery__
 *
 * To run a query within a React component, call `useGetMdrmDatapointsTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMdrmDatapointsTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMdrmDatapointsTasksQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetMdrmDatapointsTasksQuery(baseOptions: Apollo.QueryHookOptions<GetMdrmDatapointsTasksQuery_, GetMdrmDatapointsTasksQueryVariables_> & ({ variables: GetMdrmDatapointsTasksQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMdrmDatapointsTasksQuery_, GetMdrmDatapointsTasksQueryVariables_>(GetMdrmDatapointsTasksDocument_, options);
      }
export function useGetMdrmDatapointsTasksLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMdrmDatapointsTasksQuery_, GetMdrmDatapointsTasksQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMdrmDatapointsTasksQuery_, GetMdrmDatapointsTasksQueryVariables_>(GetMdrmDatapointsTasksDocument_, options);
        }
export function useGetMdrmDatapointsTasksSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMdrmDatapointsTasksQuery_, GetMdrmDatapointsTasksQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMdrmDatapointsTasksQuery_, GetMdrmDatapointsTasksQueryVariables_>(GetMdrmDatapointsTasksDocument_, options);
        }
export type GetMdrmDatapointsTasksQueryHookResult = ReturnType<typeof useGetMdrmDatapointsTasksQuery>;
export type GetMdrmDatapointsTasksLazyQuery_HookResult = ReturnType<typeof useGetMdrmDatapointsTasksLazyQuery_>;
export type GetMdrmDatapointsTasksSuspenseQuery_HookResult = ReturnType<typeof useGetMdrmDatapointsTasksSuspenseQuery_>;
export type GetMdrmDatapointsTasksQueryResult_ = Apollo.QueryResult<GetMdrmDatapointsTasksQuery_, GetMdrmDatapointsTasksQueryVariables_>;
export function refetchGetMdrmDatapointsTasksQuery_(variables: GetMdrmDatapointsTasksQueryVariables_) {
      return { query: GetMdrmDatapointsTasksDocument_, variables: variables }
    }
export const GetDatapointsTasksDocument_ = gql`
    query getDatapointsTasks($assessmentId: uuid!) {
  Task(
    where: {datapoints: {answer: {assessmentId: {_eq: $assessmentId}}}, table: {_eq: "Datapoint"}}
  ) {
    ...TaskFields
    datapoints {
      id
      answer {
        ...AnswerDetails
      }
    }
  }
}
    ${TaskFieldsFragmentDoc_}
${AnswerDetailsFragmentDoc_}`;

/**
 * __useGetDatapointsTasksQuery__
 *
 * To run a query within a React component, call `useGetDatapointsTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatapointsTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatapointsTasksQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetDatapointsTasksQuery(baseOptions: Apollo.QueryHookOptions<GetDatapointsTasksQuery_, GetDatapointsTasksQueryVariables_> & ({ variables: GetDatapointsTasksQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatapointsTasksQuery_, GetDatapointsTasksQueryVariables_>(GetDatapointsTasksDocument_, options);
      }
export function useGetDatapointsTasksLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDatapointsTasksQuery_, GetDatapointsTasksQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatapointsTasksQuery_, GetDatapointsTasksQueryVariables_>(GetDatapointsTasksDocument_, options);
        }
export function useGetDatapointsTasksSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatapointsTasksQuery_, GetDatapointsTasksQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatapointsTasksQuery_, GetDatapointsTasksQueryVariables_>(GetDatapointsTasksDocument_, options);
        }
export type GetDatapointsTasksQueryHookResult = ReturnType<typeof useGetDatapointsTasksQuery>;
export type GetDatapointsTasksLazyQuery_HookResult = ReturnType<typeof useGetDatapointsTasksLazyQuery_>;
export type GetDatapointsTasksSuspenseQuery_HookResult = ReturnType<typeof useGetDatapointsTasksSuspenseQuery_>;
export type GetDatapointsTasksQueryResult_ = Apollo.QueryResult<GetDatapointsTasksQuery_, GetDatapointsTasksQueryVariables_>;
export function refetchGetDatapointsTasksQuery_(variables: GetDatapointsTasksQueryVariables_) {
      return { query: GetDatapointsTasksDocument_, variables: variables }
    }
export const GetDatapointMdrmTasksDocument_ = gql`
    query getDatapointMdrmTasks($assessmentId: uuid!) {
  Task(
    where: {datapoints: {answer: {assessmentId: {_eq: $assessmentId}}}, table: {_eq: "DatapointMdrm"}}
  ) {
    ...TaskFields
    datapointMdrm {
      id
      datapoint {
        isMdrmDisclosed
        answer {
          ...AnswerDetails
        }
      }
    }
  }
}
    ${TaskFieldsFragmentDoc_}
${AnswerDetailsFragmentDoc_}`;

/**
 * __useGetDatapointMdrmTasksQuery__
 *
 * To run a query within a React component, call `useGetDatapointMdrmTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDatapointMdrmTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDatapointMdrmTasksQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetDatapointMdrmTasksQuery(baseOptions: Apollo.QueryHookOptions<GetDatapointMdrmTasksQuery_, GetDatapointMdrmTasksQueryVariables_> & ({ variables: GetDatapointMdrmTasksQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDatapointMdrmTasksQuery_, GetDatapointMdrmTasksQueryVariables_>(GetDatapointMdrmTasksDocument_, options);
      }
export function useGetDatapointMdrmTasksLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetDatapointMdrmTasksQuery_, GetDatapointMdrmTasksQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDatapointMdrmTasksQuery_, GetDatapointMdrmTasksQueryVariables_>(GetDatapointMdrmTasksDocument_, options);
        }
export function useGetDatapointMdrmTasksSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDatapointMdrmTasksQuery_, GetDatapointMdrmTasksQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDatapointMdrmTasksQuery_, GetDatapointMdrmTasksQueryVariables_>(GetDatapointMdrmTasksDocument_, options);
        }
export type GetDatapointMdrmTasksQueryHookResult = ReturnType<typeof useGetDatapointMdrmTasksQuery>;
export type GetDatapointMdrmTasksLazyQuery_HookResult = ReturnType<typeof useGetDatapointMdrmTasksLazyQuery_>;
export type GetDatapointMdrmTasksSuspenseQuery_HookResult = ReturnType<typeof useGetDatapointMdrmTasksSuspenseQuery_>;
export type GetDatapointMdrmTasksQueryResult_ = Apollo.QueryResult<GetDatapointMdrmTasksQuery_, GetDatapointMdrmTasksQueryVariables_>;
export function refetchGetDatapointMdrmTasksQuery_(variables: GetDatapointMdrmTasksQueryVariables_) {
      return { query: GetDatapointMdrmTasksDocument_, variables: variables }
    }
export const GetMetricsDisclosureRequirementsDocument_ = gql`
    query getMetricsDisclosureRequirements($metricRefs: [String!]!) {
  EsrsMetric(where: {reference: {_in: $metricRefs}}) {
    ...MetricDisclosureDetails
  }
}
    ${MetricDisclosureDetailsFragmentDoc_}`;

/**
 * __useGetMetricsDisclosureRequirementsQuery__
 *
 * To run a query within a React component, call `useGetMetricsDisclosureRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetricsDisclosureRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetricsDisclosureRequirementsQuery({
 *   variables: {
 *      metricRefs: // value for 'metricRefs'
 *   },
 * });
 */
export function useGetMetricsDisclosureRequirementsQuery(baseOptions: Apollo.QueryHookOptions<GetMetricsDisclosureRequirementsQuery_, GetMetricsDisclosureRequirementsQueryVariables_> & ({ variables: GetMetricsDisclosureRequirementsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetricsDisclosureRequirementsQuery_, GetMetricsDisclosureRequirementsQueryVariables_>(GetMetricsDisclosureRequirementsDocument_, options);
      }
export function useGetMetricsDisclosureRequirementsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetMetricsDisclosureRequirementsQuery_, GetMetricsDisclosureRequirementsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetricsDisclosureRequirementsQuery_, GetMetricsDisclosureRequirementsQueryVariables_>(GetMetricsDisclosureRequirementsDocument_, options);
        }
export function useGetMetricsDisclosureRequirementsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMetricsDisclosureRequirementsQuery_, GetMetricsDisclosureRequirementsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMetricsDisclosureRequirementsQuery_, GetMetricsDisclosureRequirementsQueryVariables_>(GetMetricsDisclosureRequirementsDocument_, options);
        }
export type GetMetricsDisclosureRequirementsQueryHookResult = ReturnType<typeof useGetMetricsDisclosureRequirementsQuery>;
export type GetMetricsDisclosureRequirementsLazyQuery_HookResult = ReturnType<typeof useGetMetricsDisclosureRequirementsLazyQuery_>;
export type GetMetricsDisclosureRequirementsSuspenseQuery_HookResult = ReturnType<typeof useGetMetricsDisclosureRequirementsSuspenseQuery_>;
export type GetMetricsDisclosureRequirementsQueryResult_ = Apollo.QueryResult<GetMetricsDisclosureRequirementsQuery_, GetMetricsDisclosureRequirementsQueryVariables_>;
export function refetchGetMetricsDisclosureRequirementsQuery_(variables: GetMetricsDisclosureRequirementsQueryVariables_) {
      return { query: GetMetricsDisclosureRequirementsDocument_, variables: variables }
    }
export const GetCompanyUsersDocument_ = gql`
    query getCompanyUsers($companyId: uuid!) {
  CompanyUser(where: {companyId: {_eq: $companyId}}) {
    user {
      ...ShortUser
    }
  }
}
    ${ShortUserFragmentDoc_}`;

/**
 * __useGetCompanyUsersQuery__
 *
 * To run a query within a React component, call `useGetCompanyUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyUsersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetCompanyUsersQuery(baseOptions: Apollo.QueryHookOptions<GetCompanyUsersQuery_, GetCompanyUsersQueryVariables_> & ({ variables: GetCompanyUsersQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyUsersQuery_, GetCompanyUsersQueryVariables_>(GetCompanyUsersDocument_, options);
      }
export function useGetCompanyUsersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyUsersQuery_, GetCompanyUsersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyUsersQuery_, GetCompanyUsersQueryVariables_>(GetCompanyUsersDocument_, options);
        }
export function useGetCompanyUsersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCompanyUsersQuery_, GetCompanyUsersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompanyUsersQuery_, GetCompanyUsersQueryVariables_>(GetCompanyUsersDocument_, options);
        }
export type GetCompanyUsersQueryHookResult = ReturnType<typeof useGetCompanyUsersQuery>;
export type GetCompanyUsersLazyQuery_HookResult = ReturnType<typeof useGetCompanyUsersLazyQuery_>;
export type GetCompanyUsersSuspenseQuery_HookResult = ReturnType<typeof useGetCompanyUsersSuspenseQuery_>;
export type GetCompanyUsersQueryResult_ = Apollo.QueryResult<GetCompanyUsersQuery_, GetCompanyUsersQueryVariables_>;
export function refetchGetCompanyUsersQuery_(variables: GetCompanyUsersQueryVariables_) {
      return { query: GetCompanyUsersDocument_, variables: variables }
    }
export const GetAssessmentDisclosureRequirementsDocument_ = gql`
    query getAssessmentDisclosureRequirements($assessmentId: uuid!) {
  EsrsAssessment_by_pk(id: $assessmentId) {
    materialStandards {
      standard {
        title
        order
        reference
      }
      materialMetrics(where: {isMaterial: {_eq: true}}) {
        dataCollection
        metric {
          metricType
          ...MetricDisclosureDetails
          answers(where: {assessmentId: {_eq: $assessmentId}}) {
            reportingUnit {
              id
              name
            }
            datapoints {
              taskId
            }
          }
        }
      }
    }
  }
}
    ${MetricDisclosureDetailsFragmentDoc_}`;

/**
 * __useGetAssessmentDisclosureRequirementsQuery__
 *
 * To run a query within a React component, call `useGetAssessmentDisclosureRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssessmentDisclosureRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssessmentDisclosureRequirementsQuery({
 *   variables: {
 *      assessmentId: // value for 'assessmentId'
 *   },
 * });
 */
export function useGetAssessmentDisclosureRequirementsQuery(baseOptions: Apollo.QueryHookOptions<GetAssessmentDisclosureRequirementsQuery_, GetAssessmentDisclosureRequirementsQueryVariables_> & ({ variables: GetAssessmentDisclosureRequirementsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssessmentDisclosureRequirementsQuery_, GetAssessmentDisclosureRequirementsQueryVariables_>(GetAssessmentDisclosureRequirementsDocument_, options);
      }
export function useGetAssessmentDisclosureRequirementsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetAssessmentDisclosureRequirementsQuery_, GetAssessmentDisclosureRequirementsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssessmentDisclosureRequirementsQuery_, GetAssessmentDisclosureRequirementsQueryVariables_>(GetAssessmentDisclosureRequirementsDocument_, options);
        }
export function useGetAssessmentDisclosureRequirementsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAssessmentDisclosureRequirementsQuery_, GetAssessmentDisclosureRequirementsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAssessmentDisclosureRequirementsQuery_, GetAssessmentDisclosureRequirementsQueryVariables_>(GetAssessmentDisclosureRequirementsDocument_, options);
        }
export type GetAssessmentDisclosureRequirementsQueryHookResult = ReturnType<typeof useGetAssessmentDisclosureRequirementsQuery>;
export type GetAssessmentDisclosureRequirementsLazyQuery_HookResult = ReturnType<typeof useGetAssessmentDisclosureRequirementsLazyQuery_>;
export type GetAssessmentDisclosureRequirementsSuspenseQuery_HookResult = ReturnType<typeof useGetAssessmentDisclosureRequirementsSuspenseQuery_>;
export type GetAssessmentDisclosureRequirementsQueryResult_ = Apollo.QueryResult<GetAssessmentDisclosureRequirementsQuery_, GetAssessmentDisclosureRequirementsQueryVariables_>;
export function refetchGetAssessmentDisclosureRequirementsQuery_(variables: GetAssessmentDisclosureRequirementsQueryVariables_) {
      return { query: GetAssessmentDisclosureRequirementsDocument_, variables: variables }
    }
export const UpdateTasksDocument_ = gql`
    mutation updateTasks($tasksIds: [uuid!]!, $_set: Task_set_input!) {
  update_Task(where: {id: {_in: $tasksIds}}, _set: $_set) {
    affected_rows
  }
}
    `;
export type UpdateTasksMutationFn_ = Apollo.MutationFunction<UpdateTasksMutation_, UpdateTasksMutationVariables_>;

/**
 * __useUpdateTasksMutation__
 *
 * To run a mutation, you first call `useUpdateTasksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTasksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTasksMutation, { data, loading, error }] = useUpdateTasksMutation({
 *   variables: {
 *      tasksIds: // value for 'tasksIds'
 *      _set: // value for '_set'
 *   },
 * });
 */
export function useUpdateTasksMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTasksMutation_, UpdateTasksMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTasksMutation_, UpdateTasksMutationVariables_>(UpdateTasksDocument_, options);
      }
export type UpdateTasksMutationHookResult = ReturnType<typeof useUpdateTasksMutation>;
export type UpdateTasksMutationResult_ = Apollo.MutationResult<UpdateTasksMutation_>;
export type UpdateTasksMutationOptions_ = Apollo.BaseMutationOptions<UpdateTasksMutation_, UpdateTasksMutationVariables_>;
export const UpdateTaskInProgressDocument_ = gql`
    mutation updateTaskInProgress($id: uuid!) {
  update_Task_by_pk(pk_columns: {id: $id}, _set: {status: IN_PROGRESS}) {
    id
  }
}
    `;
export type UpdateTaskInProgressMutationFn_ = Apollo.MutationFunction<UpdateTaskInProgressMutation_, UpdateTaskInProgressMutationVariables_>;

/**
 * __useUpdateTaskInProgressMutation__
 *
 * To run a mutation, you first call `useUpdateTaskInProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskInProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskInProgressMutation, { data, loading, error }] = useUpdateTaskInProgressMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateTaskInProgressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskInProgressMutation_, UpdateTaskInProgressMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskInProgressMutation_, UpdateTaskInProgressMutationVariables_>(UpdateTaskInProgressDocument_, options);
      }
export type UpdateTaskInProgressMutationHookResult = ReturnType<typeof useUpdateTaskInProgressMutation>;
export type UpdateTaskInProgressMutationResult_ = Apollo.MutationResult<UpdateTaskInProgressMutation_>;
export type UpdateTaskInProgressMutationOptions_ = Apollo.BaseMutationOptions<UpdateTaskInProgressMutation_, UpdateTaskInProgressMutationVariables_>;
export const UpdateTaskCompletedDocument_ = gql`
    mutation updateTaskCompleted($id: uuid!) {
  update_Task_by_pk(pk_columns: {id: $id}, _set: {status: COMPLETED}) {
    id
  }
}
    `;
export type UpdateTaskCompletedMutationFn_ = Apollo.MutationFunction<UpdateTaskCompletedMutation_, UpdateTaskCompletedMutationVariables_>;

/**
 * __useUpdateTaskCompletedMutation__
 *
 * To run a mutation, you first call `useUpdateTaskCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskCompletedMutation, { data, loading, error }] = useUpdateTaskCompletedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateTaskCompletedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskCompletedMutation_, UpdateTaskCompletedMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskCompletedMutation_, UpdateTaskCompletedMutationVariables_>(UpdateTaskCompletedDocument_, options);
      }
export type UpdateTaskCompletedMutationHookResult = ReturnType<typeof useUpdateTaskCompletedMutation>;
export type UpdateTaskCompletedMutationResult_ = Apollo.MutationResult<UpdateTaskCompletedMutation_>;
export type UpdateTaskCompletedMutationOptions_ = Apollo.BaseMutationOptions<UpdateTaskCompletedMutation_, UpdateTaskCompletedMutationVariables_>;
export const UpdateManyTasksInProgressDocument_ = gql`
    mutation updateManyTasksInProgress($ids: [uuid!]!) {
  update_Task(where: {id: {_in: $ids}}, _set: {status: IN_PROGRESS}) {
    affected_rows
  }
}
    `;
export type UpdateManyTasksInProgressMutationFn_ = Apollo.MutationFunction<UpdateManyTasksInProgressMutation_, UpdateManyTasksInProgressMutationVariables_>;

/**
 * __useUpdateManyTasksInProgressMutation__
 *
 * To run a mutation, you first call `useUpdateManyTasksInProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManyTasksInProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManyTasksInProgressMutation, { data, loading, error }] = useUpdateManyTasksInProgressMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUpdateManyTasksInProgressMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManyTasksInProgressMutation_, UpdateManyTasksInProgressMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManyTasksInProgressMutation_, UpdateManyTasksInProgressMutationVariables_>(UpdateManyTasksInProgressDocument_, options);
      }
export type UpdateManyTasksInProgressMutationHookResult = ReturnType<typeof useUpdateManyTasksInProgressMutation>;
export type UpdateManyTasksInProgressMutationResult_ = Apollo.MutationResult<UpdateManyTasksInProgressMutation_>;
export type UpdateManyTasksInProgressMutationOptions_ = Apollo.BaseMutationOptions<UpdateManyTasksInProgressMutation_, UpdateManyTasksInProgressMutationVariables_>;
export const GetThreadDocument_ = gql`
    query getThread($id: uuid!) {
  thread: Thread_by_pk(id: $id) {
    ...ThreadFields
  }
}
    ${ThreadFieldsFragmentDoc_}`;

/**
 * __useGetThreadQuery__
 *
 * To run a query within a React component, call `useGetThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetThreadQuery(baseOptions: Apollo.QueryHookOptions<GetThreadQuery_, GetThreadQueryVariables_> & ({ variables: GetThreadQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetThreadQuery_, GetThreadQueryVariables_>(GetThreadDocument_, options);
      }
export function useGetThreadLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetThreadQuery_, GetThreadQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetThreadQuery_, GetThreadQueryVariables_>(GetThreadDocument_, options);
        }
export function useGetThreadSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetThreadQuery_, GetThreadQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetThreadQuery_, GetThreadQueryVariables_>(GetThreadDocument_, options);
        }
export type GetThreadQueryHookResult = ReturnType<typeof useGetThreadQuery>;
export type GetThreadLazyQuery_HookResult = ReturnType<typeof useGetThreadLazyQuery_>;
export type GetThreadSuspenseQuery_HookResult = ReturnType<typeof useGetThreadSuspenseQuery_>;
export type GetThreadQueryResult_ = Apollo.QueryResult<GetThreadQuery_, GetThreadQueryVariables_>;
export function refetchGetThreadQuery_(variables: GetThreadQueryVariables_) {
      return { query: GetThreadDocument_, variables: variables }
    }
export const ThreadDocument_ = gql`
    subscription Thread($id: uuid!) {
  thread: Thread_by_pk(id: $id) {
    ...ThreadFields
  }
}
    ${ThreadFieldsFragmentDoc_}`;

/**
 * __useThreadSubscription__
 *
 * To run a query within a React component, call `useThreadSubscription` and pass it any options that fit your needs.
 * When your component renders, `useThreadSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThreadSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useThreadSubscription(baseOptions: Apollo.SubscriptionHookOptions<ThreadSubscription_, ThreadSubscriptionVariables_> & ({ variables: ThreadSubscriptionVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ThreadSubscription_, ThreadSubscriptionVariables_>(ThreadDocument_, options);
      }
export type ThreadSubscriptionHookResult = ReturnType<typeof useThreadSubscription>;
export type ThreadSubscriptionResult_ = Apollo.SubscriptionResult<ThreadSubscription_>;
export const UpsertThreadDocument_ = gql`
    mutation upsertThread($thread: Thread_insert_input!) {
  thread: insert_Thread_one(
    object: $thread
    on_conflict: {constraint: Thread_pkey, update_columns: [answerId]}
  ) {
    ...ThreadFields
    answer {
      id
      thread {
        id
      }
    }
    esrsDatapoint {
      id
      thread {
        id
      }
    }
  }
}
    ${ThreadFieldsFragmentDoc_}`;
export type UpsertThreadMutationFn_ = Apollo.MutationFunction<UpsertThreadMutation_, UpsertThreadMutationVariables_>;

/**
 * __useUpsertThreadMutation__
 *
 * To run a mutation, you first call `useUpsertThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertThreadMutation, { data, loading, error }] = useUpsertThreadMutation({
 *   variables: {
 *      thread: // value for 'thread'
 *   },
 * });
 */
export function useUpsertThreadMutation(baseOptions?: Apollo.MutationHookOptions<UpsertThreadMutation_, UpsertThreadMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertThreadMutation_, UpsertThreadMutationVariables_>(UpsertThreadDocument_, options);
      }
export type UpsertThreadMutationHookResult = ReturnType<typeof useUpsertThreadMutation>;
export type UpsertThreadMutationResult_ = Apollo.MutationResult<UpsertThreadMutation_>;
export type UpsertThreadMutationOptions_ = Apollo.BaseMutationOptions<UpsertThreadMutation_, UpsertThreadMutationVariables_>;
export const AddCommentDocument_ = gql`
    mutation addComment($input: Comment_insert_input!, $subscription: ThreadSubscriber_insert_input!) {
  createComment: insert_Comment_one(object: $input) {
    ...CommentFields
    thread {
      ...ThreadUpdate
    }
    notificationsSent: notifications_aggregate {
      aggregate {
        count
      }
    }
  }
  subscription: insert_ThreadSubscriber_one(
    object: $subscription
    on_conflict: {constraint: ThreadSubscriber_threadId_userId_c1ed612a_uniq, update_columns: [isSubscribed]}
  ) {
    id
    isSubscribed
    userId
  }
}
    ${CommentFieldsFragmentDoc_}
${ThreadUpdateFragmentDoc_}`;
export type AddCommentMutationFn_ = Apollo.MutationFunction<AddCommentMutation_, AddCommentMutationVariables_>;

/**
 * __useAddCommentMutation__
 *
 * To run a mutation, you first call `useAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCommentMutation, { data, loading, error }] = useAddCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *      subscription: // value for 'subscription'
 *   },
 * });
 */
export function useAddCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCommentMutation_, AddCommentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCommentMutation_, AddCommentMutationVariables_>(AddCommentDocument_, options);
      }
export type AddCommentMutationHookResult = ReturnType<typeof useAddCommentMutation>;
export type AddCommentMutationResult_ = Apollo.MutationResult<AddCommentMutation_>;
export type AddCommentMutationOptions_ = Apollo.BaseMutationOptions<AddCommentMutation_, AddCommentMutationVariables_>;
export const RemoveCommentDocument_ = gql`
    mutation removeComment($id: uuid!) {
  deleteComment: update_Comment_by_pk(
    pk_columns: {id: $id}
    _set: {deletedAt: "now()"}
  ) {
    thread {
      ...ThreadUpdate
    }
  }
}
    ${ThreadUpdateFragmentDoc_}`;
export type RemoveCommentMutationFn_ = Apollo.MutationFunction<RemoveCommentMutation_, RemoveCommentMutationVariables_>;

/**
 * __useRemoveCommentMutation__
 *
 * To run a mutation, you first call `useRemoveCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCommentMutation, { data, loading, error }] = useRemoveCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCommentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCommentMutation_, RemoveCommentMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCommentMutation_, RemoveCommentMutationVariables_>(RemoveCommentDocument_, options);
      }
export type RemoveCommentMutationHookResult = ReturnType<typeof useRemoveCommentMutation>;
export type RemoveCommentMutationResult_ = Apollo.MutationResult<RemoveCommentMutation_>;
export type RemoveCommentMutationOptions_ = Apollo.BaseMutationOptions<RemoveCommentMutation_, RemoveCommentMutationVariables_>;
export const GetUserRoleInCompanyDocument_ = gql`
    query getUserRoleInCompany($userId: uuid!, $companyId: uuid!) {
  roleInCompany: CompanyUser_by_pk(companyId: $companyId, userId: $userId) {
    role
  }
}
    `;

/**
 * __useGetUserRoleInCompanyQuery__
 *
 * To run a query within a React component, call `useGetUserRoleInCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRoleInCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRoleInCompanyQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetUserRoleInCompanyQuery(baseOptions: Apollo.QueryHookOptions<GetUserRoleInCompanyQuery_, GetUserRoleInCompanyQueryVariables_> & ({ variables: GetUserRoleInCompanyQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRoleInCompanyQuery_, GetUserRoleInCompanyQueryVariables_>(GetUserRoleInCompanyDocument_, options);
      }
export function useGetUserRoleInCompanyLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRoleInCompanyQuery_, GetUserRoleInCompanyQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRoleInCompanyQuery_, GetUserRoleInCompanyQueryVariables_>(GetUserRoleInCompanyDocument_, options);
        }
export function useGetUserRoleInCompanySuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserRoleInCompanyQuery_, GetUserRoleInCompanyQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserRoleInCompanyQuery_, GetUserRoleInCompanyQueryVariables_>(GetUserRoleInCompanyDocument_, options);
        }
export type GetUserRoleInCompanyQueryHookResult = ReturnType<typeof useGetUserRoleInCompanyQuery>;
export type GetUserRoleInCompanyLazyQuery_HookResult = ReturnType<typeof useGetUserRoleInCompanyLazyQuery_>;
export type GetUserRoleInCompanySuspenseQuery_HookResult = ReturnType<typeof useGetUserRoleInCompanySuspenseQuery_>;
export type GetUserRoleInCompanyQueryResult_ = Apollo.QueryResult<GetUserRoleInCompanyQuery_, GetUserRoleInCompanyQueryVariables_>;
export function refetchGetUserRoleInCompanyQuery_(variables: GetUserRoleInCompanyQueryVariables_) {
      return { query: GetUserRoleInCompanyDocument_, variables: variables }
    }
export const UserCompaniesDocument_ = gql`
    query UserCompanies($id: uuid!) {
  data: user(id: $id) {
    companies: companyUsers {
      company {
        ...CompanyDetailsFields
      }
    }
  }
}
    ${CompanyDetailsFieldsFragmentDoc_}`;

/**
 * __useUserCompaniesQuery__
 *
 * To run a query within a React component, call `useUserCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCompaniesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserCompaniesQuery(baseOptions: Apollo.QueryHookOptions<UserCompaniesQuery_, UserCompaniesQueryVariables_> & ({ variables: UserCompaniesQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserCompaniesQuery_, UserCompaniesQueryVariables_>(UserCompaniesDocument_, options);
      }
export function useUserCompaniesLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<UserCompaniesQuery_, UserCompaniesQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserCompaniesQuery_, UserCompaniesQueryVariables_>(UserCompaniesDocument_, options);
        }
export function useUserCompaniesSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserCompaniesQuery_, UserCompaniesQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserCompaniesQuery_, UserCompaniesQueryVariables_>(UserCompaniesDocument_, options);
        }
export type UserCompaniesQueryHookResult = ReturnType<typeof useUserCompaniesQuery>;
export type UserCompaniesLazyQuery_HookResult = ReturnType<typeof useUserCompaniesLazyQuery_>;
export type UserCompaniesSuspenseQuery_HookResult = ReturnType<typeof useUserCompaniesSuspenseQuery_>;
export type UserCompaniesQueryResult_ = Apollo.QueryResult<UserCompaniesQuery_, UserCompaniesQueryVariables_>;
export function refetchUserCompaniesQuery_(variables: UserCompaniesQueryVariables_) {
      return { query: UserCompaniesDocument_, variables: variables }
    }
export const UserProvidersDocument_ = gql`
    query userProviders($userId: uuid!) {
  providers: authUserProviders(where: {userId: {_eq: $userId}}) {
    providerId
  }
}
    `;

/**
 * __useUserProvidersQuery__
 *
 * To run a query within a React component, call `useUserProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProvidersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserProvidersQuery(baseOptions: Apollo.QueryHookOptions<UserProvidersQuery_, UserProvidersQueryVariables_> & ({ variables: UserProvidersQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProvidersQuery_, UserProvidersQueryVariables_>(UserProvidersDocument_, options);
      }
export function useUserProvidersLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<UserProvidersQuery_, UserProvidersQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProvidersQuery_, UserProvidersQueryVariables_>(UserProvidersDocument_, options);
        }
export function useUserProvidersSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserProvidersQuery_, UserProvidersQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserProvidersQuery_, UserProvidersQueryVariables_>(UserProvidersDocument_, options);
        }
export type UserProvidersQueryHookResult = ReturnType<typeof useUserProvidersQuery>;
export type UserProvidersLazyQuery_HookResult = ReturnType<typeof useUserProvidersLazyQuery_>;
export type UserProvidersSuspenseQuery_HookResult = ReturnType<typeof useUserProvidersSuspenseQuery_>;
export type UserProvidersQueryResult_ = Apollo.QueryResult<UserProvidersQuery_, UserProvidersQueryVariables_>;
export function refetchUserProvidersQuery_(variables: UserProvidersQueryVariables_) {
      return { query: UserProvidersDocument_, variables: variables }
    }
export const UserDetailsDocument_ = gql`
    query UserDetails($userId: uuid!) {
  user(id: $userId) {
    avatarUrl
    displayName
    email
  }
}
    `;

/**
 * __useUserDetailsQuery__
 *
 * To run a query within a React component, call `useUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDetailsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDetailsQuery(baseOptions: Apollo.QueryHookOptions<UserDetailsQuery_, UserDetailsQueryVariables_> & ({ variables: UserDetailsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDetailsQuery_, UserDetailsQueryVariables_>(UserDetailsDocument_, options);
      }
export function useUserDetailsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<UserDetailsQuery_, UserDetailsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDetailsQuery_, UserDetailsQueryVariables_>(UserDetailsDocument_, options);
        }
export function useUserDetailsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserDetailsQuery_, UserDetailsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserDetailsQuery_, UserDetailsQueryVariables_>(UserDetailsDocument_, options);
        }
export type UserDetailsQueryHookResult = ReturnType<typeof useUserDetailsQuery>;
export type UserDetailsLazyQuery_HookResult = ReturnType<typeof useUserDetailsLazyQuery_>;
export type UserDetailsSuspenseQuery_HookResult = ReturnType<typeof useUserDetailsSuspenseQuery_>;
export type UserDetailsQueryResult_ = Apollo.QueryResult<UserDetailsQuery_, UserDetailsQueryVariables_>;
export function refetchUserDetailsQuery_(variables: UserDetailsQueryVariables_) {
      return { query: UserDetailsDocument_, variables: variables }
    }
export const UpdateUserProfileDocument_ = gql`
    mutation updateUserProfile($id: uuid!, $user: users_set_input) {
  user: updateUser(pk_columns: {id: $id}, _set: $user) {
    id
    displayName
    email
    metadata
    avatarUrl
    locale
  }
}
    `;
export type UpdateUserProfileMutationFn_ = Apollo.MutationFunction<UpdateUserProfileMutation_, UpdateUserProfileMutationVariables_>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation_, UpdateUserProfileMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileMutation_, UpdateUserProfileMutationVariables_>(UpdateUserProfileDocument_, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult_ = Apollo.MutationResult<UpdateUserProfileMutation_>;
export type UpdateUserProfileMutationOptions_ = Apollo.BaseMutationOptions<UpdateUserProfileMutation_, UpdateUserProfileMutationVariables_>;
export const UpdateCompanyUserDocument_ = gql`
    mutation updateCompanyUser($companyId: uuid!, $userId: uuid!, $role: UserRole_enum!) {
  companyUser: update_CompanyUser_by_pk(
    pk_columns: {companyId: $companyId, userId: $userId}
    _set: {role: $role}
  ) {
    companyId
    userId
    role
  }
}
    `;
export type UpdateCompanyUserMutationFn_ = Apollo.MutationFunction<UpdateCompanyUserMutation_, UpdateCompanyUserMutationVariables_>;

/**
 * __useUpdateCompanyUserMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyUserMutation, { data, loading, error }] = useUpdateCompanyUserMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateCompanyUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyUserMutation_, UpdateCompanyUserMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyUserMutation_, UpdateCompanyUserMutationVariables_>(UpdateCompanyUserDocument_, options);
      }
export type UpdateCompanyUserMutationHookResult = ReturnType<typeof useUpdateCompanyUserMutation>;
export type UpdateCompanyUserMutationResult_ = Apollo.MutationResult<UpdateCompanyUserMutation_>;
export type UpdateCompanyUserMutationOptions_ = Apollo.BaseMutationOptions<UpdateCompanyUserMutation_, UpdateCompanyUserMutationVariables_>;
export const GetUserIdFromRefreshTokenIdDocument_ = gql`
    query GetUserIdFromRefreshTokenId($refreshTokenId: uuid!) {
  authRefreshToken(id: $refreshTokenId) {
    userId
  }
}
    `;

/**
 * __useGetUserIdFromRefreshTokenIdQuery__
 *
 * To run a query within a React component, call `useGetUserIdFromRefreshTokenIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserIdFromRefreshTokenIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserIdFromRefreshTokenIdQuery({
 *   variables: {
 *      refreshTokenId: // value for 'refreshTokenId'
 *   },
 * });
 */
export function useGetUserIdFromRefreshTokenIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserIdFromRefreshTokenIdQuery_, GetUserIdFromRefreshTokenIdQueryVariables_> & ({ variables: GetUserIdFromRefreshTokenIdQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserIdFromRefreshTokenIdQuery_, GetUserIdFromRefreshTokenIdQueryVariables_>(GetUserIdFromRefreshTokenIdDocument_, options);
      }
export function useGetUserIdFromRefreshTokenIdLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<GetUserIdFromRefreshTokenIdQuery_, GetUserIdFromRefreshTokenIdQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserIdFromRefreshTokenIdQuery_, GetUserIdFromRefreshTokenIdQueryVariables_>(GetUserIdFromRefreshTokenIdDocument_, options);
        }
export function useGetUserIdFromRefreshTokenIdSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserIdFromRefreshTokenIdQuery_, GetUserIdFromRefreshTokenIdQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserIdFromRefreshTokenIdQuery_, GetUserIdFromRefreshTokenIdQueryVariables_>(GetUserIdFromRefreshTokenIdDocument_, options);
        }
export type GetUserIdFromRefreshTokenIdQueryHookResult = ReturnType<typeof useGetUserIdFromRefreshTokenIdQuery>;
export type GetUserIdFromRefreshTokenIdLazyQuery_HookResult = ReturnType<typeof useGetUserIdFromRefreshTokenIdLazyQuery_>;
export type GetUserIdFromRefreshTokenIdSuspenseQuery_HookResult = ReturnType<typeof useGetUserIdFromRefreshTokenIdSuspenseQuery_>;
export type GetUserIdFromRefreshTokenIdQueryResult_ = Apollo.QueryResult<GetUserIdFromRefreshTokenIdQuery_, GetUserIdFromRefreshTokenIdQueryVariables_>;
export function refetchGetUserIdFromRefreshTokenIdQuery_(variables: GetUserIdFromRefreshTokenIdQueryVariables_) {
      return { query: GetUserIdFromRefreshTokenIdDocument_, variables: variables }
    }
export const UserSessionsDocument_ = gql`
    query UserSessions($userId: uuid!) {
  activeSessions: UserSessionMetadata(
    where: {userId: {_eq: $userId}, refreshToken: {expiresAt: {_gte: now}}}
    order_by: {updatedAt: desc}
  ) {
    id
    refreshTokenId
    userId
    ipAddress
    operatingSystem
    browser
    device
    createdAt
    updatedAt
  }
  inactiveSessions: UserSessionMetadata(
    where: {userId: {_eq: $userId}, _or: [{refreshToken: {expiresAt: {_lt: now}}}, {refreshTokenId: {_is_null: true}}]}
    order_by: {updatedAt: desc}
    limit: 10
  ) {
    id
    refreshTokenId
    userId
    ipAddress
    operatingSystem
    browser
    device
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useUserSessionsQuery__
 *
 * To run a query within a React component, call `useUserSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSessionsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserSessionsQuery(baseOptions: Apollo.QueryHookOptions<UserSessionsQuery_, UserSessionsQueryVariables_> & ({ variables: UserSessionsQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSessionsQuery_, UserSessionsQueryVariables_>(UserSessionsDocument_, options);
      }
export function useUserSessionsLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<UserSessionsQuery_, UserSessionsQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSessionsQuery_, UserSessionsQueryVariables_>(UserSessionsDocument_, options);
        }
export function useUserSessionsSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserSessionsQuery_, UserSessionsQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserSessionsQuery_, UserSessionsQueryVariables_>(UserSessionsDocument_, options);
        }
export type UserSessionsQueryHookResult = ReturnType<typeof useUserSessionsQuery>;
export type UserSessionsLazyQuery_HookResult = ReturnType<typeof useUserSessionsLazyQuery_>;
export type UserSessionsSuspenseQuery_HookResult = ReturnType<typeof useUserSessionsSuspenseQuery_>;
export type UserSessionsQueryResult_ = Apollo.QueryResult<UserSessionsQuery_, UserSessionsQueryVariables_>;
export function refetchUserSessionsQuery_(variables: UserSessionsQueryVariables_) {
      return { query: UserSessionsDocument_, variables: variables }
    }
export const DeleteCompanyUserDocument_ = gql`
    mutation deleteCompanyUser($companyId: uuid!, $userId: uuid!) {
  delete_CompanyUser_by_pk(companyId: $companyId, userId: $userId) {
    companyId
    userId
  }
}
    `;
export type DeleteCompanyUserMutationFn_ = Apollo.MutationFunction<DeleteCompanyUserMutation_, DeleteCompanyUserMutationVariables_>;

/**
 * __useDeleteCompanyUserMutation__
 *
 * To run a mutation, you first call `useDeleteCompanyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompanyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompanyUserMutation, { data, loading, error }] = useDeleteCompanyUserMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteCompanyUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompanyUserMutation_, DeleteCompanyUserMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompanyUserMutation_, DeleteCompanyUserMutationVariables_>(DeleteCompanyUserDocument_, options);
      }
export type DeleteCompanyUserMutationHookResult = ReturnType<typeof useDeleteCompanyUserMutation>;
export type DeleteCompanyUserMutationResult_ = Apollo.MutationResult<DeleteCompanyUserMutation_>;
export type DeleteCompanyUserMutationOptions_ = Apollo.BaseMutationOptions<DeleteCompanyUserMutation_, DeleteCompanyUserMutationVariables_>;
export const UpsertUserSessionMetadataDocument_ = gql`
    mutation UpsertUserSessionMetadata($sessionData: UserSessionMetadata_insert_input!) {
  insert_UserSessionMetadata_one(
    object: $sessionData
    on_conflict: {constraint: UserSessionMetadata_pkey, update_columns: [ipAddress, operatingSystem, browser, device, deletedAt]}
  ) {
    id
    userId
    refreshTokenId
    ipAddress
    operatingSystem
    browser
    device
    createdAt
    updatedAt
    deletedAt
  }
}
    `;
export type UpsertUserSessionMetadataMutationFn_ = Apollo.MutationFunction<UpsertUserSessionMetadataMutation_, UpsertUserSessionMetadataMutationVariables_>;

/**
 * __useUpsertUserSessionMetadataMutation__
 *
 * To run a mutation, you first call `useUpsertUserSessionMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserSessionMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserSessionMetadataMutation, { data, loading, error }] = useUpsertUserSessionMetadataMutation({
 *   variables: {
 *      sessionData: // value for 'sessionData'
 *   },
 * });
 */
export function useUpsertUserSessionMetadataMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserSessionMetadataMutation_, UpsertUserSessionMetadataMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserSessionMetadataMutation_, UpsertUserSessionMetadataMutationVariables_>(UpsertUserSessionMetadataDocument_, options);
      }
export type UpsertUserSessionMetadataMutationHookResult = ReturnType<typeof useUpsertUserSessionMetadataMutation>;
export type UpsertUserSessionMetadataMutationResult_ = Apollo.MutationResult<UpsertUserSessionMetadataMutation_>;
export type UpsertUserSessionMetadataMutationOptions_ = Apollo.BaseMutationOptions<UpsertUserSessionMetadataMutation_, UpsertUserSessionMetadataMutationVariables_>;
export const LogOutFromSessionDocument_ = gql`
    mutation logOutFromSession($sessionId: uuid!) {
  deleteAuthRefreshToken(id: $sessionId) {
    id
    userId
  }
}
    `;
export type LogOutFromSessionMutationFn_ = Apollo.MutationFunction<LogOutFromSessionMutation_, LogOutFromSessionMutationVariables_>;

/**
 * __useLogOutFromSessionMutation__
 *
 * To run a mutation, you first call `useLogOutFromSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogOutFromSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logOutFromSessionMutation, { data, loading, error }] = useLogOutFromSessionMutation({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useLogOutFromSessionMutation(baseOptions?: Apollo.MutationHookOptions<LogOutFromSessionMutation_, LogOutFromSessionMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogOutFromSessionMutation_, LogOutFromSessionMutationVariables_>(LogOutFromSessionDocument_, options);
      }
export type LogOutFromSessionMutationHookResult = ReturnType<typeof useLogOutFromSessionMutation>;
export type LogOutFromSessionMutationResult_ = Apollo.MutationResult<LogOutFromSessionMutation_>;
export type LogOutFromSessionMutationOptions_ = Apollo.BaseMutationOptions<LogOutFromSessionMutation_, LogOutFromSessionMutationVariables_>;
export const UserMetadataDocument_ = gql`
    query UserMetadata($userId: uuid!) {
  user(id: $userId) {
    id
    metadata
  }
}
    `;

/**
 * __useUserMetadataQuery__
 *
 * To run a query within a React component, call `useUserMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserMetadataQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserMetadataQuery(baseOptions: Apollo.QueryHookOptions<UserMetadataQuery_, UserMetadataQueryVariables_> & ({ variables: UserMetadataQueryVariables_; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserMetadataQuery_, UserMetadataQueryVariables_>(UserMetadataDocument_, options);
      }
export function useUserMetadataLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<UserMetadataQuery_, UserMetadataQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserMetadataQuery_, UserMetadataQueryVariables_>(UserMetadataDocument_, options);
        }
export function useUserMetadataSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserMetadataQuery_, UserMetadataQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserMetadataQuery_, UserMetadataQueryVariables_>(UserMetadataDocument_, options);
        }
export type UserMetadataQueryHookResult = ReturnType<typeof useUserMetadataQuery>;
export type UserMetadataLazyQuery_HookResult = ReturnType<typeof useUserMetadataLazyQuery_>;
export type UserMetadataSuspenseQuery_HookResult = ReturnType<typeof useUserMetadataSuspenseQuery_>;
export type UserMetadataQueryResult_ = Apollo.QueryResult<UserMetadataQuery_, UserMetadataQueryVariables_>;
export function refetchUserMetadataQuery_(variables: UserMetadataQueryVariables_) {
      return { query: UserMetadataDocument_, variables: variables }
    }
export const ProfilePictureDocument_ = gql`
    query profilePicture {
  files(limit: 1) {
    id
    name
  }
}
    `;

/**
 * __useProfilePictureQuery__
 *
 * To run a query within a React component, call `useProfilePictureQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilePictureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilePictureQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfilePictureQuery(baseOptions?: Apollo.QueryHookOptions<ProfilePictureQuery_, ProfilePictureQueryVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfilePictureQuery_, ProfilePictureQueryVariables_>(ProfilePictureDocument_, options);
      }
export function useProfilePictureLazyQuery_(baseOptions?: Apollo.LazyQueryHookOptions<ProfilePictureQuery_, ProfilePictureQueryVariables_>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfilePictureQuery_, ProfilePictureQueryVariables_>(ProfilePictureDocument_, options);
        }
export function useProfilePictureSuspenseQuery_(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProfilePictureQuery_, ProfilePictureQueryVariables_>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProfilePictureQuery_, ProfilePictureQueryVariables_>(ProfilePictureDocument_, options);
        }
export type ProfilePictureQueryHookResult = ReturnType<typeof useProfilePictureQuery>;
export type ProfilePictureLazyQuery_HookResult = ReturnType<typeof useProfilePictureLazyQuery_>;
export type ProfilePictureSuspenseQuery_HookResult = ReturnType<typeof useProfilePictureSuspenseQuery_>;
export type ProfilePictureQueryResult_ = Apollo.QueryResult<ProfilePictureQuery_, ProfilePictureQueryVariables_>;
export function refetchProfilePictureQuery_(variables?: ProfilePictureQueryVariables_) {
      return { query: ProfilePictureDocument_, variables: variables }
    }
export const HighestNumberDocument_ = gql`
    subscription HighestNumber {
  WebsocketTest_aggregate {
    aggregate {
      max {
        id
      }
    }
  }
}
    `;

/**
 * __useHighestNumberSubscription__
 *
 * To run a query within a React component, call `useHighestNumberSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHighestNumberSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHighestNumberSubscription({
 *   variables: {
 *   },
 * });
 */
export function useHighestNumberSubscription(baseOptions?: Apollo.SubscriptionHookOptions<HighestNumberSubscription_, HighestNumberSubscriptionVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<HighestNumberSubscription_, HighestNumberSubscriptionVariables_>(HighestNumberDocument_, options);
      }
export type HighestNumberSubscriptionHookResult = ReturnType<typeof useHighestNumberSubscription>;
export type HighestNumberSubscriptionResult_ = Apollo.SubscriptionResult<HighestNumberSubscription_>;
export const CreateNumberDocument_ = gql`
    mutation CreateNumber {
  insert_WebsocketTest_one(object: {}) {
    id
  }
}
    `;
export type CreateNumberMutationFn_ = Apollo.MutationFunction<CreateNumberMutation_, CreateNumberMutationVariables_>;

/**
 * __useCreateNumberMutation__
 *
 * To run a mutation, you first call `useCreateNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNumberMutation, { data, loading, error }] = useCreateNumberMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateNumberMutation(baseOptions?: Apollo.MutationHookOptions<CreateNumberMutation_, CreateNumberMutationVariables_>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNumberMutation_, CreateNumberMutationVariables_>(CreateNumberDocument_, options);
      }
export type CreateNumberMutationHookResult = ReturnType<typeof useCreateNumberMutation>;
export type CreateNumberMutationResult_ = Apollo.MutationResult<CreateNumberMutation_>;
export type CreateNumberMutationOptions_ = Apollo.BaseMutationOptions<CreateNumberMutation_, CreateNumberMutationVariables_>;